import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  StringToNumberMap: any;
  _text: any;
  bigint: any;
  date: any;
  datetime: any;
  inet: any;
  json: any;
  jsonb: any;
  long: number;
  name: any;
  numeric: number;
  oid: any;
  smallint: any;
  timestamp: any;
  timestamptz: any;
  tsvector: any;
  uniqueidentifier: any;
  uuid: string;
};

/** aggregate fields of "vpic.abs" */
export type Abs_Aggregate_Fields_Vpic = {
  __typename?: 'ABS_aggregate_fields_vpic';
  avg?: Maybe<Abs_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Abs_Max_Fields_Vpic>;
  min?: Maybe<Abs_Min_Fields_Vpic>;
  stddev?: Maybe<Abs_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Abs_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Abs_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Abs_Sum_Fields_Vpic>;
  var_pop?: Maybe<Abs_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Abs_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Abs_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.abs" */
export type Abs_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Abs_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.abs" */
export type Abs_Aggregate_Vpic = {
  __typename?: 'ABS_aggregate_vpic';
  aggregate?: Maybe<Abs_Aggregate_Fields_Vpic>;
  nodes: Array<Abs_Vpic>;
};

/** aggregate avg on columns */
export type Abs_Avg_Fields_Vpic = {
  __typename?: 'ABS_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.abs". All fields are combined with a logical 'AND'. */
export type Abs_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Abs_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Abs_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Abs_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.abs" */
export enum Abs_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkAbs = 'pk_abs',
  /** unique or primary key constraint on columns "name" */
  UAbsname = 'u_absname'
}

/** input type for incrementing numeric columns in table "vpic.abs" */
export type Abs_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.abs" */
export type Abs_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Abs_Max_Fields_Vpic = {
  __typename?: 'ABS_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Abs_Min_Fields_Vpic = {
  __typename?: 'ABS_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.abs" */
export type Abs_Mutation_Response_Vpic = {
  __typename?: 'ABS_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Abs_Vpic>;
};

/** on_conflict condition type for table "vpic.abs" */
export type Abs_On_Conflict_Vpic = {
  constraint: Abs_Constraint_Vpic;
  update_columns?: Array<Abs_Update_Column_Vpic>;
  where?: InputMaybe<Abs_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.abs". */
export type Abs_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.abs */
export type Abs_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.abs" */
export enum Abs_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.abs" */
export type Abs_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Abs_Stddev_Fields_Vpic = {
  __typename?: 'ABS_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Abs_Stddev_Pop_Fields_Vpic = {
  __typename?: 'ABS_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Abs_Stddev_Samp_Fields_Vpic = {
  __typename?: 'ABS_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ABS" */
export type Abs_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Abs_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Abs_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Abs_Sum_Fields_Vpic = {
  __typename?: 'ABS_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.abs" */
export enum Abs_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type Abs_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Abs_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Abs_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Abs_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Abs_Var_Pop_Fields_Vpic = {
  __typename?: 'ABS_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Abs_Var_Samp_Fields_Vpic = {
  __typename?: 'ABS_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Abs_Variance_Fields_Vpic = {
  __typename?: 'ABS_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.abs" */
export type Abs_Vpic = {
  __typename?: 'ABS_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type AchMetadata = {
  __typename?: 'AchMetadata';
  accountNumber: Scalars['String'];
  bankAccountTypeName: Scalars['String'];
  bankName: Scalars['String'];
  routingNumber: Scalars['String'];
};

/** aggregate fields of "vpic.adaptivecruisecontrol" */
export type AdaptiveCruiseControl_Aggregate_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_aggregate_fields_vpic';
  avg?: Maybe<AdaptiveCruiseControl_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<AdaptiveCruiseControl_Max_Fields_Vpic>;
  min?: Maybe<AdaptiveCruiseControl_Min_Fields_Vpic>;
  stddev?: Maybe<AdaptiveCruiseControl_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<AdaptiveCruiseControl_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<AdaptiveCruiseControl_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<AdaptiveCruiseControl_Sum_Fields_Vpic>;
  var_pop?: Maybe<AdaptiveCruiseControl_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<AdaptiveCruiseControl_Var_Samp_Fields_Vpic>;
  variance?: Maybe<AdaptiveCruiseControl_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.adaptivecruisecontrol" */
export type AdaptiveCruiseControl_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<AdaptiveCruiseControl_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.adaptivecruisecontrol" */
export type AdaptiveCruiseControl_Aggregate_Vpic = {
  __typename?: 'AdaptiveCruiseControl_aggregate_vpic';
  aggregate?: Maybe<AdaptiveCruiseControl_Aggregate_Fields_Vpic>;
  nodes: Array<AdaptiveCruiseControl_Vpic>;
};

/** aggregate avg on columns */
export type AdaptiveCruiseControl_Avg_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.adaptivecruisecontrol". All fields are combined with a logical 'AND'. */
export type AdaptiveCruiseControl_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AdaptiveCruiseControl_Bool_Exp_Vpic>>;
  _not?: InputMaybe<AdaptiveCruiseControl_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<AdaptiveCruiseControl_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.adaptivecruisecontrol" */
export enum AdaptiveCruiseControl_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkAdaptivecruisecontrol = 'pk_adaptivecruisecontrol',
  /** unique or primary key constraint on columns "name" */
  UAdaptivecruisecontrolname = 'u_adaptivecruisecontrolname'
}

/** input type for incrementing numeric columns in table "vpic.adaptivecruisecontrol" */
export type AdaptiveCruiseControl_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.adaptivecruisecontrol" */
export type AdaptiveCruiseControl_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdaptiveCruiseControl_Max_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AdaptiveCruiseControl_Min_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.adaptivecruisecontrol" */
export type AdaptiveCruiseControl_Mutation_Response_Vpic = {
  __typename?: 'AdaptiveCruiseControl_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdaptiveCruiseControl_Vpic>;
};

/** on_conflict condition type for table "vpic.adaptivecruisecontrol" */
export type AdaptiveCruiseControl_On_Conflict_Vpic = {
  constraint: AdaptiveCruiseControl_Constraint_Vpic;
  update_columns?: Array<AdaptiveCruiseControl_Update_Column_Vpic>;
  where?: InputMaybe<AdaptiveCruiseControl_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.adaptivecruisecontrol". */
export type AdaptiveCruiseControl_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.adaptivecruisecontrol */
export type AdaptiveCruiseControl_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.adaptivecruisecontrol" */
export enum AdaptiveCruiseControl_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.adaptivecruisecontrol" */
export type AdaptiveCruiseControl_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdaptiveCruiseControl_Stddev_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdaptiveCruiseControl_Stddev_Pop_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdaptiveCruiseControl_Stddev_Samp_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AdaptiveCruiseControl" */
export type AdaptiveCruiseControl_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: AdaptiveCruiseControl_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type AdaptiveCruiseControl_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AdaptiveCruiseControl_Sum_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.adaptivecruisecontrol" */
export enum AdaptiveCruiseControl_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type AdaptiveCruiseControl_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AdaptiveCruiseControl_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdaptiveCruiseControl_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: AdaptiveCruiseControl_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type AdaptiveCruiseControl_Var_Pop_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdaptiveCruiseControl_Var_Samp_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdaptiveCruiseControl_Variance_Fields_Vpic = {
  __typename?: 'AdaptiveCruiseControl_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.adaptivecruisecontrol" */
export type AdaptiveCruiseControl_Vpic = {
  __typename?: 'AdaptiveCruiseControl_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.adaptivedrivingbeam" */
export type AdaptiveDrivingBeam_Aggregate_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_aggregate_fields_vpic';
  avg?: Maybe<AdaptiveDrivingBeam_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<AdaptiveDrivingBeam_Max_Fields_Vpic>;
  min?: Maybe<AdaptiveDrivingBeam_Min_Fields_Vpic>;
  stddev?: Maybe<AdaptiveDrivingBeam_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<AdaptiveDrivingBeam_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<AdaptiveDrivingBeam_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<AdaptiveDrivingBeam_Sum_Fields_Vpic>;
  var_pop?: Maybe<AdaptiveDrivingBeam_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<AdaptiveDrivingBeam_Var_Samp_Fields_Vpic>;
  variance?: Maybe<AdaptiveDrivingBeam_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.adaptivedrivingbeam" */
export type AdaptiveDrivingBeam_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<AdaptiveDrivingBeam_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.adaptivedrivingbeam" */
export type AdaptiveDrivingBeam_Aggregate_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_aggregate_vpic';
  aggregate?: Maybe<AdaptiveDrivingBeam_Aggregate_Fields_Vpic>;
  nodes: Array<AdaptiveDrivingBeam_Vpic>;
};

/** aggregate avg on columns */
export type AdaptiveDrivingBeam_Avg_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.adaptivedrivingbeam". All fields are combined with a logical 'AND'. */
export type AdaptiveDrivingBeam_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AdaptiveDrivingBeam_Bool_Exp_Vpic>>;
  _not?: InputMaybe<AdaptiveDrivingBeam_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<AdaptiveDrivingBeam_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.adaptivedrivingbeam" */
export enum AdaptiveDrivingBeam_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkAdaptive_3214ec0753f971cf = 'pk__adaptive__3214ec0753f971cf'
}

/** input type for incrementing numeric columns in table "vpic.adaptivedrivingbeam" */
export type AdaptiveDrivingBeam_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.adaptivedrivingbeam" */
export type AdaptiveDrivingBeam_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdaptiveDrivingBeam_Max_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AdaptiveDrivingBeam_Min_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.adaptivedrivingbeam" */
export type AdaptiveDrivingBeam_Mutation_Response_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdaptiveDrivingBeam_Vpic>;
};

/** on_conflict condition type for table "vpic.adaptivedrivingbeam" */
export type AdaptiveDrivingBeam_On_Conflict_Vpic = {
  constraint: AdaptiveDrivingBeam_Constraint_Vpic;
  update_columns?: Array<AdaptiveDrivingBeam_Update_Column_Vpic>;
  where?: InputMaybe<AdaptiveDrivingBeam_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.adaptivedrivingbeam". */
export type AdaptiveDrivingBeam_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.adaptivedrivingbeam */
export type AdaptiveDrivingBeam_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.adaptivedrivingbeam" */
export enum AdaptiveDrivingBeam_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.adaptivedrivingbeam" */
export type AdaptiveDrivingBeam_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdaptiveDrivingBeam_Stddev_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdaptiveDrivingBeam_Stddev_Pop_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdaptiveDrivingBeam_Stddev_Samp_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AdaptiveDrivingBeam" */
export type AdaptiveDrivingBeam_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: AdaptiveDrivingBeam_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type AdaptiveDrivingBeam_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AdaptiveDrivingBeam_Sum_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.adaptivedrivingbeam" */
export enum AdaptiveDrivingBeam_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type AdaptiveDrivingBeam_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AdaptiveDrivingBeam_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdaptiveDrivingBeam_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: AdaptiveDrivingBeam_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type AdaptiveDrivingBeam_Var_Pop_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdaptiveDrivingBeam_Var_Samp_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdaptiveDrivingBeam_Variance_Fields_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.adaptivedrivingbeam" */
export type AdaptiveDrivingBeam_Vpic = {
  __typename?: 'AdaptiveDrivingBeam_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.airbaglocfront" */
export type AirBagLocFront_Aggregate_Fields_Vpic = {
  __typename?: 'AirBagLocFront_aggregate_fields_vpic';
  avg?: Maybe<AirBagLocFront_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<AirBagLocFront_Max_Fields_Vpic>;
  min?: Maybe<AirBagLocFront_Min_Fields_Vpic>;
  stddev?: Maybe<AirBagLocFront_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<AirBagLocFront_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<AirBagLocFront_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<AirBagLocFront_Sum_Fields_Vpic>;
  var_pop?: Maybe<AirBagLocFront_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<AirBagLocFront_Var_Samp_Fields_Vpic>;
  variance?: Maybe<AirBagLocFront_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.airbaglocfront" */
export type AirBagLocFront_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<AirBagLocFront_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.airbaglocfront" */
export type AirBagLocFront_Aggregate_Vpic = {
  __typename?: 'AirBagLocFront_aggregate_vpic';
  aggregate?: Maybe<AirBagLocFront_Aggregate_Fields_Vpic>;
  nodes: Array<AirBagLocFront_Vpic>;
};

/** aggregate avg on columns */
export type AirBagLocFront_Avg_Fields_Vpic = {
  __typename?: 'AirBagLocFront_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.airbaglocfront". All fields are combined with a logical 'AND'. */
export type AirBagLocFront_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AirBagLocFront_Bool_Exp_Vpic>>;
  _not?: InputMaybe<AirBagLocFront_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<AirBagLocFront_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.airbaglocfront" */
export enum AirBagLocFront_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkAirbaglocfront = 'pk_airbaglocfront',
  /** unique or primary key constraint on columns "name" */
  UAirbaglocfrontName = 'u_airbaglocfront_name'
}

/** input type for incrementing numeric columns in table "vpic.airbaglocfront" */
export type AirBagLocFront_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.airbaglocfront" */
export type AirBagLocFront_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AirBagLocFront_Max_Fields_Vpic = {
  __typename?: 'AirBagLocFront_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AirBagLocFront_Min_Fields_Vpic = {
  __typename?: 'AirBagLocFront_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.airbaglocfront" */
export type AirBagLocFront_Mutation_Response_Vpic = {
  __typename?: 'AirBagLocFront_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AirBagLocFront_Vpic>;
};

/** on_conflict condition type for table "vpic.airbaglocfront" */
export type AirBagLocFront_On_Conflict_Vpic = {
  constraint: AirBagLocFront_Constraint_Vpic;
  update_columns?: Array<AirBagLocFront_Update_Column_Vpic>;
  where?: InputMaybe<AirBagLocFront_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.airbaglocfront". */
export type AirBagLocFront_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.airbaglocfront */
export type AirBagLocFront_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.airbaglocfront" */
export enum AirBagLocFront_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.airbaglocfront" */
export type AirBagLocFront_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AirBagLocFront_Stddev_Fields_Vpic = {
  __typename?: 'AirBagLocFront_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AirBagLocFront_Stddev_Pop_Fields_Vpic = {
  __typename?: 'AirBagLocFront_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AirBagLocFront_Stddev_Samp_Fields_Vpic = {
  __typename?: 'AirBagLocFront_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AirBagLocFront" */
export type AirBagLocFront_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: AirBagLocFront_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type AirBagLocFront_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AirBagLocFront_Sum_Fields_Vpic = {
  __typename?: 'AirBagLocFront_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.airbaglocfront" */
export enum AirBagLocFront_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type AirBagLocFront_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AirBagLocFront_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AirBagLocFront_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: AirBagLocFront_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type AirBagLocFront_Var_Pop_Fields_Vpic = {
  __typename?: 'AirBagLocFront_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AirBagLocFront_Var_Samp_Fields_Vpic = {
  __typename?: 'AirBagLocFront_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AirBagLocFront_Variance_Fields_Vpic = {
  __typename?: 'AirBagLocFront_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.airbaglocfront" */
export type AirBagLocFront_Vpic = {
  __typename?: 'AirBagLocFront_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.airbaglocknee" */
export type AirBagLocKnee_Aggregate_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_aggregate_fields_vpic';
  avg?: Maybe<AirBagLocKnee_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<AirBagLocKnee_Max_Fields_Vpic>;
  min?: Maybe<AirBagLocKnee_Min_Fields_Vpic>;
  stddev?: Maybe<AirBagLocKnee_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<AirBagLocKnee_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<AirBagLocKnee_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<AirBagLocKnee_Sum_Fields_Vpic>;
  var_pop?: Maybe<AirBagLocKnee_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<AirBagLocKnee_Var_Samp_Fields_Vpic>;
  variance?: Maybe<AirBagLocKnee_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.airbaglocknee" */
export type AirBagLocKnee_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<AirBagLocKnee_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.airbaglocknee" */
export type AirBagLocKnee_Aggregate_Vpic = {
  __typename?: 'AirBagLocKnee_aggregate_vpic';
  aggregate?: Maybe<AirBagLocKnee_Aggregate_Fields_Vpic>;
  nodes: Array<AirBagLocKnee_Vpic>;
};

/** aggregate avg on columns */
export type AirBagLocKnee_Avg_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.airbaglocknee". All fields are combined with a logical 'AND'. */
export type AirBagLocKnee_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AirBagLocKnee_Bool_Exp_Vpic>>;
  _not?: InputMaybe<AirBagLocKnee_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<AirBagLocKnee_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.airbaglocknee" */
export enum AirBagLocKnee_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkAirbaglocknee = 'pk_airbaglocknee',
  /** unique or primary key constraint on columns "name" */
  UAirbaglockneeName = 'u_airbaglocknee_name'
}

/** input type for incrementing numeric columns in table "vpic.airbaglocknee" */
export type AirBagLocKnee_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.airbaglocknee" */
export type AirBagLocKnee_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AirBagLocKnee_Max_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AirBagLocKnee_Min_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.airbaglocknee" */
export type AirBagLocKnee_Mutation_Response_Vpic = {
  __typename?: 'AirBagLocKnee_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AirBagLocKnee_Vpic>;
};

/** on_conflict condition type for table "vpic.airbaglocknee" */
export type AirBagLocKnee_On_Conflict_Vpic = {
  constraint: AirBagLocKnee_Constraint_Vpic;
  update_columns?: Array<AirBagLocKnee_Update_Column_Vpic>;
  where?: InputMaybe<AirBagLocKnee_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.airbaglocknee". */
export type AirBagLocKnee_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.airbaglocknee */
export type AirBagLocKnee_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.airbaglocknee" */
export enum AirBagLocKnee_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.airbaglocknee" */
export type AirBagLocKnee_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AirBagLocKnee_Stddev_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AirBagLocKnee_Stddev_Pop_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AirBagLocKnee_Stddev_Samp_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AirBagLocKnee" */
export type AirBagLocKnee_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: AirBagLocKnee_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type AirBagLocKnee_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AirBagLocKnee_Sum_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.airbaglocknee" */
export enum AirBagLocKnee_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type AirBagLocKnee_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AirBagLocKnee_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AirBagLocKnee_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: AirBagLocKnee_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type AirBagLocKnee_Var_Pop_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AirBagLocKnee_Var_Samp_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AirBagLocKnee_Variance_Fields_Vpic = {
  __typename?: 'AirBagLocKnee_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.airbaglocknee" */
export type AirBagLocKnee_Vpic = {
  __typename?: 'AirBagLocKnee_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.airbaglocations" */
export type AirBagLocations_Aggregate_Fields_Vpic = {
  __typename?: 'AirBagLocations_aggregate_fields_vpic';
  avg?: Maybe<AirBagLocations_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<AirBagLocations_Max_Fields_Vpic>;
  min?: Maybe<AirBagLocations_Min_Fields_Vpic>;
  stddev?: Maybe<AirBagLocations_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<AirBagLocations_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<AirBagLocations_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<AirBagLocations_Sum_Fields_Vpic>;
  var_pop?: Maybe<AirBagLocations_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<AirBagLocations_Var_Samp_Fields_Vpic>;
  variance?: Maybe<AirBagLocations_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.airbaglocations" */
export type AirBagLocations_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<AirBagLocations_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.airbaglocations" */
export type AirBagLocations_Aggregate_Vpic = {
  __typename?: 'AirBagLocations_aggregate_vpic';
  aggregate?: Maybe<AirBagLocations_Aggregate_Fields_Vpic>;
  nodes: Array<AirBagLocations_Vpic>;
};

/** aggregate avg on columns */
export type AirBagLocations_Avg_Fields_Vpic = {
  __typename?: 'AirBagLocations_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.airbaglocations". All fields are combined with a logical 'AND'. */
export type AirBagLocations_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AirBagLocations_Bool_Exp_Vpic>>;
  _not?: InputMaybe<AirBagLocations_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<AirBagLocations_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.airbaglocations" */
export enum AirBagLocations_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkAirbaglocations = 'pk_airbaglocations',
  /** unique or primary key constraint on columns "name" */
  UAirbaglocname = 'u_airbaglocname'
}

/** input type for incrementing numeric columns in table "vpic.airbaglocations" */
export type AirBagLocations_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.airbaglocations" */
export type AirBagLocations_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AirBagLocations_Max_Fields_Vpic = {
  __typename?: 'AirBagLocations_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AirBagLocations_Min_Fields_Vpic = {
  __typename?: 'AirBagLocations_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.airbaglocations" */
export type AirBagLocations_Mutation_Response_Vpic = {
  __typename?: 'AirBagLocations_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AirBagLocations_Vpic>;
};

/** on_conflict condition type for table "vpic.airbaglocations" */
export type AirBagLocations_On_Conflict_Vpic = {
  constraint: AirBagLocations_Constraint_Vpic;
  update_columns?: Array<AirBagLocations_Update_Column_Vpic>;
  where?: InputMaybe<AirBagLocations_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.airbaglocations". */
export type AirBagLocations_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.airbaglocations */
export type AirBagLocations_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.airbaglocations" */
export enum AirBagLocations_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.airbaglocations" */
export type AirBagLocations_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AirBagLocations_Stddev_Fields_Vpic = {
  __typename?: 'AirBagLocations_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AirBagLocations_Stddev_Pop_Fields_Vpic = {
  __typename?: 'AirBagLocations_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AirBagLocations_Stddev_Samp_Fields_Vpic = {
  __typename?: 'AirBagLocations_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AirBagLocations" */
export type AirBagLocations_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: AirBagLocations_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type AirBagLocations_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AirBagLocations_Sum_Fields_Vpic = {
  __typename?: 'AirBagLocations_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.airbaglocations" */
export enum AirBagLocations_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type AirBagLocations_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AirBagLocations_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AirBagLocations_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: AirBagLocations_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type AirBagLocations_Var_Pop_Fields_Vpic = {
  __typename?: 'AirBagLocations_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AirBagLocations_Var_Samp_Fields_Vpic = {
  __typename?: 'AirBagLocations_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AirBagLocations_Variance_Fields_Vpic = {
  __typename?: 'AirBagLocations_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.airbaglocations" */
export type AirBagLocations_Vpic = {
  __typename?: 'AirBagLocations_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Already_Canceled_V1 = {
  __typename?: 'Already_Canceled_v1';
  cancelAsOfDate: Scalars['date'];
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  vin: Scalars['String'];
};

export type Already_Canceled_V2 = {
  __typename?: 'Already_Canceled_v2';
  cancelAsOfDate: Scalars['date'];
  cancelReason: Scalars['String'];
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  mileage: Scalars['numeric'];
  processedDate: Scalars['date'];
  vin: Scalars['String'];
};

export type Amortization_Schedule_Item_V1 = {
  __typename?: 'Amortization_Schedule_Item_v1';
  balance: Scalars['numeric'];
  date: Scalars['String'];
  interest: Scalars['numeric'];
  paymentAmount: Scalars['numeric'];
  paymentNumber: Scalars['numeric'];
  principal: Scalars['numeric'];
  totalInterest: Scalars['numeric'];
  totalPaid: Scalars['numeric'];
};

/** aggregate fields of "vpic.autobrake" */
export type AutoBrake_Aggregate_Fields_Vpic = {
  __typename?: 'AutoBrake_aggregate_fields_vpic';
  avg?: Maybe<AutoBrake_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<AutoBrake_Max_Fields_Vpic>;
  min?: Maybe<AutoBrake_Min_Fields_Vpic>;
  stddev?: Maybe<AutoBrake_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<AutoBrake_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<AutoBrake_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<AutoBrake_Sum_Fields_Vpic>;
  var_pop?: Maybe<AutoBrake_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<AutoBrake_Var_Samp_Fields_Vpic>;
  variance?: Maybe<AutoBrake_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.autobrake" */
export type AutoBrake_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<AutoBrake_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.autobrake" */
export type AutoBrake_Aggregate_Vpic = {
  __typename?: 'AutoBrake_aggregate_vpic';
  aggregate?: Maybe<AutoBrake_Aggregate_Fields_Vpic>;
  nodes: Array<AutoBrake_Vpic>;
};

/** aggregate avg on columns */
export type AutoBrake_Avg_Fields_Vpic = {
  __typename?: 'AutoBrake_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.autobrake". All fields are combined with a logical 'AND'. */
export type AutoBrake_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AutoBrake_Bool_Exp_Vpic>>;
  _not?: InputMaybe<AutoBrake_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<AutoBrake_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.autobrake" */
export enum AutoBrake_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkAutobrake = 'pk_autobrake',
  /** unique or primary key constraint on columns "name" */
  UAebname = 'u_aebname'
}

/** input type for incrementing numeric columns in table "vpic.autobrake" */
export type AutoBrake_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.autobrake" */
export type AutoBrake_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AutoBrake_Max_Fields_Vpic = {
  __typename?: 'AutoBrake_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AutoBrake_Min_Fields_Vpic = {
  __typename?: 'AutoBrake_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.autobrake" */
export type AutoBrake_Mutation_Response_Vpic = {
  __typename?: 'AutoBrake_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AutoBrake_Vpic>;
};

/** on_conflict condition type for table "vpic.autobrake" */
export type AutoBrake_On_Conflict_Vpic = {
  constraint: AutoBrake_Constraint_Vpic;
  update_columns?: Array<AutoBrake_Update_Column_Vpic>;
  where?: InputMaybe<AutoBrake_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.autobrake". */
export type AutoBrake_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.autobrake */
export type AutoBrake_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.autobrake" */
export enum AutoBrake_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.autobrake" */
export type AutoBrake_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AutoBrake_Stddev_Fields_Vpic = {
  __typename?: 'AutoBrake_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AutoBrake_Stddev_Pop_Fields_Vpic = {
  __typename?: 'AutoBrake_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AutoBrake_Stddev_Samp_Fields_Vpic = {
  __typename?: 'AutoBrake_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AutoBrake" */
export type AutoBrake_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: AutoBrake_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type AutoBrake_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AutoBrake_Sum_Fields_Vpic = {
  __typename?: 'AutoBrake_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.autobrake" */
export enum AutoBrake_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type AutoBrake_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AutoBrake_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AutoBrake_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: AutoBrake_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type AutoBrake_Var_Pop_Fields_Vpic = {
  __typename?: 'AutoBrake_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AutoBrake_Var_Samp_Fields_Vpic = {
  __typename?: 'AutoBrake_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AutoBrake_Variance_Fields_Vpic = {
  __typename?: 'AutoBrake_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.autobrake" */
export type AutoBrake_Vpic = {
  __typename?: 'AutoBrake_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.autoreversesystem" */
export type AutoReverseSystem_Aggregate_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_aggregate_fields_vpic';
  avg?: Maybe<AutoReverseSystem_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<AutoReverseSystem_Max_Fields_Vpic>;
  min?: Maybe<AutoReverseSystem_Min_Fields_Vpic>;
  stddev?: Maybe<AutoReverseSystem_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<AutoReverseSystem_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<AutoReverseSystem_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<AutoReverseSystem_Sum_Fields_Vpic>;
  var_pop?: Maybe<AutoReverseSystem_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<AutoReverseSystem_Var_Samp_Fields_Vpic>;
  variance?: Maybe<AutoReverseSystem_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.autoreversesystem" */
export type AutoReverseSystem_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<AutoReverseSystem_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.autoreversesystem" */
export type AutoReverseSystem_Aggregate_Vpic = {
  __typename?: 'AutoReverseSystem_aggregate_vpic';
  aggregate?: Maybe<AutoReverseSystem_Aggregate_Fields_Vpic>;
  nodes: Array<AutoReverseSystem_Vpic>;
};

/** aggregate avg on columns */
export type AutoReverseSystem_Avg_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.autoreversesystem". All fields are combined with a logical 'AND'. */
export type AutoReverseSystem_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AutoReverseSystem_Bool_Exp_Vpic>>;
  _not?: InputMaybe<AutoReverseSystem_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<AutoReverseSystem_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.autoreversesystem" */
export enum AutoReverseSystem_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkAutoreve_3214ec07d99b9c79 = 'pk__autoreve__3214ec07d99b9c79'
}

/** input type for incrementing numeric columns in table "vpic.autoreversesystem" */
export type AutoReverseSystem_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.autoreversesystem" */
export type AutoReverseSystem_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AutoReverseSystem_Max_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AutoReverseSystem_Min_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.autoreversesystem" */
export type AutoReverseSystem_Mutation_Response_Vpic = {
  __typename?: 'AutoReverseSystem_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AutoReverseSystem_Vpic>;
};

/** on_conflict condition type for table "vpic.autoreversesystem" */
export type AutoReverseSystem_On_Conflict_Vpic = {
  constraint: AutoReverseSystem_Constraint_Vpic;
  update_columns?: Array<AutoReverseSystem_Update_Column_Vpic>;
  where?: InputMaybe<AutoReverseSystem_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.autoreversesystem". */
export type AutoReverseSystem_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.autoreversesystem */
export type AutoReverseSystem_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.autoreversesystem" */
export enum AutoReverseSystem_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.autoreversesystem" */
export type AutoReverseSystem_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AutoReverseSystem_Stddev_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AutoReverseSystem_Stddev_Pop_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AutoReverseSystem_Stddev_Samp_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AutoReverseSystem" */
export type AutoReverseSystem_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: AutoReverseSystem_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type AutoReverseSystem_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AutoReverseSystem_Sum_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.autoreversesystem" */
export enum AutoReverseSystem_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type AutoReverseSystem_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AutoReverseSystem_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AutoReverseSystem_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: AutoReverseSystem_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type AutoReverseSystem_Var_Pop_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AutoReverseSystem_Var_Samp_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AutoReverseSystem_Variance_Fields_Vpic = {
  __typename?: 'AutoReverseSystem_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.autoreversesystem" */
export type AutoReverseSystem_Vpic = {
  __typename?: 'AutoReverseSystem_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.automaticpedestrainalertingsound" */
export type AutomaticPedestrainAlertingSound_Aggregate_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_aggregate_fields_vpic';
  avg?: Maybe<AutomaticPedestrainAlertingSound_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<AutomaticPedestrainAlertingSound_Max_Fields_Vpic>;
  min?: Maybe<AutomaticPedestrainAlertingSound_Min_Fields_Vpic>;
  stddev?: Maybe<AutomaticPedestrainAlertingSound_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<AutomaticPedestrainAlertingSound_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<AutomaticPedestrainAlertingSound_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<AutomaticPedestrainAlertingSound_Sum_Fields_Vpic>;
  var_pop?: Maybe<AutomaticPedestrainAlertingSound_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<AutomaticPedestrainAlertingSound_Var_Samp_Fields_Vpic>;
  variance?: Maybe<AutomaticPedestrainAlertingSound_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.automaticpedestrainalertingsound" */
export type AutomaticPedestrainAlertingSound_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.automaticpedestrainalertingsound" */
export type AutomaticPedestrainAlertingSound_Aggregate_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_aggregate_vpic';
  aggregate?: Maybe<AutomaticPedestrainAlertingSound_Aggregate_Fields_Vpic>;
  nodes: Array<AutomaticPedestrainAlertingSound_Vpic>;
};

/** aggregate avg on columns */
export type AutomaticPedestrainAlertingSound_Avg_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.automaticpedestrainalertingsound". All fields are combined with a logical 'AND'. */
export type AutomaticPedestrainAlertingSound_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Bool_Exp_Vpic>>;
  _not?: InputMaybe<AutomaticPedestrainAlertingSound_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.automaticpedestrainalertingsound" */
export enum AutomaticPedestrainAlertingSound_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkAutomati_3214ec079a150e03 = 'pk__automati__3214ec079a150e03'
}

/** input type for incrementing numeric columns in table "vpic.automaticpedestrainalertingsound" */
export type AutomaticPedestrainAlertingSound_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.automaticpedestrainalertingsound" */
export type AutomaticPedestrainAlertingSound_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AutomaticPedestrainAlertingSound_Max_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AutomaticPedestrainAlertingSound_Min_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.automaticpedestrainalertingsound" */
export type AutomaticPedestrainAlertingSound_Mutation_Response_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AutomaticPedestrainAlertingSound_Vpic>;
};

/** on_conflict condition type for table "vpic.automaticpedestrainalertingsound" */
export type AutomaticPedestrainAlertingSound_On_Conflict_Vpic = {
  constraint: AutomaticPedestrainAlertingSound_Constraint_Vpic;
  update_columns?: Array<AutomaticPedestrainAlertingSound_Update_Column_Vpic>;
  where?: InputMaybe<AutomaticPedestrainAlertingSound_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.automaticpedestrainalertingsound". */
export type AutomaticPedestrainAlertingSound_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.automaticpedestrainalertingsound */
export type AutomaticPedestrainAlertingSound_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.automaticpedestrainalertingsound" */
export enum AutomaticPedestrainAlertingSound_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.automaticpedestrainalertingsound" */
export type AutomaticPedestrainAlertingSound_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AutomaticPedestrainAlertingSound_Stddev_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AutomaticPedestrainAlertingSound_Stddev_Pop_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AutomaticPedestrainAlertingSound_Stddev_Samp_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AutomaticPedestrainAlertingSound" */
export type AutomaticPedestrainAlertingSound_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: AutomaticPedestrainAlertingSound_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type AutomaticPedestrainAlertingSound_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AutomaticPedestrainAlertingSound_Sum_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.automaticpedestrainalertingsound" */
export enum AutomaticPedestrainAlertingSound_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type AutomaticPedestrainAlertingSound_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AutomaticPedestrainAlertingSound_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AutomaticPedestrainAlertingSound_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: AutomaticPedestrainAlertingSound_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type AutomaticPedestrainAlertingSound_Var_Pop_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AutomaticPedestrainAlertingSound_Var_Samp_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AutomaticPedestrainAlertingSound_Variance_Fields_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.automaticpedestrainalertingsound" */
export type AutomaticPedestrainAlertingSound_Vpic = {
  __typename?: 'AutomaticPedestrainAlertingSound_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.axleconfiguration" */
export type AxleConfiguration_Aggregate_Fields_Vpic = {
  __typename?: 'AxleConfiguration_aggregate_fields_vpic';
  avg?: Maybe<AxleConfiguration_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<AxleConfiguration_Max_Fields_Vpic>;
  min?: Maybe<AxleConfiguration_Min_Fields_Vpic>;
  stddev?: Maybe<AxleConfiguration_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<AxleConfiguration_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<AxleConfiguration_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<AxleConfiguration_Sum_Fields_Vpic>;
  var_pop?: Maybe<AxleConfiguration_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<AxleConfiguration_Var_Samp_Fields_Vpic>;
  variance?: Maybe<AxleConfiguration_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.axleconfiguration" */
export type AxleConfiguration_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<AxleConfiguration_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.axleconfiguration" */
export type AxleConfiguration_Aggregate_Vpic = {
  __typename?: 'AxleConfiguration_aggregate_vpic';
  aggregate?: Maybe<AxleConfiguration_Aggregate_Fields_Vpic>;
  nodes: Array<AxleConfiguration_Vpic>;
};

/** aggregate avg on columns */
export type AxleConfiguration_Avg_Fields_Vpic = {
  __typename?: 'AxleConfiguration_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.axleconfiguration". All fields are combined with a logical 'AND'. */
export type AxleConfiguration_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AxleConfiguration_Bool_Exp_Vpic>>;
  _not?: InputMaybe<AxleConfiguration_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<AxleConfiguration_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.axleconfiguration" */
export enum AxleConfiguration_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkAxleconfiguration = 'pk_axleconfiguration',
  /** unique or primary key constraint on columns "name" */
  UAxleconfiguration = 'u_axleconfiguration'
}

/** input type for incrementing numeric columns in table "vpic.axleconfiguration" */
export type AxleConfiguration_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.axleconfiguration" */
export type AxleConfiguration_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AxleConfiguration_Max_Fields_Vpic = {
  __typename?: 'AxleConfiguration_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AxleConfiguration_Min_Fields_Vpic = {
  __typename?: 'AxleConfiguration_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.axleconfiguration" */
export type AxleConfiguration_Mutation_Response_Vpic = {
  __typename?: 'AxleConfiguration_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AxleConfiguration_Vpic>;
};

/** on_conflict condition type for table "vpic.axleconfiguration" */
export type AxleConfiguration_On_Conflict_Vpic = {
  constraint: AxleConfiguration_Constraint_Vpic;
  update_columns?: Array<AxleConfiguration_Update_Column_Vpic>;
  where?: InputMaybe<AxleConfiguration_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.axleconfiguration". */
export type AxleConfiguration_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.axleconfiguration */
export type AxleConfiguration_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.axleconfiguration" */
export enum AxleConfiguration_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.axleconfiguration" */
export type AxleConfiguration_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AxleConfiguration_Stddev_Fields_Vpic = {
  __typename?: 'AxleConfiguration_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AxleConfiguration_Stddev_Pop_Fields_Vpic = {
  __typename?: 'AxleConfiguration_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AxleConfiguration_Stddev_Samp_Fields_Vpic = {
  __typename?: 'AxleConfiguration_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AxleConfiguration" */
export type AxleConfiguration_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: AxleConfiguration_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type AxleConfiguration_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AxleConfiguration_Sum_Fields_Vpic = {
  __typename?: 'AxleConfiguration_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.axleconfiguration" */
export enum AxleConfiguration_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type AxleConfiguration_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AxleConfiguration_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AxleConfiguration_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: AxleConfiguration_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type AxleConfiguration_Var_Pop_Fields_Vpic = {
  __typename?: 'AxleConfiguration_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AxleConfiguration_Var_Samp_Fields_Vpic = {
  __typename?: 'AxleConfiguration_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AxleConfiguration_Variance_Fields_Vpic = {
  __typename?: 'AxleConfiguration_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.axleconfiguration" */
export type AxleConfiguration_Vpic = {
  __typename?: 'AxleConfiguration_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.batterytype" */
export type BatteryType_Aggregate_Fields_Vpic = {
  __typename?: 'BatteryType_aggregate_fields_vpic';
  avg?: Maybe<BatteryType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<BatteryType_Max_Fields_Vpic>;
  min?: Maybe<BatteryType_Min_Fields_Vpic>;
  stddev?: Maybe<BatteryType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<BatteryType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<BatteryType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<BatteryType_Sum_Fields_Vpic>;
  var_pop?: Maybe<BatteryType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<BatteryType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<BatteryType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.batterytype" */
export type BatteryType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<BatteryType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.batterytype" */
export type BatteryType_Aggregate_Vpic = {
  __typename?: 'BatteryType_aggregate_vpic';
  aggregate?: Maybe<BatteryType_Aggregate_Fields_Vpic>;
  nodes: Array<BatteryType_Vpic>;
};

/** aggregate avg on columns */
export type BatteryType_Avg_Fields_Vpic = {
  __typename?: 'BatteryType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.batterytype". All fields are combined with a logical 'AND'. */
export type BatteryType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<BatteryType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<BatteryType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<BatteryType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.batterytype" */
export enum BatteryType_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkBatterytype = 'pk_batterytype',
  /** unique or primary key constraint on columns "name" */
  UBatterytypename = 'u_batterytypename'
}

/** input type for incrementing numeric columns in table "vpic.batterytype" */
export type BatteryType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.batterytype" */
export type BatteryType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BatteryType_Max_Fields_Vpic = {
  __typename?: 'BatteryType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BatteryType_Min_Fields_Vpic = {
  __typename?: 'BatteryType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.batterytype" */
export type BatteryType_Mutation_Response_Vpic = {
  __typename?: 'BatteryType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BatteryType_Vpic>;
};

/** on_conflict condition type for table "vpic.batterytype" */
export type BatteryType_On_Conflict_Vpic = {
  constraint: BatteryType_Constraint_Vpic;
  update_columns?: Array<BatteryType_Update_Column_Vpic>;
  where?: InputMaybe<BatteryType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.batterytype". */
export type BatteryType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.batterytype */
export type BatteryType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.batterytype" */
export enum BatteryType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.batterytype" */
export type BatteryType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BatteryType_Stddev_Fields_Vpic = {
  __typename?: 'BatteryType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BatteryType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'BatteryType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BatteryType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'BatteryType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BatteryType" */
export type BatteryType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: BatteryType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type BatteryType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BatteryType_Sum_Fields_Vpic = {
  __typename?: 'BatteryType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.batterytype" */
export enum BatteryType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type BatteryType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BatteryType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BatteryType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: BatteryType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type BatteryType_Var_Pop_Fields_Vpic = {
  __typename?: 'BatteryType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BatteryType_Var_Samp_Fields_Vpic = {
  __typename?: 'BatteryType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BatteryType_Variance_Fields_Vpic = {
  __typename?: 'BatteryType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.batterytype" */
export type BatteryType_Vpic = {
  __typename?: 'BatteryType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.bedtype" */
export type BedType_Aggregate_Fields_Vpic = {
  __typename?: 'BedType_aggregate_fields_vpic';
  avg?: Maybe<BedType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<BedType_Max_Fields_Vpic>;
  min?: Maybe<BedType_Min_Fields_Vpic>;
  stddev?: Maybe<BedType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<BedType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<BedType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<BedType_Sum_Fields_Vpic>;
  var_pop?: Maybe<BedType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<BedType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<BedType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.bedtype" */
export type BedType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<BedType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.bedtype" */
export type BedType_Aggregate_Vpic = {
  __typename?: 'BedType_aggregate_vpic';
  aggregate?: Maybe<BedType_Aggregate_Fields_Vpic>;
  nodes: Array<BedType_Vpic>;
};

/** aggregate avg on columns */
export type BedType_Avg_Fields_Vpic = {
  __typename?: 'BedType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.bedtype". All fields are combined with a logical 'AND'. */
export type BedType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<BedType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<BedType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<BedType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.bedtype" */
export enum BedType_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkBedtype = 'pk_bedtype',
  /** unique or primary key constraint on columns "name" */
  UBedtypename = 'u_bedtypename'
}

/** input type for incrementing numeric columns in table "vpic.bedtype" */
export type BedType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.bedtype" */
export type BedType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BedType_Max_Fields_Vpic = {
  __typename?: 'BedType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BedType_Min_Fields_Vpic = {
  __typename?: 'BedType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.bedtype" */
export type BedType_Mutation_Response_Vpic = {
  __typename?: 'BedType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BedType_Vpic>;
};

/** on_conflict condition type for table "vpic.bedtype" */
export type BedType_On_Conflict_Vpic = {
  constraint: BedType_Constraint_Vpic;
  update_columns?: Array<BedType_Update_Column_Vpic>;
  where?: InputMaybe<BedType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.bedtype". */
export type BedType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.bedtype */
export type BedType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.bedtype" */
export enum BedType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.bedtype" */
export type BedType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BedType_Stddev_Fields_Vpic = {
  __typename?: 'BedType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BedType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'BedType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BedType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'BedType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BedType" */
export type BedType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: BedType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type BedType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BedType_Sum_Fields_Vpic = {
  __typename?: 'BedType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.bedtype" */
export enum BedType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type BedType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BedType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BedType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: BedType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type BedType_Var_Pop_Fields_Vpic = {
  __typename?: 'BedType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BedType_Var_Samp_Fields_Vpic = {
  __typename?: 'BedType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BedType_Variance_Fields_Vpic = {
  __typename?: 'BedType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.bedtype" */
export type BedType_Vpic = {
  __typename?: 'BedType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.blindspotintervention" */
export type BlindSpotIntervention_Aggregate_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_aggregate_fields_vpic';
  avg?: Maybe<BlindSpotIntervention_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<BlindSpotIntervention_Max_Fields_Vpic>;
  min?: Maybe<BlindSpotIntervention_Min_Fields_Vpic>;
  stddev?: Maybe<BlindSpotIntervention_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<BlindSpotIntervention_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<BlindSpotIntervention_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<BlindSpotIntervention_Sum_Fields_Vpic>;
  var_pop?: Maybe<BlindSpotIntervention_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<BlindSpotIntervention_Var_Samp_Fields_Vpic>;
  variance?: Maybe<BlindSpotIntervention_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.blindspotintervention" */
export type BlindSpotIntervention_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<BlindSpotIntervention_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.blindspotintervention" */
export type BlindSpotIntervention_Aggregate_Vpic = {
  __typename?: 'BlindSpotIntervention_aggregate_vpic';
  aggregate?: Maybe<BlindSpotIntervention_Aggregate_Fields_Vpic>;
  nodes: Array<BlindSpotIntervention_Vpic>;
};

/** aggregate avg on columns */
export type BlindSpotIntervention_Avg_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.blindspotintervention". All fields are combined with a logical 'AND'. */
export type BlindSpotIntervention_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<BlindSpotIntervention_Bool_Exp_Vpic>>;
  _not?: InputMaybe<BlindSpotIntervention_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<BlindSpotIntervention_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.blindspotintervention" */
export enum BlindSpotIntervention_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkBlindspotintervention = 'pk_blindspotintervention',
  /** unique or primary key constraint on columns "name" */
  UBlindspotintervention = 'u_blindspotintervention'
}

/** input type for incrementing numeric columns in table "vpic.blindspotintervention" */
export type BlindSpotIntervention_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.blindspotintervention" */
export type BlindSpotIntervention_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BlindSpotIntervention_Max_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BlindSpotIntervention_Min_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.blindspotintervention" */
export type BlindSpotIntervention_Mutation_Response_Vpic = {
  __typename?: 'BlindSpotIntervention_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BlindSpotIntervention_Vpic>;
};

/** on_conflict condition type for table "vpic.blindspotintervention" */
export type BlindSpotIntervention_On_Conflict_Vpic = {
  constraint: BlindSpotIntervention_Constraint_Vpic;
  update_columns?: Array<BlindSpotIntervention_Update_Column_Vpic>;
  where?: InputMaybe<BlindSpotIntervention_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.blindspotintervention". */
export type BlindSpotIntervention_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.blindspotintervention */
export type BlindSpotIntervention_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.blindspotintervention" */
export enum BlindSpotIntervention_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.blindspotintervention" */
export type BlindSpotIntervention_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BlindSpotIntervention_Stddev_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BlindSpotIntervention_Stddev_Pop_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BlindSpotIntervention_Stddev_Samp_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BlindSpotIntervention" */
export type BlindSpotIntervention_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: BlindSpotIntervention_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type BlindSpotIntervention_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BlindSpotIntervention_Sum_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.blindspotintervention" */
export enum BlindSpotIntervention_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type BlindSpotIntervention_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BlindSpotIntervention_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BlindSpotIntervention_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: BlindSpotIntervention_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type BlindSpotIntervention_Var_Pop_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BlindSpotIntervention_Var_Samp_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BlindSpotIntervention_Variance_Fields_Vpic = {
  __typename?: 'BlindSpotIntervention_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.blindspotintervention" */
export type BlindSpotIntervention_Vpic = {
  __typename?: 'BlindSpotIntervention_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.blindspotmonitoring" */
export type BlindSpotMonitoring_Aggregate_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_aggregate_fields_vpic';
  avg?: Maybe<BlindSpotMonitoring_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<BlindSpotMonitoring_Max_Fields_Vpic>;
  min?: Maybe<BlindSpotMonitoring_Min_Fields_Vpic>;
  stddev?: Maybe<BlindSpotMonitoring_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<BlindSpotMonitoring_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<BlindSpotMonitoring_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<BlindSpotMonitoring_Sum_Fields_Vpic>;
  var_pop?: Maybe<BlindSpotMonitoring_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<BlindSpotMonitoring_Var_Samp_Fields_Vpic>;
  variance?: Maybe<BlindSpotMonitoring_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.blindspotmonitoring" */
export type BlindSpotMonitoring_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<BlindSpotMonitoring_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.blindspotmonitoring" */
export type BlindSpotMonitoring_Aggregate_Vpic = {
  __typename?: 'BlindSpotMonitoring_aggregate_vpic';
  aggregate?: Maybe<BlindSpotMonitoring_Aggregate_Fields_Vpic>;
  nodes: Array<BlindSpotMonitoring_Vpic>;
};

/** aggregate avg on columns */
export type BlindSpotMonitoring_Avg_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.blindspotmonitoring". All fields are combined with a logical 'AND'. */
export type BlindSpotMonitoring_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<BlindSpotMonitoring_Bool_Exp_Vpic>>;
  _not?: InputMaybe<BlindSpotMonitoring_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<BlindSpotMonitoring_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.blindspotmonitoring" */
export enum BlindSpotMonitoring_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkBlindspotmonitoring = 'pk_blindspotmonitoring',
  /** unique or primary key constraint on columns "name" */
  UBlindspotmonname = 'u_blindspotmonname'
}

/** input type for incrementing numeric columns in table "vpic.blindspotmonitoring" */
export type BlindSpotMonitoring_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.blindspotmonitoring" */
export type BlindSpotMonitoring_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BlindSpotMonitoring_Max_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BlindSpotMonitoring_Min_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.blindspotmonitoring" */
export type BlindSpotMonitoring_Mutation_Response_Vpic = {
  __typename?: 'BlindSpotMonitoring_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BlindSpotMonitoring_Vpic>;
};

/** on_conflict condition type for table "vpic.blindspotmonitoring" */
export type BlindSpotMonitoring_On_Conflict_Vpic = {
  constraint: BlindSpotMonitoring_Constraint_Vpic;
  update_columns?: Array<BlindSpotMonitoring_Update_Column_Vpic>;
  where?: InputMaybe<BlindSpotMonitoring_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.blindspotmonitoring". */
export type BlindSpotMonitoring_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.blindspotmonitoring */
export type BlindSpotMonitoring_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.blindspotmonitoring" */
export enum BlindSpotMonitoring_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.blindspotmonitoring" */
export type BlindSpotMonitoring_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BlindSpotMonitoring_Stddev_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BlindSpotMonitoring_Stddev_Pop_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BlindSpotMonitoring_Stddev_Samp_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BlindSpotMonitoring" */
export type BlindSpotMonitoring_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: BlindSpotMonitoring_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type BlindSpotMonitoring_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BlindSpotMonitoring_Sum_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.blindspotmonitoring" */
export enum BlindSpotMonitoring_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type BlindSpotMonitoring_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BlindSpotMonitoring_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BlindSpotMonitoring_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: BlindSpotMonitoring_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type BlindSpotMonitoring_Var_Pop_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BlindSpotMonitoring_Var_Samp_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BlindSpotMonitoring_Variance_Fields_Vpic = {
  __typename?: 'BlindSpotMonitoring_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.blindspotmonitoring" */
export type BlindSpotMonitoring_Vpic = {
  __typename?: 'BlindSpotMonitoring_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.bodycab" */
export type BodyCab_Aggregate_Fields_Vpic = {
  __typename?: 'BodyCab_aggregate_fields_vpic';
  avg?: Maybe<BodyCab_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<BodyCab_Max_Fields_Vpic>;
  min?: Maybe<BodyCab_Min_Fields_Vpic>;
  stddev?: Maybe<BodyCab_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<BodyCab_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<BodyCab_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<BodyCab_Sum_Fields_Vpic>;
  var_pop?: Maybe<BodyCab_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<BodyCab_Var_Samp_Fields_Vpic>;
  variance?: Maybe<BodyCab_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.bodycab" */
export type BodyCab_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<BodyCab_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.bodycab" */
export type BodyCab_Aggregate_Vpic = {
  __typename?: 'BodyCab_aggregate_vpic';
  aggregate?: Maybe<BodyCab_Aggregate_Fields_Vpic>;
  nodes: Array<BodyCab_Vpic>;
};

/** aggregate avg on columns */
export type BodyCab_Avg_Fields_Vpic = {
  __typename?: 'BodyCab_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.bodycab". All fields are combined with a logical 'AND'. */
export type BodyCab_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<BodyCab_Bool_Exp_Vpic>>;
  _not?: InputMaybe<BodyCab_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<BodyCab_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.bodycab" */
export enum BodyCab_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkBodycab = 'pk_bodycab',
  /** unique or primary key constraint on columns "name" */
  UBodycabtypename = 'u_bodycabtypename'
}

/** input type for incrementing numeric columns in table "vpic.bodycab" */
export type BodyCab_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.bodycab" */
export type BodyCab_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BodyCab_Max_Fields_Vpic = {
  __typename?: 'BodyCab_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BodyCab_Min_Fields_Vpic = {
  __typename?: 'BodyCab_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.bodycab" */
export type BodyCab_Mutation_Response_Vpic = {
  __typename?: 'BodyCab_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BodyCab_Vpic>;
};

/** on_conflict condition type for table "vpic.bodycab" */
export type BodyCab_On_Conflict_Vpic = {
  constraint: BodyCab_Constraint_Vpic;
  update_columns?: Array<BodyCab_Update_Column_Vpic>;
  where?: InputMaybe<BodyCab_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.bodycab". */
export type BodyCab_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.bodycab */
export type BodyCab_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.bodycab" */
export enum BodyCab_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.bodycab" */
export type BodyCab_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BodyCab_Stddev_Fields_Vpic = {
  __typename?: 'BodyCab_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BodyCab_Stddev_Pop_Fields_Vpic = {
  __typename?: 'BodyCab_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BodyCab_Stddev_Samp_Fields_Vpic = {
  __typename?: 'BodyCab_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BodyCab" */
export type BodyCab_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: BodyCab_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type BodyCab_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BodyCab_Sum_Fields_Vpic = {
  __typename?: 'BodyCab_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.bodycab" */
export enum BodyCab_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type BodyCab_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BodyCab_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BodyCab_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: BodyCab_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type BodyCab_Var_Pop_Fields_Vpic = {
  __typename?: 'BodyCab_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BodyCab_Var_Samp_Fields_Vpic = {
  __typename?: 'BodyCab_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BodyCab_Variance_Fields_Vpic = {
  __typename?: 'BodyCab_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.bodycab" */
export type BodyCab_Vpic = {
  __typename?: 'BodyCab_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.bodystyle" */
export type BodyStyle_Aggregate_Fields_Vpic = {
  __typename?: 'BodyStyle_aggregate_fields_vpic';
  avg?: Maybe<BodyStyle_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<BodyStyle_Max_Fields_Vpic>;
  min?: Maybe<BodyStyle_Min_Fields_Vpic>;
  stddev?: Maybe<BodyStyle_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<BodyStyle_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<BodyStyle_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<BodyStyle_Sum_Fields_Vpic>;
  var_pop?: Maybe<BodyStyle_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<BodyStyle_Var_Samp_Fields_Vpic>;
  variance?: Maybe<BodyStyle_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.bodystyle" */
export type BodyStyle_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<BodyStyle_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.bodystyle" */
export type BodyStyle_Aggregate_Vpic = {
  __typename?: 'BodyStyle_aggregate_vpic';
  aggregate?: Maybe<BodyStyle_Aggregate_Fields_Vpic>;
  nodes: Array<BodyStyle_Vpic>;
};

/** aggregate avg on columns */
export type BodyStyle_Avg_Fields_Vpic = {
  __typename?: 'BodyStyle_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.bodystyle". All fields are combined with a logical 'AND'. */
export type BodyStyle_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<BodyStyle_Bool_Exp_Vpic>>;
  _not?: InputMaybe<BodyStyle_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<BodyStyle_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.bodystyle" */
export enum BodyStyle_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkBodystyle = 'pk_bodystyle',
  /** unique or primary key constraint on columns "name" */
  UBodyclassname = 'u_bodyclassname'
}

/** input type for incrementing numeric columns in table "vpic.bodystyle" */
export type BodyStyle_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.bodystyle" */
export type BodyStyle_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BodyStyle_Max_Fields_Vpic = {
  __typename?: 'BodyStyle_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BodyStyle_Min_Fields_Vpic = {
  __typename?: 'BodyStyle_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.bodystyle" */
export type BodyStyle_Mutation_Response_Vpic = {
  __typename?: 'BodyStyle_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BodyStyle_Vpic>;
};

/** on_conflict condition type for table "vpic.bodystyle" */
export type BodyStyle_On_Conflict_Vpic = {
  constraint: BodyStyle_Constraint_Vpic;
  update_columns?: Array<BodyStyle_Update_Column_Vpic>;
  where?: InputMaybe<BodyStyle_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.bodystyle". */
export type BodyStyle_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.bodystyle */
export type BodyStyle_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.bodystyle" */
export enum BodyStyle_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.bodystyle" */
export type BodyStyle_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BodyStyle_Stddev_Fields_Vpic = {
  __typename?: 'BodyStyle_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BodyStyle_Stddev_Pop_Fields_Vpic = {
  __typename?: 'BodyStyle_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BodyStyle_Stddev_Samp_Fields_Vpic = {
  __typename?: 'BodyStyle_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BodyStyle" */
export type BodyStyle_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: BodyStyle_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type BodyStyle_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BodyStyle_Sum_Fields_Vpic = {
  __typename?: 'BodyStyle_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.bodystyle" */
export enum BodyStyle_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type BodyStyle_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BodyStyle_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BodyStyle_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: BodyStyle_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type BodyStyle_Var_Pop_Fields_Vpic = {
  __typename?: 'BodyStyle_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BodyStyle_Var_Samp_Fields_Vpic = {
  __typename?: 'BodyStyle_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BodyStyle_Variance_Fields_Vpic = {
  __typename?: 'BodyStyle_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.bodystyle" */
export type BodyStyle_Vpic = {
  __typename?: 'BodyStyle_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** aggregate fields of "vpic.brakesystem" */
export type BrakeSystem_Aggregate_Fields_Vpic = {
  __typename?: 'BrakeSystem_aggregate_fields_vpic';
  avg?: Maybe<BrakeSystem_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<BrakeSystem_Max_Fields_Vpic>;
  min?: Maybe<BrakeSystem_Min_Fields_Vpic>;
  stddev?: Maybe<BrakeSystem_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<BrakeSystem_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<BrakeSystem_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<BrakeSystem_Sum_Fields_Vpic>;
  var_pop?: Maybe<BrakeSystem_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<BrakeSystem_Var_Samp_Fields_Vpic>;
  variance?: Maybe<BrakeSystem_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.brakesystem" */
export type BrakeSystem_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<BrakeSystem_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.brakesystem" */
export type BrakeSystem_Aggregate_Vpic = {
  __typename?: 'BrakeSystem_aggregate_vpic';
  aggregate?: Maybe<BrakeSystem_Aggregate_Fields_Vpic>;
  nodes: Array<BrakeSystem_Vpic>;
};

/** aggregate avg on columns */
export type BrakeSystem_Avg_Fields_Vpic = {
  __typename?: 'BrakeSystem_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.brakesystem". All fields are combined with a logical 'AND'. */
export type BrakeSystem_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<BrakeSystem_Bool_Exp_Vpic>>;
  _not?: InputMaybe<BrakeSystem_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<BrakeSystem_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.brakesystem" */
export enum BrakeSystem_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkBrakesystem = 'pk_brakesystem',
  /** unique or primary key constraint on columns "name" */
  UBrakesystemtypename = 'u_brakesystemtypename'
}

/** input type for incrementing numeric columns in table "vpic.brakesystem" */
export type BrakeSystem_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.brakesystem" */
export type BrakeSystem_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BrakeSystem_Max_Fields_Vpic = {
  __typename?: 'BrakeSystem_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BrakeSystem_Min_Fields_Vpic = {
  __typename?: 'BrakeSystem_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.brakesystem" */
export type BrakeSystem_Mutation_Response_Vpic = {
  __typename?: 'BrakeSystem_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BrakeSystem_Vpic>;
};

/** on_conflict condition type for table "vpic.brakesystem" */
export type BrakeSystem_On_Conflict_Vpic = {
  constraint: BrakeSystem_Constraint_Vpic;
  update_columns?: Array<BrakeSystem_Update_Column_Vpic>;
  where?: InputMaybe<BrakeSystem_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.brakesystem". */
export type BrakeSystem_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.brakesystem */
export type BrakeSystem_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.brakesystem" */
export enum BrakeSystem_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.brakesystem" */
export type BrakeSystem_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BrakeSystem_Stddev_Fields_Vpic = {
  __typename?: 'BrakeSystem_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BrakeSystem_Stddev_Pop_Fields_Vpic = {
  __typename?: 'BrakeSystem_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BrakeSystem_Stddev_Samp_Fields_Vpic = {
  __typename?: 'BrakeSystem_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BrakeSystem" */
export type BrakeSystem_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: BrakeSystem_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type BrakeSystem_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BrakeSystem_Sum_Fields_Vpic = {
  __typename?: 'BrakeSystem_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.brakesystem" */
export enum BrakeSystem_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type BrakeSystem_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BrakeSystem_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BrakeSystem_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: BrakeSystem_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type BrakeSystem_Var_Pop_Fields_Vpic = {
  __typename?: 'BrakeSystem_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BrakeSystem_Var_Samp_Fields_Vpic = {
  __typename?: 'BrakeSystem_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BrakeSystem_Variance_Fields_Vpic = {
  __typename?: 'BrakeSystem_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.brakesystem" */
export type BrakeSystem_Vpic = {
  __typename?: 'BrakeSystem_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Bucket = {
  __typename?: 'Bucket';
  rateBucketTypeName?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['numeric']>;
};

/** aggregate fields of "vpic.busfloorconfigtype" */
export type BusFloorConfigType_Aggregate_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_aggregate_fields_vpic';
  avg?: Maybe<BusFloorConfigType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<BusFloorConfigType_Max_Fields_Vpic>;
  min?: Maybe<BusFloorConfigType_Min_Fields_Vpic>;
  stddev?: Maybe<BusFloorConfigType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<BusFloorConfigType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<BusFloorConfigType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<BusFloorConfigType_Sum_Fields_Vpic>;
  var_pop?: Maybe<BusFloorConfigType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<BusFloorConfigType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<BusFloorConfigType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.busfloorconfigtype" */
export type BusFloorConfigType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<BusFloorConfigType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.busfloorconfigtype" */
export type BusFloorConfigType_Aggregate_Vpic = {
  __typename?: 'BusFloorConfigType_aggregate_vpic';
  aggregate?: Maybe<BusFloorConfigType_Aggregate_Fields_Vpic>;
  nodes: Array<BusFloorConfigType_Vpic>;
};

/** aggregate avg on columns */
export type BusFloorConfigType_Avg_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.busfloorconfigtype". All fields are combined with a logical 'AND'. */
export type BusFloorConfigType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<BusFloorConfigType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<BusFloorConfigType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<BusFloorConfigType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.busfloorconfigtype" */
export enum BusFloorConfigType_Constraint_Vpic {
  /** unique or primary key constraint on columns "name" */
  IxBusfloorconfigtype = 'ix_busfloorconfigtype',
  /** unique or primary key constraint on columns "id" */
  PkBusfloorconfigtype = 'pk_busfloorconfigtype'
}

/** input type for incrementing numeric columns in table "vpic.busfloorconfigtype" */
export type BusFloorConfigType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.busfloorconfigtype" */
export type BusFloorConfigType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BusFloorConfigType_Max_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BusFloorConfigType_Min_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.busfloorconfigtype" */
export type BusFloorConfigType_Mutation_Response_Vpic = {
  __typename?: 'BusFloorConfigType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BusFloorConfigType_Vpic>;
};

/** on_conflict condition type for table "vpic.busfloorconfigtype" */
export type BusFloorConfigType_On_Conflict_Vpic = {
  constraint: BusFloorConfigType_Constraint_Vpic;
  update_columns?: Array<BusFloorConfigType_Update_Column_Vpic>;
  where?: InputMaybe<BusFloorConfigType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.busfloorconfigtype". */
export type BusFloorConfigType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.busfloorconfigtype */
export type BusFloorConfigType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.busfloorconfigtype" */
export enum BusFloorConfigType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.busfloorconfigtype" */
export type BusFloorConfigType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BusFloorConfigType_Stddev_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BusFloorConfigType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BusFloorConfigType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BusFloorConfigType" */
export type BusFloorConfigType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: BusFloorConfigType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type BusFloorConfigType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BusFloorConfigType_Sum_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.busfloorconfigtype" */
export enum BusFloorConfigType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type BusFloorConfigType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BusFloorConfigType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusFloorConfigType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: BusFloorConfigType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type BusFloorConfigType_Var_Pop_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BusFloorConfigType_Var_Samp_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BusFloorConfigType_Variance_Fields_Vpic = {
  __typename?: 'BusFloorConfigType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.busfloorconfigtype" */
export type BusFloorConfigType_Vpic = {
  __typename?: 'BusFloorConfigType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.bustype" */
export type BusType_Aggregate_Fields_Vpic = {
  __typename?: 'BusType_aggregate_fields_vpic';
  avg?: Maybe<BusType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<BusType_Max_Fields_Vpic>;
  min?: Maybe<BusType_Min_Fields_Vpic>;
  stddev?: Maybe<BusType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<BusType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<BusType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<BusType_Sum_Fields_Vpic>;
  var_pop?: Maybe<BusType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<BusType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<BusType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.bustype" */
export type BusType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<BusType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.bustype" */
export type BusType_Aggregate_Vpic = {
  __typename?: 'BusType_aggregate_vpic';
  aggregate?: Maybe<BusType_Aggregate_Fields_Vpic>;
  nodes: Array<BusType_Vpic>;
};

/** aggregate avg on columns */
export type BusType_Avg_Fields_Vpic = {
  __typename?: 'BusType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.bustype". All fields are combined with a logical 'AND'. */
export type BusType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<BusType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<BusType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<BusType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.bustype" */
export enum BusType_Constraint_Vpic {
  /** unique or primary key constraint on columns "name" */
  IxBustype = 'ix_bustype',
  /** unique or primary key constraint on columns "id" */
  PkBustype = 'pk_bustype'
}

/** input type for incrementing numeric columns in table "vpic.bustype" */
export type BusType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.bustype" */
export type BusType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BusType_Max_Fields_Vpic = {
  __typename?: 'BusType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BusType_Min_Fields_Vpic = {
  __typename?: 'BusType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.bustype" */
export type BusType_Mutation_Response_Vpic = {
  __typename?: 'BusType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BusType_Vpic>;
};

/** on_conflict condition type for table "vpic.bustype" */
export type BusType_On_Conflict_Vpic = {
  constraint: BusType_Constraint_Vpic;
  update_columns?: Array<BusType_Update_Column_Vpic>;
  where?: InputMaybe<BusType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.bustype". */
export type BusType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.bustype */
export type BusType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.bustype" */
export enum BusType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.bustype" */
export type BusType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BusType_Stddev_Fields_Vpic = {
  __typename?: 'BusType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BusType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'BusType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BusType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'BusType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BusType" */
export type BusType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: BusType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type BusType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BusType_Sum_Fields_Vpic = {
  __typename?: 'BusType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.bustype" */
export enum BusType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type BusType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BusType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: BusType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type BusType_Var_Pop_Fields_Vpic = {
  __typename?: 'BusType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BusType_Var_Samp_Fields_Vpic = {
  __typename?: 'BusType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BusType_Variance_Fields_Vpic = {
  __typename?: 'BusType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.bustype" */
export type BusType_Vpic = {
  __typename?: 'BusType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.can_aacn" */
export type Can_Aacn_Aggregate_Fields_Vpic = {
  __typename?: 'CAN_AACN_aggregate_fields_vpic';
  avg?: Maybe<Can_Aacn_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Can_Aacn_Max_Fields_Vpic>;
  min?: Maybe<Can_Aacn_Min_Fields_Vpic>;
  stddev?: Maybe<Can_Aacn_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Can_Aacn_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Can_Aacn_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Can_Aacn_Sum_Fields_Vpic>;
  var_pop?: Maybe<Can_Aacn_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Can_Aacn_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Can_Aacn_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.can_aacn" */
export type Can_Aacn_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Can_Aacn_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.can_aacn" */
export type Can_Aacn_Aggregate_Vpic = {
  __typename?: 'CAN_AACN_aggregate_vpic';
  aggregate?: Maybe<Can_Aacn_Aggregate_Fields_Vpic>;
  nodes: Array<Can_Aacn_Vpic>;
};

/** aggregate avg on columns */
export type Can_Aacn_Avg_Fields_Vpic = {
  __typename?: 'CAN_AACN_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.can_aacn". All fields are combined with a logical 'AND'. */
export type Can_Aacn_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Can_Aacn_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Can_Aacn_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Can_Aacn_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.can_aacn" */
export enum Can_Aacn_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkCanAacn_3214ec079657df7c = 'pk__can_aacn__3214ec079657df7c'
}

/** input type for incrementing numeric columns in table "vpic.can_aacn" */
export type Can_Aacn_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.can_aacn" */
export type Can_Aacn_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Can_Aacn_Max_Fields_Vpic = {
  __typename?: 'CAN_AACN_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Can_Aacn_Min_Fields_Vpic = {
  __typename?: 'CAN_AACN_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.can_aacn" */
export type Can_Aacn_Mutation_Response_Vpic = {
  __typename?: 'CAN_AACN_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Can_Aacn_Vpic>;
};

/** on_conflict condition type for table "vpic.can_aacn" */
export type Can_Aacn_On_Conflict_Vpic = {
  constraint: Can_Aacn_Constraint_Vpic;
  update_columns?: Array<Can_Aacn_Update_Column_Vpic>;
  where?: InputMaybe<Can_Aacn_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.can_aacn". */
export type Can_Aacn_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.can_aacn */
export type Can_Aacn_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.can_aacn" */
export enum Can_Aacn_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.can_aacn" */
export type Can_Aacn_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Can_Aacn_Stddev_Fields_Vpic = {
  __typename?: 'CAN_AACN_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Can_Aacn_Stddev_Pop_Fields_Vpic = {
  __typename?: 'CAN_AACN_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Can_Aacn_Stddev_Samp_Fields_Vpic = {
  __typename?: 'CAN_AACN_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "CAN_AACN" */
export type Can_Aacn_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Can_Aacn_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Can_Aacn_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Can_Aacn_Sum_Fields_Vpic = {
  __typename?: 'CAN_AACN_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.can_aacn" */
export enum Can_Aacn_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type Can_Aacn_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Can_Aacn_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Can_Aacn_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Can_Aacn_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Can_Aacn_Var_Pop_Fields_Vpic = {
  __typename?: 'CAN_AACN_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Can_Aacn_Var_Samp_Fields_Vpic = {
  __typename?: 'CAN_AACN_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Can_Aacn_Variance_Fields_Vpic = {
  __typename?: 'CAN_AACN_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.can_aacn" */
export type Can_Aacn_Vpic = {
  __typename?: 'CAN_AACN_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type CancelQuoteMetadata = {
  __typename?: 'CancelQuoteMetadata';
  accountCode: Scalars['String'];
  accountId: Scalars['String'];
  cancelAsOfDate: Scalars['date'];
  cancelInitiatorTypeId: Scalars['String'];
  cancelReasonTypeId?: Maybe<Scalars['String']>;
  categoryCode: Scalars['String'];
  contractSuffix?: Maybe<Scalars['String']>;
  policyContractId: Scalars['String'];
  policyContractNumber: Scalars['String'];
  username?: Maybe<Scalars['String']>;
  vehicleMileage: Scalars['numeric'];
};

export type CancelQuoteResultMetadata = {
  __typename?: 'CancelQuoteResultMetadata';
  breakdown: CancelQuoteResultMetadata_Breakdown;
  cancelFee: Scalars['numeric'];
  cancelRefundAmountNotCoveredByAdministrator: Scalars['numeric'];
  cancelRule?: Maybe<CancelQuoteResultMetadata_CancelRule>;
  claimsPaidAmount: Scalars['numeric'];
  commissionAmount: Scalars['numeric'];
  customerPrice: Scalars['numeric'];
  dealerIsDirectMarketer?: Maybe<Scalars['Boolean']>;
  dealerNoChargebackLiableAmount: Scalars['numeric'];
  dealerOverRemitAmount: Scalars['numeric'];
  dealerProfit: Scalars['numeric'];
  dealerRefundAmount: Scalars['numeric'];
  dealerShareOfCancelFee: Scalars['numeric'];
  dealerShareOfClaims: Scalars['numeric'];
  isCancelRefundDeductOverremitFromAdministratorCheck?: Maybe<Scalars['Boolean']>;
  isDealerNoChargeback?: Maybe<Scalars['Boolean']>;
  isDealerObligor?: Maybe<Scalars['Boolean']>;
  isOutOfBusiness?: Maybe<Scalars['Boolean']>;
  isOverRemitNoChargeback?: Maybe<Scalars['Boolean']>;
  mbpiCost: Scalars['numeric'];
  mbpiRefundAmount: Scalars['numeric'];
  mbpiShareOfCancelFee: Scalars['numeric'];
  mbpiShareOfClaims: Scalars['numeric'];
  quoteIsAssociatedDealer?: Maybe<Scalars['Boolean']>;
  refundAmount: Scalars['numeric'];
  refundPercent: Scalars['numeric'];
};

export type CancelQuoteResultMetadata_Breakdown = {
  __typename?: 'CancelQuoteResultMetadata_Breakdown';
  cancelRefundAmountNotCoveredByAdministrator: Scalars['numeric'];
  dealerOverRemitAmount: Scalars['numeric'];
  dealerProfit: Scalars['numeric'];
  mbpiCost: Scalars['numeric'];
};

export type CancelQuoteResultMetadata_CancelRule = {
  __typename?: 'CancelQuoteResultMetadata_CancelRule';
  cancelClaimStatusTypeId?: Maybe<Scalars['String']>;
  cancelInitiatorTypeId: Scalars['String'];
  cancelInitiatorTypeName: Scalars['String'];
  cancelRuleFeeId: Scalars['String'];
  cancelRuleFees: Array<CancelQuoteResultMetadata_CancelRuleFee>;
  cancelRuleId: Scalars['String'];
  cancelRuleRefundId: Scalars['String'];
  cancelRuleRefunds: Array<CancelQuoteResultMetadata_CancelRuleRefund>;
  endAgeDays?: Maybe<Scalars['numeric']>;
  lenderId?: Maybe<Scalars['String']>;
  lenderName?: Maybe<Scalars['String']>;
  startAgeDays: Scalars['numeric'];
  stateAbbreviation: Scalars['String'];
  subtractClaims: Scalars['Boolean'];
};

export type CancelQuoteResultMetadata_CancelRuleFee = {
  __typename?: 'CancelQuoteResultMetadata_CancelRuleFee';
  cancelFeeId: Scalars['String'];
  cancelFeeTypeId: Scalars['String'];
  cancelFeeTypeName: Scalars['String'];
  feeAmount: Scalars['numeric'];
  number: Scalars['numeric'];
};

export type CancelQuoteResultMetadata_CancelRuleRefund = {
  __typename?: 'CancelQuoteResultMetadata_CancelRuleRefund';
  cancelMethodTypeId: Scalars['String'];
  cancelMethodTypeName: Scalars['String'];
  cancelRuleRefundId: Scalars['String'];
  refundAmount: Scalars['numeric'];
  refundPercent: Scalars['numeric'];
};

export type Cancel_Denial_Gap_Payout_V1 = {
  __typename?: 'Cancel_Denial_Gap_Payout_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  lenderAddress1: Scalars['String'];
  lenderAddress2: Scalars['String'];
  lenderCity: Scalars['String'];
  lenderName: Scalars['String'];
  lenderState: Scalars['String'];
  lenderZip: Scalars['String'];
  vin: Scalars['String'];
};

export type Cancellation_Metadata = {
  __typename?: 'Cancellation_Metadata';
  isFromConversion?: Maybe<Scalars['Boolean']>;
};

/** aggregate fields of "vpic.chargerlevel" */
export type ChargerLevel_Aggregate_Fields_Vpic = {
  __typename?: 'ChargerLevel_aggregate_fields_vpic';
  avg?: Maybe<ChargerLevel_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<ChargerLevel_Max_Fields_Vpic>;
  min?: Maybe<ChargerLevel_Min_Fields_Vpic>;
  stddev?: Maybe<ChargerLevel_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<ChargerLevel_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<ChargerLevel_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<ChargerLevel_Sum_Fields_Vpic>;
  var_pop?: Maybe<ChargerLevel_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<ChargerLevel_Var_Samp_Fields_Vpic>;
  variance?: Maybe<ChargerLevel_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.chargerlevel" */
export type ChargerLevel_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<ChargerLevel_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.chargerlevel" */
export type ChargerLevel_Aggregate_Vpic = {
  __typename?: 'ChargerLevel_aggregate_vpic';
  aggregate?: Maybe<ChargerLevel_Aggregate_Fields_Vpic>;
  nodes: Array<ChargerLevel_Vpic>;
};

/** aggregate avg on columns */
export type ChargerLevel_Avg_Fields_Vpic = {
  __typename?: 'ChargerLevel_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.chargerlevel". All fields are combined with a logical 'AND'. */
export type ChargerLevel_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ChargerLevel_Bool_Exp_Vpic>>;
  _not?: InputMaybe<ChargerLevel_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<ChargerLevel_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.chargerlevel" */
export enum ChargerLevel_Constraint_Vpic {
  /** unique or primary key constraint on columns "name" */
  IxChargerlevel = 'ix_chargerlevel',
  /** unique or primary key constraint on columns "id" */
  PkChargerlevel = 'pk_chargerlevel'
}

/** input type for incrementing numeric columns in table "vpic.chargerlevel" */
export type ChargerLevel_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.chargerlevel" */
export type ChargerLevel_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ChargerLevel_Max_Fields_Vpic = {
  __typename?: 'ChargerLevel_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ChargerLevel_Min_Fields_Vpic = {
  __typename?: 'ChargerLevel_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.chargerlevel" */
export type ChargerLevel_Mutation_Response_Vpic = {
  __typename?: 'ChargerLevel_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ChargerLevel_Vpic>;
};

/** on_conflict condition type for table "vpic.chargerlevel" */
export type ChargerLevel_On_Conflict_Vpic = {
  constraint: ChargerLevel_Constraint_Vpic;
  update_columns?: Array<ChargerLevel_Update_Column_Vpic>;
  where?: InputMaybe<ChargerLevel_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.chargerlevel". */
export type ChargerLevel_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.chargerlevel */
export type ChargerLevel_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.chargerlevel" */
export enum ChargerLevel_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.chargerlevel" */
export type ChargerLevel_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ChargerLevel_Stddev_Fields_Vpic = {
  __typename?: 'ChargerLevel_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ChargerLevel_Stddev_Pop_Fields_Vpic = {
  __typename?: 'ChargerLevel_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ChargerLevel_Stddev_Samp_Fields_Vpic = {
  __typename?: 'ChargerLevel_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ChargerLevel" */
export type ChargerLevel_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: ChargerLevel_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type ChargerLevel_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ChargerLevel_Sum_Fields_Vpic = {
  __typename?: 'ChargerLevel_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.chargerlevel" */
export enum ChargerLevel_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type ChargerLevel_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ChargerLevel_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChargerLevel_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: ChargerLevel_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type ChargerLevel_Var_Pop_Fields_Vpic = {
  __typename?: 'ChargerLevel_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ChargerLevel_Var_Samp_Fields_Vpic = {
  __typename?: 'ChargerLevel_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ChargerLevel_Variance_Fields_Vpic = {
  __typename?: 'ChargerLevel_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.chargerlevel" */
export type ChargerLevel_Vpic = {
  __typename?: 'ChargerLevel_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type ClaimDetail_JobType_Metadata = {
  __typename?: 'ClaimDetail_JobType_Metadata';
  as400ComponentCode?: Maybe<Scalars['String']>;
  as400ComponentSet?: Maybe<Scalars['String']>;
  isDeductible?: Maybe<Scalars['Boolean']>;
  isRetired: Scalars['Boolean'];
};

/** columns and relationships of "ClaimStatus" */
export type ClaimStatus = {
  __typename?: 'ClaimStatus';
  ClaimStatusCode: Scalars['String'];
  Name: Scalars['String'];
  /** An array relationship */
  claims: Array<ClaimsMaster>;
  /** An aggregate relationship */
  claims_aggregate: ClaimsMaster_Aggregate;
};


/** columns and relationships of "ClaimStatus" */
export type ClaimStatusClaimsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimsMaster_Order_By>>;
  where?: InputMaybe<ClaimsMaster_Bool_Exp>;
};


/** columns and relationships of "ClaimStatus" */
export type ClaimStatusClaims_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimsMaster_Order_By>>;
  where?: InputMaybe<ClaimsMaster_Bool_Exp>;
};

/** aggregated selection of "ClaimStatus" */
export type ClaimStatus_Aggregate = {
  __typename?: 'ClaimStatus_aggregate';
  aggregate?: Maybe<ClaimStatus_Aggregate_Fields>;
  nodes: Array<ClaimStatus>;
};

/** aggregate fields of "ClaimStatus" */
export type ClaimStatus_Aggregate_Fields = {
  __typename?: 'ClaimStatus_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ClaimStatus_Max_Fields>;
  min?: Maybe<ClaimStatus_Min_Fields>;
};


/** aggregate fields of "ClaimStatus" */
export type ClaimStatus_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<ClaimStatus_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ClaimStatus". All fields are combined with a logical 'AND'. */
export type ClaimStatus_Bool_Exp = {
  ClaimStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Name?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<ClaimStatus_Bool_Exp>>;
  _not?: InputMaybe<ClaimStatus_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimStatus_Bool_Exp>>;
  claims?: InputMaybe<ClaimsMaster_Bool_Exp>;
};

/** upsert condition type for table "ClaimStatus" */
export type ClaimStatus_If_Matched = {
  match_columns?: Array<ClaimStatus_Insert_Match_Column>;
  update_columns?: Array<ClaimStatus_Update_Column>;
  where?: InputMaybe<ClaimStatus_Bool_Exp>;
};

/** input type for inserting data into table "ClaimStatus" */
export type ClaimStatus_Insert_Input = {
  ClaimStatusCode?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** select match_columns of table "ClaimStatus" */
export enum ClaimStatus_Insert_Match_Column {
  /** column name */
  ClaimStatusCode = 'ClaimStatusCode',
  /** column name */
  Name = 'Name'
}

/** aggregate max on columns */
export type ClaimStatus_Max_Fields = {
  __typename?: 'ClaimStatus_max_fields';
  ClaimStatusCode?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ClaimStatus_Min_Fields = {
  __typename?: 'ClaimStatus_min_fields';
  ClaimStatusCode?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ClaimStatus" */
export type ClaimStatus_Mutation_Response = {
  __typename?: 'ClaimStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimStatus>;
};

/** Ordering options when selecting data from "ClaimStatus". */
export type ClaimStatus_Order_By = {
  ClaimStatusCode?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  claims_aggregate?: InputMaybe<ClaimsMaster_Aggregate_Order_By>;
};

/** primary key columns input for table: ClaimStatus */
export type ClaimStatus_Pk_Columns_Input = {
  ClaimStatusCode: Scalars['String'];
};

/** select columns of table "ClaimStatus" */
export enum ClaimStatus_Select_Column {
  /** column name */
  ClaimStatusCode = 'ClaimStatusCode',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "ClaimStatus" */
export type ClaimStatus_Set_Input = {
  ClaimStatusCode?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ClaimStatus" */
export enum ClaimStatus_Update_Column {
  /** column name */
  ClaimStatusCode = 'ClaimStatusCode',
  /** column name */
  Name = 'Name'
}

/** columns and relationships of "ClaimsMaster" */
export type ClaimsMaster = {
  __typename?: 'ClaimsMaster';
  AS400SyncUpdateDate?: Maybe<Scalars['datetime']>;
  AgreementNumber: Scalars['Float'];
  AgreementSuffix: Scalars['String'];
  AppraiserBillDate: Scalars['Float'];
  BatchKey?: Maybe<Scalars['uniqueidentifier']>;
  BeginMileage: Scalars['Float'];
  ChecksumColumn?: Maybe<Scalars['Int']>;
  ClaimAmount: Scalars['Float'];
  ClaimDetailChecksumColumn?: Maybe<Scalars['Int']>;
  ClaimMileage: Scalars['Float'];
  ClaimNumber: Scalars['Float'];
  ClaimStatusCode: Scalars['String'];
  CompanyCode: Scalars['String'];
  CompositeKey?: Maybe<Scalars['String']>;
  ConversionDate: Scalars['Float'];
  ConversionRecordFlag: Scalars['String'];
  CoverageTypeCode: Scalars['String'];
  DealerCode: Scalars['String'];
  DeductibleAmount: Scalars['Float'];
  EnteredBy: Scalars['String'];
  EnteredDate: Scalars['Float'];
  EnteredTime: Scalars['Float'];
  FailedDate: Scalars['Float'];
  FlatRateManual: Scalars['String'];
  ID: Scalars['uniqueidentifier'];
  LaborRate: Scalars['Float'];
  LaborTax: Scalars['Float'];
  MajorProblem1Desc: Scalars['String'];
  MajorProblem2Desc: Scalars['String'];
  MaxShopSupplies: Scalars['Float'];
  Misc1BillDate: Scalars['Float'];
  Misc1Description: Scalars['String'];
  Misc2BillDate: Scalars['Float'];
  Misc2Description: Scalars['String'];
  Misc3BillDate: Scalars['Float'];
  Misc3Description: Scalars['String'];
  NewOrUsedCode: Scalars['String'];
  NoteMetadata?: Maybe<Scalars['String']>;
  OwnersFirstName: Scalars['String'];
  OwnersLastName: Scalars['String'];
  OwnersSSN: Scalars['String'];
  PaidAmount: Scalars['Float'];
  PaidDate?: Maybe<Scalars['Float']>;
  PlanCode: Scalars['String'];
  PostgresSyncUpdateDate?: Maybe<Scalars['datetime']>;
  QuickClaimFlag: Scalars['String'];
  ROReceivedDate1: Scalars['Float'];
  ROReceivedDate2: Scalars['Float'];
  ROReceivedDate3: Scalars['Float'];
  ROReceivedDate4: Scalars['Float'];
  ReimburseForRentalFlag: Scalars['String'];
  ReimburseForRepairFlag: Scalars['String'];
  ReimburseForTowFlag: Scalars['String'];
  RentalBillDate: Scalars['Float'];
  RepairFacility: Scalars['String'];
  RepairFacilityContact: Scalars['String'];
  RepairFacilityEmail?: Maybe<Scalars['String']>;
  RepairFacilityName: Scalars['String'];
  RepairFacilityPhone: Scalars['String'];
  RepairOrder1: Scalars['String'];
  RepairOrder2: Scalars['String'];
  RepairOrder3: Scalars['String'];
  RepairOrder4: Scalars['String'];
  RepairOrderDate1: Scalars['Float'];
  RepairOrderDate3: Scalars['Float'];
  RepairOrderDate4: Scalars['Float'];
  RepariOrderDate2: Scalars['Float'];
  ReportedDate: Scalars['Float'];
  ReportedTime: Scalars['Float'];
  SequenceNumber: Scalars['Float'];
  ShopEntryDate: Scalars['Float'];
  ShopSuppliesTax: Scalars['Float'];
  TowBillDate: Scalars['Float'];
  UpdatedBy: Scalars['String'];
  UpdatedDate: Scalars['Float'];
  UpdatedTime: Scalars['Float'];
  VehicleInServiceDate: Scalars['Float'];
  VehicleManufacturer: Scalars['String'];
  VehicleManufacturerCode: Scalars['String'];
  VehicleYear: Scalars['Float'];
  VinNumber: Scalars['String'];
  VinNumberLast6: Scalars['String'];
  /** An object relationship */
  contract?: Maybe<ContractMaster>;
  /** An object relationship */
  dealer?: Maybe<Dealer>;
  /** An object relationship */
  status?: Maybe<ClaimStatus>;
};

/** aggregated selection of "ClaimsMaster" */
export type ClaimsMaster_Aggregate = {
  __typename?: 'ClaimsMaster_aggregate';
  aggregate?: Maybe<ClaimsMaster_Aggregate_Fields>;
  nodes: Array<ClaimsMaster>;
};

/** aggregate fields of "ClaimsMaster" */
export type ClaimsMaster_Aggregate_Fields = {
  __typename?: 'ClaimsMaster_aggregate_fields';
  avg?: Maybe<ClaimsMaster_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClaimsMaster_Max_Fields>;
  min?: Maybe<ClaimsMaster_Min_Fields>;
  stddev?: Maybe<ClaimsMaster_Stddev_Fields>;
  stddev_pop?: Maybe<ClaimsMaster_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClaimsMaster_Stddev_Samp_Fields>;
  sum?: Maybe<ClaimsMaster_Sum_Fields>;
  var_pop?: Maybe<ClaimsMaster_Var_Pop_Fields>;
  var_samp?: Maybe<ClaimsMaster_Var_Samp_Fields>;
  variance?: Maybe<ClaimsMaster_Variance_Fields>;
};


/** aggregate fields of "ClaimsMaster" */
export type ClaimsMaster_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<ClaimsMaster_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ClaimsMaster" */
export type ClaimsMaster_Aggregate_Order_By = {
  avg?: InputMaybe<ClaimsMaster_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClaimsMaster_Max_Order_By>;
  min?: InputMaybe<ClaimsMaster_Min_Order_By>;
  stddev?: InputMaybe<ClaimsMaster_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ClaimsMaster_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ClaimsMaster_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ClaimsMaster_Sum_Order_By>;
  var_pop?: InputMaybe<ClaimsMaster_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ClaimsMaster_Var_Samp_Order_By>;
  variance?: InputMaybe<ClaimsMaster_Variance_Order_By>;
};

/** aggregate avg on columns */
export type ClaimsMaster_Avg_Fields = {
  __typename?: 'ClaimsMaster_avg_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  AppraiserBillDate?: Maybe<Scalars['Float']>;
  BeginMileage?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimAmount?: Maybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimMileage?: Maybe<Scalars['Float']>;
  ClaimNumber?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  DeductibleAmount?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EnteredTime?: Maybe<Scalars['Float']>;
  FailedDate?: Maybe<Scalars['Float']>;
  LaborRate?: Maybe<Scalars['Float']>;
  LaborTax?: Maybe<Scalars['Float']>;
  MaxShopSupplies?: Maybe<Scalars['Float']>;
  Misc1BillDate?: Maybe<Scalars['Float']>;
  Misc2BillDate?: Maybe<Scalars['Float']>;
  Misc3BillDate?: Maybe<Scalars['Float']>;
  PaidAmount?: Maybe<Scalars['Float']>;
  PaidDate?: Maybe<Scalars['Float']>;
  ROReceivedDate1?: Maybe<Scalars['Float']>;
  ROReceivedDate2?: Maybe<Scalars['Float']>;
  ROReceivedDate3?: Maybe<Scalars['Float']>;
  ROReceivedDate4?: Maybe<Scalars['Float']>;
  RentalBillDate?: Maybe<Scalars['Float']>;
  RepairOrderDate1?: Maybe<Scalars['Float']>;
  RepairOrderDate3?: Maybe<Scalars['Float']>;
  RepairOrderDate4?: Maybe<Scalars['Float']>;
  RepariOrderDate2?: Maybe<Scalars['Float']>;
  ReportedDate?: Maybe<Scalars['Float']>;
  ReportedTime?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  ShopEntryDate?: Maybe<Scalars['Float']>;
  ShopSuppliesTax?: Maybe<Scalars['Float']>;
  TowBillDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpdatedTime?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ClaimsMaster" */
export type ClaimsMaster_Avg_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ClaimsMaster". All fields are combined with a logical 'AND'. */
export type ClaimsMaster_Bool_Exp = {
  AS400SyncUpdateDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  AgreementNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AgreementSuffix?: InputMaybe<String_Mssql_Comparison_Exp>;
  AppraiserBillDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  BatchKey?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  BeginMileage?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ChecksumColumn?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ClaimAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClaimDetailChecksumColumn?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ClaimMileage?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClaimNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClaimStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  CompanyCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  CompositeKey?: InputMaybe<String_Mssql_Comparison_Exp>;
  ConversionDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ConversionRecordFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  CoverageTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  DealerCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  DeductibleAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  EnteredBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  EnteredDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  EnteredTime?: InputMaybe<Float_Mssql_Comparison_Exp>;
  FailedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  FlatRateManual?: InputMaybe<String_Mssql_Comparison_Exp>;
  ID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  LaborRate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  LaborTax?: InputMaybe<Float_Mssql_Comparison_Exp>;
  MajorProblem1Desc?: InputMaybe<String_Mssql_Comparison_Exp>;
  MajorProblem2Desc?: InputMaybe<String_Mssql_Comparison_Exp>;
  MaxShopSupplies?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Misc1BillDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Misc1Description?: InputMaybe<String_Mssql_Comparison_Exp>;
  Misc2BillDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Misc2Description?: InputMaybe<String_Mssql_Comparison_Exp>;
  Misc3BillDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Misc3Description?: InputMaybe<String_Mssql_Comparison_Exp>;
  NewOrUsedCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  NoteMetadata?: InputMaybe<String_Mssql_Comparison_Exp>;
  OwnersFirstName?: InputMaybe<String_Mssql_Comparison_Exp>;
  OwnersLastName?: InputMaybe<String_Mssql_Comparison_Exp>;
  OwnersSSN?: InputMaybe<String_Mssql_Comparison_Exp>;
  PaidAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  PaidDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  PlanCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  PostgresSyncUpdateDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  QuickClaimFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  ROReceivedDate1?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ROReceivedDate2?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ROReceivedDate3?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ROReceivedDate4?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReimburseForRentalFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  ReimburseForRepairFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  ReimburseForTowFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  RentalBillDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RepairFacility?: InputMaybe<String_Mssql_Comparison_Exp>;
  RepairFacilityContact?: InputMaybe<String_Mssql_Comparison_Exp>;
  RepairFacilityEmail?: InputMaybe<String_Mssql_Comparison_Exp>;
  RepairFacilityName?: InputMaybe<String_Mssql_Comparison_Exp>;
  RepairFacilityPhone?: InputMaybe<String_Mssql_Comparison_Exp>;
  RepairOrder1?: InputMaybe<String_Mssql_Comparison_Exp>;
  RepairOrder2?: InputMaybe<String_Mssql_Comparison_Exp>;
  RepairOrder3?: InputMaybe<String_Mssql_Comparison_Exp>;
  RepairOrder4?: InputMaybe<String_Mssql_Comparison_Exp>;
  RepairOrderDate1?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RepairOrderDate3?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RepairOrderDate4?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RepariOrderDate2?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReportedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReportedTime?: InputMaybe<Float_Mssql_Comparison_Exp>;
  SequenceNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ShopEntryDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ShopSuppliesTax?: InputMaybe<Float_Mssql_Comparison_Exp>;
  TowBillDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  UpdatedBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  UpdatedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  UpdatedTime?: InputMaybe<Float_Mssql_Comparison_Exp>;
  VehicleInServiceDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  VehicleManufacturer?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleManufacturerCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleYear?: InputMaybe<Float_Mssql_Comparison_Exp>;
  VinNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  VinNumberLast6?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<ClaimsMaster_Bool_Exp>>;
  _not?: InputMaybe<ClaimsMaster_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimsMaster_Bool_Exp>>;
  contract?: InputMaybe<ContractMaster_Bool_Exp>;
  dealer?: InputMaybe<Dealer_Bool_Exp>;
  status?: InputMaybe<ClaimStatus_Bool_Exp>;
};

/** upsert condition type for table "ClaimsMaster" */
export type ClaimsMaster_If_Matched = {
  match_columns?: Array<ClaimsMaster_Insert_Match_Column>;
  update_columns?: Array<ClaimsMaster_Update_Column>;
  where?: InputMaybe<ClaimsMaster_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "ClaimsMaster" */
export type ClaimsMaster_Inc_Input = {
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  AppraiserBillDate?: InputMaybe<Scalars['Float']>;
  BeginMileage?: InputMaybe<Scalars['Float']>;
  ChecksumColumn?: InputMaybe<Scalars['Int']>;
  ClaimAmount?: InputMaybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: InputMaybe<Scalars['Int']>;
  ClaimMileage?: InputMaybe<Scalars['Float']>;
  ClaimNumber?: InputMaybe<Scalars['Float']>;
  ConversionDate?: InputMaybe<Scalars['Float']>;
  DeductibleAmount?: InputMaybe<Scalars['Float']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  EnteredTime?: InputMaybe<Scalars['Float']>;
  FailedDate?: InputMaybe<Scalars['Float']>;
  LaborRate?: InputMaybe<Scalars['Float']>;
  LaborTax?: InputMaybe<Scalars['Float']>;
  MaxShopSupplies?: InputMaybe<Scalars['Float']>;
  Misc1BillDate?: InputMaybe<Scalars['Float']>;
  Misc2BillDate?: InputMaybe<Scalars['Float']>;
  Misc3BillDate?: InputMaybe<Scalars['Float']>;
  PaidAmount?: InputMaybe<Scalars['Float']>;
  PaidDate?: InputMaybe<Scalars['Float']>;
  ROReceivedDate1?: InputMaybe<Scalars['Float']>;
  ROReceivedDate2?: InputMaybe<Scalars['Float']>;
  ROReceivedDate3?: InputMaybe<Scalars['Float']>;
  ROReceivedDate4?: InputMaybe<Scalars['Float']>;
  RentalBillDate?: InputMaybe<Scalars['Float']>;
  RepairOrderDate1?: InputMaybe<Scalars['Float']>;
  RepairOrderDate3?: InputMaybe<Scalars['Float']>;
  RepairOrderDate4?: InputMaybe<Scalars['Float']>;
  RepariOrderDate2?: InputMaybe<Scalars['Float']>;
  ReportedDate?: InputMaybe<Scalars['Float']>;
  ReportedTime?: InputMaybe<Scalars['Float']>;
  SequenceNumber?: InputMaybe<Scalars['Float']>;
  ShopEntryDate?: InputMaybe<Scalars['Float']>;
  ShopSuppliesTax?: InputMaybe<Scalars['Float']>;
  TowBillDate?: InputMaybe<Scalars['Float']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
  UpdatedTime?: InputMaybe<Scalars['Float']>;
  VehicleInServiceDate?: InputMaybe<Scalars['Float']>;
  VehicleYear?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "ClaimsMaster" */
export type ClaimsMaster_Insert_Input = {
  AS400SyncUpdateDate?: InputMaybe<Scalars['datetime']>;
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  AgreementSuffix?: InputMaybe<Scalars['String']>;
  AppraiserBillDate?: InputMaybe<Scalars['Float']>;
  BatchKey?: InputMaybe<Scalars['uniqueidentifier']>;
  BeginMileage?: InputMaybe<Scalars['Float']>;
  ChecksumColumn?: InputMaybe<Scalars['Int']>;
  ClaimAmount?: InputMaybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: InputMaybe<Scalars['Int']>;
  ClaimMileage?: InputMaybe<Scalars['Float']>;
  ClaimNumber?: InputMaybe<Scalars['Float']>;
  ClaimStatusCode?: InputMaybe<Scalars['String']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  ConversionDate?: InputMaybe<Scalars['Float']>;
  ConversionRecordFlag?: InputMaybe<Scalars['String']>;
  CoverageTypeCode?: InputMaybe<Scalars['String']>;
  DealerCode?: InputMaybe<Scalars['String']>;
  DeductibleAmount?: InputMaybe<Scalars['Float']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  EnteredTime?: InputMaybe<Scalars['Float']>;
  FailedDate?: InputMaybe<Scalars['Float']>;
  FlatRateManual?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['uniqueidentifier']>;
  LaborRate?: InputMaybe<Scalars['Float']>;
  LaborTax?: InputMaybe<Scalars['Float']>;
  MajorProblem1Desc?: InputMaybe<Scalars['String']>;
  MajorProblem2Desc?: InputMaybe<Scalars['String']>;
  MaxShopSupplies?: InputMaybe<Scalars['Float']>;
  Misc1BillDate?: InputMaybe<Scalars['Float']>;
  Misc1Description?: InputMaybe<Scalars['String']>;
  Misc2BillDate?: InputMaybe<Scalars['Float']>;
  Misc2Description?: InputMaybe<Scalars['String']>;
  Misc3BillDate?: InputMaybe<Scalars['Float']>;
  Misc3Description?: InputMaybe<Scalars['String']>;
  NewOrUsedCode?: InputMaybe<Scalars['String']>;
  NoteMetadata?: InputMaybe<Scalars['String']>;
  OwnersFirstName?: InputMaybe<Scalars['String']>;
  OwnersLastName?: InputMaybe<Scalars['String']>;
  OwnersSSN?: InputMaybe<Scalars['String']>;
  PaidAmount?: InputMaybe<Scalars['Float']>;
  PaidDate?: InputMaybe<Scalars['Float']>;
  PlanCode?: InputMaybe<Scalars['String']>;
  PostgresSyncUpdateDate?: InputMaybe<Scalars['datetime']>;
  QuickClaimFlag?: InputMaybe<Scalars['String']>;
  ROReceivedDate1?: InputMaybe<Scalars['Float']>;
  ROReceivedDate2?: InputMaybe<Scalars['Float']>;
  ROReceivedDate3?: InputMaybe<Scalars['Float']>;
  ROReceivedDate4?: InputMaybe<Scalars['Float']>;
  ReimburseForRentalFlag?: InputMaybe<Scalars['String']>;
  ReimburseForRepairFlag?: InputMaybe<Scalars['String']>;
  ReimburseForTowFlag?: InputMaybe<Scalars['String']>;
  RentalBillDate?: InputMaybe<Scalars['Float']>;
  RepairFacility?: InputMaybe<Scalars['String']>;
  RepairFacilityContact?: InputMaybe<Scalars['String']>;
  RepairFacilityEmail?: InputMaybe<Scalars['String']>;
  RepairFacilityName?: InputMaybe<Scalars['String']>;
  RepairFacilityPhone?: InputMaybe<Scalars['String']>;
  RepairOrder1?: InputMaybe<Scalars['String']>;
  RepairOrder2?: InputMaybe<Scalars['String']>;
  RepairOrder3?: InputMaybe<Scalars['String']>;
  RepairOrder4?: InputMaybe<Scalars['String']>;
  RepairOrderDate1?: InputMaybe<Scalars['Float']>;
  RepairOrderDate3?: InputMaybe<Scalars['Float']>;
  RepairOrderDate4?: InputMaybe<Scalars['Float']>;
  RepariOrderDate2?: InputMaybe<Scalars['Float']>;
  ReportedDate?: InputMaybe<Scalars['Float']>;
  ReportedTime?: InputMaybe<Scalars['Float']>;
  SequenceNumber?: InputMaybe<Scalars['Float']>;
  ShopEntryDate?: InputMaybe<Scalars['Float']>;
  ShopSuppliesTax?: InputMaybe<Scalars['Float']>;
  TowBillDate?: InputMaybe<Scalars['Float']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
  UpdatedTime?: InputMaybe<Scalars['Float']>;
  VehicleInServiceDate?: InputMaybe<Scalars['Float']>;
  VehicleManufacturer?: InputMaybe<Scalars['String']>;
  VehicleManufacturerCode?: InputMaybe<Scalars['String']>;
  VehicleYear?: InputMaybe<Scalars['Float']>;
  VinNumber?: InputMaybe<Scalars['String']>;
  VinNumberLast6?: InputMaybe<Scalars['String']>;
};

/** select match_columns of table "ClaimsMaster" */
export enum ClaimsMaster_Insert_Match_Column {
  /** column name */
  As400SyncUpdateDate = 'AS400SyncUpdateDate',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  AppraiserBillDate = 'AppraiserBillDate',
  /** column name */
  BatchKey = 'BatchKey',
  /** column name */
  BeginMileage = 'BeginMileage',
  /** column name */
  ChecksumColumn = 'ChecksumColumn',
  /** column name */
  ClaimAmount = 'ClaimAmount',
  /** column name */
  ClaimDetailChecksumColumn = 'ClaimDetailChecksumColumn',
  /** column name */
  ClaimMileage = 'ClaimMileage',
  /** column name */
  ClaimNumber = 'ClaimNumber',
  /** column name */
  ClaimStatusCode = 'ClaimStatusCode',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  CompositeKey = 'CompositeKey',
  /** column name */
  ConversionDate = 'ConversionDate',
  /** column name */
  ConversionRecordFlag = 'ConversionRecordFlag',
  /** column name */
  CoverageTypeCode = 'CoverageTypeCode',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  DeductibleAmount = 'DeductibleAmount',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  EnteredTime = 'EnteredTime',
  /** column name */
  FailedDate = 'FailedDate',
  /** column name */
  FlatRateManual = 'FlatRateManual',
  /** column name */
  Id = 'ID',
  /** column name */
  LaborRate = 'LaborRate',
  /** column name */
  LaborTax = 'LaborTax',
  /** column name */
  MajorProblem1Desc = 'MajorProblem1Desc',
  /** column name */
  MajorProblem2Desc = 'MajorProblem2Desc',
  /** column name */
  MaxShopSupplies = 'MaxShopSupplies',
  /** column name */
  Misc1BillDate = 'Misc1BillDate',
  /** column name */
  Misc1Description = 'Misc1Description',
  /** column name */
  Misc2BillDate = 'Misc2BillDate',
  /** column name */
  Misc2Description = 'Misc2Description',
  /** column name */
  Misc3BillDate = 'Misc3BillDate',
  /** column name */
  Misc3Description = 'Misc3Description',
  /** column name */
  NewOrUsedCode = 'NewOrUsedCode',
  /** column name */
  NoteMetadata = 'NoteMetadata',
  /** column name */
  OwnersFirstName = 'OwnersFirstName',
  /** column name */
  OwnersLastName = 'OwnersLastName',
  /** column name */
  OwnersSsn = 'OwnersSSN',
  /** column name */
  PaidAmount = 'PaidAmount',
  /** column name */
  PaidDate = 'PaidDate',
  /** column name */
  PlanCode = 'PlanCode',
  /** column name */
  PostgresSyncUpdateDate = 'PostgresSyncUpdateDate',
  /** column name */
  QuickClaimFlag = 'QuickClaimFlag',
  /** column name */
  RoReceivedDate1 = 'ROReceivedDate1',
  /** column name */
  RoReceivedDate2 = 'ROReceivedDate2',
  /** column name */
  RoReceivedDate3 = 'ROReceivedDate3',
  /** column name */
  RoReceivedDate4 = 'ROReceivedDate4',
  /** column name */
  ReimburseForRentalFlag = 'ReimburseForRentalFlag',
  /** column name */
  ReimburseForRepairFlag = 'ReimburseForRepairFlag',
  /** column name */
  ReimburseForTowFlag = 'ReimburseForTowFlag',
  /** column name */
  RentalBillDate = 'RentalBillDate',
  /** column name */
  RepairFacility = 'RepairFacility',
  /** column name */
  RepairFacilityContact = 'RepairFacilityContact',
  /** column name */
  RepairFacilityEmail = 'RepairFacilityEmail',
  /** column name */
  RepairFacilityName = 'RepairFacilityName',
  /** column name */
  RepairFacilityPhone = 'RepairFacilityPhone',
  /** column name */
  RepairOrder1 = 'RepairOrder1',
  /** column name */
  RepairOrder2 = 'RepairOrder2',
  /** column name */
  RepairOrder3 = 'RepairOrder3',
  /** column name */
  RepairOrder4 = 'RepairOrder4',
  /** column name */
  RepairOrderDate1 = 'RepairOrderDate1',
  /** column name */
  RepairOrderDate3 = 'RepairOrderDate3',
  /** column name */
  RepairOrderDate4 = 'RepairOrderDate4',
  /** column name */
  RepariOrderDate2 = 'RepariOrderDate2',
  /** column name */
  ReportedDate = 'ReportedDate',
  /** column name */
  ReportedTime = 'ReportedTime',
  /** column name */
  SequenceNumber = 'SequenceNumber',
  /** column name */
  ShopEntryDate = 'ShopEntryDate',
  /** column name */
  ShopSuppliesTax = 'ShopSuppliesTax',
  /** column name */
  TowBillDate = 'TowBillDate',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  UpdatedTime = 'UpdatedTime',
  /** column name */
  VehicleInServiceDate = 'VehicleInServiceDate',
  /** column name */
  VehicleManufacturer = 'VehicleManufacturer',
  /** column name */
  VehicleManufacturerCode = 'VehicleManufacturerCode',
  /** column name */
  VehicleYear = 'VehicleYear',
  /** column name */
  VinNumber = 'VinNumber',
  /** column name */
  VinNumberLast6 = 'VinNumberLast6'
}

/** aggregate max on columns */
export type ClaimsMaster_Max_Fields = {
  __typename?: 'ClaimsMaster_max_fields';
  AS400SyncUpdateDate?: Maybe<Scalars['datetime']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AgreementSuffix?: Maybe<Scalars['String']>;
  AppraiserBillDate?: Maybe<Scalars['Float']>;
  BeginMileage?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Int']>;
  ClaimAmount?: Maybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: Maybe<Scalars['Int']>;
  ClaimMileage?: Maybe<Scalars['Float']>;
  ClaimNumber?: Maybe<Scalars['Float']>;
  ClaimStatusCode?: Maybe<Scalars['String']>;
  CompanyCode?: Maybe<Scalars['String']>;
  CompositeKey?: Maybe<Scalars['String']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  ConversionRecordFlag?: Maybe<Scalars['String']>;
  CoverageTypeCode?: Maybe<Scalars['String']>;
  DealerCode?: Maybe<Scalars['String']>;
  DeductibleAmount?: Maybe<Scalars['Float']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EnteredTime?: Maybe<Scalars['Float']>;
  FailedDate?: Maybe<Scalars['Float']>;
  FlatRateManual?: Maybe<Scalars['String']>;
  LaborRate?: Maybe<Scalars['Float']>;
  LaborTax?: Maybe<Scalars['Float']>;
  MajorProblem1Desc?: Maybe<Scalars['String']>;
  MajorProblem2Desc?: Maybe<Scalars['String']>;
  MaxShopSupplies?: Maybe<Scalars['Float']>;
  Misc1BillDate?: Maybe<Scalars['Float']>;
  Misc1Description?: Maybe<Scalars['String']>;
  Misc2BillDate?: Maybe<Scalars['Float']>;
  Misc2Description?: Maybe<Scalars['String']>;
  Misc3BillDate?: Maybe<Scalars['Float']>;
  Misc3Description?: Maybe<Scalars['String']>;
  NewOrUsedCode?: Maybe<Scalars['String']>;
  NoteMetadata?: Maybe<Scalars['String']>;
  OwnersFirstName?: Maybe<Scalars['String']>;
  OwnersLastName?: Maybe<Scalars['String']>;
  OwnersSSN?: Maybe<Scalars['String']>;
  PaidAmount?: Maybe<Scalars['Float']>;
  PaidDate?: Maybe<Scalars['Float']>;
  PlanCode?: Maybe<Scalars['String']>;
  PostgresSyncUpdateDate?: Maybe<Scalars['datetime']>;
  QuickClaimFlag?: Maybe<Scalars['String']>;
  ROReceivedDate1?: Maybe<Scalars['Float']>;
  ROReceivedDate2?: Maybe<Scalars['Float']>;
  ROReceivedDate3?: Maybe<Scalars['Float']>;
  ROReceivedDate4?: Maybe<Scalars['Float']>;
  ReimburseForRentalFlag?: Maybe<Scalars['String']>;
  ReimburseForRepairFlag?: Maybe<Scalars['String']>;
  ReimburseForTowFlag?: Maybe<Scalars['String']>;
  RentalBillDate?: Maybe<Scalars['Float']>;
  RepairFacility?: Maybe<Scalars['String']>;
  RepairFacilityContact?: Maybe<Scalars['String']>;
  RepairFacilityEmail?: Maybe<Scalars['String']>;
  RepairFacilityName?: Maybe<Scalars['String']>;
  RepairFacilityPhone?: Maybe<Scalars['String']>;
  RepairOrder1?: Maybe<Scalars['String']>;
  RepairOrder2?: Maybe<Scalars['String']>;
  RepairOrder3?: Maybe<Scalars['String']>;
  RepairOrder4?: Maybe<Scalars['String']>;
  RepairOrderDate1?: Maybe<Scalars['Float']>;
  RepairOrderDate3?: Maybe<Scalars['Float']>;
  RepairOrderDate4?: Maybe<Scalars['Float']>;
  RepariOrderDate2?: Maybe<Scalars['Float']>;
  ReportedDate?: Maybe<Scalars['Float']>;
  ReportedTime?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  ShopEntryDate?: Maybe<Scalars['Float']>;
  ShopSuppliesTax?: Maybe<Scalars['Float']>;
  TowBillDate?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpdatedTime?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleManufacturer?: Maybe<Scalars['String']>;
  VehicleManufacturerCode?: Maybe<Scalars['String']>;
  VehicleYear?: Maybe<Scalars['Float']>;
  VinNumber?: Maybe<Scalars['String']>;
  VinNumberLast6?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ClaimsMaster" */
export type ClaimsMaster_Max_Order_By = {
  AS400SyncUpdateDate?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ClaimStatusCode?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  CompositeKey?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  ConversionRecordFlag?: InputMaybe<Order_By>;
  CoverageTypeCode?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  FlatRateManual?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MajorProblem1Desc?: InputMaybe<Order_By>;
  MajorProblem2Desc?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc1Description?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc2Description?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  Misc3Description?: InputMaybe<Order_By>;
  NewOrUsedCode?: InputMaybe<Order_By>;
  NoteMetadata?: InputMaybe<Order_By>;
  OwnersFirstName?: InputMaybe<Order_By>;
  OwnersLastName?: InputMaybe<Order_By>;
  OwnersSSN?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  PlanCode?: InputMaybe<Order_By>;
  PostgresSyncUpdateDate?: InputMaybe<Order_By>;
  QuickClaimFlag?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  ReimburseForRentalFlag?: InputMaybe<Order_By>;
  ReimburseForRepairFlag?: InputMaybe<Order_By>;
  ReimburseForTowFlag?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairFacility?: InputMaybe<Order_By>;
  RepairFacilityContact?: InputMaybe<Order_By>;
  RepairFacilityEmail?: InputMaybe<Order_By>;
  RepairFacilityName?: InputMaybe<Order_By>;
  RepairFacilityPhone?: InputMaybe<Order_By>;
  RepairOrder1?: InputMaybe<Order_By>;
  RepairOrder2?: InputMaybe<Order_By>;
  RepairOrder3?: InputMaybe<Order_By>;
  RepairOrder4?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleManufacturer?: InputMaybe<Order_By>;
  VehicleManufacturerCode?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
  VinNumber?: InputMaybe<Order_By>;
  VinNumberLast6?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClaimsMaster_Min_Fields = {
  __typename?: 'ClaimsMaster_min_fields';
  AS400SyncUpdateDate?: Maybe<Scalars['datetime']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AgreementSuffix?: Maybe<Scalars['String']>;
  AppraiserBillDate?: Maybe<Scalars['Float']>;
  BeginMileage?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Int']>;
  ClaimAmount?: Maybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: Maybe<Scalars['Int']>;
  ClaimMileage?: Maybe<Scalars['Float']>;
  ClaimNumber?: Maybe<Scalars['Float']>;
  ClaimStatusCode?: Maybe<Scalars['String']>;
  CompanyCode?: Maybe<Scalars['String']>;
  CompositeKey?: Maybe<Scalars['String']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  ConversionRecordFlag?: Maybe<Scalars['String']>;
  CoverageTypeCode?: Maybe<Scalars['String']>;
  DealerCode?: Maybe<Scalars['String']>;
  DeductibleAmount?: Maybe<Scalars['Float']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EnteredTime?: Maybe<Scalars['Float']>;
  FailedDate?: Maybe<Scalars['Float']>;
  FlatRateManual?: Maybe<Scalars['String']>;
  LaborRate?: Maybe<Scalars['Float']>;
  LaborTax?: Maybe<Scalars['Float']>;
  MajorProblem1Desc?: Maybe<Scalars['String']>;
  MajorProblem2Desc?: Maybe<Scalars['String']>;
  MaxShopSupplies?: Maybe<Scalars['Float']>;
  Misc1BillDate?: Maybe<Scalars['Float']>;
  Misc1Description?: Maybe<Scalars['String']>;
  Misc2BillDate?: Maybe<Scalars['Float']>;
  Misc2Description?: Maybe<Scalars['String']>;
  Misc3BillDate?: Maybe<Scalars['Float']>;
  Misc3Description?: Maybe<Scalars['String']>;
  NewOrUsedCode?: Maybe<Scalars['String']>;
  NoteMetadata?: Maybe<Scalars['String']>;
  OwnersFirstName?: Maybe<Scalars['String']>;
  OwnersLastName?: Maybe<Scalars['String']>;
  OwnersSSN?: Maybe<Scalars['String']>;
  PaidAmount?: Maybe<Scalars['Float']>;
  PaidDate?: Maybe<Scalars['Float']>;
  PlanCode?: Maybe<Scalars['String']>;
  PostgresSyncUpdateDate?: Maybe<Scalars['datetime']>;
  QuickClaimFlag?: Maybe<Scalars['String']>;
  ROReceivedDate1?: Maybe<Scalars['Float']>;
  ROReceivedDate2?: Maybe<Scalars['Float']>;
  ROReceivedDate3?: Maybe<Scalars['Float']>;
  ROReceivedDate4?: Maybe<Scalars['Float']>;
  ReimburseForRentalFlag?: Maybe<Scalars['String']>;
  ReimburseForRepairFlag?: Maybe<Scalars['String']>;
  ReimburseForTowFlag?: Maybe<Scalars['String']>;
  RentalBillDate?: Maybe<Scalars['Float']>;
  RepairFacility?: Maybe<Scalars['String']>;
  RepairFacilityContact?: Maybe<Scalars['String']>;
  RepairFacilityEmail?: Maybe<Scalars['String']>;
  RepairFacilityName?: Maybe<Scalars['String']>;
  RepairFacilityPhone?: Maybe<Scalars['String']>;
  RepairOrder1?: Maybe<Scalars['String']>;
  RepairOrder2?: Maybe<Scalars['String']>;
  RepairOrder3?: Maybe<Scalars['String']>;
  RepairOrder4?: Maybe<Scalars['String']>;
  RepairOrderDate1?: Maybe<Scalars['Float']>;
  RepairOrderDate3?: Maybe<Scalars['Float']>;
  RepairOrderDate4?: Maybe<Scalars['Float']>;
  RepariOrderDate2?: Maybe<Scalars['Float']>;
  ReportedDate?: Maybe<Scalars['Float']>;
  ReportedTime?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  ShopEntryDate?: Maybe<Scalars['Float']>;
  ShopSuppliesTax?: Maybe<Scalars['Float']>;
  TowBillDate?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpdatedTime?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleManufacturer?: Maybe<Scalars['String']>;
  VehicleManufacturerCode?: Maybe<Scalars['String']>;
  VehicleYear?: Maybe<Scalars['Float']>;
  VinNumber?: Maybe<Scalars['String']>;
  VinNumberLast6?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ClaimsMaster" */
export type ClaimsMaster_Min_Order_By = {
  AS400SyncUpdateDate?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ClaimStatusCode?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  CompositeKey?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  ConversionRecordFlag?: InputMaybe<Order_By>;
  CoverageTypeCode?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  FlatRateManual?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MajorProblem1Desc?: InputMaybe<Order_By>;
  MajorProblem2Desc?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc1Description?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc2Description?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  Misc3Description?: InputMaybe<Order_By>;
  NewOrUsedCode?: InputMaybe<Order_By>;
  NoteMetadata?: InputMaybe<Order_By>;
  OwnersFirstName?: InputMaybe<Order_By>;
  OwnersLastName?: InputMaybe<Order_By>;
  OwnersSSN?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  PlanCode?: InputMaybe<Order_By>;
  PostgresSyncUpdateDate?: InputMaybe<Order_By>;
  QuickClaimFlag?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  ReimburseForRentalFlag?: InputMaybe<Order_By>;
  ReimburseForRepairFlag?: InputMaybe<Order_By>;
  ReimburseForTowFlag?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairFacility?: InputMaybe<Order_By>;
  RepairFacilityContact?: InputMaybe<Order_By>;
  RepairFacilityEmail?: InputMaybe<Order_By>;
  RepairFacilityName?: InputMaybe<Order_By>;
  RepairFacilityPhone?: InputMaybe<Order_By>;
  RepairOrder1?: InputMaybe<Order_By>;
  RepairOrder2?: InputMaybe<Order_By>;
  RepairOrder3?: InputMaybe<Order_By>;
  RepairOrder4?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleManufacturer?: InputMaybe<Order_By>;
  VehicleManufacturerCode?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
  VinNumber?: InputMaybe<Order_By>;
  VinNumberLast6?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ClaimsMaster" */
export type ClaimsMaster_Mutation_Response = {
  __typename?: 'ClaimsMaster_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimsMaster>;
};

/** Ordering options when selecting data from "ClaimsMaster". */
export type ClaimsMaster_Order_By = {
  AS400SyncUpdateDate?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BatchKey?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ClaimStatusCode?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  CompositeKey?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  ConversionRecordFlag?: InputMaybe<Order_By>;
  CoverageTypeCode?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  FlatRateManual?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MajorProblem1Desc?: InputMaybe<Order_By>;
  MajorProblem2Desc?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc1Description?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc2Description?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  Misc3Description?: InputMaybe<Order_By>;
  NewOrUsedCode?: InputMaybe<Order_By>;
  NoteMetadata?: InputMaybe<Order_By>;
  OwnersFirstName?: InputMaybe<Order_By>;
  OwnersLastName?: InputMaybe<Order_By>;
  OwnersSSN?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  PlanCode?: InputMaybe<Order_By>;
  PostgresSyncUpdateDate?: InputMaybe<Order_By>;
  QuickClaimFlag?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  ReimburseForRentalFlag?: InputMaybe<Order_By>;
  ReimburseForRepairFlag?: InputMaybe<Order_By>;
  ReimburseForTowFlag?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairFacility?: InputMaybe<Order_By>;
  RepairFacilityContact?: InputMaybe<Order_By>;
  RepairFacilityEmail?: InputMaybe<Order_By>;
  RepairFacilityName?: InputMaybe<Order_By>;
  RepairFacilityPhone?: InputMaybe<Order_By>;
  RepairOrder1?: InputMaybe<Order_By>;
  RepairOrder2?: InputMaybe<Order_By>;
  RepairOrder3?: InputMaybe<Order_By>;
  RepairOrder4?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleManufacturer?: InputMaybe<Order_By>;
  VehicleManufacturerCode?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
  VinNumber?: InputMaybe<Order_By>;
  VinNumberLast6?: InputMaybe<Order_By>;
  contract?: InputMaybe<ContractMaster_Order_By>;
  dealer?: InputMaybe<Dealer_Order_By>;
  status?: InputMaybe<ClaimStatus_Order_By>;
};

/** select columns of table "ClaimsMaster" */
export enum ClaimsMaster_Select_Column {
  /** column name */
  As400SyncUpdateDate = 'AS400SyncUpdateDate',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  AppraiserBillDate = 'AppraiserBillDate',
  /** column name */
  BatchKey = 'BatchKey',
  /** column name */
  BeginMileage = 'BeginMileage',
  /** column name */
  ChecksumColumn = 'ChecksumColumn',
  /** column name */
  ClaimAmount = 'ClaimAmount',
  /** column name */
  ClaimDetailChecksumColumn = 'ClaimDetailChecksumColumn',
  /** column name */
  ClaimMileage = 'ClaimMileage',
  /** column name */
  ClaimNumber = 'ClaimNumber',
  /** column name */
  ClaimStatusCode = 'ClaimStatusCode',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  CompositeKey = 'CompositeKey',
  /** column name */
  ConversionDate = 'ConversionDate',
  /** column name */
  ConversionRecordFlag = 'ConversionRecordFlag',
  /** column name */
  CoverageTypeCode = 'CoverageTypeCode',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  DeductibleAmount = 'DeductibleAmount',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  EnteredTime = 'EnteredTime',
  /** column name */
  FailedDate = 'FailedDate',
  /** column name */
  FlatRateManual = 'FlatRateManual',
  /** column name */
  Id = 'ID',
  /** column name */
  LaborRate = 'LaborRate',
  /** column name */
  LaborTax = 'LaborTax',
  /** column name */
  MajorProblem1Desc = 'MajorProblem1Desc',
  /** column name */
  MajorProblem2Desc = 'MajorProblem2Desc',
  /** column name */
  MaxShopSupplies = 'MaxShopSupplies',
  /** column name */
  Misc1BillDate = 'Misc1BillDate',
  /** column name */
  Misc1Description = 'Misc1Description',
  /** column name */
  Misc2BillDate = 'Misc2BillDate',
  /** column name */
  Misc2Description = 'Misc2Description',
  /** column name */
  Misc3BillDate = 'Misc3BillDate',
  /** column name */
  Misc3Description = 'Misc3Description',
  /** column name */
  NewOrUsedCode = 'NewOrUsedCode',
  /** column name */
  NoteMetadata = 'NoteMetadata',
  /** column name */
  OwnersFirstName = 'OwnersFirstName',
  /** column name */
  OwnersLastName = 'OwnersLastName',
  /** column name */
  OwnersSsn = 'OwnersSSN',
  /** column name */
  PaidAmount = 'PaidAmount',
  /** column name */
  PaidDate = 'PaidDate',
  /** column name */
  PlanCode = 'PlanCode',
  /** column name */
  PostgresSyncUpdateDate = 'PostgresSyncUpdateDate',
  /** column name */
  QuickClaimFlag = 'QuickClaimFlag',
  /** column name */
  RoReceivedDate1 = 'ROReceivedDate1',
  /** column name */
  RoReceivedDate2 = 'ROReceivedDate2',
  /** column name */
  RoReceivedDate3 = 'ROReceivedDate3',
  /** column name */
  RoReceivedDate4 = 'ROReceivedDate4',
  /** column name */
  ReimburseForRentalFlag = 'ReimburseForRentalFlag',
  /** column name */
  ReimburseForRepairFlag = 'ReimburseForRepairFlag',
  /** column name */
  ReimburseForTowFlag = 'ReimburseForTowFlag',
  /** column name */
  RentalBillDate = 'RentalBillDate',
  /** column name */
  RepairFacility = 'RepairFacility',
  /** column name */
  RepairFacilityContact = 'RepairFacilityContact',
  /** column name */
  RepairFacilityEmail = 'RepairFacilityEmail',
  /** column name */
  RepairFacilityName = 'RepairFacilityName',
  /** column name */
  RepairFacilityPhone = 'RepairFacilityPhone',
  /** column name */
  RepairOrder1 = 'RepairOrder1',
  /** column name */
  RepairOrder2 = 'RepairOrder2',
  /** column name */
  RepairOrder3 = 'RepairOrder3',
  /** column name */
  RepairOrder4 = 'RepairOrder4',
  /** column name */
  RepairOrderDate1 = 'RepairOrderDate1',
  /** column name */
  RepairOrderDate3 = 'RepairOrderDate3',
  /** column name */
  RepairOrderDate4 = 'RepairOrderDate4',
  /** column name */
  RepariOrderDate2 = 'RepariOrderDate2',
  /** column name */
  ReportedDate = 'ReportedDate',
  /** column name */
  ReportedTime = 'ReportedTime',
  /** column name */
  SequenceNumber = 'SequenceNumber',
  /** column name */
  ShopEntryDate = 'ShopEntryDate',
  /** column name */
  ShopSuppliesTax = 'ShopSuppliesTax',
  /** column name */
  TowBillDate = 'TowBillDate',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  UpdatedTime = 'UpdatedTime',
  /** column name */
  VehicleInServiceDate = 'VehicleInServiceDate',
  /** column name */
  VehicleManufacturer = 'VehicleManufacturer',
  /** column name */
  VehicleManufacturerCode = 'VehicleManufacturerCode',
  /** column name */
  VehicleYear = 'VehicleYear',
  /** column name */
  VinNumber = 'VinNumber',
  /** column name */
  VinNumberLast6 = 'VinNumberLast6'
}

/** input type for updating data in table "ClaimsMaster" */
export type ClaimsMaster_Set_Input = {
  AS400SyncUpdateDate?: InputMaybe<Scalars['datetime']>;
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  AgreementSuffix?: InputMaybe<Scalars['String']>;
  AppraiserBillDate?: InputMaybe<Scalars['Float']>;
  BatchKey?: InputMaybe<Scalars['uniqueidentifier']>;
  BeginMileage?: InputMaybe<Scalars['Float']>;
  ChecksumColumn?: InputMaybe<Scalars['Int']>;
  ClaimAmount?: InputMaybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: InputMaybe<Scalars['Int']>;
  ClaimMileage?: InputMaybe<Scalars['Float']>;
  ClaimNumber?: InputMaybe<Scalars['Float']>;
  ClaimStatusCode?: InputMaybe<Scalars['String']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  ConversionDate?: InputMaybe<Scalars['Float']>;
  ConversionRecordFlag?: InputMaybe<Scalars['String']>;
  CoverageTypeCode?: InputMaybe<Scalars['String']>;
  DealerCode?: InputMaybe<Scalars['String']>;
  DeductibleAmount?: InputMaybe<Scalars['Float']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  EnteredTime?: InputMaybe<Scalars['Float']>;
  FailedDate?: InputMaybe<Scalars['Float']>;
  FlatRateManual?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['uniqueidentifier']>;
  LaborRate?: InputMaybe<Scalars['Float']>;
  LaborTax?: InputMaybe<Scalars['Float']>;
  MajorProblem1Desc?: InputMaybe<Scalars['String']>;
  MajorProblem2Desc?: InputMaybe<Scalars['String']>;
  MaxShopSupplies?: InputMaybe<Scalars['Float']>;
  Misc1BillDate?: InputMaybe<Scalars['Float']>;
  Misc1Description?: InputMaybe<Scalars['String']>;
  Misc2BillDate?: InputMaybe<Scalars['Float']>;
  Misc2Description?: InputMaybe<Scalars['String']>;
  Misc3BillDate?: InputMaybe<Scalars['Float']>;
  Misc3Description?: InputMaybe<Scalars['String']>;
  NewOrUsedCode?: InputMaybe<Scalars['String']>;
  NoteMetadata?: InputMaybe<Scalars['String']>;
  OwnersFirstName?: InputMaybe<Scalars['String']>;
  OwnersLastName?: InputMaybe<Scalars['String']>;
  OwnersSSN?: InputMaybe<Scalars['String']>;
  PaidAmount?: InputMaybe<Scalars['Float']>;
  PaidDate?: InputMaybe<Scalars['Float']>;
  PlanCode?: InputMaybe<Scalars['String']>;
  PostgresSyncUpdateDate?: InputMaybe<Scalars['datetime']>;
  QuickClaimFlag?: InputMaybe<Scalars['String']>;
  ROReceivedDate1?: InputMaybe<Scalars['Float']>;
  ROReceivedDate2?: InputMaybe<Scalars['Float']>;
  ROReceivedDate3?: InputMaybe<Scalars['Float']>;
  ROReceivedDate4?: InputMaybe<Scalars['Float']>;
  ReimburseForRentalFlag?: InputMaybe<Scalars['String']>;
  ReimburseForRepairFlag?: InputMaybe<Scalars['String']>;
  ReimburseForTowFlag?: InputMaybe<Scalars['String']>;
  RentalBillDate?: InputMaybe<Scalars['Float']>;
  RepairFacility?: InputMaybe<Scalars['String']>;
  RepairFacilityContact?: InputMaybe<Scalars['String']>;
  RepairFacilityEmail?: InputMaybe<Scalars['String']>;
  RepairFacilityName?: InputMaybe<Scalars['String']>;
  RepairFacilityPhone?: InputMaybe<Scalars['String']>;
  RepairOrder1?: InputMaybe<Scalars['String']>;
  RepairOrder2?: InputMaybe<Scalars['String']>;
  RepairOrder3?: InputMaybe<Scalars['String']>;
  RepairOrder4?: InputMaybe<Scalars['String']>;
  RepairOrderDate1?: InputMaybe<Scalars['Float']>;
  RepairOrderDate3?: InputMaybe<Scalars['Float']>;
  RepairOrderDate4?: InputMaybe<Scalars['Float']>;
  RepariOrderDate2?: InputMaybe<Scalars['Float']>;
  ReportedDate?: InputMaybe<Scalars['Float']>;
  ReportedTime?: InputMaybe<Scalars['Float']>;
  SequenceNumber?: InputMaybe<Scalars['Float']>;
  ShopEntryDate?: InputMaybe<Scalars['Float']>;
  ShopSuppliesTax?: InputMaybe<Scalars['Float']>;
  TowBillDate?: InputMaybe<Scalars['Float']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
  UpdatedTime?: InputMaybe<Scalars['Float']>;
  VehicleInServiceDate?: InputMaybe<Scalars['Float']>;
  VehicleManufacturer?: InputMaybe<Scalars['String']>;
  VehicleManufacturerCode?: InputMaybe<Scalars['String']>;
  VehicleYear?: InputMaybe<Scalars['Float']>;
  VinNumber?: InputMaybe<Scalars['String']>;
  VinNumberLast6?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ClaimsMaster_Stddev_Fields = {
  __typename?: 'ClaimsMaster_stddev_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  AppraiserBillDate?: Maybe<Scalars['Float']>;
  BeginMileage?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimAmount?: Maybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimMileage?: Maybe<Scalars['Float']>;
  ClaimNumber?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  DeductibleAmount?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EnteredTime?: Maybe<Scalars['Float']>;
  FailedDate?: Maybe<Scalars['Float']>;
  LaborRate?: Maybe<Scalars['Float']>;
  LaborTax?: Maybe<Scalars['Float']>;
  MaxShopSupplies?: Maybe<Scalars['Float']>;
  Misc1BillDate?: Maybe<Scalars['Float']>;
  Misc2BillDate?: Maybe<Scalars['Float']>;
  Misc3BillDate?: Maybe<Scalars['Float']>;
  PaidAmount?: Maybe<Scalars['Float']>;
  PaidDate?: Maybe<Scalars['Float']>;
  ROReceivedDate1?: Maybe<Scalars['Float']>;
  ROReceivedDate2?: Maybe<Scalars['Float']>;
  ROReceivedDate3?: Maybe<Scalars['Float']>;
  ROReceivedDate4?: Maybe<Scalars['Float']>;
  RentalBillDate?: Maybe<Scalars['Float']>;
  RepairOrderDate1?: Maybe<Scalars['Float']>;
  RepairOrderDate3?: Maybe<Scalars['Float']>;
  RepairOrderDate4?: Maybe<Scalars['Float']>;
  RepariOrderDate2?: Maybe<Scalars['Float']>;
  ReportedDate?: Maybe<Scalars['Float']>;
  ReportedTime?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  ShopEntryDate?: Maybe<Scalars['Float']>;
  ShopSuppliesTax?: Maybe<Scalars['Float']>;
  TowBillDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpdatedTime?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ClaimsMaster" */
export type ClaimsMaster_Stddev_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ClaimsMaster_Stddev_Pop_Fields = {
  __typename?: 'ClaimsMaster_stddev_pop_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  AppraiserBillDate?: Maybe<Scalars['Float']>;
  BeginMileage?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimAmount?: Maybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimMileage?: Maybe<Scalars['Float']>;
  ClaimNumber?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  DeductibleAmount?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EnteredTime?: Maybe<Scalars['Float']>;
  FailedDate?: Maybe<Scalars['Float']>;
  LaborRate?: Maybe<Scalars['Float']>;
  LaborTax?: Maybe<Scalars['Float']>;
  MaxShopSupplies?: Maybe<Scalars['Float']>;
  Misc1BillDate?: Maybe<Scalars['Float']>;
  Misc2BillDate?: Maybe<Scalars['Float']>;
  Misc3BillDate?: Maybe<Scalars['Float']>;
  PaidAmount?: Maybe<Scalars['Float']>;
  PaidDate?: Maybe<Scalars['Float']>;
  ROReceivedDate1?: Maybe<Scalars['Float']>;
  ROReceivedDate2?: Maybe<Scalars['Float']>;
  ROReceivedDate3?: Maybe<Scalars['Float']>;
  ROReceivedDate4?: Maybe<Scalars['Float']>;
  RentalBillDate?: Maybe<Scalars['Float']>;
  RepairOrderDate1?: Maybe<Scalars['Float']>;
  RepairOrderDate3?: Maybe<Scalars['Float']>;
  RepairOrderDate4?: Maybe<Scalars['Float']>;
  RepariOrderDate2?: Maybe<Scalars['Float']>;
  ReportedDate?: Maybe<Scalars['Float']>;
  ReportedTime?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  ShopEntryDate?: Maybe<Scalars['Float']>;
  ShopSuppliesTax?: Maybe<Scalars['Float']>;
  TowBillDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpdatedTime?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ClaimsMaster" */
export type ClaimsMaster_Stddev_Pop_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ClaimsMaster_Stddev_Samp_Fields = {
  __typename?: 'ClaimsMaster_stddev_samp_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  AppraiserBillDate?: Maybe<Scalars['Float']>;
  BeginMileage?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimAmount?: Maybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimMileage?: Maybe<Scalars['Float']>;
  ClaimNumber?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  DeductibleAmount?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EnteredTime?: Maybe<Scalars['Float']>;
  FailedDate?: Maybe<Scalars['Float']>;
  LaborRate?: Maybe<Scalars['Float']>;
  LaborTax?: Maybe<Scalars['Float']>;
  MaxShopSupplies?: Maybe<Scalars['Float']>;
  Misc1BillDate?: Maybe<Scalars['Float']>;
  Misc2BillDate?: Maybe<Scalars['Float']>;
  Misc3BillDate?: Maybe<Scalars['Float']>;
  PaidAmount?: Maybe<Scalars['Float']>;
  PaidDate?: Maybe<Scalars['Float']>;
  ROReceivedDate1?: Maybe<Scalars['Float']>;
  ROReceivedDate2?: Maybe<Scalars['Float']>;
  ROReceivedDate3?: Maybe<Scalars['Float']>;
  ROReceivedDate4?: Maybe<Scalars['Float']>;
  RentalBillDate?: Maybe<Scalars['Float']>;
  RepairOrderDate1?: Maybe<Scalars['Float']>;
  RepairOrderDate3?: Maybe<Scalars['Float']>;
  RepairOrderDate4?: Maybe<Scalars['Float']>;
  RepariOrderDate2?: Maybe<Scalars['Float']>;
  ReportedDate?: Maybe<Scalars['Float']>;
  ReportedTime?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  ShopEntryDate?: Maybe<Scalars['Float']>;
  ShopSuppliesTax?: Maybe<Scalars['Float']>;
  TowBillDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpdatedTime?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ClaimsMaster" */
export type ClaimsMaster_Stddev_Samp_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type ClaimsMaster_Sum_Fields = {
  __typename?: 'ClaimsMaster_sum_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  AppraiserBillDate?: Maybe<Scalars['Float']>;
  BeginMileage?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Int']>;
  ClaimAmount?: Maybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: Maybe<Scalars['Int']>;
  ClaimMileage?: Maybe<Scalars['Float']>;
  ClaimNumber?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  DeductibleAmount?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EnteredTime?: Maybe<Scalars['Float']>;
  FailedDate?: Maybe<Scalars['Float']>;
  LaborRate?: Maybe<Scalars['Float']>;
  LaborTax?: Maybe<Scalars['Float']>;
  MaxShopSupplies?: Maybe<Scalars['Float']>;
  Misc1BillDate?: Maybe<Scalars['Float']>;
  Misc2BillDate?: Maybe<Scalars['Float']>;
  Misc3BillDate?: Maybe<Scalars['Float']>;
  PaidAmount?: Maybe<Scalars['Float']>;
  PaidDate?: Maybe<Scalars['Float']>;
  ROReceivedDate1?: Maybe<Scalars['Float']>;
  ROReceivedDate2?: Maybe<Scalars['Float']>;
  ROReceivedDate3?: Maybe<Scalars['Float']>;
  ROReceivedDate4?: Maybe<Scalars['Float']>;
  RentalBillDate?: Maybe<Scalars['Float']>;
  RepairOrderDate1?: Maybe<Scalars['Float']>;
  RepairOrderDate3?: Maybe<Scalars['Float']>;
  RepairOrderDate4?: Maybe<Scalars['Float']>;
  RepariOrderDate2?: Maybe<Scalars['Float']>;
  ReportedDate?: Maybe<Scalars['Float']>;
  ReportedTime?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  ShopEntryDate?: Maybe<Scalars['Float']>;
  ShopSuppliesTax?: Maybe<Scalars['Float']>;
  TowBillDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpdatedTime?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "ClaimsMaster" */
export type ClaimsMaster_Sum_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** update columns of table "ClaimsMaster" */
export enum ClaimsMaster_Update_Column {
  /** column name */
  As400SyncUpdateDate = 'AS400SyncUpdateDate',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  AppraiserBillDate = 'AppraiserBillDate',
  /** column name */
  BatchKey = 'BatchKey',
  /** column name */
  BeginMileage = 'BeginMileage',
  /** column name */
  ChecksumColumn = 'ChecksumColumn',
  /** column name */
  ClaimAmount = 'ClaimAmount',
  /** column name */
  ClaimDetailChecksumColumn = 'ClaimDetailChecksumColumn',
  /** column name */
  ClaimMileage = 'ClaimMileage',
  /** column name */
  ClaimNumber = 'ClaimNumber',
  /** column name */
  ClaimStatusCode = 'ClaimStatusCode',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  ConversionDate = 'ConversionDate',
  /** column name */
  ConversionRecordFlag = 'ConversionRecordFlag',
  /** column name */
  CoverageTypeCode = 'CoverageTypeCode',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  DeductibleAmount = 'DeductibleAmount',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  EnteredTime = 'EnteredTime',
  /** column name */
  FailedDate = 'FailedDate',
  /** column name */
  FlatRateManual = 'FlatRateManual',
  /** column name */
  Id = 'ID',
  /** column name */
  LaborRate = 'LaborRate',
  /** column name */
  LaborTax = 'LaborTax',
  /** column name */
  MajorProblem1Desc = 'MajorProblem1Desc',
  /** column name */
  MajorProblem2Desc = 'MajorProblem2Desc',
  /** column name */
  MaxShopSupplies = 'MaxShopSupplies',
  /** column name */
  Misc1BillDate = 'Misc1BillDate',
  /** column name */
  Misc1Description = 'Misc1Description',
  /** column name */
  Misc2BillDate = 'Misc2BillDate',
  /** column name */
  Misc2Description = 'Misc2Description',
  /** column name */
  Misc3BillDate = 'Misc3BillDate',
  /** column name */
  Misc3Description = 'Misc3Description',
  /** column name */
  NewOrUsedCode = 'NewOrUsedCode',
  /** column name */
  NoteMetadata = 'NoteMetadata',
  /** column name */
  OwnersFirstName = 'OwnersFirstName',
  /** column name */
  OwnersLastName = 'OwnersLastName',
  /** column name */
  OwnersSsn = 'OwnersSSN',
  /** column name */
  PaidAmount = 'PaidAmount',
  /** column name */
  PaidDate = 'PaidDate',
  /** column name */
  PlanCode = 'PlanCode',
  /** column name */
  PostgresSyncUpdateDate = 'PostgresSyncUpdateDate',
  /** column name */
  QuickClaimFlag = 'QuickClaimFlag',
  /** column name */
  RoReceivedDate1 = 'ROReceivedDate1',
  /** column name */
  RoReceivedDate2 = 'ROReceivedDate2',
  /** column name */
  RoReceivedDate3 = 'ROReceivedDate3',
  /** column name */
  RoReceivedDate4 = 'ROReceivedDate4',
  /** column name */
  ReimburseForRentalFlag = 'ReimburseForRentalFlag',
  /** column name */
  ReimburseForRepairFlag = 'ReimburseForRepairFlag',
  /** column name */
  ReimburseForTowFlag = 'ReimburseForTowFlag',
  /** column name */
  RentalBillDate = 'RentalBillDate',
  /** column name */
  RepairFacility = 'RepairFacility',
  /** column name */
  RepairFacilityContact = 'RepairFacilityContact',
  /** column name */
  RepairFacilityEmail = 'RepairFacilityEmail',
  /** column name */
  RepairFacilityName = 'RepairFacilityName',
  /** column name */
  RepairFacilityPhone = 'RepairFacilityPhone',
  /** column name */
  RepairOrder1 = 'RepairOrder1',
  /** column name */
  RepairOrder2 = 'RepairOrder2',
  /** column name */
  RepairOrder3 = 'RepairOrder3',
  /** column name */
  RepairOrder4 = 'RepairOrder4',
  /** column name */
  RepairOrderDate1 = 'RepairOrderDate1',
  /** column name */
  RepairOrderDate3 = 'RepairOrderDate3',
  /** column name */
  RepairOrderDate4 = 'RepairOrderDate4',
  /** column name */
  RepariOrderDate2 = 'RepariOrderDate2',
  /** column name */
  ReportedDate = 'ReportedDate',
  /** column name */
  ReportedTime = 'ReportedTime',
  /** column name */
  SequenceNumber = 'SequenceNumber',
  /** column name */
  ShopEntryDate = 'ShopEntryDate',
  /** column name */
  ShopSuppliesTax = 'ShopSuppliesTax',
  /** column name */
  TowBillDate = 'TowBillDate',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  UpdatedTime = 'UpdatedTime',
  /** column name */
  VehicleInServiceDate = 'VehicleInServiceDate',
  /** column name */
  VehicleManufacturer = 'VehicleManufacturer',
  /** column name */
  VehicleManufacturerCode = 'VehicleManufacturerCode',
  /** column name */
  VehicleYear = 'VehicleYear',
  /** column name */
  VinNumber = 'VinNumber',
  /** column name */
  VinNumberLast6 = 'VinNumberLast6'
}

/** aggregate var_pop on columns */
export type ClaimsMaster_Var_Pop_Fields = {
  __typename?: 'ClaimsMaster_var_pop_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  AppraiserBillDate?: Maybe<Scalars['Float']>;
  BeginMileage?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimAmount?: Maybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimMileage?: Maybe<Scalars['Float']>;
  ClaimNumber?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  DeductibleAmount?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EnteredTime?: Maybe<Scalars['Float']>;
  FailedDate?: Maybe<Scalars['Float']>;
  LaborRate?: Maybe<Scalars['Float']>;
  LaborTax?: Maybe<Scalars['Float']>;
  MaxShopSupplies?: Maybe<Scalars['Float']>;
  Misc1BillDate?: Maybe<Scalars['Float']>;
  Misc2BillDate?: Maybe<Scalars['Float']>;
  Misc3BillDate?: Maybe<Scalars['Float']>;
  PaidAmount?: Maybe<Scalars['Float']>;
  PaidDate?: Maybe<Scalars['Float']>;
  ROReceivedDate1?: Maybe<Scalars['Float']>;
  ROReceivedDate2?: Maybe<Scalars['Float']>;
  ROReceivedDate3?: Maybe<Scalars['Float']>;
  ROReceivedDate4?: Maybe<Scalars['Float']>;
  RentalBillDate?: Maybe<Scalars['Float']>;
  RepairOrderDate1?: Maybe<Scalars['Float']>;
  RepairOrderDate3?: Maybe<Scalars['Float']>;
  RepairOrderDate4?: Maybe<Scalars['Float']>;
  RepariOrderDate2?: Maybe<Scalars['Float']>;
  ReportedDate?: Maybe<Scalars['Float']>;
  ReportedTime?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  ShopEntryDate?: Maybe<Scalars['Float']>;
  ShopSuppliesTax?: Maybe<Scalars['Float']>;
  TowBillDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpdatedTime?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ClaimsMaster" */
export type ClaimsMaster_Var_Pop_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ClaimsMaster_Var_Samp_Fields = {
  __typename?: 'ClaimsMaster_var_samp_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  AppraiserBillDate?: Maybe<Scalars['Float']>;
  BeginMileage?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimAmount?: Maybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimMileage?: Maybe<Scalars['Float']>;
  ClaimNumber?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  DeductibleAmount?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EnteredTime?: Maybe<Scalars['Float']>;
  FailedDate?: Maybe<Scalars['Float']>;
  LaborRate?: Maybe<Scalars['Float']>;
  LaborTax?: Maybe<Scalars['Float']>;
  MaxShopSupplies?: Maybe<Scalars['Float']>;
  Misc1BillDate?: Maybe<Scalars['Float']>;
  Misc2BillDate?: Maybe<Scalars['Float']>;
  Misc3BillDate?: Maybe<Scalars['Float']>;
  PaidAmount?: Maybe<Scalars['Float']>;
  PaidDate?: Maybe<Scalars['Float']>;
  ROReceivedDate1?: Maybe<Scalars['Float']>;
  ROReceivedDate2?: Maybe<Scalars['Float']>;
  ROReceivedDate3?: Maybe<Scalars['Float']>;
  ROReceivedDate4?: Maybe<Scalars['Float']>;
  RentalBillDate?: Maybe<Scalars['Float']>;
  RepairOrderDate1?: Maybe<Scalars['Float']>;
  RepairOrderDate3?: Maybe<Scalars['Float']>;
  RepairOrderDate4?: Maybe<Scalars['Float']>;
  RepariOrderDate2?: Maybe<Scalars['Float']>;
  ReportedDate?: Maybe<Scalars['Float']>;
  ReportedTime?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  ShopEntryDate?: Maybe<Scalars['Float']>;
  ShopSuppliesTax?: Maybe<Scalars['Float']>;
  TowBillDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpdatedTime?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ClaimsMaster" */
export type ClaimsMaster_Var_Samp_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ClaimsMaster_Variance_Fields = {
  __typename?: 'ClaimsMaster_variance_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  AppraiserBillDate?: Maybe<Scalars['Float']>;
  BeginMileage?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimAmount?: Maybe<Scalars['Float']>;
  ClaimDetailChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimMileage?: Maybe<Scalars['Float']>;
  ClaimNumber?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  DeductibleAmount?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EnteredTime?: Maybe<Scalars['Float']>;
  FailedDate?: Maybe<Scalars['Float']>;
  LaborRate?: Maybe<Scalars['Float']>;
  LaborTax?: Maybe<Scalars['Float']>;
  MaxShopSupplies?: Maybe<Scalars['Float']>;
  Misc1BillDate?: Maybe<Scalars['Float']>;
  Misc2BillDate?: Maybe<Scalars['Float']>;
  Misc3BillDate?: Maybe<Scalars['Float']>;
  PaidAmount?: Maybe<Scalars['Float']>;
  PaidDate?: Maybe<Scalars['Float']>;
  ROReceivedDate1?: Maybe<Scalars['Float']>;
  ROReceivedDate2?: Maybe<Scalars['Float']>;
  ROReceivedDate3?: Maybe<Scalars['Float']>;
  ROReceivedDate4?: Maybe<Scalars['Float']>;
  RentalBillDate?: Maybe<Scalars['Float']>;
  RepairOrderDate1?: Maybe<Scalars['Float']>;
  RepairOrderDate3?: Maybe<Scalars['Float']>;
  RepairOrderDate4?: Maybe<Scalars['Float']>;
  RepariOrderDate2?: Maybe<Scalars['Float']>;
  ReportedDate?: Maybe<Scalars['Float']>;
  ReportedTime?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  ShopEntryDate?: Maybe<Scalars['Float']>;
  ShopSuppliesTax?: Maybe<Scalars['Float']>;
  TowBillDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpdatedTime?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ClaimsMaster" */
export type ClaimsMaster_Variance_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  AppraiserBillDate?: InputMaybe<Order_By>;
  BeginMileage?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimAmount?: InputMaybe<Order_By>;
  ClaimDetailChecksumColumn?: InputMaybe<Order_By>;
  ClaimMileage?: InputMaybe<Order_By>;
  ClaimNumber?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  DeductibleAmount?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EnteredTime?: InputMaybe<Order_By>;
  FailedDate?: InputMaybe<Order_By>;
  LaborRate?: InputMaybe<Order_By>;
  LaborTax?: InputMaybe<Order_By>;
  MaxShopSupplies?: InputMaybe<Order_By>;
  Misc1BillDate?: InputMaybe<Order_By>;
  Misc2BillDate?: InputMaybe<Order_By>;
  Misc3BillDate?: InputMaybe<Order_By>;
  PaidAmount?: InputMaybe<Order_By>;
  PaidDate?: InputMaybe<Order_By>;
  ROReceivedDate1?: InputMaybe<Order_By>;
  ROReceivedDate2?: InputMaybe<Order_By>;
  ROReceivedDate3?: InputMaybe<Order_By>;
  ROReceivedDate4?: InputMaybe<Order_By>;
  RentalBillDate?: InputMaybe<Order_By>;
  RepairOrderDate1?: InputMaybe<Order_By>;
  RepairOrderDate3?: InputMaybe<Order_By>;
  RepairOrderDate4?: InputMaybe<Order_By>;
  RepariOrderDate2?: InputMaybe<Order_By>;
  ReportedDate?: InputMaybe<Order_By>;
  ReportedTime?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  ShopEntryDate?: InputMaybe<Order_By>;
  ShopSuppliesTax?: InputMaybe<Order_By>;
  TowBillDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpdatedTime?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate fields of "vpic.combinedbrakingsystem" */
export type CombinedBrakingSystem_Aggregate_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_aggregate_fields_vpic';
  avg?: Maybe<CombinedBrakingSystem_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<CombinedBrakingSystem_Max_Fields_Vpic>;
  min?: Maybe<CombinedBrakingSystem_Min_Fields_Vpic>;
  stddev?: Maybe<CombinedBrakingSystem_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<CombinedBrakingSystem_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<CombinedBrakingSystem_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<CombinedBrakingSystem_Sum_Fields_Vpic>;
  var_pop?: Maybe<CombinedBrakingSystem_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<CombinedBrakingSystem_Var_Samp_Fields_Vpic>;
  variance?: Maybe<CombinedBrakingSystem_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.combinedbrakingsystem" */
export type CombinedBrakingSystem_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<CombinedBrakingSystem_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.combinedbrakingsystem" */
export type CombinedBrakingSystem_Aggregate_Vpic = {
  __typename?: 'CombinedBrakingSystem_aggregate_vpic';
  aggregate?: Maybe<CombinedBrakingSystem_Aggregate_Fields_Vpic>;
  nodes: Array<CombinedBrakingSystem_Vpic>;
};

/** aggregate avg on columns */
export type CombinedBrakingSystem_Avg_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.combinedbrakingsystem". All fields are combined with a logical 'AND'. */
export type CombinedBrakingSystem_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<CombinedBrakingSystem_Bool_Exp_Vpic>>;
  _not?: InputMaybe<CombinedBrakingSystem_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<CombinedBrakingSystem_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.combinedbrakingsystem" */
export enum CombinedBrakingSystem_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkCombinedbrakingsystem = 'pk_combinedbrakingsystem',
  /** unique or primary key constraint on columns "name" */
  UCombinedbrakingsystem = 'u_combinedbrakingsystem'
}

/** input type for incrementing numeric columns in table "vpic.combinedbrakingsystem" */
export type CombinedBrakingSystem_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.combinedbrakingsystem" */
export type CombinedBrakingSystem_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CombinedBrakingSystem_Max_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CombinedBrakingSystem_Min_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.combinedbrakingsystem" */
export type CombinedBrakingSystem_Mutation_Response_Vpic = {
  __typename?: 'CombinedBrakingSystem_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CombinedBrakingSystem_Vpic>;
};

/** on_conflict condition type for table "vpic.combinedbrakingsystem" */
export type CombinedBrakingSystem_On_Conflict_Vpic = {
  constraint: CombinedBrakingSystem_Constraint_Vpic;
  update_columns?: Array<CombinedBrakingSystem_Update_Column_Vpic>;
  where?: InputMaybe<CombinedBrakingSystem_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.combinedbrakingsystem". */
export type CombinedBrakingSystem_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.combinedbrakingsystem */
export type CombinedBrakingSystem_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.combinedbrakingsystem" */
export enum CombinedBrakingSystem_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.combinedbrakingsystem" */
export type CombinedBrakingSystem_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CombinedBrakingSystem_Stddev_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CombinedBrakingSystem_Stddev_Pop_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CombinedBrakingSystem_Stddev_Samp_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "CombinedBrakingSystem" */
export type CombinedBrakingSystem_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: CombinedBrakingSystem_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type CombinedBrakingSystem_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CombinedBrakingSystem_Sum_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.combinedbrakingsystem" */
export enum CombinedBrakingSystem_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type CombinedBrakingSystem_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CombinedBrakingSystem_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CombinedBrakingSystem_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: CombinedBrakingSystem_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type CombinedBrakingSystem_Var_Pop_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CombinedBrakingSystem_Var_Samp_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CombinedBrakingSystem_Variance_Fields_Vpic = {
  __typename?: 'CombinedBrakingSystem_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.combinedbrakingsystem" */
export type CombinedBrakingSystem_Vpic = {
  __typename?: 'CombinedBrakingSystem_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** columns and relationships of "ContractMaster" */
export type ContractMaster = {
  __typename?: 'ContractMaster';
  AccountPostedDate: Scalars['Float'];
  ActiveFromDate: Scalars['Float'];
  ActiveFromDateComputed?: Maybe<Scalars['date']>;
  AddendumMetadata?: Maybe<Scalars['String']>;
  Address1: Scalars['String'];
  Address2: Scalars['String'];
  AdjustedAdminCostAmount: Scalars['Float'];
  AdjustedMiscCost1Amount: Scalars['Float'];
  AdjustedMiscCost2Amount: Scalars['Float'];
  AdjustedReserveAmount: Scalars['Float'];
  AdjustedSpecialReserveAmount: Scalars['Float'];
  AdminCost2Amount: Scalars['Float'];
  AdminCostAmount: Scalars['Float'];
  AgreementNumber: Scalars['Float'];
  AgreementSuffix: Scalars['String'];
  AllowedTransferNumber: Scalars['Float'];
  AlternateFactoryWarrantyFlag: Scalars['String'];
  BatchKey?: Maybe<Scalars['uniqueidentifier']>;
  BatchNumber: Scalars['Float'];
  BookState: Scalars['String'];
  CanMethod: Scalars['Float'];
  CanRule: Scalars['Float'];
  CancelAsOfDate: Scalars['Float'];
  CancelAsOfDateComputed?: Maybe<Scalars['date']>;
  CancelBatchNumber: Scalars['Float'];
  CancelFeeAmount: Scalars['Float'];
  CancelPostedDate: Scalars['Float'];
  CancelProcessFromDate: Scalars['Float'];
  CancelTransferDate: Scalars['Float'];
  CarrierCode: Scalars['String'];
  ChecksumColumn?: Maybe<Scalars['Int']>;
  City: Scalars['String'];
  ClaimCount: Scalars['Float'];
  ClaimsPaidAmount: Scalars['Float'];
  CompanyCode: Scalars['String'];
  CompositeKey?: Maybe<Scalars['String']>;
  ContractMasterID: Scalars['Int'];
  ContractPdfFilename?: Maybe<Scalars['String']>;
  ContractPurchaseDate: Scalars['Float'];
  ContractPurchaseDateComputed?: Maybe<Scalars['date']>;
  ConversionDate: Scalars['Float'];
  ConversionRecordFlag: Scalars['String'];
  CostDetailMetadata?: Maybe<Scalars['String']>;
  CoverageCostAmount: Scalars['Float'];
  CoverageMiles: Scalars['Float'];
  CoverageMonths: Scalars['Float'];
  CoverageOption: Scalars['Float'];
  CoverageTypeCode: Scalars['String'];
  CustomerCostAmount: Scalars['Float'];
  CustomerRefundAmount: Scalars['Float'];
  CylinderNumber: Scalars['Float'];
  DealerAgentOverrageUnderageFlag: Scalars['String'];
  DealerCode: Scalars['String'];
  DealerIncentiveAmount: Scalars['Float'];
  DealerRefundAmount: Scalars['Float'];
  DealerRemittedAmount: Scalars['Float'];
  DealerState: Scalars['String'];
  Deductible: Scalars['Float'];
  DeniedDate: Scalars['Float'];
  DeniedDateComputed?: Maybe<Scalars['date']>;
  EnteredBy: Scalars['String'];
  EnteredDate: Scalars['Float'];
  ExceptionFlag: Scalars['String'];
  ExecAdminCostAmount: Scalars['Float'];
  ExecMiscCost1Amount: Scalars['Float'];
  ExecMiscCost2Amount: Scalars['Float'];
  ExecReserveAmount: Scalars['Float'];
  ExecSpecialReserveAmount: Scalars['Float'];
  ExpireMiles: Scalars['Float'];
  FleetNumber: Scalars['Float'];
  ForcedAgreementFlag: Scalars['String'];
  ForcedRefundAmount: Scalars['Float'];
  FormCode: Scalars['String'];
  FuelDeliveryCode: Scalars['String'];
  FuelTypeCode: Scalars['String'];
  GroupCode: Scalars['String'];
  ID: Scalars['uniqueidentifier'];
  LastClaimMileage: Scalars['Float'];
  LastTransferDate: Scalars['Float'];
  LastTransferDateComputed?: Maybe<Scalars['date']>;
  LastTransferMileage: Scalars['Float'];
  LenderMetadata?: Maybe<Scalars['String']>;
  MBPIRefundAmount: Scalars['Float'];
  MaxDaysToPayNumber: Scalars['Float'];
  MaxPayPerDayAmount: Scalars['Float'];
  MaxTowingExpenseAmount: Scalars['Float'];
  MiscCost1Amount: Scalars['Float'];
  MiscCost2Amount: Scalars['Float'];
  MiscCost3Amount: Scalars['Float'];
  MiscCost4Amount: Scalars['Float'];
  NewOrUsedCode: Scalars['String'];
  NoteMetadata?: Maybe<Scalars['String']>;
  OdometerReading: Scalars['Float'];
  OwnerMetadata?: Maybe<Scalars['String']>;
  OwnersFirstName: Scalars['String'];
  OwnersLastName: Scalars['String'];
  PhoneNumber: Scalars['String'];
  PlanCode: Scalars['String'];
  PolicyModifiedDate: Scalars['Float'];
  PolicyTypeCode: Scalars['String'];
  PostedDate: Scalars['Float'];
  PostedDateComputed?: Maybe<Scalars['date']>;
  PostgresSyncUpdateDate?: Maybe<Scalars['datetime']>;
  PrimaryAgentCode: Scalars['String'];
  ProductMetadata?: Maybe<Scalars['String']>;
  ProgramCarFlag: Scalars['String'];
  ReceivedDate: Scalars['Float'];
  RecordTypeCode: Scalars['String'];
  RedoContractPdfFilename?: Maybe<Scalars['Boolean']>;
  RefundPercentage: Scalars['Float'];
  ReinstatedDate: Scalars['Float'];
  ReinstatedDateComputed?: Maybe<Scalars['date']>;
  ReinstatedFlag: Scalars['String'];
  Reserve2Amount: Scalars['Float'];
  ReserveAmount: Scalars['Float'];
  ReturnCancellationToAgentFlag: Scalars['Float'];
  ReturnCancellationToCustomerFlag: Scalars['Float'];
  ReturnCancellationToDealerFlag: Scalars['Float'];
  ReturnCancellationToFinancialInstFlag: Scalars['Float'];
  ReturnCancellationToLeinHolderFlag: Scalars['Float'];
  ReturnCancellationToOtherFlag: Scalars['Float'];
  ReturnFromMailingFlag: Scalars['String'];
  SSN: Scalars['String'];
  SecondaryExpirationDate?: Maybe<Scalars['date']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Int']>;
  SecondaryOwnersFirstName?: Maybe<Scalars['String']>;
  SecondaryOwnersLastName?: Maybe<Scalars['String']>;
  SequenceNumber: Scalars['Float'];
  SpecialReserve2Amount: Scalars['Float'];
  SpecialReserveAmount: Scalars['Float'];
  StateAbbreviation: Scalars['String'];
  StatusCode: Scalars['Int'];
  SubmitExpireDate: Scalars['Float'];
  SurchargeCostAmount: Scalars['Float'];
  SyncUpdateDate?: Maybe<Scalars['datetime']>;
  TransferFeeAmount: Scalars['Float'];
  TransferNumber: Scalars['Float'];
  TransferTypeCode: Scalars['String'];
  TransferredFlag: Scalars['String'];
  TrueExpireDate: Scalars['Float'];
  TrueExpireDateComputed?: Maybe<Scalars['date']>;
  UpdatedBy: Scalars['String'];
  UpdatedDate: Scalars['Float'];
  UpgradedFlag: Scalars['String'];
  VehicleClassCode: Scalars['String'];
  VehicleClassificationCode: Scalars['String'];
  VehicleCost: Scalars['Float'];
  VehicleInServiceDate: Scalars['Float'];
  VehicleInServiceDateComputed?: Maybe<Scalars['date']>;
  VehicleMakeCode: Scalars['String'];
  VehicleManufacturerCode: Scalars['String'];
  VehicleMilesWhenCancel: Scalars['Float'];
  VehicleModelCode: Scalars['String'];
  VehiclePurchaseDate: Scalars['Float'];
  VehiclePurchaseDateComputed?: Maybe<Scalars['date']>;
  VehicleSeriesName: Scalars['String'];
  VehicleWheelsDriving: Scalars['Float'];
  VehicleYear: Scalars['Float'];
  VinNotFoundFlag: Scalars['String'];
  VinNumber: Scalars['String'];
  Zip: Scalars['String'];
  /** An array relationship */
  claims: Array<ClaimsMaster>;
  /** An aggregate relationship */
  claims_aggregate: ClaimsMaster_Aggregate;
  /** An array relationship */
  contractMasterAdditionalEntities: Array<ContractMasterAdditionalEntity>;
  /** An aggregate relationship */
  contractMasterAdditionalEntities_aggregate: ContractMasterAdditionalEntity_Aggregate;
  /** An array relationship */
  contractMasterSurcharges: Array<ContractMasterSurcharge>;
  /** An aggregate relationship */
  contractMasterSurcharges_aggregate: ContractMasterSurcharge_Aggregate;
  /** An object relationship */
  dealer?: Maybe<Dealer>;
  /** An object relationship */
  plan?: Maybe<Plan>;
};


/** columns and relationships of "ContractMaster" */
export type ContractMasterClaimsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimsMaster_Order_By>>;
  where?: InputMaybe<ClaimsMaster_Bool_Exp>;
};


/** columns and relationships of "ContractMaster" */
export type ContractMasterClaims_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimsMaster_Order_By>>;
  where?: InputMaybe<ClaimsMaster_Bool_Exp>;
};


/** columns and relationships of "ContractMaster" */
export type ContractMasterContractMasterAdditionalEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterAdditionalEntity_Order_By>>;
  where?: InputMaybe<ContractMasterAdditionalEntity_Bool_Exp>;
};


/** columns and relationships of "ContractMaster" */
export type ContractMasterContractMasterAdditionalEntities_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterAdditionalEntity_Order_By>>;
  where?: InputMaybe<ContractMasterAdditionalEntity_Bool_Exp>;
};


/** columns and relationships of "ContractMaster" */
export type ContractMasterContractMasterSurchargesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterSurcharge_Order_By>>;
  where?: InputMaybe<ContractMasterSurcharge_Bool_Exp>;
};


/** columns and relationships of "ContractMaster" */
export type ContractMasterContractMasterSurcharges_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterSurcharge_Order_By>>;
  where?: InputMaybe<ContractMasterSurcharge_Bool_Exp>;
};

/** columns and relationships of "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity = {
  __typename?: 'ContractMasterAdditionalEntity';
  AdditionalEntityTypeCode: Scalars['String'];
  Address1: Scalars['String'];
  Address2: Scalars['String'];
  AgreementNumber: Scalars['Float'];
  AgreementSuffix: Scalars['String'];
  City: Scalars['String'];
  CompanyCode: Scalars['String'];
  DealerCode: Scalars['String'];
  EnteredBy: Scalars['String'];
  EnteredDate: Scalars['Float'];
  Name: Scalars['String'];
  PhoneNumber: Scalars['String'];
  StateAbbreviation: Scalars['String'];
  UpdatedBy: Scalars['String'];
  UpdatedDate: Scalars['Float'];
  Zip: Scalars['String'];
};

/** aggregated selection of "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Aggregate = {
  __typename?: 'ContractMasterAdditionalEntity_aggregate';
  aggregate?: Maybe<ContractMasterAdditionalEntity_Aggregate_Fields>;
  nodes: Array<ContractMasterAdditionalEntity>;
};

/** aggregate fields of "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Aggregate_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_aggregate_fields';
  avg?: Maybe<ContractMasterAdditionalEntity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ContractMasterAdditionalEntity_Max_Fields>;
  min?: Maybe<ContractMasterAdditionalEntity_Min_Fields>;
  stddev?: Maybe<ContractMasterAdditionalEntity_Stddev_Fields>;
  stddev_pop?: Maybe<ContractMasterAdditionalEntity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ContractMasterAdditionalEntity_Stddev_Samp_Fields>;
  sum?: Maybe<ContractMasterAdditionalEntity_Sum_Fields>;
  var_pop?: Maybe<ContractMasterAdditionalEntity_Var_Pop_Fields>;
  var_samp?: Maybe<ContractMasterAdditionalEntity_Var_Samp_Fields>;
  variance?: Maybe<ContractMasterAdditionalEntity_Variance_Fields>;
};


/** aggregate fields of "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<ContractMasterAdditionalEntity_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Aggregate_Order_By = {
  avg?: InputMaybe<ContractMasterAdditionalEntity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ContractMasterAdditionalEntity_Max_Order_By>;
  min?: InputMaybe<ContractMasterAdditionalEntity_Min_Order_By>;
  stddev?: InputMaybe<ContractMasterAdditionalEntity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ContractMasterAdditionalEntity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ContractMasterAdditionalEntity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ContractMasterAdditionalEntity_Sum_Order_By>;
  var_pop?: InputMaybe<ContractMasterAdditionalEntity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ContractMasterAdditionalEntity_Var_Samp_Order_By>;
  variance?: InputMaybe<ContractMasterAdditionalEntity_Variance_Order_By>;
};

/** aggregate avg on columns */
export type ContractMasterAdditionalEntity_Avg_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_avg_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Avg_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ContractMasterAdditionalEntity". All fields are combined with a logical 'AND'. */
export type ContractMasterAdditionalEntity_Bool_Exp = {
  AdditionalEntityTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Address1?: InputMaybe<String_Mssql_Comparison_Exp>;
  Address2?: InputMaybe<String_Mssql_Comparison_Exp>;
  AgreementNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AgreementSuffix?: InputMaybe<String_Mssql_Comparison_Exp>;
  City?: InputMaybe<String_Mssql_Comparison_Exp>;
  CompanyCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  DealerCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  EnteredBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  EnteredDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Name?: InputMaybe<String_Mssql_Comparison_Exp>;
  PhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  StateAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  UpdatedBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  UpdatedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Zip?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<ContractMasterAdditionalEntity_Bool_Exp>>;
  _not?: InputMaybe<ContractMasterAdditionalEntity_Bool_Exp>;
  _or?: InputMaybe<Array<ContractMasterAdditionalEntity_Bool_Exp>>;
};

/** upsert condition type for table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_If_Matched = {
  match_columns?: Array<ContractMasterAdditionalEntity_Insert_Match_Column>;
  update_columns?: Array<ContractMasterAdditionalEntity_Update_Column>;
  where?: InputMaybe<ContractMasterAdditionalEntity_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Inc_Input = {
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Insert_Input = {
  AdditionalEntityTypeCode?: InputMaybe<Scalars['String']>;
  Address1?: InputMaybe<Scalars['String']>;
  Address2?: InputMaybe<Scalars['String']>;
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  AgreementSuffix?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  DealerCode?: InputMaybe<Scalars['String']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  Name?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  StateAbbreviation?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
  Zip?: InputMaybe<Scalars['String']>;
};

/** select match_columns of table "ContractMasterAdditionalEntity" */
export enum ContractMasterAdditionalEntity_Insert_Match_Column {
  /** column name */
  AdditionalEntityTypeCode = 'AdditionalEntityTypeCode',
  /** column name */
  Address1 = 'Address1',
  /** column name */
  Address2 = 'Address2',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  City = 'City',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  Name = 'Name',
  /** column name */
  PhoneNumber = 'PhoneNumber',
  /** column name */
  StateAbbreviation = 'StateAbbreviation',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  Zip = 'Zip'
}

/** aggregate max on columns */
export type ContractMasterAdditionalEntity_Max_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_max_fields';
  AdditionalEntityTypeCode?: Maybe<Scalars['String']>;
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AgreementSuffix?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  CompanyCode?: Maybe<Scalars['String']>;
  DealerCode?: Maybe<Scalars['String']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  Name?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  StateAbbreviation?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  Zip?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Max_Order_By = {
  AdditionalEntityTypeCode?: InputMaybe<Order_By>;
  Address1?: InputMaybe<Order_By>;
  Address2?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  City?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  PhoneNumber?: InputMaybe<Order_By>;
  StateAbbreviation?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  Zip?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ContractMasterAdditionalEntity_Min_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_min_fields';
  AdditionalEntityTypeCode?: Maybe<Scalars['String']>;
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AgreementSuffix?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  CompanyCode?: Maybe<Scalars['String']>;
  DealerCode?: Maybe<Scalars['String']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  Name?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  StateAbbreviation?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  Zip?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Min_Order_By = {
  AdditionalEntityTypeCode?: InputMaybe<Order_By>;
  Address1?: InputMaybe<Order_By>;
  Address2?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  City?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  PhoneNumber?: InputMaybe<Order_By>;
  StateAbbreviation?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  Zip?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Mutation_Response = {
  __typename?: 'ContractMasterAdditionalEntity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractMasterAdditionalEntity>;
};

/** Ordering options when selecting data from "ContractMasterAdditionalEntity". */
export type ContractMasterAdditionalEntity_Order_By = {
  AdditionalEntityTypeCode?: InputMaybe<Order_By>;
  Address1?: InputMaybe<Order_By>;
  Address2?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  City?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  PhoneNumber?: InputMaybe<Order_By>;
  StateAbbreviation?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  Zip?: InputMaybe<Order_By>;
};

/** select columns of table "ContractMasterAdditionalEntity" */
export enum ContractMasterAdditionalEntity_Select_Column {
  /** column name */
  AdditionalEntityTypeCode = 'AdditionalEntityTypeCode',
  /** column name */
  Address1 = 'Address1',
  /** column name */
  Address2 = 'Address2',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  City = 'City',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  Name = 'Name',
  /** column name */
  PhoneNumber = 'PhoneNumber',
  /** column name */
  StateAbbreviation = 'StateAbbreviation',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  Zip = 'Zip'
}

/** input type for updating data in table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Set_Input = {
  AdditionalEntityTypeCode?: InputMaybe<Scalars['String']>;
  Address1?: InputMaybe<Scalars['String']>;
  Address2?: InputMaybe<Scalars['String']>;
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  AgreementSuffix?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  DealerCode?: InputMaybe<Scalars['String']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  Name?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  StateAbbreviation?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
  Zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ContractMasterAdditionalEntity_Stddev_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_stddev_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Stddev_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ContractMasterAdditionalEntity_Stddev_Pop_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_stddev_pop_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Stddev_Pop_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ContractMasterAdditionalEntity_Stddev_Samp_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_stddev_samp_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Stddev_Samp_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type ContractMasterAdditionalEntity_Sum_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_sum_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Sum_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** update columns of table "ContractMasterAdditionalEntity" */
export enum ContractMasterAdditionalEntity_Update_Column {
  /** column name */
  AdditionalEntityTypeCode = 'AdditionalEntityTypeCode',
  /** column name */
  Address1 = 'Address1',
  /** column name */
  Address2 = 'Address2',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  City = 'City',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  Name = 'Name',
  /** column name */
  PhoneNumber = 'PhoneNumber',
  /** column name */
  StateAbbreviation = 'StateAbbreviation',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  Zip = 'Zip'
}

/** aggregate var_pop on columns */
export type ContractMasterAdditionalEntity_Var_Pop_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_var_pop_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Var_Pop_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ContractMasterAdditionalEntity_Var_Samp_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_var_samp_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Var_Samp_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ContractMasterAdditionalEntity_Variance_Fields = {
  __typename?: 'ContractMasterAdditionalEntity_variance_fields';
  AgreementNumber?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ContractMasterAdditionalEntity" */
export type ContractMasterAdditionalEntity_Variance_Order_By = {
  AgreementNumber?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** columns and relationships of "ContractMasterSurcharge" */
export type ContractMasterSurcharge = {
  __typename?: 'ContractMasterSurcharge';
  ActivatedDate: Scalars['Float'];
  AdminAmount: Scalars['Float'];
  AgreementNumber: Scalars['Float'];
  AgreementSuffix: Scalars['String'];
  CancelMethod: Scalars['Float'];
  CancelPercent: Scalars['Float'];
  CancelReturnAmount: Scalars['Float'];
  CancelRule: Scalars['Float'];
  CompanyCode: Scalars['String'];
  ConversionDate: Scalars['Float'];
  ConversionRecordFlag: Scalars['String'];
  DealerCode: Scalars['String'];
  EffectiveDate: Scalars['Float'];
  EnteredBy: Scalars['String'];
  EnteredDate: Scalars['Float'];
  ExpirationDate: Scalars['Float'];
  Misc1Amount: Scalars['Float'];
  Misc2Amount: Scalars['Float'];
  NumberTimesRenewed: Scalars['Float'];
  PostedDate: Scalars['Float'];
  PremiumFlag: Scalars['String'];
  RenewAmount: Scalars['Float'];
  RenewDate: Scalars['Float'];
  RenewDayNumber: Scalars['Float'];
  ReserveAmount: Scalars['Float'];
  ReserveFlag: Scalars['String'];
  RiderFlag: Scalars['String'];
  SequenceNumber: Scalars['Float'];
  SpecialReserveAmount: Scalars['Float'];
  StandardCancelFlag: Scalars['String'];
  StatusCode: Scalars['String'];
  SurchargeCostAmount: Scalars['Float'];
  SurchargeTypeAS400Code: Scalars['String'];
  UpdatedBy: Scalars['String'];
  UpdatedDate: Scalars['Float'];
};

/** aggregated selection of "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Aggregate = {
  __typename?: 'ContractMasterSurcharge_aggregate';
  aggregate?: Maybe<ContractMasterSurcharge_Aggregate_Fields>;
  nodes: Array<ContractMasterSurcharge>;
};

/** aggregate fields of "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Aggregate_Fields = {
  __typename?: 'ContractMasterSurcharge_aggregate_fields';
  avg?: Maybe<ContractMasterSurcharge_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ContractMasterSurcharge_Max_Fields>;
  min?: Maybe<ContractMasterSurcharge_Min_Fields>;
  stddev?: Maybe<ContractMasterSurcharge_Stddev_Fields>;
  stddev_pop?: Maybe<ContractMasterSurcharge_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ContractMasterSurcharge_Stddev_Samp_Fields>;
  sum?: Maybe<ContractMasterSurcharge_Sum_Fields>;
  var_pop?: Maybe<ContractMasterSurcharge_Var_Pop_Fields>;
  var_samp?: Maybe<ContractMasterSurcharge_Var_Samp_Fields>;
  variance?: Maybe<ContractMasterSurcharge_Variance_Fields>;
};


/** aggregate fields of "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<ContractMasterSurcharge_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Aggregate_Order_By = {
  avg?: InputMaybe<ContractMasterSurcharge_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ContractMasterSurcharge_Max_Order_By>;
  min?: InputMaybe<ContractMasterSurcharge_Min_Order_By>;
  stddev?: InputMaybe<ContractMasterSurcharge_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ContractMasterSurcharge_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ContractMasterSurcharge_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ContractMasterSurcharge_Sum_Order_By>;
  var_pop?: InputMaybe<ContractMasterSurcharge_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ContractMasterSurcharge_Var_Samp_Order_By>;
  variance?: InputMaybe<ContractMasterSurcharge_Variance_Order_By>;
};

/** aggregate avg on columns */
export type ContractMasterSurcharge_Avg_Fields = {
  __typename?: 'ContractMasterSurcharge_avg_fields';
  ActivatedDate?: Maybe<Scalars['Float']>;
  AdminAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelPercent?: Maybe<Scalars['Float']>;
  CancelReturnAmount?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  Misc1Amount?: Maybe<Scalars['Float']>;
  Misc2Amount?: Maybe<Scalars['Float']>;
  NumberTimesRenewed?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  RenewAmount?: Maybe<Scalars['Float']>;
  RenewDate?: Maybe<Scalars['Float']>;
  RenewDayNumber?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Avg_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ContractMasterSurcharge". All fields are combined with a logical 'AND'. */
export type ContractMasterSurcharge_Bool_Exp = {
  ActivatedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AdminAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AgreementNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AgreementSuffix?: InputMaybe<String_Mssql_Comparison_Exp>;
  CancelMethod?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelReturnAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelRule?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CompanyCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ConversionDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ConversionRecordFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  DealerCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  EffectiveDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  EnteredBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  EnteredDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ExpirationDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Misc1Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Misc2Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  NumberTimesRenewed?: InputMaybe<Float_Mssql_Comparison_Exp>;
  PostedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  PremiumFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  RenewAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RenewDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RenewDayNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReserveAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReserveFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  RiderFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  SequenceNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  SpecialReserveAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  StandardCancelFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  StatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  SurchargeCostAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  SurchargeTypeAS400Code?: InputMaybe<String_Mssql_Comparison_Exp>;
  UpdatedBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  UpdatedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<ContractMasterSurcharge_Bool_Exp>>;
  _not?: InputMaybe<ContractMasterSurcharge_Bool_Exp>;
  _or?: InputMaybe<Array<ContractMasterSurcharge_Bool_Exp>>;
};

/** upsert condition type for table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_If_Matched = {
  match_columns?: Array<ContractMasterSurcharge_Insert_Match_Column>;
  update_columns?: Array<ContractMasterSurcharge_Update_Column>;
  where?: InputMaybe<ContractMasterSurcharge_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Inc_Input = {
  ActivatedDate?: InputMaybe<Scalars['Float']>;
  AdminAmount?: InputMaybe<Scalars['Float']>;
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  CancelMethod?: InputMaybe<Scalars['Float']>;
  CancelPercent?: InputMaybe<Scalars['Float']>;
  CancelReturnAmount?: InputMaybe<Scalars['Float']>;
  CancelRule?: InputMaybe<Scalars['Float']>;
  ConversionDate?: InputMaybe<Scalars['Float']>;
  EffectiveDate?: InputMaybe<Scalars['Float']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  ExpirationDate?: InputMaybe<Scalars['Float']>;
  Misc1Amount?: InputMaybe<Scalars['Float']>;
  Misc2Amount?: InputMaybe<Scalars['Float']>;
  NumberTimesRenewed?: InputMaybe<Scalars['Float']>;
  PostedDate?: InputMaybe<Scalars['Float']>;
  RenewAmount?: InputMaybe<Scalars['Float']>;
  RenewDate?: InputMaybe<Scalars['Float']>;
  RenewDayNumber?: InputMaybe<Scalars['Float']>;
  ReserveAmount?: InputMaybe<Scalars['Float']>;
  SequenceNumber?: InputMaybe<Scalars['Float']>;
  SpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  SurchargeCostAmount?: InputMaybe<Scalars['Float']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Insert_Input = {
  ActivatedDate?: InputMaybe<Scalars['Float']>;
  AdminAmount?: InputMaybe<Scalars['Float']>;
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  AgreementSuffix?: InputMaybe<Scalars['String']>;
  CancelMethod?: InputMaybe<Scalars['Float']>;
  CancelPercent?: InputMaybe<Scalars['Float']>;
  CancelReturnAmount?: InputMaybe<Scalars['Float']>;
  CancelRule?: InputMaybe<Scalars['Float']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  ConversionDate?: InputMaybe<Scalars['Float']>;
  ConversionRecordFlag?: InputMaybe<Scalars['String']>;
  DealerCode?: InputMaybe<Scalars['String']>;
  EffectiveDate?: InputMaybe<Scalars['Float']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  ExpirationDate?: InputMaybe<Scalars['Float']>;
  Misc1Amount?: InputMaybe<Scalars['Float']>;
  Misc2Amount?: InputMaybe<Scalars['Float']>;
  NumberTimesRenewed?: InputMaybe<Scalars['Float']>;
  PostedDate?: InputMaybe<Scalars['Float']>;
  PremiumFlag?: InputMaybe<Scalars['String']>;
  RenewAmount?: InputMaybe<Scalars['Float']>;
  RenewDate?: InputMaybe<Scalars['Float']>;
  RenewDayNumber?: InputMaybe<Scalars['Float']>;
  ReserveAmount?: InputMaybe<Scalars['Float']>;
  ReserveFlag?: InputMaybe<Scalars['String']>;
  RiderFlag?: InputMaybe<Scalars['String']>;
  SequenceNumber?: InputMaybe<Scalars['Float']>;
  SpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  StandardCancelFlag?: InputMaybe<Scalars['String']>;
  StatusCode?: InputMaybe<Scalars['String']>;
  SurchargeCostAmount?: InputMaybe<Scalars['Float']>;
  SurchargeTypeAS400Code?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
};

/** select match_columns of table "ContractMasterSurcharge" */
export enum ContractMasterSurcharge_Insert_Match_Column {
  /** column name */
  ActivatedDate = 'ActivatedDate',
  /** column name */
  AdminAmount = 'AdminAmount',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  CancelMethod = 'CancelMethod',
  /** column name */
  CancelPercent = 'CancelPercent',
  /** column name */
  CancelReturnAmount = 'CancelReturnAmount',
  /** column name */
  CancelRule = 'CancelRule',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  ConversionDate = 'ConversionDate',
  /** column name */
  ConversionRecordFlag = 'ConversionRecordFlag',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  EffectiveDate = 'EffectiveDate',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  ExpirationDate = 'ExpirationDate',
  /** column name */
  Misc1Amount = 'Misc1Amount',
  /** column name */
  Misc2Amount = 'Misc2Amount',
  /** column name */
  NumberTimesRenewed = 'NumberTimesRenewed',
  /** column name */
  PostedDate = 'PostedDate',
  /** column name */
  PremiumFlag = 'PremiumFlag',
  /** column name */
  RenewAmount = 'RenewAmount',
  /** column name */
  RenewDate = 'RenewDate',
  /** column name */
  RenewDayNumber = 'RenewDayNumber',
  /** column name */
  ReserveAmount = 'ReserveAmount',
  /** column name */
  ReserveFlag = 'ReserveFlag',
  /** column name */
  RiderFlag = 'RiderFlag',
  /** column name */
  SequenceNumber = 'SequenceNumber',
  /** column name */
  SpecialReserveAmount = 'SpecialReserveAmount',
  /** column name */
  StandardCancelFlag = 'StandardCancelFlag',
  /** column name */
  StatusCode = 'StatusCode',
  /** column name */
  SurchargeCostAmount = 'SurchargeCostAmount',
  /** column name */
  SurchargeTypeAs400Code = 'SurchargeTypeAS400Code',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate'
}

/** aggregate max on columns */
export type ContractMasterSurcharge_Max_Fields = {
  __typename?: 'ContractMasterSurcharge_max_fields';
  ActivatedDate?: Maybe<Scalars['Float']>;
  AdminAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AgreementSuffix?: Maybe<Scalars['String']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelPercent?: Maybe<Scalars['Float']>;
  CancelReturnAmount?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  CompanyCode?: Maybe<Scalars['String']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  ConversionRecordFlag?: Maybe<Scalars['String']>;
  DealerCode?: Maybe<Scalars['String']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  Misc1Amount?: Maybe<Scalars['Float']>;
  Misc2Amount?: Maybe<Scalars['Float']>;
  NumberTimesRenewed?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  PremiumFlag?: Maybe<Scalars['String']>;
  RenewAmount?: Maybe<Scalars['Float']>;
  RenewDate?: Maybe<Scalars['Float']>;
  RenewDayNumber?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReserveFlag?: Maybe<Scalars['String']>;
  RiderFlag?: Maybe<Scalars['String']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StandardCancelFlag?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['String']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  SurchargeTypeAS400Code?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by max() on columns of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Max_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  ConversionRecordFlag?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  PremiumFlag?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReserveFlag?: InputMaybe<Order_By>;
  RiderFlag?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StandardCancelFlag?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  SurchargeTypeAS400Code?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ContractMasterSurcharge_Min_Fields = {
  __typename?: 'ContractMasterSurcharge_min_fields';
  ActivatedDate?: Maybe<Scalars['Float']>;
  AdminAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AgreementSuffix?: Maybe<Scalars['String']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelPercent?: Maybe<Scalars['Float']>;
  CancelReturnAmount?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  CompanyCode?: Maybe<Scalars['String']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  ConversionRecordFlag?: Maybe<Scalars['String']>;
  DealerCode?: Maybe<Scalars['String']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  Misc1Amount?: Maybe<Scalars['Float']>;
  Misc2Amount?: Maybe<Scalars['Float']>;
  NumberTimesRenewed?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  PremiumFlag?: Maybe<Scalars['String']>;
  RenewAmount?: Maybe<Scalars['Float']>;
  RenewDate?: Maybe<Scalars['Float']>;
  RenewDayNumber?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReserveFlag?: Maybe<Scalars['String']>;
  RiderFlag?: Maybe<Scalars['String']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StandardCancelFlag?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['String']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  SurchargeTypeAS400Code?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by min() on columns of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Min_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  ConversionRecordFlag?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  PremiumFlag?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReserveFlag?: InputMaybe<Order_By>;
  RiderFlag?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StandardCancelFlag?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  SurchargeTypeAS400Code?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Mutation_Response = {
  __typename?: 'ContractMasterSurcharge_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractMasterSurcharge>;
};

/** Ordering options when selecting data from "ContractMasterSurcharge". */
export type ContractMasterSurcharge_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  ConversionRecordFlag?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  PremiumFlag?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReserveFlag?: InputMaybe<Order_By>;
  RiderFlag?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StandardCancelFlag?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  SurchargeTypeAS400Code?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** select columns of table "ContractMasterSurcharge" */
export enum ContractMasterSurcharge_Select_Column {
  /** column name */
  ActivatedDate = 'ActivatedDate',
  /** column name */
  AdminAmount = 'AdminAmount',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  CancelMethod = 'CancelMethod',
  /** column name */
  CancelPercent = 'CancelPercent',
  /** column name */
  CancelReturnAmount = 'CancelReturnAmount',
  /** column name */
  CancelRule = 'CancelRule',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  ConversionDate = 'ConversionDate',
  /** column name */
  ConversionRecordFlag = 'ConversionRecordFlag',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  EffectiveDate = 'EffectiveDate',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  ExpirationDate = 'ExpirationDate',
  /** column name */
  Misc1Amount = 'Misc1Amount',
  /** column name */
  Misc2Amount = 'Misc2Amount',
  /** column name */
  NumberTimesRenewed = 'NumberTimesRenewed',
  /** column name */
  PostedDate = 'PostedDate',
  /** column name */
  PremiumFlag = 'PremiumFlag',
  /** column name */
  RenewAmount = 'RenewAmount',
  /** column name */
  RenewDate = 'RenewDate',
  /** column name */
  RenewDayNumber = 'RenewDayNumber',
  /** column name */
  ReserveAmount = 'ReserveAmount',
  /** column name */
  ReserveFlag = 'ReserveFlag',
  /** column name */
  RiderFlag = 'RiderFlag',
  /** column name */
  SequenceNumber = 'SequenceNumber',
  /** column name */
  SpecialReserveAmount = 'SpecialReserveAmount',
  /** column name */
  StandardCancelFlag = 'StandardCancelFlag',
  /** column name */
  StatusCode = 'StatusCode',
  /** column name */
  SurchargeCostAmount = 'SurchargeCostAmount',
  /** column name */
  SurchargeTypeAs400Code = 'SurchargeTypeAS400Code',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate'
}

/** input type for updating data in table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Set_Input = {
  ActivatedDate?: InputMaybe<Scalars['Float']>;
  AdminAmount?: InputMaybe<Scalars['Float']>;
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  AgreementSuffix?: InputMaybe<Scalars['String']>;
  CancelMethod?: InputMaybe<Scalars['Float']>;
  CancelPercent?: InputMaybe<Scalars['Float']>;
  CancelReturnAmount?: InputMaybe<Scalars['Float']>;
  CancelRule?: InputMaybe<Scalars['Float']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  ConversionDate?: InputMaybe<Scalars['Float']>;
  ConversionRecordFlag?: InputMaybe<Scalars['String']>;
  DealerCode?: InputMaybe<Scalars['String']>;
  EffectiveDate?: InputMaybe<Scalars['Float']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  ExpirationDate?: InputMaybe<Scalars['Float']>;
  Misc1Amount?: InputMaybe<Scalars['Float']>;
  Misc2Amount?: InputMaybe<Scalars['Float']>;
  NumberTimesRenewed?: InputMaybe<Scalars['Float']>;
  PostedDate?: InputMaybe<Scalars['Float']>;
  PremiumFlag?: InputMaybe<Scalars['String']>;
  RenewAmount?: InputMaybe<Scalars['Float']>;
  RenewDate?: InputMaybe<Scalars['Float']>;
  RenewDayNumber?: InputMaybe<Scalars['Float']>;
  ReserveAmount?: InputMaybe<Scalars['Float']>;
  ReserveFlag?: InputMaybe<Scalars['String']>;
  RiderFlag?: InputMaybe<Scalars['String']>;
  SequenceNumber?: InputMaybe<Scalars['Float']>;
  SpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  StandardCancelFlag?: InputMaybe<Scalars['String']>;
  StatusCode?: InputMaybe<Scalars['String']>;
  SurchargeCostAmount?: InputMaybe<Scalars['Float']>;
  SurchargeTypeAS400Code?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type ContractMasterSurcharge_Stddev_Fields = {
  __typename?: 'ContractMasterSurcharge_stddev_fields';
  ActivatedDate?: Maybe<Scalars['Float']>;
  AdminAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelPercent?: Maybe<Scalars['Float']>;
  CancelReturnAmount?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  Misc1Amount?: Maybe<Scalars['Float']>;
  Misc2Amount?: Maybe<Scalars['Float']>;
  NumberTimesRenewed?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  RenewAmount?: Maybe<Scalars['Float']>;
  RenewDate?: Maybe<Scalars['Float']>;
  RenewDayNumber?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Stddev_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ContractMasterSurcharge_Stddev_Pop_Fields = {
  __typename?: 'ContractMasterSurcharge_stddev_pop_fields';
  ActivatedDate?: Maybe<Scalars['Float']>;
  AdminAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelPercent?: Maybe<Scalars['Float']>;
  CancelReturnAmount?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  Misc1Amount?: Maybe<Scalars['Float']>;
  Misc2Amount?: Maybe<Scalars['Float']>;
  NumberTimesRenewed?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  RenewAmount?: Maybe<Scalars['Float']>;
  RenewDate?: Maybe<Scalars['Float']>;
  RenewDayNumber?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Stddev_Pop_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ContractMasterSurcharge_Stddev_Samp_Fields = {
  __typename?: 'ContractMasterSurcharge_stddev_samp_fields';
  ActivatedDate?: Maybe<Scalars['Float']>;
  AdminAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelPercent?: Maybe<Scalars['Float']>;
  CancelReturnAmount?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  Misc1Amount?: Maybe<Scalars['Float']>;
  Misc2Amount?: Maybe<Scalars['Float']>;
  NumberTimesRenewed?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  RenewAmount?: Maybe<Scalars['Float']>;
  RenewDate?: Maybe<Scalars['Float']>;
  RenewDayNumber?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Stddev_Samp_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type ContractMasterSurcharge_Sum_Fields = {
  __typename?: 'ContractMasterSurcharge_sum_fields';
  ActivatedDate?: Maybe<Scalars['Float']>;
  AdminAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelPercent?: Maybe<Scalars['Float']>;
  CancelReturnAmount?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  Misc1Amount?: Maybe<Scalars['Float']>;
  Misc2Amount?: Maybe<Scalars['Float']>;
  NumberTimesRenewed?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  RenewAmount?: Maybe<Scalars['Float']>;
  RenewDate?: Maybe<Scalars['Float']>;
  RenewDayNumber?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Sum_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** update columns of table "ContractMasterSurcharge" */
export enum ContractMasterSurcharge_Update_Column {
  /** column name */
  ActivatedDate = 'ActivatedDate',
  /** column name */
  AdminAmount = 'AdminAmount',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  CancelMethod = 'CancelMethod',
  /** column name */
  CancelPercent = 'CancelPercent',
  /** column name */
  CancelReturnAmount = 'CancelReturnAmount',
  /** column name */
  CancelRule = 'CancelRule',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  ConversionDate = 'ConversionDate',
  /** column name */
  ConversionRecordFlag = 'ConversionRecordFlag',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  EffectiveDate = 'EffectiveDate',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  ExpirationDate = 'ExpirationDate',
  /** column name */
  Misc1Amount = 'Misc1Amount',
  /** column name */
  Misc2Amount = 'Misc2Amount',
  /** column name */
  NumberTimesRenewed = 'NumberTimesRenewed',
  /** column name */
  PostedDate = 'PostedDate',
  /** column name */
  PremiumFlag = 'PremiumFlag',
  /** column name */
  RenewAmount = 'RenewAmount',
  /** column name */
  RenewDate = 'RenewDate',
  /** column name */
  RenewDayNumber = 'RenewDayNumber',
  /** column name */
  ReserveAmount = 'ReserveAmount',
  /** column name */
  ReserveFlag = 'ReserveFlag',
  /** column name */
  RiderFlag = 'RiderFlag',
  /** column name */
  SequenceNumber = 'SequenceNumber',
  /** column name */
  SpecialReserveAmount = 'SpecialReserveAmount',
  /** column name */
  StandardCancelFlag = 'StandardCancelFlag',
  /** column name */
  StatusCode = 'StatusCode',
  /** column name */
  SurchargeCostAmount = 'SurchargeCostAmount',
  /** column name */
  SurchargeTypeAs400Code = 'SurchargeTypeAS400Code',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate'
}

/** aggregate var_pop on columns */
export type ContractMasterSurcharge_Var_Pop_Fields = {
  __typename?: 'ContractMasterSurcharge_var_pop_fields';
  ActivatedDate?: Maybe<Scalars['Float']>;
  AdminAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelPercent?: Maybe<Scalars['Float']>;
  CancelReturnAmount?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  Misc1Amount?: Maybe<Scalars['Float']>;
  Misc2Amount?: Maybe<Scalars['Float']>;
  NumberTimesRenewed?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  RenewAmount?: Maybe<Scalars['Float']>;
  RenewDate?: Maybe<Scalars['Float']>;
  RenewDayNumber?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Var_Pop_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ContractMasterSurcharge_Var_Samp_Fields = {
  __typename?: 'ContractMasterSurcharge_var_samp_fields';
  ActivatedDate?: Maybe<Scalars['Float']>;
  AdminAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelPercent?: Maybe<Scalars['Float']>;
  CancelReturnAmount?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  Misc1Amount?: Maybe<Scalars['Float']>;
  Misc2Amount?: Maybe<Scalars['Float']>;
  NumberTimesRenewed?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  RenewAmount?: Maybe<Scalars['Float']>;
  RenewDate?: Maybe<Scalars['Float']>;
  RenewDayNumber?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Var_Samp_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ContractMasterSurcharge_Variance_Fields = {
  __typename?: 'ContractMasterSurcharge_variance_fields';
  ActivatedDate?: Maybe<Scalars['Float']>;
  AdminAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelPercent?: Maybe<Scalars['Float']>;
  CancelReturnAmount?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  Misc1Amount?: Maybe<Scalars['Float']>;
  Misc2Amount?: Maybe<Scalars['Float']>;
  NumberTimesRenewed?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  RenewAmount?: Maybe<Scalars['Float']>;
  RenewDate?: Maybe<Scalars['Float']>;
  RenewDayNumber?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ContractMasterSurcharge" */
export type ContractMasterSurcharge_Variance_Order_By = {
  ActivatedDate?: InputMaybe<Order_By>;
  AdminAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelPercent?: InputMaybe<Order_By>;
  CancelReturnAmount?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  Misc1Amount?: InputMaybe<Order_By>;
  Misc2Amount?: InputMaybe<Order_By>;
  NumberTimesRenewed?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  RenewAmount?: InputMaybe<Order_By>;
  RenewDate?: InputMaybe<Order_By>;
  RenewDayNumber?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** aggregated selection of "ContractMaster" */
export type ContractMaster_Aggregate = {
  __typename?: 'ContractMaster_aggregate';
  aggregate?: Maybe<ContractMaster_Aggregate_Fields>;
  nodes: Array<ContractMaster>;
};

/** aggregate fields of "ContractMaster" */
export type ContractMaster_Aggregate_Fields = {
  __typename?: 'ContractMaster_aggregate_fields';
  avg?: Maybe<ContractMaster_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ContractMaster_Max_Fields>;
  min?: Maybe<ContractMaster_Min_Fields>;
  stddev?: Maybe<ContractMaster_Stddev_Fields>;
  stddev_pop?: Maybe<ContractMaster_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ContractMaster_Stddev_Samp_Fields>;
  sum?: Maybe<ContractMaster_Sum_Fields>;
  var_pop?: Maybe<ContractMaster_Var_Pop_Fields>;
  var_samp?: Maybe<ContractMaster_Var_Samp_Fields>;
  variance?: Maybe<ContractMaster_Variance_Fields>;
};


/** aggregate fields of "ContractMaster" */
export type ContractMaster_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<ContractMaster_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ContractMaster" */
export type ContractMaster_Aggregate_Order_By = {
  avg?: InputMaybe<ContractMaster_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ContractMaster_Max_Order_By>;
  min?: InputMaybe<ContractMaster_Min_Order_By>;
  stddev?: InputMaybe<ContractMaster_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ContractMaster_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ContractMaster_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ContractMaster_Sum_Order_By>;
  var_pop?: InputMaybe<ContractMaster_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ContractMaster_Var_Samp_Order_By>;
  variance?: InputMaybe<ContractMaster_Variance_Order_By>;
};

/** aggregate avg on columns */
export type ContractMaster_Avg_Fields = {
  __typename?: 'ContractMaster_avg_fields';
  AccountPostedDate?: Maybe<Scalars['Float']>;
  ActiveFromDate?: Maybe<Scalars['Float']>;
  AdjustedAdminCostAmount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: Maybe<Scalars['Float']>;
  AdjustedReserveAmount?: Maybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: Maybe<Scalars['Float']>;
  AdminCost2Amount?: Maybe<Scalars['Float']>;
  AdminCostAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AllowedTransferNumber?: Maybe<Scalars['Float']>;
  BatchNumber?: Maybe<Scalars['Float']>;
  CanMethod?: Maybe<Scalars['Float']>;
  CanRule?: Maybe<Scalars['Float']>;
  CancelAsOfDate?: Maybe<Scalars['Float']>;
  CancelBatchNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelPostedDate?: Maybe<Scalars['Float']>;
  CancelProcessFromDate?: Maybe<Scalars['Float']>;
  CancelTransferDate?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimCount?: Maybe<Scalars['Float']>;
  ClaimsPaidAmount?: Maybe<Scalars['Float']>;
  ContractMasterID?: Maybe<Scalars['Float']>;
  ContractPurchaseDate?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  CoverageCostAmount?: Maybe<Scalars['Float']>;
  CoverageMiles?: Maybe<Scalars['Float']>;
  CoverageMonths?: Maybe<Scalars['Float']>;
  CoverageOption?: Maybe<Scalars['Float']>;
  CustomerCostAmount?: Maybe<Scalars['Float']>;
  CustomerRefundAmount?: Maybe<Scalars['Float']>;
  CylinderNumber?: Maybe<Scalars['Float']>;
  DealerIncentiveAmount?: Maybe<Scalars['Float']>;
  DealerRefundAmount?: Maybe<Scalars['Float']>;
  DealerRemittedAmount?: Maybe<Scalars['Float']>;
  Deductible?: Maybe<Scalars['Float']>;
  DeniedDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExecAdminCostAmount?: Maybe<Scalars['Float']>;
  ExecMiscCost1Amount?: Maybe<Scalars['Float']>;
  ExecMiscCost2Amount?: Maybe<Scalars['Float']>;
  ExecReserveAmount?: Maybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: Maybe<Scalars['Float']>;
  ExpireMiles?: Maybe<Scalars['Float']>;
  FleetNumber?: Maybe<Scalars['Float']>;
  ForcedRefundAmount?: Maybe<Scalars['Float']>;
  LastClaimMileage?: Maybe<Scalars['Float']>;
  LastTransferDate?: Maybe<Scalars['Float']>;
  LastTransferMileage?: Maybe<Scalars['Float']>;
  MBPIRefundAmount?: Maybe<Scalars['Float']>;
  MaxDaysToPayNumber?: Maybe<Scalars['Float']>;
  MaxPayPerDayAmount?: Maybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: Maybe<Scalars['Float']>;
  MiscCost1Amount?: Maybe<Scalars['Float']>;
  MiscCost2Amount?: Maybe<Scalars['Float']>;
  MiscCost3Amount?: Maybe<Scalars['Float']>;
  MiscCost4Amount?: Maybe<Scalars['Float']>;
  OdometerReading?: Maybe<Scalars['Float']>;
  PolicyModifiedDate?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  ReceivedDate?: Maybe<Scalars['Float']>;
  RefundPercentage?: Maybe<Scalars['Float']>;
  ReinstatedDate?: Maybe<Scalars['Float']>;
  Reserve2Amount?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: Maybe<Scalars['Float']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserve2Amount?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StatusCode?: Maybe<Scalars['Float']>;
  SubmitExpireDate?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  TransferFeeAmount?: Maybe<Scalars['Float']>;
  TransferNumber?: Maybe<Scalars['Float']>;
  TrueExpireDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  VehicleCost?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleMilesWhenCancel?: Maybe<Scalars['Float']>;
  VehiclePurchaseDate?: Maybe<Scalars['Float']>;
  VehicleWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ContractMaster" */
export type ContractMaster_Avg_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ContractMaster". All fields are combined with a logical 'AND'. */
export type ContractMaster_Bool_Exp = {
  AccountPostedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ActiveFromDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ActiveFromDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  AddendumMetadata?: InputMaybe<String_Mssql_Comparison_Exp>;
  Address1?: InputMaybe<String_Mssql_Comparison_Exp>;
  Address2?: InputMaybe<String_Mssql_Comparison_Exp>;
  AdjustedAdminCostAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AdjustedMiscCost1Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AdjustedMiscCost2Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AdjustedReserveAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AdjustedSpecialReserveAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AdminCost2Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AdminCostAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AgreementNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AgreementSuffix?: InputMaybe<String_Mssql_Comparison_Exp>;
  AllowedTransferNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  AlternateFactoryWarrantyFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  BatchKey?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  BatchNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  BookState?: InputMaybe<String_Mssql_Comparison_Exp>;
  CanMethod?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CanRule?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelAsOfDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelAsOfDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  CancelBatchNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelFeeAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelPostedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelProcessFromDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelTransferDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CarrierCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ChecksumColumn?: InputMaybe<Int_Mssql_Comparison_Exp>;
  City?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClaimCount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClaimsPaidAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CompanyCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  CompositeKey?: InputMaybe<String_Mssql_Comparison_Exp>;
  ContractMasterID?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ContractPdfFilename?: InputMaybe<String_Mssql_Comparison_Exp>;
  ContractPurchaseDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ContractPurchaseDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  ConversionDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ConversionRecordFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  CostDetailMetadata?: InputMaybe<String_Mssql_Comparison_Exp>;
  CoverageCostAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CoverageMiles?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CoverageMonths?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CoverageOption?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CoverageTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  CustomerCostAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CustomerRefundAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CylinderNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  DealerAgentOverrageUnderageFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  DealerCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  DealerIncentiveAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  DealerRefundAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  DealerRemittedAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  DealerState?: InputMaybe<String_Mssql_Comparison_Exp>;
  Deductible?: InputMaybe<Float_Mssql_Comparison_Exp>;
  DeniedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  DeniedDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  EnteredBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  EnteredDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ExceptionFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  ExecAdminCostAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ExecMiscCost1Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ExecMiscCost2Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ExecReserveAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ExecSpecialReserveAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ExpireMiles?: InputMaybe<Float_Mssql_Comparison_Exp>;
  FleetNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ForcedAgreementFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  ForcedRefundAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  FormCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  FuelDeliveryCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  FuelTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  GroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  LastClaimMileage?: InputMaybe<Float_Mssql_Comparison_Exp>;
  LastTransferDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  LastTransferDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  LastTransferMileage?: InputMaybe<Float_Mssql_Comparison_Exp>;
  LenderMetadata?: InputMaybe<String_Mssql_Comparison_Exp>;
  MBPIRefundAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  MaxDaysToPayNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  MaxPayPerDayAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  MaxTowingExpenseAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  MiscCost1Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  MiscCost2Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  MiscCost3Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  MiscCost4Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  NewOrUsedCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  NoteMetadata?: InputMaybe<String_Mssql_Comparison_Exp>;
  OdometerReading?: InputMaybe<Float_Mssql_Comparison_Exp>;
  OwnerMetadata?: InputMaybe<String_Mssql_Comparison_Exp>;
  OwnersFirstName?: InputMaybe<String_Mssql_Comparison_Exp>;
  OwnersLastName?: InputMaybe<String_Mssql_Comparison_Exp>;
  PhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  PlanCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  PolicyModifiedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  PolicyTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  PostedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  PostedDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  PostgresSyncUpdateDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  PrimaryAgentCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ProductMetadata?: InputMaybe<String_Mssql_Comparison_Exp>;
  ProgramCarFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  ReceivedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RecordTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  RedoContractPdfFilename?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  RefundPercentage?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReinstatedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReinstatedDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  ReinstatedFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  Reserve2Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReserveAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReturnCancellationToAgentFlag?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReturnCancellationToDealerFlag?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReturnCancellationToOtherFlag?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ReturnFromMailingFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  SSN?: InputMaybe<String_Mssql_Comparison_Exp>;
  SecondaryExpirationDate?: InputMaybe<Date_Mssql_Comparison_Exp>;
  SecondaryExpirationMiles?: InputMaybe<Int_Mssql_Comparison_Exp>;
  SecondaryOwnersFirstName?: InputMaybe<String_Mssql_Comparison_Exp>;
  SecondaryOwnersLastName?: InputMaybe<String_Mssql_Comparison_Exp>;
  SequenceNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  SpecialReserve2Amount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  SpecialReserveAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  StateAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  StatusCode?: InputMaybe<Int_Mssql_Comparison_Exp>;
  SubmitExpireDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  SurchargeCostAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  SyncUpdateDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  TransferFeeAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  TransferNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  TransferTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  TransferredFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  TrueExpireDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  TrueExpireDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  UpdatedBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  UpdatedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  UpgradedFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleClassCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleClassificationCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleCost?: InputMaybe<Float_Mssql_Comparison_Exp>;
  VehicleInServiceDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  VehicleInServiceDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  VehicleMakeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleManufacturerCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleMilesWhenCancel?: InputMaybe<Float_Mssql_Comparison_Exp>;
  VehicleModelCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehiclePurchaseDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  VehiclePurchaseDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  VehicleSeriesName?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleWheelsDriving?: InputMaybe<Float_Mssql_Comparison_Exp>;
  VehicleYear?: InputMaybe<Float_Mssql_Comparison_Exp>;
  VinNotFoundFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  VinNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Zip?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<ContractMaster_Bool_Exp>>;
  _not?: InputMaybe<ContractMaster_Bool_Exp>;
  _or?: InputMaybe<Array<ContractMaster_Bool_Exp>>;
  claims?: InputMaybe<ClaimsMaster_Bool_Exp>;
  contractMasterAdditionalEntities?: InputMaybe<ContractMasterAdditionalEntity_Bool_Exp>;
  contractMasterSurcharges?: InputMaybe<ContractMasterSurcharge_Bool_Exp>;
  dealer?: InputMaybe<Dealer_Bool_Exp>;
  plan?: InputMaybe<Plan_Bool_Exp>;
};

/** upsert condition type for table "ContractMaster" */
export type ContractMaster_If_Matched = {
  match_columns?: Array<ContractMaster_Insert_Match_Column>;
  update_columns?: Array<ContractMaster_Update_Column>;
  where?: InputMaybe<ContractMaster_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "ContractMaster" */
export type ContractMaster_Inc_Input = {
  AccountPostedDate?: InputMaybe<Scalars['Float']>;
  ActiveFromDate?: InputMaybe<Scalars['Float']>;
  AdjustedAdminCostAmount?: InputMaybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: InputMaybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: InputMaybe<Scalars['Float']>;
  AdjustedReserveAmount?: InputMaybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  AdminCost2Amount?: InputMaybe<Scalars['Float']>;
  AdminCostAmount?: InputMaybe<Scalars['Float']>;
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  AllowedTransferNumber?: InputMaybe<Scalars['Float']>;
  BatchNumber?: InputMaybe<Scalars['Float']>;
  CanMethod?: InputMaybe<Scalars['Float']>;
  CanRule?: InputMaybe<Scalars['Float']>;
  CancelAsOfDate?: InputMaybe<Scalars['Float']>;
  CancelBatchNumber?: InputMaybe<Scalars['Float']>;
  CancelFeeAmount?: InputMaybe<Scalars['Float']>;
  CancelPostedDate?: InputMaybe<Scalars['Float']>;
  CancelProcessFromDate?: InputMaybe<Scalars['Float']>;
  CancelTransferDate?: InputMaybe<Scalars['Float']>;
  ChecksumColumn?: InputMaybe<Scalars['Int']>;
  ClaimCount?: InputMaybe<Scalars['Float']>;
  ClaimsPaidAmount?: InputMaybe<Scalars['Float']>;
  ContractPurchaseDate?: InputMaybe<Scalars['Float']>;
  ConversionDate?: InputMaybe<Scalars['Float']>;
  CoverageCostAmount?: InputMaybe<Scalars['Float']>;
  CoverageMiles?: InputMaybe<Scalars['Float']>;
  CoverageMonths?: InputMaybe<Scalars['Float']>;
  CoverageOption?: InputMaybe<Scalars['Float']>;
  CustomerCostAmount?: InputMaybe<Scalars['Float']>;
  CustomerRefundAmount?: InputMaybe<Scalars['Float']>;
  CylinderNumber?: InputMaybe<Scalars['Float']>;
  DealerIncentiveAmount?: InputMaybe<Scalars['Float']>;
  DealerRefundAmount?: InputMaybe<Scalars['Float']>;
  DealerRemittedAmount?: InputMaybe<Scalars['Float']>;
  Deductible?: InputMaybe<Scalars['Float']>;
  DeniedDate?: InputMaybe<Scalars['Float']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  ExecAdminCostAmount?: InputMaybe<Scalars['Float']>;
  ExecMiscCost1Amount?: InputMaybe<Scalars['Float']>;
  ExecMiscCost2Amount?: InputMaybe<Scalars['Float']>;
  ExecReserveAmount?: InputMaybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  ExpireMiles?: InputMaybe<Scalars['Float']>;
  FleetNumber?: InputMaybe<Scalars['Float']>;
  ForcedRefundAmount?: InputMaybe<Scalars['Float']>;
  LastClaimMileage?: InputMaybe<Scalars['Float']>;
  LastTransferDate?: InputMaybe<Scalars['Float']>;
  LastTransferMileage?: InputMaybe<Scalars['Float']>;
  MBPIRefundAmount?: InputMaybe<Scalars['Float']>;
  MaxDaysToPayNumber?: InputMaybe<Scalars['Float']>;
  MaxPayPerDayAmount?: InputMaybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: InputMaybe<Scalars['Float']>;
  MiscCost1Amount?: InputMaybe<Scalars['Float']>;
  MiscCost2Amount?: InputMaybe<Scalars['Float']>;
  MiscCost3Amount?: InputMaybe<Scalars['Float']>;
  MiscCost4Amount?: InputMaybe<Scalars['Float']>;
  OdometerReading?: InputMaybe<Scalars['Float']>;
  PolicyModifiedDate?: InputMaybe<Scalars['Float']>;
  PostedDate?: InputMaybe<Scalars['Float']>;
  ReceivedDate?: InputMaybe<Scalars['Float']>;
  RefundPercentage?: InputMaybe<Scalars['Float']>;
  ReinstatedDate?: InputMaybe<Scalars['Float']>;
  Reserve2Amount?: InputMaybe<Scalars['Float']>;
  ReserveAmount?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: InputMaybe<Scalars['Float']>;
  SecondaryExpirationMiles?: InputMaybe<Scalars['Int']>;
  SequenceNumber?: InputMaybe<Scalars['Float']>;
  SpecialReserve2Amount?: InputMaybe<Scalars['Float']>;
  SpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  StatusCode?: InputMaybe<Scalars['Int']>;
  SubmitExpireDate?: InputMaybe<Scalars['Float']>;
  SurchargeCostAmount?: InputMaybe<Scalars['Float']>;
  TransferFeeAmount?: InputMaybe<Scalars['Float']>;
  TransferNumber?: InputMaybe<Scalars['Float']>;
  TrueExpireDate?: InputMaybe<Scalars['Float']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
  VehicleCost?: InputMaybe<Scalars['Float']>;
  VehicleInServiceDate?: InputMaybe<Scalars['Float']>;
  VehicleMilesWhenCancel?: InputMaybe<Scalars['Float']>;
  VehiclePurchaseDate?: InputMaybe<Scalars['Float']>;
  VehicleWheelsDriving?: InputMaybe<Scalars['Float']>;
  VehicleYear?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "ContractMaster" */
export type ContractMaster_Insert_Input = {
  AccountPostedDate?: InputMaybe<Scalars['Float']>;
  ActiveFromDate?: InputMaybe<Scalars['Float']>;
  ActiveFromDateComputed?: InputMaybe<Scalars['date']>;
  AddendumMetadata?: InputMaybe<Scalars['String']>;
  Address1?: InputMaybe<Scalars['String']>;
  Address2?: InputMaybe<Scalars['String']>;
  AdjustedAdminCostAmount?: InputMaybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: InputMaybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: InputMaybe<Scalars['Float']>;
  AdjustedReserveAmount?: InputMaybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  AdminCost2Amount?: InputMaybe<Scalars['Float']>;
  AdminCostAmount?: InputMaybe<Scalars['Float']>;
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  AgreementSuffix?: InputMaybe<Scalars['String']>;
  AllowedTransferNumber?: InputMaybe<Scalars['Float']>;
  AlternateFactoryWarrantyFlag?: InputMaybe<Scalars['String']>;
  BatchKey?: InputMaybe<Scalars['uniqueidentifier']>;
  BatchNumber?: InputMaybe<Scalars['Float']>;
  BookState?: InputMaybe<Scalars['String']>;
  CanMethod?: InputMaybe<Scalars['Float']>;
  CanRule?: InputMaybe<Scalars['Float']>;
  CancelAsOfDate?: InputMaybe<Scalars['Float']>;
  CancelAsOfDateComputed?: InputMaybe<Scalars['date']>;
  CancelBatchNumber?: InputMaybe<Scalars['Float']>;
  CancelFeeAmount?: InputMaybe<Scalars['Float']>;
  CancelPostedDate?: InputMaybe<Scalars['Float']>;
  CancelProcessFromDate?: InputMaybe<Scalars['Float']>;
  CancelTransferDate?: InputMaybe<Scalars['Float']>;
  CarrierCode?: InputMaybe<Scalars['String']>;
  ChecksumColumn?: InputMaybe<Scalars['Int']>;
  City?: InputMaybe<Scalars['String']>;
  ClaimCount?: InputMaybe<Scalars['Float']>;
  ClaimsPaidAmount?: InputMaybe<Scalars['Float']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  ContractPdfFilename?: InputMaybe<Scalars['String']>;
  ContractPurchaseDate?: InputMaybe<Scalars['Float']>;
  ContractPurchaseDateComputed?: InputMaybe<Scalars['date']>;
  ConversionDate?: InputMaybe<Scalars['Float']>;
  ConversionRecordFlag?: InputMaybe<Scalars['String']>;
  CostDetailMetadata?: InputMaybe<Scalars['String']>;
  CoverageCostAmount?: InputMaybe<Scalars['Float']>;
  CoverageMiles?: InputMaybe<Scalars['Float']>;
  CoverageMonths?: InputMaybe<Scalars['Float']>;
  CoverageOption?: InputMaybe<Scalars['Float']>;
  CoverageTypeCode?: InputMaybe<Scalars['String']>;
  CustomerCostAmount?: InputMaybe<Scalars['Float']>;
  CustomerRefundAmount?: InputMaybe<Scalars['Float']>;
  CylinderNumber?: InputMaybe<Scalars['Float']>;
  DealerAgentOverrageUnderageFlag?: InputMaybe<Scalars['String']>;
  DealerCode?: InputMaybe<Scalars['String']>;
  DealerIncentiveAmount?: InputMaybe<Scalars['Float']>;
  DealerRefundAmount?: InputMaybe<Scalars['Float']>;
  DealerRemittedAmount?: InputMaybe<Scalars['Float']>;
  DealerState?: InputMaybe<Scalars['String']>;
  Deductible?: InputMaybe<Scalars['Float']>;
  DeniedDate?: InputMaybe<Scalars['Float']>;
  DeniedDateComputed?: InputMaybe<Scalars['date']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  ExceptionFlag?: InputMaybe<Scalars['String']>;
  ExecAdminCostAmount?: InputMaybe<Scalars['Float']>;
  ExecMiscCost1Amount?: InputMaybe<Scalars['Float']>;
  ExecMiscCost2Amount?: InputMaybe<Scalars['Float']>;
  ExecReserveAmount?: InputMaybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  ExpireMiles?: InputMaybe<Scalars['Float']>;
  FleetNumber?: InputMaybe<Scalars['Float']>;
  ForcedAgreementFlag?: InputMaybe<Scalars['String']>;
  ForcedRefundAmount?: InputMaybe<Scalars['Float']>;
  FormCode?: InputMaybe<Scalars['String']>;
  FuelDeliveryCode?: InputMaybe<Scalars['String']>;
  FuelTypeCode?: InputMaybe<Scalars['String']>;
  GroupCode?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['uniqueidentifier']>;
  LastClaimMileage?: InputMaybe<Scalars['Float']>;
  LastTransferDate?: InputMaybe<Scalars['Float']>;
  LastTransferDateComputed?: InputMaybe<Scalars['date']>;
  LastTransferMileage?: InputMaybe<Scalars['Float']>;
  LenderMetadata?: InputMaybe<Scalars['String']>;
  MBPIRefundAmount?: InputMaybe<Scalars['Float']>;
  MaxDaysToPayNumber?: InputMaybe<Scalars['Float']>;
  MaxPayPerDayAmount?: InputMaybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: InputMaybe<Scalars['Float']>;
  MiscCost1Amount?: InputMaybe<Scalars['Float']>;
  MiscCost2Amount?: InputMaybe<Scalars['Float']>;
  MiscCost3Amount?: InputMaybe<Scalars['Float']>;
  MiscCost4Amount?: InputMaybe<Scalars['Float']>;
  NewOrUsedCode?: InputMaybe<Scalars['String']>;
  NoteMetadata?: InputMaybe<Scalars['String']>;
  OdometerReading?: InputMaybe<Scalars['Float']>;
  OwnerMetadata?: InputMaybe<Scalars['String']>;
  OwnersFirstName?: InputMaybe<Scalars['String']>;
  OwnersLastName?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  PlanCode?: InputMaybe<Scalars['String']>;
  PolicyModifiedDate?: InputMaybe<Scalars['Float']>;
  PolicyTypeCode?: InputMaybe<Scalars['String']>;
  PostedDate?: InputMaybe<Scalars['Float']>;
  PostedDateComputed?: InputMaybe<Scalars['date']>;
  PostgresSyncUpdateDate?: InputMaybe<Scalars['datetime']>;
  PrimaryAgentCode?: InputMaybe<Scalars['String']>;
  ProductMetadata?: InputMaybe<Scalars['String']>;
  ProgramCarFlag?: InputMaybe<Scalars['String']>;
  ReceivedDate?: InputMaybe<Scalars['Float']>;
  RecordTypeCode?: InputMaybe<Scalars['String']>;
  RedoContractPdfFilename?: InputMaybe<Scalars['Boolean']>;
  RefundPercentage?: InputMaybe<Scalars['Float']>;
  ReinstatedDate?: InputMaybe<Scalars['Float']>;
  ReinstatedDateComputed?: InputMaybe<Scalars['date']>;
  ReinstatedFlag?: InputMaybe<Scalars['String']>;
  Reserve2Amount?: InputMaybe<Scalars['Float']>;
  ReserveAmount?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: InputMaybe<Scalars['Float']>;
  ReturnFromMailingFlag?: InputMaybe<Scalars['String']>;
  SSN?: InputMaybe<Scalars['String']>;
  SecondaryExpirationDate?: InputMaybe<Scalars['date']>;
  SecondaryExpirationMiles?: InputMaybe<Scalars['Int']>;
  SecondaryOwnersFirstName?: InputMaybe<Scalars['String']>;
  SecondaryOwnersLastName?: InputMaybe<Scalars['String']>;
  SequenceNumber?: InputMaybe<Scalars['Float']>;
  SpecialReserve2Amount?: InputMaybe<Scalars['Float']>;
  SpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  StateAbbreviation?: InputMaybe<Scalars['String']>;
  StatusCode?: InputMaybe<Scalars['Int']>;
  SubmitExpireDate?: InputMaybe<Scalars['Float']>;
  SurchargeCostAmount?: InputMaybe<Scalars['Float']>;
  SyncUpdateDate?: InputMaybe<Scalars['datetime']>;
  TransferFeeAmount?: InputMaybe<Scalars['Float']>;
  TransferNumber?: InputMaybe<Scalars['Float']>;
  TransferTypeCode?: InputMaybe<Scalars['String']>;
  TransferredFlag?: InputMaybe<Scalars['String']>;
  TrueExpireDate?: InputMaybe<Scalars['Float']>;
  TrueExpireDateComputed?: InputMaybe<Scalars['date']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
  UpgradedFlag?: InputMaybe<Scalars['String']>;
  VehicleClassCode?: InputMaybe<Scalars['String']>;
  VehicleClassificationCode?: InputMaybe<Scalars['String']>;
  VehicleCost?: InputMaybe<Scalars['Float']>;
  VehicleInServiceDate?: InputMaybe<Scalars['Float']>;
  VehicleInServiceDateComputed?: InputMaybe<Scalars['date']>;
  VehicleMakeCode?: InputMaybe<Scalars['String']>;
  VehicleManufacturerCode?: InputMaybe<Scalars['String']>;
  VehicleMilesWhenCancel?: InputMaybe<Scalars['Float']>;
  VehicleModelCode?: InputMaybe<Scalars['String']>;
  VehiclePurchaseDate?: InputMaybe<Scalars['Float']>;
  VehiclePurchaseDateComputed?: InputMaybe<Scalars['date']>;
  VehicleSeriesName?: InputMaybe<Scalars['String']>;
  VehicleWheelsDriving?: InputMaybe<Scalars['Float']>;
  VehicleYear?: InputMaybe<Scalars['Float']>;
  VinNotFoundFlag?: InputMaybe<Scalars['String']>;
  VinNumber?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
};

/** select match_columns of table "ContractMaster" */
export enum ContractMaster_Insert_Match_Column {
  /** column name */
  AccountPostedDate = 'AccountPostedDate',
  /** column name */
  ActiveFromDate = 'ActiveFromDate',
  /** column name */
  ActiveFromDateComputed = 'ActiveFromDateComputed',
  /** column name */
  AddendumMetadata = 'AddendumMetadata',
  /** column name */
  Address1 = 'Address1',
  /** column name */
  Address2 = 'Address2',
  /** column name */
  AdjustedAdminCostAmount = 'AdjustedAdminCostAmount',
  /** column name */
  AdjustedMiscCost1Amount = 'AdjustedMiscCost1Amount',
  /** column name */
  AdjustedMiscCost2Amount = 'AdjustedMiscCost2Amount',
  /** column name */
  AdjustedReserveAmount = 'AdjustedReserveAmount',
  /** column name */
  AdjustedSpecialReserveAmount = 'AdjustedSpecialReserveAmount',
  /** column name */
  AdminCost2Amount = 'AdminCost2Amount',
  /** column name */
  AdminCostAmount = 'AdminCostAmount',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  AllowedTransferNumber = 'AllowedTransferNumber',
  /** column name */
  AlternateFactoryWarrantyFlag = 'AlternateFactoryWarrantyFlag',
  /** column name */
  BatchKey = 'BatchKey',
  /** column name */
  BatchNumber = 'BatchNumber',
  /** column name */
  BookState = 'BookState',
  /** column name */
  CanMethod = 'CanMethod',
  /** column name */
  CanRule = 'CanRule',
  /** column name */
  CancelAsOfDate = 'CancelAsOfDate',
  /** column name */
  CancelAsOfDateComputed = 'CancelAsOfDateComputed',
  /** column name */
  CancelBatchNumber = 'CancelBatchNumber',
  /** column name */
  CancelFeeAmount = 'CancelFeeAmount',
  /** column name */
  CancelPostedDate = 'CancelPostedDate',
  /** column name */
  CancelProcessFromDate = 'CancelProcessFromDate',
  /** column name */
  CancelTransferDate = 'CancelTransferDate',
  /** column name */
  CarrierCode = 'CarrierCode',
  /** column name */
  ChecksumColumn = 'ChecksumColumn',
  /** column name */
  City = 'City',
  /** column name */
  ClaimCount = 'ClaimCount',
  /** column name */
  ClaimsPaidAmount = 'ClaimsPaidAmount',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  CompositeKey = 'CompositeKey',
  /** column name */
  ContractMasterId = 'ContractMasterID',
  /** column name */
  ContractPdfFilename = 'ContractPdfFilename',
  /** column name */
  ContractPurchaseDate = 'ContractPurchaseDate',
  /** column name */
  ContractPurchaseDateComputed = 'ContractPurchaseDateComputed',
  /** column name */
  ConversionDate = 'ConversionDate',
  /** column name */
  ConversionRecordFlag = 'ConversionRecordFlag',
  /** column name */
  CostDetailMetadata = 'CostDetailMetadata',
  /** column name */
  CoverageCostAmount = 'CoverageCostAmount',
  /** column name */
  CoverageMiles = 'CoverageMiles',
  /** column name */
  CoverageMonths = 'CoverageMonths',
  /** column name */
  CoverageOption = 'CoverageOption',
  /** column name */
  CoverageTypeCode = 'CoverageTypeCode',
  /** column name */
  CustomerCostAmount = 'CustomerCostAmount',
  /** column name */
  CustomerRefundAmount = 'CustomerRefundAmount',
  /** column name */
  CylinderNumber = 'CylinderNumber',
  /** column name */
  DealerAgentOverrageUnderageFlag = 'DealerAgentOverrageUnderageFlag',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  DealerIncentiveAmount = 'DealerIncentiveAmount',
  /** column name */
  DealerRefundAmount = 'DealerRefundAmount',
  /** column name */
  DealerRemittedAmount = 'DealerRemittedAmount',
  /** column name */
  DealerState = 'DealerState',
  /** column name */
  Deductible = 'Deductible',
  /** column name */
  DeniedDate = 'DeniedDate',
  /** column name */
  DeniedDateComputed = 'DeniedDateComputed',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  ExceptionFlag = 'ExceptionFlag',
  /** column name */
  ExecAdminCostAmount = 'ExecAdminCostAmount',
  /** column name */
  ExecMiscCost1Amount = 'ExecMiscCost1Amount',
  /** column name */
  ExecMiscCost2Amount = 'ExecMiscCost2Amount',
  /** column name */
  ExecReserveAmount = 'ExecReserveAmount',
  /** column name */
  ExecSpecialReserveAmount = 'ExecSpecialReserveAmount',
  /** column name */
  ExpireMiles = 'ExpireMiles',
  /** column name */
  FleetNumber = 'FleetNumber',
  /** column name */
  ForcedAgreementFlag = 'ForcedAgreementFlag',
  /** column name */
  ForcedRefundAmount = 'ForcedRefundAmount',
  /** column name */
  FormCode = 'FormCode',
  /** column name */
  FuelDeliveryCode = 'FuelDeliveryCode',
  /** column name */
  FuelTypeCode = 'FuelTypeCode',
  /** column name */
  GroupCode = 'GroupCode',
  /** column name */
  Id = 'ID',
  /** column name */
  LastClaimMileage = 'LastClaimMileage',
  /** column name */
  LastTransferDate = 'LastTransferDate',
  /** column name */
  LastTransferDateComputed = 'LastTransferDateComputed',
  /** column name */
  LastTransferMileage = 'LastTransferMileage',
  /** column name */
  LenderMetadata = 'LenderMetadata',
  /** column name */
  MbpiRefundAmount = 'MBPIRefundAmount',
  /** column name */
  MaxDaysToPayNumber = 'MaxDaysToPayNumber',
  /** column name */
  MaxPayPerDayAmount = 'MaxPayPerDayAmount',
  /** column name */
  MaxTowingExpenseAmount = 'MaxTowingExpenseAmount',
  /** column name */
  MiscCost1Amount = 'MiscCost1Amount',
  /** column name */
  MiscCost2Amount = 'MiscCost2Amount',
  /** column name */
  MiscCost3Amount = 'MiscCost3Amount',
  /** column name */
  MiscCost4Amount = 'MiscCost4Amount',
  /** column name */
  NewOrUsedCode = 'NewOrUsedCode',
  /** column name */
  NoteMetadata = 'NoteMetadata',
  /** column name */
  OdometerReading = 'OdometerReading',
  /** column name */
  OwnerMetadata = 'OwnerMetadata',
  /** column name */
  OwnersFirstName = 'OwnersFirstName',
  /** column name */
  OwnersLastName = 'OwnersLastName',
  /** column name */
  PhoneNumber = 'PhoneNumber',
  /** column name */
  PlanCode = 'PlanCode',
  /** column name */
  PolicyModifiedDate = 'PolicyModifiedDate',
  /** column name */
  PolicyTypeCode = 'PolicyTypeCode',
  /** column name */
  PostedDate = 'PostedDate',
  /** column name */
  PostedDateComputed = 'PostedDateComputed',
  /** column name */
  PostgresSyncUpdateDate = 'PostgresSyncUpdateDate',
  /** column name */
  PrimaryAgentCode = 'PrimaryAgentCode',
  /** column name */
  ProductMetadata = 'ProductMetadata',
  /** column name */
  ProgramCarFlag = 'ProgramCarFlag',
  /** column name */
  ReceivedDate = 'ReceivedDate',
  /** column name */
  RecordTypeCode = 'RecordTypeCode',
  /** column name */
  RedoContractPdfFilename = 'RedoContractPdfFilename',
  /** column name */
  RefundPercentage = 'RefundPercentage',
  /** column name */
  ReinstatedDate = 'ReinstatedDate',
  /** column name */
  ReinstatedDateComputed = 'ReinstatedDateComputed',
  /** column name */
  ReinstatedFlag = 'ReinstatedFlag',
  /** column name */
  Reserve2Amount = 'Reserve2Amount',
  /** column name */
  ReserveAmount = 'ReserveAmount',
  /** column name */
  ReturnCancellationToAgentFlag = 'ReturnCancellationToAgentFlag',
  /** column name */
  ReturnCancellationToCustomerFlag = 'ReturnCancellationToCustomerFlag',
  /** column name */
  ReturnCancellationToDealerFlag = 'ReturnCancellationToDealerFlag',
  /** column name */
  ReturnCancellationToFinancialInstFlag = 'ReturnCancellationToFinancialInstFlag',
  /** column name */
  ReturnCancellationToLeinHolderFlag = 'ReturnCancellationToLeinHolderFlag',
  /** column name */
  ReturnCancellationToOtherFlag = 'ReturnCancellationToOtherFlag',
  /** column name */
  ReturnFromMailingFlag = 'ReturnFromMailingFlag',
  /** column name */
  Ssn = 'SSN',
  /** column name */
  SecondaryExpirationDate = 'SecondaryExpirationDate',
  /** column name */
  SecondaryExpirationMiles = 'SecondaryExpirationMiles',
  /** column name */
  SecondaryOwnersFirstName = 'SecondaryOwnersFirstName',
  /** column name */
  SecondaryOwnersLastName = 'SecondaryOwnersLastName',
  /** column name */
  SequenceNumber = 'SequenceNumber',
  /** column name */
  SpecialReserve2Amount = 'SpecialReserve2Amount',
  /** column name */
  SpecialReserveAmount = 'SpecialReserveAmount',
  /** column name */
  StateAbbreviation = 'StateAbbreviation',
  /** column name */
  StatusCode = 'StatusCode',
  /** column name */
  SubmitExpireDate = 'SubmitExpireDate',
  /** column name */
  SurchargeCostAmount = 'SurchargeCostAmount',
  /** column name */
  SyncUpdateDate = 'SyncUpdateDate',
  /** column name */
  TransferFeeAmount = 'TransferFeeAmount',
  /** column name */
  TransferNumber = 'TransferNumber',
  /** column name */
  TransferTypeCode = 'TransferTypeCode',
  /** column name */
  TransferredFlag = 'TransferredFlag',
  /** column name */
  TrueExpireDate = 'TrueExpireDate',
  /** column name */
  TrueExpireDateComputed = 'TrueExpireDateComputed',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  UpgradedFlag = 'UpgradedFlag',
  /** column name */
  VehicleClassCode = 'VehicleClassCode',
  /** column name */
  VehicleClassificationCode = 'VehicleClassificationCode',
  /** column name */
  VehicleCost = 'VehicleCost',
  /** column name */
  VehicleInServiceDate = 'VehicleInServiceDate',
  /** column name */
  VehicleInServiceDateComputed = 'VehicleInServiceDateComputed',
  /** column name */
  VehicleMakeCode = 'VehicleMakeCode',
  /** column name */
  VehicleManufacturerCode = 'VehicleManufacturerCode',
  /** column name */
  VehicleMilesWhenCancel = 'VehicleMilesWhenCancel',
  /** column name */
  VehicleModelCode = 'VehicleModelCode',
  /** column name */
  VehiclePurchaseDate = 'VehiclePurchaseDate',
  /** column name */
  VehiclePurchaseDateComputed = 'VehiclePurchaseDateComputed',
  /** column name */
  VehicleSeriesName = 'VehicleSeriesName',
  /** column name */
  VehicleWheelsDriving = 'VehicleWheelsDriving',
  /** column name */
  VehicleYear = 'VehicleYear',
  /** column name */
  VinNotFoundFlag = 'VinNotFoundFlag',
  /** column name */
  VinNumber = 'VinNumber',
  /** column name */
  Zip = 'Zip'
}

/** aggregate max on columns */
export type ContractMaster_Max_Fields = {
  __typename?: 'ContractMaster_max_fields';
  AccountPostedDate?: Maybe<Scalars['Float']>;
  ActiveFromDate?: Maybe<Scalars['Float']>;
  ActiveFromDateComputed?: Maybe<Scalars['date']>;
  AddendumMetadata?: Maybe<Scalars['String']>;
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  AdjustedAdminCostAmount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: Maybe<Scalars['Float']>;
  AdjustedReserveAmount?: Maybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: Maybe<Scalars['Float']>;
  AdminCost2Amount?: Maybe<Scalars['Float']>;
  AdminCostAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AgreementSuffix?: Maybe<Scalars['String']>;
  AllowedTransferNumber?: Maybe<Scalars['Float']>;
  AlternateFactoryWarrantyFlag?: Maybe<Scalars['String']>;
  BatchNumber?: Maybe<Scalars['Float']>;
  BookState?: Maybe<Scalars['String']>;
  CanMethod?: Maybe<Scalars['Float']>;
  CanRule?: Maybe<Scalars['Float']>;
  CancelAsOfDate?: Maybe<Scalars['Float']>;
  CancelAsOfDateComputed?: Maybe<Scalars['date']>;
  CancelBatchNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelPostedDate?: Maybe<Scalars['Float']>;
  CancelProcessFromDate?: Maybe<Scalars['Float']>;
  CancelTransferDate?: Maybe<Scalars['Float']>;
  CarrierCode?: Maybe<Scalars['String']>;
  ChecksumColumn?: Maybe<Scalars['Int']>;
  City?: Maybe<Scalars['String']>;
  ClaimCount?: Maybe<Scalars['Float']>;
  ClaimsPaidAmount?: Maybe<Scalars['Float']>;
  CompanyCode?: Maybe<Scalars['String']>;
  CompositeKey?: Maybe<Scalars['String']>;
  ContractMasterID?: Maybe<Scalars['Int']>;
  ContractPdfFilename?: Maybe<Scalars['String']>;
  ContractPurchaseDate?: Maybe<Scalars['Float']>;
  ContractPurchaseDateComputed?: Maybe<Scalars['date']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  ConversionRecordFlag?: Maybe<Scalars['String']>;
  CostDetailMetadata?: Maybe<Scalars['String']>;
  CoverageCostAmount?: Maybe<Scalars['Float']>;
  CoverageMiles?: Maybe<Scalars['Float']>;
  CoverageMonths?: Maybe<Scalars['Float']>;
  CoverageOption?: Maybe<Scalars['Float']>;
  CoverageTypeCode?: Maybe<Scalars['String']>;
  CustomerCostAmount?: Maybe<Scalars['Float']>;
  CustomerRefundAmount?: Maybe<Scalars['Float']>;
  CylinderNumber?: Maybe<Scalars['Float']>;
  DealerAgentOverrageUnderageFlag?: Maybe<Scalars['String']>;
  DealerCode?: Maybe<Scalars['String']>;
  DealerIncentiveAmount?: Maybe<Scalars['Float']>;
  DealerRefundAmount?: Maybe<Scalars['Float']>;
  DealerRemittedAmount?: Maybe<Scalars['Float']>;
  DealerState?: Maybe<Scalars['String']>;
  Deductible?: Maybe<Scalars['Float']>;
  DeniedDate?: Maybe<Scalars['Float']>;
  DeniedDateComputed?: Maybe<Scalars['date']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExceptionFlag?: Maybe<Scalars['String']>;
  ExecAdminCostAmount?: Maybe<Scalars['Float']>;
  ExecMiscCost1Amount?: Maybe<Scalars['Float']>;
  ExecMiscCost2Amount?: Maybe<Scalars['Float']>;
  ExecReserveAmount?: Maybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: Maybe<Scalars['Float']>;
  ExpireMiles?: Maybe<Scalars['Float']>;
  FleetNumber?: Maybe<Scalars['Float']>;
  ForcedAgreementFlag?: Maybe<Scalars['String']>;
  ForcedRefundAmount?: Maybe<Scalars['Float']>;
  FormCode?: Maybe<Scalars['String']>;
  FuelDeliveryCode?: Maybe<Scalars['String']>;
  FuelTypeCode?: Maybe<Scalars['String']>;
  GroupCode?: Maybe<Scalars['String']>;
  LastClaimMileage?: Maybe<Scalars['Float']>;
  LastTransferDate?: Maybe<Scalars['Float']>;
  LastTransferDateComputed?: Maybe<Scalars['date']>;
  LastTransferMileage?: Maybe<Scalars['Float']>;
  LenderMetadata?: Maybe<Scalars['String']>;
  MBPIRefundAmount?: Maybe<Scalars['Float']>;
  MaxDaysToPayNumber?: Maybe<Scalars['Float']>;
  MaxPayPerDayAmount?: Maybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: Maybe<Scalars['Float']>;
  MiscCost1Amount?: Maybe<Scalars['Float']>;
  MiscCost2Amount?: Maybe<Scalars['Float']>;
  MiscCost3Amount?: Maybe<Scalars['Float']>;
  MiscCost4Amount?: Maybe<Scalars['Float']>;
  NewOrUsedCode?: Maybe<Scalars['String']>;
  NoteMetadata?: Maybe<Scalars['String']>;
  OdometerReading?: Maybe<Scalars['Float']>;
  OwnerMetadata?: Maybe<Scalars['String']>;
  OwnersFirstName?: Maybe<Scalars['String']>;
  OwnersLastName?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  PlanCode?: Maybe<Scalars['String']>;
  PolicyModifiedDate?: Maybe<Scalars['Float']>;
  PolicyTypeCode?: Maybe<Scalars['String']>;
  PostedDate?: Maybe<Scalars['Float']>;
  PostedDateComputed?: Maybe<Scalars['date']>;
  PostgresSyncUpdateDate?: Maybe<Scalars['datetime']>;
  PrimaryAgentCode?: Maybe<Scalars['String']>;
  ProductMetadata?: Maybe<Scalars['String']>;
  ProgramCarFlag?: Maybe<Scalars['String']>;
  ReceivedDate?: Maybe<Scalars['Float']>;
  RecordTypeCode?: Maybe<Scalars['String']>;
  RefundPercentage?: Maybe<Scalars['Float']>;
  ReinstatedDate?: Maybe<Scalars['Float']>;
  ReinstatedDateComputed?: Maybe<Scalars['date']>;
  ReinstatedFlag?: Maybe<Scalars['String']>;
  Reserve2Amount?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: Maybe<Scalars['Float']>;
  ReturnFromMailingFlag?: Maybe<Scalars['String']>;
  SSN?: Maybe<Scalars['String']>;
  SecondaryExpirationDate?: Maybe<Scalars['date']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Int']>;
  SecondaryOwnersFirstName?: Maybe<Scalars['String']>;
  SecondaryOwnersLastName?: Maybe<Scalars['String']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserve2Amount?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StateAbbreviation?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['Int']>;
  SubmitExpireDate?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  SyncUpdateDate?: Maybe<Scalars['datetime']>;
  TransferFeeAmount?: Maybe<Scalars['Float']>;
  TransferNumber?: Maybe<Scalars['Float']>;
  TransferTypeCode?: Maybe<Scalars['String']>;
  TransferredFlag?: Maybe<Scalars['String']>;
  TrueExpireDate?: Maybe<Scalars['Float']>;
  TrueExpireDateComputed?: Maybe<Scalars['date']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpgradedFlag?: Maybe<Scalars['String']>;
  VehicleClassCode?: Maybe<Scalars['String']>;
  VehicleClassificationCode?: Maybe<Scalars['String']>;
  VehicleCost?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleInServiceDateComputed?: Maybe<Scalars['date']>;
  VehicleMakeCode?: Maybe<Scalars['String']>;
  VehicleManufacturerCode?: Maybe<Scalars['String']>;
  VehicleMilesWhenCancel?: Maybe<Scalars['Float']>;
  VehicleModelCode?: Maybe<Scalars['String']>;
  VehiclePurchaseDate?: Maybe<Scalars['Float']>;
  VehiclePurchaseDateComputed?: Maybe<Scalars['date']>;
  VehicleSeriesName?: Maybe<Scalars['String']>;
  VehicleWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
  VinNotFoundFlag?: Maybe<Scalars['String']>;
  VinNumber?: Maybe<Scalars['String']>;
  Zip?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ContractMaster" */
export type ContractMaster_Max_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  ActiveFromDateComputed?: InputMaybe<Order_By>;
  AddendumMetadata?: InputMaybe<Order_By>;
  Address1?: InputMaybe<Order_By>;
  Address2?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  AlternateFactoryWarrantyFlag?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  BookState?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelAsOfDateComputed?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  CarrierCode?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  City?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  CompositeKey?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPdfFilename?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ContractPurchaseDateComputed?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  ConversionRecordFlag?: InputMaybe<Order_By>;
  CostDetailMetadata?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CoverageTypeCode?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerAgentOverrageUnderageFlag?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  DealerState?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  DeniedDateComputed?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExceptionFlag?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedAgreementFlag?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  FormCode?: InputMaybe<Order_By>;
  FuelDeliveryCode?: InputMaybe<Order_By>;
  FuelTypeCode?: InputMaybe<Order_By>;
  GroupCode?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferDateComputed?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  LenderMetadata?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  NewOrUsedCode?: InputMaybe<Order_By>;
  NoteMetadata?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  OwnerMetadata?: InputMaybe<Order_By>;
  OwnersFirstName?: InputMaybe<Order_By>;
  OwnersLastName?: InputMaybe<Order_By>;
  PhoneNumber?: InputMaybe<Order_By>;
  PlanCode?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PolicyTypeCode?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  PostedDateComputed?: InputMaybe<Order_By>;
  PostgresSyncUpdateDate?: InputMaybe<Order_By>;
  PrimaryAgentCode?: InputMaybe<Order_By>;
  ProductMetadata?: InputMaybe<Order_By>;
  ProgramCarFlag?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RecordTypeCode?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  ReinstatedDateComputed?: InputMaybe<Order_By>;
  ReinstatedFlag?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  ReturnFromMailingFlag?: InputMaybe<Order_By>;
  SSN?: InputMaybe<Order_By>;
  SecondaryExpirationDate?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SecondaryOwnersFirstName?: InputMaybe<Order_By>;
  SecondaryOwnersLastName?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StateAbbreviation?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  SyncUpdateDate?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TransferTypeCode?: InputMaybe<Order_By>;
  TransferredFlag?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  TrueExpireDateComputed?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpgradedFlag?: InputMaybe<Order_By>;
  VehicleClassCode?: InputMaybe<Order_By>;
  VehicleClassificationCode?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleInServiceDateComputed?: InputMaybe<Order_By>;
  VehicleMakeCode?: InputMaybe<Order_By>;
  VehicleManufacturerCode?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehicleModelCode?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehiclePurchaseDateComputed?: InputMaybe<Order_By>;
  VehicleSeriesName?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
  VinNotFoundFlag?: InputMaybe<Order_By>;
  VinNumber?: InputMaybe<Order_By>;
  Zip?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ContractMaster_Min_Fields = {
  __typename?: 'ContractMaster_min_fields';
  AccountPostedDate?: Maybe<Scalars['Float']>;
  ActiveFromDate?: Maybe<Scalars['Float']>;
  ActiveFromDateComputed?: Maybe<Scalars['date']>;
  AddendumMetadata?: Maybe<Scalars['String']>;
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  AdjustedAdminCostAmount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: Maybe<Scalars['Float']>;
  AdjustedReserveAmount?: Maybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: Maybe<Scalars['Float']>;
  AdminCost2Amount?: Maybe<Scalars['Float']>;
  AdminCostAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AgreementSuffix?: Maybe<Scalars['String']>;
  AllowedTransferNumber?: Maybe<Scalars['Float']>;
  AlternateFactoryWarrantyFlag?: Maybe<Scalars['String']>;
  BatchNumber?: Maybe<Scalars['Float']>;
  BookState?: Maybe<Scalars['String']>;
  CanMethod?: Maybe<Scalars['Float']>;
  CanRule?: Maybe<Scalars['Float']>;
  CancelAsOfDate?: Maybe<Scalars['Float']>;
  CancelAsOfDateComputed?: Maybe<Scalars['date']>;
  CancelBatchNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelPostedDate?: Maybe<Scalars['Float']>;
  CancelProcessFromDate?: Maybe<Scalars['Float']>;
  CancelTransferDate?: Maybe<Scalars['Float']>;
  CarrierCode?: Maybe<Scalars['String']>;
  ChecksumColumn?: Maybe<Scalars['Int']>;
  City?: Maybe<Scalars['String']>;
  ClaimCount?: Maybe<Scalars['Float']>;
  ClaimsPaidAmount?: Maybe<Scalars['Float']>;
  CompanyCode?: Maybe<Scalars['String']>;
  CompositeKey?: Maybe<Scalars['String']>;
  ContractMasterID?: Maybe<Scalars['Int']>;
  ContractPdfFilename?: Maybe<Scalars['String']>;
  ContractPurchaseDate?: Maybe<Scalars['Float']>;
  ContractPurchaseDateComputed?: Maybe<Scalars['date']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  ConversionRecordFlag?: Maybe<Scalars['String']>;
  CostDetailMetadata?: Maybe<Scalars['String']>;
  CoverageCostAmount?: Maybe<Scalars['Float']>;
  CoverageMiles?: Maybe<Scalars['Float']>;
  CoverageMonths?: Maybe<Scalars['Float']>;
  CoverageOption?: Maybe<Scalars['Float']>;
  CoverageTypeCode?: Maybe<Scalars['String']>;
  CustomerCostAmount?: Maybe<Scalars['Float']>;
  CustomerRefundAmount?: Maybe<Scalars['Float']>;
  CylinderNumber?: Maybe<Scalars['Float']>;
  DealerAgentOverrageUnderageFlag?: Maybe<Scalars['String']>;
  DealerCode?: Maybe<Scalars['String']>;
  DealerIncentiveAmount?: Maybe<Scalars['Float']>;
  DealerRefundAmount?: Maybe<Scalars['Float']>;
  DealerRemittedAmount?: Maybe<Scalars['Float']>;
  DealerState?: Maybe<Scalars['String']>;
  Deductible?: Maybe<Scalars['Float']>;
  DeniedDate?: Maybe<Scalars['Float']>;
  DeniedDateComputed?: Maybe<Scalars['date']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExceptionFlag?: Maybe<Scalars['String']>;
  ExecAdminCostAmount?: Maybe<Scalars['Float']>;
  ExecMiscCost1Amount?: Maybe<Scalars['Float']>;
  ExecMiscCost2Amount?: Maybe<Scalars['Float']>;
  ExecReserveAmount?: Maybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: Maybe<Scalars['Float']>;
  ExpireMiles?: Maybe<Scalars['Float']>;
  FleetNumber?: Maybe<Scalars['Float']>;
  ForcedAgreementFlag?: Maybe<Scalars['String']>;
  ForcedRefundAmount?: Maybe<Scalars['Float']>;
  FormCode?: Maybe<Scalars['String']>;
  FuelDeliveryCode?: Maybe<Scalars['String']>;
  FuelTypeCode?: Maybe<Scalars['String']>;
  GroupCode?: Maybe<Scalars['String']>;
  LastClaimMileage?: Maybe<Scalars['Float']>;
  LastTransferDate?: Maybe<Scalars['Float']>;
  LastTransferDateComputed?: Maybe<Scalars['date']>;
  LastTransferMileage?: Maybe<Scalars['Float']>;
  LenderMetadata?: Maybe<Scalars['String']>;
  MBPIRefundAmount?: Maybe<Scalars['Float']>;
  MaxDaysToPayNumber?: Maybe<Scalars['Float']>;
  MaxPayPerDayAmount?: Maybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: Maybe<Scalars['Float']>;
  MiscCost1Amount?: Maybe<Scalars['Float']>;
  MiscCost2Amount?: Maybe<Scalars['Float']>;
  MiscCost3Amount?: Maybe<Scalars['Float']>;
  MiscCost4Amount?: Maybe<Scalars['Float']>;
  NewOrUsedCode?: Maybe<Scalars['String']>;
  NoteMetadata?: Maybe<Scalars['String']>;
  OdometerReading?: Maybe<Scalars['Float']>;
  OwnerMetadata?: Maybe<Scalars['String']>;
  OwnersFirstName?: Maybe<Scalars['String']>;
  OwnersLastName?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  PlanCode?: Maybe<Scalars['String']>;
  PolicyModifiedDate?: Maybe<Scalars['Float']>;
  PolicyTypeCode?: Maybe<Scalars['String']>;
  PostedDate?: Maybe<Scalars['Float']>;
  PostedDateComputed?: Maybe<Scalars['date']>;
  PostgresSyncUpdateDate?: Maybe<Scalars['datetime']>;
  PrimaryAgentCode?: Maybe<Scalars['String']>;
  ProductMetadata?: Maybe<Scalars['String']>;
  ProgramCarFlag?: Maybe<Scalars['String']>;
  ReceivedDate?: Maybe<Scalars['Float']>;
  RecordTypeCode?: Maybe<Scalars['String']>;
  RefundPercentage?: Maybe<Scalars['Float']>;
  ReinstatedDate?: Maybe<Scalars['Float']>;
  ReinstatedDateComputed?: Maybe<Scalars['date']>;
  ReinstatedFlag?: Maybe<Scalars['String']>;
  Reserve2Amount?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: Maybe<Scalars['Float']>;
  ReturnFromMailingFlag?: Maybe<Scalars['String']>;
  SSN?: Maybe<Scalars['String']>;
  SecondaryExpirationDate?: Maybe<Scalars['date']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Int']>;
  SecondaryOwnersFirstName?: Maybe<Scalars['String']>;
  SecondaryOwnersLastName?: Maybe<Scalars['String']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserve2Amount?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StateAbbreviation?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['Int']>;
  SubmitExpireDate?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  SyncUpdateDate?: Maybe<Scalars['datetime']>;
  TransferFeeAmount?: Maybe<Scalars['Float']>;
  TransferNumber?: Maybe<Scalars['Float']>;
  TransferTypeCode?: Maybe<Scalars['String']>;
  TransferredFlag?: Maybe<Scalars['String']>;
  TrueExpireDate?: Maybe<Scalars['Float']>;
  TrueExpireDateComputed?: Maybe<Scalars['date']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  UpgradedFlag?: Maybe<Scalars['String']>;
  VehicleClassCode?: Maybe<Scalars['String']>;
  VehicleClassificationCode?: Maybe<Scalars['String']>;
  VehicleCost?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleInServiceDateComputed?: Maybe<Scalars['date']>;
  VehicleMakeCode?: Maybe<Scalars['String']>;
  VehicleManufacturerCode?: Maybe<Scalars['String']>;
  VehicleMilesWhenCancel?: Maybe<Scalars['Float']>;
  VehicleModelCode?: Maybe<Scalars['String']>;
  VehiclePurchaseDate?: Maybe<Scalars['Float']>;
  VehiclePurchaseDateComputed?: Maybe<Scalars['date']>;
  VehicleSeriesName?: Maybe<Scalars['String']>;
  VehicleWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
  VinNotFoundFlag?: Maybe<Scalars['String']>;
  VinNumber?: Maybe<Scalars['String']>;
  Zip?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ContractMaster" */
export type ContractMaster_Min_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  ActiveFromDateComputed?: InputMaybe<Order_By>;
  AddendumMetadata?: InputMaybe<Order_By>;
  Address1?: InputMaybe<Order_By>;
  Address2?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  AlternateFactoryWarrantyFlag?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  BookState?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelAsOfDateComputed?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  CarrierCode?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  City?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  CompositeKey?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPdfFilename?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ContractPurchaseDateComputed?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  ConversionRecordFlag?: InputMaybe<Order_By>;
  CostDetailMetadata?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CoverageTypeCode?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerAgentOverrageUnderageFlag?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  DealerState?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  DeniedDateComputed?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExceptionFlag?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedAgreementFlag?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  FormCode?: InputMaybe<Order_By>;
  FuelDeliveryCode?: InputMaybe<Order_By>;
  FuelTypeCode?: InputMaybe<Order_By>;
  GroupCode?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferDateComputed?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  LenderMetadata?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  NewOrUsedCode?: InputMaybe<Order_By>;
  NoteMetadata?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  OwnerMetadata?: InputMaybe<Order_By>;
  OwnersFirstName?: InputMaybe<Order_By>;
  OwnersLastName?: InputMaybe<Order_By>;
  PhoneNumber?: InputMaybe<Order_By>;
  PlanCode?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PolicyTypeCode?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  PostedDateComputed?: InputMaybe<Order_By>;
  PostgresSyncUpdateDate?: InputMaybe<Order_By>;
  PrimaryAgentCode?: InputMaybe<Order_By>;
  ProductMetadata?: InputMaybe<Order_By>;
  ProgramCarFlag?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RecordTypeCode?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  ReinstatedDateComputed?: InputMaybe<Order_By>;
  ReinstatedFlag?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  ReturnFromMailingFlag?: InputMaybe<Order_By>;
  SSN?: InputMaybe<Order_By>;
  SecondaryExpirationDate?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SecondaryOwnersFirstName?: InputMaybe<Order_By>;
  SecondaryOwnersLastName?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StateAbbreviation?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  SyncUpdateDate?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TransferTypeCode?: InputMaybe<Order_By>;
  TransferredFlag?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  TrueExpireDateComputed?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpgradedFlag?: InputMaybe<Order_By>;
  VehicleClassCode?: InputMaybe<Order_By>;
  VehicleClassificationCode?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleInServiceDateComputed?: InputMaybe<Order_By>;
  VehicleMakeCode?: InputMaybe<Order_By>;
  VehicleManufacturerCode?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehicleModelCode?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehiclePurchaseDateComputed?: InputMaybe<Order_By>;
  VehicleSeriesName?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
  VinNotFoundFlag?: InputMaybe<Order_By>;
  VinNumber?: InputMaybe<Order_By>;
  Zip?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ContractMaster" */
export type ContractMaster_Mutation_Response = {
  __typename?: 'ContractMaster_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractMaster>;
};

/** Ordering options when selecting data from "ContractMaster". */
export type ContractMaster_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  ActiveFromDateComputed?: InputMaybe<Order_By>;
  AddendumMetadata?: InputMaybe<Order_By>;
  Address1?: InputMaybe<Order_By>;
  Address2?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AgreementSuffix?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  AlternateFactoryWarrantyFlag?: InputMaybe<Order_By>;
  BatchKey?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  BookState?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelAsOfDateComputed?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  CarrierCode?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  City?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  CompositeKey?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPdfFilename?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ContractPurchaseDateComputed?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  ConversionRecordFlag?: InputMaybe<Order_By>;
  CostDetailMetadata?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CoverageTypeCode?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerAgentOverrageUnderageFlag?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  DealerState?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  DeniedDateComputed?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExceptionFlag?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedAgreementFlag?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  FormCode?: InputMaybe<Order_By>;
  FuelDeliveryCode?: InputMaybe<Order_By>;
  FuelTypeCode?: InputMaybe<Order_By>;
  GroupCode?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferDateComputed?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  LenderMetadata?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  NewOrUsedCode?: InputMaybe<Order_By>;
  NoteMetadata?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  OwnerMetadata?: InputMaybe<Order_By>;
  OwnersFirstName?: InputMaybe<Order_By>;
  OwnersLastName?: InputMaybe<Order_By>;
  PhoneNumber?: InputMaybe<Order_By>;
  PlanCode?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PolicyTypeCode?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  PostedDateComputed?: InputMaybe<Order_By>;
  PostgresSyncUpdateDate?: InputMaybe<Order_By>;
  PrimaryAgentCode?: InputMaybe<Order_By>;
  ProductMetadata?: InputMaybe<Order_By>;
  ProgramCarFlag?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RecordTypeCode?: InputMaybe<Order_By>;
  RedoContractPdfFilename?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  ReinstatedDateComputed?: InputMaybe<Order_By>;
  ReinstatedFlag?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  ReturnFromMailingFlag?: InputMaybe<Order_By>;
  SSN?: InputMaybe<Order_By>;
  SecondaryExpirationDate?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SecondaryOwnersFirstName?: InputMaybe<Order_By>;
  SecondaryOwnersLastName?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StateAbbreviation?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  SyncUpdateDate?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TransferTypeCode?: InputMaybe<Order_By>;
  TransferredFlag?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  TrueExpireDateComputed?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UpgradedFlag?: InputMaybe<Order_By>;
  VehicleClassCode?: InputMaybe<Order_By>;
  VehicleClassificationCode?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleInServiceDateComputed?: InputMaybe<Order_By>;
  VehicleMakeCode?: InputMaybe<Order_By>;
  VehicleManufacturerCode?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehicleModelCode?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehiclePurchaseDateComputed?: InputMaybe<Order_By>;
  VehicleSeriesName?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
  VinNotFoundFlag?: InputMaybe<Order_By>;
  VinNumber?: InputMaybe<Order_By>;
  Zip?: InputMaybe<Order_By>;
  claims_aggregate?: InputMaybe<ClaimsMaster_Aggregate_Order_By>;
  contractMasterAdditionalEntities_aggregate?: InputMaybe<ContractMasterAdditionalEntity_Aggregate_Order_By>;
  contractMasterSurcharges_aggregate?: InputMaybe<ContractMasterSurcharge_Aggregate_Order_By>;
  dealer?: InputMaybe<Dealer_Order_By>;
  plan?: InputMaybe<Plan_Order_By>;
};

/** primary key columns input for table: ContractMaster */
export type ContractMaster_Pk_Columns_Input = {
  ContractMasterID: Scalars['Int'];
};

/** select columns of table "ContractMaster" */
export enum ContractMaster_Select_Column {
  /** column name */
  AccountPostedDate = 'AccountPostedDate',
  /** column name */
  ActiveFromDate = 'ActiveFromDate',
  /** column name */
  ActiveFromDateComputed = 'ActiveFromDateComputed',
  /** column name */
  AddendumMetadata = 'AddendumMetadata',
  /** column name */
  Address1 = 'Address1',
  /** column name */
  Address2 = 'Address2',
  /** column name */
  AdjustedAdminCostAmount = 'AdjustedAdminCostAmount',
  /** column name */
  AdjustedMiscCost1Amount = 'AdjustedMiscCost1Amount',
  /** column name */
  AdjustedMiscCost2Amount = 'AdjustedMiscCost2Amount',
  /** column name */
  AdjustedReserveAmount = 'AdjustedReserveAmount',
  /** column name */
  AdjustedSpecialReserveAmount = 'AdjustedSpecialReserveAmount',
  /** column name */
  AdminCost2Amount = 'AdminCost2Amount',
  /** column name */
  AdminCostAmount = 'AdminCostAmount',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  AllowedTransferNumber = 'AllowedTransferNumber',
  /** column name */
  AlternateFactoryWarrantyFlag = 'AlternateFactoryWarrantyFlag',
  /** column name */
  BatchKey = 'BatchKey',
  /** column name */
  BatchNumber = 'BatchNumber',
  /** column name */
  BookState = 'BookState',
  /** column name */
  CanMethod = 'CanMethod',
  /** column name */
  CanRule = 'CanRule',
  /** column name */
  CancelAsOfDate = 'CancelAsOfDate',
  /** column name */
  CancelAsOfDateComputed = 'CancelAsOfDateComputed',
  /** column name */
  CancelBatchNumber = 'CancelBatchNumber',
  /** column name */
  CancelFeeAmount = 'CancelFeeAmount',
  /** column name */
  CancelPostedDate = 'CancelPostedDate',
  /** column name */
  CancelProcessFromDate = 'CancelProcessFromDate',
  /** column name */
  CancelTransferDate = 'CancelTransferDate',
  /** column name */
  CarrierCode = 'CarrierCode',
  /** column name */
  ChecksumColumn = 'ChecksumColumn',
  /** column name */
  City = 'City',
  /** column name */
  ClaimCount = 'ClaimCount',
  /** column name */
  ClaimsPaidAmount = 'ClaimsPaidAmount',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  CompositeKey = 'CompositeKey',
  /** column name */
  ContractMasterId = 'ContractMasterID',
  /** column name */
  ContractPdfFilename = 'ContractPdfFilename',
  /** column name */
  ContractPurchaseDate = 'ContractPurchaseDate',
  /** column name */
  ContractPurchaseDateComputed = 'ContractPurchaseDateComputed',
  /** column name */
  ConversionDate = 'ConversionDate',
  /** column name */
  ConversionRecordFlag = 'ConversionRecordFlag',
  /** column name */
  CostDetailMetadata = 'CostDetailMetadata',
  /** column name */
  CoverageCostAmount = 'CoverageCostAmount',
  /** column name */
  CoverageMiles = 'CoverageMiles',
  /** column name */
  CoverageMonths = 'CoverageMonths',
  /** column name */
  CoverageOption = 'CoverageOption',
  /** column name */
  CoverageTypeCode = 'CoverageTypeCode',
  /** column name */
  CustomerCostAmount = 'CustomerCostAmount',
  /** column name */
  CustomerRefundAmount = 'CustomerRefundAmount',
  /** column name */
  CylinderNumber = 'CylinderNumber',
  /** column name */
  DealerAgentOverrageUnderageFlag = 'DealerAgentOverrageUnderageFlag',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  DealerIncentiveAmount = 'DealerIncentiveAmount',
  /** column name */
  DealerRefundAmount = 'DealerRefundAmount',
  /** column name */
  DealerRemittedAmount = 'DealerRemittedAmount',
  /** column name */
  DealerState = 'DealerState',
  /** column name */
  Deductible = 'Deductible',
  /** column name */
  DeniedDate = 'DeniedDate',
  /** column name */
  DeniedDateComputed = 'DeniedDateComputed',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  ExceptionFlag = 'ExceptionFlag',
  /** column name */
  ExecAdminCostAmount = 'ExecAdminCostAmount',
  /** column name */
  ExecMiscCost1Amount = 'ExecMiscCost1Amount',
  /** column name */
  ExecMiscCost2Amount = 'ExecMiscCost2Amount',
  /** column name */
  ExecReserveAmount = 'ExecReserveAmount',
  /** column name */
  ExecSpecialReserveAmount = 'ExecSpecialReserveAmount',
  /** column name */
  ExpireMiles = 'ExpireMiles',
  /** column name */
  FleetNumber = 'FleetNumber',
  /** column name */
  ForcedAgreementFlag = 'ForcedAgreementFlag',
  /** column name */
  ForcedRefundAmount = 'ForcedRefundAmount',
  /** column name */
  FormCode = 'FormCode',
  /** column name */
  FuelDeliveryCode = 'FuelDeliveryCode',
  /** column name */
  FuelTypeCode = 'FuelTypeCode',
  /** column name */
  GroupCode = 'GroupCode',
  /** column name */
  Id = 'ID',
  /** column name */
  LastClaimMileage = 'LastClaimMileage',
  /** column name */
  LastTransferDate = 'LastTransferDate',
  /** column name */
  LastTransferDateComputed = 'LastTransferDateComputed',
  /** column name */
  LastTransferMileage = 'LastTransferMileage',
  /** column name */
  LenderMetadata = 'LenderMetadata',
  /** column name */
  MbpiRefundAmount = 'MBPIRefundAmount',
  /** column name */
  MaxDaysToPayNumber = 'MaxDaysToPayNumber',
  /** column name */
  MaxPayPerDayAmount = 'MaxPayPerDayAmount',
  /** column name */
  MaxTowingExpenseAmount = 'MaxTowingExpenseAmount',
  /** column name */
  MiscCost1Amount = 'MiscCost1Amount',
  /** column name */
  MiscCost2Amount = 'MiscCost2Amount',
  /** column name */
  MiscCost3Amount = 'MiscCost3Amount',
  /** column name */
  MiscCost4Amount = 'MiscCost4Amount',
  /** column name */
  NewOrUsedCode = 'NewOrUsedCode',
  /** column name */
  NoteMetadata = 'NoteMetadata',
  /** column name */
  OdometerReading = 'OdometerReading',
  /** column name */
  OwnerMetadata = 'OwnerMetadata',
  /** column name */
  OwnersFirstName = 'OwnersFirstName',
  /** column name */
  OwnersLastName = 'OwnersLastName',
  /** column name */
  PhoneNumber = 'PhoneNumber',
  /** column name */
  PlanCode = 'PlanCode',
  /** column name */
  PolicyModifiedDate = 'PolicyModifiedDate',
  /** column name */
  PolicyTypeCode = 'PolicyTypeCode',
  /** column name */
  PostedDate = 'PostedDate',
  /** column name */
  PostedDateComputed = 'PostedDateComputed',
  /** column name */
  PostgresSyncUpdateDate = 'PostgresSyncUpdateDate',
  /** column name */
  PrimaryAgentCode = 'PrimaryAgentCode',
  /** column name */
  ProductMetadata = 'ProductMetadata',
  /** column name */
  ProgramCarFlag = 'ProgramCarFlag',
  /** column name */
  ReceivedDate = 'ReceivedDate',
  /** column name */
  RecordTypeCode = 'RecordTypeCode',
  /** column name */
  RedoContractPdfFilename = 'RedoContractPdfFilename',
  /** column name */
  RefundPercentage = 'RefundPercentage',
  /** column name */
  ReinstatedDate = 'ReinstatedDate',
  /** column name */
  ReinstatedDateComputed = 'ReinstatedDateComputed',
  /** column name */
  ReinstatedFlag = 'ReinstatedFlag',
  /** column name */
  Reserve2Amount = 'Reserve2Amount',
  /** column name */
  ReserveAmount = 'ReserveAmount',
  /** column name */
  ReturnCancellationToAgentFlag = 'ReturnCancellationToAgentFlag',
  /** column name */
  ReturnCancellationToCustomerFlag = 'ReturnCancellationToCustomerFlag',
  /** column name */
  ReturnCancellationToDealerFlag = 'ReturnCancellationToDealerFlag',
  /** column name */
  ReturnCancellationToFinancialInstFlag = 'ReturnCancellationToFinancialInstFlag',
  /** column name */
  ReturnCancellationToLeinHolderFlag = 'ReturnCancellationToLeinHolderFlag',
  /** column name */
  ReturnCancellationToOtherFlag = 'ReturnCancellationToOtherFlag',
  /** column name */
  ReturnFromMailingFlag = 'ReturnFromMailingFlag',
  /** column name */
  Ssn = 'SSN',
  /** column name */
  SecondaryExpirationDate = 'SecondaryExpirationDate',
  /** column name */
  SecondaryExpirationMiles = 'SecondaryExpirationMiles',
  /** column name */
  SecondaryOwnersFirstName = 'SecondaryOwnersFirstName',
  /** column name */
  SecondaryOwnersLastName = 'SecondaryOwnersLastName',
  /** column name */
  SequenceNumber = 'SequenceNumber',
  /** column name */
  SpecialReserve2Amount = 'SpecialReserve2Amount',
  /** column name */
  SpecialReserveAmount = 'SpecialReserveAmount',
  /** column name */
  StateAbbreviation = 'StateAbbreviation',
  /** column name */
  StatusCode = 'StatusCode',
  /** column name */
  SubmitExpireDate = 'SubmitExpireDate',
  /** column name */
  SurchargeCostAmount = 'SurchargeCostAmount',
  /** column name */
  SyncUpdateDate = 'SyncUpdateDate',
  /** column name */
  TransferFeeAmount = 'TransferFeeAmount',
  /** column name */
  TransferNumber = 'TransferNumber',
  /** column name */
  TransferTypeCode = 'TransferTypeCode',
  /** column name */
  TransferredFlag = 'TransferredFlag',
  /** column name */
  TrueExpireDate = 'TrueExpireDate',
  /** column name */
  TrueExpireDateComputed = 'TrueExpireDateComputed',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  UpgradedFlag = 'UpgradedFlag',
  /** column name */
  VehicleClassCode = 'VehicleClassCode',
  /** column name */
  VehicleClassificationCode = 'VehicleClassificationCode',
  /** column name */
  VehicleCost = 'VehicleCost',
  /** column name */
  VehicleInServiceDate = 'VehicleInServiceDate',
  /** column name */
  VehicleInServiceDateComputed = 'VehicleInServiceDateComputed',
  /** column name */
  VehicleMakeCode = 'VehicleMakeCode',
  /** column name */
  VehicleManufacturerCode = 'VehicleManufacturerCode',
  /** column name */
  VehicleMilesWhenCancel = 'VehicleMilesWhenCancel',
  /** column name */
  VehicleModelCode = 'VehicleModelCode',
  /** column name */
  VehiclePurchaseDate = 'VehiclePurchaseDate',
  /** column name */
  VehiclePurchaseDateComputed = 'VehiclePurchaseDateComputed',
  /** column name */
  VehicleSeriesName = 'VehicleSeriesName',
  /** column name */
  VehicleWheelsDriving = 'VehicleWheelsDriving',
  /** column name */
  VehicleYear = 'VehicleYear',
  /** column name */
  VinNotFoundFlag = 'VinNotFoundFlag',
  /** column name */
  VinNumber = 'VinNumber',
  /** column name */
  Zip = 'Zip'
}

/** input type for updating data in table "ContractMaster" */
export type ContractMaster_Set_Input = {
  AccountPostedDate?: InputMaybe<Scalars['Float']>;
  ActiveFromDate?: InputMaybe<Scalars['Float']>;
  ActiveFromDateComputed?: InputMaybe<Scalars['date']>;
  AddendumMetadata?: InputMaybe<Scalars['String']>;
  Address1?: InputMaybe<Scalars['String']>;
  Address2?: InputMaybe<Scalars['String']>;
  AdjustedAdminCostAmount?: InputMaybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: InputMaybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: InputMaybe<Scalars['Float']>;
  AdjustedReserveAmount?: InputMaybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  AdminCost2Amount?: InputMaybe<Scalars['Float']>;
  AdminCostAmount?: InputMaybe<Scalars['Float']>;
  AgreementNumber?: InputMaybe<Scalars['Float']>;
  AgreementSuffix?: InputMaybe<Scalars['String']>;
  AllowedTransferNumber?: InputMaybe<Scalars['Float']>;
  AlternateFactoryWarrantyFlag?: InputMaybe<Scalars['String']>;
  BatchKey?: InputMaybe<Scalars['uniqueidentifier']>;
  BatchNumber?: InputMaybe<Scalars['Float']>;
  BookState?: InputMaybe<Scalars['String']>;
  CanMethod?: InputMaybe<Scalars['Float']>;
  CanRule?: InputMaybe<Scalars['Float']>;
  CancelAsOfDate?: InputMaybe<Scalars['Float']>;
  CancelAsOfDateComputed?: InputMaybe<Scalars['date']>;
  CancelBatchNumber?: InputMaybe<Scalars['Float']>;
  CancelFeeAmount?: InputMaybe<Scalars['Float']>;
  CancelPostedDate?: InputMaybe<Scalars['Float']>;
  CancelProcessFromDate?: InputMaybe<Scalars['Float']>;
  CancelTransferDate?: InputMaybe<Scalars['Float']>;
  CarrierCode?: InputMaybe<Scalars['String']>;
  ChecksumColumn?: InputMaybe<Scalars['Int']>;
  City?: InputMaybe<Scalars['String']>;
  ClaimCount?: InputMaybe<Scalars['Float']>;
  ClaimsPaidAmount?: InputMaybe<Scalars['Float']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  ContractPdfFilename?: InputMaybe<Scalars['String']>;
  ContractPurchaseDate?: InputMaybe<Scalars['Float']>;
  ContractPurchaseDateComputed?: InputMaybe<Scalars['date']>;
  ConversionDate?: InputMaybe<Scalars['Float']>;
  ConversionRecordFlag?: InputMaybe<Scalars['String']>;
  CostDetailMetadata?: InputMaybe<Scalars['String']>;
  CoverageCostAmount?: InputMaybe<Scalars['Float']>;
  CoverageMiles?: InputMaybe<Scalars['Float']>;
  CoverageMonths?: InputMaybe<Scalars['Float']>;
  CoverageOption?: InputMaybe<Scalars['Float']>;
  CoverageTypeCode?: InputMaybe<Scalars['String']>;
  CustomerCostAmount?: InputMaybe<Scalars['Float']>;
  CustomerRefundAmount?: InputMaybe<Scalars['Float']>;
  CylinderNumber?: InputMaybe<Scalars['Float']>;
  DealerAgentOverrageUnderageFlag?: InputMaybe<Scalars['String']>;
  DealerCode?: InputMaybe<Scalars['String']>;
  DealerIncentiveAmount?: InputMaybe<Scalars['Float']>;
  DealerRefundAmount?: InputMaybe<Scalars['Float']>;
  DealerRemittedAmount?: InputMaybe<Scalars['Float']>;
  DealerState?: InputMaybe<Scalars['String']>;
  Deductible?: InputMaybe<Scalars['Float']>;
  DeniedDate?: InputMaybe<Scalars['Float']>;
  DeniedDateComputed?: InputMaybe<Scalars['date']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  ExceptionFlag?: InputMaybe<Scalars['String']>;
  ExecAdminCostAmount?: InputMaybe<Scalars['Float']>;
  ExecMiscCost1Amount?: InputMaybe<Scalars['Float']>;
  ExecMiscCost2Amount?: InputMaybe<Scalars['Float']>;
  ExecReserveAmount?: InputMaybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  ExpireMiles?: InputMaybe<Scalars['Float']>;
  FleetNumber?: InputMaybe<Scalars['Float']>;
  ForcedAgreementFlag?: InputMaybe<Scalars['String']>;
  ForcedRefundAmount?: InputMaybe<Scalars['Float']>;
  FormCode?: InputMaybe<Scalars['String']>;
  FuelDeliveryCode?: InputMaybe<Scalars['String']>;
  FuelTypeCode?: InputMaybe<Scalars['String']>;
  GroupCode?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['uniqueidentifier']>;
  LastClaimMileage?: InputMaybe<Scalars['Float']>;
  LastTransferDate?: InputMaybe<Scalars['Float']>;
  LastTransferDateComputed?: InputMaybe<Scalars['date']>;
  LastTransferMileage?: InputMaybe<Scalars['Float']>;
  LenderMetadata?: InputMaybe<Scalars['String']>;
  MBPIRefundAmount?: InputMaybe<Scalars['Float']>;
  MaxDaysToPayNumber?: InputMaybe<Scalars['Float']>;
  MaxPayPerDayAmount?: InputMaybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: InputMaybe<Scalars['Float']>;
  MiscCost1Amount?: InputMaybe<Scalars['Float']>;
  MiscCost2Amount?: InputMaybe<Scalars['Float']>;
  MiscCost3Amount?: InputMaybe<Scalars['Float']>;
  MiscCost4Amount?: InputMaybe<Scalars['Float']>;
  NewOrUsedCode?: InputMaybe<Scalars['String']>;
  NoteMetadata?: InputMaybe<Scalars['String']>;
  OdometerReading?: InputMaybe<Scalars['Float']>;
  OwnerMetadata?: InputMaybe<Scalars['String']>;
  OwnersFirstName?: InputMaybe<Scalars['String']>;
  OwnersLastName?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  PlanCode?: InputMaybe<Scalars['String']>;
  PolicyModifiedDate?: InputMaybe<Scalars['Float']>;
  PolicyTypeCode?: InputMaybe<Scalars['String']>;
  PostedDate?: InputMaybe<Scalars['Float']>;
  PostedDateComputed?: InputMaybe<Scalars['date']>;
  PostgresSyncUpdateDate?: InputMaybe<Scalars['datetime']>;
  PrimaryAgentCode?: InputMaybe<Scalars['String']>;
  ProductMetadata?: InputMaybe<Scalars['String']>;
  ProgramCarFlag?: InputMaybe<Scalars['String']>;
  ReceivedDate?: InputMaybe<Scalars['Float']>;
  RecordTypeCode?: InputMaybe<Scalars['String']>;
  RedoContractPdfFilename?: InputMaybe<Scalars['Boolean']>;
  RefundPercentage?: InputMaybe<Scalars['Float']>;
  ReinstatedDate?: InputMaybe<Scalars['Float']>;
  ReinstatedDateComputed?: InputMaybe<Scalars['date']>;
  ReinstatedFlag?: InputMaybe<Scalars['String']>;
  Reserve2Amount?: InputMaybe<Scalars['Float']>;
  ReserveAmount?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: InputMaybe<Scalars['Float']>;
  ReturnFromMailingFlag?: InputMaybe<Scalars['String']>;
  SSN?: InputMaybe<Scalars['String']>;
  SecondaryExpirationDate?: InputMaybe<Scalars['date']>;
  SecondaryExpirationMiles?: InputMaybe<Scalars['Int']>;
  SecondaryOwnersFirstName?: InputMaybe<Scalars['String']>;
  SecondaryOwnersLastName?: InputMaybe<Scalars['String']>;
  SequenceNumber?: InputMaybe<Scalars['Float']>;
  SpecialReserve2Amount?: InputMaybe<Scalars['Float']>;
  SpecialReserveAmount?: InputMaybe<Scalars['Float']>;
  StateAbbreviation?: InputMaybe<Scalars['String']>;
  StatusCode?: InputMaybe<Scalars['Int']>;
  SubmitExpireDate?: InputMaybe<Scalars['Float']>;
  SurchargeCostAmount?: InputMaybe<Scalars['Float']>;
  SyncUpdateDate?: InputMaybe<Scalars['datetime']>;
  TransferFeeAmount?: InputMaybe<Scalars['Float']>;
  TransferNumber?: InputMaybe<Scalars['Float']>;
  TransferTypeCode?: InputMaybe<Scalars['String']>;
  TransferredFlag?: InputMaybe<Scalars['String']>;
  TrueExpireDate?: InputMaybe<Scalars['Float']>;
  TrueExpireDateComputed?: InputMaybe<Scalars['date']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
  UpgradedFlag?: InputMaybe<Scalars['String']>;
  VehicleClassCode?: InputMaybe<Scalars['String']>;
  VehicleClassificationCode?: InputMaybe<Scalars['String']>;
  VehicleCost?: InputMaybe<Scalars['Float']>;
  VehicleInServiceDate?: InputMaybe<Scalars['Float']>;
  VehicleInServiceDateComputed?: InputMaybe<Scalars['date']>;
  VehicleMakeCode?: InputMaybe<Scalars['String']>;
  VehicleManufacturerCode?: InputMaybe<Scalars['String']>;
  VehicleMilesWhenCancel?: InputMaybe<Scalars['Float']>;
  VehicleModelCode?: InputMaybe<Scalars['String']>;
  VehiclePurchaseDate?: InputMaybe<Scalars['Float']>;
  VehiclePurchaseDateComputed?: InputMaybe<Scalars['date']>;
  VehicleSeriesName?: InputMaybe<Scalars['String']>;
  VehicleWheelsDriving?: InputMaybe<Scalars['Float']>;
  VehicleYear?: InputMaybe<Scalars['Float']>;
  VinNotFoundFlag?: InputMaybe<Scalars['String']>;
  VinNumber?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ContractMaster_Stddev_Fields = {
  __typename?: 'ContractMaster_stddev_fields';
  AccountPostedDate?: Maybe<Scalars['Float']>;
  ActiveFromDate?: Maybe<Scalars['Float']>;
  AdjustedAdminCostAmount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: Maybe<Scalars['Float']>;
  AdjustedReserveAmount?: Maybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: Maybe<Scalars['Float']>;
  AdminCost2Amount?: Maybe<Scalars['Float']>;
  AdminCostAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AllowedTransferNumber?: Maybe<Scalars['Float']>;
  BatchNumber?: Maybe<Scalars['Float']>;
  CanMethod?: Maybe<Scalars['Float']>;
  CanRule?: Maybe<Scalars['Float']>;
  CancelAsOfDate?: Maybe<Scalars['Float']>;
  CancelBatchNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelPostedDate?: Maybe<Scalars['Float']>;
  CancelProcessFromDate?: Maybe<Scalars['Float']>;
  CancelTransferDate?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimCount?: Maybe<Scalars['Float']>;
  ClaimsPaidAmount?: Maybe<Scalars['Float']>;
  ContractMasterID?: Maybe<Scalars['Float']>;
  ContractPurchaseDate?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  CoverageCostAmount?: Maybe<Scalars['Float']>;
  CoverageMiles?: Maybe<Scalars['Float']>;
  CoverageMonths?: Maybe<Scalars['Float']>;
  CoverageOption?: Maybe<Scalars['Float']>;
  CustomerCostAmount?: Maybe<Scalars['Float']>;
  CustomerRefundAmount?: Maybe<Scalars['Float']>;
  CylinderNumber?: Maybe<Scalars['Float']>;
  DealerIncentiveAmount?: Maybe<Scalars['Float']>;
  DealerRefundAmount?: Maybe<Scalars['Float']>;
  DealerRemittedAmount?: Maybe<Scalars['Float']>;
  Deductible?: Maybe<Scalars['Float']>;
  DeniedDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExecAdminCostAmount?: Maybe<Scalars['Float']>;
  ExecMiscCost1Amount?: Maybe<Scalars['Float']>;
  ExecMiscCost2Amount?: Maybe<Scalars['Float']>;
  ExecReserveAmount?: Maybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: Maybe<Scalars['Float']>;
  ExpireMiles?: Maybe<Scalars['Float']>;
  FleetNumber?: Maybe<Scalars['Float']>;
  ForcedRefundAmount?: Maybe<Scalars['Float']>;
  LastClaimMileage?: Maybe<Scalars['Float']>;
  LastTransferDate?: Maybe<Scalars['Float']>;
  LastTransferMileage?: Maybe<Scalars['Float']>;
  MBPIRefundAmount?: Maybe<Scalars['Float']>;
  MaxDaysToPayNumber?: Maybe<Scalars['Float']>;
  MaxPayPerDayAmount?: Maybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: Maybe<Scalars['Float']>;
  MiscCost1Amount?: Maybe<Scalars['Float']>;
  MiscCost2Amount?: Maybe<Scalars['Float']>;
  MiscCost3Amount?: Maybe<Scalars['Float']>;
  MiscCost4Amount?: Maybe<Scalars['Float']>;
  OdometerReading?: Maybe<Scalars['Float']>;
  PolicyModifiedDate?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  ReceivedDate?: Maybe<Scalars['Float']>;
  RefundPercentage?: Maybe<Scalars['Float']>;
  ReinstatedDate?: Maybe<Scalars['Float']>;
  Reserve2Amount?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: Maybe<Scalars['Float']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserve2Amount?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StatusCode?: Maybe<Scalars['Float']>;
  SubmitExpireDate?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  TransferFeeAmount?: Maybe<Scalars['Float']>;
  TransferNumber?: Maybe<Scalars['Float']>;
  TrueExpireDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  VehicleCost?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleMilesWhenCancel?: Maybe<Scalars['Float']>;
  VehiclePurchaseDate?: Maybe<Scalars['Float']>;
  VehicleWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ContractMaster" */
export type ContractMaster_Stddev_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ContractMaster_Stddev_Pop_Fields = {
  __typename?: 'ContractMaster_stddev_pop_fields';
  AccountPostedDate?: Maybe<Scalars['Float']>;
  ActiveFromDate?: Maybe<Scalars['Float']>;
  AdjustedAdminCostAmount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: Maybe<Scalars['Float']>;
  AdjustedReserveAmount?: Maybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: Maybe<Scalars['Float']>;
  AdminCost2Amount?: Maybe<Scalars['Float']>;
  AdminCostAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AllowedTransferNumber?: Maybe<Scalars['Float']>;
  BatchNumber?: Maybe<Scalars['Float']>;
  CanMethod?: Maybe<Scalars['Float']>;
  CanRule?: Maybe<Scalars['Float']>;
  CancelAsOfDate?: Maybe<Scalars['Float']>;
  CancelBatchNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelPostedDate?: Maybe<Scalars['Float']>;
  CancelProcessFromDate?: Maybe<Scalars['Float']>;
  CancelTransferDate?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimCount?: Maybe<Scalars['Float']>;
  ClaimsPaidAmount?: Maybe<Scalars['Float']>;
  ContractMasterID?: Maybe<Scalars['Float']>;
  ContractPurchaseDate?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  CoverageCostAmount?: Maybe<Scalars['Float']>;
  CoverageMiles?: Maybe<Scalars['Float']>;
  CoverageMonths?: Maybe<Scalars['Float']>;
  CoverageOption?: Maybe<Scalars['Float']>;
  CustomerCostAmount?: Maybe<Scalars['Float']>;
  CustomerRefundAmount?: Maybe<Scalars['Float']>;
  CylinderNumber?: Maybe<Scalars['Float']>;
  DealerIncentiveAmount?: Maybe<Scalars['Float']>;
  DealerRefundAmount?: Maybe<Scalars['Float']>;
  DealerRemittedAmount?: Maybe<Scalars['Float']>;
  Deductible?: Maybe<Scalars['Float']>;
  DeniedDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExecAdminCostAmount?: Maybe<Scalars['Float']>;
  ExecMiscCost1Amount?: Maybe<Scalars['Float']>;
  ExecMiscCost2Amount?: Maybe<Scalars['Float']>;
  ExecReserveAmount?: Maybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: Maybe<Scalars['Float']>;
  ExpireMiles?: Maybe<Scalars['Float']>;
  FleetNumber?: Maybe<Scalars['Float']>;
  ForcedRefundAmount?: Maybe<Scalars['Float']>;
  LastClaimMileage?: Maybe<Scalars['Float']>;
  LastTransferDate?: Maybe<Scalars['Float']>;
  LastTransferMileage?: Maybe<Scalars['Float']>;
  MBPIRefundAmount?: Maybe<Scalars['Float']>;
  MaxDaysToPayNumber?: Maybe<Scalars['Float']>;
  MaxPayPerDayAmount?: Maybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: Maybe<Scalars['Float']>;
  MiscCost1Amount?: Maybe<Scalars['Float']>;
  MiscCost2Amount?: Maybe<Scalars['Float']>;
  MiscCost3Amount?: Maybe<Scalars['Float']>;
  MiscCost4Amount?: Maybe<Scalars['Float']>;
  OdometerReading?: Maybe<Scalars['Float']>;
  PolicyModifiedDate?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  ReceivedDate?: Maybe<Scalars['Float']>;
  RefundPercentage?: Maybe<Scalars['Float']>;
  ReinstatedDate?: Maybe<Scalars['Float']>;
  Reserve2Amount?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: Maybe<Scalars['Float']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserve2Amount?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StatusCode?: Maybe<Scalars['Float']>;
  SubmitExpireDate?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  TransferFeeAmount?: Maybe<Scalars['Float']>;
  TransferNumber?: Maybe<Scalars['Float']>;
  TrueExpireDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  VehicleCost?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleMilesWhenCancel?: Maybe<Scalars['Float']>;
  VehiclePurchaseDate?: Maybe<Scalars['Float']>;
  VehicleWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ContractMaster" */
export type ContractMaster_Stddev_Pop_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ContractMaster_Stddev_Samp_Fields = {
  __typename?: 'ContractMaster_stddev_samp_fields';
  AccountPostedDate?: Maybe<Scalars['Float']>;
  ActiveFromDate?: Maybe<Scalars['Float']>;
  AdjustedAdminCostAmount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: Maybe<Scalars['Float']>;
  AdjustedReserveAmount?: Maybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: Maybe<Scalars['Float']>;
  AdminCost2Amount?: Maybe<Scalars['Float']>;
  AdminCostAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AllowedTransferNumber?: Maybe<Scalars['Float']>;
  BatchNumber?: Maybe<Scalars['Float']>;
  CanMethod?: Maybe<Scalars['Float']>;
  CanRule?: Maybe<Scalars['Float']>;
  CancelAsOfDate?: Maybe<Scalars['Float']>;
  CancelBatchNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelPostedDate?: Maybe<Scalars['Float']>;
  CancelProcessFromDate?: Maybe<Scalars['Float']>;
  CancelTransferDate?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimCount?: Maybe<Scalars['Float']>;
  ClaimsPaidAmount?: Maybe<Scalars['Float']>;
  ContractMasterID?: Maybe<Scalars['Float']>;
  ContractPurchaseDate?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  CoverageCostAmount?: Maybe<Scalars['Float']>;
  CoverageMiles?: Maybe<Scalars['Float']>;
  CoverageMonths?: Maybe<Scalars['Float']>;
  CoverageOption?: Maybe<Scalars['Float']>;
  CustomerCostAmount?: Maybe<Scalars['Float']>;
  CustomerRefundAmount?: Maybe<Scalars['Float']>;
  CylinderNumber?: Maybe<Scalars['Float']>;
  DealerIncentiveAmount?: Maybe<Scalars['Float']>;
  DealerRefundAmount?: Maybe<Scalars['Float']>;
  DealerRemittedAmount?: Maybe<Scalars['Float']>;
  Deductible?: Maybe<Scalars['Float']>;
  DeniedDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExecAdminCostAmount?: Maybe<Scalars['Float']>;
  ExecMiscCost1Amount?: Maybe<Scalars['Float']>;
  ExecMiscCost2Amount?: Maybe<Scalars['Float']>;
  ExecReserveAmount?: Maybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: Maybe<Scalars['Float']>;
  ExpireMiles?: Maybe<Scalars['Float']>;
  FleetNumber?: Maybe<Scalars['Float']>;
  ForcedRefundAmount?: Maybe<Scalars['Float']>;
  LastClaimMileage?: Maybe<Scalars['Float']>;
  LastTransferDate?: Maybe<Scalars['Float']>;
  LastTransferMileage?: Maybe<Scalars['Float']>;
  MBPIRefundAmount?: Maybe<Scalars['Float']>;
  MaxDaysToPayNumber?: Maybe<Scalars['Float']>;
  MaxPayPerDayAmount?: Maybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: Maybe<Scalars['Float']>;
  MiscCost1Amount?: Maybe<Scalars['Float']>;
  MiscCost2Amount?: Maybe<Scalars['Float']>;
  MiscCost3Amount?: Maybe<Scalars['Float']>;
  MiscCost4Amount?: Maybe<Scalars['Float']>;
  OdometerReading?: Maybe<Scalars['Float']>;
  PolicyModifiedDate?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  ReceivedDate?: Maybe<Scalars['Float']>;
  RefundPercentage?: Maybe<Scalars['Float']>;
  ReinstatedDate?: Maybe<Scalars['Float']>;
  Reserve2Amount?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: Maybe<Scalars['Float']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserve2Amount?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StatusCode?: Maybe<Scalars['Float']>;
  SubmitExpireDate?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  TransferFeeAmount?: Maybe<Scalars['Float']>;
  TransferNumber?: Maybe<Scalars['Float']>;
  TrueExpireDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  VehicleCost?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleMilesWhenCancel?: Maybe<Scalars['Float']>;
  VehiclePurchaseDate?: Maybe<Scalars['Float']>;
  VehicleWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ContractMaster" */
export type ContractMaster_Stddev_Samp_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type ContractMaster_Sum_Fields = {
  __typename?: 'ContractMaster_sum_fields';
  AccountPostedDate?: Maybe<Scalars['Float']>;
  ActiveFromDate?: Maybe<Scalars['Float']>;
  AdjustedAdminCostAmount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: Maybe<Scalars['Float']>;
  AdjustedReserveAmount?: Maybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: Maybe<Scalars['Float']>;
  AdminCost2Amount?: Maybe<Scalars['Float']>;
  AdminCostAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AllowedTransferNumber?: Maybe<Scalars['Float']>;
  BatchNumber?: Maybe<Scalars['Float']>;
  CanMethod?: Maybe<Scalars['Float']>;
  CanRule?: Maybe<Scalars['Float']>;
  CancelAsOfDate?: Maybe<Scalars['Float']>;
  CancelBatchNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelPostedDate?: Maybe<Scalars['Float']>;
  CancelProcessFromDate?: Maybe<Scalars['Float']>;
  CancelTransferDate?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Int']>;
  ClaimCount?: Maybe<Scalars['Float']>;
  ClaimsPaidAmount?: Maybe<Scalars['Float']>;
  ContractMasterID?: Maybe<Scalars['Int']>;
  ContractPurchaseDate?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  CoverageCostAmount?: Maybe<Scalars['Float']>;
  CoverageMiles?: Maybe<Scalars['Float']>;
  CoverageMonths?: Maybe<Scalars['Float']>;
  CoverageOption?: Maybe<Scalars['Float']>;
  CustomerCostAmount?: Maybe<Scalars['Float']>;
  CustomerRefundAmount?: Maybe<Scalars['Float']>;
  CylinderNumber?: Maybe<Scalars['Float']>;
  DealerIncentiveAmount?: Maybe<Scalars['Float']>;
  DealerRefundAmount?: Maybe<Scalars['Float']>;
  DealerRemittedAmount?: Maybe<Scalars['Float']>;
  Deductible?: Maybe<Scalars['Float']>;
  DeniedDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExecAdminCostAmount?: Maybe<Scalars['Float']>;
  ExecMiscCost1Amount?: Maybe<Scalars['Float']>;
  ExecMiscCost2Amount?: Maybe<Scalars['Float']>;
  ExecReserveAmount?: Maybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: Maybe<Scalars['Float']>;
  ExpireMiles?: Maybe<Scalars['Float']>;
  FleetNumber?: Maybe<Scalars['Float']>;
  ForcedRefundAmount?: Maybe<Scalars['Float']>;
  LastClaimMileage?: Maybe<Scalars['Float']>;
  LastTransferDate?: Maybe<Scalars['Float']>;
  LastTransferMileage?: Maybe<Scalars['Float']>;
  MBPIRefundAmount?: Maybe<Scalars['Float']>;
  MaxDaysToPayNumber?: Maybe<Scalars['Float']>;
  MaxPayPerDayAmount?: Maybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: Maybe<Scalars['Float']>;
  MiscCost1Amount?: Maybe<Scalars['Float']>;
  MiscCost2Amount?: Maybe<Scalars['Float']>;
  MiscCost3Amount?: Maybe<Scalars['Float']>;
  MiscCost4Amount?: Maybe<Scalars['Float']>;
  OdometerReading?: Maybe<Scalars['Float']>;
  PolicyModifiedDate?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  ReceivedDate?: Maybe<Scalars['Float']>;
  RefundPercentage?: Maybe<Scalars['Float']>;
  ReinstatedDate?: Maybe<Scalars['Float']>;
  Reserve2Amount?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: Maybe<Scalars['Float']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Int']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserve2Amount?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StatusCode?: Maybe<Scalars['Int']>;
  SubmitExpireDate?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  TransferFeeAmount?: Maybe<Scalars['Float']>;
  TransferNumber?: Maybe<Scalars['Float']>;
  TrueExpireDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  VehicleCost?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleMilesWhenCancel?: Maybe<Scalars['Float']>;
  VehiclePurchaseDate?: Maybe<Scalars['Float']>;
  VehicleWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "ContractMaster" */
export type ContractMaster_Sum_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** update columns of table "ContractMaster" */
export enum ContractMaster_Update_Column {
  /** column name */
  AccountPostedDate = 'AccountPostedDate',
  /** column name */
  ActiveFromDate = 'ActiveFromDate',
  /** column name */
  ActiveFromDateComputed = 'ActiveFromDateComputed',
  /** column name */
  AddendumMetadata = 'AddendumMetadata',
  /** column name */
  Address1 = 'Address1',
  /** column name */
  Address2 = 'Address2',
  /** column name */
  AdjustedAdminCostAmount = 'AdjustedAdminCostAmount',
  /** column name */
  AdjustedMiscCost1Amount = 'AdjustedMiscCost1Amount',
  /** column name */
  AdjustedMiscCost2Amount = 'AdjustedMiscCost2Amount',
  /** column name */
  AdjustedReserveAmount = 'AdjustedReserveAmount',
  /** column name */
  AdjustedSpecialReserveAmount = 'AdjustedSpecialReserveAmount',
  /** column name */
  AdminCost2Amount = 'AdminCost2Amount',
  /** column name */
  AdminCostAmount = 'AdminCostAmount',
  /** column name */
  AgreementNumber = 'AgreementNumber',
  /** column name */
  AgreementSuffix = 'AgreementSuffix',
  /** column name */
  AllowedTransferNumber = 'AllowedTransferNumber',
  /** column name */
  AlternateFactoryWarrantyFlag = 'AlternateFactoryWarrantyFlag',
  /** column name */
  BatchKey = 'BatchKey',
  /** column name */
  BatchNumber = 'BatchNumber',
  /** column name */
  BookState = 'BookState',
  /** column name */
  CanMethod = 'CanMethod',
  /** column name */
  CanRule = 'CanRule',
  /** column name */
  CancelAsOfDate = 'CancelAsOfDate',
  /** column name */
  CancelAsOfDateComputed = 'CancelAsOfDateComputed',
  /** column name */
  CancelBatchNumber = 'CancelBatchNumber',
  /** column name */
  CancelFeeAmount = 'CancelFeeAmount',
  /** column name */
  CancelPostedDate = 'CancelPostedDate',
  /** column name */
  CancelProcessFromDate = 'CancelProcessFromDate',
  /** column name */
  CancelTransferDate = 'CancelTransferDate',
  /** column name */
  CarrierCode = 'CarrierCode',
  /** column name */
  ChecksumColumn = 'ChecksumColumn',
  /** column name */
  City = 'City',
  /** column name */
  ClaimCount = 'ClaimCount',
  /** column name */
  ClaimsPaidAmount = 'ClaimsPaidAmount',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  ContractPdfFilename = 'ContractPdfFilename',
  /** column name */
  ContractPurchaseDate = 'ContractPurchaseDate',
  /** column name */
  ContractPurchaseDateComputed = 'ContractPurchaseDateComputed',
  /** column name */
  ConversionDate = 'ConversionDate',
  /** column name */
  ConversionRecordFlag = 'ConversionRecordFlag',
  /** column name */
  CostDetailMetadata = 'CostDetailMetadata',
  /** column name */
  CoverageCostAmount = 'CoverageCostAmount',
  /** column name */
  CoverageMiles = 'CoverageMiles',
  /** column name */
  CoverageMonths = 'CoverageMonths',
  /** column name */
  CoverageOption = 'CoverageOption',
  /** column name */
  CoverageTypeCode = 'CoverageTypeCode',
  /** column name */
  CustomerCostAmount = 'CustomerCostAmount',
  /** column name */
  CustomerRefundAmount = 'CustomerRefundAmount',
  /** column name */
  CylinderNumber = 'CylinderNumber',
  /** column name */
  DealerAgentOverrageUnderageFlag = 'DealerAgentOverrageUnderageFlag',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  DealerIncentiveAmount = 'DealerIncentiveAmount',
  /** column name */
  DealerRefundAmount = 'DealerRefundAmount',
  /** column name */
  DealerRemittedAmount = 'DealerRemittedAmount',
  /** column name */
  DealerState = 'DealerState',
  /** column name */
  Deductible = 'Deductible',
  /** column name */
  DeniedDate = 'DeniedDate',
  /** column name */
  DeniedDateComputed = 'DeniedDateComputed',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  ExceptionFlag = 'ExceptionFlag',
  /** column name */
  ExecAdminCostAmount = 'ExecAdminCostAmount',
  /** column name */
  ExecMiscCost1Amount = 'ExecMiscCost1Amount',
  /** column name */
  ExecMiscCost2Amount = 'ExecMiscCost2Amount',
  /** column name */
  ExecReserveAmount = 'ExecReserveAmount',
  /** column name */
  ExecSpecialReserveAmount = 'ExecSpecialReserveAmount',
  /** column name */
  ExpireMiles = 'ExpireMiles',
  /** column name */
  FleetNumber = 'FleetNumber',
  /** column name */
  ForcedAgreementFlag = 'ForcedAgreementFlag',
  /** column name */
  ForcedRefundAmount = 'ForcedRefundAmount',
  /** column name */
  FormCode = 'FormCode',
  /** column name */
  FuelDeliveryCode = 'FuelDeliveryCode',
  /** column name */
  FuelTypeCode = 'FuelTypeCode',
  /** column name */
  GroupCode = 'GroupCode',
  /** column name */
  Id = 'ID',
  /** column name */
  LastClaimMileage = 'LastClaimMileage',
  /** column name */
  LastTransferDate = 'LastTransferDate',
  /** column name */
  LastTransferDateComputed = 'LastTransferDateComputed',
  /** column name */
  LastTransferMileage = 'LastTransferMileage',
  /** column name */
  LenderMetadata = 'LenderMetadata',
  /** column name */
  MbpiRefundAmount = 'MBPIRefundAmount',
  /** column name */
  MaxDaysToPayNumber = 'MaxDaysToPayNumber',
  /** column name */
  MaxPayPerDayAmount = 'MaxPayPerDayAmount',
  /** column name */
  MaxTowingExpenseAmount = 'MaxTowingExpenseAmount',
  /** column name */
  MiscCost1Amount = 'MiscCost1Amount',
  /** column name */
  MiscCost2Amount = 'MiscCost2Amount',
  /** column name */
  MiscCost3Amount = 'MiscCost3Amount',
  /** column name */
  MiscCost4Amount = 'MiscCost4Amount',
  /** column name */
  NewOrUsedCode = 'NewOrUsedCode',
  /** column name */
  NoteMetadata = 'NoteMetadata',
  /** column name */
  OdometerReading = 'OdometerReading',
  /** column name */
  OwnerMetadata = 'OwnerMetadata',
  /** column name */
  OwnersFirstName = 'OwnersFirstName',
  /** column name */
  OwnersLastName = 'OwnersLastName',
  /** column name */
  PhoneNumber = 'PhoneNumber',
  /** column name */
  PlanCode = 'PlanCode',
  /** column name */
  PolicyModifiedDate = 'PolicyModifiedDate',
  /** column name */
  PolicyTypeCode = 'PolicyTypeCode',
  /** column name */
  PostedDate = 'PostedDate',
  /** column name */
  PostedDateComputed = 'PostedDateComputed',
  /** column name */
  PostgresSyncUpdateDate = 'PostgresSyncUpdateDate',
  /** column name */
  PrimaryAgentCode = 'PrimaryAgentCode',
  /** column name */
  ProductMetadata = 'ProductMetadata',
  /** column name */
  ProgramCarFlag = 'ProgramCarFlag',
  /** column name */
  ReceivedDate = 'ReceivedDate',
  /** column name */
  RecordTypeCode = 'RecordTypeCode',
  /** column name */
  RedoContractPdfFilename = 'RedoContractPdfFilename',
  /** column name */
  RefundPercentage = 'RefundPercentage',
  /** column name */
  ReinstatedDate = 'ReinstatedDate',
  /** column name */
  ReinstatedDateComputed = 'ReinstatedDateComputed',
  /** column name */
  ReinstatedFlag = 'ReinstatedFlag',
  /** column name */
  Reserve2Amount = 'Reserve2Amount',
  /** column name */
  ReserveAmount = 'ReserveAmount',
  /** column name */
  ReturnCancellationToAgentFlag = 'ReturnCancellationToAgentFlag',
  /** column name */
  ReturnCancellationToCustomerFlag = 'ReturnCancellationToCustomerFlag',
  /** column name */
  ReturnCancellationToDealerFlag = 'ReturnCancellationToDealerFlag',
  /** column name */
  ReturnCancellationToFinancialInstFlag = 'ReturnCancellationToFinancialInstFlag',
  /** column name */
  ReturnCancellationToLeinHolderFlag = 'ReturnCancellationToLeinHolderFlag',
  /** column name */
  ReturnCancellationToOtherFlag = 'ReturnCancellationToOtherFlag',
  /** column name */
  ReturnFromMailingFlag = 'ReturnFromMailingFlag',
  /** column name */
  Ssn = 'SSN',
  /** column name */
  SecondaryExpirationDate = 'SecondaryExpirationDate',
  /** column name */
  SecondaryExpirationMiles = 'SecondaryExpirationMiles',
  /** column name */
  SecondaryOwnersFirstName = 'SecondaryOwnersFirstName',
  /** column name */
  SecondaryOwnersLastName = 'SecondaryOwnersLastName',
  /** column name */
  SequenceNumber = 'SequenceNumber',
  /** column name */
  SpecialReserve2Amount = 'SpecialReserve2Amount',
  /** column name */
  SpecialReserveAmount = 'SpecialReserveAmount',
  /** column name */
  StateAbbreviation = 'StateAbbreviation',
  /** column name */
  StatusCode = 'StatusCode',
  /** column name */
  SubmitExpireDate = 'SubmitExpireDate',
  /** column name */
  SurchargeCostAmount = 'SurchargeCostAmount',
  /** column name */
  SyncUpdateDate = 'SyncUpdateDate',
  /** column name */
  TransferFeeAmount = 'TransferFeeAmount',
  /** column name */
  TransferNumber = 'TransferNumber',
  /** column name */
  TransferTypeCode = 'TransferTypeCode',
  /** column name */
  TransferredFlag = 'TransferredFlag',
  /** column name */
  TrueExpireDate = 'TrueExpireDate',
  /** column name */
  TrueExpireDateComputed = 'TrueExpireDateComputed',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  UpgradedFlag = 'UpgradedFlag',
  /** column name */
  VehicleClassCode = 'VehicleClassCode',
  /** column name */
  VehicleClassificationCode = 'VehicleClassificationCode',
  /** column name */
  VehicleCost = 'VehicleCost',
  /** column name */
  VehicleInServiceDate = 'VehicleInServiceDate',
  /** column name */
  VehicleInServiceDateComputed = 'VehicleInServiceDateComputed',
  /** column name */
  VehicleMakeCode = 'VehicleMakeCode',
  /** column name */
  VehicleManufacturerCode = 'VehicleManufacturerCode',
  /** column name */
  VehicleMilesWhenCancel = 'VehicleMilesWhenCancel',
  /** column name */
  VehicleModelCode = 'VehicleModelCode',
  /** column name */
  VehiclePurchaseDate = 'VehiclePurchaseDate',
  /** column name */
  VehiclePurchaseDateComputed = 'VehiclePurchaseDateComputed',
  /** column name */
  VehicleSeriesName = 'VehicleSeriesName',
  /** column name */
  VehicleWheelsDriving = 'VehicleWheelsDriving',
  /** column name */
  VehicleYear = 'VehicleYear',
  /** column name */
  VinNotFoundFlag = 'VinNotFoundFlag',
  /** column name */
  VinNumber = 'VinNumber',
  /** column name */
  Zip = 'Zip'
}

/** aggregate var_pop on columns */
export type ContractMaster_Var_Pop_Fields = {
  __typename?: 'ContractMaster_var_pop_fields';
  AccountPostedDate?: Maybe<Scalars['Float']>;
  ActiveFromDate?: Maybe<Scalars['Float']>;
  AdjustedAdminCostAmount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: Maybe<Scalars['Float']>;
  AdjustedReserveAmount?: Maybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: Maybe<Scalars['Float']>;
  AdminCost2Amount?: Maybe<Scalars['Float']>;
  AdminCostAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AllowedTransferNumber?: Maybe<Scalars['Float']>;
  BatchNumber?: Maybe<Scalars['Float']>;
  CanMethod?: Maybe<Scalars['Float']>;
  CanRule?: Maybe<Scalars['Float']>;
  CancelAsOfDate?: Maybe<Scalars['Float']>;
  CancelBatchNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelPostedDate?: Maybe<Scalars['Float']>;
  CancelProcessFromDate?: Maybe<Scalars['Float']>;
  CancelTransferDate?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimCount?: Maybe<Scalars['Float']>;
  ClaimsPaidAmount?: Maybe<Scalars['Float']>;
  ContractMasterID?: Maybe<Scalars['Float']>;
  ContractPurchaseDate?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  CoverageCostAmount?: Maybe<Scalars['Float']>;
  CoverageMiles?: Maybe<Scalars['Float']>;
  CoverageMonths?: Maybe<Scalars['Float']>;
  CoverageOption?: Maybe<Scalars['Float']>;
  CustomerCostAmount?: Maybe<Scalars['Float']>;
  CustomerRefundAmount?: Maybe<Scalars['Float']>;
  CylinderNumber?: Maybe<Scalars['Float']>;
  DealerIncentiveAmount?: Maybe<Scalars['Float']>;
  DealerRefundAmount?: Maybe<Scalars['Float']>;
  DealerRemittedAmount?: Maybe<Scalars['Float']>;
  Deductible?: Maybe<Scalars['Float']>;
  DeniedDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExecAdminCostAmount?: Maybe<Scalars['Float']>;
  ExecMiscCost1Amount?: Maybe<Scalars['Float']>;
  ExecMiscCost2Amount?: Maybe<Scalars['Float']>;
  ExecReserveAmount?: Maybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: Maybe<Scalars['Float']>;
  ExpireMiles?: Maybe<Scalars['Float']>;
  FleetNumber?: Maybe<Scalars['Float']>;
  ForcedRefundAmount?: Maybe<Scalars['Float']>;
  LastClaimMileage?: Maybe<Scalars['Float']>;
  LastTransferDate?: Maybe<Scalars['Float']>;
  LastTransferMileage?: Maybe<Scalars['Float']>;
  MBPIRefundAmount?: Maybe<Scalars['Float']>;
  MaxDaysToPayNumber?: Maybe<Scalars['Float']>;
  MaxPayPerDayAmount?: Maybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: Maybe<Scalars['Float']>;
  MiscCost1Amount?: Maybe<Scalars['Float']>;
  MiscCost2Amount?: Maybe<Scalars['Float']>;
  MiscCost3Amount?: Maybe<Scalars['Float']>;
  MiscCost4Amount?: Maybe<Scalars['Float']>;
  OdometerReading?: Maybe<Scalars['Float']>;
  PolicyModifiedDate?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  ReceivedDate?: Maybe<Scalars['Float']>;
  RefundPercentage?: Maybe<Scalars['Float']>;
  ReinstatedDate?: Maybe<Scalars['Float']>;
  Reserve2Amount?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: Maybe<Scalars['Float']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserve2Amount?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StatusCode?: Maybe<Scalars['Float']>;
  SubmitExpireDate?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  TransferFeeAmount?: Maybe<Scalars['Float']>;
  TransferNumber?: Maybe<Scalars['Float']>;
  TrueExpireDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  VehicleCost?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleMilesWhenCancel?: Maybe<Scalars['Float']>;
  VehiclePurchaseDate?: Maybe<Scalars['Float']>;
  VehicleWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ContractMaster" */
export type ContractMaster_Var_Pop_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ContractMaster_Var_Samp_Fields = {
  __typename?: 'ContractMaster_var_samp_fields';
  AccountPostedDate?: Maybe<Scalars['Float']>;
  ActiveFromDate?: Maybe<Scalars['Float']>;
  AdjustedAdminCostAmount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: Maybe<Scalars['Float']>;
  AdjustedReserveAmount?: Maybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: Maybe<Scalars['Float']>;
  AdminCost2Amount?: Maybe<Scalars['Float']>;
  AdminCostAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AllowedTransferNumber?: Maybe<Scalars['Float']>;
  BatchNumber?: Maybe<Scalars['Float']>;
  CanMethod?: Maybe<Scalars['Float']>;
  CanRule?: Maybe<Scalars['Float']>;
  CancelAsOfDate?: Maybe<Scalars['Float']>;
  CancelBatchNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelPostedDate?: Maybe<Scalars['Float']>;
  CancelProcessFromDate?: Maybe<Scalars['Float']>;
  CancelTransferDate?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimCount?: Maybe<Scalars['Float']>;
  ClaimsPaidAmount?: Maybe<Scalars['Float']>;
  ContractMasterID?: Maybe<Scalars['Float']>;
  ContractPurchaseDate?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  CoverageCostAmount?: Maybe<Scalars['Float']>;
  CoverageMiles?: Maybe<Scalars['Float']>;
  CoverageMonths?: Maybe<Scalars['Float']>;
  CoverageOption?: Maybe<Scalars['Float']>;
  CustomerCostAmount?: Maybe<Scalars['Float']>;
  CustomerRefundAmount?: Maybe<Scalars['Float']>;
  CylinderNumber?: Maybe<Scalars['Float']>;
  DealerIncentiveAmount?: Maybe<Scalars['Float']>;
  DealerRefundAmount?: Maybe<Scalars['Float']>;
  DealerRemittedAmount?: Maybe<Scalars['Float']>;
  Deductible?: Maybe<Scalars['Float']>;
  DeniedDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExecAdminCostAmount?: Maybe<Scalars['Float']>;
  ExecMiscCost1Amount?: Maybe<Scalars['Float']>;
  ExecMiscCost2Amount?: Maybe<Scalars['Float']>;
  ExecReserveAmount?: Maybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: Maybe<Scalars['Float']>;
  ExpireMiles?: Maybe<Scalars['Float']>;
  FleetNumber?: Maybe<Scalars['Float']>;
  ForcedRefundAmount?: Maybe<Scalars['Float']>;
  LastClaimMileage?: Maybe<Scalars['Float']>;
  LastTransferDate?: Maybe<Scalars['Float']>;
  LastTransferMileage?: Maybe<Scalars['Float']>;
  MBPIRefundAmount?: Maybe<Scalars['Float']>;
  MaxDaysToPayNumber?: Maybe<Scalars['Float']>;
  MaxPayPerDayAmount?: Maybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: Maybe<Scalars['Float']>;
  MiscCost1Amount?: Maybe<Scalars['Float']>;
  MiscCost2Amount?: Maybe<Scalars['Float']>;
  MiscCost3Amount?: Maybe<Scalars['Float']>;
  MiscCost4Amount?: Maybe<Scalars['Float']>;
  OdometerReading?: Maybe<Scalars['Float']>;
  PolicyModifiedDate?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  ReceivedDate?: Maybe<Scalars['Float']>;
  RefundPercentage?: Maybe<Scalars['Float']>;
  ReinstatedDate?: Maybe<Scalars['Float']>;
  Reserve2Amount?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: Maybe<Scalars['Float']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserve2Amount?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StatusCode?: Maybe<Scalars['Float']>;
  SubmitExpireDate?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  TransferFeeAmount?: Maybe<Scalars['Float']>;
  TransferNumber?: Maybe<Scalars['Float']>;
  TrueExpireDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  VehicleCost?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleMilesWhenCancel?: Maybe<Scalars['Float']>;
  VehiclePurchaseDate?: Maybe<Scalars['Float']>;
  VehicleWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ContractMaster" */
export type ContractMaster_Var_Samp_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ContractMaster_Variance_Fields = {
  __typename?: 'ContractMaster_variance_fields';
  AccountPostedDate?: Maybe<Scalars['Float']>;
  ActiveFromDate?: Maybe<Scalars['Float']>;
  AdjustedAdminCostAmount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost1Amount?: Maybe<Scalars['Float']>;
  AdjustedMiscCost2Amount?: Maybe<Scalars['Float']>;
  AdjustedReserveAmount?: Maybe<Scalars['Float']>;
  AdjustedSpecialReserveAmount?: Maybe<Scalars['Float']>;
  AdminCost2Amount?: Maybe<Scalars['Float']>;
  AdminCostAmount?: Maybe<Scalars['Float']>;
  AgreementNumber?: Maybe<Scalars['Float']>;
  AllowedTransferNumber?: Maybe<Scalars['Float']>;
  BatchNumber?: Maybe<Scalars['Float']>;
  CanMethod?: Maybe<Scalars['Float']>;
  CanRule?: Maybe<Scalars['Float']>;
  CancelAsOfDate?: Maybe<Scalars['Float']>;
  CancelBatchNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelPostedDate?: Maybe<Scalars['Float']>;
  CancelProcessFromDate?: Maybe<Scalars['Float']>;
  CancelTransferDate?: Maybe<Scalars['Float']>;
  ChecksumColumn?: Maybe<Scalars['Float']>;
  ClaimCount?: Maybe<Scalars['Float']>;
  ClaimsPaidAmount?: Maybe<Scalars['Float']>;
  ContractMasterID?: Maybe<Scalars['Float']>;
  ContractPurchaseDate?: Maybe<Scalars['Float']>;
  ConversionDate?: Maybe<Scalars['Float']>;
  CoverageCostAmount?: Maybe<Scalars['Float']>;
  CoverageMiles?: Maybe<Scalars['Float']>;
  CoverageMonths?: Maybe<Scalars['Float']>;
  CoverageOption?: Maybe<Scalars['Float']>;
  CustomerCostAmount?: Maybe<Scalars['Float']>;
  CustomerRefundAmount?: Maybe<Scalars['Float']>;
  CylinderNumber?: Maybe<Scalars['Float']>;
  DealerIncentiveAmount?: Maybe<Scalars['Float']>;
  DealerRefundAmount?: Maybe<Scalars['Float']>;
  DealerRemittedAmount?: Maybe<Scalars['Float']>;
  Deductible?: Maybe<Scalars['Float']>;
  DeniedDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExecAdminCostAmount?: Maybe<Scalars['Float']>;
  ExecMiscCost1Amount?: Maybe<Scalars['Float']>;
  ExecMiscCost2Amount?: Maybe<Scalars['Float']>;
  ExecReserveAmount?: Maybe<Scalars['Float']>;
  ExecSpecialReserveAmount?: Maybe<Scalars['Float']>;
  ExpireMiles?: Maybe<Scalars['Float']>;
  FleetNumber?: Maybe<Scalars['Float']>;
  ForcedRefundAmount?: Maybe<Scalars['Float']>;
  LastClaimMileage?: Maybe<Scalars['Float']>;
  LastTransferDate?: Maybe<Scalars['Float']>;
  LastTransferMileage?: Maybe<Scalars['Float']>;
  MBPIRefundAmount?: Maybe<Scalars['Float']>;
  MaxDaysToPayNumber?: Maybe<Scalars['Float']>;
  MaxPayPerDayAmount?: Maybe<Scalars['Float']>;
  MaxTowingExpenseAmount?: Maybe<Scalars['Float']>;
  MiscCost1Amount?: Maybe<Scalars['Float']>;
  MiscCost2Amount?: Maybe<Scalars['Float']>;
  MiscCost3Amount?: Maybe<Scalars['Float']>;
  MiscCost4Amount?: Maybe<Scalars['Float']>;
  OdometerReading?: Maybe<Scalars['Float']>;
  PolicyModifiedDate?: Maybe<Scalars['Float']>;
  PostedDate?: Maybe<Scalars['Float']>;
  ReceivedDate?: Maybe<Scalars['Float']>;
  RefundPercentage?: Maybe<Scalars['Float']>;
  ReinstatedDate?: Maybe<Scalars['Float']>;
  Reserve2Amount?: Maybe<Scalars['Float']>;
  ReserveAmount?: Maybe<Scalars['Float']>;
  ReturnCancellationToAgentFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToCustomerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToDealerFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToFinancialInstFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToLeinHolderFlag?: Maybe<Scalars['Float']>;
  ReturnCancellationToOtherFlag?: Maybe<Scalars['Float']>;
  SecondaryExpirationMiles?: Maybe<Scalars['Float']>;
  SequenceNumber?: Maybe<Scalars['Float']>;
  SpecialReserve2Amount?: Maybe<Scalars['Float']>;
  SpecialReserveAmount?: Maybe<Scalars['Float']>;
  StatusCode?: Maybe<Scalars['Float']>;
  SubmitExpireDate?: Maybe<Scalars['Float']>;
  SurchargeCostAmount?: Maybe<Scalars['Float']>;
  TransferFeeAmount?: Maybe<Scalars['Float']>;
  TransferNumber?: Maybe<Scalars['Float']>;
  TrueExpireDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  VehicleCost?: Maybe<Scalars['Float']>;
  VehicleInServiceDate?: Maybe<Scalars['Float']>;
  VehicleMilesWhenCancel?: Maybe<Scalars['Float']>;
  VehiclePurchaseDate?: Maybe<Scalars['Float']>;
  VehicleWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ContractMaster" */
export type ContractMaster_Variance_Order_By = {
  AccountPostedDate?: InputMaybe<Order_By>;
  ActiveFromDate?: InputMaybe<Order_By>;
  AdjustedAdminCostAmount?: InputMaybe<Order_By>;
  AdjustedMiscCost1Amount?: InputMaybe<Order_By>;
  AdjustedMiscCost2Amount?: InputMaybe<Order_By>;
  AdjustedReserveAmount?: InputMaybe<Order_By>;
  AdjustedSpecialReserveAmount?: InputMaybe<Order_By>;
  AdminCost2Amount?: InputMaybe<Order_By>;
  AdminCostAmount?: InputMaybe<Order_By>;
  AgreementNumber?: InputMaybe<Order_By>;
  AllowedTransferNumber?: InputMaybe<Order_By>;
  BatchNumber?: InputMaybe<Order_By>;
  CanMethod?: InputMaybe<Order_By>;
  CanRule?: InputMaybe<Order_By>;
  CancelAsOfDate?: InputMaybe<Order_By>;
  CancelBatchNumber?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelPostedDate?: InputMaybe<Order_By>;
  CancelProcessFromDate?: InputMaybe<Order_By>;
  CancelTransferDate?: InputMaybe<Order_By>;
  ChecksumColumn?: InputMaybe<Order_By>;
  ClaimCount?: InputMaybe<Order_By>;
  ClaimsPaidAmount?: InputMaybe<Order_By>;
  ContractMasterID?: InputMaybe<Order_By>;
  ContractPurchaseDate?: InputMaybe<Order_By>;
  ConversionDate?: InputMaybe<Order_By>;
  CoverageCostAmount?: InputMaybe<Order_By>;
  CoverageMiles?: InputMaybe<Order_By>;
  CoverageMonths?: InputMaybe<Order_By>;
  CoverageOption?: InputMaybe<Order_By>;
  CustomerCostAmount?: InputMaybe<Order_By>;
  CustomerRefundAmount?: InputMaybe<Order_By>;
  CylinderNumber?: InputMaybe<Order_By>;
  DealerIncentiveAmount?: InputMaybe<Order_By>;
  DealerRefundAmount?: InputMaybe<Order_By>;
  DealerRemittedAmount?: InputMaybe<Order_By>;
  Deductible?: InputMaybe<Order_By>;
  DeniedDate?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  ExecAdminCostAmount?: InputMaybe<Order_By>;
  ExecMiscCost1Amount?: InputMaybe<Order_By>;
  ExecMiscCost2Amount?: InputMaybe<Order_By>;
  ExecReserveAmount?: InputMaybe<Order_By>;
  ExecSpecialReserveAmount?: InputMaybe<Order_By>;
  ExpireMiles?: InputMaybe<Order_By>;
  FleetNumber?: InputMaybe<Order_By>;
  ForcedRefundAmount?: InputMaybe<Order_By>;
  LastClaimMileage?: InputMaybe<Order_By>;
  LastTransferDate?: InputMaybe<Order_By>;
  LastTransferMileage?: InputMaybe<Order_By>;
  MBPIRefundAmount?: InputMaybe<Order_By>;
  MaxDaysToPayNumber?: InputMaybe<Order_By>;
  MaxPayPerDayAmount?: InputMaybe<Order_By>;
  MaxTowingExpenseAmount?: InputMaybe<Order_By>;
  MiscCost1Amount?: InputMaybe<Order_By>;
  MiscCost2Amount?: InputMaybe<Order_By>;
  MiscCost3Amount?: InputMaybe<Order_By>;
  MiscCost4Amount?: InputMaybe<Order_By>;
  OdometerReading?: InputMaybe<Order_By>;
  PolicyModifiedDate?: InputMaybe<Order_By>;
  PostedDate?: InputMaybe<Order_By>;
  ReceivedDate?: InputMaybe<Order_By>;
  RefundPercentage?: InputMaybe<Order_By>;
  ReinstatedDate?: InputMaybe<Order_By>;
  Reserve2Amount?: InputMaybe<Order_By>;
  ReserveAmount?: InputMaybe<Order_By>;
  ReturnCancellationToAgentFlag?: InputMaybe<Order_By>;
  ReturnCancellationToCustomerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToDealerFlag?: InputMaybe<Order_By>;
  ReturnCancellationToFinancialInstFlag?: InputMaybe<Order_By>;
  ReturnCancellationToLeinHolderFlag?: InputMaybe<Order_By>;
  ReturnCancellationToOtherFlag?: InputMaybe<Order_By>;
  SecondaryExpirationMiles?: InputMaybe<Order_By>;
  SequenceNumber?: InputMaybe<Order_By>;
  SpecialReserve2Amount?: InputMaybe<Order_By>;
  SpecialReserveAmount?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  SubmitExpireDate?: InputMaybe<Order_By>;
  SurchargeCostAmount?: InputMaybe<Order_By>;
  TransferFeeAmount?: InputMaybe<Order_By>;
  TransferNumber?: InputMaybe<Order_By>;
  TrueExpireDate?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  VehicleCost?: InputMaybe<Order_By>;
  VehicleInServiceDate?: InputMaybe<Order_By>;
  VehicleMilesWhenCancel?: InputMaybe<Order_By>;
  VehiclePurchaseDate?: InputMaybe<Order_By>;
  VehicleWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

export type Contract_Denial_V1 = {
  __typename?: 'Contract_Denial_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerAddress1: Scalars['String'];
  customerAddress2: Scalars['String'];
  customerCity: Scalars['String'];
  customerName1: Scalars['String'];
  customerName2: Scalars['String'];
  customerState: Scalars['String'];
  customerZip: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  reasonForDenial: Scalars['String'];
  vin: Scalars['String'];
};

/** aggregate fields of "vpic.conversion" */
export type Conversion_Aggregate_Fields_Vpic = {
  __typename?: 'Conversion_aggregate_fields_vpic';
  avg?: Maybe<Conversion_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Conversion_Max_Fields_Vpic>;
  min?: Maybe<Conversion_Min_Fields_Vpic>;
  stddev?: Maybe<Conversion_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Conversion_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Conversion_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Conversion_Sum_Fields_Vpic>;
  var_pop?: Maybe<Conversion_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Conversion_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Conversion_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.conversion" */
export type Conversion_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Conversion_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.conversion" */
export type Conversion_Aggregate_Vpic = {
  __typename?: 'Conversion_aggregate_vpic';
  aggregate?: Maybe<Conversion_Aggregate_Fields_Vpic>;
  nodes: Array<Conversion_Vpic>;
};

/** aggregate avg on columns */
export type Conversion_Avg_Fields_Vpic = {
  __typename?: 'Conversion_avg_fields_vpic';
  FromElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  ToElementId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.conversion". All fields are combined with a logical 'AND'. */
export type Conversion_Bool_Exp_Vpic = {
  Formula?: InputMaybe<String_Comparison_Exp>;
  FromElementId?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  ToElementId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Conversion_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Conversion_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Conversion_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.conversion" */
export enum Conversion_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkConversion = 'pk_conversion'
}

/** input type for incrementing numeric columns in table "vpic.conversion" */
export type Conversion_Inc_Input_Vpic = {
  FromElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  ToElementId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.conversion" */
export type Conversion_Insert_Input_Vpic = {
  Formula?: InputMaybe<Scalars['String']>;
  FromElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  ToElementId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Conversion_Max_Fields_Vpic = {
  __typename?: 'Conversion_max_fields_vpic';
  Formula?: Maybe<Scalars['String']>;
  FromElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  ToElementId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Conversion_Min_Fields_Vpic = {
  __typename?: 'Conversion_min_fields_vpic';
  Formula?: Maybe<Scalars['String']>;
  FromElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  ToElementId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vpic.conversion" */
export type Conversion_Mutation_Response_Vpic = {
  __typename?: 'Conversion_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Conversion_Vpic>;
};

/** on_conflict condition type for table "vpic.conversion" */
export type Conversion_On_Conflict_Vpic = {
  constraint: Conversion_Constraint_Vpic;
  update_columns?: Array<Conversion_Update_Column_Vpic>;
  where?: InputMaybe<Conversion_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.conversion". */
export type Conversion_Order_By_Vpic = {
  Formula?: InputMaybe<Order_By>;
  FromElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ToElementId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.conversion */
export type Conversion_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.conversion" */
export enum Conversion_Select_Column_Vpic {
  /** column name */
  Formula = 'Formula',
  /** column name */
  FromElementId = 'FromElementId',
  /** column name */
  Id = 'Id',
  /** column name */
  ToElementId = 'ToElementId'
}

/** input type for updating data in table "vpic.conversion" */
export type Conversion_Set_Input_Vpic = {
  Formula?: InputMaybe<Scalars['String']>;
  FromElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  ToElementId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Conversion_Stddev_Fields_Vpic = {
  __typename?: 'Conversion_stddev_fields_vpic';
  FromElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  ToElementId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Conversion_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Conversion_stddev_pop_fields_vpic';
  FromElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  ToElementId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Conversion_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Conversion_stddev_samp_fields_vpic';
  FromElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  ToElementId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Conversion" */
export type Conversion_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Conversion_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Conversion_Stream_Cursor_Value_Input_Vpic = {
  Formula?: InputMaybe<Scalars['String']>;
  FromElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  ToElementId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Conversion_Sum_Fields_Vpic = {
  __typename?: 'Conversion_sum_fields_vpic';
  FromElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  ToElementId?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.conversion" */
export enum Conversion_Update_Column_Vpic {
  /** column name */
  Formula = 'Formula',
  /** column name */
  FromElementId = 'FromElementId',
  /** column name */
  Id = 'Id',
  /** column name */
  ToElementId = 'ToElementId'
}

export type Conversion_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Conversion_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Conversion_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Conversion_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Conversion_Var_Pop_Fields_Vpic = {
  __typename?: 'Conversion_var_pop_fields_vpic';
  FromElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  ToElementId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Conversion_Var_Samp_Fields_Vpic = {
  __typename?: 'Conversion_var_samp_fields_vpic';
  FromElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  ToElementId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Conversion_Variance_Fields_Vpic = {
  __typename?: 'Conversion_variance_fields_vpic';
  FromElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  ToElementId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.conversion" */
export type Conversion_Vpic = {
  __typename?: 'Conversion_vpic';
  Formula: Scalars['String'];
  FromElementId: Scalars['Int'];
  Id: Scalars['Int'];
  ToElementId: Scalars['Int'];
};

/** aggregate fields of "vpic.coolingtype" */
export type CoolingType_Aggregate_Fields_Vpic = {
  __typename?: 'CoolingType_aggregate_fields_vpic';
  avg?: Maybe<CoolingType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<CoolingType_Max_Fields_Vpic>;
  min?: Maybe<CoolingType_Min_Fields_Vpic>;
  stddev?: Maybe<CoolingType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<CoolingType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<CoolingType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<CoolingType_Sum_Fields_Vpic>;
  var_pop?: Maybe<CoolingType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<CoolingType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<CoolingType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.coolingtype" */
export type CoolingType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<CoolingType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.coolingtype" */
export type CoolingType_Aggregate_Vpic = {
  __typename?: 'CoolingType_aggregate_vpic';
  aggregate?: Maybe<CoolingType_Aggregate_Fields_Vpic>;
  nodes: Array<CoolingType_Vpic>;
};

/** aggregate avg on columns */
export type CoolingType_Avg_Fields_Vpic = {
  __typename?: 'CoolingType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.coolingtype". All fields are combined with a logical 'AND'. */
export type CoolingType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<CoolingType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<CoolingType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<CoolingType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.coolingtype" */
export enum CoolingType_Constraint_Vpic {
  /** unique or primary key constraint on columns "name" */
  IxCoolingtype = 'ix_coolingtype',
  /** unique or primary key constraint on columns "id" */
  PkCoolingtype = 'pk_coolingtype'
}

/** input type for incrementing numeric columns in table "vpic.coolingtype" */
export type CoolingType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.coolingtype" */
export type CoolingType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CoolingType_Max_Fields_Vpic = {
  __typename?: 'CoolingType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CoolingType_Min_Fields_Vpic = {
  __typename?: 'CoolingType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.coolingtype" */
export type CoolingType_Mutation_Response_Vpic = {
  __typename?: 'CoolingType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoolingType_Vpic>;
};

/** on_conflict condition type for table "vpic.coolingtype" */
export type CoolingType_On_Conflict_Vpic = {
  constraint: CoolingType_Constraint_Vpic;
  update_columns?: Array<CoolingType_Update_Column_Vpic>;
  where?: InputMaybe<CoolingType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.coolingtype". */
export type CoolingType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.coolingtype */
export type CoolingType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.coolingtype" */
export enum CoolingType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.coolingtype" */
export type CoolingType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CoolingType_Stddev_Fields_Vpic = {
  __typename?: 'CoolingType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CoolingType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'CoolingType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CoolingType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'CoolingType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "CoolingType" */
export type CoolingType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: CoolingType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type CoolingType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CoolingType_Sum_Fields_Vpic = {
  __typename?: 'CoolingType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.coolingtype" */
export enum CoolingType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type CoolingType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CoolingType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoolingType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: CoolingType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type CoolingType_Var_Pop_Fields_Vpic = {
  __typename?: 'CoolingType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CoolingType_Var_Samp_Fields_Vpic = {
  __typename?: 'CoolingType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CoolingType_Variance_Fields_Vpic = {
  __typename?: 'CoolingType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.coolingtype" */
export type CoolingType_Vpic = {
  __typename?: 'CoolingType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.country" */
export type Country_Aggregate_Fields_Vpic = {
  __typename?: 'Country_aggregate_fields_vpic';
  avg?: Maybe<Country_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Country_Max_Fields_Vpic>;
  min?: Maybe<Country_Min_Fields_Vpic>;
  stddev?: Maybe<Country_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Country_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Country_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Country_Sum_Fields_Vpic>;
  var_pop?: Maybe<Country_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Country_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Country_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.country" */
export type Country_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Country_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.country" */
export type Country_Aggregate_Vpic = {
  __typename?: 'Country_aggregate_vpic';
  aggregate?: Maybe<Country_Aggregate_Fields_Vpic>;
  nodes: Array<Country_Vpic>;
};

/** aggregate avg on columns */
export type Country_Avg_Fields_Vpic = {
  __typename?: 'Country_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  displayorder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.country". All fields are combined with a logical 'AND'. */
export type Country_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Country_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Country_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Country_Bool_Exp_Vpic>>;
  displayorder?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vpic.country" */
export enum Country_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkCountry = 'pk_country',
  /** unique or primary key constraint on columns "name" */
  UCountryname = 'u_countryname'
}

/** input type for incrementing numeric columns in table "vpic.country" */
export type Country_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  displayorder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.country" */
export type Country_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  displayorder?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Country_Max_Fields_Vpic = {
  __typename?: 'Country_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  displayorder?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Country_Min_Fields_Vpic = {
  __typename?: 'Country_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  displayorder?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vpic.country" */
export type Country_Mutation_Response_Vpic = {
  __typename?: 'Country_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Country_Vpic>;
};

/** on_conflict condition type for table "vpic.country" */
export type Country_On_Conflict_Vpic = {
  constraint: Country_Constraint_Vpic;
  update_columns?: Array<Country_Update_Column_Vpic>;
  where?: InputMaybe<Country_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.country". */
export type Country_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  displayorder?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.country */
export type Country_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.country" */
export enum Country_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Displayorder = 'displayorder'
}

/** input type for updating data in table "vpic.country" */
export type Country_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  displayorder?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Country_Stddev_Fields_Vpic = {
  __typename?: 'Country_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  displayorder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Country_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Country_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  displayorder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Country_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Country_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  displayorder?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Country" */
export type Country_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Country_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  displayorder?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Country_Sum_Fields_Vpic = {
  __typename?: 'Country_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  displayorder?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.country" */
export enum Country_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Displayorder = 'displayorder'
}

export type Country_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Country_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Country_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Country_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Country_Var_Pop_Fields_Vpic = {
  __typename?: 'Country_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  displayorder?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Country_Var_Samp_Fields_Vpic = {
  __typename?: 'Country_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  displayorder?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Country_Variance_Fields_Vpic = {
  __typename?: 'Country_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  displayorder?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.country" */
export type Country_Vpic = {
  __typename?: 'Country_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
  displayorder?: Maybe<Scalars['Int']>;
};

export type CreditCardMetadata = {
  __typename?: 'CreditCardMetadata';
  accountNumber: Scalars['String'];
  cardHolderName: Scalars['String'];
  expirationMonth: Scalars['numeric'];
  expirationYear: Scalars['numeric'];
  useForDownPayment: Scalars['Boolean'];
  useForMonthlyPayment: Scalars['Boolean'];
};

/** aggregate fields of "vpic.custommotorcycletype" */
export type CustomMotorcycleType_Aggregate_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_aggregate_fields_vpic';
  avg?: Maybe<CustomMotorcycleType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<CustomMotorcycleType_Max_Fields_Vpic>;
  min?: Maybe<CustomMotorcycleType_Min_Fields_Vpic>;
  stddev?: Maybe<CustomMotorcycleType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<CustomMotorcycleType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<CustomMotorcycleType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<CustomMotorcycleType_Sum_Fields_Vpic>;
  var_pop?: Maybe<CustomMotorcycleType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<CustomMotorcycleType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<CustomMotorcycleType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.custommotorcycletype" */
export type CustomMotorcycleType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<CustomMotorcycleType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.custommotorcycletype" */
export type CustomMotorcycleType_Aggregate_Vpic = {
  __typename?: 'CustomMotorcycleType_aggregate_vpic';
  aggregate?: Maybe<CustomMotorcycleType_Aggregate_Fields_Vpic>;
  nodes: Array<CustomMotorcycleType_Vpic>;
};

/** aggregate avg on columns */
export type CustomMotorcycleType_Avg_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.custommotorcycletype". All fields are combined with a logical 'AND'. */
export type CustomMotorcycleType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<CustomMotorcycleType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<CustomMotorcycleType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<CustomMotorcycleType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.custommotorcycletype" */
export enum CustomMotorcycleType_Constraint_Vpic {
  /** unique or primary key constraint on columns "name" */
  IxCustommotorcycletype = 'ix_custommotorcycletype',
  /** unique or primary key constraint on columns "id" */
  PkCustommotorcycletype = 'pk_custommotorcycletype'
}

/** input type for incrementing numeric columns in table "vpic.custommotorcycletype" */
export type CustomMotorcycleType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.custommotorcycletype" */
export type CustomMotorcycleType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CustomMotorcycleType_Max_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CustomMotorcycleType_Min_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.custommotorcycletype" */
export type CustomMotorcycleType_Mutation_Response_Vpic = {
  __typename?: 'CustomMotorcycleType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomMotorcycleType_Vpic>;
};

/** on_conflict condition type for table "vpic.custommotorcycletype" */
export type CustomMotorcycleType_On_Conflict_Vpic = {
  constraint: CustomMotorcycleType_Constraint_Vpic;
  update_columns?: Array<CustomMotorcycleType_Update_Column_Vpic>;
  where?: InputMaybe<CustomMotorcycleType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.custommotorcycletype". */
export type CustomMotorcycleType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.custommotorcycletype */
export type CustomMotorcycleType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.custommotorcycletype" */
export enum CustomMotorcycleType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.custommotorcycletype" */
export type CustomMotorcycleType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CustomMotorcycleType_Stddev_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CustomMotorcycleType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CustomMotorcycleType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "CustomMotorcycleType" */
export type CustomMotorcycleType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: CustomMotorcycleType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type CustomMotorcycleType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CustomMotorcycleType_Sum_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.custommotorcycletype" */
export enum CustomMotorcycleType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type CustomMotorcycleType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CustomMotorcycleType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomMotorcycleType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: CustomMotorcycleType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type CustomMotorcycleType_Var_Pop_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CustomMotorcycleType_Var_Samp_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CustomMotorcycleType_Variance_Fields_Vpic = {
  __typename?: 'CustomMotorcycleType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.custommotorcycletype" */
export type CustomMotorcycleType_Vpic = {
  __typename?: 'CustomMotorcycleType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type CustomTypesForGeneration = {
  __typename?: 'CustomTypesForGeneration';
  PolicyContractAsset_IdentifierMetadata_Vehicle: PolicyContractAsset_IdentifierMetadata_Vehicle;
  PolicyContractCostDetail_BucketMetadata: Array<Maybe<Bucket>>;
  PolicyContractCostDetail_CostMetadata: PolicyContractCostDetail_CostMetadata;
  PolicyContractCostDetail_DisbursementMetadata: Array<Maybe<Disbursement>>;
  PolicyContractObligorMetadata: PolicyContract_ObligorMetadata;
  PolicyContractQuote_ProductOptionsMetadata: PolicyContractQuote_ProductOptionsMetadata;
  achMetadata: AchMetadata;
  cancelQuoteMetadata: CancelQuoteMetadata;
  cancelQuoteResultMetadata: CancelQuoteResultMetadata;
  cancellationMetadata: Cancellation_Metadata;
  claimDetailDeductionMetadata?: Maybe<Scalars['StringToNumberMap']>;
  claimDetailJobTypeMetadata: ClaimDetail_JobType_Metadata;
  claimDetailRefundMetadata?: Maybe<Scalars['StringToNumberMap']>;
  creditCardMetadata: CreditCardMetadata;
  documentInstanceMetadataTypes: DocumentInstanceMetadataTypes;
  expirationCalculationMetadata: ExpirationCalculationMetadata;
  fileStorageMetadata: FileStorageMetadata;
  globalSearchCommandMetadata: GlobalSearchCommand_Metadata;
  jobScheduleMetadata: JobScheduleMetadata;
  laborGuideMetadata: LaborGuide_Metadata;
  legacyPolicyContractAccountManagerMetadata: LegacyPolicyContract_AccountManagerMetadata;
  legacyPolicyContractAccountMetadata: LegacyPolicyContract_AccountMetadata;
  legacyPolicyContractAssetMetadata: LegacyPolicyContract_AssetMetadata;
  legacyPolicyContractCostDetailMetadata: LegacyPolicyContract_CostDetailMetadata;
  legacyPolicyContractLenderMetadata: LegacyPolicyContract_LenderMetadata;
  legacyPolicyContractNoteMetadata: LegacyPolicyContract_NoteMetadata;
  legacyPolicyContractOwnerMetadata: LegacyPolicyContract_OwnerMetadata;
  legacyPolicyContractProductMetadata: LegacyPolicyContract_ProductMetadata;
  legacyPolicyContractStatusMetadata: LegacyPolicyContract_StatusMetadata;
  legacyPolicyContractSurchargeMetadata: LegacyPolicyContract_SurchargeMetadata;
  oryPublicMetadata: OryPublicMetadata;
  oryTraits: OryTraits;
  policyClaimAssetMetadata: PolicyClaim_AssetMetadata;
  policyClaimMetadata: PolicyClaim_Metadata;
  policyClaimReportingMetadata?: Maybe<Scalars['StringToNumberMap']>;
  policyContractAssetMetadata: PolicyContract_AssetMetadata;
  policyContractOptionalCoverageMetadata: PolicyContract_OptionalCoverageMetadata;
  policyContractProductMetadata: PolicyContract_ProductMetadata;
  policyContractSurchageMetadata: PolicyContract_SurchageMetadata;
  quoteEditMetadata: QuoteEditMetadata;
  quoteMetadata: QuoteMetadata;
  quoteResultMetadata: QuoteResultMetadata;
  serviceProviderTypeMetadata: ServiceProviderType_Metadata;
  shortcutBindingMetadata: ShortcutBinding_BindingMetadata;
};

export type Customer_Address_Only_V1 = {
  __typename?: 'Customer_Address_Only_v1';
  customerAddress1: Scalars['String'];
  customerAddress2: Scalars['String'];
  customerCity: Scalars['String'];
  customerName1: Scalars['String'];
  customerName2?: Maybe<Scalars['String']>;
  customerState: Scalars['String'];
  customerZip: Scalars['String'];
};

export type Cxl_Add_Doc_Req_Mileage_V1 = {
  __typename?: 'Cxl_Add_Doc_Req_Mileage_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName1: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  vin: Scalars['String'];
};

export type Cxl_Add_Doc_Req_Sign_V1 = {
  __typename?: 'Cxl_Add_Doc_Req_Sign_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName1: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  vin: Scalars['String'];
};

export type Cxl_Do_Check_Statement_V1 = {
  __typename?: 'Cxl_DO_Check_Statement_v1';
  cancelAsOfDate: Scalars['date'];
  categoryName: Scalars['String'];
  claimsPaidAmount?: Maybe<Scalars['numeric']>;
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  feeAmount: Scalars['numeric'];
  refundAmount: Scalars['numeric'];
  refundPercent: Scalars['numeric'];
  subtractClaims?: Maybe<Scalars['Boolean']>;
  vin: Scalars['String'];
};

export type Cxl_Denied_Non_Cancellable_Dlr_V1 = {
  __typename?: 'Cxl_Denied_Non_Cancellable_Dlr_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  vin: Scalars['String'];
};

export type Cxl_Denied_Previously_Denied_Dlr_V1 = {
  __typename?: 'Cxl_Denied_Previously_Denied_Dlr_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  vin: Scalars['String'];
};

export type Cxl_Denied_Suspended_Dlr_V1 = {
  __typename?: 'Cxl_Denied_Suspended_Dlr_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  vin: Scalars['String'];
};

export type Cxl_Proof_Of_Cancellation_Customer_V1 = {
  __typename?: 'Cxl_Proof_Of_Cancellation_Customer_v1';
  cancelAsOfDate: Scalars['date'];
  cancelFee: Scalars['numeric'];
  categoryName: Scalars['String'];
  claimsPaidAmount: Scalars['numeric'];
  contractNumber: Scalars['String'];
  customerAddress1: Scalars['String'];
  customerAddress2: Scalars['String'];
  customerCity: Scalars['String'];
  customerName1: Scalars['String'];
  customerName2?: Maybe<Scalars['String']>;
  customerState: Scalars['String'];
  customerZip: Scalars['String'];
  date: Scalars['date'];
  refundPercent: Scalars['numeric'];
  vin: Scalars['String'];
};

/** aggregate fields of "vpic.daytimerunninglight" */
export type DaytimeRunningLight_Aggregate_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_aggregate_fields_vpic';
  avg?: Maybe<DaytimeRunningLight_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<DaytimeRunningLight_Max_Fields_Vpic>;
  min?: Maybe<DaytimeRunningLight_Min_Fields_Vpic>;
  stddev?: Maybe<DaytimeRunningLight_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<DaytimeRunningLight_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<DaytimeRunningLight_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<DaytimeRunningLight_Sum_Fields_Vpic>;
  var_pop?: Maybe<DaytimeRunningLight_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<DaytimeRunningLight_Var_Samp_Fields_Vpic>;
  variance?: Maybe<DaytimeRunningLight_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.daytimerunninglight" */
export type DaytimeRunningLight_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<DaytimeRunningLight_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.daytimerunninglight" */
export type DaytimeRunningLight_Aggregate_Vpic = {
  __typename?: 'DaytimeRunningLight_aggregate_vpic';
  aggregate?: Maybe<DaytimeRunningLight_Aggregate_Fields_Vpic>;
  nodes: Array<DaytimeRunningLight_Vpic>;
};

/** aggregate avg on columns */
export type DaytimeRunningLight_Avg_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.daytimerunninglight". All fields are combined with a logical 'AND'. */
export type DaytimeRunningLight_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<DaytimeRunningLight_Bool_Exp_Vpic>>;
  _not?: InputMaybe<DaytimeRunningLight_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<DaytimeRunningLight_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.daytimerunninglight" */
export enum DaytimeRunningLight_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkDaytimer_3214ec07e6e39743 = 'pk__daytimer__3214ec07e6e39743'
}

/** input type for incrementing numeric columns in table "vpic.daytimerunninglight" */
export type DaytimeRunningLight_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.daytimerunninglight" */
export type DaytimeRunningLight_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DaytimeRunningLight_Max_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DaytimeRunningLight_Min_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.daytimerunninglight" */
export type DaytimeRunningLight_Mutation_Response_Vpic = {
  __typename?: 'DaytimeRunningLight_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DaytimeRunningLight_Vpic>;
};

/** on_conflict condition type for table "vpic.daytimerunninglight" */
export type DaytimeRunningLight_On_Conflict_Vpic = {
  constraint: DaytimeRunningLight_Constraint_Vpic;
  update_columns?: Array<DaytimeRunningLight_Update_Column_Vpic>;
  where?: InputMaybe<DaytimeRunningLight_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.daytimerunninglight". */
export type DaytimeRunningLight_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.daytimerunninglight */
export type DaytimeRunningLight_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.daytimerunninglight" */
export enum DaytimeRunningLight_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.daytimerunninglight" */
export type DaytimeRunningLight_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DaytimeRunningLight_Stddev_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DaytimeRunningLight_Stddev_Pop_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DaytimeRunningLight_Stddev_Samp_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "DaytimeRunningLight" */
export type DaytimeRunningLight_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: DaytimeRunningLight_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type DaytimeRunningLight_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DaytimeRunningLight_Sum_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.daytimerunninglight" */
export enum DaytimeRunningLight_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type DaytimeRunningLight_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DaytimeRunningLight_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DaytimeRunningLight_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: DaytimeRunningLight_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type DaytimeRunningLight_Var_Pop_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DaytimeRunningLight_Var_Samp_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DaytimeRunningLight_Variance_Fields_Vpic = {
  __typename?: 'DaytimeRunningLight_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.daytimerunninglight" */
export type DaytimeRunningLight_Vpic = {
  __typename?: 'DaytimeRunningLight_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** columns and relationships of "Dealer" */
export type Dealer = {
  __typename?: 'Dealer';
  AccountID?: Maybe<Scalars['uniqueidentifier']>;
  Address1: Scalars['String'];
  Address2: Scalars['String'];
  BookingStateCode: Scalars['String'];
  BusinessStatusCode: Scalars['String'];
  CancelAfterDaysNumber: Scalars['Float'];
  CancelBeforeOrAfterFlag: Scalars['String'];
  CancelFeeAmount: Scalars['Float'];
  CancelMethod: Scalars['Float'];
  CancelMethodArray: Scalars['String'];
  CancelRule: Scalars['Float'];
  CancelRuleArray: Scalars['String'];
  Carrier: Scalars['String'];
  City: Scalars['String'];
  CompanyCode: Scalars['String'];
  CorporateOrIndividualCode: Scalars['String'];
  CreateCredRecordFlag: Scalars['String'];
  DealerCode: Scalars['String'];
  DealerCreditorCode: Scalars['String'];
  DealerGroupIdentifier?: Maybe<Scalars['uniqueidentifier']>;
  DealerID: Scalars['Int'];
  DealerObligorCode: Scalars['String'];
  DealerTypeCode: Scalars['String'];
  EffectiveDate: Scalars['Float'];
  EnteredBy: Scalars['String'];
  EnteredDate: Scalars['Float'];
  EscrowAccountNumber: Scalars['String'];
  EscrowHolderName: Scalars['String'];
  ExpirationDate: Scalars['Float'];
  ExpirationDateComputed?: Maybe<Scalars['date']>;
  FlatCancelDaysNumber: Scalars['Float'];
  FlatCancelFeeAmount: Scalars['Float'];
  GroupCode1: Scalars['String'];
  GroupCode2: Scalars['String'];
  GroupCode3: Scalars['String'];
  GroupDescription1: Scalars['String'];
  GroupDescription2: Scalars['String'];
  GroupDescription3: Scalars['String'];
  HasAsianCarsFlag: Scalars['String'];
  HasDomesticCarsFlag: Scalars['String'];
  HasEuropeanCarsFlag: Scalars['String'];
  HasImportCarsFlag: Scalars['String'];
  HasOtherTypeCarsFlag: Scalars['String'];
  HierarchyLevel: Scalars['Float'];
  InCareOf: Scalars['String'];
  IsTestDealer: Scalars['Boolean'];
  LastBusinessBatch: Scalars['Float'];
  LastBusinessDate: Scalars['Float'];
  MainDealerCode?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  NormalizedTaxIDNumber?: Maybe<Scalars['String']>;
  OtherTypeCarsDescription: Scalars['String'];
  PhoneNumber: Scalars['String'];
  PreferredStatusFlag: Scalars['String'];
  PrimaryAgencyName?: Maybe<Scalars['String']>;
  PrimaryAgentCode?: Maybe<Scalars['String']>;
  RaterPassword?: Maybe<Scalars['String']>;
  RaterUsername?: Maybe<Scalars['String']>;
  RecordStatusCode: Scalars['String'];
  StateAbbreviation: Scalars['String'];
  SubtractClaimsFlag: Scalars['String'];
  TaxIDNumber: Scalars['String'];
  TaxLaborFlag: Scalars['String'];
  TaxPartsFlag: Scalars['String'];
  TaxShopSuppliesFlag: Scalars['String'];
  UpdatedBy: Scalars['String'];
  UpdatedDate: Scalars['Float'];
  UseMainDealerNameAsNameOnContract: Scalars['Boolean'];
  Zip: Scalars['String'];
  /** An array relationship */
  contracts: Array<ContractMaster>;
  /** An aggregate relationship */
  contracts_aggregate: ContractMaster_Aggregate;
};


/** columns and relationships of "Dealer" */
export type DealerContractsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMaster_Order_By>>;
  where?: InputMaybe<ContractMaster_Bool_Exp>;
};


/** columns and relationships of "Dealer" */
export type DealerContracts_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMaster_Order_By>>;
  where?: InputMaybe<ContractMaster_Bool_Exp>;
};

export type Dealer_Address_Only_V1 = {
  __typename?: 'Dealer_Address_Only_v1';
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
};

/** aggregated selection of "Dealer" */
export type Dealer_Aggregate = {
  __typename?: 'Dealer_aggregate';
  aggregate?: Maybe<Dealer_Aggregate_Fields>;
  nodes: Array<Dealer>;
};

/** aggregate fields of "Dealer" */
export type Dealer_Aggregate_Fields = {
  __typename?: 'Dealer_aggregate_fields';
  avg?: Maybe<Dealer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Dealer_Max_Fields>;
  min?: Maybe<Dealer_Min_Fields>;
  stddev?: Maybe<Dealer_Stddev_Fields>;
  stddev_pop?: Maybe<Dealer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dealer_Stddev_Samp_Fields>;
  sum?: Maybe<Dealer_Sum_Fields>;
  var_pop?: Maybe<Dealer_Var_Pop_Fields>;
  var_samp?: Maybe<Dealer_Var_Samp_Fields>;
  variance?: Maybe<Dealer_Variance_Fields>;
};


/** aggregate fields of "Dealer" */
export type Dealer_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Dealer_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Dealer_Avg_Fields = {
  __typename?: 'Dealer_avg_fields';
  CancelAfterDaysNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  DealerID?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  FlatCancelDaysNumber?: Maybe<Scalars['Float']>;
  FlatCancelFeeAmount?: Maybe<Scalars['Float']>;
  HierarchyLevel?: Maybe<Scalars['Float']>;
  LastBusinessBatch?: Maybe<Scalars['Float']>;
  LastBusinessDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Dealer". All fields are combined with a logical 'AND'. */
export type Dealer_Bool_Exp = {
  AccountID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  Address1?: InputMaybe<String_Mssql_Comparison_Exp>;
  Address2?: InputMaybe<String_Mssql_Comparison_Exp>;
  BookingStateCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  CancelAfterDaysNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelBeforeOrAfterFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  CancelFeeAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelMethod?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelMethodArray?: InputMaybe<String_Mssql_Comparison_Exp>;
  CancelRule?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelRuleArray?: InputMaybe<String_Mssql_Comparison_Exp>;
  Carrier?: InputMaybe<String_Mssql_Comparison_Exp>;
  City?: InputMaybe<String_Mssql_Comparison_Exp>;
  CompanyCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  CorporateOrIndividualCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  CreateCredRecordFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  DealerCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  DealerCreditorCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  DealerGroupIdentifier?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  DealerID?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DealerObligorCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  DealerTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  EffectiveDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  EnteredBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  EnteredDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  EscrowAccountNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  EscrowHolderName?: InputMaybe<String_Mssql_Comparison_Exp>;
  ExpirationDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ExpirationDateComputed?: InputMaybe<Date_Mssql_Comparison_Exp>;
  FlatCancelDaysNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  FlatCancelFeeAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  GroupCode1?: InputMaybe<String_Mssql_Comparison_Exp>;
  GroupCode2?: InputMaybe<String_Mssql_Comparison_Exp>;
  GroupCode3?: InputMaybe<String_Mssql_Comparison_Exp>;
  GroupDescription1?: InputMaybe<String_Mssql_Comparison_Exp>;
  GroupDescription2?: InputMaybe<String_Mssql_Comparison_Exp>;
  GroupDescription3?: InputMaybe<String_Mssql_Comparison_Exp>;
  HasAsianCarsFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  HasDomesticCarsFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  HasEuropeanCarsFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  HasImportCarsFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  HasOtherTypeCarsFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  HierarchyLevel?: InputMaybe<Float_Mssql_Comparison_Exp>;
  InCareOf?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsTestDealer?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  LastBusinessBatch?: InputMaybe<Float_Mssql_Comparison_Exp>;
  LastBusinessDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  MainDealerCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Name?: InputMaybe<String_Mssql_Comparison_Exp>;
  NormalizedTaxIDNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  OtherTypeCarsDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  PhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  PreferredStatusFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  PrimaryAgencyName?: InputMaybe<String_Mssql_Comparison_Exp>;
  PrimaryAgentCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  RaterPassword?: InputMaybe<String_Mssql_Comparison_Exp>;
  RaterUsername?: InputMaybe<String_Mssql_Comparison_Exp>;
  RecordStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  StateAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  SubtractClaimsFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  TaxIDNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  TaxLaborFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  TaxPartsFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  TaxShopSuppliesFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  UpdatedBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  UpdatedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  UseMainDealerNameAsNameOnContract?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  Zip?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Dealer_Bool_Exp>>;
  _not?: InputMaybe<Dealer_Bool_Exp>;
  _or?: InputMaybe<Array<Dealer_Bool_Exp>>;
  contracts?: InputMaybe<ContractMaster_Bool_Exp>;
};

/** upsert condition type for table "Dealer" */
export type Dealer_If_Matched = {
  match_columns?: Array<Dealer_Insert_Match_Column>;
  update_columns?: Array<Dealer_Update_Column>;
  where?: InputMaybe<Dealer_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "Dealer" */
export type Dealer_Inc_Input = {
  CancelAfterDaysNumber?: InputMaybe<Scalars['Float']>;
  CancelFeeAmount?: InputMaybe<Scalars['Float']>;
  CancelMethod?: InputMaybe<Scalars['Float']>;
  CancelRule?: InputMaybe<Scalars['Float']>;
  EffectiveDate?: InputMaybe<Scalars['Float']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  ExpirationDate?: InputMaybe<Scalars['Float']>;
  FlatCancelDaysNumber?: InputMaybe<Scalars['Float']>;
  FlatCancelFeeAmount?: InputMaybe<Scalars['Float']>;
  HierarchyLevel?: InputMaybe<Scalars['Float']>;
  LastBusinessBatch?: InputMaybe<Scalars['Float']>;
  LastBusinessDate?: InputMaybe<Scalars['Float']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "Dealer" */
export type Dealer_Insert_Input = {
  AccountID?: InputMaybe<Scalars['uniqueidentifier']>;
  Address1?: InputMaybe<Scalars['String']>;
  Address2?: InputMaybe<Scalars['String']>;
  BookingStateCode?: InputMaybe<Scalars['String']>;
  BusinessStatusCode?: InputMaybe<Scalars['String']>;
  CancelAfterDaysNumber?: InputMaybe<Scalars['Float']>;
  CancelBeforeOrAfterFlag?: InputMaybe<Scalars['String']>;
  CancelFeeAmount?: InputMaybe<Scalars['Float']>;
  CancelMethod?: InputMaybe<Scalars['Float']>;
  CancelMethodArray?: InputMaybe<Scalars['String']>;
  CancelRule?: InputMaybe<Scalars['Float']>;
  CancelRuleArray?: InputMaybe<Scalars['String']>;
  Carrier?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  CorporateOrIndividualCode?: InputMaybe<Scalars['String']>;
  CreateCredRecordFlag?: InputMaybe<Scalars['String']>;
  DealerCode?: InputMaybe<Scalars['String']>;
  DealerCreditorCode?: InputMaybe<Scalars['String']>;
  DealerGroupIdentifier?: InputMaybe<Scalars['uniqueidentifier']>;
  DealerObligorCode?: InputMaybe<Scalars['String']>;
  DealerTypeCode?: InputMaybe<Scalars['String']>;
  EffectiveDate?: InputMaybe<Scalars['Float']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  EscrowAccountNumber?: InputMaybe<Scalars['String']>;
  EscrowHolderName?: InputMaybe<Scalars['String']>;
  ExpirationDate?: InputMaybe<Scalars['Float']>;
  ExpirationDateComputed?: InputMaybe<Scalars['date']>;
  FlatCancelDaysNumber?: InputMaybe<Scalars['Float']>;
  FlatCancelFeeAmount?: InputMaybe<Scalars['Float']>;
  GroupCode1?: InputMaybe<Scalars['String']>;
  GroupCode2?: InputMaybe<Scalars['String']>;
  GroupCode3?: InputMaybe<Scalars['String']>;
  GroupDescription1?: InputMaybe<Scalars['String']>;
  GroupDescription2?: InputMaybe<Scalars['String']>;
  GroupDescription3?: InputMaybe<Scalars['String']>;
  HasAsianCarsFlag?: InputMaybe<Scalars['String']>;
  HasDomesticCarsFlag?: InputMaybe<Scalars['String']>;
  HasEuropeanCarsFlag?: InputMaybe<Scalars['String']>;
  HasImportCarsFlag?: InputMaybe<Scalars['String']>;
  HasOtherTypeCarsFlag?: InputMaybe<Scalars['String']>;
  HierarchyLevel?: InputMaybe<Scalars['Float']>;
  InCareOf?: InputMaybe<Scalars['String']>;
  IsTestDealer?: InputMaybe<Scalars['Boolean']>;
  LastBusinessBatch?: InputMaybe<Scalars['Float']>;
  LastBusinessDate?: InputMaybe<Scalars['Float']>;
  MainDealerCode?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  NormalizedTaxIDNumber?: InputMaybe<Scalars['String']>;
  OtherTypeCarsDescription?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  PreferredStatusFlag?: InputMaybe<Scalars['String']>;
  PrimaryAgencyName?: InputMaybe<Scalars['String']>;
  PrimaryAgentCode?: InputMaybe<Scalars['String']>;
  RaterPassword?: InputMaybe<Scalars['String']>;
  RaterUsername?: InputMaybe<Scalars['String']>;
  RecordStatusCode?: InputMaybe<Scalars['String']>;
  StateAbbreviation?: InputMaybe<Scalars['String']>;
  SubtractClaimsFlag?: InputMaybe<Scalars['String']>;
  TaxIDNumber?: InputMaybe<Scalars['String']>;
  TaxLaborFlag?: InputMaybe<Scalars['String']>;
  TaxPartsFlag?: InputMaybe<Scalars['String']>;
  TaxShopSuppliesFlag?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
  UseMainDealerNameAsNameOnContract?: InputMaybe<Scalars['Boolean']>;
  Zip?: InputMaybe<Scalars['String']>;
};

/** select match_columns of table "Dealer" */
export enum Dealer_Insert_Match_Column {
  /** column name */
  AccountId = 'AccountID',
  /** column name */
  Address1 = 'Address1',
  /** column name */
  Address2 = 'Address2',
  /** column name */
  BookingStateCode = 'BookingStateCode',
  /** column name */
  BusinessStatusCode = 'BusinessStatusCode',
  /** column name */
  CancelAfterDaysNumber = 'CancelAfterDaysNumber',
  /** column name */
  CancelBeforeOrAfterFlag = 'CancelBeforeOrAfterFlag',
  /** column name */
  CancelFeeAmount = 'CancelFeeAmount',
  /** column name */
  CancelMethod = 'CancelMethod',
  /** column name */
  CancelMethodArray = 'CancelMethodArray',
  /** column name */
  CancelRule = 'CancelRule',
  /** column name */
  CancelRuleArray = 'CancelRuleArray',
  /** column name */
  Carrier = 'Carrier',
  /** column name */
  City = 'City',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  CorporateOrIndividualCode = 'CorporateOrIndividualCode',
  /** column name */
  CreateCredRecordFlag = 'CreateCredRecordFlag',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  DealerCreditorCode = 'DealerCreditorCode',
  /** column name */
  DealerGroupIdentifier = 'DealerGroupIdentifier',
  /** column name */
  DealerId = 'DealerID',
  /** column name */
  DealerObligorCode = 'DealerObligorCode',
  /** column name */
  DealerTypeCode = 'DealerTypeCode',
  /** column name */
  EffectiveDate = 'EffectiveDate',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  EscrowAccountNumber = 'EscrowAccountNumber',
  /** column name */
  EscrowHolderName = 'EscrowHolderName',
  /** column name */
  ExpirationDate = 'ExpirationDate',
  /** column name */
  ExpirationDateComputed = 'ExpirationDateComputed',
  /** column name */
  FlatCancelDaysNumber = 'FlatCancelDaysNumber',
  /** column name */
  FlatCancelFeeAmount = 'FlatCancelFeeAmount',
  /** column name */
  GroupCode1 = 'GroupCode1',
  /** column name */
  GroupCode2 = 'GroupCode2',
  /** column name */
  GroupCode3 = 'GroupCode3',
  /** column name */
  GroupDescription1 = 'GroupDescription1',
  /** column name */
  GroupDescription2 = 'GroupDescription2',
  /** column name */
  GroupDescription3 = 'GroupDescription3',
  /** column name */
  HasAsianCarsFlag = 'HasAsianCarsFlag',
  /** column name */
  HasDomesticCarsFlag = 'HasDomesticCarsFlag',
  /** column name */
  HasEuropeanCarsFlag = 'HasEuropeanCarsFlag',
  /** column name */
  HasImportCarsFlag = 'HasImportCarsFlag',
  /** column name */
  HasOtherTypeCarsFlag = 'HasOtherTypeCarsFlag',
  /** column name */
  HierarchyLevel = 'HierarchyLevel',
  /** column name */
  InCareOf = 'InCareOf',
  /** column name */
  IsTestDealer = 'IsTestDealer',
  /** column name */
  LastBusinessBatch = 'LastBusinessBatch',
  /** column name */
  LastBusinessDate = 'LastBusinessDate',
  /** column name */
  MainDealerCode = 'MainDealerCode',
  /** column name */
  Name = 'Name',
  /** column name */
  NormalizedTaxIdNumber = 'NormalizedTaxIDNumber',
  /** column name */
  OtherTypeCarsDescription = 'OtherTypeCarsDescription',
  /** column name */
  PhoneNumber = 'PhoneNumber',
  /** column name */
  PreferredStatusFlag = 'PreferredStatusFlag',
  /** column name */
  PrimaryAgencyName = 'PrimaryAgencyName',
  /** column name */
  PrimaryAgentCode = 'PrimaryAgentCode',
  /** column name */
  RaterPassword = 'RaterPassword',
  /** column name */
  RaterUsername = 'RaterUsername',
  /** column name */
  RecordStatusCode = 'RecordStatusCode',
  /** column name */
  StateAbbreviation = 'StateAbbreviation',
  /** column name */
  SubtractClaimsFlag = 'SubtractClaimsFlag',
  /** column name */
  TaxIdNumber = 'TaxIDNumber',
  /** column name */
  TaxLaborFlag = 'TaxLaborFlag',
  /** column name */
  TaxPartsFlag = 'TaxPartsFlag',
  /** column name */
  TaxShopSuppliesFlag = 'TaxShopSuppliesFlag',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  UseMainDealerNameAsNameOnContract = 'UseMainDealerNameAsNameOnContract',
  /** column name */
  Zip = 'Zip'
}

/** aggregate max on columns */
export type Dealer_Max_Fields = {
  __typename?: 'Dealer_max_fields';
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  BookingStateCode?: Maybe<Scalars['String']>;
  BusinessStatusCode?: Maybe<Scalars['String']>;
  CancelAfterDaysNumber?: Maybe<Scalars['Float']>;
  CancelBeforeOrAfterFlag?: Maybe<Scalars['String']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelMethodArray?: Maybe<Scalars['String']>;
  CancelRule?: Maybe<Scalars['Float']>;
  CancelRuleArray?: Maybe<Scalars['String']>;
  Carrier?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  CompanyCode?: Maybe<Scalars['String']>;
  CorporateOrIndividualCode?: Maybe<Scalars['String']>;
  CreateCredRecordFlag?: Maybe<Scalars['String']>;
  DealerCode?: Maybe<Scalars['String']>;
  DealerCreditorCode?: Maybe<Scalars['String']>;
  DealerID?: Maybe<Scalars['Int']>;
  DealerObligorCode?: Maybe<Scalars['String']>;
  DealerTypeCode?: Maybe<Scalars['String']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EscrowAccountNumber?: Maybe<Scalars['String']>;
  EscrowHolderName?: Maybe<Scalars['String']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  ExpirationDateComputed?: Maybe<Scalars['date']>;
  FlatCancelDaysNumber?: Maybe<Scalars['Float']>;
  FlatCancelFeeAmount?: Maybe<Scalars['Float']>;
  GroupCode1?: Maybe<Scalars['String']>;
  GroupCode2?: Maybe<Scalars['String']>;
  GroupCode3?: Maybe<Scalars['String']>;
  GroupDescription1?: Maybe<Scalars['String']>;
  GroupDescription2?: Maybe<Scalars['String']>;
  GroupDescription3?: Maybe<Scalars['String']>;
  HasAsianCarsFlag?: Maybe<Scalars['String']>;
  HasDomesticCarsFlag?: Maybe<Scalars['String']>;
  HasEuropeanCarsFlag?: Maybe<Scalars['String']>;
  HasImportCarsFlag?: Maybe<Scalars['String']>;
  HasOtherTypeCarsFlag?: Maybe<Scalars['String']>;
  HierarchyLevel?: Maybe<Scalars['Float']>;
  InCareOf?: Maybe<Scalars['String']>;
  LastBusinessBatch?: Maybe<Scalars['Float']>;
  LastBusinessDate?: Maybe<Scalars['Float']>;
  MainDealerCode?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  NormalizedTaxIDNumber?: Maybe<Scalars['String']>;
  OtherTypeCarsDescription?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  PreferredStatusFlag?: Maybe<Scalars['String']>;
  PrimaryAgencyName?: Maybe<Scalars['String']>;
  PrimaryAgentCode?: Maybe<Scalars['String']>;
  RaterPassword?: Maybe<Scalars['String']>;
  RaterUsername?: Maybe<Scalars['String']>;
  RecordStatusCode?: Maybe<Scalars['String']>;
  StateAbbreviation?: Maybe<Scalars['String']>;
  SubtractClaimsFlag?: Maybe<Scalars['String']>;
  TaxIDNumber?: Maybe<Scalars['String']>;
  TaxLaborFlag?: Maybe<Scalars['String']>;
  TaxPartsFlag?: Maybe<Scalars['String']>;
  TaxShopSuppliesFlag?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  Zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Dealer_Min_Fields = {
  __typename?: 'Dealer_min_fields';
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  BookingStateCode?: Maybe<Scalars['String']>;
  BusinessStatusCode?: Maybe<Scalars['String']>;
  CancelAfterDaysNumber?: Maybe<Scalars['Float']>;
  CancelBeforeOrAfterFlag?: Maybe<Scalars['String']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelMethodArray?: Maybe<Scalars['String']>;
  CancelRule?: Maybe<Scalars['Float']>;
  CancelRuleArray?: Maybe<Scalars['String']>;
  Carrier?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  CompanyCode?: Maybe<Scalars['String']>;
  CorporateOrIndividualCode?: Maybe<Scalars['String']>;
  CreateCredRecordFlag?: Maybe<Scalars['String']>;
  DealerCode?: Maybe<Scalars['String']>;
  DealerCreditorCode?: Maybe<Scalars['String']>;
  DealerID?: Maybe<Scalars['Int']>;
  DealerObligorCode?: Maybe<Scalars['String']>;
  DealerTypeCode?: Maybe<Scalars['String']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EscrowAccountNumber?: Maybe<Scalars['String']>;
  EscrowHolderName?: Maybe<Scalars['String']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  ExpirationDateComputed?: Maybe<Scalars['date']>;
  FlatCancelDaysNumber?: Maybe<Scalars['Float']>;
  FlatCancelFeeAmount?: Maybe<Scalars['Float']>;
  GroupCode1?: Maybe<Scalars['String']>;
  GroupCode2?: Maybe<Scalars['String']>;
  GroupCode3?: Maybe<Scalars['String']>;
  GroupDescription1?: Maybe<Scalars['String']>;
  GroupDescription2?: Maybe<Scalars['String']>;
  GroupDescription3?: Maybe<Scalars['String']>;
  HasAsianCarsFlag?: Maybe<Scalars['String']>;
  HasDomesticCarsFlag?: Maybe<Scalars['String']>;
  HasEuropeanCarsFlag?: Maybe<Scalars['String']>;
  HasImportCarsFlag?: Maybe<Scalars['String']>;
  HasOtherTypeCarsFlag?: Maybe<Scalars['String']>;
  HierarchyLevel?: Maybe<Scalars['Float']>;
  InCareOf?: Maybe<Scalars['String']>;
  LastBusinessBatch?: Maybe<Scalars['Float']>;
  LastBusinessDate?: Maybe<Scalars['Float']>;
  MainDealerCode?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  NormalizedTaxIDNumber?: Maybe<Scalars['String']>;
  OtherTypeCarsDescription?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  PreferredStatusFlag?: Maybe<Scalars['String']>;
  PrimaryAgencyName?: Maybe<Scalars['String']>;
  PrimaryAgentCode?: Maybe<Scalars['String']>;
  RaterPassword?: Maybe<Scalars['String']>;
  RaterUsername?: Maybe<Scalars['String']>;
  RecordStatusCode?: Maybe<Scalars['String']>;
  StateAbbreviation?: Maybe<Scalars['String']>;
  SubtractClaimsFlag?: Maybe<Scalars['String']>;
  TaxIDNumber?: Maybe<Scalars['String']>;
  TaxLaborFlag?: Maybe<Scalars['String']>;
  TaxPartsFlag?: Maybe<Scalars['String']>;
  TaxShopSuppliesFlag?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
  Zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Dealer" */
export type Dealer_Mutation_Response = {
  __typename?: 'Dealer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Dealer>;
};

/** Ordering options when selecting data from "Dealer". */
export type Dealer_Order_By = {
  AccountID?: InputMaybe<Order_By>;
  Address1?: InputMaybe<Order_By>;
  Address2?: InputMaybe<Order_By>;
  BookingStateCode?: InputMaybe<Order_By>;
  BusinessStatusCode?: InputMaybe<Order_By>;
  CancelAfterDaysNumber?: InputMaybe<Order_By>;
  CancelBeforeOrAfterFlag?: InputMaybe<Order_By>;
  CancelFeeAmount?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelMethodArray?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  CancelRuleArray?: InputMaybe<Order_By>;
  Carrier?: InputMaybe<Order_By>;
  City?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  CorporateOrIndividualCode?: InputMaybe<Order_By>;
  CreateCredRecordFlag?: InputMaybe<Order_By>;
  DealerCode?: InputMaybe<Order_By>;
  DealerCreditorCode?: InputMaybe<Order_By>;
  DealerGroupIdentifier?: InputMaybe<Order_By>;
  DealerID?: InputMaybe<Order_By>;
  DealerObligorCode?: InputMaybe<Order_By>;
  DealerTypeCode?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EscrowAccountNumber?: InputMaybe<Order_By>;
  EscrowHolderName?: InputMaybe<Order_By>;
  ExpirationDate?: InputMaybe<Order_By>;
  ExpirationDateComputed?: InputMaybe<Order_By>;
  FlatCancelDaysNumber?: InputMaybe<Order_By>;
  FlatCancelFeeAmount?: InputMaybe<Order_By>;
  GroupCode1?: InputMaybe<Order_By>;
  GroupCode2?: InputMaybe<Order_By>;
  GroupCode3?: InputMaybe<Order_By>;
  GroupDescription1?: InputMaybe<Order_By>;
  GroupDescription2?: InputMaybe<Order_By>;
  GroupDescription3?: InputMaybe<Order_By>;
  HasAsianCarsFlag?: InputMaybe<Order_By>;
  HasDomesticCarsFlag?: InputMaybe<Order_By>;
  HasEuropeanCarsFlag?: InputMaybe<Order_By>;
  HasImportCarsFlag?: InputMaybe<Order_By>;
  HasOtherTypeCarsFlag?: InputMaybe<Order_By>;
  HierarchyLevel?: InputMaybe<Order_By>;
  InCareOf?: InputMaybe<Order_By>;
  IsTestDealer?: InputMaybe<Order_By>;
  LastBusinessBatch?: InputMaybe<Order_By>;
  LastBusinessDate?: InputMaybe<Order_By>;
  MainDealerCode?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  NormalizedTaxIDNumber?: InputMaybe<Order_By>;
  OtherTypeCarsDescription?: InputMaybe<Order_By>;
  PhoneNumber?: InputMaybe<Order_By>;
  PreferredStatusFlag?: InputMaybe<Order_By>;
  PrimaryAgencyName?: InputMaybe<Order_By>;
  PrimaryAgentCode?: InputMaybe<Order_By>;
  RaterPassword?: InputMaybe<Order_By>;
  RaterUsername?: InputMaybe<Order_By>;
  RecordStatusCode?: InputMaybe<Order_By>;
  StateAbbreviation?: InputMaybe<Order_By>;
  SubtractClaimsFlag?: InputMaybe<Order_By>;
  TaxIDNumber?: InputMaybe<Order_By>;
  TaxLaborFlag?: InputMaybe<Order_By>;
  TaxPartsFlag?: InputMaybe<Order_By>;
  TaxShopSuppliesFlag?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
  UseMainDealerNameAsNameOnContract?: InputMaybe<Order_By>;
  Zip?: InputMaybe<Order_By>;
  contracts_aggregate?: InputMaybe<ContractMaster_Aggregate_Order_By>;
};

/** primary key columns input for table: Dealer */
export type Dealer_Pk_Columns_Input = {
  DealerID: Scalars['Int'];
};

/** select columns of table "Dealer" */
export enum Dealer_Select_Column {
  /** column name */
  AccountId = 'AccountID',
  /** column name */
  Address1 = 'Address1',
  /** column name */
  Address2 = 'Address2',
  /** column name */
  BookingStateCode = 'BookingStateCode',
  /** column name */
  BusinessStatusCode = 'BusinessStatusCode',
  /** column name */
  CancelAfterDaysNumber = 'CancelAfterDaysNumber',
  /** column name */
  CancelBeforeOrAfterFlag = 'CancelBeforeOrAfterFlag',
  /** column name */
  CancelFeeAmount = 'CancelFeeAmount',
  /** column name */
  CancelMethod = 'CancelMethod',
  /** column name */
  CancelMethodArray = 'CancelMethodArray',
  /** column name */
  CancelRule = 'CancelRule',
  /** column name */
  CancelRuleArray = 'CancelRuleArray',
  /** column name */
  Carrier = 'Carrier',
  /** column name */
  City = 'City',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  CorporateOrIndividualCode = 'CorporateOrIndividualCode',
  /** column name */
  CreateCredRecordFlag = 'CreateCredRecordFlag',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  DealerCreditorCode = 'DealerCreditorCode',
  /** column name */
  DealerGroupIdentifier = 'DealerGroupIdentifier',
  /** column name */
  DealerId = 'DealerID',
  /** column name */
  DealerObligorCode = 'DealerObligorCode',
  /** column name */
  DealerTypeCode = 'DealerTypeCode',
  /** column name */
  EffectiveDate = 'EffectiveDate',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  EscrowAccountNumber = 'EscrowAccountNumber',
  /** column name */
  EscrowHolderName = 'EscrowHolderName',
  /** column name */
  ExpirationDate = 'ExpirationDate',
  /** column name */
  ExpirationDateComputed = 'ExpirationDateComputed',
  /** column name */
  FlatCancelDaysNumber = 'FlatCancelDaysNumber',
  /** column name */
  FlatCancelFeeAmount = 'FlatCancelFeeAmount',
  /** column name */
  GroupCode1 = 'GroupCode1',
  /** column name */
  GroupCode2 = 'GroupCode2',
  /** column name */
  GroupCode3 = 'GroupCode3',
  /** column name */
  GroupDescription1 = 'GroupDescription1',
  /** column name */
  GroupDescription2 = 'GroupDescription2',
  /** column name */
  GroupDescription3 = 'GroupDescription3',
  /** column name */
  HasAsianCarsFlag = 'HasAsianCarsFlag',
  /** column name */
  HasDomesticCarsFlag = 'HasDomesticCarsFlag',
  /** column name */
  HasEuropeanCarsFlag = 'HasEuropeanCarsFlag',
  /** column name */
  HasImportCarsFlag = 'HasImportCarsFlag',
  /** column name */
  HasOtherTypeCarsFlag = 'HasOtherTypeCarsFlag',
  /** column name */
  HierarchyLevel = 'HierarchyLevel',
  /** column name */
  InCareOf = 'InCareOf',
  /** column name */
  IsTestDealer = 'IsTestDealer',
  /** column name */
  LastBusinessBatch = 'LastBusinessBatch',
  /** column name */
  LastBusinessDate = 'LastBusinessDate',
  /** column name */
  MainDealerCode = 'MainDealerCode',
  /** column name */
  Name = 'Name',
  /** column name */
  NormalizedTaxIdNumber = 'NormalizedTaxIDNumber',
  /** column name */
  OtherTypeCarsDescription = 'OtherTypeCarsDescription',
  /** column name */
  PhoneNumber = 'PhoneNumber',
  /** column name */
  PreferredStatusFlag = 'PreferredStatusFlag',
  /** column name */
  PrimaryAgencyName = 'PrimaryAgencyName',
  /** column name */
  PrimaryAgentCode = 'PrimaryAgentCode',
  /** column name */
  RaterPassword = 'RaterPassword',
  /** column name */
  RaterUsername = 'RaterUsername',
  /** column name */
  RecordStatusCode = 'RecordStatusCode',
  /** column name */
  StateAbbreviation = 'StateAbbreviation',
  /** column name */
  SubtractClaimsFlag = 'SubtractClaimsFlag',
  /** column name */
  TaxIdNumber = 'TaxIDNumber',
  /** column name */
  TaxLaborFlag = 'TaxLaborFlag',
  /** column name */
  TaxPartsFlag = 'TaxPartsFlag',
  /** column name */
  TaxShopSuppliesFlag = 'TaxShopSuppliesFlag',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  UseMainDealerNameAsNameOnContract = 'UseMainDealerNameAsNameOnContract',
  /** column name */
  Zip = 'Zip'
}

/** input type for updating data in table "Dealer" */
export type Dealer_Set_Input = {
  AccountID?: InputMaybe<Scalars['uniqueidentifier']>;
  Address1?: InputMaybe<Scalars['String']>;
  Address2?: InputMaybe<Scalars['String']>;
  BookingStateCode?: InputMaybe<Scalars['String']>;
  BusinessStatusCode?: InputMaybe<Scalars['String']>;
  CancelAfterDaysNumber?: InputMaybe<Scalars['Float']>;
  CancelBeforeOrAfterFlag?: InputMaybe<Scalars['String']>;
  CancelFeeAmount?: InputMaybe<Scalars['Float']>;
  CancelMethod?: InputMaybe<Scalars['Float']>;
  CancelMethodArray?: InputMaybe<Scalars['String']>;
  CancelRule?: InputMaybe<Scalars['Float']>;
  CancelRuleArray?: InputMaybe<Scalars['String']>;
  Carrier?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  CorporateOrIndividualCode?: InputMaybe<Scalars['String']>;
  CreateCredRecordFlag?: InputMaybe<Scalars['String']>;
  DealerCode?: InputMaybe<Scalars['String']>;
  DealerCreditorCode?: InputMaybe<Scalars['String']>;
  DealerGroupIdentifier?: InputMaybe<Scalars['uniqueidentifier']>;
  DealerObligorCode?: InputMaybe<Scalars['String']>;
  DealerTypeCode?: InputMaybe<Scalars['String']>;
  EffectiveDate?: InputMaybe<Scalars['Float']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  EscrowAccountNumber?: InputMaybe<Scalars['String']>;
  EscrowHolderName?: InputMaybe<Scalars['String']>;
  ExpirationDate?: InputMaybe<Scalars['Float']>;
  ExpirationDateComputed?: InputMaybe<Scalars['date']>;
  FlatCancelDaysNumber?: InputMaybe<Scalars['Float']>;
  FlatCancelFeeAmount?: InputMaybe<Scalars['Float']>;
  GroupCode1?: InputMaybe<Scalars['String']>;
  GroupCode2?: InputMaybe<Scalars['String']>;
  GroupCode3?: InputMaybe<Scalars['String']>;
  GroupDescription1?: InputMaybe<Scalars['String']>;
  GroupDescription2?: InputMaybe<Scalars['String']>;
  GroupDescription3?: InputMaybe<Scalars['String']>;
  HasAsianCarsFlag?: InputMaybe<Scalars['String']>;
  HasDomesticCarsFlag?: InputMaybe<Scalars['String']>;
  HasEuropeanCarsFlag?: InputMaybe<Scalars['String']>;
  HasImportCarsFlag?: InputMaybe<Scalars['String']>;
  HasOtherTypeCarsFlag?: InputMaybe<Scalars['String']>;
  HierarchyLevel?: InputMaybe<Scalars['Float']>;
  InCareOf?: InputMaybe<Scalars['String']>;
  IsTestDealer?: InputMaybe<Scalars['Boolean']>;
  LastBusinessBatch?: InputMaybe<Scalars['Float']>;
  LastBusinessDate?: InputMaybe<Scalars['Float']>;
  MainDealerCode?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  NormalizedTaxIDNumber?: InputMaybe<Scalars['String']>;
  OtherTypeCarsDescription?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  PreferredStatusFlag?: InputMaybe<Scalars['String']>;
  PrimaryAgencyName?: InputMaybe<Scalars['String']>;
  PrimaryAgentCode?: InputMaybe<Scalars['String']>;
  RaterPassword?: InputMaybe<Scalars['String']>;
  RaterUsername?: InputMaybe<Scalars['String']>;
  RecordStatusCode?: InputMaybe<Scalars['String']>;
  StateAbbreviation?: InputMaybe<Scalars['String']>;
  SubtractClaimsFlag?: InputMaybe<Scalars['String']>;
  TaxIDNumber?: InputMaybe<Scalars['String']>;
  TaxLaborFlag?: InputMaybe<Scalars['String']>;
  TaxPartsFlag?: InputMaybe<Scalars['String']>;
  TaxShopSuppliesFlag?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
  UseMainDealerNameAsNameOnContract?: InputMaybe<Scalars['Boolean']>;
  Zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Dealer_Stddev_Fields = {
  __typename?: 'Dealer_stddev_fields';
  CancelAfterDaysNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  DealerID?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  FlatCancelDaysNumber?: Maybe<Scalars['Float']>;
  FlatCancelFeeAmount?: Maybe<Scalars['Float']>;
  HierarchyLevel?: Maybe<Scalars['Float']>;
  LastBusinessBatch?: Maybe<Scalars['Float']>;
  LastBusinessDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Dealer_Stddev_Pop_Fields = {
  __typename?: 'Dealer_stddev_pop_fields';
  CancelAfterDaysNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  DealerID?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  FlatCancelDaysNumber?: Maybe<Scalars['Float']>;
  FlatCancelFeeAmount?: Maybe<Scalars['Float']>;
  HierarchyLevel?: Maybe<Scalars['Float']>;
  LastBusinessBatch?: Maybe<Scalars['Float']>;
  LastBusinessDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Dealer_Stddev_Samp_Fields = {
  __typename?: 'Dealer_stddev_samp_fields';
  CancelAfterDaysNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  DealerID?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  FlatCancelDaysNumber?: Maybe<Scalars['Float']>;
  FlatCancelFeeAmount?: Maybe<Scalars['Float']>;
  HierarchyLevel?: Maybe<Scalars['Float']>;
  LastBusinessBatch?: Maybe<Scalars['Float']>;
  LastBusinessDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Dealer_Sum_Fields = {
  __typename?: 'Dealer_sum_fields';
  CancelAfterDaysNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  DealerID?: Maybe<Scalars['Int']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  FlatCancelDaysNumber?: Maybe<Scalars['Float']>;
  FlatCancelFeeAmount?: Maybe<Scalars['Float']>;
  HierarchyLevel?: Maybe<Scalars['Float']>;
  LastBusinessBatch?: Maybe<Scalars['Float']>;
  LastBusinessDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** update columns of table "Dealer" */
export enum Dealer_Update_Column {
  /** column name */
  AccountId = 'AccountID',
  /** column name */
  Address1 = 'Address1',
  /** column name */
  Address2 = 'Address2',
  /** column name */
  BookingStateCode = 'BookingStateCode',
  /** column name */
  BusinessStatusCode = 'BusinessStatusCode',
  /** column name */
  CancelAfterDaysNumber = 'CancelAfterDaysNumber',
  /** column name */
  CancelBeforeOrAfterFlag = 'CancelBeforeOrAfterFlag',
  /** column name */
  CancelFeeAmount = 'CancelFeeAmount',
  /** column name */
  CancelMethod = 'CancelMethod',
  /** column name */
  CancelMethodArray = 'CancelMethodArray',
  /** column name */
  CancelRule = 'CancelRule',
  /** column name */
  CancelRuleArray = 'CancelRuleArray',
  /** column name */
  Carrier = 'Carrier',
  /** column name */
  City = 'City',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  CorporateOrIndividualCode = 'CorporateOrIndividualCode',
  /** column name */
  CreateCredRecordFlag = 'CreateCredRecordFlag',
  /** column name */
  DealerCode = 'DealerCode',
  /** column name */
  DealerCreditorCode = 'DealerCreditorCode',
  /** column name */
  DealerGroupIdentifier = 'DealerGroupIdentifier',
  /** column name */
  DealerObligorCode = 'DealerObligorCode',
  /** column name */
  DealerTypeCode = 'DealerTypeCode',
  /** column name */
  EffectiveDate = 'EffectiveDate',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  EscrowAccountNumber = 'EscrowAccountNumber',
  /** column name */
  EscrowHolderName = 'EscrowHolderName',
  /** column name */
  ExpirationDate = 'ExpirationDate',
  /** column name */
  ExpirationDateComputed = 'ExpirationDateComputed',
  /** column name */
  FlatCancelDaysNumber = 'FlatCancelDaysNumber',
  /** column name */
  FlatCancelFeeAmount = 'FlatCancelFeeAmount',
  /** column name */
  GroupCode1 = 'GroupCode1',
  /** column name */
  GroupCode2 = 'GroupCode2',
  /** column name */
  GroupCode3 = 'GroupCode3',
  /** column name */
  GroupDescription1 = 'GroupDescription1',
  /** column name */
  GroupDescription2 = 'GroupDescription2',
  /** column name */
  GroupDescription3 = 'GroupDescription3',
  /** column name */
  HasAsianCarsFlag = 'HasAsianCarsFlag',
  /** column name */
  HasDomesticCarsFlag = 'HasDomesticCarsFlag',
  /** column name */
  HasEuropeanCarsFlag = 'HasEuropeanCarsFlag',
  /** column name */
  HasImportCarsFlag = 'HasImportCarsFlag',
  /** column name */
  HasOtherTypeCarsFlag = 'HasOtherTypeCarsFlag',
  /** column name */
  HierarchyLevel = 'HierarchyLevel',
  /** column name */
  InCareOf = 'InCareOf',
  /** column name */
  IsTestDealer = 'IsTestDealer',
  /** column name */
  LastBusinessBatch = 'LastBusinessBatch',
  /** column name */
  LastBusinessDate = 'LastBusinessDate',
  /** column name */
  MainDealerCode = 'MainDealerCode',
  /** column name */
  Name = 'Name',
  /** column name */
  NormalizedTaxIdNumber = 'NormalizedTaxIDNumber',
  /** column name */
  OtherTypeCarsDescription = 'OtherTypeCarsDescription',
  /** column name */
  PhoneNumber = 'PhoneNumber',
  /** column name */
  PreferredStatusFlag = 'PreferredStatusFlag',
  /** column name */
  PrimaryAgencyName = 'PrimaryAgencyName',
  /** column name */
  PrimaryAgentCode = 'PrimaryAgentCode',
  /** column name */
  RaterPassword = 'RaterPassword',
  /** column name */
  RaterUsername = 'RaterUsername',
  /** column name */
  RecordStatusCode = 'RecordStatusCode',
  /** column name */
  StateAbbreviation = 'StateAbbreviation',
  /** column name */
  SubtractClaimsFlag = 'SubtractClaimsFlag',
  /** column name */
  TaxIdNumber = 'TaxIDNumber',
  /** column name */
  TaxLaborFlag = 'TaxLaborFlag',
  /** column name */
  TaxPartsFlag = 'TaxPartsFlag',
  /** column name */
  TaxShopSuppliesFlag = 'TaxShopSuppliesFlag',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate',
  /** column name */
  UseMainDealerNameAsNameOnContract = 'UseMainDealerNameAsNameOnContract',
  /** column name */
  Zip = 'Zip'
}

/** aggregate var_pop on columns */
export type Dealer_Var_Pop_Fields = {
  __typename?: 'Dealer_var_pop_fields';
  CancelAfterDaysNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  DealerID?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  FlatCancelDaysNumber?: Maybe<Scalars['Float']>;
  FlatCancelFeeAmount?: Maybe<Scalars['Float']>;
  HierarchyLevel?: Maybe<Scalars['Float']>;
  LastBusinessBatch?: Maybe<Scalars['Float']>;
  LastBusinessDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Dealer_Var_Samp_Fields = {
  __typename?: 'Dealer_var_samp_fields';
  CancelAfterDaysNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  DealerID?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  FlatCancelDaysNumber?: Maybe<Scalars['Float']>;
  FlatCancelFeeAmount?: Maybe<Scalars['Float']>;
  HierarchyLevel?: Maybe<Scalars['Float']>;
  LastBusinessBatch?: Maybe<Scalars['Float']>;
  LastBusinessDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Dealer_Variance_Fields = {
  __typename?: 'Dealer_variance_fields';
  CancelAfterDaysNumber?: Maybe<Scalars['Float']>;
  CancelFeeAmount?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  DealerID?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpirationDate?: Maybe<Scalars['Float']>;
  FlatCancelDaysNumber?: Maybe<Scalars['Float']>;
  FlatCancelFeeAmount?: Maybe<Scalars['Float']>;
  HierarchyLevel?: Maybe<Scalars['Float']>;
  LastBusinessBatch?: Maybe<Scalars['Float']>;
  LastBusinessDate?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

export type DefaultValue_Aggregate_Bool_Exp = {
  count?: InputMaybe<DefaultValue_Aggregate_Bool_Exp_Count>;
};

export type DefaultValue_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<DefaultValue_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vpic.defaultvalue" */
export type DefaultValue_Aggregate_Fields_Vpic = {
  __typename?: 'DefaultValue_aggregate_fields_vpic';
  avg?: Maybe<DefaultValue_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<DefaultValue_Max_Fields_Vpic>;
  min?: Maybe<DefaultValue_Min_Fields_Vpic>;
  stddev?: Maybe<DefaultValue_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<DefaultValue_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<DefaultValue_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<DefaultValue_Sum_Fields_Vpic>;
  var_pop?: Maybe<DefaultValue_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<DefaultValue_Var_Samp_Fields_Vpic>;
  variance?: Maybe<DefaultValue_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.defaultvalue" */
export type DefaultValue_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<DefaultValue_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vpic.defaultvalue" */
export type DefaultValue_Aggregate_Order_By_Vpic = {
  avg?: InputMaybe<DefaultValue_Avg_Order_By_Vpic>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<DefaultValue_Max_Order_By_Vpic>;
  min?: InputMaybe<DefaultValue_Min_Order_By_Vpic>;
  stddev?: InputMaybe<DefaultValue_Stddev_Order_By_Vpic>;
  stddev_pop?: InputMaybe<DefaultValue_Stddev_Pop_Order_By_Vpic>;
  stddev_samp?: InputMaybe<DefaultValue_Stddev_Samp_Order_By_Vpic>;
  sum?: InputMaybe<DefaultValue_Sum_Order_By_Vpic>;
  var_pop?: InputMaybe<DefaultValue_Var_Pop_Order_By_Vpic>;
  var_samp?: InputMaybe<DefaultValue_Var_Samp_Order_By_Vpic>;
  variance?: InputMaybe<DefaultValue_Variance_Order_By_Vpic>;
};

/** aggregated selection of "vpic.defaultvalue" */
export type DefaultValue_Aggregate_Vpic = {
  __typename?: 'DefaultValue_aggregate_vpic';
  aggregate?: Maybe<DefaultValue_Aggregate_Fields_Vpic>;
  nodes: Array<DefaultValue_Vpic>;
};

/** input type for inserting array relation for remote table "vpic.defaultvalue" */
export type DefaultValue_Arr_Rel_Insert_Input_Vpic = {
  data: Array<DefaultValue_Insert_Input_Vpic>;
  /** upsert condition */
  on_conflict?: InputMaybe<DefaultValue_On_Conflict_Vpic>;
};

/** aggregate avg on columns */
export type DefaultValue_Avg_Fields_Vpic = {
  __typename?: 'DefaultValue_avg_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vpic.defaultvalue" */
export type DefaultValue_Avg_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vpic.defaultvalue". All fields are combined with a logical 'AND'. */
export type DefaultValue_Bool_Exp_Vpic = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  DefaultValue?: InputMaybe<String_Comparison_Exp>;
  Element?: InputMaybe<Element_Bool_Exp_Vpic>;
  ElementId?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  VehicleType?: InputMaybe<VehicleType_Bool_Exp_Vpic>;
  VehicleTypeId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<DefaultValue_Bool_Exp_Vpic>>;
  _not?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<DefaultValue_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.defaultvalue" */
export enum DefaultValue_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkDefaultvalue = 'pk_defaultvalue'
}

/** input type for incrementing numeric columns in table "vpic.defaultvalue" */
export type DefaultValue_Inc_Input_Vpic = {
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.defaultvalue" */
export type DefaultValue_Insert_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  DefaultValue?: InputMaybe<Scalars['String']>;
  Element?: InputMaybe<Element_Obj_Rel_Insert_Input_Vpic>;
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VehicleType?: InputMaybe<VehicleType_Obj_Rel_Insert_Input_Vpic>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type DefaultValue_Max_Fields_Vpic = {
  __typename?: 'DefaultValue_max_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DefaultValue?: Maybe<Scalars['String']>;
  ElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VehicleTypeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vpic.defaultvalue" */
export type DefaultValue_Max_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  DefaultValue?: InputMaybe<Order_By>;
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type DefaultValue_Min_Fields_Vpic = {
  __typename?: 'DefaultValue_min_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DefaultValue?: Maybe<Scalars['String']>;
  ElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VehicleTypeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vpic.defaultvalue" */
export type DefaultValue_Min_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  DefaultValue?: InputMaybe<Order_By>;
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vpic.defaultvalue" */
export type DefaultValue_Mutation_Response_Vpic = {
  __typename?: 'DefaultValue_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DefaultValue_Vpic>;
};

/** on_conflict condition type for table "vpic.defaultvalue" */
export type DefaultValue_On_Conflict_Vpic = {
  constraint: DefaultValue_Constraint_Vpic;
  update_columns?: Array<DefaultValue_Update_Column_Vpic>;
  where?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.defaultvalue". */
export type DefaultValue_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  DefaultValue?: InputMaybe<Order_By>;
  Element?: InputMaybe<Element_Order_By_Vpic>;
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VehicleType?: InputMaybe<VehicleType_Order_By_Vpic>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.defaultvalue */
export type DefaultValue_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.defaultvalue" */
export enum DefaultValue_Select_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  DefaultValue = 'DefaultValue',
  /** column name */
  ElementId = 'ElementId',
  /** column name */
  Id = 'Id',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VehicleTypeId = 'VehicleTypeId'
}

/** input type for updating data in table "vpic.defaultvalue" */
export type DefaultValue_Set_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  DefaultValue?: InputMaybe<Scalars['String']>;
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type DefaultValue_Stddev_Fields_Vpic = {
  __typename?: 'DefaultValue_stddev_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vpic.defaultvalue" */
export type DefaultValue_Stddev_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type DefaultValue_Stddev_Pop_Fields_Vpic = {
  __typename?: 'DefaultValue_stddev_pop_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vpic.defaultvalue" */
export type DefaultValue_Stddev_Pop_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type DefaultValue_Stddev_Samp_Fields_Vpic = {
  __typename?: 'DefaultValue_stddev_samp_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vpic.defaultvalue" */
export type DefaultValue_Stddev_Samp_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "DefaultValue" */
export type DefaultValue_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: DefaultValue_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type DefaultValue_Stream_Cursor_Value_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  DefaultValue?: InputMaybe<Scalars['String']>;
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type DefaultValue_Sum_Fields_Vpic = {
  __typename?: 'DefaultValue_sum_fields_vpic';
  ElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  VehicleTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vpic.defaultvalue" */
export type DefaultValue_Sum_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "vpic.defaultvalue" */
export enum DefaultValue_Update_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  DefaultValue = 'DefaultValue',
  /** column name */
  ElementId = 'ElementId',
  /** column name */
  Id = 'Id',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VehicleTypeId = 'VehicleTypeId'
}

export type DefaultValue_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DefaultValue_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DefaultValue_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: DefaultValue_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type DefaultValue_Var_Pop_Fields_Vpic = {
  __typename?: 'DefaultValue_var_pop_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vpic.defaultvalue" */
export type DefaultValue_Var_Pop_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type DefaultValue_Var_Samp_Fields_Vpic = {
  __typename?: 'DefaultValue_var_samp_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vpic.defaultvalue" */
export type DefaultValue_Var_Samp_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type DefaultValue_Variance_Fields_Vpic = {
  __typename?: 'DefaultValue_variance_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vpic.defaultvalue" */
export type DefaultValue_Variance_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "vpic.defaultvalue" */
export type DefaultValue_Vpic = {
  __typename?: 'DefaultValue_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DefaultValue?: Maybe<Scalars['String']>;
  /** An object relationship */
  Element?: Maybe<Element_Vpic>;
  ElementId: Scalars['Int'];
  Id: Scalars['Int'];
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  VehicleType?: Maybe<VehicleType_Vpic>;
  VehicleTypeId: Scalars['Int'];
};

/** aggregate fields of "vpic.destinationmarket" */
export type DestinationMarket_Aggregate_Fields_Vpic = {
  __typename?: 'DestinationMarket_aggregate_fields_vpic';
  avg?: Maybe<DestinationMarket_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<DestinationMarket_Max_Fields_Vpic>;
  min?: Maybe<DestinationMarket_Min_Fields_Vpic>;
  stddev?: Maybe<DestinationMarket_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<DestinationMarket_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<DestinationMarket_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<DestinationMarket_Sum_Fields_Vpic>;
  var_pop?: Maybe<DestinationMarket_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<DestinationMarket_Var_Samp_Fields_Vpic>;
  variance?: Maybe<DestinationMarket_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.destinationmarket" */
export type DestinationMarket_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<DestinationMarket_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.destinationmarket" */
export type DestinationMarket_Aggregate_Vpic = {
  __typename?: 'DestinationMarket_aggregate_vpic';
  aggregate?: Maybe<DestinationMarket_Aggregate_Fields_Vpic>;
  nodes: Array<DestinationMarket_Vpic>;
};

/** aggregate avg on columns */
export type DestinationMarket_Avg_Fields_Vpic = {
  __typename?: 'DestinationMarket_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.destinationmarket". All fields are combined with a logical 'AND'. */
export type DestinationMarket_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<DestinationMarket_Bool_Exp_Vpic>>;
  _not?: InputMaybe<DestinationMarket_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<DestinationMarket_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.destinationmarket" */
export enum DestinationMarket_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkDestinationmarket = 'pk_destinationmarket',
  /** unique or primary key constraint on columns "name" */
  UDestinationmarketname = 'u_destinationmarketname'
}

/** input type for incrementing numeric columns in table "vpic.destinationmarket" */
export type DestinationMarket_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.destinationmarket" */
export type DestinationMarket_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DestinationMarket_Max_Fields_Vpic = {
  __typename?: 'DestinationMarket_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DestinationMarket_Min_Fields_Vpic = {
  __typename?: 'DestinationMarket_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.destinationmarket" */
export type DestinationMarket_Mutation_Response_Vpic = {
  __typename?: 'DestinationMarket_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DestinationMarket_Vpic>;
};

/** on_conflict condition type for table "vpic.destinationmarket" */
export type DestinationMarket_On_Conflict_Vpic = {
  constraint: DestinationMarket_Constraint_Vpic;
  update_columns?: Array<DestinationMarket_Update_Column_Vpic>;
  where?: InputMaybe<DestinationMarket_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.destinationmarket". */
export type DestinationMarket_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.destinationmarket */
export type DestinationMarket_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.destinationmarket" */
export enum DestinationMarket_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.destinationmarket" */
export type DestinationMarket_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DestinationMarket_Stddev_Fields_Vpic = {
  __typename?: 'DestinationMarket_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DestinationMarket_Stddev_Pop_Fields_Vpic = {
  __typename?: 'DestinationMarket_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DestinationMarket_Stddev_Samp_Fields_Vpic = {
  __typename?: 'DestinationMarket_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "DestinationMarket" */
export type DestinationMarket_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: DestinationMarket_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type DestinationMarket_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DestinationMarket_Sum_Fields_Vpic = {
  __typename?: 'DestinationMarket_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.destinationmarket" */
export enum DestinationMarket_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type DestinationMarket_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DestinationMarket_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DestinationMarket_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: DestinationMarket_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type DestinationMarket_Var_Pop_Fields_Vpic = {
  __typename?: 'DestinationMarket_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DestinationMarket_Var_Samp_Fields_Vpic = {
  __typename?: 'DestinationMarket_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DestinationMarket_Variance_Fields_Vpic = {
  __typename?: 'DestinationMarket_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.destinationmarket" */
export type DestinationMarket_Vpic = {
  __typename?: 'DestinationMarket_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Disbursement = {
  __typename?: 'Disbursement';
  amount?: Maybe<Scalars['numeric']>;
  code?: Maybe<Scalars['String']>;
  disbursementTypeName?: Maybe<Scalars['String']>;
};

export type DocumentInstanceMetadataTypes = {
  __typename?: 'DocumentInstanceMetadataTypes';
  Already_Canceled_v1?: Maybe<Already_Canceled_V1>;
  Already_Canceled_v2?: Maybe<Already_Canceled_V2>;
  Cancel_Denial_Gap_Payout_v1?: Maybe<Cancel_Denial_Gap_Payout_V1>;
  Contract_Denial_v1?: Maybe<Contract_Denial_V1>;
  Customer_Address_Only_v1?: Maybe<Customer_Address_Only_V1>;
  Cxl_Add_Doc_Req_Mileage_v1?: Maybe<Cxl_Add_Doc_Req_Mileage_V1>;
  Cxl_Add_Doc_Req_Sign_v1?: Maybe<Cxl_Add_Doc_Req_Sign_V1>;
  Cxl_DO_Check_Statement_v1?: Maybe<Cxl_Do_Check_Statement_V1>;
  Cxl_Denied_Non_Cancellable_Dlr_v1?: Maybe<Cxl_Denied_Non_Cancellable_Dlr_V1>;
  Cxl_Denied_Previously_Denied_Dlr_v1?: Maybe<Cxl_Denied_Previously_Denied_Dlr_V1>;
  Cxl_Denied_Suspended_Dlr_v1?: Maybe<Cxl_Denied_Suspended_Dlr_V1>;
  Cxl_Proof_Of_Cancellation_Customer_v1?: Maybe<Cxl_Proof_Of_Cancellation_Customer_V1>;
  Dealer_Address_Only_v1?: Maybe<Dealer_Address_Only_V1>;
  Expired_Date_v1?: Maybe<Expired_Date_V1>;
  Expired_Mileage_v1?: Maybe<Expired_Mileage_V1>;
  GAP_Claim_Denial_Letter_v1?: Maybe<Gap_Claim_Denial_Letter_V1>;
  GAP_Claim_Finishing_Letter_v1?: Maybe<Gap_Claim_Finishing_Letter_V1>;
  GAP_Claim_Initial_Letter_v1?: Maybe<Gap_Claim_Initial_Letter_V1>;
  GAP_Claim_Working_Letter_v1?: Maybe<Gap_Claim_Working_Letter_V1>;
  Lease_Amortization_Schedule_v1?: Maybe<Lease_Amortization_Schedule_V1>;
  Mo_Cancellation_v1?: Maybe<Mo_Cancellation_V1>;
  Mo_Cancellation_v2?: Maybe<Mo_Cancellation_V2>;
  No_Refund_Due_v1?: Maybe<No_Refund_Due_V1>;
  Noncancellable_v1?: Maybe<Noncancellable_V1>;
  Ops_Gap_Late_Submission_Agreement_v1?: Maybe<Ops_Gap_Late_Submission_Agreement_V1>;
  Simple_Interest_Amortization_Schedule_v1?: Maybe<Simple_Interest_Amortization_Schedule_V1>;
  Transfer_Letter_v1?: Maybe<Transfer_Letter_V1>;
};

/** aggregate fields of "vpic.drivetype" */
export type DriveType_Aggregate_Fields_Vpic = {
  __typename?: 'DriveType_aggregate_fields_vpic';
  avg?: Maybe<DriveType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<DriveType_Max_Fields_Vpic>;
  min?: Maybe<DriveType_Min_Fields_Vpic>;
  stddev?: Maybe<DriveType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<DriveType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<DriveType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<DriveType_Sum_Fields_Vpic>;
  var_pop?: Maybe<DriveType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<DriveType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<DriveType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.drivetype" */
export type DriveType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<DriveType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.drivetype" */
export type DriveType_Aggregate_Vpic = {
  __typename?: 'DriveType_aggregate_vpic';
  aggregate?: Maybe<DriveType_Aggregate_Fields_Vpic>;
  nodes: Array<DriveType_Vpic>;
};

/** aggregate avg on columns */
export type DriveType_Avg_Fields_Vpic = {
  __typename?: 'DriveType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.drivetype". All fields are combined with a logical 'AND'. */
export type DriveType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<DriveType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<DriveType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<DriveType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.drivetype" */
export enum DriveType_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkDrivetype = 'pk_drivetype',
  /** unique or primary key constraint on columns "name" */
  UDrivetypename = 'u_drivetypename'
}

/** input type for incrementing numeric columns in table "vpic.drivetype" */
export type DriveType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.drivetype" */
export type DriveType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DriveType_Max_Fields_Vpic = {
  __typename?: 'DriveType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DriveType_Min_Fields_Vpic = {
  __typename?: 'DriveType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.drivetype" */
export type DriveType_Mutation_Response_Vpic = {
  __typename?: 'DriveType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DriveType_Vpic>;
};

/** on_conflict condition type for table "vpic.drivetype" */
export type DriveType_On_Conflict_Vpic = {
  constraint: DriveType_Constraint_Vpic;
  update_columns?: Array<DriveType_Update_Column_Vpic>;
  where?: InputMaybe<DriveType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.drivetype". */
export type DriveType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.drivetype */
export type DriveType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.drivetype" */
export enum DriveType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.drivetype" */
export type DriveType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DriveType_Stddev_Fields_Vpic = {
  __typename?: 'DriveType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DriveType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'DriveType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DriveType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'DriveType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "DriveType" */
export type DriveType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: DriveType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type DriveType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DriveType_Sum_Fields_Vpic = {
  __typename?: 'DriveType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.drivetype" */
export enum DriveType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type DriveType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DriveType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DriveType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: DriveType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type DriveType_Var_Pop_Fields_Vpic = {
  __typename?: 'DriveType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DriveType_Var_Samp_Fields_Vpic = {
  __typename?: 'DriveType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DriveType_Variance_Fields_Vpic = {
  __typename?: 'DriveType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.drivetype" */
export type DriveType_Vpic = {
  __typename?: 'DriveType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.dynamicbrakesupport" */
export type DynamicBrakeSupport_Aggregate_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_aggregate_fields_vpic';
  avg?: Maybe<DynamicBrakeSupport_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<DynamicBrakeSupport_Max_Fields_Vpic>;
  min?: Maybe<DynamicBrakeSupport_Min_Fields_Vpic>;
  stddev?: Maybe<DynamicBrakeSupport_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<DynamicBrakeSupport_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<DynamicBrakeSupport_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<DynamicBrakeSupport_Sum_Fields_Vpic>;
  var_pop?: Maybe<DynamicBrakeSupport_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<DynamicBrakeSupport_Var_Samp_Fields_Vpic>;
  variance?: Maybe<DynamicBrakeSupport_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.dynamicbrakesupport" */
export type DynamicBrakeSupport_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<DynamicBrakeSupport_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.dynamicbrakesupport" */
export type DynamicBrakeSupport_Aggregate_Vpic = {
  __typename?: 'DynamicBrakeSupport_aggregate_vpic';
  aggregate?: Maybe<DynamicBrakeSupport_Aggregate_Fields_Vpic>;
  nodes: Array<DynamicBrakeSupport_Vpic>;
};

/** aggregate avg on columns */
export type DynamicBrakeSupport_Avg_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.dynamicbrakesupport". All fields are combined with a logical 'AND'. */
export type DynamicBrakeSupport_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<DynamicBrakeSupport_Bool_Exp_Vpic>>;
  _not?: InputMaybe<DynamicBrakeSupport_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<DynamicBrakeSupport_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.dynamicbrakesupport" */
export enum DynamicBrakeSupport_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkDynamicb_3214ec07a7d5e8a9 = 'pk__dynamicb__3214ec07a7d5e8a9'
}

/** input type for incrementing numeric columns in table "vpic.dynamicbrakesupport" */
export type DynamicBrakeSupport_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.dynamicbrakesupport" */
export type DynamicBrakeSupport_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DynamicBrakeSupport_Max_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DynamicBrakeSupport_Min_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.dynamicbrakesupport" */
export type DynamicBrakeSupport_Mutation_Response_Vpic = {
  __typename?: 'DynamicBrakeSupport_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DynamicBrakeSupport_Vpic>;
};

/** on_conflict condition type for table "vpic.dynamicbrakesupport" */
export type DynamicBrakeSupport_On_Conflict_Vpic = {
  constraint: DynamicBrakeSupport_Constraint_Vpic;
  update_columns?: Array<DynamicBrakeSupport_Update_Column_Vpic>;
  where?: InputMaybe<DynamicBrakeSupport_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.dynamicbrakesupport". */
export type DynamicBrakeSupport_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.dynamicbrakesupport */
export type DynamicBrakeSupport_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.dynamicbrakesupport" */
export enum DynamicBrakeSupport_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.dynamicbrakesupport" */
export type DynamicBrakeSupport_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DynamicBrakeSupport_Stddev_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DynamicBrakeSupport_Stddev_Pop_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DynamicBrakeSupport_Stddev_Samp_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "DynamicBrakeSupport" */
export type DynamicBrakeSupport_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: DynamicBrakeSupport_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type DynamicBrakeSupport_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DynamicBrakeSupport_Sum_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.dynamicbrakesupport" */
export enum DynamicBrakeSupport_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type DynamicBrakeSupport_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DynamicBrakeSupport_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DynamicBrakeSupport_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: DynamicBrakeSupport_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type DynamicBrakeSupport_Var_Pop_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DynamicBrakeSupport_Var_Samp_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DynamicBrakeSupport_Variance_Fields_Vpic = {
  __typename?: 'DynamicBrakeSupport_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.dynamicbrakesupport" */
export type DynamicBrakeSupport_Vpic = {
  __typename?: 'DynamicBrakeSupport_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.ecs" */
export type Ecs_Aggregate_Fields_Vpic = {
  __typename?: 'ECS_aggregate_fields_vpic';
  avg?: Maybe<Ecs_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Ecs_Max_Fields_Vpic>;
  min?: Maybe<Ecs_Min_Fields_Vpic>;
  stddev?: Maybe<Ecs_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Ecs_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Ecs_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Ecs_Sum_Fields_Vpic>;
  var_pop?: Maybe<Ecs_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Ecs_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Ecs_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.ecs" */
export type Ecs_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Ecs_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.ecs" */
export type Ecs_Aggregate_Vpic = {
  __typename?: 'ECS_aggregate_vpic';
  aggregate?: Maybe<Ecs_Aggregate_Fields_Vpic>;
  nodes: Array<Ecs_Vpic>;
};

/** aggregate avg on columns */
export type Ecs_Avg_Fields_Vpic = {
  __typename?: 'ECS_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.ecs". All fields are combined with a logical 'AND'. */
export type Ecs_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Ecs_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Ecs_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Ecs_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.ecs" */
export enum Ecs_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkEcs = 'pk_ecs',
  /** unique or primary key constraint on columns "name" */
  UEscname = 'u_escname'
}

/** input type for incrementing numeric columns in table "vpic.ecs" */
export type Ecs_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.ecs" */
export type Ecs_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ecs_Max_Fields_Vpic = {
  __typename?: 'ECS_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ecs_Min_Fields_Vpic = {
  __typename?: 'ECS_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.ecs" */
export type Ecs_Mutation_Response_Vpic = {
  __typename?: 'ECS_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ecs_Vpic>;
};

/** on_conflict condition type for table "vpic.ecs" */
export type Ecs_On_Conflict_Vpic = {
  constraint: Ecs_Constraint_Vpic;
  update_columns?: Array<Ecs_Update_Column_Vpic>;
  where?: InputMaybe<Ecs_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.ecs". */
export type Ecs_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.ecs */
export type Ecs_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.ecs" */
export enum Ecs_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.ecs" */
export type Ecs_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Ecs_Stddev_Fields_Vpic = {
  __typename?: 'ECS_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ecs_Stddev_Pop_Fields_Vpic = {
  __typename?: 'ECS_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ecs_Stddev_Samp_Fields_Vpic = {
  __typename?: 'ECS_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ECS" */
export type Ecs_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Ecs_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Ecs_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Ecs_Sum_Fields_Vpic = {
  __typename?: 'ECS_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.ecs" */
export enum Ecs_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type Ecs_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ecs_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ecs_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Ecs_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Ecs_Var_Pop_Fields_Vpic = {
  __typename?: 'ECS_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ecs_Var_Samp_Fields_Vpic = {
  __typename?: 'ECS_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ecs_Variance_Fields_Vpic = {
  __typename?: 'ECS_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.ecs" */
export type Ecs_Vpic = {
  __typename?: 'ECS_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.edr" */
export type Edr_Aggregate_Fields_Vpic = {
  __typename?: 'EDR_aggregate_fields_vpic';
  avg?: Maybe<Edr_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Edr_Max_Fields_Vpic>;
  min?: Maybe<Edr_Min_Fields_Vpic>;
  stddev?: Maybe<Edr_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Edr_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Edr_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Edr_Sum_Fields_Vpic>;
  var_pop?: Maybe<Edr_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Edr_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Edr_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.edr" */
export type Edr_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Edr_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.edr" */
export type Edr_Aggregate_Vpic = {
  __typename?: 'EDR_aggregate_vpic';
  aggregate?: Maybe<Edr_Aggregate_Fields_Vpic>;
  nodes: Array<Edr_Vpic>;
};

/** aggregate avg on columns */
export type Edr_Avg_Fields_Vpic = {
  __typename?: 'EDR_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.edr". All fields are combined with a logical 'AND'. */
export type Edr_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Edr_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Edr_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Edr_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.edr" */
export enum Edr_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkEdr_3214ec07273a4b03 = 'pk__edr__3214ec07273a4b03'
}

/** input type for incrementing numeric columns in table "vpic.edr" */
export type Edr_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.edr" */
export type Edr_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Edr_Max_Fields_Vpic = {
  __typename?: 'EDR_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Edr_Min_Fields_Vpic = {
  __typename?: 'EDR_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.edr" */
export type Edr_Mutation_Response_Vpic = {
  __typename?: 'EDR_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Edr_Vpic>;
};

/** on_conflict condition type for table "vpic.edr" */
export type Edr_On_Conflict_Vpic = {
  constraint: Edr_Constraint_Vpic;
  update_columns?: Array<Edr_Update_Column_Vpic>;
  where?: InputMaybe<Edr_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.edr". */
export type Edr_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.edr */
export type Edr_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.edr" */
export enum Edr_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.edr" */
export type Edr_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Edr_Stddev_Fields_Vpic = {
  __typename?: 'EDR_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Edr_Stddev_Pop_Fields_Vpic = {
  __typename?: 'EDR_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Edr_Stddev_Samp_Fields_Vpic = {
  __typename?: 'EDR_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "EDR" */
export type Edr_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Edr_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Edr_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Edr_Sum_Fields_Vpic = {
  __typename?: 'EDR_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.edr" */
export enum Edr_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type Edr_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Edr_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Edr_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Edr_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Edr_Var_Pop_Fields_Vpic = {
  __typename?: 'EDR_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Edr_Var_Samp_Fields_Vpic = {
  __typename?: 'EDR_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Edr_Variance_Fields_Vpic = {
  __typename?: 'EDR_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.edr" */
export type Edr_Vpic = {
  __typename?: 'EDR_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.evdriveunit" */
export type EvDriveUnit_Aggregate_Fields_Vpic = {
  __typename?: 'EVDriveUnit_aggregate_fields_vpic';
  avg?: Maybe<EvDriveUnit_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<EvDriveUnit_Max_Fields_Vpic>;
  min?: Maybe<EvDriveUnit_Min_Fields_Vpic>;
  stddev?: Maybe<EvDriveUnit_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<EvDriveUnit_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<EvDriveUnit_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<EvDriveUnit_Sum_Fields_Vpic>;
  var_pop?: Maybe<EvDriveUnit_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<EvDriveUnit_Var_Samp_Fields_Vpic>;
  variance?: Maybe<EvDriveUnit_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.evdriveunit" */
export type EvDriveUnit_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<EvDriveUnit_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.evdriveunit" */
export type EvDriveUnit_Aggregate_Vpic = {
  __typename?: 'EVDriveUnit_aggregate_vpic';
  aggregate?: Maybe<EvDriveUnit_Aggregate_Fields_Vpic>;
  nodes: Array<EvDriveUnit_Vpic>;
};

/** aggregate avg on columns */
export type EvDriveUnit_Avg_Fields_Vpic = {
  __typename?: 'EVDriveUnit_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.evdriveunit". All fields are combined with a logical 'AND'. */
export type EvDriveUnit_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<EvDriveUnit_Bool_Exp_Vpic>>;
  _not?: InputMaybe<EvDriveUnit_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<EvDriveUnit_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.evdriveunit" */
export enum EvDriveUnit_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkEvdriveunit = 'pk_evdriveunit',
  /** unique or primary key constraint on columns "name" */
  UEvdriveunitname = 'u_evdriveunitname'
}

/** input type for incrementing numeric columns in table "vpic.evdriveunit" */
export type EvDriveUnit_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.evdriveunit" */
export type EvDriveUnit_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EvDriveUnit_Max_Fields_Vpic = {
  __typename?: 'EVDriveUnit_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EvDriveUnit_Min_Fields_Vpic = {
  __typename?: 'EVDriveUnit_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.evdriveunit" */
export type EvDriveUnit_Mutation_Response_Vpic = {
  __typename?: 'EVDriveUnit_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EvDriveUnit_Vpic>;
};

/** on_conflict condition type for table "vpic.evdriveunit" */
export type EvDriveUnit_On_Conflict_Vpic = {
  constraint: EvDriveUnit_Constraint_Vpic;
  update_columns?: Array<EvDriveUnit_Update_Column_Vpic>;
  where?: InputMaybe<EvDriveUnit_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.evdriveunit". */
export type EvDriveUnit_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.evdriveunit */
export type EvDriveUnit_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.evdriveunit" */
export enum EvDriveUnit_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.evdriveunit" */
export type EvDriveUnit_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EvDriveUnit_Stddev_Fields_Vpic = {
  __typename?: 'EVDriveUnit_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EvDriveUnit_Stddev_Pop_Fields_Vpic = {
  __typename?: 'EVDriveUnit_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EvDriveUnit_Stddev_Samp_Fields_Vpic = {
  __typename?: 'EVDriveUnit_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "EVDriveUnit" */
export type EvDriveUnit_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: EvDriveUnit_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type EvDriveUnit_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type EvDriveUnit_Sum_Fields_Vpic = {
  __typename?: 'EVDriveUnit_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.evdriveunit" */
export enum EvDriveUnit_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type EvDriveUnit_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EvDriveUnit_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvDriveUnit_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: EvDriveUnit_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type EvDriveUnit_Var_Pop_Fields_Vpic = {
  __typename?: 'EVDriveUnit_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EvDriveUnit_Var_Samp_Fields_Vpic = {
  __typename?: 'EVDriveUnit_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EvDriveUnit_Variance_Fields_Vpic = {
  __typename?: 'EVDriveUnit_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.evdriveunit" */
export type EvDriveUnit_Vpic = {
  __typename?: 'EVDriveUnit_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.electrificationlevel" */
export type ElectrificationLevel_Aggregate_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_aggregate_fields_vpic';
  avg?: Maybe<ElectrificationLevel_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<ElectrificationLevel_Max_Fields_Vpic>;
  min?: Maybe<ElectrificationLevel_Min_Fields_Vpic>;
  stddev?: Maybe<ElectrificationLevel_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<ElectrificationLevel_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<ElectrificationLevel_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<ElectrificationLevel_Sum_Fields_Vpic>;
  var_pop?: Maybe<ElectrificationLevel_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<ElectrificationLevel_Var_Samp_Fields_Vpic>;
  variance?: Maybe<ElectrificationLevel_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.electrificationlevel" */
export type ElectrificationLevel_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<ElectrificationLevel_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.electrificationlevel" */
export type ElectrificationLevel_Aggregate_Vpic = {
  __typename?: 'ElectrificationLevel_aggregate_vpic';
  aggregate?: Maybe<ElectrificationLevel_Aggregate_Fields_Vpic>;
  nodes: Array<ElectrificationLevel_Vpic>;
};

/** aggregate avg on columns */
export type ElectrificationLevel_Avg_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.electrificationlevel". All fields are combined with a logical 'AND'. */
export type ElectrificationLevel_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ElectrificationLevel_Bool_Exp_Vpic>>;
  _not?: InputMaybe<ElectrificationLevel_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<ElectrificationLevel_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.electrificationlevel" */
export enum ElectrificationLevel_Constraint_Vpic {
  /** unique or primary key constraint on columns "name" */
  IxElectrificationlevel = 'ix_electrificationlevel',
  /** unique or primary key constraint on columns "id" */
  PkElectrificationlevel = 'pk_electrificationlevel'
}

/** input type for incrementing numeric columns in table "vpic.electrificationlevel" */
export type ElectrificationLevel_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.electrificationlevel" */
export type ElectrificationLevel_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ElectrificationLevel_Max_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ElectrificationLevel_Min_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.electrificationlevel" */
export type ElectrificationLevel_Mutation_Response_Vpic = {
  __typename?: 'ElectrificationLevel_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ElectrificationLevel_Vpic>;
};

/** on_conflict condition type for table "vpic.electrificationlevel" */
export type ElectrificationLevel_On_Conflict_Vpic = {
  constraint: ElectrificationLevel_Constraint_Vpic;
  update_columns?: Array<ElectrificationLevel_Update_Column_Vpic>;
  where?: InputMaybe<ElectrificationLevel_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.electrificationlevel". */
export type ElectrificationLevel_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.electrificationlevel */
export type ElectrificationLevel_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.electrificationlevel" */
export enum ElectrificationLevel_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.electrificationlevel" */
export type ElectrificationLevel_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ElectrificationLevel_Stddev_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ElectrificationLevel_Stddev_Pop_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ElectrificationLevel_Stddev_Samp_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ElectrificationLevel" */
export type ElectrificationLevel_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: ElectrificationLevel_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type ElectrificationLevel_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ElectrificationLevel_Sum_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.electrificationlevel" */
export enum ElectrificationLevel_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type ElectrificationLevel_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ElectrificationLevel_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ElectrificationLevel_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: ElectrificationLevel_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type ElectrificationLevel_Var_Pop_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ElectrificationLevel_Var_Samp_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ElectrificationLevel_Variance_Fields_Vpic = {
  __typename?: 'ElectrificationLevel_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.electrificationlevel" */
export type ElectrificationLevel_Vpic = {
  __typename?: 'ElectrificationLevel_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.element" */
export type Element_Aggregate_Fields_Vpic = {
  __typename?: 'Element_aggregate_fields_vpic';
  avg?: Maybe<Element_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Element_Max_Fields_Vpic>;
  min?: Maybe<Element_Min_Fields_Vpic>;
  stddev?: Maybe<Element_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Element_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Element_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Element_Sum_Fields_Vpic>;
  var_pop?: Maybe<Element_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Element_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Element_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.element" */
export type Element_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Element_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.element" */
export type Element_Aggregate_Vpic = {
  __typename?: 'Element_aggregate_vpic';
  aggregate?: Maybe<Element_Aggregate_Fields_Vpic>;
  nodes: Array<Element_Vpic>;
};

/** aggregate avg on columns */
export type Element_Avg_Fields_Vpic = {
  __typename?: 'Element_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxAllowedValue?: Maybe<Scalars['Float']>;
  MinAllowedValue?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.element". All fields are combined with a logical 'AND'. */
export type Element_Bool_Exp_Vpic = {
  Code?: InputMaybe<String_Comparison_Exp>;
  DataType?: InputMaybe<String_Comparison_Exp>;
  Decode?: InputMaybe<String_Comparison_Exp>;
  DefaultValues?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
  DefaultValues_aggregate?: InputMaybe<DefaultValue_Aggregate_Bool_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  GroupName?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  IsPrivate?: InputMaybe<Boolean_Comparison_Exp>;
  IsQS?: InputMaybe<Boolean_Comparison_Exp>;
  LookupTable?: InputMaybe<String_Comparison_Exp>;
  MaxAllowedValue?: InputMaybe<Int_Comparison_Exp>;
  MinAllowedValue?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Patterns?: InputMaybe<Pattern_Bool_Exp_Vpic>;
  Patterns_aggregate?: InputMaybe<Pattern_Aggregate_Bool_Exp>;
  VehicleSpecPatterns?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
  VehicleSpecPatterns_aggregate?: InputMaybe<VehicleSpecPattern_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Element_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Element_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Element_Bool_Exp_Vpic>>;
  weight?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vpic.element" */
export enum Element_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkElement = 'pk_element'
}

/** input type for incrementing numeric columns in table "vpic.element" */
export type Element_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MaxAllowedValue?: InputMaybe<Scalars['Int']>;
  MinAllowedValue?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.element" */
export type Element_Insert_Input_Vpic = {
  Code?: InputMaybe<Scalars['String']>;
  DataType?: InputMaybe<Scalars['String']>;
  Decode?: InputMaybe<Scalars['String']>;
  DefaultValues?: InputMaybe<DefaultValue_Arr_Rel_Insert_Input_Vpic>;
  Description?: InputMaybe<Scalars['String']>;
  GroupName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  IsPrivate?: InputMaybe<Scalars['Boolean']>;
  IsQS?: InputMaybe<Scalars['Boolean']>;
  LookupTable?: InputMaybe<Scalars['String']>;
  MaxAllowedValue?: InputMaybe<Scalars['Int']>;
  MinAllowedValue?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  Patterns?: InputMaybe<Pattern_Arr_Rel_Insert_Input_Vpic>;
  VehicleSpecPatterns?: InputMaybe<VehicleSpecPattern_Arr_Rel_Insert_Input_Vpic>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Element_Max_Fields_Vpic = {
  __typename?: 'Element_max_fields_vpic';
  Code?: Maybe<Scalars['String']>;
  DataType?: Maybe<Scalars['String']>;
  Decode?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  GroupName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  LookupTable?: Maybe<Scalars['String']>;
  MaxAllowedValue?: Maybe<Scalars['Int']>;
  MinAllowedValue?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Element_Min_Fields_Vpic = {
  __typename?: 'Element_min_fields_vpic';
  Code?: Maybe<Scalars['String']>;
  DataType?: Maybe<Scalars['String']>;
  Decode?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  GroupName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  LookupTable?: Maybe<Scalars['String']>;
  MaxAllowedValue?: Maybe<Scalars['Int']>;
  MinAllowedValue?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vpic.element" */
export type Element_Mutation_Response_Vpic = {
  __typename?: 'Element_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Element_Vpic>;
};

/** input type for inserting object relation for remote table "vpic.element" */
export type Element_Obj_Rel_Insert_Input_Vpic = {
  data: Element_Insert_Input_Vpic;
  /** upsert condition */
  on_conflict?: InputMaybe<Element_On_Conflict_Vpic>;
};

/** on_conflict condition type for table "vpic.element" */
export type Element_On_Conflict_Vpic = {
  constraint: Element_Constraint_Vpic;
  update_columns?: Array<Element_Update_Column_Vpic>;
  where?: InputMaybe<Element_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.element". */
export type Element_Order_By_Vpic = {
  Code?: InputMaybe<Order_By>;
  DataType?: InputMaybe<Order_By>;
  Decode?: InputMaybe<Order_By>;
  DefaultValues_aggregate?: InputMaybe<DefaultValue_Aggregate_Order_By_Vpic>;
  Description?: InputMaybe<Order_By>;
  GroupName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsPrivate?: InputMaybe<Order_By>;
  IsQS?: InputMaybe<Order_By>;
  LookupTable?: InputMaybe<Order_By>;
  MaxAllowedValue?: InputMaybe<Order_By>;
  MinAllowedValue?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Patterns_aggregate?: InputMaybe<Pattern_Aggregate_Order_By_Vpic>;
  VehicleSpecPatterns_aggregate?: InputMaybe<VehicleSpecPattern_Aggregate_Order_By_Vpic>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.element */
export type Element_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.element" */
export enum Element_Select_Column_Vpic {
  /** column name */
  Code = 'Code',
  /** column name */
  DataType = 'DataType',
  /** column name */
  Decode = 'Decode',
  /** column name */
  Description = 'Description',
  /** column name */
  GroupName = 'GroupName',
  /** column name */
  Id = 'Id',
  /** column name */
  IsPrivate = 'IsPrivate',
  /** column name */
  IsQs = 'IsQS',
  /** column name */
  LookupTable = 'LookupTable',
  /** column name */
  MaxAllowedValue = 'MaxAllowedValue',
  /** column name */
  MinAllowedValue = 'MinAllowedValue',
  /** column name */
  Name = 'Name',
  /** column name */
  Weight = 'weight'
}

/** input type for updating data in table "vpic.element" */
export type Element_Set_Input_Vpic = {
  Code?: InputMaybe<Scalars['String']>;
  DataType?: InputMaybe<Scalars['String']>;
  Decode?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  GroupName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  IsPrivate?: InputMaybe<Scalars['Boolean']>;
  IsQS?: InputMaybe<Scalars['Boolean']>;
  LookupTable?: InputMaybe<Scalars['String']>;
  MaxAllowedValue?: InputMaybe<Scalars['Int']>;
  MinAllowedValue?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Element_Stddev_Fields_Vpic = {
  __typename?: 'Element_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxAllowedValue?: Maybe<Scalars['Float']>;
  MinAllowedValue?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Element_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Element_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxAllowedValue?: Maybe<Scalars['Float']>;
  MinAllowedValue?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Element_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Element_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxAllowedValue?: Maybe<Scalars['Float']>;
  MinAllowedValue?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Element" */
export type Element_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Element_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Element_Stream_Cursor_Value_Input_Vpic = {
  Code?: InputMaybe<Scalars['String']>;
  DataType?: InputMaybe<Scalars['String']>;
  Decode?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  GroupName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  IsPrivate?: InputMaybe<Scalars['Boolean']>;
  IsQS?: InputMaybe<Scalars['Boolean']>;
  LookupTable?: InputMaybe<Scalars['String']>;
  MaxAllowedValue?: InputMaybe<Scalars['Int']>;
  MinAllowedValue?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Element_Sum_Fields_Vpic = {
  __typename?: 'Element_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MaxAllowedValue?: Maybe<Scalars['Int']>;
  MinAllowedValue?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.element" */
export enum Element_Update_Column_Vpic {
  /** column name */
  Code = 'Code',
  /** column name */
  DataType = 'DataType',
  /** column name */
  Decode = 'Decode',
  /** column name */
  Description = 'Description',
  /** column name */
  GroupName = 'GroupName',
  /** column name */
  Id = 'Id',
  /** column name */
  IsPrivate = 'IsPrivate',
  /** column name */
  IsQs = 'IsQS',
  /** column name */
  LookupTable = 'LookupTable',
  /** column name */
  MaxAllowedValue = 'MaxAllowedValue',
  /** column name */
  MinAllowedValue = 'MinAllowedValue',
  /** column name */
  Name = 'Name',
  /** column name */
  Weight = 'weight'
}

export type Element_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Element_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Element_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Element_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Element_Var_Pop_Fields_Vpic = {
  __typename?: 'Element_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxAllowedValue?: Maybe<Scalars['Float']>;
  MinAllowedValue?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Element_Var_Samp_Fields_Vpic = {
  __typename?: 'Element_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxAllowedValue?: Maybe<Scalars['Float']>;
  MinAllowedValue?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Element_Variance_Fields_Vpic = {
  __typename?: 'Element_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxAllowedValue?: Maybe<Scalars['Float']>;
  MinAllowedValue?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.element" */
export type Element_Vpic = {
  __typename?: 'Element_vpic';
  Code?: Maybe<Scalars['String']>;
  DataType?: Maybe<Scalars['String']>;
  Decode?: Maybe<Scalars['String']>;
  /** An array relationship */
  DefaultValues: Array<DefaultValue_Vpic>;
  /** An aggregate relationship */
  DefaultValues_aggregate: DefaultValue_Aggregate_Vpic;
  Description?: Maybe<Scalars['String']>;
  GroupName?: Maybe<Scalars['String']>;
  Id: Scalars['Int'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  IsQS?: Maybe<Scalars['Boolean']>;
  LookupTable?: Maybe<Scalars['String']>;
  MaxAllowedValue?: Maybe<Scalars['Int']>;
  MinAllowedValue?: Maybe<Scalars['Int']>;
  Name: Scalars['String'];
  /** An array relationship */
  Patterns: Array<Pattern_Vpic>;
  /** An aggregate relationship */
  Patterns_aggregate: Pattern_Aggregate_Vpic;
  /** An array relationship */
  VehicleSpecPatterns: Array<VehicleSpecPattern_Vpic>;
  /** An aggregate relationship */
  VehicleSpecPatterns_aggregate: VehicleSpecPattern_Aggregate_Vpic;
  weight?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "vpic.element" */
export type Element_VpicDefaultValuesArgs = {
  distinct_on?: InputMaybe<Array<DefaultValue_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DefaultValue_Order_By_Vpic>>;
  where?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.element" */
export type Element_VpicDefaultValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DefaultValue_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DefaultValue_Order_By_Vpic>>;
  where?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.element" */
export type Element_VpicPatternsArgs = {
  distinct_on?: InputMaybe<Array<Pattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pattern_Order_By_Vpic>>;
  where?: InputMaybe<Pattern_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.element" */
export type Element_VpicPatterns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pattern_Order_By_Vpic>>;
  where?: InputMaybe<Pattern_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.element" */
export type Element_VpicVehicleSpecPatternsArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecPattern_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.element" */
export type Element_VpicVehicleSpecPatterns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecPattern_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
};

/** aggregate fields of "vpic.engineconfiguration" */
export type EngineConfiguration_Aggregate_Fields_Vpic = {
  __typename?: 'EngineConfiguration_aggregate_fields_vpic';
  avg?: Maybe<EngineConfiguration_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<EngineConfiguration_Max_Fields_Vpic>;
  min?: Maybe<EngineConfiguration_Min_Fields_Vpic>;
  stddev?: Maybe<EngineConfiguration_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<EngineConfiguration_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<EngineConfiguration_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<EngineConfiguration_Sum_Fields_Vpic>;
  var_pop?: Maybe<EngineConfiguration_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<EngineConfiguration_Var_Samp_Fields_Vpic>;
  variance?: Maybe<EngineConfiguration_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.engineconfiguration" */
export type EngineConfiguration_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<EngineConfiguration_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.engineconfiguration" */
export type EngineConfiguration_Aggregate_Vpic = {
  __typename?: 'EngineConfiguration_aggregate_vpic';
  aggregate?: Maybe<EngineConfiguration_Aggregate_Fields_Vpic>;
  nodes: Array<EngineConfiguration_Vpic>;
};

/** aggregate avg on columns */
export type EngineConfiguration_Avg_Fields_Vpic = {
  __typename?: 'EngineConfiguration_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.engineconfiguration". All fields are combined with a logical 'AND'. */
export type EngineConfiguration_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<EngineConfiguration_Bool_Exp_Vpic>>;
  _not?: InputMaybe<EngineConfiguration_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<EngineConfiguration_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.engineconfiguration" */
export enum EngineConfiguration_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkEngineconfiguration = 'pk_engineconfiguration',
  /** unique or primary key constraint on columns "name" */
  UEngineconfigurationname = 'u_engineconfigurationname'
}

/** input type for incrementing numeric columns in table "vpic.engineconfiguration" */
export type EngineConfiguration_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.engineconfiguration" */
export type EngineConfiguration_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EngineConfiguration_Max_Fields_Vpic = {
  __typename?: 'EngineConfiguration_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EngineConfiguration_Min_Fields_Vpic = {
  __typename?: 'EngineConfiguration_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.engineconfiguration" */
export type EngineConfiguration_Mutation_Response_Vpic = {
  __typename?: 'EngineConfiguration_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EngineConfiguration_Vpic>;
};

/** on_conflict condition type for table "vpic.engineconfiguration" */
export type EngineConfiguration_On_Conflict_Vpic = {
  constraint: EngineConfiguration_Constraint_Vpic;
  update_columns?: Array<EngineConfiguration_Update_Column_Vpic>;
  where?: InputMaybe<EngineConfiguration_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.engineconfiguration". */
export type EngineConfiguration_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.engineconfiguration */
export type EngineConfiguration_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.engineconfiguration" */
export enum EngineConfiguration_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.engineconfiguration" */
export type EngineConfiguration_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EngineConfiguration_Stddev_Fields_Vpic = {
  __typename?: 'EngineConfiguration_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EngineConfiguration_Stddev_Pop_Fields_Vpic = {
  __typename?: 'EngineConfiguration_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EngineConfiguration_Stddev_Samp_Fields_Vpic = {
  __typename?: 'EngineConfiguration_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "EngineConfiguration" */
export type EngineConfiguration_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: EngineConfiguration_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type EngineConfiguration_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type EngineConfiguration_Sum_Fields_Vpic = {
  __typename?: 'EngineConfiguration_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.engineconfiguration" */
export enum EngineConfiguration_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type EngineConfiguration_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EngineConfiguration_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EngineConfiguration_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: EngineConfiguration_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type EngineConfiguration_Var_Pop_Fields_Vpic = {
  __typename?: 'EngineConfiguration_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EngineConfiguration_Var_Samp_Fields_Vpic = {
  __typename?: 'EngineConfiguration_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EngineConfiguration_Variance_Fields_Vpic = {
  __typename?: 'EngineConfiguration_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.engineconfiguration" */
export type EngineConfiguration_Vpic = {
  __typename?: 'EngineConfiguration_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type EngineModelPattern_Aggregate_Bool_Exp = {
  count?: InputMaybe<EngineModelPattern_Aggregate_Bool_Exp_Count>;
};

export type EngineModelPattern_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EngineModelPattern_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vpic.enginemodelpattern" */
export type EngineModelPattern_Aggregate_Fields_Vpic = {
  __typename?: 'EngineModelPattern_aggregate_fields_vpic';
  avg?: Maybe<EngineModelPattern_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<EngineModelPattern_Max_Fields_Vpic>;
  min?: Maybe<EngineModelPattern_Min_Fields_Vpic>;
  stddev?: Maybe<EngineModelPattern_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<EngineModelPattern_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<EngineModelPattern_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<EngineModelPattern_Sum_Fields_Vpic>;
  var_pop?: Maybe<EngineModelPattern_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<EngineModelPattern_Var_Samp_Fields_Vpic>;
  variance?: Maybe<EngineModelPattern_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.enginemodelpattern" */
export type EngineModelPattern_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<EngineModelPattern_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Aggregate_Order_By_Vpic = {
  avg?: InputMaybe<EngineModelPattern_Avg_Order_By_Vpic>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EngineModelPattern_Max_Order_By_Vpic>;
  min?: InputMaybe<EngineModelPattern_Min_Order_By_Vpic>;
  stddev?: InputMaybe<EngineModelPattern_Stddev_Order_By_Vpic>;
  stddev_pop?: InputMaybe<EngineModelPattern_Stddev_Pop_Order_By_Vpic>;
  stddev_samp?: InputMaybe<EngineModelPattern_Stddev_Samp_Order_By_Vpic>;
  sum?: InputMaybe<EngineModelPattern_Sum_Order_By_Vpic>;
  var_pop?: InputMaybe<EngineModelPattern_Var_Pop_Order_By_Vpic>;
  var_samp?: InputMaybe<EngineModelPattern_Var_Samp_Order_By_Vpic>;
  variance?: InputMaybe<EngineModelPattern_Variance_Order_By_Vpic>;
};

/** aggregated selection of "vpic.enginemodelpattern" */
export type EngineModelPattern_Aggregate_Vpic = {
  __typename?: 'EngineModelPattern_aggregate_vpic';
  aggregate?: Maybe<EngineModelPattern_Aggregate_Fields_Vpic>;
  nodes: Array<EngineModelPattern_Vpic>;
};

/** input type for inserting array relation for remote table "vpic.enginemodelpattern" */
export type EngineModelPattern_Arr_Rel_Insert_Input_Vpic = {
  data: Array<EngineModelPattern_Insert_Input_Vpic>;
  /** upsert condition */
  on_conflict?: InputMaybe<EngineModelPattern_On_Conflict_Vpic>;
};

/** aggregate avg on columns */
export type EngineModelPattern_Avg_Fields_Vpic = {
  __typename?: 'EngineModelPattern_avg_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  EngineModelId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Avg_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vpic.enginemodelpattern". All fields are combined with a logical 'AND'. */
export type EngineModelPattern_Bool_Exp_Vpic = {
  AttributeId?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  ElementId?: InputMaybe<Int_Comparison_Exp>;
  EngineModel?: InputMaybe<EngineModel_Bool_Exp_Vpic>;
  EngineModelId?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<EngineModelPattern_Bool_Exp_Vpic>>;
  _not?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<EngineModelPattern_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.enginemodelpattern" */
export enum EngineModelPattern_Constraint_Vpic {
  /** unique or primary key constraint on columns "enginemodelid", "elementid" */
  IxEnginemodelpatternKeyelementUnique = 'ix_enginemodelpattern_keyelement_unique',
  /** unique or primary key constraint on columns "id" */
  PkEnginemodelpattern = 'pk_enginemodelpattern'
}

/** input type for incrementing numeric columns in table "vpic.enginemodelpattern" */
export type EngineModelPattern_Inc_Input_Vpic = {
  ElementId?: InputMaybe<Scalars['Int']>;
  EngineModelId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.enginemodelpattern" */
export type EngineModelPattern_Insert_Input_Vpic = {
  AttributeId?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ElementId?: InputMaybe<Scalars['Int']>;
  EngineModel?: InputMaybe<EngineModel_Obj_Rel_Insert_Input_Vpic>;
  EngineModelId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type EngineModelPattern_Max_Fields_Vpic = {
  __typename?: 'EngineModelPattern_max_fields_vpic';
  AttributeId?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ElementId?: Maybe<Scalars['Int']>;
  EngineModelId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Max_Order_By_Vpic = {
  AttributeId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ElementId?: InputMaybe<Order_By>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EngineModelPattern_Min_Fields_Vpic = {
  __typename?: 'EngineModelPattern_min_fields_vpic';
  AttributeId?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ElementId?: Maybe<Scalars['Int']>;
  EngineModelId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Min_Order_By_Vpic = {
  AttributeId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ElementId?: InputMaybe<Order_By>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vpic.enginemodelpattern" */
export type EngineModelPattern_Mutation_Response_Vpic = {
  __typename?: 'EngineModelPattern_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EngineModelPattern_Vpic>;
};

/** on_conflict condition type for table "vpic.enginemodelpattern" */
export type EngineModelPattern_On_Conflict_Vpic = {
  constraint: EngineModelPattern_Constraint_Vpic;
  update_columns?: Array<EngineModelPattern_Update_Column_Vpic>;
  where?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.enginemodelpattern". */
export type EngineModelPattern_Order_By_Vpic = {
  AttributeId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ElementId?: InputMaybe<Order_By>;
  EngineModel?: InputMaybe<EngineModel_Order_By_Vpic>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.enginemodelpattern */
export type EngineModelPattern_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.enginemodelpattern" */
export enum EngineModelPattern_Select_Column_Vpic {
  /** column name */
  AttributeId = 'AttributeId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  ElementId = 'ElementId',
  /** column name */
  EngineModelId = 'EngineModelId',
  /** column name */
  Id = 'Id',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "vpic.enginemodelpattern" */
export type EngineModelPattern_Set_Input_Vpic = {
  AttributeId?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ElementId?: InputMaybe<Scalars['Int']>;
  EngineModelId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type EngineModelPattern_Stddev_Fields_Vpic = {
  __typename?: 'EngineModelPattern_stddev_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  EngineModelId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Stddev_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EngineModelPattern_Stddev_Pop_Fields_Vpic = {
  __typename?: 'EngineModelPattern_stddev_pop_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  EngineModelId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Stddev_Pop_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EngineModelPattern_Stddev_Samp_Fields_Vpic = {
  __typename?: 'EngineModelPattern_stddev_samp_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  EngineModelId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Stddev_Samp_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "EngineModelPattern" */
export type EngineModelPattern_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: EngineModelPattern_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type EngineModelPattern_Stream_Cursor_Value_Input_Vpic = {
  AttributeId?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ElementId?: InputMaybe<Scalars['Int']>;
  EngineModelId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type EngineModelPattern_Sum_Fields_Vpic = {
  __typename?: 'EngineModelPattern_sum_fields_vpic';
  ElementId?: Maybe<Scalars['Int']>;
  EngineModelId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Sum_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
};

/** update columns of table "vpic.enginemodelpattern" */
export enum EngineModelPattern_Update_Column_Vpic {
  /** column name */
  AttributeId = 'AttributeId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  ElementId = 'ElementId',
  /** column name */
  EngineModelId = 'EngineModelId',
  /** column name */
  Id = 'Id',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type EngineModelPattern_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EngineModelPattern_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EngineModelPattern_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: EngineModelPattern_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type EngineModelPattern_Var_Pop_Fields_Vpic = {
  __typename?: 'EngineModelPattern_var_pop_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  EngineModelId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Var_Pop_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EngineModelPattern_Var_Samp_Fields_Vpic = {
  __typename?: 'EngineModelPattern_var_samp_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  EngineModelId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Var_Samp_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EngineModelPattern_Variance_Fields_Vpic = {
  __typename?: 'EngineModelPattern_variance_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  EngineModelId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vpic.enginemodelpattern" */
export type EngineModelPattern_Variance_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  EngineModelId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
};

/** columns and relationships of "vpic.enginemodelpattern" */
export type EngineModelPattern_Vpic = {
  __typename?: 'EngineModelPattern_vpic';
  AttributeId: Scalars['String'];
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ElementId: Scalars['Int'];
  /** An object relationship */
  EngineModel?: Maybe<EngineModel_Vpic>;
  EngineModelId: Scalars['Int'];
  Id: Scalars['Int'];
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate fields of "vpic.enginemodel" */
export type EngineModel_Aggregate_Fields_Vpic = {
  __typename?: 'EngineModel_aggregate_fields_vpic';
  avg?: Maybe<EngineModel_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<EngineModel_Max_Fields_Vpic>;
  min?: Maybe<EngineModel_Min_Fields_Vpic>;
  stddev?: Maybe<EngineModel_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<EngineModel_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<EngineModel_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<EngineModel_Sum_Fields_Vpic>;
  var_pop?: Maybe<EngineModel_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<EngineModel_Var_Samp_Fields_Vpic>;
  variance?: Maybe<EngineModel_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.enginemodel" */
export type EngineModel_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<EngineModel_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.enginemodel" */
export type EngineModel_Aggregate_Vpic = {
  __typename?: 'EngineModel_aggregate_vpic';
  aggregate?: Maybe<EngineModel_Aggregate_Fields_Vpic>;
  nodes: Array<EngineModel_Vpic>;
};

/** aggregate avg on columns */
export type EngineModel_Avg_Fields_Vpic = {
  __typename?: 'EngineModel_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.enginemodel". All fields are combined with a logical 'AND'. */
export type EngineModel_Bool_Exp_Vpic = {
  Description?: InputMaybe<String_Comparison_Exp>;
  EngineModelPatterns?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
  EngineModelPatterns_aggregate?: InputMaybe<EngineModelPattern_Aggregate_Bool_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<EngineModel_Bool_Exp_Vpic>>;
  _not?: InputMaybe<EngineModel_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<EngineModel_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.enginemodel" */
export enum EngineModel_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkEnginemodel = 'pk_enginemodel'
}

/** input type for incrementing numeric columns in table "vpic.enginemodel" */
export type EngineModel_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.enginemodel" */
export type EngineModel_Insert_Input_Vpic = {
  Description?: InputMaybe<Scalars['String']>;
  EngineModelPatterns?: InputMaybe<EngineModelPattern_Arr_Rel_Insert_Input_Vpic>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EngineModel_Max_Fields_Vpic = {
  __typename?: 'EngineModel_max_fields_vpic';
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EngineModel_Min_Fields_Vpic = {
  __typename?: 'EngineModel_min_fields_vpic';
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.enginemodel" */
export type EngineModel_Mutation_Response_Vpic = {
  __typename?: 'EngineModel_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EngineModel_Vpic>;
};

/** input type for inserting object relation for remote table "vpic.enginemodel" */
export type EngineModel_Obj_Rel_Insert_Input_Vpic = {
  data: EngineModel_Insert_Input_Vpic;
  /** upsert condition */
  on_conflict?: InputMaybe<EngineModel_On_Conflict_Vpic>;
};

/** on_conflict condition type for table "vpic.enginemodel" */
export type EngineModel_On_Conflict_Vpic = {
  constraint: EngineModel_Constraint_Vpic;
  update_columns?: Array<EngineModel_Update_Column_Vpic>;
  where?: InputMaybe<EngineModel_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.enginemodel". */
export type EngineModel_Order_By_Vpic = {
  Description?: InputMaybe<Order_By>;
  EngineModelPatterns_aggregate?: InputMaybe<EngineModelPattern_Aggregate_Order_By_Vpic>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.enginemodel */
export type EngineModel_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.enginemodel" */
export enum EngineModel_Select_Column_Vpic {
  /** column name */
  Description = 'Description',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.enginemodel" */
export type EngineModel_Set_Input_Vpic = {
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EngineModel_Stddev_Fields_Vpic = {
  __typename?: 'EngineModel_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EngineModel_Stddev_Pop_Fields_Vpic = {
  __typename?: 'EngineModel_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EngineModel_Stddev_Samp_Fields_Vpic = {
  __typename?: 'EngineModel_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "EngineModel" */
export type EngineModel_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: EngineModel_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type EngineModel_Stream_Cursor_Value_Input_Vpic = {
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type EngineModel_Sum_Fields_Vpic = {
  __typename?: 'EngineModel_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.enginemodel" */
export enum EngineModel_Update_Column_Vpic {
  /** column name */
  Description = 'Description',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type EngineModel_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EngineModel_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EngineModel_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: EngineModel_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type EngineModel_Var_Pop_Fields_Vpic = {
  __typename?: 'EngineModel_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EngineModel_Var_Samp_Fields_Vpic = {
  __typename?: 'EngineModel_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EngineModel_Variance_Fields_Vpic = {
  __typename?: 'EngineModel_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.enginemodel" */
export type EngineModel_Vpic = {
  __typename?: 'EngineModel_vpic';
  Description?: Maybe<Scalars['String']>;
  /** An array relationship */
  EngineModelPatterns: Array<EngineModelPattern_Vpic>;
  /** An aggregate relationship */
  EngineModelPatterns_aggregate: EngineModelPattern_Aggregate_Vpic;
  Id: Scalars['Int'];
  Name: Scalars['String'];
};


/** columns and relationships of "vpic.enginemodel" */
export type EngineModel_VpicEngineModelPatternsArgs = {
  distinct_on?: InputMaybe<Array<EngineModelPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineModelPattern_Order_By_Vpic>>;
  where?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.enginemodel" */
export type EngineModel_VpicEngineModelPatterns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EngineModelPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineModelPattern_Order_By_Vpic>>;
  where?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
};

/** aggregate fields of "vpic.entertainmentsystem" */
export type EntertainmentSystem_Aggregate_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_aggregate_fields_vpic';
  avg?: Maybe<EntertainmentSystem_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<EntertainmentSystem_Max_Fields_Vpic>;
  min?: Maybe<EntertainmentSystem_Min_Fields_Vpic>;
  stddev?: Maybe<EntertainmentSystem_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<EntertainmentSystem_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<EntertainmentSystem_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<EntertainmentSystem_Sum_Fields_Vpic>;
  var_pop?: Maybe<EntertainmentSystem_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<EntertainmentSystem_Var_Samp_Fields_Vpic>;
  variance?: Maybe<EntertainmentSystem_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.entertainmentsystem" */
export type EntertainmentSystem_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<EntertainmentSystem_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.entertainmentsystem" */
export type EntertainmentSystem_Aggregate_Vpic = {
  __typename?: 'EntertainmentSystem_aggregate_vpic';
  aggregate?: Maybe<EntertainmentSystem_Aggregate_Fields_Vpic>;
  nodes: Array<EntertainmentSystem_Vpic>;
};

/** aggregate avg on columns */
export type EntertainmentSystem_Avg_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.entertainmentsystem". All fields are combined with a logical 'AND'. */
export type EntertainmentSystem_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<EntertainmentSystem_Bool_Exp_Vpic>>;
  _not?: InputMaybe<EntertainmentSystem_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<EntertainmentSystem_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.entertainmentsystem" */
export enum EntertainmentSystem_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkEntertainmentsystem = 'pk_entertainmentsystem',
  /** unique or primary key constraint on columns "name" */
  UEntertainmentsystemname = 'u_entertainmentsystemname'
}

/** input type for incrementing numeric columns in table "vpic.entertainmentsystem" */
export type EntertainmentSystem_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.entertainmentsystem" */
export type EntertainmentSystem_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EntertainmentSystem_Max_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EntertainmentSystem_Min_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.entertainmentsystem" */
export type EntertainmentSystem_Mutation_Response_Vpic = {
  __typename?: 'EntertainmentSystem_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntertainmentSystem_Vpic>;
};

/** on_conflict condition type for table "vpic.entertainmentsystem" */
export type EntertainmentSystem_On_Conflict_Vpic = {
  constraint: EntertainmentSystem_Constraint_Vpic;
  update_columns?: Array<EntertainmentSystem_Update_Column_Vpic>;
  where?: InputMaybe<EntertainmentSystem_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.entertainmentsystem". */
export type EntertainmentSystem_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.entertainmentsystem */
export type EntertainmentSystem_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.entertainmentsystem" */
export enum EntertainmentSystem_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.entertainmentsystem" */
export type EntertainmentSystem_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EntertainmentSystem_Stddev_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EntertainmentSystem_Stddev_Pop_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EntertainmentSystem_Stddev_Samp_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "EntertainmentSystem" */
export type EntertainmentSystem_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: EntertainmentSystem_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type EntertainmentSystem_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type EntertainmentSystem_Sum_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.entertainmentsystem" */
export enum EntertainmentSystem_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type EntertainmentSystem_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EntertainmentSystem_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntertainmentSystem_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: EntertainmentSystem_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type EntertainmentSystem_Var_Pop_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EntertainmentSystem_Var_Samp_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EntertainmentSystem_Variance_Fields_Vpic = {
  __typename?: 'EntertainmentSystem_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.entertainmentsystem" */
export type EntertainmentSystem_Vpic = {
  __typename?: 'EntertainmentSystem_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Entity_ConfigurationItem = {
  __typename?: 'Entity_ConfigurationItem';
  configurationItemId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate fields of "vpic.errorcode" */
export type ErrorCode_Aggregate_Fields_Vpic = {
  __typename?: 'ErrorCode_aggregate_fields_vpic';
  avg?: Maybe<ErrorCode_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<ErrorCode_Max_Fields_Vpic>;
  min?: Maybe<ErrorCode_Min_Fields_Vpic>;
  stddev?: Maybe<ErrorCode_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<ErrorCode_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<ErrorCode_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<ErrorCode_Sum_Fields_Vpic>;
  var_pop?: Maybe<ErrorCode_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<ErrorCode_Var_Samp_Fields_Vpic>;
  variance?: Maybe<ErrorCode_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.errorcode" */
export type ErrorCode_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<ErrorCode_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.errorcode" */
export type ErrorCode_Aggregate_Vpic = {
  __typename?: 'ErrorCode_aggregate_vpic';
  aggregate?: Maybe<ErrorCode_Aggregate_Fields_Vpic>;
  nodes: Array<ErrorCode_Vpic>;
};

/** aggregate avg on columns */
export type ErrorCode_Avg_Fields_Vpic = {
  __typename?: 'ErrorCode_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.errorcode". All fields are combined with a logical 'AND'. */
export type ErrorCode_Bool_Exp_Vpic = {
  AdditionalErrorText?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ErrorCode_Bool_Exp_Vpic>>;
  _not?: InputMaybe<ErrorCode_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<ErrorCode_Bool_Exp_Vpic>>;
  weight?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vpic.errorcode" */
export enum ErrorCode_Constraint_Vpic {
  /** unique or primary key constraint on columns "name" */
  IxName = 'ix_name',
  /** unique or primary key constraint on columns "id" */
  PkErrorcode = 'pk_errorcode'
}

/** input type for incrementing numeric columns in table "vpic.errorcode" */
export type ErrorCode_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.errorcode" */
export type ErrorCode_Insert_Input_Vpic = {
  AdditionalErrorText?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ErrorCode_Max_Fields_Vpic = {
  __typename?: 'ErrorCode_max_fields_vpic';
  AdditionalErrorText?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ErrorCode_Min_Fields_Vpic = {
  __typename?: 'ErrorCode_min_fields_vpic';
  AdditionalErrorText?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vpic.errorcode" */
export type ErrorCode_Mutation_Response_Vpic = {
  __typename?: 'ErrorCode_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ErrorCode_Vpic>;
};

/** on_conflict condition type for table "vpic.errorcode" */
export type ErrorCode_On_Conflict_Vpic = {
  constraint: ErrorCode_Constraint_Vpic;
  update_columns?: Array<ErrorCode_Update_Column_Vpic>;
  where?: InputMaybe<ErrorCode_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.errorcode". */
export type ErrorCode_Order_By_Vpic = {
  AdditionalErrorText?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.errorcode */
export type ErrorCode_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.errorcode" */
export enum ErrorCode_Select_Column_Vpic {
  /** column name */
  AdditionalErrorText = 'AdditionalErrorText',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Weight = 'weight'
}

/** input type for updating data in table "vpic.errorcode" */
export type ErrorCode_Set_Input_Vpic = {
  AdditionalErrorText?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ErrorCode_Stddev_Fields_Vpic = {
  __typename?: 'ErrorCode_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ErrorCode_Stddev_Pop_Fields_Vpic = {
  __typename?: 'ErrorCode_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ErrorCode_Stddev_Samp_Fields_Vpic = {
  __typename?: 'ErrorCode_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ErrorCode" */
export type ErrorCode_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: ErrorCode_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type ErrorCode_Stream_Cursor_Value_Input_Vpic = {
  AdditionalErrorText?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ErrorCode_Sum_Fields_Vpic = {
  __typename?: 'ErrorCode_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.errorcode" */
export enum ErrorCode_Update_Column_Vpic {
  /** column name */
  AdditionalErrorText = 'AdditionalErrorText',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Weight = 'weight'
}

export type ErrorCode_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ErrorCode_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ErrorCode_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: ErrorCode_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type ErrorCode_Var_Pop_Fields_Vpic = {
  __typename?: 'ErrorCode_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ErrorCode_Var_Samp_Fields_Vpic = {
  __typename?: 'ErrorCode_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ErrorCode_Variance_Fields_Vpic = {
  __typename?: 'ErrorCode_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.errorcode" */
export type ErrorCode_Vpic = {
  __typename?: 'ErrorCode_vpic';
  AdditionalErrorText?: Maybe<Scalars['String']>;
  Id: Scalars['Int'];
  Name: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};

export type ExpirationCalculationMetadata = {
  __typename?: 'ExpirationCalculationMetadata';
  expirationDateCalculationFixedValue?: Maybe<Scalars['Int']>;
  expirationDateCalculationTypeId?: Maybe<Scalars['Int']>;
  expirationMilesCalculationFixedValue?: Maybe<Scalars['Int']>;
  expirationMilesCalculationTypeId?: Maybe<Scalars['Int']>;
  secondaryExpirationDateCalculationFixedValue?: Maybe<Scalars['Int']>;
  secondaryExpirationDateCalculationTypeId?: Maybe<Scalars['Int']>;
  secondaryExpirationMilesCalculationFixedValue?: Maybe<Scalars['Int']>;
  secondaryExpirationMilesCalculationTypeId?: Maybe<Scalars['Int']>;
};

export type Expired_Date_V1 = {
  __typename?: 'Expired_Date_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  expirationDate: Scalars['date'];
  vin: Scalars['String'];
};

export type Expired_Mileage_V1 = {
  __typename?: 'Expired_Mileage_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  expirationMileage: Scalars['numeric'];
  vin: Scalars['String'];
};

export type FileStorageMetadata = {
  __typename?: 'FileStorageMetadata';
  contentType: Scalars['String'];
  extension: Scalars['String'];
  size: Scalars['long'];
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

/** aggregate fields of "vpic.forwardcollisionwarning" */
export type ForwardCollisionWarning_Aggregate_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_aggregate_fields_vpic';
  avg?: Maybe<ForwardCollisionWarning_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<ForwardCollisionWarning_Max_Fields_Vpic>;
  min?: Maybe<ForwardCollisionWarning_Min_Fields_Vpic>;
  stddev?: Maybe<ForwardCollisionWarning_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<ForwardCollisionWarning_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<ForwardCollisionWarning_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<ForwardCollisionWarning_Sum_Fields_Vpic>;
  var_pop?: Maybe<ForwardCollisionWarning_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<ForwardCollisionWarning_Var_Samp_Fields_Vpic>;
  variance?: Maybe<ForwardCollisionWarning_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.forwardcollisionwarning" */
export type ForwardCollisionWarning_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<ForwardCollisionWarning_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.forwardcollisionwarning" */
export type ForwardCollisionWarning_Aggregate_Vpic = {
  __typename?: 'ForwardCollisionWarning_aggregate_vpic';
  aggregate?: Maybe<ForwardCollisionWarning_Aggregate_Fields_Vpic>;
  nodes: Array<ForwardCollisionWarning_Vpic>;
};

/** aggregate avg on columns */
export type ForwardCollisionWarning_Avg_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.forwardcollisionwarning". All fields are combined with a logical 'AND'. */
export type ForwardCollisionWarning_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ForwardCollisionWarning_Bool_Exp_Vpic>>;
  _not?: InputMaybe<ForwardCollisionWarning_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<ForwardCollisionWarning_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.forwardcollisionwarning" */
export enum ForwardCollisionWarning_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkForwardcollisionwarning = 'pk_forwardcollisionwarning',
  /** unique or primary key constraint on columns "name" */
  UForwardcollisionwarningname = 'u_forwardcollisionwarningname'
}

/** input type for incrementing numeric columns in table "vpic.forwardcollisionwarning" */
export type ForwardCollisionWarning_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.forwardcollisionwarning" */
export type ForwardCollisionWarning_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ForwardCollisionWarning_Max_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ForwardCollisionWarning_Min_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.forwardcollisionwarning" */
export type ForwardCollisionWarning_Mutation_Response_Vpic = {
  __typename?: 'ForwardCollisionWarning_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ForwardCollisionWarning_Vpic>;
};

/** on_conflict condition type for table "vpic.forwardcollisionwarning" */
export type ForwardCollisionWarning_On_Conflict_Vpic = {
  constraint: ForwardCollisionWarning_Constraint_Vpic;
  update_columns?: Array<ForwardCollisionWarning_Update_Column_Vpic>;
  where?: InputMaybe<ForwardCollisionWarning_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.forwardcollisionwarning". */
export type ForwardCollisionWarning_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.forwardcollisionwarning */
export type ForwardCollisionWarning_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.forwardcollisionwarning" */
export enum ForwardCollisionWarning_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.forwardcollisionwarning" */
export type ForwardCollisionWarning_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ForwardCollisionWarning_Stddev_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ForwardCollisionWarning_Stddev_Pop_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ForwardCollisionWarning_Stddev_Samp_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ForwardCollisionWarning" */
export type ForwardCollisionWarning_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: ForwardCollisionWarning_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type ForwardCollisionWarning_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ForwardCollisionWarning_Sum_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.forwardcollisionwarning" */
export enum ForwardCollisionWarning_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type ForwardCollisionWarning_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ForwardCollisionWarning_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ForwardCollisionWarning_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: ForwardCollisionWarning_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type ForwardCollisionWarning_Var_Pop_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ForwardCollisionWarning_Var_Samp_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ForwardCollisionWarning_Variance_Fields_Vpic = {
  __typename?: 'ForwardCollisionWarning_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.forwardcollisionwarning" */
export type ForwardCollisionWarning_Vpic = {
  __typename?: 'ForwardCollisionWarning_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.fueldeliverytype" */
export type FuelDeliveryType_Aggregate_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_aggregate_fields_vpic';
  avg?: Maybe<FuelDeliveryType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<FuelDeliveryType_Max_Fields_Vpic>;
  min?: Maybe<FuelDeliveryType_Min_Fields_Vpic>;
  stddev?: Maybe<FuelDeliveryType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<FuelDeliveryType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<FuelDeliveryType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<FuelDeliveryType_Sum_Fields_Vpic>;
  var_pop?: Maybe<FuelDeliveryType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<FuelDeliveryType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<FuelDeliveryType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.fueldeliverytype" */
export type FuelDeliveryType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<FuelDeliveryType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.fueldeliverytype" */
export type FuelDeliveryType_Aggregate_Vpic = {
  __typename?: 'FuelDeliveryType_aggregate_vpic';
  aggregate?: Maybe<FuelDeliveryType_Aggregate_Fields_Vpic>;
  nodes: Array<FuelDeliveryType_Vpic>;
};

/** aggregate avg on columns */
export type FuelDeliveryType_Avg_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.fueldeliverytype". All fields are combined with a logical 'AND'. */
export type FuelDeliveryType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<FuelDeliveryType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<FuelDeliveryType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<FuelDeliveryType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.fueldeliverytype" */
export enum FuelDeliveryType_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkFueldeliverytype = 'pk_fueldeliverytype',
  /** unique or primary key constraint on columns "name" */
  UFuelinjectiontypename = 'u_fuelinjectiontypename'
}

/** input type for incrementing numeric columns in table "vpic.fueldeliverytype" */
export type FuelDeliveryType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.fueldeliverytype" */
export type FuelDeliveryType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FuelDeliveryType_Max_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FuelDeliveryType_Min_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.fueldeliverytype" */
export type FuelDeliveryType_Mutation_Response_Vpic = {
  __typename?: 'FuelDeliveryType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FuelDeliveryType_Vpic>;
};

/** on_conflict condition type for table "vpic.fueldeliverytype" */
export type FuelDeliveryType_On_Conflict_Vpic = {
  constraint: FuelDeliveryType_Constraint_Vpic;
  update_columns?: Array<FuelDeliveryType_Update_Column_Vpic>;
  where?: InputMaybe<FuelDeliveryType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.fueldeliverytype". */
export type FuelDeliveryType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.fueldeliverytype */
export type FuelDeliveryType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.fueldeliverytype" */
export enum FuelDeliveryType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.fueldeliverytype" */
export type FuelDeliveryType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type FuelDeliveryType_Stddev_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FuelDeliveryType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FuelDeliveryType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "FuelDeliveryType" */
export type FuelDeliveryType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: FuelDeliveryType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type FuelDeliveryType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type FuelDeliveryType_Sum_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.fueldeliverytype" */
export enum FuelDeliveryType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type FuelDeliveryType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FuelDeliveryType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FuelDeliveryType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: FuelDeliveryType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type FuelDeliveryType_Var_Pop_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FuelDeliveryType_Var_Samp_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FuelDeliveryType_Variance_Fields_Vpic = {
  __typename?: 'FuelDeliveryType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.fueldeliverytype" */
export type FuelDeliveryType_Vpic = {
  __typename?: 'FuelDeliveryType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.fueltankmaterial" */
export type FuelTankMaterial_Aggregate_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_aggregate_fields_vpic';
  avg?: Maybe<FuelTankMaterial_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<FuelTankMaterial_Max_Fields_Vpic>;
  min?: Maybe<FuelTankMaterial_Min_Fields_Vpic>;
  stddev?: Maybe<FuelTankMaterial_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<FuelTankMaterial_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<FuelTankMaterial_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<FuelTankMaterial_Sum_Fields_Vpic>;
  var_pop?: Maybe<FuelTankMaterial_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<FuelTankMaterial_Var_Samp_Fields_Vpic>;
  variance?: Maybe<FuelTankMaterial_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.fueltankmaterial" */
export type FuelTankMaterial_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<FuelTankMaterial_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.fueltankmaterial" */
export type FuelTankMaterial_Aggregate_Vpic = {
  __typename?: 'FuelTankMaterial_aggregate_vpic';
  aggregate?: Maybe<FuelTankMaterial_Aggregate_Fields_Vpic>;
  nodes: Array<FuelTankMaterial_Vpic>;
};

/** aggregate avg on columns */
export type FuelTankMaterial_Avg_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.fueltankmaterial". All fields are combined with a logical 'AND'. */
export type FuelTankMaterial_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<FuelTankMaterial_Bool_Exp_Vpic>>;
  _not?: InputMaybe<FuelTankMaterial_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<FuelTankMaterial_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.fueltankmaterial" */
export enum FuelTankMaterial_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkFueltankmaterial = 'pk_fueltankmaterial',
  /** unique or primary key constraint on columns "name" */
  UFueltankmaterial = 'u_fueltankmaterial'
}

/** input type for incrementing numeric columns in table "vpic.fueltankmaterial" */
export type FuelTankMaterial_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.fueltankmaterial" */
export type FuelTankMaterial_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FuelTankMaterial_Max_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FuelTankMaterial_Min_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.fueltankmaterial" */
export type FuelTankMaterial_Mutation_Response_Vpic = {
  __typename?: 'FuelTankMaterial_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FuelTankMaterial_Vpic>;
};

/** on_conflict condition type for table "vpic.fueltankmaterial" */
export type FuelTankMaterial_On_Conflict_Vpic = {
  constraint: FuelTankMaterial_Constraint_Vpic;
  update_columns?: Array<FuelTankMaterial_Update_Column_Vpic>;
  where?: InputMaybe<FuelTankMaterial_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.fueltankmaterial". */
export type FuelTankMaterial_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.fueltankmaterial */
export type FuelTankMaterial_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.fueltankmaterial" */
export enum FuelTankMaterial_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.fueltankmaterial" */
export type FuelTankMaterial_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type FuelTankMaterial_Stddev_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FuelTankMaterial_Stddev_Pop_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FuelTankMaterial_Stddev_Samp_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "FuelTankMaterial" */
export type FuelTankMaterial_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: FuelTankMaterial_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type FuelTankMaterial_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type FuelTankMaterial_Sum_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.fueltankmaterial" */
export enum FuelTankMaterial_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type FuelTankMaterial_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FuelTankMaterial_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FuelTankMaterial_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: FuelTankMaterial_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type FuelTankMaterial_Var_Pop_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FuelTankMaterial_Var_Samp_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FuelTankMaterial_Variance_Fields_Vpic = {
  __typename?: 'FuelTankMaterial_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.fueltankmaterial" */
export type FuelTankMaterial_Vpic = {
  __typename?: 'FuelTankMaterial_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.fueltanktype" */
export type FuelTankType_Aggregate_Fields_Vpic = {
  __typename?: 'FuelTankType_aggregate_fields_vpic';
  avg?: Maybe<FuelTankType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<FuelTankType_Max_Fields_Vpic>;
  min?: Maybe<FuelTankType_Min_Fields_Vpic>;
  stddev?: Maybe<FuelTankType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<FuelTankType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<FuelTankType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<FuelTankType_Sum_Fields_Vpic>;
  var_pop?: Maybe<FuelTankType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<FuelTankType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<FuelTankType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.fueltanktype" */
export type FuelTankType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<FuelTankType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.fueltanktype" */
export type FuelTankType_Aggregate_Vpic = {
  __typename?: 'FuelTankType_aggregate_vpic';
  aggregate?: Maybe<FuelTankType_Aggregate_Fields_Vpic>;
  nodes: Array<FuelTankType_Vpic>;
};

/** aggregate avg on columns */
export type FuelTankType_Avg_Fields_Vpic = {
  __typename?: 'FuelTankType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.fueltanktype". All fields are combined with a logical 'AND'. */
export type FuelTankType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<FuelTankType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<FuelTankType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<FuelTankType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.fueltanktype" */
export enum FuelTankType_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkFueltanktype = 'pk_fueltanktype',
  /** unique or primary key constraint on columns "name" */
  UFueltanktype = 'u_fueltanktype'
}

/** input type for incrementing numeric columns in table "vpic.fueltanktype" */
export type FuelTankType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.fueltanktype" */
export type FuelTankType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FuelTankType_Max_Fields_Vpic = {
  __typename?: 'FuelTankType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FuelTankType_Min_Fields_Vpic = {
  __typename?: 'FuelTankType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.fueltanktype" */
export type FuelTankType_Mutation_Response_Vpic = {
  __typename?: 'FuelTankType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FuelTankType_Vpic>;
};

/** on_conflict condition type for table "vpic.fueltanktype" */
export type FuelTankType_On_Conflict_Vpic = {
  constraint: FuelTankType_Constraint_Vpic;
  update_columns?: Array<FuelTankType_Update_Column_Vpic>;
  where?: InputMaybe<FuelTankType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.fueltanktype". */
export type FuelTankType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.fueltanktype */
export type FuelTankType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.fueltanktype" */
export enum FuelTankType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.fueltanktype" */
export type FuelTankType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type FuelTankType_Stddev_Fields_Vpic = {
  __typename?: 'FuelTankType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FuelTankType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'FuelTankType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FuelTankType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'FuelTankType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "FuelTankType" */
export type FuelTankType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: FuelTankType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type FuelTankType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type FuelTankType_Sum_Fields_Vpic = {
  __typename?: 'FuelTankType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.fueltanktype" */
export enum FuelTankType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type FuelTankType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FuelTankType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FuelTankType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: FuelTankType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type FuelTankType_Var_Pop_Fields_Vpic = {
  __typename?: 'FuelTankType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FuelTankType_Var_Samp_Fields_Vpic = {
  __typename?: 'FuelTankType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FuelTankType_Variance_Fields_Vpic = {
  __typename?: 'FuelTankType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.fueltanktype" */
export type FuelTankType_Vpic = {
  __typename?: 'FuelTankType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.fueltype" */
export type FuelType_Aggregate_Fields_Vpic = {
  __typename?: 'FuelType_aggregate_fields_vpic';
  avg?: Maybe<FuelType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<FuelType_Max_Fields_Vpic>;
  min?: Maybe<FuelType_Min_Fields_Vpic>;
  stddev?: Maybe<FuelType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<FuelType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<FuelType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<FuelType_Sum_Fields_Vpic>;
  var_pop?: Maybe<FuelType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<FuelType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<FuelType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.fueltype" */
export type FuelType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<FuelType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.fueltype" */
export type FuelType_Aggregate_Vpic = {
  __typename?: 'FuelType_aggregate_vpic';
  aggregate?: Maybe<FuelType_Aggregate_Fields_Vpic>;
  nodes: Array<FuelType_Vpic>;
};

/** aggregate avg on columns */
export type FuelType_Avg_Fields_Vpic = {
  __typename?: 'FuelType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.fueltype". All fields are combined with a logical 'AND'. */
export type FuelType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<FuelType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<FuelType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<FuelType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.fueltype" */
export enum FuelType_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkFueltype = 'pk_fueltype',
  /** unique or primary key constraint on columns "name" */
  UFueltypename = 'u_fueltypename'
}

/** input type for incrementing numeric columns in table "vpic.fueltype" */
export type FuelType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.fueltype" */
export type FuelType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FuelType_Max_Fields_Vpic = {
  __typename?: 'FuelType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FuelType_Min_Fields_Vpic = {
  __typename?: 'FuelType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.fueltype" */
export type FuelType_Mutation_Response_Vpic = {
  __typename?: 'FuelType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FuelType_Vpic>;
};

/** on_conflict condition type for table "vpic.fueltype" */
export type FuelType_On_Conflict_Vpic = {
  constraint: FuelType_Constraint_Vpic;
  update_columns?: Array<FuelType_Update_Column_Vpic>;
  where?: InputMaybe<FuelType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.fueltype". */
export type FuelType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.fueltype */
export type FuelType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.fueltype" */
export enum FuelType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.fueltype" */
export type FuelType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type FuelType_Stddev_Fields_Vpic = {
  __typename?: 'FuelType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FuelType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'FuelType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FuelType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'FuelType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "FuelType" */
export type FuelType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: FuelType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type FuelType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type FuelType_Sum_Fields_Vpic = {
  __typename?: 'FuelType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.fueltype" */
export enum FuelType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type FuelType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FuelType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FuelType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: FuelType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type FuelType_Var_Pop_Fields_Vpic = {
  __typename?: 'FuelType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FuelType_Var_Samp_Fields_Vpic = {
  __typename?: 'FuelType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FuelType_Variance_Fields_Vpic = {
  __typename?: 'FuelType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.fueltype" */
export type FuelType_Vpic = {
  __typename?: 'FuelType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Gap_Claim_Adjustment = {
  __typename?: 'GAP_Claim_Adjustment';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Gap_Claim_Denial_Letter_V1 = {
  __typename?: 'GAP_Claim_Denial_Letter_v1';
  cc: Scalars['String'];
  contractNumber: Scalars['String'];
  customerAddress1: Scalars['String'];
  customerAddress2: Scalars['String'];
  customerCity: Scalars['String'];
  customerName: Scalars['String'];
  customerState: Scalars['String'];
  customerZip: Scalars['String'];
  date: Scalars['String'];
  dateOfLoss: Scalars['String'];
  lenderName: Scalars['String'];
  purchaseDate: Scalars['String'];
  refinanceDate: Scalars['String'];
  salvageTitleDate: Scalars['String'];
  vehicleMake: Scalars['String'];
  vehicleModel: Scalars['String'];
  vehicleType: Scalars['String'];
  vehicleYear: Scalars['String'];
};

export type Gap_Claim_Finishing_Letter_V1 = {
  __typename?: 'GAP_Claim_Finishing_Letter_v1';
  adjustments: Array<Gap_Claim_Adjustment>;
  adjustmentsTotal: Scalars['String'];
  claimStatus: Scalars['String'];
  contractNumber: Scalars['String'];
  contractualPayoff: Scalars['String'];
  customerAddress1: Scalars['String'];
  customerAddress2: Scalars['String'];
  customerCity: Scalars['String'];
  customerName: Scalars['String'];
  customerState: Scalars['String'];
  customerZip: Scalars['String'];
  date: Scalars['String'];
  dateOfLoss: Scalars['String'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  lenderAddress1: Scalars['String'];
  lenderAddress2: Scalars['String'];
  lenderCity: Scalars['String'];
  lenderName: Scalars['String'];
  lenderState: Scalars['String'];
  lenderZip: Scalars['String'];
  loanNumber: Scalars['String'];
  notCoveredItems: Array<Gap_Claim_Adjustment>;
  notCoveredItemsTotal: Scalars['String'];
  refunds: Array<Gap_Claim_Adjustment>;
  refundsTotal: Scalars['String'];
  totalBalanceWaivedToLender: Scalars['String'];
  vehicleMake: Scalars['String'];
  vehicleModel: Scalars['String'];
  vehicleYear: Scalars['String'];
  vin: Scalars['String'];
};

export type Gap_Claim_Initial_Letter_V1 = {
  __typename?: 'GAP_Claim_Initial_Letter_v1';
  contractNumber: Scalars['String'];
  customerAddress1: Scalars['String'];
  customerAddress2: Scalars['String'];
  customerCity: Scalars['String'];
  customerName: Scalars['String'];
  customerState: Scalars['String'];
  customerZip: Scalars['String'];
  date: Scalars['String'];
  missingDocuments?: Maybe<Array<Scalars['String']>>;
};

export type Gap_Claim_Working_Letter_V1 = {
  __typename?: 'GAP_Claim_Working_Letter_v1';
  allDocumentsReceivedDate: Scalars['String'];
  claimDate: Scalars['String'];
  contractNumber: Scalars['String'];
  customerAddress1: Scalars['String'];
  customerAddress2: Scalars['String'];
  customerCity: Scalars['String'];
  customerName: Scalars['String'];
  customerState: Scalars['String'];
  customerZip: Scalars['String'];
  date: Scalars['String'];
  lenderName: Scalars['String'];
  missingDocuments?: Maybe<Array<Scalars['String']>>;
  vehicleMake: Scalars['String'];
  vehicleModel: Scalars['String'];
  vehicleYear: Scalars['String'];
  vin: Scalars['String'];
};

export type GlobalSearchCommand_Metadata = {
  __typename?: 'GlobalSearchCommand_Metadata';
  chipDisplay?: Maybe<Scalars['String']>;
  qualifiers?: Maybe<Array<GlobalSearchCommand_Metadata_Qualifier>>;
};

export type GlobalSearchCommand_Metadata_Qualifier = {
  __typename?: 'GlobalSearchCommand_Metadata_Qualifier';
  key: Scalars['String'];
  label: Scalars['String'];
  minLength?: Maybe<Scalars['Int']>;
  placeholder: Scalars['String'];
  valueType: Scalars['String'];
};

/** aggregate fields of "vpic.grossvehicleweightrating" */
export type GrossVehicleWeightRating_Aggregate_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_aggregate_fields_vpic';
  avg?: Maybe<GrossVehicleWeightRating_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<GrossVehicleWeightRating_Max_Fields_Vpic>;
  min?: Maybe<GrossVehicleWeightRating_Min_Fields_Vpic>;
  stddev?: Maybe<GrossVehicleWeightRating_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<GrossVehicleWeightRating_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<GrossVehicleWeightRating_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<GrossVehicleWeightRating_Sum_Fields_Vpic>;
  var_pop?: Maybe<GrossVehicleWeightRating_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<GrossVehicleWeightRating_Var_Samp_Fields_Vpic>;
  variance?: Maybe<GrossVehicleWeightRating_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.grossvehicleweightrating" */
export type GrossVehicleWeightRating_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<GrossVehicleWeightRating_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.grossvehicleweightrating" */
export type GrossVehicleWeightRating_Aggregate_Vpic = {
  __typename?: 'GrossVehicleWeightRating_aggregate_vpic';
  aggregate?: Maybe<GrossVehicleWeightRating_Aggregate_Fields_Vpic>;
  nodes: Array<GrossVehicleWeightRating_Vpic>;
};

/** aggregate avg on columns */
export type GrossVehicleWeightRating_Avg_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxRangeWeight?: Maybe<Scalars['Float']>;
  MinRangeWeight?: Maybe<Scalars['Float']>;
  SortOrder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.grossvehicleweightrating". All fields are combined with a logical 'AND'. */
export type GrossVehicleWeightRating_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  MaxRangeWeight?: InputMaybe<Int_Comparison_Exp>;
  MinRangeWeight?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  SortOrder?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<GrossVehicleWeightRating_Bool_Exp_Vpic>>;
  _not?: InputMaybe<GrossVehicleWeightRating_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<GrossVehicleWeightRating_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.grossvehicleweightrating" */
export enum GrossVehicleWeightRating_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkGrossvehicleweightrating = 'pk_grossvehicleweightrating',
  /** unique or primary key constraint on columns "name" */
  UGvwrname = 'u_gvwrname'
}

/** input type for incrementing numeric columns in table "vpic.grossvehicleweightrating" */
export type GrossVehicleWeightRating_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MaxRangeWeight?: InputMaybe<Scalars['Int']>;
  MinRangeWeight?: InputMaybe<Scalars['Int']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.grossvehicleweightrating" */
export type GrossVehicleWeightRating_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MaxRangeWeight?: InputMaybe<Scalars['Int']>;
  MinRangeWeight?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type GrossVehicleWeightRating_Max_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MaxRangeWeight?: Maybe<Scalars['Int']>;
  MinRangeWeight?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  SortOrder?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type GrossVehicleWeightRating_Min_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MaxRangeWeight?: Maybe<Scalars['Int']>;
  MinRangeWeight?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  SortOrder?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vpic.grossvehicleweightrating" */
export type GrossVehicleWeightRating_Mutation_Response_Vpic = {
  __typename?: 'GrossVehicleWeightRating_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GrossVehicleWeightRating_Vpic>;
};

/** on_conflict condition type for table "vpic.grossvehicleweightrating" */
export type GrossVehicleWeightRating_On_Conflict_Vpic = {
  constraint: GrossVehicleWeightRating_Constraint_Vpic;
  update_columns?: Array<GrossVehicleWeightRating_Update_Column_Vpic>;
  where?: InputMaybe<GrossVehicleWeightRating_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.grossvehicleweightrating". */
export type GrossVehicleWeightRating_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MaxRangeWeight?: InputMaybe<Order_By>;
  MinRangeWeight?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  SortOrder?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.grossvehicleweightrating */
export type GrossVehicleWeightRating_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.grossvehicleweightrating" */
export enum GrossVehicleWeightRating_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  MaxRangeWeight = 'MaxRangeWeight',
  /** column name */
  MinRangeWeight = 'MinRangeWeight',
  /** column name */
  Name = 'Name',
  /** column name */
  SortOrder = 'SortOrder'
}

/** input type for updating data in table "vpic.grossvehicleweightrating" */
export type GrossVehicleWeightRating_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MaxRangeWeight?: InputMaybe<Scalars['Int']>;
  MinRangeWeight?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type GrossVehicleWeightRating_Stddev_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxRangeWeight?: Maybe<Scalars['Float']>;
  MinRangeWeight?: Maybe<Scalars['Float']>;
  SortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type GrossVehicleWeightRating_Stddev_Pop_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxRangeWeight?: Maybe<Scalars['Float']>;
  MinRangeWeight?: Maybe<Scalars['Float']>;
  SortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type GrossVehicleWeightRating_Stddev_Samp_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxRangeWeight?: Maybe<Scalars['Float']>;
  MinRangeWeight?: Maybe<Scalars['Float']>;
  SortOrder?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "GrossVehicleWeightRating" */
export type GrossVehicleWeightRating_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: GrossVehicleWeightRating_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type GrossVehicleWeightRating_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MaxRangeWeight?: InputMaybe<Scalars['Int']>;
  MinRangeWeight?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type GrossVehicleWeightRating_Sum_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MaxRangeWeight?: Maybe<Scalars['Int']>;
  MinRangeWeight?: Maybe<Scalars['Int']>;
  SortOrder?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.grossvehicleweightrating" */
export enum GrossVehicleWeightRating_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  MaxRangeWeight = 'MaxRangeWeight',
  /** column name */
  MinRangeWeight = 'MinRangeWeight',
  /** column name */
  Name = 'Name',
  /** column name */
  SortOrder = 'SortOrder'
}

export type GrossVehicleWeightRating_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GrossVehicleWeightRating_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GrossVehicleWeightRating_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: GrossVehicleWeightRating_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type GrossVehicleWeightRating_Var_Pop_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxRangeWeight?: Maybe<Scalars['Float']>;
  MinRangeWeight?: Maybe<Scalars['Float']>;
  SortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type GrossVehicleWeightRating_Var_Samp_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxRangeWeight?: Maybe<Scalars['Float']>;
  MinRangeWeight?: Maybe<Scalars['Float']>;
  SortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type GrossVehicleWeightRating_Variance_Fields_Vpic = {
  __typename?: 'GrossVehicleWeightRating_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MaxRangeWeight?: Maybe<Scalars['Float']>;
  MinRangeWeight?: Maybe<Scalars['Float']>;
  SortOrder?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.grossvehicleweightrating" */
export type GrossVehicleWeightRating_Vpic = {
  __typename?: 'GrossVehicleWeightRating_vpic';
  Id: Scalars['Int'];
  MaxRangeWeight?: Maybe<Scalars['Int']>;
  MinRangeWeight?: Maybe<Scalars['Int']>;
  Name: Scalars['String'];
  SortOrder?: Maybe<Scalars['Int']>;
};

export type InsertType = {
  __typename?: 'InsertType';
  id: Scalars['uuid'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['Int']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Int']>>;
  _eq?: InputMaybe<Array<Scalars['Int']>>;
  _gt?: InputMaybe<Array<Scalars['Int']>>;
  _gte?: InputMaybe<Array<Scalars['Int']>>;
  _in?: InputMaybe<Array<Array<Scalars['Int']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['Int']>>;
  _lte?: InputMaybe<Array<Scalars['Int']>>;
  _neq?: InputMaybe<Array<Scalars['Int']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Int']>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type JobScheduleMetadata = {
  __typename?: 'JobScheduleMetadata';
  cron?: Maybe<JobScheduleMetadata_Cron>;
  exclusions?: Maybe<Array<Maybe<Scalars['String']>>>;
  inclusions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type JobScheduleMetadata_Cron = {
  __typename?: 'JobScheduleMetadata_Cron';
  expression: Scalars['String'];
  timeZone: Scalars['String'];
};

/** aggregate fields of "vpic.keylessignition" */
export type KeylessIgnition_Aggregate_Fields_Vpic = {
  __typename?: 'KeylessIgnition_aggregate_fields_vpic';
  avg?: Maybe<KeylessIgnition_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<KeylessIgnition_Max_Fields_Vpic>;
  min?: Maybe<KeylessIgnition_Min_Fields_Vpic>;
  stddev?: Maybe<KeylessIgnition_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<KeylessIgnition_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<KeylessIgnition_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<KeylessIgnition_Sum_Fields_Vpic>;
  var_pop?: Maybe<KeylessIgnition_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<KeylessIgnition_Var_Samp_Fields_Vpic>;
  variance?: Maybe<KeylessIgnition_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.keylessignition" */
export type KeylessIgnition_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<KeylessIgnition_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.keylessignition" */
export type KeylessIgnition_Aggregate_Vpic = {
  __typename?: 'KeylessIgnition_aggregate_vpic';
  aggregate?: Maybe<KeylessIgnition_Aggregate_Fields_Vpic>;
  nodes: Array<KeylessIgnition_Vpic>;
};

/** aggregate avg on columns */
export type KeylessIgnition_Avg_Fields_Vpic = {
  __typename?: 'KeylessIgnition_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.keylessignition". All fields are combined with a logical 'AND'. */
export type KeylessIgnition_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<KeylessIgnition_Bool_Exp_Vpic>>;
  _not?: InputMaybe<KeylessIgnition_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<KeylessIgnition_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.keylessignition" */
export enum KeylessIgnition_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkKeylessi_3214ec0729e1cccb = 'pk__keylessi__3214ec0729e1cccb'
}

/** input type for incrementing numeric columns in table "vpic.keylessignition" */
export type KeylessIgnition_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.keylessignition" */
export type KeylessIgnition_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type KeylessIgnition_Max_Fields_Vpic = {
  __typename?: 'KeylessIgnition_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type KeylessIgnition_Min_Fields_Vpic = {
  __typename?: 'KeylessIgnition_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.keylessignition" */
export type KeylessIgnition_Mutation_Response_Vpic = {
  __typename?: 'KeylessIgnition_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<KeylessIgnition_Vpic>;
};

/** on_conflict condition type for table "vpic.keylessignition" */
export type KeylessIgnition_On_Conflict_Vpic = {
  constraint: KeylessIgnition_Constraint_Vpic;
  update_columns?: Array<KeylessIgnition_Update_Column_Vpic>;
  where?: InputMaybe<KeylessIgnition_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.keylessignition". */
export type KeylessIgnition_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.keylessignition */
export type KeylessIgnition_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.keylessignition" */
export enum KeylessIgnition_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.keylessignition" */
export type KeylessIgnition_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type KeylessIgnition_Stddev_Fields_Vpic = {
  __typename?: 'KeylessIgnition_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type KeylessIgnition_Stddev_Pop_Fields_Vpic = {
  __typename?: 'KeylessIgnition_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type KeylessIgnition_Stddev_Samp_Fields_Vpic = {
  __typename?: 'KeylessIgnition_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "KeylessIgnition" */
export type KeylessIgnition_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: KeylessIgnition_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type KeylessIgnition_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type KeylessIgnition_Sum_Fields_Vpic = {
  __typename?: 'KeylessIgnition_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.keylessignition" */
export enum KeylessIgnition_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type KeylessIgnition_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<KeylessIgnition_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<KeylessIgnition_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: KeylessIgnition_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type KeylessIgnition_Var_Pop_Fields_Vpic = {
  __typename?: 'KeylessIgnition_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type KeylessIgnition_Var_Samp_Fields_Vpic = {
  __typename?: 'KeylessIgnition_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type KeylessIgnition_Variance_Fields_Vpic = {
  __typename?: 'KeylessIgnition_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.keylessignition" */
export type KeylessIgnition_Vpic = {
  __typename?: 'KeylessIgnition_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type LaborGuide_Metadata = {
  __typename?: 'LaborGuide_Metadata';
  isRetired: Scalars['Boolean'];
};

/** aggregate fields of "vpic.lanecenteringassistance" */
export type LaneCenteringAssistance_Aggregate_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_aggregate_fields_vpic';
  avg?: Maybe<LaneCenteringAssistance_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<LaneCenteringAssistance_Max_Fields_Vpic>;
  min?: Maybe<LaneCenteringAssistance_Min_Fields_Vpic>;
  stddev?: Maybe<LaneCenteringAssistance_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<LaneCenteringAssistance_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<LaneCenteringAssistance_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<LaneCenteringAssistance_Sum_Fields_Vpic>;
  var_pop?: Maybe<LaneCenteringAssistance_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<LaneCenteringAssistance_Var_Samp_Fields_Vpic>;
  variance?: Maybe<LaneCenteringAssistance_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.lanecenteringassistance" */
export type LaneCenteringAssistance_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<LaneCenteringAssistance_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.lanecenteringassistance" */
export type LaneCenteringAssistance_Aggregate_Vpic = {
  __typename?: 'LaneCenteringAssistance_aggregate_vpic';
  aggregate?: Maybe<LaneCenteringAssistance_Aggregate_Fields_Vpic>;
  nodes: Array<LaneCenteringAssistance_Vpic>;
};

/** aggregate avg on columns */
export type LaneCenteringAssistance_Avg_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.lanecenteringassistance". All fields are combined with a logical 'AND'. */
export type LaneCenteringAssistance_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<LaneCenteringAssistance_Bool_Exp_Vpic>>;
  _not?: InputMaybe<LaneCenteringAssistance_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<LaneCenteringAssistance_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.lanecenteringassistance" */
export enum LaneCenteringAssistance_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkLanecenteringassistance = 'pk_lanecenteringassistance',
  /** unique or primary key constraint on columns "name" */
  ULanecenteringassistance = 'u_lanecenteringassistance'
}

/** input type for incrementing numeric columns in table "vpic.lanecenteringassistance" */
export type LaneCenteringAssistance_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.lanecenteringassistance" */
export type LaneCenteringAssistance_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LaneCenteringAssistance_Max_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LaneCenteringAssistance_Min_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.lanecenteringassistance" */
export type LaneCenteringAssistance_Mutation_Response_Vpic = {
  __typename?: 'LaneCenteringAssistance_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LaneCenteringAssistance_Vpic>;
};

/** on_conflict condition type for table "vpic.lanecenteringassistance" */
export type LaneCenteringAssistance_On_Conflict_Vpic = {
  constraint: LaneCenteringAssistance_Constraint_Vpic;
  update_columns?: Array<LaneCenteringAssistance_Update_Column_Vpic>;
  where?: InputMaybe<LaneCenteringAssistance_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.lanecenteringassistance". */
export type LaneCenteringAssistance_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.lanecenteringassistance */
export type LaneCenteringAssistance_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.lanecenteringassistance" */
export enum LaneCenteringAssistance_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.lanecenteringassistance" */
export type LaneCenteringAssistance_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type LaneCenteringAssistance_Stddev_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LaneCenteringAssistance_Stddev_Pop_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LaneCenteringAssistance_Stddev_Samp_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "LaneCenteringAssistance" */
export type LaneCenteringAssistance_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: LaneCenteringAssistance_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type LaneCenteringAssistance_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type LaneCenteringAssistance_Sum_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.lanecenteringassistance" */
export enum LaneCenteringAssistance_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type LaneCenteringAssistance_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LaneCenteringAssistance_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LaneCenteringAssistance_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: LaneCenteringAssistance_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type LaneCenteringAssistance_Var_Pop_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LaneCenteringAssistance_Var_Samp_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LaneCenteringAssistance_Variance_Fields_Vpic = {
  __typename?: 'LaneCenteringAssistance_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.lanecenteringassistance" */
export type LaneCenteringAssistance_Vpic = {
  __typename?: 'LaneCenteringAssistance_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.lanedeparturewarning" */
export type LaneDepartureWarning_Aggregate_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_aggregate_fields_vpic';
  avg?: Maybe<LaneDepartureWarning_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<LaneDepartureWarning_Max_Fields_Vpic>;
  min?: Maybe<LaneDepartureWarning_Min_Fields_Vpic>;
  stddev?: Maybe<LaneDepartureWarning_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<LaneDepartureWarning_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<LaneDepartureWarning_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<LaneDepartureWarning_Sum_Fields_Vpic>;
  var_pop?: Maybe<LaneDepartureWarning_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<LaneDepartureWarning_Var_Samp_Fields_Vpic>;
  variance?: Maybe<LaneDepartureWarning_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.lanedeparturewarning" */
export type LaneDepartureWarning_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<LaneDepartureWarning_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.lanedeparturewarning" */
export type LaneDepartureWarning_Aggregate_Vpic = {
  __typename?: 'LaneDepartureWarning_aggregate_vpic';
  aggregate?: Maybe<LaneDepartureWarning_Aggregate_Fields_Vpic>;
  nodes: Array<LaneDepartureWarning_Vpic>;
};

/** aggregate avg on columns */
export type LaneDepartureWarning_Avg_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.lanedeparturewarning". All fields are combined with a logical 'AND'. */
export type LaneDepartureWarning_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<LaneDepartureWarning_Bool_Exp_Vpic>>;
  _not?: InputMaybe<LaneDepartureWarning_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<LaneDepartureWarning_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.lanedeparturewarning" */
export enum LaneDepartureWarning_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkLanedeparturewarning = 'pk_lanedeparturewarning',
  /** unique or primary key constraint on columns "name" */
  ULanedeparturewarningname = 'u_lanedeparturewarningname'
}

/** input type for incrementing numeric columns in table "vpic.lanedeparturewarning" */
export type LaneDepartureWarning_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.lanedeparturewarning" */
export type LaneDepartureWarning_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LaneDepartureWarning_Max_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LaneDepartureWarning_Min_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.lanedeparturewarning" */
export type LaneDepartureWarning_Mutation_Response_Vpic = {
  __typename?: 'LaneDepartureWarning_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LaneDepartureWarning_Vpic>;
};

/** on_conflict condition type for table "vpic.lanedeparturewarning" */
export type LaneDepartureWarning_On_Conflict_Vpic = {
  constraint: LaneDepartureWarning_Constraint_Vpic;
  update_columns?: Array<LaneDepartureWarning_Update_Column_Vpic>;
  where?: InputMaybe<LaneDepartureWarning_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.lanedeparturewarning". */
export type LaneDepartureWarning_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.lanedeparturewarning */
export type LaneDepartureWarning_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.lanedeparturewarning" */
export enum LaneDepartureWarning_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.lanedeparturewarning" */
export type LaneDepartureWarning_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type LaneDepartureWarning_Stddev_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LaneDepartureWarning_Stddev_Pop_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LaneDepartureWarning_Stddev_Samp_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "LaneDepartureWarning" */
export type LaneDepartureWarning_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: LaneDepartureWarning_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type LaneDepartureWarning_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type LaneDepartureWarning_Sum_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.lanedeparturewarning" */
export enum LaneDepartureWarning_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type LaneDepartureWarning_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LaneDepartureWarning_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LaneDepartureWarning_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: LaneDepartureWarning_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type LaneDepartureWarning_Var_Pop_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LaneDepartureWarning_Var_Samp_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LaneDepartureWarning_Variance_Fields_Vpic = {
  __typename?: 'LaneDepartureWarning_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.lanedeparturewarning" */
export type LaneDepartureWarning_Vpic = {
  __typename?: 'LaneDepartureWarning_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.lanekeepsystem" */
export type LaneKeepSystem_Aggregate_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_aggregate_fields_vpic';
  avg?: Maybe<LaneKeepSystem_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<LaneKeepSystem_Max_Fields_Vpic>;
  min?: Maybe<LaneKeepSystem_Min_Fields_Vpic>;
  stddev?: Maybe<LaneKeepSystem_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<LaneKeepSystem_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<LaneKeepSystem_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<LaneKeepSystem_Sum_Fields_Vpic>;
  var_pop?: Maybe<LaneKeepSystem_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<LaneKeepSystem_Var_Samp_Fields_Vpic>;
  variance?: Maybe<LaneKeepSystem_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.lanekeepsystem" */
export type LaneKeepSystem_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<LaneKeepSystem_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.lanekeepsystem" */
export type LaneKeepSystem_Aggregate_Vpic = {
  __typename?: 'LaneKeepSystem_aggregate_vpic';
  aggregate?: Maybe<LaneKeepSystem_Aggregate_Fields_Vpic>;
  nodes: Array<LaneKeepSystem_Vpic>;
};

/** aggregate avg on columns */
export type LaneKeepSystem_Avg_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.lanekeepsystem". All fields are combined with a logical 'AND'. */
export type LaneKeepSystem_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<LaneKeepSystem_Bool_Exp_Vpic>>;
  _not?: InputMaybe<LaneKeepSystem_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<LaneKeepSystem_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.lanekeepsystem" */
export enum LaneKeepSystem_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkLanekeepsystem = 'pk_lanekeepsystem',
  /** unique or primary key constraint on columns "name" */
  ULanekeepsystemname = 'u_lanekeepsystemname'
}

/** input type for incrementing numeric columns in table "vpic.lanekeepsystem" */
export type LaneKeepSystem_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.lanekeepsystem" */
export type LaneKeepSystem_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LaneKeepSystem_Max_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LaneKeepSystem_Min_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.lanekeepsystem" */
export type LaneKeepSystem_Mutation_Response_Vpic = {
  __typename?: 'LaneKeepSystem_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LaneKeepSystem_Vpic>;
};

/** on_conflict condition type for table "vpic.lanekeepsystem" */
export type LaneKeepSystem_On_Conflict_Vpic = {
  constraint: LaneKeepSystem_Constraint_Vpic;
  update_columns?: Array<LaneKeepSystem_Update_Column_Vpic>;
  where?: InputMaybe<LaneKeepSystem_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.lanekeepsystem". */
export type LaneKeepSystem_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.lanekeepsystem */
export type LaneKeepSystem_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.lanekeepsystem" */
export enum LaneKeepSystem_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.lanekeepsystem" */
export type LaneKeepSystem_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type LaneKeepSystem_Stddev_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LaneKeepSystem_Stddev_Pop_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LaneKeepSystem_Stddev_Samp_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "LaneKeepSystem" */
export type LaneKeepSystem_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: LaneKeepSystem_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type LaneKeepSystem_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type LaneKeepSystem_Sum_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.lanekeepsystem" */
export enum LaneKeepSystem_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type LaneKeepSystem_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LaneKeepSystem_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LaneKeepSystem_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: LaneKeepSystem_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type LaneKeepSystem_Var_Pop_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LaneKeepSystem_Var_Samp_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LaneKeepSystem_Variance_Fields_Vpic = {
  __typename?: 'LaneKeepSystem_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.lanekeepsystem" */
export type LaneKeepSystem_Vpic = {
  __typename?: 'LaneKeepSystem_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Lease_Amortization_Schedule_V1 = {
  __typename?: 'Lease_Amortization_Schedule_v1';
  amortizationScheduleItems: Array<Amortization_Schedule_Item_V1>;
  calculationMethod: Scalars['String'];
  failureDate: Scalars['String'];
  financeAmount: Scalars['numeric'];
  firstPaymentDate: Scalars['String'];
  interestRate: Scalars['numeric'];
  loanTerm: Scalars['numeric'];
  lossDatePayoff: Scalars['numeric'];
  policyContractLoanContractTypeId: Scalars['String'];
  residualValue: Scalars['numeric'];
};

export type LegacyPolicyContract_AccountManagerMetadata = {
  __typename?: 'LegacyPolicyContract_AccountManagerMetadata';
  accountManagerCode?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LegacyPolicyContract_AccountMetadata = {
  __typename?: 'LegacyPolicyContract_AccountMetadata';
  accountCode?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LegacyPolicyContract_AssetMetadata = {
  __typename?: 'LegacyPolicyContract_AssetMetadata';
  cubicCentimeters?: Maybe<Scalars['Int']>;
  cylindersNumber?: Maybe<Scalars['Int']>;
  drivingWheelsCode?: Maybe<Scalars['String']>;
  endServiceDate?: Maybe<Scalars['String']>;
  fuelTypeDescription?: Maybe<Scalars['String']>;
  hasSupercharger?: Maybe<Scalars['Boolean']>;
  hasTurbo?: Maybe<Scalars['Boolean']>;
  isDiesel?: Maybe<Scalars['Boolean']>;
  isElectric?: Maybe<Scalars['Boolean']>;
  isFourWheelDrive?: Maybe<Scalars['Boolean']>;
  isGas?: Maybe<Scalars['Boolean']>;
  isHybrid?: Maybe<Scalars['Boolean']>;
  makeCode?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['Int']>;
  modelCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  vehicleClassCode?: Maybe<Scalars['String']>;
  vehiclePurchasePrice?: Maybe<Scalars['numeric']>;
  vehicleYear?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
};

export type LegacyPolicyContract_BucketMetadata = {
  __typename?: 'LegacyPolicyContract_BucketMetadata';
  rateBucketTypeName?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['numeric']>;
};

export type LegacyPolicyContract_CostDetailMetadata = {
  __typename?: 'LegacyPolicyContract_CostDetailMetadata';
  bucketMetadata?: Maybe<Array<Maybe<LegacyPolicyContract_BucketMetadata>>>;
  customerCost?: Maybe<Scalars['numeric']>;
  dealerCost?: Maybe<Scalars['numeric']>;
  dealerRemitAmount?: Maybe<Scalars['numeric']>;
  disbursementMetadata?: Maybe<Array<Maybe<LegacyPolicyContract_DisbursementMetadata>>>;
  remittanceCostMarkupAmount?: Maybe<Scalars['numeric']>;
  remittanceOverrideAmount?: Maybe<Scalars['numeric']>;
  retailAmount?: Maybe<Scalars['numeric']>;
};

export type LegacyPolicyContract_DisbursementMetadata = {
  __typename?: 'LegacyPolicyContract_DisbursementMetadata';
  amount?: Maybe<Scalars['numeric']>;
  code?: Maybe<Scalars['String']>;
  disbursementTypeName?: Maybe<Scalars['String']>;
};

export type LegacyPolicyContract_LenderMetadata = {
  __typename?: 'LegacyPolicyContract_LenderMetadata';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  financeAmount?: Maybe<Scalars['numeric']>;
  loanTerm?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type LegacyPolicyContract_NoteMetadata = {
  __typename?: 'LegacyPolicyContract_NoteMetadata';
  EnteredDate: Scalars['String'];
  NoteTypeName: Scalars['String'];
  Text: Scalars['String'];
  Username: Scalars['String'];
  createUser: Scalars['String'];
};

export type LegacyPolicyContract_OwnerMetadata = {
  __typename?: 'LegacyPolicyContract_OwnerMetadata';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  homePhoneNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type LegacyPolicyContract_ProductMetadata = {
  __typename?: 'LegacyPolicyContract_ProductMetadata';
  actualContractFormName?: Maybe<Scalars['String']>;
  coverageDisplayType?: Maybe<Scalars['numeric']>;
  coverageMiles?: Maybe<Scalars['Int']>;
  coverageMonths?: Maybe<Scalars['Int']>;
  coverageTypeCode?: Maybe<Scalars['String']>;
  deductibleAmount?: Maybe<Scalars['numeric']>;
  formCode?: Maybe<Scalars['String']>;
  includesCosmeticCoverageOption?: Maybe<Scalars['Boolean']>;
  includesDentCoverageOption?: Maybe<Scalars['Boolean']>;
  includesKeyCoverageOption?: Maybe<Scalars['Boolean']>;
  includesSafeLinkTheftOption?: Maybe<Scalars['Boolean']>;
  includesTireCoverageOption?: Maybe<Scalars['Boolean']>;
  includesWindshieldCoverageOption?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  planCode?: Maybe<Scalars['String']>;
};

export type LegacyPolicyContract_StatusMetadata = {
  __typename?: 'LegacyPolicyContract_StatusMetadata';
  code?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

export type LegacyPolicyContract_SurchargeMetadata = {
  __typename?: 'LegacyPolicyContract_SurchargeMetadata';
  amount?: Maybe<Scalars['numeric']>;
  surchargeCode?: Maybe<Scalars['String']>;
};

/** aggregate fields of "vpic.lowerbeamheadlamplightsource" */
export type LowerBeamHeadlampLightSource_Aggregate_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_aggregate_fields_vpic';
  avg?: Maybe<LowerBeamHeadlampLightSource_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<LowerBeamHeadlampLightSource_Max_Fields_Vpic>;
  min?: Maybe<LowerBeamHeadlampLightSource_Min_Fields_Vpic>;
  stddev?: Maybe<LowerBeamHeadlampLightSource_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<LowerBeamHeadlampLightSource_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<LowerBeamHeadlampLightSource_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<LowerBeamHeadlampLightSource_Sum_Fields_Vpic>;
  var_pop?: Maybe<LowerBeamHeadlampLightSource_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<LowerBeamHeadlampLightSource_Var_Samp_Fields_Vpic>;
  variance?: Maybe<LowerBeamHeadlampLightSource_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.lowerbeamheadlamplightsource" */
export type LowerBeamHeadlampLightSource_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<LowerBeamHeadlampLightSource_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.lowerbeamheadlamplightsource" */
export type LowerBeamHeadlampLightSource_Aggregate_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_aggregate_vpic';
  aggregate?: Maybe<LowerBeamHeadlampLightSource_Aggregate_Fields_Vpic>;
  nodes: Array<LowerBeamHeadlampLightSource_Vpic>;
};

/** aggregate avg on columns */
export type LowerBeamHeadlampLightSource_Avg_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.lowerbeamheadlamplightsource". All fields are combined with a logical 'AND'. */
export type LowerBeamHeadlampLightSource_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<LowerBeamHeadlampLightSource_Bool_Exp_Vpic>>;
  _not?: InputMaybe<LowerBeamHeadlampLightSource_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<LowerBeamHeadlampLightSource_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.lowerbeamheadlamplightsource" */
export enum LowerBeamHeadlampLightSource_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkLowerbea_3214ec077a78c7a5 = 'pk__lowerbea__3214ec077a78c7a5'
}

/** input type for incrementing numeric columns in table "vpic.lowerbeamheadlamplightsource" */
export type LowerBeamHeadlampLightSource_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.lowerbeamheadlamplightsource" */
export type LowerBeamHeadlampLightSource_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LowerBeamHeadlampLightSource_Max_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type LowerBeamHeadlampLightSource_Min_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.lowerbeamheadlamplightsource" */
export type LowerBeamHeadlampLightSource_Mutation_Response_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LowerBeamHeadlampLightSource_Vpic>;
};

/** on_conflict condition type for table "vpic.lowerbeamheadlamplightsource" */
export type LowerBeamHeadlampLightSource_On_Conflict_Vpic = {
  constraint: LowerBeamHeadlampLightSource_Constraint_Vpic;
  update_columns?: Array<LowerBeamHeadlampLightSource_Update_Column_Vpic>;
  where?: InputMaybe<LowerBeamHeadlampLightSource_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.lowerbeamheadlamplightsource". */
export type LowerBeamHeadlampLightSource_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.lowerbeamheadlamplightsource */
export type LowerBeamHeadlampLightSource_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.lowerbeamheadlamplightsource" */
export enum LowerBeamHeadlampLightSource_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.lowerbeamheadlamplightsource" */
export type LowerBeamHeadlampLightSource_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type LowerBeamHeadlampLightSource_Stddev_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LowerBeamHeadlampLightSource_Stddev_Pop_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LowerBeamHeadlampLightSource_Stddev_Samp_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "LowerBeamHeadlampLightSource" */
export type LowerBeamHeadlampLightSource_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: LowerBeamHeadlampLightSource_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type LowerBeamHeadlampLightSource_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type LowerBeamHeadlampLightSource_Sum_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.lowerbeamheadlamplightsource" */
export enum LowerBeamHeadlampLightSource_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type LowerBeamHeadlampLightSource_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LowerBeamHeadlampLightSource_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LowerBeamHeadlampLightSource_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: LowerBeamHeadlampLightSource_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type LowerBeamHeadlampLightSource_Var_Pop_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LowerBeamHeadlampLightSource_Var_Samp_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LowerBeamHeadlampLightSource_Variance_Fields_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.lowerbeamheadlamplightsource" */
export type LowerBeamHeadlampLightSource_Vpic = {
  __typename?: 'LowerBeamHeadlampLightSource_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Make_Model_Aggregate_Bool_Exp = {
  count?: InputMaybe<Make_Model_Aggregate_Bool_Exp_Count>;
};

export type Make_Model_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Make_Model_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vpic.make_model" */
export type Make_Model_Aggregate_Fields_Vpic = {
  __typename?: 'Make_Model_aggregate_fields_vpic';
  avg?: Maybe<Make_Model_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Make_Model_Max_Fields_Vpic>;
  min?: Maybe<Make_Model_Min_Fields_Vpic>;
  stddev?: Maybe<Make_Model_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Make_Model_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Make_Model_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Make_Model_Sum_Fields_Vpic>;
  var_pop?: Maybe<Make_Model_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Make_Model_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Make_Model_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.make_model" */
export type Make_Model_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Make_Model_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vpic.make_model" */
export type Make_Model_Aggregate_Order_By_Vpic = {
  avg?: InputMaybe<Make_Model_Avg_Order_By_Vpic>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Make_Model_Max_Order_By_Vpic>;
  min?: InputMaybe<Make_Model_Min_Order_By_Vpic>;
  stddev?: InputMaybe<Make_Model_Stddev_Order_By_Vpic>;
  stddev_pop?: InputMaybe<Make_Model_Stddev_Pop_Order_By_Vpic>;
  stddev_samp?: InputMaybe<Make_Model_Stddev_Samp_Order_By_Vpic>;
  sum?: InputMaybe<Make_Model_Sum_Order_By_Vpic>;
  var_pop?: InputMaybe<Make_Model_Var_Pop_Order_By_Vpic>;
  var_samp?: InputMaybe<Make_Model_Var_Samp_Order_By_Vpic>;
  variance?: InputMaybe<Make_Model_Variance_Order_By_Vpic>;
};

/** aggregated selection of "vpic.make_model" */
export type Make_Model_Aggregate_Vpic = {
  __typename?: 'Make_Model_aggregate_vpic';
  aggregate?: Maybe<Make_Model_Aggregate_Fields_Vpic>;
  nodes: Array<Make_Model_Vpic>;
};

/** input type for inserting array relation for remote table "vpic.make_model" */
export type Make_Model_Arr_Rel_Insert_Input_Vpic = {
  data: Array<Make_Model_Insert_Input_Vpic>;
  /** upsert condition */
  on_conflict?: InputMaybe<Make_Model_On_Conflict_Vpic>;
};

/** aggregate avg on columns */
export type Make_Model_Avg_Fields_Vpic = {
  __typename?: 'Make_Model_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vpic.make_model" */
export type Make_Model_Avg_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vpic.make_model". All fields are combined with a logical 'AND'. */
export type Make_Model_Bool_Exp_Vpic = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  Make?: InputMaybe<Make_Bool_Exp_Vpic>;
  MakeId?: InputMaybe<Int_Comparison_Exp>;
  Model?: InputMaybe<Model_Bool_Exp_Vpic>;
  ModelId?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Make_Model_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Make_Model_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.make_model" */
export enum Make_Model_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkMakeModel = 'pk_make_model'
}

/** input type for incrementing numeric columns in table "vpic.make_model" */
export type Make_Model_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  ModelId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.make_model" */
export type Make_Model_Insert_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  Make?: InputMaybe<Make_Obj_Rel_Insert_Input_Vpic>;
  MakeId?: InputMaybe<Scalars['Int']>;
  Model?: InputMaybe<Model_Obj_Rel_Insert_Input_Vpic>;
  ModelId?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Make_Model_Max_Fields_Vpic = {
  __typename?: 'Make_Model_max_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  ModelId?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "vpic.make_model" */
export type Make_Model_Max_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Make_Model_Min_Fields_Vpic = {
  __typename?: 'Make_Model_min_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  ModelId?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "vpic.make_model" */
export type Make_Model_Min_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vpic.make_model" */
export type Make_Model_Mutation_Response_Vpic = {
  __typename?: 'Make_Model_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Make_Model_Vpic>;
};

/** on_conflict condition type for table "vpic.make_model" */
export type Make_Model_On_Conflict_Vpic = {
  constraint: Make_Model_Constraint_Vpic;
  update_columns?: Array<Make_Model_Update_Column_Vpic>;
  where?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.make_model". */
export type Make_Model_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Make?: InputMaybe<Make_Order_By_Vpic>;
  MakeId?: InputMaybe<Order_By>;
  Model?: InputMaybe<Model_Order_By_Vpic>;
  ModelId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.make_model */
export type Make_Model_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.make_model" */
export enum Make_Model_Select_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  ModelId = 'ModelId',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "vpic.make_model" */
export type Make_Model_Set_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  ModelId?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Make_Model_Stddev_Fields_Vpic = {
  __typename?: 'Make_Model_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vpic.make_model" */
export type Make_Model_Stddev_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Make_Model_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Make_Model_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vpic.make_model" */
export type Make_Model_Stddev_Pop_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Make_Model_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Make_Model_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vpic.make_model" */
export type Make_Model_Stddev_Samp_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Make_Model" */
export type Make_Model_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Make_Model_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Make_Model_Stream_Cursor_Value_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  ModelId?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Make_Model_Sum_Fields_Vpic = {
  __typename?: 'Make_Model_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  ModelId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vpic.make_model" */
export type Make_Model_Sum_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
};

/** update columns of table "vpic.make_model" */
export enum Make_Model_Update_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  ModelId = 'ModelId',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Make_Model_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Make_Model_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Make_Model_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Make_Model_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Make_Model_Var_Pop_Fields_Vpic = {
  __typename?: 'Make_Model_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vpic.make_model" */
export type Make_Model_Var_Pop_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Make_Model_Var_Samp_Fields_Vpic = {
  __typename?: 'Make_Model_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vpic.make_model" */
export type Make_Model_Var_Samp_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Make_Model_Variance_Fields_Vpic = {
  __typename?: 'Make_Model_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vpic.make_model" */
export type Make_Model_Variance_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
};

/** columns and relationships of "vpic.make_model" */
export type Make_Model_Vpic = {
  __typename?: 'Make_Model_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id: Scalars['Int'];
  /** An object relationship */
  Make?: Maybe<Make_Vpic>;
  MakeId: Scalars['Int'];
  /** An object relationship */
  Model?: Maybe<Model_Vpic>;
  ModelId: Scalars['Int'];
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate fields of "vpic.make" */
export type Make_Aggregate_Fields_Vpic = {
  __typename?: 'Make_aggregate_fields_vpic';
  avg?: Maybe<Make_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Make_Max_Fields_Vpic>;
  min?: Maybe<Make_Min_Fields_Vpic>;
  stddev?: Maybe<Make_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Make_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Make_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Make_Sum_Fields_Vpic>;
  var_pop?: Maybe<Make_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Make_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Make_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.make" */
export type Make_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Make_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.make" */
export type Make_Aggregate_Vpic = {
  __typename?: 'Make_aggregate_vpic';
  aggregate?: Maybe<Make_Aggregate_Fields_Vpic>;
  nodes: Array<Make_Vpic>;
};

/** aggregate avg on columns */
export type Make_Avg_Fields_Vpic = {
  __typename?: 'Make_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.make". All fields are combined with a logical 'AND'. */
export type Make_Bool_Exp_Vpic = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  Make_Models?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
  Make_Models_aggregate?: InputMaybe<Make_Model_Aggregate_Bool_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Wmi_Makes?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
  Wmi_Makes_aggregate?: InputMaybe<Wmi_Make_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Make_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Make_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Make_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.make" */
export enum Make_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkMake = 'pk_make',
  /** unique or primary key constraint on columns "name" */
  UMakename = 'u_makename'
}

/** input type for incrementing numeric columns in table "vpic.make" */
export type Make_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.make" */
export type Make_Insert_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  Make_Models?: InputMaybe<Make_Model_Arr_Rel_Insert_Input_Vpic>;
  Name?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Wmi_Makes?: InputMaybe<Wmi_Make_Arr_Rel_Insert_Input_Vpic>;
};

/** aggregate max on columns */
export type Make_Max_Fields_Vpic = {
  __typename?: 'Make_max_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Make_Min_Fields_Vpic = {
  __typename?: 'Make_min_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "vpic.make" */
export type Make_Mutation_Response_Vpic = {
  __typename?: 'Make_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Make_Vpic>;
};

/** input type for inserting object relation for remote table "vpic.make" */
export type Make_Obj_Rel_Insert_Input_Vpic = {
  data: Make_Insert_Input_Vpic;
  /** upsert condition */
  on_conflict?: InputMaybe<Make_On_Conflict_Vpic>;
};

/** on_conflict condition type for table "vpic.make" */
export type Make_On_Conflict_Vpic = {
  constraint: Make_Constraint_Vpic;
  update_columns?: Array<Make_Update_Column_Vpic>;
  where?: InputMaybe<Make_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.make". */
export type Make_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Make_Models_aggregate?: InputMaybe<Make_Model_Aggregate_Order_By_Vpic>;
  Name?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Wmi_Makes_aggregate?: InputMaybe<Wmi_Make_Aggregate_Order_By_Vpic>;
};

/** primary key columns input for table: vpic.make */
export type Make_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.make" */
export enum Make_Select_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "vpic.make" */
export type Make_Set_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Make_Stddev_Fields_Vpic = {
  __typename?: 'Make_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Make_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Make_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Make_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Make_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Make" */
export type Make_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Make_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Make_Stream_Cursor_Value_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Make_Sum_Fields_Vpic = {
  __typename?: 'Make_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.make" */
export enum Make_Update_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Make_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Make_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Make_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Make_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Make_Var_Pop_Fields_Vpic = {
  __typename?: 'Make_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Make_Var_Samp_Fields_Vpic = {
  __typename?: 'Make_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Make_Variance_Fields_Vpic = {
  __typename?: 'Make_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.make" */
export type Make_Vpic = {
  __typename?: 'Make_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id: Scalars['Int'];
  /** An array relationship */
  Make_Models: Array<Make_Model_Vpic>;
  /** An aggregate relationship */
  Make_Models_aggregate: Make_Model_Aggregate_Vpic;
  Name: Scalars['String'];
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  Wmi_Makes: Array<Wmi_Make_Vpic>;
  /** An aggregate relationship */
  Wmi_Makes_aggregate: Wmi_Make_Aggregate_Vpic;
};


/** columns and relationships of "vpic.make" */
export type Make_VpicMake_ModelsArgs = {
  distinct_on?: InputMaybe<Array<Make_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Model_Order_By_Vpic>>;
  where?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.make" */
export type Make_VpicMake_Models_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Make_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Model_Order_By_Vpic>>;
  where?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.make" */
export type Make_VpicWmi_MakesArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Make_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.make" */
export type Make_VpicWmi_Makes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Make_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
};

/** aggregate fields of "vpic.manufacturer_make" */
export type Manufacturer_Make_Aggregate_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_aggregate_fields_vpic';
  avg?: Maybe<Manufacturer_Make_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Manufacturer_Make_Max_Fields_Vpic>;
  min?: Maybe<Manufacturer_Make_Min_Fields_Vpic>;
  stddev?: Maybe<Manufacturer_Make_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Manufacturer_Make_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Manufacturer_Make_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Manufacturer_Make_Sum_Fields_Vpic>;
  var_pop?: Maybe<Manufacturer_Make_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Manufacturer_Make_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Manufacturer_Make_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.manufacturer_make" */
export type Manufacturer_Make_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Manufacturer_Make_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.manufacturer_make" */
export type Manufacturer_Make_Aggregate_Vpic = {
  __typename?: 'Manufacturer_Make_aggregate_vpic';
  aggregate?: Maybe<Manufacturer_Make_Aggregate_Fields_Vpic>;
  nodes: Array<Manufacturer_Make_Vpic>;
};

/** aggregate avg on columns */
export type Manufacturer_Make_Avg_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.manufacturer_make". All fields are combined with a logical 'AND'. */
export type Manufacturer_Make_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  MakeId?: InputMaybe<Int_Comparison_Exp>;
  ManufacturerId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Manufacturer_Make_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Manufacturer_Make_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Manufacturer_Make_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.manufacturer_make" */
export enum Manufacturer_Make_Constraint_Vpic {
  /** unique or primary key constraint on columns "makeid", "manufacturerid" */
  IxManufacturerMake = 'ix_manufacturer_make',
  /** unique or primary key constraint on columns "id" */
  PkManufacturerMake = 'pk_manufacturer_make'
}

/** input type for incrementing numeric columns in table "vpic.manufacturer_make" */
export type Manufacturer_Make_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  ManufacturerId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.manufacturer_make" */
export type Manufacturer_Make_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  ManufacturerId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Manufacturer_Make_Max_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  ManufacturerId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Manufacturer_Make_Min_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  ManufacturerId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vpic.manufacturer_make" */
export type Manufacturer_Make_Mutation_Response_Vpic = {
  __typename?: 'Manufacturer_Make_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Manufacturer_Make_Vpic>;
};

/** on_conflict condition type for table "vpic.manufacturer_make" */
export type Manufacturer_Make_On_Conflict_Vpic = {
  constraint: Manufacturer_Make_Constraint_Vpic;
  update_columns?: Array<Manufacturer_Make_Update_Column_Vpic>;
  where?: InputMaybe<Manufacturer_Make_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.manufacturer_make". */
export type Manufacturer_Make_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.manufacturer_make */
export type Manufacturer_Make_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.manufacturer_make" */
export enum Manufacturer_Make_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  ManufacturerId = 'ManufacturerId'
}

/** input type for updating data in table "vpic.manufacturer_make" */
export type Manufacturer_Make_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  ManufacturerId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Manufacturer_Make_Stddev_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Manufacturer_Make_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Manufacturer_Make_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Manufacturer_Make" */
export type Manufacturer_Make_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Manufacturer_Make_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Manufacturer_Make_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  ManufacturerId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Manufacturer_Make_Sum_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  ManufacturerId?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.manufacturer_make" */
export enum Manufacturer_Make_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  ManufacturerId = 'ManufacturerId'
}

export type Manufacturer_Make_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Manufacturer_Make_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Manufacturer_Make_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Manufacturer_Make_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Manufacturer_Make_Var_Pop_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Manufacturer_Make_Var_Samp_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Manufacturer_Make_Variance_Fields_Vpic = {
  __typename?: 'Manufacturer_Make_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.manufacturer_make" */
export type Manufacturer_Make_Vpic = {
  __typename?: 'Manufacturer_Make_vpic';
  Id: Scalars['Int'];
  MakeId: Scalars['Int'];
  ManufacturerId: Scalars['Int'];
};

/** aggregate fields of "vpic.manufacturer" */
export type Manufacturer_Aggregate_Fields_Vpic = {
  __typename?: 'Manufacturer_aggregate_fields_vpic';
  avg?: Maybe<Manufacturer_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Manufacturer_Max_Fields_Vpic>;
  min?: Maybe<Manufacturer_Min_Fields_Vpic>;
  stddev?: Maybe<Manufacturer_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Manufacturer_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Manufacturer_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Manufacturer_Sum_Fields_Vpic>;
  var_pop?: Maybe<Manufacturer_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Manufacturer_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Manufacturer_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.manufacturer" */
export type Manufacturer_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Manufacturer_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.manufacturer" */
export type Manufacturer_Aggregate_Vpic = {
  __typename?: 'Manufacturer_aggregate_vpic';
  aggregate?: Maybe<Manufacturer_Aggregate_Fields_Vpic>;
  nodes: Array<Manufacturer_Vpic>;
};

/** aggregate avg on columns */
export type Manufacturer_Avg_Fields_Vpic = {
  __typename?: 'Manufacturer_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.manufacturer". All fields are combined with a logical 'AND'. */
export type Manufacturer_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Wmis?: InputMaybe<Wmi_Bool_Exp_Vpic>;
  Wmis_aggregate?: InputMaybe<Wmi_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Manufacturer_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Manufacturer_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Manufacturer_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.manufacturer" */
export enum Manufacturer_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkManufacturer = 'pk_manufacturer'
}

/** input type for incrementing numeric columns in table "vpic.manufacturer" */
export type Manufacturer_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.manufacturer" */
export type Manufacturer_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  Wmis?: InputMaybe<Wmi_Arr_Rel_Insert_Input_Vpic>;
};

/** aggregate max on columns */
export type Manufacturer_Max_Fields_Vpic = {
  __typename?: 'Manufacturer_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Manufacturer_Min_Fields_Vpic = {
  __typename?: 'Manufacturer_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.manufacturer" */
export type Manufacturer_Mutation_Response_Vpic = {
  __typename?: 'Manufacturer_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Manufacturer_Vpic>;
};

/** input type for inserting object relation for remote table "vpic.manufacturer" */
export type Manufacturer_Obj_Rel_Insert_Input_Vpic = {
  data: Manufacturer_Insert_Input_Vpic;
  /** upsert condition */
  on_conflict?: InputMaybe<Manufacturer_On_Conflict_Vpic>;
};

/** on_conflict condition type for table "vpic.manufacturer" */
export type Manufacturer_On_Conflict_Vpic = {
  constraint: Manufacturer_Constraint_Vpic;
  update_columns?: Array<Manufacturer_Update_Column_Vpic>;
  where?: InputMaybe<Manufacturer_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.manufacturer". */
export type Manufacturer_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Wmis_aggregate?: InputMaybe<Wmi_Aggregate_Order_By_Vpic>;
};

/** primary key columns input for table: vpic.manufacturer */
export type Manufacturer_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.manufacturer" */
export enum Manufacturer_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.manufacturer" */
export type Manufacturer_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Manufacturer_Stddev_Fields_Vpic = {
  __typename?: 'Manufacturer_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Manufacturer_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Manufacturer_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Manufacturer_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Manufacturer_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Manufacturer" */
export type Manufacturer_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Manufacturer_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Manufacturer_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Manufacturer_Sum_Fields_Vpic = {
  __typename?: 'Manufacturer_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.manufacturer" */
export enum Manufacturer_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type Manufacturer_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Manufacturer_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Manufacturer_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Manufacturer_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Manufacturer_Var_Pop_Fields_Vpic = {
  __typename?: 'Manufacturer_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Manufacturer_Var_Samp_Fields_Vpic = {
  __typename?: 'Manufacturer_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Manufacturer_Variance_Fields_Vpic = {
  __typename?: 'Manufacturer_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.manufacturer" */
export type Manufacturer_Vpic = {
  __typename?: 'Manufacturer_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
  /** An array relationship */
  Wmis: Array<Wmi_Vpic>;
  /** An aggregate relationship */
  Wmis_aggregate: Wmi_Aggregate_Vpic;
};


/** columns and relationships of "vpic.manufacturer" */
export type Manufacturer_VpicWmisArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.manufacturer" */
export type Manufacturer_VpicWmis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Bool_Exp_Vpic>;
};

export type Mo_Cancellation_V1 = {
  __typename?: 'Mo_Cancellation_v1';
  cancelAsOfDate: Scalars['date'];
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerAddress1: Scalars['String'];
  customerAddress2: Scalars['String'];
  customerCity: Scalars['String'];
  customerName1: Scalars['String'];
  customerName2?: Maybe<Scalars['String']>;
  customerState: Scalars['String'];
  customerZip: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerCode: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  vin: Scalars['String'];
};

export type Mo_Cancellation_V2 = {
  __typename?: 'Mo_Cancellation_v2';
  cancelAsOfDate: Scalars['date'];
  cancelReason: Scalars['String'];
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerAddress1: Scalars['String'];
  customerAddress2: Scalars['String'];
  customerCity: Scalars['String'];
  customerName1: Scalars['String'];
  customerName2?: Maybe<Scalars['String']>;
  customerState: Scalars['String'];
  customerZip: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerCode: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  mileage: Scalars['numeric'];
  processedDate: Scalars['date'];
  vin: Scalars['String'];
};

/** aggregate fields of "vpic.model" */
export type Model_Aggregate_Fields_Vpic = {
  __typename?: 'Model_aggregate_fields_vpic';
  avg?: Maybe<Model_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Model_Max_Fields_Vpic>;
  min?: Maybe<Model_Min_Fields_Vpic>;
  stddev?: Maybe<Model_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Model_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Model_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Model_Sum_Fields_Vpic>;
  var_pop?: Maybe<Model_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Model_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Model_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.model" */
export type Model_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Model_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.model" */
export type Model_Aggregate_Vpic = {
  __typename?: 'Model_aggregate_vpic';
  aggregate?: Maybe<Model_Aggregate_Fields_Vpic>;
  nodes: Array<Model_Vpic>;
};

/** aggregate avg on columns */
export type Model_Avg_Fields_Vpic = {
  __typename?: 'Model_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.model". All fields are combined with a logical 'AND'. */
export type Model_Bool_Exp_Vpic = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  Make_Models?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
  Make_Models_aggregate?: InputMaybe<Make_Model_Aggregate_Bool_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Model_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Model_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Model_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.model" */
export enum Model_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkModel = 'pk_model'
}

/** input type for incrementing numeric columns in table "vpic.model" */
export type Model_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.model" */
export type Model_Insert_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  Make_Models?: InputMaybe<Make_Model_Arr_Rel_Insert_Input_Vpic>;
  Name?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Model_Max_Fields_Vpic = {
  __typename?: 'Model_max_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Model_Min_Fields_Vpic = {
  __typename?: 'Model_min_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "vpic.model" */
export type Model_Mutation_Response_Vpic = {
  __typename?: 'Model_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Vpic>;
};

/** input type for inserting object relation for remote table "vpic.model" */
export type Model_Obj_Rel_Insert_Input_Vpic = {
  data: Model_Insert_Input_Vpic;
  /** upsert condition */
  on_conflict?: InputMaybe<Model_On_Conflict_Vpic>;
};

/** on_conflict condition type for table "vpic.model" */
export type Model_On_Conflict_Vpic = {
  constraint: Model_Constraint_Vpic;
  update_columns?: Array<Model_Update_Column_Vpic>;
  where?: InputMaybe<Model_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.model". */
export type Model_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Make_Models_aggregate?: InputMaybe<Make_Model_Aggregate_Order_By_Vpic>;
  Name?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.model */
export type Model_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.model" */
export enum Model_Select_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "vpic.model" */
export type Model_Set_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Model_Stddev_Fields_Vpic = {
  __typename?: 'Model_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Model_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Model_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Model_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Model_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Model" */
export type Model_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Model_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Stream_Cursor_Value_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Model_Sum_Fields_Vpic = {
  __typename?: 'Model_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.model" */
export enum Model_Update_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Model_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Model_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Model_Var_Pop_Fields_Vpic = {
  __typename?: 'Model_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Model_Var_Samp_Fields_Vpic = {
  __typename?: 'Model_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Model_Variance_Fields_Vpic = {
  __typename?: 'Model_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.model" */
export type Model_Vpic = {
  __typename?: 'Model_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id: Scalars['Int'];
  /** An array relationship */
  Make_Models: Array<Make_Model_Vpic>;
  /** An aggregate relationship */
  Make_Models_aggregate: Make_Model_Aggregate_Vpic;
  Name: Scalars['String'];
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};


/** columns and relationships of "vpic.model" */
export type Model_VpicMake_ModelsArgs = {
  distinct_on?: InputMaybe<Array<Make_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Model_Order_By_Vpic>>;
  where?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.model" */
export type Model_VpicMake_Models_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Make_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Model_Order_By_Vpic>>;
  where?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
};

/** aggregate fields of "vpic.motorcyclechassistype" */
export type MotorcycleChassisType_Aggregate_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_aggregate_fields_vpic';
  avg?: Maybe<MotorcycleChassisType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<MotorcycleChassisType_Max_Fields_Vpic>;
  min?: Maybe<MotorcycleChassisType_Min_Fields_Vpic>;
  stddev?: Maybe<MotorcycleChassisType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<MotorcycleChassisType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<MotorcycleChassisType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<MotorcycleChassisType_Sum_Fields_Vpic>;
  var_pop?: Maybe<MotorcycleChassisType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<MotorcycleChassisType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<MotorcycleChassisType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.motorcyclechassistype" */
export type MotorcycleChassisType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<MotorcycleChassisType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.motorcyclechassistype" */
export type MotorcycleChassisType_Aggregate_Vpic = {
  __typename?: 'MotorcycleChassisType_aggregate_vpic';
  aggregate?: Maybe<MotorcycleChassisType_Aggregate_Fields_Vpic>;
  nodes: Array<MotorcycleChassisType_Vpic>;
};

/** aggregate avg on columns */
export type MotorcycleChassisType_Avg_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.motorcyclechassistype". All fields are combined with a logical 'AND'. */
export type MotorcycleChassisType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<MotorcycleChassisType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<MotorcycleChassisType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<MotorcycleChassisType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.motorcyclechassistype" */
export enum MotorcycleChassisType_Constraint_Vpic {
  /** unique or primary key constraint on columns "name" */
  IxMotorcyclechassistype = 'ix_motorcyclechassistype',
  /** unique or primary key constraint on columns "id" */
  PkMotorcyclechassistype = 'pk_motorcyclechassistype'
}

/** input type for incrementing numeric columns in table "vpic.motorcyclechassistype" */
export type MotorcycleChassisType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.motorcyclechassistype" */
export type MotorcycleChassisType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MotorcycleChassisType_Max_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MotorcycleChassisType_Min_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.motorcyclechassistype" */
export type MotorcycleChassisType_Mutation_Response_Vpic = {
  __typename?: 'MotorcycleChassisType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MotorcycleChassisType_Vpic>;
};

/** on_conflict condition type for table "vpic.motorcyclechassistype" */
export type MotorcycleChassisType_On_Conflict_Vpic = {
  constraint: MotorcycleChassisType_Constraint_Vpic;
  update_columns?: Array<MotorcycleChassisType_Update_Column_Vpic>;
  where?: InputMaybe<MotorcycleChassisType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.motorcyclechassistype". */
export type MotorcycleChassisType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.motorcyclechassistype */
export type MotorcycleChassisType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.motorcyclechassistype" */
export enum MotorcycleChassisType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.motorcyclechassistype" */
export type MotorcycleChassisType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type MotorcycleChassisType_Stddev_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MotorcycleChassisType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MotorcycleChassisType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "MotorcycleChassisType" */
export type MotorcycleChassisType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: MotorcycleChassisType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type MotorcycleChassisType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type MotorcycleChassisType_Sum_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.motorcyclechassistype" */
export enum MotorcycleChassisType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type MotorcycleChassisType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MotorcycleChassisType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MotorcycleChassisType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: MotorcycleChassisType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type MotorcycleChassisType_Var_Pop_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MotorcycleChassisType_Var_Samp_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MotorcycleChassisType_Variance_Fields_Vpic = {
  __typename?: 'MotorcycleChassisType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.motorcyclechassistype" */
export type MotorcycleChassisType_Vpic = {
  __typename?: 'MotorcycleChassisType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.motorcyclesuspensiontype" */
export type MotorcycleSuspensionType_Aggregate_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_aggregate_fields_vpic';
  avg?: Maybe<MotorcycleSuspensionType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<MotorcycleSuspensionType_Max_Fields_Vpic>;
  min?: Maybe<MotorcycleSuspensionType_Min_Fields_Vpic>;
  stddev?: Maybe<MotorcycleSuspensionType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<MotorcycleSuspensionType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<MotorcycleSuspensionType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<MotorcycleSuspensionType_Sum_Fields_Vpic>;
  var_pop?: Maybe<MotorcycleSuspensionType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<MotorcycleSuspensionType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<MotorcycleSuspensionType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.motorcyclesuspensiontype" */
export type MotorcycleSuspensionType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<MotorcycleSuspensionType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.motorcyclesuspensiontype" */
export type MotorcycleSuspensionType_Aggregate_Vpic = {
  __typename?: 'MotorcycleSuspensionType_aggregate_vpic';
  aggregate?: Maybe<MotorcycleSuspensionType_Aggregate_Fields_Vpic>;
  nodes: Array<MotorcycleSuspensionType_Vpic>;
};

/** aggregate avg on columns */
export type MotorcycleSuspensionType_Avg_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.motorcyclesuspensiontype". All fields are combined with a logical 'AND'. */
export type MotorcycleSuspensionType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<MotorcycleSuspensionType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<MotorcycleSuspensionType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<MotorcycleSuspensionType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.motorcyclesuspensiontype" */
export enum MotorcycleSuspensionType_Constraint_Vpic {
  /** unique or primary key constraint on columns "name" */
  IxMotorcyclesuspensiontype = 'ix_motorcyclesuspensiontype',
  /** unique or primary key constraint on columns "id" */
  PkMotorcyclesuspensiontype = 'pk_motorcyclesuspensiontype'
}

/** input type for incrementing numeric columns in table "vpic.motorcyclesuspensiontype" */
export type MotorcycleSuspensionType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.motorcyclesuspensiontype" */
export type MotorcycleSuspensionType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MotorcycleSuspensionType_Max_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MotorcycleSuspensionType_Min_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.motorcyclesuspensiontype" */
export type MotorcycleSuspensionType_Mutation_Response_Vpic = {
  __typename?: 'MotorcycleSuspensionType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MotorcycleSuspensionType_Vpic>;
};

/** on_conflict condition type for table "vpic.motorcyclesuspensiontype" */
export type MotorcycleSuspensionType_On_Conflict_Vpic = {
  constraint: MotorcycleSuspensionType_Constraint_Vpic;
  update_columns?: Array<MotorcycleSuspensionType_Update_Column_Vpic>;
  where?: InputMaybe<MotorcycleSuspensionType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.motorcyclesuspensiontype". */
export type MotorcycleSuspensionType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.motorcyclesuspensiontype */
export type MotorcycleSuspensionType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.motorcyclesuspensiontype" */
export enum MotorcycleSuspensionType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.motorcyclesuspensiontype" */
export type MotorcycleSuspensionType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type MotorcycleSuspensionType_Stddev_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MotorcycleSuspensionType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MotorcycleSuspensionType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "MotorcycleSuspensionType" */
export type MotorcycleSuspensionType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: MotorcycleSuspensionType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type MotorcycleSuspensionType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type MotorcycleSuspensionType_Sum_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.motorcyclesuspensiontype" */
export enum MotorcycleSuspensionType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type MotorcycleSuspensionType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MotorcycleSuspensionType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MotorcycleSuspensionType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: MotorcycleSuspensionType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type MotorcycleSuspensionType_Var_Pop_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MotorcycleSuspensionType_Var_Samp_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MotorcycleSuspensionType_Variance_Fields_Vpic = {
  __typename?: 'MotorcycleSuspensionType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.motorcyclesuspensiontype" */
export type MotorcycleSuspensionType_Vpic = {
  __typename?: 'MotorcycleSuspensionType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type No_Refund_Due_V1 = {
  __typename?: 'No_Refund_Due_v1';
  cancelAsOfDate: Scalars['date'];
  categoryName: Scalars['String'];
  claimsPaidAmount?: Maybe<Scalars['numeric']>;
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  dealerAddress1: Scalars['String'];
  dealerAddress2: Scalars['String'];
  dealerCity: Scalars['String'];
  dealerName: Scalars['String'];
  dealerState: Scalars['String'];
  dealerZip: Scalars['String'];
  feeAmount: Scalars['numeric'];
  refundAmount: Scalars['numeric'];
  refundPercent: Scalars['numeric'];
  subtractClaims?: Maybe<Scalars['Boolean']>;
  vin: Scalars['String'];
};

/** aggregate fields of "vpic.nonlanduse" */
export type NonLandUse_Aggregate_Fields_Vpic = {
  __typename?: 'NonLandUse_aggregate_fields_vpic';
  avg?: Maybe<NonLandUse_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<NonLandUse_Max_Fields_Vpic>;
  min?: Maybe<NonLandUse_Min_Fields_Vpic>;
  stddev?: Maybe<NonLandUse_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<NonLandUse_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<NonLandUse_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<NonLandUse_Sum_Fields_Vpic>;
  var_pop?: Maybe<NonLandUse_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<NonLandUse_Var_Samp_Fields_Vpic>;
  variance?: Maybe<NonLandUse_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.nonlanduse" */
export type NonLandUse_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<NonLandUse_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.nonlanduse" */
export type NonLandUse_Aggregate_Vpic = {
  __typename?: 'NonLandUse_aggregate_vpic';
  aggregate?: Maybe<NonLandUse_Aggregate_Fields_Vpic>;
  nodes: Array<NonLandUse_Vpic>;
};

/** aggregate avg on columns */
export type NonLandUse_Avg_Fields_Vpic = {
  __typename?: 'NonLandUse_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.nonlanduse". All fields are combined with a logical 'AND'. */
export type NonLandUse_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<NonLandUse_Bool_Exp_Vpic>>;
  _not?: InputMaybe<NonLandUse_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<NonLandUse_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.nonlanduse" */
export enum NonLandUse_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkNonlanduse = 'pk_nonlanduse',
  /** unique or primary key constraint on columns "name" */
  UNonlandusename = 'u_nonlandusename'
}

/** input type for incrementing numeric columns in table "vpic.nonlanduse" */
export type NonLandUse_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.nonlanduse" */
export type NonLandUse_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type NonLandUse_Max_Fields_Vpic = {
  __typename?: 'NonLandUse_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type NonLandUse_Min_Fields_Vpic = {
  __typename?: 'NonLandUse_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.nonlanduse" */
export type NonLandUse_Mutation_Response_Vpic = {
  __typename?: 'NonLandUse_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NonLandUse_Vpic>;
};

/** on_conflict condition type for table "vpic.nonlanduse" */
export type NonLandUse_On_Conflict_Vpic = {
  constraint: NonLandUse_Constraint_Vpic;
  update_columns?: Array<NonLandUse_Update_Column_Vpic>;
  where?: InputMaybe<NonLandUse_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.nonlanduse". */
export type NonLandUse_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.nonlanduse */
export type NonLandUse_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.nonlanduse" */
export enum NonLandUse_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.nonlanduse" */
export type NonLandUse_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type NonLandUse_Stddev_Fields_Vpic = {
  __typename?: 'NonLandUse_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type NonLandUse_Stddev_Pop_Fields_Vpic = {
  __typename?: 'NonLandUse_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type NonLandUse_Stddev_Samp_Fields_Vpic = {
  __typename?: 'NonLandUse_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "NonLandUse" */
export type NonLandUse_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: NonLandUse_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type NonLandUse_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type NonLandUse_Sum_Fields_Vpic = {
  __typename?: 'NonLandUse_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.nonlanduse" */
export enum NonLandUse_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type NonLandUse_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NonLandUse_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NonLandUse_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: NonLandUse_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type NonLandUse_Var_Pop_Fields_Vpic = {
  __typename?: 'NonLandUse_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type NonLandUse_Var_Samp_Fields_Vpic = {
  __typename?: 'NonLandUse_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NonLandUse_Variance_Fields_Vpic = {
  __typename?: 'NonLandUse_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.nonlanduse" */
export type NonLandUse_Vpic = {
  __typename?: 'NonLandUse_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Noncancellable_V1 = {
  __typename?: 'Noncancellable_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  lenderAddress1: Scalars['String'];
  lenderAddress2: Scalars['String'];
  lenderCity: Scalars['String'];
  lenderName: Scalars['String'];
  lenderState: Scalars['String'];
  lenderZip: Scalars['String'];
  vin: Scalars['String'];
};

export type Ops_Gap_Late_Submission_Agreement_V1 = {
  __typename?: 'Ops_Gap_Late_Submission_Agreement_v1';
  contractNumber: Scalars['String'];
  coverageCost: Scalars['numeric'];
  customerName: Scalars['String'];
  date: Scalars['date'];
  deadlineDate: Scalars['date'];
};

export type OryPublicMetadata = {
  __typename?: 'OryPublicMetadata';
  role?: Maybe<Scalars['String']>;
};

export type OryTraits = {
  __typename?: 'OryTraits';
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** aggregate fields of "vpic.parkassist" */
export type ParkAssist_Aggregate_Fields_Vpic = {
  __typename?: 'ParkAssist_aggregate_fields_vpic';
  avg?: Maybe<ParkAssist_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<ParkAssist_Max_Fields_Vpic>;
  min?: Maybe<ParkAssist_Min_Fields_Vpic>;
  stddev?: Maybe<ParkAssist_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<ParkAssist_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<ParkAssist_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<ParkAssist_Sum_Fields_Vpic>;
  var_pop?: Maybe<ParkAssist_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<ParkAssist_Var_Samp_Fields_Vpic>;
  variance?: Maybe<ParkAssist_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.parkassist" */
export type ParkAssist_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<ParkAssist_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.parkassist" */
export type ParkAssist_Aggregate_Vpic = {
  __typename?: 'ParkAssist_aggregate_vpic';
  aggregate?: Maybe<ParkAssist_Aggregate_Fields_Vpic>;
  nodes: Array<ParkAssist_Vpic>;
};

/** aggregate avg on columns */
export type ParkAssist_Avg_Fields_Vpic = {
  __typename?: 'ParkAssist_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.parkassist". All fields are combined with a logical 'AND'. */
export type ParkAssist_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ParkAssist_Bool_Exp_Vpic>>;
  _not?: InputMaybe<ParkAssist_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<ParkAssist_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.parkassist" */
export enum ParkAssist_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkParkassist = 'pk_parkassist',
  /** unique or primary key constraint on columns "name" */
  UParkassistname = 'u_parkassistname'
}

/** input type for incrementing numeric columns in table "vpic.parkassist" */
export type ParkAssist_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.parkassist" */
export type ParkAssist_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ParkAssist_Max_Fields_Vpic = {
  __typename?: 'ParkAssist_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ParkAssist_Min_Fields_Vpic = {
  __typename?: 'ParkAssist_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.parkassist" */
export type ParkAssist_Mutation_Response_Vpic = {
  __typename?: 'ParkAssist_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ParkAssist_Vpic>;
};

/** on_conflict condition type for table "vpic.parkassist" */
export type ParkAssist_On_Conflict_Vpic = {
  constraint: ParkAssist_Constraint_Vpic;
  update_columns?: Array<ParkAssist_Update_Column_Vpic>;
  where?: InputMaybe<ParkAssist_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.parkassist". */
export type ParkAssist_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.parkassist */
export type ParkAssist_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.parkassist" */
export enum ParkAssist_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.parkassist" */
export type ParkAssist_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ParkAssist_Stddev_Fields_Vpic = {
  __typename?: 'ParkAssist_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ParkAssist_Stddev_Pop_Fields_Vpic = {
  __typename?: 'ParkAssist_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ParkAssist_Stddev_Samp_Fields_Vpic = {
  __typename?: 'ParkAssist_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ParkAssist" */
export type ParkAssist_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: ParkAssist_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type ParkAssist_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ParkAssist_Sum_Fields_Vpic = {
  __typename?: 'ParkAssist_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.parkassist" */
export enum ParkAssist_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type ParkAssist_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ParkAssist_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParkAssist_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: ParkAssist_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type ParkAssist_Var_Pop_Fields_Vpic = {
  __typename?: 'ParkAssist_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ParkAssist_Var_Samp_Fields_Vpic = {
  __typename?: 'ParkAssist_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ParkAssist_Variance_Fields_Vpic = {
  __typename?: 'ParkAssist_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.parkassist" */
export type ParkAssist_Vpic = {
  __typename?: 'ParkAssist_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Pattern_Aggregate_Bool_Exp = {
  count?: InputMaybe<Pattern_Aggregate_Bool_Exp_Count>;
};

export type Pattern_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pattern_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Pattern_Bool_Exp_Vpic>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vpic.pattern" */
export type Pattern_Aggregate_Fields_Vpic = {
  __typename?: 'Pattern_aggregate_fields_vpic';
  avg?: Maybe<Pattern_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Pattern_Max_Fields_Vpic>;
  min?: Maybe<Pattern_Min_Fields_Vpic>;
  stddev?: Maybe<Pattern_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Pattern_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Pattern_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Pattern_Sum_Fields_Vpic>;
  var_pop?: Maybe<Pattern_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Pattern_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Pattern_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.pattern" */
export type Pattern_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Pattern_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vpic.pattern" */
export type Pattern_Aggregate_Order_By_Vpic = {
  avg?: InputMaybe<Pattern_Avg_Order_By_Vpic>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pattern_Max_Order_By_Vpic>;
  min?: InputMaybe<Pattern_Min_Order_By_Vpic>;
  stddev?: InputMaybe<Pattern_Stddev_Order_By_Vpic>;
  stddev_pop?: InputMaybe<Pattern_Stddev_Pop_Order_By_Vpic>;
  stddev_samp?: InputMaybe<Pattern_Stddev_Samp_Order_By_Vpic>;
  sum?: InputMaybe<Pattern_Sum_Order_By_Vpic>;
  var_pop?: InputMaybe<Pattern_Var_Pop_Order_By_Vpic>;
  var_samp?: InputMaybe<Pattern_Var_Samp_Order_By_Vpic>;
  variance?: InputMaybe<Pattern_Variance_Order_By_Vpic>;
};

/** aggregated selection of "vpic.pattern" */
export type Pattern_Aggregate_Vpic = {
  __typename?: 'Pattern_aggregate_vpic';
  aggregate?: Maybe<Pattern_Aggregate_Fields_Vpic>;
  nodes: Array<Pattern_Vpic>;
};

/** input type for inserting array relation for remote table "vpic.pattern" */
export type Pattern_Arr_Rel_Insert_Input_Vpic = {
  data: Array<Pattern_Insert_Input_Vpic>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pattern_On_Conflict_Vpic>;
};

/** aggregate avg on columns */
export type Pattern_Avg_Fields_Vpic = {
  __typename?: 'Pattern_avg_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vpic.pattern" */
export type Pattern_Avg_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vpic.pattern". All fields are combined with a logical 'AND'. */
export type Pattern_Bool_Exp_Vpic = {
  AttributeId?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Element?: InputMaybe<Element_Bool_Exp_Vpic>;
  ElementId?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  Keys?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  VinSchema?: InputMaybe<VinSchema_Bool_Exp_Vpic>;
  VinSchemaId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Pattern_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Pattern_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Pattern_Bool_Exp_Vpic>>;
  keys_regex?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vpic.pattern" */
export enum Pattern_Constraint_Vpic {
  /** unique or primary key constraint on columns "elementid", "vinschemaid", "keys" */
  IxPatternKeyelementUnique = 'ix_pattern_keyelement_unique',
  /** unique or primary key constraint on columns "id" */
  PkPattern = 'pk_pattern'
}

/** input type for incrementing numeric columns in table "vpic.pattern" */
export type Pattern_Inc_Input_Vpic = {
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  VinSchemaId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.pattern" */
export type Pattern_Insert_Input_Vpic = {
  AttributeId?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Element?: InputMaybe<Element_Obj_Rel_Insert_Input_Vpic>;
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  Keys?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VinSchema?: InputMaybe<VinSchema_Obj_Rel_Insert_Input_Vpic>;
  VinSchemaId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Pattern_Max_Fields_Vpic = {
  __typename?: 'Pattern_max_fields_vpic';
  AttributeId?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  Keys?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VinSchemaId?: Maybe<Scalars['Int']>;
  keys_regex?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "vpic.pattern" */
export type Pattern_Max_Order_By_Vpic = {
  AttributeId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Keys?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  keys_regex?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pattern_Min_Fields_Vpic = {
  __typename?: 'Pattern_min_fields_vpic';
  AttributeId?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  Keys?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VinSchemaId?: Maybe<Scalars['Int']>;
  keys_regex?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "vpic.pattern" */
export type Pattern_Min_Order_By_Vpic = {
  AttributeId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Keys?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  keys_regex?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vpic.pattern" */
export type Pattern_Mutation_Response_Vpic = {
  __typename?: 'Pattern_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pattern_Vpic>;
};

/** on_conflict condition type for table "vpic.pattern" */
export type Pattern_On_Conflict_Vpic = {
  constraint: Pattern_Constraint_Vpic;
  update_columns?: Array<Pattern_Update_Column_Vpic>;
  where?: InputMaybe<Pattern_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.pattern". */
export type Pattern_Order_By_Vpic = {
  AttributeId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Element?: InputMaybe<Element_Order_By_Vpic>;
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Keys?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VinSchema?: InputMaybe<VinSchema_Order_By_Vpic>;
  VinSchemaId?: InputMaybe<Order_By>;
  keys_regex?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.pattern */
export type Pattern_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.pattern" */
export enum Pattern_Select_Column_Vpic {
  /** column name */
  AttributeId = 'AttributeId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  ElementId = 'ElementId',
  /** column name */
  Id = 'Id',
  /** column name */
  Keys = 'Keys',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VinSchemaId = 'VinSchemaId',
  /** column name */
  KeysRegex = 'keys_regex'
}

/** input type for updating data in table "vpic.pattern" */
export type Pattern_Set_Input_Vpic = {
  AttributeId?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  Keys?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VinSchemaId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Pattern_Stddev_Fields_Vpic = {
  __typename?: 'Pattern_stddev_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vpic.pattern" */
export type Pattern_Stddev_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pattern_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Pattern_stddev_pop_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vpic.pattern" */
export type Pattern_Stddev_Pop_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pattern_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Pattern_stddev_samp_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vpic.pattern" */
export type Pattern_Stddev_Samp_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Pattern" */
export type Pattern_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Pattern_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Pattern_Stream_Cursor_Value_Input_Vpic = {
  AttributeId?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  Keys?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VinSchemaId?: InputMaybe<Scalars['Int']>;
  keys_regex?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Pattern_Sum_Fields_Vpic = {
  __typename?: 'Pattern_sum_fields_vpic';
  ElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  VinSchemaId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vpic.pattern" */
export type Pattern_Sum_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
};

/** update columns of table "vpic.pattern" */
export enum Pattern_Update_Column_Vpic {
  /** column name */
  AttributeId = 'AttributeId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  ElementId = 'ElementId',
  /** column name */
  Id = 'Id',
  /** column name */
  Keys = 'Keys',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VinSchemaId = 'VinSchemaId'
}

export type Pattern_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pattern_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pattern_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Pattern_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Pattern_Var_Pop_Fields_Vpic = {
  __typename?: 'Pattern_var_pop_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vpic.pattern" */
export type Pattern_Var_Pop_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pattern_Var_Samp_Fields_Vpic = {
  __typename?: 'Pattern_var_samp_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vpic.pattern" */
export type Pattern_Var_Samp_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pattern_Variance_Fields_Vpic = {
  __typename?: 'Pattern_variance_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vpic.pattern" */
export type Pattern_Variance_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
};

/** columns and relationships of "vpic.pattern" */
export type Pattern_Vpic = {
  __typename?: 'Pattern_vpic';
  AttributeId: Scalars['String'];
  CreatedOn?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  Element?: Maybe<Element_Vpic>;
  ElementId: Scalars['Int'];
  Id: Scalars['Int'];
  Keys: Scalars['String'];
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  VinSchema?: Maybe<VinSchema_Vpic>;
  VinSchemaId: Scalars['Int'];
  keys_regex?: Maybe<Scalars['String']>;
};

/** aggregate fields of "vpic.pedestrianautomaticemergencybraking" */
export type PedestrianAutomaticEmergencyBraking_Aggregate_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_aggregate_fields_vpic';
  avg?: Maybe<PedestrianAutomaticEmergencyBraking_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<PedestrianAutomaticEmergencyBraking_Max_Fields_Vpic>;
  min?: Maybe<PedestrianAutomaticEmergencyBraking_Min_Fields_Vpic>;
  stddev?: Maybe<PedestrianAutomaticEmergencyBraking_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<PedestrianAutomaticEmergencyBraking_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<PedestrianAutomaticEmergencyBraking_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<PedestrianAutomaticEmergencyBraking_Sum_Fields_Vpic>;
  var_pop?: Maybe<PedestrianAutomaticEmergencyBraking_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<PedestrianAutomaticEmergencyBraking_Var_Samp_Fields_Vpic>;
  variance?: Maybe<PedestrianAutomaticEmergencyBraking_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.pedestrianautomaticemergencybraking" */
export type PedestrianAutomaticEmergencyBraking_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.pedestrianautomaticemergencybraking" */
export type PedestrianAutomaticEmergencyBraking_Aggregate_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_aggregate_vpic';
  aggregate?: Maybe<PedestrianAutomaticEmergencyBraking_Aggregate_Fields_Vpic>;
  nodes: Array<PedestrianAutomaticEmergencyBraking_Vpic>;
};

/** aggregate avg on columns */
export type PedestrianAutomaticEmergencyBraking_Avg_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.pedestrianautomaticemergencybraking". All fields are combined with a logical 'AND'. */
export type PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic>>;
  _not?: InputMaybe<PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.pedestrianautomaticemergencybraking" */
export enum PedestrianAutomaticEmergencyBraking_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkPedestri_3214ec07a638ba23 = 'pk__pedestri__3214ec07a638ba23'
}

/** input type for incrementing numeric columns in table "vpic.pedestrianautomaticemergencybraking" */
export type PedestrianAutomaticEmergencyBraking_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.pedestrianautomaticemergencybraking" */
export type PedestrianAutomaticEmergencyBraking_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PedestrianAutomaticEmergencyBraking_Max_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PedestrianAutomaticEmergencyBraking_Min_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.pedestrianautomaticemergencybraking" */
export type PedestrianAutomaticEmergencyBraking_Mutation_Response_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PedestrianAutomaticEmergencyBraking_Vpic>;
};

/** on_conflict condition type for table "vpic.pedestrianautomaticemergencybraking" */
export type PedestrianAutomaticEmergencyBraking_On_Conflict_Vpic = {
  constraint: PedestrianAutomaticEmergencyBraking_Constraint_Vpic;
  update_columns?: Array<PedestrianAutomaticEmergencyBraking_Update_Column_Vpic>;
  where?: InputMaybe<PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.pedestrianautomaticemergencybraking". */
export type PedestrianAutomaticEmergencyBraking_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.pedestrianautomaticemergencybraking */
export type PedestrianAutomaticEmergencyBraking_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.pedestrianautomaticemergencybraking" */
export enum PedestrianAutomaticEmergencyBraking_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.pedestrianautomaticemergencybraking" */
export type PedestrianAutomaticEmergencyBraking_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type PedestrianAutomaticEmergencyBraking_Stddev_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PedestrianAutomaticEmergencyBraking_Stddev_Pop_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PedestrianAutomaticEmergencyBraking_Stddev_Samp_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PedestrianAutomaticEmergencyBraking" */
export type PedestrianAutomaticEmergencyBraking_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: PedestrianAutomaticEmergencyBraking_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type PedestrianAutomaticEmergencyBraking_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PedestrianAutomaticEmergencyBraking_Sum_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.pedestrianautomaticemergencybraking" */
export enum PedestrianAutomaticEmergencyBraking_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type PedestrianAutomaticEmergencyBraking_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PedestrianAutomaticEmergencyBraking_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PedestrianAutomaticEmergencyBraking_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type PedestrianAutomaticEmergencyBraking_Var_Pop_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PedestrianAutomaticEmergencyBraking_Var_Samp_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PedestrianAutomaticEmergencyBraking_Variance_Fields_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.pedestrianautomaticemergencybraking" */
export type PedestrianAutomaticEmergencyBraking_Vpic = {
  __typename?: 'PedestrianAutomaticEmergencyBraking_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** columns and relationships of "Plan" */
export type Plan = {
  __typename?: 'Plan';
  AsianFlag: Scalars['String'];
  BookState: Scalars['String'];
  CancelAfterDays: Scalars['Float'];
  CancelBeforeAfterCode: Scalars['String'];
  CancelFee: Scalars['Float'];
  CancelMethod: Scalars['Float'];
  CancelMethodArray: Scalars['String'];
  CancelRule: Scalars['Float'];
  CancelRuleArray: Scalars['String'];
  CompanyCode: Scalars['String'];
  CoverageOptionTypeCode: Scalars['String'];
  CoverageTypeCode: Scalars['String'];
  Description: Scalars['String'];
  DomesticFlag: Scalars['String'];
  EffectiveDate: Scalars['Float'];
  EnteredBy: Scalars['String'];
  EnteredDate: Scalars['Float'];
  EuropeanFlag: Scalars['String'];
  ExpiredDate: Scalars['Float'];
  FlatCancelDays: Scalars['Float'];
  FlatCancelFee: Scalars['Float'];
  FormName: Scalars['String'];
  FriendlyDescription?: Maybe<Scalars['String']>;
  Group1: Scalars['String'];
  Group1Description: Scalars['String'];
  Group2: Scalars['String'];
  Group2Description: Scalars['String'];
  Group3: Scalars['String'];
  Group3Description: Scalars['String'];
  HasDisappearingDeductible?: Maybe<Scalars['Boolean']>;
  HeirarchyLevel: Scalars['Float'];
  ImportFlag: Scalars['String'];
  IsCPOLimitedWarrantyPlan?: Maybe<Scalars['Boolean']>;
  IsCPOMBPWrapPlan?: Maybe<Scalars['Boolean']>;
  IsCPOManufacturerWrapPlan?: Maybe<Scalars['Boolean']>;
  IsCPOWrapPlan?: Maybe<Scalars['Boolean']>;
  IsComplementaryPlan?: Maybe<Scalars['Boolean']>;
  IsForwardMotionPlan?: Maybe<Scalars['Boolean']>;
  IsGAPLeasePlan?: Maybe<Scalars['Boolean']>;
  IsGAPLoanPlan?: Maybe<Scalars['Boolean']>;
  IsLifetimeWrapPlan?: Maybe<Scalars['Boolean']>;
  IsLimitedLifetimeWarrantyPlan?: Maybe<Scalars['Boolean']>;
  IsLimitedWarrantyPlan?: Maybe<Scalars['Boolean']>;
  IsMSquaredPlan?: Maybe<Scalars['Boolean']>;
  IsMonthToMonthPlan?: Maybe<Scalars['Boolean']>;
  IsNewCarPlan?: Maybe<Scalars['Boolean']>;
  IsRoushPlan?: Maybe<Scalars['Boolean']>;
  IsShortTermLimitedWarrantyPlan?: Maybe<Scalars['Boolean']>;
  IsWrapPlan?: Maybe<Scalars['Boolean']>;
  MinVehicleFleet: Scalars['Float'];
  NewUsedBothCode: Scalars['String'];
  OtherVehicleTypesFlag: Scalars['String'];
  PlanCode: Scalars['String'];
  PlanID: Scalars['Int'];
  PlanType: Scalars['String'];
  RecordStatusCode: Scalars['String'];
  SubtractClaimsFlag: Scalars['String'];
  UpdatedBy: Scalars['String'];
  UpdatedDate: Scalars['Float'];
};

/** aggregated selection of "Plan" */
export type Plan_Aggregate = {
  __typename?: 'Plan_aggregate';
  aggregate?: Maybe<Plan_Aggregate_Fields>;
  nodes: Array<Plan>;
};

/** aggregate fields of "Plan" */
export type Plan_Aggregate_Fields = {
  __typename?: 'Plan_aggregate_fields';
  avg?: Maybe<Plan_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plan_Max_Fields>;
  min?: Maybe<Plan_Min_Fields>;
  stddev?: Maybe<Plan_Stddev_Fields>;
  stddev_pop?: Maybe<Plan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plan_Stddev_Samp_Fields>;
  sum?: Maybe<Plan_Sum_Fields>;
  var_pop?: Maybe<Plan_Var_Pop_Fields>;
  var_samp?: Maybe<Plan_Var_Samp_Fields>;
  variance?: Maybe<Plan_Variance_Fields>;
};


/** aggregate fields of "Plan" */
export type Plan_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Plan_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Plan_Avg_Fields = {
  __typename?: 'Plan_avg_fields';
  CancelAfterDays?: Maybe<Scalars['Float']>;
  CancelFee?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpiredDate?: Maybe<Scalars['Float']>;
  FlatCancelDays?: Maybe<Scalars['Float']>;
  FlatCancelFee?: Maybe<Scalars['Float']>;
  HeirarchyLevel?: Maybe<Scalars['Float']>;
  MinVehicleFleet?: Maybe<Scalars['Float']>;
  PlanID?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Plan". All fields are combined with a logical 'AND'. */
export type Plan_Bool_Exp = {
  AsianFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  BookState?: InputMaybe<String_Mssql_Comparison_Exp>;
  CancelAfterDays?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelBeforeAfterCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  CancelFee?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelMethod?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelMethodArray?: InputMaybe<String_Mssql_Comparison_Exp>;
  CancelRule?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CancelRuleArray?: InputMaybe<String_Mssql_Comparison_Exp>;
  CompanyCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  CoverageOptionTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  CoverageTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Description?: InputMaybe<String_Mssql_Comparison_Exp>;
  DomesticFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  EffectiveDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  EnteredBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  EnteredDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  EuropeanFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  ExpiredDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  FlatCancelDays?: InputMaybe<Float_Mssql_Comparison_Exp>;
  FlatCancelFee?: InputMaybe<Float_Mssql_Comparison_Exp>;
  FormName?: InputMaybe<String_Mssql_Comparison_Exp>;
  FriendlyDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  Group1?: InputMaybe<String_Mssql_Comparison_Exp>;
  Group1Description?: InputMaybe<String_Mssql_Comparison_Exp>;
  Group2?: InputMaybe<String_Mssql_Comparison_Exp>;
  Group2Description?: InputMaybe<String_Mssql_Comparison_Exp>;
  Group3?: InputMaybe<String_Mssql_Comparison_Exp>;
  Group3Description?: InputMaybe<String_Mssql_Comparison_Exp>;
  HasDisappearingDeductible?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  HeirarchyLevel?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ImportFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsCPOLimitedWarrantyPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsCPOMBPWrapPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsCPOManufacturerWrapPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsCPOWrapPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsComplementaryPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsForwardMotionPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsGAPLeasePlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsGAPLoanPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsLifetimeWrapPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsLimitedLifetimeWarrantyPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsLimitedWarrantyPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsMSquaredPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsMonthToMonthPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsNewCarPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsRoushPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsShortTermLimitedWarrantyPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsWrapPlan?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  MinVehicleFleet?: InputMaybe<Float_Mssql_Comparison_Exp>;
  NewUsedBothCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  OtherVehicleTypesFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  PlanCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  PlanID?: InputMaybe<Int_Mssql_Comparison_Exp>;
  PlanType?: InputMaybe<String_Mssql_Comparison_Exp>;
  RecordStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  SubtractClaimsFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  UpdatedBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  UpdatedDate?: InputMaybe<Float_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Plan_Bool_Exp>>;
  _not?: InputMaybe<Plan_Bool_Exp>;
  _or?: InputMaybe<Array<Plan_Bool_Exp>>;
};

/** upsert condition type for table "Plan" */
export type Plan_If_Matched = {
  match_columns?: Array<Plan_Insert_Match_Column>;
  update_columns?: Array<Plan_Update_Column>;
  where?: InputMaybe<Plan_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "Plan" */
export type Plan_Inc_Input = {
  CancelAfterDays?: InputMaybe<Scalars['Float']>;
  CancelFee?: InputMaybe<Scalars['Float']>;
  CancelMethod?: InputMaybe<Scalars['Float']>;
  CancelRule?: InputMaybe<Scalars['Float']>;
  EffectiveDate?: InputMaybe<Scalars['Float']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  ExpiredDate?: InputMaybe<Scalars['Float']>;
  FlatCancelDays?: InputMaybe<Scalars['Float']>;
  FlatCancelFee?: InputMaybe<Scalars['Float']>;
  HeirarchyLevel?: InputMaybe<Scalars['Float']>;
  MinVehicleFleet?: InputMaybe<Scalars['Float']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "Plan" */
export type Plan_Insert_Input = {
  AsianFlag?: InputMaybe<Scalars['String']>;
  BookState?: InputMaybe<Scalars['String']>;
  CancelAfterDays?: InputMaybe<Scalars['Float']>;
  CancelBeforeAfterCode?: InputMaybe<Scalars['String']>;
  CancelFee?: InputMaybe<Scalars['Float']>;
  CancelMethod?: InputMaybe<Scalars['Float']>;
  CancelMethodArray?: InputMaybe<Scalars['String']>;
  CancelRule?: InputMaybe<Scalars['Float']>;
  CancelRuleArray?: InputMaybe<Scalars['String']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  CoverageOptionTypeCode?: InputMaybe<Scalars['String']>;
  CoverageTypeCode?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DomesticFlag?: InputMaybe<Scalars['String']>;
  EffectiveDate?: InputMaybe<Scalars['Float']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  EuropeanFlag?: InputMaybe<Scalars['String']>;
  ExpiredDate?: InputMaybe<Scalars['Float']>;
  FlatCancelDays?: InputMaybe<Scalars['Float']>;
  FlatCancelFee?: InputMaybe<Scalars['Float']>;
  FormName?: InputMaybe<Scalars['String']>;
  FriendlyDescription?: InputMaybe<Scalars['String']>;
  Group1?: InputMaybe<Scalars['String']>;
  Group1Description?: InputMaybe<Scalars['String']>;
  Group2?: InputMaybe<Scalars['String']>;
  Group2Description?: InputMaybe<Scalars['String']>;
  Group3?: InputMaybe<Scalars['String']>;
  Group3Description?: InputMaybe<Scalars['String']>;
  HasDisappearingDeductible?: InputMaybe<Scalars['Boolean']>;
  HeirarchyLevel?: InputMaybe<Scalars['Float']>;
  ImportFlag?: InputMaybe<Scalars['String']>;
  IsCPOLimitedWarrantyPlan?: InputMaybe<Scalars['Boolean']>;
  IsCPOMBPWrapPlan?: InputMaybe<Scalars['Boolean']>;
  IsCPOManufacturerWrapPlan?: InputMaybe<Scalars['Boolean']>;
  IsCPOWrapPlan?: InputMaybe<Scalars['Boolean']>;
  IsComplementaryPlan?: InputMaybe<Scalars['Boolean']>;
  IsForwardMotionPlan?: InputMaybe<Scalars['Boolean']>;
  IsGAPLeasePlan?: InputMaybe<Scalars['Boolean']>;
  IsGAPLoanPlan?: InputMaybe<Scalars['Boolean']>;
  IsLifetimeWrapPlan?: InputMaybe<Scalars['Boolean']>;
  IsLimitedLifetimeWarrantyPlan?: InputMaybe<Scalars['Boolean']>;
  IsLimitedWarrantyPlan?: InputMaybe<Scalars['Boolean']>;
  IsMSquaredPlan?: InputMaybe<Scalars['Boolean']>;
  IsMonthToMonthPlan?: InputMaybe<Scalars['Boolean']>;
  IsNewCarPlan?: InputMaybe<Scalars['Boolean']>;
  IsRoushPlan?: InputMaybe<Scalars['Boolean']>;
  IsShortTermLimitedWarrantyPlan?: InputMaybe<Scalars['Boolean']>;
  IsWrapPlan?: InputMaybe<Scalars['Boolean']>;
  MinVehicleFleet?: InputMaybe<Scalars['Float']>;
  NewUsedBothCode?: InputMaybe<Scalars['String']>;
  OtherVehicleTypesFlag?: InputMaybe<Scalars['String']>;
  PlanCode?: InputMaybe<Scalars['String']>;
  PlanType?: InputMaybe<Scalars['String']>;
  RecordStatusCode?: InputMaybe<Scalars['String']>;
  SubtractClaimsFlag?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
};

/** select match_columns of table "Plan" */
export enum Plan_Insert_Match_Column {
  /** column name */
  AsianFlag = 'AsianFlag',
  /** column name */
  BookState = 'BookState',
  /** column name */
  CancelAfterDays = 'CancelAfterDays',
  /** column name */
  CancelBeforeAfterCode = 'CancelBeforeAfterCode',
  /** column name */
  CancelFee = 'CancelFee',
  /** column name */
  CancelMethod = 'CancelMethod',
  /** column name */
  CancelMethodArray = 'CancelMethodArray',
  /** column name */
  CancelRule = 'CancelRule',
  /** column name */
  CancelRuleArray = 'CancelRuleArray',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  CoverageOptionTypeCode = 'CoverageOptionTypeCode',
  /** column name */
  CoverageTypeCode = 'CoverageTypeCode',
  /** column name */
  Description = 'Description',
  /** column name */
  DomesticFlag = 'DomesticFlag',
  /** column name */
  EffectiveDate = 'EffectiveDate',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  EuropeanFlag = 'EuropeanFlag',
  /** column name */
  ExpiredDate = 'ExpiredDate',
  /** column name */
  FlatCancelDays = 'FlatCancelDays',
  /** column name */
  FlatCancelFee = 'FlatCancelFee',
  /** column name */
  FormName = 'FormName',
  /** column name */
  FriendlyDescription = 'FriendlyDescription',
  /** column name */
  Group1 = 'Group1',
  /** column name */
  Group1Description = 'Group1Description',
  /** column name */
  Group2 = 'Group2',
  /** column name */
  Group2Description = 'Group2Description',
  /** column name */
  Group3 = 'Group3',
  /** column name */
  Group3Description = 'Group3Description',
  /** column name */
  HasDisappearingDeductible = 'HasDisappearingDeductible',
  /** column name */
  HeirarchyLevel = 'HeirarchyLevel',
  /** column name */
  ImportFlag = 'ImportFlag',
  /** column name */
  IsCpoLimitedWarrantyPlan = 'IsCPOLimitedWarrantyPlan',
  /** column name */
  IsCpombpWrapPlan = 'IsCPOMBPWrapPlan',
  /** column name */
  IsCpoManufacturerWrapPlan = 'IsCPOManufacturerWrapPlan',
  /** column name */
  IsCpoWrapPlan = 'IsCPOWrapPlan',
  /** column name */
  IsComplementaryPlan = 'IsComplementaryPlan',
  /** column name */
  IsForwardMotionPlan = 'IsForwardMotionPlan',
  /** column name */
  IsGapLeasePlan = 'IsGAPLeasePlan',
  /** column name */
  IsGapLoanPlan = 'IsGAPLoanPlan',
  /** column name */
  IsLifetimeWrapPlan = 'IsLifetimeWrapPlan',
  /** column name */
  IsLimitedLifetimeWarrantyPlan = 'IsLimitedLifetimeWarrantyPlan',
  /** column name */
  IsLimitedWarrantyPlan = 'IsLimitedWarrantyPlan',
  /** column name */
  IsMSquaredPlan = 'IsMSquaredPlan',
  /** column name */
  IsMonthToMonthPlan = 'IsMonthToMonthPlan',
  /** column name */
  IsNewCarPlan = 'IsNewCarPlan',
  /** column name */
  IsRoushPlan = 'IsRoushPlan',
  /** column name */
  IsShortTermLimitedWarrantyPlan = 'IsShortTermLimitedWarrantyPlan',
  /** column name */
  IsWrapPlan = 'IsWrapPlan',
  /** column name */
  MinVehicleFleet = 'MinVehicleFleet',
  /** column name */
  NewUsedBothCode = 'NewUsedBothCode',
  /** column name */
  OtherVehicleTypesFlag = 'OtherVehicleTypesFlag',
  /** column name */
  PlanCode = 'PlanCode',
  /** column name */
  PlanId = 'PlanID',
  /** column name */
  PlanType = 'PlanType',
  /** column name */
  RecordStatusCode = 'RecordStatusCode',
  /** column name */
  SubtractClaimsFlag = 'SubtractClaimsFlag',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate'
}

/** aggregate max on columns */
export type Plan_Max_Fields = {
  __typename?: 'Plan_max_fields';
  AsianFlag?: Maybe<Scalars['String']>;
  BookState?: Maybe<Scalars['String']>;
  CancelAfterDays?: Maybe<Scalars['Float']>;
  CancelBeforeAfterCode?: Maybe<Scalars['String']>;
  CancelFee?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelMethodArray?: Maybe<Scalars['String']>;
  CancelRule?: Maybe<Scalars['Float']>;
  CancelRuleArray?: Maybe<Scalars['String']>;
  CompanyCode?: Maybe<Scalars['String']>;
  CoverageOptionTypeCode?: Maybe<Scalars['String']>;
  CoverageTypeCode?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DomesticFlag?: Maybe<Scalars['String']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EuropeanFlag?: Maybe<Scalars['String']>;
  ExpiredDate?: Maybe<Scalars['Float']>;
  FlatCancelDays?: Maybe<Scalars['Float']>;
  FlatCancelFee?: Maybe<Scalars['Float']>;
  FormName?: Maybe<Scalars['String']>;
  FriendlyDescription?: Maybe<Scalars['String']>;
  Group1?: Maybe<Scalars['String']>;
  Group1Description?: Maybe<Scalars['String']>;
  Group2?: Maybe<Scalars['String']>;
  Group2Description?: Maybe<Scalars['String']>;
  Group3?: Maybe<Scalars['String']>;
  Group3Description?: Maybe<Scalars['String']>;
  HeirarchyLevel?: Maybe<Scalars['Float']>;
  ImportFlag?: Maybe<Scalars['String']>;
  MinVehicleFleet?: Maybe<Scalars['Float']>;
  NewUsedBothCode?: Maybe<Scalars['String']>;
  OtherVehicleTypesFlag?: Maybe<Scalars['String']>;
  PlanCode?: Maybe<Scalars['String']>;
  PlanID?: Maybe<Scalars['Int']>;
  PlanType?: Maybe<Scalars['String']>;
  RecordStatusCode?: Maybe<Scalars['String']>;
  SubtractClaimsFlag?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Plan_Min_Fields = {
  __typename?: 'Plan_min_fields';
  AsianFlag?: Maybe<Scalars['String']>;
  BookState?: Maybe<Scalars['String']>;
  CancelAfterDays?: Maybe<Scalars['Float']>;
  CancelBeforeAfterCode?: Maybe<Scalars['String']>;
  CancelFee?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelMethodArray?: Maybe<Scalars['String']>;
  CancelRule?: Maybe<Scalars['Float']>;
  CancelRuleArray?: Maybe<Scalars['String']>;
  CompanyCode?: Maybe<Scalars['String']>;
  CoverageOptionTypeCode?: Maybe<Scalars['String']>;
  CoverageTypeCode?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DomesticFlag?: Maybe<Scalars['String']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredBy?: Maybe<Scalars['String']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  EuropeanFlag?: Maybe<Scalars['String']>;
  ExpiredDate?: Maybe<Scalars['Float']>;
  FlatCancelDays?: Maybe<Scalars['Float']>;
  FlatCancelFee?: Maybe<Scalars['Float']>;
  FormName?: Maybe<Scalars['String']>;
  FriendlyDescription?: Maybe<Scalars['String']>;
  Group1?: Maybe<Scalars['String']>;
  Group1Description?: Maybe<Scalars['String']>;
  Group2?: Maybe<Scalars['String']>;
  Group2Description?: Maybe<Scalars['String']>;
  Group3?: Maybe<Scalars['String']>;
  Group3Description?: Maybe<Scalars['String']>;
  HeirarchyLevel?: Maybe<Scalars['Float']>;
  ImportFlag?: Maybe<Scalars['String']>;
  MinVehicleFleet?: Maybe<Scalars['Float']>;
  NewUsedBothCode?: Maybe<Scalars['String']>;
  OtherVehicleTypesFlag?: Maybe<Scalars['String']>;
  PlanCode?: Maybe<Scalars['String']>;
  PlanID?: Maybe<Scalars['Int']>;
  PlanType?: Maybe<Scalars['String']>;
  RecordStatusCode?: Maybe<Scalars['String']>;
  SubtractClaimsFlag?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['String']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "Plan" */
export type Plan_Mutation_Response = {
  __typename?: 'Plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plan>;
};

/** Ordering options when selecting data from "Plan". */
export type Plan_Order_By = {
  AsianFlag?: InputMaybe<Order_By>;
  BookState?: InputMaybe<Order_By>;
  CancelAfterDays?: InputMaybe<Order_By>;
  CancelBeforeAfterCode?: InputMaybe<Order_By>;
  CancelFee?: InputMaybe<Order_By>;
  CancelMethod?: InputMaybe<Order_By>;
  CancelMethodArray?: InputMaybe<Order_By>;
  CancelRule?: InputMaybe<Order_By>;
  CancelRuleArray?: InputMaybe<Order_By>;
  CompanyCode?: InputMaybe<Order_By>;
  CoverageOptionTypeCode?: InputMaybe<Order_By>;
  CoverageTypeCode?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DomesticFlag?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  EnteredBy?: InputMaybe<Order_By>;
  EnteredDate?: InputMaybe<Order_By>;
  EuropeanFlag?: InputMaybe<Order_By>;
  ExpiredDate?: InputMaybe<Order_By>;
  FlatCancelDays?: InputMaybe<Order_By>;
  FlatCancelFee?: InputMaybe<Order_By>;
  FormName?: InputMaybe<Order_By>;
  FriendlyDescription?: InputMaybe<Order_By>;
  Group1?: InputMaybe<Order_By>;
  Group1Description?: InputMaybe<Order_By>;
  Group2?: InputMaybe<Order_By>;
  Group2Description?: InputMaybe<Order_By>;
  Group3?: InputMaybe<Order_By>;
  Group3Description?: InputMaybe<Order_By>;
  HasDisappearingDeductible?: InputMaybe<Order_By>;
  HeirarchyLevel?: InputMaybe<Order_By>;
  ImportFlag?: InputMaybe<Order_By>;
  IsCPOLimitedWarrantyPlan?: InputMaybe<Order_By>;
  IsCPOMBPWrapPlan?: InputMaybe<Order_By>;
  IsCPOManufacturerWrapPlan?: InputMaybe<Order_By>;
  IsCPOWrapPlan?: InputMaybe<Order_By>;
  IsComplementaryPlan?: InputMaybe<Order_By>;
  IsForwardMotionPlan?: InputMaybe<Order_By>;
  IsGAPLeasePlan?: InputMaybe<Order_By>;
  IsGAPLoanPlan?: InputMaybe<Order_By>;
  IsLifetimeWrapPlan?: InputMaybe<Order_By>;
  IsLimitedLifetimeWarrantyPlan?: InputMaybe<Order_By>;
  IsLimitedWarrantyPlan?: InputMaybe<Order_By>;
  IsMSquaredPlan?: InputMaybe<Order_By>;
  IsMonthToMonthPlan?: InputMaybe<Order_By>;
  IsNewCarPlan?: InputMaybe<Order_By>;
  IsRoushPlan?: InputMaybe<Order_By>;
  IsShortTermLimitedWarrantyPlan?: InputMaybe<Order_By>;
  IsWrapPlan?: InputMaybe<Order_By>;
  MinVehicleFleet?: InputMaybe<Order_By>;
  NewUsedBothCode?: InputMaybe<Order_By>;
  OtherVehicleTypesFlag?: InputMaybe<Order_By>;
  PlanCode?: InputMaybe<Order_By>;
  PlanID?: InputMaybe<Order_By>;
  PlanType?: InputMaybe<Order_By>;
  RecordStatusCode?: InputMaybe<Order_By>;
  SubtractClaimsFlag?: InputMaybe<Order_By>;
  UpdatedBy?: InputMaybe<Order_By>;
  UpdatedDate?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Plan */
export type Plan_Pk_Columns_Input = {
  PlanID: Scalars['Int'];
};

/** select columns of table "Plan" */
export enum Plan_Select_Column {
  /** column name */
  AsianFlag = 'AsianFlag',
  /** column name */
  BookState = 'BookState',
  /** column name */
  CancelAfterDays = 'CancelAfterDays',
  /** column name */
  CancelBeforeAfterCode = 'CancelBeforeAfterCode',
  /** column name */
  CancelFee = 'CancelFee',
  /** column name */
  CancelMethod = 'CancelMethod',
  /** column name */
  CancelMethodArray = 'CancelMethodArray',
  /** column name */
  CancelRule = 'CancelRule',
  /** column name */
  CancelRuleArray = 'CancelRuleArray',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  CoverageOptionTypeCode = 'CoverageOptionTypeCode',
  /** column name */
  CoverageTypeCode = 'CoverageTypeCode',
  /** column name */
  Description = 'Description',
  /** column name */
  DomesticFlag = 'DomesticFlag',
  /** column name */
  EffectiveDate = 'EffectiveDate',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  EuropeanFlag = 'EuropeanFlag',
  /** column name */
  ExpiredDate = 'ExpiredDate',
  /** column name */
  FlatCancelDays = 'FlatCancelDays',
  /** column name */
  FlatCancelFee = 'FlatCancelFee',
  /** column name */
  FormName = 'FormName',
  /** column name */
  FriendlyDescription = 'FriendlyDescription',
  /** column name */
  Group1 = 'Group1',
  /** column name */
  Group1Description = 'Group1Description',
  /** column name */
  Group2 = 'Group2',
  /** column name */
  Group2Description = 'Group2Description',
  /** column name */
  Group3 = 'Group3',
  /** column name */
  Group3Description = 'Group3Description',
  /** column name */
  HasDisappearingDeductible = 'HasDisappearingDeductible',
  /** column name */
  HeirarchyLevel = 'HeirarchyLevel',
  /** column name */
  ImportFlag = 'ImportFlag',
  /** column name */
  IsCpoLimitedWarrantyPlan = 'IsCPOLimitedWarrantyPlan',
  /** column name */
  IsCpombpWrapPlan = 'IsCPOMBPWrapPlan',
  /** column name */
  IsCpoManufacturerWrapPlan = 'IsCPOManufacturerWrapPlan',
  /** column name */
  IsCpoWrapPlan = 'IsCPOWrapPlan',
  /** column name */
  IsComplementaryPlan = 'IsComplementaryPlan',
  /** column name */
  IsForwardMotionPlan = 'IsForwardMotionPlan',
  /** column name */
  IsGapLeasePlan = 'IsGAPLeasePlan',
  /** column name */
  IsGapLoanPlan = 'IsGAPLoanPlan',
  /** column name */
  IsLifetimeWrapPlan = 'IsLifetimeWrapPlan',
  /** column name */
  IsLimitedLifetimeWarrantyPlan = 'IsLimitedLifetimeWarrantyPlan',
  /** column name */
  IsLimitedWarrantyPlan = 'IsLimitedWarrantyPlan',
  /** column name */
  IsMSquaredPlan = 'IsMSquaredPlan',
  /** column name */
  IsMonthToMonthPlan = 'IsMonthToMonthPlan',
  /** column name */
  IsNewCarPlan = 'IsNewCarPlan',
  /** column name */
  IsRoushPlan = 'IsRoushPlan',
  /** column name */
  IsShortTermLimitedWarrantyPlan = 'IsShortTermLimitedWarrantyPlan',
  /** column name */
  IsWrapPlan = 'IsWrapPlan',
  /** column name */
  MinVehicleFleet = 'MinVehicleFleet',
  /** column name */
  NewUsedBothCode = 'NewUsedBothCode',
  /** column name */
  OtherVehicleTypesFlag = 'OtherVehicleTypesFlag',
  /** column name */
  PlanCode = 'PlanCode',
  /** column name */
  PlanId = 'PlanID',
  /** column name */
  PlanType = 'PlanType',
  /** column name */
  RecordStatusCode = 'RecordStatusCode',
  /** column name */
  SubtractClaimsFlag = 'SubtractClaimsFlag',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate'
}

/** input type for updating data in table "Plan" */
export type Plan_Set_Input = {
  AsianFlag?: InputMaybe<Scalars['String']>;
  BookState?: InputMaybe<Scalars['String']>;
  CancelAfterDays?: InputMaybe<Scalars['Float']>;
  CancelBeforeAfterCode?: InputMaybe<Scalars['String']>;
  CancelFee?: InputMaybe<Scalars['Float']>;
  CancelMethod?: InputMaybe<Scalars['Float']>;
  CancelMethodArray?: InputMaybe<Scalars['String']>;
  CancelRule?: InputMaybe<Scalars['Float']>;
  CancelRuleArray?: InputMaybe<Scalars['String']>;
  CompanyCode?: InputMaybe<Scalars['String']>;
  CoverageOptionTypeCode?: InputMaybe<Scalars['String']>;
  CoverageTypeCode?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DomesticFlag?: InputMaybe<Scalars['String']>;
  EffectiveDate?: InputMaybe<Scalars['Float']>;
  EnteredBy?: InputMaybe<Scalars['String']>;
  EnteredDate?: InputMaybe<Scalars['Float']>;
  EuropeanFlag?: InputMaybe<Scalars['String']>;
  ExpiredDate?: InputMaybe<Scalars['Float']>;
  FlatCancelDays?: InputMaybe<Scalars['Float']>;
  FlatCancelFee?: InputMaybe<Scalars['Float']>;
  FormName?: InputMaybe<Scalars['String']>;
  FriendlyDescription?: InputMaybe<Scalars['String']>;
  Group1?: InputMaybe<Scalars['String']>;
  Group1Description?: InputMaybe<Scalars['String']>;
  Group2?: InputMaybe<Scalars['String']>;
  Group2Description?: InputMaybe<Scalars['String']>;
  Group3?: InputMaybe<Scalars['String']>;
  Group3Description?: InputMaybe<Scalars['String']>;
  HasDisappearingDeductible?: InputMaybe<Scalars['Boolean']>;
  HeirarchyLevel?: InputMaybe<Scalars['Float']>;
  ImportFlag?: InputMaybe<Scalars['String']>;
  IsCPOLimitedWarrantyPlan?: InputMaybe<Scalars['Boolean']>;
  IsCPOMBPWrapPlan?: InputMaybe<Scalars['Boolean']>;
  IsCPOManufacturerWrapPlan?: InputMaybe<Scalars['Boolean']>;
  IsCPOWrapPlan?: InputMaybe<Scalars['Boolean']>;
  IsComplementaryPlan?: InputMaybe<Scalars['Boolean']>;
  IsForwardMotionPlan?: InputMaybe<Scalars['Boolean']>;
  IsGAPLeasePlan?: InputMaybe<Scalars['Boolean']>;
  IsGAPLoanPlan?: InputMaybe<Scalars['Boolean']>;
  IsLifetimeWrapPlan?: InputMaybe<Scalars['Boolean']>;
  IsLimitedLifetimeWarrantyPlan?: InputMaybe<Scalars['Boolean']>;
  IsLimitedWarrantyPlan?: InputMaybe<Scalars['Boolean']>;
  IsMSquaredPlan?: InputMaybe<Scalars['Boolean']>;
  IsMonthToMonthPlan?: InputMaybe<Scalars['Boolean']>;
  IsNewCarPlan?: InputMaybe<Scalars['Boolean']>;
  IsRoushPlan?: InputMaybe<Scalars['Boolean']>;
  IsShortTermLimitedWarrantyPlan?: InputMaybe<Scalars['Boolean']>;
  IsWrapPlan?: InputMaybe<Scalars['Boolean']>;
  MinVehicleFleet?: InputMaybe<Scalars['Float']>;
  NewUsedBothCode?: InputMaybe<Scalars['String']>;
  OtherVehicleTypesFlag?: InputMaybe<Scalars['String']>;
  PlanCode?: InputMaybe<Scalars['String']>;
  PlanType?: InputMaybe<Scalars['String']>;
  RecordStatusCode?: InputMaybe<Scalars['String']>;
  SubtractClaimsFlag?: InputMaybe<Scalars['String']>;
  UpdatedBy?: InputMaybe<Scalars['String']>;
  UpdatedDate?: InputMaybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Plan_Stddev_Fields = {
  __typename?: 'Plan_stddev_fields';
  CancelAfterDays?: Maybe<Scalars['Float']>;
  CancelFee?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpiredDate?: Maybe<Scalars['Float']>;
  FlatCancelDays?: Maybe<Scalars['Float']>;
  FlatCancelFee?: Maybe<Scalars['Float']>;
  HeirarchyLevel?: Maybe<Scalars['Float']>;
  MinVehicleFleet?: Maybe<Scalars['Float']>;
  PlanID?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Plan_Stddev_Pop_Fields = {
  __typename?: 'Plan_stddev_pop_fields';
  CancelAfterDays?: Maybe<Scalars['Float']>;
  CancelFee?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpiredDate?: Maybe<Scalars['Float']>;
  FlatCancelDays?: Maybe<Scalars['Float']>;
  FlatCancelFee?: Maybe<Scalars['Float']>;
  HeirarchyLevel?: Maybe<Scalars['Float']>;
  MinVehicleFleet?: Maybe<Scalars['Float']>;
  PlanID?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Plan_Stddev_Samp_Fields = {
  __typename?: 'Plan_stddev_samp_fields';
  CancelAfterDays?: Maybe<Scalars['Float']>;
  CancelFee?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpiredDate?: Maybe<Scalars['Float']>;
  FlatCancelDays?: Maybe<Scalars['Float']>;
  FlatCancelFee?: Maybe<Scalars['Float']>;
  HeirarchyLevel?: Maybe<Scalars['Float']>;
  MinVehicleFleet?: Maybe<Scalars['Float']>;
  PlanID?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Plan_Sum_Fields = {
  __typename?: 'Plan_sum_fields';
  CancelAfterDays?: Maybe<Scalars['Float']>;
  CancelFee?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpiredDate?: Maybe<Scalars['Float']>;
  FlatCancelDays?: Maybe<Scalars['Float']>;
  FlatCancelFee?: Maybe<Scalars['Float']>;
  HeirarchyLevel?: Maybe<Scalars['Float']>;
  MinVehicleFleet?: Maybe<Scalars['Float']>;
  PlanID?: Maybe<Scalars['Int']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** update columns of table "Plan" */
export enum Plan_Update_Column {
  /** column name */
  AsianFlag = 'AsianFlag',
  /** column name */
  BookState = 'BookState',
  /** column name */
  CancelAfterDays = 'CancelAfterDays',
  /** column name */
  CancelBeforeAfterCode = 'CancelBeforeAfterCode',
  /** column name */
  CancelFee = 'CancelFee',
  /** column name */
  CancelMethod = 'CancelMethod',
  /** column name */
  CancelMethodArray = 'CancelMethodArray',
  /** column name */
  CancelRule = 'CancelRule',
  /** column name */
  CancelRuleArray = 'CancelRuleArray',
  /** column name */
  CompanyCode = 'CompanyCode',
  /** column name */
  CoverageOptionTypeCode = 'CoverageOptionTypeCode',
  /** column name */
  CoverageTypeCode = 'CoverageTypeCode',
  /** column name */
  Description = 'Description',
  /** column name */
  DomesticFlag = 'DomesticFlag',
  /** column name */
  EffectiveDate = 'EffectiveDate',
  /** column name */
  EnteredBy = 'EnteredBy',
  /** column name */
  EnteredDate = 'EnteredDate',
  /** column name */
  EuropeanFlag = 'EuropeanFlag',
  /** column name */
  ExpiredDate = 'ExpiredDate',
  /** column name */
  FlatCancelDays = 'FlatCancelDays',
  /** column name */
  FlatCancelFee = 'FlatCancelFee',
  /** column name */
  FormName = 'FormName',
  /** column name */
  FriendlyDescription = 'FriendlyDescription',
  /** column name */
  Group1 = 'Group1',
  /** column name */
  Group1Description = 'Group1Description',
  /** column name */
  Group2 = 'Group2',
  /** column name */
  Group2Description = 'Group2Description',
  /** column name */
  Group3 = 'Group3',
  /** column name */
  Group3Description = 'Group3Description',
  /** column name */
  HasDisappearingDeductible = 'HasDisappearingDeductible',
  /** column name */
  HeirarchyLevel = 'HeirarchyLevel',
  /** column name */
  ImportFlag = 'ImportFlag',
  /** column name */
  IsCpoLimitedWarrantyPlan = 'IsCPOLimitedWarrantyPlan',
  /** column name */
  IsCpombpWrapPlan = 'IsCPOMBPWrapPlan',
  /** column name */
  IsCpoManufacturerWrapPlan = 'IsCPOManufacturerWrapPlan',
  /** column name */
  IsCpoWrapPlan = 'IsCPOWrapPlan',
  /** column name */
  IsComplementaryPlan = 'IsComplementaryPlan',
  /** column name */
  IsForwardMotionPlan = 'IsForwardMotionPlan',
  /** column name */
  IsGapLeasePlan = 'IsGAPLeasePlan',
  /** column name */
  IsGapLoanPlan = 'IsGAPLoanPlan',
  /** column name */
  IsLifetimeWrapPlan = 'IsLifetimeWrapPlan',
  /** column name */
  IsLimitedLifetimeWarrantyPlan = 'IsLimitedLifetimeWarrantyPlan',
  /** column name */
  IsLimitedWarrantyPlan = 'IsLimitedWarrantyPlan',
  /** column name */
  IsMSquaredPlan = 'IsMSquaredPlan',
  /** column name */
  IsMonthToMonthPlan = 'IsMonthToMonthPlan',
  /** column name */
  IsNewCarPlan = 'IsNewCarPlan',
  /** column name */
  IsRoushPlan = 'IsRoushPlan',
  /** column name */
  IsShortTermLimitedWarrantyPlan = 'IsShortTermLimitedWarrantyPlan',
  /** column name */
  IsWrapPlan = 'IsWrapPlan',
  /** column name */
  MinVehicleFleet = 'MinVehicleFleet',
  /** column name */
  NewUsedBothCode = 'NewUsedBothCode',
  /** column name */
  OtherVehicleTypesFlag = 'OtherVehicleTypesFlag',
  /** column name */
  PlanCode = 'PlanCode',
  /** column name */
  PlanType = 'PlanType',
  /** column name */
  RecordStatusCode = 'RecordStatusCode',
  /** column name */
  SubtractClaimsFlag = 'SubtractClaimsFlag',
  /** column name */
  UpdatedBy = 'UpdatedBy',
  /** column name */
  UpdatedDate = 'UpdatedDate'
}

/** aggregate var_pop on columns */
export type Plan_Var_Pop_Fields = {
  __typename?: 'Plan_var_pop_fields';
  CancelAfterDays?: Maybe<Scalars['Float']>;
  CancelFee?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpiredDate?: Maybe<Scalars['Float']>;
  FlatCancelDays?: Maybe<Scalars['Float']>;
  FlatCancelFee?: Maybe<Scalars['Float']>;
  HeirarchyLevel?: Maybe<Scalars['Float']>;
  MinVehicleFleet?: Maybe<Scalars['Float']>;
  PlanID?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Plan_Var_Samp_Fields = {
  __typename?: 'Plan_var_samp_fields';
  CancelAfterDays?: Maybe<Scalars['Float']>;
  CancelFee?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpiredDate?: Maybe<Scalars['Float']>;
  FlatCancelDays?: Maybe<Scalars['Float']>;
  FlatCancelFee?: Maybe<Scalars['Float']>;
  HeirarchyLevel?: Maybe<Scalars['Float']>;
  MinVehicleFleet?: Maybe<Scalars['Float']>;
  PlanID?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Plan_Variance_Fields = {
  __typename?: 'Plan_variance_fields';
  CancelAfterDays?: Maybe<Scalars['Float']>;
  CancelFee?: Maybe<Scalars['Float']>;
  CancelMethod?: Maybe<Scalars['Float']>;
  CancelRule?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['Float']>;
  EnteredDate?: Maybe<Scalars['Float']>;
  ExpiredDate?: Maybe<Scalars['Float']>;
  FlatCancelDays?: Maybe<Scalars['Float']>;
  FlatCancelFee?: Maybe<Scalars['Float']>;
  HeirarchyLevel?: Maybe<Scalars['Float']>;
  MinVehicleFleet?: Maybe<Scalars['Float']>;
  PlanID?: Maybe<Scalars['Float']>;
  UpdatedDate?: Maybe<Scalars['Float']>;
};

export type PolicyClaim_AssetMetadata = {
  __typename?: 'PolicyClaim_AssetMetadata';
  ClaimMileage: Scalars['numeric'];
  ineligibleVehicleTypeId: Scalars['String'];
};

export type PolicyClaim_Metadata = {
  __typename?: 'PolicyClaim_Metadata';
  isFromConversion?: Maybe<Scalars['Boolean']>;
};

export type PolicyContractAsset_IdentifierMetadata_Vehicle = {
  __typename?: 'PolicyContractAsset_IdentifierMetadata_Vehicle';
  vin: Scalars['String'];
};

export type PolicyContractCostDetail_CostMetadata = {
  __typename?: 'PolicyContractCostDetail_CostMetadata';
  dealerCostMarkupAmount?: Maybe<Scalars['numeric']>;
  remittanceCostMarkupAmount: Scalars['numeric'];
  remittanceOverrideAmount?: Maybe<Scalars['numeric']>;
};

export type PolicyContractQuote_ProductOptionsMetadata = {
  __typename?: 'PolicyContractQuote_ProductOptionsMetadata';
  coverageMiles: Scalars['Int'];
  coverageMonths: Scalars['Int'];
  customerPrice: Scalars['numeric'];
  deductibleAmount: Scalars['numeric'];
  expirationDate?: Maybe<Scalars['date']>;
  expirationMiles?: Maybe<Scalars['Int']>;
  includesCosmeticCoverageOption: Scalars['Boolean'];
  includesDentCoverageOption: Scalars['Boolean'];
  includesKeyCoverageOption: Scalars['Boolean'];
  includesTireCoverageOption: Scalars['Boolean'];
  includesWindshieldCoverageOption: Scalars['Boolean'];
  optionalCoverages?: Maybe<Array<QuoteResultMetadata_OptionalCoverage>>;
  planGroupName?: Maybe<Scalars['String']>;
  planIdentifier: Scalars['String'];
  planName?: Maybe<Scalars['String']>;
  planSubGroupName?: Maybe<Scalars['String']>;
};

export type PolicyContract_AssetMetadata = {
  __typename?: 'PolicyContract_AssetMetadata';
  hasAftermarketModifications?: Maybe<Scalars['Boolean']>;
  mileage: Scalars['Int'];
  vehicleClassCode?: Maybe<Scalars['String']>;
  vehiclePurchasePrice: Scalars['numeric'];
  vehicleStatusType?: Maybe<Scalars['numeric']>;
};

export type PolicyContract_ObligorMetadata = {
  __typename?: 'PolicyContract_ObligorMetadata';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  contactDescription?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactFax?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type PolicyContract_OptionalCoverageMetadata = {
  __typename?: 'PolicyContract_OptionalCoverageMetadata';
  amount: Scalars['numeric'];
  name?: Maybe<Scalars['String']>;
  optionalCoverageIdentifier: Scalars['Int'];
  surchargeTypeId: Scalars['Int'];
};

export type PolicyContract_ProductMetadata = {
  __typename?: 'PolicyContract_ProductMetadata';
  configurationItems?: Maybe<QuoteResultMetadata_PlanConfigurationItems>;
  coverageMiles: Scalars['Int'];
  coverageMonths: Scalars['Int'];
  coverageTypeCode?: Maybe<Scalars['String']>;
  deductible: Scalars['numeric'];
  deductibleType: Scalars['Int'];
  formCode?: Maybe<Scalars['String']>;
  includesCosmeticCoverageOption?: Maybe<Scalars['Boolean']>;
  includesDentCoverageOption?: Maybe<Scalars['Boolean']>;
  includesKeyCoverageOption?: Maybe<Scalars['Boolean']>;
  includesSafeLinkTheftOption?: Maybe<Scalars['Boolean']>;
  includesTireCoverageOption?: Maybe<Scalars['Boolean']>;
  includesWindshieldCoverageOption?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  planCode?: Maybe<Scalars['String']>;
  totalAllowableLeaseMiles?: Maybe<Scalars['Int']>;
};

export type PolicyContract_SurchageMetadata = {
  __typename?: 'PolicyContract_SurchageMetadata';
  amount: Scalars['numeric'];
  surchargeTypeId: Scalars['Int'];
};

/** aggregate fields of "vpic.pretensioner" */
export type Pretensioner_Aggregate_Fields_Vpic = {
  __typename?: 'Pretensioner_aggregate_fields_vpic';
  avg?: Maybe<Pretensioner_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Pretensioner_Max_Fields_Vpic>;
  min?: Maybe<Pretensioner_Min_Fields_Vpic>;
  stddev?: Maybe<Pretensioner_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Pretensioner_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Pretensioner_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Pretensioner_Sum_Fields_Vpic>;
  var_pop?: Maybe<Pretensioner_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Pretensioner_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Pretensioner_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.pretensioner" */
export type Pretensioner_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Pretensioner_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.pretensioner" */
export type Pretensioner_Aggregate_Vpic = {
  __typename?: 'Pretensioner_aggregate_vpic';
  aggregate?: Maybe<Pretensioner_Aggregate_Fields_Vpic>;
  nodes: Array<Pretensioner_Vpic>;
};

/** aggregate avg on columns */
export type Pretensioner_Avg_Fields_Vpic = {
  __typename?: 'Pretensioner_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.pretensioner". All fields are combined with a logical 'AND'. */
export type Pretensioner_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Pretensioner_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Pretensioner_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Pretensioner_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.pretensioner" */
export enum Pretensioner_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkPretensioner = 'pk_pretensioner',
  /** unique or primary key constraint on columns "name" */
  UPretensionername = 'u_pretensionername'
}

/** input type for incrementing numeric columns in table "vpic.pretensioner" */
export type Pretensioner_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.pretensioner" */
export type Pretensioner_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Pretensioner_Max_Fields_Vpic = {
  __typename?: 'Pretensioner_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Pretensioner_Min_Fields_Vpic = {
  __typename?: 'Pretensioner_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.pretensioner" */
export type Pretensioner_Mutation_Response_Vpic = {
  __typename?: 'Pretensioner_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pretensioner_Vpic>;
};

/** on_conflict condition type for table "vpic.pretensioner" */
export type Pretensioner_On_Conflict_Vpic = {
  constraint: Pretensioner_Constraint_Vpic;
  update_columns?: Array<Pretensioner_Update_Column_Vpic>;
  where?: InputMaybe<Pretensioner_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.pretensioner". */
export type Pretensioner_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.pretensioner */
export type Pretensioner_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.pretensioner" */
export enum Pretensioner_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.pretensioner" */
export type Pretensioner_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Pretensioner_Stddev_Fields_Vpic = {
  __typename?: 'Pretensioner_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pretensioner_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Pretensioner_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pretensioner_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Pretensioner_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Pretensioner" */
export type Pretensioner_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Pretensioner_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Pretensioner_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Pretensioner_Sum_Fields_Vpic = {
  __typename?: 'Pretensioner_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.pretensioner" */
export enum Pretensioner_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type Pretensioner_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pretensioner_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pretensioner_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Pretensioner_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Pretensioner_Var_Pop_Fields_Vpic = {
  __typename?: 'Pretensioner_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pretensioner_Var_Samp_Fields_Vpic = {
  __typename?: 'Pretensioner_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pretensioner_Variance_Fields_Vpic = {
  __typename?: 'Pretensioner_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.pretensioner" */
export type Pretensioner_Vpic = {
  __typename?: 'Pretensioner_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type QuoteEditMetadata = {
  __typename?: 'QuoteEditMetadata';
  activeProgramCode?: Maybe<Scalars['String']>;
  customer?: Maybe<QuoteEditMetadata_Customer>;
  dealerRepresentative?: Maybe<Scalars['String']>;
  filters?: Maybe<QuoteEditMetadata_Filters>;
  finance?: Maybe<QuoteEditMetadata_Finance>;
  isFinalizingGap?: Maybe<Scalars['Boolean']>;
  lender?: Maybe<QuoteEditMetadata_Lender>;
  menu?: Maybe<QuoteEditMetadata_Menu>;
  programs?: Maybe<QuoteEditMetadata_Programs>;
  quoteForm?: Maybe<QuoteEditMetadata_QuoteForm>;
  trainingMode?: Maybe<Scalars['Boolean']>;
};

export type QuoteEditMetadata_Customer = {
  __typename?: 'QuoteEditMetadata_Customer';
  customer?: Maybe<QuoteEditMetadata_CustomerInfo>;
  form?: Maybe<QuoteEditMetadata_CustomerForm>;
  submitted?: Maybe<Scalars['Boolean']>;
};

export type QuoteEditMetadata_CustomerForm = {
  __typename?: 'QuoteEditMetadata_CustomerForm';
  dirty?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['jsonb']>;
  model?: Maybe<QuoteEditMetadata_CustomerInfo>;
  status?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_CustomerInfo = {
  __typename?: 'QuoteEditMetadata_CustomerInfo';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstDOB?: Maybe<Scalars['date']>;
  firstName?: Maybe<Scalars['String']>;
  hasAdditionalName?: Maybe<Scalars['Boolean']>;
  homePhone?: Maybe<Scalars['String']>;
  homePhoneNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  secondaryFirstName?: Maybe<Scalars['String']>;
  secondaryLastName?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_DecodedVinVehicleInformation = {
  __typename?: 'QuoteEditMetadata_DecodedVinVehicleInformation';
  availableTrims?: Maybe<Array<Maybe<QuoteEditMetadata_VehicleTrim>>>;
  bodyStyleName?: Maybe<Scalars['String']>;
  cubicInchesAbbreviation?: Maybe<Scalars['String']>;
  cylindersAbbreviation?: Maybe<Scalars['String']>;
  cylindersNumber: Scalars['Int'];
  drivingWheelsCode?: Maybe<Scalars['String']>;
  drivingWheelsDescription?: Maybe<Scalars['String']>;
  fuelDeliveryCode?: Maybe<Scalars['String']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  fuelTypeDescription?: Maybe<Scalars['String']>;
  hasMBPCertificationAvailable?: Maybe<Scalars['Boolean']>;
  hasSupercharger?: Maybe<Scalars['Boolean']>;
  hasTurbo?: Maybe<Scalars['Boolean']>;
  inServiceDate?: Maybe<Scalars['date']>;
  isDiesel?: Maybe<Scalars['Boolean']>;
  isElectric?: Maybe<Scalars['Boolean']>;
  isFourWheelDrive?: Maybe<Scalars['Boolean']>;
  isGas?: Maybe<Scalars['Boolean']>;
  isHybrid?: Maybe<Scalars['Boolean']>;
  isOneTon?: Maybe<Scalars['Boolean']>;
  makeAbbreviation?: Maybe<Scalars['String']>;
  makeCode?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  mileage: Scalars['Int'];
  modelCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving: Scalars['Int'];
  purchasePrice?: Maybe<Scalars['numeric']>;
  saleMileage: Scalars['Int'];
  transmissionCode?: Maybe<Scalars['String']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  vehicleYear: Scalars['Int'];
  vin?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_Errors = {
  __typename?: 'QuoteEditMetadata_Errors';
  cylinders?: Maybe<Scalars['String']>;
  dealer?: Maybe<Scalars['String']>;
  drivingWheels?: Maybe<Scalars['String']>;
  fuelType?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['String']>;
  quoteResponse?: Maybe<Array<Maybe<QuoteEditMetadata_QuoteResponse>>>;
  status?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_Filters = {
  __typename?: 'QuoteEditMetadata_Filters';
  deductibles?: Maybe<Array<Maybe<Scalars['numeric']>>>;
  miles?: Maybe<Array<Maybe<Scalars['numeric']>>>;
  months?: Maybe<Array<Maybe<Scalars['numeric']>>>;
};

export type QuoteEditMetadata_Finance = {
  __typename?: 'QuoteEditMetadata_Finance';
  dealerCoversFee?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<QuoteEditMetadata_FinanceErrors>;
  form?: Maybe<QuoteEditMetadata_FinanceForm>;
  submitted?: Maybe<Scalars['Boolean']>;
  useMBPFinance?: Maybe<Scalars['Boolean']>;
};

export type QuoteEditMetadata_FinanceErrors = {
  __typename?: 'QuoteEditMetadata_FinanceErrors';
  cardExpiration?: Maybe<Scalars['String']>;
  cardHolderName?: Maybe<Scalars['String']>;
  cardNumber?: Maybe<Scalars['String']>;
  financePlans?: Maybe<Scalars['jsonb']>;
  firstPaymentDate?: Maybe<Scalars['String']>;
  genericError?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_FinanceForm = {
  __typename?: 'QuoteEditMetadata_FinanceForm';
  cardExpiration?: Maybe<Scalars['String']>;
  cardHolderName?: Maybe<Scalars['String']>;
  cardNumber?: Maybe<Scalars['String']>;
  financePlans?: Maybe<Scalars['jsonb']>;
  firstPaymentDate?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_Form = {
  __typename?: 'QuoteEditMetadata_Form';
  cylinders?: Maybe<Scalars['numeric']>;
  dealerCode?: Maybe<Scalars['String']>;
  drivingWheelsCode?: Maybe<Scalars['String']>;
  electiveSurcharges?: Maybe<Array<Maybe<Scalars['numeric']>>>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  hasRoushAftermarketModifications?: Maybe<Scalars['Boolean']>;
  hasTurbo?: Maybe<Scalars['Boolean']>;
  makeCode?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['numeric']>;
  modelName?: Maybe<Scalars['String']>;
  programs?: Maybe<Array<Maybe<Scalars['Int']>>>;
  purchaseDate?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_GapForm = {
  __typename?: 'QuoteEditMetadata_GapForm';
  dirty?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['jsonb']>;
  model?: Maybe<QuoteEditMetadata_GapFormModel>;
  status?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_GapFormModel = {
  __typename?: 'QuoteEditMetadata_GapFormModel';
  interestRate?: Maybe<Scalars['numeric']>;
  loanContractType?: Maybe<Scalars['Int']>;
  monthlyPaymentAmount?: Maybe<Scalars['numeric']>;
  totalFinanceAmount?: Maybe<Scalars['numeric']>;
};

export type QuoteEditMetadata_Lender = {
  __typename?: 'QuoteEditMetadata_Lender';
  created?: Maybe<QuoteEditMetadata_LenderInfo>;
  deleted?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['jsonb']>;
  form?: Maybe<QuoteEditMetadata_LenderForm>;
  gapForm?: Maybe<QuoteEditMetadata_GapForm>;
  gapLender?: Maybe<QuoteEditMetadata_LenderInfo>;
  isSetupForMBPFinance?: Maybe<Scalars['Boolean']>;
  list?: Maybe<Array<Maybe<QuoteEditMetadata_LenderInfo>>>;
  loanContractTypes?: Maybe<Array<Maybe<QuoteEditMetadata_LoanContractTypes>>>;
  mbpFinanceLender?: Maybe<QuoteEditMetadata_LenderInfo>;
  selected?: Maybe<QuoteEditMetadata_LenderInfo>;
};

export type QuoteEditMetadata_LenderForm = {
  __typename?: 'QuoteEditMetadata_LenderForm';
  action?: Maybe<Scalars['Int']>;
  actionDisplay?: Maybe<Scalars['String']>;
  dirty?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Scalars['jsonb']>;
  model?: Maybe<QuoteEditMetadata_LenderInfo>;
  open?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_LenderInfo = {
  __typename?: 'QuoteEditMetadata_LenderInfo';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  dealerCode?: Maybe<Scalars['String']>;
  dealerLenderID?: Maybe<Scalars['Int']>;
  interestRate?: Maybe<Scalars['numeric']>;
  isGenericLender?: Maybe<Scalars['Boolean']>;
  isMBPFinanceLender?: Maybe<Scalars['Boolean']>;
  loanContractType?: Maybe<Scalars['Int']>;
  monthlyPaymentAmount?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  programCode?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  totalFinanceAmount?: Maybe<Scalars['numeric']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_LoanContractTypes = {
  __typename?: 'QuoteEditMetadata_LoanContractTypes';
  loanContractType?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type QuoteEditMetadata_Menu = {
  __typename?: 'QuoteEditMetadata_Menu';
  cashDownAmount?: Maybe<Scalars['numeric']>;
  generatedPdf?: Maybe<Scalars['Boolean']>;
  loanTermMonths?: Maybe<Scalars['numeric']>;
  loanTermMonths2?: Maybe<Scalars['numeric']>;
  loanTermRatePercent?: Maybe<Scalars['numeric']>;
  loanTermRatePercent2?: Maybe<Scalars['numeric']>;
  payoffAmount?: Maybe<Scalars['numeric']>;
  rebateAmount?: Maybe<Scalars['numeric']>;
  taxOverrideAmount?: Maybe<Scalars['numeric']>;
  tradeInAmount?: Maybe<Scalars['numeric']>;
};

export type QuoteEditMetadata_Programs = {
  __typename?: 'QuoteEditMetadata_Programs';
  additionalInfos?: Maybe<Scalars['jsonb']>;
  priceAdjustments?: Maybe<Scalars['jsonb']>;
  selectedCoverages?: Maybe<Scalars['jsonb']>;
  selectedOptionalCoverages?: Maybe<Scalars['jsonb']>;
  selectedOptions?: Maybe<Scalars['jsonb']>;
  selectedPlans?: Maybe<Scalars['jsonb']>;
};

export type QuoteEditMetadata_QuoteForm = {
  __typename?: 'QuoteEditMetadata_QuoteForm';
  decodedVinVehicleInformation?: Maybe<QuoteEditMetadata_DecodedVinVehicleInformation>;
  enterVehicleByType?: Maybe<Scalars['Int']>;
  errors?: Maybe<QuoteEditMetadata_Errors>;
  form?: Maybe<QuoteEditMetadata_Form>;
  submitted?: Maybe<Scalars['Boolean']>;
};

export type QuoteEditMetadata_QuoteResponse = {
  __typename?: 'QuoteEditMetadata_QuoteResponse';
  friendlyMessage?: Maybe<Scalars['String']>;
  fullMessage?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
};

export type QuoteEditMetadata_VehicleTrim = {
  __typename?: 'QuoteEditMetadata_VehicleTrim';
  trimName?: Maybe<Scalars['String']>;
};

export type QuoteMetadata = {
  __typename?: 'QuoteMetadata';
  dealerCode?: Maybe<Scalars['String']>;
  dealerRepresentativeName?: Maybe<Scalars['String']>;
  electiveSurcharges?: Maybe<Array<Scalars['Int']>>;
  enterVehicleByType: Scalars['Int'];
  expectedDrivingMilesPerYear?: Maybe<Scalars['Int']>;
  expectedOwnershipYears?: Maybe<Scalars['Int']>;
  factoryWarrantyCoverageMiles?: Maybe<Scalars['Int']>;
  factoryWarrantyCoverageMonths?: Maybe<Scalars['Int']>;
  factoryWarrantyInServiceDate?: Maybe<Scalars['date']>;
  hasBeenPurchased?: Maybe<Scalars['Boolean']>;
  hasRoushAftermarketModifications?: Maybe<Scalars['Boolean']>;
  inServiceDate?: Maybe<Scalars['date']>;
  legacyAccountProfileUsername?: Maybe<Scalars['String']>;
  mileage: Scalars['numeric'];
  programTypes?: Maybe<Array<Scalars['Int']>>;
  purchaseDate: Scalars['date'];
  useSefi: Scalars['Boolean'];
  username?: Maybe<Scalars['String']>;
  vehicleCubicCentimeters?: Maybe<Scalars['Int']>;
  vehicleCylinders?: Maybe<Scalars['Int']>;
  vehicleDrivingWheelsCode?: Maybe<Scalars['String']>;
  vehicleFuelTypeCode?: Maybe<Scalars['String']>;
  vehicleHasTurbo: Scalars['Boolean'];
  vehicleMakeCode?: Maybe<Scalars['String']>;
  vehicleModelName?: Maybe<Scalars['String']>;
  vehiclePurchasePrice: Scalars['numeric'];
  vehicleStatusType: Scalars['Int'];
  vehicleTrim?: Maybe<Scalars['String']>;
  vehicleType?: Maybe<Scalars['Int']>;
  vehicleYear?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
};

export type QuoteResultMetadata = {
  __typename?: 'QuoteResultMetadata';
  availableCoverageMiles?: Maybe<Array<Maybe<QuoteResultMetadata_RefineByValue>>>;
  availableCoverageMonths?: Maybe<Array<Maybe<QuoteResultMetadata_RefineByValue>>>;
  availableDeductibles?: Maybe<Array<Maybe<QuoteResultMetadata_RefineByValue>>>;
  contractNumber?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<QuoteResultMetadata_Error>>>;
  expirationDate: Scalars['date'];
  fromSEFI: Scalars['Boolean'];
  originalQuoteRequest?: Maybe<QuoteResultMetadata_OriginalQuoteRequest>;
  programs?: Maybe<Array<Maybe<QuoteResultMetadata_Program>>>;
  purchasedContractID?: Maybe<Scalars['String']>;
  refinedCoverageMiles?: Maybe<Array<Scalars['Int']>>;
  refinedCoverageMonths?: Maybe<Array<Scalars['Int']>>;
  refinedDeductibles?: Maybe<Array<Scalars['numeric']>>;
  responseID?: Maybe<Scalars['String']>;
  savedContractInfo?: Maybe<QuoteResultMetadata_SavedContractInfo>;
  savedQuoteID?: Maybe<Scalars['String']>;
  vehicleInformation?: Maybe<QuoteResultMetadata_VehicleInformation>;
  vin?: Maybe<Scalars['String']>;
};

export type QuoteResultMetadata_Bucket = {
  __typename?: 'QuoteResultMetadata_Bucket';
  rateBucketTypeName?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['numeric']>;
};

export type QuoteResultMetadata_Coverage = {
  __typename?: 'QuoteResultMetadata_Coverage';
  coverageMonths?: Maybe<Scalars['Int']>;
  display?: Maybe<Scalars['String']>;
};

export type QuoteResultMetadata_Disbursement = {
  __typename?: 'QuoteResultMetadata_Disbursement';
  amount?: Maybe<Scalars['numeric']>;
  code?: Maybe<Scalars['String']>;
  disbursementTypeName?: Maybe<Scalars['String']>;
};

export type QuoteResultMetadata_Error = {
  __typename?: 'QuoteResultMetadata_Error';
  friendlyMessage?: Maybe<Scalars['String']>;
  fullMessage?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
};

export type QuoteResultMetadata_Group = {
  __typename?: 'QuoteResultMetadata_Group';
  deductibleAmounts?: Maybe<Array<Scalars['numeric']>>;
  displayOrder: Scalars['Int'];
  hasSubGroups: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  plans?: Maybe<Array<Maybe<QuoteResultMetadata_GroupPlanGroup>>>;
};

export type QuoteResultMetadata_GroupPlanGroup = {
  __typename?: 'QuoteResultMetadata_GroupPlanGroup';
  coverageMiles: Scalars['Int'];
  coverageMonths: Scalars['Int'];
  expirationDate?: Maybe<Scalars['date']>;
  expirationMiles?: Maybe<Scalars['Int']>;
  includesCosmeticCoverageOption: Scalars['Boolean'];
  includesDentCoverageOption: Scalars['Boolean'];
  includesKeyCoverageOption: Scalars['Boolean'];
  includesTireCoverageOption: Scalars['Boolean'];
  includesWindshieldCoverageOption: Scalars['Boolean'];
  plans?: Maybe<Array<Maybe<QuoteResultMetadata_GroupPlanGroupPlan>>>;
  preloadPlans?: Maybe<Array<Maybe<QuoteResultMetadata_GroupPlanGroupPlan>>>;
  secondaryExpirationDate?: Maybe<Scalars['date']>;
  secondaryExpirationMiles?: Maybe<Scalars['Int']>;
  subGroupDisplayOrder: Scalars['Int'];
  subGroupName?: Maybe<Scalars['String']>;
};

export type QuoteResultMetadata_GroupPlanGroupPlan = {
  __typename?: 'QuoteResultMetadata_GroupPlanGroupPlan';
  adminAmount: Scalars['numeric'];
  coverageMiles: Scalars['Int'];
  coverageMonths: Scalars['Int'];
  customerPrice: Scalars['numeric'];
  dealerCost: Scalars['numeric'];
  deductibleAmount: Scalars['numeric'];
  deductibleType: Scalars['Int'];
  deductibleTypeDescription?: Maybe<Scalars['String']>;
  disbursementAmount: Scalars['numeric'];
  groupSuffix?: Maybe<Scalars['String']>;
  includesCosmeticCoverageOption: Scalars['Boolean'];
  includesDentCoverageOption: Scalars['Boolean'];
  includesKeyCoverageOption: Scalars['Boolean'];
  includesTireCoverageOption: Scalars['Boolean'];
  includesWindshieldCoverageOption: Scalars['Boolean'];
  isAddOnWrapPlan: Scalars['Boolean'];
  isLimitedAddOnWrapPlan: Scalars['Boolean'];
  isLimitedLifetimeWarrantyPlan: Scalars['Boolean'];
  isLimitedWarrantyPlan: Scalars['Boolean'];
  isNewCarPlan: Scalars['Boolean'];
  maxCustomerPrice: Scalars['numeric'];
  maxDiscountAmount: Scalars['numeric'];
  maxMarkupAmount: Scalars['numeric'];
  minCustomerPrice: Scalars['numeric'];
  optionalCoverages?: Maybe<Array<Maybe<QuoteResultMetadata_OptionalCoverage>>>;
  planCode?: Maybe<Scalars['String']>;
  planGroupName?: Maybe<Scalars['String']>;
  planIdentifier?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  reserveAmount: Scalars['numeric'];
  retailAmount: Scalars['numeric'];
  selectedIdentifier?: Maybe<Scalars['String']>;
  subProgramTypeID?: Maybe<Scalars['Int']>;
  surcharges?: Maybe<Array<Maybe<QuoteResultMetadata_Surcharge>>>;
};

export type QuoteResultMetadata_OptionalCoverage = {
  __typename?: 'QuoteResultMetadata_OptionalCoverage';
  amount: Scalars['numeric'];
  name?: Maybe<Scalars['String']>;
  optionalCoverageIdentifier: Scalars['Int'];
  planIdentifier?: Maybe<Scalars['String']>;
};

export type QuoteResultMetadata_OriginalQuoteRequest = {
  __typename?: 'QuoteResultMetadata_OriginalQuoteRequest';
  dealerCode?: Maybe<Scalars['String']>;
  dealerRepresentativeName?: Maybe<Scalars['String']>;
  electiveSurcharges?: Maybe<Array<Scalars['Int']>>;
  enterVehicleByType: Scalars['Int'];
  expectedDrivingMilesPerYear?: Maybe<Scalars['Int']>;
  expectedOwnershipYears?: Maybe<Scalars['Int']>;
  factoryWarrantyCoverageMiles?: Maybe<Scalars['Int']>;
  factoryWarrantyCoverageMonths?: Maybe<Scalars['Int']>;
  factoryWarrantyInServiceDate?: Maybe<Scalars['date']>;
  hasRoushAftermarketModifications?: Maybe<Scalars['Boolean']>;
  inServiceDate?: Maybe<Scalars['date']>;
  legacyAccountProfileUsername?: Maybe<Scalars['String']>;
  mileage: Scalars['numeric'];
  programTypes?: Maybe<Array<Scalars['Int']>>;
  purchaseDate: Scalars['date'];
  useSefi: Scalars['Boolean'];
  username?: Maybe<Scalars['String']>;
  vehicleCubicCentimeters?: Maybe<Scalars['Int']>;
  vehicleCylinders?: Maybe<Scalars['Int']>;
  vehicleDrivingWheelsCode?: Maybe<Scalars['String']>;
  vehicleFuelTypeCode?: Maybe<Scalars['String']>;
  vehicleHasTurbo: Scalars['Boolean'];
  vehicleMakeCode?: Maybe<Scalars['String']>;
  vehicleModelName?: Maybe<Scalars['String']>;
  vehiclePurchasePrice: Scalars['numeric'];
  vehicleStatusType: Scalars['Int'];
  vehicleTrim?: Maybe<Scalars['String']>;
  vehicleType?: Maybe<Scalars['Int']>;
  vehicleYear?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
};

export type QuoteResultMetadata_Plan = {
  __typename?: 'QuoteResultMetadata_Plan';
  automaticDiscountAmount: Scalars['numeric'];
  buckets?: Maybe<Array<Maybe<QuoteResultMetadata_Bucket>>>;
  childPlans?: Maybe<Array<Maybe<QuoteResultMetadata_Plan>>>;
  configurationItems?: Maybe<QuoteResultMetadata_PlanConfigurationItems>;
  contractFormName?: Maybe<Scalars['String']>;
  coverageDisplayType: Scalars['Int'];
  coverageMiles: Scalars['Int'];
  coverageMonths: Scalars['Int'];
  coverageOptionTypeCode?: Maybe<Scalars['String']>;
  coverageTypeCode?: Maybe<Scalars['String']>;
  customerActivationPrice?: Maybe<Scalars['numeric']>;
  customerPrice: Scalars['numeric'];
  customerRenewalPrice?: Maybe<Scalars['numeric']>;
  dealerAdminAmount: Scalars['numeric'];
  dealerCost: Scalars['numeric'];
  dealerCostMarkupAmount: Scalars['numeric'];
  dealerDisbursementAmount: Scalars['numeric'];
  dealerReserveAmount: Scalars['numeric'];
  deductibleAmount: Scalars['numeric'];
  deductibleType: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  disbursements?: Maybe<Array<Maybe<QuoteResultMetadata_Disbursement>>>;
  discountAmount: Scalars['numeric'];
  expirationDate?: Maybe<Scalars['date']>;
  expirationMiles?: Maybe<Scalars['Int']>;
  fromMileage: Scalars['Int'];
  gapFinancedAmountEnd: Scalars['Int'];
  gapFinancedAmountStart: Scalars['Int'];
  groupKey?: Maybe<Scalars['String']>;
  includesCosmeticCoverageOption: Scalars['Boolean'];
  includesDentCoverageOption: Scalars['Boolean'];
  includesKeyCoverageOption: Scalars['Boolean'];
  includesPowersportsTireAndWheelCoverage: Scalars['Boolean'];
  includesPowersportsTrailerCoverage: Scalars['Boolean'];
  includesRustCoverageOption: Scalars['Boolean'];
  includesSafeLinkTheftOption: Scalars['Boolean'];
  includesTireCoverageOption: Scalars['Boolean'];
  includesUndercoatCoverageOption: Scalars['Boolean'];
  includesWindshieldCoverageOption: Scalars['Boolean'];
  isAddOnWrapPlan: Scalars['Boolean'];
  isGAPLeasePlan: Scalars['Boolean'];
  isGAPLoanPlan: Scalars['Boolean'];
  isLeaseVSCPlan: Scalars['Boolean'];
  isLimitedAddOnWrapPlan: Scalars['Boolean'];
  isLimitedLifetimeWarrantyPlan: Scalars['Boolean'];
  isLimitedWarrantyPlan: Scalars['Boolean'];
  isNewCarPlan: Scalars['Boolean'];
  isPreloadedPlan: Scalars['Boolean'];
  isSelected: Scalars['Boolean'];
  isUnlimitedCoverageMiles: Scalars['Boolean'];
  maxCustomerPrice: Scalars['numeric'];
  maxDiscountAmount: Scalars['numeric'];
  maxMarkupAmount: Scalars['numeric'];
  minCustomerPrice: Scalars['numeric'];
  obligorCode?: Maybe<Scalars['String']>;
  optionalCoverages?: Maybe<Array<Maybe<QuoteResultMetadata_OptionalCoverage>>>;
  originalCustomerPrice: Scalars['numeric'];
  planCode?: Maybe<Scalars['String']>;
  planGroupDisplayOrder: Scalars['Int'];
  planGroupName?: Maybe<Scalars['String']>;
  planIdentifier?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planSubGroupDisplayOrder: Scalars['Int'];
  planSubGroupName?: Maybe<Scalars['String']>;
  planTypeDescription?: Maybe<Scalars['String']>;
  processedFromInServiceDate: Scalars['Boolean'];
  rateBookID: Scalars['Int'];
  remittanceCostMarkupAmount: Scalars['numeric'];
  remittanceOverrideAmount?: Maybe<Scalars['numeric']>;
  retail2Amount: Scalars['numeric'];
  retail3Amount: Scalars['numeric'];
  retailAmount: Scalars['numeric'];
  secondaryExpirationDate?: Maybe<Scalars['date']>;
  secondaryExpirationMiles?: Maybe<Scalars['Int']>;
  selectedFinancePlan?: Maybe<QuoteResultMetadata_SelectedFinancePlan>;
  subProgramTypeID?: Maybe<Scalars['Int']>;
  surcharges?: Maybe<Array<Maybe<QuoteResultMetadata_Surcharge>>>;
  toMileage: Scalars['Int'];
  totalRateAmount: Scalars['numeric'];
  trueDealerCost: Scalars['numeric'];
  vehicleClassCode?: Maybe<Scalars['String']>;
};

export type QuoteResultMetadata_PlanConfigurationItems = {
  __typename?: 'QuoteResultMetadata_PlanConfigurationItems';
  category?: Maybe<Array<Maybe<Entity_ConfigurationItem>>>;
  product?: Maybe<Array<Maybe<Entity_ConfigurationItem>>>;
};

export type QuoteResultMetadata_Program = {
  __typename?: 'QuoteResultMetadata_Program';
  allowMultipleSelections: Scalars['Boolean'];
  allowedToBeMBPFinanced: Scalars['Boolean'];
  coverages?: Maybe<Array<Maybe<QuoteResultMetadata_Coverage>>>;
  dealerCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Maybe<QuoteResultMetadata_Group>>>;
  hasCosmeticCoverageOptionPlansAvailable: Scalars['Boolean'];
  hasDentCoverageOptionPlansAvailable: Scalars['Boolean'];
  hasKeyCoverageOptionPlansAvailable: Scalars['Boolean'];
  hasMultipleResistAllProducts: Scalars['Boolean'];
  hasTireCoverageOptionPlansAvailable: Scalars['Boolean'];
  hasWindshieldCoverageOptionPlansAvailable: Scalars['Boolean'];
  isStandardAncillaryProgram: Scalars['Boolean'];
  optionalCoverages?: Maybe<Array<Maybe<QuoteResultMetadata_OptionalCoverage>>>;
  plans?: Maybe<Array<Maybe<QuoteResultMetadata_Plan>>>;
  programCode?: Maybe<Scalars['String']>;
  programIdentifier?: Maybe<Scalars['String']>;
  programName?: Maybe<Scalars['String']>;
  programType?: Maybe<Scalars['Int']>;
  programTypeID: Scalars['Int'];
};

export type QuoteResultMetadata_RefineByValue = {
  __typename?: 'QuoteResultMetadata_RefineByValue';
  display?: Maybe<Scalars['String']>;
  isSelected: Scalars['Boolean'];
  value: Scalars['numeric'];
};

export type QuoteResultMetadata_SavedAccountPayment = {
  __typename?: 'QuoteResultMetadata_SavedAccountPayment';
  accountNumber?: Maybe<Scalars['String']>;
  accountPaymentTypeID: Scalars['Int'];
  accountPaymentTypeName?: Maybe<Scalars['String']>;
  bankAccountTypeID?: Maybe<Scalars['Int']>;
  bankAccountTypeName?: Maybe<Scalars['String']>;
  cardHolderName?: Maybe<Scalars['String']>;
  creditCardTypeID?: Maybe<Scalars['Int']>;
  creditCardTypeName?: Maybe<Scalars['String']>;
  expirationMonth?: Maybe<Scalars['String']>;
  expirationYear?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
  securityCode?: Maybe<Scalars['String']>;
  useForDownPayment: Scalars['Boolean'];
  useForMonthlyPayment: Scalars['Boolean'];
};

export type QuoteResultMetadata_SavedContractInfo = {
  __typename?: 'QuoteResultMetadata_SavedContractInfo';
  accountPayments?: Maybe<Array<Maybe<QuoteResultMetadata_SavedAccountPayment>>>;
  customerAddress1?: Maybe<Scalars['String']>;
  customerAddress2?: Maybe<Scalars['String']>;
  customerCity?: Maybe<Scalars['String']>;
  customerDateOfBirth?: Maybe<Scalars['date']>;
  customerEmailAddress?: Maybe<Scalars['String']>;
  customerFirstName?: Maybe<Scalars['String']>;
  customerHomePhone?: Maybe<Scalars['String']>;
  customerLastName?: Maybe<Scalars['String']>;
  customerSecondaryDateOfBirth?: Maybe<Scalars['date']>;
  customerSecondaryFirstName?: Maybe<Scalars['String']>;
  customerSecondaryLastName?: Maybe<Scalars['String']>;
  customerStateAbbreviation?: Maybe<Scalars['String']>;
  customerZip?: Maybe<Scalars['String']>;
  dealerCode?: Maybe<Scalars['String']>;
  dealerRepresentativeName?: Maybe<Scalars['String']>;
  expectedDrivingMilesPerYear?: Maybe<Scalars['Int']>;
  expectedOwnershipYears?: Maybe<Scalars['Int']>;
  hasClarityJacketInformation: Scalars['Boolean'];
  isInTrainingMode: Scalars['Boolean'];
  lenders?: Maybe<Array<Maybe<QuoteResultMetadata_SavedContractLender>>>;
  programType?: Maybe<Scalars['Int']>;
  quoteResponseID: Scalars['String'];
  selectedPlans?: Maybe<Array<Maybe<QuoteResultMetadata_SavedContractSelectedPlan>>>;
  useMBPFinance: Scalars['Boolean'];
};

export type QuoteResultMetadata_SavedContractLender = {
  __typename?: 'QuoteResultMetadata_SavedContractLender';
  contractTypeID?: Maybe<Scalars['Int']>;
  dealerLenderID?: Maybe<Scalars['Int']>;
  downPaymentAmount?: Maybe<Scalars['numeric']>;
  financedAmount?: Maybe<Scalars['numeric']>;
  firstPaymentDate?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['numeric']>;
  isMBPFinanceLender: Scalars['Boolean'];
  loanTerm?: Maybe<Scalars['Int']>;
  mbpFinancePlanID?: Maybe<Scalars['Int']>;
  monthlyPaymentAmount?: Maybe<Scalars['numeric']>;
  programCode?: Maybe<Scalars['String']>;
};

export type QuoteResultMetadata_SavedContractSelectedPlan = {
  __typename?: 'QuoteResultMetadata_SavedContractSelectedPlan';
  customerPrice?: Maybe<Scalars['numeric']>;
  deviceIMEINumber?: Maybe<Scalars['String']>;
  deviceSerialNumber?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['numeric']>;
  hasCosmeticOption: Scalars['Boolean'];
  hasDentOption: Scalars['Boolean'];
  hasKeyOption: Scalars['Boolean'];
  hasTireOption: Scalars['Boolean'];
  hasWindowOption: Scalars['Boolean'];
  loanTermsOrCoverageMonths?: Maybe<Scalars['Int']>;
  optionalCoverages?: Maybe<Array<Maybe<QuoteResultMetadata_OptionalCoverage>>>;
  planIdentifier?: Maybe<Scalars['String']>;
  programCode?: Maybe<Scalars['String']>;
  saleTypeID?: Maybe<Scalars['Int']>;
  totalAllowableLeaseMiles?: Maybe<Scalars['Int']>;
  trailerMakeName?: Maybe<Scalars['String']>;
  trailerModelName?: Maybe<Scalars['String']>;
  trailerNumberOfAxles?: Maybe<Scalars['Int']>;
  trailerSerialNumber?: Maybe<Scalars['String']>;
  trailerYear?: Maybe<Scalars['Int']>;
};

export type QuoteResultMetadata_SelectedFinancePlan = {
  __typename?: 'QuoteResultMetadata_SelectedFinancePlan';
  downPaymentAmount?: Maybe<Scalars['numeric']>;
  downPaymentPercent?: Maybe<Scalars['numeric']>;
  loanTerm: Scalars['Int'];
  mbpFinancePlanID: Scalars['Int'];
  minAllowedCoverageMonths?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  programCode?: Maybe<Scalars['String']>;
  programType: Scalars['Int'];
  serviceFeeAmount: Scalars['numeric'];
};

export type QuoteResultMetadata_Surcharge = {
  __typename?: 'QuoteResultMetadata_Surcharge';
  amount: Scalars['numeric'];
  description?: Maybe<Scalars['String']>;
  isElective: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  surchargeTypeID: Scalars['Int'];
};

export type QuoteResultMetadata_VehicleInformation = {
  __typename?: 'QuoteResultMetadata_VehicleInformation';
  bodyStyleName?: Maybe<Scalars['String']>;
  checkDigitIsValid: Scalars['Boolean'];
  cubicCentimeters?: Maybe<Scalars['Int']>;
  cubicInchesAbbreviation?: Maybe<Scalars['String']>;
  cylindersAbbreviation?: Maybe<Scalars['String']>;
  cylindersNumber?: Maybe<Scalars['Int']>;
  drivingWheelsCode?: Maybe<Scalars['String']>;
  drivingWheelsDescription?: Maybe<Scalars['String']>;
  fuelDeliveryCode?: Maybe<Scalars['String']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  fuelTypeDescription?: Maybe<Scalars['String']>;
  hasSupercharger: Scalars['Boolean'];
  hasTurbo: Scalars['Boolean'];
  isDiesel: Scalars['Boolean'];
  isElectric: Scalars['Boolean'];
  isFourWheelDrive: Scalars['Boolean'];
  isGas: Scalars['Boolean'];
  isHybrid: Scalars['Boolean'];
  isOneTon: Scalars['Boolean'];
  makeAbbreviation?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  modelCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberOfCylinders: Scalars['Int'];
  numberWheelsDriving: Scalars['Int'];
  transmissionCode?: Maybe<Scalars['String']>;
  vehicleClassIsSetup: Scalars['Boolean'];
  vehicleIsIneligible: Scalars['Boolean'];
  vehicleTypeCode?: Maybe<Scalars['String']>;
  vehicleYear: Scalars['Int'];
  vin?: Maybe<Scalars['String']>;
  year: Scalars['Int'];
};

/** aggregate fields of "vpic.rearautomaticemergencybraking" */
export type RearAutomaticEmergencyBraking_Aggregate_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_aggregate_fields_vpic';
  avg?: Maybe<RearAutomaticEmergencyBraking_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<RearAutomaticEmergencyBraking_Max_Fields_Vpic>;
  min?: Maybe<RearAutomaticEmergencyBraking_Min_Fields_Vpic>;
  stddev?: Maybe<RearAutomaticEmergencyBraking_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<RearAutomaticEmergencyBraking_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<RearAutomaticEmergencyBraking_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<RearAutomaticEmergencyBraking_Sum_Fields_Vpic>;
  var_pop?: Maybe<RearAutomaticEmergencyBraking_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<RearAutomaticEmergencyBraking_Var_Samp_Fields_Vpic>;
  variance?: Maybe<RearAutomaticEmergencyBraking_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.rearautomaticemergencybraking" */
export type RearAutomaticEmergencyBraking_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<RearAutomaticEmergencyBraking_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.rearautomaticemergencybraking" */
export type RearAutomaticEmergencyBraking_Aggregate_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_aggregate_vpic';
  aggregate?: Maybe<RearAutomaticEmergencyBraking_Aggregate_Fields_Vpic>;
  nodes: Array<RearAutomaticEmergencyBraking_Vpic>;
};

/** aggregate avg on columns */
export type RearAutomaticEmergencyBraking_Avg_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.rearautomaticemergencybraking". All fields are combined with a logical 'AND'. */
export type RearAutomaticEmergencyBraking_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<RearAutomaticEmergencyBraking_Bool_Exp_Vpic>>;
  _not?: InputMaybe<RearAutomaticEmergencyBraking_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<RearAutomaticEmergencyBraking_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.rearautomaticemergencybraking" */
export enum RearAutomaticEmergencyBraking_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkRearautomaticemergencybraking = 'pk_rearautomaticemergencybraking',
  /** unique or primary key constraint on columns "name" */
  URearautomaticemergencybraking = 'u_rearautomaticemergencybraking'
}

/** input type for incrementing numeric columns in table "vpic.rearautomaticemergencybraking" */
export type RearAutomaticEmergencyBraking_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.rearautomaticemergencybraking" */
export type RearAutomaticEmergencyBraking_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RearAutomaticEmergencyBraking_Max_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RearAutomaticEmergencyBraking_Min_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.rearautomaticemergencybraking" */
export type RearAutomaticEmergencyBraking_Mutation_Response_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RearAutomaticEmergencyBraking_Vpic>;
};

/** on_conflict condition type for table "vpic.rearautomaticemergencybraking" */
export type RearAutomaticEmergencyBraking_On_Conflict_Vpic = {
  constraint: RearAutomaticEmergencyBraking_Constraint_Vpic;
  update_columns?: Array<RearAutomaticEmergencyBraking_Update_Column_Vpic>;
  where?: InputMaybe<RearAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.rearautomaticemergencybraking". */
export type RearAutomaticEmergencyBraking_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.rearautomaticemergencybraking */
export type RearAutomaticEmergencyBraking_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.rearautomaticemergencybraking" */
export enum RearAutomaticEmergencyBraking_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.rearautomaticemergencybraking" */
export type RearAutomaticEmergencyBraking_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RearAutomaticEmergencyBraking_Stddev_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RearAutomaticEmergencyBraking_Stddev_Pop_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RearAutomaticEmergencyBraking_Stddev_Samp_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "RearAutomaticEmergencyBraking" */
export type RearAutomaticEmergencyBraking_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: RearAutomaticEmergencyBraking_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type RearAutomaticEmergencyBraking_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type RearAutomaticEmergencyBraking_Sum_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.rearautomaticemergencybraking" */
export enum RearAutomaticEmergencyBraking_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type RearAutomaticEmergencyBraking_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RearAutomaticEmergencyBraking_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RearAutomaticEmergencyBraking_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: RearAutomaticEmergencyBraking_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type RearAutomaticEmergencyBraking_Var_Pop_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RearAutomaticEmergencyBraking_Var_Samp_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RearAutomaticEmergencyBraking_Variance_Fields_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.rearautomaticemergencybraking" */
export type RearAutomaticEmergencyBraking_Vpic = {
  __typename?: 'RearAutomaticEmergencyBraking_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.rearcrosstrafficalert" */
export type RearCrossTrafficAlert_Aggregate_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_aggregate_fields_vpic';
  avg?: Maybe<RearCrossTrafficAlert_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<RearCrossTrafficAlert_Max_Fields_Vpic>;
  min?: Maybe<RearCrossTrafficAlert_Min_Fields_Vpic>;
  stddev?: Maybe<RearCrossTrafficAlert_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<RearCrossTrafficAlert_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<RearCrossTrafficAlert_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<RearCrossTrafficAlert_Sum_Fields_Vpic>;
  var_pop?: Maybe<RearCrossTrafficAlert_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<RearCrossTrafficAlert_Var_Samp_Fields_Vpic>;
  variance?: Maybe<RearCrossTrafficAlert_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.rearcrosstrafficalert" */
export type RearCrossTrafficAlert_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<RearCrossTrafficAlert_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.rearcrosstrafficalert" */
export type RearCrossTrafficAlert_Aggregate_Vpic = {
  __typename?: 'RearCrossTrafficAlert_aggregate_vpic';
  aggregate?: Maybe<RearCrossTrafficAlert_Aggregate_Fields_Vpic>;
  nodes: Array<RearCrossTrafficAlert_Vpic>;
};

/** aggregate avg on columns */
export type RearCrossTrafficAlert_Avg_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.rearcrosstrafficalert". All fields are combined with a logical 'AND'. */
export type RearCrossTrafficAlert_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<RearCrossTrafficAlert_Bool_Exp_Vpic>>;
  _not?: InputMaybe<RearCrossTrafficAlert_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<RearCrossTrafficAlert_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.rearcrosstrafficalert" */
export enum RearCrossTrafficAlert_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkRearcrosstrafficalert = 'pk_rearcrosstrafficalert'
}

/** input type for incrementing numeric columns in table "vpic.rearcrosstrafficalert" */
export type RearCrossTrafficAlert_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.rearcrosstrafficalert" */
export type RearCrossTrafficAlert_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RearCrossTrafficAlert_Max_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RearCrossTrafficAlert_Min_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.rearcrosstrafficalert" */
export type RearCrossTrafficAlert_Mutation_Response_Vpic = {
  __typename?: 'RearCrossTrafficAlert_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RearCrossTrafficAlert_Vpic>;
};

/** on_conflict condition type for table "vpic.rearcrosstrafficalert" */
export type RearCrossTrafficAlert_On_Conflict_Vpic = {
  constraint: RearCrossTrafficAlert_Constraint_Vpic;
  update_columns?: Array<RearCrossTrafficAlert_Update_Column_Vpic>;
  where?: InputMaybe<RearCrossTrafficAlert_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.rearcrosstrafficalert". */
export type RearCrossTrafficAlert_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.rearcrosstrafficalert */
export type RearCrossTrafficAlert_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.rearcrosstrafficalert" */
export enum RearCrossTrafficAlert_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.rearcrosstrafficalert" */
export type RearCrossTrafficAlert_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RearCrossTrafficAlert_Stddev_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RearCrossTrafficAlert_Stddev_Pop_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RearCrossTrafficAlert_Stddev_Samp_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "RearCrossTrafficAlert" */
export type RearCrossTrafficAlert_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: RearCrossTrafficAlert_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type RearCrossTrafficAlert_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type RearCrossTrafficAlert_Sum_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.rearcrosstrafficalert" */
export enum RearCrossTrafficAlert_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type RearCrossTrafficAlert_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RearCrossTrafficAlert_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RearCrossTrafficAlert_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: RearCrossTrafficAlert_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type RearCrossTrafficAlert_Var_Pop_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RearCrossTrafficAlert_Var_Samp_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RearCrossTrafficAlert_Variance_Fields_Vpic = {
  __typename?: 'RearCrossTrafficAlert_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.rearcrosstrafficalert" */
export type RearCrossTrafficAlert_Vpic = {
  __typename?: 'RearCrossTrafficAlert_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.rearvisibilitycamera" */
export type RearVisibilityCamera_Aggregate_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_aggregate_fields_vpic';
  avg?: Maybe<RearVisibilityCamera_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<RearVisibilityCamera_Max_Fields_Vpic>;
  min?: Maybe<RearVisibilityCamera_Min_Fields_Vpic>;
  stddev?: Maybe<RearVisibilityCamera_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<RearVisibilityCamera_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<RearVisibilityCamera_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<RearVisibilityCamera_Sum_Fields_Vpic>;
  var_pop?: Maybe<RearVisibilityCamera_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<RearVisibilityCamera_Var_Samp_Fields_Vpic>;
  variance?: Maybe<RearVisibilityCamera_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.rearvisibilitycamera" */
export type RearVisibilityCamera_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<RearVisibilityCamera_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.rearvisibilitycamera" */
export type RearVisibilityCamera_Aggregate_Vpic = {
  __typename?: 'RearVisibilityCamera_aggregate_vpic';
  aggregate?: Maybe<RearVisibilityCamera_Aggregate_Fields_Vpic>;
  nodes: Array<RearVisibilityCamera_Vpic>;
};

/** aggregate avg on columns */
export type RearVisibilityCamera_Avg_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.rearvisibilitycamera". All fields are combined with a logical 'AND'. */
export type RearVisibilityCamera_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<RearVisibilityCamera_Bool_Exp_Vpic>>;
  _not?: InputMaybe<RearVisibilityCamera_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<RearVisibilityCamera_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.rearvisibilitycamera" */
export enum RearVisibilityCamera_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkRearvisibilitycamera = 'pk_rearvisibilitycamera',
  /** unique or primary key constraint on columns "name" */
  URearvisibilitycameraname = 'u_rearvisibilitycameraname'
}

/** input type for incrementing numeric columns in table "vpic.rearvisibilitycamera" */
export type RearVisibilityCamera_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.rearvisibilitycamera" */
export type RearVisibilityCamera_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RearVisibilityCamera_Max_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RearVisibilityCamera_Min_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.rearvisibilitycamera" */
export type RearVisibilityCamera_Mutation_Response_Vpic = {
  __typename?: 'RearVisibilityCamera_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RearVisibilityCamera_Vpic>;
};

/** on_conflict condition type for table "vpic.rearvisibilitycamera" */
export type RearVisibilityCamera_On_Conflict_Vpic = {
  constraint: RearVisibilityCamera_Constraint_Vpic;
  update_columns?: Array<RearVisibilityCamera_Update_Column_Vpic>;
  where?: InputMaybe<RearVisibilityCamera_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.rearvisibilitycamera". */
export type RearVisibilityCamera_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.rearvisibilitycamera */
export type RearVisibilityCamera_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.rearvisibilitycamera" */
export enum RearVisibilityCamera_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.rearvisibilitycamera" */
export type RearVisibilityCamera_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RearVisibilityCamera_Stddev_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RearVisibilityCamera_Stddev_Pop_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RearVisibilityCamera_Stddev_Samp_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "RearVisibilityCamera" */
export type RearVisibilityCamera_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: RearVisibilityCamera_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type RearVisibilityCamera_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type RearVisibilityCamera_Sum_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.rearvisibilitycamera" */
export enum RearVisibilityCamera_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type RearVisibilityCamera_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RearVisibilityCamera_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RearVisibilityCamera_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: RearVisibilityCamera_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type RearVisibilityCamera_Var_Pop_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RearVisibilityCamera_Var_Samp_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RearVisibilityCamera_Variance_Fields_Vpic = {
  __typename?: 'RearVisibilityCamera_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.rearvisibilitycamera" */
export type RearVisibilityCamera_Vpic = {
  __typename?: 'RearVisibilityCamera_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type SaveRateQuoteActionInput = {
  accountId?: InputMaybe<Scalars['uuid']>;
  optionBuckets?: InputMaybe<Scalars['jsonb']>;
  performance?: InputMaybe<Scalars['jsonb']>;
  query?: InputMaybe<Scalars['jsonb']>;
};

export type SaveRateQuoteActionOutput = {
  __typename?: 'SaveRateQuoteActionOutput';
  insertRateQuote: InsertType;
};

/** aggregate fields of "vpic.seatbeltsall" */
export type SeatBeltsAll_Aggregate_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_aggregate_fields_vpic';
  avg?: Maybe<SeatBeltsAll_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<SeatBeltsAll_Max_Fields_Vpic>;
  min?: Maybe<SeatBeltsAll_Min_Fields_Vpic>;
  stddev?: Maybe<SeatBeltsAll_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<SeatBeltsAll_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<SeatBeltsAll_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<SeatBeltsAll_Sum_Fields_Vpic>;
  var_pop?: Maybe<SeatBeltsAll_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<SeatBeltsAll_Var_Samp_Fields_Vpic>;
  variance?: Maybe<SeatBeltsAll_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.seatbeltsall" */
export type SeatBeltsAll_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<SeatBeltsAll_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.seatbeltsall" */
export type SeatBeltsAll_Aggregate_Vpic = {
  __typename?: 'SeatBeltsAll_aggregate_vpic';
  aggregate?: Maybe<SeatBeltsAll_Aggregate_Fields_Vpic>;
  nodes: Array<SeatBeltsAll_Vpic>;
};

/** aggregate avg on columns */
export type SeatBeltsAll_Avg_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.seatbeltsall". All fields are combined with a logical 'AND'. */
export type SeatBeltsAll_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<SeatBeltsAll_Bool_Exp_Vpic>>;
  _not?: InputMaybe<SeatBeltsAll_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<SeatBeltsAll_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.seatbeltsall" */
export enum SeatBeltsAll_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkSeatbeltsall = 'pk_seatbeltsall',
  /** unique or primary key constraint on columns "name" */
  USeatbeltsallname = 'u_seatbeltsallname'
}

/** input type for incrementing numeric columns in table "vpic.seatbeltsall" */
export type SeatBeltsAll_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.seatbeltsall" */
export type SeatBeltsAll_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SeatBeltsAll_Max_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SeatBeltsAll_Min_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.seatbeltsall" */
export type SeatBeltsAll_Mutation_Response_Vpic = {
  __typename?: 'SeatBeltsAll_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SeatBeltsAll_Vpic>;
};

/** on_conflict condition type for table "vpic.seatbeltsall" */
export type SeatBeltsAll_On_Conflict_Vpic = {
  constraint: SeatBeltsAll_Constraint_Vpic;
  update_columns?: Array<SeatBeltsAll_Update_Column_Vpic>;
  where?: InputMaybe<SeatBeltsAll_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.seatbeltsall". */
export type SeatBeltsAll_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.seatbeltsall */
export type SeatBeltsAll_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.seatbeltsall" */
export enum SeatBeltsAll_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.seatbeltsall" */
export type SeatBeltsAll_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SeatBeltsAll_Stddev_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SeatBeltsAll_Stddev_Pop_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SeatBeltsAll_Stddev_Samp_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "SeatBeltsAll" */
export type SeatBeltsAll_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: SeatBeltsAll_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type SeatBeltsAll_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SeatBeltsAll_Sum_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.seatbeltsall" */
export enum SeatBeltsAll_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type SeatBeltsAll_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SeatBeltsAll_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SeatBeltsAll_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: SeatBeltsAll_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type SeatBeltsAll_Var_Pop_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SeatBeltsAll_Var_Samp_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SeatBeltsAll_Variance_Fields_Vpic = {
  __typename?: 'SeatBeltsAll_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.seatbeltsall" */
export type SeatBeltsAll_Vpic = {
  __typename?: 'SeatBeltsAll_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.semiautomaticheadlampbeamswitching" */
export type SemiautomaticHeadlampBeamSwitching_Aggregate_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_aggregate_fields_vpic';
  avg?: Maybe<SemiautomaticHeadlampBeamSwitching_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<SemiautomaticHeadlampBeamSwitching_Max_Fields_Vpic>;
  min?: Maybe<SemiautomaticHeadlampBeamSwitching_Min_Fields_Vpic>;
  stddev?: Maybe<SemiautomaticHeadlampBeamSwitching_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<SemiautomaticHeadlampBeamSwitching_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<SemiautomaticHeadlampBeamSwitching_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<SemiautomaticHeadlampBeamSwitching_Sum_Fields_Vpic>;
  var_pop?: Maybe<SemiautomaticHeadlampBeamSwitching_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<SemiautomaticHeadlampBeamSwitching_Var_Samp_Fields_Vpic>;
  variance?: Maybe<SemiautomaticHeadlampBeamSwitching_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.semiautomaticheadlampbeamswitching" */
export type SemiautomaticHeadlampBeamSwitching_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.semiautomaticheadlampbeamswitching" */
export type SemiautomaticHeadlampBeamSwitching_Aggregate_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_aggregate_vpic';
  aggregate?: Maybe<SemiautomaticHeadlampBeamSwitching_Aggregate_Fields_Vpic>;
  nodes: Array<SemiautomaticHeadlampBeamSwitching_Vpic>;
};

/** aggregate avg on columns */
export type SemiautomaticHeadlampBeamSwitching_Avg_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.semiautomaticheadlampbeamswitching". All fields are combined with a logical 'AND'. */
export type SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic>>;
  _not?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.semiautomaticheadlampbeamswitching" */
export enum SemiautomaticHeadlampBeamSwitching_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkSemiauto_3214ec071068b17a = 'pk__semiauto__3214ec071068b17a'
}

/** input type for incrementing numeric columns in table "vpic.semiautomaticheadlampbeamswitching" */
export type SemiautomaticHeadlampBeamSwitching_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.semiautomaticheadlampbeamswitching" */
export type SemiautomaticHeadlampBeamSwitching_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SemiautomaticHeadlampBeamSwitching_Max_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SemiautomaticHeadlampBeamSwitching_Min_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.semiautomaticheadlampbeamswitching" */
export type SemiautomaticHeadlampBeamSwitching_Mutation_Response_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SemiautomaticHeadlampBeamSwitching_Vpic>;
};

/** on_conflict condition type for table "vpic.semiautomaticheadlampbeamswitching" */
export type SemiautomaticHeadlampBeamSwitching_On_Conflict_Vpic = {
  constraint: SemiautomaticHeadlampBeamSwitching_Constraint_Vpic;
  update_columns?: Array<SemiautomaticHeadlampBeamSwitching_Update_Column_Vpic>;
  where?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.semiautomaticheadlampbeamswitching". */
export type SemiautomaticHeadlampBeamSwitching_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.semiautomaticheadlampbeamswitching */
export type SemiautomaticHeadlampBeamSwitching_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.semiautomaticheadlampbeamswitching" */
export enum SemiautomaticHeadlampBeamSwitching_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.semiautomaticheadlampbeamswitching" */
export type SemiautomaticHeadlampBeamSwitching_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SemiautomaticHeadlampBeamSwitching_Stddev_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SemiautomaticHeadlampBeamSwitching_Stddev_Pop_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SemiautomaticHeadlampBeamSwitching_Stddev_Samp_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "SemiautomaticHeadlampBeamSwitching" */
export type SemiautomaticHeadlampBeamSwitching_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: SemiautomaticHeadlampBeamSwitching_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type SemiautomaticHeadlampBeamSwitching_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SemiautomaticHeadlampBeamSwitching_Sum_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.semiautomaticheadlampbeamswitching" */
export enum SemiautomaticHeadlampBeamSwitching_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type SemiautomaticHeadlampBeamSwitching_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type SemiautomaticHeadlampBeamSwitching_Var_Pop_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SemiautomaticHeadlampBeamSwitching_Var_Samp_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SemiautomaticHeadlampBeamSwitching_Variance_Fields_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.semiautomaticheadlampbeamswitching" */
export type SemiautomaticHeadlampBeamSwitching_Vpic = {
  __typename?: 'SemiautomaticHeadlampBeamSwitching_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type ServiceProviderType_Metadata = {
  __typename?: 'ServiceProviderType_Metadata';
  autoCreateDeductible: Scalars['Boolean'];
  isRetired: Scalars['Boolean'];
};

export type ShortcutBinding_BindingMetadata = {
  __typename?: 'ShortcutBinding_BindingMetadata';
  alt?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  mod?: Maybe<Scalars['Boolean']>;
  shift?: Maybe<Scalars['Boolean']>;
};

export type Simple_Interest_Amortization_Schedule_V1 = {
  __typename?: 'Simple_Interest_Amortization_Schedule_v1';
  amortizationScheduleItems: Array<Amortization_Schedule_Item_V1>;
  calculationMethod: Scalars['String'];
  extraDays: Scalars['numeric'];
  extraDaysInterest: Scalars['numeric'];
  failureDate: Scalars['String'];
  financeAmount: Scalars['numeric'];
  firstPaymentDate: Scalars['String'];
  interestRate: Scalars['numeric'];
  loanPaymentFrequencyId: Scalars['String'];
  loanTerm: Scalars['numeric'];
  lossDateBalance: Scalars['numeric'];
  policyContractLoanContractTypeId: Scalars['String'];
  purchaseDate: Scalars['String'];
};

/** aggregate fields of "vpic.steering" */
export type Steering_Aggregate_Fields_Vpic = {
  __typename?: 'Steering_aggregate_fields_vpic';
  avg?: Maybe<Steering_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Steering_Max_Fields_Vpic>;
  min?: Maybe<Steering_Min_Fields_Vpic>;
  stddev?: Maybe<Steering_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Steering_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Steering_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Steering_Sum_Fields_Vpic>;
  var_pop?: Maybe<Steering_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Steering_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Steering_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.steering" */
export type Steering_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Steering_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.steering" */
export type Steering_Aggregate_Vpic = {
  __typename?: 'Steering_aggregate_vpic';
  aggregate?: Maybe<Steering_Aggregate_Fields_Vpic>;
  nodes: Array<Steering_Vpic>;
};

/** aggregate avg on columns */
export type Steering_Avg_Fields_Vpic = {
  __typename?: 'Steering_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.steering". All fields are combined with a logical 'AND'. */
export type Steering_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Steering_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Steering_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Steering_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.steering" */
export enum Steering_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkSteering = 'pk_steering',
  /** unique or primary key constraint on columns "name" */
  USteeringlocationname = 'u_steeringlocationname'
}

/** input type for incrementing numeric columns in table "vpic.steering" */
export type Steering_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.steering" */
export type Steering_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Steering_Max_Fields_Vpic = {
  __typename?: 'Steering_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Steering_Min_Fields_Vpic = {
  __typename?: 'Steering_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.steering" */
export type Steering_Mutation_Response_Vpic = {
  __typename?: 'Steering_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Steering_Vpic>;
};

/** on_conflict condition type for table "vpic.steering" */
export type Steering_On_Conflict_Vpic = {
  constraint: Steering_Constraint_Vpic;
  update_columns?: Array<Steering_Update_Column_Vpic>;
  where?: InputMaybe<Steering_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.steering". */
export type Steering_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.steering */
export type Steering_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.steering" */
export enum Steering_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.steering" */
export type Steering_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Steering_Stddev_Fields_Vpic = {
  __typename?: 'Steering_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Steering_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Steering_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Steering_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Steering_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Steering" */
export type Steering_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Steering_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Steering_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Steering_Sum_Fields_Vpic = {
  __typename?: 'Steering_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.steering" */
export enum Steering_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type Steering_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Steering_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Steering_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Steering_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Steering_Var_Pop_Fields_Vpic = {
  __typename?: 'Steering_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Steering_Var_Samp_Fields_Vpic = {
  __typename?: 'Steering_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Steering_Variance_Fields_Vpic = {
  __typename?: 'Steering_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.steering" */
export type Steering_Vpic = {
  __typename?: 'Steering_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** aggregate fields of "vpic.tpms" */
export type Tpms_Aggregate_Fields_Vpic = {
  __typename?: 'TPMS_aggregate_fields_vpic';
  avg?: Maybe<Tpms_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Tpms_Max_Fields_Vpic>;
  min?: Maybe<Tpms_Min_Fields_Vpic>;
  stddev?: Maybe<Tpms_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Tpms_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Tpms_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Tpms_Sum_Fields_Vpic>;
  var_pop?: Maybe<Tpms_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Tpms_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Tpms_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.tpms" */
export type Tpms_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Tpms_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.tpms" */
export type Tpms_Aggregate_Vpic = {
  __typename?: 'TPMS_aggregate_vpic';
  aggregate?: Maybe<Tpms_Aggregate_Fields_Vpic>;
  nodes: Array<Tpms_Vpic>;
};

/** aggregate avg on columns */
export type Tpms_Avg_Fields_Vpic = {
  __typename?: 'TPMS_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.tpms". All fields are combined with a logical 'AND'. */
export type Tpms_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tpms_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Tpms_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Tpms_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.tpms" */
export enum Tpms_Constraint_Vpic {
  /** unique or primary key constraint on columns "name" */
  IxTpms = 'ix_tpms',
  /** unique or primary key constraint on columns "id" */
  PkTpms = 'pk_tpms'
}

/** input type for incrementing numeric columns in table "vpic.tpms" */
export type Tpms_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.tpms" */
export type Tpms_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tpms_Max_Fields_Vpic = {
  __typename?: 'TPMS_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tpms_Min_Fields_Vpic = {
  __typename?: 'TPMS_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.tpms" */
export type Tpms_Mutation_Response_Vpic = {
  __typename?: 'TPMS_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tpms_Vpic>;
};

/** on_conflict condition type for table "vpic.tpms" */
export type Tpms_On_Conflict_Vpic = {
  constraint: Tpms_Constraint_Vpic;
  update_columns?: Array<Tpms_Update_Column_Vpic>;
  where?: InputMaybe<Tpms_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.tpms". */
export type Tpms_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.tpms */
export type Tpms_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.tpms" */
export enum Tpms_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.tpms" */
export type Tpms_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Tpms_Stddev_Fields_Vpic = {
  __typename?: 'TPMS_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Tpms_Stddev_Pop_Fields_Vpic = {
  __typename?: 'TPMS_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Tpms_Stddev_Samp_Fields_Vpic = {
  __typename?: 'TPMS_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TPMS" */
export type Tpms_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Tpms_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Tpms_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Tpms_Sum_Fields_Vpic = {
  __typename?: 'TPMS_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.tpms" */
export enum Tpms_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type Tpms_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tpms_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tpms_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Tpms_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Tpms_Var_Pop_Fields_Vpic = {
  __typename?: 'TPMS_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Tpms_Var_Samp_Fields_Vpic = {
  __typename?: 'TPMS_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Tpms_Variance_Fields_Vpic = {
  __typename?: 'TPMS_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.tpms" */
export type Tpms_Vpic = {
  __typename?: 'TPMS_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.tractioncontrol" */
export type TractionControl_Aggregate_Fields_Vpic = {
  __typename?: 'TractionControl_aggregate_fields_vpic';
  avg?: Maybe<TractionControl_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<TractionControl_Max_Fields_Vpic>;
  min?: Maybe<TractionControl_Min_Fields_Vpic>;
  stddev?: Maybe<TractionControl_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<TractionControl_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<TractionControl_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<TractionControl_Sum_Fields_Vpic>;
  var_pop?: Maybe<TractionControl_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<TractionControl_Var_Samp_Fields_Vpic>;
  variance?: Maybe<TractionControl_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.tractioncontrol" */
export type TractionControl_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<TractionControl_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.tractioncontrol" */
export type TractionControl_Aggregate_Vpic = {
  __typename?: 'TractionControl_aggregate_vpic';
  aggregate?: Maybe<TractionControl_Aggregate_Fields_Vpic>;
  nodes: Array<TractionControl_Vpic>;
};

/** aggregate avg on columns */
export type TractionControl_Avg_Fields_Vpic = {
  __typename?: 'TractionControl_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.tractioncontrol". All fields are combined with a logical 'AND'. */
export type TractionControl_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<TractionControl_Bool_Exp_Vpic>>;
  _not?: InputMaybe<TractionControl_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<TractionControl_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.tractioncontrol" */
export enum TractionControl_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkTractioncontrol = 'pk_tractioncontrol',
  /** unique or primary key constraint on columns "name" */
  UTractioncontrolname = 'u_tractioncontrolname'
}

/** input type for incrementing numeric columns in table "vpic.tractioncontrol" */
export type TractionControl_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.tractioncontrol" */
export type TractionControl_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TractionControl_Max_Fields_Vpic = {
  __typename?: 'TractionControl_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TractionControl_Min_Fields_Vpic = {
  __typename?: 'TractionControl_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.tractioncontrol" */
export type TractionControl_Mutation_Response_Vpic = {
  __typename?: 'TractionControl_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TractionControl_Vpic>;
};

/** on_conflict condition type for table "vpic.tractioncontrol" */
export type TractionControl_On_Conflict_Vpic = {
  constraint: TractionControl_Constraint_Vpic;
  update_columns?: Array<TractionControl_Update_Column_Vpic>;
  where?: InputMaybe<TractionControl_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.tractioncontrol". */
export type TractionControl_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.tractioncontrol */
export type TractionControl_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.tractioncontrol" */
export enum TractionControl_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.tractioncontrol" */
export type TractionControl_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TractionControl_Stddev_Fields_Vpic = {
  __typename?: 'TractionControl_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TractionControl_Stddev_Pop_Fields_Vpic = {
  __typename?: 'TractionControl_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TractionControl_Stddev_Samp_Fields_Vpic = {
  __typename?: 'TractionControl_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TractionControl" */
export type TractionControl_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: TractionControl_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type TractionControl_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TractionControl_Sum_Fields_Vpic = {
  __typename?: 'TractionControl_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.tractioncontrol" */
export enum TractionControl_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type TractionControl_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TractionControl_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TractionControl_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: TractionControl_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type TractionControl_Var_Pop_Fields_Vpic = {
  __typename?: 'TractionControl_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TractionControl_Var_Samp_Fields_Vpic = {
  __typename?: 'TractionControl_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TractionControl_Variance_Fields_Vpic = {
  __typename?: 'TractionControl_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.tractioncontrol" */
export type TractionControl_Vpic = {
  __typename?: 'TractionControl_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.trailerbodytype" */
export type TrailerBodyType_Aggregate_Fields_Vpic = {
  __typename?: 'TrailerBodyType_aggregate_fields_vpic';
  avg?: Maybe<TrailerBodyType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<TrailerBodyType_Max_Fields_Vpic>;
  min?: Maybe<TrailerBodyType_Min_Fields_Vpic>;
  stddev?: Maybe<TrailerBodyType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<TrailerBodyType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<TrailerBodyType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<TrailerBodyType_Sum_Fields_Vpic>;
  var_pop?: Maybe<TrailerBodyType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<TrailerBodyType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<TrailerBodyType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.trailerbodytype" */
export type TrailerBodyType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<TrailerBodyType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.trailerbodytype" */
export type TrailerBodyType_Aggregate_Vpic = {
  __typename?: 'TrailerBodyType_aggregate_vpic';
  aggregate?: Maybe<TrailerBodyType_Aggregate_Fields_Vpic>;
  nodes: Array<TrailerBodyType_Vpic>;
};

/** aggregate avg on columns */
export type TrailerBodyType_Avg_Fields_Vpic = {
  __typename?: 'TrailerBodyType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.trailerbodytype". All fields are combined with a logical 'AND'. */
export type TrailerBodyType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<TrailerBodyType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<TrailerBodyType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<TrailerBodyType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.trailerbodytype" */
export enum TrailerBodyType_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkTrailerbodytype = 'pk_trailerbodytype',
  /** unique or primary key constraint on columns "name" */
  UTrailerbodytypename = 'u_trailerbodytypename'
}

/** input type for incrementing numeric columns in table "vpic.trailerbodytype" */
export type TrailerBodyType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.trailerbodytype" */
export type TrailerBodyType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TrailerBodyType_Max_Fields_Vpic = {
  __typename?: 'TrailerBodyType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TrailerBodyType_Min_Fields_Vpic = {
  __typename?: 'TrailerBodyType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.trailerbodytype" */
export type TrailerBodyType_Mutation_Response_Vpic = {
  __typename?: 'TrailerBodyType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TrailerBodyType_Vpic>;
};

/** on_conflict condition type for table "vpic.trailerbodytype" */
export type TrailerBodyType_On_Conflict_Vpic = {
  constraint: TrailerBodyType_Constraint_Vpic;
  update_columns?: Array<TrailerBodyType_Update_Column_Vpic>;
  where?: InputMaybe<TrailerBodyType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.trailerbodytype". */
export type TrailerBodyType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.trailerbodytype */
export type TrailerBodyType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.trailerbodytype" */
export enum TrailerBodyType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.trailerbodytype" */
export type TrailerBodyType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TrailerBodyType_Stddev_Fields_Vpic = {
  __typename?: 'TrailerBodyType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TrailerBodyType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'TrailerBodyType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TrailerBodyType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'TrailerBodyType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TrailerBodyType" */
export type TrailerBodyType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: TrailerBodyType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type TrailerBodyType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TrailerBodyType_Sum_Fields_Vpic = {
  __typename?: 'TrailerBodyType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.trailerbodytype" */
export enum TrailerBodyType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type TrailerBodyType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TrailerBodyType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TrailerBodyType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: TrailerBodyType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type TrailerBodyType_Var_Pop_Fields_Vpic = {
  __typename?: 'TrailerBodyType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TrailerBodyType_Var_Samp_Fields_Vpic = {
  __typename?: 'TrailerBodyType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TrailerBodyType_Variance_Fields_Vpic = {
  __typename?: 'TrailerBodyType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.trailerbodytype" */
export type TrailerBodyType_Vpic = {
  __typename?: 'TrailerBodyType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.trailertype" */
export type TrailerType_Aggregate_Fields_Vpic = {
  __typename?: 'TrailerType_aggregate_fields_vpic';
  avg?: Maybe<TrailerType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<TrailerType_Max_Fields_Vpic>;
  min?: Maybe<TrailerType_Min_Fields_Vpic>;
  stddev?: Maybe<TrailerType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<TrailerType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<TrailerType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<TrailerType_Sum_Fields_Vpic>;
  var_pop?: Maybe<TrailerType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<TrailerType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<TrailerType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.trailertype" */
export type TrailerType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<TrailerType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.trailertype" */
export type TrailerType_Aggregate_Vpic = {
  __typename?: 'TrailerType_aggregate_vpic';
  aggregate?: Maybe<TrailerType_Aggregate_Fields_Vpic>;
  nodes: Array<TrailerType_Vpic>;
};

/** aggregate avg on columns */
export type TrailerType_Avg_Fields_Vpic = {
  __typename?: 'TrailerType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.trailertype". All fields are combined with a logical 'AND'. */
export type TrailerType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<TrailerType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<TrailerType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<TrailerType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.trailertype" */
export enum TrailerType_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkTrailertype = 'pk_trailertype',
  /** unique or primary key constraint on columns "name" */
  UTrailertypename = 'u_trailertypename'
}

/** input type for incrementing numeric columns in table "vpic.trailertype" */
export type TrailerType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.trailertype" */
export type TrailerType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TrailerType_Max_Fields_Vpic = {
  __typename?: 'TrailerType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TrailerType_Min_Fields_Vpic = {
  __typename?: 'TrailerType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.trailertype" */
export type TrailerType_Mutation_Response_Vpic = {
  __typename?: 'TrailerType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TrailerType_Vpic>;
};

/** on_conflict condition type for table "vpic.trailertype" */
export type TrailerType_On_Conflict_Vpic = {
  constraint: TrailerType_Constraint_Vpic;
  update_columns?: Array<TrailerType_Update_Column_Vpic>;
  where?: InputMaybe<TrailerType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.trailertype". */
export type TrailerType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.trailertype */
export type TrailerType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.trailertype" */
export enum TrailerType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.trailertype" */
export type TrailerType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TrailerType_Stddev_Fields_Vpic = {
  __typename?: 'TrailerType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TrailerType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'TrailerType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TrailerType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'TrailerType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TrailerType" */
export type TrailerType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: TrailerType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type TrailerType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TrailerType_Sum_Fields_Vpic = {
  __typename?: 'TrailerType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.trailertype" */
export enum TrailerType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type TrailerType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TrailerType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TrailerType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: TrailerType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type TrailerType_Var_Pop_Fields_Vpic = {
  __typename?: 'TrailerType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TrailerType_Var_Samp_Fields_Vpic = {
  __typename?: 'TrailerType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TrailerType_Variance_Fields_Vpic = {
  __typename?: 'TrailerType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.trailertype" */
export type TrailerType_Vpic = {
  __typename?: 'TrailerType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Transfer_Letter_V1 = {
  __typename?: 'Transfer_Letter_v1';
  categoryName: Scalars['String'];
  contractNumber: Scalars['String'];
  customerName1: Scalars['String'];
  date: Scalars['date'];
  vin: Scalars['String'];
};

/** aggregate fields of "vpic.transmission" */
export type Transmission_Aggregate_Fields_Vpic = {
  __typename?: 'Transmission_aggregate_fields_vpic';
  avg?: Maybe<Transmission_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Transmission_Max_Fields_Vpic>;
  min?: Maybe<Transmission_Min_Fields_Vpic>;
  stddev?: Maybe<Transmission_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Transmission_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Transmission_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Transmission_Sum_Fields_Vpic>;
  var_pop?: Maybe<Transmission_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Transmission_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Transmission_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.transmission" */
export type Transmission_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Transmission_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.transmission" */
export type Transmission_Aggregate_Vpic = {
  __typename?: 'Transmission_aggregate_vpic';
  aggregate?: Maybe<Transmission_Aggregate_Fields_Vpic>;
  nodes: Array<Transmission_Vpic>;
};

/** aggregate avg on columns */
export type Transmission_Avg_Fields_Vpic = {
  __typename?: 'Transmission_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.transmission". All fields are combined with a logical 'AND'. */
export type Transmission_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Transmission_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Transmission_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Transmission_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.transmission" */
export enum Transmission_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkTransmission = 'pk_transmission',
  /** unique or primary key constraint on columns "name" */
  UTransmissionstylename = 'u_transmissionstylename'
}

/** input type for incrementing numeric columns in table "vpic.transmission" */
export type Transmission_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.transmission" */
export type Transmission_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Transmission_Max_Fields_Vpic = {
  __typename?: 'Transmission_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Transmission_Min_Fields_Vpic = {
  __typename?: 'Transmission_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.transmission" */
export type Transmission_Mutation_Response_Vpic = {
  __typename?: 'Transmission_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Transmission_Vpic>;
};

/** on_conflict condition type for table "vpic.transmission" */
export type Transmission_On_Conflict_Vpic = {
  constraint: Transmission_Constraint_Vpic;
  update_columns?: Array<Transmission_Update_Column_Vpic>;
  where?: InputMaybe<Transmission_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.transmission". */
export type Transmission_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.transmission */
export type Transmission_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.transmission" */
export enum Transmission_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.transmission" */
export type Transmission_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Transmission_Stddev_Fields_Vpic = {
  __typename?: 'Transmission_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Transmission_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Transmission_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Transmission_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Transmission_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Transmission" */
export type Transmission_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Transmission_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Transmission_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Transmission_Sum_Fields_Vpic = {
  __typename?: 'Transmission_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.transmission" */
export enum Transmission_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type Transmission_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transmission_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transmission_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Transmission_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Transmission_Var_Pop_Fields_Vpic = {
  __typename?: 'Transmission_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Transmission_Var_Samp_Fields_Vpic = {
  __typename?: 'Transmission_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Transmission_Variance_Fields_Vpic = {
  __typename?: 'Transmission_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.transmission" */
export type Transmission_Vpic = {
  __typename?: 'Transmission_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.turbo" */
export type Turbo_Aggregate_Fields_Vpic = {
  __typename?: 'Turbo_aggregate_fields_vpic';
  avg?: Maybe<Turbo_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Turbo_Max_Fields_Vpic>;
  min?: Maybe<Turbo_Min_Fields_Vpic>;
  stddev?: Maybe<Turbo_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Turbo_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Turbo_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Turbo_Sum_Fields_Vpic>;
  var_pop?: Maybe<Turbo_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Turbo_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Turbo_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.turbo" */
export type Turbo_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Turbo_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.turbo" */
export type Turbo_Aggregate_Vpic = {
  __typename?: 'Turbo_aggregate_vpic';
  aggregate?: Maybe<Turbo_Aggregate_Fields_Vpic>;
  nodes: Array<Turbo_Vpic>;
};

/** aggregate avg on columns */
export type Turbo_Avg_Fields_Vpic = {
  __typename?: 'Turbo_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.turbo". All fields are combined with a logical 'AND'. */
export type Turbo_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Turbo_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Turbo_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Turbo_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.turbo" */
export enum Turbo_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkTurbo = 'pk_turbo',
  /** unique or primary key constraint on columns "name" */
  UTurboname = 'u_turboname'
}

/** input type for incrementing numeric columns in table "vpic.turbo" */
export type Turbo_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.turbo" */
export type Turbo_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Turbo_Max_Fields_Vpic = {
  __typename?: 'Turbo_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Turbo_Min_Fields_Vpic = {
  __typename?: 'Turbo_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.turbo" */
export type Turbo_Mutation_Response_Vpic = {
  __typename?: 'Turbo_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Turbo_Vpic>;
};

/** on_conflict condition type for table "vpic.turbo" */
export type Turbo_On_Conflict_Vpic = {
  constraint: Turbo_Constraint_Vpic;
  update_columns?: Array<Turbo_Update_Column_Vpic>;
  where?: InputMaybe<Turbo_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.turbo". */
export type Turbo_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.turbo */
export type Turbo_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.turbo" */
export enum Turbo_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.turbo" */
export type Turbo_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Turbo_Stddev_Fields_Vpic = {
  __typename?: 'Turbo_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Turbo_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Turbo_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Turbo_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Turbo_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Turbo" */
export type Turbo_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Turbo_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Turbo_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Turbo_Sum_Fields_Vpic = {
  __typename?: 'Turbo_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.turbo" */
export enum Turbo_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type Turbo_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Turbo_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Turbo_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Turbo_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Turbo_Var_Pop_Fields_Vpic = {
  __typename?: 'Turbo_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Turbo_Var_Samp_Fields_Vpic = {
  __typename?: 'Turbo_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Turbo_Variance_Fields_Vpic = {
  __typename?: 'Turbo_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.turbo" */
export type Turbo_Vpic = {
  __typename?: 'Turbo_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type VSpecSchemaPattern_Aggregate_Bool_Exp = {
  count?: InputMaybe<VSpecSchemaPattern_Aggregate_Bool_Exp_Count>;
};

export type VSpecSchemaPattern_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<VSpecSchemaPattern_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Aggregate_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_aggregate_fields_vpic';
  avg?: Maybe<VSpecSchemaPattern_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VSpecSchemaPattern_Max_Fields_Vpic>;
  min?: Maybe<VSpecSchemaPattern_Min_Fields_Vpic>;
  stddev?: Maybe<VSpecSchemaPattern_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VSpecSchemaPattern_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VSpecSchemaPattern_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VSpecSchemaPattern_Sum_Fields_Vpic>;
  var_pop?: Maybe<VSpecSchemaPattern_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VSpecSchemaPattern_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VSpecSchemaPattern_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VSpecSchemaPattern_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Aggregate_Order_By_Vpic = {
  avg?: InputMaybe<VSpecSchemaPattern_Avg_Order_By_Vpic>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<VSpecSchemaPattern_Max_Order_By_Vpic>;
  min?: InputMaybe<VSpecSchemaPattern_Min_Order_By_Vpic>;
  stddev?: InputMaybe<VSpecSchemaPattern_Stddev_Order_By_Vpic>;
  stddev_pop?: InputMaybe<VSpecSchemaPattern_Stddev_Pop_Order_By_Vpic>;
  stddev_samp?: InputMaybe<VSpecSchemaPattern_Stddev_Samp_Order_By_Vpic>;
  sum?: InputMaybe<VSpecSchemaPattern_Sum_Order_By_Vpic>;
  var_pop?: InputMaybe<VSpecSchemaPattern_Var_Pop_Order_By_Vpic>;
  var_samp?: InputMaybe<VSpecSchemaPattern_Var_Samp_Order_By_Vpic>;
  variance?: InputMaybe<VSpecSchemaPattern_Variance_Order_By_Vpic>;
};

/** aggregated selection of "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Aggregate_Vpic = {
  __typename?: 'VSpecSchemaPattern_aggregate_vpic';
  aggregate?: Maybe<VSpecSchemaPattern_Aggregate_Fields_Vpic>;
  nodes: Array<VSpecSchemaPattern_Vpic>;
};

/** input type for inserting array relation for remote table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Arr_Rel_Insert_Input_Vpic = {
  data: Array<VSpecSchemaPattern_Insert_Input_Vpic>;
  /** upsert condition */
  on_conflict?: InputMaybe<VSpecSchemaPattern_On_Conflict_Vpic>;
};

/** aggregate avg on columns */
export type VSpecSchemaPattern_Avg_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  SchemaId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Avg_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vpic.vspecschemapattern". All fields are combined with a logical 'AND'. */
export type VSpecSchemaPattern_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  SchemaId?: InputMaybe<Int_Comparison_Exp>;
  VehicleSpecSchema?: InputMaybe<VehicleSpecSchema_Bool_Exp_Vpic>;
  _and?: InputMaybe<Array<VSpecSchemaPattern_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VSpecSchemaPattern_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.vspecschemapattern" */
export enum VSpecSchemaPattern_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkVspecschemapattern = 'pk_vspecschemapattern'
}

/** input type for incrementing numeric columns in table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  SchemaId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  SchemaId?: InputMaybe<Scalars['Int']>;
  VehicleSpecSchema?: InputMaybe<VehicleSpecSchema_Obj_Rel_Insert_Input_Vpic>;
};

/** aggregate max on columns */
export type VSpecSchemaPattern_Max_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  SchemaId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Max_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type VSpecSchemaPattern_Min_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  SchemaId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Min_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Mutation_Response_Vpic = {
  __typename?: 'VSpecSchemaPattern_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VSpecSchemaPattern_Vpic>;
};

/** on_conflict condition type for table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_On_Conflict_Vpic = {
  constraint: VSpecSchemaPattern_Constraint_Vpic;
  update_columns?: Array<VSpecSchemaPattern_Update_Column_Vpic>;
  where?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.vspecschemapattern". */
export type VSpecSchemaPattern_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
  VehicleSpecSchema?: InputMaybe<VehicleSpecSchema_Order_By_Vpic>;
};

/** primary key columns input for table: vpic.vspecschemapattern */
export type VSpecSchemaPattern_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.vspecschemapattern" */
export enum VSpecSchemaPattern_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  SchemaId = 'SchemaId'
}

/** input type for updating data in table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  SchemaId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VSpecSchemaPattern_Stddev_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  SchemaId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Stddev_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type VSpecSchemaPattern_Stddev_Pop_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  SchemaId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Stddev_Pop_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type VSpecSchemaPattern_Stddev_Samp_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  SchemaId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Stddev_Samp_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "VSpecSchemaPattern" */
export type VSpecSchemaPattern_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VSpecSchemaPattern_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VSpecSchemaPattern_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  SchemaId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type VSpecSchemaPattern_Sum_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  SchemaId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Sum_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
};

/** update columns of table "vpic.vspecschemapattern" */
export enum VSpecSchemaPattern_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  SchemaId = 'SchemaId'
}

export type VSpecSchemaPattern_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VSpecSchemaPattern_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VSpecSchemaPattern_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: VSpecSchemaPattern_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type VSpecSchemaPattern_Var_Pop_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  SchemaId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Var_Pop_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type VSpecSchemaPattern_Var_Samp_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  SchemaId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Var_Samp_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type VSpecSchemaPattern_Variance_Fields_Vpic = {
  __typename?: 'VSpecSchemaPattern_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  SchemaId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Variance_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  SchemaId?: InputMaybe<Order_By>;
};

/** columns and relationships of "vpic.vspecschemapattern" */
export type VSpecSchemaPattern_Vpic = {
  __typename?: 'VSpecSchemaPattern_vpic';
  Id: Scalars['Int'];
  SchemaId: Scalars['Int'];
  /** An object relationship */
  VehicleSpecSchema?: Maybe<VehicleSpecSchema_Vpic>;
};

/** aggregate fields of "vpic.valvetraindesign" */
export type ValvetrainDesign_Aggregate_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_aggregate_fields_vpic';
  avg?: Maybe<ValvetrainDesign_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<ValvetrainDesign_Max_Fields_Vpic>;
  min?: Maybe<ValvetrainDesign_Min_Fields_Vpic>;
  stddev?: Maybe<ValvetrainDesign_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<ValvetrainDesign_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<ValvetrainDesign_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<ValvetrainDesign_Sum_Fields_Vpic>;
  var_pop?: Maybe<ValvetrainDesign_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<ValvetrainDesign_Var_Samp_Fields_Vpic>;
  variance?: Maybe<ValvetrainDesign_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.valvetraindesign" */
export type ValvetrainDesign_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<ValvetrainDesign_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.valvetraindesign" */
export type ValvetrainDesign_Aggregate_Vpic = {
  __typename?: 'ValvetrainDesign_aggregate_vpic';
  aggregate?: Maybe<ValvetrainDesign_Aggregate_Fields_Vpic>;
  nodes: Array<ValvetrainDesign_Vpic>;
};

/** aggregate avg on columns */
export type ValvetrainDesign_Avg_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.valvetraindesign". All fields are combined with a logical 'AND'. */
export type ValvetrainDesign_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ValvetrainDesign_Bool_Exp_Vpic>>;
  _not?: InputMaybe<ValvetrainDesign_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<ValvetrainDesign_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.valvetraindesign" */
export enum ValvetrainDesign_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkValvetraindesign = 'pk_valvetraindesign',
  /** unique or primary key constraint on columns "name" */
  UValvetraindesignname = 'u_valvetraindesignname'
}

/** input type for incrementing numeric columns in table "vpic.valvetraindesign" */
export type ValvetrainDesign_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.valvetraindesign" */
export type ValvetrainDesign_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ValvetrainDesign_Max_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ValvetrainDesign_Min_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.valvetraindesign" */
export type ValvetrainDesign_Mutation_Response_Vpic = {
  __typename?: 'ValvetrainDesign_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ValvetrainDesign_Vpic>;
};

/** on_conflict condition type for table "vpic.valvetraindesign" */
export type ValvetrainDesign_On_Conflict_Vpic = {
  constraint: ValvetrainDesign_Constraint_Vpic;
  update_columns?: Array<ValvetrainDesign_Update_Column_Vpic>;
  where?: InputMaybe<ValvetrainDesign_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.valvetraindesign". */
export type ValvetrainDesign_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.valvetraindesign */
export type ValvetrainDesign_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.valvetraindesign" */
export enum ValvetrainDesign_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.valvetraindesign" */
export type ValvetrainDesign_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ValvetrainDesign_Stddev_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ValvetrainDesign_Stddev_Pop_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ValvetrainDesign_Stddev_Samp_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ValvetrainDesign" */
export type ValvetrainDesign_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: ValvetrainDesign_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type ValvetrainDesign_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ValvetrainDesign_Sum_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.valvetraindesign" */
export enum ValvetrainDesign_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type ValvetrainDesign_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ValvetrainDesign_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ValvetrainDesign_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: ValvetrainDesign_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type ValvetrainDesign_Var_Pop_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ValvetrainDesign_Var_Samp_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ValvetrainDesign_Variance_Fields_Vpic = {
  __typename?: 'ValvetrainDesign_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.valvetraindesign" */
export type ValvetrainDesign_Vpic = {
  __typename?: 'ValvetrainDesign_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type VehicleSpecPattern_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<VehicleSpecPattern_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<VehicleSpecPattern_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<VehicleSpecPattern_Aggregate_Bool_Exp_Count>;
};

export type VehicleSpecPattern_Aggregate_Bool_Exp_Bool_And = {
  arguments: VehicleSpecPattern_Select_Column_VehicleSpecPattern_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_Vpic;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
  predicate: Boolean_Comparison_Exp;
};

export type VehicleSpecPattern_Aggregate_Bool_Exp_Bool_Or = {
  arguments: VehicleSpecPattern_Select_Column_VehicleSpecPattern_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_Vpic;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
  predicate: Boolean_Comparison_Exp;
};

export type VehicleSpecPattern_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<VehicleSpecPattern_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Aggregate_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_aggregate_fields_vpic';
  avg?: Maybe<VehicleSpecPattern_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VehicleSpecPattern_Max_Fields_Vpic>;
  min?: Maybe<VehicleSpecPattern_Min_Fields_Vpic>;
  stddev?: Maybe<VehicleSpecPattern_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VehicleSpecPattern_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VehicleSpecPattern_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VehicleSpecPattern_Sum_Fields_Vpic>;
  var_pop?: Maybe<VehicleSpecPattern_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VehicleSpecPattern_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VehicleSpecPattern_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VehicleSpecPattern_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Aggregate_Order_By_Vpic = {
  avg?: InputMaybe<VehicleSpecPattern_Avg_Order_By_Vpic>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<VehicleSpecPattern_Max_Order_By_Vpic>;
  min?: InputMaybe<VehicleSpecPattern_Min_Order_By_Vpic>;
  stddev?: InputMaybe<VehicleSpecPattern_Stddev_Order_By_Vpic>;
  stddev_pop?: InputMaybe<VehicleSpecPattern_Stddev_Pop_Order_By_Vpic>;
  stddev_samp?: InputMaybe<VehicleSpecPattern_Stddev_Samp_Order_By_Vpic>;
  sum?: InputMaybe<VehicleSpecPattern_Sum_Order_By_Vpic>;
  var_pop?: InputMaybe<VehicleSpecPattern_Var_Pop_Order_By_Vpic>;
  var_samp?: InputMaybe<VehicleSpecPattern_Var_Samp_Order_By_Vpic>;
  variance?: InputMaybe<VehicleSpecPattern_Variance_Order_By_Vpic>;
};

/** aggregated selection of "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Aggregate_Vpic = {
  __typename?: 'VehicleSpecPattern_aggregate_vpic';
  aggregate?: Maybe<VehicleSpecPattern_Aggregate_Fields_Vpic>;
  nodes: Array<VehicleSpecPattern_Vpic>;
};

/** input type for inserting array relation for remote table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Arr_Rel_Insert_Input_Vpic = {
  data: Array<VehicleSpecPattern_Insert_Input_Vpic>;
  /** upsert condition */
  on_conflict?: InputMaybe<VehicleSpecPattern_On_Conflict_Vpic>;
};

/** aggregate avg on columns */
export type VehicleSpecPattern_Avg_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_avg_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VSpecSchemaPatternId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Avg_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vpic.vehiclespecpattern". All fields are combined with a logical 'AND'. */
export type VehicleSpecPattern_Bool_Exp_Vpic = {
  AttributeId?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Element?: InputMaybe<Element_Bool_Exp_Vpic>;
  ElementId?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  IsKey?: InputMaybe<Boolean_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  VSpecSchemaPatternId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<VehicleSpecPattern_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VehicleSpecPattern_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.vehiclespecpattern" */
export enum VehicleSpecPattern_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkVehicledataNotwmirelated = 'pk_vehicledata_notwmirelated'
}

/** input type for incrementing numeric columns in table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Inc_Input_Vpic = {
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  VSpecSchemaPatternId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Insert_Input_Vpic = {
  AttributeId?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Element?: InputMaybe<Element_Obj_Rel_Insert_Input_Vpic>;
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  IsKey?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VSpecSchemaPatternId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type VehicleSpecPattern_Max_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_max_fields_vpic';
  AttributeId?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VSpecSchemaPatternId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Max_Order_By_Vpic = {
  AttributeId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type VehicleSpecPattern_Min_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_min_fields_vpic';
  AttributeId?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VSpecSchemaPatternId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Min_Order_By_Vpic = {
  AttributeId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Mutation_Response_Vpic = {
  __typename?: 'VehicleSpecPattern_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleSpecPattern_Vpic>;
};

/** on_conflict condition type for table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_On_Conflict_Vpic = {
  constraint: VehicleSpecPattern_Constraint_Vpic;
  update_columns?: Array<VehicleSpecPattern_Update_Column_Vpic>;
  where?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.vehiclespecpattern". */
export type VehicleSpecPattern_Order_By_Vpic = {
  AttributeId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Element?: InputMaybe<Element_Order_By_Vpic>;
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsKey?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.vehiclespecpattern */
export type VehicleSpecPattern_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select "VehicleSpecPattern_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vpic.vehiclespecpattern" */
export enum VehicleSpecPattern_Select_Column_VehicleSpecPattern_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_Vpic {
  /** column name */
  IsKey = 'IsKey'
}

/** select "VehicleSpecPattern_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vpic.vehiclespecpattern" */
export enum VehicleSpecPattern_Select_Column_VehicleSpecPattern_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_Vpic {
  /** column name */
  IsKey = 'IsKey'
}

/** select columns of table "vpic.vehiclespecpattern" */
export enum VehicleSpecPattern_Select_Column_Vpic {
  /** column name */
  AttributeId = 'AttributeId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  ElementId = 'ElementId',
  /** column name */
  Id = 'Id',
  /** column name */
  IsKey = 'IsKey',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VSpecSchemaPatternId = 'VSpecSchemaPatternId'
}

/** input type for updating data in table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Set_Input_Vpic = {
  AttributeId?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  IsKey?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VSpecSchemaPatternId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VehicleSpecPattern_Stddev_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_stddev_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VSpecSchemaPatternId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Stddev_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type VehicleSpecPattern_Stddev_Pop_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_stddev_pop_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VSpecSchemaPatternId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Stddev_Pop_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type VehicleSpecPattern_Stddev_Samp_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_stddev_samp_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VSpecSchemaPatternId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Stddev_Samp_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "VehicleSpecPattern" */
export type VehicleSpecPattern_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VehicleSpecPattern_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VehicleSpecPattern_Stream_Cursor_Value_Input_Vpic = {
  AttributeId?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ElementId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  IsKey?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VSpecSchemaPatternId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type VehicleSpecPattern_Sum_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_sum_fields_vpic';
  ElementId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  VSpecSchemaPatternId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Sum_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** update columns of table "vpic.vehiclespecpattern" */
export enum VehicleSpecPattern_Update_Column_Vpic {
  /** column name */
  AttributeId = 'AttributeId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  ElementId = 'ElementId',
  /** column name */
  Id = 'Id',
  /** column name */
  IsKey = 'IsKey',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VSpecSchemaPatternId = 'VSpecSchemaPatternId'
}

export type VehicleSpecPattern_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VehicleSpecPattern_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VehicleSpecPattern_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: VehicleSpecPattern_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type VehicleSpecPattern_Var_Pop_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_var_pop_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VSpecSchemaPatternId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Var_Pop_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type VehicleSpecPattern_Var_Samp_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_var_samp_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VSpecSchemaPatternId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Var_Samp_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type VehicleSpecPattern_Variance_Fields_Vpic = {
  __typename?: 'VehicleSpecPattern_variance_fields_vpic';
  ElementId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  VSpecSchemaPatternId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Variance_Order_By_Vpic = {
  ElementId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  VSpecSchemaPatternId?: InputMaybe<Order_By>;
};

/** columns and relationships of "vpic.vehiclespecpattern" */
export type VehicleSpecPattern_Vpic = {
  __typename?: 'VehicleSpecPattern_vpic';
  AttributeId: Scalars['String'];
  CreatedOn?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  Element?: Maybe<Element_Vpic>;
  ElementId: Scalars['Int'];
  Id: Scalars['Int'];
  IsKey: Scalars['Boolean'];
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VSpecSchemaPatternId: Scalars['Int'];
};

/** aggregate fields of "vpic.vehiclespecschema_model" */
export type VehicleSpecSchema_Model_Aggregate_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_aggregate_fields_vpic';
  avg?: Maybe<VehicleSpecSchema_Model_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VehicleSpecSchema_Model_Max_Fields_Vpic>;
  min?: Maybe<VehicleSpecSchema_Model_Min_Fields_Vpic>;
  stddev?: Maybe<VehicleSpecSchema_Model_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VehicleSpecSchema_Model_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VehicleSpecSchema_Model_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VehicleSpecSchema_Model_Sum_Fields_Vpic>;
  var_pop?: Maybe<VehicleSpecSchema_Model_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VehicleSpecSchema_Model_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VehicleSpecSchema_Model_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vehiclespecschema_model" */
export type VehicleSpecSchema_Model_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VehicleSpecSchema_Model_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.vehiclespecschema_model" */
export type VehicleSpecSchema_Model_Aggregate_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_aggregate_vpic';
  aggregate?: Maybe<VehicleSpecSchema_Model_Aggregate_Fields_Vpic>;
  nodes: Array<VehicleSpecSchema_Model_Vpic>;
};

/** aggregate avg on columns */
export type VehicleSpecSchema_Model_Avg_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.vehiclespecschema_model". All fields are combined with a logical 'AND'. */
export type VehicleSpecSchema_Model_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  ModelId?: InputMaybe<Int_Comparison_Exp>;
  VehicleSpecSchemaId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<VehicleSpecSchema_Model_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VehicleSpecSchema_Model_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VehicleSpecSchema_Model_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.vehiclespecschema_model" */
export enum VehicleSpecSchema_Model_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkVehiclespecschemaModel = 'pk_vehiclespecschema_model'
}

/** input type for incrementing numeric columns in table "vpic.vehiclespecschema_model" */
export type VehicleSpecSchema_Model_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  ModelId?: InputMaybe<Scalars['Int']>;
  VehicleSpecSchemaId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.vehiclespecschema_model" */
export type VehicleSpecSchema_Model_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  ModelId?: InputMaybe<Scalars['Int']>;
  VehicleSpecSchemaId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type VehicleSpecSchema_Model_Max_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  ModelId?: Maybe<Scalars['Int']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type VehicleSpecSchema_Model_Min_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  ModelId?: Maybe<Scalars['Int']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vpic.vehiclespecschema_model" */
export type VehicleSpecSchema_Model_Mutation_Response_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleSpecSchema_Model_Vpic>;
};

/** on_conflict condition type for table "vpic.vehiclespecschema_model" */
export type VehicleSpecSchema_Model_On_Conflict_Vpic = {
  constraint: VehicleSpecSchema_Model_Constraint_Vpic;
  update_columns?: Array<VehicleSpecSchema_Model_Update_Column_Vpic>;
  where?: InputMaybe<VehicleSpecSchema_Model_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.vehiclespecschema_model". */
export type VehicleSpecSchema_Model_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  ModelId?: InputMaybe<Order_By>;
  VehicleSpecSchemaId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.vehiclespecschema_model */
export type VehicleSpecSchema_Model_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.vehiclespecschema_model" */
export enum VehicleSpecSchema_Model_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  ModelId = 'ModelId',
  /** column name */
  VehicleSpecSchemaId = 'VehicleSpecSchemaId'
}

/** input type for updating data in table "vpic.vehiclespecschema_model" */
export type VehicleSpecSchema_Model_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  ModelId?: InputMaybe<Scalars['Int']>;
  VehicleSpecSchemaId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VehicleSpecSchema_Model_Stddev_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VehicleSpecSchema_Model_Stddev_Pop_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VehicleSpecSchema_Model_Stddev_Samp_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "VehicleSpecSchema_Model" */
export type VehicleSpecSchema_Model_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VehicleSpecSchema_Model_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VehicleSpecSchema_Model_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  ModelId?: InputMaybe<Scalars['Int']>;
  VehicleSpecSchemaId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type VehicleSpecSchema_Model_Sum_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  ModelId?: Maybe<Scalars['Int']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.vehiclespecschema_model" */
export enum VehicleSpecSchema_Model_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  ModelId = 'ModelId',
  /** column name */
  VehicleSpecSchemaId = 'VehicleSpecSchemaId'
}

export type VehicleSpecSchema_Model_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VehicleSpecSchema_Model_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VehicleSpecSchema_Model_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: VehicleSpecSchema_Model_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type VehicleSpecSchema_Model_Var_Pop_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VehicleSpecSchema_Model_Var_Samp_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VehicleSpecSchema_Model_Variance_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelId?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.vehiclespecschema_model" */
export type VehicleSpecSchema_Model_Vpic = {
  __typename?: 'VehicleSpecSchema_Model_vpic';
  Id: Scalars['Int'];
  ModelId: Scalars['Int'];
  VehicleSpecSchemaId: Scalars['Int'];
};

/** aggregate fields of "vpic.vehiclespecschema_year" */
export type VehicleSpecSchema_Year_Aggregate_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_aggregate_fields_vpic';
  avg?: Maybe<VehicleSpecSchema_Year_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VehicleSpecSchema_Year_Max_Fields_Vpic>;
  min?: Maybe<VehicleSpecSchema_Year_Min_Fields_Vpic>;
  stddev?: Maybe<VehicleSpecSchema_Year_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VehicleSpecSchema_Year_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VehicleSpecSchema_Year_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VehicleSpecSchema_Year_Sum_Fields_Vpic>;
  var_pop?: Maybe<VehicleSpecSchema_Year_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VehicleSpecSchema_Year_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VehicleSpecSchema_Year_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vehiclespecschema_year" */
export type VehicleSpecSchema_Year_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VehicleSpecSchema_Year_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.vehiclespecschema_year" */
export type VehicleSpecSchema_Year_Aggregate_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_aggregate_vpic';
  aggregate?: Maybe<VehicleSpecSchema_Year_Aggregate_Fields_Vpic>;
  nodes: Array<VehicleSpecSchema_Year_Vpic>;
};

/** aggregate avg on columns */
export type VehicleSpecSchema_Year_Avg_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.vehiclespecschema_year". All fields are combined with a logical 'AND'. */
export type VehicleSpecSchema_Year_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  VehicleSpecSchemaId?: InputMaybe<Int_Comparison_Exp>;
  Year?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<VehicleSpecSchema_Year_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VehicleSpecSchema_Year_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VehicleSpecSchema_Year_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.vehiclespecschema_year" */
export enum VehicleSpecSchema_Year_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkVehiclespecschemaYear = 'pk_vehiclespecschema_year'
}

/** input type for incrementing numeric columns in table "vpic.vehiclespecschema_year" */
export type VehicleSpecSchema_Year_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  VehicleSpecSchemaId?: InputMaybe<Scalars['Int']>;
  Year?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.vehiclespecschema_year" */
export type VehicleSpecSchema_Year_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  VehicleSpecSchemaId?: InputMaybe<Scalars['Int']>;
  Year?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type VehicleSpecSchema_Year_Max_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Int']>;
  Year?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type VehicleSpecSchema_Year_Min_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Int']>;
  Year?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vpic.vehiclespecschema_year" */
export type VehicleSpecSchema_Year_Mutation_Response_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleSpecSchema_Year_Vpic>;
};

/** on_conflict condition type for table "vpic.vehiclespecschema_year" */
export type VehicleSpecSchema_Year_On_Conflict_Vpic = {
  constraint: VehicleSpecSchema_Year_Constraint_Vpic;
  update_columns?: Array<VehicleSpecSchema_Year_Update_Column_Vpic>;
  where?: InputMaybe<VehicleSpecSchema_Year_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.vehiclespecschema_year". */
export type VehicleSpecSchema_Year_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  VehicleSpecSchemaId?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.vehiclespecschema_year */
export type VehicleSpecSchema_Year_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.vehiclespecschema_year" */
export enum VehicleSpecSchema_Year_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  VehicleSpecSchemaId = 'VehicleSpecSchemaId',
  /** column name */
  Year = 'Year'
}

/** input type for updating data in table "vpic.vehiclespecschema_year" */
export type VehicleSpecSchema_Year_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  VehicleSpecSchemaId?: InputMaybe<Scalars['Int']>;
  Year?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VehicleSpecSchema_Year_Stddev_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VehicleSpecSchema_Year_Stddev_Pop_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VehicleSpecSchema_Year_Stddev_Samp_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "VehicleSpecSchema_Year" */
export type VehicleSpecSchema_Year_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VehicleSpecSchema_Year_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VehicleSpecSchema_Year_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  VehicleSpecSchemaId?: InputMaybe<Scalars['Int']>;
  Year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type VehicleSpecSchema_Year_Sum_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Int']>;
  Year?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.vehiclespecschema_year" */
export enum VehicleSpecSchema_Year_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  VehicleSpecSchemaId = 'VehicleSpecSchemaId',
  /** column name */
  Year = 'Year'
}

export type VehicleSpecSchema_Year_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VehicleSpecSchema_Year_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VehicleSpecSchema_Year_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: VehicleSpecSchema_Year_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type VehicleSpecSchema_Year_Var_Pop_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VehicleSpecSchema_Year_Var_Samp_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VehicleSpecSchema_Year_Variance_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  VehicleSpecSchemaId?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.vehiclespecschema_year" */
export type VehicleSpecSchema_Year_Vpic = {
  __typename?: 'VehicleSpecSchema_Year_vpic';
  Id: Scalars['Int'];
  VehicleSpecSchemaId: Scalars['Int'];
  Year: Scalars['Int'];
};

/** aggregate fields of "vpic.vehiclespecschema" */
export type VehicleSpecSchema_Aggregate_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_aggregate_fields_vpic';
  avg?: Maybe<VehicleSpecSchema_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VehicleSpecSchema_Max_Fields_Vpic>;
  min?: Maybe<VehicleSpecSchema_Min_Fields_Vpic>;
  stddev?: Maybe<VehicleSpecSchema_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VehicleSpecSchema_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VehicleSpecSchema_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VehicleSpecSchema_Sum_Fields_Vpic>;
  var_pop?: Maybe<VehicleSpecSchema_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VehicleSpecSchema_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VehicleSpecSchema_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vehiclespecschema" */
export type VehicleSpecSchema_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VehicleSpecSchema_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.vehiclespecschema" */
export type VehicleSpecSchema_Aggregate_Vpic = {
  __typename?: 'VehicleSpecSchema_aggregate_vpic';
  aggregate?: Maybe<VehicleSpecSchema_Aggregate_Fields_Vpic>;
  nodes: Array<VehicleSpecSchema_Vpic>;
};

/** aggregate avg on columns */
export type VehicleSpecSchema_Avg_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.vehiclespecschema". All fields are combined with a logical 'AND'. */
export type VehicleSpecSchema_Bool_Exp_Vpic = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  MakeId?: InputMaybe<Int_Comparison_Exp>;
  SourceDate?: InputMaybe<Timestamp_Comparison_Exp>;
  TobeQCed?: InputMaybe<Boolean_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  VSpecSchemaPatterns?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
  VSpecSchemaPatterns_aggregate?: InputMaybe<VSpecSchemaPattern_Aggregate_Bool_Exp>;
  VehicleTypeId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<VehicleSpecSchema_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VehicleSpecSchema_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VehicleSpecSchema_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.vehiclespecschema" */
export enum VehicleSpecSchema_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkVehiclespec = 'pk_vehiclespec'
}

/** input type for incrementing numeric columns in table "vpic.vehiclespecschema" */
export type VehicleSpecSchema_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.vehiclespecschema" */
export type VehicleSpecSchema_Insert_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  SourceDate?: InputMaybe<Scalars['timestamp']>;
  TobeQCed?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VSpecSchemaPatterns?: InputMaybe<VSpecSchemaPattern_Arr_Rel_Insert_Input_Vpic>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type VehicleSpecSchema_Max_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_max_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  SourceDate?: Maybe<Scalars['timestamp']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VehicleTypeId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type VehicleSpecSchema_Min_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_min_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  SourceDate?: Maybe<Scalars['timestamp']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VehicleTypeId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vpic.vehiclespecschema" */
export type VehicleSpecSchema_Mutation_Response_Vpic = {
  __typename?: 'VehicleSpecSchema_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleSpecSchema_Vpic>;
};

/** input type for inserting object relation for remote table "vpic.vehiclespecschema" */
export type VehicleSpecSchema_Obj_Rel_Insert_Input_Vpic = {
  data: VehicleSpecSchema_Insert_Input_Vpic;
  /** upsert condition */
  on_conflict?: InputMaybe<VehicleSpecSchema_On_Conflict_Vpic>;
};

/** on_conflict condition type for table "vpic.vehiclespecschema" */
export type VehicleSpecSchema_On_Conflict_Vpic = {
  constraint: VehicleSpecSchema_Constraint_Vpic;
  update_columns?: Array<VehicleSpecSchema_Update_Column_Vpic>;
  where?: InputMaybe<VehicleSpecSchema_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.vehiclespecschema". */
export type VehicleSpecSchema_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  SourceDate?: InputMaybe<Order_By>;
  TobeQCed?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VSpecSchemaPatterns_aggregate?: InputMaybe<VSpecSchemaPattern_Aggregate_Order_By_Vpic>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.vehiclespecschema */
export type VehicleSpecSchema_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.vehiclespecschema" */
export enum VehicleSpecSchema_Select_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  SourceDate = 'SourceDate',
  /** column name */
  TobeQCed = 'TobeQCed',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VehicleTypeId = 'VehicleTypeId'
}

/** input type for updating data in table "vpic.vehiclespecschema" */
export type VehicleSpecSchema_Set_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  SourceDate?: InputMaybe<Scalars['timestamp']>;
  TobeQCed?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VehicleSpecSchema_Stddev_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VehicleSpecSchema_Stddev_Pop_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VehicleSpecSchema_Stddev_Samp_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "VehicleSpecSchema" */
export type VehicleSpecSchema_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VehicleSpecSchema_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VehicleSpecSchema_Stream_Cursor_Value_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  SourceDate?: InputMaybe<Scalars['timestamp']>;
  TobeQCed?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type VehicleSpecSchema_Sum_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  VehicleTypeId?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.vehiclespecschema" */
export enum VehicleSpecSchema_Update_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  SourceDate = 'SourceDate',
  /** column name */
  TobeQCed = 'TobeQCed',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VehicleTypeId = 'VehicleTypeId'
}

export type VehicleSpecSchema_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VehicleSpecSchema_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VehicleSpecSchema_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: VehicleSpecSchema_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type VehicleSpecSchema_Var_Pop_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VehicleSpecSchema_Var_Samp_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VehicleSpecSchema_Variance_Fields_Vpic = {
  __typename?: 'VehicleSpecSchema_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.vehiclespecschema" */
export type VehicleSpecSchema_Vpic = {
  __typename?: 'VehicleSpecSchema_vpic';
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['Int'];
  MakeId: Scalars['Int'];
  SourceDate?: Maybe<Scalars['timestamp']>;
  TobeQCed?: Maybe<Scalars['Boolean']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  VSpecSchemaPatterns: Array<VSpecSchemaPattern_Vpic>;
  /** An aggregate relationship */
  VSpecSchemaPatterns_aggregate: VSpecSchemaPattern_Aggregate_Vpic;
  VehicleTypeId?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "vpic.vehiclespecschema" */
export type VehicleSpecSchema_VpicVSpecSchemaPatternsArgs = {
  distinct_on?: InputMaybe<Array<VSpecSchemaPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VSpecSchemaPattern_Order_By_Vpic>>;
  where?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.vehiclespecschema" */
export type VehicleSpecSchema_VpicVSpecSchemaPatterns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VSpecSchemaPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VSpecSchemaPattern_Order_By_Vpic>>;
  where?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
};

/** aggregate fields of "vpic.vehicletype" */
export type VehicleType_Aggregate_Fields_Vpic = {
  __typename?: 'VehicleType_aggregate_fields_vpic';
  avg?: Maybe<VehicleType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VehicleType_Max_Fields_Vpic>;
  min?: Maybe<VehicleType_Min_Fields_Vpic>;
  stddev?: Maybe<VehicleType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VehicleType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VehicleType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VehicleType_Sum_Fields_Vpic>;
  var_pop?: Maybe<VehicleType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VehicleType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VehicleType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vehicletype" */
export type VehicleType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VehicleType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.vehicletype" */
export type VehicleType_Aggregate_Vpic = {
  __typename?: 'VehicleType_aggregate_vpic';
  aggregate?: Maybe<VehicleType_Aggregate_Fields_Vpic>;
  nodes: Array<VehicleType_Vpic>;
};

/** aggregate avg on columns */
export type VehicleType_Avg_Fields_Vpic = {
  __typename?: 'VehicleType_avg_fields_vpic';
  DisplayOrder?: Maybe<Scalars['Float']>;
  FormType?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.vehicletype". All fields are combined with a logical 'AND'. */
export type VehicleType_Bool_Exp_Vpic = {
  DefaultValues?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
  DefaultValues_aggregate?: InputMaybe<DefaultValue_Aggregate_Bool_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  DisplayOrder?: InputMaybe<Int_Comparison_Exp>;
  FormType?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  IncludeInEquipPlant?: InputMaybe<Boolean_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Wmis?: InputMaybe<Wmi_Bool_Exp_Vpic>;
  Wmis_aggregate?: InputMaybe<Wmi_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<VehicleType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VehicleType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VehicleType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.vehicletype" */
export enum VehicleType_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkVehicletype = 'pk_vehicletype',
  /** unique or primary key constraint on columns "name" */
  UVehicletypename = 'u_vehicletypename'
}

/** input type for incrementing numeric columns in table "vpic.vehicletype" */
export type VehicleType_Inc_Input_Vpic = {
  DisplayOrder?: InputMaybe<Scalars['Int']>;
  FormType?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.vehicletype" */
export type VehicleType_Insert_Input_Vpic = {
  DefaultValues?: InputMaybe<DefaultValue_Arr_Rel_Insert_Input_Vpic>;
  Description?: InputMaybe<Scalars['String']>;
  DisplayOrder?: InputMaybe<Scalars['Int']>;
  FormType?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  IncludeInEquipPlant?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  Wmis?: InputMaybe<Wmi_Arr_Rel_Insert_Input_Vpic>;
};

/** aggregate max on columns */
export type VehicleType_Max_Fields_Vpic = {
  __typename?: 'VehicleType_max_fields_vpic';
  Description?: Maybe<Scalars['String']>;
  DisplayOrder?: Maybe<Scalars['Int']>;
  FormType?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VehicleType_Min_Fields_Vpic = {
  __typename?: 'VehicleType_min_fields_vpic';
  Description?: Maybe<Scalars['String']>;
  DisplayOrder?: Maybe<Scalars['Int']>;
  FormType?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.vehicletype" */
export type VehicleType_Mutation_Response_Vpic = {
  __typename?: 'VehicleType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleType_Vpic>;
};

/** input type for inserting object relation for remote table "vpic.vehicletype" */
export type VehicleType_Obj_Rel_Insert_Input_Vpic = {
  data: VehicleType_Insert_Input_Vpic;
  /** upsert condition */
  on_conflict?: InputMaybe<VehicleType_On_Conflict_Vpic>;
};

/** on_conflict condition type for table "vpic.vehicletype" */
export type VehicleType_On_Conflict_Vpic = {
  constraint: VehicleType_Constraint_Vpic;
  update_columns?: Array<VehicleType_Update_Column_Vpic>;
  where?: InputMaybe<VehicleType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.vehicletype". */
export type VehicleType_Order_By_Vpic = {
  DefaultValues_aggregate?: InputMaybe<DefaultValue_Aggregate_Order_By_Vpic>;
  Description?: InputMaybe<Order_By>;
  DisplayOrder?: InputMaybe<Order_By>;
  FormType?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IncludeInEquipPlant?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Wmis_aggregate?: InputMaybe<Wmi_Aggregate_Order_By_Vpic>;
};

/** primary key columns input for table: vpic.vehicletype */
export type VehicleType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.vehicletype" */
export enum VehicleType_Select_Column_Vpic {
  /** column name */
  Description = 'Description',
  /** column name */
  DisplayOrder = 'DisplayOrder',
  /** column name */
  FormType = 'FormType',
  /** column name */
  Id = 'Id',
  /** column name */
  IncludeInEquipPlant = 'IncludeInEquipPlant',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.vehicletype" */
export type VehicleType_Set_Input_Vpic = {
  Description?: InputMaybe<Scalars['String']>;
  DisplayOrder?: InputMaybe<Scalars['Int']>;
  FormType?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  IncludeInEquipPlant?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type VehicleType_Stddev_Fields_Vpic = {
  __typename?: 'VehicleType_stddev_fields_vpic';
  DisplayOrder?: Maybe<Scalars['Float']>;
  FormType?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VehicleType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'VehicleType_stddev_pop_fields_vpic';
  DisplayOrder?: Maybe<Scalars['Float']>;
  FormType?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VehicleType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'VehicleType_stddev_samp_fields_vpic';
  DisplayOrder?: Maybe<Scalars['Float']>;
  FormType?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "VehicleType" */
export type VehicleType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VehicleType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VehicleType_Stream_Cursor_Value_Input_Vpic = {
  Description?: InputMaybe<Scalars['String']>;
  DisplayOrder?: InputMaybe<Scalars['Int']>;
  FormType?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  IncludeInEquipPlant?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type VehicleType_Sum_Fields_Vpic = {
  __typename?: 'VehicleType_sum_fields_vpic';
  DisplayOrder?: Maybe<Scalars['Int']>;
  FormType?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.vehicletype" */
export enum VehicleType_Update_Column_Vpic {
  /** column name */
  Description = 'Description',
  /** column name */
  DisplayOrder = 'DisplayOrder',
  /** column name */
  FormType = 'FormType',
  /** column name */
  Id = 'Id',
  /** column name */
  IncludeInEquipPlant = 'IncludeInEquipPlant',
  /** column name */
  Name = 'Name'
}

export type VehicleType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VehicleType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VehicleType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: VehicleType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type VehicleType_Var_Pop_Fields_Vpic = {
  __typename?: 'VehicleType_var_pop_fields_vpic';
  DisplayOrder?: Maybe<Scalars['Float']>;
  FormType?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VehicleType_Var_Samp_Fields_Vpic = {
  __typename?: 'VehicleType_var_samp_fields_vpic';
  DisplayOrder?: Maybe<Scalars['Float']>;
  FormType?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VehicleType_Variance_Fields_Vpic = {
  __typename?: 'VehicleType_variance_fields_vpic';
  DisplayOrder?: Maybe<Scalars['Float']>;
  FormType?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.vehicletype" */
export type VehicleType_Vpic = {
  __typename?: 'VehicleType_vpic';
  /** An array relationship */
  DefaultValues: Array<DefaultValue_Vpic>;
  /** An aggregate relationship */
  DefaultValues_aggregate: DefaultValue_Aggregate_Vpic;
  Description?: Maybe<Scalars['String']>;
  DisplayOrder?: Maybe<Scalars['Int']>;
  FormType?: Maybe<Scalars['Int']>;
  Id: Scalars['Int'];
  IncludeInEquipPlant?: Maybe<Scalars['Boolean']>;
  Name: Scalars['String'];
  /** An array relationship */
  Wmis: Array<Wmi_Vpic>;
  /** An aggregate relationship */
  Wmis_aggregate: Wmi_Aggregate_Vpic;
};


/** columns and relationships of "vpic.vehicletype" */
export type VehicleType_VpicDefaultValuesArgs = {
  distinct_on?: InputMaybe<Array<DefaultValue_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DefaultValue_Order_By_Vpic>>;
  where?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.vehicletype" */
export type VehicleType_VpicDefaultValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DefaultValue_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DefaultValue_Order_By_Vpic>>;
  where?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.vehicletype" */
export type VehicleType_VpicWmisArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.vehicletype" */
export type VehicleType_VpicWmis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Bool_Exp_Vpic>;
};

export type VinDecoderActionInput = {
  vin?: InputMaybe<Scalars['String']>;
};

export type VinDecoderActionOutput = {
  __typename?: 'VinDecoderActionOutput';
  data?: Maybe<VinDecoderActionOutputData>;
  errors?: Maybe<Array<Maybe<VinDecoderActionOutputError>>>;
};

export type VinDecoderActionOutputData = {
  __typename?: 'VinDecoderActionOutputData';
  availableTrims?: Maybe<Scalars['String']>;
  bodyStyleName?: Maybe<Scalars['String']>;
  cubicInchesAbbreviation?: Maybe<Scalars['String']>;
  cylindersAbbreviation?: Maybe<Scalars['String']>;
  cylindersNumber?: Maybe<Scalars['Int']>;
  drivingWheelsCode?: Maybe<Scalars['String']>;
  drivingWheelsDescription?: Maybe<Scalars['String']>;
  fuelDeliveryCode?: Maybe<Scalars['String']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  fuelTypeDescription?: Maybe<Scalars['String']>;
  hasMBPCertificationAvailable?: Maybe<Scalars['Boolean']>;
  hasSupercharger?: Maybe<Scalars['Boolean']>;
  hasTurbo?: Maybe<Scalars['Boolean']>;
  isDiesel?: Maybe<Scalars['Boolean']>;
  isElectric?: Maybe<Scalars['Boolean']>;
  isFourWheelDrive?: Maybe<Scalars['Boolean']>;
  isGas?: Maybe<Scalars['Boolean']>;
  isHybrid?: Maybe<Scalars['Boolean']>;
  isOneTon?: Maybe<Scalars['Boolean']>;
  makeAbbreviation?: Maybe<Scalars['String']>;
  makeCode?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  modelCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  transmissionCode?: Maybe<Scalars['String']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  vehicleYear?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
};

export type VinDecoderActionOutputError = {
  __typename?: 'VinDecoderActionOutputError';
  exception?: Maybe<Scalars['String']>;
  friendlyMessage?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/** aggregate fields of "vpic.vindescriptor" */
export type VinDescriptor_Aggregate_Fields_Vpic = {
  __typename?: 'VinDescriptor_aggregate_fields_vpic';
  avg?: Maybe<VinDescriptor_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VinDescriptor_Max_Fields_Vpic>;
  min?: Maybe<VinDescriptor_Min_Fields_Vpic>;
  stddev?: Maybe<VinDescriptor_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VinDescriptor_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VinDescriptor_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VinDescriptor_Sum_Fields_Vpic>;
  var_pop?: Maybe<VinDescriptor_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VinDescriptor_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VinDescriptor_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vindescriptor" */
export type VinDescriptor_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VinDescriptor_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.vindescriptor" */
export type VinDescriptor_Aggregate_Vpic = {
  __typename?: 'VinDescriptor_aggregate_vpic';
  aggregate?: Maybe<VinDescriptor_Aggregate_Fields_Vpic>;
  nodes: Array<VinDescriptor_Vpic>;
};

/** aggregate avg on columns */
export type VinDescriptor_Avg_Fields_Vpic = {
  __typename?: 'VinDescriptor_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelYear?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.vindescriptor". All fields are combined with a logical 'AND'. */
export type VinDescriptor_Bool_Exp_Vpic = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Descriptor?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  ModelYear?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<VinDescriptor_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VinDescriptor_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VinDescriptor_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.vindescriptor" */
export enum VinDescriptor_Constraint_Vpic {
  /** unique or primary key constraint on columns "descriptor" */
  IxVindescriptorDescriptor = 'ix_vindescriptor_descriptor',
  /** unique or primary key constraint on columns "id" */
  PkVindescriptor = 'pk_vindescriptor'
}

/** input type for incrementing numeric columns in table "vpic.vindescriptor" */
export type VinDescriptor_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  ModelYear?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.vindescriptor" */
export type VinDescriptor_Insert_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Descriptor?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  ModelYear?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type VinDescriptor_Max_Fields_Vpic = {
  __typename?: 'VinDescriptor_max_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Descriptor?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  ModelYear?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type VinDescriptor_Min_Fields_Vpic = {
  __typename?: 'VinDescriptor_min_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Descriptor?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  ModelYear?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "vpic.vindescriptor" */
export type VinDescriptor_Mutation_Response_Vpic = {
  __typename?: 'VinDescriptor_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VinDescriptor_Vpic>;
};

/** on_conflict condition type for table "vpic.vindescriptor" */
export type VinDescriptor_On_Conflict_Vpic = {
  constraint: VinDescriptor_Constraint_Vpic;
  update_columns?: Array<VinDescriptor_Update_Column_Vpic>;
  where?: InputMaybe<VinDescriptor_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.vindescriptor". */
export type VinDescriptor_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  Descriptor?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModelYear?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.vindescriptor */
export type VinDescriptor_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.vindescriptor" */
export enum VinDescriptor_Select_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Descriptor = 'Descriptor',
  /** column name */
  Id = 'Id',
  /** column name */
  ModelYear = 'ModelYear',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "vpic.vindescriptor" */
export type VinDescriptor_Set_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Descriptor?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  ModelYear?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type VinDescriptor_Stddev_Fields_Vpic = {
  __typename?: 'VinDescriptor_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VinDescriptor_Stddev_Pop_Fields_Vpic = {
  __typename?: 'VinDescriptor_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VinDescriptor_Stddev_Samp_Fields_Vpic = {
  __typename?: 'VinDescriptor_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelYear?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "VinDescriptor" */
export type VinDescriptor_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VinDescriptor_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VinDescriptor_Stream_Cursor_Value_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Descriptor?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['Int']>;
  ModelYear?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type VinDescriptor_Sum_Fields_Vpic = {
  __typename?: 'VinDescriptor_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  ModelYear?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.vindescriptor" */
export enum VinDescriptor_Update_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Descriptor = 'Descriptor',
  /** column name */
  Id = 'Id',
  /** column name */
  ModelYear = 'ModelYear',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type VinDescriptor_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VinDescriptor_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VinDescriptor_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: VinDescriptor_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type VinDescriptor_Var_Pop_Fields_Vpic = {
  __typename?: 'VinDescriptor_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelYear?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VinDescriptor_Var_Samp_Fields_Vpic = {
  __typename?: 'VinDescriptor_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelYear?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VinDescriptor_Variance_Fields_Vpic = {
  __typename?: 'VinDescriptor_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  ModelYear?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.vindescriptor" */
export type VinDescriptor_Vpic = {
  __typename?: 'VinDescriptor_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Descriptor: Scalars['String'];
  Id: Scalars['Int'];
  ModelYear: Scalars['Int'];
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate fields of "vpic.vinexception" */
export type VinException_Aggregate_Fields_Vpic = {
  __typename?: 'VinException_aggregate_fields_vpic';
  avg?: Maybe<VinException_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VinException_Max_Fields_Vpic>;
  min?: Maybe<VinException_Min_Fields_Vpic>;
  stddev?: Maybe<VinException_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VinException_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VinException_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VinException_Sum_Fields_Vpic>;
  var_pop?: Maybe<VinException_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VinException_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VinException_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vinexception" */
export type VinException_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VinException_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.vinexception" */
export type VinException_Aggregate_Vpic = {
  __typename?: 'VinException_aggregate_vpic';
  aggregate?: Maybe<VinException_Aggregate_Fields_Vpic>;
  nodes: Array<VinException_Vpic>;
};

/** aggregate avg on columns */
export type VinException_Avg_Fields_Vpic = {
  __typename?: 'VinException_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.vinexception". All fields are combined with a logical 'AND'. */
export type VinException_Bool_Exp_Vpic = {
  CheckDigit?: InputMaybe<Boolean_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  VIN?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<VinException_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VinException_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VinException_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.vinexception" */
export enum VinException_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkVinexception = 'pk_vinexception'
}

/** input type for incrementing numeric columns in table "vpic.vinexception" */
export type VinException_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.vinexception" */
export type VinException_Insert_Input_Vpic = {
  CheckDigit?: InputMaybe<Scalars['Boolean']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VIN?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VinException_Max_Fields_Vpic = {
  __typename?: 'VinException_max_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VIN?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VinException_Min_Fields_Vpic = {
  __typename?: 'VinException_min_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VIN?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.vinexception" */
export type VinException_Mutation_Response_Vpic = {
  __typename?: 'VinException_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VinException_Vpic>;
};

/** on_conflict condition type for table "vpic.vinexception" */
export type VinException_On_Conflict_Vpic = {
  constraint: VinException_Constraint_Vpic;
  update_columns?: Array<VinException_Update_Column_Vpic>;
  where?: InputMaybe<VinException_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.vinexception". */
export type VinException_Order_By_Vpic = {
  CheckDigit?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VIN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.vinexception */
export type VinException_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.vinexception" */
export enum VinException_Select_Column_Vpic {
  /** column name */
  CheckDigit = 'CheckDigit',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Vin = 'VIN'
}

/** input type for updating data in table "vpic.vinexception" */
export type VinException_Set_Input_Vpic = {
  CheckDigit?: InputMaybe<Scalars['Boolean']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VIN?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type VinException_Stddev_Fields_Vpic = {
  __typename?: 'VinException_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VinException_Stddev_Pop_Fields_Vpic = {
  __typename?: 'VinException_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VinException_Stddev_Samp_Fields_Vpic = {
  __typename?: 'VinException_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "VinException" */
export type VinException_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VinException_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VinException_Stream_Cursor_Value_Input_Vpic = {
  CheckDigit?: InputMaybe<Scalars['Boolean']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VIN?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type VinException_Sum_Fields_Vpic = {
  __typename?: 'VinException_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.vinexception" */
export enum VinException_Update_Column_Vpic {
  /** column name */
  CheckDigit = 'CheckDigit',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Vin = 'VIN'
}

export type VinException_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VinException_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VinException_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: VinException_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type VinException_Var_Pop_Fields_Vpic = {
  __typename?: 'VinException_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VinException_Var_Samp_Fields_Vpic = {
  __typename?: 'VinException_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VinException_Variance_Fields_Vpic = {
  __typename?: 'VinException_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.vinexception" */
export type VinException_Vpic = {
  __typename?: 'VinException_vpic';
  CheckDigit: Scalars['Boolean'];
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id: Scalars['Int'];
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VIN: Scalars['String'];
};

/** aggregate fields of "vpic.vinschema" */
export type VinSchema_Aggregate_Fields_Vpic = {
  __typename?: 'VinSchema_aggregate_fields_vpic';
  avg?: Maybe<VinSchema_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VinSchema_Max_Fields_Vpic>;
  min?: Maybe<VinSchema_Min_Fields_Vpic>;
  stddev?: Maybe<VinSchema_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VinSchema_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VinSchema_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VinSchema_Sum_Fields_Vpic>;
  var_pop?: Maybe<VinSchema_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VinSchema_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VinSchema_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vinschema" */
export type VinSchema_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VinSchema_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.vinschema" */
export type VinSchema_Aggregate_Vpic = {
  __typename?: 'VinSchema_aggregate_vpic';
  aggregate?: Maybe<VinSchema_Aggregate_Fields_Vpic>;
  nodes: Array<VinSchema_Vpic>;
};

/** aggregate avg on columns */
export type VinSchema_Avg_Fields_Vpic = {
  __typename?: 'VinSchema_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.vinschema". All fields are combined with a logical 'AND'. */
export type VinSchema_Bool_Exp_Vpic = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Patterns?: InputMaybe<Pattern_Bool_Exp_Vpic>;
  Patterns_aggregate?: InputMaybe<Pattern_Aggregate_Bool_Exp>;
  TobeQCed?: InputMaybe<Boolean_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Wmi_VinSchemas?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
  Wmi_VinSchemas_aggregate?: InputMaybe<Wmi_VinSchema_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<VinSchema_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VinSchema_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VinSchema_Bool_Exp_Vpic>>;
  sourcewmi?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vpic.vinschema" */
export enum VinSchema_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkVinschema = 'pk_vinschema'
}

/** input type for incrementing numeric columns in table "vpic.vinschema" */
export type VinSchema_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.vinschema" */
export type VinSchema_Insert_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  Patterns?: InputMaybe<Pattern_Arr_Rel_Insert_Input_Vpic>;
  TobeQCed?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Wmi_VinSchemas?: InputMaybe<Wmi_VinSchema_Arr_Rel_Insert_Input_Vpic>;
  sourcewmi?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VinSchema_Max_Fields_Vpic = {
  __typename?: 'VinSchema_max_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  sourcewmi?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VinSchema_Min_Fields_Vpic = {
  __typename?: 'VinSchema_min_fields_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  sourcewmi?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.vinschema" */
export type VinSchema_Mutation_Response_Vpic = {
  __typename?: 'VinSchema_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VinSchema_Vpic>;
};

/** input type for inserting object relation for remote table "vpic.vinschema" */
export type VinSchema_Obj_Rel_Insert_Input_Vpic = {
  data: VinSchema_Insert_Input_Vpic;
  /** upsert condition */
  on_conflict?: InputMaybe<VinSchema_On_Conflict_Vpic>;
};

/** on_conflict condition type for table "vpic.vinschema" */
export type VinSchema_On_Conflict_Vpic = {
  constraint: VinSchema_Constraint_Vpic;
  update_columns?: Array<VinSchema_Update_Column_Vpic>;
  where?: InputMaybe<VinSchema_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.vinschema". */
export type VinSchema_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Patterns_aggregate?: InputMaybe<Pattern_Aggregate_Order_By_Vpic>;
  TobeQCed?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Wmi_VinSchemas_aggregate?: InputMaybe<Wmi_VinSchema_Aggregate_Order_By_Vpic>;
  sourcewmi?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.vinschema */
export type VinSchema_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.vinschema" */
export enum VinSchema_Select_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  TobeQCed = 'TobeQCed',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Sourcewmi = 'sourcewmi'
}

/** input type for updating data in table "vpic.vinschema" */
export type VinSchema_Set_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  TobeQCed?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  sourcewmi?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type VinSchema_Stddev_Fields_Vpic = {
  __typename?: 'VinSchema_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VinSchema_Stddev_Pop_Fields_Vpic = {
  __typename?: 'VinSchema_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VinSchema_Stddev_Samp_Fields_Vpic = {
  __typename?: 'VinSchema_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "VinSchema" */
export type VinSchema_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VinSchema_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VinSchema_Stream_Cursor_Value_Input_Vpic = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
  TobeQCed?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  sourcewmi?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type VinSchema_Sum_Fields_Vpic = {
  __typename?: 'VinSchema_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.vinschema" */
export enum VinSchema_Update_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  TobeQCed = 'TobeQCed',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Sourcewmi = 'sourcewmi'
}

export type VinSchema_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VinSchema_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VinSchema_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: VinSchema_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type VinSchema_Var_Pop_Fields_Vpic = {
  __typename?: 'VinSchema_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VinSchema_Var_Samp_Fields_Vpic = {
  __typename?: 'VinSchema_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VinSchema_Variance_Fields_Vpic = {
  __typename?: 'VinSchema_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.vinschema" */
export type VinSchema_Vpic = {
  __typename?: 'VinSchema_vpic';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id: Scalars['Int'];
  Name: Scalars['String'];
  /** An array relationship */
  Patterns: Array<Pattern_Vpic>;
  /** An aggregate relationship */
  Patterns_aggregate: Pattern_Aggregate_Vpic;
  TobeQCed?: Maybe<Scalars['Boolean']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  Wmi_VinSchemas: Array<Wmi_VinSchema_Vpic>;
  /** An aggregate relationship */
  Wmi_VinSchemas_aggregate: Wmi_VinSchema_Aggregate_Vpic;
  sourcewmi?: Maybe<Scalars['String']>;
};


/** columns and relationships of "vpic.vinschema" */
export type VinSchema_VpicPatternsArgs = {
  distinct_on?: InputMaybe<Array<Pattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pattern_Order_By_Vpic>>;
  where?: InputMaybe<Pattern_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.vinschema" */
export type VinSchema_VpicPatterns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pattern_Order_By_Vpic>>;
  where?: InputMaybe<Pattern_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.vinschema" */
export type VinSchema_VpicWmi_VinSchemasArgs = {
  distinct_on?: InputMaybe<Array<Wmi_VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.vinschema" */
export type VinSchema_VpicWmi_VinSchemas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
};

/** aggregate fields of "vpic.wmiyearvalidchars_cacheexceptions" */
export type WmiYearValidChars_CacheExceptions_Aggregate_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_aggregate_fields_vpic';
  avg?: Maybe<WmiYearValidChars_CacheExceptions_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<WmiYearValidChars_CacheExceptions_Max_Fields_Vpic>;
  min?: Maybe<WmiYearValidChars_CacheExceptions_Min_Fields_Vpic>;
  stddev?: Maybe<WmiYearValidChars_CacheExceptions_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<WmiYearValidChars_CacheExceptions_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<WmiYearValidChars_CacheExceptions_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<WmiYearValidChars_CacheExceptions_Sum_Fields_Vpic>;
  var_pop?: Maybe<WmiYearValidChars_CacheExceptions_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<WmiYearValidChars_CacheExceptions_Var_Samp_Fields_Vpic>;
  variance?: Maybe<WmiYearValidChars_CacheExceptions_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.wmiyearvalidchars_cacheexceptions" */
export type WmiYearValidChars_CacheExceptions_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.wmiyearvalidchars_cacheexceptions" */
export type WmiYearValidChars_CacheExceptions_Aggregate_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_aggregate_vpic';
  aggregate?: Maybe<WmiYearValidChars_CacheExceptions_Aggregate_Fields_Vpic>;
  nodes: Array<WmiYearValidChars_CacheExceptions_Vpic>;
};

/** aggregate avg on columns */
export type WmiYearValidChars_CacheExceptions_Avg_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.wmiyearvalidchars_cacheexceptions". All fields are combined with a logical 'AND'. */
export type WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic = {
  CreatedOn?: InputMaybe<Timestamp_Array_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  WMI?: InputMaybe<String_Array_Comparison_Exp>;
  _and?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic>>;
  _not?: InputMaybe<WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic>>;
};

/** input type for incrementing numeric columns in table "vpic.wmiyearvalidchars_cacheexceptions" */
export type WmiYearValidChars_CacheExceptions_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.wmiyearvalidchars_cacheexceptions" */
export type WmiYearValidChars_CacheExceptions_Insert_Input_Vpic = {
  CreatedOn?: InputMaybe<Array<Scalars['timestamp']>>;
  Id?: InputMaybe<Scalars['Int']>;
  WMI?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate max on columns */
export type WmiYearValidChars_CacheExceptions_Max_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_max_fields_vpic';
  CreatedOn?: Maybe<Array<Scalars['timestamp']>>;
  Id?: Maybe<Scalars['Int']>;
  WMI?: Maybe<Array<Scalars['String']>>;
};

/** aggregate min on columns */
export type WmiYearValidChars_CacheExceptions_Min_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_min_fields_vpic';
  CreatedOn?: Maybe<Array<Scalars['timestamp']>>;
  Id?: Maybe<Scalars['Int']>;
  WMI?: Maybe<Array<Scalars['String']>>;
};

/** response of any mutation on the table "vpic.wmiyearvalidchars_cacheexceptions" */
export type WmiYearValidChars_CacheExceptions_Mutation_Response_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WmiYearValidChars_CacheExceptions_Vpic>;
};

/** Ordering options when selecting data from "vpic.wmiyearvalidchars_cacheexceptions". */
export type WmiYearValidChars_CacheExceptions_Order_By_Vpic = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  WMI?: InputMaybe<Order_By>;
};

/** select columns of table "vpic.wmiyearvalidchars_cacheexceptions" */
export enum WmiYearValidChars_CacheExceptions_Select_Column_Vpic {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Wmi = 'WMI'
}

/** input type for updating data in table "vpic.wmiyearvalidchars_cacheexceptions" */
export type WmiYearValidChars_CacheExceptions_Set_Input_Vpic = {
  CreatedOn?: InputMaybe<Array<Scalars['timestamp']>>;
  Id?: InputMaybe<Scalars['Int']>;
  WMI?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate stddev on columns */
export type WmiYearValidChars_CacheExceptions_Stddev_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WmiYearValidChars_CacheExceptions_Stddev_Pop_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WmiYearValidChars_CacheExceptions_Stddev_Samp_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "WMIYearValidChars_CacheExceptions" */
export type WmiYearValidChars_CacheExceptions_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: WmiYearValidChars_CacheExceptions_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type WmiYearValidChars_CacheExceptions_Stream_Cursor_Value_Input_Vpic = {
  CreatedOn?: InputMaybe<Array<Scalars['timestamp']>>;
  Id?: InputMaybe<Scalars['Int']>;
  WMI?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate sum on columns */
export type WmiYearValidChars_CacheExceptions_Sum_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

export type WmiYearValidChars_CacheExceptions_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WmiYearValidChars_CacheExceptions_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WmiYearValidChars_CacheExceptions_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type WmiYearValidChars_CacheExceptions_Var_Pop_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WmiYearValidChars_CacheExceptions_Var_Samp_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WmiYearValidChars_CacheExceptions_Variance_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.wmiyearvalidchars_cacheexceptions" */
export type WmiYearValidChars_CacheExceptions_Vpic = {
  __typename?: 'WMIYearValidChars_CacheExceptions_vpic';
  CreatedOn?: Maybe<Array<Scalars['timestamp']>>;
  Id?: Maybe<Scalars['Int']>;
  WMI?: Maybe<Array<Scalars['String']>>;
};

/** aggregate fields of "vpic.wmiyearvalidchars" */
export type WmiYearValidChars_Aggregate_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_aggregate_fields_vpic';
  avg?: Maybe<WmiYearValidChars_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<WmiYearValidChars_Max_Fields_Vpic>;
  min?: Maybe<WmiYearValidChars_Min_Fields_Vpic>;
  stddev?: Maybe<WmiYearValidChars_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<WmiYearValidChars_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<WmiYearValidChars_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<WmiYearValidChars_Sum_Fields_Vpic>;
  var_pop?: Maybe<WmiYearValidChars_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<WmiYearValidChars_Var_Samp_Fields_Vpic>;
  variance?: Maybe<WmiYearValidChars_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.wmiyearvalidchars" */
export type WmiYearValidChars_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<WmiYearValidChars_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.wmiyearvalidchars" */
export type WmiYearValidChars_Aggregate_Vpic = {
  __typename?: 'WMIYearValidChars_aggregate_vpic';
  aggregate?: Maybe<WmiYearValidChars_Aggregate_Fields_Vpic>;
  nodes: Array<WmiYearValidChars_Vpic>;
};

/** aggregate avg on columns */
export type WmiYearValidChars_Avg_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_avg_fields_vpic';
  Position?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.wmiyearvalidchars". All fields are combined with a logical 'AND'. */
export type WmiYearValidChars_Bool_Exp_Vpic = {
  Char?: InputMaybe<String_Comparison_Exp>;
  Position?: InputMaybe<Int_Comparison_Exp>;
  WMI?: InputMaybe<String_Comparison_Exp>;
  Year?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<WmiYearValidChars_Bool_Exp_Vpic>>;
  _not?: InputMaybe<WmiYearValidChars_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<WmiYearValidChars_Bool_Exp_Vpic>>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vpic.wmiyearvalidchars" */
export enum WmiYearValidChars_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkWmiyearvalidchars = 'pk_wmiyearvalidchars'
}

/** input type for incrementing numeric columns in table "vpic.wmiyearvalidchars" */
export type WmiYearValidChars_Inc_Input_Vpic = {
  Position?: InputMaybe<Scalars['Int']>;
  Year?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.wmiyearvalidchars" */
export type WmiYearValidChars_Insert_Input_Vpic = {
  Char?: InputMaybe<Scalars['String']>;
  Position?: InputMaybe<Scalars['Int']>;
  WMI?: InputMaybe<Scalars['String']>;
  Year?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type WmiYearValidChars_Max_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_max_fields_vpic';
  Char?: Maybe<Scalars['String']>;
  Position?: Maybe<Scalars['Int']>;
  WMI?: Maybe<Scalars['String']>;
  Year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type WmiYearValidChars_Min_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_min_fields_vpic';
  Char?: Maybe<Scalars['String']>;
  Position?: Maybe<Scalars['Int']>;
  WMI?: Maybe<Scalars['String']>;
  Year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vpic.wmiyearvalidchars" */
export type WmiYearValidChars_Mutation_Response_Vpic = {
  __typename?: 'WMIYearValidChars_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WmiYearValidChars_Vpic>;
};

/** on_conflict condition type for table "vpic.wmiyearvalidchars" */
export type WmiYearValidChars_On_Conflict_Vpic = {
  constraint: WmiYearValidChars_Constraint_Vpic;
  update_columns?: Array<WmiYearValidChars_Update_Column_Vpic>;
  where?: InputMaybe<WmiYearValidChars_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.wmiyearvalidchars". */
export type WmiYearValidChars_Order_By_Vpic = {
  Char?: InputMaybe<Order_By>;
  Position?: InputMaybe<Order_By>;
  WMI?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.wmiyearvalidchars */
export type WmiYearValidChars_Pk_Columns_Input_Vpic = {
  id: Scalars['Int'];
};

/** select columns of table "vpic.wmiyearvalidchars" */
export enum WmiYearValidChars_Select_Column_Vpic {
  /** column name */
  Char = 'Char',
  /** column name */
  Position = 'Position',
  /** column name */
  Wmi = 'WMI',
  /** column name */
  Year = 'Year',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "vpic.wmiyearvalidchars" */
export type WmiYearValidChars_Set_Input_Vpic = {
  Char?: InputMaybe<Scalars['String']>;
  Position?: InputMaybe<Scalars['Int']>;
  WMI?: InputMaybe<Scalars['String']>;
  Year?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type WmiYearValidChars_Stddev_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_stddev_fields_vpic';
  Position?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WmiYearValidChars_Stddev_Pop_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_stddev_pop_fields_vpic';
  Position?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WmiYearValidChars_Stddev_Samp_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_stddev_samp_fields_vpic';
  Position?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "WMIYearValidChars" */
export type WmiYearValidChars_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: WmiYearValidChars_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type WmiYearValidChars_Stream_Cursor_Value_Input_Vpic = {
  Char?: InputMaybe<Scalars['String']>;
  Position?: InputMaybe<Scalars['Int']>;
  WMI?: InputMaybe<Scalars['String']>;
  Year?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type WmiYearValidChars_Sum_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_sum_fields_vpic';
  Position?: Maybe<Scalars['Int']>;
  Year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.wmiyearvalidchars" */
export enum WmiYearValidChars_Update_Column_Vpic {
  /** column name */
  Char = 'Char',
  /** column name */
  Position = 'Position',
  /** column name */
  Wmi = 'WMI',
  /** column name */
  Year = 'Year',
  /** column name */
  Id = 'id'
}

export type WmiYearValidChars_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WmiYearValidChars_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WmiYearValidChars_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: WmiYearValidChars_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type WmiYearValidChars_Var_Pop_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_var_pop_fields_vpic';
  Position?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WmiYearValidChars_Var_Samp_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_var_samp_fields_vpic';
  Position?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WmiYearValidChars_Variance_Fields_Vpic = {
  __typename?: 'WMIYearValidChars_variance_fields_vpic';
  Position?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.wmiyearvalidchars" */
export type WmiYearValidChars_Vpic = {
  __typename?: 'WMIYearValidChars_vpic';
  Char?: Maybe<Scalars['String']>;
  Position?: Maybe<Scalars['Int']>;
  WMI: Scalars['String'];
  Year: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregate fields of "vpic.wheelbasetype" */
export type WheelBaseType_Aggregate_Fields_Vpic = {
  __typename?: 'WheelBaseType_aggregate_fields_vpic';
  avg?: Maybe<WheelBaseType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<WheelBaseType_Max_Fields_Vpic>;
  min?: Maybe<WheelBaseType_Min_Fields_Vpic>;
  stddev?: Maybe<WheelBaseType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<WheelBaseType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<WheelBaseType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<WheelBaseType_Sum_Fields_Vpic>;
  var_pop?: Maybe<WheelBaseType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<WheelBaseType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<WheelBaseType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.wheelbasetype" */
export type WheelBaseType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<WheelBaseType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.wheelbasetype" */
export type WheelBaseType_Aggregate_Vpic = {
  __typename?: 'WheelBaseType_aggregate_vpic';
  aggregate?: Maybe<WheelBaseType_Aggregate_Fields_Vpic>;
  nodes: Array<WheelBaseType_Vpic>;
};

/** aggregate avg on columns */
export type WheelBaseType_Avg_Fields_Vpic = {
  __typename?: 'WheelBaseType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.wheelbasetype". All fields are combined with a logical 'AND'. */
export type WheelBaseType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<WheelBaseType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<WheelBaseType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<WheelBaseType_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.wheelbasetype" */
export enum WheelBaseType_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkWheelbasetype = 'pk_wheelbasetype',
  /** unique or primary key constraint on columns "name" */
  UWheelbasetypename = 'u_wheelbasetypename'
}

/** input type for incrementing numeric columns in table "vpic.wheelbasetype" */
export type WheelBaseType_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.wheelbasetype" */
export type WheelBaseType_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type WheelBaseType_Max_Fields_Vpic = {
  __typename?: 'WheelBaseType_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type WheelBaseType_Min_Fields_Vpic = {
  __typename?: 'WheelBaseType_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.wheelbasetype" */
export type WheelBaseType_Mutation_Response_Vpic = {
  __typename?: 'WheelBaseType_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WheelBaseType_Vpic>;
};

/** on_conflict condition type for table "vpic.wheelbasetype" */
export type WheelBaseType_On_Conflict_Vpic = {
  constraint: WheelBaseType_Constraint_Vpic;
  update_columns?: Array<WheelBaseType_Update_Column_Vpic>;
  where?: InputMaybe<WheelBaseType_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.wheelbasetype". */
export type WheelBaseType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.wheelbasetype */
export type WheelBaseType_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.wheelbasetype" */
export enum WheelBaseType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.wheelbasetype" */
export type WheelBaseType_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type WheelBaseType_Stddev_Fields_Vpic = {
  __typename?: 'WheelBaseType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WheelBaseType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'WheelBaseType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WheelBaseType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'WheelBaseType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "WheelBaseType" */
export type WheelBaseType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: WheelBaseType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type WheelBaseType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type WheelBaseType_Sum_Fields_Vpic = {
  __typename?: 'WheelBaseType_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.wheelbasetype" */
export enum WheelBaseType_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type WheelBaseType_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WheelBaseType_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WheelBaseType_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: WheelBaseType_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type WheelBaseType_Var_Pop_Fields_Vpic = {
  __typename?: 'WheelBaseType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WheelBaseType_Var_Samp_Fields_Vpic = {
  __typename?: 'WheelBaseType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WheelBaseType_Variance_Fields_Vpic = {
  __typename?: 'WheelBaseType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.wheelbasetype" */
export type WheelBaseType_Vpic = {
  __typename?: 'WheelBaseType_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

/** aggregate fields of "vpic.wheeliemitigation" */
export type WheelieMitigation_Aggregate_Fields_Vpic = {
  __typename?: 'WheelieMitigation_aggregate_fields_vpic';
  avg?: Maybe<WheelieMitigation_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<WheelieMitigation_Max_Fields_Vpic>;
  min?: Maybe<WheelieMitigation_Min_Fields_Vpic>;
  stddev?: Maybe<WheelieMitigation_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<WheelieMitigation_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<WheelieMitigation_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<WheelieMitigation_Sum_Fields_Vpic>;
  var_pop?: Maybe<WheelieMitigation_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<WheelieMitigation_Var_Samp_Fields_Vpic>;
  variance?: Maybe<WheelieMitigation_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.wheeliemitigation" */
export type WheelieMitigation_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<WheelieMitigation_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.wheeliemitigation" */
export type WheelieMitigation_Aggregate_Vpic = {
  __typename?: 'WheelieMitigation_aggregate_vpic';
  aggregate?: Maybe<WheelieMitigation_Aggregate_Fields_Vpic>;
  nodes: Array<WheelieMitigation_Vpic>;
};

/** aggregate avg on columns */
export type WheelieMitigation_Avg_Fields_Vpic = {
  __typename?: 'WheelieMitigation_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.wheeliemitigation". All fields are combined with a logical 'AND'. */
export type WheelieMitigation_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<WheelieMitigation_Bool_Exp_Vpic>>;
  _not?: InputMaybe<WheelieMitigation_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<WheelieMitigation_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.wheeliemitigation" */
export enum WheelieMitigation_Constraint_Vpic {
  /** unique or primary key constraint on columns "id" */
  PkWheeliemitigation = 'pk_wheeliemitigation',
  /** unique or primary key constraint on columns "name" */
  UWheeliemitigation = 'u_wheeliemitigation'
}

/** input type for incrementing numeric columns in table "vpic.wheeliemitigation" */
export type WheelieMitigation_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.wheeliemitigation" */
export type WheelieMitigation_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type WheelieMitigation_Max_Fields_Vpic = {
  __typename?: 'WheelieMitigation_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type WheelieMitigation_Min_Fields_Vpic = {
  __typename?: 'WheelieMitigation_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vpic.wheeliemitigation" */
export type WheelieMitigation_Mutation_Response_Vpic = {
  __typename?: 'WheelieMitigation_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WheelieMitigation_Vpic>;
};

/** on_conflict condition type for table "vpic.wheeliemitigation" */
export type WheelieMitigation_On_Conflict_Vpic = {
  constraint: WheelieMitigation_Constraint_Vpic;
  update_columns?: Array<WheelieMitigation_Update_Column_Vpic>;
  where?: InputMaybe<WheelieMitigation_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.wheeliemitigation". */
export type WheelieMitigation_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.wheeliemitigation */
export type WheelieMitigation_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.wheeliemitigation" */
export enum WheelieMitigation_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vpic.wheeliemitigation" */
export type WheelieMitigation_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type WheelieMitigation_Stddev_Fields_Vpic = {
  __typename?: 'WheelieMitigation_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WheelieMitigation_Stddev_Pop_Fields_Vpic = {
  __typename?: 'WheelieMitigation_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WheelieMitigation_Stddev_Samp_Fields_Vpic = {
  __typename?: 'WheelieMitigation_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "WheelieMitigation" */
export type WheelieMitigation_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: WheelieMitigation_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type WheelieMitigation_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type WheelieMitigation_Sum_Fields_Vpic = {
  __typename?: 'WheelieMitigation_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vpic.wheeliemitigation" */
export enum WheelieMitigation_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

export type WheelieMitigation_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WheelieMitigation_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WheelieMitigation_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: WheelieMitigation_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type WheelieMitigation_Var_Pop_Fields_Vpic = {
  __typename?: 'WheelieMitigation_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WheelieMitigation_Var_Samp_Fields_Vpic = {
  __typename?: 'WheelieMitigation_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WheelieMitigation_Variance_Fields_Vpic = {
  __typename?: 'WheelieMitigation_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.wheeliemitigation" */
export type WheelieMitigation_Vpic = {
  __typename?: 'WheelieMitigation_vpic';
  Id: Scalars['Int'];
  Name: Scalars['String'];
};

export type Wmi_Make_Aggregate_Bool_Exp = {
  count?: InputMaybe<Wmi_Make_Aggregate_Bool_Exp_Count>;
};

export type Wmi_Make_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wmi_Make_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vpic.wmi_make" */
export type Wmi_Make_Aggregate_Fields_Vpic = {
  __typename?: 'Wmi_Make_aggregate_fields_vpic';
  avg?: Maybe<Wmi_Make_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Wmi_Make_Max_Fields_Vpic>;
  min?: Maybe<Wmi_Make_Min_Fields_Vpic>;
  stddev?: Maybe<Wmi_Make_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Wmi_Make_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Wmi_Make_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Wmi_Make_Sum_Fields_Vpic>;
  var_pop?: Maybe<Wmi_Make_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Wmi_Make_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Wmi_Make_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.wmi_make" */
export type Wmi_Make_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Wmi_Make_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vpic.wmi_make" */
export type Wmi_Make_Aggregate_Order_By_Vpic = {
  avg?: InputMaybe<Wmi_Make_Avg_Order_By_Vpic>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wmi_Make_Max_Order_By_Vpic>;
  min?: InputMaybe<Wmi_Make_Min_Order_By_Vpic>;
  stddev?: InputMaybe<Wmi_Make_Stddev_Order_By_Vpic>;
  stddev_pop?: InputMaybe<Wmi_Make_Stddev_Pop_Order_By_Vpic>;
  stddev_samp?: InputMaybe<Wmi_Make_Stddev_Samp_Order_By_Vpic>;
  sum?: InputMaybe<Wmi_Make_Sum_Order_By_Vpic>;
  var_pop?: InputMaybe<Wmi_Make_Var_Pop_Order_By_Vpic>;
  var_samp?: InputMaybe<Wmi_Make_Var_Samp_Order_By_Vpic>;
  variance?: InputMaybe<Wmi_Make_Variance_Order_By_Vpic>;
};

/** aggregated selection of "vpic.wmi_make" */
export type Wmi_Make_Aggregate_Vpic = {
  __typename?: 'Wmi_Make_aggregate_vpic';
  aggregate?: Maybe<Wmi_Make_Aggregate_Fields_Vpic>;
  nodes: Array<Wmi_Make_Vpic>;
};

/** input type for inserting array relation for remote table "vpic.wmi_make" */
export type Wmi_Make_Arr_Rel_Insert_Input_Vpic = {
  data: Array<Wmi_Make_Insert_Input_Vpic>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wmi_Make_On_Conflict_Vpic>;
};

/** aggregate avg on columns */
export type Wmi_Make_Avg_Fields_Vpic = {
  __typename?: 'Wmi_Make_avg_fields_vpic';
  MakeId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vpic.wmi_make" */
export type Wmi_Make_Avg_Order_By_Vpic = {
  MakeId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vpic.wmi_make". All fields are combined with a logical 'AND'. */
export type Wmi_Make_Bool_Exp_Vpic = {
  Make?: InputMaybe<Make_Bool_Exp_Vpic>;
  MakeId?: InputMaybe<Int_Comparison_Exp>;
  Wmi?: InputMaybe<Wmi_Bool_Exp_Vpic>;
  WmiId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Wmi_Make_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Wmi_Make_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.wmi_make" */
export enum Wmi_Make_Constraint_Vpic {
  /** unique or primary key constraint on columns "makeid", "wmiid" */
  PkWmiMake = 'pk_wmi_make'
}

/** input type for incrementing numeric columns in table "vpic.wmi_make" */
export type Wmi_Make_Inc_Input_Vpic = {
  MakeId?: InputMaybe<Scalars['Int']>;
  WmiId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.wmi_make" */
export type Wmi_Make_Insert_Input_Vpic = {
  Make?: InputMaybe<Make_Obj_Rel_Insert_Input_Vpic>;
  MakeId?: InputMaybe<Scalars['Int']>;
  Wmi?: InputMaybe<Wmi_Obj_Rel_Insert_Input_Vpic>;
  WmiId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Wmi_Make_Max_Fields_Vpic = {
  __typename?: 'Wmi_Make_max_fields_vpic';
  MakeId?: Maybe<Scalars['Int']>;
  WmiId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vpic.wmi_make" */
export type Wmi_Make_Max_Order_By_Vpic = {
  MakeId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wmi_Make_Min_Fields_Vpic = {
  __typename?: 'Wmi_Make_min_fields_vpic';
  MakeId?: Maybe<Scalars['Int']>;
  WmiId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vpic.wmi_make" */
export type Wmi_Make_Min_Order_By_Vpic = {
  MakeId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vpic.wmi_make" */
export type Wmi_Make_Mutation_Response_Vpic = {
  __typename?: 'Wmi_Make_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Wmi_Make_Vpic>;
};

/** on_conflict condition type for table "vpic.wmi_make" */
export type Wmi_Make_On_Conflict_Vpic = {
  constraint: Wmi_Make_Constraint_Vpic;
  update_columns?: Array<Wmi_Make_Update_Column_Vpic>;
  where?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.wmi_make". */
export type Wmi_Make_Order_By_Vpic = {
  Make?: InputMaybe<Make_Order_By_Vpic>;
  MakeId?: InputMaybe<Order_By>;
  Wmi?: InputMaybe<Wmi_Order_By_Vpic>;
  WmiId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.wmi_make */
export type Wmi_Make_Pk_Columns_Input_Vpic = {
  MakeId: Scalars['Int'];
  WmiId: Scalars['Int'];
};

/** select columns of table "vpic.wmi_make" */
export enum Wmi_Make_Select_Column_Vpic {
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  WmiId = 'WmiId'
}

/** input type for updating data in table "vpic.wmi_make" */
export type Wmi_Make_Set_Input_Vpic = {
  MakeId?: InputMaybe<Scalars['Int']>;
  WmiId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Wmi_Make_Stddev_Fields_Vpic = {
  __typename?: 'Wmi_Make_stddev_fields_vpic';
  MakeId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vpic.wmi_make" */
export type Wmi_Make_Stddev_Order_By_Vpic = {
  MakeId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wmi_Make_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Wmi_Make_stddev_pop_fields_vpic';
  MakeId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vpic.wmi_make" */
export type Wmi_Make_Stddev_Pop_Order_By_Vpic = {
  MakeId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wmi_Make_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Wmi_Make_stddev_samp_fields_vpic';
  MakeId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vpic.wmi_make" */
export type Wmi_Make_Stddev_Samp_Order_By_Vpic = {
  MakeId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Wmi_Make" */
export type Wmi_Make_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Wmi_Make_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Wmi_Make_Stream_Cursor_Value_Input_Vpic = {
  MakeId?: InputMaybe<Scalars['Int']>;
  WmiId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Wmi_Make_Sum_Fields_Vpic = {
  __typename?: 'Wmi_Make_sum_fields_vpic';
  MakeId?: Maybe<Scalars['Int']>;
  WmiId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vpic.wmi_make" */
export type Wmi_Make_Sum_Order_By_Vpic = {
  MakeId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
};

/** update columns of table "vpic.wmi_make" */
export enum Wmi_Make_Update_Column_Vpic {
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  WmiId = 'WmiId'
}

export type Wmi_Make_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wmi_Make_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wmi_Make_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Wmi_Make_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Wmi_Make_Var_Pop_Fields_Vpic = {
  __typename?: 'Wmi_Make_var_pop_fields_vpic';
  MakeId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vpic.wmi_make" */
export type Wmi_Make_Var_Pop_Order_By_Vpic = {
  MakeId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wmi_Make_Var_Samp_Fields_Vpic = {
  __typename?: 'Wmi_Make_var_samp_fields_vpic';
  MakeId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vpic.wmi_make" */
export type Wmi_Make_Var_Samp_Order_By_Vpic = {
  MakeId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wmi_Make_Variance_Fields_Vpic = {
  __typename?: 'Wmi_Make_variance_fields_vpic';
  MakeId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vpic.wmi_make" */
export type Wmi_Make_Variance_Order_By_Vpic = {
  MakeId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
};

/** columns and relationships of "vpic.wmi_make" */
export type Wmi_Make_Vpic = {
  __typename?: 'Wmi_Make_vpic';
  /** An object relationship */
  Make?: Maybe<Make_Vpic>;
  MakeId: Scalars['Int'];
  /** An object relationship */
  Wmi?: Maybe<Wmi_Vpic>;
  WmiId: Scalars['Int'];
};

export type Wmi_VinSchema_Aggregate_Bool_Exp = {
  count?: InputMaybe<Wmi_VinSchema_Aggregate_Bool_Exp_Count>;
};

export type Wmi_VinSchema_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wmi_VinSchema_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Aggregate_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_aggregate_fields_vpic';
  avg?: Maybe<Wmi_VinSchema_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Wmi_VinSchema_Max_Fields_Vpic>;
  min?: Maybe<Wmi_VinSchema_Min_Fields_Vpic>;
  stddev?: Maybe<Wmi_VinSchema_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Wmi_VinSchema_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Wmi_VinSchema_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Wmi_VinSchema_Sum_Fields_Vpic>;
  var_pop?: Maybe<Wmi_VinSchema_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Wmi_VinSchema_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Wmi_VinSchema_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Wmi_VinSchema_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Aggregate_Order_By_Vpic = {
  avg?: InputMaybe<Wmi_VinSchema_Avg_Order_By_Vpic>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wmi_VinSchema_Max_Order_By_Vpic>;
  min?: InputMaybe<Wmi_VinSchema_Min_Order_By_Vpic>;
  stddev?: InputMaybe<Wmi_VinSchema_Stddev_Order_By_Vpic>;
  stddev_pop?: InputMaybe<Wmi_VinSchema_Stddev_Pop_Order_By_Vpic>;
  stddev_samp?: InputMaybe<Wmi_VinSchema_Stddev_Samp_Order_By_Vpic>;
  sum?: InputMaybe<Wmi_VinSchema_Sum_Order_By_Vpic>;
  var_pop?: InputMaybe<Wmi_VinSchema_Var_Pop_Order_By_Vpic>;
  var_samp?: InputMaybe<Wmi_VinSchema_Var_Samp_Order_By_Vpic>;
  variance?: InputMaybe<Wmi_VinSchema_Variance_Order_By_Vpic>;
};

/** aggregated selection of "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Aggregate_Vpic = {
  __typename?: 'Wmi_VinSchema_aggregate_vpic';
  aggregate?: Maybe<Wmi_VinSchema_Aggregate_Fields_Vpic>;
  nodes: Array<Wmi_VinSchema_Vpic>;
};

/** input type for inserting array relation for remote table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Arr_Rel_Insert_Input_Vpic = {
  data: Array<Wmi_VinSchema_Insert_Input_Vpic>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wmi_VinSchema_On_Conflict_Vpic>;
};

/** aggregate avg on columns */
export type Wmi_VinSchema_Avg_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  OrgId?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
  YearFrom?: Maybe<Scalars['Float']>;
  YearTo?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Avg_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vpic.wmi_vinschema". All fields are combined with a logical 'AND'. */
export type Wmi_VinSchema_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  OrgId?: InputMaybe<Int_Comparison_Exp>;
  VinSchema?: InputMaybe<VinSchema_Bool_Exp_Vpic>;
  VinSchemaId?: InputMaybe<Int_Comparison_Exp>;
  Wmi?: InputMaybe<Wmi_Bool_Exp_Vpic>;
  WmiId?: InputMaybe<Int_Comparison_Exp>;
  YearFrom?: InputMaybe<Int_Comparison_Exp>;
  YearTo?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Wmi_VinSchema_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Wmi_VinSchema_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.wmi_vinschema" */
export enum Wmi_VinSchema_Constraint_Vpic {
  /** unique or primary key constraint on columns "wmiid", "vinschemaid", "yearfrom" */
  IxWmiVinschema = 'ix_wmi_vinschema',
  /** unique or primary key constraint on columns "id" */
  PkWmiVinschema = 'pk_wmi_vinschema'
}

/** input type for incrementing numeric columns in table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Inc_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  OrgId?: InputMaybe<Scalars['Int']>;
  VinSchemaId?: InputMaybe<Scalars['Int']>;
  WmiId?: InputMaybe<Scalars['Int']>;
  YearFrom?: InputMaybe<Scalars['Int']>;
  YearTo?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Insert_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  OrgId?: InputMaybe<Scalars['Int']>;
  VinSchema?: InputMaybe<VinSchema_Obj_Rel_Insert_Input_Vpic>;
  VinSchemaId?: InputMaybe<Scalars['Int']>;
  Wmi?: InputMaybe<Wmi_Obj_Rel_Insert_Input_Vpic>;
  WmiId?: InputMaybe<Scalars['Int']>;
  YearFrom?: InputMaybe<Scalars['Int']>;
  YearTo?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Wmi_VinSchema_Max_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  OrgId?: Maybe<Scalars['Int']>;
  VinSchemaId?: Maybe<Scalars['Int']>;
  WmiId?: Maybe<Scalars['Int']>;
  YearFrom?: Maybe<Scalars['Int']>;
  YearTo?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Max_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wmi_VinSchema_Min_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  OrgId?: Maybe<Scalars['Int']>;
  VinSchemaId?: Maybe<Scalars['Int']>;
  WmiId?: Maybe<Scalars['Int']>;
  YearFrom?: Maybe<Scalars['Int']>;
  YearTo?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Min_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Mutation_Response_Vpic = {
  __typename?: 'Wmi_VinSchema_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Wmi_VinSchema_Vpic>;
};

/** on_conflict condition type for table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_On_Conflict_Vpic = {
  constraint: Wmi_VinSchema_Constraint_Vpic;
  update_columns?: Array<Wmi_VinSchema_Update_Column_Vpic>;
  where?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.wmi_vinschema". */
export type Wmi_VinSchema_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchema?: InputMaybe<VinSchema_Order_By_Vpic>;
  VinSchemaId?: InputMaybe<Order_By>;
  Wmi?: InputMaybe<Wmi_Order_By_Vpic>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vpic.wmi_vinschema */
export type Wmi_VinSchema_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select columns of table "vpic.wmi_vinschema" */
export enum Wmi_VinSchema_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  OrgId = 'OrgId',
  /** column name */
  VinSchemaId = 'VinSchemaId',
  /** column name */
  WmiId = 'WmiId',
  /** column name */
  YearFrom = 'YearFrom',
  /** column name */
  YearTo = 'YearTo'
}

/** input type for updating data in table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Set_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  OrgId?: InputMaybe<Scalars['Int']>;
  VinSchemaId?: InputMaybe<Scalars['Int']>;
  WmiId?: InputMaybe<Scalars['Int']>;
  YearFrom?: InputMaybe<Scalars['Int']>;
  YearTo?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Wmi_VinSchema_Stddev_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  OrgId?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
  YearFrom?: Maybe<Scalars['Float']>;
  YearTo?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Stddev_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wmi_VinSchema_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  OrgId?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
  YearFrom?: Maybe<Scalars['Float']>;
  YearTo?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Stddev_Pop_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wmi_VinSchema_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  OrgId?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
  YearFrom?: Maybe<Scalars['Float']>;
  YearTo?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Stddev_Samp_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Wmi_VinSchema" */
export type Wmi_VinSchema_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Wmi_VinSchema_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Wmi_VinSchema_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  OrgId?: InputMaybe<Scalars['Int']>;
  VinSchemaId?: InputMaybe<Scalars['Int']>;
  WmiId?: InputMaybe<Scalars['Int']>;
  YearFrom?: InputMaybe<Scalars['Int']>;
  YearTo?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Wmi_VinSchema_Sum_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  OrgId?: Maybe<Scalars['Int']>;
  VinSchemaId?: Maybe<Scalars['Int']>;
  WmiId?: Maybe<Scalars['Int']>;
  YearFrom?: Maybe<Scalars['Int']>;
  YearTo?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Sum_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** update columns of table "vpic.wmi_vinschema" */
export enum Wmi_VinSchema_Update_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  OrgId = 'OrgId',
  /** column name */
  VinSchemaId = 'VinSchemaId',
  /** column name */
  WmiId = 'WmiId',
  /** column name */
  YearFrom = 'YearFrom',
  /** column name */
  YearTo = 'YearTo'
}

export type Wmi_VinSchema_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wmi_VinSchema_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wmi_VinSchema_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Wmi_VinSchema_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Wmi_VinSchema_Var_Pop_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  OrgId?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
  YearFrom?: Maybe<Scalars['Float']>;
  YearTo?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Var_Pop_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wmi_VinSchema_Var_Samp_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  OrgId?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
  YearFrom?: Maybe<Scalars['Float']>;
  YearTo?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Var_Samp_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wmi_VinSchema_Variance_Fields_Vpic = {
  __typename?: 'Wmi_VinSchema_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  OrgId?: Maybe<Scalars['Float']>;
  VinSchemaId?: Maybe<Scalars['Float']>;
  WmiId?: Maybe<Scalars['Float']>;
  YearFrom?: Maybe<Scalars['Float']>;
  YearTo?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Variance_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  OrgId?: InputMaybe<Order_By>;
  VinSchemaId?: InputMaybe<Order_By>;
  WmiId?: InputMaybe<Order_By>;
  YearFrom?: InputMaybe<Order_By>;
  YearTo?: InputMaybe<Order_By>;
};

/** columns and relationships of "vpic.wmi_vinschema" */
export type Wmi_VinSchema_Vpic = {
  __typename?: 'Wmi_VinSchema_vpic';
  Id: Scalars['Int'];
  OrgId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  VinSchema?: Maybe<VinSchema_Vpic>;
  VinSchemaId: Scalars['Int'];
  /** An object relationship */
  Wmi?: Maybe<Wmi_Vpic>;
  WmiId: Scalars['Int'];
  YearFrom: Scalars['Int'];
  YearTo?: Maybe<Scalars['Int']>;
};

export type Wmi_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Wmi_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Wmi_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Wmi_Aggregate_Bool_Exp_Count>;
};

export type Wmi_Aggregate_Bool_Exp_Bool_And = {
  arguments: Wmi_Select_Column_Wmi_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_Vpic;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Wmi_Bool_Exp_Vpic>;
  predicate: Boolean_Comparison_Exp;
};

export type Wmi_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Wmi_Select_Column_Wmi_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_Vpic;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Wmi_Bool_Exp_Vpic>;
  predicate: Boolean_Comparison_Exp;
};

export type Wmi_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wmi_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Wmi_Bool_Exp_Vpic>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vpic.wmi" */
export type Wmi_Aggregate_Fields_Vpic = {
  __typename?: 'Wmi_aggregate_fields_vpic';
  avg?: Maybe<Wmi_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<Wmi_Max_Fields_Vpic>;
  min?: Maybe<Wmi_Min_Fields_Vpic>;
  stddev?: Maybe<Wmi_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<Wmi_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<Wmi_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<Wmi_Sum_Fields_Vpic>;
  var_pop?: Maybe<Wmi_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<Wmi_Var_Samp_Fields_Vpic>;
  variance?: Maybe<Wmi_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.wmi" */
export type Wmi_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<Wmi_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vpic.wmi" */
export type Wmi_Aggregate_Order_By_Vpic = {
  avg?: InputMaybe<Wmi_Avg_Order_By_Vpic>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wmi_Max_Order_By_Vpic>;
  min?: InputMaybe<Wmi_Min_Order_By_Vpic>;
  stddev?: InputMaybe<Wmi_Stddev_Order_By_Vpic>;
  stddev_pop?: InputMaybe<Wmi_Stddev_Pop_Order_By_Vpic>;
  stddev_samp?: InputMaybe<Wmi_Stddev_Samp_Order_By_Vpic>;
  sum?: InputMaybe<Wmi_Sum_Order_By_Vpic>;
  var_pop?: InputMaybe<Wmi_Var_Pop_Order_By_Vpic>;
  var_samp?: InputMaybe<Wmi_Var_Samp_Order_By_Vpic>;
  variance?: InputMaybe<Wmi_Variance_Order_By_Vpic>;
};

/** aggregated selection of "vpic.wmi" */
export type Wmi_Aggregate_Vpic = {
  __typename?: 'Wmi_aggregate_vpic';
  aggregate?: Maybe<Wmi_Aggregate_Fields_Vpic>;
  nodes: Array<Wmi_Vpic>;
};

/** input type for inserting array relation for remote table "vpic.wmi" */
export type Wmi_Arr_Rel_Insert_Input_Vpic = {
  data: Array<Wmi_Insert_Input_Vpic>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wmi_On_Conflict_Vpic>;
};

/** aggregate avg on columns */
export type Wmi_Avg_Fields_Vpic = {
  __typename?: 'Wmi_avg_fields_vpic';
  CountryId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
  TruckTypeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vpic.wmi" */
export type Wmi_Avg_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vpic.wmi". All fields are combined with a logical 'AND'. */
export type Wmi_Bool_Exp_Vpic = {
  CountryId?: InputMaybe<Int_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Int_Comparison_Exp>;
  MakeId?: InputMaybe<Int_Comparison_Exp>;
  Manufacturer?: InputMaybe<Manufacturer_Bool_Exp_Vpic>;
  ManufacturerId?: InputMaybe<Int_Comparison_Exp>;
  NonCompliant?: InputMaybe<Boolean_Comparison_Exp>;
  NonCompliantSetByOVSC?: InputMaybe<Boolean_Comparison_Exp>;
  ProcessedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  PublicAvailabilityDate?: InputMaybe<Timestamp_Comparison_Exp>;
  TruckTypeId?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  VehicleType?: InputMaybe<VehicleType_Bool_Exp_Vpic>;
  VehicleTypeId?: InputMaybe<Int_Comparison_Exp>;
  Wmi?: InputMaybe<String_Comparison_Exp>;
  Wmi_Makes?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
  Wmi_Makes_aggregate?: InputMaybe<Wmi_Make_Aggregate_Bool_Exp>;
  Wmi_VinSchemas?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
  Wmi_VinSchemas_aggregate?: InputMaybe<Wmi_VinSchema_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Wmi_Bool_Exp_Vpic>>;
  _not?: InputMaybe<Wmi_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<Wmi_Bool_Exp_Vpic>>;
};

/** unique or primary key constraints on table "vpic.wmi" */
export enum Wmi_Constraint_Vpic {
  /** unique or primary key constraint on columns "wmi" */
  IxWmi = 'ix_wmi',
  /** unique or primary key constraint on columns "id" */
  PkWmi = 'pk_wmi'
}

/** input type for incrementing numeric columns in table "vpic.wmi" */
export type Wmi_Inc_Input_Vpic = {
  CountryId?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  ManufacturerId?: InputMaybe<Scalars['Int']>;
  TruckTypeId?: InputMaybe<Scalars['Int']>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vpic.wmi" */
export type Wmi_Insert_Input_Vpic = {
  CountryId?: InputMaybe<Scalars['Int']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  Manufacturer?: InputMaybe<Manufacturer_Obj_Rel_Insert_Input_Vpic>;
  ManufacturerId?: InputMaybe<Scalars['Int']>;
  NonCompliant?: InputMaybe<Scalars['Boolean']>;
  NonCompliantSetByOVSC?: InputMaybe<Scalars['Boolean']>;
  ProcessedOn?: InputMaybe<Scalars['timestamp']>;
  PublicAvailabilityDate?: InputMaybe<Scalars['timestamp']>;
  TruckTypeId?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VehicleType?: InputMaybe<VehicleType_Obj_Rel_Insert_Input_Vpic>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
  Wmi?: InputMaybe<Scalars['String']>;
  Wmi_Makes?: InputMaybe<Wmi_Make_Arr_Rel_Insert_Input_Vpic>;
  Wmi_VinSchemas?: InputMaybe<Wmi_VinSchema_Arr_Rel_Insert_Input_Vpic>;
};

/** aggregate max on columns */
export type Wmi_Max_Fields_Vpic = {
  __typename?: 'Wmi_max_fields_vpic';
  CountryId?: Maybe<Scalars['Int']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  ManufacturerId?: Maybe<Scalars['Int']>;
  ProcessedOn?: Maybe<Scalars['timestamp']>;
  PublicAvailabilityDate?: Maybe<Scalars['timestamp']>;
  TruckTypeId?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VehicleTypeId?: Maybe<Scalars['Int']>;
  Wmi?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "vpic.wmi" */
export type Wmi_Max_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
  ProcessedOn?: InputMaybe<Order_By>;
  PublicAvailabilityDate?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
  Wmi?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wmi_Min_Fields_Vpic = {
  __typename?: 'Wmi_min_fields_vpic';
  CountryId?: Maybe<Scalars['Int']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  ManufacturerId?: Maybe<Scalars['Int']>;
  ProcessedOn?: Maybe<Scalars['timestamp']>;
  PublicAvailabilityDate?: Maybe<Scalars['timestamp']>;
  TruckTypeId?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VehicleTypeId?: Maybe<Scalars['Int']>;
  Wmi?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "vpic.wmi" */
export type Wmi_Min_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
  ProcessedOn?: InputMaybe<Order_By>;
  PublicAvailabilityDate?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
  Wmi?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vpic.wmi" */
export type Wmi_Mutation_Response_Vpic = {
  __typename?: 'Wmi_mutation_response_vpic';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Wmi_Vpic>;
};

/** input type for inserting object relation for remote table "vpic.wmi" */
export type Wmi_Obj_Rel_Insert_Input_Vpic = {
  data: Wmi_Insert_Input_Vpic;
  /** upsert condition */
  on_conflict?: InputMaybe<Wmi_On_Conflict_Vpic>;
};

/** on_conflict condition type for table "vpic.wmi" */
export type Wmi_On_Conflict_Vpic = {
  constraint: Wmi_Constraint_Vpic;
  update_columns?: Array<Wmi_Update_Column_Vpic>;
  where?: InputMaybe<Wmi_Bool_Exp_Vpic>;
};

/** Ordering options when selecting data from "vpic.wmi". */
export type Wmi_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  Manufacturer?: InputMaybe<Manufacturer_Order_By_Vpic>;
  ManufacturerId?: InputMaybe<Order_By>;
  NonCompliant?: InputMaybe<Order_By>;
  NonCompliantSetByOVSC?: InputMaybe<Order_By>;
  ProcessedOn?: InputMaybe<Order_By>;
  PublicAvailabilityDate?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VehicleType?: InputMaybe<VehicleType_Order_By_Vpic>;
  VehicleTypeId?: InputMaybe<Order_By>;
  Wmi?: InputMaybe<Order_By>;
  Wmi_Makes_aggregate?: InputMaybe<Wmi_Make_Aggregate_Order_By_Vpic>;
  Wmi_VinSchemas_aggregate?: InputMaybe<Wmi_VinSchema_Aggregate_Order_By_Vpic>;
};

/** primary key columns input for table: vpic.wmi */
export type Wmi_Pk_Columns_Input_Vpic = {
  Id: Scalars['Int'];
};

/** select "Wmi_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vpic.wmi" */
export enum Wmi_Select_Column_Wmi_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_Vpic {
  /** column name */
  NonCompliant = 'NonCompliant',
  /** column name */
  NonCompliantSetByOvsc = 'NonCompliantSetByOVSC'
}

/** select "Wmi_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vpic.wmi" */
export enum Wmi_Select_Column_Wmi_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_Vpic {
  /** column name */
  NonCompliant = 'NonCompliant',
  /** column name */
  NonCompliantSetByOvsc = 'NonCompliantSetByOVSC'
}

/** select columns of table "vpic.wmi" */
export enum Wmi_Select_Column_Vpic {
  /** column name */
  CountryId = 'CountryId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  ManufacturerId = 'ManufacturerId',
  /** column name */
  NonCompliant = 'NonCompliant',
  /** column name */
  NonCompliantSetByOvsc = 'NonCompliantSetByOVSC',
  /** column name */
  ProcessedOn = 'ProcessedOn',
  /** column name */
  PublicAvailabilityDate = 'PublicAvailabilityDate',
  /** column name */
  TruckTypeId = 'TruckTypeId',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VehicleTypeId = 'VehicleTypeId',
  /** column name */
  Wmi = 'Wmi'
}

/** input type for updating data in table "vpic.wmi" */
export type Wmi_Set_Input_Vpic = {
  CountryId?: InputMaybe<Scalars['Int']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  ManufacturerId?: InputMaybe<Scalars['Int']>;
  NonCompliant?: InputMaybe<Scalars['Boolean']>;
  NonCompliantSetByOVSC?: InputMaybe<Scalars['Boolean']>;
  ProcessedOn?: InputMaybe<Scalars['timestamp']>;
  PublicAvailabilityDate?: InputMaybe<Scalars['timestamp']>;
  TruckTypeId?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
  Wmi?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Wmi_Stddev_Fields_Vpic = {
  __typename?: 'Wmi_stddev_fields_vpic';
  CountryId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
  TruckTypeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vpic.wmi" */
export type Wmi_Stddev_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wmi_Stddev_Pop_Fields_Vpic = {
  __typename?: 'Wmi_stddev_pop_fields_vpic';
  CountryId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
  TruckTypeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vpic.wmi" */
export type Wmi_Stddev_Pop_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wmi_Stddev_Samp_Fields_Vpic = {
  __typename?: 'Wmi_stddev_samp_fields_vpic';
  CountryId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
  TruckTypeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vpic.wmi" */
export type Wmi_Stddev_Samp_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Wmi" */
export type Wmi_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: Wmi_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type Wmi_Stream_Cursor_Value_Input_Vpic = {
  CountryId?: InputMaybe<Scalars['Int']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['Int']>;
  ManufacturerId?: InputMaybe<Scalars['Int']>;
  NonCompliant?: InputMaybe<Scalars['Boolean']>;
  NonCompliantSetByOVSC?: InputMaybe<Scalars['Boolean']>;
  ProcessedOn?: InputMaybe<Scalars['timestamp']>;
  PublicAvailabilityDate?: InputMaybe<Scalars['timestamp']>;
  TruckTypeId?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VehicleTypeId?: InputMaybe<Scalars['Int']>;
  Wmi?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Wmi_Sum_Fields_Vpic = {
  __typename?: 'Wmi_sum_fields_vpic';
  CountryId?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['Int']>;
  ManufacturerId?: Maybe<Scalars['Int']>;
  TruckTypeId?: Maybe<Scalars['Int']>;
  VehicleTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vpic.wmi" */
export type Wmi_Sum_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "vpic.wmi" */
export enum Wmi_Update_Column_Vpic {
  /** column name */
  CountryId = 'CountryId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  ManufacturerId = 'ManufacturerId',
  /** column name */
  NonCompliant = 'NonCompliant',
  /** column name */
  NonCompliantSetByOvsc = 'NonCompliantSetByOVSC',
  /** column name */
  ProcessedOn = 'ProcessedOn',
  /** column name */
  PublicAvailabilityDate = 'PublicAvailabilityDate',
  /** column name */
  TruckTypeId = 'TruckTypeId',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VehicleTypeId = 'VehicleTypeId',
  /** column name */
  Wmi = 'Wmi'
}

export type Wmi_Updates_Vpic = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wmi_Inc_Input_Vpic>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wmi_Set_Input_Vpic>;
  /** filter the rows which have to be updated */
  where: Wmi_Bool_Exp_Vpic;
};

/** aggregate var_pop on columns */
export type Wmi_Var_Pop_Fields_Vpic = {
  __typename?: 'Wmi_var_pop_fields_vpic';
  CountryId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
  TruckTypeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vpic.wmi" */
export type Wmi_Var_Pop_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wmi_Var_Samp_Fields_Vpic = {
  __typename?: 'Wmi_var_samp_fields_vpic';
  CountryId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
  TruckTypeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vpic.wmi" */
export type Wmi_Var_Samp_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wmi_Variance_Fields_Vpic = {
  __typename?: 'Wmi_variance_fields_vpic';
  CountryId?: Maybe<Scalars['Float']>;
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  ManufacturerId?: Maybe<Scalars['Float']>;
  TruckTypeId?: Maybe<Scalars['Float']>;
  VehicleTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vpic.wmi" */
export type Wmi_Variance_Order_By_Vpic = {
  CountryId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  ManufacturerId?: InputMaybe<Order_By>;
  TruckTypeId?: InputMaybe<Order_By>;
  VehicleTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "vpic.wmi" */
export type Wmi_Vpic = {
  __typename?: 'Wmi_vpic';
  CountryId?: Maybe<Scalars['Int']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id: Scalars['Int'];
  MakeId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  Manufacturer?: Maybe<Manufacturer_Vpic>;
  ManufacturerId?: Maybe<Scalars['Int']>;
  NonCompliant?: Maybe<Scalars['Boolean']>;
  NonCompliantSetByOVSC?: Maybe<Scalars['Boolean']>;
  ProcessedOn?: Maybe<Scalars['timestamp']>;
  PublicAvailabilityDate?: Maybe<Scalars['timestamp']>;
  TruckTypeId?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  VehicleType?: Maybe<VehicleType_Vpic>;
  VehicleTypeId?: Maybe<Scalars['Int']>;
  Wmi: Scalars['String'];
  /** An array relationship */
  Wmi_Makes: Array<Wmi_Make_Vpic>;
  /** An aggregate relationship */
  Wmi_Makes_aggregate: Wmi_Make_Aggregate_Vpic;
  /** An array relationship */
  Wmi_VinSchemas: Array<Wmi_VinSchema_Vpic>;
  /** An aggregate relationship */
  Wmi_VinSchemas_aggregate: Wmi_VinSchema_Aggregate_Vpic;
};


/** columns and relationships of "vpic.wmi" */
export type Wmi_VpicWmi_MakesArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Make_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.wmi" */
export type Wmi_VpicWmi_Makes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Make_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.wmi" */
export type Wmi_VpicWmi_VinSchemasArgs = {
  distinct_on?: InputMaybe<Array<Wmi_VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
};


/** columns and relationships of "vpic.wmi" */
export type Wmi_VpicWmi_VinSchemas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
};

/** columns and relationships of "account" */
export type Account = {
  __typename?: 'account';
  /** An array relationship */
  accountAccountManagers: Array<AccountAccountManager>;
  /** An aggregate relationship */
  accountAccountManagers_aggregate: AccountAccountManager_Aggregate;
  /** An array relationship */
  accountCategories: Array<AccountCategory>;
  /** An aggregate relationship */
  accountCategories_aggregate: AccountCategory_Aggregate;
  /** An array relationship */
  accountDisbursements: Array<AccountDisbursement>;
  /** An aggregate relationship */
  accountDisbursements_aggregate: AccountDisbursement_Aggregate;
  /** An array relationship */
  accountObligors: Array<AccountObligor>;
  /** An aggregate relationship */
  accountObligors_aggregate: AccountObligor_Aggregate;
  /** An array relationship */
  accountProducts: Array<AccountProduct>;
  /** An aggregate relationship */
  accountProducts_aggregate: AccountProduct_Aggregate;
  /** An array relationship */
  accountRetails: Array<AccountRetail>;
  /** An aggregate relationship */
  accountRetails_aggregate: AccountRetail_Aggregate;
  /** An object relationship */
  accountType?: Maybe<AccountType>;
  accountTypeId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  addresses: Array<Address>;
  /** An aggregate relationship */
  addresses_aggregate: Address_Aggregate;
  code?: Maybe<Scalars['String']>;
  /** An array relationship */
  contacts: Array<Contact>;
  /** An aggregate relationship */
  contacts_aggregate: Contact_Aggregate;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  currentLossRatios: Array<LossRatioCurrentView>;
  /** An aggregate relationship */
  currentLossRatios_aggregate: LossRatioCurrentView_Aggregate;
  dbaName?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityBillingInformations: Array<EntityBillingInformation>;
  /** An aggregate relationship */
  entityBillingInformations_aggregate: EntityBillingInformation_Aggregate;
  /** An array relationship */
  entityConfigurationItems: Array<EntityConfigurationItem>;
  /** An aggregate relationship */
  entityConfigurationItems_aggregate: EntityConfigurationItem_Aggregate;
  /** An array relationship */
  entityCustomFields: Array<EntityCustomField>;
  /** An aggregate relationship */
  entityCustomFields_aggregate: EntityCustomField_Aggregate;
  /** An array relationship */
  entityFeatures: Array<EntityFeature>;
  /** An aggregate relationship */
  entityFeatures_aggregate: EntityFeature_Aggregate;
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An array relationship */
  identityEntities: Array<IdentityEntity>;
  /** An aggregate relationship */
  identityEntities_aggregate: IdentityEntity_Aggregate;
  /** An array relationship */
  identityEntityViews: Array<IdentityEntityView>;
  /** An aggregate relationship */
  identityEntityViews_aggregate: IdentityEntityView_Aggregate;
  isGmDealer?: Maybe<Scalars['Boolean']>;
  /** Array of strings built from the account name split on spaces, the account code, and AS400 Code from entity_configuration, all uppercase. */
  keywordsMetadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An array relationship */
  lossRatios: Array<LossRatio>;
  /** An aggregate relationship */
  lossRatios_aggregate: LossRatio_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  policyContracts: Array<PolicyContract>;
  /** An aggregate relationship */
  policyContracts_aggregate: PolicyContract_Aggregate;
  /** An array relationship */
  serviceCenters: Array<ServiceCenter>;
  /** An aggregate relationship */
  serviceCenters_aggregate: ServiceCenter_Aggregate;
  taxId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userProfiles: Array<UserProfile>;
  /** An aggregate relationship */
  userProfiles_aggregate: UserProfile_Aggregate;
  /** An object relationship */
  workStatusType?: Maybe<WorkStatusType>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "account" */
export type AccountAccountAccountManagersArgs = {
  distinct_on?: InputMaybe<Array<AccountAccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountAccountManager_Order_By>>;
  where?: InputMaybe<AccountAccountManager_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountAccountManagers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountAccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountAccountManager_Order_By>>;
  where?: InputMaybe<AccountAccountManager_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountCategoriesArgs = {
  distinct_on?: InputMaybe<Array<AccountCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountCategory_Order_By>>;
  where?: InputMaybe<AccountCategory_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountCategory_Order_By>>;
  where?: InputMaybe<AccountCategory_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountDisbursements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountObligorsArgs = {
  distinct_on?: InputMaybe<Array<AccountObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountObligor_Order_By>>;
  where?: InputMaybe<AccountObligor_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountObligors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountObligor_Order_By>>;
  where?: InputMaybe<AccountObligor_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountProductsArgs = {
  distinct_on?: InputMaybe<Array<AccountProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProduct_Order_By>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProduct_Order_By>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountRetailsArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAccountRetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountContactsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountCurrentLossRatiosArgs = {
  distinct_on?: InputMaybe<Array<LossRatioCurrentView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatioCurrentView_Order_By>>;
  where?: InputMaybe<LossRatioCurrentView_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountCurrentLossRatios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LossRatioCurrentView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatioCurrentView_Order_By>>;
  where?: InputMaybe<LossRatioCurrentView_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityBillingInformationsArgs = {
  distinct_on?: InputMaybe<Array<EntityBillingInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityBillingInformation_Order_By>>;
  where?: InputMaybe<EntityBillingInformation_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityBillingInformations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityBillingInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityBillingInformation_Order_By>>;
  where?: InputMaybe<EntityBillingInformation_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityConfigurationItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityCustomFieldsArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomField_Order_By>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityCustomFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomField_Order_By>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityFeaturesArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityFeatures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountIdentityEntitiesArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntity_Order_By>>;
  where?: InputMaybe<IdentityEntity_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountIdentityEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntity_Order_By>>;
  where?: InputMaybe<IdentityEntity_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountIdentityEntityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountIdentityEntityViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountKeywordsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "account" */
export type AccountLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountLossRatiosArgs = {
  distinct_on?: InputMaybe<Array<LossRatio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatio_Order_By>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountLossRatios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LossRatio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatio_Order_By>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountPolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountPolicyContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountServiceCenters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountUserProfilesArgs = {
  distinct_on?: InputMaybe<Array<UserProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserProfile_Order_By>>;
  where?: InputMaybe<UserProfile_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountUserProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserProfile_Order_By>>;
  where?: InputMaybe<UserProfile_Bool_Exp>;
};

/** columns and relationships of "account_account_manager" */
export type AccountAccountManager = {
  __typename?: 'accountAccountManager';
  /** An object relationship */
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  accountManager?: Maybe<AccountManager>;
  accountManagerId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "account_account_manager" */
export type AccountAccountManager_Aggregate = {
  __typename?: 'accountAccountManager_aggregate';
  aggregate?: Maybe<AccountAccountManager_Aggregate_Fields>;
  nodes: Array<AccountAccountManager>;
};

export type AccountAccountManager_Aggregate_Bool_Exp = {
  count?: InputMaybe<AccountAccountManager_Aggregate_Bool_Exp_Count>;
};

export type AccountAccountManager_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AccountAccountManager_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountAccountManager_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_account_manager" */
export type AccountAccountManager_Aggregate_Fields = {
  __typename?: 'accountAccountManager_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AccountAccountManager_Max_Fields>;
  min?: Maybe<AccountAccountManager_Min_Fields>;
};


/** aggregate fields of "account_account_manager" */
export type AccountAccountManager_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountAccountManager_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_account_manager" */
export type AccountAccountManager_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AccountAccountManager_Max_Order_By>;
  min?: InputMaybe<AccountAccountManager_Min_Order_By>;
};

/** input type for inserting array relation for remote table "account_account_manager" */
export type AccountAccountManager_Arr_Rel_Insert_Input = {
  data: Array<AccountAccountManager_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountAccountManager_On_Conflict>;
};

/** Boolean expression to filter rows from the table "account_account_manager". All fields are combined with a logical 'AND'. */
export type AccountAccountManager_Bool_Exp = {
  _and?: InputMaybe<Array<AccountAccountManager_Bool_Exp>>;
  _not?: InputMaybe<AccountAccountManager_Bool_Exp>;
  _or?: InputMaybe<Array<AccountAccountManager_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  accountManager?: InputMaybe<AccountManager_Bool_Exp>;
  accountManagerId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_account_manager" */
export enum AccountAccountManager_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountAccountManagerPkey = 'account_account_manager_pkey'
}

/** input type for inserting data into table "account_account_manager" */
export type AccountAccountManager_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['uuid']>;
  accountManager?: InputMaybe<AccountManager_Obj_Rel_Insert_Input>;
  accountManagerId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccountAccountManager_Max_Fields = {
  __typename?: 'accountAccountManager_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  accountManagerId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "account_account_manager" */
export type AccountAccountManager_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  accountManagerId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AccountAccountManager_Min_Fields = {
  __typename?: 'accountAccountManager_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  accountManagerId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "account_account_manager" */
export type AccountAccountManager_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  accountManagerId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_account_manager" */
export type AccountAccountManager_Mutation_Response = {
  __typename?: 'accountAccountManager_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountAccountManager>;
};

/** on_conflict condition type for table "account_account_manager" */
export type AccountAccountManager_On_Conflict = {
  constraint: AccountAccountManager_Constraint;
  update_columns?: Array<AccountAccountManager_Update_Column>;
  where?: InputMaybe<AccountAccountManager_Bool_Exp>;
};

/** Ordering options when selecting data from "account_account_manager". */
export type AccountAccountManager_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountId?: InputMaybe<Order_By>;
  accountManager?: InputMaybe<AccountManager_Order_By>;
  accountManagerId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_account_manager */
export type AccountAccountManager_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "account_account_manager" */
export enum AccountAccountManager_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AccountManagerId = 'accountManagerId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "account_account_manager" */
export type AccountAccountManager_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  accountManagerId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "accountAccountManager" */
export type AccountAccountManager_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountAccountManager_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountAccountManager_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  accountManagerId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "account_account_manager" */
export enum AccountAccountManager_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AccountManagerId = 'accountManagerId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AccountAccountManager_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountAccountManager_Set_Input>;
  /** filter the rows which have to be updated */
  where: AccountAccountManager_Bool_Exp;
};

/** columns and relationships of "account_category" */
export type AccountCategory = {
  __typename?: 'accountCategory';
  /** An object relationship */
  account: Account;
  accountId: Scalars['uuid'];
  /** An object relationship */
  category: Category;
  categoryId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  entityConfigurationItems: Array<EntityConfigurationItem>;
  /** An aggregate relationship */
  entityConfigurationItems_aggregate: EntityConfigurationItem_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  lossRatios: Array<LossRatio>;
  /** An aggregate relationship */
  lossRatios_aggregate: LossRatio_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "account_category" */
export type AccountCategoryEntityConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "account_category" */
export type AccountCategoryEntityConfigurationItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "account_category" */
export type AccountCategoryLossRatiosArgs = {
  distinct_on?: InputMaybe<Array<LossRatio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatio_Order_By>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};


/** columns and relationships of "account_category" */
export type AccountCategoryLossRatios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LossRatio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatio_Order_By>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};

/** aggregated selection of "account_category" */
export type AccountCategory_Aggregate = {
  __typename?: 'accountCategory_aggregate';
  aggregate?: Maybe<AccountCategory_Aggregate_Fields>;
  nodes: Array<AccountCategory>;
};

export type AccountCategory_Aggregate_Bool_Exp = {
  count?: InputMaybe<AccountCategory_Aggregate_Bool_Exp_Count>;
};

export type AccountCategory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AccountCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountCategory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_category" */
export type AccountCategory_Aggregate_Fields = {
  __typename?: 'accountCategory_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AccountCategory_Max_Fields>;
  min?: Maybe<AccountCategory_Min_Fields>;
};


/** aggregate fields of "account_category" */
export type AccountCategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_category" */
export type AccountCategory_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AccountCategory_Max_Order_By>;
  min?: InputMaybe<AccountCategory_Min_Order_By>;
};

/** input type for inserting array relation for remote table "account_category" */
export type AccountCategory_Arr_Rel_Insert_Input = {
  data: Array<AccountCategory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountCategory_On_Conflict>;
};

/** Boolean expression to filter rows from the table "account_category". All fields are combined with a logical 'AND'. */
export type AccountCategory_Bool_Exp = {
  _and?: InputMaybe<Array<AccountCategory_Bool_Exp>>;
  _not?: InputMaybe<AccountCategory_Bool_Exp>;
  _or?: InputMaybe<Array<AccountCategory_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lossRatios?: InputMaybe<LossRatio_Bool_Exp>;
  lossRatios_aggregate?: InputMaybe<LossRatio_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_category" */
export enum AccountCategory_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountCategoryPkey = 'account_category_pkey'
}

/** input type for inserting data into table "account_category" */
export type AccountCategory_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  lossRatios?: InputMaybe<LossRatio_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccountCategory_Max_Fields = {
  __typename?: 'accountCategory_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "account_category" */
export type AccountCategory_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AccountCategory_Min_Fields = {
  __typename?: 'accountCategory_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "account_category" */
export type AccountCategory_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_category" */
export type AccountCategory_Mutation_Response = {
  __typename?: 'accountCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountCategory>;
};

/** input type for inserting object relation for remote table "account_category" */
export type AccountCategory_Obj_Rel_Insert_Input = {
  data: AccountCategory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountCategory_On_Conflict>;
};

/** on_conflict condition type for table "account_category" */
export type AccountCategory_On_Conflict = {
  constraint: AccountCategory_Constraint;
  update_columns?: Array<AccountCategory_Update_Column>;
  where?: InputMaybe<AccountCategory_Bool_Exp>;
};

/** Ordering options when selecting data from "account_category". */
export type AccountCategory_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountId?: InputMaybe<Order_By>;
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lossRatios_aggregate?: InputMaybe<LossRatio_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_category */
export type AccountCategory_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "account_category" */
export enum AccountCategory_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "account_category" */
export type AccountCategory_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "accountCategory" */
export type AccountCategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountCategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountCategory_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "account_category" */
export enum AccountCategory_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AccountCategory_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountCategory_Set_Input>;
  /** filter the rows which have to be updated */
  where: AccountCategory_Bool_Exp;
};

/** columns and relationships of "account_disbursement" */
export type AccountDisbursement = {
  __typename?: 'accountDisbursement';
  /** An object relationship */
  account: Account;
  accountId: Scalars['uuid'];
  amount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  category?: Maybe<Category>;
  /** The category this disbursement is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: Maybe<Scalars['uuid']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  createdAt: Scalars['timestamptz'];
  disbursementCode?: Maybe<Scalars['String']>;
  /** An object relationship */
  disbursementType: DisbursementType;
  disbursementTypeId: Scalars['Int'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  payee?: Maybe<Payee>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  product?: Maybe<Product>;
  /** The product this disbursement applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id. */
  productId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  workStatusType?: Maybe<WorkStatusType>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "account_disbursement" */
export type AccountDisbursement_Aggregate = {
  __typename?: 'accountDisbursement_aggregate';
  aggregate?: Maybe<AccountDisbursement_Aggregate_Fields>;
  nodes: Array<AccountDisbursement>;
};

export type AccountDisbursement_Aggregate_Bool_Exp = {
  count?: InputMaybe<AccountDisbursement_Aggregate_Bool_Exp_Count>;
};

export type AccountDisbursement_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountDisbursement_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_disbursement" */
export type AccountDisbursement_Aggregate_Fields = {
  __typename?: 'accountDisbursement_aggregate_fields';
  avg?: Maybe<AccountDisbursement_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AccountDisbursement_Max_Fields>;
  min?: Maybe<AccountDisbursement_Min_Fields>;
  stddev?: Maybe<AccountDisbursement_Stddev_Fields>;
  stddev_pop?: Maybe<AccountDisbursement_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AccountDisbursement_Stddev_Samp_Fields>;
  sum?: Maybe<AccountDisbursement_Sum_Fields>;
  var_pop?: Maybe<AccountDisbursement_Var_Pop_Fields>;
  var_samp?: Maybe<AccountDisbursement_Var_Samp_Fields>;
  variance?: Maybe<AccountDisbursement_Variance_Fields>;
};


/** aggregate fields of "account_disbursement" */
export type AccountDisbursement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_disbursement" */
export type AccountDisbursement_Aggregate_Order_By = {
  avg?: InputMaybe<AccountDisbursement_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AccountDisbursement_Max_Order_By>;
  min?: InputMaybe<AccountDisbursement_Min_Order_By>;
  stddev?: InputMaybe<AccountDisbursement_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AccountDisbursement_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AccountDisbursement_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AccountDisbursement_Sum_Order_By>;
  var_pop?: InputMaybe<AccountDisbursement_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AccountDisbursement_Var_Samp_Order_By>;
  variance?: InputMaybe<AccountDisbursement_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "account_disbursement" */
export type AccountDisbursement_Arr_Rel_Insert_Input = {
  data: Array<AccountDisbursement_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountDisbursement_On_Conflict>;
};

/** aggregate avg on columns */
export type AccountDisbursement_Avg_Fields = {
  __typename?: 'accountDisbursement_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "account_disbursement" */
export type AccountDisbursement_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account_disbursement". All fields are combined with a logical 'AND'. */
export type AccountDisbursement_Bool_Exp = {
  _and?: InputMaybe<Array<AccountDisbursement_Bool_Exp>>;
  _not?: InputMaybe<AccountDisbursement_Bool_Exp>;
  _or?: InputMaybe<Array<AccountDisbursement_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  coverageMonthsEnd?: InputMaybe<Int_Comparison_Exp>;
  coverageMonthsStart?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  disbursementCode?: InputMaybe<String_Comparison_Exp>;
  disbursementType?: InputMaybe<DisbursementType_Bool_Exp>;
  disbursementTypeId?: InputMaybe<Int_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payee?: InputMaybe<Payee_Bool_Exp>;
  payeeId?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  workStatusType?: InputMaybe<WorkStatusType_Bool_Exp>;
  workStatusTypeId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_disbursement" */
export enum AccountDisbursement_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountDisbursementPkey = 'account_disbursement_pkey'
}

/** input type for incrementing numeric columns in table "account_disbursement" */
export type AccountDisbursement_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  disbursementTypeId?: InputMaybe<Scalars['Int']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "account_disbursement" */
export type AccountDisbursement_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['uuid']>;
  amount?: InputMaybe<Scalars['numeric']>;
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  /** The category this disbursement is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: InputMaybe<Scalars['uuid']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  disbursementCode?: InputMaybe<Scalars['String']>;
  disbursementType?: InputMaybe<DisbursementType_Obj_Rel_Insert_Input>;
  disbursementTypeId?: InputMaybe<Scalars['Int']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  payee?: InputMaybe<Payee_Obj_Rel_Insert_Input>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  /** The product this disbursement applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id. */
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusType?: InputMaybe<WorkStatusType_Obj_Rel_Insert_Input>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AccountDisbursement_Max_Fields = {
  __typename?: 'accountDisbursement_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  amount?: Maybe<Scalars['numeric']>;
  /** The category this disbursement is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: Maybe<Scalars['uuid']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  disbursementCode?: Maybe<Scalars['String']>;
  disbursementTypeId?: Maybe<Scalars['Int']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: Maybe<Scalars['uuid']>;
  /** The product this disbursement applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id. */
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "account_disbursement" */
export type AccountDisbursement_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  /** The category this disbursement is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  disbursementCode?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: InputMaybe<Order_By>;
  /** The product this disbursement applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id. */
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AccountDisbursement_Min_Fields = {
  __typename?: 'accountDisbursement_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  amount?: Maybe<Scalars['numeric']>;
  /** The category this disbursement is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: Maybe<Scalars['uuid']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  disbursementCode?: Maybe<Scalars['String']>;
  disbursementTypeId?: Maybe<Scalars['Int']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: Maybe<Scalars['uuid']>;
  /** The product this disbursement applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id. */
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "account_disbursement" */
export type AccountDisbursement_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  /** The category this disbursement is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  disbursementCode?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: InputMaybe<Order_By>;
  /** The product this disbursement applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id. */
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_disbursement" */
export type AccountDisbursement_Mutation_Response = {
  __typename?: 'accountDisbursement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountDisbursement>;
};

/** on_conflict condition type for table "account_disbursement" */
export type AccountDisbursement_On_Conflict = {
  constraint: AccountDisbursement_Constraint;
  update_columns?: Array<AccountDisbursement_Update_Column>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};

/** Ordering options when selecting data from "account_disbursement". */
export type AccountDisbursement_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  disbursementCode?: InputMaybe<Order_By>;
  disbursementType?: InputMaybe<DisbursementType_Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payee?: InputMaybe<Payee_Order_By>;
  payeeId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusType?: InputMaybe<WorkStatusType_Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_disbursement */
export type AccountDisbursement_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "account_disbursement" */
export enum AccountDisbursement_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  Amount = 'amount',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CoverageMonthsEnd = 'coverageMonthsEnd',
  /** column name */
  CoverageMonthsStart = 'coverageMonthsStart',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisbursementCode = 'disbursementCode',
  /** column name */
  DisbursementTypeId = 'disbursementTypeId',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  PayeeId = 'payeeId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WorkStatusTypeId = 'workStatusTypeId'
}

/** input type for updating data in table "account_disbursement" */
export type AccountDisbursement_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  amount?: InputMaybe<Scalars['numeric']>;
  /** The category this disbursement is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: InputMaybe<Scalars['uuid']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  disbursementCode?: InputMaybe<Scalars['String']>;
  disbursementTypeId?: InputMaybe<Scalars['Int']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: InputMaybe<Scalars['uuid']>;
  /** The product this disbursement applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id. */
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AccountDisbursement_Stddev_Fields = {
  __typename?: 'accountDisbursement_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "account_disbursement" */
export type AccountDisbursement_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AccountDisbursement_Stddev_Pop_Fields = {
  __typename?: 'accountDisbursement_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "account_disbursement" */
export type AccountDisbursement_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AccountDisbursement_Stddev_Samp_Fields = {
  __typename?: 'accountDisbursement_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "account_disbursement" */
export type AccountDisbursement_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "accountDisbursement" */
export type AccountDisbursement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountDisbursement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountDisbursement_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  amount?: InputMaybe<Scalars['numeric']>;
  /** The category this disbursement is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: InputMaybe<Scalars['uuid']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  disbursementCode?: InputMaybe<Scalars['String']>;
  disbursementTypeId?: InputMaybe<Scalars['Int']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: InputMaybe<Scalars['uuid']>;
  /** The product this disbursement applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id. */
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AccountDisbursement_Sum_Fields = {
  __typename?: 'accountDisbursement_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  disbursementTypeId?: Maybe<Scalars['Int']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "account_disbursement" */
export type AccountDisbursement_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "account_disbursement" */
export enum AccountDisbursement_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  Amount = 'amount',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CoverageMonthsEnd = 'coverageMonthsEnd',
  /** column name */
  CoverageMonthsStart = 'coverageMonthsStart',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisbursementCode = 'disbursementCode',
  /** column name */
  DisbursementTypeId = 'disbursementTypeId',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  PayeeId = 'payeeId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WorkStatusTypeId = 'workStatusTypeId'
}

export type AccountDisbursement_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AccountDisbursement_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountDisbursement_Set_Input>;
  /** filter the rows which have to be updated */
  where: AccountDisbursement_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AccountDisbursement_Var_Pop_Fields = {
  __typename?: 'accountDisbursement_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "account_disbursement" */
export type AccountDisbursement_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AccountDisbursement_Var_Samp_Fields = {
  __typename?: 'accountDisbursement_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "account_disbursement" */
export type AccountDisbursement_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AccountDisbursement_Variance_Fields = {
  __typename?: 'accountDisbursement_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "account_disbursement" */
export type AccountDisbursement_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "account_manager" */
export type AccountManager = {
  __typename?: 'accountManager';
  /** An array relationship */
  accountAccountManagers: Array<AccountAccountManager>;
  /** An aggregate relationship */
  accountAccountManagers_aggregate: AccountAccountManager_Aggregate;
  /** An array relationship */
  addresses: Array<Address>;
  /** An aggregate relationship */
  addresses_aggregate: Address_Aggregate;
  code?: Maybe<Scalars['String']>;
  /** An array relationship */
  contacts: Array<Contact>;
  /** An aggregate relationship */
  contacts_aggregate: Contact_Aggregate;
  createdAt: Scalars['timestamptz'];
  dbaName?: Maybe<Scalars['String']>;
  /** An array relationship */
  entityFeatures: Array<EntityFeature>;
  /** An aggregate relationship */
  entityFeatures_aggregate: EntityFeature_Aggregate;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  identityEntityViews: Array<IdentityEntityView>;
  /** An aggregate relationship */
  identityEntityViews_aggregate: IdentityEntityView_Aggregate;
  name?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userProfiles: Array<UserProfile>;
  /** An aggregate relationship */
  userProfiles_aggregate: UserProfile_Aggregate;
};


/** columns and relationships of "account_manager" */
export type AccountManagerAccountAccountManagersArgs = {
  distinct_on?: InputMaybe<Array<AccountAccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountAccountManager_Order_By>>;
  where?: InputMaybe<AccountAccountManager_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerAccountAccountManagers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountAccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountAccountManager_Order_By>>;
  where?: InputMaybe<AccountAccountManager_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerContactsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerEntityFeaturesArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerEntityFeatures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerIdentityEntityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerIdentityEntityViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerUserProfilesArgs = {
  distinct_on?: InputMaybe<Array<UserProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserProfile_Order_By>>;
  where?: InputMaybe<UserProfile_Bool_Exp>;
};


/** columns and relationships of "account_manager" */
export type AccountManagerUserProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserProfile_Order_By>>;
  where?: InputMaybe<UserProfile_Bool_Exp>;
};

/** aggregated selection of "account_manager" */
export type AccountManager_Aggregate = {
  __typename?: 'accountManager_aggregate';
  aggregate?: Maybe<AccountManager_Aggregate_Fields>;
  nodes: Array<AccountManager>;
};

/** aggregate fields of "account_manager" */
export type AccountManager_Aggregate_Fields = {
  __typename?: 'accountManager_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AccountManager_Max_Fields>;
  min?: Maybe<AccountManager_Min_Fields>;
};


/** aggregate fields of "account_manager" */
export type AccountManager_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountManager_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "account_manager". All fields are combined with a logical 'AND'. */
export type AccountManager_Bool_Exp = {
  _and?: InputMaybe<Array<AccountManager_Bool_Exp>>;
  _not?: InputMaybe<AccountManager_Bool_Exp>;
  _or?: InputMaybe<Array<AccountManager_Bool_Exp>>;
  accountAccountManagers?: InputMaybe<AccountAccountManager_Bool_Exp>;
  accountAccountManagers_aggregate?: InputMaybe<AccountAccountManager_Aggregate_Bool_Exp>;
  addresses?: InputMaybe<Address_Bool_Exp>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  contacts?: InputMaybe<Contact_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dbaName?: InputMaybe<String_Comparison_Exp>;
  entityFeatures?: InputMaybe<EntityFeature_Bool_Exp>;
  entityFeatures_aggregate?: InputMaybe<EntityFeature_Aggregate_Bool_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Bool_Exp>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  taxId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userProfiles?: InputMaybe<UserProfile_Bool_Exp>;
  userProfiles_aggregate?: InputMaybe<UserProfile_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "account_manager" */
export enum AccountManager_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountManagerPkey = 'account_manager_pkey'
}

/** input type for inserting data into table "account_manager" */
export type AccountManager_Insert_Input = {
  accountAccountManagers?: InputMaybe<AccountAccountManager_Arr_Rel_Insert_Input>;
  addresses?: InputMaybe<Address_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Contact_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbaName?: InputMaybe<Scalars['String']>;
  entityFeatures?: InputMaybe<EntityFeature_Arr_Rel_Insert_Input>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userProfiles?: InputMaybe<UserProfile_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AccountManager_Max_Fields = {
  __typename?: 'accountManager_max_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dbaName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AccountManager_Min_Fields = {
  __typename?: 'accountManager_min_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dbaName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "account_manager" */
export type AccountManager_Mutation_Response = {
  __typename?: 'accountManager_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountManager>;
};

/** input type for inserting object relation for remote table "account_manager" */
export type AccountManager_Obj_Rel_Insert_Input = {
  data: AccountManager_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountManager_On_Conflict>;
};

/** on_conflict condition type for table "account_manager" */
export type AccountManager_On_Conflict = {
  constraint: AccountManager_Constraint;
  update_columns?: Array<AccountManager_Update_Column>;
  where?: InputMaybe<AccountManager_Bool_Exp>;
};

/** Ordering options when selecting data from "account_manager". */
export type AccountManager_Order_By = {
  accountAccountManagers_aggregate?: InputMaybe<AccountAccountManager_Aggregate_Order_By>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Order_By>;
  code?: InputMaybe<Order_By>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dbaName?: InputMaybe<Order_By>;
  entityFeatures_aggregate?: InputMaybe<EntityFeature_Aggregate_Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  taxId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProfiles_aggregate?: InputMaybe<UserProfile_Aggregate_Order_By>;
};

/** primary key columns input for table: account_manager */
export type AccountManager_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "account_manager" */
export enum AccountManager_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DbaName = 'dbaName',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TaxId = 'taxId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "account_manager" */
export type AccountManager_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbaName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "accountManager" */
export type AccountManager_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountManager_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountManager_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbaName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "account_manager" */
export enum AccountManager_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DbaName = 'dbaName',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TaxId = 'taxId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AccountManager_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountManager_Set_Input>;
  /** filter the rows which have to be updated */
  where: AccountManager_Bool_Exp;
};

/** columns and relationships of "account_obligor" */
export type AccountObligor = {
  __typename?: 'accountObligor';
  /** An object relationship */
  account: Account;
  accountId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  obligor: Obligor;
  obligorId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "account_obligor" */
export type AccountObligor_Aggregate = {
  __typename?: 'accountObligor_aggregate';
  aggregate?: Maybe<AccountObligor_Aggregate_Fields>;
  nodes: Array<AccountObligor>;
};

export type AccountObligor_Aggregate_Bool_Exp = {
  count?: InputMaybe<AccountObligor_Aggregate_Bool_Exp_Count>;
};

export type AccountObligor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AccountObligor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountObligor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_obligor" */
export type AccountObligor_Aggregate_Fields = {
  __typename?: 'accountObligor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AccountObligor_Max_Fields>;
  min?: Maybe<AccountObligor_Min_Fields>;
};


/** aggregate fields of "account_obligor" */
export type AccountObligor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountObligor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_obligor" */
export type AccountObligor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AccountObligor_Max_Order_By>;
  min?: InputMaybe<AccountObligor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "account_obligor" */
export type AccountObligor_Arr_Rel_Insert_Input = {
  data: Array<AccountObligor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountObligor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "account_obligor". All fields are combined with a logical 'AND'. */
export type AccountObligor_Bool_Exp = {
  _and?: InputMaybe<Array<AccountObligor_Bool_Exp>>;
  _not?: InputMaybe<AccountObligor_Bool_Exp>;
  _or?: InputMaybe<Array<AccountObligor_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  obligor?: InputMaybe<Obligor_Bool_Exp>;
  obligorId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_obligor" */
export enum AccountObligor_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountObligorPkey = 'account_obligor_pkey'
}

/** input type for inserting data into table "account_obligor" */
export type AccountObligor_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  obligor?: InputMaybe<Obligor_Obj_Rel_Insert_Input>;
  obligorId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccountObligor_Max_Fields = {
  __typename?: 'accountObligor_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  obligorId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "account_obligor" */
export type AccountObligor_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  obligorId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AccountObligor_Min_Fields = {
  __typename?: 'accountObligor_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  obligorId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "account_obligor" */
export type AccountObligor_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  obligorId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_obligor" */
export type AccountObligor_Mutation_Response = {
  __typename?: 'accountObligor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountObligor>;
};

/** on_conflict condition type for table "account_obligor" */
export type AccountObligor_On_Conflict = {
  constraint: AccountObligor_Constraint;
  update_columns?: Array<AccountObligor_Update_Column>;
  where?: InputMaybe<AccountObligor_Bool_Exp>;
};

/** Ordering options when selecting data from "account_obligor". */
export type AccountObligor_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  obligor?: InputMaybe<Obligor_Order_By>;
  obligorId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_obligor */
export type AccountObligor_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "account_obligor" */
export enum AccountObligor_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ObligorId = 'obligorId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "account_obligor" */
export type AccountObligor_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  obligorId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "accountObligor" */
export type AccountObligor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountObligor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountObligor_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  obligorId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "account_obligor" */
export enum AccountObligor_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ObligorId = 'obligorId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AccountObligor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountObligor_Set_Input>;
  /** filter the rows which have to be updated */
  where: AccountObligor_Bool_Exp;
};

/** columns and relationships of "account_product" */
export type AccountProduct = {
  __typename?: 'accountProduct';
  /** An object relationship */
  account: Account;
  accountId: Scalars['uuid'];
  /** An array relationship */
  accountProductObligors: Array<AccountProductObligor>;
  /** An aggregate relationship */
  accountProductObligors_aggregate: AccountProductObligor_Aggregate;
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityEligibilityRules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entityEligibilityRules_aggregate: EntityEligibilityRule_Aggregate;
  /** An array relationship */
  entityOfferings: Array<EntityOffering>;
  /** An aggregate relationship */
  entityOfferings_aggregate: EntityOffering_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  product: Product;
  productId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  workStatusType?: Maybe<WorkStatusType>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "account_product" */
export type AccountProductAccountProductObligorsArgs = {
  distinct_on?: InputMaybe<Array<AccountProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProductObligor_Order_By>>;
  where?: InputMaybe<AccountProductObligor_Bool_Exp>;
};


/** columns and relationships of "account_product" */
export type AccountProductAccountProductObligors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProductObligor_Order_By>>;
  where?: InputMaybe<AccountProductObligor_Bool_Exp>;
};


/** columns and relationships of "account_product" */
export type AccountProductEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "account_product" */
export type AccountProductEntityEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "account_product" */
export type AccountProductEntityOfferingsArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


/** columns and relationships of "account_product" */
export type AccountProductEntityOfferings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};

/** columns and relationships of "account_product_obligor" */
export type AccountProductObligor = {
  __typename?: 'accountProductObligor';
  /** An object relationship */
  accountProduct: AccountProduct;
  accountProductId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  obligor: Obligor;
  obligorId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "account_product_obligor" */
export type AccountProductObligor_Aggregate = {
  __typename?: 'accountProductObligor_aggregate';
  aggregate?: Maybe<AccountProductObligor_Aggregate_Fields>;
  nodes: Array<AccountProductObligor>;
};

export type AccountProductObligor_Aggregate_Bool_Exp = {
  count?: InputMaybe<AccountProductObligor_Aggregate_Bool_Exp_Count>;
};

export type AccountProductObligor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AccountProductObligor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountProductObligor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_product_obligor" */
export type AccountProductObligor_Aggregate_Fields = {
  __typename?: 'accountProductObligor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AccountProductObligor_Max_Fields>;
  min?: Maybe<AccountProductObligor_Min_Fields>;
};


/** aggregate fields of "account_product_obligor" */
export type AccountProductObligor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountProductObligor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_product_obligor" */
export type AccountProductObligor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AccountProductObligor_Max_Order_By>;
  min?: InputMaybe<AccountProductObligor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "account_product_obligor" */
export type AccountProductObligor_Arr_Rel_Insert_Input = {
  data: Array<AccountProductObligor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountProductObligor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "account_product_obligor". All fields are combined with a logical 'AND'. */
export type AccountProductObligor_Bool_Exp = {
  _and?: InputMaybe<Array<AccountProductObligor_Bool_Exp>>;
  _not?: InputMaybe<AccountProductObligor_Bool_Exp>;
  _or?: InputMaybe<Array<AccountProductObligor_Bool_Exp>>;
  accountProduct?: InputMaybe<AccountProduct_Bool_Exp>;
  accountProductId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  obligor?: InputMaybe<Obligor_Bool_Exp>;
  obligorId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_product_obligor" */
export enum AccountProductObligor_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountProductObligorPkey = 'account_product_obligor_pkey'
}

/** input type for inserting data into table "account_product_obligor" */
export type AccountProductObligor_Insert_Input = {
  accountProduct?: InputMaybe<AccountProduct_Obj_Rel_Insert_Input>;
  accountProductId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  obligor?: InputMaybe<Obligor_Obj_Rel_Insert_Input>;
  obligorId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccountProductObligor_Max_Fields = {
  __typename?: 'accountProductObligor_max_fields';
  accountProductId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  obligorId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "account_product_obligor" */
export type AccountProductObligor_Max_Order_By = {
  accountProductId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  obligorId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AccountProductObligor_Min_Fields = {
  __typename?: 'accountProductObligor_min_fields';
  accountProductId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  obligorId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "account_product_obligor" */
export type AccountProductObligor_Min_Order_By = {
  accountProductId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  obligorId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_product_obligor" */
export type AccountProductObligor_Mutation_Response = {
  __typename?: 'accountProductObligor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountProductObligor>;
};

/** on_conflict condition type for table "account_product_obligor" */
export type AccountProductObligor_On_Conflict = {
  constraint: AccountProductObligor_Constraint;
  update_columns?: Array<AccountProductObligor_Update_Column>;
  where?: InputMaybe<AccountProductObligor_Bool_Exp>;
};

/** Ordering options when selecting data from "account_product_obligor". */
export type AccountProductObligor_Order_By = {
  accountProduct?: InputMaybe<AccountProduct_Order_By>;
  accountProductId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  obligor?: InputMaybe<Obligor_Order_By>;
  obligorId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_product_obligor */
export type AccountProductObligor_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "account_product_obligor" */
export enum AccountProductObligor_Select_Column {
  /** column name */
  AccountProductId = 'accountProductId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ObligorId = 'obligorId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "account_product_obligor" */
export type AccountProductObligor_Set_Input = {
  accountProductId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  obligorId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "accountProductObligor" */
export type AccountProductObligor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountProductObligor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountProductObligor_Stream_Cursor_Value_Input = {
  accountProductId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  obligorId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "account_product_obligor" */
export enum AccountProductObligor_Update_Column {
  /** column name */
  AccountProductId = 'accountProductId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ObligorId = 'obligorId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AccountProductObligor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountProductObligor_Set_Input>;
  /** filter the rows which have to be updated */
  where: AccountProductObligor_Bool_Exp;
};

/** aggregated selection of "account_product" */
export type AccountProduct_Aggregate = {
  __typename?: 'accountProduct_aggregate';
  aggregate?: Maybe<AccountProduct_Aggregate_Fields>;
  nodes: Array<AccountProduct>;
};

export type AccountProduct_Aggregate_Bool_Exp = {
  count?: InputMaybe<AccountProduct_Aggregate_Bool_Exp_Count>;
};

export type AccountProduct_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AccountProduct_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountProduct_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_product" */
export type AccountProduct_Aggregate_Fields = {
  __typename?: 'accountProduct_aggregate_fields';
  avg?: Maybe<AccountProduct_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AccountProduct_Max_Fields>;
  min?: Maybe<AccountProduct_Min_Fields>;
  stddev?: Maybe<AccountProduct_Stddev_Fields>;
  stddev_pop?: Maybe<AccountProduct_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AccountProduct_Stddev_Samp_Fields>;
  sum?: Maybe<AccountProduct_Sum_Fields>;
  var_pop?: Maybe<AccountProduct_Var_Pop_Fields>;
  var_samp?: Maybe<AccountProduct_Var_Samp_Fields>;
  variance?: Maybe<AccountProduct_Variance_Fields>;
};


/** aggregate fields of "account_product" */
export type AccountProduct_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountProduct_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_product" */
export type AccountProduct_Aggregate_Order_By = {
  avg?: InputMaybe<AccountProduct_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AccountProduct_Max_Order_By>;
  min?: InputMaybe<AccountProduct_Min_Order_By>;
  stddev?: InputMaybe<AccountProduct_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AccountProduct_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AccountProduct_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AccountProduct_Sum_Order_By>;
  var_pop?: InputMaybe<AccountProduct_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AccountProduct_Var_Samp_Order_By>;
  variance?: InputMaybe<AccountProduct_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "account_product" */
export type AccountProduct_Arr_Rel_Insert_Input = {
  data: Array<AccountProduct_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountProduct_On_Conflict>;
};

/** aggregate avg on columns */
export type AccountProduct_Avg_Fields = {
  __typename?: 'accountProduct_avg_fields';
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "account_product" */
export type AccountProduct_Avg_Order_By = {
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account_product". All fields are combined with a logical 'AND'. */
export type AccountProduct_Bool_Exp = {
  _and?: InputMaybe<Array<AccountProduct_Bool_Exp>>;
  _not?: InputMaybe<AccountProduct_Bool_Exp>;
  _or?: InputMaybe<Array<AccountProduct_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  accountProductObligors?: InputMaybe<AccountProductObligor_Bool_Exp>;
  accountProductObligors_aggregate?: InputMaybe<AccountProductObligor_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  entityOfferings?: InputMaybe<EntityOffering_Bool_Exp>;
  entityOfferings_aggregate?: InputMaybe<EntityOffering_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  workStatusType?: InputMaybe<WorkStatusType_Bool_Exp>;
  workStatusTypeId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_product" */
export enum AccountProduct_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountProductPkey = 'account_product_pkey'
}

/** input type for incrementing numeric columns in table "account_product" */
export type AccountProduct_Inc_Input = {
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "account_product" */
export type AccountProduct_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['uuid']>;
  accountProductObligors?: InputMaybe<AccountProductObligor_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  entityOfferings?: InputMaybe<EntityOffering_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusType?: InputMaybe<WorkStatusType_Obj_Rel_Insert_Input>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AccountProduct_Max_Fields = {
  __typename?: 'accountProduct_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "account_product" */
export type AccountProduct_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AccountProduct_Min_Fields = {
  __typename?: 'accountProduct_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "account_product" */
export type AccountProduct_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_product" */
export type AccountProduct_Mutation_Response = {
  __typename?: 'accountProduct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountProduct>;
};

/** input type for inserting object relation for remote table "account_product" */
export type AccountProduct_Obj_Rel_Insert_Input = {
  data: AccountProduct_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountProduct_On_Conflict>;
};

/** on_conflict condition type for table "account_product" */
export type AccountProduct_On_Conflict = {
  constraint: AccountProduct_Constraint;
  update_columns?: Array<AccountProduct_Update_Column>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};

/** Ordering options when selecting data from "account_product". */
export type AccountProduct_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountId?: InputMaybe<Order_By>;
  accountProductObligors_aggregate?: InputMaybe<AccountProductObligor_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  entityOfferings_aggregate?: InputMaybe<EntityOffering_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusType?: InputMaybe<WorkStatusType_Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_product */
export type AccountProduct_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "account_product" */
export enum AccountProduct_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WorkStatusTypeId = 'workStatusTypeId'
}

/** input type for updating data in table "account_product" */
export type AccountProduct_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AccountProduct_Stddev_Fields = {
  __typename?: 'accountProduct_stddev_fields';
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "account_product" */
export type AccountProduct_Stddev_Order_By = {
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AccountProduct_Stddev_Pop_Fields = {
  __typename?: 'accountProduct_stddev_pop_fields';
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "account_product" */
export type AccountProduct_Stddev_Pop_Order_By = {
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AccountProduct_Stddev_Samp_Fields = {
  __typename?: 'accountProduct_stddev_samp_fields';
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "account_product" */
export type AccountProduct_Stddev_Samp_Order_By = {
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "accountProduct" */
export type AccountProduct_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountProduct_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountProduct_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AccountProduct_Sum_Fields = {
  __typename?: 'accountProduct_sum_fields';
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "account_product" */
export type AccountProduct_Sum_Order_By = {
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "account_product" */
export enum AccountProduct_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WorkStatusTypeId = 'workStatusTypeId'
}

export type AccountProduct_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AccountProduct_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountProduct_Set_Input>;
  /** filter the rows which have to be updated */
  where: AccountProduct_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AccountProduct_Var_Pop_Fields = {
  __typename?: 'accountProduct_var_pop_fields';
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "account_product" */
export type AccountProduct_Var_Pop_Order_By = {
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AccountProduct_Var_Samp_Fields = {
  __typename?: 'accountProduct_var_samp_fields';
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "account_product" */
export type AccountProduct_Var_Samp_Order_By = {
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AccountProduct_Variance_Fields = {
  __typename?: 'accountProduct_variance_fields';
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "account_product" */
export type AccountProduct_Variance_Order_By = {
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "account_retail" */
export type AccountRetail = {
  __typename?: 'accountRetail';
  /** An object relationship */
  account: Account;
  accountId: Scalars['uuid'];
  allowedToDiscountToZero?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  category?: Maybe<Category>;
  /** The category this retail row is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: Maybe<Scalars['uuid']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  createdAt: Scalars['timestamptz'];
  customerPriceOverrideAmount?: Maybe<Scalars['numeric']>;
  dealerCostMarkupAmount?: Maybe<Scalars['numeric']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  markupAmount?: Maybe<Scalars['numeric']>;
  maxProfitAmount?: Maybe<Scalars['numeric']>;
  minProfitAmount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  product?: Maybe<Product>;
  /** The product this retail row applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id that has no product-scoped row of its own. */
  productId?: Maybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['numeric']>;
  remittanceOverrideAmount?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  workStatusType?: Maybe<WorkStatusType>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "account_retail" */
export type AccountRetail_Aggregate = {
  __typename?: 'accountRetail_aggregate';
  aggregate?: Maybe<AccountRetail_Aggregate_Fields>;
  nodes: Array<AccountRetail>;
};

export type AccountRetail_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<AccountRetail_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<AccountRetail_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<AccountRetail_Aggregate_Bool_Exp_Count>;
};

export type AccountRetail_Aggregate_Bool_Exp_Bool_And = {
  arguments: AccountRetail_Select_Column_AccountRetail_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountRetail_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type AccountRetail_Aggregate_Bool_Exp_Bool_Or = {
  arguments: AccountRetail_Select_Column_AccountRetail_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountRetail_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type AccountRetail_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AccountRetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountRetail_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_retail" */
export type AccountRetail_Aggregate_Fields = {
  __typename?: 'accountRetail_aggregate_fields';
  avg?: Maybe<AccountRetail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AccountRetail_Max_Fields>;
  min?: Maybe<AccountRetail_Min_Fields>;
  stddev?: Maybe<AccountRetail_Stddev_Fields>;
  stddev_pop?: Maybe<AccountRetail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AccountRetail_Stddev_Samp_Fields>;
  sum?: Maybe<AccountRetail_Sum_Fields>;
  var_pop?: Maybe<AccountRetail_Var_Pop_Fields>;
  var_samp?: Maybe<AccountRetail_Var_Samp_Fields>;
  variance?: Maybe<AccountRetail_Variance_Fields>;
};


/** aggregate fields of "account_retail" */
export type AccountRetail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountRetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_retail" */
export type AccountRetail_Aggregate_Order_By = {
  avg?: InputMaybe<AccountRetail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AccountRetail_Max_Order_By>;
  min?: InputMaybe<AccountRetail_Min_Order_By>;
  stddev?: InputMaybe<AccountRetail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AccountRetail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AccountRetail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AccountRetail_Sum_Order_By>;
  var_pop?: InputMaybe<AccountRetail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AccountRetail_Var_Samp_Order_By>;
  variance?: InputMaybe<AccountRetail_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "account_retail" */
export type AccountRetail_Arr_Rel_Insert_Input = {
  data: Array<AccountRetail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountRetail_On_Conflict>;
};

/** aggregate avg on columns */
export type AccountRetail_Avg_Fields = {
  __typename?: 'accountRetail_avg_fields';
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  customerPriceOverrideAmount?: Maybe<Scalars['Float']>;
  dealerCostMarkupAmount?: Maybe<Scalars['Float']>;
  markupAmount?: Maybe<Scalars['Float']>;
  maxProfitAmount?: Maybe<Scalars['Float']>;
  minProfitAmount?: Maybe<Scalars['Float']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['Float']>;
  remittanceOverrideAmount?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "account_retail" */
export type AccountRetail_Avg_Order_By = {
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account_retail". All fields are combined with a logical 'AND'. */
export type AccountRetail_Bool_Exp = {
  _and?: InputMaybe<Array<AccountRetail_Bool_Exp>>;
  _not?: InputMaybe<AccountRetail_Bool_Exp>;
  _or?: InputMaybe<Array<AccountRetail_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  allowedToDiscountToZero?: InputMaybe<Boolean_Comparison_Exp>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  coverageMonthsEnd?: InputMaybe<Int_Comparison_Exp>;
  coverageMonthsStart?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customerPriceOverrideAmount?: InputMaybe<Numeric_Comparison_Exp>;
  dealerCostMarkupAmount?: InputMaybe<Numeric_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  markupAmount?: InputMaybe<Numeric_Comparison_Exp>;
  maxProfitAmount?: InputMaybe<Numeric_Comparison_Exp>;
  minProfitAmount?: InputMaybe<Numeric_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  remittanceCostMarkupAmount?: InputMaybe<Numeric_Comparison_Exp>;
  remittanceOverrideAmount?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  workStatusType?: InputMaybe<WorkStatusType_Bool_Exp>;
  workStatusTypeId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_retail" */
export enum AccountRetail_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountRetailPkey = 'account_retail_pkey'
}

/** input type for incrementing numeric columns in table "account_retail" */
export type AccountRetail_Inc_Input = {
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  customerPriceOverrideAmount?: InputMaybe<Scalars['numeric']>;
  dealerCostMarkupAmount?: InputMaybe<Scalars['numeric']>;
  markupAmount?: InputMaybe<Scalars['numeric']>;
  maxProfitAmount?: InputMaybe<Scalars['numeric']>;
  minProfitAmount?: InputMaybe<Scalars['numeric']>;
  remittanceCostMarkupAmount?: InputMaybe<Scalars['numeric']>;
  remittanceOverrideAmount?: InputMaybe<Scalars['numeric']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "account_retail" */
export type AccountRetail_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['uuid']>;
  allowedToDiscountToZero?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  /** The category this retail row is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: InputMaybe<Scalars['uuid']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerPriceOverrideAmount?: InputMaybe<Scalars['numeric']>;
  dealerCostMarkupAmount?: InputMaybe<Scalars['numeric']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  markupAmount?: InputMaybe<Scalars['numeric']>;
  maxProfitAmount?: InputMaybe<Scalars['numeric']>;
  minProfitAmount?: InputMaybe<Scalars['numeric']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  /** The product this retail row applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id that has no product-scoped row of its own. */
  productId?: InputMaybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: InputMaybe<Scalars['numeric']>;
  remittanceOverrideAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusType?: InputMaybe<WorkStatusType_Obj_Rel_Insert_Input>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AccountRetail_Max_Fields = {
  __typename?: 'accountRetail_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  /** The category this retail row is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: Maybe<Scalars['uuid']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerPriceOverrideAmount?: Maybe<Scalars['numeric']>;
  dealerCostMarkupAmount?: Maybe<Scalars['numeric']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  markupAmount?: Maybe<Scalars['numeric']>;
  maxProfitAmount?: Maybe<Scalars['numeric']>;
  minProfitAmount?: Maybe<Scalars['numeric']>;
  /** The product this retail row applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id that has no product-scoped row of its own. */
  productId?: Maybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['numeric']>;
  remittanceOverrideAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "account_retail" */
export type AccountRetail_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  /** The category this retail row is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  /** The product this retail row applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id that has no product-scoped row of its own. */
  productId?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AccountRetail_Min_Fields = {
  __typename?: 'accountRetail_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  /** The category this retail row is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: Maybe<Scalars['uuid']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerPriceOverrideAmount?: Maybe<Scalars['numeric']>;
  dealerCostMarkupAmount?: Maybe<Scalars['numeric']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  markupAmount?: Maybe<Scalars['numeric']>;
  maxProfitAmount?: Maybe<Scalars['numeric']>;
  minProfitAmount?: Maybe<Scalars['numeric']>;
  /** The product this retail row applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id that has no product-scoped row of its own. */
  productId?: Maybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['numeric']>;
  remittanceOverrideAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "account_retail" */
export type AccountRetail_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  /** The category this retail row is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  /** The product this retail row applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id that has no product-scoped row of its own. */
  productId?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_retail" */
export type AccountRetail_Mutation_Response = {
  __typename?: 'accountRetail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountRetail>;
};

/** on_conflict condition type for table "account_retail" */
export type AccountRetail_On_Conflict = {
  constraint: AccountRetail_Constraint;
  update_columns?: Array<AccountRetail_Update_Column>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};

/** Ordering options when selecting data from "account_retail". */
export type AccountRetail_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountId?: InputMaybe<Order_By>;
  allowedToDiscountToZero?: InputMaybe<Order_By>;
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusType?: InputMaybe<WorkStatusType_Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_retail */
export type AccountRetail_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "account_retail" */
export enum AccountRetail_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AllowedToDiscountToZero = 'allowedToDiscountToZero',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CoverageMonthsEnd = 'coverageMonthsEnd',
  /** column name */
  CoverageMonthsStart = 'coverageMonthsStart',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerPriceOverrideAmount = 'customerPriceOverrideAmount',
  /** column name */
  DealerCostMarkupAmount = 'dealerCostMarkupAmount',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  MarkupAmount = 'markupAmount',
  /** column name */
  MaxProfitAmount = 'maxProfitAmount',
  /** column name */
  MinProfitAmount = 'minProfitAmount',
  /** column name */
  ProductId = 'productId',
  /** column name */
  RemittanceCostMarkupAmount = 'remittanceCostMarkupAmount',
  /** column name */
  RemittanceOverrideAmount = 'remittanceOverrideAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WorkStatusTypeId = 'workStatusTypeId'
}

/** select "accountRetail_aggregate_bool_exp_bool_and_arguments_columns" columns of table "account_retail" */
export enum AccountRetail_Select_Column_AccountRetail_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowedToDiscountToZero = 'allowedToDiscountToZero'
}

/** select "accountRetail_aggregate_bool_exp_bool_or_arguments_columns" columns of table "account_retail" */
export enum AccountRetail_Select_Column_AccountRetail_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowedToDiscountToZero = 'allowedToDiscountToZero'
}

/** input type for updating data in table "account_retail" */
export type AccountRetail_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  allowedToDiscountToZero?: InputMaybe<Scalars['Boolean']>;
  /** The category this retail row is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: InputMaybe<Scalars['uuid']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerPriceOverrideAmount?: InputMaybe<Scalars['numeric']>;
  dealerCostMarkupAmount?: InputMaybe<Scalars['numeric']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  markupAmount?: InputMaybe<Scalars['numeric']>;
  maxProfitAmount?: InputMaybe<Scalars['numeric']>;
  minProfitAmount?: InputMaybe<Scalars['numeric']>;
  /** The product this retail row applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id that has no product-scoped row of its own. */
  productId?: InputMaybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: InputMaybe<Scalars['numeric']>;
  remittanceOverrideAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AccountRetail_Stddev_Fields = {
  __typename?: 'accountRetail_stddev_fields';
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  customerPriceOverrideAmount?: Maybe<Scalars['Float']>;
  dealerCostMarkupAmount?: Maybe<Scalars['Float']>;
  markupAmount?: Maybe<Scalars['Float']>;
  maxProfitAmount?: Maybe<Scalars['Float']>;
  minProfitAmount?: Maybe<Scalars['Float']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['Float']>;
  remittanceOverrideAmount?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "account_retail" */
export type AccountRetail_Stddev_Order_By = {
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AccountRetail_Stddev_Pop_Fields = {
  __typename?: 'accountRetail_stddev_pop_fields';
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  customerPriceOverrideAmount?: Maybe<Scalars['Float']>;
  dealerCostMarkupAmount?: Maybe<Scalars['Float']>;
  markupAmount?: Maybe<Scalars['Float']>;
  maxProfitAmount?: Maybe<Scalars['Float']>;
  minProfitAmount?: Maybe<Scalars['Float']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['Float']>;
  remittanceOverrideAmount?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "account_retail" */
export type AccountRetail_Stddev_Pop_Order_By = {
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AccountRetail_Stddev_Samp_Fields = {
  __typename?: 'accountRetail_stddev_samp_fields';
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  customerPriceOverrideAmount?: Maybe<Scalars['Float']>;
  dealerCostMarkupAmount?: Maybe<Scalars['Float']>;
  markupAmount?: Maybe<Scalars['Float']>;
  maxProfitAmount?: Maybe<Scalars['Float']>;
  minProfitAmount?: Maybe<Scalars['Float']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['Float']>;
  remittanceOverrideAmount?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "account_retail" */
export type AccountRetail_Stddev_Samp_Order_By = {
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "accountRetail" */
export type AccountRetail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountRetail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountRetail_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  allowedToDiscountToZero?: InputMaybe<Scalars['Boolean']>;
  /** The category this retail row is configured under in Account Setup — i.e. the category page it is listed on. When product_id is set, rating matches the row by product alone, so this does not have to equal the product's own category (a bundle-only child from another category is configured under its parent's category page). */
  categoryId?: InputMaybe<Scalars['uuid']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerPriceOverrideAmount?: InputMaybe<Scalars['numeric']>;
  dealerCostMarkupAmount?: InputMaybe<Scalars['numeric']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  markupAmount?: InputMaybe<Scalars['numeric']>;
  maxProfitAmount?: InputMaybe<Scalars['numeric']>;
  minProfitAmount?: InputMaybe<Scalars['numeric']>;
  /** The product this retail row applies to; rating matches the row to that product directly, including bundle-only child products configured under a parent's category page. NULL means a category-wide row that applies to every product in category_id that has no product-scoped row of its own. */
  productId?: InputMaybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: InputMaybe<Scalars['numeric']>;
  remittanceOverrideAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AccountRetail_Sum_Fields = {
  __typename?: 'accountRetail_sum_fields';
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  customerPriceOverrideAmount?: Maybe<Scalars['numeric']>;
  dealerCostMarkupAmount?: Maybe<Scalars['numeric']>;
  markupAmount?: Maybe<Scalars['numeric']>;
  maxProfitAmount?: Maybe<Scalars['numeric']>;
  minProfitAmount?: Maybe<Scalars['numeric']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['numeric']>;
  remittanceOverrideAmount?: Maybe<Scalars['numeric']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "account_retail" */
export type AccountRetail_Sum_Order_By = {
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "account_retail" */
export enum AccountRetail_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AllowedToDiscountToZero = 'allowedToDiscountToZero',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CoverageMonthsEnd = 'coverageMonthsEnd',
  /** column name */
  CoverageMonthsStart = 'coverageMonthsStart',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerPriceOverrideAmount = 'customerPriceOverrideAmount',
  /** column name */
  DealerCostMarkupAmount = 'dealerCostMarkupAmount',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  MarkupAmount = 'markupAmount',
  /** column name */
  MaxProfitAmount = 'maxProfitAmount',
  /** column name */
  MinProfitAmount = 'minProfitAmount',
  /** column name */
  ProductId = 'productId',
  /** column name */
  RemittanceCostMarkupAmount = 'remittanceCostMarkupAmount',
  /** column name */
  RemittanceOverrideAmount = 'remittanceOverrideAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WorkStatusTypeId = 'workStatusTypeId'
}

export type AccountRetail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AccountRetail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountRetail_Set_Input>;
  /** filter the rows which have to be updated */
  where: AccountRetail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AccountRetail_Var_Pop_Fields = {
  __typename?: 'accountRetail_var_pop_fields';
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  customerPriceOverrideAmount?: Maybe<Scalars['Float']>;
  dealerCostMarkupAmount?: Maybe<Scalars['Float']>;
  markupAmount?: Maybe<Scalars['Float']>;
  maxProfitAmount?: Maybe<Scalars['Float']>;
  minProfitAmount?: Maybe<Scalars['Float']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['Float']>;
  remittanceOverrideAmount?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "account_retail" */
export type AccountRetail_Var_Pop_Order_By = {
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AccountRetail_Var_Samp_Fields = {
  __typename?: 'accountRetail_var_samp_fields';
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  customerPriceOverrideAmount?: Maybe<Scalars['Float']>;
  dealerCostMarkupAmount?: Maybe<Scalars['Float']>;
  markupAmount?: Maybe<Scalars['Float']>;
  maxProfitAmount?: Maybe<Scalars['Float']>;
  minProfitAmount?: Maybe<Scalars['Float']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['Float']>;
  remittanceOverrideAmount?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "account_retail" */
export type AccountRetail_Var_Samp_Order_By = {
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AccountRetail_Variance_Fields = {
  __typename?: 'accountRetail_variance_fields';
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  customerPriceOverrideAmount?: Maybe<Scalars['Float']>;
  dealerCostMarkupAmount?: Maybe<Scalars['Float']>;
  markupAmount?: Maybe<Scalars['Float']>;
  maxProfitAmount?: Maybe<Scalars['Float']>;
  minProfitAmount?: Maybe<Scalars['Float']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['Float']>;
  remittanceOverrideAmount?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "account_retail" */
export type AccountRetail_Variance_Order_By = {
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  customerPriceOverrideAmount?: InputMaybe<Order_By>;
  dealerCostMarkupAmount?: InputMaybe<Order_By>;
  markupAmount?: InputMaybe<Order_By>;
  maxProfitAmount?: InputMaybe<Order_By>;
  minProfitAmount?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  remittanceOverrideAmount?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "account_type" */
export type AccountType = {
  __typename?: 'accountType';
  /** An array relationship */
  accounts: Array<Account>;
  /** An aggregate relationship */
  accounts_aggregate: Account_Aggregate;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "account_type" */
export type AccountTypeAccountsArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


/** columns and relationships of "account_type" */
export type AccountTypeAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};

/** aggregated selection of "account_type" */
export type AccountType_Aggregate = {
  __typename?: 'accountType_aggregate';
  aggregate?: Maybe<AccountType_Aggregate_Fields>;
  nodes: Array<AccountType>;
};

/** aggregate fields of "account_type" */
export type AccountType_Aggregate_Fields = {
  __typename?: 'accountType_aggregate_fields';
  avg?: Maybe<AccountType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AccountType_Max_Fields>;
  min?: Maybe<AccountType_Min_Fields>;
  stddev?: Maybe<AccountType_Stddev_Fields>;
  stddev_pop?: Maybe<AccountType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AccountType_Stddev_Samp_Fields>;
  sum?: Maybe<AccountType_Sum_Fields>;
  var_pop?: Maybe<AccountType_Var_Pop_Fields>;
  var_samp?: Maybe<AccountType_Var_Samp_Fields>;
  variance?: Maybe<AccountType_Variance_Fields>;
};


/** aggregate fields of "account_type" */
export type AccountType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AccountType_Avg_Fields = {
  __typename?: 'accountType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "account_type". All fields are combined with a logical 'AND'. */
export type AccountType_Bool_Exp = {
  _and?: InputMaybe<Array<AccountType_Bool_Exp>>;
  _not?: InputMaybe<AccountType_Bool_Exp>;
  _or?: InputMaybe<Array<AccountType_Bool_Exp>>;
  accounts?: InputMaybe<Account_Bool_Exp>;
  accounts_aggregate?: InputMaybe<Account_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_type" */
export enum AccountType_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountTypePkey = 'account_type_pkey'
}

/** input type for incrementing numeric columns in table "account_type" */
export type AccountType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "account_type" */
export type AccountType_Insert_Input = {
  accounts?: InputMaybe<Account_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccountType_Max_Fields = {
  __typename?: 'accountType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AccountType_Min_Fields = {
  __typename?: 'accountType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "account_type" */
export type AccountType_Mutation_Response = {
  __typename?: 'accountType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountType>;
};

/** input type for inserting object relation for remote table "account_type" */
export type AccountType_Obj_Rel_Insert_Input = {
  data: AccountType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AccountType_On_Conflict>;
};

/** on_conflict condition type for table "account_type" */
export type AccountType_On_Conflict = {
  constraint: AccountType_Constraint;
  update_columns?: Array<AccountType_Update_Column>;
  where?: InputMaybe<AccountType_Bool_Exp>;
};

/** Ordering options when selecting data from "account_type". */
export type AccountType_Order_By = {
  accounts_aggregate?: InputMaybe<Account_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_type */
export type AccountType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "account_type" */
export enum AccountType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "account_type" */
export type AccountType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type AccountType_Stddev_Fields = {
  __typename?: 'accountType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AccountType_Stddev_Pop_Fields = {
  __typename?: 'accountType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AccountType_Stddev_Samp_Fields = {
  __typename?: 'accountType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "accountType" */
export type AccountType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AccountType_Sum_Fields = {
  __typename?: 'accountType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "account_type" */
export enum AccountType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AccountType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AccountType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountType_Set_Input>;
  /** filter the rows which have to be updated */
  where: AccountType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AccountType_Var_Pop_Fields = {
  __typename?: 'accountType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AccountType_Var_Samp_Fields = {
  __typename?: 'accountType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AccountType_Variance_Fields = {
  __typename?: 'accountType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "account" */
export type Account_Aggregate = {
  __typename?: 'account_aggregate';
  aggregate?: Maybe<Account_Aggregate_Fields>;
  nodes: Array<Account>;
};

export type Account_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Account_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Account_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Account_Aggregate_Bool_Exp_Count>;
};

export type Account_Aggregate_Bool_Exp_Bool_And = {
  arguments: Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Account_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Account_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account" */
export type Account_Aggregate_Fields = {
  __typename?: 'account_aggregate_fields';
  avg?: Maybe<Account_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Account_Max_Fields>;
  min?: Maybe<Account_Min_Fields>;
  stddev?: Maybe<Account_Stddev_Fields>;
  stddev_pop?: Maybe<Account_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Account_Stddev_Samp_Fields>;
  sum?: Maybe<Account_Sum_Fields>;
  var_pop?: Maybe<Account_Var_Pop_Fields>;
  var_samp?: Maybe<Account_Var_Samp_Fields>;
  variance?: Maybe<Account_Variance_Fields>;
};


/** aggregate fields of "account" */
export type Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account" */
export type Account_Aggregate_Order_By = {
  avg?: InputMaybe<Account_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Max_Order_By>;
  min?: InputMaybe<Account_Min_Order_By>;
  stddev?: InputMaybe<Account_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Account_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Account_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Account_Sum_Order_By>;
  var_pop?: InputMaybe<Account_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Account_Var_Samp_Order_By>;
  variance?: InputMaybe<Account_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Account_Append_Input = {
  /** Array of strings built from the account name split on spaces, the account code, and AS400 Code from entity_configuration, all uppercase. */
  keywordsMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "account" */
export type Account_Arr_Rel_Insert_Input = {
  data: Array<Account_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_On_Conflict>;
};

/** aggregate avg on columns */
export type Account_Avg_Fields = {
  __typename?: 'account_avg_fields';
  accountTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "account" */
export type Account_Avg_Order_By = {
  accountTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account". All fields are combined with a logical 'AND'. */
export type Account_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Bool_Exp>>;
  _not?: InputMaybe<Account_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Bool_Exp>>;
  accountAccountManagers?: InputMaybe<AccountAccountManager_Bool_Exp>;
  accountAccountManagers_aggregate?: InputMaybe<AccountAccountManager_Aggregate_Bool_Exp>;
  accountCategories?: InputMaybe<AccountCategory_Bool_Exp>;
  accountCategories_aggregate?: InputMaybe<AccountCategory_Aggregate_Bool_Exp>;
  accountDisbursements?: InputMaybe<AccountDisbursement_Bool_Exp>;
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Bool_Exp>;
  accountObligors?: InputMaybe<AccountObligor_Bool_Exp>;
  accountObligors_aggregate?: InputMaybe<AccountObligor_Aggregate_Bool_Exp>;
  accountProducts?: InputMaybe<AccountProduct_Bool_Exp>;
  accountProducts_aggregate?: InputMaybe<AccountProduct_Aggregate_Bool_Exp>;
  accountRetails?: InputMaybe<AccountRetail_Bool_Exp>;
  accountRetails_aggregate?: InputMaybe<AccountRetail_Aggregate_Bool_Exp>;
  accountType?: InputMaybe<AccountType_Bool_Exp>;
  accountTypeId?: InputMaybe<Int_Comparison_Exp>;
  addresses?: InputMaybe<Address_Bool_Exp>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  contacts?: InputMaybe<Contact_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentLossRatios?: InputMaybe<LossRatioCurrentView_Bool_Exp>;
  currentLossRatios_aggregate?: InputMaybe<LossRatioCurrentView_Aggregate_Bool_Exp>;
  dbaName?: InputMaybe<String_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityBillingInformations?: InputMaybe<EntityBillingInformation_Bool_Exp>;
  entityBillingInformations_aggregate?: InputMaybe<EntityBillingInformation_Aggregate_Bool_Exp>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Bool_Exp>;
  entityCustomFields?: InputMaybe<EntityCustomField_Bool_Exp>;
  entityCustomFields_aggregate?: InputMaybe<EntityCustomField_Aggregate_Bool_Exp>;
  entityFeatures?: InputMaybe<EntityFeature_Bool_Exp>;
  entityFeatures_aggregate?: InputMaybe<EntityFeature_Aggregate_Bool_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityEntities?: InputMaybe<IdentityEntity_Bool_Exp>;
  identityEntities_aggregate?: InputMaybe<IdentityEntity_Aggregate_Bool_Exp>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Bool_Exp>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Bool_Exp>;
  isGmDealer?: InputMaybe<Boolean_Comparison_Exp>;
  keywordsMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  lossRatios?: InputMaybe<LossRatio_Bool_Exp>;
  lossRatios_aggregate?: InputMaybe<LossRatio_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  policyContracts?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Bool_Exp>;
  serviceCenters?: InputMaybe<ServiceCenter_Bool_Exp>;
  serviceCenters_aggregate?: InputMaybe<ServiceCenter_Aggregate_Bool_Exp>;
  taxId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userProfiles?: InputMaybe<UserProfile_Bool_Exp>;
  userProfiles_aggregate?: InputMaybe<UserProfile_Aggregate_Bool_Exp>;
  workStatusType?: InputMaybe<WorkStatusType_Bool_Exp>;
  workStatusTypeId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "account" */
export enum Account_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountPkey = 'account_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Account_Delete_At_Path_Input = {
  /** Array of strings built from the account name split on spaces, the account code, and AS400 Code from entity_configuration, all uppercase. */
  keywordsMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Account_Delete_Elem_Input = {
  /** Array of strings built from the account name split on spaces, the account code, and AS400 Code from entity_configuration, all uppercase. */
  keywordsMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Account_Delete_Key_Input = {
  /** Array of strings built from the account name split on spaces, the account code, and AS400 Code from entity_configuration, all uppercase. */
  keywordsMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "account" */
export type Account_Inc_Input = {
  accountTypeId?: InputMaybe<Scalars['Int']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "account" */
export type Account_Insert_Input = {
  accountAccountManagers?: InputMaybe<AccountAccountManager_Arr_Rel_Insert_Input>;
  accountCategories?: InputMaybe<AccountCategory_Arr_Rel_Insert_Input>;
  accountDisbursements?: InputMaybe<AccountDisbursement_Arr_Rel_Insert_Input>;
  accountObligors?: InputMaybe<AccountObligor_Arr_Rel_Insert_Input>;
  accountProducts?: InputMaybe<AccountProduct_Arr_Rel_Insert_Input>;
  accountRetails?: InputMaybe<AccountRetail_Arr_Rel_Insert_Input>;
  accountType?: InputMaybe<AccountType_Obj_Rel_Insert_Input>;
  accountTypeId?: InputMaybe<Scalars['Int']>;
  addresses?: InputMaybe<Address_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Contact_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentLossRatios?: InputMaybe<LossRatioCurrentView_Arr_Rel_Insert_Input>;
  dbaName?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityBillingInformations?: InputMaybe<EntityBillingInformation_Arr_Rel_Insert_Input>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Arr_Rel_Insert_Input>;
  entityCustomFields?: InputMaybe<EntityCustomField_Arr_Rel_Insert_Input>;
  entityFeatures?: InputMaybe<EntityFeature_Arr_Rel_Insert_Input>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityEntities?: InputMaybe<IdentityEntity_Arr_Rel_Insert_Input>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Arr_Rel_Insert_Input>;
  isGmDealer?: InputMaybe<Scalars['Boolean']>;
  /** Array of strings built from the account name split on spaces, the account code, and AS400 Code from entity_configuration, all uppercase. */
  keywordsMetadata?: InputMaybe<Scalars['jsonb']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  lossRatios?: InputMaybe<LossRatio_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  policyContracts?: InputMaybe<PolicyContract_Arr_Rel_Insert_Input>;
  serviceCenters?: InputMaybe<ServiceCenter_Arr_Rel_Insert_Input>;
  taxId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userProfiles?: InputMaybe<UserProfile_Arr_Rel_Insert_Input>;
  workStatusType?: InputMaybe<WorkStatusType_Obj_Rel_Insert_Input>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Account_Max_Fields = {
  __typename?: 'account_max_fields';
  accountTypeId?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dbaName?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "account" */
export type Account_Max_Order_By = {
  accountTypeId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dbaName?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  taxId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Min_Fields = {
  __typename?: 'account_min_fields';
  accountTypeId?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dbaName?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "account" */
export type Account_Min_Order_By = {
  accountTypeId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dbaName?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  taxId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account" */
export type Account_Mutation_Response = {
  __typename?: 'account_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Account>;
};

/** input type for inserting object relation for remote table "account" */
export type Account_Obj_Rel_Insert_Input = {
  data: Account_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_On_Conflict>;
};

/** on_conflict condition type for table "account" */
export type Account_On_Conflict = {
  constraint: Account_Constraint;
  update_columns?: Array<Account_Update_Column>;
  where?: InputMaybe<Account_Bool_Exp>;
};

/** Ordering options when selecting data from "account". */
export type Account_Order_By = {
  accountAccountManagers_aggregate?: InputMaybe<AccountAccountManager_Aggregate_Order_By>;
  accountCategories_aggregate?: InputMaybe<AccountCategory_Aggregate_Order_By>;
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Order_By>;
  accountObligors_aggregate?: InputMaybe<AccountObligor_Aggregate_Order_By>;
  accountProducts_aggregate?: InputMaybe<AccountProduct_Aggregate_Order_By>;
  accountRetails_aggregate?: InputMaybe<AccountRetail_Aggregate_Order_By>;
  accountType?: InputMaybe<AccountType_Order_By>;
  accountTypeId?: InputMaybe<Order_By>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Order_By>;
  code?: InputMaybe<Order_By>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentLossRatios_aggregate?: InputMaybe<LossRatioCurrentView_Aggregate_Order_By>;
  dbaName?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityBillingInformations_aggregate?: InputMaybe<EntityBillingInformation_Aggregate_Order_By>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Order_By>;
  entityCustomFields_aggregate?: InputMaybe<EntityCustomField_Aggregate_Order_By>;
  entityFeatures_aggregate?: InputMaybe<EntityFeature_Aggregate_Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityEntities_aggregate?: InputMaybe<IdentityEntity_Aggregate_Order_By>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Order_By>;
  isGmDealer?: InputMaybe<Order_By>;
  keywordsMetadata?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  lossRatios_aggregate?: InputMaybe<LossRatio_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Order_By>;
  serviceCenters_aggregate?: InputMaybe<ServiceCenter_Aggregate_Order_By>;
  taxId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProfiles_aggregate?: InputMaybe<UserProfile_Aggregate_Order_By>;
  workStatusType?: InputMaybe<WorkStatusType_Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account */
export type Account_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Account_Prepend_Input = {
  /** Array of strings built from the account name split on spaces, the account code, and AS400 Code from entity_configuration, all uppercase. */
  keywordsMetadata?: InputMaybe<Scalars['jsonb']>;
};

export type Account_Search_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** select columns of table "account" */
export enum Account_Select_Column {
  /** column name */
  AccountTypeId = 'accountTypeId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DbaName = 'dbaName',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsGmDealer = 'isGmDealer',
  /** column name */
  KeywordsMetadata = 'keywordsMetadata',
  /** column name */
  Name = 'name',
  /** column name */
  TaxId = 'taxId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WorkStatusTypeId = 'workStatusTypeId'
}

/** select "account_aggregate_bool_exp_bool_and_arguments_columns" columns of table "account" */
export enum Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsGmDealer = 'isGmDealer'
}

/** select "account_aggregate_bool_exp_bool_or_arguments_columns" columns of table "account" */
export enum Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsGmDealer = 'isGmDealer'
}

/** input type for updating data in table "account" */
export type Account_Set_Input = {
  accountTypeId?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbaName?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isGmDealer?: InputMaybe<Scalars['Boolean']>;
  /** Array of strings built from the account name split on spaces, the account code, and AS400 Code from entity_configuration, all uppercase. */
  keywordsMetadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Account_Stddev_Fields = {
  __typename?: 'account_stddev_fields';
  accountTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "account" */
export type Account_Stddev_Order_By = {
  accountTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Account_Stddev_Pop_Fields = {
  __typename?: 'account_stddev_pop_fields';
  accountTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "account" */
export type Account_Stddev_Pop_Order_By = {
  accountTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Account_Stddev_Samp_Fields = {
  __typename?: 'account_stddev_samp_fields';
  accountTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "account" */
export type Account_Stddev_Samp_Order_By = {
  accountTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "account" */
export type Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Stream_Cursor_Value_Input = {
  accountTypeId?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbaName?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isGmDealer?: InputMaybe<Scalars['Boolean']>;
  /** Array of strings built from the account name split on spaces, the account code, and AS400 Code from entity_configuration, all uppercase. */
  keywordsMetadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workStatusTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Account_Sum_Fields = {
  __typename?: 'account_sum_fields';
  accountTypeId?: Maybe<Scalars['Int']>;
  workStatusTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "account" */
export type Account_Sum_Order_By = {
  accountTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "account" */
export enum Account_Update_Column {
  /** column name */
  AccountTypeId = 'accountTypeId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DbaName = 'dbaName',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsGmDealer = 'isGmDealer',
  /** column name */
  KeywordsMetadata = 'keywordsMetadata',
  /** column name */
  Name = 'name',
  /** column name */
  TaxId = 'taxId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WorkStatusTypeId = 'workStatusTypeId'
}

export type Account_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Account_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Account_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Account_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Account_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Account_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_Var_Pop_Fields = {
  __typename?: 'account_var_pop_fields';
  accountTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "account" */
export type Account_Var_Pop_Order_By = {
  accountTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Account_Var_Samp_Fields = {
  __typename?: 'account_var_samp_fields';
  accountTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "account" */
export type Account_Var_Samp_Order_By = {
  accountTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Account_Variance_Fields = {
  __typename?: 'account_variance_fields';
  accountTypeId?: Maybe<Scalars['Float']>;
  workStatusTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "account" */
export type Account_Variance_Order_By = {
  accountTypeId?: InputMaybe<Order_By>;
  workStatusTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "address" */
export type Address = {
  __typename?: 'address';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  accountManager?: Maybe<AccountManager>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  /** An object relationship */
  addressType?: Maybe<AddressType>;
  addressTypeId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  carrier?: Maybe<Carrier>;
  city?: Maybe<Scalars['String']>;
  /** An object relationship */
  contact?: Maybe<Contact>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  obligor?: Maybe<Obligor>;
  /** An array relationship */
  obligors: Array<Obligor>;
  /** An aggregate relationship */
  obligors_aggregate: Obligor_Aggregate;
  parentId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment?: Maybe<Payment>;
  /** An array relationship */
  serviceCenters: Array<ServiceCenter>;
  /** An aggregate relationship */
  serviceCenters_aggregate: ServiceCenter_Aggregate;
  state?: Maybe<Scalars['String']>;
  /** An object relationship */
  stateInformation?: Maybe<State>;
  updatedAt: Scalars['timestamptz'];
  zip?: Maybe<Scalars['String']>;
};


/** columns and relationships of "address" */
export type AddressLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressObligorsArgs = {
  distinct_on?: InputMaybe<Array<Obligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Obligor_Order_By>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressObligors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Obligor_Order_By>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressServiceCenters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};

/** columns and relationships of "address_type" */
export type AddressType = {
  __typename?: 'addressType';
  /** An array relationship */
  addresses: Array<Address>;
  /** An aggregate relationship */
  addresses_aggregate: Address_Aggregate;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "address_type" */
export type AddressTypeAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "address_type" */
export type AddressTypeAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** aggregated selection of "address_type" */
export type AddressType_Aggregate = {
  __typename?: 'addressType_aggregate';
  aggregate?: Maybe<AddressType_Aggregate_Fields>;
  nodes: Array<AddressType>;
};

/** aggregate fields of "address_type" */
export type AddressType_Aggregate_Fields = {
  __typename?: 'addressType_aggregate_fields';
  avg?: Maybe<AddressType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AddressType_Max_Fields>;
  min?: Maybe<AddressType_Min_Fields>;
  stddev?: Maybe<AddressType_Stddev_Fields>;
  stddev_pop?: Maybe<AddressType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AddressType_Stddev_Samp_Fields>;
  sum?: Maybe<AddressType_Sum_Fields>;
  var_pop?: Maybe<AddressType_Var_Pop_Fields>;
  var_samp?: Maybe<AddressType_Var_Samp_Fields>;
  variance?: Maybe<AddressType_Variance_Fields>;
};


/** aggregate fields of "address_type" */
export type AddressType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AddressType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AddressType_Avg_Fields = {
  __typename?: 'addressType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "address_type". All fields are combined with a logical 'AND'. */
export type AddressType_Bool_Exp = {
  _and?: InputMaybe<Array<AddressType_Bool_Exp>>;
  _not?: InputMaybe<AddressType_Bool_Exp>;
  _or?: InputMaybe<Array<AddressType_Bool_Exp>>;
  addresses?: InputMaybe<Address_Bool_Exp>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "address_type" */
export enum AddressType_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressTypePkey = 'address_type_pkey'
}

/** input type for incrementing numeric columns in table "address_type" */
export type AddressType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "address_type" */
export type AddressType_Insert_Input = {
  addresses?: InputMaybe<Address_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AddressType_Max_Fields = {
  __typename?: 'addressType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AddressType_Min_Fields = {
  __typename?: 'addressType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "address_type" */
export type AddressType_Mutation_Response = {
  __typename?: 'addressType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AddressType>;
};

/** input type for inserting object relation for remote table "address_type" */
export type AddressType_Obj_Rel_Insert_Input = {
  data: AddressType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AddressType_On_Conflict>;
};

/** on_conflict condition type for table "address_type" */
export type AddressType_On_Conflict = {
  constraint: AddressType_Constraint;
  update_columns?: Array<AddressType_Update_Column>;
  where?: InputMaybe<AddressType_Bool_Exp>;
};

/** Ordering options when selecting data from "address_type". */
export type AddressType_Order_By = {
  addresses_aggregate?: InputMaybe<Address_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address_type */
export type AddressType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "address_type" */
export enum AddressType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "address_type" */
export type AddressType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type AddressType_Stddev_Fields = {
  __typename?: 'addressType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AddressType_Stddev_Pop_Fields = {
  __typename?: 'addressType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AddressType_Stddev_Samp_Fields = {
  __typename?: 'addressType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "addressType" */
export type AddressType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AddressType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AddressType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AddressType_Sum_Fields = {
  __typename?: 'addressType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "address_type" */
export enum AddressType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AddressType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AddressType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AddressType_Set_Input>;
  /** filter the rows which have to be updated */
  where: AddressType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AddressType_Var_Pop_Fields = {
  __typename?: 'addressType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AddressType_Var_Samp_Fields = {
  __typename?: 'addressType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AddressType_Variance_Fields = {
  __typename?: 'addressType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "address" */
export type Address_Aggregate = {
  __typename?: 'address_aggregate';
  aggregate?: Maybe<Address_Aggregate_Fields>;
  nodes: Array<Address>;
};

export type Address_Aggregate_Bool_Exp = {
  count?: InputMaybe<Address_Aggregate_Bool_Exp_Count>;
};

export type Address_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Address_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "address" */
export type Address_Aggregate_Fields = {
  __typename?: 'address_aggregate_fields';
  avg?: Maybe<Address_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Address_Max_Fields>;
  min?: Maybe<Address_Min_Fields>;
  stddev?: Maybe<Address_Stddev_Fields>;
  stddev_pop?: Maybe<Address_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Address_Stddev_Samp_Fields>;
  sum?: Maybe<Address_Sum_Fields>;
  var_pop?: Maybe<Address_Var_Pop_Fields>;
  var_samp?: Maybe<Address_Var_Samp_Fields>;
  variance?: Maybe<Address_Variance_Fields>;
};


/** aggregate fields of "address" */
export type Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "address" */
export type Address_Aggregate_Order_By = {
  avg?: InputMaybe<Address_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Address_Max_Order_By>;
  min?: InputMaybe<Address_Min_Order_By>;
  stddev?: InputMaybe<Address_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Address_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Address_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Address_Sum_Order_By>;
  var_pop?: InputMaybe<Address_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Address_Var_Samp_Order_By>;
  variance?: InputMaybe<Address_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "address" */
export type Address_Arr_Rel_Insert_Input = {
  data: Array<Address_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** aggregate avg on columns */
export type Address_Avg_Fields = {
  __typename?: 'address_avg_fields';
  addressTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "address" */
export type Address_Avg_Order_By = {
  addressTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountManager?: InputMaybe<AccountManager_Bool_Exp>;
  address1?: InputMaybe<String_Comparison_Exp>;
  address2?: InputMaybe<String_Comparison_Exp>;
  addressType?: InputMaybe<AddressType_Bool_Exp>;
  addressTypeId?: InputMaybe<Int_Comparison_Exp>;
  carrier?: InputMaybe<Carrier_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  obligor?: InputMaybe<Obligor_Bool_Exp>;
  obligors?: InputMaybe<Obligor_Bool_Exp>;
  obligors_aggregate?: InputMaybe<Obligor_Aggregate_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  payment?: InputMaybe<Payment_Bool_Exp>;
  serviceCenters?: InputMaybe<ServiceCenter_Bool_Exp>;
  serviceCenters_aggregate?: InputMaybe<ServiceCenter_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  stateInformation?: InputMaybe<State_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** input type for incrementing numeric columns in table "address" */
export type Address_Inc_Input = {
  addressTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountManager?: InputMaybe<AccountManager_Obj_Rel_Insert_Input>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<AddressType_Obj_Rel_Insert_Input>;
  addressTypeId?: InputMaybe<Scalars['Int']>;
  carrier?: InputMaybe<Carrier_Obj_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  obligor?: InputMaybe<Obligor_Obj_Rel_Insert_Input>;
  obligors?: InputMaybe<Obligor_Arr_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['uuid']>;
  payment?: InputMaybe<Payment_Obj_Rel_Insert_Input>;
  serviceCenters?: InputMaybe<ServiceCenter_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  stateInformation?: InputMaybe<State_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Address_Max_Fields = {
  __typename?: 'address_max_fields';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressTypeId?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "address" */
export type Address_Max_Order_By = {
  address1?: InputMaybe<Order_By>;
  address2?: InputMaybe<Order_By>;
  addressTypeId?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Address_Min_Fields = {
  __typename?: 'address_min_fields';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressTypeId?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "address" */
export type Address_Min_Order_By = {
  address1?: InputMaybe<Order_By>;
  address2?: InputMaybe<Order_By>;
  addressTypeId?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: 'address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountManager?: InputMaybe<AccountManager_Order_By>;
  address1?: InputMaybe<Order_By>;
  address2?: InputMaybe<Order_By>;
  addressType?: InputMaybe<AddressType_Order_By>;
  addressTypeId?: InputMaybe<Order_By>;
  carrier?: InputMaybe<Carrier_Order_By>;
  city?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  obligor?: InputMaybe<Obligor_Order_By>;
  obligors_aggregate?: InputMaybe<Obligor_Aggregate_Order_By>;
  parentId?: InputMaybe<Order_By>;
  payment?: InputMaybe<Payment_Order_By>;
  serviceCenters_aggregate?: InputMaybe<ServiceCenter_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  stateInformation?: InputMaybe<State_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  Address1 = 'address1',
  /** column name */
  Address2 = 'address2',
  /** column name */
  AddressTypeId = 'addressTypeId',
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressTypeId?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Address_Stddev_Fields = {
  __typename?: 'address_stddev_fields';
  addressTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "address" */
export type Address_Stddev_Order_By = {
  addressTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Address_Stddev_Pop_Fields = {
  __typename?: 'address_stddev_pop_fields';
  addressTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "address" */
export type Address_Stddev_Pop_Order_By = {
  addressTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Address_Stddev_Samp_Fields = {
  __typename?: 'address_stddev_samp_fields';
  addressTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "address" */
export type Address_Stddev_Samp_Order_By = {
  addressTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressTypeId?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Address_Sum_Fields = {
  __typename?: 'address_sum_fields';
  addressTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "address" */
export type Address_Sum_Order_By = {
  addressTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  Address1 = 'address1',
  /** column name */
  Address2 = 'address2',
  /** column name */
  AddressTypeId = 'addressTypeId',
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Zip = 'zip'
}

export type Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Address_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Address_Var_Pop_Fields = {
  __typename?: 'address_var_pop_fields';
  addressTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "address" */
export type Address_Var_Pop_Order_By = {
  addressTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Address_Var_Samp_Fields = {
  __typename?: 'address_var_samp_fields';
  addressTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "address" */
export type Address_Var_Samp_Order_By = {
  addressTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Address_Variance_Fields = {
  __typename?: 'address_variance_fields';
  addressTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "address" */
export type Address_Variance_Order_By = {
  addressTypeId?: InputMaybe<Order_By>;
};

/** A configured message surfaced to a user when the entity they are viewing satisfies the Alert's attached Eligibility Rules (shared.entity_eligibility_rule, parent_id = the alert id). An Alert with no attached rules shows on every entity its consumer evaluates. Business-managed data: created and retired by administrators, never by a deploy. */
export type Alert = {
  __typename?: 'alert';
  /** An array relationship */
  alertAcknowledgments: Array<AlertAcknowledgment>;
  /** An aggregate relationship */
  alertAcknowledgments_aggregate: AlertAcknowledgment_Aggregate;
  /** An object relationship */
  alertType: Type;
  /** Severity, from the AlertSeverity group in shared.type (Critical, Warning). Presentational only — it groups and orders the panel and never changes whether an alert matches. Consumers render whatever members exist, ordered by shared.type.enum_value. */
  alertTypeId: Scalars['uuid'];
  /** An object relationship */
  application: Application;
  /** The single application this alert is DISPLAYED in (Claims, Operations, …). Distinct from eligibility_rule.application_id, which controls which admin screen may edit a rule — display reach is never inferred from rule ownership. */
  applicationId: Scalars['uuid'];
  /** An array relationship */
  applicationRoutes: Array<Route>;
  /** An aggregate relationship */
  applicationRoutes_aggregate: Route_Aggregate;
  createdAt: Scalars['timestamptz'];
  /** First date the alert can match. Evaluation compares this window against the caller's effective date, so alerts can be introduced on a schedule without a deploy. */
  effectiveDate: Scalars['date'];
  /** An array relationship */
  entityEligibilityRules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entityEligibilityRules_aggregate: EntityEligibilityRule_Aggregate;
  /** Last date the alert can match; NULL means it never expires. Retiring an alert means setting this, not deleting the row — acknowledgments reference it. */
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** The text shown to the user. Static: no templating or placeholder interpolation in v1. */
  message: Scalars['String'];
  /** Administrative label, shown only in the alerts admin screens so staff can find and reuse an alert. Never shown to the adjuster — the adjuster sees message. */
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** A configured message surfaced to a user when the entity they are viewing satisfies the Alert's attached Eligibility Rules (shared.entity_eligibility_rule, parent_id = the alert id). An Alert with no attached rules shows on every entity its consumer evaluates. Business-managed data: created and retired by administrators, never by a deploy. */
export type AlertAlertAcknowledgmentsArgs = {
  distinct_on?: InputMaybe<Array<AlertAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertAcknowledgment_Order_By>>;
  where?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
};


/** A configured message surfaced to a user when the entity they are viewing satisfies the Alert's attached Eligibility Rules (shared.entity_eligibility_rule, parent_id = the alert id). An Alert with no attached rules shows on every entity its consumer evaluates. Business-managed data: created and retired by administrators, never by a deploy. */
export type AlertAlertAcknowledgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AlertAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertAcknowledgment_Order_By>>;
  where?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
};


/** A configured message surfaced to a user when the entity they are viewing satisfies the Alert's attached Eligibility Rules (shared.entity_eligibility_rule, parent_id = the alert id). An Alert with no attached rules shows on every entity its consumer evaluates. Business-managed data: created and retired by administrators, never by a deploy. */
export type AlertApplicationRoutesArgs = {
  distinct_on?: InputMaybe<Array<Route_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Route_Order_By>>;
  where?: InputMaybe<Route_Bool_Exp>;
};


/** A configured message surfaced to a user when the entity they are viewing satisfies the Alert's attached Eligibility Rules (shared.entity_eligibility_rule, parent_id = the alert id). An Alert with no attached rules shows on every entity its consumer evaluates. Business-managed data: created and retired by administrators, never by a deploy. */
export type AlertApplicationRoutes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Route_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Route_Order_By>>;
  where?: InputMaybe<Route_Bool_Exp>;
};


/** A configured message surfaced to a user when the entity they are viewing satisfies the Alert's attached Eligibility Rules (shared.entity_eligibility_rule, parent_id = the alert id). An Alert with no attached rules shows on every entity its consumer evaluates. Business-managed data: created and retired by administrators, never by a deploy. */
export type AlertEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** A configured message surfaced to a user when the entity they are viewing satisfies the Alert's attached Eligibility Rules (shared.entity_eligibility_rule, parent_id = the alert id). An Alert with no attached rules shows on every entity its consumer evaluates. Business-managed data: created and retired by administrators, never by a deploy. */
export type AlertEntityEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** A configured message surfaced to a user when the entity they are viewing satisfies the Alert's attached Eligibility Rules (shared.entity_eligibility_rule, parent_id = the alert id). An Alert with no attached rules shows on every entity its consumer evaluates. Business-managed data: created and retired by administrators, never by a deploy. */
export type AlertLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** A configured message surfaced to a user when the entity they are viewing satisfies the Alert's attached Eligibility Rules (shared.entity_eligibility_rule, parent_id = the alert id). An Alert with no attached rules shows on every entity its consumer evaluates. Business-managed data: created and retired by administrators, never by a deploy. */
export type AlertLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** One row per acceptance: this identity has read this alert on this entity. Insert-only — never updated or deleted, so it doubles as the permanent audit trail of who saw what and when. The read path filters matched alerts to those with no row here for the acting identity + entity; that is what releases the gate. */
export type AlertAcknowledgment = {
  __typename?: 'alertAcknowledgment';
  /** An object relationship */
  alert: Alert;
  /** The alert accepted. Acceptance is per alert, so an alert added later gates a user who has already worked the entity. */
  alertId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  identity?: Maybe<Identity>;
  /** The Ory identity that accepted. No FK into the Ory-managed schema. Acceptance is per identity: a colleague opening the same entity is gated independently. */
  identityId: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** The entity the alert was accepted on — a claims.policy_claim id in v1, deliberately generic so other consumers (contracts, accounts) need no schema change. No FK (polymorphic), same pattern as shared.participant.parent_id. */
  parentId: Scalars['uuid'];
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
};


/** One row per acceptance: this identity has read this alert on this entity. Insert-only — never updated or deleted, so it doubles as the permanent audit trail of who saw what and when. The read path filters matched alerts to those with no row here for the acting identity + entity; that is what releases the gate. */
export type AlertAcknowledgmentLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** One row per acceptance: this identity has read this alert on this entity. Insert-only — never updated or deleted, so it doubles as the permanent audit trail of who saw what and when. The read path filters matched alerts to those with no row here for the acting identity + entity; that is what releases the gate. */
export type AlertAcknowledgmentLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "shared.alert_acknowledgment" */
export type AlertAcknowledgment_Aggregate = {
  __typename?: 'alertAcknowledgment_aggregate';
  aggregate?: Maybe<AlertAcknowledgment_Aggregate_Fields>;
  nodes: Array<AlertAcknowledgment>;
};

export type AlertAcknowledgment_Aggregate_Bool_Exp = {
  count?: InputMaybe<AlertAcknowledgment_Aggregate_Bool_Exp_Count>;
};

export type AlertAcknowledgment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AlertAcknowledgment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.alert_acknowledgment" */
export type AlertAcknowledgment_Aggregate_Fields = {
  __typename?: 'alertAcknowledgment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AlertAcknowledgment_Max_Fields>;
  min?: Maybe<AlertAcknowledgment_Min_Fields>;
};


/** aggregate fields of "shared.alert_acknowledgment" */
export type AlertAcknowledgment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AlertAcknowledgment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.alert_acknowledgment" */
export type AlertAcknowledgment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AlertAcknowledgment_Max_Order_By>;
  min?: InputMaybe<AlertAcknowledgment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.alert_acknowledgment" */
export type AlertAcknowledgment_Arr_Rel_Insert_Input = {
  data: Array<AlertAcknowledgment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AlertAcknowledgment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.alert_acknowledgment". All fields are combined with a logical 'AND'. */
export type AlertAcknowledgment_Bool_Exp = {
  _and?: InputMaybe<Array<AlertAcknowledgment_Bool_Exp>>;
  _not?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
  _or?: InputMaybe<Array<AlertAcknowledgment_Bool_Exp>>;
  alert?: InputMaybe<Alert_Bool_Exp>;
  alertId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
};

/** unique or primary key constraints on table "shared.alert_acknowledgment" */
export enum AlertAcknowledgment_Constraint {
  /** unique or primary key constraint on columns "identity_id", "parent_id", "alert_id" */
  AlertAcknowledgmentParentIdIdentityIdAlertIdKey = 'alert_acknowledgment_parent_id_identity_id_alert_id_key',
  /** unique or primary key constraint on columns "id" */
  AlertAcknowledgmentPkey = 'alert_acknowledgment_pkey'
}

/** input type for inserting data into table "shared.alert_acknowledgment" */
export type AlertAcknowledgment_Insert_Input = {
  alert?: InputMaybe<Alert_Obj_Rel_Insert_Input>;
  /** The alert accepted. Acceptance is per alert, so an alert added later gates a user who has already worked the entity. */
  alertId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  /** The Ory identity that accepted. No FK into the Ory-managed schema. Acceptance is per identity: a colleague opening the same entity is gated independently. */
  identityId?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  /** The entity the alert was accepted on — a claims.policy_claim id in v1, deliberately generic so other consumers (contracts, accounts) need no schema change. No FK (polymorphic), same pattern as shared.participant.parent_id. */
  parentId?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AlertAcknowledgment_Max_Fields = {
  __typename?: 'alertAcknowledgment_max_fields';
  /** The alert accepted. Acceptance is per alert, so an alert added later gates a user who has already worked the entity. */
  alertId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Ory identity that accepted. No FK into the Ory-managed schema. Acceptance is per identity: a colleague opening the same entity is gated independently. */
  identityId?: Maybe<Scalars['uuid']>;
  /** The entity the alert was accepted on — a claims.policy_claim id in v1, deliberately generic so other consumers (contracts, accounts) need no schema change. No FK (polymorphic), same pattern as shared.participant.parent_id. */
  parentId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "shared.alert_acknowledgment" */
export type AlertAcknowledgment_Max_Order_By = {
  /** The alert accepted. Acceptance is per alert, so an alert added later gates a user who has already worked the entity. */
  alertId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The Ory identity that accepted. No FK into the Ory-managed schema. Acceptance is per identity: a colleague opening the same entity is gated independently. */
  identityId?: InputMaybe<Order_By>;
  /** The entity the alert was accepted on — a claims.policy_claim id in v1, deliberately generic so other consumers (contracts, accounts) need no schema change. No FK (polymorphic), same pattern as shared.participant.parent_id. */
  parentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AlertAcknowledgment_Min_Fields = {
  __typename?: 'alertAcknowledgment_min_fields';
  /** The alert accepted. Acceptance is per alert, so an alert added later gates a user who has already worked the entity. */
  alertId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Ory identity that accepted. No FK into the Ory-managed schema. Acceptance is per identity: a colleague opening the same entity is gated independently. */
  identityId?: Maybe<Scalars['uuid']>;
  /** The entity the alert was accepted on — a claims.policy_claim id in v1, deliberately generic so other consumers (contracts, accounts) need no schema change. No FK (polymorphic), same pattern as shared.participant.parent_id. */
  parentId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "shared.alert_acknowledgment" */
export type AlertAcknowledgment_Min_Order_By = {
  /** The alert accepted. Acceptance is per alert, so an alert added later gates a user who has already worked the entity. */
  alertId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The Ory identity that accepted. No FK into the Ory-managed schema. Acceptance is per identity: a colleague opening the same entity is gated independently. */
  identityId?: InputMaybe<Order_By>;
  /** The entity the alert was accepted on — a claims.policy_claim id in v1, deliberately generic so other consumers (contracts, accounts) need no schema change. No FK (polymorphic), same pattern as shared.participant.parent_id. */
  parentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.alert_acknowledgment" */
export type AlertAcknowledgment_Mutation_Response = {
  __typename?: 'alertAcknowledgment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AlertAcknowledgment>;
};

/** on_conflict condition type for table "shared.alert_acknowledgment" */
export type AlertAcknowledgment_On_Conflict = {
  constraint: AlertAcknowledgment_Constraint;
  update_columns?: Array<AlertAcknowledgment_Update_Column>;
  where?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.alert_acknowledgment". */
export type AlertAcknowledgment_Order_By = {
  alert?: InputMaybe<Alert_Order_By>;
  alertId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityId?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  parentId?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
};

/** primary key columns input for table: shared.alert_acknowledgment */
export type AlertAcknowledgment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.alert_acknowledgment" */
export enum AlertAcknowledgment_Select_Column {
  /** column name */
  AlertId = 'alertId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  ParentId = 'parentId'
}

/** input type for updating data in table "shared.alert_acknowledgment" */
export type AlertAcknowledgment_Set_Input = {
  /** The alert accepted. Acceptance is per alert, so an alert added later gates a user who has already worked the entity. */
  alertId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The Ory identity that accepted. No FK into the Ory-managed schema. Acceptance is per identity: a colleague opening the same entity is gated independently. */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** The entity the alert was accepted on — a claims.policy_claim id in v1, deliberately generic so other consumers (contracts, accounts) need no schema change. No FK (polymorphic), same pattern as shared.participant.parent_id. */
  parentId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "alertAcknowledgment" */
export type AlertAcknowledgment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AlertAcknowledgment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AlertAcknowledgment_Stream_Cursor_Value_Input = {
  /** The alert accepted. Acceptance is per alert, so an alert added later gates a user who has already worked the entity. */
  alertId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The Ory identity that accepted. No FK into the Ory-managed schema. Acceptance is per identity: a colleague opening the same entity is gated independently. */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** The entity the alert was accepted on — a claims.policy_claim id in v1, deliberately generic so other consumers (contracts, accounts) need no schema change. No FK (polymorphic), same pattern as shared.participant.parent_id. */
  parentId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "shared.alert_acknowledgment" */
export enum AlertAcknowledgment_Update_Column {
  /** column name */
  AlertId = 'alertId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  ParentId = 'parentId'
}

export type AlertAcknowledgment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AlertAcknowledgment_Set_Input>;
  /** filter the rows which have to be updated */
  where: AlertAcknowledgment_Bool_Exp;
};

/** aggregated selection of "shared.alert" */
export type Alert_Aggregate = {
  __typename?: 'alert_aggregate';
  aggregate?: Maybe<Alert_Aggregate_Fields>;
  nodes: Array<Alert>;
};

/** aggregate fields of "shared.alert" */
export type Alert_Aggregate_Fields = {
  __typename?: 'alert_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Alert_Max_Fields>;
  min?: Maybe<Alert_Min_Fields>;
};


/** aggregate fields of "shared.alert" */
export type Alert_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Alert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "shared.alert". All fields are combined with a logical 'AND'. */
export type Alert_Bool_Exp = {
  _and?: InputMaybe<Array<Alert_Bool_Exp>>;
  _not?: InputMaybe<Alert_Bool_Exp>;
  _or?: InputMaybe<Array<Alert_Bool_Exp>>;
  alertAcknowledgments?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
  alertAcknowledgments_aggregate?: InputMaybe<AlertAcknowledgment_Aggregate_Bool_Exp>;
  alertType?: InputMaybe<Type_Bool_Exp>;
  alertTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  application?: InputMaybe<Application_Bool_Exp>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  applicationRoutes?: InputMaybe<Route_Bool_Exp>;
  applicationRoutes_aggregate?: InputMaybe<Route_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.alert" */
export enum Alert_Constraint {
  /** unique or primary key constraint on columns "id" */
  AlertPkey = 'alert_pkey'
}

/** input type for inserting data into table "shared.alert" */
export type Alert_Insert_Input = {
  alertAcknowledgments?: InputMaybe<AlertAcknowledgment_Arr_Rel_Insert_Input>;
  alertType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** Severity, from the AlertSeverity group in shared.type (Critical, Warning). Presentational only — it groups and orders the panel and never changes whether an alert matches. Consumers render whatever members exist, ordered by shared.type.enum_value. */
  alertTypeId?: InputMaybe<Scalars['uuid']>;
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  /** The single application this alert is DISPLAYED in (Claims, Operations, …). Distinct from eligibility_rule.application_id, which controls which admin screen may edit a rule — display reach is never inferred from rule ownership. */
  applicationId?: InputMaybe<Scalars['uuid']>;
  applicationRoutes?: InputMaybe<Route_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** First date the alert can match. Evaluation compares this window against the caller's effective date, so alerts can be introduced on a schedule without a deploy. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  /** Last date the alert can match; NULL means it never expires. Retiring an alert means setting this, not deleting the row — acknowledgments reference it. */
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  /** The text shown to the user. Static: no templating or placeholder interpolation in v1. */
  message?: InputMaybe<Scalars['String']>;
  /** Administrative label, shown only in the alerts admin screens so staff can find and reuse an alert. Never shown to the adjuster — the adjuster sees message. */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Alert_Max_Fields = {
  __typename?: 'alert_max_fields';
  /** Severity, from the AlertSeverity group in shared.type (Critical, Warning). Presentational only — it groups and orders the panel and never changes whether an alert matches. Consumers render whatever members exist, ordered by shared.type.enum_value. */
  alertTypeId?: Maybe<Scalars['uuid']>;
  /** The single application this alert is DISPLAYED in (Claims, Operations, …). Distinct from eligibility_rule.application_id, which controls which admin screen may edit a rule — display reach is never inferred from rule ownership. */
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** First date the alert can match. Evaluation compares this window against the caller's effective date, so alerts can be introduced on a schedule without a deploy. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** Last date the alert can match; NULL means it never expires. Retiring an alert means setting this, not deleting the row — acknowledgments reference it. */
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** The text shown to the user. Static: no templating or placeholder interpolation in v1. */
  message?: Maybe<Scalars['String']>;
  /** Administrative label, shown only in the alerts admin screens so staff can find and reuse an alert. Never shown to the adjuster — the adjuster sees message. */
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Alert_Min_Fields = {
  __typename?: 'alert_min_fields';
  /** Severity, from the AlertSeverity group in shared.type (Critical, Warning). Presentational only — it groups and orders the panel and never changes whether an alert matches. Consumers render whatever members exist, ordered by shared.type.enum_value. */
  alertTypeId?: Maybe<Scalars['uuid']>;
  /** The single application this alert is DISPLAYED in (Claims, Operations, …). Distinct from eligibility_rule.application_id, which controls which admin screen may edit a rule — display reach is never inferred from rule ownership. */
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** First date the alert can match. Evaluation compares this window against the caller's effective date, so alerts can be introduced on a schedule without a deploy. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** Last date the alert can match; NULL means it never expires. Retiring an alert means setting this, not deleting the row — acknowledgments reference it. */
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** The text shown to the user. Static: no templating or placeholder interpolation in v1. */
  message?: Maybe<Scalars['String']>;
  /** Administrative label, shown only in the alerts admin screens so staff can find and reuse an alert. Never shown to the adjuster — the adjuster sees message. */
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shared.alert" */
export type Alert_Mutation_Response = {
  __typename?: 'alert_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Alert>;
};

/** input type for inserting object relation for remote table "shared.alert" */
export type Alert_Obj_Rel_Insert_Input = {
  data: Alert_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Alert_On_Conflict>;
};

/** on_conflict condition type for table "shared.alert" */
export type Alert_On_Conflict = {
  constraint: Alert_Constraint;
  update_columns?: Array<Alert_Update_Column>;
  where?: InputMaybe<Alert_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.alert". */
export type Alert_Order_By = {
  alertAcknowledgments_aggregate?: InputMaybe<AlertAcknowledgment_Aggregate_Order_By>;
  alertType?: InputMaybe<Type_Order_By>;
  alertTypeId?: InputMaybe<Order_By>;
  application?: InputMaybe<Application_Order_By>;
  applicationId?: InputMaybe<Order_By>;
  applicationRoutes_aggregate?: InputMaybe<Route_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.alert */
export type Alert_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.alert" */
export enum Alert_Select_Column {
  /** column name */
  AlertTypeId = 'alertTypeId',
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.alert" */
export type Alert_Set_Input = {
  /** Severity, from the AlertSeverity group in shared.type (Critical, Warning). Presentational only — it groups and orders the panel and never changes whether an alert matches. Consumers render whatever members exist, ordered by shared.type.enum_value. */
  alertTypeId?: InputMaybe<Scalars['uuid']>;
  /** The single application this alert is DISPLAYED in (Claims, Operations, …). Distinct from eligibility_rule.application_id, which controls which admin screen may edit a rule — display reach is never inferred from rule ownership. */
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** First date the alert can match. Evaluation compares this window against the caller's effective date, so alerts can be introduced on a schedule without a deploy. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** Last date the alert can match; NULL means it never expires. Retiring an alert means setting this, not deleting the row — acknowledgments reference it. */
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The text shown to the user. Static: no templating or placeholder interpolation in v1. */
  message?: InputMaybe<Scalars['String']>;
  /** Administrative label, shown only in the alerts admin screens so staff can find and reuse an alert. Never shown to the adjuster — the adjuster sees message. */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "alert" */
export type Alert_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Alert_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Alert_Stream_Cursor_Value_Input = {
  /** Severity, from the AlertSeverity group in shared.type (Critical, Warning). Presentational only — it groups and orders the panel and never changes whether an alert matches. Consumers render whatever members exist, ordered by shared.type.enum_value. */
  alertTypeId?: InputMaybe<Scalars['uuid']>;
  /** The single application this alert is DISPLAYED in (Claims, Operations, …). Distinct from eligibility_rule.application_id, which controls which admin screen may edit a rule — display reach is never inferred from rule ownership. */
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** First date the alert can match. Evaluation compares this window against the caller's effective date, so alerts can be introduced on a schedule without a deploy. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** Last date the alert can match; NULL means it never expires. Retiring an alert means setting this, not deleting the row — acknowledgments reference it. */
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The text shown to the user. Static: no templating or placeholder interpolation in v1. */
  message?: InputMaybe<Scalars['String']>;
  /** Administrative label, shown only in the alerts admin screens so staff can find and reuse an alert. Never shown to the adjuster — the adjuster sees message. */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.alert" */
export enum Alert_Update_Column {
  /** column name */
  AlertTypeId = 'alertTypeId',
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Alert_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Alert_Set_Input>;
  /** filter the rows which have to be updated */
  where: Alert_Bool_Exp;
};

/** columns and relationships of "auth.application" */
export type Application = {
  __typename?: 'application';
  createdAt: Scalars['timestamptz'];
  display?: Maybe<Scalars['String']>;
  /** An array relationship */
  eligibilityRules: Array<EligibilityRule>;
  /** An aggregate relationship */
  eligibilityRules_aggregate: EligibilityRule_Aggregate;
  /** An array relationship */
  entityFeatures: Array<EntityFeature>;
  /** An aggregate relationship */
  entityFeatures_aggregate: EntityFeature_Aggregate;
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  routes: Array<Route>;
  /** An aggregate relationship */
  routes_aggregate: Route_Aggregate;
  subdomain: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "auth.application" */
export type ApplicationEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRule_Order_By>>;
  where?: InputMaybe<EligibilityRule_Bool_Exp>;
};


/** columns and relationships of "auth.application" */
export type ApplicationEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRule_Order_By>>;
  where?: InputMaybe<EligibilityRule_Bool_Exp>;
};


/** columns and relationships of "auth.application" */
export type ApplicationEntityFeaturesArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


/** columns and relationships of "auth.application" */
export type ApplicationEntityFeatures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


/** columns and relationships of "auth.application" */
export type ApplicationRoutesArgs = {
  distinct_on?: InputMaybe<Array<Route_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Route_Order_By>>;
  where?: InputMaybe<Route_Bool_Exp>;
};


/** columns and relationships of "auth.application" */
export type ApplicationRoutes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Route_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Route_Order_By>>;
  where?: InputMaybe<Route_Bool_Exp>;
};

/**
 * Per-user settings that apply across every screen of one application, such as which
 * other records' Notes a claim page shows. One row per identity and application.
 * Absence of a row, or of a key in it, means the application's code default.
 */
export type ApplicationPreference = {
  __typename?: 'applicationPreference';
  /** An object relationship */
  application: Application;
  /**
   * The application these settings apply in: auth.application.id. A setting here holds on
   * every screen of that application, so a choice made on one claim type applies to all.
   */
  applicationId: Scalars['uuid'];
  /** When this identity first saved a preference for this application. */
  createdAt: Scalars['timestamptz'];
  /** Primary key. */
  id: Scalars['uuid'];
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId: Scalars['uuid'];
  /**
   * A JSON object of named settings, each validated by the form action that saves it and
   * merged in without disturbing the others. Claims: { noteSources: { relatedClaims,
   * contract } }, the notes side menu's Related Claims and Contract options.
   */
  preference: Scalars['jsonb'];
  /** Maintained by the set_users_application_preference_updated_at trigger. */
  updatedAt: Scalars['timestamptz'];
};


/**
 * Per-user settings that apply across every screen of one application, such as which
 * other records' Notes a claim page shows. One row per identity and application.
 * Absence of a row, or of a key in it, means the application's code default.
 */
export type ApplicationPreferencePreferenceArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "users.application_preference" */
export type ApplicationPreference_Aggregate = {
  __typename?: 'applicationPreference_aggregate';
  aggregate?: Maybe<ApplicationPreference_Aggregate_Fields>;
  nodes: Array<ApplicationPreference>;
};

/** aggregate fields of "users.application_preference" */
export type ApplicationPreference_Aggregate_Fields = {
  __typename?: 'applicationPreference_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ApplicationPreference_Max_Fields>;
  min?: Maybe<ApplicationPreference_Min_Fields>;
};


/** aggregate fields of "users.application_preference" */
export type ApplicationPreference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ApplicationPreference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ApplicationPreference_Append_Input = {
  /**
   * A JSON object of named settings, each validated by the form action that saves it and
   * merged in without disturbing the others. Claims: { noteSources: { relatedClaims,
   * contract } }, the notes side menu's Related Claims and Contract options.
   */
  preference?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "users.application_preference". All fields are combined with a logical 'AND'. */
export type ApplicationPreference_Bool_Exp = {
  _and?: InputMaybe<Array<ApplicationPreference_Bool_Exp>>;
  _not?: InputMaybe<ApplicationPreference_Bool_Exp>;
  _or?: InputMaybe<Array<ApplicationPreference_Bool_Exp>>;
  application?: InputMaybe<Application_Bool_Exp>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  preference?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "users.application_preference" */
export enum ApplicationPreference_Constraint {
  /** unique or primary key constraint on columns "identity_id", "application_id" */
  ApplicationPreferenceIdentityIdApplicationIdKey = 'application_preference_identity_id_application_id_key',
  /** unique or primary key constraint on columns "id" */
  ApplicationPreferencePkey = 'application_preference_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ApplicationPreference_Delete_At_Path_Input = {
  /**
   * A JSON object of named settings, each validated by the form action that saves it and
   * merged in without disturbing the others. Claims: { noteSources: { relatedClaims,
   * contract } }, the notes side menu's Related Claims and Contract options.
   */
  preference?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ApplicationPreference_Delete_Elem_Input = {
  /**
   * A JSON object of named settings, each validated by the form action that saves it and
   * merged in without disturbing the others. Claims: { noteSources: { relatedClaims,
   * contract } }, the notes side menu's Related Claims and Contract options.
   */
  preference?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ApplicationPreference_Delete_Key_Input = {
  /**
   * A JSON object of named settings, each validated by the form action that saves it and
   * merged in without disturbing the others. Claims: { noteSources: { relatedClaims,
   * contract } }, the notes side menu's Related Claims and Contract options.
   */
  preference?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "users.application_preference" */
export type ApplicationPreference_Insert_Input = {
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  /**
   * The application these settings apply in: auth.application.id. A setting here holds on
   * every screen of that application, so a choice made on one claim type applies to all.
   */
  applicationId?: InputMaybe<Scalars['uuid']>;
  /** When this identity first saved a preference for this application. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /**
   * A JSON object of named settings, each validated by the form action that saves it and
   * merged in without disturbing the others. Claims: { noteSources: { relatedClaims,
   * contract } }, the notes side menu's Related Claims and Contract options.
   */
  preference?: InputMaybe<Scalars['jsonb']>;
  /** Maintained by the set_users_application_preference_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ApplicationPreference_Max_Fields = {
  __typename?: 'applicationPreference_max_fields';
  /**
   * The application these settings apply in: auth.application.id. A setting here holds on
   * every screen of that application, so a choice made on one claim type applies to all.
   */
  applicationId?: Maybe<Scalars['uuid']>;
  /** When this identity first saved a preference for this application. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId?: Maybe<Scalars['uuid']>;
  /** Maintained by the set_users_application_preference_updated_at trigger. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ApplicationPreference_Min_Fields = {
  __typename?: 'applicationPreference_min_fields';
  /**
   * The application these settings apply in: auth.application.id. A setting here holds on
   * every screen of that application, so a choice made on one claim type applies to all.
   */
  applicationId?: Maybe<Scalars['uuid']>;
  /** When this identity first saved a preference for this application. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId?: Maybe<Scalars['uuid']>;
  /** Maintained by the set_users_application_preference_updated_at trigger. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "users.application_preference" */
export type ApplicationPreference_Mutation_Response = {
  __typename?: 'applicationPreference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApplicationPreference>;
};

/** on_conflict condition type for table "users.application_preference" */
export type ApplicationPreference_On_Conflict = {
  constraint: ApplicationPreference_Constraint;
  update_columns?: Array<ApplicationPreference_Update_Column>;
  where?: InputMaybe<ApplicationPreference_Bool_Exp>;
};

/** Ordering options when selecting data from "users.application_preference". */
export type ApplicationPreference_Order_By = {
  application?: InputMaybe<Application_Order_By>;
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  preference?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users.application_preference */
export type ApplicationPreference_Pk_Columns_Input = {
  /** Primary key. */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ApplicationPreference_Prepend_Input = {
  /**
   * A JSON object of named settings, each validated by the form action that saves it and
   * merged in without disturbing the others. Claims: { noteSources: { relatedClaims,
   * contract } }, the notes side menu's Related Claims and Contract options.
   */
  preference?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users.application_preference" */
export enum ApplicationPreference_Select_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  Preference = 'preference',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "users.application_preference" */
export type ApplicationPreference_Set_Input = {
  /**
   * The application these settings apply in: auth.application.id. A setting here holds on
   * every screen of that application, so a choice made on one claim type applies to all.
   */
  applicationId?: InputMaybe<Scalars['uuid']>;
  /** When this identity first saved a preference for this application. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /**
   * A JSON object of named settings, each validated by the form action that saves it and
   * merged in without disturbing the others. Claims: { noteSources: { relatedClaims,
   * contract } }, the notes side menu's Related Claims and Contract options.
   */
  preference?: InputMaybe<Scalars['jsonb']>;
  /** Maintained by the set_users_application_preference_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "applicationPreference" */
export type ApplicationPreference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ApplicationPreference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationPreference_Stream_Cursor_Value_Input = {
  /**
   * The application these settings apply in: auth.application.id. A setting here holds on
   * every screen of that application, so a choice made on one claim type applies to all.
   */
  applicationId?: InputMaybe<Scalars['uuid']>;
  /** When this identity first saved a preference for this application. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /**
   * A JSON object of named settings, each validated by the form action that saves it and
   * merged in without disturbing the others. Claims: { noteSources: { relatedClaims,
   * contract } }, the notes side menu's Related Claims and Contract options.
   */
  preference?: InputMaybe<Scalars['jsonb']>;
  /** Maintained by the set_users_application_preference_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "users.application_preference" */
export enum ApplicationPreference_Update_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  Preference = 'preference',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ApplicationPreference_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ApplicationPreference_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ApplicationPreference_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ApplicationPreference_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ApplicationPreference_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ApplicationPreference_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApplicationPreference_Set_Input>;
  /** filter the rows which have to be updated */
  where: ApplicationPreference_Bool_Exp;
};

/** aggregated selection of "auth.application" */
export type Application_Aggregate = {
  __typename?: 'application_aggregate';
  aggregate?: Maybe<Application_Aggregate_Fields>;
  nodes: Array<Application>;
};

/** aggregate fields of "auth.application" */
export type Application_Aggregate_Fields = {
  __typename?: 'application_aggregate_fields';
  avg?: Maybe<Application_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Application_Max_Fields>;
  min?: Maybe<Application_Min_Fields>;
  stddev?: Maybe<Application_Stddev_Fields>;
  stddev_pop?: Maybe<Application_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Application_Stddev_Samp_Fields>;
  sum?: Maybe<Application_Sum_Fields>;
  var_pop?: Maybe<Application_Var_Pop_Fields>;
  var_samp?: Maybe<Application_Var_Samp_Fields>;
  variance?: Maybe<Application_Variance_Fields>;
};


/** aggregate fields of "auth.application" */
export type Application_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Application_Avg_Fields = {
  __typename?: 'application_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "auth.application". All fields are combined with a logical 'AND'. */
export type Application_Bool_Exp = {
  _and?: InputMaybe<Array<Application_Bool_Exp>>;
  _not?: InputMaybe<Application_Bool_Exp>;
  _or?: InputMaybe<Array<Application_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  eligibilityRules?: InputMaybe<EligibilityRule_Bool_Exp>;
  eligibilityRules_aggregate?: InputMaybe<EligibilityRule_Aggregate_Bool_Exp>;
  entityFeatures?: InputMaybe<EntityFeature_Bool_Exp>;
  entityFeatures_aggregate?: InputMaybe<EntityFeature_Aggregate_Bool_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  routes?: InputMaybe<Route_Bool_Exp>;
  routes_aggregate?: InputMaybe<Route_Aggregate_Bool_Exp>;
  subdomain?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.application" */
export enum Application_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationIdKey = 'application_id_key',
  /** unique or primary key constraint on columns "id" */
  ApplicationPkey = 'application_pkey'
}

/** input type for incrementing numeric columns in table "auth.application" */
export type Application_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth.application" */
export type Application_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  eligibilityRules?: InputMaybe<EligibilityRule_Arr_Rel_Insert_Input>;
  entityFeatures?: InputMaybe<EntityFeature_Arr_Rel_Insert_Input>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  routes?: InputMaybe<Route_Arr_Rel_Insert_Input>;
  subdomain?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Application_Max_Fields = {
  __typename?: 'application_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Application_Min_Fields = {
  __typename?: 'application_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "auth.application" */
export type Application_Mutation_Response = {
  __typename?: 'application_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Application>;
};

/** input type for inserting object relation for remote table "auth.application" */
export type Application_Obj_Rel_Insert_Input = {
  data: Application_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_On_Conflict>;
};

/** on_conflict condition type for table "auth.application" */
export type Application_On_Conflict = {
  constraint: Application_Constraint;
  update_columns?: Array<Application_Update_Column>;
  where?: InputMaybe<Application_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.application". */
export type Application_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  eligibilityRules_aggregate?: InputMaybe<EligibilityRule_Aggregate_Order_By>;
  entityFeatures_aggregate?: InputMaybe<EntityFeature_Aggregate_Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  routes_aggregate?: InputMaybe<Route_Aggregate_Order_By>;
  subdomain?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.application */
export type Application_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.application" */
export enum Application_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Subdomain = 'subdomain',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.application" */
export type Application_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Application_Stddev_Fields = {
  __typename?: 'application_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Application_Stddev_Pop_Fields = {
  __typename?: 'application_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Application_Stddev_Samp_Fields = {
  __typename?: 'application_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "application" */
export type Application_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Application_Sum_Fields = {
  __typename?: 'application_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "auth.application" */
export enum Application_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Subdomain = 'subdomain',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Application_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Application_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Application_Set_Input>;
  /** filter the rows which have to be updated */
  where: Application_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Application_Var_Pop_Fields = {
  __typename?: 'application_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Application_Var_Samp_Fields = {
  __typename?: 'application_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Application_Variance_Fields = {
  __typename?: 'application_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** A grant by an Approver raising one identity's authority, on one entity, to a stated cap. Persists rather than being consumed, so the same identity may re-attempt the action; stops applying once the Action Value exceeds the cap, or under Always once the subject's material fields change. Because it references an entity rather than a blocked attempt it may be granted before the condition is ever met — pre-approval needs no separate concept. IT-6672. */
export type Approval = {
  __typename?: 'approval';
  /** An object relationship */
  approver?: Maybe<Identity>;
  /** The Approver who granted this (logical ref to ory.identity). With granted_authority this is the audit record: who authorized what, and up to how much. */
  approverIdentityId: Scalars['uuid'];
  /** An object relationship */
  capability: Capability;
  /** The Capability this Approval authorizes. */
  capabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** The Gate this Approval was granted against, set by validate_grant from the subject rather than trusted from the caller. Null applies to the Capability as a whole, which is what an Approval granted before this column existed means. IT-6672. */
  gateId?: Maybe<Scalars['uuid']>;
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  /** An object relationship */
  identity?: Maybe<Identity>;
  /** The acting identity whose authority is raised (logical ref to ory.identity). An Approval on one entity grants nothing on any other — this is what distinguishes it from a Validation Override. */
  identityId: Scalars['uuid'];
  /** Under Always: hash of the subject's material fields when granted. A mismatch means the entity changed after approval and the Approval no longer applies. Set by the validating trigger, never trusted from the caller. */
  materialHash?: Maybe<Scalars['String']>;
  /** When this Approval was withdrawn; NULL means it still stands. Revoking never deletes — the record of the original decision is kept. */
  revokedAt?: Maybe<Scalars['timestamptz']>;
  /** The entity this Approval applies to, as returned by the gate's subject resolver. Deliberately untyped: subjects live in different tables per Capability. */
  subjectId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** What one identity may do for one Capability, unaided: how far their own reach extends, and whether they may extend it to someone else. Per identity per Capability — authority on one Capability grants nothing on any other. IT-6672. */
export type ApprovalAuthority = {
  __typename?: 'approvalAuthority';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['numeric']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['numeric']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['numeric']>;
  /** Whether this identity may grant Approvals for this Capability. Independent of the size of their own authority: authority governs their own reach, this governs whether they may extend it to someone else. */
  canApprove: Scalars['Boolean'];
  /** An object relationship */
  capability: Capability;
  /** The Capability this authority applies to. */
  capabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** The Gate this Approval Limit applies to, or null for the Capability as a whole. Resolution is most-specific-first: the row for the Gate that governs the attempt, else the capability-wide row, else nothing — which is 0, not unlimited. IT-6672. */
  gateId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** Logical ref to ory.identity(id) — the person this authority belongs to. Not a foreign key: ory is Kratos-owned. */
  identityId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "approvals.authority" */
export type ApprovalAuthority_Aggregate = {
  __typename?: 'approvalAuthority_aggregate';
  aggregate?: Maybe<ApprovalAuthority_Aggregate_Fields>;
  nodes: Array<ApprovalAuthority>;
};

export type ApprovalAuthority_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ApprovalAuthority_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ApprovalAuthority_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ApprovalAuthority_Aggregate_Bool_Exp_Count>;
};

export type ApprovalAuthority_Aggregate_Bool_Exp_Bool_And = {
  arguments: ApprovalAuthority_Select_Column_ApprovalAuthority_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApprovalAuthority_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ApprovalAuthority_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ApprovalAuthority_Select_Column_ApprovalAuthority_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApprovalAuthority_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ApprovalAuthority_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ApprovalAuthority_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApprovalAuthority_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "approvals.authority" */
export type ApprovalAuthority_Aggregate_Fields = {
  __typename?: 'approvalAuthority_aggregate_fields';
  avg?: Maybe<ApprovalAuthority_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ApprovalAuthority_Max_Fields>;
  min?: Maybe<ApprovalAuthority_Min_Fields>;
  stddev?: Maybe<ApprovalAuthority_Stddev_Fields>;
  stddev_pop?: Maybe<ApprovalAuthority_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ApprovalAuthority_Stddev_Samp_Fields>;
  sum?: Maybe<ApprovalAuthority_Sum_Fields>;
  var_pop?: Maybe<ApprovalAuthority_Var_Pop_Fields>;
  var_samp?: Maybe<ApprovalAuthority_Var_Samp_Fields>;
  variance?: Maybe<ApprovalAuthority_Variance_Fields>;
};


/** aggregate fields of "approvals.authority" */
export type ApprovalAuthority_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ApprovalAuthority_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "approvals.authority" */
export type ApprovalAuthority_Aggregate_Order_By = {
  avg?: InputMaybe<ApprovalAuthority_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ApprovalAuthority_Max_Order_By>;
  min?: InputMaybe<ApprovalAuthority_Min_Order_By>;
  stddev?: InputMaybe<ApprovalAuthority_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ApprovalAuthority_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ApprovalAuthority_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ApprovalAuthority_Sum_Order_By>;
  var_pop?: InputMaybe<ApprovalAuthority_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ApprovalAuthority_Var_Samp_Order_By>;
  variance?: InputMaybe<ApprovalAuthority_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "approvals.authority" */
export type ApprovalAuthority_Arr_Rel_Insert_Input = {
  data: Array<ApprovalAuthority_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ApprovalAuthority_On_Conflict>;
};

/** aggregate avg on columns */
export type ApprovalAuthority_Avg_Fields = {
  __typename?: 'approvalAuthority_avg_fields';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "approvals.authority" */
export type ApprovalAuthority_Avg_Order_By = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Order_By>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Order_By>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "approvals.authority". All fields are combined with a logical 'AND'. */
export type ApprovalAuthority_Bool_Exp = {
  _and?: InputMaybe<Array<ApprovalAuthority_Bool_Exp>>;
  _not?: InputMaybe<ApprovalAuthority_Bool_Exp>;
  _or?: InputMaybe<Array<ApprovalAuthority_Bool_Exp>>;
  authority?: InputMaybe<Numeric_Comparison_Exp>;
  authorityMax?: InputMaybe<Numeric_Comparison_Exp>;
  authorityMin?: InputMaybe<Numeric_Comparison_Exp>;
  canApprove?: InputMaybe<Boolean_Comparison_Exp>;
  capability?: InputMaybe<Capability_Bool_Exp>;
  capabilityId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  gateId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "approvals.authority" */
export enum ApprovalAuthority_Constraint {
  /** unique or primary key constraint on columns "identity_id", "gate_id", "capability_id" */
  AuthorityIdentityCapabilityGateKey = 'authority_identity_capability_gate_key',
  /** unique or primary key constraint on columns "id" */
  AuthorityPkey = 'authority_pkey'
}

/** input type for incrementing numeric columns in table "approvals.authority" */
export type ApprovalAuthority_Inc_Input = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Scalars['numeric']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Scalars['numeric']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "approvals.authority" */
export type ApprovalAuthority_Insert_Input = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Scalars['numeric']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Scalars['numeric']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Scalars['numeric']>;
  /** Whether this identity may grant Approvals for this Capability. Independent of the size of their own authority: authority governs their own reach, this governs whether they may extend it to someone else. */
  canApprove?: InputMaybe<Scalars['Boolean']>;
  capability?: InputMaybe<Capability_Obj_Rel_Insert_Input>;
  /** The Capability this authority applies to. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Gate this Approval Limit applies to, or null for the Capability as a whole. Resolution is most-specific-first: the row for the Gate that governs the attempt, else the capability-wide row, else nothing — which is 0, not unlimited. IT-6672. */
  gateId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Logical ref to ory.identity(id) — the person this authority belongs to. Not a foreign key: ory is Kratos-owned. */
  identityId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ApprovalAuthority_Max_Fields = {
  __typename?: 'approvalAuthority_max_fields';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['numeric']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['numeric']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['numeric']>;
  /** The Capability this authority applies to. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The Gate this Approval Limit applies to, or null for the Capability as a whole. Resolution is most-specific-first: the row for the Gate that governs the attempt, else the capability-wide row, else nothing — which is 0, not unlimited. IT-6672. */
  gateId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Logical ref to ory.identity(id) — the person this authority belongs to. Not a foreign key: ory is Kratos-owned. */
  identityId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "approvals.authority" */
export type ApprovalAuthority_Max_Order_By = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Order_By>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Order_By>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Order_By>;
  /** The Capability this authority applies to. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** The Gate this Approval Limit applies to, or null for the Capability as a whole. Resolution is most-specific-first: the row for the Gate that governs the attempt, else the capability-wide row, else nothing — which is 0, not unlimited. IT-6672. */
  gateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Logical ref to ory.identity(id) — the person this authority belongs to. Not a foreign key: ory is Kratos-owned. */
  identityId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ApprovalAuthority_Min_Fields = {
  __typename?: 'approvalAuthority_min_fields';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['numeric']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['numeric']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['numeric']>;
  /** The Capability this authority applies to. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The Gate this Approval Limit applies to, or null for the Capability as a whole. Resolution is most-specific-first: the row for the Gate that governs the attempt, else the capability-wide row, else nothing — which is 0, not unlimited. IT-6672. */
  gateId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Logical ref to ory.identity(id) — the person this authority belongs to. Not a foreign key: ory is Kratos-owned. */
  identityId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "approvals.authority" */
export type ApprovalAuthority_Min_Order_By = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Order_By>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Order_By>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Order_By>;
  /** The Capability this authority applies to. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** The Gate this Approval Limit applies to, or null for the Capability as a whole. Resolution is most-specific-first: the row for the Gate that governs the attempt, else the capability-wide row, else nothing — which is 0, not unlimited. IT-6672. */
  gateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Logical ref to ory.identity(id) — the person this authority belongs to. Not a foreign key: ory is Kratos-owned. */
  identityId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "approvals.authority" */
export type ApprovalAuthority_Mutation_Response = {
  __typename?: 'approvalAuthority_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApprovalAuthority>;
};

/** on_conflict condition type for table "approvals.authority" */
export type ApprovalAuthority_On_Conflict = {
  constraint: ApprovalAuthority_Constraint;
  update_columns?: Array<ApprovalAuthority_Update_Column>;
  where?: InputMaybe<ApprovalAuthority_Bool_Exp>;
};

/** Ordering options when selecting data from "approvals.authority". */
export type ApprovalAuthority_Order_By = {
  authority?: InputMaybe<Order_By>;
  authorityMax?: InputMaybe<Order_By>;
  authorityMin?: InputMaybe<Order_By>;
  canApprove?: InputMaybe<Order_By>;
  capability?: InputMaybe<Capability_Order_By>;
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  gateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: approvals.authority */
export type ApprovalAuthority_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "approvals.authority" */
export enum ApprovalAuthority_Select_Column {
  /** column name */
  Authority = 'authority',
  /** column name */
  AuthorityMax = 'authorityMax',
  /** column name */
  AuthorityMin = 'authorityMin',
  /** column name */
  CanApprove = 'canApprove',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GateId = 'gateId',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "approvalAuthority_aggregate_bool_exp_bool_and_arguments_columns" columns of table "approvals.authority" */
export enum ApprovalAuthority_Select_Column_ApprovalAuthority_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CanApprove = 'canApprove'
}

/** select "approvalAuthority_aggregate_bool_exp_bool_or_arguments_columns" columns of table "approvals.authority" */
export enum ApprovalAuthority_Select_Column_ApprovalAuthority_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CanApprove = 'canApprove'
}

/** input type for updating data in table "approvals.authority" */
export type ApprovalAuthority_Set_Input = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Scalars['numeric']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Scalars['numeric']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Scalars['numeric']>;
  /** Whether this identity may grant Approvals for this Capability. Independent of the size of their own authority: authority governs their own reach, this governs whether they may extend it to someone else. */
  canApprove?: InputMaybe<Scalars['Boolean']>;
  /** The Capability this authority applies to. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Gate this Approval Limit applies to, or null for the Capability as a whole. Resolution is most-specific-first: the row for the Gate that governs the attempt, else the capability-wide row, else nothing — which is 0, not unlimited. IT-6672. */
  gateId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Logical ref to ory.identity(id) — the person this authority belongs to. Not a foreign key: ory is Kratos-owned. */
  identityId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ApprovalAuthority_Stddev_Fields = {
  __typename?: 'approvalAuthority_stddev_fields';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "approvals.authority" */
export type ApprovalAuthority_Stddev_Order_By = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Order_By>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Order_By>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ApprovalAuthority_Stddev_Pop_Fields = {
  __typename?: 'approvalAuthority_stddev_pop_fields';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "approvals.authority" */
export type ApprovalAuthority_Stddev_Pop_Order_By = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Order_By>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Order_By>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ApprovalAuthority_Stddev_Samp_Fields = {
  __typename?: 'approvalAuthority_stddev_samp_fields';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "approvals.authority" */
export type ApprovalAuthority_Stddev_Samp_Order_By = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Order_By>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Order_By>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "approvalAuthority" */
export type ApprovalAuthority_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ApprovalAuthority_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ApprovalAuthority_Stream_Cursor_Value_Input = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Scalars['numeric']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Scalars['numeric']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Scalars['numeric']>;
  /** Whether this identity may grant Approvals for this Capability. Independent of the size of their own authority: authority governs their own reach, this governs whether they may extend it to someone else. */
  canApprove?: InputMaybe<Scalars['Boolean']>;
  /** The Capability this authority applies to. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Gate this Approval Limit applies to, or null for the Capability as a whole. Resolution is most-specific-first: the row for the Gate that governs the attempt, else the capability-wide row, else nothing — which is 0, not unlimited. IT-6672. */
  gateId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Logical ref to ory.identity(id) — the person this authority belongs to. Not a foreign key: ory is Kratos-owned. */
  identityId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ApprovalAuthority_Sum_Fields = {
  __typename?: 'approvalAuthority_sum_fields';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['numeric']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['numeric']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "approvals.authority" */
export type ApprovalAuthority_Sum_Order_By = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Order_By>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Order_By>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Order_By>;
};

/** update columns of table "approvals.authority" */
export enum ApprovalAuthority_Update_Column {
  /** column name */
  Authority = 'authority',
  /** column name */
  AuthorityMax = 'authorityMax',
  /** column name */
  AuthorityMin = 'authorityMin',
  /** column name */
  CanApprove = 'canApprove',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GateId = 'gateId',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ApprovalAuthority_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ApprovalAuthority_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApprovalAuthority_Set_Input>;
  /** filter the rows which have to be updated */
  where: ApprovalAuthority_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ApprovalAuthority_Var_Pop_Fields = {
  __typename?: 'approvalAuthority_var_pop_fields';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "approvals.authority" */
export type ApprovalAuthority_Var_Pop_Order_By = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Order_By>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Order_By>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ApprovalAuthority_Var_Samp_Fields = {
  __typename?: 'approvalAuthority_var_samp_fields';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "approvals.authority" */
export type ApprovalAuthority_Var_Samp_Order_By = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Order_By>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Order_By>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ApprovalAuthority_Variance_Fields = {
  __typename?: 'approvalAuthority_variance_fields';
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "approvals.authority" */
export type ApprovalAuthority_Variance_Order_By = {
  /** The highest Action Value this identity may act on without an Approval. Unit is the Capability's business: dollars under OverLimit, rank under Always. NULL means Unlimited — at least one Unlimited holder is what guarantees any attempt can eventually be authorized. A missing row means 0 (deny by default), not unlimited. */
  authority?: InputMaybe<Order_By>;
  /** Upper bound of a range authority, inclusive. NULL on amount rows. */
  authorityMax?: InputMaybe<Order_By>;
  /** Lower bound of a range authority, for gates whose Action Value is a scope rather than an amount (a claim-number range). One row carries either `authority` or the min/max pair, mirroring the eligibility engine's single_value vs start_number/end_number. NULL on amount rows. */
  authorityMin?: InputMaybe<Order_By>;
};

/** What makes one Capability require approval. Optional and at most one per Capability — a Capability with no gate is a plain permission, which is what most of them are. Registering a row here is what makes a write gated; the framework changes no behaviour until one exists. IT-6672. */
export type ApprovalGate = {
  __typename?: 'approvalGate';
  /** An object relationship */
  approvalTriggerType: Type;
  /** shared.type in the ApprovalTrigger group: OverLimit (approval needed when the Action Value exceeds the actor's authority) or Always (every attempt needs approval, with nothing measured). */
  approvalTriggerTypeId: Scalars['uuid'];
  /** The discriminator value this Gate addresses, compared as text — store an id rather than a name so renaming a Category cannot silently detach a limit. Null makes this the Capability's default Gate, used when no sibling matches; a Capability may have at most one. IT-6672. */
  bindingArgument?: Maybe<Scalars['String']>;
  /** An object relationship */
  capability: Capability;
  /** The Capability this gate applies to. Unique: a Capability is either gated or it is not. */
  capabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** What to call this Gate in a refusal, when its Capability has more than one. Two Gates on Pay mechanical claims would otherwise raise the same sentence and the reader could not tell which limit bit. Falls back to auth.capability.display when null. IT-6672. */
  display?: Maybe<Scalars['String']>;
  /** An array relationship */
  gateBindings: Array<ApprovalGateBinding>;
  /** An aggregate relationship */
  gateBindings_aggregate: ApprovalGateBinding_Aggregate;
  id: Scalars['uuid'];
  /** Column names on the SUBJECT ROW whose change invalidates an existing Approval, hashed into approvals.approval.material_hash. Use when what matters is a handful of the subject's own columns (a time-off request's dates). Mutually exclusive with material_function_*. */
  materialFields?: Maybe<Array<Scalars['String']>>;
  /** Name of a function (subject uuid -> jsonb) returning the facts an Approval was granted against, hashed into approvals.approval.material_hash. Use when those facts are not columns of the subject — a repair bill is its set of claim_detail rows, not a column on claim_service_center. The function chooses what counts: selecting id, quantity and cost per line means a corrected part-number typo does NOT invalidate the approval, while a changed price does. Mutually exclusive with material_fields; declaring neither means only the cap invalidates. */
  materialFunctionName?: Maybe<Scalars['String']>;
  /** Schema of the material function. Mutually exclusive with material_fields. */
  materialFunctionSchema?: Maybe<Scalars['String']>;
  /** What to tell the user when the precondition fails, e.g. "This repair has no valid authorization." Written by whoever configures the gate, because only they know what the predicate means. NULL falls back to a generic sentence. */
  preconditionMessage?: Maybe<Scalars['String']>;
  /** Name of a function (subject uuid -> boolean) that must hold before the write is allowed, over and above authority. Dual control: the payments department may only disburse where the adjuster has issued a Repair Authorization for that Service Provider, so the predicate asks the claims domain whether a valid one exists. It deliberately reads DOMAIN data, not approvals data — an authorization within the adjuster's own limit produces no Approval row at all, so a precondition looking for one would refuse every ordinary payment. Unlike authority this is NOT satisfiable by a large limit: an unlimited holder is still refused. NULL means no precondition. */
  preconditionName?: Maybe<Scalars['String']>;
  /** Schema of the precondition function. */
  preconditionSchema?: Maybe<Scalars['String']>;
  /** Name of a function (subject uuid -> text) returning the value that selects among a Capability's Gates — a Category id for claim payments. Takes the SUBJECT rather than the guarded row so the write path and the advisory read share one implementation. All Gates of a Capability must name the same function; a trigger enforces it. IT-6672. */
  subjectDiscriminatorName?: Maybe<Scalars['String']>;
  /** Schema of the subject discriminator. Null on a Capability with a single Gate. */
  subjectDiscriminatorSchema?: Maybe<Scalars['String']>;
  /** Schema of the table the subject entity lives in. */
  subjectSchema: Scalars['String'];
  /** Table the subject entity lives in — what subject_resolver_name returns an id into. Needed to read material_fields off the subject. */
  subjectTable: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** What makes one Capability require approval. Optional and at most one per Capability — a Capability with no gate is a plain permission, which is what most of them are. Registering a row here is what makes a write gated; the framework changes no behaviour until one exists. IT-6672. */
export type ApprovalGateGateBindingsArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGateBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGateBinding_Order_By>>;
  where?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
};


/** What makes one Capability require approval. Optional and at most one per Capability — a Capability with no gate is a plain permission, which is what most of them are. Registering a row here is what makes a write gated; the framework changes no behaviour until one exists. IT-6672. */
export type ApprovalGateGateBindings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGateBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGateBinding_Order_By>>;
  where?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
};

/** One table's piece of a Gate: which table it guards, which operations, and the row-reading functions (binding predicate, subject resolver, action value reader) for that table. A Gate spans many tables through many bindings; approvals.enforce() joins gate -> binding on the table whose trigger fired. */
export type ApprovalGateBinding = {
  __typename?: 'approvalGateBinding';
  /** Name of a function (guarded row -> numeric) producing the number the attempt is measured by. Its unit is this Capability's business (dollars, days, a claim number). NULL under Always. */
  actionValueName?: Maybe<Scalars['String']>;
  /** Schema of the Action Value function. NULL under Always. */
  actionValueSchema?: Maybe<Scalars['String']>;
  /** Name of a function (guarded row -> boolean) deciding whether a given row is an instance of this Capability. */
  bindingPredicateName?: Maybe<Scalars['String']>;
  /** Schema of the optional predicate narrowing which rows this binding applies to. NULL means every write to the guarded table. */
  bindingPredicateSchema?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  gate: ApprovalGate;
  /** The Gate this binding belongs to. */
  gateId: Scalars['uuid'];
  /** Which operations this binding applies to: INSERT, UPDATE, or DELETE. Without this filter a gate on inserts would also re-gate the follow-up update that completes one — the claims pay flow inserts a payment then updates its status — refusing a write for money already authorized. DELETE is supported: enforce() reads OLD on a delete and returns it to allow. */
  guardedOperations: Array<Scalars['String']>;
  /** Schema of the table whose writes this binding guards. */
  guardedSchema: Scalars['String'];
  /** Table whose writes this binding guards. One table may serve several gates (shared.payment carries claims and remittance payments), which is what binding_predicate_* disambiguates. */
  guardedTable: Scalars['String'];
  id: Scalars['uuid'];
  /** Name of a function (guarded row -> uuid) returning the entity the action is ABOUT, never the row being created. A claim payment inserts into shared.payment but is approved against the Claim — this is what lets creation-shaped actions be gated at all. Every binding of a Gate resolves to the same subject; bindings differ only in how they get there. */
  subjectResolverName: Scalars['String'];
  /** Schema of the subject resolver. */
  subjectResolverSchema: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "approvals.gate_binding" */
export type ApprovalGateBinding_Aggregate = {
  __typename?: 'approvalGateBinding_aggregate';
  aggregate?: Maybe<ApprovalGateBinding_Aggregate_Fields>;
  nodes: Array<ApprovalGateBinding>;
};

export type ApprovalGateBinding_Aggregate_Bool_Exp = {
  count?: InputMaybe<ApprovalGateBinding_Aggregate_Bool_Exp_Count>;
};

export type ApprovalGateBinding_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ApprovalGateBinding_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "approvals.gate_binding" */
export type ApprovalGateBinding_Aggregate_Fields = {
  __typename?: 'approvalGateBinding_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ApprovalGateBinding_Max_Fields>;
  min?: Maybe<ApprovalGateBinding_Min_Fields>;
};


/** aggregate fields of "approvals.gate_binding" */
export type ApprovalGateBinding_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ApprovalGateBinding_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "approvals.gate_binding" */
export type ApprovalGateBinding_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ApprovalGateBinding_Max_Order_By>;
  min?: InputMaybe<ApprovalGateBinding_Min_Order_By>;
};

/** input type for inserting array relation for remote table "approvals.gate_binding" */
export type ApprovalGateBinding_Arr_Rel_Insert_Input = {
  data: Array<ApprovalGateBinding_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ApprovalGateBinding_On_Conflict>;
};

/** Boolean expression to filter rows from the table "approvals.gate_binding". All fields are combined with a logical 'AND'. */
export type ApprovalGateBinding_Bool_Exp = {
  _and?: InputMaybe<Array<ApprovalGateBinding_Bool_Exp>>;
  _not?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
  _or?: InputMaybe<Array<ApprovalGateBinding_Bool_Exp>>;
  actionValueName?: InputMaybe<String_Comparison_Exp>;
  actionValueSchema?: InputMaybe<String_Comparison_Exp>;
  bindingPredicateName?: InputMaybe<String_Comparison_Exp>;
  bindingPredicateSchema?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  gate?: InputMaybe<ApprovalGate_Bool_Exp>;
  gateId?: InputMaybe<Uuid_Comparison_Exp>;
  guardedOperations?: InputMaybe<String_Array_Comparison_Exp>;
  guardedSchema?: InputMaybe<String_Comparison_Exp>;
  guardedTable?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  subjectResolverName?: InputMaybe<String_Comparison_Exp>;
  subjectResolverSchema?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "approvals.gate_binding" */
export enum ApprovalGateBinding_Constraint {
  /** unique or primary key constraint on columns "id" */
  GateBindingPkey = 'gate_binding_pkey'
}

/** input type for inserting data into table "approvals.gate_binding" */
export type ApprovalGateBinding_Insert_Input = {
  /** Name of a function (guarded row -> numeric) producing the number the attempt is measured by. Its unit is this Capability's business (dollars, days, a claim number). NULL under Always. */
  actionValueName?: InputMaybe<Scalars['String']>;
  /** Schema of the Action Value function. NULL under Always. */
  actionValueSchema?: InputMaybe<Scalars['String']>;
  /** Name of a function (guarded row -> boolean) deciding whether a given row is an instance of this Capability. */
  bindingPredicateName?: InputMaybe<Scalars['String']>;
  /** Schema of the optional predicate narrowing which rows this binding applies to. NULL means every write to the guarded table. */
  bindingPredicateSchema?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  gate?: InputMaybe<ApprovalGate_Obj_Rel_Insert_Input>;
  /** The Gate this binding belongs to. */
  gateId?: InputMaybe<Scalars['uuid']>;
  /** Which operations this binding applies to: INSERT, UPDATE, or DELETE. Without this filter a gate on inserts would also re-gate the follow-up update that completes one — the claims pay flow inserts a payment then updates its status — refusing a write for money already authorized. DELETE is supported: enforce() reads OLD on a delete and returns it to allow. */
  guardedOperations?: InputMaybe<Array<Scalars['String']>>;
  /** Schema of the table whose writes this binding guards. */
  guardedSchema?: InputMaybe<Scalars['String']>;
  /** Table whose writes this binding guards. One table may serve several gates (shared.payment carries claims and remittance payments), which is what binding_predicate_* disambiguates. */
  guardedTable?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Name of a function (guarded row -> uuid) returning the entity the action is ABOUT, never the row being created. A claim payment inserts into shared.payment but is approved against the Claim — this is what lets creation-shaped actions be gated at all. Every binding of a Gate resolves to the same subject; bindings differ only in how they get there. */
  subjectResolverName?: InputMaybe<Scalars['String']>;
  /** Schema of the subject resolver. */
  subjectResolverSchema?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ApprovalGateBinding_Max_Fields = {
  __typename?: 'approvalGateBinding_max_fields';
  /** Name of a function (guarded row -> numeric) producing the number the attempt is measured by. Its unit is this Capability's business (dollars, days, a claim number). NULL under Always. */
  actionValueName?: Maybe<Scalars['String']>;
  /** Schema of the Action Value function. NULL under Always. */
  actionValueSchema?: Maybe<Scalars['String']>;
  /** Name of a function (guarded row -> boolean) deciding whether a given row is an instance of this Capability. */
  bindingPredicateName?: Maybe<Scalars['String']>;
  /** Schema of the optional predicate narrowing which rows this binding applies to. NULL means every write to the guarded table. */
  bindingPredicateSchema?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The Gate this binding belongs to. */
  gateId?: Maybe<Scalars['uuid']>;
  /** Which operations this binding applies to: INSERT, UPDATE, or DELETE. Without this filter a gate on inserts would also re-gate the follow-up update that completes one — the claims pay flow inserts a payment then updates its status — refusing a write for money already authorized. DELETE is supported: enforce() reads OLD on a delete and returns it to allow. */
  guardedOperations?: Maybe<Array<Scalars['String']>>;
  /** Schema of the table whose writes this binding guards. */
  guardedSchema?: Maybe<Scalars['String']>;
  /** Table whose writes this binding guards. One table may serve several gates (shared.payment carries claims and remittance payments), which is what binding_predicate_* disambiguates. */
  guardedTable?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** Name of a function (guarded row -> uuid) returning the entity the action is ABOUT, never the row being created. A claim payment inserts into shared.payment but is approved against the Claim — this is what lets creation-shaped actions be gated at all. Every binding of a Gate resolves to the same subject; bindings differ only in how they get there. */
  subjectResolverName?: Maybe<Scalars['String']>;
  /** Schema of the subject resolver. */
  subjectResolverSchema?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "approvals.gate_binding" */
export type ApprovalGateBinding_Max_Order_By = {
  /** Name of a function (guarded row -> numeric) producing the number the attempt is measured by. Its unit is this Capability's business (dollars, days, a claim number). NULL under Always. */
  actionValueName?: InputMaybe<Order_By>;
  /** Schema of the Action Value function. NULL under Always. */
  actionValueSchema?: InputMaybe<Order_By>;
  /** Name of a function (guarded row -> boolean) deciding whether a given row is an instance of this Capability. */
  bindingPredicateName?: InputMaybe<Order_By>;
  /** Schema of the optional predicate narrowing which rows this binding applies to. NULL means every write to the guarded table. */
  bindingPredicateSchema?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** The Gate this binding belongs to. */
  gateId?: InputMaybe<Order_By>;
  /** Which operations this binding applies to: INSERT, UPDATE, or DELETE. Without this filter a gate on inserts would also re-gate the follow-up update that completes one — the claims pay flow inserts a payment then updates its status — refusing a write for money already authorized. DELETE is supported: enforce() reads OLD on a delete and returns it to allow. */
  guardedOperations?: InputMaybe<Order_By>;
  /** Schema of the table whose writes this binding guards. */
  guardedSchema?: InputMaybe<Order_By>;
  /** Table whose writes this binding guards. One table may serve several gates (shared.payment carries claims and remittance payments), which is what binding_predicate_* disambiguates. */
  guardedTable?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Name of a function (guarded row -> uuid) returning the entity the action is ABOUT, never the row being created. A claim payment inserts into shared.payment but is approved against the Claim — this is what lets creation-shaped actions be gated at all. Every binding of a Gate resolves to the same subject; bindings differ only in how they get there. */
  subjectResolverName?: InputMaybe<Order_By>;
  /** Schema of the subject resolver. */
  subjectResolverSchema?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ApprovalGateBinding_Min_Fields = {
  __typename?: 'approvalGateBinding_min_fields';
  /** Name of a function (guarded row -> numeric) producing the number the attempt is measured by. Its unit is this Capability's business (dollars, days, a claim number). NULL under Always. */
  actionValueName?: Maybe<Scalars['String']>;
  /** Schema of the Action Value function. NULL under Always. */
  actionValueSchema?: Maybe<Scalars['String']>;
  /** Name of a function (guarded row -> boolean) deciding whether a given row is an instance of this Capability. */
  bindingPredicateName?: Maybe<Scalars['String']>;
  /** Schema of the optional predicate narrowing which rows this binding applies to. NULL means every write to the guarded table. */
  bindingPredicateSchema?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The Gate this binding belongs to. */
  gateId?: Maybe<Scalars['uuid']>;
  /** Which operations this binding applies to: INSERT, UPDATE, or DELETE. Without this filter a gate on inserts would also re-gate the follow-up update that completes one — the claims pay flow inserts a payment then updates its status — refusing a write for money already authorized. DELETE is supported: enforce() reads OLD on a delete and returns it to allow. */
  guardedOperations?: Maybe<Array<Scalars['String']>>;
  /** Schema of the table whose writes this binding guards. */
  guardedSchema?: Maybe<Scalars['String']>;
  /** Table whose writes this binding guards. One table may serve several gates (shared.payment carries claims and remittance payments), which is what binding_predicate_* disambiguates. */
  guardedTable?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** Name of a function (guarded row -> uuid) returning the entity the action is ABOUT, never the row being created. A claim payment inserts into shared.payment but is approved against the Claim — this is what lets creation-shaped actions be gated at all. Every binding of a Gate resolves to the same subject; bindings differ only in how they get there. */
  subjectResolverName?: Maybe<Scalars['String']>;
  /** Schema of the subject resolver. */
  subjectResolverSchema?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "approvals.gate_binding" */
export type ApprovalGateBinding_Min_Order_By = {
  /** Name of a function (guarded row -> numeric) producing the number the attempt is measured by. Its unit is this Capability's business (dollars, days, a claim number). NULL under Always. */
  actionValueName?: InputMaybe<Order_By>;
  /** Schema of the Action Value function. NULL under Always. */
  actionValueSchema?: InputMaybe<Order_By>;
  /** Name of a function (guarded row -> boolean) deciding whether a given row is an instance of this Capability. */
  bindingPredicateName?: InputMaybe<Order_By>;
  /** Schema of the optional predicate narrowing which rows this binding applies to. NULL means every write to the guarded table. */
  bindingPredicateSchema?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** The Gate this binding belongs to. */
  gateId?: InputMaybe<Order_By>;
  /** Which operations this binding applies to: INSERT, UPDATE, or DELETE. Without this filter a gate on inserts would also re-gate the follow-up update that completes one — the claims pay flow inserts a payment then updates its status — refusing a write for money already authorized. DELETE is supported: enforce() reads OLD on a delete and returns it to allow. */
  guardedOperations?: InputMaybe<Order_By>;
  /** Schema of the table whose writes this binding guards. */
  guardedSchema?: InputMaybe<Order_By>;
  /** Table whose writes this binding guards. One table may serve several gates (shared.payment carries claims and remittance payments), which is what binding_predicate_* disambiguates. */
  guardedTable?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Name of a function (guarded row -> uuid) returning the entity the action is ABOUT, never the row being created. A claim payment inserts into shared.payment but is approved against the Claim — this is what lets creation-shaped actions be gated at all. Every binding of a Gate resolves to the same subject; bindings differ only in how they get there. */
  subjectResolverName?: InputMaybe<Order_By>;
  /** Schema of the subject resolver. */
  subjectResolverSchema?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "approvals.gate_binding" */
export type ApprovalGateBinding_Mutation_Response = {
  __typename?: 'approvalGateBinding_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApprovalGateBinding>;
};

/** on_conflict condition type for table "approvals.gate_binding" */
export type ApprovalGateBinding_On_Conflict = {
  constraint: ApprovalGateBinding_Constraint;
  update_columns?: Array<ApprovalGateBinding_Update_Column>;
  where?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
};

/** Ordering options when selecting data from "approvals.gate_binding". */
export type ApprovalGateBinding_Order_By = {
  actionValueName?: InputMaybe<Order_By>;
  actionValueSchema?: InputMaybe<Order_By>;
  bindingPredicateName?: InputMaybe<Order_By>;
  bindingPredicateSchema?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  gate?: InputMaybe<ApprovalGate_Order_By>;
  gateId?: InputMaybe<Order_By>;
  guardedOperations?: InputMaybe<Order_By>;
  guardedSchema?: InputMaybe<Order_By>;
  guardedTable?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subjectResolverName?: InputMaybe<Order_By>;
  subjectResolverSchema?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: approvals.gate_binding */
export type ApprovalGateBinding_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "approvals.gate_binding" */
export enum ApprovalGateBinding_Select_Column {
  /** column name */
  ActionValueName = 'actionValueName',
  /** column name */
  ActionValueSchema = 'actionValueSchema',
  /** column name */
  BindingPredicateName = 'bindingPredicateName',
  /** column name */
  BindingPredicateSchema = 'bindingPredicateSchema',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GateId = 'gateId',
  /** column name */
  GuardedOperations = 'guardedOperations',
  /** column name */
  GuardedSchema = 'guardedSchema',
  /** column name */
  GuardedTable = 'guardedTable',
  /** column name */
  Id = 'id',
  /** column name */
  SubjectResolverName = 'subjectResolverName',
  /** column name */
  SubjectResolverSchema = 'subjectResolverSchema',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "approvals.gate_binding" */
export type ApprovalGateBinding_Set_Input = {
  /** Name of a function (guarded row -> numeric) producing the number the attempt is measured by. Its unit is this Capability's business (dollars, days, a claim number). NULL under Always. */
  actionValueName?: InputMaybe<Scalars['String']>;
  /** Schema of the Action Value function. NULL under Always. */
  actionValueSchema?: InputMaybe<Scalars['String']>;
  /** Name of a function (guarded row -> boolean) deciding whether a given row is an instance of this Capability. */
  bindingPredicateName?: InputMaybe<Scalars['String']>;
  /** Schema of the optional predicate narrowing which rows this binding applies to. NULL means every write to the guarded table. */
  bindingPredicateSchema?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Gate this binding belongs to. */
  gateId?: InputMaybe<Scalars['uuid']>;
  /** Which operations this binding applies to: INSERT, UPDATE, or DELETE. Without this filter a gate on inserts would also re-gate the follow-up update that completes one — the claims pay flow inserts a payment then updates its status — refusing a write for money already authorized. DELETE is supported: enforce() reads OLD on a delete and returns it to allow. */
  guardedOperations?: InputMaybe<Array<Scalars['String']>>;
  /** Schema of the table whose writes this binding guards. */
  guardedSchema?: InputMaybe<Scalars['String']>;
  /** Table whose writes this binding guards. One table may serve several gates (shared.payment carries claims and remittance payments), which is what binding_predicate_* disambiguates. */
  guardedTable?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Name of a function (guarded row -> uuid) returning the entity the action is ABOUT, never the row being created. A claim payment inserts into shared.payment but is approved against the Claim — this is what lets creation-shaped actions be gated at all. Every binding of a Gate resolves to the same subject; bindings differ only in how they get there. */
  subjectResolverName?: InputMaybe<Scalars['String']>;
  /** Schema of the subject resolver. */
  subjectResolverSchema?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "approvalGateBinding" */
export type ApprovalGateBinding_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ApprovalGateBinding_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ApprovalGateBinding_Stream_Cursor_Value_Input = {
  /** Name of a function (guarded row -> numeric) producing the number the attempt is measured by. Its unit is this Capability's business (dollars, days, a claim number). NULL under Always. */
  actionValueName?: InputMaybe<Scalars['String']>;
  /** Schema of the Action Value function. NULL under Always. */
  actionValueSchema?: InputMaybe<Scalars['String']>;
  /** Name of a function (guarded row -> boolean) deciding whether a given row is an instance of this Capability. */
  bindingPredicateName?: InputMaybe<Scalars['String']>;
  /** Schema of the optional predicate narrowing which rows this binding applies to. NULL means every write to the guarded table. */
  bindingPredicateSchema?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Gate this binding belongs to. */
  gateId?: InputMaybe<Scalars['uuid']>;
  /** Which operations this binding applies to: INSERT, UPDATE, or DELETE. Without this filter a gate on inserts would also re-gate the follow-up update that completes one — the claims pay flow inserts a payment then updates its status — refusing a write for money already authorized. DELETE is supported: enforce() reads OLD on a delete and returns it to allow. */
  guardedOperations?: InputMaybe<Array<Scalars['String']>>;
  /** Schema of the table whose writes this binding guards. */
  guardedSchema?: InputMaybe<Scalars['String']>;
  /** Table whose writes this binding guards. One table may serve several gates (shared.payment carries claims and remittance payments), which is what binding_predicate_* disambiguates. */
  guardedTable?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Name of a function (guarded row -> uuid) returning the entity the action is ABOUT, never the row being created. A claim payment inserts into shared.payment but is approved against the Claim — this is what lets creation-shaped actions be gated at all. Every binding of a Gate resolves to the same subject; bindings differ only in how they get there. */
  subjectResolverName?: InputMaybe<Scalars['String']>;
  /** Schema of the subject resolver. */
  subjectResolverSchema?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "approvals.gate_binding" */
export enum ApprovalGateBinding_Update_Column {
  /** column name */
  ActionValueName = 'actionValueName',
  /** column name */
  ActionValueSchema = 'actionValueSchema',
  /** column name */
  BindingPredicateName = 'bindingPredicateName',
  /** column name */
  BindingPredicateSchema = 'bindingPredicateSchema',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GateId = 'gateId',
  /** column name */
  GuardedOperations = 'guardedOperations',
  /** column name */
  GuardedSchema = 'guardedSchema',
  /** column name */
  GuardedTable = 'guardedTable',
  /** column name */
  Id = 'id',
  /** column name */
  SubjectResolverName = 'subjectResolverName',
  /** column name */
  SubjectResolverSchema = 'subjectResolverSchema',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ApprovalGateBinding_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApprovalGateBinding_Set_Input>;
  /** filter the rows which have to be updated */
  where: ApprovalGateBinding_Bool_Exp;
};

/** aggregated selection of "approvals.gate" */
export type ApprovalGate_Aggregate = {
  __typename?: 'approvalGate_aggregate';
  aggregate?: Maybe<ApprovalGate_Aggregate_Fields>;
  nodes: Array<ApprovalGate>;
};

export type ApprovalGate_Aggregate_Bool_Exp = {
  count?: InputMaybe<ApprovalGate_Aggregate_Bool_Exp_Count>;
};

export type ApprovalGate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ApprovalGate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApprovalGate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "approvals.gate" */
export type ApprovalGate_Aggregate_Fields = {
  __typename?: 'approvalGate_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ApprovalGate_Max_Fields>;
  min?: Maybe<ApprovalGate_Min_Fields>;
};


/** aggregate fields of "approvals.gate" */
export type ApprovalGate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ApprovalGate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "approvals.gate" */
export type ApprovalGate_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ApprovalGate_Max_Order_By>;
  min?: InputMaybe<ApprovalGate_Min_Order_By>;
};

/** input type for inserting array relation for remote table "approvals.gate" */
export type ApprovalGate_Arr_Rel_Insert_Input = {
  data: Array<ApprovalGate_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ApprovalGate_On_Conflict>;
};

/** Boolean expression to filter rows from the table "approvals.gate". All fields are combined with a logical 'AND'. */
export type ApprovalGate_Bool_Exp = {
  _and?: InputMaybe<Array<ApprovalGate_Bool_Exp>>;
  _not?: InputMaybe<ApprovalGate_Bool_Exp>;
  _or?: InputMaybe<Array<ApprovalGate_Bool_Exp>>;
  approvalTriggerType?: InputMaybe<Type_Bool_Exp>;
  approvalTriggerTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  bindingArgument?: InputMaybe<String_Comparison_Exp>;
  capability?: InputMaybe<Capability_Bool_Exp>;
  capabilityId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  gateBindings?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
  gateBindings_aggregate?: InputMaybe<ApprovalGateBinding_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  materialFields?: InputMaybe<String_Array_Comparison_Exp>;
  materialFunctionName?: InputMaybe<String_Comparison_Exp>;
  materialFunctionSchema?: InputMaybe<String_Comparison_Exp>;
  preconditionMessage?: InputMaybe<String_Comparison_Exp>;
  preconditionName?: InputMaybe<String_Comparison_Exp>;
  preconditionSchema?: InputMaybe<String_Comparison_Exp>;
  subjectDiscriminatorName?: InputMaybe<String_Comparison_Exp>;
  subjectDiscriminatorSchema?: InputMaybe<String_Comparison_Exp>;
  subjectSchema?: InputMaybe<String_Comparison_Exp>;
  subjectTable?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "approvals.gate" */
export enum ApprovalGate_Constraint {
  /** unique or primary key constraint on columns "capability_id" */
  GateOneDefaultPerCapability = 'gate_one_default_per_capability',
  /** unique or primary key constraint on columns "binding_argument", "capability_id" */
  GateOnePerCapabilityArgument = 'gate_one_per_capability_argument',
  /** unique or primary key constraint on columns "id" */
  GatePkey = 'gate_pkey'
}

/** input type for inserting data into table "approvals.gate" */
export type ApprovalGate_Insert_Input = {
  approvalTriggerType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** shared.type in the ApprovalTrigger group: OverLimit (approval needed when the Action Value exceeds the actor's authority) or Always (every attempt needs approval, with nothing measured). */
  approvalTriggerTypeId?: InputMaybe<Scalars['uuid']>;
  /** The discriminator value this Gate addresses, compared as text — store an id rather than a name so renaming a Category cannot silently detach a limit. Null makes this the Capability's default Gate, used when no sibling matches; a Capability may have at most one. IT-6672. */
  bindingArgument?: InputMaybe<Scalars['String']>;
  capability?: InputMaybe<Capability_Obj_Rel_Insert_Input>;
  /** The Capability this gate applies to. Unique: a Capability is either gated or it is not. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** What to call this Gate in a refusal, when its Capability has more than one. Two Gates on Pay mechanical claims would otherwise raise the same sentence and the reader could not tell which limit bit. Falls back to auth.capability.display when null. IT-6672. */
  display?: InputMaybe<Scalars['String']>;
  gateBindings?: InputMaybe<ApprovalGateBinding_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Column names on the SUBJECT ROW whose change invalidates an existing Approval, hashed into approvals.approval.material_hash. Use when what matters is a handful of the subject's own columns (a time-off request's dates). Mutually exclusive with material_function_*. */
  materialFields?: InputMaybe<Array<Scalars['String']>>;
  /** Name of a function (subject uuid -> jsonb) returning the facts an Approval was granted against, hashed into approvals.approval.material_hash. Use when those facts are not columns of the subject — a repair bill is its set of claim_detail rows, not a column on claim_service_center. The function chooses what counts: selecting id, quantity and cost per line means a corrected part-number typo does NOT invalidate the approval, while a changed price does. Mutually exclusive with material_fields; declaring neither means only the cap invalidates. */
  materialFunctionName?: InputMaybe<Scalars['String']>;
  /** Schema of the material function. Mutually exclusive with material_fields. */
  materialFunctionSchema?: InputMaybe<Scalars['String']>;
  /** What to tell the user when the precondition fails, e.g. "This repair has no valid authorization." Written by whoever configures the gate, because only they know what the predicate means. NULL falls back to a generic sentence. */
  preconditionMessage?: InputMaybe<Scalars['String']>;
  /** Name of a function (subject uuid -> boolean) that must hold before the write is allowed, over and above authority. Dual control: the payments department may only disburse where the adjuster has issued a Repair Authorization for that Service Provider, so the predicate asks the claims domain whether a valid one exists. It deliberately reads DOMAIN data, not approvals data — an authorization within the adjuster's own limit produces no Approval row at all, so a precondition looking for one would refuse every ordinary payment. Unlike authority this is NOT satisfiable by a large limit: an unlimited holder is still refused. NULL means no precondition. */
  preconditionName?: InputMaybe<Scalars['String']>;
  /** Schema of the precondition function. */
  preconditionSchema?: InputMaybe<Scalars['String']>;
  /** Name of a function (subject uuid -> text) returning the value that selects among a Capability's Gates — a Category id for claim payments. Takes the SUBJECT rather than the guarded row so the write path and the advisory read share one implementation. All Gates of a Capability must name the same function; a trigger enforces it. IT-6672. */
  subjectDiscriminatorName?: InputMaybe<Scalars['String']>;
  /** Schema of the subject discriminator. Null on a Capability with a single Gate. */
  subjectDiscriminatorSchema?: InputMaybe<Scalars['String']>;
  /** Schema of the table the subject entity lives in. */
  subjectSchema?: InputMaybe<Scalars['String']>;
  /** Table the subject entity lives in — what subject_resolver_name returns an id into. Needed to read material_fields off the subject. */
  subjectTable?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ApprovalGate_Max_Fields = {
  __typename?: 'approvalGate_max_fields';
  /** shared.type in the ApprovalTrigger group: OverLimit (approval needed when the Action Value exceeds the actor's authority) or Always (every attempt needs approval, with nothing measured). */
  approvalTriggerTypeId?: Maybe<Scalars['uuid']>;
  /** The discriminator value this Gate addresses, compared as text — store an id rather than a name so renaming a Category cannot silently detach a limit. Null makes this the Capability's default Gate, used when no sibling matches; a Capability may have at most one. IT-6672. */
  bindingArgument?: Maybe<Scalars['String']>;
  /** The Capability this gate applies to. Unique: a Capability is either gated or it is not. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** What to call this Gate in a refusal, when its Capability has more than one. Two Gates on Pay mechanical claims would otherwise raise the same sentence and the reader could not tell which limit bit. Falls back to auth.capability.display when null. IT-6672. */
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** Column names on the SUBJECT ROW whose change invalidates an existing Approval, hashed into approvals.approval.material_hash. Use when what matters is a handful of the subject's own columns (a time-off request's dates). Mutually exclusive with material_function_*. */
  materialFields?: Maybe<Array<Scalars['String']>>;
  /** Name of a function (subject uuid -> jsonb) returning the facts an Approval was granted against, hashed into approvals.approval.material_hash. Use when those facts are not columns of the subject — a repair bill is its set of claim_detail rows, not a column on claim_service_center. The function chooses what counts: selecting id, quantity and cost per line means a corrected part-number typo does NOT invalidate the approval, while a changed price does. Mutually exclusive with material_fields; declaring neither means only the cap invalidates. */
  materialFunctionName?: Maybe<Scalars['String']>;
  /** Schema of the material function. Mutually exclusive with material_fields. */
  materialFunctionSchema?: Maybe<Scalars['String']>;
  /** What to tell the user when the precondition fails, e.g. "This repair has no valid authorization." Written by whoever configures the gate, because only they know what the predicate means. NULL falls back to a generic sentence. */
  preconditionMessage?: Maybe<Scalars['String']>;
  /** Name of a function (subject uuid -> boolean) that must hold before the write is allowed, over and above authority. Dual control: the payments department may only disburse where the adjuster has issued a Repair Authorization for that Service Provider, so the predicate asks the claims domain whether a valid one exists. It deliberately reads DOMAIN data, not approvals data — an authorization within the adjuster's own limit produces no Approval row at all, so a precondition looking for one would refuse every ordinary payment. Unlike authority this is NOT satisfiable by a large limit: an unlimited holder is still refused. NULL means no precondition. */
  preconditionName?: Maybe<Scalars['String']>;
  /** Schema of the precondition function. */
  preconditionSchema?: Maybe<Scalars['String']>;
  /** Name of a function (subject uuid -> text) returning the value that selects among a Capability's Gates — a Category id for claim payments. Takes the SUBJECT rather than the guarded row so the write path and the advisory read share one implementation. All Gates of a Capability must name the same function; a trigger enforces it. IT-6672. */
  subjectDiscriminatorName?: Maybe<Scalars['String']>;
  /** Schema of the subject discriminator. Null on a Capability with a single Gate. */
  subjectDiscriminatorSchema?: Maybe<Scalars['String']>;
  /** Schema of the table the subject entity lives in. */
  subjectSchema?: Maybe<Scalars['String']>;
  /** Table the subject entity lives in — what subject_resolver_name returns an id into. Needed to read material_fields off the subject. */
  subjectTable?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "approvals.gate" */
export type ApprovalGate_Max_Order_By = {
  /** shared.type in the ApprovalTrigger group: OverLimit (approval needed when the Action Value exceeds the actor's authority) or Always (every attempt needs approval, with nothing measured). */
  approvalTriggerTypeId?: InputMaybe<Order_By>;
  /** The discriminator value this Gate addresses, compared as text — store an id rather than a name so renaming a Category cannot silently detach a limit. Null makes this the Capability's default Gate, used when no sibling matches; a Capability may have at most one. IT-6672. */
  bindingArgument?: InputMaybe<Order_By>;
  /** The Capability this gate applies to. Unique: a Capability is either gated or it is not. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** What to call this Gate in a refusal, when its Capability has more than one. Two Gates on Pay mechanical claims would otherwise raise the same sentence and the reader could not tell which limit bit. Falls back to auth.capability.display when null. IT-6672. */
  display?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Column names on the SUBJECT ROW whose change invalidates an existing Approval, hashed into approvals.approval.material_hash. Use when what matters is a handful of the subject's own columns (a time-off request's dates). Mutually exclusive with material_function_*. */
  materialFields?: InputMaybe<Order_By>;
  /** Name of a function (subject uuid -> jsonb) returning the facts an Approval was granted against, hashed into approvals.approval.material_hash. Use when those facts are not columns of the subject — a repair bill is its set of claim_detail rows, not a column on claim_service_center. The function chooses what counts: selecting id, quantity and cost per line means a corrected part-number typo does NOT invalidate the approval, while a changed price does. Mutually exclusive with material_fields; declaring neither means only the cap invalidates. */
  materialFunctionName?: InputMaybe<Order_By>;
  /** Schema of the material function. Mutually exclusive with material_fields. */
  materialFunctionSchema?: InputMaybe<Order_By>;
  /** What to tell the user when the precondition fails, e.g. "This repair has no valid authorization." Written by whoever configures the gate, because only they know what the predicate means. NULL falls back to a generic sentence. */
  preconditionMessage?: InputMaybe<Order_By>;
  /** Name of a function (subject uuid -> boolean) that must hold before the write is allowed, over and above authority. Dual control: the payments department may only disburse where the adjuster has issued a Repair Authorization for that Service Provider, so the predicate asks the claims domain whether a valid one exists. It deliberately reads DOMAIN data, not approvals data — an authorization within the adjuster's own limit produces no Approval row at all, so a precondition looking for one would refuse every ordinary payment. Unlike authority this is NOT satisfiable by a large limit: an unlimited holder is still refused. NULL means no precondition. */
  preconditionName?: InputMaybe<Order_By>;
  /** Schema of the precondition function. */
  preconditionSchema?: InputMaybe<Order_By>;
  /** Name of a function (subject uuid -> text) returning the value that selects among a Capability's Gates — a Category id for claim payments. Takes the SUBJECT rather than the guarded row so the write path and the advisory read share one implementation. All Gates of a Capability must name the same function; a trigger enforces it. IT-6672. */
  subjectDiscriminatorName?: InputMaybe<Order_By>;
  /** Schema of the subject discriminator. Null on a Capability with a single Gate. */
  subjectDiscriminatorSchema?: InputMaybe<Order_By>;
  /** Schema of the table the subject entity lives in. */
  subjectSchema?: InputMaybe<Order_By>;
  /** Table the subject entity lives in — what subject_resolver_name returns an id into. Needed to read material_fields off the subject. */
  subjectTable?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ApprovalGate_Min_Fields = {
  __typename?: 'approvalGate_min_fields';
  /** shared.type in the ApprovalTrigger group: OverLimit (approval needed when the Action Value exceeds the actor's authority) or Always (every attempt needs approval, with nothing measured). */
  approvalTriggerTypeId?: Maybe<Scalars['uuid']>;
  /** The discriminator value this Gate addresses, compared as text — store an id rather than a name so renaming a Category cannot silently detach a limit. Null makes this the Capability's default Gate, used when no sibling matches; a Capability may have at most one. IT-6672. */
  bindingArgument?: Maybe<Scalars['String']>;
  /** The Capability this gate applies to. Unique: a Capability is either gated or it is not. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** What to call this Gate in a refusal, when its Capability has more than one. Two Gates on Pay mechanical claims would otherwise raise the same sentence and the reader could not tell which limit bit. Falls back to auth.capability.display when null. IT-6672. */
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** Column names on the SUBJECT ROW whose change invalidates an existing Approval, hashed into approvals.approval.material_hash. Use when what matters is a handful of the subject's own columns (a time-off request's dates). Mutually exclusive with material_function_*. */
  materialFields?: Maybe<Array<Scalars['String']>>;
  /** Name of a function (subject uuid -> jsonb) returning the facts an Approval was granted against, hashed into approvals.approval.material_hash. Use when those facts are not columns of the subject — a repair bill is its set of claim_detail rows, not a column on claim_service_center. The function chooses what counts: selecting id, quantity and cost per line means a corrected part-number typo does NOT invalidate the approval, while a changed price does. Mutually exclusive with material_fields; declaring neither means only the cap invalidates. */
  materialFunctionName?: Maybe<Scalars['String']>;
  /** Schema of the material function. Mutually exclusive with material_fields. */
  materialFunctionSchema?: Maybe<Scalars['String']>;
  /** What to tell the user when the precondition fails, e.g. "This repair has no valid authorization." Written by whoever configures the gate, because only they know what the predicate means. NULL falls back to a generic sentence. */
  preconditionMessage?: Maybe<Scalars['String']>;
  /** Name of a function (subject uuid -> boolean) that must hold before the write is allowed, over and above authority. Dual control: the payments department may only disburse where the adjuster has issued a Repair Authorization for that Service Provider, so the predicate asks the claims domain whether a valid one exists. It deliberately reads DOMAIN data, not approvals data — an authorization within the adjuster's own limit produces no Approval row at all, so a precondition looking for one would refuse every ordinary payment. Unlike authority this is NOT satisfiable by a large limit: an unlimited holder is still refused. NULL means no precondition. */
  preconditionName?: Maybe<Scalars['String']>;
  /** Schema of the precondition function. */
  preconditionSchema?: Maybe<Scalars['String']>;
  /** Name of a function (subject uuid -> text) returning the value that selects among a Capability's Gates — a Category id for claim payments. Takes the SUBJECT rather than the guarded row so the write path and the advisory read share one implementation. All Gates of a Capability must name the same function; a trigger enforces it. IT-6672. */
  subjectDiscriminatorName?: Maybe<Scalars['String']>;
  /** Schema of the subject discriminator. Null on a Capability with a single Gate. */
  subjectDiscriminatorSchema?: Maybe<Scalars['String']>;
  /** Schema of the table the subject entity lives in. */
  subjectSchema?: Maybe<Scalars['String']>;
  /** Table the subject entity lives in — what subject_resolver_name returns an id into. Needed to read material_fields off the subject. */
  subjectTable?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "approvals.gate" */
export type ApprovalGate_Min_Order_By = {
  /** shared.type in the ApprovalTrigger group: OverLimit (approval needed when the Action Value exceeds the actor's authority) or Always (every attempt needs approval, with nothing measured). */
  approvalTriggerTypeId?: InputMaybe<Order_By>;
  /** The discriminator value this Gate addresses, compared as text — store an id rather than a name so renaming a Category cannot silently detach a limit. Null makes this the Capability's default Gate, used when no sibling matches; a Capability may have at most one. IT-6672. */
  bindingArgument?: InputMaybe<Order_By>;
  /** The Capability this gate applies to. Unique: a Capability is either gated or it is not. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** What to call this Gate in a refusal, when its Capability has more than one. Two Gates on Pay mechanical claims would otherwise raise the same sentence and the reader could not tell which limit bit. Falls back to auth.capability.display when null. IT-6672. */
  display?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Column names on the SUBJECT ROW whose change invalidates an existing Approval, hashed into approvals.approval.material_hash. Use when what matters is a handful of the subject's own columns (a time-off request's dates). Mutually exclusive with material_function_*. */
  materialFields?: InputMaybe<Order_By>;
  /** Name of a function (subject uuid -> jsonb) returning the facts an Approval was granted against, hashed into approvals.approval.material_hash. Use when those facts are not columns of the subject — a repair bill is its set of claim_detail rows, not a column on claim_service_center. The function chooses what counts: selecting id, quantity and cost per line means a corrected part-number typo does NOT invalidate the approval, while a changed price does. Mutually exclusive with material_fields; declaring neither means only the cap invalidates. */
  materialFunctionName?: InputMaybe<Order_By>;
  /** Schema of the material function. Mutually exclusive with material_fields. */
  materialFunctionSchema?: InputMaybe<Order_By>;
  /** What to tell the user when the precondition fails, e.g. "This repair has no valid authorization." Written by whoever configures the gate, because only they know what the predicate means. NULL falls back to a generic sentence. */
  preconditionMessage?: InputMaybe<Order_By>;
  /** Name of a function (subject uuid -> boolean) that must hold before the write is allowed, over and above authority. Dual control: the payments department may only disburse where the adjuster has issued a Repair Authorization for that Service Provider, so the predicate asks the claims domain whether a valid one exists. It deliberately reads DOMAIN data, not approvals data — an authorization within the adjuster's own limit produces no Approval row at all, so a precondition looking for one would refuse every ordinary payment. Unlike authority this is NOT satisfiable by a large limit: an unlimited holder is still refused. NULL means no precondition. */
  preconditionName?: InputMaybe<Order_By>;
  /** Schema of the precondition function. */
  preconditionSchema?: InputMaybe<Order_By>;
  /** Name of a function (subject uuid -> text) returning the value that selects among a Capability's Gates — a Category id for claim payments. Takes the SUBJECT rather than the guarded row so the write path and the advisory read share one implementation. All Gates of a Capability must name the same function; a trigger enforces it. IT-6672. */
  subjectDiscriminatorName?: InputMaybe<Order_By>;
  /** Schema of the subject discriminator. Null on a Capability with a single Gate. */
  subjectDiscriminatorSchema?: InputMaybe<Order_By>;
  /** Schema of the table the subject entity lives in. */
  subjectSchema?: InputMaybe<Order_By>;
  /** Table the subject entity lives in — what subject_resolver_name returns an id into. Needed to read material_fields off the subject. */
  subjectTable?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "approvals.gate" */
export type ApprovalGate_Mutation_Response = {
  __typename?: 'approvalGate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApprovalGate>;
};

/** input type for inserting object relation for remote table "approvals.gate" */
export type ApprovalGate_Obj_Rel_Insert_Input = {
  data: ApprovalGate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ApprovalGate_On_Conflict>;
};

/** on_conflict condition type for table "approvals.gate" */
export type ApprovalGate_On_Conflict = {
  constraint: ApprovalGate_Constraint;
  update_columns?: Array<ApprovalGate_Update_Column>;
  where?: InputMaybe<ApprovalGate_Bool_Exp>;
};

/** Ordering options when selecting data from "approvals.gate". */
export type ApprovalGate_Order_By = {
  approvalTriggerType?: InputMaybe<Type_Order_By>;
  approvalTriggerTypeId?: InputMaybe<Order_By>;
  bindingArgument?: InputMaybe<Order_By>;
  capability?: InputMaybe<Capability_Order_By>;
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  gateBindings_aggregate?: InputMaybe<ApprovalGateBinding_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  materialFields?: InputMaybe<Order_By>;
  materialFunctionName?: InputMaybe<Order_By>;
  materialFunctionSchema?: InputMaybe<Order_By>;
  preconditionMessage?: InputMaybe<Order_By>;
  preconditionName?: InputMaybe<Order_By>;
  preconditionSchema?: InputMaybe<Order_By>;
  subjectDiscriminatorName?: InputMaybe<Order_By>;
  subjectDiscriminatorSchema?: InputMaybe<Order_By>;
  subjectSchema?: InputMaybe<Order_By>;
  subjectTable?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: approvals.gate */
export type ApprovalGate_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "approvals.gate" */
export enum ApprovalGate_Select_Column {
  /** column name */
  ApprovalTriggerTypeId = 'approvalTriggerTypeId',
  /** column name */
  BindingArgument = 'bindingArgument',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialFields = 'materialFields',
  /** column name */
  MaterialFunctionName = 'materialFunctionName',
  /** column name */
  MaterialFunctionSchema = 'materialFunctionSchema',
  /** column name */
  PreconditionMessage = 'preconditionMessage',
  /** column name */
  PreconditionName = 'preconditionName',
  /** column name */
  PreconditionSchema = 'preconditionSchema',
  /** column name */
  SubjectDiscriminatorName = 'subjectDiscriminatorName',
  /** column name */
  SubjectDiscriminatorSchema = 'subjectDiscriminatorSchema',
  /** column name */
  SubjectSchema = 'subjectSchema',
  /** column name */
  SubjectTable = 'subjectTable',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "approvals.gate" */
export type ApprovalGate_Set_Input = {
  /** shared.type in the ApprovalTrigger group: OverLimit (approval needed when the Action Value exceeds the actor's authority) or Always (every attempt needs approval, with nothing measured). */
  approvalTriggerTypeId?: InputMaybe<Scalars['uuid']>;
  /** The discriminator value this Gate addresses, compared as text — store an id rather than a name so renaming a Category cannot silently detach a limit. Null makes this the Capability's default Gate, used when no sibling matches; a Capability may have at most one. IT-6672. */
  bindingArgument?: InputMaybe<Scalars['String']>;
  /** The Capability this gate applies to. Unique: a Capability is either gated or it is not. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** What to call this Gate in a refusal, when its Capability has more than one. Two Gates on Pay mechanical claims would otherwise raise the same sentence and the reader could not tell which limit bit. Falls back to auth.capability.display when null. IT-6672. */
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Column names on the SUBJECT ROW whose change invalidates an existing Approval, hashed into approvals.approval.material_hash. Use when what matters is a handful of the subject's own columns (a time-off request's dates). Mutually exclusive with material_function_*. */
  materialFields?: InputMaybe<Array<Scalars['String']>>;
  /** Name of a function (subject uuid -> jsonb) returning the facts an Approval was granted against, hashed into approvals.approval.material_hash. Use when those facts are not columns of the subject — a repair bill is its set of claim_detail rows, not a column on claim_service_center. The function chooses what counts: selecting id, quantity and cost per line means a corrected part-number typo does NOT invalidate the approval, while a changed price does. Mutually exclusive with material_fields; declaring neither means only the cap invalidates. */
  materialFunctionName?: InputMaybe<Scalars['String']>;
  /** Schema of the material function. Mutually exclusive with material_fields. */
  materialFunctionSchema?: InputMaybe<Scalars['String']>;
  /** What to tell the user when the precondition fails, e.g. "This repair has no valid authorization." Written by whoever configures the gate, because only they know what the predicate means. NULL falls back to a generic sentence. */
  preconditionMessage?: InputMaybe<Scalars['String']>;
  /** Name of a function (subject uuid -> boolean) that must hold before the write is allowed, over and above authority. Dual control: the payments department may only disburse where the adjuster has issued a Repair Authorization for that Service Provider, so the predicate asks the claims domain whether a valid one exists. It deliberately reads DOMAIN data, not approvals data — an authorization within the adjuster's own limit produces no Approval row at all, so a precondition looking for one would refuse every ordinary payment. Unlike authority this is NOT satisfiable by a large limit: an unlimited holder is still refused. NULL means no precondition. */
  preconditionName?: InputMaybe<Scalars['String']>;
  /** Schema of the precondition function. */
  preconditionSchema?: InputMaybe<Scalars['String']>;
  /** Name of a function (subject uuid -> text) returning the value that selects among a Capability's Gates — a Category id for claim payments. Takes the SUBJECT rather than the guarded row so the write path and the advisory read share one implementation. All Gates of a Capability must name the same function; a trigger enforces it. IT-6672. */
  subjectDiscriminatorName?: InputMaybe<Scalars['String']>;
  /** Schema of the subject discriminator. Null on a Capability with a single Gate. */
  subjectDiscriminatorSchema?: InputMaybe<Scalars['String']>;
  /** Schema of the table the subject entity lives in. */
  subjectSchema?: InputMaybe<Scalars['String']>;
  /** Table the subject entity lives in — what subject_resolver_name returns an id into. Needed to read material_fields off the subject. */
  subjectTable?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "approvalGate" */
export type ApprovalGate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ApprovalGate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ApprovalGate_Stream_Cursor_Value_Input = {
  /** shared.type in the ApprovalTrigger group: OverLimit (approval needed when the Action Value exceeds the actor's authority) or Always (every attempt needs approval, with nothing measured). */
  approvalTriggerTypeId?: InputMaybe<Scalars['uuid']>;
  /** The discriminator value this Gate addresses, compared as text — store an id rather than a name so renaming a Category cannot silently detach a limit. Null makes this the Capability's default Gate, used when no sibling matches; a Capability may have at most one. IT-6672. */
  bindingArgument?: InputMaybe<Scalars['String']>;
  /** The Capability this gate applies to. Unique: a Capability is either gated or it is not. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** What to call this Gate in a refusal, when its Capability has more than one. Two Gates on Pay mechanical claims would otherwise raise the same sentence and the reader could not tell which limit bit. Falls back to auth.capability.display when null. IT-6672. */
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Column names on the SUBJECT ROW whose change invalidates an existing Approval, hashed into approvals.approval.material_hash. Use when what matters is a handful of the subject's own columns (a time-off request's dates). Mutually exclusive with material_function_*. */
  materialFields?: InputMaybe<Array<Scalars['String']>>;
  /** Name of a function (subject uuid -> jsonb) returning the facts an Approval was granted against, hashed into approvals.approval.material_hash. Use when those facts are not columns of the subject — a repair bill is its set of claim_detail rows, not a column on claim_service_center. The function chooses what counts: selecting id, quantity and cost per line means a corrected part-number typo does NOT invalidate the approval, while a changed price does. Mutually exclusive with material_fields; declaring neither means only the cap invalidates. */
  materialFunctionName?: InputMaybe<Scalars['String']>;
  /** Schema of the material function. Mutually exclusive with material_fields. */
  materialFunctionSchema?: InputMaybe<Scalars['String']>;
  /** What to tell the user when the precondition fails, e.g. "This repair has no valid authorization." Written by whoever configures the gate, because only they know what the predicate means. NULL falls back to a generic sentence. */
  preconditionMessage?: InputMaybe<Scalars['String']>;
  /** Name of a function (subject uuid -> boolean) that must hold before the write is allowed, over and above authority. Dual control: the payments department may only disburse where the adjuster has issued a Repair Authorization for that Service Provider, so the predicate asks the claims domain whether a valid one exists. It deliberately reads DOMAIN data, not approvals data — an authorization within the adjuster's own limit produces no Approval row at all, so a precondition looking for one would refuse every ordinary payment. Unlike authority this is NOT satisfiable by a large limit: an unlimited holder is still refused. NULL means no precondition. */
  preconditionName?: InputMaybe<Scalars['String']>;
  /** Schema of the precondition function. */
  preconditionSchema?: InputMaybe<Scalars['String']>;
  /** Name of a function (subject uuid -> text) returning the value that selects among a Capability's Gates — a Category id for claim payments. Takes the SUBJECT rather than the guarded row so the write path and the advisory read share one implementation. All Gates of a Capability must name the same function; a trigger enforces it. IT-6672. */
  subjectDiscriminatorName?: InputMaybe<Scalars['String']>;
  /** Schema of the subject discriminator. Null on a Capability with a single Gate. */
  subjectDiscriminatorSchema?: InputMaybe<Scalars['String']>;
  /** Schema of the table the subject entity lives in. */
  subjectSchema?: InputMaybe<Scalars['String']>;
  /** Table the subject entity lives in — what subject_resolver_name returns an id into. Needed to read material_fields off the subject. */
  subjectTable?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "approvals.gate" */
export enum ApprovalGate_Update_Column {
  /** column name */
  ApprovalTriggerTypeId = 'approvalTriggerTypeId',
  /** column name */
  BindingArgument = 'bindingArgument',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialFields = 'materialFields',
  /** column name */
  MaterialFunctionName = 'materialFunctionName',
  /** column name */
  MaterialFunctionSchema = 'materialFunctionSchema',
  /** column name */
  PreconditionMessage = 'preconditionMessage',
  /** column name */
  PreconditionName = 'preconditionName',
  /** column name */
  PreconditionSchema = 'preconditionSchema',
  /** column name */
  SubjectDiscriminatorName = 'subjectDiscriminatorName',
  /** column name */
  SubjectDiscriminatorSchema = 'subjectDiscriminatorSchema',
  /** column name */
  SubjectSchema = 'subjectSchema',
  /** column name */
  SubjectTable = 'subjectTable',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ApprovalGate_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApprovalGate_Set_Input>;
  /** filter the rows which have to be updated */
  where: ApprovalGate_Bool_Exp;
};

export type ApprovalHeadroom_Args = {
  p_capability_name?: InputMaybe<Scalars['String']>;
  p_subject_id?: InputMaybe<Scalars['uuid']>;
};

export type ApprovalHeadroom_ClaimServiceCenter_Args = {
  p_capability_name?: InputMaybe<Scalars['String']>;
};

/** A payer asking for an Approval they cannot grant themselves. Separate from approvals.approval because a pending row there would be refused by validate_grant(), which requires can_approve of whoever writes it. Deciding a request inserts the approval, so every guard on granting still applies. IT-6672. */
export type ApprovalRequest = {
  __typename?: 'approvalRequest';
  /** An object relationship */
  approval?: Maybe<Approval>;
  /** The approvals.approval row decide_request wrote when it was approved — the thing that actually raises the payer's reach. Null unless approved, by the state CHECK. Approving is therefore one write, running through validate_grant like any other grant. */
  approvalId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  capability: Capability;
  /** The Capability the requester is asking to act beyond their authority on. Decided against by decide_request, which reads the asker's and the decider's authority for it. */
  capabilityId: Scalars['uuid'];
  /** An object relationship */
  claimServiceCenter?: Maybe<ClaimServiceCenter>;
  createdAt: Scalars['timestamptz'];
  /** When it stopped being pending. Null while pending and required once decided, by the same state CHECK. The Answered queue orders on it. */
  decidedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  decidedBy?: Maybe<Identity>;
  /** Who approved or denied it (logical ref to ory.identity, no FK). Null while pending; the state CHECK requires it once decided. For a cancellation it is the requester, who is the only person allowed to cancel. */
  decidedByIdentityId?: Maybe<Scalars['uuid']>;
  /** Why it was denied, shown to the payer on the claim. Non-blank is required for a denial and forbidden on any other state, so a pending request has no mutable field a requester could change after an approver has read the queue. */
  denialReason?: Maybe<Scalars['String']>;
  /** The Gate the request is measured against, derived from the subject rather than trusted from the caller — same rule as approvals.approval.gate_id, so the Approval decide_request writes lands on the Gate the payment will actually be measured by. */
  gateId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  identity?: Maybe<Identity>;
  /** The person asking — the one who would pay (logical ref to ory.identity, no FK). validate_request pins this to the session identity, so a request cannot be raised on someone else's behalf. */
  identityId: Scalars['uuid'];
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount: Scalars['numeric'];
  /** pending, approved, denied or cancelled. Approved carries the approval_id it created; denied carries a required denial_reason; cancelled is the requester withdrawing their own ask and needs no reason. A request whose Approval later stops applying because the subject changed is NOT denied — nobody refused it — and the payer requests again. IT-6672. */
  state: Scalars['String'];
  /** The entity the request is about, as the Gate's subject resolver returns it. Deliberately untyped and carries no FK: subjects live in different tables per Capability. Partial unique index request_one_pending_per_subject keys on it. */
  subjectId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "approvals.request" */
export type ApprovalRequest_Aggregate = {
  __typename?: 'approvalRequest_aggregate';
  aggregate?: Maybe<ApprovalRequest_Aggregate_Fields>;
  nodes: Array<ApprovalRequest>;
};

export type ApprovalRequest_Aggregate_Bool_Exp = {
  count?: InputMaybe<ApprovalRequest_Aggregate_Bool_Exp_Count>;
};

export type ApprovalRequest_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ApprovalRequest_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApprovalRequest_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "approvals.request" */
export type ApprovalRequest_Aggregate_Fields = {
  __typename?: 'approvalRequest_aggregate_fields';
  avg?: Maybe<ApprovalRequest_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ApprovalRequest_Max_Fields>;
  min?: Maybe<ApprovalRequest_Min_Fields>;
  stddev?: Maybe<ApprovalRequest_Stddev_Fields>;
  stddev_pop?: Maybe<ApprovalRequest_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ApprovalRequest_Stddev_Samp_Fields>;
  sum?: Maybe<ApprovalRequest_Sum_Fields>;
  var_pop?: Maybe<ApprovalRequest_Var_Pop_Fields>;
  var_samp?: Maybe<ApprovalRequest_Var_Samp_Fields>;
  variance?: Maybe<ApprovalRequest_Variance_Fields>;
};


/** aggregate fields of "approvals.request" */
export type ApprovalRequest_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ApprovalRequest_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "approvals.request" */
export type ApprovalRequest_Aggregate_Order_By = {
  avg?: InputMaybe<ApprovalRequest_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ApprovalRequest_Max_Order_By>;
  min?: InputMaybe<ApprovalRequest_Min_Order_By>;
  stddev?: InputMaybe<ApprovalRequest_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ApprovalRequest_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ApprovalRequest_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ApprovalRequest_Sum_Order_By>;
  var_pop?: InputMaybe<ApprovalRequest_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ApprovalRequest_Var_Samp_Order_By>;
  variance?: InputMaybe<ApprovalRequest_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "approvals.request" */
export type ApprovalRequest_Arr_Rel_Insert_Input = {
  data: Array<ApprovalRequest_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ApprovalRequest_On_Conflict>;
};

/** aggregate avg on columns */
export type ApprovalRequest_Avg_Fields = {
  __typename?: 'approvalRequest_avg_fields';
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "approvals.request" */
export type ApprovalRequest_Avg_Order_By = {
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "approvals.request". All fields are combined with a logical 'AND'. */
export type ApprovalRequest_Bool_Exp = {
  _and?: InputMaybe<Array<ApprovalRequest_Bool_Exp>>;
  _not?: InputMaybe<ApprovalRequest_Bool_Exp>;
  _or?: InputMaybe<Array<ApprovalRequest_Bool_Exp>>;
  approval?: InputMaybe<Approval_Bool_Exp>;
  approvalId?: InputMaybe<Uuid_Comparison_Exp>;
  capability?: InputMaybe<Capability_Bool_Exp>;
  capabilityId?: InputMaybe<Uuid_Comparison_Exp>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  decidedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  decidedBy?: InputMaybe<Identity_Bool_Exp>;
  decidedByIdentityId?: InputMaybe<Uuid_Comparison_Exp>;
  denialReason?: InputMaybe<String_Comparison_Exp>;
  gateId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  requestedAmount?: InputMaybe<Numeric_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  subjectId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "approvals.request" */
export enum ApprovalRequest_Constraint {
  /** unique or primary key constraint on columns "identity_id", "subject_id", "capability_id" */
  RequestOnePendingPerSubject = 'request_one_pending_per_subject',
  /** unique or primary key constraint on columns "id" */
  RequestPkey = 'request_pkey'
}

/** input type for incrementing numeric columns in table "approvals.request" */
export type ApprovalRequest_Inc_Input = {
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "approvals.request" */
export type ApprovalRequest_Insert_Input = {
  approval?: InputMaybe<Approval_Obj_Rel_Insert_Input>;
  /** The approvals.approval row decide_request wrote when it was approved — the thing that actually raises the payer's reach. Null unless approved, by the state CHECK. Approving is therefore one write, running through validate_grant like any other grant. */
  approvalId?: InputMaybe<Scalars['uuid']>;
  capability?: InputMaybe<Capability_Obj_Rel_Insert_Input>;
  /** The Capability the requester is asking to act beyond their authority on. Decided against by decide_request, which reads the asker's and the decider's authority for it. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** When it stopped being pending. Null while pending and required once decided, by the same state CHECK. The Answered queue orders on it. */
  decidedAt?: InputMaybe<Scalars['timestamptz']>;
  decidedBy?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  /** Who approved or denied it (logical ref to ory.identity, no FK). Null while pending; the state CHECK requires it once decided. For a cancellation it is the requester, who is the only person allowed to cancel. */
  decidedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** Why it was denied, shown to the payer on the claim. Non-blank is required for a denial and forbidden on any other state, so a pending request has no mutable field a requester could change after an approver has read the queue. */
  denialReason?: InputMaybe<Scalars['String']>;
  /** The Gate the request is measured against, derived from the subject rather than trusted from the caller — same rule as approvals.approval.gate_id, so the Approval decide_request writes lands on the Gate the payment will actually be measured by. */
  gateId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  /** The person asking — the one who would pay (logical ref to ory.identity, no FK). validate_request pins this to the session identity, so a request cannot be raised on someone else's behalf. */
  identityId?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Scalars['numeric']>;
  /** pending, approved, denied or cancelled. Approved carries the approval_id it created; denied carries a required denial_reason; cancelled is the requester withdrawing their own ask and needs no reason. A request whose Approval later stops applying because the subject changed is NOT denied — nobody refused it — and the payer requests again. IT-6672. */
  state?: InputMaybe<Scalars['String']>;
  /** The entity the request is about, as the Gate's subject resolver returns it. Deliberately untyped and carries no FK: subjects live in different tables per Capability. Partial unique index request_one_pending_per_subject keys on it. */
  subjectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ApprovalRequest_Max_Fields = {
  __typename?: 'approvalRequest_max_fields';
  /** The approvals.approval row decide_request wrote when it was approved — the thing that actually raises the payer's reach. Null unless approved, by the state CHECK. Approving is therefore one write, running through validate_grant like any other grant. */
  approvalId?: Maybe<Scalars['uuid']>;
  /** The Capability the requester is asking to act beyond their authority on. Decided against by decide_request, which reads the asker's and the decider's authority for it. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** When it stopped being pending. Null while pending and required once decided, by the same state CHECK. The Answered queue orders on it. */
  decidedAt?: Maybe<Scalars['timestamptz']>;
  /** Who approved or denied it (logical ref to ory.identity, no FK). Null while pending; the state CHECK requires it once decided. For a cancellation it is the requester, who is the only person allowed to cancel. */
  decidedByIdentityId?: Maybe<Scalars['uuid']>;
  /** Why it was denied, shown to the payer on the claim. Non-blank is required for a denial and forbidden on any other state, so a pending request has no mutable field a requester could change after an approver has read the queue. */
  denialReason?: Maybe<Scalars['String']>;
  /** The Gate the request is measured against, derived from the subject rather than trusted from the caller — same rule as approvals.approval.gate_id, so the Approval decide_request writes lands on the Gate the payment will actually be measured by. */
  gateId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The person asking — the one who would pay (logical ref to ory.identity, no FK). validate_request pins this to the session identity, so a request cannot be raised on someone else's behalf. */
  identityId?: Maybe<Scalars['uuid']>;
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: Maybe<Scalars['numeric']>;
  /** pending, approved, denied or cancelled. Approved carries the approval_id it created; denied carries a required denial_reason; cancelled is the requester withdrawing their own ask and needs no reason. A request whose Approval later stops applying because the subject changed is NOT denied — nobody refused it — and the payer requests again. IT-6672. */
  state?: Maybe<Scalars['String']>;
  /** The entity the request is about, as the Gate's subject resolver returns it. Deliberately untyped and carries no FK: subjects live in different tables per Capability. Partial unique index request_one_pending_per_subject keys on it. */
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "approvals.request" */
export type ApprovalRequest_Max_Order_By = {
  /** The approvals.approval row decide_request wrote when it was approved — the thing that actually raises the payer's reach. Null unless approved, by the state CHECK. Approving is therefore one write, running through validate_grant like any other grant. */
  approvalId?: InputMaybe<Order_By>;
  /** The Capability the requester is asking to act beyond their authority on. Decided against by decide_request, which reads the asker's and the decider's authority for it. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** When it stopped being pending. Null while pending and required once decided, by the same state CHECK. The Answered queue orders on it. */
  decidedAt?: InputMaybe<Order_By>;
  /** Who approved or denied it (logical ref to ory.identity, no FK). Null while pending; the state CHECK requires it once decided. For a cancellation it is the requester, who is the only person allowed to cancel. */
  decidedByIdentityId?: InputMaybe<Order_By>;
  /** Why it was denied, shown to the payer on the claim. Non-blank is required for a denial and forbidden on any other state, so a pending request has no mutable field a requester could change after an approver has read the queue. */
  denialReason?: InputMaybe<Order_By>;
  /** The Gate the request is measured against, derived from the subject rather than trusted from the caller — same rule as approvals.approval.gate_id, so the Approval decide_request writes lands on the Gate the payment will actually be measured by. */
  gateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The person asking — the one who would pay (logical ref to ory.identity, no FK). validate_request pins this to the session identity, so a request cannot be raised on someone else's behalf. */
  identityId?: InputMaybe<Order_By>;
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Order_By>;
  /** pending, approved, denied or cancelled. Approved carries the approval_id it created; denied carries a required denial_reason; cancelled is the requester withdrawing their own ask and needs no reason. A request whose Approval later stops applying because the subject changed is NOT denied — nobody refused it — and the payer requests again. IT-6672. */
  state?: InputMaybe<Order_By>;
  /** The entity the request is about, as the Gate's subject resolver returns it. Deliberately untyped and carries no FK: subjects live in different tables per Capability. Partial unique index request_one_pending_per_subject keys on it. */
  subjectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ApprovalRequest_Min_Fields = {
  __typename?: 'approvalRequest_min_fields';
  /** The approvals.approval row decide_request wrote when it was approved — the thing that actually raises the payer's reach. Null unless approved, by the state CHECK. Approving is therefore one write, running through validate_grant like any other grant. */
  approvalId?: Maybe<Scalars['uuid']>;
  /** The Capability the requester is asking to act beyond their authority on. Decided against by decide_request, which reads the asker's and the decider's authority for it. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** When it stopped being pending. Null while pending and required once decided, by the same state CHECK. The Answered queue orders on it. */
  decidedAt?: Maybe<Scalars['timestamptz']>;
  /** Who approved or denied it (logical ref to ory.identity, no FK). Null while pending; the state CHECK requires it once decided. For a cancellation it is the requester, who is the only person allowed to cancel. */
  decidedByIdentityId?: Maybe<Scalars['uuid']>;
  /** Why it was denied, shown to the payer on the claim. Non-blank is required for a denial and forbidden on any other state, so a pending request has no mutable field a requester could change after an approver has read the queue. */
  denialReason?: Maybe<Scalars['String']>;
  /** The Gate the request is measured against, derived from the subject rather than trusted from the caller — same rule as approvals.approval.gate_id, so the Approval decide_request writes lands on the Gate the payment will actually be measured by. */
  gateId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The person asking — the one who would pay (logical ref to ory.identity, no FK). validate_request pins this to the session identity, so a request cannot be raised on someone else's behalf. */
  identityId?: Maybe<Scalars['uuid']>;
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: Maybe<Scalars['numeric']>;
  /** pending, approved, denied or cancelled. Approved carries the approval_id it created; denied carries a required denial_reason; cancelled is the requester withdrawing their own ask and needs no reason. A request whose Approval later stops applying because the subject changed is NOT denied — nobody refused it — and the payer requests again. IT-6672. */
  state?: Maybe<Scalars['String']>;
  /** The entity the request is about, as the Gate's subject resolver returns it. Deliberately untyped and carries no FK: subjects live in different tables per Capability. Partial unique index request_one_pending_per_subject keys on it. */
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "approvals.request" */
export type ApprovalRequest_Min_Order_By = {
  /** The approvals.approval row decide_request wrote when it was approved — the thing that actually raises the payer's reach. Null unless approved, by the state CHECK. Approving is therefore one write, running through validate_grant like any other grant. */
  approvalId?: InputMaybe<Order_By>;
  /** The Capability the requester is asking to act beyond their authority on. Decided against by decide_request, which reads the asker's and the decider's authority for it. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** When it stopped being pending. Null while pending and required once decided, by the same state CHECK. The Answered queue orders on it. */
  decidedAt?: InputMaybe<Order_By>;
  /** Who approved or denied it (logical ref to ory.identity, no FK). Null while pending; the state CHECK requires it once decided. For a cancellation it is the requester, who is the only person allowed to cancel. */
  decidedByIdentityId?: InputMaybe<Order_By>;
  /** Why it was denied, shown to the payer on the claim. Non-blank is required for a denial and forbidden on any other state, so a pending request has no mutable field a requester could change after an approver has read the queue. */
  denialReason?: InputMaybe<Order_By>;
  /** The Gate the request is measured against, derived from the subject rather than trusted from the caller — same rule as approvals.approval.gate_id, so the Approval decide_request writes lands on the Gate the payment will actually be measured by. */
  gateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The person asking — the one who would pay (logical ref to ory.identity, no FK). validate_request pins this to the session identity, so a request cannot be raised on someone else's behalf. */
  identityId?: InputMaybe<Order_By>;
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Order_By>;
  /** pending, approved, denied or cancelled. Approved carries the approval_id it created; denied carries a required denial_reason; cancelled is the requester withdrawing their own ask and needs no reason. A request whose Approval later stops applying because the subject changed is NOT denied — nobody refused it — and the payer requests again. IT-6672. */
  state?: InputMaybe<Order_By>;
  /** The entity the request is about, as the Gate's subject resolver returns it. Deliberately untyped and carries no FK: subjects live in different tables per Capability. Partial unique index request_one_pending_per_subject keys on it. */
  subjectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "approvals.request" */
export type ApprovalRequest_Mutation_Response = {
  __typename?: 'approvalRequest_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApprovalRequest>;
};

/** on_conflict condition type for table "approvals.request" */
export type ApprovalRequest_On_Conflict = {
  constraint: ApprovalRequest_Constraint;
  update_columns?: Array<ApprovalRequest_Update_Column>;
  where?: InputMaybe<ApprovalRequest_Bool_Exp>;
};

/** Ordering options when selecting data from "approvals.request". */
export type ApprovalRequest_Order_By = {
  approval?: InputMaybe<Approval_Order_By>;
  approvalId?: InputMaybe<Order_By>;
  capability?: InputMaybe<Capability_Order_By>;
  capabilityId?: InputMaybe<Order_By>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  decidedAt?: InputMaybe<Order_By>;
  decidedBy?: InputMaybe<Identity_Order_By>;
  decidedByIdentityId?: InputMaybe<Order_By>;
  denialReason?: InputMaybe<Order_By>;
  gateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityId?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  requestedAmount?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  subjectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: approvals.request */
export type ApprovalRequest_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "approvals.request" */
export enum ApprovalRequest_Select_Column {
  /** column name */
  ApprovalId = 'approvalId',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DecidedAt = 'decidedAt',
  /** column name */
  DecidedByIdentityId = 'decidedByIdentityId',
  /** column name */
  DenialReason = 'denialReason',
  /** column name */
  GateId = 'gateId',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  RequestedAmount = 'requestedAmount',
  /** column name */
  State = 'state',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "approvals.request" */
export type ApprovalRequest_Set_Input = {
  /** The approvals.approval row decide_request wrote when it was approved — the thing that actually raises the payer's reach. Null unless approved, by the state CHECK. Approving is therefore one write, running through validate_grant like any other grant. */
  approvalId?: InputMaybe<Scalars['uuid']>;
  /** The Capability the requester is asking to act beyond their authority on. Decided against by decide_request, which reads the asker's and the decider's authority for it. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** When it stopped being pending. Null while pending and required once decided, by the same state CHECK. The Answered queue orders on it. */
  decidedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Who approved or denied it (logical ref to ory.identity, no FK). Null while pending; the state CHECK requires it once decided. For a cancellation it is the requester, who is the only person allowed to cancel. */
  decidedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** Why it was denied, shown to the payer on the claim. Non-blank is required for a denial and forbidden on any other state, so a pending request has no mutable field a requester could change after an approver has read the queue. */
  denialReason?: InputMaybe<Scalars['String']>;
  /** The Gate the request is measured against, derived from the subject rather than trusted from the caller — same rule as approvals.approval.gate_id, so the Approval decide_request writes lands on the Gate the payment will actually be measured by. */
  gateId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The person asking — the one who would pay (logical ref to ory.identity, no FK). validate_request pins this to the session identity, so a request cannot be raised on someone else's behalf. */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Scalars['numeric']>;
  /** pending, approved, denied or cancelled. Approved carries the approval_id it created; denied carries a required denial_reason; cancelled is the requester withdrawing their own ask and needs no reason. A request whose Approval later stops applying because the subject changed is NOT denied — nobody refused it — and the payer requests again. IT-6672. */
  state?: InputMaybe<Scalars['String']>;
  /** The entity the request is about, as the Gate's subject resolver returns it. Deliberately untyped and carries no FK: subjects live in different tables per Capability. Partial unique index request_one_pending_per_subject keys on it. */
  subjectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ApprovalRequest_Stddev_Fields = {
  __typename?: 'approvalRequest_stddev_fields';
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "approvals.request" */
export type ApprovalRequest_Stddev_Order_By = {
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ApprovalRequest_Stddev_Pop_Fields = {
  __typename?: 'approvalRequest_stddev_pop_fields';
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "approvals.request" */
export type ApprovalRequest_Stddev_Pop_Order_By = {
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ApprovalRequest_Stddev_Samp_Fields = {
  __typename?: 'approvalRequest_stddev_samp_fields';
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "approvals.request" */
export type ApprovalRequest_Stddev_Samp_Order_By = {
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "approvalRequest" */
export type ApprovalRequest_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ApprovalRequest_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ApprovalRequest_Stream_Cursor_Value_Input = {
  /** The approvals.approval row decide_request wrote when it was approved — the thing that actually raises the payer's reach. Null unless approved, by the state CHECK. Approving is therefore one write, running through validate_grant like any other grant. */
  approvalId?: InputMaybe<Scalars['uuid']>;
  /** The Capability the requester is asking to act beyond their authority on. Decided against by decide_request, which reads the asker's and the decider's authority for it. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** When it stopped being pending. Null while pending and required once decided, by the same state CHECK. The Answered queue orders on it. */
  decidedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Who approved or denied it (logical ref to ory.identity, no FK). Null while pending; the state CHECK requires it once decided. For a cancellation it is the requester, who is the only person allowed to cancel. */
  decidedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** Why it was denied, shown to the payer on the claim. Non-blank is required for a denial and forbidden on any other state, so a pending request has no mutable field a requester could change after an approver has read the queue. */
  denialReason?: InputMaybe<Scalars['String']>;
  /** The Gate the request is measured against, derived from the subject rather than trusted from the caller — same rule as approvals.approval.gate_id, so the Approval decide_request writes lands on the Gate the payment will actually be measured by. */
  gateId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The person asking — the one who would pay (logical ref to ory.identity, no FK). validate_request pins this to the session identity, so a request cannot be raised on someone else's behalf. */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Scalars['numeric']>;
  /** pending, approved, denied or cancelled. Approved carries the approval_id it created; denied carries a required denial_reason; cancelled is the requester withdrawing their own ask and needs no reason. A request whose Approval later stops applying because the subject changed is NOT denied — nobody refused it — and the payer requests again. IT-6672. */
  state?: InputMaybe<Scalars['String']>;
  /** The entity the request is about, as the Gate's subject resolver returns it. Deliberately untyped and carries no FK: subjects live in different tables per Capability. Partial unique index request_one_pending_per_subject keys on it. */
  subjectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ApprovalRequest_Sum_Fields = {
  __typename?: 'approvalRequest_sum_fields';
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "approvals.request" */
export type ApprovalRequest_Sum_Order_By = {
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Order_By>;
};

/** update columns of table "approvals.request" */
export enum ApprovalRequest_Update_Column {
  /** column name */
  ApprovalId = 'approvalId',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DecidedAt = 'decidedAt',
  /** column name */
  DecidedByIdentityId = 'decidedByIdentityId',
  /** column name */
  DenialReason = 'denialReason',
  /** column name */
  GateId = 'gateId',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  RequestedAmount = 'requestedAmount',
  /** column name */
  State = 'state',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ApprovalRequest_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ApprovalRequest_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApprovalRequest_Set_Input>;
  /** filter the rows which have to be updated */
  where: ApprovalRequest_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ApprovalRequest_Var_Pop_Fields = {
  __typename?: 'approvalRequest_var_pop_fields';
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "approvals.request" */
export type ApprovalRequest_Var_Pop_Order_By = {
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ApprovalRequest_Var_Samp_Fields = {
  __typename?: 'approvalRequest_var_samp_fields';
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "approvals.request" */
export type ApprovalRequest_Var_Samp_Order_By = {
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ApprovalRequest_Variance_Fields = {
  __typename?: 'approvalRequest_variance_fields';
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "approvals.request" */
export type ApprovalRequest_Variance_Order_By = {
  /** What the payment would submit, not the subject total — asking for more escalates the request past approvers entitled to answer it. IT-6672. */
  requestedAmount?: InputMaybe<Order_By>;
};

/** Result shape only — NEVER populated, and nothing may insert into it. Describes whether one identity may act on one entity for one Capability: their own reach, and the best Approval covering them there. A table rather than a composite type so approvals.headroom can return SETOF it and Hasura can type the result. IT-6672. */
export type ApprovalState = {
  __typename?: 'approvalState';
  /** shared.type.name of the applicable Gate's ApprovalTrigger — OverLimit or Always. Null means no Gate applies, which permits() reads as ungated: permission alone decides. */
  approvalTrigger?: Maybe<Scalars['String']>;
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['numeric']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['numeric']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['numeric']>;
  /** The Capability this state was resolved for. Null when the Capability does not exist, which is how resolve_state reports "no such Capability" rather than returning a permissive default. */
  capabilityId?: Maybe<Scalars['uuid']>;
  /** auth.capability.name, so a caller can key on the Capability without a second read. The UI matches on this to find the state for the control it is drawing. */
  capabilityName?: Maybe<Scalars['String']>;
  /** What to call that Gate in a message — its own display, else the Capability's. */
  gateDisplay?: Maybe<Scalars['String']>;
  /** The Gate that governs this attempt, resolved from the subject. Null when the Capability is ungated. */
  gateId?: Maybe<Scalars['uuid']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['numeric']>;
  /** Whether any live Approval covers this identity on this entity (under Always, one whose material_hash still matches). */
  hasApproval?: Maybe<Scalars['Boolean']>;
  /** False when nobody has configured this identity for this Capability. Lets the UI say "not configured" rather than "capped at zero" — different messages, and the first is what generates support calls at go-live. */
  hasAuthorityRow?: Maybe<Scalars['Boolean']>;
  /** True when the identity holds an authority row with unlimited reach. Distinguishes "unlimited" from "no row", which both leave authority looking empty in different ways. */
  isUnlimited?: Maybe<Scalars['Boolean']>;
  /** Whether the gate's precondition holds for this subject (see approvals.gate.precondition_name). True when the gate declares none. False blocks the action outright whatever the actor's authority — which is what lets the UI say "this repair has no valid authorization" rather than "you need a bigger limit". */
  preconditionMet?: Maybe<Scalars['Boolean']>;
  /** Whether this identity may grant Approvals for this Capability — used to decide whether to offer approving to them, not whether they may act. */
  viewerCanApprove?: Maybe<Scalars['Boolean']>;
};

export type ApprovalState_Aggregate = {
  __typename?: 'approvalState_aggregate';
  aggregate?: Maybe<ApprovalState_Aggregate_Fields>;
  nodes: Array<ApprovalState>;
};

/** aggregate fields of "approvals.state" */
export type ApprovalState_Aggregate_Fields = {
  __typename?: 'approvalState_aggregate_fields';
  avg?: Maybe<ApprovalState_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ApprovalState_Max_Fields>;
  min?: Maybe<ApprovalState_Min_Fields>;
  stddev?: Maybe<ApprovalState_Stddev_Fields>;
  stddev_pop?: Maybe<ApprovalState_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ApprovalState_Stddev_Samp_Fields>;
  sum?: Maybe<ApprovalState_Sum_Fields>;
  var_pop?: Maybe<ApprovalState_Var_Pop_Fields>;
  var_samp?: Maybe<ApprovalState_Var_Samp_Fields>;
  variance?: Maybe<ApprovalState_Variance_Fields>;
};


/** aggregate fields of "approvals.state" */
export type ApprovalState_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ApprovalState_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ApprovalState_Avg_Fields = {
  __typename?: 'approvalState_avg_fields';
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['Float']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "approvals.state". All fields are combined with a logical 'AND'. */
export type ApprovalState_Bool_Exp = {
  _and?: InputMaybe<Array<ApprovalState_Bool_Exp>>;
  _not?: InputMaybe<ApprovalState_Bool_Exp>;
  _or?: InputMaybe<Array<ApprovalState_Bool_Exp>>;
  approvalTrigger?: InputMaybe<String_Comparison_Exp>;
  authority?: InputMaybe<Numeric_Comparison_Exp>;
  authorityMax?: InputMaybe<Numeric_Comparison_Exp>;
  authorityMin?: InputMaybe<Numeric_Comparison_Exp>;
  capabilityId?: InputMaybe<Uuid_Comparison_Exp>;
  capabilityName?: InputMaybe<String_Comparison_Exp>;
  gateDisplay?: InputMaybe<String_Comparison_Exp>;
  gateId?: InputMaybe<Uuid_Comparison_Exp>;
  grantedAuthority?: InputMaybe<Numeric_Comparison_Exp>;
  hasApproval?: InputMaybe<Boolean_Comparison_Exp>;
  hasAuthorityRow?: InputMaybe<Boolean_Comparison_Exp>;
  isUnlimited?: InputMaybe<Boolean_Comparison_Exp>;
  preconditionMet?: InputMaybe<Boolean_Comparison_Exp>;
  viewerCanApprove?: InputMaybe<Boolean_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "approvals.state" */
export type ApprovalState_Inc_Input = {
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: InputMaybe<Scalars['numeric']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: InputMaybe<Scalars['numeric']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: InputMaybe<Scalars['numeric']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "approvals.state" */
export type ApprovalState_Insert_Input = {
  /** shared.type.name of the applicable Gate's ApprovalTrigger — OverLimit or Always. Null means no Gate applies, which permits() reads as ungated: permission alone decides. */
  approvalTrigger?: InputMaybe<Scalars['String']>;
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: InputMaybe<Scalars['numeric']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: InputMaybe<Scalars['numeric']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: InputMaybe<Scalars['numeric']>;
  /** The Capability this state was resolved for. Null when the Capability does not exist, which is how resolve_state reports "no such Capability" rather than returning a permissive default. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  /** auth.capability.name, so a caller can key on the Capability without a second read. The UI matches on this to find the state for the control it is drawing. */
  capabilityName?: InputMaybe<Scalars['String']>;
  /** What to call that Gate in a message — its own display, else the Capability's. */
  gateDisplay?: InputMaybe<Scalars['String']>;
  /** The Gate that governs this attempt, resolved from the subject. Null when the Capability is ungated. */
  gateId?: InputMaybe<Scalars['uuid']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: InputMaybe<Scalars['numeric']>;
  /** Whether any live Approval covers this identity on this entity (under Always, one whose material_hash still matches). */
  hasApproval?: InputMaybe<Scalars['Boolean']>;
  /** False when nobody has configured this identity for this Capability. Lets the UI say "not configured" rather than "capped at zero" — different messages, and the first is what generates support calls at go-live. */
  hasAuthorityRow?: InputMaybe<Scalars['Boolean']>;
  /** True when the identity holds an authority row with unlimited reach. Distinguishes "unlimited" from "no row", which both leave authority looking empty in different ways. */
  isUnlimited?: InputMaybe<Scalars['Boolean']>;
  /** Whether the gate's precondition holds for this subject (see approvals.gate.precondition_name). True when the gate declares none. False blocks the action outright whatever the actor's authority — which is what lets the UI say "this repair has no valid authorization" rather than "you need a bigger limit". */
  preconditionMet?: InputMaybe<Scalars['Boolean']>;
  /** Whether this identity may grant Approvals for this Capability — used to decide whether to offer approving to them, not whether they may act. */
  viewerCanApprove?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type ApprovalState_Max_Fields = {
  __typename?: 'approvalState_max_fields';
  /** shared.type.name of the applicable Gate's ApprovalTrigger — OverLimit or Always. Null means no Gate applies, which permits() reads as ungated: permission alone decides. */
  approvalTrigger?: Maybe<Scalars['String']>;
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['numeric']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['numeric']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['numeric']>;
  /** The Capability this state was resolved for. Null when the Capability does not exist, which is how resolve_state reports "no such Capability" rather than returning a permissive default. */
  capabilityId?: Maybe<Scalars['uuid']>;
  /** auth.capability.name, so a caller can key on the Capability without a second read. The UI matches on this to find the state for the control it is drawing. */
  capabilityName?: Maybe<Scalars['String']>;
  /** What to call that Gate in a message — its own display, else the Capability's. */
  gateDisplay?: Maybe<Scalars['String']>;
  /** The Gate that governs this attempt, resolved from the subject. Null when the Capability is ungated. */
  gateId?: Maybe<Scalars['uuid']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type ApprovalState_Min_Fields = {
  __typename?: 'approvalState_min_fields';
  /** shared.type.name of the applicable Gate's ApprovalTrigger — OverLimit or Always. Null means no Gate applies, which permits() reads as ungated: permission alone decides. */
  approvalTrigger?: Maybe<Scalars['String']>;
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['numeric']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['numeric']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['numeric']>;
  /** The Capability this state was resolved for. Null when the Capability does not exist, which is how resolve_state reports "no such Capability" rather than returning a permissive default. */
  capabilityId?: Maybe<Scalars['uuid']>;
  /** auth.capability.name, so a caller can key on the Capability without a second read. The UI matches on this to find the state for the control it is drawing. */
  capabilityName?: Maybe<Scalars['String']>;
  /** What to call that Gate in a message — its own display, else the Capability's. */
  gateDisplay?: Maybe<Scalars['String']>;
  /** The Gate that governs this attempt, resolved from the subject. Null when the Capability is ungated. */
  gateId?: Maybe<Scalars['uuid']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "approvals.state" */
export type ApprovalState_Mutation_Response = {
  __typename?: 'approvalState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApprovalState>;
};

/** Ordering options when selecting data from "approvals.state". */
export type ApprovalState_Order_By = {
  approvalTrigger?: InputMaybe<Order_By>;
  authority?: InputMaybe<Order_By>;
  authorityMax?: InputMaybe<Order_By>;
  authorityMin?: InputMaybe<Order_By>;
  capabilityId?: InputMaybe<Order_By>;
  capabilityName?: InputMaybe<Order_By>;
  gateDisplay?: InputMaybe<Order_By>;
  gateId?: InputMaybe<Order_By>;
  grantedAuthority?: InputMaybe<Order_By>;
  hasApproval?: InputMaybe<Order_By>;
  hasAuthorityRow?: InputMaybe<Order_By>;
  isUnlimited?: InputMaybe<Order_By>;
  preconditionMet?: InputMaybe<Order_By>;
  viewerCanApprove?: InputMaybe<Order_By>;
};

/** select columns of table "approvals.state" */
export enum ApprovalState_Select_Column {
  /** column name */
  ApprovalTrigger = 'approvalTrigger',
  /** column name */
  Authority = 'authority',
  /** column name */
  AuthorityMax = 'authorityMax',
  /** column name */
  AuthorityMin = 'authorityMin',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CapabilityName = 'capabilityName',
  /** column name */
  GateDisplay = 'gateDisplay',
  /** column name */
  GateId = 'gateId',
  /** column name */
  GrantedAuthority = 'grantedAuthority',
  /** column name */
  HasApproval = 'hasApproval',
  /** column name */
  HasAuthorityRow = 'hasAuthorityRow',
  /** column name */
  IsUnlimited = 'isUnlimited',
  /** column name */
  PreconditionMet = 'preconditionMet',
  /** column name */
  ViewerCanApprove = 'viewerCanApprove'
}

/** input type for updating data in table "approvals.state" */
export type ApprovalState_Set_Input = {
  /** shared.type.name of the applicable Gate's ApprovalTrigger — OverLimit or Always. Null means no Gate applies, which permits() reads as ungated: permission alone decides. */
  approvalTrigger?: InputMaybe<Scalars['String']>;
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: InputMaybe<Scalars['numeric']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: InputMaybe<Scalars['numeric']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: InputMaybe<Scalars['numeric']>;
  /** The Capability this state was resolved for. Null when the Capability does not exist, which is how resolve_state reports "no such Capability" rather than returning a permissive default. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  /** auth.capability.name, so a caller can key on the Capability without a second read. The UI matches on this to find the state for the control it is drawing. */
  capabilityName?: InputMaybe<Scalars['String']>;
  /** What to call that Gate in a message — its own display, else the Capability's. */
  gateDisplay?: InputMaybe<Scalars['String']>;
  /** The Gate that governs this attempt, resolved from the subject. Null when the Capability is ungated. */
  gateId?: InputMaybe<Scalars['uuid']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: InputMaybe<Scalars['numeric']>;
  /** Whether any live Approval covers this identity on this entity (under Always, one whose material_hash still matches). */
  hasApproval?: InputMaybe<Scalars['Boolean']>;
  /** False when nobody has configured this identity for this Capability. Lets the UI say "not configured" rather than "capped at zero" — different messages, and the first is what generates support calls at go-live. */
  hasAuthorityRow?: InputMaybe<Scalars['Boolean']>;
  /** True when the identity holds an authority row with unlimited reach. Distinguishes "unlimited" from "no row", which both leave authority looking empty in different ways. */
  isUnlimited?: InputMaybe<Scalars['Boolean']>;
  /** Whether the gate's precondition holds for this subject (see approvals.gate.precondition_name). True when the gate declares none. False blocks the action outright whatever the actor's authority — which is what lets the UI say "this repair has no valid authorization" rather than "you need a bigger limit". */
  preconditionMet?: InputMaybe<Scalars['Boolean']>;
  /** Whether this identity may grant Approvals for this Capability — used to decide whether to offer approving to them, not whether they may act. */
  viewerCanApprove?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type ApprovalState_Stddev_Fields = {
  __typename?: 'approvalState_stddev_fields';
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['Float']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ApprovalState_Stddev_Pop_Fields = {
  __typename?: 'approvalState_stddev_pop_fields';
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['Float']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ApprovalState_Stddev_Samp_Fields = {
  __typename?: 'approvalState_stddev_samp_fields';
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['Float']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "approvalState" */
export type ApprovalState_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ApprovalState_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ApprovalState_Stream_Cursor_Value_Input = {
  /** shared.type.name of the applicable Gate's ApprovalTrigger — OverLimit or Always. Null means no Gate applies, which permits() reads as ungated: permission alone decides. */
  approvalTrigger?: InputMaybe<Scalars['String']>;
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: InputMaybe<Scalars['numeric']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: InputMaybe<Scalars['numeric']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: InputMaybe<Scalars['numeric']>;
  /** The Capability this state was resolved for. Null when the Capability does not exist, which is how resolve_state reports "no such Capability" rather than returning a permissive default. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  /** auth.capability.name, so a caller can key on the Capability without a second read. The UI matches on this to find the state for the control it is drawing. */
  capabilityName?: InputMaybe<Scalars['String']>;
  /** What to call that Gate in a message — its own display, else the Capability's. */
  gateDisplay?: InputMaybe<Scalars['String']>;
  /** The Gate that governs this attempt, resolved from the subject. Null when the Capability is ungated. */
  gateId?: InputMaybe<Scalars['uuid']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: InputMaybe<Scalars['numeric']>;
  /** Whether any live Approval covers this identity on this entity (under Always, one whose material_hash still matches). */
  hasApproval?: InputMaybe<Scalars['Boolean']>;
  /** False when nobody has configured this identity for this Capability. Lets the UI say "not configured" rather than "capped at zero" — different messages, and the first is what generates support calls at go-live. */
  hasAuthorityRow?: InputMaybe<Scalars['Boolean']>;
  /** True when the identity holds an authority row with unlimited reach. Distinguishes "unlimited" from "no row", which both leave authority looking empty in different ways. */
  isUnlimited?: InputMaybe<Scalars['Boolean']>;
  /** Whether the gate's precondition holds for this subject (see approvals.gate.precondition_name). True when the gate declares none. False blocks the action outright whatever the actor's authority — which is what lets the UI say "this repair has no valid authorization" rather than "you need a bigger limit". */
  preconditionMet?: InputMaybe<Scalars['Boolean']>;
  /** Whether this identity may grant Approvals for this Capability — used to decide whether to offer approving to them, not whether they may act. */
  viewerCanApprove?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type ApprovalState_Sum_Fields = {
  __typename?: 'approvalState_sum_fields';
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['numeric']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['numeric']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['numeric']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['numeric']>;
};

export type ApprovalState_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ApprovalState_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApprovalState_Set_Input>;
  /** filter the rows which have to be updated */
  where: ApprovalState_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ApprovalState_Var_Pop_Fields = {
  __typename?: 'approvalState_var_pop_fields';
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['Float']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ApprovalState_Var_Samp_Fields = {
  __typename?: 'approvalState_var_samp_fields';
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['Float']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ApprovalState_Variance_Fields = {
  __typename?: 'approvalState_variance_fields';
  /** The acting identity's own reach. 0 when they have no authority row (deny by default); NULL when unlimited — read is_unlimited rather than treating NULL as zero. */
  authority?: Maybe<Scalars['Float']>;
  /** Upper bound of the resolved range authority, inclusive. NULL on amount gates. */
  authorityMax?: Maybe<Scalars['Float']>;
  /** Lower bound of the resolved range authority. NULL on amount (OverLimit) gates. */
  authorityMin?: Maybe<Scalars['Float']>;
  /** Cap of the best live Approval covering this identity on this entity; NULL when there is none, or under Always where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "approvals.approval" */
export type Approval_Aggregate = {
  __typename?: 'approval_aggregate';
  aggregate?: Maybe<Approval_Aggregate_Fields>;
  nodes: Array<Approval>;
};

export type Approval_Aggregate_Bool_Exp = {
  count?: InputMaybe<Approval_Aggregate_Bool_Exp_Count>;
};

export type Approval_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Approval_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Approval_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "approvals.approval" */
export type Approval_Aggregate_Fields = {
  __typename?: 'approval_aggregate_fields';
  avg?: Maybe<Approval_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Approval_Max_Fields>;
  min?: Maybe<Approval_Min_Fields>;
  stddev?: Maybe<Approval_Stddev_Fields>;
  stddev_pop?: Maybe<Approval_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Approval_Stddev_Samp_Fields>;
  sum?: Maybe<Approval_Sum_Fields>;
  var_pop?: Maybe<Approval_Var_Pop_Fields>;
  var_samp?: Maybe<Approval_Var_Samp_Fields>;
  variance?: Maybe<Approval_Variance_Fields>;
};


/** aggregate fields of "approvals.approval" */
export type Approval_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Approval_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "approvals.approval" */
export type Approval_Aggregate_Order_By = {
  avg?: InputMaybe<Approval_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Approval_Max_Order_By>;
  min?: InputMaybe<Approval_Min_Order_By>;
  stddev?: InputMaybe<Approval_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Approval_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Approval_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Approval_Sum_Order_By>;
  var_pop?: InputMaybe<Approval_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Approval_Var_Samp_Order_By>;
  variance?: InputMaybe<Approval_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "approvals.approval" */
export type Approval_Arr_Rel_Insert_Input = {
  data: Array<Approval_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Approval_On_Conflict>;
};

/** aggregate avg on columns */
export type Approval_Avg_Fields = {
  __typename?: 'approval_avg_fields';
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "approvals.approval" */
export type Approval_Avg_Order_By = {
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "approvals.approval". All fields are combined with a logical 'AND'. */
export type Approval_Bool_Exp = {
  _and?: InputMaybe<Array<Approval_Bool_Exp>>;
  _not?: InputMaybe<Approval_Bool_Exp>;
  _or?: InputMaybe<Array<Approval_Bool_Exp>>;
  approver?: InputMaybe<Identity_Bool_Exp>;
  approverIdentityId?: InputMaybe<Uuid_Comparison_Exp>;
  capability?: InputMaybe<Capability_Bool_Exp>;
  capabilityId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  gateId?: InputMaybe<Uuid_Comparison_Exp>;
  grantedAuthority?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  materialHash?: InputMaybe<String_Comparison_Exp>;
  revokedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  subjectId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "approvals.approval" */
export enum Approval_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApprovalPkey = 'approval_pkey'
}

/** input type for incrementing numeric columns in table "approvals.approval" */
export type Approval_Inc_Input = {
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "approvals.approval" */
export type Approval_Insert_Input = {
  approver?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  /** The Approver who granted this (logical ref to ory.identity). With granted_authority this is the audit record: who authorized what, and up to how much. */
  approverIdentityId?: InputMaybe<Scalars['uuid']>;
  capability?: InputMaybe<Capability_Obj_Rel_Insert_Input>;
  /** The Capability this Approval authorizes. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Gate this Approval was granted against, set by validate_grant from the subject rather than trusted from the caller. Null applies to the Capability as a whole, which is what an Approval granted before this column existed means. IT-6672. */
  gateId?: InputMaybe<Scalars['uuid']>;
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  /** The acting identity whose authority is raised (logical ref to ory.identity). An Approval on one entity grants nothing on any other — this is what distinguishes it from a Validation Override. */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Under Always: hash of the subject's material fields when granted. A mismatch means the entity changed after approval and the Approval no longer applies. Set by the validating trigger, never trusted from the caller. */
  materialHash?: InputMaybe<Scalars['String']>;
  /** When this Approval was withdrawn; NULL means it still stands. Revoking never deletes — the record of the original decision is kept. */
  revokedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The entity this Approval applies to, as returned by the gate's subject resolver. Deliberately untyped: subjects live in different tables per Capability. */
  subjectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Approval_Max_Fields = {
  __typename?: 'approval_max_fields';
  /** The Approver who granted this (logical ref to ory.identity). With granted_authority this is the audit record: who authorized what, and up to how much. */
  approverIdentityId?: Maybe<Scalars['uuid']>;
  /** The Capability this Approval authorizes. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The Gate this Approval was granted against, set by validate_grant from the subject rather than trusted from the caller. Null applies to the Capability as a whole, which is what an Approval granted before this column existed means. IT-6672. */
  gateId?: Maybe<Scalars['uuid']>;
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  /** The acting identity whose authority is raised (logical ref to ory.identity). An Approval on one entity grants nothing on any other — this is what distinguishes it from a Validation Override. */
  identityId?: Maybe<Scalars['uuid']>;
  /** Under Always: hash of the subject's material fields when granted. A mismatch means the entity changed after approval and the Approval no longer applies. Set by the validating trigger, never trusted from the caller. */
  materialHash?: Maybe<Scalars['String']>;
  /** When this Approval was withdrawn; NULL means it still stands. Revoking never deletes — the record of the original decision is kept. */
  revokedAt?: Maybe<Scalars['timestamptz']>;
  /** The entity this Approval applies to, as returned by the gate's subject resolver. Deliberately untyped: subjects live in different tables per Capability. */
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "approvals.approval" */
export type Approval_Max_Order_By = {
  /** The Approver who granted this (logical ref to ory.identity). With granted_authority this is the audit record: who authorized what, and up to how much. */
  approverIdentityId?: InputMaybe<Order_By>;
  /** The Capability this Approval authorizes. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** The Gate this Approval was granted against, set by validate_grant from the subject rather than trusted from the caller. Null applies to the Capability as a whole, which is what an Approval granted before this column existed means. IT-6672. */
  gateId?: InputMaybe<Order_By>;
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The acting identity whose authority is raised (logical ref to ory.identity). An Approval on one entity grants nothing on any other — this is what distinguishes it from a Validation Override. */
  identityId?: InputMaybe<Order_By>;
  /** Under Always: hash of the subject's material fields when granted. A mismatch means the entity changed after approval and the Approval no longer applies. Set by the validating trigger, never trusted from the caller. */
  materialHash?: InputMaybe<Order_By>;
  /** When this Approval was withdrawn; NULL means it still stands. Revoking never deletes — the record of the original decision is kept. */
  revokedAt?: InputMaybe<Order_By>;
  /** The entity this Approval applies to, as returned by the gate's subject resolver. Deliberately untyped: subjects live in different tables per Capability. */
  subjectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Approval_Min_Fields = {
  __typename?: 'approval_min_fields';
  /** The Approver who granted this (logical ref to ory.identity). With granted_authority this is the audit record: who authorized what, and up to how much. */
  approverIdentityId?: Maybe<Scalars['uuid']>;
  /** The Capability this Approval authorizes. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The Gate this Approval was granted against, set by validate_grant from the subject rather than trusted from the caller. Null applies to the Capability as a whole, which is what an Approval granted before this column existed means. IT-6672. */
  gateId?: Maybe<Scalars['uuid']>;
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  /** The acting identity whose authority is raised (logical ref to ory.identity). An Approval on one entity grants nothing on any other — this is what distinguishes it from a Validation Override. */
  identityId?: Maybe<Scalars['uuid']>;
  /** Under Always: hash of the subject's material fields when granted. A mismatch means the entity changed after approval and the Approval no longer applies. Set by the validating trigger, never trusted from the caller. */
  materialHash?: Maybe<Scalars['String']>;
  /** When this Approval was withdrawn; NULL means it still stands. Revoking never deletes — the record of the original decision is kept. */
  revokedAt?: Maybe<Scalars['timestamptz']>;
  /** The entity this Approval applies to, as returned by the gate's subject resolver. Deliberately untyped: subjects live in different tables per Capability. */
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "approvals.approval" */
export type Approval_Min_Order_By = {
  /** The Approver who granted this (logical ref to ory.identity). With granted_authority this is the audit record: who authorized what, and up to how much. */
  approverIdentityId?: InputMaybe<Order_By>;
  /** The Capability this Approval authorizes. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** The Gate this Approval was granted against, set by validate_grant from the subject rather than trusted from the caller. Null applies to the Capability as a whole, which is what an Approval granted before this column existed means. IT-6672. */
  gateId?: InputMaybe<Order_By>;
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The acting identity whose authority is raised (logical ref to ory.identity). An Approval on one entity grants nothing on any other — this is what distinguishes it from a Validation Override. */
  identityId?: InputMaybe<Order_By>;
  /** Under Always: hash of the subject's material fields when granted. A mismatch means the entity changed after approval and the Approval no longer applies. Set by the validating trigger, never trusted from the caller. */
  materialHash?: InputMaybe<Order_By>;
  /** When this Approval was withdrawn; NULL means it still stands. Revoking never deletes — the record of the original decision is kept. */
  revokedAt?: InputMaybe<Order_By>;
  /** The entity this Approval applies to, as returned by the gate's subject resolver. Deliberately untyped: subjects live in different tables per Capability. */
  subjectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "approvals.approval" */
export type Approval_Mutation_Response = {
  __typename?: 'approval_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Approval>;
};

/** input type for inserting object relation for remote table "approvals.approval" */
export type Approval_Obj_Rel_Insert_Input = {
  data: Approval_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Approval_On_Conflict>;
};

/** on_conflict condition type for table "approvals.approval" */
export type Approval_On_Conflict = {
  constraint: Approval_Constraint;
  update_columns?: Array<Approval_Update_Column>;
  where?: InputMaybe<Approval_Bool_Exp>;
};

/** Ordering options when selecting data from "approvals.approval". */
export type Approval_Order_By = {
  approver?: InputMaybe<Identity_Order_By>;
  approverIdentityId?: InputMaybe<Order_By>;
  capability?: InputMaybe<Capability_Order_By>;
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  gateId?: InputMaybe<Order_By>;
  grantedAuthority?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityId?: InputMaybe<Order_By>;
  materialHash?: InputMaybe<Order_By>;
  revokedAt?: InputMaybe<Order_By>;
  subjectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: approvals.approval */
export type Approval_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "approvals.approval" */
export enum Approval_Select_Column {
  /** column name */
  ApproverIdentityId = 'approverIdentityId',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GateId = 'gateId',
  /** column name */
  GrantedAuthority = 'grantedAuthority',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  MaterialHash = 'materialHash',
  /** column name */
  RevokedAt = 'revokedAt',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "approvals.approval" */
export type Approval_Set_Input = {
  /** The Approver who granted this (logical ref to ory.identity). With granted_authority this is the audit record: who authorized what, and up to how much. */
  approverIdentityId?: InputMaybe<Scalars['uuid']>;
  /** The Capability this Approval authorizes. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Gate this Approval was granted against, set by validate_grant from the subject rather than trusted from the caller. Null applies to the Capability as a whole, which is what an Approval granted before this column existed means. IT-6672. */
  gateId?: InputMaybe<Scalars['uuid']>;
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The acting identity whose authority is raised (logical ref to ory.identity). An Approval on one entity grants nothing on any other — this is what distinguishes it from a Validation Override. */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Under Always: hash of the subject's material fields when granted. A mismatch means the entity changed after approval and the Approval no longer applies. Set by the validating trigger, never trusted from the caller. */
  materialHash?: InputMaybe<Scalars['String']>;
  /** When this Approval was withdrawn; NULL means it still stands. Revoking never deletes — the record of the original decision is kept. */
  revokedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The entity this Approval applies to, as returned by the gate's subject resolver. Deliberately untyped: subjects live in different tables per Capability. */
  subjectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Approval_Stddev_Fields = {
  __typename?: 'approval_stddev_fields';
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "approvals.approval" */
export type Approval_Stddev_Order_By = {
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Approval_Stddev_Pop_Fields = {
  __typename?: 'approval_stddev_pop_fields';
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "approvals.approval" */
export type Approval_Stddev_Pop_Order_By = {
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Approval_Stddev_Samp_Fields = {
  __typename?: 'approval_stddev_samp_fields';
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "approvals.approval" */
export type Approval_Stddev_Samp_Order_By = {
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "approval" */
export type Approval_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Approval_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Approval_Stream_Cursor_Value_Input = {
  /** The Approver who granted this (logical ref to ory.identity). With granted_authority this is the audit record: who authorized what, and up to how much. */
  approverIdentityId?: InputMaybe<Scalars['uuid']>;
  /** The Capability this Approval authorizes. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Gate this Approval was granted against, set by validate_grant from the subject rather than trusted from the caller. Null applies to the Capability as a whole, which is what an Approval granted before this column existed means. IT-6672. */
  gateId?: InputMaybe<Scalars['uuid']>;
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The acting identity whose authority is raised (logical ref to ory.identity). An Approval on one entity grants nothing on any other — this is what distinguishes it from a Validation Override. */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Under Always: hash of the subject's material fields when granted. A mismatch means the entity changed after approval and the Approval no longer applies. Set by the validating trigger, never trusted from the caller. */
  materialHash?: InputMaybe<Scalars['String']>;
  /** When this Approval was withdrawn; NULL means it still stands. Revoking never deletes — the record of the original decision is kept. */
  revokedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The entity this Approval applies to, as returned by the gate's subject resolver. Deliberately untyped: subjects live in different tables per Capability. */
  subjectId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Approval_Sum_Fields = {
  __typename?: 'approval_sum_fields';
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "approvals.approval" */
export type Approval_Sum_Order_By = {
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Order_By>;
};

/** update columns of table "approvals.approval" */
export enum Approval_Update_Column {
  /** column name */
  ApproverIdentityId = 'approverIdentityId',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GateId = 'gateId',
  /** column name */
  GrantedAuthority = 'grantedAuthority',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  MaterialHash = 'materialHash',
  /** column name */
  RevokedAt = 'revokedAt',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Approval_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Approval_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Approval_Set_Input>;
  /** filter the rows which have to be updated */
  where: Approval_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Approval_Var_Pop_Fields = {
  __typename?: 'approval_var_pop_fields';
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "approvals.approval" */
export type Approval_Var_Pop_Order_By = {
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Approval_Var_Samp_Fields = {
  __typename?: 'approval_var_samp_fields';
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "approvals.approval" */
export type Approval_Var_Samp_Order_By = {
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Approval_Variance_Fields = {
  __typename?: 'approval_variance_fields';
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "approvals.approval" */
export type Approval_Variance_Order_By = {
  /** The cap this Approval raises the actor to for this subject. Entered explicitly by the Approver and capped at the Approver's own authority AS IT STOOD AT GRANT TIME — which is why authority changes need no history of their own. NULL under Always, where nothing is measured. */
  grantedAuthority?: InputMaybe<Order_By>;
};

/** Used to see if data needs to be pushed to on prem SQL server */
export type As400DataSync = {
  __typename?: 'as400DataSync';
  createdAt: Scalars['timestamptz'];
  dataId?: Maybe<Scalars['uuid']>;
  hasBeenSynced?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  is_processing: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "as400_data_sync" */
export type As400DataSync_Aggregate = {
  __typename?: 'as400DataSync_aggregate';
  aggregate?: Maybe<As400DataSync_Aggregate_Fields>;
  nodes: Array<As400DataSync>;
};

/** aggregate fields of "as400_data_sync" */
export type As400DataSync_Aggregate_Fields = {
  __typename?: 'as400DataSync_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<As400DataSync_Max_Fields>;
  min?: Maybe<As400DataSync_Min_Fields>;
};


/** aggregate fields of "as400_data_sync" */
export type As400DataSync_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As400DataSync_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "as400_data_sync". All fields are combined with a logical 'AND'. */
export type As400DataSync_Bool_Exp = {
  _and?: InputMaybe<Array<As400DataSync_Bool_Exp>>;
  _not?: InputMaybe<As400DataSync_Bool_Exp>;
  _or?: InputMaybe<Array<As400DataSync_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dataId?: InputMaybe<Uuid_Comparison_Exp>;
  hasBeenSynced?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_processing?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "as400_data_sync" */
export enum As400DataSync_Constraint {
  /** unique or primary key constraint on columns "id" */
  As400DataSyncPkey = 'as400_data_sync_pkey'
}

/** input type for inserting data into table "as400_data_sync" */
export type As400DataSync_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dataId?: InputMaybe<Scalars['uuid']>;
  hasBeenSynced?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_processing?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type As400DataSync_Max_Fields = {
  __typename?: 'as400DataSync_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  dataId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type As400DataSync_Min_Fields = {
  __typename?: 'as400DataSync_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  dataId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "as400_data_sync" */
export type As400DataSync_Mutation_Response = {
  __typename?: 'as400DataSync_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As400DataSync>;
};

/** on_conflict condition type for table "as400_data_sync" */
export type As400DataSync_On_Conflict = {
  constraint: As400DataSync_Constraint;
  update_columns?: Array<As400DataSync_Update_Column>;
  where?: InputMaybe<As400DataSync_Bool_Exp>;
};

/** Ordering options when selecting data from "as400_data_sync". */
export type As400DataSync_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  dataId?: InputMaybe<Order_By>;
  hasBeenSynced?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_processing?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: as400_data_sync */
export type As400DataSync_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "as400_data_sync" */
export enum As400DataSync_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DataId = 'dataId',
  /** column name */
  HasBeenSynced = 'hasBeenSynced',
  /** column name */
  Id = 'id',
  /** column name */
  IsProcessing = 'is_processing',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "as400_data_sync" */
export type As400DataSync_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dataId?: InputMaybe<Scalars['uuid']>;
  hasBeenSynced?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_processing?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "as400DataSync" */
export type As400DataSync_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As400DataSync_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As400DataSync_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dataId?: InputMaybe<Scalars['uuid']>;
  hasBeenSynced?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_processing?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "as400_data_sync" */
export enum As400DataSync_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DataId = 'dataId',
  /** column name */
  HasBeenSynced = 'hasBeenSynced',
  /** column name */
  Id = 'id',
  /** column name */
  IsProcessing = 'is_processing',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type As400DataSync_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As400DataSync_Set_Input>;
  /** filter the rows which have to be updated */
  where: As400DataSync_Bool_Exp;
};

/** Configuration for formatting audit.logged_actions activity messages. Defines how different field changes should be displayed to users. */
export type Audit_Message_Formatter_Config = {
  __typename?: 'audit_message_formatter_config';
  /** JSONB object for advanced configuration like custom templates, context queries, and entity name lookups. See table comment for supported keys. */
  advanced_config?: Maybe<Scalars['jsonb']>;
  boolean_false_text?: Maybe<Scalars['String']>;
  boolean_true_text?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name: Scalars['String'];
  field_name: Scalars['String'];
  /** status_lookup: Look up display value from a type/status table | simple: Show old->new value directly | prefixed_number: Show old->new with custom prefix (e.g., #, $) | suffixed_number: Show old->new with custom suffix (e.g., miles, months, %) | boolean: Use custom true/false text | date: Format as date change | jsonb_diff: Compare JSONB objects and show what changed | ignore: Skip this field in messages */
  formatter_strategy: Scalars['String'];
  is_active?: Maybe<Scalars['Boolean']>;
  lookup_display_column?: Maybe<Scalars['String']>;
  lookup_table?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  prefix_text?: Maybe<Scalars['String']>;
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Int']>;
  schema_name: Scalars['String'];
  suffix_text?: Maybe<Scalars['String']>;
  table_name: Scalars['String'];
};


/** Configuration for formatting audit.logged_actions activity messages. Defines how different field changes should be displayed to users. */
export type Audit_Message_Formatter_ConfigAdvanced_ConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "audit.message_formatter_config" */
export type Audit_Message_Formatter_Config_Aggregate = {
  __typename?: 'audit_message_formatter_config_aggregate';
  aggregate?: Maybe<Audit_Message_Formatter_Config_Aggregate_Fields>;
  nodes: Array<Audit_Message_Formatter_Config>;
};

/** aggregate fields of "audit.message_formatter_config" */
export type Audit_Message_Formatter_Config_Aggregate_Fields = {
  __typename?: 'audit_message_formatter_config_aggregate_fields';
  avg?: Maybe<Audit_Message_Formatter_Config_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Audit_Message_Formatter_Config_Max_Fields>;
  min?: Maybe<Audit_Message_Formatter_Config_Min_Fields>;
  stddev?: Maybe<Audit_Message_Formatter_Config_Stddev_Fields>;
  stddev_pop?: Maybe<Audit_Message_Formatter_Config_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Audit_Message_Formatter_Config_Stddev_Samp_Fields>;
  sum?: Maybe<Audit_Message_Formatter_Config_Sum_Fields>;
  var_pop?: Maybe<Audit_Message_Formatter_Config_Var_Pop_Fields>;
  var_samp?: Maybe<Audit_Message_Formatter_Config_Var_Samp_Fields>;
  variance?: Maybe<Audit_Message_Formatter_Config_Variance_Fields>;
};


/** aggregate fields of "audit.message_formatter_config" */
export type Audit_Message_Formatter_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audit_Message_Formatter_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Audit_Message_Formatter_Config_Append_Input = {
  /** JSONB object for advanced configuration like custom templates, context queries, and entity name lookups. See table comment for supported keys. */
  advanced_config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Audit_Message_Formatter_Config_Avg_Fields = {
  __typename?: 'audit_message_formatter_config_avg_fields';
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "audit.message_formatter_config". All fields are combined with a logical 'AND'. */
export type Audit_Message_Formatter_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Message_Formatter_Config_Bool_Exp>>;
  _not?: InputMaybe<Audit_Message_Formatter_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Message_Formatter_Config_Bool_Exp>>;
  advanced_config?: InputMaybe<Jsonb_Comparison_Exp>;
  boolean_false_text?: InputMaybe<String_Comparison_Exp>;
  boolean_true_text?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  field_name?: InputMaybe<String_Comparison_Exp>;
  formatter_strategy?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  lookup_display_column?: InputMaybe<String_Comparison_Exp>;
  lookup_table?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  prefix_text?: InputMaybe<String_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  schema_name?: InputMaybe<String_Comparison_Exp>;
  suffix_text?: InputMaybe<String_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "audit.message_formatter_config" */
export enum Audit_Message_Formatter_Config_Constraint {
  /** unique or primary key constraint on columns "field_name", "schema_name", "formatter_strategy", "table_name" */
  MessageFormatterConfigPkey = 'message_formatter_config_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Audit_Message_Formatter_Config_Delete_At_Path_Input = {
  /** JSONB object for advanced configuration like custom templates, context queries, and entity name lookups. See table comment for supported keys. */
  advanced_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Audit_Message_Formatter_Config_Delete_Elem_Input = {
  /** JSONB object for advanced configuration like custom templates, context queries, and entity name lookups. See table comment for supported keys. */
  advanced_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Audit_Message_Formatter_Config_Delete_Key_Input = {
  /** JSONB object for advanced configuration like custom templates, context queries, and entity name lookups. See table comment for supported keys. */
  advanced_config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "audit.message_formatter_config" */
export type Audit_Message_Formatter_Config_Inc_Input = {
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "audit.message_formatter_config" */
export type Audit_Message_Formatter_Config_Insert_Input = {
  /** JSONB object for advanced configuration like custom templates, context queries, and entity name lookups. See table comment for supported keys. */
  advanced_config?: InputMaybe<Scalars['jsonb']>;
  boolean_false_text?: InputMaybe<Scalars['String']>;
  boolean_true_text?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  field_name?: InputMaybe<Scalars['String']>;
  /** status_lookup: Look up display value from a type/status table | simple: Show old->new value directly | prefixed_number: Show old->new with custom prefix (e.g., #, $) | suffixed_number: Show old->new with custom suffix (e.g., miles, months, %) | boolean: Use custom true/false text | date: Format as date change | jsonb_diff: Compare JSONB objects and show what changed | ignore: Skip this field in messages */
  formatter_strategy?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  lookup_display_column?: InputMaybe<Scalars['String']>;
  lookup_table?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  prefix_text?: InputMaybe<Scalars['String']>;
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: InputMaybe<Scalars['Int']>;
  schema_name?: InputMaybe<Scalars['String']>;
  suffix_text?: InputMaybe<Scalars['String']>;
  table_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Audit_Message_Formatter_Config_Max_Fields = {
  __typename?: 'audit_message_formatter_config_max_fields';
  boolean_false_text?: Maybe<Scalars['String']>;
  boolean_true_text?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  field_name?: Maybe<Scalars['String']>;
  /** status_lookup: Look up display value from a type/status table | simple: Show old->new value directly | prefixed_number: Show old->new with custom prefix (e.g., #, $) | suffixed_number: Show old->new with custom suffix (e.g., miles, months, %) | boolean: Use custom true/false text | date: Format as date change | jsonb_diff: Compare JSONB objects and show what changed | ignore: Skip this field in messages */
  formatter_strategy?: Maybe<Scalars['String']>;
  lookup_display_column?: Maybe<Scalars['String']>;
  lookup_table?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  prefix_text?: Maybe<Scalars['String']>;
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Int']>;
  schema_name?: Maybe<Scalars['String']>;
  suffix_text?: Maybe<Scalars['String']>;
  table_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Audit_Message_Formatter_Config_Min_Fields = {
  __typename?: 'audit_message_formatter_config_min_fields';
  boolean_false_text?: Maybe<Scalars['String']>;
  boolean_true_text?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  field_name?: Maybe<Scalars['String']>;
  /** status_lookup: Look up display value from a type/status table | simple: Show old->new value directly | prefixed_number: Show old->new with custom prefix (e.g., #, $) | suffixed_number: Show old->new with custom suffix (e.g., miles, months, %) | boolean: Use custom true/false text | date: Format as date change | jsonb_diff: Compare JSONB objects and show what changed | ignore: Skip this field in messages */
  formatter_strategy?: Maybe<Scalars['String']>;
  lookup_display_column?: Maybe<Scalars['String']>;
  lookup_table?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  prefix_text?: Maybe<Scalars['String']>;
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Int']>;
  schema_name?: Maybe<Scalars['String']>;
  suffix_text?: Maybe<Scalars['String']>;
  table_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "audit.message_formatter_config" */
export type Audit_Message_Formatter_Config_Mutation_Response = {
  __typename?: 'audit_message_formatter_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Audit_Message_Formatter_Config>;
};

/** on_conflict condition type for table "audit.message_formatter_config" */
export type Audit_Message_Formatter_Config_On_Conflict = {
  constraint: Audit_Message_Formatter_Config_Constraint;
  update_columns?: Array<Audit_Message_Formatter_Config_Update_Column>;
  where?: InputMaybe<Audit_Message_Formatter_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "audit.message_formatter_config". */
export type Audit_Message_Formatter_Config_Order_By = {
  advanced_config?: InputMaybe<Order_By>;
  boolean_false_text?: InputMaybe<Order_By>;
  boolean_true_text?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  formatter_strategy?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  lookup_display_column?: InputMaybe<Order_By>;
  lookup_table?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  prefix_text?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  schema_name?: InputMaybe<Order_By>;
  suffix_text?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: audit.message_formatter_config */
export type Audit_Message_Formatter_Config_Pk_Columns_Input = {
  field_name: Scalars['String'];
  /** status_lookup: Look up display value from a type/status table | simple: Show old->new value directly | prefixed_number: Show old->new with custom prefix (e.g., #, $) | suffixed_number: Show old->new with custom suffix (e.g., miles, months, %) | boolean: Use custom true/false text | date: Format as date change | jsonb_diff: Compare JSONB objects and show what changed | ignore: Skip this field in messages */
  formatter_strategy: Scalars['String'];
  schema_name: Scalars['String'];
  table_name: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Audit_Message_Formatter_Config_Prepend_Input = {
  /** JSONB object for advanced configuration like custom templates, context queries, and entity name lookups. See table comment for supported keys. */
  advanced_config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "audit.message_formatter_config" */
export enum Audit_Message_Formatter_Config_Select_Column {
  /** column name */
  AdvancedConfig = 'advanced_config',
  /** column name */
  BooleanFalseText = 'boolean_false_text',
  /** column name */
  BooleanTrueText = 'boolean_true_text',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  FieldName = 'field_name',
  /** column name */
  FormatterStrategy = 'formatter_strategy',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LookupDisplayColumn = 'lookup_display_column',
  /** column name */
  LookupTable = 'lookup_table',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrefixText = 'prefix_text',
  /** column name */
  Priority = 'priority',
  /** column name */
  SchemaName = 'schema_name',
  /** column name */
  SuffixText = 'suffix_text',
  /** column name */
  TableName = 'table_name'
}

/** input type for updating data in table "audit.message_formatter_config" */
export type Audit_Message_Formatter_Config_Set_Input = {
  /** JSONB object for advanced configuration like custom templates, context queries, and entity name lookups. See table comment for supported keys. */
  advanced_config?: InputMaybe<Scalars['jsonb']>;
  boolean_false_text?: InputMaybe<Scalars['String']>;
  boolean_true_text?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  field_name?: InputMaybe<Scalars['String']>;
  /** status_lookup: Look up display value from a type/status table | simple: Show old->new value directly | prefixed_number: Show old->new with custom prefix (e.g., #, $) | suffixed_number: Show old->new with custom suffix (e.g., miles, months, %) | boolean: Use custom true/false text | date: Format as date change | jsonb_diff: Compare JSONB objects and show what changed | ignore: Skip this field in messages */
  formatter_strategy?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  lookup_display_column?: InputMaybe<Scalars['String']>;
  lookup_table?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  prefix_text?: InputMaybe<Scalars['String']>;
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: InputMaybe<Scalars['Int']>;
  schema_name?: InputMaybe<Scalars['String']>;
  suffix_text?: InputMaybe<Scalars['String']>;
  table_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Audit_Message_Formatter_Config_Stddev_Fields = {
  __typename?: 'audit_message_formatter_config_stddev_fields';
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Audit_Message_Formatter_Config_Stddev_Pop_Fields = {
  __typename?: 'audit_message_formatter_config_stddev_pop_fields';
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Audit_Message_Formatter_Config_Stddev_Samp_Fields = {
  __typename?: 'audit_message_formatter_config_stddev_samp_fields';
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "audit_message_formatter_config" */
export type Audit_Message_Formatter_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Message_Formatter_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Message_Formatter_Config_Stream_Cursor_Value_Input = {
  /** JSONB object for advanced configuration like custom templates, context queries, and entity name lookups. See table comment for supported keys. */
  advanced_config?: InputMaybe<Scalars['jsonb']>;
  boolean_false_text?: InputMaybe<Scalars['String']>;
  boolean_true_text?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  field_name?: InputMaybe<Scalars['String']>;
  /** status_lookup: Look up display value from a type/status table | simple: Show old->new value directly | prefixed_number: Show old->new with custom prefix (e.g., #, $) | suffixed_number: Show old->new with custom suffix (e.g., miles, months, %) | boolean: Use custom true/false text | date: Format as date change | jsonb_diff: Compare JSONB objects and show what changed | ignore: Skip this field in messages */
  formatter_strategy?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  lookup_display_column?: InputMaybe<Scalars['String']>;
  lookup_table?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  prefix_text?: InputMaybe<Scalars['String']>;
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: InputMaybe<Scalars['Int']>;
  schema_name?: InputMaybe<Scalars['String']>;
  suffix_text?: InputMaybe<Scalars['String']>;
  table_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Audit_Message_Formatter_Config_Sum_Fields = {
  __typename?: 'audit_message_formatter_config_sum_fields';
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Int']>;
};

/** update columns of table "audit.message_formatter_config" */
export enum Audit_Message_Formatter_Config_Update_Column {
  /** column name */
  AdvancedConfig = 'advanced_config',
  /** column name */
  BooleanFalseText = 'boolean_false_text',
  /** column name */
  BooleanTrueText = 'boolean_true_text',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  FieldName = 'field_name',
  /** column name */
  FormatterStrategy = 'formatter_strategy',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LookupDisplayColumn = 'lookup_display_column',
  /** column name */
  LookupTable = 'lookup_table',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrefixText = 'prefix_text',
  /** column name */
  Priority = 'priority',
  /** column name */
  SchemaName = 'schema_name',
  /** column name */
  SuffixText = 'suffix_text',
  /** column name */
  TableName = 'table_name'
}

export type Audit_Message_Formatter_Config_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Audit_Message_Formatter_Config_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Audit_Message_Formatter_Config_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Audit_Message_Formatter_Config_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Audit_Message_Formatter_Config_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Audit_Message_Formatter_Config_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Audit_Message_Formatter_Config_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Audit_Message_Formatter_Config_Set_Input>;
  /** filter the rows which have to be updated */
  where: Audit_Message_Formatter_Config_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Audit_Message_Formatter_Config_Var_Pop_Fields = {
  __typename?: 'audit_message_formatter_config_var_pop_fields';
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Audit_Message_Formatter_Config_Var_Samp_Fields = {
  __typename?: 'audit_message_formatter_config_var_samp_fields';
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Audit_Message_Formatter_Config_Variance_Fields = {
  __typename?: 'audit_message_formatter_config_variance_fields';
  /** Lower numbers appear first when multiple fields change. Default 100. */
  priority?: Maybe<Scalars['Float']>;
};

/** View showing all tables with auditing set up. Ordered by schema, then table. */
export type Audit_Tableslist = {
  __typename?: 'audit_tableslist';
  auditedtable?: Maybe<Scalars['name']>;
  schema?: Maybe<Scalars['name']>;
};

/** aggregated selection of "audit.tableslist" */
export type Audit_Tableslist_Aggregate = {
  __typename?: 'audit_tableslist_aggregate';
  aggregate?: Maybe<Audit_Tableslist_Aggregate_Fields>;
  nodes: Array<Audit_Tableslist>;
};

/** aggregate fields of "audit.tableslist" */
export type Audit_Tableslist_Aggregate_Fields = {
  __typename?: 'audit_tableslist_aggregate_fields';
  count: Scalars['Int'];
};


/** aggregate fields of "audit.tableslist" */
export type Audit_Tableslist_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audit_Tableslist_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "audit.tableslist". All fields are combined with a logical 'AND'. */
export type Audit_Tableslist_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Tableslist_Bool_Exp>>;
  _not?: InputMaybe<Audit_Tableslist_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Tableslist_Bool_Exp>>;
  auditedtable?: InputMaybe<Name_Comparison_Exp>;
  schema?: InputMaybe<Name_Comparison_Exp>;
};

/** Ordering options when selecting data from "audit.tableslist". */
export type Audit_Tableslist_Order_By = {
  auditedtable?: InputMaybe<Order_By>;
  schema?: InputMaybe<Order_By>;
};

/** select columns of table "audit.tableslist" */
export enum Audit_Tableslist_Select_Column {
  /** column name */
  Auditedtable = 'auditedtable',
  /** column name */
  Schema = 'schema'
}

/** Streaming cursor of the table "audit_tableslist" */
export type Audit_Tableslist_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Tableslist_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Tableslist_Stream_Cursor_Value_Input = {
  auditedtable?: InputMaybe<Scalars['name']>;
  schema?: InputMaybe<Scalars['name']>;
};

/** columns and relationships of "auth.group" */
export type Auth_Group = {
  __typename?: 'auth_group';
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  group_actions: Array<Auth_Group_Actions>;
  /** An aggregate relationship */
  group_actions_aggregate: Auth_Group_Actions_Aggregate;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  user_groups: Array<UserGroup>;
  /** An aggregate relationship */
  user_groups_aggregate: UserGroup_Aggregate;
};


/** columns and relationships of "auth.group" */
export type Auth_GroupGroup_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Actions_Order_By>>;
  where?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
};


/** columns and relationships of "auth.group" */
export type Auth_GroupGroup_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Actions_Order_By>>;
  where?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
};


/** columns and relationships of "auth.group" */
export type Auth_GroupUser_GroupsArgs = {
  distinct_on?: InputMaybe<Array<UserGroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroup_Order_By>>;
  where?: InputMaybe<UserGroup_Bool_Exp>;
};


/** columns and relationships of "auth.group" */
export type Auth_GroupUser_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroup_Order_By>>;
  where?: InputMaybe<UserGroup_Bool_Exp>;
};

/** columns and relationships of "auth.group_actions" */
export type Auth_Group_Actions = {
  __typename?: 'auth_group_actions';
  actions?: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  group: Auth_Group;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "auth.group_actions" */
export type Auth_Group_ActionsActionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "auth.group_actions" */
export type Auth_Group_Actions_Aggregate = {
  __typename?: 'auth_group_actions_aggregate';
  aggregate?: Maybe<Auth_Group_Actions_Aggregate_Fields>;
  nodes: Array<Auth_Group_Actions>;
};

export type Auth_Group_Actions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Auth_Group_Actions_Aggregate_Bool_Exp_Count>;
};

export type Auth_Group_Actions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Auth_Group_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.group_actions" */
export type Auth_Group_Actions_Aggregate_Fields = {
  __typename?: 'auth_group_actions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Auth_Group_Actions_Max_Fields>;
  min?: Maybe<Auth_Group_Actions_Min_Fields>;
};


/** aggregate fields of "auth.group_actions" */
export type Auth_Group_Actions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Group_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.group_actions" */
export type Auth_Group_Actions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Group_Actions_Max_Order_By>;
  min?: InputMaybe<Auth_Group_Actions_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Auth_Group_Actions_Append_Input = {
  actions?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "auth.group_actions" */
export type Auth_Group_Actions_Arr_Rel_Insert_Input = {
  data: Array<Auth_Group_Actions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Group_Actions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.group_actions". All fields are combined with a logical 'AND'. */
export type Auth_Group_Actions_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Group_Actions_Bool_Exp>>;
  _not?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Group_Actions_Bool_Exp>>;
  actions?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  group?: InputMaybe<Auth_Group_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.group_actions" */
export enum Auth_Group_Actions_Constraint {
  /** unique or primary key constraint on columns "id" */
  GroupActionsPkey = 'group_actions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Auth_Group_Actions_Delete_At_Path_Input = {
  actions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Auth_Group_Actions_Delete_Elem_Input = {
  actions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Auth_Group_Actions_Delete_Key_Input = {
  actions?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "auth.group_actions" */
export type Auth_Group_Actions_Insert_Input = {
  actions?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<Auth_Group_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Auth_Group_Actions_Max_Fields = {
  __typename?: 'auth_group_actions_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.group_actions" */
export type Auth_Group_Actions_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Group_Actions_Min_Fields = {
  __typename?: 'auth_group_actions_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.group_actions" */
export type Auth_Group_Actions_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.group_actions" */
export type Auth_Group_Actions_Mutation_Response = {
  __typename?: 'auth_group_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Group_Actions>;
};

/** on_conflict condition type for table "auth.group_actions" */
export type Auth_Group_Actions_On_Conflict = {
  constraint: Auth_Group_Actions_Constraint;
  update_columns?: Array<Auth_Group_Actions_Update_Column>;
  where?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.group_actions". */
export type Auth_Group_Actions_Order_By = {
  actions?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  group?: InputMaybe<Auth_Group_Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.group_actions */
export type Auth_Group_Actions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Auth_Group_Actions_Prepend_Input = {
  actions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "auth.group_actions" */
export enum Auth_Group_Actions_Select_Column {
  /** column name */
  Actions = 'actions',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.group_actions" */
export type Auth_Group_Actions_Set_Input = {
  actions?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "auth_group_actions" */
export type Auth_Group_Actions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Group_Actions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Group_Actions_Stream_Cursor_Value_Input = {
  actions?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.group_actions" */
export enum Auth_Group_Actions_Update_Column {
  /** column name */
  Actions = 'actions',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Auth_Group_Actions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Auth_Group_Actions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Auth_Group_Actions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Auth_Group_Actions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Auth_Group_Actions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Auth_Group_Actions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Group_Actions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Group_Actions_Bool_Exp;
};

/** aggregated selection of "auth.group" */
export type Auth_Group_Aggregate = {
  __typename?: 'auth_group_aggregate';
  aggregate?: Maybe<Auth_Group_Aggregate_Fields>;
  nodes: Array<Auth_Group>;
};

/** aggregate fields of "auth.group" */
export type Auth_Group_Aggregate_Fields = {
  __typename?: 'auth_group_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Auth_Group_Max_Fields>;
  min?: Maybe<Auth_Group_Min_Fields>;
};


/** aggregate fields of "auth.group" */
export type Auth_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "auth.group". All fields are combined with a logical 'AND'. */
export type Auth_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Group_Bool_Exp>>;
  _not?: InputMaybe<Auth_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Group_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_actions?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
  group_actions_aggregate?: InputMaybe<Auth_Group_Actions_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_groups?: InputMaybe<UserGroup_Bool_Exp>;
  user_groups_aggregate?: InputMaybe<UserGroup_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.group" */
export enum Auth_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  GroupPkey = 'group_pkey'
}

/** input type for inserting data into table "auth.group" */
export type Auth_Group_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  group_actions?: InputMaybe<Auth_Group_Actions_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user_groups?: InputMaybe<UserGroup_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Auth_Group_Max_Fields = {
  __typename?: 'auth_group_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Auth_Group_Min_Fields = {
  __typename?: 'auth_group_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "auth.group" */
export type Auth_Group_Mutation_Response = {
  __typename?: 'auth_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Group>;
};

/** input type for inserting object relation for remote table "auth.group" */
export type Auth_Group_Obj_Rel_Insert_Input = {
  data: Auth_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};

/** on_conflict condition type for table "auth.group" */
export type Auth_Group_On_Conflict = {
  constraint: Auth_Group_Constraint;
  update_columns?: Array<Auth_Group_Update_Column>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.group". */
export type Auth_Group_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  group_actions_aggregate?: InputMaybe<Auth_Group_Actions_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user_groups_aggregate?: InputMaybe<UserGroup_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.group */
export type Auth_Group_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.group" */
export enum Auth_Group_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.group" */
export type Auth_Group_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "auth_group" */
export type Auth_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Group_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.group" */
export enum Auth_Group_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Auth_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Group_Bool_Exp;
};

export type AvailableCoverageOptions_PolicyContractQuote_Args = {
  field?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "shared.bank_account_type" */
export type BankAccountType = {
  __typename?: 'bankAccountType';
  display: Scalars['String'];
  /** An array relationship */
  entity_billing_informations: Array<EntityBillingInformation>;
  /** An aggregate relationship */
  entity_billing_informations_aggregate: EntityBillingInformation_Aggregate;
  enumValue: Scalars['numeric'];
  id: Scalars['uuid'];
  name: Scalars['String'];
};


/** columns and relationships of "shared.bank_account_type" */
export type BankAccountTypeEntity_Billing_InformationsArgs = {
  distinct_on?: InputMaybe<Array<EntityBillingInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityBillingInformation_Order_By>>;
  where?: InputMaybe<EntityBillingInformation_Bool_Exp>;
};


/** columns and relationships of "shared.bank_account_type" */
export type BankAccountTypeEntity_Billing_Informations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityBillingInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityBillingInformation_Order_By>>;
  where?: InputMaybe<EntityBillingInformation_Bool_Exp>;
};

/** aggregated selection of "shared.bank_account_type" */
export type BankAccountType_Aggregate = {
  __typename?: 'bankAccountType_aggregate';
  aggregate?: Maybe<BankAccountType_Aggregate_Fields>;
  nodes: Array<BankAccountType>;
};

/** aggregate fields of "shared.bank_account_type" */
export type BankAccountType_Aggregate_Fields = {
  __typename?: 'bankAccountType_aggregate_fields';
  avg?: Maybe<BankAccountType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<BankAccountType_Max_Fields>;
  min?: Maybe<BankAccountType_Min_Fields>;
  stddev?: Maybe<BankAccountType_Stddev_Fields>;
  stddev_pop?: Maybe<BankAccountType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BankAccountType_Stddev_Samp_Fields>;
  sum?: Maybe<BankAccountType_Sum_Fields>;
  var_pop?: Maybe<BankAccountType_Var_Pop_Fields>;
  var_samp?: Maybe<BankAccountType_Var_Samp_Fields>;
  variance?: Maybe<BankAccountType_Variance_Fields>;
};


/** aggregate fields of "shared.bank_account_type" */
export type BankAccountType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BankAccountType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BankAccountType_Avg_Fields = {
  __typename?: 'bankAccountType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shared.bank_account_type". All fields are combined with a logical 'AND'. */
export type BankAccountType_Bool_Exp = {
  _and?: InputMaybe<Array<BankAccountType_Bool_Exp>>;
  _not?: InputMaybe<BankAccountType_Bool_Exp>;
  _or?: InputMaybe<Array<BankAccountType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  entity_billing_informations?: InputMaybe<EntityBillingInformation_Bool_Exp>;
  entity_billing_informations_aggregate?: InputMaybe<EntityBillingInformation_Aggregate_Bool_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.bank_account_type" */
export enum BankAccountType_Constraint {
  /** unique or primary key constraint on columns "id" */
  BankAccountTypePkey = 'bank_account_type_pkey'
}

/** input type for incrementing numeric columns in table "shared.bank_account_type" */
export type BankAccountType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "shared.bank_account_type" */
export type BankAccountType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  entity_billing_informations?: InputMaybe<EntityBillingInformation_Arr_Rel_Insert_Input>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BankAccountType_Max_Fields = {
  __typename?: 'bankAccountType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BankAccountType_Min_Fields = {
  __typename?: 'bankAccountType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shared.bank_account_type" */
export type BankAccountType_Mutation_Response = {
  __typename?: 'bankAccountType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BankAccountType>;
};

/** input type for inserting object relation for remote table "shared.bank_account_type" */
export type BankAccountType_Obj_Rel_Insert_Input = {
  data: BankAccountType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BankAccountType_On_Conflict>;
};

/** on_conflict condition type for table "shared.bank_account_type" */
export type BankAccountType_On_Conflict = {
  constraint: BankAccountType_Constraint;
  update_columns?: Array<BankAccountType_Update_Column>;
  where?: InputMaybe<BankAccountType_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.bank_account_type". */
export type BankAccountType_Order_By = {
  display?: InputMaybe<Order_By>;
  entity_billing_informations_aggregate?: InputMaybe<EntityBillingInformation_Aggregate_Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.bank_account_type */
export type BankAccountType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.bank_account_type" */
export enum BankAccountType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "shared.bank_account_type" */
export type BankAccountType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BankAccountType_Stddev_Fields = {
  __typename?: 'bankAccountType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BankAccountType_Stddev_Pop_Fields = {
  __typename?: 'bankAccountType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BankAccountType_Stddev_Samp_Fields = {
  __typename?: 'bankAccountType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "bankAccountType" */
export type BankAccountType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BankAccountType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BankAccountType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BankAccountType_Sum_Fields = {
  __typename?: 'bankAccountType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "shared.bank_account_type" */
export enum BankAccountType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type BankAccountType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BankAccountType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BankAccountType_Set_Input>;
  /** filter the rows which have to be updated */
  where: BankAccountType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BankAccountType_Var_Pop_Fields = {
  __typename?: 'bankAccountType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BankAccountType_Var_Samp_Fields = {
  __typename?: 'bankAccountType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BankAccountType_Variance_Fields = {
  __typename?: 'bankAccountType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "caddy.caddy" */
export type Caddy = {
  __typename?: 'caddy';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "caddy.caddy" */
export type CaddyConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "caddy.caddy_server_manager_log" */
export type CaddyServerManagerLog = {
  __typename?: 'caddyServerManagerLog';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  message: Scalars['jsonb'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "caddy.caddy_server_manager_log" */
export type CaddyServerManagerLogMessageArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "caddy.caddy_server_manager_log" */
export type CaddyServerManagerLog_Aggregate = {
  __typename?: 'caddyServerManagerLog_aggregate';
  aggregate?: Maybe<CaddyServerManagerLog_Aggregate_Fields>;
  nodes: Array<CaddyServerManagerLog>;
};

/** aggregate fields of "caddy.caddy_server_manager_log" */
export type CaddyServerManagerLog_Aggregate_Fields = {
  __typename?: 'caddyServerManagerLog_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CaddyServerManagerLog_Max_Fields>;
  min?: Maybe<CaddyServerManagerLog_Min_Fields>;
};


/** aggregate fields of "caddy.caddy_server_manager_log" */
export type CaddyServerManagerLog_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CaddyServerManagerLog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CaddyServerManagerLog_Append_Input = {
  message?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "caddy.caddy_server_manager_log". All fields are combined with a logical 'AND'. */
export type CaddyServerManagerLog_Bool_Exp = {
  _and?: InputMaybe<Array<CaddyServerManagerLog_Bool_Exp>>;
  _not?: InputMaybe<CaddyServerManagerLog_Bool_Exp>;
  _or?: InputMaybe<Array<CaddyServerManagerLog_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "caddy.caddy_server_manager_log" */
export enum CaddyServerManagerLog_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaddyServerManagerLogPkey = 'caddy_server_manager_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CaddyServerManagerLog_Delete_At_Path_Input = {
  message?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CaddyServerManagerLog_Delete_Elem_Input = {
  message?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CaddyServerManagerLog_Delete_Key_Input = {
  message?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "caddy.caddy_server_manager_log" */
export type CaddyServerManagerLog_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CaddyServerManagerLog_Max_Fields = {
  __typename?: 'caddyServerManagerLog_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CaddyServerManagerLog_Min_Fields = {
  __typename?: 'caddyServerManagerLog_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "caddy.caddy_server_manager_log" */
export type CaddyServerManagerLog_Mutation_Response = {
  __typename?: 'caddyServerManagerLog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CaddyServerManagerLog>;
};

/** on_conflict condition type for table "caddy.caddy_server_manager_log" */
export type CaddyServerManagerLog_On_Conflict = {
  constraint: CaddyServerManagerLog_Constraint;
  update_columns?: Array<CaddyServerManagerLog_Update_Column>;
  where?: InputMaybe<CaddyServerManagerLog_Bool_Exp>;
};

/** Ordering options when selecting data from "caddy.caddy_server_manager_log". */
export type CaddyServerManagerLog_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: caddy.caddy_server_manager_log */
export type CaddyServerManagerLog_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CaddyServerManagerLog_Prepend_Input = {
  message?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "caddy.caddy_server_manager_log" */
export enum CaddyServerManagerLog_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "caddy.caddy_server_manager_log" */
export type CaddyServerManagerLog_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "caddyServerManagerLog" */
export type CaddyServerManagerLog_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CaddyServerManagerLog_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CaddyServerManagerLog_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "caddy.caddy_server_manager_log" */
export enum CaddyServerManagerLog_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type CaddyServerManagerLog_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CaddyServerManagerLog_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CaddyServerManagerLog_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CaddyServerManagerLog_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CaddyServerManagerLog_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CaddyServerManagerLog_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CaddyServerManagerLog_Set_Input>;
  /** filter the rows which have to be updated */
  where: CaddyServerManagerLog_Bool_Exp;
};

/** aggregated selection of "caddy.caddy" */
export type Caddy_Aggregate = {
  __typename?: 'caddy_aggregate';
  aggregate?: Maybe<Caddy_Aggregate_Fields>;
  nodes: Array<Caddy>;
};

/** aggregate fields of "caddy.caddy" */
export type Caddy_Aggregate_Fields = {
  __typename?: 'caddy_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Caddy_Max_Fields>;
  min?: Maybe<Caddy_Min_Fields>;
};


/** aggregate fields of "caddy.caddy" */
export type Caddy_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Caddy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Caddy_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "caddy.caddy". All fields are combined with a logical 'AND'. */
export type Caddy_Bool_Exp = {
  _and?: InputMaybe<Array<Caddy_Bool_Exp>>;
  _not?: InputMaybe<Caddy_Bool_Exp>;
  _or?: InputMaybe<Array<Caddy_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "caddy.caddy" */
export enum Caddy_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaddyPkey = 'caddy_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Caddy_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Caddy_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Caddy_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "caddy.caddy" */
export type Caddy_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Caddy_Max_Fields = {
  __typename?: 'caddy_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Caddy_Min_Fields = {
  __typename?: 'caddy_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "caddy.caddy" */
export type Caddy_Mutation_Response = {
  __typename?: 'caddy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Caddy>;
};

/** on_conflict condition type for table "caddy.caddy" */
export type Caddy_On_Conflict = {
  constraint: Caddy_Constraint;
  update_columns?: Array<Caddy_Update_Column>;
  where?: InputMaybe<Caddy_Bool_Exp>;
};

/** Ordering options when selecting data from "caddy.caddy". */
export type Caddy_Order_By = {
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: caddy.caddy */
export type Caddy_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Caddy_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "caddy.caddy" */
export enum Caddy_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "caddy.caddy" */
export type Caddy_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "caddy" */
export type Caddy_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Caddy_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Caddy_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "caddy.caddy" */
export enum Caddy_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Caddy_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Caddy_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Caddy_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Caddy_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Caddy_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Caddy_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Caddy_Set_Input>;
  /** filter the rows which have to be updated */
  where: Caddy_Bool_Exp;
};

/** columns and relationships of "quotes.cancel_quote_list_view" */
export type CancelQuoteListView = {
  __typename?: 'cancelQuoteListView';
  cancelAsOfDate?: Maybe<Scalars['date']>;
  cancelFee?: Maybe<Scalars['numeric']>;
  cancelInitiatorTypeId?: Maybe<Scalars['String']>;
  cancelMethodTypeName?: Maybe<Scalars['String']>;
  cancelReasonType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  policyContractId?: Maybe<Scalars['uuid']>;
  quoteDate?: Maybe<Scalars['timestamptz']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  refundPercent?: Maybe<Scalars['numeric']>;
  vehicleMileage?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Aggregate = {
  __typename?: 'cancelQuoteListView_aggregate';
  aggregate?: Maybe<CancelQuoteListView_Aggregate_Fields>;
  nodes: Array<CancelQuoteListView>;
};

export type CancelQuoteListView_Aggregate_Bool_Exp = {
  count?: InputMaybe<CancelQuoteListView_Aggregate_Bool_Exp_Count>;
};

export type CancelQuoteListView_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CancelQuoteListView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CancelQuoteListView_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Aggregate_Fields = {
  __typename?: 'cancelQuoteListView_aggregate_fields';
  avg?: Maybe<CancelQuoteListView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CancelQuoteListView_Max_Fields>;
  min?: Maybe<CancelQuoteListView_Min_Fields>;
  stddev?: Maybe<CancelQuoteListView_Stddev_Fields>;
  stddev_pop?: Maybe<CancelQuoteListView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CancelQuoteListView_Stddev_Samp_Fields>;
  sum?: Maybe<CancelQuoteListView_Sum_Fields>;
  var_pop?: Maybe<CancelQuoteListView_Var_Pop_Fields>;
  var_samp?: Maybe<CancelQuoteListView_Var_Samp_Fields>;
  variance?: Maybe<CancelQuoteListView_Variance_Fields>;
};


/** aggregate fields of "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CancelQuoteListView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Aggregate_Order_By = {
  avg?: InputMaybe<CancelQuoteListView_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CancelQuoteListView_Max_Order_By>;
  min?: InputMaybe<CancelQuoteListView_Min_Order_By>;
  stddev?: InputMaybe<CancelQuoteListView_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CancelQuoteListView_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CancelQuoteListView_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CancelQuoteListView_Sum_Order_By>;
  var_pop?: InputMaybe<CancelQuoteListView_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CancelQuoteListView_Var_Samp_Order_By>;
  variance?: InputMaybe<CancelQuoteListView_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Arr_Rel_Insert_Input = {
  data: Array<CancelQuoteListView_Insert_Input>;
};

/** aggregate avg on columns */
export type CancelQuoteListView_Avg_Fields = {
  __typename?: 'cancelQuoteListView_avg_fields';
  cancelFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  refundPercent?: Maybe<Scalars['Float']>;
  vehicleMileage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Avg_Order_By = {
  cancelFee?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quotes.cancel_quote_list_view". All fields are combined with a logical 'AND'. */
export type CancelQuoteListView_Bool_Exp = {
  _and?: InputMaybe<Array<CancelQuoteListView_Bool_Exp>>;
  _not?: InputMaybe<CancelQuoteListView_Bool_Exp>;
  _or?: InputMaybe<Array<CancelQuoteListView_Bool_Exp>>;
  cancelAsOfDate?: InputMaybe<Date_Comparison_Exp>;
  cancelFee?: InputMaybe<Numeric_Comparison_Exp>;
  cancelInitiatorTypeId?: InputMaybe<String_Comparison_Exp>;
  cancelMethodTypeName?: InputMaybe<String_Comparison_Exp>;
  cancelReasonType?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  quoteDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  refundAmount?: InputMaybe<Numeric_Comparison_Exp>;
  refundPercent?: InputMaybe<Numeric_Comparison_Exp>;
  vehicleMileage?: InputMaybe<Numeric_Comparison_Exp>;
};

/** input type for inserting data into table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Insert_Input = {
  cancelAsOfDate?: InputMaybe<Scalars['date']>;
  cancelFee?: InputMaybe<Scalars['numeric']>;
  cancelInitiatorTypeId?: InputMaybe<Scalars['String']>;
  cancelMethodTypeName?: InputMaybe<Scalars['String']>;
  cancelReasonType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  quoteDate?: InputMaybe<Scalars['timestamptz']>;
  refundAmount?: InputMaybe<Scalars['numeric']>;
  refundPercent?: InputMaybe<Scalars['numeric']>;
  vehicleMileage?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type CancelQuoteListView_Max_Fields = {
  __typename?: 'cancelQuoteListView_max_fields';
  cancelAsOfDate?: Maybe<Scalars['date']>;
  cancelFee?: Maybe<Scalars['numeric']>;
  cancelInitiatorTypeId?: Maybe<Scalars['String']>;
  cancelMethodTypeName?: Maybe<Scalars['String']>;
  cancelReasonType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  quoteDate?: Maybe<Scalars['timestamptz']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  refundPercent?: Maybe<Scalars['numeric']>;
  vehicleMileage?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Max_Order_By = {
  cancelAsOfDate?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  cancelInitiatorTypeId?: InputMaybe<Order_By>;
  cancelMethodTypeName?: InputMaybe<Order_By>;
  cancelReasonType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  quoteDate?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CancelQuoteListView_Min_Fields = {
  __typename?: 'cancelQuoteListView_min_fields';
  cancelAsOfDate?: Maybe<Scalars['date']>;
  cancelFee?: Maybe<Scalars['numeric']>;
  cancelInitiatorTypeId?: Maybe<Scalars['String']>;
  cancelMethodTypeName?: Maybe<Scalars['String']>;
  cancelReasonType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  quoteDate?: Maybe<Scalars['timestamptz']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  refundPercent?: Maybe<Scalars['numeric']>;
  vehicleMileage?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Min_Order_By = {
  cancelAsOfDate?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  cancelInitiatorTypeId?: InputMaybe<Order_By>;
  cancelMethodTypeName?: InputMaybe<Order_By>;
  cancelReasonType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  quoteDate?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "quotes.cancel_quote_list_view". */
export type CancelQuoteListView_Order_By = {
  cancelAsOfDate?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  cancelInitiatorTypeId?: InputMaybe<Order_By>;
  cancelMethodTypeName?: InputMaybe<Order_By>;
  cancelReasonType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  quoteDate?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** select columns of table "quotes.cancel_quote_list_view" */
export enum CancelQuoteListView_Select_Column {
  /** column name */
  CancelAsOfDate = 'cancelAsOfDate',
  /** column name */
  CancelFee = 'cancelFee',
  /** column name */
  CancelInitiatorTypeId = 'cancelInitiatorTypeId',
  /** column name */
  CancelMethodTypeName = 'cancelMethodTypeName',
  /** column name */
  CancelReasonType = 'cancelReasonType',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  QuoteDate = 'quoteDate',
  /** column name */
  RefundAmount = 'refundAmount',
  /** column name */
  RefundPercent = 'refundPercent',
  /** column name */
  VehicleMileage = 'vehicleMileage'
}

/** aggregate stddev on columns */
export type CancelQuoteListView_Stddev_Fields = {
  __typename?: 'cancelQuoteListView_stddev_fields';
  cancelFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  refundPercent?: Maybe<Scalars['Float']>;
  vehicleMileage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Stddev_Order_By = {
  cancelFee?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CancelQuoteListView_Stddev_Pop_Fields = {
  __typename?: 'cancelQuoteListView_stddev_pop_fields';
  cancelFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  refundPercent?: Maybe<Scalars['Float']>;
  vehicleMileage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Stddev_Pop_Order_By = {
  cancelFee?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CancelQuoteListView_Stddev_Samp_Fields = {
  __typename?: 'cancelQuoteListView_stddev_samp_fields';
  cancelFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  refundPercent?: Maybe<Scalars['Float']>;
  vehicleMileage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Stddev_Samp_Order_By = {
  cancelFee?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cancelQuoteListView" */
export type CancelQuoteListView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CancelQuoteListView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CancelQuoteListView_Stream_Cursor_Value_Input = {
  cancelAsOfDate?: InputMaybe<Scalars['date']>;
  cancelFee?: InputMaybe<Scalars['numeric']>;
  cancelInitiatorTypeId?: InputMaybe<Scalars['String']>;
  cancelMethodTypeName?: InputMaybe<Scalars['String']>;
  cancelReasonType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  quoteDate?: InputMaybe<Scalars['timestamptz']>;
  refundAmount?: InputMaybe<Scalars['numeric']>;
  refundPercent?: InputMaybe<Scalars['numeric']>;
  vehicleMileage?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type CancelQuoteListView_Sum_Fields = {
  __typename?: 'cancelQuoteListView_sum_fields';
  cancelFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  refundPercent?: Maybe<Scalars['numeric']>;
  vehicleMileage?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Sum_Order_By = {
  cancelFee?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type CancelQuoteListView_Var_Pop_Fields = {
  __typename?: 'cancelQuoteListView_var_pop_fields';
  cancelFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  refundPercent?: Maybe<Scalars['Float']>;
  vehicleMileage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Var_Pop_Order_By = {
  cancelFee?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CancelQuoteListView_Var_Samp_Fields = {
  __typename?: 'cancelQuoteListView_var_samp_fields';
  cancelFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  refundPercent?: Maybe<Scalars['Float']>;
  vehicleMileage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Var_Samp_Order_By = {
  cancelFee?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CancelQuoteListView_Variance_Fields = {
  __typename?: 'cancelQuoteListView_variance_fields';
  cancelFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  refundPercent?: Maybe<Scalars['Float']>;
  vehicleMileage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "quotes.cancel_quote_list_view" */
export type CancelQuoteListView_Variance_Order_By = {
  cancelFee?: InputMaybe<Order_By>;
  refundAmount?: InputMaybe<Order_By>;
  refundPercent?: InputMaybe<Order_By>;
  vehicleMileage?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance.cancel_rule" */
export type CancelRule = {
  __typename?: 'cancelRule';
  /** An object relationship */
  cancelClaimStatusType?: Maybe<Type>;
  cancelClaimStatusTypeId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  cancelInitiatorType: Type;
  cancelInitiatorTypeId: Scalars['uuid'];
  /** An object relationship */
  cancelReasonType?: Maybe<Type>;
  cancelReasonTypeId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  cancelRuleFees: Array<CancelRuleFee>;
  /** An aggregate relationship */
  cancelRuleFees_aggregate: CancelRuleFee_Aggregate;
  /** An array relationship */
  cancelRuleRefunds: Array<CancelRuleRefund>;
  /** An aggregate relationship */
  cancelRuleRefunds_aggregate: CancelRuleRefund_Aggregate;
  /** An object relationship */
  contractFormVersion: ContractFormVersion;
  contractFormVersionId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  endAgeDays?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  filingLender?: Maybe<FilingLender>;
  id: Scalars['uuid'];
  isBlockRule?: Maybe<Scalars['Boolean']>;
  lenderId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  startAgeDays: Scalars['numeric'];
  stateAbbreviation?: Maybe<Scalars['String']>;
  subtractClaims: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "compliance.cancel_rule" */
export type CancelRuleCancelRuleFeesArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleFee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleFee_Order_By>>;
  where?: InputMaybe<CancelRuleFee_Bool_Exp>;
};


/** columns and relationships of "compliance.cancel_rule" */
export type CancelRuleCancelRuleFees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleFee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleFee_Order_By>>;
  where?: InputMaybe<CancelRuleFee_Bool_Exp>;
};


/** columns and relationships of "compliance.cancel_rule" */
export type CancelRuleCancelRuleRefundsArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleRefund_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleRefund_Order_By>>;
  where?: InputMaybe<CancelRuleRefund_Bool_Exp>;
};


/** columns and relationships of "compliance.cancel_rule" */
export type CancelRuleCancelRuleRefunds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleRefund_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleRefund_Order_By>>;
  where?: InputMaybe<CancelRuleRefund_Bool_Exp>;
};


/** columns and relationships of "compliance.cancel_rule" */
export type CancelRuleLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "compliance.cancel_rule" */
export type CancelRuleLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** columns and relationships of "compliance.cancel_rule_fee" */
export type CancelRuleFee = {
  __typename?: 'cancelRuleFee';
  /** An object relationship */
  cancelFeeType: Type;
  cancelFeeTypeId: Scalars['uuid'];
  /** An object relationship */
  cancelRule: CancelRule;
  cancelRuleId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  number: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "compliance.cancel_rule_fee" */
export type CancelRuleFee_Aggregate = {
  __typename?: 'cancelRuleFee_aggregate';
  aggregate?: Maybe<CancelRuleFee_Aggregate_Fields>;
  nodes: Array<CancelRuleFee>;
};

export type CancelRuleFee_Aggregate_Bool_Exp = {
  count?: InputMaybe<CancelRuleFee_Aggregate_Bool_Exp_Count>;
};

export type CancelRuleFee_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CancelRuleFee_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CancelRuleFee_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance.cancel_rule_fee" */
export type CancelRuleFee_Aggregate_Fields = {
  __typename?: 'cancelRuleFee_aggregate_fields';
  avg?: Maybe<CancelRuleFee_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CancelRuleFee_Max_Fields>;
  min?: Maybe<CancelRuleFee_Min_Fields>;
  stddev?: Maybe<CancelRuleFee_Stddev_Fields>;
  stddev_pop?: Maybe<CancelRuleFee_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CancelRuleFee_Stddev_Samp_Fields>;
  sum?: Maybe<CancelRuleFee_Sum_Fields>;
  var_pop?: Maybe<CancelRuleFee_Var_Pop_Fields>;
  var_samp?: Maybe<CancelRuleFee_Var_Samp_Fields>;
  variance?: Maybe<CancelRuleFee_Variance_Fields>;
};


/** aggregate fields of "compliance.cancel_rule_fee" */
export type CancelRuleFee_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CancelRuleFee_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Aggregate_Order_By = {
  avg?: InputMaybe<CancelRuleFee_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CancelRuleFee_Max_Order_By>;
  min?: InputMaybe<CancelRuleFee_Min_Order_By>;
  stddev?: InputMaybe<CancelRuleFee_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CancelRuleFee_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CancelRuleFee_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CancelRuleFee_Sum_Order_By>;
  var_pop?: InputMaybe<CancelRuleFee_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CancelRuleFee_Var_Samp_Order_By>;
  variance?: InputMaybe<CancelRuleFee_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Arr_Rel_Insert_Input = {
  data: Array<CancelRuleFee_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CancelRuleFee_On_Conflict>;
};

/** aggregate avg on columns */
export type CancelRuleFee_Avg_Fields = {
  __typename?: 'cancelRuleFee_avg_fields';
  number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Avg_Order_By = {
  number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance.cancel_rule_fee". All fields are combined with a logical 'AND'. */
export type CancelRuleFee_Bool_Exp = {
  _and?: InputMaybe<Array<CancelRuleFee_Bool_Exp>>;
  _not?: InputMaybe<CancelRuleFee_Bool_Exp>;
  _or?: InputMaybe<Array<CancelRuleFee_Bool_Exp>>;
  cancelFeeType?: InputMaybe<Type_Bool_Exp>;
  cancelFeeTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  cancelRule?: InputMaybe<CancelRule_Bool_Exp>;
  cancelRuleId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  number?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.cancel_rule_fee" */
export enum CancelRuleFee_Constraint {
  /** unique or primary key constraint on columns "id" */
  CancelRuleFeePkey = 'cancel_rule_fee_pkey'
}

/** input type for incrementing numeric columns in table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Inc_Input = {
  number?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Insert_Input = {
  cancelFeeType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  cancelFeeTypeId?: InputMaybe<Scalars['uuid']>;
  cancelRule?: InputMaybe<CancelRule_Obj_Rel_Insert_Input>;
  cancelRuleId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  number?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CancelRuleFee_Max_Fields = {
  __typename?: 'cancelRuleFee_max_fields';
  cancelFeeTypeId?: Maybe<Scalars['uuid']>;
  cancelRuleId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Max_Order_By = {
  cancelFeeTypeId?: InputMaybe<Order_By>;
  cancelRuleId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CancelRuleFee_Min_Fields = {
  __typename?: 'cancelRuleFee_min_fields';
  cancelFeeTypeId?: Maybe<Scalars['uuid']>;
  cancelRuleId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Min_Order_By = {
  cancelFeeTypeId?: InputMaybe<Order_By>;
  cancelRuleId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Mutation_Response = {
  __typename?: 'cancelRuleFee_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CancelRuleFee>;
};

/** on_conflict condition type for table "compliance.cancel_rule_fee" */
export type CancelRuleFee_On_Conflict = {
  constraint: CancelRuleFee_Constraint;
  update_columns?: Array<CancelRuleFee_Update_Column>;
  where?: InputMaybe<CancelRuleFee_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.cancel_rule_fee". */
export type CancelRuleFee_Order_By = {
  cancelFeeType?: InputMaybe<Type_Order_By>;
  cancelFeeTypeId?: InputMaybe<Order_By>;
  cancelRule?: InputMaybe<CancelRule_Order_By>;
  cancelRuleId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.cancel_rule_fee */
export type CancelRuleFee_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.cancel_rule_fee" */
export enum CancelRuleFee_Select_Column {
  /** column name */
  CancelFeeTypeId = 'cancelFeeTypeId',
  /** column name */
  CancelRuleId = 'cancelRuleId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Set_Input = {
  cancelFeeTypeId?: InputMaybe<Scalars['uuid']>;
  cancelRuleId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  number?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CancelRuleFee_Stddev_Fields = {
  __typename?: 'cancelRuleFee_stddev_fields';
  number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Stddev_Order_By = {
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CancelRuleFee_Stddev_Pop_Fields = {
  __typename?: 'cancelRuleFee_stddev_pop_fields';
  number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Stddev_Pop_Order_By = {
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CancelRuleFee_Stddev_Samp_Fields = {
  __typename?: 'cancelRuleFee_stddev_samp_fields';
  number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Stddev_Samp_Order_By = {
  number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cancelRuleFee" */
export type CancelRuleFee_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CancelRuleFee_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CancelRuleFee_Stream_Cursor_Value_Input = {
  cancelFeeTypeId?: InputMaybe<Scalars['uuid']>;
  cancelRuleId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  number?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CancelRuleFee_Sum_Fields = {
  __typename?: 'cancelRuleFee_sum_fields';
  number?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Sum_Order_By = {
  number?: InputMaybe<Order_By>;
};

/** update columns of table "compliance.cancel_rule_fee" */
export enum CancelRuleFee_Update_Column {
  /** column name */
  CancelFeeTypeId = 'cancelFeeTypeId',
  /** column name */
  CancelRuleId = 'cancelRuleId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CancelRuleFee_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CancelRuleFee_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CancelRuleFee_Set_Input>;
  /** filter the rows which have to be updated */
  where: CancelRuleFee_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CancelRuleFee_Var_Pop_Fields = {
  __typename?: 'cancelRuleFee_var_pop_fields';
  number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Var_Pop_Order_By = {
  number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CancelRuleFee_Var_Samp_Fields = {
  __typename?: 'cancelRuleFee_var_samp_fields';
  number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Var_Samp_Order_By = {
  number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CancelRuleFee_Variance_Fields = {
  __typename?: 'cancelRuleFee_variance_fields';
  number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance.cancel_rule_fee" */
export type CancelRuleFee_Variance_Order_By = {
  number?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance.cancel_rule_refund" */
export type CancelRuleRefund = {
  __typename?: 'cancelRuleRefund';
  /** An object relationship */
  cancelMethodType: Type;
  cancelMethodTypeId: Scalars['uuid'];
  /** An object relationship */
  cancelRule: CancelRule;
  cancelRuleId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "compliance.cancel_rule_refund" */
export type CancelRuleRefund_Aggregate = {
  __typename?: 'cancelRuleRefund_aggregate';
  aggregate?: Maybe<CancelRuleRefund_Aggregate_Fields>;
  nodes: Array<CancelRuleRefund>;
};

export type CancelRuleRefund_Aggregate_Bool_Exp = {
  count?: InputMaybe<CancelRuleRefund_Aggregate_Bool_Exp_Count>;
};

export type CancelRuleRefund_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CancelRuleRefund_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CancelRuleRefund_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance.cancel_rule_refund" */
export type CancelRuleRefund_Aggregate_Fields = {
  __typename?: 'cancelRuleRefund_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CancelRuleRefund_Max_Fields>;
  min?: Maybe<CancelRuleRefund_Min_Fields>;
};


/** aggregate fields of "compliance.cancel_rule_refund" */
export type CancelRuleRefund_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CancelRuleRefund_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance.cancel_rule_refund" */
export type CancelRuleRefund_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CancelRuleRefund_Max_Order_By>;
  min?: InputMaybe<CancelRuleRefund_Min_Order_By>;
};

/** input type for inserting array relation for remote table "compliance.cancel_rule_refund" */
export type CancelRuleRefund_Arr_Rel_Insert_Input = {
  data: Array<CancelRuleRefund_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CancelRuleRefund_On_Conflict>;
};

/** Boolean expression to filter rows from the table "compliance.cancel_rule_refund". All fields are combined with a logical 'AND'. */
export type CancelRuleRefund_Bool_Exp = {
  _and?: InputMaybe<Array<CancelRuleRefund_Bool_Exp>>;
  _not?: InputMaybe<CancelRuleRefund_Bool_Exp>;
  _or?: InputMaybe<Array<CancelRuleRefund_Bool_Exp>>;
  cancelMethodType?: InputMaybe<Type_Bool_Exp>;
  cancelMethodTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  cancelRule?: InputMaybe<CancelRule_Bool_Exp>;
  cancelRuleId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.cancel_rule_refund" */
export enum CancelRuleRefund_Constraint {
  /** unique or primary key constraint on columns "id" */
  CancelRuleRefundPkey = 'cancel_rule_refund_pkey'
}

/** input type for inserting data into table "compliance.cancel_rule_refund" */
export type CancelRuleRefund_Insert_Input = {
  cancelMethodType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  cancelMethodTypeId?: InputMaybe<Scalars['uuid']>;
  cancelRule?: InputMaybe<CancelRule_Obj_Rel_Insert_Input>;
  cancelRuleId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CancelRuleRefund_Max_Fields = {
  __typename?: 'cancelRuleRefund_max_fields';
  cancelMethodTypeId?: Maybe<Scalars['uuid']>;
  cancelRuleId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance.cancel_rule_refund" */
export type CancelRuleRefund_Max_Order_By = {
  cancelMethodTypeId?: InputMaybe<Order_By>;
  cancelRuleId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CancelRuleRefund_Min_Fields = {
  __typename?: 'cancelRuleRefund_min_fields';
  cancelMethodTypeId?: Maybe<Scalars['uuid']>;
  cancelRuleId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance.cancel_rule_refund" */
export type CancelRuleRefund_Min_Order_By = {
  cancelMethodTypeId?: InputMaybe<Order_By>;
  cancelRuleId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance.cancel_rule_refund" */
export type CancelRuleRefund_Mutation_Response = {
  __typename?: 'cancelRuleRefund_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CancelRuleRefund>;
};

/** on_conflict condition type for table "compliance.cancel_rule_refund" */
export type CancelRuleRefund_On_Conflict = {
  constraint: CancelRuleRefund_Constraint;
  update_columns?: Array<CancelRuleRefund_Update_Column>;
  where?: InputMaybe<CancelRuleRefund_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.cancel_rule_refund". */
export type CancelRuleRefund_Order_By = {
  cancelMethodType?: InputMaybe<Type_Order_By>;
  cancelMethodTypeId?: InputMaybe<Order_By>;
  cancelRule?: InputMaybe<CancelRule_Order_By>;
  cancelRuleId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.cancel_rule_refund */
export type CancelRuleRefund_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.cancel_rule_refund" */
export enum CancelRuleRefund_Select_Column {
  /** column name */
  CancelMethodTypeId = 'cancelMethodTypeId',
  /** column name */
  CancelRuleId = 'cancelRuleId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "compliance.cancel_rule_refund" */
export type CancelRuleRefund_Set_Input = {
  cancelMethodTypeId?: InputMaybe<Scalars['uuid']>;
  cancelRuleId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "cancelRuleRefund" */
export type CancelRuleRefund_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CancelRuleRefund_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CancelRuleRefund_Stream_Cursor_Value_Input = {
  cancelMethodTypeId?: InputMaybe<Scalars['uuid']>;
  cancelRuleId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "compliance.cancel_rule_refund" */
export enum CancelRuleRefund_Update_Column {
  /** column name */
  CancelMethodTypeId = 'cancelMethodTypeId',
  /** column name */
  CancelRuleId = 'cancelRuleId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CancelRuleRefund_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CancelRuleRefund_Set_Input>;
  /** filter the rows which have to be updated */
  where: CancelRuleRefund_Bool_Exp;
};

/** aggregated selection of "compliance.cancel_rule" */
export type CancelRule_Aggregate = {
  __typename?: 'cancelRule_aggregate';
  aggregate?: Maybe<CancelRule_Aggregate_Fields>;
  nodes: Array<CancelRule>;
};

export type CancelRule_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<CancelRule_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<CancelRule_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<CancelRule_Aggregate_Bool_Exp_Count>;
};

export type CancelRule_Aggregate_Bool_Exp_Bool_And = {
  arguments: CancelRule_Select_Column_CancelRule_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CancelRule_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type CancelRule_Aggregate_Bool_Exp_Bool_Or = {
  arguments: CancelRule_Select_Column_CancelRule_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CancelRule_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type CancelRule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CancelRule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CancelRule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance.cancel_rule" */
export type CancelRule_Aggregate_Fields = {
  __typename?: 'cancelRule_aggregate_fields';
  avg?: Maybe<CancelRule_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CancelRule_Max_Fields>;
  min?: Maybe<CancelRule_Min_Fields>;
  stddev?: Maybe<CancelRule_Stddev_Fields>;
  stddev_pop?: Maybe<CancelRule_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CancelRule_Stddev_Samp_Fields>;
  sum?: Maybe<CancelRule_Sum_Fields>;
  var_pop?: Maybe<CancelRule_Var_Pop_Fields>;
  var_samp?: Maybe<CancelRule_Var_Samp_Fields>;
  variance?: Maybe<CancelRule_Variance_Fields>;
};


/** aggregate fields of "compliance.cancel_rule" */
export type CancelRule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CancelRule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance.cancel_rule" */
export type CancelRule_Aggregate_Order_By = {
  avg?: InputMaybe<CancelRule_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CancelRule_Max_Order_By>;
  min?: InputMaybe<CancelRule_Min_Order_By>;
  stddev?: InputMaybe<CancelRule_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CancelRule_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CancelRule_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CancelRule_Sum_Order_By>;
  var_pop?: InputMaybe<CancelRule_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CancelRule_Var_Samp_Order_By>;
  variance?: InputMaybe<CancelRule_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "compliance.cancel_rule" */
export type CancelRule_Arr_Rel_Insert_Input = {
  data: Array<CancelRule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CancelRule_On_Conflict>;
};

/** aggregate avg on columns */
export type CancelRule_Avg_Fields = {
  __typename?: 'cancelRule_avg_fields';
  endAgeDays?: Maybe<Scalars['Float']>;
  startAgeDays?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance.cancel_rule" */
export type CancelRule_Avg_Order_By = {
  endAgeDays?: InputMaybe<Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance.cancel_rule". All fields are combined with a logical 'AND'. */
export type CancelRule_Bool_Exp = {
  _and?: InputMaybe<Array<CancelRule_Bool_Exp>>;
  _not?: InputMaybe<CancelRule_Bool_Exp>;
  _or?: InputMaybe<Array<CancelRule_Bool_Exp>>;
  cancelClaimStatusType?: InputMaybe<Type_Bool_Exp>;
  cancelClaimStatusTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  cancelInitiatorType?: InputMaybe<Type_Bool_Exp>;
  cancelInitiatorTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  cancelReasonType?: InputMaybe<Type_Bool_Exp>;
  cancelReasonTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  cancelRuleFees?: InputMaybe<CancelRuleFee_Bool_Exp>;
  cancelRuleFees_aggregate?: InputMaybe<CancelRuleFee_Aggregate_Bool_Exp>;
  cancelRuleRefunds?: InputMaybe<CancelRuleRefund_Bool_Exp>;
  cancelRuleRefunds_aggregate?: InputMaybe<CancelRuleRefund_Aggregate_Bool_Exp>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Bool_Exp>;
  contractFormVersionId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  endAgeDays?: InputMaybe<Numeric_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  filingLender?: InputMaybe<FilingLender_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isBlockRule?: InputMaybe<Boolean_Comparison_Exp>;
  lenderId?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  startAgeDays?: InputMaybe<Numeric_Comparison_Exp>;
  stateAbbreviation?: InputMaybe<String_Comparison_Exp>;
  subtractClaims?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.cancel_rule" */
export enum CancelRule_Constraint {
  /** unique or primary key constraint on columns "id" */
  CancelRulePkey = 'cancel_rule_pkey'
}

/** input type for incrementing numeric columns in table "compliance.cancel_rule" */
export type CancelRule_Inc_Input = {
  endAgeDays?: InputMaybe<Scalars['numeric']>;
  startAgeDays?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "compliance.cancel_rule" */
export type CancelRule_Insert_Input = {
  cancelClaimStatusType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  cancelClaimStatusTypeId?: InputMaybe<Scalars['uuid']>;
  cancelInitiatorType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  cancelInitiatorTypeId?: InputMaybe<Scalars['uuid']>;
  cancelReasonType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  cancelReasonTypeId?: InputMaybe<Scalars['uuid']>;
  cancelRuleFees?: InputMaybe<CancelRuleFee_Arr_Rel_Insert_Input>;
  cancelRuleRefunds?: InputMaybe<CancelRuleRefund_Arr_Rel_Insert_Input>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Obj_Rel_Insert_Input>;
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  endAgeDays?: InputMaybe<Scalars['numeric']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  filingLender?: InputMaybe<FilingLender_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  isBlockRule?: InputMaybe<Scalars['Boolean']>;
  lenderId?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  startAgeDays?: InputMaybe<Scalars['numeric']>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  subtractClaims?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CancelRule_Max_Fields = {
  __typename?: 'cancelRule_max_fields';
  cancelClaimStatusTypeId?: Maybe<Scalars['uuid']>;
  cancelInitiatorTypeId?: Maybe<Scalars['uuid']>;
  cancelReasonTypeId?: Maybe<Scalars['uuid']>;
  contractFormVersionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  endAgeDays?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  lenderId?: Maybe<Scalars['uuid']>;
  startAgeDays?: Maybe<Scalars['numeric']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance.cancel_rule" */
export type CancelRule_Max_Order_By = {
  cancelClaimStatusTypeId?: InputMaybe<Order_By>;
  cancelInitiatorTypeId?: InputMaybe<Order_By>;
  cancelReasonTypeId?: InputMaybe<Order_By>;
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  endAgeDays?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lenderId?: InputMaybe<Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
  stateAbbreviation?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CancelRule_Min_Fields = {
  __typename?: 'cancelRule_min_fields';
  cancelClaimStatusTypeId?: Maybe<Scalars['uuid']>;
  cancelInitiatorTypeId?: Maybe<Scalars['uuid']>;
  cancelReasonTypeId?: Maybe<Scalars['uuid']>;
  contractFormVersionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  endAgeDays?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  lenderId?: Maybe<Scalars['uuid']>;
  startAgeDays?: Maybe<Scalars['numeric']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance.cancel_rule" */
export type CancelRule_Min_Order_By = {
  cancelClaimStatusTypeId?: InputMaybe<Order_By>;
  cancelInitiatorTypeId?: InputMaybe<Order_By>;
  cancelReasonTypeId?: InputMaybe<Order_By>;
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  endAgeDays?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lenderId?: InputMaybe<Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
  stateAbbreviation?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance.cancel_rule" */
export type CancelRule_Mutation_Response = {
  __typename?: 'cancelRule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CancelRule>;
};

/** input type for inserting object relation for remote table "compliance.cancel_rule" */
export type CancelRule_Obj_Rel_Insert_Input = {
  data: CancelRule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CancelRule_On_Conflict>;
};

/** on_conflict condition type for table "compliance.cancel_rule" */
export type CancelRule_On_Conflict = {
  constraint: CancelRule_Constraint;
  update_columns?: Array<CancelRule_Update_Column>;
  where?: InputMaybe<CancelRule_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.cancel_rule". */
export type CancelRule_Order_By = {
  cancelClaimStatusType?: InputMaybe<Type_Order_By>;
  cancelClaimStatusTypeId?: InputMaybe<Order_By>;
  cancelInitiatorType?: InputMaybe<Type_Order_By>;
  cancelInitiatorTypeId?: InputMaybe<Order_By>;
  cancelReasonType?: InputMaybe<Type_Order_By>;
  cancelReasonTypeId?: InputMaybe<Order_By>;
  cancelRuleFees_aggregate?: InputMaybe<CancelRuleFee_Aggregate_Order_By>;
  cancelRuleRefunds_aggregate?: InputMaybe<CancelRuleRefund_Aggregate_Order_By>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Order_By>;
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  endAgeDays?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  filingLender?: InputMaybe<FilingLender_Order_By>;
  id?: InputMaybe<Order_By>;
  isBlockRule?: InputMaybe<Order_By>;
  lenderId?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
  stateAbbreviation?: InputMaybe<Order_By>;
  subtractClaims?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.cancel_rule */
export type CancelRule_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.cancel_rule" */
export enum CancelRule_Select_Column {
  /** column name */
  CancelClaimStatusTypeId = 'cancelClaimStatusTypeId',
  /** column name */
  CancelInitiatorTypeId = 'cancelInitiatorTypeId',
  /** column name */
  CancelReasonTypeId = 'cancelReasonTypeId',
  /** column name */
  ContractFormVersionId = 'contractFormVersionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EndAgeDays = 'endAgeDays',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsBlockRule = 'isBlockRule',
  /** column name */
  LenderId = 'lenderId',
  /** column name */
  StartAgeDays = 'startAgeDays',
  /** column name */
  StateAbbreviation = 'stateAbbreviation',
  /** column name */
  SubtractClaims = 'subtractClaims',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "cancelRule_aggregate_bool_exp_bool_and_arguments_columns" columns of table "compliance.cancel_rule" */
export enum CancelRule_Select_Column_CancelRule_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsBlockRule = 'isBlockRule',
  /** column name */
  SubtractClaims = 'subtractClaims'
}

/** select "cancelRule_aggregate_bool_exp_bool_or_arguments_columns" columns of table "compliance.cancel_rule" */
export enum CancelRule_Select_Column_CancelRule_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsBlockRule = 'isBlockRule',
  /** column name */
  SubtractClaims = 'subtractClaims'
}

/** input type for updating data in table "compliance.cancel_rule" */
export type CancelRule_Set_Input = {
  cancelClaimStatusTypeId?: InputMaybe<Scalars['uuid']>;
  cancelInitiatorTypeId?: InputMaybe<Scalars['uuid']>;
  cancelReasonTypeId?: InputMaybe<Scalars['uuid']>;
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  endAgeDays?: InputMaybe<Scalars['numeric']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isBlockRule?: InputMaybe<Scalars['Boolean']>;
  lenderId?: InputMaybe<Scalars['uuid']>;
  startAgeDays?: InputMaybe<Scalars['numeric']>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  subtractClaims?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CancelRule_Stddev_Fields = {
  __typename?: 'cancelRule_stddev_fields';
  endAgeDays?: Maybe<Scalars['Float']>;
  startAgeDays?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance.cancel_rule" */
export type CancelRule_Stddev_Order_By = {
  endAgeDays?: InputMaybe<Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CancelRule_Stddev_Pop_Fields = {
  __typename?: 'cancelRule_stddev_pop_fields';
  endAgeDays?: Maybe<Scalars['Float']>;
  startAgeDays?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance.cancel_rule" */
export type CancelRule_Stddev_Pop_Order_By = {
  endAgeDays?: InputMaybe<Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CancelRule_Stddev_Samp_Fields = {
  __typename?: 'cancelRule_stddev_samp_fields';
  endAgeDays?: Maybe<Scalars['Float']>;
  startAgeDays?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance.cancel_rule" */
export type CancelRule_Stddev_Samp_Order_By = {
  endAgeDays?: InputMaybe<Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cancelRule" */
export type CancelRule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CancelRule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CancelRule_Stream_Cursor_Value_Input = {
  cancelClaimStatusTypeId?: InputMaybe<Scalars['uuid']>;
  cancelInitiatorTypeId?: InputMaybe<Scalars['uuid']>;
  cancelReasonTypeId?: InputMaybe<Scalars['uuid']>;
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  endAgeDays?: InputMaybe<Scalars['numeric']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isBlockRule?: InputMaybe<Scalars['Boolean']>;
  lenderId?: InputMaybe<Scalars['uuid']>;
  startAgeDays?: InputMaybe<Scalars['numeric']>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  subtractClaims?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CancelRule_Sum_Fields = {
  __typename?: 'cancelRule_sum_fields';
  endAgeDays?: Maybe<Scalars['numeric']>;
  startAgeDays?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "compliance.cancel_rule" */
export type CancelRule_Sum_Order_By = {
  endAgeDays?: InputMaybe<Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
};

/** update columns of table "compliance.cancel_rule" */
export enum CancelRule_Update_Column {
  /** column name */
  CancelClaimStatusTypeId = 'cancelClaimStatusTypeId',
  /** column name */
  CancelInitiatorTypeId = 'cancelInitiatorTypeId',
  /** column name */
  CancelReasonTypeId = 'cancelReasonTypeId',
  /** column name */
  ContractFormVersionId = 'contractFormVersionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EndAgeDays = 'endAgeDays',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsBlockRule = 'isBlockRule',
  /** column name */
  LenderId = 'lenderId',
  /** column name */
  StartAgeDays = 'startAgeDays',
  /** column name */
  StateAbbreviation = 'stateAbbreviation',
  /** column name */
  SubtractClaims = 'subtractClaims',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CancelRule_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CancelRule_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CancelRule_Set_Input>;
  /** filter the rows which have to be updated */
  where: CancelRule_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CancelRule_Var_Pop_Fields = {
  __typename?: 'cancelRule_var_pop_fields';
  endAgeDays?: Maybe<Scalars['Float']>;
  startAgeDays?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance.cancel_rule" */
export type CancelRule_Var_Pop_Order_By = {
  endAgeDays?: InputMaybe<Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CancelRule_Var_Samp_Fields = {
  __typename?: 'cancelRule_var_samp_fields';
  endAgeDays?: Maybe<Scalars['Float']>;
  startAgeDays?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance.cancel_rule" */
export type CancelRule_Var_Samp_Order_By = {
  endAgeDays?: InputMaybe<Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CancelRule_Variance_Fields = {
  __typename?: 'cancelRule_variance_fields';
  endAgeDays?: Maybe<Scalars['Float']>;
  startAgeDays?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance.cancel_rule" */
export type CancelRule_Variance_Order_By = {
  endAgeDays?: InputMaybe<Order_By>;
  startAgeDays?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations.cancellation" */
export type Cancellation = {
  __typename?: 'cancellation';
  accountRefundAmount: Scalars['numeric'];
  cancelAsOfDate?: Maybe<Scalars['date']>;
  cancelFee: Scalars['numeric'];
  claimsPaidAmount: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  mbpiRefundAmount: Scalars['numeric'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  payee?: Maybe<Type>;
  payeeAddress1: Scalars['String'];
  payeeAddress2?: Maybe<Scalars['String']>;
  payeeCity: Scalars['String'];
  payeeName: Scalars['String'];
  payeeState: Scalars['String'];
  payeeTypeId: Scalars['uuid'];
  payeeZip: Scalars['String'];
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  policyContractId: Scalars['uuid'];
  /** An object relationship */
  policyContractQuote?: Maybe<PolicyContractQuote>;
  policyContractQuoteId: Scalars['uuid'];
  reinstateDate?: Maybe<Scalars['timestamptz']>;
  subtractClaims?: Maybe<Scalars['Boolean']>;
  totalRefundAmount: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "operations.cancellation" */
export type CancellationMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Shows which cancellation records have been synced to the AS400 */
export type CancellationAs400 = {
  __typename?: 'cancellationAs400';
  /** An object relationship */
  cancellation: Cancellation;
  cancellationId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "operations.cancellation_as400" */
export type CancellationAs400_Aggregate = {
  __typename?: 'cancellationAs400_aggregate';
  aggregate?: Maybe<CancellationAs400_Aggregate_Fields>;
  nodes: Array<CancellationAs400>;
};

/** aggregate fields of "operations.cancellation_as400" */
export type CancellationAs400_Aggregate_Fields = {
  __typename?: 'cancellationAs400_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CancellationAs400_Max_Fields>;
  min?: Maybe<CancellationAs400_Min_Fields>;
};


/** aggregate fields of "operations.cancellation_as400" */
export type CancellationAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CancellationAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "operations.cancellation_as400". All fields are combined with a logical 'AND'. */
export type CancellationAs400_Bool_Exp = {
  _and?: InputMaybe<Array<CancellationAs400_Bool_Exp>>;
  _not?: InputMaybe<CancellationAs400_Bool_Exp>;
  _or?: InputMaybe<Array<CancellationAs400_Bool_Exp>>;
  cancellation?: InputMaybe<Cancellation_Bool_Exp>;
  cancellationId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.cancellation_as400" */
export enum CancellationAs400_Constraint {
  /** unique or primary key constraint on columns "cancellation_id" */
  CancellationAs400CancellationIdKey = 'cancellation_as400_cancellation_id_key',
  /** unique or primary key constraint on columns "id" */
  CancellationAs400Pkey = 'cancellation_as400_pkey'
}

/** input type for inserting data into table "operations.cancellation_as400" */
export type CancellationAs400_Insert_Input = {
  cancellation?: InputMaybe<Cancellation_Obj_Rel_Insert_Input>;
  cancellationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CancellationAs400_Max_Fields = {
  __typename?: 'cancellationAs400_max_fields';
  cancellationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CancellationAs400_Min_Fields = {
  __typename?: 'cancellationAs400_min_fields';
  cancellationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "operations.cancellation_as400" */
export type CancellationAs400_Mutation_Response = {
  __typename?: 'cancellationAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CancellationAs400>;
};

/** on_conflict condition type for table "operations.cancellation_as400" */
export type CancellationAs400_On_Conflict = {
  constraint: CancellationAs400_Constraint;
  update_columns?: Array<CancellationAs400_Update_Column>;
  where?: InputMaybe<CancellationAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.cancellation_as400". */
export type CancellationAs400_Order_By = {
  cancellation?: InputMaybe<Cancellation_Order_By>;
  cancellationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.cancellation_as400 */
export type CancellationAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.cancellation_as400" */
export enum CancellationAs400_Select_Column {
  /** column name */
  CancellationId = 'cancellationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.cancellation_as400" */
export type CancellationAs400_Set_Input = {
  cancellationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "cancellationAs400" */
export type CancellationAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CancellationAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CancellationAs400_Stream_Cursor_Value_Input = {
  cancellationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "operations.cancellation_as400" */
export enum CancellationAs400_Update_Column {
  /** column name */
  CancellationId = 'cancellationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CancellationAs400_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CancellationAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: CancellationAs400_Bool_Exp;
};

/** aggregated selection of "operations.cancellation" */
export type Cancellation_Aggregate = {
  __typename?: 'cancellation_aggregate';
  aggregate?: Maybe<Cancellation_Aggregate_Fields>;
  nodes: Array<Cancellation>;
};

export type Cancellation_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Cancellation_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cancellation_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Cancellation_Aggregate_Bool_Exp_Count>;
};

export type Cancellation_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cancellation_Select_Column_Cancellation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Cancellation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cancellation_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cancellation_Select_Column_Cancellation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Cancellation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cancellation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cancellation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Cancellation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.cancellation" */
export type Cancellation_Aggregate_Fields = {
  __typename?: 'cancellation_aggregate_fields';
  avg?: Maybe<Cancellation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Cancellation_Max_Fields>;
  min?: Maybe<Cancellation_Min_Fields>;
  stddev?: Maybe<Cancellation_Stddev_Fields>;
  stddev_pop?: Maybe<Cancellation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cancellation_Stddev_Samp_Fields>;
  sum?: Maybe<Cancellation_Sum_Fields>;
  var_pop?: Maybe<Cancellation_Var_Pop_Fields>;
  var_samp?: Maybe<Cancellation_Var_Samp_Fields>;
  variance?: Maybe<Cancellation_Variance_Fields>;
};


/** aggregate fields of "operations.cancellation" */
export type Cancellation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cancellation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.cancellation" */
export type Cancellation_Aggregate_Order_By = {
  avg?: InputMaybe<Cancellation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cancellation_Max_Order_By>;
  min?: InputMaybe<Cancellation_Min_Order_By>;
  stddev?: InputMaybe<Cancellation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cancellation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cancellation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cancellation_Sum_Order_By>;
  var_pop?: InputMaybe<Cancellation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cancellation_Var_Samp_Order_By>;
  variance?: InputMaybe<Cancellation_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Cancellation_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "operations.cancellation" */
export type Cancellation_Arr_Rel_Insert_Input = {
  data: Array<Cancellation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cancellation_On_Conflict>;
};

/** aggregate avg on columns */
export type Cancellation_Avg_Fields = {
  __typename?: 'cancellation_avg_fields';
  accountRefundAmount?: Maybe<Scalars['Float']>;
  cancelFee?: Maybe<Scalars['Float']>;
  claimsPaidAmount?: Maybe<Scalars['Float']>;
  mbpiRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations.cancellation" */
export type Cancellation_Avg_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations.cancellation". All fields are combined with a logical 'AND'. */
export type Cancellation_Bool_Exp = {
  _and?: InputMaybe<Array<Cancellation_Bool_Exp>>;
  _not?: InputMaybe<Cancellation_Bool_Exp>;
  _or?: InputMaybe<Array<Cancellation_Bool_Exp>>;
  accountRefundAmount?: InputMaybe<Numeric_Comparison_Exp>;
  cancelAsOfDate?: InputMaybe<Date_Comparison_Exp>;
  cancelFee?: InputMaybe<Numeric_Comparison_Exp>;
  claimsPaidAmount?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mbpiRefundAmount?: InputMaybe<Numeric_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  payee?: InputMaybe<Type_Bool_Exp>;
  payeeAddress1?: InputMaybe<String_Comparison_Exp>;
  payeeAddress2?: InputMaybe<String_Comparison_Exp>;
  payeeCity?: InputMaybe<String_Comparison_Exp>;
  payeeName?: InputMaybe<String_Comparison_Exp>;
  payeeState?: InputMaybe<String_Comparison_Exp>;
  payeeTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  payeeZip?: InputMaybe<String_Comparison_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContractQuote?: InputMaybe<PolicyContractQuote_Bool_Exp>;
  policyContractQuoteId?: InputMaybe<Uuid_Comparison_Exp>;
  reinstateDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  subtractClaims?: InputMaybe<Boolean_Comparison_Exp>;
  totalRefundAmount?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.cancellation" */
export enum Cancellation_Constraint {
  /** unique or primary key constraint on columns "id" */
  CancellationPkey = 'cancellation_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Cancellation_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Cancellation_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Cancellation_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "operations.cancellation" */
export type Cancellation_Inc_Input = {
  accountRefundAmount?: InputMaybe<Scalars['numeric']>;
  cancelFee?: InputMaybe<Scalars['numeric']>;
  claimsPaidAmount?: InputMaybe<Scalars['numeric']>;
  mbpiRefundAmount?: InputMaybe<Scalars['numeric']>;
  totalRefundAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.cancellation" */
export type Cancellation_Insert_Input = {
  accountRefundAmount?: InputMaybe<Scalars['numeric']>;
  cancelAsOfDate?: InputMaybe<Scalars['date']>;
  cancelFee?: InputMaybe<Scalars['numeric']>;
  claimsPaidAmount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mbpiRefundAmount?: InputMaybe<Scalars['numeric']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  payee?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  payeeAddress1?: InputMaybe<Scalars['String']>;
  payeeAddress2?: InputMaybe<Scalars['String']>;
  payeeCity?: InputMaybe<Scalars['String']>;
  payeeName?: InputMaybe<Scalars['String']>;
  payeeState?: InputMaybe<Scalars['String']>;
  payeeTypeId?: InputMaybe<Scalars['uuid']>;
  payeeZip?: InputMaybe<Scalars['String']>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  policyContractQuote?: InputMaybe<PolicyContractQuote_Obj_Rel_Insert_Input>;
  policyContractQuoteId?: InputMaybe<Scalars['uuid']>;
  reinstateDate?: InputMaybe<Scalars['timestamptz']>;
  subtractClaims?: InputMaybe<Scalars['Boolean']>;
  totalRefundAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Cancellation_Max_Fields = {
  __typename?: 'cancellation_max_fields';
  accountRefundAmount?: Maybe<Scalars['numeric']>;
  cancelAsOfDate?: Maybe<Scalars['date']>;
  cancelFee?: Maybe<Scalars['numeric']>;
  claimsPaidAmount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mbpiRefundAmount?: Maybe<Scalars['numeric']>;
  payeeAddress1?: Maybe<Scalars['String']>;
  payeeAddress2?: Maybe<Scalars['String']>;
  payeeCity?: Maybe<Scalars['String']>;
  payeeName?: Maybe<Scalars['String']>;
  payeeState?: Maybe<Scalars['String']>;
  payeeTypeId?: Maybe<Scalars['uuid']>;
  payeeZip?: Maybe<Scalars['String']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  policyContractQuoteId?: Maybe<Scalars['uuid']>;
  reinstateDate?: Maybe<Scalars['timestamptz']>;
  totalRefundAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.cancellation" */
export type Cancellation_Max_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelAsOfDate?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  payeeAddress1?: InputMaybe<Order_By>;
  payeeAddress2?: InputMaybe<Order_By>;
  payeeCity?: InputMaybe<Order_By>;
  payeeName?: InputMaybe<Order_By>;
  payeeState?: InputMaybe<Order_By>;
  payeeTypeId?: InputMaybe<Order_By>;
  payeeZip?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  policyContractQuoteId?: InputMaybe<Order_By>;
  reinstateDate?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cancellation_Min_Fields = {
  __typename?: 'cancellation_min_fields';
  accountRefundAmount?: Maybe<Scalars['numeric']>;
  cancelAsOfDate?: Maybe<Scalars['date']>;
  cancelFee?: Maybe<Scalars['numeric']>;
  claimsPaidAmount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mbpiRefundAmount?: Maybe<Scalars['numeric']>;
  payeeAddress1?: Maybe<Scalars['String']>;
  payeeAddress2?: Maybe<Scalars['String']>;
  payeeCity?: Maybe<Scalars['String']>;
  payeeName?: Maybe<Scalars['String']>;
  payeeState?: Maybe<Scalars['String']>;
  payeeTypeId?: Maybe<Scalars['uuid']>;
  payeeZip?: Maybe<Scalars['String']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  policyContractQuoteId?: Maybe<Scalars['uuid']>;
  reinstateDate?: Maybe<Scalars['timestamptz']>;
  totalRefundAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.cancellation" */
export type Cancellation_Min_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelAsOfDate?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  payeeAddress1?: InputMaybe<Order_By>;
  payeeAddress2?: InputMaybe<Order_By>;
  payeeCity?: InputMaybe<Order_By>;
  payeeName?: InputMaybe<Order_By>;
  payeeState?: InputMaybe<Order_By>;
  payeeTypeId?: InputMaybe<Order_By>;
  payeeZip?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  policyContractQuoteId?: InputMaybe<Order_By>;
  reinstateDate?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.cancellation" */
export type Cancellation_Mutation_Response = {
  __typename?: 'cancellation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cancellation>;
};

/** input type for inserting object relation for remote table "operations.cancellation" */
export type Cancellation_Obj_Rel_Insert_Input = {
  data: Cancellation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cancellation_On_Conflict>;
};

/** on_conflict condition type for table "operations.cancellation" */
export type Cancellation_On_Conflict = {
  constraint: Cancellation_Constraint;
  update_columns?: Array<Cancellation_Update_Column>;
  where?: InputMaybe<Cancellation_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.cancellation". */
export type Cancellation_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelAsOfDate?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  payee?: InputMaybe<Type_Order_By>;
  payeeAddress1?: InputMaybe<Order_By>;
  payeeAddress2?: InputMaybe<Order_By>;
  payeeCity?: InputMaybe<Order_By>;
  payeeName?: InputMaybe<Order_By>;
  payeeState?: InputMaybe<Order_By>;
  payeeTypeId?: InputMaybe<Order_By>;
  payeeZip?: InputMaybe<Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  policyContractQuote?: InputMaybe<PolicyContractQuote_Order_By>;
  policyContractQuoteId?: InputMaybe<Order_By>;
  reinstateDate?: InputMaybe<Order_By>;
  subtractClaims?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.cancellation */
export type Cancellation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Cancellation_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "operations.cancellation" */
export enum Cancellation_Select_Column {
  /** column name */
  AccountRefundAmount = 'accountRefundAmount',
  /** column name */
  CancelAsOfDate = 'cancelAsOfDate',
  /** column name */
  CancelFee = 'cancelFee',
  /** column name */
  ClaimsPaidAmount = 'claimsPaidAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  MbpiRefundAmount = 'mbpiRefundAmount',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PayeeAddress1 = 'payeeAddress1',
  /** column name */
  PayeeAddress2 = 'payeeAddress2',
  /** column name */
  PayeeCity = 'payeeCity',
  /** column name */
  PayeeName = 'payeeName',
  /** column name */
  PayeeState = 'payeeState',
  /** column name */
  PayeeTypeId = 'payeeTypeId',
  /** column name */
  PayeeZip = 'payeeZip',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  PolicyContractQuoteId = 'policyContractQuoteId',
  /** column name */
  ReinstateDate = 'reinstateDate',
  /** column name */
  SubtractClaims = 'subtractClaims',
  /** column name */
  TotalRefundAmount = 'totalRefundAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "cancellation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "operations.cancellation" */
export enum Cancellation_Select_Column_Cancellation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  SubtractClaims = 'subtractClaims'
}

/** select "cancellation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "operations.cancellation" */
export enum Cancellation_Select_Column_Cancellation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  SubtractClaims = 'subtractClaims'
}

/** input type for updating data in table "operations.cancellation" */
export type Cancellation_Set_Input = {
  accountRefundAmount?: InputMaybe<Scalars['numeric']>;
  cancelAsOfDate?: InputMaybe<Scalars['date']>;
  cancelFee?: InputMaybe<Scalars['numeric']>;
  claimsPaidAmount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mbpiRefundAmount?: InputMaybe<Scalars['numeric']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  payeeAddress1?: InputMaybe<Scalars['String']>;
  payeeAddress2?: InputMaybe<Scalars['String']>;
  payeeCity?: InputMaybe<Scalars['String']>;
  payeeName?: InputMaybe<Scalars['String']>;
  payeeState?: InputMaybe<Scalars['String']>;
  payeeTypeId?: InputMaybe<Scalars['uuid']>;
  payeeZip?: InputMaybe<Scalars['String']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  policyContractQuoteId?: InputMaybe<Scalars['uuid']>;
  reinstateDate?: InputMaybe<Scalars['timestamptz']>;
  subtractClaims?: InputMaybe<Scalars['Boolean']>;
  totalRefundAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Cancellation_Stddev_Fields = {
  __typename?: 'cancellation_stddev_fields';
  accountRefundAmount?: Maybe<Scalars['Float']>;
  cancelFee?: Maybe<Scalars['Float']>;
  claimsPaidAmount?: Maybe<Scalars['Float']>;
  mbpiRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations.cancellation" */
export type Cancellation_Stddev_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cancellation_Stddev_Pop_Fields = {
  __typename?: 'cancellation_stddev_pop_fields';
  accountRefundAmount?: Maybe<Scalars['Float']>;
  cancelFee?: Maybe<Scalars['Float']>;
  claimsPaidAmount?: Maybe<Scalars['Float']>;
  mbpiRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations.cancellation" */
export type Cancellation_Stddev_Pop_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cancellation_Stddev_Samp_Fields = {
  __typename?: 'cancellation_stddev_samp_fields';
  accountRefundAmount?: Maybe<Scalars['Float']>;
  cancelFee?: Maybe<Scalars['Float']>;
  claimsPaidAmount?: Maybe<Scalars['Float']>;
  mbpiRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations.cancellation" */
export type Cancellation_Stddev_Samp_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cancellation" */
export type Cancellation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cancellation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cancellation_Stream_Cursor_Value_Input = {
  accountRefundAmount?: InputMaybe<Scalars['numeric']>;
  cancelAsOfDate?: InputMaybe<Scalars['date']>;
  cancelFee?: InputMaybe<Scalars['numeric']>;
  claimsPaidAmount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mbpiRefundAmount?: InputMaybe<Scalars['numeric']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  payeeAddress1?: InputMaybe<Scalars['String']>;
  payeeAddress2?: InputMaybe<Scalars['String']>;
  payeeCity?: InputMaybe<Scalars['String']>;
  payeeName?: InputMaybe<Scalars['String']>;
  payeeState?: InputMaybe<Scalars['String']>;
  payeeTypeId?: InputMaybe<Scalars['uuid']>;
  payeeZip?: InputMaybe<Scalars['String']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  policyContractQuoteId?: InputMaybe<Scalars['uuid']>;
  reinstateDate?: InputMaybe<Scalars['timestamptz']>;
  subtractClaims?: InputMaybe<Scalars['Boolean']>;
  totalRefundAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Cancellation_Sum_Fields = {
  __typename?: 'cancellation_sum_fields';
  accountRefundAmount?: Maybe<Scalars['numeric']>;
  cancelFee?: Maybe<Scalars['numeric']>;
  claimsPaidAmount?: Maybe<Scalars['numeric']>;
  mbpiRefundAmount?: Maybe<Scalars['numeric']>;
  totalRefundAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "operations.cancellation" */
export type Cancellation_Sum_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
};

/** update columns of table "operations.cancellation" */
export enum Cancellation_Update_Column {
  /** column name */
  AccountRefundAmount = 'accountRefundAmount',
  /** column name */
  CancelAsOfDate = 'cancelAsOfDate',
  /** column name */
  CancelFee = 'cancelFee',
  /** column name */
  ClaimsPaidAmount = 'claimsPaidAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  MbpiRefundAmount = 'mbpiRefundAmount',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PayeeAddress1 = 'payeeAddress1',
  /** column name */
  PayeeAddress2 = 'payeeAddress2',
  /** column name */
  PayeeCity = 'payeeCity',
  /** column name */
  PayeeName = 'payeeName',
  /** column name */
  PayeeState = 'payeeState',
  /** column name */
  PayeeTypeId = 'payeeTypeId',
  /** column name */
  PayeeZip = 'payeeZip',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  PolicyContractQuoteId = 'policyContractQuoteId',
  /** column name */
  ReinstateDate = 'reinstateDate',
  /** column name */
  SubtractClaims = 'subtractClaims',
  /** column name */
  TotalRefundAmount = 'totalRefundAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Cancellation_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Cancellation_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Cancellation_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Cancellation_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Cancellation_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cancellation_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Cancellation_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cancellation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cancellation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cancellation_Var_Pop_Fields = {
  __typename?: 'cancellation_var_pop_fields';
  accountRefundAmount?: Maybe<Scalars['Float']>;
  cancelFee?: Maybe<Scalars['Float']>;
  claimsPaidAmount?: Maybe<Scalars['Float']>;
  mbpiRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations.cancellation" */
export type Cancellation_Var_Pop_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cancellation_Var_Samp_Fields = {
  __typename?: 'cancellation_var_samp_fields';
  accountRefundAmount?: Maybe<Scalars['Float']>;
  cancelFee?: Maybe<Scalars['Float']>;
  claimsPaidAmount?: Maybe<Scalars['Float']>;
  mbpiRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations.cancellation" */
export type Cancellation_Var_Samp_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cancellation_Variance_Fields = {
  __typename?: 'cancellation_variance_fields';
  accountRefundAmount?: Maybe<Scalars['Float']>;
  cancelFee?: Maybe<Scalars['Float']>;
  claimsPaidAmount?: Maybe<Scalars['Float']>;
  mbpiRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations.cancellation" */
export type Cancellation_Variance_Order_By = {
  accountRefundAmount?: InputMaybe<Order_By>;
  cancelFee?: InputMaybe<Order_By>;
  claimsPaidAmount?: InputMaybe<Order_By>;
  mbpiRefundAmount?: InputMaybe<Order_By>;
  totalRefundAmount?: InputMaybe<Order_By>;
};

/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type Capability = {
  __typename?: 'capability';
  /** An object relationship */
  application: Application;
  /** The application that administers this Capability. */
  applicationId: Scalars['uuid'];
  /** An array relationship */
  approvals: Array<Approval>;
  /** An aggregate relationship */
  approvals_aggregate: Approval_Aggregate;
  /** An array relationship */
  authorities: Array<ApprovalAuthority>;
  /** An aggregate relationship */
  authorities_aggregate: ApprovalAuthority_Aggregate;
  /** An array relationship */
  capabilityRoutes: Array<CapabilityRoute>;
  /** An aggregate relationship */
  capabilityRoutes_aggregate: CapabilityRoute_Aggregate;
  /** An array relationship */
  configs: Array<CapabilityConfig>;
  /** An aggregate relationship */
  configs_aggregate: CapabilityConfig_Aggregate;
  createdAt: Scalars['timestamptz'];
  /** Human-readable label shown in admin screens. */
  display: Scalars['String'];
  /** An array relationship */
  gates: Array<ApprovalGate>;
  /** An aggregate relationship */
  gates_aggregate: ApprovalGate_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  identityCapabilities: Array<IdentityCapability>;
  /** An aggregate relationship */
  identityCapabilities_aggregate: IdentityCapability_Aggregate;
  /** PascalCase, no spaces, unique — the stable identifier the UI and the secure attribute reference (e.g. PayClaim). */
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approval_Order_By>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityApprovals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approval_Order_By>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityAuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<ApprovalAuthority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalAuthority_Order_By>>;
  where?: InputMaybe<ApprovalAuthority_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityAuthorities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalAuthority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalAuthority_Order_By>>;
  where?: InputMaybe<ApprovalAuthority_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityCapabilityRoutesArgs = {
  distinct_on?: InputMaybe<Array<CapabilityRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityRoute_Order_By>>;
  where?: InputMaybe<CapabilityRoute_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityCapabilityRoutes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CapabilityRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityRoute_Order_By>>;
  where?: InputMaybe<CapabilityRoute_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityConfigsArgs = {
  distinct_on?: InputMaybe<Array<CapabilityConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityConfig_Order_By>>;
  where?: InputMaybe<CapabilityConfig_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityConfigs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CapabilityConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityConfig_Order_By>>;
  where?: InputMaybe<CapabilityConfig_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityGatesArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGate_Order_By>>;
  where?: InputMaybe<ApprovalGate_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityGates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGate_Order_By>>;
  where?: InputMaybe<ApprovalGate_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityIdentityCapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapability_Order_By>>;
  where?: InputMaybe<IdentityCapability_Bool_Exp>;
};


/** A named thing a user may be permitted to do, identified by a uuid and independent of how it is reached — a URL, a button, or a direct mutation. Permission is granted on the Capability; a route is one way a Capability is reached, not the thing permission hangs off. Nothing here concerns approvals: a Capability needing a second gate gets an approvals.gate row, and most never will. IT-6672. */
export type CapabilityIdentityCapabilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapability_Order_By>>;
  where?: InputMaybe<IdentityCapability_Bool_Exp>;
};

/** Table-level access a Capability confers, for use in Hasura permission expressions: they traverse identity_capability -> capability -> configs instead of listing route uuids inline. Same columns as auth.route_config, one level up, so the fact is stated once per Capability rather than once per route. IT-6672. */
export type CapabilityConfig = {
  __typename?: 'capabilityConfig';
  /** Whether this Capability allows delete on the table. */
  canDelete: Scalars['Boolean'];
  /** Whether this Capability allows insert on the table. */
  canInsert: Scalars['Boolean'];
  /** Whether this Capability allows select on the table. */
  canSelect: Scalars['Boolean'];
  /** Whether this Capability allows update on the table. */
  canUpdate: Scalars['Boolean'];
  /** An object relationship */
  capability: Capability;
  /** The Capability conferring this access. */
  capabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** Full table name including schema (e.g. shared.document_instance), matching auth.route_config.table_name. */
  tableName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "auth.capability_config" */
export type CapabilityConfig_Aggregate = {
  __typename?: 'capabilityConfig_aggregate';
  aggregate?: Maybe<CapabilityConfig_Aggregate_Fields>;
  nodes: Array<CapabilityConfig>;
};

export type CapabilityConfig_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<CapabilityConfig_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<CapabilityConfig_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<CapabilityConfig_Aggregate_Bool_Exp_Count>;
};

export type CapabilityConfig_Aggregate_Bool_Exp_Bool_And = {
  arguments: CapabilityConfig_Select_Column_CapabilityConfig_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CapabilityConfig_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type CapabilityConfig_Aggregate_Bool_Exp_Bool_Or = {
  arguments: CapabilityConfig_Select_Column_CapabilityConfig_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CapabilityConfig_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type CapabilityConfig_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CapabilityConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CapabilityConfig_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.capability_config" */
export type CapabilityConfig_Aggregate_Fields = {
  __typename?: 'capabilityConfig_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CapabilityConfig_Max_Fields>;
  min?: Maybe<CapabilityConfig_Min_Fields>;
};


/** aggregate fields of "auth.capability_config" */
export type CapabilityConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CapabilityConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.capability_config" */
export type CapabilityConfig_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CapabilityConfig_Max_Order_By>;
  min?: InputMaybe<CapabilityConfig_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.capability_config" */
export type CapabilityConfig_Arr_Rel_Insert_Input = {
  data: Array<CapabilityConfig_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CapabilityConfig_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.capability_config". All fields are combined with a logical 'AND'. */
export type CapabilityConfig_Bool_Exp = {
  _and?: InputMaybe<Array<CapabilityConfig_Bool_Exp>>;
  _not?: InputMaybe<CapabilityConfig_Bool_Exp>;
  _or?: InputMaybe<Array<CapabilityConfig_Bool_Exp>>;
  canDelete?: InputMaybe<Boolean_Comparison_Exp>;
  canInsert?: InputMaybe<Boolean_Comparison_Exp>;
  canSelect?: InputMaybe<Boolean_Comparison_Exp>;
  canUpdate?: InputMaybe<Boolean_Comparison_Exp>;
  capability?: InputMaybe<Capability_Bool_Exp>;
  capabilityId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  tableName?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.capability_config" */
export enum CapabilityConfig_Constraint {
  /** unique or primary key constraint on columns "capability_id", "table_name" */
  CapabilityConfigCapabilityIdTableNameKey = 'capability_config_capability_id_table_name_key',
  /** unique or primary key constraint on columns "id" */
  CapabilityConfigPkey = 'capability_config_pkey'
}

/** input type for inserting data into table "auth.capability_config" */
export type CapabilityConfig_Insert_Input = {
  /** Whether this Capability allows delete on the table. */
  canDelete?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Capability allows insert on the table. */
  canInsert?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Capability allows select on the table. */
  canSelect?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Capability allows update on the table. */
  canUpdate?: InputMaybe<Scalars['Boolean']>;
  capability?: InputMaybe<Capability_Obj_Rel_Insert_Input>;
  /** The Capability conferring this access. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Full table name including schema (e.g. shared.document_instance), matching auth.route_config.table_name. */
  tableName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CapabilityConfig_Max_Fields = {
  __typename?: 'capabilityConfig_max_fields';
  /** The Capability conferring this access. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Full table name including schema (e.g. shared.document_instance), matching auth.route_config.table_name. */
  tableName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.capability_config" */
export type CapabilityConfig_Max_Order_By = {
  /** The Capability conferring this access. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Full table name including schema (e.g. shared.document_instance), matching auth.route_config.table_name. */
  tableName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CapabilityConfig_Min_Fields = {
  __typename?: 'capabilityConfig_min_fields';
  /** The Capability conferring this access. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Full table name including schema (e.g. shared.document_instance), matching auth.route_config.table_name. */
  tableName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.capability_config" */
export type CapabilityConfig_Min_Order_By = {
  /** The Capability conferring this access. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Full table name including schema (e.g. shared.document_instance), matching auth.route_config.table_name. */
  tableName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.capability_config" */
export type CapabilityConfig_Mutation_Response = {
  __typename?: 'capabilityConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CapabilityConfig>;
};

/** on_conflict condition type for table "auth.capability_config" */
export type CapabilityConfig_On_Conflict = {
  constraint: CapabilityConfig_Constraint;
  update_columns?: Array<CapabilityConfig_Update_Column>;
  where?: InputMaybe<CapabilityConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.capability_config". */
export type CapabilityConfig_Order_By = {
  canDelete?: InputMaybe<Order_By>;
  canInsert?: InputMaybe<Order_By>;
  canSelect?: InputMaybe<Order_By>;
  canUpdate?: InputMaybe<Order_By>;
  capability?: InputMaybe<Capability_Order_By>;
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tableName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.capability_config */
export type CapabilityConfig_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.capability_config" */
export enum CapabilityConfig_Select_Column {
  /** column name */
  CanDelete = 'canDelete',
  /** column name */
  CanInsert = 'canInsert',
  /** column name */
  CanSelect = 'canSelect',
  /** column name */
  CanUpdate = 'canUpdate',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  TableName = 'tableName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "capabilityConfig_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.capability_config" */
export enum CapabilityConfig_Select_Column_CapabilityConfig_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CanDelete = 'canDelete',
  /** column name */
  CanInsert = 'canInsert',
  /** column name */
  CanSelect = 'canSelect',
  /** column name */
  CanUpdate = 'canUpdate'
}

/** select "capabilityConfig_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.capability_config" */
export enum CapabilityConfig_Select_Column_CapabilityConfig_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CanDelete = 'canDelete',
  /** column name */
  CanInsert = 'canInsert',
  /** column name */
  CanSelect = 'canSelect',
  /** column name */
  CanUpdate = 'canUpdate'
}

/** input type for updating data in table "auth.capability_config" */
export type CapabilityConfig_Set_Input = {
  /** Whether this Capability allows delete on the table. */
  canDelete?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Capability allows insert on the table. */
  canInsert?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Capability allows select on the table. */
  canSelect?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Capability allows update on the table. */
  canUpdate?: InputMaybe<Scalars['Boolean']>;
  /** The Capability conferring this access. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Full table name including schema (e.g. shared.document_instance), matching auth.route_config.table_name. */
  tableName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "capabilityConfig" */
export type CapabilityConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CapabilityConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CapabilityConfig_Stream_Cursor_Value_Input = {
  /** Whether this Capability allows delete on the table. */
  canDelete?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Capability allows insert on the table. */
  canInsert?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Capability allows select on the table. */
  canSelect?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Capability allows update on the table. */
  canUpdate?: InputMaybe<Scalars['Boolean']>;
  /** The Capability conferring this access. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Full table name including schema (e.g. shared.document_instance), matching auth.route_config.table_name. */
  tableName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.capability_config" */
export enum CapabilityConfig_Update_Column {
  /** column name */
  CanDelete = 'canDelete',
  /** column name */
  CanInsert = 'canInsert',
  /** column name */
  CanSelect = 'canSelect',
  /** column name */
  CanUpdate = 'canUpdate',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  TableName = 'tableName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CapabilityConfig_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CapabilityConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: CapabilityConfig_Bool_Exp;
};

/** Which routes a Capability grants access to. Many-to-many on purpose: 22 routes belong to more than one bundle, so a capability_id column on auth.route would silently drop grants. This is the mapping that was previously a hard-coded CTE per bundle inside auth.apply_user_permissions. IT-6672. */
export type CapabilityRoute = {
  __typename?: 'capabilityRoute';
  /** An object relationship */
  capability: Capability;
  /** The Capability granting access. */
  capabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  route: Route;
  /** A route the Capability grants. A route reached by several Capabilities has a row per Capability. */
  routeId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "auth.capability_route" */
export type CapabilityRoute_Aggregate = {
  __typename?: 'capabilityRoute_aggregate';
  aggregate?: Maybe<CapabilityRoute_Aggregate_Fields>;
  nodes: Array<CapabilityRoute>;
};

export type CapabilityRoute_Aggregate_Bool_Exp = {
  count?: InputMaybe<CapabilityRoute_Aggregate_Bool_Exp_Count>;
};

export type CapabilityRoute_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CapabilityRoute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CapabilityRoute_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.capability_route" */
export type CapabilityRoute_Aggregate_Fields = {
  __typename?: 'capabilityRoute_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CapabilityRoute_Max_Fields>;
  min?: Maybe<CapabilityRoute_Min_Fields>;
};


/** aggregate fields of "auth.capability_route" */
export type CapabilityRoute_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CapabilityRoute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.capability_route" */
export type CapabilityRoute_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CapabilityRoute_Max_Order_By>;
  min?: InputMaybe<CapabilityRoute_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.capability_route" */
export type CapabilityRoute_Arr_Rel_Insert_Input = {
  data: Array<CapabilityRoute_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CapabilityRoute_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.capability_route". All fields are combined with a logical 'AND'. */
export type CapabilityRoute_Bool_Exp = {
  _and?: InputMaybe<Array<CapabilityRoute_Bool_Exp>>;
  _not?: InputMaybe<CapabilityRoute_Bool_Exp>;
  _or?: InputMaybe<Array<CapabilityRoute_Bool_Exp>>;
  capability?: InputMaybe<Capability_Bool_Exp>;
  capabilityId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  route?: InputMaybe<Route_Bool_Exp>;
  routeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.capability_route" */
export enum CapabilityRoute_Constraint {
  /** unique or primary key constraint on columns "capability_id", "route_id" */
  CapabilityRouteCapabilityIdRouteIdKey = 'capability_route_capability_id_route_id_key',
  /** unique or primary key constraint on columns "id" */
  CapabilityRoutePkey = 'capability_route_pkey'
}

/** input type for inserting data into table "auth.capability_route" */
export type CapabilityRoute_Insert_Input = {
  capability?: InputMaybe<Capability_Obj_Rel_Insert_Input>;
  /** The Capability granting access. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  route?: InputMaybe<Route_Obj_Rel_Insert_Input>;
  /** A route the Capability grants. A route reached by several Capabilities has a row per Capability. */
  routeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CapabilityRoute_Max_Fields = {
  __typename?: 'capabilityRoute_max_fields';
  /** The Capability granting access. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** A route the Capability grants. A route reached by several Capabilities has a row per Capability. */
  routeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.capability_route" */
export type CapabilityRoute_Max_Order_By = {
  /** The Capability granting access. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** A route the Capability grants. A route reached by several Capabilities has a row per Capability. */
  routeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CapabilityRoute_Min_Fields = {
  __typename?: 'capabilityRoute_min_fields';
  /** The Capability granting access. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** A route the Capability grants. A route reached by several Capabilities has a row per Capability. */
  routeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.capability_route" */
export type CapabilityRoute_Min_Order_By = {
  /** The Capability granting access. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** A route the Capability grants. A route reached by several Capabilities has a row per Capability. */
  routeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.capability_route" */
export type CapabilityRoute_Mutation_Response = {
  __typename?: 'capabilityRoute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CapabilityRoute>;
};

/** on_conflict condition type for table "auth.capability_route" */
export type CapabilityRoute_On_Conflict = {
  constraint: CapabilityRoute_Constraint;
  update_columns?: Array<CapabilityRoute_Update_Column>;
  where?: InputMaybe<CapabilityRoute_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.capability_route". */
export type CapabilityRoute_Order_By = {
  capability?: InputMaybe<Capability_Order_By>;
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  route?: InputMaybe<Route_Order_By>;
  routeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.capability_route */
export type CapabilityRoute_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.capability_route" */
export enum CapabilityRoute_Select_Column {
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RouteId = 'routeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.capability_route" */
export type CapabilityRoute_Set_Input = {
  /** The Capability granting access. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** A route the Capability grants. A route reached by several Capabilities has a row per Capability. */
  routeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "capabilityRoute" */
export type CapabilityRoute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CapabilityRoute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CapabilityRoute_Stream_Cursor_Value_Input = {
  /** The Capability granting access. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** A route the Capability grants. A route reached by several Capabilities has a row per Capability. */
  routeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.capability_route" */
export enum CapabilityRoute_Update_Column {
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RouteId = 'routeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CapabilityRoute_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CapabilityRoute_Set_Input>;
  /** filter the rows which have to be updated */
  where: CapabilityRoute_Bool_Exp;
};

/** aggregated selection of "auth.capability" */
export type Capability_Aggregate = {
  __typename?: 'capability_aggregate';
  aggregate?: Maybe<Capability_Aggregate_Fields>;
  nodes: Array<Capability>;
};

/** aggregate fields of "auth.capability" */
export type Capability_Aggregate_Fields = {
  __typename?: 'capability_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Capability_Max_Fields>;
  min?: Maybe<Capability_Min_Fields>;
};


/** aggregate fields of "auth.capability" */
export type Capability_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Capability_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "auth.capability". All fields are combined with a logical 'AND'. */
export type Capability_Bool_Exp = {
  _and?: InputMaybe<Array<Capability_Bool_Exp>>;
  _not?: InputMaybe<Capability_Bool_Exp>;
  _or?: InputMaybe<Array<Capability_Bool_Exp>>;
  application?: InputMaybe<Application_Bool_Exp>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  approvals?: InputMaybe<Approval_Bool_Exp>;
  approvals_aggregate?: InputMaybe<Approval_Aggregate_Bool_Exp>;
  authorities?: InputMaybe<ApprovalAuthority_Bool_Exp>;
  authorities_aggregate?: InputMaybe<ApprovalAuthority_Aggregate_Bool_Exp>;
  capabilityRoutes?: InputMaybe<CapabilityRoute_Bool_Exp>;
  capabilityRoutes_aggregate?: InputMaybe<CapabilityRoute_Aggregate_Bool_Exp>;
  configs?: InputMaybe<CapabilityConfig_Bool_Exp>;
  configs_aggregate?: InputMaybe<CapabilityConfig_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  gates?: InputMaybe<ApprovalGate_Bool_Exp>;
  gates_aggregate?: InputMaybe<ApprovalGate_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityCapabilities?: InputMaybe<IdentityCapability_Bool_Exp>;
  identityCapabilities_aggregate?: InputMaybe<IdentityCapability_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.capability" */
export enum Capability_Constraint {
  /** unique or primary key constraint on columns "name" */
  CapabilityNameKey = 'capability_name_key',
  /** unique or primary key constraint on columns "id" */
  CapabilityPkey = 'capability_pkey'
}

/** input type for inserting data into table "auth.capability" */
export type Capability_Insert_Input = {
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  /** The application that administers this Capability. */
  applicationId?: InputMaybe<Scalars['uuid']>;
  approvals?: InputMaybe<Approval_Arr_Rel_Insert_Input>;
  authorities?: InputMaybe<ApprovalAuthority_Arr_Rel_Insert_Input>;
  capabilityRoutes?: InputMaybe<CapabilityRoute_Arr_Rel_Insert_Input>;
  configs?: InputMaybe<CapabilityConfig_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Human-readable label shown in admin screens. */
  display?: InputMaybe<Scalars['String']>;
  gates?: InputMaybe<ApprovalGate_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  identityCapabilities?: InputMaybe<IdentityCapability_Arr_Rel_Insert_Input>;
  /** PascalCase, no spaces, unique — the stable identifier the UI and the secure attribute reference (e.g. PayClaim). */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Capability_Max_Fields = {
  __typename?: 'capability_max_fields';
  /** The application that administers this Capability. */
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Human-readable label shown in admin screens. */
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** PascalCase, no spaces, unique — the stable identifier the UI and the secure attribute reference (e.g. PayClaim). */
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Capability_Min_Fields = {
  __typename?: 'capability_min_fields';
  /** The application that administers this Capability. */
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Human-readable label shown in admin screens. */
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** PascalCase, no spaces, unique — the stable identifier the UI and the secure attribute reference (e.g. PayClaim). */
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "auth.capability" */
export type Capability_Mutation_Response = {
  __typename?: 'capability_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Capability>;
};

/** input type for inserting object relation for remote table "auth.capability" */
export type Capability_Obj_Rel_Insert_Input = {
  data: Capability_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Capability_On_Conflict>;
};

/** on_conflict condition type for table "auth.capability" */
export type Capability_On_Conflict = {
  constraint: Capability_Constraint;
  update_columns?: Array<Capability_Update_Column>;
  where?: InputMaybe<Capability_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.capability". */
export type Capability_Order_By = {
  application?: InputMaybe<Application_Order_By>;
  applicationId?: InputMaybe<Order_By>;
  approvals_aggregate?: InputMaybe<Approval_Aggregate_Order_By>;
  authorities_aggregate?: InputMaybe<ApprovalAuthority_Aggregate_Order_By>;
  capabilityRoutes_aggregate?: InputMaybe<CapabilityRoute_Aggregate_Order_By>;
  configs_aggregate?: InputMaybe<CapabilityConfig_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  gates_aggregate?: InputMaybe<ApprovalGate_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  identityCapabilities_aggregate?: InputMaybe<IdentityCapability_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.capability */
export type Capability_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.capability" */
export enum Capability_Select_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.capability" */
export type Capability_Set_Input = {
  /** The application that administers this Capability. */
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Human-readable label shown in admin screens. */
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** PascalCase, no spaces, unique — the stable identifier the UI and the secure attribute reference (e.g. PayClaim). */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "capability" */
export type Capability_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Capability_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Capability_Stream_Cursor_Value_Input = {
  /** The application that administers this Capability. */
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Human-readable label shown in admin screens. */
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** PascalCase, no spaces, unique — the stable identifier the UI and the secure attribute reference (e.g. PayClaim). */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.capability" */
export enum Capability_Update_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Capability_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Capability_Set_Input>;
  /** filter the rows which have to be updated */
  where: Capability_Bool_Exp;
};

/**
 * Per-user arrangement of the cards on a detail screen: row, start column, width in
 * twelfths and hidden state, saved as named views the user switches between. One row
 * per identity and route — not per record, so one layout applies to every claim
 * of that type. Absence of a row means the screen renders its code default.
 */
export type CardLayout = {
  __typename?: 'cardLayout';
  /** When this identity first saved a view for this screen. */
  createdAt: Scalars['timestamptz'];
  /** Primary key. */
  id: Scalars['uuid'];
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId: Scalars['uuid'];
  /**
   * { version, columns, activeView, views: [{ name, rows, hidden }] }.
   * rows is run-length: [[{id, w}, ...], ...] where w is a width in twelfths and each row
   * sums to at most 12. Array position is the display order. Card ids absent from the
   * current template are retained so a conditionally rendered card keeps its place. An
   * activeView naming a view that no longer exists falls back to the virtual "Default".
   */
  layout: Scalars['jsonb'];
  /** An object relationship */
  route: Route;
  /**
   * The screen this layout belongs to: auth.route.id, the same identifier the
   * permission system grants against. Not a record id — a route stands for the KIND of
   * screen (/claims/mechanical/[id]), so one layout applies to every claim of that type.
   *
   * A generated, closed set, so there is no second naming scheme to keep in step with
   * the routes and no application-level allow-list to maintain. Route ids are preserved
   * by hand when a path moves, which is what lets a layout outlive a route rename.
   * ON DELETE CASCADE: a layout for a screen that no longer exists is unreachable.
   */
  routeId: Scalars['uuid'];
  /** Maintained by the set_users_card_layout_updated_at trigger. */
  updatedAt: Scalars['timestamptz'];
};


/**
 * Per-user arrangement of the cards on a detail screen: row, start column, width in
 * twelfths and hidden state, saved as named views the user switches between. One row
 * per identity and route — not per record, so one layout applies to every claim
 * of that type. Absence of a row means the screen renders its code default.
 */
export type CardLayoutLayoutArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "users.card_layout" */
export type CardLayout_Aggregate = {
  __typename?: 'cardLayout_aggregate';
  aggregate?: Maybe<CardLayout_Aggregate_Fields>;
  nodes: Array<CardLayout>;
};

/** aggregate fields of "users.card_layout" */
export type CardLayout_Aggregate_Fields = {
  __typename?: 'cardLayout_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CardLayout_Max_Fields>;
  min?: Maybe<CardLayout_Min_Fields>;
};


/** aggregate fields of "users.card_layout" */
export type CardLayout_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CardLayout_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CardLayout_Append_Input = {
  /**
   * { version, columns, activeView, views: [{ name, rows, hidden }] }.
   * rows is run-length: [[{id, w}, ...], ...] where w is a width in twelfths and each row
   * sums to at most 12. Array position is the display order. Card ids absent from the
   * current template are retained so a conditionally rendered card keeps its place. An
   * activeView naming a view that no longer exists falls back to the virtual "Default".
   */
  layout?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "users.card_layout". All fields are combined with a logical 'AND'. */
export type CardLayout_Bool_Exp = {
  _and?: InputMaybe<Array<CardLayout_Bool_Exp>>;
  _not?: InputMaybe<CardLayout_Bool_Exp>;
  _or?: InputMaybe<Array<CardLayout_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  layout?: InputMaybe<Jsonb_Comparison_Exp>;
  route?: InputMaybe<Route_Bool_Exp>;
  routeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "users.card_layout" */
export enum CardLayout_Constraint {
  /** unique or primary key constraint on columns "identity_id", "route_id" */
  CardLayoutIdentityIdRouteIdKey = 'card_layout_identity_id_route_id_key',
  /** unique or primary key constraint on columns "id" */
  CardLayoutPkey = 'card_layout_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CardLayout_Delete_At_Path_Input = {
  /**
   * { version, columns, activeView, views: [{ name, rows, hidden }] }.
   * rows is run-length: [[{id, w}, ...], ...] where w is a width in twelfths and each row
   * sums to at most 12. Array position is the display order. Card ids absent from the
   * current template are retained so a conditionally rendered card keeps its place. An
   * activeView naming a view that no longer exists falls back to the virtual "Default".
   */
  layout?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CardLayout_Delete_Elem_Input = {
  /**
   * { version, columns, activeView, views: [{ name, rows, hidden }] }.
   * rows is run-length: [[{id, w}, ...], ...] where w is a width in twelfths and each row
   * sums to at most 12. Array position is the display order. Card ids absent from the
   * current template are retained so a conditionally rendered card keeps its place. An
   * activeView naming a view that no longer exists falls back to the virtual "Default".
   */
  layout?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CardLayout_Delete_Key_Input = {
  /**
   * { version, columns, activeView, views: [{ name, rows, hidden }] }.
   * rows is run-length: [[{id, w}, ...], ...] where w is a width in twelfths and each row
   * sums to at most 12. Array position is the display order. Card ids absent from the
   * current template are retained so a conditionally rendered card keeps its place. An
   * activeView naming a view that no longer exists falls back to the virtual "Default".
   */
  layout?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "users.card_layout" */
export type CardLayout_Insert_Input = {
  /** When this identity first saved a view for this screen. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /**
   * { version, columns, activeView, views: [{ name, rows, hidden }] }.
   * rows is run-length: [[{id, w}, ...], ...] where w is a width in twelfths and each row
   * sums to at most 12. Array position is the display order. Card ids absent from the
   * current template are retained so a conditionally rendered card keeps its place. An
   * activeView naming a view that no longer exists falls back to the virtual "Default".
   */
  layout?: InputMaybe<Scalars['jsonb']>;
  route?: InputMaybe<Route_Obj_Rel_Insert_Input>;
  /**
   * The screen this layout belongs to: auth.route.id, the same identifier the
   * permission system grants against. Not a record id — a route stands for the KIND of
   * screen (/claims/mechanical/[id]), so one layout applies to every claim of that type.
   *
   * A generated, closed set, so there is no second naming scheme to keep in step with
   * the routes and no application-level allow-list to maintain. Route ids are preserved
   * by hand when a path moves, which is what lets a layout outlive a route rename.
   * ON DELETE CASCADE: a layout for a screen that no longer exists is unreachable.
   */
  routeId?: InputMaybe<Scalars['uuid']>;
  /** Maintained by the set_users_card_layout_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CardLayout_Max_Fields = {
  __typename?: 'cardLayout_max_fields';
  /** When this identity first saved a view for this screen. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId?: Maybe<Scalars['uuid']>;
  /**
   * The screen this layout belongs to: auth.route.id, the same identifier the
   * permission system grants against. Not a record id — a route stands for the KIND of
   * screen (/claims/mechanical/[id]), so one layout applies to every claim of that type.
   *
   * A generated, closed set, so there is no second naming scheme to keep in step with
   * the routes and no application-level allow-list to maintain. Route ids are preserved
   * by hand when a path moves, which is what lets a layout outlive a route rename.
   * ON DELETE CASCADE: a layout for a screen that no longer exists is unreachable.
   */
  routeId?: Maybe<Scalars['uuid']>;
  /** Maintained by the set_users_card_layout_updated_at trigger. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CardLayout_Min_Fields = {
  __typename?: 'cardLayout_min_fields';
  /** When this identity first saved a view for this screen. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId?: Maybe<Scalars['uuid']>;
  /**
   * The screen this layout belongs to: auth.route.id, the same identifier the
   * permission system grants against. Not a record id — a route stands for the KIND of
   * screen (/claims/mechanical/[id]), so one layout applies to every claim of that type.
   *
   * A generated, closed set, so there is no second naming scheme to keep in step with
   * the routes and no application-level allow-list to maintain. Route ids are preserved
   * by hand when a path moves, which is what lets a layout outlive a route rename.
   * ON DELETE CASCADE: a layout for a screen that no longer exists is unreachable.
   */
  routeId?: Maybe<Scalars['uuid']>;
  /** Maintained by the set_users_card_layout_updated_at trigger. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "users.card_layout" */
export type CardLayout_Mutation_Response = {
  __typename?: 'cardLayout_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CardLayout>;
};

/** on_conflict condition type for table "users.card_layout" */
export type CardLayout_On_Conflict = {
  constraint: CardLayout_Constraint;
  update_columns?: Array<CardLayout_Update_Column>;
  where?: InputMaybe<CardLayout_Bool_Exp>;
};

/** Ordering options when selecting data from "users.card_layout". */
export type CardLayout_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  layout?: InputMaybe<Order_By>;
  route?: InputMaybe<Route_Order_By>;
  routeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users.card_layout */
export type CardLayout_Pk_Columns_Input = {
  /** Primary key. */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CardLayout_Prepend_Input = {
  /**
   * { version, columns, activeView, views: [{ name, rows, hidden }] }.
   * rows is run-length: [[{id, w}, ...], ...] where w is a width in twelfths and each row
   * sums to at most 12. Array position is the display order. Card ids absent from the
   * current template are retained so a conditionally rendered card keeps its place. An
   * activeView naming a view that no longer exists falls back to the virtual "Default".
   */
  layout?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users.card_layout" */
export enum CardLayout_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  Layout = 'layout',
  /** column name */
  RouteId = 'routeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "users.card_layout" */
export type CardLayout_Set_Input = {
  /** When this identity first saved a view for this screen. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /**
   * { version, columns, activeView, views: [{ name, rows, hidden }] }.
   * rows is run-length: [[{id, w}, ...], ...] where w is a width in twelfths and each row
   * sums to at most 12. Array position is the display order. Card ids absent from the
   * current template are retained so a conditionally rendered card keeps its place. An
   * activeView naming a view that no longer exists falls back to the virtual "Default".
   */
  layout?: InputMaybe<Scalars['jsonb']>;
  /**
   * The screen this layout belongs to: auth.route.id, the same identifier the
   * permission system grants against. Not a record id — a route stands for the KIND of
   * screen (/claims/mechanical/[id]), so one layout applies to every claim of that type.
   *
   * A generated, closed set, so there is no second naming scheme to keep in step with
   * the routes and no application-level allow-list to maintain. Route ids are preserved
   * by hand when a path moves, which is what lets a layout outlive a route rename.
   * ON DELETE CASCADE: a layout for a screen that no longer exists is unreachable.
   */
  routeId?: InputMaybe<Scalars['uuid']>;
  /** Maintained by the set_users_card_layout_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "cardLayout" */
export type CardLayout_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CardLayout_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CardLayout_Stream_Cursor_Value_Input = {
  /** When this identity first saved a view for this screen. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Matches x-hasura-user-id, which is what the row-level permissions filter on.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /**
   * { version, columns, activeView, views: [{ name, rows, hidden }] }.
   * rows is run-length: [[{id, w}, ...], ...] where w is a width in twelfths and each row
   * sums to at most 12. Array position is the display order. Card ids absent from the
   * current template are retained so a conditionally rendered card keeps its place. An
   * activeView naming a view that no longer exists falls back to the virtual "Default".
   */
  layout?: InputMaybe<Scalars['jsonb']>;
  /**
   * The screen this layout belongs to: auth.route.id, the same identifier the
   * permission system grants against. Not a record id — a route stands for the KIND of
   * screen (/claims/mechanical/[id]), so one layout applies to every claim of that type.
   *
   * A generated, closed set, so there is no second naming scheme to keep in step with
   * the routes and no application-level allow-list to maintain. Route ids are preserved
   * by hand when a path moves, which is what lets a layout outlive a route rename.
   * ON DELETE CASCADE: a layout for a screen that no longer exists is unreachable.
   */
  routeId?: InputMaybe<Scalars['uuid']>;
  /** Maintained by the set_users_card_layout_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "users.card_layout" */
export enum CardLayout_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  Layout = 'layout',
  /** column name */
  RouteId = 'routeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CardLayout_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CardLayout_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CardLayout_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CardLayout_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CardLayout_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CardLayout_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CardLayout_Set_Input>;
  /** filter the rows which have to be updated */
  where: CardLayout_Bool_Exp;
};

/** columns and relationships of "carrier" */
export type Carrier = {
  __typename?: 'carrier';
  /** An array relationship */
  addresses: Array<Address>;
  /** An aggregate relationship */
  addresses_aggregate: Address_Aggregate;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  obligors: Array<Obligor>;
  /** An aggregate relationship */
  obligors_aggregate: Obligor_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "carrier" */
export type CarrierAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "carrier" */
export type CarrierAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "carrier" */
export type CarrierEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "carrier" */
export type CarrierEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "carrier" */
export type CarrierObligorsArgs = {
  distinct_on?: InputMaybe<Array<Obligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Obligor_Order_By>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};


/** columns and relationships of "carrier" */
export type CarrierObligors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Obligor_Order_By>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};

/** aggregated selection of "carrier" */
export type Carrier_Aggregate = {
  __typename?: 'carrier_aggregate';
  aggregate?: Maybe<Carrier_Aggregate_Fields>;
  nodes: Array<Carrier>;
};

/** aggregate fields of "carrier" */
export type Carrier_Aggregate_Fields = {
  __typename?: 'carrier_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Carrier_Max_Fields>;
  min?: Maybe<Carrier_Min_Fields>;
};


/** aggregate fields of "carrier" */
export type Carrier_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Carrier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "carrier". All fields are combined with a logical 'AND'. */
export type Carrier_Bool_Exp = {
  _and?: InputMaybe<Array<Carrier_Bool_Exp>>;
  _not?: InputMaybe<Carrier_Bool_Exp>;
  _or?: InputMaybe<Array<Carrier_Bool_Exp>>;
  addresses?: InputMaybe<Address_Bool_Exp>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  obligors?: InputMaybe<Obligor_Bool_Exp>;
  obligors_aggregate?: InputMaybe<Obligor_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "carrier" */
export enum Carrier_Constraint {
  /** unique or primary key constraint on columns "id" */
  CarrierPkey = 'carrier_pkey'
}

/** input type for inserting data into table "carrier" */
export type Carrier_Insert_Input = {
  addresses?: InputMaybe<Address_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  obligors?: InputMaybe<Obligor_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Carrier_Max_Fields = {
  __typename?: 'carrier_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Carrier_Min_Fields = {
  __typename?: 'carrier_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "carrier" */
export type Carrier_Mutation_Response = {
  __typename?: 'carrier_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Carrier>;
};

/** input type for inserting object relation for remote table "carrier" */
export type Carrier_Obj_Rel_Insert_Input = {
  data: Carrier_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Carrier_On_Conflict>;
};

/** on_conflict condition type for table "carrier" */
export type Carrier_On_Conflict = {
  constraint: Carrier_Constraint;
  update_columns?: Array<Carrier_Update_Column>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};

/** Ordering options when selecting data from "carrier". */
export type Carrier_Order_By = {
  addresses_aggregate?: InputMaybe<Address_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  obligors_aggregate?: InputMaybe<Obligor_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: carrier */
export type Carrier_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "carrier" */
export enum Carrier_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "carrier" */
export type Carrier_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "carrier" */
export type Carrier_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Carrier_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Carrier_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "carrier" */
export enum Carrier_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Carrier_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Carrier_Set_Input>;
  /** filter the rows which have to be updated */
  where: Carrier_Bool_Exp;
};

/** columns and relationships of "category" */
export type Category = {
  __typename?: 'category';
  /** An array relationship */
  accountCategories: Array<AccountCategory>;
  /** An aggregate relationship */
  accountCategories_aggregate: AccountCategory_Aggregate;
  /** An array relationship */
  accountDisbursements: Array<AccountDisbursement>;
  /** An aggregate relationship */
  accountDisbursements_aggregate: AccountDisbursement_Aggregate;
  /** An array relationship */
  accountRetails: Array<AccountRetail>;
  /** An aggregate relationship */
  accountRetails_aggregate: AccountRetail_Aggregate;
  /** An array relationship */
  categoryProductAttributeTypes: Array<CategoryProductAttributeType>;
  /** An aggregate relationship */
  categoryProductAttributeTypes_aggregate: CategoryProductAttributeType_Aggregate;
  /** An object relationship */
  claimType?: Maybe<Type>;
  /** References the claim type from shared.type table. Used to map claim types to categories. */
  claimTypeId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  classGuides: Array<ClassGuide>;
  /** An aggregate relationship */
  classGuides_aggregate: ClassGuide_Aggregate;
  code?: Maybe<Scalars['String']>;
  /** An array relationship */
  costAdjustments: Array<CostAdjustment>;
  /** An aggregate relationship */
  costAdjustments_aggregate: CostAdjustment_Aggregate;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  eligibilityRules: Array<EligibilityRule>;
  /** An aggregate relationship */
  eligibilityRules_aggregate: EligibilityRule_Aggregate;
  /** An array relationship */
  entityConfigurationItems: Array<EntityConfigurationItem>;
  /** An aggregate relationship */
  entityConfigurationItems_aggregate: EntityConfigurationItem_Aggregate;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  lossRatios: Array<LossRatio>;
  /** An aggregate relationship */
  lossRatios_aggregate: LossRatio_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  products: Array<Product>;
  /** An aggregate relationship */
  products_aggregate: Product_Aggregate;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  validationRuleFors: Array<ValidationRuleFor>;
  /** An aggregate relationship */
  validationRuleFors_aggregate: ValidationRuleFor_Aggregate;
  /** An array relationship */
  validationWhens: Array<ValidationWhen>;
  /** An aggregate relationship */
  validationWhens_aggregate: ValidationWhen_Aggregate;
};


/** columns and relationships of "category" */
export type CategoryAccountCategoriesArgs = {
  distinct_on?: InputMaybe<Array<AccountCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountCategory_Order_By>>;
  where?: InputMaybe<AccountCategory_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryAccountCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountCategory_Order_By>>;
  where?: InputMaybe<AccountCategory_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryAccountDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryAccountDisbursements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryAccountRetailsArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryAccountRetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryCategoryProductAttributeTypesArgs = {
  distinct_on?: InputMaybe<Array<CategoryProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CategoryProductAttributeType_Order_By>>;
  where?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryCategoryProductAttributeTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CategoryProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CategoryProductAttributeType_Order_By>>;
  where?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryClassGuidesArgs = {
  distinct_on?: InputMaybe<Array<ClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuide_Order_By>>;
  where?: InputMaybe<ClassGuide_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryClassGuides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuide_Order_By>>;
  where?: InputMaybe<ClassGuide_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryCostAdjustmentsArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustment_Order_By>>;
  where?: InputMaybe<CostAdjustment_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryCostAdjustments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustment_Order_By>>;
  where?: InputMaybe<CostAdjustment_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRule_Order_By>>;
  where?: InputMaybe<EligibilityRule_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRule_Order_By>>;
  where?: InputMaybe<EligibilityRule_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryEntityConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryEntityConfigurationItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryLossRatiosArgs = {
  distinct_on?: InputMaybe<Array<LossRatio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatio_Order_By>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryLossRatios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LossRatio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatio_Order_By>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryValidationRuleForsArgs = {
  distinct_on?: InputMaybe<Array<ValidationRuleFor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationRuleFor_Order_By>>;
  where?: InputMaybe<ValidationRuleFor_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryValidationRuleFors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationRuleFor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationRuleFor_Order_By>>;
  where?: InputMaybe<ValidationRuleFor_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryValidationWhensArgs = {
  distinct_on?: InputMaybe<Array<ValidationWhen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationWhen_Order_By>>;
  where?: InputMaybe<ValidationWhen_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryValidationWhens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationWhen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationWhen_Order_By>>;
  where?: InputMaybe<ValidationWhen_Bool_Exp>;
};

export type CategoryClassGuide = {
  __typename?: 'categoryClassGuide';
  alternateNewCarClassCode?: Maybe<Scalars['String']>;
  alternateUsedCarClassCode?: Maybe<Scalars['String']>;
  categoryCode?: Maybe<Scalars['String']>;
  classGuideName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  newCarClassCode?: Maybe<Scalars['String']>;
  usedCarClassCode?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "categoryClassGuide". All fields are combined with a logical 'AND'. */
export type CategoryClassGuide_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<CategoryClassGuide_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<CategoryClassGuide_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<CategoryClassGuide_Bool_Exp_Bool_Exp>>;
  alternateNewCarClassCode?: InputMaybe<String_Comparison_Exp>;
  alternateUsedCarClassCode?: InputMaybe<String_Comparison_Exp>;
  categoryCode?: InputMaybe<String_Comparison_Exp>;
  classGuideName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  newCarClassCode?: InputMaybe<String_Comparison_Exp>;
  usedCarClassCode?: InputMaybe<String_Comparison_Exp>;
};

export enum CategoryClassGuide_Enum_Name {
  /** column name */
  AlternateNewCarClassCode = 'alternateNewCarClassCode',
  /** column name */
  AlternateUsedCarClassCode = 'alternateUsedCarClassCode',
  /** column name */
  CategoryCode = 'categoryCode',
  /** column name */
  ClassGuideName = 'classGuideName',
  /** column name */
  Id = 'id',
  /** column name */
  NewCarClassCode = 'newCarClassCode',
  /** column name */
  UsedCarClassCode = 'usedCarClassCode'
}

/** Ordering options when selecting data from "categoryClassGuide". */
export type CategoryClassGuide_Order_By = {
  alternateNewCarClassCode?: InputMaybe<Order_By>;
  alternateUsedCarClassCode?: InputMaybe<Order_By>;
  categoryCode?: InputMaybe<Order_By>;
  classGuideName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  newCarClassCode?: InputMaybe<Order_By>;
  usedCarClassCode?: InputMaybe<Order_By>;
};

/** Join table between "category" and "product_attribute_type" */
export type CategoryProductAttributeType = {
  __typename?: 'categoryProductAttributeType';
  /** An object relationship */
  category: Category;
  categoryId: Scalars['uuid'];
  createdAt: Scalars['timestamp'];
  id: Scalars['uuid'];
  /** An object relationship */
  productAttributeType: ProductAttributeType;
  productAttributeTypeId: Scalars['Int'];
  updatedAt: Scalars['timestamp'];
};

/** aggregated selection of "category_product_attribute_type" */
export type CategoryProductAttributeType_Aggregate = {
  __typename?: 'categoryProductAttributeType_aggregate';
  aggregate?: Maybe<CategoryProductAttributeType_Aggregate_Fields>;
  nodes: Array<CategoryProductAttributeType>;
};

export type CategoryProductAttributeType_Aggregate_Bool_Exp = {
  count?: InputMaybe<CategoryProductAttributeType_Aggregate_Bool_Exp_Count>;
};

export type CategoryProductAttributeType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CategoryProductAttributeType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "category_product_attribute_type" */
export type CategoryProductAttributeType_Aggregate_Fields = {
  __typename?: 'categoryProductAttributeType_aggregate_fields';
  avg?: Maybe<CategoryProductAttributeType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CategoryProductAttributeType_Max_Fields>;
  min?: Maybe<CategoryProductAttributeType_Min_Fields>;
  stddev?: Maybe<CategoryProductAttributeType_Stddev_Fields>;
  stddev_pop?: Maybe<CategoryProductAttributeType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CategoryProductAttributeType_Stddev_Samp_Fields>;
  sum?: Maybe<CategoryProductAttributeType_Sum_Fields>;
  var_pop?: Maybe<CategoryProductAttributeType_Var_Pop_Fields>;
  var_samp?: Maybe<CategoryProductAttributeType_Var_Samp_Fields>;
  variance?: Maybe<CategoryProductAttributeType_Variance_Fields>;
};


/** aggregate fields of "category_product_attribute_type" */
export type CategoryProductAttributeType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CategoryProductAttributeType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Aggregate_Order_By = {
  avg?: InputMaybe<CategoryProductAttributeType_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CategoryProductAttributeType_Max_Order_By>;
  min?: InputMaybe<CategoryProductAttributeType_Min_Order_By>;
  stddev?: InputMaybe<CategoryProductAttributeType_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CategoryProductAttributeType_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CategoryProductAttributeType_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CategoryProductAttributeType_Sum_Order_By>;
  var_pop?: InputMaybe<CategoryProductAttributeType_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CategoryProductAttributeType_Var_Samp_Order_By>;
  variance?: InputMaybe<CategoryProductAttributeType_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "category_product_attribute_type" */
export type CategoryProductAttributeType_Arr_Rel_Insert_Input = {
  data: Array<CategoryProductAttributeType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CategoryProductAttributeType_On_Conflict>;
};

/** aggregate avg on columns */
export type CategoryProductAttributeType_Avg_Fields = {
  __typename?: 'categoryProductAttributeType_avg_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Avg_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "category_product_attribute_type". All fields are combined with a logical 'AND'. */
export type CategoryProductAttributeType_Bool_Exp = {
  _and?: InputMaybe<Array<CategoryProductAttributeType_Bool_Exp>>;
  _not?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
  _or?: InputMaybe<Array<CategoryProductAttributeType_Bool_Exp>>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  productAttributeType?: InputMaybe<ProductAttributeType_Bool_Exp>;
  productAttributeTypeId?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "category_product_attribute_type" */
export enum CategoryProductAttributeType_Constraint {
  /** unique or primary key constraint on columns "id" */
  CategoryProductAttributeTypePkey = 'category_product_attribute_type_pkey'
}

/** input type for incrementing numeric columns in table "category_product_attribute_type" */
export type CategoryProductAttributeType_Inc_Input = {
  productAttributeTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "category_product_attribute_type" */
export type CategoryProductAttributeType_Insert_Input = {
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  productAttributeType?: InputMaybe<ProductAttributeType_Obj_Rel_Insert_Input>;
  productAttributeTypeId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type CategoryProductAttributeType_Max_Fields = {
  __typename?: 'categoryProductAttributeType_max_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  productAttributeTypeId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Max_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productAttributeTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CategoryProductAttributeType_Min_Fields = {
  __typename?: 'categoryProductAttributeType_min_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  productAttributeTypeId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Min_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productAttributeTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "category_product_attribute_type" */
export type CategoryProductAttributeType_Mutation_Response = {
  __typename?: 'categoryProductAttributeType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CategoryProductAttributeType>;
};

/** on_conflict condition type for table "category_product_attribute_type" */
export type CategoryProductAttributeType_On_Conflict = {
  constraint: CategoryProductAttributeType_Constraint;
  update_columns?: Array<CategoryProductAttributeType_Update_Column>;
  where?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
};

/** Ordering options when selecting data from "category_product_attribute_type". */
export type CategoryProductAttributeType_Order_By = {
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productAttributeType?: InputMaybe<ProductAttributeType_Order_By>;
  productAttributeTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: category_product_attribute_type */
export type CategoryProductAttributeType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "category_product_attribute_type" */
export enum CategoryProductAttributeType_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProductAttributeTypeId = 'productAttributeTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "category_product_attribute_type" */
export type CategoryProductAttributeType_Set_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  productAttributeTypeId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type CategoryProductAttributeType_Stddev_Fields = {
  __typename?: 'categoryProductAttributeType_stddev_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Stddev_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CategoryProductAttributeType_Stddev_Pop_Fields = {
  __typename?: 'categoryProductAttributeType_stddev_pop_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Stddev_Pop_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CategoryProductAttributeType_Stddev_Samp_Fields = {
  __typename?: 'categoryProductAttributeType_stddev_samp_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Stddev_Samp_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "categoryProductAttributeType" */
export type CategoryProductAttributeType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CategoryProductAttributeType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CategoryProductAttributeType_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  productAttributeTypeId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type CategoryProductAttributeType_Sum_Fields = {
  __typename?: 'categoryProductAttributeType_sum_fields';
  productAttributeTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Sum_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "category_product_attribute_type" */
export enum CategoryProductAttributeType_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProductAttributeTypeId = 'productAttributeTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CategoryProductAttributeType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CategoryProductAttributeType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CategoryProductAttributeType_Set_Input>;
  /** filter the rows which have to be updated */
  where: CategoryProductAttributeType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CategoryProductAttributeType_Var_Pop_Fields = {
  __typename?: 'categoryProductAttributeType_var_pop_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Var_Pop_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CategoryProductAttributeType_Var_Samp_Fields = {
  __typename?: 'categoryProductAttributeType_var_samp_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Var_Samp_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CategoryProductAttributeType_Variance_Fields = {
  __typename?: 'categoryProductAttributeType_variance_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "category_product_attribute_type" */
export type CategoryProductAttributeType_Variance_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** aggregated selection of "category" */
export type Category_Aggregate = {
  __typename?: 'category_aggregate';
  aggregate?: Maybe<Category_Aggregate_Fields>;
  nodes: Array<Category>;
};

/** aggregate fields of "category" */
export type Category_Aggregate_Fields = {
  __typename?: 'category_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Category_Max_Fields>;
  min?: Maybe<Category_Min_Fields>;
};


/** aggregate fields of "category" */
export type Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "category". All fields are combined with a logical 'AND'. */
export type Category_Bool_Exp = {
  _and?: InputMaybe<Array<Category_Bool_Exp>>;
  _not?: InputMaybe<Category_Bool_Exp>;
  _or?: InputMaybe<Array<Category_Bool_Exp>>;
  accountCategories?: InputMaybe<AccountCategory_Bool_Exp>;
  accountCategories_aggregate?: InputMaybe<AccountCategory_Aggregate_Bool_Exp>;
  accountDisbursements?: InputMaybe<AccountDisbursement_Bool_Exp>;
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Bool_Exp>;
  accountRetails?: InputMaybe<AccountRetail_Bool_Exp>;
  accountRetails_aggregate?: InputMaybe<AccountRetail_Aggregate_Bool_Exp>;
  categoryProductAttributeTypes?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
  categoryProductAttributeTypes_aggregate?: InputMaybe<CategoryProductAttributeType_Aggregate_Bool_Exp>;
  claimType?: InputMaybe<Type_Bool_Exp>;
  claimTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  classGuides?: InputMaybe<ClassGuide_Bool_Exp>;
  classGuides_aggregate?: InputMaybe<ClassGuide_Aggregate_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  costAdjustments?: InputMaybe<CostAdjustment_Bool_Exp>;
  costAdjustments_aggregate?: InputMaybe<CostAdjustment_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  eligibilityRules?: InputMaybe<EligibilityRule_Bool_Exp>;
  eligibilityRules_aggregate?: InputMaybe<EligibilityRule_Aggregate_Bool_Exp>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Bool_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lossRatios?: InputMaybe<LossRatio_Bool_Exp>;
  lossRatios_aggregate?: InputMaybe<LossRatio_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Product_Bool_Exp>;
  products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  validationRuleFors?: InputMaybe<ValidationRuleFor_Bool_Exp>;
  validationRuleFors_aggregate?: InputMaybe<ValidationRuleFor_Aggregate_Bool_Exp>;
  validationWhens?: InputMaybe<ValidationWhen_Bool_Exp>;
  validationWhens_aggregate?: InputMaybe<ValidationWhen_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "category" */
export enum Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  CategoryPkey = 'category_pkey'
}

/** input type for inserting data into table "category" */
export type Category_Insert_Input = {
  accountCategories?: InputMaybe<AccountCategory_Arr_Rel_Insert_Input>;
  accountDisbursements?: InputMaybe<AccountDisbursement_Arr_Rel_Insert_Input>;
  accountRetails?: InputMaybe<AccountRetail_Arr_Rel_Insert_Input>;
  categoryProductAttributeTypes?: InputMaybe<CategoryProductAttributeType_Arr_Rel_Insert_Input>;
  claimType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** References the claim type from shared.type table. Used to map claim types to categories. */
  claimTypeId?: InputMaybe<Scalars['uuid']>;
  classGuides?: InputMaybe<ClassGuide_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']>;
  costAdjustments?: InputMaybe<CostAdjustment_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eligibilityRules?: InputMaybe<EligibilityRule_Arr_Rel_Insert_Input>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Arr_Rel_Insert_Input>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  lossRatios?: InputMaybe<LossRatio_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationRuleFors?: InputMaybe<ValidationRuleFor_Arr_Rel_Insert_Input>;
  validationWhens?: InputMaybe<ValidationWhen_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Category_Max_Fields = {
  __typename?: 'category_max_fields';
  /** References the claim type from shared.type table. Used to map claim types to categories. */
  claimTypeId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Category_Min_Fields = {
  __typename?: 'category_min_fields';
  /** References the claim type from shared.type table. Used to map claim types to categories. */
  claimTypeId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "category" */
export type Category_Mutation_Response = {
  __typename?: 'category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Category>;
};

/** input type for inserting object relation for remote table "category" */
export type Category_Obj_Rel_Insert_Input = {
  data: Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_On_Conflict>;
};

/** on_conflict condition type for table "category" */
export type Category_On_Conflict = {
  constraint: Category_Constraint;
  update_columns?: Array<Category_Update_Column>;
  where?: InputMaybe<Category_Bool_Exp>;
};

/** Ordering options when selecting data from "category". */
export type Category_Order_By = {
  accountCategories_aggregate?: InputMaybe<AccountCategory_Aggregate_Order_By>;
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Order_By>;
  accountRetails_aggregate?: InputMaybe<AccountRetail_Aggregate_Order_By>;
  categoryProductAttributeTypes_aggregate?: InputMaybe<CategoryProductAttributeType_Aggregate_Order_By>;
  claimType?: InputMaybe<Type_Order_By>;
  claimTypeId?: InputMaybe<Order_By>;
  classGuides_aggregate?: InputMaybe<ClassGuide_Aggregate_Order_By>;
  code?: InputMaybe<Order_By>;
  costAdjustments_aggregate?: InputMaybe<CostAdjustment_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  eligibilityRules_aggregate?: InputMaybe<EligibilityRule_Aggregate_Order_By>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lossRatios_aggregate?: InputMaybe<LossRatio_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationRuleFors_aggregate?: InputMaybe<ValidationRuleFor_Aggregate_Order_By>;
  validationWhens_aggregate?: InputMaybe<ValidationWhen_Aggregate_Order_By>;
};

/** primary key columns input for table: category */
export type Category_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "category" */
export enum Category_Select_Column {
  /** column name */
  ClaimTypeId = 'claimTypeId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "category" */
export type Category_Set_Input = {
  /** References the claim type from shared.type table. Used to map claim types to categories. */
  claimTypeId?: InputMaybe<Scalars['uuid']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "category" */
export type Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Category_Stream_Cursor_Value_Input = {
  /** References the claim type from shared.type table. Used to map claim types to categories. */
  claimTypeId?: InputMaybe<Scalars['uuid']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "category" */
export enum Category_Update_Column {
  /** column name */
  ClaimTypeId = 'claimTypeId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Category_Bool_Exp;
};

/** columns and relationships of "claim" */
export type Claim = {
  __typename?: 'claim';
  cause?: Maybe<Scalars['String']>;
  claimNumber: Scalars['String'];
  /** An object relationship */
  claimStatusType: ClaimStatusType;
  claimStatusTypeEnumValue: Scalars['Int'];
  closedAt?: Maybe<Scalars['timestamptz']>;
  complaint: Scalars['String'];
  /** An object relationship */
  contract: Contract;
  contractId: Scalars['uuid'];
  correction?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  dealer: Legacy_Claims_Dealer;
  dealerContactName: Scalars['String'];
  dealerContactPhone: Scalars['String'];
  dealerId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  jobs: Array<ObsoleteJob>;
  /** An aggregate relationship */
  jobs_aggregate: ObsoleteJob_Aggregate;
  overriddenDeductibleAmount?: Maybe<Scalars['numeric']>;
  payeeDealerLaborHourlyRateAmount: Scalars['numeric'];
  payeeDealerLaborTaxPercent: Scalars['numeric'];
  payeeDealerPartsTaxPercent: Scalars['numeric'];
  payeeDealerPaymentLocation: Scalars['String'];
  payeeDealerPaymentTypeEnumValue: Scalars['Int'];
  payeeDealerPhone: Scalars['String'];
  repairOrderDate: Scalars['date'];
  repairOrderNumber: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  vehicleMileageAmount: Scalars['numeric'];
};


/** columns and relationships of "claim" */
export type ClaimJobsArgs = {
  distinct_on?: InputMaybe<Array<ObsoleteJob_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObsoleteJob_Order_By>>;
  where?: InputMaybe<ObsoleteJob_Bool_Exp>;
};


/** columns and relationships of "claim" */
export type ClaimJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ObsoleteJob_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObsoleteJob_Order_By>>;
  where?: InputMaybe<ObsoleteJob_Bool_Exp>;
};

/** columns and relationships of "claims.claim_detail" */
export type ClaimDetail = {
  __typename?: 'claimDetail';
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * JSONB object holding the automatic adjustments applied to GAP claims: "Over Benefit Limit" (when the total exceeds the paid amount limit) and "Negative Amount" (when the total would be negative). Also carries a "total" key with the sum of all adjustments. Adjustments are subtracted from total_cost.
   *
   * Written by the trigger for GAP claims in Open status; non-GAP and non-Open claims use the mechanical formula and leave it empty. Keys are generated by the trigger, not a type table -- do not branch on them in application code. See ADR 0003 in docs/adr/ (originally IT-7607).
   */
  adjustment_metadata?: Maybe<Scalars['jsonb']>;
  breakDownCode?: Maybe<Scalars['String']>;
  cashValueOnDateOfLoss?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  claimDetailCategory?: Maybe<ClaimDetailCategory>;
  /** Describes the type of cost of the claim detail, and specifies if tax and labor apply. */
  claimDetailCategoryId: Scalars['uuid'];
  /** An object relationship */
  claimDetailJobType?: Maybe<Type>;
  /** A method used to group claim details, primarily refers to what component or system is being repaired. */
  claimDetailJobTypeId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  claimDetailPartLookup?: Maybe<ClaimDetailPartLookup>;
  /** An object relationship */
  claimPart?: Maybe<ClaimPart>;
  /** An object relationship */
  claimServiceCenter?: Maybe<ClaimServiceCenter>;
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  componentCode?: Maybe<Scalars['String']>;
  cost: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  /** This is a mapping of claimDeductionTypeId to number */
  deductionMetadata?: Maybe<Scalars['jsonb']>;
  description?: Maybe<Scalars['String']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount: Scalars['numeric'];
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  itemCode?: Maybe<Scalars['String']>;
  laborCost: Scalars['numeric'];
  laborHours: Scalars['numeric'];
  laborRateAmount: Scalars['numeric'];
  laborTax: Scalars['numeric'];
  laborTaxPercent: Scalars['numeric'];
  laborTaxRate: Scalars['numeric'];
  /** IT-7607: Timestamp of last trigger recalculation. Updated by force_recalculate_claim_detail() to propagate changes from related tables (policy_claim, policy_claim_insurance, policy_contract_asset, policy_contract_lender). */
  last_recalc_trigger?: Maybe<Scalars['timestamptz']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['numeric']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  partNumber?: Maybe<Scalars['String']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax: Scalars['numeric'];
  partTaxPercent: Scalars['numeric'];
  partTaxRate: Scalars['numeric'];
  /** An array relationship */
  participants: Array<Participant>;
  /** An aggregate relationship */
  participants_aggregate: Participant_Aggregate;
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
  policyClaimId: Scalars['uuid'];
  quantity: Scalars['numeric'];
  /** This is a mapping of claimRefundTypeId to number */
  refundMetadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  remittanceClaimDetails: Array<RemittanceClaimDetail>;
  /** An aggregate relationship */
  remittanceClaimDetails_aggregate: RemittanceClaimDetail_Aggregate;
  /** An array relationship */
  repeatPartAcknowledgments: Array<RepeatPartAcknowledgment>;
  /** An aggregate relationship */
  repeatPartAcknowledgments_aggregate: RepeatPartAcknowledgment_Aggregate;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailAdjustment_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailDeductionMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailParticipants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailRefundMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailRemittanceClaimDetailsArgs = {
  distinct_on?: InputMaybe<Array<RemittanceClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceClaimDetail_Order_By>>;
  where?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailRemittanceClaimDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittanceClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceClaimDetail_Order_By>>;
  where?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailRepeatPartAcknowledgmentsArgs = {
  distinct_on?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatPartAcknowledgment_Order_By>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};


/** columns and relationships of "claims.claim_detail" */
export type ClaimDetailRepeatPartAcknowledgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatPartAcknowledgment_Order_By>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};

/** Maps each claim detail to the ESCLMT sequence number (CTSEQN) it was assigned in the AS400, so the AS400 export can update line items in place instead of delete/re-insert (which wiped the payment columns the AS400 stamps at check-print time). Assigned once at sync time and never changed. claim_detail_id is set NULL (not cascaded) when the detail is deleted so the row survives as a high-water mark - a deleted detail's sequence number is never reused against a possibly-paid leftover AS400 row. */
export type ClaimDetailAs400 = {
  __typename?: 'claimDetailAs400';
  /** An object relationship */
  claimDetail?: Maybe<ClaimDetail>;
  claimDetailId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  claimServiceCenter?: Maybe<ClaimServiceCenter>;
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  policyClaim: PolicyClaim;
  policyClaimId: Scalars['uuid'];
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "claims.claim_detail_as400" */
export type ClaimDetailAs400_Aggregate = {
  __typename?: 'claimDetailAs400_aggregate';
  aggregate?: Maybe<ClaimDetailAs400_Aggregate_Fields>;
  nodes: Array<ClaimDetailAs400>;
};

/** aggregate fields of "claims.claim_detail_as400" */
export type ClaimDetailAs400_Aggregate_Fields = {
  __typename?: 'claimDetailAs400_aggregate_fields';
  avg?: Maybe<ClaimDetailAs400_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClaimDetailAs400_Max_Fields>;
  min?: Maybe<ClaimDetailAs400_Min_Fields>;
  stddev?: Maybe<ClaimDetailAs400_Stddev_Fields>;
  stddev_pop?: Maybe<ClaimDetailAs400_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClaimDetailAs400_Stddev_Samp_Fields>;
  sum?: Maybe<ClaimDetailAs400_Sum_Fields>;
  var_pop?: Maybe<ClaimDetailAs400_Var_Pop_Fields>;
  var_samp?: Maybe<ClaimDetailAs400_Var_Samp_Fields>;
  variance?: Maybe<ClaimDetailAs400_Variance_Fields>;
};


/** aggregate fields of "claims.claim_detail_as400" */
export type ClaimDetailAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClaimDetailAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ClaimDetailAs400_Avg_Fields = {
  __typename?: 'claimDetailAs400_avg_fields';
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "claims.claim_detail_as400". All fields are combined with a logical 'AND'. */
export type ClaimDetailAs400_Bool_Exp = {
  _and?: InputMaybe<Array<ClaimDetailAs400_Bool_Exp>>;
  _not?: InputMaybe<ClaimDetailAs400_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimDetailAs400_Bool_Exp>>;
  claimDetail?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimDetailId?: InputMaybe<Uuid_Comparison_Exp>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  claimServiceCenterId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaimId?: InputMaybe<Uuid_Comparison_Exp>;
  sequenceNumber?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.claim_detail_as400" */
export enum ClaimDetailAs400_Constraint {
  /** unique or primary key constraint on columns "claim_detail_id" */
  ClaimDetailAs400ClaimDetailIdKey = 'claim_detail_as400_claim_detail_id_key',
  /** unique or primary key constraint on columns "id" */
  ClaimDetailAs400Pkey = 'claim_detail_as400_pkey',
  /** unique or primary key constraint on columns "sequence_number", "policy_claim_id" */
  ClaimDetailAs400PolicyClaimSequenceKey = 'claim_detail_as400_policy_claim_sequence_key',
  /** unique or primary key constraint on columns "sequence_number", "claim_service_center_id" */
  ClaimDetailAs400ServiceCenterSequenceKey = 'claim_detail_as400_service_center_sequence_key'
}

/** input type for incrementing numeric columns in table "claims.claim_detail_as400" */
export type ClaimDetailAs400_Inc_Input = {
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "claims.claim_detail_as400" */
export type ClaimDetailAs400_Insert_Input = {
  claimDetail?: InputMaybe<ClaimDetail_Obj_Rel_Insert_Input>;
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Obj_Rel_Insert_Input>;
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClaimDetailAs400_Max_Fields = {
  __typename?: 'claimDetailAs400_max_fields';
  claimDetailId?: Maybe<Scalars['uuid']>;
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ClaimDetailAs400_Min_Fields = {
  __typename?: 'claimDetailAs400_min_fields';
  claimDetailId?: Maybe<Scalars['uuid']>;
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.claim_detail_as400" */
export type ClaimDetailAs400_Mutation_Response = {
  __typename?: 'claimDetailAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimDetailAs400>;
};

/** on_conflict condition type for table "claims.claim_detail_as400" */
export type ClaimDetailAs400_On_Conflict = {
  constraint: ClaimDetailAs400_Constraint;
  update_columns?: Array<ClaimDetailAs400_Update_Column>;
  where?: InputMaybe<ClaimDetailAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.claim_detail_as400". */
export type ClaimDetailAs400_Order_By = {
  claimDetail?: InputMaybe<ClaimDetail_Order_By>;
  claimDetailId?: InputMaybe<Order_By>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Order_By>;
  claimServiceCenterId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  sequenceNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.claim_detail_as400 */
export type ClaimDetailAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.claim_detail_as400" */
export enum ClaimDetailAs400_Select_Column {
  /** column name */
  ClaimDetailId = 'claimDetailId',
  /** column name */
  ClaimServiceCenterId = 'claimServiceCenterId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  SequenceNumber = 'sequenceNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.claim_detail_as400" */
export type ClaimDetailAs400_Set_Input = {
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ClaimDetailAs400_Stddev_Fields = {
  __typename?: 'claimDetailAs400_stddev_fields';
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ClaimDetailAs400_Stddev_Pop_Fields = {
  __typename?: 'claimDetailAs400_stddev_pop_fields';
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ClaimDetailAs400_Stddev_Samp_Fields = {
  __typename?: 'claimDetailAs400_stddev_samp_fields';
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "claimDetailAs400" */
export type ClaimDetailAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClaimDetailAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClaimDetailAs400_Stream_Cursor_Value_Input = {
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ClaimDetailAs400_Sum_Fields = {
  __typename?: 'claimDetailAs400_sum_fields';
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: Maybe<Scalars['Int']>;
};

/** update columns of table "claims.claim_detail_as400" */
export enum ClaimDetailAs400_Update_Column {
  /** column name */
  ClaimDetailId = 'claimDetailId',
  /** column name */
  ClaimServiceCenterId = 'claimServiceCenterId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  SequenceNumber = 'sequenceNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClaimDetailAs400_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClaimDetailAs400_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClaimDetailAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClaimDetailAs400_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClaimDetailAs400_Var_Pop_Fields = {
  __typename?: 'claimDetailAs400_var_pop_fields';
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ClaimDetailAs400_Var_Samp_Fields = {
  __typename?: 'claimDetailAs400_var_samp_fields';
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ClaimDetailAs400_Variance_Fields = {
  __typename?: 'claimDetailAs400_variance_fields';
  /** ESCLMT CTSEQN for this claim detail. Unique within the AS400 claim: scoped to claim_service_center_id for mechanical claims, to policy_claim_id for GAP/TLC/TSW/LCA claims (sequence 1 is reserved there for the synthesized benefit/tax line). */
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** The category is used to group claim details together for totalling. Some details will not have a category, so they will use the 'None' category. It is codegenned, and used in code as a constant so it can't be changed without modifying the code. Any record in this table that is codegenned with business logic written for it will not be able to be changed without modifying code. */
export type ClaimDetailCategory = {
  __typename?: 'claimDetailCategory';
  /** An array relationship */
  claimDetails: Array<ClaimDetail>;
  /** An aggregate relationship */
  claimDetails_aggregate: ClaimDetail_Aggregate;
  createdAt: Scalars['timestamptz'];
  defaultItemName?: Maybe<Scalars['String']>;
  display: Scalars['String'];
  id: Scalars['uuid'];
  /** A flag for the codegen container so that it can deterministically codegen records in this table */
  isCodegenned: Scalars['Boolean'];
  /** Allows users to control which category represents the deductible type */
  isDeductible: Scalars['Boolean'];
  isLaborApplicable: Scalars['Boolean'];
  /** Allows users to remove the ability to apply the category to a claim detail */
  isRetired: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** The category is used to group claim details together for totalling. Some details will not have a category, so they will use the 'None' category. It is codegenned, and used in code as a constant so it can't be changed without modifying the code. Any record in this table that is codegenned with business logic written for it will not be able to be changed without modifying code. */
export type ClaimDetailCategoryClaimDetailsArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


/** The category is used to group claim details together for totalling. Some details will not have a category, so they will use the 'None' category. It is codegenned, and used in code as a constant so it can't be changed without modifying the code. Any record in this table that is codegenned with business logic written for it will not be able to be changed without modifying code. */
export type ClaimDetailCategoryClaimDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


/** The category is used to group claim details together for totalling. Some details will not have a category, so they will use the 'None' category. It is codegenned, and used in code as a constant so it can't be changed without modifying the code. Any record in this table that is codegenned with business logic written for it will not be able to be changed without modifying code. */
export type ClaimDetailCategoryLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** The category is used to group claim details together for totalling. Some details will not have a category, so they will use the 'None' category. It is codegenned, and used in code as a constant so it can't be changed without modifying the code. Any record in this table that is codegenned with business logic written for it will not be able to be changed without modifying code. */
export type ClaimDetailCategoryLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "claims.claim_detail_category" */
export type ClaimDetailCategory_Aggregate = {
  __typename?: 'claimDetailCategory_aggregate';
  aggregate?: Maybe<ClaimDetailCategory_Aggregate_Fields>;
  nodes: Array<ClaimDetailCategory>;
};

/** aggregate fields of "claims.claim_detail_category" */
export type ClaimDetailCategory_Aggregate_Fields = {
  __typename?: 'claimDetailCategory_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ClaimDetailCategory_Max_Fields>;
  min?: Maybe<ClaimDetailCategory_Min_Fields>;
};


/** aggregate fields of "claims.claim_detail_category" */
export type ClaimDetailCategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClaimDetailCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.claim_detail_category". All fields are combined with a logical 'AND'. */
export type ClaimDetailCategory_Bool_Exp = {
  _and?: InputMaybe<Array<ClaimDetailCategory_Bool_Exp>>;
  _not?: InputMaybe<ClaimDetailCategory_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimDetailCategory_Bool_Exp>>;
  claimDetails?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimDetails_aggregate?: InputMaybe<ClaimDetail_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  defaultItemName?: InputMaybe<String_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isCodegenned?: InputMaybe<Boolean_Comparison_Exp>;
  isDeductible?: InputMaybe<Boolean_Comparison_Exp>;
  isLaborApplicable?: InputMaybe<Boolean_Comparison_Exp>;
  isRetired?: InputMaybe<Boolean_Comparison_Exp>;
  isTaxable?: InputMaybe<Boolean_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.claim_detail_category" */
export enum ClaimDetailCategory_Constraint {
  /** unique or primary key constraint on columns  */
  ClaimDetailCategoryNameUniqueIdx = 'claim_detail_category_name_unique_idx',
  /** unique or primary key constraint on columns "id" */
  ClaimDetailCategoryPkey = 'claim_detail_category_pkey'
}

/** input type for inserting data into table "claims.claim_detail_category" */
export type ClaimDetailCategory_Insert_Input = {
  claimDetails?: InputMaybe<ClaimDetail_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultItemName?: InputMaybe<Scalars['String']>;
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** A flag for the codegen container so that it can deterministically codegen records in this table */
  isCodegenned?: InputMaybe<Scalars['Boolean']>;
  /** Allows users to control which category represents the deductible type */
  isDeductible?: InputMaybe<Scalars['Boolean']>;
  isLaborApplicable?: InputMaybe<Scalars['Boolean']>;
  /** Allows users to remove the ability to apply the category to a claim detail */
  isRetired?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClaimDetailCategory_Max_Fields = {
  __typename?: 'claimDetailCategory_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultItemName?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ClaimDetailCategory_Min_Fields = {
  __typename?: 'claimDetailCategory_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultItemName?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.claim_detail_category" */
export type ClaimDetailCategory_Mutation_Response = {
  __typename?: 'claimDetailCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimDetailCategory>;
};

/** input type for inserting object relation for remote table "claims.claim_detail_category" */
export type ClaimDetailCategory_Obj_Rel_Insert_Input = {
  data: ClaimDetailCategory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClaimDetailCategory_On_Conflict>;
};

/** on_conflict condition type for table "claims.claim_detail_category" */
export type ClaimDetailCategory_On_Conflict = {
  constraint: ClaimDetailCategory_Constraint;
  update_columns?: Array<ClaimDetailCategory_Update_Column>;
  where?: InputMaybe<ClaimDetailCategory_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.claim_detail_category". */
export type ClaimDetailCategory_Order_By = {
  claimDetails_aggregate?: InputMaybe<ClaimDetail_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defaultItemName?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isCodegenned?: InputMaybe<Order_By>;
  isDeductible?: InputMaybe<Order_By>;
  isLaborApplicable?: InputMaybe<Order_By>;
  isRetired?: InputMaybe<Order_By>;
  isTaxable?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.claim_detail_category */
export type ClaimDetailCategory_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.claim_detail_category" */
export enum ClaimDetailCategory_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultItemName = 'defaultItemName',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  IsCodegenned = 'isCodegenned',
  /** column name */
  IsDeductible = 'isDeductible',
  /** column name */
  IsLaborApplicable = 'isLaborApplicable',
  /** column name */
  IsRetired = 'isRetired',
  /** column name */
  IsTaxable = 'isTaxable',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.claim_detail_category" */
export type ClaimDetailCategory_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultItemName?: InputMaybe<Scalars['String']>;
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** A flag for the codegen container so that it can deterministically codegen records in this table */
  isCodegenned?: InputMaybe<Scalars['Boolean']>;
  /** Allows users to control which category represents the deductible type */
  isDeductible?: InputMaybe<Scalars['Boolean']>;
  isLaborApplicable?: InputMaybe<Scalars['Boolean']>;
  /** Allows users to remove the ability to apply the category to a claim detail */
  isRetired?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "claimDetailCategory" */
export type ClaimDetailCategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClaimDetailCategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClaimDetailCategory_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultItemName?: InputMaybe<Scalars['String']>;
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** A flag for the codegen container so that it can deterministically codegen records in this table */
  isCodegenned?: InputMaybe<Scalars['Boolean']>;
  /** Allows users to control which category represents the deductible type */
  isDeductible?: InputMaybe<Scalars['Boolean']>;
  isLaborApplicable?: InputMaybe<Scalars['Boolean']>;
  /** Allows users to remove the ability to apply the category to a claim detail */
  isRetired?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "claims.claim_detail_category" */
export enum ClaimDetailCategory_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultItemName = 'defaultItemName',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  IsCodegenned = 'isCodegenned',
  /** column name */
  IsDeductible = 'isDeductible',
  /** column name */
  IsLaborApplicable = 'isLaborApplicable',
  /** column name */
  IsRetired = 'isRetired',
  /** column name */
  IsTaxable = 'isTaxable',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClaimDetailCategory_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClaimDetailCategory_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClaimDetailCategory_Bool_Exp;
};

/** Maps each AS400-sourced deduction (a mbpi.dbo.ClaimsMasterDetail row with DiscountAmount > 0) to the negative-cost claims.claim_detail row the import synthesizes from it. The synthetic detail id cannot be derived from the source id (the reverse sync re-issues source ids when its heuristic match fails), so this map is the only stable link; it keeps remittance_claim_detail allocations from being orphaned and a paid deduction from reappearing unpaid after a re-sync. source_claim_detail_id is updated in place when the AS400 churns the source id - the map row, and with it the deduction detail and its payment linkage, survives. */
export type ClaimDetailDeductionAs400 = {
  __typename?: 'claimDetailDeductionAs400';
  /** Source-row break_down_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  breakDownCode?: Maybe<Scalars['String']>;
  /** Source-row claim_service_center_id, stored on the map to scope re-point matching to the same service center. Refreshed from the source row on every sync. */
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  /** Source-row component_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  componentCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  deductionClaimDetail: ClaimDetail;
  /** The claims.claim_detail row (negative cost) created from the source deduction. Kept stable across re-syncs so remittance_claim_detail rows pointing at it survive. */
  deductionClaimDetailId: Scalars['uuid'];
  /** Source-row description, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  description?: Maybe<Scalars['String']>;
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  /** Source-row item_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  itemCode?: Maybe<Scalars['String']>;
  /** Source-row part_number, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  partNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  policyClaim: PolicyClaim;
  policyClaimId: Scalars['uuid'];
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['numeric']>;
  /** mbpi.dbo.ClaimsMasterDetail.ID of the source deduction line. Volatile across syncs by design of the AS400 import; the map row survives id churn by being re-pointed at the new source id. */
  sourceClaimDetailId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "claims.claim_detail_deduction_as400" */
export type ClaimDetailDeductionAs400_Aggregate = {
  __typename?: 'claimDetailDeductionAs400_aggregate';
  aggregate?: Maybe<ClaimDetailDeductionAs400_Aggregate_Fields>;
  nodes: Array<ClaimDetailDeductionAs400>;
};

/** aggregate fields of "claims.claim_detail_deduction_as400" */
export type ClaimDetailDeductionAs400_Aggregate_Fields = {
  __typename?: 'claimDetailDeductionAs400_aggregate_fields';
  avg?: Maybe<ClaimDetailDeductionAs400_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClaimDetailDeductionAs400_Max_Fields>;
  min?: Maybe<ClaimDetailDeductionAs400_Min_Fields>;
  stddev?: Maybe<ClaimDetailDeductionAs400_Stddev_Fields>;
  stddev_pop?: Maybe<ClaimDetailDeductionAs400_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClaimDetailDeductionAs400_Stddev_Samp_Fields>;
  sum?: Maybe<ClaimDetailDeductionAs400_Sum_Fields>;
  var_pop?: Maybe<ClaimDetailDeductionAs400_Var_Pop_Fields>;
  var_samp?: Maybe<ClaimDetailDeductionAs400_Var_Samp_Fields>;
  variance?: Maybe<ClaimDetailDeductionAs400_Variance_Fields>;
};


/** aggregate fields of "claims.claim_detail_deduction_as400" */
export type ClaimDetailDeductionAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClaimDetailDeductionAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ClaimDetailDeductionAs400_Avg_Fields = {
  __typename?: 'claimDetailDeductionAs400_avg_fields';
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "claims.claim_detail_deduction_as400". All fields are combined with a logical 'AND'. */
export type ClaimDetailDeductionAs400_Bool_Exp = {
  _and?: InputMaybe<Array<ClaimDetailDeductionAs400_Bool_Exp>>;
  _not?: InputMaybe<ClaimDetailDeductionAs400_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimDetailDeductionAs400_Bool_Exp>>;
  breakDownCode?: InputMaybe<String_Comparison_Exp>;
  claimServiceCenterId?: InputMaybe<Uuid_Comparison_Exp>;
  componentCode?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deductionClaimDetail?: InputMaybe<ClaimDetail_Bool_Exp>;
  deductionClaimDetailId?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discountAmount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  itemCode?: InputMaybe<String_Comparison_Exp>;
  partNumber?: InputMaybe<String_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaimId?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  sourceClaimDetailId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.claim_detail_deduction_as400" */
export enum ClaimDetailDeductionAs400_Constraint {
  /** unique or primary key constraint on columns "deduction_claim_detail_id" */
  ClaimDetailDeductionAs400DeductionClaimDetailIdKey = 'claim_detail_deduction_as400_deduction_claim_detail_id_key',
  /** unique or primary key constraint on columns "id" */
  ClaimDetailDeductionAs400Pkey = 'claim_detail_deduction_as400_pkey',
  /** unique or primary key constraint on columns "source_claim_detail_id" */
  ClaimDetailDeductionAs400SourceClaimDetailIdKey = 'claim_detail_deduction_as400_source_claim_detail_id_key'
}

/** input type for incrementing numeric columns in table "claims.claim_detail_deduction_as400" */
export type ClaimDetailDeductionAs400_Inc_Input = {
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: InputMaybe<Scalars['numeric']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claims.claim_detail_deduction_as400" */
export type ClaimDetailDeductionAs400_Insert_Input = {
  /** Source-row break_down_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  breakDownCode?: InputMaybe<Scalars['String']>;
  /** Source-row claim_service_center_id, stored on the map to scope re-point matching to the same service center. Refreshed from the source row on every sync. */
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  /** Source-row component_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  componentCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deductionClaimDetail?: InputMaybe<ClaimDetail_Obj_Rel_Insert_Input>;
  /** The claims.claim_detail row (negative cost) created from the source deduction. Kept stable across re-syncs so remittance_claim_detail rows pointing at it survive. */
  deductionClaimDetailId?: InputMaybe<Scalars['uuid']>;
  /** Source-row description, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  description?: InputMaybe<Scalars['String']>;
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Source-row item_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  itemCode?: InputMaybe<Scalars['String']>;
  /** Source-row part_number, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  partNumber?: InputMaybe<Scalars['String']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: InputMaybe<Scalars['numeric']>;
  /** mbpi.dbo.ClaimsMasterDetail.ID of the source deduction line. Volatile across syncs by design of the AS400 import; the map row survives id churn by being re-pointed at the new source id. */
  sourceClaimDetailId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClaimDetailDeductionAs400_Max_Fields = {
  __typename?: 'claimDetailDeductionAs400_max_fields';
  /** Source-row break_down_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  breakDownCode?: Maybe<Scalars['String']>;
  /** Source-row claim_service_center_id, stored on the map to scope re-point matching to the same service center. Refreshed from the source row on every sync. */
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  /** Source-row component_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  componentCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The claims.claim_detail row (negative cost) created from the source deduction. Kept stable across re-syncs so remittance_claim_detail rows pointing at it survive. */
  deductionClaimDetailId?: Maybe<Scalars['uuid']>;
  /** Source-row description, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  description?: Maybe<Scalars['String']>;
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  /** Source-row item_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  itemCode?: Maybe<Scalars['String']>;
  /** Source-row part_number, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  partNumber?: Maybe<Scalars['String']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['numeric']>;
  /** mbpi.dbo.ClaimsMasterDetail.ID of the source deduction line. Volatile across syncs by design of the AS400 import; the map row survives id churn by being re-pointed at the new source id. */
  sourceClaimDetailId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ClaimDetailDeductionAs400_Min_Fields = {
  __typename?: 'claimDetailDeductionAs400_min_fields';
  /** Source-row break_down_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  breakDownCode?: Maybe<Scalars['String']>;
  /** Source-row claim_service_center_id, stored on the map to scope re-point matching to the same service center. Refreshed from the source row on every sync. */
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  /** Source-row component_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  componentCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The claims.claim_detail row (negative cost) created from the source deduction. Kept stable across re-syncs so remittance_claim_detail rows pointing at it survive. */
  deductionClaimDetailId?: Maybe<Scalars['uuid']>;
  /** Source-row description, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  description?: Maybe<Scalars['String']>;
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  /** Source-row item_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  itemCode?: Maybe<Scalars['String']>;
  /** Source-row part_number, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  partNumber?: Maybe<Scalars['String']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['numeric']>;
  /** mbpi.dbo.ClaimsMasterDetail.ID of the source deduction line. Volatile across syncs by design of the AS400 import; the map row survives id churn by being re-pointed at the new source id. */
  sourceClaimDetailId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.claim_detail_deduction_as400" */
export type ClaimDetailDeductionAs400_Mutation_Response = {
  __typename?: 'claimDetailDeductionAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimDetailDeductionAs400>;
};

/** on_conflict condition type for table "claims.claim_detail_deduction_as400" */
export type ClaimDetailDeductionAs400_On_Conflict = {
  constraint: ClaimDetailDeductionAs400_Constraint;
  update_columns?: Array<ClaimDetailDeductionAs400_Update_Column>;
  where?: InputMaybe<ClaimDetailDeductionAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.claim_detail_deduction_as400". */
export type ClaimDetailDeductionAs400_Order_By = {
  breakDownCode?: InputMaybe<Order_By>;
  claimServiceCenterId?: InputMaybe<Order_By>;
  componentCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deductionClaimDetail?: InputMaybe<ClaimDetail_Order_By>;
  deductionClaimDetailId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discountAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemCode?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sourceClaimDetailId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.claim_detail_deduction_as400 */
export type ClaimDetailDeductionAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.claim_detail_deduction_as400" */
export enum ClaimDetailDeductionAs400_Select_Column {
  /** column name */
  BreakDownCode = 'breakDownCode',
  /** column name */
  ClaimServiceCenterId = 'claimServiceCenterId',
  /** column name */
  ComponentCode = 'componentCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeductionClaimDetailId = 'deductionClaimDetailId',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  Id = 'id',
  /** column name */
  ItemCode = 'itemCode',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  SourceClaimDetailId = 'sourceClaimDetailId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.claim_detail_deduction_as400" */
export type ClaimDetailDeductionAs400_Set_Input = {
  /** Source-row break_down_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  breakDownCode?: InputMaybe<Scalars['String']>;
  /** Source-row claim_service_center_id, stored on the map to scope re-point matching to the same service center. Refreshed from the source row on every sync. */
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  /** Source-row component_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  componentCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The claims.claim_detail row (negative cost) created from the source deduction. Kept stable across re-syncs so remittance_claim_detail rows pointing at it survive. */
  deductionClaimDetailId?: InputMaybe<Scalars['uuid']>;
  /** Source-row description, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  description?: InputMaybe<Scalars['String']>;
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Source-row item_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  itemCode?: InputMaybe<Scalars['String']>;
  /** Source-row part_number, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  partNumber?: InputMaybe<Scalars['String']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: InputMaybe<Scalars['numeric']>;
  /** mbpi.dbo.ClaimsMasterDetail.ID of the source deduction line. Volatile across syncs by design of the AS400 import; the map row survives id churn by being re-pointed at the new source id. */
  sourceClaimDetailId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ClaimDetailDeductionAs400_Stddev_Fields = {
  __typename?: 'claimDetailDeductionAs400_stddev_fields';
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ClaimDetailDeductionAs400_Stddev_Pop_Fields = {
  __typename?: 'claimDetailDeductionAs400_stddev_pop_fields';
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ClaimDetailDeductionAs400_Stddev_Samp_Fields = {
  __typename?: 'claimDetailDeductionAs400_stddev_samp_fields';
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "claimDetailDeductionAs400" */
export type ClaimDetailDeductionAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClaimDetailDeductionAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClaimDetailDeductionAs400_Stream_Cursor_Value_Input = {
  /** Source-row break_down_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  breakDownCode?: InputMaybe<Scalars['String']>;
  /** Source-row claim_service_center_id, stored on the map to scope re-point matching to the same service center. Refreshed from the source row on every sync. */
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  /** Source-row component_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  componentCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The claims.claim_detail row (negative cost) created from the source deduction. Kept stable across re-syncs so remittance_claim_detail rows pointing at it survive. */
  deductionClaimDetailId?: InputMaybe<Scalars['uuid']>;
  /** Source-row description, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  description?: InputMaybe<Scalars['String']>;
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Source-row item_code, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  itemCode?: InputMaybe<Scalars['String']>;
  /** Source-row part_number, stored on the map so the re-point heuristic can match a churned source id without reading the deduction detail. Refreshed from the source row on every sync. */
  partNumber?: InputMaybe<Scalars['String']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: InputMaybe<Scalars['numeric']>;
  /** mbpi.dbo.ClaimsMasterDetail.ID of the source deduction line. Volatile across syncs by design of the AS400 import; the map row survives id churn by being re-pointed at the new source id. */
  sourceClaimDetailId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ClaimDetailDeductionAs400_Sum_Fields = {
  __typename?: 'claimDetailDeductionAs400_sum_fields';
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['numeric']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['numeric']>;
};

/** update columns of table "claims.claim_detail_deduction_as400" */
export enum ClaimDetailDeductionAs400_Update_Column {
  /** column name */
  BreakDownCode = 'breakDownCode',
  /** column name */
  ClaimServiceCenterId = 'claimServiceCenterId',
  /** column name */
  ComponentCode = 'componentCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeductionClaimDetailId = 'deductionClaimDetailId',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  Id = 'id',
  /** column name */
  ItemCode = 'itemCode',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  SourceClaimDetailId = 'sourceClaimDetailId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClaimDetailDeductionAs400_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClaimDetailDeductionAs400_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClaimDetailDeductionAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClaimDetailDeductionAs400_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClaimDetailDeductionAs400_Var_Pop_Fields = {
  __typename?: 'claimDetailDeductionAs400_var_pop_fields';
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ClaimDetailDeductionAs400_Var_Samp_Fields = {
  __typename?: 'claimDetailDeductionAs400_var_samp_fields';
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ClaimDetailDeductionAs400_Variance_Fields = {
  __typename?: 'claimDetailDeductionAs400_variance_fields';
  /** Source-row discount amount (DeductionNumber x DeductibleAmount), stored on the map so the re-point heuristic can distinguish two deductions with identical descriptive fields but different amounts. Refreshed from the source row on every sync. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Source-row quantity, stored on the map to disambiguate two deductions with identical descriptive fields on the same claim. Refreshed from the source row on every sync. */
  quantity?: Maybe<Scalars['Float']>;
};

/** Storage for snapshots of part price from part lookup providers */
export type ClaimDetailPartLookup = {
  __typename?: 'claimDetailPartLookup';
  /** An object relationship */
  claimDetail: ClaimDetail;
  claimDetailId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  dealerCost?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  msrp: Scalars['numeric'];
  /** An object relationship */
  partLookupProvider: Type;
  partLookupProviderId: Scalars['uuid'];
  partNumber: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** Storage for snapshots of part price from part lookup providers */
export type ClaimDetailPartLookupLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** Storage for snapshots of part price from part lookup providers */
export type ClaimDetailPartLookupLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "claims.claim_detail_part_lookup" */
export type ClaimDetailPartLookup_Aggregate = {
  __typename?: 'claimDetailPartLookup_aggregate';
  aggregate?: Maybe<ClaimDetailPartLookup_Aggregate_Fields>;
  nodes: Array<ClaimDetailPartLookup>;
};

/** aggregate fields of "claims.claim_detail_part_lookup" */
export type ClaimDetailPartLookup_Aggregate_Fields = {
  __typename?: 'claimDetailPartLookup_aggregate_fields';
  avg?: Maybe<ClaimDetailPartLookup_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClaimDetailPartLookup_Max_Fields>;
  min?: Maybe<ClaimDetailPartLookup_Min_Fields>;
  stddev?: Maybe<ClaimDetailPartLookup_Stddev_Fields>;
  stddev_pop?: Maybe<ClaimDetailPartLookup_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClaimDetailPartLookup_Stddev_Samp_Fields>;
  sum?: Maybe<ClaimDetailPartLookup_Sum_Fields>;
  var_pop?: Maybe<ClaimDetailPartLookup_Var_Pop_Fields>;
  var_samp?: Maybe<ClaimDetailPartLookup_Var_Samp_Fields>;
  variance?: Maybe<ClaimDetailPartLookup_Variance_Fields>;
};


/** aggregate fields of "claims.claim_detail_part_lookup" */
export type ClaimDetailPartLookup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClaimDetailPartLookup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ClaimDetailPartLookup_Avg_Fields = {
  __typename?: 'claimDetailPartLookup_avg_fields';
  dealerCost?: Maybe<Scalars['Float']>;
  msrp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "claims.claim_detail_part_lookup". All fields are combined with a logical 'AND'. */
export type ClaimDetailPartLookup_Bool_Exp = {
  _and?: InputMaybe<Array<ClaimDetailPartLookup_Bool_Exp>>;
  _not?: InputMaybe<ClaimDetailPartLookup_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimDetailPartLookup_Bool_Exp>>;
  claimDetail?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimDetailId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dealerCost?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  msrp?: InputMaybe<Numeric_Comparison_Exp>;
  partLookupProvider?: InputMaybe<Type_Bool_Exp>;
  partLookupProviderId?: InputMaybe<Uuid_Comparison_Exp>;
  partNumber?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.claim_detail_part_lookup" */
export enum ClaimDetailPartLookup_Constraint {
  /** unique or primary key constraint on columns "claim_detail_id" */
  ClaimDetailPartLookupClaimDetailIdKey = 'claim_detail_part_lookup_claim_detail_id_key',
  /** unique or primary key constraint on columns "id" */
  ClaimDetailPartLookupPkey = 'claim_detail_part_lookup_pkey'
}

/** input type for incrementing numeric columns in table "claims.claim_detail_part_lookup" */
export type ClaimDetailPartLookup_Inc_Input = {
  dealerCost?: InputMaybe<Scalars['numeric']>;
  msrp?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claims.claim_detail_part_lookup" */
export type ClaimDetailPartLookup_Insert_Input = {
  claimDetail?: InputMaybe<ClaimDetail_Obj_Rel_Insert_Input>;
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerCost?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  msrp?: InputMaybe<Scalars['numeric']>;
  partLookupProvider?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  partLookupProviderId?: InputMaybe<Scalars['uuid']>;
  partNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClaimDetailPartLookup_Max_Fields = {
  __typename?: 'claimDetailPartLookup_max_fields';
  claimDetailId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dealerCost?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  msrp?: Maybe<Scalars['numeric']>;
  partLookupProviderId?: Maybe<Scalars['uuid']>;
  partNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ClaimDetailPartLookup_Min_Fields = {
  __typename?: 'claimDetailPartLookup_min_fields';
  claimDetailId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dealerCost?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  msrp?: Maybe<Scalars['numeric']>;
  partLookupProviderId?: Maybe<Scalars['uuid']>;
  partNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.claim_detail_part_lookup" */
export type ClaimDetailPartLookup_Mutation_Response = {
  __typename?: 'claimDetailPartLookup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimDetailPartLookup>;
};

/** input type for inserting object relation for remote table "claims.claim_detail_part_lookup" */
export type ClaimDetailPartLookup_Obj_Rel_Insert_Input = {
  data: ClaimDetailPartLookup_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClaimDetailPartLookup_On_Conflict>;
};

/** on_conflict condition type for table "claims.claim_detail_part_lookup" */
export type ClaimDetailPartLookup_On_Conflict = {
  constraint: ClaimDetailPartLookup_Constraint;
  update_columns?: Array<ClaimDetailPartLookup_Update_Column>;
  where?: InputMaybe<ClaimDetailPartLookup_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.claim_detail_part_lookup". */
export type ClaimDetailPartLookup_Order_By = {
  claimDetail?: InputMaybe<ClaimDetail_Order_By>;
  claimDetailId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dealerCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  msrp?: InputMaybe<Order_By>;
  partLookupProvider?: InputMaybe<Type_Order_By>;
  partLookupProviderId?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.claim_detail_part_lookup */
export type ClaimDetailPartLookup_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.claim_detail_part_lookup" */
export enum ClaimDetailPartLookup_Select_Column {
  /** column name */
  ClaimDetailId = 'claimDetailId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DealerCost = 'dealerCost',
  /** column name */
  Id = 'id',
  /** column name */
  Msrp = 'msrp',
  /** column name */
  PartLookupProviderId = 'partLookupProviderId',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.claim_detail_part_lookup" */
export type ClaimDetailPartLookup_Set_Input = {
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerCost?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  msrp?: InputMaybe<Scalars['numeric']>;
  partLookupProviderId?: InputMaybe<Scalars['uuid']>;
  partNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ClaimDetailPartLookup_Stddev_Fields = {
  __typename?: 'claimDetailPartLookup_stddev_fields';
  dealerCost?: Maybe<Scalars['Float']>;
  msrp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ClaimDetailPartLookup_Stddev_Pop_Fields = {
  __typename?: 'claimDetailPartLookup_stddev_pop_fields';
  dealerCost?: Maybe<Scalars['Float']>;
  msrp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ClaimDetailPartLookup_Stddev_Samp_Fields = {
  __typename?: 'claimDetailPartLookup_stddev_samp_fields';
  dealerCost?: Maybe<Scalars['Float']>;
  msrp?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "claimDetailPartLookup" */
export type ClaimDetailPartLookup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClaimDetailPartLookup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClaimDetailPartLookup_Stream_Cursor_Value_Input = {
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerCost?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  msrp?: InputMaybe<Scalars['numeric']>;
  partLookupProviderId?: InputMaybe<Scalars['uuid']>;
  partNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ClaimDetailPartLookup_Sum_Fields = {
  __typename?: 'claimDetailPartLookup_sum_fields';
  dealerCost?: Maybe<Scalars['numeric']>;
  msrp?: Maybe<Scalars['numeric']>;
};

/** update columns of table "claims.claim_detail_part_lookup" */
export enum ClaimDetailPartLookup_Update_Column {
  /** column name */
  ClaimDetailId = 'claimDetailId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DealerCost = 'dealerCost',
  /** column name */
  Id = 'id',
  /** column name */
  Msrp = 'msrp',
  /** column name */
  PartLookupProviderId = 'partLookupProviderId',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClaimDetailPartLookup_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClaimDetailPartLookup_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClaimDetailPartLookup_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClaimDetailPartLookup_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClaimDetailPartLookup_Var_Pop_Fields = {
  __typename?: 'claimDetailPartLookup_var_pop_fields';
  dealerCost?: Maybe<Scalars['Float']>;
  msrp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ClaimDetailPartLookup_Var_Samp_Fields = {
  __typename?: 'claimDetailPartLookup_var_samp_fields';
  dealerCost?: Maybe<Scalars['Float']>;
  msrp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ClaimDetailPartLookup_Variance_Fields = {
  __typename?: 'claimDetailPartLookup_variance_fields';
  dealerCost?: Maybe<Scalars['Float']>;
  msrp?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "claims.claim_detail" */
export type ClaimDetail_Aggregate = {
  __typename?: 'claimDetail_aggregate';
  aggregate?: Maybe<ClaimDetail_Aggregate_Fields>;
  nodes: Array<ClaimDetail>;
};

export type ClaimDetail_Aggregate_Bool_Exp = {
  count?: InputMaybe<ClaimDetail_Aggregate_Bool_Exp_Count>;
};

export type ClaimDetail_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClaimDetail_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.claim_detail" */
export type ClaimDetail_Aggregate_Fields = {
  __typename?: 'claimDetail_aggregate_fields';
  avg?: Maybe<ClaimDetail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClaimDetail_Max_Fields>;
  min?: Maybe<ClaimDetail_Min_Fields>;
  stddev?: Maybe<ClaimDetail_Stddev_Fields>;
  stddev_pop?: Maybe<ClaimDetail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClaimDetail_Stddev_Samp_Fields>;
  sum?: Maybe<ClaimDetail_Sum_Fields>;
  var_pop?: Maybe<ClaimDetail_Var_Pop_Fields>;
  var_samp?: Maybe<ClaimDetail_Var_Samp_Fields>;
  variance?: Maybe<ClaimDetail_Variance_Fields>;
};


/** aggregate fields of "claims.claim_detail" */
export type ClaimDetail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.claim_detail" */
export type ClaimDetail_Aggregate_Order_By = {
  avg?: InputMaybe<ClaimDetail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClaimDetail_Max_Order_By>;
  min?: InputMaybe<ClaimDetail_Min_Order_By>;
  stddev?: InputMaybe<ClaimDetail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ClaimDetail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ClaimDetail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ClaimDetail_Sum_Order_By>;
  var_pop?: InputMaybe<ClaimDetail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ClaimDetail_Var_Samp_Order_By>;
  variance?: InputMaybe<ClaimDetail_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ClaimDetail_Append_Input = {
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * JSONB object holding the automatic adjustments applied to GAP claims: "Over Benefit Limit" (when the total exceeds the paid amount limit) and "Negative Amount" (when the total would be negative). Also carries a "total" key with the sum of all adjustments. Adjustments are subtracted from total_cost.
   *
   * Written by the trigger for GAP claims in Open status; non-GAP and non-Open claims use the mechanical formula and leave it empty. Keys are generated by the trigger, not a type table -- do not branch on them in application code. See ADR 0003 in docs/adr/ (originally IT-7607).
   */
  adjustment_metadata?: InputMaybe<Scalars['jsonb']>;
  /** This is a mapping of claimDeductionTypeId to number */
  deductionMetadata?: InputMaybe<Scalars['jsonb']>;
  /** This is a mapping of claimRefundTypeId to number */
  refundMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "claims.claim_detail" */
export type ClaimDetail_Arr_Rel_Insert_Input = {
  data: Array<ClaimDetail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClaimDetail_On_Conflict>;
};

/** aggregate avg on columns */
export type ClaimDetail_Avg_Fields = {
  __typename?: 'claimDetail_avg_fields';
  cashValueOnDateOfLoss?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['Float']>;
  laborCost?: Maybe<Scalars['Float']>;
  laborHours?: Maybe<Scalars['Float']>;
  laborRateAmount?: Maybe<Scalars['Float']>;
  laborTax?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['Float']>;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: Maybe<Scalars['Float']>;
  partTaxPercent?: Maybe<Scalars['Float']>;
  partTaxRate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "claims.claim_detail" */
export type ClaimDetail_Avg_Order_By = {
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Order_By>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Order_By>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "claims.claim_detail". All fields are combined with a logical 'AND'. */
export type ClaimDetail_Bool_Exp = {
  _and?: InputMaybe<Array<ClaimDetail_Bool_Exp>>;
  _not?: InputMaybe<ClaimDetail_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimDetail_Bool_Exp>>;
  adjustment_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  breakDownCode?: InputMaybe<String_Comparison_Exp>;
  cashValueOnDateOfLoss?: InputMaybe<Numeric_Comparison_Exp>;
  claimDetailCategory?: InputMaybe<ClaimDetailCategory_Bool_Exp>;
  claimDetailCategoryId?: InputMaybe<Uuid_Comparison_Exp>;
  claimDetailJobType?: InputMaybe<Type_Bool_Exp>;
  claimDetailJobTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  claimDetailPartLookup?: InputMaybe<ClaimDetailPartLookup_Bool_Exp>;
  claimPart?: InputMaybe<ClaimPart_Bool_Exp>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  claimServiceCenterId?: InputMaybe<Uuid_Comparison_Exp>;
  componentCode?: InputMaybe<String_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deductionMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discountAmount?: InputMaybe<Numeric_Comparison_Exp>;
  financeBenefitLimitAmount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  itemCode?: InputMaybe<String_Comparison_Exp>;
  laborCost?: InputMaybe<Numeric_Comparison_Exp>;
  laborHours?: InputMaybe<Numeric_Comparison_Exp>;
  laborRateAmount?: InputMaybe<Numeric_Comparison_Exp>;
  laborTax?: InputMaybe<Numeric_Comparison_Exp>;
  laborTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  laborTaxRate?: InputMaybe<Numeric_Comparison_Exp>;
  last_recalc_trigger?: InputMaybe<Timestamptz_Comparison_Exp>;
  lenderPayoffAmount?: InputMaybe<Numeric_Comparison_Exp>;
  lenderPayoffMinusRefundTotal?: InputMaybe<Numeric_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  owedAmount?: InputMaybe<Numeric_Comparison_Exp>;
  paidAmount?: InputMaybe<Numeric_Comparison_Exp>;
  partNumber?: InputMaybe<String_Comparison_Exp>;
  partTax?: InputMaybe<Numeric_Comparison_Exp>;
  partTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  partTaxRate?: InputMaybe<Numeric_Comparison_Exp>;
  participants?: InputMaybe<Participant_Bool_Exp>;
  participants_aggregate?: InputMaybe<Participant_Aggregate_Bool_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaimId?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  refundMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  remittanceClaimDetails?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
  remittanceClaimDetails_aggregate?: InputMaybe<RemittanceClaimDetail_Aggregate_Bool_Exp>;
  repeatPartAcknowledgments?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
  repeatPartAcknowledgments_aggregate?: InputMaybe<RepeatPartAcknowledgment_Aggregate_Bool_Exp>;
  totalCost?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.claim_detail" */
export enum ClaimDetail_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClaimDetailPkey = 'claim_detail_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ClaimDetail_Delete_At_Path_Input = {
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * JSONB object holding the automatic adjustments applied to GAP claims: "Over Benefit Limit" (when the total exceeds the paid amount limit) and "Negative Amount" (when the total would be negative). Also carries a "total" key with the sum of all adjustments. Adjustments are subtracted from total_cost.
   *
   * Written by the trigger for GAP claims in Open status; non-GAP and non-Open claims use the mechanical formula and leave it empty. Keys are generated by the trigger, not a type table -- do not branch on them in application code. See ADR 0003 in docs/adr/ (originally IT-7607).
   */
  adjustment_metadata?: InputMaybe<Array<Scalars['String']>>;
  /** This is a mapping of claimDeductionTypeId to number */
  deductionMetadata?: InputMaybe<Array<Scalars['String']>>;
  /** This is a mapping of claimRefundTypeId to number */
  refundMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ClaimDetail_Delete_Elem_Input = {
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * JSONB object holding the automatic adjustments applied to GAP claims: "Over Benefit Limit" (when the total exceeds the paid amount limit) and "Negative Amount" (when the total would be negative). Also carries a "total" key with the sum of all adjustments. Adjustments are subtracted from total_cost.
   *
   * Written by the trigger for GAP claims in Open status; non-GAP and non-Open claims use the mechanical formula and leave it empty. Keys are generated by the trigger, not a type table -- do not branch on them in application code. See ADR 0003 in docs/adr/ (originally IT-7607).
   */
  adjustment_metadata?: InputMaybe<Scalars['Int']>;
  /** This is a mapping of claimDeductionTypeId to number */
  deductionMetadata?: InputMaybe<Scalars['Int']>;
  /** This is a mapping of claimRefundTypeId to number */
  refundMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ClaimDetail_Delete_Key_Input = {
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * JSONB object holding the automatic adjustments applied to GAP claims: "Over Benefit Limit" (when the total exceeds the paid amount limit) and "Negative Amount" (when the total would be negative). Also carries a "total" key with the sum of all adjustments. Adjustments are subtracted from total_cost.
   *
   * Written by the trigger for GAP claims in Open status; non-GAP and non-Open claims use the mechanical formula and leave it empty. Keys are generated by the trigger, not a type table -- do not branch on them in application code. See ADR 0003 in docs/adr/ (originally IT-7607).
   */
  adjustment_metadata?: InputMaybe<Scalars['String']>;
  /** This is a mapping of claimDeductionTypeId to number */
  deductionMetadata?: InputMaybe<Scalars['String']>;
  /** This is a mapping of claimRefundTypeId to number */
  refundMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "claims.claim_detail" */
export type ClaimDetail_Inc_Input = {
  cashValueOnDateOfLoss?: InputMaybe<Scalars['numeric']>;
  cost?: InputMaybe<Scalars['numeric']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Scalars['numeric']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Scalars['numeric']>;
  laborHours?: InputMaybe<Scalars['numeric']>;
  laborRateAmount?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Scalars['numeric']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Scalars['numeric']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Scalars['numeric']>;
  partTaxPercent?: InputMaybe<Scalars['numeric']>;
  partTaxRate?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claims.claim_detail" */
export type ClaimDetail_Insert_Input = {
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * JSONB object holding the automatic adjustments applied to GAP claims: "Over Benefit Limit" (when the total exceeds the paid amount limit) and "Negative Amount" (when the total would be negative). Also carries a "total" key with the sum of all adjustments. Adjustments are subtracted from total_cost.
   *
   * Written by the trigger for GAP claims in Open status; non-GAP and non-Open claims use the mechanical formula and leave it empty. Keys are generated by the trigger, not a type table -- do not branch on them in application code. See ADR 0003 in docs/adr/ (originally IT-7607).
   */
  adjustment_metadata?: InputMaybe<Scalars['jsonb']>;
  breakDownCode?: InputMaybe<Scalars['String']>;
  cashValueOnDateOfLoss?: InputMaybe<Scalars['numeric']>;
  claimDetailCategory?: InputMaybe<ClaimDetailCategory_Obj_Rel_Insert_Input>;
  /** Describes the type of cost of the claim detail, and specifies if tax and labor apply. */
  claimDetailCategoryId?: InputMaybe<Scalars['uuid']>;
  claimDetailJobType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** A method used to group claim details, primarily refers to what component or system is being repaired. */
  claimDetailJobTypeId?: InputMaybe<Scalars['uuid']>;
  claimDetailPartLookup?: InputMaybe<ClaimDetailPartLookup_Obj_Rel_Insert_Input>;
  claimPart?: InputMaybe<ClaimPart_Obj_Rel_Insert_Input>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Obj_Rel_Insert_Input>;
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  componentCode?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** This is a mapping of claimDeductionTypeId to number */
  deductionMetadata?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Scalars['numeric']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  itemCode?: InputMaybe<Scalars['String']>;
  laborHours?: InputMaybe<Scalars['numeric']>;
  laborRateAmount?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
  /** IT-7607: Timestamp of last trigger recalculation. Updated by force_recalculate_claim_detail() to propagate changes from related tables (policy_claim, policy_claim_insurance, policy_contract_asset, policy_contract_lender). */
  last_recalc_trigger?: InputMaybe<Scalars['timestamptz']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Scalars['numeric']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Scalars['numeric']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  partNumber?: InputMaybe<Scalars['String']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Scalars['numeric']>;
  partTaxPercent?: InputMaybe<Scalars['numeric']>;
  partTaxRate?: InputMaybe<Scalars['numeric']>;
  participants?: InputMaybe<Participant_Arr_Rel_Insert_Input>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  /** This is a mapping of claimRefundTypeId to number */
  refundMetadata?: InputMaybe<Scalars['jsonb']>;
  remittanceClaimDetails?: InputMaybe<RemittanceClaimDetail_Arr_Rel_Insert_Input>;
  repeatPartAcknowledgments?: InputMaybe<RepeatPartAcknowledgment_Arr_Rel_Insert_Input>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClaimDetail_Max_Fields = {
  __typename?: 'claimDetail_max_fields';
  breakDownCode?: Maybe<Scalars['String']>;
  cashValueOnDateOfLoss?: Maybe<Scalars['numeric']>;
  /** Describes the type of cost of the claim detail, and specifies if tax and labor apply. */
  claimDetailCategoryId?: Maybe<Scalars['uuid']>;
  /** A method used to group claim details, primarily refers to what component or system is being repaired. */
  claimDetailJobTypeId?: Maybe<Scalars['uuid']>;
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  componentCode?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: Maybe<Scalars['numeric']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  itemCode?: Maybe<Scalars['String']>;
  laborCost?: Maybe<Scalars['numeric']>;
  laborHours?: Maybe<Scalars['numeric']>;
  laborRateAmount?: Maybe<Scalars['numeric']>;
  laborTax?: Maybe<Scalars['numeric']>;
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  laborTaxRate?: Maybe<Scalars['numeric']>;
  /** IT-7607: Timestamp of last trigger recalculation. Updated by force_recalculate_claim_detail() to propagate changes from related tables (policy_claim, policy_claim_insurance, policy_contract_asset, policy_contract_lender). */
  last_recalc_trigger?: Maybe<Scalars['timestamptz']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['numeric']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['numeric']>;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  partNumber?: Maybe<Scalars['String']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: Maybe<Scalars['numeric']>;
  partTaxPercent?: Maybe<Scalars['numeric']>;
  partTaxRate?: Maybe<Scalars['numeric']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['numeric']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "claims.claim_detail" */
export type ClaimDetail_Max_Order_By = {
  breakDownCode?: InputMaybe<Order_By>;
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  /** Describes the type of cost of the claim detail, and specifies if tax and labor apply. */
  claimDetailCategoryId?: InputMaybe<Order_By>;
  /** A method used to group claim details, primarily refers to what component or system is being repaired. */
  claimDetailJobTypeId?: InputMaybe<Order_By>;
  claimServiceCenterId?: InputMaybe<Order_By>;
  componentCode?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Order_By>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemCode?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  /** IT-7607: Timestamp of last trigger recalculation. Updated by force_recalculate_claim_detail() to propagate changes from related tables (policy_claim, policy_claim_insurance, policy_contract_asset, policy_contract_lender). */
  last_recalc_trigger?: InputMaybe<Order_By>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Order_By>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClaimDetail_Min_Fields = {
  __typename?: 'claimDetail_min_fields';
  breakDownCode?: Maybe<Scalars['String']>;
  cashValueOnDateOfLoss?: Maybe<Scalars['numeric']>;
  /** Describes the type of cost of the claim detail, and specifies if tax and labor apply. */
  claimDetailCategoryId?: Maybe<Scalars['uuid']>;
  /** A method used to group claim details, primarily refers to what component or system is being repaired. */
  claimDetailJobTypeId?: Maybe<Scalars['uuid']>;
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  componentCode?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: Maybe<Scalars['numeric']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  itemCode?: Maybe<Scalars['String']>;
  laborCost?: Maybe<Scalars['numeric']>;
  laborHours?: Maybe<Scalars['numeric']>;
  laborRateAmount?: Maybe<Scalars['numeric']>;
  laborTax?: Maybe<Scalars['numeric']>;
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  laborTaxRate?: Maybe<Scalars['numeric']>;
  /** IT-7607: Timestamp of last trigger recalculation. Updated by force_recalculate_claim_detail() to propagate changes from related tables (policy_claim, policy_claim_insurance, policy_contract_asset, policy_contract_lender). */
  last_recalc_trigger?: Maybe<Scalars['timestamptz']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['numeric']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['numeric']>;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  partNumber?: Maybe<Scalars['String']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: Maybe<Scalars['numeric']>;
  partTaxPercent?: Maybe<Scalars['numeric']>;
  partTaxRate?: Maybe<Scalars['numeric']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['numeric']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "claims.claim_detail" */
export type ClaimDetail_Min_Order_By = {
  breakDownCode?: InputMaybe<Order_By>;
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  /** Describes the type of cost of the claim detail, and specifies if tax and labor apply. */
  claimDetailCategoryId?: InputMaybe<Order_By>;
  /** A method used to group claim details, primarily refers to what component or system is being repaired. */
  claimDetailJobTypeId?: InputMaybe<Order_By>;
  claimServiceCenterId?: InputMaybe<Order_By>;
  componentCode?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Order_By>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemCode?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  /** IT-7607: Timestamp of last trigger recalculation. Updated by force_recalculate_claim_detail() to propagate changes from related tables (policy_claim, policy_claim_insurance, policy_contract_asset, policy_contract_lender). */
  last_recalc_trigger?: InputMaybe<Order_By>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Order_By>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.claim_detail" */
export type ClaimDetail_Mutation_Response = {
  __typename?: 'claimDetail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimDetail>;
};

/** input type for inserting object relation for remote table "claims.claim_detail" */
export type ClaimDetail_Obj_Rel_Insert_Input = {
  data: ClaimDetail_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClaimDetail_On_Conflict>;
};

/** on_conflict condition type for table "claims.claim_detail" */
export type ClaimDetail_On_Conflict = {
  constraint: ClaimDetail_Constraint;
  update_columns?: Array<ClaimDetail_Update_Column>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.claim_detail". */
export type ClaimDetail_Order_By = {
  adjustment_metadata?: InputMaybe<Order_By>;
  breakDownCode?: InputMaybe<Order_By>;
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  claimDetailCategory?: InputMaybe<ClaimDetailCategory_Order_By>;
  claimDetailCategoryId?: InputMaybe<Order_By>;
  claimDetailJobType?: InputMaybe<Type_Order_By>;
  claimDetailJobTypeId?: InputMaybe<Order_By>;
  claimDetailPartLookup?: InputMaybe<ClaimDetailPartLookup_Order_By>;
  claimPart?: InputMaybe<ClaimPart_Order_By>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Order_By>;
  claimServiceCenterId?: InputMaybe<Order_By>;
  componentCode?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deductionMetadata?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discountAmount?: InputMaybe<Order_By>;
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemCode?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  last_recalc_trigger?: InputMaybe<Order_By>;
  lenderPayoffAmount?: InputMaybe<Order_By>;
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  owedAmount?: InputMaybe<Order_By>;
  paidAmount?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  participants_aggregate?: InputMaybe<Participant_Aggregate_Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  refundMetadata?: InputMaybe<Order_By>;
  remittanceClaimDetails_aggregate?: InputMaybe<RemittanceClaimDetail_Aggregate_Order_By>;
  repeatPartAcknowledgments_aggregate?: InputMaybe<RepeatPartAcknowledgment_Aggregate_Order_By>;
  totalCost?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.claim_detail */
export type ClaimDetail_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ClaimDetail_Prepend_Input = {
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * JSONB object holding the automatic adjustments applied to GAP claims: "Over Benefit Limit" (when the total exceeds the paid amount limit) and "Negative Amount" (when the total would be negative). Also carries a "total" key with the sum of all adjustments. Adjustments are subtracted from total_cost.
   *
   * Written by the trigger for GAP claims in Open status; non-GAP and non-Open claims use the mechanical formula and leave it empty. Keys are generated by the trigger, not a type table -- do not branch on them in application code. See ADR 0003 in docs/adr/ (originally IT-7607).
   */
  adjustment_metadata?: InputMaybe<Scalars['jsonb']>;
  /** This is a mapping of claimDeductionTypeId to number */
  deductionMetadata?: InputMaybe<Scalars['jsonb']>;
  /** This is a mapping of claimRefundTypeId to number */
  refundMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "claims.claim_detail" */
export enum ClaimDetail_Select_Column {
  /** column name */
  AdjustmentMetadata = 'adjustment_metadata',
  /** column name */
  BreakDownCode = 'breakDownCode',
  /** column name */
  CashValueOnDateOfLoss = 'cashValueOnDateOfLoss',
  /** column name */
  ClaimDetailCategoryId = 'claimDetailCategoryId',
  /** column name */
  ClaimDetailJobTypeId = 'claimDetailJobTypeId',
  /** column name */
  ClaimServiceCenterId = 'claimServiceCenterId',
  /** column name */
  ComponentCode = 'componentCode',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeductionMetadata = 'deductionMetadata',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  FinanceBenefitLimitAmount = 'financeBenefitLimitAmount',
  /** column name */
  Id = 'id',
  /** column name */
  ItemCode = 'itemCode',
  /** column name */
  LaborCost = 'laborCost',
  /** column name */
  LaborHours = 'laborHours',
  /** column name */
  LaborRateAmount = 'laborRateAmount',
  /** column name */
  LaborTax = 'laborTax',
  /** column name */
  LaborTaxPercent = 'laborTaxPercent',
  /** column name */
  LaborTaxRate = 'laborTaxRate',
  /** column name */
  LastRecalcTrigger = 'last_recalc_trigger',
  /** column name */
  LenderPayoffAmount = 'lenderPayoffAmount',
  /** column name */
  LenderPayoffMinusRefundTotal = 'lenderPayoffMinusRefundTotal',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  PartTax = 'partTax',
  /** column name */
  PartTaxPercent = 'partTaxPercent',
  /** column name */
  PartTaxRate = 'partTaxRate',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RefundMetadata = 'refundMetadata',
  /** column name */
  TotalCost = 'totalCost',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.claim_detail" */
export type ClaimDetail_Set_Input = {
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * JSONB object holding the automatic adjustments applied to GAP claims: "Over Benefit Limit" (when the total exceeds the paid amount limit) and "Negative Amount" (when the total would be negative). Also carries a "total" key with the sum of all adjustments. Adjustments are subtracted from total_cost.
   *
   * Written by the trigger for GAP claims in Open status; non-GAP and non-Open claims use the mechanical formula and leave it empty. Keys are generated by the trigger, not a type table -- do not branch on them in application code. See ADR 0003 in docs/adr/ (originally IT-7607).
   */
  adjustment_metadata?: InputMaybe<Scalars['jsonb']>;
  breakDownCode?: InputMaybe<Scalars['String']>;
  cashValueOnDateOfLoss?: InputMaybe<Scalars['numeric']>;
  /** Describes the type of cost of the claim detail, and specifies if tax and labor apply. */
  claimDetailCategoryId?: InputMaybe<Scalars['uuid']>;
  /** A method used to group claim details, primarily refers to what component or system is being repaired. */
  claimDetailJobTypeId?: InputMaybe<Scalars['uuid']>;
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  componentCode?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** This is a mapping of claimDeductionTypeId to number */
  deductionMetadata?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Scalars['numeric']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  itemCode?: InputMaybe<Scalars['String']>;
  laborHours?: InputMaybe<Scalars['numeric']>;
  laborRateAmount?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
  /** IT-7607: Timestamp of last trigger recalculation. Updated by force_recalculate_claim_detail() to propagate changes from related tables (policy_claim, policy_claim_insurance, policy_contract_asset, policy_contract_lender). */
  last_recalc_trigger?: InputMaybe<Scalars['timestamptz']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Scalars['numeric']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Scalars['numeric']>;
  partNumber?: InputMaybe<Scalars['String']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Scalars['numeric']>;
  partTaxPercent?: InputMaybe<Scalars['numeric']>;
  partTaxRate?: InputMaybe<Scalars['numeric']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  /** This is a mapping of claimRefundTypeId to number */
  refundMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ClaimDetail_Stddev_Fields = {
  __typename?: 'claimDetail_stddev_fields';
  cashValueOnDateOfLoss?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['Float']>;
  laborCost?: Maybe<Scalars['Float']>;
  laborHours?: Maybe<Scalars['Float']>;
  laborRateAmount?: Maybe<Scalars['Float']>;
  laborTax?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['Float']>;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: Maybe<Scalars['Float']>;
  partTaxPercent?: Maybe<Scalars['Float']>;
  partTaxRate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "claims.claim_detail" */
export type ClaimDetail_Stddev_Order_By = {
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Order_By>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Order_By>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ClaimDetail_Stddev_Pop_Fields = {
  __typename?: 'claimDetail_stddev_pop_fields';
  cashValueOnDateOfLoss?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['Float']>;
  laborCost?: Maybe<Scalars['Float']>;
  laborHours?: Maybe<Scalars['Float']>;
  laborRateAmount?: Maybe<Scalars['Float']>;
  laborTax?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['Float']>;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: Maybe<Scalars['Float']>;
  partTaxPercent?: Maybe<Scalars['Float']>;
  partTaxRate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "claims.claim_detail" */
export type ClaimDetail_Stddev_Pop_Order_By = {
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Order_By>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Order_By>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ClaimDetail_Stddev_Samp_Fields = {
  __typename?: 'claimDetail_stddev_samp_fields';
  cashValueOnDateOfLoss?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['Float']>;
  laborCost?: Maybe<Scalars['Float']>;
  laborHours?: Maybe<Scalars['Float']>;
  laborRateAmount?: Maybe<Scalars['Float']>;
  laborTax?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['Float']>;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: Maybe<Scalars['Float']>;
  partTaxPercent?: Maybe<Scalars['Float']>;
  partTaxRate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "claims.claim_detail" */
export type ClaimDetail_Stddev_Samp_Order_By = {
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Order_By>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Order_By>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "claimDetail" */
export type ClaimDetail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClaimDetail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClaimDetail_Stream_Cursor_Value_Input = {
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * JSONB object holding the automatic adjustments applied to GAP claims: "Over Benefit Limit" (when the total exceeds the paid amount limit) and "Negative Amount" (when the total would be negative). Also carries a "total" key with the sum of all adjustments. Adjustments are subtracted from total_cost.
   *
   * Written by the trigger for GAP claims in Open status; non-GAP and non-Open claims use the mechanical formula and leave it empty. Keys are generated by the trigger, not a type table -- do not branch on them in application code. See ADR 0003 in docs/adr/ (originally IT-7607).
   */
  adjustment_metadata?: InputMaybe<Scalars['jsonb']>;
  breakDownCode?: InputMaybe<Scalars['String']>;
  cashValueOnDateOfLoss?: InputMaybe<Scalars['numeric']>;
  /** Describes the type of cost of the claim detail, and specifies if tax and labor apply. */
  claimDetailCategoryId?: InputMaybe<Scalars['uuid']>;
  /** A method used to group claim details, primarily refers to what component or system is being repaired. */
  claimDetailJobTypeId?: InputMaybe<Scalars['uuid']>;
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  componentCode?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** This is a mapping of claimDeductionTypeId to number */
  deductionMetadata?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Scalars['numeric']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  itemCode?: InputMaybe<Scalars['String']>;
  laborCost?: InputMaybe<Scalars['numeric']>;
  laborHours?: InputMaybe<Scalars['numeric']>;
  laborRateAmount?: InputMaybe<Scalars['numeric']>;
  laborTax?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
  /** IT-7607: Timestamp of last trigger recalculation. Updated by force_recalculate_claim_detail() to propagate changes from related tables (policy_claim, policy_claim_insurance, policy_contract_asset, policy_contract_lender). */
  last_recalc_trigger?: InputMaybe<Scalars['timestamptz']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Scalars['numeric']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Scalars['numeric']>;
  partNumber?: InputMaybe<Scalars['String']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Scalars['numeric']>;
  partTaxPercent?: InputMaybe<Scalars['numeric']>;
  partTaxRate?: InputMaybe<Scalars['numeric']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  /** This is a mapping of claimRefundTypeId to number */
  refundMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ClaimDetail_Sum_Fields = {
  __typename?: 'claimDetail_sum_fields';
  cashValueOnDateOfLoss?: Maybe<Scalars['numeric']>;
  cost?: Maybe<Scalars['numeric']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: Maybe<Scalars['numeric']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['numeric']>;
  laborCost?: Maybe<Scalars['numeric']>;
  laborHours?: Maybe<Scalars['numeric']>;
  laborRateAmount?: Maybe<Scalars['numeric']>;
  laborTax?: Maybe<Scalars['numeric']>;
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  laborTaxRate?: Maybe<Scalars['numeric']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['numeric']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['numeric']>;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: Maybe<Scalars['numeric']>;
  partTaxPercent?: Maybe<Scalars['numeric']>;
  partTaxRate?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "claims.claim_detail" */
export type ClaimDetail_Sum_Order_By = {
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Order_By>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Order_By>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Order_By>;
};

/** update columns of table "claims.claim_detail" */
export enum ClaimDetail_Update_Column {
  /** column name */
  AdjustmentMetadata = 'adjustment_metadata',
  /** column name */
  BreakDownCode = 'breakDownCode',
  /** column name */
  CashValueOnDateOfLoss = 'cashValueOnDateOfLoss',
  /** column name */
  ClaimDetailCategoryId = 'claimDetailCategoryId',
  /** column name */
  ClaimDetailJobTypeId = 'claimDetailJobTypeId',
  /** column name */
  ClaimServiceCenterId = 'claimServiceCenterId',
  /** column name */
  ComponentCode = 'componentCode',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeductionMetadata = 'deductionMetadata',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  FinanceBenefitLimitAmount = 'financeBenefitLimitAmount',
  /** column name */
  Id = 'id',
  /** column name */
  ItemCode = 'itemCode',
  /** column name */
  LaborHours = 'laborHours',
  /** column name */
  LaborRateAmount = 'laborRateAmount',
  /** column name */
  LaborTaxPercent = 'laborTaxPercent',
  /** column name */
  LaborTaxRate = 'laborTaxRate',
  /** column name */
  LastRecalcTrigger = 'last_recalc_trigger',
  /** column name */
  LenderPayoffAmount = 'lenderPayoffAmount',
  /** column name */
  LenderPayoffMinusRefundTotal = 'lenderPayoffMinusRefundTotal',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  PartTax = 'partTax',
  /** column name */
  PartTaxPercent = 'partTaxPercent',
  /** column name */
  PartTaxRate = 'partTaxRate',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RefundMetadata = 'refundMetadata',
  /** column name */
  TotalCost = 'totalCost',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClaimDetail_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ClaimDetail_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ClaimDetail_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ClaimDetail_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ClaimDetail_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClaimDetail_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ClaimDetail_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClaimDetail_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClaimDetail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClaimDetail_Var_Pop_Fields = {
  __typename?: 'claimDetail_var_pop_fields';
  cashValueOnDateOfLoss?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['Float']>;
  laborCost?: Maybe<Scalars['Float']>;
  laborHours?: Maybe<Scalars['Float']>;
  laborRateAmount?: Maybe<Scalars['Float']>;
  laborTax?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['Float']>;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: Maybe<Scalars['Float']>;
  partTaxPercent?: Maybe<Scalars['Float']>;
  partTaxRate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "claims.claim_detail" */
export type ClaimDetail_Var_Pop_Order_By = {
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Order_By>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Order_By>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ClaimDetail_Var_Samp_Fields = {
  __typename?: 'claimDetail_var_samp_fields';
  cashValueOnDateOfLoss?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['Float']>;
  laborCost?: Maybe<Scalars['Float']>;
  laborHours?: Maybe<Scalars['Float']>;
  laborRateAmount?: Maybe<Scalars['Float']>;
  laborTax?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['Float']>;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: Maybe<Scalars['Float']>;
  partTaxPercent?: Maybe<Scalars['Float']>;
  partTaxRate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "claims.claim_detail" */
export type ClaimDetail_Var_Samp_Order_By = {
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Order_By>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Order_By>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ClaimDetail_Variance_Fields = {
  __typename?: 'claimDetail_variance_fields';
  cashValueOnDateOfLoss?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: Maybe<Scalars['Float']>;
  laborCost?: Maybe<Scalars['Float']>;
  laborHours?: Maybe<Scalars['Float']>;
  laborRateAmount?: Maybe<Scalars['Float']>;
  laborTax?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: Maybe<Scalars['Float']>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: Maybe<Scalars['Float']>;
  /** The amount still left to be paid on a claim detail. A negative amount would mean overpaid. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The total amount paid for a claim detail (sum of payment_details amount field). */
  paidAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: Maybe<Scalars['Float']>;
  partTaxPercent?: Maybe<Scalars['Float']>;
  partTaxRate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "claims.claim_detail" */
export type ClaimDetail_Variance_Order_By = {
  cashValueOnDateOfLoss?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  /** DEPRECATED for sync — Migrated to its own claim detail record (negative-cost deductible line). The AS400 sync no longer writes it, but it is still read: calculate_totals STEP 3 subtracts it and calculate_service_center_cost_summary sums it, so native (app-created) claims keep their Discount line. Defaults to 0 for synced rows; retained for backward compatibility. */
  discountAmount?: InputMaybe<Order_By>;
  /** Materialized column: (Lender Payoff Minus Refund Total) × (100% - [Cash Value × Finance Benefit Limit %] / Amount Financed). Returns 0 when finance_benefit_limit_percent is NULL (unlimited) or when division by zero would occur. Updated automatically by triggers. */
  financeBenefitLimitAmount?: InputMaybe<Order_By>;
  laborCost?: InputMaybe<Order_By>;
  laborHours?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  laborTax?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  /** Result of the Amortization Schedule calculation */
  lenderPayoffAmount?: InputMaybe<Order_By>;
  /** Materialized column: lender_payoff_amount - refund_metadata→total. Updated automatically by triggers. */
  lenderPayoffMinusRefundTotal?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax amount for parts (cost × quantity × part_tax_percent). Updated by calculate_totals(). Changed from generated column to regular column. */
  partTax?: InputMaybe<Order_By>;
  partTaxPercent?: InputMaybe<Order_By>;
  partTaxRate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  /** Materialized column: For GAP claims (claim_type_id cbe4fedd-81f0-485a-8bd2-e87b5f6ed37c), calculated as lender_payoff_minus_refund_total - finance_benefit_limit_amount - settlement_amount - deduction_metadata→total. For non-GAP claims, calculated as cost × quantity × (1 + part_tax_percent) + (labor_rate_amount × labor_hours) × (1 + labor_tax_percent) - discount_amount. Updated automatically by triggers. */
  totalCost?: InputMaybe<Order_By>;
};

/** Every part on a Claim, and whether that part repeats on the Contract (a part number appearing on more than one Claim). Spans all claim details (~1M rows): every consumer must filter by contract_id or policy_claim_id — an unfiltered scan is pathological. Computed on read; nothing is stored. */
export type ClaimPart = {
  __typename?: 'claimPart';
  /** An array relationship */
  acknowledgments: Array<RepeatPartAcknowledgment>;
  /** An aggregate relationship */
  acknowledgments_aggregate: RepeatPartAcknowledgment_Aggregate;
  /** An object relationship */
  claimDetail?: Maybe<ClaimDetail>;
  claimDetailId?: Maybe<Scalars['uuid']>;
  contractId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** The entry's display and sort date: the job's RO date, falling back to the claim's effective failure date. */
  displayDate?: Maybe<Scalars['date']>;
  /** Whether this part number also appears on another Claim of the same Contract — the only place the Repeat Part rule is written. */
  isRepeat?: Maybe<Scalars['Boolean']>;
  partNumber?: Maybe<Scalars['String']>;
  partNumberNormalized?: Maybe<Scalars['String']>;
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  samePart: Array<ClaimPart>;
  /** An aggregate relationship */
  samePart_aggregate: ClaimPart_Aggregate;
};


/** Every part on a Claim, and whether that part repeats on the Contract (a part number appearing on more than one Claim). Spans all claim details (~1M rows): every consumer must filter by contract_id or policy_claim_id — an unfiltered scan is pathological. Computed on read; nothing is stored. */
export type ClaimPartAcknowledgmentsArgs = {
  distinct_on?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatPartAcknowledgment_Order_By>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};


/** Every part on a Claim, and whether that part repeats on the Contract (a part number appearing on more than one Claim). Spans all claim details (~1M rows): every consumer must filter by contract_id or policy_claim_id — an unfiltered scan is pathological. Computed on read; nothing is stored. */
export type ClaimPartAcknowledgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatPartAcknowledgment_Order_By>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};


/** Every part on a Claim, and whether that part repeats on the Contract (a part number appearing on more than one Claim). Spans all claim details (~1M rows): every consumer must filter by contract_id or policy_claim_id — an unfiltered scan is pathological. Computed on read; nothing is stored. */
export type ClaimPartSamePartArgs = {
  distinct_on?: InputMaybe<Array<ClaimPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimPart_Order_By>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};


/** Every part on a Claim, and whether that part repeats on the Contract (a part number appearing on more than one Claim). Spans all claim details (~1M rows): every consumer must filter by contract_id or policy_claim_id — an unfiltered scan is pathological. Computed on read; nothing is stored. */
export type ClaimPartSamePart_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimPart_Order_By>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};

/** aggregated selection of "claims.claim_part" */
export type ClaimPart_Aggregate = {
  __typename?: 'claimPart_aggregate';
  aggregate?: Maybe<ClaimPart_Aggregate_Fields>;
  nodes: Array<ClaimPart>;
};

export type ClaimPart_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ClaimPart_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ClaimPart_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ClaimPart_Aggregate_Bool_Exp_Count>;
};

export type ClaimPart_Aggregate_Bool_Exp_Bool_And = {
  arguments: ClaimPart_Select_Column_ClaimPart_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClaimPart_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ClaimPart_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ClaimPart_Select_Column_ClaimPart_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClaimPart_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ClaimPart_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClaimPart_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClaimPart_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.claim_part" */
export type ClaimPart_Aggregate_Fields = {
  __typename?: 'claimPart_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ClaimPart_Max_Fields>;
  min?: Maybe<ClaimPart_Min_Fields>;
};


/** aggregate fields of "claims.claim_part" */
export type ClaimPart_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClaimPart_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.claim_part" */
export type ClaimPart_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClaimPart_Max_Order_By>;
  min?: InputMaybe<ClaimPart_Min_Order_By>;
};

/** input type for inserting array relation for remote table "claims.claim_part" */
export type ClaimPart_Arr_Rel_Insert_Input = {
  data: Array<ClaimPart_Insert_Input>;
};

/** Boolean expression to filter rows from the table "claims.claim_part". All fields are combined with a logical 'AND'. */
export type ClaimPart_Bool_Exp = {
  _and?: InputMaybe<Array<ClaimPart_Bool_Exp>>;
  _not?: InputMaybe<ClaimPart_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimPart_Bool_Exp>>;
  acknowledgments?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
  acknowledgments_aggregate?: InputMaybe<RepeatPartAcknowledgment_Aggregate_Bool_Exp>;
  claimDetail?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimDetailId?: InputMaybe<Uuid_Comparison_Exp>;
  contractId?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  displayDate?: InputMaybe<Date_Comparison_Exp>;
  isRepeat?: InputMaybe<Boolean_Comparison_Exp>;
  partNumber?: InputMaybe<String_Comparison_Exp>;
  partNumberNormalized?: InputMaybe<String_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaimId?: InputMaybe<Uuid_Comparison_Exp>;
  samePart?: InputMaybe<ClaimPart_Bool_Exp>;
  samePart_aggregate?: InputMaybe<ClaimPart_Aggregate_Bool_Exp>;
};

/** input type for inserting data into table "claims.claim_part" */
export type ClaimPart_Insert_Input = {
  acknowledgments?: InputMaybe<RepeatPartAcknowledgment_Arr_Rel_Insert_Input>;
  claimDetail?: InputMaybe<ClaimDetail_Obj_Rel_Insert_Input>;
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  /** The entry's display and sort date: the job's RO date, falling back to the claim's effective failure date. */
  displayDate?: InputMaybe<Scalars['date']>;
  /** Whether this part number also appears on another Claim of the same Contract — the only place the Repeat Part rule is written. */
  isRepeat?: InputMaybe<Scalars['Boolean']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partNumberNormalized?: InputMaybe<Scalars['String']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  samePart?: InputMaybe<ClaimPart_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ClaimPart_Max_Fields = {
  __typename?: 'claimPart_max_fields';
  claimDetailId?: Maybe<Scalars['uuid']>;
  contractId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** The entry's display and sort date: the job's RO date, falling back to the claim's effective failure date. */
  displayDate?: Maybe<Scalars['date']>;
  partNumber?: Maybe<Scalars['String']>;
  partNumberNormalized?: Maybe<Scalars['String']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "claims.claim_part" */
export type ClaimPart_Max_Order_By = {
  claimDetailId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** The entry's display and sort date: the job's RO date, falling back to the claim's effective failure date. */
  displayDate?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partNumberNormalized?: InputMaybe<Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClaimPart_Min_Fields = {
  __typename?: 'claimPart_min_fields';
  claimDetailId?: Maybe<Scalars['uuid']>;
  contractId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** The entry's display and sort date: the job's RO date, falling back to the claim's effective failure date. */
  displayDate?: Maybe<Scalars['date']>;
  partNumber?: Maybe<Scalars['String']>;
  partNumberNormalized?: Maybe<Scalars['String']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "claims.claim_part" */
export type ClaimPart_Min_Order_By = {
  claimDetailId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** The entry's display and sort date: the job's RO date, falling back to the claim's effective failure date. */
  displayDate?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partNumberNormalized?: InputMaybe<Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "claims.claim_part" */
export type ClaimPart_Obj_Rel_Insert_Input = {
  data: ClaimPart_Insert_Input;
};

/** Ordering options when selecting data from "claims.claim_part". */
export type ClaimPart_Order_By = {
  acknowledgments_aggregate?: InputMaybe<RepeatPartAcknowledgment_Aggregate_Order_By>;
  claimDetail?: InputMaybe<ClaimDetail_Order_By>;
  claimDetailId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  displayDate?: InputMaybe<Order_By>;
  isRepeat?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partNumberNormalized?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  samePart_aggregate?: InputMaybe<ClaimPart_Aggregate_Order_By>;
};

/** select columns of table "claims.claim_part" */
export enum ClaimPart_Select_Column {
  /** column name */
  ClaimDetailId = 'claimDetailId',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayDate = 'displayDate',
  /** column name */
  IsRepeat = 'isRepeat',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  PartNumberNormalized = 'partNumberNormalized',
  /** column name */
  PolicyClaimId = 'policyClaimId'
}

/** select "claimPart_aggregate_bool_exp_bool_and_arguments_columns" columns of table "claims.claim_part" */
export enum ClaimPart_Select_Column_ClaimPart_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRepeat = 'isRepeat'
}

/** select "claimPart_aggregate_bool_exp_bool_or_arguments_columns" columns of table "claims.claim_part" */
export enum ClaimPart_Select_Column_ClaimPart_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRepeat = 'isRepeat'
}

/** Streaming cursor of the table "claimPart" */
export type ClaimPart_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClaimPart_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClaimPart_Stream_Cursor_Value_Input = {
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  /** The entry's display and sort date: the job's RO date, falling back to the claim's effective failure date. */
  displayDate?: InputMaybe<Scalars['date']>;
  /** Whether this part number also appears on another Claim of the same Contract — the only place the Repeat Part rule is written. */
  isRepeat?: InputMaybe<Scalars['Boolean']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partNumberNormalized?: InputMaybe<Scalars['String']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenter = {
  __typename?: 'claimServiceCenter';
  /** What the viewer may authorize or pay on this Service Provider, as a computed field so it travels with the Claim rather than being read once per provider when the page loads. A limit read at load time goes stale against an Approval granted while the page is open, and is simply absent for a provider added after it, which left the actions either disagreeing with the gate or offered with nothing measured. */
  approvalHeadroom?: Maybe<Array<ApprovalState>>;
  /** An array relationship */
  approvalRequests: Array<ApprovalRequest>;
  /** An aggregate relationship */
  approvalRequests_aggregate: ApprovalRequest_Aggregate;
  /** An array relationship */
  authorizations: Array<ClaimServiceCenterAuthorization>;
  /** An aggregate relationship */
  authorizations_aggregate: ClaimServiceCenterAuthorization_Aggregate;
  /** An array relationship */
  claimDetails: Array<ClaimDetail>;
  /** An aggregate relationship */
  claimDetails_aggregate: ClaimDetail_Aggregate;
  /** An object relationship */
  contact?: Maybe<Contact>;
  costSummaryMetadata: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  defaultPaymentMethodType?: Maybe<PaymentMethodType>;
  defaultPaymentMethodTypeId?: Maybe<Scalars['uuid']>;
  entryDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  itemTaxPercent: Scalars['numeric'];
  itemTaxRate: Scalars['numeric'];
  /** An object relationship */
  laborGuideType?: Maybe<Type>;
  /** The labor guide this Service Provider quoted their labor hours from, recorded by the adjuster so a quote can be re-checked against the same source later (IT-8494). References a shared.type row in the LaborGuide type group (af411fb9-0765-4950-b2e8-74523289b287); the group is display-only, so the claims Service Provider side menus read it at runtime ordered by display rather than through generated constants - see docs/adr/0006-job-types-read-at-runtime.md. NULL means the adjuster has not recorded one. */
  laborGuideTypeId?: Maybe<Scalars['uuid']>;
  laborRate: Scalars['numeric'];
  laborTaxPercent: Scalars['numeric'];
  laborTaxRate: Scalars['numeric'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An array relationship */
  participants: Array<Participant>;
  /** An aggregate relationship */
  participants_aggregate: Participant_Aggregate;
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
  /** An object relationship */
  policyClaim: PolicyClaim;
  policyClaimId: Scalars['uuid'];
  roDate?: Maybe<Scalars['date']>;
  roNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  serviceCenter: ServiceCenter;
  serviceCenterId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterApprovalHeadroomArgs = {
  args: ApprovalHeadroom_ClaimServiceCenter_Args;
  distinct_on?: InputMaybe<Array<ApprovalState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalState_Order_By>>;
  where?: InputMaybe<ApprovalState_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterApprovalRequestsArgs = {
  distinct_on?: InputMaybe<Array<ApprovalRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalRequest_Order_By>>;
  where?: InputMaybe<ApprovalRequest_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterApprovalRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalRequest_Order_By>>;
  where?: InputMaybe<ApprovalRequest_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterAuthorizationsArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenterAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenterAuthorization_Order_By>>;
  where?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterAuthorizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenterAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenterAuthorization_Order_By>>;
  where?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterClaimDetailsArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterClaimDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterCostSummaryMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterParticipants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "claims.claim_service_center" */
export type ClaimServiceCenterPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};

/** Records that a claim service center exists as its own claim in the AS400 and which claim number it was assigned. Populated only by the AS400 mechanical-claim sync (IT-8281/IT-8167); legacy claims never get rows here. */
export type ClaimServiceCenterAs400 = {
  __typename?: 'claimServiceCenterAs400';
  /** AS400 claim number for this service center. The first service center on a claim re-uses policy_claim.number; additional ones pull from public.policy_claim_number_seq. New-system claims use the reserved 3,000,000-3,999,999 range. */
  claimNumber: Scalars['String'];
  /** An object relationship */
  claimServiceCenter: ClaimServiceCenter;
  claimServiceCenterId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "claims.claim_service_center_as400" */
export type ClaimServiceCenterAs400_Aggregate = {
  __typename?: 'claimServiceCenterAs400_aggregate';
  aggregate?: Maybe<ClaimServiceCenterAs400_Aggregate_Fields>;
  nodes: Array<ClaimServiceCenterAs400>;
};

/** aggregate fields of "claims.claim_service_center_as400" */
export type ClaimServiceCenterAs400_Aggregate_Fields = {
  __typename?: 'claimServiceCenterAs400_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ClaimServiceCenterAs400_Max_Fields>;
  min?: Maybe<ClaimServiceCenterAs400_Min_Fields>;
};


/** aggregate fields of "claims.claim_service_center_as400" */
export type ClaimServiceCenterAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClaimServiceCenterAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.claim_service_center_as400". All fields are combined with a logical 'AND'. */
export type ClaimServiceCenterAs400_Bool_Exp = {
  _and?: InputMaybe<Array<ClaimServiceCenterAs400_Bool_Exp>>;
  _not?: InputMaybe<ClaimServiceCenterAs400_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimServiceCenterAs400_Bool_Exp>>;
  claimNumber?: InputMaybe<String_Comparison_Exp>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  claimServiceCenterId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.claim_service_center_as400" */
export enum ClaimServiceCenterAs400_Constraint {
  /** unique or primary key constraint on columns "claim_number" */
  ClaimServiceCenterAs400ClaimNumberKey = 'claim_service_center_as400_claim_number_key',
  /** unique or primary key constraint on columns "claim_service_center_id" */
  ClaimServiceCenterAs400ClaimServiceCenterIdKey = 'claim_service_center_as400_claim_service_center_id_key',
  /** unique or primary key constraint on columns "id" */
  ClaimServiceCenterAs400Pkey = 'claim_service_center_as400_pkey'
}

/** input type for inserting data into table "claims.claim_service_center_as400" */
export type ClaimServiceCenterAs400_Insert_Input = {
  /** AS400 claim number for this service center. The first service center on a claim re-uses policy_claim.number; additional ones pull from public.policy_claim_number_seq. New-system claims use the reserved 3,000,000-3,999,999 range. */
  claimNumber?: InputMaybe<Scalars['String']>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Obj_Rel_Insert_Input>;
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClaimServiceCenterAs400_Max_Fields = {
  __typename?: 'claimServiceCenterAs400_max_fields';
  /** AS400 claim number for this service center. The first service center on a claim re-uses policy_claim.number; additional ones pull from public.policy_claim_number_seq. New-system claims use the reserved 3,000,000-3,999,999 range. */
  claimNumber?: Maybe<Scalars['String']>;
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ClaimServiceCenterAs400_Min_Fields = {
  __typename?: 'claimServiceCenterAs400_min_fields';
  /** AS400 claim number for this service center. The first service center on a claim re-uses policy_claim.number; additional ones pull from public.policy_claim_number_seq. New-system claims use the reserved 3,000,000-3,999,999 range. */
  claimNumber?: Maybe<Scalars['String']>;
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.claim_service_center_as400" */
export type ClaimServiceCenterAs400_Mutation_Response = {
  __typename?: 'claimServiceCenterAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimServiceCenterAs400>;
};

/** on_conflict condition type for table "claims.claim_service_center_as400" */
export type ClaimServiceCenterAs400_On_Conflict = {
  constraint: ClaimServiceCenterAs400_Constraint;
  update_columns?: Array<ClaimServiceCenterAs400_Update_Column>;
  where?: InputMaybe<ClaimServiceCenterAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.claim_service_center_as400". */
export type ClaimServiceCenterAs400_Order_By = {
  claimNumber?: InputMaybe<Order_By>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Order_By>;
  claimServiceCenterId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.claim_service_center_as400 */
export type ClaimServiceCenterAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.claim_service_center_as400" */
export enum ClaimServiceCenterAs400_Select_Column {
  /** column name */
  ClaimNumber = 'claimNumber',
  /** column name */
  ClaimServiceCenterId = 'claimServiceCenterId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.claim_service_center_as400" */
export type ClaimServiceCenterAs400_Set_Input = {
  /** AS400 claim number for this service center. The first service center on a claim re-uses policy_claim.number; additional ones pull from public.policy_claim_number_seq. New-system claims use the reserved 3,000,000-3,999,999 range. */
  claimNumber?: InputMaybe<Scalars['String']>;
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "claimServiceCenterAs400" */
export type ClaimServiceCenterAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClaimServiceCenterAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClaimServiceCenterAs400_Stream_Cursor_Value_Input = {
  /** AS400 claim number for this service center. The first service center on a claim re-uses policy_claim.number; additional ones pull from public.policy_claim_number_seq. New-system claims use the reserved 3,000,000-3,999,999 range. */
  claimNumber?: InputMaybe<Scalars['String']>;
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "claims.claim_service_center_as400" */
export enum ClaimServiceCenterAs400_Update_Column {
  /** column name */
  ClaimNumber = 'claimNumber',
  /** column name */
  ClaimServiceCenterId = 'claimServiceCenterId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClaimServiceCenterAs400_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClaimServiceCenterAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClaimServiceCenterAs400_Bool_Exp;
};

/** An Adjuster's go-ahead to one Service Provider on a Claim to perform work, which in the same act clears that provider to be paid. One row per authorization event: a supplement is a new row, never an edit to the previous one. Does not change the Claim's status — status is lifecycle only (Pending -> Open -> Closed, with Denied and Voided terminal), and the retired Approved status is what this table replaces. */
export type ClaimServiceCenterAuthorization = {
  __typename?: 'claimServiceCenterAuthorization';
  /** The six-character Crockford base32 code the Service Provider quotes when calling back about this Claim Authorization, derived from the amount it authorizes. One per authorization rather than one per provider, so a supplement is quoted under its own code and an Adjuster can still read what an older code was granted for. NULL means the AS400 sync created the row, where no code was read to anyone. */
  authorizationNumber?: Maybe<Scalars['String']>;
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount: Scalars['numeric'];
  /** An object relationship */
  authorizedBy?: Maybe<Identity>;
  /** Who authorized. NULL means the AS400 sync created this row: AS400 keeps producing ClaimStatusCode = 'A' forever and the import maps it to Open, keeping one live authorization at AS400's current total for each provider in that claim's ClaimServiceCenter.csv (volumes/data-sync/claims/import.sql). No Adjuster made that judgment, none is recorded, and no Authorization Number is minted — the screen says "authorized in AS400" rather than inventing a code. This column is the test for that, so do not fill it in with a service account. */
  authorizedByIdentityId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  claimServiceCenter: ClaimServiceCenter;
  /** The Service Provider on the Claim that this authorization clears. The grain of the table: authorization is per provider, not per Claim, so one Claim can carry an authorized shop and an unauthorized one at once. */
  claimServiceCenterId: Scalars['uuid'];
  /** When the authorization was granted. The Adjuster's decision time, and what orders a provider's supplements. */
  createdAt: Scalars['timestamptz'];
  /** Surrogate key. One row per authorization event: a supplement is a new row, never an edit to the previous one, so this is not stable across a provider's authorizations. */
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** Revocation is a state change, never a delete. Set manually by anyone who could have granted the authorization — withdrawing permission must not need more authority than granting it — and automatically when the Claim is Denied, Voided or closed, because a closed or voided Claim must not carry a live payment clearance. On a Legacy Claim the AS400 sync also sets it when AS400 changes the provider's bill or no longer has the Claim at 'A'. */
  revokedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  revokedBy?: Maybe<Identity>;
  /** Who revoked. NULL alongside a set revoked_at means no person did: the terminal-status trigger revokes during an automatic close, including one driven by the AS400 sync, and the sync revokes its own authorization when AS400 changes the provider's bill or no longer has the Claim at 'A'. A person here is not proof of an Adjuster's decision: a Pay that covers the last provider closes the Claim in the payer's session and the terminal-status trigger records the payer, which is why the sync authorizes a Legacy Claim again whoever revoked it. */
  revokedByIdentityId?: Maybe<Scalars['uuid']>;
  /** Last write to the row. Only a revocation edits an existing row, so this differs from created_at exactly when revoked_at is set. */
  updatedAt: Scalars['timestamptz'];
};


/** An Adjuster's go-ahead to one Service Provider on a Claim to perform work, which in the same act clears that provider to be paid. One row per authorization event: a supplement is a new row, never an edit to the previous one. Does not change the Claim's status — status is lifecycle only (Pending -> Open -> Closed, with Denied and Voided terminal), and the retired Approved status is what this table replaces. */
export type ClaimServiceCenterAuthorizationLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** An Adjuster's go-ahead to one Service Provider on a Claim to perform work, which in the same act clears that provider to be paid. One row per authorization event: a supplement is a new row, never an edit to the previous one. Does not change the Claim's status — status is lifecycle only (Pending -> Open -> Closed, with Denied and Voided terminal), and the retired Approved status is what this table replaces. */
export type ClaimServiceCenterAuthorizationLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Aggregate = {
  __typename?: 'claimServiceCenterAuthorization_aggregate';
  aggregate?: Maybe<ClaimServiceCenterAuthorization_Aggregate_Fields>;
  nodes: Array<ClaimServiceCenterAuthorization>;
};

export type ClaimServiceCenterAuthorization_Aggregate_Bool_Exp = {
  count?: InputMaybe<ClaimServiceCenterAuthorization_Aggregate_Bool_Exp_Count>;
};

export type ClaimServiceCenterAuthorization_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClaimServiceCenterAuthorization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Aggregate_Fields = {
  __typename?: 'claimServiceCenterAuthorization_aggregate_fields';
  avg?: Maybe<ClaimServiceCenterAuthorization_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClaimServiceCenterAuthorization_Max_Fields>;
  min?: Maybe<ClaimServiceCenterAuthorization_Min_Fields>;
  stddev?: Maybe<ClaimServiceCenterAuthorization_Stddev_Fields>;
  stddev_pop?: Maybe<ClaimServiceCenterAuthorization_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClaimServiceCenterAuthorization_Stddev_Samp_Fields>;
  sum?: Maybe<ClaimServiceCenterAuthorization_Sum_Fields>;
  var_pop?: Maybe<ClaimServiceCenterAuthorization_Var_Pop_Fields>;
  var_samp?: Maybe<ClaimServiceCenterAuthorization_Var_Samp_Fields>;
  variance?: Maybe<ClaimServiceCenterAuthorization_Variance_Fields>;
};


/** aggregate fields of "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClaimServiceCenterAuthorization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Aggregate_Order_By = {
  avg?: InputMaybe<ClaimServiceCenterAuthorization_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClaimServiceCenterAuthorization_Max_Order_By>;
  min?: InputMaybe<ClaimServiceCenterAuthorization_Min_Order_By>;
  stddev?: InputMaybe<ClaimServiceCenterAuthorization_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ClaimServiceCenterAuthorization_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ClaimServiceCenterAuthorization_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ClaimServiceCenterAuthorization_Sum_Order_By>;
  var_pop?: InputMaybe<ClaimServiceCenterAuthorization_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ClaimServiceCenterAuthorization_Var_Samp_Order_By>;
  variance?: InputMaybe<ClaimServiceCenterAuthorization_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Arr_Rel_Insert_Input = {
  data: Array<ClaimServiceCenterAuthorization_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClaimServiceCenterAuthorization_On_Conflict>;
};

/** aggregate avg on columns */
export type ClaimServiceCenterAuthorization_Avg_Fields = {
  __typename?: 'claimServiceCenterAuthorization_avg_fields';
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Avg_Order_By = {
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "claims.claim_service_center_authorization". All fields are combined with a logical 'AND'. */
export type ClaimServiceCenterAuthorization_Bool_Exp = {
  _and?: InputMaybe<Array<ClaimServiceCenterAuthorization_Bool_Exp>>;
  _not?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimServiceCenterAuthorization_Bool_Exp>>;
  authorizationNumber?: InputMaybe<String_Comparison_Exp>;
  authorizedAmount?: InputMaybe<Numeric_Comparison_Exp>;
  authorizedBy?: InputMaybe<Identity_Bool_Exp>;
  authorizedByIdentityId?: InputMaybe<Uuid_Comparison_Exp>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  claimServiceCenterId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  revokedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  revokedBy?: InputMaybe<Identity_Bool_Exp>;
  revokedByIdentityId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.claim_service_center_authorization" */
export enum ClaimServiceCenterAuthorization_Constraint {
  /** unique or primary key constraint on columns "claim_service_center_id" */
  ClaimServiceCenterAuthorizationOneLiveIdx = 'claim_service_center_authorization_one_live_idx',
  /** unique or primary key constraint on columns "id" */
  ClaimServiceCenterAuthorizationPkey = 'claim_service_center_authorization_pkey'
}

/** input type for incrementing numeric columns in table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Inc_Input = {
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Insert_Input = {
  /** The six-character Crockford base32 code the Service Provider quotes when calling back about this Claim Authorization, derived from the amount it authorizes. One per authorization rather than one per provider, so a supplement is quoted under its own code and an Adjuster can still read what an older code was granted for. NULL means the AS400 sync created the row, where no code was read to anyone. */
  authorizationNumber?: InputMaybe<Scalars['String']>;
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Scalars['numeric']>;
  authorizedBy?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  /** Who authorized. NULL means the AS400 sync created this row: AS400 keeps producing ClaimStatusCode = 'A' forever and the import maps it to Open, keeping one live authorization at AS400's current total for each provider in that claim's ClaimServiceCenter.csv (volumes/data-sync/claims/import.sql). No Adjuster made that judgment, none is recorded, and no Authorization Number is minted — the screen says "authorized in AS400" rather than inventing a code. This column is the test for that, so do not fill it in with a service account. */
  authorizedByIdentityId?: InputMaybe<Scalars['uuid']>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Obj_Rel_Insert_Input>;
  /** The Service Provider on the Claim that this authorization clears. The grain of the table: authorization is per provider, not per Claim, so one Claim can carry an authorized shop and an unauthorized one at once. */
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  /** When the authorization was granted. The Adjuster's decision time, and what orders a provider's supplements. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Surrogate key. One row per authorization event: a supplement is a new row, never an edit to the previous one, so this is not stable across a provider's authorizations. */
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  /** Revocation is a state change, never a delete. Set manually by anyone who could have granted the authorization — withdrawing permission must not need more authority than granting it — and automatically when the Claim is Denied, Voided or closed, because a closed or voided Claim must not carry a live payment clearance. On a Legacy Claim the AS400 sync also sets it when AS400 changes the provider's bill or no longer has the Claim at 'A'. */
  revokedAt?: InputMaybe<Scalars['timestamptz']>;
  revokedBy?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  /** Who revoked. NULL alongside a set revoked_at means no person did: the terminal-status trigger revokes during an automatic close, including one driven by the AS400 sync, and the sync revokes its own authorization when AS400 changes the provider's bill or no longer has the Claim at 'A'. A person here is not proof of an Adjuster's decision: a Pay that covers the last provider closes the Claim in the payer's session and the terminal-status trigger records the payer, which is why the sync authorizes a Legacy Claim again whoever revoked it. */
  revokedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** Last write to the row. Only a revocation edits an existing row, so this differs from created_at exactly when revoked_at is set. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClaimServiceCenterAuthorization_Max_Fields = {
  __typename?: 'claimServiceCenterAuthorization_max_fields';
  /** The six-character Crockford base32 code the Service Provider quotes when calling back about this Claim Authorization, derived from the amount it authorizes. One per authorization rather than one per provider, so a supplement is quoted under its own code and an Adjuster can still read what an older code was granted for. NULL means the AS400 sync created the row, where no code was read to anyone. */
  authorizationNumber?: Maybe<Scalars['String']>;
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: Maybe<Scalars['numeric']>;
  /** Who authorized. NULL means the AS400 sync created this row: AS400 keeps producing ClaimStatusCode = 'A' forever and the import maps it to Open, keeping one live authorization at AS400's current total for each provider in that claim's ClaimServiceCenter.csv (volumes/data-sync/claims/import.sql). No Adjuster made that judgment, none is recorded, and no Authorization Number is minted — the screen says "authorized in AS400" rather than inventing a code. This column is the test for that, so do not fill it in with a service account. */
  authorizedByIdentityId?: Maybe<Scalars['uuid']>;
  /** The Service Provider on the Claim that this authorization clears. The grain of the table: authorization is per provider, not per Claim, so one Claim can carry an authorized shop and an unauthorized one at once. */
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  /** When the authorization was granted. The Adjuster's decision time, and what orders a provider's supplements. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Surrogate key. One row per authorization event: a supplement is a new row, never an edit to the previous one, so this is not stable across a provider's authorizations. */
  id?: Maybe<Scalars['uuid']>;
  /** Revocation is a state change, never a delete. Set manually by anyone who could have granted the authorization — withdrawing permission must not need more authority than granting it — and automatically when the Claim is Denied, Voided or closed, because a closed or voided Claim must not carry a live payment clearance. On a Legacy Claim the AS400 sync also sets it when AS400 changes the provider's bill or no longer has the Claim at 'A'. */
  revokedAt?: Maybe<Scalars['timestamptz']>;
  /** Who revoked. NULL alongside a set revoked_at means no person did: the terminal-status trigger revokes during an automatic close, including one driven by the AS400 sync, and the sync revokes its own authorization when AS400 changes the provider's bill or no longer has the Claim at 'A'. A person here is not proof of an Adjuster's decision: a Pay that covers the last provider closes the Claim in the payer's session and the terminal-status trigger records the payer, which is why the sync authorizes a Legacy Claim again whoever revoked it. */
  revokedByIdentityId?: Maybe<Scalars['uuid']>;
  /** Last write to the row. Only a revocation edits an existing row, so this differs from created_at exactly when revoked_at is set. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Max_Order_By = {
  /** The six-character Crockford base32 code the Service Provider quotes when calling back about this Claim Authorization, derived from the amount it authorizes. One per authorization rather than one per provider, so a supplement is quoted under its own code and an Adjuster can still read what an older code was granted for. NULL means the AS400 sync created the row, where no code was read to anyone. */
  authorizationNumber?: InputMaybe<Order_By>;
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Order_By>;
  /** Who authorized. NULL means the AS400 sync created this row: AS400 keeps producing ClaimStatusCode = 'A' forever and the import maps it to Open, keeping one live authorization at AS400's current total for each provider in that claim's ClaimServiceCenter.csv (volumes/data-sync/claims/import.sql). No Adjuster made that judgment, none is recorded, and no Authorization Number is minted — the screen says "authorized in AS400" rather than inventing a code. This column is the test for that, so do not fill it in with a service account. */
  authorizedByIdentityId?: InputMaybe<Order_By>;
  /** The Service Provider on the Claim that this authorization clears. The grain of the table: authorization is per provider, not per Claim, so one Claim can carry an authorized shop and an unauthorized one at once. */
  claimServiceCenterId?: InputMaybe<Order_By>;
  /** When the authorization was granted. The Adjuster's decision time, and what orders a provider's supplements. */
  createdAt?: InputMaybe<Order_By>;
  /** Surrogate key. One row per authorization event: a supplement is a new row, never an edit to the previous one, so this is not stable across a provider's authorizations. */
  id?: InputMaybe<Order_By>;
  /** Revocation is a state change, never a delete. Set manually by anyone who could have granted the authorization — withdrawing permission must not need more authority than granting it — and automatically when the Claim is Denied, Voided or closed, because a closed or voided Claim must not carry a live payment clearance. On a Legacy Claim the AS400 sync also sets it when AS400 changes the provider's bill or no longer has the Claim at 'A'. */
  revokedAt?: InputMaybe<Order_By>;
  /** Who revoked. NULL alongside a set revoked_at means no person did: the terminal-status trigger revokes during an automatic close, including one driven by the AS400 sync, and the sync revokes its own authorization when AS400 changes the provider's bill or no longer has the Claim at 'A'. A person here is not proof of an Adjuster's decision: a Pay that covers the last provider closes the Claim in the payer's session and the terminal-status trigger records the payer, which is why the sync authorizes a Legacy Claim again whoever revoked it. */
  revokedByIdentityId?: InputMaybe<Order_By>;
  /** Last write to the row. Only a revocation edits an existing row, so this differs from created_at exactly when revoked_at is set. */
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClaimServiceCenterAuthorization_Min_Fields = {
  __typename?: 'claimServiceCenterAuthorization_min_fields';
  /** The six-character Crockford base32 code the Service Provider quotes when calling back about this Claim Authorization, derived from the amount it authorizes. One per authorization rather than one per provider, so a supplement is quoted under its own code and an Adjuster can still read what an older code was granted for. NULL means the AS400 sync created the row, where no code was read to anyone. */
  authorizationNumber?: Maybe<Scalars['String']>;
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: Maybe<Scalars['numeric']>;
  /** Who authorized. NULL means the AS400 sync created this row: AS400 keeps producing ClaimStatusCode = 'A' forever and the import maps it to Open, keeping one live authorization at AS400's current total for each provider in that claim's ClaimServiceCenter.csv (volumes/data-sync/claims/import.sql). No Adjuster made that judgment, none is recorded, and no Authorization Number is minted — the screen says "authorized in AS400" rather than inventing a code. This column is the test for that, so do not fill it in with a service account. */
  authorizedByIdentityId?: Maybe<Scalars['uuid']>;
  /** The Service Provider on the Claim that this authorization clears. The grain of the table: authorization is per provider, not per Claim, so one Claim can carry an authorized shop and an unauthorized one at once. */
  claimServiceCenterId?: Maybe<Scalars['uuid']>;
  /** When the authorization was granted. The Adjuster's decision time, and what orders a provider's supplements. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Surrogate key. One row per authorization event: a supplement is a new row, never an edit to the previous one, so this is not stable across a provider's authorizations. */
  id?: Maybe<Scalars['uuid']>;
  /** Revocation is a state change, never a delete. Set manually by anyone who could have granted the authorization — withdrawing permission must not need more authority than granting it — and automatically when the Claim is Denied, Voided or closed, because a closed or voided Claim must not carry a live payment clearance. On a Legacy Claim the AS400 sync also sets it when AS400 changes the provider's bill or no longer has the Claim at 'A'. */
  revokedAt?: Maybe<Scalars['timestamptz']>;
  /** Who revoked. NULL alongside a set revoked_at means no person did: the terminal-status trigger revokes during an automatic close, including one driven by the AS400 sync, and the sync revokes its own authorization when AS400 changes the provider's bill or no longer has the Claim at 'A'. A person here is not proof of an Adjuster's decision: a Pay that covers the last provider closes the Claim in the payer's session and the terminal-status trigger records the payer, which is why the sync authorizes a Legacy Claim again whoever revoked it. */
  revokedByIdentityId?: Maybe<Scalars['uuid']>;
  /** Last write to the row. Only a revocation edits an existing row, so this differs from created_at exactly when revoked_at is set. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Min_Order_By = {
  /** The six-character Crockford base32 code the Service Provider quotes when calling back about this Claim Authorization, derived from the amount it authorizes. One per authorization rather than one per provider, so a supplement is quoted under its own code and an Adjuster can still read what an older code was granted for. NULL means the AS400 sync created the row, where no code was read to anyone. */
  authorizationNumber?: InputMaybe<Order_By>;
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Order_By>;
  /** Who authorized. NULL means the AS400 sync created this row: AS400 keeps producing ClaimStatusCode = 'A' forever and the import maps it to Open, keeping one live authorization at AS400's current total for each provider in that claim's ClaimServiceCenter.csv (volumes/data-sync/claims/import.sql). No Adjuster made that judgment, none is recorded, and no Authorization Number is minted — the screen says "authorized in AS400" rather than inventing a code. This column is the test for that, so do not fill it in with a service account. */
  authorizedByIdentityId?: InputMaybe<Order_By>;
  /** The Service Provider on the Claim that this authorization clears. The grain of the table: authorization is per provider, not per Claim, so one Claim can carry an authorized shop and an unauthorized one at once. */
  claimServiceCenterId?: InputMaybe<Order_By>;
  /** When the authorization was granted. The Adjuster's decision time, and what orders a provider's supplements. */
  createdAt?: InputMaybe<Order_By>;
  /** Surrogate key. One row per authorization event: a supplement is a new row, never an edit to the previous one, so this is not stable across a provider's authorizations. */
  id?: InputMaybe<Order_By>;
  /** Revocation is a state change, never a delete. Set manually by anyone who could have granted the authorization — withdrawing permission must not need more authority than granting it — and automatically when the Claim is Denied, Voided or closed, because a closed or voided Claim must not carry a live payment clearance. On a Legacy Claim the AS400 sync also sets it when AS400 changes the provider's bill or no longer has the Claim at 'A'. */
  revokedAt?: InputMaybe<Order_By>;
  /** Who revoked. NULL alongside a set revoked_at means no person did: the terminal-status trigger revokes during an automatic close, including one driven by the AS400 sync, and the sync revokes its own authorization when AS400 changes the provider's bill or no longer has the Claim at 'A'. A person here is not proof of an Adjuster's decision: a Pay that covers the last provider closes the Claim in the payer's session and the terminal-status trigger records the payer, which is why the sync authorizes a Legacy Claim again whoever revoked it. */
  revokedByIdentityId?: InputMaybe<Order_By>;
  /** Last write to the row. Only a revocation edits an existing row, so this differs from created_at exactly when revoked_at is set. */
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Mutation_Response = {
  __typename?: 'claimServiceCenterAuthorization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimServiceCenterAuthorization>;
};

/** on_conflict condition type for table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_On_Conflict = {
  constraint: ClaimServiceCenterAuthorization_Constraint;
  update_columns?: Array<ClaimServiceCenterAuthorization_Update_Column>;
  where?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.claim_service_center_authorization". */
export type ClaimServiceCenterAuthorization_Order_By = {
  authorizationNumber?: InputMaybe<Order_By>;
  authorizedAmount?: InputMaybe<Order_By>;
  authorizedBy?: InputMaybe<Identity_Order_By>;
  authorizedByIdentityId?: InputMaybe<Order_By>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Order_By>;
  claimServiceCenterId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  revokedAt?: InputMaybe<Order_By>;
  revokedBy?: InputMaybe<Identity_Order_By>;
  revokedByIdentityId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.claim_service_center_authorization */
export type ClaimServiceCenterAuthorization_Pk_Columns_Input = {
  /** Surrogate key. One row per authorization event: a supplement is a new row, never an edit to the previous one, so this is not stable across a provider's authorizations. */
  id: Scalars['uuid'];
};

/** select columns of table "claims.claim_service_center_authorization" */
export enum ClaimServiceCenterAuthorization_Select_Column {
  /** column name */
  AuthorizationNumber = 'authorizationNumber',
  /** column name */
  AuthorizedAmount = 'authorizedAmount',
  /** column name */
  AuthorizedByIdentityId = 'authorizedByIdentityId',
  /** column name */
  ClaimServiceCenterId = 'claimServiceCenterId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RevokedAt = 'revokedAt',
  /** column name */
  RevokedByIdentityId = 'revokedByIdentityId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Set_Input = {
  /** The six-character Crockford base32 code the Service Provider quotes when calling back about this Claim Authorization, derived from the amount it authorizes. One per authorization rather than one per provider, so a supplement is quoted under its own code and an Adjuster can still read what an older code was granted for. NULL means the AS400 sync created the row, where no code was read to anyone. */
  authorizationNumber?: InputMaybe<Scalars['String']>;
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Scalars['numeric']>;
  /** Who authorized. NULL means the AS400 sync created this row: AS400 keeps producing ClaimStatusCode = 'A' forever and the import maps it to Open, keeping one live authorization at AS400's current total for each provider in that claim's ClaimServiceCenter.csv (volumes/data-sync/claims/import.sql). No Adjuster made that judgment, none is recorded, and no Authorization Number is minted — the screen says "authorized in AS400" rather than inventing a code. This column is the test for that, so do not fill it in with a service account. */
  authorizedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** The Service Provider on the Claim that this authorization clears. The grain of the table: authorization is per provider, not per Claim, so one Claim can carry an authorized shop and an unauthorized one at once. */
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  /** When the authorization was granted. The Adjuster's decision time, and what orders a provider's supplements. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Surrogate key. One row per authorization event: a supplement is a new row, never an edit to the previous one, so this is not stable across a provider's authorizations. */
  id?: InputMaybe<Scalars['uuid']>;
  /** Revocation is a state change, never a delete. Set manually by anyone who could have granted the authorization — withdrawing permission must not need more authority than granting it — and automatically when the Claim is Denied, Voided or closed, because a closed or voided Claim must not carry a live payment clearance. On a Legacy Claim the AS400 sync also sets it when AS400 changes the provider's bill or no longer has the Claim at 'A'. */
  revokedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Who revoked. NULL alongside a set revoked_at means no person did: the terminal-status trigger revokes during an automatic close, including one driven by the AS400 sync, and the sync revokes its own authorization when AS400 changes the provider's bill or no longer has the Claim at 'A'. A person here is not proof of an Adjuster's decision: a Pay that covers the last provider closes the Claim in the payer's session and the terminal-status trigger records the payer, which is why the sync authorizes a Legacy Claim again whoever revoked it. */
  revokedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** Last write to the row. Only a revocation edits an existing row, so this differs from created_at exactly when revoked_at is set. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ClaimServiceCenterAuthorization_Stddev_Fields = {
  __typename?: 'claimServiceCenterAuthorization_stddev_fields';
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Stddev_Order_By = {
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ClaimServiceCenterAuthorization_Stddev_Pop_Fields = {
  __typename?: 'claimServiceCenterAuthorization_stddev_pop_fields';
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Stddev_Pop_Order_By = {
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ClaimServiceCenterAuthorization_Stddev_Samp_Fields = {
  __typename?: 'claimServiceCenterAuthorization_stddev_samp_fields';
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Stddev_Samp_Order_By = {
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "claimServiceCenterAuthorization" */
export type ClaimServiceCenterAuthorization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClaimServiceCenterAuthorization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClaimServiceCenterAuthorization_Stream_Cursor_Value_Input = {
  /** The six-character Crockford base32 code the Service Provider quotes when calling back about this Claim Authorization, derived from the amount it authorizes. One per authorization rather than one per provider, so a supplement is quoted under its own code and an Adjuster can still read what an older code was granted for. NULL means the AS400 sync created the row, where no code was read to anyone. */
  authorizationNumber?: InputMaybe<Scalars['String']>;
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Scalars['numeric']>;
  /** Who authorized. NULL means the AS400 sync created this row: AS400 keeps producing ClaimStatusCode = 'A' forever and the import maps it to Open, keeping one live authorization at AS400's current total for each provider in that claim's ClaimServiceCenter.csv (volumes/data-sync/claims/import.sql). No Adjuster made that judgment, none is recorded, and no Authorization Number is minted — the screen says "authorized in AS400" rather than inventing a code. This column is the test for that, so do not fill it in with a service account. */
  authorizedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** The Service Provider on the Claim that this authorization clears. The grain of the table: authorization is per provider, not per Claim, so one Claim can carry an authorized shop and an unauthorized one at once. */
  claimServiceCenterId?: InputMaybe<Scalars['uuid']>;
  /** When the authorization was granted. The Adjuster's decision time, and what orders a provider's supplements. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Surrogate key. One row per authorization event: a supplement is a new row, never an edit to the previous one, so this is not stable across a provider's authorizations. */
  id?: InputMaybe<Scalars['uuid']>;
  /** Revocation is a state change, never a delete. Set manually by anyone who could have granted the authorization — withdrawing permission must not need more authority than granting it — and automatically when the Claim is Denied, Voided or closed, because a closed or voided Claim must not carry a live payment clearance. On a Legacy Claim the AS400 sync also sets it when AS400 changes the provider's bill or no longer has the Claim at 'A'. */
  revokedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Who revoked. NULL alongside a set revoked_at means no person did: the terminal-status trigger revokes during an automatic close, including one driven by the AS400 sync, and the sync revokes its own authorization when AS400 changes the provider's bill or no longer has the Claim at 'A'. A person here is not proof of an Adjuster's decision: a Pay that covers the last provider closes the Claim in the payer's session and the terminal-status trigger records the payer, which is why the sync authorizes a Legacy Claim again whoever revoked it. */
  revokedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** Last write to the row. Only a revocation edits an existing row, so this differs from created_at exactly when revoked_at is set. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ClaimServiceCenterAuthorization_Sum_Fields = {
  __typename?: 'claimServiceCenterAuthorization_sum_fields';
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Sum_Order_By = {
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Order_By>;
};

/** update columns of table "claims.claim_service_center_authorization" */
export enum ClaimServiceCenterAuthorization_Update_Column {
  /** column name */
  AuthorizationNumber = 'authorizationNumber',
  /** column name */
  AuthorizedAmount = 'authorizedAmount',
  /** column name */
  AuthorizedByIdentityId = 'authorizedByIdentityId',
  /** column name */
  ClaimServiceCenterId = 'claimServiceCenterId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RevokedAt = 'revokedAt',
  /** column name */
  RevokedByIdentityId = 'revokedByIdentityId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClaimServiceCenterAuthorization_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClaimServiceCenterAuthorization_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClaimServiceCenterAuthorization_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClaimServiceCenterAuthorization_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClaimServiceCenterAuthorization_Var_Pop_Fields = {
  __typename?: 'claimServiceCenterAuthorization_var_pop_fields';
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Var_Pop_Order_By = {
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ClaimServiceCenterAuthorization_Var_Samp_Fields = {
  __typename?: 'claimServiceCenterAuthorization_var_samp_fields';
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Var_Samp_Order_By = {
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ClaimServiceCenterAuthorization_Variance_Fields = {
  __typename?: 'claimServiceCenterAuthorization_variance_fields';
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "claims.claim_service_center_authorization" */
export type ClaimServiceCenterAuthorization_Variance_Order_By = {
  /** What this Service Provider was authorized for when it was granted, and what this authorization's Authorization Number is derived from. Not what the gate measures: that is the whole Claim's total against the Adjuster's limit. A person's later change to the provider's claim_detail rows revokes the authorization outright rather than being compared against this. On a Legacy Claim the AS400 sync does compare it, against AS400's current total for the provider, and replaces the authorization when the two differ. */
  authorizedAmount?: InputMaybe<Order_By>;
};

/** aggregated selection of "claims.claim_service_center" */
export type ClaimServiceCenter_Aggregate = {
  __typename?: 'claimServiceCenter_aggregate';
  aggregate?: Maybe<ClaimServiceCenter_Aggregate_Fields>;
  nodes: Array<ClaimServiceCenter>;
};

export type ClaimServiceCenter_Aggregate_Bool_Exp = {
  count?: InputMaybe<ClaimServiceCenter_Aggregate_Bool_Exp_Count>;
};

export type ClaimServiceCenter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.claim_service_center" */
export type ClaimServiceCenter_Aggregate_Fields = {
  __typename?: 'claimServiceCenter_aggregate_fields';
  avg?: Maybe<ClaimServiceCenter_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClaimServiceCenter_Max_Fields>;
  min?: Maybe<ClaimServiceCenter_Min_Fields>;
  stddev?: Maybe<ClaimServiceCenter_Stddev_Fields>;
  stddev_pop?: Maybe<ClaimServiceCenter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClaimServiceCenter_Stddev_Samp_Fields>;
  sum?: Maybe<ClaimServiceCenter_Sum_Fields>;
  var_pop?: Maybe<ClaimServiceCenter_Var_Pop_Fields>;
  var_samp?: Maybe<ClaimServiceCenter_Var_Samp_Fields>;
  variance?: Maybe<ClaimServiceCenter_Variance_Fields>;
};


/** aggregate fields of "claims.claim_service_center" */
export type ClaimServiceCenter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.claim_service_center" */
export type ClaimServiceCenter_Aggregate_Order_By = {
  avg?: InputMaybe<ClaimServiceCenter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClaimServiceCenter_Max_Order_By>;
  min?: InputMaybe<ClaimServiceCenter_Min_Order_By>;
  stddev?: InputMaybe<ClaimServiceCenter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ClaimServiceCenter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ClaimServiceCenter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ClaimServiceCenter_Sum_Order_By>;
  var_pop?: InputMaybe<ClaimServiceCenter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ClaimServiceCenter_Var_Samp_Order_By>;
  variance?: InputMaybe<ClaimServiceCenter_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ClaimServiceCenter_Append_Input = {
  costSummaryMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "claims.claim_service_center" */
export type ClaimServiceCenter_Arr_Rel_Insert_Input = {
  data: Array<ClaimServiceCenter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClaimServiceCenter_On_Conflict>;
};

/** aggregate avg on columns */
export type ClaimServiceCenter_Avg_Fields = {
  __typename?: 'claimServiceCenter_avg_fields';
  itemTaxPercent?: Maybe<Scalars['Float']>;
  itemTaxRate?: Maybe<Scalars['Float']>;
  laborRate?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "claims.claim_service_center" */
export type ClaimServiceCenter_Avg_Order_By = {
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "claims.claim_service_center". All fields are combined with a logical 'AND'. */
export type ClaimServiceCenter_Bool_Exp = {
  _and?: InputMaybe<Array<ClaimServiceCenter_Bool_Exp>>;
  _not?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimServiceCenter_Bool_Exp>>;
  approvalRequests?: InputMaybe<ApprovalRequest_Bool_Exp>;
  approvalRequests_aggregate?: InputMaybe<ApprovalRequest_Aggregate_Bool_Exp>;
  authorizations?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
  authorizations_aggregate?: InputMaybe<ClaimServiceCenterAuthorization_Aggregate_Bool_Exp>;
  claimDetails?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimDetails_aggregate?: InputMaybe<ClaimDetail_Aggregate_Bool_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  costSummaryMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  defaultPaymentMethodType?: InputMaybe<PaymentMethodType_Bool_Exp>;
  defaultPaymentMethodTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  entryDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  itemTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  itemTaxRate?: InputMaybe<Numeric_Comparison_Exp>;
  laborGuideType?: InputMaybe<Type_Bool_Exp>;
  laborGuideTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  laborRate?: InputMaybe<Numeric_Comparison_Exp>;
  laborTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  laborTaxRate?: InputMaybe<Numeric_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  participants?: InputMaybe<Participant_Bool_Exp>;
  participants_aggregate?: InputMaybe<Participant_Aggregate_Bool_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Bool_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaimId?: InputMaybe<Uuid_Comparison_Exp>;
  roDate?: InputMaybe<Date_Comparison_Exp>;
  roNumber?: InputMaybe<String_Comparison_Exp>;
  serviceCenter?: InputMaybe<ServiceCenter_Bool_Exp>;
  serviceCenterId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.claim_service_center" */
export enum ClaimServiceCenter_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClaimServiceCenterPkey = 'claim_service_center_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ClaimServiceCenter_Delete_At_Path_Input = {
  costSummaryMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ClaimServiceCenter_Delete_Elem_Input = {
  costSummaryMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ClaimServiceCenter_Delete_Key_Input = {
  costSummaryMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "claims.claim_service_center" */
export type ClaimServiceCenter_Inc_Input = {
  itemTaxPercent?: InputMaybe<Scalars['numeric']>;
  itemTaxRate?: InputMaybe<Scalars['numeric']>;
  laborRate?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claims.claim_service_center" */
export type ClaimServiceCenter_Insert_Input = {
  approvalRequests?: InputMaybe<ApprovalRequest_Arr_Rel_Insert_Input>;
  authorizations?: InputMaybe<ClaimServiceCenterAuthorization_Arr_Rel_Insert_Input>;
  claimDetails?: InputMaybe<ClaimDetail_Arr_Rel_Insert_Input>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  costSummaryMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultPaymentMethodType?: InputMaybe<PaymentMethodType_Obj_Rel_Insert_Input>;
  defaultPaymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  entryDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  itemTaxPercent?: InputMaybe<Scalars['numeric']>;
  itemTaxRate?: InputMaybe<Scalars['numeric']>;
  laborGuideType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** The labor guide this Service Provider quoted their labor hours from, recorded by the adjuster so a quote can be re-checked against the same source later (IT-8494). References a shared.type row in the LaborGuide type group (af411fb9-0765-4950-b2e8-74523289b287); the group is display-only, so the claims Service Provider side menus read it at runtime ordered by display rather than through generated constants - see docs/adr/0006-job-types-read-at-runtime.md. NULL means the adjuster has not recorded one. */
  laborGuideTypeId?: InputMaybe<Scalars['uuid']>;
  laborRate?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  participants?: InputMaybe<Participant_Arr_Rel_Insert_Input>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  roDate?: InputMaybe<Scalars['date']>;
  roNumber?: InputMaybe<Scalars['String']>;
  serviceCenter?: InputMaybe<ServiceCenter_Obj_Rel_Insert_Input>;
  serviceCenterId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClaimServiceCenter_Max_Fields = {
  __typename?: 'claimServiceCenter_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultPaymentMethodTypeId?: Maybe<Scalars['uuid']>;
  entryDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  itemTaxPercent?: Maybe<Scalars['numeric']>;
  itemTaxRate?: Maybe<Scalars['numeric']>;
  /** The labor guide this Service Provider quoted their labor hours from, recorded by the adjuster so a quote can be re-checked against the same source later (IT-8494). References a shared.type row in the LaborGuide type group (af411fb9-0765-4950-b2e8-74523289b287); the group is display-only, so the claims Service Provider side menus read it at runtime ordered by display rather than through generated constants - see docs/adr/0006-job-types-read-at-runtime.md. NULL means the adjuster has not recorded one. */
  laborGuideTypeId?: Maybe<Scalars['uuid']>;
  laborRate?: Maybe<Scalars['numeric']>;
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  laborTaxRate?: Maybe<Scalars['numeric']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  roDate?: Maybe<Scalars['date']>;
  roNumber?: Maybe<Scalars['String']>;
  serviceCenterId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "claims.claim_service_center" */
export type ClaimServiceCenter_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  defaultPaymentMethodTypeId?: InputMaybe<Order_By>;
  entryDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  /** The labor guide this Service Provider quoted their labor hours from, recorded by the adjuster so a quote can be re-checked against the same source later (IT-8494). References a shared.type row in the LaborGuide type group (af411fb9-0765-4950-b2e8-74523289b287); the group is display-only, so the claims Service Provider side menus read it at runtime ordered by display rather than through generated constants - see docs/adr/0006-job-types-read-at-runtime.md. NULL means the adjuster has not recorded one. */
  laborGuideTypeId?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  roDate?: InputMaybe<Order_By>;
  roNumber?: InputMaybe<Order_By>;
  serviceCenterId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClaimServiceCenter_Min_Fields = {
  __typename?: 'claimServiceCenter_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultPaymentMethodTypeId?: Maybe<Scalars['uuid']>;
  entryDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  itemTaxPercent?: Maybe<Scalars['numeric']>;
  itemTaxRate?: Maybe<Scalars['numeric']>;
  /** The labor guide this Service Provider quoted their labor hours from, recorded by the adjuster so a quote can be re-checked against the same source later (IT-8494). References a shared.type row in the LaborGuide type group (af411fb9-0765-4950-b2e8-74523289b287); the group is display-only, so the claims Service Provider side menus read it at runtime ordered by display rather than through generated constants - see docs/adr/0006-job-types-read-at-runtime.md. NULL means the adjuster has not recorded one. */
  laborGuideTypeId?: Maybe<Scalars['uuid']>;
  laborRate?: Maybe<Scalars['numeric']>;
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  laborTaxRate?: Maybe<Scalars['numeric']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  roDate?: Maybe<Scalars['date']>;
  roNumber?: Maybe<Scalars['String']>;
  serviceCenterId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "claims.claim_service_center" */
export type ClaimServiceCenter_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  defaultPaymentMethodTypeId?: InputMaybe<Order_By>;
  entryDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  /** The labor guide this Service Provider quoted their labor hours from, recorded by the adjuster so a quote can be re-checked against the same source later (IT-8494). References a shared.type row in the LaborGuide type group (af411fb9-0765-4950-b2e8-74523289b287); the group is display-only, so the claims Service Provider side menus read it at runtime ordered by display rather than through generated constants - see docs/adr/0006-job-types-read-at-runtime.md. NULL means the adjuster has not recorded one. */
  laborGuideTypeId?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  roDate?: InputMaybe<Order_By>;
  roNumber?: InputMaybe<Order_By>;
  serviceCenterId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.claim_service_center" */
export type ClaimServiceCenter_Mutation_Response = {
  __typename?: 'claimServiceCenter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimServiceCenter>;
};

/** input type for inserting object relation for remote table "claims.claim_service_center" */
export type ClaimServiceCenter_Obj_Rel_Insert_Input = {
  data: ClaimServiceCenter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClaimServiceCenter_On_Conflict>;
};

/** on_conflict condition type for table "claims.claim_service_center" */
export type ClaimServiceCenter_On_Conflict = {
  constraint: ClaimServiceCenter_Constraint;
  update_columns?: Array<ClaimServiceCenter_Update_Column>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.claim_service_center". */
export type ClaimServiceCenter_Order_By = {
  approvalRequests_aggregate?: InputMaybe<ApprovalRequest_Aggregate_Order_By>;
  authorizations_aggregate?: InputMaybe<ClaimServiceCenterAuthorization_Aggregate_Order_By>;
  claimDetails_aggregate?: InputMaybe<ClaimDetail_Aggregate_Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  costSummaryMetadata?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defaultPaymentMethodType?: InputMaybe<PaymentMethodType_Order_By>;
  defaultPaymentMethodTypeId?: InputMaybe<Order_By>;
  entryDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  laborGuideType?: InputMaybe<Type_Order_By>;
  laborGuideTypeId?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  participants_aggregate?: InputMaybe<Participant_Aggregate_Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  roDate?: InputMaybe<Order_By>;
  roNumber?: InputMaybe<Order_By>;
  serviceCenter?: InputMaybe<ServiceCenter_Order_By>;
  serviceCenterId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.claim_service_center */
export type ClaimServiceCenter_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ClaimServiceCenter_Prepend_Input = {
  costSummaryMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "claims.claim_service_center" */
export enum ClaimServiceCenter_Select_Column {
  /** column name */
  CostSummaryMetadata = 'costSummaryMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultPaymentMethodTypeId = 'defaultPaymentMethodTypeId',
  /** column name */
  EntryDate = 'entryDate',
  /** column name */
  Id = 'id',
  /** column name */
  ItemTaxPercent = 'itemTaxPercent',
  /** column name */
  ItemTaxRate = 'itemTaxRate',
  /** column name */
  LaborGuideTypeId = 'laborGuideTypeId',
  /** column name */
  LaborRate = 'laborRate',
  /** column name */
  LaborTaxPercent = 'laborTaxPercent',
  /** column name */
  LaborTaxRate = 'laborTaxRate',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  RoDate = 'roDate',
  /** column name */
  RoNumber = 'roNumber',
  /** column name */
  ServiceCenterId = 'serviceCenterId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.claim_service_center" */
export type ClaimServiceCenter_Set_Input = {
  costSummaryMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultPaymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  entryDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  itemTaxPercent?: InputMaybe<Scalars['numeric']>;
  itemTaxRate?: InputMaybe<Scalars['numeric']>;
  /** The labor guide this Service Provider quoted their labor hours from, recorded by the adjuster so a quote can be re-checked against the same source later (IT-8494). References a shared.type row in the LaborGuide type group (af411fb9-0765-4950-b2e8-74523289b287); the group is display-only, so the claims Service Provider side menus read it at runtime ordered by display rather than through generated constants - see docs/adr/0006-job-types-read-at-runtime.md. NULL means the adjuster has not recorded one. */
  laborGuideTypeId?: InputMaybe<Scalars['uuid']>;
  laborRate?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  roDate?: InputMaybe<Scalars['date']>;
  roNumber?: InputMaybe<Scalars['String']>;
  serviceCenterId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ClaimServiceCenter_Stddev_Fields = {
  __typename?: 'claimServiceCenter_stddev_fields';
  itemTaxPercent?: Maybe<Scalars['Float']>;
  itemTaxRate?: Maybe<Scalars['Float']>;
  laborRate?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "claims.claim_service_center" */
export type ClaimServiceCenter_Stddev_Order_By = {
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ClaimServiceCenter_Stddev_Pop_Fields = {
  __typename?: 'claimServiceCenter_stddev_pop_fields';
  itemTaxPercent?: Maybe<Scalars['Float']>;
  itemTaxRate?: Maybe<Scalars['Float']>;
  laborRate?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "claims.claim_service_center" */
export type ClaimServiceCenter_Stddev_Pop_Order_By = {
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ClaimServiceCenter_Stddev_Samp_Fields = {
  __typename?: 'claimServiceCenter_stddev_samp_fields';
  itemTaxPercent?: Maybe<Scalars['Float']>;
  itemTaxRate?: Maybe<Scalars['Float']>;
  laborRate?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "claims.claim_service_center" */
export type ClaimServiceCenter_Stddev_Samp_Order_By = {
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "claimServiceCenter" */
export type ClaimServiceCenter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClaimServiceCenter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClaimServiceCenter_Stream_Cursor_Value_Input = {
  costSummaryMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultPaymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  entryDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  itemTaxPercent?: InputMaybe<Scalars['numeric']>;
  itemTaxRate?: InputMaybe<Scalars['numeric']>;
  /** The labor guide this Service Provider quoted their labor hours from, recorded by the adjuster so a quote can be re-checked against the same source later (IT-8494). References a shared.type row in the LaborGuide type group (af411fb9-0765-4950-b2e8-74523289b287); the group is display-only, so the claims Service Provider side menus read it at runtime ordered by display rather than through generated constants - see docs/adr/0006-job-types-read-at-runtime.md. NULL means the adjuster has not recorded one. */
  laborGuideTypeId?: InputMaybe<Scalars['uuid']>;
  laborRate?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  roDate?: InputMaybe<Scalars['date']>;
  roNumber?: InputMaybe<Scalars['String']>;
  serviceCenterId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ClaimServiceCenter_Sum_Fields = {
  __typename?: 'claimServiceCenter_sum_fields';
  itemTaxPercent?: Maybe<Scalars['numeric']>;
  itemTaxRate?: Maybe<Scalars['numeric']>;
  laborRate?: Maybe<Scalars['numeric']>;
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  laborTaxRate?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "claims.claim_service_center" */
export type ClaimServiceCenter_Sum_Order_By = {
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
};

/** update columns of table "claims.claim_service_center" */
export enum ClaimServiceCenter_Update_Column {
  /** column name */
  CostSummaryMetadata = 'costSummaryMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultPaymentMethodTypeId = 'defaultPaymentMethodTypeId',
  /** column name */
  EntryDate = 'entryDate',
  /** column name */
  Id = 'id',
  /** column name */
  ItemTaxPercent = 'itemTaxPercent',
  /** column name */
  ItemTaxRate = 'itemTaxRate',
  /** column name */
  LaborGuideTypeId = 'laborGuideTypeId',
  /** column name */
  LaborRate = 'laborRate',
  /** column name */
  LaborTaxPercent = 'laborTaxPercent',
  /** column name */
  LaborTaxRate = 'laborTaxRate',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  RoDate = 'roDate',
  /** column name */
  RoNumber = 'roNumber',
  /** column name */
  ServiceCenterId = 'serviceCenterId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClaimServiceCenter_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ClaimServiceCenter_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ClaimServiceCenter_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ClaimServiceCenter_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ClaimServiceCenter_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClaimServiceCenter_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ClaimServiceCenter_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClaimServiceCenter_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClaimServiceCenter_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClaimServiceCenter_Var_Pop_Fields = {
  __typename?: 'claimServiceCenter_var_pop_fields';
  itemTaxPercent?: Maybe<Scalars['Float']>;
  itemTaxRate?: Maybe<Scalars['Float']>;
  laborRate?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "claims.claim_service_center" */
export type ClaimServiceCenter_Var_Pop_Order_By = {
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ClaimServiceCenter_Var_Samp_Fields = {
  __typename?: 'claimServiceCenter_var_samp_fields';
  itemTaxPercent?: Maybe<Scalars['Float']>;
  itemTaxRate?: Maybe<Scalars['Float']>;
  laborRate?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "claims.claim_service_center" */
export type ClaimServiceCenter_Var_Samp_Order_By = {
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ClaimServiceCenter_Variance_Fields = {
  __typename?: 'claimServiceCenter_variance_fields';
  itemTaxPercent?: Maybe<Scalars['Float']>;
  itemTaxRate?: Maybe<Scalars['Float']>;
  laborRate?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "claims.claim_service_center" */
export type ClaimServiceCenter_Variance_Order_By = {
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
};

/** columns and relationships of "claim_status_type" */
export type ClaimStatusType = {
  __typename?: 'claimStatusType';
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "claim_status_type" */
export type ClaimStatusType_Aggregate = {
  __typename?: 'claimStatusType_aggregate';
  aggregate?: Maybe<ClaimStatusType_Aggregate_Fields>;
  nodes: Array<ClaimStatusType>;
};

/** aggregate fields of "claim_status_type" */
export type ClaimStatusType_Aggregate_Fields = {
  __typename?: 'claimStatusType_aggregate_fields';
  avg?: Maybe<ClaimStatusType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClaimStatusType_Max_Fields>;
  min?: Maybe<ClaimStatusType_Min_Fields>;
  stddev?: Maybe<ClaimStatusType_Stddev_Fields>;
  stddev_pop?: Maybe<ClaimStatusType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClaimStatusType_Stddev_Samp_Fields>;
  sum?: Maybe<ClaimStatusType_Sum_Fields>;
  var_pop?: Maybe<ClaimStatusType_Var_Pop_Fields>;
  var_samp?: Maybe<ClaimStatusType_Var_Samp_Fields>;
  variance?: Maybe<ClaimStatusType_Variance_Fields>;
};


/** aggregate fields of "claim_status_type" */
export type ClaimStatusType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClaimStatusType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ClaimStatusType_Avg_Fields = {
  __typename?: 'claimStatusType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "claim_status_type". All fields are combined with a logical 'AND'. */
export type ClaimStatusType_Bool_Exp = {
  _and?: InputMaybe<Array<ClaimStatusType_Bool_Exp>>;
  _not?: InputMaybe<ClaimStatusType_Bool_Exp>;
  _or?: InputMaybe<Array<ClaimStatusType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claim_status_type" */
export enum ClaimStatusType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  ClaimStatusTypeEnumValueKey = 'claim_status_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  ClaimStatusTypePkey = 'claim_status_type_pkey'
}

/** input type for incrementing numeric columns in table "claim_status_type" */
export type ClaimStatusType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "claim_status_type" */
export type ClaimStatusType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClaimStatusType_Max_Fields = {
  __typename?: 'claimStatusType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ClaimStatusType_Min_Fields = {
  __typename?: 'claimStatusType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claim_status_type" */
export type ClaimStatusType_Mutation_Response = {
  __typename?: 'claimStatusType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClaimStatusType>;
};

/** input type for inserting object relation for remote table "claim_status_type" */
export type ClaimStatusType_Obj_Rel_Insert_Input = {
  data: ClaimStatusType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClaimStatusType_On_Conflict>;
};

/** on_conflict condition type for table "claim_status_type" */
export type ClaimStatusType_On_Conflict = {
  constraint: ClaimStatusType_Constraint;
  update_columns?: Array<ClaimStatusType_Update_Column>;
  where?: InputMaybe<ClaimStatusType_Bool_Exp>;
};

/** Ordering options when selecting data from "claim_status_type". */
export type ClaimStatusType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claim_status_type */
export type ClaimStatusType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claim_status_type" */
export enum ClaimStatusType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claim_status_type" */
export type ClaimStatusType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ClaimStatusType_Stddev_Fields = {
  __typename?: 'claimStatusType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ClaimStatusType_Stddev_Pop_Fields = {
  __typename?: 'claimStatusType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ClaimStatusType_Stddev_Samp_Fields = {
  __typename?: 'claimStatusType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "claimStatusType" */
export type ClaimStatusType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClaimStatusType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClaimStatusType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ClaimStatusType_Sum_Fields = {
  __typename?: 'claimStatusType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "claim_status_type" */
export enum ClaimStatusType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClaimStatusType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClaimStatusType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClaimStatusType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClaimStatusType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClaimStatusType_Var_Pop_Fields = {
  __typename?: 'claimStatusType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ClaimStatusType_Var_Samp_Fields = {
  __typename?: 'claimStatusType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ClaimStatusType_Variance_Fields = {
  __typename?: 'claimStatusType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "claim" */
export type Claim_Aggregate = {
  __typename?: 'claim_aggregate';
  aggregate?: Maybe<Claim_Aggregate_Fields>;
  nodes: Array<Claim>;
};

export type Claim_Aggregate_Bool_Exp = {
  count?: InputMaybe<Claim_Aggregate_Bool_Exp_Count>;
};

export type Claim_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Claim_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Claim_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claim" */
export type Claim_Aggregate_Fields = {
  __typename?: 'claim_aggregate_fields';
  avg?: Maybe<Claim_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Claim_Max_Fields>;
  min?: Maybe<Claim_Min_Fields>;
  stddev?: Maybe<Claim_Stddev_Fields>;
  stddev_pop?: Maybe<Claim_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Claim_Stddev_Samp_Fields>;
  sum?: Maybe<Claim_Sum_Fields>;
  var_pop?: Maybe<Claim_Var_Pop_Fields>;
  var_samp?: Maybe<Claim_Var_Samp_Fields>;
  variance?: Maybe<Claim_Variance_Fields>;
};


/** aggregate fields of "claim" */
export type Claim_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Claim_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claim" */
export type Claim_Aggregate_Order_By = {
  avg?: InputMaybe<Claim_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Claim_Max_Order_By>;
  min?: InputMaybe<Claim_Min_Order_By>;
  stddev?: InputMaybe<Claim_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Claim_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Claim_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Claim_Sum_Order_By>;
  var_pop?: InputMaybe<Claim_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Claim_Var_Samp_Order_By>;
  variance?: InputMaybe<Claim_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "claim" */
export type Claim_Arr_Rel_Insert_Input = {
  data: Array<Claim_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Claim_On_Conflict>;
};

/** aggregate avg on columns */
export type Claim_Avg_Fields = {
  __typename?: 'claim_avg_fields';
  claimStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  overriddenDeductibleAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborHourlyRateAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPartsTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPaymentTypeEnumValue?: Maybe<Scalars['Float']>;
  repairOrderNumber?: Maybe<Scalars['Float']>;
  vehicleMileageAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "claim" */
export type Claim_Avg_Order_By = {
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "claim". All fields are combined with a logical 'AND'. */
export type Claim_Bool_Exp = {
  _and?: InputMaybe<Array<Claim_Bool_Exp>>;
  _not?: InputMaybe<Claim_Bool_Exp>;
  _or?: InputMaybe<Array<Claim_Bool_Exp>>;
  cause?: InputMaybe<String_Comparison_Exp>;
  claimNumber?: InputMaybe<String_Comparison_Exp>;
  claimStatusType?: InputMaybe<ClaimStatusType_Bool_Exp>;
  claimStatusTypeEnumValue?: InputMaybe<Int_Comparison_Exp>;
  closedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  complaint?: InputMaybe<String_Comparison_Exp>;
  contract?: InputMaybe<Contract_Bool_Exp>;
  contractId?: InputMaybe<Uuid_Comparison_Exp>;
  correction?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dealer?: InputMaybe<Legacy_Claims_Dealer_Bool_Exp>;
  dealerContactName?: InputMaybe<String_Comparison_Exp>;
  dealerContactPhone?: InputMaybe<String_Comparison_Exp>;
  dealerId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobs?: InputMaybe<ObsoleteJob_Bool_Exp>;
  jobs_aggregate?: InputMaybe<ObsoleteJob_Aggregate_Bool_Exp>;
  overriddenDeductibleAmount?: InputMaybe<Numeric_Comparison_Exp>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Numeric_Comparison_Exp>;
  payeeDealerLaborTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  payeeDealerPartsTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  payeeDealerPaymentLocation?: InputMaybe<String_Comparison_Exp>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Int_Comparison_Exp>;
  payeeDealerPhone?: InputMaybe<String_Comparison_Exp>;
  repairOrderDate?: InputMaybe<Date_Comparison_Exp>;
  repairOrderNumber?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicleMileageAmount?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "claim" */
export enum Claim_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClaimPkey = 'claim_pkey'
}

/** input type for incrementing numeric columns in table "claim" */
export type Claim_Inc_Input = {
  claimStatusTypeEnumValue?: InputMaybe<Scalars['Int']>;
  overriddenDeductibleAmount?: InputMaybe<Scalars['numeric']>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Scalars['numeric']>;
  payeeDealerLaborTaxPercent?: InputMaybe<Scalars['numeric']>;
  payeeDealerPartsTaxPercent?: InputMaybe<Scalars['numeric']>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Scalars['Int']>;
  repairOrderNumber?: InputMaybe<Scalars['Int']>;
  vehicleMileageAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claim" */
export type Claim_Insert_Input = {
  cause?: InputMaybe<Scalars['String']>;
  claimNumber?: InputMaybe<Scalars['String']>;
  claimStatusType?: InputMaybe<ClaimStatusType_Obj_Rel_Insert_Input>;
  claimStatusTypeEnumValue?: InputMaybe<Scalars['Int']>;
  closedAt?: InputMaybe<Scalars['timestamptz']>;
  complaint?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<Contract_Obj_Rel_Insert_Input>;
  contractId?: InputMaybe<Scalars['uuid']>;
  correction?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealer?: InputMaybe<Legacy_Claims_Dealer_Obj_Rel_Insert_Input>;
  dealerContactName?: InputMaybe<Scalars['String']>;
  dealerContactPhone?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobs?: InputMaybe<ObsoleteJob_Arr_Rel_Insert_Input>;
  overriddenDeductibleAmount?: InputMaybe<Scalars['numeric']>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Scalars['numeric']>;
  payeeDealerLaborTaxPercent?: InputMaybe<Scalars['numeric']>;
  payeeDealerPartsTaxPercent?: InputMaybe<Scalars['numeric']>;
  payeeDealerPaymentLocation?: InputMaybe<Scalars['String']>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Scalars['Int']>;
  payeeDealerPhone?: InputMaybe<Scalars['String']>;
  repairOrderDate?: InputMaybe<Scalars['date']>;
  repairOrderNumber?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleMileageAmount?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Claim_Max_Fields = {
  __typename?: 'claim_max_fields';
  cause?: Maybe<Scalars['String']>;
  claimNumber?: Maybe<Scalars['String']>;
  claimStatusTypeEnumValue?: Maybe<Scalars['Int']>;
  closedAt?: Maybe<Scalars['timestamptz']>;
  complaint?: Maybe<Scalars['String']>;
  contractId?: Maybe<Scalars['uuid']>;
  correction?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dealerContactName?: Maybe<Scalars['String']>;
  dealerContactPhone?: Maybe<Scalars['String']>;
  dealerId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  overriddenDeductibleAmount?: Maybe<Scalars['numeric']>;
  payeeDealerLaborHourlyRateAmount?: Maybe<Scalars['numeric']>;
  payeeDealerLaborTaxPercent?: Maybe<Scalars['numeric']>;
  payeeDealerPartsTaxPercent?: Maybe<Scalars['numeric']>;
  payeeDealerPaymentLocation?: Maybe<Scalars['String']>;
  payeeDealerPaymentTypeEnumValue?: Maybe<Scalars['Int']>;
  payeeDealerPhone?: Maybe<Scalars['String']>;
  repairOrderDate?: Maybe<Scalars['date']>;
  repairOrderNumber?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleMileageAmount?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "claim" */
export type Claim_Max_Order_By = {
  cause?: InputMaybe<Order_By>;
  claimNumber?: InputMaybe<Order_By>;
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  closedAt?: InputMaybe<Order_By>;
  complaint?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  correction?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dealerContactName?: InputMaybe<Order_By>;
  dealerContactPhone?: InputMaybe<Order_By>;
  dealerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentLocation?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  payeeDealerPhone?: InputMaybe<Order_By>;
  repairOrderDate?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Claim_Min_Fields = {
  __typename?: 'claim_min_fields';
  cause?: Maybe<Scalars['String']>;
  claimNumber?: Maybe<Scalars['String']>;
  claimStatusTypeEnumValue?: Maybe<Scalars['Int']>;
  closedAt?: Maybe<Scalars['timestamptz']>;
  complaint?: Maybe<Scalars['String']>;
  contractId?: Maybe<Scalars['uuid']>;
  correction?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dealerContactName?: Maybe<Scalars['String']>;
  dealerContactPhone?: Maybe<Scalars['String']>;
  dealerId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  overriddenDeductibleAmount?: Maybe<Scalars['numeric']>;
  payeeDealerLaborHourlyRateAmount?: Maybe<Scalars['numeric']>;
  payeeDealerLaborTaxPercent?: Maybe<Scalars['numeric']>;
  payeeDealerPartsTaxPercent?: Maybe<Scalars['numeric']>;
  payeeDealerPaymentLocation?: Maybe<Scalars['String']>;
  payeeDealerPaymentTypeEnumValue?: Maybe<Scalars['Int']>;
  payeeDealerPhone?: Maybe<Scalars['String']>;
  repairOrderDate?: Maybe<Scalars['date']>;
  repairOrderNumber?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleMileageAmount?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "claim" */
export type Claim_Min_Order_By = {
  cause?: InputMaybe<Order_By>;
  claimNumber?: InputMaybe<Order_By>;
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  closedAt?: InputMaybe<Order_By>;
  complaint?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  correction?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dealerContactName?: InputMaybe<Order_By>;
  dealerContactPhone?: InputMaybe<Order_By>;
  dealerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentLocation?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  payeeDealerPhone?: InputMaybe<Order_By>;
  repairOrderDate?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claim" */
export type Claim_Mutation_Response = {
  __typename?: 'claim_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Claim>;
};

/** input type for inserting object relation for remote table "claim" */
export type Claim_Obj_Rel_Insert_Input = {
  data: Claim_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Claim_On_Conflict>;
};

/** on_conflict condition type for table "claim" */
export type Claim_On_Conflict = {
  constraint: Claim_Constraint;
  update_columns?: Array<Claim_Update_Column>;
  where?: InputMaybe<Claim_Bool_Exp>;
};

/** Ordering options when selecting data from "claim". */
export type Claim_Order_By = {
  cause?: InputMaybe<Order_By>;
  claimNumber?: InputMaybe<Order_By>;
  claimStatusType?: InputMaybe<ClaimStatusType_Order_By>;
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  closedAt?: InputMaybe<Order_By>;
  complaint?: InputMaybe<Order_By>;
  contract?: InputMaybe<Contract_Order_By>;
  contractId?: InputMaybe<Order_By>;
  correction?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dealer?: InputMaybe<Legacy_Claims_Dealer_Order_By>;
  dealerContactName?: InputMaybe<Order_By>;
  dealerContactPhone?: InputMaybe<Order_By>;
  dealerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobs_aggregate?: InputMaybe<ObsoleteJob_Aggregate_Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentLocation?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  payeeDealerPhone?: InputMaybe<Order_By>;
  repairOrderDate?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claim */
export type Claim_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claim" */
export enum Claim_Select_Column {
  /** column name */
  Cause = 'cause',
  /** column name */
  ClaimNumber = 'claimNumber',
  /** column name */
  ClaimStatusTypeEnumValue = 'claimStatusTypeEnumValue',
  /** column name */
  ClosedAt = 'closedAt',
  /** column name */
  Complaint = 'complaint',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  Correction = 'correction',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DealerContactName = 'dealerContactName',
  /** column name */
  DealerContactPhone = 'dealerContactPhone',
  /** column name */
  DealerId = 'dealerId',
  /** column name */
  Id = 'id',
  /** column name */
  OverriddenDeductibleAmount = 'overriddenDeductibleAmount',
  /** column name */
  PayeeDealerLaborHourlyRateAmount = 'payeeDealerLaborHourlyRateAmount',
  /** column name */
  PayeeDealerLaborTaxPercent = 'payeeDealerLaborTaxPercent',
  /** column name */
  PayeeDealerPartsTaxPercent = 'payeeDealerPartsTaxPercent',
  /** column name */
  PayeeDealerPaymentLocation = 'payeeDealerPaymentLocation',
  /** column name */
  PayeeDealerPaymentTypeEnumValue = 'payeeDealerPaymentTypeEnumValue',
  /** column name */
  PayeeDealerPhone = 'payeeDealerPhone',
  /** column name */
  RepairOrderDate = 'repairOrderDate',
  /** column name */
  RepairOrderNumber = 'repairOrderNumber',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VehicleMileageAmount = 'vehicleMileageAmount'
}

/** input type for updating data in table "claim" */
export type Claim_Set_Input = {
  cause?: InputMaybe<Scalars['String']>;
  claimNumber?: InputMaybe<Scalars['String']>;
  claimStatusTypeEnumValue?: InputMaybe<Scalars['Int']>;
  closedAt?: InputMaybe<Scalars['timestamptz']>;
  complaint?: InputMaybe<Scalars['String']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  correction?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerContactName?: InputMaybe<Scalars['String']>;
  dealerContactPhone?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  overriddenDeductibleAmount?: InputMaybe<Scalars['numeric']>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Scalars['numeric']>;
  payeeDealerLaborTaxPercent?: InputMaybe<Scalars['numeric']>;
  payeeDealerPartsTaxPercent?: InputMaybe<Scalars['numeric']>;
  payeeDealerPaymentLocation?: InputMaybe<Scalars['String']>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Scalars['Int']>;
  payeeDealerPhone?: InputMaybe<Scalars['String']>;
  repairOrderDate?: InputMaybe<Scalars['date']>;
  repairOrderNumber?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleMileageAmount?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Claim_Stddev_Fields = {
  __typename?: 'claim_stddev_fields';
  claimStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  overriddenDeductibleAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborHourlyRateAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPartsTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPaymentTypeEnumValue?: Maybe<Scalars['Float']>;
  repairOrderNumber?: Maybe<Scalars['Float']>;
  vehicleMileageAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "claim" */
export type Claim_Stddev_Order_By = {
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Claim_Stddev_Pop_Fields = {
  __typename?: 'claim_stddev_pop_fields';
  claimStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  overriddenDeductibleAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborHourlyRateAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPartsTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPaymentTypeEnumValue?: Maybe<Scalars['Float']>;
  repairOrderNumber?: Maybe<Scalars['Float']>;
  vehicleMileageAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "claim" */
export type Claim_Stddev_Pop_Order_By = {
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Claim_Stddev_Samp_Fields = {
  __typename?: 'claim_stddev_samp_fields';
  claimStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  overriddenDeductibleAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborHourlyRateAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPartsTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPaymentTypeEnumValue?: Maybe<Scalars['Float']>;
  repairOrderNumber?: Maybe<Scalars['Float']>;
  vehicleMileageAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "claim" */
export type Claim_Stddev_Samp_Order_By = {
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "claim" */
export type Claim_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Claim_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Claim_Stream_Cursor_Value_Input = {
  cause?: InputMaybe<Scalars['String']>;
  claimNumber?: InputMaybe<Scalars['String']>;
  claimStatusTypeEnumValue?: InputMaybe<Scalars['Int']>;
  closedAt?: InputMaybe<Scalars['timestamptz']>;
  complaint?: InputMaybe<Scalars['String']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  correction?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerContactName?: InputMaybe<Scalars['String']>;
  dealerContactPhone?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  overriddenDeductibleAmount?: InputMaybe<Scalars['numeric']>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Scalars['numeric']>;
  payeeDealerLaborTaxPercent?: InputMaybe<Scalars['numeric']>;
  payeeDealerPartsTaxPercent?: InputMaybe<Scalars['numeric']>;
  payeeDealerPaymentLocation?: InputMaybe<Scalars['String']>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Scalars['Int']>;
  payeeDealerPhone?: InputMaybe<Scalars['String']>;
  repairOrderDate?: InputMaybe<Scalars['date']>;
  repairOrderNumber?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleMileageAmount?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Claim_Sum_Fields = {
  __typename?: 'claim_sum_fields';
  claimStatusTypeEnumValue?: Maybe<Scalars['Int']>;
  overriddenDeductibleAmount?: Maybe<Scalars['numeric']>;
  payeeDealerLaborHourlyRateAmount?: Maybe<Scalars['numeric']>;
  payeeDealerLaborTaxPercent?: Maybe<Scalars['numeric']>;
  payeeDealerPartsTaxPercent?: Maybe<Scalars['numeric']>;
  payeeDealerPaymentTypeEnumValue?: Maybe<Scalars['Int']>;
  repairOrderNumber?: Maybe<Scalars['Int']>;
  vehicleMileageAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "claim" */
export type Claim_Sum_Order_By = {
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** update columns of table "claim" */
export enum Claim_Update_Column {
  /** column name */
  Cause = 'cause',
  /** column name */
  ClaimNumber = 'claimNumber',
  /** column name */
  ClaimStatusTypeEnumValue = 'claimStatusTypeEnumValue',
  /** column name */
  ClosedAt = 'closedAt',
  /** column name */
  Complaint = 'complaint',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  Correction = 'correction',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DealerContactName = 'dealerContactName',
  /** column name */
  DealerContactPhone = 'dealerContactPhone',
  /** column name */
  DealerId = 'dealerId',
  /** column name */
  Id = 'id',
  /** column name */
  OverriddenDeductibleAmount = 'overriddenDeductibleAmount',
  /** column name */
  PayeeDealerLaborHourlyRateAmount = 'payeeDealerLaborHourlyRateAmount',
  /** column name */
  PayeeDealerLaborTaxPercent = 'payeeDealerLaborTaxPercent',
  /** column name */
  PayeeDealerPartsTaxPercent = 'payeeDealerPartsTaxPercent',
  /** column name */
  PayeeDealerPaymentLocation = 'payeeDealerPaymentLocation',
  /** column name */
  PayeeDealerPaymentTypeEnumValue = 'payeeDealerPaymentTypeEnumValue',
  /** column name */
  PayeeDealerPhone = 'payeeDealerPhone',
  /** column name */
  RepairOrderDate = 'repairOrderDate',
  /** column name */
  RepairOrderNumber = 'repairOrderNumber',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VehicleMileageAmount = 'vehicleMileageAmount'
}

export type Claim_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Claim_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Claim_Set_Input>;
  /** filter the rows which have to be updated */
  where: Claim_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Claim_Var_Pop_Fields = {
  __typename?: 'claim_var_pop_fields';
  claimStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  overriddenDeductibleAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborHourlyRateAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPartsTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPaymentTypeEnumValue?: Maybe<Scalars['Float']>;
  repairOrderNumber?: Maybe<Scalars['Float']>;
  vehicleMileageAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "claim" */
export type Claim_Var_Pop_Order_By = {
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Claim_Var_Samp_Fields = {
  __typename?: 'claim_var_samp_fields';
  claimStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  overriddenDeductibleAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborHourlyRateAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPartsTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPaymentTypeEnumValue?: Maybe<Scalars['Float']>;
  repairOrderNumber?: Maybe<Scalars['Float']>;
  vehicleMileageAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "claim" */
export type Claim_Var_Samp_Order_By = {
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Claim_Variance_Fields = {
  __typename?: 'claim_variance_fields';
  claimStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  overriddenDeductibleAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborHourlyRateAmount?: Maybe<Scalars['Float']>;
  payeeDealerLaborTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPartsTaxPercent?: Maybe<Scalars['Float']>;
  payeeDealerPaymentTypeEnumValue?: Maybe<Scalars['Float']>;
  repairOrderNumber?: Maybe<Scalars['Float']>;
  vehicleMileageAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "claim" */
export type Claim_Variance_Order_By = {
  claimStatusTypeEnumValue?: InputMaybe<Order_By>;
  overriddenDeductibleAmount?: InputMaybe<Order_By>;
  payeeDealerLaborHourlyRateAmount?: InputMaybe<Order_By>;
  payeeDealerLaborTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPartsTaxPercent?: InputMaybe<Order_By>;
  payeeDealerPaymentTypeEnumValue?: InputMaybe<Order_By>;
  repairOrderNumber?: InputMaybe<Order_By>;
  vehicleMileageAmount?: InputMaybe<Order_By>;
};

/** DELETE WHEN CLAIMS PAYMENT IS LIVE */
export type Claims_Pre_Authorization_Vehicle_Information = {
  __typename?: 'claims_pre_authorization_vehicle_information';
  cylindersNumber?: Maybe<Scalars['String']>;
  fuelTypeDescription?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isElectric?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['String']>;
  vehicleYear?: Maybe<Scalars['String']>;
};

/** aggregated selection of "claims.pre_authorization_vehicle_information" */
export type Claims_Pre_Authorization_Vehicle_Information_Aggregate = {
  __typename?: 'claims_pre_authorization_vehicle_information_aggregate';
  aggregate?: Maybe<Claims_Pre_Authorization_Vehicle_Information_Aggregate_Fields>;
  nodes: Array<Claims_Pre_Authorization_Vehicle_Information>;
};

/** aggregate fields of "claims.pre_authorization_vehicle_information" */
export type Claims_Pre_Authorization_Vehicle_Information_Aggregate_Fields = {
  __typename?: 'claims_pre_authorization_vehicle_information_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Claims_Pre_Authorization_Vehicle_Information_Max_Fields>;
  min?: Maybe<Claims_Pre_Authorization_Vehicle_Information_Min_Fields>;
};


/** aggregate fields of "claims.pre_authorization_vehicle_information" */
export type Claims_Pre_Authorization_Vehicle_Information_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.pre_authorization_vehicle_information". All fields are combined with a logical 'AND'. */
export type Claims_Pre_Authorization_Vehicle_Information_Bool_Exp = {
  _and?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Bool_Exp>>;
  _not?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Bool_Exp>;
  _or?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Bool_Exp>>;
  cylindersNumber?: InputMaybe<String_Comparison_Exp>;
  fuelTypeDescription?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isElectric?: InputMaybe<String_Comparison_Exp>;
  makeName?: InputMaybe<String_Comparison_Exp>;
  modelName?: InputMaybe<String_Comparison_Exp>;
  numberWheelsDriving?: InputMaybe<String_Comparison_Exp>;
  vehicleYear?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.pre_authorization_vehicle_information" */
export enum Claims_Pre_Authorization_Vehicle_Information_Constraint {
  /** unique or primary key constraint on columns "id" */
  PreAuthorizationVehicleInformationPkey = 'pre_authorization_vehicle_information_pkey'
}

/** input type for inserting data into table "claims.pre_authorization_vehicle_information" */
export type Claims_Pre_Authorization_Vehicle_Information_Insert_Input = {
  cylindersNumber?: InputMaybe<Scalars['String']>;
  fuelTypeDescription?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isElectric?: InputMaybe<Scalars['String']>;
  makeName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['String']>;
  vehicleYear?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Claims_Pre_Authorization_Vehicle_Information_Max_Fields = {
  __typename?: 'claims_pre_authorization_vehicle_information_max_fields';
  cylindersNumber?: Maybe<Scalars['String']>;
  fuelTypeDescription?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isElectric?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['String']>;
  vehicleYear?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Claims_Pre_Authorization_Vehicle_Information_Min_Fields = {
  __typename?: 'claims_pre_authorization_vehicle_information_min_fields';
  cylindersNumber?: Maybe<Scalars['String']>;
  fuelTypeDescription?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isElectric?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['String']>;
  vehicleYear?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "claims.pre_authorization_vehicle_information" */
export type Claims_Pre_Authorization_Vehicle_Information_Mutation_Response = {
  __typename?: 'claims_pre_authorization_vehicle_information_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Claims_Pre_Authorization_Vehicle_Information>;
};

/** input type for inserting object relation for remote table "claims.pre_authorization_vehicle_information" */
export type Claims_Pre_Authorization_Vehicle_Information_Obj_Rel_Insert_Input = {
  data: Claims_Pre_Authorization_Vehicle_Information_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_On_Conflict>;
};

/** on_conflict condition type for table "claims.pre_authorization_vehicle_information" */
export type Claims_Pre_Authorization_Vehicle_Information_On_Conflict = {
  constraint: Claims_Pre_Authorization_Vehicle_Information_Constraint;
  update_columns?: Array<Claims_Pre_Authorization_Vehicle_Information_Update_Column>;
  where?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.pre_authorization_vehicle_information". */
export type Claims_Pre_Authorization_Vehicle_Information_Order_By = {
  cylindersNumber?: InputMaybe<Order_By>;
  fuelTypeDescription?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isElectric?: InputMaybe<Order_By>;
  makeName?: InputMaybe<Order_By>;
  modelName?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  vehicleYear?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.pre_authorization_vehicle_information */
export type Claims_Pre_Authorization_Vehicle_Information_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.pre_authorization_vehicle_information" */
export enum Claims_Pre_Authorization_Vehicle_Information_Select_Column {
  /** column name */
  CylindersNumber = 'cylindersNumber',
  /** column name */
  FuelTypeDescription = 'fuelTypeDescription',
  /** column name */
  Id = 'id',
  /** column name */
  IsElectric = 'isElectric',
  /** column name */
  MakeName = 'makeName',
  /** column name */
  ModelName = 'modelName',
  /** column name */
  NumberWheelsDriving = 'numberWheelsDriving',
  /** column name */
  VehicleYear = 'vehicleYear'
}

/** input type for updating data in table "claims.pre_authorization_vehicle_information" */
export type Claims_Pre_Authorization_Vehicle_Information_Set_Input = {
  cylindersNumber?: InputMaybe<Scalars['String']>;
  fuelTypeDescription?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isElectric?: InputMaybe<Scalars['String']>;
  makeName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['String']>;
  vehicleYear?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "claims_pre_authorization_vehicle_information" */
export type Claims_Pre_Authorization_Vehicle_Information_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Claims_Pre_Authorization_Vehicle_Information_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Claims_Pre_Authorization_Vehicle_Information_Stream_Cursor_Value_Input = {
  cylindersNumber?: InputMaybe<Scalars['String']>;
  fuelTypeDescription?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isElectric?: InputMaybe<Scalars['String']>;
  makeName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['String']>;
  vehicleYear?: InputMaybe<Scalars['String']>;
};

/** update columns of table "claims.pre_authorization_vehicle_information" */
export enum Claims_Pre_Authorization_Vehicle_Information_Update_Column {
  /** column name */
  CylindersNumber = 'cylindersNumber',
  /** column name */
  FuelTypeDescription = 'fuelTypeDescription',
  /** column name */
  Id = 'id',
  /** column name */
  IsElectric = 'isElectric',
  /** column name */
  MakeName = 'makeName',
  /** column name */
  ModelName = 'modelName',
  /** column name */
  NumberWheelsDriving = 'numberWheelsDriving',
  /** column name */
  VehicleYear = 'vehicleYear'
}

export type Claims_Pre_Authorization_Vehicle_Information_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Set_Input>;
  /** filter the rows which have to be updated */
  where: Claims_Pre_Authorization_Vehicle_Information_Bool_Exp;
};

/** columns and relationships of "claims.temp_claims_auth_table" */
export type Claims_Temp_Claims_Auth_Table = {
  __typename?: 'claims_temp_claims_auth_table';
  created_at: Scalars['timestamptz'];
  email_address: Scalars['String'];
  id: Scalars['uuid'];
  permissions: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "claims.temp_claims_auth_table" */
export type Claims_Temp_Claims_Auth_TablePermissionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "claims.temp_claims_auth_table" */
export type Claims_Temp_Claims_Auth_Table_Aggregate = {
  __typename?: 'claims_temp_claims_auth_table_aggregate';
  aggregate?: Maybe<Claims_Temp_Claims_Auth_Table_Aggregate_Fields>;
  nodes: Array<Claims_Temp_Claims_Auth_Table>;
};

/** aggregate fields of "claims.temp_claims_auth_table" */
export type Claims_Temp_Claims_Auth_Table_Aggregate_Fields = {
  __typename?: 'claims_temp_claims_auth_table_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Claims_Temp_Claims_Auth_Table_Max_Fields>;
  min?: Maybe<Claims_Temp_Claims_Auth_Table_Min_Fields>;
};


/** aggregate fields of "claims.temp_claims_auth_table" */
export type Claims_Temp_Claims_Auth_Table_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Claims_Temp_Claims_Auth_Table_Append_Input = {
  permissions?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "claims.temp_claims_auth_table". All fields are combined with a logical 'AND'. */
export type Claims_Temp_Claims_Auth_Table_Bool_Exp = {
  _and?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Bool_Exp>>;
  _not?: InputMaybe<Claims_Temp_Claims_Auth_Table_Bool_Exp>;
  _or?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  permissions?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.temp_claims_auth_table" */
export enum Claims_Temp_Claims_Auth_Table_Constraint {
  /** unique or primary key constraint on columns "id" */
  TempClaimsAuthTablePkey = 'temp_claims_auth_table_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Claims_Temp_Claims_Auth_Table_Delete_At_Path_Input = {
  permissions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Claims_Temp_Claims_Auth_Table_Delete_Elem_Input = {
  permissions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Claims_Temp_Claims_Auth_Table_Delete_Key_Input = {
  permissions?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "claims.temp_claims_auth_table" */
export type Claims_Temp_Claims_Auth_Table_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Claims_Temp_Claims_Auth_Table_Max_Fields = {
  __typename?: 'claims_temp_claims_auth_table_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Claims_Temp_Claims_Auth_Table_Min_Fields = {
  __typename?: 'claims_temp_claims_auth_table_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.temp_claims_auth_table" */
export type Claims_Temp_Claims_Auth_Table_Mutation_Response = {
  __typename?: 'claims_temp_claims_auth_table_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Claims_Temp_Claims_Auth_Table>;
};

/** on_conflict condition type for table "claims.temp_claims_auth_table" */
export type Claims_Temp_Claims_Auth_Table_On_Conflict = {
  constraint: Claims_Temp_Claims_Auth_Table_Constraint;
  update_columns?: Array<Claims_Temp_Claims_Auth_Table_Update_Column>;
  where?: InputMaybe<Claims_Temp_Claims_Auth_Table_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.temp_claims_auth_table". */
export type Claims_Temp_Claims_Auth_Table_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.temp_claims_auth_table */
export type Claims_Temp_Claims_Auth_Table_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Claims_Temp_Claims_Auth_Table_Prepend_Input = {
  permissions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "claims.temp_claims_auth_table" */
export enum Claims_Temp_Claims_Auth_Table_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  Id = 'id',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "claims.temp_claims_auth_table" */
export type Claims_Temp_Claims_Auth_Table_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "claims_temp_claims_auth_table" */
export type Claims_Temp_Claims_Auth_Table_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Claims_Temp_Claims_Auth_Table_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Claims_Temp_Claims_Auth_Table_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "claims.temp_claims_auth_table" */
export enum Claims_Temp_Claims_Auth_Table_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  Id = 'id',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Claims_Temp_Claims_Auth_Table_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Claims_Temp_Claims_Auth_Table_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Claims_Temp_Claims_Auth_Table_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Claims_Temp_Claims_Auth_Table_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Claims_Temp_Claims_Auth_Table_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Claims_Temp_Claims_Auth_Table_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Claims_Temp_Claims_Auth_Table_Set_Input>;
  /** filter the rows which have to be updated */
  where: Claims_Temp_Claims_Auth_Table_Bool_Exp;
};

/** columns and relationships of "classes.class_criteria" */
export type ClassCriteria = {
  __typename?: 'classCriteria';
  /** An array relationship */
  classGuideClassCriterias: Array<ClassGuideClassCriteria>;
  /** An aggregate relationship */
  classGuideClassCriterias_aggregate: ClassGuideClassCriteria_Aggregate;
  /** An object relationship */
  classGuideCriteriaType: ClassGuideCriteriaType;
  classGuideCriteriaTypeId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  criteriaWeight: Scalars['Int'];
  id: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "classes.class_criteria" */
export type ClassCriteriaClassGuideClassCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


/** columns and relationships of "classes.class_criteria" */
export type ClassCriteriaClassGuideClassCriterias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


/** columns and relationships of "classes.class_criteria" */
export type ClassCriteriaMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "classes.class_criteria_view" */
export type ClassCriteriaView = {
  __typename?: 'classCriteriaView';
  bodyStyleCode?: Maybe<Scalars['String']>;
  /** An array relationship */
  classGuideClassCriterias: Array<ClassGuideClassCriteria>;
  /** An aggregate relationship */
  classGuideClassCriterias_aggregate: ClassGuideClassCriteria_Aggregate;
  /** An object relationship */
  classGuideCriteriaType?: Maybe<ClassGuideCriteriaType>;
  classGuideCriteriaTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  criteriaWeight?: Maybe<Scalars['Int']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  hasSupercharger?: Maybe<Scalars['Boolean']>;
  hasTurbo?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  makeId?: Maybe<Scalars['Int']>;
  makeModelId?: Maybe<Scalars['Int']>;
  makeName?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['Int']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "classes.class_criteria_view" */
export type ClassCriteriaViewClassGuideClassCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


/** columns and relationships of "classes.class_criteria_view" */
export type ClassCriteriaViewClassGuideClassCriterias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};

/** columns and relationships of "classes.class_criteria_view_default_vehicle_criteria" */
export type ClassCriteriaViewDefaultVehicleCriteria = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria';
  bodyStyleCode?: Maybe<Scalars['String']>;
  /** An array relationship */
  classGuideClassCriterias: Array<ClassGuideClassCriteria>;
  /** An aggregate relationship */
  classGuideClassCriterias_aggregate: ClassGuideClassCriteria_Aggregate;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  hasSupercharger?: Maybe<Scalars['Boolean']>;
  hasTurbo?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "classes.class_criteria_view_default_vehicle_criteria" */
export type ClassCriteriaViewDefaultVehicleCriteriaClassGuideClassCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


/** columns and relationships of "classes.class_criteria_view_default_vehicle_criteria" */
export type ClassCriteriaViewDefaultVehicleCriteriaClassGuideClassCriterias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};

/** aggregated selection of "classes.class_criteria_view_default_vehicle_criteria" */
export type ClassCriteriaViewDefaultVehicleCriteria_Aggregate = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_aggregate';
  aggregate?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Aggregate_Fields>;
  nodes: Array<ClassCriteriaViewDefaultVehicleCriteria>;
};

/** aggregate fields of "classes.class_criteria_view_default_vehicle_criteria" */
export type ClassCriteriaViewDefaultVehicleCriteria_Aggregate_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_aggregate_fields';
  avg?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Max_Fields>;
  min?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Min_Fields>;
  stddev?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Stddev_Fields>;
  stddev_pop?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Stddev_Samp_Fields>;
  sum?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Sum_Fields>;
  var_pop?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Var_Pop_Fields>;
  var_samp?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Var_Samp_Fields>;
  variance?: Maybe<ClassCriteriaViewDefaultVehicleCriteria_Variance_Fields>;
};


/** aggregate fields of "classes.class_criteria_view_default_vehicle_criteria" */
export type ClassCriteriaViewDefaultVehicleCriteria_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ClassCriteriaViewDefaultVehicleCriteria_Avg_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_avg_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "classes.class_criteria_view_default_vehicle_criteria". All fields are combined with a logical 'AND'. */
export type ClassCriteriaViewDefaultVehicleCriteria_Bool_Exp = {
  _and?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>>;
  _not?: InputMaybe<ClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
  _or?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>>;
  bodyStyleCode?: InputMaybe<String_Comparison_Exp>;
  classGuideClassCriterias?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
  classGuideClassCriterias_aggregate?: InputMaybe<ClassGuideClassCriteria_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cylinders?: InputMaybe<Int_Comparison_Exp>;
  fuelTypeCode?: InputMaybe<String_Comparison_Exp>;
  hasSupercharger?: InputMaybe<Boolean_Comparison_Exp>;
  hasTurbo?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  makeCode?: InputMaybe<String_Comparison_Exp>;
  modelName?: InputMaybe<String_Comparison_Exp>;
  numberWheelsDriving?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicleTypeCode?: InputMaybe<String_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type ClassCriteriaViewDefaultVehicleCriteria_Max_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_max_fields';
  bodyStyleCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ClassCriteriaViewDefaultVehicleCriteria_Min_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_min_fields';
  bodyStyleCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "classes.class_criteria_view_default_vehicle_criteria". */
export type ClassCriteriaViewDefaultVehicleCriteria_Order_By = {
  bodyStyleCode?: InputMaybe<Order_By>;
  classGuideClassCriterias_aggregate?: InputMaybe<ClassGuideClassCriteria_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  fuelTypeCode?: InputMaybe<Order_By>;
  hasSupercharger?: InputMaybe<Order_By>;
  hasTurbo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  makeCode?: InputMaybe<Order_By>;
  modelName?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleTypeCode?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** select columns of table "classes.class_criteria_view_default_vehicle_criteria" */
export enum ClassCriteriaViewDefaultVehicleCriteria_Select_Column {
  /** column name */
  BodyStyleCode = 'bodyStyleCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Cylinders = 'cylinders',
  /** column name */
  FuelTypeCode = 'fuelTypeCode',
  /** column name */
  HasSupercharger = 'hasSupercharger',
  /** column name */
  HasTurbo = 'hasTurbo',
  /** column name */
  Id = 'id',
  /** column name */
  MakeCode = 'makeCode',
  /** column name */
  ModelName = 'modelName',
  /** column name */
  NumberWheelsDriving = 'numberWheelsDriving',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VehicleTypeCode = 'vehicleTypeCode',
  /** column name */
  Year = 'year'
}

/** aggregate stddev on columns */
export type ClassCriteriaViewDefaultVehicleCriteria_Stddev_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_stddev_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ClassCriteriaViewDefaultVehicleCriteria_Stddev_Pop_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_stddev_pop_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ClassCriteriaViewDefaultVehicleCriteria_Stddev_Samp_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_stddev_samp_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "classCriteriaViewDefaultVehicleCriteria" */
export type ClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Value_Input = {
  bodyStyleCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cylinders?: InputMaybe<Scalars['Int']>;
  fuelTypeCode?: InputMaybe<Scalars['String']>;
  hasSupercharger?: InputMaybe<Scalars['Boolean']>;
  hasTurbo?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  makeCode?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleTypeCode?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ClassCriteriaViewDefaultVehicleCriteria_Sum_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_sum_fields';
  cylinders?: Maybe<Scalars['Int']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type ClassCriteriaViewDefaultVehicleCriteria_Var_Pop_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_var_pop_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ClassCriteriaViewDefaultVehicleCriteria_Var_Samp_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_var_samp_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ClassCriteriaViewDefaultVehicleCriteria_Variance_Fields = {
  __typename?: 'classCriteriaViewDefaultVehicleCriteria_variance_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "classes.class_criteria_view_unclassed_default_vehicle_criteria" */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria';
  bodyStyleCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  hasSupercharger?: Maybe<Scalars['Boolean']>;
  hasTurbo?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "classes.class_criteria_view_unclassed_default_vehicle_criteria" */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Aggregate = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_aggregate';
  aggregate?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Aggregate_Fields>;
  nodes: Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria>;
};

/** aggregate fields of "classes.class_criteria_view_unclassed_default_vehicle_criteria" */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Aggregate_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_aggregate_fields';
  avg?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Max_Fields>;
  min?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Min_Fields>;
  stddev?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Stddev_Fields>;
  stddev_pop?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Stddev_Samp_Fields>;
  sum?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Sum_Fields>;
  var_pop?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Var_Pop_Fields>;
  var_samp?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Var_Samp_Fields>;
  variance?: Maybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Variance_Fields>;
};


/** aggregate fields of "classes.class_criteria_view_unclassed_default_vehicle_criteria" */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Avg_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_avg_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "classes.class_criteria_view_unclassed_default_vehicle_criteria". All fields are combined with a logical 'AND'. */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Bool_Exp = {
  _and?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Bool_Exp>>;
  _not?: InputMaybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Bool_Exp>;
  _or?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Bool_Exp>>;
  bodyStyleCode?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cylinders?: InputMaybe<Int_Comparison_Exp>;
  fuelTypeCode?: InputMaybe<String_Comparison_Exp>;
  hasSupercharger?: InputMaybe<Boolean_Comparison_Exp>;
  hasTurbo?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  makeCode?: InputMaybe<String_Comparison_Exp>;
  modelName?: InputMaybe<String_Comparison_Exp>;
  numberWheelsDriving?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicleTypeCode?: InputMaybe<String_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Max_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_max_fields';
  bodyStyleCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Min_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_min_fields';
  bodyStyleCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "classes.class_criteria_view_unclassed_default_vehicle_criteria". */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Order_By = {
  bodyStyleCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  fuelTypeCode?: InputMaybe<Order_By>;
  hasSupercharger?: InputMaybe<Order_By>;
  hasTurbo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  makeCode?: InputMaybe<Order_By>;
  modelName?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleTypeCode?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** select columns of table "classes.class_criteria_view_unclassed_default_vehicle_criteria" */
export enum ClassCriteriaViewUnclassedDefaultVehicleCriteria_Select_Column {
  /** column name */
  BodyStyleCode = 'bodyStyleCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Cylinders = 'cylinders',
  /** column name */
  FuelTypeCode = 'fuelTypeCode',
  /** column name */
  HasSupercharger = 'hasSupercharger',
  /** column name */
  HasTurbo = 'hasTurbo',
  /** column name */
  Id = 'id',
  /** column name */
  MakeCode = 'makeCode',
  /** column name */
  ModelName = 'modelName',
  /** column name */
  NumberWheelsDriving = 'numberWheelsDriving',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VehicleTypeCode = 'vehicleTypeCode',
  /** column name */
  Year = 'year'
}

/** aggregate stddev on columns */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Stddev_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_stddev_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Stddev_Pop_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_stddev_pop_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Stddev_Samp_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_stddev_samp_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "classCriteriaViewUnclassedDefaultVehicleCriteria" */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassCriteriaViewUnclassedDefaultVehicleCriteria_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Stream_Cursor_Value_Input = {
  bodyStyleCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cylinders?: InputMaybe<Scalars['Int']>;
  fuelTypeCode?: InputMaybe<Scalars['String']>;
  hasSupercharger?: InputMaybe<Scalars['Boolean']>;
  hasTurbo?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  makeCode?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleTypeCode?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Sum_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_sum_fields';
  cylinders?: Maybe<Scalars['Int']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Var_Pop_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_var_pop_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Var_Samp_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_var_samp_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ClassCriteriaViewUnclassedDefaultVehicleCriteria_Variance_Fields = {
  __typename?: 'classCriteriaViewUnclassedDefaultVehicleCriteria_variance_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "classes.class_criteria_view" */
export type ClassCriteriaView_Aggregate = {
  __typename?: 'classCriteriaView_aggregate';
  aggregate?: Maybe<ClassCriteriaView_Aggregate_Fields>;
  nodes: Array<ClassCriteriaView>;
};

export type ClassCriteriaView_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ClassCriteriaView_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ClassCriteriaView_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ClassCriteriaView_Aggregate_Bool_Exp_Count>;
};

export type ClassCriteriaView_Aggregate_Bool_Exp_Bool_And = {
  arguments: ClassCriteriaView_Select_Column_ClassCriteriaView_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClassCriteriaView_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ClassCriteriaView_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ClassCriteriaView_Select_Column_ClassCriteriaView_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClassCriteriaView_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ClassCriteriaView_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassCriteriaView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClassCriteriaView_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classes.class_criteria_view" */
export type ClassCriteriaView_Aggregate_Fields = {
  __typename?: 'classCriteriaView_aggregate_fields';
  avg?: Maybe<ClassCriteriaView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClassCriteriaView_Max_Fields>;
  min?: Maybe<ClassCriteriaView_Min_Fields>;
  stddev?: Maybe<ClassCriteriaView_Stddev_Fields>;
  stddev_pop?: Maybe<ClassCriteriaView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClassCriteriaView_Stddev_Samp_Fields>;
  sum?: Maybe<ClassCriteriaView_Sum_Fields>;
  var_pop?: Maybe<ClassCriteriaView_Var_Pop_Fields>;
  var_samp?: Maybe<ClassCriteriaView_Var_Samp_Fields>;
  variance?: Maybe<ClassCriteriaView_Variance_Fields>;
};


/** aggregate fields of "classes.class_criteria_view" */
export type ClassCriteriaView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassCriteriaView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "classes.class_criteria_view" */
export type ClassCriteriaView_Aggregate_Order_By = {
  avg?: InputMaybe<ClassCriteriaView_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassCriteriaView_Max_Order_By>;
  min?: InputMaybe<ClassCriteriaView_Min_Order_By>;
  stddev?: InputMaybe<ClassCriteriaView_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ClassCriteriaView_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ClassCriteriaView_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ClassCriteriaView_Sum_Order_By>;
  var_pop?: InputMaybe<ClassCriteriaView_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ClassCriteriaView_Var_Samp_Order_By>;
  variance?: InputMaybe<ClassCriteriaView_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "classes.class_criteria_view" */
export type ClassCriteriaView_Arr_Rel_Insert_Input = {
  data: Array<ClassCriteriaView_Insert_Input>;
};

/** aggregate avg on columns */
export type ClassCriteriaView_Avg_Fields = {
  __typename?: 'classCriteriaView_avg_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
  cylinders?: Maybe<Scalars['Float']>;
  makeId?: Maybe<Scalars['Float']>;
  makeModelId?: Maybe<Scalars['Float']>;
  modelId?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "classes.class_criteria_view" */
export type ClassCriteriaView_Avg_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "classes.class_criteria_view". All fields are combined with a logical 'AND'. */
export type ClassCriteriaView_Bool_Exp = {
  _and?: InputMaybe<Array<ClassCriteriaView_Bool_Exp>>;
  _not?: InputMaybe<ClassCriteriaView_Bool_Exp>;
  _or?: InputMaybe<Array<ClassCriteriaView_Bool_Exp>>;
  bodyStyleCode?: InputMaybe<String_Comparison_Exp>;
  classGuideClassCriterias?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
  classGuideClassCriterias_aggregate?: InputMaybe<ClassGuideClassCriteria_Aggregate_Bool_Exp>;
  classGuideCriteriaType?: InputMaybe<ClassGuideCriteriaType_Bool_Exp>;
  classGuideCriteriaTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  criteriaWeight?: InputMaybe<Int_Comparison_Exp>;
  cylinders?: InputMaybe<Int_Comparison_Exp>;
  fuelTypeCode?: InputMaybe<String_Comparison_Exp>;
  hasSupercharger?: InputMaybe<Boolean_Comparison_Exp>;
  hasTurbo?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  makeCode?: InputMaybe<String_Comparison_Exp>;
  makeId?: InputMaybe<Int_Comparison_Exp>;
  makeModelId?: InputMaybe<Int_Comparison_Exp>;
  makeName?: InputMaybe<String_Comparison_Exp>;
  modelId?: InputMaybe<Int_Comparison_Exp>;
  modelName?: InputMaybe<String_Comparison_Exp>;
  numberWheelsDriving?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicleTypeCode?: InputMaybe<String_Comparison_Exp>;
  vin?: InputMaybe<String_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for inserting data into table "classes.class_criteria_view" */
export type ClassCriteriaView_Insert_Input = {
  bodyStyleCode?: InputMaybe<Scalars['String']>;
  classGuideClassCriterias?: InputMaybe<ClassGuideClassCriteria_Arr_Rel_Insert_Input>;
  classGuideCriteriaType?: InputMaybe<ClassGuideCriteriaType_Obj_Rel_Insert_Input>;
  classGuideCriteriaTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  criteriaWeight?: InputMaybe<Scalars['Int']>;
  cylinders?: InputMaybe<Scalars['Int']>;
  fuelTypeCode?: InputMaybe<Scalars['String']>;
  hasSupercharger?: InputMaybe<Scalars['Boolean']>;
  hasTurbo?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  makeCode?: InputMaybe<Scalars['String']>;
  makeId?: InputMaybe<Scalars['Int']>;
  makeModelId?: InputMaybe<Scalars['Int']>;
  makeName?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleTypeCode?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ClassCriteriaView_Max_Fields = {
  __typename?: 'classCriteriaView_max_fields';
  bodyStyleCode?: Maybe<Scalars['String']>;
  classGuideCriteriaTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  criteriaWeight?: Maybe<Scalars['Int']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  makeId?: Maybe<Scalars['Int']>;
  makeModelId?: Maybe<Scalars['Int']>;
  makeName?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['Int']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "classes.class_criteria_view" */
export type ClassCriteriaView_Max_Order_By = {
  bodyStyleCode?: InputMaybe<Order_By>;
  classGuideCriteriaTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  fuelTypeCode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  makeCode?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  makeName?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  modelName?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleTypeCode?: InputMaybe<Order_By>;
  vin?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassCriteriaView_Min_Fields = {
  __typename?: 'classCriteriaView_min_fields';
  bodyStyleCode?: Maybe<Scalars['String']>;
  classGuideCriteriaTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  criteriaWeight?: Maybe<Scalars['Int']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  makeId?: Maybe<Scalars['Int']>;
  makeModelId?: Maybe<Scalars['Int']>;
  makeName?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['Int']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "classes.class_criteria_view" */
export type ClassCriteriaView_Min_Order_By = {
  bodyStyleCode?: InputMaybe<Order_By>;
  classGuideCriteriaTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  fuelTypeCode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  makeCode?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  makeName?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  modelName?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleTypeCode?: InputMaybe<Order_By>;
  vin?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "classes.class_criteria_view". */
export type ClassCriteriaView_Order_By = {
  bodyStyleCode?: InputMaybe<Order_By>;
  classGuideClassCriterias_aggregate?: InputMaybe<ClassGuideClassCriteria_Aggregate_Order_By>;
  classGuideCriteriaType?: InputMaybe<ClassGuideCriteriaType_Order_By>;
  classGuideCriteriaTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  fuelTypeCode?: InputMaybe<Order_By>;
  hasSupercharger?: InputMaybe<Order_By>;
  hasTurbo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  makeCode?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  makeName?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  modelName?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleTypeCode?: InputMaybe<Order_By>;
  vin?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** select columns of table "classes.class_criteria_view" */
export enum ClassCriteriaView_Select_Column {
  /** column name */
  BodyStyleCode = 'bodyStyleCode',
  /** column name */
  ClassGuideCriteriaTypeId = 'classGuideCriteriaTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CriteriaWeight = 'criteriaWeight',
  /** column name */
  Cylinders = 'cylinders',
  /** column name */
  FuelTypeCode = 'fuelTypeCode',
  /** column name */
  HasSupercharger = 'hasSupercharger',
  /** column name */
  HasTurbo = 'hasTurbo',
  /** column name */
  Id = 'id',
  /** column name */
  MakeCode = 'makeCode',
  /** column name */
  MakeId = 'makeId',
  /** column name */
  MakeModelId = 'makeModelId',
  /** column name */
  MakeName = 'makeName',
  /** column name */
  ModelId = 'modelId',
  /** column name */
  ModelName = 'modelName',
  /** column name */
  NumberWheelsDriving = 'numberWheelsDriving',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VehicleTypeCode = 'vehicleTypeCode',
  /** column name */
  Vin = 'vin',
  /** column name */
  Year = 'year'
}

/** select "classCriteriaView_aggregate_bool_exp_bool_and_arguments_columns" columns of table "classes.class_criteria_view" */
export enum ClassCriteriaView_Select_Column_ClassCriteriaView_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasSupercharger = 'hasSupercharger',
  /** column name */
  HasTurbo = 'hasTurbo'
}

/** select "classCriteriaView_aggregate_bool_exp_bool_or_arguments_columns" columns of table "classes.class_criteria_view" */
export enum ClassCriteriaView_Select_Column_ClassCriteriaView_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasSupercharger = 'hasSupercharger',
  /** column name */
  HasTurbo = 'hasTurbo'
}

/** aggregate stddev on columns */
export type ClassCriteriaView_Stddev_Fields = {
  __typename?: 'classCriteriaView_stddev_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
  cylinders?: Maybe<Scalars['Float']>;
  makeId?: Maybe<Scalars['Float']>;
  makeModelId?: Maybe<Scalars['Float']>;
  modelId?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "classes.class_criteria_view" */
export type ClassCriteriaView_Stddev_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ClassCriteriaView_Stddev_Pop_Fields = {
  __typename?: 'classCriteriaView_stddev_pop_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
  cylinders?: Maybe<Scalars['Float']>;
  makeId?: Maybe<Scalars['Float']>;
  makeModelId?: Maybe<Scalars['Float']>;
  modelId?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "classes.class_criteria_view" */
export type ClassCriteriaView_Stddev_Pop_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ClassCriteriaView_Stddev_Samp_Fields = {
  __typename?: 'classCriteriaView_stddev_samp_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
  cylinders?: Maybe<Scalars['Float']>;
  makeId?: Maybe<Scalars['Float']>;
  makeModelId?: Maybe<Scalars['Float']>;
  modelId?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "classes.class_criteria_view" */
export type ClassCriteriaView_Stddev_Samp_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "classCriteriaView" */
export type ClassCriteriaView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassCriteriaView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassCriteriaView_Stream_Cursor_Value_Input = {
  bodyStyleCode?: InputMaybe<Scalars['String']>;
  classGuideCriteriaTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  criteriaWeight?: InputMaybe<Scalars['Int']>;
  cylinders?: InputMaybe<Scalars['Int']>;
  fuelTypeCode?: InputMaybe<Scalars['String']>;
  hasSupercharger?: InputMaybe<Scalars['Boolean']>;
  hasTurbo?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  makeCode?: InputMaybe<Scalars['String']>;
  makeId?: InputMaybe<Scalars['Int']>;
  makeModelId?: InputMaybe<Scalars['Int']>;
  makeName?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['Int']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleTypeCode?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ClassCriteriaView_Sum_Fields = {
  __typename?: 'classCriteriaView_sum_fields';
  criteriaWeight?: Maybe<Scalars['Int']>;
  cylinders?: Maybe<Scalars['Int']>;
  makeId?: Maybe<Scalars['Int']>;
  makeModelId?: Maybe<Scalars['Int']>;
  modelId?: Maybe<Scalars['Int']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "classes.class_criteria_view" */
export type ClassCriteriaView_Sum_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type ClassCriteriaView_Var_Pop_Fields = {
  __typename?: 'classCriteriaView_var_pop_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
  cylinders?: Maybe<Scalars['Float']>;
  makeId?: Maybe<Scalars['Float']>;
  makeModelId?: Maybe<Scalars['Float']>;
  modelId?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "classes.class_criteria_view" */
export type ClassCriteriaView_Var_Pop_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ClassCriteriaView_Var_Samp_Fields = {
  __typename?: 'classCriteriaView_var_samp_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
  cylinders?: Maybe<Scalars['Float']>;
  makeId?: Maybe<Scalars['Float']>;
  makeModelId?: Maybe<Scalars['Float']>;
  modelId?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "classes.class_criteria_view" */
export type ClassCriteriaView_Var_Samp_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ClassCriteriaView_Variance_Fields = {
  __typename?: 'classCriteriaView_variance_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
  cylinders?: Maybe<Scalars['Float']>;
  makeId?: Maybe<Scalars['Float']>;
  makeModelId?: Maybe<Scalars['Float']>;
  modelId?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "classes.class_criteria_view" */
export type ClassCriteriaView_Variance_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  makeId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  modelId?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregated selection of "classes.class_criteria" */
export type ClassCriteria_Aggregate = {
  __typename?: 'classCriteria_aggregate';
  aggregate?: Maybe<ClassCriteria_Aggregate_Fields>;
  nodes: Array<ClassCriteria>;
};

export type ClassCriteria_Aggregate_Bool_Exp = {
  count?: InputMaybe<ClassCriteria_Aggregate_Bool_Exp_Count>;
};

export type ClassCriteria_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassCriteria_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClassCriteria_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classes.class_criteria" */
export type ClassCriteria_Aggregate_Fields = {
  __typename?: 'classCriteria_aggregate_fields';
  avg?: Maybe<ClassCriteria_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClassCriteria_Max_Fields>;
  min?: Maybe<ClassCriteria_Min_Fields>;
  stddev?: Maybe<ClassCriteria_Stddev_Fields>;
  stddev_pop?: Maybe<ClassCriteria_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClassCriteria_Stddev_Samp_Fields>;
  sum?: Maybe<ClassCriteria_Sum_Fields>;
  var_pop?: Maybe<ClassCriteria_Var_Pop_Fields>;
  var_samp?: Maybe<ClassCriteria_Var_Samp_Fields>;
  variance?: Maybe<ClassCriteria_Variance_Fields>;
};


/** aggregate fields of "classes.class_criteria" */
export type ClassCriteria_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassCriteria_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "classes.class_criteria" */
export type ClassCriteria_Aggregate_Order_By = {
  avg?: InputMaybe<ClassCriteria_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassCriteria_Max_Order_By>;
  min?: InputMaybe<ClassCriteria_Min_Order_By>;
  stddev?: InputMaybe<ClassCriteria_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ClassCriteria_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ClassCriteria_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ClassCriteria_Sum_Order_By>;
  var_pop?: InputMaybe<ClassCriteria_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ClassCriteria_Var_Samp_Order_By>;
  variance?: InputMaybe<ClassCriteria_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ClassCriteria_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "classes.class_criteria" */
export type ClassCriteria_Arr_Rel_Insert_Input = {
  data: Array<ClassCriteria_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassCriteria_On_Conflict>;
};

/** aggregate avg on columns */
export type ClassCriteria_Avg_Fields = {
  __typename?: 'classCriteria_avg_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "classes.class_criteria" */
export type ClassCriteria_Avg_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "classes.class_criteria". All fields are combined with a logical 'AND'. */
export type ClassCriteria_Bool_Exp = {
  _and?: InputMaybe<Array<ClassCriteria_Bool_Exp>>;
  _not?: InputMaybe<ClassCriteria_Bool_Exp>;
  _or?: InputMaybe<Array<ClassCriteria_Bool_Exp>>;
  classGuideClassCriterias?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
  classGuideClassCriterias_aggregate?: InputMaybe<ClassGuideClassCriteria_Aggregate_Bool_Exp>;
  classGuideCriteriaType?: InputMaybe<ClassGuideCriteriaType_Bool_Exp>;
  classGuideCriteriaTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  criteriaWeight?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "classes.class_criteria" */
export enum ClassCriteria_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClassCriteriaPkey = 'class_criteria_pkey',
  /** unique or primary key constraint on columns  */
  ClassCriteriaUniqueMetadataIdx = 'class_criteria_unique_metadata_idx'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ClassCriteria_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ClassCriteria_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ClassCriteria_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "classes.class_criteria" */
export type ClassCriteria_Inc_Input = {
  criteriaWeight?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "classes.class_criteria" */
export type ClassCriteria_Insert_Input = {
  classGuideClassCriterias?: InputMaybe<ClassGuideClassCriteria_Arr_Rel_Insert_Input>;
  classGuideCriteriaType?: InputMaybe<ClassGuideCriteriaType_Obj_Rel_Insert_Input>;
  classGuideCriteriaTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  criteriaWeight?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClassCriteria_Max_Fields = {
  __typename?: 'classCriteria_max_fields';
  classGuideCriteriaTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  criteriaWeight?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "classes.class_criteria" */
export type ClassCriteria_Max_Order_By = {
  classGuideCriteriaTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  criteriaWeight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassCriteria_Min_Fields = {
  __typename?: 'classCriteria_min_fields';
  classGuideCriteriaTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  criteriaWeight?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "classes.class_criteria" */
export type ClassCriteria_Min_Order_By = {
  classGuideCriteriaTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  criteriaWeight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classes.class_criteria" */
export type ClassCriteria_Mutation_Response = {
  __typename?: 'classCriteria_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassCriteria>;
};

/** input type for inserting object relation for remote table "classes.class_criteria" */
export type ClassCriteria_Obj_Rel_Insert_Input = {
  data: ClassCriteria_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassCriteria_On_Conflict>;
};

/** on_conflict condition type for table "classes.class_criteria" */
export type ClassCriteria_On_Conflict = {
  constraint: ClassCriteria_Constraint;
  update_columns?: Array<ClassCriteria_Update_Column>;
  where?: InputMaybe<ClassCriteria_Bool_Exp>;
};

/** Ordering options when selecting data from "classes.class_criteria". */
export type ClassCriteria_Order_By = {
  classGuideClassCriterias_aggregate?: InputMaybe<ClassGuideClassCriteria_Aggregate_Order_By>;
  classGuideCriteriaType?: InputMaybe<ClassGuideCriteriaType_Order_By>;
  classGuideCriteriaTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  criteriaWeight?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classes.class_criteria */
export type ClassCriteria_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ClassCriteria_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "classes.class_criteria" */
export enum ClassCriteria_Select_Column {
  /** column name */
  ClassGuideCriteriaTypeId = 'classGuideCriteriaTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CriteriaWeight = 'criteriaWeight',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "classes.class_criteria" */
export type ClassCriteria_Set_Input = {
  classGuideCriteriaTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  criteriaWeight?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ClassCriteria_Stddev_Fields = {
  __typename?: 'classCriteria_stddev_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "classes.class_criteria" */
export type ClassCriteria_Stddev_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ClassCriteria_Stddev_Pop_Fields = {
  __typename?: 'classCriteria_stddev_pop_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "classes.class_criteria" */
export type ClassCriteria_Stddev_Pop_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ClassCriteria_Stddev_Samp_Fields = {
  __typename?: 'classCriteria_stddev_samp_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "classes.class_criteria" */
export type ClassCriteria_Stddev_Samp_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "classCriteria" */
export type ClassCriteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassCriteria_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassCriteria_Stream_Cursor_Value_Input = {
  classGuideCriteriaTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  criteriaWeight?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ClassCriteria_Sum_Fields = {
  __typename?: 'classCriteria_sum_fields';
  criteriaWeight?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "classes.class_criteria" */
export type ClassCriteria_Sum_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
};

/** update columns of table "classes.class_criteria" */
export enum ClassCriteria_Update_Column {
  /** column name */
  ClassGuideCriteriaTypeId = 'classGuideCriteriaTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CriteriaWeight = 'criteriaWeight',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClassCriteria_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ClassCriteria_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ClassCriteria_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ClassCriteria_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ClassCriteria_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClassCriteria_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ClassCriteria_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassCriteria_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassCriteria_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClassCriteria_Var_Pop_Fields = {
  __typename?: 'classCriteria_var_pop_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "classes.class_criteria" */
export type ClassCriteria_Var_Pop_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ClassCriteria_Var_Samp_Fields = {
  __typename?: 'classCriteria_var_samp_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "classes.class_criteria" */
export type ClassCriteria_Var_Samp_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ClassCriteria_Variance_Fields = {
  __typename?: 'classCriteria_variance_fields';
  criteriaWeight?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "classes.class_criteria" */
export type ClassCriteria_Variance_Order_By = {
  criteriaWeight?: InputMaybe<Order_By>;
};

/** columns and relationships of "classes.class_guide" */
export type ClassGuide = {
  __typename?: 'classGuide';
  /** An object relationship */
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  class_guide_class_criteria: Array<ClassGuideClassCriteria>;
  /** An aggregate relationship */
  class_guide_class_criteria_aggregate: ClassGuideClassCriteria_Aggregate;
  createdAt: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "classes.class_guide" */
export type ClassGuideClass_Guide_Class_CriteriaArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


/** columns and relationships of "classes.class_guide" */
export type ClassGuideClass_Guide_Class_Criteria_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};

/** columns and relationships of "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria = {
  __typename?: 'classGuideClassCriteria';
  /** An object relationship */
  classCriteria: ClassCriteria;
  classCriteriaId: Scalars['uuid'];
  /** An array relationship */
  classCriteriaView: Array<ClassCriteriaView>;
  /** An aggregate relationship */
  classCriteriaView_aggregate: ClassCriteriaView_Aggregate;
  /** An object relationship */
  classGuide: ClassGuide;
  /** An array relationship */
  classGuideCriteriaDefinitions: Array<ClassGuideCriteriaDefinition>;
  /** An aggregate relationship */
  classGuideCriteriaDefinitions_aggregate: ClassGuideCriteriaDefinition_Aggregate;
  classGuideId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteriaClassCriteriaViewArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaView_Order_By>>;
  where?: InputMaybe<ClassCriteriaView_Bool_Exp>;
};


/** columns and relationships of "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteriaClassCriteriaView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaView_Order_By>>;
  where?: InputMaybe<ClassCriteriaView_Bool_Exp>;
};


/** columns and relationships of "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteriaClassGuideCriteriaDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaDefinition_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};


/** columns and relationships of "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteriaClassGuideCriteriaDefinitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaDefinition_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};

/** columns and relationships of "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria';
  bodyStyleCode?: Maybe<Scalars['String']>;
  /** An object relationship */
  classCriteria?: Maybe<ClassCriteria>;
  classCriteriaId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  classGuide?: Maybe<ClassGuide>;
  /** An array relationship */
  classGuideCriteriaDefinitions: Array<ClassGuideCriteriaDefinition>;
  /** An aggregate relationship */
  classGuideCriteriaDefinitions_aggregate: ClassGuideCriteriaDefinition_Aggregate;
  classGuideId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  hasSupercharger?: Maybe<Scalars['Boolean']>;
  hasTurbo?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteriaClassGuideCriteriaDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaDefinition_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};


/** columns and relationships of "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteriaClassGuideCriteriaDefinitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaDefinition_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};

/** aggregated selection of "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Aggregate = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_aggregate';
  aggregate?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Aggregate_Fields>;
  nodes: Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria>;
};

/** aggregate fields of "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Aggregate_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_aggregate_fields';
  avg?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Max_Fields>;
  min?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Min_Fields>;
  stddev?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Stddev_Fields>;
  stddev_pop?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Stddev_Samp_Fields>;
  sum?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Sum_Fields>;
  var_pop?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Var_Pop_Fields>;
  var_samp?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Var_Samp_Fields>;
  variance?: Maybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Variance_Fields>;
};


/** aggregate fields of "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Avg_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_avg_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "classes.class_guide_class_criteria_view_default_vehicle_criteria". All fields are combined with a logical 'AND'. */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Bool_Exp = {
  _and?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>>;
  _not?: InputMaybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
  _or?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>>;
  bodyStyleCode?: InputMaybe<String_Comparison_Exp>;
  classCriteria?: InputMaybe<ClassCriteria_Bool_Exp>;
  classCriteriaId?: InputMaybe<Uuid_Comparison_Exp>;
  classGuide?: InputMaybe<ClassGuide_Bool_Exp>;
  classGuideCriteriaDefinitions?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
  classGuideCriteriaDefinitions_aggregate?: InputMaybe<ClassGuideCriteriaDefinition_Aggregate_Bool_Exp>;
  classGuideId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cylinders?: InputMaybe<Int_Comparison_Exp>;
  fuelTypeCode?: InputMaybe<String_Comparison_Exp>;
  hasSupercharger?: InputMaybe<Boolean_Comparison_Exp>;
  hasTurbo?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  makeCode?: InputMaybe<String_Comparison_Exp>;
  modelName?: InputMaybe<String_Comparison_Exp>;
  numberWheelsDriving?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicleTypeCode?: InputMaybe<String_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Max_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_max_fields';
  bodyStyleCode?: Maybe<Scalars['String']>;
  classCriteriaId?: Maybe<Scalars['uuid']>;
  classGuideId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Min_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_min_fields';
  bodyStyleCode?: Maybe<Scalars['String']>;
  classCriteriaId?: Maybe<Scalars['uuid']>;
  classGuideId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['Int']>;
  fuelTypeCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  makeCode?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleTypeCode?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "classes.class_guide_class_criteria_view_default_vehicle_criteria". */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Order_By = {
  bodyStyleCode?: InputMaybe<Order_By>;
  classCriteria?: InputMaybe<ClassCriteria_Order_By>;
  classCriteriaId?: InputMaybe<Order_By>;
  classGuide?: InputMaybe<ClassGuide_Order_By>;
  classGuideCriteriaDefinitions_aggregate?: InputMaybe<ClassGuideCriteriaDefinition_Aggregate_Order_By>;
  classGuideId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  fuelTypeCode?: InputMaybe<Order_By>;
  hasSupercharger?: InputMaybe<Order_By>;
  hasTurbo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  makeCode?: InputMaybe<Order_By>;
  modelName?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleTypeCode?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** select columns of table "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
export enum ClassGuideClassCriteriaViewDefaultVehicleCriteria_Select_Column {
  /** column name */
  BodyStyleCode = 'bodyStyleCode',
  /** column name */
  ClassCriteriaId = 'classCriteriaId',
  /** column name */
  ClassGuideId = 'classGuideId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Cylinders = 'cylinders',
  /** column name */
  FuelTypeCode = 'fuelTypeCode',
  /** column name */
  HasSupercharger = 'hasSupercharger',
  /** column name */
  HasTurbo = 'hasTurbo',
  /** column name */
  Id = 'id',
  /** column name */
  MakeCode = 'makeCode',
  /** column name */
  ModelName = 'modelName',
  /** column name */
  NumberWheelsDriving = 'numberWheelsDriving',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VehicleTypeCode = 'vehicleTypeCode',
  /** column name */
  Year = 'year'
}

/** aggregate stddev on columns */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Stddev_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_stddev_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Stddev_Pop_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_stddev_pop_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Stddev_Samp_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_stddev_samp_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "classGuideClassCriteriaViewDefaultVehicleCriteria" */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassGuideClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Value_Input = {
  bodyStyleCode?: InputMaybe<Scalars['String']>;
  classCriteriaId?: InputMaybe<Scalars['uuid']>;
  classGuideId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cylinders?: InputMaybe<Scalars['Int']>;
  fuelTypeCode?: InputMaybe<Scalars['String']>;
  hasSupercharger?: InputMaybe<Scalars['Boolean']>;
  hasTurbo?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  makeCode?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleTypeCode?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Sum_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_sum_fields';
  cylinders?: Maybe<Scalars['Int']>;
  numberWheelsDriving?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Var_Pop_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_var_pop_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Var_Samp_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_var_samp_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ClassGuideClassCriteriaViewDefaultVehicleCriteria_Variance_Fields = {
  __typename?: 'classGuideClassCriteriaViewDefaultVehicleCriteria_variance_fields';
  cylinders?: Maybe<Scalars['Float']>;
  numberWheelsDriving?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "classes.class_guide_class_criteria_view_vin" */
export type ClassGuideClassCriteriaViewVin = {
  __typename?: 'classGuideClassCriteriaViewVin';
  /** An object relationship */
  classCriteria?: Maybe<ClassCriteria>;
  classCriteriaId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  classGuide?: Maybe<ClassGuide>;
  /** An array relationship */
  classGuideCriteriaDefinitions: Array<ClassGuideCriteriaDefinition>;
  /** An aggregate relationship */
  classGuideCriteriaDefinitions_aggregate: ClassGuideCriteriaDefinition_Aggregate;
  classGuideId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vin?: Maybe<Scalars['String']>;
};


/** columns and relationships of "classes.class_guide_class_criteria_view_vin" */
export type ClassGuideClassCriteriaViewVinClassGuideCriteriaDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaDefinition_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};


/** columns and relationships of "classes.class_guide_class_criteria_view_vin" */
export type ClassGuideClassCriteriaViewVinClassGuideCriteriaDefinitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaDefinition_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};

/** aggregated selection of "classes.class_guide_class_criteria_view_vin" */
export type ClassGuideClassCriteriaViewVin_Aggregate = {
  __typename?: 'classGuideClassCriteriaViewVin_aggregate';
  aggregate?: Maybe<ClassGuideClassCriteriaViewVin_Aggregate_Fields>;
  nodes: Array<ClassGuideClassCriteriaViewVin>;
};

/** aggregate fields of "classes.class_guide_class_criteria_view_vin" */
export type ClassGuideClassCriteriaViewVin_Aggregate_Fields = {
  __typename?: 'classGuideClassCriteriaViewVin_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ClassGuideClassCriteriaViewVin_Max_Fields>;
  min?: Maybe<ClassGuideClassCriteriaViewVin_Min_Fields>;
};


/** aggregate fields of "classes.class_guide_class_criteria_view_vin" */
export type ClassGuideClassCriteriaViewVin_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "classes.class_guide_class_criteria_view_vin". All fields are combined with a logical 'AND'. */
export type ClassGuideClassCriteriaViewVin_Bool_Exp = {
  _and?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Bool_Exp>>;
  _not?: InputMaybe<ClassGuideClassCriteriaViewVin_Bool_Exp>;
  _or?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Bool_Exp>>;
  classCriteria?: InputMaybe<ClassCriteria_Bool_Exp>;
  classCriteriaId?: InputMaybe<Uuid_Comparison_Exp>;
  classGuide?: InputMaybe<ClassGuide_Bool_Exp>;
  classGuideCriteriaDefinitions?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
  classGuideCriteriaDefinitions_aggregate?: InputMaybe<ClassGuideCriteriaDefinition_Aggregate_Bool_Exp>;
  classGuideId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vin?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type ClassGuideClassCriteriaViewVin_Max_Fields = {
  __typename?: 'classGuideClassCriteriaViewVin_max_fields';
  classCriteriaId?: Maybe<Scalars['uuid']>;
  classGuideId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vin?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ClassGuideClassCriteriaViewVin_Min_Fields = {
  __typename?: 'classGuideClassCriteriaViewVin_min_fields';
  classCriteriaId?: Maybe<Scalars['uuid']>;
  classGuideId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vin?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "classes.class_guide_class_criteria_view_vin". */
export type ClassGuideClassCriteriaViewVin_Order_By = {
  classCriteria?: InputMaybe<ClassCriteria_Order_By>;
  classCriteriaId?: InputMaybe<Order_By>;
  classGuide?: InputMaybe<ClassGuide_Order_By>;
  classGuideCriteriaDefinitions_aggregate?: InputMaybe<ClassGuideCriteriaDefinition_Aggregate_Order_By>;
  classGuideId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vin?: InputMaybe<Order_By>;
};

/** select columns of table "classes.class_guide_class_criteria_view_vin" */
export enum ClassGuideClassCriteriaViewVin_Select_Column {
  /** column name */
  ClassCriteriaId = 'classCriteriaId',
  /** column name */
  ClassGuideId = 'classGuideId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Vin = 'vin'
}

/** Streaming cursor of the table "classGuideClassCriteriaViewVin" */
export type ClassGuideClassCriteriaViewVin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassGuideClassCriteriaViewVin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassGuideClassCriteriaViewVin_Stream_Cursor_Value_Input = {
  classCriteriaId?: InputMaybe<Scalars['uuid']>;
  classGuideId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vin?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Aggregate = {
  __typename?: 'classGuideClassCriteria_aggregate';
  aggregate?: Maybe<ClassGuideClassCriteria_Aggregate_Fields>;
  nodes: Array<ClassGuideClassCriteria>;
};

export type ClassGuideClassCriteria_Aggregate_Bool_Exp = {
  count?: InputMaybe<ClassGuideClassCriteria_Aggregate_Bool_Exp_Count>;
};

export type ClassGuideClassCriteria_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Aggregate_Fields = {
  __typename?: 'classGuideClassCriteria_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ClassGuideClassCriteria_Max_Fields>;
  min?: Maybe<ClassGuideClassCriteria_Min_Fields>;
};


/** aggregate fields of "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassGuideClassCriteria_Max_Order_By>;
  min?: InputMaybe<ClassGuideClassCriteria_Min_Order_By>;
};

/** input type for inserting array relation for remote table "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Arr_Rel_Insert_Input = {
  data: Array<ClassGuideClassCriteria_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassGuideClassCriteria_On_Conflict>;
};

/** Boolean expression to filter rows from the table "classes.class_guide_class_criteria". All fields are combined with a logical 'AND'. */
export type ClassGuideClassCriteria_Bool_Exp = {
  _and?: InputMaybe<Array<ClassGuideClassCriteria_Bool_Exp>>;
  _not?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
  _or?: InputMaybe<Array<ClassGuideClassCriteria_Bool_Exp>>;
  classCriteria?: InputMaybe<ClassCriteria_Bool_Exp>;
  classCriteriaId?: InputMaybe<Uuid_Comparison_Exp>;
  classCriteriaView?: InputMaybe<ClassCriteriaView_Bool_Exp>;
  classCriteriaView_aggregate?: InputMaybe<ClassCriteriaView_Aggregate_Bool_Exp>;
  classGuide?: InputMaybe<ClassGuide_Bool_Exp>;
  classGuideCriteriaDefinitions?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
  classGuideCriteriaDefinitions_aggregate?: InputMaybe<ClassGuideCriteriaDefinition_Aggregate_Bool_Exp>;
  classGuideId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "classes.class_guide_class_criteria" */
export enum ClassGuideClassCriteria_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClassGuideClassCriteriaPkey = 'class_guide_class_criteria_pkey'
}

/** input type for inserting data into table "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Insert_Input = {
  classCriteria?: InputMaybe<ClassCriteria_Obj_Rel_Insert_Input>;
  classCriteriaId?: InputMaybe<Scalars['uuid']>;
  classCriteriaView?: InputMaybe<ClassCriteriaView_Arr_Rel_Insert_Input>;
  classGuide?: InputMaybe<ClassGuide_Obj_Rel_Insert_Input>;
  classGuideCriteriaDefinitions?: InputMaybe<ClassGuideCriteriaDefinition_Arr_Rel_Insert_Input>;
  classGuideId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClassGuideClassCriteria_Max_Fields = {
  __typename?: 'classGuideClassCriteria_max_fields';
  classCriteriaId?: Maybe<Scalars['uuid']>;
  classGuideId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Max_Order_By = {
  classCriteriaId?: InputMaybe<Order_By>;
  classGuideId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassGuideClassCriteria_Min_Fields = {
  __typename?: 'classGuideClassCriteria_min_fields';
  classCriteriaId?: Maybe<Scalars['uuid']>;
  classGuideId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Min_Order_By = {
  classCriteriaId?: InputMaybe<Order_By>;
  classGuideId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Mutation_Response = {
  __typename?: 'classGuideClassCriteria_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassGuideClassCriteria>;
};

/** input type for inserting object relation for remote table "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Obj_Rel_Insert_Input = {
  data: ClassGuideClassCriteria_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassGuideClassCriteria_On_Conflict>;
};

/** on_conflict condition type for table "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_On_Conflict = {
  constraint: ClassGuideClassCriteria_Constraint;
  update_columns?: Array<ClassGuideClassCriteria_Update_Column>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};

/** Ordering options when selecting data from "classes.class_guide_class_criteria". */
export type ClassGuideClassCriteria_Order_By = {
  classCriteria?: InputMaybe<ClassCriteria_Order_By>;
  classCriteriaId?: InputMaybe<Order_By>;
  classCriteriaView_aggregate?: InputMaybe<ClassCriteriaView_Aggregate_Order_By>;
  classGuide?: InputMaybe<ClassGuide_Order_By>;
  classGuideCriteriaDefinitions_aggregate?: InputMaybe<ClassGuideCriteriaDefinition_Aggregate_Order_By>;
  classGuideId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classes.class_guide_class_criteria */
export type ClassGuideClassCriteria_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "classes.class_guide_class_criteria" */
export enum ClassGuideClassCriteria_Select_Column {
  /** column name */
  ClassCriteriaId = 'classCriteriaId',
  /** column name */
  ClassGuideId = 'classGuideId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "classes.class_guide_class_criteria" */
export type ClassGuideClassCriteria_Set_Input = {
  classCriteriaId?: InputMaybe<Scalars['uuid']>;
  classGuideId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "classGuideClassCriteria" */
export type ClassGuideClassCriteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassGuideClassCriteria_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassGuideClassCriteria_Stream_Cursor_Value_Input = {
  classCriteriaId?: InputMaybe<Scalars['uuid']>;
  classGuideId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "classes.class_guide_class_criteria" */
export enum ClassGuideClassCriteria_Update_Column {
  /** column name */
  ClassCriteriaId = 'classCriteriaId',
  /** column name */
  ClassGuideId = 'classGuideId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClassGuideClassCriteria_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassGuideClassCriteria_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassGuideClassCriteria_Bool_Exp;
};

/** columns and relationships of "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition = {
  __typename?: 'classGuideCriteriaDefinition';
  /** An object relationship */
  classGuideClassCriteria: ClassGuideClassCriteria;
  classGuideClassCriteriaId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  effectiveDate: Scalars['date'];
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  newClassCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  usedClassCode?: Maybe<Scalars['String']>;
};

/** aggregated selection of "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_Aggregate = {
  __typename?: 'classGuideCriteriaDefinition_aggregate';
  aggregate?: Maybe<ClassGuideCriteriaDefinition_Aggregate_Fields>;
  nodes: Array<ClassGuideCriteriaDefinition>;
};

export type ClassGuideCriteriaDefinition_Aggregate_Bool_Exp = {
  count?: InputMaybe<ClassGuideCriteriaDefinition_Aggregate_Bool_Exp_Count>;
};

export type ClassGuideCriteriaDefinition_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_Aggregate_Fields = {
  __typename?: 'classGuideCriteriaDefinition_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ClassGuideCriteriaDefinition_Max_Fields>;
  min?: Maybe<ClassGuideCriteriaDefinition_Min_Fields>;
};


/** aggregate fields of "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassGuideCriteriaDefinition_Max_Order_By>;
  min?: InputMaybe<ClassGuideCriteriaDefinition_Min_Order_By>;
};

/** input type for inserting array relation for remote table "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_Arr_Rel_Insert_Input = {
  data: Array<ClassGuideCriteriaDefinition_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassGuideCriteriaDefinition_On_Conflict>;
};

/** Boolean expression to filter rows from the table "classes.class_guide_criteria_definition". All fields are combined with a logical 'AND'. */
export type ClassGuideCriteriaDefinition_Bool_Exp = {
  _and?: InputMaybe<Array<ClassGuideCriteriaDefinition_Bool_Exp>>;
  _not?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
  _or?: InputMaybe<Array<ClassGuideCriteriaDefinition_Bool_Exp>>;
  classGuideClassCriteria?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
  classGuideClassCriteriaId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  newClassCode?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  usedClassCode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "classes.class_guide_criteria_definition" */
export enum ClassGuideCriteriaDefinition_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClassGuideCriteriaDefinitionPkey = 'class_guide_criteria_definition_pkey'
}

/** input type for inserting data into table "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_Insert_Input = {
  classGuideClassCriteria?: InputMaybe<ClassGuideClassCriteria_Obj_Rel_Insert_Input>;
  classGuideClassCriteriaId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  newClassCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usedClassCode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ClassGuideCriteriaDefinition_Max_Fields = {
  __typename?: 'classGuideCriteriaDefinition_max_fields';
  classGuideClassCriteriaId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  newClassCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usedClassCode?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_Max_Order_By = {
  classGuideClassCriteriaId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  newClassCode?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usedClassCode?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassGuideCriteriaDefinition_Min_Fields = {
  __typename?: 'classGuideCriteriaDefinition_min_fields';
  classGuideClassCriteriaId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  newClassCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usedClassCode?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_Min_Order_By = {
  classGuideClassCriteriaId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  newClassCode?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usedClassCode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_Mutation_Response = {
  __typename?: 'classGuideCriteriaDefinition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassGuideCriteriaDefinition>;
};

/** on_conflict condition type for table "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_On_Conflict = {
  constraint: ClassGuideCriteriaDefinition_Constraint;
  update_columns?: Array<ClassGuideCriteriaDefinition_Update_Column>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};

/** Ordering options when selecting data from "classes.class_guide_criteria_definition". */
export type ClassGuideCriteriaDefinition_Order_By = {
  classGuideClassCriteria?: InputMaybe<ClassGuideClassCriteria_Order_By>;
  classGuideClassCriteriaId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  newClassCode?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usedClassCode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classes.class_guide_criteria_definition */
export type ClassGuideCriteriaDefinition_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "classes.class_guide_criteria_definition" */
export enum ClassGuideCriteriaDefinition_Select_Column {
  /** column name */
  ClassGuideClassCriteriaId = 'classGuideClassCriteriaId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  NewClassCode = 'newClassCode',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsedClassCode = 'usedClassCode'
}

/** input type for updating data in table "classes.class_guide_criteria_definition" */
export type ClassGuideCriteriaDefinition_Set_Input = {
  classGuideClassCriteriaId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  newClassCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usedClassCode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "classGuideCriteriaDefinition" */
export type ClassGuideCriteriaDefinition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassGuideCriteriaDefinition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassGuideCriteriaDefinition_Stream_Cursor_Value_Input = {
  classGuideClassCriteriaId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  newClassCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usedClassCode?: InputMaybe<Scalars['String']>;
};

/** update columns of table "classes.class_guide_criteria_definition" */
export enum ClassGuideCriteriaDefinition_Update_Column {
  /** column name */
  ClassGuideClassCriteriaId = 'classGuideClassCriteriaId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  NewClassCode = 'newClassCode',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsedClassCode = 'usedClassCode'
}

export type ClassGuideCriteriaDefinition_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassGuideCriteriaDefinition_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassGuideCriteriaDefinition_Bool_Exp;
};

/** columns and relationships of "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaType = {
  __typename?: 'classGuideCriteriaType';
  /** An array relationship */
  class_criteria: Array<ClassCriteria>;
  /** An aggregate relationship */
  class_criteria_aggregate: ClassCriteria_Aggregate;
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaTypeClass_CriteriaArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteria_Bool_Exp>;
};


/** columns and relationships of "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaTypeClass_Criteria_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteria_Bool_Exp>;
};

/** aggregated selection of "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaType_Aggregate = {
  __typename?: 'classGuideCriteriaType_aggregate';
  aggregate?: Maybe<ClassGuideCriteriaType_Aggregate_Fields>;
  nodes: Array<ClassGuideCriteriaType>;
};

/** aggregate fields of "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaType_Aggregate_Fields = {
  __typename?: 'classGuideCriteriaType_aggregate_fields';
  avg?: Maybe<ClassGuideCriteriaType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClassGuideCriteriaType_Max_Fields>;
  min?: Maybe<ClassGuideCriteriaType_Min_Fields>;
  stddev?: Maybe<ClassGuideCriteriaType_Stddev_Fields>;
  stddev_pop?: Maybe<ClassGuideCriteriaType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClassGuideCriteriaType_Stddev_Samp_Fields>;
  sum?: Maybe<ClassGuideCriteriaType_Sum_Fields>;
  var_pop?: Maybe<ClassGuideCriteriaType_Var_Pop_Fields>;
  var_samp?: Maybe<ClassGuideCriteriaType_Var_Samp_Fields>;
  variance?: Maybe<ClassGuideCriteriaType_Variance_Fields>;
};


/** aggregate fields of "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassGuideCriteriaType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ClassGuideCriteriaType_Avg_Fields = {
  __typename?: 'classGuideCriteriaType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "classes.class_guide_criteria_type". All fields are combined with a logical 'AND'. */
export type ClassGuideCriteriaType_Bool_Exp = {
  _and?: InputMaybe<Array<ClassGuideCriteriaType_Bool_Exp>>;
  _not?: InputMaybe<ClassGuideCriteriaType_Bool_Exp>;
  _or?: InputMaybe<Array<ClassGuideCriteriaType_Bool_Exp>>;
  class_criteria?: InputMaybe<ClassCriteria_Bool_Exp>;
  class_criteria_aggregate?: InputMaybe<ClassCriteria_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "classes.class_guide_criteria_type" */
export enum ClassGuideCriteriaType_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClassGuideCriteriaTypePkey = 'class_guide_criteria_type_pkey'
}

/** input type for incrementing numeric columns in table "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaType_Insert_Input = {
  class_criteria?: InputMaybe<ClassCriteria_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClassGuideCriteriaType_Max_Fields = {
  __typename?: 'classGuideCriteriaType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ClassGuideCriteriaType_Min_Fields = {
  __typename?: 'classGuideCriteriaType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaType_Mutation_Response = {
  __typename?: 'classGuideCriteriaType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassGuideCriteriaType>;
};

/** input type for inserting object relation for remote table "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaType_Obj_Rel_Insert_Input = {
  data: ClassGuideCriteriaType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassGuideCriteriaType_On_Conflict>;
};

/** on_conflict condition type for table "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaType_On_Conflict = {
  constraint: ClassGuideCriteriaType_Constraint;
  update_columns?: Array<ClassGuideCriteriaType_Update_Column>;
  where?: InputMaybe<ClassGuideCriteriaType_Bool_Exp>;
};

/** Ordering options when selecting data from "classes.class_guide_criteria_type". */
export type ClassGuideCriteriaType_Order_By = {
  class_criteria_aggregate?: InputMaybe<ClassCriteria_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classes.class_guide_criteria_type */
export type ClassGuideCriteriaType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "classes.class_guide_criteria_type" */
export enum ClassGuideCriteriaType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "classes.class_guide_criteria_type" */
export type ClassGuideCriteriaType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ClassGuideCriteriaType_Stddev_Fields = {
  __typename?: 'classGuideCriteriaType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ClassGuideCriteriaType_Stddev_Pop_Fields = {
  __typename?: 'classGuideCriteriaType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ClassGuideCriteriaType_Stddev_Samp_Fields = {
  __typename?: 'classGuideCriteriaType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "classGuideCriteriaType" */
export type ClassGuideCriteriaType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassGuideCriteriaType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassGuideCriteriaType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ClassGuideCriteriaType_Sum_Fields = {
  __typename?: 'classGuideCriteriaType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "classes.class_guide_criteria_type" */
export enum ClassGuideCriteriaType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClassGuideCriteriaType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClassGuideCriteriaType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassGuideCriteriaType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassGuideCriteriaType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClassGuideCriteriaType_Var_Pop_Fields = {
  __typename?: 'classGuideCriteriaType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ClassGuideCriteriaType_Var_Samp_Fields = {
  __typename?: 'classGuideCriteriaType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ClassGuideCriteriaType_Variance_Fields = {
  __typename?: 'classGuideCriteriaType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "classes.class_guide" */
export type ClassGuide_Aggregate = {
  __typename?: 'classGuide_aggregate';
  aggregate?: Maybe<ClassGuide_Aggregate_Fields>;
  nodes: Array<ClassGuide>;
};

export type ClassGuide_Aggregate_Bool_Exp = {
  count?: InputMaybe<ClassGuide_Aggregate_Bool_Exp_Count>;
};

export type ClassGuide_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ClassGuide_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClassGuide_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "classes.class_guide" */
export type ClassGuide_Aggregate_Fields = {
  __typename?: 'classGuide_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ClassGuide_Max_Fields>;
  min?: Maybe<ClassGuide_Min_Fields>;
};


/** aggregate fields of "classes.class_guide" */
export type ClassGuide_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClassGuide_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "classes.class_guide" */
export type ClassGuide_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClassGuide_Max_Order_By>;
  min?: InputMaybe<ClassGuide_Min_Order_By>;
};

/** input type for inserting array relation for remote table "classes.class_guide" */
export type ClassGuide_Arr_Rel_Insert_Input = {
  data: Array<ClassGuide_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassGuide_On_Conflict>;
};

/** Boolean expression to filter rows from the table "classes.class_guide". All fields are combined with a logical 'AND'. */
export type ClassGuide_Bool_Exp = {
  _and?: InputMaybe<Array<ClassGuide_Bool_Exp>>;
  _not?: InputMaybe<ClassGuide_Bool_Exp>;
  _or?: InputMaybe<Array<ClassGuide_Bool_Exp>>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  class_guide_class_criteria?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
  class_guide_class_criteria_aggregate?: InputMaybe<ClassGuideClassCriteria_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "classes.class_guide" */
export enum ClassGuide_Constraint {
  /** unique or primary key constraint on columns "name" */
  ClassGuideNameKey = 'class_guide_name_key',
  /** unique or primary key constraint on columns "id" */
  ClassGuidePkey = 'class_guide_pkey'
}

/** input type for inserting data into table "classes.class_guide" */
export type ClassGuide_Insert_Input = {
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  class_guide_class_criteria?: InputMaybe<ClassGuideClassCriteria_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClassGuide_Max_Fields = {
  __typename?: 'classGuide_max_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "classes.class_guide" */
export type ClassGuide_Max_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClassGuide_Min_Fields = {
  __typename?: 'classGuide_min_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "classes.class_guide" */
export type ClassGuide_Min_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "classes.class_guide" */
export type ClassGuide_Mutation_Response = {
  __typename?: 'classGuide_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassGuide>;
};

/** input type for inserting object relation for remote table "classes.class_guide" */
export type ClassGuide_Obj_Rel_Insert_Input = {
  data: ClassGuide_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClassGuide_On_Conflict>;
};

/** on_conflict condition type for table "classes.class_guide" */
export type ClassGuide_On_Conflict = {
  constraint: ClassGuide_Constraint;
  update_columns?: Array<ClassGuide_Update_Column>;
  where?: InputMaybe<ClassGuide_Bool_Exp>;
};

/** Ordering options when selecting data from "classes.class_guide". */
export type ClassGuide_Order_By = {
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  class_guide_class_criteria_aggregate?: InputMaybe<ClassGuideClassCriteria_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: classes.class_guide */
export type ClassGuide_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "classes.class_guide" */
export enum ClassGuide_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "classes.class_guide" */
export type ClassGuide_Set_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "classGuide" */
export type ClassGuide_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClassGuide_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClassGuide_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "classes.class_guide" */
export enum ClassGuide_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClassGuide_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClassGuide_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClassGuide_Bool_Exp;
};

/** columns and relationships of "composite_product" */
export type CompositeProduct = {
  __typename?: 'compositeProduct';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  parentProduct: Product;
  parentProductId: Scalars['uuid'];
  /** An object relationship */
  product: Product;
  productId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "composite_product" */
export type CompositeProduct_Aggregate = {
  __typename?: 'compositeProduct_aggregate';
  aggregate?: Maybe<CompositeProduct_Aggregate_Fields>;
  nodes: Array<CompositeProduct>;
};

export type CompositeProduct_Aggregate_Bool_Exp = {
  count?: InputMaybe<CompositeProduct_Aggregate_Bool_Exp_Count>;
};

export type CompositeProduct_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CompositeProduct_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompositeProduct_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "composite_product" */
export type CompositeProduct_Aggregate_Fields = {
  __typename?: 'compositeProduct_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CompositeProduct_Max_Fields>;
  min?: Maybe<CompositeProduct_Min_Fields>;
};


/** aggregate fields of "composite_product" */
export type CompositeProduct_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CompositeProduct_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "composite_product" */
export type CompositeProduct_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CompositeProduct_Max_Order_By>;
  min?: InputMaybe<CompositeProduct_Min_Order_By>;
};

/** input type for inserting array relation for remote table "composite_product" */
export type CompositeProduct_Arr_Rel_Insert_Input = {
  data: Array<CompositeProduct_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CompositeProduct_On_Conflict>;
};

/** Boolean expression to filter rows from the table "composite_product". All fields are combined with a logical 'AND'. */
export type CompositeProduct_Bool_Exp = {
  _and?: InputMaybe<Array<CompositeProduct_Bool_Exp>>;
  _not?: InputMaybe<CompositeProduct_Bool_Exp>;
  _or?: InputMaybe<Array<CompositeProduct_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parentProduct?: InputMaybe<Product_Bool_Exp>;
  parentProductId?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "composite_product" */
export enum CompositeProduct_Constraint {
  /** unique or primary key constraint on columns "product_id", "parent_product_id" */
  CompositeProductParentProductIdProductIdKey = 'composite_product_parent_product_id_product_id_key',
  /** unique or primary key constraint on columns "id" */
  CompositeProductPkey = 'composite_product_pkey'
}

/** input type for inserting data into table "composite_product" */
export type CompositeProduct_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  parentProductId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CompositeProduct_Max_Fields = {
  __typename?: 'compositeProduct_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentProductId?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "composite_product" */
export type CompositeProduct_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentProductId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CompositeProduct_Min_Fields = {
  __typename?: 'compositeProduct_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentProductId?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "composite_product" */
export type CompositeProduct_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentProductId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "composite_product" */
export type CompositeProduct_Mutation_Response = {
  __typename?: 'compositeProduct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompositeProduct>;
};

/** on_conflict condition type for table "composite_product" */
export type CompositeProduct_On_Conflict = {
  constraint: CompositeProduct_Constraint;
  update_columns?: Array<CompositeProduct_Update_Column>;
  where?: InputMaybe<CompositeProduct_Bool_Exp>;
};

/** Ordering options when selecting data from "composite_product". */
export type CompositeProduct_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentProduct?: InputMaybe<Product_Order_By>;
  parentProductId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: composite_product */
export type CompositeProduct_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "composite_product" */
export enum CompositeProduct_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentProductId = 'parentProductId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "composite_product" */
export type CompositeProduct_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentProductId?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "compositeProduct" */
export type CompositeProduct_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CompositeProduct_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CompositeProduct_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentProductId?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "composite_product" */
export enum CompositeProduct_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentProductId = 'parentProductId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CompositeProduct_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompositeProduct_Set_Input>;
  /** filter the rows which have to be updated */
  where: CompositeProduct_Bool_Exp;
};

/** aggregate fields of "nhtsa.concern_synonym" */
export type ConcernSynonym_Aggregate_Fields_Nhtsa = {
  __typename?: 'concernSynonym_aggregate_fields_nhtsa';
  count: Scalars['Int'];
  max?: Maybe<ConcernSynonym_Max_Fields_Nhtsa>;
  min?: Maybe<ConcernSynonym_Min_Fields_Nhtsa>;
};


/** aggregate fields of "nhtsa.concern_synonym" */
export type ConcernSynonym_Aggregate_Fields_NhtsaCountArgs = {
  columns?: InputMaybe<Array<ConcernSynonym_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "nhtsa.concern_synonym" */
export type ConcernSynonym_Aggregate_Nhtsa = {
  __typename?: 'concernSynonym_aggregate_nhtsa';
  aggregate?: Maybe<ConcernSynonym_Aggregate_Fields_Nhtsa>;
  nodes: Array<ConcernSynonym_Nhtsa>;
};

/** Boolean expression to filter rows from the table "nhtsa.concern_synonym". All fields are combined with a logical 'AND'. */
export type ConcernSynonym_Bool_Exp_Nhtsa = {
  _and?: InputMaybe<Array<ConcernSynonym_Bool_Exp_Nhtsa>>;
  _not?: InputMaybe<ConcernSynonym_Bool_Exp_Nhtsa>;
  _or?: InputMaybe<Array<ConcernSynonym_Bool_Exp_Nhtsa>>;
  groupName?: InputMaybe<String_Comparison_Exp>;
  term?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "nhtsa.concern_synonym" */
export enum ConcernSynonym_Constraint_Nhtsa {
  /** unique or primary key constraint on columns "term", "group_name" */
  ConcernSynonymPkey = 'concern_synonym_pkey'
}

/** input type for inserting data into table "nhtsa.concern_synonym" */
export type ConcernSynonym_Insert_Input_Nhtsa = {
  groupName?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ConcernSynonym_Max_Fields_Nhtsa = {
  __typename?: 'concernSynonym_max_fields_nhtsa';
  groupName?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ConcernSynonym_Min_Fields_Nhtsa = {
  __typename?: 'concernSynonym_min_fields_nhtsa';
  groupName?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "nhtsa.concern_synonym" */
export type ConcernSynonym_Mutation_Response_Nhtsa = {
  __typename?: 'concernSynonym_mutation_response_nhtsa';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConcernSynonym_Nhtsa>;
};

/** Automotive terms treated as equivalent when matching an adjuster's concern text: a concern containing any term of a group matches records containing any other. Multi-word terms match as phrases. */
export type ConcernSynonym_Nhtsa = {
  __typename?: 'concernSynonym_nhtsa';
  groupName: Scalars['String'];
  term: Scalars['String'];
};

/** on_conflict condition type for table "nhtsa.concern_synonym" */
export type ConcernSynonym_On_Conflict_Nhtsa = {
  constraint: ConcernSynonym_Constraint_Nhtsa;
  update_columns?: Array<ConcernSynonym_Update_Column_Nhtsa>;
  where?: InputMaybe<ConcernSynonym_Bool_Exp_Nhtsa>;
};

/** Ordering options when selecting data from "nhtsa.concern_synonym". */
export type ConcernSynonym_Order_By_Nhtsa = {
  groupName?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nhtsa.concern_synonym */
export type ConcernSynonym_Pk_Columns_Input_Nhtsa = {
  groupName: Scalars['String'];
  term: Scalars['String'];
};

/** select columns of table "nhtsa.concern_synonym" */
export enum ConcernSynonym_Select_Column_Nhtsa {
  /** column name */
  GroupName = 'groupName',
  /** column name */
  Term = 'term'
}

/** input type for updating data in table "nhtsa.concern_synonym" */
export type ConcernSynonym_Set_Input_Nhtsa = {
  groupName?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "concernSynonym" */
export type ConcernSynonym_Stream_Cursor_Input_Nhtsa = {
  /** Stream column input with initial value */
  initial_value: ConcernSynonym_Stream_Cursor_Value_Input_Nhtsa;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Nhtsa>;
};

/** Initial value of the column from where the streaming should start */
export type ConcernSynonym_Stream_Cursor_Value_Input_Nhtsa = {
  groupName?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

/** update columns of table "nhtsa.concern_synonym" */
export enum ConcernSynonym_Update_Column_Nhtsa {
  /** column name */
  GroupName = 'groupName',
  /** column name */
  Term = 'term'
}

export type ConcernSynonym_Updates_Nhtsa = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConcernSynonym_Set_Input_Nhtsa>;
  /** filter the rows which have to be updated */
  where: ConcernSynonym_Bool_Exp_Nhtsa;
};

/** columns and relationships of "configuration_item" */
export type ConfigurationItem = {
  __typename?: 'configurationItem';
  /** An object relationship */
  configurationItemType: ConfigurationItemType;
  configurationItemTypeId: Scalars['Int'];
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** This is where we store global defaults for configurations. */
  defaultValue?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  entityConfigurationItems: Array<EntityConfigurationItem>;
  /** An aggregate relationship */
  entityConfigurationItems_aggregate: EntityConfigurationItem_Aggregate;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "configuration_item" */
export type ConfigurationItemEntityConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "configuration_item" */
export type ConfigurationItemEntityConfigurationItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};

/** columns and relationships of "configuration_item_type" */
export type ConfigurationItemType = {
  __typename?: 'configurationItemType';
  /** An array relationship */
  configurationItems: Array<ConfigurationItem>;
  /** An aggregate relationship */
  configurationItems_aggregate: ConfigurationItem_Aggregate;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "configuration_item_type" */
export type ConfigurationItemTypeConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<ConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigurationItem_Order_By>>;
  where?: InputMaybe<ConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "configuration_item_type" */
export type ConfigurationItemTypeConfigurationItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigurationItem_Order_By>>;
  where?: InputMaybe<ConfigurationItem_Bool_Exp>;
};

/** aggregated selection of "configuration_item_type" */
export type ConfigurationItemType_Aggregate = {
  __typename?: 'configurationItemType_aggregate';
  aggregate?: Maybe<ConfigurationItemType_Aggregate_Fields>;
  nodes: Array<ConfigurationItemType>;
};

/** aggregate fields of "configuration_item_type" */
export type ConfigurationItemType_Aggregate_Fields = {
  __typename?: 'configurationItemType_aggregate_fields';
  avg?: Maybe<ConfigurationItemType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ConfigurationItemType_Max_Fields>;
  min?: Maybe<ConfigurationItemType_Min_Fields>;
  stddev?: Maybe<ConfigurationItemType_Stddev_Fields>;
  stddev_pop?: Maybe<ConfigurationItemType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConfigurationItemType_Stddev_Samp_Fields>;
  sum?: Maybe<ConfigurationItemType_Sum_Fields>;
  var_pop?: Maybe<ConfigurationItemType_Var_Pop_Fields>;
  var_samp?: Maybe<ConfigurationItemType_Var_Samp_Fields>;
  variance?: Maybe<ConfigurationItemType_Variance_Fields>;
};


/** aggregate fields of "configuration_item_type" */
export type ConfigurationItemType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConfigurationItemType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ConfigurationItemType_Avg_Fields = {
  __typename?: 'configurationItemType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "configuration_item_type". All fields are combined with a logical 'AND'. */
export type ConfigurationItemType_Bool_Exp = {
  _and?: InputMaybe<Array<ConfigurationItemType_Bool_Exp>>;
  _not?: InputMaybe<ConfigurationItemType_Bool_Exp>;
  _or?: InputMaybe<Array<ConfigurationItemType_Bool_Exp>>;
  configurationItems?: InputMaybe<ConfigurationItem_Bool_Exp>;
  configurationItems_aggregate?: InputMaybe<ConfigurationItem_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "configuration_item_type" */
export enum ConfigurationItemType_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConfigurationItemTypePkey = 'configuration_item_type_pkey'
}

/** input type for incrementing numeric columns in table "configuration_item_type" */
export type ConfigurationItemType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "configuration_item_type" */
export type ConfigurationItemType_Insert_Input = {
  configurationItems?: InputMaybe<ConfigurationItem_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ConfigurationItemType_Max_Fields = {
  __typename?: 'configurationItemType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ConfigurationItemType_Min_Fields = {
  __typename?: 'configurationItemType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "configuration_item_type" */
export type ConfigurationItemType_Mutation_Response = {
  __typename?: 'configurationItemType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConfigurationItemType>;
};

/** input type for inserting object relation for remote table "configuration_item_type" */
export type ConfigurationItemType_Obj_Rel_Insert_Input = {
  data: ConfigurationItemType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ConfigurationItemType_On_Conflict>;
};

/** on_conflict condition type for table "configuration_item_type" */
export type ConfigurationItemType_On_Conflict = {
  constraint: ConfigurationItemType_Constraint;
  update_columns?: Array<ConfigurationItemType_Update_Column>;
  where?: InputMaybe<ConfigurationItemType_Bool_Exp>;
};

/** Ordering options when selecting data from "configuration_item_type". */
export type ConfigurationItemType_Order_By = {
  configurationItems_aggregate?: InputMaybe<ConfigurationItem_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: configuration_item_type */
export type ConfigurationItemType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "configuration_item_type" */
export enum ConfigurationItemType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "configuration_item_type" */
export type ConfigurationItemType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ConfigurationItemType_Stddev_Fields = {
  __typename?: 'configurationItemType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ConfigurationItemType_Stddev_Pop_Fields = {
  __typename?: 'configurationItemType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ConfigurationItemType_Stddev_Samp_Fields = {
  __typename?: 'configurationItemType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "configurationItemType" */
export type ConfigurationItemType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConfigurationItemType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConfigurationItemType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ConfigurationItemType_Sum_Fields = {
  __typename?: 'configurationItemType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "configuration_item_type" */
export enum ConfigurationItemType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ConfigurationItemType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConfigurationItemType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConfigurationItemType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConfigurationItemType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConfigurationItemType_Var_Pop_Fields = {
  __typename?: 'configurationItemType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ConfigurationItemType_Var_Samp_Fields = {
  __typename?: 'configurationItemType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ConfigurationItemType_Variance_Fields = {
  __typename?: 'configurationItemType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "configuration_item" */
export type ConfigurationItem_Aggregate = {
  __typename?: 'configurationItem_aggregate';
  aggregate?: Maybe<ConfigurationItem_Aggregate_Fields>;
  nodes: Array<ConfigurationItem>;
};

export type ConfigurationItem_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConfigurationItem_Aggregate_Bool_Exp_Count>;
};

export type ConfigurationItem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConfigurationItem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ConfigurationItem_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "configuration_item" */
export type ConfigurationItem_Aggregate_Fields = {
  __typename?: 'configurationItem_aggregate_fields';
  avg?: Maybe<ConfigurationItem_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ConfigurationItem_Max_Fields>;
  min?: Maybe<ConfigurationItem_Min_Fields>;
  stddev?: Maybe<ConfigurationItem_Stddev_Fields>;
  stddev_pop?: Maybe<ConfigurationItem_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConfigurationItem_Stddev_Samp_Fields>;
  sum?: Maybe<ConfigurationItem_Sum_Fields>;
  var_pop?: Maybe<ConfigurationItem_Var_Pop_Fields>;
  var_samp?: Maybe<ConfigurationItem_Var_Samp_Fields>;
  variance?: Maybe<ConfigurationItem_Variance_Fields>;
};


/** aggregate fields of "configuration_item" */
export type ConfigurationItem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConfigurationItem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "configuration_item" */
export type ConfigurationItem_Aggregate_Order_By = {
  avg?: InputMaybe<ConfigurationItem_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConfigurationItem_Max_Order_By>;
  min?: InputMaybe<ConfigurationItem_Min_Order_By>;
  stddev?: InputMaybe<ConfigurationItem_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ConfigurationItem_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ConfigurationItem_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ConfigurationItem_Sum_Order_By>;
  var_pop?: InputMaybe<ConfigurationItem_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ConfigurationItem_Var_Samp_Order_By>;
  variance?: InputMaybe<ConfigurationItem_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "configuration_item" */
export type ConfigurationItem_Arr_Rel_Insert_Input = {
  data: Array<ConfigurationItem_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConfigurationItem_On_Conflict>;
};

/** aggregate avg on columns */
export type ConfigurationItem_Avg_Fields = {
  __typename?: 'configurationItem_avg_fields';
  configurationItemTypeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "configuration_item" */
export type ConfigurationItem_Avg_Order_By = {
  configurationItemTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "configuration_item". All fields are combined with a logical 'AND'. */
export type ConfigurationItem_Bool_Exp = {
  _and?: InputMaybe<Array<ConfigurationItem_Bool_Exp>>;
  _not?: InputMaybe<ConfigurationItem_Bool_Exp>;
  _or?: InputMaybe<Array<ConfigurationItem_Bool_Exp>>;
  configurationItemType?: InputMaybe<ConfigurationItemType_Bool_Exp>;
  configurationItemTypeId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  defaultValue?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "configuration_item" */
export enum ConfigurationItem_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConfigurationItemPkey = 'configuration_item_pkey'
}

/** input type for incrementing numeric columns in table "configuration_item" */
export type ConfigurationItem_Inc_Input = {
  configurationItemTypeId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "configuration_item" */
export type ConfigurationItem_Insert_Input = {
  configurationItemType?: InputMaybe<ConfigurationItemType_Obj_Rel_Insert_Input>;
  configurationItemTypeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** This is where we store global defaults for configurations. */
  defaultValue?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ConfigurationItem_Max_Fields = {
  __typename?: 'configurationItem_max_fields';
  configurationItemTypeId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** This is where we store global defaults for configurations. */
  defaultValue?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "configuration_item" */
export type ConfigurationItem_Max_Order_By = {
  configurationItemTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** This is where we store global defaults for configurations. */
  defaultValue?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConfigurationItem_Min_Fields = {
  __typename?: 'configurationItem_min_fields';
  configurationItemTypeId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** This is where we store global defaults for configurations. */
  defaultValue?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "configuration_item" */
export type ConfigurationItem_Min_Order_By = {
  configurationItemTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** This is where we store global defaults for configurations. */
  defaultValue?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "configuration_item" */
export type ConfigurationItem_Mutation_Response = {
  __typename?: 'configurationItem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConfigurationItem>;
};

/** input type for inserting object relation for remote table "configuration_item" */
export type ConfigurationItem_Obj_Rel_Insert_Input = {
  data: ConfigurationItem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ConfigurationItem_On_Conflict>;
};

/** on_conflict condition type for table "configuration_item" */
export type ConfigurationItem_On_Conflict = {
  constraint: ConfigurationItem_Constraint;
  update_columns?: Array<ConfigurationItem_Update_Column>;
  where?: InputMaybe<ConfigurationItem_Bool_Exp>;
};

/** Ordering options when selecting data from "configuration_item". */
export type ConfigurationItem_Order_By = {
  configurationItemType?: InputMaybe<ConfigurationItemType_Order_By>;
  configurationItemTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defaultValue?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: configuration_item */
export type ConfigurationItem_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "configuration_item" */
export enum ConfigurationItem_Select_Column {
  /** column name */
  ConfigurationItemTypeId = 'configurationItemTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultValue = 'defaultValue',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "configuration_item" */
export type ConfigurationItem_Set_Input = {
  configurationItemTypeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** This is where we store global defaults for configurations. */
  defaultValue?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ConfigurationItem_Stddev_Fields = {
  __typename?: 'configurationItem_stddev_fields';
  configurationItemTypeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "configuration_item" */
export type ConfigurationItem_Stddev_Order_By = {
  configurationItemTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ConfigurationItem_Stddev_Pop_Fields = {
  __typename?: 'configurationItem_stddev_pop_fields';
  configurationItemTypeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "configuration_item" */
export type ConfigurationItem_Stddev_Pop_Order_By = {
  configurationItemTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ConfigurationItem_Stddev_Samp_Fields = {
  __typename?: 'configurationItem_stddev_samp_fields';
  configurationItemTypeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "configuration_item" */
export type ConfigurationItem_Stddev_Samp_Order_By = {
  configurationItemTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "configurationItem" */
export type ConfigurationItem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConfigurationItem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConfigurationItem_Stream_Cursor_Value_Input = {
  configurationItemTypeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** This is where we store global defaults for configurations. */
  defaultValue?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ConfigurationItem_Sum_Fields = {
  __typename?: 'configurationItem_sum_fields';
  configurationItemTypeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "configuration_item" */
export type ConfigurationItem_Sum_Order_By = {
  configurationItemTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "configuration_item" */
export enum ConfigurationItem_Update_Column {
  /** column name */
  ConfigurationItemTypeId = 'configurationItemTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultValue = 'defaultValue',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ConfigurationItem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConfigurationItem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConfigurationItem_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConfigurationItem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConfigurationItem_Var_Pop_Fields = {
  __typename?: 'configurationItem_var_pop_fields';
  configurationItemTypeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "configuration_item" */
export type ConfigurationItem_Var_Pop_Order_By = {
  configurationItemTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ConfigurationItem_Var_Samp_Fields = {
  __typename?: 'configurationItem_var_samp_fields';
  configurationItemTypeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "configuration_item" */
export type ConfigurationItem_Var_Samp_Order_By = {
  configurationItemTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ConfigurationItem_Variance_Fields = {
  __typename?: 'configurationItem_variance_fields';
  configurationItemTypeId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "configuration_item" */
export type ConfigurationItem_Variance_Order_By = {
  configurationItemTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "contact" */
export type Contact = {
  __typename?: 'contact';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  accountManager?: Maybe<AccountManager>;
  /** An array relationship */
  addresses: Array<Address>;
  /** An aggregate relationship */
  addresses_aggregate: Address_Aggregate;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** An object relationship */
  entityTags?: Maybe<EntityTag>;
  fax?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** Array of strings built from the contact name split on spaces and uppercase. */
  keywordsMetadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  obligors: Array<Obligor>;
  /** An aggregate relationship */
  obligors_aggregate: Obligor_Aggregate;
  parentId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment?: Maybe<Payment>;
  phone?: Maybe<Scalars['String']>;
  /** An array relationship */
  policyClaimInsurances: Array<PolicyClaimInsurance>;
  /** An aggregate relationship */
  policyClaimInsurances_aggregate: PolicyClaimInsurance_Aggregate;
  /** An array relationship */
  policyContractLenders: Array<PolicyContractLender>;
  /** An aggregate relationship */
  policyContractLenders_aggregate: PolicyContractLender_Aggregate;
  /** An array relationship */
  policyContractOwners: Array<PolicyContractOwner>;
  /** An aggregate relationship */
  policyContractOwners_aggregate: PolicyContractOwner_Aggregate;
  /** An array relationship */
  serviceCenters: Array<ServiceCenter>;
  /** An aggregate relationship */
  serviceCenters_aggregate: ServiceCenter_Aggregate;
  updatedAt: Scalars['timestamp'];
};


/** columns and relationships of "contact" */
export type ContactAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactKeywordsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "contact" */
export type ContactLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactObligorsArgs = {
  distinct_on?: InputMaybe<Array<Obligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Obligor_Order_By>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactObligors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Obligor_Order_By>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactPolicyClaimInsurancesArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimInsurance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimInsurance_Order_By>>;
  where?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactPolicyClaimInsurances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimInsurance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimInsurance_Order_By>>;
  where?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactPolicyContractLendersArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLender_Order_By>>;
  where?: InputMaybe<PolicyContractLender_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactPolicyContractLenders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLender_Order_By>>;
  where?: InputMaybe<PolicyContractLender_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactPolicyContractOwnersArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractOwner_Order_By>>;
  where?: InputMaybe<PolicyContractOwner_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactPolicyContractOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractOwner_Order_By>>;
  where?: InputMaybe<PolicyContractOwner_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


/** columns and relationships of "contact" */
export type ContactServiceCenters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};

/** aggregated selection of "contact" */
export type Contact_Aggregate = {
  __typename?: 'contact_aggregate';
  aggregate?: Maybe<Contact_Aggregate_Fields>;
  nodes: Array<Contact>;
};

export type Contact_Aggregate_Bool_Exp = {
  count?: InputMaybe<Contact_Aggregate_Bool_Exp_Count>;
};

export type Contact_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Contact_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contact" */
export type Contact_Aggregate_Fields = {
  __typename?: 'contact_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Contact_Max_Fields>;
  min?: Maybe<Contact_Min_Fields>;
};


/** aggregate fields of "contact" */
export type Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contact" */
export type Contact_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contact_Max_Order_By>;
  min?: InputMaybe<Contact_Min_Order_By>;
};

/** input type for inserting array relation for remote table "contact" */
export type Contact_Arr_Rel_Insert_Input = {
  data: Array<Contact_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};

/** Boolean expression to filter rows from the table "contact". All fields are combined with a logical 'AND'. */
export type Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_Bool_Exp>>;
  _not?: InputMaybe<Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Contact_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountManager?: InputMaybe<AccountManager_Bool_Exp>;
  addresses?: InputMaybe<Address_Bool_Exp>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  fax?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  keywordsMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  obligors?: InputMaybe<Obligor_Bool_Exp>;
  obligors_aggregate?: InputMaybe<Obligor_Aggregate_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  payment?: InputMaybe<Payment_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  policyClaimInsurances?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
  policyClaimInsurances_aggregate?: InputMaybe<PolicyClaimInsurance_Aggregate_Bool_Exp>;
  policyContractLenders?: InputMaybe<PolicyContractLender_Bool_Exp>;
  policyContractLenders_aggregate?: InputMaybe<PolicyContractLender_Aggregate_Bool_Exp>;
  policyContractOwners?: InputMaybe<PolicyContractOwner_Bool_Exp>;
  policyContractOwners_aggregate?: InputMaybe<PolicyContractOwner_Aggregate_Bool_Exp>;
  serviceCenters?: InputMaybe<ServiceCenter_Bool_Exp>;
  serviceCenters_aggregate?: InputMaybe<ServiceCenter_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "contact" */
export enum Contact_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContactPkey = 'contact_pkey'
}

/** input type for inserting data into table "contact" */
export type Contact_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountManager?: InputMaybe<AccountManager_Obj_Rel_Insert_Input>;
  addresses?: InputMaybe<Address_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  entityTags?: InputMaybe<EntityTag_Obj_Rel_Insert_Input>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  obligors?: InputMaybe<Obligor_Arr_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['uuid']>;
  payment?: InputMaybe<Payment_Obj_Rel_Insert_Input>;
  phone?: InputMaybe<Scalars['String']>;
  policyClaimInsurances?: InputMaybe<PolicyClaimInsurance_Arr_Rel_Insert_Input>;
  policyContractLenders?: InputMaybe<PolicyContractLender_Arr_Rel_Insert_Input>;
  policyContractOwners?: InputMaybe<PolicyContractOwner_Arr_Rel_Insert_Input>;
  serviceCenters?: InputMaybe<ServiceCenter_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Contact_Max_Fields = {
  __typename?: 'contact_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "contact" */
export type Contact_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  fax?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contact_Min_Fields = {
  __typename?: 'contact_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "contact" */
export type Contact_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  fax?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "contact" */
export type Contact_Mutation_Response = {
  __typename?: 'contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contact>;
};

/** input type for inserting object relation for remote table "contact" */
export type Contact_Obj_Rel_Insert_Input = {
  data: Contact_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};

/** on_conflict condition type for table "contact" */
export type Contact_On_Conflict = {
  constraint: Contact_Constraint;
  update_columns?: Array<Contact_Update_Column>;
  where?: InputMaybe<Contact_Bool_Exp>;
};

/** Ordering options when selecting data from "contact". */
export type Contact_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountManager?: InputMaybe<AccountManager_Order_By>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  entityTags?: InputMaybe<EntityTag_Order_By>;
  fax?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keywordsMetadata?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  obligors_aggregate?: InputMaybe<Obligor_Aggregate_Order_By>;
  parentId?: InputMaybe<Order_By>;
  payment?: InputMaybe<Payment_Order_By>;
  phone?: InputMaybe<Order_By>;
  policyClaimInsurances_aggregate?: InputMaybe<PolicyClaimInsurance_Aggregate_Order_By>;
  policyContractLenders_aggregate?: InputMaybe<PolicyContractLender_Aggregate_Order_By>;
  policyContractOwners_aggregate?: InputMaybe<PolicyContractOwner_Aggregate_Order_By>;
  serviceCenters_aggregate?: InputMaybe<ServiceCenter_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contact */
export type Contact_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "contact" */
export enum Contact_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Fax = 'fax',
  /** column name */
  Id = 'id',
  /** column name */
  KeywordsMetadata = 'keywordsMetadata',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "contact" */
export type Contact_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "contact" */
export type Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Array of strings built from the contact name split on spaces and uppercase. */
  keywordsMetadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "contact" */
export enum Contact_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Fax = 'fax',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Contact_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contact_Bool_Exp;
};

/** Stores the various content types we will use to describe files and documents */
export type ContentType = {
  __typename?: 'contentType';
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  /** An array relationship */
  entityContentTypes: Array<EntityContentType>;
  /** An aggregate relationship */
  entityContentTypes_aggregate: EntityContentType_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** Currently, this is the id of the related "Claim Type" row in the shared.type table. */
  parentId?: Maybe<Scalars['uuid']>;
  sortOrder?: Maybe<Scalars['Int']>;
  /** An object relationship */
  type?: Maybe<Type>;
  updatedAt: Scalars['timestamptz'];
};


/** Stores the various content types we will use to describe files and documents */
export type ContentTypeEntityContentTypesArgs = {
  distinct_on?: InputMaybe<Array<EntityContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityContentType_Order_By>>;
  where?: InputMaybe<EntityContentType_Bool_Exp>;
};


/** Stores the various content types we will use to describe files and documents */
export type ContentTypeEntityContentTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityContentType_Order_By>>;
  where?: InputMaybe<EntityContentType_Bool_Exp>;
};

/** aggregated selection of "shared.content_type" */
export type ContentType_Aggregate = {
  __typename?: 'contentType_aggregate';
  aggregate?: Maybe<ContentType_Aggregate_Fields>;
  nodes: Array<ContentType>;
};

export type ContentType_Aggregate_Bool_Exp = {
  count?: InputMaybe<ContentType_Aggregate_Bool_Exp_Count>;
};

export type ContentType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ContentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.content_type" */
export type ContentType_Aggregate_Fields = {
  __typename?: 'contentType_aggregate_fields';
  avg?: Maybe<ContentType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ContentType_Max_Fields>;
  min?: Maybe<ContentType_Min_Fields>;
  stddev?: Maybe<ContentType_Stddev_Fields>;
  stddev_pop?: Maybe<ContentType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ContentType_Stddev_Samp_Fields>;
  sum?: Maybe<ContentType_Sum_Fields>;
  var_pop?: Maybe<ContentType_Var_Pop_Fields>;
  var_samp?: Maybe<ContentType_Var_Samp_Fields>;
  variance?: Maybe<ContentType_Variance_Fields>;
};


/** aggregate fields of "shared.content_type" */
export type ContentType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ContentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.content_type" */
export type ContentType_Aggregate_Order_By = {
  avg?: InputMaybe<ContentType_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ContentType_Max_Order_By>;
  min?: InputMaybe<ContentType_Min_Order_By>;
  stddev?: InputMaybe<ContentType_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ContentType_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ContentType_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ContentType_Sum_Order_By>;
  var_pop?: InputMaybe<ContentType_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ContentType_Var_Samp_Order_By>;
  variance?: InputMaybe<ContentType_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shared.content_type" */
export type ContentType_Arr_Rel_Insert_Input = {
  data: Array<ContentType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentType_On_Conflict>;
};

/** aggregate avg on columns */
export type ContentType_Avg_Fields = {
  __typename?: 'contentType_avg_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shared.content_type" */
export type ContentType_Avg_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shared.content_type". All fields are combined with a logical 'AND'. */
export type ContentType_Bool_Exp = {
  _and?: InputMaybe<Array<ContentType_Bool_Exp>>;
  _not?: InputMaybe<ContentType_Bool_Exp>;
  _or?: InputMaybe<Array<ContentType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  entityContentTypes?: InputMaybe<EntityContentType_Bool_Exp>;
  entityContentTypes_aggregate?: InputMaybe<EntityContentType_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Type_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.content_type" */
export enum ContentType_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContentTypePkey = 'content_type_pkey'
}

/** input type for incrementing numeric columns in table "shared.content_type" */
export type ContentType_Inc_Input = {
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shared.content_type" */
export type ContentType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  entityContentTypes?: InputMaybe<EntityContentType_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** Currently, this is the id of the related "Claim Type" row in the shared.type table. */
  parentId?: InputMaybe<Scalars['uuid']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ContentType_Max_Fields = {
  __typename?: 'contentType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** Currently, this is the id of the related "Claim Type" row in the shared.type table. */
  parentId?: Maybe<Scalars['uuid']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.content_type" */
export type ContentType_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Currently, this is the id of the related "Claim Type" row in the shared.type table. */
  parentId?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ContentType_Min_Fields = {
  __typename?: 'contentType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** Currently, this is the id of the related "Claim Type" row in the shared.type table. */
  parentId?: Maybe<Scalars['uuid']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.content_type" */
export type ContentType_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Currently, this is the id of the related "Claim Type" row in the shared.type table. */
  parentId?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.content_type" */
export type ContentType_Mutation_Response = {
  __typename?: 'contentType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentType>;
};

/** input type for inserting object relation for remote table "shared.content_type" */
export type ContentType_Obj_Rel_Insert_Input = {
  data: ContentType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentType_On_Conflict>;
};

/** on_conflict condition type for table "shared.content_type" */
export type ContentType_On_Conflict = {
  constraint: ContentType_Constraint;
  update_columns?: Array<ContentType_Update_Column>;
  where?: InputMaybe<ContentType_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.content_type". */
export type ContentType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  entityContentTypes_aggregate?: InputMaybe<EntityContentType_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  type?: InputMaybe<Type_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.content_type */
export type ContentType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.content_type" */
export enum ContentType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.content_type" */
export type ContentType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** Currently, this is the id of the related "Claim Type" row in the shared.type table. */
  parentId?: InputMaybe<Scalars['uuid']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ContentType_Stddev_Fields = {
  __typename?: 'contentType_stddev_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shared.content_type" */
export type ContentType_Stddev_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ContentType_Stddev_Pop_Fields = {
  __typename?: 'contentType_stddev_pop_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shared.content_type" */
export type ContentType_Stddev_Pop_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ContentType_Stddev_Samp_Fields = {
  __typename?: 'contentType_stddev_samp_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shared.content_type" */
export type ContentType_Stddev_Samp_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "contentType" */
export type ContentType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ContentType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** Currently, this is the id of the related "Claim Type" row in the shared.type table. */
  parentId?: InputMaybe<Scalars['uuid']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ContentType_Sum_Fields = {
  __typename?: 'contentType_sum_fields';
  sortOrder?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "shared.content_type" */
export type ContentType_Sum_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** update columns of table "shared.content_type" */
export enum ContentType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ContentType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ContentType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ContentType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ContentType_Var_Pop_Fields = {
  __typename?: 'contentType_var_pop_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shared.content_type" */
export type ContentType_Var_Pop_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ContentType_Var_Samp_Fields = {
  __typename?: 'contentType_var_samp_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shared.content_type" */
export type ContentType_Var_Samp_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ContentType_Variance_Fields = {
  __typename?: 'contentType_variance_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shared.content_type" */
export type ContentType_Variance_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
};

/** columns and relationships of "contract" */
export type Contract = {
  __typename?: 'contract';
  /** An array relationship */
  claims: Array<Claim>;
  /** An aggregate relationship */
  claims_aggregate: Claim_Aggregate;
  contractNumber: Scalars['String'];
  /** An object relationship */
  contractStatusType: ContractStatusType;
  contractStatusTypeEnumValue: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  dealer: Legacy_Claims_Dealer;
  dealerId: Scalars['uuid'];
  deductibleAmount: Scalars['numeric'];
  deductibleType: Scalars['String'];
  expirationDate: Scalars['date'];
  expirationMileageAmount: Scalars['numeric'];
  id: Scalars['uuid'];
  /** An array relationship */
  notes: Array<Legacy_Claims_Note>;
  /** An aggregate relationship */
  notes_aggregate: Legacy_Claims_Note_Aggregate;
  planName: Scalars['String'];
  planTerms: Scalars['String'];
  /** An object relationship */
  primaryCustomer: Customer;
  primaryCustomerId: Scalars['uuid'];
  purchasePriceAmount: Scalars['numeric'];
  /** An object relationship */
  secondaryCustomer?: Maybe<Customer>;
  secondaryCustomerId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  vehicle: Vehicle;
  vehicleId: Scalars['uuid'];
};


/** columns and relationships of "contract" */
export type ContractClaimsArgs = {
  distinct_on?: InputMaybe<Array<Claim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claim_Order_By>>;
  where?: InputMaybe<Claim_Bool_Exp>;
};


/** columns and relationships of "contract" */
export type ContractClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Claim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claim_Order_By>>;
  where?: InputMaybe<Claim_Bool_Exp>;
};


/** columns and relationships of "contract" */
export type ContractNotesArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Claims_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Claims_Note_Order_By>>;
  where?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
};


/** columns and relationships of "contract" */
export type ContractNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Claims_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Claims_Note_Order_By>>;
  where?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
};

/** columns and relationships of "compliance.contract_form" */
export type ContractForm = {
  __typename?: 'contractForm';
  composeOrder: Scalars['Int'];
  /** An object relationship */
  contractFormType: ContractFormType;
  contractFormTypeId: Scalars['uuid'];
  /** An array relationship */
  contractFormVersions: Array<ContractFormVersion>;
  /** An aggregate relationship */
  contractFormVersions_aggregate: ContractFormVersion_Aggregate;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityEligibilityRules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entityEligibilityRules_aggregate: EntityEligibilityRule_Aggregate;
  /** An array relationship */
  entityNote: Array<EntityNote>;
  /** An aggregate relationship */
  entityNote_aggregate: EntityNote_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  formNumber?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  productContractForms: Array<ProductContractForm>;
  /** An aggregate relationship */
  productContractForms_aggregate: ProductContractForm_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "compliance.contract_form" */
export type ContractFormContractFormVersionsArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersion_Order_By>>;
  where?: InputMaybe<ContractFormVersion_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form" */
export type ContractFormContractFormVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersion_Order_By>>;
  where?: InputMaybe<ContractFormVersion_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form" */
export type ContractFormEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form" */
export type ContractFormEntityEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form" */
export type ContractFormEntityNoteArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form" */
export type ContractFormEntityNote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form" */
export type ContractFormProductContractFormsArgs = {
  distinct_on?: InputMaybe<Array<ProductContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductContractForm_Order_By>>;
  where?: InputMaybe<ProductContractForm_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form" */
export type ContractFormProductContractForms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductContractForm_Order_By>>;
  where?: InputMaybe<ProductContractForm_Bool_Exp>;
};

/** columns and relationships of "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus = {
  __typename?: 'contractFormFilingStatus';
  approvedDate?: Maybe<Scalars['date']>;
  approvedDateDeprecated?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contractFormVersion?: Maybe<ContractFormVersion>;
  contractFormVersionId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  /** First purchase date this Filing can be sold. Empty means not live, even when Approved. Distinct from approved_date, which only records when the regulator or lender approved it. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  /** Last purchase date this Filing can be sold. Empty means open-ended. After it, the sale falls back to the next qualifying Contract Form Version. */
  expirationDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  filingLender?: Maybe<FilingLender>;
  filingLenderId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  filingState?: Maybe<FilingState>;
  filingStateId: Scalars['uuid'];
  /** An object relationship */
  filingStatusType?: Maybe<FilingStatusType>;
  filingStatusTypeId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  rejectedDate?: Maybe<Scalars['date']>;
  resubmittedDate?: Maybe<Scalars['date']>;
  submittedDate?: Maybe<Scalars['date']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "compliance.contract_form_filing_status" */
export type ContractFormFilingStatusEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_filing_status" */
export type ContractFormFilingStatusEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};

/** aggregated selection of "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Aggregate = {
  __typename?: 'contractFormFilingStatus_aggregate';
  aggregate?: Maybe<ContractFormFilingStatus_Aggregate_Fields>;
  nodes: Array<ContractFormFilingStatus>;
};

export type ContractFormFilingStatus_Aggregate_Bool_Exp = {
  count?: InputMaybe<ContractFormFilingStatus_Aggregate_Bool_Exp_Count>;
};

export type ContractFormFilingStatus_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Aggregate_Fields = {
  __typename?: 'contractFormFilingStatus_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ContractFormFilingStatus_Max_Fields>;
  min?: Maybe<ContractFormFilingStatus_Min_Fields>;
};


/** aggregate fields of "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ContractFormFilingStatus_Max_Order_By>;
  min?: InputMaybe<ContractFormFilingStatus_Min_Order_By>;
};

/** input type for inserting array relation for remote table "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Arr_Rel_Insert_Input = {
  data: Array<ContractFormFilingStatus_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ContractFormFilingStatus_On_Conflict>;
};

/** Boolean expression to filter rows from the table "compliance.contract_form_filing_status". All fields are combined with a logical 'AND'. */
export type ContractFormFilingStatus_Bool_Exp = {
  _and?: InputMaybe<Array<ContractFormFilingStatus_Bool_Exp>>;
  _not?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
  _or?: InputMaybe<Array<ContractFormFilingStatus_Bool_Exp>>;
  approvedDate?: InputMaybe<Date_Comparison_Exp>;
  approvedDateDeprecated?: InputMaybe<Uuid_Comparison_Exp>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Bool_Exp>;
  contractFormVersionId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  filingLender?: InputMaybe<FilingLender_Bool_Exp>;
  filingLenderId?: InputMaybe<Uuid_Comparison_Exp>;
  filingState?: InputMaybe<FilingState_Bool_Exp>;
  filingStateId?: InputMaybe<Uuid_Comparison_Exp>;
  filingStatusType?: InputMaybe<FilingStatusType_Bool_Exp>;
  filingStatusTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rejectedDate?: InputMaybe<Date_Comparison_Exp>;
  resubmittedDate?: InputMaybe<Date_Comparison_Exp>;
  submittedDate?: InputMaybe<Date_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.contract_form_filing_status" */
export enum ContractFormFilingStatus_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractFormFilingStatusPkey = 'contract_form_filing_status_pkey'
}

/** input type for inserting data into table "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Insert_Input = {
  approvedDate?: InputMaybe<Scalars['date']>;
  approvedDateDeprecated?: InputMaybe<Scalars['uuid']>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Obj_Rel_Insert_Input>;
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** First purchase date this Filing can be sold. Empty means not live, even when Approved. Distinct from approved_date, which only records when the regulator or lender approved it. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  /** Last purchase date this Filing can be sold. Empty means open-ended. After it, the sale falls back to the next qualifying Contract Form Version. */
  expirationDate?: InputMaybe<Scalars['date']>;
  filingLender?: InputMaybe<FilingLender_Obj_Rel_Insert_Input>;
  filingLenderId?: InputMaybe<Scalars['uuid']>;
  filingState?: InputMaybe<FilingState_Obj_Rel_Insert_Input>;
  filingStateId?: InputMaybe<Scalars['uuid']>;
  filingStatusType?: InputMaybe<FilingStatusType_Obj_Rel_Insert_Input>;
  filingStatusTypeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  rejectedDate?: InputMaybe<Scalars['date']>;
  resubmittedDate?: InputMaybe<Scalars['date']>;
  submittedDate?: InputMaybe<Scalars['date']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ContractFormFilingStatus_Max_Fields = {
  __typename?: 'contractFormFilingStatus_max_fields';
  approvedDate?: Maybe<Scalars['date']>;
  approvedDateDeprecated?: Maybe<Scalars['uuid']>;
  contractFormVersionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** First purchase date this Filing can be sold. Empty means not live, even when Approved. Distinct from approved_date, which only records when the regulator or lender approved it. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** Last purchase date this Filing can be sold. Empty means open-ended. After it, the sale falls back to the next qualifying Contract Form Version. */
  expirationDate?: Maybe<Scalars['date']>;
  filingLenderId?: Maybe<Scalars['uuid']>;
  filingStateId?: Maybe<Scalars['uuid']>;
  filingStatusTypeId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  rejectedDate?: Maybe<Scalars['date']>;
  resubmittedDate?: Maybe<Scalars['date']>;
  submittedDate?: Maybe<Scalars['date']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Max_Order_By = {
  approvedDate?: InputMaybe<Order_By>;
  approvedDateDeprecated?: InputMaybe<Order_By>;
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** First purchase date this Filing can be sold. Empty means not live, even when Approved. Distinct from approved_date, which only records when the regulator or lender approved it. */
  effectiveDate?: InputMaybe<Order_By>;
  /** Last purchase date this Filing can be sold. Empty means open-ended. After it, the sale falls back to the next qualifying Contract Form Version. */
  expirationDate?: InputMaybe<Order_By>;
  filingLenderId?: InputMaybe<Order_By>;
  filingStateId?: InputMaybe<Order_By>;
  filingStatusTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejectedDate?: InputMaybe<Order_By>;
  resubmittedDate?: InputMaybe<Order_By>;
  submittedDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ContractFormFilingStatus_Min_Fields = {
  __typename?: 'contractFormFilingStatus_min_fields';
  approvedDate?: Maybe<Scalars['date']>;
  approvedDateDeprecated?: Maybe<Scalars['uuid']>;
  contractFormVersionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** First purchase date this Filing can be sold. Empty means not live, even when Approved. Distinct from approved_date, which only records when the regulator or lender approved it. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** Last purchase date this Filing can be sold. Empty means open-ended. After it, the sale falls back to the next qualifying Contract Form Version. */
  expirationDate?: Maybe<Scalars['date']>;
  filingLenderId?: Maybe<Scalars['uuid']>;
  filingStateId?: Maybe<Scalars['uuid']>;
  filingStatusTypeId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  rejectedDate?: Maybe<Scalars['date']>;
  resubmittedDate?: Maybe<Scalars['date']>;
  submittedDate?: Maybe<Scalars['date']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Min_Order_By = {
  approvedDate?: InputMaybe<Order_By>;
  approvedDateDeprecated?: InputMaybe<Order_By>;
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** First purchase date this Filing can be sold. Empty means not live, even when Approved. Distinct from approved_date, which only records when the regulator or lender approved it. */
  effectiveDate?: InputMaybe<Order_By>;
  /** Last purchase date this Filing can be sold. Empty means open-ended. After it, the sale falls back to the next qualifying Contract Form Version. */
  expirationDate?: InputMaybe<Order_By>;
  filingLenderId?: InputMaybe<Order_By>;
  filingStateId?: InputMaybe<Order_By>;
  filingStatusTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejectedDate?: InputMaybe<Order_By>;
  resubmittedDate?: InputMaybe<Order_By>;
  submittedDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Mutation_Response = {
  __typename?: 'contractFormFilingStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractFormFilingStatus>;
};

/** input type for inserting object relation for remote table "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Obj_Rel_Insert_Input = {
  data: ContractFormFilingStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ContractFormFilingStatus_On_Conflict>;
};

/** on_conflict condition type for table "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_On_Conflict = {
  constraint: ContractFormFilingStatus_Constraint;
  update_columns?: Array<ContractFormFilingStatus_Update_Column>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.contract_form_filing_status". */
export type ContractFormFilingStatus_Order_By = {
  approvedDate?: InputMaybe<Order_By>;
  approvedDateDeprecated?: InputMaybe<Order_By>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Order_By>;
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  filingLender?: InputMaybe<FilingLender_Order_By>;
  filingLenderId?: InputMaybe<Order_By>;
  filingState?: InputMaybe<FilingState_Order_By>;
  filingStateId?: InputMaybe<Order_By>;
  filingStatusType?: InputMaybe<FilingStatusType_Order_By>;
  filingStatusTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejectedDate?: InputMaybe<Order_By>;
  resubmittedDate?: InputMaybe<Order_By>;
  submittedDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.contract_form_filing_status */
export type ContractFormFilingStatus_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.contract_form_filing_status" */
export enum ContractFormFilingStatus_Select_Column {
  /** column name */
  ApprovedDate = 'approvedDate',
  /** column name */
  ApprovedDateDeprecated = 'approvedDateDeprecated',
  /** column name */
  ContractFormVersionId = 'contractFormVersionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  FilingLenderId = 'filingLenderId',
  /** column name */
  FilingStateId = 'filingStateId',
  /** column name */
  FilingStatusTypeId = 'filingStatusTypeId',
  /** column name */
  Id = 'id',
  /** column name */
  RejectedDate = 'rejectedDate',
  /** column name */
  ResubmittedDate = 'resubmittedDate',
  /** column name */
  SubmittedDate = 'submittedDate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "compliance.contract_form_filing_status" */
export type ContractFormFilingStatus_Set_Input = {
  approvedDate?: InputMaybe<Scalars['date']>;
  approvedDateDeprecated?: InputMaybe<Scalars['uuid']>;
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** First purchase date this Filing can be sold. Empty means not live, even when Approved. Distinct from approved_date, which only records when the regulator or lender approved it. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** Last purchase date this Filing can be sold. Empty means open-ended. After it, the sale falls back to the next qualifying Contract Form Version. */
  expirationDate?: InputMaybe<Scalars['date']>;
  filingLenderId?: InputMaybe<Scalars['uuid']>;
  filingStateId?: InputMaybe<Scalars['uuid']>;
  filingStatusTypeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  rejectedDate?: InputMaybe<Scalars['date']>;
  resubmittedDate?: InputMaybe<Scalars['date']>;
  submittedDate?: InputMaybe<Scalars['date']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "contractFormFilingStatus" */
export type ContractFormFilingStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ContractFormFilingStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractFormFilingStatus_Stream_Cursor_Value_Input = {
  approvedDate?: InputMaybe<Scalars['date']>;
  approvedDateDeprecated?: InputMaybe<Scalars['uuid']>;
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** First purchase date this Filing can be sold. Empty means not live, even when Approved. Distinct from approved_date, which only records when the regulator or lender approved it. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** Last purchase date this Filing can be sold. Empty means open-ended. After it, the sale falls back to the next qualifying Contract Form Version. */
  expirationDate?: InputMaybe<Scalars['date']>;
  filingLenderId?: InputMaybe<Scalars['uuid']>;
  filingStateId?: InputMaybe<Scalars['uuid']>;
  filingStatusTypeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  rejectedDate?: InputMaybe<Scalars['date']>;
  resubmittedDate?: InputMaybe<Scalars['date']>;
  submittedDate?: InputMaybe<Scalars['date']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "compliance.contract_form_filing_status" */
export enum ContractFormFilingStatus_Update_Column {
  /** column name */
  ApprovedDate = 'approvedDate',
  /** column name */
  ApprovedDateDeprecated = 'approvedDateDeprecated',
  /** column name */
  ContractFormVersionId = 'contractFormVersionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  FilingLenderId = 'filingLenderId',
  /** column name */
  FilingStateId = 'filingStateId',
  /** column name */
  FilingStatusTypeId = 'filingStatusTypeId',
  /** column name */
  Id = 'id',
  /** column name */
  RejectedDate = 'rejectedDate',
  /** column name */
  ResubmittedDate = 'resubmittedDate',
  /** column name */
  SubmittedDate = 'submittedDate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ContractFormFilingStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractFormFilingStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: ContractFormFilingStatus_Bool_Exp;
};

/** columns and relationships of "compliance.contract_form_type" */
export type ContractFormType = {
  __typename?: 'contractFormType';
  createdAt: Scalars['timestamptz'];
  description: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "compliance.contract_form_type" */
export type ContractFormType_Aggregate = {
  __typename?: 'contractFormType_aggregate';
  aggregate?: Maybe<ContractFormType_Aggregate_Fields>;
  nodes: Array<ContractFormType>;
};

/** aggregate fields of "compliance.contract_form_type" */
export type ContractFormType_Aggregate_Fields = {
  __typename?: 'contractFormType_aggregate_fields';
  avg?: Maybe<ContractFormType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ContractFormType_Max_Fields>;
  min?: Maybe<ContractFormType_Min_Fields>;
  stddev?: Maybe<ContractFormType_Stddev_Fields>;
  stddev_pop?: Maybe<ContractFormType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ContractFormType_Stddev_Samp_Fields>;
  sum?: Maybe<ContractFormType_Sum_Fields>;
  var_pop?: Maybe<ContractFormType_Var_Pop_Fields>;
  var_samp?: Maybe<ContractFormType_Var_Samp_Fields>;
  variance?: Maybe<ContractFormType_Variance_Fields>;
};


/** aggregate fields of "compliance.contract_form_type" */
export type ContractFormType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ContractFormType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ContractFormType_Avg_Fields = {
  __typename?: 'contractFormType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance.contract_form_type". All fields are combined with a logical 'AND'. */
export type ContractFormType_Bool_Exp = {
  _and?: InputMaybe<Array<ContractFormType_Bool_Exp>>;
  _not?: InputMaybe<ContractFormType_Bool_Exp>;
  _or?: InputMaybe<Array<ContractFormType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.contract_form_type" */
export enum ContractFormType_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractFormTypePkey = 'contract_form_type_pkey'
}

/** input type for incrementing numeric columns in table "compliance.contract_form_type" */
export type ContractFormType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance.contract_form_type" */
export type ContractFormType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ContractFormType_Max_Fields = {
  __typename?: 'contractFormType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ContractFormType_Min_Fields = {
  __typename?: 'contractFormType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "compliance.contract_form_type" */
export type ContractFormType_Mutation_Response = {
  __typename?: 'contractFormType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractFormType>;
};

/** input type for inserting object relation for remote table "compliance.contract_form_type" */
export type ContractFormType_Obj_Rel_Insert_Input = {
  data: ContractFormType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ContractFormType_On_Conflict>;
};

/** on_conflict condition type for table "compliance.contract_form_type" */
export type ContractFormType_On_Conflict = {
  constraint: ContractFormType_Constraint;
  update_columns?: Array<ContractFormType_Update_Column>;
  where?: InputMaybe<ContractFormType_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.contract_form_type". */
export type ContractFormType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.contract_form_type */
export type ContractFormType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.contract_form_type" */
export enum ContractFormType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "compliance.contract_form_type" */
export type ContractFormType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ContractFormType_Stddev_Fields = {
  __typename?: 'contractFormType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ContractFormType_Stddev_Pop_Fields = {
  __typename?: 'contractFormType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ContractFormType_Stddev_Samp_Fields = {
  __typename?: 'contractFormType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "contractFormType" */
export type ContractFormType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ContractFormType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractFormType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ContractFormType_Sum_Fields = {
  __typename?: 'contractFormType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "compliance.contract_form_type" */
export enum ContractFormType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ContractFormType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ContractFormType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractFormType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ContractFormType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ContractFormType_Var_Pop_Fields = {
  __typename?: 'contractFormType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ContractFormType_Var_Samp_Fields = {
  __typename?: 'contractFormType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ContractFormType_Variance_Fields = {
  __typename?: 'contractFormType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersion = {
  __typename?: 'contractFormVersion';
  /** An array relationship */
  cancelRules: Array<CancelRule>;
  /** An aggregate relationship */
  cancelRules_aggregate: CancelRule_Aggregate;
  /** An object relationship */
  contractForm?: Maybe<ContractForm>;
  /** An array relationship */
  contractFormFilingStatuses: Array<ContractFormFilingStatus>;
  /** An aggregate relationship */
  contractFormFilingStatuses_aggregate: ContractFormFilingStatus_Aggregate;
  contractFormId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  contractFormVersionLegacyFiles: Array<ContractFormVersionLegacyFile>;
  /** An aggregate relationship */
  contractFormVersionLegacyFiles_aggregate: ContractFormVersionLegacyFile_Aggregate;
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityEligibilityRules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entityEligibilityRules_aggregate: EntityEligibilityRule_Aggregate;
  /** An object relationship */
  entityFileStorage?: Maybe<EntityFileStorage>;
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An array relationship */
  policyContractContractFormVersions: Array<PolicyContractContractFormVersion>;
  /** An aggregate relationship */
  policyContractContractFormVersions_aggregate: PolicyContractContractFormVersion_Aggregate;
  revision?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  version?: Maybe<Scalars['String']>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionCancelRulesArgs = {
  distinct_on?: InputMaybe<Array<CancelRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRule_Order_By>>;
  where?: InputMaybe<CancelRule_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionCancelRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRule_Order_By>>;
  where?: InputMaybe<CancelRule_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionContractFormFilingStatusesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionContractFormFilingStatuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionContractFormVersionLegacyFilesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersionLegacyFile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersionLegacyFile_Order_By>>;
  where?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionContractFormVersionLegacyFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersionLegacyFile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersionLegacyFile_Order_By>>;
  where?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionEntityEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionPolicyContractContractFormVersionsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractContractFormVersion_Order_By>>;
  where?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
};


/** columns and relationships of "compliance.contract_form_version" */
export type ContractFormVersionPolicyContractContractFormVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractContractFormVersion_Order_By>>;
  where?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
};

/** Matches legacy file names to contract form version records */
export type ContractFormVersionLegacyFile = {
  __typename?: 'contractFormVersionLegacyFile';
  /** An object relationship */
  contractFormVersion: ContractFormVersion;
  contractFormVersionId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  legacyFileName: Scalars['String'];
  /** A computed field, executes function "compliance.get_legacy_file_name_for_matching" */
  legacyFileNameMatch?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_Aggregate = {
  __typename?: 'contractFormVersionLegacyFile_aggregate';
  aggregate?: Maybe<ContractFormVersionLegacyFile_Aggregate_Fields>;
  nodes: Array<ContractFormVersionLegacyFile>;
};

export type ContractFormVersionLegacyFile_Aggregate_Bool_Exp = {
  count?: InputMaybe<ContractFormVersionLegacyFile_Aggregate_Bool_Exp_Count>;
};

export type ContractFormVersionLegacyFile_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ContractFormVersionLegacyFile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_Aggregate_Fields = {
  __typename?: 'contractFormVersionLegacyFile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ContractFormVersionLegacyFile_Max_Fields>;
  min?: Maybe<ContractFormVersionLegacyFile_Min_Fields>;
};


/** aggregate fields of "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ContractFormVersionLegacyFile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ContractFormVersionLegacyFile_Max_Order_By>;
  min?: InputMaybe<ContractFormVersionLegacyFile_Min_Order_By>;
};

/** input type for inserting array relation for remote table "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_Arr_Rel_Insert_Input = {
  data: Array<ContractFormVersionLegacyFile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ContractFormVersionLegacyFile_On_Conflict>;
};

/** Boolean expression to filter rows from the table "compliance.contract_form_version_legacy_file". All fields are combined with a logical 'AND'. */
export type ContractFormVersionLegacyFile_Bool_Exp = {
  _and?: InputMaybe<Array<ContractFormVersionLegacyFile_Bool_Exp>>;
  _not?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
  _or?: InputMaybe<Array<ContractFormVersionLegacyFile_Bool_Exp>>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Bool_Exp>;
  contractFormVersionId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  legacyFileName?: InputMaybe<String_Comparison_Exp>;
  legacyFileNameMatch?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.contract_form_version_legacy_file" */
export enum ContractFormVersionLegacyFile_Constraint {
  /** unique or primary key constraint on columns "legacy_file_name" */
  ContractFormVersionLegacyFileLegacyFileNameKey = 'contract_form_version_legacy_file_legacy_file_name_key',
  /** unique or primary key constraint on columns "id" */
  ContractFormVersionLegacyFilePkey = 'contract_form_version_legacy_file_pkey'
}

/** input type for inserting data into table "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_Insert_Input = {
  contractFormVersion?: InputMaybe<ContractFormVersion_Obj_Rel_Insert_Input>;
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  legacyFileName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ContractFormVersionLegacyFile_Max_Fields = {
  __typename?: 'contractFormVersionLegacyFile_max_fields';
  contractFormVersionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  legacyFileName?: Maybe<Scalars['String']>;
  /** A computed field, executes function "compliance.get_legacy_file_name_for_matching" */
  legacyFileNameMatch?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_Max_Order_By = {
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyFileName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ContractFormVersionLegacyFile_Min_Fields = {
  __typename?: 'contractFormVersionLegacyFile_min_fields';
  contractFormVersionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  legacyFileName?: Maybe<Scalars['String']>;
  /** A computed field, executes function "compliance.get_legacy_file_name_for_matching" */
  legacyFileNameMatch?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_Min_Order_By = {
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyFileName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_Mutation_Response = {
  __typename?: 'contractFormVersionLegacyFile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractFormVersionLegacyFile>;
};

/** on_conflict condition type for table "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_On_Conflict = {
  constraint: ContractFormVersionLegacyFile_Constraint;
  update_columns?: Array<ContractFormVersionLegacyFile_Update_Column>;
  where?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.contract_form_version_legacy_file". */
export type ContractFormVersionLegacyFile_Order_By = {
  contractFormVersion?: InputMaybe<ContractFormVersion_Order_By>;
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyFileName?: InputMaybe<Order_By>;
  legacyFileNameMatch?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.contract_form_version_legacy_file */
export type ContractFormVersionLegacyFile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.contract_form_version_legacy_file" */
export enum ContractFormVersionLegacyFile_Select_Column {
  /** column name */
  ContractFormVersionId = 'contractFormVersionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LegacyFileName = 'legacyFileName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "compliance.contract_form_version_legacy_file" */
export type ContractFormVersionLegacyFile_Set_Input = {
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  legacyFileName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "contractFormVersionLegacyFile" */
export type ContractFormVersionLegacyFile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ContractFormVersionLegacyFile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractFormVersionLegacyFile_Stream_Cursor_Value_Input = {
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  legacyFileName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "compliance.contract_form_version_legacy_file" */
export enum ContractFormVersionLegacyFile_Update_Column {
  /** column name */
  ContractFormVersionId = 'contractFormVersionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LegacyFileName = 'legacyFileName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ContractFormVersionLegacyFile_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractFormVersionLegacyFile_Set_Input>;
  /** filter the rows which have to be updated */
  where: ContractFormVersionLegacyFile_Bool_Exp;
};

/** aggregated selection of "compliance.contract_form_version" */
export type ContractFormVersion_Aggregate = {
  __typename?: 'contractFormVersion_aggregate';
  aggregate?: Maybe<ContractFormVersion_Aggregate_Fields>;
  nodes: Array<ContractFormVersion>;
};

export type ContractFormVersion_Aggregate_Bool_Exp = {
  count?: InputMaybe<ContractFormVersion_Aggregate_Bool_Exp_Count>;
};

export type ContractFormVersion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ContractFormVersion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContractFormVersion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance.contract_form_version" */
export type ContractFormVersion_Aggregate_Fields = {
  __typename?: 'contractFormVersion_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ContractFormVersion_Max_Fields>;
  min?: Maybe<ContractFormVersion_Min_Fields>;
};


/** aggregate fields of "compliance.contract_form_version" */
export type ContractFormVersion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ContractFormVersion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance.contract_form_version" */
export type ContractFormVersion_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ContractFormVersion_Max_Order_By>;
  min?: InputMaybe<ContractFormVersion_Min_Order_By>;
};

/** input type for inserting array relation for remote table "compliance.contract_form_version" */
export type ContractFormVersion_Arr_Rel_Insert_Input = {
  data: Array<ContractFormVersion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ContractFormVersion_On_Conflict>;
};

/** Boolean expression to filter rows from the table "compliance.contract_form_version". All fields are combined with a logical 'AND'. */
export type ContractFormVersion_Bool_Exp = {
  _and?: InputMaybe<Array<ContractFormVersion_Bool_Exp>>;
  _not?: InputMaybe<ContractFormVersion_Bool_Exp>;
  _or?: InputMaybe<Array<ContractFormVersion_Bool_Exp>>;
  cancelRules?: InputMaybe<CancelRule_Bool_Exp>;
  cancelRules_aggregate?: InputMaybe<CancelRule_Aggregate_Bool_Exp>;
  contractForm?: InputMaybe<ContractForm_Bool_Exp>;
  contractFormFilingStatuses?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
  contractFormFilingStatuses_aggregate?: InputMaybe<ContractFormFilingStatus_Aggregate_Bool_Exp>;
  contractFormId?: InputMaybe<Uuid_Comparison_Exp>;
  contractFormVersionLegacyFiles?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
  contractFormVersionLegacyFiles_aggregate?: InputMaybe<ContractFormVersionLegacyFile_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  entityFileStorage?: InputMaybe<EntityFileStorage_Bool_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policyContractContractFormVersions?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
  policyContractContractFormVersions_aggregate?: InputMaybe<PolicyContractContractFormVersion_Aggregate_Bool_Exp>;
  revision?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.contract_form_version" */
export enum ContractFormVersion_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractFormVersionPkey = 'contract_form_version_pkey'
}

/** input type for inserting data into table "compliance.contract_form_version" */
export type ContractFormVersion_Insert_Input = {
  cancelRules?: InputMaybe<CancelRule_Arr_Rel_Insert_Input>;
  contractForm?: InputMaybe<ContractForm_Obj_Rel_Insert_Input>;
  contractFormFilingStatuses?: InputMaybe<ContractFormFilingStatus_Arr_Rel_Insert_Input>;
  contractFormId?: InputMaybe<Scalars['uuid']>;
  contractFormVersionLegacyFiles?: InputMaybe<ContractFormVersionLegacyFile_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  entityFileStorage?: InputMaybe<EntityFileStorage_Obj_Rel_Insert_Input>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyContractContractFormVersions?: InputMaybe<PolicyContractContractFormVersion_Arr_Rel_Insert_Input>;
  revision?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ContractFormVersion_Max_Fields = {
  __typename?: 'contractFormVersion_max_fields';
  contractFormId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  revision?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "compliance.contract_form_version" */
export type ContractFormVersion_Max_Order_By = {
  contractFormId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ContractFormVersion_Min_Fields = {
  __typename?: 'contractFormVersion_min_fields';
  contractFormId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  revision?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "compliance.contract_form_version" */
export type ContractFormVersion_Min_Order_By = {
  contractFormId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance.contract_form_version" */
export type ContractFormVersion_Mutation_Response = {
  __typename?: 'contractFormVersion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractFormVersion>;
};

/** input type for inserting object relation for remote table "compliance.contract_form_version" */
export type ContractFormVersion_Obj_Rel_Insert_Input = {
  data: ContractFormVersion_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ContractFormVersion_On_Conflict>;
};

/** on_conflict condition type for table "compliance.contract_form_version" */
export type ContractFormVersion_On_Conflict = {
  constraint: ContractFormVersion_Constraint;
  update_columns?: Array<ContractFormVersion_Update_Column>;
  where?: InputMaybe<ContractFormVersion_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.contract_form_version". */
export type ContractFormVersion_Order_By = {
  cancelRules_aggregate?: InputMaybe<CancelRule_Aggregate_Order_By>;
  contractForm?: InputMaybe<ContractForm_Order_By>;
  contractFormFilingStatuses_aggregate?: InputMaybe<ContractFormFilingStatus_Aggregate_Order_By>;
  contractFormId?: InputMaybe<Order_By>;
  contractFormVersionLegacyFiles_aggregate?: InputMaybe<ContractFormVersionLegacyFile_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  entityFileStorage?: InputMaybe<EntityFileStorage_Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyContractContractFormVersions_aggregate?: InputMaybe<PolicyContractContractFormVersion_Aggregate_Order_By>;
  revision?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.contract_form_version */
export type ContractFormVersion_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.contract_form_version" */
export enum ContractFormVersion_Select_Column {
  /** column name */
  ContractFormId = 'contractFormId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Revision = 'revision',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "compliance.contract_form_version" */
export type ContractFormVersion_Set_Input = {
  contractFormId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  revision?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "contractFormVersion" */
export type ContractFormVersion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ContractFormVersion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractFormVersion_Stream_Cursor_Value_Input = {
  contractFormId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  revision?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** update columns of table "compliance.contract_form_version" */
export enum ContractFormVersion_Update_Column {
  /** column name */
  ContractFormId = 'contractFormId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Revision = 'revision',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

export type ContractFormVersion_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractFormVersion_Set_Input>;
  /** filter the rows which have to be updated */
  where: ContractFormVersion_Bool_Exp;
};

/** aggregated selection of "compliance.contract_form" */
export type ContractForm_Aggregate = {
  __typename?: 'contractForm_aggregate';
  aggregate?: Maybe<ContractForm_Aggregate_Fields>;
  nodes: Array<ContractForm>;
};

/** aggregate fields of "compliance.contract_form" */
export type ContractForm_Aggregate_Fields = {
  __typename?: 'contractForm_aggregate_fields';
  avg?: Maybe<ContractForm_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ContractForm_Max_Fields>;
  min?: Maybe<ContractForm_Min_Fields>;
  stddev?: Maybe<ContractForm_Stddev_Fields>;
  stddev_pop?: Maybe<ContractForm_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ContractForm_Stddev_Samp_Fields>;
  sum?: Maybe<ContractForm_Sum_Fields>;
  var_pop?: Maybe<ContractForm_Var_Pop_Fields>;
  var_samp?: Maybe<ContractForm_Var_Samp_Fields>;
  variance?: Maybe<ContractForm_Variance_Fields>;
};


/** aggregate fields of "compliance.contract_form" */
export type ContractForm_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ContractForm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ContractForm_Avg_Fields = {
  __typename?: 'contractForm_avg_fields';
  composeOrder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance.contract_form". All fields are combined with a logical 'AND'. */
export type ContractForm_Bool_Exp = {
  _and?: InputMaybe<Array<ContractForm_Bool_Exp>>;
  _not?: InputMaybe<ContractForm_Bool_Exp>;
  _or?: InputMaybe<Array<ContractForm_Bool_Exp>>;
  composeOrder?: InputMaybe<Int_Comparison_Exp>;
  contractFormType?: InputMaybe<ContractFormType_Bool_Exp>;
  contractFormTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  contractFormVersions?: InputMaybe<ContractFormVersion_Bool_Exp>;
  contractFormVersions_aggregate?: InputMaybe<ContractFormVersion_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  entityNote?: InputMaybe<EntityNote_Bool_Exp>;
  entityNote_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  formNumber?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  productContractForms?: InputMaybe<ProductContractForm_Bool_Exp>;
  productContractForms_aggregate?: InputMaybe<ProductContractForm_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.contract_form" */
export enum ContractForm_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractFormPkey = 'contract_form_pkey'
}

/** input type for incrementing numeric columns in table "compliance.contract_form" */
export type ContractForm_Inc_Input = {
  composeOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance.contract_form" */
export type ContractForm_Insert_Input = {
  composeOrder?: InputMaybe<Scalars['Int']>;
  contractFormType?: InputMaybe<ContractFormType_Obj_Rel_Insert_Input>;
  contractFormTypeId?: InputMaybe<Scalars['uuid']>;
  contractFormVersions?: InputMaybe<ContractFormVersion_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  entityNote?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  formNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  productContractForms?: InputMaybe<ProductContractForm_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ContractForm_Max_Fields = {
  __typename?: 'contractForm_max_fields';
  composeOrder?: Maybe<Scalars['Int']>;
  contractFormTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  formNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ContractForm_Min_Fields = {
  __typename?: 'contractForm_min_fields';
  composeOrder?: Maybe<Scalars['Int']>;
  contractFormTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  formNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "compliance.contract_form" */
export type ContractForm_Mutation_Response = {
  __typename?: 'contractForm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractForm>;
};

/** input type for inserting object relation for remote table "compliance.contract_form" */
export type ContractForm_Obj_Rel_Insert_Input = {
  data: ContractForm_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ContractForm_On_Conflict>;
};

/** on_conflict condition type for table "compliance.contract_form" */
export type ContractForm_On_Conflict = {
  constraint: ContractForm_Constraint;
  update_columns?: Array<ContractForm_Update_Column>;
  where?: InputMaybe<ContractForm_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.contract_form". */
export type ContractForm_Order_By = {
  composeOrder?: InputMaybe<Order_By>;
  contractFormType?: InputMaybe<ContractFormType_Order_By>;
  contractFormTypeId?: InputMaybe<Order_By>;
  contractFormVersions_aggregate?: InputMaybe<ContractFormVersion_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  entityNote_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  formNumber?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  productContractForms_aggregate?: InputMaybe<ProductContractForm_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.contract_form */
export type ContractForm_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.contract_form" */
export enum ContractForm_Select_Column {
  /** column name */
  ComposeOrder = 'composeOrder',
  /** column name */
  ContractFormTypeId = 'contractFormTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  FormNumber = 'formNumber',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "compliance.contract_form" */
export type ContractForm_Set_Input = {
  composeOrder?: InputMaybe<Scalars['Int']>;
  contractFormTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  formNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ContractForm_Stddev_Fields = {
  __typename?: 'contractForm_stddev_fields';
  composeOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ContractForm_Stddev_Pop_Fields = {
  __typename?: 'contractForm_stddev_pop_fields';
  composeOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ContractForm_Stddev_Samp_Fields = {
  __typename?: 'contractForm_stddev_samp_fields';
  composeOrder?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "contractForm" */
export type ContractForm_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ContractForm_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractForm_Stream_Cursor_Value_Input = {
  composeOrder?: InputMaybe<Scalars['Int']>;
  contractFormTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  formNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ContractForm_Sum_Fields = {
  __typename?: 'contractForm_sum_fields';
  composeOrder?: Maybe<Scalars['Int']>;
};

/** update columns of table "compliance.contract_form" */
export enum ContractForm_Update_Column {
  /** column name */
  ComposeOrder = 'composeOrder',
  /** column name */
  ContractFormTypeId = 'contractFormTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  FormNumber = 'formNumber',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ContractForm_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ContractForm_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractForm_Set_Input>;
  /** filter the rows which have to be updated */
  where: ContractForm_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ContractForm_Var_Pop_Fields = {
  __typename?: 'contractForm_var_pop_fields';
  composeOrder?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ContractForm_Var_Samp_Fields = {
  __typename?: 'contractForm_var_samp_fields';
  composeOrder?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ContractForm_Variance_Fields = {
  __typename?: 'contractForm_variance_fields';
  composeOrder?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "contract_status_type" */
export type ContractStatusType = {
  __typename?: 'contractStatusType';
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "contract_status_type" */
export type ContractStatusType_Aggregate = {
  __typename?: 'contractStatusType_aggregate';
  aggregate?: Maybe<ContractStatusType_Aggregate_Fields>;
  nodes: Array<ContractStatusType>;
};

/** aggregate fields of "contract_status_type" */
export type ContractStatusType_Aggregate_Fields = {
  __typename?: 'contractStatusType_aggregate_fields';
  avg?: Maybe<ContractStatusType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ContractStatusType_Max_Fields>;
  min?: Maybe<ContractStatusType_Min_Fields>;
  stddev?: Maybe<ContractStatusType_Stddev_Fields>;
  stddev_pop?: Maybe<ContractStatusType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ContractStatusType_Stddev_Samp_Fields>;
  sum?: Maybe<ContractStatusType_Sum_Fields>;
  var_pop?: Maybe<ContractStatusType_Var_Pop_Fields>;
  var_samp?: Maybe<ContractStatusType_Var_Samp_Fields>;
  variance?: Maybe<ContractStatusType_Variance_Fields>;
};


/** aggregate fields of "contract_status_type" */
export type ContractStatusType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ContractStatusType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ContractStatusType_Avg_Fields = {
  __typename?: 'contractStatusType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "contract_status_type". All fields are combined with a logical 'AND'. */
export type ContractStatusType_Bool_Exp = {
  _and?: InputMaybe<Array<ContractStatusType_Bool_Exp>>;
  _not?: InputMaybe<ContractStatusType_Bool_Exp>;
  _or?: InputMaybe<Array<ContractStatusType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "contract_status_type" */
export enum ContractStatusType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  ContractStatusTypeEnumValueKey = 'contract_status_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  ContractStatusTypePkey = 'contract_status_type_pkey'
}

/** input type for incrementing numeric columns in table "contract_status_type" */
export type ContractStatusType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "contract_status_type" */
export type ContractStatusType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ContractStatusType_Max_Fields = {
  __typename?: 'contractStatusType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ContractStatusType_Min_Fields = {
  __typename?: 'contractStatusType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "contract_status_type" */
export type ContractStatusType_Mutation_Response = {
  __typename?: 'contractStatusType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractStatusType>;
};

/** input type for inserting object relation for remote table "contract_status_type" */
export type ContractStatusType_Obj_Rel_Insert_Input = {
  data: ContractStatusType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ContractStatusType_On_Conflict>;
};

/** on_conflict condition type for table "contract_status_type" */
export type ContractStatusType_On_Conflict = {
  constraint: ContractStatusType_Constraint;
  update_columns?: Array<ContractStatusType_Update_Column>;
  where?: InputMaybe<ContractStatusType_Bool_Exp>;
};

/** Ordering options when selecting data from "contract_status_type". */
export type ContractStatusType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contract_status_type */
export type ContractStatusType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "contract_status_type" */
export enum ContractStatusType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "contract_status_type" */
export type ContractStatusType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ContractStatusType_Stddev_Fields = {
  __typename?: 'contractStatusType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ContractStatusType_Stddev_Pop_Fields = {
  __typename?: 'contractStatusType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ContractStatusType_Stddev_Samp_Fields = {
  __typename?: 'contractStatusType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "contractStatusType" */
export type ContractStatusType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ContractStatusType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractStatusType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ContractStatusType_Sum_Fields = {
  __typename?: 'contractStatusType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "contract_status_type" */
export enum ContractStatusType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ContractStatusType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ContractStatusType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractStatusType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ContractStatusType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ContractStatusType_Var_Pop_Fields = {
  __typename?: 'contractStatusType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ContractStatusType_Var_Samp_Fields = {
  __typename?: 'contractStatusType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ContractStatusType_Variance_Fields = {
  __typename?: 'contractStatusType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "contract" */
export type Contract_Aggregate = {
  __typename?: 'contract_aggregate';
  aggregate?: Maybe<Contract_Aggregate_Fields>;
  nodes: Array<Contract>;
};

/** aggregate fields of "contract" */
export type Contract_Aggregate_Fields = {
  __typename?: 'contract_aggregate_fields';
  avg?: Maybe<Contract_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Contract_Max_Fields>;
  min?: Maybe<Contract_Min_Fields>;
  stddev?: Maybe<Contract_Stddev_Fields>;
  stddev_pop?: Maybe<Contract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contract_Stddev_Samp_Fields>;
  sum?: Maybe<Contract_Sum_Fields>;
  var_pop?: Maybe<Contract_Var_Pop_Fields>;
  var_samp?: Maybe<Contract_Var_Samp_Fields>;
  variance?: Maybe<Contract_Variance_Fields>;
};


/** aggregate fields of "contract" */
export type Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Contract_Avg_Fields = {
  __typename?: 'contract_avg_fields';
  contractStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMileageAmount?: Maybe<Scalars['Float']>;
  purchasePriceAmount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "contract". All fields are combined with a logical 'AND'. */
export type Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Contract_Bool_Exp>>;
  _not?: InputMaybe<Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Contract_Bool_Exp>>;
  claims?: InputMaybe<Claim_Bool_Exp>;
  claims_aggregate?: InputMaybe<Claim_Aggregate_Bool_Exp>;
  contractNumber?: InputMaybe<String_Comparison_Exp>;
  contractStatusType?: InputMaybe<ContractStatusType_Bool_Exp>;
  contractStatusTypeEnumValue?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dealer?: InputMaybe<Legacy_Claims_Dealer_Bool_Exp>;
  dealerId?: InputMaybe<Uuid_Comparison_Exp>;
  deductibleAmount?: InputMaybe<Numeric_Comparison_Exp>;
  deductibleType?: InputMaybe<String_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  expirationMileageAmount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Legacy_Claims_Note_Aggregate_Bool_Exp>;
  planName?: InputMaybe<String_Comparison_Exp>;
  planTerms?: InputMaybe<String_Comparison_Exp>;
  primaryCustomer?: InputMaybe<Customer_Bool_Exp>;
  primaryCustomerId?: InputMaybe<Uuid_Comparison_Exp>;
  purchasePriceAmount?: InputMaybe<Numeric_Comparison_Exp>;
  secondaryCustomer?: InputMaybe<Customer_Bool_Exp>;
  secondaryCustomerId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicleId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "contract" */
export enum Contract_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractPkey = 'contract_pkey'
}

/** input type for incrementing numeric columns in table "contract" */
export type Contract_Inc_Input = {
  contractStatusTypeEnumValue?: InputMaybe<Scalars['Int']>;
  deductibleAmount?: InputMaybe<Scalars['numeric']>;
  expirationMileageAmount?: InputMaybe<Scalars['numeric']>;
  purchasePriceAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "contract" */
export type Contract_Insert_Input = {
  claims?: InputMaybe<Claim_Arr_Rel_Insert_Input>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractStatusType?: InputMaybe<ContractStatusType_Obj_Rel_Insert_Input>;
  contractStatusTypeEnumValue?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealer?: InputMaybe<Legacy_Claims_Dealer_Obj_Rel_Insert_Input>;
  dealerId?: InputMaybe<Scalars['uuid']>;
  deductibleAmount?: InputMaybe<Scalars['numeric']>;
  deductibleType?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  expirationMileageAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Legacy_Claims_Note_Arr_Rel_Insert_Input>;
  planName?: InputMaybe<Scalars['String']>;
  planTerms?: InputMaybe<Scalars['String']>;
  primaryCustomer?: InputMaybe<Customer_Obj_Rel_Insert_Input>;
  primaryCustomerId?: InputMaybe<Scalars['uuid']>;
  purchasePriceAmount?: InputMaybe<Scalars['numeric']>;
  secondaryCustomer?: InputMaybe<Customer_Obj_Rel_Insert_Input>;
  secondaryCustomerId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicleId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Contract_Max_Fields = {
  __typename?: 'contract_max_fields';
  contractNumber?: Maybe<Scalars['String']>;
  contractStatusTypeEnumValue?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dealerId?: Maybe<Scalars['uuid']>;
  deductibleAmount?: Maybe<Scalars['numeric']>;
  deductibleType?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['date']>;
  expirationMileageAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  planName?: Maybe<Scalars['String']>;
  planTerms?: Maybe<Scalars['String']>;
  primaryCustomerId?: Maybe<Scalars['uuid']>;
  purchasePriceAmount?: Maybe<Scalars['numeric']>;
  secondaryCustomerId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Contract_Min_Fields = {
  __typename?: 'contract_min_fields';
  contractNumber?: Maybe<Scalars['String']>;
  contractStatusTypeEnumValue?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dealerId?: Maybe<Scalars['uuid']>;
  deductibleAmount?: Maybe<Scalars['numeric']>;
  deductibleType?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['date']>;
  expirationMileageAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  planName?: Maybe<Scalars['String']>;
  planTerms?: Maybe<Scalars['String']>;
  primaryCustomerId?: Maybe<Scalars['uuid']>;
  purchasePriceAmount?: Maybe<Scalars['numeric']>;
  secondaryCustomerId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "contract" */
export type Contract_Mutation_Response = {
  __typename?: 'contract_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contract>;
};

/** input type for inserting object relation for remote table "contract" */
export type Contract_Obj_Rel_Insert_Input = {
  data: Contract_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contract_On_Conflict>;
};

/** on_conflict condition type for table "contract" */
export type Contract_On_Conflict = {
  constraint: Contract_Constraint;
  update_columns?: Array<Contract_Update_Column>;
  where?: InputMaybe<Contract_Bool_Exp>;
};

/** Ordering options when selecting data from "contract". */
export type Contract_Order_By = {
  claims_aggregate?: InputMaybe<Claim_Aggregate_Order_By>;
  contractNumber?: InputMaybe<Order_By>;
  contractStatusType?: InputMaybe<ContractStatusType_Order_By>;
  contractStatusTypeEnumValue?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dealer?: InputMaybe<Legacy_Claims_Dealer_Order_By>;
  dealerId?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  deductibleType?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  expirationMileageAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Legacy_Claims_Note_Aggregate_Order_By>;
  planName?: InputMaybe<Order_By>;
  planTerms?: InputMaybe<Order_By>;
  primaryCustomer?: InputMaybe<Customer_Order_By>;
  primaryCustomerId?: InputMaybe<Order_By>;
  purchasePriceAmount?: InputMaybe<Order_By>;
  secondaryCustomer?: InputMaybe<Customer_Order_By>;
  secondaryCustomerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicleId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contract */
export type Contract_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "contract" */
export enum Contract_Select_Column {
  /** column name */
  ContractNumber = 'contractNumber',
  /** column name */
  ContractStatusTypeEnumValue = 'contractStatusTypeEnumValue',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DealerId = 'dealerId',
  /** column name */
  DeductibleAmount = 'deductibleAmount',
  /** column name */
  DeductibleType = 'deductibleType',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  ExpirationMileageAmount = 'expirationMileageAmount',
  /** column name */
  Id = 'id',
  /** column name */
  PlanName = 'planName',
  /** column name */
  PlanTerms = 'planTerms',
  /** column name */
  PrimaryCustomerId = 'primaryCustomerId',
  /** column name */
  PurchasePriceAmount = 'purchasePriceAmount',
  /** column name */
  SecondaryCustomerId = 'secondaryCustomerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VehicleId = 'vehicleId'
}

/** input type for updating data in table "contract" */
export type Contract_Set_Input = {
  contractNumber?: InputMaybe<Scalars['String']>;
  contractStatusTypeEnumValue?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerId?: InputMaybe<Scalars['uuid']>;
  deductibleAmount?: InputMaybe<Scalars['numeric']>;
  deductibleType?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  expirationMileageAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  planName?: InputMaybe<Scalars['String']>;
  planTerms?: InputMaybe<Scalars['String']>;
  primaryCustomerId?: InputMaybe<Scalars['uuid']>;
  purchasePriceAmount?: InputMaybe<Scalars['numeric']>;
  secondaryCustomerId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Contract_Stddev_Fields = {
  __typename?: 'contract_stddev_fields';
  contractStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMileageAmount?: Maybe<Scalars['Float']>;
  purchasePriceAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Contract_Stddev_Pop_Fields = {
  __typename?: 'contract_stddev_pop_fields';
  contractStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMileageAmount?: Maybe<Scalars['Float']>;
  purchasePriceAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Contract_Stddev_Samp_Fields = {
  __typename?: 'contract_stddev_samp_fields';
  contractStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMileageAmount?: Maybe<Scalars['Float']>;
  purchasePriceAmount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "contract" */
export type Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contract_Stream_Cursor_Value_Input = {
  contractNumber?: InputMaybe<Scalars['String']>;
  contractStatusTypeEnumValue?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerId?: InputMaybe<Scalars['uuid']>;
  deductibleAmount?: InputMaybe<Scalars['numeric']>;
  deductibleType?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  expirationMileageAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  planName?: InputMaybe<Scalars['String']>;
  planTerms?: InputMaybe<Scalars['String']>;
  primaryCustomerId?: InputMaybe<Scalars['uuid']>;
  purchasePriceAmount?: InputMaybe<Scalars['numeric']>;
  secondaryCustomerId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Contract_Sum_Fields = {
  __typename?: 'contract_sum_fields';
  contractStatusTypeEnumValue?: Maybe<Scalars['Int']>;
  deductibleAmount?: Maybe<Scalars['numeric']>;
  expirationMileageAmount?: Maybe<Scalars['numeric']>;
  purchasePriceAmount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "contract" */
export enum Contract_Update_Column {
  /** column name */
  ContractNumber = 'contractNumber',
  /** column name */
  ContractStatusTypeEnumValue = 'contractStatusTypeEnumValue',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DealerId = 'dealerId',
  /** column name */
  DeductibleAmount = 'deductibleAmount',
  /** column name */
  DeductibleType = 'deductibleType',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  ExpirationMileageAmount = 'expirationMileageAmount',
  /** column name */
  Id = 'id',
  /** column name */
  PlanName = 'planName',
  /** column name */
  PlanTerms = 'planTerms',
  /** column name */
  PrimaryCustomerId = 'primaryCustomerId',
  /** column name */
  PurchasePriceAmount = 'purchasePriceAmount',
  /** column name */
  SecondaryCustomerId = 'secondaryCustomerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VehicleId = 'vehicleId'
}

export type Contract_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Contract_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contract_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contract_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contract_Var_Pop_Fields = {
  __typename?: 'contract_var_pop_fields';
  contractStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMileageAmount?: Maybe<Scalars['Float']>;
  purchasePriceAmount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Contract_Var_Samp_Fields = {
  __typename?: 'contract_var_samp_fields';
  contractStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMileageAmount?: Maybe<Scalars['Float']>;
  purchasePriceAmount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Contract_Variance_Fields = {
  __typename?: 'contract_variance_fields';
  contractStatusTypeEnumValue?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMileageAmount?: Maybe<Scalars['Float']>;
  purchasePriceAmount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cost_adjustment" */
export type CostAdjustment = {
  __typename?: 'costAdjustment';
  /** An object relationship */
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  costAdjustmentExtendedCosts: Array<CostAdjustmentExtendedCost>;
  /** An aggregate relationship */
  costAdjustmentExtendedCosts_aggregate: CostAdjustmentExtendedCost_Aggregate;
  /** An array relationship */
  costAdjustmentLookups: Array<CostAdjustmentLookup>;
  /** An aggregate relationship */
  costAdjustmentLookups_aggregate: CostAdjustmentLookup_Aggregate;
  /** An object relationship */
  costAdjustmentType?: Maybe<CostAdjustmentType>;
  costAdjustmentTypeId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  entityEligibilityRules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entityEligibilityRules_aggregate: EntityEligibilityRule_Aggregate;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  id: Scalars['uuid'];
  isMultiply?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** An array relationship */
  productCosts: Array<ProductCost>;
  /** An aggregate relationship */
  productCosts_aggregate: ProductCost_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "cost_adjustment" */
export type CostAdjustmentCostAdjustmentExtendedCostsArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentExtendedCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentExtendedCost_Order_By>>;
  where?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment" */
export type CostAdjustmentCostAdjustmentExtendedCosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentExtendedCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentExtendedCost_Order_By>>;
  where?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment" */
export type CostAdjustmentCostAdjustmentLookupsArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentLookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentLookup_Order_By>>;
  where?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment" */
export type CostAdjustmentCostAdjustmentLookups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentLookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentLookup_Order_By>>;
  where?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment" */
export type CostAdjustmentEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment" */
export type CostAdjustmentEntityEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment" */
export type CostAdjustmentEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment" */
export type CostAdjustmentEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment" */
export type CostAdjustmentProductCostsArgs = {
  distinct_on?: InputMaybe<Array<ProductCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductCost_Order_By>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment" */
export type CostAdjustmentProductCosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductCost_Order_By>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};

/** columns and relationships of "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost = {
  __typename?: 'costAdjustmentExtendedCost';
  baseCost: Scalars['numeric'];
  /** An object relationship */
  costAdjustment: CostAdjustment;
  costAdjustmentId: Scalars['uuid'];
  defaultLookupCost: Scalars['numeric'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
};

/** aggregated selection of "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Aggregate = {
  __typename?: 'costAdjustmentExtendedCost_aggregate';
  aggregate?: Maybe<CostAdjustmentExtendedCost_Aggregate_Fields>;
  nodes: Array<CostAdjustmentExtendedCost>;
};

export type CostAdjustmentExtendedCost_Aggregate_Bool_Exp = {
  count?: InputMaybe<CostAdjustmentExtendedCost_Aggregate_Bool_Exp_Count>;
};

export type CostAdjustmentExtendedCost_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CostAdjustmentExtendedCost_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Aggregate_Fields = {
  __typename?: 'costAdjustmentExtendedCost_aggregate_fields';
  avg?: Maybe<CostAdjustmentExtendedCost_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CostAdjustmentExtendedCost_Max_Fields>;
  min?: Maybe<CostAdjustmentExtendedCost_Min_Fields>;
  stddev?: Maybe<CostAdjustmentExtendedCost_Stddev_Fields>;
  stddev_pop?: Maybe<CostAdjustmentExtendedCost_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CostAdjustmentExtendedCost_Stddev_Samp_Fields>;
  sum?: Maybe<CostAdjustmentExtendedCost_Sum_Fields>;
  var_pop?: Maybe<CostAdjustmentExtendedCost_Var_Pop_Fields>;
  var_samp?: Maybe<CostAdjustmentExtendedCost_Var_Samp_Fields>;
  variance?: Maybe<CostAdjustmentExtendedCost_Variance_Fields>;
};


/** aggregate fields of "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CostAdjustmentExtendedCost_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Aggregate_Order_By = {
  avg?: InputMaybe<CostAdjustmentExtendedCost_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CostAdjustmentExtendedCost_Max_Order_By>;
  min?: InputMaybe<CostAdjustmentExtendedCost_Min_Order_By>;
  stddev?: InputMaybe<CostAdjustmentExtendedCost_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CostAdjustmentExtendedCost_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CostAdjustmentExtendedCost_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CostAdjustmentExtendedCost_Sum_Order_By>;
  var_pop?: InputMaybe<CostAdjustmentExtendedCost_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CostAdjustmentExtendedCost_Var_Samp_Order_By>;
  variance?: InputMaybe<CostAdjustmentExtendedCost_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Arr_Rel_Insert_Input = {
  data: Array<CostAdjustmentExtendedCost_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CostAdjustmentExtendedCost_On_Conflict>;
};

/** aggregate avg on columns */
export type CostAdjustmentExtendedCost_Avg_Fields = {
  __typename?: 'costAdjustmentExtendedCost_avg_fields';
  baseCost?: Maybe<Scalars['Float']>;
  defaultLookupCost?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Avg_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cost_adjustment_extended_cost". All fields are combined with a logical 'AND'. */
export type CostAdjustmentExtendedCost_Bool_Exp = {
  _and?: InputMaybe<Array<CostAdjustmentExtendedCost_Bool_Exp>>;
  _not?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
  _or?: InputMaybe<Array<CostAdjustmentExtendedCost_Bool_Exp>>;
  baseCost?: InputMaybe<Numeric_Comparison_Exp>;
  costAdjustment?: InputMaybe<CostAdjustment_Bool_Exp>;
  costAdjustmentId?: InputMaybe<Uuid_Comparison_Exp>;
  defaultLookupCost?: InputMaybe<Numeric_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "cost_adjustment_extended_cost" */
export enum CostAdjustmentExtendedCost_Constraint {
  /** unique or primary key constraint on columns "id" */
  CostAdjustmentExtendedCostPkey = 'cost_adjustment_extended_cost_pkey'
}

/** input type for incrementing numeric columns in table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Inc_Input = {
  baseCost?: InputMaybe<Scalars['numeric']>;
  defaultLookupCost?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Insert_Input = {
  baseCost?: InputMaybe<Scalars['numeric']>;
  costAdjustment?: InputMaybe<CostAdjustment_Obj_Rel_Insert_Input>;
  costAdjustmentId?: InputMaybe<Scalars['uuid']>;
  defaultLookupCost?: InputMaybe<Scalars['numeric']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CostAdjustmentExtendedCost_Max_Fields = {
  __typename?: 'costAdjustmentExtendedCost_max_fields';
  baseCost?: Maybe<Scalars['numeric']>;
  costAdjustmentId?: Maybe<Scalars['uuid']>;
  defaultLookupCost?: Maybe<Scalars['numeric']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Max_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  costAdjustmentId?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CostAdjustmentExtendedCost_Min_Fields = {
  __typename?: 'costAdjustmentExtendedCost_min_fields';
  baseCost?: Maybe<Scalars['numeric']>;
  costAdjustmentId?: Maybe<Scalars['uuid']>;
  defaultLookupCost?: Maybe<Scalars['numeric']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Min_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  costAdjustmentId?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Mutation_Response = {
  __typename?: 'costAdjustmentExtendedCost_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CostAdjustmentExtendedCost>;
};

/** on_conflict condition type for table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_On_Conflict = {
  constraint: CostAdjustmentExtendedCost_Constraint;
  update_columns?: Array<CostAdjustmentExtendedCost_Update_Column>;
  where?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
};

/** Ordering options when selecting data from "cost_adjustment_extended_cost". */
export type CostAdjustmentExtendedCost_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  costAdjustment?: InputMaybe<CostAdjustment_Order_By>;
  costAdjustmentId?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cost_adjustment_extended_cost */
export type CostAdjustmentExtendedCost_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cost_adjustment_extended_cost" */
export enum CostAdjustmentExtendedCost_Select_Column {
  /** column name */
  BaseCost = 'baseCost',
  /** column name */
  CostAdjustmentId = 'costAdjustmentId',
  /** column name */
  DefaultLookupCost = 'defaultLookupCost',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Set_Input = {
  baseCost?: InputMaybe<Scalars['numeric']>;
  costAdjustmentId?: InputMaybe<Scalars['uuid']>;
  defaultLookupCost?: InputMaybe<Scalars['numeric']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type CostAdjustmentExtendedCost_Stddev_Fields = {
  __typename?: 'costAdjustmentExtendedCost_stddev_fields';
  baseCost?: Maybe<Scalars['Float']>;
  defaultLookupCost?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Stddev_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CostAdjustmentExtendedCost_Stddev_Pop_Fields = {
  __typename?: 'costAdjustmentExtendedCost_stddev_pop_fields';
  baseCost?: Maybe<Scalars['Float']>;
  defaultLookupCost?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Stddev_Pop_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CostAdjustmentExtendedCost_Stddev_Samp_Fields = {
  __typename?: 'costAdjustmentExtendedCost_stddev_samp_fields';
  baseCost?: Maybe<Scalars['Float']>;
  defaultLookupCost?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Stddev_Samp_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "costAdjustmentExtendedCost" */
export type CostAdjustmentExtendedCost_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CostAdjustmentExtendedCost_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CostAdjustmentExtendedCost_Stream_Cursor_Value_Input = {
  baseCost?: InputMaybe<Scalars['numeric']>;
  costAdjustmentId?: InputMaybe<Scalars['uuid']>;
  defaultLookupCost?: InputMaybe<Scalars['numeric']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type CostAdjustmentExtendedCost_Sum_Fields = {
  __typename?: 'costAdjustmentExtendedCost_sum_fields';
  baseCost?: Maybe<Scalars['numeric']>;
  defaultLookupCost?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Sum_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
};

/** update columns of table "cost_adjustment_extended_cost" */
export enum CostAdjustmentExtendedCost_Update_Column {
  /** column name */
  BaseCost = 'baseCost',
  /** column name */
  CostAdjustmentId = 'costAdjustmentId',
  /** column name */
  DefaultLookupCost = 'defaultLookupCost',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id'
}

export type CostAdjustmentExtendedCost_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CostAdjustmentExtendedCost_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CostAdjustmentExtendedCost_Set_Input>;
  /** filter the rows which have to be updated */
  where: CostAdjustmentExtendedCost_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CostAdjustmentExtendedCost_Var_Pop_Fields = {
  __typename?: 'costAdjustmentExtendedCost_var_pop_fields';
  baseCost?: Maybe<Scalars['Float']>;
  defaultLookupCost?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Var_Pop_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CostAdjustmentExtendedCost_Var_Samp_Fields = {
  __typename?: 'costAdjustmentExtendedCost_var_samp_fields';
  baseCost?: Maybe<Scalars['Float']>;
  defaultLookupCost?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Var_Samp_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CostAdjustmentExtendedCost_Variance_Fields = {
  __typename?: 'costAdjustmentExtendedCost_variance_fields';
  baseCost?: Maybe<Scalars['Float']>;
  defaultLookupCost?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cost_adjustment_extended_cost" */
export type CostAdjustmentExtendedCost_Variance_Order_By = {
  baseCost?: InputMaybe<Order_By>;
  defaultLookupCost?: InputMaybe<Order_By>;
};

/** columns and relationships of "cost_adjustment_lookup" */
export type CostAdjustmentLookup = {
  __typename?: 'costAdjustmentLookup';
  cost: Scalars['numeric'];
  /** An object relationship */
  costAdjustment: CostAdjustment;
  costAdjustmentId: Scalars['uuid'];
  effectiveDate?: Maybe<Scalars['date']>;
  endValue?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  entityEligibilityRules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entityEligibilityRules_aggregate: EntityEligibilityRule_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  jsonValue?: Maybe<Scalars['jsonb']>;
  singleValue?: Maybe<Scalars['String']>;
  startValue?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "cost_adjustment_lookup" */
export type CostAdjustmentLookupEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment_lookup" */
export type CostAdjustmentLookupEntityEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment_lookup" */
export type CostAdjustmentLookupJsonValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Aggregate = {
  __typename?: 'costAdjustmentLookup_aggregate';
  aggregate?: Maybe<CostAdjustmentLookup_Aggregate_Fields>;
  nodes: Array<CostAdjustmentLookup>;
};

export type CostAdjustmentLookup_Aggregate_Bool_Exp = {
  count?: InputMaybe<CostAdjustmentLookup_Aggregate_Bool_Exp_Count>;
};

export type CostAdjustmentLookup_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CostAdjustmentLookup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Aggregate_Fields = {
  __typename?: 'costAdjustmentLookup_aggregate_fields';
  avg?: Maybe<CostAdjustmentLookup_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CostAdjustmentLookup_Max_Fields>;
  min?: Maybe<CostAdjustmentLookup_Min_Fields>;
  stddev?: Maybe<CostAdjustmentLookup_Stddev_Fields>;
  stddev_pop?: Maybe<CostAdjustmentLookup_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CostAdjustmentLookup_Stddev_Samp_Fields>;
  sum?: Maybe<CostAdjustmentLookup_Sum_Fields>;
  var_pop?: Maybe<CostAdjustmentLookup_Var_Pop_Fields>;
  var_samp?: Maybe<CostAdjustmentLookup_Var_Samp_Fields>;
  variance?: Maybe<CostAdjustmentLookup_Variance_Fields>;
};


/** aggregate fields of "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CostAdjustmentLookup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Aggregate_Order_By = {
  avg?: InputMaybe<CostAdjustmentLookup_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CostAdjustmentLookup_Max_Order_By>;
  min?: InputMaybe<CostAdjustmentLookup_Min_Order_By>;
  stddev?: InputMaybe<CostAdjustmentLookup_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CostAdjustmentLookup_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CostAdjustmentLookup_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CostAdjustmentLookup_Sum_Order_By>;
  var_pop?: InputMaybe<CostAdjustmentLookup_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CostAdjustmentLookup_Var_Samp_Order_By>;
  variance?: InputMaybe<CostAdjustmentLookup_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CostAdjustmentLookup_Append_Input = {
  jsonValue?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Arr_Rel_Insert_Input = {
  data: Array<CostAdjustmentLookup_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CostAdjustmentLookup_On_Conflict>;
};

/** aggregate avg on columns */
export type CostAdjustmentLookup_Avg_Fields = {
  __typename?: 'costAdjustmentLookup_avg_fields';
  cost?: Maybe<Scalars['Float']>;
  endValue?: Maybe<Scalars['Float']>;
  startValue?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cost_adjustment_lookup". All fields are combined with a logical 'AND'. */
export type CostAdjustmentLookup_Bool_Exp = {
  _and?: InputMaybe<Array<CostAdjustmentLookup_Bool_Exp>>;
  _not?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
  _or?: InputMaybe<Array<CostAdjustmentLookup_Bool_Exp>>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  costAdjustment?: InputMaybe<CostAdjustment_Bool_Exp>;
  costAdjustmentId?: InputMaybe<Uuid_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  endValue?: InputMaybe<Numeric_Comparison_Exp>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jsonValue?: InputMaybe<Jsonb_Comparison_Exp>;
  singleValue?: InputMaybe<String_Comparison_Exp>;
  startValue?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "cost_adjustment_lookup" */
export enum CostAdjustmentLookup_Constraint {
  /** unique or primary key constraint on columns "id" */
  CostAdjustmentLookupPkey = 'cost_adjustment_lookup_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CostAdjustmentLookup_Delete_At_Path_Input = {
  jsonValue?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CostAdjustmentLookup_Delete_Elem_Input = {
  jsonValue?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CostAdjustmentLookup_Delete_Key_Input = {
  jsonValue?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Inc_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  endValue?: InputMaybe<Scalars['numeric']>;
  startValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Insert_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  costAdjustment?: InputMaybe<CostAdjustment_Obj_Rel_Insert_Input>;
  costAdjustmentId?: InputMaybe<Scalars['uuid']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  endValue?: InputMaybe<Scalars['numeric']>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  jsonValue?: InputMaybe<Scalars['jsonb']>;
  singleValue?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type CostAdjustmentLookup_Max_Fields = {
  __typename?: 'costAdjustmentLookup_max_fields';
  cost?: Maybe<Scalars['numeric']>;
  costAdjustmentId?: Maybe<Scalars['uuid']>;
  effectiveDate?: Maybe<Scalars['date']>;
  endValue?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  singleValue?: Maybe<Scalars['String']>;
  startValue?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Max_Order_By = {
  cost?: InputMaybe<Order_By>;
  costAdjustmentId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  singleValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CostAdjustmentLookup_Min_Fields = {
  __typename?: 'costAdjustmentLookup_min_fields';
  cost?: Maybe<Scalars['numeric']>;
  costAdjustmentId?: Maybe<Scalars['uuid']>;
  effectiveDate?: Maybe<Scalars['date']>;
  endValue?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  singleValue?: Maybe<Scalars['String']>;
  startValue?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Min_Order_By = {
  cost?: InputMaybe<Order_By>;
  costAdjustmentId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  singleValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Mutation_Response = {
  __typename?: 'costAdjustmentLookup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CostAdjustmentLookup>;
};

/** input type for inserting object relation for remote table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Obj_Rel_Insert_Input = {
  data: CostAdjustmentLookup_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CostAdjustmentLookup_On_Conflict>;
};

/** on_conflict condition type for table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_On_Conflict = {
  constraint: CostAdjustmentLookup_Constraint;
  update_columns?: Array<CostAdjustmentLookup_Update_Column>;
  where?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
};

/** Ordering options when selecting data from "cost_adjustment_lookup". */
export type CostAdjustmentLookup_Order_By = {
  cost?: InputMaybe<Order_By>;
  costAdjustment?: InputMaybe<CostAdjustment_Order_By>;
  costAdjustmentId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jsonValue?: InputMaybe<Order_By>;
  singleValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cost_adjustment_lookup */
export type CostAdjustmentLookup_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CostAdjustmentLookup_Prepend_Input = {
  jsonValue?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cost_adjustment_lookup" */
export enum CostAdjustmentLookup_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostAdjustmentId = 'costAdjustmentId',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EndValue = 'endValue',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  JsonValue = 'jsonValue',
  /** column name */
  SingleValue = 'singleValue',
  /** column name */
  StartValue = 'startValue'
}

/** input type for updating data in table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Set_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  costAdjustmentId?: InputMaybe<Scalars['uuid']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  endValue?: InputMaybe<Scalars['numeric']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  jsonValue?: InputMaybe<Scalars['jsonb']>;
  singleValue?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type CostAdjustmentLookup_Stddev_Fields = {
  __typename?: 'costAdjustmentLookup_stddev_fields';
  cost?: Maybe<Scalars['Float']>;
  endValue?: Maybe<Scalars['Float']>;
  startValue?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CostAdjustmentLookup_Stddev_Pop_Fields = {
  __typename?: 'costAdjustmentLookup_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  endValue?: Maybe<Scalars['Float']>;
  startValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CostAdjustmentLookup_Stddev_Samp_Fields = {
  __typename?: 'costAdjustmentLookup_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  endValue?: Maybe<Scalars['Float']>;
  startValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "costAdjustmentLookup" */
export type CostAdjustmentLookup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CostAdjustmentLookup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CostAdjustmentLookup_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  costAdjustmentId?: InputMaybe<Scalars['uuid']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  endValue?: InputMaybe<Scalars['numeric']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  jsonValue?: InputMaybe<Scalars['jsonb']>;
  singleValue?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type CostAdjustmentLookup_Sum_Fields = {
  __typename?: 'costAdjustmentLookup_sum_fields';
  cost?: Maybe<Scalars['numeric']>;
  endValue?: Maybe<Scalars['numeric']>;
  startValue?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** update columns of table "cost_adjustment_lookup" */
export enum CostAdjustmentLookup_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostAdjustmentId = 'costAdjustmentId',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EndValue = 'endValue',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  JsonValue = 'jsonValue',
  /** column name */
  SingleValue = 'singleValue',
  /** column name */
  StartValue = 'startValue'
}

export type CostAdjustmentLookup_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CostAdjustmentLookup_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CostAdjustmentLookup_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CostAdjustmentLookup_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CostAdjustmentLookup_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CostAdjustmentLookup_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CostAdjustmentLookup_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CostAdjustmentLookup_Set_Input>;
  /** filter the rows which have to be updated */
  where: CostAdjustmentLookup_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CostAdjustmentLookup_Var_Pop_Fields = {
  __typename?: 'costAdjustmentLookup_var_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  endValue?: Maybe<Scalars['Float']>;
  startValue?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CostAdjustmentLookup_Var_Samp_Fields = {
  __typename?: 'costAdjustmentLookup_var_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  endValue?: Maybe<Scalars['Float']>;
  startValue?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CostAdjustmentLookup_Variance_Fields = {
  __typename?: 'costAdjustmentLookup_variance_fields';
  cost?: Maybe<Scalars['Float']>;
  endValue?: Maybe<Scalars['Float']>;
  startValue?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cost_adjustment_lookup" */
export type CostAdjustmentLookup_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
  endValue?: InputMaybe<Order_By>;
  startValue?: InputMaybe<Order_By>;
};

/** columns and relationships of "cost_adjustment_type" */
export type CostAdjustmentType = {
  __typename?: 'costAdjustmentType';
  /** An array relationship */
  costAdjustments: Array<CostAdjustment>;
  /** An aggregate relationship */
  costAdjustments_aggregate: CostAdjustment_Aggregate;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** columns and relationships of "cost_adjustment_type" */
export type CostAdjustmentTypeCostAdjustmentsArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustment_Order_By>>;
  where?: InputMaybe<CostAdjustment_Bool_Exp>;
};


/** columns and relationships of "cost_adjustment_type" */
export type CostAdjustmentTypeCostAdjustments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustment_Order_By>>;
  where?: InputMaybe<CostAdjustment_Bool_Exp>;
};

/** aggregated selection of "cost_adjustment_type" */
export type CostAdjustmentType_Aggregate = {
  __typename?: 'costAdjustmentType_aggregate';
  aggregate?: Maybe<CostAdjustmentType_Aggregate_Fields>;
  nodes: Array<CostAdjustmentType>;
};

/** aggregate fields of "cost_adjustment_type" */
export type CostAdjustmentType_Aggregate_Fields = {
  __typename?: 'costAdjustmentType_aggregate_fields';
  avg?: Maybe<CostAdjustmentType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CostAdjustmentType_Max_Fields>;
  min?: Maybe<CostAdjustmentType_Min_Fields>;
  stddev?: Maybe<CostAdjustmentType_Stddev_Fields>;
  stddev_pop?: Maybe<CostAdjustmentType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CostAdjustmentType_Stddev_Samp_Fields>;
  sum?: Maybe<CostAdjustmentType_Sum_Fields>;
  var_pop?: Maybe<CostAdjustmentType_Var_Pop_Fields>;
  var_samp?: Maybe<CostAdjustmentType_Var_Samp_Fields>;
  variance?: Maybe<CostAdjustmentType_Variance_Fields>;
};


/** aggregate fields of "cost_adjustment_type" */
export type CostAdjustmentType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CostAdjustmentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CostAdjustmentType_Avg_Fields = {
  __typename?: 'costAdjustmentType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cost_adjustment_type". All fields are combined with a logical 'AND'. */
export type CostAdjustmentType_Bool_Exp = {
  _and?: InputMaybe<Array<CostAdjustmentType_Bool_Exp>>;
  _not?: InputMaybe<CostAdjustmentType_Bool_Exp>;
  _or?: InputMaybe<Array<CostAdjustmentType_Bool_Exp>>;
  costAdjustments?: InputMaybe<CostAdjustment_Bool_Exp>;
  costAdjustments_aggregate?: InputMaybe<CostAdjustment_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cost_adjustment_type" */
export enum CostAdjustmentType_Constraint {
  /** unique or primary key constraint on columns "id" */
  CostAdjustmentTypeIdKey = 'cost_adjustment_type_id_key',
  /** unique or primary key constraint on columns "id" */
  CostAdjustmentTypePkey = 'cost_adjustment_type_pkey'
}

/** input type for incrementing numeric columns in table "cost_adjustment_type" */
export type CostAdjustmentType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cost_adjustment_type" */
export type CostAdjustmentType_Insert_Input = {
  costAdjustments?: InputMaybe<CostAdjustment_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CostAdjustmentType_Max_Fields = {
  __typename?: 'costAdjustmentType_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CostAdjustmentType_Min_Fields = {
  __typename?: 'costAdjustmentType_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cost_adjustment_type" */
export type CostAdjustmentType_Mutation_Response = {
  __typename?: 'costAdjustmentType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CostAdjustmentType>;
};

/** input type for inserting object relation for remote table "cost_adjustment_type" */
export type CostAdjustmentType_Obj_Rel_Insert_Input = {
  data: CostAdjustmentType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CostAdjustmentType_On_Conflict>;
};

/** on_conflict condition type for table "cost_adjustment_type" */
export type CostAdjustmentType_On_Conflict = {
  constraint: CostAdjustmentType_Constraint;
  update_columns?: Array<CostAdjustmentType_Update_Column>;
  where?: InputMaybe<CostAdjustmentType_Bool_Exp>;
};

/** Ordering options when selecting data from "cost_adjustment_type". */
export type CostAdjustmentType_Order_By = {
  costAdjustments_aggregate?: InputMaybe<CostAdjustment_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cost_adjustment_type */
export type CostAdjustmentType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "cost_adjustment_type" */
export enum CostAdjustmentType_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "cost_adjustment_type" */
export type CostAdjustmentType_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CostAdjustmentType_Stddev_Fields = {
  __typename?: 'costAdjustmentType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CostAdjustmentType_Stddev_Pop_Fields = {
  __typename?: 'costAdjustmentType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CostAdjustmentType_Stddev_Samp_Fields = {
  __typename?: 'costAdjustmentType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "costAdjustmentType" */
export type CostAdjustmentType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CostAdjustmentType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CostAdjustmentType_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CostAdjustmentType_Sum_Fields = {
  __typename?: 'costAdjustmentType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "cost_adjustment_type" */
export enum CostAdjustmentType_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type CostAdjustmentType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CostAdjustmentType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CostAdjustmentType_Set_Input>;
  /** filter the rows which have to be updated */
  where: CostAdjustmentType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CostAdjustmentType_Var_Pop_Fields = {
  __typename?: 'costAdjustmentType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CostAdjustmentType_Var_Samp_Fields = {
  __typename?: 'costAdjustmentType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CostAdjustmentType_Variance_Fields = {
  __typename?: 'costAdjustmentType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "cost_adjustment" */
export type CostAdjustment_Aggregate = {
  __typename?: 'costAdjustment_aggregate';
  aggregate?: Maybe<CostAdjustment_Aggregate_Fields>;
  nodes: Array<CostAdjustment>;
};

export type CostAdjustment_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<CostAdjustment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<CostAdjustment_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<CostAdjustment_Aggregate_Bool_Exp_Count>;
};

export type CostAdjustment_Aggregate_Bool_Exp_Bool_And = {
  arguments: CostAdjustment_Select_Column_CostAdjustment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CostAdjustment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type CostAdjustment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: CostAdjustment_Select_Column_CostAdjustment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CostAdjustment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type CostAdjustment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CostAdjustment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CostAdjustment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cost_adjustment" */
export type CostAdjustment_Aggregate_Fields = {
  __typename?: 'costAdjustment_aggregate_fields';
  avg?: Maybe<CostAdjustment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CostAdjustment_Max_Fields>;
  min?: Maybe<CostAdjustment_Min_Fields>;
  stddev?: Maybe<CostAdjustment_Stddev_Fields>;
  stddev_pop?: Maybe<CostAdjustment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CostAdjustment_Stddev_Samp_Fields>;
  sum?: Maybe<CostAdjustment_Sum_Fields>;
  var_pop?: Maybe<CostAdjustment_Var_Pop_Fields>;
  var_samp?: Maybe<CostAdjustment_Var_Samp_Fields>;
  variance?: Maybe<CostAdjustment_Variance_Fields>;
};


/** aggregate fields of "cost_adjustment" */
export type CostAdjustment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CostAdjustment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cost_adjustment" */
export type CostAdjustment_Aggregate_Order_By = {
  avg?: InputMaybe<CostAdjustment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CostAdjustment_Max_Order_By>;
  min?: InputMaybe<CostAdjustment_Min_Order_By>;
  stddev?: InputMaybe<CostAdjustment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CostAdjustment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CostAdjustment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CostAdjustment_Sum_Order_By>;
  var_pop?: InputMaybe<CostAdjustment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CostAdjustment_Var_Samp_Order_By>;
  variance?: InputMaybe<CostAdjustment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cost_adjustment" */
export type CostAdjustment_Arr_Rel_Insert_Input = {
  data: Array<CostAdjustment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CostAdjustment_On_Conflict>;
};

/** aggregate avg on columns */
export type CostAdjustment_Avg_Fields = {
  __typename?: 'costAdjustment_avg_fields';
  costAdjustmentTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cost_adjustment" */
export type CostAdjustment_Avg_Order_By = {
  costAdjustmentTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cost_adjustment". All fields are combined with a logical 'AND'. */
export type CostAdjustment_Bool_Exp = {
  _and?: InputMaybe<Array<CostAdjustment_Bool_Exp>>;
  _not?: InputMaybe<CostAdjustment_Bool_Exp>;
  _or?: InputMaybe<Array<CostAdjustment_Bool_Exp>>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  costAdjustmentExtendedCosts?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
  costAdjustmentExtendedCosts_aggregate?: InputMaybe<CostAdjustmentExtendedCost_Aggregate_Bool_Exp>;
  costAdjustmentLookups?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
  costAdjustmentLookups_aggregate?: InputMaybe<CostAdjustmentLookup_Aggregate_Bool_Exp>;
  costAdjustmentType?: InputMaybe<CostAdjustmentType_Bool_Exp>;
  costAdjustmentTypeId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isMultiply?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  productCosts?: InputMaybe<ProductCost_Bool_Exp>;
  productCosts_aggregate?: InputMaybe<ProductCost_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cost_adjustment" */
export enum CostAdjustment_Constraint {
  /** unique or primary key constraint on columns "id" */
  CostAdjustmentPkey = 'cost_adjustment_pkey'
}

/** input type for incrementing numeric columns in table "cost_adjustment" */
export type CostAdjustment_Inc_Input = {
  costAdjustmentTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cost_adjustment" */
export type CostAdjustment_Insert_Input = {
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  costAdjustmentExtendedCosts?: InputMaybe<CostAdjustmentExtendedCost_Arr_Rel_Insert_Input>;
  costAdjustmentLookups?: InputMaybe<CostAdjustmentLookup_Arr_Rel_Insert_Input>;
  costAdjustmentType?: InputMaybe<CostAdjustmentType_Obj_Rel_Insert_Input>;
  costAdjustmentTypeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  isMultiply?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  productCosts?: InputMaybe<ProductCost_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CostAdjustment_Max_Fields = {
  __typename?: 'costAdjustment_max_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  costAdjustmentTypeId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "cost_adjustment" */
export type CostAdjustment_Max_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  costAdjustmentTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CostAdjustment_Min_Fields = {
  __typename?: 'costAdjustment_min_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  costAdjustmentTypeId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "cost_adjustment" */
export type CostAdjustment_Min_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  costAdjustmentTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cost_adjustment" */
export type CostAdjustment_Mutation_Response = {
  __typename?: 'costAdjustment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CostAdjustment>;
};

/** input type for inserting object relation for remote table "cost_adjustment" */
export type CostAdjustment_Obj_Rel_Insert_Input = {
  data: CostAdjustment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CostAdjustment_On_Conflict>;
};

/** on_conflict condition type for table "cost_adjustment" */
export type CostAdjustment_On_Conflict = {
  constraint: CostAdjustment_Constraint;
  update_columns?: Array<CostAdjustment_Update_Column>;
  where?: InputMaybe<CostAdjustment_Bool_Exp>;
};

/** Ordering options when selecting data from "cost_adjustment". */
export type CostAdjustment_Order_By = {
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  costAdjustmentExtendedCosts_aggregate?: InputMaybe<CostAdjustmentExtendedCost_Aggregate_Order_By>;
  costAdjustmentLookups_aggregate?: InputMaybe<CostAdjustmentLookup_Aggregate_Order_By>;
  costAdjustmentType?: InputMaybe<CostAdjustmentType_Order_By>;
  costAdjustmentTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  isMultiply?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  productCosts_aggregate?: InputMaybe<ProductCost_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cost_adjustment */
export type CostAdjustment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cost_adjustment" */
export enum CostAdjustment_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CostAdjustmentTypeId = 'costAdjustmentTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsMultiply = 'isMultiply',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "costAdjustment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cost_adjustment" */
export enum CostAdjustment_Select_Column_CostAdjustment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsMultiply = 'isMultiply'
}

/** select "costAdjustment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cost_adjustment" */
export enum CostAdjustment_Select_Column_CostAdjustment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsMultiply = 'isMultiply'
}

/** input type for updating data in table "cost_adjustment" */
export type CostAdjustment_Set_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  costAdjustmentTypeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isMultiply?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CostAdjustment_Stddev_Fields = {
  __typename?: 'costAdjustment_stddev_fields';
  costAdjustmentTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cost_adjustment" */
export type CostAdjustment_Stddev_Order_By = {
  costAdjustmentTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CostAdjustment_Stddev_Pop_Fields = {
  __typename?: 'costAdjustment_stddev_pop_fields';
  costAdjustmentTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cost_adjustment" */
export type CostAdjustment_Stddev_Pop_Order_By = {
  costAdjustmentTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CostAdjustment_Stddev_Samp_Fields = {
  __typename?: 'costAdjustment_stddev_samp_fields';
  costAdjustmentTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cost_adjustment" */
export type CostAdjustment_Stddev_Samp_Order_By = {
  costAdjustmentTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "costAdjustment" */
export type CostAdjustment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CostAdjustment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CostAdjustment_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  costAdjustmentTypeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isMultiply?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CostAdjustment_Sum_Fields = {
  __typename?: 'costAdjustment_sum_fields';
  costAdjustmentTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "cost_adjustment" */
export type CostAdjustment_Sum_Order_By = {
  costAdjustmentTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "cost_adjustment" */
export enum CostAdjustment_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CostAdjustmentTypeId = 'costAdjustmentTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsMultiply = 'isMultiply',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CostAdjustment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CostAdjustment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CostAdjustment_Set_Input>;
  /** filter the rows which have to be updated */
  where: CostAdjustment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CostAdjustment_Var_Pop_Fields = {
  __typename?: 'costAdjustment_var_pop_fields';
  costAdjustmentTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cost_adjustment" */
export type CostAdjustment_Var_Pop_Order_By = {
  costAdjustmentTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CostAdjustment_Var_Samp_Fields = {
  __typename?: 'costAdjustment_var_samp_fields';
  costAdjustmentTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cost_adjustment" */
export type CostAdjustment_Var_Samp_Order_By = {
  costAdjustmentTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CostAdjustment_Variance_Fields = {
  __typename?: 'costAdjustment_variance_fields';
  costAdjustmentTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cost_adjustment" */
export type CostAdjustment_Variance_Order_By = {
  costAdjustmentTypeId?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** ordering argument of a cursor */
export enum Cursor_Ordering_Nhtsa {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** ordering argument of a cursor */
export enum Cursor_Ordering_Vpic {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "custom_field" */
export type CustomField = {
  __typename?: 'customField';
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  customFieldData: Array<CustomFieldData>;
  /** An aggregate relationship */
  customFieldData_aggregate: CustomFieldData_Aggregate;
  /** An object relationship */
  customFieldType?: Maybe<CustomFieldType>;
  customFieldTypeEnumValue: Scalars['numeric'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  entityCustomFields: Array<EntityCustomField>;
  /** An aggregate relationship */
  entityCustomFields_aggregate: EntityCustomField_Aggregate;
  /** An array relationship */
  entityDataDefinitions: Array<EntityDataDefinition>;
  /** An aggregate relationship */
  entityDataDefinitions_aggregate: EntityDataDefinition_Aggregate;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "custom_field" */
export type CustomFieldCustomFieldDataArgs = {
  distinct_on?: InputMaybe<Array<CustomFieldData_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomFieldData_Order_By>>;
  where?: InputMaybe<CustomFieldData_Bool_Exp>;
};


/** columns and relationships of "custom_field" */
export type CustomFieldCustomFieldData_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomFieldData_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomFieldData_Order_By>>;
  where?: InputMaybe<CustomFieldData_Bool_Exp>;
};


/** columns and relationships of "custom_field" */
export type CustomFieldEntityCustomFieldsArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomField_Order_By>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


/** columns and relationships of "custom_field" */
export type CustomFieldEntityCustomFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomField_Order_By>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


/** columns and relationships of "custom_field" */
export type CustomFieldEntityDataDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<EntityDataDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityDataDefinition_Order_By>>;
  where?: InputMaybe<EntityDataDefinition_Bool_Exp>;
};


/** columns and relationships of "custom_field" */
export type CustomFieldEntityDataDefinitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityDataDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityDataDefinition_Order_By>>;
  where?: InputMaybe<EntityDataDefinition_Bool_Exp>;
};

/** columns and relationships of "custom_field_data" */
export type CustomFieldData = {
  __typename?: 'customFieldData';
  /** An object relationship */
  customField: CustomField;
  customFieldId: Scalars['uuid'];
  data: Scalars['jsonb'];
  /** An array relationship */
  entityCustomFieldValues: Array<EntityCustomFieldValue>;
  /** An aggregate relationship */
  entityCustomFieldValues_aggregate: EntityCustomFieldValue_Aggregate;
  id: Scalars['uuid'];
};


/** columns and relationships of "custom_field_data" */
export type CustomFieldDataDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "custom_field_data" */
export type CustomFieldDataEntityCustomFieldValuesArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomFieldValue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomFieldValue_Order_By>>;
  where?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
};


/** columns and relationships of "custom_field_data" */
export type CustomFieldDataEntityCustomFieldValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomFieldValue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomFieldValue_Order_By>>;
  where?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
};

/** aggregated selection of "custom_field_data" */
export type CustomFieldData_Aggregate = {
  __typename?: 'customFieldData_aggregate';
  aggregate?: Maybe<CustomFieldData_Aggregate_Fields>;
  nodes: Array<CustomFieldData>;
};

export type CustomFieldData_Aggregate_Bool_Exp = {
  count?: InputMaybe<CustomFieldData_Aggregate_Bool_Exp_Count>;
};

export type CustomFieldData_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CustomFieldData_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CustomFieldData_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "custom_field_data" */
export type CustomFieldData_Aggregate_Fields = {
  __typename?: 'customFieldData_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CustomFieldData_Max_Fields>;
  min?: Maybe<CustomFieldData_Min_Fields>;
};


/** aggregate fields of "custom_field_data" */
export type CustomFieldData_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CustomFieldData_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "custom_field_data" */
export type CustomFieldData_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CustomFieldData_Max_Order_By>;
  min?: InputMaybe<CustomFieldData_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CustomFieldData_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "custom_field_data" */
export type CustomFieldData_Arr_Rel_Insert_Input = {
  data: Array<CustomFieldData_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldData_On_Conflict>;
};

/** Boolean expression to filter rows from the table "custom_field_data". All fields are combined with a logical 'AND'. */
export type CustomFieldData_Bool_Exp = {
  _and?: InputMaybe<Array<CustomFieldData_Bool_Exp>>;
  _not?: InputMaybe<CustomFieldData_Bool_Exp>;
  _or?: InputMaybe<Array<CustomFieldData_Bool_Exp>>;
  customField?: InputMaybe<CustomField_Bool_Exp>;
  customFieldId?: InputMaybe<Uuid_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  entityCustomFieldValues?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
  entityCustomFieldValues_aggregate?: InputMaybe<EntityCustomFieldValue_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_field_data" */
export enum CustomFieldData_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomFieldDataPkey = 'custom_field_data_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CustomFieldData_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CustomFieldData_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CustomFieldData_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "custom_field_data" */
export type CustomFieldData_Insert_Input = {
  customField?: InputMaybe<CustomField_Obj_Rel_Insert_Input>;
  customFieldId?: InputMaybe<Scalars['uuid']>;
  data?: InputMaybe<Scalars['jsonb']>;
  entityCustomFieldValues?: InputMaybe<EntityCustomFieldValue_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CustomFieldData_Max_Fields = {
  __typename?: 'customFieldData_max_fields';
  customFieldId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "custom_field_data" */
export type CustomFieldData_Max_Order_By = {
  customFieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CustomFieldData_Min_Fields = {
  __typename?: 'customFieldData_min_fields';
  customFieldId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "custom_field_data" */
export type CustomFieldData_Min_Order_By = {
  customFieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "custom_field_data" */
export type CustomFieldData_Mutation_Response = {
  __typename?: 'customFieldData_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomFieldData>;
};

/** input type for inserting object relation for remote table "custom_field_data" */
export type CustomFieldData_Obj_Rel_Insert_Input = {
  data: CustomFieldData_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldData_On_Conflict>;
};

/** on_conflict condition type for table "custom_field_data" */
export type CustomFieldData_On_Conflict = {
  constraint: CustomFieldData_Constraint;
  update_columns?: Array<CustomFieldData_Update_Column>;
  where?: InputMaybe<CustomFieldData_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_field_data". */
export type CustomFieldData_Order_By = {
  customField?: InputMaybe<CustomField_Order_By>;
  customFieldId?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  entityCustomFieldValues_aggregate?: InputMaybe<EntityCustomFieldValue_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_field_data */
export type CustomFieldData_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CustomFieldData_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "custom_field_data" */
export enum CustomFieldData_Select_Column {
  /** column name */
  CustomFieldId = 'customFieldId',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "custom_field_data" */
export type CustomFieldData_Set_Input = {
  customFieldId?: InputMaybe<Scalars['uuid']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "customFieldData" */
export type CustomFieldData_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CustomFieldData_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CustomFieldData_Stream_Cursor_Value_Input = {
  customFieldId?: InputMaybe<Scalars['uuid']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "custom_field_data" */
export enum CustomFieldData_Update_Column {
  /** column name */
  CustomFieldId = 'customFieldId',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id'
}

export type CustomFieldData_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CustomFieldData_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CustomFieldData_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CustomFieldData_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CustomFieldData_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CustomFieldData_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomFieldData_Set_Input>;
  /** filter the rows which have to be updated */
  where: CustomFieldData_Bool_Exp;
};

/** columns and relationships of "custom_field_type" */
export type CustomFieldType = {
  __typename?: 'customFieldType';
  display: Scalars['String'];
  /** An array relationship */
  entityDataDefinitions: Array<EntityDataDefinition>;
  /** An aggregate relationship */
  entityDataDefinitions_aggregate: EntityDataDefinition_Aggregate;
  enumValue: Scalars['numeric'];
  id: Scalars['uuid'];
  name: Scalars['String'];
};


/** columns and relationships of "custom_field_type" */
export type CustomFieldTypeEntityDataDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<EntityDataDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityDataDefinition_Order_By>>;
  where?: InputMaybe<EntityDataDefinition_Bool_Exp>;
};


/** columns and relationships of "custom_field_type" */
export type CustomFieldTypeEntityDataDefinitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityDataDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityDataDefinition_Order_By>>;
  where?: InputMaybe<EntityDataDefinition_Bool_Exp>;
};

/** aggregated selection of "custom_field_type" */
export type CustomFieldType_Aggregate = {
  __typename?: 'customFieldType_aggregate';
  aggregate?: Maybe<CustomFieldType_Aggregate_Fields>;
  nodes: Array<CustomFieldType>;
};

/** aggregate fields of "custom_field_type" */
export type CustomFieldType_Aggregate_Fields = {
  __typename?: 'customFieldType_aggregate_fields';
  avg?: Maybe<CustomFieldType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CustomFieldType_Max_Fields>;
  min?: Maybe<CustomFieldType_Min_Fields>;
  stddev?: Maybe<CustomFieldType_Stddev_Fields>;
  stddev_pop?: Maybe<CustomFieldType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CustomFieldType_Stddev_Samp_Fields>;
  sum?: Maybe<CustomFieldType_Sum_Fields>;
  var_pop?: Maybe<CustomFieldType_Var_Pop_Fields>;
  var_samp?: Maybe<CustomFieldType_Var_Samp_Fields>;
  variance?: Maybe<CustomFieldType_Variance_Fields>;
};


/** aggregate fields of "custom_field_type" */
export type CustomFieldType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CustomFieldType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CustomFieldType_Avg_Fields = {
  __typename?: 'customFieldType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "custom_field_type". All fields are combined with a logical 'AND'. */
export type CustomFieldType_Bool_Exp = {
  _and?: InputMaybe<Array<CustomFieldType_Bool_Exp>>;
  _not?: InputMaybe<CustomFieldType_Bool_Exp>;
  _or?: InputMaybe<Array<CustomFieldType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  entityDataDefinitions?: InputMaybe<EntityDataDefinition_Bool_Exp>;
  entityDataDefinitions_aggregate?: InputMaybe<EntityDataDefinition_Aggregate_Bool_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_field_type" */
export enum CustomFieldType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  CustomFieldTypeEnumValueKey = 'custom_field_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  CustomFieldTypePkey = 'custom_field_type_pkey'
}

/** input type for incrementing numeric columns in table "custom_field_type" */
export type CustomFieldType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "custom_field_type" */
export type CustomFieldType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  entityDataDefinitions?: InputMaybe<EntityDataDefinition_Arr_Rel_Insert_Input>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CustomFieldType_Max_Fields = {
  __typename?: 'customFieldType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CustomFieldType_Min_Fields = {
  __typename?: 'customFieldType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "custom_field_type" */
export type CustomFieldType_Mutation_Response = {
  __typename?: 'customFieldType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomFieldType>;
};

/** input type for inserting object relation for remote table "custom_field_type" */
export type CustomFieldType_Obj_Rel_Insert_Input = {
  data: CustomFieldType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldType_On_Conflict>;
};

/** on_conflict condition type for table "custom_field_type" */
export type CustomFieldType_On_Conflict = {
  constraint: CustomFieldType_Constraint;
  update_columns?: Array<CustomFieldType_Update_Column>;
  where?: InputMaybe<CustomFieldType_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_field_type". */
export type CustomFieldType_Order_By = {
  display?: InputMaybe<Order_By>;
  entityDataDefinitions_aggregate?: InputMaybe<EntityDataDefinition_Aggregate_Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_field_type */
export type CustomFieldType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "custom_field_type" */
export enum CustomFieldType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "custom_field_type" */
export type CustomFieldType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CustomFieldType_Stddev_Fields = {
  __typename?: 'customFieldType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CustomFieldType_Stddev_Pop_Fields = {
  __typename?: 'customFieldType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CustomFieldType_Stddev_Samp_Fields = {
  __typename?: 'customFieldType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "customFieldType" */
export type CustomFieldType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CustomFieldType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CustomFieldType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CustomFieldType_Sum_Fields = {
  __typename?: 'customFieldType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "custom_field_type" */
export enum CustomFieldType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type CustomFieldType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CustomFieldType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomFieldType_Set_Input>;
  /** filter the rows which have to be updated */
  where: CustomFieldType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CustomFieldType_Var_Pop_Fields = {
  __typename?: 'customFieldType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CustomFieldType_Var_Samp_Fields = {
  __typename?: 'customFieldType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CustomFieldType_Variance_Fields = {
  __typename?: 'customFieldType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "custom_field" */
export type CustomField_Aggregate = {
  __typename?: 'customField_aggregate';
  aggregate?: Maybe<CustomField_Aggregate_Fields>;
  nodes: Array<CustomField>;
};

/** aggregate fields of "custom_field" */
export type CustomField_Aggregate_Fields = {
  __typename?: 'customField_aggregate_fields';
  avg?: Maybe<CustomField_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CustomField_Max_Fields>;
  min?: Maybe<CustomField_Min_Fields>;
  stddev?: Maybe<CustomField_Stddev_Fields>;
  stddev_pop?: Maybe<CustomField_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CustomField_Stddev_Samp_Fields>;
  sum?: Maybe<CustomField_Sum_Fields>;
  var_pop?: Maybe<CustomField_Var_Pop_Fields>;
  var_samp?: Maybe<CustomField_Var_Samp_Fields>;
  variance?: Maybe<CustomField_Variance_Fields>;
};


/** aggregate fields of "custom_field" */
export type CustomField_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CustomField_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CustomField_Avg_Fields = {
  __typename?: 'customField_avg_fields';
  customFieldTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "custom_field". All fields are combined with a logical 'AND'. */
export type CustomField_Bool_Exp = {
  _and?: InputMaybe<Array<CustomField_Bool_Exp>>;
  _not?: InputMaybe<CustomField_Bool_Exp>;
  _or?: InputMaybe<Array<CustomField_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customFieldData?: InputMaybe<CustomFieldData_Bool_Exp>;
  customFieldData_aggregate?: InputMaybe<CustomFieldData_Aggregate_Bool_Exp>;
  customFieldType?: InputMaybe<CustomFieldType_Bool_Exp>;
  customFieldTypeEnumValue?: InputMaybe<Numeric_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entityCustomFields?: InputMaybe<EntityCustomField_Bool_Exp>;
  entityCustomFields_aggregate?: InputMaybe<EntityCustomField_Aggregate_Bool_Exp>;
  entityDataDefinitions?: InputMaybe<EntityDataDefinition_Bool_Exp>;
  entityDataDefinitions_aggregate?: InputMaybe<EntityDataDefinition_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_field" */
export enum CustomField_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomFieldPkey = 'custom_field_pkey'
}

/** input type for incrementing numeric columns in table "custom_field" */
export type CustomField_Inc_Input = {
  customFieldTypeEnumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "custom_field" */
export type CustomField_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customFieldData?: InputMaybe<CustomFieldData_Arr_Rel_Insert_Input>;
  customFieldType?: InputMaybe<CustomFieldType_Obj_Rel_Insert_Input>;
  customFieldTypeEnumValue?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  entityCustomFields?: InputMaybe<EntityCustomField_Arr_Rel_Insert_Input>;
  entityDataDefinitions?: InputMaybe<EntityDataDefinition_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CustomField_Max_Fields = {
  __typename?: 'customField_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customFieldTypeEnumValue?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CustomField_Min_Fields = {
  __typename?: 'customField_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customFieldTypeEnumValue?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "custom_field" */
export type CustomField_Mutation_Response = {
  __typename?: 'customField_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomField>;
};

/** input type for inserting object relation for remote table "custom_field" */
export type CustomField_Obj_Rel_Insert_Input = {
  data: CustomField_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomField_On_Conflict>;
};

/** on_conflict condition type for table "custom_field" */
export type CustomField_On_Conflict = {
  constraint: CustomField_Constraint;
  update_columns?: Array<CustomField_Update_Column>;
  where?: InputMaybe<CustomField_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_field". */
export type CustomField_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  customFieldData_aggregate?: InputMaybe<CustomFieldData_Aggregate_Order_By>;
  customFieldType?: InputMaybe<CustomFieldType_Order_By>;
  customFieldTypeEnumValue?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityCustomFields_aggregate?: InputMaybe<EntityCustomField_Aggregate_Order_By>;
  entityDataDefinitions_aggregate?: InputMaybe<EntityDataDefinition_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_field */
export type CustomField_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "custom_field" */
export enum CustomField_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomFieldTypeEnumValue = 'customFieldTypeEnumValue',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "custom_field" */
export type CustomField_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customFieldTypeEnumValue?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CustomField_Stddev_Fields = {
  __typename?: 'customField_stddev_fields';
  customFieldTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CustomField_Stddev_Pop_Fields = {
  __typename?: 'customField_stddev_pop_fields';
  customFieldTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CustomField_Stddev_Samp_Fields = {
  __typename?: 'customField_stddev_samp_fields';
  customFieldTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "customField" */
export type CustomField_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CustomField_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CustomField_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customFieldTypeEnumValue?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CustomField_Sum_Fields = {
  __typename?: 'customField_sum_fields';
  customFieldTypeEnumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "custom_field" */
export enum CustomField_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomFieldTypeEnumValue = 'customFieldTypeEnumValue',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CustomField_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CustomField_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomField_Set_Input>;
  /** filter the rows which have to be updated */
  where: CustomField_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CustomField_Var_Pop_Fields = {
  __typename?: 'customField_var_pop_fields';
  customFieldTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CustomField_Var_Samp_Fields = {
  __typename?: 'customField_var_samp_fields';
  customFieldTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CustomField_Variance_Fields = {
  __typename?: 'customField_variance_fields';
  customFieldTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "customer" */
export type Customer = {
  __typename?: 'customer';
  city: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['uuid'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  stateOrTerritoryAbbreviation: Scalars['String'];
  streetAddress: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  zipCode: Scalars['String'];
};

/** aggregated selection of "customer" */
export type Customer_Aggregate = {
  __typename?: 'customer_aggregate';
  aggregate?: Maybe<Customer_Aggregate_Fields>;
  nodes: Array<Customer>;
};

/** aggregate fields of "customer" */
export type Customer_Aggregate_Fields = {
  __typename?: 'customer_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Customer_Max_Fields>;
  min?: Maybe<Customer_Min_Fields>;
};


/** aggregate fields of "customer" */
export type Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "customer". All fields are combined with a logical 'AND'. */
export type Customer_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Bool_Exp>>;
  _not?: InputMaybe<Customer_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  fullName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  stateOrTerritoryAbbreviation?: InputMaybe<String_Comparison_Exp>;
  streetAddress?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  zipCode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer" */
export enum Customer_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerPkey = 'customer_pkey'
}

/** input type for inserting data into table "customer" */
export type Customer_Insert_Input = {
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  stateOrTerritoryAbbreviation?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Customer_Max_Fields = {
  __typename?: 'customer_max_fields';
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  stateOrTerritoryAbbreviation?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Customer_Min_Fields = {
  __typename?: 'customer_min_fields';
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  stateOrTerritoryAbbreviation?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "customer" */
export type Customer_Mutation_Response = {
  __typename?: 'customer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer>;
};

/** input type for inserting object relation for remote table "customer" */
export type Customer_Obj_Rel_Insert_Input = {
  data: Customer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_On_Conflict>;
};

/** on_conflict condition type for table "customer" */
export type Customer_On_Conflict = {
  constraint: Customer_Constraint;
  update_columns?: Array<Customer_Update_Column>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

/** Ordering options when selecting data from "customer". */
export type Customer_Order_By = {
  city?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  fullName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  stateOrTerritoryAbbreviation?: InputMaybe<Order_By>;
  streetAddress?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  zipCode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer */
export type Customer_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "customer" */
export enum Customer_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  StateOrTerritoryAbbreviation = 'stateOrTerritoryAbbreviation',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ZipCode = 'zipCode'
}

/** input type for updating data in table "customer" */
export type Customer_Set_Input = {
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  stateOrTerritoryAbbreviation?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "customer" */
export type Customer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  stateOrTerritoryAbbreviation?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** update columns of table "customer" */
export enum Customer_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  StateOrTerritoryAbbreviation = 'stateOrTerritoryAbbreviation',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ZipCode = 'zipCode'
}

export type Customer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Bool_Exp;
};

/** An accounting period with a name, dates and a closing date. The Journal Entries it holds are listed in cycle_journal_entry, placed there by whatever writes or places them; its dates name the period and do not decide which entries it holds. Its totals are kept in cycle_total. Cycles may cover any dates, overlap and share a name. Closing is a status, not a freeze: a closed Cycle can still be renamed, re-dated and reopened. */
export type Cycle = {
  __typename?: 'cycle';
  /** An object relationship */
  closedBy?: Maybe<Identity>;
  /** Kratos identity (ory.identity.id) of the signed-in user who closed the Cycle, taken from the Hasura session. No foreign key: the identity is mastered by Kratos. Null while the Cycle is open, and when it was closed outside Hasura, such as by the back-fill. */
  closedByIdentityId?: Maybe<Scalars['uuid']>;
  /** The last day of business the Cycle closes, inclusive. */
  closingDate: Scalars['date'];
  /** When the Cycle was created. */
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  cycleJournalEntries: Array<CycleJournalEntry>;
  /** An aggregate relationship */
  cycleJournalEntries_aggregate: CycleJournalEntry_Aggregate;
  /** An array relationship */
  cycleTotals: Array<CycleTotal>;
  /** An aggregate relationship */
  cycleTotals_aggregate: CycleTotal_Aggregate;
  /** Last day of the period the Cycle is named for, inclusive; on or after start_date. It does not decide which Journal Entries the Cycle holds. */
  endDate: Scalars['date'];
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  /** Primary key. */
  id: Scalars['uuid'];
  /** Whether the Cycle is closed. Setting it to true stamps closed_by_identity_id; setting it back to false reopens the Cycle and clears closed_by_identity_id. Closing freezes nothing. */
  isClosed: Scalars['Boolean'];
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** The Cycle's name, usually the month and year it covers, such as September 2026. Given when the Cycle is created and editable afterwards; changing its dates does not change it. Not unique: Cycles can share a name. */
  name: Scalars['String'];
  /** First day of the period the Cycle is named for, inclusive. It does not decide which Journal Entries the Cycle holds. */
  startDate: Scalars['date'];
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
  /** When the Cycle was last updated (maintained by trigger). */
  updatedAt: Scalars['timestamptz'];
};


/** An accounting period with a name, dates and a closing date. The Journal Entries it holds are listed in cycle_journal_entry, placed there by whatever writes or places them; its dates name the period and do not decide which entries it holds. Its totals are kept in cycle_total. Cycles may cover any dates, overlap and share a name. Closing is a status, not a freeze: a closed Cycle can still be renamed, re-dated and reopened. */
export type CycleCycleJournalEntriesArgs = {
  distinct_on?: InputMaybe<Array<CycleJournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleJournalEntry_Order_By>>;
  where?: InputMaybe<CycleJournalEntry_Bool_Exp>;
};


/** An accounting period with a name, dates and a closing date. The Journal Entries it holds are listed in cycle_journal_entry, placed there by whatever writes or places them; its dates name the period and do not decide which entries it holds. Its totals are kept in cycle_total. Cycles may cover any dates, overlap and share a name. Closing is a status, not a freeze: a closed Cycle can still be renamed, re-dated and reopened. */
export type CycleCycleJournalEntries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CycleJournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleJournalEntry_Order_By>>;
  where?: InputMaybe<CycleJournalEntry_Bool_Exp>;
};


/** An accounting period with a name, dates and a closing date. The Journal Entries it holds are listed in cycle_journal_entry, placed there by whatever writes or places them; its dates name the period and do not decide which entries it holds. Its totals are kept in cycle_total. Cycles may cover any dates, overlap and share a name. Closing is a status, not a freeze: a closed Cycle can still be renamed, re-dated and reopened. */
export type CycleCycleTotalsArgs = {
  distinct_on?: InputMaybe<Array<CycleTotal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleTotal_Order_By>>;
  where?: InputMaybe<CycleTotal_Bool_Exp>;
};


/** An accounting period with a name, dates and a closing date. The Journal Entries it holds are listed in cycle_journal_entry, placed there by whatever writes or places them; its dates name the period and do not decide which entries it holds. Its totals are kept in cycle_total. Cycles may cover any dates, overlap and share a name. Closing is a status, not a freeze: a closed Cycle can still be renamed, re-dated and reopened. */
export type CycleCycleTotals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CycleTotal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleTotal_Order_By>>;
  where?: InputMaybe<CycleTotal_Bool_Exp>;
};


/** An accounting period with a name, dates and a closing date. The Journal Entries it holds are listed in cycle_journal_entry, placed there by whatever writes or places them; its dates name the period and do not decide which entries it holds. Its totals are kept in cycle_total. Cycles may cover any dates, overlap and share a name. Closing is a status, not a freeze: a closed Cycle can still be renamed, re-dated and reopened. */
export type CycleEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** An accounting period with a name, dates and a closing date. The Journal Entries it holds are listed in cycle_journal_entry, placed there by whatever writes or places them; its dates name the period and do not decide which entries it holds. Its totals are kept in cycle_total. Cycles may cover any dates, overlap and share a name. Closing is a status, not a freeze: a closed Cycle can still be renamed, re-dated and reopened. */
export type CycleEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** An accounting period with a name, dates and a closing date. The Journal Entries it holds are listed in cycle_journal_entry, placed there by whatever writes or places them; its dates name the period and do not decide which entries it holds. Its totals are kept in cycle_total. Cycles may cover any dates, overlap and share a name. Closing is a status, not a freeze: a closed Cycle can still be renamed, re-dated and reopened. */
export type CycleLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};


/** An accounting period with a name, dates and a closing date. The Journal Entries it holds are listed in cycle_journal_entry, placed there by whatever writes or places them; its dates name the period and do not decide which entries it holds. Its totals are kept in cycle_total. Cycles may cover any dates, overlap and share a name. Closing is a status, not a freeze: a closed Cycle can still be renamed, re-dated and reopened. */
export type CycleLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** An accounting period with a name, dates and a closing date. The Journal Entries it holds are listed in cycle_journal_entry, placed there by whatever writes or places them; its dates name the period and do not decide which entries it holds. Its totals are kept in cycle_total. Cycles may cover any dates, overlap and share a name. Closing is a status, not a freeze: a closed Cycle can still be renamed, re-dated and reopened. */
export type CycleLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** Which Journal Entries a Cycle holds, one row per entry placed in it. Written by whatever places entries; nothing derives it from dates. Placing, moving or removing an entry refreshes the affected Cycles' totals. */
export type CycleJournalEntry = {
  __typename?: 'cycleJournalEntry';
  /** When the entry was listed for the Cycle. */
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  cycle: Cycle;
  /** The Cycle. */
  cycleId: Scalars['uuid'];
  /** Primary key. */
  id: Scalars['uuid'];
  /** An object relationship */
  journalEntry: JournalEntry;
  /** The Journal Entry the Cycle holds. */
  journalEntryId: Scalars['uuid'];
  /** When the row was last updated (maintained by trigger). */
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "accounting.cycle_journal_entry" */
export type CycleJournalEntry_Aggregate = {
  __typename?: 'cycleJournalEntry_aggregate';
  aggregate?: Maybe<CycleJournalEntry_Aggregate_Fields>;
  nodes: Array<CycleJournalEntry>;
};

export type CycleJournalEntry_Aggregate_Bool_Exp = {
  count?: InputMaybe<CycleJournalEntry_Aggregate_Bool_Exp_Count>;
};

export type CycleJournalEntry_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CycleJournalEntry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CycleJournalEntry_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "accounting.cycle_journal_entry" */
export type CycleJournalEntry_Aggregate_Fields = {
  __typename?: 'cycleJournalEntry_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CycleJournalEntry_Max_Fields>;
  min?: Maybe<CycleJournalEntry_Min_Fields>;
};


/** aggregate fields of "accounting.cycle_journal_entry" */
export type CycleJournalEntry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CycleJournalEntry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accounting.cycle_journal_entry" */
export type CycleJournalEntry_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CycleJournalEntry_Max_Order_By>;
  min?: InputMaybe<CycleJournalEntry_Min_Order_By>;
};

/** input type for inserting array relation for remote table "accounting.cycle_journal_entry" */
export type CycleJournalEntry_Arr_Rel_Insert_Input = {
  data: Array<CycleJournalEntry_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CycleJournalEntry_On_Conflict>;
};

/** Boolean expression to filter rows from the table "accounting.cycle_journal_entry". All fields are combined with a logical 'AND'. */
export type CycleJournalEntry_Bool_Exp = {
  _and?: InputMaybe<Array<CycleJournalEntry_Bool_Exp>>;
  _not?: InputMaybe<CycleJournalEntry_Bool_Exp>;
  _or?: InputMaybe<Array<CycleJournalEntry_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cycle?: InputMaybe<Cycle_Bool_Exp>;
  cycleId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journalEntry?: InputMaybe<JournalEntry_Bool_Exp>;
  journalEntryId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounting.cycle_journal_entry" */
export enum CycleJournalEntry_Constraint {
  /** unique or primary key constraint on columns "journal_entry_id", "cycle_id" */
  CycleJournalEntryCycleIdJournalEntryIdKey = 'cycle_journal_entry_cycle_id_journal_entry_id_key',
  /** unique or primary key constraint on columns "id" */
  CycleJournalEntryPkey = 'cycle_journal_entry_pkey'
}

/** input type for inserting data into table "accounting.cycle_journal_entry" */
export type CycleJournalEntry_Insert_Input = {
  /** When the entry was listed for the Cycle. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cycle?: InputMaybe<Cycle_Obj_Rel_Insert_Input>;
  /** The Cycle. */
  cycleId?: InputMaybe<Scalars['uuid']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  journalEntry?: InputMaybe<JournalEntry_Obj_Rel_Insert_Input>;
  /** The Journal Entry the Cycle holds. */
  journalEntryId?: InputMaybe<Scalars['uuid']>;
  /** When the row was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CycleJournalEntry_Max_Fields = {
  __typename?: 'cycleJournalEntry_max_fields';
  /** When the entry was listed for the Cycle. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The Cycle. */
  cycleId?: Maybe<Scalars['uuid']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /** The Journal Entry the Cycle holds. */
  journalEntryId?: Maybe<Scalars['uuid']>;
  /** When the row was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "accounting.cycle_journal_entry" */
export type CycleJournalEntry_Max_Order_By = {
  /** When the entry was listed for the Cycle. */
  createdAt?: InputMaybe<Order_By>;
  /** The Cycle. */
  cycleId?: InputMaybe<Order_By>;
  /** Primary key. */
  id?: InputMaybe<Order_By>;
  /** The Journal Entry the Cycle holds. */
  journalEntryId?: InputMaybe<Order_By>;
  /** When the row was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CycleJournalEntry_Min_Fields = {
  __typename?: 'cycleJournalEntry_min_fields';
  /** When the entry was listed for the Cycle. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The Cycle. */
  cycleId?: Maybe<Scalars['uuid']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /** The Journal Entry the Cycle holds. */
  journalEntryId?: Maybe<Scalars['uuid']>;
  /** When the row was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "accounting.cycle_journal_entry" */
export type CycleJournalEntry_Min_Order_By = {
  /** When the entry was listed for the Cycle. */
  createdAt?: InputMaybe<Order_By>;
  /** The Cycle. */
  cycleId?: InputMaybe<Order_By>;
  /** Primary key. */
  id?: InputMaybe<Order_By>;
  /** The Journal Entry the Cycle holds. */
  journalEntryId?: InputMaybe<Order_By>;
  /** When the row was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "accounting.cycle_journal_entry" */
export type CycleJournalEntry_Mutation_Response = {
  __typename?: 'cycleJournalEntry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CycleJournalEntry>;
};

/** on_conflict condition type for table "accounting.cycle_journal_entry" */
export type CycleJournalEntry_On_Conflict = {
  constraint: CycleJournalEntry_Constraint;
  update_columns?: Array<CycleJournalEntry_Update_Column>;
  where?: InputMaybe<CycleJournalEntry_Bool_Exp>;
};

/** Ordering options when selecting data from "accounting.cycle_journal_entry". */
export type CycleJournalEntry_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Cycle_Order_By>;
  cycleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journalEntry?: InputMaybe<JournalEntry_Order_By>;
  journalEntryId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounting.cycle_journal_entry */
export type CycleJournalEntry_Pk_Columns_Input = {
  /** Primary key. */
  id: Scalars['uuid'];
};

/** select columns of table "accounting.cycle_journal_entry" */
export enum CycleJournalEntry_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CycleId = 'cycleId',
  /** column name */
  Id = 'id',
  /** column name */
  JournalEntryId = 'journalEntryId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "accounting.cycle_journal_entry" */
export type CycleJournalEntry_Set_Input = {
  /** When the entry was listed for the Cycle. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Cycle. */
  cycleId?: InputMaybe<Scalars['uuid']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** The Journal Entry the Cycle holds. */
  journalEntryId?: InputMaybe<Scalars['uuid']>;
  /** When the row was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "cycleJournalEntry" */
export type CycleJournalEntry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CycleJournalEntry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CycleJournalEntry_Stream_Cursor_Value_Input = {
  /** When the entry was listed for the Cycle. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Cycle. */
  cycleId?: InputMaybe<Scalars['uuid']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** The Journal Entry the Cycle holds. */
  journalEntryId?: InputMaybe<Scalars['uuid']>;
  /** When the row was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "accounting.cycle_journal_entry" */
export enum CycleJournalEntry_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CycleId = 'cycleId',
  /** column name */
  Id = 'id',
  /** column name */
  JournalEntryId = 'journalEntryId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CycleJournalEntry_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CycleJournalEntry_Set_Input>;
  /** filter the rows which have to be updated */
  where: CycleJournalEntry_Bool_Exp;
};

/** A Cycle's totals, one row per line type and name, summing the lines of the Journal Entries it holds. Kept current by refresh_cycle_totals whenever an entry is placed in or removed from the Cycle, or a line of an entry it holds changes, so reading a Cycle's totals is a lookup rather than a sum. */
export type CycleTotal = {
  __typename?: 'cycleTotal';
  /** When the total was written. */
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  cycle: Cycle;
  /** The Cycle. */
  cycleId: Scalars['uuid'];
  /** Primary key. */
  id: Scalars['uuid'];
  /** An object relationship */
  journalEntryLineType: Type;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId: Scalars['uuid'];
  /** How many lines the total sums. */
  lineCount: Scalars['Int'];
  /** The line name totaled: a Bucket, a disbursement type, or a surcharge type. */
  name: Scalars['String'];
  /** The sum of those lines' amounts in dollars. */
  totalAmount: Scalars['numeric'];
  /** When the total was last updated (maintained by trigger). */
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "accounting.cycle_total" */
export type CycleTotal_Aggregate = {
  __typename?: 'cycleTotal_aggregate';
  aggregate?: Maybe<CycleTotal_Aggregate_Fields>;
  nodes: Array<CycleTotal>;
};

export type CycleTotal_Aggregate_Bool_Exp = {
  count?: InputMaybe<CycleTotal_Aggregate_Bool_Exp_Count>;
};

export type CycleTotal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CycleTotal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CycleTotal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "accounting.cycle_total" */
export type CycleTotal_Aggregate_Fields = {
  __typename?: 'cycleTotal_aggregate_fields';
  avg?: Maybe<CycleTotal_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CycleTotal_Max_Fields>;
  min?: Maybe<CycleTotal_Min_Fields>;
  stddev?: Maybe<CycleTotal_Stddev_Fields>;
  stddev_pop?: Maybe<CycleTotal_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CycleTotal_Stddev_Samp_Fields>;
  sum?: Maybe<CycleTotal_Sum_Fields>;
  var_pop?: Maybe<CycleTotal_Var_Pop_Fields>;
  var_samp?: Maybe<CycleTotal_Var_Samp_Fields>;
  variance?: Maybe<CycleTotal_Variance_Fields>;
};


/** aggregate fields of "accounting.cycle_total" */
export type CycleTotal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CycleTotal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accounting.cycle_total" */
export type CycleTotal_Aggregate_Order_By = {
  avg?: InputMaybe<CycleTotal_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CycleTotal_Max_Order_By>;
  min?: InputMaybe<CycleTotal_Min_Order_By>;
  stddev?: InputMaybe<CycleTotal_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CycleTotal_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CycleTotal_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CycleTotal_Sum_Order_By>;
  var_pop?: InputMaybe<CycleTotal_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CycleTotal_Var_Samp_Order_By>;
  variance?: InputMaybe<CycleTotal_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "accounting.cycle_total" */
export type CycleTotal_Arr_Rel_Insert_Input = {
  data: Array<CycleTotal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CycleTotal_On_Conflict>;
};

/** aggregate avg on columns */
export type CycleTotal_Avg_Fields = {
  __typename?: 'cycleTotal_avg_fields';
  /** How many lines the total sums. */
  lineCount?: Maybe<Scalars['Float']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "accounting.cycle_total" */
export type CycleTotal_Avg_Order_By = {
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Order_By>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "accounting.cycle_total". All fields are combined with a logical 'AND'. */
export type CycleTotal_Bool_Exp = {
  _and?: InputMaybe<Array<CycleTotal_Bool_Exp>>;
  _not?: InputMaybe<CycleTotal_Bool_Exp>;
  _or?: InputMaybe<Array<CycleTotal_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cycle?: InputMaybe<Cycle_Bool_Exp>;
  cycleId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journalEntryLineType?: InputMaybe<Type_Bool_Exp>;
  journalEntryLineTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  lineCount?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  totalAmount?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounting.cycle_total" */
export enum CycleTotal_Constraint {
  /** unique or primary key constraint on columns "journal_entry_line_type_id", "cycle_id", "name" */
  CycleTotalCycleIdJournalEntryLineTypeIdNameKey = 'cycle_total_cycle_id_journal_entry_line_type_id_name_key',
  /** unique or primary key constraint on columns "id" */
  CycleTotalPkey = 'cycle_total_pkey'
}

/** input type for incrementing numeric columns in table "accounting.cycle_total" */
export type CycleTotal_Inc_Input = {
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Scalars['Int']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "accounting.cycle_total" */
export type CycleTotal_Insert_Input = {
  /** When the total was written. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cycle?: InputMaybe<Cycle_Obj_Rel_Insert_Input>;
  /** The Cycle. */
  cycleId?: InputMaybe<Scalars['uuid']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  journalEntryLineType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: InputMaybe<Scalars['uuid']>;
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Scalars['Int']>;
  /** The line name totaled: a Bucket, a disbursement type, or a surcharge type. */
  name?: InputMaybe<Scalars['String']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Scalars['numeric']>;
  /** When the total was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CycleTotal_Max_Fields = {
  __typename?: 'cycleTotal_max_fields';
  /** When the total was written. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The Cycle. */
  cycleId?: Maybe<Scalars['uuid']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: Maybe<Scalars['uuid']>;
  /** How many lines the total sums. */
  lineCount?: Maybe<Scalars['Int']>;
  /** The line name totaled: a Bucket, a disbursement type, or a surcharge type. */
  name?: Maybe<Scalars['String']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: Maybe<Scalars['numeric']>;
  /** When the total was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "accounting.cycle_total" */
export type CycleTotal_Max_Order_By = {
  /** When the total was written. */
  createdAt?: InputMaybe<Order_By>;
  /** The Cycle. */
  cycleId?: InputMaybe<Order_By>;
  /** Primary key. */
  id?: InputMaybe<Order_By>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: InputMaybe<Order_By>;
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Order_By>;
  /** The line name totaled: a Bucket, a disbursement type, or a surcharge type. */
  name?: InputMaybe<Order_By>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Order_By>;
  /** When the total was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CycleTotal_Min_Fields = {
  __typename?: 'cycleTotal_min_fields';
  /** When the total was written. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The Cycle. */
  cycleId?: Maybe<Scalars['uuid']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: Maybe<Scalars['uuid']>;
  /** How many lines the total sums. */
  lineCount?: Maybe<Scalars['Int']>;
  /** The line name totaled: a Bucket, a disbursement type, or a surcharge type. */
  name?: Maybe<Scalars['String']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: Maybe<Scalars['numeric']>;
  /** When the total was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "accounting.cycle_total" */
export type CycleTotal_Min_Order_By = {
  /** When the total was written. */
  createdAt?: InputMaybe<Order_By>;
  /** The Cycle. */
  cycleId?: InputMaybe<Order_By>;
  /** Primary key. */
  id?: InputMaybe<Order_By>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: InputMaybe<Order_By>;
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Order_By>;
  /** The line name totaled: a Bucket, a disbursement type, or a surcharge type. */
  name?: InputMaybe<Order_By>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Order_By>;
  /** When the total was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "accounting.cycle_total" */
export type CycleTotal_Mutation_Response = {
  __typename?: 'cycleTotal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CycleTotal>;
};

/** on_conflict condition type for table "accounting.cycle_total" */
export type CycleTotal_On_Conflict = {
  constraint: CycleTotal_Constraint;
  update_columns?: Array<CycleTotal_Update_Column>;
  where?: InputMaybe<CycleTotal_Bool_Exp>;
};

/** Ordering options when selecting data from "accounting.cycle_total". */
export type CycleTotal_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  cycle?: InputMaybe<Cycle_Order_By>;
  cycleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journalEntryLineType?: InputMaybe<Type_Order_By>;
  journalEntryLineTypeId?: InputMaybe<Order_By>;
  lineCount?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  totalAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounting.cycle_total */
export type CycleTotal_Pk_Columns_Input = {
  /** Primary key. */
  id: Scalars['uuid'];
};

/** select columns of table "accounting.cycle_total" */
export enum CycleTotal_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CycleId = 'cycleId',
  /** column name */
  Id = 'id',
  /** column name */
  JournalEntryLineTypeId = 'journalEntryLineTypeId',
  /** column name */
  LineCount = 'lineCount',
  /** column name */
  Name = 'name',
  /** column name */
  TotalAmount = 'totalAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "accounting.cycle_total" */
export type CycleTotal_Set_Input = {
  /** When the total was written. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Cycle. */
  cycleId?: InputMaybe<Scalars['uuid']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: InputMaybe<Scalars['uuid']>;
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Scalars['Int']>;
  /** The line name totaled: a Bucket, a disbursement type, or a surcharge type. */
  name?: InputMaybe<Scalars['String']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Scalars['numeric']>;
  /** When the total was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CycleTotal_Stddev_Fields = {
  __typename?: 'cycleTotal_stddev_fields';
  /** How many lines the total sums. */
  lineCount?: Maybe<Scalars['Float']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "accounting.cycle_total" */
export type CycleTotal_Stddev_Order_By = {
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Order_By>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CycleTotal_Stddev_Pop_Fields = {
  __typename?: 'cycleTotal_stddev_pop_fields';
  /** How many lines the total sums. */
  lineCount?: Maybe<Scalars['Float']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "accounting.cycle_total" */
export type CycleTotal_Stddev_Pop_Order_By = {
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Order_By>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CycleTotal_Stddev_Samp_Fields = {
  __typename?: 'cycleTotal_stddev_samp_fields';
  /** How many lines the total sums. */
  lineCount?: Maybe<Scalars['Float']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "accounting.cycle_total" */
export type CycleTotal_Stddev_Samp_Order_By = {
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Order_By>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cycleTotal" */
export type CycleTotal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CycleTotal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CycleTotal_Stream_Cursor_Value_Input = {
  /** When the total was written. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The Cycle. */
  cycleId?: InputMaybe<Scalars['uuid']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: InputMaybe<Scalars['uuid']>;
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Scalars['Int']>;
  /** The line name totaled: a Bucket, a disbursement type, or a surcharge type. */
  name?: InputMaybe<Scalars['String']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Scalars['numeric']>;
  /** When the total was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CycleTotal_Sum_Fields = {
  __typename?: 'cycleTotal_sum_fields';
  /** How many lines the total sums. */
  lineCount?: Maybe<Scalars['Int']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "accounting.cycle_total" */
export type CycleTotal_Sum_Order_By = {
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Order_By>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Order_By>;
};

/** update columns of table "accounting.cycle_total" */
export enum CycleTotal_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CycleId = 'cycleId',
  /** column name */
  Id = 'id',
  /** column name */
  JournalEntryLineTypeId = 'journalEntryLineTypeId',
  /** column name */
  LineCount = 'lineCount',
  /** column name */
  Name = 'name',
  /** column name */
  TotalAmount = 'totalAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CycleTotal_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CycleTotal_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CycleTotal_Set_Input>;
  /** filter the rows which have to be updated */
  where: CycleTotal_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CycleTotal_Var_Pop_Fields = {
  __typename?: 'cycleTotal_var_pop_fields';
  /** How many lines the total sums. */
  lineCount?: Maybe<Scalars['Float']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "accounting.cycle_total" */
export type CycleTotal_Var_Pop_Order_By = {
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Order_By>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CycleTotal_Var_Samp_Fields = {
  __typename?: 'cycleTotal_var_samp_fields';
  /** How many lines the total sums. */
  lineCount?: Maybe<Scalars['Float']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "accounting.cycle_total" */
export type CycleTotal_Var_Samp_Order_By = {
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Order_By>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CycleTotal_Variance_Fields = {
  __typename?: 'cycleTotal_variance_fields';
  /** How many lines the total sums. */
  lineCount?: Maybe<Scalars['Float']>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "accounting.cycle_total" */
export type CycleTotal_Variance_Order_By = {
  /** How many lines the total sums. */
  lineCount?: InputMaybe<Order_By>;
  /** The sum of those lines' amounts in dollars. */
  totalAmount?: InputMaybe<Order_By>;
};

/** aggregated selection of "accounting.cycle" */
export type Cycle_Aggregate = {
  __typename?: 'cycle_aggregate';
  aggregate?: Maybe<Cycle_Aggregate_Fields>;
  nodes: Array<Cycle>;
};

/** aggregate fields of "accounting.cycle" */
export type Cycle_Aggregate_Fields = {
  __typename?: 'cycle_aggregate_fields';
  avg?: Maybe<Cycle_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Cycle_Max_Fields>;
  min?: Maybe<Cycle_Min_Fields>;
  stddev?: Maybe<Cycle_Stddev_Fields>;
  stddev_pop?: Maybe<Cycle_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cycle_Stddev_Samp_Fields>;
  sum?: Maybe<Cycle_Sum_Fields>;
  var_pop?: Maybe<Cycle_Var_Pop_Fields>;
  var_samp?: Maybe<Cycle_Var_Samp_Fields>;
  variance?: Maybe<Cycle_Variance_Fields>;
};


/** aggregate fields of "accounting.cycle" */
export type Cycle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cycle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Cycle_Avg_Fields = {
  __typename?: 'cycle_avg_fields';
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate avg on columns */
export type Cycle_Avg_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};

/** Boolean expression to filter rows from the table "accounting.cycle". All fields are combined with a logical 'AND'. */
export type Cycle_Bool_Exp = {
  _and?: InputMaybe<Array<Cycle_Bool_Exp>>;
  _not?: InputMaybe<Cycle_Bool_Exp>;
  _or?: InputMaybe<Array<Cycle_Bool_Exp>>;
  closedBy?: InputMaybe<Identity_Bool_Exp>;
  closedByIdentityId?: InputMaybe<Uuid_Comparison_Exp>;
  closingDate?: InputMaybe<Date_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cycleJournalEntries?: InputMaybe<CycleJournalEntry_Bool_Exp>;
  cycleJournalEntries_aggregate?: InputMaybe<CycleJournalEntry_Aggregate_Bool_Exp>;
  cycleTotals?: InputMaybe<CycleTotal_Bool_Exp>;
  cycleTotals_aggregate?: InputMaybe<CycleTotal_Aggregate_Bool_Exp>;
  endDate?: InputMaybe<Date_Comparison_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isClosed?: InputMaybe<Boolean_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  startDate?: InputMaybe<Date_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounting.cycle" */
export enum Cycle_Constraint {
  /** unique or primary key constraint on columns "id" */
  CyclePkey = 'cycle_pkey'
}

/** input type for inserting data into table "accounting.cycle" */
export type Cycle_Insert_Input = {
  closedBy?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  /** Kratos identity (ory.identity.id) of the signed-in user who closed the Cycle, taken from the Hasura session. No foreign key: the identity is mastered by Kratos. Null while the Cycle is open, and when it was closed outside Hasura, such as by the back-fill. */
  closedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** The last day of business the Cycle closes, inclusive. */
  closingDate?: InputMaybe<Scalars['date']>;
  /** When the Cycle was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cycleJournalEntries?: InputMaybe<CycleJournalEntry_Arr_Rel_Insert_Input>;
  cycleTotals?: InputMaybe<CycleTotal_Arr_Rel_Insert_Input>;
  /** Last day of the period the Cycle is named for, inclusive; on or after start_date. It does not decide which Journal Entries the Cycle holds. */
  endDate?: InputMaybe<Scalars['date']>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** Whether the Cycle is closed. Setting it to true stamps closed_by_identity_id; setting it back to false reopens the Cycle and clears closed_by_identity_id. Closing freezes nothing. */
  isClosed?: InputMaybe<Scalars['Boolean']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  /** The Cycle's name, usually the month and year it covers, such as September 2026. Given when the Cycle is created and editable afterwards; changing its dates does not change it. Not unique: Cycles can share a name. */
  name?: InputMaybe<Scalars['String']>;
  /** First day of the period the Cycle is named for, inclusive. It does not decide which Journal Entries the Cycle holds. */
  startDate?: InputMaybe<Scalars['date']>;
  /** When the Cycle was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Cycle_Max_Fields = {
  __typename?: 'cycle_max_fields';
  /** Kratos identity (ory.identity.id) of the signed-in user who closed the Cycle, taken from the Hasura session. No foreign key: the identity is mastered by Kratos. Null while the Cycle is open, and when it was closed outside Hasura, such as by the back-fill. */
  closedByIdentityId?: Maybe<Scalars['uuid']>;
  /** The last day of business the Cycle closes, inclusive. */
  closingDate?: Maybe<Scalars['date']>;
  /** When the Cycle was created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Last day of the period the Cycle is named for, inclusive; on or after start_date. It does not decide which Journal Entries the Cycle holds. */
  endDate?: Maybe<Scalars['date']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The Cycle's name, usually the month and year it covers, such as September 2026. Given when the Cycle is created and editable afterwards; changing its dates does not change it. Not unique: Cycles can share a name. */
  name?: Maybe<Scalars['String']>;
  /** First day of the period the Cycle is named for, inclusive. It does not decide which Journal Entries the Cycle holds. */
  startDate?: Maybe<Scalars['date']>;
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
  /** When the Cycle was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** aggregate max on columns */
export type Cycle_Max_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};

/** aggregate min on columns */
export type Cycle_Min_Fields = {
  __typename?: 'cycle_min_fields';
  /** Kratos identity (ory.identity.id) of the signed-in user who closed the Cycle, taken from the Hasura session. No foreign key: the identity is mastered by Kratos. Null while the Cycle is open, and when it was closed outside Hasura, such as by the back-fill. */
  closedByIdentityId?: Maybe<Scalars['uuid']>;
  /** The last day of business the Cycle closes, inclusive. */
  closingDate?: Maybe<Scalars['date']>;
  /** When the Cycle was created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Last day of the period the Cycle is named for, inclusive; on or after start_date. It does not decide which Journal Entries the Cycle holds. */
  endDate?: Maybe<Scalars['date']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The Cycle's name, usually the month and year it covers, such as September 2026. Given when the Cycle is created and editable afterwards; changing its dates does not change it. Not unique: Cycles can share a name. */
  name?: Maybe<Scalars['String']>;
  /** First day of the period the Cycle is named for, inclusive. It does not decide which Journal Entries the Cycle holds. */
  startDate?: Maybe<Scalars['date']>;
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
  /** When the Cycle was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** aggregate min on columns */
export type Cycle_Min_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};

/** response of any mutation on the table "accounting.cycle" */
export type Cycle_Mutation_Response = {
  __typename?: 'cycle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cycle>;
};

/** input type for inserting object relation for remote table "accounting.cycle" */
export type Cycle_Obj_Rel_Insert_Input = {
  data: Cycle_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cycle_On_Conflict>;
};

/** on_conflict condition type for table "accounting.cycle" */
export type Cycle_On_Conflict = {
  constraint: Cycle_Constraint;
  update_columns?: Array<Cycle_Update_Column>;
  where?: InputMaybe<Cycle_Bool_Exp>;
};

/** Ordering options when selecting data from "accounting.cycle". */
export type Cycle_Order_By = {
  closedBy?: InputMaybe<Identity_Order_By>;
  closedByIdentityId?: InputMaybe<Order_By>;
  closingDate?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cycleJournalEntries_aggregate?: InputMaybe<CycleJournalEntry_Aggregate_Order_By>;
  cycleTotals_aggregate?: InputMaybe<CycleTotal_Aggregate_Order_By>;
  endDate?: InputMaybe<Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  isClosed?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounting.cycle */
export type Cycle_Pk_Columns_Input = {
  /** Primary key. */
  id: Scalars['uuid'];
};

/** select columns of table "accounting.cycle" */
export enum Cycle_Select_Column {
  /** column name */
  ClosedByIdentityId = 'closedByIdentityId',
  /** column name */
  ClosingDate = 'closingDate',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'isClosed',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "accounting.cycle" */
export type Cycle_Set_Input = {
  /** Kratos identity (ory.identity.id) of the signed-in user who closed the Cycle, taken from the Hasura session. No foreign key: the identity is mastered by Kratos. Null while the Cycle is open, and when it was closed outside Hasura, such as by the back-fill. */
  closedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** The last day of business the Cycle closes, inclusive. */
  closingDate?: InputMaybe<Scalars['date']>;
  /** When the Cycle was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Last day of the period the Cycle is named for, inclusive; on or after start_date. It does not decide which Journal Entries the Cycle holds. */
  endDate?: InputMaybe<Scalars['date']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** Whether the Cycle is closed. Setting it to true stamps closed_by_identity_id; setting it back to false reopens the Cycle and clears closed_by_identity_id. Closing freezes nothing. */
  isClosed?: InputMaybe<Scalars['Boolean']>;
  /** The Cycle's name, usually the month and year it covers, such as September 2026. Given when the Cycle is created and editable afterwards; changing its dates does not change it. Not unique: Cycles can share a name. */
  name?: InputMaybe<Scalars['String']>;
  /** First day of the period the Cycle is named for, inclusive. It does not decide which Journal Entries the Cycle holds. */
  startDate?: InputMaybe<Scalars['date']>;
  /** When the Cycle was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Cycle_Stddev_Fields = {
  __typename?: 'cycle_stddev_fields';
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate stddev on columns */
export type Cycle_Stddev_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};

/** aggregate stddev_pop on columns */
export type Cycle_Stddev_Pop_Fields = {
  __typename?: 'cycle_stddev_pop_fields';
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate stddev_pop on columns */
export type Cycle_Stddev_Pop_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};

/** aggregate stddev_samp on columns */
export type Cycle_Stddev_Samp_Fields = {
  __typename?: 'cycle_stddev_samp_fields';
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate stddev_samp on columns */
export type Cycle_Stddev_Samp_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};

/** Streaming cursor of the table "cycle" */
export type Cycle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cycle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cycle_Stream_Cursor_Value_Input = {
  /** Kratos identity (ory.identity.id) of the signed-in user who closed the Cycle, taken from the Hasura session. No foreign key: the identity is mastered by Kratos. Null while the Cycle is open, and when it was closed outside Hasura, such as by the back-fill. */
  closedByIdentityId?: InputMaybe<Scalars['uuid']>;
  /** The last day of business the Cycle closes, inclusive. */
  closingDate?: InputMaybe<Scalars['date']>;
  /** When the Cycle was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Last day of the period the Cycle is named for, inclusive; on or after start_date. It does not decide which Journal Entries the Cycle holds. */
  endDate?: InputMaybe<Scalars['date']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** Whether the Cycle is closed. Setting it to true stamps closed_by_identity_id; setting it back to false reopens the Cycle and clears closed_by_identity_id. Closing freezes nothing. */
  isClosed?: InputMaybe<Scalars['Boolean']>;
  /** The Cycle's name, usually the month and year it covers, such as September 2026. Given when the Cycle is created and editable afterwards; changing its dates does not change it. Not unique: Cycles can share a name. */
  name?: InputMaybe<Scalars['String']>;
  /** First day of the period the Cycle is named for, inclusive. It does not decide which Journal Entries the Cycle holds. */
  startDate?: InputMaybe<Scalars['date']>;
  /** When the Cycle was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Cycle_Sum_Fields = {
  __typename?: 'cycle_sum_fields';
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate sum on columns */
export type Cycle_Sum_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};

/** update columns of table "accounting.cycle" */
export enum Cycle_Update_Column {
  /** column name */
  ClosedByIdentityId = 'closedByIdentityId',
  /** column name */
  ClosingDate = 'closingDate',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsClosed = 'isClosed',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Cycle_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cycle_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cycle_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cycle_Var_Pop_Fields = {
  __typename?: 'cycle_var_pop_fields';
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate var_pop on columns */
export type Cycle_Var_Pop_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};

/** aggregate var_samp on columns */
export type Cycle_Var_Samp_Fields = {
  __typename?: 'cycle_var_samp_fields';
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate var_samp on columns */
export type Cycle_Var_Samp_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};

/** aggregate variance on columns */
export type Cycle_Variance_Fields = {
  __typename?: 'cycle_variance_fields';
  /** The Cycle's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The Cycle's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate variance on columns */
export type Cycle_Variance_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_Cycle_Args;
};

/** columns and relationships of "data_type" */
export type DataType = {
  __typename?: 'dataType';
  display: Scalars['String'];
  enumValue: Scalars['numeric'];
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** aggregated selection of "data_type" */
export type DataType_Aggregate = {
  __typename?: 'dataType_aggregate';
  aggregate?: Maybe<DataType_Aggregate_Fields>;
  nodes: Array<DataType>;
};

/** aggregate fields of "data_type" */
export type DataType_Aggregate_Fields = {
  __typename?: 'dataType_aggregate_fields';
  avg?: Maybe<DataType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<DataType_Max_Fields>;
  min?: Maybe<DataType_Min_Fields>;
  stddev?: Maybe<DataType_Stddev_Fields>;
  stddev_pop?: Maybe<DataType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DataType_Stddev_Samp_Fields>;
  sum?: Maybe<DataType_Sum_Fields>;
  var_pop?: Maybe<DataType_Var_Pop_Fields>;
  var_samp?: Maybe<DataType_Var_Samp_Fields>;
  variance?: Maybe<DataType_Variance_Fields>;
};


/** aggregate fields of "data_type" */
export type DataType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DataType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DataType_Avg_Fields = {
  __typename?: 'dataType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "data_type". All fields are combined with a logical 'AND'. */
export type DataType_Bool_Exp = {
  _and?: InputMaybe<Array<DataType_Bool_Exp>>;
  _not?: InputMaybe<DataType_Bool_Exp>;
  _or?: InputMaybe<Array<DataType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "data_type" */
export enum DataType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  DataTypeEnumValueKey = 'data_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  DataTypePkey = 'data_type_pkey'
}

/** input type for incrementing numeric columns in table "data_type" */
export type DataType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "data_type" */
export type DataType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DataType_Max_Fields = {
  __typename?: 'dataType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DataType_Min_Fields = {
  __typename?: 'dataType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "data_type" */
export type DataType_Mutation_Response = {
  __typename?: 'dataType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DataType>;
};

/** input type for inserting object relation for remote table "data_type" */
export type DataType_Obj_Rel_Insert_Input = {
  data: DataType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DataType_On_Conflict>;
};

/** on_conflict condition type for table "data_type" */
export type DataType_On_Conflict = {
  constraint: DataType_Constraint;
  update_columns?: Array<DataType_Update_Column>;
  where?: InputMaybe<DataType_Bool_Exp>;
};

/** Ordering options when selecting data from "data_type". */
export type DataType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: data_type */
export type DataType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "data_type" */
export enum DataType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "data_type" */
export type DataType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DataType_Stddev_Fields = {
  __typename?: 'dataType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DataType_Stddev_Pop_Fields = {
  __typename?: 'dataType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DataType_Stddev_Samp_Fields = {
  __typename?: 'dataType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "dataType" */
export type DataType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DataType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DataType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DataType_Sum_Fields = {
  __typename?: 'dataType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "data_type" */
export enum DataType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type DataType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DataType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataType_Set_Input>;
  /** filter the rows which have to be updated */
  where: DataType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DataType_Var_Pop_Fields = {
  __typename?: 'dataType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DataType_Var_Samp_Fields = {
  __typename?: 'dataType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DataType_Variance_Fields = {
  __typename?: 'dataType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "date_calculation_type" */
export type DateCalculationType = {
  __typename?: 'dateCalculationType';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** aggregated selection of "date_calculation_type" */
export type DateCalculationType_Aggregate = {
  __typename?: 'dateCalculationType_aggregate';
  aggregate?: Maybe<DateCalculationType_Aggregate_Fields>;
  nodes: Array<DateCalculationType>;
};

/** aggregate fields of "date_calculation_type" */
export type DateCalculationType_Aggregate_Fields = {
  __typename?: 'dateCalculationType_aggregate_fields';
  avg?: Maybe<DateCalculationType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<DateCalculationType_Max_Fields>;
  min?: Maybe<DateCalculationType_Min_Fields>;
  stddev?: Maybe<DateCalculationType_Stddev_Fields>;
  stddev_pop?: Maybe<DateCalculationType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DateCalculationType_Stddev_Samp_Fields>;
  sum?: Maybe<DateCalculationType_Sum_Fields>;
  var_pop?: Maybe<DateCalculationType_Var_Pop_Fields>;
  var_samp?: Maybe<DateCalculationType_Var_Samp_Fields>;
  variance?: Maybe<DateCalculationType_Variance_Fields>;
};


/** aggregate fields of "date_calculation_type" */
export type DateCalculationType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DateCalculationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DateCalculationType_Avg_Fields = {
  __typename?: 'dateCalculationType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "date_calculation_type". All fields are combined with a logical 'AND'. */
export type DateCalculationType_Bool_Exp = {
  _and?: InputMaybe<Array<DateCalculationType_Bool_Exp>>;
  _not?: InputMaybe<DateCalculationType_Bool_Exp>;
  _or?: InputMaybe<Array<DateCalculationType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "date_calculation_type" */
export enum DateCalculationType_Constraint {
  /** unique or primary key constraint on columns "id" */
  DateCalculationTypePkey = 'date_calculation_type_pkey'
}

/** input type for incrementing numeric columns in table "date_calculation_type" */
export type DateCalculationType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "date_calculation_type" */
export type DateCalculationType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DateCalculationType_Max_Fields = {
  __typename?: 'dateCalculationType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DateCalculationType_Min_Fields = {
  __typename?: 'dateCalculationType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "date_calculation_type" */
export type DateCalculationType_Mutation_Response = {
  __typename?: 'dateCalculationType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DateCalculationType>;
};

/** on_conflict condition type for table "date_calculation_type" */
export type DateCalculationType_On_Conflict = {
  constraint: DateCalculationType_Constraint;
  update_columns?: Array<DateCalculationType_Update_Column>;
  where?: InputMaybe<DateCalculationType_Bool_Exp>;
};

/** Ordering options when selecting data from "date_calculation_type". */
export type DateCalculationType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: date_calculation_type */
export type DateCalculationType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "date_calculation_type" */
export enum DateCalculationType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "date_calculation_type" */
export type DateCalculationType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DateCalculationType_Stddev_Fields = {
  __typename?: 'dateCalculationType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DateCalculationType_Stddev_Pop_Fields = {
  __typename?: 'dateCalculationType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DateCalculationType_Stddev_Samp_Fields = {
  __typename?: 'dateCalculationType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "dateCalculationType" */
export type DateCalculationType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DateCalculationType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DateCalculationType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DateCalculationType_Sum_Fields = {
  __typename?: 'dateCalculationType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "date_calculation_type" */
export enum DateCalculationType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type DateCalculationType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DateCalculationType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DateCalculationType_Set_Input>;
  /** filter the rows which have to be updated */
  where: DateCalculationType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DateCalculationType_Var_Pop_Fields = {
  __typename?: 'dateCalculationType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DateCalculationType_Var_Samp_Fields = {
  __typename?: 'dateCalculationType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DateCalculationType_Variance_Fields = {
  __typename?: 'dateCalculationType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** Boolean expression to compare columns of type "datetime". All fields are combined with logical 'AND'. */
export type Datetime_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['datetime']>;
  _gt?: InputMaybe<Scalars['datetime']>;
  _gte?: InputMaybe<Scalars['datetime']>;
  _in?: InputMaybe<Array<Scalars['datetime']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['datetime']>;
  _lte?: InputMaybe<Scalars['datetime']>;
  _neq?: InputMaybe<Scalars['datetime']>;
  _nin?: InputMaybe<Array<Scalars['datetime']>>;
};

/** columns and relationships of "dealer_payment_type" */
export type DealerPaymentType = {
  __typename?: 'dealerPaymentType';
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "dealer_payment_type" */
export type DealerPaymentType_Aggregate = {
  __typename?: 'dealerPaymentType_aggregate';
  aggregate?: Maybe<DealerPaymentType_Aggregate_Fields>;
  nodes: Array<DealerPaymentType>;
};

/** aggregate fields of "dealer_payment_type" */
export type DealerPaymentType_Aggregate_Fields = {
  __typename?: 'dealerPaymentType_aggregate_fields';
  avg?: Maybe<DealerPaymentType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<DealerPaymentType_Max_Fields>;
  min?: Maybe<DealerPaymentType_Min_Fields>;
  stddev?: Maybe<DealerPaymentType_Stddev_Fields>;
  stddev_pop?: Maybe<DealerPaymentType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DealerPaymentType_Stddev_Samp_Fields>;
  sum?: Maybe<DealerPaymentType_Sum_Fields>;
  var_pop?: Maybe<DealerPaymentType_Var_Pop_Fields>;
  var_samp?: Maybe<DealerPaymentType_Var_Samp_Fields>;
  variance?: Maybe<DealerPaymentType_Variance_Fields>;
};


/** aggregate fields of "dealer_payment_type" */
export type DealerPaymentType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DealerPaymentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DealerPaymentType_Avg_Fields = {
  __typename?: 'dealerPaymentType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "dealer_payment_type". All fields are combined with a logical 'AND'. */
export type DealerPaymentType_Bool_Exp = {
  _and?: InputMaybe<Array<DealerPaymentType_Bool_Exp>>;
  _not?: InputMaybe<DealerPaymentType_Bool_Exp>;
  _or?: InputMaybe<Array<DealerPaymentType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dealer_payment_type" */
export enum DealerPaymentType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  DealerPaymentTypeEnumValueKey = 'dealer_payment_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  DealerPaymentTypePkey = 'dealer_payment_type_pkey'
}

/** input type for incrementing numeric columns in table "dealer_payment_type" */
export type DealerPaymentType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "dealer_payment_type" */
export type DealerPaymentType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DealerPaymentType_Max_Fields = {
  __typename?: 'dealerPaymentType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type DealerPaymentType_Min_Fields = {
  __typename?: 'dealerPaymentType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "dealer_payment_type" */
export type DealerPaymentType_Mutation_Response = {
  __typename?: 'dealerPaymentType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DealerPaymentType>;
};

/** input type for inserting object relation for remote table "dealer_payment_type" */
export type DealerPaymentType_Obj_Rel_Insert_Input = {
  data: DealerPaymentType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DealerPaymentType_On_Conflict>;
};

/** on_conflict condition type for table "dealer_payment_type" */
export type DealerPaymentType_On_Conflict = {
  constraint: DealerPaymentType_Constraint;
  update_columns?: Array<DealerPaymentType_Update_Column>;
  where?: InputMaybe<DealerPaymentType_Bool_Exp>;
};

/** Ordering options when selecting data from "dealer_payment_type". */
export type DealerPaymentType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dealer_payment_type */
export type DealerPaymentType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "dealer_payment_type" */
export enum DealerPaymentType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "dealer_payment_type" */
export type DealerPaymentType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type DealerPaymentType_Stddev_Fields = {
  __typename?: 'dealerPaymentType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DealerPaymentType_Stddev_Pop_Fields = {
  __typename?: 'dealerPaymentType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DealerPaymentType_Stddev_Samp_Fields = {
  __typename?: 'dealerPaymentType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "dealerPaymentType" */
export type DealerPaymentType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DealerPaymentType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DealerPaymentType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type DealerPaymentType_Sum_Fields = {
  __typename?: 'dealerPaymentType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "dealer_payment_type" */
export enum DealerPaymentType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type DealerPaymentType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DealerPaymentType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DealerPaymentType_Set_Input>;
  /** filter the rows which have to be updated */
  where: DealerPaymentType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DealerPaymentType_Var_Pop_Fields = {
  __typename?: 'dealerPaymentType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DealerPaymentType_Var_Samp_Fields = {
  __typename?: 'dealerPaymentType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DealerPaymentType_Variance_Fields = {
  __typename?: 'dealerPaymentType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "disbursement_type" */
export type DisbursementType = {
  __typename?: 'disbursementType';
  /** An array relationship */
  accountDisbursements: Array<AccountDisbursement>;
  /** An aggregate relationship */
  accountDisbursements_aggregate: AccountDisbursement_Aggregate;
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  productDisbursements: Array<ProductDisbursement>;
  /** An aggregate relationship */
  productDisbursements_aggregate: ProductDisbursement_Aggregate;
};


/** columns and relationships of "disbursement_type" */
export type DisbursementTypeAccountDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** columns and relationships of "disbursement_type" */
export type DisbursementTypeAccountDisbursements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** columns and relationships of "disbursement_type" */
export type DisbursementTypeProductDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductDisbursement_Order_By>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};


/** columns and relationships of "disbursement_type" */
export type DisbursementTypeProductDisbursements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductDisbursement_Order_By>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};

/** aggregated selection of "disbursement_type" */
export type DisbursementType_Aggregate = {
  __typename?: 'disbursementType_aggregate';
  aggregate?: Maybe<DisbursementType_Aggregate_Fields>;
  nodes: Array<DisbursementType>;
};

/** aggregate fields of "disbursement_type" */
export type DisbursementType_Aggregate_Fields = {
  __typename?: 'disbursementType_aggregate_fields';
  avg?: Maybe<DisbursementType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<DisbursementType_Max_Fields>;
  min?: Maybe<DisbursementType_Min_Fields>;
  stddev?: Maybe<DisbursementType_Stddev_Fields>;
  stddev_pop?: Maybe<DisbursementType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DisbursementType_Stddev_Samp_Fields>;
  sum?: Maybe<DisbursementType_Sum_Fields>;
  var_pop?: Maybe<DisbursementType_Var_Pop_Fields>;
  var_samp?: Maybe<DisbursementType_Var_Samp_Fields>;
  variance?: Maybe<DisbursementType_Variance_Fields>;
};


/** aggregate fields of "disbursement_type" */
export type DisbursementType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DisbursementType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DisbursementType_Avg_Fields = {
  __typename?: 'disbursementType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "disbursement_type". All fields are combined with a logical 'AND'. */
export type DisbursementType_Bool_Exp = {
  _and?: InputMaybe<Array<DisbursementType_Bool_Exp>>;
  _not?: InputMaybe<DisbursementType_Bool_Exp>;
  _or?: InputMaybe<Array<DisbursementType_Bool_Exp>>;
  accountDisbursements?: InputMaybe<AccountDisbursement_Bool_Exp>;
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  productDisbursements?: InputMaybe<ProductDisbursement_Bool_Exp>;
  productDisbursements_aggregate?: InputMaybe<ProductDisbursement_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "disbursement_type" */
export enum DisbursementType_Constraint {
  /** unique or primary key constraint on columns "id" */
  DisbursementTypePkey = 'disbursement_type_pkey'
}

/** input type for incrementing numeric columns in table "disbursement_type" */
export type DisbursementType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "disbursement_type" */
export type DisbursementType_Insert_Input = {
  accountDisbursements?: InputMaybe<AccountDisbursement_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productDisbursements?: InputMaybe<ProductDisbursement_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type DisbursementType_Max_Fields = {
  __typename?: 'disbursementType_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DisbursementType_Min_Fields = {
  __typename?: 'disbursementType_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "disbursement_type" */
export type DisbursementType_Mutation_Response = {
  __typename?: 'disbursementType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DisbursementType>;
};

/** input type for inserting object relation for remote table "disbursement_type" */
export type DisbursementType_Obj_Rel_Insert_Input = {
  data: DisbursementType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DisbursementType_On_Conflict>;
};

/** on_conflict condition type for table "disbursement_type" */
export type DisbursementType_On_Conflict = {
  constraint: DisbursementType_Constraint;
  update_columns?: Array<DisbursementType_Update_Column>;
  where?: InputMaybe<DisbursementType_Bool_Exp>;
};

/** Ordering options when selecting data from "disbursement_type". */
export type DisbursementType_Order_By = {
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  productDisbursements_aggregate?: InputMaybe<ProductDisbursement_Aggregate_Order_By>;
};

/** primary key columns input for table: disbursement_type */
export type DisbursementType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "disbursement_type" */
export enum DisbursementType_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "disbursement_type" */
export type DisbursementType_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DisbursementType_Stddev_Fields = {
  __typename?: 'disbursementType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DisbursementType_Stddev_Pop_Fields = {
  __typename?: 'disbursementType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DisbursementType_Stddev_Samp_Fields = {
  __typename?: 'disbursementType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "disbursementType" */
export type DisbursementType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DisbursementType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DisbursementType_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DisbursementType_Sum_Fields = {
  __typename?: 'disbursementType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "disbursement_type" */
export enum DisbursementType_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type DisbursementType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DisbursementType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DisbursementType_Set_Input>;
  /** filter the rows which have to be updated */
  where: DisbursementType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DisbursementType_Var_Pop_Fields = {
  __typename?: 'disbursementType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DisbursementType_Var_Samp_Fields = {
  __typename?: 'disbursementType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DisbursementType_Variance_Fields = {
  __typename?: 'disbursementType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "claims.document" */
export type Document = {
  __typename?: 'document';
  claimNumber: Scalars['String'];
  compositeKey: Scalars['String'];
  contractNumber: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  entityFileStorages: Array<EntityFileStorage>;
  /** An aggregate relationship */
  entityFileStorages_aggregate: EntityFileStorage_Aggregate;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['String'];
  vin: Scalars['String'];
};


/** columns and relationships of "claims.document" */
export type DocumentEntityFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** columns and relationships of "claims.document" */
export type DocumentEntityFileStorages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};

/** columns and relationships of "shared.document_instance" */
export type DocumentInstance = {
  __typename?: 'documentInstance';
  createdAt: Scalars['timestamptz'];
  documentInstanceMetadata: Scalars['jsonb'];
  /** An object relationship */
  documentTemplate: DocumentTemplate;
  documentTemplateId: Scalars['uuid'];
  firstPrintDate?: Maybe<Scalars['date']>;
  /** A computed field, executes function "shared.get_document_instance_generated_by" */
  generatedBy?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  parentId: Scalars['uuid'];
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "shared.document_instance" */
export type DocumentInstanceDocumentInstanceMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shared.document_instance" */
export type DocumentInstanceLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "shared.document_instance" */
export type DocumentInstanceLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "shared.document_instance" */
export type DocumentInstance_Aggregate = {
  __typename?: 'documentInstance_aggregate';
  aggregate?: Maybe<DocumentInstance_Aggregate_Fields>;
  nodes: Array<DocumentInstance>;
};

export type DocumentInstance_Aggregate_Bool_Exp = {
  count?: InputMaybe<DocumentInstance_Aggregate_Bool_Exp_Count>;
};

export type DocumentInstance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DocumentInstance_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.document_instance" */
export type DocumentInstance_Aggregate_Fields = {
  __typename?: 'documentInstance_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<DocumentInstance_Max_Fields>;
  min?: Maybe<DocumentInstance_Min_Fields>;
};


/** aggregate fields of "shared.document_instance" */
export type DocumentInstance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.document_instance" */
export type DocumentInstance_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<DocumentInstance_Max_Order_By>;
  min?: InputMaybe<DocumentInstance_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DocumentInstance_Append_Input = {
  documentInstanceMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "shared.document_instance" */
export type DocumentInstance_Arr_Rel_Insert_Input = {
  data: Array<DocumentInstance_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentInstance_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.document_instance". All fields are combined with a logical 'AND'. */
export type DocumentInstance_Bool_Exp = {
  _and?: InputMaybe<Array<DocumentInstance_Bool_Exp>>;
  _not?: InputMaybe<DocumentInstance_Bool_Exp>;
  _or?: InputMaybe<Array<DocumentInstance_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  documentInstanceMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  documentTemplate?: InputMaybe<DocumentTemplate_Bool_Exp>;
  documentTemplateId?: InputMaybe<Uuid_Comparison_Exp>;
  firstPrintDate?: InputMaybe<Date_Comparison_Exp>;
  generatedBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.document_instance" */
export enum DocumentInstance_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentInstancePkey = 'document_instance_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DocumentInstance_Delete_At_Path_Input = {
  documentInstanceMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DocumentInstance_Delete_Elem_Input = {
  documentInstanceMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DocumentInstance_Delete_Key_Input = {
  documentInstanceMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "shared.document_instance" */
export type DocumentInstance_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentInstanceMetadata?: InputMaybe<Scalars['jsonb']>;
  documentTemplate?: InputMaybe<DocumentTemplate_Obj_Rel_Insert_Input>;
  documentTemplateId?: InputMaybe<Scalars['uuid']>;
  firstPrintDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['uuid']>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DocumentInstance_Max_Fields = {
  __typename?: 'documentInstance_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  documentTemplateId?: Maybe<Scalars['uuid']>;
  firstPrintDate?: Maybe<Scalars['date']>;
  /** A computed field, executes function "shared.get_document_instance_generated_by" */
  generatedBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.document_instance" */
export type DocumentInstance_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  documentTemplateId?: InputMaybe<Order_By>;
  firstPrintDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type DocumentInstance_Min_Fields = {
  __typename?: 'documentInstance_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  documentTemplateId?: Maybe<Scalars['uuid']>;
  firstPrintDate?: Maybe<Scalars['date']>;
  /** A computed field, executes function "shared.get_document_instance_generated_by" */
  generatedBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.document_instance" */
export type DocumentInstance_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  documentTemplateId?: InputMaybe<Order_By>;
  firstPrintDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.document_instance" */
export type DocumentInstance_Mutation_Response = {
  __typename?: 'documentInstance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DocumentInstance>;
};

/** on_conflict condition type for table "shared.document_instance" */
export type DocumentInstance_On_Conflict = {
  constraint: DocumentInstance_Constraint;
  update_columns?: Array<DocumentInstance_Update_Column>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.document_instance". */
export type DocumentInstance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  documentInstanceMetadata?: InputMaybe<Order_By>;
  documentTemplate?: InputMaybe<DocumentTemplate_Order_By>;
  documentTemplateId?: InputMaybe<Order_By>;
  firstPrintDate?: InputMaybe<Order_By>;
  generatedBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  parentId?: InputMaybe<Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.document_instance */
export type DocumentInstance_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DocumentInstance_Prepend_Input = {
  documentInstanceMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shared.document_instance" */
export enum DocumentInstance_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DocumentInstanceMetadata = 'documentInstanceMetadata',
  /** column name */
  DocumentTemplateId = 'documentTemplateId',
  /** column name */
  FirstPrintDate = 'firstPrintDate',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.document_instance" */
export type DocumentInstance_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentInstanceMetadata?: InputMaybe<Scalars['jsonb']>;
  documentTemplateId?: InputMaybe<Scalars['uuid']>;
  firstPrintDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "documentInstance" */
export type DocumentInstance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DocumentInstance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DocumentInstance_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentInstanceMetadata?: InputMaybe<Scalars['jsonb']>;
  documentTemplateId?: InputMaybe<Scalars['uuid']>;
  firstPrintDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.document_instance" */
export enum DocumentInstance_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DocumentInstanceMetadata = 'documentInstanceMetadata',
  /** column name */
  DocumentTemplateId = 'documentTemplateId',
  /** column name */
  FirstPrintDate = 'firstPrintDate',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type DocumentInstance_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DocumentInstance_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DocumentInstance_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DocumentInstance_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DocumentInstance_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DocumentInstance_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DocumentInstance_Set_Input>;
  /** filter the rows which have to be updated */
  where: DocumentInstance_Bool_Exp;
};

/** columns and relationships of "shared.document_template" */
export type DocumentTemplate = {
  __typename?: 'documentTemplate';
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  documentInstances: Array<DocumentInstance>;
  /** An aggregate relationship */
  documentInstances_aggregate: DocumentInstance_Aggregate;
  /** An array relationship */
  documentTemplateApplications: Array<DocumentTemplateApplication>;
  /** An aggregate relationship */
  documentTemplateApplications_aggregate: DocumentTemplateApplication_Aggregate;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  templateTypeId: Scalars['uuid'];
  /** An object relationship */
  type: Type;
  updatedAt: Scalars['timestamptz'];
  /** The version number of a specific document type. This version is used in the code to map the data that is stored on documentInstance.documentInstanceMetadata. So, if a new version is added, the code will need to be updated. */
  version: Scalars['String'];
};


/** columns and relationships of "shared.document_template" */
export type DocumentTemplateDocumentInstancesArgs = {
  distinct_on?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentInstance_Order_By>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


/** columns and relationships of "shared.document_template" */
export type DocumentTemplateDocumentInstances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentInstance_Order_By>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


/** columns and relationships of "shared.document_template" */
export type DocumentTemplateDocumentTemplateApplicationsArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplateApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplateApplication_Order_By>>;
  where?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
};


/** columns and relationships of "shared.document_template" */
export type DocumentTemplateDocumentTemplateApplications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplateApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplateApplication_Order_By>>;
  where?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
};

/** columns and relationships of "shared.document_template_application" */
export type DocumentTemplateApplication = {
  __typename?: 'documentTemplateApplication';
  /** An object relationship */
  application: Application;
  applicationId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  documentTemplate: DocumentTemplate;
  documentTemplateId: Scalars['uuid'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "shared.document_template_application" */
export type DocumentTemplateApplication_Aggregate = {
  __typename?: 'documentTemplateApplication_aggregate';
  aggregate?: Maybe<DocumentTemplateApplication_Aggregate_Fields>;
  nodes: Array<DocumentTemplateApplication>;
};

export type DocumentTemplateApplication_Aggregate_Bool_Exp = {
  count?: InputMaybe<DocumentTemplateApplication_Aggregate_Bool_Exp_Count>;
};

export type DocumentTemplateApplication_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<DocumentTemplateApplication_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.document_template_application" */
export type DocumentTemplateApplication_Aggregate_Fields = {
  __typename?: 'documentTemplateApplication_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<DocumentTemplateApplication_Max_Fields>;
  min?: Maybe<DocumentTemplateApplication_Min_Fields>;
};


/** aggregate fields of "shared.document_template_application" */
export type DocumentTemplateApplication_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DocumentTemplateApplication_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.document_template_application" */
export type DocumentTemplateApplication_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<DocumentTemplateApplication_Max_Order_By>;
  min?: InputMaybe<DocumentTemplateApplication_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.document_template_application" */
export type DocumentTemplateApplication_Arr_Rel_Insert_Input = {
  data: Array<DocumentTemplateApplication_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentTemplateApplication_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.document_template_application". All fields are combined with a logical 'AND'. */
export type DocumentTemplateApplication_Bool_Exp = {
  _and?: InputMaybe<Array<DocumentTemplateApplication_Bool_Exp>>;
  _not?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
  _or?: InputMaybe<Array<DocumentTemplateApplication_Bool_Exp>>;
  application?: InputMaybe<Application_Bool_Exp>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  documentTemplate?: InputMaybe<DocumentTemplate_Bool_Exp>;
  documentTemplateId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.document_template_application" */
export enum DocumentTemplateApplication_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentTemplateApplicationPkey = 'document_template_application_pkey'
}

/** input type for inserting data into table "shared.document_template_application" */
export type DocumentTemplateApplication_Insert_Input = {
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentTemplate?: InputMaybe<DocumentTemplate_Obj_Rel_Insert_Input>;
  documentTemplateId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DocumentTemplateApplication_Max_Fields = {
  __typename?: 'documentTemplateApplication_max_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  documentTemplateId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.document_template_application" */
export type DocumentTemplateApplication_Max_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  documentTemplateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type DocumentTemplateApplication_Min_Fields = {
  __typename?: 'documentTemplateApplication_min_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  documentTemplateId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.document_template_application" */
export type DocumentTemplateApplication_Min_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  documentTemplateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.document_template_application" */
export type DocumentTemplateApplication_Mutation_Response = {
  __typename?: 'documentTemplateApplication_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DocumentTemplateApplication>;
};

/** on_conflict condition type for table "shared.document_template_application" */
export type DocumentTemplateApplication_On_Conflict = {
  constraint: DocumentTemplateApplication_Constraint;
  update_columns?: Array<DocumentTemplateApplication_Update_Column>;
  where?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.document_template_application". */
export type DocumentTemplateApplication_Order_By = {
  application?: InputMaybe<Application_Order_By>;
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  documentTemplate?: InputMaybe<DocumentTemplate_Order_By>;
  documentTemplateId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.document_template_application */
export type DocumentTemplateApplication_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.document_template_application" */
export enum DocumentTemplateApplication_Select_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DocumentTemplateId = 'documentTemplateId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.document_template_application" */
export type DocumentTemplateApplication_Set_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentTemplateId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "documentTemplateApplication" */
export type DocumentTemplateApplication_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DocumentTemplateApplication_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DocumentTemplateApplication_Stream_Cursor_Value_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentTemplateId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.document_template_application" */
export enum DocumentTemplateApplication_Update_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DocumentTemplateId = 'documentTemplateId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type DocumentTemplateApplication_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DocumentTemplateApplication_Set_Input>;
  /** filter the rows which have to be updated */
  where: DocumentTemplateApplication_Bool_Exp;
};

/** aggregated selection of "shared.document_template" */
export type DocumentTemplate_Aggregate = {
  __typename?: 'documentTemplate_aggregate';
  aggregate?: Maybe<DocumentTemplate_Aggregate_Fields>;
  nodes: Array<DocumentTemplate>;
};

export type DocumentTemplate_Aggregate_Bool_Exp = {
  count?: InputMaybe<DocumentTemplate_Aggregate_Bool_Exp_Count>;
};

export type DocumentTemplate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<DocumentTemplate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DocumentTemplate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.document_template" */
export type DocumentTemplate_Aggregate_Fields = {
  __typename?: 'documentTemplate_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<DocumentTemplate_Max_Fields>;
  min?: Maybe<DocumentTemplate_Min_Fields>;
};


/** aggregate fields of "shared.document_template" */
export type DocumentTemplate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DocumentTemplate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.document_template" */
export type DocumentTemplate_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<DocumentTemplate_Max_Order_By>;
  min?: InputMaybe<DocumentTemplate_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.document_template" */
export type DocumentTemplate_Arr_Rel_Insert_Input = {
  data: Array<DocumentTemplate_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentTemplate_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.document_template". All fields are combined with a logical 'AND'. */
export type DocumentTemplate_Bool_Exp = {
  _and?: InputMaybe<Array<DocumentTemplate_Bool_Exp>>;
  _not?: InputMaybe<DocumentTemplate_Bool_Exp>;
  _or?: InputMaybe<Array<DocumentTemplate_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  documentInstances?: InputMaybe<DocumentInstance_Bool_Exp>;
  documentInstances_aggregate?: InputMaybe<DocumentInstance_Aggregate_Bool_Exp>;
  documentTemplateApplications?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
  documentTemplateApplications_aggregate?: InputMaybe<DocumentTemplateApplication_Aggregate_Bool_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  templateTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Type_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.document_template" */
export enum DocumentTemplate_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentTemplatePkey = 'document_template_pkey'
}

/** input type for inserting data into table "shared.document_template" */
export type DocumentTemplate_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentInstances?: InputMaybe<DocumentInstance_Arr_Rel_Insert_Input>;
  documentTemplateApplications?: InputMaybe<DocumentTemplateApplication_Arr_Rel_Insert_Input>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  templateTypeId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The version number of a specific document type. This version is used in the code to map the data that is stored on documentInstance.documentInstanceMetadata. So, if a new version is added, the code will need to be updated. */
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DocumentTemplate_Max_Fields = {
  __typename?: 'documentTemplate_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  templateTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** The version number of a specific document type. This version is used in the code to map the data that is stored on documentInstance.documentInstanceMetadata. So, if a new version is added, the code will need to be updated. */
  version?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "shared.document_template" */
export type DocumentTemplate_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  templateTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  /** The version number of a specific document type. This version is used in the code to map the data that is stored on documentInstance.documentInstanceMetadata. So, if a new version is added, the code will need to be updated. */
  version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type DocumentTemplate_Min_Fields = {
  __typename?: 'documentTemplate_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  templateTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** The version number of a specific document type. This version is used in the code to map the data that is stored on documentInstance.documentInstanceMetadata. So, if a new version is added, the code will need to be updated. */
  version?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "shared.document_template" */
export type DocumentTemplate_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  templateTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  /** The version number of a specific document type. This version is used in the code to map the data that is stored on documentInstance.documentInstanceMetadata. So, if a new version is added, the code will need to be updated. */
  version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.document_template" */
export type DocumentTemplate_Mutation_Response = {
  __typename?: 'documentTemplate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DocumentTemplate>;
};

/** input type for inserting object relation for remote table "shared.document_template" */
export type DocumentTemplate_Obj_Rel_Insert_Input = {
  data: DocumentTemplate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentTemplate_On_Conflict>;
};

/** on_conflict condition type for table "shared.document_template" */
export type DocumentTemplate_On_Conflict = {
  constraint: DocumentTemplate_Constraint;
  update_columns?: Array<DocumentTemplate_Update_Column>;
  where?: InputMaybe<DocumentTemplate_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.document_template". */
export type DocumentTemplate_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  documentInstances_aggregate?: InputMaybe<DocumentInstance_Aggregate_Order_By>;
  documentTemplateApplications_aggregate?: InputMaybe<DocumentTemplateApplication_Aggregate_Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  templateTypeId?: InputMaybe<Order_By>;
  type?: InputMaybe<Type_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.document_template */
export type DocumentTemplate_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.document_template" */
export enum DocumentTemplate_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  TemplateTypeId = 'templateTypeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "shared.document_template" */
export type DocumentTemplate_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  templateTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The version number of a specific document type. This version is used in the code to map the data that is stored on documentInstance.documentInstanceMetadata. So, if a new version is added, the code will need to be updated. */
  version?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "documentTemplate" */
export type DocumentTemplate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DocumentTemplate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DocumentTemplate_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  templateTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The version number of a specific document type. This version is used in the code to map the data that is stored on documentInstance.documentInstanceMetadata. So, if a new version is added, the code will need to be updated. */
  version?: InputMaybe<Scalars['String']>;
};

/** update columns of table "shared.document_template" */
export enum DocumentTemplate_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  TemplateTypeId = 'templateTypeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

export type DocumentTemplate_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DocumentTemplate_Set_Input>;
  /** filter the rows which have to be updated */
  where: DocumentTemplate_Bool_Exp;
};

/** aggregated selection of "claims.document" */
export type Document_Aggregate = {
  __typename?: 'document_aggregate';
  aggregate?: Maybe<Document_Aggregate_Fields>;
  nodes: Array<Document>;
};

/** aggregate fields of "claims.document" */
export type Document_Aggregate_Fields = {
  __typename?: 'document_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Document_Max_Fields>;
  min?: Maybe<Document_Min_Fields>;
};


/** aggregate fields of "claims.document" */
export type Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.document". All fields are combined with a logical 'AND'. */
export type Document_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Bool_Exp>>;
  _not?: InputMaybe<Document_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Bool_Exp>>;
  claimNumber?: InputMaybe<String_Comparison_Exp>;
  compositeKey?: InputMaybe<String_Comparison_Exp>;
  contractNumber?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Bool_Exp>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
  vin?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.document" */
export enum Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentPkey = 'document_pkey'
}

/** input type for inserting data into table "claims.document" */
export type Document_Insert_Input = {
  claimNumber?: InputMaybe<Scalars['String']>;
  compositeKey?: InputMaybe<Scalars['String']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Max_Fields = {
  __typename?: 'document_max_fields';
  claimNumber?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  contractNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Min_Fields = {
  __typename?: 'document_min_fields';
  claimNumber?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  contractNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "claims.document" */
export type Document_Mutation_Response = {
  __typename?: 'document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document>;
};

/** on_conflict condition type for table "claims.document" */
export type Document_On_Conflict = {
  constraint: Document_Constraint;
  update_columns?: Array<Document_Update_Column>;
  where?: InputMaybe<Document_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.document". */
export type Document_Order_By = {
  claimNumber?: InputMaybe<Order_By>;
  compositeKey?: InputMaybe<Order_By>;
  contractNumber?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  vin?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.document */
export type Document_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.document" */
export enum Document_Select_Column {
  /** column name */
  ClaimNumber = 'claimNumber',
  /** column name */
  CompositeKey = 'compositeKey',
  /** column name */
  ContractNumber = 'contractNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Vin = 'vin'
}

/** input type for updating data in table "claims.document" */
export type Document_Set_Input = {
  claimNumber?: InputMaybe<Scalars['String']>;
  compositeKey?: InputMaybe<Scalars['String']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "document" */
export type Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Stream_Cursor_Value_Input = {
  claimNumber?: InputMaybe<Scalars['String']>;
  compositeKey?: InputMaybe<Scalars['String']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

/** update columns of table "claims.document" */
export enum Document_Update_Column {
  /** column name */
  ClaimNumber = 'claimNumber',
  /** column name */
  CompositeKey = 'compositeKey',
  /** column name */
  ContractNumber = 'contractNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Vin = 'vin'
}

export type Document_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Bool_Exp;
};

/** columns and relationships of "eligibility_rule" */
export type EligibilityRule = {
  __typename?: 'eligibilityRule';
  /** An object relationship */
  application?: Maybe<Application>;
  applicationId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  applicationRoutes: Array<Route>;
  /** An aggregate relationship */
  applicationRoutes_aggregate: Route_Aggregate;
  /** An object relationship */
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  eligibilityRuleDefinitions: Array<EligibilityRuleDefinition>;
  /** An aggregate relationship */
  eligibilityRuleDefinitions_aggregate: EligibilityRuleDefinition_Aggregate;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  /** An array relationship */
  entity_eligibility_rules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entity_eligibility_rules_aggregate: EntityEligibilityRule_Aggregate;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  productEligibilityRules: Array<ProductEligibility>;
  /** An aggregate relationship */
  productEligibilityRules_aggregate: ProductEligibility_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "eligibility_rule" */
export type EligibilityRuleApplicationRoutesArgs = {
  distinct_on?: InputMaybe<Array<Route_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Route_Order_By>>;
  where?: InputMaybe<Route_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule" */
export type EligibilityRuleApplicationRoutes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Route_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Route_Order_By>>;
  where?: InputMaybe<Route_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule" */
export type EligibilityRuleEligibilityRuleDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRuleDefinition_Order_By>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule" */
export type EligibilityRuleEligibilityRuleDefinitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRuleDefinition_Order_By>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule" */
export type EligibilityRuleEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule" */
export type EligibilityRuleEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule" */
export type EligibilityRuleEntity_Eligibility_RulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule" */
export type EligibilityRuleEntity_Eligibility_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule" */
export type EligibilityRuleProductEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<ProductEligibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductEligibility_Order_By>>;
  where?: InputMaybe<ProductEligibility_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule" */
export type EligibilityRuleProductEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductEligibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductEligibility_Order_By>>;
  where?: InputMaybe<ProductEligibility_Bool_Exp>;
};

/** columns and relationships of "eligibility_rule_definition" */
export type EligibilityRuleDefinition = {
  __typename?: 'eligibilityRuleDefinition';
  /** An array relationship */
  childEligibilityRuleDefinitions: Array<EligibilityRuleDefinition>;
  /** An aggregate relationship */
  childEligibilityRuleDefinitions_aggregate: EligibilityRuleDefinition_Aggregate;
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  eligibilityRule?: Maybe<EligibilityRule>;
  eligibilityRuleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  eligibilityType?: Maybe<EligibilityType>;
  eligibilityTypeId?: Maybe<Scalars['Int']>;
  endNumber?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  jsonValue?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  parentEligibilityRuleDefinition?: Maybe<EligibilityRuleDefinition>;
  parentEligibilityRuleDefinitionId?: Maybe<Scalars['uuid']>;
  singleValue?: Maybe<Scalars['String']>;
  startNumber?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "eligibility_rule_definition" */
export type EligibilityRuleDefinitionChildEligibilityRuleDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRuleDefinition_Order_By>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule_definition" */
export type EligibilityRuleDefinitionChildEligibilityRuleDefinitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRuleDefinition_Order_By>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule_definition" */
export type EligibilityRuleDefinitionJsonValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "eligibility_rule_definition" */
export type EligibilityRuleDefinitionLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "eligibility_rule_definition" */
export type EligibilityRuleDefinitionLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Aggregate = {
  __typename?: 'eligibilityRuleDefinition_aggregate';
  aggregate?: Maybe<EligibilityRuleDefinition_Aggregate_Fields>;
  nodes: Array<EligibilityRuleDefinition>;
};

export type EligibilityRuleDefinition_Aggregate_Bool_Exp = {
  count?: InputMaybe<EligibilityRuleDefinition_Aggregate_Bool_Exp_Count>;
};

export type EligibilityRuleDefinition_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Aggregate_Fields = {
  __typename?: 'eligibilityRuleDefinition_aggregate_fields';
  avg?: Maybe<EligibilityRuleDefinition_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<EligibilityRuleDefinition_Max_Fields>;
  min?: Maybe<EligibilityRuleDefinition_Min_Fields>;
  stddev?: Maybe<EligibilityRuleDefinition_Stddev_Fields>;
  stddev_pop?: Maybe<EligibilityRuleDefinition_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EligibilityRuleDefinition_Stddev_Samp_Fields>;
  sum?: Maybe<EligibilityRuleDefinition_Sum_Fields>;
  var_pop?: Maybe<EligibilityRuleDefinition_Var_Pop_Fields>;
  var_samp?: Maybe<EligibilityRuleDefinition_Var_Samp_Fields>;
  variance?: Maybe<EligibilityRuleDefinition_Variance_Fields>;
};


/** aggregate fields of "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Aggregate_Order_By = {
  avg?: InputMaybe<EligibilityRuleDefinition_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EligibilityRuleDefinition_Max_Order_By>;
  min?: InputMaybe<EligibilityRuleDefinition_Min_Order_By>;
  stddev?: InputMaybe<EligibilityRuleDefinition_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EligibilityRuleDefinition_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EligibilityRuleDefinition_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EligibilityRuleDefinition_Sum_Order_By>;
  var_pop?: InputMaybe<EligibilityRuleDefinition_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EligibilityRuleDefinition_Var_Samp_Order_By>;
  variance?: InputMaybe<EligibilityRuleDefinition_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EligibilityRuleDefinition_Append_Input = {
  jsonValue?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Arr_Rel_Insert_Input = {
  data: Array<EligibilityRuleDefinition_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EligibilityRuleDefinition_On_Conflict>;
};

/** aggregate avg on columns */
export type EligibilityRuleDefinition_Avg_Fields = {
  __typename?: 'eligibilityRuleDefinition_avg_fields';
  eligibilityTypeId?: Maybe<Scalars['Float']>;
  endNumber?: Maybe<Scalars['Float']>;
  startNumber?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Avg_Order_By = {
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eligibility_rule_definition". All fields are combined with a logical 'AND'. */
export type EligibilityRuleDefinition_Bool_Exp = {
  _and?: InputMaybe<Array<EligibilityRuleDefinition_Bool_Exp>>;
  _not?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
  _or?: InputMaybe<Array<EligibilityRuleDefinition_Bool_Exp>>;
  childEligibilityRuleDefinitions?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
  childEligibilityRuleDefinitions_aggregate?: InputMaybe<EligibilityRuleDefinition_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  eligibilityRule?: InputMaybe<EligibilityRule_Bool_Exp>;
  eligibilityRuleId?: InputMaybe<Uuid_Comparison_Exp>;
  eligibilityType?: InputMaybe<EligibilityType_Bool_Exp>;
  eligibilityTypeId?: InputMaybe<Int_Comparison_Exp>;
  endNumber?: InputMaybe<Numeric_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jsonValue?: InputMaybe<Jsonb_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  parentEligibilityRuleDefinition?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
  parentEligibilityRuleDefinitionId?: InputMaybe<Uuid_Comparison_Exp>;
  singleValue?: InputMaybe<String_Comparison_Exp>;
  startNumber?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eligibility_rule_definition" */
export enum EligibilityRuleDefinition_Constraint {
  /** unique or primary key constraint on columns "id" */
  EligibilityRuleDefinitionPkey = 'eligibility_rule_definition_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EligibilityRuleDefinition_Delete_At_Path_Input = {
  jsonValue?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EligibilityRuleDefinition_Delete_Elem_Input = {
  jsonValue?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EligibilityRuleDefinition_Delete_Key_Input = {
  jsonValue?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Inc_Input = {
  eligibilityTypeId?: InputMaybe<Scalars['Int']>;
  endNumber?: InputMaybe<Scalars['numeric']>;
  startNumber?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Insert_Input = {
  childEligibilityRuleDefinitions?: InputMaybe<EligibilityRuleDefinition_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  eligibilityRule?: InputMaybe<EligibilityRule_Obj_Rel_Insert_Input>;
  eligibilityRuleId?: InputMaybe<Scalars['uuid']>;
  eligibilityType?: InputMaybe<EligibilityType_Obj_Rel_Insert_Input>;
  eligibilityTypeId?: InputMaybe<Scalars['Int']>;
  endNumber?: InputMaybe<Scalars['numeric']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  jsonValue?: InputMaybe<Scalars['jsonb']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  parentEligibilityRuleDefinition?: InputMaybe<EligibilityRuleDefinition_Obj_Rel_Insert_Input>;
  parentEligibilityRuleDefinitionId?: InputMaybe<Scalars['uuid']>;
  singleValue?: InputMaybe<Scalars['String']>;
  startNumber?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EligibilityRuleDefinition_Max_Fields = {
  __typename?: 'eligibilityRuleDefinition_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  eligibilityRuleId?: Maybe<Scalars['uuid']>;
  eligibilityTypeId?: Maybe<Scalars['Int']>;
  endNumber?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  parentEligibilityRuleDefinitionId?: Maybe<Scalars['uuid']>;
  singleValue?: Maybe<Scalars['String']>;
  startNumber?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  eligibilityRuleId?: InputMaybe<Order_By>;
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentEligibilityRuleDefinitionId?: InputMaybe<Order_By>;
  singleValue?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EligibilityRuleDefinition_Min_Fields = {
  __typename?: 'eligibilityRuleDefinition_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  eligibilityRuleId?: Maybe<Scalars['uuid']>;
  eligibilityTypeId?: Maybe<Scalars['Int']>;
  endNumber?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  parentEligibilityRuleDefinitionId?: Maybe<Scalars['uuid']>;
  singleValue?: Maybe<Scalars['String']>;
  startNumber?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  eligibilityRuleId?: InputMaybe<Order_By>;
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentEligibilityRuleDefinitionId?: InputMaybe<Order_By>;
  singleValue?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Mutation_Response = {
  __typename?: 'eligibilityRuleDefinition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EligibilityRuleDefinition>;
};

/** input type for inserting object relation for remote table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Obj_Rel_Insert_Input = {
  data: EligibilityRuleDefinition_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EligibilityRuleDefinition_On_Conflict>;
};

/** on_conflict condition type for table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_On_Conflict = {
  constraint: EligibilityRuleDefinition_Constraint;
  update_columns?: Array<EligibilityRuleDefinition_Update_Column>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};

/** Ordering options when selecting data from "eligibility_rule_definition". */
export type EligibilityRuleDefinition_Order_By = {
  childEligibilityRuleDefinitions_aggregate?: InputMaybe<EligibilityRuleDefinition_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  eligibilityRule?: InputMaybe<EligibilityRule_Order_By>;
  eligibilityRuleId?: InputMaybe<Order_By>;
  eligibilityType?: InputMaybe<EligibilityType_Order_By>;
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jsonValue?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  parentEligibilityRuleDefinition?: InputMaybe<EligibilityRuleDefinition_Order_By>;
  parentEligibilityRuleDefinitionId?: InputMaybe<Order_By>;
  singleValue?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eligibility_rule_definition */
export type EligibilityRuleDefinition_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EligibilityRuleDefinition_Prepend_Input = {
  jsonValue?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "eligibility_rule_definition" */
export enum EligibilityRuleDefinition_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EligibilityRuleId = 'eligibilityRuleId',
  /** column name */
  EligibilityTypeId = 'eligibilityTypeId',
  /** column name */
  EndNumber = 'endNumber',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  JsonValue = 'jsonValue',
  /** column name */
  ParentEligibilityRuleDefinitionId = 'parentEligibilityRuleDefinitionId',
  /** column name */
  SingleValue = 'singleValue',
  /** column name */
  StartNumber = 'startNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  eligibilityRuleId?: InputMaybe<Scalars['uuid']>;
  eligibilityTypeId?: InputMaybe<Scalars['Int']>;
  endNumber?: InputMaybe<Scalars['numeric']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  jsonValue?: InputMaybe<Scalars['jsonb']>;
  parentEligibilityRuleDefinitionId?: InputMaybe<Scalars['uuid']>;
  singleValue?: InputMaybe<Scalars['String']>;
  startNumber?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EligibilityRuleDefinition_Stddev_Fields = {
  __typename?: 'eligibilityRuleDefinition_stddev_fields';
  eligibilityTypeId?: Maybe<Scalars['Float']>;
  endNumber?: Maybe<Scalars['Float']>;
  startNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Stddev_Order_By = {
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EligibilityRuleDefinition_Stddev_Pop_Fields = {
  __typename?: 'eligibilityRuleDefinition_stddev_pop_fields';
  eligibilityTypeId?: Maybe<Scalars['Float']>;
  endNumber?: Maybe<Scalars['Float']>;
  startNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Stddev_Pop_Order_By = {
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EligibilityRuleDefinition_Stddev_Samp_Fields = {
  __typename?: 'eligibilityRuleDefinition_stddev_samp_fields';
  eligibilityTypeId?: Maybe<Scalars['Float']>;
  endNumber?: Maybe<Scalars['Float']>;
  startNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Stddev_Samp_Order_By = {
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eligibilityRuleDefinition" */
export type EligibilityRuleDefinition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EligibilityRuleDefinition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EligibilityRuleDefinition_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  eligibilityRuleId?: InputMaybe<Scalars['uuid']>;
  eligibilityTypeId?: InputMaybe<Scalars['Int']>;
  endNumber?: InputMaybe<Scalars['numeric']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  jsonValue?: InputMaybe<Scalars['jsonb']>;
  parentEligibilityRuleDefinitionId?: InputMaybe<Scalars['uuid']>;
  singleValue?: InputMaybe<Scalars['String']>;
  startNumber?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EligibilityRuleDefinition_Sum_Fields = {
  __typename?: 'eligibilityRuleDefinition_sum_fields';
  eligibilityTypeId?: Maybe<Scalars['Int']>;
  endNumber?: Maybe<Scalars['numeric']>;
  startNumber?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Sum_Order_By = {
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
};

/** update columns of table "eligibility_rule_definition" */
export enum EligibilityRuleDefinition_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EligibilityRuleId = 'eligibilityRuleId',
  /** column name */
  EligibilityTypeId = 'eligibilityTypeId',
  /** column name */
  EndNumber = 'endNumber',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  JsonValue = 'jsonValue',
  /** column name */
  ParentEligibilityRuleDefinitionId = 'parentEligibilityRuleDefinitionId',
  /** column name */
  SingleValue = 'singleValue',
  /** column name */
  StartNumber = 'startNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EligibilityRuleDefinition_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EligibilityRuleDefinition_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EligibilityRuleDefinition_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EligibilityRuleDefinition_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EligibilityRuleDefinition_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EligibilityRuleDefinition_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EligibilityRuleDefinition_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EligibilityRuleDefinition_Set_Input>;
  /** filter the rows which have to be updated */
  where: EligibilityRuleDefinition_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EligibilityRuleDefinition_Var_Pop_Fields = {
  __typename?: 'eligibilityRuleDefinition_var_pop_fields';
  eligibilityTypeId?: Maybe<Scalars['Float']>;
  endNumber?: Maybe<Scalars['Float']>;
  startNumber?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Var_Pop_Order_By = {
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EligibilityRuleDefinition_Var_Samp_Fields = {
  __typename?: 'eligibilityRuleDefinition_var_samp_fields';
  eligibilityTypeId?: Maybe<Scalars['Float']>;
  endNumber?: Maybe<Scalars['Float']>;
  startNumber?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Var_Samp_Order_By = {
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EligibilityRuleDefinition_Variance_Fields = {
  __typename?: 'eligibilityRuleDefinition_variance_fields';
  eligibilityTypeId?: Maybe<Scalars['Float']>;
  endNumber?: Maybe<Scalars['Float']>;
  startNumber?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "eligibility_rule_definition" */
export type EligibilityRuleDefinition_Variance_Order_By = {
  eligibilityTypeId?: InputMaybe<Order_By>;
  endNumber?: InputMaybe<Order_By>;
  startNumber?: InputMaybe<Order_By>;
};

/** aggregated selection of "eligibility_rule" */
export type EligibilityRule_Aggregate = {
  __typename?: 'eligibilityRule_aggregate';
  aggregate?: Maybe<EligibilityRule_Aggregate_Fields>;
  nodes: Array<EligibilityRule>;
};

export type EligibilityRule_Aggregate_Bool_Exp = {
  count?: InputMaybe<EligibilityRule_Aggregate_Bool_Exp_Count>;
};

export type EligibilityRule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EligibilityRule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EligibilityRule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eligibility_rule" */
export type EligibilityRule_Aggregate_Fields = {
  __typename?: 'eligibilityRule_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EligibilityRule_Max_Fields>;
  min?: Maybe<EligibilityRule_Min_Fields>;
};


/** aggregate fields of "eligibility_rule" */
export type EligibilityRule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EligibilityRule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "eligibility_rule" */
export type EligibilityRule_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EligibilityRule_Max_Order_By>;
  min?: InputMaybe<EligibilityRule_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eligibility_rule" */
export type EligibilityRule_Arr_Rel_Insert_Input = {
  data: Array<EligibilityRule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EligibilityRule_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eligibility_rule". All fields are combined with a logical 'AND'. */
export type EligibilityRule_Bool_Exp = {
  _and?: InputMaybe<Array<EligibilityRule_Bool_Exp>>;
  _not?: InputMaybe<EligibilityRule_Bool_Exp>;
  _or?: InputMaybe<Array<EligibilityRule_Bool_Exp>>;
  application?: InputMaybe<Application_Bool_Exp>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  applicationRoutes?: InputMaybe<Route_Bool_Exp>;
  applicationRoutes_aggregate?: InputMaybe<Route_Aggregate_Bool_Exp>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  eligibilityRuleDefinitions?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
  eligibilityRuleDefinitions_aggregate?: InputMaybe<EligibilityRuleDefinition_Aggregate_Bool_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  entity_eligibility_rules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entity_eligibility_rules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  productEligibilityRules?: InputMaybe<ProductEligibility_Bool_Exp>;
  productEligibilityRules_aggregate?: InputMaybe<ProductEligibility_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eligibility_rule" */
export enum EligibilityRule_Constraint {
  /** unique or primary key constraint on columns "id" */
  EligibilityRulePkey = 'eligibility_rule_pkey'
}

/** input type for inserting data into table "eligibility_rule" */
export type EligibilityRule_Insert_Input = {
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  applicationId?: InputMaybe<Scalars['uuid']>;
  applicationRoutes?: InputMaybe<Route_Arr_Rel_Insert_Input>;
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eligibilityRuleDefinitions?: InputMaybe<EligibilityRuleDefinition_Arr_Rel_Insert_Input>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  entity_eligibility_rules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  productEligibilityRules?: InputMaybe<ProductEligibility_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EligibilityRule_Max_Fields = {
  __typename?: 'eligibilityRule_max_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "eligibility_rule" */
export type EligibilityRule_Max_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EligibilityRule_Min_Fields = {
  __typename?: 'eligibilityRule_min_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "eligibility_rule" */
export type EligibilityRule_Min_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eligibility_rule" */
export type EligibilityRule_Mutation_Response = {
  __typename?: 'eligibilityRule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EligibilityRule>;
};

/** input type for inserting object relation for remote table "eligibility_rule" */
export type EligibilityRule_Obj_Rel_Insert_Input = {
  data: EligibilityRule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EligibilityRule_On_Conflict>;
};

/** on_conflict condition type for table "eligibility_rule" */
export type EligibilityRule_On_Conflict = {
  constraint: EligibilityRule_Constraint;
  update_columns?: Array<EligibilityRule_Update_Column>;
  where?: InputMaybe<EligibilityRule_Bool_Exp>;
};

/** Ordering options when selecting data from "eligibility_rule". */
export type EligibilityRule_Order_By = {
  application?: InputMaybe<Application_Order_By>;
  applicationId?: InputMaybe<Order_By>;
  applicationRoutes_aggregate?: InputMaybe<Route_Aggregate_Order_By>;
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  eligibilityRuleDefinitions_aggregate?: InputMaybe<EligibilityRuleDefinition_Aggregate_Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  entity_eligibility_rules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  productEligibilityRules_aggregate?: InputMaybe<ProductEligibility_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eligibility_rule */
export type EligibilityRule_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "eligibility_rule" */
export enum EligibilityRule_Select_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "eligibility_rule" */
export type EligibilityRule_Set_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "eligibilityRule" */
export type EligibilityRule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EligibilityRule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EligibilityRule_Stream_Cursor_Value_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "eligibility_rule" */
export enum EligibilityRule_Update_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EligibilityRule_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EligibilityRule_Set_Input>;
  /** filter the rows which have to be updated */
  where: EligibilityRule_Bool_Exp;
};

/** columns and relationships of "eligibility_type" */
export type EligibilityType = {
  __typename?: 'eligibilityType';
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  eligibilityRuleDefinitions: Array<EligibilityRuleDefinition>;
  /** An aggregate relationship */
  eligibilityRuleDefinitions_aggregate: EligibilityRuleDefinition_Aggregate;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "eligibility_type" */
export type EligibilityTypeEligibilityRuleDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRuleDefinition_Order_By>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};


/** columns and relationships of "eligibility_type" */
export type EligibilityTypeEligibilityRuleDefinitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRuleDefinition_Order_By>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};

/** aggregated selection of "eligibility_type" */
export type EligibilityType_Aggregate = {
  __typename?: 'eligibilityType_aggregate';
  aggregate?: Maybe<EligibilityType_Aggregate_Fields>;
  nodes: Array<EligibilityType>;
};

/** aggregate fields of "eligibility_type" */
export type EligibilityType_Aggregate_Fields = {
  __typename?: 'eligibilityType_aggregate_fields';
  avg?: Maybe<EligibilityType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<EligibilityType_Max_Fields>;
  min?: Maybe<EligibilityType_Min_Fields>;
  stddev?: Maybe<EligibilityType_Stddev_Fields>;
  stddev_pop?: Maybe<EligibilityType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EligibilityType_Stddev_Samp_Fields>;
  sum?: Maybe<EligibilityType_Sum_Fields>;
  var_pop?: Maybe<EligibilityType_Var_Pop_Fields>;
  var_samp?: Maybe<EligibilityType_Var_Samp_Fields>;
  variance?: Maybe<EligibilityType_Variance_Fields>;
};


/** aggregate fields of "eligibility_type" */
export type EligibilityType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EligibilityType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EligibilityType_Avg_Fields = {
  __typename?: 'eligibilityType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "eligibility_type". All fields are combined with a logical 'AND'. */
export type EligibilityType_Bool_Exp = {
  _and?: InputMaybe<Array<EligibilityType_Bool_Exp>>;
  _not?: InputMaybe<EligibilityType_Bool_Exp>;
  _or?: InputMaybe<Array<EligibilityType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  eligibilityRuleDefinitions?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
  eligibilityRuleDefinitions_aggregate?: InputMaybe<EligibilityRuleDefinition_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eligibility_type" */
export enum EligibilityType_Constraint {
  /** unique or primary key constraint on columns "id" */
  EligibilityTypePkey = 'eligibility_type_pkey'
}

/** input type for incrementing numeric columns in table "eligibility_type" */
export type EligibilityType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "eligibility_type" */
export type EligibilityType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  eligibilityRuleDefinitions?: InputMaybe<EligibilityRuleDefinition_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EligibilityType_Max_Fields = {
  __typename?: 'eligibilityType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type EligibilityType_Min_Fields = {
  __typename?: 'eligibilityType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "eligibility_type" */
export type EligibilityType_Mutation_Response = {
  __typename?: 'eligibilityType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EligibilityType>;
};

/** input type for inserting object relation for remote table "eligibility_type" */
export type EligibilityType_Obj_Rel_Insert_Input = {
  data: EligibilityType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EligibilityType_On_Conflict>;
};

/** on_conflict condition type for table "eligibility_type" */
export type EligibilityType_On_Conflict = {
  constraint: EligibilityType_Constraint;
  update_columns?: Array<EligibilityType_Update_Column>;
  where?: InputMaybe<EligibilityType_Bool_Exp>;
};

/** Ordering options when selecting data from "eligibility_type". */
export type EligibilityType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  eligibilityRuleDefinitions_aggregate?: InputMaybe<EligibilityRuleDefinition_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eligibility_type */
export type EligibilityType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "eligibility_type" */
export enum EligibilityType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "eligibility_type" */
export type EligibilityType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EligibilityType_Stddev_Fields = {
  __typename?: 'eligibilityType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EligibilityType_Stddev_Pop_Fields = {
  __typename?: 'eligibilityType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EligibilityType_Stddev_Samp_Fields = {
  __typename?: 'eligibilityType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "eligibilityType" */
export type EligibilityType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EligibilityType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EligibilityType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EligibilityType_Sum_Fields = {
  __typename?: 'eligibilityType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "eligibility_type" */
export enum EligibilityType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EligibilityType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EligibilityType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EligibilityType_Set_Input>;
  /** filter the rows which have to be updated */
  where: EligibilityType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EligibilityType_Var_Pop_Fields = {
  __typename?: 'eligibilityType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EligibilityType_Var_Samp_Fields = {
  __typename?: 'eligibilityType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EligibilityType_Variance_Fields = {
  __typename?: 'eligibilityType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "shared.entity_billing_information" */
export type EntityBillingInformation = {
  __typename?: 'entityBillingInformation';
  /** An object relationship */
  account?: Maybe<Account>;
  accountNumber: Scalars['String'];
  /** An object relationship */
  bankAccountType: BankAccountType;
  bankAccountTypeId: Scalars['uuid'];
  bankName: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  parentId: Scalars['uuid'];
  routingNumber: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "shared.entity_billing_information" */
export type EntityBillingInformation_Aggregate = {
  __typename?: 'entityBillingInformation_aggregate';
  aggregate?: Maybe<EntityBillingInformation_Aggregate_Fields>;
  nodes: Array<EntityBillingInformation>;
};

export type EntityBillingInformation_Aggregate_Bool_Exp = {
  count?: InputMaybe<EntityBillingInformation_Aggregate_Bool_Exp_Count>;
};

export type EntityBillingInformation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityBillingInformation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityBillingInformation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.entity_billing_information" */
export type EntityBillingInformation_Aggregate_Fields = {
  __typename?: 'entityBillingInformation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityBillingInformation_Max_Fields>;
  min?: Maybe<EntityBillingInformation_Min_Fields>;
};


/** aggregate fields of "shared.entity_billing_information" */
export type EntityBillingInformation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityBillingInformation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.entity_billing_information" */
export type EntityBillingInformation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityBillingInformation_Max_Order_By>;
  min?: InputMaybe<EntityBillingInformation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.entity_billing_information" */
export type EntityBillingInformation_Arr_Rel_Insert_Input = {
  data: Array<EntityBillingInformation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityBillingInformation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.entity_billing_information". All fields are combined with a logical 'AND'. */
export type EntityBillingInformation_Bool_Exp = {
  _and?: InputMaybe<Array<EntityBillingInformation_Bool_Exp>>;
  _not?: InputMaybe<EntityBillingInformation_Bool_Exp>;
  _or?: InputMaybe<Array<EntityBillingInformation_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountNumber?: InputMaybe<String_Comparison_Exp>;
  bankAccountType?: InputMaybe<BankAccountType_Bool_Exp>;
  bankAccountTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  bankName?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  routingNumber?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.entity_billing_information" */
export enum EntityBillingInformation_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityBillingInformationPkey = 'entity_billing_information_pkey'
}

/** input type for inserting data into table "shared.entity_billing_information" */
export type EntityBillingInformation_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountNumber?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<BankAccountType_Obj_Rel_Insert_Input>;
  bankAccountTypeId?: InputMaybe<Scalars['uuid']>;
  bankName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  routingNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EntityBillingInformation_Max_Fields = {
  __typename?: 'entityBillingInformation_max_fields';
  accountNumber?: Maybe<Scalars['String']>;
  bankAccountTypeId?: Maybe<Scalars['uuid']>;
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  routingNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.entity_billing_information" */
export type EntityBillingInformation_Max_Order_By = {
  accountNumber?: InputMaybe<Order_By>;
  bankAccountTypeId?: InputMaybe<Order_By>;
  bankName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  routingNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityBillingInformation_Min_Fields = {
  __typename?: 'entityBillingInformation_min_fields';
  accountNumber?: Maybe<Scalars['String']>;
  bankAccountTypeId?: Maybe<Scalars['uuid']>;
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  routingNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.entity_billing_information" */
export type EntityBillingInformation_Min_Order_By = {
  accountNumber?: InputMaybe<Order_By>;
  bankAccountTypeId?: InputMaybe<Order_By>;
  bankName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  routingNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.entity_billing_information" */
export type EntityBillingInformation_Mutation_Response = {
  __typename?: 'entityBillingInformation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityBillingInformation>;
};

/** on_conflict condition type for table "shared.entity_billing_information" */
export type EntityBillingInformation_On_Conflict = {
  constraint: EntityBillingInformation_Constraint;
  update_columns?: Array<EntityBillingInformation_Update_Column>;
  where?: InputMaybe<EntityBillingInformation_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.entity_billing_information". */
export type EntityBillingInformation_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountNumber?: InputMaybe<Order_By>;
  bankAccountType?: InputMaybe<BankAccountType_Order_By>;
  bankAccountTypeId?: InputMaybe<Order_By>;
  bankName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  routingNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.entity_billing_information */
export type EntityBillingInformation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.entity_billing_information" */
export enum EntityBillingInformation_Select_Column {
  /** column name */
  AccountNumber = 'accountNumber',
  /** column name */
  BankAccountTypeId = 'bankAccountTypeId',
  /** column name */
  BankName = 'bankName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  RoutingNumber = 'routingNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.entity_billing_information" */
export type EntityBillingInformation_Set_Input = {
  accountNumber?: InputMaybe<Scalars['String']>;
  bankAccountTypeId?: InputMaybe<Scalars['uuid']>;
  bankName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  routingNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "entityBillingInformation" */
export type EntityBillingInformation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityBillingInformation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityBillingInformation_Stream_Cursor_Value_Input = {
  accountNumber?: InputMaybe<Scalars['String']>;
  bankAccountTypeId?: InputMaybe<Scalars['uuid']>;
  bankName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  routingNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.entity_billing_information" */
export enum EntityBillingInformation_Update_Column {
  /** column name */
  AccountNumber = 'accountNumber',
  /** column name */
  BankAccountTypeId = 'bankAccountTypeId',
  /** column name */
  BankName = 'bankName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  RoutingNumber = 'routingNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityBillingInformation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityBillingInformation_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityBillingInformation_Bool_Exp;
};

/** columns and relationships of "entity_configuration_item" */
export type EntityConfigurationItem = {
  __typename?: 'entityConfigurationItem';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  accountCategory?: Maybe<AccountCategory>;
  /** An object relationship */
  category?: Maybe<Category>;
  /** An object relationship */
  configurationItem: ConfigurationItem;
  configurationItemId: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  identity?: Maybe<Identity>;
  parentId: Scalars['uuid'];
  /** An object relationship */
  product?: Maybe<Product>;
  updatedAt: Scalars['timestamptz'];
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "entity_configuration_item" */
export type EntityConfigurationItem_Aggregate = {
  __typename?: 'entityConfigurationItem_aggregate';
  aggregate?: Maybe<EntityConfigurationItem_Aggregate_Fields>;
  nodes: Array<EntityConfigurationItem>;
};

export type EntityConfigurationItem_Aggregate_Bool_Exp = {
  count?: InputMaybe<EntityConfigurationItem_Aggregate_Bool_Exp_Count>;
};

export type EntityConfigurationItem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entity_configuration_item" */
export type EntityConfigurationItem_Aggregate_Fields = {
  __typename?: 'entityConfigurationItem_aggregate_fields';
  avg?: Maybe<EntityConfigurationItem_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<EntityConfigurationItem_Max_Fields>;
  min?: Maybe<EntityConfigurationItem_Min_Fields>;
  stddev?: Maybe<EntityConfigurationItem_Stddev_Fields>;
  stddev_pop?: Maybe<EntityConfigurationItem_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EntityConfigurationItem_Stddev_Samp_Fields>;
  sum?: Maybe<EntityConfigurationItem_Sum_Fields>;
  var_pop?: Maybe<EntityConfigurationItem_Var_Pop_Fields>;
  var_samp?: Maybe<EntityConfigurationItem_Var_Samp_Fields>;
  variance?: Maybe<EntityConfigurationItem_Variance_Fields>;
};


/** aggregate fields of "entity_configuration_item" */
export type EntityConfigurationItem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "entity_configuration_item" */
export type EntityConfigurationItem_Aggregate_Order_By = {
  avg?: InputMaybe<EntityConfigurationItem_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityConfigurationItem_Max_Order_By>;
  min?: InputMaybe<EntityConfigurationItem_Min_Order_By>;
  stddev?: InputMaybe<EntityConfigurationItem_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EntityConfigurationItem_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EntityConfigurationItem_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EntityConfigurationItem_Sum_Order_By>;
  var_pop?: InputMaybe<EntityConfigurationItem_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EntityConfigurationItem_Var_Samp_Order_By>;
  variance?: InputMaybe<EntityConfigurationItem_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "entity_configuration_item" */
export type EntityConfigurationItem_Arr_Rel_Insert_Input = {
  data: Array<EntityConfigurationItem_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityConfigurationItem_On_Conflict>;
};

/** aggregate avg on columns */
export type EntityConfigurationItem_Avg_Fields = {
  __typename?: 'entityConfigurationItem_avg_fields';
  configurationItemId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "entity_configuration_item" */
export type EntityConfigurationItem_Avg_Order_By = {
  configurationItemId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "entity_configuration_item". All fields are combined with a logical 'AND'. */
export type EntityConfigurationItem_Bool_Exp = {
  _and?: InputMaybe<Array<EntityConfigurationItem_Bool_Exp>>;
  _not?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
  _or?: InputMaybe<Array<EntityConfigurationItem_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountCategory?: InputMaybe<AccountCategory_Bool_Exp>;
  category?: InputMaybe<Category_Bool_Exp>;
  configurationItem?: InputMaybe<ConfigurationItem_Bool_Exp>;
  configurationItemId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_configuration_item" */
export enum EntityConfigurationItem_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityConfigurationItemPkey = 'entity_configuration_item_pkey'
}

/** input type for incrementing numeric columns in table "entity_configuration_item" */
export type EntityConfigurationItem_Inc_Input = {
  configurationItemId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "entity_configuration_item" */
export type EntityConfigurationItem_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountCategory?: InputMaybe<AccountCategory_Obj_Rel_Insert_Input>;
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  configurationItem?: InputMaybe<ConfigurationItem_Obj_Rel_Insert_Input>;
  configurationItemId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EntityConfigurationItem_Max_Fields = {
  __typename?: 'entityConfigurationItem_max_fields';
  configurationItemId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "entity_configuration_item" */
export type EntityConfigurationItem_Max_Order_By = {
  configurationItemId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityConfigurationItem_Min_Fields = {
  __typename?: 'entityConfigurationItem_min_fields';
  configurationItemId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "entity_configuration_item" */
export type EntityConfigurationItem_Min_Order_By = {
  configurationItemId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity_configuration_item" */
export type EntityConfigurationItem_Mutation_Response = {
  __typename?: 'entityConfigurationItem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityConfigurationItem>;
};

/** on_conflict condition type for table "entity_configuration_item" */
export type EntityConfigurationItem_On_Conflict = {
  constraint: EntityConfigurationItem_Constraint;
  update_columns?: Array<EntityConfigurationItem_Update_Column>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_configuration_item". */
export type EntityConfigurationItem_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountCategory?: InputMaybe<AccountCategory_Order_By>;
  category?: InputMaybe<Category_Order_By>;
  configurationItem?: InputMaybe<ConfigurationItem_Order_By>;
  configurationItemId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  parentId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_configuration_item */
export type EntityConfigurationItem_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "entity_configuration_item" */
export enum EntityConfigurationItem_Select_Column {
  /** column name */
  ConfigurationItemId = 'configurationItemId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "entity_configuration_item" */
export type EntityConfigurationItem_Set_Input = {
  configurationItemId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EntityConfigurationItem_Stddev_Fields = {
  __typename?: 'entityConfigurationItem_stddev_fields';
  configurationItemId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "entity_configuration_item" */
export type EntityConfigurationItem_Stddev_Order_By = {
  configurationItemId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EntityConfigurationItem_Stddev_Pop_Fields = {
  __typename?: 'entityConfigurationItem_stddev_pop_fields';
  configurationItemId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "entity_configuration_item" */
export type EntityConfigurationItem_Stddev_Pop_Order_By = {
  configurationItemId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EntityConfigurationItem_Stddev_Samp_Fields = {
  __typename?: 'entityConfigurationItem_stddev_samp_fields';
  configurationItemId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "entity_configuration_item" */
export type EntityConfigurationItem_Stddev_Samp_Order_By = {
  configurationItemId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entityConfigurationItem" */
export type EntityConfigurationItem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityConfigurationItem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityConfigurationItem_Stream_Cursor_Value_Input = {
  configurationItemId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type EntityConfigurationItem_Sum_Fields = {
  __typename?: 'entityConfigurationItem_sum_fields';
  configurationItemId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "entity_configuration_item" */
export type EntityConfigurationItem_Sum_Order_By = {
  configurationItemId?: InputMaybe<Order_By>;
};

/** update columns of table "entity_configuration_item" */
export enum EntityConfigurationItem_Update_Column {
  /** column name */
  ConfigurationItemId = 'configurationItemId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

export type EntityConfigurationItem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EntityConfigurationItem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityConfigurationItem_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityConfigurationItem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EntityConfigurationItem_Var_Pop_Fields = {
  __typename?: 'entityConfigurationItem_var_pop_fields';
  configurationItemId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "entity_configuration_item" */
export type EntityConfigurationItem_Var_Pop_Order_By = {
  configurationItemId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EntityConfigurationItem_Var_Samp_Fields = {
  __typename?: 'entityConfigurationItem_var_samp_fields';
  configurationItemId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "entity_configuration_item" */
export type EntityConfigurationItem_Var_Samp_Order_By = {
  configurationItemId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EntityConfigurationItem_Variance_Fields = {
  __typename?: 'entityConfigurationItem_variance_fields';
  configurationItemId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "entity_configuration_item" */
export type EntityConfigurationItem_Variance_Order_By = {
  configurationItemId?: InputMaybe<Order_By>;
};

/** Defines what content_types are required for a given parent. */
export type EntityContentType = {
  __typename?: 'entityContentType';
  /** An object relationship */
  contentType: ContentType;
  contentTypeId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** The entity that requires the content_type (e.g. the id of the policy_claim). */
  parentId: Scalars['uuid'];
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
  updatedAt: Scalars['timestamptz'];
};


/** Defines what content_types are required for a given parent. */
export type EntityContentTypeLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** Defines what content_types are required for a given parent. */
export type EntityContentTypeLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "shared.entity_content_type" */
export type EntityContentType_Aggregate = {
  __typename?: 'entityContentType_aggregate';
  aggregate?: Maybe<EntityContentType_Aggregate_Fields>;
  nodes: Array<EntityContentType>;
};

export type EntityContentType_Aggregate_Bool_Exp = {
  count?: InputMaybe<EntityContentType_Aggregate_Bool_Exp_Count>;
};

export type EntityContentType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityContentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityContentType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.entity_content_type" */
export type EntityContentType_Aggregate_Fields = {
  __typename?: 'entityContentType_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityContentType_Max_Fields>;
  min?: Maybe<EntityContentType_Min_Fields>;
};


/** aggregate fields of "shared.entity_content_type" */
export type EntityContentType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityContentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.entity_content_type" */
export type EntityContentType_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityContentType_Max_Order_By>;
  min?: InputMaybe<EntityContentType_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.entity_content_type" */
export type EntityContentType_Arr_Rel_Insert_Input = {
  data: Array<EntityContentType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityContentType_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.entity_content_type". All fields are combined with a logical 'AND'. */
export type EntityContentType_Bool_Exp = {
  _and?: InputMaybe<Array<EntityContentType_Bool_Exp>>;
  _not?: InputMaybe<EntityContentType_Bool_Exp>;
  _or?: InputMaybe<Array<EntityContentType_Bool_Exp>>;
  contentType?: InputMaybe<ContentType_Bool_Exp>;
  contentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.entity_content_type" */
export enum EntityContentType_Constraint {
  /** unique or primary key constraint on columns "parent_id", "content_type_id" */
  EntityContentTypeParentIdContentTypeIdKey = 'entity_content_type_parent_id_content_type_id_key',
  /** unique or primary key constraint on columns "id" */
  EntityContentTypePkey = 'entity_content_type_pkey'
}

/** input type for inserting data into table "shared.entity_content_type" */
export type EntityContentType_Insert_Input = {
  contentType?: InputMaybe<ContentType_Obj_Rel_Insert_Input>;
  contentTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  /** The entity that requires the content_type (e.g. the id of the policy_claim). */
  parentId?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EntityContentType_Max_Fields = {
  __typename?: 'entityContentType_max_fields';
  contentTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The entity that requires the content_type (e.g. the id of the policy_claim). */
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.entity_content_type" */
export type EntityContentType_Max_Order_By = {
  contentTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The entity that requires the content_type (e.g. the id of the policy_claim). */
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityContentType_Min_Fields = {
  __typename?: 'entityContentType_min_fields';
  contentTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The entity that requires the content_type (e.g. the id of the policy_claim). */
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.entity_content_type" */
export type EntityContentType_Min_Order_By = {
  contentTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The entity that requires the content_type (e.g. the id of the policy_claim). */
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.entity_content_type" */
export type EntityContentType_Mutation_Response = {
  __typename?: 'entityContentType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityContentType>;
};

/** on_conflict condition type for table "shared.entity_content_type" */
export type EntityContentType_On_Conflict = {
  constraint: EntityContentType_Constraint;
  update_columns?: Array<EntityContentType_Update_Column>;
  where?: InputMaybe<EntityContentType_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.entity_content_type". */
export type EntityContentType_Order_By = {
  contentType?: InputMaybe<ContentType_Order_By>;
  contentTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  parentId?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.entity_content_type */
export type EntityContentType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.entity_content_type" */
export enum EntityContentType_Select_Column {
  /** column name */
  ContentTypeId = 'contentTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.entity_content_type" */
export type EntityContentType_Set_Input = {
  contentTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The entity that requires the content_type (e.g. the id of the policy_claim). */
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "entityContentType" */
export type EntityContentType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityContentType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityContentType_Stream_Cursor_Value_Input = {
  contentTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The entity that requires the content_type (e.g. the id of the policy_claim). */
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.entity_content_type" */
export enum EntityContentType_Update_Column {
  /** column name */
  ContentTypeId = 'contentTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityContentType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityContentType_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityContentType_Bool_Exp;
};

/** columns and relationships of "entity_custom_field" */
export type EntityCustomField = {
  __typename?: 'entityCustomField';
  /** An object relationship */
  account?: Maybe<Account>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  customField: CustomField;
  customFieldId: Scalars['uuid'];
  /** An array relationship */
  entityCustomFieldValues: Array<EntityCustomFieldValue>;
  /** An aggregate relationship */
  entityCustomFieldValues_aggregate: EntityCustomFieldValue_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  parentId: Scalars['uuid'];
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
  updatedAt: Scalars['timestamptz'];
  /** DEPRECATED DO NOT USE */
  value?: Maybe<Scalars['String']>;
};


/** columns and relationships of "entity_custom_field" */
export type EntityCustomFieldEntityCustomFieldValuesArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomFieldValue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomFieldValue_Order_By>>;
  where?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
};


/** columns and relationships of "entity_custom_field" */
export type EntityCustomFieldEntityCustomFieldValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomFieldValue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomFieldValue_Order_By>>;
  where?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
};


/** columns and relationships of "entity_custom_field" */
export type EntityCustomFieldLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "entity_custom_field" */
export type EntityCustomFieldLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** columns and relationships of "entity_custom_field_value" */
export type EntityCustomFieldValue = {
  __typename?: 'entityCustomFieldValue';
  /** An object relationship */
  customFieldData: CustomFieldData;
  customFieldDataId: Scalars['uuid'];
  /** An object relationship */
  entityCustomField: EntityCustomField;
  entityCustomFieldId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** mark an entityCustomField value as display only, user cannot update or change */
  isLocked: Scalars['Boolean'];
};

/** aggregated selection of "entity_custom_field_value" */
export type EntityCustomFieldValue_Aggregate = {
  __typename?: 'entityCustomFieldValue_aggregate';
  aggregate?: Maybe<EntityCustomFieldValue_Aggregate_Fields>;
  nodes: Array<EntityCustomFieldValue>;
};

export type EntityCustomFieldValue_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<EntityCustomFieldValue_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<EntityCustomFieldValue_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<EntityCustomFieldValue_Aggregate_Bool_Exp_Count>;
};

export type EntityCustomFieldValue_Aggregate_Bool_Exp_Bool_And = {
  arguments: EntityCustomFieldValue_Select_Column_EntityCustomFieldValue_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type EntityCustomFieldValue_Aggregate_Bool_Exp_Bool_Or = {
  arguments: EntityCustomFieldValue_Select_Column_EntityCustomFieldValue_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type EntityCustomFieldValue_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityCustomFieldValue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entity_custom_field_value" */
export type EntityCustomFieldValue_Aggregate_Fields = {
  __typename?: 'entityCustomFieldValue_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityCustomFieldValue_Max_Fields>;
  min?: Maybe<EntityCustomFieldValue_Min_Fields>;
};


/** aggregate fields of "entity_custom_field_value" */
export type EntityCustomFieldValue_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityCustomFieldValue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "entity_custom_field_value" */
export type EntityCustomFieldValue_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityCustomFieldValue_Max_Order_By>;
  min?: InputMaybe<EntityCustomFieldValue_Min_Order_By>;
};

/** input type for inserting array relation for remote table "entity_custom_field_value" */
export type EntityCustomFieldValue_Arr_Rel_Insert_Input = {
  data: Array<EntityCustomFieldValue_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityCustomFieldValue_On_Conflict>;
};

/** Boolean expression to filter rows from the table "entity_custom_field_value". All fields are combined with a logical 'AND'. */
export type EntityCustomFieldValue_Bool_Exp = {
  _and?: InputMaybe<Array<EntityCustomFieldValue_Bool_Exp>>;
  _not?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
  _or?: InputMaybe<Array<EntityCustomFieldValue_Bool_Exp>>;
  customFieldData?: InputMaybe<CustomFieldData_Bool_Exp>;
  customFieldDataId?: InputMaybe<Uuid_Comparison_Exp>;
  entityCustomField?: InputMaybe<EntityCustomField_Bool_Exp>;
  entityCustomFieldId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isLocked?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_custom_field_value" */
export enum EntityCustomFieldValue_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityCustomFieldValuePkey = 'entity_custom_field_value_pkey'
}

/** input type for inserting data into table "entity_custom_field_value" */
export type EntityCustomFieldValue_Insert_Input = {
  customFieldData?: InputMaybe<CustomFieldData_Obj_Rel_Insert_Input>;
  customFieldDataId?: InputMaybe<Scalars['uuid']>;
  entityCustomField?: InputMaybe<EntityCustomField_Obj_Rel_Insert_Input>;
  entityCustomFieldId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** mark an entityCustomField value as display only, user cannot update or change */
  isLocked?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type EntityCustomFieldValue_Max_Fields = {
  __typename?: 'entityCustomFieldValue_max_fields';
  customFieldDataId?: Maybe<Scalars['uuid']>;
  entityCustomFieldId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "entity_custom_field_value" */
export type EntityCustomFieldValue_Max_Order_By = {
  customFieldDataId?: InputMaybe<Order_By>;
  entityCustomFieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityCustomFieldValue_Min_Fields = {
  __typename?: 'entityCustomFieldValue_min_fields';
  customFieldDataId?: Maybe<Scalars['uuid']>;
  entityCustomFieldId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "entity_custom_field_value" */
export type EntityCustomFieldValue_Min_Order_By = {
  customFieldDataId?: InputMaybe<Order_By>;
  entityCustomFieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity_custom_field_value" */
export type EntityCustomFieldValue_Mutation_Response = {
  __typename?: 'entityCustomFieldValue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityCustomFieldValue>;
};

/** on_conflict condition type for table "entity_custom_field_value" */
export type EntityCustomFieldValue_On_Conflict = {
  constraint: EntityCustomFieldValue_Constraint;
  update_columns?: Array<EntityCustomFieldValue_Update_Column>;
  where?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_custom_field_value". */
export type EntityCustomFieldValue_Order_By = {
  customFieldData?: InputMaybe<CustomFieldData_Order_By>;
  customFieldDataId?: InputMaybe<Order_By>;
  entityCustomField?: InputMaybe<EntityCustomField_Order_By>;
  entityCustomFieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isLocked?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_custom_field_value */
export type EntityCustomFieldValue_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "entity_custom_field_value" */
export enum EntityCustomFieldValue_Select_Column {
  /** column name */
  CustomFieldDataId = 'customFieldDataId',
  /** column name */
  EntityCustomFieldId = 'entityCustomFieldId',
  /** column name */
  Id = 'id',
  /** column name */
  IsLocked = 'isLocked'
}

/** select "entityCustomFieldValue_aggregate_bool_exp_bool_and_arguments_columns" columns of table "entity_custom_field_value" */
export enum EntityCustomFieldValue_Select_Column_EntityCustomFieldValue_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsLocked = 'isLocked'
}

/** select "entityCustomFieldValue_aggregate_bool_exp_bool_or_arguments_columns" columns of table "entity_custom_field_value" */
export enum EntityCustomFieldValue_Select_Column_EntityCustomFieldValue_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsLocked = 'isLocked'
}

/** input type for updating data in table "entity_custom_field_value" */
export type EntityCustomFieldValue_Set_Input = {
  customFieldDataId?: InputMaybe<Scalars['uuid']>;
  entityCustomFieldId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** mark an entityCustomField value as display only, user cannot update or change */
  isLocked?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "entityCustomFieldValue" */
export type EntityCustomFieldValue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityCustomFieldValue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityCustomFieldValue_Stream_Cursor_Value_Input = {
  customFieldDataId?: InputMaybe<Scalars['uuid']>;
  entityCustomFieldId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** mark an entityCustomField value as display only, user cannot update or change */
  isLocked?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "entity_custom_field_value" */
export enum EntityCustomFieldValue_Update_Column {
  /** column name */
  CustomFieldDataId = 'customFieldDataId',
  /** column name */
  EntityCustomFieldId = 'entityCustomFieldId',
  /** column name */
  Id = 'id',
  /** column name */
  IsLocked = 'isLocked'
}

export type EntityCustomFieldValue_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityCustomFieldValue_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityCustomFieldValue_Bool_Exp;
};

/** aggregated selection of "entity_custom_field" */
export type EntityCustomField_Aggregate = {
  __typename?: 'entityCustomField_aggregate';
  aggregate?: Maybe<EntityCustomField_Aggregate_Fields>;
  nodes: Array<EntityCustomField>;
};

export type EntityCustomField_Aggregate_Bool_Exp = {
  count?: InputMaybe<EntityCustomField_Aggregate_Bool_Exp_Count>;
};

export type EntityCustomField_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityCustomField_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entity_custom_field" */
export type EntityCustomField_Aggregate_Fields = {
  __typename?: 'entityCustomField_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityCustomField_Max_Fields>;
  min?: Maybe<EntityCustomField_Min_Fields>;
};


/** aggregate fields of "entity_custom_field" */
export type EntityCustomField_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "entity_custom_field" */
export type EntityCustomField_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityCustomField_Max_Order_By>;
  min?: InputMaybe<EntityCustomField_Min_Order_By>;
};

/** input type for inserting array relation for remote table "entity_custom_field" */
export type EntityCustomField_Arr_Rel_Insert_Input = {
  data: Array<EntityCustomField_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityCustomField_On_Conflict>;
};

/** Boolean expression to filter rows from the table "entity_custom_field". All fields are combined with a logical 'AND'. */
export type EntityCustomField_Bool_Exp = {
  _and?: InputMaybe<Array<EntityCustomField_Bool_Exp>>;
  _not?: InputMaybe<EntityCustomField_Bool_Exp>;
  _or?: InputMaybe<Array<EntityCustomField_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customField?: InputMaybe<CustomField_Bool_Exp>;
  customFieldId?: InputMaybe<Uuid_Comparison_Exp>;
  entityCustomFieldValues?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
  entityCustomFieldValues_aggregate?: InputMaybe<EntityCustomFieldValue_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_custom_field" */
export enum EntityCustomField_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityCustomFieldPkey = 'entity_custom_field_pkey'
}

/** input type for inserting data into table "entity_custom_field" */
export type EntityCustomField_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customField?: InputMaybe<CustomField_Obj_Rel_Insert_Input>;
  customFieldId?: InputMaybe<Scalars['uuid']>;
  entityCustomFieldValues?: InputMaybe<EntityCustomFieldValue_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** DEPRECATED DO NOT USE */
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EntityCustomField_Max_Fields = {
  __typename?: 'entityCustomField_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customFieldId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED DO NOT USE */
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "entity_custom_field" */
export type EntityCustomField_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  customFieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  /** DEPRECATED DO NOT USE */
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityCustomField_Min_Fields = {
  __typename?: 'entityCustomField_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customFieldId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED DO NOT USE */
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "entity_custom_field" */
export type EntityCustomField_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  customFieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  /** DEPRECATED DO NOT USE */
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity_custom_field" */
export type EntityCustomField_Mutation_Response = {
  __typename?: 'entityCustomField_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityCustomField>;
};

/** input type for inserting object relation for remote table "entity_custom_field" */
export type EntityCustomField_Obj_Rel_Insert_Input = {
  data: EntityCustomField_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityCustomField_On_Conflict>;
};

/** on_conflict condition type for table "entity_custom_field" */
export type EntityCustomField_On_Conflict = {
  constraint: EntityCustomField_Constraint;
  update_columns?: Array<EntityCustomField_Update_Column>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_custom_field". */
export type EntityCustomField_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customField?: InputMaybe<CustomField_Order_By>;
  customFieldId?: InputMaybe<Order_By>;
  entityCustomFieldValues_aggregate?: InputMaybe<EntityCustomFieldValue_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  parentId?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_custom_field */
export type EntityCustomField_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "entity_custom_field" */
export enum EntityCustomField_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomFieldId = 'customFieldId',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "entity_custom_field" */
export type EntityCustomField_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customFieldId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** DEPRECATED DO NOT USE */
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "entityCustomField" */
export type EntityCustomField_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityCustomField_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityCustomField_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customFieldId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** DEPRECATED DO NOT USE */
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "entity_custom_field" */
export enum EntityCustomField_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomFieldId = 'customFieldId',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

export type EntityCustomField_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityCustomField_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityCustomField_Bool_Exp;
};

/** columns and relationships of "entity_data_definition" */
export type EntityDataDefinition = {
  __typename?: 'entityDataDefinition';
  /** An object relationship */
  customField?: Maybe<CustomField>;
  /** An object relationship */
  customFieldType?: Maybe<CustomFieldType>;
  /** An object relationship */
  dataType?: Maybe<DataType>;
  dataTypeEnumValue: Scalars['numeric'];
  id: Scalars['uuid'];
  parentId: Scalars['uuid'];
  propertyName: Scalars['String'];
  useForValue: Scalars['Boolean'];
};

/** aggregated selection of "entity_data_definition" */
export type EntityDataDefinition_Aggregate = {
  __typename?: 'entityDataDefinition_aggregate';
  aggregate?: Maybe<EntityDataDefinition_Aggregate_Fields>;
  nodes: Array<EntityDataDefinition>;
};

export type EntityDataDefinition_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<EntityDataDefinition_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<EntityDataDefinition_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<EntityDataDefinition_Aggregate_Bool_Exp_Count>;
};

export type EntityDataDefinition_Aggregate_Bool_Exp_Bool_And = {
  arguments: EntityDataDefinition_Select_Column_EntityDataDefinition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityDataDefinition_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type EntityDataDefinition_Aggregate_Bool_Exp_Bool_Or = {
  arguments: EntityDataDefinition_Select_Column_EntityDataDefinition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityDataDefinition_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type EntityDataDefinition_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityDataDefinition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityDataDefinition_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entity_data_definition" */
export type EntityDataDefinition_Aggregate_Fields = {
  __typename?: 'entityDataDefinition_aggregate_fields';
  avg?: Maybe<EntityDataDefinition_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<EntityDataDefinition_Max_Fields>;
  min?: Maybe<EntityDataDefinition_Min_Fields>;
  stddev?: Maybe<EntityDataDefinition_Stddev_Fields>;
  stddev_pop?: Maybe<EntityDataDefinition_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EntityDataDefinition_Stddev_Samp_Fields>;
  sum?: Maybe<EntityDataDefinition_Sum_Fields>;
  var_pop?: Maybe<EntityDataDefinition_Var_Pop_Fields>;
  var_samp?: Maybe<EntityDataDefinition_Var_Samp_Fields>;
  variance?: Maybe<EntityDataDefinition_Variance_Fields>;
};


/** aggregate fields of "entity_data_definition" */
export type EntityDataDefinition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityDataDefinition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "entity_data_definition" */
export type EntityDataDefinition_Aggregate_Order_By = {
  avg?: InputMaybe<EntityDataDefinition_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityDataDefinition_Max_Order_By>;
  min?: InputMaybe<EntityDataDefinition_Min_Order_By>;
  stddev?: InputMaybe<EntityDataDefinition_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EntityDataDefinition_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EntityDataDefinition_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EntityDataDefinition_Sum_Order_By>;
  var_pop?: InputMaybe<EntityDataDefinition_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EntityDataDefinition_Var_Samp_Order_By>;
  variance?: InputMaybe<EntityDataDefinition_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "entity_data_definition" */
export type EntityDataDefinition_Arr_Rel_Insert_Input = {
  data: Array<EntityDataDefinition_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityDataDefinition_On_Conflict>;
};

/** aggregate avg on columns */
export type EntityDataDefinition_Avg_Fields = {
  __typename?: 'entityDataDefinition_avg_fields';
  dataTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "entity_data_definition" */
export type EntityDataDefinition_Avg_Order_By = {
  dataTypeEnumValue?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "entity_data_definition". All fields are combined with a logical 'AND'. */
export type EntityDataDefinition_Bool_Exp = {
  _and?: InputMaybe<Array<EntityDataDefinition_Bool_Exp>>;
  _not?: InputMaybe<EntityDataDefinition_Bool_Exp>;
  _or?: InputMaybe<Array<EntityDataDefinition_Bool_Exp>>;
  customField?: InputMaybe<CustomField_Bool_Exp>;
  customFieldType?: InputMaybe<CustomFieldType_Bool_Exp>;
  dataType?: InputMaybe<DataType_Bool_Exp>;
  dataTypeEnumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  propertyName?: InputMaybe<String_Comparison_Exp>;
  useForValue?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_data_definition" */
export enum EntityDataDefinition_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityDataDefinitionPkey = 'entity_data_definition_pkey'
}

/** input type for incrementing numeric columns in table "entity_data_definition" */
export type EntityDataDefinition_Inc_Input = {
  dataTypeEnumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "entity_data_definition" */
export type EntityDataDefinition_Insert_Input = {
  customField?: InputMaybe<CustomField_Obj_Rel_Insert_Input>;
  customFieldType?: InputMaybe<CustomFieldType_Obj_Rel_Insert_Input>;
  dataType?: InputMaybe<DataType_Obj_Rel_Insert_Input>;
  dataTypeEnumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  propertyName?: InputMaybe<Scalars['String']>;
  useForValue?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type EntityDataDefinition_Max_Fields = {
  __typename?: 'entityDataDefinition_max_fields';
  dataTypeEnumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  propertyName?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "entity_data_definition" */
export type EntityDataDefinition_Max_Order_By = {
  dataTypeEnumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  propertyName?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityDataDefinition_Min_Fields = {
  __typename?: 'entityDataDefinition_min_fields';
  dataTypeEnumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  propertyName?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "entity_data_definition" */
export type EntityDataDefinition_Min_Order_By = {
  dataTypeEnumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  propertyName?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity_data_definition" */
export type EntityDataDefinition_Mutation_Response = {
  __typename?: 'entityDataDefinition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityDataDefinition>;
};

/** on_conflict condition type for table "entity_data_definition" */
export type EntityDataDefinition_On_Conflict = {
  constraint: EntityDataDefinition_Constraint;
  update_columns?: Array<EntityDataDefinition_Update_Column>;
  where?: InputMaybe<EntityDataDefinition_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_data_definition". */
export type EntityDataDefinition_Order_By = {
  customField?: InputMaybe<CustomField_Order_By>;
  customFieldType?: InputMaybe<CustomFieldType_Order_By>;
  dataType?: InputMaybe<DataType_Order_By>;
  dataTypeEnumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  propertyName?: InputMaybe<Order_By>;
  useForValue?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_data_definition */
export type EntityDataDefinition_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "entity_data_definition" */
export enum EntityDataDefinition_Select_Column {
  /** column name */
  DataTypeEnumValue = 'dataTypeEnumValue',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PropertyName = 'propertyName',
  /** column name */
  UseForValue = 'useForValue'
}

/** select "entityDataDefinition_aggregate_bool_exp_bool_and_arguments_columns" columns of table "entity_data_definition" */
export enum EntityDataDefinition_Select_Column_EntityDataDefinition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  UseForValue = 'useForValue'
}

/** select "entityDataDefinition_aggregate_bool_exp_bool_or_arguments_columns" columns of table "entity_data_definition" */
export enum EntityDataDefinition_Select_Column_EntityDataDefinition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  UseForValue = 'useForValue'
}

/** input type for updating data in table "entity_data_definition" */
export type EntityDataDefinition_Set_Input = {
  dataTypeEnumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  propertyName?: InputMaybe<Scalars['String']>;
  useForValue?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type EntityDataDefinition_Stddev_Fields = {
  __typename?: 'entityDataDefinition_stddev_fields';
  dataTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "entity_data_definition" */
export type EntityDataDefinition_Stddev_Order_By = {
  dataTypeEnumValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EntityDataDefinition_Stddev_Pop_Fields = {
  __typename?: 'entityDataDefinition_stddev_pop_fields';
  dataTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "entity_data_definition" */
export type EntityDataDefinition_Stddev_Pop_Order_By = {
  dataTypeEnumValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EntityDataDefinition_Stddev_Samp_Fields = {
  __typename?: 'entityDataDefinition_stddev_samp_fields';
  dataTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "entity_data_definition" */
export type EntityDataDefinition_Stddev_Samp_Order_By = {
  dataTypeEnumValue?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entityDataDefinition" */
export type EntityDataDefinition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityDataDefinition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityDataDefinition_Stream_Cursor_Value_Input = {
  dataTypeEnumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  propertyName?: InputMaybe<Scalars['String']>;
  useForValue?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type EntityDataDefinition_Sum_Fields = {
  __typename?: 'entityDataDefinition_sum_fields';
  dataTypeEnumValue?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "entity_data_definition" */
export type EntityDataDefinition_Sum_Order_By = {
  dataTypeEnumValue?: InputMaybe<Order_By>;
};

/** update columns of table "entity_data_definition" */
export enum EntityDataDefinition_Update_Column {
  /** column name */
  DataTypeEnumValue = 'dataTypeEnumValue',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PropertyName = 'propertyName',
  /** column name */
  UseForValue = 'useForValue'
}

export type EntityDataDefinition_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EntityDataDefinition_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityDataDefinition_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityDataDefinition_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EntityDataDefinition_Var_Pop_Fields = {
  __typename?: 'entityDataDefinition_var_pop_fields';
  dataTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "entity_data_definition" */
export type EntityDataDefinition_Var_Pop_Order_By = {
  dataTypeEnumValue?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EntityDataDefinition_Var_Samp_Fields = {
  __typename?: 'entityDataDefinition_var_samp_fields';
  dataTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "entity_data_definition" */
export type EntityDataDefinition_Var_Samp_Order_By = {
  dataTypeEnumValue?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EntityDataDefinition_Variance_Fields = {
  __typename?: 'entityDataDefinition_variance_fields';
  dataTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "entity_data_definition" */
export type EntityDataDefinition_Variance_Order_By = {
  dataTypeEnumValue?: InputMaybe<Order_By>;
};

/** columns and relationships of "entity_eligibility_rule" */
export type EntityEligibilityRule = {
  __typename?: 'entityEligibilityRule';
  /** An object relationship */
  accountProduct?: Maybe<AccountProduct>;
  /** An object relationship */
  contractForm?: Maybe<ContractForm>;
  /** An object relationship */
  contractFormVersion?: Maybe<ContractFormVersion>;
  /** An object relationship */
  costAdjustment?: Maybe<CostAdjustment>;
  /** An object relationship */
  costAdjustmentLookup?: Maybe<CostAdjustmentLookup>;
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  eligibilityRule?: Maybe<EligibilityRule>;
  eligibilityRuleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  entityOffering?: Maybe<EntityOffering>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  isInclusion: Scalars['Boolean'];
  parentId: Scalars['uuid'];
  /** An object relationship */
  product?: Maybe<Product>;
  /** An object relationship */
  productContractForm?: Maybe<ProductContractForm>;
  /** An object relationship */
  productCost?: Maybe<ProductCost>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "entity_eligibility_rule" */
export type EntityEligibilityRule_Aggregate = {
  __typename?: 'entityEligibilityRule_aggregate';
  aggregate?: Maybe<EntityEligibilityRule_Aggregate_Fields>;
  nodes: Array<EntityEligibilityRule>;
};

export type EntityEligibilityRule_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp_Count>;
};

export type EntityEligibilityRule_Aggregate_Bool_Exp_Bool_And = {
  arguments: EntityEligibilityRule_Select_Column_EntityEligibilityRule_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type EntityEligibilityRule_Aggregate_Bool_Exp_Bool_Or = {
  arguments: EntityEligibilityRule_Select_Column_EntityEligibilityRule_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type EntityEligibilityRule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entity_eligibility_rule" */
export type EntityEligibilityRule_Aggregate_Fields = {
  __typename?: 'entityEligibilityRule_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityEligibilityRule_Max_Fields>;
  min?: Maybe<EntityEligibilityRule_Min_Fields>;
};


/** aggregate fields of "entity_eligibility_rule" */
export type EntityEligibilityRule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "entity_eligibility_rule" */
export type EntityEligibilityRule_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityEligibilityRule_Max_Order_By>;
  min?: InputMaybe<EntityEligibilityRule_Min_Order_By>;
};

/** input type for inserting array relation for remote table "entity_eligibility_rule" */
export type EntityEligibilityRule_Arr_Rel_Insert_Input = {
  data: Array<EntityEligibilityRule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityEligibilityRule_On_Conflict>;
};

/** Boolean expression to filter rows from the table "entity_eligibility_rule". All fields are combined with a logical 'AND'. */
export type EntityEligibilityRule_Bool_Exp = {
  _and?: InputMaybe<Array<EntityEligibilityRule_Bool_Exp>>;
  _not?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  _or?: InputMaybe<Array<EntityEligibilityRule_Bool_Exp>>;
  accountProduct?: InputMaybe<AccountProduct_Bool_Exp>;
  contractForm?: InputMaybe<ContractForm_Bool_Exp>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Bool_Exp>;
  costAdjustment?: InputMaybe<CostAdjustment_Bool_Exp>;
  costAdjustmentLookup?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  eligibilityRule?: InputMaybe<EligibilityRule_Bool_Exp>;
  eligibilityRuleId?: InputMaybe<Uuid_Comparison_Exp>;
  entityOffering?: InputMaybe<EntityOffering_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isInclusion?: InputMaybe<Boolean_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productContractForm?: InputMaybe<ProductContractForm_Bool_Exp>;
  productCost?: InputMaybe<ProductCost_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_eligibility_rule" */
export enum EntityEligibilityRule_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityEligibilityRulePkey = 'entity_eligibility_rule_pkey'
}

/** input type for inserting data into table "entity_eligibility_rule" */
export type EntityEligibilityRule_Insert_Input = {
  accountProduct?: InputMaybe<AccountProduct_Obj_Rel_Insert_Input>;
  contractForm?: InputMaybe<ContractForm_Obj_Rel_Insert_Input>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Obj_Rel_Insert_Input>;
  costAdjustment?: InputMaybe<CostAdjustment_Obj_Rel_Insert_Input>;
  costAdjustmentLookup?: InputMaybe<CostAdjustmentLookup_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  eligibilityRule?: InputMaybe<EligibilityRule_Obj_Rel_Insert_Input>;
  eligibilityRuleId?: InputMaybe<Scalars['uuid']>;
  entityOffering?: InputMaybe<EntityOffering_Obj_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInclusion?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productContractForm?: InputMaybe<ProductContractForm_Obj_Rel_Insert_Input>;
  productCost?: InputMaybe<ProductCost_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EntityEligibilityRule_Max_Fields = {
  __typename?: 'entityEligibilityRule_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  eligibilityRuleId?: Maybe<Scalars['uuid']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "entity_eligibility_rule" */
export type EntityEligibilityRule_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  eligibilityRuleId?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityEligibilityRule_Min_Fields = {
  __typename?: 'entityEligibilityRule_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  eligibilityRuleId?: Maybe<Scalars['uuid']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "entity_eligibility_rule" */
export type EntityEligibilityRule_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  eligibilityRuleId?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity_eligibility_rule" */
export type EntityEligibilityRule_Mutation_Response = {
  __typename?: 'entityEligibilityRule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityEligibilityRule>;
};

/** on_conflict condition type for table "entity_eligibility_rule" */
export type EntityEligibilityRule_On_Conflict = {
  constraint: EntityEligibilityRule_Constraint;
  update_columns?: Array<EntityEligibilityRule_Update_Column>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_eligibility_rule". */
export type EntityEligibilityRule_Order_By = {
  accountProduct?: InputMaybe<AccountProduct_Order_By>;
  contractForm?: InputMaybe<ContractForm_Order_By>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Order_By>;
  costAdjustment?: InputMaybe<CostAdjustment_Order_By>;
  costAdjustmentLookup?: InputMaybe<CostAdjustmentLookup_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  eligibilityRule?: InputMaybe<EligibilityRule_Order_By>;
  eligibilityRuleId?: InputMaybe<Order_By>;
  entityOffering?: InputMaybe<EntityOffering_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isInclusion?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productContractForm?: InputMaybe<ProductContractForm_Order_By>;
  productCost?: InputMaybe<ProductCost_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_eligibility_rule */
export type EntityEligibilityRule_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "entity_eligibility_rule" */
export enum EntityEligibilityRule_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EligibilityRuleId = 'eligibilityRuleId',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsInclusion = 'isInclusion',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "entityEligibilityRule_aggregate_bool_exp_bool_and_arguments_columns" columns of table "entity_eligibility_rule" */
export enum EntityEligibilityRule_Select_Column_EntityEligibilityRule_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsInclusion = 'isInclusion'
}

/** select "entityEligibilityRule_aggregate_bool_exp_bool_or_arguments_columns" columns of table "entity_eligibility_rule" */
export enum EntityEligibilityRule_Select_Column_EntityEligibilityRule_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsInclusion = 'isInclusion'
}

/** input type for updating data in table "entity_eligibility_rule" */
export type EntityEligibilityRule_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  eligibilityRuleId?: InputMaybe<Scalars['uuid']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInclusion?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "entityEligibilityRule" */
export type EntityEligibilityRule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityEligibilityRule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityEligibilityRule_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  eligibilityRuleId?: InputMaybe<Scalars['uuid']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInclusion?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "entity_eligibility_rule" */
export enum EntityEligibilityRule_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EligibilityRuleId = 'eligibilityRuleId',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsInclusion = 'isInclusion',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityEligibilityRule_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityEligibilityRule_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityEligibilityRule_Bool_Exp;
};

/** columns and relationships of "shared.entity_feature" */
export type EntityFeature = {
  __typename?: 'entityFeature';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  accountManager?: Maybe<AccountManager>;
  /** An object relationship */
  application?: Maybe<Application>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  feature: Feature;
  featureId: Scalars['uuid'];
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  parentId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "shared.entity_feature" */
export type EntityFeature_Aggregate = {
  __typename?: 'entityFeature_aggregate';
  aggregate?: Maybe<EntityFeature_Aggregate_Fields>;
  nodes: Array<EntityFeature>;
};

export type EntityFeature_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<EntityFeature_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<EntityFeature_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<EntityFeature_Aggregate_Bool_Exp_Count>;
};

export type EntityFeature_Aggregate_Bool_Exp_Bool_And = {
  arguments: EntityFeature_Select_Column_EntityFeature_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityFeature_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type EntityFeature_Aggregate_Bool_Exp_Bool_Or = {
  arguments: EntityFeature_Select_Column_EntityFeature_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityFeature_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type EntityFeature_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityFeature_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityFeature_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.entity_feature" */
export type EntityFeature_Aggregate_Fields = {
  __typename?: 'entityFeature_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityFeature_Max_Fields>;
  min?: Maybe<EntityFeature_Min_Fields>;
};


/** aggregate fields of "shared.entity_feature" */
export type EntityFeature_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityFeature_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.entity_feature" */
export type EntityFeature_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityFeature_Max_Order_By>;
  min?: InputMaybe<EntityFeature_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.entity_feature" */
export type EntityFeature_Arr_Rel_Insert_Input = {
  data: Array<EntityFeature_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityFeature_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.entity_feature". All fields are combined with a logical 'AND'. */
export type EntityFeature_Bool_Exp = {
  _and?: InputMaybe<Array<EntityFeature_Bool_Exp>>;
  _not?: InputMaybe<EntityFeature_Bool_Exp>;
  _or?: InputMaybe<Array<EntityFeature_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountManager?: InputMaybe<AccountManager_Bool_Exp>;
  application?: InputMaybe<Application_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  feature?: InputMaybe<Feature_Bool_Exp>;
  featureId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.entity_feature" */
export enum EntityFeature_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityFeaturePkey = 'entity_feature_pkey'
}

/** input type for inserting data into table "shared.entity_feature" */
export type EntityFeature_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountManager?: InputMaybe<AccountManager_Obj_Rel_Insert_Input>;
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  feature?: InputMaybe<Feature_Obj_Rel_Insert_Input>;
  featureId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EntityFeature_Max_Fields = {
  __typename?: 'entityFeature_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  featureId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.entity_feature" */
export type EntityFeature_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  featureId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityFeature_Min_Fields = {
  __typename?: 'entityFeature_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  featureId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.entity_feature" */
export type EntityFeature_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  featureId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.entity_feature" */
export type EntityFeature_Mutation_Response = {
  __typename?: 'entityFeature_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityFeature>;
};

/** on_conflict condition type for table "shared.entity_feature" */
export type EntityFeature_On_Conflict = {
  constraint: EntityFeature_Constraint;
  update_columns?: Array<EntityFeature_Update_Column>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.entity_feature". */
export type EntityFeature_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountManager?: InputMaybe<AccountManager_Order_By>;
  application?: InputMaybe<Application_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  feature?: InputMaybe<Feature_Order_By>;
  featureId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.entity_feature */
export type EntityFeature_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.entity_feature" */
export enum EntityFeature_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FeatureId = 'featureId',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "entityFeature_aggregate_bool_exp_bool_and_arguments_columns" columns of table "shared.entity_feature" */
export enum EntityFeature_Select_Column_EntityFeature_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** select "entityFeature_aggregate_bool_exp_bool_or_arguments_columns" columns of table "shared.entity_feature" */
export enum EntityFeature_Select_Column_EntityFeature_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "shared.entity_feature" */
export type EntityFeature_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  featureId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "entityFeature" */
export type EntityFeature_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityFeature_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityFeature_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  featureId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.entity_feature" */
export enum EntityFeature_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FeatureId = 'featureId',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityFeature_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityFeature_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityFeature_Bool_Exp;
};

/** Affiliates content_types to entity_file_storage records. */
export type EntityFileContentType = {
  __typename?: 'entityFileContentType';
  /** An object relationship */
  contentType: ContentType;
  contentTypeId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  entityFileStorage: EntityFileStorage;
  entityFileStorageId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** Affiliates content_types to entity_file_storage records. */
export type EntityFileContentTypeLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** Affiliates content_types to entity_file_storage records. */
export type EntityFileContentTypeLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "shared.entity_file_content_type" */
export type EntityFileContentType_Aggregate = {
  __typename?: 'entityFileContentType_aggregate';
  aggregate?: Maybe<EntityFileContentType_Aggregate_Fields>;
  nodes: Array<EntityFileContentType>;
};

export type EntityFileContentType_Aggregate_Bool_Exp = {
  count?: InputMaybe<EntityFileContentType_Aggregate_Bool_Exp_Count>;
};

export type EntityFileContentType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityFileContentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityFileContentType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.entity_file_content_type" */
export type EntityFileContentType_Aggregate_Fields = {
  __typename?: 'entityFileContentType_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityFileContentType_Max_Fields>;
  min?: Maybe<EntityFileContentType_Min_Fields>;
};


/** aggregate fields of "shared.entity_file_content_type" */
export type EntityFileContentType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityFileContentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.entity_file_content_type" */
export type EntityFileContentType_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityFileContentType_Max_Order_By>;
  min?: InputMaybe<EntityFileContentType_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.entity_file_content_type" */
export type EntityFileContentType_Arr_Rel_Insert_Input = {
  data: Array<EntityFileContentType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityFileContentType_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.entity_file_content_type". All fields are combined with a logical 'AND'. */
export type EntityFileContentType_Bool_Exp = {
  _and?: InputMaybe<Array<EntityFileContentType_Bool_Exp>>;
  _not?: InputMaybe<EntityFileContentType_Bool_Exp>;
  _or?: InputMaybe<Array<EntityFileContentType_Bool_Exp>>;
  contentType?: InputMaybe<ContentType_Bool_Exp>;
  contentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityFileStorage?: InputMaybe<EntityFileStorage_Bool_Exp>;
  entityFileStorageId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.entity_file_content_type" */
export enum EntityFileContentType_Constraint {
  /** unique or primary key constraint on columns "entity_file_storage_id", "content_type_id" */
  EntityFileContentTypeEntityFileStorageIdContentTypeId = 'entity_file_content_type_entity_file_storage_id_content_type_id',
  /** unique or primary key constraint on columns "id" */
  EntityFileContentTypePkey = 'entity_file_content_type_pkey'
}

/** input type for inserting data into table "shared.entity_file_content_type" */
export type EntityFileContentType_Insert_Input = {
  contentType?: InputMaybe<ContentType_Obj_Rel_Insert_Input>;
  contentTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityFileStorage?: InputMaybe<EntityFileStorage_Obj_Rel_Insert_Input>;
  entityFileStorageId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EntityFileContentType_Max_Fields = {
  __typename?: 'entityFileContentType_max_fields';
  contentTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  entityFileStorageId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.entity_file_content_type" */
export type EntityFileContentType_Max_Order_By = {
  contentTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityFileStorageId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityFileContentType_Min_Fields = {
  __typename?: 'entityFileContentType_min_fields';
  contentTypeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  entityFileStorageId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.entity_file_content_type" */
export type EntityFileContentType_Min_Order_By = {
  contentTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityFileStorageId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.entity_file_content_type" */
export type EntityFileContentType_Mutation_Response = {
  __typename?: 'entityFileContentType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityFileContentType>;
};

/** on_conflict condition type for table "shared.entity_file_content_type" */
export type EntityFileContentType_On_Conflict = {
  constraint: EntityFileContentType_Constraint;
  update_columns?: Array<EntityFileContentType_Update_Column>;
  where?: InputMaybe<EntityFileContentType_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.entity_file_content_type". */
export type EntityFileContentType_Order_By = {
  contentType?: InputMaybe<ContentType_Order_By>;
  contentTypeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityFileStorage?: InputMaybe<EntityFileStorage_Order_By>;
  entityFileStorageId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.entity_file_content_type */
export type EntityFileContentType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.entity_file_content_type" */
export enum EntityFileContentType_Select_Column {
  /** column name */
  ContentTypeId = 'contentTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityFileStorageId = 'entityFileStorageId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.entity_file_content_type" */
export type EntityFileContentType_Set_Input = {
  contentTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityFileStorageId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "entityFileContentType" */
export type EntityFileContentType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityFileContentType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityFileContentType_Stream_Cursor_Value_Input = {
  contentTypeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityFileStorageId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.entity_file_content_type" */
export enum EntityFileContentType_Update_Column {
  /** column name */
  ContentTypeId = 'contentTypeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityFileStorageId = 'entityFileStorageId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityFileContentType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityFileContentType_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityFileContentType_Bool_Exp;
};

/** This is the join table between the `file_storage` and the entity associated to the file. For example a cancellation document would exist in `file_storage` and have a record with the `parent_id` of the cancellation record. */
export type EntityFileStorage = {
  __typename?: 'entityFileStorage';
  /** This is similar to `parent_id` but used with non-uuid values, something alphanumeric. For example an old contract number. */
  altParentId?: Maybe<Scalars['String']>;
  /** An object relationship */
  contractFormVersion?: Maybe<ContractFormVersion>;
  createdAt: Scalars['timestamptz'];
  effectiveDate: Scalars['date'];
  /** An array relationship */
  entityFileContentTypes: Array<EntityFileContentType>;
  /** An aggregate relationship */
  entityFileContentTypes_aggregate: EntityFileContentType_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  fileStorage: FileStorage;
  /** The file that this entity is associated with. */
  fileStorageId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** Indicates whether the file has been soft deleted. When true, the file should not be visible in normal operations but is retained for audit purposes. */
  isDeleted: Scalars['Boolean'];
  /** An object relationship */
  legacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  onPremClaimMaster?: Maybe<ClaimsMaster>;
  /** The id of the entity to be associated to. */
  parentId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  updatedAt: Scalars['timestamptz'];
};


/** This is the join table between the `file_storage` and the entity associated to the file. For example a cancellation document would exist in `file_storage` and have a record with the `parent_id` of the cancellation record. */
export type EntityFileStorageEntityFileContentTypesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileContentType_Order_By>>;
  where?: InputMaybe<EntityFileContentType_Bool_Exp>;
};


/** This is the join table between the `file_storage` and the entity associated to the file. For example a cancellation document would exist in `file_storage` and have a record with the `parent_id` of the cancellation record. */
export type EntityFileStorageEntityFileContentTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileContentType_Order_By>>;
  where?: InputMaybe<EntityFileContentType_Bool_Exp>;
};


/** This is the join table between the `file_storage` and the entity associated to the file. For example a cancellation document would exist in `file_storage` and have a record with the `parent_id` of the cancellation record. */
export type EntityFileStorageLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** This is the join table between the `file_storage` and the entity associated to the file. For example a cancellation document would exist in `file_storage` and have a record with the `parent_id` of the cancellation record. */
export type EntityFileStorageLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "shared.entity_file_storage" */
export type EntityFileStorage_Aggregate = {
  __typename?: 'entityFileStorage_aggregate';
  aggregate?: Maybe<EntityFileStorage_Aggregate_Fields>;
  nodes: Array<EntityFileStorage>;
};

export type EntityFileStorage_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<EntityFileStorage_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<EntityFileStorage_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<EntityFileStorage_Aggregate_Bool_Exp_Count>;
};

export type EntityFileStorage_Aggregate_Bool_Exp_Bool_And = {
  arguments: EntityFileStorage_Select_Column_EntityFileStorage_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityFileStorage_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type EntityFileStorage_Aggregate_Bool_Exp_Bool_Or = {
  arguments: EntityFileStorage_Select_Column_EntityFileStorage_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityFileStorage_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type EntityFileStorage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityFileStorage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.entity_file_storage" */
export type EntityFileStorage_Aggregate_Fields = {
  __typename?: 'entityFileStorage_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityFileStorage_Max_Fields>;
  min?: Maybe<EntityFileStorage_Min_Fields>;
};


/** aggregate fields of "shared.entity_file_storage" */
export type EntityFileStorage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.entity_file_storage" */
export type EntityFileStorage_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityFileStorage_Max_Order_By>;
  min?: InputMaybe<EntityFileStorage_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.entity_file_storage" */
export type EntityFileStorage_Arr_Rel_Insert_Input = {
  data: Array<EntityFileStorage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityFileStorage_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.entity_file_storage". All fields are combined with a logical 'AND'. */
export type EntityFileStorage_Bool_Exp = {
  _and?: InputMaybe<Array<EntityFileStorage_Bool_Exp>>;
  _not?: InputMaybe<EntityFileStorage_Bool_Exp>;
  _or?: InputMaybe<Array<EntityFileStorage_Bool_Exp>>;
  altParentId?: InputMaybe<String_Comparison_Exp>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityFileContentTypes?: InputMaybe<EntityFileContentType_Bool_Exp>;
  entityFileContentTypes_aggregate?: InputMaybe<EntityFileContentType_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  fileStorage?: InputMaybe<FileStorage_Bool_Exp>;
  fileStorageId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDeleted?: InputMaybe<Boolean_Comparison_Exp>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.entity_file_storage" */
export enum EntityFileStorage_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityFileStoragePkey = 'entity_file_storage_pkey'
}

/** input type for inserting data into table "shared.entity_file_storage" */
export type EntityFileStorage_Insert_Input = {
  /** This is similar to `parent_id` but used with non-uuid values, something alphanumeric. For example an old contract number. */
  altParentId?: InputMaybe<Scalars['String']>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityFileContentTypes?: InputMaybe<EntityFileContentType_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  fileStorage?: InputMaybe<FileStorage_Obj_Rel_Insert_Input>;
  /** The file that this entity is associated with. */
  fileStorageId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Indicates whether the file has been soft deleted. When true, the file should not be visible in normal operations but is retained for audit purposes. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Obj_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  /** The id of the entity to be associated to. */
  parentId?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EntityFileStorage_Max_Fields = {
  __typename?: 'entityFileStorage_max_fields';
  /** This is similar to `parent_id` but used with non-uuid values, something alphanumeric. For example an old contract number. */
  altParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  /** The file that this entity is associated with. */
  fileStorageId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The id of the entity to be associated to. */
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.entity_file_storage" */
export type EntityFileStorage_Max_Order_By = {
  /** This is similar to `parent_id` but used with non-uuid values, something alphanumeric. For example an old contract number. */
  altParentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  /** The file that this entity is associated with. */
  fileStorageId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The id of the entity to be associated to. */
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityFileStorage_Min_Fields = {
  __typename?: 'entityFileStorage_min_fields';
  /** This is similar to `parent_id` but used with non-uuid values, something alphanumeric. For example an old contract number. */
  altParentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  /** The file that this entity is associated with. */
  fileStorageId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The id of the entity to be associated to. */
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.entity_file_storage" */
export type EntityFileStorage_Min_Order_By = {
  /** This is similar to `parent_id` but used with non-uuid values, something alphanumeric. For example an old contract number. */
  altParentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  /** The file that this entity is associated with. */
  fileStorageId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The id of the entity to be associated to. */
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.entity_file_storage" */
export type EntityFileStorage_Mutation_Response = {
  __typename?: 'entityFileStorage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityFileStorage>;
};

/** input type for inserting object relation for remote table "shared.entity_file_storage" */
export type EntityFileStorage_Obj_Rel_Insert_Input = {
  data: EntityFileStorage_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityFileStorage_On_Conflict>;
};

/** on_conflict condition type for table "shared.entity_file_storage" */
export type EntityFileStorage_On_Conflict = {
  constraint: EntityFileStorage_Constraint;
  update_columns?: Array<EntityFileStorage_Update_Column>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.entity_file_storage". */
export type EntityFileStorage_Order_By = {
  altParentId?: InputMaybe<Order_By>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityFileContentTypes_aggregate?: InputMaybe<EntityFileContentType_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  fileStorage?: InputMaybe<FileStorage_Order_By>;
  fileStorageId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDeleted?: InputMaybe<Order_By>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  parentId?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.entity_file_storage */
export type EntityFileStorage_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.entity_file_storage" */
export enum EntityFileStorage_Select_Column {
  /** column name */
  AltParentId = 'altParentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  FileStorageId = 'fileStorageId',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "entityFileStorage_aggregate_bool_exp_bool_and_arguments_columns" columns of table "shared.entity_file_storage" */
export enum EntityFileStorage_Select_Column_EntityFileStorage_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'isDeleted'
}

/** select "entityFileStorage_aggregate_bool_exp_bool_or_arguments_columns" columns of table "shared.entity_file_storage" */
export enum EntityFileStorage_Select_Column_EntityFileStorage_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'isDeleted'
}

/** input type for updating data in table "shared.entity_file_storage" */
export type EntityFileStorage_Set_Input = {
  /** This is similar to `parent_id` but used with non-uuid values, something alphanumeric. For example an old contract number. */
  altParentId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  /** The file that this entity is associated with. */
  fileStorageId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Indicates whether the file has been soft deleted. When true, the file should not be visible in normal operations but is retained for audit purposes. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** The id of the entity to be associated to. */
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "entityFileStorage" */
export type EntityFileStorage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityFileStorage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityFileStorage_Stream_Cursor_Value_Input = {
  /** This is similar to `parent_id` but used with non-uuid values, something alphanumeric. For example an old contract number. */
  altParentId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  /** The file that this entity is associated with. */
  fileStorageId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Indicates whether the file has been soft deleted. When true, the file should not be visible in normal operations but is retained for audit purposes. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** The id of the entity to be associated to. */
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.entity_file_storage" */
export enum EntityFileStorage_Update_Column {
  /** column name */
  AltParentId = 'altParentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  FileStorageId = 'fileStorageId',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityFileStorage_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityFileStorage_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityFileStorage_Bool_Exp;
};

/** columns and relationships of "shared.entity_note" */
export type EntityNote = {
  __typename?: 'entityNote';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  contractForm?: Maybe<ContractForm>;
  /** An object relationship */
  contractFormFilingStatus?: Maybe<ContractFormFilingStatus>;
  /** An object relationship */
  contractFormVersion?: Maybe<ContractFormVersion>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  legacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** This contains migrated notes from the AS400. TODO: migrate these notes that contain a {"migration": true} */
  note: Scalars['jsonb'];
  parentId: Scalars['uuid'];
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "shared.entity_note" */
export type EntityNoteLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "shared.entity_note" */
export type EntityNoteLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "shared.entity_note" */
export type EntityNoteNoteArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Which Capabilities govern the notes on a given parent, and what each may do to them. shared.entity_note.parent_id is an untyped uuid with no foreign key, so a parent's kind is found by resolving the id against each parent table in turn; an id matching none yields no rows, which closes its notes rather than opening them. The verbs come from auth.capability_config, so a Capability naming no row for shared.entity_note grants nothing. Claim notes are split by claim type, reached through the contract's product category — the join claims.is_gap_claim_payment uses — and matched by type id so that renaming a type cannot silently detach a Capability from the claims it governs. Contract notes are written under OperationsContractNotesWrite rather than OperationsContractsWrite, so someone may keep notes on a contract they cannot edit. operations.legacy_policy_contract is deprecated and not resolved, so notes on a legacy contract, or on a claim against one, are closed. Payments answer to Accounting's payment Capabilities, where their pages live, and remittances to Operations' remittance Capabilities, not to the claim they may belong to: a mechanical claim's payment hangs off claim_service_center, which no claim-type branch reaches. Cycles answer to Accounting's Cycles Capabilities. Invoice notes answer to the mechanical Capabilities without being split by type, because claims.invoice carries a claim number rather than a key and so cannot be resolved to one, and the screen showing them is reached through ClaimsMechanicalRead. Payee notes answer to AccountingPayeesRead and AccountingPayeesWrite. */
export type EntityNoteCapabilityView = {
  __typename?: 'entityNoteCapabilityView';
  canDelete?: Maybe<Scalars['Boolean']>;
  canInsert?: Maybe<Scalars['Boolean']>;
  canSelect?: Maybe<Scalars['Boolean']>;
  canUpdate?: Maybe<Scalars['Boolean']>;
  /** The Capability governing notes on this parent. Holding it, within its effective window, permits the verbs flagged on this row. */
  capabilityId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  identityCapabilityViews: Array<IdentityCapabilityView>;
  /** An aggregate relationship */
  identityCapabilityViews_aggregate: IdentityCapabilityView_Aggregate;
  /** The shared.entity_note.parent_id this row governs. Compare a note's parent_id against it rather than joining, so the correlated lookup stays an index probe. */
  parentId?: Maybe<Scalars['uuid']>;
};


/** Which Capabilities govern the notes on a given parent, and what each may do to them. shared.entity_note.parent_id is an untyped uuid with no foreign key, so a parent's kind is found by resolving the id against each parent table in turn; an id matching none yields no rows, which closes its notes rather than opening them. The verbs come from auth.capability_config, so a Capability naming no row for shared.entity_note grants nothing. Claim notes are split by claim type, reached through the contract's product category — the join claims.is_gap_claim_payment uses — and matched by type id so that renaming a type cannot silently detach a Capability from the claims it governs. Contract notes are written under OperationsContractNotesWrite rather than OperationsContractsWrite, so someone may keep notes on a contract they cannot edit. operations.legacy_policy_contract is deprecated and not resolved, so notes on a legacy contract, or on a claim against one, are closed. Payments answer to Accounting's payment Capabilities, where their pages live, and remittances to Operations' remittance Capabilities, not to the claim they may belong to: a mechanical claim's payment hangs off claim_service_center, which no claim-type branch reaches. Cycles answer to Accounting's Cycles Capabilities. Invoice notes answer to the mechanical Capabilities without being split by type, because claims.invoice carries a claim number rather than a key and so cannot be resolved to one, and the screen showing them is reached through ClaimsMechanicalRead. Payee notes answer to AccountingPayeesRead and AccountingPayeesWrite. */
export type EntityNoteCapabilityViewIdentityCapabilityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapabilityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapabilityView_Order_By>>;
  where?: InputMaybe<IdentityCapabilityView_Bool_Exp>;
};


/** Which Capabilities govern the notes on a given parent, and what each may do to them. shared.entity_note.parent_id is an untyped uuid with no foreign key, so a parent's kind is found by resolving the id against each parent table in turn; an id matching none yields no rows, which closes its notes rather than opening them. The verbs come from auth.capability_config, so a Capability naming no row for shared.entity_note grants nothing. Claim notes are split by claim type, reached through the contract's product category — the join claims.is_gap_claim_payment uses — and matched by type id so that renaming a type cannot silently detach a Capability from the claims it governs. Contract notes are written under OperationsContractNotesWrite rather than OperationsContractsWrite, so someone may keep notes on a contract they cannot edit. operations.legacy_policy_contract is deprecated and not resolved, so notes on a legacy contract, or on a claim against one, are closed. Payments answer to Accounting's payment Capabilities, where their pages live, and remittances to Operations' remittance Capabilities, not to the claim they may belong to: a mechanical claim's payment hangs off claim_service_center, which no claim-type branch reaches. Cycles answer to Accounting's Cycles Capabilities. Invoice notes answer to the mechanical Capabilities without being split by type, because claims.invoice carries a claim number rather than a key and so cannot be resolved to one, and the screen showing them is reached through ClaimsMechanicalRead. Payee notes answer to AccountingPayeesRead and AccountingPayeesWrite. */
export type EntityNoteCapabilityViewIdentityCapabilityViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapabilityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapabilityView_Order_By>>;
  where?: InputMaybe<IdentityCapabilityView_Bool_Exp>;
};

/** aggregated selection of "auth.entity_note_capability_view" */
export type EntityNoteCapabilityView_Aggregate = {
  __typename?: 'entityNoteCapabilityView_aggregate';
  aggregate?: Maybe<EntityNoteCapabilityView_Aggregate_Fields>;
  nodes: Array<EntityNoteCapabilityView>;
};

/** aggregate fields of "auth.entity_note_capability_view" */
export type EntityNoteCapabilityView_Aggregate_Fields = {
  __typename?: 'entityNoteCapabilityView_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityNoteCapabilityView_Max_Fields>;
  min?: Maybe<EntityNoteCapabilityView_Min_Fields>;
};


/** aggregate fields of "auth.entity_note_capability_view" */
export type EntityNoteCapabilityView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityNoteCapabilityView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "auth.entity_note_capability_view". All fields are combined with a logical 'AND'. */
export type EntityNoteCapabilityView_Bool_Exp = {
  _and?: InputMaybe<Array<EntityNoteCapabilityView_Bool_Exp>>;
  _not?: InputMaybe<EntityNoteCapabilityView_Bool_Exp>;
  _or?: InputMaybe<Array<EntityNoteCapabilityView_Bool_Exp>>;
  canDelete?: InputMaybe<Boolean_Comparison_Exp>;
  canInsert?: InputMaybe<Boolean_Comparison_Exp>;
  canSelect?: InputMaybe<Boolean_Comparison_Exp>;
  canUpdate?: InputMaybe<Boolean_Comparison_Exp>;
  capabilityId?: InputMaybe<Uuid_Comparison_Exp>;
  identityCapabilityViews?: InputMaybe<IdentityCapabilityView_Bool_Exp>;
  identityCapabilityViews_aggregate?: InputMaybe<IdentityCapabilityView_Aggregate_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type EntityNoteCapabilityView_Max_Fields = {
  __typename?: 'entityNoteCapabilityView_max_fields';
  /** The Capability governing notes on this parent. Holding it, within its effective window, permits the verbs flagged on this row. */
  capabilityId?: Maybe<Scalars['uuid']>;
  /** The shared.entity_note.parent_id this row governs. Compare a note's parent_id against it rather than joining, so the correlated lookup stays an index probe. */
  parentId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type EntityNoteCapabilityView_Min_Fields = {
  __typename?: 'entityNoteCapabilityView_min_fields';
  /** The Capability governing notes on this parent. Holding it, within its effective window, permits the verbs flagged on this row. */
  capabilityId?: Maybe<Scalars['uuid']>;
  /** The shared.entity_note.parent_id this row governs. Compare a note's parent_id against it rather than joining, so the correlated lookup stays an index probe. */
  parentId?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "auth.entity_note_capability_view". */
export type EntityNoteCapabilityView_Order_By = {
  canDelete?: InputMaybe<Order_By>;
  canInsert?: InputMaybe<Order_By>;
  canSelect?: InputMaybe<Order_By>;
  canUpdate?: InputMaybe<Order_By>;
  capabilityId?: InputMaybe<Order_By>;
  identityCapabilityViews_aggregate?: InputMaybe<IdentityCapabilityView_Aggregate_Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** select columns of table "auth.entity_note_capability_view" */
export enum EntityNoteCapabilityView_Select_Column {
  /** column name */
  CanDelete = 'canDelete',
  /** column name */
  CanInsert = 'canInsert',
  /** column name */
  CanSelect = 'canSelect',
  /** column name */
  CanUpdate = 'canUpdate',
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  ParentId = 'parentId'
}

/** Streaming cursor of the table "entityNoteCapabilityView" */
export type EntityNoteCapabilityView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityNoteCapabilityView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityNoteCapabilityView_Stream_Cursor_Value_Input = {
  canDelete?: InputMaybe<Scalars['Boolean']>;
  canInsert?: InputMaybe<Scalars['Boolean']>;
  canSelect?: InputMaybe<Scalars['Boolean']>;
  canUpdate?: InputMaybe<Scalars['Boolean']>;
  /** The Capability governing notes on this parent. Holding it, within its effective window, permits the verbs flagged on this row. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  /** The shared.entity_note.parent_id this row governs. Compare a note's parent_id against it rather than joining, so the correlated lookup stays an index probe. */
  parentId?: InputMaybe<Scalars['uuid']>;
};

/** aggregated selection of "shared.entity_note" */
export type EntityNote_Aggregate = {
  __typename?: 'entityNote_aggregate';
  aggregate?: Maybe<EntityNote_Aggregate_Fields>;
  nodes: Array<EntityNote>;
};

export type EntityNote_Aggregate_Bool_Exp = {
  count?: InputMaybe<EntityNote_Aggregate_Bool_Exp_Count>;
};

export type EntityNote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityNote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityNote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.entity_note" */
export type EntityNote_Aggregate_Fields = {
  __typename?: 'entityNote_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityNote_Max_Fields>;
  min?: Maybe<EntityNote_Min_Fields>;
};


/** aggregate fields of "shared.entity_note" */
export type EntityNote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityNote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.entity_note" */
export type EntityNote_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityNote_Max_Order_By>;
  min?: InputMaybe<EntityNote_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EntityNote_Append_Input = {
  /** This contains migrated notes from the AS400. TODO: migrate these notes that contain a {"migration": true} */
  note?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "shared.entity_note" */
export type EntityNote_Arr_Rel_Insert_Input = {
  data: Array<EntityNote_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityNote_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.entity_note". All fields are combined with a logical 'AND'. */
export type EntityNote_Bool_Exp = {
  _and?: InputMaybe<Array<EntityNote_Bool_Exp>>;
  _not?: InputMaybe<EntityNote_Bool_Exp>;
  _or?: InputMaybe<Array<EntityNote_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  contractForm?: InputMaybe<ContractForm_Bool_Exp>;
  contractFormFilingStatus?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  note?: InputMaybe<Jsonb_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.entity_note" */
export enum EntityNote_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityNotePkey = 'entity_note_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EntityNote_Delete_At_Path_Input = {
  /** This contains migrated notes from the AS400. TODO: migrate these notes that contain a {"migration": true} */
  note?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EntityNote_Delete_Elem_Input = {
  /** This contains migrated notes from the AS400. TODO: migrate these notes that contain a {"migration": true} */
  note?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EntityNote_Delete_Key_Input = {
  /** This contains migrated notes from the AS400. TODO: migrate these notes that contain a {"migration": true} */
  note?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "shared.entity_note" */
export type EntityNote_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  contractForm?: InputMaybe<ContractForm_Obj_Rel_Insert_Input>;
  contractFormFilingStatus?: InputMaybe<ContractFormFilingStatus_Obj_Rel_Insert_Input>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Obj_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  /** This contains migrated notes from the AS400. TODO: migrate these notes that contain a {"migration": true} */
  note?: InputMaybe<Scalars['jsonb']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EntityNote_Max_Fields = {
  __typename?: 'entityNote_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.entity_note" */
export type EntityNote_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityNote_Min_Fields = {
  __typename?: 'entityNote_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.entity_note" */
export type EntityNote_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.entity_note" */
export type EntityNote_Mutation_Response = {
  __typename?: 'entityNote_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityNote>;
};

/** on_conflict condition type for table "shared.entity_note" */
export type EntityNote_On_Conflict = {
  constraint: EntityNote_Constraint;
  update_columns?: Array<EntityNote_Update_Column>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.entity_note". */
export type EntityNote_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  contractForm?: InputMaybe<ContractForm_Order_By>;
  contractFormFilingStatus?: InputMaybe<ContractFormFilingStatus_Order_By>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  note?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.entity_note */
export type EntityNote_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EntityNote_Prepend_Input = {
  /** This contains migrated notes from the AS400. TODO: migrate these notes that contain a {"migration": true} */
  note?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shared.entity_note" */
export enum EntityNote_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.entity_note" */
export type EntityNote_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** This contains migrated notes from the AS400. TODO: migrate these notes that contain a {"migration": true} */
  note?: InputMaybe<Scalars['jsonb']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "entityNote" */
export type EntityNote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityNote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityNote_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** This contains migrated notes from the AS400. TODO: migrate these notes that contain a {"migration": true} */
  note?: InputMaybe<Scalars['jsonb']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.entity_note" */
export enum EntityNote_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityNote_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EntityNote_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EntityNote_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EntityNote_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EntityNote_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EntityNote_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityNote_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityNote_Bool_Exp;
};

/** Offering for entities. Product, Accounts, etc. */
export type EntityOffering = {
  __typename?: 'entityOffering';
  /** An object relationship */
  accountProduct?: Maybe<AccountProduct>;
  /** An array relationship */
  childEntityOfferings: Array<EntityOffering>;
  /** An aggregate relationship */
  childEntityOfferings_aggregate: EntityOffering_Aggregate;
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityEligibilityRules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entityEligibilityRules_aggregate: EntityEligibilityRule_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  parentEntityOffering?: Maybe<EntityOffering>;
  parentEntityOfferingId?: Maybe<Scalars['uuid']>;
  parentId: Scalars['uuid'];
  /** An object relationship */
  product?: Maybe<Product>;
  /** An object relationship */
  productAttribute?: Maybe<ProductAttribute>;
  productAttributeId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** Offering for entities. Product, Accounts, etc. */
export type EntityOfferingChildEntityOfferingsArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


/** Offering for entities. Product, Accounts, etc. */
export type EntityOfferingChildEntityOfferings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


/** Offering for entities. Product, Accounts, etc. */
export type EntityOfferingEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** Offering for entities. Product, Accounts, etc. */
export type EntityOfferingEntityEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};

/** aggregated selection of "entity_offering" */
export type EntityOffering_Aggregate = {
  __typename?: 'entityOffering_aggregate';
  aggregate?: Maybe<EntityOffering_Aggregate_Fields>;
  nodes: Array<EntityOffering>;
};

export type EntityOffering_Aggregate_Bool_Exp = {
  count?: InputMaybe<EntityOffering_Aggregate_Bool_Exp_Count>;
};

export type EntityOffering_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityOffering_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityOffering_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entity_offering" */
export type EntityOffering_Aggregate_Fields = {
  __typename?: 'entityOffering_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityOffering_Max_Fields>;
  min?: Maybe<EntityOffering_Min_Fields>;
};


/** aggregate fields of "entity_offering" */
export type EntityOffering_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityOffering_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "entity_offering" */
export type EntityOffering_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityOffering_Max_Order_By>;
  min?: InputMaybe<EntityOffering_Min_Order_By>;
};

/** input type for inserting array relation for remote table "entity_offering" */
export type EntityOffering_Arr_Rel_Insert_Input = {
  data: Array<EntityOffering_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityOffering_On_Conflict>;
};

/** Boolean expression to filter rows from the table "entity_offering". All fields are combined with a logical 'AND'. */
export type EntityOffering_Bool_Exp = {
  _and?: InputMaybe<Array<EntityOffering_Bool_Exp>>;
  _not?: InputMaybe<EntityOffering_Bool_Exp>;
  _or?: InputMaybe<Array<EntityOffering_Bool_Exp>>;
  accountProduct?: InputMaybe<AccountProduct_Bool_Exp>;
  childEntityOfferings?: InputMaybe<EntityOffering_Bool_Exp>;
  childEntityOfferings_aggregate?: InputMaybe<EntityOffering_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parentEntityOffering?: InputMaybe<EntityOffering_Bool_Exp>;
  parentEntityOfferingId?: InputMaybe<Uuid_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productAttribute?: InputMaybe<ProductAttribute_Bool_Exp>;
  productAttributeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_offering" */
export enum EntityOffering_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityOfferingPkey = 'entity_offering_pkey'
}

/** input type for inserting data into table "entity_offering" */
export type EntityOffering_Insert_Input = {
  accountProduct?: InputMaybe<AccountProduct_Obj_Rel_Insert_Input>;
  childEntityOfferings?: InputMaybe<EntityOffering_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentEntityOffering?: InputMaybe<EntityOffering_Obj_Rel_Insert_Input>;
  parentEntityOfferingId?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productAttribute?: InputMaybe<ProductAttribute_Obj_Rel_Insert_Input>;
  productAttributeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EntityOffering_Max_Fields = {
  __typename?: 'entityOffering_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  parentEntityOfferingId?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  productAttributeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "entity_offering" */
export type EntityOffering_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentEntityOfferingId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  productAttributeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityOffering_Min_Fields = {
  __typename?: 'entityOffering_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  parentEntityOfferingId?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  productAttributeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "entity_offering" */
export type EntityOffering_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentEntityOfferingId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  productAttributeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity_offering" */
export type EntityOffering_Mutation_Response = {
  __typename?: 'entityOffering_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityOffering>;
};

/** input type for inserting object relation for remote table "entity_offering" */
export type EntityOffering_Obj_Rel_Insert_Input = {
  data: EntityOffering_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityOffering_On_Conflict>;
};

/** on_conflict condition type for table "entity_offering" */
export type EntityOffering_On_Conflict = {
  constraint: EntityOffering_Constraint;
  update_columns?: Array<EntityOffering_Update_Column>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_offering". */
export type EntityOffering_Order_By = {
  accountProduct?: InputMaybe<AccountProduct_Order_By>;
  childEntityOfferings_aggregate?: InputMaybe<EntityOffering_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentEntityOffering?: InputMaybe<EntityOffering_Order_By>;
  parentEntityOfferingId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productAttribute?: InputMaybe<ProductAttribute_Order_By>;
  productAttributeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_offering */
export type EntityOffering_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "entity_offering" */
export enum EntityOffering_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ParentEntityOfferingId = 'parentEntityOfferingId',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  ProductAttributeId = 'productAttributeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "entity_offering" */
export type EntityOffering_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentEntityOfferingId?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  productAttributeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "entityOffering" */
export type EntityOffering_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityOffering_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityOffering_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentEntityOfferingId?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  productAttributeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "entity_offering" */
export enum EntityOffering_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ParentEntityOfferingId = 'parentEntityOfferingId',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  ProductAttributeId = 'productAttributeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityOffering_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityOffering_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityOffering_Bool_Exp;
};

/** columns and relationships of "shared.entity_remittance_detail" */
export type EntityRemittanceDetail = {
  __typename?: 'entityRemittanceDetail';
  amount: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  parentId: Scalars['uuid'];
  /** An object relationship */
  paymentStatusType: PaymentStatusType;
  paymentStatusTypeId: Scalars['uuid'];
  /** An object relationship */
  paymentType?: Maybe<PaymentType>;
  paymentTypeId: Scalars['uuid'];
  posTransactionNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  remittance: Remittance;
  remittanceId: Scalars['uuid'];
  /** An object relationship */
  remittancePolicyContract?: Maybe<RemittancePolicyContract>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Aggregate = {
  __typename?: 'entityRemittanceDetail_aggregate';
  aggregate?: Maybe<EntityRemittanceDetail_Aggregate_Fields>;
  nodes: Array<EntityRemittanceDetail>;
};

export type EntityRemittanceDetail_Aggregate_Bool_Exp = {
  count?: InputMaybe<EntityRemittanceDetail_Aggregate_Bool_Exp_Count>;
};

export type EntityRemittanceDetail_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Aggregate_Fields = {
  __typename?: 'entityRemittanceDetail_aggregate_fields';
  avg?: Maybe<EntityRemittanceDetail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<EntityRemittanceDetail_Max_Fields>;
  min?: Maybe<EntityRemittanceDetail_Min_Fields>;
  stddev?: Maybe<EntityRemittanceDetail_Stddev_Fields>;
  stddev_pop?: Maybe<EntityRemittanceDetail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EntityRemittanceDetail_Stddev_Samp_Fields>;
  sum?: Maybe<EntityRemittanceDetail_Sum_Fields>;
  var_pop?: Maybe<EntityRemittanceDetail_Var_Pop_Fields>;
  var_samp?: Maybe<EntityRemittanceDetail_Var_Samp_Fields>;
  variance?: Maybe<EntityRemittanceDetail_Variance_Fields>;
};


/** aggregate fields of "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Aggregate_Order_By = {
  avg?: InputMaybe<EntityRemittanceDetail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityRemittanceDetail_Max_Order_By>;
  min?: InputMaybe<EntityRemittanceDetail_Min_Order_By>;
  stddev?: InputMaybe<EntityRemittanceDetail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EntityRemittanceDetail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EntityRemittanceDetail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EntityRemittanceDetail_Sum_Order_By>;
  var_pop?: InputMaybe<EntityRemittanceDetail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EntityRemittanceDetail_Var_Samp_Order_By>;
  variance?: InputMaybe<EntityRemittanceDetail_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Arr_Rel_Insert_Input = {
  data: Array<EntityRemittanceDetail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityRemittanceDetail_On_Conflict>;
};

/** aggregate avg on columns */
export type EntityRemittanceDetail_Avg_Fields = {
  __typename?: 'entityRemittanceDetail_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shared.entity_remittance_detail". All fields are combined with a logical 'AND'. */
export type EntityRemittanceDetail_Bool_Exp = {
  _and?: InputMaybe<Array<EntityRemittanceDetail_Bool_Exp>>;
  _not?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
  _or?: InputMaybe<Array<EntityRemittanceDetail_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  paymentStatusType?: InputMaybe<PaymentStatusType_Bool_Exp>;
  paymentStatusTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  paymentType?: InputMaybe<PaymentType_Bool_Exp>;
  paymentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  posTransactionNumber?: InputMaybe<String_Comparison_Exp>;
  remittance?: InputMaybe<Remittance_Bool_Exp>;
  remittanceId?: InputMaybe<Uuid_Comparison_Exp>;
  remittancePolicyContract?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.entity_remittance_detail" */
export enum EntityRemittanceDetail_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityPaymentPkey = 'entity_payment_pkey'
}

/** input type for incrementing numeric columns in table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  paymentStatusType?: InputMaybe<PaymentStatusType_Obj_Rel_Insert_Input>;
  paymentStatusTypeId?: InputMaybe<Scalars['uuid']>;
  paymentType?: InputMaybe<PaymentType_Obj_Rel_Insert_Input>;
  paymentTypeId?: InputMaybe<Scalars['uuid']>;
  posTransactionNumber?: InputMaybe<Scalars['String']>;
  remittance?: InputMaybe<Remittance_Obj_Rel_Insert_Input>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  remittancePolicyContract?: InputMaybe<RemittancePolicyContract_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EntityRemittanceDetail_Max_Fields = {
  __typename?: 'entityRemittanceDetail_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  paymentStatusTypeId?: Maybe<Scalars['uuid']>;
  paymentTypeId?: Maybe<Scalars['uuid']>;
  posTransactionNumber?: Maybe<Scalars['String']>;
  remittanceId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  paymentStatusTypeId?: InputMaybe<Order_By>;
  paymentTypeId?: InputMaybe<Order_By>;
  posTransactionNumber?: InputMaybe<Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityRemittanceDetail_Min_Fields = {
  __typename?: 'entityRemittanceDetail_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  paymentStatusTypeId?: Maybe<Scalars['uuid']>;
  paymentTypeId?: Maybe<Scalars['uuid']>;
  posTransactionNumber?: Maybe<Scalars['String']>;
  remittanceId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  paymentStatusTypeId?: InputMaybe<Order_By>;
  paymentTypeId?: InputMaybe<Order_By>;
  posTransactionNumber?: InputMaybe<Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Mutation_Response = {
  __typename?: 'entityRemittanceDetail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityRemittanceDetail>;
};

/** on_conflict condition type for table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_On_Conflict = {
  constraint: EntityRemittanceDetail_Constraint;
  update_columns?: Array<EntityRemittanceDetail_Update_Column>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.entity_remittance_detail". */
export type EntityRemittanceDetail_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  paymentStatusType?: InputMaybe<PaymentStatusType_Order_By>;
  paymentStatusTypeId?: InputMaybe<Order_By>;
  paymentType?: InputMaybe<PaymentType_Order_By>;
  paymentTypeId?: InputMaybe<Order_By>;
  posTransactionNumber?: InputMaybe<Order_By>;
  remittance?: InputMaybe<Remittance_Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  remittancePolicyContract?: InputMaybe<RemittancePolicyContract_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.entity_remittance_detail */
export type EntityRemittanceDetail_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.entity_remittance_detail" */
export enum EntityRemittanceDetail_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PaymentStatusTypeId = 'paymentStatusTypeId',
  /** column name */
  PaymentTypeId = 'paymentTypeId',
  /** column name */
  PosTransactionNumber = 'posTransactionNumber',
  /** column name */
  RemittanceId = 'remittanceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  paymentStatusTypeId?: InputMaybe<Scalars['uuid']>;
  paymentTypeId?: InputMaybe<Scalars['uuid']>;
  posTransactionNumber?: InputMaybe<Scalars['String']>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EntityRemittanceDetail_Stddev_Fields = {
  __typename?: 'entityRemittanceDetail_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EntityRemittanceDetail_Stddev_Pop_Fields = {
  __typename?: 'entityRemittanceDetail_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EntityRemittanceDetail_Stddev_Samp_Fields = {
  __typename?: 'entityRemittanceDetail_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entityRemittanceDetail" */
export type EntityRemittanceDetail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityRemittanceDetail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityRemittanceDetail_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  paymentStatusTypeId?: InputMaybe<Scalars['uuid']>;
  paymentTypeId?: InputMaybe<Scalars['uuid']>;
  posTransactionNumber?: InputMaybe<Scalars['String']>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EntityRemittanceDetail_Sum_Fields = {
  __typename?: 'entityRemittanceDetail_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "shared.entity_remittance_detail" */
export enum EntityRemittanceDetail_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PaymentStatusTypeId = 'paymentStatusTypeId',
  /** column name */
  PaymentTypeId = 'paymentTypeId',
  /** column name */
  PosTransactionNumber = 'posTransactionNumber',
  /** column name */
  RemittanceId = 'remittanceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityRemittanceDetail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EntityRemittanceDetail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityRemittanceDetail_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityRemittanceDetail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EntityRemittanceDetail_Var_Pop_Fields = {
  __typename?: 'entityRemittanceDetail_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EntityRemittanceDetail_Var_Samp_Fields = {
  __typename?: 'entityRemittanceDetail_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EntityRemittanceDetail_Variance_Fields = {
  __typename?: 'entityRemittanceDetail_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shared.entity_remittance_detail" */
export type EntityRemittanceDetail_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Bridge table to connect entities and tags. We do not allow duplicates. */
export type EntityTag = {
  __typename?: 'entityTag';
  /** An object relationship */
  accountManagers?: Maybe<AccountManager>;
  /** An object relationship */
  accounts?: Maybe<Account>;
  /** An object relationship */
  carriers?: Maybe<Carrier>;
  /** An object relationship */
  categories?: Maybe<Category>;
  /** An object relationship */
  contacts?: Maybe<Contact>;
  /** An object relationship */
  costAdjustments?: Maybe<CostAdjustment>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  eligibilityRules?: Maybe<EligibilityRule>;
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  obligors?: Maybe<Obligor>;
  parentId: Scalars['uuid'];
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
  /** An object relationship */
  productAttributes?: Maybe<ProductAttribute>;
  /** An object relationship */
  productCosts?: Maybe<ProductCost>;
  /** An object relationship */
  products?: Maybe<Product>;
  /** An object relationship */
  tag: Tag;
  tagId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** Bridge table to connect entities and tags. We do not allow duplicates. */
export type EntityTagLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** Bridge table to connect entities and tags. We do not allow duplicates. */
export type EntityTagLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "shared.entity_tag" */
export type EntityTag_Aggregate = {
  __typename?: 'entityTag_aggregate';
  aggregate?: Maybe<EntityTag_Aggregate_Fields>;
  nodes: Array<EntityTag>;
};

export type EntityTag_Aggregate_Bool_Exp = {
  count?: InputMaybe<EntityTag_Aggregate_Bool_Exp_Count>;
};

export type EntityTag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EntityTag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EntityTag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.entity_tag" */
export type EntityTag_Aggregate_Fields = {
  __typename?: 'entityTag_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<EntityTag_Max_Fields>;
  min?: Maybe<EntityTag_Min_Fields>;
};


/** aggregate fields of "shared.entity_tag" */
export type EntityTag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityTag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.entity_tag" */
export type EntityTag_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EntityTag_Max_Order_By>;
  min?: InputMaybe<EntityTag_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.entity_tag" */
export type EntityTag_Arr_Rel_Insert_Input = {
  data: Array<EntityTag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityTag_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.entity_tag". All fields are combined with a logical 'AND'. */
export type EntityTag_Bool_Exp = {
  _and?: InputMaybe<Array<EntityTag_Bool_Exp>>;
  _not?: InputMaybe<EntityTag_Bool_Exp>;
  _or?: InputMaybe<Array<EntityTag_Bool_Exp>>;
  accountManagers?: InputMaybe<AccountManager_Bool_Exp>;
  accounts?: InputMaybe<Account_Bool_Exp>;
  carriers?: InputMaybe<Carrier_Bool_Exp>;
  categories?: InputMaybe<Category_Bool_Exp>;
  contacts?: InputMaybe<Contact_Bool_Exp>;
  costAdjustments?: InputMaybe<CostAdjustment_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  eligibilityRules?: InputMaybe<EligibilityRule_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  obligors?: InputMaybe<Obligor_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  productAttributes?: InputMaybe<ProductAttribute_Bool_Exp>;
  productCosts?: InputMaybe<ProductCost_Bool_Exp>;
  products?: InputMaybe<Product_Bool_Exp>;
  tag?: InputMaybe<Tag_Bool_Exp>;
  tagId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.entity_tag" */
export enum EntityTag_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityTagPkey = 'entity_tag_pkey',
  /** unique or primary key constraint on columns "parent_id", "tag_id" */
  EntityTagTagIdParentIdKey = 'entity_tag_tag_id_parent_id_key'
}

/** input type for inserting data into table "shared.entity_tag" */
export type EntityTag_Insert_Input = {
  accountManagers?: InputMaybe<AccountManager_Obj_Rel_Insert_Input>;
  accounts?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  carriers?: InputMaybe<Carrier_Obj_Rel_Insert_Input>;
  categories?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  contacts?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  costAdjustments?: InputMaybe<CostAdjustment_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eligibilityRules?: InputMaybe<EligibilityRule_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  obligors?: InputMaybe<Obligor_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  productAttributes?: InputMaybe<ProductAttribute_Obj_Rel_Insert_Input>;
  productCosts?: InputMaybe<ProductCost_Obj_Rel_Insert_Input>;
  products?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  tag?: InputMaybe<Tag_Obj_Rel_Insert_Input>;
  tagId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EntityTag_Max_Fields = {
  __typename?: 'entityTag_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  tagId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.entity_tag" */
export type EntityTag_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EntityTag_Min_Fields = {
  __typename?: 'entityTag_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  tagId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.entity_tag" */
export type EntityTag_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.entity_tag" */
export type EntityTag_Mutation_Response = {
  __typename?: 'entityTag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityTag>;
};

/** input type for inserting object relation for remote table "shared.entity_tag" */
export type EntityTag_Obj_Rel_Insert_Input = {
  data: EntityTag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityTag_On_Conflict>;
};

/** on_conflict condition type for table "shared.entity_tag" */
export type EntityTag_On_Conflict = {
  constraint: EntityTag_Constraint;
  update_columns?: Array<EntityTag_Update_Column>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.entity_tag". */
export type EntityTag_Order_By = {
  accountManagers?: InputMaybe<AccountManager_Order_By>;
  accounts?: InputMaybe<Account_Order_By>;
  carriers?: InputMaybe<Carrier_Order_By>;
  categories?: InputMaybe<Category_Order_By>;
  contacts?: InputMaybe<Contact_Order_By>;
  costAdjustments?: InputMaybe<CostAdjustment_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  eligibilityRules?: InputMaybe<EligibilityRule_Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  obligors?: InputMaybe<Obligor_Order_By>;
  parentId?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  productAttributes?: InputMaybe<ProductAttribute_Order_By>;
  productCosts?: InputMaybe<ProductCost_Order_By>;
  products?: InputMaybe<Product_Order_By>;
  tag?: InputMaybe<Tag_Order_By>;
  tagId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.entity_tag */
export type EntityTag_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.entity_tag" */
export enum EntityTag_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  TagId = 'tagId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.entity_tag" */
export type EntityTag_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  tagId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "entityTag" */
export type EntityTag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityTag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityTag_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  tagId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.entity_tag" */
export enum EntityTag_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  TagId = 'tagId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EntityTag_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityTag_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityTag_Bool_Exp;
};

/** columns and relationships of "shared.feature" */
export type Feature = {
  __typename?: 'feature';
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  entityFeatures: Array<EntityFeature>;
  /** An aggregate relationship */
  entityFeatures_aggregate: EntityFeature_Aggregate;
  /** 'entity_type' is a list of entities that can belong to an 'entity_feature' */
  entityTypes: Scalars['jsonb'];
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  isFullyActive: Scalars['Boolean'];
  /** A computed field, executes function "shared.last_updated_by_feature" */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "shared.feature" */
export type FeatureEntityFeaturesArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


/** columns and relationships of "shared.feature" */
export type FeatureEntityFeatures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


/** columns and relationships of "shared.feature" */
export type FeatureEntityTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "shared.feature" */
export type Feature_Aggregate = {
  __typename?: 'feature_aggregate';
  aggregate?: Maybe<Feature_Aggregate_Fields>;
  nodes: Array<Feature>;
};

/** aggregate fields of "shared.feature" */
export type Feature_Aggregate_Fields = {
  __typename?: 'feature_aggregate_fields';
  avg?: Maybe<Feature_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feature_Max_Fields>;
  min?: Maybe<Feature_Min_Fields>;
  stddev?: Maybe<Feature_Stddev_Fields>;
  stddev_pop?: Maybe<Feature_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feature_Stddev_Samp_Fields>;
  sum?: Maybe<Feature_Sum_Fields>;
  var_pop?: Maybe<Feature_Var_Pop_Fields>;
  var_samp?: Maybe<Feature_Var_Samp_Fields>;
  variance?: Maybe<Feature_Variance_Fields>;
};


/** aggregate fields of "shared.feature" */
export type Feature_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Feature_Append_Input = {
  /** 'entity_type' is a list of entities that can belong to an 'entity_feature' */
  entityTypes?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Feature_Avg_Fields = {
  __typename?: 'feature_avg_fields';
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "shared.feature". All fields are combined with a logical 'AND'. */
export type Feature_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Bool_Exp>>;
  _not?: InputMaybe<Feature_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityFeatureCount?: InputMaybe<Numeric_Comparison_Exp>;
  entityFeatures?: InputMaybe<EntityFeature_Bool_Exp>;
  entityFeatures_aggregate?: InputMaybe<EntityFeature_Aggregate_Bool_Exp>;
  entityTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isFullyActive?: InputMaybe<Boolean_Comparison_Exp>;
  lastUpdatedBy?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.feature" */
export enum Feature_Constraint {
  /** unique or primary key constraint on columns "id" */
  FeaturePkey = 'feature_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Feature_Delete_At_Path_Input = {
  /** 'entity_type' is a list of entities that can belong to an 'entity_feature' */
  entityTypes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Feature_Delete_Elem_Input = {
  /** 'entity_type' is a list of entities that can belong to an 'entity_feature' */
  entityTypes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Feature_Delete_Key_Input = {
  /** 'entity_type' is a list of entities that can belong to an 'entity_feature' */
  entityTypes?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "shared.feature" */
export type Feature_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityFeatures?: InputMaybe<EntityFeature_Arr_Rel_Insert_Input>;
  /** 'entity_type' is a list of entities that can belong to an 'entity_feature' */
  entityTypes?: InputMaybe<Scalars['jsonb']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isFullyActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Feature_Max_Fields = {
  __typename?: 'feature_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "shared.last_updated_by_feature" */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Feature_Min_Fields = {
  __typename?: 'feature_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "shared.last_updated_by_feature" */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shared.feature" */
export type Feature_Mutation_Response = {
  __typename?: 'feature_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature>;
};

/** input type for inserting object relation for remote table "shared.feature" */
export type Feature_Obj_Rel_Insert_Input = {
  data: Feature_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Feature_On_Conflict>;
};

/** on_conflict condition type for table "shared.feature" */
export type Feature_On_Conflict = {
  constraint: Feature_Constraint;
  update_columns?: Array<Feature_Update_Column>;
  where?: InputMaybe<Feature_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.feature". */
export type Feature_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityFeatureCount?: InputMaybe<Order_By>;
  entityFeatures_aggregate?: InputMaybe<EntityFeature_Aggregate_Order_By>;
  entityTypes?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isFullyActive?: InputMaybe<Order_By>;
  lastUpdatedBy?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.feature */
export type Feature_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Feature_Prepend_Input = {
  /** 'entity_type' is a list of entities that can belong to an 'entity_feature' */
  entityTypes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shared.feature" */
export enum Feature_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EntityTypes = 'entityTypes',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsFullyActive = 'isFullyActive',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.feature" */
export type Feature_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** 'entity_type' is a list of entities that can belong to an 'entity_feature' */
  entityTypes?: InputMaybe<Scalars['jsonb']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isFullyActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Feature_Stddev_Fields = {
  __typename?: 'feature_stddev_fields';
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_pop on columns */
export type Feature_Stddev_Pop_Fields = {
  __typename?: 'feature_stddev_pop_fields';
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_samp on columns */
export type Feature_Stddev_Samp_Fields = {
  __typename?: 'feature_stddev_samp_fields';
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "feature" */
export type Feature_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** 'entity_type' is a list of entities that can belong to an 'entity_feature' */
  entityTypes?: InputMaybe<Scalars['jsonb']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isFullyActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Feature_Sum_Fields = {
  __typename?: 'feature_sum_fields';
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "shared.feature" */
export enum Feature_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EntityTypes = 'entityTypes',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsFullyActive = 'isFullyActive',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Feature_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Feature_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Feature_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Feature_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Feature_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Feature_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feature_Var_Pop_Fields = {
  __typename?: 'feature_var_pop_fields';
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_samp on columns */
export type Feature_Var_Samp_Fields = {
  __typename?: 'feature_var_samp_fields';
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
};

/** aggregate variance on columns */
export type Feature_Variance_Fields = {
  __typename?: 'feature_variance_fields';
  /** A count of how many `entity_feature`s are associated to this feature, regardless of `is_active`. */
  entityFeatureCount?: Maybe<Scalars['numeric']>;
};

/** This table holds information regarding the physical files stored in azure storage. */
export type FileStorage = {
  __typename?: 'fileStorage';
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  entityFileStorages: Array<EntityFileStorage>;
  /** An aggregate relationship */
  entityFileStorages_aggregate: EntityFileStorage_Aggregate;
  /** An object relationship */
  fileStorageType: FileStorageType;
  /** This is the virtual folder path the file is in. This is what can be adjusted if a user wants to move a file to a different folder. This is also how multiple files with the same name can exist in the same "folder". */
  folderPath: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  metadata?: Maybe<Scalars['jsonb']>;
  /** The file name the user will use to reference this file. */
  name: Scalars['String'];
  /** The identifier that the storage mechanism uses. For Azure blob storage this corresponds to `Name`. */
  storageId?: Maybe<Scalars['uuid']>;
  /** The `uuid` of the storage mechanism. Currently we use Azure Blob or Table Storage. */
  storageTypeId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** This table holds information regarding the physical files stored in azure storage. */
export type FileStorageEntityFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** This table holds information regarding the physical files stored in azure storage. */
export type FileStorageEntityFileStorages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** This table holds information regarding the physical files stored in azure storage. */
export type FileStorageLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** This table holds information regarding the physical files stored in azure storage. */
export type FileStorageLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** This table holds information regarding the physical files stored in azure storage. */
export type FileStorageMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** The different types of storage we use. Currently Azure Blob and Table Storage. */
export type FileStorageType = {
  __typename?: 'fileStorageType';
  created_at: Scalars['timestamptz'];
  /** What the user sees in the UI, or the description of the storage type. */
  display: Scalars['String'];
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue: Scalars['Int'];
  /** An array relationship */
  fileStorages: Array<FileStorage>;
  /** An aggregate relationship */
  fileStorages_aggregate: FileStorage_Aggregate;
  /** The `uuid` of the storage type. This is referenced in the `file_storage` table. */
  id: Scalars['uuid'];
  /** This is like a code. It can contains spaces, but usually does not. This is normally used in code, not for UIs. */
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** The different types of storage we use. Currently Azure Blob and Table Storage. */
export type FileStorageTypeFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<FileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileStorage_Order_By>>;
  where?: InputMaybe<FileStorage_Bool_Exp>;
};


/** The different types of storage we use. Currently Azure Blob and Table Storage. */
export type FileStorageTypeFileStorages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileStorage_Order_By>>;
  where?: InputMaybe<FileStorage_Bool_Exp>;
};

/** aggregated selection of "shared.file_storage_type" */
export type FileStorageType_Aggregate = {
  __typename?: 'fileStorageType_aggregate';
  aggregate?: Maybe<FileStorageType_Aggregate_Fields>;
  nodes: Array<FileStorageType>;
};

/** aggregate fields of "shared.file_storage_type" */
export type FileStorageType_Aggregate_Fields = {
  __typename?: 'fileStorageType_aggregate_fields';
  avg?: Maybe<FileStorageType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<FileStorageType_Max_Fields>;
  min?: Maybe<FileStorageType_Min_Fields>;
  stddev?: Maybe<FileStorageType_Stddev_Fields>;
  stddev_pop?: Maybe<FileStorageType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FileStorageType_Stddev_Samp_Fields>;
  sum?: Maybe<FileStorageType_Sum_Fields>;
  var_pop?: Maybe<FileStorageType_Var_Pop_Fields>;
  var_samp?: Maybe<FileStorageType_Var_Samp_Fields>;
  variance?: Maybe<FileStorageType_Variance_Fields>;
};


/** aggregate fields of "shared.file_storage_type" */
export type FileStorageType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FileStorageType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FileStorageType_Avg_Fields = {
  __typename?: 'fileStorageType_avg_fields';
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shared.file_storage_type". All fields are combined with a logical 'AND'. */
export type FileStorageType_Bool_Exp = {
  _and?: InputMaybe<Array<FileStorageType_Bool_Exp>>;
  _not?: InputMaybe<FileStorageType_Bool_Exp>;
  _or?: InputMaybe<Array<FileStorageType_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  fileStorages?: InputMaybe<FileStorage_Bool_Exp>;
  fileStorages_aggregate?: InputMaybe<FileStorage_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.file_storage_type" */
export enum FileStorageType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  StorageTypeEnumValueKey = 'storage_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  StorageTypePkey = 'storage_type_pkey'
}

/** input type for incrementing numeric columns in table "shared.file_storage_type" */
export type FileStorageType_Inc_Input = {
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shared.file_storage_type" */
export type FileStorageType_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** What the user sees in the UI, or the description of the storage type. */
  display?: InputMaybe<Scalars['String']>;
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: InputMaybe<Scalars['Int']>;
  fileStorages?: InputMaybe<FileStorage_Arr_Rel_Insert_Input>;
  /** The `uuid` of the storage type. This is referenced in the `file_storage` table. */
  id?: InputMaybe<Scalars['uuid']>;
  /** This is like a code. It can contains spaces, but usually does not. This is normally used in code, not for UIs. */
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type FileStorageType_Max_Fields = {
  __typename?: 'fileStorageType_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** What the user sees in the UI, or the description of the storage type. */
  display?: Maybe<Scalars['String']>;
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: Maybe<Scalars['Int']>;
  /** The `uuid` of the storage type. This is referenced in the `file_storage` table. */
  id?: Maybe<Scalars['uuid']>;
  /** This is like a code. It can contains spaces, but usually does not. This is normally used in code, not for UIs. */
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type FileStorageType_Min_Fields = {
  __typename?: 'fileStorageType_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** What the user sees in the UI, or the description of the storage type. */
  display?: Maybe<Scalars['String']>;
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: Maybe<Scalars['Int']>;
  /** The `uuid` of the storage type. This is referenced in the `file_storage` table. */
  id?: Maybe<Scalars['uuid']>;
  /** This is like a code. It can contains spaces, but usually does not. This is normally used in code, not for UIs. */
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shared.file_storage_type" */
export type FileStorageType_Mutation_Response = {
  __typename?: 'fileStorageType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FileStorageType>;
};

/** input type for inserting object relation for remote table "shared.file_storage_type" */
export type FileStorageType_Obj_Rel_Insert_Input = {
  data: FileStorageType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FileStorageType_On_Conflict>;
};

/** on_conflict condition type for table "shared.file_storage_type" */
export type FileStorageType_On_Conflict = {
  constraint: FileStorageType_Constraint;
  update_columns?: Array<FileStorageType_Update_Column>;
  where?: InputMaybe<FileStorageType_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.file_storage_type". */
export type FileStorageType_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  fileStorages_aggregate?: InputMaybe<FileStorage_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.file_storage_type */
export type FileStorageType_Pk_Columns_Input = {
  /** The `uuid` of the storage type. This is referenced in the `file_storage` table. */
  id: Scalars['uuid'];
};

/** select columns of table "shared.file_storage_type" */
export enum FileStorageType_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "shared.file_storage_type" */
export type FileStorageType_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** What the user sees in the UI, or the description of the storage type. */
  display?: InputMaybe<Scalars['String']>;
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: InputMaybe<Scalars['Int']>;
  /** The `uuid` of the storage type. This is referenced in the `file_storage` table. */
  id?: InputMaybe<Scalars['uuid']>;
  /** This is like a code. It can contains spaces, but usually does not. This is normally used in code, not for UIs. */
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type FileStorageType_Stddev_Fields = {
  __typename?: 'fileStorageType_stddev_fields';
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FileStorageType_Stddev_Pop_Fields = {
  __typename?: 'fileStorageType_stddev_pop_fields';
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FileStorageType_Stddev_Samp_Fields = {
  __typename?: 'fileStorageType_stddev_samp_fields';
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fileStorageType" */
export type FileStorageType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FileStorageType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FileStorageType_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** What the user sees in the UI, or the description of the storage type. */
  display?: InputMaybe<Scalars['String']>;
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: InputMaybe<Scalars['Int']>;
  /** The `uuid` of the storage type. This is referenced in the `file_storage` table. */
  id?: InputMaybe<Scalars['uuid']>;
  /** This is like a code. It can contains spaces, but usually does not. This is normally used in code, not for UIs. */
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type FileStorageType_Sum_Fields = {
  __typename?: 'fileStorageType_sum_fields';
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "shared.file_storage_type" */
export enum FileStorageType_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type FileStorageType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FileStorageType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FileStorageType_Set_Input>;
  /** filter the rows which have to be updated */
  where: FileStorageType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FileStorageType_Var_Pop_Fields = {
  __typename?: 'fileStorageType_var_pop_fields';
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FileStorageType_Var_Samp_Fields = {
  __typename?: 'fileStorageType_var_samp_fields';
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FileStorageType_Variance_Fields = {
  __typename?: 'fileStorageType_variance_fields';
  /** DEPRECATED - We do not use the `enum_value`. Please use the `id` to reference the type. */
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "shared.file_storage" */
export type FileStorage_Aggregate = {
  __typename?: 'fileStorage_aggregate';
  aggregate?: Maybe<FileStorage_Aggregate_Fields>;
  nodes: Array<FileStorage>;
};

export type FileStorage_Aggregate_Bool_Exp = {
  count?: InputMaybe<FileStorage_Aggregate_Bool_Exp_Count>;
};

export type FileStorage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<FileStorage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FileStorage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.file_storage" */
export type FileStorage_Aggregate_Fields = {
  __typename?: 'fileStorage_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FileStorage_Max_Fields>;
  min?: Maybe<FileStorage_Min_Fields>;
};


/** aggregate fields of "shared.file_storage" */
export type FileStorage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FileStorage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.file_storage" */
export type FileStorage_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<FileStorage_Max_Order_By>;
  min?: InputMaybe<FileStorage_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FileStorage_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "shared.file_storage" */
export type FileStorage_Arr_Rel_Insert_Input = {
  data: Array<FileStorage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<FileStorage_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.file_storage". All fields are combined with a logical 'AND'. */
export type FileStorage_Bool_Exp = {
  _and?: InputMaybe<Array<FileStorage_Bool_Exp>>;
  _not?: InputMaybe<FileStorage_Bool_Exp>;
  _or?: InputMaybe<Array<FileStorage_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Bool_Exp>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Bool_Exp>;
  fileStorageType?: InputMaybe<FileStorageType_Bool_Exp>;
  folderPath?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  storageId?: InputMaybe<Uuid_Comparison_Exp>;
  storageTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.file_storage" */
export enum FileStorage_Constraint {
  /** unique or primary key constraint on columns "id" */
  FileStoragePkey = 'file_storage_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FileStorage_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FileStorage_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FileStorage_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "shared.file_storage" */
export type FileStorage_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Arr_Rel_Insert_Input>;
  fileStorageType?: InputMaybe<FileStorageType_Obj_Rel_Insert_Input>;
  /** This is the virtual folder path the file is in. This is what can be adjusted if a user wants to move a file to a different folder. This is also how multiple files with the same name can exist in the same "folder". */
  folderPath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** The file name the user will use to reference this file. */
  name?: InputMaybe<Scalars['String']>;
  /** The identifier that the storage mechanism uses. For Azure blob storage this corresponds to `Name`. */
  storageId?: InputMaybe<Scalars['uuid']>;
  /** The `uuid` of the storage mechanism. Currently we use Azure Blob or Table Storage. */
  storageTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type FileStorage_Max_Fields = {
  __typename?: 'fileStorage_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** This is the virtual folder path the file is in. This is what can be adjusted if a user wants to move a file to a different folder. This is also how multiple files with the same name can exist in the same "folder". */
  folderPath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The file name the user will use to reference this file. */
  name?: Maybe<Scalars['String']>;
  /** The identifier that the storage mechanism uses. For Azure blob storage this corresponds to `Name`. */
  storageId?: Maybe<Scalars['uuid']>;
  /** The `uuid` of the storage mechanism. Currently we use Azure Blob or Table Storage. */
  storageTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.file_storage" */
export type FileStorage_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  /** This is the virtual folder path the file is in. This is what can be adjusted if a user wants to move a file to a different folder. This is also how multiple files with the same name can exist in the same "folder". */
  folderPath?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The file name the user will use to reference this file. */
  name?: InputMaybe<Order_By>;
  /** The identifier that the storage mechanism uses. For Azure blob storage this corresponds to `Name`. */
  storageId?: InputMaybe<Order_By>;
  /** The `uuid` of the storage mechanism. Currently we use Azure Blob or Table Storage. */
  storageTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type FileStorage_Min_Fields = {
  __typename?: 'fileStorage_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** This is the virtual folder path the file is in. This is what can be adjusted if a user wants to move a file to a different folder. This is also how multiple files with the same name can exist in the same "folder". */
  folderPath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The file name the user will use to reference this file. */
  name?: Maybe<Scalars['String']>;
  /** The identifier that the storage mechanism uses. For Azure blob storage this corresponds to `Name`. */
  storageId?: Maybe<Scalars['uuid']>;
  /** The `uuid` of the storage mechanism. Currently we use Azure Blob or Table Storage. */
  storageTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.file_storage" */
export type FileStorage_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  /** This is the virtual folder path the file is in. This is what can be adjusted if a user wants to move a file to a different folder. This is also how multiple files with the same name can exist in the same "folder". */
  folderPath?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The file name the user will use to reference this file. */
  name?: InputMaybe<Order_By>;
  /** The identifier that the storage mechanism uses. For Azure blob storage this corresponds to `Name`. */
  storageId?: InputMaybe<Order_By>;
  /** The `uuid` of the storage mechanism. Currently we use Azure Blob or Table Storage. */
  storageTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.file_storage" */
export type FileStorage_Mutation_Response = {
  __typename?: 'fileStorage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FileStorage>;
};

/** input type for inserting object relation for remote table "shared.file_storage" */
export type FileStorage_Obj_Rel_Insert_Input = {
  data: FileStorage_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FileStorage_On_Conflict>;
};

/** on_conflict condition type for table "shared.file_storage" */
export type FileStorage_On_Conflict = {
  constraint: FileStorage_Constraint;
  update_columns?: Array<FileStorage_Update_Column>;
  where?: InputMaybe<FileStorage_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.file_storage". */
export type FileStorage_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Order_By>;
  fileStorageType?: InputMaybe<FileStorageType_Order_By>;
  folderPath?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  storageId?: InputMaybe<Order_By>;
  storageTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.file_storage */
export type FileStorage_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FileStorage_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shared.file_storage" */
export enum FileStorage_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FolderPath = 'folderPath',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  StorageId = 'storageId',
  /** column name */
  StorageTypeId = 'storageTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.file_storage" */
export type FileStorage_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** This is the virtual folder path the file is in. This is what can be adjusted if a user wants to move a file to a different folder. This is also how multiple files with the same name can exist in the same "folder". */
  folderPath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** The file name the user will use to reference this file. */
  name?: InputMaybe<Scalars['String']>;
  /** The identifier that the storage mechanism uses. For Azure blob storage this corresponds to `Name`. */
  storageId?: InputMaybe<Scalars['uuid']>;
  /** The `uuid` of the storage mechanism. Currently we use Azure Blob or Table Storage. */
  storageTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "fileStorage" */
export type FileStorage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FileStorage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FileStorage_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** This is the virtual folder path the file is in. This is what can be adjusted if a user wants to move a file to a different folder. This is also how multiple files with the same name can exist in the same "folder". */
  folderPath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** The file name the user will use to reference this file. */
  name?: InputMaybe<Scalars['String']>;
  /** The identifier that the storage mechanism uses. For Azure blob storage this corresponds to `Name`. */
  storageId?: InputMaybe<Scalars['uuid']>;
  /** The `uuid` of the storage mechanism. Currently we use Azure Blob or Table Storage. */
  storageTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.file_storage" */
export enum FileStorage_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FolderPath = 'folderPath',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  StorageId = 'storageId',
  /** column name */
  StorageTypeId = 'storageTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type FileStorage_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<FileStorage_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<FileStorage_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<FileStorage_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<FileStorage_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<FileStorage_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FileStorage_Set_Input>;
  /** filter the rows which have to be updated */
  where: FileStorage_Bool_Exp;
};

/** columns and relationships of "compliance.filing_lender" */
export type FilingLender = {
  __typename?: 'filingLender';
  /** An array relationship */
  contractFormFilingStatuses: Array<ContractFormFilingStatus>;
  /** An aggregate relationship */
  contractFormFilingStatuses_aggregate: ContractFormFilingStatus_Aggregate;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  filingLenderMatches: Array<FilingLenderMatch>;
  /** An aggregate relationship */
  filingLenderMatches_aggregate: FilingLenderMatch_Aggregate;
  id: Scalars['uuid'];
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "compliance.filing_lender" */
export type FilingLenderContractFormFilingStatusesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


/** columns and relationships of "compliance.filing_lender" */
export type FilingLenderContractFormFilingStatuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


/** columns and relationships of "compliance.filing_lender" */
export type FilingLenderFilingLenderMatchesArgs = {
  distinct_on?: InputMaybe<Array<FilingLenderMatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingLenderMatch_Order_By>>;
  where?: InputMaybe<FilingLenderMatch_Bool_Exp>;
};


/** columns and relationships of "compliance.filing_lender" */
export type FilingLenderFilingLenderMatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FilingLenderMatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingLenderMatch_Order_By>>;
  where?: InputMaybe<FilingLenderMatch_Bool_Exp>;
};


/** columns and relationships of "compliance.filing_lender" */
export type FilingLenderMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "compliance.filing_lender_match" */
export type FilingLenderMatch = {
  __typename?: 'filingLenderMatch';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  filingLender: FilingLender;
  filingLenderId: Scalars['uuid'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  value: Scalars['String'];
};

/** aggregated selection of "compliance.filing_lender_match" */
export type FilingLenderMatch_Aggregate = {
  __typename?: 'filingLenderMatch_aggregate';
  aggregate?: Maybe<FilingLenderMatch_Aggregate_Fields>;
  nodes: Array<FilingLenderMatch>;
};

export type FilingLenderMatch_Aggregate_Bool_Exp = {
  count?: InputMaybe<FilingLenderMatch_Aggregate_Bool_Exp_Count>;
};

export type FilingLenderMatch_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<FilingLenderMatch_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FilingLenderMatch_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance.filing_lender_match" */
export type FilingLenderMatch_Aggregate_Fields = {
  __typename?: 'filingLenderMatch_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FilingLenderMatch_Max_Fields>;
  min?: Maybe<FilingLenderMatch_Min_Fields>;
};


/** aggregate fields of "compliance.filing_lender_match" */
export type FilingLenderMatch_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FilingLenderMatch_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance.filing_lender_match" */
export type FilingLenderMatch_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<FilingLenderMatch_Max_Order_By>;
  min?: InputMaybe<FilingLenderMatch_Min_Order_By>;
};

/** input type for inserting array relation for remote table "compliance.filing_lender_match" */
export type FilingLenderMatch_Arr_Rel_Insert_Input = {
  data: Array<FilingLenderMatch_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<FilingLenderMatch_On_Conflict>;
};

/** Boolean expression to filter rows from the table "compliance.filing_lender_match". All fields are combined with a logical 'AND'. */
export type FilingLenderMatch_Bool_Exp = {
  _and?: InputMaybe<Array<FilingLenderMatch_Bool_Exp>>;
  _not?: InputMaybe<FilingLenderMatch_Bool_Exp>;
  _or?: InputMaybe<Array<FilingLenderMatch_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  filingLender?: InputMaybe<FilingLender_Bool_Exp>;
  filingLenderId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.filing_lender_match" */
export enum FilingLenderMatch_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilingLenderMatchPkey = 'filing_lender_match_pkey'
}

/** input type for inserting data into table "compliance.filing_lender_match" */
export type FilingLenderMatch_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  filingLender?: InputMaybe<FilingLender_Obj_Rel_Insert_Input>;
  filingLenderId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FilingLenderMatch_Max_Fields = {
  __typename?: 'filingLenderMatch_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  filingLenderId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "compliance.filing_lender_match" */
export type FilingLenderMatch_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  filingLenderId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type FilingLenderMatch_Min_Fields = {
  __typename?: 'filingLenderMatch_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  filingLenderId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "compliance.filing_lender_match" */
export type FilingLenderMatch_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  filingLenderId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance.filing_lender_match" */
export type FilingLenderMatch_Mutation_Response = {
  __typename?: 'filingLenderMatch_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FilingLenderMatch>;
};

/** on_conflict condition type for table "compliance.filing_lender_match" */
export type FilingLenderMatch_On_Conflict = {
  constraint: FilingLenderMatch_Constraint;
  update_columns?: Array<FilingLenderMatch_Update_Column>;
  where?: InputMaybe<FilingLenderMatch_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.filing_lender_match". */
export type FilingLenderMatch_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  filingLender?: InputMaybe<FilingLender_Order_By>;
  filingLenderId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.filing_lender_match */
export type FilingLenderMatch_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.filing_lender_match" */
export enum FilingLenderMatch_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FilingLenderId = 'filingLenderId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "compliance.filing_lender_match" */
export type FilingLenderMatch_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  filingLenderId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "filingLenderMatch" */
export type FilingLenderMatch_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FilingLenderMatch_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FilingLenderMatch_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  filingLenderId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "compliance.filing_lender_match" */
export enum FilingLenderMatch_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FilingLenderId = 'filingLenderId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

export type FilingLenderMatch_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FilingLenderMatch_Set_Input>;
  /** filter the rows which have to be updated */
  where: FilingLenderMatch_Bool_Exp;
};

/** aggregated selection of "compliance.filing_lender" */
export type FilingLender_Aggregate = {
  __typename?: 'filingLender_aggregate';
  aggregate?: Maybe<FilingLender_Aggregate_Fields>;
  nodes: Array<FilingLender>;
};

/** aggregate fields of "compliance.filing_lender" */
export type FilingLender_Aggregate_Fields = {
  __typename?: 'filingLender_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FilingLender_Max_Fields>;
  min?: Maybe<FilingLender_Min_Fields>;
};


/** aggregate fields of "compliance.filing_lender" */
export type FilingLender_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FilingLender_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FilingLender_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "compliance.filing_lender". All fields are combined with a logical 'AND'. */
export type FilingLender_Bool_Exp = {
  _and?: InputMaybe<Array<FilingLender_Bool_Exp>>;
  _not?: InputMaybe<FilingLender_Bool_Exp>;
  _or?: InputMaybe<Array<FilingLender_Bool_Exp>>;
  contractFormFilingStatuses?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
  contractFormFilingStatuses_aggregate?: InputMaybe<ContractFormFilingStatus_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  filingLenderMatches?: InputMaybe<FilingLenderMatch_Bool_Exp>;
  filingLenderMatches_aggregate?: InputMaybe<FilingLenderMatch_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.filing_lender" */
export enum FilingLender_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilingLenderPkey = 'filing_lender_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FilingLender_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FilingLender_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FilingLender_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "compliance.filing_lender" */
export type FilingLender_Insert_Input = {
  contractFormFilingStatuses?: InputMaybe<ContractFormFilingStatus_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  filingLenderMatches?: InputMaybe<FilingLenderMatch_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type FilingLender_Max_Fields = {
  __typename?: 'filingLender_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type FilingLender_Min_Fields = {
  __typename?: 'filingLender_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "compliance.filing_lender" */
export type FilingLender_Mutation_Response = {
  __typename?: 'filingLender_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FilingLender>;
};

/** input type for inserting object relation for remote table "compliance.filing_lender" */
export type FilingLender_Obj_Rel_Insert_Input = {
  data: FilingLender_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FilingLender_On_Conflict>;
};

/** on_conflict condition type for table "compliance.filing_lender" */
export type FilingLender_On_Conflict = {
  constraint: FilingLender_Constraint;
  update_columns?: Array<FilingLender_Update_Column>;
  where?: InputMaybe<FilingLender_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.filing_lender". */
export type FilingLender_Order_By = {
  contractFormFilingStatuses_aggregate?: InputMaybe<ContractFormFilingStatus_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  filingLenderMatches_aggregate?: InputMaybe<FilingLenderMatch_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.filing_lender */
export type FilingLender_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FilingLender_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "compliance.filing_lender" */
export enum FilingLender_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "compliance.filing_lender" */
export type FilingLender_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "filingLender" */
export type FilingLender_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FilingLender_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FilingLender_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "compliance.filing_lender" */
export enum FilingLender_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type FilingLender_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<FilingLender_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<FilingLender_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<FilingLender_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<FilingLender_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<FilingLender_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FilingLender_Set_Input>;
  /** filter the rows which have to be updated */
  where: FilingLender_Bool_Exp;
};

/** columns and relationships of "compliance.filing_state" */
export type FilingState = {
  __typename?: 'filingState';
  /** An array relationship */
  contractFormFilingStatuses: Array<ContractFormFilingStatus>;
  /** An aggregate relationship */
  contractFormFilingStatuses_aggregate: ContractFormFilingStatus_Aggregate;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "compliance.filing_state" */
export type FilingStateContractFormFilingStatusesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


/** columns and relationships of "compliance.filing_state" */
export type FilingStateContractFormFilingStatuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};

/** aggregated selection of "compliance.filing_state" */
export type FilingState_Aggregate = {
  __typename?: 'filingState_aggregate';
  aggregate?: Maybe<FilingState_Aggregate_Fields>;
  nodes: Array<FilingState>;
};

/** aggregate fields of "compliance.filing_state" */
export type FilingState_Aggregate_Fields = {
  __typename?: 'filingState_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FilingState_Max_Fields>;
  min?: Maybe<FilingState_Min_Fields>;
};


/** aggregate fields of "compliance.filing_state" */
export type FilingState_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FilingState_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "compliance.filing_state". All fields are combined with a logical 'AND'. */
export type FilingState_Bool_Exp = {
  _and?: InputMaybe<Array<FilingState_Bool_Exp>>;
  _not?: InputMaybe<FilingState_Bool_Exp>;
  _or?: InputMaybe<Array<FilingState_Bool_Exp>>;
  contractFormFilingStatuses?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
  contractFormFilingStatuses_aggregate?: InputMaybe<ContractFormFilingStatus_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  stateAbbreviation?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.filing_state" */
export enum FilingState_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilingStatePkey = 'filing_state_pkey'
}

/** input type for inserting data into table "compliance.filing_state" */
export type FilingState_Insert_Input = {
  contractFormFilingStatuses?: InputMaybe<ContractFormFilingStatus_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type FilingState_Max_Fields = {
  __typename?: 'filingState_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type FilingState_Min_Fields = {
  __typename?: 'filingState_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "compliance.filing_state" */
export type FilingState_Mutation_Response = {
  __typename?: 'filingState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FilingState>;
};

/** input type for inserting object relation for remote table "compliance.filing_state" */
export type FilingState_Obj_Rel_Insert_Input = {
  data: FilingState_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FilingState_On_Conflict>;
};

/** on_conflict condition type for table "compliance.filing_state" */
export type FilingState_On_Conflict = {
  constraint: FilingState_Constraint;
  update_columns?: Array<FilingState_Update_Column>;
  where?: InputMaybe<FilingState_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.filing_state". */
export type FilingState_Order_By = {
  contractFormFilingStatuses_aggregate?: InputMaybe<ContractFormFilingStatus_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stateAbbreviation?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.filing_state */
export type FilingState_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.filing_state" */
export enum FilingState_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StateAbbreviation = 'stateAbbreviation',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "compliance.filing_state" */
export type FilingState_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "filingState" */
export type FilingState_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FilingState_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FilingState_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "compliance.filing_state" */
export enum FilingState_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StateAbbreviation = 'stateAbbreviation',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type FilingState_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FilingState_Set_Input>;
  /** filter the rows which have to be updated */
  where: FilingState_Bool_Exp;
};

/** columns and relationships of "compliance.filing_status_type" */
export type FilingStatusType = {
  __typename?: 'filingStatusType';
  /** An array relationship */
  contractFormFilingStatuses: Array<ContractFormFilingStatus>;
  /** An aggregate relationship */
  contractFormFilingStatuses_aggregate: ContractFormFilingStatus_Aggregate;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "compliance.filing_status_type" */
export type FilingStatusTypeContractFormFilingStatusesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


/** columns and relationships of "compliance.filing_status_type" */
export type FilingStatusTypeContractFormFilingStatuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};

/** aggregated selection of "compliance.filing_status_type" */
export type FilingStatusType_Aggregate = {
  __typename?: 'filingStatusType_aggregate';
  aggregate?: Maybe<FilingStatusType_Aggregate_Fields>;
  nodes: Array<FilingStatusType>;
};

/** aggregate fields of "compliance.filing_status_type" */
export type FilingStatusType_Aggregate_Fields = {
  __typename?: 'filingStatusType_aggregate_fields';
  avg?: Maybe<FilingStatusType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<FilingStatusType_Max_Fields>;
  min?: Maybe<FilingStatusType_Min_Fields>;
  stddev?: Maybe<FilingStatusType_Stddev_Fields>;
  stddev_pop?: Maybe<FilingStatusType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FilingStatusType_Stddev_Samp_Fields>;
  sum?: Maybe<FilingStatusType_Sum_Fields>;
  var_pop?: Maybe<FilingStatusType_Var_Pop_Fields>;
  var_samp?: Maybe<FilingStatusType_Var_Samp_Fields>;
  variance?: Maybe<FilingStatusType_Variance_Fields>;
};


/** aggregate fields of "compliance.filing_status_type" */
export type FilingStatusType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FilingStatusType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FilingStatusType_Avg_Fields = {
  __typename?: 'filingStatusType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance.filing_status_type". All fields are combined with a logical 'AND'. */
export type FilingStatusType_Bool_Exp = {
  _and?: InputMaybe<Array<FilingStatusType_Bool_Exp>>;
  _not?: InputMaybe<FilingStatusType_Bool_Exp>;
  _or?: InputMaybe<Array<FilingStatusType_Bool_Exp>>;
  contractFormFilingStatuses?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
  contractFormFilingStatuses_aggregate?: InputMaybe<ContractFormFilingStatus_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.filing_status_type" */
export enum FilingStatusType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  FilingStatusTypeEnumValueKey = 'filing_status_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  FilingStatusTypePkey = 'filing_status_type_pkey'
}

/** input type for incrementing numeric columns in table "compliance.filing_status_type" */
export type FilingStatusType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "compliance.filing_status_type" */
export type FilingStatusType_Insert_Input = {
  contractFormFilingStatuses?: InputMaybe<ContractFormFilingStatus_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type FilingStatusType_Max_Fields = {
  __typename?: 'filingStatusType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type FilingStatusType_Min_Fields = {
  __typename?: 'filingStatusType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "compliance.filing_status_type" */
export type FilingStatusType_Mutation_Response = {
  __typename?: 'filingStatusType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FilingStatusType>;
};

/** input type for inserting object relation for remote table "compliance.filing_status_type" */
export type FilingStatusType_Obj_Rel_Insert_Input = {
  data: FilingStatusType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FilingStatusType_On_Conflict>;
};

/** on_conflict condition type for table "compliance.filing_status_type" */
export type FilingStatusType_On_Conflict = {
  constraint: FilingStatusType_Constraint;
  update_columns?: Array<FilingStatusType_Update_Column>;
  where?: InputMaybe<FilingStatusType_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.filing_status_type". */
export type FilingStatusType_Order_By = {
  contractFormFilingStatuses_aggregate?: InputMaybe<ContractFormFilingStatus_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.filing_status_type */
export type FilingStatusType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.filing_status_type" */
export enum FilingStatusType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "compliance.filing_status_type" */
export type FilingStatusType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type FilingStatusType_Stddev_Fields = {
  __typename?: 'filingStatusType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FilingStatusType_Stddev_Pop_Fields = {
  __typename?: 'filingStatusType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FilingStatusType_Stddev_Samp_Fields = {
  __typename?: 'filingStatusType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "filingStatusType" */
export type FilingStatusType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FilingStatusType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FilingStatusType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type FilingStatusType_Sum_Fields = {
  __typename?: 'filingStatusType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "compliance.filing_status_type" */
export enum FilingStatusType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type FilingStatusType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FilingStatusType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FilingStatusType_Set_Input>;
  /** filter the rows which have to be updated */
  where: FilingStatusType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FilingStatusType_Var_Pop_Fields = {
  __typename?: 'filingStatusType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FilingStatusType_Var_Samp_Fields = {
  __typename?: 'filingStatusType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FilingStatusType_Variance_Fields = {
  __typename?: 'filingStatusType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "auth.flow_item" */
export type FlowItem = {
  __typename?: 'flowItem';
  created_at?: Maybe<Scalars['timestamptz']>;
  expiration_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  flowItemType: FlowItemType;
  flowItemTypeId: Scalars['uuid'];
  /** An object relationship */
  flowType: FlowType;
  flowTypeId: Scalars['uuid'];
  id: Scalars['uuid'];
  order: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  userFlowItems: Array<UserFlowItem>;
  /** An aggregate relationship */
  userFlowItems_aggregate: UserFlowItem_Aggregate;
};


/** columns and relationships of "auth.flow_item" */
export type FlowItemUserFlowItemsArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItem_Order_By>>;
  where?: InputMaybe<UserFlowItem_Bool_Exp>;
};


/** columns and relationships of "auth.flow_item" */
export type FlowItemUserFlowItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItem_Order_By>>;
  where?: InputMaybe<UserFlowItem_Bool_Exp>;
};

/** columns and relationships of "auth.flow_item_type" */
export type FlowItemType = {
  __typename?: 'flowItemType';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  /** An array relationship */
  flowItems: Array<FlowItem>;
  /** An aggregate relationship */
  flowItems_aggregate: FlowItem_Aggregate;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
};


/** columns and relationships of "auth.flow_item_type" */
export type FlowItemTypeFlowItemsArgs = {
  distinct_on?: InputMaybe<Array<FlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItem_Order_By>>;
  where?: InputMaybe<FlowItem_Bool_Exp>;
};


/** columns and relationships of "auth.flow_item_type" */
export type FlowItemTypeFlowItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItem_Order_By>>;
  where?: InputMaybe<FlowItem_Bool_Exp>;
};

/** aggregated selection of "auth.flow_item_type" */
export type FlowItemType_Aggregate = {
  __typename?: 'flowItemType_aggregate';
  aggregate?: Maybe<FlowItemType_Aggregate_Fields>;
  nodes: Array<FlowItemType>;
};

/** aggregate fields of "auth.flow_item_type" */
export type FlowItemType_Aggregate_Fields = {
  __typename?: 'flowItemType_aggregate_fields';
  avg?: Maybe<FlowItemType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<FlowItemType_Max_Fields>;
  min?: Maybe<FlowItemType_Min_Fields>;
  stddev?: Maybe<FlowItemType_Stddev_Fields>;
  stddev_pop?: Maybe<FlowItemType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FlowItemType_Stddev_Samp_Fields>;
  sum?: Maybe<FlowItemType_Sum_Fields>;
  var_pop?: Maybe<FlowItemType_Var_Pop_Fields>;
  var_samp?: Maybe<FlowItemType_Var_Samp_Fields>;
  variance?: Maybe<FlowItemType_Variance_Fields>;
};


/** aggregate fields of "auth.flow_item_type" */
export type FlowItemType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FlowItemType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FlowItemType_Avg_Fields = {
  __typename?: 'flowItemType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "auth.flow_item_type". All fields are combined with a logical 'AND'. */
export type FlowItemType_Bool_Exp = {
  _and?: InputMaybe<Array<FlowItemType_Bool_Exp>>;
  _not?: InputMaybe<FlowItemType_Bool_Exp>;
  _or?: InputMaybe<Array<FlowItemType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  flowItems?: InputMaybe<FlowItem_Bool_Exp>;
  flowItems_aggregate?: InputMaybe<FlowItem_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.flow_item_type" */
export enum FlowItemType_Constraint {
  /** unique or primary key constraint on columns "display" */
  FlowItemTypeDisplayKey = 'flow_item_type_display_key',
  /** unique or primary key constraint on columns "enum_value" */
  FlowItemTypeEnumValueKey = 'flow_item_type_enum_value_key',
  /** unique or primary key constraint on columns "name" */
  FlowItemTypeNameKey = 'flow_item_type_name_key',
  /** unique or primary key constraint on columns "id" */
  FlowItemTypePkey = 'flow_item_type_pkey'
}

/** input type for incrementing numeric columns in table "auth.flow_item_type" */
export type FlowItemType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth.flow_item_type" */
export type FlowItemType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  flowItems?: InputMaybe<FlowItem_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FlowItemType_Max_Fields = {
  __typename?: 'flowItemType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FlowItemType_Min_Fields = {
  __typename?: 'flowItemType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth.flow_item_type" */
export type FlowItemType_Mutation_Response = {
  __typename?: 'flowItemType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FlowItemType>;
};

/** input type for inserting object relation for remote table "auth.flow_item_type" */
export type FlowItemType_Obj_Rel_Insert_Input = {
  data: FlowItemType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FlowItemType_On_Conflict>;
};

/** on_conflict condition type for table "auth.flow_item_type" */
export type FlowItemType_On_Conflict = {
  constraint: FlowItemType_Constraint;
  update_columns?: Array<FlowItemType_Update_Column>;
  where?: InputMaybe<FlowItemType_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.flow_item_type". */
export type FlowItemType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  flowItems_aggregate?: InputMaybe<FlowItem_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.flow_item_type */
export type FlowItemType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.flow_item_type" */
export enum FlowItemType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "auth.flow_item_type" */
export type FlowItemType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type FlowItemType_Stddev_Fields = {
  __typename?: 'flowItemType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FlowItemType_Stddev_Pop_Fields = {
  __typename?: 'flowItemType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FlowItemType_Stddev_Samp_Fields = {
  __typename?: 'flowItemType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "flowItemType" */
export type FlowItemType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FlowItemType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FlowItemType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type FlowItemType_Sum_Fields = {
  __typename?: 'flowItemType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "auth.flow_item_type" */
export enum FlowItemType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type FlowItemType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FlowItemType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FlowItemType_Set_Input>;
  /** filter the rows which have to be updated */
  where: FlowItemType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FlowItemType_Var_Pop_Fields = {
  __typename?: 'flowItemType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FlowItemType_Var_Samp_Fields = {
  __typename?: 'flowItemType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FlowItemType_Variance_Fields = {
  __typename?: 'flowItemType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "auth.flow_item" */
export type FlowItem_Aggregate = {
  __typename?: 'flowItem_aggregate';
  aggregate?: Maybe<FlowItem_Aggregate_Fields>;
  nodes: Array<FlowItem>;
};

export type FlowItem_Aggregate_Bool_Exp = {
  count?: InputMaybe<FlowItem_Aggregate_Bool_Exp_Count>;
};

export type FlowItem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<FlowItem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FlowItem_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.flow_item" */
export type FlowItem_Aggregate_Fields = {
  __typename?: 'flowItem_aggregate_fields';
  avg?: Maybe<FlowItem_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<FlowItem_Max_Fields>;
  min?: Maybe<FlowItem_Min_Fields>;
  stddev?: Maybe<FlowItem_Stddev_Fields>;
  stddev_pop?: Maybe<FlowItem_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FlowItem_Stddev_Samp_Fields>;
  sum?: Maybe<FlowItem_Sum_Fields>;
  var_pop?: Maybe<FlowItem_Var_Pop_Fields>;
  var_samp?: Maybe<FlowItem_Var_Samp_Fields>;
  variance?: Maybe<FlowItem_Variance_Fields>;
};


/** aggregate fields of "auth.flow_item" */
export type FlowItem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FlowItem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.flow_item" */
export type FlowItem_Aggregate_Order_By = {
  avg?: InputMaybe<FlowItem_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<FlowItem_Max_Order_By>;
  min?: InputMaybe<FlowItem_Min_Order_By>;
  stddev?: InputMaybe<FlowItem_Stddev_Order_By>;
  stddev_pop?: InputMaybe<FlowItem_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<FlowItem_Stddev_Samp_Order_By>;
  sum?: InputMaybe<FlowItem_Sum_Order_By>;
  var_pop?: InputMaybe<FlowItem_Var_Pop_Order_By>;
  var_samp?: InputMaybe<FlowItem_Var_Samp_Order_By>;
  variance?: InputMaybe<FlowItem_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth.flow_item" */
export type FlowItem_Arr_Rel_Insert_Input = {
  data: Array<FlowItem_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<FlowItem_On_Conflict>;
};

/** aggregate avg on columns */
export type FlowItem_Avg_Fields = {
  __typename?: 'flowItem_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "auth.flow_item" */
export type FlowItem_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth.flow_item". All fields are combined with a logical 'AND'. */
export type FlowItem_Bool_Exp = {
  _and?: InputMaybe<Array<FlowItem_Bool_Exp>>;
  _not?: InputMaybe<FlowItem_Bool_Exp>;
  _or?: InputMaybe<Array<FlowItem_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiration_date?: InputMaybe<Date_Comparison_Exp>;
  flowItemType?: InputMaybe<FlowItemType_Bool_Exp>;
  flowItemTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  flowType?: InputMaybe<FlowType_Bool_Exp>;
  flowTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userFlowItems?: InputMaybe<UserFlowItem_Bool_Exp>;
  userFlowItems_aggregate?: InputMaybe<UserFlowItem_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.flow_item" */
export enum FlowItem_Constraint {
  /** unique or primary key constraint on columns "id" */
  FlowItemPkey = 'flow_item_pkey'
}

/** input type for incrementing numeric columns in table "auth.flow_item" */
export type FlowItem_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth.flow_item" */
export type FlowItem_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  flowItemType?: InputMaybe<FlowItemType_Obj_Rel_Insert_Input>;
  flowItemTypeId?: InputMaybe<Scalars['uuid']>;
  flowType?: InputMaybe<FlowType_Obj_Rel_Insert_Input>;
  flowTypeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userFlowItems?: InputMaybe<UserFlowItem_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type FlowItem_Max_Fields = {
  __typename?: 'flowItem_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expiration_date?: Maybe<Scalars['date']>;
  flowItemTypeId?: Maybe<Scalars['uuid']>;
  flowTypeId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.flow_item" */
export type FlowItem_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  flowItemTypeId?: InputMaybe<Order_By>;
  flowTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type FlowItem_Min_Fields = {
  __typename?: 'flowItem_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expiration_date?: Maybe<Scalars['date']>;
  flowItemTypeId?: Maybe<Scalars['uuid']>;
  flowTypeId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.flow_item" */
export type FlowItem_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  flowItemTypeId?: InputMaybe<Order_By>;
  flowTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.flow_item" */
export type FlowItem_Mutation_Response = {
  __typename?: 'flowItem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FlowItem>;
};

/** input type for inserting object relation for remote table "auth.flow_item" */
export type FlowItem_Obj_Rel_Insert_Input = {
  data: FlowItem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FlowItem_On_Conflict>;
};

/** on_conflict condition type for table "auth.flow_item" */
export type FlowItem_On_Conflict = {
  constraint: FlowItem_Constraint;
  update_columns?: Array<FlowItem_Update_Column>;
  where?: InputMaybe<FlowItem_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.flow_item". */
export type FlowItem_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  flowItemType?: InputMaybe<FlowItemType_Order_By>;
  flowItemTypeId?: InputMaybe<Order_By>;
  flowType?: InputMaybe<FlowType_Order_By>;
  flowTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userFlowItems_aggregate?: InputMaybe<UserFlowItem_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.flow_item */
export type FlowItem_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.flow_item" */
export enum FlowItem_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  FlowItemTypeId = 'flowItemTypeId',
  /** column name */
  FlowTypeId = 'flowTypeId',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "auth.flow_item" */
export type FlowItem_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  flowItemTypeId?: InputMaybe<Scalars['uuid']>;
  flowTypeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type FlowItem_Stddev_Fields = {
  __typename?: 'flowItem_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "auth.flow_item" */
export type FlowItem_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type FlowItem_Stddev_Pop_Fields = {
  __typename?: 'flowItem_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "auth.flow_item" */
export type FlowItem_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type FlowItem_Stddev_Samp_Fields = {
  __typename?: 'flowItem_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "auth.flow_item" */
export type FlowItem_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "flowItem" */
export type FlowItem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FlowItem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FlowItem_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  flowItemTypeId?: InputMaybe<Scalars['uuid']>;
  flowTypeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type FlowItem_Sum_Fields = {
  __typename?: 'flowItem_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "auth.flow_item" */
export type FlowItem_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "auth.flow_item" */
export enum FlowItem_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  FlowItemTypeId = 'flowItemTypeId',
  /** column name */
  FlowTypeId = 'flowTypeId',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type FlowItem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FlowItem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FlowItem_Set_Input>;
  /** filter the rows which have to be updated */
  where: FlowItem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FlowItem_Var_Pop_Fields = {
  __typename?: 'flowItem_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "auth.flow_item" */
export type FlowItem_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type FlowItem_Var_Samp_Fields = {
  __typename?: 'flowItem_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "auth.flow_item" */
export type FlowItem_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type FlowItem_Variance_Fields = {
  __typename?: 'flowItem_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "auth.flow_item" */
export type FlowItem_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "auth.flow_type" */
export type FlowType = {
  __typename?: 'flowType';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  /** An array relationship */
  flowItems: Array<FlowItem>;
  /** An aggregate relationship */
  flowItems_aggregate: FlowItem_Aggregate;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
};


/** columns and relationships of "auth.flow_type" */
export type FlowTypeFlowItemsArgs = {
  distinct_on?: InputMaybe<Array<FlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItem_Order_By>>;
  where?: InputMaybe<FlowItem_Bool_Exp>;
};


/** columns and relationships of "auth.flow_type" */
export type FlowTypeFlowItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItem_Order_By>>;
  where?: InputMaybe<FlowItem_Bool_Exp>;
};

/** aggregated selection of "auth.flow_type" */
export type FlowType_Aggregate = {
  __typename?: 'flowType_aggregate';
  aggregate?: Maybe<FlowType_Aggregate_Fields>;
  nodes: Array<FlowType>;
};

/** aggregate fields of "auth.flow_type" */
export type FlowType_Aggregate_Fields = {
  __typename?: 'flowType_aggregate_fields';
  avg?: Maybe<FlowType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<FlowType_Max_Fields>;
  min?: Maybe<FlowType_Min_Fields>;
  stddev?: Maybe<FlowType_Stddev_Fields>;
  stddev_pop?: Maybe<FlowType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FlowType_Stddev_Samp_Fields>;
  sum?: Maybe<FlowType_Sum_Fields>;
  var_pop?: Maybe<FlowType_Var_Pop_Fields>;
  var_samp?: Maybe<FlowType_Var_Samp_Fields>;
  variance?: Maybe<FlowType_Variance_Fields>;
};


/** aggregate fields of "auth.flow_type" */
export type FlowType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FlowType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FlowType_Avg_Fields = {
  __typename?: 'flowType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "auth.flow_type". All fields are combined with a logical 'AND'. */
export type FlowType_Bool_Exp = {
  _and?: InputMaybe<Array<FlowType_Bool_Exp>>;
  _not?: InputMaybe<FlowType_Bool_Exp>;
  _or?: InputMaybe<Array<FlowType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  flowItems?: InputMaybe<FlowItem_Bool_Exp>;
  flowItems_aggregate?: InputMaybe<FlowItem_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.flow_type" */
export enum FlowType_Constraint {
  /** unique or primary key constraint on columns "display" */
  FlowTypeDisplayKey = 'flow_type_display_key',
  /** unique or primary key constraint on columns "enum_value" */
  FlowTypeEnumValueKey = 'flow_type_enum_value_key',
  /** unique or primary key constraint on columns "name" */
  FlowTypeNameKey = 'flow_type_name_key',
  /** unique or primary key constraint on columns "id" */
  FlowTypePkey = 'flow_type_pkey'
}

/** input type for incrementing numeric columns in table "auth.flow_type" */
export type FlowType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth.flow_type" */
export type FlowType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  flowItems?: InputMaybe<FlowItem_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FlowType_Max_Fields = {
  __typename?: 'flowType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FlowType_Min_Fields = {
  __typename?: 'flowType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth.flow_type" */
export type FlowType_Mutation_Response = {
  __typename?: 'flowType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FlowType>;
};

/** input type for inserting object relation for remote table "auth.flow_type" */
export type FlowType_Obj_Rel_Insert_Input = {
  data: FlowType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FlowType_On_Conflict>;
};

/** on_conflict condition type for table "auth.flow_type" */
export type FlowType_On_Conflict = {
  constraint: FlowType_Constraint;
  update_columns?: Array<FlowType_Update_Column>;
  where?: InputMaybe<FlowType_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.flow_type". */
export type FlowType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  flowItems_aggregate?: InputMaybe<FlowItem_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.flow_type */
export type FlowType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.flow_type" */
export enum FlowType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "auth.flow_type" */
export type FlowType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type FlowType_Stddev_Fields = {
  __typename?: 'flowType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FlowType_Stddev_Pop_Fields = {
  __typename?: 'flowType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FlowType_Stddev_Samp_Fields = {
  __typename?: 'flowType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "flowType" */
export type FlowType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FlowType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FlowType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type FlowType_Sum_Fields = {
  __typename?: 'flowType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "auth.flow_type" */
export enum FlowType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type FlowType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FlowType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FlowType_Set_Input>;
  /** filter the rows which have to be updated */
  where: FlowType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FlowType_Var_Pop_Fields = {
  __typename?: 'flowType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FlowType_Var_Samp_Fields = {
  __typename?: 'flowType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FlowType_Variance_Fields = {
  __typename?: 'flowType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "identities" */
export type Identities = {
  __typename?: 'identities';
  available_aal?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  metadata_admin?: Maybe<Scalars['jsonb']>;
  metadata_public?: Maybe<Scalars['jsonb']>;
  nid?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  schema_id: Scalars['String'];
  state: Scalars['String'];
  state_changed_at?: Maybe<Scalars['timestamp']>;
  traits: Scalars['jsonb'];
  updated_at: Scalars['timestamp'];
};


/** columns and relationships of "identities" */
export type IdentitiesMetadata_AdminArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "identities" */
export type IdentitiesMetadata_PublicArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "identities" */
export type IdentitiesTraitsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "identities" */
export type Identities_Aggregate = {
  __typename?: 'identities_aggregate';
  aggregate?: Maybe<Identities_Aggregate_Fields>;
  nodes: Array<Identities>;
};

/** aggregate fields of "identities" */
export type Identities_Aggregate_Fields = {
  __typename?: 'identities_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Identities_Max_Fields>;
  min?: Maybe<Identities_Min_Fields>;
};


/** aggregate fields of "identities" */
export type Identities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Identities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Identities_Append_Input = {
  metadata_admin?: InputMaybe<Scalars['jsonb']>;
  metadata_public?: InputMaybe<Scalars['jsonb']>;
  traits?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "identities". All fields are combined with a logical 'AND'. */
export type Identities_Bool_Exp = {
  _and?: InputMaybe<Array<Identities_Bool_Exp>>;
  _not?: InputMaybe<Identities_Bool_Exp>;
  _or?: InputMaybe<Array<Identities_Bool_Exp>>;
  available_aal?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata_admin?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata_public?: InputMaybe<Jsonb_Comparison_Exp>;
  nid?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  schema_id?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_changed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  traits?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "identities" */
export enum Identities_Constraint {
  /** unique or primary key constraint on columns "id" */
  IdentitiesPkey = 'identities_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Identities_Delete_At_Path_Input = {
  metadata_admin?: InputMaybe<Array<Scalars['String']>>;
  metadata_public?: InputMaybe<Array<Scalars['String']>>;
  traits?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Identities_Delete_Elem_Input = {
  metadata_admin?: InputMaybe<Scalars['Int']>;
  metadata_public?: InputMaybe<Scalars['Int']>;
  traits?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Identities_Delete_Key_Input = {
  metadata_admin?: InputMaybe<Scalars['String']>;
  metadata_public?: InputMaybe<Scalars['String']>;
  traits?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "identities" */
export type Identities_Insert_Input = {
  available_aal?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata_admin?: InputMaybe<Scalars['jsonb']>;
  metadata_public?: InputMaybe<Scalars['jsonb']>;
  nid?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  schema_id?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  state_changed_at?: InputMaybe<Scalars['timestamp']>;
  traits?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Identities_Max_Fields = {
  __typename?: 'identities_max_fields';
  available_aal?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  nid?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  schema_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_changed_at?: Maybe<Scalars['timestamp']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Identities_Min_Fields = {
  __typename?: 'identities_min_fields';
  available_aal?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  nid?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  schema_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_changed_at?: Maybe<Scalars['timestamp']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "identities" */
export type Identities_Mutation_Response = {
  __typename?: 'identities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Identities>;
};

/** on_conflict condition type for table "identities" */
export type Identities_On_Conflict = {
  constraint: Identities_Constraint;
  update_columns?: Array<Identities_Update_Column>;
  where?: InputMaybe<Identities_Bool_Exp>;
};

/** Ordering options when selecting data from "identities". */
export type Identities_Order_By = {
  available_aal?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata_admin?: InputMaybe<Order_By>;
  metadata_public?: InputMaybe<Order_By>;
  nid?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  schema_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_changed_at?: InputMaybe<Order_By>;
  traits?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: identities */
export type Identities_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Identities_Prepend_Input = {
  metadata_admin?: InputMaybe<Scalars['jsonb']>;
  metadata_public?: InputMaybe<Scalars['jsonb']>;
  traits?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "identities" */
export enum Identities_Select_Column {
  /** column name */
  AvailableAal = 'available_aal',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetadataAdmin = 'metadata_admin',
  /** column name */
  MetadataPublic = 'metadata_public',
  /** column name */
  Nid = 'nid',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  SchemaId = 'schema_id',
  /** column name */
  State = 'state',
  /** column name */
  StateChangedAt = 'state_changed_at',
  /** column name */
  Traits = 'traits',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "identities" */
export type Identities_Set_Input = {
  available_aal?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata_admin?: InputMaybe<Scalars['jsonb']>;
  metadata_public?: InputMaybe<Scalars['jsonb']>;
  nid?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  schema_id?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  state_changed_at?: InputMaybe<Scalars['timestamp']>;
  traits?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "identities" */
export type Identities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Identities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Identities_Stream_Cursor_Value_Input = {
  available_aal?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata_admin?: InputMaybe<Scalars['jsonb']>;
  metadata_public?: InputMaybe<Scalars['jsonb']>;
  nid?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  schema_id?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  state_changed_at?: InputMaybe<Scalars['timestamp']>;
  traits?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "identities" */
export enum Identities_Update_Column {
  /** column name */
  AvailableAal = 'available_aal',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetadataAdmin = 'metadata_admin',
  /** column name */
  MetadataPublic = 'metadata_public',
  /** column name */
  Nid = 'nid',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  SchemaId = 'schema_id',
  /** column name */
  State = 'state',
  /** column name */
  StateChangedAt = 'state_changed_at',
  /** column name */
  Traits = 'traits',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Identities_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Identities_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Identities_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Identities_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Identities_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Identities_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Identities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Identities_Bool_Exp;
};

/** columns and relationships of "ory.identity" */
export type Identity = {
  __typename?: 'identity';
  /** A computed field, executes function "ory.get_as400_username" */
  as400Username?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  email?: Maybe<Scalars['String']>;
  /** An array relationship */
  entityConfigurationItems: Array<EntityConfigurationItem>;
  /** An aggregate relationship */
  entityConfigurationItems_aggregate: EntityConfigurationItem_Aggregate;
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  identityEntities: Array<IdentityEntity>;
  /** An aggregate relationship */
  identityEntities_aggregate: IdentityEntity_Aggregate;
  /** An array relationship */
  identityEntityViews: Array<IdentityEntityView>;
  /** An aggregate relationship */
  identityEntityViews_aggregate: IdentityEntityView_Aggregate;
  /** An array relationship */
  identityFilters: Array<IdentityFilter>;
  /** An aggregate relationship */
  identityFilters_aggregate: IdentityFilter_Aggregate;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** An object relationship */
  profile?: Maybe<Profile>;
  /** An array relationship */
  repeatPartAcknowledgments: Array<RepeatPartAcknowledgment>;
  /** An aggregate relationship */
  repeatPartAcknowledgments_aggregate: RepeatPartAcknowledgment_Aggregate;
  role?: Maybe<Scalars['String']>;
  /** An object relationship */
  roleInfo?: Maybe<Role>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  userFlowItems: Array<UserFlowItem>;
  /** An aggregate relationship */
  userFlowItems_aggregate: UserFlowItem_Aggregate;
};


/** columns and relationships of "ory.identity" */
export type IdentityEntityConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityEntityConfigurationItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityIdentityEntitiesArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntity_Order_By>>;
  where?: InputMaybe<IdentityEntity_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityIdentityEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntity_Order_By>>;
  where?: InputMaybe<IdentityEntity_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityIdentityEntityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityIdentityEntityViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityIdentityFiltersArgs = {
  distinct_on?: InputMaybe<Array<IdentityFilter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityFilter_Order_By>>;
  where?: InputMaybe<IdentityFilter_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityIdentityFilters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityFilter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityFilter_Order_By>>;
  where?: InputMaybe<IdentityFilter_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityRepeatPartAcknowledgmentsArgs = {
  distinct_on?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatPartAcknowledgment_Order_By>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityRepeatPartAcknowledgments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatPartAcknowledgment_Order_By>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityUserFlowItemsArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItem_Order_By>>;
  where?: InputMaybe<UserFlowItem_Bool_Exp>;
};


/** columns and relationships of "ory.identity" */
export type IdentityUserFlowItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItem_Order_By>>;
  where?: InputMaybe<UserFlowItem_Bool_Exp>;
};

/** Maps an ory.identity to the hand-assigned legacy AS400 login username for that person. Read by ory.get_as400_username (consumed by the AS400 export stored procedures PolicyClaimExportToAS400 / ClaimPaymentToAS400 / CancellationExportToAS400 and the ory.identity.as400Username Hasura computed field) so claims/contracts/cancellations sync under the correct operator instead of a name-derived guess. Transitional crutch that exists only while the AS400 is live - drop it when the AS400 is retired. Only staff who enter/adjust AS400-synced work need a row; unmapped identities fall back to the name derivation. */
export type IdentityAs400 = {
  __typename?: 'identityAs400';
  /** The person's AS400 user profile name, used to stamp the operator columns CLENTB/CLUPDB/CTENTB/CTUPDB and the contract/cancellation equivalents. Not derivable - hand-assigned on the AS400 (e.g. mattj, march, antoinette). varchar(10) to match the AS400 field width (the downstream export temp tables use varchar(10)). Stored as-entered (mixed case); ory.get_as400_username uppercases it on read. */
  as400Username: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  identity: Identity;
  identityId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "ory.identity_as400" */
export type IdentityAs400_Aggregate = {
  __typename?: 'identityAs400_aggregate';
  aggregate?: Maybe<IdentityAs400_Aggregate_Fields>;
  nodes: Array<IdentityAs400>;
};

/** aggregate fields of "ory.identity_as400" */
export type IdentityAs400_Aggregate_Fields = {
  __typename?: 'identityAs400_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<IdentityAs400_Max_Fields>;
  min?: Maybe<IdentityAs400_Min_Fields>;
};


/** aggregate fields of "ory.identity_as400" */
export type IdentityAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IdentityAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ory.identity_as400". All fields are combined with a logical 'AND'. */
export type IdentityAs400_Bool_Exp = {
  _and?: InputMaybe<Array<IdentityAs400_Bool_Exp>>;
  _not?: InputMaybe<IdentityAs400_Bool_Exp>;
  _or?: InputMaybe<Array<IdentityAs400_Bool_Exp>>;
  as400Username?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ory.identity_as400" */
export enum IdentityAs400_Constraint {
  /** unique or primary key constraint on columns "identity_id" */
  IdentityAs400IdentityIdKey = 'identity_as400_identity_id_key',
  /** unique or primary key constraint on columns "id" */
  IdentityAs400Pkey = 'identity_as400_pkey'
}

/** input type for inserting data into table "ory.identity_as400" */
export type IdentityAs400_Insert_Input = {
  /** The person's AS400 user profile name, used to stamp the operator columns CLENTB/CLUPDB/CTENTB/CTUPDB and the contract/cancellation equivalents. Not derivable - hand-assigned on the AS400 (e.g. mattj, march, antoinette). varchar(10) to match the AS400 field width (the downstream export temp tables use varchar(10)). Stored as-entered (mixed case); ory.get_as400_username uppercases it on read. */
  as400Username?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  identityId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IdentityAs400_Max_Fields = {
  __typename?: 'identityAs400_max_fields';
  /** The person's AS400 user profile name, used to stamp the operator columns CLENTB/CLUPDB/CTENTB/CTUPDB and the contract/cancellation equivalents. Not derivable - hand-assigned on the AS400 (e.g. mattj, march, antoinette). varchar(10) to match the AS400 field width (the downstream export temp tables use varchar(10)). Stored as-entered (mixed case); ory.get_as400_username uppercases it on read. */
  as400Username?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type IdentityAs400_Min_Fields = {
  __typename?: 'identityAs400_min_fields';
  /** The person's AS400 user profile name, used to stamp the operator columns CLENTB/CLUPDB/CTENTB/CTUPDB and the contract/cancellation equivalents. Not derivable - hand-assigned on the AS400 (e.g. mattj, march, antoinette). varchar(10) to match the AS400 field width (the downstream export temp tables use varchar(10)). Stored as-entered (mixed case); ory.get_as400_username uppercases it on read. */
  as400Username?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "ory.identity_as400" */
export type IdentityAs400_Mutation_Response = {
  __typename?: 'identityAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IdentityAs400>;
};

/** on_conflict condition type for table "ory.identity_as400" */
export type IdentityAs400_On_Conflict = {
  constraint: IdentityAs400_Constraint;
  update_columns?: Array<IdentityAs400_Update_Column>;
  where?: InputMaybe<IdentityAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "ory.identity_as400". */
export type IdentityAs400_Order_By = {
  as400Username?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ory.identity_as400 */
export type IdentityAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ory.identity_as400" */
export enum IdentityAs400_Select_Column {
  /** column name */
  As400Username = 'as400Username',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "ory.identity_as400" */
export type IdentityAs400_Set_Input = {
  /** The person's AS400 user profile name, used to stamp the operator columns CLENTB/CLUPDB/CTENTB/CTUPDB and the contract/cancellation equivalents. Not derivable - hand-assigned on the AS400 (e.g. mattj, march, antoinette). varchar(10) to match the AS400 field width (the downstream export temp tables use varchar(10)). Stored as-entered (mixed case); ory.get_as400_username uppercases it on read. */
  as400Username?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "identityAs400" */
export type IdentityAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IdentityAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityAs400_Stream_Cursor_Value_Input = {
  /** The person's AS400 user profile name, used to stamp the operator columns CLENTB/CLUPDB/CTENTB/CTUPDB and the contract/cancellation equivalents. Not derivable - hand-assigned on the AS400 (e.g. mattj, march, antoinette). varchar(10) to match the AS400 field width (the downstream export temp tables use varchar(10)). Stored as-entered (mixed case); ory.get_as400_username uppercases it on read. */
  as400Username?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ory.identity_as400" */
export enum IdentityAs400_Update_Column {
  /** column name */
  As400Username = 'as400Username',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type IdentityAs400_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IdentityAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: IdentityAs400_Bool_Exp;
};

/** One person holds one Capability. This is the grant a manager makes and the checkbox they tick — the intent, which auth.identity_entity route rows are derived from rather than the reverse. Kept separate from identity_entity precisely because a table cannot be derived from itself. IT-6672. */
export type IdentityCapability = {
  __typename?: 'identityCapability';
  /** An object relationship */
  capability: Capability;
  /** The Capability held. */
  capabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** Date the grant starts applying. */
  effectiveDate: Scalars['date'];
  /** Date the grant stops applying; NULL means never. */
  expirationDate?: Maybe<Scalars['date']>;
  /** Who granted it, when a person did. NULL for grants made by a migration or system process, which carry no Hasura session. */
  grantedByIdentityId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  identity?: Maybe<Identity>;
  /** Logical ref to ory.identity(id) — who holds the Capability. Not a foreign key: ory is Kratos-owned. */
  identityId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** Capability grants currently in force, for Hasura permission expressions to traverse. Exists for the same reason auth.identity_entity_view does: a permission expression cannot call now(), so the date window is applied here. Read this, never auth.identity_capability directly, from a permission. IT-6672. */
export type IdentityCapabilityView = {
  __typename?: 'identityCapabilityView';
  /** An object relationship */
  capability?: Maybe<Capability>;
  capabilityId?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "auth.identity_capability_view" */
export type IdentityCapabilityView_Aggregate = {
  __typename?: 'identityCapabilityView_aggregate';
  aggregate?: Maybe<IdentityCapabilityView_Aggregate_Fields>;
  nodes: Array<IdentityCapabilityView>;
};

export type IdentityCapabilityView_Aggregate_Bool_Exp = {
  count?: InputMaybe<IdentityCapabilityView_Aggregate_Bool_Exp_Count>;
};

export type IdentityCapabilityView_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IdentityCapabilityView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdentityCapabilityView_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.identity_capability_view" */
export type IdentityCapabilityView_Aggregate_Fields = {
  __typename?: 'identityCapabilityView_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<IdentityCapabilityView_Max_Fields>;
  min?: Maybe<IdentityCapabilityView_Min_Fields>;
};


/** aggregate fields of "auth.identity_capability_view" */
export type IdentityCapabilityView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IdentityCapabilityView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.identity_capability_view" */
export type IdentityCapabilityView_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<IdentityCapabilityView_Max_Order_By>;
  min?: InputMaybe<IdentityCapabilityView_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "auth.identity_capability_view". All fields are combined with a logical 'AND'. */
export type IdentityCapabilityView_Bool_Exp = {
  _and?: InputMaybe<Array<IdentityCapabilityView_Bool_Exp>>;
  _not?: InputMaybe<IdentityCapabilityView_Bool_Exp>;
  _or?: InputMaybe<Array<IdentityCapabilityView_Bool_Exp>>;
  capability?: InputMaybe<Capability_Bool_Exp>;
  capabilityId?: InputMaybe<Uuid_Comparison_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "auth.identity_capability_view" */
export type IdentityCapabilityView_Insert_Input = {
  capability?: InputMaybe<Capability_Obj_Rel_Insert_Input>;
  capabilityId?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type IdentityCapabilityView_Max_Fields = {
  __typename?: 'identityCapabilityView_max_fields';
  capabilityId?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.identity_capability_view" */
export type IdentityCapabilityView_Max_Order_By = {
  capabilityId?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type IdentityCapabilityView_Min_Fields = {
  __typename?: 'identityCapabilityView_min_fields';
  capabilityId?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.identity_capability_view" */
export type IdentityCapabilityView_Min_Order_By = {
  capabilityId?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.identity_capability_view" */
export type IdentityCapabilityView_Mutation_Response = {
  __typename?: 'identityCapabilityView_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IdentityCapabilityView>;
};

/** Ordering options when selecting data from "auth.identity_capability_view". */
export type IdentityCapabilityView_Order_By = {
  capability?: InputMaybe<Capability_Order_By>;
  capabilityId?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
};

/** select columns of table "auth.identity_capability_view" */
export enum IdentityCapabilityView_Select_Column {
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  IdentityId = 'identityId'
}

/** input type for updating data in table "auth.identity_capability_view" */
export type IdentityCapabilityView_Set_Input = {
  capabilityId?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "identityCapabilityView" */
export type IdentityCapabilityView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IdentityCapabilityView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityCapabilityView_Stream_Cursor_Value_Input = {
  capabilityId?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
};

export type IdentityCapabilityView_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IdentityCapabilityView_Set_Input>;
  /** filter the rows which have to be updated */
  where: IdentityCapabilityView_Bool_Exp;
};

/** aggregated selection of "auth.identity_capability" */
export type IdentityCapability_Aggregate = {
  __typename?: 'identityCapability_aggregate';
  aggregate?: Maybe<IdentityCapability_Aggregate_Fields>;
  nodes: Array<IdentityCapability>;
};

export type IdentityCapability_Aggregate_Bool_Exp = {
  count?: InputMaybe<IdentityCapability_Aggregate_Bool_Exp_Count>;
};

export type IdentityCapability_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IdentityCapability_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdentityCapability_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.identity_capability" */
export type IdentityCapability_Aggregate_Fields = {
  __typename?: 'identityCapability_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<IdentityCapability_Max_Fields>;
  min?: Maybe<IdentityCapability_Min_Fields>;
};


/** aggregate fields of "auth.identity_capability" */
export type IdentityCapability_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IdentityCapability_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.identity_capability" */
export type IdentityCapability_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<IdentityCapability_Max_Order_By>;
  min?: InputMaybe<IdentityCapability_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.identity_capability" */
export type IdentityCapability_Arr_Rel_Insert_Input = {
  data: Array<IdentityCapability_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IdentityCapability_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.identity_capability". All fields are combined with a logical 'AND'. */
export type IdentityCapability_Bool_Exp = {
  _and?: InputMaybe<Array<IdentityCapability_Bool_Exp>>;
  _not?: InputMaybe<IdentityCapability_Bool_Exp>;
  _or?: InputMaybe<Array<IdentityCapability_Bool_Exp>>;
  capability?: InputMaybe<Capability_Bool_Exp>;
  capabilityId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  grantedByIdentityId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.identity_capability" */
export enum IdentityCapability_Constraint {
  /** unique or primary key constraint on columns "identity_id", "capability_id" */
  IdentityCapabilityIdentityIdCapabilityIdKey = 'identity_capability_identity_id_capability_id_key',
  /** unique or primary key constraint on columns "id" */
  IdentityCapabilityPkey = 'identity_capability_pkey'
}

/** input type for inserting data into table "auth.identity_capability" */
export type IdentityCapability_Insert_Input = {
  capability?: InputMaybe<Capability_Obj_Rel_Insert_Input>;
  /** The Capability held. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Date the grant starts applying. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** Date the grant stops applying; NULL means never. */
  expirationDate?: InputMaybe<Scalars['date']>;
  /** Who granted it, when a person did. NULL for grants made by a migration or system process, which carry no Hasura session. */
  grantedByIdentityId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  /** Logical ref to ory.identity(id) — who holds the Capability. Not a foreign key: ory is Kratos-owned. */
  identityId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IdentityCapability_Max_Fields = {
  __typename?: 'identityCapability_max_fields';
  /** The Capability held. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Date the grant starts applying. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** Date the grant stops applying; NULL means never. */
  expirationDate?: Maybe<Scalars['date']>;
  /** Who granted it, when a person did. NULL for grants made by a migration or system process, which carry no Hasura session. */
  grantedByIdentityId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Logical ref to ory.identity(id) — who holds the Capability. Not a foreign key: ory is Kratos-owned. */
  identityId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.identity_capability" */
export type IdentityCapability_Max_Order_By = {
  /** The Capability held. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** Date the grant starts applying. */
  effectiveDate?: InputMaybe<Order_By>;
  /** Date the grant stops applying; NULL means never. */
  expirationDate?: InputMaybe<Order_By>;
  /** Who granted it, when a person did. NULL for grants made by a migration or system process, which carry no Hasura session. */
  grantedByIdentityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Logical ref to ory.identity(id) — who holds the Capability. Not a foreign key: ory is Kratos-owned. */
  identityId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type IdentityCapability_Min_Fields = {
  __typename?: 'identityCapability_min_fields';
  /** The Capability held. */
  capabilityId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Date the grant starts applying. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** Date the grant stops applying; NULL means never. */
  expirationDate?: Maybe<Scalars['date']>;
  /** Who granted it, when a person did. NULL for grants made by a migration or system process, which carry no Hasura session. */
  grantedByIdentityId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Logical ref to ory.identity(id) — who holds the Capability. Not a foreign key: ory is Kratos-owned. */
  identityId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.identity_capability" */
export type IdentityCapability_Min_Order_By = {
  /** The Capability held. */
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  /** Date the grant starts applying. */
  effectiveDate?: InputMaybe<Order_By>;
  /** Date the grant stops applying; NULL means never. */
  expirationDate?: InputMaybe<Order_By>;
  /** Who granted it, when a person did. NULL for grants made by a migration or system process, which carry no Hasura session. */
  grantedByIdentityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Logical ref to ory.identity(id) — who holds the Capability. Not a foreign key: ory is Kratos-owned. */
  identityId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.identity_capability" */
export type IdentityCapability_Mutation_Response = {
  __typename?: 'identityCapability_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IdentityCapability>;
};

/** on_conflict condition type for table "auth.identity_capability" */
export type IdentityCapability_On_Conflict = {
  constraint: IdentityCapability_Constraint;
  update_columns?: Array<IdentityCapability_Update_Column>;
  where?: InputMaybe<IdentityCapability_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.identity_capability". */
export type IdentityCapability_Order_By = {
  capability?: InputMaybe<Capability_Order_By>;
  capabilityId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  grantedByIdentityId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.identity_capability */
export type IdentityCapability_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.identity_capability" */
export enum IdentityCapability_Select_Column {
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  GrantedByIdentityId = 'grantedByIdentityId',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.identity_capability" */
export type IdentityCapability_Set_Input = {
  /** The Capability held. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Date the grant starts applying. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** Date the grant stops applying; NULL means never. */
  expirationDate?: InputMaybe<Scalars['date']>;
  /** Who granted it, when a person did. NULL for grants made by a migration or system process, which carry no Hasura session. */
  grantedByIdentityId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Logical ref to ory.identity(id) — who holds the Capability. Not a foreign key: ory is Kratos-owned. */
  identityId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "identityCapability" */
export type IdentityCapability_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IdentityCapability_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityCapability_Stream_Cursor_Value_Input = {
  /** The Capability held. */
  capabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Date the grant starts applying. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** Date the grant stops applying; NULL means never. */
  expirationDate?: InputMaybe<Scalars['date']>;
  /** Who granted it, when a person did. NULL for grants made by a migration or system process, which carry no Hasura session. */
  grantedByIdentityId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Logical ref to ory.identity(id) — who holds the Capability. Not a foreign key: ory is Kratos-owned. */
  identityId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.identity_capability" */
export enum IdentityCapability_Update_Column {
  /** column name */
  CapabilityId = 'capabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  GrantedByIdentityId = 'grantedByIdentityId',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type IdentityCapability_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IdentityCapability_Set_Input>;
  /** filter the rows which have to be updated */
  where: IdentityCapability_Bool_Exp;
};

/** columns and relationships of "auth.identity_entity" */
export type IdentityEntity = {
  __typename?: 'identityEntity';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  accountManager?: Maybe<AccountManager>;
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  entityId: Scalars['uuid'];
  entityType?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['date']>;
  hasAccess: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  identity?: Maybe<Identity>;
  /** A computed field, executes function "auth.identity_entity_identity_display_name" */
  identityDisplay?: Maybe<Scalars['String']>;
  identityId: Scalars['uuid'];
  identityType?: Maybe<Scalars['String']>;
  isOwner: Scalars['Boolean'];
  /** A computed field, executes function "auth.identity_entity_last_updated_user" */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  /** An object relationship */
  legacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  /** An object relationship */
  role?: Maybe<Role>;
  /** An object relationship */
  route?: Maybe<Route>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "auth.identity_entity" */
export type IdentityEntityLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "auth.identity_entity" */
export type IdentityEntityLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** Entity access in force for an identity: rows held directly, plus the accounts an account manager reaches. A third branch, fanning a role-keyed row out to everyone holding that role, is dropped by §12b of 20260827_IT-6672.sql once it has materialised those into Capability grants — so on a database built from these migrations alone, role-keyed rows still grant. IT-6672. */
export type IdentityEntityView = {
  __typename?: 'identityEntityView';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  accountManager?: Maybe<AccountManager>;
  entityId?: Maybe<Scalars['uuid']>;
  hasAccess?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  identity?: Maybe<Identity>;
  /** An array relationship */
  identityEntityViewIdentityEntityView: Array<IdentityEntityView>;
  /** An aggregate relationship */
  identityEntityViewIdentityEntityView_aggregate: IdentityEntityView_Aggregate;
  identityId?: Maybe<Scalars['uuid']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  route?: Maybe<Route>;
};


/** Entity access in force for an identity: rows held directly, plus the accounts an account manager reaches. A third branch, fanning a role-keyed row out to everyone holding that role, is dropped by §12b of 20260827_IT-6672.sql once it has materialised those into Capability grants — so on a database built from these migrations alone, role-keyed rows still grant. IT-6672. */
export type IdentityEntityViewIdentityEntityViewIdentityEntityViewArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** Entity access in force for an identity: rows held directly, plus the accounts an account manager reaches. A third branch, fanning a role-keyed row out to everyone holding that role, is dropped by §12b of 20260827_IT-6672.sql once it has materialised those into Capability grants — so on a database built from these migrations alone, role-keyed rows still grant. IT-6672. */
export type IdentityEntityViewIdentityEntityViewIdentityEntityView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};

/** aggregated selection of "auth.identity_entity_view" */
export type IdentityEntityView_Aggregate = {
  __typename?: 'identityEntityView_aggregate';
  aggregate?: Maybe<IdentityEntityView_Aggregate_Fields>;
  nodes: Array<IdentityEntityView>;
};

export type IdentityEntityView_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<IdentityEntityView_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<IdentityEntityView_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<IdentityEntityView_Aggregate_Bool_Exp_Count>;
};

export type IdentityEntityView_Aggregate_Bool_Exp_Bool_And = {
  arguments: IdentityEntityView_Select_Column_IdentityEntityView_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdentityEntityView_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type IdentityEntityView_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IdentityEntityView_Select_Column_IdentityEntityView_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdentityEntityView_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type IdentityEntityView_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdentityEntityView_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.identity_entity_view" */
export type IdentityEntityView_Aggregate_Fields = {
  __typename?: 'identityEntityView_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<IdentityEntityView_Max_Fields>;
  min?: Maybe<IdentityEntityView_Min_Fields>;
};


/** aggregate fields of "auth.identity_entity_view" */
export type IdentityEntityView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.identity_entity_view" */
export type IdentityEntityView_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<IdentityEntityView_Max_Order_By>;
  min?: InputMaybe<IdentityEntityView_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.identity_entity_view" */
export type IdentityEntityView_Arr_Rel_Insert_Input = {
  data: Array<IdentityEntityView_Insert_Input>;
};

/** Boolean expression to filter rows from the table "auth.identity_entity_view". All fields are combined with a logical 'AND'. */
export type IdentityEntityView_Bool_Exp = {
  _and?: InputMaybe<Array<IdentityEntityView_Bool_Exp>>;
  _not?: InputMaybe<IdentityEntityView_Bool_Exp>;
  _or?: InputMaybe<Array<IdentityEntityView_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountManager?: InputMaybe<AccountManager_Bool_Exp>;
  entityId?: InputMaybe<Uuid_Comparison_Exp>;
  hasAccess?: InputMaybe<Boolean_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityEntityViewIdentityEntityView?: InputMaybe<IdentityEntityView_Bool_Exp>;
  identityEntityViewIdentityEntityView_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Bool_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  isOwner?: InputMaybe<Boolean_Comparison_Exp>;
  route?: InputMaybe<Route_Bool_Exp>;
};

/** input type for inserting data into table "auth.identity_entity_view" */
export type IdentityEntityView_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountManager?: InputMaybe<AccountManager_Obj_Rel_Insert_Input>;
  entityId?: InputMaybe<Scalars['uuid']>;
  hasAccess?: InputMaybe<Scalars['Boolean']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  identityEntityViewIdentityEntityView?: InputMaybe<IdentityEntityView_Arr_Rel_Insert_Input>;
  identityId?: InputMaybe<Scalars['uuid']>;
  isOwner?: InputMaybe<Scalars['Boolean']>;
  route?: InputMaybe<Route_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type IdentityEntityView_Max_Fields = {
  __typename?: 'identityEntityView_max_fields';
  entityId?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.identity_entity_view" */
export type IdentityEntityView_Max_Order_By = {
  entityId?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type IdentityEntityView_Min_Fields = {
  __typename?: 'identityEntityView_min_fields';
  entityId?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.identity_entity_view" */
export type IdentityEntityView_Min_Order_By = {
  entityId?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "auth.identity_entity_view". */
export type IdentityEntityView_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountManager?: InputMaybe<AccountManager_Order_By>;
  entityId?: InputMaybe<Order_By>;
  hasAccess?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityEntityViewIdentityEntityView_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Order_By>;
  identityId?: InputMaybe<Order_By>;
  isOwner?: InputMaybe<Order_By>;
  route?: InputMaybe<Route_Order_By>;
};

/** select columns of table "auth.identity_entity_view" */
export enum IdentityEntityView_Select_Column {
  /** column name */
  EntityId = 'entityId',
  /** column name */
  HasAccess = 'hasAccess',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  IsOwner = 'isOwner'
}

/** select "identityEntityView_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.identity_entity_view" */
export enum IdentityEntityView_Select_Column_IdentityEntityView_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasAccess = 'hasAccess',
  /** column name */
  IsOwner = 'isOwner'
}

/** select "identityEntityView_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.identity_entity_view" */
export enum IdentityEntityView_Select_Column_IdentityEntityView_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasAccess = 'hasAccess',
  /** column name */
  IsOwner = 'isOwner'
}

/** Streaming cursor of the table "identityEntityView" */
export type IdentityEntityView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IdentityEntityView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityEntityView_Stream_Cursor_Value_Input = {
  entityId?: InputMaybe<Scalars['uuid']>;
  hasAccess?: InputMaybe<Scalars['Boolean']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  isOwner?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "auth.identity_entity" */
export type IdentityEntity_Aggregate = {
  __typename?: 'identityEntity_aggregate';
  aggregate?: Maybe<IdentityEntity_Aggregate_Fields>;
  nodes: Array<IdentityEntity>;
};

export type IdentityEntity_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<IdentityEntity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<IdentityEntity_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<IdentityEntity_Aggregate_Bool_Exp_Count>;
};

export type IdentityEntity_Aggregate_Bool_Exp_Bool_And = {
  arguments: IdentityEntity_Select_Column_IdentityEntity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdentityEntity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type IdentityEntity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IdentityEntity_Select_Column_IdentityEntity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdentityEntity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type IdentityEntity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IdentityEntity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdentityEntity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.identity_entity" */
export type IdentityEntity_Aggregate_Fields = {
  __typename?: 'identityEntity_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<IdentityEntity_Max_Fields>;
  min?: Maybe<IdentityEntity_Min_Fields>;
};


/** aggregate fields of "auth.identity_entity" */
export type IdentityEntity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IdentityEntity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.identity_entity" */
export type IdentityEntity_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<IdentityEntity_Max_Order_By>;
  min?: InputMaybe<IdentityEntity_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.identity_entity" */
export type IdentityEntity_Arr_Rel_Insert_Input = {
  data: Array<IdentityEntity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IdentityEntity_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.identity_entity". All fields are combined with a logical 'AND'. */
export type IdentityEntity_Bool_Exp = {
  _and?: InputMaybe<Array<IdentityEntity_Bool_Exp>>;
  _not?: InputMaybe<IdentityEntity_Bool_Exp>;
  _or?: InputMaybe<Array<IdentityEntity_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountManager?: InputMaybe<AccountManager_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityId?: InputMaybe<Uuid_Comparison_Exp>;
  entityType?: InputMaybe<String_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  hasAccess?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityDisplay?: InputMaybe<String_Comparison_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  identityType?: InputMaybe<String_Comparison_Exp>;
  isOwner?: InputMaybe<Boolean_Comparison_Exp>;
  lastUpdatedBy?: InputMaybe<String_Comparison_Exp>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  role?: InputMaybe<Role_Bool_Exp>;
  route?: InputMaybe<Route_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.identity_entity" */
export enum IdentityEntity_Constraint {
  /** unique or primary key constraint on columns "id" */
  IdentityEntityPkey = 'identity_entity_pkey',
  /** unique or primary key constraint on columns "identity_id", "entity_id" */
  UniqueIdentityEntityPair = 'unique_identity_entity_pair'
}

/** input type for inserting data into table "auth.identity_entity" */
export type IdentityEntity_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountManager?: InputMaybe<AccountManager_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityId?: InputMaybe<Scalars['uuid']>;
  entityType?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  hasAccess?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  identityId?: InputMaybe<Scalars['uuid']>;
  identityType?: InputMaybe<Scalars['String']>;
  isOwner?: InputMaybe<Scalars['Boolean']>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Obj_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  role?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  route?: InputMaybe<Route_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IdentityEntity_Max_Fields = {
  __typename?: 'identityEntity_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  entityId?: Maybe<Scalars['uuid']>;
  entityType?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "auth.identity_entity_identity_display_name" */
  identityDisplay?: Maybe<Scalars['String']>;
  identityId?: Maybe<Scalars['uuid']>;
  identityType?: Maybe<Scalars['String']>;
  /** A computed field, executes function "auth.identity_entity_last_updated_user" */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.identity_entity" */
export type IdentityEntity_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  entityType?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  identityType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type IdentityEntity_Min_Fields = {
  __typename?: 'identityEntity_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  entityId?: Maybe<Scalars['uuid']>;
  entityType?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "auth.identity_entity_identity_display_name" */
  identityDisplay?: Maybe<Scalars['String']>;
  identityId?: Maybe<Scalars['uuid']>;
  identityType?: Maybe<Scalars['String']>;
  /** A computed field, executes function "auth.identity_entity_last_updated_user" */
  lastUpdatedBy?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.identity_entity" */
export type IdentityEntity_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  entityType?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  identityType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.identity_entity" */
export type IdentityEntity_Mutation_Response = {
  __typename?: 'identityEntity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IdentityEntity>;
};

/** on_conflict condition type for table "auth.identity_entity" */
export type IdentityEntity_On_Conflict = {
  constraint: IdentityEntity_Constraint;
  update_columns?: Array<IdentityEntity_Update_Column>;
  where?: InputMaybe<IdentityEntity_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.identity_entity". */
export type IdentityEntity_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountManager?: InputMaybe<AccountManager_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  entityType?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  hasAccess?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityDisplay?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  identityType?: InputMaybe<Order_By>;
  isOwner?: InputMaybe<Order_By>;
  lastUpdatedBy?: InputMaybe<Order_By>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  role?: InputMaybe<Role_Order_By>;
  route?: InputMaybe<Route_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.identity_entity */
export type IdentityEntity_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.identity_entity" */
export enum IdentityEntity_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  HasAccess = 'hasAccess',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  IdentityType = 'identityType',
  /** column name */
  IsOwner = 'isOwner',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "identityEntity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.identity_entity" */
export enum IdentityEntity_Select_Column_IdentityEntity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasAccess = 'hasAccess',
  /** column name */
  IsOwner = 'isOwner'
}

/** select "identityEntity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.identity_entity" */
export enum IdentityEntity_Select_Column_IdentityEntity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasAccess = 'hasAccess',
  /** column name */
  IsOwner = 'isOwner'
}

/** input type for updating data in table "auth.identity_entity" */
export type IdentityEntity_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityId?: InputMaybe<Scalars['uuid']>;
  entityType?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  hasAccess?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  identityType?: InputMaybe<Scalars['String']>;
  isOwner?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "identityEntity" */
export type IdentityEntity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IdentityEntity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityEntity_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityId?: InputMaybe<Scalars['uuid']>;
  entityType?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  hasAccess?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  identityType?: InputMaybe<Scalars['String']>;
  isOwner?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.identity_entity" */
export enum IdentityEntity_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  HasAccess = 'hasAccess',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  IdentityType = 'identityType',
  /** column name */
  IsOwner = 'isOwner',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type IdentityEntity_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IdentityEntity_Set_Input>;
  /** filter the rows which have to be updated */
  where: IdentityEntity_Bool_Exp;
};

/** columns and relationships of "auth.identity_filter" */
export type IdentityFilter = {
  __typename?: 'identityFilter';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  identity: Identity;
  identityId: Scalars['uuid'];
  name: Scalars['String'];
  queryParams?: Maybe<Scalars['String']>;
  /** An object relationship */
  route: Route;
  routeId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "auth.identity_filter" */
export type IdentityFilter_Aggregate = {
  __typename?: 'identityFilter_aggregate';
  aggregate?: Maybe<IdentityFilter_Aggregate_Fields>;
  nodes: Array<IdentityFilter>;
};

export type IdentityFilter_Aggregate_Bool_Exp = {
  count?: InputMaybe<IdentityFilter_Aggregate_Bool_Exp_Count>;
};

export type IdentityFilter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IdentityFilter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdentityFilter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.identity_filter" */
export type IdentityFilter_Aggregate_Fields = {
  __typename?: 'identityFilter_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<IdentityFilter_Max_Fields>;
  min?: Maybe<IdentityFilter_Min_Fields>;
};


/** aggregate fields of "auth.identity_filter" */
export type IdentityFilter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IdentityFilter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.identity_filter" */
export type IdentityFilter_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<IdentityFilter_Max_Order_By>;
  min?: InputMaybe<IdentityFilter_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.identity_filter" */
export type IdentityFilter_Arr_Rel_Insert_Input = {
  data: Array<IdentityFilter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IdentityFilter_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.identity_filter". All fields are combined with a logical 'AND'. */
export type IdentityFilter_Bool_Exp = {
  _and?: InputMaybe<Array<IdentityFilter_Bool_Exp>>;
  _not?: InputMaybe<IdentityFilter_Bool_Exp>;
  _or?: InputMaybe<Array<IdentityFilter_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  queryParams?: InputMaybe<String_Comparison_Exp>;
  route?: InputMaybe<Route_Bool_Exp>;
  routeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.identity_filter" */
export enum IdentityFilter_Constraint {
  /** unique or primary key constraint on columns "id" */
  IdentityFilterPkey = 'identity_filter_pkey'
}

/** input type for inserting data into table "auth.identity_filter" */
export type IdentityFilter_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  identityId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  queryParams?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Route_Obj_Rel_Insert_Input>;
  routeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IdentityFilter_Max_Fields = {
  __typename?: 'identityFilter_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  queryParams?: Maybe<Scalars['String']>;
  routeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.identity_filter" */
export type IdentityFilter_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  queryParams?: InputMaybe<Order_By>;
  routeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type IdentityFilter_Min_Fields = {
  __typename?: 'identityFilter_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  queryParams?: Maybe<Scalars['String']>;
  routeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.identity_filter" */
export type IdentityFilter_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  queryParams?: InputMaybe<Order_By>;
  routeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.identity_filter" */
export type IdentityFilter_Mutation_Response = {
  __typename?: 'identityFilter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IdentityFilter>;
};

/** on_conflict condition type for table "auth.identity_filter" */
export type IdentityFilter_On_Conflict = {
  constraint: IdentityFilter_Constraint;
  update_columns?: Array<IdentityFilter_Update_Column>;
  where?: InputMaybe<IdentityFilter_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.identity_filter". */
export type IdentityFilter_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  queryParams?: InputMaybe<Order_By>;
  route?: InputMaybe<Route_Order_By>;
  routeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.identity_filter */
export type IdentityFilter_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.identity_filter" */
export enum IdentityFilter_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  Name = 'name',
  /** column name */
  QueryParams = 'queryParams',
  /** column name */
  RouteId = 'routeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.identity_filter" */
export type IdentityFilter_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  queryParams?: InputMaybe<Scalars['String']>;
  routeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "identityFilter" */
export type IdentityFilter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IdentityFilter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityFilter_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  queryParams?: InputMaybe<Scalars['String']>;
  routeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.identity_filter" */
export enum IdentityFilter_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  Name = 'name',
  /** column name */
  QueryParams = 'queryParams',
  /** column name */
  RouteId = 'routeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type IdentityFilter_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IdentityFilter_Set_Input>;
  /** filter the rows which have to be updated */
  where: IdentityFilter_Bool_Exp;
};

/** aggregated selection of "ory.identity" */
export type Identity_Aggregate = {
  __typename?: 'identity_aggregate';
  aggregate?: Maybe<Identity_Aggregate_Fields>;
  nodes: Array<Identity>;
};

export type Identity_Aggregate_Bool_Exp = {
  count?: InputMaybe<Identity_Aggregate_Bool_Exp_Count>;
};

export type Identity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Identity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Identity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ory.identity" */
export type Identity_Aggregate_Fields = {
  __typename?: 'identity_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Identity_Max_Fields>;
  min?: Maybe<Identity_Min_Fields>;
};


/** aggregate fields of "ory.identity" */
export type Identity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Identity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ory.identity" */
export type Identity_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Identity_Max_Order_By>;
  min?: InputMaybe<Identity_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ory.identity" */
export type Identity_Arr_Rel_Insert_Input = {
  data: Array<Identity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Identity_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ory.identity". All fields are combined with a logical 'AND'. */
export type Identity_Bool_Exp = {
  _and?: InputMaybe<Array<Identity_Bool_Exp>>;
  _not?: InputMaybe<Identity_Bool_Exp>;
  _or?: InputMaybe<Array<Identity_Bool_Exp>>;
  as400Username?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Bool_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityEntities?: InputMaybe<IdentityEntity_Bool_Exp>;
  identityEntities_aggregate?: InputMaybe<IdentityEntity_Aggregate_Bool_Exp>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Bool_Exp>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Bool_Exp>;
  identityFilters?: InputMaybe<IdentityFilter_Bool_Exp>;
  identityFilters_aggregate?: InputMaybe<IdentityFilter_Aggregate_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  repeatPartAcknowledgments?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
  repeatPartAcknowledgments_aggregate?: InputMaybe<RepeatPartAcknowledgment_Aggregate_Bool_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  roleInfo?: InputMaybe<Role_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  userFlowItems?: InputMaybe<UserFlowItem_Bool_Exp>;
  userFlowItems_aggregate?: InputMaybe<UserFlowItem_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "ory.identity" */
export enum Identity_Constraint {
  /** unique or primary key constraint on columns "id" */
  IdentityPkey = 'identity_pkey'
}

/** input type for inserting data into table "ory.identity" */
export type Identity_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Arr_Rel_Insert_Input>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  identityEntities?: InputMaybe<IdentityEntity_Arr_Rel_Insert_Input>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Arr_Rel_Insert_Input>;
  identityFilters?: InputMaybe<IdentityFilter_Arr_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  repeatPartAcknowledgments?: InputMaybe<RepeatPartAcknowledgment_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Scalars['String']>;
  roleInfo?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  userFlowItems?: InputMaybe<UserFlowItem_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Identity_Max_Fields = {
  __typename?: 'identity_max_fields';
  /** A computed field, executes function "ory.get_as400_username" */
  as400Username?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "ory.identity" */
export type Identity_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Identity_Min_Fields = {
  __typename?: 'identity_min_fields';
  /** A computed field, executes function "ory.get_as400_username" */
  as400Username?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "ory.identity" */
export type Identity_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ory.identity" */
export type Identity_Mutation_Response = {
  __typename?: 'identity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Identity>;
};

/** input type for inserting object relation for remote table "ory.identity" */
export type Identity_Obj_Rel_Insert_Input = {
  data: Identity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Identity_On_Conflict>;
};

/** on_conflict condition type for table "ory.identity" */
export type Identity_On_Conflict = {
  constraint: Identity_Constraint;
  update_columns?: Array<Identity_Update_Column>;
  where?: InputMaybe<Identity_Bool_Exp>;
};

/** Ordering options when selecting data from "ory.identity". */
export type Identity_Order_By = {
  as400Username?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  identityEntities_aggregate?: InputMaybe<IdentityEntity_Aggregate_Order_By>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Order_By>;
  identityFilters_aggregate?: InputMaybe<IdentityFilter_Aggregate_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  repeatPartAcknowledgments_aggregate?: InputMaybe<RepeatPartAcknowledgment_Aggregate_Order_By>;
  role?: InputMaybe<Order_By>;
  roleInfo?: InputMaybe<Role_Order_By>;
  state?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userFlowItems_aggregate?: InputMaybe<UserFlowItem_Aggregate_Order_By>;
};

/** primary key columns input for table: ory.identity */
export type Identity_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ory.identity" */
export enum Identity_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Role = 'role',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "ory.identity" */
export type Identity_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "identity" */
export type Identity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Identity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Identity_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "ory.identity" */
export enum Identity_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Role = 'role',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Identity_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Identity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Identity_Bool_Exp;
};

/** Boolean expression to compare columns of type "inet". All fields are combined with logical 'AND'. */
export type Inet_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['inet']>;
  _gt?: InputMaybe<Scalars['inet']>;
  _gte?: InputMaybe<Scalars['inet']>;
  _in?: InputMaybe<Array<Scalars['inet']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['inet']>;
  _lte?: InputMaybe<Scalars['inet']>;
  _neq?: InputMaybe<Scalars['inet']>;
  _nin?: InputMaybe<Array<Scalars['inet']>>;
};

export type InvestigationRecall_Aggregate_Bool_Exp = {
  count?: InputMaybe<InvestigationRecall_Aggregate_Bool_Exp_Count>;
};

export type InvestigationRecall_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<InvestigationRecall_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "nhtsa.investigation_recall" */
export type InvestigationRecall_Aggregate_Fields_Nhtsa = {
  __typename?: 'investigationRecall_aggregate_fields_nhtsa';
  count: Scalars['Int'];
  max?: Maybe<InvestigationRecall_Max_Fields_Nhtsa>;
  min?: Maybe<InvestigationRecall_Min_Fields_Nhtsa>;
};


/** aggregate fields of "nhtsa.investigation_recall" */
export type InvestigationRecall_Aggregate_Fields_NhtsaCountArgs = {
  columns?: InputMaybe<Array<InvestigationRecall_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "nhtsa.investigation_recall" */
export type InvestigationRecall_Aggregate_Nhtsa = {
  __typename?: 'investigationRecall_aggregate_nhtsa';
  aggregate?: Maybe<InvestigationRecall_Aggregate_Fields_Nhtsa>;
  nodes: Array<InvestigationRecall_Nhtsa>;
};

/** order by aggregate values of table "nhtsa.investigation_recall" */
export type InvestigationRecall_Aggregate_Order_By_Nhtsa = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<InvestigationRecall_Max_Order_By_Nhtsa>;
  min?: InputMaybe<InvestigationRecall_Min_Order_By_Nhtsa>;
};

/** input type for inserting array relation for remote table "nhtsa.investigation_recall" */
export type InvestigationRecall_Arr_Rel_Insert_Input_Nhtsa = {
  data: Array<InvestigationRecall_Insert_Input_Nhtsa>;
  /** upsert condition */
  on_conflict?: InputMaybe<InvestigationRecall_On_Conflict_Nhtsa>;
};

/** Boolean expression to filter rows from the table "nhtsa.investigation_recall". All fields are combined with a logical 'AND'. */
export type InvestigationRecall_Bool_Exp_Nhtsa = {
  _and?: InputMaybe<Array<InvestigationRecall_Bool_Exp_Nhtsa>>;
  _not?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
  _or?: InputMaybe<Array<InvestigationRecall_Bool_Exp_Nhtsa>>;
  investigation?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
  investigationIssueId?: InputMaybe<String_Comparison_Exp>;
  recall?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
  recallIssueId?: InputMaybe<String_Comparison_Exp>;
  recallNumber?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "nhtsa.investigation_recall" */
export enum InvestigationRecall_Constraint_Nhtsa {
  /** unique or primary key constraint on columns "recall_number", "investigation_issue_id" */
  InvestigationRecallPkey = 'investigation_recall_pkey'
}

/** input type for inserting data into table "nhtsa.investigation_recall" */
export type InvestigationRecall_Insert_Input_Nhtsa = {
  investigation?: InputMaybe<Issue_Obj_Rel_Insert_Input_Nhtsa>;
  investigationIssueId?: InputMaybe<Scalars['String']>;
  recall?: InputMaybe<Issue_Obj_Rel_Insert_Input_Nhtsa>;
  /** nhtsa.issue.id of that recall. Null when the recall files do not carry it. */
  recallIssueId?: InputMaybe<Scalars['String']>;
  /** The NHTSA recall campaign number, padded to its nine-character form when FLAT_INV gives six (19V014 -> 19V014000). */
  recallNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type InvestigationRecall_Max_Fields_Nhtsa = {
  __typename?: 'investigationRecall_max_fields_nhtsa';
  investigationIssueId?: Maybe<Scalars['String']>;
  /** nhtsa.issue.id of that recall. Null when the recall files do not carry it. */
  recallIssueId?: Maybe<Scalars['String']>;
  /** The NHTSA recall campaign number, padded to its nine-character form when FLAT_INV gives six (19V014 -> 19V014000). */
  recallNumber?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "nhtsa.investigation_recall" */
export type InvestigationRecall_Max_Order_By_Nhtsa = {
  investigationIssueId?: InputMaybe<Order_By>;
  /** nhtsa.issue.id of that recall. Null when the recall files do not carry it. */
  recallIssueId?: InputMaybe<Order_By>;
  /** The NHTSA recall campaign number, padded to its nine-character form when FLAT_INV gives six (19V014 -> 19V014000). */
  recallNumber?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type InvestigationRecall_Min_Fields_Nhtsa = {
  __typename?: 'investigationRecall_min_fields_nhtsa';
  investigationIssueId?: Maybe<Scalars['String']>;
  /** nhtsa.issue.id of that recall. Null when the recall files do not carry it. */
  recallIssueId?: Maybe<Scalars['String']>;
  /** The NHTSA recall campaign number, padded to its nine-character form when FLAT_INV gives six (19V014 -> 19V014000). */
  recallNumber?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "nhtsa.investigation_recall" */
export type InvestigationRecall_Min_Order_By_Nhtsa = {
  investigationIssueId?: InputMaybe<Order_By>;
  /** nhtsa.issue.id of that recall. Null when the recall files do not carry it. */
  recallIssueId?: InputMaybe<Order_By>;
  /** The NHTSA recall campaign number, padded to its nine-character form when FLAT_INV gives six (19V014 -> 19V014000). */
  recallNumber?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "nhtsa.investigation_recall" */
export type InvestigationRecall_Mutation_Response_Nhtsa = {
  __typename?: 'investigationRecall_mutation_response_nhtsa';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvestigationRecall_Nhtsa>;
};

/** The recalls an investigation led to. FLAT_INV repeats an investigation's vehicle rows once per recall campaign, so one investigation can name many (the Takata investigation EA15001 names 194). */
export type InvestigationRecall_Nhtsa = {
  __typename?: 'investigationRecall_nhtsa';
  /** An object relationship */
  investigation?: Maybe<Issue_Nhtsa>;
  investigationIssueId: Scalars['String'];
  /** An object relationship */
  recall?: Maybe<Issue_Nhtsa>;
  /** nhtsa.issue.id of that recall. Null when the recall files do not carry it. */
  recallIssueId?: Maybe<Scalars['String']>;
  /** The NHTSA recall campaign number, padded to its nine-character form when FLAT_INV gives six (19V014 -> 19V014000). */
  recallNumber: Scalars['String'];
};

/** on_conflict condition type for table "nhtsa.investigation_recall" */
export type InvestigationRecall_On_Conflict_Nhtsa = {
  constraint: InvestigationRecall_Constraint_Nhtsa;
  update_columns?: Array<InvestigationRecall_Update_Column_Nhtsa>;
  where?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
};

/** Ordering options when selecting data from "nhtsa.investigation_recall". */
export type InvestigationRecall_Order_By_Nhtsa = {
  investigation?: InputMaybe<Issue_Order_By_Nhtsa>;
  investigationIssueId?: InputMaybe<Order_By>;
  recall?: InputMaybe<Issue_Order_By_Nhtsa>;
  recallIssueId?: InputMaybe<Order_By>;
  recallNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nhtsa.investigation_recall */
export type InvestigationRecall_Pk_Columns_Input_Nhtsa = {
  investigationIssueId: Scalars['String'];
  /** The NHTSA recall campaign number, padded to its nine-character form when FLAT_INV gives six (19V014 -> 19V014000). */
  recallNumber: Scalars['String'];
};

/** select columns of table "nhtsa.investigation_recall" */
export enum InvestigationRecall_Select_Column_Nhtsa {
  /** column name */
  InvestigationIssueId = 'investigationIssueId',
  /** column name */
  RecallIssueId = 'recallIssueId',
  /** column name */
  RecallNumber = 'recallNumber'
}

/** input type for updating data in table "nhtsa.investigation_recall" */
export type InvestigationRecall_Set_Input_Nhtsa = {
  investigationIssueId?: InputMaybe<Scalars['String']>;
  /** nhtsa.issue.id of that recall. Null when the recall files do not carry it. */
  recallIssueId?: InputMaybe<Scalars['String']>;
  /** The NHTSA recall campaign number, padded to its nine-character form when FLAT_INV gives six (19V014 -> 19V014000). */
  recallNumber?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "investigationRecall" */
export type InvestigationRecall_Stream_Cursor_Input_Nhtsa = {
  /** Stream column input with initial value */
  initial_value: InvestigationRecall_Stream_Cursor_Value_Input_Nhtsa;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Nhtsa>;
};

/** Initial value of the column from where the streaming should start */
export type InvestigationRecall_Stream_Cursor_Value_Input_Nhtsa = {
  investigationIssueId?: InputMaybe<Scalars['String']>;
  /** nhtsa.issue.id of that recall. Null when the recall files do not carry it. */
  recallIssueId?: InputMaybe<Scalars['String']>;
  /** The NHTSA recall campaign number, padded to its nine-character form when FLAT_INV gives six (19V014 -> 19V014000). */
  recallNumber?: InputMaybe<Scalars['String']>;
};

/** update columns of table "nhtsa.investigation_recall" */
export enum InvestigationRecall_Update_Column_Nhtsa {
  /** column name */
  InvestigationIssueId = 'investigationIssueId',
  /** column name */
  RecallIssueId = 'recallIssueId',
  /** column name */
  RecallNumber = 'recallNumber'
}

export type InvestigationRecall_Updates_Nhtsa = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvestigationRecall_Set_Input_Nhtsa>;
  /** filter the rows which have to be updated */
  where: InvestigationRecall_Bool_Exp_Nhtsa;
};

/** columns and relationships of "claims.invoice" */
export type Invoice = {
  __typename?: 'invoice';
  assignedEmployeeUserId?: Maybe<Scalars['String']>;
  claimNumber?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  contractNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  customerName?: Maybe<Scalars['String']>;
  dashboardAlertTimestamp?: Maybe<Scalars['timestamptz']>;
  displayColorStyle?: Maybe<Scalars['String']>;
  /** An array relationship */
  entityFileStorages: Array<EntityFileStorage>;
  /** An aggregate relationship */
  entityFileStorages_aggregate: EntityFileStorage_Aggregate;
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  invoiceDocumentType?: Maybe<InvoiceDocumentType>;
  invoiceDocumentTypeId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoicePaymentType?: Maybe<InvoicePaymentType>;
  invoicePaymentTypeId?: Maybe<Scalars['uuid']>;
  tempOriginalFileId?: Maybe<Scalars['uuid']>;
  unlockTimestamp?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  vin?: Maybe<Scalars['String']>;
  workflowStateTimestamp: Scalars['timestamptz'];
  /** An object relationship */
  workflowStateType: WorkflowStateType;
  workflowStateTypeId: Scalars['uuid'];
};


/** columns and relationships of "claims.invoice" */
export type InvoiceEntityFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** columns and relationships of "claims.invoice" */
export type InvoiceEntityFileStorages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** columns and relationships of "claims.invoice" */
export type InvoiceEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "claims.invoice" */
export type InvoiceEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};

/** columns and relationships of "claims.invoice_document_type" */
export type InvoiceDocumentType = {
  __typename?: 'invoiceDocumentType';
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "claims.invoice_document_type" */
export type InvoiceDocumentType_Aggregate = {
  __typename?: 'invoiceDocumentType_aggregate';
  aggregate?: Maybe<InvoiceDocumentType_Aggregate_Fields>;
  nodes: Array<InvoiceDocumentType>;
};

/** aggregate fields of "claims.invoice_document_type" */
export type InvoiceDocumentType_Aggregate_Fields = {
  __typename?: 'invoiceDocumentType_aggregate_fields';
  avg?: Maybe<InvoiceDocumentType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<InvoiceDocumentType_Max_Fields>;
  min?: Maybe<InvoiceDocumentType_Min_Fields>;
  stddev?: Maybe<InvoiceDocumentType_Stddev_Fields>;
  stddev_pop?: Maybe<InvoiceDocumentType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<InvoiceDocumentType_Stddev_Samp_Fields>;
  sum?: Maybe<InvoiceDocumentType_Sum_Fields>;
  var_pop?: Maybe<InvoiceDocumentType_Var_Pop_Fields>;
  var_samp?: Maybe<InvoiceDocumentType_Var_Samp_Fields>;
  variance?: Maybe<InvoiceDocumentType_Variance_Fields>;
};


/** aggregate fields of "claims.invoice_document_type" */
export type InvoiceDocumentType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceDocumentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type InvoiceDocumentType_Avg_Fields = {
  __typename?: 'invoiceDocumentType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "claims.invoice_document_type". All fields are combined with a logical 'AND'. */
export type InvoiceDocumentType_Bool_Exp = {
  _and?: InputMaybe<Array<InvoiceDocumentType_Bool_Exp>>;
  _not?: InputMaybe<InvoiceDocumentType_Bool_Exp>;
  _or?: InputMaybe<Array<InvoiceDocumentType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.invoice_document_type" */
export enum InvoiceDocumentType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  InvoiceDocumentTypeEnumValueKey = 'invoice_document_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  InvoiceDocumentTypePkey = 'invoice_document_type_pkey'
}

/** input type for incrementing numeric columns in table "claims.invoice_document_type" */
export type InvoiceDocumentType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "claims.invoice_document_type" */
export type InvoiceDocumentType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoiceDocumentType_Max_Fields = {
  __typename?: 'invoiceDocumentType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type InvoiceDocumentType_Min_Fields = {
  __typename?: 'invoiceDocumentType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.invoice_document_type" */
export type InvoiceDocumentType_Mutation_Response = {
  __typename?: 'invoiceDocumentType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoiceDocumentType>;
};

/** input type for inserting object relation for remote table "claims.invoice_document_type" */
export type InvoiceDocumentType_Obj_Rel_Insert_Input = {
  data: InvoiceDocumentType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<InvoiceDocumentType_On_Conflict>;
};

/** on_conflict condition type for table "claims.invoice_document_type" */
export type InvoiceDocumentType_On_Conflict = {
  constraint: InvoiceDocumentType_Constraint;
  update_columns?: Array<InvoiceDocumentType_Update_Column>;
  where?: InputMaybe<InvoiceDocumentType_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.invoice_document_type". */
export type InvoiceDocumentType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.invoice_document_type */
export type InvoiceDocumentType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.invoice_document_type" */
export enum InvoiceDocumentType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.invoice_document_type" */
export type InvoiceDocumentType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type InvoiceDocumentType_Stddev_Fields = {
  __typename?: 'invoiceDocumentType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type InvoiceDocumentType_Stddev_Pop_Fields = {
  __typename?: 'invoiceDocumentType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type InvoiceDocumentType_Stddev_Samp_Fields = {
  __typename?: 'invoiceDocumentType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "invoiceDocumentType" */
export type InvoiceDocumentType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: InvoiceDocumentType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceDocumentType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type InvoiceDocumentType_Sum_Fields = {
  __typename?: 'invoiceDocumentType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "claims.invoice_document_type" */
export enum InvoiceDocumentType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type InvoiceDocumentType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoiceDocumentType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoiceDocumentType_Set_Input>;
  /** filter the rows which have to be updated */
  where: InvoiceDocumentType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type InvoiceDocumentType_Var_Pop_Fields = {
  __typename?: 'invoiceDocumentType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type InvoiceDocumentType_Var_Samp_Fields = {
  __typename?: 'invoiceDocumentType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type InvoiceDocumentType_Variance_Fields = {
  __typename?: 'invoiceDocumentType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "claims.invoice_payment_type" */
export type InvoicePaymentType = {
  __typename?: 'invoicePaymentType';
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "claims.invoice_payment_type" */
export type InvoicePaymentType_Aggregate = {
  __typename?: 'invoicePaymentType_aggregate';
  aggregate?: Maybe<InvoicePaymentType_Aggregate_Fields>;
  nodes: Array<InvoicePaymentType>;
};

/** aggregate fields of "claims.invoice_payment_type" */
export type InvoicePaymentType_Aggregate_Fields = {
  __typename?: 'invoicePaymentType_aggregate_fields';
  avg?: Maybe<InvoicePaymentType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<InvoicePaymentType_Max_Fields>;
  min?: Maybe<InvoicePaymentType_Min_Fields>;
  stddev?: Maybe<InvoicePaymentType_Stddev_Fields>;
  stddev_pop?: Maybe<InvoicePaymentType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<InvoicePaymentType_Stddev_Samp_Fields>;
  sum?: Maybe<InvoicePaymentType_Sum_Fields>;
  var_pop?: Maybe<InvoicePaymentType_Var_Pop_Fields>;
  var_samp?: Maybe<InvoicePaymentType_Var_Samp_Fields>;
  variance?: Maybe<InvoicePaymentType_Variance_Fields>;
};


/** aggregate fields of "claims.invoice_payment_type" */
export type InvoicePaymentType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<InvoicePaymentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type InvoicePaymentType_Avg_Fields = {
  __typename?: 'invoicePaymentType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "claims.invoice_payment_type". All fields are combined with a logical 'AND'. */
export type InvoicePaymentType_Bool_Exp = {
  _and?: InputMaybe<Array<InvoicePaymentType_Bool_Exp>>;
  _not?: InputMaybe<InvoicePaymentType_Bool_Exp>;
  _or?: InputMaybe<Array<InvoicePaymentType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.invoice_payment_type" */
export enum InvoicePaymentType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  InvoicePaymentTypeEnumValueKey = 'invoice_payment_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  InvoicePaymentTypePkey = 'invoice_payment_type_pkey'
}

/** input type for incrementing numeric columns in table "claims.invoice_payment_type" */
export type InvoicePaymentType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "claims.invoice_payment_type" */
export type InvoicePaymentType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoicePaymentType_Max_Fields = {
  __typename?: 'invoicePaymentType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type InvoicePaymentType_Min_Fields = {
  __typename?: 'invoicePaymentType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.invoice_payment_type" */
export type InvoicePaymentType_Mutation_Response = {
  __typename?: 'invoicePaymentType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoicePaymentType>;
};

/** input type for inserting object relation for remote table "claims.invoice_payment_type" */
export type InvoicePaymentType_Obj_Rel_Insert_Input = {
  data: InvoicePaymentType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<InvoicePaymentType_On_Conflict>;
};

/** on_conflict condition type for table "claims.invoice_payment_type" */
export type InvoicePaymentType_On_Conflict = {
  constraint: InvoicePaymentType_Constraint;
  update_columns?: Array<InvoicePaymentType_Update_Column>;
  where?: InputMaybe<InvoicePaymentType_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.invoice_payment_type". */
export type InvoicePaymentType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.invoice_payment_type */
export type InvoicePaymentType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.invoice_payment_type" */
export enum InvoicePaymentType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.invoice_payment_type" */
export type InvoicePaymentType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type InvoicePaymentType_Stddev_Fields = {
  __typename?: 'invoicePaymentType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type InvoicePaymentType_Stddev_Pop_Fields = {
  __typename?: 'invoicePaymentType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type InvoicePaymentType_Stddev_Samp_Fields = {
  __typename?: 'invoicePaymentType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "invoicePaymentType" */
export type InvoicePaymentType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: InvoicePaymentType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicePaymentType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type InvoicePaymentType_Sum_Fields = {
  __typename?: 'invoicePaymentType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "claims.invoice_payment_type" */
export enum InvoicePaymentType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type InvoicePaymentType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoicePaymentType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoicePaymentType_Set_Input>;
  /** filter the rows which have to be updated */
  where: InvoicePaymentType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type InvoicePaymentType_Var_Pop_Fields = {
  __typename?: 'invoicePaymentType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type InvoicePaymentType_Var_Samp_Fields = {
  __typename?: 'invoicePaymentType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type InvoicePaymentType_Variance_Fields = {
  __typename?: 'invoicePaymentType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "claims.invoice" */
export type Invoice_Aggregate = {
  __typename?: 'invoice_aggregate';
  aggregate?: Maybe<Invoice_Aggregate_Fields>;
  nodes: Array<Invoice>;
};

/** aggregate fields of "claims.invoice" */
export type Invoice_Aggregate_Fields = {
  __typename?: 'invoice_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invoice_Max_Fields>;
  min?: Maybe<Invoice_Min_Fields>;
};


/** aggregate fields of "claims.invoice" */
export type Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.invoice". All fields are combined with a logical 'AND'. */
export type Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Bool_Exp>>;
  assignedEmployeeUserId?: InputMaybe<String_Comparison_Exp>;
  claimNumber?: InputMaybe<String_Comparison_Exp>;
  compositeKey?: InputMaybe<String_Comparison_Exp>;
  contractNumber?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customerName?: InputMaybe<String_Comparison_Exp>;
  dashboardAlertTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  displayColorStyle?: InputMaybe<String_Comparison_Exp>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Bool_Exp>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Bool_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiceDocumentType?: InputMaybe<InvoiceDocumentType_Bool_Exp>;
  invoiceDocumentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  invoicePaymentType?: InputMaybe<InvoicePaymentType_Bool_Exp>;
  invoicePaymentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  tempOriginalFileId?: InputMaybe<Uuid_Comparison_Exp>;
  unlockTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vin?: InputMaybe<String_Comparison_Exp>;
  workflowStateTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  workflowStateType?: InputMaybe<WorkflowStateType_Bool_Exp>;
  workflowStateTypeId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.invoice" */
export enum Invoice_Constraint {
  /** unique or primary key constraint on columns "id" */
  InvoicePkey = 'invoice_pkey'
}

/** input type for inserting data into table "claims.invoice" */
export type Invoice_Insert_Input = {
  assignedEmployeeUserId?: InputMaybe<Scalars['String']>;
  claimNumber?: InputMaybe<Scalars['String']>;
  compositeKey?: InputMaybe<Scalars['String']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerName?: InputMaybe<Scalars['String']>;
  dashboardAlertTimestamp?: InputMaybe<Scalars['timestamptz']>;
  displayColorStyle?: InputMaybe<Scalars['String']>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Arr_Rel_Insert_Input>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  invoiceDocumentType?: InputMaybe<InvoiceDocumentType_Obj_Rel_Insert_Input>;
  invoiceDocumentTypeId?: InputMaybe<Scalars['uuid']>;
  invoicePaymentType?: InputMaybe<InvoicePaymentType_Obj_Rel_Insert_Input>;
  invoicePaymentTypeId?: InputMaybe<Scalars['uuid']>;
  tempOriginalFileId?: InputMaybe<Scalars['uuid']>;
  unlockTimestamp?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vin?: InputMaybe<Scalars['String']>;
  workflowStateTimestamp?: InputMaybe<Scalars['timestamptz']>;
  workflowStateType?: InputMaybe<WorkflowStateType_Obj_Rel_Insert_Input>;
  workflowStateTypeId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Invoice_Max_Fields = {
  __typename?: 'invoice_max_fields';
  assignedEmployeeUserId?: Maybe<Scalars['String']>;
  claimNumber?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  contractNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerName?: Maybe<Scalars['String']>;
  dashboardAlertTimestamp?: Maybe<Scalars['timestamptz']>;
  displayColorStyle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceDocumentTypeId?: Maybe<Scalars['uuid']>;
  invoicePaymentTypeId?: Maybe<Scalars['uuid']>;
  tempOriginalFileId?: Maybe<Scalars['uuid']>;
  unlockTimestamp?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vin?: Maybe<Scalars['String']>;
  workflowStateTimestamp?: Maybe<Scalars['timestamptz']>;
  workflowStateTypeId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Invoice_Min_Fields = {
  __typename?: 'invoice_min_fields';
  assignedEmployeeUserId?: Maybe<Scalars['String']>;
  claimNumber?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  contractNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerName?: Maybe<Scalars['String']>;
  dashboardAlertTimestamp?: Maybe<Scalars['timestamptz']>;
  displayColorStyle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceDocumentTypeId?: Maybe<Scalars['uuid']>;
  invoicePaymentTypeId?: Maybe<Scalars['uuid']>;
  tempOriginalFileId?: Maybe<Scalars['uuid']>;
  unlockTimestamp?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vin?: Maybe<Scalars['String']>;
  workflowStateTimestamp?: Maybe<Scalars['timestamptz']>;
  workflowStateTypeId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "claims.invoice" */
export type Invoice_Mutation_Response = {
  __typename?: 'invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice>;
};

/** on_conflict condition type for table "claims.invoice" */
export type Invoice_On_Conflict = {
  constraint: Invoice_Constraint;
  update_columns?: Array<Invoice_Update_Column>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.invoice". */
export type Invoice_Order_By = {
  assignedEmployeeUserId?: InputMaybe<Order_By>;
  claimNumber?: InputMaybe<Order_By>;
  compositeKey?: InputMaybe<Order_By>;
  contractNumber?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customerName?: InputMaybe<Order_By>;
  dashboardAlertTimestamp?: InputMaybe<Order_By>;
  displayColorStyle?: InputMaybe<Order_By>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceDocumentType?: InputMaybe<InvoiceDocumentType_Order_By>;
  invoiceDocumentTypeId?: InputMaybe<Order_By>;
  invoicePaymentType?: InputMaybe<InvoicePaymentType_Order_By>;
  invoicePaymentTypeId?: InputMaybe<Order_By>;
  tempOriginalFileId?: InputMaybe<Order_By>;
  unlockTimestamp?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vin?: InputMaybe<Order_By>;
  workflowStateTimestamp?: InputMaybe<Order_By>;
  workflowStateType?: InputMaybe<WorkflowStateType_Order_By>;
  workflowStateTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.invoice */
export type Invoice_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.invoice" */
export enum Invoice_Select_Column {
  /** column name */
  AssignedEmployeeUserId = 'assignedEmployeeUserId',
  /** column name */
  ClaimNumber = 'claimNumber',
  /** column name */
  CompositeKey = 'compositeKey',
  /** column name */
  ContractNumber = 'contractNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerName = 'customerName',
  /** column name */
  DashboardAlertTimestamp = 'dashboardAlertTimestamp',
  /** column name */
  DisplayColorStyle = 'displayColorStyle',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceDocumentTypeId = 'invoiceDocumentTypeId',
  /** column name */
  InvoicePaymentTypeId = 'invoicePaymentTypeId',
  /** column name */
  TempOriginalFileId = 'tempOriginalFileId',
  /** column name */
  UnlockTimestamp = 'unlockTimestamp',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Vin = 'vin',
  /** column name */
  WorkflowStateTimestamp = 'workflowStateTimestamp',
  /** column name */
  WorkflowStateTypeId = 'workflowStateTypeId'
}

/** input type for updating data in table "claims.invoice" */
export type Invoice_Set_Input = {
  assignedEmployeeUserId?: InputMaybe<Scalars['String']>;
  claimNumber?: InputMaybe<Scalars['String']>;
  compositeKey?: InputMaybe<Scalars['String']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerName?: InputMaybe<Scalars['String']>;
  dashboardAlertTimestamp?: InputMaybe<Scalars['timestamptz']>;
  displayColorStyle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoiceDocumentTypeId?: InputMaybe<Scalars['uuid']>;
  invoicePaymentTypeId?: InputMaybe<Scalars['uuid']>;
  tempOriginalFileId?: InputMaybe<Scalars['uuid']>;
  unlockTimestamp?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vin?: InputMaybe<Scalars['String']>;
  workflowStateTimestamp?: InputMaybe<Scalars['timestamptz']>;
  workflowStateTypeId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "invoice" */
export type Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Stream_Cursor_Value_Input = {
  assignedEmployeeUserId?: InputMaybe<Scalars['String']>;
  claimNumber?: InputMaybe<Scalars['String']>;
  compositeKey?: InputMaybe<Scalars['String']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerName?: InputMaybe<Scalars['String']>;
  dashboardAlertTimestamp?: InputMaybe<Scalars['timestamptz']>;
  displayColorStyle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoiceDocumentTypeId?: InputMaybe<Scalars['uuid']>;
  invoicePaymentTypeId?: InputMaybe<Scalars['uuid']>;
  tempOriginalFileId?: InputMaybe<Scalars['uuid']>;
  unlockTimestamp?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vin?: InputMaybe<Scalars['String']>;
  workflowStateTimestamp?: InputMaybe<Scalars['timestamptz']>;
  workflowStateTypeId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "claims.invoice" */
export enum Invoice_Update_Column {
  /** column name */
  AssignedEmployeeUserId = 'assignedEmployeeUserId',
  /** column name */
  ClaimNumber = 'claimNumber',
  /** column name */
  CompositeKey = 'compositeKey',
  /** column name */
  ContractNumber = 'contractNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerName = 'customerName',
  /** column name */
  DashboardAlertTimestamp = 'dashboardAlertTimestamp',
  /** column name */
  DisplayColorStyle = 'displayColorStyle',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceDocumentTypeId = 'invoiceDocumentTypeId',
  /** column name */
  InvoicePaymentTypeId = 'invoicePaymentTypeId',
  /** column name */
  TempOriginalFileId = 'tempOriginalFileId',
  /** column name */
  UnlockTimestamp = 'unlockTimestamp',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Vin = 'vin',
  /** column name */
  WorkflowStateTimestamp = 'workflowStateTimestamp',
  /** column name */
  WorkflowStateTypeId = 'workflowStateTypeId'
}

export type Invoice_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Bool_Exp;
};

export type IssueMakeModel_Aggregate_Bool_Exp = {
  count?: InputMaybe<IssueMakeModel_Aggregate_Bool_Exp_Count>;
};

export type IssueMakeModel_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IssueMakeModel_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "nhtsa.issue_make_model" */
export type IssueMakeModel_Aggregate_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_aggregate_fields_nhtsa';
  avg?: Maybe<IssueMakeModel_Avg_Fields_Nhtsa>;
  count: Scalars['Int'];
  max?: Maybe<IssueMakeModel_Max_Fields_Nhtsa>;
  min?: Maybe<IssueMakeModel_Min_Fields_Nhtsa>;
  stddev?: Maybe<IssueMakeModel_Stddev_Fields_Nhtsa>;
  stddev_pop?: Maybe<IssueMakeModel_Stddev_Pop_Fields_Nhtsa>;
  stddev_samp?: Maybe<IssueMakeModel_Stddev_Samp_Fields_Nhtsa>;
  sum?: Maybe<IssueMakeModel_Sum_Fields_Nhtsa>;
  var_pop?: Maybe<IssueMakeModel_Var_Pop_Fields_Nhtsa>;
  var_samp?: Maybe<IssueMakeModel_Var_Samp_Fields_Nhtsa>;
  variance?: Maybe<IssueMakeModel_Variance_Fields_Nhtsa>;
};


/** aggregate fields of "nhtsa.issue_make_model" */
export type IssueMakeModel_Aggregate_Fields_NhtsaCountArgs = {
  columns?: InputMaybe<Array<IssueMakeModel_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "nhtsa.issue_make_model" */
export type IssueMakeModel_Aggregate_Nhtsa = {
  __typename?: 'issueMakeModel_aggregate_nhtsa';
  aggregate?: Maybe<IssueMakeModel_Aggregate_Fields_Nhtsa>;
  nodes: Array<IssueMakeModel_Nhtsa>;
};

/** order by aggregate values of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Aggregate_Order_By_Nhtsa = {
  avg?: InputMaybe<IssueMakeModel_Avg_Order_By_Nhtsa>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<IssueMakeModel_Max_Order_By_Nhtsa>;
  min?: InputMaybe<IssueMakeModel_Min_Order_By_Nhtsa>;
  stddev?: InputMaybe<IssueMakeModel_Stddev_Order_By_Nhtsa>;
  stddev_pop?: InputMaybe<IssueMakeModel_Stddev_Pop_Order_By_Nhtsa>;
  stddev_samp?: InputMaybe<IssueMakeModel_Stddev_Samp_Order_By_Nhtsa>;
  sum?: InputMaybe<IssueMakeModel_Sum_Order_By_Nhtsa>;
  var_pop?: InputMaybe<IssueMakeModel_Var_Pop_Order_By_Nhtsa>;
  var_samp?: InputMaybe<IssueMakeModel_Var_Samp_Order_By_Nhtsa>;
  variance?: InputMaybe<IssueMakeModel_Variance_Order_By_Nhtsa>;
};

/** input type for inserting array relation for remote table "nhtsa.issue_make_model" */
export type IssueMakeModel_Arr_Rel_Insert_Input_Nhtsa = {
  data: Array<IssueMakeModel_Insert_Input_Nhtsa>;
  /** upsert condition */
  on_conflict?: InputMaybe<IssueMakeModel_On_Conflict_Nhtsa>;
};

/** aggregate avg on columns */
export type IssueMakeModel_Avg_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_avg_fields_nhtsa';
  makeModelId?: Maybe<Scalars['Float']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Avg_Order_By_Nhtsa = {
  makeModelId?: InputMaybe<Order_By>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nhtsa.issue_make_model". All fields are combined with a logical 'AND'. */
export type IssueMakeModel_Bool_Exp_Nhtsa = {
  _and?: InputMaybe<Array<IssueMakeModel_Bool_Exp_Nhtsa>>;
  _not?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
  _or?: InputMaybe<Array<IssueMakeModel_Bool_Exp_Nhtsa>>;
  issue?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
  issueId?: InputMaybe<String_Comparison_Exp>;
  makeModel?: InputMaybe<MakeModel_Bool_Exp_Nhtsa>;
  makeModelId?: InputMaybe<Int_Comparison_Exp>;
  modelYear?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "nhtsa.issue_make_model" */
export enum IssueMakeModel_Constraint_Nhtsa {
  /** unique or primary key constraint on columns "model_year", "issue_id", "make_model_id" */
  IssueMakeModelIssueIdMakeModelIdModelYearKey = 'issue_make_model_issue_id_make_model_id_model_year_key'
}

/** input type for incrementing numeric columns in table "nhtsa.issue_make_model" */
export type IssueMakeModel_Inc_Input_Nhtsa = {
  makeModelId?: InputMaybe<Scalars['Int']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nhtsa.issue_make_model" */
export type IssueMakeModel_Insert_Input_Nhtsa = {
  issue?: InputMaybe<Issue_Obj_Rel_Insert_Input_Nhtsa>;
  issueId?: InputMaybe<Scalars['String']>;
  makeModel?: InputMaybe<MakeModel_Obj_Rel_Insert_Input_Nhtsa>;
  makeModelId?: InputMaybe<Scalars['Int']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type IssueMakeModel_Max_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_max_fields_nhtsa';
  issueId?: Maybe<Scalars['String']>;
  makeModelId?: Maybe<Scalars['Int']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Max_Order_By_Nhtsa = {
  issueId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type IssueMakeModel_Min_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_min_fields_nhtsa';
  issueId?: Maybe<Scalars['String']>;
  makeModelId?: Maybe<Scalars['Int']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Min_Order_By_Nhtsa = {
  issueId?: InputMaybe<Order_By>;
  makeModelId?: InputMaybe<Order_By>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "nhtsa.issue_make_model" */
export type IssueMakeModel_Mutation_Response_Nhtsa = {
  __typename?: 'issueMakeModel_mutation_response_nhtsa';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IssueMakeModel_Nhtsa>;
};

/** The vehicles (or equipment) an issue lists. */
export type IssueMakeModel_Nhtsa = {
  __typename?: 'issueMakeModel_nhtsa';
  /** An object relationship */
  issue?: Maybe<Issue_Nhtsa>;
  issueId: Scalars['String'];
  /** An object relationship */
  makeModel?: Maybe<MakeModel_Nhtsa>;
  makeModelId: Scalars['Int'];
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Int']>;
};

/** on_conflict condition type for table "nhtsa.issue_make_model" */
export type IssueMakeModel_On_Conflict_Nhtsa = {
  constraint: IssueMakeModel_Constraint_Nhtsa;
  update_columns?: Array<IssueMakeModel_Update_Column_Nhtsa>;
  where?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
};

/** Ordering options when selecting data from "nhtsa.issue_make_model". */
export type IssueMakeModel_Order_By_Nhtsa = {
  issue?: InputMaybe<Issue_Order_By_Nhtsa>;
  issueId?: InputMaybe<Order_By>;
  makeModel?: InputMaybe<MakeModel_Order_By_Nhtsa>;
  makeModelId?: InputMaybe<Order_By>;
  modelYear?: InputMaybe<Order_By>;
};

/** select columns of table "nhtsa.issue_make_model" */
export enum IssueMakeModel_Select_Column_Nhtsa {
  /** column name */
  IssueId = 'issueId',
  /** column name */
  MakeModelId = 'makeModelId',
  /** column name */
  ModelYear = 'modelYear'
}

/** input type for updating data in table "nhtsa.issue_make_model" */
export type IssueMakeModel_Set_Input_Nhtsa = {
  issueId?: InputMaybe<Scalars['String']>;
  makeModelId?: InputMaybe<Scalars['Int']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type IssueMakeModel_Stddev_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_stddev_fields_nhtsa';
  makeModelId?: Maybe<Scalars['Float']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Stddev_Order_By_Nhtsa = {
  makeModelId?: InputMaybe<Order_By>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type IssueMakeModel_Stddev_Pop_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_stddev_pop_fields_nhtsa';
  makeModelId?: Maybe<Scalars['Float']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Stddev_Pop_Order_By_Nhtsa = {
  makeModelId?: InputMaybe<Order_By>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type IssueMakeModel_Stddev_Samp_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_stddev_samp_fields_nhtsa';
  makeModelId?: Maybe<Scalars['Float']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Stddev_Samp_Order_By_Nhtsa = {
  makeModelId?: InputMaybe<Order_By>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "issueMakeModel" */
export type IssueMakeModel_Stream_Cursor_Input_Nhtsa = {
  /** Stream column input with initial value */
  initial_value: IssueMakeModel_Stream_Cursor_Value_Input_Nhtsa;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Nhtsa>;
};

/** Initial value of the column from where the streaming should start */
export type IssueMakeModel_Stream_Cursor_Value_Input_Nhtsa = {
  issueId?: InputMaybe<Scalars['String']>;
  makeModelId?: InputMaybe<Scalars['Int']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type IssueMakeModel_Sum_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_sum_fields_nhtsa';
  makeModelId?: Maybe<Scalars['Int']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Sum_Order_By_Nhtsa = {
  makeModelId?: InputMaybe<Order_By>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Order_By>;
};

/** update columns of table "nhtsa.issue_make_model" */
export enum IssueMakeModel_Update_Column_Nhtsa {
  /** column name */
  IssueId = 'issueId',
  /** column name */
  MakeModelId = 'makeModelId',
  /** column name */
  ModelYear = 'modelYear'
}

export type IssueMakeModel_Updates_Nhtsa = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IssueMakeModel_Inc_Input_Nhtsa>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IssueMakeModel_Set_Input_Nhtsa>;
  /** filter the rows which have to be updated */
  where: IssueMakeModel_Bool_Exp_Nhtsa;
};

/** aggregate var_pop on columns */
export type IssueMakeModel_Var_Pop_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_var_pop_fields_nhtsa';
  makeModelId?: Maybe<Scalars['Float']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Var_Pop_Order_By_Nhtsa = {
  makeModelId?: InputMaybe<Order_By>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type IssueMakeModel_Var_Samp_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_var_samp_fields_nhtsa';
  makeModelId?: Maybe<Scalars['Float']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Var_Samp_Order_By_Nhtsa = {
  makeModelId?: InputMaybe<Order_By>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type IssueMakeModel_Variance_Fields_Nhtsa = {
  __typename?: 'issueMakeModel_variance_fields_nhtsa';
  makeModelId?: Maybe<Scalars['Float']>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nhtsa.issue_make_model" */
export type IssueMakeModel_Variance_Order_By_Nhtsa = {
  makeModelId?: InputMaybe<Order_By>;
  /** Null where NHTSA files 9999 (unknown or not applicable: most tire, child seat and equipment rows). Such rows never match a vehicle search and are found by keyword only. */
  modelYear?: InputMaybe<Order_By>;
};

/** aggregate fields of "nhtsa.issue_search_result" */
export type IssueSearchResult_Aggregate_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_aggregate_fields_nhtsa';
  avg?: Maybe<IssueSearchResult_Avg_Fields_Nhtsa>;
  count: Scalars['Int'];
  max?: Maybe<IssueSearchResult_Max_Fields_Nhtsa>;
  min?: Maybe<IssueSearchResult_Min_Fields_Nhtsa>;
  stddev?: Maybe<IssueSearchResult_Stddev_Fields_Nhtsa>;
  stddev_pop?: Maybe<IssueSearchResult_Stddev_Pop_Fields_Nhtsa>;
  stddev_samp?: Maybe<IssueSearchResult_Stddev_Samp_Fields_Nhtsa>;
  sum?: Maybe<IssueSearchResult_Sum_Fields_Nhtsa>;
  var_pop?: Maybe<IssueSearchResult_Var_Pop_Fields_Nhtsa>;
  var_samp?: Maybe<IssueSearchResult_Var_Samp_Fields_Nhtsa>;
  variance?: Maybe<IssueSearchResult_Variance_Fields_Nhtsa>;
};


/** aggregate fields of "nhtsa.issue_search_result" */
export type IssueSearchResult_Aggregate_Fields_NhtsaCountArgs = {
  columns?: InputMaybe<Array<IssueSearchResult_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

export type IssueSearchResult_Aggregate_Nhtsa = {
  __typename?: 'issueSearchResult_aggregate_nhtsa';
  aggregate?: Maybe<IssueSearchResult_Aggregate_Fields_Nhtsa>;
  nodes: Array<IssueSearchResult_Nhtsa>;
};

/** aggregate avg on columns */
export type IssueSearchResult_Avg_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_avg_fields_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: Maybe<Scalars['Float']>;
  concernRank?: Maybe<Scalars['Float']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: Maybe<Scalars['Float']>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nhtsa.issue_search_result". All fields are combined with a logical 'AND'. */
export type IssueSearchResult_Bool_Exp_Nhtsa = {
  _and?: InputMaybe<Array<IssueSearchResult_Bool_Exp_Nhtsa>>;
  _not?: InputMaybe<IssueSearchResult_Bool_Exp_Nhtsa>;
  _or?: InputMaybe<Array<IssueSearchResult_Bool_Exp_Nhtsa>>;
  conceptCount?: InputMaybe<Int_Comparison_Exp>;
  concernRank?: InputMaybe<Float_Comparison_Exp>;
  isVehicleMatch?: InputMaybe<Boolean_Comparison_Exp>;
  issue?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
  issueId?: InputMaybe<String_Comparison_Exp>;
  matchedConceptCount?: InputMaybe<Int_Comparison_Exp>;
  matchedModels?: InputMaybe<String_Array_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "nhtsa.issue_search_result" */
export type IssueSearchResult_Inc_Input_Nhtsa = {
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: InputMaybe<Scalars['Int']>;
  concernRank?: InputMaybe<Scalars['Float']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: InputMaybe<Scalars['Int']>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nhtsa.issue_search_result" */
export type IssueSearchResult_Insert_Input_Nhtsa = {
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: InputMaybe<Scalars['Int']>;
  concernRank?: InputMaybe<Scalars['Float']>;
  isVehicleMatch?: InputMaybe<Scalars['Boolean']>;
  issue?: InputMaybe<Issue_Obj_Rel_Insert_Input_Nhtsa>;
  issueId?: InputMaybe<Scalars['String']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: InputMaybe<Scalars['Int']>;
  /** The NHTSA model spellings the searched vehicle matched for this issue. Null for a keyword-only search. */
  matchedModels?: InputMaybe<Array<Scalars['String']>>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type IssueSearchResult_Max_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_max_fields_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: Maybe<Scalars['Int']>;
  concernRank?: Maybe<Scalars['Float']>;
  issueId?: Maybe<Scalars['String']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: Maybe<Scalars['Int']>;
  /** The NHTSA model spellings the searched vehicle matched for this issue. Null for a keyword-only search. */
  matchedModels?: Maybe<Array<Scalars['String']>>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type IssueSearchResult_Min_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_min_fields_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: Maybe<Scalars['Int']>;
  concernRank?: Maybe<Scalars['Float']>;
  issueId?: Maybe<Scalars['String']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: Maybe<Scalars['Int']>;
  /** The NHTSA model spellings the searched vehicle matched for this issue. Null for a keyword-only search. */
  matchedModels?: Maybe<Array<Scalars['String']>>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "nhtsa.issue_search_result" */
export type IssueSearchResult_Mutation_Response_Nhtsa = {
  __typename?: 'issueSearchResult_mutation_response_nhtsa';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IssueSearchResult_Nhtsa>;
};

/** Row shape returned by nhtsa.search_issues. Never holds rows; it exists so Hasura can track the function. */
export type IssueSearchResult_Nhtsa = {
  __typename?: 'issueSearchResult_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount: Scalars['Int'];
  concernRank: Scalars['Float'];
  isVehicleMatch: Scalars['Boolean'];
  /** An object relationship */
  issue?: Maybe<Issue_Nhtsa>;
  issueId: Scalars['String'];
  /** How many of them this issue's text matches. */
  matchedConceptCount: Scalars['Int'];
  /** The NHTSA model spellings the searched vehicle matched for this issue. Null for a keyword-only search. */
  matchedModels?: Maybe<Array<Scalars['String']>>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder: Scalars['Int'];
};

/** Ordering options when selecting data from "nhtsa.issue_search_result". */
export type IssueSearchResult_Order_By_Nhtsa = {
  conceptCount?: InputMaybe<Order_By>;
  concernRank?: InputMaybe<Order_By>;
  isVehicleMatch?: InputMaybe<Order_By>;
  issue?: InputMaybe<Issue_Order_By_Nhtsa>;
  issueId?: InputMaybe<Order_By>;
  matchedConceptCount?: InputMaybe<Order_By>;
  matchedModels?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
};

/** select columns of table "nhtsa.issue_search_result" */
export enum IssueSearchResult_Select_Column_Nhtsa {
  /** column name */
  ConceptCount = 'conceptCount',
  /** column name */
  ConcernRank = 'concernRank',
  /** column name */
  IsVehicleMatch = 'isVehicleMatch',
  /** column name */
  IssueId = 'issueId',
  /** column name */
  MatchedConceptCount = 'matchedConceptCount',
  /** column name */
  MatchedModels = 'matchedModels',
  /** column name */
  SortOrder = 'sortOrder'
}

/** input type for updating data in table "nhtsa.issue_search_result" */
export type IssueSearchResult_Set_Input_Nhtsa = {
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: InputMaybe<Scalars['Int']>;
  concernRank?: InputMaybe<Scalars['Float']>;
  isVehicleMatch?: InputMaybe<Scalars['Boolean']>;
  issueId?: InputMaybe<Scalars['String']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: InputMaybe<Scalars['Int']>;
  /** The NHTSA model spellings the searched vehicle matched for this issue. Null for a keyword-only search. */
  matchedModels?: InputMaybe<Array<Scalars['String']>>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type IssueSearchResult_Stddev_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_stddev_fields_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: Maybe<Scalars['Float']>;
  concernRank?: Maybe<Scalars['Float']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: Maybe<Scalars['Float']>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type IssueSearchResult_Stddev_Pop_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_stddev_pop_fields_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: Maybe<Scalars['Float']>;
  concernRank?: Maybe<Scalars['Float']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: Maybe<Scalars['Float']>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type IssueSearchResult_Stddev_Samp_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_stddev_samp_fields_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: Maybe<Scalars['Float']>;
  concernRank?: Maybe<Scalars['Float']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: Maybe<Scalars['Float']>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "issueSearchResult" */
export type IssueSearchResult_Stream_Cursor_Input_Nhtsa = {
  /** Stream column input with initial value */
  initial_value: IssueSearchResult_Stream_Cursor_Value_Input_Nhtsa;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Nhtsa>;
};

/** Initial value of the column from where the streaming should start */
export type IssueSearchResult_Stream_Cursor_Value_Input_Nhtsa = {
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: InputMaybe<Scalars['Int']>;
  concernRank?: InputMaybe<Scalars['Float']>;
  isVehicleMatch?: InputMaybe<Scalars['Boolean']>;
  issueId?: InputMaybe<Scalars['String']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: InputMaybe<Scalars['Int']>;
  /** The NHTSA model spellings the searched vehicle matched for this issue. Null for a keyword-only search. */
  matchedModels?: InputMaybe<Array<Scalars['String']>>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type IssueSearchResult_Sum_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_sum_fields_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: Maybe<Scalars['Int']>;
  concernRank?: Maybe<Scalars['Float']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: Maybe<Scalars['Int']>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: Maybe<Scalars['Int']>;
};

export type IssueSearchResult_Updates_Nhtsa = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IssueSearchResult_Inc_Input_Nhtsa>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IssueSearchResult_Set_Input_Nhtsa>;
  /** filter the rows which have to be updated */
  where: IssueSearchResult_Bool_Exp_Nhtsa;
};

/** aggregate var_pop on columns */
export type IssueSearchResult_Var_Pop_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_var_pop_fields_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: Maybe<Scalars['Float']>;
  concernRank?: Maybe<Scalars['Float']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: Maybe<Scalars['Float']>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type IssueSearchResult_Var_Samp_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_var_samp_fields_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: Maybe<Scalars['Float']>;
  concernRank?: Maybe<Scalars['Float']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: Maybe<Scalars['Float']>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type IssueSearchResult_Variance_Fields_Nhtsa = {
  __typename?: 'issueSearchResult_variance_fields_nhtsa';
  /** How many concepts the concern text produced (nhtsa.get_concern_concepts). */
  conceptCount?: Maybe<Scalars['Float']>;
  concernRank?: Maybe<Scalars['Float']>;
  /** How many of them this issue's text matches. */
  matchedConceptCount?: Maybe<Scalars['Float']>;
  /** Rank of the result, 1 first: most concern concepts matched, then full-text rank, then newest. */
  sortOrder?: Maybe<Scalars['Float']>;
};

export type IssueVehicle_Aggregate_Bool_Exp = {
  count?: InputMaybe<IssueVehicle_Aggregate_Bool_Exp_Count>;
};

export type IssueVehicle_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IssueVehicle_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IssueVehicle_Bool_Exp_Nhtsa>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "nhtsa.issue_vehicle" */
export type IssueVehicle_Aggregate_Fields_Nhtsa = {
  __typename?: 'issueVehicle_aggregate_fields_nhtsa';
  avg?: Maybe<IssueVehicle_Avg_Fields_Nhtsa>;
  count: Scalars['Int'];
  max?: Maybe<IssueVehicle_Max_Fields_Nhtsa>;
  min?: Maybe<IssueVehicle_Min_Fields_Nhtsa>;
  stddev?: Maybe<IssueVehicle_Stddev_Fields_Nhtsa>;
  stddev_pop?: Maybe<IssueVehicle_Stddev_Pop_Fields_Nhtsa>;
  stddev_samp?: Maybe<IssueVehicle_Stddev_Samp_Fields_Nhtsa>;
  sum?: Maybe<IssueVehicle_Sum_Fields_Nhtsa>;
  var_pop?: Maybe<IssueVehicle_Var_Pop_Fields_Nhtsa>;
  var_samp?: Maybe<IssueVehicle_Var_Samp_Fields_Nhtsa>;
  variance?: Maybe<IssueVehicle_Variance_Fields_Nhtsa>;
};


/** aggregate fields of "nhtsa.issue_vehicle" */
export type IssueVehicle_Aggregate_Fields_NhtsaCountArgs = {
  columns?: InputMaybe<Array<IssueVehicle_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "nhtsa.issue_vehicle" */
export type IssueVehicle_Aggregate_Nhtsa = {
  __typename?: 'issueVehicle_aggregate_nhtsa';
  aggregate?: Maybe<IssueVehicle_Aggregate_Fields_Nhtsa>;
  nodes: Array<IssueVehicle_Nhtsa>;
};

/** order by aggregate values of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Aggregate_Order_By_Nhtsa = {
  avg?: InputMaybe<IssueVehicle_Avg_Order_By_Nhtsa>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<IssueVehicle_Max_Order_By_Nhtsa>;
  min?: InputMaybe<IssueVehicle_Min_Order_By_Nhtsa>;
  stddev?: InputMaybe<IssueVehicle_Stddev_Order_By_Nhtsa>;
  stddev_pop?: InputMaybe<IssueVehicle_Stddev_Pop_Order_By_Nhtsa>;
  stddev_samp?: InputMaybe<IssueVehicle_Stddev_Samp_Order_By_Nhtsa>;
  sum?: InputMaybe<IssueVehicle_Sum_Order_By_Nhtsa>;
  var_pop?: InputMaybe<IssueVehicle_Var_Pop_Order_By_Nhtsa>;
  var_samp?: InputMaybe<IssueVehicle_Var_Samp_Order_By_Nhtsa>;
  variance?: InputMaybe<IssueVehicle_Variance_Order_By_Nhtsa>;
};

/** input type for inserting array relation for remote table "nhtsa.issue_vehicle" */
export type IssueVehicle_Arr_Rel_Insert_Input_Nhtsa = {
  data: Array<IssueVehicle_Insert_Input_Nhtsa>;
};

/** aggregate avg on columns */
export type IssueVehicle_Avg_Fields_Nhtsa = {
  __typename?: 'issueVehicle_avg_fields_nhtsa';
  firstModelYear?: Maybe<Scalars['Float']>;
  lastModelYear?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Avg_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nhtsa.issue_vehicle". All fields are combined with a logical 'AND'. */
export type IssueVehicle_Bool_Exp_Nhtsa = {
  _and?: InputMaybe<Array<IssueVehicle_Bool_Exp_Nhtsa>>;
  _not?: InputMaybe<IssueVehicle_Bool_Exp_Nhtsa>;
  _or?: InputMaybe<Array<IssueVehicle_Bool_Exp_Nhtsa>>;
  firstModelYear?: InputMaybe<Int_Comparison_Exp>;
  issueId?: InputMaybe<String_Comparison_Exp>;
  lastModelYear?: InputMaybe<Int_Comparison_Exp>;
  make?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  modelYears?: InputMaybe<Int_Array_Comparison_Exp>;
};

/** input type for inserting data into table "nhtsa.issue_vehicle" */
export type IssueVehicle_Insert_Input_Nhtsa = {
  firstModelYear?: InputMaybe<Scalars['Int']>;
  issueId?: InputMaybe<Scalars['String']>;
  lastModelYear?: InputMaybe<Scalars['Int']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  modelYears?: InputMaybe<Array<Scalars['Int']>>;
};

/** aggregate max on columns */
export type IssueVehicle_Max_Fields_Nhtsa = {
  __typename?: 'issueVehicle_max_fields_nhtsa';
  firstModelYear?: Maybe<Scalars['Int']>;
  issueId?: Maybe<Scalars['String']>;
  lastModelYear?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  modelYears?: Maybe<Array<Scalars['Int']>>;
};

/** order by max() on columns of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Max_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  issueId?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  modelYears?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type IssueVehicle_Min_Fields_Nhtsa = {
  __typename?: 'issueVehicle_min_fields_nhtsa';
  firstModelYear?: Maybe<Scalars['Int']>;
  issueId?: Maybe<Scalars['String']>;
  lastModelYear?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  modelYears?: Maybe<Array<Scalars['Int']>>;
};

/** order by min() on columns of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Min_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  issueId?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  modelYears?: InputMaybe<Order_By>;
};

/** The make/models an issue lists, one row each with its model years. Empty model_years means NHTSA filed it with year 9999. */
export type IssueVehicle_Nhtsa = {
  __typename?: 'issueVehicle_nhtsa';
  firstModelYear?: Maybe<Scalars['Int']>;
  issueId?: Maybe<Scalars['String']>;
  lastModelYear?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  modelYears?: Maybe<Array<Scalars['Int']>>;
};

/** Ordering options when selecting data from "nhtsa.issue_vehicle". */
export type IssueVehicle_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  issueId?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  modelYears?: InputMaybe<Order_By>;
};

/** select columns of table "nhtsa.issue_vehicle" */
export enum IssueVehicle_Select_Column_Nhtsa {
  /** column name */
  FirstModelYear = 'firstModelYear',
  /** column name */
  IssueId = 'issueId',
  /** column name */
  LastModelYear = 'lastModelYear',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  ModelYears = 'modelYears'
}

/** aggregate stddev on columns */
export type IssueVehicle_Stddev_Fields_Nhtsa = {
  __typename?: 'issueVehicle_stddev_fields_nhtsa';
  firstModelYear?: Maybe<Scalars['Float']>;
  lastModelYear?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Stddev_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type IssueVehicle_Stddev_Pop_Fields_Nhtsa = {
  __typename?: 'issueVehicle_stddev_pop_fields_nhtsa';
  firstModelYear?: Maybe<Scalars['Float']>;
  lastModelYear?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Stddev_Pop_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type IssueVehicle_Stddev_Samp_Fields_Nhtsa = {
  __typename?: 'issueVehicle_stddev_samp_fields_nhtsa';
  firstModelYear?: Maybe<Scalars['Float']>;
  lastModelYear?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Stddev_Samp_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "issueVehicle" */
export type IssueVehicle_Stream_Cursor_Input_Nhtsa = {
  /** Stream column input with initial value */
  initial_value: IssueVehicle_Stream_Cursor_Value_Input_Nhtsa;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Nhtsa>;
};

/** Initial value of the column from where the streaming should start */
export type IssueVehicle_Stream_Cursor_Value_Input_Nhtsa = {
  firstModelYear?: InputMaybe<Scalars['Int']>;
  issueId?: InputMaybe<Scalars['String']>;
  lastModelYear?: InputMaybe<Scalars['Int']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  modelYears?: InputMaybe<Array<Scalars['Int']>>;
};

/** aggregate sum on columns */
export type IssueVehicle_Sum_Fields_Nhtsa = {
  __typename?: 'issueVehicle_sum_fields_nhtsa';
  firstModelYear?: Maybe<Scalars['Int']>;
  lastModelYear?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Sum_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type IssueVehicle_Var_Pop_Fields_Nhtsa = {
  __typename?: 'issueVehicle_var_pop_fields_nhtsa';
  firstModelYear?: Maybe<Scalars['Float']>;
  lastModelYear?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Var_Pop_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type IssueVehicle_Var_Samp_Fields_Nhtsa = {
  __typename?: 'issueVehicle_var_samp_fields_nhtsa';
  firstModelYear?: Maybe<Scalars['Float']>;
  lastModelYear?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Var_Samp_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type IssueVehicle_Variance_Fields_Nhtsa = {
  __typename?: 'issueVehicle_variance_fields_nhtsa';
  firstModelYear?: Maybe<Scalars['Float']>;
  lastModelYear?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nhtsa.issue_vehicle" */
export type IssueVehicle_Variance_Order_By_Nhtsa = {
  firstModelYear?: InputMaybe<Order_By>;
  lastModelYear?: InputMaybe<Order_By>;
};

/** aggregate fields of "nhtsa.issue" */
export type Issue_Aggregate_Fields_Nhtsa = {
  __typename?: 'issue_aggregate_fields_nhtsa';
  avg?: Maybe<Issue_Avg_Fields_Nhtsa>;
  count: Scalars['Int'];
  max?: Maybe<Issue_Max_Fields_Nhtsa>;
  min?: Maybe<Issue_Min_Fields_Nhtsa>;
  stddev?: Maybe<Issue_Stddev_Fields_Nhtsa>;
  stddev_pop?: Maybe<Issue_Stddev_Pop_Fields_Nhtsa>;
  stddev_samp?: Maybe<Issue_Stddev_Samp_Fields_Nhtsa>;
  sum?: Maybe<Issue_Sum_Fields_Nhtsa>;
  var_pop?: Maybe<Issue_Var_Pop_Fields_Nhtsa>;
  var_samp?: Maybe<Issue_Var_Samp_Fields_Nhtsa>;
  variance?: Maybe<Issue_Variance_Fields_Nhtsa>;
};


/** aggregate fields of "nhtsa.issue" */
export type Issue_Aggregate_Fields_NhtsaCountArgs = {
  columns?: InputMaybe<Array<Issue_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "nhtsa.issue" */
export type Issue_Aggregate_Nhtsa = {
  __typename?: 'issue_aggregate_nhtsa';
  aggregate?: Maybe<Issue_Aggregate_Fields_Nhtsa>;
  nodes: Array<Issue_Nhtsa>;
};

/** aggregate avg on columns */
export type Issue_Avg_Fields_Nhtsa = {
  __typename?: 'issue_avg_fields_nhtsa';
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nhtsa.issue". All fields are combined with a logical 'AND'. */
export type Issue_Bool_Exp_Nhtsa = {
  _and?: InputMaybe<Array<Issue_Bool_Exp_Nhtsa>>;
  _not?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
  _or?: InputMaybe<Array<Issue_Bool_Exp_Nhtsa>>;
  closedDate?: InputMaybe<Date_Comparison_Exp>;
  communicationType?: InputMaybe<String_Comparison_Exp>;
  components?: InputMaybe<String_Array_Comparison_Exp>;
  consequence?: InputMaybe<String_Comparison_Exp>;
  correctiveAction?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  investigationLinks?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
  investigationLinks_aggregate?: InputMaybe<InvestigationRecall_Aggregate_Bool_Exp>;
  isDoNotDrive?: InputMaybe<Boolean_Comparison_Exp>;
  isParkOutside?: InputMaybe<Boolean_Comparison_Exp>;
  issueDate?: InputMaybe<Date_Comparison_Exp>;
  issueType?: InputMaybe<String_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  manufacturerCampaignNumber?: InputMaybe<String_Comparison_Exp>;
  nhtsaId?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  partNumbers?: InputMaybe<String_Array_Comparison_Exp>;
  potentiallyAffectedCount?: InputMaybe<Int_Comparison_Exp>;
  recallLinks?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
  recallLinks_aggregate?: InputMaybe<InvestigationRecall_Aggregate_Bool_Exp>;
  recallType?: InputMaybe<String_Comparison_Exp>;
  recordType?: InputMaybe<String_Comparison_Exp>;
  search_vector?: InputMaybe<Tsvector_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  summary?: InputMaybe<String_Comparison_Exp>;
  vehicles?: InputMaybe<IssueVehicle_Bool_Exp_Nhtsa>;
  vehicles_aggregate?: InputMaybe<IssueVehicle_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "nhtsa.issue" */
export enum Issue_Constraint_Nhtsa {
  /** unique or primary key constraint on columns "id" */
  IssuePkey = 'issue_pkey'
}

/** input type for incrementing numeric columns in table "nhtsa.issue" */
export type Issue_Inc_Input_Nhtsa = {
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nhtsa.issue" */
export type Issue_Insert_Input_Nhtsa = {
  /** Investigation closed date. Null while NHTSA is still investigating, and for other issue types. */
  closedDate?: InputMaybe<Scalars['date']>;
  /** Communication: the source Communication Type column. */
  communicationType?: InputMaybe<Scalars['String']>;
  components?: InputMaybe<Array<Scalars['String']>>;
  /** Recall consequence summary. Null for other issue types. */
  consequence?: InputMaybe<Scalars['String']>;
  /** Recall remedy summary. Null for other issue types. */
  correctiveAction?: InputMaybe<Scalars['String']>;
  /** recall-<NHTSA campaign number>, communication-<NHTSA ID number> or investigation-<NHTSA action number>. Used in the claims app URL /oem-issues/<id>. */
  id?: InputMaybe<Scalars['String']>;
  investigationLinks?: InputMaybe<InvestigationRecall_Arr_Rel_Insert_Input_Nhtsa>;
  isDoNotDrive?: InputMaybe<Scalars['Boolean']>;
  isParkOutside?: InputMaybe<Scalars['Boolean']>;
  /** Recall: Part 573 report received date. Communication: manufacturer communication date. Investigation: date opened. */
  issueDate?: InputMaybe<Scalars['date']>;
  /** Which ODI dataset the issue came from: Recall (FLAT_RCL), Manufacturer Communication (TSBS_RECEIVED) or Investigation (FLAT_INV). */
  issueType?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  /** Recall: manufacturer campaign number. Communication: Mfr Internal Campaign ID / Software Version. */
  manufacturerCampaignNumber?: InputMaybe<Scalars['String']>;
  /** NHTSA's key for the issue in api.nhtsa.gov/safetyIssues/byNhtsaId, which lists its source documents. Same as number for recalls and investigations. */
  nhtsaId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** The number people quote: the NHTSA recall campaign number, the manufacturer's TSB/Document ID, or the NHTSA investigation action number. */
  number?: InputMaybe<Scalars['String']>;
  /** Recall: manufacturer-supplied component part numbers. */
  partNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: InputMaybe<Scalars['Int']>;
  recallLinks?: InputMaybe<InvestigationRecall_Arr_Rel_Insert_Input_Nhtsa>;
  /** Recall: Vehicle, Equipment, Tire, Child Seat, or the raw RCLTYPECD for the rare undocumented codes. */
  recallType?: InputMaybe<Scalars['String']>;
  /** What the claims search filters on: Recall, Investigation, or for communications the source Communication Type column verbatim (Service Bulletin/Repair Instructions, Service Campaign, Warranty Program/Extension, Over The Air, Emissions, Other). */
  recordType?: InputMaybe<Scalars['String']>;
  /** english full-text vector over the number, components, part numbers, subject, summary and recall consequence/remedy. Queries must use the english configuration too. */
  search_vector?: InputMaybe<Scalars['tsvector']>;
  /** Investigation subject. Null for recalls and communications, which publish no subject in the flat files. */
  subject?: InputMaybe<Scalars['String']>;
  /** Recall defect summary, communication summary, or investigation summary. */
  summary?: InputMaybe<Scalars['String']>;
  vehicles?: InputMaybe<IssueVehicle_Arr_Rel_Insert_Input_Nhtsa>;
};

/** aggregate max on columns */
export type Issue_Max_Fields_Nhtsa = {
  __typename?: 'issue_max_fields_nhtsa';
  /** Investigation closed date. Null while NHTSA is still investigating, and for other issue types. */
  closedDate?: Maybe<Scalars['date']>;
  /** Communication: the source Communication Type column. */
  communicationType?: Maybe<Scalars['String']>;
  components?: Maybe<Array<Scalars['String']>>;
  /** Recall consequence summary. Null for other issue types. */
  consequence?: Maybe<Scalars['String']>;
  /** Recall remedy summary. Null for other issue types. */
  correctiveAction?: Maybe<Scalars['String']>;
  /** recall-<NHTSA campaign number>, communication-<NHTSA ID number> or investigation-<NHTSA action number>. Used in the claims app URL /oem-issues/<id>. */
  id?: Maybe<Scalars['String']>;
  /** Recall: Part 573 report received date. Communication: manufacturer communication date. Investigation: date opened. */
  issueDate?: Maybe<Scalars['date']>;
  /** Which ODI dataset the issue came from: Recall (FLAT_RCL), Manufacturer Communication (TSBS_RECEIVED) or Investigation (FLAT_INV). */
  issueType?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  /** Recall: manufacturer campaign number. Communication: Mfr Internal Campaign ID / Software Version. */
  manufacturerCampaignNumber?: Maybe<Scalars['String']>;
  /** NHTSA's key for the issue in api.nhtsa.gov/safetyIssues/byNhtsaId, which lists its source documents. Same as number for recalls and investigations. */
  nhtsaId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  /** The number people quote: the NHTSA recall campaign number, the manufacturer's TSB/Document ID, or the NHTSA investigation action number. */
  number?: Maybe<Scalars['String']>;
  /** Recall: manufacturer-supplied component part numbers. */
  partNumbers?: Maybe<Array<Scalars['String']>>;
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Int']>;
  /** Recall: Vehicle, Equipment, Tire, Child Seat, or the raw RCLTYPECD for the rare undocumented codes. */
  recallType?: Maybe<Scalars['String']>;
  /** What the claims search filters on: Recall, Investigation, or for communications the source Communication Type column verbatim (Service Bulletin/Repair Instructions, Service Campaign, Warranty Program/Extension, Over The Air, Emissions, Other). */
  recordType?: Maybe<Scalars['String']>;
  /** Investigation subject. Null for recalls and communications, which publish no subject in the flat files. */
  subject?: Maybe<Scalars['String']>;
  /** Recall defect summary, communication summary, or investigation summary. */
  summary?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Issue_Min_Fields_Nhtsa = {
  __typename?: 'issue_min_fields_nhtsa';
  /** Investigation closed date. Null while NHTSA is still investigating, and for other issue types. */
  closedDate?: Maybe<Scalars['date']>;
  /** Communication: the source Communication Type column. */
  communicationType?: Maybe<Scalars['String']>;
  components?: Maybe<Array<Scalars['String']>>;
  /** Recall consequence summary. Null for other issue types. */
  consequence?: Maybe<Scalars['String']>;
  /** Recall remedy summary. Null for other issue types. */
  correctiveAction?: Maybe<Scalars['String']>;
  /** recall-<NHTSA campaign number>, communication-<NHTSA ID number> or investigation-<NHTSA action number>. Used in the claims app URL /oem-issues/<id>. */
  id?: Maybe<Scalars['String']>;
  /** Recall: Part 573 report received date. Communication: manufacturer communication date. Investigation: date opened. */
  issueDate?: Maybe<Scalars['date']>;
  /** Which ODI dataset the issue came from: Recall (FLAT_RCL), Manufacturer Communication (TSBS_RECEIVED) or Investigation (FLAT_INV). */
  issueType?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  /** Recall: manufacturer campaign number. Communication: Mfr Internal Campaign ID / Software Version. */
  manufacturerCampaignNumber?: Maybe<Scalars['String']>;
  /** NHTSA's key for the issue in api.nhtsa.gov/safetyIssues/byNhtsaId, which lists its source documents. Same as number for recalls and investigations. */
  nhtsaId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  /** The number people quote: the NHTSA recall campaign number, the manufacturer's TSB/Document ID, or the NHTSA investigation action number. */
  number?: Maybe<Scalars['String']>;
  /** Recall: manufacturer-supplied component part numbers. */
  partNumbers?: Maybe<Array<Scalars['String']>>;
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Int']>;
  /** Recall: Vehicle, Equipment, Tire, Child Seat, or the raw RCLTYPECD for the rare undocumented codes. */
  recallType?: Maybe<Scalars['String']>;
  /** What the claims search filters on: Recall, Investigation, or for communications the source Communication Type column verbatim (Service Bulletin/Repair Instructions, Service Campaign, Warranty Program/Extension, Over The Air, Emissions, Other). */
  recordType?: Maybe<Scalars['String']>;
  /** Investigation subject. Null for recalls and communications, which publish no subject in the flat files. */
  subject?: Maybe<Scalars['String']>;
  /** Recall defect summary, communication summary, or investigation summary. */
  summary?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "nhtsa.issue" */
export type Issue_Mutation_Response_Nhtsa = {
  __typename?: 'issue_mutation_response_nhtsa';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Issue_Nhtsa>;
};

/** One NHTSA recall, manufacturer communication (TSB, service campaign, warranty extension, ...) or defect investigation, folded from the ODI flat files that list it once per vehicle and component. Reference material: nothing here says whether a recall is open or remedied on a particular VIN. */
export type Issue_Nhtsa = {
  __typename?: 'issue_nhtsa';
  /** Investigation closed date. Null while NHTSA is still investigating, and for other issue types. */
  closedDate?: Maybe<Scalars['date']>;
  /** Communication: the source Communication Type column. */
  communicationType?: Maybe<Scalars['String']>;
  components: Array<Scalars['String']>;
  /** Recall consequence summary. Null for other issue types. */
  consequence?: Maybe<Scalars['String']>;
  /** Recall remedy summary. Null for other issue types. */
  correctiveAction?: Maybe<Scalars['String']>;
  /** recall-<NHTSA campaign number>, communication-<NHTSA ID number> or investigation-<NHTSA action number>. Used in the claims app URL /oem-issues/<id>. */
  id: Scalars['String'];
  /** An array relationship */
  investigationLinks: Array<InvestigationRecall_Nhtsa>;
  /** An aggregate relationship */
  investigationLinks_aggregate: InvestigationRecall_Aggregate_Nhtsa;
  isDoNotDrive: Scalars['Boolean'];
  isParkOutside: Scalars['Boolean'];
  /** Recall: Part 573 report received date. Communication: manufacturer communication date. Investigation: date opened. */
  issueDate?: Maybe<Scalars['date']>;
  /** Which ODI dataset the issue came from: Recall (FLAT_RCL), Manufacturer Communication (TSBS_RECEIVED) or Investigation (FLAT_INV). */
  issueType: Scalars['String'];
  manufacturer?: Maybe<Scalars['String']>;
  /** Recall: manufacturer campaign number. Communication: Mfr Internal Campaign ID / Software Version. */
  manufacturerCampaignNumber?: Maybe<Scalars['String']>;
  /** NHTSA's key for the issue in api.nhtsa.gov/safetyIssues/byNhtsaId, which lists its source documents. Same as number for recalls and investigations. */
  nhtsaId: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  /** The number people quote: the NHTSA recall campaign number, the manufacturer's TSB/Document ID, or the NHTSA investigation action number. */
  number: Scalars['String'];
  /** Recall: manufacturer-supplied component part numbers. */
  partNumbers: Array<Scalars['String']>;
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Int']>;
  /** An array relationship */
  recallLinks: Array<InvestigationRecall_Nhtsa>;
  /** An aggregate relationship */
  recallLinks_aggregate: InvestigationRecall_Aggregate_Nhtsa;
  /** Recall: Vehicle, Equipment, Tire, Child Seat, or the raw RCLTYPECD for the rare undocumented codes. */
  recallType?: Maybe<Scalars['String']>;
  /** What the claims search filters on: Recall, Investigation, or for communications the source Communication Type column verbatim (Service Bulletin/Repair Instructions, Service Campaign, Warranty Program/Extension, Over The Air, Emissions, Other). */
  recordType: Scalars['String'];
  /** english full-text vector over the number, components, part numbers, subject, summary and recall consequence/remedy. Queries must use the english configuration too. */
  search_vector: Scalars['tsvector'];
  /** Investigation subject. Null for recalls and communications, which publish no subject in the flat files. */
  subject?: Maybe<Scalars['String']>;
  /** Recall defect summary, communication summary, or investigation summary. */
  summary?: Maybe<Scalars['String']>;
  /** An array relationship */
  vehicles: Array<IssueVehicle_Nhtsa>;
  /** An aggregate relationship */
  vehicles_aggregate: IssueVehicle_Aggregate_Nhtsa;
};


/** One NHTSA recall, manufacturer communication (TSB, service campaign, warranty extension, ...) or defect investigation, folded from the ODI flat files that list it once per vehicle and component. Reference material: nothing here says whether a recall is open or remedied on a particular VIN. */
export type Issue_NhtsaInvestigationLinksArgs = {
  distinct_on?: InputMaybe<Array<InvestigationRecall_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvestigationRecall_Order_By_Nhtsa>>;
  where?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
};


/** One NHTSA recall, manufacturer communication (TSB, service campaign, warranty extension, ...) or defect investigation, folded from the ODI flat files that list it once per vehicle and component. Reference material: nothing here says whether a recall is open or remedied on a particular VIN. */
export type Issue_NhtsaInvestigationLinks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InvestigationRecall_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvestigationRecall_Order_By_Nhtsa>>;
  where?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
};


/** One NHTSA recall, manufacturer communication (TSB, service campaign, warranty extension, ...) or defect investigation, folded from the ODI flat files that list it once per vehicle and component. Reference material: nothing here says whether a recall is open or remedied on a particular VIN. */
export type Issue_NhtsaRecallLinksArgs = {
  distinct_on?: InputMaybe<Array<InvestigationRecall_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvestigationRecall_Order_By_Nhtsa>>;
  where?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
};


/** One NHTSA recall, manufacturer communication (TSB, service campaign, warranty extension, ...) or defect investigation, folded from the ODI flat files that list it once per vehicle and component. Reference material: nothing here says whether a recall is open or remedied on a particular VIN. */
export type Issue_NhtsaRecallLinks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InvestigationRecall_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvestigationRecall_Order_By_Nhtsa>>;
  where?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
};


/** One NHTSA recall, manufacturer communication (TSB, service campaign, warranty extension, ...) or defect investigation, folded from the ODI flat files that list it once per vehicle and component. Reference material: nothing here says whether a recall is open or remedied on a particular VIN. */
export type Issue_NhtsaVehiclesArgs = {
  distinct_on?: InputMaybe<Array<IssueVehicle_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueVehicle_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueVehicle_Bool_Exp_Nhtsa>;
};


/** One NHTSA recall, manufacturer communication (TSB, service campaign, warranty extension, ...) or defect investigation, folded from the ODI flat files that list it once per vehicle and component. Reference material: nothing here says whether a recall is open or remedied on a particular VIN. */
export type Issue_NhtsaVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IssueVehicle_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueVehicle_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueVehicle_Bool_Exp_Nhtsa>;
};

/** input type for inserting object relation for remote table "nhtsa.issue" */
export type Issue_Obj_Rel_Insert_Input_Nhtsa = {
  data: Issue_Insert_Input_Nhtsa;
  /** upsert condition */
  on_conflict?: InputMaybe<Issue_On_Conflict_Nhtsa>;
};

/** on_conflict condition type for table "nhtsa.issue" */
export type Issue_On_Conflict_Nhtsa = {
  constraint: Issue_Constraint_Nhtsa;
  update_columns?: Array<Issue_Update_Column_Nhtsa>;
  where?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
};

/** Ordering options when selecting data from "nhtsa.issue". */
export type Issue_Order_By_Nhtsa = {
  closedDate?: InputMaybe<Order_By>;
  communicationType?: InputMaybe<Order_By>;
  components?: InputMaybe<Order_By>;
  consequence?: InputMaybe<Order_By>;
  correctiveAction?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  investigationLinks_aggregate?: InputMaybe<InvestigationRecall_Aggregate_Order_By_Nhtsa>;
  isDoNotDrive?: InputMaybe<Order_By>;
  isParkOutside?: InputMaybe<Order_By>;
  issueDate?: InputMaybe<Order_By>;
  issueType?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  manufacturerCampaignNumber?: InputMaybe<Order_By>;
  nhtsaId?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  partNumbers?: InputMaybe<Order_By>;
  potentiallyAffectedCount?: InputMaybe<Order_By>;
  recallLinks_aggregate?: InputMaybe<InvestigationRecall_Aggregate_Order_By_Nhtsa>;
  recallType?: InputMaybe<Order_By>;
  recordType?: InputMaybe<Order_By>;
  search_vector?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  vehicles_aggregate?: InputMaybe<IssueVehicle_Aggregate_Order_By_Nhtsa>;
};

/** primary key columns input for table: nhtsa.issue */
export type Issue_Pk_Columns_Input_Nhtsa = {
  /** recall-<NHTSA campaign number>, communication-<NHTSA ID number> or investigation-<NHTSA action number>. Used in the claims app URL /oem-issues/<id>. */
  id: Scalars['String'];
};

/** select columns of table "nhtsa.issue" */
export enum Issue_Select_Column_Nhtsa {
  /** column name */
  ClosedDate = 'closedDate',
  /** column name */
  CommunicationType = 'communicationType',
  /** column name */
  Components = 'components',
  /** column name */
  Consequence = 'consequence',
  /** column name */
  CorrectiveAction = 'correctiveAction',
  /** column name */
  Id = 'id',
  /** column name */
  IsDoNotDrive = 'isDoNotDrive',
  /** column name */
  IsParkOutside = 'isParkOutside',
  /** column name */
  IssueDate = 'issueDate',
  /** column name */
  IssueType = 'issueType',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  ManufacturerCampaignNumber = 'manufacturerCampaignNumber',
  /** column name */
  NhtsaId = 'nhtsaId',
  /** column name */
  Notes = 'notes',
  /** column name */
  Number = 'number',
  /** column name */
  PartNumbers = 'partNumbers',
  /** column name */
  PotentiallyAffectedCount = 'potentiallyAffectedCount',
  /** column name */
  RecallType = 'recallType',
  /** column name */
  RecordType = 'recordType',
  /** column name */
  SearchVector = 'search_vector',
  /** column name */
  Subject = 'subject',
  /** column name */
  Summary = 'summary'
}

/** input type for updating data in table "nhtsa.issue" */
export type Issue_Set_Input_Nhtsa = {
  /** Investigation closed date. Null while NHTSA is still investigating, and for other issue types. */
  closedDate?: InputMaybe<Scalars['date']>;
  /** Communication: the source Communication Type column. */
  communicationType?: InputMaybe<Scalars['String']>;
  components?: InputMaybe<Array<Scalars['String']>>;
  /** Recall consequence summary. Null for other issue types. */
  consequence?: InputMaybe<Scalars['String']>;
  /** Recall remedy summary. Null for other issue types. */
  correctiveAction?: InputMaybe<Scalars['String']>;
  /** recall-<NHTSA campaign number>, communication-<NHTSA ID number> or investigation-<NHTSA action number>. Used in the claims app URL /oem-issues/<id>. */
  id?: InputMaybe<Scalars['String']>;
  isDoNotDrive?: InputMaybe<Scalars['Boolean']>;
  isParkOutside?: InputMaybe<Scalars['Boolean']>;
  /** Recall: Part 573 report received date. Communication: manufacturer communication date. Investigation: date opened. */
  issueDate?: InputMaybe<Scalars['date']>;
  /** Which ODI dataset the issue came from: Recall (FLAT_RCL), Manufacturer Communication (TSBS_RECEIVED) or Investigation (FLAT_INV). */
  issueType?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  /** Recall: manufacturer campaign number. Communication: Mfr Internal Campaign ID / Software Version. */
  manufacturerCampaignNumber?: InputMaybe<Scalars['String']>;
  /** NHTSA's key for the issue in api.nhtsa.gov/safetyIssues/byNhtsaId, which lists its source documents. Same as number for recalls and investigations. */
  nhtsaId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** The number people quote: the NHTSA recall campaign number, the manufacturer's TSB/Document ID, or the NHTSA investigation action number. */
  number?: InputMaybe<Scalars['String']>;
  /** Recall: manufacturer-supplied component part numbers. */
  partNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: InputMaybe<Scalars['Int']>;
  /** Recall: Vehicle, Equipment, Tire, Child Seat, or the raw RCLTYPECD for the rare undocumented codes. */
  recallType?: InputMaybe<Scalars['String']>;
  /** What the claims search filters on: Recall, Investigation, or for communications the source Communication Type column verbatim (Service Bulletin/Repair Instructions, Service Campaign, Warranty Program/Extension, Over The Air, Emissions, Other). */
  recordType?: InputMaybe<Scalars['String']>;
  /** english full-text vector over the number, components, part numbers, subject, summary and recall consequence/remedy. Queries must use the english configuration too. */
  search_vector?: InputMaybe<Scalars['tsvector']>;
  /** Investigation subject. Null for recalls and communications, which publish no subject in the flat files. */
  subject?: InputMaybe<Scalars['String']>;
  /** Recall defect summary, communication summary, or investigation summary. */
  summary?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Issue_Stddev_Fields_Nhtsa = {
  __typename?: 'issue_stddev_fields_nhtsa';
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Issue_Stddev_Pop_Fields_Nhtsa = {
  __typename?: 'issue_stddev_pop_fields_nhtsa';
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Issue_Stddev_Samp_Fields_Nhtsa = {
  __typename?: 'issue_stddev_samp_fields_nhtsa';
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "issue" */
export type Issue_Stream_Cursor_Input_Nhtsa = {
  /** Stream column input with initial value */
  initial_value: Issue_Stream_Cursor_Value_Input_Nhtsa;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Nhtsa>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Stream_Cursor_Value_Input_Nhtsa = {
  /** Investigation closed date. Null while NHTSA is still investigating, and for other issue types. */
  closedDate?: InputMaybe<Scalars['date']>;
  /** Communication: the source Communication Type column. */
  communicationType?: InputMaybe<Scalars['String']>;
  components?: InputMaybe<Array<Scalars['String']>>;
  /** Recall consequence summary. Null for other issue types. */
  consequence?: InputMaybe<Scalars['String']>;
  /** Recall remedy summary. Null for other issue types. */
  correctiveAction?: InputMaybe<Scalars['String']>;
  /** recall-<NHTSA campaign number>, communication-<NHTSA ID number> or investigation-<NHTSA action number>. Used in the claims app URL /oem-issues/<id>. */
  id?: InputMaybe<Scalars['String']>;
  isDoNotDrive?: InputMaybe<Scalars['Boolean']>;
  isParkOutside?: InputMaybe<Scalars['Boolean']>;
  /** Recall: Part 573 report received date. Communication: manufacturer communication date. Investigation: date opened. */
  issueDate?: InputMaybe<Scalars['date']>;
  /** Which ODI dataset the issue came from: Recall (FLAT_RCL), Manufacturer Communication (TSBS_RECEIVED) or Investigation (FLAT_INV). */
  issueType?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  /** Recall: manufacturer campaign number. Communication: Mfr Internal Campaign ID / Software Version. */
  manufacturerCampaignNumber?: InputMaybe<Scalars['String']>;
  /** NHTSA's key for the issue in api.nhtsa.gov/safetyIssues/byNhtsaId, which lists its source documents. Same as number for recalls and investigations. */
  nhtsaId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** The number people quote: the NHTSA recall campaign number, the manufacturer's TSB/Document ID, or the NHTSA investigation action number. */
  number?: InputMaybe<Scalars['String']>;
  /** Recall: manufacturer-supplied component part numbers. */
  partNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: InputMaybe<Scalars['Int']>;
  /** Recall: Vehicle, Equipment, Tire, Child Seat, or the raw RCLTYPECD for the rare undocumented codes. */
  recallType?: InputMaybe<Scalars['String']>;
  /** What the claims search filters on: Recall, Investigation, or for communications the source Communication Type column verbatim (Service Bulletin/Repair Instructions, Service Campaign, Warranty Program/Extension, Over The Air, Emissions, Other). */
  recordType?: InputMaybe<Scalars['String']>;
  /** english full-text vector over the number, components, part numbers, subject, summary and recall consequence/remedy. Queries must use the english configuration too. */
  search_vector?: InputMaybe<Scalars['tsvector']>;
  /** Investigation subject. Null for recalls and communications, which publish no subject in the flat files. */
  subject?: InputMaybe<Scalars['String']>;
  /** Recall defect summary, communication summary, or investigation summary. */
  summary?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Issue_Sum_Fields_Nhtsa = {
  __typename?: 'issue_sum_fields_nhtsa';
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Int']>;
};

/** update columns of table "nhtsa.issue" */
export enum Issue_Update_Column_Nhtsa {
  /** column name */
  ClosedDate = 'closedDate',
  /** column name */
  CommunicationType = 'communicationType',
  /** column name */
  Components = 'components',
  /** column name */
  Consequence = 'consequence',
  /** column name */
  CorrectiveAction = 'correctiveAction',
  /** column name */
  Id = 'id',
  /** column name */
  IsDoNotDrive = 'isDoNotDrive',
  /** column name */
  IsParkOutside = 'isParkOutside',
  /** column name */
  IssueDate = 'issueDate',
  /** column name */
  IssueType = 'issueType',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  ManufacturerCampaignNumber = 'manufacturerCampaignNumber',
  /** column name */
  NhtsaId = 'nhtsaId',
  /** column name */
  Notes = 'notes',
  /** column name */
  Number = 'number',
  /** column name */
  PartNumbers = 'partNumbers',
  /** column name */
  PotentiallyAffectedCount = 'potentiallyAffectedCount',
  /** column name */
  RecallType = 'recallType',
  /** column name */
  RecordType = 'recordType',
  /** column name */
  SearchVector = 'search_vector',
  /** column name */
  Subject = 'subject',
  /** column name */
  Summary = 'summary'
}

export type Issue_Updates_Nhtsa = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Issue_Inc_Input_Nhtsa>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Issue_Set_Input_Nhtsa>;
  /** filter the rows which have to be updated */
  where: Issue_Bool_Exp_Nhtsa;
};

/** aggregate var_pop on columns */
export type Issue_Var_Pop_Fields_Nhtsa = {
  __typename?: 'issue_var_pop_fields_nhtsa';
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Issue_Var_Samp_Fields_Nhtsa = {
  __typename?: 'issue_var_samp_fields_nhtsa';
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Issue_Variance_Fields_Nhtsa = {
  __typename?: 'issue_variance_fields_nhtsa';
  /** Recall: potential number of units affected. */
  potentiallyAffectedCount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "system.job" */
export type Job = {
  __typename?: 'job';
  /** An object relationship */
  application?: Maybe<Application>;
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An array relationship */
  jobHistories: Array<JobHistory>;
  /** An aggregate relationship */
  jobHistories_aggregate: JobHistory_Aggregate;
  /** An array relationship */
  jobSchedules: Array<JobSchedule>;
  /** An aggregate relationship */
  jobSchedules_aggregate: JobSchedule_Aggregate;
  /** An array relationship */
  jobSteps: Array<JobStep>;
  /** An aggregate relationship */
  jobSteps_aggregate: JobStep_Aggregate;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  startingJobStep?: Maybe<JobStep>;
  startingJobStepId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "system.job" */
export type JobEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "system.job" */
export type JobEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "system.job" */
export type JobJobHistoriesArgs = {
  distinct_on?: InputMaybe<Array<JobHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistory_Order_By>>;
  where?: InputMaybe<JobHistory_Bool_Exp>;
};


/** columns and relationships of "system.job" */
export type JobJobHistories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JobHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistory_Order_By>>;
  where?: InputMaybe<JobHistory_Bool_Exp>;
};


/** columns and relationships of "system.job" */
export type JobJobSchedulesArgs = {
  distinct_on?: InputMaybe<Array<JobSchedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSchedule_Order_By>>;
  where?: InputMaybe<JobSchedule_Bool_Exp>;
};


/** columns and relationships of "system.job" */
export type JobJobSchedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JobSchedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSchedule_Order_By>>;
  where?: InputMaybe<JobSchedule_Bool_Exp>;
};


/** columns and relationships of "system.job" */
export type JobJobStepsArgs = {
  distinct_on?: InputMaybe<Array<JobStep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobStep_Order_By>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};


/** columns and relationships of "system.job" */
export type JobJobSteps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JobStep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobStep_Order_By>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};


/** columns and relationships of "system.job" */
export type JobLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "system.job" */
export type JobLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** columns and relationships of "system.job_history" */
export type JobHistory = {
  __typename?: 'jobHistory';
  createdAt: Scalars['timestamptz'];
  endDatetime?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  isRunning: Scalars['Boolean'];
  /** An object relationship */
  job?: Maybe<Job>;
  /** An array relationship */
  jobHistoryLogs: Array<JobHistoryLog>;
  /** An aggregate relationship */
  jobHistoryLogs_aggregate: JobHistoryLog_Aggregate;
  jobId: Scalars['uuid'];
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
  startDatetime?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  startingJobStep?: Maybe<JobStep>;
  startingJobStepId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  wasScheduled: Scalars['Boolean'];
  /** A computed field, executes function "system.find_was_successful" */
  wasSuccessful?: Maybe<Scalars['String']>;
};


/** columns and relationships of "system.job_history" */
export type JobHistoryJobHistoryLogsArgs = {
  distinct_on?: InputMaybe<Array<JobHistoryLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistoryLog_Order_By>>;
  where?: InputMaybe<JobHistoryLog_Bool_Exp>;
};


/** columns and relationships of "system.job_history" */
export type JobHistoryJobHistoryLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JobHistoryLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistoryLog_Order_By>>;
  where?: InputMaybe<JobHistoryLog_Bool_Exp>;
};

/** columns and relationships of "system.job_history_log" */
export type JobHistoryLog = {
  __typename?: 'jobHistoryLog';
  createdAt: Scalars['timestamptz'];
  endDatetime?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  jobHistory?: Maybe<JobHistory>;
  jobHistoryId: Scalars['uuid'];
  /** An object relationship */
  jobStep?: Maybe<JobStep>;
  jobStepId?: Maybe<Scalars['uuid']>;
  jobStepMetadata?: Maybe<Scalars['jsonb']>;
  message?: Maybe<Scalars['String']>;
  /** An array relationship */
  referenceLogs: Array<ReferenceLog>;
  /** An aggregate relationship */
  referenceLogs_aggregate: ReferenceLog_Aggregate;
  result?: Maybe<Scalars['jsonb']>;
  startDatetime?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  wasSuccessful?: Maybe<Scalars['Boolean']>;
};


/** columns and relationships of "system.job_history_log" */
export type JobHistoryLogJobStepMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "system.job_history_log" */
export type JobHistoryLogReferenceLogsArgs = {
  distinct_on?: InputMaybe<Array<ReferenceLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReferenceLog_Order_By>>;
  where?: InputMaybe<ReferenceLog_Bool_Exp>;
};


/** columns and relationships of "system.job_history_log" */
export type JobHistoryLogReferenceLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReferenceLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReferenceLog_Order_By>>;
  where?: InputMaybe<ReferenceLog_Bool_Exp>;
};


/** columns and relationships of "system.job_history_log" */
export type JobHistoryLogResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "system.job_history_log" */
export type JobHistoryLog_Aggregate = {
  __typename?: 'jobHistoryLog_aggregate';
  aggregate?: Maybe<JobHistoryLog_Aggregate_Fields>;
  nodes: Array<JobHistoryLog>;
};

export type JobHistoryLog_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<JobHistoryLog_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<JobHistoryLog_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<JobHistoryLog_Aggregate_Bool_Exp_Count>;
};

export type JobHistoryLog_Aggregate_Bool_Exp_Bool_And = {
  arguments: JobHistoryLog_Select_Column_JobHistoryLog_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobHistoryLog_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type JobHistoryLog_Aggregate_Bool_Exp_Bool_Or = {
  arguments: JobHistoryLog_Select_Column_JobHistoryLog_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobHistoryLog_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type JobHistoryLog_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<JobHistoryLog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobHistoryLog_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "system.job_history_log" */
export type JobHistoryLog_Aggregate_Fields = {
  __typename?: 'jobHistoryLog_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<JobHistoryLog_Max_Fields>;
  min?: Maybe<JobHistoryLog_Min_Fields>;
};


/** aggregate fields of "system.job_history_log" */
export type JobHistoryLog_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JobHistoryLog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "system.job_history_log" */
export type JobHistoryLog_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<JobHistoryLog_Max_Order_By>;
  min?: InputMaybe<JobHistoryLog_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type JobHistoryLog_Append_Input = {
  jobStepMetadata?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "system.job_history_log" */
export type JobHistoryLog_Arr_Rel_Insert_Input = {
  data: Array<JobHistoryLog_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<JobHistoryLog_On_Conflict>;
};

/** Boolean expression to filter rows from the table "system.job_history_log". All fields are combined with a logical 'AND'. */
export type JobHistoryLog_Bool_Exp = {
  _and?: InputMaybe<Array<JobHistoryLog_Bool_Exp>>;
  _not?: InputMaybe<JobHistoryLog_Bool_Exp>;
  _or?: InputMaybe<Array<JobHistoryLog_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endDatetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobHistory?: InputMaybe<JobHistory_Bool_Exp>;
  jobHistoryId?: InputMaybe<Uuid_Comparison_Exp>;
  jobStep?: InputMaybe<JobStep_Bool_Exp>;
  jobStepId?: InputMaybe<Uuid_Comparison_Exp>;
  jobStepMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  referenceLogs?: InputMaybe<ReferenceLog_Bool_Exp>;
  referenceLogs_aggregate?: InputMaybe<ReferenceLog_Aggregate_Bool_Exp>;
  result?: InputMaybe<Jsonb_Comparison_Exp>;
  startDatetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  wasSuccessful?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.job_history_log" */
export enum JobHistoryLog_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobHistoryLogPkey = 'job_history_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type JobHistoryLog_Delete_At_Path_Input = {
  jobStepMetadata?: InputMaybe<Array<Scalars['String']>>;
  result?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type JobHistoryLog_Delete_Elem_Input = {
  jobStepMetadata?: InputMaybe<Scalars['Int']>;
  result?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type JobHistoryLog_Delete_Key_Input = {
  jobStepMetadata?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "system.job_history_log" */
export type JobHistoryLog_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endDatetime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobHistory?: InputMaybe<JobHistory_Obj_Rel_Insert_Input>;
  jobHistoryId?: InputMaybe<Scalars['uuid']>;
  jobStep?: InputMaybe<JobStep_Obj_Rel_Insert_Input>;
  jobStepId?: InputMaybe<Scalars['uuid']>;
  jobStepMetadata?: InputMaybe<Scalars['jsonb']>;
  message?: InputMaybe<Scalars['String']>;
  referenceLogs?: InputMaybe<ReferenceLog_Arr_Rel_Insert_Input>;
  result?: InputMaybe<Scalars['jsonb']>;
  startDatetime?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wasSuccessful?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type JobHistoryLog_Max_Fields = {
  __typename?: 'jobHistoryLog_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  endDatetime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  jobHistoryId?: Maybe<Scalars['uuid']>;
  jobStepId?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  startDatetime?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "system.job_history_log" */
export type JobHistoryLog_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDatetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobHistoryId?: InputMaybe<Order_By>;
  jobStepId?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  startDatetime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type JobHistoryLog_Min_Fields = {
  __typename?: 'jobHistoryLog_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  endDatetime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  jobHistoryId?: Maybe<Scalars['uuid']>;
  jobStepId?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  startDatetime?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "system.job_history_log" */
export type JobHistoryLog_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDatetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobHistoryId?: InputMaybe<Order_By>;
  jobStepId?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  startDatetime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "system.job_history_log" */
export type JobHistoryLog_Mutation_Response = {
  __typename?: 'jobHistoryLog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobHistoryLog>;
};

/** input type for inserting object relation for remote table "system.job_history_log" */
export type JobHistoryLog_Obj_Rel_Insert_Input = {
  data: JobHistoryLog_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<JobHistoryLog_On_Conflict>;
};

/** on_conflict condition type for table "system.job_history_log" */
export type JobHistoryLog_On_Conflict = {
  constraint: JobHistoryLog_Constraint;
  update_columns?: Array<JobHistoryLog_Update_Column>;
  where?: InputMaybe<JobHistoryLog_Bool_Exp>;
};

/** Ordering options when selecting data from "system.job_history_log". */
export type JobHistoryLog_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDatetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobHistory?: InputMaybe<JobHistory_Order_By>;
  jobHistoryId?: InputMaybe<Order_By>;
  jobStep?: InputMaybe<JobStep_Order_By>;
  jobStepId?: InputMaybe<Order_By>;
  jobStepMetadata?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  referenceLogs_aggregate?: InputMaybe<ReferenceLog_Aggregate_Order_By>;
  result?: InputMaybe<Order_By>;
  startDatetime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  wasSuccessful?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.job_history_log */
export type JobHistoryLog_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type JobHistoryLog_Prepend_Input = {
  jobStepMetadata?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "system.job_history_log" */
export enum JobHistoryLog_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDatetime = 'endDatetime',
  /** column name */
  Id = 'id',
  /** column name */
  JobHistoryId = 'jobHistoryId',
  /** column name */
  JobStepId = 'jobStepId',
  /** column name */
  JobStepMetadata = 'jobStepMetadata',
  /** column name */
  Message = 'message',
  /** column name */
  Result = 'result',
  /** column name */
  StartDatetime = 'startDatetime',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WasSuccessful = 'wasSuccessful'
}

/** select "jobHistoryLog_aggregate_bool_exp_bool_and_arguments_columns" columns of table "system.job_history_log" */
export enum JobHistoryLog_Select_Column_JobHistoryLog_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  WasSuccessful = 'wasSuccessful'
}

/** select "jobHistoryLog_aggregate_bool_exp_bool_or_arguments_columns" columns of table "system.job_history_log" */
export enum JobHistoryLog_Select_Column_JobHistoryLog_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  WasSuccessful = 'wasSuccessful'
}

/** input type for updating data in table "system.job_history_log" */
export type JobHistoryLog_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endDatetime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobHistoryId?: InputMaybe<Scalars['uuid']>;
  jobStepId?: InputMaybe<Scalars['uuid']>;
  jobStepMetadata?: InputMaybe<Scalars['jsonb']>;
  message?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['jsonb']>;
  startDatetime?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wasSuccessful?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "jobHistoryLog" */
export type JobHistoryLog_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JobHistoryLog_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JobHistoryLog_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endDatetime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobHistoryId?: InputMaybe<Scalars['uuid']>;
  jobStepId?: InputMaybe<Scalars['uuid']>;
  jobStepMetadata?: InputMaybe<Scalars['jsonb']>;
  message?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['jsonb']>;
  startDatetime?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wasSuccessful?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "system.job_history_log" */
export enum JobHistoryLog_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDatetime = 'endDatetime',
  /** column name */
  Id = 'id',
  /** column name */
  JobHistoryId = 'jobHistoryId',
  /** column name */
  JobStepId = 'jobStepId',
  /** column name */
  JobStepMetadata = 'jobStepMetadata',
  /** column name */
  Message = 'message',
  /** column name */
  Result = 'result',
  /** column name */
  StartDatetime = 'startDatetime',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WasSuccessful = 'wasSuccessful'
}

export type JobHistoryLog_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<JobHistoryLog_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<JobHistoryLog_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<JobHistoryLog_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<JobHistoryLog_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<JobHistoryLog_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobHistoryLog_Set_Input>;
  /** filter the rows which have to be updated */
  where: JobHistoryLog_Bool_Exp;
};

/** aggregated selection of "system.job_history" */
export type JobHistory_Aggregate = {
  __typename?: 'jobHistory_aggregate';
  aggregate?: Maybe<JobHistory_Aggregate_Fields>;
  nodes: Array<JobHistory>;
};

export type JobHistory_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<JobHistory_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<JobHistory_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<JobHistory_Aggregate_Bool_Exp_Count>;
};

export type JobHistory_Aggregate_Bool_Exp_Bool_And = {
  arguments: JobHistory_Select_Column_JobHistory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobHistory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type JobHistory_Aggregate_Bool_Exp_Bool_Or = {
  arguments: JobHistory_Select_Column_JobHistory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobHistory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type JobHistory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<JobHistory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobHistory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "system.job_history" */
export type JobHistory_Aggregate_Fields = {
  __typename?: 'jobHistory_aggregate_fields';
  avg?: Maybe<JobHistory_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<JobHistory_Max_Fields>;
  min?: Maybe<JobHistory_Min_Fields>;
  stddev?: Maybe<JobHistory_Stddev_Fields>;
  stddev_pop?: Maybe<JobHistory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<JobHistory_Stddev_Samp_Fields>;
  sum?: Maybe<JobHistory_Sum_Fields>;
  var_pop?: Maybe<JobHistory_Var_Pop_Fields>;
  var_samp?: Maybe<JobHistory_Var_Samp_Fields>;
  variance?: Maybe<JobHistory_Variance_Fields>;
};


/** aggregate fields of "system.job_history" */
export type JobHistory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JobHistory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "system.job_history" */
export type JobHistory_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<JobHistory_Max_Order_By>;
  min?: InputMaybe<JobHistory_Min_Order_By>;
};

/** input type for inserting array relation for remote table "system.job_history" */
export type JobHistory_Arr_Rel_Insert_Input = {
  data: Array<JobHistory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<JobHistory_On_Conflict>;
};

/** aggregate avg on columns */
export type JobHistory_Avg_Fields = {
  __typename?: 'jobHistory_avg_fields';
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "system.job_history". All fields are combined with a logical 'AND'. */
export type JobHistory_Bool_Exp = {
  _and?: InputMaybe<Array<JobHistory_Bool_Exp>>;
  _not?: InputMaybe<JobHistory_Bool_Exp>;
  _or?: InputMaybe<Array<JobHistory_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endDatetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isRunning?: InputMaybe<Boolean_Comparison_Exp>;
  job?: InputMaybe<Job_Bool_Exp>;
  jobHistoryLogs?: InputMaybe<JobHistoryLog_Bool_Exp>;
  jobHistoryLogs_aggregate?: InputMaybe<JobHistoryLog_Aggregate_Bool_Exp>;
  jobId?: InputMaybe<Uuid_Comparison_Exp>;
  referenceLogCount?: InputMaybe<Numeric_Comparison_Exp>;
  startDatetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  startingJobStep?: InputMaybe<JobStep_Bool_Exp>;
  startingJobStepId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  wasScheduled?: InputMaybe<Boolean_Comparison_Exp>;
  wasSuccessful?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.job_history" */
export enum JobHistory_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobHistoryPkey = 'job_history_pkey'
}

/** input type for inserting data into table "system.job_history" */
export type JobHistory_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endDatetime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isRunning?: InputMaybe<Scalars['Boolean']>;
  job?: InputMaybe<Job_Obj_Rel_Insert_Input>;
  jobHistoryLogs?: InputMaybe<JobHistoryLog_Arr_Rel_Insert_Input>;
  jobId?: InputMaybe<Scalars['uuid']>;
  startDatetime?: InputMaybe<Scalars['timestamptz']>;
  startingJobStep?: InputMaybe<JobStep_Obj_Rel_Insert_Input>;
  startingJobStepId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wasScheduled?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type JobHistory_Max_Fields = {
  __typename?: 'jobHistory_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  endDatetime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
  startDatetime?: Maybe<Scalars['timestamptz']>;
  startingJobStepId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "system.find_was_successful" */
  wasSuccessful?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "system.job_history" */
export type JobHistory_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDatetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  startDatetime?: InputMaybe<Order_By>;
  startingJobStepId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type JobHistory_Min_Fields = {
  __typename?: 'jobHistory_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  endDatetime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
  startDatetime?: Maybe<Scalars['timestamptz']>;
  startingJobStepId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "system.find_was_successful" */
  wasSuccessful?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "system.job_history" */
export type JobHistory_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDatetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  startDatetime?: InputMaybe<Order_By>;
  startingJobStepId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "system.job_history" */
export type JobHistory_Mutation_Response = {
  __typename?: 'jobHistory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobHistory>;
};

/** input type for inserting object relation for remote table "system.job_history" */
export type JobHistory_Obj_Rel_Insert_Input = {
  data: JobHistory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<JobHistory_On_Conflict>;
};

/** on_conflict condition type for table "system.job_history" */
export type JobHistory_On_Conflict = {
  constraint: JobHistory_Constraint;
  update_columns?: Array<JobHistory_Update_Column>;
  where?: InputMaybe<JobHistory_Bool_Exp>;
};

/** Ordering options when selecting data from "system.job_history". */
export type JobHistory_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDatetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isRunning?: InputMaybe<Order_By>;
  job?: InputMaybe<Job_Order_By>;
  jobHistoryLogs_aggregate?: InputMaybe<JobHistoryLog_Aggregate_Order_By>;
  jobId?: InputMaybe<Order_By>;
  referenceLogCount?: InputMaybe<Order_By>;
  startDatetime?: InputMaybe<Order_By>;
  startingJobStep?: InputMaybe<JobStep_Order_By>;
  startingJobStepId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  wasScheduled?: InputMaybe<Order_By>;
  wasSuccessful?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.job_history */
export type JobHistory_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "system.job_history" */
export enum JobHistory_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDatetime = 'endDatetime',
  /** column name */
  Id = 'id',
  /** column name */
  IsRunning = 'isRunning',
  /** column name */
  JobId = 'jobId',
  /** column name */
  StartDatetime = 'startDatetime',
  /** column name */
  StartingJobStepId = 'startingJobStepId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WasScheduled = 'wasScheduled'
}

/** select "jobHistory_aggregate_bool_exp_bool_and_arguments_columns" columns of table "system.job_history" */
export enum JobHistory_Select_Column_JobHistory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRunning = 'isRunning',
  /** column name */
  WasScheduled = 'wasScheduled'
}

/** select "jobHistory_aggregate_bool_exp_bool_or_arguments_columns" columns of table "system.job_history" */
export enum JobHistory_Select_Column_JobHistory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRunning = 'isRunning',
  /** column name */
  WasScheduled = 'wasScheduled'
}

/** input type for updating data in table "system.job_history" */
export type JobHistory_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endDatetime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isRunning?: InputMaybe<Scalars['Boolean']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  startDatetime?: InputMaybe<Scalars['timestamptz']>;
  startingJobStepId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wasScheduled?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type JobHistory_Stddev_Fields = {
  __typename?: 'jobHistory_stddev_fields';
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_pop on columns */
export type JobHistory_Stddev_Pop_Fields = {
  __typename?: 'jobHistory_stddev_pop_fields';
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_samp on columns */
export type JobHistory_Stddev_Samp_Fields = {
  __typename?: 'jobHistory_stddev_samp_fields';
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "jobHistory" */
export type JobHistory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JobHistory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JobHistory_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endDatetime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isRunning?: InputMaybe<Scalars['Boolean']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  startDatetime?: InputMaybe<Scalars['timestamptz']>;
  startingJobStepId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wasScheduled?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type JobHistory_Sum_Fields = {
  __typename?: 'jobHistory_sum_fields';
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "system.job_history" */
export enum JobHistory_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDatetime = 'endDatetime',
  /** column name */
  Id = 'id',
  /** column name */
  IsRunning = 'isRunning',
  /** column name */
  JobId = 'jobId',
  /** column name */
  StartDatetime = 'startDatetime',
  /** column name */
  StartingJobStepId = 'startingJobStepId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WasScheduled = 'wasScheduled'
}

export type JobHistory_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobHistory_Set_Input>;
  /** filter the rows which have to be updated */
  where: JobHistory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type JobHistory_Var_Pop_Fields = {
  __typename?: 'jobHistory_var_pop_fields';
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_samp on columns */
export type JobHistory_Var_Samp_Fields = {
  __typename?: 'jobHistory_var_samp_fields';
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
};

/** aggregate variance on columns */
export type JobHistory_Variance_Fields = {
  __typename?: 'jobHistory_variance_fields';
  /** A computed field, executes function "system.calculate_reference_log_count" */
  referenceLogCount?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "system.job_list_view" */
export type JobListView = {
  __typename?: 'jobListView';
  applicationId?: Maybe<Scalars['uuid']>;
  applicationName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  executionNumber?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  jobSteps: Array<JobStep>;
  /** An aggregate relationship */
  jobSteps_aggregate: JobStep_Aggregate;
  /** An object relationship */
  latestJobHistory?: Maybe<JobHistory>;
  latestJobHistoryId?: Maybe<Scalars['uuid']>;
  latestStartDatetime?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  numberOfSteps?: Maybe<Scalars['Int']>;
  startingJobStepId?: Maybe<Scalars['uuid']>;
  technologyType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "system.job_list_view" */
export type JobListViewJobStepsArgs = {
  distinct_on?: InputMaybe<Array<JobStep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobStep_Order_By>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};


/** columns and relationships of "system.job_list_view" */
export type JobListViewJobSteps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JobStep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobStep_Order_By>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};

/** aggregated selection of "system.job_list_view" */
export type JobListView_Aggregate = {
  __typename?: 'jobListView_aggregate';
  aggregate?: Maybe<JobListView_Aggregate_Fields>;
  nodes: Array<JobListView>;
};

/** aggregate fields of "system.job_list_view" */
export type JobListView_Aggregate_Fields = {
  __typename?: 'jobListView_aggregate_fields';
  avg?: Maybe<JobListView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<JobListView_Max_Fields>;
  min?: Maybe<JobListView_Min_Fields>;
  stddev?: Maybe<JobListView_Stddev_Fields>;
  stddev_pop?: Maybe<JobListView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<JobListView_Stddev_Samp_Fields>;
  sum?: Maybe<JobListView_Sum_Fields>;
  var_pop?: Maybe<JobListView_Var_Pop_Fields>;
  var_samp?: Maybe<JobListView_Var_Samp_Fields>;
  variance?: Maybe<JobListView_Variance_Fields>;
};


/** aggregate fields of "system.job_list_view" */
export type JobListView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JobListView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JobListView_Avg_Fields = {
  __typename?: 'jobListView_avg_fields';
  executionNumber?: Maybe<Scalars['Float']>;
  numberOfSteps?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "system.job_list_view". All fields are combined with a logical 'AND'. */
export type JobListView_Bool_Exp = {
  _and?: InputMaybe<Array<JobListView_Bool_Exp>>;
  _not?: InputMaybe<JobListView_Bool_Exp>;
  _or?: InputMaybe<Array<JobListView_Bool_Exp>>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  applicationName?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  executionNumber?: InputMaybe<Int_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobSteps?: InputMaybe<JobStep_Bool_Exp>;
  jobSteps_aggregate?: InputMaybe<JobStep_Aggregate_Bool_Exp>;
  latestJobHistory?: InputMaybe<JobHistory_Bool_Exp>;
  latestJobHistoryId?: InputMaybe<Uuid_Comparison_Exp>;
  latestStartDatetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numberOfSteps?: InputMaybe<Int_Comparison_Exp>;
  startingJobStepId?: InputMaybe<Uuid_Comparison_Exp>;
  technologyType?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type JobListView_Max_Fields = {
  __typename?: 'jobListView_max_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  applicationName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  executionNumber?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  latestJobHistoryId?: Maybe<Scalars['uuid']>;
  latestStartDatetime?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  numberOfSteps?: Maybe<Scalars['Int']>;
  startingJobStepId?: Maybe<Scalars['uuid']>;
  technologyType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JobListView_Min_Fields = {
  __typename?: 'jobListView_min_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  applicationName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  executionNumber?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  latestJobHistoryId?: Maybe<Scalars['uuid']>;
  latestStartDatetime?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  numberOfSteps?: Maybe<Scalars['Int']>;
  startingJobStepId?: Maybe<Scalars['uuid']>;
  technologyType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "system.job_list_view". */
export type JobListView_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  applicationName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  executionNumber?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobSteps_aggregate?: InputMaybe<JobStep_Aggregate_Order_By>;
  latestJobHistory?: InputMaybe<JobHistory_Order_By>;
  latestJobHistoryId?: InputMaybe<Order_By>;
  latestStartDatetime?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfSteps?: InputMaybe<Order_By>;
  startingJobStepId?: InputMaybe<Order_By>;
  technologyType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "system.job_list_view" */
export enum JobListView_Select_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  ApplicationName = 'applicationName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExecutionNumber = 'executionNumber',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  LatestJobHistoryId = 'latestJobHistoryId',
  /** column name */
  LatestStartDatetime = 'latestStartDatetime',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfSteps = 'numberOfSteps',
  /** column name */
  StartingJobStepId = 'startingJobStepId',
  /** column name */
  TechnologyType = 'technologyType',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type JobListView_Stddev_Fields = {
  __typename?: 'jobListView_stddev_fields';
  executionNumber?: Maybe<Scalars['Float']>;
  numberOfSteps?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type JobListView_Stddev_Pop_Fields = {
  __typename?: 'jobListView_stddev_pop_fields';
  executionNumber?: Maybe<Scalars['Float']>;
  numberOfSteps?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type JobListView_Stddev_Samp_Fields = {
  __typename?: 'jobListView_stddev_samp_fields';
  executionNumber?: Maybe<Scalars['Float']>;
  numberOfSteps?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "jobListView" */
export type JobListView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JobListView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JobListView_Stream_Cursor_Value_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  applicationName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  executionNumber?: InputMaybe<Scalars['Int']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  latestJobHistoryId?: InputMaybe<Scalars['uuid']>;
  latestStartDatetime?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  numberOfSteps?: InputMaybe<Scalars['Int']>;
  startingJobStepId?: InputMaybe<Scalars['uuid']>;
  technologyType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type JobListView_Sum_Fields = {
  __typename?: 'jobListView_sum_fields';
  executionNumber?: Maybe<Scalars['Int']>;
  numberOfSteps?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type JobListView_Var_Pop_Fields = {
  __typename?: 'jobListView_var_pop_fields';
  executionNumber?: Maybe<Scalars['Float']>;
  numberOfSteps?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type JobListView_Var_Samp_Fields = {
  __typename?: 'jobListView_var_samp_fields';
  executionNumber?: Maybe<Scalars['Float']>;
  numberOfSteps?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JobListView_Variance_Fields = {
  __typename?: 'jobListView_variance_fields';
  executionNumber?: Maybe<Scalars['Float']>;
  numberOfSteps?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "system.job_schedule" */
export type JobSchedule = {
  __typename?: 'jobSchedule';
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  job?: Maybe<Job>;
  jobId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  name?: Maybe<Scalars['String']>;
  scheduleMetadata?: Maybe<Scalars['jsonb']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "system.job_schedule" */
export type JobScheduleEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "system.job_schedule" */
export type JobScheduleEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "system.job_schedule" */
export type JobScheduleLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "system.job_schedule" */
export type JobScheduleLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "system.job_schedule" */
export type JobScheduleScheduleMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "system.job_schedule" */
export type JobSchedule_Aggregate = {
  __typename?: 'jobSchedule_aggregate';
  aggregate?: Maybe<JobSchedule_Aggregate_Fields>;
  nodes: Array<JobSchedule>;
};

export type JobSchedule_Aggregate_Bool_Exp = {
  count?: InputMaybe<JobSchedule_Aggregate_Bool_Exp_Count>;
};

export type JobSchedule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<JobSchedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobSchedule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "system.job_schedule" */
export type JobSchedule_Aggregate_Fields = {
  __typename?: 'jobSchedule_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<JobSchedule_Max_Fields>;
  min?: Maybe<JobSchedule_Min_Fields>;
};


/** aggregate fields of "system.job_schedule" */
export type JobSchedule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JobSchedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "system.job_schedule" */
export type JobSchedule_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<JobSchedule_Max_Order_By>;
  min?: InputMaybe<JobSchedule_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type JobSchedule_Append_Input = {
  scheduleMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "system.job_schedule" */
export type JobSchedule_Arr_Rel_Insert_Input = {
  data: Array<JobSchedule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<JobSchedule_On_Conflict>;
};

/** Boolean expression to filter rows from the table "system.job_schedule". All fields are combined with a logical 'AND'. */
export type JobSchedule_Bool_Exp = {
  _and?: InputMaybe<Array<JobSchedule_Bool_Exp>>;
  _not?: InputMaybe<JobSchedule_Bool_Exp>;
  _or?: InputMaybe<Array<JobSchedule_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job?: InputMaybe<Job_Bool_Exp>;
  jobId?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  scheduleMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.job_schedule" */
export enum JobSchedule_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobEventPkey = 'job_event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type JobSchedule_Delete_At_Path_Input = {
  scheduleMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type JobSchedule_Delete_Elem_Input = {
  scheduleMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type JobSchedule_Delete_Key_Input = {
  scheduleMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "system.job_schedule" */
export type JobSchedule_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<Job_Obj_Rel_Insert_Input>;
  jobId?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  scheduleMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobSchedule_Max_Fields = {
  __typename?: 'jobSchedule_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "system.job_schedule" */
export type JobSchedule_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type JobSchedule_Min_Fields = {
  __typename?: 'jobSchedule_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "system.job_schedule" */
export type JobSchedule_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "system.job_schedule" */
export type JobSchedule_Mutation_Response = {
  __typename?: 'jobSchedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobSchedule>;
};

/** on_conflict condition type for table "system.job_schedule" */
export type JobSchedule_On_Conflict = {
  constraint: JobSchedule_Constraint;
  update_columns?: Array<JobSchedule_Update_Column>;
  where?: InputMaybe<JobSchedule_Bool_Exp>;
};

/** Ordering options when selecting data from "system.job_schedule". */
export type JobSchedule_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job?: InputMaybe<Job_Order_By>;
  jobId?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  scheduleMetadata?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.job_schedule */
export type JobSchedule_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type JobSchedule_Prepend_Input = {
  scheduleMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "system.job_schedule" */
export enum JobSchedule_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'jobId',
  /** column name */
  Name = 'name',
  /** column name */
  ScheduleMetadata = 'scheduleMetadata',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "system.job_schedule" */
export type JobSchedule_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  scheduleMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "jobSchedule" */
export type JobSchedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JobSchedule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JobSchedule_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  scheduleMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "system.job_schedule" */
export enum JobSchedule_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'jobId',
  /** column name */
  Name = 'name',
  /** column name */
  ScheduleMetadata = 'scheduleMetadata',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type JobSchedule_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<JobSchedule_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<JobSchedule_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<JobSchedule_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<JobSchedule_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<JobSchedule_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobSchedule_Set_Input>;
  /** filter the rows which have to be updated */
  where: JobSchedule_Bool_Exp;
};

/** columns and relationships of "system.job_step" */
export type JobStep = {
  __typename?: 'jobStep';
  args?: Maybe<Scalars['String']>;
  /** An object relationship */
  argsFromJobStep?: Maybe<JobStep>;
  argsFromJobStepId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  job: Job;
  jobId: Scalars['uuid'];
  /** An object relationship */
  onFailureNextJobStep?: Maybe<JobStep>;
  onFailureNextJobStepId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  onSuccessNextJobStep?: Maybe<JobStep>;
  onSuccessNextJobStepId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  step: Step;
  stepId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "system.job_step" */
export type JobStep_Aggregate = {
  __typename?: 'jobStep_aggregate';
  aggregate?: Maybe<JobStep_Aggregate_Fields>;
  nodes: Array<JobStep>;
};

export type JobStep_Aggregate_Bool_Exp = {
  count?: InputMaybe<JobStep_Aggregate_Bool_Exp_Count>;
};

export type JobStep_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<JobStep_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobStep_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "system.job_step" */
export type JobStep_Aggregate_Fields = {
  __typename?: 'jobStep_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<JobStep_Max_Fields>;
  min?: Maybe<JobStep_Min_Fields>;
};


/** aggregate fields of "system.job_step" */
export type JobStep_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JobStep_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "system.job_step" */
export type JobStep_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<JobStep_Max_Order_By>;
  min?: InputMaybe<JobStep_Min_Order_By>;
};

/** input type for inserting array relation for remote table "system.job_step" */
export type JobStep_Arr_Rel_Insert_Input = {
  data: Array<JobStep_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<JobStep_On_Conflict>;
};

/** Boolean expression to filter rows from the table "system.job_step". All fields are combined with a logical 'AND'. */
export type JobStep_Bool_Exp = {
  _and?: InputMaybe<Array<JobStep_Bool_Exp>>;
  _not?: InputMaybe<JobStep_Bool_Exp>;
  _or?: InputMaybe<Array<JobStep_Bool_Exp>>;
  args?: InputMaybe<String_Comparison_Exp>;
  argsFromJobStep?: InputMaybe<JobStep_Bool_Exp>;
  argsFromJobStepId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job?: InputMaybe<Job_Bool_Exp>;
  jobId?: InputMaybe<Uuid_Comparison_Exp>;
  onFailureNextJobStep?: InputMaybe<JobStep_Bool_Exp>;
  onFailureNextJobStepId?: InputMaybe<Uuid_Comparison_Exp>;
  onSuccessNextJobStep?: InputMaybe<JobStep_Bool_Exp>;
  onSuccessNextJobStepId?: InputMaybe<Uuid_Comparison_Exp>;
  step?: InputMaybe<Step_Bool_Exp>;
  stepId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.job_step" */
export enum JobStep_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobStepPkey = 'job_step_pkey'
}

/** input type for inserting data into table "system.job_step" */
export type JobStep_Insert_Input = {
  args?: InputMaybe<Scalars['String']>;
  argsFromJobStep?: InputMaybe<JobStep_Obj_Rel_Insert_Input>;
  argsFromJobStepId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<Job_Obj_Rel_Insert_Input>;
  jobId?: InputMaybe<Scalars['uuid']>;
  onFailureNextJobStep?: InputMaybe<JobStep_Obj_Rel_Insert_Input>;
  onFailureNextJobStepId?: InputMaybe<Scalars['uuid']>;
  onSuccessNextJobStep?: InputMaybe<JobStep_Obj_Rel_Insert_Input>;
  onSuccessNextJobStepId?: InputMaybe<Scalars['uuid']>;
  step?: InputMaybe<Step_Obj_Rel_Insert_Input>;
  stepId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobStep_Max_Fields = {
  __typename?: 'jobStep_max_fields';
  args?: Maybe<Scalars['String']>;
  argsFromJobStepId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['uuid']>;
  onFailureNextJobStepId?: Maybe<Scalars['uuid']>;
  onSuccessNextJobStepId?: Maybe<Scalars['uuid']>;
  stepId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "system.job_step" */
export type JobStep_Max_Order_By = {
  args?: InputMaybe<Order_By>;
  argsFromJobStepId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  onFailureNextJobStepId?: InputMaybe<Order_By>;
  onSuccessNextJobStepId?: InputMaybe<Order_By>;
  stepId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type JobStep_Min_Fields = {
  __typename?: 'jobStep_min_fields';
  args?: Maybe<Scalars['String']>;
  argsFromJobStepId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['uuid']>;
  onFailureNextJobStepId?: Maybe<Scalars['uuid']>;
  onSuccessNextJobStepId?: Maybe<Scalars['uuid']>;
  stepId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "system.job_step" */
export type JobStep_Min_Order_By = {
  args?: InputMaybe<Order_By>;
  argsFromJobStepId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  onFailureNextJobStepId?: InputMaybe<Order_By>;
  onSuccessNextJobStepId?: InputMaybe<Order_By>;
  stepId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "system.job_step" */
export type JobStep_Mutation_Response = {
  __typename?: 'jobStep_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobStep>;
};

/** input type for inserting object relation for remote table "system.job_step" */
export type JobStep_Obj_Rel_Insert_Input = {
  data: JobStep_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<JobStep_On_Conflict>;
};

/** on_conflict condition type for table "system.job_step" */
export type JobStep_On_Conflict = {
  constraint: JobStep_Constraint;
  update_columns?: Array<JobStep_Update_Column>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};

/** Ordering options when selecting data from "system.job_step". */
export type JobStep_Order_By = {
  args?: InputMaybe<Order_By>;
  argsFromJobStep?: InputMaybe<JobStep_Order_By>;
  argsFromJobStepId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job?: InputMaybe<Job_Order_By>;
  jobId?: InputMaybe<Order_By>;
  onFailureNextJobStep?: InputMaybe<JobStep_Order_By>;
  onFailureNextJobStepId?: InputMaybe<Order_By>;
  onSuccessNextJobStep?: InputMaybe<JobStep_Order_By>;
  onSuccessNextJobStepId?: InputMaybe<Order_By>;
  step?: InputMaybe<Step_Order_By>;
  stepId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.job_step */
export type JobStep_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "system.job_step" */
export enum JobStep_Select_Column {
  /** column name */
  Args = 'args',
  /** column name */
  ArgsFromJobStepId = 'argsFromJobStepId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'jobId',
  /** column name */
  OnFailureNextJobStepId = 'onFailureNextJobStepId',
  /** column name */
  OnSuccessNextJobStepId = 'onSuccessNextJobStepId',
  /** column name */
  StepId = 'stepId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "system.job_step" */
export type JobStep_Set_Input = {
  args?: InputMaybe<Scalars['String']>;
  argsFromJobStepId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  onFailureNextJobStepId?: InputMaybe<Scalars['uuid']>;
  onSuccessNextJobStepId?: InputMaybe<Scalars['uuid']>;
  stepId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "jobStep" */
export type JobStep_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JobStep_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JobStep_Stream_Cursor_Value_Input = {
  args?: InputMaybe<Scalars['String']>;
  argsFromJobStepId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  onFailureNextJobStepId?: InputMaybe<Scalars['uuid']>;
  onSuccessNextJobStepId?: InputMaybe<Scalars['uuid']>;
  stepId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "system.job_step" */
export enum JobStep_Update_Column {
  /** column name */
  Args = 'args',
  /** column name */
  ArgsFromJobStepId = 'argsFromJobStepId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'jobId',
  /** column name */
  OnFailureNextJobStepId = 'onFailureNextJobStepId',
  /** column name */
  OnSuccessNextJobStepId = 'onSuccessNextJobStepId',
  /** column name */
  StepId = 'stepId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type JobStep_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobStep_Set_Input>;
  /** filter the rows which have to be updated */
  where: JobStep_Bool_Exp;
};

/** aggregated selection of "system.job" */
export type Job_Aggregate = {
  __typename?: 'job_aggregate';
  aggregate?: Maybe<Job_Aggregate_Fields>;
  nodes: Array<Job>;
};

/** aggregate fields of "system.job" */
export type Job_Aggregate_Fields = {
  __typename?: 'job_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Job_Max_Fields>;
  min?: Maybe<Job_Min_Fields>;
};


/** aggregate fields of "system.job" */
export type Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "system.job". All fields are combined with a logical 'AND'. */
export type Job_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Bool_Exp>>;
  _not?: InputMaybe<Job_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Bool_Exp>>;
  application?: InputMaybe<Application_Bool_Exp>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobHistories?: InputMaybe<JobHistory_Bool_Exp>;
  jobHistories_aggregate?: InputMaybe<JobHistory_Aggregate_Bool_Exp>;
  jobSchedules?: InputMaybe<JobSchedule_Bool_Exp>;
  jobSchedules_aggregate?: InputMaybe<JobSchedule_Aggregate_Bool_Exp>;
  jobSteps?: InputMaybe<JobStep_Bool_Exp>;
  jobSteps_aggregate?: InputMaybe<JobStep_Aggregate_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  startingJobStep?: InputMaybe<JobStep_Bool_Exp>;
  startingJobStepId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.job" */
export enum Job_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobPkey = 'job_pkey'
}

/** input type for inserting data into table "system.job" */
export type Job_Insert_Input = {
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobHistories?: InputMaybe<JobHistory_Arr_Rel_Insert_Input>;
  jobSchedules?: InputMaybe<JobSchedule_Arr_Rel_Insert_Input>;
  jobSteps?: InputMaybe<JobStep_Arr_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  startingJobStep?: InputMaybe<JobStep_Obj_Rel_Insert_Input>;
  startingJobStepId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Job_Max_Fields = {
  __typename?: 'job_max_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  startingJobStepId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Job_Min_Fields = {
  __typename?: 'job_min_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  startingJobStepId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "system.job" */
export type Job_Mutation_Response = {
  __typename?: 'job_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job>;
};

/** input type for inserting object relation for remote table "system.job" */
export type Job_Obj_Rel_Insert_Input = {
  data: Job_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_On_Conflict>;
};

/** on_conflict condition type for table "system.job" */
export type Job_On_Conflict = {
  constraint: Job_Constraint;
  update_columns?: Array<Job_Update_Column>;
  where?: InputMaybe<Job_Bool_Exp>;
};

/** Ordering options when selecting data from "system.job". */
export type Job_Order_By = {
  application?: InputMaybe<Application_Order_By>;
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobHistories_aggregate?: InputMaybe<JobHistory_Aggregate_Order_By>;
  jobSchedules_aggregate?: InputMaybe<JobSchedule_Aggregate_Order_By>;
  jobSteps_aggregate?: InputMaybe<JobStep_Aggregate_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  startingJobStep?: InputMaybe<JobStep_Order_By>;
  startingJobStepId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.job */
export type Job_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "system.job" */
export enum Job_Select_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StartingJobStepId = 'startingJobStepId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "system.job" */
export type Job_Set_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  startingJobStepId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job" */
export type Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Stream_Cursor_Value_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  startingJobStepId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "system.job" */
export enum Job_Update_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StartingJobStepId = 'startingJobStepId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Job_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Bool_Exp;
};

/** One contract activity with its money, copied at the time of entry; its lines are in journal_entry_line. Written only by the database, which may update it in place. */
export type JournalEntry = {
  __typename?: 'journalEntry';
  /** The contract's account (dealer) code, as a snapshot at the time of entry. */
  accountCode?: Maybe<Scalars['String']>;
  /** The contract's account (dealer) name, as a snapshot at the time of entry. */
  accountName?: Maybe<Scalars['String']>;
  /** The category code of the contract's product, as a snapshot at the time of entry. */
  categoryCode?: Maybe<Scalars['String']>;
  /** When the entry was written. */
  createdAt: Scalars['timestamptz'];
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  cycleJournalEntries: Array<CycleJournalEntry>;
  /** An aggregate relationship */
  cycleJournalEntries_aggregate: CycleJournalEntry_Aggregate;
  /** The business date of the entry. It does not place the entry in a Cycle: that is done in cycle_journal_entry. Back-filled entries carry the contract's month-end posted date, since their activation date is not known. */
  entryDate: Scalars['date'];
  /** Primary key. */
  id: Scalars['uuid'];
  /** An array relationship */
  journalEntryLines: Array<JournalEntryLine>;
  /** An aggregate relationship */
  journalEntryLines_aggregate: JournalEntryLine_Aggregate;
  /** An object relationship */
  journalEntryType: Type;
  /** shared.type in the JournalEntryType group: the kind of activity. New Business is the only type so far. */
  journalEntryTypeId: Scalars['uuid'];
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  policyContract: PolicyContract;
  /** The contract the activity is about. The foreign key is checked at commit, so a contract deleted and inserted again under the same id in one transaction keeps its entries; deleting a contract outright is refused while it has entries. */
  policyContractId: Scalars['uuid'];
  /** The contract number, as a snapshot at the time of entry. */
  policyContractNumber: Scalars['String'];
  /** The contract's product name, as a snapshot at the time of entry. */
  productName?: Maybe<Scalars['String']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
  /** When the entry was last updated (maintained by trigger). */
  updatedAt: Scalars['timestamptz'];
};


/** One contract activity with its money, copied at the time of entry; its lines are in journal_entry_line. Written only by the database, which may update it in place. */
export type JournalEntryCycleJournalEntriesArgs = {
  distinct_on?: InputMaybe<Array<CycleJournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleJournalEntry_Order_By>>;
  where?: InputMaybe<CycleJournalEntry_Bool_Exp>;
};


/** One contract activity with its money, copied at the time of entry; its lines are in journal_entry_line. Written only by the database, which may update it in place. */
export type JournalEntryCycleJournalEntries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CycleJournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleJournalEntry_Order_By>>;
  where?: InputMaybe<CycleJournalEntry_Bool_Exp>;
};


/** One contract activity with its money, copied at the time of entry; its lines are in journal_entry_line. Written only by the database, which may update it in place. */
export type JournalEntryJournalEntryLinesArgs = {
  distinct_on?: InputMaybe<Array<JournalEntryLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntryLine_Order_By>>;
  where?: InputMaybe<JournalEntryLine_Bool_Exp>;
};


/** One contract activity with its money, copied at the time of entry; its lines are in journal_entry_line. Written only by the database, which may update it in place. */
export type JournalEntryJournalEntryLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JournalEntryLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntryLine_Order_By>>;
  where?: InputMaybe<JournalEntryLine_Bool_Exp>;
};


/** One contract activity with its money, copied at the time of entry; its lines are in journal_entry_line. Written only by the database, which may update it in place. */
export type JournalEntryLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** A money line on a Journal Entry: one per Bucket or surcharge with a non-zero amount, and one per disbursement. A Bucket or surcharge with no line was $0, or the contract's cost detail gave no amount for it. Written only by the database. */
export type JournalEntryLine = {
  __typename?: 'journalEntryLine';
  /** The line's amount in dollars. */
  amount: Scalars['numeric'];
  /** When the line was written. */
  createdAt: Scalars['timestamptz'];
  /** For a disbursement line, its disbursement code from the contract's cost detail. */
  disbursementCode?: Maybe<Scalars['String']>;
  /** Primary key. */
  id: Scalars['uuid'];
  /** An object relationship */
  journalEntry: JournalEntry;
  /** The entry the line belongs to. */
  journalEntryId: Scalars['uuid'];
  /** An object relationship */
  journalEntryLineType: Type;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId: Scalars['uuid'];
  /** The Bucket, disbursement type or surcharge the line is for. */
  name: Scalars['String'];
  /** An object relationship */
  payee?: Maybe<Payee>;
  /** The Payee to be paid for this line. Null until accounting.import_as400_payees links the line by upper(btrim(disbursement_code)). */
  payeeId?: Maybe<Scalars['uuid']>;
  /** The name of the Payee in payee_id, as of when the line was written, or when the import linked it. A later rename of the Payee does not change it. */
  payeeName?: Maybe<Scalars['String']>;
  /** When the line was last updated (maintained by trigger). */
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "accounting.journal_entry_line" */
export type JournalEntryLine_Aggregate = {
  __typename?: 'journalEntryLine_aggregate';
  aggregate?: Maybe<JournalEntryLine_Aggregate_Fields>;
  nodes: Array<JournalEntryLine>;
};

export type JournalEntryLine_Aggregate_Bool_Exp = {
  count?: InputMaybe<JournalEntryLine_Aggregate_Bool_Exp_Count>;
};

export type JournalEntryLine_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<JournalEntryLine_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JournalEntryLine_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "accounting.journal_entry_line" */
export type JournalEntryLine_Aggregate_Fields = {
  __typename?: 'journalEntryLine_aggregate_fields';
  avg?: Maybe<JournalEntryLine_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<JournalEntryLine_Max_Fields>;
  min?: Maybe<JournalEntryLine_Min_Fields>;
  stddev?: Maybe<JournalEntryLine_Stddev_Fields>;
  stddev_pop?: Maybe<JournalEntryLine_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<JournalEntryLine_Stddev_Samp_Fields>;
  sum?: Maybe<JournalEntryLine_Sum_Fields>;
  var_pop?: Maybe<JournalEntryLine_Var_Pop_Fields>;
  var_samp?: Maybe<JournalEntryLine_Var_Samp_Fields>;
  variance?: Maybe<JournalEntryLine_Variance_Fields>;
};


/** aggregate fields of "accounting.journal_entry_line" */
export type JournalEntryLine_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JournalEntryLine_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accounting.journal_entry_line" */
export type JournalEntryLine_Aggregate_Order_By = {
  avg?: InputMaybe<JournalEntryLine_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<JournalEntryLine_Max_Order_By>;
  min?: InputMaybe<JournalEntryLine_Min_Order_By>;
  stddev?: InputMaybe<JournalEntryLine_Stddev_Order_By>;
  stddev_pop?: InputMaybe<JournalEntryLine_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<JournalEntryLine_Stddev_Samp_Order_By>;
  sum?: InputMaybe<JournalEntryLine_Sum_Order_By>;
  var_pop?: InputMaybe<JournalEntryLine_Var_Pop_Order_By>;
  var_samp?: InputMaybe<JournalEntryLine_Var_Samp_Order_By>;
  variance?: InputMaybe<JournalEntryLine_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "accounting.journal_entry_line" */
export type JournalEntryLine_Arr_Rel_Insert_Input = {
  data: Array<JournalEntryLine_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<JournalEntryLine_On_Conflict>;
};

/** aggregate avg on columns */
export type JournalEntryLine_Avg_Fields = {
  __typename?: 'journalEntryLine_avg_fields';
  /** The line's amount in dollars. */
  amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "accounting.journal_entry_line" */
export type JournalEntryLine_Avg_Order_By = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "accounting.journal_entry_line". All fields are combined with a logical 'AND'. */
export type JournalEntryLine_Bool_Exp = {
  _and?: InputMaybe<Array<JournalEntryLine_Bool_Exp>>;
  _not?: InputMaybe<JournalEntryLine_Bool_Exp>;
  _or?: InputMaybe<Array<JournalEntryLine_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  disbursementCode?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journalEntry?: InputMaybe<JournalEntry_Bool_Exp>;
  journalEntryId?: InputMaybe<Uuid_Comparison_Exp>;
  journalEntryLineType?: InputMaybe<Type_Bool_Exp>;
  journalEntryLineTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payee?: InputMaybe<Payee_Bool_Exp>;
  payeeId?: InputMaybe<Uuid_Comparison_Exp>;
  payeeName?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounting.journal_entry_line" */
export enum JournalEntryLine_Constraint {
  /** unique or primary key constraint on columns "id" */
  JournalEntryLinePkey = 'journal_entry_line_pkey'
}

/** input type for incrementing numeric columns in table "accounting.journal_entry_line" */
export type JournalEntryLine_Inc_Input = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "accounting.journal_entry_line" */
export type JournalEntryLine_Insert_Input = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Scalars['numeric']>;
  /** When the line was written. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** For a disbursement line, its disbursement code from the contract's cost detail. */
  disbursementCode?: InputMaybe<Scalars['String']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  journalEntry?: InputMaybe<JournalEntry_Obj_Rel_Insert_Input>;
  /** The entry the line belongs to. */
  journalEntryId?: InputMaybe<Scalars['uuid']>;
  journalEntryLineType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: InputMaybe<Scalars['uuid']>;
  /** The Bucket, disbursement type or surcharge the line is for. */
  name?: InputMaybe<Scalars['String']>;
  payee?: InputMaybe<Payee_Obj_Rel_Insert_Input>;
  /** The Payee to be paid for this line. Null until accounting.import_as400_payees links the line by upper(btrim(disbursement_code)). */
  payeeId?: InputMaybe<Scalars['uuid']>;
  /** The name of the Payee in payee_id, as of when the line was written, or when the import linked it. A later rename of the Payee does not change it. */
  payeeName?: InputMaybe<Scalars['String']>;
  /** When the line was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JournalEntryLine_Max_Fields = {
  __typename?: 'journalEntryLine_max_fields';
  /** The line's amount in dollars. */
  amount?: Maybe<Scalars['numeric']>;
  /** When the line was written. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** For a disbursement line, its disbursement code from the contract's cost detail. */
  disbursementCode?: Maybe<Scalars['String']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /** The entry the line belongs to. */
  journalEntryId?: Maybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: Maybe<Scalars['uuid']>;
  /** The Bucket, disbursement type or surcharge the line is for. */
  name?: Maybe<Scalars['String']>;
  /** The Payee to be paid for this line. Null until accounting.import_as400_payees links the line by upper(btrim(disbursement_code)). */
  payeeId?: Maybe<Scalars['uuid']>;
  /** The name of the Payee in payee_id, as of when the line was written, or when the import linked it. A later rename of the Payee does not change it. */
  payeeName?: Maybe<Scalars['String']>;
  /** When the line was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "accounting.journal_entry_line" */
export type JournalEntryLine_Max_Order_By = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Order_By>;
  /** When the line was written. */
  createdAt?: InputMaybe<Order_By>;
  /** For a disbursement line, its disbursement code from the contract's cost detail. */
  disbursementCode?: InputMaybe<Order_By>;
  /** Primary key. */
  id?: InputMaybe<Order_By>;
  /** The entry the line belongs to. */
  journalEntryId?: InputMaybe<Order_By>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: InputMaybe<Order_By>;
  /** The Bucket, disbursement type or surcharge the line is for. */
  name?: InputMaybe<Order_By>;
  /** The Payee to be paid for this line. Null until accounting.import_as400_payees links the line by upper(btrim(disbursement_code)). */
  payeeId?: InputMaybe<Order_By>;
  /** The name of the Payee in payee_id, as of when the line was written, or when the import linked it. A later rename of the Payee does not change it. */
  payeeName?: InputMaybe<Order_By>;
  /** When the line was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type JournalEntryLine_Min_Fields = {
  __typename?: 'journalEntryLine_min_fields';
  /** The line's amount in dollars. */
  amount?: Maybe<Scalars['numeric']>;
  /** When the line was written. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** For a disbursement line, its disbursement code from the contract's cost detail. */
  disbursementCode?: Maybe<Scalars['String']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /** The entry the line belongs to. */
  journalEntryId?: Maybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: Maybe<Scalars['uuid']>;
  /** The Bucket, disbursement type or surcharge the line is for. */
  name?: Maybe<Scalars['String']>;
  /** The Payee to be paid for this line. Null until accounting.import_as400_payees links the line by upper(btrim(disbursement_code)). */
  payeeId?: Maybe<Scalars['uuid']>;
  /** The name of the Payee in payee_id, as of when the line was written, or when the import linked it. A later rename of the Payee does not change it. */
  payeeName?: Maybe<Scalars['String']>;
  /** When the line was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "accounting.journal_entry_line" */
export type JournalEntryLine_Min_Order_By = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Order_By>;
  /** When the line was written. */
  createdAt?: InputMaybe<Order_By>;
  /** For a disbursement line, its disbursement code from the contract's cost detail. */
  disbursementCode?: InputMaybe<Order_By>;
  /** Primary key. */
  id?: InputMaybe<Order_By>;
  /** The entry the line belongs to. */
  journalEntryId?: InputMaybe<Order_By>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: InputMaybe<Order_By>;
  /** The Bucket, disbursement type or surcharge the line is for. */
  name?: InputMaybe<Order_By>;
  /** The Payee to be paid for this line. Null until accounting.import_as400_payees links the line by upper(btrim(disbursement_code)). */
  payeeId?: InputMaybe<Order_By>;
  /** The name of the Payee in payee_id, as of when the line was written, or when the import linked it. A later rename of the Payee does not change it. */
  payeeName?: InputMaybe<Order_By>;
  /** When the line was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "accounting.journal_entry_line" */
export type JournalEntryLine_Mutation_Response = {
  __typename?: 'journalEntryLine_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JournalEntryLine>;
};

/** on_conflict condition type for table "accounting.journal_entry_line" */
export type JournalEntryLine_On_Conflict = {
  constraint: JournalEntryLine_Constraint;
  update_columns?: Array<JournalEntryLine_Update_Column>;
  where?: InputMaybe<JournalEntryLine_Bool_Exp>;
};

/** Ordering options when selecting data from "accounting.journal_entry_line". */
export type JournalEntryLine_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  disbursementCode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journalEntry?: InputMaybe<JournalEntry_Order_By>;
  journalEntryId?: InputMaybe<Order_By>;
  journalEntryLineType?: InputMaybe<Type_Order_By>;
  journalEntryLineTypeId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payee?: InputMaybe<Payee_Order_By>;
  payeeId?: InputMaybe<Order_By>;
  payeeName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounting.journal_entry_line */
export type JournalEntryLine_Pk_Columns_Input = {
  /** Primary key. */
  id: Scalars['uuid'];
};

/** select columns of table "accounting.journal_entry_line" */
export enum JournalEntryLine_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisbursementCode = 'disbursementCode',
  /** column name */
  Id = 'id',
  /** column name */
  JournalEntryId = 'journalEntryId',
  /** column name */
  JournalEntryLineTypeId = 'journalEntryLineTypeId',
  /** column name */
  Name = 'name',
  /** column name */
  PayeeId = 'payeeId',
  /** column name */
  PayeeName = 'payeeName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "accounting.journal_entry_line" */
export type JournalEntryLine_Set_Input = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Scalars['numeric']>;
  /** When the line was written. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** For a disbursement line, its disbursement code from the contract's cost detail. */
  disbursementCode?: InputMaybe<Scalars['String']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** The entry the line belongs to. */
  journalEntryId?: InputMaybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: InputMaybe<Scalars['uuid']>;
  /** The Bucket, disbursement type or surcharge the line is for. */
  name?: InputMaybe<Scalars['String']>;
  /** The Payee to be paid for this line. Null until accounting.import_as400_payees links the line by upper(btrim(disbursement_code)). */
  payeeId?: InputMaybe<Scalars['uuid']>;
  /** The name of the Payee in payee_id, as of when the line was written, or when the import linked it. A later rename of the Payee does not change it. */
  payeeName?: InputMaybe<Scalars['String']>;
  /** When the line was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type JournalEntryLine_Stddev_Fields = {
  __typename?: 'journalEntryLine_stddev_fields';
  /** The line's amount in dollars. */
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "accounting.journal_entry_line" */
export type JournalEntryLine_Stddev_Order_By = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type JournalEntryLine_Stddev_Pop_Fields = {
  __typename?: 'journalEntryLine_stddev_pop_fields';
  /** The line's amount in dollars. */
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "accounting.journal_entry_line" */
export type JournalEntryLine_Stddev_Pop_Order_By = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type JournalEntryLine_Stddev_Samp_Fields = {
  __typename?: 'journalEntryLine_stddev_samp_fields';
  /** The line's amount in dollars. */
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "accounting.journal_entry_line" */
export type JournalEntryLine_Stddev_Samp_Order_By = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "journalEntryLine" */
export type JournalEntryLine_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JournalEntryLine_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JournalEntryLine_Stream_Cursor_Value_Input = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Scalars['numeric']>;
  /** When the line was written. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** For a disbursement line, its disbursement code from the contract's cost detail. */
  disbursementCode?: InputMaybe<Scalars['String']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** The entry the line belongs to. */
  journalEntryId?: InputMaybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryLineType group: Bucket, Disbursement or Surcharge. */
  journalEntryLineTypeId?: InputMaybe<Scalars['uuid']>;
  /** The Bucket, disbursement type or surcharge the line is for. */
  name?: InputMaybe<Scalars['String']>;
  /** The Payee to be paid for this line. Null until accounting.import_as400_payees links the line by upper(btrim(disbursement_code)). */
  payeeId?: InputMaybe<Scalars['uuid']>;
  /** The name of the Payee in payee_id, as of when the line was written, or when the import linked it. A later rename of the Payee does not change it. */
  payeeName?: InputMaybe<Scalars['String']>;
  /** When the line was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type JournalEntryLine_Sum_Fields = {
  __typename?: 'journalEntryLine_sum_fields';
  /** The line's amount in dollars. */
  amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "accounting.journal_entry_line" */
export type JournalEntryLine_Sum_Order_By = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "accounting.journal_entry_line" */
export enum JournalEntryLine_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisbursementCode = 'disbursementCode',
  /** column name */
  Id = 'id',
  /** column name */
  JournalEntryId = 'journalEntryId',
  /** column name */
  JournalEntryLineTypeId = 'journalEntryLineTypeId',
  /** column name */
  Name = 'name',
  /** column name */
  PayeeId = 'payeeId',
  /** column name */
  PayeeName = 'payeeName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type JournalEntryLine_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JournalEntryLine_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JournalEntryLine_Set_Input>;
  /** filter the rows which have to be updated */
  where: JournalEntryLine_Bool_Exp;
};

/** aggregate var_pop on columns */
export type JournalEntryLine_Var_Pop_Fields = {
  __typename?: 'journalEntryLine_var_pop_fields';
  /** The line's amount in dollars. */
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "accounting.journal_entry_line" */
export type JournalEntryLine_Var_Pop_Order_By = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type JournalEntryLine_Var_Samp_Fields = {
  __typename?: 'journalEntryLine_var_samp_fields';
  /** The line's amount in dollars. */
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "accounting.journal_entry_line" */
export type JournalEntryLine_Var_Samp_Order_By = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type JournalEntryLine_Variance_Fields = {
  __typename?: 'journalEntryLine_variance_fields';
  /** The line's amount in dollars. */
  amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "accounting.journal_entry_line" */
export type JournalEntryLine_Variance_Order_By = {
  /** The line's amount in dollars. */
  amount?: InputMaybe<Order_By>;
};

/** aggregated selection of "accounting.journal_entry" */
export type JournalEntry_Aggregate = {
  __typename?: 'journalEntry_aggregate';
  aggregate?: Maybe<JournalEntry_Aggregate_Fields>;
  nodes: Array<JournalEntry>;
};

export type JournalEntry_Aggregate_Bool_Exp = {
  count?: InputMaybe<JournalEntry_Aggregate_Bool_Exp_Count>;
};

export type JournalEntry_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<JournalEntry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JournalEntry_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "accounting.journal_entry" */
export type JournalEntry_Aggregate_Fields = {
  __typename?: 'journalEntry_aggregate_fields';
  avg?: Maybe<JournalEntry_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<JournalEntry_Max_Fields>;
  min?: Maybe<JournalEntry_Min_Fields>;
  stddev?: Maybe<JournalEntry_Stddev_Fields>;
  stddev_pop?: Maybe<JournalEntry_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<JournalEntry_Stddev_Samp_Fields>;
  sum?: Maybe<JournalEntry_Sum_Fields>;
  var_pop?: Maybe<JournalEntry_Var_Pop_Fields>;
  var_samp?: Maybe<JournalEntry_Var_Samp_Fields>;
  variance?: Maybe<JournalEntry_Variance_Fields>;
};


/** aggregate fields of "accounting.journal_entry" */
export type JournalEntry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JournalEntry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accounting.journal_entry" */
export type JournalEntry_Aggregate_Order_By = {
  avg?: InputMaybe<JournalEntry_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<JournalEntry_Max_Order_By>;
  min?: InputMaybe<JournalEntry_Min_Order_By>;
  stddev?: InputMaybe<JournalEntry_Stddev_Order_By>;
  stddev_pop?: InputMaybe<JournalEntry_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<JournalEntry_Stddev_Samp_Order_By>;
  sum?: InputMaybe<JournalEntry_Sum_Order_By>;
  var_pop?: InputMaybe<JournalEntry_Var_Pop_Order_By>;
  var_samp?: InputMaybe<JournalEntry_Var_Samp_Order_By>;
  variance?: InputMaybe<JournalEntry_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "accounting.journal_entry" */
export type JournalEntry_Arr_Rel_Insert_Input = {
  data: Array<JournalEntry_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<JournalEntry_On_Conflict>;
};

/** aggregate avg on columns */
export type JournalEntry_Avg_Fields = {
  __typename?: 'journalEntry_avg_fields';
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate avg on columns */
export type JournalEntry_Avg_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** order by avg() on columns of table "accounting.journal_entry" */
export type JournalEntry_Avg_Order_By = {
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "accounting.journal_entry". All fields are combined with a logical 'AND'. */
export type JournalEntry_Bool_Exp = {
  _and?: InputMaybe<Array<JournalEntry_Bool_Exp>>;
  _not?: InputMaybe<JournalEntry_Bool_Exp>;
  _or?: InputMaybe<Array<JournalEntry_Bool_Exp>>;
  accountCode?: InputMaybe<String_Comparison_Exp>;
  accountName?: InputMaybe<String_Comparison_Exp>;
  categoryCode?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customerPrice?: InputMaybe<Numeric_Comparison_Exp>;
  cycleJournalEntries?: InputMaybe<CycleJournalEntry_Bool_Exp>;
  cycleJournalEntries_aggregate?: InputMaybe<CycleJournalEntry_Aggregate_Bool_Exp>;
  entryDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  journalEntryLines?: InputMaybe<JournalEntryLine_Bool_Exp>;
  journalEntryLines_aggregate?: InputMaybe<JournalEntryLine_Aggregate_Bool_Exp>;
  journalEntryType?: InputMaybe<Type_Bool_Exp>;
  journalEntryTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContractNumber?: InputMaybe<String_Comparison_Exp>;
  productName?: InputMaybe<String_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounting.journal_entry" */
export enum JournalEntry_Constraint {
  /** unique or primary key constraint on columns "id" */
  JournalEntryPkey = 'journal_entry_pkey'
}

/** input type for incrementing numeric columns in table "accounting.journal_entry" */
export type JournalEntry_Inc_Input = {
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "accounting.journal_entry" */
export type JournalEntry_Insert_Input = {
  /** The contract's account (dealer) code, as a snapshot at the time of entry. */
  accountCode?: InputMaybe<Scalars['String']>;
  /** The contract's account (dealer) name, as a snapshot at the time of entry. */
  accountName?: InputMaybe<Scalars['String']>;
  /** The category code of the contract's product, as a snapshot at the time of entry. */
  categoryCode?: InputMaybe<Scalars['String']>;
  /** When the entry was written. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Scalars['numeric']>;
  cycleJournalEntries?: InputMaybe<CycleJournalEntry_Arr_Rel_Insert_Input>;
  /** The business date of the entry. It does not place the entry in a Cycle: that is done in cycle_journal_entry. Back-filled entries carry the contract's month-end posted date, since their activation date is not known. */
  entryDate?: InputMaybe<Scalars['date']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  journalEntryLines?: InputMaybe<JournalEntryLine_Arr_Rel_Insert_Input>;
  journalEntryType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** shared.type in the JournalEntryType group: the kind of activity. New Business is the only type so far. */
  journalEntryTypeId?: InputMaybe<Scalars['uuid']>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  /** The contract the activity is about. The foreign key is checked at commit, so a contract deleted and inserted again under the same id in one transaction keeps its entries; deleting a contract outright is refused while it has entries. */
  policyContractId?: InputMaybe<Scalars['uuid']>;
  /** The contract number, as a snapshot at the time of entry. */
  policyContractNumber?: InputMaybe<Scalars['String']>;
  /** The contract's product name, as a snapshot at the time of entry. */
  productName?: InputMaybe<Scalars['String']>;
  /** When the entry was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JournalEntry_Max_Fields = {
  __typename?: 'journalEntry_max_fields';
  /** The contract's account (dealer) code, as a snapshot at the time of entry. */
  accountCode?: Maybe<Scalars['String']>;
  /** The contract's account (dealer) name, as a snapshot at the time of entry. */
  accountName?: Maybe<Scalars['String']>;
  /** The category code of the contract's product, as a snapshot at the time of entry. */
  categoryCode?: Maybe<Scalars['String']>;
  /** When the entry was written. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['numeric']>;
  /** The business date of the entry. It does not place the entry in a Cycle: that is done in cycle_journal_entry. Back-filled entries carry the contract's month-end posted date, since their activation date is not known. */
  entryDate?: Maybe<Scalars['date']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryType group: the kind of activity. New Business is the only type so far. */
  journalEntryTypeId?: Maybe<Scalars['uuid']>;
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The contract the activity is about. The foreign key is checked at commit, so a contract deleted and inserted again under the same id in one transaction keeps its entries; deleting a contract outright is refused while it has entries. */
  policyContractId?: Maybe<Scalars['uuid']>;
  /** The contract number, as a snapshot at the time of entry. */
  policyContractNumber?: Maybe<Scalars['String']>;
  /** The contract's product name, as a snapshot at the time of entry. */
  productName?: Maybe<Scalars['String']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
  /** When the entry was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** aggregate max on columns */
export type JournalEntry_Max_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** order by max() on columns of table "accounting.journal_entry" */
export type JournalEntry_Max_Order_By = {
  /** The contract's account (dealer) code, as a snapshot at the time of entry. */
  accountCode?: InputMaybe<Order_By>;
  /** The contract's account (dealer) name, as a snapshot at the time of entry. */
  accountName?: InputMaybe<Order_By>;
  /** The category code of the contract's product, as a snapshot at the time of entry. */
  categoryCode?: InputMaybe<Order_By>;
  /** When the entry was written. */
  createdAt?: InputMaybe<Order_By>;
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Order_By>;
  /** The business date of the entry. It does not place the entry in a Cycle: that is done in cycle_journal_entry. Back-filled entries carry the contract's month-end posted date, since their activation date is not known. */
  entryDate?: InputMaybe<Order_By>;
  /** Primary key. */
  id?: InputMaybe<Order_By>;
  /** shared.type in the JournalEntryType group: the kind of activity. New Business is the only type so far. */
  journalEntryTypeId?: InputMaybe<Order_By>;
  /** The contract the activity is about. The foreign key is checked at commit, so a contract deleted and inserted again under the same id in one transaction keeps its entries; deleting a contract outright is refused while it has entries. */
  policyContractId?: InputMaybe<Order_By>;
  /** The contract number, as a snapshot at the time of entry. */
  policyContractNumber?: InputMaybe<Order_By>;
  /** The contract's product name, as a snapshot at the time of entry. */
  productName?: InputMaybe<Order_By>;
  /** When the entry was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type JournalEntry_Min_Fields = {
  __typename?: 'journalEntry_min_fields';
  /** The contract's account (dealer) code, as a snapshot at the time of entry. */
  accountCode?: Maybe<Scalars['String']>;
  /** The contract's account (dealer) name, as a snapshot at the time of entry. */
  accountName?: Maybe<Scalars['String']>;
  /** The category code of the contract's product, as a snapshot at the time of entry. */
  categoryCode?: Maybe<Scalars['String']>;
  /** When the entry was written. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['numeric']>;
  /** The business date of the entry. It does not place the entry in a Cycle: that is done in cycle_journal_entry. Back-filled entries carry the contract's month-end posted date, since their activation date is not known. */
  entryDate?: Maybe<Scalars['date']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryType group: the kind of activity. New Business is the only type so far. */
  journalEntryTypeId?: Maybe<Scalars['uuid']>;
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The contract the activity is about. The foreign key is checked at commit, so a contract deleted and inserted again under the same id in one transaction keeps its entries; deleting a contract outright is refused while it has entries. */
  policyContractId?: Maybe<Scalars['uuid']>;
  /** The contract number, as a snapshot at the time of entry. */
  policyContractNumber?: Maybe<Scalars['String']>;
  /** The contract's product name, as a snapshot at the time of entry. */
  productName?: Maybe<Scalars['String']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
  /** When the entry was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** aggregate min on columns */
export type JournalEntry_Min_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** order by min() on columns of table "accounting.journal_entry" */
export type JournalEntry_Min_Order_By = {
  /** The contract's account (dealer) code, as a snapshot at the time of entry. */
  accountCode?: InputMaybe<Order_By>;
  /** The contract's account (dealer) name, as a snapshot at the time of entry. */
  accountName?: InputMaybe<Order_By>;
  /** The category code of the contract's product, as a snapshot at the time of entry. */
  categoryCode?: InputMaybe<Order_By>;
  /** When the entry was written. */
  createdAt?: InputMaybe<Order_By>;
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Order_By>;
  /** The business date of the entry. It does not place the entry in a Cycle: that is done in cycle_journal_entry. Back-filled entries carry the contract's month-end posted date, since their activation date is not known. */
  entryDate?: InputMaybe<Order_By>;
  /** Primary key. */
  id?: InputMaybe<Order_By>;
  /** shared.type in the JournalEntryType group: the kind of activity. New Business is the only type so far. */
  journalEntryTypeId?: InputMaybe<Order_By>;
  /** The contract the activity is about. The foreign key is checked at commit, so a contract deleted and inserted again under the same id in one transaction keeps its entries; deleting a contract outright is refused while it has entries. */
  policyContractId?: InputMaybe<Order_By>;
  /** The contract number, as a snapshot at the time of entry. */
  policyContractNumber?: InputMaybe<Order_By>;
  /** The contract's product name, as a snapshot at the time of entry. */
  productName?: InputMaybe<Order_By>;
  /** When the entry was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "accounting.journal_entry" */
export type JournalEntry_Mutation_Response = {
  __typename?: 'journalEntry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JournalEntry>;
};

/** input type for inserting object relation for remote table "accounting.journal_entry" */
export type JournalEntry_Obj_Rel_Insert_Input = {
  data: JournalEntry_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<JournalEntry_On_Conflict>;
};

/** on_conflict condition type for table "accounting.journal_entry" */
export type JournalEntry_On_Conflict = {
  constraint: JournalEntry_Constraint;
  update_columns?: Array<JournalEntry_Update_Column>;
  where?: InputMaybe<JournalEntry_Bool_Exp>;
};

/** Ordering options when selecting data from "accounting.journal_entry". */
export type JournalEntry_Order_By = {
  accountCode?: InputMaybe<Order_By>;
  accountName?: InputMaybe<Order_By>;
  categoryCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  cycleJournalEntries_aggregate?: InputMaybe<CycleJournalEntry_Aggregate_Order_By>;
  entryDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journalEntryLines_aggregate?: InputMaybe<JournalEntryLine_Aggregate_Order_By>;
  journalEntryType?: InputMaybe<Type_Order_By>;
  journalEntryTypeId?: InputMaybe<Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  policyContractNumber?: InputMaybe<Order_By>;
  productName?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounting.journal_entry */
export type JournalEntry_Pk_Columns_Input = {
  /** Primary key. */
  id: Scalars['uuid'];
};

/** select columns of table "accounting.journal_entry" */
export enum JournalEntry_Select_Column {
  /** column name */
  AccountCode = 'accountCode',
  /** column name */
  AccountName = 'accountName',
  /** column name */
  CategoryCode = 'categoryCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerPrice = 'customerPrice',
  /** column name */
  EntryDate = 'entryDate',
  /** column name */
  Id = 'id',
  /** column name */
  JournalEntryTypeId = 'journalEntryTypeId',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  PolicyContractNumber = 'policyContractNumber',
  /** column name */
  ProductName = 'productName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "accounting.journal_entry" */
export type JournalEntry_Set_Input = {
  /** The contract's account (dealer) code, as a snapshot at the time of entry. */
  accountCode?: InputMaybe<Scalars['String']>;
  /** The contract's account (dealer) name, as a snapshot at the time of entry. */
  accountName?: InputMaybe<Scalars['String']>;
  /** The category code of the contract's product, as a snapshot at the time of entry. */
  categoryCode?: InputMaybe<Scalars['String']>;
  /** When the entry was written. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Scalars['numeric']>;
  /** The business date of the entry. It does not place the entry in a Cycle: that is done in cycle_journal_entry. Back-filled entries carry the contract's month-end posted date, since their activation date is not known. */
  entryDate?: InputMaybe<Scalars['date']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryType group: the kind of activity. New Business is the only type so far. */
  journalEntryTypeId?: InputMaybe<Scalars['uuid']>;
  /** The contract the activity is about. The foreign key is checked at commit, so a contract deleted and inserted again under the same id in one transaction keeps its entries; deleting a contract outright is refused while it has entries. */
  policyContractId?: InputMaybe<Scalars['uuid']>;
  /** The contract number, as a snapshot at the time of entry. */
  policyContractNumber?: InputMaybe<Scalars['String']>;
  /** The contract's product name, as a snapshot at the time of entry. */
  productName?: InputMaybe<Scalars['String']>;
  /** When the entry was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type JournalEntry_Stddev_Fields = {
  __typename?: 'journalEntry_stddev_fields';
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate stddev on columns */
export type JournalEntry_Stddev_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** order by stddev() on columns of table "accounting.journal_entry" */
export type JournalEntry_Stddev_Order_By = {
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type JournalEntry_Stddev_Pop_Fields = {
  __typename?: 'journalEntry_stddev_pop_fields';
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate stddev_pop on columns */
export type JournalEntry_Stddev_Pop_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** order by stddev_pop() on columns of table "accounting.journal_entry" */
export type JournalEntry_Stddev_Pop_Order_By = {
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type JournalEntry_Stddev_Samp_Fields = {
  __typename?: 'journalEntry_stddev_samp_fields';
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate stddev_samp on columns */
export type JournalEntry_Stddev_Samp_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** order by stddev_samp() on columns of table "accounting.journal_entry" */
export type JournalEntry_Stddev_Samp_Order_By = {
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "journalEntry" */
export type JournalEntry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JournalEntry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JournalEntry_Stream_Cursor_Value_Input = {
  /** The contract's account (dealer) code, as a snapshot at the time of entry. */
  accountCode?: InputMaybe<Scalars['String']>;
  /** The contract's account (dealer) name, as a snapshot at the time of entry. */
  accountName?: InputMaybe<Scalars['String']>;
  /** The category code of the contract's product, as a snapshot at the time of entry. */
  categoryCode?: InputMaybe<Scalars['String']>;
  /** When the entry was written. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Scalars['numeric']>;
  /** The business date of the entry. It does not place the entry in a Cycle: that is done in cycle_journal_entry. Back-filled entries carry the contract's month-end posted date, since their activation date is not known. */
  entryDate?: InputMaybe<Scalars['date']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /** shared.type in the JournalEntryType group: the kind of activity. New Business is the only type so far. */
  journalEntryTypeId?: InputMaybe<Scalars['uuid']>;
  /** The contract the activity is about. The foreign key is checked at commit, so a contract deleted and inserted again under the same id in one transaction keeps its entries; deleting a contract outright is refused while it has entries. */
  policyContractId?: InputMaybe<Scalars['uuid']>;
  /** The contract number, as a snapshot at the time of entry. */
  policyContractNumber?: InputMaybe<Scalars['String']>;
  /** The contract's product name, as a snapshot at the time of entry. */
  productName?: InputMaybe<Scalars['String']>;
  /** When the entry was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type JournalEntry_Sum_Fields = {
  __typename?: 'journalEntry_sum_fields';
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['numeric']>;
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate sum on columns */
export type JournalEntry_Sum_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** order by sum() on columns of table "accounting.journal_entry" */
export type JournalEntry_Sum_Order_By = {
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Order_By>;
};

/** update columns of table "accounting.journal_entry" */
export enum JournalEntry_Update_Column {
  /** column name */
  AccountCode = 'accountCode',
  /** column name */
  AccountName = 'accountName',
  /** column name */
  CategoryCode = 'categoryCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerPrice = 'customerPrice',
  /** column name */
  EntryDate = 'entryDate',
  /** column name */
  Id = 'id',
  /** column name */
  JournalEntryTypeId = 'journalEntryTypeId',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  PolicyContractNumber = 'policyContractNumber',
  /** column name */
  ProductName = 'productName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type JournalEntry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JournalEntry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JournalEntry_Set_Input>;
  /** filter the rows which have to be updated */
  where: JournalEntry_Bool_Exp;
};

/** aggregate var_pop on columns */
export type JournalEntry_Var_Pop_Fields = {
  __typename?: 'journalEntry_var_pop_fields';
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate var_pop on columns */
export type JournalEntry_Var_Pop_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** order by var_pop() on columns of table "accounting.journal_entry" */
export type JournalEntry_Var_Pop_Order_By = {
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type JournalEntry_Var_Samp_Fields = {
  __typename?: 'journalEntry_var_samp_fields';
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate var_samp on columns */
export type JournalEntry_Var_Samp_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** order by var_samp() on columns of table "accounting.journal_entry" */
export type JournalEntry_Var_Samp_Order_By = {
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type JournalEntry_Variance_Fields = {
  __typename?: 'journalEntry_variance_fields';
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The entry's total in dollars for one line type. */
  lineTypeTotal?: Maybe<Scalars['numeric']>;
  /** The entry's total in dollars, Buckets, Disbursements and Surcharges together. */
  total?: Maybe<Scalars['numeric']>;
};


/** aggregate variance on columns */
export type JournalEntry_Variance_FieldsLineTypeTotalArgs = {
  args: LineTypeTotal_JournalEntry_Args;
};

/** order by variance() on columns of table "accounting.journal_entry" */
export type JournalEntry_Variance_Order_By = {
  /** The contract's customer price in dollars, copied from its cost detail at the time of entry. Null when the contract had no cost detail. */
  customerPrice?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "labor_guide_type" */
export type LaborGuideType = {
  __typename?: 'laborGuideType';
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "labor_guide_type" */
export type LaborGuideType_Aggregate = {
  __typename?: 'laborGuideType_aggregate';
  aggregate?: Maybe<LaborGuideType_Aggregate_Fields>;
  nodes: Array<LaborGuideType>;
};

/** aggregate fields of "labor_guide_type" */
export type LaborGuideType_Aggregate_Fields = {
  __typename?: 'laborGuideType_aggregate_fields';
  avg?: Maybe<LaborGuideType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<LaborGuideType_Max_Fields>;
  min?: Maybe<LaborGuideType_Min_Fields>;
  stddev?: Maybe<LaborGuideType_Stddev_Fields>;
  stddev_pop?: Maybe<LaborGuideType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<LaborGuideType_Stddev_Samp_Fields>;
  sum?: Maybe<LaborGuideType_Sum_Fields>;
  var_pop?: Maybe<LaborGuideType_Var_Pop_Fields>;
  var_samp?: Maybe<LaborGuideType_Var_Samp_Fields>;
  variance?: Maybe<LaborGuideType_Variance_Fields>;
};


/** aggregate fields of "labor_guide_type" */
export type LaborGuideType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LaborGuideType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LaborGuideType_Avg_Fields = {
  __typename?: 'laborGuideType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "labor_guide_type". All fields are combined with a logical 'AND'. */
export type LaborGuideType_Bool_Exp = {
  _and?: InputMaybe<Array<LaborGuideType_Bool_Exp>>;
  _not?: InputMaybe<LaborGuideType_Bool_Exp>;
  _or?: InputMaybe<Array<LaborGuideType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "labor_guide_type" */
export enum LaborGuideType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  LaborGuideTypeEnumValueKey = 'labor_guide_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  LaborGuideTypePkey = 'labor_guide_type_pkey'
}

/** input type for incrementing numeric columns in table "labor_guide_type" */
export type LaborGuideType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "labor_guide_type" */
export type LaborGuideType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LaborGuideType_Max_Fields = {
  __typename?: 'laborGuideType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LaborGuideType_Min_Fields = {
  __typename?: 'laborGuideType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "labor_guide_type" */
export type LaborGuideType_Mutation_Response = {
  __typename?: 'laborGuideType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LaborGuideType>;
};

/** input type for inserting object relation for remote table "labor_guide_type" */
export type LaborGuideType_Obj_Rel_Insert_Input = {
  data: LaborGuideType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<LaborGuideType_On_Conflict>;
};

/** on_conflict condition type for table "labor_guide_type" */
export type LaborGuideType_On_Conflict = {
  constraint: LaborGuideType_Constraint;
  update_columns?: Array<LaborGuideType_Update_Column>;
  where?: InputMaybe<LaborGuideType_Bool_Exp>;
};

/** Ordering options when selecting data from "labor_guide_type". */
export type LaborGuideType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: labor_guide_type */
export type LaborGuideType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "labor_guide_type" */
export enum LaborGuideType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "labor_guide_type" */
export type LaborGuideType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LaborGuideType_Stddev_Fields = {
  __typename?: 'laborGuideType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LaborGuideType_Stddev_Pop_Fields = {
  __typename?: 'laborGuideType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LaborGuideType_Stddev_Samp_Fields = {
  __typename?: 'laborGuideType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "laborGuideType" */
export type LaborGuideType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: LaborGuideType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LaborGuideType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LaborGuideType_Sum_Fields = {
  __typename?: 'laborGuideType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "labor_guide_type" */
export enum LaborGuideType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LaborGuideType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LaborGuideType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LaborGuideType_Set_Input>;
  /** filter the rows which have to be updated */
  where: LaborGuideType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type LaborGuideType_Var_Pop_Fields = {
  __typename?: 'laborGuideType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LaborGuideType_Var_Samp_Fields = {
  __typename?: 'laborGuideType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LaborGuideType_Variance_Fields = {
  __typename?: 'laborGuideType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "claims.labor_rate" */
export type LaborRate = {
  __typename?: 'laborRate';
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  laborRateAmount: Scalars['numeric'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  serviceCenter: ServiceCenter;
  serviceCenterId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "claims.labor_rate" */
export type LaborRateLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.labor_rate" */
export type LaborRateLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** Shows which labor rates were written by the dealer_labor sync */
export type LaborRateAs400 = {
  __typename?: 'laborRateAs400';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  laborRate: LaborRate;
  /** The labor rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a labor rate that has a row here. */
  laborRateId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "claims.labor_rate_as400" */
export type LaborRateAs400_Aggregate = {
  __typename?: 'laborRateAs400_aggregate';
  aggregate?: Maybe<LaborRateAs400_Aggregate_Fields>;
  nodes: Array<LaborRateAs400>;
};

/** aggregate fields of "claims.labor_rate_as400" */
export type LaborRateAs400_Aggregate_Fields = {
  __typename?: 'laborRateAs400_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<LaborRateAs400_Max_Fields>;
  min?: Maybe<LaborRateAs400_Min_Fields>;
};


/** aggregate fields of "claims.labor_rate_as400" */
export type LaborRateAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LaborRateAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.labor_rate_as400". All fields are combined with a logical 'AND'. */
export type LaborRateAs400_Bool_Exp = {
  _and?: InputMaybe<Array<LaborRateAs400_Bool_Exp>>;
  _not?: InputMaybe<LaborRateAs400_Bool_Exp>;
  _or?: InputMaybe<Array<LaborRateAs400_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  laborRate?: InputMaybe<LaborRate_Bool_Exp>;
  laborRateId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.labor_rate_as400" */
export enum LaborRateAs400_Constraint {
  /** unique or primary key constraint on columns "labor_rate_id" */
  LaborRateAs400LaborRateIdKey = 'labor_rate_as400_labor_rate_id_key',
  /** unique or primary key constraint on columns "id" */
  LaborRateAs400Pkey = 'labor_rate_as400_pkey'
}

/** input type for inserting data into table "claims.labor_rate_as400" */
export type LaborRateAs400_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  laborRate?: InputMaybe<LaborRate_Obj_Rel_Insert_Input>;
  /** The labor rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a labor rate that has a row here. */
  laborRateId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LaborRateAs400_Max_Fields = {
  __typename?: 'laborRateAs400_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The labor rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a labor rate that has a row here. */
  laborRateId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LaborRateAs400_Min_Fields = {
  __typename?: 'laborRateAs400_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The labor rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a labor rate that has a row here. */
  laborRateId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.labor_rate_as400" */
export type LaborRateAs400_Mutation_Response = {
  __typename?: 'laborRateAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LaborRateAs400>;
};

/** on_conflict condition type for table "claims.labor_rate_as400" */
export type LaborRateAs400_On_Conflict = {
  constraint: LaborRateAs400_Constraint;
  update_columns?: Array<LaborRateAs400_Update_Column>;
  where?: InputMaybe<LaborRateAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.labor_rate_as400". */
export type LaborRateAs400_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laborRate?: InputMaybe<LaborRate_Order_By>;
  laborRateId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.labor_rate_as400 */
export type LaborRateAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.labor_rate_as400" */
export enum LaborRateAs400_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LaborRateId = 'laborRateId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.labor_rate_as400" */
export type LaborRateAs400_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The labor rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a labor rate that has a row here. */
  laborRateId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "laborRateAs400" */
export type LaborRateAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: LaborRateAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LaborRateAs400_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The labor rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a labor rate that has a row here. */
  laborRateId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "claims.labor_rate_as400" */
export enum LaborRateAs400_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LaborRateId = 'laborRateId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LaborRateAs400_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LaborRateAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: LaborRateAs400_Bool_Exp;
};

/** aggregated selection of "claims.labor_rate" */
export type LaborRate_Aggregate = {
  __typename?: 'laborRate_aggregate';
  aggregate?: Maybe<LaborRate_Aggregate_Fields>;
  nodes: Array<LaborRate>;
};

export type LaborRate_Aggregate_Bool_Exp = {
  count?: InputMaybe<LaborRate_Aggregate_Bool_Exp_Count>;
};

export type LaborRate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<LaborRate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LaborRate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.labor_rate" */
export type LaborRate_Aggregate_Fields = {
  __typename?: 'laborRate_aggregate_fields';
  avg?: Maybe<LaborRate_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<LaborRate_Max_Fields>;
  min?: Maybe<LaborRate_Min_Fields>;
  stddev?: Maybe<LaborRate_Stddev_Fields>;
  stddev_pop?: Maybe<LaborRate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<LaborRate_Stddev_Samp_Fields>;
  sum?: Maybe<LaborRate_Sum_Fields>;
  var_pop?: Maybe<LaborRate_Var_Pop_Fields>;
  var_samp?: Maybe<LaborRate_Var_Samp_Fields>;
  variance?: Maybe<LaborRate_Variance_Fields>;
};


/** aggregate fields of "claims.labor_rate" */
export type LaborRate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LaborRate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.labor_rate" */
export type LaborRate_Aggregate_Order_By = {
  avg?: InputMaybe<LaborRate_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<LaborRate_Max_Order_By>;
  min?: InputMaybe<LaborRate_Min_Order_By>;
  stddev?: InputMaybe<LaborRate_Stddev_Order_By>;
  stddev_pop?: InputMaybe<LaborRate_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<LaborRate_Stddev_Samp_Order_By>;
  sum?: InputMaybe<LaborRate_Sum_Order_By>;
  var_pop?: InputMaybe<LaborRate_Var_Pop_Order_By>;
  var_samp?: InputMaybe<LaborRate_Var_Samp_Order_By>;
  variance?: InputMaybe<LaborRate_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "claims.labor_rate" */
export type LaborRate_Arr_Rel_Insert_Input = {
  data: Array<LaborRate_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<LaborRate_On_Conflict>;
};

/** aggregate avg on columns */
export type LaborRate_Avg_Fields = {
  __typename?: 'laborRate_avg_fields';
  laborRateAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "claims.labor_rate" */
export type LaborRate_Avg_Order_By = {
  laborRateAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "claims.labor_rate". All fields are combined with a logical 'AND'. */
export type LaborRate_Bool_Exp = {
  _and?: InputMaybe<Array<LaborRate_Bool_Exp>>;
  _not?: InputMaybe<LaborRate_Bool_Exp>;
  _or?: InputMaybe<Array<LaborRate_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  laborRateAmount?: InputMaybe<Numeric_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  serviceCenter?: InputMaybe<ServiceCenter_Bool_Exp>;
  serviceCenterId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.labor_rate" */
export enum LaborRate_Constraint {
  /** unique or primary key constraint on columns "id" */
  LaborRatePkey = 'labor_rate_pkey',
  /** unique or primary key constraint on columns "service_center_id", "effective_date" */
  LaborRateServiceCenterIdEffectiveDateKey = 'labor_rate_service_center_id_effective_date_key'
}

/** input type for incrementing numeric columns in table "claims.labor_rate" */
export type LaborRate_Inc_Input = {
  laborRateAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claims.labor_rate" */
export type LaborRate_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  laborRateAmount?: InputMaybe<Scalars['numeric']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  serviceCenter?: InputMaybe<ServiceCenter_Obj_Rel_Insert_Input>;
  serviceCenterId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LaborRate_Max_Fields = {
  __typename?: 'laborRate_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  laborRateAmount?: Maybe<Scalars['numeric']>;
  serviceCenterId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "claims.labor_rate" */
export type LaborRate_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  serviceCenterId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type LaborRate_Min_Fields = {
  __typename?: 'laborRate_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  laborRateAmount?: Maybe<Scalars['numeric']>;
  serviceCenterId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "claims.labor_rate" */
export type LaborRate_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  serviceCenterId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.labor_rate" */
export type LaborRate_Mutation_Response = {
  __typename?: 'laborRate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LaborRate>;
};

/** input type for inserting object relation for remote table "claims.labor_rate" */
export type LaborRate_Obj_Rel_Insert_Input = {
  data: LaborRate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<LaborRate_On_Conflict>;
};

/** on_conflict condition type for table "claims.labor_rate" */
export type LaborRate_On_Conflict = {
  constraint: LaborRate_Constraint;
  update_columns?: Array<LaborRate_Update_Column>;
  where?: InputMaybe<LaborRate_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.labor_rate". */
export type LaborRate_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laborRateAmount?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  serviceCenter?: InputMaybe<ServiceCenter_Order_By>;
  serviceCenterId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.labor_rate */
export type LaborRate_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.labor_rate" */
export enum LaborRate_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  LaborRateAmount = 'laborRateAmount',
  /** column name */
  ServiceCenterId = 'serviceCenterId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.labor_rate" */
export type LaborRate_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  laborRateAmount?: InputMaybe<Scalars['numeric']>;
  serviceCenterId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LaborRate_Stddev_Fields = {
  __typename?: 'laborRate_stddev_fields';
  laborRateAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "claims.labor_rate" */
export type LaborRate_Stddev_Order_By = {
  laborRateAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type LaborRate_Stddev_Pop_Fields = {
  __typename?: 'laborRate_stddev_pop_fields';
  laborRateAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "claims.labor_rate" */
export type LaborRate_Stddev_Pop_Order_By = {
  laborRateAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type LaborRate_Stddev_Samp_Fields = {
  __typename?: 'laborRate_stddev_samp_fields';
  laborRateAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "claims.labor_rate" */
export type LaborRate_Stddev_Samp_Order_By = {
  laborRateAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "laborRate" */
export type LaborRate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: LaborRate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LaborRate_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  laborRateAmount?: InputMaybe<Scalars['numeric']>;
  serviceCenterId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LaborRate_Sum_Fields = {
  __typename?: 'laborRate_sum_fields';
  laborRateAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "claims.labor_rate" */
export type LaborRate_Sum_Order_By = {
  laborRateAmount?: InputMaybe<Order_By>;
};

/** update columns of table "claims.labor_rate" */
export enum LaborRate_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  LaborRateAmount = 'laborRateAmount',
  /** column name */
  ServiceCenterId = 'serviceCenterId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LaborRate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LaborRate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LaborRate_Set_Input>;
  /** filter the rows which have to be updated */
  where: LaborRate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type LaborRate_Var_Pop_Fields = {
  __typename?: 'laborRate_var_pop_fields';
  laborRateAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "claims.labor_rate" */
export type LaborRate_Var_Pop_Order_By = {
  laborRateAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type LaborRate_Var_Samp_Fields = {
  __typename?: 'laborRate_var_samp_fields';
  laborRateAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "claims.labor_rate" */
export type LaborRate_Var_Samp_Order_By = {
  laborRateAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type LaborRate_Variance_Fields = {
  __typename?: 'laborRate_variance_fields';
  laborRateAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "claims.labor_rate" */
export type LaborRate_Variance_Order_By = {
  laborRateAmount?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContract = {
  __typename?: 'legacyPolicyContract';
  /** An object relationship */
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['uuid']>;
  accountManagerId?: Maybe<Scalars['uuid']>;
  accountManagerMetadata?: Maybe<Scalars['jsonb']>;
  accountMetadata?: Maybe<Scalars['jsonb']>;
  assetMetadata?: Maybe<Scalars['jsonb']>;
  batch_key?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  cancelQuoteListView: Array<CancelQuoteListView>;
  /** An aggregate relationship */
  cancelQuoteListView_aggregate: CancelQuoteListView_Aggregate;
  cancellationMetadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  cancellations: Array<Cancellation>;
  /** An aggregate relationship */
  cancellations_aggregate: Cancellation_Aggregate;
  /** An object relationship */
  category?: Maybe<Category>;
  categoryCode?: Maybe<Scalars['String']>;
  contractMasterId?: Maybe<Scalars['Int']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractStatusMetadata?: Maybe<Scalars['jsonb']>;
  contractSuffix?: Maybe<Scalars['String']>;
  /** An object relationship */
  costDetail?: Maybe<Operations_Legacy_Policy_Contract_Cost_Detail_View>;
  costDetailMetadata?: Maybe<Scalars['jsonb']>;
  createUser?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  entityFileStorages: Array<EntityFileStorage>;
  /** An aggregate relationship */
  entityFileStorages_aggregate: EntityFileStorage_Aggregate;
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  existsInAs400?: Maybe<Scalars['Boolean']>;
  expirationDate?: Maybe<Scalars['date']>;
  expirationMiles?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  lenderMetadata?: Maybe<Scalars['jsonb']>;
  monthEndMetadata?: Maybe<Scalars['jsonb']>;
  noteMetadata?: Maybe<Scalars['jsonb']>;
  obligorCode?: Maybe<Scalars['String']>;
  optionalCoverageMetadata?: Maybe<Scalars['jsonb']>;
  ownerMetadata?: Maybe<Scalars['jsonb']>;
  paymentMetadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  policyClaims: Array<PolicyClaim>;
  /** An aggregate relationship */
  policyClaims_aggregate: PolicyClaim_Aggregate;
  /** An array relationship */
  policyContractQuote: Array<PolicyContractQuote>;
  /** An aggregate relationship */
  policyContractQuote_aggregate: PolicyContractQuote_Aggregate;
  postedDate?: Maybe<Scalars['date']>;
  productId?: Maybe<Scalars['uuid']>;
  productMetadata?: Maybe<Scalars['jsonb']>;
  purchaseDate?: Maybe<Scalars['date']>;
  quote_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  remittancePolicyContracts: Array<RemittancePolicyContract>;
  /** An aggregate relationship */
  remittancePolicyContracts_aggregate: RemittancePolicyContract_Aggregate;
  salesRepresentativeName?: Maybe<Scalars['String']>;
  secondaryExpirationDate?: Maybe<Scalars['date']>;
  secondaryExpirationMiles?: Maybe<Scalars['numeric']>;
  statusHistoryMetadata?: Maybe<Scalars['jsonb']>;
  surchargeMetadata?: Maybe<Scalars['jsonb']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractAccountManagerMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractAccountMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractAssetMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractCancelQuoteListViewArgs = {
  distinct_on?: InputMaybe<Array<CancelQuoteListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelQuoteListView_Order_By>>;
  where?: InputMaybe<CancelQuoteListView_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractCancelQuoteListView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelQuoteListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelQuoteListView_Order_By>>;
  where?: InputMaybe<CancelQuoteListView_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractCancellationMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractCancellationsArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancellation_Order_By>>;
  where?: InputMaybe<Cancellation_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractCancellations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancellation_Order_By>>;
  where?: InputMaybe<Cancellation_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractContractStatusMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractCostDetailMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractEntityFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractEntityFileStorages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractLenderMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractMonthEndMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractNoteMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractOptionalCoverageMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractOwnerMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractPaymentMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractPolicyClaimsArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaim_Order_By>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractPolicyClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaim_Order_By>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractPolicyContractQuoteArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractQuote_Order_By>>;
  where?: InputMaybe<PolicyContractQuote_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractPolicyContractQuote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractQuote_Order_By>>;
  where?: InputMaybe<PolicyContractQuote_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractProductMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractRemittancePolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContract_Order_By>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractRemittancePolicyContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContract_Order_By>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractStatusHistoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract" */
export type LegacyPolicyContractSurchargeMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "operations.legacy_policy_contract" */
export type LegacyPolicyContract_Aggregate = {
  __typename?: 'legacyPolicyContract_aggregate';
  aggregate?: Maybe<LegacyPolicyContract_Aggregate_Fields>;
  nodes: Array<LegacyPolicyContract>;
};

/** aggregate fields of "operations.legacy_policy_contract" */
export type LegacyPolicyContract_Aggregate_Fields = {
  __typename?: 'legacyPolicyContract_aggregate_fields';
  avg?: Maybe<LegacyPolicyContract_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<LegacyPolicyContract_Max_Fields>;
  min?: Maybe<LegacyPolicyContract_Min_Fields>;
  stddev?: Maybe<LegacyPolicyContract_Stddev_Fields>;
  stddev_pop?: Maybe<LegacyPolicyContract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<LegacyPolicyContract_Stddev_Samp_Fields>;
  sum?: Maybe<LegacyPolicyContract_Sum_Fields>;
  var_pop?: Maybe<LegacyPolicyContract_Var_Pop_Fields>;
  var_samp?: Maybe<LegacyPolicyContract_Var_Samp_Fields>;
  variance?: Maybe<LegacyPolicyContract_Variance_Fields>;
};


/** aggregate fields of "operations.legacy_policy_contract" */
export type LegacyPolicyContract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LegacyPolicyContract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type LegacyPolicyContract_Append_Input = {
  accountManagerMetadata?: InputMaybe<Scalars['jsonb']>;
  accountMetadata?: InputMaybe<Scalars['jsonb']>;
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  cancellationMetadata?: InputMaybe<Scalars['jsonb']>;
  contractStatusMetadata?: InputMaybe<Scalars['jsonb']>;
  costDetailMetadata?: InputMaybe<Scalars['jsonb']>;
  lenderMetadata?: InputMaybe<Scalars['jsonb']>;
  monthEndMetadata?: InputMaybe<Scalars['jsonb']>;
  noteMetadata?: InputMaybe<Scalars['jsonb']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  ownerMetadata?: InputMaybe<Scalars['jsonb']>;
  paymentMetadata?: InputMaybe<Scalars['jsonb']>;
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  statusHistoryMetadata?: InputMaybe<Scalars['jsonb']>;
  surchargeMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type LegacyPolicyContract_Avg_Fields = {
  __typename?: 'legacyPolicyContract_avg_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.legacy_policy_contract". All fields are combined with a logical 'AND'. */
export type LegacyPolicyContract_Bool_Exp = {
  _and?: InputMaybe<Array<LegacyPolicyContract_Bool_Exp>>;
  _not?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
  _or?: InputMaybe<Array<LegacyPolicyContract_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  accountManagerId?: InputMaybe<Uuid_Comparison_Exp>;
  accountManagerMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  accountMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  assetMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  batch_key?: InputMaybe<Uuid_Comparison_Exp>;
  cancelQuoteListView?: InputMaybe<CancelQuoteListView_Bool_Exp>;
  cancelQuoteListView_aggregate?: InputMaybe<CancelQuoteListView_Aggregate_Bool_Exp>;
  cancellationMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  cancellations?: InputMaybe<Cancellation_Bool_Exp>;
  cancellations_aggregate?: InputMaybe<Cancellation_Aggregate_Bool_Exp>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryCode?: InputMaybe<String_Comparison_Exp>;
  contractMasterId?: InputMaybe<Int_Comparison_Exp>;
  contractNumber?: InputMaybe<String_Comparison_Exp>;
  contractStatusMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  contractSuffix?: InputMaybe<String_Comparison_Exp>;
  costDetail?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp>;
  costDetailMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  createUser?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Bool_Exp>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Bool_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  existsInAs400?: InputMaybe<Boolean_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  expirationMiles?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lenderMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  monthEndMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  noteMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  obligorCode?: InputMaybe<String_Comparison_Exp>;
  optionalCoverageMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  ownerMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  paymentMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  policyClaims?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaims_aggregate?: InputMaybe<PolicyClaim_Aggregate_Bool_Exp>;
  policyContractQuote?: InputMaybe<PolicyContractQuote_Bool_Exp>;
  policyContractQuote_aggregate?: InputMaybe<PolicyContractQuote_Aggregate_Bool_Exp>;
  postedDate?: InputMaybe<Date_Comparison_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  productMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  purchaseDate?: InputMaybe<Date_Comparison_Exp>;
  quote_id?: InputMaybe<Uuid_Comparison_Exp>;
  remittancePolicyContracts?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
  remittancePolicyContracts_aggregate?: InputMaybe<RemittancePolicyContract_Aggregate_Bool_Exp>;
  salesRepresentativeName?: InputMaybe<String_Comparison_Exp>;
  secondaryExpirationDate?: InputMaybe<Date_Comparison_Exp>;
  secondaryExpirationMiles?: InputMaybe<Numeric_Comparison_Exp>;
  statusHistoryMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  surchargeMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.legacy_policy_contract" */
export enum LegacyPolicyContract_Constraint {
  /** unique or primary key constraint on columns "id" */
  LegacyPolicyContractPkey = 'legacy_policy_contract_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type LegacyPolicyContract_Delete_At_Path_Input = {
  accountManagerMetadata?: InputMaybe<Array<Scalars['String']>>;
  accountMetadata?: InputMaybe<Array<Scalars['String']>>;
  assetMetadata?: InputMaybe<Array<Scalars['String']>>;
  cancellationMetadata?: InputMaybe<Array<Scalars['String']>>;
  contractStatusMetadata?: InputMaybe<Array<Scalars['String']>>;
  costDetailMetadata?: InputMaybe<Array<Scalars['String']>>;
  lenderMetadata?: InputMaybe<Array<Scalars['String']>>;
  monthEndMetadata?: InputMaybe<Array<Scalars['String']>>;
  noteMetadata?: InputMaybe<Array<Scalars['String']>>;
  optionalCoverageMetadata?: InputMaybe<Array<Scalars['String']>>;
  ownerMetadata?: InputMaybe<Array<Scalars['String']>>;
  paymentMetadata?: InputMaybe<Array<Scalars['String']>>;
  productMetadata?: InputMaybe<Array<Scalars['String']>>;
  statusHistoryMetadata?: InputMaybe<Array<Scalars['String']>>;
  surchargeMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type LegacyPolicyContract_Delete_Elem_Input = {
  accountManagerMetadata?: InputMaybe<Scalars['Int']>;
  accountMetadata?: InputMaybe<Scalars['Int']>;
  assetMetadata?: InputMaybe<Scalars['Int']>;
  cancellationMetadata?: InputMaybe<Scalars['Int']>;
  contractStatusMetadata?: InputMaybe<Scalars['Int']>;
  costDetailMetadata?: InputMaybe<Scalars['Int']>;
  lenderMetadata?: InputMaybe<Scalars['Int']>;
  monthEndMetadata?: InputMaybe<Scalars['Int']>;
  noteMetadata?: InputMaybe<Scalars['Int']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['Int']>;
  ownerMetadata?: InputMaybe<Scalars['Int']>;
  paymentMetadata?: InputMaybe<Scalars['Int']>;
  productMetadata?: InputMaybe<Scalars['Int']>;
  statusHistoryMetadata?: InputMaybe<Scalars['Int']>;
  surchargeMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type LegacyPolicyContract_Delete_Key_Input = {
  accountManagerMetadata?: InputMaybe<Scalars['String']>;
  accountMetadata?: InputMaybe<Scalars['String']>;
  assetMetadata?: InputMaybe<Scalars['String']>;
  cancellationMetadata?: InputMaybe<Scalars['String']>;
  contractStatusMetadata?: InputMaybe<Scalars['String']>;
  costDetailMetadata?: InputMaybe<Scalars['String']>;
  lenderMetadata?: InputMaybe<Scalars['String']>;
  monthEndMetadata?: InputMaybe<Scalars['String']>;
  noteMetadata?: InputMaybe<Scalars['String']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['String']>;
  ownerMetadata?: InputMaybe<Scalars['String']>;
  paymentMetadata?: InputMaybe<Scalars['String']>;
  productMetadata?: InputMaybe<Scalars['String']>;
  statusHistoryMetadata?: InputMaybe<Scalars['String']>;
  surchargeMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "operations.legacy_policy_contract" */
export type LegacyPolicyContract_Inc_Input = {
  contractMasterId?: InputMaybe<Scalars['Int']>;
  expirationMiles?: InputMaybe<Scalars['numeric']>;
  secondaryExpirationMiles?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.legacy_policy_contract" */
export type LegacyPolicyContract_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['uuid']>;
  accountManagerId?: InputMaybe<Scalars['uuid']>;
  accountManagerMetadata?: InputMaybe<Scalars['jsonb']>;
  accountMetadata?: InputMaybe<Scalars['jsonb']>;
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  batch_key?: InputMaybe<Scalars['uuid']>;
  cancelQuoteListView?: InputMaybe<CancelQuoteListView_Arr_Rel_Insert_Input>;
  cancellationMetadata?: InputMaybe<Scalars['jsonb']>;
  cancellations?: InputMaybe<Cancellation_Arr_Rel_Insert_Input>;
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  categoryCode?: InputMaybe<Scalars['String']>;
  contractMasterId?: InputMaybe<Scalars['Int']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractStatusMetadata?: InputMaybe<Scalars['jsonb']>;
  contractSuffix?: InputMaybe<Scalars['String']>;
  costDetail?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Obj_Rel_Insert_Input>;
  costDetailMetadata?: InputMaybe<Scalars['jsonb']>;
  createUser?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Arr_Rel_Insert_Input>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  expirationMiles?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  lenderMetadata?: InputMaybe<Scalars['jsonb']>;
  monthEndMetadata?: InputMaybe<Scalars['jsonb']>;
  noteMetadata?: InputMaybe<Scalars['jsonb']>;
  obligorCode?: InputMaybe<Scalars['String']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  ownerMetadata?: InputMaybe<Scalars['jsonb']>;
  paymentMetadata?: InputMaybe<Scalars['jsonb']>;
  policyClaims?: InputMaybe<PolicyClaim_Arr_Rel_Insert_Input>;
  policyContractQuote?: InputMaybe<PolicyContractQuote_Arr_Rel_Insert_Input>;
  postedDate?: InputMaybe<Scalars['date']>;
  productId?: InputMaybe<Scalars['uuid']>;
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  purchaseDate?: InputMaybe<Scalars['date']>;
  quote_id?: InputMaybe<Scalars['uuid']>;
  remittancePolicyContracts?: InputMaybe<RemittancePolicyContract_Arr_Rel_Insert_Input>;
  salesRepresentativeName?: InputMaybe<Scalars['String']>;
  secondaryExpirationDate?: InputMaybe<Scalars['date']>;
  secondaryExpirationMiles?: InputMaybe<Scalars['numeric']>;
  statusHistoryMetadata?: InputMaybe<Scalars['jsonb']>;
  surchargeMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LegacyPolicyContract_Max_Fields = {
  __typename?: 'legacyPolicyContract_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  accountManagerId?: Maybe<Scalars['uuid']>;
  batch_key?: Maybe<Scalars['uuid']>;
  categoryCode?: Maybe<Scalars['String']>;
  contractMasterId?: Maybe<Scalars['Int']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSuffix?: Maybe<Scalars['String']>;
  createUser?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expirationDate?: Maybe<Scalars['date']>;
  expirationMiles?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  obligorCode?: Maybe<Scalars['String']>;
  postedDate?: Maybe<Scalars['date']>;
  productId?: Maybe<Scalars['uuid']>;
  purchaseDate?: Maybe<Scalars['date']>;
  quote_id?: Maybe<Scalars['uuid']>;
  salesRepresentativeName?: Maybe<Scalars['String']>;
  secondaryExpirationDate?: Maybe<Scalars['date']>;
  secondaryExpirationMiles?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LegacyPolicyContract_Min_Fields = {
  __typename?: 'legacyPolicyContract_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  accountManagerId?: Maybe<Scalars['uuid']>;
  batch_key?: Maybe<Scalars['uuid']>;
  categoryCode?: Maybe<Scalars['String']>;
  contractMasterId?: Maybe<Scalars['Int']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSuffix?: Maybe<Scalars['String']>;
  createUser?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expirationDate?: Maybe<Scalars['date']>;
  expirationMiles?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  obligorCode?: Maybe<Scalars['String']>;
  postedDate?: Maybe<Scalars['date']>;
  productId?: Maybe<Scalars['uuid']>;
  purchaseDate?: Maybe<Scalars['date']>;
  quote_id?: Maybe<Scalars['uuid']>;
  salesRepresentativeName?: Maybe<Scalars['String']>;
  secondaryExpirationDate?: Maybe<Scalars['date']>;
  secondaryExpirationMiles?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "operations.legacy_policy_contract" */
export type LegacyPolicyContract_Mutation_Response = {
  __typename?: 'legacyPolicyContract_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LegacyPolicyContract>;
};

/** input type for inserting object relation for remote table "operations.legacy_policy_contract" */
export type LegacyPolicyContract_Obj_Rel_Insert_Input = {
  data: LegacyPolicyContract_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<LegacyPolicyContract_On_Conflict>;
};

/** on_conflict condition type for table "operations.legacy_policy_contract" */
export type LegacyPolicyContract_On_Conflict = {
  constraint: LegacyPolicyContract_Constraint;
  update_columns?: Array<LegacyPolicyContract_Update_Column>;
  where?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.legacy_policy_contract". */
export type LegacyPolicyContract_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountId?: InputMaybe<Order_By>;
  accountManagerId?: InputMaybe<Order_By>;
  accountManagerMetadata?: InputMaybe<Order_By>;
  accountMetadata?: InputMaybe<Order_By>;
  assetMetadata?: InputMaybe<Order_By>;
  batch_key?: InputMaybe<Order_By>;
  cancelQuoteListView_aggregate?: InputMaybe<CancelQuoteListView_Aggregate_Order_By>;
  cancellationMetadata?: InputMaybe<Order_By>;
  cancellations_aggregate?: InputMaybe<Cancellation_Aggregate_Order_By>;
  category?: InputMaybe<Category_Order_By>;
  categoryCode?: InputMaybe<Order_By>;
  contractMasterId?: InputMaybe<Order_By>;
  contractNumber?: InputMaybe<Order_By>;
  contractStatusMetadata?: InputMaybe<Order_By>;
  contractSuffix?: InputMaybe<Order_By>;
  costDetail?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Order_By>;
  costDetailMetadata?: InputMaybe<Order_By>;
  createUser?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  existsInAs400?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lenderMetadata?: InputMaybe<Order_By>;
  monthEndMetadata?: InputMaybe<Order_By>;
  noteMetadata?: InputMaybe<Order_By>;
  obligorCode?: InputMaybe<Order_By>;
  optionalCoverageMetadata?: InputMaybe<Order_By>;
  ownerMetadata?: InputMaybe<Order_By>;
  paymentMetadata?: InputMaybe<Order_By>;
  policyClaims_aggregate?: InputMaybe<PolicyClaim_Aggregate_Order_By>;
  policyContractQuote_aggregate?: InputMaybe<PolicyContractQuote_Aggregate_Order_By>;
  postedDate?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  productMetadata?: InputMaybe<Order_By>;
  purchaseDate?: InputMaybe<Order_By>;
  quote_id?: InputMaybe<Order_By>;
  remittancePolicyContracts_aggregate?: InputMaybe<RemittancePolicyContract_Aggregate_Order_By>;
  salesRepresentativeName?: InputMaybe<Order_By>;
  secondaryExpirationDate?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
  statusHistoryMetadata?: InputMaybe<Order_By>;
  surchargeMetadata?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.legacy_policy_contract */
export type LegacyPolicyContract_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type LegacyPolicyContract_Prepend_Input = {
  accountManagerMetadata?: InputMaybe<Scalars['jsonb']>;
  accountMetadata?: InputMaybe<Scalars['jsonb']>;
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  cancellationMetadata?: InputMaybe<Scalars['jsonb']>;
  contractStatusMetadata?: InputMaybe<Scalars['jsonb']>;
  costDetailMetadata?: InputMaybe<Scalars['jsonb']>;
  lenderMetadata?: InputMaybe<Scalars['jsonb']>;
  monthEndMetadata?: InputMaybe<Scalars['jsonb']>;
  noteMetadata?: InputMaybe<Scalars['jsonb']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  ownerMetadata?: InputMaybe<Scalars['jsonb']>;
  paymentMetadata?: InputMaybe<Scalars['jsonb']>;
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  statusHistoryMetadata?: InputMaybe<Scalars['jsonb']>;
  surchargeMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "operations.legacy_policy_contract" */
export enum LegacyPolicyContract_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AccountManagerId = 'accountManagerId',
  /** column name */
  AccountManagerMetadata = 'accountManagerMetadata',
  /** column name */
  AccountMetadata = 'accountMetadata',
  /** column name */
  AssetMetadata = 'assetMetadata',
  /** column name */
  BatchKey = 'batch_key',
  /** column name */
  CancellationMetadata = 'cancellationMetadata',
  /** column name */
  CategoryCode = 'categoryCode',
  /** column name */
  ContractMasterId = 'contractMasterId',
  /** column name */
  ContractNumber = 'contractNumber',
  /** column name */
  ContractStatusMetadata = 'contractStatusMetadata',
  /** column name */
  ContractSuffix = 'contractSuffix',
  /** column name */
  CostDetailMetadata = 'costDetailMetadata',
  /** column name */
  CreateUser = 'createUser',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  ExpirationMiles = 'expirationMiles',
  /** column name */
  Id = 'id',
  /** column name */
  LenderMetadata = 'lenderMetadata',
  /** column name */
  MonthEndMetadata = 'monthEndMetadata',
  /** column name */
  NoteMetadata = 'noteMetadata',
  /** column name */
  ObligorCode = 'obligorCode',
  /** column name */
  OptionalCoverageMetadata = 'optionalCoverageMetadata',
  /** column name */
  OwnerMetadata = 'ownerMetadata',
  /** column name */
  PaymentMetadata = 'paymentMetadata',
  /** column name */
  PostedDate = 'postedDate',
  /** column name */
  ProductId = 'productId',
  /** column name */
  ProductMetadata = 'productMetadata',
  /** column name */
  PurchaseDate = 'purchaseDate',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  SalesRepresentativeName = 'salesRepresentativeName',
  /** column name */
  SecondaryExpirationDate = 'secondaryExpirationDate',
  /** column name */
  SecondaryExpirationMiles = 'secondaryExpirationMiles',
  /** column name */
  StatusHistoryMetadata = 'statusHistoryMetadata',
  /** column name */
  SurchargeMetadata = 'surchargeMetadata',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.legacy_policy_contract" */
export type LegacyPolicyContract_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  accountManagerId?: InputMaybe<Scalars['uuid']>;
  accountManagerMetadata?: InputMaybe<Scalars['jsonb']>;
  accountMetadata?: InputMaybe<Scalars['jsonb']>;
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  batch_key?: InputMaybe<Scalars['uuid']>;
  cancellationMetadata?: InputMaybe<Scalars['jsonb']>;
  categoryCode?: InputMaybe<Scalars['String']>;
  contractMasterId?: InputMaybe<Scalars['Int']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractStatusMetadata?: InputMaybe<Scalars['jsonb']>;
  contractSuffix?: InputMaybe<Scalars['String']>;
  costDetailMetadata?: InputMaybe<Scalars['jsonb']>;
  createUser?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  expirationMiles?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  lenderMetadata?: InputMaybe<Scalars['jsonb']>;
  monthEndMetadata?: InputMaybe<Scalars['jsonb']>;
  noteMetadata?: InputMaybe<Scalars['jsonb']>;
  obligorCode?: InputMaybe<Scalars['String']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  ownerMetadata?: InputMaybe<Scalars['jsonb']>;
  paymentMetadata?: InputMaybe<Scalars['jsonb']>;
  postedDate?: InputMaybe<Scalars['date']>;
  productId?: InputMaybe<Scalars['uuid']>;
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  purchaseDate?: InputMaybe<Scalars['date']>;
  quote_id?: InputMaybe<Scalars['uuid']>;
  salesRepresentativeName?: InputMaybe<Scalars['String']>;
  secondaryExpirationDate?: InputMaybe<Scalars['date']>;
  secondaryExpirationMiles?: InputMaybe<Scalars['numeric']>;
  statusHistoryMetadata?: InputMaybe<Scalars['jsonb']>;
  surchargeMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LegacyPolicyContract_Stddev_Fields = {
  __typename?: 'legacyPolicyContract_stddev_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LegacyPolicyContract_Stddev_Pop_Fields = {
  __typename?: 'legacyPolicyContract_stddev_pop_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LegacyPolicyContract_Stddev_Samp_Fields = {
  __typename?: 'legacyPolicyContract_stddev_samp_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "legacyPolicyContract" */
export type LegacyPolicyContract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: LegacyPolicyContract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LegacyPolicyContract_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  accountManagerId?: InputMaybe<Scalars['uuid']>;
  accountManagerMetadata?: InputMaybe<Scalars['jsonb']>;
  accountMetadata?: InputMaybe<Scalars['jsonb']>;
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  batch_key?: InputMaybe<Scalars['uuid']>;
  cancellationMetadata?: InputMaybe<Scalars['jsonb']>;
  categoryCode?: InputMaybe<Scalars['String']>;
  contractMasterId?: InputMaybe<Scalars['Int']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractStatusMetadata?: InputMaybe<Scalars['jsonb']>;
  contractSuffix?: InputMaybe<Scalars['String']>;
  costDetailMetadata?: InputMaybe<Scalars['jsonb']>;
  createUser?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  expirationMiles?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  lenderMetadata?: InputMaybe<Scalars['jsonb']>;
  monthEndMetadata?: InputMaybe<Scalars['jsonb']>;
  noteMetadata?: InputMaybe<Scalars['jsonb']>;
  obligorCode?: InputMaybe<Scalars['String']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  ownerMetadata?: InputMaybe<Scalars['jsonb']>;
  paymentMetadata?: InputMaybe<Scalars['jsonb']>;
  postedDate?: InputMaybe<Scalars['date']>;
  productId?: InputMaybe<Scalars['uuid']>;
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  purchaseDate?: InputMaybe<Scalars['date']>;
  quote_id?: InputMaybe<Scalars['uuid']>;
  salesRepresentativeName?: InputMaybe<Scalars['String']>;
  secondaryExpirationDate?: InputMaybe<Scalars['date']>;
  secondaryExpirationMiles?: InputMaybe<Scalars['numeric']>;
  statusHistoryMetadata?: InputMaybe<Scalars['jsonb']>;
  surchargeMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LegacyPolicyContract_Sum_Fields = {
  __typename?: 'legacyPolicyContract_sum_fields';
  contractMasterId?: Maybe<Scalars['Int']>;
  expirationMiles?: Maybe<Scalars['numeric']>;
  secondaryExpirationMiles?: Maybe<Scalars['numeric']>;
};

/** update columns of table "operations.legacy_policy_contract" */
export enum LegacyPolicyContract_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AccountManagerId = 'accountManagerId',
  /** column name */
  AccountManagerMetadata = 'accountManagerMetadata',
  /** column name */
  AccountMetadata = 'accountMetadata',
  /** column name */
  AssetMetadata = 'assetMetadata',
  /** column name */
  BatchKey = 'batch_key',
  /** column name */
  CancellationMetadata = 'cancellationMetadata',
  /** column name */
  CategoryCode = 'categoryCode',
  /** column name */
  ContractMasterId = 'contractMasterId',
  /** column name */
  ContractNumber = 'contractNumber',
  /** column name */
  ContractStatusMetadata = 'contractStatusMetadata',
  /** column name */
  ContractSuffix = 'contractSuffix',
  /** column name */
  CostDetailMetadata = 'costDetailMetadata',
  /** column name */
  CreateUser = 'createUser',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  ExpirationMiles = 'expirationMiles',
  /** column name */
  Id = 'id',
  /** column name */
  LenderMetadata = 'lenderMetadata',
  /** column name */
  MonthEndMetadata = 'monthEndMetadata',
  /** column name */
  NoteMetadata = 'noteMetadata',
  /** column name */
  ObligorCode = 'obligorCode',
  /** column name */
  OptionalCoverageMetadata = 'optionalCoverageMetadata',
  /** column name */
  OwnerMetadata = 'ownerMetadata',
  /** column name */
  PaymentMetadata = 'paymentMetadata',
  /** column name */
  PostedDate = 'postedDate',
  /** column name */
  ProductId = 'productId',
  /** column name */
  ProductMetadata = 'productMetadata',
  /** column name */
  PurchaseDate = 'purchaseDate',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  SalesRepresentativeName = 'salesRepresentativeName',
  /** column name */
  SecondaryExpirationDate = 'secondaryExpirationDate',
  /** column name */
  SecondaryExpirationMiles = 'secondaryExpirationMiles',
  /** column name */
  StatusHistoryMetadata = 'statusHistoryMetadata',
  /** column name */
  SurchargeMetadata = 'surchargeMetadata',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LegacyPolicyContract_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<LegacyPolicyContract_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<LegacyPolicyContract_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<LegacyPolicyContract_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<LegacyPolicyContract_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LegacyPolicyContract_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<LegacyPolicyContract_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LegacyPolicyContract_Set_Input>;
  /** filter the rows which have to be updated */
  where: LegacyPolicyContract_Bool_Exp;
};

/** aggregate var_pop on columns */
export type LegacyPolicyContract_Var_Pop_Fields = {
  __typename?: 'legacyPolicyContract_var_pop_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LegacyPolicyContract_Var_Samp_Fields = {
  __typename?: 'legacyPolicyContract_var_samp_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LegacyPolicyContract_Variance_Fields = {
  __typename?: 'legacyPolicyContract_variance_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "dealer" */
export type Legacy_Claims_Dealer = {
  __typename?: 'legacy_claims_dealer';
  code: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  dealerPaymentType: DealerPaymentType;
  id: Scalars['uuid'];
  laborHourlyRateAmount: Scalars['numeric'];
  laborTaxPercent: Scalars['numeric'];
  name: Scalars['String'];
  partsTaxPercent: Scalars['numeric'];
  paymentLocation: Scalars['String'];
  paymentTypeEnumValue: Scalars['Int'];
  phone: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "dealer" */
export type Legacy_Claims_Dealer_Aggregate = {
  __typename?: 'legacy_claims_dealer_aggregate';
  aggregate?: Maybe<Legacy_Claims_Dealer_Aggregate_Fields>;
  nodes: Array<Legacy_Claims_Dealer>;
};

/** aggregate fields of "dealer" */
export type Legacy_Claims_Dealer_Aggregate_Fields = {
  __typename?: 'legacy_claims_dealer_aggregate_fields';
  avg?: Maybe<Legacy_Claims_Dealer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Legacy_Claims_Dealer_Max_Fields>;
  min?: Maybe<Legacy_Claims_Dealer_Min_Fields>;
  stddev?: Maybe<Legacy_Claims_Dealer_Stddev_Fields>;
  stddev_pop?: Maybe<Legacy_Claims_Dealer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Legacy_Claims_Dealer_Stddev_Samp_Fields>;
  sum?: Maybe<Legacy_Claims_Dealer_Sum_Fields>;
  var_pop?: Maybe<Legacy_Claims_Dealer_Var_Pop_Fields>;
  var_samp?: Maybe<Legacy_Claims_Dealer_Var_Samp_Fields>;
  variance?: Maybe<Legacy_Claims_Dealer_Variance_Fields>;
};


/** aggregate fields of "dealer" */
export type Legacy_Claims_Dealer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legacy_Claims_Dealer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Legacy_Claims_Dealer_Avg_Fields = {
  __typename?: 'legacy_claims_dealer_avg_fields';
  laborHourlyRateAmount?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  partsTaxPercent?: Maybe<Scalars['Float']>;
  paymentTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "dealer". All fields are combined with a logical 'AND'. */
export type Legacy_Claims_Dealer_Bool_Exp = {
  _and?: InputMaybe<Array<Legacy_Claims_Dealer_Bool_Exp>>;
  _not?: InputMaybe<Legacy_Claims_Dealer_Bool_Exp>;
  _or?: InputMaybe<Array<Legacy_Claims_Dealer_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dealerPaymentType?: InputMaybe<DealerPaymentType_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  laborHourlyRateAmount?: InputMaybe<Numeric_Comparison_Exp>;
  laborTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partsTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  paymentLocation?: InputMaybe<String_Comparison_Exp>;
  paymentTypeEnumValue?: InputMaybe<Int_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dealer" */
export enum Legacy_Claims_Dealer_Constraint {
  /** unique or primary key constraint on columns "id" */
  DealerPkey = 'dealer_pkey'
}

/** input type for incrementing numeric columns in table "dealer" */
export type Legacy_Claims_Dealer_Inc_Input = {
  laborHourlyRateAmount?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  partsTaxPercent?: InputMaybe<Scalars['numeric']>;
  paymentTypeEnumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "dealer" */
export type Legacy_Claims_Dealer_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerPaymentType?: InputMaybe<DealerPaymentType_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  laborHourlyRateAmount?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  partsTaxPercent?: InputMaybe<Scalars['numeric']>;
  paymentLocation?: InputMaybe<Scalars['String']>;
  paymentTypeEnumValue?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Legacy_Claims_Dealer_Max_Fields = {
  __typename?: 'legacy_claims_dealer_max_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  laborHourlyRateAmount?: Maybe<Scalars['numeric']>;
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  partsTaxPercent?: Maybe<Scalars['numeric']>;
  paymentLocation?: Maybe<Scalars['String']>;
  paymentTypeEnumValue?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Legacy_Claims_Dealer_Min_Fields = {
  __typename?: 'legacy_claims_dealer_min_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  laborHourlyRateAmount?: Maybe<Scalars['numeric']>;
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  partsTaxPercent?: Maybe<Scalars['numeric']>;
  paymentLocation?: Maybe<Scalars['String']>;
  paymentTypeEnumValue?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "dealer" */
export type Legacy_Claims_Dealer_Mutation_Response = {
  __typename?: 'legacy_claims_dealer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Legacy_Claims_Dealer>;
};

/** input type for inserting object relation for remote table "dealer" */
export type Legacy_Claims_Dealer_Obj_Rel_Insert_Input = {
  data: Legacy_Claims_Dealer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Legacy_Claims_Dealer_On_Conflict>;
};

/** on_conflict condition type for table "dealer" */
export type Legacy_Claims_Dealer_On_Conflict = {
  constraint: Legacy_Claims_Dealer_Constraint;
  update_columns?: Array<Legacy_Claims_Dealer_Update_Column>;
  where?: InputMaybe<Legacy_Claims_Dealer_Bool_Exp>;
};

/** Ordering options when selecting data from "dealer". */
export type Legacy_Claims_Dealer_Order_By = {
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dealerPaymentType?: InputMaybe<DealerPaymentType_Order_By>;
  id?: InputMaybe<Order_By>;
  laborHourlyRateAmount?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partsTaxPercent?: InputMaybe<Order_By>;
  paymentLocation?: InputMaybe<Order_By>;
  paymentTypeEnumValue?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dealer */
export type Legacy_Claims_Dealer_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "dealer" */
export enum Legacy_Claims_Dealer_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LaborHourlyRateAmount = 'laborHourlyRateAmount',
  /** column name */
  LaborTaxPercent = 'laborTaxPercent',
  /** column name */
  Name = 'name',
  /** column name */
  PartsTaxPercent = 'partsTaxPercent',
  /** column name */
  PaymentLocation = 'paymentLocation',
  /** column name */
  PaymentTypeEnumValue = 'paymentTypeEnumValue',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "dealer" */
export type Legacy_Claims_Dealer_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  laborHourlyRateAmount?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  partsTaxPercent?: InputMaybe<Scalars['numeric']>;
  paymentLocation?: InputMaybe<Scalars['String']>;
  paymentTypeEnumValue?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Legacy_Claims_Dealer_Stddev_Fields = {
  __typename?: 'legacy_claims_dealer_stddev_fields';
  laborHourlyRateAmount?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  partsTaxPercent?: Maybe<Scalars['Float']>;
  paymentTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Legacy_Claims_Dealer_Stddev_Pop_Fields = {
  __typename?: 'legacy_claims_dealer_stddev_pop_fields';
  laborHourlyRateAmount?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  partsTaxPercent?: Maybe<Scalars['Float']>;
  paymentTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Legacy_Claims_Dealer_Stddev_Samp_Fields = {
  __typename?: 'legacy_claims_dealer_stddev_samp_fields';
  laborHourlyRateAmount?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  partsTaxPercent?: Maybe<Scalars['Float']>;
  paymentTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "legacy_claims_dealer" */
export type Legacy_Claims_Dealer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legacy_Claims_Dealer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legacy_Claims_Dealer_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  laborHourlyRateAmount?: InputMaybe<Scalars['numeric']>;
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  partsTaxPercent?: InputMaybe<Scalars['numeric']>;
  paymentLocation?: InputMaybe<Scalars['String']>;
  paymentTypeEnumValue?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Legacy_Claims_Dealer_Sum_Fields = {
  __typename?: 'legacy_claims_dealer_sum_fields';
  laborHourlyRateAmount?: Maybe<Scalars['numeric']>;
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  partsTaxPercent?: Maybe<Scalars['numeric']>;
  paymentTypeEnumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "dealer" */
export enum Legacy_Claims_Dealer_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LaborHourlyRateAmount = 'laborHourlyRateAmount',
  /** column name */
  LaborTaxPercent = 'laborTaxPercent',
  /** column name */
  Name = 'name',
  /** column name */
  PartsTaxPercent = 'partsTaxPercent',
  /** column name */
  PaymentLocation = 'paymentLocation',
  /** column name */
  PaymentTypeEnumValue = 'paymentTypeEnumValue',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Legacy_Claims_Dealer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Legacy_Claims_Dealer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legacy_Claims_Dealer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legacy_Claims_Dealer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Legacy_Claims_Dealer_Var_Pop_Fields = {
  __typename?: 'legacy_claims_dealer_var_pop_fields';
  laborHourlyRateAmount?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  partsTaxPercent?: Maybe<Scalars['Float']>;
  paymentTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Legacy_Claims_Dealer_Var_Samp_Fields = {
  __typename?: 'legacy_claims_dealer_var_samp_fields';
  laborHourlyRateAmount?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  partsTaxPercent?: Maybe<Scalars['Float']>;
  paymentTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Legacy_Claims_Dealer_Variance_Fields = {
  __typename?: 'legacy_claims_dealer_variance_fields';
  laborHourlyRateAmount?: Maybe<Scalars['Float']>;
  laborTaxPercent?: Maybe<Scalars['Float']>;
  partsTaxPercent?: Maybe<Scalars['Float']>;
  paymentTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "note" */
export type Legacy_Claims_Note = {
  __typename?: 'legacy_claims_note';
  authorId: Scalars['String'];
  /** An object relationship */
  claim?: Maybe<Claim>;
  claimId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contract: Contract;
  contractId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isPinned: Scalars['Boolean'];
  message: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "note" */
export type Legacy_Claims_Note_Aggregate = {
  __typename?: 'legacy_claims_note_aggregate';
  aggregate?: Maybe<Legacy_Claims_Note_Aggregate_Fields>;
  nodes: Array<Legacy_Claims_Note>;
};

export type Legacy_Claims_Note_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Legacy_Claims_Note_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Legacy_Claims_Note_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Legacy_Claims_Note_Aggregate_Bool_Exp_Count>;
};

export type Legacy_Claims_Note_Aggregate_Bool_Exp_Bool_And = {
  arguments: Legacy_Claims_Note_Select_Column_Legacy_Claims_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Legacy_Claims_Note_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Legacy_Claims_Note_Select_Column_Legacy_Claims_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Legacy_Claims_Note_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Legacy_Claims_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "note" */
export type Legacy_Claims_Note_Aggregate_Fields = {
  __typename?: 'legacy_claims_note_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Legacy_Claims_Note_Max_Fields>;
  min?: Maybe<Legacy_Claims_Note_Min_Fields>;
};


/** aggregate fields of "note" */
export type Legacy_Claims_Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legacy_Claims_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "note" */
export type Legacy_Claims_Note_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Legacy_Claims_Note_Max_Order_By>;
  min?: InputMaybe<Legacy_Claims_Note_Min_Order_By>;
};

/** input type for inserting array relation for remote table "note" */
export type Legacy_Claims_Note_Arr_Rel_Insert_Input = {
  data: Array<Legacy_Claims_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Legacy_Claims_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "note". All fields are combined with a logical 'AND'. */
export type Legacy_Claims_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Legacy_Claims_Note_Bool_Exp>>;
  _not?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Legacy_Claims_Note_Bool_Exp>>;
  authorId?: InputMaybe<String_Comparison_Exp>;
  claim?: InputMaybe<Claim_Bool_Exp>;
  claimId?: InputMaybe<Uuid_Comparison_Exp>;
  contract?: InputMaybe<Contract_Bool_Exp>;
  contractId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isPinned?: InputMaybe<Boolean_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "note" */
export enum Legacy_Claims_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotePkey = 'note_pkey'
}

/** input type for inserting data into table "note" */
export type Legacy_Claims_Note_Insert_Input = {
  authorId?: InputMaybe<Scalars['String']>;
  claim?: InputMaybe<Claim_Obj_Rel_Insert_Input>;
  claimId?: InputMaybe<Scalars['uuid']>;
  contract?: InputMaybe<Contract_Obj_Rel_Insert_Input>;
  contractId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Legacy_Claims_Note_Max_Fields = {
  __typename?: 'legacy_claims_note_max_fields';
  authorId?: Maybe<Scalars['String']>;
  claimId?: Maybe<Scalars['uuid']>;
  contractId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "note" */
export type Legacy_Claims_Note_Max_Order_By = {
  authorId?: InputMaybe<Order_By>;
  claimId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Legacy_Claims_Note_Min_Fields = {
  __typename?: 'legacy_claims_note_min_fields';
  authorId?: Maybe<Scalars['String']>;
  claimId?: Maybe<Scalars['uuid']>;
  contractId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "note" */
export type Legacy_Claims_Note_Min_Order_By = {
  authorId?: InputMaybe<Order_By>;
  claimId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "note" */
export type Legacy_Claims_Note_Mutation_Response = {
  __typename?: 'legacy_claims_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Legacy_Claims_Note>;
};

/** on_conflict condition type for table "note" */
export type Legacy_Claims_Note_On_Conflict = {
  constraint: Legacy_Claims_Note_Constraint;
  update_columns?: Array<Legacy_Claims_Note_Update_Column>;
  where?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "note". */
export type Legacy_Claims_Note_Order_By = {
  authorId?: InputMaybe<Order_By>;
  claim?: InputMaybe<Claim_Order_By>;
  claimId?: InputMaybe<Order_By>;
  contract?: InputMaybe<Contract_Order_By>;
  contractId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPinned?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: note */
export type Legacy_Claims_Note_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "note" */
export enum Legacy_Claims_Note_Select_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  ClaimId = 'claimId',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPinned = 'isPinned',
  /** column name */
  Message = 'message',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "legacy_claims_note_aggregate_bool_exp_bool_and_arguments_columns" columns of table "note" */
export enum Legacy_Claims_Note_Select_Column_Legacy_Claims_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPinned = 'isPinned'
}

/** select "legacy_claims_note_aggregate_bool_exp_bool_or_arguments_columns" columns of table "note" */
export enum Legacy_Claims_Note_Select_Column_Legacy_Claims_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPinned = 'isPinned'
}

/** input type for updating data in table "note" */
export type Legacy_Claims_Note_Set_Input = {
  authorId?: InputMaybe<Scalars['String']>;
  claimId?: InputMaybe<Scalars['uuid']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "legacy_claims_note" */
export type Legacy_Claims_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legacy_Claims_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legacy_Claims_Note_Stream_Cursor_Value_Input = {
  authorId?: InputMaybe<Scalars['String']>;
  claimId?: InputMaybe<Scalars['uuid']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "note" */
export enum Legacy_Claims_Note_Update_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  ClaimId = 'claimId',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPinned = 'isPinned',
  /** column name */
  Message = 'message',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Legacy_Claims_Note_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legacy_Claims_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legacy_Claims_Note_Bool_Exp;
};

export type LineTypeTotal_Cycle_Args = {
  line_type_id?: InputMaybe<Scalars['uuid']>;
};

export type LineTypeTotal_JournalEntry_Args = {
  line_type_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate fields of "nhtsa.load" */
export type Load_Aggregate_Fields_Nhtsa = {
  __typename?: 'load_aggregate_fields_nhtsa';
  avg?: Maybe<Load_Avg_Fields_Nhtsa>;
  count: Scalars['Int'];
  max?: Maybe<Load_Max_Fields_Nhtsa>;
  min?: Maybe<Load_Min_Fields_Nhtsa>;
  stddev?: Maybe<Load_Stddev_Fields_Nhtsa>;
  stddev_pop?: Maybe<Load_Stddev_Pop_Fields_Nhtsa>;
  stddev_samp?: Maybe<Load_Stddev_Samp_Fields_Nhtsa>;
  sum?: Maybe<Load_Sum_Fields_Nhtsa>;
  var_pop?: Maybe<Load_Var_Pop_Fields_Nhtsa>;
  var_samp?: Maybe<Load_Var_Samp_Fields_Nhtsa>;
  variance?: Maybe<Load_Variance_Fields_Nhtsa>;
};


/** aggregate fields of "nhtsa.load" */
export type Load_Aggregate_Fields_NhtsaCountArgs = {
  columns?: InputMaybe<Array<Load_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "nhtsa.load" */
export type Load_Aggregate_Nhtsa = {
  __typename?: 'load_aggregate_nhtsa';
  aggregate?: Maybe<Load_Aggregate_Fields_Nhtsa>;
  nodes: Array<Load_Nhtsa>;
};

/** aggregate avg on columns */
export type Load_Avg_Fields_Nhtsa = {
  __typename?: 'load_avg_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  makeModelCount?: Maybe<Scalars['Float']>;
  sourceRowCount?: Maybe<Scalars['Float']>;
  unmatchedIssueCount?: Maybe<Scalars['Float']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Float']>;
  vehicleRowCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nhtsa.load". All fields are combined with a logical 'AND'. */
export type Load_Bool_Exp_Nhtsa = {
  _and?: InputMaybe<Array<Load_Bool_Exp_Nhtsa>>;
  _not?: InputMaybe<Load_Bool_Exp_Nhtsa>;
  _or?: InputMaybe<Array<Load_Bool_Exp_Nhtsa>>;
  dataset?: InputMaybe<String_Comparison_Exp>;
  issueCount?: InputMaybe<Int_Comparison_Exp>;
  loadedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  makeModelCount?: InputMaybe<Int_Comparison_Exp>;
  sourceFiles?: InputMaybe<String_Array_Comparison_Exp>;
  sourceRowCount?: InputMaybe<Int_Comparison_Exp>;
  unmatchedIssueCount?: InputMaybe<Int_Comparison_Exp>;
  unmatchedVehicleRowCount?: InputMaybe<Int_Comparison_Exp>;
  vehicleRowCount?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "nhtsa.load" */
export enum Load_Constraint_Nhtsa {
  /** unique or primary key constraint on columns "dataset" */
  LoadPkey = 'load_pkey'
}

/** input type for incrementing numeric columns in table "nhtsa.load" */
export type Load_Inc_Input_Nhtsa = {
  issueCount?: InputMaybe<Scalars['Int']>;
  makeModelCount?: InputMaybe<Scalars['Int']>;
  sourceRowCount?: InputMaybe<Scalars['Int']>;
  unmatchedIssueCount?: InputMaybe<Scalars['Int']>;
  unmatchedVehicleRowCount?: InputMaybe<Scalars['Int']>;
  vehicleRowCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nhtsa.load" */
export type Load_Insert_Input_Nhtsa = {
  dataset?: InputMaybe<Scalars['String']>;
  issueCount?: InputMaybe<Scalars['Int']>;
  loadedAt?: InputMaybe<Scalars['timestamptz']>;
  makeModelCount?: InputMaybe<Scalars['Int']>;
  sourceFiles?: InputMaybe<Array<Scalars['String']>>;
  sourceRowCount?: InputMaybe<Scalars['Int']>;
  unmatchedIssueCount?: InputMaybe<Scalars['Int']>;
  unmatchedVehicleRowCount?: InputMaybe<Scalars['Int']>;
  vehicleRowCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Load_Max_Fields_Nhtsa = {
  __typename?: 'load_max_fields_nhtsa';
  dataset?: Maybe<Scalars['String']>;
  issueCount?: Maybe<Scalars['Int']>;
  loadedAt?: Maybe<Scalars['timestamptz']>;
  makeModelCount?: Maybe<Scalars['Int']>;
  sourceFiles?: Maybe<Array<Scalars['String']>>;
  sourceRowCount?: Maybe<Scalars['Int']>;
  unmatchedIssueCount?: Maybe<Scalars['Int']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Int']>;
  vehicleRowCount?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Load_Min_Fields_Nhtsa = {
  __typename?: 'load_min_fields_nhtsa';
  dataset?: Maybe<Scalars['String']>;
  issueCount?: Maybe<Scalars['Int']>;
  loadedAt?: Maybe<Scalars['timestamptz']>;
  makeModelCount?: Maybe<Scalars['Int']>;
  sourceFiles?: Maybe<Array<Scalars['String']>>;
  sourceRowCount?: Maybe<Scalars['Int']>;
  unmatchedIssueCount?: Maybe<Scalars['Int']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Int']>;
  vehicleRowCount?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "nhtsa.load" */
export type Load_Mutation_Response_Nhtsa = {
  __typename?: 'load_mutation_response_nhtsa';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Load_Nhtsa>;
};

/** One row per dataset describing the load that built this database. unmatched_* count rows with a model year whose make/model pairs with nothing in vPIC (nhtsa.make_model.is_vpic_match = false); they stay keyword-searchable. An upper bound: a model NHTSA spells as a trim (C250, RX350) counts here, though a search with the decoded trim finds it. Null until restore-nhtsa.sh has compared against vpic. */
export type Load_Nhtsa = {
  __typename?: 'load_nhtsa';
  dataset: Scalars['String'];
  issueCount: Scalars['Int'];
  loadedAt: Scalars['timestamptz'];
  makeModelCount: Scalars['Int'];
  sourceFiles: Array<Scalars['String']>;
  sourceRowCount: Scalars['Int'];
  unmatchedIssueCount?: Maybe<Scalars['Int']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Int']>;
  vehicleRowCount: Scalars['Int'];
};

/** on_conflict condition type for table "nhtsa.load" */
export type Load_On_Conflict_Nhtsa = {
  constraint: Load_Constraint_Nhtsa;
  update_columns?: Array<Load_Update_Column_Nhtsa>;
  where?: InputMaybe<Load_Bool_Exp_Nhtsa>;
};

/** Ordering options when selecting data from "nhtsa.load". */
export type Load_Order_By_Nhtsa = {
  dataset?: InputMaybe<Order_By>;
  issueCount?: InputMaybe<Order_By>;
  loadedAt?: InputMaybe<Order_By>;
  makeModelCount?: InputMaybe<Order_By>;
  sourceFiles?: InputMaybe<Order_By>;
  sourceRowCount?: InputMaybe<Order_By>;
  unmatchedIssueCount?: InputMaybe<Order_By>;
  unmatchedVehicleRowCount?: InputMaybe<Order_By>;
  vehicleRowCount?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nhtsa.load */
export type Load_Pk_Columns_Input_Nhtsa = {
  dataset: Scalars['String'];
};

/** select columns of table "nhtsa.load" */
export enum Load_Select_Column_Nhtsa {
  /** column name */
  Dataset = 'dataset',
  /** column name */
  IssueCount = 'issueCount',
  /** column name */
  LoadedAt = 'loadedAt',
  /** column name */
  MakeModelCount = 'makeModelCount',
  /** column name */
  SourceFiles = 'sourceFiles',
  /** column name */
  SourceRowCount = 'sourceRowCount',
  /** column name */
  UnmatchedIssueCount = 'unmatchedIssueCount',
  /** column name */
  UnmatchedVehicleRowCount = 'unmatchedVehicleRowCount',
  /** column name */
  VehicleRowCount = 'vehicleRowCount'
}

/** input type for updating data in table "nhtsa.load" */
export type Load_Set_Input_Nhtsa = {
  dataset?: InputMaybe<Scalars['String']>;
  issueCount?: InputMaybe<Scalars['Int']>;
  loadedAt?: InputMaybe<Scalars['timestamptz']>;
  makeModelCount?: InputMaybe<Scalars['Int']>;
  sourceFiles?: InputMaybe<Array<Scalars['String']>>;
  sourceRowCount?: InputMaybe<Scalars['Int']>;
  unmatchedIssueCount?: InputMaybe<Scalars['Int']>;
  unmatchedVehicleRowCount?: InputMaybe<Scalars['Int']>;
  vehicleRowCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Load_Stddev_Fields_Nhtsa = {
  __typename?: 'load_stddev_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  makeModelCount?: Maybe<Scalars['Float']>;
  sourceRowCount?: Maybe<Scalars['Float']>;
  unmatchedIssueCount?: Maybe<Scalars['Float']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Float']>;
  vehicleRowCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Load_Stddev_Pop_Fields_Nhtsa = {
  __typename?: 'load_stddev_pop_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  makeModelCount?: Maybe<Scalars['Float']>;
  sourceRowCount?: Maybe<Scalars['Float']>;
  unmatchedIssueCount?: Maybe<Scalars['Float']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Float']>;
  vehicleRowCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Load_Stddev_Samp_Fields_Nhtsa = {
  __typename?: 'load_stddev_samp_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  makeModelCount?: Maybe<Scalars['Float']>;
  sourceRowCount?: Maybe<Scalars['Float']>;
  unmatchedIssueCount?: Maybe<Scalars['Float']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Float']>;
  vehicleRowCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "load" */
export type Load_Stream_Cursor_Input_Nhtsa = {
  /** Stream column input with initial value */
  initial_value: Load_Stream_Cursor_Value_Input_Nhtsa;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Nhtsa>;
};

/** Initial value of the column from where the streaming should start */
export type Load_Stream_Cursor_Value_Input_Nhtsa = {
  dataset?: InputMaybe<Scalars['String']>;
  issueCount?: InputMaybe<Scalars['Int']>;
  loadedAt?: InputMaybe<Scalars['timestamptz']>;
  makeModelCount?: InputMaybe<Scalars['Int']>;
  sourceFiles?: InputMaybe<Array<Scalars['String']>>;
  sourceRowCount?: InputMaybe<Scalars['Int']>;
  unmatchedIssueCount?: InputMaybe<Scalars['Int']>;
  unmatchedVehicleRowCount?: InputMaybe<Scalars['Int']>;
  vehicleRowCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Load_Sum_Fields_Nhtsa = {
  __typename?: 'load_sum_fields_nhtsa';
  issueCount?: Maybe<Scalars['Int']>;
  makeModelCount?: Maybe<Scalars['Int']>;
  sourceRowCount?: Maybe<Scalars['Int']>;
  unmatchedIssueCount?: Maybe<Scalars['Int']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Int']>;
  vehicleRowCount?: Maybe<Scalars['Int']>;
};

/** update columns of table "nhtsa.load" */
export enum Load_Update_Column_Nhtsa {
  /** column name */
  Dataset = 'dataset',
  /** column name */
  IssueCount = 'issueCount',
  /** column name */
  LoadedAt = 'loadedAt',
  /** column name */
  MakeModelCount = 'makeModelCount',
  /** column name */
  SourceFiles = 'sourceFiles',
  /** column name */
  SourceRowCount = 'sourceRowCount',
  /** column name */
  UnmatchedIssueCount = 'unmatchedIssueCount',
  /** column name */
  UnmatchedVehicleRowCount = 'unmatchedVehicleRowCount',
  /** column name */
  VehicleRowCount = 'vehicleRowCount'
}

export type Load_Updates_Nhtsa = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Load_Inc_Input_Nhtsa>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Load_Set_Input_Nhtsa>;
  /** filter the rows which have to be updated */
  where: Load_Bool_Exp_Nhtsa;
};

/** aggregate var_pop on columns */
export type Load_Var_Pop_Fields_Nhtsa = {
  __typename?: 'load_var_pop_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  makeModelCount?: Maybe<Scalars['Float']>;
  sourceRowCount?: Maybe<Scalars['Float']>;
  unmatchedIssueCount?: Maybe<Scalars['Float']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Float']>;
  vehicleRowCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Load_Var_Samp_Fields_Nhtsa = {
  __typename?: 'load_var_samp_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  makeModelCount?: Maybe<Scalars['Float']>;
  sourceRowCount?: Maybe<Scalars['Float']>;
  unmatchedIssueCount?: Maybe<Scalars['Float']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Float']>;
  vehicleRowCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Load_Variance_Fields_Nhtsa = {
  __typename?: 'load_variance_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  makeModelCount?: Maybe<Scalars['Float']>;
  sourceRowCount?: Maybe<Scalars['Float']>;
  unmatchedIssueCount?: Maybe<Scalars['Float']>;
  unmatchedVehicleRowCount?: Maybe<Scalars['Float']>;
  vehicleRowCount?: Maybe<Scalars['Float']>;
};

/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type LoggedAction = {
  __typename?: 'loggedAction';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action: Scalars['String'];
  /** Wall clock time at which audited event's trigger call occurred */
  actionTstampClk: Scalars['timestamptz'];
  /** Statement start timestamp for tx in which audited event occurred */
  actionTstampStm: Scalars['timestamptz'];
  /** Transaction start timestamp for tx in which audited event occurred */
  actionTstampTx: Scalars['timestamptz'];
  activityMessage?: Maybe<Scalars['String']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  applicationName?: Maybe<Scalars['String']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changedFields?: Maybe<Scalars['jsonb']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  clientAddr?: Maybe<Scalars['inet']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  clientQuery?: Maybe<Scalars['String']>;
  hasuraUser?: Maybe<Scalars['jsonb']>;
  /** Unique identifier for each auditable event */
  id: Scalars['uuid'];
  /** An object relationship */
  identity?: Maybe<Identity>;
  identityId?: Maybe<Scalars['uuid']>;
  /** Returns the identity name from ory.identity table for a logged action. Used as a computed field in Hasura. */
  identityName?: Maybe<Scalars['String']>;
  /** Table OID. Changes with drop/create. Get with 'tablename'::regclass */
  relid: Scalars['oid'];
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  rowData?: Maybe<Scalars['jsonb']>;
  rowUUID?: Maybe<Scalars['uuid']>;
  /** Database schema audited table for this event is in */
  schemaName: Scalars['String'];
  /** Login / session user whose statement caused the audited event */
  sessionUserName?: Maybe<Scalars['String']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  statementOnly: Scalars['Boolean'];
  /** Non-schema-qualified table name of table event occured in */
  tableName: Scalars['String'];
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['bigint']>;
};


/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type LoggedActionChangedFieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type LoggedActionHasuraUserArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type LoggedActionRowDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "audit.logged_actions" */
export type LoggedAction_Aggregate = {
  __typename?: 'loggedAction_aggregate';
  aggregate?: Maybe<LoggedAction_Aggregate_Fields>;
  nodes: Array<LoggedAction>;
};

export type LoggedAction_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<LoggedAction_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<LoggedAction_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<LoggedAction_Aggregate_Bool_Exp_Count>;
};

export type LoggedAction_Aggregate_Bool_Exp_Bool_And = {
  arguments: LoggedAction_Select_Column_LoggedAction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LoggedAction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type LoggedAction_Aggregate_Bool_Exp_Bool_Or = {
  arguments: LoggedAction_Select_Column_LoggedAction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LoggedAction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type LoggedAction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<LoggedAction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LoggedAction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "audit.logged_actions" */
export type LoggedAction_Aggregate_Fields = {
  __typename?: 'loggedAction_aggregate_fields';
  avg?: Maybe<LoggedAction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<LoggedAction_Max_Fields>;
  min?: Maybe<LoggedAction_Min_Fields>;
  stddev?: Maybe<LoggedAction_Stddev_Fields>;
  stddev_pop?: Maybe<LoggedAction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<LoggedAction_Stddev_Samp_Fields>;
  sum?: Maybe<LoggedAction_Sum_Fields>;
  var_pop?: Maybe<LoggedAction_Var_Pop_Fields>;
  var_samp?: Maybe<LoggedAction_Var_Samp_Fields>;
  variance?: Maybe<LoggedAction_Variance_Fields>;
};


/** aggregate fields of "audit.logged_actions" */
export type LoggedAction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LoggedAction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "audit.logged_actions" */
export type LoggedAction_Aggregate_Order_By = {
  avg?: InputMaybe<LoggedAction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<LoggedAction_Max_Order_By>;
  min?: InputMaybe<LoggedAction_Min_Order_By>;
  stddev?: InputMaybe<LoggedAction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<LoggedAction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<LoggedAction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<LoggedAction_Sum_Order_By>;
  var_pop?: InputMaybe<LoggedAction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<LoggedAction_Var_Samp_Order_By>;
  variance?: InputMaybe<LoggedAction_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type LoggedAction_Append_Input = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changedFields?: InputMaybe<Scalars['jsonb']>;
  hasuraUser?: InputMaybe<Scalars['jsonb']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  rowData?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "audit.logged_actions" */
export type LoggedAction_Arr_Rel_Insert_Input = {
  data: Array<LoggedAction_Insert_Input>;
};

/** aggregate avg on columns */
export type LoggedAction_Avg_Fields = {
  __typename?: 'loggedAction_avg_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "audit.logged_actions" */
export type LoggedAction_Avg_Order_By = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Order_By>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "audit.logged_actions". All fields are combined with a logical 'AND'. */
export type LoggedAction_Bool_Exp = {
  _and?: InputMaybe<Array<LoggedAction_Bool_Exp>>;
  _not?: InputMaybe<LoggedAction_Bool_Exp>;
  _or?: InputMaybe<Array<LoggedAction_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  actionTstampClk?: InputMaybe<Timestamptz_Comparison_Exp>;
  actionTstampStm?: InputMaybe<Timestamptz_Comparison_Exp>;
  actionTstampTx?: InputMaybe<Timestamptz_Comparison_Exp>;
  activityMessage?: InputMaybe<String_Comparison_Exp>;
  applicationName?: InputMaybe<String_Comparison_Exp>;
  changedFields?: InputMaybe<Jsonb_Comparison_Exp>;
  clientAddr?: InputMaybe<Inet_Comparison_Exp>;
  clientPort?: InputMaybe<Int_Comparison_Exp>;
  clientQuery?: InputMaybe<String_Comparison_Exp>;
  hasuraUser?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  identityName?: InputMaybe<String_Comparison_Exp>;
  relid?: InputMaybe<Oid_Comparison_Exp>;
  rowData?: InputMaybe<Jsonb_Comparison_Exp>;
  rowUUID?: InputMaybe<Uuid_Comparison_Exp>;
  schemaName?: InputMaybe<String_Comparison_Exp>;
  sessionUserName?: InputMaybe<String_Comparison_Exp>;
  statementOnly?: InputMaybe<Boolean_Comparison_Exp>;
  tableName?: InputMaybe<String_Comparison_Exp>;
  transactionId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type LoggedAction_Delete_At_Path_Input = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changedFields?: InputMaybe<Array<Scalars['String']>>;
  hasuraUser?: InputMaybe<Array<Scalars['String']>>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  rowData?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type LoggedAction_Delete_Elem_Input = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changedFields?: InputMaybe<Scalars['Int']>;
  hasuraUser?: InputMaybe<Scalars['Int']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  rowData?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type LoggedAction_Delete_Key_Input = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changedFields?: InputMaybe<Scalars['String']>;
  hasuraUser?: InputMaybe<Scalars['String']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  rowData?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "audit.logged_actions" */
export type LoggedAction_Inc_Input = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Scalars['Int']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "audit.logged_actions" */
export type LoggedAction_Insert_Input = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: InputMaybe<Scalars['String']>;
  /** Wall clock time at which audited event's trigger call occurred */
  actionTstampClk?: InputMaybe<Scalars['timestamptz']>;
  /** Statement start timestamp for tx in which audited event occurred */
  actionTstampStm?: InputMaybe<Scalars['timestamptz']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  actionTstampTx?: InputMaybe<Scalars['timestamptz']>;
  activityMessage?: InputMaybe<Scalars['String']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  applicationName?: InputMaybe<Scalars['String']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changedFields?: InputMaybe<Scalars['jsonb']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  clientAddr?: InputMaybe<Scalars['inet']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  clientQuery?: InputMaybe<Scalars['String']>;
  hasuraUser?: InputMaybe<Scalars['jsonb']>;
  /** Unique identifier for each auditable event */
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Table OID. Changes with drop/create. Get with 'tablename'::regclass */
  relid?: InputMaybe<Scalars['oid']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  rowData?: InputMaybe<Scalars['jsonb']>;
  rowUUID?: InputMaybe<Scalars['uuid']>;
  /** Database schema audited table for this event is in */
  schemaName?: InputMaybe<Scalars['String']>;
  /** Login / session user whose statement caused the audited event */
  sessionUserName?: InputMaybe<Scalars['String']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  statementOnly?: InputMaybe<Scalars['Boolean']>;
  /** Non-schema-qualified table name of table event occured in */
  tableName?: InputMaybe<Scalars['String']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type LoggedAction_Max_Fields = {
  __typename?: 'loggedAction_max_fields';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: Maybe<Scalars['String']>;
  /** Wall clock time at which audited event's trigger call occurred */
  actionTstampClk?: Maybe<Scalars['timestamptz']>;
  /** Statement start timestamp for tx in which audited event occurred */
  actionTstampStm?: Maybe<Scalars['timestamptz']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  actionTstampTx?: Maybe<Scalars['timestamptz']>;
  activityMessage?: Maybe<Scalars['String']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  applicationName?: Maybe<Scalars['String']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  clientQuery?: Maybe<Scalars['String']>;
  /** Unique identifier for each auditable event */
  id?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
  /** Returns the identity name from ory.identity table for a logged action. Used as a computed field in Hasura. */
  identityName?: Maybe<Scalars['String']>;
  rowUUID?: Maybe<Scalars['uuid']>;
  /** Database schema audited table for this event is in */
  schemaName?: Maybe<Scalars['String']>;
  /** Login / session user whose statement caused the audited event */
  sessionUserName?: Maybe<Scalars['String']>;
  /** Non-schema-qualified table name of table event occured in */
  tableName?: Maybe<Scalars['String']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "audit.logged_actions" */
export type LoggedAction_Max_Order_By = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: InputMaybe<Order_By>;
  /** Wall clock time at which audited event's trigger call occurred */
  actionTstampClk?: InputMaybe<Order_By>;
  /** Statement start timestamp for tx in which audited event occurred */
  actionTstampStm?: InputMaybe<Order_By>;
  /** Transaction start timestamp for tx in which audited event occurred */
  actionTstampTx?: InputMaybe<Order_By>;
  activityMessage?: InputMaybe<Order_By>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  applicationName?: InputMaybe<Order_By>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Order_By>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  clientQuery?: InputMaybe<Order_By>;
  /** Unique identifier for each auditable event */
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  rowUUID?: InputMaybe<Order_By>;
  /** Database schema audited table for this event is in */
  schemaName?: InputMaybe<Order_By>;
  /** Login / session user whose statement caused the audited event */
  sessionUserName?: InputMaybe<Order_By>;
  /** Non-schema-qualified table name of table event occured in */
  tableName?: InputMaybe<Order_By>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type LoggedAction_Min_Fields = {
  __typename?: 'loggedAction_min_fields';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: Maybe<Scalars['String']>;
  /** Wall clock time at which audited event's trigger call occurred */
  actionTstampClk?: Maybe<Scalars['timestamptz']>;
  /** Statement start timestamp for tx in which audited event occurred */
  actionTstampStm?: Maybe<Scalars['timestamptz']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  actionTstampTx?: Maybe<Scalars['timestamptz']>;
  activityMessage?: Maybe<Scalars['String']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  applicationName?: Maybe<Scalars['String']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  clientQuery?: Maybe<Scalars['String']>;
  /** Unique identifier for each auditable event */
  id?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
  /** Returns the identity name from ory.identity table for a logged action. Used as a computed field in Hasura. */
  identityName?: Maybe<Scalars['String']>;
  rowUUID?: Maybe<Scalars['uuid']>;
  /** Database schema audited table for this event is in */
  schemaName?: Maybe<Scalars['String']>;
  /** Login / session user whose statement caused the audited event */
  sessionUserName?: Maybe<Scalars['String']>;
  /** Non-schema-qualified table name of table event occured in */
  tableName?: Maybe<Scalars['String']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "audit.logged_actions" */
export type LoggedAction_Min_Order_By = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: InputMaybe<Order_By>;
  /** Wall clock time at which audited event's trigger call occurred */
  actionTstampClk?: InputMaybe<Order_By>;
  /** Statement start timestamp for tx in which audited event occurred */
  actionTstampStm?: InputMaybe<Order_By>;
  /** Transaction start timestamp for tx in which audited event occurred */
  actionTstampTx?: InputMaybe<Order_By>;
  activityMessage?: InputMaybe<Order_By>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  applicationName?: InputMaybe<Order_By>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Order_By>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  clientQuery?: InputMaybe<Order_By>;
  /** Unique identifier for each auditable event */
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  rowUUID?: InputMaybe<Order_By>;
  /** Database schema audited table for this event is in */
  schemaName?: InputMaybe<Order_By>;
  /** Login / session user whose statement caused the audited event */
  sessionUserName?: InputMaybe<Order_By>;
  /** Non-schema-qualified table name of table event occured in */
  tableName?: InputMaybe<Order_By>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "audit.logged_actions" */
export type LoggedAction_Mutation_Response = {
  __typename?: 'loggedAction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LoggedAction>;
};

/** Ordering options when selecting data from "audit.logged_actions". */
export type LoggedAction_Order_By = {
  action?: InputMaybe<Order_By>;
  actionTstampClk?: InputMaybe<Order_By>;
  actionTstampStm?: InputMaybe<Order_By>;
  actionTstampTx?: InputMaybe<Order_By>;
  activityMessage?: InputMaybe<Order_By>;
  applicationName?: InputMaybe<Order_By>;
  changedFields?: InputMaybe<Order_By>;
  clientAddr?: InputMaybe<Order_By>;
  clientPort?: InputMaybe<Order_By>;
  clientQuery?: InputMaybe<Order_By>;
  hasuraUser?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityId?: InputMaybe<Order_By>;
  identityName?: InputMaybe<Order_By>;
  relid?: InputMaybe<Order_By>;
  rowData?: InputMaybe<Order_By>;
  rowUUID?: InputMaybe<Order_By>;
  schemaName?: InputMaybe<Order_By>;
  sessionUserName?: InputMaybe<Order_By>;
  statementOnly?: InputMaybe<Order_By>;
  tableName?: InputMaybe<Order_By>;
  transactionId?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type LoggedAction_Prepend_Input = {
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changedFields?: InputMaybe<Scalars['jsonb']>;
  hasuraUser?: InputMaybe<Scalars['jsonb']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  rowData?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "audit.logged_actions" */
export enum LoggedAction_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTstampClk = 'actionTstampClk',
  /** column name */
  ActionTstampStm = 'actionTstampStm',
  /** column name */
  ActionTstampTx = 'actionTstampTx',
  /** column name */
  ActivityMessage = 'activityMessage',
  /** column name */
  ApplicationName = 'applicationName',
  /** column name */
  ChangedFields = 'changedFields',
  /** column name */
  ClientAddr = 'clientAddr',
  /** column name */
  ClientPort = 'clientPort',
  /** column name */
  ClientQuery = 'clientQuery',
  /** column name */
  HasuraUser = 'hasuraUser',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  Relid = 'relid',
  /** column name */
  RowData = 'rowData',
  /** column name */
  RowUuid = 'rowUUID',
  /** column name */
  SchemaName = 'schemaName',
  /** column name */
  SessionUserName = 'sessionUserName',
  /** column name */
  StatementOnly = 'statementOnly',
  /** column name */
  TableName = 'tableName',
  /** column name */
  TransactionId = 'transactionId'
}

/** select "loggedAction_aggregate_bool_exp_bool_and_arguments_columns" columns of table "audit.logged_actions" */
export enum LoggedAction_Select_Column_LoggedAction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  StatementOnly = 'statementOnly'
}

/** select "loggedAction_aggregate_bool_exp_bool_or_arguments_columns" columns of table "audit.logged_actions" */
export enum LoggedAction_Select_Column_LoggedAction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  StatementOnly = 'statementOnly'
}

/** input type for updating data in table "audit.logged_actions" */
export type LoggedAction_Set_Input = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: InputMaybe<Scalars['String']>;
  /** Wall clock time at which audited event's trigger call occurred */
  actionTstampClk?: InputMaybe<Scalars['timestamptz']>;
  /** Statement start timestamp for tx in which audited event occurred */
  actionTstampStm?: InputMaybe<Scalars['timestamptz']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  actionTstampTx?: InputMaybe<Scalars['timestamptz']>;
  activityMessage?: InputMaybe<Scalars['String']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  applicationName?: InputMaybe<Scalars['String']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changedFields?: InputMaybe<Scalars['jsonb']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  clientAddr?: InputMaybe<Scalars['inet']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  clientQuery?: InputMaybe<Scalars['String']>;
  hasuraUser?: InputMaybe<Scalars['jsonb']>;
  /** Unique identifier for each auditable event */
  id?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Table OID. Changes with drop/create. Get with 'tablename'::regclass */
  relid?: InputMaybe<Scalars['oid']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  rowData?: InputMaybe<Scalars['jsonb']>;
  rowUUID?: InputMaybe<Scalars['uuid']>;
  /** Database schema audited table for this event is in */
  schemaName?: InputMaybe<Scalars['String']>;
  /** Login / session user whose statement caused the audited event */
  sessionUserName?: InputMaybe<Scalars['String']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  statementOnly?: InputMaybe<Scalars['Boolean']>;
  /** Non-schema-qualified table name of table event occured in */
  tableName?: InputMaybe<Scalars['String']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type LoggedAction_Stddev_Fields = {
  __typename?: 'loggedAction_stddev_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "audit.logged_actions" */
export type LoggedAction_Stddev_Order_By = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Order_By>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type LoggedAction_Stddev_Pop_Fields = {
  __typename?: 'loggedAction_stddev_pop_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "audit.logged_actions" */
export type LoggedAction_Stddev_Pop_Order_By = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Order_By>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type LoggedAction_Stddev_Samp_Fields = {
  __typename?: 'loggedAction_stddev_samp_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "audit.logged_actions" */
export type LoggedAction_Stddev_Samp_Order_By = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Order_By>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "loggedAction" */
export type LoggedAction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: LoggedAction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LoggedAction_Stream_Cursor_Value_Input = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: InputMaybe<Scalars['String']>;
  /** Wall clock time at which audited event's trigger call occurred */
  actionTstampClk?: InputMaybe<Scalars['timestamptz']>;
  /** Statement start timestamp for tx in which audited event occurred */
  actionTstampStm?: InputMaybe<Scalars['timestamptz']>;
  /** Transaction start timestamp for tx in which audited event occurred */
  actionTstampTx?: InputMaybe<Scalars['timestamptz']>;
  activityMessage?: InputMaybe<Scalars['String']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  applicationName?: InputMaybe<Scalars['String']>;
  /** New values of fields changed by UPDATE. Null except for row-level UPDATE events. */
  changedFields?: InputMaybe<Scalars['jsonb']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  clientAddr?: InputMaybe<Scalars['inet']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Scalars['Int']>;
  /** Top-level query that caused this auditable event. May be more than one statement. */
  clientQuery?: InputMaybe<Scalars['String']>;
  hasuraUser?: InputMaybe<Scalars['jsonb']>;
  /** Unique identifier for each auditable event */
  id?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Table OID. Changes with drop/create. Get with 'tablename'::regclass */
  relid?: InputMaybe<Scalars['oid']>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  rowData?: InputMaybe<Scalars['jsonb']>;
  rowUUID?: InputMaybe<Scalars['uuid']>;
  /** Database schema audited table for this event is in */
  schemaName?: InputMaybe<Scalars['String']>;
  /** Login / session user whose statement caused the audited event */
  sessionUserName?: InputMaybe<Scalars['String']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  statementOnly?: InputMaybe<Scalars['Boolean']>;
  /** Non-schema-qualified table name of table event occured in */
  tableName?: InputMaybe<Scalars['String']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type LoggedAction_Sum_Fields = {
  __typename?: 'loggedAction_sum_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Int']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "audit.logged_actions" */
export type LoggedAction_Sum_Order_By = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Order_By>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Order_By>;
};

export type LoggedAction_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<LoggedAction_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<LoggedAction_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<LoggedAction_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<LoggedAction_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LoggedAction_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<LoggedAction_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LoggedAction_Set_Input>;
  /** filter the rows which have to be updated */
  where: LoggedAction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type LoggedAction_Var_Pop_Fields = {
  __typename?: 'loggedAction_var_pop_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "audit.logged_actions" */
export type LoggedAction_Var_Pop_Order_By = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Order_By>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type LoggedAction_Var_Samp_Fields = {
  __typename?: 'loggedAction_var_samp_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "audit.logged_actions" */
export type LoggedAction_Var_Samp_Order_By = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Order_By>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type LoggedAction_Variance_Fields = {
  __typename?: 'loggedAction_variance_fields';
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Float']>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "audit.logged_actions" */
export type LoggedAction_Variance_Order_By = {
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: InputMaybe<Order_By>;
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: InputMaybe<Order_By>;
};

/** columns and relationships of "reporting.loss_ratio" */
export type LossRatio = {
  __typename?: 'lossRatio';
  /** An object relationship */
  account: Account;
  accountId: Scalars['uuid'];
  /** An object relationship */
  category: Category;
  categoryId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  earnedAmount: Scalars['numeric'];
  earnedThroughDate: Scalars['date'];
  id: Scalars['uuid'];
  lossRatioPercent: Scalars['numeric'];
  totalClaimsPaidAmount: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
};

/** Returns the most recent loss_ratio for each category based on the earned_through_date */
export type LossRatioCurrentView = {
  __typename?: 'lossRatioCurrentView';
  accountId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  earnedAmount?: Maybe<Scalars['numeric']>;
  earnedThroughDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  lossRatioPercent?: Maybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Aggregate = {
  __typename?: 'lossRatioCurrentView_aggregate';
  aggregate?: Maybe<LossRatioCurrentView_Aggregate_Fields>;
  nodes: Array<LossRatioCurrentView>;
};

export type LossRatioCurrentView_Aggregate_Bool_Exp = {
  count?: InputMaybe<LossRatioCurrentView_Aggregate_Bool_Exp_Count>;
};

export type LossRatioCurrentView_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<LossRatioCurrentView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LossRatioCurrentView_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Aggregate_Fields = {
  __typename?: 'lossRatioCurrentView_aggregate_fields';
  avg?: Maybe<LossRatioCurrentView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<LossRatioCurrentView_Max_Fields>;
  min?: Maybe<LossRatioCurrentView_Min_Fields>;
  stddev?: Maybe<LossRatioCurrentView_Stddev_Fields>;
  stddev_pop?: Maybe<LossRatioCurrentView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<LossRatioCurrentView_Stddev_Samp_Fields>;
  sum?: Maybe<LossRatioCurrentView_Sum_Fields>;
  var_pop?: Maybe<LossRatioCurrentView_Var_Pop_Fields>;
  var_samp?: Maybe<LossRatioCurrentView_Var_Samp_Fields>;
  variance?: Maybe<LossRatioCurrentView_Variance_Fields>;
};


/** aggregate fields of "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LossRatioCurrentView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Aggregate_Order_By = {
  avg?: InputMaybe<LossRatioCurrentView_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<LossRatioCurrentView_Max_Order_By>;
  min?: InputMaybe<LossRatioCurrentView_Min_Order_By>;
  stddev?: InputMaybe<LossRatioCurrentView_Stddev_Order_By>;
  stddev_pop?: InputMaybe<LossRatioCurrentView_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<LossRatioCurrentView_Stddev_Samp_Order_By>;
  sum?: InputMaybe<LossRatioCurrentView_Sum_Order_By>;
  var_pop?: InputMaybe<LossRatioCurrentView_Var_Pop_Order_By>;
  var_samp?: InputMaybe<LossRatioCurrentView_Var_Samp_Order_By>;
  variance?: InputMaybe<LossRatioCurrentView_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Arr_Rel_Insert_Input = {
  data: Array<LossRatioCurrentView_Insert_Input>;
};

/** aggregate avg on columns */
export type LossRatioCurrentView_Avg_Fields = {
  __typename?: 'lossRatioCurrentView_avg_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Avg_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reporting.loss_ratio_current_view". All fields are combined with a logical 'AND'. */
export type LossRatioCurrentView_Bool_Exp = {
  _and?: InputMaybe<Array<LossRatioCurrentView_Bool_Exp>>;
  _not?: InputMaybe<LossRatioCurrentView_Bool_Exp>;
  _or?: InputMaybe<Array<LossRatioCurrentView_Bool_Exp>>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  earnedAmount?: InputMaybe<Numeric_Comparison_Exp>;
  earnedThroughDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lossRatioPercent?: InputMaybe<Numeric_Comparison_Exp>;
  totalClaimsPaidAmount?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Insert_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  earnedAmount?: InputMaybe<Scalars['numeric']>;
  earnedThroughDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  lossRatioPercent?: InputMaybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LossRatioCurrentView_Max_Fields = {
  __typename?: 'lossRatioCurrentView_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  earnedAmount?: Maybe<Scalars['numeric']>;
  earnedThroughDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  lossRatioPercent?: Maybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  earnedAmount?: InputMaybe<Order_By>;
  earnedThroughDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type LossRatioCurrentView_Min_Fields = {
  __typename?: 'lossRatioCurrentView_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  earnedAmount?: Maybe<Scalars['numeric']>;
  earnedThroughDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  lossRatioPercent?: Maybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  earnedAmount?: InputMaybe<Order_By>;
  earnedThroughDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "reporting.loss_ratio_current_view". */
export type LossRatioCurrentView_Order_By = {
  accountId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  earnedAmount?: InputMaybe<Order_By>;
  earnedThroughDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "reporting.loss_ratio_current_view" */
export enum LossRatioCurrentView_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EarnedAmount = 'earnedAmount',
  /** column name */
  EarnedThroughDate = 'earnedThroughDate',
  /** column name */
  Id = 'id',
  /** column name */
  LossRatioPercent = 'lossRatioPercent',
  /** column name */
  TotalClaimsPaidAmount = 'totalClaimsPaidAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type LossRatioCurrentView_Stddev_Fields = {
  __typename?: 'lossRatioCurrentView_stddev_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Stddev_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type LossRatioCurrentView_Stddev_Pop_Fields = {
  __typename?: 'lossRatioCurrentView_stddev_pop_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Stddev_Pop_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type LossRatioCurrentView_Stddev_Samp_Fields = {
  __typename?: 'lossRatioCurrentView_stddev_samp_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Stddev_Samp_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lossRatioCurrentView" */
export type LossRatioCurrentView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: LossRatioCurrentView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LossRatioCurrentView_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  earnedAmount?: InputMaybe<Scalars['numeric']>;
  earnedThroughDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  lossRatioPercent?: InputMaybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LossRatioCurrentView_Sum_Fields = {
  __typename?: 'lossRatioCurrentView_sum_fields';
  earnedAmount?: Maybe<Scalars['numeric']>;
  lossRatioPercent?: Maybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Sum_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type LossRatioCurrentView_Var_Pop_Fields = {
  __typename?: 'lossRatioCurrentView_var_pop_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Var_Pop_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type LossRatioCurrentView_Var_Samp_Fields = {
  __typename?: 'lossRatioCurrentView_var_samp_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Var_Samp_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type LossRatioCurrentView_Variance_Fields = {
  __typename?: 'lossRatioCurrentView_variance_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reporting.loss_ratio_current_view" */
export type LossRatioCurrentView_Variance_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregated selection of "reporting.loss_ratio" */
export type LossRatio_Aggregate = {
  __typename?: 'lossRatio_aggregate';
  aggregate?: Maybe<LossRatio_Aggregate_Fields>;
  nodes: Array<LossRatio>;
};

export type LossRatio_Aggregate_Bool_Exp = {
  count?: InputMaybe<LossRatio_Aggregate_Bool_Exp_Count>;
};

export type LossRatio_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<LossRatio_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LossRatio_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reporting.loss_ratio" */
export type LossRatio_Aggregate_Fields = {
  __typename?: 'lossRatio_aggregate_fields';
  avg?: Maybe<LossRatio_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<LossRatio_Max_Fields>;
  min?: Maybe<LossRatio_Min_Fields>;
  stddev?: Maybe<LossRatio_Stddev_Fields>;
  stddev_pop?: Maybe<LossRatio_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<LossRatio_Stddev_Samp_Fields>;
  sum?: Maybe<LossRatio_Sum_Fields>;
  var_pop?: Maybe<LossRatio_Var_Pop_Fields>;
  var_samp?: Maybe<LossRatio_Var_Samp_Fields>;
  variance?: Maybe<LossRatio_Variance_Fields>;
};


/** aggregate fields of "reporting.loss_ratio" */
export type LossRatio_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LossRatio_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reporting.loss_ratio" */
export type LossRatio_Aggregate_Order_By = {
  avg?: InputMaybe<LossRatio_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<LossRatio_Max_Order_By>;
  min?: InputMaybe<LossRatio_Min_Order_By>;
  stddev?: InputMaybe<LossRatio_Stddev_Order_By>;
  stddev_pop?: InputMaybe<LossRatio_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<LossRatio_Stddev_Samp_Order_By>;
  sum?: InputMaybe<LossRatio_Sum_Order_By>;
  var_pop?: InputMaybe<LossRatio_Var_Pop_Order_By>;
  var_samp?: InputMaybe<LossRatio_Var_Samp_Order_By>;
  variance?: InputMaybe<LossRatio_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reporting.loss_ratio" */
export type LossRatio_Arr_Rel_Insert_Input = {
  data: Array<LossRatio_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<LossRatio_On_Conflict>;
};

/** aggregate avg on columns */
export type LossRatio_Avg_Fields = {
  __typename?: 'lossRatio_avg_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reporting.loss_ratio" */
export type LossRatio_Avg_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reporting.loss_ratio". All fields are combined with a logical 'AND'. */
export type LossRatio_Bool_Exp = {
  _and?: InputMaybe<Array<LossRatio_Bool_Exp>>;
  _not?: InputMaybe<LossRatio_Bool_Exp>;
  _or?: InputMaybe<Array<LossRatio_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  earnedAmount?: InputMaybe<Numeric_Comparison_Exp>;
  earnedThroughDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lossRatioPercent?: InputMaybe<Numeric_Comparison_Exp>;
  totalClaimsPaidAmount?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "reporting.loss_ratio" */
export enum LossRatio_Constraint {
  /** unique or primary key constraint on columns "account_id", "category_id", "earned_through_date" */
  LossRatioAccountCategoryDateKey = 'loss_ratio_account_category_date_key',
  /** unique or primary key constraint on columns "id" */
  LossRatioPkey = 'loss_ratio_pkey'
}

/** input type for incrementing numeric columns in table "reporting.loss_ratio" */
export type LossRatio_Inc_Input = {
  earnedAmount?: InputMaybe<Scalars['numeric']>;
  lossRatioPercent?: InputMaybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "reporting.loss_ratio" */
export type LossRatio_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  earnedAmount?: InputMaybe<Scalars['numeric']>;
  earnedThroughDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  lossRatioPercent?: InputMaybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LossRatio_Max_Fields = {
  __typename?: 'lossRatio_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  earnedAmount?: Maybe<Scalars['numeric']>;
  earnedThroughDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  lossRatioPercent?: Maybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "reporting.loss_ratio" */
export type LossRatio_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  earnedAmount?: InputMaybe<Order_By>;
  earnedThroughDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type LossRatio_Min_Fields = {
  __typename?: 'lossRatio_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  earnedAmount?: Maybe<Scalars['numeric']>;
  earnedThroughDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  lossRatioPercent?: Maybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "reporting.loss_ratio" */
export type LossRatio_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  earnedAmount?: InputMaybe<Order_By>;
  earnedThroughDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reporting.loss_ratio" */
export type LossRatio_Mutation_Response = {
  __typename?: 'lossRatio_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LossRatio>;
};

/** on_conflict condition type for table "reporting.loss_ratio" */
export type LossRatio_On_Conflict = {
  constraint: LossRatio_Constraint;
  update_columns?: Array<LossRatio_Update_Column>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};

/** Ordering options when selecting data from "reporting.loss_ratio". */
export type LossRatio_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountId?: InputMaybe<Order_By>;
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  earnedAmount?: InputMaybe<Order_By>;
  earnedThroughDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reporting.loss_ratio */
export type LossRatio_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "reporting.loss_ratio" */
export enum LossRatio_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EarnedAmount = 'earnedAmount',
  /** column name */
  EarnedThroughDate = 'earnedThroughDate',
  /** column name */
  Id = 'id',
  /** column name */
  LossRatioPercent = 'lossRatioPercent',
  /** column name */
  TotalClaimsPaidAmount = 'totalClaimsPaidAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "reporting.loss_ratio" */
export type LossRatio_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  earnedAmount?: InputMaybe<Scalars['numeric']>;
  earnedThroughDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  lossRatioPercent?: InputMaybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LossRatio_Stddev_Fields = {
  __typename?: 'lossRatio_stddev_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reporting.loss_ratio" */
export type LossRatio_Stddev_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type LossRatio_Stddev_Pop_Fields = {
  __typename?: 'lossRatio_stddev_pop_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reporting.loss_ratio" */
export type LossRatio_Stddev_Pop_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type LossRatio_Stddev_Samp_Fields = {
  __typename?: 'lossRatio_stddev_samp_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reporting.loss_ratio" */
export type LossRatio_Stddev_Samp_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lossRatio" */
export type LossRatio_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: LossRatio_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LossRatio_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  earnedAmount?: InputMaybe<Scalars['numeric']>;
  earnedThroughDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  lossRatioPercent?: InputMaybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LossRatio_Sum_Fields = {
  __typename?: 'lossRatio_sum_fields';
  earnedAmount?: Maybe<Scalars['numeric']>;
  lossRatioPercent?: Maybe<Scalars['numeric']>;
  totalClaimsPaidAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "reporting.loss_ratio" */
export type LossRatio_Sum_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** update columns of table "reporting.loss_ratio" */
export enum LossRatio_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EarnedAmount = 'earnedAmount',
  /** column name */
  EarnedThroughDate = 'earnedThroughDate',
  /** column name */
  Id = 'id',
  /** column name */
  LossRatioPercent = 'lossRatioPercent',
  /** column name */
  TotalClaimsPaidAmount = 'totalClaimsPaidAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LossRatio_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LossRatio_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LossRatio_Set_Input>;
  /** filter the rows which have to be updated */
  where: LossRatio_Bool_Exp;
};

/** aggregate var_pop on columns */
export type LossRatio_Var_Pop_Fields = {
  __typename?: 'lossRatio_var_pop_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reporting.loss_ratio" */
export type LossRatio_Var_Pop_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type LossRatio_Var_Samp_Fields = {
  __typename?: 'lossRatio_var_samp_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reporting.loss_ratio" */
export type LossRatio_Var_Samp_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type LossRatio_Variance_Fields = {
  __typename?: 'lossRatio_variance_fields';
  earnedAmount?: Maybe<Scalars['Float']>;
  lossRatioPercent?: Maybe<Scalars['Float']>;
  totalClaimsPaidAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reporting.loss_ratio" */
export type LossRatio_Variance_Order_By = {
  earnedAmount?: InputMaybe<Order_By>;
  lossRatioPercent?: InputMaybe<Order_By>;
  totalClaimsPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate fields of "nhtsa.make_model" */
export type MakeModel_Aggregate_Fields_Nhtsa = {
  __typename?: 'makeModel_aggregate_fields_nhtsa';
  avg?: Maybe<MakeModel_Avg_Fields_Nhtsa>;
  count: Scalars['Int'];
  max?: Maybe<MakeModel_Max_Fields_Nhtsa>;
  min?: Maybe<MakeModel_Min_Fields_Nhtsa>;
  stddev?: Maybe<MakeModel_Stddev_Fields_Nhtsa>;
  stddev_pop?: Maybe<MakeModel_Stddev_Pop_Fields_Nhtsa>;
  stddev_samp?: Maybe<MakeModel_Stddev_Samp_Fields_Nhtsa>;
  sum?: Maybe<MakeModel_Sum_Fields_Nhtsa>;
  var_pop?: Maybe<MakeModel_Var_Pop_Fields_Nhtsa>;
  var_samp?: Maybe<MakeModel_Var_Samp_Fields_Nhtsa>;
  variance?: Maybe<MakeModel_Variance_Fields_Nhtsa>;
};


/** aggregate fields of "nhtsa.make_model" */
export type MakeModel_Aggregate_Fields_NhtsaCountArgs = {
  columns?: InputMaybe<Array<MakeModel_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "nhtsa.make_model" */
export type MakeModel_Aggregate_Nhtsa = {
  __typename?: 'makeModel_aggregate_nhtsa';
  aggregate?: Maybe<MakeModel_Aggregate_Fields_Nhtsa>;
  nodes: Array<MakeModel_Nhtsa>;
};

/** aggregate avg on columns */
export type MakeModel_Avg_Fields_Nhtsa = {
  __typename?: 'makeModel_avg_fields_nhtsa';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nhtsa.make_model". All fields are combined with a logical 'AND'. */
export type MakeModel_Bool_Exp_Nhtsa = {
  _and?: InputMaybe<Array<MakeModel_Bool_Exp_Nhtsa>>;
  _not?: InputMaybe<MakeModel_Bool_Exp_Nhtsa>;
  _or?: InputMaybe<Array<MakeModel_Bool_Exp_Nhtsa>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isVpicMatch?: InputMaybe<Boolean_Comparison_Exp>;
  isVpicModel?: InputMaybe<Boolean_Comparison_Exp>;
  issueMakeModels?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
  issueMakeModels_aggregate?: InputMaybe<IssueMakeModel_Aggregate_Bool_Exp>;
  make?: InputMaybe<String_Comparison_Exp>;
  makeKey?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  modelKey?: InputMaybe<String_Comparison_Exp>;
  modelTokens?: InputMaybe<String_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "nhtsa.make_model" */
export enum MakeModel_Constraint_Nhtsa {
  /** unique or primary key constraint on columns "make", "model" */
  MakeModelMakeModelKey = 'make_model_make_model_key',
  /** unique or primary key constraint on columns "id" */
  MakeModelPkey = 'make_model_pkey'
}

/** input type for inserting data into table "nhtsa.make_model" */
export type MakeModel_Insert_Input_Nhtsa = {
  /** Whether some vPIC make/model pairs with this one under nhtsa.is_model_match, set by restore-nhtsa.sh against the vpic database on the same server. Null when vpic was unavailable. False rows are what nhtsa.load reports as unmatched. */
  isVpicMatch?: InputMaybe<Scalars['Boolean']>;
  /** Whether vPIC has a model for this make spelled the same, ignoring case, punctuation and spacing (BRONCO, MUSTANG), set by restore-nhtsa.sh. nhtsa.search_issues does not treat such a model as the generic form of a longer one (Bronco for a Bronco Sport). Null when vpic was unavailable. */
  isVpicModel?: InputMaybe<Scalars['Boolean']>;
  issueMakeModels?: InputMaybe<IssueMakeModel_Arr_Rel_Insert_Input_Nhtsa>;
  make?: InputMaybe<Scalars['String']>;
  /** nhtsa.get_match_key(make). */
  makeKey?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  /** nhtsa.get_match_key(model). */
  modelKey?: InputMaybe<Scalars['String']>;
  /** nhtsa.get_match_tokens(model). */
  modelTokens?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate max on columns */
export type MakeModel_Max_Fields_Nhtsa = {
  __typename?: 'makeModel_max_fields_nhtsa';
  id?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  /** nhtsa.get_match_key(make). */
  makeKey?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  /** nhtsa.get_match_key(model). */
  modelKey?: Maybe<Scalars['String']>;
  /** nhtsa.get_match_tokens(model). */
  modelTokens?: Maybe<Array<Scalars['String']>>;
};

/** aggregate min on columns */
export type MakeModel_Min_Fields_Nhtsa = {
  __typename?: 'makeModel_min_fields_nhtsa';
  id?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  /** nhtsa.get_match_key(make). */
  makeKey?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  /** nhtsa.get_match_key(model). */
  modelKey?: Maybe<Scalars['String']>;
  /** nhtsa.get_match_tokens(model). */
  modelTokens?: Maybe<Array<Scalars['String']>>;
};

/** response of any mutation on the table "nhtsa.make_model" */
export type MakeModel_Mutation_Response_Nhtsa = {
  __typename?: 'makeModel_mutation_response_nhtsa';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MakeModel_Nhtsa>;
};

/** Every distinct make/model spelling across the three datasets, with the normalized forms the vehicle match compares against vPIC decode output. */
export type MakeModel_Nhtsa = {
  __typename?: 'makeModel_nhtsa';
  id: Scalars['Int'];
  /** Whether some vPIC make/model pairs with this one under nhtsa.is_model_match, set by restore-nhtsa.sh against the vpic database on the same server. Null when vpic was unavailable. False rows are what nhtsa.load reports as unmatched. */
  isVpicMatch?: Maybe<Scalars['Boolean']>;
  /** Whether vPIC has a model for this make spelled the same, ignoring case, punctuation and spacing (BRONCO, MUSTANG), set by restore-nhtsa.sh. nhtsa.search_issues does not treat such a model as the generic form of a longer one (Bronco for a Bronco Sport). Null when vpic was unavailable. */
  isVpicModel?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  issueMakeModels: Array<IssueMakeModel_Nhtsa>;
  /** An aggregate relationship */
  issueMakeModels_aggregate: IssueMakeModel_Aggregate_Nhtsa;
  make: Scalars['String'];
  /** nhtsa.get_match_key(make). */
  makeKey: Scalars['String'];
  model: Scalars['String'];
  /** nhtsa.get_match_key(model). */
  modelKey: Scalars['String'];
  /** nhtsa.get_match_tokens(model). */
  modelTokens: Array<Scalars['String']>;
};


/** Every distinct make/model spelling across the three datasets, with the normalized forms the vehicle match compares against vPIC decode output. */
export type MakeModel_NhtsaIssueMakeModelsArgs = {
  distinct_on?: InputMaybe<Array<IssueMakeModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueMakeModel_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
};


/** Every distinct make/model spelling across the three datasets, with the normalized forms the vehicle match compares against vPIC decode output. */
export type MakeModel_NhtsaIssueMakeModels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IssueMakeModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueMakeModel_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
};

/** input type for inserting object relation for remote table "nhtsa.make_model" */
export type MakeModel_Obj_Rel_Insert_Input_Nhtsa = {
  data: MakeModel_Insert_Input_Nhtsa;
  /** upsert condition */
  on_conflict?: InputMaybe<MakeModel_On_Conflict_Nhtsa>;
};

/** on_conflict condition type for table "nhtsa.make_model" */
export type MakeModel_On_Conflict_Nhtsa = {
  constraint: MakeModel_Constraint_Nhtsa;
  update_columns?: Array<MakeModel_Update_Column_Nhtsa>;
  where?: InputMaybe<MakeModel_Bool_Exp_Nhtsa>;
};

/** Ordering options when selecting data from "nhtsa.make_model". */
export type MakeModel_Order_By_Nhtsa = {
  id?: InputMaybe<Order_By>;
  isVpicMatch?: InputMaybe<Order_By>;
  isVpicModel?: InputMaybe<Order_By>;
  issueMakeModels_aggregate?: InputMaybe<IssueMakeModel_Aggregate_Order_By_Nhtsa>;
  make?: InputMaybe<Order_By>;
  makeKey?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  modelKey?: InputMaybe<Order_By>;
  modelTokens?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nhtsa.make_model */
export type MakeModel_Pk_Columns_Input_Nhtsa = {
  id: Scalars['Int'];
};

/** select columns of table "nhtsa.make_model" */
export enum MakeModel_Select_Column_Nhtsa {
  /** column name */
  Id = 'id',
  /** column name */
  IsVpicMatch = 'isVpicMatch',
  /** column name */
  IsVpicModel = 'isVpicModel',
  /** column name */
  Make = 'make',
  /** column name */
  MakeKey = 'makeKey',
  /** column name */
  Model = 'model',
  /** column name */
  ModelKey = 'modelKey',
  /** column name */
  ModelTokens = 'modelTokens'
}

/** input type for updating data in table "nhtsa.make_model" */
export type MakeModel_Set_Input_Nhtsa = {
  /** Whether some vPIC make/model pairs with this one under nhtsa.is_model_match, set by restore-nhtsa.sh against the vpic database on the same server. Null when vpic was unavailable. False rows are what nhtsa.load reports as unmatched. */
  isVpicMatch?: InputMaybe<Scalars['Boolean']>;
  /** Whether vPIC has a model for this make spelled the same, ignoring case, punctuation and spacing (BRONCO, MUSTANG), set by restore-nhtsa.sh. nhtsa.search_issues does not treat such a model as the generic form of a longer one (Bronco for a Bronco Sport). Null when vpic was unavailable. */
  isVpicModel?: InputMaybe<Scalars['Boolean']>;
  make?: InputMaybe<Scalars['String']>;
  /** nhtsa.get_match_key(make). */
  makeKey?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  /** nhtsa.get_match_key(model). */
  modelKey?: InputMaybe<Scalars['String']>;
  /** nhtsa.get_match_tokens(model). */
  modelTokens?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate stddev on columns */
export type MakeModel_Stddev_Fields_Nhtsa = {
  __typename?: 'makeModel_stddev_fields_nhtsa';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MakeModel_Stddev_Pop_Fields_Nhtsa = {
  __typename?: 'makeModel_stddev_pop_fields_nhtsa';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MakeModel_Stddev_Samp_Fields_Nhtsa = {
  __typename?: 'makeModel_stddev_samp_fields_nhtsa';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "makeModel" */
export type MakeModel_Stream_Cursor_Input_Nhtsa = {
  /** Stream column input with initial value */
  initial_value: MakeModel_Stream_Cursor_Value_Input_Nhtsa;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Nhtsa>;
};

/** Initial value of the column from where the streaming should start */
export type MakeModel_Stream_Cursor_Value_Input_Nhtsa = {
  id?: InputMaybe<Scalars['Int']>;
  /** Whether some vPIC make/model pairs with this one under nhtsa.is_model_match, set by restore-nhtsa.sh against the vpic database on the same server. Null when vpic was unavailable. False rows are what nhtsa.load reports as unmatched. */
  isVpicMatch?: InputMaybe<Scalars['Boolean']>;
  /** Whether vPIC has a model for this make spelled the same, ignoring case, punctuation and spacing (BRONCO, MUSTANG), set by restore-nhtsa.sh. nhtsa.search_issues does not treat such a model as the generic form of a longer one (Bronco for a Bronco Sport). Null when vpic was unavailable. */
  isVpicModel?: InputMaybe<Scalars['Boolean']>;
  make?: InputMaybe<Scalars['String']>;
  /** nhtsa.get_match_key(make). */
  makeKey?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  /** nhtsa.get_match_key(model). */
  modelKey?: InputMaybe<Scalars['String']>;
  /** nhtsa.get_match_tokens(model). */
  modelTokens?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate sum on columns */
export type MakeModel_Sum_Fields_Nhtsa = {
  __typename?: 'makeModel_sum_fields_nhtsa';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "nhtsa.make_model" */
export enum MakeModel_Update_Column_Nhtsa {
  /** column name */
  IsVpicMatch = 'isVpicMatch',
  /** column name */
  IsVpicModel = 'isVpicModel',
  /** column name */
  Make = 'make',
  /** column name */
  MakeKey = 'makeKey',
  /** column name */
  Model = 'model',
  /** column name */
  ModelKey = 'modelKey',
  /** column name */
  ModelTokens = 'modelTokens'
}

export type MakeModel_Updates_Nhtsa = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MakeModel_Set_Input_Nhtsa>;
  /** filter the rows which have to be updated */
  where: MakeModel_Bool_Exp_Nhtsa;
};

/** aggregate var_pop on columns */
export type MakeModel_Var_Pop_Fields_Nhtsa = {
  __typename?: 'makeModel_var_pop_fields_nhtsa';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MakeModel_Var_Samp_Fields_Nhtsa = {
  __typename?: 'makeModel_var_samp_fields_nhtsa';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MakeModel_Variance_Fields_Nhtsa = {
  __typename?: 'makeModel_variance_fields_nhtsa';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "classes.materalized_class_criteria_view_default_vehicle_criteria" */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria';
  body_style_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  classGuideClassCriterias: Array<ClassGuideClassCriteria>;
  /** An aggregate relationship */
  classGuideClassCriterias_aggregate: ClassGuideClassCriteria_Aggregate;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fuel_type_code?: Maybe<Scalars['String']>;
  has_supercharger?: Maybe<Scalars['Boolean']>;
  has_turbo?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  make_code?: Maybe<Scalars['String']>;
  model_name?: Maybe<Scalars['String']>;
  number_of_cylinders?: Maybe<Scalars['Int']>;
  number_wheels_driving?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_type_code?: Maybe<Scalars['String']>;
  vehicle_year?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "classes.materalized_class_criteria_view_default_vehicle_criteria" */
export type MateralizedClassCriteriaViewDefaultVehicleCriteriaClassGuideClassCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


/** columns and relationships of "classes.materalized_class_criteria_view_default_vehicle_criteria" */
export type MateralizedClassCriteriaViewDefaultVehicleCriteriaClassGuideClassCriterias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};

/** aggregated selection of "classes.materalized_class_criteria_view_default_vehicle_criteria" */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Aggregate = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_aggregate';
  aggregate?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Aggregate_Fields>;
  nodes: Array<MateralizedClassCriteriaViewDefaultVehicleCriteria>;
};

/** aggregate fields of "classes.materalized_class_criteria_view_default_vehicle_criteria" */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Aggregate_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_aggregate_fields';
  avg?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Max_Fields>;
  min?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Min_Fields>;
  stddev?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Stddev_Fields>;
  stddev_pop?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Stddev_Samp_Fields>;
  sum?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Sum_Fields>;
  var_pop?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Var_Pop_Fields>;
  var_samp?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Var_Samp_Fields>;
  variance?: Maybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Variance_Fields>;
};


/** aggregate fields of "classes.materalized_class_criteria_view_default_vehicle_criteria" */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Avg_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_avg_fields';
  number_of_cylinders?: Maybe<Scalars['Float']>;
  number_wheels_driving?: Maybe<Scalars['Float']>;
  vehicle_year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "classes.materalized_class_criteria_view_default_vehicle_criteria". All fields are combined with a logical 'AND'. */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Bool_Exp = {
  _and?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>>;
  _not?: InputMaybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
  _or?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>>;
  body_style_code?: InputMaybe<String_Comparison_Exp>;
  classGuideClassCriterias?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
  classGuideClassCriterias_aggregate?: InputMaybe<ClassGuideClassCriteria_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fuel_type_code?: InputMaybe<String_Comparison_Exp>;
  has_supercharger?: InputMaybe<Boolean_Comparison_Exp>;
  has_turbo?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  make_code?: InputMaybe<String_Comparison_Exp>;
  model_name?: InputMaybe<String_Comparison_Exp>;
  number_of_cylinders?: InputMaybe<Int_Comparison_Exp>;
  number_wheels_driving?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicle_type_code?: InputMaybe<String_Comparison_Exp>;
  vehicle_year?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Max_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_max_fields';
  body_style_code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fuel_type_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make_code?: Maybe<Scalars['String']>;
  model_name?: Maybe<Scalars['String']>;
  number_of_cylinders?: Maybe<Scalars['Int']>;
  number_wheels_driving?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_type_code?: Maybe<Scalars['String']>;
  vehicle_year?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Min_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_min_fields';
  body_style_code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fuel_type_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make_code?: Maybe<Scalars['String']>;
  model_name?: Maybe<Scalars['String']>;
  number_of_cylinders?: Maybe<Scalars['Int']>;
  number_wheels_driving?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_type_code?: Maybe<Scalars['String']>;
  vehicle_year?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "classes.materalized_class_criteria_view_default_vehicle_criteria". */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Order_By = {
  body_style_code?: InputMaybe<Order_By>;
  classGuideClassCriterias_aggregate?: InputMaybe<ClassGuideClassCriteria_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fuel_type_code?: InputMaybe<Order_By>;
  has_supercharger?: InputMaybe<Order_By>;
  has_turbo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  make_code?: InputMaybe<Order_By>;
  model_name?: InputMaybe<Order_By>;
  number_of_cylinders?: InputMaybe<Order_By>;
  number_wheels_driving?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicle_type_code?: InputMaybe<Order_By>;
  vehicle_year?: InputMaybe<Order_By>;
};

/** select columns of table "classes.materalized_class_criteria_view_default_vehicle_criteria" */
export enum MateralizedClassCriteriaViewDefaultVehicleCriteria_Select_Column {
  /** column name */
  BodyStyleCode = 'body_style_code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FuelTypeCode = 'fuel_type_code',
  /** column name */
  HasSupercharger = 'has_supercharger',
  /** column name */
  HasTurbo = 'has_turbo',
  /** column name */
  Id = 'id',
  /** column name */
  MakeCode = 'make_code',
  /** column name */
  ModelName = 'model_name',
  /** column name */
  NumberOfCylinders = 'number_of_cylinders',
  /** column name */
  NumberWheelsDriving = 'number_wheels_driving',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleTypeCode = 'vehicle_type_code',
  /** column name */
  VehicleYear = 'vehicle_year'
}

/** aggregate stddev on columns */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Stddev_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_stddev_fields';
  number_of_cylinders?: Maybe<Scalars['Float']>;
  number_wheels_driving?: Maybe<Scalars['Float']>;
  vehicle_year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Stddev_Pop_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_stddev_pop_fields';
  number_of_cylinders?: Maybe<Scalars['Float']>;
  number_wheels_driving?: Maybe<Scalars['Float']>;
  vehicle_year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Stddev_Samp_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_stddev_samp_fields';
  number_of_cylinders?: Maybe<Scalars['Float']>;
  number_wheels_driving?: Maybe<Scalars['Float']>;
  vehicle_year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "materalizedClassCriteriaViewDefaultVehicleCriteria" */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MateralizedClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Value_Input = {
  body_style_code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fuel_type_code?: InputMaybe<Scalars['String']>;
  has_supercharger?: InputMaybe<Scalars['Boolean']>;
  has_turbo?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  make_code?: InputMaybe<Scalars['String']>;
  model_name?: InputMaybe<Scalars['String']>;
  number_of_cylinders?: InputMaybe<Scalars['Int']>;
  number_wheels_driving?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vehicle_type_code?: InputMaybe<Scalars['String']>;
  vehicle_year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Sum_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_sum_fields';
  number_of_cylinders?: Maybe<Scalars['Int']>;
  number_wheels_driving?: Maybe<Scalars['Int']>;
  vehicle_year?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Var_Pop_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_var_pop_fields';
  number_of_cylinders?: Maybe<Scalars['Float']>;
  number_wheels_driving?: Maybe<Scalars['Float']>;
  vehicle_year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Var_Samp_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_var_samp_fields';
  number_of_cylinders?: Maybe<Scalars['Float']>;
  number_wheels_driving?: Maybe<Scalars['Float']>;
  vehicle_year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MateralizedClassCriteriaViewDefaultVehicleCriteria_Variance_Fields = {
  __typename?: 'materalizedClassCriteriaViewDefaultVehicleCriteria_variance_fields';
  number_of_cylinders?: Maybe<Scalars['Float']>;
  number_wheels_driving?: Maybe<Scalars['Float']>;
  vehicle_year?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "miles_calculation_type" */
export type MilesCalculationType = {
  __typename?: 'milesCalculationType';
  display?: Maybe<Scalars['String']>;
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** aggregated selection of "miles_calculation_type" */
export type MilesCalculationType_Aggregate = {
  __typename?: 'milesCalculationType_aggregate';
  aggregate?: Maybe<MilesCalculationType_Aggregate_Fields>;
  nodes: Array<MilesCalculationType>;
};

/** aggregate fields of "miles_calculation_type" */
export type MilesCalculationType_Aggregate_Fields = {
  __typename?: 'milesCalculationType_aggregate_fields';
  avg?: Maybe<MilesCalculationType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<MilesCalculationType_Max_Fields>;
  min?: Maybe<MilesCalculationType_Min_Fields>;
  stddev?: Maybe<MilesCalculationType_Stddev_Fields>;
  stddev_pop?: Maybe<MilesCalculationType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MilesCalculationType_Stddev_Samp_Fields>;
  sum?: Maybe<MilesCalculationType_Sum_Fields>;
  var_pop?: Maybe<MilesCalculationType_Var_Pop_Fields>;
  var_samp?: Maybe<MilesCalculationType_Var_Samp_Fields>;
  variance?: Maybe<MilesCalculationType_Variance_Fields>;
};


/** aggregate fields of "miles_calculation_type" */
export type MilesCalculationType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MilesCalculationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MilesCalculationType_Avg_Fields = {
  __typename?: 'milesCalculationType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "miles_calculation_type". All fields are combined with a logical 'AND'. */
export type MilesCalculationType_Bool_Exp = {
  _and?: InputMaybe<Array<MilesCalculationType_Bool_Exp>>;
  _not?: InputMaybe<MilesCalculationType_Bool_Exp>;
  _or?: InputMaybe<Array<MilesCalculationType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "miles_calculation_type" */
export enum MilesCalculationType_Constraint {
  /** unique or primary key constraint on columns "id" */
  MilesCalculationTypePkey = 'miles_calculation_type_pkey'
}

/** input type for incrementing numeric columns in table "miles_calculation_type" */
export type MilesCalculationType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "miles_calculation_type" */
export type MilesCalculationType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MilesCalculationType_Max_Fields = {
  __typename?: 'milesCalculationType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MilesCalculationType_Min_Fields = {
  __typename?: 'milesCalculationType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "miles_calculation_type" */
export type MilesCalculationType_Mutation_Response = {
  __typename?: 'milesCalculationType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MilesCalculationType>;
};

/** on_conflict condition type for table "miles_calculation_type" */
export type MilesCalculationType_On_Conflict = {
  constraint: MilesCalculationType_Constraint;
  update_columns?: Array<MilesCalculationType_Update_Column>;
  where?: InputMaybe<MilesCalculationType_Bool_Exp>;
};

/** Ordering options when selecting data from "miles_calculation_type". */
export type MilesCalculationType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: miles_calculation_type */
export type MilesCalculationType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "miles_calculation_type" */
export enum MilesCalculationType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "miles_calculation_type" */
export type MilesCalculationType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type MilesCalculationType_Stddev_Fields = {
  __typename?: 'milesCalculationType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MilesCalculationType_Stddev_Pop_Fields = {
  __typename?: 'milesCalculationType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MilesCalculationType_Stddev_Samp_Fields = {
  __typename?: 'milesCalculationType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "milesCalculationType" */
export type MilesCalculationType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MilesCalculationType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MilesCalculationType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type MilesCalculationType_Sum_Fields = {
  __typename?: 'milesCalculationType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "miles_calculation_type" */
export enum MilesCalculationType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type MilesCalculationType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MilesCalculationType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MilesCalculationType_Set_Input>;
  /** filter the rows which have to be updated */
  where: MilesCalculationType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MilesCalculationType_Var_Pop_Fields = {
  __typename?: 'milesCalculationType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MilesCalculationType_Var_Samp_Fields = {
  __typename?: 'milesCalculationType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MilesCalculationType_Variance_Fields = {
  __typename?: 'milesCalculationType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate fields of "nhtsa.model_year_model" */
export type ModelYearModel_Aggregate_Fields_Nhtsa = {
  __typename?: 'modelYearModel_aggregate_fields_nhtsa';
  avg?: Maybe<ModelYearModel_Avg_Fields_Nhtsa>;
  count: Scalars['Int'];
  max?: Maybe<ModelYearModel_Max_Fields_Nhtsa>;
  min?: Maybe<ModelYearModel_Min_Fields_Nhtsa>;
  stddev?: Maybe<ModelYearModel_Stddev_Fields_Nhtsa>;
  stddev_pop?: Maybe<ModelYearModel_Stddev_Pop_Fields_Nhtsa>;
  stddev_samp?: Maybe<ModelYearModel_Stddev_Samp_Fields_Nhtsa>;
  sum?: Maybe<ModelYearModel_Sum_Fields_Nhtsa>;
  var_pop?: Maybe<ModelYearModel_Var_Pop_Fields_Nhtsa>;
  var_samp?: Maybe<ModelYearModel_Var_Samp_Fields_Nhtsa>;
  variance?: Maybe<ModelYearModel_Variance_Fields_Nhtsa>;
};


/** aggregate fields of "nhtsa.model_year_model" */
export type ModelYearModel_Aggregate_Fields_NhtsaCountArgs = {
  columns?: InputMaybe<Array<ModelYearModel_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "nhtsa.model_year_model" */
export type ModelYearModel_Aggregate_Nhtsa = {
  __typename?: 'modelYearModel_aggregate_nhtsa';
  aggregate?: Maybe<ModelYearModel_Aggregate_Fields_Nhtsa>;
  nodes: Array<ModelYearModel_Nhtsa>;
};

/** aggregate avg on columns */
export type ModelYearModel_Avg_Fields_Nhtsa = {
  __typename?: 'modelYearModel_avg_fields_nhtsa';
  modelYear?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nhtsa.model_year_model". All fields are combined with a logical 'AND'. */
export type ModelYearModel_Bool_Exp_Nhtsa = {
  _and?: InputMaybe<Array<ModelYearModel_Bool_Exp_Nhtsa>>;
  _not?: InputMaybe<ModelYearModel_Bool_Exp_Nhtsa>;
  _or?: InputMaybe<Array<ModelYearModel_Bool_Exp_Nhtsa>>;
  make?: InputMaybe<String_Comparison_Exp>;
  makeKey?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  modelYear?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "nhtsa.model_year_model" */
export enum ModelYearModel_Constraint_Nhtsa {
  /** unique or primary key constraint on columns "make_key", "model_year", "model" */
  ModelYearModelPkey = 'model_year_model_pkey'
}

/** input type for incrementing numeric columns in table "nhtsa.model_year_model" */
export type ModelYearModel_Inc_Input_Nhtsa = {
  modelYear?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nhtsa.model_year_model" */
export type ModelYearModel_Insert_Input_Nhtsa = {
  make?: InputMaybe<Scalars['String']>;
  makeKey?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  modelYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ModelYearModel_Max_Fields_Nhtsa = {
  __typename?: 'modelYearModel_max_fields_nhtsa';
  make?: Maybe<Scalars['String']>;
  makeKey?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  modelYear?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ModelYearModel_Min_Fields_Nhtsa = {
  __typename?: 'modelYearModel_min_fields_nhtsa';
  make?: Maybe<Scalars['String']>;
  makeKey?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  modelYear?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "nhtsa.model_year_model" */
export type ModelYearModel_Mutation_Response_Nhtsa = {
  __typename?: 'modelYearModel_mutation_response_nhtsa';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ModelYearModel_Nhtsa>;
};

/** The year/make/model combinations some issue lists, for the claims search's manual vehicle entry. make is the most common spelling of the make_key. */
export type ModelYearModel_Nhtsa = {
  __typename?: 'modelYearModel_nhtsa';
  make: Scalars['String'];
  makeKey: Scalars['String'];
  model: Scalars['String'];
  modelYear: Scalars['Int'];
};

/** on_conflict condition type for table "nhtsa.model_year_model" */
export type ModelYearModel_On_Conflict_Nhtsa = {
  constraint: ModelYearModel_Constraint_Nhtsa;
  update_columns?: Array<ModelYearModel_Update_Column_Nhtsa>;
  where?: InputMaybe<ModelYearModel_Bool_Exp_Nhtsa>;
};

/** Ordering options when selecting data from "nhtsa.model_year_model". */
export type ModelYearModel_Order_By_Nhtsa = {
  make?: InputMaybe<Order_By>;
  makeKey?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  modelYear?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nhtsa.model_year_model */
export type ModelYearModel_Pk_Columns_Input_Nhtsa = {
  makeKey: Scalars['String'];
  model: Scalars['String'];
  modelYear: Scalars['Int'];
};

/** select columns of table "nhtsa.model_year_model" */
export enum ModelYearModel_Select_Column_Nhtsa {
  /** column name */
  Make = 'make',
  /** column name */
  MakeKey = 'makeKey',
  /** column name */
  Model = 'model',
  /** column name */
  ModelYear = 'modelYear'
}

/** input type for updating data in table "nhtsa.model_year_model" */
export type ModelYearModel_Set_Input_Nhtsa = {
  make?: InputMaybe<Scalars['String']>;
  makeKey?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  modelYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ModelYearModel_Stddev_Fields_Nhtsa = {
  __typename?: 'modelYearModel_stddev_fields_nhtsa';
  modelYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ModelYearModel_Stddev_Pop_Fields_Nhtsa = {
  __typename?: 'modelYearModel_stddev_pop_fields_nhtsa';
  modelYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ModelYearModel_Stddev_Samp_Fields_Nhtsa = {
  __typename?: 'modelYearModel_stddev_samp_fields_nhtsa';
  modelYear?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "modelYearModel" */
export type ModelYearModel_Stream_Cursor_Input_Nhtsa = {
  /** Stream column input with initial value */
  initial_value: ModelYearModel_Stream_Cursor_Value_Input_Nhtsa;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Nhtsa>;
};

/** Initial value of the column from where the streaming should start */
export type ModelYearModel_Stream_Cursor_Value_Input_Nhtsa = {
  make?: InputMaybe<Scalars['String']>;
  makeKey?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  modelYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ModelYearModel_Sum_Fields_Nhtsa = {
  __typename?: 'modelYearModel_sum_fields_nhtsa';
  modelYear?: Maybe<Scalars['Int']>;
};

/** update columns of table "nhtsa.model_year_model" */
export enum ModelYearModel_Update_Column_Nhtsa {
  /** column name */
  Make = 'make',
  /** column name */
  MakeKey = 'makeKey',
  /** column name */
  Model = 'model',
  /** column name */
  ModelYear = 'modelYear'
}

export type ModelYearModel_Updates_Nhtsa = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ModelYearModel_Inc_Input_Nhtsa>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ModelYearModel_Set_Input_Nhtsa>;
  /** filter the rows which have to be updated */
  where: ModelYearModel_Bool_Exp_Nhtsa;
};

/** aggregate var_pop on columns */
export type ModelYearModel_Var_Pop_Fields_Nhtsa = {
  __typename?: 'modelYearModel_var_pop_fields_nhtsa';
  modelYear?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ModelYearModel_Var_Samp_Fields_Nhtsa = {
  __typename?: 'modelYearModel_var_samp_fields_nhtsa';
  modelYear?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ModelYearModel_Variance_Fields_Nhtsa = {
  __typename?: 'modelYearModel_variance_fields_nhtsa';
  modelYear?: Maybe<Scalars['Float']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete single row from the table: "account" */
  deleteAccount?: Maybe<Account>;
  /** delete single row from the table: "account_account_manager" */
  deleteAccountAccountManager?: Maybe<AccountAccountManager>;
  /** delete data from the table: "account_account_manager" */
  deleteAccountAccountManagers?: Maybe<AccountAccountManager_Mutation_Response>;
  /** delete data from the table: "account_category" */
  deleteAccountCategories?: Maybe<AccountCategory_Mutation_Response>;
  /** delete single row from the table: "account_category" */
  deleteAccountCategory?: Maybe<AccountCategory>;
  /** delete single row from the table: "account_disbursement" */
  deleteAccountDisbursement?: Maybe<AccountDisbursement>;
  /** delete data from the table: "account_disbursement" */
  deleteAccountDisbursements?: Maybe<AccountDisbursement_Mutation_Response>;
  /** delete single row from the table: "account_manager" */
  deleteAccountManager?: Maybe<AccountManager>;
  /** delete data from the table: "account_manager" */
  deleteAccountManagers?: Maybe<AccountManager_Mutation_Response>;
  /** delete single row from the table: "account_obligor" */
  deleteAccountObligor?: Maybe<AccountObligor>;
  /** delete data from the table: "account_obligor" */
  deleteAccountObligors?: Maybe<AccountObligor_Mutation_Response>;
  /** delete single row from the table: "account_product" */
  deleteAccountProduct?: Maybe<AccountProduct>;
  /** delete single row from the table: "account_product_obligor" */
  deleteAccountProductObligor?: Maybe<AccountProductObligor>;
  /** delete data from the table: "account_product_obligor" */
  deleteAccountProductObligors?: Maybe<AccountProductObligor_Mutation_Response>;
  /** delete data from the table: "account_product" */
  deleteAccountProducts?: Maybe<AccountProduct_Mutation_Response>;
  /** delete single row from the table: "account_retail" */
  deleteAccountRetail?: Maybe<AccountRetail>;
  /** delete data from the table: "account_retail" */
  deleteAccountRetails?: Maybe<AccountRetail_Mutation_Response>;
  /** delete single row from the table: "account_type" */
  deleteAccountType?: Maybe<AccountType>;
  /** delete data from the table: "account_type" */
  deleteAccountTypes?: Maybe<AccountType_Mutation_Response>;
  /** delete data from the table: "account" */
  deleteAccounts?: Maybe<Account_Mutation_Response>;
  /** delete single row from the table: "address" */
  deleteAddress?: Maybe<Address>;
  /** delete single row from the table: "address_type" */
  deleteAddressType?: Maybe<AddressType>;
  /** delete data from the table: "address_type" */
  deleteAddressTypes?: Maybe<AddressType_Mutation_Response>;
  /** delete data from the table: "address" */
  deleteAddresses?: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "shared.alert" */
  deleteAlert?: Maybe<Alert>;
  /** delete single row from the table: "shared.alert_acknowledgment" */
  deleteAlertAcknowledgment?: Maybe<AlertAcknowledgment>;
  /** delete data from the table: "shared.alert_acknowledgment" */
  deleteAlertAcknowledgments?: Maybe<AlertAcknowledgment_Mutation_Response>;
  /** delete data from the table: "shared.alert" */
  deleteAlerts?: Maybe<Alert_Mutation_Response>;
  /** delete single row from the table: "auth.application" */
  deleteApplication?: Maybe<Application>;
  /** delete single row from the table: "users.application_preference" */
  deleteApplicationPreference?: Maybe<ApplicationPreference>;
  /** delete data from the table: "users.application_preference" */
  deleteApplicationPreferences?: Maybe<ApplicationPreference_Mutation_Response>;
  /** delete data from the table: "auth.application" */
  deleteApplications?: Maybe<Application_Mutation_Response>;
  /** delete single row from the table: "approvals.approval" */
  deleteApproval?: Maybe<Approval>;
  /** delete data from the table: "approvals.authority" */
  deleteApprovalAuthorities?: Maybe<ApprovalAuthority_Mutation_Response>;
  /** delete single row from the table: "approvals.authority" */
  deleteApprovalAuthority?: Maybe<ApprovalAuthority>;
  /** delete single row from the table: "approvals.gate" */
  deleteApprovalGate?: Maybe<ApprovalGate>;
  /** delete single row from the table: "approvals.gate_binding" */
  deleteApprovalGateBinding?: Maybe<ApprovalGateBinding>;
  /** delete data from the table: "approvals.gate_binding" */
  deleteApprovalGateBindings?: Maybe<ApprovalGateBinding_Mutation_Response>;
  /** delete data from the table: "approvals.gate" */
  deleteApprovalGates?: Maybe<ApprovalGate_Mutation_Response>;
  /** delete data from the table: "approvals.approval" */
  deleteApprovalRecords?: Maybe<Approval_Mutation_Response>;
  /** delete single row from the table: "approvals.request" */
  deleteApprovalRequest?: Maybe<ApprovalRequest>;
  /** delete data from the table: "approvals.request" */
  deleteApprovalRequests?: Maybe<ApprovalRequest_Mutation_Response>;
  /** delete data from the table: "approvals.state" */
  deleteApprovalStates?: Maybe<ApprovalState_Mutation_Response>;
  /** delete single row from the table: "as400_data_sync" */
  deleteAs400DataSync?: Maybe<As400DataSync>;
  /** delete data from the table: "as400_data_sync" */
  deleteAs400DataSyncs?: Maybe<As400DataSync_Mutation_Response>;
  /** delete single row from the table: "shared.bank_account_type" */
  deleteBankAccountType?: Maybe<BankAccountType>;
  /** delete data from the table: "shared.bank_account_type" */
  deleteBankAccountTypes?: Maybe<BankAccountType_Mutation_Response>;
  /** delete single row from the table: "caddy.caddy" */
  deleteCaddy?: Maybe<Caddy>;
  /** delete single row from the table: "caddy.caddy_server_manager_log" */
  deleteCaddyServerManagerLog?: Maybe<CaddyServerManagerLog>;
  /** delete data from the table: "caddy.caddy_server_manager_log" */
  deleteCaddyServerManagerLogs?: Maybe<CaddyServerManagerLog_Mutation_Response>;
  /** delete data from the table: "caddy.caddy" */
  deleteCaddys?: Maybe<Caddy_Mutation_Response>;
  /** delete single row from the table: "compliance.cancel_rule" */
  deleteCancelRule?: Maybe<CancelRule>;
  /** delete single row from the table: "compliance.cancel_rule_fee" */
  deleteCancelRuleFee?: Maybe<CancelRuleFee>;
  /** delete data from the table: "compliance.cancel_rule_fee" */
  deleteCancelRuleFees?: Maybe<CancelRuleFee_Mutation_Response>;
  /** delete single row from the table: "compliance.cancel_rule_refund" */
  deleteCancelRuleRefund?: Maybe<CancelRuleRefund>;
  /** delete data from the table: "compliance.cancel_rule_refund" */
  deleteCancelRuleRefunds?: Maybe<CancelRuleRefund_Mutation_Response>;
  /** delete data from the table: "compliance.cancel_rule" */
  deleteCancelRules?: Maybe<CancelRule_Mutation_Response>;
  /** delete single row from the table: "operations.cancellation" */
  deleteCancellation?: Maybe<Cancellation>;
  /** delete single row from the table: "operations.cancellation_as400" */
  deleteCancellationAs400?: Maybe<CancellationAs400>;
  /** delete data from the table: "operations.cancellation_as400" */
  deleteCancellationAs400s?: Maybe<CancellationAs400_Mutation_Response>;
  /** delete data from the table: "operations.cancellation" */
  deleteCancellations?: Maybe<Cancellation_Mutation_Response>;
  /** delete data from the table: "auth.capability" */
  deleteCapabilities?: Maybe<Capability_Mutation_Response>;
  /** delete single row from the table: "auth.capability" */
  deleteCapability?: Maybe<Capability>;
  /** delete single row from the table: "auth.capability_config" */
  deleteCapabilityConfig?: Maybe<CapabilityConfig>;
  /** delete data from the table: "auth.capability_config" */
  deleteCapabilityConfigs?: Maybe<CapabilityConfig_Mutation_Response>;
  /** delete single row from the table: "auth.capability_route" */
  deleteCapabilityRoute?: Maybe<CapabilityRoute>;
  /** delete data from the table: "auth.capability_route" */
  deleteCapabilityRoutes?: Maybe<CapabilityRoute_Mutation_Response>;
  /** delete single row from the table: "users.card_layout" */
  deleteCardLayout?: Maybe<CardLayout>;
  /** delete data from the table: "users.card_layout" */
  deleteCardLayouts?: Maybe<CardLayout_Mutation_Response>;
  /** delete single row from the table: "carrier" */
  deleteCarrier?: Maybe<Carrier>;
  /** delete data from the table: "carrier" */
  deleteCarriers?: Maybe<Carrier_Mutation_Response>;
  /** delete data from the table: "category" */
  deleteCategories?: Maybe<Category_Mutation_Response>;
  /** delete single row from the table: "category" */
  deleteCategory?: Maybe<Category>;
  /** delete single row from the table: "category_product_attribute_type" */
  deleteCategoryProductAttributeType?: Maybe<CategoryProductAttributeType>;
  /** delete data from the table: "category_product_attribute_type" */
  deleteCategoryProductAttributeTypes?: Maybe<CategoryProductAttributeType_Mutation_Response>;
  /** delete single row from the table: "claim" */
  deleteClaim?: Maybe<Claim>;
  /** delete single row from the table: "claims.claim_detail" */
  deleteClaimDetail?: Maybe<ClaimDetail>;
  /** delete single row from the table: "claims.claim_detail_as400" */
  deleteClaimDetailAs400?: Maybe<ClaimDetailAs400>;
  /** delete data from the table: "claims.claim_detail_as400" */
  deleteClaimDetailAs400s?: Maybe<ClaimDetailAs400_Mutation_Response>;
  /** delete data from the table: "claims.claim_detail_category" */
  deleteClaimDetailCategories?: Maybe<ClaimDetailCategory_Mutation_Response>;
  /** delete single row from the table: "claims.claim_detail_category" */
  deleteClaimDetailCategory?: Maybe<ClaimDetailCategory>;
  /** delete single row from the table: "claims.claim_detail_deduction_as400" */
  deleteClaimDetailDeductionAs400?: Maybe<ClaimDetailDeductionAs400>;
  /** delete data from the table: "claims.claim_detail_deduction_as400" */
  deleteClaimDetailDeductionAs400s?: Maybe<ClaimDetailDeductionAs400_Mutation_Response>;
  /** delete single row from the table: "claims.claim_detail_part_lookup" */
  deleteClaimDetailPartLookup?: Maybe<ClaimDetailPartLookup>;
  /** delete data from the table: "claims.claim_detail_part_lookup" */
  deleteClaimDetailPartLookups?: Maybe<ClaimDetailPartLookup_Mutation_Response>;
  /** delete data from the table: "claims.claim_detail" */
  deleteClaimDetails?: Maybe<ClaimDetail_Mutation_Response>;
  /** delete single row from the table: "claims.claim_service_center" */
  deleteClaimServiceCenter?: Maybe<ClaimServiceCenter>;
  /** delete single row from the table: "claims.claim_service_center_as400" */
  deleteClaimServiceCenterAs400?: Maybe<ClaimServiceCenterAs400>;
  /** delete data from the table: "claims.claim_service_center_as400" */
  deleteClaimServiceCenterAs400s?: Maybe<ClaimServiceCenterAs400_Mutation_Response>;
  /** delete single row from the table: "claims.claim_service_center_authorization" */
  deleteClaimServiceCenterAuthorization?: Maybe<ClaimServiceCenterAuthorization>;
  /** delete data from the table: "claims.claim_service_center_authorization" */
  deleteClaimServiceCenterAuthorizations?: Maybe<ClaimServiceCenterAuthorization_Mutation_Response>;
  /** delete data from the table: "claims.claim_service_center" */
  deleteClaimServiceCenters?: Maybe<ClaimServiceCenter_Mutation_Response>;
  /** delete single row from the table: "ClaimStatus" */
  deleteClaimStatus?: Maybe<ClaimStatus>;
  /** delete single row from the table: "claim_status_type" */
  deleteClaimStatusType?: Maybe<ClaimStatusType>;
  /** delete data from the table: "claim_status_type" */
  deleteClaimStatusTypes?: Maybe<ClaimStatusType_Mutation_Response>;
  /** delete data from the table: "ClaimStatus" */
  deleteClaimStatuses?: Maybe<ClaimStatus_Mutation_Response>;
  /** delete data from the table: "claim" */
  deleteClaims?: Maybe<Claim_Mutation_Response>;
  /** delete data from the table: "ClaimsMaster" */
  deleteClaimsMasters?: Maybe<ClaimsMaster_Mutation_Response>;
  /** delete single row from the table: "classes.class_criteria" */
  deleteClassCriteria?: Maybe<ClassCriteria>;
  /** delete data from the table: "classes.class_criteria" */
  deleteClassCriterias?: Maybe<ClassCriteria_Mutation_Response>;
  /** delete single row from the table: "classes.class_guide" */
  deleteClassGuide?: Maybe<ClassGuide>;
  /** delete single row from the table: "classes.class_guide_class_criteria" */
  deleteClassGuideClassCriteria?: Maybe<ClassGuideClassCriteria>;
  /** delete data from the table: "classes.class_guide_class_criteria" */
  deleteClassGuideClassCriterias?: Maybe<ClassGuideClassCriteria_Mutation_Response>;
  /** delete single row from the table: "classes.class_guide_criteria_definition" */
  deleteClassGuideCriteriaDefinition?: Maybe<ClassGuideCriteriaDefinition>;
  /** delete data from the table: "classes.class_guide_criteria_definition" */
  deleteClassGuideCriteriaDefinitions?: Maybe<ClassGuideCriteriaDefinition_Mutation_Response>;
  /** delete single row from the table: "classes.class_guide_criteria_type" */
  deleteClassGuideCriteriaType?: Maybe<ClassGuideCriteriaType>;
  /** delete data from the table: "classes.class_guide_criteria_type" */
  deleteClassGuideCriteriaTypes?: Maybe<ClassGuideCriteriaType_Mutation_Response>;
  /** delete data from the table: "classes.class_guide" */
  deleteClassGuides?: Maybe<ClassGuide_Mutation_Response>;
  /** delete single row from the table: "composite_product" */
  deleteCompositeProduct?: Maybe<CompositeProduct>;
  /** delete data from the table: "composite_product" */
  deleteCompositeProducts?: Maybe<CompositeProduct_Mutation_Response>;
  /** delete single row from the table: "configuration_item" */
  deleteConfigurationItem?: Maybe<ConfigurationItem>;
  /** delete single row from the table: "configuration_item_type" */
  deleteConfigurationItemType?: Maybe<ConfigurationItemType>;
  /** delete data from the table: "configuration_item_type" */
  deleteConfigurationItemTypes?: Maybe<ConfigurationItemType_Mutation_Response>;
  /** delete data from the table: "configuration_item" */
  deleteConfigurationItems?: Maybe<ConfigurationItem_Mutation_Response>;
  /** delete single row from the table: "contact" */
  deleteContact?: Maybe<Contact>;
  /** delete data from the table: "contact" */
  deleteContacts?: Maybe<Contact_Mutation_Response>;
  /** delete single row from the table: "shared.content_type" */
  deleteContentType?: Maybe<ContentType>;
  /** delete data from the table: "shared.content_type" */
  deleteContentTypes?: Maybe<ContentType_Mutation_Response>;
  /** delete single row from the table: "contract" */
  deleteContract?: Maybe<Contract>;
  /** delete single row from the table: "compliance.contract_form" */
  deleteContractForm?: Maybe<ContractForm>;
  /** delete single row from the table: "compliance.contract_form_filing_status" */
  deleteContractFormFilingStatus?: Maybe<ContractFormFilingStatus>;
  /** delete data from the table: "compliance.contract_form_filing_status" */
  deleteContractFormFilingStatuses?: Maybe<ContractFormFilingStatus_Mutation_Response>;
  /** delete single row from the table: "compliance.contract_form_type" */
  deleteContractFormType?: Maybe<ContractFormType>;
  /** delete data from the table: "compliance.contract_form_type" */
  deleteContractFormTypes?: Maybe<ContractFormType_Mutation_Response>;
  /** delete single row from the table: "compliance.contract_form_version" */
  deleteContractFormVersion?: Maybe<ContractFormVersion>;
  /** delete single row from the table: "compliance.contract_form_version_legacy_file" */
  deleteContractFormVersionLegacyFile?: Maybe<ContractFormVersionLegacyFile>;
  /** delete data from the table: "compliance.contract_form_version_legacy_file" */
  deleteContractFormVersionLegacyFiles?: Maybe<ContractFormVersionLegacyFile_Mutation_Response>;
  /** delete data from the table: "compliance.contract_form_version" */
  deleteContractFormVersions?: Maybe<ContractFormVersion_Mutation_Response>;
  /** delete data from the table: "compliance.contract_form" */
  deleteContractForms?: Maybe<ContractForm_Mutation_Response>;
  /** delete single row from the table: "ContractMaster" */
  deleteContractMaster?: Maybe<ContractMaster>;
  /** delete data from the table: "ContractMasterAdditionalEntity" */
  deleteContractMasterAdditionalEntities?: Maybe<ContractMasterAdditionalEntity_Mutation_Response>;
  /** delete data from the table: "ContractMaster" */
  deleteContractMasters?: Maybe<ContractMaster_Mutation_Response>;
  /** delete single row from the table: "contract_status_type" */
  deleteContractStatusType?: Maybe<ContractStatusType>;
  /** delete data from the table: "contract_status_type" */
  deleteContractStatusTypes?: Maybe<ContractStatusType_Mutation_Response>;
  /** delete data from the table: "contract" */
  deleteContracts?: Maybe<Contract_Mutation_Response>;
  /** delete single row from the table: "cost_adjustment" */
  deleteCostAdjustment?: Maybe<CostAdjustment>;
  /** delete single row from the table: "cost_adjustment_extended_cost" */
  deleteCostAdjustmentExtendedCost?: Maybe<CostAdjustmentExtendedCost>;
  /** delete data from the table: "cost_adjustment_extended_cost" */
  deleteCostAdjustmentExtendedCosts?: Maybe<CostAdjustmentExtendedCost_Mutation_Response>;
  /** delete single row from the table: "cost_adjustment_lookup" */
  deleteCostAdjustmentLookup?: Maybe<CostAdjustmentLookup>;
  /** delete data from the table: "cost_adjustment_lookup" */
  deleteCostAdjustmentLookups?: Maybe<CostAdjustmentLookup_Mutation_Response>;
  /** delete single row from the table: "cost_adjustment_type" */
  deleteCostAdjustmentType?: Maybe<CostAdjustmentType>;
  /** delete data from the table: "cost_adjustment_type" */
  deleteCostAdjustmentTypes?: Maybe<CostAdjustmentType_Mutation_Response>;
  /** delete data from the table: "cost_adjustment" */
  deleteCostAdjustments?: Maybe<CostAdjustment_Mutation_Response>;
  /** delete single row from the table: "custom_field" */
  deleteCustomField?: Maybe<CustomField>;
  /** delete single row from the table: "custom_field_data" */
  deleteCustomFieldData?: Maybe<CustomFieldData>;
  /** delete data from the table: "custom_field_data" */
  deleteCustomFieldDatas?: Maybe<CustomFieldData_Mutation_Response>;
  /** delete single row from the table: "custom_field_type" */
  deleteCustomFieldType?: Maybe<CustomFieldType>;
  /** delete data from the table: "custom_field_type" */
  deleteCustomFieldTypes?: Maybe<CustomFieldType_Mutation_Response>;
  /** delete data from the table: "custom_field" */
  deleteCustomFields?: Maybe<CustomField_Mutation_Response>;
  /** delete single row from the table: "customer" */
  deleteCustomer?: Maybe<Customer>;
  /** delete data from the table: "customer" */
  deleteCustomers?: Maybe<Customer_Mutation_Response>;
  /** delete single row from the table: "accounting.cycle" */
  deleteCycle?: Maybe<Cycle>;
  /** delete data from the table: "accounting.cycle_journal_entry" */
  deleteCycleJournalEntries?: Maybe<CycleJournalEntry_Mutation_Response>;
  /** delete single row from the table: "accounting.cycle_journal_entry" */
  deleteCycleJournalEntry?: Maybe<CycleJournalEntry>;
  /** delete single row from the table: "accounting.cycle_total" */
  deleteCycleTotal?: Maybe<CycleTotal>;
  /** delete data from the table: "accounting.cycle_total" */
  deleteCycleTotals?: Maybe<CycleTotal_Mutation_Response>;
  /** delete data from the table: "accounting.cycle" */
  deleteCycles?: Maybe<Cycle_Mutation_Response>;
  /** delete single row from the table: "data_type" */
  deleteDataType?: Maybe<DataType>;
  /** delete data from the table: "data_type" */
  deleteDataTypes?: Maybe<DataType_Mutation_Response>;
  /** delete single row from the table: "date_calculation_type" */
  deleteDateCalculationType?: Maybe<DateCalculationType>;
  /** delete data from the table: "date_calculation_type" */
  deleteDateCalculationTypes?: Maybe<DateCalculationType_Mutation_Response>;
  /** delete single row from the table: "Dealer" */
  deleteDealer?: Maybe<Dealer>;
  /** delete single row from the table: "dealer_payment_type" */
  deleteDealerPaymentType?: Maybe<DealerPaymentType>;
  /** delete data from the table: "dealer_payment_type" */
  deleteDealerPaymentTypes?: Maybe<DealerPaymentType_Mutation_Response>;
  /** delete data from the table: "Dealer" */
  deleteDealers?: Maybe<Dealer_Mutation_Response>;
  /** delete single row from the table: "disbursement_type" */
  deleteDisbursementType?: Maybe<DisbursementType>;
  /** delete data from the table: "disbursement_type" */
  deleteDisbursementTypes?: Maybe<DisbursementType_Mutation_Response>;
  /** delete single row from the table: "claims.document" */
  deleteDocument?: Maybe<Document>;
  /** delete single row from the table: "shared.document_instance" */
  deleteDocumentInstance?: Maybe<DocumentInstance>;
  /** delete data from the table: "shared.document_instance" */
  deleteDocumentInstances?: Maybe<DocumentInstance_Mutation_Response>;
  /** delete single row from the table: "shared.document_template" */
  deleteDocumentTemplate?: Maybe<DocumentTemplate>;
  /** delete single row from the table: "shared.document_template_application" */
  deleteDocumentTemplateApplication?: Maybe<DocumentTemplateApplication>;
  /** delete data from the table: "shared.document_template_application" */
  deleteDocumentTemplateApplications?: Maybe<DocumentTemplateApplication_Mutation_Response>;
  /** delete data from the table: "shared.document_template" */
  deleteDocumentTemplates?: Maybe<DocumentTemplate_Mutation_Response>;
  /** delete data from the table: "claims.document" */
  deleteDocuments?: Maybe<Document_Mutation_Response>;
  /** delete single row from the table: "eligibility_rule" */
  deleteEligibilityRule?: Maybe<EligibilityRule>;
  /** delete single row from the table: "eligibility_rule_definition" */
  deleteEligibilityRuleDefinition?: Maybe<EligibilityRuleDefinition>;
  /** delete data from the table: "eligibility_rule_definition" */
  deleteEligibilityRuleDefinitions?: Maybe<EligibilityRuleDefinition_Mutation_Response>;
  /** delete data from the table: "eligibility_rule" */
  deleteEligibilityRules?: Maybe<EligibilityRule_Mutation_Response>;
  /** delete single row from the table: "eligibility_type" */
  deleteEligibilityType?: Maybe<EligibilityType>;
  /** delete data from the table: "eligibility_type" */
  deleteEligibilityTypes?: Maybe<EligibilityType_Mutation_Response>;
  /** delete single row from the table: "shared.entity_billing_information" */
  deleteEntityBillingInformation?: Maybe<EntityBillingInformation>;
  /** delete data from the table: "shared.entity_billing_information" */
  deleteEntityBillingInformations?: Maybe<EntityBillingInformation_Mutation_Response>;
  /** delete single row from the table: "entity_configuration_item" */
  deleteEntityConfigurationItem?: Maybe<EntityConfigurationItem>;
  /** delete data from the table: "entity_configuration_item" */
  deleteEntityConfigurationItems?: Maybe<EntityConfigurationItem_Mutation_Response>;
  /** delete single row from the table: "shared.entity_content_type" */
  deleteEntityContentType?: Maybe<EntityContentType>;
  /** delete data from the table: "shared.entity_content_type" */
  deleteEntityContentTypes?: Maybe<EntityContentType_Mutation_Response>;
  /** delete single row from the table: "entity_custom_field" */
  deleteEntityCustomField?: Maybe<EntityCustomField>;
  /** delete single row from the table: "entity_custom_field_value" */
  deleteEntityCustomFieldValue?: Maybe<EntityCustomFieldValue>;
  /** delete data from the table: "entity_custom_field_value" */
  deleteEntityCustomFieldValues?: Maybe<EntityCustomFieldValue_Mutation_Response>;
  /** delete data from the table: "entity_custom_field" */
  deleteEntityCustomFields?: Maybe<EntityCustomField_Mutation_Response>;
  /** delete single row from the table: "entity_data_definition" */
  deleteEntityDataDefinition?: Maybe<EntityDataDefinition>;
  /** delete data from the table: "entity_data_definition" */
  deleteEntityDataDefinitions?: Maybe<EntityDataDefinition_Mutation_Response>;
  /** delete single row from the table: "entity_eligibility_rule" */
  deleteEntityEligibilityRule?: Maybe<EntityEligibilityRule>;
  /** delete data from the table: "entity_eligibility_rule" */
  deleteEntityEligibilityRules?: Maybe<EntityEligibilityRule_Mutation_Response>;
  /** delete single row from the table: "shared.entity_feature" */
  deleteEntityFeature?: Maybe<EntityFeature>;
  /** delete data from the table: "shared.entity_feature" */
  deleteEntityFeatures?: Maybe<EntityFeature_Mutation_Response>;
  /** delete single row from the table: "shared.entity_file_content_type" */
  deleteEntityFileContentType?: Maybe<EntityFileContentType>;
  /** delete data from the table: "shared.entity_file_content_type" */
  deleteEntityFileContentTypes?: Maybe<EntityFileContentType_Mutation_Response>;
  /** delete single row from the table: "shared.entity_file_storage" */
  deleteEntityFileStorage?: Maybe<EntityFileStorage>;
  /** delete data from the table: "shared.entity_file_storage" */
  deleteEntityFileStorages?: Maybe<EntityFileStorage_Mutation_Response>;
  /** delete single row from the table: "shared.entity_note" */
  deleteEntityNote?: Maybe<EntityNote>;
  /** delete data from the table: "shared.entity_note" */
  deleteEntityNotes?: Maybe<EntityNote_Mutation_Response>;
  /** delete single row from the table: "entity_offering" */
  deleteEntityOffering?: Maybe<EntityOffering>;
  /** delete data from the table: "entity_offering" */
  deleteEntityOfferings?: Maybe<EntityOffering_Mutation_Response>;
  /** delete single row from the table: "shared.entity_remittance_detail" */
  deleteEntityRemittanceDetail?: Maybe<EntityRemittanceDetail>;
  /** delete data from the table: "shared.entity_remittance_detail" */
  deleteEntityRemittanceDetails?: Maybe<EntityRemittanceDetail_Mutation_Response>;
  /** delete single row from the table: "shared.entity_tag" */
  deleteEntityTag?: Maybe<EntityTag>;
  /** delete data from the table: "shared.entity_tag" */
  deleteEntityTags?: Maybe<EntityTag_Mutation_Response>;
  /** delete single row from the table: "shared.feature" */
  deleteFeature?: Maybe<Feature>;
  /** delete data from the table: "shared.feature" */
  deleteFeatures?: Maybe<Feature_Mutation_Response>;
  /** delete single row from the table: "shared.file_storage" */
  deleteFileStorage?: Maybe<FileStorage>;
  /** delete single row from the table: "shared.file_storage_type" */
  deleteFileStorageType?: Maybe<FileStorageType>;
  /** delete data from the table: "shared.file_storage_type" */
  deleteFileStorageTypes?: Maybe<FileStorageType_Mutation_Response>;
  /** delete data from the table: "shared.file_storage" */
  deleteFileStorages?: Maybe<FileStorage_Mutation_Response>;
  /** delete single row from the table: "compliance.filing_lender" */
  deleteFilingLender?: Maybe<FilingLender>;
  /** delete single row from the table: "compliance.filing_lender_match" */
  deleteFilingLenderMatch?: Maybe<FilingLenderMatch>;
  /** delete data from the table: "compliance.filing_lender_match" */
  deleteFilingLenderMatches?: Maybe<FilingLenderMatch_Mutation_Response>;
  /** delete data from the table: "compliance.filing_lender" */
  deleteFilingLenders?: Maybe<FilingLender_Mutation_Response>;
  /** delete single row from the table: "compliance.filing_state" */
  deleteFilingState?: Maybe<FilingState>;
  /** delete data from the table: "compliance.filing_state" */
  deleteFilingStates?: Maybe<FilingState_Mutation_Response>;
  /** delete single row from the table: "compliance.filing_status_type" */
  deleteFilingStatusType?: Maybe<FilingStatusType>;
  /** delete data from the table: "compliance.filing_status_type" */
  deleteFilingStatusTypes?: Maybe<FilingStatusType_Mutation_Response>;
  /** delete single row from the table: "auth.flow_item" */
  deleteFlowItem?: Maybe<FlowItem>;
  /** delete single row from the table: "auth.flow_item_type" */
  deleteFlowItemType?: Maybe<FlowItemType>;
  /** delete data from the table: "auth.flow_item_type" */
  deleteFlowItemTypes?: Maybe<FlowItemType_Mutation_Response>;
  /** delete data from the table: "auth.flow_item" */
  deleteFlowItems?: Maybe<FlowItem_Mutation_Response>;
  /** delete single row from the table: "auth.flow_type" */
  deleteFlowType?: Maybe<FlowType>;
  /** delete data from the table: "auth.flow_type" */
  deleteFlowTypes?: Maybe<FlowType_Mutation_Response>;
  /** delete data from the table: "ory.identity" */
  deleteIdentities?: Maybe<Identity_Mutation_Response>;
  /** delete single row from the table: "ory.identity" */
  deleteIdentity?: Maybe<Identity>;
  /** delete single row from the table: "ory.identity_as400" */
  deleteIdentityAs400?: Maybe<IdentityAs400>;
  /** delete data from the table: "ory.identity_as400" */
  deleteIdentityAs400s?: Maybe<IdentityAs400_Mutation_Response>;
  /** delete data from the table: "auth.identity_capability" */
  deleteIdentityCapabilities?: Maybe<IdentityCapability_Mutation_Response>;
  /** delete single row from the table: "auth.identity_capability" */
  deleteIdentityCapability?: Maybe<IdentityCapability>;
  /** delete data from the table: "auth.identity_entity" */
  deleteIdentityEntities?: Maybe<IdentityEntity_Mutation_Response>;
  /** delete single row from the table: "auth.identity_entity" */
  deleteIdentityEntity?: Maybe<IdentityEntity>;
  /** delete single row from the table: "auth.identity_filter" */
  deleteIdentityFilter?: Maybe<IdentityFilter>;
  /** delete data from the table: "auth.identity_filter" */
  deleteIdentityFilters?: Maybe<IdentityFilter_Mutation_Response>;
  /** delete single row from the table: "claims.invoice" */
  deleteInvoice?: Maybe<Invoice>;
  /** delete single row from the table: "claims.invoice_document_type" */
  deleteInvoiceDocumentType?: Maybe<InvoiceDocumentType>;
  /** delete data from the table: "claims.invoice_document_type" */
  deleteInvoiceDocumentTypes?: Maybe<InvoiceDocumentType_Mutation_Response>;
  /** delete single row from the table: "claims.invoice_payment_type" */
  deleteInvoicePaymentType?: Maybe<InvoicePaymentType>;
  /** delete data from the table: "claims.invoice_payment_type" */
  deleteInvoicePaymentTypes?: Maybe<InvoicePaymentType_Mutation_Response>;
  /** delete data from the table: "claims.invoice" */
  deleteInvoices?: Maybe<Invoice_Mutation_Response>;
  /** delete single row from the table: "system.job" */
  deleteJob?: Maybe<Job>;
  /** delete data from the table: "system.job_history" */
  deleteJobHistories?: Maybe<JobHistory_Mutation_Response>;
  /** delete single row from the table: "system.job_history" */
  deleteJobHistory?: Maybe<JobHistory>;
  /** delete single row from the table: "system.job_history_log" */
  deleteJobHistoryLog?: Maybe<JobHistoryLog>;
  /** delete data from the table: "system.job_history_log" */
  deleteJobHistoryLogs?: Maybe<JobHistoryLog_Mutation_Response>;
  /** delete data from the table: "system.job_schedule" */
  deleteJobSchedule?: Maybe<JobSchedule_Mutation_Response>;
  /** delete single row from the table: "system.job_schedule" */
  deleteJobSchedules?: Maybe<JobSchedule>;
  /** delete single row from the table: "system.job_step" */
  deleteJobStep?: Maybe<JobStep>;
  /** delete data from the table: "system.job_step" */
  deleteJobSteps?: Maybe<JobStep_Mutation_Response>;
  /** delete data from the table: "system.job" */
  deleteJobs?: Maybe<Job_Mutation_Response>;
  /** delete data from the table: "accounting.journal_entry" */
  deleteJournalEntries?: Maybe<JournalEntry_Mutation_Response>;
  /** delete single row from the table: "accounting.journal_entry" */
  deleteJournalEntry?: Maybe<JournalEntry>;
  /** delete single row from the table: "accounting.journal_entry_line" */
  deleteJournalEntryLine?: Maybe<JournalEntryLine>;
  /** delete data from the table: "accounting.journal_entry_line" */
  deleteJournalEntryLines?: Maybe<JournalEntryLine_Mutation_Response>;
  /** delete single row from the table: "labor_guide_type" */
  deleteLaborGuideType?: Maybe<LaborGuideType>;
  /** delete data from the table: "labor_guide_type" */
  deleteLaborGuideTypes?: Maybe<LaborGuideType_Mutation_Response>;
  /** delete single row from the table: "claims.labor_rate" */
  deleteLaborRate?: Maybe<LaborRate>;
  /** delete single row from the table: "claims.labor_rate_as400" */
  deleteLaborRateAs400?: Maybe<LaborRateAs400>;
  /** delete data from the table: "claims.labor_rate_as400" */
  deleteLaborRateAs400s?: Maybe<LaborRateAs400_Mutation_Response>;
  /** delete data from the table: "claims.labor_rate" */
  deleteLaborRates?: Maybe<LaborRate_Mutation_Response>;
  /** delete single row from the table: "operations.legacy_policy_contract" */
  deleteLegacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** delete data from the table: "operations.legacy_policy_contract" */
  deleteLegacyPolicyContracts?: Maybe<LegacyPolicyContract_Mutation_Response>;
  /** delete data from the table: "audit.logged_actions" */
  deleteLoggedActions?: Maybe<LoggedAction_Mutation_Response>;
  /** delete single row from the table: "reporting.loss_ratio" */
  deleteLossRatio?: Maybe<LossRatio>;
  /** delete data from the table: "reporting.loss_ratio" */
  deleteLossRatios?: Maybe<LossRatio_Mutation_Response>;
  /** delete single row from the table: "miles_calculation_type" */
  deleteMilesCalculationType?: Maybe<MilesCalculationType>;
  /** delete data from the table: "miles_calculation_type" */
  deleteMilesCalculationTypes?: Maybe<MilesCalculationType_Mutation_Response>;
  /** delete single row from the table: "obligor" */
  deleteObligor?: Maybe<Obligor>;
  /** delete data from the table: "obligor" */
  deleteObligors?: Maybe<Obligor_Mutation_Response>;
  /** delete single row from the table: "job" */
  deleteObsoleteJob?: Maybe<ObsoleteJob>;
  /** delete data from the table: "job" */
  deleteObsoleteJobs?: Maybe<ObsoleteJob_Mutation_Response>;
  /** delete single row from the table: "system.outbox_event" */
  deleteOutboxEvent?: Maybe<OutboxEvent>;
  /** delete data from the table: "system.outbox_event" */
  deleteOutboxEvents?: Maybe<OutboxEvent_Mutation_Response>;
  /** delete single row from the table: "shared.participant" */
  deleteParticipant?: Maybe<Participant>;
  /** delete data from the table: "shared.participant" */
  deleteParticipants?: Maybe<Participant_Mutation_Response>;
  /** delete single row from the table: "accounting.payee" */
  deletePayee?: Maybe<Payee>;
  /** delete single row from the table: "accounting.payee_as400" */
  deletePayeeAs400?: Maybe<PayeeAs400>;
  /** delete data from the table: "accounting.payee_as400" */
  deletePayeeAs400s?: Maybe<PayeeAs400_Mutation_Response>;
  /** delete data from the table: "accounting.payee" */
  deletePayees?: Maybe<Payee_Mutation_Response>;
  /** delete single row from the table: "shared.payment" */
  deletePayment?: Maybe<Payment>;
  /** delete single row from the table: "shared.payment_as400" */
  deletePaymentAs400?: Maybe<PaymentAs400>;
  /** delete data from the table: "shared.payment_as400" */
  deletePaymentAs400s?: Maybe<PaymentAs400_Mutation_Response>;
  /** delete single row from the table: "shared.payment_detail" */
  deletePaymentDetail?: Maybe<PaymentDetail>;
  /** delete data from the table: "shared.payment_detail" */
  deletePaymentDetails?: Maybe<PaymentDetail_Mutation_Response>;
  /** delete single row from the table: "shared.payment_method_type" */
  deletePaymentMethodType?: Maybe<PaymentMethodType>;
  /** delete data from the table: "shared.payment_method_type" */
  deletePaymentMethodTypes?: Maybe<PaymentMethodType_Mutation_Response>;
  /** delete single row from the table: "shared.payment_status_type" */
  deletePaymentStatusType?: Maybe<PaymentStatusType>;
  /** delete data from the table: "shared.payment_status_type" */
  deletePaymentStatusTypes?: Maybe<PaymentStatusType_Mutation_Response>;
  /** delete single row from the table: "shared.payment_type" */
  deletePaymentType?: Maybe<PaymentType>;
  /** delete data from the table: "shared.payment_type" */
  deletePaymentTypes?: Maybe<PaymentType_Mutation_Response>;
  /** delete data from the table: "shared.payment" */
  deletePayments?: Maybe<Payment_Mutation_Response>;
  /** delete single row from the table: "Plan" */
  deletePlan?: Maybe<Plan>;
  /** delete data from the table: "Plan" */
  deletePlans?: Maybe<Plan_Mutation_Response>;
  /** delete data from the table: "operations.policy" */
  deletePolicies?: Maybe<Policy_Mutation_Response>;
  /** delete single row from the table: "operations.policy" */
  deletePolicy?: Maybe<Policy>;
  /** delete single row from the table: "claims.policy_claim" */
  deletePolicyClaim?: Maybe<PolicyClaim>;
  /** delete single row from the table: "claims.policy_claim_as400" */
  deletePolicyClaimAs400?: Maybe<PolicyClaimAs400>;
  /** delete data from the table: "claims.policy_claim_as400" */
  deletePolicyClaimAs400s?: Maybe<PolicyClaimAs400_Mutation_Response>;
  /** delete single row from the table: "claims.policy_claim_concern" */
  deletePolicyClaimConcern?: Maybe<PolicyClaimConcern>;
  /** delete data from the table: "claims.policy_claim_concern" */
  deletePolicyClaimConcerns?: Maybe<PolicyClaimConcern_Mutation_Response>;
  /** delete single row from the table: "claims.policy_claim_insurance" */
  deletePolicyClaimInsurance?: Maybe<PolicyClaimInsurance>;
  /** delete data from the table: "claims.policy_claim_insurance" */
  deletePolicyClaimInsurances?: Maybe<PolicyClaimInsurance_Mutation_Response>;
  /** delete data from the table: "claims.policy_claim" */
  deletePolicyClaims?: Maybe<PolicyClaim_Mutation_Response>;
  /** delete single row from the table: "operations.policy_contract" */
  deletePolicyContract?: Maybe<PolicyContract>;
  /** delete single row from the table: "operations.policy_contract_asset" */
  deletePolicyContractAsset?: Maybe<PolicyContractAsset>;
  /** delete single row from the table: "operations.policy_contract_asset_type" */
  deletePolicyContractAssetType?: Maybe<PolicyContractAssetType>;
  /** delete data from the table: "operations.policy_contract_asset_type" */
  deletePolicyContractAssetTypes?: Maybe<PolicyContractAssetType_Mutation_Response>;
  /** delete data from the table: "operations.policy_contract_asset" */
  deletePolicyContractAssets?: Maybe<PolicyContractAsset_Mutation_Response>;
  /** delete single row from the table: "operations.policy_contract_contract_form_version" */
  deletePolicyContractContractFormVersion?: Maybe<PolicyContractContractFormVersion>;
  /** delete data from the table: "operations.policy_contract_contract_form_version" */
  deletePolicyContractContractFormVersions?: Maybe<PolicyContractContractFormVersion_Mutation_Response>;
  /** delete single row from the table: "operations.policy_contract_cost_detail" */
  deletePolicyContractCostDetail?: Maybe<PolicyContractCostDetail>;
  /** delete data from the table: "operations.policy_contract_cost_detail" */
  deletePolicyContractCostDetails?: Maybe<PolicyContractCostDetail_Mutation_Response>;
  /** delete single row from the table: "operations.policy_contract_lender" */
  deletePolicyContractLender?: Maybe<PolicyContractLender>;
  /** delete data from the table: "operations.policy_contract_lender" */
  deletePolicyContractLenders?: Maybe<PolicyContractLender_Mutation_Response>;
  /** delete single row from the table: "operations.policy_contract_loan_contract_type" */
  deletePolicyContractLoanContractType?: Maybe<PolicyContractLoanContractType>;
  /** delete data from the table: "operations.policy_contract_loan_contract_type" */
  deletePolicyContractLoanContractTypes?: Maybe<PolicyContractLoanContractType_Mutation_Response>;
  /** delete single row from the table: "operations.policy_contract_owner" */
  deletePolicyContractOwner?: Maybe<PolicyContractOwner>;
  /** delete data from the table: "operations.policy_contract_owner" */
  deletePolicyContractOwners?: Maybe<PolicyContractOwner_Mutation_Response>;
  /** delete single row from the table: "operations.policy_contract_product" */
  deletePolicyContractProduct?: Maybe<PolicyContractProduct>;
  /** delete single row from the table: "operations.policy_contract_product_cost_detail" */
  deletePolicyContractProductCostDetail?: Maybe<PolicyContractProductCostDetail>;
  /** delete data from the table: "operations.policy_contract_product_cost_detail" */
  deletePolicyContractProductCostDetails?: Maybe<PolicyContractProductCostDetail_Mutation_Response>;
  /** delete data from the table: "operations.policy_contract_product" */
  deletePolicyContractProducts?: Maybe<PolicyContractProduct_Mutation_Response>;
  /** delete single row from the table: "operations.policy_contract_quote" */
  deletePolicyContractQuote?: Maybe<PolicyContractQuote>;
  /** delete data from the table: "operations.policy_contract_quote" */
  deletePolicyContractQuotes?: Maybe<PolicyContractQuote_Mutation_Response>;
  /** delete single row from the table: "operations.policy_contract_status_type" */
  deletePolicyContractStatusType?: Maybe<PolicyContractStatusType>;
  /** delete data from the table: "operations.policy_contract_status_type" */
  deletePolicyContractStatusTypes?: Maybe<PolicyContractStatusType_Mutation_Response>;
  /** delete single row from the table: "operations.policy_contract_void_reason_type" */
  deletePolicyContractVoidReasonType?: Maybe<PolicyContractVoidReasonType>;
  /** delete data from the table: "operations.policy_contract_void_reason_type" */
  deletePolicyContractVoidReasonTypes?: Maybe<PolicyContractVoidReasonType_Mutation_Response>;
  /** delete data from the table: "operations.policy_contract" */
  deletePolicyContracts?: Maybe<PolicyContract_Mutation_Response>;
  /** delete single row from the table: "claims.pre_authorization" */
  deletePreAuthorization?: Maybe<PreAuthorization>;
  /** delete single row from the table: "claims.pre_authorization_status_type" */
  deletePreAuthorizationStatusType?: Maybe<PreAuthorizationStatusType>;
  /** delete data from the table: "claims.pre_authorization_status_type" */
  deletePreAuthorizationStatusTypes?: Maybe<PreAuthorizationStatusType_Mutation_Response>;
  /** delete single row from the table: "claims.pre_authorization_type" */
  deletePreAuthorizationType?: Maybe<PreAuthorizationType>;
  /** delete data from the table: "claims.pre_authorization_type" */
  deletePreAuthorizationTypes?: Maybe<PreAuthorizationType_Mutation_Response>;
  /** delete data from the table: "claims.pre_authorization" */
  deletePreAuthorizations?: Maybe<PreAuthorization_Mutation_Response>;
  /** delete single row from the table: "product" */
  deleteProduct?: Maybe<Product>;
  /** delete single row from the table: "product_attribute" */
  deleteProductAttribute?: Maybe<ProductAttribute>;
  /** delete single row from the table: "product_attribute_type" */
  deleteProductAttributeType?: Maybe<ProductAttributeType>;
  /** delete data from the table: "product_attribute_type" */
  deleteProductAttributeTypes?: Maybe<ProductAttributeType_Mutation_Response>;
  /** delete data from the table: "product_attribute" */
  deleteProductAttributes?: Maybe<ProductAttribute_Mutation_Response>;
  /** delete single row from the table: "product_class_guide" */
  deleteProductClassGuide?: Maybe<ProductClassGuide>;
  /** delete data from the table: "product_class_guide" */
  deleteProductClassGuides?: Maybe<ProductClassGuide_Mutation_Response>;
  /** delete single row from the table: "compliance.product_contract_form" */
  deleteProductContractForm?: Maybe<ProductContractForm>;
  /** delete data from the table: "compliance.product_contract_form" */
  deleteProductContractForms?: Maybe<ProductContractForm_Mutation_Response>;
  /** delete single row from the table: "product_cost" */
  deleteProductCost?: Maybe<ProductCost>;
  /** delete data from the table: "product_cost" */
  deleteProductCosts?: Maybe<ProductCost_Mutation_Response>;
  /** delete single row from the table: "product_disbursement" */
  deleteProductDisbursement?: Maybe<ProductDisbursement>;
  /** delete data from the table: "product_disbursement" */
  deleteProductDisbursements?: Maybe<ProductDisbursement_Mutation_Response>;
  /** delete data from the table: "product_eligibility_rule" */
  deleteProductEligibilities?: Maybe<ProductEligibility_Mutation_Response>;
  /** delete single row from the table: "product_eligibility_rule" */
  deleteProductEligibility?: Maybe<ProductEligibility>;
  /** delete single row from the table: "product_obligor" */
  deleteProductObligor?: Maybe<ProductObligor>;
  /** delete data from the table: "product_obligor" */
  deleteProductObligors?: Maybe<ProductObligor_Mutation_Response>;
  /** delete single row from the table: "product_rate_bucket" */
  deleteProductRateBucket?: Maybe<ProductRateBucket>;
  /** delete data from the table: "product_rate_bucket" */
  deleteProductRateBuckets?: Maybe<ProductRateBucket_Mutation_Response>;
  /** delete single row from the table: "product_surcharge_type" */
  deleteProductSurchargeType?: Maybe<ProductSurchargeType>;
  /** delete data from the table: "product_surcharge_type" */
  deleteProductSurchargeTypes?: Maybe<ProductSurchargeType_Mutation_Response>;
  /** delete data from the table: "product" */
  deleteProducts?: Maybe<Product_Mutation_Response>;
  /** delete single row from the table: "users.profile" */
  deleteProfile?: Maybe<Profile>;
  /** delete data from the table: "users.profile" */
  deleteProfiles?: Maybe<Profile_Mutation_Response>;
  /** delete single row from the table: "quotes.quote" */
  deleteQuote?: Maybe<Quote>;
  /** delete data from the table: "quotes.quote_minimal_view" */
  deleteQuoteMinimalViews?: Maybe<QuoteMinimalView_Mutation_Response>;
  /** delete single row from the table: "quotes.quote_type" */
  deleteQuoteType?: Maybe<QuoteType>;
  /** delete data from the table: "quotes.quote_type" */
  deleteQuoteTypes?: Maybe<QuoteType_Mutation_Response>;
  /** delete data from the table: "quotes.quote" */
  deleteQuotes?: Maybe<Quote_Mutation_Response>;
  /** delete single row from the table: "rate_bucket_type" */
  deleteRateBucketType?: Maybe<RateBucketType>;
  /** delete data from the table: "rate_bucket_type" */
  deleteRateBucketTypes?: Maybe<RateBucketType_Mutation_Response>;
  /** delete single row from the table: "rate_quote" */
  deleteRateQuote?: Maybe<RateQuote>;
  /** delete data from the table: "rate_quote" */
  deleteRateQuotes?: Maybe<RateQuote_Mutation_Response>;
  /** delete single row from the table: "ui.rater_view_config" */
  deleteRaterViewConfig?: Maybe<RaterViewConfig>;
  /** delete data from the table: "ui.rater_view_config" */
  deleteRaterViewConfigs?: Maybe<RaterViewConfig_Mutation_Response>;
  /** delete single row from the table: "system.reference_log" */
  deleteReferenceLog?: Maybe<ReferenceLog>;
  /** delete data from the table: "system.reference_log" */
  deleteReferenceLogs?: Maybe<ReferenceLog_Mutation_Response>;
  /** delete single row from the table: "operations.remittance" */
  deleteRemittance?: Maybe<Remittance>;
  /** delete single row from the table: "claims.remittance_claim_detail" */
  deleteRemittanceClaimDetail?: Maybe<RemittanceClaimDetail>;
  /** delete data from the table: "claims.remittance_claim_detail" */
  deleteRemittanceClaimDetails?: Maybe<RemittanceClaimDetail_Mutation_Response>;
  /** delete single row from the table: "operations.remittance_payment" */
  deleteRemittancePayment?: Maybe<RemittancePayment>;
  /** delete data from the table: "operations.remittance_payment" */
  deleteRemittancePayments?: Maybe<RemittancePayment_Mutation_Response>;
  /** delete single row from the table: "operations.remittance_policy_contract" */
  deleteRemittancePolicyContract?: Maybe<RemittancePolicyContract>;
  /** delete single row from the table: "operations.remittance_policy_contract_as400" */
  deleteRemittancePolicyContractAs400?: Maybe<RemittancePolicyContractAs400>;
  /** delete data from the table: "operations.remittance_policy_contract_as400" */
  deleteRemittancePolicyContractAs400s?: Maybe<RemittancePolicyContractAs400_Mutation_Response>;
  /** delete data from the table: "operations.remittance_policy_contract" */
  deleteRemittancePolicyContracts?: Maybe<RemittancePolicyContract_Mutation_Response>;
  /** delete single row from the table: "operations.remittance_status_type" */
  deleteRemittanceStatusType?: Maybe<RemittanceStatusType>;
  /** delete data from the table: "operations.remittance_status_type" */
  deleteRemittanceStatusTypes?: Maybe<RemittanceStatusType_Mutation_Response>;
  /** delete single row from the table: "operations.remittance_type" */
  deleteRemittanceType?: Maybe<RemittanceType>;
  /** delete data from the table: "operations.remittance_type" */
  deleteRemittanceTypes?: Maybe<RemittanceType_Mutation_Response>;
  /** delete data from the table: "operations.remittance" */
  deleteRemittances?: Maybe<Remittance_Mutation_Response>;
  /** delete single row from the table: "claims.repeat_part_acknowledgment" */
  deleteRepeatPartAcknowledgment?: Maybe<RepeatPartAcknowledgment>;
  /** delete data from the table: "claims.repeat_part_acknowledgment" */
  deleteRepeatPartAcknowledgments?: Maybe<RepeatPartAcknowledgment_Mutation_Response>;
  /** delete data from the table: "auth.role" */
  deleteRole?: Maybe<Role_Mutation_Response>;
  /** delete single row from the table: "auth.role_attribute" */
  deleteRoleAttribute?: Maybe<RoleAttribute>;
  /** delete data from the table: "auth.role_attribute" */
  deleteRoleAttributes?: Maybe<RoleAttribute_Mutation_Response>;
  /** update multiples rows of table: "auth.role" */
  deleteRoles?: Maybe<Array<Maybe<Role_Mutation_Response>>>;
  /** delete single row from the table: "auth.route" */
  deleteRoute?: Maybe<Route>;
  /** delete single row from the table: "auth.route_config" */
  deleteRouteConfig?: Maybe<RouteConfig>;
  /** delete data from the table: "auth.route_config" */
  deleteRouteConfigs?: Maybe<RouteConfig_Mutation_Response>;
  /** delete data from the table: "auth.route" */
  deleteRoutes?: Maybe<Route_Mutation_Response>;
  /** delete single row from the table: "shared.search_index" */
  deleteSearchIndex?: Maybe<SearchIndex>;
  /** delete data from the table: "shared.search_index" */
  deleteSearchIndexes?: Maybe<SearchIndex_Mutation_Response>;
  /** delete single row from the table: "state" */
  deleteSelectState?: Maybe<State>;
  /** delete data from the table: "state" */
  deleteSelectStates?: Maybe<State_Mutation_Response>;
  /** delete single row from the table: "claims.service_center" */
  deleteServiceCenter?: Maybe<ServiceCenter>;
  /** delete data from the table: "claims.service_center" */
  deleteServiceCenters?: Maybe<ServiceCenter_Mutation_Response>;
  /** delete single row from the table: "system.severity_level_type" */
  deleteSeverityLevelType?: Maybe<SeverityLevelType>;
  /** delete data from the table: "system.severity_level_type" */
  deleteSeverityLevelTypes?: Maybe<SeverityLevelType_Mutation_Response>;
  /** delete single row from the table: "users.shortcut_binding" */
  deleteShortcutBinding?: Maybe<ShortcutBinding>;
  /** delete data from the table: "users.shortcut_binding" */
  deleteShortcutBindings?: Maybe<ShortcutBinding_Mutation_Response>;
  /** delete single row from the table: "system.step" */
  deleteStep?: Maybe<Step>;
  /** delete single row from the table: "system.step_type" */
  deleteStepType?: Maybe<StepType>;
  /** delete data from the table: "system.step_type" */
  deleteStepTypes?: Maybe<StepType_Mutation_Response>;
  /** delete data from the table: "system.step" */
  deleteSteps?: Maybe<Step_Mutation_Response>;
  /** delete single row from the table: "surcharge_type" */
  deleteSurchargeType?: Maybe<SurchargeType>;
  /** delete data from the table: "surcharge_type" */
  deleteSurchargeTypes?: Maybe<SurchargeType_Mutation_Response>;
  /** delete single row from the table: "shared.tag" */
  deleteTag?: Maybe<Tag>;
  /** delete data from the table: "shared.tag" */
  deleteTags?: Maybe<Tag_Mutation_Response>;
  /** delete single row from the table: "task" */
  deleteTask?: Maybe<Task>;
  /** delete data from the table: "task" */
  deleteTasks?: Maybe<Task_Mutation_Response>;
  /** delete single row from the table: "claims.tax_rate" */
  deleteTaxRate?: Maybe<TaxRate>;
  /** delete single row from the table: "claims.tax_rate_as400" */
  deleteTaxRateAs400?: Maybe<TaxRateAs400>;
  /** delete data from the table: "claims.tax_rate_as400" */
  deleteTaxRateAs400s?: Maybe<TaxRateAs400_Mutation_Response>;
  /** delete data from the table: "claims.tax_rate" */
  deleteTaxRates?: Maybe<TaxRate_Mutation_Response>;
  /** delete single row from the table: "system.technology_type" */
  deleteTechnologyType?: Maybe<TechnologyType>;
  /** delete data from the table: "system.technology_type" */
  deleteTechnologyTypes?: Maybe<TechnologyType_Mutation_Response>;
  /** delete single row from the table: "shared.type" */
  deleteType?: Maybe<Type>;
  /** delete single row from the table: "shared.type_group" */
  deleteTypeGroup?: Maybe<TypeGroup>;
  /** delete data from the table: "shared.type_group" */
  deleteTypeGroups?: Maybe<TypeGroup_Mutation_Response>;
  /** delete data from the table: "shared.type" */
  deleteTypes?: Maybe<Type_Mutation_Response>;
  /** delete single row from the table: "auth.user" */
  deleteUser?: Maybe<User>;
  /** delete single row from the table: "auth.user_flow_item" */
  deleteUserFlowItem?: Maybe<UserFlowItem>;
  /** delete single row from the table: "auth.user_flow_item_mfa" */
  deleteUserFlowItemMfa?: Maybe<UserFlowItemMfa>;
  /** delete data from the table: "auth.user_flow_item_mfa" */
  deleteUserFlowItemMfas?: Maybe<UserFlowItemMfa_Mutation_Response>;
  /** delete data from the table: "auth.user_flow_item" */
  deleteUserFlowItems?: Maybe<UserFlowItem_Mutation_Response>;
  /** delete single row from the table: "auth.user_group" */
  deleteUserGroup?: Maybe<UserGroup>;
  /** delete data from the table: "auth.user_group" */
  deleteUserGroups?: Maybe<UserGroup_Mutation_Response>;
  /** delete single row from the table: "user_pin" */
  deleteUserPin?: Maybe<UserPin>;
  /** delete data from the table: "user_pin" */
  deleteUserPins?: Maybe<UserPin_Mutation_Response>;
  /** delete single row from the table: "auth.user_profile" */
  deleteUserProfile?: Maybe<UserProfile>;
  /** delete data from the table: "auth.user_profile" */
  deleteUserProfiles?: Maybe<UserProfile_Mutation_Response>;
  /** delete single row from the table: "auth.user_session" */
  deleteUserSession?: Maybe<UserSession>;
  /** delete data from the table: "auth.user_session" */
  deleteUserSessions?: Maybe<UserSession_Mutation_Response>;
  /** delete data from the table: "auth.user" */
  deleteUsers?: Maybe<User_Mutation_Response>;
  /** delete single row from the table: "shared.validation" */
  deleteValidation?: Maybe<Validation>;
  /** delete single row from the table: "shared.validation_lifecycle_hook" */
  deleteValidationLifecycleHook?: Maybe<ValidationLifecycleHook>;
  /** delete data from the table: "shared.validation_lifecycle_hook" */
  deleteValidationLifecycleHooks?: Maybe<ValidationLifecycleHook_Mutation_Response>;
  /** delete single row from the table: "shared.validation_override" */
  deleteValidationOverride?: Maybe<ValidationOverride>;
  /** delete data from the table: "shared.validation_override" */
  deleteValidationOverrides?: Maybe<ValidationOverride_Mutation_Response>;
  /** delete single row from the table: "shared.validation_rule_for" */
  deleteValidationRuleFor?: Maybe<ValidationRuleFor>;
  /** delete data from the table: "shared.validation_rule_for" */
  deleteValidationRuleFors?: Maybe<ValidationRuleFor_Mutation_Response>;
  /** delete single row from the table: "shared.validation_type_operation" */
  deleteValidationTypeOperation?: Maybe<ValidationTypeOperation>;
  /** delete data from the table: "shared.validation_type_operation" */
  deleteValidationTypeOperations?: Maybe<ValidationTypeOperation_Mutation_Response>;
  /** delete single row from the table: "shared.validation_when" */
  deleteValidationWhen?: Maybe<ValidationWhen>;
  /** delete data from the table: "shared.validation_when" */
  deleteValidationWhens?: Maybe<ValidationWhen_Mutation_Response>;
  /** delete data from the table: "shared.validation" */
  deleteValidations?: Maybe<Validation_Mutation_Response>;
  /** delete single row from the table: "vehicle" */
  deleteVehicle?: Maybe<Vehicle>;
  /** delete single row from the table: "vehicle.vehicle_status_type" */
  deleteVehicleStatusType?: Maybe<VehicleStatusType>;
  /** delete data from the table: "vehicle.vehicle_status_type" */
  deleteVehicleStatusTypes?: Maybe<VehicleStatusType_Mutation_Response>;
  /** delete data from the table: "vehicle" */
  deleteVehicles?: Maybe<Vehicle_Mutation_Response>;
  /** delete single row from the table: "vehicle.vpic_decode_alternative" */
  deleteVpicDecodeAlternative?: Maybe<VpicDecodeAlternative>;
  /** delete data from the table: "vehicle.vpic_decode_alternative" */
  deleteVpicDecodeAlternatives?: Maybe<VpicDecodeAlternative_Mutation_Response>;
  /** delete single row from the table: "work_status_type" */
  deleteWorkStatusType?: Maybe<WorkStatusType>;
  /** delete data from the table: "work_status_type" */
  deleteWorkStatusTypes?: Maybe<WorkStatusType_Mutation_Response>;
  /** delete single row from the table: "claims.workflow_state_type" */
  deleteWorkflowStateType?: Maybe<WorkflowStateType>;
  /** delete data from the table: "claims.workflow_state_type" */
  deleteWorkflowStateTypes?: Maybe<WorkflowStateType_Mutation_Response>;
  /** delete data from the table: "vpic.abs" */
  delete_ABS?: Maybe<Abs_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.abs" */
  delete_ABS_by_pk?: Maybe<Abs_Vpic>;
  /** delete data from the table: "vpic.adaptivecruisecontrol" */
  delete_AdaptiveCruiseControl?: Maybe<AdaptiveCruiseControl_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.adaptivecruisecontrol" */
  delete_AdaptiveCruiseControl_by_pk?: Maybe<AdaptiveCruiseControl_Vpic>;
  /** delete data from the table: "vpic.adaptivedrivingbeam" */
  delete_AdaptiveDrivingBeam?: Maybe<AdaptiveDrivingBeam_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.adaptivedrivingbeam" */
  delete_AdaptiveDrivingBeam_by_pk?: Maybe<AdaptiveDrivingBeam_Vpic>;
  /** delete data from the table: "vpic.airbaglocfront" */
  delete_AirBagLocFront?: Maybe<AirBagLocFront_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.airbaglocfront" */
  delete_AirBagLocFront_by_pk?: Maybe<AirBagLocFront_Vpic>;
  /** delete data from the table: "vpic.airbaglocknee" */
  delete_AirBagLocKnee?: Maybe<AirBagLocKnee_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.airbaglocknee" */
  delete_AirBagLocKnee_by_pk?: Maybe<AirBagLocKnee_Vpic>;
  /** delete data from the table: "vpic.airbaglocations" */
  delete_AirBagLocations?: Maybe<AirBagLocations_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.airbaglocations" */
  delete_AirBagLocations_by_pk?: Maybe<AirBagLocations_Vpic>;
  /** delete data from the table: "vpic.autobrake" */
  delete_AutoBrake?: Maybe<AutoBrake_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.autobrake" */
  delete_AutoBrake_by_pk?: Maybe<AutoBrake_Vpic>;
  /** delete data from the table: "vpic.autoreversesystem" */
  delete_AutoReverseSystem?: Maybe<AutoReverseSystem_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.autoreversesystem" */
  delete_AutoReverseSystem_by_pk?: Maybe<AutoReverseSystem_Vpic>;
  /** delete data from the table: "vpic.automaticpedestrainalertingsound" */
  delete_AutomaticPedestrainAlertingSound?: Maybe<AutomaticPedestrainAlertingSound_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.automaticpedestrainalertingsound" */
  delete_AutomaticPedestrainAlertingSound_by_pk?: Maybe<AutomaticPedestrainAlertingSound_Vpic>;
  /** delete data from the table: "vpic.axleconfiguration" */
  delete_AxleConfiguration?: Maybe<AxleConfiguration_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.axleconfiguration" */
  delete_AxleConfiguration_by_pk?: Maybe<AxleConfiguration_Vpic>;
  /** delete data from the table: "vpic.batterytype" */
  delete_BatteryType?: Maybe<BatteryType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.batterytype" */
  delete_BatteryType_by_pk?: Maybe<BatteryType_Vpic>;
  /** delete data from the table: "vpic.bedtype" */
  delete_BedType?: Maybe<BedType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.bedtype" */
  delete_BedType_by_pk?: Maybe<BedType_Vpic>;
  /** delete data from the table: "vpic.blindspotintervention" */
  delete_BlindSpotIntervention?: Maybe<BlindSpotIntervention_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.blindspotintervention" */
  delete_BlindSpotIntervention_by_pk?: Maybe<BlindSpotIntervention_Vpic>;
  /** delete data from the table: "vpic.blindspotmonitoring" */
  delete_BlindSpotMonitoring?: Maybe<BlindSpotMonitoring_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.blindspotmonitoring" */
  delete_BlindSpotMonitoring_by_pk?: Maybe<BlindSpotMonitoring_Vpic>;
  /** delete data from the table: "vpic.bodycab" */
  delete_BodyCab?: Maybe<BodyCab_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.bodycab" */
  delete_BodyCab_by_pk?: Maybe<BodyCab_Vpic>;
  /** delete data from the table: "vpic.bodystyle" */
  delete_BodyStyle?: Maybe<BodyStyle_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.bodystyle" */
  delete_BodyStyle_by_pk?: Maybe<BodyStyle_Vpic>;
  /** delete data from the table: "vpic.brakesystem" */
  delete_BrakeSystem?: Maybe<BrakeSystem_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.brakesystem" */
  delete_BrakeSystem_by_pk?: Maybe<BrakeSystem_Vpic>;
  /** delete data from the table: "vpic.busfloorconfigtype" */
  delete_BusFloorConfigType?: Maybe<BusFloorConfigType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.busfloorconfigtype" */
  delete_BusFloorConfigType_by_pk?: Maybe<BusFloorConfigType_Vpic>;
  /** delete data from the table: "vpic.bustype" */
  delete_BusType?: Maybe<BusType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.bustype" */
  delete_BusType_by_pk?: Maybe<BusType_Vpic>;
  /** delete data from the table: "vpic.can_aacn" */
  delete_CAN_AACN?: Maybe<Can_Aacn_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.can_aacn" */
  delete_CAN_AACN_by_pk?: Maybe<Can_Aacn_Vpic>;
  /** delete data from the table: "vpic.chargerlevel" */
  delete_ChargerLevel?: Maybe<ChargerLevel_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.chargerlevel" */
  delete_ChargerLevel_by_pk?: Maybe<ChargerLevel_Vpic>;
  /** delete data from the table: "vpic.combinedbrakingsystem" */
  delete_CombinedBrakingSystem?: Maybe<CombinedBrakingSystem_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.combinedbrakingsystem" */
  delete_CombinedBrakingSystem_by_pk?: Maybe<CombinedBrakingSystem_Vpic>;
  /** delete data from the table: "ContractMasterSurcharge" */
  delete_ContractMasterSurcharge?: Maybe<ContractMasterSurcharge_Mutation_Response>;
  /** delete data from the table: "vpic.conversion" */
  delete_Conversion?: Maybe<Conversion_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.conversion" */
  delete_Conversion_by_pk?: Maybe<Conversion_Vpic>;
  /** delete data from the table: "vpic.coolingtype" */
  delete_CoolingType?: Maybe<CoolingType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.coolingtype" */
  delete_CoolingType_by_pk?: Maybe<CoolingType_Vpic>;
  /** delete data from the table: "vpic.country" */
  delete_Country?: Maybe<Country_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.country" */
  delete_Country_by_pk?: Maybe<Country_Vpic>;
  /** delete data from the table: "vpic.custommotorcycletype" */
  delete_CustomMotorcycleType?: Maybe<CustomMotorcycleType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.custommotorcycletype" */
  delete_CustomMotorcycleType_by_pk?: Maybe<CustomMotorcycleType_Vpic>;
  /** delete data from the table: "vpic.daytimerunninglight" */
  delete_DaytimeRunningLight?: Maybe<DaytimeRunningLight_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.daytimerunninglight" */
  delete_DaytimeRunningLight_by_pk?: Maybe<DaytimeRunningLight_Vpic>;
  /** delete data from the table: "vpic.defaultvalue" */
  delete_DefaultValue?: Maybe<DefaultValue_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.defaultvalue" */
  delete_DefaultValue_by_pk?: Maybe<DefaultValue_Vpic>;
  /** delete data from the table: "vpic.destinationmarket" */
  delete_DestinationMarket?: Maybe<DestinationMarket_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.destinationmarket" */
  delete_DestinationMarket_by_pk?: Maybe<DestinationMarket_Vpic>;
  /** delete data from the table: "vpic.drivetype" */
  delete_DriveType?: Maybe<DriveType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.drivetype" */
  delete_DriveType_by_pk?: Maybe<DriveType_Vpic>;
  /** delete data from the table: "vpic.dynamicbrakesupport" */
  delete_DynamicBrakeSupport?: Maybe<DynamicBrakeSupport_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.dynamicbrakesupport" */
  delete_DynamicBrakeSupport_by_pk?: Maybe<DynamicBrakeSupport_Vpic>;
  /** delete data from the table: "vpic.ecs" */
  delete_ECS?: Maybe<Ecs_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.ecs" */
  delete_ECS_by_pk?: Maybe<Ecs_Vpic>;
  /** delete data from the table: "vpic.edr" */
  delete_EDR?: Maybe<Edr_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.edr" */
  delete_EDR_by_pk?: Maybe<Edr_Vpic>;
  /** delete data from the table: "vpic.evdriveunit" */
  delete_EVDriveUnit?: Maybe<EvDriveUnit_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.evdriveunit" */
  delete_EVDriveUnit_by_pk?: Maybe<EvDriveUnit_Vpic>;
  /** delete data from the table: "vpic.electrificationlevel" */
  delete_ElectrificationLevel?: Maybe<ElectrificationLevel_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.electrificationlevel" */
  delete_ElectrificationLevel_by_pk?: Maybe<ElectrificationLevel_Vpic>;
  /** delete data from the table: "vpic.element" */
  delete_Element?: Maybe<Element_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.element" */
  delete_Element_by_pk?: Maybe<Element_Vpic>;
  /** delete data from the table: "vpic.engineconfiguration" */
  delete_EngineConfiguration?: Maybe<EngineConfiguration_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.engineconfiguration" */
  delete_EngineConfiguration_by_pk?: Maybe<EngineConfiguration_Vpic>;
  /** delete data from the table: "vpic.enginemodel" */
  delete_EngineModel?: Maybe<EngineModel_Mutation_Response_Vpic>;
  /** delete data from the table: "vpic.enginemodelpattern" */
  delete_EngineModelPattern?: Maybe<EngineModelPattern_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.enginemodelpattern" */
  delete_EngineModelPattern_by_pk?: Maybe<EngineModelPattern_Vpic>;
  /** delete single row from the table: "vpic.enginemodel" */
  delete_EngineModel_by_pk?: Maybe<EngineModel_Vpic>;
  /** delete data from the table: "vpic.entertainmentsystem" */
  delete_EntertainmentSystem?: Maybe<EntertainmentSystem_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.entertainmentsystem" */
  delete_EntertainmentSystem_by_pk?: Maybe<EntertainmentSystem_Vpic>;
  /** delete data from the table: "vpic.errorcode" */
  delete_ErrorCode?: Maybe<ErrorCode_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.errorcode" */
  delete_ErrorCode_by_pk?: Maybe<ErrorCode_Vpic>;
  /** delete data from the table: "vpic.forwardcollisionwarning" */
  delete_ForwardCollisionWarning?: Maybe<ForwardCollisionWarning_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.forwardcollisionwarning" */
  delete_ForwardCollisionWarning_by_pk?: Maybe<ForwardCollisionWarning_Vpic>;
  /** delete data from the table: "vpic.fueldeliverytype" */
  delete_FuelDeliveryType?: Maybe<FuelDeliveryType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.fueldeliverytype" */
  delete_FuelDeliveryType_by_pk?: Maybe<FuelDeliveryType_Vpic>;
  /** delete data from the table: "vpic.fueltankmaterial" */
  delete_FuelTankMaterial?: Maybe<FuelTankMaterial_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.fueltankmaterial" */
  delete_FuelTankMaterial_by_pk?: Maybe<FuelTankMaterial_Vpic>;
  /** delete data from the table: "vpic.fueltanktype" */
  delete_FuelTankType?: Maybe<FuelTankType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.fueltanktype" */
  delete_FuelTankType_by_pk?: Maybe<FuelTankType_Vpic>;
  /** delete data from the table: "vpic.fueltype" */
  delete_FuelType?: Maybe<FuelType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.fueltype" */
  delete_FuelType_by_pk?: Maybe<FuelType_Vpic>;
  /** delete data from the table: "vpic.grossvehicleweightrating" */
  delete_GrossVehicleWeightRating?: Maybe<GrossVehicleWeightRating_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.grossvehicleweightrating" */
  delete_GrossVehicleWeightRating_by_pk?: Maybe<GrossVehicleWeightRating_Vpic>;
  /** delete data from the table: "vpic.keylessignition" */
  delete_KeylessIgnition?: Maybe<KeylessIgnition_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.keylessignition" */
  delete_KeylessIgnition_by_pk?: Maybe<KeylessIgnition_Vpic>;
  /** delete data from the table: "vpic.lanecenteringassistance" */
  delete_LaneCenteringAssistance?: Maybe<LaneCenteringAssistance_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.lanecenteringassistance" */
  delete_LaneCenteringAssistance_by_pk?: Maybe<LaneCenteringAssistance_Vpic>;
  /** delete data from the table: "vpic.lanedeparturewarning" */
  delete_LaneDepartureWarning?: Maybe<LaneDepartureWarning_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.lanedeparturewarning" */
  delete_LaneDepartureWarning_by_pk?: Maybe<LaneDepartureWarning_Vpic>;
  /** delete data from the table: "vpic.lanekeepsystem" */
  delete_LaneKeepSystem?: Maybe<LaneKeepSystem_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.lanekeepsystem" */
  delete_LaneKeepSystem_by_pk?: Maybe<LaneKeepSystem_Vpic>;
  /** delete data from the table: "vpic.lowerbeamheadlamplightsource" */
  delete_LowerBeamHeadlampLightSource?: Maybe<LowerBeamHeadlampLightSource_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.lowerbeamheadlamplightsource" */
  delete_LowerBeamHeadlampLightSource_by_pk?: Maybe<LowerBeamHeadlampLightSource_Vpic>;
  /** delete data from the table: "vpic.make" */
  delete_Make?: Maybe<Make_Mutation_Response_Vpic>;
  /** delete data from the table: "vpic.make_model" */
  delete_Make_Model?: Maybe<Make_Model_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.make_model" */
  delete_Make_Model_by_pk?: Maybe<Make_Model_Vpic>;
  /** delete single row from the table: "vpic.make" */
  delete_Make_by_pk?: Maybe<Make_Vpic>;
  /** delete data from the table: "vpic.manufacturer" */
  delete_Manufacturer?: Maybe<Manufacturer_Mutation_Response_Vpic>;
  /** delete data from the table: "vpic.manufacturer_make" */
  delete_Manufacturer_Make?: Maybe<Manufacturer_Make_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.manufacturer_make" */
  delete_Manufacturer_Make_by_pk?: Maybe<Manufacturer_Make_Vpic>;
  /** delete single row from the table: "vpic.manufacturer" */
  delete_Manufacturer_by_pk?: Maybe<Manufacturer_Vpic>;
  /** delete data from the table: "vpic.model" */
  delete_Model?: Maybe<Model_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.model" */
  delete_Model_by_pk?: Maybe<Model_Vpic>;
  /** delete data from the table: "vpic.motorcyclechassistype" */
  delete_MotorcycleChassisType?: Maybe<MotorcycleChassisType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.motorcyclechassistype" */
  delete_MotorcycleChassisType_by_pk?: Maybe<MotorcycleChassisType_Vpic>;
  /** delete data from the table: "vpic.motorcyclesuspensiontype" */
  delete_MotorcycleSuspensionType?: Maybe<MotorcycleSuspensionType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.motorcyclesuspensiontype" */
  delete_MotorcycleSuspensionType_by_pk?: Maybe<MotorcycleSuspensionType_Vpic>;
  /** delete data from the table: "vpic.nonlanduse" */
  delete_NonLandUse?: Maybe<NonLandUse_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.nonlanduse" */
  delete_NonLandUse_by_pk?: Maybe<NonLandUse_Vpic>;
  /** delete data from the table: "vpic.parkassist" */
  delete_ParkAssist?: Maybe<ParkAssist_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.parkassist" */
  delete_ParkAssist_by_pk?: Maybe<ParkAssist_Vpic>;
  /** delete data from the table: "vpic.pattern" */
  delete_Pattern?: Maybe<Pattern_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.pattern" */
  delete_Pattern_by_pk?: Maybe<Pattern_Vpic>;
  /** delete data from the table: "vpic.pedestrianautomaticemergencybraking" */
  delete_PedestrianAutomaticEmergencyBraking?: Maybe<PedestrianAutomaticEmergencyBraking_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.pedestrianautomaticemergencybraking" */
  delete_PedestrianAutomaticEmergencyBraking_by_pk?: Maybe<PedestrianAutomaticEmergencyBraking_Vpic>;
  /** delete data from the table: "vpic.pretensioner" */
  delete_Pretensioner?: Maybe<Pretensioner_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.pretensioner" */
  delete_Pretensioner_by_pk?: Maybe<Pretensioner_Vpic>;
  /** delete data from the table: "vpic.rearautomaticemergencybraking" */
  delete_RearAutomaticEmergencyBraking?: Maybe<RearAutomaticEmergencyBraking_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.rearautomaticemergencybraking" */
  delete_RearAutomaticEmergencyBraking_by_pk?: Maybe<RearAutomaticEmergencyBraking_Vpic>;
  /** delete data from the table: "vpic.rearcrosstrafficalert" */
  delete_RearCrossTrafficAlert?: Maybe<RearCrossTrafficAlert_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.rearcrosstrafficalert" */
  delete_RearCrossTrafficAlert_by_pk?: Maybe<RearCrossTrafficAlert_Vpic>;
  /** delete data from the table: "vpic.rearvisibilitycamera" */
  delete_RearVisibilityCamera?: Maybe<RearVisibilityCamera_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.rearvisibilitycamera" */
  delete_RearVisibilityCamera_by_pk?: Maybe<RearVisibilityCamera_Vpic>;
  /** delete data from the table: "vpic.seatbeltsall" */
  delete_SeatBeltsAll?: Maybe<SeatBeltsAll_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.seatbeltsall" */
  delete_SeatBeltsAll_by_pk?: Maybe<SeatBeltsAll_Vpic>;
  /** delete data from the table: "vpic.semiautomaticheadlampbeamswitching" */
  delete_SemiautomaticHeadlampBeamSwitching?: Maybe<SemiautomaticHeadlampBeamSwitching_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.semiautomaticheadlampbeamswitching" */
  delete_SemiautomaticHeadlampBeamSwitching_by_pk?: Maybe<SemiautomaticHeadlampBeamSwitching_Vpic>;
  /** delete data from the table: "vpic.steering" */
  delete_Steering?: Maybe<Steering_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.steering" */
  delete_Steering_by_pk?: Maybe<Steering_Vpic>;
  /** delete data from the table: "vpic.tpms" */
  delete_TPMS?: Maybe<Tpms_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.tpms" */
  delete_TPMS_by_pk?: Maybe<Tpms_Vpic>;
  /** delete data from the table: "vpic.tractioncontrol" */
  delete_TractionControl?: Maybe<TractionControl_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.tractioncontrol" */
  delete_TractionControl_by_pk?: Maybe<TractionControl_Vpic>;
  /** delete data from the table: "vpic.trailerbodytype" */
  delete_TrailerBodyType?: Maybe<TrailerBodyType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.trailerbodytype" */
  delete_TrailerBodyType_by_pk?: Maybe<TrailerBodyType_Vpic>;
  /** delete data from the table: "vpic.trailertype" */
  delete_TrailerType?: Maybe<TrailerType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.trailertype" */
  delete_TrailerType_by_pk?: Maybe<TrailerType_Vpic>;
  /** delete data from the table: "vpic.transmission" */
  delete_Transmission?: Maybe<Transmission_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.transmission" */
  delete_Transmission_by_pk?: Maybe<Transmission_Vpic>;
  /** delete data from the table: "vpic.turbo" */
  delete_Turbo?: Maybe<Turbo_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.turbo" */
  delete_Turbo_by_pk?: Maybe<Turbo_Vpic>;
  /** delete data from the table: "vpic.vspecschemapattern" */
  delete_VSpecSchemaPattern?: Maybe<VSpecSchemaPattern_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.vspecschemapattern" */
  delete_VSpecSchemaPattern_by_pk?: Maybe<VSpecSchemaPattern_Vpic>;
  /** delete data from the table: "vpic.valvetraindesign" */
  delete_ValvetrainDesign?: Maybe<ValvetrainDesign_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.valvetraindesign" */
  delete_ValvetrainDesign_by_pk?: Maybe<ValvetrainDesign_Vpic>;
  /** delete data from the table: "vpic.vehiclespecpattern" */
  delete_VehicleSpecPattern?: Maybe<VehicleSpecPattern_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.vehiclespecpattern" */
  delete_VehicleSpecPattern_by_pk?: Maybe<VehicleSpecPattern_Vpic>;
  /** delete data from the table: "vpic.vehiclespecschema" */
  delete_VehicleSpecSchema?: Maybe<VehicleSpecSchema_Mutation_Response_Vpic>;
  /** delete data from the table: "vpic.vehiclespecschema_model" */
  delete_VehicleSpecSchema_Model?: Maybe<VehicleSpecSchema_Model_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.vehiclespecschema_model" */
  delete_VehicleSpecSchema_Model_by_pk?: Maybe<VehicleSpecSchema_Model_Vpic>;
  /** delete data from the table: "vpic.vehiclespecschema_year" */
  delete_VehicleSpecSchema_Year?: Maybe<VehicleSpecSchema_Year_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.vehiclespecschema_year" */
  delete_VehicleSpecSchema_Year_by_pk?: Maybe<VehicleSpecSchema_Year_Vpic>;
  /** delete single row from the table: "vpic.vehiclespecschema" */
  delete_VehicleSpecSchema_by_pk?: Maybe<VehicleSpecSchema_Vpic>;
  /** delete data from the table: "vpic.vehicletype" */
  delete_VehicleType?: Maybe<VehicleType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.vehicletype" */
  delete_VehicleType_by_pk?: Maybe<VehicleType_Vpic>;
  /** delete data from the table: "vpic.vindescriptor" */
  delete_VinDescriptor?: Maybe<VinDescriptor_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.vindescriptor" */
  delete_VinDescriptor_by_pk?: Maybe<VinDescriptor_Vpic>;
  /** delete data from the table: "vpic.vinexception" */
  delete_VinException?: Maybe<VinException_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.vinexception" */
  delete_VinException_by_pk?: Maybe<VinException_Vpic>;
  /** delete data from the table: "vpic.vinschema" */
  delete_VinSchema?: Maybe<VinSchema_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.vinschema" */
  delete_VinSchema_by_pk?: Maybe<VinSchema_Vpic>;
  /** delete data from the table: "vpic.wmiyearvalidchars" */
  delete_WMIYearValidChars?: Maybe<WmiYearValidChars_Mutation_Response_Vpic>;
  /** delete data from the table: "vpic.wmiyearvalidchars_cacheexceptions" */
  delete_WMIYearValidChars_CacheExceptions?: Maybe<WmiYearValidChars_CacheExceptions_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.wmiyearvalidchars" */
  delete_WMIYearValidChars_by_pk?: Maybe<WmiYearValidChars_Vpic>;
  /** delete data from the table: "vpic.wheelbasetype" */
  delete_WheelBaseType?: Maybe<WheelBaseType_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.wheelbasetype" */
  delete_WheelBaseType_by_pk?: Maybe<WheelBaseType_Vpic>;
  /** delete data from the table: "vpic.wheeliemitigation" */
  delete_WheelieMitigation?: Maybe<WheelieMitigation_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.wheeliemitigation" */
  delete_WheelieMitigation_by_pk?: Maybe<WheelieMitigation_Vpic>;
  /** delete data from the table: "vpic.wmi" */
  delete_Wmi?: Maybe<Wmi_Mutation_Response_Vpic>;
  /** delete data from the table: "vpic.wmi_make" */
  delete_Wmi_Make?: Maybe<Wmi_Make_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.wmi_make" */
  delete_Wmi_Make_by_pk?: Maybe<Wmi_Make_Vpic>;
  /** delete data from the table: "vpic.wmi_vinschema" */
  delete_Wmi_VinSchema?: Maybe<Wmi_VinSchema_Mutation_Response_Vpic>;
  /** delete single row from the table: "vpic.wmi_vinschema" */
  delete_Wmi_VinSchema_by_pk?: Maybe<Wmi_VinSchema_Vpic>;
  /** delete single row from the table: "vpic.wmi" */
  delete_Wmi_by_pk?: Maybe<Wmi_Vpic>;
  /** delete data from the table: "audit.message_formatter_config" */
  delete_audit_message_formatter_config?: Maybe<Audit_Message_Formatter_Config_Mutation_Response>;
  /** delete single row from the table: "audit.message_formatter_config" */
  delete_audit_message_formatter_config_by_pk?: Maybe<Audit_Message_Formatter_Config>;
  /** delete data from the table: "auth.group" */
  delete_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** delete data from the table: "auth.group_actions" */
  delete_auth_group_actions?: Maybe<Auth_Group_Actions_Mutation_Response>;
  /** delete single row from the table: "auth.group_actions" */
  delete_auth_group_actions_by_pk?: Maybe<Auth_Group_Actions>;
  /** delete single row from the table: "auth.group" */
  delete_auth_group_by_pk?: Maybe<Auth_Group>;
  /** delete data from the table: "claims.pre_authorization_vehicle_information" */
  delete_claims_pre_authorization_vehicle_information?: Maybe<Claims_Pre_Authorization_Vehicle_Information_Mutation_Response>;
  /** delete single row from the table: "claims.pre_authorization_vehicle_information" */
  delete_claims_pre_authorization_vehicle_information_by_pk?: Maybe<Claims_Pre_Authorization_Vehicle_Information>;
  /** delete data from the table: "claims.temp_claims_auth_table" */
  delete_claims_temp_claims_auth_table?: Maybe<Claims_Temp_Claims_Auth_Table_Mutation_Response>;
  /** delete single row from the table: "claims.temp_claims_auth_table" */
  delete_claims_temp_claims_auth_table_by_pk?: Maybe<Claims_Temp_Claims_Auth_Table>;
  /** delete data from the table: "nhtsa.concern_synonym" */
  delete_concernSynonym?: Maybe<ConcernSynonym_Mutation_Response_Nhtsa>;
  /** delete single row from the table: "nhtsa.concern_synonym" */
  delete_concernSynonym_by_pk?: Maybe<ConcernSynonym_Nhtsa>;
  /** delete data from the table: "identities" */
  delete_identities?: Maybe<Identities_Mutation_Response>;
  /** delete single row from the table: "identities" */
  delete_identities_by_pk?: Maybe<Identities>;
  /** delete data from the table: "auth.identity_capability_view" */
  delete_identityCapabilityView?: Maybe<IdentityCapabilityView_Mutation_Response>;
  /** delete data from the table: "nhtsa.investigation_recall" */
  delete_investigationRecall?: Maybe<InvestigationRecall_Mutation_Response_Nhtsa>;
  /** delete single row from the table: "nhtsa.investigation_recall" */
  delete_investigationRecall_by_pk?: Maybe<InvestigationRecall_Nhtsa>;
  /** delete data from the table: "nhtsa.issue" */
  delete_issue?: Maybe<Issue_Mutation_Response_Nhtsa>;
  /** delete data from the table: "nhtsa.issue_make_model" */
  delete_issueMakeModel?: Maybe<IssueMakeModel_Mutation_Response_Nhtsa>;
  /** delete data from the table: "nhtsa.issue_search_result" */
  delete_issueSearchResult?: Maybe<IssueSearchResult_Mutation_Response_Nhtsa>;
  /** delete single row from the table: "nhtsa.issue" */
  delete_issue_by_pk?: Maybe<Issue_Nhtsa>;
  /** delete data from the table: "nhtsa.load" */
  delete_load?: Maybe<Load_Mutation_Response_Nhtsa>;
  /** delete single row from the table: "nhtsa.load" */
  delete_load_by_pk?: Maybe<Load_Nhtsa>;
  /** delete data from the table: "nhtsa.make_model" */
  delete_makeModel?: Maybe<MakeModel_Mutation_Response_Nhtsa>;
  /** delete single row from the table: "nhtsa.make_model" */
  delete_makeModel_by_pk?: Maybe<MakeModel_Nhtsa>;
  /** delete data from the table: "nhtsa.model_year_model" */
  delete_modelYearModel?: Maybe<ModelYearModel_Mutation_Response_Nhtsa>;
  /** delete single row from the table: "nhtsa.model_year_model" */
  delete_modelYearModel_by_pk?: Maybe<ModelYearModel_Nhtsa>;
  /** delete data from the table: "operations.legacy_policy_contract_cost_detail_view" */
  delete_operations_legacy_policy_contract_cost_detail_view?: Maybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Mutation_Response>;
  /** delete data from the table: "nhtsa.record_type" */
  delete_recordType?: Maybe<RecordType_Mutation_Response_Nhtsa>;
  /** delete single row from the table: "nhtsa.record_type" */
  delete_recordType_by_pk?: Maybe<RecordType_Nhtsa>;
  /** delete single row from the table: "auth.role" */
  delete_role_by_pk?: Maybe<Role>;
  /** delete data from the table: "shared.search_result" */
  delete_shared_search_result?: Maybe<Shared_Search_Result_Mutation_Response>;
  /** delete data from the table: "vwVehicleClassingBodyStyle" */
  delete_vehicleClassingBodyStyle?: Maybe<VehicleClassingBodyStyle_Mutation_Response>;
  /** delete data from the table: "vwVehicleClassingFuelType" */
  delete_vehicleClassingFuelType?: Maybe<VehicleClassingFuelType_Mutation_Response>;
  /** delete data from the table: "vwVehicleClassingVehicleMake" */
  delete_vehicleClassingVehicleMake?: Maybe<VehicleClassingVehicleMake_Mutation_Response>;
  /** delete data from the table: "vwVehicleClassingVehicleType" */
  delete_vehicleClassingVehicleType?: Maybe<VehicleClassingVehicleType_Mutation_Response>;
  /** delete data from the table: "vwVehicleCylindersDistinct" */
  delete_vwVehicleCylindersDistinct?: Maybe<VwVehicleCylindersDistinct_Mutation_Response>;
  /** delete data from the table: "vwVehicleDrivingWheelsDistinct" */
  delete_vwVehicleDrivingWheelsDistinct?: Maybe<VwVehicleDrivingWheelsDistinct_Mutation_Response>;
  /** delete data from the table: "vwVehicleFuelTypesDistinct" */
  delete_vwVehicleFuelTypesDistinct?: Maybe<VwVehicleFuelTypesDistinct_Mutation_Response>;
  /** delete data from the table: "vwVehicleMakesDistinct" */
  delete_vwVehicleMakesDistinct?: Maybe<VwVehicleMakesDistinct_Mutation_Response>;
  /** delete data from the table: "vwVehicleModelsDistinct" */
  delete_vwVehicleModelsDistinct?: Maybe<VwVehicleModelsDistinct_Mutation_Response>;
  /** delete data from the table: "vwVehicleYearsDistinct" */
  delete_vwVehicleYearsDistinct?: Maybe<VwVehicleYearsDistinct_Mutation_Response>;
  /** insert a single row into the table: "account" */
  insertAccount?: Maybe<Account>;
  /** insert a single row into the table: "account_account_manager" */
  insertAccountAccountManager?: Maybe<AccountAccountManager>;
  /** insert data into the table: "account_account_manager" */
  insertAccountAccountManagers?: Maybe<AccountAccountManager_Mutation_Response>;
  /** insert data into the table: "account_category" */
  insertAccountCategories?: Maybe<AccountCategory_Mutation_Response>;
  /** insert a single row into the table: "account_category" */
  insertAccountCategory?: Maybe<AccountCategory>;
  /** insert a single row into the table: "account_disbursement" */
  insertAccountDisbursement?: Maybe<AccountDisbursement>;
  /** insert data into the table: "account_disbursement" */
  insertAccountDisbursements?: Maybe<AccountDisbursement_Mutation_Response>;
  /** insert a single row into the table: "account_manager" */
  insertAccountManager?: Maybe<AccountManager>;
  /** insert data into the table: "account_manager" */
  insertAccountManagers?: Maybe<AccountManager_Mutation_Response>;
  /** insert a single row into the table: "account_obligor" */
  insertAccountObligor?: Maybe<AccountObligor>;
  /** insert data into the table: "account_obligor" */
  insertAccountObligors?: Maybe<AccountObligor_Mutation_Response>;
  /** insert a single row into the table: "account_product" */
  insertAccountProduct?: Maybe<AccountProduct>;
  /** insert a single row into the table: "account_product_obligor" */
  insertAccountProductObligor?: Maybe<AccountProductObligor>;
  /** insert data into the table: "account_product_obligor" */
  insertAccountProductObligors?: Maybe<AccountProductObligor_Mutation_Response>;
  /** insert data into the table: "account_product" */
  insertAccountProducts?: Maybe<AccountProduct_Mutation_Response>;
  /** insert a single row into the table: "account_retail" */
  insertAccountRetail?: Maybe<AccountRetail>;
  /** insert data into the table: "account_retail" */
  insertAccountRetails?: Maybe<AccountRetail_Mutation_Response>;
  /** insert a single row into the table: "account_type" */
  insertAccountType?: Maybe<AccountType>;
  /** insert data into the table: "account_type" */
  insertAccountTypes?: Maybe<AccountType_Mutation_Response>;
  /** insert data into the table: "account" */
  insertAccounts?: Maybe<Account_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insertAddress?: Maybe<Address>;
  /** insert a single row into the table: "address_type" */
  insertAddressType?: Maybe<AddressType>;
  /** insert data into the table: "address_type" */
  insertAddressTypes?: Maybe<AddressType_Mutation_Response>;
  /** insert data into the table: "address" */
  insertAddresses?: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "shared.alert" */
  insertAlert?: Maybe<Alert>;
  /** insert a single row into the table: "shared.alert_acknowledgment" */
  insertAlertAcknowledgment?: Maybe<AlertAcknowledgment>;
  /** insert data into the table: "shared.alert_acknowledgment" */
  insertAlertAcknowledgments?: Maybe<AlertAcknowledgment_Mutation_Response>;
  /** insert data into the table: "shared.alert" */
  insertAlerts?: Maybe<Alert_Mutation_Response>;
  /** insert a single row into the table: "auth.application" */
  insertApplication?: Maybe<Application>;
  /** insert a single row into the table: "users.application_preference" */
  insertApplicationPreference?: Maybe<ApplicationPreference>;
  /** insert data into the table: "users.application_preference" */
  insertApplicationPreferences?: Maybe<ApplicationPreference_Mutation_Response>;
  /** insert data into the table: "auth.application" */
  insertApplications?: Maybe<Application_Mutation_Response>;
  /** insert a single row into the table: "approvals.approval" */
  insertApproval?: Maybe<Approval>;
  /** insert data into the table: "approvals.authority" */
  insertApprovalAuthorities?: Maybe<ApprovalAuthority_Mutation_Response>;
  /** insert a single row into the table: "approvals.authority" */
  insertApprovalAuthority?: Maybe<ApprovalAuthority>;
  /** insert a single row into the table: "approvals.gate" */
  insertApprovalGate?: Maybe<ApprovalGate>;
  /** insert a single row into the table: "approvals.gate_binding" */
  insertApprovalGateBinding?: Maybe<ApprovalGateBinding>;
  /** insert data into the table: "approvals.gate_binding" */
  insertApprovalGateBindings?: Maybe<ApprovalGateBinding_Mutation_Response>;
  /** insert data into the table: "approvals.gate" */
  insertApprovalGates?: Maybe<ApprovalGate_Mutation_Response>;
  /** insert data into the table: "approvals.approval" */
  insertApprovalRecords?: Maybe<Approval_Mutation_Response>;
  /** insert a single row into the table: "approvals.request" */
  insertApprovalRequest?: Maybe<ApprovalRequest>;
  /** insert data into the table: "approvals.request" */
  insertApprovalRequests?: Maybe<ApprovalRequest_Mutation_Response>;
  /** insert a single row into the table: "approvals.state" */
  insertApprovalState?: Maybe<ApprovalState>;
  /** insert data into the table: "approvals.state" */
  insertApprovalStates?: Maybe<ApprovalState_Mutation_Response>;
  /** insert a single row into the table: "as400_data_sync" */
  insertAs400DataSync?: Maybe<As400DataSync>;
  /** insert data into the table: "as400_data_sync" */
  insertAs400DataSyncs?: Maybe<As400DataSync_Mutation_Response>;
  /** insert a single row into the table: "shared.bank_account_type" */
  insertBankAccountType?: Maybe<BankAccountType>;
  /** insert data into the table: "shared.bank_account_type" */
  insertBankAccountTypes?: Maybe<BankAccountType_Mutation_Response>;
  /** insert a single row into the table: "caddy.caddy" */
  insertCaddy?: Maybe<Caddy>;
  /** insert a single row into the table: "caddy.caddy_server_manager_log" */
  insertCaddyServerManagerLog?: Maybe<CaddyServerManagerLog>;
  /** insert data into the table: "caddy.caddy_server_manager_log" */
  insertCaddyServerManagerLogs?: Maybe<CaddyServerManagerLog_Mutation_Response>;
  /** insert data into the table: "caddy.caddy" */
  insertCaddys?: Maybe<Caddy_Mutation_Response>;
  /** insert a single row into the table: "compliance.cancel_rule" */
  insertCancelRule?: Maybe<CancelRule>;
  /** insert a single row into the table: "compliance.cancel_rule_fee" */
  insertCancelRuleFee?: Maybe<CancelRuleFee>;
  /** insert data into the table: "compliance.cancel_rule_fee" */
  insertCancelRuleFees?: Maybe<CancelRuleFee_Mutation_Response>;
  /** insert a single row into the table: "compliance.cancel_rule_refund" */
  insertCancelRuleRefund?: Maybe<CancelRuleRefund>;
  /** insert data into the table: "compliance.cancel_rule_refund" */
  insertCancelRuleRefunds?: Maybe<CancelRuleRefund_Mutation_Response>;
  /** insert data into the table: "compliance.cancel_rule" */
  insertCancelRules?: Maybe<CancelRule_Mutation_Response>;
  /** insert a single row into the table: "operations.cancellation" */
  insertCancellation?: Maybe<Cancellation>;
  /** insert a single row into the table: "operations.cancellation_as400" */
  insertCancellationAs400?: Maybe<CancellationAs400>;
  /** insert data into the table: "operations.cancellation_as400" */
  insertCancellationAs400s?: Maybe<CancellationAs400_Mutation_Response>;
  /** insert data into the table: "operations.cancellation" */
  insertCancellations?: Maybe<Cancellation_Mutation_Response>;
  /** insert data into the table: "auth.capability" */
  insertCapabilities?: Maybe<Capability_Mutation_Response>;
  /** insert a single row into the table: "auth.capability" */
  insertCapability?: Maybe<Capability>;
  /** insert a single row into the table: "auth.capability_config" */
  insertCapabilityConfig?: Maybe<CapabilityConfig>;
  /** insert data into the table: "auth.capability_config" */
  insertCapabilityConfigs?: Maybe<CapabilityConfig_Mutation_Response>;
  /** insert a single row into the table: "auth.capability_route" */
  insertCapabilityRoute?: Maybe<CapabilityRoute>;
  /** insert data into the table: "auth.capability_route" */
  insertCapabilityRoutes?: Maybe<CapabilityRoute_Mutation_Response>;
  /** insert a single row into the table: "users.card_layout" */
  insertCardLayout?: Maybe<CardLayout>;
  /** insert data into the table: "users.card_layout" */
  insertCardLayouts?: Maybe<CardLayout_Mutation_Response>;
  /** insert a single row into the table: "carrier" */
  insertCarrier?: Maybe<Carrier>;
  /** insert data into the table: "carrier" */
  insertCarriers?: Maybe<Carrier_Mutation_Response>;
  /** insert data into the table: "category" */
  insertCategories?: Maybe<Category_Mutation_Response>;
  /** insert a single row into the table: "category" */
  insertCategory?: Maybe<Category>;
  /** insert a single row into the table: "category_product_attribute_type" */
  insertCategoryProductAttributeType?: Maybe<CategoryProductAttributeType>;
  /** insert data into the table: "category_product_attribute_type" */
  insertCategoryProductAttributeTypes?: Maybe<CategoryProductAttributeType_Mutation_Response>;
  /** insert a single row into the table: "claim" */
  insertClaim?: Maybe<Claim>;
  /** insert a single row into the table: "claims.claim_detail" */
  insertClaimDetail?: Maybe<ClaimDetail>;
  /** insert a single row into the table: "claims.claim_detail_as400" */
  insertClaimDetailAs400?: Maybe<ClaimDetailAs400>;
  /** insert data into the table: "claims.claim_detail_as400" */
  insertClaimDetailAs400s?: Maybe<ClaimDetailAs400_Mutation_Response>;
  /** insert data into the table: "claims.claim_detail_category" */
  insertClaimDetailCategories?: Maybe<ClaimDetailCategory_Mutation_Response>;
  /** insert a single row into the table: "claims.claim_detail_category" */
  insertClaimDetailCategory?: Maybe<ClaimDetailCategory>;
  /** insert a single row into the table: "claims.claim_detail_deduction_as400" */
  insertClaimDetailDeductionAs400?: Maybe<ClaimDetailDeductionAs400>;
  /** insert data into the table: "claims.claim_detail_deduction_as400" */
  insertClaimDetailDeductionAs400s?: Maybe<ClaimDetailDeductionAs400_Mutation_Response>;
  /** insert a single row into the table: "claims.claim_detail_part_lookup" */
  insertClaimDetailPartLookup?: Maybe<ClaimDetailPartLookup>;
  /** insert data into the table: "claims.claim_detail_part_lookup" */
  insertClaimDetailPartLookups?: Maybe<ClaimDetailPartLookup_Mutation_Response>;
  /** insert data into the table: "claims.claim_detail" */
  insertClaimDetails?: Maybe<ClaimDetail_Mutation_Response>;
  /** insert a single row into the table: "claims.claim_service_center" */
  insertClaimServiceCenter?: Maybe<ClaimServiceCenter>;
  /** insert a single row into the table: "claims.claim_service_center_as400" */
  insertClaimServiceCenterAs400?: Maybe<ClaimServiceCenterAs400>;
  /** insert data into the table: "claims.claim_service_center_as400" */
  insertClaimServiceCenterAs400s?: Maybe<ClaimServiceCenterAs400_Mutation_Response>;
  /** insert a single row into the table: "claims.claim_service_center_authorization" */
  insertClaimServiceCenterAuthorization?: Maybe<ClaimServiceCenterAuthorization>;
  /** insert data into the table: "claims.claim_service_center_authorization" */
  insertClaimServiceCenterAuthorizations?: Maybe<ClaimServiceCenterAuthorization_Mutation_Response>;
  /** insert data into the table: "claims.claim_service_center" */
  insertClaimServiceCenters?: Maybe<ClaimServiceCenter_Mutation_Response>;
  /** insert a single row into the table: "ClaimStatus" */
  insertClaimStatus?: Maybe<ClaimStatus>;
  /** insert a single row into the table: "claim_status_type" */
  insertClaimStatusType?: Maybe<ClaimStatusType>;
  /** insert data into the table: "claim_status_type" */
  insertClaimStatusTypes?: Maybe<ClaimStatusType_Mutation_Response>;
  /** insert data into the table: "ClaimStatus" */
  insertClaimStatuses?: Maybe<ClaimStatus_Mutation_Response>;
  /** insert data into the table: "claim" */
  insertClaims?: Maybe<Claim_Mutation_Response>;
  /** insert a single row into the table: "ClaimsMaster" */
  insertClaimsMaster?: Maybe<ClaimsMaster>;
  /** insert data into the table: "ClaimsMaster" */
  insertClaimsMasters?: Maybe<ClaimsMaster_Mutation_Response>;
  /** insert a single row into the table: "classes.class_criteria" */
  insertClassCriteria?: Maybe<ClassCriteria>;
  /** insert data into the table: "classes.class_criteria" */
  insertClassCriterias?: Maybe<ClassCriteria_Mutation_Response>;
  /** insert a single row into the table: "classes.class_guide" */
  insertClassGuide?: Maybe<ClassGuide>;
  /** insert a single row into the table: "classes.class_guide_class_criteria" */
  insertClassGuideClassCriteria?: Maybe<ClassGuideClassCriteria>;
  /** insert data into the table: "classes.class_guide_class_criteria" */
  insertClassGuideClassCriterias?: Maybe<ClassGuideClassCriteria_Mutation_Response>;
  /** insert a single row into the table: "classes.class_guide_criteria_definition" */
  insertClassGuideCriteriaDefinition?: Maybe<ClassGuideCriteriaDefinition>;
  /** insert data into the table: "classes.class_guide_criteria_definition" */
  insertClassGuideCriteriaDefinitions?: Maybe<ClassGuideCriteriaDefinition_Mutation_Response>;
  /** insert a single row into the table: "classes.class_guide_criteria_type" */
  insertClassGuideCriteriaType?: Maybe<ClassGuideCriteriaType>;
  /** insert data into the table: "classes.class_guide_criteria_type" */
  insertClassGuideCriteriaTypes?: Maybe<ClassGuideCriteriaType_Mutation_Response>;
  /** insert data into the table: "classes.class_guide" */
  insertClassGuides?: Maybe<ClassGuide_Mutation_Response>;
  /** insert a single row into the table: "composite_product" */
  insertCompositeProduct?: Maybe<CompositeProduct>;
  /** insert data into the table: "composite_product" */
  insertCompositeProducts?: Maybe<CompositeProduct_Mutation_Response>;
  /** insert a single row into the table: "configuration_item" */
  insertConfigurationItem?: Maybe<ConfigurationItem>;
  /** insert a single row into the table: "configuration_item_type" */
  insertConfigurationItemType?: Maybe<ConfigurationItemType>;
  /** insert data into the table: "configuration_item_type" */
  insertConfigurationItemTypes?: Maybe<ConfigurationItemType_Mutation_Response>;
  /** insert data into the table: "configuration_item" */
  insertConfigurationItems?: Maybe<ConfigurationItem_Mutation_Response>;
  /** insert a single row into the table: "contact" */
  insertContact?: Maybe<Contact>;
  /** insert data into the table: "contact" */
  insertContacts?: Maybe<Contact_Mutation_Response>;
  /** insert a single row into the table: "shared.content_type" */
  insertContentType?: Maybe<ContentType>;
  /** insert data into the table: "shared.content_type" */
  insertContentTypes?: Maybe<ContentType_Mutation_Response>;
  /** insert a single row into the table: "contract" */
  insertContract?: Maybe<Contract>;
  /** insert a single row into the table: "compliance.contract_form" */
  insertContractForm?: Maybe<ContractForm>;
  /** insert a single row into the table: "compliance.contract_form_filing_status" */
  insertContractFormFilingStatus?: Maybe<ContractFormFilingStatus>;
  /** insert data into the table: "compliance.contract_form_filing_status" */
  insertContractFormFilingStatuses?: Maybe<ContractFormFilingStatus_Mutation_Response>;
  /** insert a single row into the table: "compliance.contract_form_type" */
  insertContractFormType?: Maybe<ContractFormType>;
  /** insert data into the table: "compliance.contract_form_type" */
  insertContractFormTypes?: Maybe<ContractFormType_Mutation_Response>;
  /** insert a single row into the table: "compliance.contract_form_version" */
  insertContractFormVersion?: Maybe<ContractFormVersion>;
  /** insert a single row into the table: "compliance.contract_form_version_legacy_file" */
  insertContractFormVersionLegacyFile?: Maybe<ContractFormVersionLegacyFile>;
  /** insert data into the table: "compliance.contract_form_version_legacy_file" */
  insertContractFormVersionLegacyFiles?: Maybe<ContractFormVersionLegacyFile_Mutation_Response>;
  /** insert data into the table: "compliance.contract_form_version" */
  insertContractFormVersions?: Maybe<ContractFormVersion_Mutation_Response>;
  /** insert data into the table: "compliance.contract_form" */
  insertContractForms?: Maybe<ContractForm_Mutation_Response>;
  /** insert a single row into the table: "ContractMaster" */
  insertContractMaster?: Maybe<ContractMaster>;
  /** insert data into the table: "ContractMasterAdditionalEntity" */
  insertContractMasterAdditionalEntities?: Maybe<ContractMasterAdditionalEntity_Mutation_Response>;
  /** insert a single row into the table: "ContractMasterAdditionalEntity" */
  insertContractMasterAdditionalEntity?: Maybe<ContractMasterAdditionalEntity>;
  /** insert data into the table: "ContractMaster" */
  insertContractMasters?: Maybe<ContractMaster_Mutation_Response>;
  /** insert a single row into the table: "contract_status_type" */
  insertContractStatusType?: Maybe<ContractStatusType>;
  /** insert data into the table: "contract_status_type" */
  insertContractStatusTypes?: Maybe<ContractStatusType_Mutation_Response>;
  /** insert data into the table: "contract" */
  insertContracts?: Maybe<Contract_Mutation_Response>;
  /** insert a single row into the table: "cost_adjustment" */
  insertCostAdjustment?: Maybe<CostAdjustment>;
  /** insert a single row into the table: "cost_adjustment_extended_cost" */
  insertCostAdjustmentExtendedCost?: Maybe<CostAdjustmentExtendedCost>;
  /** insert data into the table: "cost_adjustment_extended_cost" */
  insertCostAdjustmentExtendedCosts?: Maybe<CostAdjustmentExtendedCost_Mutation_Response>;
  /** insert a single row into the table: "cost_adjustment_lookup" */
  insertCostAdjustmentLookup?: Maybe<CostAdjustmentLookup>;
  /** insert data into the table: "cost_adjustment_lookup" */
  insertCostAdjustmentLookups?: Maybe<CostAdjustmentLookup_Mutation_Response>;
  /** insert a single row into the table: "cost_adjustment_type" */
  insertCostAdjustmentType?: Maybe<CostAdjustmentType>;
  /** insert data into the table: "cost_adjustment_type" */
  insertCostAdjustmentTypes?: Maybe<CostAdjustmentType_Mutation_Response>;
  /** insert data into the table: "cost_adjustment" */
  insertCostAdjustments?: Maybe<CostAdjustment_Mutation_Response>;
  /** insert a single row into the table: "custom_field" */
  insertCustomField?: Maybe<CustomField>;
  /** insert a single row into the table: "custom_field_data" */
  insertCustomFieldData?: Maybe<CustomFieldData>;
  /** insert data into the table: "custom_field_data" */
  insertCustomFieldDatas?: Maybe<CustomFieldData_Mutation_Response>;
  /** insert a single row into the table: "custom_field_type" */
  insertCustomFieldType?: Maybe<CustomFieldType>;
  /** insert data into the table: "custom_field_type" */
  insertCustomFieldTypes?: Maybe<CustomFieldType_Mutation_Response>;
  /** insert data into the table: "custom_field" */
  insertCustomFields?: Maybe<CustomField_Mutation_Response>;
  /** insert a single row into the table: "customer" */
  insertCustomer?: Maybe<Customer>;
  /** insert data into the table: "customer" */
  insertCustomers?: Maybe<Customer_Mutation_Response>;
  /** insert a single row into the table: "accounting.cycle" */
  insertCycle?: Maybe<Cycle>;
  /** insert data into the table: "accounting.cycle_journal_entry" */
  insertCycleJournalEntries?: Maybe<CycleJournalEntry_Mutation_Response>;
  /** insert a single row into the table: "accounting.cycle_journal_entry" */
  insertCycleJournalEntry?: Maybe<CycleJournalEntry>;
  /** insert a single row into the table: "accounting.cycle_total" */
  insertCycleTotal?: Maybe<CycleTotal>;
  /** insert data into the table: "accounting.cycle_total" */
  insertCycleTotals?: Maybe<CycleTotal_Mutation_Response>;
  /** insert data into the table: "accounting.cycle" */
  insertCycles?: Maybe<Cycle_Mutation_Response>;
  /** insert a single row into the table: "data_type" */
  insertDataType?: Maybe<DataType>;
  /** insert data into the table: "data_type" */
  insertDataTypes?: Maybe<DataType_Mutation_Response>;
  /** insert a single row into the table: "date_calculation_type" */
  insertDateCalculationType?: Maybe<DateCalculationType>;
  /** insert data into the table: "date_calculation_type" */
  insertDateCalculationTypes?: Maybe<DateCalculationType_Mutation_Response>;
  /** insert a single row into the table: "Dealer" */
  insertDealer?: Maybe<Dealer>;
  /** insert a single row into the table: "dealer_payment_type" */
  insertDealerPaymentType?: Maybe<DealerPaymentType>;
  /** insert data into the table: "dealer_payment_type" */
  insertDealerPaymentTypes?: Maybe<DealerPaymentType_Mutation_Response>;
  /** insert data into the table: "Dealer" */
  insertDealers?: Maybe<Dealer_Mutation_Response>;
  /** insert a single row into the table: "disbursement_type" */
  insertDisbursementType?: Maybe<DisbursementType>;
  /** insert data into the table: "disbursement_type" */
  insertDisbursementTypes?: Maybe<DisbursementType_Mutation_Response>;
  /** insert a single row into the table: "claims.document" */
  insertDocument?: Maybe<Document>;
  /** insert a single row into the table: "shared.document_instance" */
  insertDocumentInstance?: Maybe<DocumentInstance>;
  /** insert data into the table: "shared.document_instance" */
  insertDocumentInstances?: Maybe<DocumentInstance_Mutation_Response>;
  /** insert a single row into the table: "shared.document_template" */
  insertDocumentTemplate?: Maybe<DocumentTemplate>;
  /** insert a single row into the table: "shared.document_template_application" */
  insertDocumentTemplateApplication?: Maybe<DocumentTemplateApplication>;
  /** insert data into the table: "shared.document_template_application" */
  insertDocumentTemplateApplications?: Maybe<DocumentTemplateApplication_Mutation_Response>;
  /** insert data into the table: "shared.document_template" */
  insertDocumentTemplates?: Maybe<DocumentTemplate_Mutation_Response>;
  /** insert data into the table: "claims.document" */
  insertDocuments?: Maybe<Document_Mutation_Response>;
  /** insert a single row into the table: "eligibility_rule" */
  insertEligibilityRule?: Maybe<EligibilityRule>;
  /** insert a single row into the table: "eligibility_rule_definition" */
  insertEligibilityRuleDefinition?: Maybe<EligibilityRuleDefinition>;
  /** insert data into the table: "eligibility_rule_definition" */
  insertEligibilityRuleDefinitions?: Maybe<EligibilityRuleDefinition_Mutation_Response>;
  /** insert data into the table: "eligibility_rule" */
  insertEligibilityRules?: Maybe<EligibilityRule_Mutation_Response>;
  /** insert a single row into the table: "eligibility_type" */
  insertEligibilityType?: Maybe<EligibilityType>;
  /** insert data into the table: "eligibility_type" */
  insertEligibilityTypes?: Maybe<EligibilityType_Mutation_Response>;
  /** insert a single row into the table: "shared.entity_billing_information" */
  insertEntityBillingInformation?: Maybe<EntityBillingInformation>;
  /** insert data into the table: "shared.entity_billing_information" */
  insertEntityBillingInformations?: Maybe<EntityBillingInformation_Mutation_Response>;
  /** insert a single row into the table: "entity_configuration_item" */
  insertEntityConfigurationItem?: Maybe<EntityConfigurationItem>;
  /** insert data into the table: "entity_configuration_item" */
  insertEntityConfigurationItems?: Maybe<EntityConfigurationItem_Mutation_Response>;
  /** insert a single row into the table: "shared.entity_content_type" */
  insertEntityContentType?: Maybe<EntityContentType>;
  /** insert data into the table: "shared.entity_content_type" */
  insertEntityContentTypes?: Maybe<EntityContentType_Mutation_Response>;
  /** insert a single row into the table: "entity_custom_field" */
  insertEntityCustomField?: Maybe<EntityCustomField>;
  /** insert a single row into the table: "entity_custom_field_value" */
  insertEntityCustomFieldValue?: Maybe<EntityCustomFieldValue>;
  /** insert data into the table: "entity_custom_field_value" */
  insertEntityCustomFieldValues?: Maybe<EntityCustomFieldValue_Mutation_Response>;
  /** insert data into the table: "entity_custom_field" */
  insertEntityCustomFields?: Maybe<EntityCustomField_Mutation_Response>;
  /** insert a single row into the table: "entity_data_definition" */
  insertEntityDataDefinition?: Maybe<EntityDataDefinition>;
  /** insert data into the table: "entity_data_definition" */
  insertEntityDataDefinitions?: Maybe<EntityDataDefinition_Mutation_Response>;
  /** insert a single row into the table: "entity_eligibility_rule" */
  insertEntityEligibilityRule?: Maybe<EntityEligibilityRule>;
  /** insert data into the table: "entity_eligibility_rule" */
  insertEntityEligibilityRules?: Maybe<EntityEligibilityRule_Mutation_Response>;
  /** insert a single row into the table: "shared.entity_feature" */
  insertEntityFeature?: Maybe<EntityFeature>;
  /** insert data into the table: "shared.entity_feature" */
  insertEntityFeatures?: Maybe<EntityFeature_Mutation_Response>;
  /** insert a single row into the table: "shared.entity_file_content_type" */
  insertEntityFileContentType?: Maybe<EntityFileContentType>;
  /** insert data into the table: "shared.entity_file_content_type" */
  insertEntityFileContentTypes?: Maybe<EntityFileContentType_Mutation_Response>;
  /** insert a single row into the table: "shared.entity_file_storage" */
  insertEntityFileStorage?: Maybe<EntityFileStorage>;
  /** insert data into the table: "shared.entity_file_storage" */
  insertEntityFileStorages?: Maybe<EntityFileStorage_Mutation_Response>;
  /** insert a single row into the table: "shared.entity_note" */
  insertEntityNote?: Maybe<EntityNote>;
  /** insert data into the table: "shared.entity_note" */
  insertEntityNotes?: Maybe<EntityNote_Mutation_Response>;
  /** insert a single row into the table: "entity_offering" */
  insertEntityOffering?: Maybe<EntityOffering>;
  /** insert data into the table: "entity_offering" */
  insertEntityOfferings?: Maybe<EntityOffering_Mutation_Response>;
  /** insert a single row into the table: "shared.entity_remittance_detail" */
  insertEntityRemittanceDetail?: Maybe<EntityRemittanceDetail>;
  /** insert data into the table: "shared.entity_remittance_detail" */
  insertEntityRemittanceDetails?: Maybe<EntityRemittanceDetail_Mutation_Response>;
  /** insert a single row into the table: "shared.entity_tag" */
  insertEntityTag?: Maybe<EntityTag>;
  /** insert data into the table: "shared.entity_tag" */
  insertEntityTags?: Maybe<EntityTag_Mutation_Response>;
  /** insert a single row into the table: "shared.feature" */
  insertFeature?: Maybe<Feature>;
  /** insert data into the table: "shared.feature" */
  insertFeatures?: Maybe<Feature_Mutation_Response>;
  /** insert a single row into the table: "shared.file_storage" */
  insertFileStorage?: Maybe<FileStorage>;
  /** insert a single row into the table: "shared.file_storage_type" */
  insertFileStorageType?: Maybe<FileStorageType>;
  /** insert data into the table: "shared.file_storage_type" */
  insertFileStorageTypes?: Maybe<FileStorageType_Mutation_Response>;
  /** insert data into the table: "shared.file_storage" */
  insertFileStorages?: Maybe<FileStorage_Mutation_Response>;
  /** insert a single row into the table: "compliance.filing_lender" */
  insertFilingLender?: Maybe<FilingLender>;
  /** insert a single row into the table: "compliance.filing_lender_match" */
  insertFilingLenderMatch?: Maybe<FilingLenderMatch>;
  /** insert data into the table: "compliance.filing_lender_match" */
  insertFilingLenderMatches?: Maybe<FilingLenderMatch_Mutation_Response>;
  /** insert data into the table: "compliance.filing_lender" */
  insertFilingLenders?: Maybe<FilingLender_Mutation_Response>;
  /** insert a single row into the table: "compliance.filing_state" */
  insertFilingState?: Maybe<FilingState>;
  /** insert data into the table: "compliance.filing_state" */
  insertFilingStates?: Maybe<FilingState_Mutation_Response>;
  /** insert a single row into the table: "compliance.filing_status_type" */
  insertFilingStatusType?: Maybe<FilingStatusType>;
  /** insert data into the table: "compliance.filing_status_type" */
  insertFilingStatusTypes?: Maybe<FilingStatusType_Mutation_Response>;
  /** insert a single row into the table: "auth.flow_item" */
  insertFlowItem?: Maybe<FlowItem>;
  /** insert a single row into the table: "auth.flow_item_type" */
  insertFlowItemType?: Maybe<FlowItemType>;
  /** insert data into the table: "auth.flow_item_type" */
  insertFlowItemTypes?: Maybe<FlowItemType_Mutation_Response>;
  /** insert data into the table: "auth.flow_item" */
  insertFlowItems?: Maybe<FlowItem_Mutation_Response>;
  /** insert a single row into the table: "auth.flow_type" */
  insertFlowType?: Maybe<FlowType>;
  /** insert data into the table: "auth.flow_type" */
  insertFlowTypes?: Maybe<FlowType_Mutation_Response>;
  /** insert data into the table: "ory.identity" */
  insertIdentities?: Maybe<Identity_Mutation_Response>;
  /** insert a single row into the table: "ory.identity" */
  insertIdentity?: Maybe<Identity>;
  /** insert a single row into the table: "ory.identity_as400" */
  insertIdentityAs400?: Maybe<IdentityAs400>;
  /** insert data into the table: "ory.identity_as400" */
  insertIdentityAs400s?: Maybe<IdentityAs400_Mutation_Response>;
  /** insert data into the table: "auth.identity_capability" */
  insertIdentityCapabilities?: Maybe<IdentityCapability_Mutation_Response>;
  /** insert a single row into the table: "auth.identity_capability" */
  insertIdentityCapability?: Maybe<IdentityCapability>;
  /** insert data into the table: "auth.identity_entity" */
  insertIdentityEntities?: Maybe<IdentityEntity_Mutation_Response>;
  /** insert a single row into the table: "auth.identity_entity" */
  insertIdentityEntity?: Maybe<IdentityEntity>;
  /** insert a single row into the table: "auth.identity_filter" */
  insertIdentityFilter?: Maybe<IdentityFilter>;
  /** insert data into the table: "auth.identity_filter" */
  insertIdentityFilters?: Maybe<IdentityFilter_Mutation_Response>;
  /** insert a single row into the table: "claims.invoice" */
  insertInvoice?: Maybe<Invoice>;
  /** insert a single row into the table: "claims.invoice_document_type" */
  insertInvoiceDocumentType?: Maybe<InvoiceDocumentType>;
  /** insert data into the table: "claims.invoice_document_type" */
  insertInvoiceDocumentTypes?: Maybe<InvoiceDocumentType_Mutation_Response>;
  /** insert a single row into the table: "claims.invoice_payment_type" */
  insertInvoicePaymentType?: Maybe<InvoicePaymentType>;
  /** insert data into the table: "claims.invoice_payment_type" */
  insertInvoicePaymentTypes?: Maybe<InvoicePaymentType_Mutation_Response>;
  /** insert data into the table: "claims.invoice" */
  insertInvoices?: Maybe<Invoice_Mutation_Response>;
  /** insert a single row into the table: "system.job" */
  insertJob?: Maybe<Job>;
  /** insert data into the table: "system.job_history" */
  insertJobHistories?: Maybe<JobHistory_Mutation_Response>;
  /** insert a single row into the table: "system.job_history" */
  insertJobHistory?: Maybe<JobHistory>;
  /** insert a single row into the table: "system.job_history_log" */
  insertJobHistoryLog?: Maybe<JobHistoryLog>;
  /** insert data into the table: "system.job_history_log" */
  insertJobHistoryLogs?: Maybe<JobHistoryLog_Mutation_Response>;
  /** insert a single row into the table: "system.job_schedule" */
  insertJobSchedule?: Maybe<JobSchedule>;
  /** insert data into the table: "system.job_schedule" */
  insertJobSchedules?: Maybe<JobSchedule_Mutation_Response>;
  /** insert a single row into the table: "system.job_step" */
  insertJobStep?: Maybe<JobStep>;
  /** insert data into the table: "system.job_step" */
  insertJobSteps?: Maybe<JobStep_Mutation_Response>;
  /** insert data into the table: "system.job" */
  insertJobs?: Maybe<Job_Mutation_Response>;
  /** insert data into the table: "accounting.journal_entry" */
  insertJournalEntries?: Maybe<JournalEntry_Mutation_Response>;
  /** insert a single row into the table: "accounting.journal_entry" */
  insertJournalEntry?: Maybe<JournalEntry>;
  /** insert a single row into the table: "accounting.journal_entry_line" */
  insertJournalEntryLine?: Maybe<JournalEntryLine>;
  /** insert data into the table: "accounting.journal_entry_line" */
  insertJournalEntryLines?: Maybe<JournalEntryLine_Mutation_Response>;
  /** insert a single row into the table: "labor_guide_type" */
  insertLaborGuideType?: Maybe<LaborGuideType>;
  /** insert data into the table: "labor_guide_type" */
  insertLaborGuideTypes?: Maybe<LaborGuideType_Mutation_Response>;
  /** insert a single row into the table: "claims.labor_rate" */
  insertLaborRate?: Maybe<LaborRate>;
  /** insert a single row into the table: "claims.labor_rate_as400" */
  insertLaborRateAs400?: Maybe<LaborRateAs400>;
  /** insert data into the table: "claims.labor_rate_as400" */
  insertLaborRateAs400s?: Maybe<LaborRateAs400_Mutation_Response>;
  /** insert data into the table: "claims.labor_rate" */
  insertLaborRates?: Maybe<LaborRate_Mutation_Response>;
  /** insert a single row into the table: "operations.legacy_policy_contract" */
  insertLegacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** insert data into the table: "operations.legacy_policy_contract" */
  insertLegacyPolicyContracts?: Maybe<LegacyPolicyContract_Mutation_Response>;
  /** insert a single row into the table: "audit.logged_actions" */
  insertLoggedAction?: Maybe<LoggedAction>;
  /** insert data into the table: "audit.logged_actions" */
  insertLoggedActions?: Maybe<LoggedAction_Mutation_Response>;
  /** insert a single row into the table: "reporting.loss_ratio" */
  insertLossRatio?: Maybe<LossRatio>;
  /** insert data into the table: "reporting.loss_ratio" */
  insertLossRatios?: Maybe<LossRatio_Mutation_Response>;
  /** insert a single row into the table: "miles_calculation_type" */
  insertMilesCalculationType?: Maybe<MilesCalculationType>;
  /** insert data into the table: "miles_calculation_type" */
  insertMilesCalculationTypes?: Maybe<MilesCalculationType_Mutation_Response>;
  /** insert a single row into the table: "obligor" */
  insertObligor?: Maybe<Obligor>;
  /** insert data into the table: "obligor" */
  insertObligors?: Maybe<Obligor_Mutation_Response>;
  /** insert a single row into the table: "job" */
  insertObsoleteJob?: Maybe<ObsoleteJob>;
  /** insert data into the table: "job" */
  insertObsoleteJobs?: Maybe<ObsoleteJob_Mutation_Response>;
  /** insert a single row into the table: "system.outbox_event" */
  insertOutboxEvent?: Maybe<OutboxEvent>;
  /** insert data into the table: "system.outbox_event" */
  insertOutboxEvents?: Maybe<OutboxEvent_Mutation_Response>;
  /** insert a single row into the table: "shared.participant" */
  insertParticipant?: Maybe<Participant>;
  /** insert data into the table: "shared.participant" */
  insertParticipants?: Maybe<Participant_Mutation_Response>;
  /** insert a single row into the table: "accounting.payee" */
  insertPayee?: Maybe<Payee>;
  /** insert a single row into the table: "accounting.payee_as400" */
  insertPayeeAs400?: Maybe<PayeeAs400>;
  /** insert data into the table: "accounting.payee_as400" */
  insertPayeeAs400s?: Maybe<PayeeAs400_Mutation_Response>;
  /** insert data into the table: "accounting.payee" */
  insertPayees?: Maybe<Payee_Mutation_Response>;
  /** insert a single row into the table: "shared.payment" */
  insertPayment?: Maybe<Payment>;
  /** insert a single row into the table: "shared.payment_as400" */
  insertPaymentAs400?: Maybe<PaymentAs400>;
  /** insert data into the table: "shared.payment_as400" */
  insertPaymentAs400s?: Maybe<PaymentAs400_Mutation_Response>;
  /** insert a single row into the table: "shared.payment_detail" */
  insertPaymentDetail?: Maybe<PaymentDetail>;
  /** insert data into the table: "shared.payment_detail" */
  insertPaymentDetails?: Maybe<PaymentDetail_Mutation_Response>;
  /** insert a single row into the table: "shared.payment_method_type" */
  insertPaymentMethodType?: Maybe<PaymentMethodType>;
  /** insert data into the table: "shared.payment_method_type" */
  insertPaymentMethodTypes?: Maybe<PaymentMethodType_Mutation_Response>;
  /** insert a single row into the table: "shared.payment_status_type" */
  insertPaymentStatusType?: Maybe<PaymentStatusType>;
  /** insert data into the table: "shared.payment_status_type" */
  insertPaymentStatusTypes?: Maybe<PaymentStatusType_Mutation_Response>;
  /** insert a single row into the table: "shared.payment_type" */
  insertPaymentType?: Maybe<PaymentType>;
  /** insert data into the table: "shared.payment_type" */
  insertPaymentTypes?: Maybe<PaymentType_Mutation_Response>;
  /** insert data into the table: "shared.payment" */
  insertPayments?: Maybe<Payment_Mutation_Response>;
  /** insert a single row into the table: "Plan" */
  insertPlan?: Maybe<Plan>;
  /** insert data into the table: "Plan" */
  insertPlans?: Maybe<Plan_Mutation_Response>;
  /** insert data into the table: "operations.policy" */
  insertPolicies?: Maybe<Policy_Mutation_Response>;
  /** insert a single row into the table: "operations.policy" */
  insertPolicy?: Maybe<Policy>;
  /** insert a single row into the table: "claims.policy_claim" */
  insertPolicyClaim?: Maybe<PolicyClaim>;
  /** insert a single row into the table: "claims.policy_claim_as400" */
  insertPolicyClaimAs400?: Maybe<PolicyClaimAs400>;
  /** insert data into the table: "claims.policy_claim_as400" */
  insertPolicyClaimAs400s?: Maybe<PolicyClaimAs400_Mutation_Response>;
  /** insert a single row into the table: "claims.policy_claim_concern" */
  insertPolicyClaimConcern?: Maybe<PolicyClaimConcern>;
  /** insert data into the table: "claims.policy_claim_concern" */
  insertPolicyClaimConcerns?: Maybe<PolicyClaimConcern_Mutation_Response>;
  /** insert a single row into the table: "claims.policy_claim_insurance" */
  insertPolicyClaimInsurance?: Maybe<PolicyClaimInsurance>;
  /** insert data into the table: "claims.policy_claim_insurance" */
  insertPolicyClaimInsurances?: Maybe<PolicyClaimInsurance_Mutation_Response>;
  /** insert data into the table: "claims.policy_claim" */
  insertPolicyClaims?: Maybe<PolicyClaim_Mutation_Response>;
  /** insert a single row into the table: "operations.policy_contract" */
  insertPolicyContract?: Maybe<PolicyContract>;
  /** insert a single row into the table: "operations.policy_contract_asset" */
  insertPolicyContractAsset?: Maybe<PolicyContractAsset>;
  /** insert a single row into the table: "operations.policy_contract_asset_type" */
  insertPolicyContractAssetType?: Maybe<PolicyContractAssetType>;
  /** insert data into the table: "operations.policy_contract_asset_type" */
  insertPolicyContractAssetTypes?: Maybe<PolicyContractAssetType_Mutation_Response>;
  /** insert data into the table: "operations.policy_contract_asset" */
  insertPolicyContractAssets?: Maybe<PolicyContractAsset_Mutation_Response>;
  /** insert a single row into the table: "operations.policy_contract_contract_form_version" */
  insertPolicyContractContractFormVersion?: Maybe<PolicyContractContractFormVersion>;
  /** insert data into the table: "operations.policy_contract_contract_form_version" */
  insertPolicyContractContractFormVersions?: Maybe<PolicyContractContractFormVersion_Mutation_Response>;
  /** insert a single row into the table: "operations.policy_contract_cost_detail" */
  insertPolicyContractCostDetail?: Maybe<PolicyContractCostDetail>;
  /** insert data into the table: "operations.policy_contract_cost_detail" */
  insertPolicyContractCostDetails?: Maybe<PolicyContractCostDetail_Mutation_Response>;
  /** insert a single row into the table: "operations.policy_contract_lender" */
  insertPolicyContractLender?: Maybe<PolicyContractLender>;
  /** insert data into the table: "operations.policy_contract_lender" */
  insertPolicyContractLenders?: Maybe<PolicyContractLender_Mutation_Response>;
  /** insert a single row into the table: "operations.policy_contract_loan_contract_type" */
  insertPolicyContractLoanContractType?: Maybe<PolicyContractLoanContractType>;
  /** insert data into the table: "operations.policy_contract_loan_contract_type" */
  insertPolicyContractLoanContractTypes?: Maybe<PolicyContractLoanContractType_Mutation_Response>;
  /** insert a single row into the table: "operations.policy_contract_owner" */
  insertPolicyContractOwner?: Maybe<PolicyContractOwner>;
  /** insert data into the table: "operations.policy_contract_owner" */
  insertPolicyContractOwners?: Maybe<PolicyContractOwner_Mutation_Response>;
  /** insert a single row into the table: "operations.policy_contract_product" */
  insertPolicyContractProduct?: Maybe<PolicyContractProduct>;
  /** insert a single row into the table: "operations.policy_contract_product_cost_detail" */
  insertPolicyContractProductCostDetail?: Maybe<PolicyContractProductCostDetail>;
  /** insert data into the table: "operations.policy_contract_product_cost_detail" */
  insertPolicyContractProductCostDetails?: Maybe<PolicyContractProductCostDetail_Mutation_Response>;
  /** insert data into the table: "operations.policy_contract_product" */
  insertPolicyContractProducts?: Maybe<PolicyContractProduct_Mutation_Response>;
  /** insert a single row into the table: "operations.policy_contract_quote" */
  insertPolicyContractQuote?: Maybe<PolicyContractQuote>;
  /** insert data into the table: "operations.policy_contract_quote" */
  insertPolicyContractQuotes?: Maybe<PolicyContractQuote_Mutation_Response>;
  /** insert a single row into the table: "operations.policy_contract_status_type" */
  insertPolicyContractStatusType?: Maybe<PolicyContractStatusType>;
  /** insert data into the table: "operations.policy_contract_status_type" */
  insertPolicyContractStatusTypes?: Maybe<PolicyContractStatusType_Mutation_Response>;
  /** insert a single row into the table: "operations.policy_contract_void_reason_type" */
  insertPolicyContractVoidReasonType?: Maybe<PolicyContractVoidReasonType>;
  /** insert data into the table: "operations.policy_contract_void_reason_type" */
  insertPolicyContractVoidReasonTypes?: Maybe<PolicyContractVoidReasonType_Mutation_Response>;
  /** insert data into the table: "operations.policy_contract" */
  insertPolicyContracts?: Maybe<PolicyContract_Mutation_Response>;
  /** insert a single row into the table: "claims.pre_authorization" */
  insertPreAuthorization?: Maybe<PreAuthorization>;
  /** insert a single row into the table: "claims.pre_authorization_status_type" */
  insertPreAuthorizationStatusType?: Maybe<PreAuthorizationStatusType>;
  /** insert data into the table: "claims.pre_authorization_status_type" */
  insertPreAuthorizationStatusTypes?: Maybe<PreAuthorizationStatusType_Mutation_Response>;
  /** insert a single row into the table: "claims.pre_authorization_type" */
  insertPreAuthorizationType?: Maybe<PreAuthorizationType>;
  /** insert data into the table: "claims.pre_authorization_type" */
  insertPreAuthorizationTypes?: Maybe<PreAuthorizationType_Mutation_Response>;
  /** insert data into the table: "claims.pre_authorization" */
  insertPreAuthorizations?: Maybe<PreAuthorization_Mutation_Response>;
  /** insert a single row into the table: "product" */
  insertProduct?: Maybe<Product>;
  /** insert a single row into the table: "product_attribute" */
  insertProductAttribute?: Maybe<ProductAttribute>;
  /** insert a single row into the table: "product_attribute_type" */
  insertProductAttributeType?: Maybe<ProductAttributeType>;
  /** insert data into the table: "product_attribute_type" */
  insertProductAttributeTypes?: Maybe<ProductAttributeType_Mutation_Response>;
  /** insert data into the table: "product_attribute" */
  insertProductAttributes?: Maybe<ProductAttribute_Mutation_Response>;
  /** insert a single row into the table: "product_class_guide" */
  insertProductClassGuide?: Maybe<ProductClassGuide>;
  /** insert data into the table: "product_class_guide" */
  insertProductClassGuides?: Maybe<ProductClassGuide_Mutation_Response>;
  /** insert a single row into the table: "compliance.product_contract_form" */
  insertProductContractForm?: Maybe<ProductContractForm>;
  /** insert data into the table: "compliance.product_contract_form" */
  insertProductContractForms?: Maybe<ProductContractForm_Mutation_Response>;
  /** insert a single row into the table: "product_cost" */
  insertProductCost?: Maybe<ProductCost>;
  /** insert data into the table: "product_cost" */
  insertProductCosts?: Maybe<ProductCost_Mutation_Response>;
  /** insert a single row into the table: "product_disbursement" */
  insertProductDisbursement?: Maybe<ProductDisbursement>;
  /** insert data into the table: "product_disbursement" */
  insertProductDisbursements?: Maybe<ProductDisbursement_Mutation_Response>;
  /** insert data into the table: "product_eligibility_rule" */
  insertProductEligibilities?: Maybe<ProductEligibility_Mutation_Response>;
  /** insert a single row into the table: "product_eligibility_rule" */
  insertProductEligibility?: Maybe<ProductEligibility>;
  /** insert a single row into the table: "product_obligor" */
  insertProductObligor?: Maybe<ProductObligor>;
  /** insert data into the table: "product_obligor" */
  insertProductObligors?: Maybe<ProductObligor_Mutation_Response>;
  /** insert a single row into the table: "product_rate_bucket" */
  insertProductRateBucket?: Maybe<ProductRateBucket>;
  /** insert data into the table: "product_rate_bucket" */
  insertProductRateBuckets?: Maybe<ProductRateBucket_Mutation_Response>;
  /** insert a single row into the table: "product_surcharge_type" */
  insertProductSurchargeType?: Maybe<ProductSurchargeType>;
  /** insert data into the table: "product_surcharge_type" */
  insertProductSurchargeTypes?: Maybe<ProductSurchargeType_Mutation_Response>;
  /** insert data into the table: "product" */
  insertProducts?: Maybe<Product_Mutation_Response>;
  /** insert a single row into the table: "users.profile" */
  insertProfile?: Maybe<Profile>;
  /** insert data into the table: "users.profile" */
  insertProfiles?: Maybe<Profile_Mutation_Response>;
  /** insert a single row into the table: "quotes.quote" */
  insertQuote?: Maybe<Quote>;
  /** insert a single row into the table: "quotes.quote_minimal_view" */
  insertQuoteMinimalView?: Maybe<QuoteMinimalView>;
  /** insert data into the table: "quotes.quote_minimal_view" */
  insertQuoteMinimalViews?: Maybe<QuoteMinimalView_Mutation_Response>;
  /** insert a single row into the table: "quotes.quote_type" */
  insertQuoteType?: Maybe<QuoteType>;
  /** insert data into the table: "quotes.quote_type" */
  insertQuoteTypes?: Maybe<QuoteType_Mutation_Response>;
  /** insert data into the table: "quotes.quote" */
  insertQuotes?: Maybe<Quote_Mutation_Response>;
  /** insert a single row into the table: "rate_bucket_type" */
  insertRateBucketType?: Maybe<RateBucketType>;
  /** insert data into the table: "rate_bucket_type" */
  insertRateBucketTypes?: Maybe<RateBucketType_Mutation_Response>;
  /** insert a single row into the table: "rate_quote" */
  insertRateQuote?: Maybe<RateQuote>;
  /** insert data into the table: "rate_quote" */
  insertRateQuotes?: Maybe<RateQuote_Mutation_Response>;
  /** insert a single row into the table: "ui.rater_view_config" */
  insertRaterViewConfig?: Maybe<RaterViewConfig>;
  /** insert data into the table: "ui.rater_view_config" */
  insertRaterViewConfigs?: Maybe<RaterViewConfig_Mutation_Response>;
  /** insert a single row into the table: "system.reference_log" */
  insertReferenceLog?: Maybe<ReferenceLog>;
  /** insert data into the table: "system.reference_log" */
  insertReferenceLogs?: Maybe<ReferenceLog_Mutation_Response>;
  /** insert a single row into the table: "operations.remittance" */
  insertRemittance?: Maybe<Remittance>;
  /** insert a single row into the table: "claims.remittance_claim_detail" */
  insertRemittanceClaimDetail?: Maybe<RemittanceClaimDetail>;
  /** insert data into the table: "claims.remittance_claim_detail" */
  insertRemittanceClaimDetails?: Maybe<RemittanceClaimDetail_Mutation_Response>;
  /** insert a single row into the table: "operations.remittance_payment" */
  insertRemittancePayment?: Maybe<RemittancePayment>;
  /** insert data into the table: "operations.remittance_payment" */
  insertRemittancePayments?: Maybe<RemittancePayment_Mutation_Response>;
  /** insert a single row into the table: "operations.remittance_policy_contract" */
  insertRemittancePolicyContract?: Maybe<RemittancePolicyContract>;
  /** insert a single row into the table: "operations.remittance_policy_contract_as400" */
  insertRemittancePolicyContractAs400?: Maybe<RemittancePolicyContractAs400>;
  /** insert data into the table: "operations.remittance_policy_contract_as400" */
  insertRemittancePolicyContractAs400s?: Maybe<RemittancePolicyContractAs400_Mutation_Response>;
  /** insert data into the table: "operations.remittance_policy_contract" */
  insertRemittancePolicyContracts?: Maybe<RemittancePolicyContract_Mutation_Response>;
  /** insert a single row into the table: "operations.remittance_status_type" */
  insertRemittanceStatusType?: Maybe<RemittanceStatusType>;
  /** insert data into the table: "operations.remittance_status_type" */
  insertRemittanceStatusTypes?: Maybe<RemittanceStatusType_Mutation_Response>;
  /** insert a single row into the table: "operations.remittance_type" */
  insertRemittanceType?: Maybe<RemittanceType>;
  /** insert data into the table: "operations.remittance_type" */
  insertRemittanceTypes?: Maybe<RemittanceType_Mutation_Response>;
  /** insert data into the table: "operations.remittance" */
  insertRemittances?: Maybe<Remittance_Mutation_Response>;
  /** insert a single row into the table: "claims.repeat_part_acknowledgment" */
  insertRepeatPartAcknowledgment?: Maybe<RepeatPartAcknowledgment>;
  /** insert data into the table: "claims.repeat_part_acknowledgment" */
  insertRepeatPartAcknowledgments?: Maybe<RepeatPartAcknowledgment_Mutation_Response>;
  /** insert a single row into the table: "auth.role" */
  insertRole?: Maybe<Role>;
  /** insert a single row into the table: "auth.role_attribute" */
  insertRoleAttribute?: Maybe<RoleAttribute>;
  /** insert data into the table: "auth.role_attribute" */
  insertRoleAttributes?: Maybe<RoleAttribute_Mutation_Response>;
  /** insert data into the table: "auth.role" */
  insertRoles?: Maybe<Role_Mutation_Response>;
  /** insert a single row into the table: "auth.route" */
  insertRoute?: Maybe<Route>;
  /** insert a single row into the table: "auth.route_config" */
  insertRouteConfig?: Maybe<RouteConfig>;
  /** insert data into the table: "auth.route_config" */
  insertRouteConfigs?: Maybe<RouteConfig_Mutation_Response>;
  /** insert data into the table: "auth.route" */
  insertRoutes?: Maybe<Route_Mutation_Response>;
  /** insert a single row into the table: "shared.search_index" */
  insertSearchIndex?: Maybe<SearchIndex>;
  /** insert data into the table: "shared.search_index" */
  insertSearchIndexes?: Maybe<SearchIndex_Mutation_Response>;
  /** insert a single row into the table: "state" */
  insertSelectState?: Maybe<State>;
  /** insert data into the table: "state" */
  insertSelectStates?: Maybe<State_Mutation_Response>;
  /** insert a single row into the table: "claims.service_center" */
  insertServiceCenter?: Maybe<ServiceCenter>;
  /** insert data into the table: "claims.service_center" */
  insertServiceCenters?: Maybe<ServiceCenter_Mutation_Response>;
  /** insert a single row into the table: "system.severity_level_type" */
  insertSeverityLevelType?: Maybe<SeverityLevelType>;
  /** insert data into the table: "system.severity_level_type" */
  insertSeverityLevelTypes?: Maybe<SeverityLevelType_Mutation_Response>;
  /** insert a single row into the table: "users.shortcut_binding" */
  insertShortcutBinding?: Maybe<ShortcutBinding>;
  /** insert data into the table: "users.shortcut_binding" */
  insertShortcutBindings?: Maybe<ShortcutBinding_Mutation_Response>;
  /** insert a single row into the table: "system.step" */
  insertStep?: Maybe<Step>;
  /** insert a single row into the table: "system.step_type" */
  insertStepType?: Maybe<StepType>;
  /** insert data into the table: "system.step_type" */
  insertStepTypes?: Maybe<StepType_Mutation_Response>;
  /** insert data into the table: "system.step" */
  insertSteps?: Maybe<Step_Mutation_Response>;
  /** insert a single row into the table: "surcharge_type" */
  insertSurchargeType?: Maybe<SurchargeType>;
  /** insert data into the table: "surcharge_type" */
  insertSurchargeTypes?: Maybe<SurchargeType_Mutation_Response>;
  /** insert a single row into the table: "shared.tag" */
  insertTag?: Maybe<Tag>;
  /** insert data into the table: "shared.tag" */
  insertTags?: Maybe<Tag_Mutation_Response>;
  /** insert a single row into the table: "task" */
  insertTask?: Maybe<Task>;
  /** insert data into the table: "task" */
  insertTasks?: Maybe<Task_Mutation_Response>;
  /** insert a single row into the table: "claims.tax_rate" */
  insertTaxRate?: Maybe<TaxRate>;
  /** insert a single row into the table: "claims.tax_rate_as400" */
  insertTaxRateAs400?: Maybe<TaxRateAs400>;
  /** insert data into the table: "claims.tax_rate_as400" */
  insertTaxRateAs400s?: Maybe<TaxRateAs400_Mutation_Response>;
  /** insert data into the table: "claims.tax_rate" */
  insertTaxRates?: Maybe<TaxRate_Mutation_Response>;
  /** insert a single row into the table: "system.technology_type" */
  insertTechnologyType?: Maybe<TechnologyType>;
  /** insert data into the table: "system.technology_type" */
  insertTechnologyTypes?: Maybe<TechnologyType_Mutation_Response>;
  /** insert a single row into the table: "shared.type" */
  insertType?: Maybe<Type>;
  /** insert a single row into the table: "shared.type_group" */
  insertTypeGroup?: Maybe<TypeGroup>;
  /** insert data into the table: "shared.type_group" */
  insertTypeGroups?: Maybe<TypeGroup_Mutation_Response>;
  /** insert data into the table: "shared.type" */
  insertTypes?: Maybe<Type_Mutation_Response>;
  /** insert a single row into the table: "auth.user" */
  insertUser?: Maybe<User>;
  /** insert a single row into the table: "auth.user_flow_item" */
  insertUserFlowItem?: Maybe<UserFlowItem>;
  /** insert a single row into the table: "auth.user_flow_item_mfa" */
  insertUserFlowItemMfa?: Maybe<UserFlowItemMfa>;
  /** insert data into the table: "auth.user_flow_item_mfa" */
  insertUserFlowItemMfas?: Maybe<UserFlowItemMfa_Mutation_Response>;
  /** insert data into the table: "auth.user_flow_item" */
  insertUserFlowItems?: Maybe<UserFlowItem_Mutation_Response>;
  /** insert a single row into the table: "auth.user_group" */
  insertUserGroup?: Maybe<UserGroup>;
  /** insert data into the table: "auth.user_group" */
  insertUserGroups?: Maybe<UserGroup_Mutation_Response>;
  /** insert a single row into the table: "user_pin" */
  insertUserPin?: Maybe<UserPin>;
  /** insert data into the table: "user_pin" */
  insertUserPins?: Maybe<UserPin_Mutation_Response>;
  /** insert a single row into the table: "auth.user_profile" */
  insertUserProfile?: Maybe<UserProfile>;
  /** insert data into the table: "auth.user_profile" */
  insertUserProfiles?: Maybe<UserProfile_Mutation_Response>;
  /** insert a single row into the table: "auth.user_session" */
  insertUserSession?: Maybe<UserSession>;
  /** insert data into the table: "auth.user_session" */
  insertUserSessions?: Maybe<UserSession_Mutation_Response>;
  /** insert data into the table: "auth.user" */
  insertUsers?: Maybe<User_Mutation_Response>;
  /** insert a single row into the table: "shared.validation" */
  insertValidation?: Maybe<Validation>;
  /** insert a single row into the table: "shared.validation_lifecycle_hook" */
  insertValidationLifecycleHook?: Maybe<ValidationLifecycleHook>;
  /** insert data into the table: "shared.validation_lifecycle_hook" */
  insertValidationLifecycleHooks?: Maybe<ValidationLifecycleHook_Mutation_Response>;
  /** insert a single row into the table: "shared.validation_override" */
  insertValidationOverride?: Maybe<ValidationOverride>;
  /** insert data into the table: "shared.validation_override" */
  insertValidationOverrides?: Maybe<ValidationOverride_Mutation_Response>;
  /** insert a single row into the table: "shared.validation_rule_for" */
  insertValidationRuleFor?: Maybe<ValidationRuleFor>;
  /** insert data into the table: "shared.validation_rule_for" */
  insertValidationRuleFors?: Maybe<ValidationRuleFor_Mutation_Response>;
  /** insert a single row into the table: "shared.validation_type_operation" */
  insertValidationTypeOperation?: Maybe<ValidationTypeOperation>;
  /** insert data into the table: "shared.validation_type_operation" */
  insertValidationTypeOperations?: Maybe<ValidationTypeOperation_Mutation_Response>;
  /** insert a single row into the table: "shared.validation_when" */
  insertValidationWhen?: Maybe<ValidationWhen>;
  /** insert data into the table: "shared.validation_when" */
  insertValidationWhens?: Maybe<ValidationWhen_Mutation_Response>;
  /** insert data into the table: "shared.validation" */
  insertValidations?: Maybe<Validation_Mutation_Response>;
  /** insert a single row into the table: "vehicle" */
  insertVehicle?: Maybe<Vehicle>;
  /** insert a single row into the table: "vehicle.vehicle_status_type" */
  insertVehicleStatusType?: Maybe<VehicleStatusType>;
  /** insert data into the table: "vehicle.vehicle_status_type" */
  insertVehicleStatusTypes?: Maybe<VehicleStatusType_Mutation_Response>;
  /** insert data into the table: "vehicle" */
  insertVehicles?: Maybe<Vehicle_Mutation_Response>;
  /** insert a single row into the table: "vehicle.vpic_decode_alternative" */
  insertVpicDecodeAlternative?: Maybe<VpicDecodeAlternative>;
  /** insert data into the table: "vehicle.vpic_decode_alternative" */
  insertVpicDecodeAlternatives?: Maybe<VpicDecodeAlternative_Mutation_Response>;
  /** insert a single row into the table: "work_status_type" */
  insertWorkStatusType?: Maybe<WorkStatusType>;
  /** insert data into the table: "work_status_type" */
  insertWorkStatusTypes?: Maybe<WorkStatusType_Mutation_Response>;
  /** insert a single row into the table: "claims.workflow_state_type" */
  insertWorkflowStateType?: Maybe<WorkflowStateType>;
  /** insert data into the table: "claims.workflow_state_type" */
  insertWorkflowStateTypes?: Maybe<WorkflowStateType_Mutation_Response>;
  /** insert data into the table: "vpic.abs" */
  insert_ABS?: Maybe<Abs_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.abs" */
  insert_ABS_one?: Maybe<Abs_Vpic>;
  /** insert data into the table: "vpic.adaptivecruisecontrol" */
  insert_AdaptiveCruiseControl?: Maybe<AdaptiveCruiseControl_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.adaptivecruisecontrol" */
  insert_AdaptiveCruiseControl_one?: Maybe<AdaptiveCruiseControl_Vpic>;
  /** insert data into the table: "vpic.adaptivedrivingbeam" */
  insert_AdaptiveDrivingBeam?: Maybe<AdaptiveDrivingBeam_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.adaptivedrivingbeam" */
  insert_AdaptiveDrivingBeam_one?: Maybe<AdaptiveDrivingBeam_Vpic>;
  /** insert data into the table: "vpic.airbaglocfront" */
  insert_AirBagLocFront?: Maybe<AirBagLocFront_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.airbaglocfront" */
  insert_AirBagLocFront_one?: Maybe<AirBagLocFront_Vpic>;
  /** insert data into the table: "vpic.airbaglocknee" */
  insert_AirBagLocKnee?: Maybe<AirBagLocKnee_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.airbaglocknee" */
  insert_AirBagLocKnee_one?: Maybe<AirBagLocKnee_Vpic>;
  /** insert data into the table: "vpic.airbaglocations" */
  insert_AirBagLocations?: Maybe<AirBagLocations_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.airbaglocations" */
  insert_AirBagLocations_one?: Maybe<AirBagLocations_Vpic>;
  /** insert data into the table: "vpic.autobrake" */
  insert_AutoBrake?: Maybe<AutoBrake_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.autobrake" */
  insert_AutoBrake_one?: Maybe<AutoBrake_Vpic>;
  /** insert data into the table: "vpic.autoreversesystem" */
  insert_AutoReverseSystem?: Maybe<AutoReverseSystem_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.autoreversesystem" */
  insert_AutoReverseSystem_one?: Maybe<AutoReverseSystem_Vpic>;
  /** insert data into the table: "vpic.automaticpedestrainalertingsound" */
  insert_AutomaticPedestrainAlertingSound?: Maybe<AutomaticPedestrainAlertingSound_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.automaticpedestrainalertingsound" */
  insert_AutomaticPedestrainAlertingSound_one?: Maybe<AutomaticPedestrainAlertingSound_Vpic>;
  /** insert data into the table: "vpic.axleconfiguration" */
  insert_AxleConfiguration?: Maybe<AxleConfiguration_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.axleconfiguration" */
  insert_AxleConfiguration_one?: Maybe<AxleConfiguration_Vpic>;
  /** insert data into the table: "vpic.batterytype" */
  insert_BatteryType?: Maybe<BatteryType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.batterytype" */
  insert_BatteryType_one?: Maybe<BatteryType_Vpic>;
  /** insert data into the table: "vpic.bedtype" */
  insert_BedType?: Maybe<BedType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.bedtype" */
  insert_BedType_one?: Maybe<BedType_Vpic>;
  /** insert data into the table: "vpic.blindspotintervention" */
  insert_BlindSpotIntervention?: Maybe<BlindSpotIntervention_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.blindspotintervention" */
  insert_BlindSpotIntervention_one?: Maybe<BlindSpotIntervention_Vpic>;
  /** insert data into the table: "vpic.blindspotmonitoring" */
  insert_BlindSpotMonitoring?: Maybe<BlindSpotMonitoring_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.blindspotmonitoring" */
  insert_BlindSpotMonitoring_one?: Maybe<BlindSpotMonitoring_Vpic>;
  /** insert data into the table: "vpic.bodycab" */
  insert_BodyCab?: Maybe<BodyCab_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.bodycab" */
  insert_BodyCab_one?: Maybe<BodyCab_Vpic>;
  /** insert data into the table: "vpic.bodystyle" */
  insert_BodyStyle?: Maybe<BodyStyle_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.bodystyle" */
  insert_BodyStyle_one?: Maybe<BodyStyle_Vpic>;
  /** insert data into the table: "vpic.brakesystem" */
  insert_BrakeSystem?: Maybe<BrakeSystem_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.brakesystem" */
  insert_BrakeSystem_one?: Maybe<BrakeSystem_Vpic>;
  /** insert data into the table: "vpic.busfloorconfigtype" */
  insert_BusFloorConfigType?: Maybe<BusFloorConfigType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.busfloorconfigtype" */
  insert_BusFloorConfigType_one?: Maybe<BusFloorConfigType_Vpic>;
  /** insert data into the table: "vpic.bustype" */
  insert_BusType?: Maybe<BusType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.bustype" */
  insert_BusType_one?: Maybe<BusType_Vpic>;
  /** insert data into the table: "vpic.can_aacn" */
  insert_CAN_AACN?: Maybe<Can_Aacn_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.can_aacn" */
  insert_CAN_AACN_one?: Maybe<Can_Aacn_Vpic>;
  /** insert data into the table: "vpic.chargerlevel" */
  insert_ChargerLevel?: Maybe<ChargerLevel_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.chargerlevel" */
  insert_ChargerLevel_one?: Maybe<ChargerLevel_Vpic>;
  /** insert data into the table: "vpic.combinedbrakingsystem" */
  insert_CombinedBrakingSystem?: Maybe<CombinedBrakingSystem_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.combinedbrakingsystem" */
  insert_CombinedBrakingSystem_one?: Maybe<CombinedBrakingSystem_Vpic>;
  /** insert data into the table: "ContractMasterSurcharge" */
  insert_ContractMasterSurcharge?: Maybe<ContractMasterSurcharge_Mutation_Response>;
  /** insert a single row into the table: "ContractMasterSurcharge" */
  insert_ContractMasterSurcharge_one?: Maybe<ContractMasterSurcharge>;
  /** insert data into the table: "vpic.conversion" */
  insert_Conversion?: Maybe<Conversion_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.conversion" */
  insert_Conversion_one?: Maybe<Conversion_Vpic>;
  /** insert data into the table: "vpic.coolingtype" */
  insert_CoolingType?: Maybe<CoolingType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.coolingtype" */
  insert_CoolingType_one?: Maybe<CoolingType_Vpic>;
  /** insert data into the table: "vpic.country" */
  insert_Country?: Maybe<Country_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.country" */
  insert_Country_one?: Maybe<Country_Vpic>;
  /** insert data into the table: "vpic.custommotorcycletype" */
  insert_CustomMotorcycleType?: Maybe<CustomMotorcycleType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.custommotorcycletype" */
  insert_CustomMotorcycleType_one?: Maybe<CustomMotorcycleType_Vpic>;
  /** insert data into the table: "vpic.daytimerunninglight" */
  insert_DaytimeRunningLight?: Maybe<DaytimeRunningLight_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.daytimerunninglight" */
  insert_DaytimeRunningLight_one?: Maybe<DaytimeRunningLight_Vpic>;
  /** insert data into the table: "vpic.defaultvalue" */
  insert_DefaultValue?: Maybe<DefaultValue_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.defaultvalue" */
  insert_DefaultValue_one?: Maybe<DefaultValue_Vpic>;
  /** insert data into the table: "vpic.destinationmarket" */
  insert_DestinationMarket?: Maybe<DestinationMarket_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.destinationmarket" */
  insert_DestinationMarket_one?: Maybe<DestinationMarket_Vpic>;
  /** insert data into the table: "vpic.drivetype" */
  insert_DriveType?: Maybe<DriveType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.drivetype" */
  insert_DriveType_one?: Maybe<DriveType_Vpic>;
  /** insert data into the table: "vpic.dynamicbrakesupport" */
  insert_DynamicBrakeSupport?: Maybe<DynamicBrakeSupport_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.dynamicbrakesupport" */
  insert_DynamicBrakeSupport_one?: Maybe<DynamicBrakeSupport_Vpic>;
  /** insert data into the table: "vpic.ecs" */
  insert_ECS?: Maybe<Ecs_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.ecs" */
  insert_ECS_one?: Maybe<Ecs_Vpic>;
  /** insert data into the table: "vpic.edr" */
  insert_EDR?: Maybe<Edr_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.edr" */
  insert_EDR_one?: Maybe<Edr_Vpic>;
  /** insert data into the table: "vpic.evdriveunit" */
  insert_EVDriveUnit?: Maybe<EvDriveUnit_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.evdriveunit" */
  insert_EVDriveUnit_one?: Maybe<EvDriveUnit_Vpic>;
  /** insert data into the table: "vpic.electrificationlevel" */
  insert_ElectrificationLevel?: Maybe<ElectrificationLevel_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.electrificationlevel" */
  insert_ElectrificationLevel_one?: Maybe<ElectrificationLevel_Vpic>;
  /** insert data into the table: "vpic.element" */
  insert_Element?: Maybe<Element_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.element" */
  insert_Element_one?: Maybe<Element_Vpic>;
  /** insert data into the table: "vpic.engineconfiguration" */
  insert_EngineConfiguration?: Maybe<EngineConfiguration_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.engineconfiguration" */
  insert_EngineConfiguration_one?: Maybe<EngineConfiguration_Vpic>;
  /** insert data into the table: "vpic.enginemodel" */
  insert_EngineModel?: Maybe<EngineModel_Mutation_Response_Vpic>;
  /** insert data into the table: "vpic.enginemodelpattern" */
  insert_EngineModelPattern?: Maybe<EngineModelPattern_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.enginemodelpattern" */
  insert_EngineModelPattern_one?: Maybe<EngineModelPattern_Vpic>;
  /** insert a single row into the table: "vpic.enginemodel" */
  insert_EngineModel_one?: Maybe<EngineModel_Vpic>;
  /** insert data into the table: "vpic.entertainmentsystem" */
  insert_EntertainmentSystem?: Maybe<EntertainmentSystem_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.entertainmentsystem" */
  insert_EntertainmentSystem_one?: Maybe<EntertainmentSystem_Vpic>;
  /** insert data into the table: "vpic.errorcode" */
  insert_ErrorCode?: Maybe<ErrorCode_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.errorcode" */
  insert_ErrorCode_one?: Maybe<ErrorCode_Vpic>;
  /** insert data into the table: "vpic.forwardcollisionwarning" */
  insert_ForwardCollisionWarning?: Maybe<ForwardCollisionWarning_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.forwardcollisionwarning" */
  insert_ForwardCollisionWarning_one?: Maybe<ForwardCollisionWarning_Vpic>;
  /** insert data into the table: "vpic.fueldeliverytype" */
  insert_FuelDeliveryType?: Maybe<FuelDeliveryType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.fueldeliverytype" */
  insert_FuelDeliveryType_one?: Maybe<FuelDeliveryType_Vpic>;
  /** insert data into the table: "vpic.fueltankmaterial" */
  insert_FuelTankMaterial?: Maybe<FuelTankMaterial_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.fueltankmaterial" */
  insert_FuelTankMaterial_one?: Maybe<FuelTankMaterial_Vpic>;
  /** insert data into the table: "vpic.fueltanktype" */
  insert_FuelTankType?: Maybe<FuelTankType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.fueltanktype" */
  insert_FuelTankType_one?: Maybe<FuelTankType_Vpic>;
  /** insert data into the table: "vpic.fueltype" */
  insert_FuelType?: Maybe<FuelType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.fueltype" */
  insert_FuelType_one?: Maybe<FuelType_Vpic>;
  /** insert data into the table: "vpic.grossvehicleweightrating" */
  insert_GrossVehicleWeightRating?: Maybe<GrossVehicleWeightRating_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.grossvehicleweightrating" */
  insert_GrossVehicleWeightRating_one?: Maybe<GrossVehicleWeightRating_Vpic>;
  /** insert data into the table: "vpic.keylessignition" */
  insert_KeylessIgnition?: Maybe<KeylessIgnition_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.keylessignition" */
  insert_KeylessIgnition_one?: Maybe<KeylessIgnition_Vpic>;
  /** insert data into the table: "vpic.lanecenteringassistance" */
  insert_LaneCenteringAssistance?: Maybe<LaneCenteringAssistance_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.lanecenteringassistance" */
  insert_LaneCenteringAssistance_one?: Maybe<LaneCenteringAssistance_Vpic>;
  /** insert data into the table: "vpic.lanedeparturewarning" */
  insert_LaneDepartureWarning?: Maybe<LaneDepartureWarning_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.lanedeparturewarning" */
  insert_LaneDepartureWarning_one?: Maybe<LaneDepartureWarning_Vpic>;
  /** insert data into the table: "vpic.lanekeepsystem" */
  insert_LaneKeepSystem?: Maybe<LaneKeepSystem_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.lanekeepsystem" */
  insert_LaneKeepSystem_one?: Maybe<LaneKeepSystem_Vpic>;
  /** insert data into the table: "vpic.lowerbeamheadlamplightsource" */
  insert_LowerBeamHeadlampLightSource?: Maybe<LowerBeamHeadlampLightSource_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.lowerbeamheadlamplightsource" */
  insert_LowerBeamHeadlampLightSource_one?: Maybe<LowerBeamHeadlampLightSource_Vpic>;
  /** insert data into the table: "vpic.make" */
  insert_Make?: Maybe<Make_Mutation_Response_Vpic>;
  /** insert data into the table: "vpic.make_model" */
  insert_Make_Model?: Maybe<Make_Model_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.make_model" */
  insert_Make_Model_one?: Maybe<Make_Model_Vpic>;
  /** insert a single row into the table: "vpic.make" */
  insert_Make_one?: Maybe<Make_Vpic>;
  /** insert data into the table: "vpic.manufacturer" */
  insert_Manufacturer?: Maybe<Manufacturer_Mutation_Response_Vpic>;
  /** insert data into the table: "vpic.manufacturer_make" */
  insert_Manufacturer_Make?: Maybe<Manufacturer_Make_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.manufacturer_make" */
  insert_Manufacturer_Make_one?: Maybe<Manufacturer_Make_Vpic>;
  /** insert a single row into the table: "vpic.manufacturer" */
  insert_Manufacturer_one?: Maybe<Manufacturer_Vpic>;
  /** insert data into the table: "vpic.model" */
  insert_Model?: Maybe<Model_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.model" */
  insert_Model_one?: Maybe<Model_Vpic>;
  /** insert data into the table: "vpic.motorcyclechassistype" */
  insert_MotorcycleChassisType?: Maybe<MotorcycleChassisType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.motorcyclechassistype" */
  insert_MotorcycleChassisType_one?: Maybe<MotorcycleChassisType_Vpic>;
  /** insert data into the table: "vpic.motorcyclesuspensiontype" */
  insert_MotorcycleSuspensionType?: Maybe<MotorcycleSuspensionType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.motorcyclesuspensiontype" */
  insert_MotorcycleSuspensionType_one?: Maybe<MotorcycleSuspensionType_Vpic>;
  /** insert data into the table: "vpic.nonlanduse" */
  insert_NonLandUse?: Maybe<NonLandUse_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.nonlanduse" */
  insert_NonLandUse_one?: Maybe<NonLandUse_Vpic>;
  /** insert data into the table: "vpic.parkassist" */
  insert_ParkAssist?: Maybe<ParkAssist_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.parkassist" */
  insert_ParkAssist_one?: Maybe<ParkAssist_Vpic>;
  /** insert data into the table: "vpic.pattern" */
  insert_Pattern?: Maybe<Pattern_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.pattern" */
  insert_Pattern_one?: Maybe<Pattern_Vpic>;
  /** insert data into the table: "vpic.pedestrianautomaticemergencybraking" */
  insert_PedestrianAutomaticEmergencyBraking?: Maybe<PedestrianAutomaticEmergencyBraking_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.pedestrianautomaticemergencybraking" */
  insert_PedestrianAutomaticEmergencyBraking_one?: Maybe<PedestrianAutomaticEmergencyBraking_Vpic>;
  /** insert data into the table: "vpic.pretensioner" */
  insert_Pretensioner?: Maybe<Pretensioner_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.pretensioner" */
  insert_Pretensioner_one?: Maybe<Pretensioner_Vpic>;
  /** insert data into the table: "vpic.rearautomaticemergencybraking" */
  insert_RearAutomaticEmergencyBraking?: Maybe<RearAutomaticEmergencyBraking_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.rearautomaticemergencybraking" */
  insert_RearAutomaticEmergencyBraking_one?: Maybe<RearAutomaticEmergencyBraking_Vpic>;
  /** insert data into the table: "vpic.rearcrosstrafficalert" */
  insert_RearCrossTrafficAlert?: Maybe<RearCrossTrafficAlert_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.rearcrosstrafficalert" */
  insert_RearCrossTrafficAlert_one?: Maybe<RearCrossTrafficAlert_Vpic>;
  /** insert data into the table: "vpic.rearvisibilitycamera" */
  insert_RearVisibilityCamera?: Maybe<RearVisibilityCamera_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.rearvisibilitycamera" */
  insert_RearVisibilityCamera_one?: Maybe<RearVisibilityCamera_Vpic>;
  /** insert data into the table: "vpic.seatbeltsall" */
  insert_SeatBeltsAll?: Maybe<SeatBeltsAll_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.seatbeltsall" */
  insert_SeatBeltsAll_one?: Maybe<SeatBeltsAll_Vpic>;
  /** insert data into the table: "vpic.semiautomaticheadlampbeamswitching" */
  insert_SemiautomaticHeadlampBeamSwitching?: Maybe<SemiautomaticHeadlampBeamSwitching_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.semiautomaticheadlampbeamswitching" */
  insert_SemiautomaticHeadlampBeamSwitching_one?: Maybe<SemiautomaticHeadlampBeamSwitching_Vpic>;
  /** insert data into the table: "vpic.steering" */
  insert_Steering?: Maybe<Steering_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.steering" */
  insert_Steering_one?: Maybe<Steering_Vpic>;
  /** insert data into the table: "vpic.tpms" */
  insert_TPMS?: Maybe<Tpms_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.tpms" */
  insert_TPMS_one?: Maybe<Tpms_Vpic>;
  /** insert data into the table: "vpic.tractioncontrol" */
  insert_TractionControl?: Maybe<TractionControl_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.tractioncontrol" */
  insert_TractionControl_one?: Maybe<TractionControl_Vpic>;
  /** insert data into the table: "vpic.trailerbodytype" */
  insert_TrailerBodyType?: Maybe<TrailerBodyType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.trailerbodytype" */
  insert_TrailerBodyType_one?: Maybe<TrailerBodyType_Vpic>;
  /** insert data into the table: "vpic.trailertype" */
  insert_TrailerType?: Maybe<TrailerType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.trailertype" */
  insert_TrailerType_one?: Maybe<TrailerType_Vpic>;
  /** insert data into the table: "vpic.transmission" */
  insert_Transmission?: Maybe<Transmission_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.transmission" */
  insert_Transmission_one?: Maybe<Transmission_Vpic>;
  /** insert data into the table: "vpic.turbo" */
  insert_Turbo?: Maybe<Turbo_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.turbo" */
  insert_Turbo_one?: Maybe<Turbo_Vpic>;
  /** insert data into the table: "vpic.vspecschemapattern" */
  insert_VSpecSchemaPattern?: Maybe<VSpecSchemaPattern_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.vspecschemapattern" */
  insert_VSpecSchemaPattern_one?: Maybe<VSpecSchemaPattern_Vpic>;
  /** insert data into the table: "vpic.valvetraindesign" */
  insert_ValvetrainDesign?: Maybe<ValvetrainDesign_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.valvetraindesign" */
  insert_ValvetrainDesign_one?: Maybe<ValvetrainDesign_Vpic>;
  /** insert data into the table: "vpic.vehiclespecpattern" */
  insert_VehicleSpecPattern?: Maybe<VehicleSpecPattern_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.vehiclespecpattern" */
  insert_VehicleSpecPattern_one?: Maybe<VehicleSpecPattern_Vpic>;
  /** insert data into the table: "vpic.vehiclespecschema" */
  insert_VehicleSpecSchema?: Maybe<VehicleSpecSchema_Mutation_Response_Vpic>;
  /** insert data into the table: "vpic.vehiclespecschema_model" */
  insert_VehicleSpecSchema_Model?: Maybe<VehicleSpecSchema_Model_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.vehiclespecschema_model" */
  insert_VehicleSpecSchema_Model_one?: Maybe<VehicleSpecSchema_Model_Vpic>;
  /** insert data into the table: "vpic.vehiclespecschema_year" */
  insert_VehicleSpecSchema_Year?: Maybe<VehicleSpecSchema_Year_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.vehiclespecschema_year" */
  insert_VehicleSpecSchema_Year_one?: Maybe<VehicleSpecSchema_Year_Vpic>;
  /** insert a single row into the table: "vpic.vehiclespecschema" */
  insert_VehicleSpecSchema_one?: Maybe<VehicleSpecSchema_Vpic>;
  /** insert data into the table: "vpic.vehicletype" */
  insert_VehicleType?: Maybe<VehicleType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.vehicletype" */
  insert_VehicleType_one?: Maybe<VehicleType_Vpic>;
  /** insert data into the table: "vpic.vindescriptor" */
  insert_VinDescriptor?: Maybe<VinDescriptor_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.vindescriptor" */
  insert_VinDescriptor_one?: Maybe<VinDescriptor_Vpic>;
  /** insert data into the table: "vpic.vinexception" */
  insert_VinException?: Maybe<VinException_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.vinexception" */
  insert_VinException_one?: Maybe<VinException_Vpic>;
  /** insert data into the table: "vpic.vinschema" */
  insert_VinSchema?: Maybe<VinSchema_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.vinschema" */
  insert_VinSchema_one?: Maybe<VinSchema_Vpic>;
  /** insert data into the table: "vpic.wmiyearvalidchars" */
  insert_WMIYearValidChars?: Maybe<WmiYearValidChars_Mutation_Response_Vpic>;
  /** insert data into the table: "vpic.wmiyearvalidchars_cacheexceptions" */
  insert_WMIYearValidChars_CacheExceptions?: Maybe<WmiYearValidChars_CacheExceptions_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.wmiyearvalidchars_cacheexceptions" */
  insert_WMIYearValidChars_CacheExceptions_one?: Maybe<WmiYearValidChars_CacheExceptions_Vpic>;
  /** insert a single row into the table: "vpic.wmiyearvalidchars" */
  insert_WMIYearValidChars_one?: Maybe<WmiYearValidChars_Vpic>;
  /** insert data into the table: "vpic.wheelbasetype" */
  insert_WheelBaseType?: Maybe<WheelBaseType_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.wheelbasetype" */
  insert_WheelBaseType_one?: Maybe<WheelBaseType_Vpic>;
  /** insert data into the table: "vpic.wheeliemitigation" */
  insert_WheelieMitigation?: Maybe<WheelieMitigation_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.wheeliemitigation" */
  insert_WheelieMitigation_one?: Maybe<WheelieMitigation_Vpic>;
  /** insert data into the table: "vpic.wmi" */
  insert_Wmi?: Maybe<Wmi_Mutation_Response_Vpic>;
  /** insert data into the table: "vpic.wmi_make" */
  insert_Wmi_Make?: Maybe<Wmi_Make_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.wmi_make" */
  insert_Wmi_Make_one?: Maybe<Wmi_Make_Vpic>;
  /** insert data into the table: "vpic.wmi_vinschema" */
  insert_Wmi_VinSchema?: Maybe<Wmi_VinSchema_Mutation_Response_Vpic>;
  /** insert a single row into the table: "vpic.wmi_vinschema" */
  insert_Wmi_VinSchema_one?: Maybe<Wmi_VinSchema_Vpic>;
  /** insert a single row into the table: "vpic.wmi" */
  insert_Wmi_one?: Maybe<Wmi_Vpic>;
  /** insert data into the table: "audit.message_formatter_config" */
  insert_audit_message_formatter_config?: Maybe<Audit_Message_Formatter_Config_Mutation_Response>;
  /** insert a single row into the table: "audit.message_formatter_config" */
  insert_audit_message_formatter_config_one?: Maybe<Audit_Message_Formatter_Config>;
  /** insert data into the table: "auth.group" */
  insert_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** insert data into the table: "auth.group_actions" */
  insert_auth_group_actions?: Maybe<Auth_Group_Actions_Mutation_Response>;
  /** insert a single row into the table: "auth.group_actions" */
  insert_auth_group_actions_one?: Maybe<Auth_Group_Actions>;
  /** insert a single row into the table: "auth.group" */
  insert_auth_group_one?: Maybe<Auth_Group>;
  /** insert data into the table: "claims.pre_authorization_vehicle_information" */
  insert_claims_pre_authorization_vehicle_information?: Maybe<Claims_Pre_Authorization_Vehicle_Information_Mutation_Response>;
  /** insert a single row into the table: "claims.pre_authorization_vehicle_information" */
  insert_claims_pre_authorization_vehicle_information_one?: Maybe<Claims_Pre_Authorization_Vehicle_Information>;
  /** insert data into the table: "claims.temp_claims_auth_table" */
  insert_claims_temp_claims_auth_table?: Maybe<Claims_Temp_Claims_Auth_Table_Mutation_Response>;
  /** insert a single row into the table: "claims.temp_claims_auth_table" */
  insert_claims_temp_claims_auth_table_one?: Maybe<Claims_Temp_Claims_Auth_Table>;
  /** insert data into the table: "nhtsa.concern_synonym" */
  insert_concernSynonym?: Maybe<ConcernSynonym_Mutation_Response_Nhtsa>;
  /** insert a single row into the table: "nhtsa.concern_synonym" */
  insert_concernSynonym_one?: Maybe<ConcernSynonym_Nhtsa>;
  /** insert data into the table: "identities" */
  insert_identities?: Maybe<Identities_Mutation_Response>;
  /** insert a single row into the table: "identities" */
  insert_identities_one?: Maybe<Identities>;
  /** insert data into the table: "auth.identity_capability_view" */
  insert_identityCapabilityView?: Maybe<IdentityCapabilityView_Mutation_Response>;
  /** insert a single row into the table: "auth.identity_capability_view" */
  insert_identityCapabilityView_one?: Maybe<IdentityCapabilityView>;
  /** insert data into the table: "nhtsa.investigation_recall" */
  insert_investigationRecall?: Maybe<InvestigationRecall_Mutation_Response_Nhtsa>;
  /** insert a single row into the table: "nhtsa.investigation_recall" */
  insert_investigationRecall_one?: Maybe<InvestigationRecall_Nhtsa>;
  /** insert data into the table: "nhtsa.issue" */
  insert_issue?: Maybe<Issue_Mutation_Response_Nhtsa>;
  /** insert data into the table: "nhtsa.issue_make_model" */
  insert_issueMakeModel?: Maybe<IssueMakeModel_Mutation_Response_Nhtsa>;
  /** insert a single row into the table: "nhtsa.issue_make_model" */
  insert_issueMakeModel_one?: Maybe<IssueMakeModel_Nhtsa>;
  /** insert data into the table: "nhtsa.issue_search_result" */
  insert_issueSearchResult?: Maybe<IssueSearchResult_Mutation_Response_Nhtsa>;
  /** insert a single row into the table: "nhtsa.issue_search_result" */
  insert_issueSearchResult_one?: Maybe<IssueSearchResult_Nhtsa>;
  /** insert a single row into the table: "nhtsa.issue" */
  insert_issue_one?: Maybe<Issue_Nhtsa>;
  /** insert data into the table: "nhtsa.load" */
  insert_load?: Maybe<Load_Mutation_Response_Nhtsa>;
  /** insert a single row into the table: "nhtsa.load" */
  insert_load_one?: Maybe<Load_Nhtsa>;
  /** insert data into the table: "nhtsa.make_model" */
  insert_makeModel?: Maybe<MakeModel_Mutation_Response_Nhtsa>;
  /** insert a single row into the table: "nhtsa.make_model" */
  insert_makeModel_one?: Maybe<MakeModel_Nhtsa>;
  /** insert data into the table: "nhtsa.model_year_model" */
  insert_modelYearModel?: Maybe<ModelYearModel_Mutation_Response_Nhtsa>;
  /** insert a single row into the table: "nhtsa.model_year_model" */
  insert_modelYearModel_one?: Maybe<ModelYearModel_Nhtsa>;
  /** insert data into the table: "operations.legacy_policy_contract_cost_detail_view" */
  insert_operations_legacy_policy_contract_cost_detail_view?: Maybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Mutation_Response>;
  /** insert a single row into the table: "operations.legacy_policy_contract_cost_detail_view" */
  insert_operations_legacy_policy_contract_cost_detail_view_one?: Maybe<Operations_Legacy_Policy_Contract_Cost_Detail_View>;
  /** insert data into the table: "nhtsa.record_type" */
  insert_recordType?: Maybe<RecordType_Mutation_Response_Nhtsa>;
  /** insert a single row into the table: "nhtsa.record_type" */
  insert_recordType_one?: Maybe<RecordType_Nhtsa>;
  /** insert data into the table: "shared.search_result" */
  insert_shared_search_result?: Maybe<Shared_Search_Result_Mutation_Response>;
  /** insert a single row into the table: "shared.search_result" */
  insert_shared_search_result_one?: Maybe<Shared_Search_Result>;
  /** insert data into the table: "vwVehicleClassingBodyStyle" */
  insert_vehicleClassingBodyStyle?: Maybe<VehicleClassingBodyStyle_Mutation_Response>;
  /** insert a single row into the table: "vwVehicleClassingBodyStyle" */
  insert_vehicleClassingBodyStyle_one?: Maybe<VehicleClassingBodyStyle>;
  /** insert data into the table: "vwVehicleClassingFuelType" */
  insert_vehicleClassingFuelType?: Maybe<VehicleClassingFuelType_Mutation_Response>;
  /** insert a single row into the table: "vwVehicleClassingFuelType" */
  insert_vehicleClassingFuelType_one?: Maybe<VehicleClassingFuelType>;
  /** insert data into the table: "vwVehicleClassingVehicleMake" */
  insert_vehicleClassingVehicleMake?: Maybe<VehicleClassingVehicleMake_Mutation_Response>;
  /** insert a single row into the table: "vwVehicleClassingVehicleMake" */
  insert_vehicleClassingVehicleMake_one?: Maybe<VehicleClassingVehicleMake>;
  /** insert data into the table: "vwVehicleClassingVehicleType" */
  insert_vehicleClassingVehicleType?: Maybe<VehicleClassingVehicleType_Mutation_Response>;
  /** insert a single row into the table: "vwVehicleClassingVehicleType" */
  insert_vehicleClassingVehicleType_one?: Maybe<VehicleClassingVehicleType>;
  /** insert data into the table: "vwVehicleCylindersDistinct" */
  insert_vwVehicleCylindersDistinct?: Maybe<VwVehicleCylindersDistinct_Mutation_Response>;
  /** insert a single row into the table: "vwVehicleCylindersDistinct" */
  insert_vwVehicleCylindersDistinct_one?: Maybe<VwVehicleCylindersDistinct>;
  /** insert data into the table: "vwVehicleDrivingWheelsDistinct" */
  insert_vwVehicleDrivingWheelsDistinct?: Maybe<VwVehicleDrivingWheelsDistinct_Mutation_Response>;
  /** insert a single row into the table: "vwVehicleDrivingWheelsDistinct" */
  insert_vwVehicleDrivingWheelsDistinct_one?: Maybe<VwVehicleDrivingWheelsDistinct>;
  /** insert data into the table: "vwVehicleFuelTypesDistinct" */
  insert_vwVehicleFuelTypesDistinct?: Maybe<VwVehicleFuelTypesDistinct_Mutation_Response>;
  /** insert a single row into the table: "vwVehicleFuelTypesDistinct" */
  insert_vwVehicleFuelTypesDistinct_one?: Maybe<VwVehicleFuelTypesDistinct>;
  /** insert data into the table: "vwVehicleMakesDistinct" */
  insert_vwVehicleMakesDistinct?: Maybe<VwVehicleMakesDistinct_Mutation_Response>;
  /** insert a single row into the table: "vwVehicleMakesDistinct" */
  insert_vwVehicleMakesDistinct_one?: Maybe<VwVehicleMakesDistinct>;
  /** insert data into the table: "vwVehicleModelsDistinct" */
  insert_vwVehicleModelsDistinct?: Maybe<VwVehicleModelsDistinct_Mutation_Response>;
  /** insert a single row into the table: "vwVehicleModelsDistinct" */
  insert_vwVehicleModelsDistinct_one?: Maybe<VwVehicleModelsDistinct>;
  /** insert data into the table: "vwVehicleYearsDistinct" */
  insert_vwVehicleYearsDistinct?: Maybe<VwVehicleYearsDistinct_Mutation_Response>;
  /** insert a single row into the table: "vwVehicleYearsDistinct" */
  insert_vwVehicleYearsDistinct_one?: Maybe<VwVehicleYearsDistinct>;
  /** delete single row from the table: "dealer" */
  legacy_claims_deleteDealer?: Maybe<Legacy_Claims_Dealer>;
  /** delete data from the table: "dealer" */
  legacy_claims_deleteDealers?: Maybe<Legacy_Claims_Dealer_Mutation_Response>;
  /** delete single row from the table: "note" */
  legacy_claims_deleteNote?: Maybe<Legacy_Claims_Note>;
  /** delete data from the table: "note" */
  legacy_claims_deleteNotes?: Maybe<Legacy_Claims_Note_Mutation_Response>;
  /** insert a single row into the table: "dealer" */
  legacy_claims_insertDealer?: Maybe<Legacy_Claims_Dealer>;
  /** insert data into the table: "dealer" */
  legacy_claims_insertDealers?: Maybe<Legacy_Claims_Dealer_Mutation_Response>;
  /** insert a single row into the table: "note" */
  legacy_claims_insertNote?: Maybe<Legacy_Claims_Note>;
  /** insert data into the table: "note" */
  legacy_claims_insertNotes?: Maybe<Legacy_Claims_Note_Mutation_Response>;
  /** update single row of the table: "dealer" */
  legacy_claims_updateDealer?: Maybe<Legacy_Claims_Dealer>;
  /** update data of the table: "dealer" */
  legacy_claims_updateDealers?: Maybe<Legacy_Claims_Dealer_Mutation_Response>;
  /** update single row of the table: "note" */
  legacy_claims_updateNote?: Maybe<Legacy_Claims_Note>;
  /** update data of the table: "note" */
  legacy_claims_updateNotes?: Maybe<Legacy_Claims_Note_Mutation_Response>;
  saveRateQuoteAction: Scalars['uuid'];
  /** update single row of the table: "account" */
  updateAccount?: Maybe<Account>;
  /** update single row of the table: "account_account_manager" */
  updateAccountAccountManager?: Maybe<AccountAccountManager>;
  /** update data of the table: "account_account_manager" */
  updateAccountAccountManagers?: Maybe<AccountAccountManager_Mutation_Response>;
  /** update data of the table: "account_category" */
  updateAccountCategories?: Maybe<AccountCategory_Mutation_Response>;
  /** update single row of the table: "account_category" */
  updateAccountCategory?: Maybe<AccountCategory>;
  /** update single row of the table: "account_disbursement" */
  updateAccountDisbursement?: Maybe<AccountDisbursement>;
  /** update data of the table: "account_disbursement" */
  updateAccountDisbursements?: Maybe<AccountDisbursement_Mutation_Response>;
  /** update single row of the table: "account_manager" */
  updateAccountManager?: Maybe<AccountManager>;
  /** update data of the table: "account_manager" */
  updateAccountManagers?: Maybe<AccountManager_Mutation_Response>;
  /** update single row of the table: "account_obligor" */
  updateAccountObligor?: Maybe<AccountObligor>;
  /** update data of the table: "account_obligor" */
  updateAccountObligors?: Maybe<AccountObligor_Mutation_Response>;
  /** update single row of the table: "account_product" */
  updateAccountProduct?: Maybe<AccountProduct>;
  /** update single row of the table: "account_product_obligor" */
  updateAccountProductObligor?: Maybe<AccountProductObligor>;
  /** update data of the table: "account_product_obligor" */
  updateAccountProductObligors?: Maybe<AccountProductObligor_Mutation_Response>;
  /** update data of the table: "account_product" */
  updateAccountProducts?: Maybe<AccountProduct_Mutation_Response>;
  /** update single row of the table: "account_retail" */
  updateAccountRetail?: Maybe<AccountRetail>;
  /** update data of the table: "account_retail" */
  updateAccountRetails?: Maybe<AccountRetail_Mutation_Response>;
  /** update single row of the table: "account_type" */
  updateAccountType?: Maybe<AccountType>;
  /** update data of the table: "account_type" */
  updateAccountTypes?: Maybe<AccountType_Mutation_Response>;
  /** update data of the table: "account" */
  updateAccounts?: Maybe<Account_Mutation_Response>;
  /** update single row of the table: "address" */
  updateAddress?: Maybe<Address>;
  /** update single row of the table: "address_type" */
  updateAddressType?: Maybe<AddressType>;
  /** update data of the table: "address_type" */
  updateAddressTypes?: Maybe<AddressType_Mutation_Response>;
  /** update data of the table: "address" */
  updateAddresses?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "shared.alert" */
  updateAlert?: Maybe<Alert>;
  /** update single row of the table: "shared.alert_acknowledgment" */
  updateAlertAcknowledgment?: Maybe<AlertAcknowledgment>;
  /** update data of the table: "shared.alert_acknowledgment" */
  updateAlertAcknowledgments?: Maybe<AlertAcknowledgment_Mutation_Response>;
  /** update data of the table: "shared.alert" */
  updateAlerts?: Maybe<Alert_Mutation_Response>;
  /** update single row of the table: "auth.application" */
  updateApplication?: Maybe<Application>;
  /** update single row of the table: "users.application_preference" */
  updateApplicationPreference?: Maybe<ApplicationPreference>;
  /** update data of the table: "users.application_preference" */
  updateApplicationPreferences?: Maybe<ApplicationPreference_Mutation_Response>;
  /** update data of the table: "auth.application" */
  updateApplications?: Maybe<Application_Mutation_Response>;
  /** update single row of the table: "approvals.approval" */
  updateApproval?: Maybe<Approval>;
  /** update data of the table: "approvals.authority" */
  updateApprovalAuthorities?: Maybe<ApprovalAuthority_Mutation_Response>;
  /** update single row of the table: "approvals.authority" */
  updateApprovalAuthority?: Maybe<ApprovalAuthority>;
  /** update single row of the table: "approvals.gate" */
  updateApprovalGate?: Maybe<ApprovalGate>;
  /** update single row of the table: "approvals.gate_binding" */
  updateApprovalGateBinding?: Maybe<ApprovalGateBinding>;
  /** update data of the table: "approvals.gate_binding" */
  updateApprovalGateBindings?: Maybe<ApprovalGateBinding_Mutation_Response>;
  /** update data of the table: "approvals.gate" */
  updateApprovalGates?: Maybe<ApprovalGate_Mutation_Response>;
  /** update data of the table: "approvals.approval" */
  updateApprovalRecords?: Maybe<Approval_Mutation_Response>;
  /** update single row of the table: "approvals.request" */
  updateApprovalRequest?: Maybe<ApprovalRequest>;
  /** update data of the table: "approvals.request" */
  updateApprovalRequests?: Maybe<ApprovalRequest_Mutation_Response>;
  /** update data of the table: "approvals.state" */
  updateApprovalStates?: Maybe<ApprovalState_Mutation_Response>;
  /** update single row of the table: "as400_data_sync" */
  updateAs400DataSync?: Maybe<As400DataSync>;
  /** update data of the table: "as400_data_sync" */
  updateAs400DataSyncs?: Maybe<As400DataSync_Mutation_Response>;
  /** update single row of the table: "shared.bank_account_type" */
  updateBankAccountType?: Maybe<BankAccountType>;
  /** update data of the table: "shared.bank_account_type" */
  updateBankAccountTypes?: Maybe<BankAccountType_Mutation_Response>;
  /** update single row of the table: "caddy.caddy" */
  updateCaddy?: Maybe<Caddy>;
  /** update single row of the table: "caddy.caddy_server_manager_log" */
  updateCaddyServerManagerLog?: Maybe<CaddyServerManagerLog>;
  /** update data of the table: "caddy.caddy_server_manager_log" */
  updateCaddyServerManagerLogs?: Maybe<CaddyServerManagerLog_Mutation_Response>;
  /** update data of the table: "caddy.caddy" */
  updateCaddys?: Maybe<Caddy_Mutation_Response>;
  /** update single row of the table: "compliance.cancel_rule" */
  updateCancelRule?: Maybe<CancelRule>;
  /** update single row of the table: "compliance.cancel_rule_fee" */
  updateCancelRuleFee?: Maybe<CancelRuleFee>;
  /** update data of the table: "compliance.cancel_rule_fee" */
  updateCancelRuleFees?: Maybe<CancelRuleFee_Mutation_Response>;
  /** update single row of the table: "compliance.cancel_rule_refund" */
  updateCancelRuleRefund?: Maybe<CancelRuleRefund>;
  /** update data of the table: "compliance.cancel_rule_refund" */
  updateCancelRuleRefunds?: Maybe<CancelRuleRefund_Mutation_Response>;
  /** update data of the table: "compliance.cancel_rule" */
  updateCancelRules?: Maybe<CancelRule_Mutation_Response>;
  /** update single row of the table: "operations.cancellation" */
  updateCancellation?: Maybe<Cancellation>;
  /** update single row of the table: "operations.cancellation_as400" */
  updateCancellationAs400?: Maybe<CancellationAs400>;
  /** update data of the table: "operations.cancellation_as400" */
  updateCancellationAs400s?: Maybe<CancellationAs400_Mutation_Response>;
  /** update data of the table: "operations.cancellation" */
  updateCancellations?: Maybe<Cancellation_Mutation_Response>;
  /** update data of the table: "auth.capability" */
  updateCapabilities?: Maybe<Capability_Mutation_Response>;
  /** update single row of the table: "auth.capability" */
  updateCapability?: Maybe<Capability>;
  /** update single row of the table: "auth.capability_config" */
  updateCapabilityConfig?: Maybe<CapabilityConfig>;
  /** update data of the table: "auth.capability_config" */
  updateCapabilityConfigs?: Maybe<CapabilityConfig_Mutation_Response>;
  /** update single row of the table: "auth.capability_route" */
  updateCapabilityRoute?: Maybe<CapabilityRoute>;
  /** update data of the table: "auth.capability_route" */
  updateCapabilityRoutes?: Maybe<CapabilityRoute_Mutation_Response>;
  /** update single row of the table: "users.card_layout" */
  updateCardLayout?: Maybe<CardLayout>;
  /** update data of the table: "users.card_layout" */
  updateCardLayouts?: Maybe<CardLayout_Mutation_Response>;
  /** update single row of the table: "carrier" */
  updateCarrier?: Maybe<Carrier>;
  /** update data of the table: "carrier" */
  updateCarriers?: Maybe<Carrier_Mutation_Response>;
  /** update data of the table: "category" */
  updateCategories?: Maybe<Category_Mutation_Response>;
  /** update single row of the table: "category" */
  updateCategory?: Maybe<Category>;
  /** update single row of the table: "category_product_attribute_type" */
  updateCategoryProductAttributeType?: Maybe<CategoryProductAttributeType>;
  /** update data of the table: "category_product_attribute_type" */
  updateCategoryProductAttributeTypes?: Maybe<CategoryProductAttributeType_Mutation_Response>;
  /** update single row of the table: "claim" */
  updateClaim?: Maybe<Claim>;
  /** update single row of the table: "claims.claim_detail" */
  updateClaimDetail?: Maybe<ClaimDetail>;
  /** update single row of the table: "claims.claim_detail_as400" */
  updateClaimDetailAs400?: Maybe<ClaimDetailAs400>;
  /** update data of the table: "claims.claim_detail_as400" */
  updateClaimDetailAs400s?: Maybe<ClaimDetailAs400_Mutation_Response>;
  /** update data of the table: "claims.claim_detail_category" */
  updateClaimDetailCategories?: Maybe<ClaimDetailCategory_Mutation_Response>;
  /** update single row of the table: "claims.claim_detail_category" */
  updateClaimDetailCategory?: Maybe<ClaimDetailCategory>;
  /** update single row of the table: "claims.claim_detail_deduction_as400" */
  updateClaimDetailDeductionAs400?: Maybe<ClaimDetailDeductionAs400>;
  /** update data of the table: "claims.claim_detail_deduction_as400" */
  updateClaimDetailDeductionAs400s?: Maybe<ClaimDetailDeductionAs400_Mutation_Response>;
  /** update single row of the table: "claims.claim_detail_part_lookup" */
  updateClaimDetailPartLookup?: Maybe<ClaimDetailPartLookup>;
  /** update data of the table: "claims.claim_detail_part_lookup" */
  updateClaimDetailPartLookups?: Maybe<ClaimDetailPartLookup_Mutation_Response>;
  /** update data of the table: "claims.claim_detail" */
  updateClaimDetails?: Maybe<ClaimDetail_Mutation_Response>;
  /** update single row of the table: "claims.claim_service_center" */
  updateClaimServiceCenter?: Maybe<ClaimServiceCenter>;
  /** update single row of the table: "claims.claim_service_center_as400" */
  updateClaimServiceCenterAs400?: Maybe<ClaimServiceCenterAs400>;
  /** update data of the table: "claims.claim_service_center_as400" */
  updateClaimServiceCenterAs400s?: Maybe<ClaimServiceCenterAs400_Mutation_Response>;
  /** update single row of the table: "claims.claim_service_center_authorization" */
  updateClaimServiceCenterAuthorization?: Maybe<ClaimServiceCenterAuthorization>;
  /** update data of the table: "claims.claim_service_center_authorization" */
  updateClaimServiceCenterAuthorizations?: Maybe<ClaimServiceCenterAuthorization_Mutation_Response>;
  /** update data of the table: "claims.claim_service_center" */
  updateClaimServiceCenters?: Maybe<ClaimServiceCenter_Mutation_Response>;
  /** update single row of the table: "ClaimStatus" */
  updateClaimStatus?: Maybe<ClaimStatus>;
  /** update single row of the table: "claim_status_type" */
  updateClaimStatusType?: Maybe<ClaimStatusType>;
  /** update data of the table: "claim_status_type" */
  updateClaimStatusTypes?: Maybe<ClaimStatusType_Mutation_Response>;
  /** update data of the table: "ClaimStatus" */
  updateClaimStatuses?: Maybe<ClaimStatus_Mutation_Response>;
  /** update data of the table: "claim" */
  updateClaims?: Maybe<Claim_Mutation_Response>;
  /** update data of the table: "ClaimsMaster" */
  updateClaimsMasters?: Maybe<ClaimsMaster_Mutation_Response>;
  /** update single row of the table: "classes.class_criteria" */
  updateClassCriteria?: Maybe<ClassCriteria>;
  /** update data of the table: "classes.class_criteria" */
  updateClassCriterias?: Maybe<ClassCriteria_Mutation_Response>;
  /** update single row of the table: "classes.class_guide" */
  updateClassGuide?: Maybe<ClassGuide>;
  /** update single row of the table: "classes.class_guide_class_criteria" */
  updateClassGuideClassCriteria?: Maybe<ClassGuideClassCriteria>;
  /** update data of the table: "classes.class_guide_class_criteria" */
  updateClassGuideClassCriterias?: Maybe<ClassGuideClassCriteria_Mutation_Response>;
  /** update single row of the table: "classes.class_guide_criteria_definition" */
  updateClassGuideCriteriaDefinition?: Maybe<ClassGuideCriteriaDefinition>;
  /** update data of the table: "classes.class_guide_criteria_definition" */
  updateClassGuideCriteriaDefinitions?: Maybe<ClassGuideCriteriaDefinition_Mutation_Response>;
  /** update single row of the table: "classes.class_guide_criteria_type" */
  updateClassGuideCriteriaType?: Maybe<ClassGuideCriteriaType>;
  /** update data of the table: "classes.class_guide_criteria_type" */
  updateClassGuideCriteriaTypes?: Maybe<ClassGuideCriteriaType_Mutation_Response>;
  /** update data of the table: "classes.class_guide" */
  updateClassGuides?: Maybe<ClassGuide_Mutation_Response>;
  /** update single row of the table: "composite_product" */
  updateCompositeProduct?: Maybe<CompositeProduct>;
  /** update data of the table: "composite_product" */
  updateCompositeProducts?: Maybe<CompositeProduct_Mutation_Response>;
  /** update single row of the table: "configuration_item" */
  updateConfigurationItem?: Maybe<ConfigurationItem>;
  /** update single row of the table: "configuration_item_type" */
  updateConfigurationItemType?: Maybe<ConfigurationItemType>;
  /** update data of the table: "configuration_item_type" */
  updateConfigurationItemTypes?: Maybe<ConfigurationItemType_Mutation_Response>;
  /** update data of the table: "configuration_item" */
  updateConfigurationItems?: Maybe<ConfigurationItem_Mutation_Response>;
  /** update single row of the table: "contact" */
  updateContact?: Maybe<Contact>;
  /** update data of the table: "contact" */
  updateContacts?: Maybe<Contact_Mutation_Response>;
  /** update single row of the table: "shared.content_type" */
  updateContentType?: Maybe<ContentType>;
  /** update data of the table: "shared.content_type" */
  updateContentTypes?: Maybe<ContentType_Mutation_Response>;
  /** update single row of the table: "contract" */
  updateContract?: Maybe<Contract>;
  /** update single row of the table: "compliance.contract_form" */
  updateContractForm?: Maybe<ContractForm>;
  /** update single row of the table: "compliance.contract_form_filing_status" */
  updateContractFormFilingStatus?: Maybe<ContractFormFilingStatus>;
  /** update data of the table: "compliance.contract_form_filing_status" */
  updateContractFormFilingStatuses?: Maybe<ContractFormFilingStatus_Mutation_Response>;
  /** update single row of the table: "compliance.contract_form_type" */
  updateContractFormType?: Maybe<ContractFormType>;
  /** update data of the table: "compliance.contract_form_type" */
  updateContractFormTypes?: Maybe<ContractFormType_Mutation_Response>;
  /** update single row of the table: "compliance.contract_form_version" */
  updateContractFormVersion?: Maybe<ContractFormVersion>;
  /** update single row of the table: "compliance.contract_form_version_legacy_file" */
  updateContractFormVersionLegacyFile?: Maybe<ContractFormVersionLegacyFile>;
  /** update data of the table: "compliance.contract_form_version_legacy_file" */
  updateContractFormVersionLegacyFiles?: Maybe<ContractFormVersionLegacyFile_Mutation_Response>;
  /** update data of the table: "compliance.contract_form_version" */
  updateContractFormVersions?: Maybe<ContractFormVersion_Mutation_Response>;
  /** update data of the table: "compliance.contract_form" */
  updateContractForms?: Maybe<ContractForm_Mutation_Response>;
  /** update single row of the table: "ContractMaster" */
  updateContractMaster?: Maybe<ContractMaster>;
  /** update data of the table: "ContractMasterAdditionalEntity" */
  updateContractMasterAdditionalEntities?: Maybe<ContractMasterAdditionalEntity_Mutation_Response>;
  /** update data of the table: "ContractMaster" */
  updateContractMasters?: Maybe<ContractMaster_Mutation_Response>;
  /** update single row of the table: "contract_status_type" */
  updateContractStatusType?: Maybe<ContractStatusType>;
  /** update data of the table: "contract_status_type" */
  updateContractStatusTypes?: Maybe<ContractStatusType_Mutation_Response>;
  /** update data of the table: "contract" */
  updateContracts?: Maybe<Contract_Mutation_Response>;
  /** update single row of the table: "cost_adjustment" */
  updateCostAdjustment?: Maybe<CostAdjustment>;
  /** update single row of the table: "cost_adjustment_extended_cost" */
  updateCostAdjustmentExtendedCost?: Maybe<CostAdjustmentExtendedCost>;
  /** update data of the table: "cost_adjustment_extended_cost" */
  updateCostAdjustmentExtendedCosts?: Maybe<CostAdjustmentExtendedCost_Mutation_Response>;
  /** update single row of the table: "cost_adjustment_lookup" */
  updateCostAdjustmentLookup?: Maybe<CostAdjustmentLookup>;
  /** update data of the table: "cost_adjustment_lookup" */
  updateCostAdjustmentLookups?: Maybe<CostAdjustmentLookup_Mutation_Response>;
  /** update single row of the table: "cost_adjustment_type" */
  updateCostAdjustmentType?: Maybe<CostAdjustmentType>;
  /** update data of the table: "cost_adjustment_type" */
  updateCostAdjustmentTypes?: Maybe<CostAdjustmentType_Mutation_Response>;
  /** update data of the table: "cost_adjustment" */
  updateCostAdjustments?: Maybe<CostAdjustment_Mutation_Response>;
  /** update single row of the table: "custom_field" */
  updateCustomField?: Maybe<CustomField>;
  /** update single row of the table: "custom_field_data" */
  updateCustomFieldData?: Maybe<CustomFieldData>;
  /** update data of the table: "custom_field_data" */
  updateCustomFieldDatas?: Maybe<CustomFieldData_Mutation_Response>;
  /** update single row of the table: "custom_field_type" */
  updateCustomFieldType?: Maybe<CustomFieldType>;
  /** update data of the table: "custom_field_type" */
  updateCustomFieldTypes?: Maybe<CustomFieldType_Mutation_Response>;
  /** update data of the table: "custom_field" */
  updateCustomFields?: Maybe<CustomField_Mutation_Response>;
  /** update single row of the table: "customer" */
  updateCustomer?: Maybe<Customer>;
  /** update data of the table: "customer" */
  updateCustomers?: Maybe<Customer_Mutation_Response>;
  /** update single row of the table: "accounting.cycle" */
  updateCycle?: Maybe<Cycle>;
  /** update data of the table: "accounting.cycle_journal_entry" */
  updateCycleJournalEntries?: Maybe<CycleJournalEntry_Mutation_Response>;
  /** update single row of the table: "accounting.cycle_journal_entry" */
  updateCycleJournalEntry?: Maybe<CycleJournalEntry>;
  /** update single row of the table: "accounting.cycle_total" */
  updateCycleTotal?: Maybe<CycleTotal>;
  /** update data of the table: "accounting.cycle_total" */
  updateCycleTotals?: Maybe<CycleTotal_Mutation_Response>;
  /** update data of the table: "accounting.cycle" */
  updateCycles?: Maybe<Cycle_Mutation_Response>;
  /** update single row of the table: "data_type" */
  updateDataType?: Maybe<DataType>;
  /** update data of the table: "data_type" */
  updateDataTypes?: Maybe<DataType_Mutation_Response>;
  /** update single row of the table: "date_calculation_type" */
  updateDateCalculationType?: Maybe<DateCalculationType>;
  /** update data of the table: "date_calculation_type" */
  updateDateCalculationTypes?: Maybe<DateCalculationType_Mutation_Response>;
  /** update single row of the table: "Dealer" */
  updateDealer?: Maybe<Dealer>;
  /** update single row of the table: "dealer_payment_type" */
  updateDealerPaymentType?: Maybe<DealerPaymentType>;
  /** update data of the table: "dealer_payment_type" */
  updateDealerPaymentTypes?: Maybe<DealerPaymentType_Mutation_Response>;
  /** update data of the table: "Dealer" */
  updateDealers?: Maybe<Dealer_Mutation_Response>;
  /** update single row of the table: "disbursement_type" */
  updateDisbursementType?: Maybe<DisbursementType>;
  /** update data of the table: "disbursement_type" */
  updateDisbursementTypes?: Maybe<DisbursementType_Mutation_Response>;
  /** update single row of the table: "claims.document" */
  updateDocument?: Maybe<Document>;
  /** update single row of the table: "shared.document_instance" */
  updateDocumentInstance?: Maybe<DocumentInstance>;
  /** update data of the table: "shared.document_instance" */
  updateDocumentInstances?: Maybe<DocumentInstance_Mutation_Response>;
  /** update single row of the table: "shared.document_template" */
  updateDocumentTemplate?: Maybe<DocumentTemplate>;
  /** update single row of the table: "shared.document_template_application" */
  updateDocumentTemplateApplication?: Maybe<DocumentTemplateApplication>;
  /** update data of the table: "shared.document_template_application" */
  updateDocumentTemplateApplications?: Maybe<DocumentTemplateApplication_Mutation_Response>;
  /** update data of the table: "shared.document_template" */
  updateDocumentTemplates?: Maybe<DocumentTemplate_Mutation_Response>;
  /** update data of the table: "claims.document" */
  updateDocuments?: Maybe<Document_Mutation_Response>;
  /** update single row of the table: "eligibility_rule" */
  updateEligibilityRule?: Maybe<EligibilityRule>;
  /** update single row of the table: "eligibility_rule_definition" */
  updateEligibilityRuleDefinition?: Maybe<EligibilityRuleDefinition>;
  /** update data of the table: "eligibility_rule_definition" */
  updateEligibilityRuleDefinitions?: Maybe<EligibilityRuleDefinition_Mutation_Response>;
  /** update data of the table: "eligibility_rule" */
  updateEligibilityRules?: Maybe<EligibilityRule_Mutation_Response>;
  /** update single row of the table: "eligibility_type" */
  updateEligibilityType?: Maybe<EligibilityType>;
  /** update data of the table: "eligibility_type" */
  updateEligibilityTypes?: Maybe<EligibilityType_Mutation_Response>;
  /** update single row of the table: "shared.entity_billing_information" */
  updateEntityBillingInformation?: Maybe<EntityBillingInformation>;
  /** update data of the table: "shared.entity_billing_information" */
  updateEntityBillingInformations?: Maybe<EntityBillingInformation_Mutation_Response>;
  /** update single row of the table: "entity_configuration_item" */
  updateEntityConfigurationItem?: Maybe<EntityConfigurationItem>;
  /** update data of the table: "entity_configuration_item" */
  updateEntityConfigurationItems?: Maybe<EntityConfigurationItem_Mutation_Response>;
  /** update single row of the table: "shared.entity_content_type" */
  updateEntityContentType?: Maybe<EntityContentType>;
  /** update data of the table: "shared.entity_content_type" */
  updateEntityContentTypes?: Maybe<EntityContentType_Mutation_Response>;
  /** update single row of the table: "entity_custom_field" */
  updateEntityCustomField?: Maybe<EntityCustomField>;
  /** update single row of the table: "entity_custom_field_value" */
  updateEntityCustomFieldValue?: Maybe<EntityCustomFieldValue>;
  /** update data of the table: "entity_custom_field_value" */
  updateEntityCustomFieldValues?: Maybe<EntityCustomFieldValue_Mutation_Response>;
  /** update data of the table: "entity_custom_field" */
  updateEntityCustomFields?: Maybe<EntityCustomField_Mutation_Response>;
  /** update single row of the table: "entity_data_definition" */
  updateEntityDataDefinition?: Maybe<EntityDataDefinition>;
  /** update data of the table: "entity_data_definition" */
  updateEntityDataDefinitions?: Maybe<EntityDataDefinition_Mutation_Response>;
  /** update single row of the table: "entity_eligibility_rule" */
  updateEntityEligibilityRule?: Maybe<EntityEligibilityRule>;
  /** update data of the table: "entity_eligibility_rule" */
  updateEntityEligibilityRules?: Maybe<EntityEligibilityRule_Mutation_Response>;
  /** update single row of the table: "shared.entity_feature" */
  updateEntityFeature?: Maybe<EntityFeature>;
  /** update data of the table: "shared.entity_feature" */
  updateEntityFeatures?: Maybe<EntityFeature_Mutation_Response>;
  /** update single row of the table: "shared.entity_file_content_type" */
  updateEntityFileContentType?: Maybe<EntityFileContentType>;
  /** update data of the table: "shared.entity_file_content_type" */
  updateEntityFileContentTypes?: Maybe<EntityFileContentType_Mutation_Response>;
  /** update single row of the table: "shared.entity_file_storage" */
  updateEntityFileStorage?: Maybe<EntityFileStorage>;
  /** update data of the table: "shared.entity_file_storage" */
  updateEntityFileStorages?: Maybe<EntityFileStorage_Mutation_Response>;
  /** update single row of the table: "shared.entity_note" */
  updateEntityNote?: Maybe<EntityNote>;
  /** update data of the table: "shared.entity_note" */
  updateEntityNotes?: Maybe<EntityNote_Mutation_Response>;
  /** update single row of the table: "entity_offering" */
  updateEntityOffering?: Maybe<EntityOffering>;
  /** update data of the table: "entity_offering" */
  updateEntityOfferings?: Maybe<EntityOffering_Mutation_Response>;
  /** update single row of the table: "shared.entity_remittance_detail" */
  updateEntityRemittanceDetail?: Maybe<EntityRemittanceDetail>;
  /** update data of the table: "shared.entity_remittance_detail" */
  updateEntityRemittanceDetails?: Maybe<EntityRemittanceDetail_Mutation_Response>;
  /** update single row of the table: "shared.entity_tag" */
  updateEntityTag?: Maybe<EntityTag>;
  /** update data of the table: "shared.entity_tag" */
  updateEntityTags?: Maybe<EntityTag_Mutation_Response>;
  /** update single row of the table: "shared.feature" */
  updateFeature?: Maybe<Feature>;
  /** update data of the table: "shared.feature" */
  updateFeatures?: Maybe<Feature_Mutation_Response>;
  /** update single row of the table: "shared.file_storage" */
  updateFileStorage?: Maybe<FileStorage>;
  /** update single row of the table: "shared.file_storage_type" */
  updateFileStorageType?: Maybe<FileStorageType>;
  /** update data of the table: "shared.file_storage_type" */
  updateFileStorageTypes?: Maybe<FileStorageType_Mutation_Response>;
  /** update data of the table: "shared.file_storage" */
  updateFileStorages?: Maybe<FileStorage_Mutation_Response>;
  /** update single row of the table: "compliance.filing_lender" */
  updateFilingLender?: Maybe<FilingLender>;
  /** update single row of the table: "compliance.filing_lender_match" */
  updateFilingLenderMatch?: Maybe<FilingLenderMatch>;
  /** update data of the table: "compliance.filing_lender_match" */
  updateFilingLenderMatches?: Maybe<FilingLenderMatch_Mutation_Response>;
  /** update data of the table: "compliance.filing_lender" */
  updateFilingLenders?: Maybe<FilingLender_Mutation_Response>;
  /** update single row of the table: "compliance.filing_state" */
  updateFilingState?: Maybe<FilingState>;
  /** update data of the table: "compliance.filing_state" */
  updateFilingStates?: Maybe<FilingState_Mutation_Response>;
  /** update single row of the table: "compliance.filing_status_type" */
  updateFilingStatusType?: Maybe<FilingStatusType>;
  /** update data of the table: "compliance.filing_status_type" */
  updateFilingStatusTypes?: Maybe<FilingStatusType_Mutation_Response>;
  /** update single row of the table: "auth.flow_item" */
  updateFlowItem?: Maybe<FlowItem>;
  /** update single row of the table: "auth.flow_item_type" */
  updateFlowItemType?: Maybe<FlowItemType>;
  /** update data of the table: "auth.flow_item_type" */
  updateFlowItemTypes?: Maybe<FlowItemType_Mutation_Response>;
  /** update data of the table: "auth.flow_item" */
  updateFlowItems?: Maybe<FlowItem_Mutation_Response>;
  /** update single row of the table: "auth.flow_type" */
  updateFlowType?: Maybe<FlowType>;
  /** update data of the table: "auth.flow_type" */
  updateFlowTypes?: Maybe<FlowType_Mutation_Response>;
  /** update data of the table: "ory.identity" */
  updateIdentities?: Maybe<Identity_Mutation_Response>;
  /** update multiples rows of table: "ory.identity" */
  updateIdentitiesMany?: Maybe<Array<Maybe<Identity_Mutation_Response>>>;
  /** update single row of the table: "ory.identity" */
  updateIdentity?: Maybe<Identity>;
  /** update single row of the table: "ory.identity_as400" */
  updateIdentityAs400?: Maybe<IdentityAs400>;
  /** update data of the table: "ory.identity_as400" */
  updateIdentityAs400s?: Maybe<IdentityAs400_Mutation_Response>;
  /** update data of the table: "auth.identity_capability" */
  updateIdentityCapabilities?: Maybe<IdentityCapability_Mutation_Response>;
  /** update single row of the table: "auth.identity_capability" */
  updateIdentityCapability?: Maybe<IdentityCapability>;
  /** update data of the table: "auth.identity_entity" */
  updateIdentityEntities?: Maybe<IdentityEntity_Mutation_Response>;
  /** update single row of the table: "auth.identity_entity" */
  updateIdentityEntity?: Maybe<IdentityEntity>;
  /** update single row of the table: "auth.identity_filter" */
  updateIdentityFilter?: Maybe<IdentityFilter>;
  /** update data of the table: "auth.identity_filter" */
  updateIdentityFilters?: Maybe<IdentityFilter_Mutation_Response>;
  /** update single row of the table: "claims.invoice" */
  updateInvoice?: Maybe<Invoice>;
  /** update single row of the table: "claims.invoice_document_type" */
  updateInvoiceDocumentType?: Maybe<InvoiceDocumentType>;
  /** update data of the table: "claims.invoice_document_type" */
  updateInvoiceDocumentTypes?: Maybe<InvoiceDocumentType_Mutation_Response>;
  /** update single row of the table: "claims.invoice_payment_type" */
  updateInvoicePaymentType?: Maybe<InvoicePaymentType>;
  /** update data of the table: "claims.invoice_payment_type" */
  updateInvoicePaymentTypes?: Maybe<InvoicePaymentType_Mutation_Response>;
  /** update data of the table: "claims.invoice" */
  updateInvoices?: Maybe<Invoice_Mutation_Response>;
  /** update single row of the table: "system.job" */
  updateJob?: Maybe<Job>;
  /** update data of the table: "system.job_history" */
  updateJobHistories?: Maybe<JobHistory_Mutation_Response>;
  /** update single row of the table: "system.job_history" */
  updateJobHistory?: Maybe<JobHistory>;
  /** update single row of the table: "system.job_history_log" */
  updateJobHistoryLog?: Maybe<JobHistoryLog>;
  /** update data of the table: "system.job_history_log" */
  updateJobHistoryLogs?: Maybe<JobHistoryLog_Mutation_Response>;
  /** update single row of the table: "system.job_schedule" */
  updateJobSchedule?: Maybe<JobSchedule>;
  /** update data of the table: "system.job_schedule" */
  updateJobSchedules?: Maybe<JobSchedule_Mutation_Response>;
  /** update single row of the table: "system.job_step" */
  updateJobStep?: Maybe<JobStep>;
  /** update data of the table: "system.job_step" */
  updateJobSteps?: Maybe<JobStep_Mutation_Response>;
  /** update data of the table: "system.job" */
  updateJobs?: Maybe<Job_Mutation_Response>;
  /** update data of the table: "accounting.journal_entry" */
  updateJournalEntries?: Maybe<JournalEntry_Mutation_Response>;
  /** update single row of the table: "accounting.journal_entry" */
  updateJournalEntry?: Maybe<JournalEntry>;
  /** update single row of the table: "accounting.journal_entry_line" */
  updateJournalEntryLine?: Maybe<JournalEntryLine>;
  /** update data of the table: "accounting.journal_entry_line" */
  updateJournalEntryLines?: Maybe<JournalEntryLine_Mutation_Response>;
  /** update single row of the table: "labor_guide_type" */
  updateLaborGuideType?: Maybe<LaborGuideType>;
  /** update data of the table: "labor_guide_type" */
  updateLaborGuideTypes?: Maybe<LaborGuideType_Mutation_Response>;
  /** update single row of the table: "claims.labor_rate" */
  updateLaborRate?: Maybe<LaborRate>;
  /** update single row of the table: "claims.labor_rate_as400" */
  updateLaborRateAs400?: Maybe<LaborRateAs400>;
  /** update data of the table: "claims.labor_rate_as400" */
  updateLaborRateAs400s?: Maybe<LaborRateAs400_Mutation_Response>;
  /** update data of the table: "claims.labor_rate" */
  updateLaborRates?: Maybe<LaborRate_Mutation_Response>;
  /** update single row of the table: "operations.legacy_policy_contract" */
  updateLegacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** update data of the table: "operations.legacy_policy_contract" */
  updateLegacyPolicyContracts?: Maybe<LegacyPolicyContract_Mutation_Response>;
  /** update data of the table: "audit.logged_actions" */
  updateLoggedActions?: Maybe<LoggedAction_Mutation_Response>;
  /** update single row of the table: "reporting.loss_ratio" */
  updateLossRatio?: Maybe<LossRatio>;
  /** update data of the table: "reporting.loss_ratio" */
  updateLossRatios?: Maybe<LossRatio_Mutation_Response>;
  /** update multiples rows of table: "shared.entity_feature" */
  updateManuEntityFeatures?: Maybe<Array<Maybe<EntityFeature_Mutation_Response>>>;
  /** update multiples rows of table: "account_obligor" */
  updateManyAccountObligors?: Maybe<Array<Maybe<AccountObligor_Mutation_Response>>>;
  /** update multiples rows of table: "shared.alert_acknowledgment" */
  updateManyAlertAcknowledgments?: Maybe<Array<Maybe<AlertAcknowledgment_Mutation_Response>>>;
  /** update multiples rows of table: "shared.alert" */
  updateManyAlerts?: Maybe<Array<Maybe<Alert_Mutation_Response>>>;
  /** update multiples rows of table: "users.application_preference" */
  updateManyApplicationPreferences?: Maybe<Array<Maybe<ApplicationPreference_Mutation_Response>>>;
  /** update multiples rows of table: "auth.application" */
  updateManyApplications?: Maybe<Array<Maybe<Application_Mutation_Response>>>;
  /** update multiples rows of table: "shared.bank_account_type" */
  updateManyBankAccountTypes?: Maybe<Array<Maybe<BankAccountType_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.cancel_rule_fee" */
  updateManyCancelRuleFees?: Maybe<Array<Maybe<CancelRuleFee_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.cancel_rule_refund" */
  updateManyCancelRuleRefunds?: Maybe<Array<Maybe<CancelRuleRefund_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.cancel_rule" */
  updateManyCancelRules?: Maybe<Array<Maybe<CancelRule_Mutation_Response>>>;
  /** update multiples rows of table: "operations.cancellation_as400" */
  updateManyCancellationAs400s?: Maybe<Array<Maybe<CancellationAs400_Mutation_Response>>>;
  /** update multiples rows of table: "users.card_layout" */
  updateManyCardLayouts?: Maybe<Array<Maybe<CardLayout_Mutation_Response>>>;
  /** update multiples rows of table: "claims.claim_detail_as400" */
  updateManyClaimDetailAs400s?: Maybe<Array<Maybe<ClaimDetailAs400_Mutation_Response>>>;
  /** update multiples rows of table: "claims.claim_detail_deduction_as400" */
  updateManyClaimDetailDeductionAs400s?: Maybe<Array<Maybe<ClaimDetailDeductionAs400_Mutation_Response>>>;
  /** update multiples rows of table: "claims.claim_detail_part_lookup" */
  updateManyClaimDetailPartLookups?: Maybe<Array<Maybe<ClaimDetailPartLookup_Mutation_Response>>>;
  /** update multiples rows of table: "claims.claim_detail" */
  updateManyClaimDetails?: Maybe<Array<Maybe<ClaimDetail_Mutation_Response>>>;
  /** update multiples rows of table: "claims.claim_service_center_as400" */
  updateManyClaimServiceCenterAs400s?: Maybe<Array<Maybe<ClaimServiceCenterAs400_Mutation_Response>>>;
  /** update multiples rows of table: "claims.claim_service_center_authorization" */
  updateManyClaimServiceCenterAuthorizations?: Maybe<Array<Maybe<ClaimServiceCenterAuthorization_Mutation_Response>>>;
  /** update multiples rows of table: "claims.claim_service_center" */
  updateManyClaimServiceCenters?: Maybe<Array<Maybe<ClaimServiceCenter_Mutation_Response>>>;
  /** update multiples rows of table: "composite_product" */
  updateManyCompositeProducts?: Maybe<Array<Maybe<CompositeProduct_Mutation_Response>>>;
  /** update multiples rows of table: "shared.content_type" */
  updateManyContentTypes?: Maybe<Array<Maybe<ContentType_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.contract_form_filing_status" */
  updateManyContractFormFilingStatuses?: Maybe<Array<Maybe<ContractFormFilingStatus_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.contract_form_version_legacy_file" */
  updateManyContractFormVersionLegacyFiles?: Maybe<Array<Maybe<ContractFormVersionLegacyFile_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.contract_form_version" */
  updateManyContractFormVersions?: Maybe<Array<Maybe<ContractFormVersion_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.contract_form" */
  updateManyContractForms?: Maybe<Array<Maybe<ContractForm_Mutation_Response>>>;
  /** update multiples rows of table: "accounting.cycle_journal_entry" */
  updateManyCycleJournalEntries?: Maybe<Array<Maybe<CycleJournalEntry_Mutation_Response>>>;
  /** update multiples rows of table: "accounting.cycle_total" */
  updateManyCycleTotals?: Maybe<Array<Maybe<CycleTotal_Mutation_Response>>>;
  /** update multiples rows of table: "accounting.cycle" */
  updateManyCycles?: Maybe<Array<Maybe<Cycle_Mutation_Response>>>;
  /** update multiples rows of table: "date_calculation_type" */
  updateManyDateCalculationTypes?: Maybe<Array<Maybe<DateCalculationType_Mutation_Response>>>;
  /** update multiples rows of table: "shared.document_instance" */
  updateManyDocumentInstances?: Maybe<Array<Maybe<DocumentInstance_Mutation_Response>>>;
  /** update multiples rows of table: "shared.document_template_application" */
  updateManyDocumentTemplateApplications?: Maybe<Array<Maybe<DocumentTemplateApplication_Mutation_Response>>>;
  /** update multiples rows of table: "shared.document_template" */
  updateManyDocumentTemplates?: Maybe<Array<Maybe<DocumentTemplate_Mutation_Response>>>;
  /** update multiples rows of table: "shared.entity_content_type" */
  updateManyEntityContentTypes?: Maybe<Array<Maybe<EntityContentType_Mutation_Response>>>;
  /** update multiples rows of table: "shared.entity_file_content_type" */
  updateManyEntityFileContentTypes?: Maybe<Array<Maybe<EntityFileContentType_Mutation_Response>>>;
  /** update multiples rows of table: "shared.feature" */
  updateManyFeatures?: Maybe<Array<Maybe<Feature_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.filing_lender_match" */
  updateManyFilingLenderMatches?: Maybe<Array<Maybe<FilingLenderMatch_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.filing_lender" */
  updateManyFilingLenders?: Maybe<Array<Maybe<FilingLender_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.filing_state" */
  updateManyFilingStates?: Maybe<Array<Maybe<FilingState_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.filing_status_type" */
  updateManyFilingStatusTypes?: Maybe<Array<Maybe<FilingStatusType_Mutation_Response>>>;
  /** update multiples rows of table: "auth.flow_item_type" */
  updateManyFlowItemTypes?: Maybe<Array<Maybe<FlowItemType_Mutation_Response>>>;
  /** update multiples rows of table: "auth.flow_item" */
  updateManyFlowItems?: Maybe<Array<Maybe<FlowItem_Mutation_Response>>>;
  /** update multiples rows of table: "auth.flow_type" */
  updateManyFlowTypes?: Maybe<Array<Maybe<FlowType_Mutation_Response>>>;
  /** update multiples rows of table: "ory.identity_as400" */
  updateManyIdentityAs400s?: Maybe<Array<Maybe<IdentityAs400_Mutation_Response>>>;
  /** update multiples rows of table: "auth.identity_filter" */
  updateManyIdentityFilters?: Maybe<Array<Maybe<IdentityFilter_Mutation_Response>>>;
  /** update multiples rows of table: "system.job_history" */
  updateManyJobHistories?: Maybe<Array<Maybe<JobHistory_Mutation_Response>>>;
  /** update multiples rows of table: "system.job_history_log" */
  updateManyJobHistoryLogs?: Maybe<Array<Maybe<JobHistoryLog_Mutation_Response>>>;
  /** update multiples rows of table: "system.job_schedule" */
  updateManyJobSchedule?: Maybe<Array<Maybe<JobSchedule_Mutation_Response>>>;
  /** update multiples rows of table: "system.job_step" */
  updateManyJobSteps?: Maybe<Array<Maybe<JobStep_Mutation_Response>>>;
  /** update multiples rows of table: "system.job" */
  updateManyJobs?: Maybe<Array<Maybe<Job_Mutation_Response>>>;
  /** update multiples rows of table: "accounting.journal_entry" */
  updateManyJournalEntries?: Maybe<Array<Maybe<JournalEntry_Mutation_Response>>>;
  /** update multiples rows of table: "accounting.journal_entry_line" */
  updateManyJournalEntryLines?: Maybe<Array<Maybe<JournalEntryLine_Mutation_Response>>>;
  /** update multiples rows of table: "claims.labor_rate_as400" */
  updateManyLaborRateAs400s?: Maybe<Array<Maybe<LaborRateAs400_Mutation_Response>>>;
  /** update multiples rows of table: "claims.labor_rate" */
  updateManyLaborRates?: Maybe<Array<Maybe<LaborRate_Mutation_Response>>>;
  /** update multiples rows of table: "operations.legacy_policy_contract" */
  updateManyLegacyPolicyContracts?: Maybe<Array<Maybe<LegacyPolicyContract_Mutation_Response>>>;
  /** update multiples rows of table: "reporting.loss_ratio" */
  updateManyLossRatios?: Maybe<Array<Maybe<LossRatio_Mutation_Response>>>;
  /** update multiples rows of table: "miles_calculation_type" */
  updateManyMilesCalculationTypes?: Maybe<Array<Maybe<MilesCalculationType_Mutation_Response>>>;
  /** update multiples rows of table: "system.outbox_event" */
  updateManyOutboxEvents?: Maybe<Array<Maybe<OutboxEvent_Mutation_Response>>>;
  /** update multiples rows of table: "shared.participant" */
  updateManyParticipants?: Maybe<Array<Maybe<Participant_Mutation_Response>>>;
  /** update multiples rows of table: "accounting.payee_as400" */
  updateManyPayeeAs400s?: Maybe<Array<Maybe<PayeeAs400_Mutation_Response>>>;
  /** update multiples rows of table: "shared.payment_as400" */
  updateManyPaymentAs400s?: Maybe<Array<Maybe<PaymentAs400_Mutation_Response>>>;
  /** update multiples rows of table: "shared.payment_method_type" */
  updateManyPaymentMethodTypes?: Maybe<Array<Maybe<PaymentMethodType_Mutation_Response>>>;
  /** update multiples rows of table: "shared.payment_type" */
  updateManyPaymentTypes?: Maybe<Array<Maybe<PaymentType_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy" */
  updateManyPolicies?: Maybe<Array<Maybe<Policy_Mutation_Response>>>;
  /** update multiples rows of table: "claims.policy_claim_as400" */
  updateManyPolicyClaimAs400s?: Maybe<Array<Maybe<PolicyClaimAs400_Mutation_Response>>>;
  /** update multiples rows of table: "claims.policy_claim_insurance" */
  updateManyPolicyClaimInsurances?: Maybe<Array<Maybe<PolicyClaimInsurance_Mutation_Response>>>;
  /** update multiples rows of table: "claims.policy_claim" */
  updateManyPolicyClaims?: Maybe<Array<Maybe<PolicyClaim_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_asset_type" */
  updateManyPolicyContractAssetTypes?: Maybe<Array<Maybe<PolicyContractAssetType_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_asset" */
  updateManyPolicyContractAssets?: Maybe<Array<Maybe<PolicyContractAsset_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_cost_detail" */
  updateManyPolicyContractCostDetails?: Maybe<Array<Maybe<PolicyContractCostDetail_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_lender" */
  updateManyPolicyContractLenders?: Maybe<Array<Maybe<PolicyContractLender_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_loan_contract_type" */
  updateManyPolicyContractLoanContractTypes?: Maybe<Array<Maybe<PolicyContractLoanContractType_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_owner" */
  updateManyPolicyContractOwners?: Maybe<Array<Maybe<PolicyContractOwner_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_product_cost_detail" */
  updateManyPolicyContractProductCostDetails?: Maybe<Array<Maybe<PolicyContractProductCostDetail_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_product" */
  updateManyPolicyContractProducts?: Maybe<Array<Maybe<PolicyContractProduct_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_quote" */
  updateManyPolicyContractQuotes?: Maybe<Array<Maybe<PolicyContractQuote_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_status_type" */
  updateManyPolicyContractStatusTypes?: Maybe<Array<Maybe<PolicyContractStatusType_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_void_reason_type" */
  updateManyPolicyContractVoidReasonTypes?: Maybe<Array<Maybe<PolicyContractVoidReasonType_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract" */
  updateManyPolicyContracts?: Maybe<Array<Maybe<PolicyContract_Mutation_Response>>>;
  /** update multiples rows of table: "claims.pre_authorization_status_type" */
  updateManyPreAuthorizationStatusTypes?: Maybe<Array<Maybe<PreAuthorizationStatusType_Mutation_Response>>>;
  /** update multiples rows of table: "claims.pre_authorization_type" */
  updateManyPreAuthorizationTypes?: Maybe<Array<Maybe<PreAuthorizationType_Mutation_Response>>>;
  /** update multiples rows of table: "claims.pre_authorization" */
  updateManyPreAuthorizations?: Maybe<Array<Maybe<PreAuthorization_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.product_contract_form" */
  updateManyProductContractForms?: Maybe<Array<Maybe<ProductContractForm_Mutation_Response>>>;
  /** update multiples rows of table: "users.profile" */
  updateManyProfiles?: Maybe<Array<Maybe<Profile_Mutation_Response>>>;
  /** update multiples rows of table: "quotes.quote_type" */
  updateManyQuoteTypes?: Maybe<Array<Maybe<QuoteType_Mutation_Response>>>;
  /** update multiples rows of table: "quotes.quote" */
  updateManyQuotes?: Maybe<Array<Maybe<Quote_Mutation_Response>>>;
  /** update multiples rows of table: "ui.rater_view_config" */
  updateManyRaterViewConfigs?: Maybe<Array<Maybe<RaterViewConfig_Mutation_Response>>>;
  /** update multiples rows of table: "system.reference_log" */
  updateManyReferenceLog?: Maybe<Array<Maybe<ReferenceLog_Mutation_Response>>>;
  /** update multiples rows of table: "claims.remittance_claim_detail" */
  updateManyRemittanceClaimDetails?: Maybe<Array<Maybe<RemittanceClaimDetail_Mutation_Response>>>;
  /** update multiples rows of table: "operations.remittance_policy_contract_as400" */
  updateManyRemittancePolicyContractAs400s?: Maybe<Array<Maybe<RemittancePolicyContractAs400_Mutation_Response>>>;
  /** update multiples rows of table: "operations.remittance_policy_contract" */
  updateManyRemittancePolicyContracts?: Maybe<Array<Maybe<RemittancePolicyContract_Mutation_Response>>>;
  /** update multiples rows of table: "operations.remittance_status_type" */
  updateManyRemittanceStatusTypes?: Maybe<Array<Maybe<RemittanceStatusType_Mutation_Response>>>;
  /** update multiples rows of table: "operations.remittance" */
  updateManyRemittances?: Maybe<Array<Maybe<Remittance_Mutation_Response>>>;
  /** update multiples rows of table: "claims.repeat_part_acknowledgment" */
  updateManyRepeatPartAcknowledgments?: Maybe<Array<Maybe<RepeatPartAcknowledgment_Mutation_Response>>>;
  /** update multiples rows of table: "claims.service_center" */
  updateManyServiceCenters?: Maybe<Array<Maybe<ServiceCenter_Mutation_Response>>>;
  /** update multiples rows of table: "system.severity_level_type" */
  updateManySeverityLevelType?: Maybe<Array<Maybe<SeverityLevelType_Mutation_Response>>>;
  /** update multiples rows of table: "users.shortcut_binding" */
  updateManyShortcutBindings?: Maybe<Array<Maybe<ShortcutBinding_Mutation_Response>>>;
  /** update multiples rows of table: "system.step_type" */
  updateManyStepTypes?: Maybe<Array<Maybe<StepType_Mutation_Response>>>;
  /** update multiples rows of table: "system.step" */
  updateManySteps?: Maybe<Array<Maybe<Step_Mutation_Response>>>;
  /** update multiples rows of table: "claims.tax_rate_as400" */
  updateManyTaxRateAs400s?: Maybe<Array<Maybe<TaxRateAs400_Mutation_Response>>>;
  /** update multiples rows of table: "claims.tax_rate" */
  updateManyTaxRates?: Maybe<Array<Maybe<TaxRate_Mutation_Response>>>;
  /** update multiples rows of table: "system.technology_type" */
  updateManyTechnologyTypes?: Maybe<Array<Maybe<TechnologyType_Mutation_Response>>>;
  /** update multiples rows of table: "shared.type_group" */
  updateManyTypeGroups?: Maybe<Array<Maybe<TypeGroup_Mutation_Response>>>;
  /** update multiples rows of table: "shared.type" */
  updateManyTypes?: Maybe<Array<Maybe<Type_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_flow_item_mfa" */
  updateManyUserFlowItemMfas?: Maybe<Array<Maybe<UserFlowItemMfa_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_flow_item" */
  updateManyUserFlowItems?: Maybe<Array<Maybe<UserFlowItem_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user" */
  updateManyUsers?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update multiples rows of table: "shared.validation_type_operation" */
  updateManyValidationTypeOperation?: Maybe<Array<Maybe<ValidationTypeOperation_Mutation_Response>>>;
  /** update multiples rows of table: "vehicle.vehicle_status_type" */
  updateManyVehicleStatusTypes?: Maybe<Array<Maybe<VehicleStatusType_Mutation_Response>>>;
  /** update multiples rows of table: "vehicle.vpic_decode_alternative" */
  updateManyVpicDecodeAlternatives?: Maybe<Array<Maybe<VpicDecodeAlternative_Mutation_Response>>>;
  /** update single row of the table: "miles_calculation_type" */
  updateMilesCalculationType?: Maybe<MilesCalculationType>;
  /** update data of the table: "miles_calculation_type" */
  updateMilesCalculationTypes?: Maybe<MilesCalculationType_Mutation_Response>;
  /** update single row of the table: "obligor" */
  updateObligor?: Maybe<Obligor>;
  /** update data of the table: "obligor" */
  updateObligors?: Maybe<Obligor_Mutation_Response>;
  /** update single row of the table: "job" */
  updateObsoleteJob?: Maybe<ObsoleteJob>;
  /** update data of the table: "job" */
  updateObsoleteJobs?: Maybe<ObsoleteJob_Mutation_Response>;
  /** update single row of the table: "system.outbox_event" */
  updateOutboxEvent?: Maybe<OutboxEvent>;
  /** update data of the table: "system.outbox_event" */
  updateOutboxEvents?: Maybe<OutboxEvent_Mutation_Response>;
  /** update single row of the table: "shared.participant" */
  updateParticipant?: Maybe<Participant>;
  /** update data of the table: "shared.participant" */
  updateParticipants?: Maybe<Participant_Mutation_Response>;
  /** update single row of the table: "accounting.payee" */
  updatePayee?: Maybe<Payee>;
  /** update single row of the table: "accounting.payee_as400" */
  updatePayeeAs400?: Maybe<PayeeAs400>;
  /** update data of the table: "accounting.payee_as400" */
  updatePayeeAs400s?: Maybe<PayeeAs400_Mutation_Response>;
  /** update data of the table: "accounting.payee" */
  updatePayees?: Maybe<Payee_Mutation_Response>;
  /** update single row of the table: "shared.payment" */
  updatePayment?: Maybe<Payment>;
  /** update single row of the table: "shared.payment_as400" */
  updatePaymentAs400?: Maybe<PaymentAs400>;
  /** update data of the table: "shared.payment_as400" */
  updatePaymentAs400s?: Maybe<PaymentAs400_Mutation_Response>;
  /** update single row of the table: "shared.payment_detail" */
  updatePaymentDetail?: Maybe<PaymentDetail>;
  /** update data of the table: "shared.payment_detail" */
  updatePaymentDetails?: Maybe<PaymentDetail_Mutation_Response>;
  /** update single row of the table: "shared.payment_method_type" */
  updatePaymentMethodType?: Maybe<PaymentMethodType>;
  /** update data of the table: "shared.payment_method_type" */
  updatePaymentMethodTypes?: Maybe<PaymentMethodType_Mutation_Response>;
  /** update single row of the table: "shared.payment_status_type" */
  updatePaymentStatusType?: Maybe<PaymentStatusType>;
  /** update data of the table: "shared.payment_status_type" */
  updatePaymentStatusTypes?: Maybe<PaymentStatusType_Mutation_Response>;
  /** update single row of the table: "shared.payment_type" */
  updatePaymentType?: Maybe<PaymentType>;
  /** update data of the table: "shared.payment_type" */
  updatePaymentTypes?: Maybe<PaymentType_Mutation_Response>;
  /** update data of the table: "shared.payment" */
  updatePayments?: Maybe<Payment_Mutation_Response>;
  /** update single row of the table: "Plan" */
  updatePlan?: Maybe<Plan>;
  /** update data of the table: "Plan" */
  updatePlans?: Maybe<Plan_Mutation_Response>;
  /** update data of the table: "operations.policy" */
  updatePolicies?: Maybe<Policy_Mutation_Response>;
  /** update single row of the table: "operations.policy" */
  updatePolicy?: Maybe<Policy>;
  /** update single row of the table: "claims.policy_claim" */
  updatePolicyClaim?: Maybe<PolicyClaim>;
  /** update single row of the table: "claims.policy_claim_as400" */
  updatePolicyClaimAs400?: Maybe<PolicyClaimAs400>;
  /** update data of the table: "claims.policy_claim_as400" */
  updatePolicyClaimAs400s?: Maybe<PolicyClaimAs400_Mutation_Response>;
  /** update single row of the table: "claims.policy_claim_concern" */
  updatePolicyClaimConcern?: Maybe<PolicyClaimConcern>;
  /** update data of the table: "claims.policy_claim_concern" */
  updatePolicyClaimConcerns?: Maybe<PolicyClaimConcern_Mutation_Response>;
  /** update single row of the table: "claims.policy_claim_insurance" */
  updatePolicyClaimInsurance?: Maybe<PolicyClaimInsurance>;
  /** update data of the table: "claims.policy_claim_insurance" */
  updatePolicyClaimInsurances?: Maybe<PolicyClaimInsurance_Mutation_Response>;
  /** update data of the table: "claims.policy_claim" */
  updatePolicyClaims?: Maybe<PolicyClaim_Mutation_Response>;
  /** update single row of the table: "operations.policy_contract" */
  updatePolicyContract?: Maybe<PolicyContract>;
  /** update single row of the table: "operations.policy_contract_asset" */
  updatePolicyContractAsset?: Maybe<PolicyContractAsset>;
  /** update single row of the table: "operations.policy_contract_asset_type" */
  updatePolicyContractAssetType?: Maybe<PolicyContractAssetType>;
  /** update data of the table: "operations.policy_contract_asset_type" */
  updatePolicyContractAssetTypes?: Maybe<PolicyContractAssetType_Mutation_Response>;
  /** update data of the table: "operations.policy_contract_asset" */
  updatePolicyContractAssets?: Maybe<PolicyContractAsset_Mutation_Response>;
  /** update single row of the table: "operations.policy_contract_contract_form_version" */
  updatePolicyContractContractFormVersion?: Maybe<PolicyContractContractFormVersion>;
  /** update data of the table: "operations.policy_contract_contract_form_version" */
  updatePolicyContractContractFormVersions?: Maybe<PolicyContractContractFormVersion_Mutation_Response>;
  /** update single row of the table: "operations.policy_contract_cost_detail" */
  updatePolicyContractCostDetail?: Maybe<PolicyContractCostDetail>;
  /** update data of the table: "operations.policy_contract_cost_detail" */
  updatePolicyContractCostDetails?: Maybe<PolicyContractCostDetail_Mutation_Response>;
  /** update single row of the table: "operations.policy_contract_lender" */
  updatePolicyContractLender?: Maybe<PolicyContractLender>;
  /** update data of the table: "operations.policy_contract_lender" */
  updatePolicyContractLenders?: Maybe<PolicyContractLender_Mutation_Response>;
  /** update single row of the table: "operations.policy_contract_loan_contract_type" */
  updatePolicyContractLoanContractType?: Maybe<PolicyContractLoanContractType>;
  /** update data of the table: "operations.policy_contract_loan_contract_type" */
  updatePolicyContractLoanContractTypes?: Maybe<PolicyContractLoanContractType_Mutation_Response>;
  /** update single row of the table: "operations.policy_contract_owner" */
  updatePolicyContractOwner?: Maybe<PolicyContractOwner>;
  /** update data of the table: "operations.policy_contract_owner" */
  updatePolicyContractOwners?: Maybe<PolicyContractOwner_Mutation_Response>;
  /** update single row of the table: "operations.policy_contract_product" */
  updatePolicyContractProduct?: Maybe<PolicyContractProduct>;
  /** update single row of the table: "operations.policy_contract_product_cost_detail" */
  updatePolicyContractProductCostDetail?: Maybe<PolicyContractProductCostDetail>;
  /** update data of the table: "operations.policy_contract_product_cost_detail" */
  updatePolicyContractProductCostDetails?: Maybe<PolicyContractProductCostDetail_Mutation_Response>;
  /** update data of the table: "operations.policy_contract_product" */
  updatePolicyContractProducts?: Maybe<PolicyContractProduct_Mutation_Response>;
  /** update single row of the table: "operations.policy_contract_quote" */
  updatePolicyContractQuote?: Maybe<PolicyContractQuote>;
  /** update data of the table: "operations.policy_contract_quote" */
  updatePolicyContractQuotes?: Maybe<PolicyContractQuote_Mutation_Response>;
  /** update single row of the table: "operations.policy_contract_status_type" */
  updatePolicyContractStatusType?: Maybe<PolicyContractStatusType>;
  /** update data of the table: "operations.policy_contract_status_type" */
  updatePolicyContractStatusTypes?: Maybe<PolicyContractStatusType_Mutation_Response>;
  /** update single row of the table: "operations.policy_contract_void_reason_type" */
  updatePolicyContractVoidReasonType?: Maybe<PolicyContractVoidReasonType>;
  /** update data of the table: "operations.policy_contract_void_reason_type" */
  updatePolicyContractVoidReasonTypes?: Maybe<PolicyContractVoidReasonType_Mutation_Response>;
  /** update data of the table: "operations.policy_contract" */
  updatePolicyContracts?: Maybe<PolicyContract_Mutation_Response>;
  /** update single row of the table: "claims.pre_authorization" */
  updatePreAuthorization?: Maybe<PreAuthorization>;
  /** update single row of the table: "claims.pre_authorization_status_type" */
  updatePreAuthorizationStatusType?: Maybe<PreAuthorizationStatusType>;
  /** update data of the table: "claims.pre_authorization_status_type" */
  updatePreAuthorizationStatusTypes?: Maybe<PreAuthorizationStatusType_Mutation_Response>;
  /** update single row of the table: "claims.pre_authorization_type" */
  updatePreAuthorizationType?: Maybe<PreAuthorizationType>;
  /** update data of the table: "claims.pre_authorization_type" */
  updatePreAuthorizationTypes?: Maybe<PreAuthorizationType_Mutation_Response>;
  /** update data of the table: "claims.pre_authorization" */
  updatePreAuthorizations?: Maybe<PreAuthorization_Mutation_Response>;
  /** update single row of the table: "product" */
  updateProduct?: Maybe<Product>;
  /** update single row of the table: "product_attribute" */
  updateProductAttribute?: Maybe<ProductAttribute>;
  /** update single row of the table: "product_attribute_type" */
  updateProductAttributeType?: Maybe<ProductAttributeType>;
  /** update data of the table: "product_attribute_type" */
  updateProductAttributeTypes?: Maybe<ProductAttributeType_Mutation_Response>;
  /** update data of the table: "product_attribute" */
  updateProductAttributes?: Maybe<ProductAttribute_Mutation_Response>;
  /** update single row of the table: "product_class_guide" */
  updateProductClassGuide?: Maybe<ProductClassGuide>;
  /** update data of the table: "product_class_guide" */
  updateProductClassGuides?: Maybe<ProductClassGuide_Mutation_Response>;
  /** update single row of the table: "compliance.product_contract_form" */
  updateProductContractForm?: Maybe<ProductContractForm>;
  /** update data of the table: "compliance.product_contract_form" */
  updateProductContractForms?: Maybe<ProductContractForm_Mutation_Response>;
  /** update single row of the table: "product_cost" */
  updateProductCost?: Maybe<ProductCost>;
  /** update data of the table: "product_cost" */
  updateProductCosts?: Maybe<ProductCost_Mutation_Response>;
  /** update single row of the table: "product_disbursement" */
  updateProductDisbursement?: Maybe<ProductDisbursement>;
  /** update data of the table: "product_disbursement" */
  updateProductDisbursements?: Maybe<ProductDisbursement_Mutation_Response>;
  /** update data of the table: "product_eligibility_rule" */
  updateProductEligibilities?: Maybe<ProductEligibility_Mutation_Response>;
  /** update single row of the table: "product_eligibility_rule" */
  updateProductEligibility?: Maybe<ProductEligibility>;
  /** update single row of the table: "product_obligor" */
  updateProductObligor?: Maybe<ProductObligor>;
  /** update data of the table: "product_obligor" */
  updateProductObligors?: Maybe<ProductObligor_Mutation_Response>;
  /** update single row of the table: "product_rate_bucket" */
  updateProductRateBucket?: Maybe<ProductRateBucket>;
  /** update data of the table: "product_rate_bucket" */
  updateProductRateBuckets?: Maybe<ProductRateBucket_Mutation_Response>;
  /** update single row of the table: "product_surcharge_type" */
  updateProductSurchargeType?: Maybe<ProductSurchargeType>;
  /** update data of the table: "product_surcharge_type" */
  updateProductSurchargeTypes?: Maybe<ProductSurchargeType_Mutation_Response>;
  /** update data of the table: "product" */
  updateProducts?: Maybe<Product_Mutation_Response>;
  /** update single row of the table: "users.profile" */
  updateProfile?: Maybe<Profile>;
  /** update data of the table: "users.profile" */
  updateProfiles?: Maybe<Profile_Mutation_Response>;
  /** update single row of the table: "quotes.quote" */
  updateQuote?: Maybe<Quote>;
  /** update data of the table: "quotes.quote_minimal_view" */
  updateQuoteMinimalViews?: Maybe<QuoteMinimalView_Mutation_Response>;
  /** update single row of the table: "quotes.quote_type" */
  updateQuoteType?: Maybe<QuoteType>;
  /** update data of the table: "quotes.quote_type" */
  updateQuoteTypes?: Maybe<QuoteType_Mutation_Response>;
  /** update data of the table: "quotes.quote" */
  updateQuotes?: Maybe<Quote_Mutation_Response>;
  /** update single row of the table: "rate_bucket_type" */
  updateRateBucketType?: Maybe<RateBucketType>;
  /** update data of the table: "rate_bucket_type" */
  updateRateBucketTypes?: Maybe<RateBucketType_Mutation_Response>;
  /** update single row of the table: "rate_quote" */
  updateRateQuote?: Maybe<RateQuote>;
  /** update data of the table: "rate_quote" */
  updateRateQuotes?: Maybe<RateQuote_Mutation_Response>;
  /** update single row of the table: "ui.rater_view_config" */
  updateRaterViewConfig?: Maybe<RaterViewConfig>;
  /** update data of the table: "ui.rater_view_config" */
  updateRaterViewConfigs?: Maybe<RaterViewConfig_Mutation_Response>;
  /** update single row of the table: "system.reference_log" */
  updateReferenceLog?: Maybe<ReferenceLog>;
  /** update data of the table: "system.reference_log" */
  updateReferenceLogs?: Maybe<ReferenceLog_Mutation_Response>;
  /** update single row of the table: "operations.remittance" */
  updateRemittance?: Maybe<Remittance>;
  /** update single row of the table: "claims.remittance_claim_detail" */
  updateRemittanceClaimDetail?: Maybe<RemittanceClaimDetail>;
  /** update data of the table: "claims.remittance_claim_detail" */
  updateRemittanceClaimDetails?: Maybe<RemittanceClaimDetail_Mutation_Response>;
  /** update single row of the table: "operations.remittance_payment" */
  updateRemittancePayment?: Maybe<RemittancePayment>;
  /** update data of the table: "operations.remittance_payment" */
  updateRemittancePayments?: Maybe<RemittancePayment_Mutation_Response>;
  /** update single row of the table: "operations.remittance_policy_contract" */
  updateRemittancePolicyContract?: Maybe<RemittancePolicyContract>;
  /** update single row of the table: "operations.remittance_policy_contract_as400" */
  updateRemittancePolicyContractAs400?: Maybe<RemittancePolicyContractAs400>;
  /** update data of the table: "operations.remittance_policy_contract_as400" */
  updateRemittancePolicyContractAs400s?: Maybe<RemittancePolicyContractAs400_Mutation_Response>;
  /** update data of the table: "operations.remittance_policy_contract" */
  updateRemittancePolicyContracts?: Maybe<RemittancePolicyContract_Mutation_Response>;
  /** update single row of the table: "operations.remittance_status_type" */
  updateRemittanceStatusType?: Maybe<RemittanceStatusType>;
  /** update data of the table: "operations.remittance_status_type" */
  updateRemittanceStatusTypes?: Maybe<RemittanceStatusType_Mutation_Response>;
  /** update single row of the table: "operations.remittance_type" */
  updateRemittanceType?: Maybe<RemittanceType>;
  /** update data of the table: "operations.remittance_type" */
  updateRemittanceTypes?: Maybe<RemittanceType_Mutation_Response>;
  /** update data of the table: "operations.remittance" */
  updateRemittances?: Maybe<Remittance_Mutation_Response>;
  /** update single row of the table: "claims.repeat_part_acknowledgment" */
  updateRepeatPartAcknowledgment?: Maybe<RepeatPartAcknowledgment>;
  /** update data of the table: "claims.repeat_part_acknowledgment" */
  updateRepeatPartAcknowledgments?: Maybe<RepeatPartAcknowledgment_Mutation_Response>;
  /** update single row of the table: "auth.role" */
  updateRole?: Maybe<Role>;
  /** update single row of the table: "auth.role_attribute" */
  updateRoleAttribute?: Maybe<RoleAttribute>;
  /** update data of the table: "auth.role_attribute" */
  updateRoleAttributes?: Maybe<RoleAttribute_Mutation_Response>;
  /** update data of the table: "auth.role" */
  updateRoles?: Maybe<Role_Mutation_Response>;
  /** update single row of the table: "auth.route" */
  updateRoute?: Maybe<Route>;
  /** update single row of the table: "auth.route_config" */
  updateRouteConfig?: Maybe<RouteConfig>;
  /** update data of the table: "auth.route_config" */
  updateRouteConfigs?: Maybe<RouteConfig_Mutation_Response>;
  /** update data of the table: "auth.route" */
  updateRoutes?: Maybe<Route_Mutation_Response>;
  /** update single row of the table: "shared.search_index" */
  updateSearchIndex?: Maybe<SearchIndex>;
  /** update data of the table: "shared.search_index" */
  updateSearchIndexes?: Maybe<SearchIndex_Mutation_Response>;
  /** update single row of the table: "state" */
  updateSelectState?: Maybe<State>;
  /** update data of the table: "state" */
  updateSelectStates?: Maybe<State_Mutation_Response>;
  /** update single row of the table: "claims.service_center" */
  updateServiceCenter?: Maybe<ServiceCenter>;
  /** update data of the table: "claims.service_center" */
  updateServiceCenters?: Maybe<ServiceCenter_Mutation_Response>;
  /** update single row of the table: "system.severity_level_type" */
  updateSeverityLevelType?: Maybe<SeverityLevelType>;
  /** update data of the table: "system.severity_level_type" */
  updateSeverityLevelTypes?: Maybe<SeverityLevelType_Mutation_Response>;
  /** update single row of the table: "users.shortcut_binding" */
  updateShortcutBinding?: Maybe<ShortcutBinding>;
  /** update data of the table: "users.shortcut_binding" */
  updateShortcutBindings?: Maybe<ShortcutBinding_Mutation_Response>;
  /** update single row of the table: "system.step" */
  updateStep?: Maybe<Step>;
  /** update single row of the table: "system.step_type" */
  updateStepType?: Maybe<StepType>;
  /** update data of the table: "system.step_type" */
  updateStepTypes?: Maybe<StepType_Mutation_Response>;
  /** update data of the table: "system.step" */
  updateSteps?: Maybe<Step_Mutation_Response>;
  /** update single row of the table: "surcharge_type" */
  updateSurchargeType?: Maybe<SurchargeType>;
  /** update data of the table: "surcharge_type" */
  updateSurchargeTypes?: Maybe<SurchargeType_Mutation_Response>;
  /** update single row of the table: "shared.tag" */
  updateTag?: Maybe<Tag>;
  /** update data of the table: "shared.tag" */
  updateTags?: Maybe<Tag_Mutation_Response>;
  /** update single row of the table: "task" */
  updateTask?: Maybe<Task>;
  /** update data of the table: "task" */
  updateTasks?: Maybe<Task_Mutation_Response>;
  /** update single row of the table: "claims.tax_rate" */
  updateTaxRate?: Maybe<TaxRate>;
  /** update single row of the table: "claims.tax_rate_as400" */
  updateTaxRateAs400?: Maybe<TaxRateAs400>;
  /** update data of the table: "claims.tax_rate_as400" */
  updateTaxRateAs400s?: Maybe<TaxRateAs400_Mutation_Response>;
  /** update data of the table: "claims.tax_rate" */
  updateTaxRates?: Maybe<TaxRate_Mutation_Response>;
  /** update single row of the table: "system.technology_type" */
  updateTechnologyType?: Maybe<TechnologyType>;
  /** update data of the table: "system.technology_type" */
  updateTechnologyTypes?: Maybe<TechnologyType_Mutation_Response>;
  /** update single row of the table: "shared.type" */
  updateType?: Maybe<Type>;
  /** update single row of the table: "shared.type_group" */
  updateTypeGroup?: Maybe<TypeGroup>;
  /** update data of the table: "shared.type_group" */
  updateTypeGroups?: Maybe<TypeGroup_Mutation_Response>;
  /** update data of the table: "shared.type" */
  updateTypes?: Maybe<Type_Mutation_Response>;
  /** update single row of the table: "auth.user" */
  updateUser?: Maybe<User>;
  /** update single row of the table: "auth.user_flow_item" */
  updateUserFlowItem?: Maybe<UserFlowItem>;
  /** update single row of the table: "auth.user_flow_item_mfa" */
  updateUserFlowItemMfa?: Maybe<UserFlowItemMfa>;
  /** update data of the table: "auth.user_flow_item_mfa" */
  updateUserFlowItemMfas?: Maybe<UserFlowItemMfa_Mutation_Response>;
  /** update data of the table: "auth.user_flow_item" */
  updateUserFlowItems?: Maybe<UserFlowItem_Mutation_Response>;
  /** update single row of the table: "auth.user_group" */
  updateUserGroup?: Maybe<UserGroup>;
  /** update data of the table: "auth.user_group" */
  updateUserGroups?: Maybe<UserGroup_Mutation_Response>;
  /** update single row of the table: "user_pin" */
  updateUserPin?: Maybe<UserPin>;
  /** update data of the table: "user_pin" */
  updateUserPins?: Maybe<UserPin_Mutation_Response>;
  /** update single row of the table: "auth.user_profile" */
  updateUserProfile?: Maybe<UserProfile>;
  /** update data of the table: "auth.user_profile" */
  updateUserProfiles?: Maybe<UserProfile_Mutation_Response>;
  /** update single row of the table: "auth.user_session" */
  updateUserSession?: Maybe<UserSession>;
  /** update data of the table: "auth.user_session" */
  updateUserSessions?: Maybe<UserSession_Mutation_Response>;
  /** update data of the table: "auth.user" */
  updateUsers?: Maybe<User_Mutation_Response>;
  /** update single row of the table: "shared.validation" */
  updateValidation?: Maybe<Validation>;
  /** update single row of the table: "shared.validation_lifecycle_hook" */
  updateValidationLifecycleHook?: Maybe<ValidationLifecycleHook>;
  /** update data of the table: "shared.validation_lifecycle_hook" */
  updateValidationLifecycleHooks?: Maybe<ValidationLifecycleHook_Mutation_Response>;
  /** update single row of the table: "shared.validation_override" */
  updateValidationOverride?: Maybe<ValidationOverride>;
  /** update data of the table: "shared.validation_override" */
  updateValidationOverrides?: Maybe<ValidationOverride_Mutation_Response>;
  /** update single row of the table: "shared.validation_rule_for" */
  updateValidationRuleFor?: Maybe<ValidationRuleFor>;
  /** update data of the table: "shared.validation_rule_for" */
  updateValidationRuleFors?: Maybe<ValidationRuleFor_Mutation_Response>;
  /** update single row of the table: "shared.validation_type_operation" */
  updateValidationTypeOperation?: Maybe<ValidationTypeOperation>;
  /** update data of the table: "shared.validation_type_operation" */
  updateValidationTypeOperations?: Maybe<ValidationTypeOperation_Mutation_Response>;
  /** update single row of the table: "shared.validation_when" */
  updateValidationWhen?: Maybe<ValidationWhen>;
  /** update data of the table: "shared.validation_when" */
  updateValidationWhens?: Maybe<ValidationWhen_Mutation_Response>;
  /** update data of the table: "shared.validation" */
  updateValidations?: Maybe<Validation_Mutation_Response>;
  /** update single row of the table: "vehicle" */
  updateVehicle?: Maybe<Vehicle>;
  /** update single row of the table: "vehicle.vehicle_status_type" */
  updateVehicleStatusType?: Maybe<VehicleStatusType>;
  /** update data of the table: "vehicle.vehicle_status_type" */
  updateVehicleStatusTypes?: Maybe<VehicleStatusType_Mutation_Response>;
  /** update data of the table: "vehicle" */
  updateVehicles?: Maybe<Vehicle_Mutation_Response>;
  /** update single row of the table: "vehicle.vpic_decode_alternative" */
  updateVpicDecodeAlternative?: Maybe<VpicDecodeAlternative>;
  /** update data of the table: "vehicle.vpic_decode_alternative" */
  updateVpicDecodeAlternatives?: Maybe<VpicDecodeAlternative_Mutation_Response>;
  /** update single row of the table: "work_status_type" */
  updateWorkStatusType?: Maybe<WorkStatusType>;
  /** update data of the table: "work_status_type" */
  updateWorkStatusTypes?: Maybe<WorkStatusType_Mutation_Response>;
  /** update single row of the table: "claims.workflow_state_type" */
  updateWorkflowStateType?: Maybe<WorkflowStateType>;
  /** update data of the table: "claims.workflow_state_type" */
  updateWorkflowStateTypes?: Maybe<WorkflowStateType_Mutation_Response>;
  /** update data of the table: "vpic.abs" */
  update_ABS?: Maybe<Abs_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.abs" */
  update_ABS_by_pk?: Maybe<Abs_Vpic>;
  /** update multiples rows of table: "vpic.abs" */
  update_ABS_many?: Maybe<Array<Maybe<Abs_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.adaptivecruisecontrol" */
  update_AdaptiveCruiseControl?: Maybe<AdaptiveCruiseControl_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.adaptivecruisecontrol" */
  update_AdaptiveCruiseControl_by_pk?: Maybe<AdaptiveCruiseControl_Vpic>;
  /** update multiples rows of table: "vpic.adaptivecruisecontrol" */
  update_AdaptiveCruiseControl_many?: Maybe<Array<Maybe<AdaptiveCruiseControl_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.adaptivedrivingbeam" */
  update_AdaptiveDrivingBeam?: Maybe<AdaptiveDrivingBeam_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.adaptivedrivingbeam" */
  update_AdaptiveDrivingBeam_by_pk?: Maybe<AdaptiveDrivingBeam_Vpic>;
  /** update multiples rows of table: "vpic.adaptivedrivingbeam" */
  update_AdaptiveDrivingBeam_many?: Maybe<Array<Maybe<AdaptiveDrivingBeam_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.airbaglocfront" */
  update_AirBagLocFront?: Maybe<AirBagLocFront_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.airbaglocfront" */
  update_AirBagLocFront_by_pk?: Maybe<AirBagLocFront_Vpic>;
  /** update multiples rows of table: "vpic.airbaglocfront" */
  update_AirBagLocFront_many?: Maybe<Array<Maybe<AirBagLocFront_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.airbaglocknee" */
  update_AirBagLocKnee?: Maybe<AirBagLocKnee_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.airbaglocknee" */
  update_AirBagLocKnee_by_pk?: Maybe<AirBagLocKnee_Vpic>;
  /** update multiples rows of table: "vpic.airbaglocknee" */
  update_AirBagLocKnee_many?: Maybe<Array<Maybe<AirBagLocKnee_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.airbaglocations" */
  update_AirBagLocations?: Maybe<AirBagLocations_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.airbaglocations" */
  update_AirBagLocations_by_pk?: Maybe<AirBagLocations_Vpic>;
  /** update multiples rows of table: "vpic.airbaglocations" */
  update_AirBagLocations_many?: Maybe<Array<Maybe<AirBagLocations_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.autobrake" */
  update_AutoBrake?: Maybe<AutoBrake_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.autobrake" */
  update_AutoBrake_by_pk?: Maybe<AutoBrake_Vpic>;
  /** update multiples rows of table: "vpic.autobrake" */
  update_AutoBrake_many?: Maybe<Array<Maybe<AutoBrake_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.autoreversesystem" */
  update_AutoReverseSystem?: Maybe<AutoReverseSystem_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.autoreversesystem" */
  update_AutoReverseSystem_by_pk?: Maybe<AutoReverseSystem_Vpic>;
  /** update multiples rows of table: "vpic.autoreversesystem" */
  update_AutoReverseSystem_many?: Maybe<Array<Maybe<AutoReverseSystem_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.automaticpedestrainalertingsound" */
  update_AutomaticPedestrainAlertingSound?: Maybe<AutomaticPedestrainAlertingSound_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.automaticpedestrainalertingsound" */
  update_AutomaticPedestrainAlertingSound_by_pk?: Maybe<AutomaticPedestrainAlertingSound_Vpic>;
  /** update multiples rows of table: "vpic.automaticpedestrainalertingsound" */
  update_AutomaticPedestrainAlertingSound_many?: Maybe<Array<Maybe<AutomaticPedestrainAlertingSound_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.axleconfiguration" */
  update_AxleConfiguration?: Maybe<AxleConfiguration_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.axleconfiguration" */
  update_AxleConfiguration_by_pk?: Maybe<AxleConfiguration_Vpic>;
  /** update multiples rows of table: "vpic.axleconfiguration" */
  update_AxleConfiguration_many?: Maybe<Array<Maybe<AxleConfiguration_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.batterytype" */
  update_BatteryType?: Maybe<BatteryType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.batterytype" */
  update_BatteryType_by_pk?: Maybe<BatteryType_Vpic>;
  /** update multiples rows of table: "vpic.batterytype" */
  update_BatteryType_many?: Maybe<Array<Maybe<BatteryType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.bedtype" */
  update_BedType?: Maybe<BedType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.bedtype" */
  update_BedType_by_pk?: Maybe<BedType_Vpic>;
  /** update multiples rows of table: "vpic.bedtype" */
  update_BedType_many?: Maybe<Array<Maybe<BedType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.blindspotintervention" */
  update_BlindSpotIntervention?: Maybe<BlindSpotIntervention_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.blindspotintervention" */
  update_BlindSpotIntervention_by_pk?: Maybe<BlindSpotIntervention_Vpic>;
  /** update multiples rows of table: "vpic.blindspotintervention" */
  update_BlindSpotIntervention_many?: Maybe<Array<Maybe<BlindSpotIntervention_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.blindspotmonitoring" */
  update_BlindSpotMonitoring?: Maybe<BlindSpotMonitoring_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.blindspotmonitoring" */
  update_BlindSpotMonitoring_by_pk?: Maybe<BlindSpotMonitoring_Vpic>;
  /** update multiples rows of table: "vpic.blindspotmonitoring" */
  update_BlindSpotMonitoring_many?: Maybe<Array<Maybe<BlindSpotMonitoring_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.bodycab" */
  update_BodyCab?: Maybe<BodyCab_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.bodycab" */
  update_BodyCab_by_pk?: Maybe<BodyCab_Vpic>;
  /** update multiples rows of table: "vpic.bodycab" */
  update_BodyCab_many?: Maybe<Array<Maybe<BodyCab_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.bodystyle" */
  update_BodyStyle?: Maybe<BodyStyle_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.bodystyle" */
  update_BodyStyle_by_pk?: Maybe<BodyStyle_Vpic>;
  /** update multiples rows of table: "vpic.bodystyle" */
  update_BodyStyle_many?: Maybe<Array<Maybe<BodyStyle_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.brakesystem" */
  update_BrakeSystem?: Maybe<BrakeSystem_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.brakesystem" */
  update_BrakeSystem_by_pk?: Maybe<BrakeSystem_Vpic>;
  /** update multiples rows of table: "vpic.brakesystem" */
  update_BrakeSystem_many?: Maybe<Array<Maybe<BrakeSystem_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.busfloorconfigtype" */
  update_BusFloorConfigType?: Maybe<BusFloorConfigType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.busfloorconfigtype" */
  update_BusFloorConfigType_by_pk?: Maybe<BusFloorConfigType_Vpic>;
  /** update multiples rows of table: "vpic.busfloorconfigtype" */
  update_BusFloorConfigType_many?: Maybe<Array<Maybe<BusFloorConfigType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.bustype" */
  update_BusType?: Maybe<BusType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.bustype" */
  update_BusType_by_pk?: Maybe<BusType_Vpic>;
  /** update multiples rows of table: "vpic.bustype" */
  update_BusType_many?: Maybe<Array<Maybe<BusType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.can_aacn" */
  update_CAN_AACN?: Maybe<Can_Aacn_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.can_aacn" */
  update_CAN_AACN_by_pk?: Maybe<Can_Aacn_Vpic>;
  /** update multiples rows of table: "vpic.can_aacn" */
  update_CAN_AACN_many?: Maybe<Array<Maybe<Can_Aacn_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.chargerlevel" */
  update_ChargerLevel?: Maybe<ChargerLevel_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.chargerlevel" */
  update_ChargerLevel_by_pk?: Maybe<ChargerLevel_Vpic>;
  /** update multiples rows of table: "vpic.chargerlevel" */
  update_ChargerLevel_many?: Maybe<Array<Maybe<ChargerLevel_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.combinedbrakingsystem" */
  update_CombinedBrakingSystem?: Maybe<CombinedBrakingSystem_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.combinedbrakingsystem" */
  update_CombinedBrakingSystem_by_pk?: Maybe<CombinedBrakingSystem_Vpic>;
  /** update multiples rows of table: "vpic.combinedbrakingsystem" */
  update_CombinedBrakingSystem_many?: Maybe<Array<Maybe<CombinedBrakingSystem_Mutation_Response_Vpic>>>;
  /** update data of the table: "ContractMasterSurcharge" */
  update_ContractMasterSurcharge?: Maybe<ContractMasterSurcharge_Mutation_Response>;
  /** update data of the table: "vpic.conversion" */
  update_Conversion?: Maybe<Conversion_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.conversion" */
  update_Conversion_by_pk?: Maybe<Conversion_Vpic>;
  /** update multiples rows of table: "vpic.conversion" */
  update_Conversion_many?: Maybe<Array<Maybe<Conversion_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.coolingtype" */
  update_CoolingType?: Maybe<CoolingType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.coolingtype" */
  update_CoolingType_by_pk?: Maybe<CoolingType_Vpic>;
  /** update multiples rows of table: "vpic.coolingtype" */
  update_CoolingType_many?: Maybe<Array<Maybe<CoolingType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.country" */
  update_Country?: Maybe<Country_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.country" */
  update_Country_by_pk?: Maybe<Country_Vpic>;
  /** update multiples rows of table: "vpic.country" */
  update_Country_many?: Maybe<Array<Maybe<Country_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.custommotorcycletype" */
  update_CustomMotorcycleType?: Maybe<CustomMotorcycleType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.custommotorcycletype" */
  update_CustomMotorcycleType_by_pk?: Maybe<CustomMotorcycleType_Vpic>;
  /** update multiples rows of table: "vpic.custommotorcycletype" */
  update_CustomMotorcycleType_many?: Maybe<Array<Maybe<CustomMotorcycleType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.daytimerunninglight" */
  update_DaytimeRunningLight?: Maybe<DaytimeRunningLight_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.daytimerunninglight" */
  update_DaytimeRunningLight_by_pk?: Maybe<DaytimeRunningLight_Vpic>;
  /** update multiples rows of table: "vpic.daytimerunninglight" */
  update_DaytimeRunningLight_many?: Maybe<Array<Maybe<DaytimeRunningLight_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.defaultvalue" */
  update_DefaultValue?: Maybe<DefaultValue_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.defaultvalue" */
  update_DefaultValue_by_pk?: Maybe<DefaultValue_Vpic>;
  /** update multiples rows of table: "vpic.defaultvalue" */
  update_DefaultValue_many?: Maybe<Array<Maybe<DefaultValue_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.destinationmarket" */
  update_DestinationMarket?: Maybe<DestinationMarket_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.destinationmarket" */
  update_DestinationMarket_by_pk?: Maybe<DestinationMarket_Vpic>;
  /** update multiples rows of table: "vpic.destinationmarket" */
  update_DestinationMarket_many?: Maybe<Array<Maybe<DestinationMarket_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.drivetype" */
  update_DriveType?: Maybe<DriveType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.drivetype" */
  update_DriveType_by_pk?: Maybe<DriveType_Vpic>;
  /** update multiples rows of table: "vpic.drivetype" */
  update_DriveType_many?: Maybe<Array<Maybe<DriveType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.dynamicbrakesupport" */
  update_DynamicBrakeSupport?: Maybe<DynamicBrakeSupport_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.dynamicbrakesupport" */
  update_DynamicBrakeSupport_by_pk?: Maybe<DynamicBrakeSupport_Vpic>;
  /** update multiples rows of table: "vpic.dynamicbrakesupport" */
  update_DynamicBrakeSupport_many?: Maybe<Array<Maybe<DynamicBrakeSupport_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.ecs" */
  update_ECS?: Maybe<Ecs_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.ecs" */
  update_ECS_by_pk?: Maybe<Ecs_Vpic>;
  /** update multiples rows of table: "vpic.ecs" */
  update_ECS_many?: Maybe<Array<Maybe<Ecs_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.edr" */
  update_EDR?: Maybe<Edr_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.edr" */
  update_EDR_by_pk?: Maybe<Edr_Vpic>;
  /** update multiples rows of table: "vpic.edr" */
  update_EDR_many?: Maybe<Array<Maybe<Edr_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.evdriveunit" */
  update_EVDriveUnit?: Maybe<EvDriveUnit_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.evdriveunit" */
  update_EVDriveUnit_by_pk?: Maybe<EvDriveUnit_Vpic>;
  /** update multiples rows of table: "vpic.evdriveunit" */
  update_EVDriveUnit_many?: Maybe<Array<Maybe<EvDriveUnit_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.electrificationlevel" */
  update_ElectrificationLevel?: Maybe<ElectrificationLevel_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.electrificationlevel" */
  update_ElectrificationLevel_by_pk?: Maybe<ElectrificationLevel_Vpic>;
  /** update multiples rows of table: "vpic.electrificationlevel" */
  update_ElectrificationLevel_many?: Maybe<Array<Maybe<ElectrificationLevel_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.element" */
  update_Element?: Maybe<Element_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.element" */
  update_Element_by_pk?: Maybe<Element_Vpic>;
  /** update multiples rows of table: "vpic.element" */
  update_Element_many?: Maybe<Array<Maybe<Element_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.engineconfiguration" */
  update_EngineConfiguration?: Maybe<EngineConfiguration_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.engineconfiguration" */
  update_EngineConfiguration_by_pk?: Maybe<EngineConfiguration_Vpic>;
  /** update multiples rows of table: "vpic.engineconfiguration" */
  update_EngineConfiguration_many?: Maybe<Array<Maybe<EngineConfiguration_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.enginemodel" */
  update_EngineModel?: Maybe<EngineModel_Mutation_Response_Vpic>;
  /** update data of the table: "vpic.enginemodelpattern" */
  update_EngineModelPattern?: Maybe<EngineModelPattern_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.enginemodelpattern" */
  update_EngineModelPattern_by_pk?: Maybe<EngineModelPattern_Vpic>;
  /** update multiples rows of table: "vpic.enginemodelpattern" */
  update_EngineModelPattern_many?: Maybe<Array<Maybe<EngineModelPattern_Mutation_Response_Vpic>>>;
  /** update single row of the table: "vpic.enginemodel" */
  update_EngineModel_by_pk?: Maybe<EngineModel_Vpic>;
  /** update multiples rows of table: "vpic.enginemodel" */
  update_EngineModel_many?: Maybe<Array<Maybe<EngineModel_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.entertainmentsystem" */
  update_EntertainmentSystem?: Maybe<EntertainmentSystem_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.entertainmentsystem" */
  update_EntertainmentSystem_by_pk?: Maybe<EntertainmentSystem_Vpic>;
  /** update multiples rows of table: "vpic.entertainmentsystem" */
  update_EntertainmentSystem_many?: Maybe<Array<Maybe<EntertainmentSystem_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.errorcode" */
  update_ErrorCode?: Maybe<ErrorCode_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.errorcode" */
  update_ErrorCode_by_pk?: Maybe<ErrorCode_Vpic>;
  /** update multiples rows of table: "vpic.errorcode" */
  update_ErrorCode_many?: Maybe<Array<Maybe<ErrorCode_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.forwardcollisionwarning" */
  update_ForwardCollisionWarning?: Maybe<ForwardCollisionWarning_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.forwardcollisionwarning" */
  update_ForwardCollisionWarning_by_pk?: Maybe<ForwardCollisionWarning_Vpic>;
  /** update multiples rows of table: "vpic.forwardcollisionwarning" */
  update_ForwardCollisionWarning_many?: Maybe<Array<Maybe<ForwardCollisionWarning_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.fueldeliverytype" */
  update_FuelDeliveryType?: Maybe<FuelDeliveryType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.fueldeliverytype" */
  update_FuelDeliveryType_by_pk?: Maybe<FuelDeliveryType_Vpic>;
  /** update multiples rows of table: "vpic.fueldeliverytype" */
  update_FuelDeliveryType_many?: Maybe<Array<Maybe<FuelDeliveryType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.fueltankmaterial" */
  update_FuelTankMaterial?: Maybe<FuelTankMaterial_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.fueltankmaterial" */
  update_FuelTankMaterial_by_pk?: Maybe<FuelTankMaterial_Vpic>;
  /** update multiples rows of table: "vpic.fueltankmaterial" */
  update_FuelTankMaterial_many?: Maybe<Array<Maybe<FuelTankMaterial_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.fueltanktype" */
  update_FuelTankType?: Maybe<FuelTankType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.fueltanktype" */
  update_FuelTankType_by_pk?: Maybe<FuelTankType_Vpic>;
  /** update multiples rows of table: "vpic.fueltanktype" */
  update_FuelTankType_many?: Maybe<Array<Maybe<FuelTankType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.fueltype" */
  update_FuelType?: Maybe<FuelType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.fueltype" */
  update_FuelType_by_pk?: Maybe<FuelType_Vpic>;
  /** update multiples rows of table: "vpic.fueltype" */
  update_FuelType_many?: Maybe<Array<Maybe<FuelType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.grossvehicleweightrating" */
  update_GrossVehicleWeightRating?: Maybe<GrossVehicleWeightRating_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.grossvehicleweightrating" */
  update_GrossVehicleWeightRating_by_pk?: Maybe<GrossVehicleWeightRating_Vpic>;
  /** update multiples rows of table: "vpic.grossvehicleweightrating" */
  update_GrossVehicleWeightRating_many?: Maybe<Array<Maybe<GrossVehicleWeightRating_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.keylessignition" */
  update_KeylessIgnition?: Maybe<KeylessIgnition_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.keylessignition" */
  update_KeylessIgnition_by_pk?: Maybe<KeylessIgnition_Vpic>;
  /** update multiples rows of table: "vpic.keylessignition" */
  update_KeylessIgnition_many?: Maybe<Array<Maybe<KeylessIgnition_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.lanecenteringassistance" */
  update_LaneCenteringAssistance?: Maybe<LaneCenteringAssistance_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.lanecenteringassistance" */
  update_LaneCenteringAssistance_by_pk?: Maybe<LaneCenteringAssistance_Vpic>;
  /** update multiples rows of table: "vpic.lanecenteringassistance" */
  update_LaneCenteringAssistance_many?: Maybe<Array<Maybe<LaneCenteringAssistance_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.lanedeparturewarning" */
  update_LaneDepartureWarning?: Maybe<LaneDepartureWarning_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.lanedeparturewarning" */
  update_LaneDepartureWarning_by_pk?: Maybe<LaneDepartureWarning_Vpic>;
  /** update multiples rows of table: "vpic.lanedeparturewarning" */
  update_LaneDepartureWarning_many?: Maybe<Array<Maybe<LaneDepartureWarning_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.lanekeepsystem" */
  update_LaneKeepSystem?: Maybe<LaneKeepSystem_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.lanekeepsystem" */
  update_LaneKeepSystem_by_pk?: Maybe<LaneKeepSystem_Vpic>;
  /** update multiples rows of table: "vpic.lanekeepsystem" */
  update_LaneKeepSystem_many?: Maybe<Array<Maybe<LaneKeepSystem_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.lowerbeamheadlamplightsource" */
  update_LowerBeamHeadlampLightSource?: Maybe<LowerBeamHeadlampLightSource_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.lowerbeamheadlamplightsource" */
  update_LowerBeamHeadlampLightSource_by_pk?: Maybe<LowerBeamHeadlampLightSource_Vpic>;
  /** update multiples rows of table: "vpic.lowerbeamheadlamplightsource" */
  update_LowerBeamHeadlampLightSource_many?: Maybe<Array<Maybe<LowerBeamHeadlampLightSource_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.make" */
  update_Make?: Maybe<Make_Mutation_Response_Vpic>;
  /** update data of the table: "vpic.make_model" */
  update_Make_Model?: Maybe<Make_Model_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.make_model" */
  update_Make_Model_by_pk?: Maybe<Make_Model_Vpic>;
  /** update multiples rows of table: "vpic.make_model" */
  update_Make_Model_many?: Maybe<Array<Maybe<Make_Model_Mutation_Response_Vpic>>>;
  /** update single row of the table: "vpic.make" */
  update_Make_by_pk?: Maybe<Make_Vpic>;
  /** update multiples rows of table: "vpic.make" */
  update_Make_many?: Maybe<Array<Maybe<Make_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.manufacturer" */
  update_Manufacturer?: Maybe<Manufacturer_Mutation_Response_Vpic>;
  /** update data of the table: "vpic.manufacturer_make" */
  update_Manufacturer_Make?: Maybe<Manufacturer_Make_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.manufacturer_make" */
  update_Manufacturer_Make_by_pk?: Maybe<Manufacturer_Make_Vpic>;
  /** update multiples rows of table: "vpic.manufacturer_make" */
  update_Manufacturer_Make_many?: Maybe<Array<Maybe<Manufacturer_Make_Mutation_Response_Vpic>>>;
  /** update single row of the table: "vpic.manufacturer" */
  update_Manufacturer_by_pk?: Maybe<Manufacturer_Vpic>;
  /** update multiples rows of table: "vpic.manufacturer" */
  update_Manufacturer_many?: Maybe<Array<Maybe<Manufacturer_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.model" */
  update_Model?: Maybe<Model_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.model" */
  update_Model_by_pk?: Maybe<Model_Vpic>;
  /** update multiples rows of table: "vpic.model" */
  update_Model_many?: Maybe<Array<Maybe<Model_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.motorcyclechassistype" */
  update_MotorcycleChassisType?: Maybe<MotorcycleChassisType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.motorcyclechassistype" */
  update_MotorcycleChassisType_by_pk?: Maybe<MotorcycleChassisType_Vpic>;
  /** update multiples rows of table: "vpic.motorcyclechassistype" */
  update_MotorcycleChassisType_many?: Maybe<Array<Maybe<MotorcycleChassisType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.motorcyclesuspensiontype" */
  update_MotorcycleSuspensionType?: Maybe<MotorcycleSuspensionType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.motorcyclesuspensiontype" */
  update_MotorcycleSuspensionType_by_pk?: Maybe<MotorcycleSuspensionType_Vpic>;
  /** update multiples rows of table: "vpic.motorcyclesuspensiontype" */
  update_MotorcycleSuspensionType_many?: Maybe<Array<Maybe<MotorcycleSuspensionType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.nonlanduse" */
  update_NonLandUse?: Maybe<NonLandUse_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.nonlanduse" */
  update_NonLandUse_by_pk?: Maybe<NonLandUse_Vpic>;
  /** update multiples rows of table: "vpic.nonlanduse" */
  update_NonLandUse_many?: Maybe<Array<Maybe<NonLandUse_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.parkassist" */
  update_ParkAssist?: Maybe<ParkAssist_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.parkassist" */
  update_ParkAssist_by_pk?: Maybe<ParkAssist_Vpic>;
  /** update multiples rows of table: "vpic.parkassist" */
  update_ParkAssist_many?: Maybe<Array<Maybe<ParkAssist_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.pattern" */
  update_Pattern?: Maybe<Pattern_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.pattern" */
  update_Pattern_by_pk?: Maybe<Pattern_Vpic>;
  /** update multiples rows of table: "vpic.pattern" */
  update_Pattern_many?: Maybe<Array<Maybe<Pattern_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.pedestrianautomaticemergencybraking" */
  update_PedestrianAutomaticEmergencyBraking?: Maybe<PedestrianAutomaticEmergencyBraking_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.pedestrianautomaticemergencybraking" */
  update_PedestrianAutomaticEmergencyBraking_by_pk?: Maybe<PedestrianAutomaticEmergencyBraking_Vpic>;
  /** update multiples rows of table: "vpic.pedestrianautomaticemergencybraking" */
  update_PedestrianAutomaticEmergencyBraking_many?: Maybe<Array<Maybe<PedestrianAutomaticEmergencyBraking_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.pretensioner" */
  update_Pretensioner?: Maybe<Pretensioner_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.pretensioner" */
  update_Pretensioner_by_pk?: Maybe<Pretensioner_Vpic>;
  /** update multiples rows of table: "vpic.pretensioner" */
  update_Pretensioner_many?: Maybe<Array<Maybe<Pretensioner_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.rearautomaticemergencybraking" */
  update_RearAutomaticEmergencyBraking?: Maybe<RearAutomaticEmergencyBraking_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.rearautomaticemergencybraking" */
  update_RearAutomaticEmergencyBraking_by_pk?: Maybe<RearAutomaticEmergencyBraking_Vpic>;
  /** update multiples rows of table: "vpic.rearautomaticemergencybraking" */
  update_RearAutomaticEmergencyBraking_many?: Maybe<Array<Maybe<RearAutomaticEmergencyBraking_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.rearcrosstrafficalert" */
  update_RearCrossTrafficAlert?: Maybe<RearCrossTrafficAlert_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.rearcrosstrafficalert" */
  update_RearCrossTrafficAlert_by_pk?: Maybe<RearCrossTrafficAlert_Vpic>;
  /** update multiples rows of table: "vpic.rearcrosstrafficalert" */
  update_RearCrossTrafficAlert_many?: Maybe<Array<Maybe<RearCrossTrafficAlert_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.rearvisibilitycamera" */
  update_RearVisibilityCamera?: Maybe<RearVisibilityCamera_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.rearvisibilitycamera" */
  update_RearVisibilityCamera_by_pk?: Maybe<RearVisibilityCamera_Vpic>;
  /** update multiples rows of table: "vpic.rearvisibilitycamera" */
  update_RearVisibilityCamera_many?: Maybe<Array<Maybe<RearVisibilityCamera_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.seatbeltsall" */
  update_SeatBeltsAll?: Maybe<SeatBeltsAll_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.seatbeltsall" */
  update_SeatBeltsAll_by_pk?: Maybe<SeatBeltsAll_Vpic>;
  /** update multiples rows of table: "vpic.seatbeltsall" */
  update_SeatBeltsAll_many?: Maybe<Array<Maybe<SeatBeltsAll_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.semiautomaticheadlampbeamswitching" */
  update_SemiautomaticHeadlampBeamSwitching?: Maybe<SemiautomaticHeadlampBeamSwitching_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.semiautomaticheadlampbeamswitching" */
  update_SemiautomaticHeadlampBeamSwitching_by_pk?: Maybe<SemiautomaticHeadlampBeamSwitching_Vpic>;
  /** update multiples rows of table: "vpic.semiautomaticheadlampbeamswitching" */
  update_SemiautomaticHeadlampBeamSwitching_many?: Maybe<Array<Maybe<SemiautomaticHeadlampBeamSwitching_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.steering" */
  update_Steering?: Maybe<Steering_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.steering" */
  update_Steering_by_pk?: Maybe<Steering_Vpic>;
  /** update multiples rows of table: "vpic.steering" */
  update_Steering_many?: Maybe<Array<Maybe<Steering_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.tpms" */
  update_TPMS?: Maybe<Tpms_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.tpms" */
  update_TPMS_by_pk?: Maybe<Tpms_Vpic>;
  /** update multiples rows of table: "vpic.tpms" */
  update_TPMS_many?: Maybe<Array<Maybe<Tpms_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.tractioncontrol" */
  update_TractionControl?: Maybe<TractionControl_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.tractioncontrol" */
  update_TractionControl_by_pk?: Maybe<TractionControl_Vpic>;
  /** update multiples rows of table: "vpic.tractioncontrol" */
  update_TractionControl_many?: Maybe<Array<Maybe<TractionControl_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.trailerbodytype" */
  update_TrailerBodyType?: Maybe<TrailerBodyType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.trailerbodytype" */
  update_TrailerBodyType_by_pk?: Maybe<TrailerBodyType_Vpic>;
  /** update multiples rows of table: "vpic.trailerbodytype" */
  update_TrailerBodyType_many?: Maybe<Array<Maybe<TrailerBodyType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.trailertype" */
  update_TrailerType?: Maybe<TrailerType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.trailertype" */
  update_TrailerType_by_pk?: Maybe<TrailerType_Vpic>;
  /** update multiples rows of table: "vpic.trailertype" */
  update_TrailerType_many?: Maybe<Array<Maybe<TrailerType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.transmission" */
  update_Transmission?: Maybe<Transmission_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.transmission" */
  update_Transmission_by_pk?: Maybe<Transmission_Vpic>;
  /** update multiples rows of table: "vpic.transmission" */
  update_Transmission_many?: Maybe<Array<Maybe<Transmission_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.turbo" */
  update_Turbo?: Maybe<Turbo_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.turbo" */
  update_Turbo_by_pk?: Maybe<Turbo_Vpic>;
  /** update multiples rows of table: "vpic.turbo" */
  update_Turbo_many?: Maybe<Array<Maybe<Turbo_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.vspecschemapattern" */
  update_VSpecSchemaPattern?: Maybe<VSpecSchemaPattern_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.vspecschemapattern" */
  update_VSpecSchemaPattern_by_pk?: Maybe<VSpecSchemaPattern_Vpic>;
  /** update multiples rows of table: "vpic.vspecschemapattern" */
  update_VSpecSchemaPattern_many?: Maybe<Array<Maybe<VSpecSchemaPattern_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.valvetraindesign" */
  update_ValvetrainDesign?: Maybe<ValvetrainDesign_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.valvetraindesign" */
  update_ValvetrainDesign_by_pk?: Maybe<ValvetrainDesign_Vpic>;
  /** update multiples rows of table: "vpic.valvetraindesign" */
  update_ValvetrainDesign_many?: Maybe<Array<Maybe<ValvetrainDesign_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.vehiclespecpattern" */
  update_VehicleSpecPattern?: Maybe<VehicleSpecPattern_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.vehiclespecpattern" */
  update_VehicleSpecPattern_by_pk?: Maybe<VehicleSpecPattern_Vpic>;
  /** update multiples rows of table: "vpic.vehiclespecpattern" */
  update_VehicleSpecPattern_many?: Maybe<Array<Maybe<VehicleSpecPattern_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.vehiclespecschema" */
  update_VehicleSpecSchema?: Maybe<VehicleSpecSchema_Mutation_Response_Vpic>;
  /** update data of the table: "vpic.vehiclespecschema_model" */
  update_VehicleSpecSchema_Model?: Maybe<VehicleSpecSchema_Model_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.vehiclespecschema_model" */
  update_VehicleSpecSchema_Model_by_pk?: Maybe<VehicleSpecSchema_Model_Vpic>;
  /** update multiples rows of table: "vpic.vehiclespecschema_model" */
  update_VehicleSpecSchema_Model_many?: Maybe<Array<Maybe<VehicleSpecSchema_Model_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.vehiclespecschema_year" */
  update_VehicleSpecSchema_Year?: Maybe<VehicleSpecSchema_Year_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.vehiclespecschema_year" */
  update_VehicleSpecSchema_Year_by_pk?: Maybe<VehicleSpecSchema_Year_Vpic>;
  /** update multiples rows of table: "vpic.vehiclespecschema_year" */
  update_VehicleSpecSchema_Year_many?: Maybe<Array<Maybe<VehicleSpecSchema_Year_Mutation_Response_Vpic>>>;
  /** update single row of the table: "vpic.vehiclespecschema" */
  update_VehicleSpecSchema_by_pk?: Maybe<VehicleSpecSchema_Vpic>;
  /** update multiples rows of table: "vpic.vehiclespecschema" */
  update_VehicleSpecSchema_many?: Maybe<Array<Maybe<VehicleSpecSchema_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.vehicletype" */
  update_VehicleType?: Maybe<VehicleType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.vehicletype" */
  update_VehicleType_by_pk?: Maybe<VehicleType_Vpic>;
  /** update multiples rows of table: "vpic.vehicletype" */
  update_VehicleType_many?: Maybe<Array<Maybe<VehicleType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.vindescriptor" */
  update_VinDescriptor?: Maybe<VinDescriptor_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.vindescriptor" */
  update_VinDescriptor_by_pk?: Maybe<VinDescriptor_Vpic>;
  /** update multiples rows of table: "vpic.vindescriptor" */
  update_VinDescriptor_many?: Maybe<Array<Maybe<VinDescriptor_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.vinexception" */
  update_VinException?: Maybe<VinException_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.vinexception" */
  update_VinException_by_pk?: Maybe<VinException_Vpic>;
  /** update multiples rows of table: "vpic.vinexception" */
  update_VinException_many?: Maybe<Array<Maybe<VinException_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.vinschema" */
  update_VinSchema?: Maybe<VinSchema_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.vinschema" */
  update_VinSchema_by_pk?: Maybe<VinSchema_Vpic>;
  /** update multiples rows of table: "vpic.vinschema" */
  update_VinSchema_many?: Maybe<Array<Maybe<VinSchema_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.wmiyearvalidchars" */
  update_WMIYearValidChars?: Maybe<WmiYearValidChars_Mutation_Response_Vpic>;
  /** update data of the table: "vpic.wmiyearvalidchars_cacheexceptions" */
  update_WMIYearValidChars_CacheExceptions?: Maybe<WmiYearValidChars_CacheExceptions_Mutation_Response_Vpic>;
  /** update multiples rows of table: "vpic.wmiyearvalidchars_cacheexceptions" */
  update_WMIYearValidChars_CacheExceptions_many?: Maybe<Array<Maybe<WmiYearValidChars_CacheExceptions_Mutation_Response_Vpic>>>;
  /** update single row of the table: "vpic.wmiyearvalidchars" */
  update_WMIYearValidChars_by_pk?: Maybe<WmiYearValidChars_Vpic>;
  /** update multiples rows of table: "vpic.wmiyearvalidchars" */
  update_WMIYearValidChars_many?: Maybe<Array<Maybe<WmiYearValidChars_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.wheelbasetype" */
  update_WheelBaseType?: Maybe<WheelBaseType_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.wheelbasetype" */
  update_WheelBaseType_by_pk?: Maybe<WheelBaseType_Vpic>;
  /** update multiples rows of table: "vpic.wheelbasetype" */
  update_WheelBaseType_many?: Maybe<Array<Maybe<WheelBaseType_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.wheeliemitigation" */
  update_WheelieMitigation?: Maybe<WheelieMitigation_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.wheeliemitigation" */
  update_WheelieMitigation_by_pk?: Maybe<WheelieMitigation_Vpic>;
  /** update multiples rows of table: "vpic.wheeliemitigation" */
  update_WheelieMitigation_many?: Maybe<Array<Maybe<WheelieMitigation_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.wmi" */
  update_Wmi?: Maybe<Wmi_Mutation_Response_Vpic>;
  /** update data of the table: "vpic.wmi_make" */
  update_Wmi_Make?: Maybe<Wmi_Make_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.wmi_make" */
  update_Wmi_Make_by_pk?: Maybe<Wmi_Make_Vpic>;
  /** update multiples rows of table: "vpic.wmi_make" */
  update_Wmi_Make_many?: Maybe<Array<Maybe<Wmi_Make_Mutation_Response_Vpic>>>;
  /** update data of the table: "vpic.wmi_vinschema" */
  update_Wmi_VinSchema?: Maybe<Wmi_VinSchema_Mutation_Response_Vpic>;
  /** update single row of the table: "vpic.wmi_vinschema" */
  update_Wmi_VinSchema_by_pk?: Maybe<Wmi_VinSchema_Vpic>;
  /** update multiples rows of table: "vpic.wmi_vinschema" */
  update_Wmi_VinSchema_many?: Maybe<Array<Maybe<Wmi_VinSchema_Mutation_Response_Vpic>>>;
  /** update single row of the table: "vpic.wmi" */
  update_Wmi_by_pk?: Maybe<Wmi_Vpic>;
  /** update multiples rows of table: "vpic.wmi" */
  update_Wmi_many?: Maybe<Array<Maybe<Wmi_Mutation_Response_Vpic>>>;
  /** update multiples rows of table: "account_account_manager" */
  update_accountAccountManager_many?: Maybe<Array<Maybe<AccountAccountManager_Mutation_Response>>>;
  /** update multiples rows of table: "account_category" */
  update_accountCategory_many?: Maybe<Array<Maybe<AccountCategory_Mutation_Response>>>;
  /** update multiples rows of table: "account_disbursement" */
  update_accountDisbursement_many?: Maybe<Array<Maybe<AccountDisbursement_Mutation_Response>>>;
  /** update multiples rows of table: "account_manager" */
  update_accountManager_many?: Maybe<Array<Maybe<AccountManager_Mutation_Response>>>;
  /** update multiples rows of table: "account_product_obligor" */
  update_accountProductObligor_many?: Maybe<Array<Maybe<AccountProductObligor_Mutation_Response>>>;
  /** update multiples rows of table: "account_product" */
  update_accountProduct_many?: Maybe<Array<Maybe<AccountProduct_Mutation_Response>>>;
  /** update multiples rows of table: "account_retail" */
  update_accountRetail_many?: Maybe<Array<Maybe<AccountRetail_Mutation_Response>>>;
  /** update multiples rows of table: "account_type" */
  update_accountType_many?: Maybe<Array<Maybe<AccountType_Mutation_Response>>>;
  /** update multiples rows of table: "account" */
  update_account_many?: Maybe<Array<Maybe<Account_Mutation_Response>>>;
  /** update multiples rows of table: "address_type" */
  update_addressType_many?: Maybe<Array<Maybe<AddressType_Mutation_Response>>>;
  /** update multiples rows of table: "address" */
  update_address_many?: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update multiples rows of table: "approvals.authority" */
  update_approvalAuthority_many?: Maybe<Array<Maybe<ApprovalAuthority_Mutation_Response>>>;
  /** update multiples rows of table: "approvals.gate_binding" */
  update_approvalGateBinding_many?: Maybe<Array<Maybe<ApprovalGateBinding_Mutation_Response>>>;
  /** update multiples rows of table: "approvals.gate" */
  update_approvalGate_many?: Maybe<Array<Maybe<ApprovalGate_Mutation_Response>>>;
  /** update multiples rows of table: "approvals.request" */
  update_approvalRequest_many?: Maybe<Array<Maybe<ApprovalRequest_Mutation_Response>>>;
  /** update multiples rows of table: "approvals.state" */
  update_approvalState_many?: Maybe<Array<Maybe<ApprovalState_Mutation_Response>>>;
  /** update multiples rows of table: "approvals.approval" */
  update_approval_many?: Maybe<Array<Maybe<Approval_Mutation_Response>>>;
  /** update multiples rows of table: "as400_data_sync" */
  update_as400DataSync_many?: Maybe<Array<Maybe<As400DataSync_Mutation_Response>>>;
  /** update data of the table: "audit.message_formatter_config" */
  update_audit_message_formatter_config?: Maybe<Audit_Message_Formatter_Config_Mutation_Response>;
  /** update single row of the table: "audit.message_formatter_config" */
  update_audit_message_formatter_config_by_pk?: Maybe<Audit_Message_Formatter_Config>;
  /** update multiples rows of table: "audit.message_formatter_config" */
  update_audit_message_formatter_config_many?: Maybe<Array<Maybe<Audit_Message_Formatter_Config_Mutation_Response>>>;
  /** update data of the table: "auth.group" */
  update_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** update data of the table: "auth.group_actions" */
  update_auth_group_actions?: Maybe<Auth_Group_Actions_Mutation_Response>;
  /** update single row of the table: "auth.group_actions" */
  update_auth_group_actions_by_pk?: Maybe<Auth_Group_Actions>;
  /** update multiples rows of table: "auth.group_actions" */
  update_auth_group_actions_many?: Maybe<Array<Maybe<Auth_Group_Actions_Mutation_Response>>>;
  /** update single row of the table: "auth.group" */
  update_auth_group_by_pk?: Maybe<Auth_Group>;
  /** update multiples rows of table: "auth.group" */
  update_auth_group_many?: Maybe<Array<Maybe<Auth_Group_Mutation_Response>>>;
  /** update multiples rows of table: "caddy.caddy_server_manager_log" */
  update_caddyServerManagerLog_many?: Maybe<Array<Maybe<CaddyServerManagerLog_Mutation_Response>>>;
  /** update multiples rows of table: "caddy.caddy" */
  update_caddy_many?: Maybe<Array<Maybe<Caddy_Mutation_Response>>>;
  /** update multiples rows of table: "operations.cancellation" */
  update_cancellation_many?: Maybe<Array<Maybe<Cancellation_Mutation_Response>>>;
  /** update multiples rows of table: "auth.capability_config" */
  update_capabilityConfig_many?: Maybe<Array<Maybe<CapabilityConfig_Mutation_Response>>>;
  /** update multiples rows of table: "auth.capability_route" */
  update_capabilityRoute_many?: Maybe<Array<Maybe<CapabilityRoute_Mutation_Response>>>;
  /** update multiples rows of table: "auth.capability" */
  update_capability_many?: Maybe<Array<Maybe<Capability_Mutation_Response>>>;
  /** update multiples rows of table: "carrier" */
  update_carrier_many?: Maybe<Array<Maybe<Carrier_Mutation_Response>>>;
  /** update multiples rows of table: "category_product_attribute_type" */
  update_categoryProductAttributeType_many?: Maybe<Array<Maybe<CategoryProductAttributeType_Mutation_Response>>>;
  /** update multiples rows of table: "category" */
  update_category_many?: Maybe<Array<Maybe<Category_Mutation_Response>>>;
  /** update multiples rows of table: "claims.claim_detail_category" */
  update_claimDetailCategory_many?: Maybe<Array<Maybe<ClaimDetailCategory_Mutation_Response>>>;
  /** update multiples rows of table: "claim_status_type" */
  update_claimStatusType_many?: Maybe<Array<Maybe<ClaimStatusType_Mutation_Response>>>;
  /** update multiples rows of table: "claim" */
  update_claim_many?: Maybe<Array<Maybe<Claim_Mutation_Response>>>;
  /** update data of the table: "claims.pre_authorization_vehicle_information" */
  update_claims_pre_authorization_vehicle_information?: Maybe<Claims_Pre_Authorization_Vehicle_Information_Mutation_Response>;
  /** update single row of the table: "claims.pre_authorization_vehicle_information" */
  update_claims_pre_authorization_vehicle_information_by_pk?: Maybe<Claims_Pre_Authorization_Vehicle_Information>;
  /** update multiples rows of table: "claims.pre_authorization_vehicle_information" */
  update_claims_pre_authorization_vehicle_information_many?: Maybe<Array<Maybe<Claims_Pre_Authorization_Vehicle_Information_Mutation_Response>>>;
  /** update data of the table: "claims.temp_claims_auth_table" */
  update_claims_temp_claims_auth_table?: Maybe<Claims_Temp_Claims_Auth_Table_Mutation_Response>;
  /** update single row of the table: "claims.temp_claims_auth_table" */
  update_claims_temp_claims_auth_table_by_pk?: Maybe<Claims_Temp_Claims_Auth_Table>;
  /** update multiples rows of table: "claims.temp_claims_auth_table" */
  update_claims_temp_claims_auth_table_many?: Maybe<Array<Maybe<Claims_Temp_Claims_Auth_Table_Mutation_Response>>>;
  /** update multiples rows of table: "classes.class_criteria" */
  update_classCriteria_many?: Maybe<Array<Maybe<ClassCriteria_Mutation_Response>>>;
  /** update multiples rows of table: "classes.class_guide_class_criteria" */
  update_classGuideClassCriteria_many?: Maybe<Array<Maybe<ClassGuideClassCriteria_Mutation_Response>>>;
  /** update multiples rows of table: "classes.class_guide_criteria_definition" */
  update_classGuideCriteriaDefinition_many?: Maybe<Array<Maybe<ClassGuideCriteriaDefinition_Mutation_Response>>>;
  /** update multiples rows of table: "classes.class_guide_criteria_type" */
  update_classGuideCriteriaType_many?: Maybe<Array<Maybe<ClassGuideCriteriaType_Mutation_Response>>>;
  /** update multiples rows of table: "classes.class_guide" */
  update_classGuide_many?: Maybe<Array<Maybe<ClassGuide_Mutation_Response>>>;
  /** update data of the table: "nhtsa.concern_synonym" */
  update_concernSynonym?: Maybe<ConcernSynonym_Mutation_Response_Nhtsa>;
  /** update single row of the table: "nhtsa.concern_synonym" */
  update_concernSynonym_by_pk?: Maybe<ConcernSynonym_Nhtsa>;
  /** update multiples rows of table: "nhtsa.concern_synonym" */
  update_concernSynonym_many?: Maybe<Array<Maybe<ConcernSynonym_Mutation_Response_Nhtsa>>>;
  /** update multiples rows of table: "configuration_item_type" */
  update_configurationItemType_many?: Maybe<Array<Maybe<ConfigurationItemType_Mutation_Response>>>;
  /** update multiples rows of table: "configuration_item" */
  update_configurationItem_many?: Maybe<Array<Maybe<ConfigurationItem_Mutation_Response>>>;
  /** update multiples rows of table: "contact" */
  update_contact_many?: Maybe<Array<Maybe<Contact_Mutation_Response>>>;
  /** update multiples rows of table: "compliance.contract_form_type" */
  update_contractFormType_many?: Maybe<Array<Maybe<ContractFormType_Mutation_Response>>>;
  /** update multiples rows of table: "contract_status_type" */
  update_contractStatusType_many?: Maybe<Array<Maybe<ContractStatusType_Mutation_Response>>>;
  /** update multiples rows of table: "contract" */
  update_contract_many?: Maybe<Array<Maybe<Contract_Mutation_Response>>>;
  /** update multiples rows of table: "cost_adjustment_extended_cost" */
  update_costAdjustmentExtendedCost_many?: Maybe<Array<Maybe<CostAdjustmentExtendedCost_Mutation_Response>>>;
  /** update multiples rows of table: "cost_adjustment_lookup" */
  update_costAdjustmentLookup_many?: Maybe<Array<Maybe<CostAdjustmentLookup_Mutation_Response>>>;
  /** update multiples rows of table: "cost_adjustment_type" */
  update_costAdjustmentType_many?: Maybe<Array<Maybe<CostAdjustmentType_Mutation_Response>>>;
  /** update multiples rows of table: "cost_adjustment" */
  update_costAdjustment_many?: Maybe<Array<Maybe<CostAdjustment_Mutation_Response>>>;
  /** update multiples rows of table: "custom_field_data" */
  update_customFieldData_many?: Maybe<Array<Maybe<CustomFieldData_Mutation_Response>>>;
  /** update multiples rows of table: "custom_field_type" */
  update_customFieldType_many?: Maybe<Array<Maybe<CustomFieldType_Mutation_Response>>>;
  /** update multiples rows of table: "custom_field" */
  update_customField_many?: Maybe<Array<Maybe<CustomField_Mutation_Response>>>;
  /** update multiples rows of table: "customer" */
  update_customer_many?: Maybe<Array<Maybe<Customer_Mutation_Response>>>;
  /** update multiples rows of table: "data_type" */
  update_dataType_many?: Maybe<Array<Maybe<DataType_Mutation_Response>>>;
  /** update multiples rows of table: "dealer_payment_type" */
  update_dealerPaymentType_many?: Maybe<Array<Maybe<DealerPaymentType_Mutation_Response>>>;
  /** update multiples rows of table: "disbursement_type" */
  update_disbursementType_many?: Maybe<Array<Maybe<DisbursementType_Mutation_Response>>>;
  /** update multiples rows of table: "claims.document" */
  update_document_many?: Maybe<Array<Maybe<Document_Mutation_Response>>>;
  /** update multiples rows of table: "eligibility_rule_definition" */
  update_eligibilityRuleDefinition_many?: Maybe<Array<Maybe<EligibilityRuleDefinition_Mutation_Response>>>;
  /** update multiples rows of table: "eligibility_rule" */
  update_eligibilityRule_many?: Maybe<Array<Maybe<EligibilityRule_Mutation_Response>>>;
  /** update multiples rows of table: "eligibility_type" */
  update_eligibilityType_many?: Maybe<Array<Maybe<EligibilityType_Mutation_Response>>>;
  /** update multiples rows of table: "shared.entity_billing_information" */
  update_entityBillingInformation_many?: Maybe<Array<Maybe<EntityBillingInformation_Mutation_Response>>>;
  /** update multiples rows of table: "entity_configuration_item" */
  update_entityConfigurationItem_many?: Maybe<Array<Maybe<EntityConfigurationItem_Mutation_Response>>>;
  /** update multiples rows of table: "entity_custom_field_value" */
  update_entityCustomFieldValue_many?: Maybe<Array<Maybe<EntityCustomFieldValue_Mutation_Response>>>;
  /** update multiples rows of table: "entity_custom_field" */
  update_entityCustomField_many?: Maybe<Array<Maybe<EntityCustomField_Mutation_Response>>>;
  /** update multiples rows of table: "entity_data_definition" */
  update_entityDataDefinition_many?: Maybe<Array<Maybe<EntityDataDefinition_Mutation_Response>>>;
  /** update multiples rows of table: "entity_eligibility_rule" */
  update_entityEligibilityRule_many?: Maybe<Array<Maybe<EntityEligibilityRule_Mutation_Response>>>;
  /** update multiples rows of table: "shared.entity_file_storage" */
  update_entityFileStorage_many?: Maybe<Array<Maybe<EntityFileStorage_Mutation_Response>>>;
  /** update multiples rows of table: "shared.entity_note" */
  update_entityNote_many?: Maybe<Array<Maybe<EntityNote_Mutation_Response>>>;
  /** update multiples rows of table: "entity_offering" */
  update_entityOffering_many?: Maybe<Array<Maybe<EntityOffering_Mutation_Response>>>;
  /** update multiples rows of table: "shared.entity_remittance_detail" */
  update_entityRemittanceDetail_many?: Maybe<Array<Maybe<EntityRemittanceDetail_Mutation_Response>>>;
  /** update multiples rows of table: "shared.entity_tag" */
  update_entityTag_many?: Maybe<Array<Maybe<EntityTag_Mutation_Response>>>;
  /** update multiples rows of table: "shared.file_storage_type" */
  update_fileStorageType_many?: Maybe<Array<Maybe<FileStorageType_Mutation_Response>>>;
  /** update multiples rows of table: "shared.file_storage" */
  update_fileStorage_many?: Maybe<Array<Maybe<FileStorage_Mutation_Response>>>;
  /** update data of the table: "identities" */
  update_identities?: Maybe<Identities_Mutation_Response>;
  /** update single row of the table: "identities" */
  update_identities_by_pk?: Maybe<Identities>;
  /** update multiples rows of table: "identities" */
  update_identities_many?: Maybe<Array<Maybe<Identities_Mutation_Response>>>;
  /** update data of the table: "auth.identity_capability_view" */
  update_identityCapabilityView?: Maybe<IdentityCapabilityView_Mutation_Response>;
  /** update multiples rows of table: "auth.identity_capability_view" */
  update_identityCapabilityView_many?: Maybe<Array<Maybe<IdentityCapabilityView_Mutation_Response>>>;
  /** update multiples rows of table: "auth.identity_capability" */
  update_identityCapability_many?: Maybe<Array<Maybe<IdentityCapability_Mutation_Response>>>;
  /** update multiples rows of table: "auth.identity_entity" */
  update_identityEntity_many?: Maybe<Array<Maybe<IdentityEntity_Mutation_Response>>>;
  /** update data of the table: "nhtsa.investigation_recall" */
  update_investigationRecall?: Maybe<InvestigationRecall_Mutation_Response_Nhtsa>;
  /** update single row of the table: "nhtsa.investigation_recall" */
  update_investigationRecall_by_pk?: Maybe<InvestigationRecall_Nhtsa>;
  /** update multiples rows of table: "nhtsa.investigation_recall" */
  update_investigationRecall_many?: Maybe<Array<Maybe<InvestigationRecall_Mutation_Response_Nhtsa>>>;
  /** update multiples rows of table: "claims.invoice_document_type" */
  update_invoiceDocumentType_many?: Maybe<Array<Maybe<InvoiceDocumentType_Mutation_Response>>>;
  /** update multiples rows of table: "claims.invoice_payment_type" */
  update_invoicePaymentType_many?: Maybe<Array<Maybe<InvoicePaymentType_Mutation_Response>>>;
  /** update multiples rows of table: "claims.invoice" */
  update_invoice_many?: Maybe<Array<Maybe<Invoice_Mutation_Response>>>;
  /** update data of the table: "nhtsa.issue" */
  update_issue?: Maybe<Issue_Mutation_Response_Nhtsa>;
  /** update data of the table: "nhtsa.issue_make_model" */
  update_issueMakeModel?: Maybe<IssueMakeModel_Mutation_Response_Nhtsa>;
  /** update multiples rows of table: "nhtsa.issue_make_model" */
  update_issueMakeModel_many?: Maybe<Array<Maybe<IssueMakeModel_Mutation_Response_Nhtsa>>>;
  /** update data of the table: "nhtsa.issue_search_result" */
  update_issueSearchResult?: Maybe<IssueSearchResult_Mutation_Response_Nhtsa>;
  /** update multiples rows of table: "nhtsa.issue_search_result" */
  update_issueSearchResult_many?: Maybe<Array<Maybe<IssueSearchResult_Mutation_Response_Nhtsa>>>;
  /** update single row of the table: "nhtsa.issue" */
  update_issue_by_pk?: Maybe<Issue_Nhtsa>;
  /** update multiples rows of table: "nhtsa.issue" */
  update_issue_many?: Maybe<Array<Maybe<Issue_Mutation_Response_Nhtsa>>>;
  /** update multiples rows of table: "labor_guide_type" */
  update_laborGuideType_many?: Maybe<Array<Maybe<LaborGuideType_Mutation_Response>>>;
  /** update multiples rows of table: "dealer" */
  update_legacy_claims_dealer_many?: Maybe<Array<Maybe<Legacy_Claims_Dealer_Mutation_Response>>>;
  /** update multiples rows of table: "note" */
  update_legacy_claims_note_many?: Maybe<Array<Maybe<Legacy_Claims_Note_Mutation_Response>>>;
  /** update data of the table: "nhtsa.load" */
  update_load?: Maybe<Load_Mutation_Response_Nhtsa>;
  /** update single row of the table: "nhtsa.load" */
  update_load_by_pk?: Maybe<Load_Nhtsa>;
  /** update multiples rows of table: "nhtsa.load" */
  update_load_many?: Maybe<Array<Maybe<Load_Mutation_Response_Nhtsa>>>;
  /** update multiples rows of table: "audit.logged_actions" */
  update_loggedAction_many?: Maybe<Array<Maybe<LoggedAction_Mutation_Response>>>;
  /** update data of the table: "nhtsa.make_model" */
  update_makeModel?: Maybe<MakeModel_Mutation_Response_Nhtsa>;
  /** update single row of the table: "nhtsa.make_model" */
  update_makeModel_by_pk?: Maybe<MakeModel_Nhtsa>;
  /** update multiples rows of table: "nhtsa.make_model" */
  update_makeModel_many?: Maybe<Array<Maybe<MakeModel_Mutation_Response_Nhtsa>>>;
  /** update data of the table: "nhtsa.model_year_model" */
  update_modelYearModel?: Maybe<ModelYearModel_Mutation_Response_Nhtsa>;
  /** update single row of the table: "nhtsa.model_year_model" */
  update_modelYearModel_by_pk?: Maybe<ModelYearModel_Nhtsa>;
  /** update multiples rows of table: "nhtsa.model_year_model" */
  update_modelYearModel_many?: Maybe<Array<Maybe<ModelYearModel_Mutation_Response_Nhtsa>>>;
  /** update multiples rows of table: "obligor" */
  update_obligor_many?: Maybe<Array<Maybe<Obligor_Mutation_Response>>>;
  /** update multiples rows of table: "job" */
  update_obsoleteJob_many?: Maybe<Array<Maybe<ObsoleteJob_Mutation_Response>>>;
  /** update data of the table: "operations.legacy_policy_contract_cost_detail_view" */
  update_operations_legacy_policy_contract_cost_detail_view?: Maybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Mutation_Response>;
  /** update multiples rows of table: "operations.legacy_policy_contract_cost_detail_view" */
  update_operations_legacy_policy_contract_cost_detail_view_many?: Maybe<Array<Maybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Mutation_Response>>>;
  /** update multiples rows of table: "accounting.payee" */
  update_payee_many?: Maybe<Array<Maybe<Payee_Mutation_Response>>>;
  /** update multiples rows of table: "shared.payment_detail" */
  update_paymentDetail_many?: Maybe<Array<Maybe<PaymentDetail_Mutation_Response>>>;
  /** update multiples rows of table: "shared.payment_status_type" */
  update_paymentStatusType_many?: Maybe<Array<Maybe<PaymentStatusType_Mutation_Response>>>;
  /** update multiples rows of table: "shared.payment" */
  update_payment_many?: Maybe<Array<Maybe<Payment_Mutation_Response>>>;
  /** update multiples rows of table: "claims.policy_claim_concern" */
  update_policyClaimConcern_many?: Maybe<Array<Maybe<PolicyClaimConcern_Mutation_Response>>>;
  /** update multiples rows of table: "operations.policy_contract_contract_form_version" */
  update_policyContractContractFormVersion_many?: Maybe<Array<Maybe<PolicyContractContractFormVersion_Mutation_Response>>>;
  /** update multiples rows of table: "product_attribute_type" */
  update_productAttributeType_many?: Maybe<Array<Maybe<ProductAttributeType_Mutation_Response>>>;
  /** update multiples rows of table: "product_attribute" */
  update_productAttribute_many?: Maybe<Array<Maybe<ProductAttribute_Mutation_Response>>>;
  /** update multiples rows of table: "product_class_guide" */
  update_productClassGuide_many?: Maybe<Array<Maybe<ProductClassGuide_Mutation_Response>>>;
  /** update multiples rows of table: "product_cost" */
  update_productCost_many?: Maybe<Array<Maybe<ProductCost_Mutation_Response>>>;
  /** update multiples rows of table: "product_disbursement" */
  update_productDisbursement_many?: Maybe<Array<Maybe<ProductDisbursement_Mutation_Response>>>;
  /** update multiples rows of table: "product_eligibility_rule" */
  update_productEligibility_many?: Maybe<Array<Maybe<ProductEligibility_Mutation_Response>>>;
  /** update multiples rows of table: "product_obligor" */
  update_productObligor_many?: Maybe<Array<Maybe<ProductObligor_Mutation_Response>>>;
  /** update multiples rows of table: "product_rate_bucket" */
  update_productRateBucket_many?: Maybe<Array<Maybe<ProductRateBucket_Mutation_Response>>>;
  /** update multiples rows of table: "product_surcharge_type" */
  update_productSurchargeType_many?: Maybe<Array<Maybe<ProductSurchargeType_Mutation_Response>>>;
  /** update multiples rows of table: "product" */
  update_product_many?: Maybe<Array<Maybe<Product_Mutation_Response>>>;
  /** update multiples rows of table: "quotes.quote_minimal_view" */
  update_quoteMinimalView_many?: Maybe<Array<Maybe<QuoteMinimalView_Mutation_Response>>>;
  /** update multiples rows of table: "rate_bucket_type" */
  update_rateBucketType_many?: Maybe<Array<Maybe<RateBucketType_Mutation_Response>>>;
  /** update multiples rows of table: "rate_quote" */
  update_rateQuote_many?: Maybe<Array<Maybe<RateQuote_Mutation_Response>>>;
  /** update data of the table: "nhtsa.record_type" */
  update_recordType?: Maybe<RecordType_Mutation_Response_Nhtsa>;
  /** update single row of the table: "nhtsa.record_type" */
  update_recordType_by_pk?: Maybe<RecordType_Nhtsa>;
  /** update multiples rows of table: "nhtsa.record_type" */
  update_recordType_many?: Maybe<Array<Maybe<RecordType_Mutation_Response_Nhtsa>>>;
  /** update multiples rows of table: "operations.remittance_payment" */
  update_remittancePayment_many?: Maybe<Array<Maybe<RemittancePayment_Mutation_Response>>>;
  /** update multiples rows of table: "operations.remittance_type" */
  update_remittanceType_many?: Maybe<Array<Maybe<RemittanceType_Mutation_Response>>>;
  /** update multiples rows of table: "auth.role_attribute" */
  update_roleAttribute_many?: Maybe<Array<Maybe<RoleAttribute_Mutation_Response>>>;
  /** update multiples rows of table: "auth.route_config" */
  update_routeConfig_many?: Maybe<Array<Maybe<RouteConfig_Mutation_Response>>>;
  /** update multiples rows of table: "auth.route" */
  update_route_many?: Maybe<Array<Maybe<Route_Mutation_Response>>>;
  /** update multiples rows of table: "shared.search_index" */
  update_searchIndex_many?: Maybe<Array<Maybe<SearchIndex_Mutation_Response>>>;
  /** update data of the table: "shared.search_result" */
  update_shared_search_result?: Maybe<Shared_Search_Result_Mutation_Response>;
  /** update multiples rows of table: "shared.search_result" */
  update_shared_search_result_many?: Maybe<Array<Maybe<Shared_Search_Result_Mutation_Response>>>;
  /** update multiples rows of table: "state" */
  update_state_many?: Maybe<Array<Maybe<State_Mutation_Response>>>;
  /** update multiples rows of table: "surcharge_type" */
  update_surchargeType_many?: Maybe<Array<Maybe<SurchargeType_Mutation_Response>>>;
  /** update multiples rows of table: "shared.tag" */
  update_tag_many?: Maybe<Array<Maybe<Tag_Mutation_Response>>>;
  /** update multiples rows of table: "task" */
  update_task_many?: Maybe<Array<Maybe<Task_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_group" */
  update_userGroup_many?: Maybe<Array<Maybe<UserGroup_Mutation_Response>>>;
  /** update multiples rows of table: "user_pin" */
  update_userPin_many?: Maybe<Array<Maybe<UserPin_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_profile" */
  update_userProfile_many?: Maybe<Array<Maybe<UserProfile_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_session" */
  update_userSession_many?: Maybe<Array<Maybe<UserSession_Mutation_Response>>>;
  /** update multiples rows of table: "shared.validation_lifecycle_hook" */
  update_validationLifecycleHook_many?: Maybe<Array<Maybe<ValidationLifecycleHook_Mutation_Response>>>;
  /** update multiples rows of table: "shared.validation_override" */
  update_validationOverride_many?: Maybe<Array<Maybe<ValidationOverride_Mutation_Response>>>;
  /** update multiples rows of table: "shared.validation_rule_for" */
  update_validationRuleFor_many?: Maybe<Array<Maybe<ValidationRuleFor_Mutation_Response>>>;
  /** update multiples rows of table: "shared.validation_when" */
  update_validationWhen_many?: Maybe<Array<Maybe<ValidationWhen_Mutation_Response>>>;
  /** update multiples rows of table: "shared.validation" */
  update_validation_many?: Maybe<Array<Maybe<Validation_Mutation_Response>>>;
  /** update data of the table: "vwVehicleClassingBodyStyle" */
  update_vehicleClassingBodyStyle?: Maybe<VehicleClassingBodyStyle_Mutation_Response>;
  /** update data of the table: "vwVehicleClassingFuelType" */
  update_vehicleClassingFuelType?: Maybe<VehicleClassingFuelType_Mutation_Response>;
  /** update data of the table: "vwVehicleClassingVehicleMake" */
  update_vehicleClassingVehicleMake?: Maybe<VehicleClassingVehicleMake_Mutation_Response>;
  /** update data of the table: "vwVehicleClassingVehicleType" */
  update_vehicleClassingVehicleType?: Maybe<VehicleClassingVehicleType_Mutation_Response>;
  /** update multiples rows of table: "vehicle" */
  update_vehicle_many?: Maybe<Array<Maybe<Vehicle_Mutation_Response>>>;
  /** update data of the table: "vwVehicleCylindersDistinct" */
  update_vwVehicleCylindersDistinct?: Maybe<VwVehicleCylindersDistinct_Mutation_Response>;
  /** update data of the table: "vwVehicleDrivingWheelsDistinct" */
  update_vwVehicleDrivingWheelsDistinct?: Maybe<VwVehicleDrivingWheelsDistinct_Mutation_Response>;
  /** update data of the table: "vwVehicleFuelTypesDistinct" */
  update_vwVehicleFuelTypesDistinct?: Maybe<VwVehicleFuelTypesDistinct_Mutation_Response>;
  /** update data of the table: "vwVehicleMakesDistinct" */
  update_vwVehicleMakesDistinct?: Maybe<VwVehicleMakesDistinct_Mutation_Response>;
  /** update data of the table: "vwVehicleModelsDistinct" */
  update_vwVehicleModelsDistinct?: Maybe<VwVehicleModelsDistinct_Mutation_Response>;
  /** update data of the table: "vwVehicleYearsDistinct" */
  update_vwVehicleYearsDistinct?: Maybe<VwVehicleYearsDistinct_Mutation_Response>;
  /** update multiples rows of table: "work_status_type" */
  update_workStatusType_many?: Maybe<Array<Maybe<WorkStatusType_Mutation_Response>>>;
  /** update multiples rows of table: "claims.workflow_state_type" */
  update_workflowStateType_many?: Maybe<Array<Maybe<WorkflowStateType_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDeleteAccountArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountAccountManagerArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountAccountManagersArgs = {
  where: AccountAccountManager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAccountCategoriesArgs = {
  where: AccountCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAccountCategoryArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountDisbursementArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountDisbursementsArgs = {
  where: AccountDisbursement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAccountManagerArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountManagersArgs = {
  where: AccountManager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAccountObligorArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountObligorsArgs = {
  where: AccountObligor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAccountProductArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountProductObligorArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountProductObligorsArgs = {
  where: AccountProductObligor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAccountProductsArgs = {
  where: AccountProduct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAccountRetailArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountRetailsArgs = {
  where: AccountRetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAccountTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteAccountTypesArgs = {
  where: AccountType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAccountsArgs = {
  where: Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAddressArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAddressTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteAddressTypesArgs = {
  where: AddressType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAddressesArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAlertArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAlertAcknowledgmentArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAlertAcknowledgmentsArgs = {
  where: AlertAcknowledgment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAlertsArgs = {
  where: Alert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteApplicationArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteApplicationPreferenceArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteApplicationPreferencesArgs = {
  where: ApplicationPreference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteApplicationsArgs = {
  where: Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteApprovalArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteApprovalAuthoritiesArgs = {
  where: ApprovalAuthority_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteApprovalAuthorityArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteApprovalGateArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteApprovalGateBindingArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteApprovalGateBindingsArgs = {
  where: ApprovalGateBinding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteApprovalGatesArgs = {
  where: ApprovalGate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteApprovalRecordsArgs = {
  where: Approval_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteApprovalRequestArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteApprovalRequestsArgs = {
  where: ApprovalRequest_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteApprovalStatesArgs = {
  where: ApprovalState_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAs400DataSyncArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAs400DataSyncsArgs = {
  where: As400DataSync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteBankAccountTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteBankAccountTypesArgs = {
  where: BankAccountType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCaddyArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCaddyServerManagerLogArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCaddyServerManagerLogsArgs = {
  where: CaddyServerManagerLog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCaddysArgs = {
  where: Caddy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCancelRuleArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCancelRuleFeeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCancelRuleFeesArgs = {
  where: CancelRuleFee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCancelRuleRefundArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCancelRuleRefundsArgs = {
  where: CancelRuleRefund_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCancelRulesArgs = {
  where: CancelRule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCancellationArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCancellationAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCancellationAs400sArgs = {
  where: CancellationAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCancellationsArgs = {
  where: Cancellation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCapabilitiesArgs = {
  where: Capability_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCapabilityArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCapabilityConfigArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCapabilityConfigsArgs = {
  where: CapabilityConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCapabilityRouteArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCapabilityRoutesArgs = {
  where: CapabilityRoute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCardLayoutArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCardLayoutsArgs = {
  where: CardLayout_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCarrierArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCarriersArgs = {
  where: Carrier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCategoriesArgs = {
  where: Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCategoryArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCategoryProductAttributeTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCategoryProductAttributeTypesArgs = {
  where: CategoryProductAttributeType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClaimDetailArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClaimDetailAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClaimDetailAs400sArgs = {
  where: ClaimDetailAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimDetailCategoriesArgs = {
  where: ClaimDetailCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimDetailCategoryArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClaimDetailDeductionAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClaimDetailDeductionAs400sArgs = {
  where: ClaimDetailDeductionAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimDetailPartLookupArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClaimDetailPartLookupsArgs = {
  where: ClaimDetailPartLookup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimDetailsArgs = {
  where: ClaimDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimServiceCenterArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClaimServiceCenterAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClaimServiceCenterAs400sArgs = {
  where: ClaimServiceCenterAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimServiceCenterAuthorizationArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClaimServiceCenterAuthorizationsArgs = {
  where: ClaimServiceCenterAuthorization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimServiceCentersArgs = {
  where: ClaimServiceCenter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimStatusArgs = {
  ClaimStatusCode: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteClaimStatusTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClaimStatusTypesArgs = {
  where: ClaimStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimStatusesArgs = {
  where: ClaimStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimsArgs = {
  where: Claim_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClaimsMastersArgs = {
  where: ClaimsMaster_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClassCriteriaArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClassCriteriasArgs = {
  where: ClassCriteria_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClassGuideArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClassGuideClassCriteriaArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClassGuideClassCriteriasArgs = {
  where: ClassGuideClassCriteria_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClassGuideCriteriaDefinitionArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClassGuideCriteriaDefinitionsArgs = {
  where: ClassGuideCriteriaDefinition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClassGuideCriteriaTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteClassGuideCriteriaTypesArgs = {
  where: ClassGuideCriteriaType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClassGuidesArgs = {
  where: ClassGuide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCompositeProductArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompositeProductsArgs = {
  where: CompositeProduct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteConfigurationItemArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteConfigurationItemTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteConfigurationItemTypesArgs = {
  where: ConfigurationItemType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteConfigurationItemsArgs = {
  where: ConfigurationItem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContactArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContactsArgs = {
  where: Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContentTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContentTypesArgs = {
  where: ContentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContractArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractFormArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractFormFilingStatusArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractFormFilingStatusesArgs = {
  where: ContractFormFilingStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContractFormTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractFormTypesArgs = {
  where: ContractFormType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContractFormVersionArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractFormVersionLegacyFileArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractFormVersionLegacyFilesArgs = {
  where: ContractFormVersionLegacyFile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContractFormVersionsArgs = {
  where: ContractFormVersion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContractFormsArgs = {
  where: ContractForm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContractMasterArgs = {
  ContractMasterID: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteContractMasterAdditionalEntitiesArgs = {
  where: ContractMasterAdditionalEntity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContractMastersArgs = {
  where: ContractMaster_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContractStatusTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractStatusTypesArgs = {
  where: ContractStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteContractsArgs = {
  where: Contract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCostAdjustmentArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCostAdjustmentExtendedCostArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCostAdjustmentExtendedCostsArgs = {
  where: CostAdjustmentExtendedCost_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCostAdjustmentLookupArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCostAdjustmentLookupsArgs = {
  where: CostAdjustmentLookup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCostAdjustmentTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteCostAdjustmentTypesArgs = {
  where: CostAdjustmentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCostAdjustmentsArgs = {
  where: CostAdjustment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCustomFieldArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCustomFieldDataArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCustomFieldDatasArgs = {
  where: CustomFieldData_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCustomFieldTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCustomFieldTypesArgs = {
  where: CustomFieldType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCustomFieldsArgs = {
  where: CustomField_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCustomerArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCustomersArgs = {
  where: Customer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCycleArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCycleJournalEntriesArgs = {
  where: CycleJournalEntry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCycleJournalEntryArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCycleTotalArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCycleTotalsArgs = {
  where: CycleTotal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCyclesArgs = {
  where: Cycle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDataTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDataTypesArgs = {
  where: DataType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDateCalculationTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDateCalculationTypesArgs = {
  where: DateCalculationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDealerArgs = {
  DealerID: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteDealerPaymentTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDealerPaymentTypesArgs = {
  where: DealerPaymentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDealersArgs = {
  where: Dealer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDisbursementTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteDisbursementTypesArgs = {
  where: DisbursementType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDocumentArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDocumentInstanceArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDocumentInstancesArgs = {
  where: DocumentInstance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDocumentTemplateArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDocumentTemplateApplicationArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDocumentTemplateApplicationsArgs = {
  where: DocumentTemplateApplication_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDocumentTemplatesArgs = {
  where: DocumentTemplate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDocumentsArgs = {
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEligibilityRuleArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEligibilityRuleDefinitionArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEligibilityRuleDefinitionsArgs = {
  where: EligibilityRuleDefinition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEligibilityRulesArgs = {
  where: EligibilityRule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEligibilityTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteEligibilityTypesArgs = {
  where: EligibilityType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityBillingInformationArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityBillingInformationsArgs = {
  where: EntityBillingInformation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityConfigurationItemArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityConfigurationItemsArgs = {
  where: EntityConfigurationItem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityContentTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityContentTypesArgs = {
  where: EntityContentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityCustomFieldArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityCustomFieldValueArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityCustomFieldValuesArgs = {
  where: EntityCustomFieldValue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityCustomFieldsArgs = {
  where: EntityCustomField_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityDataDefinitionArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityDataDefinitionsArgs = {
  where: EntityDataDefinition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityEligibilityRuleArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityEligibilityRulesArgs = {
  where: EntityEligibilityRule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityFeatureArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityFeaturesArgs = {
  where: EntityFeature_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityFileContentTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityFileContentTypesArgs = {
  where: EntityFileContentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityFileStorageArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityFileStoragesArgs = {
  where: EntityFileStorage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityNoteArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityNotesArgs = {
  where: EntityNote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityOfferingArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityOfferingsArgs = {
  where: EntityOffering_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityRemittanceDetailArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityRemittanceDetailsArgs = {
  where: EntityRemittanceDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEntityTagArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntityTagsArgs = {
  where: EntityTag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFeatureArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFeaturesArgs = {
  where: Feature_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileStorageArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFileStorageTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFileStorageTypesArgs = {
  where: FileStorageType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileStoragesArgs = {
  where: FileStorage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFilingLenderArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFilingLenderMatchArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFilingLenderMatchesArgs = {
  where: FilingLenderMatch_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFilingLendersArgs = {
  where: FilingLender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFilingStateArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFilingStatesArgs = {
  where: FilingState_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFilingStatusTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFilingStatusTypesArgs = {
  where: FilingStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFlowItemArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFlowItemTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFlowItemTypesArgs = {
  where: FlowItemType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFlowItemsArgs = {
  where: FlowItem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFlowTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFlowTypesArgs = {
  where: FlowType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteIdentitiesArgs = {
  where: Identity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteIdentityArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIdentityAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIdentityAs400sArgs = {
  where: IdentityAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteIdentityCapabilitiesArgs = {
  where: IdentityCapability_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteIdentityCapabilityArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIdentityEntitiesArgs = {
  where: IdentityEntity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteIdentityEntityArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIdentityFilterArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIdentityFiltersArgs = {
  where: IdentityFilter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteInvoiceArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoiceDocumentTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoiceDocumentTypesArgs = {
  where: InvoiceDocumentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteInvoicePaymentTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoicePaymentTypesArgs = {
  where: InvoicePaymentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteInvoicesArgs = {
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteJobArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobHistoriesArgs = {
  where: JobHistory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteJobHistoryArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobHistoryLogArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobHistoryLogsArgs = {
  where: JobHistoryLog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteJobScheduleArgs = {
  where: JobSchedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteJobSchedulesArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobStepArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobStepsArgs = {
  where: JobStep_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteJobsArgs = {
  where: Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteJournalEntriesArgs = {
  where: JournalEntry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteJournalEntryArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJournalEntryLineArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJournalEntryLinesArgs = {
  where: JournalEntryLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteLaborGuideTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLaborGuideTypesArgs = {
  where: LaborGuideType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteLaborRateArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLaborRateAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLaborRateAs400sArgs = {
  where: LaborRateAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteLaborRatesArgs = {
  where: LaborRate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteLegacyPolicyContractArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLegacyPolicyContractsArgs = {
  where: LegacyPolicyContract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteLoggedActionsArgs = {
  where: LoggedAction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteLossRatioArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLossRatiosArgs = {
  where: LossRatio_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteMilesCalculationTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMilesCalculationTypesArgs = {
  where: MilesCalculationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteObligorArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteObligorsArgs = {
  where: Obligor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteObsoleteJobArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteObsoleteJobsArgs = {
  where: ObsoleteJob_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteOutboxEventArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteOutboxEventsArgs = {
  where: OutboxEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteParticipantArgs = {
  identityId: Scalars['uuid'];
  parentId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteParticipantsArgs = {
  where: Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePayeeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePayeeAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePayeeAs400sArgs = {
  where: PayeeAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePayeesArgs = {
  where: Payee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePaymentArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentAs400sArgs = {
  where: PaymentAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePaymentDetailArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentDetailsArgs = {
  where: PaymentDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodTypesArgs = {
  where: PaymentMethodType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePaymentStatusTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentStatusTypesArgs = {
  where: PaymentStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePaymentTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentTypesArgs = {
  where: PaymentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePaymentsArgs = {
  where: Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePlanArgs = {
  PlanID: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeletePlansArgs = {
  where: Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePoliciesArgs = {
  where: Policy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyClaimArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyClaimAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyClaimAs400sArgs = {
  where: PolicyClaimAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyClaimConcernArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyClaimConcernsArgs = {
  where: PolicyClaimConcern_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyClaimInsuranceArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyClaimInsurancesArgs = {
  where: PolicyClaimInsurance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyClaimsArgs = {
  where: PolicyClaim_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractAssetArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractAssetTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractAssetTypesArgs = {
  where: PolicyContractAssetType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractAssetsArgs = {
  where: PolicyContractAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractContractFormVersionArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractContractFormVersionsArgs = {
  where: PolicyContractContractFormVersion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractCostDetailArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractCostDetailsArgs = {
  where: PolicyContractCostDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractLenderArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractLendersArgs = {
  where: PolicyContractLender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractLoanContractTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractLoanContractTypesArgs = {
  where: PolicyContractLoanContractType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractOwnerArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractOwnersArgs = {
  where: PolicyContractOwner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractProductArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractProductCostDetailArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractProductCostDetailsArgs = {
  where: PolicyContractProductCostDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractProductsArgs = {
  where: PolicyContractProduct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractQuoteArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractQuotesArgs = {
  where: PolicyContractQuote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractStatusTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractStatusTypesArgs = {
  where: PolicyContractStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractVoidReasonTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePolicyContractVoidReasonTypesArgs = {
  where: PolicyContractVoidReasonType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyContractsArgs = {
  where: PolicyContract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePreAuthorizationArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePreAuthorizationStatusTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePreAuthorizationStatusTypesArgs = {
  where: PreAuthorizationStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePreAuthorizationTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePreAuthorizationTypesArgs = {
  where: PreAuthorizationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePreAuthorizationsArgs = {
  where: PreAuthorization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProductAttributeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProductAttributeTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteProductAttributeTypesArgs = {
  where: ProductAttributeType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductAttributesArgs = {
  where: ProductAttribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductClassGuideArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProductClassGuidesArgs = {
  where: ProductClassGuide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductContractFormArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProductContractFormsArgs = {
  where: ProductContractForm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductCostArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProductCostsArgs = {
  where: ProductCost_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductDisbursementArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProductDisbursementsArgs = {
  where: ProductDisbursement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductEligibilitiesArgs = {
  where: ProductEligibility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductEligibilityArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProductObligorArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProductObligorsArgs = {
  where: ProductObligor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductRateBucketArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProductRateBucketsArgs = {
  where: ProductRateBucket_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductSurchargeTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProductSurchargeTypesArgs = {
  where: ProductSurchargeType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProductsArgs = {
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProfileArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteProfilesArgs = {
  where: Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteQuoteArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteQuoteMinimalViewsArgs = {
  where: QuoteMinimalView_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteQuoteTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteQuoteTypesArgs = {
  where: QuoteType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteQuotesArgs = {
  where: Quote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRateBucketTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteRateBucketTypesArgs = {
  where: RateBucketType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRateQuoteArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRateQuotesArgs = {
  where: RateQuote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRaterViewConfigArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRaterViewConfigsArgs = {
  where: RaterViewConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteReferenceLogArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteReferenceLogsArgs = {
  where: ReferenceLog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRemittanceArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRemittanceClaimDetailArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRemittanceClaimDetailsArgs = {
  where: RemittanceClaimDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRemittancePaymentArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRemittancePaymentsArgs = {
  where: RemittancePayment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRemittancePolicyContractArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRemittancePolicyContractAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRemittancePolicyContractAs400sArgs = {
  where: RemittancePolicyContractAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRemittancePolicyContractsArgs = {
  where: RemittancePolicyContract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRemittanceStatusTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRemittanceStatusTypesArgs = {
  where: RemittanceStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRemittanceTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRemittanceTypesArgs = {
  where: RemittanceType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRemittancesArgs = {
  where: Remittance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRepeatPartAcknowledgmentArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRepeatPartAcknowledgmentsArgs = {
  where: RepeatPartAcknowledgment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRoleArgs = {
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRoleAttributeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRoleAttributesArgs = {
  where: RoleAttribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRolesArgs = {
  updates: Array<Role_Updates>;
};


/** mutation root */
export type Mutation_RootDeleteRouteArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRouteConfigArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRouteConfigsArgs = {
  where: RouteConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRoutesArgs = {
  where: Route_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSearchIndexArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteSearchIndexesArgs = {
  where: SearchIndex_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSelectStateArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteSelectStatesArgs = {
  where: State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteServiceCenterArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteServiceCentersArgs = {
  where: ServiceCenter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSeverityLevelTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteSeverityLevelTypesArgs = {
  where: SeverityLevelType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteShortcutBindingArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteShortcutBindingsArgs = {
  where: ShortcutBinding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteStepArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteStepTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteStepTypesArgs = {
  where: StepType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteStepsArgs = {
  where: Step_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSurchargeTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteSurchargeTypesArgs = {
  where: SurchargeType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteTagArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTagsArgs = {
  where: Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteTaskArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTasksArgs = {
  where: Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteTaxRateArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTaxRateAs400Args = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTaxRateAs400sArgs = {
  where: TaxRateAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteTaxRatesArgs = {
  where: TaxRate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteTechnologyTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTechnologyTypesArgs = {
  where: TechnologyType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTypeGroupArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTypeGroupsArgs = {
  where: TypeGroup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteTypesArgs = {
  where: Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserFlowItemArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserFlowItemMfaArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserFlowItemMfasArgs = {
  where: UserFlowItemMfa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserFlowItemsArgs = {
  where: UserFlowItem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserGroupArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserGroupsArgs = {
  where: UserGroup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserPinArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPinsArgs = {
  where: UserPin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserProfileArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserProfilesArgs = {
  where: UserProfile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserSessionArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserSessionsArgs = {
  where: UserSession_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteValidationArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteValidationLifecycleHookArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteValidationLifecycleHooksArgs = {
  where: ValidationLifecycleHook_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteValidationOverrideArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteValidationOverridesArgs = {
  where: ValidationOverride_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteValidationRuleForArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteValidationRuleForsArgs = {
  where: ValidationRuleFor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteValidationTypeOperationArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteValidationTypeOperationsArgs = {
  where: ValidationTypeOperation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteValidationWhenArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteValidationWhensArgs = {
  where: ValidationWhen_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteValidationsArgs = {
  where: Validation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteVehicleArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVehicleStatusTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteVehicleStatusTypesArgs = {
  where: VehicleStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteVehiclesArgs = {
  where: Vehicle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteVpicDecodeAlternativeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVpicDecodeAlternativesArgs = {
  where: VpicDecodeAlternative_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteWorkStatusTypeArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteWorkStatusTypesArgs = {
  where: WorkStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteWorkflowStateTypeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteWorkflowStateTypesArgs = {
  where: WorkflowStateType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AbsArgs = {
  where: Abs_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Abs_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AdaptiveCruiseControlArgs = {
  where: AdaptiveCruiseControl_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_AdaptiveCruiseControl_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AdaptiveDrivingBeamArgs = {
  where: AdaptiveDrivingBeam_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_AdaptiveDrivingBeam_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AirBagLocFrontArgs = {
  where: AirBagLocFront_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_AirBagLocFront_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AirBagLocKneeArgs = {
  where: AirBagLocKnee_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_AirBagLocKnee_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AirBagLocationsArgs = {
  where: AirBagLocations_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_AirBagLocations_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AutoBrakeArgs = {
  where: AutoBrake_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_AutoBrake_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AutoReverseSystemArgs = {
  where: AutoReverseSystem_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_AutoReverseSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AutomaticPedestrainAlertingSoundArgs = {
  where: AutomaticPedestrainAlertingSound_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_AutomaticPedestrainAlertingSound_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AxleConfigurationArgs = {
  where: AxleConfiguration_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_AxleConfiguration_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BatteryTypeArgs = {
  where: BatteryType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_BatteryType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BedTypeArgs = {
  where: BedType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_BedType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BlindSpotInterventionArgs = {
  where: BlindSpotIntervention_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_BlindSpotIntervention_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BlindSpotMonitoringArgs = {
  where: BlindSpotMonitoring_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_BlindSpotMonitoring_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BodyCabArgs = {
  where: BodyCab_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_BodyCab_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BodyStyleArgs = {
  where: BodyStyle_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_BodyStyle_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BrakeSystemArgs = {
  where: BrakeSystem_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_BrakeSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BusFloorConfigTypeArgs = {
  where: BusFloorConfigType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_BusFloorConfigType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BusTypeArgs = {
  where: BusType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_BusType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Can_AacnArgs = {
  where: Can_Aacn_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Can_Aacn_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ChargerLevelArgs = {
  where: ChargerLevel_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_ChargerLevel_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CombinedBrakingSystemArgs = {
  where: CombinedBrakingSystem_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_CombinedBrakingSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ContractMasterSurchargeArgs = {
  where: ContractMasterSurcharge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConversionArgs = {
  where: Conversion_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Conversion_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CoolingTypeArgs = {
  where: CoolingType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_CoolingType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CountryArgs = {
  where: Country_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Country_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CustomMotorcycleTypeArgs = {
  where: CustomMotorcycleType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_CustomMotorcycleType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DaytimeRunningLightArgs = {
  where: DaytimeRunningLight_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_DaytimeRunningLight_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DefaultValueArgs = {
  where: DefaultValue_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_DefaultValue_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DestinationMarketArgs = {
  where: DestinationMarket_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_DestinationMarket_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DriveTypeArgs = {
  where: DriveType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_DriveType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DynamicBrakeSupportArgs = {
  where: DynamicBrakeSupport_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_DynamicBrakeSupport_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_EcsArgs = {
  where: Ecs_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Ecs_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_EdrArgs = {
  where: Edr_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Edr_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_EvDriveUnitArgs = {
  where: EvDriveUnit_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_EvDriveUnit_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ElectrificationLevelArgs = {
  where: ElectrificationLevel_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_ElectrificationLevel_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ElementArgs = {
  where: Element_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Element_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_EngineConfigurationArgs = {
  where: EngineConfiguration_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_EngineConfiguration_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_EngineModelArgs = {
  where: EngineModel_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_EngineModelPatternArgs = {
  where: EngineModelPattern_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_EngineModelPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_EngineModel_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_EntertainmentSystemArgs = {
  where: EntertainmentSystem_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_EntertainmentSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ErrorCodeArgs = {
  where: ErrorCode_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_ErrorCode_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ForwardCollisionWarningArgs = {
  where: ForwardCollisionWarning_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_ForwardCollisionWarning_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FuelDeliveryTypeArgs = {
  where: FuelDeliveryType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_FuelDeliveryType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FuelTankMaterialArgs = {
  where: FuelTankMaterial_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_FuelTankMaterial_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FuelTankTypeArgs = {
  where: FuelTankType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_FuelTankType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FuelTypeArgs = {
  where: FuelType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_FuelType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_GrossVehicleWeightRatingArgs = {
  where: GrossVehicleWeightRating_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_GrossVehicleWeightRating_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_KeylessIgnitionArgs = {
  where: KeylessIgnition_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_KeylessIgnition_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LaneCenteringAssistanceArgs = {
  where: LaneCenteringAssistance_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_LaneCenteringAssistance_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LaneDepartureWarningArgs = {
  where: LaneDepartureWarning_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_LaneDepartureWarning_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LaneKeepSystemArgs = {
  where: LaneKeepSystem_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_LaneKeepSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LowerBeamHeadlampLightSourceArgs = {
  where: LowerBeamHeadlampLightSource_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_LowerBeamHeadlampLightSource_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_MakeArgs = {
  where: Make_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Make_ModelArgs = {
  where: Make_Model_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Make_Model_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Make_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ManufacturerArgs = {
  where: Manufacturer_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Manufacturer_MakeArgs = {
  where: Manufacturer_Make_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Manufacturer_Make_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Manufacturer_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ModelArgs = {
  where: Model_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Model_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_MotorcycleChassisTypeArgs = {
  where: MotorcycleChassisType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_MotorcycleChassisType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_MotorcycleSuspensionTypeArgs = {
  where: MotorcycleSuspensionType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_MotorcycleSuspensionType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_NonLandUseArgs = {
  where: NonLandUse_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_NonLandUse_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ParkAssistArgs = {
  where: ParkAssist_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_ParkAssist_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PatternArgs = {
  where: Pattern_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Pattern_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PedestrianAutomaticEmergencyBrakingArgs = {
  where: PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_PedestrianAutomaticEmergencyBraking_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PretensionerArgs = {
  where: Pretensioner_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Pretensioner_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RearAutomaticEmergencyBrakingArgs = {
  where: RearAutomaticEmergencyBraking_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_RearAutomaticEmergencyBraking_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RearCrossTrafficAlertArgs = {
  where: RearCrossTrafficAlert_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_RearCrossTrafficAlert_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RearVisibilityCameraArgs = {
  where: RearVisibilityCamera_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_RearVisibilityCamera_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SeatBeltsAllArgs = {
  where: SeatBeltsAll_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_SeatBeltsAll_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SemiautomaticHeadlampBeamSwitchingArgs = {
  where: SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_SemiautomaticHeadlampBeamSwitching_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SteeringArgs = {
  where: Steering_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Steering_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TpmsArgs = {
  where: Tpms_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Tpms_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TractionControlArgs = {
  where: TractionControl_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_TractionControl_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TrailerBodyTypeArgs = {
  where: TrailerBodyType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_TrailerBodyType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TrailerTypeArgs = {
  where: TrailerType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_TrailerType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TransmissionArgs = {
  where: Transmission_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Transmission_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TurboArgs = {
  where: Turbo_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Turbo_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VSpecSchemaPatternArgs = {
  where: VSpecSchemaPattern_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_VSpecSchemaPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ValvetrainDesignArgs = {
  where: ValvetrainDesign_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_ValvetrainDesign_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VehicleSpecPatternArgs = {
  where: VehicleSpecPattern_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_VehicleSpecPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VehicleSpecSchemaArgs = {
  where: VehicleSpecSchema_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_VehicleSpecSchema_ModelArgs = {
  where: VehicleSpecSchema_Model_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_VehicleSpecSchema_Model_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VehicleSpecSchema_YearArgs = {
  where: VehicleSpecSchema_Year_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_VehicleSpecSchema_Year_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VehicleSpecSchema_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VehicleTypeArgs = {
  where: VehicleType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_VehicleType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VinDescriptorArgs = {
  where: VinDescriptor_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_VinDescriptor_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VinExceptionArgs = {
  where: VinException_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_VinException_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VinSchemaArgs = {
  where: VinSchema_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_VinSchema_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_WmiYearValidCharsArgs = {
  where: WmiYearValidChars_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_WmiYearValidChars_CacheExceptionsArgs = {
  where: WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_WmiYearValidChars_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_WheelBaseTypeArgs = {
  where: WheelBaseType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_WheelBaseType_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_WheelieMitigationArgs = {
  where: WheelieMitigation_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_WheelieMitigation_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_WmiArgs = {
  where: Wmi_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Wmi_MakeArgs = {
  where: Wmi_Make_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Wmi_Make_By_PkArgs = {
  MakeId: Scalars['Int'];
  WmiId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Wmi_VinSchemaArgs = {
  where: Wmi_VinSchema_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootDelete_Wmi_VinSchema_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Wmi_By_PkArgs = {
  Id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Audit_Message_Formatter_ConfigArgs = {
  where: Audit_Message_Formatter_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Audit_Message_Formatter_Config_By_PkArgs = {
  field_name: Scalars['String'];
  formatter_strategy: Scalars['String'];
  schema_name: Scalars['String'];
  table_name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_GroupArgs = {
  where: Auth_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Group_ActionsArgs = {
  where: Auth_Group_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Group_Actions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Claims_Pre_Authorization_Vehicle_InformationArgs = {
  where: Claims_Pre_Authorization_Vehicle_Information_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Claims_Pre_Authorization_Vehicle_Information_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Claims_Temp_Claims_Auth_TableArgs = {
  where: Claims_Temp_Claims_Auth_Table_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Claims_Temp_Claims_Auth_Table_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ConcernSynonymArgs = {
  where: ConcernSynonym_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootDelete_ConcernSynonym_By_PkArgs = {
  groupName: Scalars['String'];
  term: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_IdentitiesArgs = {
  where: Identities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Identities_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_IdentityCapabilityViewArgs = {
  where: IdentityCapabilityView_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_InvestigationRecallArgs = {
  where: InvestigationRecall_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootDelete_InvestigationRecall_By_PkArgs = {
  investigationIssueId: Scalars['String'];
  recallNumber: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_IssueArgs = {
  where: Issue_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootDelete_IssueMakeModelArgs = {
  where: IssueMakeModel_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootDelete_IssueSearchResultArgs = {
  where: IssueSearchResult_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootDelete_Issue_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_LoadArgs = {
  where: Load_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootDelete_Load_By_PkArgs = {
  dataset: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_MakeModelArgs = {
  where: MakeModel_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootDelete_MakeModel_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ModelYearModelArgs = {
  where: ModelYearModel_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootDelete_ModelYearModel_By_PkArgs = {
  makeKey: Scalars['String'];
  model: Scalars['String'];
  modelYear: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Operations_Legacy_Policy_Contract_Cost_Detail_ViewArgs = {
  where: Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RecordTypeArgs = {
  where: RecordType_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootDelete_RecordType_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Shared_Search_ResultArgs = {
  where: Shared_Search_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VehicleClassingBodyStyleArgs = {
  where: VehicleClassingBodyStyle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VehicleClassingFuelTypeArgs = {
  where: VehicleClassingFuelType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VehicleClassingVehicleMakeArgs = {
  where: VehicleClassingVehicleMake_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VehicleClassingVehicleTypeArgs = {
  where: VehicleClassingVehicleType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VwVehicleCylindersDistinctArgs = {
  where: VwVehicleCylindersDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VwVehicleDrivingWheelsDistinctArgs = {
  where: VwVehicleDrivingWheelsDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VwVehicleFuelTypesDistinctArgs = {
  where: VwVehicleFuelTypesDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VwVehicleMakesDistinctArgs = {
  where: VwVehicleMakesDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VwVehicleModelsDistinctArgs = {
  where: VwVehicleModelsDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VwVehicleYearsDistinctArgs = {
  where: VwVehicleYearsDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootInsertAccountArgs = {
  object: Account_Insert_Input;
  on_conflict?: InputMaybe<Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountAccountManagerArgs = {
  object: AccountAccountManager_Insert_Input;
  on_conflict?: InputMaybe<AccountAccountManager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountAccountManagersArgs = {
  objects: Array<AccountAccountManager_Insert_Input>;
  on_conflict?: InputMaybe<AccountAccountManager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountCategoriesArgs = {
  objects: Array<AccountCategory_Insert_Input>;
  on_conflict?: InputMaybe<AccountCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountCategoryArgs = {
  object: AccountCategory_Insert_Input;
  on_conflict?: InputMaybe<AccountCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountDisbursementArgs = {
  object: AccountDisbursement_Insert_Input;
  on_conflict?: InputMaybe<AccountDisbursement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountDisbursementsArgs = {
  objects: Array<AccountDisbursement_Insert_Input>;
  on_conflict?: InputMaybe<AccountDisbursement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountManagerArgs = {
  object: AccountManager_Insert_Input;
  on_conflict?: InputMaybe<AccountManager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountManagersArgs = {
  objects: Array<AccountManager_Insert_Input>;
  on_conflict?: InputMaybe<AccountManager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountObligorArgs = {
  object: AccountObligor_Insert_Input;
  on_conflict?: InputMaybe<AccountObligor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountObligorsArgs = {
  objects: Array<AccountObligor_Insert_Input>;
  on_conflict?: InputMaybe<AccountObligor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountProductArgs = {
  object: AccountProduct_Insert_Input;
  on_conflict?: InputMaybe<AccountProduct_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountProductObligorArgs = {
  object: AccountProductObligor_Insert_Input;
  on_conflict?: InputMaybe<AccountProductObligor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountProductObligorsArgs = {
  objects: Array<AccountProductObligor_Insert_Input>;
  on_conflict?: InputMaybe<AccountProductObligor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountProductsArgs = {
  objects: Array<AccountProduct_Insert_Input>;
  on_conflict?: InputMaybe<AccountProduct_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountRetailArgs = {
  object: AccountRetail_Insert_Input;
  on_conflict?: InputMaybe<AccountRetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountRetailsArgs = {
  objects: Array<AccountRetail_Insert_Input>;
  on_conflict?: InputMaybe<AccountRetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountTypeArgs = {
  object: AccountType_Insert_Input;
  on_conflict?: InputMaybe<AccountType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountTypesArgs = {
  objects: Array<AccountType_Insert_Input>;
  on_conflict?: InputMaybe<AccountType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountsArgs = {
  objects: Array<Account_Insert_Input>;
  on_conflict?: InputMaybe<Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAddressArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAddressTypeArgs = {
  object: AddressType_Insert_Input;
  on_conflict?: InputMaybe<AddressType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAddressTypesArgs = {
  objects: Array<AddressType_Insert_Input>;
  on_conflict?: InputMaybe<AddressType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAddressesArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAlertArgs = {
  object: Alert_Insert_Input;
  on_conflict?: InputMaybe<Alert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAlertAcknowledgmentArgs = {
  object: AlertAcknowledgment_Insert_Input;
  on_conflict?: InputMaybe<AlertAcknowledgment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAlertAcknowledgmentsArgs = {
  objects: Array<AlertAcknowledgment_Insert_Input>;
  on_conflict?: InputMaybe<AlertAcknowledgment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAlertsArgs = {
  objects: Array<Alert_Insert_Input>;
  on_conflict?: InputMaybe<Alert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApplicationArgs = {
  object: Application_Insert_Input;
  on_conflict?: InputMaybe<Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApplicationPreferenceArgs = {
  object: ApplicationPreference_Insert_Input;
  on_conflict?: InputMaybe<ApplicationPreference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApplicationPreferencesArgs = {
  objects: Array<ApplicationPreference_Insert_Input>;
  on_conflict?: InputMaybe<ApplicationPreference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApplicationsArgs = {
  objects: Array<Application_Insert_Input>;
  on_conflict?: InputMaybe<Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalArgs = {
  object: Approval_Insert_Input;
  on_conflict?: InputMaybe<Approval_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalAuthoritiesArgs = {
  objects: Array<ApprovalAuthority_Insert_Input>;
  on_conflict?: InputMaybe<ApprovalAuthority_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalAuthorityArgs = {
  object: ApprovalAuthority_Insert_Input;
  on_conflict?: InputMaybe<ApprovalAuthority_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalGateArgs = {
  object: ApprovalGate_Insert_Input;
  on_conflict?: InputMaybe<ApprovalGate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalGateBindingArgs = {
  object: ApprovalGateBinding_Insert_Input;
  on_conflict?: InputMaybe<ApprovalGateBinding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalGateBindingsArgs = {
  objects: Array<ApprovalGateBinding_Insert_Input>;
  on_conflict?: InputMaybe<ApprovalGateBinding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalGatesArgs = {
  objects: Array<ApprovalGate_Insert_Input>;
  on_conflict?: InputMaybe<ApprovalGate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalRecordsArgs = {
  objects: Array<Approval_Insert_Input>;
  on_conflict?: InputMaybe<Approval_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalRequestArgs = {
  object: ApprovalRequest_Insert_Input;
  on_conflict?: InputMaybe<ApprovalRequest_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalRequestsArgs = {
  objects: Array<ApprovalRequest_Insert_Input>;
  on_conflict?: InputMaybe<ApprovalRequest_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertApprovalStateArgs = {
  object: ApprovalState_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsertApprovalStatesArgs = {
  objects: Array<ApprovalState_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsertAs400DataSyncArgs = {
  object: As400DataSync_Insert_Input;
  on_conflict?: InputMaybe<As400DataSync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAs400DataSyncsArgs = {
  objects: Array<As400DataSync_Insert_Input>;
  on_conflict?: InputMaybe<As400DataSync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBankAccountTypeArgs = {
  object: BankAccountType_Insert_Input;
  on_conflict?: InputMaybe<BankAccountType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBankAccountTypesArgs = {
  objects: Array<BankAccountType_Insert_Input>;
  on_conflict?: InputMaybe<BankAccountType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCaddyArgs = {
  object: Caddy_Insert_Input;
  on_conflict?: InputMaybe<Caddy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCaddyServerManagerLogArgs = {
  object: CaddyServerManagerLog_Insert_Input;
  on_conflict?: InputMaybe<CaddyServerManagerLog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCaddyServerManagerLogsArgs = {
  objects: Array<CaddyServerManagerLog_Insert_Input>;
  on_conflict?: InputMaybe<CaddyServerManagerLog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCaddysArgs = {
  objects: Array<Caddy_Insert_Input>;
  on_conflict?: InputMaybe<Caddy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCancelRuleArgs = {
  object: CancelRule_Insert_Input;
  on_conflict?: InputMaybe<CancelRule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCancelRuleFeeArgs = {
  object: CancelRuleFee_Insert_Input;
  on_conflict?: InputMaybe<CancelRuleFee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCancelRuleFeesArgs = {
  objects: Array<CancelRuleFee_Insert_Input>;
  on_conflict?: InputMaybe<CancelRuleFee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCancelRuleRefundArgs = {
  object: CancelRuleRefund_Insert_Input;
  on_conflict?: InputMaybe<CancelRuleRefund_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCancelRuleRefundsArgs = {
  objects: Array<CancelRuleRefund_Insert_Input>;
  on_conflict?: InputMaybe<CancelRuleRefund_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCancelRulesArgs = {
  objects: Array<CancelRule_Insert_Input>;
  on_conflict?: InputMaybe<CancelRule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCancellationArgs = {
  object: Cancellation_Insert_Input;
  on_conflict?: InputMaybe<Cancellation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCancellationAs400Args = {
  object: CancellationAs400_Insert_Input;
  on_conflict?: InputMaybe<CancellationAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCancellationAs400sArgs = {
  objects: Array<CancellationAs400_Insert_Input>;
  on_conflict?: InputMaybe<CancellationAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCancellationsArgs = {
  objects: Array<Cancellation_Insert_Input>;
  on_conflict?: InputMaybe<Cancellation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCapabilitiesArgs = {
  objects: Array<Capability_Insert_Input>;
  on_conflict?: InputMaybe<Capability_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCapabilityArgs = {
  object: Capability_Insert_Input;
  on_conflict?: InputMaybe<Capability_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCapabilityConfigArgs = {
  object: CapabilityConfig_Insert_Input;
  on_conflict?: InputMaybe<CapabilityConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCapabilityConfigsArgs = {
  objects: Array<CapabilityConfig_Insert_Input>;
  on_conflict?: InputMaybe<CapabilityConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCapabilityRouteArgs = {
  object: CapabilityRoute_Insert_Input;
  on_conflict?: InputMaybe<CapabilityRoute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCapabilityRoutesArgs = {
  objects: Array<CapabilityRoute_Insert_Input>;
  on_conflict?: InputMaybe<CapabilityRoute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCardLayoutArgs = {
  object: CardLayout_Insert_Input;
  on_conflict?: InputMaybe<CardLayout_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCardLayoutsArgs = {
  objects: Array<CardLayout_Insert_Input>;
  on_conflict?: InputMaybe<CardLayout_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCarrierArgs = {
  object: Carrier_Insert_Input;
  on_conflict?: InputMaybe<Carrier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCarriersArgs = {
  objects: Array<Carrier_Insert_Input>;
  on_conflict?: InputMaybe<Carrier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoriesArgs = {
  objects: Array<Category_Insert_Input>;
  on_conflict?: InputMaybe<Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoryArgs = {
  object: Category_Insert_Input;
  on_conflict?: InputMaybe<Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoryProductAttributeTypeArgs = {
  object: CategoryProductAttributeType_Insert_Input;
  on_conflict?: InputMaybe<CategoryProductAttributeType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoryProductAttributeTypesArgs = {
  objects: Array<CategoryProductAttributeType_Insert_Input>;
  on_conflict?: InputMaybe<CategoryProductAttributeType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimArgs = {
  object: Claim_Insert_Input;
  on_conflict?: InputMaybe<Claim_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimDetailArgs = {
  object: ClaimDetail_Insert_Input;
  on_conflict?: InputMaybe<ClaimDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimDetailAs400Args = {
  object: ClaimDetailAs400_Insert_Input;
  on_conflict?: InputMaybe<ClaimDetailAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimDetailAs400sArgs = {
  objects: Array<ClaimDetailAs400_Insert_Input>;
  on_conflict?: InputMaybe<ClaimDetailAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimDetailCategoriesArgs = {
  objects: Array<ClaimDetailCategory_Insert_Input>;
  on_conflict?: InputMaybe<ClaimDetailCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimDetailCategoryArgs = {
  object: ClaimDetailCategory_Insert_Input;
  on_conflict?: InputMaybe<ClaimDetailCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimDetailDeductionAs400Args = {
  object: ClaimDetailDeductionAs400_Insert_Input;
  on_conflict?: InputMaybe<ClaimDetailDeductionAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimDetailDeductionAs400sArgs = {
  objects: Array<ClaimDetailDeductionAs400_Insert_Input>;
  on_conflict?: InputMaybe<ClaimDetailDeductionAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimDetailPartLookupArgs = {
  object: ClaimDetailPartLookup_Insert_Input;
  on_conflict?: InputMaybe<ClaimDetailPartLookup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimDetailPartLookupsArgs = {
  objects: Array<ClaimDetailPartLookup_Insert_Input>;
  on_conflict?: InputMaybe<ClaimDetailPartLookup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimDetailsArgs = {
  objects: Array<ClaimDetail_Insert_Input>;
  on_conflict?: InputMaybe<ClaimDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimServiceCenterArgs = {
  object: ClaimServiceCenter_Insert_Input;
  on_conflict?: InputMaybe<ClaimServiceCenter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimServiceCenterAs400Args = {
  object: ClaimServiceCenterAs400_Insert_Input;
  on_conflict?: InputMaybe<ClaimServiceCenterAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimServiceCenterAs400sArgs = {
  objects: Array<ClaimServiceCenterAs400_Insert_Input>;
  on_conflict?: InputMaybe<ClaimServiceCenterAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimServiceCenterAuthorizationArgs = {
  object: ClaimServiceCenterAuthorization_Insert_Input;
  on_conflict?: InputMaybe<ClaimServiceCenterAuthorization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimServiceCenterAuthorizationsArgs = {
  objects: Array<ClaimServiceCenterAuthorization_Insert_Input>;
  on_conflict?: InputMaybe<ClaimServiceCenterAuthorization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimServiceCentersArgs = {
  objects: Array<ClaimServiceCenter_Insert_Input>;
  on_conflict?: InputMaybe<ClaimServiceCenter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimStatusArgs = {
  if_matched?: InputMaybe<ClaimStatus_If_Matched>;
  object: ClaimStatus_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsertClaimStatusTypeArgs = {
  object: ClaimStatusType_Insert_Input;
  on_conflict?: InputMaybe<ClaimStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimStatusTypesArgs = {
  objects: Array<ClaimStatusType_Insert_Input>;
  on_conflict?: InputMaybe<ClaimStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimStatusesArgs = {
  if_matched?: InputMaybe<ClaimStatus_If_Matched>;
  objects: Array<ClaimStatus_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsertClaimsArgs = {
  objects: Array<Claim_Insert_Input>;
  on_conflict?: InputMaybe<Claim_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClaimsMasterArgs = {
  if_matched?: InputMaybe<ClaimsMaster_If_Matched>;
  object: ClaimsMaster_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsertClaimsMastersArgs = {
  if_matched?: InputMaybe<ClaimsMaster_If_Matched>;
  objects: Array<ClaimsMaster_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsertClassCriteriaArgs = {
  object: ClassCriteria_Insert_Input;
  on_conflict?: InputMaybe<ClassCriteria_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClassCriteriasArgs = {
  objects: Array<ClassCriteria_Insert_Input>;
  on_conflict?: InputMaybe<ClassCriteria_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClassGuideArgs = {
  object: ClassGuide_Insert_Input;
  on_conflict?: InputMaybe<ClassGuide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClassGuideClassCriteriaArgs = {
  object: ClassGuideClassCriteria_Insert_Input;
  on_conflict?: InputMaybe<ClassGuideClassCriteria_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClassGuideClassCriteriasArgs = {
  objects: Array<ClassGuideClassCriteria_Insert_Input>;
  on_conflict?: InputMaybe<ClassGuideClassCriteria_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClassGuideCriteriaDefinitionArgs = {
  object: ClassGuideCriteriaDefinition_Insert_Input;
  on_conflict?: InputMaybe<ClassGuideCriteriaDefinition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClassGuideCriteriaDefinitionsArgs = {
  objects: Array<ClassGuideCriteriaDefinition_Insert_Input>;
  on_conflict?: InputMaybe<ClassGuideCriteriaDefinition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClassGuideCriteriaTypeArgs = {
  object: ClassGuideCriteriaType_Insert_Input;
  on_conflict?: InputMaybe<ClassGuideCriteriaType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClassGuideCriteriaTypesArgs = {
  objects: Array<ClassGuideCriteriaType_Insert_Input>;
  on_conflict?: InputMaybe<ClassGuideCriteriaType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertClassGuidesArgs = {
  objects: Array<ClassGuide_Insert_Input>;
  on_conflict?: InputMaybe<ClassGuide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCompositeProductArgs = {
  object: CompositeProduct_Insert_Input;
  on_conflict?: InputMaybe<CompositeProduct_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCompositeProductsArgs = {
  objects: Array<CompositeProduct_Insert_Input>;
  on_conflict?: InputMaybe<CompositeProduct_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertConfigurationItemArgs = {
  object: ConfigurationItem_Insert_Input;
  on_conflict?: InputMaybe<ConfigurationItem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertConfigurationItemTypeArgs = {
  object: ConfigurationItemType_Insert_Input;
  on_conflict?: InputMaybe<ConfigurationItemType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertConfigurationItemTypesArgs = {
  objects: Array<ConfigurationItemType_Insert_Input>;
  on_conflict?: InputMaybe<ConfigurationItemType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertConfigurationItemsArgs = {
  objects: Array<ConfigurationItem_Insert_Input>;
  on_conflict?: InputMaybe<ConfigurationItem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContactArgs = {
  object: Contact_Insert_Input;
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContactsArgs = {
  objects: Array<Contact_Insert_Input>;
  on_conflict?: InputMaybe<Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContentTypeArgs = {
  object: ContentType_Insert_Input;
  on_conflict?: InputMaybe<ContentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContentTypesArgs = {
  objects: Array<ContentType_Insert_Input>;
  on_conflict?: InputMaybe<ContentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractArgs = {
  object: Contract_Insert_Input;
  on_conflict?: InputMaybe<Contract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractFormArgs = {
  object: ContractForm_Insert_Input;
  on_conflict?: InputMaybe<ContractForm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractFormFilingStatusArgs = {
  object: ContractFormFilingStatus_Insert_Input;
  on_conflict?: InputMaybe<ContractFormFilingStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractFormFilingStatusesArgs = {
  objects: Array<ContractFormFilingStatus_Insert_Input>;
  on_conflict?: InputMaybe<ContractFormFilingStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractFormTypeArgs = {
  object: ContractFormType_Insert_Input;
  on_conflict?: InputMaybe<ContractFormType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractFormTypesArgs = {
  objects: Array<ContractFormType_Insert_Input>;
  on_conflict?: InputMaybe<ContractFormType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractFormVersionArgs = {
  object: ContractFormVersion_Insert_Input;
  on_conflict?: InputMaybe<ContractFormVersion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractFormVersionLegacyFileArgs = {
  object: ContractFormVersionLegacyFile_Insert_Input;
  on_conflict?: InputMaybe<ContractFormVersionLegacyFile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractFormVersionLegacyFilesArgs = {
  objects: Array<ContractFormVersionLegacyFile_Insert_Input>;
  on_conflict?: InputMaybe<ContractFormVersionLegacyFile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractFormVersionsArgs = {
  objects: Array<ContractFormVersion_Insert_Input>;
  on_conflict?: InputMaybe<ContractFormVersion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractFormsArgs = {
  objects: Array<ContractForm_Insert_Input>;
  on_conflict?: InputMaybe<ContractForm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractMasterArgs = {
  if_matched?: InputMaybe<ContractMaster_If_Matched>;
  object: ContractMaster_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsertContractMasterAdditionalEntitiesArgs = {
  if_matched?: InputMaybe<ContractMasterAdditionalEntity_If_Matched>;
  objects: Array<ContractMasterAdditionalEntity_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsertContractMasterAdditionalEntityArgs = {
  if_matched?: InputMaybe<ContractMasterAdditionalEntity_If_Matched>;
  object: ContractMasterAdditionalEntity_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsertContractMastersArgs = {
  if_matched?: InputMaybe<ContractMaster_If_Matched>;
  objects: Array<ContractMaster_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsertContractStatusTypeArgs = {
  object: ContractStatusType_Insert_Input;
  on_conflict?: InputMaybe<ContractStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractStatusTypesArgs = {
  objects: Array<ContractStatusType_Insert_Input>;
  on_conflict?: InputMaybe<ContractStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertContractsArgs = {
  objects: Array<Contract_Insert_Input>;
  on_conflict?: InputMaybe<Contract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCostAdjustmentArgs = {
  object: CostAdjustment_Insert_Input;
  on_conflict?: InputMaybe<CostAdjustment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCostAdjustmentExtendedCostArgs = {
  object: CostAdjustmentExtendedCost_Insert_Input;
  on_conflict?: InputMaybe<CostAdjustmentExtendedCost_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCostAdjustmentExtendedCostsArgs = {
  objects: Array<CostAdjustmentExtendedCost_Insert_Input>;
  on_conflict?: InputMaybe<CostAdjustmentExtendedCost_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCostAdjustmentLookupArgs = {
  object: CostAdjustmentLookup_Insert_Input;
  on_conflict?: InputMaybe<CostAdjustmentLookup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCostAdjustmentLookupsArgs = {
  objects: Array<CostAdjustmentLookup_Insert_Input>;
  on_conflict?: InputMaybe<CostAdjustmentLookup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCostAdjustmentTypeArgs = {
  object: CostAdjustmentType_Insert_Input;
  on_conflict?: InputMaybe<CostAdjustmentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCostAdjustmentTypesArgs = {
  objects: Array<CostAdjustmentType_Insert_Input>;
  on_conflict?: InputMaybe<CostAdjustmentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCostAdjustmentsArgs = {
  objects: Array<CostAdjustment_Insert_Input>;
  on_conflict?: InputMaybe<CostAdjustment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomFieldArgs = {
  object: CustomField_Insert_Input;
  on_conflict?: InputMaybe<CustomField_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomFieldDataArgs = {
  object: CustomFieldData_Insert_Input;
  on_conflict?: InputMaybe<CustomFieldData_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomFieldDatasArgs = {
  objects: Array<CustomFieldData_Insert_Input>;
  on_conflict?: InputMaybe<CustomFieldData_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomFieldTypeArgs = {
  object: CustomFieldType_Insert_Input;
  on_conflict?: InputMaybe<CustomFieldType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomFieldTypesArgs = {
  objects: Array<CustomFieldType_Insert_Input>;
  on_conflict?: InputMaybe<CustomFieldType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomFieldsArgs = {
  objects: Array<CustomField_Insert_Input>;
  on_conflict?: InputMaybe<CustomField_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomerArgs = {
  object: Customer_Insert_Input;
  on_conflict?: InputMaybe<Customer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomersArgs = {
  objects: Array<Customer_Insert_Input>;
  on_conflict?: InputMaybe<Customer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCycleArgs = {
  object: Cycle_Insert_Input;
  on_conflict?: InputMaybe<Cycle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCycleJournalEntriesArgs = {
  objects: Array<CycleJournalEntry_Insert_Input>;
  on_conflict?: InputMaybe<CycleJournalEntry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCycleJournalEntryArgs = {
  object: CycleJournalEntry_Insert_Input;
  on_conflict?: InputMaybe<CycleJournalEntry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCycleTotalArgs = {
  object: CycleTotal_Insert_Input;
  on_conflict?: InputMaybe<CycleTotal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCycleTotalsArgs = {
  objects: Array<CycleTotal_Insert_Input>;
  on_conflict?: InputMaybe<CycleTotal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertCyclesArgs = {
  objects: Array<Cycle_Insert_Input>;
  on_conflict?: InputMaybe<Cycle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDataTypeArgs = {
  object: DataType_Insert_Input;
  on_conflict?: InputMaybe<DataType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDataTypesArgs = {
  objects: Array<DataType_Insert_Input>;
  on_conflict?: InputMaybe<DataType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDateCalculationTypeArgs = {
  object: DateCalculationType_Insert_Input;
  on_conflict?: InputMaybe<DateCalculationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDateCalculationTypesArgs = {
  objects: Array<DateCalculationType_Insert_Input>;
  on_conflict?: InputMaybe<DateCalculationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDealerArgs = {
  if_matched?: InputMaybe<Dealer_If_Matched>;
  object: Dealer_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsertDealerPaymentTypeArgs = {
  object: DealerPaymentType_Insert_Input;
  on_conflict?: InputMaybe<DealerPaymentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDealerPaymentTypesArgs = {
  objects: Array<DealerPaymentType_Insert_Input>;
  on_conflict?: InputMaybe<DealerPaymentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDealersArgs = {
  if_matched?: InputMaybe<Dealer_If_Matched>;
  objects: Array<Dealer_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsertDisbursementTypeArgs = {
  object: DisbursementType_Insert_Input;
  on_conflict?: InputMaybe<DisbursementType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDisbursementTypesArgs = {
  objects: Array<DisbursementType_Insert_Input>;
  on_conflict?: InputMaybe<DisbursementType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDocumentArgs = {
  object: Document_Insert_Input;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDocumentInstanceArgs = {
  object: DocumentInstance_Insert_Input;
  on_conflict?: InputMaybe<DocumentInstance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDocumentInstancesArgs = {
  objects: Array<DocumentInstance_Insert_Input>;
  on_conflict?: InputMaybe<DocumentInstance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDocumentTemplateArgs = {
  object: DocumentTemplate_Insert_Input;
  on_conflict?: InputMaybe<DocumentTemplate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDocumentTemplateApplicationArgs = {
  object: DocumentTemplateApplication_Insert_Input;
  on_conflict?: InputMaybe<DocumentTemplateApplication_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDocumentTemplateApplicationsArgs = {
  objects: Array<DocumentTemplateApplication_Insert_Input>;
  on_conflict?: InputMaybe<DocumentTemplateApplication_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDocumentTemplatesArgs = {
  objects: Array<DocumentTemplate_Insert_Input>;
  on_conflict?: InputMaybe<DocumentTemplate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertDocumentsArgs = {
  objects: Array<Document_Insert_Input>;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEligibilityRuleArgs = {
  object: EligibilityRule_Insert_Input;
  on_conflict?: InputMaybe<EligibilityRule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEligibilityRuleDefinitionArgs = {
  object: EligibilityRuleDefinition_Insert_Input;
  on_conflict?: InputMaybe<EligibilityRuleDefinition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEligibilityRuleDefinitionsArgs = {
  objects: Array<EligibilityRuleDefinition_Insert_Input>;
  on_conflict?: InputMaybe<EligibilityRuleDefinition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEligibilityRulesArgs = {
  objects: Array<EligibilityRule_Insert_Input>;
  on_conflict?: InputMaybe<EligibilityRule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEligibilityTypeArgs = {
  object: EligibilityType_Insert_Input;
  on_conflict?: InputMaybe<EligibilityType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEligibilityTypesArgs = {
  objects: Array<EligibilityType_Insert_Input>;
  on_conflict?: InputMaybe<EligibilityType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityBillingInformationArgs = {
  object: EntityBillingInformation_Insert_Input;
  on_conflict?: InputMaybe<EntityBillingInformation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityBillingInformationsArgs = {
  objects: Array<EntityBillingInformation_Insert_Input>;
  on_conflict?: InputMaybe<EntityBillingInformation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityConfigurationItemArgs = {
  object: EntityConfigurationItem_Insert_Input;
  on_conflict?: InputMaybe<EntityConfigurationItem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityConfigurationItemsArgs = {
  objects: Array<EntityConfigurationItem_Insert_Input>;
  on_conflict?: InputMaybe<EntityConfigurationItem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityContentTypeArgs = {
  object: EntityContentType_Insert_Input;
  on_conflict?: InputMaybe<EntityContentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityContentTypesArgs = {
  objects: Array<EntityContentType_Insert_Input>;
  on_conflict?: InputMaybe<EntityContentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityCustomFieldArgs = {
  object: EntityCustomField_Insert_Input;
  on_conflict?: InputMaybe<EntityCustomField_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityCustomFieldValueArgs = {
  object: EntityCustomFieldValue_Insert_Input;
  on_conflict?: InputMaybe<EntityCustomFieldValue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityCustomFieldValuesArgs = {
  objects: Array<EntityCustomFieldValue_Insert_Input>;
  on_conflict?: InputMaybe<EntityCustomFieldValue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityCustomFieldsArgs = {
  objects: Array<EntityCustomField_Insert_Input>;
  on_conflict?: InputMaybe<EntityCustomField_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityDataDefinitionArgs = {
  object: EntityDataDefinition_Insert_Input;
  on_conflict?: InputMaybe<EntityDataDefinition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityDataDefinitionsArgs = {
  objects: Array<EntityDataDefinition_Insert_Input>;
  on_conflict?: InputMaybe<EntityDataDefinition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityEligibilityRuleArgs = {
  object: EntityEligibilityRule_Insert_Input;
  on_conflict?: InputMaybe<EntityEligibilityRule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityEligibilityRulesArgs = {
  objects: Array<EntityEligibilityRule_Insert_Input>;
  on_conflict?: InputMaybe<EntityEligibilityRule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityFeatureArgs = {
  object: EntityFeature_Insert_Input;
  on_conflict?: InputMaybe<EntityFeature_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityFeaturesArgs = {
  objects: Array<EntityFeature_Insert_Input>;
  on_conflict?: InputMaybe<EntityFeature_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityFileContentTypeArgs = {
  object: EntityFileContentType_Insert_Input;
  on_conflict?: InputMaybe<EntityFileContentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityFileContentTypesArgs = {
  objects: Array<EntityFileContentType_Insert_Input>;
  on_conflict?: InputMaybe<EntityFileContentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityFileStorageArgs = {
  object: EntityFileStorage_Insert_Input;
  on_conflict?: InputMaybe<EntityFileStorage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityFileStoragesArgs = {
  objects: Array<EntityFileStorage_Insert_Input>;
  on_conflict?: InputMaybe<EntityFileStorage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityNoteArgs = {
  object: EntityNote_Insert_Input;
  on_conflict?: InputMaybe<EntityNote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityNotesArgs = {
  objects: Array<EntityNote_Insert_Input>;
  on_conflict?: InputMaybe<EntityNote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityOfferingArgs = {
  object: EntityOffering_Insert_Input;
  on_conflict?: InputMaybe<EntityOffering_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityOfferingsArgs = {
  objects: Array<EntityOffering_Insert_Input>;
  on_conflict?: InputMaybe<EntityOffering_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityRemittanceDetailArgs = {
  object: EntityRemittanceDetail_Insert_Input;
  on_conflict?: InputMaybe<EntityRemittanceDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityRemittanceDetailsArgs = {
  objects: Array<EntityRemittanceDetail_Insert_Input>;
  on_conflict?: InputMaybe<EntityRemittanceDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityTagArgs = {
  object: EntityTag_Insert_Input;
  on_conflict?: InputMaybe<EntityTag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityTagsArgs = {
  objects: Array<EntityTag_Insert_Input>;
  on_conflict?: InputMaybe<EntityTag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFeatureArgs = {
  object: Feature_Insert_Input;
  on_conflict?: InputMaybe<Feature_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFeaturesArgs = {
  objects: Array<Feature_Insert_Input>;
  on_conflict?: InputMaybe<Feature_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileStorageArgs = {
  object: FileStorage_Insert_Input;
  on_conflict?: InputMaybe<FileStorage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileStorageTypeArgs = {
  object: FileStorageType_Insert_Input;
  on_conflict?: InputMaybe<FileStorageType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileStorageTypesArgs = {
  objects: Array<FileStorageType_Insert_Input>;
  on_conflict?: InputMaybe<FileStorageType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileStoragesArgs = {
  objects: Array<FileStorage_Insert_Input>;
  on_conflict?: InputMaybe<FileStorage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilingLenderArgs = {
  object: FilingLender_Insert_Input;
  on_conflict?: InputMaybe<FilingLender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilingLenderMatchArgs = {
  object: FilingLenderMatch_Insert_Input;
  on_conflict?: InputMaybe<FilingLenderMatch_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilingLenderMatchesArgs = {
  objects: Array<FilingLenderMatch_Insert_Input>;
  on_conflict?: InputMaybe<FilingLenderMatch_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilingLendersArgs = {
  objects: Array<FilingLender_Insert_Input>;
  on_conflict?: InputMaybe<FilingLender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilingStateArgs = {
  object: FilingState_Insert_Input;
  on_conflict?: InputMaybe<FilingState_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilingStatesArgs = {
  objects: Array<FilingState_Insert_Input>;
  on_conflict?: InputMaybe<FilingState_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilingStatusTypeArgs = {
  object: FilingStatusType_Insert_Input;
  on_conflict?: InputMaybe<FilingStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilingStatusTypesArgs = {
  objects: Array<FilingStatusType_Insert_Input>;
  on_conflict?: InputMaybe<FilingStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFlowItemArgs = {
  object: FlowItem_Insert_Input;
  on_conflict?: InputMaybe<FlowItem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFlowItemTypeArgs = {
  object: FlowItemType_Insert_Input;
  on_conflict?: InputMaybe<FlowItemType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFlowItemTypesArgs = {
  objects: Array<FlowItemType_Insert_Input>;
  on_conflict?: InputMaybe<FlowItemType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFlowItemsArgs = {
  objects: Array<FlowItem_Insert_Input>;
  on_conflict?: InputMaybe<FlowItem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFlowTypeArgs = {
  object: FlowType_Insert_Input;
  on_conflict?: InputMaybe<FlowType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFlowTypesArgs = {
  objects: Array<FlowType_Insert_Input>;
  on_conflict?: InputMaybe<FlowType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentitiesArgs = {
  objects: Array<Identity_Insert_Input>;
  on_conflict?: InputMaybe<Identity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityArgs = {
  object: Identity_Insert_Input;
  on_conflict?: InputMaybe<Identity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityAs400Args = {
  object: IdentityAs400_Insert_Input;
  on_conflict?: InputMaybe<IdentityAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityAs400sArgs = {
  objects: Array<IdentityAs400_Insert_Input>;
  on_conflict?: InputMaybe<IdentityAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityCapabilitiesArgs = {
  objects: Array<IdentityCapability_Insert_Input>;
  on_conflict?: InputMaybe<IdentityCapability_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityCapabilityArgs = {
  object: IdentityCapability_Insert_Input;
  on_conflict?: InputMaybe<IdentityCapability_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityEntitiesArgs = {
  objects: Array<IdentityEntity_Insert_Input>;
  on_conflict?: InputMaybe<IdentityEntity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityEntityArgs = {
  object: IdentityEntity_Insert_Input;
  on_conflict?: InputMaybe<IdentityEntity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityFilterArgs = {
  object: IdentityFilter_Insert_Input;
  on_conflict?: InputMaybe<IdentityFilter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertIdentityFiltersArgs = {
  objects: Array<IdentityFilter_Insert_Input>;
  on_conflict?: InputMaybe<IdentityFilter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceArgs = {
  object: Invoice_Insert_Input;
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceDocumentTypeArgs = {
  object: InvoiceDocumentType_Insert_Input;
  on_conflict?: InputMaybe<InvoiceDocumentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceDocumentTypesArgs = {
  objects: Array<InvoiceDocumentType_Insert_Input>;
  on_conflict?: InputMaybe<InvoiceDocumentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicePaymentTypeArgs = {
  object: InvoicePaymentType_Insert_Input;
  on_conflict?: InputMaybe<InvoicePaymentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicePaymentTypesArgs = {
  objects: Array<InvoicePaymentType_Insert_Input>;
  on_conflict?: InputMaybe<InvoicePaymentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicesArgs = {
  objects: Array<Invoice_Insert_Input>;
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJobArgs = {
  object: Job_Insert_Input;
  on_conflict?: InputMaybe<Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJobHistoriesArgs = {
  objects: Array<JobHistory_Insert_Input>;
  on_conflict?: InputMaybe<JobHistory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJobHistoryArgs = {
  object: JobHistory_Insert_Input;
  on_conflict?: InputMaybe<JobHistory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJobHistoryLogArgs = {
  object: JobHistoryLog_Insert_Input;
  on_conflict?: InputMaybe<JobHistoryLog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJobHistoryLogsArgs = {
  objects: Array<JobHistoryLog_Insert_Input>;
  on_conflict?: InputMaybe<JobHistoryLog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJobScheduleArgs = {
  object: JobSchedule_Insert_Input;
  on_conflict?: InputMaybe<JobSchedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJobSchedulesArgs = {
  objects: Array<JobSchedule_Insert_Input>;
  on_conflict?: InputMaybe<JobSchedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJobStepArgs = {
  object: JobStep_Insert_Input;
  on_conflict?: InputMaybe<JobStep_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJobStepsArgs = {
  objects: Array<JobStep_Insert_Input>;
  on_conflict?: InputMaybe<JobStep_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJobsArgs = {
  objects: Array<Job_Insert_Input>;
  on_conflict?: InputMaybe<Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJournalEntriesArgs = {
  objects: Array<JournalEntry_Insert_Input>;
  on_conflict?: InputMaybe<JournalEntry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJournalEntryArgs = {
  object: JournalEntry_Insert_Input;
  on_conflict?: InputMaybe<JournalEntry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJournalEntryLineArgs = {
  object: JournalEntryLine_Insert_Input;
  on_conflict?: InputMaybe<JournalEntryLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertJournalEntryLinesArgs = {
  objects: Array<JournalEntryLine_Insert_Input>;
  on_conflict?: InputMaybe<JournalEntryLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertLaborGuideTypeArgs = {
  object: LaborGuideType_Insert_Input;
  on_conflict?: InputMaybe<LaborGuideType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertLaborGuideTypesArgs = {
  objects: Array<LaborGuideType_Insert_Input>;
  on_conflict?: InputMaybe<LaborGuideType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertLaborRateArgs = {
  object: LaborRate_Insert_Input;
  on_conflict?: InputMaybe<LaborRate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertLaborRateAs400Args = {
  object: LaborRateAs400_Insert_Input;
  on_conflict?: InputMaybe<LaborRateAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertLaborRateAs400sArgs = {
  objects: Array<LaborRateAs400_Insert_Input>;
  on_conflict?: InputMaybe<LaborRateAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertLaborRatesArgs = {
  objects: Array<LaborRate_Insert_Input>;
  on_conflict?: InputMaybe<LaborRate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertLegacyPolicyContractArgs = {
  object: LegacyPolicyContract_Insert_Input;
  on_conflict?: InputMaybe<LegacyPolicyContract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertLegacyPolicyContractsArgs = {
  objects: Array<LegacyPolicyContract_Insert_Input>;
  on_conflict?: InputMaybe<LegacyPolicyContract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertLoggedActionArgs = {
  object: LoggedAction_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsertLoggedActionsArgs = {
  objects: Array<LoggedAction_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsertLossRatioArgs = {
  object: LossRatio_Insert_Input;
  on_conflict?: InputMaybe<LossRatio_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertLossRatiosArgs = {
  objects: Array<LossRatio_Insert_Input>;
  on_conflict?: InputMaybe<LossRatio_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertMilesCalculationTypeArgs = {
  object: MilesCalculationType_Insert_Input;
  on_conflict?: InputMaybe<MilesCalculationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertMilesCalculationTypesArgs = {
  objects: Array<MilesCalculationType_Insert_Input>;
  on_conflict?: InputMaybe<MilesCalculationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertObligorArgs = {
  object: Obligor_Insert_Input;
  on_conflict?: InputMaybe<Obligor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertObligorsArgs = {
  objects: Array<Obligor_Insert_Input>;
  on_conflict?: InputMaybe<Obligor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertObsoleteJobArgs = {
  object: ObsoleteJob_Insert_Input;
  on_conflict?: InputMaybe<ObsoleteJob_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertObsoleteJobsArgs = {
  objects: Array<ObsoleteJob_Insert_Input>;
  on_conflict?: InputMaybe<ObsoleteJob_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertOutboxEventArgs = {
  object: OutboxEvent_Insert_Input;
  on_conflict?: InputMaybe<OutboxEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertOutboxEventsArgs = {
  objects: Array<OutboxEvent_Insert_Input>;
  on_conflict?: InputMaybe<OutboxEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertParticipantArgs = {
  object: Participant_Insert_Input;
  on_conflict?: InputMaybe<Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertParticipantsArgs = {
  objects: Array<Participant_Insert_Input>;
  on_conflict?: InputMaybe<Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPayeeArgs = {
  object: Payee_Insert_Input;
  on_conflict?: InputMaybe<Payee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPayeeAs400Args = {
  object: PayeeAs400_Insert_Input;
  on_conflict?: InputMaybe<PayeeAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPayeeAs400sArgs = {
  objects: Array<PayeeAs400_Insert_Input>;
  on_conflict?: InputMaybe<PayeeAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPayeesArgs = {
  objects: Array<Payee_Insert_Input>;
  on_conflict?: InputMaybe<Payee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentArgs = {
  object: Payment_Insert_Input;
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentAs400Args = {
  object: PaymentAs400_Insert_Input;
  on_conflict?: InputMaybe<PaymentAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentAs400sArgs = {
  objects: Array<PaymentAs400_Insert_Input>;
  on_conflict?: InputMaybe<PaymentAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentDetailArgs = {
  object: PaymentDetail_Insert_Input;
  on_conflict?: InputMaybe<PaymentDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentDetailsArgs = {
  objects: Array<PaymentDetail_Insert_Input>;
  on_conflict?: InputMaybe<PaymentDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentMethodTypeArgs = {
  object: PaymentMethodType_Insert_Input;
  on_conflict?: InputMaybe<PaymentMethodType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentMethodTypesArgs = {
  objects: Array<PaymentMethodType_Insert_Input>;
  on_conflict?: InputMaybe<PaymentMethodType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentStatusTypeArgs = {
  object: PaymentStatusType_Insert_Input;
  on_conflict?: InputMaybe<PaymentStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentStatusTypesArgs = {
  objects: Array<PaymentStatusType_Insert_Input>;
  on_conflict?: InputMaybe<PaymentStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentTypeArgs = {
  object: PaymentType_Insert_Input;
  on_conflict?: InputMaybe<PaymentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentTypesArgs = {
  objects: Array<PaymentType_Insert_Input>;
  on_conflict?: InputMaybe<PaymentType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentsArgs = {
  objects: Array<Payment_Insert_Input>;
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPlanArgs = {
  if_matched?: InputMaybe<Plan_If_Matched>;
  object: Plan_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsertPlansArgs = {
  if_matched?: InputMaybe<Plan_If_Matched>;
  objects: Array<Plan_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsertPoliciesArgs = {
  objects: Array<Policy_Insert_Input>;
  on_conflict?: InputMaybe<Policy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyArgs = {
  object: Policy_Insert_Input;
  on_conflict?: InputMaybe<Policy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyClaimArgs = {
  object: PolicyClaim_Insert_Input;
  on_conflict?: InputMaybe<PolicyClaim_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyClaimAs400Args = {
  object: PolicyClaimAs400_Insert_Input;
  on_conflict?: InputMaybe<PolicyClaimAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyClaimAs400sArgs = {
  objects: Array<PolicyClaimAs400_Insert_Input>;
  on_conflict?: InputMaybe<PolicyClaimAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyClaimConcernArgs = {
  object: PolicyClaimConcern_Insert_Input;
  on_conflict?: InputMaybe<PolicyClaimConcern_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyClaimConcernsArgs = {
  objects: Array<PolicyClaimConcern_Insert_Input>;
  on_conflict?: InputMaybe<PolicyClaimConcern_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyClaimInsuranceArgs = {
  object: PolicyClaimInsurance_Insert_Input;
  on_conflict?: InputMaybe<PolicyClaimInsurance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyClaimInsurancesArgs = {
  objects: Array<PolicyClaimInsurance_Insert_Input>;
  on_conflict?: InputMaybe<PolicyClaimInsurance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyClaimsArgs = {
  objects: Array<PolicyClaim_Insert_Input>;
  on_conflict?: InputMaybe<PolicyClaim_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractArgs = {
  object: PolicyContract_Insert_Input;
  on_conflict?: InputMaybe<PolicyContract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractAssetArgs = {
  object: PolicyContractAsset_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractAssetTypeArgs = {
  object: PolicyContractAssetType_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractAssetType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractAssetTypesArgs = {
  objects: Array<PolicyContractAssetType_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractAssetType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractAssetsArgs = {
  objects: Array<PolicyContractAsset_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractContractFormVersionArgs = {
  object: PolicyContractContractFormVersion_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractContractFormVersion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractContractFormVersionsArgs = {
  objects: Array<PolicyContractContractFormVersion_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractContractFormVersion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractCostDetailArgs = {
  object: PolicyContractCostDetail_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractCostDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractCostDetailsArgs = {
  objects: Array<PolicyContractCostDetail_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractCostDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractLenderArgs = {
  object: PolicyContractLender_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractLender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractLendersArgs = {
  objects: Array<PolicyContractLender_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractLender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractLoanContractTypeArgs = {
  object: PolicyContractLoanContractType_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractLoanContractType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractLoanContractTypesArgs = {
  objects: Array<PolicyContractLoanContractType_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractLoanContractType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractOwnerArgs = {
  object: PolicyContractOwner_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractOwner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractOwnersArgs = {
  objects: Array<PolicyContractOwner_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractOwner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractProductArgs = {
  object: PolicyContractProduct_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractProduct_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractProductCostDetailArgs = {
  object: PolicyContractProductCostDetail_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractProductCostDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractProductCostDetailsArgs = {
  objects: Array<PolicyContractProductCostDetail_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractProductCostDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractProductsArgs = {
  objects: Array<PolicyContractProduct_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractProduct_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractQuoteArgs = {
  object: PolicyContractQuote_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractQuote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractQuotesArgs = {
  objects: Array<PolicyContractQuote_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractQuote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractStatusTypeArgs = {
  object: PolicyContractStatusType_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractStatusTypesArgs = {
  objects: Array<PolicyContractStatusType_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractVoidReasonTypeArgs = {
  object: PolicyContractVoidReasonType_Insert_Input;
  on_conflict?: InputMaybe<PolicyContractVoidReasonType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractVoidReasonTypesArgs = {
  objects: Array<PolicyContractVoidReasonType_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContractVoidReasonType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPolicyContractsArgs = {
  objects: Array<PolicyContract_Insert_Input>;
  on_conflict?: InputMaybe<PolicyContract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPreAuthorizationArgs = {
  object: PreAuthorization_Insert_Input;
  on_conflict?: InputMaybe<PreAuthorization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPreAuthorizationStatusTypeArgs = {
  object: PreAuthorizationStatusType_Insert_Input;
  on_conflict?: InputMaybe<PreAuthorizationStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPreAuthorizationStatusTypesArgs = {
  objects: Array<PreAuthorizationStatusType_Insert_Input>;
  on_conflict?: InputMaybe<PreAuthorizationStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPreAuthorizationTypeArgs = {
  object: PreAuthorizationType_Insert_Input;
  on_conflict?: InputMaybe<PreAuthorizationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPreAuthorizationTypesArgs = {
  objects: Array<PreAuthorizationType_Insert_Input>;
  on_conflict?: InputMaybe<PreAuthorizationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertPreAuthorizationsArgs = {
  objects: Array<PreAuthorization_Insert_Input>;
  on_conflict?: InputMaybe<PreAuthorization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductArgs = {
  object: Product_Insert_Input;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductAttributeArgs = {
  object: ProductAttribute_Insert_Input;
  on_conflict?: InputMaybe<ProductAttribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductAttributeTypeArgs = {
  object: ProductAttributeType_Insert_Input;
  on_conflict?: InputMaybe<ProductAttributeType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductAttributeTypesArgs = {
  objects: Array<ProductAttributeType_Insert_Input>;
  on_conflict?: InputMaybe<ProductAttributeType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductAttributesArgs = {
  objects: Array<ProductAttribute_Insert_Input>;
  on_conflict?: InputMaybe<ProductAttribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductClassGuideArgs = {
  object: ProductClassGuide_Insert_Input;
  on_conflict?: InputMaybe<ProductClassGuide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductClassGuidesArgs = {
  objects: Array<ProductClassGuide_Insert_Input>;
  on_conflict?: InputMaybe<ProductClassGuide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductContractFormArgs = {
  object: ProductContractForm_Insert_Input;
  on_conflict?: InputMaybe<ProductContractForm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductContractFormsArgs = {
  objects: Array<ProductContractForm_Insert_Input>;
  on_conflict?: InputMaybe<ProductContractForm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductCostArgs = {
  object: ProductCost_Insert_Input;
  on_conflict?: InputMaybe<ProductCost_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductCostsArgs = {
  objects: Array<ProductCost_Insert_Input>;
  on_conflict?: InputMaybe<ProductCost_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductDisbursementArgs = {
  object: ProductDisbursement_Insert_Input;
  on_conflict?: InputMaybe<ProductDisbursement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductDisbursementsArgs = {
  objects: Array<ProductDisbursement_Insert_Input>;
  on_conflict?: InputMaybe<ProductDisbursement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductEligibilitiesArgs = {
  objects: Array<ProductEligibility_Insert_Input>;
  on_conflict?: InputMaybe<ProductEligibility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductEligibilityArgs = {
  object: ProductEligibility_Insert_Input;
  on_conflict?: InputMaybe<ProductEligibility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductObligorArgs = {
  object: ProductObligor_Insert_Input;
  on_conflict?: InputMaybe<ProductObligor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductObligorsArgs = {
  objects: Array<ProductObligor_Insert_Input>;
  on_conflict?: InputMaybe<ProductObligor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductRateBucketArgs = {
  object: ProductRateBucket_Insert_Input;
  on_conflict?: InputMaybe<ProductRateBucket_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductRateBucketsArgs = {
  objects: Array<ProductRateBucket_Insert_Input>;
  on_conflict?: InputMaybe<ProductRateBucket_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductSurchargeTypeArgs = {
  object: ProductSurchargeType_Insert_Input;
  on_conflict?: InputMaybe<ProductSurchargeType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductSurchargeTypesArgs = {
  objects: Array<ProductSurchargeType_Insert_Input>;
  on_conflict?: InputMaybe<ProductSurchargeType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProductsArgs = {
  objects: Array<Product_Insert_Input>;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProfileArgs = {
  object: Profile_Insert_Input;
  on_conflict?: InputMaybe<Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertProfilesArgs = {
  objects: Array<Profile_Insert_Input>;
  on_conflict?: InputMaybe<Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertQuoteArgs = {
  object: Quote_Insert_Input;
  on_conflict?: InputMaybe<Quote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertQuoteMinimalViewArgs = {
  object: QuoteMinimalView_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsertQuoteMinimalViewsArgs = {
  objects: Array<QuoteMinimalView_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsertQuoteTypeArgs = {
  object: QuoteType_Insert_Input;
  on_conflict?: InputMaybe<QuoteType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertQuoteTypesArgs = {
  objects: Array<QuoteType_Insert_Input>;
  on_conflict?: InputMaybe<QuoteType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertQuotesArgs = {
  objects: Array<Quote_Insert_Input>;
  on_conflict?: InputMaybe<Quote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRateBucketTypeArgs = {
  object: RateBucketType_Insert_Input;
  on_conflict?: InputMaybe<RateBucketType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRateBucketTypesArgs = {
  objects: Array<RateBucketType_Insert_Input>;
  on_conflict?: InputMaybe<RateBucketType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRateQuoteArgs = {
  object: RateQuote_Insert_Input;
  on_conflict?: InputMaybe<RateQuote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRateQuotesArgs = {
  objects: Array<RateQuote_Insert_Input>;
  on_conflict?: InputMaybe<RateQuote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRaterViewConfigArgs = {
  object: RaterViewConfig_Insert_Input;
  on_conflict?: InputMaybe<RaterViewConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRaterViewConfigsArgs = {
  objects: Array<RaterViewConfig_Insert_Input>;
  on_conflict?: InputMaybe<RaterViewConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertReferenceLogArgs = {
  object: ReferenceLog_Insert_Input;
  on_conflict?: InputMaybe<ReferenceLog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertReferenceLogsArgs = {
  objects: Array<ReferenceLog_Insert_Input>;
  on_conflict?: InputMaybe<ReferenceLog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittanceArgs = {
  object: Remittance_Insert_Input;
  on_conflict?: InputMaybe<Remittance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittanceClaimDetailArgs = {
  object: RemittanceClaimDetail_Insert_Input;
  on_conflict?: InputMaybe<RemittanceClaimDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittanceClaimDetailsArgs = {
  objects: Array<RemittanceClaimDetail_Insert_Input>;
  on_conflict?: InputMaybe<RemittanceClaimDetail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittancePaymentArgs = {
  object: RemittancePayment_Insert_Input;
  on_conflict?: InputMaybe<RemittancePayment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittancePaymentsArgs = {
  objects: Array<RemittancePayment_Insert_Input>;
  on_conflict?: InputMaybe<RemittancePayment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittancePolicyContractArgs = {
  object: RemittancePolicyContract_Insert_Input;
  on_conflict?: InputMaybe<RemittancePolicyContract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittancePolicyContractAs400Args = {
  object: RemittancePolicyContractAs400_Insert_Input;
  on_conflict?: InputMaybe<RemittancePolicyContractAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittancePolicyContractAs400sArgs = {
  objects: Array<RemittancePolicyContractAs400_Insert_Input>;
  on_conflict?: InputMaybe<RemittancePolicyContractAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittancePolicyContractsArgs = {
  objects: Array<RemittancePolicyContract_Insert_Input>;
  on_conflict?: InputMaybe<RemittancePolicyContract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittanceStatusTypeArgs = {
  object: RemittanceStatusType_Insert_Input;
  on_conflict?: InputMaybe<RemittanceStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittanceStatusTypesArgs = {
  objects: Array<RemittanceStatusType_Insert_Input>;
  on_conflict?: InputMaybe<RemittanceStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittanceTypeArgs = {
  object: RemittanceType_Insert_Input;
  on_conflict?: InputMaybe<RemittanceType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittanceTypesArgs = {
  objects: Array<RemittanceType_Insert_Input>;
  on_conflict?: InputMaybe<RemittanceType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRemittancesArgs = {
  objects: Array<Remittance_Insert_Input>;
  on_conflict?: InputMaybe<Remittance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRepeatPartAcknowledgmentArgs = {
  object: RepeatPartAcknowledgment_Insert_Input;
  on_conflict?: InputMaybe<RepeatPartAcknowledgment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRepeatPartAcknowledgmentsArgs = {
  objects: Array<RepeatPartAcknowledgment_Insert_Input>;
  on_conflict?: InputMaybe<RepeatPartAcknowledgment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRoleArgs = {
  object: Role_Insert_Input;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRoleAttributeArgs = {
  object: RoleAttribute_Insert_Input;
  on_conflict?: InputMaybe<RoleAttribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRoleAttributesArgs = {
  objects: Array<RoleAttribute_Insert_Input>;
  on_conflict?: InputMaybe<RoleAttribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRolesArgs = {
  objects: Array<Role_Insert_Input>;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRouteArgs = {
  object: Route_Insert_Input;
  on_conflict?: InputMaybe<Route_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRouteConfigArgs = {
  object: RouteConfig_Insert_Input;
  on_conflict?: InputMaybe<RouteConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRouteConfigsArgs = {
  objects: Array<RouteConfig_Insert_Input>;
  on_conflict?: InputMaybe<RouteConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertRoutesArgs = {
  objects: Array<Route_Insert_Input>;
  on_conflict?: InputMaybe<Route_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertSearchIndexArgs = {
  object: SearchIndex_Insert_Input;
  on_conflict?: InputMaybe<SearchIndex_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertSearchIndexesArgs = {
  objects: Array<SearchIndex_Insert_Input>;
  on_conflict?: InputMaybe<SearchIndex_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertSelectStateArgs = {
  object: State_Insert_Input;
  on_conflict?: InputMaybe<State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertSelectStatesArgs = {
  objects: Array<State_Insert_Input>;
  on_conflict?: InputMaybe<State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertServiceCenterArgs = {
  object: ServiceCenter_Insert_Input;
  on_conflict?: InputMaybe<ServiceCenter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertServiceCentersArgs = {
  objects: Array<ServiceCenter_Insert_Input>;
  on_conflict?: InputMaybe<ServiceCenter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertSeverityLevelTypeArgs = {
  object: SeverityLevelType_Insert_Input;
  on_conflict?: InputMaybe<SeverityLevelType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertSeverityLevelTypesArgs = {
  objects: Array<SeverityLevelType_Insert_Input>;
  on_conflict?: InputMaybe<SeverityLevelType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertShortcutBindingArgs = {
  object: ShortcutBinding_Insert_Input;
  on_conflict?: InputMaybe<ShortcutBinding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertShortcutBindingsArgs = {
  objects: Array<ShortcutBinding_Insert_Input>;
  on_conflict?: InputMaybe<ShortcutBinding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertStepArgs = {
  object: Step_Insert_Input;
  on_conflict?: InputMaybe<Step_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertStepTypeArgs = {
  object: StepType_Insert_Input;
  on_conflict?: InputMaybe<StepType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertStepTypesArgs = {
  objects: Array<StepType_Insert_Input>;
  on_conflict?: InputMaybe<StepType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertStepsArgs = {
  objects: Array<Step_Insert_Input>;
  on_conflict?: InputMaybe<Step_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertSurchargeTypeArgs = {
  object: SurchargeType_Insert_Input;
  on_conflict?: InputMaybe<SurchargeType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertSurchargeTypesArgs = {
  objects: Array<SurchargeType_Insert_Input>;
  on_conflict?: InputMaybe<SurchargeType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTagArgs = {
  object: Tag_Insert_Input;
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTagsArgs = {
  objects: Array<Tag_Insert_Input>;
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTaskArgs = {
  object: Task_Insert_Input;
  on_conflict?: InputMaybe<Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTasksArgs = {
  objects: Array<Task_Insert_Input>;
  on_conflict?: InputMaybe<Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTaxRateArgs = {
  object: TaxRate_Insert_Input;
  on_conflict?: InputMaybe<TaxRate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTaxRateAs400Args = {
  object: TaxRateAs400_Insert_Input;
  on_conflict?: InputMaybe<TaxRateAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTaxRateAs400sArgs = {
  objects: Array<TaxRateAs400_Insert_Input>;
  on_conflict?: InputMaybe<TaxRateAs400_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTaxRatesArgs = {
  objects: Array<TaxRate_Insert_Input>;
  on_conflict?: InputMaybe<TaxRate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTechnologyTypeArgs = {
  object: TechnologyType_Insert_Input;
  on_conflict?: InputMaybe<TechnologyType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTechnologyTypesArgs = {
  objects: Array<TechnologyType_Insert_Input>;
  on_conflict?: InputMaybe<TechnologyType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTypeArgs = {
  object: Type_Insert_Input;
  on_conflict?: InputMaybe<Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTypeGroupArgs = {
  object: TypeGroup_Insert_Input;
  on_conflict?: InputMaybe<TypeGroup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTypeGroupsArgs = {
  objects: Array<TypeGroup_Insert_Input>;
  on_conflict?: InputMaybe<TypeGroup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertTypesArgs = {
  objects: Array<Type_Insert_Input>;
  on_conflict?: InputMaybe<Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFlowItemArgs = {
  object: UserFlowItem_Insert_Input;
  on_conflict?: InputMaybe<UserFlowItem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFlowItemMfaArgs = {
  object: UserFlowItemMfa_Insert_Input;
  on_conflict?: InputMaybe<UserFlowItemMfa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFlowItemMfasArgs = {
  objects: Array<UserFlowItemMfa_Insert_Input>;
  on_conflict?: InputMaybe<UserFlowItemMfa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFlowItemsArgs = {
  objects: Array<UserFlowItem_Insert_Input>;
  on_conflict?: InputMaybe<UserFlowItem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserGroupArgs = {
  object: UserGroup_Insert_Input;
  on_conflict?: InputMaybe<UserGroup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserGroupsArgs = {
  objects: Array<UserGroup_Insert_Input>;
  on_conflict?: InputMaybe<UserGroup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPinArgs = {
  object: UserPin_Insert_Input;
  on_conflict?: InputMaybe<UserPin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPinsArgs = {
  objects: Array<UserPin_Insert_Input>;
  on_conflict?: InputMaybe<UserPin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserProfileArgs = {
  object: UserProfile_Insert_Input;
  on_conflict?: InputMaybe<UserProfile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserProfilesArgs = {
  objects: Array<UserProfile_Insert_Input>;
  on_conflict?: InputMaybe<UserProfile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserSessionArgs = {
  object: UserSession_Insert_Input;
  on_conflict?: InputMaybe<UserSession_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserSessionsArgs = {
  objects: Array<UserSession_Insert_Input>;
  on_conflict?: InputMaybe<UserSession_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationArgs = {
  object: Validation_Insert_Input;
  on_conflict?: InputMaybe<Validation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationLifecycleHookArgs = {
  object: ValidationLifecycleHook_Insert_Input;
  on_conflict?: InputMaybe<ValidationLifecycleHook_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationLifecycleHooksArgs = {
  objects: Array<ValidationLifecycleHook_Insert_Input>;
  on_conflict?: InputMaybe<ValidationLifecycleHook_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationOverrideArgs = {
  object: ValidationOverride_Insert_Input;
  on_conflict?: InputMaybe<ValidationOverride_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationOverridesArgs = {
  objects: Array<ValidationOverride_Insert_Input>;
  on_conflict?: InputMaybe<ValidationOverride_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationRuleForArgs = {
  object: ValidationRuleFor_Insert_Input;
  on_conflict?: InputMaybe<ValidationRuleFor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationRuleForsArgs = {
  objects: Array<ValidationRuleFor_Insert_Input>;
  on_conflict?: InputMaybe<ValidationRuleFor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationTypeOperationArgs = {
  object: ValidationTypeOperation_Insert_Input;
  on_conflict?: InputMaybe<ValidationTypeOperation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationTypeOperationsArgs = {
  objects: Array<ValidationTypeOperation_Insert_Input>;
  on_conflict?: InputMaybe<ValidationTypeOperation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationWhenArgs = {
  object: ValidationWhen_Insert_Input;
  on_conflict?: InputMaybe<ValidationWhen_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationWhensArgs = {
  objects: Array<ValidationWhen_Insert_Input>;
  on_conflict?: InputMaybe<ValidationWhen_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertValidationsArgs = {
  objects: Array<Validation_Insert_Input>;
  on_conflict?: InputMaybe<Validation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVehicleArgs = {
  object: Vehicle_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVehicleStatusTypeArgs = {
  object: VehicleStatusType_Insert_Input;
  on_conflict?: InputMaybe<VehicleStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVehicleStatusTypesArgs = {
  objects: Array<VehicleStatusType_Insert_Input>;
  on_conflict?: InputMaybe<VehicleStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVehiclesArgs = {
  objects: Array<Vehicle_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVpicDecodeAlternativeArgs = {
  object: VpicDecodeAlternative_Insert_Input;
  on_conflict?: InputMaybe<VpicDecodeAlternative_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVpicDecodeAlternativesArgs = {
  objects: Array<VpicDecodeAlternative_Insert_Input>;
  on_conflict?: InputMaybe<VpicDecodeAlternative_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertWorkStatusTypeArgs = {
  object: WorkStatusType_Insert_Input;
  on_conflict?: InputMaybe<WorkStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertWorkStatusTypesArgs = {
  objects: Array<WorkStatusType_Insert_Input>;
  on_conflict?: InputMaybe<WorkStatusType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertWorkflowStateTypeArgs = {
  object: WorkflowStateType_Insert_Input;
  on_conflict?: InputMaybe<WorkflowStateType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertWorkflowStateTypesArgs = {
  objects: Array<WorkflowStateType_Insert_Input>;
  on_conflict?: InputMaybe<WorkflowStateType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AbsArgs = {
  objects: Array<Abs_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Abs_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Abs_OneArgs = {
  object: Abs_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Abs_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AdaptiveCruiseControlArgs = {
  objects: Array<AdaptiveCruiseControl_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<AdaptiveCruiseControl_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AdaptiveCruiseControl_OneArgs = {
  object: AdaptiveCruiseControl_Insert_Input_Vpic;
  on_conflict?: InputMaybe<AdaptiveCruiseControl_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AdaptiveDrivingBeamArgs = {
  objects: Array<AdaptiveDrivingBeam_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<AdaptiveDrivingBeam_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AdaptiveDrivingBeam_OneArgs = {
  object: AdaptiveDrivingBeam_Insert_Input_Vpic;
  on_conflict?: InputMaybe<AdaptiveDrivingBeam_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AirBagLocFrontArgs = {
  objects: Array<AirBagLocFront_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<AirBagLocFront_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AirBagLocFront_OneArgs = {
  object: AirBagLocFront_Insert_Input_Vpic;
  on_conflict?: InputMaybe<AirBagLocFront_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AirBagLocKneeArgs = {
  objects: Array<AirBagLocKnee_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<AirBagLocKnee_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AirBagLocKnee_OneArgs = {
  object: AirBagLocKnee_Insert_Input_Vpic;
  on_conflict?: InputMaybe<AirBagLocKnee_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AirBagLocationsArgs = {
  objects: Array<AirBagLocations_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<AirBagLocations_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AirBagLocations_OneArgs = {
  object: AirBagLocations_Insert_Input_Vpic;
  on_conflict?: InputMaybe<AirBagLocations_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AutoBrakeArgs = {
  objects: Array<AutoBrake_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<AutoBrake_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AutoBrake_OneArgs = {
  object: AutoBrake_Insert_Input_Vpic;
  on_conflict?: InputMaybe<AutoBrake_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AutoReverseSystemArgs = {
  objects: Array<AutoReverseSystem_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<AutoReverseSystem_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AutoReverseSystem_OneArgs = {
  object: AutoReverseSystem_Insert_Input_Vpic;
  on_conflict?: InputMaybe<AutoReverseSystem_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AutomaticPedestrainAlertingSoundArgs = {
  objects: Array<AutomaticPedestrainAlertingSound_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<AutomaticPedestrainAlertingSound_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AutomaticPedestrainAlertingSound_OneArgs = {
  object: AutomaticPedestrainAlertingSound_Insert_Input_Vpic;
  on_conflict?: InputMaybe<AutomaticPedestrainAlertingSound_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AxleConfigurationArgs = {
  objects: Array<AxleConfiguration_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<AxleConfiguration_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_AxleConfiguration_OneArgs = {
  object: AxleConfiguration_Insert_Input_Vpic;
  on_conflict?: InputMaybe<AxleConfiguration_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BatteryTypeArgs = {
  objects: Array<BatteryType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<BatteryType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BatteryType_OneArgs = {
  object: BatteryType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<BatteryType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BedTypeArgs = {
  objects: Array<BedType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<BedType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BedType_OneArgs = {
  object: BedType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<BedType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BlindSpotInterventionArgs = {
  objects: Array<BlindSpotIntervention_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<BlindSpotIntervention_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BlindSpotIntervention_OneArgs = {
  object: BlindSpotIntervention_Insert_Input_Vpic;
  on_conflict?: InputMaybe<BlindSpotIntervention_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BlindSpotMonitoringArgs = {
  objects: Array<BlindSpotMonitoring_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<BlindSpotMonitoring_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BlindSpotMonitoring_OneArgs = {
  object: BlindSpotMonitoring_Insert_Input_Vpic;
  on_conflict?: InputMaybe<BlindSpotMonitoring_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BodyCabArgs = {
  objects: Array<BodyCab_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<BodyCab_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BodyCab_OneArgs = {
  object: BodyCab_Insert_Input_Vpic;
  on_conflict?: InputMaybe<BodyCab_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BodyStyleArgs = {
  objects: Array<BodyStyle_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<BodyStyle_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BodyStyle_OneArgs = {
  object: BodyStyle_Insert_Input_Vpic;
  on_conflict?: InputMaybe<BodyStyle_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BrakeSystemArgs = {
  objects: Array<BrakeSystem_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<BrakeSystem_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BrakeSystem_OneArgs = {
  object: BrakeSystem_Insert_Input_Vpic;
  on_conflict?: InputMaybe<BrakeSystem_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BusFloorConfigTypeArgs = {
  objects: Array<BusFloorConfigType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<BusFloorConfigType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BusFloorConfigType_OneArgs = {
  object: BusFloorConfigType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<BusFloorConfigType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BusTypeArgs = {
  objects: Array<BusType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<BusType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_BusType_OneArgs = {
  object: BusType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<BusType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Can_AacnArgs = {
  objects: Array<Can_Aacn_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Can_Aacn_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Can_Aacn_OneArgs = {
  object: Can_Aacn_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Can_Aacn_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ChargerLevelArgs = {
  objects: Array<ChargerLevel_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<ChargerLevel_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ChargerLevel_OneArgs = {
  object: ChargerLevel_Insert_Input_Vpic;
  on_conflict?: InputMaybe<ChargerLevel_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_CombinedBrakingSystemArgs = {
  objects: Array<CombinedBrakingSystem_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<CombinedBrakingSystem_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_CombinedBrakingSystem_OneArgs = {
  object: CombinedBrakingSystem_Insert_Input_Vpic;
  on_conflict?: InputMaybe<CombinedBrakingSystem_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ContractMasterSurchargeArgs = {
  if_matched?: InputMaybe<ContractMasterSurcharge_If_Matched>;
  objects: Array<ContractMasterSurcharge_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_ContractMasterSurcharge_OneArgs = {
  if_matched?: InputMaybe<ContractMasterSurcharge_If_Matched>;
  object: ContractMasterSurcharge_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_ConversionArgs = {
  objects: Array<Conversion_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Conversion_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Conversion_OneArgs = {
  object: Conversion_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Conversion_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_CoolingTypeArgs = {
  objects: Array<CoolingType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<CoolingType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_CoolingType_OneArgs = {
  object: CoolingType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<CoolingType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_CountryArgs = {
  objects: Array<Country_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Country_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Country_OneArgs = {
  object: Country_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Country_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_CustomMotorcycleTypeArgs = {
  objects: Array<CustomMotorcycleType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<CustomMotorcycleType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_CustomMotorcycleType_OneArgs = {
  object: CustomMotorcycleType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<CustomMotorcycleType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_DaytimeRunningLightArgs = {
  objects: Array<DaytimeRunningLight_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<DaytimeRunningLight_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_DaytimeRunningLight_OneArgs = {
  object: DaytimeRunningLight_Insert_Input_Vpic;
  on_conflict?: InputMaybe<DaytimeRunningLight_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_DefaultValueArgs = {
  objects: Array<DefaultValue_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<DefaultValue_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_DefaultValue_OneArgs = {
  object: DefaultValue_Insert_Input_Vpic;
  on_conflict?: InputMaybe<DefaultValue_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_DestinationMarketArgs = {
  objects: Array<DestinationMarket_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<DestinationMarket_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_DestinationMarket_OneArgs = {
  object: DestinationMarket_Insert_Input_Vpic;
  on_conflict?: InputMaybe<DestinationMarket_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_DriveTypeArgs = {
  objects: Array<DriveType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<DriveType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_DriveType_OneArgs = {
  object: DriveType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<DriveType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_DynamicBrakeSupportArgs = {
  objects: Array<DynamicBrakeSupport_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<DynamicBrakeSupport_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_DynamicBrakeSupport_OneArgs = {
  object: DynamicBrakeSupport_Insert_Input_Vpic;
  on_conflict?: InputMaybe<DynamicBrakeSupport_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EcsArgs = {
  objects: Array<Ecs_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Ecs_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Ecs_OneArgs = {
  object: Ecs_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Ecs_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EdrArgs = {
  objects: Array<Edr_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Edr_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Edr_OneArgs = {
  object: Edr_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Edr_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EvDriveUnitArgs = {
  objects: Array<EvDriveUnit_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<EvDriveUnit_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EvDriveUnit_OneArgs = {
  object: EvDriveUnit_Insert_Input_Vpic;
  on_conflict?: InputMaybe<EvDriveUnit_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ElectrificationLevelArgs = {
  objects: Array<ElectrificationLevel_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<ElectrificationLevel_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ElectrificationLevel_OneArgs = {
  object: ElectrificationLevel_Insert_Input_Vpic;
  on_conflict?: InputMaybe<ElectrificationLevel_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ElementArgs = {
  objects: Array<Element_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Element_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Element_OneArgs = {
  object: Element_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Element_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EngineConfigurationArgs = {
  objects: Array<EngineConfiguration_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<EngineConfiguration_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EngineConfiguration_OneArgs = {
  object: EngineConfiguration_Insert_Input_Vpic;
  on_conflict?: InputMaybe<EngineConfiguration_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EngineModelArgs = {
  objects: Array<EngineModel_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<EngineModel_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EngineModelPatternArgs = {
  objects: Array<EngineModelPattern_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<EngineModelPattern_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EngineModelPattern_OneArgs = {
  object: EngineModelPattern_Insert_Input_Vpic;
  on_conflict?: InputMaybe<EngineModelPattern_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EngineModel_OneArgs = {
  object: EngineModel_Insert_Input_Vpic;
  on_conflict?: InputMaybe<EngineModel_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EntertainmentSystemArgs = {
  objects: Array<EntertainmentSystem_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<EntertainmentSystem_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_EntertainmentSystem_OneArgs = {
  object: EntertainmentSystem_Insert_Input_Vpic;
  on_conflict?: InputMaybe<EntertainmentSystem_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ErrorCodeArgs = {
  objects: Array<ErrorCode_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<ErrorCode_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ErrorCode_OneArgs = {
  object: ErrorCode_Insert_Input_Vpic;
  on_conflict?: InputMaybe<ErrorCode_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ForwardCollisionWarningArgs = {
  objects: Array<ForwardCollisionWarning_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<ForwardCollisionWarning_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ForwardCollisionWarning_OneArgs = {
  object: ForwardCollisionWarning_Insert_Input_Vpic;
  on_conflict?: InputMaybe<ForwardCollisionWarning_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_FuelDeliveryTypeArgs = {
  objects: Array<FuelDeliveryType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<FuelDeliveryType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_FuelDeliveryType_OneArgs = {
  object: FuelDeliveryType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<FuelDeliveryType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_FuelTankMaterialArgs = {
  objects: Array<FuelTankMaterial_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<FuelTankMaterial_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_FuelTankMaterial_OneArgs = {
  object: FuelTankMaterial_Insert_Input_Vpic;
  on_conflict?: InputMaybe<FuelTankMaterial_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_FuelTankTypeArgs = {
  objects: Array<FuelTankType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<FuelTankType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_FuelTankType_OneArgs = {
  object: FuelTankType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<FuelTankType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_FuelTypeArgs = {
  objects: Array<FuelType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<FuelType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_FuelType_OneArgs = {
  object: FuelType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<FuelType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_GrossVehicleWeightRatingArgs = {
  objects: Array<GrossVehicleWeightRating_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<GrossVehicleWeightRating_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_GrossVehicleWeightRating_OneArgs = {
  object: GrossVehicleWeightRating_Insert_Input_Vpic;
  on_conflict?: InputMaybe<GrossVehicleWeightRating_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_KeylessIgnitionArgs = {
  objects: Array<KeylessIgnition_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<KeylessIgnition_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_KeylessIgnition_OneArgs = {
  object: KeylessIgnition_Insert_Input_Vpic;
  on_conflict?: InputMaybe<KeylessIgnition_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_LaneCenteringAssistanceArgs = {
  objects: Array<LaneCenteringAssistance_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<LaneCenteringAssistance_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_LaneCenteringAssistance_OneArgs = {
  object: LaneCenteringAssistance_Insert_Input_Vpic;
  on_conflict?: InputMaybe<LaneCenteringAssistance_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_LaneDepartureWarningArgs = {
  objects: Array<LaneDepartureWarning_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<LaneDepartureWarning_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_LaneDepartureWarning_OneArgs = {
  object: LaneDepartureWarning_Insert_Input_Vpic;
  on_conflict?: InputMaybe<LaneDepartureWarning_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_LaneKeepSystemArgs = {
  objects: Array<LaneKeepSystem_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<LaneKeepSystem_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_LaneKeepSystem_OneArgs = {
  object: LaneKeepSystem_Insert_Input_Vpic;
  on_conflict?: InputMaybe<LaneKeepSystem_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_LowerBeamHeadlampLightSourceArgs = {
  objects: Array<LowerBeamHeadlampLightSource_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<LowerBeamHeadlampLightSource_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_LowerBeamHeadlampLightSource_OneArgs = {
  object: LowerBeamHeadlampLightSource_Insert_Input_Vpic;
  on_conflict?: InputMaybe<LowerBeamHeadlampLightSource_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_MakeArgs = {
  objects: Array<Make_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Make_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Make_ModelArgs = {
  objects: Array<Make_Model_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Make_Model_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Make_Model_OneArgs = {
  object: Make_Model_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Make_Model_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Make_OneArgs = {
  object: Make_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Make_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ManufacturerArgs = {
  objects: Array<Manufacturer_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Manufacturer_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Manufacturer_MakeArgs = {
  objects: Array<Manufacturer_Make_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Manufacturer_Make_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Manufacturer_Make_OneArgs = {
  object: Manufacturer_Make_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Manufacturer_Make_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Manufacturer_OneArgs = {
  object: Manufacturer_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Manufacturer_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ModelArgs = {
  objects: Array<Model_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Model_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Model_OneArgs = {
  object: Model_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Model_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_MotorcycleChassisTypeArgs = {
  objects: Array<MotorcycleChassisType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<MotorcycleChassisType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_MotorcycleChassisType_OneArgs = {
  object: MotorcycleChassisType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<MotorcycleChassisType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_MotorcycleSuspensionTypeArgs = {
  objects: Array<MotorcycleSuspensionType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<MotorcycleSuspensionType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_MotorcycleSuspensionType_OneArgs = {
  object: MotorcycleSuspensionType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<MotorcycleSuspensionType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_NonLandUseArgs = {
  objects: Array<NonLandUse_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<NonLandUse_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_NonLandUse_OneArgs = {
  object: NonLandUse_Insert_Input_Vpic;
  on_conflict?: InputMaybe<NonLandUse_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ParkAssistArgs = {
  objects: Array<ParkAssist_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<ParkAssist_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ParkAssist_OneArgs = {
  object: ParkAssist_Insert_Input_Vpic;
  on_conflict?: InputMaybe<ParkAssist_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_PatternArgs = {
  objects: Array<Pattern_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Pattern_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Pattern_OneArgs = {
  object: Pattern_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Pattern_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_PedestrianAutomaticEmergencyBrakingArgs = {
  objects: Array<PedestrianAutomaticEmergencyBraking_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<PedestrianAutomaticEmergencyBraking_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_PedestrianAutomaticEmergencyBraking_OneArgs = {
  object: PedestrianAutomaticEmergencyBraking_Insert_Input_Vpic;
  on_conflict?: InputMaybe<PedestrianAutomaticEmergencyBraking_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_PretensionerArgs = {
  objects: Array<Pretensioner_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Pretensioner_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Pretensioner_OneArgs = {
  object: Pretensioner_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Pretensioner_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_RearAutomaticEmergencyBrakingArgs = {
  objects: Array<RearAutomaticEmergencyBraking_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<RearAutomaticEmergencyBraking_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_RearAutomaticEmergencyBraking_OneArgs = {
  object: RearAutomaticEmergencyBraking_Insert_Input_Vpic;
  on_conflict?: InputMaybe<RearAutomaticEmergencyBraking_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_RearCrossTrafficAlertArgs = {
  objects: Array<RearCrossTrafficAlert_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<RearCrossTrafficAlert_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_RearCrossTrafficAlert_OneArgs = {
  object: RearCrossTrafficAlert_Insert_Input_Vpic;
  on_conflict?: InputMaybe<RearCrossTrafficAlert_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_RearVisibilityCameraArgs = {
  objects: Array<RearVisibilityCamera_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<RearVisibilityCamera_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_RearVisibilityCamera_OneArgs = {
  object: RearVisibilityCamera_Insert_Input_Vpic;
  on_conflict?: InputMaybe<RearVisibilityCamera_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_SeatBeltsAllArgs = {
  objects: Array<SeatBeltsAll_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<SeatBeltsAll_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_SeatBeltsAll_OneArgs = {
  object: SeatBeltsAll_Insert_Input_Vpic;
  on_conflict?: InputMaybe<SeatBeltsAll_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_SemiautomaticHeadlampBeamSwitchingArgs = {
  objects: Array<SemiautomaticHeadlampBeamSwitching_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<SemiautomaticHeadlampBeamSwitching_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_SemiautomaticHeadlampBeamSwitching_OneArgs = {
  object: SemiautomaticHeadlampBeamSwitching_Insert_Input_Vpic;
  on_conflict?: InputMaybe<SemiautomaticHeadlampBeamSwitching_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_SteeringArgs = {
  objects: Array<Steering_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Steering_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Steering_OneArgs = {
  object: Steering_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Steering_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_TpmsArgs = {
  objects: Array<Tpms_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Tpms_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Tpms_OneArgs = {
  object: Tpms_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Tpms_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_TractionControlArgs = {
  objects: Array<TractionControl_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<TractionControl_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_TractionControl_OneArgs = {
  object: TractionControl_Insert_Input_Vpic;
  on_conflict?: InputMaybe<TractionControl_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_TrailerBodyTypeArgs = {
  objects: Array<TrailerBodyType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<TrailerBodyType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_TrailerBodyType_OneArgs = {
  object: TrailerBodyType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<TrailerBodyType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_TrailerTypeArgs = {
  objects: Array<TrailerType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<TrailerType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_TrailerType_OneArgs = {
  object: TrailerType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<TrailerType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_TransmissionArgs = {
  objects: Array<Transmission_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Transmission_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Transmission_OneArgs = {
  object: Transmission_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Transmission_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_TurboArgs = {
  objects: Array<Turbo_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Turbo_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Turbo_OneArgs = {
  object: Turbo_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Turbo_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VSpecSchemaPatternArgs = {
  objects: Array<VSpecSchemaPattern_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<VSpecSchemaPattern_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VSpecSchemaPattern_OneArgs = {
  object: VSpecSchemaPattern_Insert_Input_Vpic;
  on_conflict?: InputMaybe<VSpecSchemaPattern_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ValvetrainDesignArgs = {
  objects: Array<ValvetrainDesign_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<ValvetrainDesign_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_ValvetrainDesign_OneArgs = {
  object: ValvetrainDesign_Insert_Input_Vpic;
  on_conflict?: InputMaybe<ValvetrainDesign_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleSpecPatternArgs = {
  objects: Array<VehicleSpecPattern_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<VehicleSpecPattern_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleSpecPattern_OneArgs = {
  object: VehicleSpecPattern_Insert_Input_Vpic;
  on_conflict?: InputMaybe<VehicleSpecPattern_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleSpecSchemaArgs = {
  objects: Array<VehicleSpecSchema_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<VehicleSpecSchema_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleSpecSchema_ModelArgs = {
  objects: Array<VehicleSpecSchema_Model_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<VehicleSpecSchema_Model_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleSpecSchema_Model_OneArgs = {
  object: VehicleSpecSchema_Model_Insert_Input_Vpic;
  on_conflict?: InputMaybe<VehicleSpecSchema_Model_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleSpecSchema_YearArgs = {
  objects: Array<VehicleSpecSchema_Year_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<VehicleSpecSchema_Year_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleSpecSchema_Year_OneArgs = {
  object: VehicleSpecSchema_Year_Insert_Input_Vpic;
  on_conflict?: InputMaybe<VehicleSpecSchema_Year_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleSpecSchema_OneArgs = {
  object: VehicleSpecSchema_Insert_Input_Vpic;
  on_conflict?: InputMaybe<VehicleSpecSchema_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleTypeArgs = {
  objects: Array<VehicleType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<VehicleType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleType_OneArgs = {
  object: VehicleType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<VehicleType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VinDescriptorArgs = {
  objects: Array<VinDescriptor_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<VinDescriptor_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VinDescriptor_OneArgs = {
  object: VinDescriptor_Insert_Input_Vpic;
  on_conflict?: InputMaybe<VinDescriptor_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VinExceptionArgs = {
  objects: Array<VinException_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<VinException_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VinException_OneArgs = {
  object: VinException_Insert_Input_Vpic;
  on_conflict?: InputMaybe<VinException_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VinSchemaArgs = {
  objects: Array<VinSchema_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<VinSchema_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_VinSchema_OneArgs = {
  object: VinSchema_Insert_Input_Vpic;
  on_conflict?: InputMaybe<VinSchema_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_WmiYearValidCharsArgs = {
  objects: Array<WmiYearValidChars_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<WmiYearValidChars_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_WmiYearValidChars_CacheExceptionsArgs = {
  objects: Array<WmiYearValidChars_CacheExceptions_Insert_Input_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_WmiYearValidChars_CacheExceptions_OneArgs = {
  object: WmiYearValidChars_CacheExceptions_Insert_Input_Vpic;
};


/** mutation root */
export type Mutation_RootInsert_WmiYearValidChars_OneArgs = {
  object: WmiYearValidChars_Insert_Input_Vpic;
  on_conflict?: InputMaybe<WmiYearValidChars_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_WheelBaseTypeArgs = {
  objects: Array<WheelBaseType_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<WheelBaseType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_WheelBaseType_OneArgs = {
  object: WheelBaseType_Insert_Input_Vpic;
  on_conflict?: InputMaybe<WheelBaseType_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_WheelieMitigationArgs = {
  objects: Array<WheelieMitigation_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<WheelieMitigation_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_WheelieMitigation_OneArgs = {
  object: WheelieMitigation_Insert_Input_Vpic;
  on_conflict?: InputMaybe<WheelieMitigation_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_WmiArgs = {
  objects: Array<Wmi_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Wmi_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Wmi_MakeArgs = {
  objects: Array<Wmi_Make_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Wmi_Make_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Wmi_Make_OneArgs = {
  object: Wmi_Make_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Wmi_Make_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Wmi_VinSchemaArgs = {
  objects: Array<Wmi_VinSchema_Insert_Input_Vpic>;
  on_conflict?: InputMaybe<Wmi_VinSchema_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Wmi_VinSchema_OneArgs = {
  object: Wmi_VinSchema_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Wmi_VinSchema_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Wmi_OneArgs = {
  object: Wmi_Insert_Input_Vpic;
  on_conflict?: InputMaybe<Wmi_On_Conflict_Vpic>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Message_Formatter_ConfigArgs = {
  objects: Array<Audit_Message_Formatter_Config_Insert_Input>;
  on_conflict?: InputMaybe<Audit_Message_Formatter_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Message_Formatter_Config_OneArgs = {
  object: Audit_Message_Formatter_Config_Insert_Input;
  on_conflict?: InputMaybe<Audit_Message_Formatter_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_GroupArgs = {
  objects: Array<Auth_Group_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Group_ActionsArgs = {
  objects: Array<Auth_Group_Actions_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Group_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Group_Actions_OneArgs = {
  object: Auth_Group_Actions_Insert_Input;
  on_conflict?: InputMaybe<Auth_Group_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Group_OneArgs = {
  object: Auth_Group_Insert_Input;
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Claims_Pre_Authorization_Vehicle_InformationArgs = {
  objects: Array<Claims_Pre_Authorization_Vehicle_Information_Insert_Input>;
  on_conflict?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Claims_Pre_Authorization_Vehicle_Information_OneArgs = {
  object: Claims_Pre_Authorization_Vehicle_Information_Insert_Input;
  on_conflict?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Claims_Temp_Claims_Auth_TableArgs = {
  objects: Array<Claims_Temp_Claims_Auth_Table_Insert_Input>;
  on_conflict?: InputMaybe<Claims_Temp_Claims_Auth_Table_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Claims_Temp_Claims_Auth_Table_OneArgs = {
  object: Claims_Temp_Claims_Auth_Table_Insert_Input;
  on_conflict?: InputMaybe<Claims_Temp_Claims_Auth_Table_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConcernSynonymArgs = {
  objects: Array<ConcernSynonym_Insert_Input_Nhtsa>;
  on_conflict?: InputMaybe<ConcernSynonym_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_ConcernSynonym_OneArgs = {
  object: ConcernSynonym_Insert_Input_Nhtsa;
  on_conflict?: InputMaybe<ConcernSynonym_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_IdentitiesArgs = {
  objects: Array<Identities_Insert_Input>;
  on_conflict?: InputMaybe<Identities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Identities_OneArgs = {
  object: Identities_Insert_Input;
  on_conflict?: InputMaybe<Identities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IdentityCapabilityViewArgs = {
  objects: Array<IdentityCapabilityView_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_IdentityCapabilityView_OneArgs = {
  object: IdentityCapabilityView_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_InvestigationRecallArgs = {
  objects: Array<InvestigationRecall_Insert_Input_Nhtsa>;
  on_conflict?: InputMaybe<InvestigationRecall_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_InvestigationRecall_OneArgs = {
  object: InvestigationRecall_Insert_Input_Nhtsa;
  on_conflict?: InputMaybe<InvestigationRecall_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_IssueArgs = {
  objects: Array<Issue_Insert_Input_Nhtsa>;
  on_conflict?: InputMaybe<Issue_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_IssueMakeModelArgs = {
  objects: Array<IssueMakeModel_Insert_Input_Nhtsa>;
  on_conflict?: InputMaybe<IssueMakeModel_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_IssueMakeModel_OneArgs = {
  object: IssueMakeModel_Insert_Input_Nhtsa;
  on_conflict?: InputMaybe<IssueMakeModel_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_IssueSearchResultArgs = {
  objects: Array<IssueSearchResult_Insert_Input_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_IssueSearchResult_OneArgs = {
  object: IssueSearchResult_Insert_Input_Nhtsa;
};


/** mutation root */
export type Mutation_RootInsert_Issue_OneArgs = {
  object: Issue_Insert_Input_Nhtsa;
  on_conflict?: InputMaybe<Issue_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_LoadArgs = {
  objects: Array<Load_Insert_Input_Nhtsa>;
  on_conflict?: InputMaybe<Load_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_Load_OneArgs = {
  object: Load_Insert_Input_Nhtsa;
  on_conflict?: InputMaybe<Load_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_MakeModelArgs = {
  objects: Array<MakeModel_Insert_Input_Nhtsa>;
  on_conflict?: InputMaybe<MakeModel_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_MakeModel_OneArgs = {
  object: MakeModel_Insert_Input_Nhtsa;
  on_conflict?: InputMaybe<MakeModel_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_ModelYearModelArgs = {
  objects: Array<ModelYearModel_Insert_Input_Nhtsa>;
  on_conflict?: InputMaybe<ModelYearModel_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_ModelYearModel_OneArgs = {
  object: ModelYearModel_Insert_Input_Nhtsa;
  on_conflict?: InputMaybe<ModelYearModel_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Legacy_Policy_Contract_Cost_Detail_ViewArgs = {
  objects: Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_Legacy_Policy_Contract_Cost_Detail_View_OneArgs = {
  object: Operations_Legacy_Policy_Contract_Cost_Detail_View_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_RecordTypeArgs = {
  objects: Array<RecordType_Insert_Input_Nhtsa>;
  on_conflict?: InputMaybe<RecordType_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_RecordType_OneArgs = {
  object: RecordType_Insert_Input_Nhtsa;
  on_conflict?: InputMaybe<RecordType_On_Conflict_Nhtsa>;
};


/** mutation root */
export type Mutation_RootInsert_Shared_Search_ResultArgs = {
  objects: Array<Shared_Search_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Shared_Search_Result_OneArgs = {
  object: Shared_Search_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VehicleClassingBodyStyleArgs = {
  if_matched?: InputMaybe<VehicleClassingBodyStyle_If_Matched>;
  objects: Array<VehicleClassingBodyStyle_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleClassingBodyStyle_OneArgs = {
  if_matched?: InputMaybe<VehicleClassingBodyStyle_If_Matched>;
  object: VehicleClassingBodyStyle_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VehicleClassingFuelTypeArgs = {
  if_matched?: InputMaybe<VehicleClassingFuelType_If_Matched>;
  objects: Array<VehicleClassingFuelType_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleClassingFuelType_OneArgs = {
  if_matched?: InputMaybe<VehicleClassingFuelType_If_Matched>;
  object: VehicleClassingFuelType_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VehicleClassingVehicleMakeArgs = {
  if_matched?: InputMaybe<VehicleClassingVehicleMake_If_Matched>;
  objects: Array<VehicleClassingVehicleMake_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleClassingVehicleMake_OneArgs = {
  if_matched?: InputMaybe<VehicleClassingVehicleMake_If_Matched>;
  object: VehicleClassingVehicleMake_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VehicleClassingVehicleTypeArgs = {
  if_matched?: InputMaybe<VehicleClassingVehicleType_If_Matched>;
  objects: Array<VehicleClassingVehicleType_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleClassingVehicleType_OneArgs = {
  if_matched?: InputMaybe<VehicleClassingVehicleType_If_Matched>;
  object: VehicleClassingVehicleType_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleCylindersDistinctArgs = {
  if_matched?: InputMaybe<VwVehicleCylindersDistinct_If_Matched>;
  objects: Array<VwVehicleCylindersDistinct_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleCylindersDistinct_OneArgs = {
  if_matched?: InputMaybe<VwVehicleCylindersDistinct_If_Matched>;
  object: VwVehicleCylindersDistinct_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleDrivingWheelsDistinctArgs = {
  if_matched?: InputMaybe<VwVehicleDrivingWheelsDistinct_If_Matched>;
  objects: Array<VwVehicleDrivingWheelsDistinct_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleDrivingWheelsDistinct_OneArgs = {
  if_matched?: InputMaybe<VwVehicleDrivingWheelsDistinct_If_Matched>;
  object: VwVehicleDrivingWheelsDistinct_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleFuelTypesDistinctArgs = {
  if_matched?: InputMaybe<VwVehicleFuelTypesDistinct_If_Matched>;
  objects: Array<VwVehicleFuelTypesDistinct_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleFuelTypesDistinct_OneArgs = {
  if_matched?: InputMaybe<VwVehicleFuelTypesDistinct_If_Matched>;
  object: VwVehicleFuelTypesDistinct_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleMakesDistinctArgs = {
  if_matched?: InputMaybe<VwVehicleMakesDistinct_If_Matched>;
  objects: Array<VwVehicleMakesDistinct_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleMakesDistinct_OneArgs = {
  if_matched?: InputMaybe<VwVehicleMakesDistinct_If_Matched>;
  object: VwVehicleMakesDistinct_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleModelsDistinctArgs = {
  if_matched?: InputMaybe<VwVehicleModelsDistinct_If_Matched>;
  objects: Array<VwVehicleModelsDistinct_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleModelsDistinct_OneArgs = {
  if_matched?: InputMaybe<VwVehicleModelsDistinct_If_Matched>;
  object: VwVehicleModelsDistinct_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleYearsDistinctArgs = {
  if_matched?: InputMaybe<VwVehicleYearsDistinct_If_Matched>;
  objects: Array<VwVehicleYearsDistinct_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_VwVehicleYearsDistinct_OneArgs = {
  if_matched?: InputMaybe<VwVehicleYearsDistinct_If_Matched>;
  object: VwVehicleYearsDistinct_Insert_Input;
};


/** mutation root */
export type Mutation_RootLegacy_Claims_DeleteDealerArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootLegacy_Claims_DeleteDealersArgs = {
  where: Legacy_Claims_Dealer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootLegacy_Claims_DeleteNoteArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootLegacy_Claims_DeleteNotesArgs = {
  where: Legacy_Claims_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootLegacy_Claims_InsertDealerArgs = {
  object: Legacy_Claims_Dealer_Insert_Input;
  on_conflict?: InputMaybe<Legacy_Claims_Dealer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLegacy_Claims_InsertDealersArgs = {
  objects: Array<Legacy_Claims_Dealer_Insert_Input>;
  on_conflict?: InputMaybe<Legacy_Claims_Dealer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLegacy_Claims_InsertNoteArgs = {
  object: Legacy_Claims_Note_Insert_Input;
  on_conflict?: InputMaybe<Legacy_Claims_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLegacy_Claims_InsertNotesArgs = {
  objects: Array<Legacy_Claims_Note_Insert_Input>;
  on_conflict?: InputMaybe<Legacy_Claims_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLegacy_Claims_UpdateDealerArgs = {
  _inc?: InputMaybe<Legacy_Claims_Dealer_Inc_Input>;
  _set?: InputMaybe<Legacy_Claims_Dealer_Set_Input>;
  pk_columns: Legacy_Claims_Dealer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootLegacy_Claims_UpdateDealersArgs = {
  _inc?: InputMaybe<Legacy_Claims_Dealer_Inc_Input>;
  _set?: InputMaybe<Legacy_Claims_Dealer_Set_Input>;
  where: Legacy_Claims_Dealer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootLegacy_Claims_UpdateNoteArgs = {
  _set?: InputMaybe<Legacy_Claims_Note_Set_Input>;
  pk_columns: Legacy_Claims_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootLegacy_Claims_UpdateNotesArgs = {
  _set?: InputMaybe<Legacy_Claims_Note_Set_Input>;
  where: Legacy_Claims_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootSaveRateQuoteActionArgs = {
  object: SaveRateQuoteActionInput;
};


/** mutation root */
export type Mutation_RootUpdateAccountArgs = {
  _append?: InputMaybe<Account_Append_Input>;
  _delete_at_path?: InputMaybe<Account_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Account_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Account_Delete_Key_Input>;
  _inc?: InputMaybe<Account_Inc_Input>;
  _prepend?: InputMaybe<Account_Prepend_Input>;
  _set?: InputMaybe<Account_Set_Input>;
  pk_columns: Account_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAccountAccountManagerArgs = {
  _set?: InputMaybe<AccountAccountManager_Set_Input>;
  pk_columns: AccountAccountManager_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAccountAccountManagersArgs = {
  _set?: InputMaybe<AccountAccountManager_Set_Input>;
  where: AccountAccountManager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAccountCategoriesArgs = {
  _set?: InputMaybe<AccountCategory_Set_Input>;
  where: AccountCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAccountCategoryArgs = {
  _set?: InputMaybe<AccountCategory_Set_Input>;
  pk_columns: AccountCategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAccountDisbursementArgs = {
  _inc?: InputMaybe<AccountDisbursement_Inc_Input>;
  _set?: InputMaybe<AccountDisbursement_Set_Input>;
  pk_columns: AccountDisbursement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAccountDisbursementsArgs = {
  _inc?: InputMaybe<AccountDisbursement_Inc_Input>;
  _set?: InputMaybe<AccountDisbursement_Set_Input>;
  where: AccountDisbursement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAccountManagerArgs = {
  _set?: InputMaybe<AccountManager_Set_Input>;
  pk_columns: AccountManager_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAccountManagersArgs = {
  _set?: InputMaybe<AccountManager_Set_Input>;
  where: AccountManager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAccountObligorArgs = {
  _set?: InputMaybe<AccountObligor_Set_Input>;
  pk_columns: AccountObligor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAccountObligorsArgs = {
  _set?: InputMaybe<AccountObligor_Set_Input>;
  where: AccountObligor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAccountProductArgs = {
  _inc?: InputMaybe<AccountProduct_Inc_Input>;
  _set?: InputMaybe<AccountProduct_Set_Input>;
  pk_columns: AccountProduct_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAccountProductObligorArgs = {
  _set?: InputMaybe<AccountProductObligor_Set_Input>;
  pk_columns: AccountProductObligor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAccountProductObligorsArgs = {
  _set?: InputMaybe<AccountProductObligor_Set_Input>;
  where: AccountProductObligor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAccountProductsArgs = {
  _inc?: InputMaybe<AccountProduct_Inc_Input>;
  _set?: InputMaybe<AccountProduct_Set_Input>;
  where: AccountProduct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAccountRetailArgs = {
  _inc?: InputMaybe<AccountRetail_Inc_Input>;
  _set?: InputMaybe<AccountRetail_Set_Input>;
  pk_columns: AccountRetail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAccountRetailsArgs = {
  _inc?: InputMaybe<AccountRetail_Inc_Input>;
  _set?: InputMaybe<AccountRetail_Set_Input>;
  where: AccountRetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAccountTypeArgs = {
  _inc?: InputMaybe<AccountType_Inc_Input>;
  _set?: InputMaybe<AccountType_Set_Input>;
  pk_columns: AccountType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAccountTypesArgs = {
  _inc?: InputMaybe<AccountType_Inc_Input>;
  _set?: InputMaybe<AccountType_Set_Input>;
  where: AccountType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAccountsArgs = {
  _append?: InputMaybe<Account_Append_Input>;
  _delete_at_path?: InputMaybe<Account_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Account_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Account_Delete_Key_Input>;
  _inc?: InputMaybe<Account_Inc_Input>;
  _prepend?: InputMaybe<Account_Prepend_Input>;
  _set?: InputMaybe<Account_Set_Input>;
  where: Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAddressArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAddressTypeArgs = {
  _inc?: InputMaybe<AddressType_Inc_Input>;
  _set?: InputMaybe<AddressType_Set_Input>;
  pk_columns: AddressType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAddressTypesArgs = {
  _inc?: InputMaybe<AddressType_Inc_Input>;
  _set?: InputMaybe<AddressType_Set_Input>;
  where: AddressType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAddressesArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAlertArgs = {
  _set?: InputMaybe<Alert_Set_Input>;
  pk_columns: Alert_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAlertAcknowledgmentArgs = {
  _set?: InputMaybe<AlertAcknowledgment_Set_Input>;
  pk_columns: AlertAcknowledgment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAlertAcknowledgmentsArgs = {
  _set?: InputMaybe<AlertAcknowledgment_Set_Input>;
  where: AlertAcknowledgment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAlertsArgs = {
  _set?: InputMaybe<Alert_Set_Input>;
  where: Alert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateApplicationArgs = {
  _inc?: InputMaybe<Application_Inc_Input>;
  _set?: InputMaybe<Application_Set_Input>;
  pk_columns: Application_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateApplicationPreferenceArgs = {
  _append?: InputMaybe<ApplicationPreference_Append_Input>;
  _delete_at_path?: InputMaybe<ApplicationPreference_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ApplicationPreference_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ApplicationPreference_Delete_Key_Input>;
  _prepend?: InputMaybe<ApplicationPreference_Prepend_Input>;
  _set?: InputMaybe<ApplicationPreference_Set_Input>;
  pk_columns: ApplicationPreference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateApplicationPreferencesArgs = {
  _append?: InputMaybe<ApplicationPreference_Append_Input>;
  _delete_at_path?: InputMaybe<ApplicationPreference_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ApplicationPreference_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ApplicationPreference_Delete_Key_Input>;
  _prepend?: InputMaybe<ApplicationPreference_Prepend_Input>;
  _set?: InputMaybe<ApplicationPreference_Set_Input>;
  where: ApplicationPreference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateApplicationsArgs = {
  _inc?: InputMaybe<Application_Inc_Input>;
  _set?: InputMaybe<Application_Set_Input>;
  where: Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateApprovalArgs = {
  _inc?: InputMaybe<Approval_Inc_Input>;
  _set?: InputMaybe<Approval_Set_Input>;
  pk_columns: Approval_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateApprovalAuthoritiesArgs = {
  _inc?: InputMaybe<ApprovalAuthority_Inc_Input>;
  _set?: InputMaybe<ApprovalAuthority_Set_Input>;
  where: ApprovalAuthority_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateApprovalAuthorityArgs = {
  _inc?: InputMaybe<ApprovalAuthority_Inc_Input>;
  _set?: InputMaybe<ApprovalAuthority_Set_Input>;
  pk_columns: ApprovalAuthority_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateApprovalGateArgs = {
  _set?: InputMaybe<ApprovalGate_Set_Input>;
  pk_columns: ApprovalGate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateApprovalGateBindingArgs = {
  _set?: InputMaybe<ApprovalGateBinding_Set_Input>;
  pk_columns: ApprovalGateBinding_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateApprovalGateBindingsArgs = {
  _set?: InputMaybe<ApprovalGateBinding_Set_Input>;
  where: ApprovalGateBinding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateApprovalGatesArgs = {
  _set?: InputMaybe<ApprovalGate_Set_Input>;
  where: ApprovalGate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateApprovalRecordsArgs = {
  _inc?: InputMaybe<Approval_Inc_Input>;
  _set?: InputMaybe<Approval_Set_Input>;
  where: Approval_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateApprovalRequestArgs = {
  _inc?: InputMaybe<ApprovalRequest_Inc_Input>;
  _set?: InputMaybe<ApprovalRequest_Set_Input>;
  pk_columns: ApprovalRequest_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateApprovalRequestsArgs = {
  _inc?: InputMaybe<ApprovalRequest_Inc_Input>;
  _set?: InputMaybe<ApprovalRequest_Set_Input>;
  where: ApprovalRequest_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateApprovalStatesArgs = {
  _inc?: InputMaybe<ApprovalState_Inc_Input>;
  _set?: InputMaybe<ApprovalState_Set_Input>;
  where: ApprovalState_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAs400DataSyncArgs = {
  _set?: InputMaybe<As400DataSync_Set_Input>;
  pk_columns: As400DataSync_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAs400DataSyncsArgs = {
  _set?: InputMaybe<As400DataSync_Set_Input>;
  where: As400DataSync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateBankAccountTypeArgs = {
  _inc?: InputMaybe<BankAccountType_Inc_Input>;
  _set?: InputMaybe<BankAccountType_Set_Input>;
  pk_columns: BankAccountType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateBankAccountTypesArgs = {
  _inc?: InputMaybe<BankAccountType_Inc_Input>;
  _set?: InputMaybe<BankAccountType_Set_Input>;
  where: BankAccountType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCaddyArgs = {
  _append?: InputMaybe<Caddy_Append_Input>;
  _delete_at_path?: InputMaybe<Caddy_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Caddy_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Caddy_Delete_Key_Input>;
  _prepend?: InputMaybe<Caddy_Prepend_Input>;
  _set?: InputMaybe<Caddy_Set_Input>;
  pk_columns: Caddy_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCaddyServerManagerLogArgs = {
  _append?: InputMaybe<CaddyServerManagerLog_Append_Input>;
  _delete_at_path?: InputMaybe<CaddyServerManagerLog_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CaddyServerManagerLog_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CaddyServerManagerLog_Delete_Key_Input>;
  _prepend?: InputMaybe<CaddyServerManagerLog_Prepend_Input>;
  _set?: InputMaybe<CaddyServerManagerLog_Set_Input>;
  pk_columns: CaddyServerManagerLog_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCaddyServerManagerLogsArgs = {
  _append?: InputMaybe<CaddyServerManagerLog_Append_Input>;
  _delete_at_path?: InputMaybe<CaddyServerManagerLog_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CaddyServerManagerLog_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CaddyServerManagerLog_Delete_Key_Input>;
  _prepend?: InputMaybe<CaddyServerManagerLog_Prepend_Input>;
  _set?: InputMaybe<CaddyServerManagerLog_Set_Input>;
  where: CaddyServerManagerLog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCaddysArgs = {
  _append?: InputMaybe<Caddy_Append_Input>;
  _delete_at_path?: InputMaybe<Caddy_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Caddy_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Caddy_Delete_Key_Input>;
  _prepend?: InputMaybe<Caddy_Prepend_Input>;
  _set?: InputMaybe<Caddy_Set_Input>;
  where: Caddy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCancelRuleArgs = {
  _inc?: InputMaybe<CancelRule_Inc_Input>;
  _set?: InputMaybe<CancelRule_Set_Input>;
  pk_columns: CancelRule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCancelRuleFeeArgs = {
  _inc?: InputMaybe<CancelRuleFee_Inc_Input>;
  _set?: InputMaybe<CancelRuleFee_Set_Input>;
  pk_columns: CancelRuleFee_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCancelRuleFeesArgs = {
  _inc?: InputMaybe<CancelRuleFee_Inc_Input>;
  _set?: InputMaybe<CancelRuleFee_Set_Input>;
  where: CancelRuleFee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCancelRuleRefundArgs = {
  _set?: InputMaybe<CancelRuleRefund_Set_Input>;
  pk_columns: CancelRuleRefund_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCancelRuleRefundsArgs = {
  _set?: InputMaybe<CancelRuleRefund_Set_Input>;
  where: CancelRuleRefund_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCancelRulesArgs = {
  _inc?: InputMaybe<CancelRule_Inc_Input>;
  _set?: InputMaybe<CancelRule_Set_Input>;
  where: CancelRule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCancellationArgs = {
  _append?: InputMaybe<Cancellation_Append_Input>;
  _delete_at_path?: InputMaybe<Cancellation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cancellation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cancellation_Delete_Key_Input>;
  _inc?: InputMaybe<Cancellation_Inc_Input>;
  _prepend?: InputMaybe<Cancellation_Prepend_Input>;
  _set?: InputMaybe<Cancellation_Set_Input>;
  pk_columns: Cancellation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCancellationAs400Args = {
  _set?: InputMaybe<CancellationAs400_Set_Input>;
  pk_columns: CancellationAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCancellationAs400sArgs = {
  _set?: InputMaybe<CancellationAs400_Set_Input>;
  where: CancellationAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCancellationsArgs = {
  _append?: InputMaybe<Cancellation_Append_Input>;
  _delete_at_path?: InputMaybe<Cancellation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cancellation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cancellation_Delete_Key_Input>;
  _inc?: InputMaybe<Cancellation_Inc_Input>;
  _prepend?: InputMaybe<Cancellation_Prepend_Input>;
  _set?: InputMaybe<Cancellation_Set_Input>;
  where: Cancellation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCapabilitiesArgs = {
  _set?: InputMaybe<Capability_Set_Input>;
  where: Capability_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCapabilityArgs = {
  _set?: InputMaybe<Capability_Set_Input>;
  pk_columns: Capability_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCapabilityConfigArgs = {
  _set?: InputMaybe<CapabilityConfig_Set_Input>;
  pk_columns: CapabilityConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCapabilityConfigsArgs = {
  _set?: InputMaybe<CapabilityConfig_Set_Input>;
  where: CapabilityConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCapabilityRouteArgs = {
  _set?: InputMaybe<CapabilityRoute_Set_Input>;
  pk_columns: CapabilityRoute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCapabilityRoutesArgs = {
  _set?: InputMaybe<CapabilityRoute_Set_Input>;
  where: CapabilityRoute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCardLayoutArgs = {
  _append?: InputMaybe<CardLayout_Append_Input>;
  _delete_at_path?: InputMaybe<CardLayout_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CardLayout_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CardLayout_Delete_Key_Input>;
  _prepend?: InputMaybe<CardLayout_Prepend_Input>;
  _set?: InputMaybe<CardLayout_Set_Input>;
  pk_columns: CardLayout_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCardLayoutsArgs = {
  _append?: InputMaybe<CardLayout_Append_Input>;
  _delete_at_path?: InputMaybe<CardLayout_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CardLayout_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CardLayout_Delete_Key_Input>;
  _prepend?: InputMaybe<CardLayout_Prepend_Input>;
  _set?: InputMaybe<CardLayout_Set_Input>;
  where: CardLayout_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCarrierArgs = {
  _set?: InputMaybe<Carrier_Set_Input>;
  pk_columns: Carrier_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCarriersArgs = {
  _set?: InputMaybe<Carrier_Set_Input>;
  where: Carrier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCategoriesArgs = {
  _set?: InputMaybe<Category_Set_Input>;
  where: Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCategoryArgs = {
  _set?: InputMaybe<Category_Set_Input>;
  pk_columns: Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCategoryProductAttributeTypeArgs = {
  _inc?: InputMaybe<CategoryProductAttributeType_Inc_Input>;
  _set?: InputMaybe<CategoryProductAttributeType_Set_Input>;
  pk_columns: CategoryProductAttributeType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCategoryProductAttributeTypesArgs = {
  _inc?: InputMaybe<CategoryProductAttributeType_Inc_Input>;
  _set?: InputMaybe<CategoryProductAttributeType_Set_Input>;
  where: CategoryProductAttributeType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimArgs = {
  _inc?: InputMaybe<Claim_Inc_Input>;
  _set?: InputMaybe<Claim_Set_Input>;
  pk_columns: Claim_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimDetailArgs = {
  _append?: InputMaybe<ClaimDetail_Append_Input>;
  _delete_at_path?: InputMaybe<ClaimDetail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ClaimDetail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ClaimDetail_Delete_Key_Input>;
  _inc?: InputMaybe<ClaimDetail_Inc_Input>;
  _prepend?: InputMaybe<ClaimDetail_Prepend_Input>;
  _set?: InputMaybe<ClaimDetail_Set_Input>;
  pk_columns: ClaimDetail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimDetailAs400Args = {
  _inc?: InputMaybe<ClaimDetailAs400_Inc_Input>;
  _set?: InputMaybe<ClaimDetailAs400_Set_Input>;
  pk_columns: ClaimDetailAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimDetailAs400sArgs = {
  _inc?: InputMaybe<ClaimDetailAs400_Inc_Input>;
  _set?: InputMaybe<ClaimDetailAs400_Set_Input>;
  where: ClaimDetailAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimDetailCategoriesArgs = {
  _set?: InputMaybe<ClaimDetailCategory_Set_Input>;
  where: ClaimDetailCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimDetailCategoryArgs = {
  _set?: InputMaybe<ClaimDetailCategory_Set_Input>;
  pk_columns: ClaimDetailCategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimDetailDeductionAs400Args = {
  _inc?: InputMaybe<ClaimDetailDeductionAs400_Inc_Input>;
  _set?: InputMaybe<ClaimDetailDeductionAs400_Set_Input>;
  pk_columns: ClaimDetailDeductionAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimDetailDeductionAs400sArgs = {
  _inc?: InputMaybe<ClaimDetailDeductionAs400_Inc_Input>;
  _set?: InputMaybe<ClaimDetailDeductionAs400_Set_Input>;
  where: ClaimDetailDeductionAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimDetailPartLookupArgs = {
  _inc?: InputMaybe<ClaimDetailPartLookup_Inc_Input>;
  _set?: InputMaybe<ClaimDetailPartLookup_Set_Input>;
  pk_columns: ClaimDetailPartLookup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimDetailPartLookupsArgs = {
  _inc?: InputMaybe<ClaimDetailPartLookup_Inc_Input>;
  _set?: InputMaybe<ClaimDetailPartLookup_Set_Input>;
  where: ClaimDetailPartLookup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimDetailsArgs = {
  _append?: InputMaybe<ClaimDetail_Append_Input>;
  _delete_at_path?: InputMaybe<ClaimDetail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ClaimDetail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ClaimDetail_Delete_Key_Input>;
  _inc?: InputMaybe<ClaimDetail_Inc_Input>;
  _prepend?: InputMaybe<ClaimDetail_Prepend_Input>;
  _set?: InputMaybe<ClaimDetail_Set_Input>;
  where: ClaimDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimServiceCenterArgs = {
  _append?: InputMaybe<ClaimServiceCenter_Append_Input>;
  _delete_at_path?: InputMaybe<ClaimServiceCenter_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ClaimServiceCenter_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ClaimServiceCenter_Delete_Key_Input>;
  _inc?: InputMaybe<ClaimServiceCenter_Inc_Input>;
  _prepend?: InputMaybe<ClaimServiceCenter_Prepend_Input>;
  _set?: InputMaybe<ClaimServiceCenter_Set_Input>;
  pk_columns: ClaimServiceCenter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimServiceCenterAs400Args = {
  _set?: InputMaybe<ClaimServiceCenterAs400_Set_Input>;
  pk_columns: ClaimServiceCenterAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimServiceCenterAs400sArgs = {
  _set?: InputMaybe<ClaimServiceCenterAs400_Set_Input>;
  where: ClaimServiceCenterAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimServiceCenterAuthorizationArgs = {
  _inc?: InputMaybe<ClaimServiceCenterAuthorization_Inc_Input>;
  _set?: InputMaybe<ClaimServiceCenterAuthorization_Set_Input>;
  pk_columns: ClaimServiceCenterAuthorization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimServiceCenterAuthorizationsArgs = {
  _inc?: InputMaybe<ClaimServiceCenterAuthorization_Inc_Input>;
  _set?: InputMaybe<ClaimServiceCenterAuthorization_Set_Input>;
  where: ClaimServiceCenterAuthorization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimServiceCentersArgs = {
  _append?: InputMaybe<ClaimServiceCenter_Append_Input>;
  _delete_at_path?: InputMaybe<ClaimServiceCenter_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ClaimServiceCenter_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ClaimServiceCenter_Delete_Key_Input>;
  _inc?: InputMaybe<ClaimServiceCenter_Inc_Input>;
  _prepend?: InputMaybe<ClaimServiceCenter_Prepend_Input>;
  _set?: InputMaybe<ClaimServiceCenter_Set_Input>;
  where: ClaimServiceCenter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimStatusArgs = {
  _set?: InputMaybe<ClaimStatus_Set_Input>;
  pk_columns: ClaimStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimStatusTypeArgs = {
  _inc?: InputMaybe<ClaimStatusType_Inc_Input>;
  _set?: InputMaybe<ClaimStatusType_Set_Input>;
  pk_columns: ClaimStatusType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClaimStatusTypesArgs = {
  _inc?: InputMaybe<ClaimStatusType_Inc_Input>;
  _set?: InputMaybe<ClaimStatusType_Set_Input>;
  where: ClaimStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimStatusesArgs = {
  _set?: InputMaybe<ClaimStatus_Set_Input>;
  where: ClaimStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimsArgs = {
  _inc?: InputMaybe<Claim_Inc_Input>;
  _set?: InputMaybe<Claim_Set_Input>;
  where: Claim_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClaimsMastersArgs = {
  _inc?: InputMaybe<ClaimsMaster_Inc_Input>;
  _set?: InputMaybe<ClaimsMaster_Set_Input>;
  where: ClaimsMaster_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClassCriteriaArgs = {
  _append?: InputMaybe<ClassCriteria_Append_Input>;
  _delete_at_path?: InputMaybe<ClassCriteria_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ClassCriteria_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ClassCriteria_Delete_Key_Input>;
  _inc?: InputMaybe<ClassCriteria_Inc_Input>;
  _prepend?: InputMaybe<ClassCriteria_Prepend_Input>;
  _set?: InputMaybe<ClassCriteria_Set_Input>;
  pk_columns: ClassCriteria_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClassCriteriasArgs = {
  _append?: InputMaybe<ClassCriteria_Append_Input>;
  _delete_at_path?: InputMaybe<ClassCriteria_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ClassCriteria_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ClassCriteria_Delete_Key_Input>;
  _inc?: InputMaybe<ClassCriteria_Inc_Input>;
  _prepend?: InputMaybe<ClassCriteria_Prepend_Input>;
  _set?: InputMaybe<ClassCriteria_Set_Input>;
  where: ClassCriteria_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClassGuideArgs = {
  _set?: InputMaybe<ClassGuide_Set_Input>;
  pk_columns: ClassGuide_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClassGuideClassCriteriaArgs = {
  _set?: InputMaybe<ClassGuideClassCriteria_Set_Input>;
  pk_columns: ClassGuideClassCriteria_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClassGuideClassCriteriasArgs = {
  _set?: InputMaybe<ClassGuideClassCriteria_Set_Input>;
  where: ClassGuideClassCriteria_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClassGuideCriteriaDefinitionArgs = {
  _set?: InputMaybe<ClassGuideCriteriaDefinition_Set_Input>;
  pk_columns: ClassGuideCriteriaDefinition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClassGuideCriteriaDefinitionsArgs = {
  _set?: InputMaybe<ClassGuideCriteriaDefinition_Set_Input>;
  where: ClassGuideCriteriaDefinition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClassGuideCriteriaTypeArgs = {
  _inc?: InputMaybe<ClassGuideCriteriaType_Inc_Input>;
  _set?: InputMaybe<ClassGuideCriteriaType_Set_Input>;
  pk_columns: ClassGuideCriteriaType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateClassGuideCriteriaTypesArgs = {
  _inc?: InputMaybe<ClassGuideCriteriaType_Inc_Input>;
  _set?: InputMaybe<ClassGuideCriteriaType_Set_Input>;
  where: ClassGuideCriteriaType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClassGuidesArgs = {
  _set?: InputMaybe<ClassGuide_Set_Input>;
  where: ClassGuide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCompositeProductArgs = {
  _set?: InputMaybe<CompositeProduct_Set_Input>;
  pk_columns: CompositeProduct_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCompositeProductsArgs = {
  _set?: InputMaybe<CompositeProduct_Set_Input>;
  where: CompositeProduct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateConfigurationItemArgs = {
  _inc?: InputMaybe<ConfigurationItem_Inc_Input>;
  _set?: InputMaybe<ConfigurationItem_Set_Input>;
  pk_columns: ConfigurationItem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateConfigurationItemTypeArgs = {
  _inc?: InputMaybe<ConfigurationItemType_Inc_Input>;
  _set?: InputMaybe<ConfigurationItemType_Set_Input>;
  pk_columns: ConfigurationItemType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateConfigurationItemTypesArgs = {
  _inc?: InputMaybe<ConfigurationItemType_Inc_Input>;
  _set?: InputMaybe<ConfigurationItemType_Set_Input>;
  where: ConfigurationItemType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateConfigurationItemsArgs = {
  _inc?: InputMaybe<ConfigurationItem_Inc_Input>;
  _set?: InputMaybe<ConfigurationItem_Set_Input>;
  where: ConfigurationItem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContactArgs = {
  _set?: InputMaybe<Contact_Set_Input>;
  pk_columns: Contact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateContactsArgs = {
  _set?: InputMaybe<Contact_Set_Input>;
  where: Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContentTypeArgs = {
  _inc?: InputMaybe<ContentType_Inc_Input>;
  _set?: InputMaybe<ContentType_Set_Input>;
  pk_columns: ContentType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateContentTypesArgs = {
  _inc?: InputMaybe<ContentType_Inc_Input>;
  _set?: InputMaybe<ContentType_Set_Input>;
  where: ContentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContractArgs = {
  _inc?: InputMaybe<Contract_Inc_Input>;
  _set?: InputMaybe<Contract_Set_Input>;
  pk_columns: Contract_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateContractFormArgs = {
  _inc?: InputMaybe<ContractForm_Inc_Input>;
  _set?: InputMaybe<ContractForm_Set_Input>;
  pk_columns: ContractForm_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateContractFormFilingStatusArgs = {
  _set?: InputMaybe<ContractFormFilingStatus_Set_Input>;
  pk_columns: ContractFormFilingStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateContractFormFilingStatusesArgs = {
  _set?: InputMaybe<ContractFormFilingStatus_Set_Input>;
  where: ContractFormFilingStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContractFormTypeArgs = {
  _inc?: InputMaybe<ContractFormType_Inc_Input>;
  _set?: InputMaybe<ContractFormType_Set_Input>;
  pk_columns: ContractFormType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateContractFormTypesArgs = {
  _inc?: InputMaybe<ContractFormType_Inc_Input>;
  _set?: InputMaybe<ContractFormType_Set_Input>;
  where: ContractFormType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContractFormVersionArgs = {
  _set?: InputMaybe<ContractFormVersion_Set_Input>;
  pk_columns: ContractFormVersion_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateContractFormVersionLegacyFileArgs = {
  _set?: InputMaybe<ContractFormVersionLegacyFile_Set_Input>;
  pk_columns: ContractFormVersionLegacyFile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateContractFormVersionLegacyFilesArgs = {
  _set?: InputMaybe<ContractFormVersionLegacyFile_Set_Input>;
  where: ContractFormVersionLegacyFile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContractFormVersionsArgs = {
  _set?: InputMaybe<ContractFormVersion_Set_Input>;
  where: ContractFormVersion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContractFormsArgs = {
  _inc?: InputMaybe<ContractForm_Inc_Input>;
  _set?: InputMaybe<ContractForm_Set_Input>;
  where: ContractForm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContractMasterArgs = {
  _inc?: InputMaybe<ContractMaster_Inc_Input>;
  _set?: InputMaybe<ContractMaster_Set_Input>;
  pk_columns: ContractMaster_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateContractMasterAdditionalEntitiesArgs = {
  _inc?: InputMaybe<ContractMasterAdditionalEntity_Inc_Input>;
  _set?: InputMaybe<ContractMasterAdditionalEntity_Set_Input>;
  where: ContractMasterAdditionalEntity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContractMastersArgs = {
  _inc?: InputMaybe<ContractMaster_Inc_Input>;
  _set?: InputMaybe<ContractMaster_Set_Input>;
  where: ContractMaster_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContractStatusTypeArgs = {
  _inc?: InputMaybe<ContractStatusType_Inc_Input>;
  _set?: InputMaybe<ContractStatusType_Set_Input>;
  pk_columns: ContractStatusType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateContractStatusTypesArgs = {
  _inc?: InputMaybe<ContractStatusType_Inc_Input>;
  _set?: InputMaybe<ContractStatusType_Set_Input>;
  where: ContractStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateContractsArgs = {
  _inc?: InputMaybe<Contract_Inc_Input>;
  _set?: InputMaybe<Contract_Set_Input>;
  where: Contract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCostAdjustmentArgs = {
  _inc?: InputMaybe<CostAdjustment_Inc_Input>;
  _set?: InputMaybe<CostAdjustment_Set_Input>;
  pk_columns: CostAdjustment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCostAdjustmentExtendedCostArgs = {
  _inc?: InputMaybe<CostAdjustmentExtendedCost_Inc_Input>;
  _set?: InputMaybe<CostAdjustmentExtendedCost_Set_Input>;
  pk_columns: CostAdjustmentExtendedCost_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCostAdjustmentExtendedCostsArgs = {
  _inc?: InputMaybe<CostAdjustmentExtendedCost_Inc_Input>;
  _set?: InputMaybe<CostAdjustmentExtendedCost_Set_Input>;
  where: CostAdjustmentExtendedCost_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCostAdjustmentLookupArgs = {
  _append?: InputMaybe<CostAdjustmentLookup_Append_Input>;
  _delete_at_path?: InputMaybe<CostAdjustmentLookup_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CostAdjustmentLookup_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CostAdjustmentLookup_Delete_Key_Input>;
  _inc?: InputMaybe<CostAdjustmentLookup_Inc_Input>;
  _prepend?: InputMaybe<CostAdjustmentLookup_Prepend_Input>;
  _set?: InputMaybe<CostAdjustmentLookup_Set_Input>;
  pk_columns: CostAdjustmentLookup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCostAdjustmentLookupsArgs = {
  _append?: InputMaybe<CostAdjustmentLookup_Append_Input>;
  _delete_at_path?: InputMaybe<CostAdjustmentLookup_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CostAdjustmentLookup_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CostAdjustmentLookup_Delete_Key_Input>;
  _inc?: InputMaybe<CostAdjustmentLookup_Inc_Input>;
  _prepend?: InputMaybe<CostAdjustmentLookup_Prepend_Input>;
  _set?: InputMaybe<CostAdjustmentLookup_Set_Input>;
  where: CostAdjustmentLookup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCostAdjustmentTypeArgs = {
  _inc?: InputMaybe<CostAdjustmentType_Inc_Input>;
  _set?: InputMaybe<CostAdjustmentType_Set_Input>;
  pk_columns: CostAdjustmentType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCostAdjustmentTypesArgs = {
  _inc?: InputMaybe<CostAdjustmentType_Inc_Input>;
  _set?: InputMaybe<CostAdjustmentType_Set_Input>;
  where: CostAdjustmentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCostAdjustmentsArgs = {
  _inc?: InputMaybe<CostAdjustment_Inc_Input>;
  _set?: InputMaybe<CostAdjustment_Set_Input>;
  where: CostAdjustment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCustomFieldArgs = {
  _inc?: InputMaybe<CustomField_Inc_Input>;
  _set?: InputMaybe<CustomField_Set_Input>;
  pk_columns: CustomField_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCustomFieldDataArgs = {
  _append?: InputMaybe<CustomFieldData_Append_Input>;
  _delete_at_path?: InputMaybe<CustomFieldData_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CustomFieldData_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CustomFieldData_Delete_Key_Input>;
  _prepend?: InputMaybe<CustomFieldData_Prepend_Input>;
  _set?: InputMaybe<CustomFieldData_Set_Input>;
  pk_columns: CustomFieldData_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCustomFieldDatasArgs = {
  _append?: InputMaybe<CustomFieldData_Append_Input>;
  _delete_at_path?: InputMaybe<CustomFieldData_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CustomFieldData_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CustomFieldData_Delete_Key_Input>;
  _prepend?: InputMaybe<CustomFieldData_Prepend_Input>;
  _set?: InputMaybe<CustomFieldData_Set_Input>;
  where: CustomFieldData_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCustomFieldTypeArgs = {
  _inc?: InputMaybe<CustomFieldType_Inc_Input>;
  _set?: InputMaybe<CustomFieldType_Set_Input>;
  pk_columns: CustomFieldType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCustomFieldTypesArgs = {
  _inc?: InputMaybe<CustomFieldType_Inc_Input>;
  _set?: InputMaybe<CustomFieldType_Set_Input>;
  where: CustomFieldType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCustomFieldsArgs = {
  _inc?: InputMaybe<CustomField_Inc_Input>;
  _set?: InputMaybe<CustomField_Set_Input>;
  where: CustomField_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCustomerArgs = {
  _set?: InputMaybe<Customer_Set_Input>;
  pk_columns: Customer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCustomersArgs = {
  _set?: InputMaybe<Customer_Set_Input>;
  where: Customer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCycleArgs = {
  _set?: InputMaybe<Cycle_Set_Input>;
  pk_columns: Cycle_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCycleJournalEntriesArgs = {
  _set?: InputMaybe<CycleJournalEntry_Set_Input>;
  where: CycleJournalEntry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCycleJournalEntryArgs = {
  _set?: InputMaybe<CycleJournalEntry_Set_Input>;
  pk_columns: CycleJournalEntry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCycleTotalArgs = {
  _inc?: InputMaybe<CycleTotal_Inc_Input>;
  _set?: InputMaybe<CycleTotal_Set_Input>;
  pk_columns: CycleTotal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCycleTotalsArgs = {
  _inc?: InputMaybe<CycleTotal_Inc_Input>;
  _set?: InputMaybe<CycleTotal_Set_Input>;
  where: CycleTotal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCyclesArgs = {
  _set?: InputMaybe<Cycle_Set_Input>;
  where: Cycle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDataTypeArgs = {
  _inc?: InputMaybe<DataType_Inc_Input>;
  _set?: InputMaybe<DataType_Set_Input>;
  pk_columns: DataType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDataTypesArgs = {
  _inc?: InputMaybe<DataType_Inc_Input>;
  _set?: InputMaybe<DataType_Set_Input>;
  where: DataType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDateCalculationTypeArgs = {
  _inc?: InputMaybe<DateCalculationType_Inc_Input>;
  _set?: InputMaybe<DateCalculationType_Set_Input>;
  pk_columns: DateCalculationType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDateCalculationTypesArgs = {
  _inc?: InputMaybe<DateCalculationType_Inc_Input>;
  _set?: InputMaybe<DateCalculationType_Set_Input>;
  where: DateCalculationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDealerArgs = {
  _inc?: InputMaybe<Dealer_Inc_Input>;
  _set?: InputMaybe<Dealer_Set_Input>;
  pk_columns: Dealer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDealerPaymentTypeArgs = {
  _inc?: InputMaybe<DealerPaymentType_Inc_Input>;
  _set?: InputMaybe<DealerPaymentType_Set_Input>;
  pk_columns: DealerPaymentType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDealerPaymentTypesArgs = {
  _inc?: InputMaybe<DealerPaymentType_Inc_Input>;
  _set?: InputMaybe<DealerPaymentType_Set_Input>;
  where: DealerPaymentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDealersArgs = {
  _inc?: InputMaybe<Dealer_Inc_Input>;
  _set?: InputMaybe<Dealer_Set_Input>;
  where: Dealer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDisbursementTypeArgs = {
  _inc?: InputMaybe<DisbursementType_Inc_Input>;
  _set?: InputMaybe<DisbursementType_Set_Input>;
  pk_columns: DisbursementType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDisbursementTypesArgs = {
  _inc?: InputMaybe<DisbursementType_Inc_Input>;
  _set?: InputMaybe<DisbursementType_Set_Input>;
  where: DisbursementType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDocumentArgs = {
  _set?: InputMaybe<Document_Set_Input>;
  pk_columns: Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDocumentInstanceArgs = {
  _append?: InputMaybe<DocumentInstance_Append_Input>;
  _delete_at_path?: InputMaybe<DocumentInstance_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<DocumentInstance_Delete_Elem_Input>;
  _delete_key?: InputMaybe<DocumentInstance_Delete_Key_Input>;
  _prepend?: InputMaybe<DocumentInstance_Prepend_Input>;
  _set?: InputMaybe<DocumentInstance_Set_Input>;
  pk_columns: DocumentInstance_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDocumentInstancesArgs = {
  _append?: InputMaybe<DocumentInstance_Append_Input>;
  _delete_at_path?: InputMaybe<DocumentInstance_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<DocumentInstance_Delete_Elem_Input>;
  _delete_key?: InputMaybe<DocumentInstance_Delete_Key_Input>;
  _prepend?: InputMaybe<DocumentInstance_Prepend_Input>;
  _set?: InputMaybe<DocumentInstance_Set_Input>;
  where: DocumentInstance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDocumentTemplateArgs = {
  _set?: InputMaybe<DocumentTemplate_Set_Input>;
  pk_columns: DocumentTemplate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDocumentTemplateApplicationArgs = {
  _set?: InputMaybe<DocumentTemplateApplication_Set_Input>;
  pk_columns: DocumentTemplateApplication_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateDocumentTemplateApplicationsArgs = {
  _set?: InputMaybe<DocumentTemplateApplication_Set_Input>;
  where: DocumentTemplateApplication_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDocumentTemplatesArgs = {
  _set?: InputMaybe<DocumentTemplate_Set_Input>;
  where: DocumentTemplate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDocumentsArgs = {
  _set?: InputMaybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEligibilityRuleArgs = {
  _set?: InputMaybe<EligibilityRule_Set_Input>;
  pk_columns: EligibilityRule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEligibilityRuleDefinitionArgs = {
  _append?: InputMaybe<EligibilityRuleDefinition_Append_Input>;
  _delete_at_path?: InputMaybe<EligibilityRuleDefinition_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<EligibilityRuleDefinition_Delete_Elem_Input>;
  _delete_key?: InputMaybe<EligibilityRuleDefinition_Delete_Key_Input>;
  _inc?: InputMaybe<EligibilityRuleDefinition_Inc_Input>;
  _prepend?: InputMaybe<EligibilityRuleDefinition_Prepend_Input>;
  _set?: InputMaybe<EligibilityRuleDefinition_Set_Input>;
  pk_columns: EligibilityRuleDefinition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEligibilityRuleDefinitionsArgs = {
  _append?: InputMaybe<EligibilityRuleDefinition_Append_Input>;
  _delete_at_path?: InputMaybe<EligibilityRuleDefinition_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<EligibilityRuleDefinition_Delete_Elem_Input>;
  _delete_key?: InputMaybe<EligibilityRuleDefinition_Delete_Key_Input>;
  _inc?: InputMaybe<EligibilityRuleDefinition_Inc_Input>;
  _prepend?: InputMaybe<EligibilityRuleDefinition_Prepend_Input>;
  _set?: InputMaybe<EligibilityRuleDefinition_Set_Input>;
  where: EligibilityRuleDefinition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEligibilityRulesArgs = {
  _set?: InputMaybe<EligibilityRule_Set_Input>;
  where: EligibilityRule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEligibilityTypeArgs = {
  _inc?: InputMaybe<EligibilityType_Inc_Input>;
  _set?: InputMaybe<EligibilityType_Set_Input>;
  pk_columns: EligibilityType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEligibilityTypesArgs = {
  _inc?: InputMaybe<EligibilityType_Inc_Input>;
  _set?: InputMaybe<EligibilityType_Set_Input>;
  where: EligibilityType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityBillingInformationArgs = {
  _set?: InputMaybe<EntityBillingInformation_Set_Input>;
  pk_columns: EntityBillingInformation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityBillingInformationsArgs = {
  _set?: InputMaybe<EntityBillingInformation_Set_Input>;
  where: EntityBillingInformation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityConfigurationItemArgs = {
  _inc?: InputMaybe<EntityConfigurationItem_Inc_Input>;
  _set?: InputMaybe<EntityConfigurationItem_Set_Input>;
  pk_columns: EntityConfigurationItem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityConfigurationItemsArgs = {
  _inc?: InputMaybe<EntityConfigurationItem_Inc_Input>;
  _set?: InputMaybe<EntityConfigurationItem_Set_Input>;
  where: EntityConfigurationItem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityContentTypeArgs = {
  _set?: InputMaybe<EntityContentType_Set_Input>;
  pk_columns: EntityContentType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityContentTypesArgs = {
  _set?: InputMaybe<EntityContentType_Set_Input>;
  where: EntityContentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityCustomFieldArgs = {
  _set?: InputMaybe<EntityCustomField_Set_Input>;
  pk_columns: EntityCustomField_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityCustomFieldValueArgs = {
  _set?: InputMaybe<EntityCustomFieldValue_Set_Input>;
  pk_columns: EntityCustomFieldValue_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityCustomFieldValuesArgs = {
  _set?: InputMaybe<EntityCustomFieldValue_Set_Input>;
  where: EntityCustomFieldValue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityCustomFieldsArgs = {
  _set?: InputMaybe<EntityCustomField_Set_Input>;
  where: EntityCustomField_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityDataDefinitionArgs = {
  _inc?: InputMaybe<EntityDataDefinition_Inc_Input>;
  _set?: InputMaybe<EntityDataDefinition_Set_Input>;
  pk_columns: EntityDataDefinition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityDataDefinitionsArgs = {
  _inc?: InputMaybe<EntityDataDefinition_Inc_Input>;
  _set?: InputMaybe<EntityDataDefinition_Set_Input>;
  where: EntityDataDefinition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityEligibilityRuleArgs = {
  _set?: InputMaybe<EntityEligibilityRule_Set_Input>;
  pk_columns: EntityEligibilityRule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityEligibilityRulesArgs = {
  _set?: InputMaybe<EntityEligibilityRule_Set_Input>;
  where: EntityEligibilityRule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityFeatureArgs = {
  _set?: InputMaybe<EntityFeature_Set_Input>;
  pk_columns: EntityFeature_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityFeaturesArgs = {
  _set?: InputMaybe<EntityFeature_Set_Input>;
  where: EntityFeature_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityFileContentTypeArgs = {
  _set?: InputMaybe<EntityFileContentType_Set_Input>;
  pk_columns: EntityFileContentType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityFileContentTypesArgs = {
  _set?: InputMaybe<EntityFileContentType_Set_Input>;
  where: EntityFileContentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityFileStorageArgs = {
  _set?: InputMaybe<EntityFileStorage_Set_Input>;
  pk_columns: EntityFileStorage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityFileStoragesArgs = {
  _set?: InputMaybe<EntityFileStorage_Set_Input>;
  where: EntityFileStorage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityNoteArgs = {
  _append?: InputMaybe<EntityNote_Append_Input>;
  _delete_at_path?: InputMaybe<EntityNote_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<EntityNote_Delete_Elem_Input>;
  _delete_key?: InputMaybe<EntityNote_Delete_Key_Input>;
  _prepend?: InputMaybe<EntityNote_Prepend_Input>;
  _set?: InputMaybe<EntityNote_Set_Input>;
  pk_columns: EntityNote_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityNotesArgs = {
  _append?: InputMaybe<EntityNote_Append_Input>;
  _delete_at_path?: InputMaybe<EntityNote_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<EntityNote_Delete_Elem_Input>;
  _delete_key?: InputMaybe<EntityNote_Delete_Key_Input>;
  _prepend?: InputMaybe<EntityNote_Prepend_Input>;
  _set?: InputMaybe<EntityNote_Set_Input>;
  where: EntityNote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityOfferingArgs = {
  _set?: InputMaybe<EntityOffering_Set_Input>;
  pk_columns: EntityOffering_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityOfferingsArgs = {
  _set?: InputMaybe<EntityOffering_Set_Input>;
  where: EntityOffering_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityRemittanceDetailArgs = {
  _inc?: InputMaybe<EntityRemittanceDetail_Inc_Input>;
  _set?: InputMaybe<EntityRemittanceDetail_Set_Input>;
  pk_columns: EntityRemittanceDetail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityRemittanceDetailsArgs = {
  _inc?: InputMaybe<EntityRemittanceDetail_Inc_Input>;
  _set?: InputMaybe<EntityRemittanceDetail_Set_Input>;
  where: EntityRemittanceDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEntityTagArgs = {
  _set?: InputMaybe<EntityTag_Set_Input>;
  pk_columns: EntityTag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateEntityTagsArgs = {
  _set?: InputMaybe<EntityTag_Set_Input>;
  where: EntityTag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFeatureArgs = {
  _append?: InputMaybe<Feature_Append_Input>;
  _delete_at_path?: InputMaybe<Feature_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Feature_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Feature_Delete_Key_Input>;
  _prepend?: InputMaybe<Feature_Prepend_Input>;
  _set?: InputMaybe<Feature_Set_Input>;
  pk_columns: Feature_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFeaturesArgs = {
  _append?: InputMaybe<Feature_Append_Input>;
  _delete_at_path?: InputMaybe<Feature_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Feature_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Feature_Delete_Key_Input>;
  _prepend?: InputMaybe<Feature_Prepend_Input>;
  _set?: InputMaybe<Feature_Set_Input>;
  where: Feature_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileStorageArgs = {
  _append?: InputMaybe<FileStorage_Append_Input>;
  _delete_at_path?: InputMaybe<FileStorage_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<FileStorage_Delete_Elem_Input>;
  _delete_key?: InputMaybe<FileStorage_Delete_Key_Input>;
  _prepend?: InputMaybe<FileStorage_Prepend_Input>;
  _set?: InputMaybe<FileStorage_Set_Input>;
  pk_columns: FileStorage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFileStorageTypeArgs = {
  _inc?: InputMaybe<FileStorageType_Inc_Input>;
  _set?: InputMaybe<FileStorageType_Set_Input>;
  pk_columns: FileStorageType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFileStorageTypesArgs = {
  _inc?: InputMaybe<FileStorageType_Inc_Input>;
  _set?: InputMaybe<FileStorageType_Set_Input>;
  where: FileStorageType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileStoragesArgs = {
  _append?: InputMaybe<FileStorage_Append_Input>;
  _delete_at_path?: InputMaybe<FileStorage_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<FileStorage_Delete_Elem_Input>;
  _delete_key?: InputMaybe<FileStorage_Delete_Key_Input>;
  _prepend?: InputMaybe<FileStorage_Prepend_Input>;
  _set?: InputMaybe<FileStorage_Set_Input>;
  where: FileStorage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFilingLenderArgs = {
  _append?: InputMaybe<FilingLender_Append_Input>;
  _delete_at_path?: InputMaybe<FilingLender_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<FilingLender_Delete_Elem_Input>;
  _delete_key?: InputMaybe<FilingLender_Delete_Key_Input>;
  _prepend?: InputMaybe<FilingLender_Prepend_Input>;
  _set?: InputMaybe<FilingLender_Set_Input>;
  pk_columns: FilingLender_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilingLenderMatchArgs = {
  _set?: InputMaybe<FilingLenderMatch_Set_Input>;
  pk_columns: FilingLenderMatch_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilingLenderMatchesArgs = {
  _set?: InputMaybe<FilingLenderMatch_Set_Input>;
  where: FilingLenderMatch_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFilingLendersArgs = {
  _append?: InputMaybe<FilingLender_Append_Input>;
  _delete_at_path?: InputMaybe<FilingLender_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<FilingLender_Delete_Elem_Input>;
  _delete_key?: InputMaybe<FilingLender_Delete_Key_Input>;
  _prepend?: InputMaybe<FilingLender_Prepend_Input>;
  _set?: InputMaybe<FilingLender_Set_Input>;
  where: FilingLender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFilingStateArgs = {
  _set?: InputMaybe<FilingState_Set_Input>;
  pk_columns: FilingState_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilingStatesArgs = {
  _set?: InputMaybe<FilingState_Set_Input>;
  where: FilingState_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFilingStatusTypeArgs = {
  _inc?: InputMaybe<FilingStatusType_Inc_Input>;
  _set?: InputMaybe<FilingStatusType_Set_Input>;
  pk_columns: FilingStatusType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilingStatusTypesArgs = {
  _inc?: InputMaybe<FilingStatusType_Inc_Input>;
  _set?: InputMaybe<FilingStatusType_Set_Input>;
  where: FilingStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFlowItemArgs = {
  _inc?: InputMaybe<FlowItem_Inc_Input>;
  _set?: InputMaybe<FlowItem_Set_Input>;
  pk_columns: FlowItem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFlowItemTypeArgs = {
  _inc?: InputMaybe<FlowItemType_Inc_Input>;
  _set?: InputMaybe<FlowItemType_Set_Input>;
  pk_columns: FlowItemType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFlowItemTypesArgs = {
  _inc?: InputMaybe<FlowItemType_Inc_Input>;
  _set?: InputMaybe<FlowItemType_Set_Input>;
  where: FlowItemType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFlowItemsArgs = {
  _inc?: InputMaybe<FlowItem_Inc_Input>;
  _set?: InputMaybe<FlowItem_Set_Input>;
  where: FlowItem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFlowTypeArgs = {
  _inc?: InputMaybe<FlowType_Inc_Input>;
  _set?: InputMaybe<FlowType_Set_Input>;
  pk_columns: FlowType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFlowTypesArgs = {
  _inc?: InputMaybe<FlowType_Inc_Input>;
  _set?: InputMaybe<FlowType_Set_Input>;
  where: FlowType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateIdentitiesArgs = {
  _set?: InputMaybe<Identity_Set_Input>;
  where: Identity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateIdentitiesManyArgs = {
  updates: Array<Identity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateIdentityArgs = {
  _set?: InputMaybe<Identity_Set_Input>;
  pk_columns: Identity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateIdentityAs400Args = {
  _set?: InputMaybe<IdentityAs400_Set_Input>;
  pk_columns: IdentityAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateIdentityAs400sArgs = {
  _set?: InputMaybe<IdentityAs400_Set_Input>;
  where: IdentityAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateIdentityCapabilitiesArgs = {
  _set?: InputMaybe<IdentityCapability_Set_Input>;
  where: IdentityCapability_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateIdentityCapabilityArgs = {
  _set?: InputMaybe<IdentityCapability_Set_Input>;
  pk_columns: IdentityCapability_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateIdentityEntitiesArgs = {
  _set?: InputMaybe<IdentityEntity_Set_Input>;
  where: IdentityEntity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateIdentityEntityArgs = {
  _set?: InputMaybe<IdentityEntity_Set_Input>;
  pk_columns: IdentityEntity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateIdentityFilterArgs = {
  _set?: InputMaybe<IdentityFilter_Set_Input>;
  pk_columns: IdentityFilter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateIdentityFiltersArgs = {
  _set?: InputMaybe<IdentityFilter_Set_Input>;
  where: IdentityFilter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceArgs = {
  _set?: InputMaybe<Invoice_Set_Input>;
  pk_columns: Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceDocumentTypeArgs = {
  _inc?: InputMaybe<InvoiceDocumentType_Inc_Input>;
  _set?: InputMaybe<InvoiceDocumentType_Set_Input>;
  pk_columns: InvoiceDocumentType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceDocumentTypesArgs = {
  _inc?: InputMaybe<InvoiceDocumentType_Inc_Input>;
  _set?: InputMaybe<InvoiceDocumentType_Set_Input>;
  where: InvoiceDocumentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateInvoicePaymentTypeArgs = {
  _inc?: InputMaybe<InvoicePaymentType_Inc_Input>;
  _set?: InputMaybe<InvoicePaymentType_Set_Input>;
  pk_columns: InvoicePaymentType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateInvoicePaymentTypesArgs = {
  _inc?: InputMaybe<InvoicePaymentType_Inc_Input>;
  _set?: InputMaybe<InvoicePaymentType_Set_Input>;
  where: InvoicePaymentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateInvoicesArgs = {
  _set?: InputMaybe<Invoice_Set_Input>;
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateJobArgs = {
  _set?: InputMaybe<Job_Set_Input>;
  pk_columns: Job_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateJobHistoriesArgs = {
  _set?: InputMaybe<JobHistory_Set_Input>;
  where: JobHistory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateJobHistoryArgs = {
  _set?: InputMaybe<JobHistory_Set_Input>;
  pk_columns: JobHistory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateJobHistoryLogArgs = {
  _append?: InputMaybe<JobHistoryLog_Append_Input>;
  _delete_at_path?: InputMaybe<JobHistoryLog_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<JobHistoryLog_Delete_Elem_Input>;
  _delete_key?: InputMaybe<JobHistoryLog_Delete_Key_Input>;
  _prepend?: InputMaybe<JobHistoryLog_Prepend_Input>;
  _set?: InputMaybe<JobHistoryLog_Set_Input>;
  pk_columns: JobHistoryLog_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateJobHistoryLogsArgs = {
  _append?: InputMaybe<JobHistoryLog_Append_Input>;
  _delete_at_path?: InputMaybe<JobHistoryLog_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<JobHistoryLog_Delete_Elem_Input>;
  _delete_key?: InputMaybe<JobHistoryLog_Delete_Key_Input>;
  _prepend?: InputMaybe<JobHistoryLog_Prepend_Input>;
  _set?: InputMaybe<JobHistoryLog_Set_Input>;
  where: JobHistoryLog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateJobScheduleArgs = {
  _append?: InputMaybe<JobSchedule_Append_Input>;
  _delete_at_path?: InputMaybe<JobSchedule_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<JobSchedule_Delete_Elem_Input>;
  _delete_key?: InputMaybe<JobSchedule_Delete_Key_Input>;
  _prepend?: InputMaybe<JobSchedule_Prepend_Input>;
  _set?: InputMaybe<JobSchedule_Set_Input>;
  pk_columns: JobSchedule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateJobSchedulesArgs = {
  _append?: InputMaybe<JobSchedule_Append_Input>;
  _delete_at_path?: InputMaybe<JobSchedule_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<JobSchedule_Delete_Elem_Input>;
  _delete_key?: InputMaybe<JobSchedule_Delete_Key_Input>;
  _prepend?: InputMaybe<JobSchedule_Prepend_Input>;
  _set?: InputMaybe<JobSchedule_Set_Input>;
  where: JobSchedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateJobStepArgs = {
  _set?: InputMaybe<JobStep_Set_Input>;
  pk_columns: JobStep_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateJobStepsArgs = {
  _set?: InputMaybe<JobStep_Set_Input>;
  where: JobStep_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateJobsArgs = {
  _set?: InputMaybe<Job_Set_Input>;
  where: Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateJournalEntriesArgs = {
  _inc?: InputMaybe<JournalEntry_Inc_Input>;
  _set?: InputMaybe<JournalEntry_Set_Input>;
  where: JournalEntry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateJournalEntryArgs = {
  _inc?: InputMaybe<JournalEntry_Inc_Input>;
  _set?: InputMaybe<JournalEntry_Set_Input>;
  pk_columns: JournalEntry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateJournalEntryLineArgs = {
  _inc?: InputMaybe<JournalEntryLine_Inc_Input>;
  _set?: InputMaybe<JournalEntryLine_Set_Input>;
  pk_columns: JournalEntryLine_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateJournalEntryLinesArgs = {
  _inc?: InputMaybe<JournalEntryLine_Inc_Input>;
  _set?: InputMaybe<JournalEntryLine_Set_Input>;
  where: JournalEntryLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateLaborGuideTypeArgs = {
  _inc?: InputMaybe<LaborGuideType_Inc_Input>;
  _set?: InputMaybe<LaborGuideType_Set_Input>;
  pk_columns: LaborGuideType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateLaborGuideTypesArgs = {
  _inc?: InputMaybe<LaborGuideType_Inc_Input>;
  _set?: InputMaybe<LaborGuideType_Set_Input>;
  where: LaborGuideType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateLaborRateArgs = {
  _inc?: InputMaybe<LaborRate_Inc_Input>;
  _set?: InputMaybe<LaborRate_Set_Input>;
  pk_columns: LaborRate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateLaborRateAs400Args = {
  _set?: InputMaybe<LaborRateAs400_Set_Input>;
  pk_columns: LaborRateAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateLaborRateAs400sArgs = {
  _set?: InputMaybe<LaborRateAs400_Set_Input>;
  where: LaborRateAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateLaborRatesArgs = {
  _inc?: InputMaybe<LaborRate_Inc_Input>;
  _set?: InputMaybe<LaborRate_Set_Input>;
  where: LaborRate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateLegacyPolicyContractArgs = {
  _append?: InputMaybe<LegacyPolicyContract_Append_Input>;
  _delete_at_path?: InputMaybe<LegacyPolicyContract_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<LegacyPolicyContract_Delete_Elem_Input>;
  _delete_key?: InputMaybe<LegacyPolicyContract_Delete_Key_Input>;
  _inc?: InputMaybe<LegacyPolicyContract_Inc_Input>;
  _prepend?: InputMaybe<LegacyPolicyContract_Prepend_Input>;
  _set?: InputMaybe<LegacyPolicyContract_Set_Input>;
  pk_columns: LegacyPolicyContract_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateLegacyPolicyContractsArgs = {
  _append?: InputMaybe<LegacyPolicyContract_Append_Input>;
  _delete_at_path?: InputMaybe<LegacyPolicyContract_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<LegacyPolicyContract_Delete_Elem_Input>;
  _delete_key?: InputMaybe<LegacyPolicyContract_Delete_Key_Input>;
  _inc?: InputMaybe<LegacyPolicyContract_Inc_Input>;
  _prepend?: InputMaybe<LegacyPolicyContract_Prepend_Input>;
  _set?: InputMaybe<LegacyPolicyContract_Set_Input>;
  where: LegacyPolicyContract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateLoggedActionsArgs = {
  _append?: InputMaybe<LoggedAction_Append_Input>;
  _delete_at_path?: InputMaybe<LoggedAction_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<LoggedAction_Delete_Elem_Input>;
  _delete_key?: InputMaybe<LoggedAction_Delete_Key_Input>;
  _inc?: InputMaybe<LoggedAction_Inc_Input>;
  _prepend?: InputMaybe<LoggedAction_Prepend_Input>;
  _set?: InputMaybe<LoggedAction_Set_Input>;
  where: LoggedAction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateLossRatioArgs = {
  _inc?: InputMaybe<LossRatio_Inc_Input>;
  _set?: InputMaybe<LossRatio_Set_Input>;
  pk_columns: LossRatio_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateLossRatiosArgs = {
  _inc?: InputMaybe<LossRatio_Inc_Input>;
  _set?: InputMaybe<LossRatio_Set_Input>;
  where: LossRatio_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateManuEntityFeaturesArgs = {
  updates: Array<EntityFeature_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyAccountObligorsArgs = {
  updates: Array<AccountObligor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyAlertAcknowledgmentsArgs = {
  updates: Array<AlertAcknowledgment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyAlertsArgs = {
  updates: Array<Alert_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyApplicationPreferencesArgs = {
  updates: Array<ApplicationPreference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyApplicationsArgs = {
  updates: Array<Application_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyBankAccountTypesArgs = {
  updates: Array<BankAccountType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyCancelRuleFeesArgs = {
  updates: Array<CancelRuleFee_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyCancelRuleRefundsArgs = {
  updates: Array<CancelRuleRefund_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyCancelRulesArgs = {
  updates: Array<CancelRule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyCancellationAs400sArgs = {
  updates: Array<CancellationAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyCardLayoutsArgs = {
  updates: Array<CardLayout_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyClaimDetailAs400sArgs = {
  updates: Array<ClaimDetailAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyClaimDetailDeductionAs400sArgs = {
  updates: Array<ClaimDetailDeductionAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyClaimDetailPartLookupsArgs = {
  updates: Array<ClaimDetailPartLookup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyClaimDetailsArgs = {
  updates: Array<ClaimDetail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyClaimServiceCenterAs400sArgs = {
  updates: Array<ClaimServiceCenterAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyClaimServiceCenterAuthorizationsArgs = {
  updates: Array<ClaimServiceCenterAuthorization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyClaimServiceCentersArgs = {
  updates: Array<ClaimServiceCenter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyCompositeProductsArgs = {
  updates: Array<CompositeProduct_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyContentTypesArgs = {
  updates: Array<ContentType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyContractFormFilingStatusesArgs = {
  updates: Array<ContractFormFilingStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyContractFormVersionLegacyFilesArgs = {
  updates: Array<ContractFormVersionLegacyFile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyContractFormVersionsArgs = {
  updates: Array<ContractFormVersion_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyContractFormsArgs = {
  updates: Array<ContractForm_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyCycleJournalEntriesArgs = {
  updates: Array<CycleJournalEntry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyCycleTotalsArgs = {
  updates: Array<CycleTotal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyCyclesArgs = {
  updates: Array<Cycle_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyDateCalculationTypesArgs = {
  updates: Array<DateCalculationType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyDocumentInstancesArgs = {
  updates: Array<DocumentInstance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyDocumentTemplateApplicationsArgs = {
  updates: Array<DocumentTemplateApplication_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyDocumentTemplatesArgs = {
  updates: Array<DocumentTemplate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyEntityContentTypesArgs = {
  updates: Array<EntityContentType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyEntityFileContentTypesArgs = {
  updates: Array<EntityFileContentType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyFeaturesArgs = {
  updates: Array<Feature_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyFilingLenderMatchesArgs = {
  updates: Array<FilingLenderMatch_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyFilingLendersArgs = {
  updates: Array<FilingLender_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyFilingStatesArgs = {
  updates: Array<FilingState_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyFilingStatusTypesArgs = {
  updates: Array<FilingStatusType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyFlowItemTypesArgs = {
  updates: Array<FlowItemType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyFlowItemsArgs = {
  updates: Array<FlowItem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyFlowTypesArgs = {
  updates: Array<FlowType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyIdentityAs400sArgs = {
  updates: Array<IdentityAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyIdentityFiltersArgs = {
  updates: Array<IdentityFilter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyJobHistoriesArgs = {
  updates: Array<JobHistory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyJobHistoryLogsArgs = {
  updates: Array<JobHistoryLog_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyJobScheduleArgs = {
  updates: Array<JobSchedule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyJobStepsArgs = {
  updates: Array<JobStep_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyJobsArgs = {
  updates: Array<Job_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyJournalEntriesArgs = {
  updates: Array<JournalEntry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyJournalEntryLinesArgs = {
  updates: Array<JournalEntryLine_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyLaborRateAs400sArgs = {
  updates: Array<LaborRateAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyLaborRatesArgs = {
  updates: Array<LaborRate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyLegacyPolicyContractsArgs = {
  updates: Array<LegacyPolicyContract_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyLossRatiosArgs = {
  updates: Array<LossRatio_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyMilesCalculationTypesArgs = {
  updates: Array<MilesCalculationType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyOutboxEventsArgs = {
  updates: Array<OutboxEvent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyParticipantsArgs = {
  updates: Array<Participant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPayeeAs400sArgs = {
  updates: Array<PayeeAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPaymentAs400sArgs = {
  updates: Array<PaymentAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPaymentMethodTypesArgs = {
  updates: Array<PaymentMethodType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPaymentTypesArgs = {
  updates: Array<PaymentType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPoliciesArgs = {
  updates: Array<Policy_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyClaimAs400sArgs = {
  updates: Array<PolicyClaimAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyClaimInsurancesArgs = {
  updates: Array<PolicyClaimInsurance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyClaimsArgs = {
  updates: Array<PolicyClaim_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractAssetTypesArgs = {
  updates: Array<PolicyContractAssetType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractAssetsArgs = {
  updates: Array<PolicyContractAsset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractCostDetailsArgs = {
  updates: Array<PolicyContractCostDetail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractLendersArgs = {
  updates: Array<PolicyContractLender_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractLoanContractTypesArgs = {
  updates: Array<PolicyContractLoanContractType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractOwnersArgs = {
  updates: Array<PolicyContractOwner_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractProductCostDetailsArgs = {
  updates: Array<PolicyContractProductCostDetail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractProductsArgs = {
  updates: Array<PolicyContractProduct_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractQuotesArgs = {
  updates: Array<PolicyContractQuote_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractStatusTypesArgs = {
  updates: Array<PolicyContractStatusType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractVoidReasonTypesArgs = {
  updates: Array<PolicyContractVoidReasonType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPolicyContractsArgs = {
  updates: Array<PolicyContract_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPreAuthorizationStatusTypesArgs = {
  updates: Array<PreAuthorizationStatusType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPreAuthorizationTypesArgs = {
  updates: Array<PreAuthorizationType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyPreAuthorizationsArgs = {
  updates: Array<PreAuthorization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyProductContractFormsArgs = {
  updates: Array<ProductContractForm_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyProfilesArgs = {
  updates: Array<Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyQuoteTypesArgs = {
  updates: Array<QuoteType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyQuotesArgs = {
  updates: Array<Quote_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyRaterViewConfigsArgs = {
  updates: Array<RaterViewConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyReferenceLogArgs = {
  updates: Array<ReferenceLog_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyRemittanceClaimDetailsArgs = {
  updates: Array<RemittanceClaimDetail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyRemittancePolicyContractAs400sArgs = {
  updates: Array<RemittancePolicyContractAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyRemittancePolicyContractsArgs = {
  updates: Array<RemittancePolicyContract_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyRemittanceStatusTypesArgs = {
  updates: Array<RemittanceStatusType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyRemittancesArgs = {
  updates: Array<Remittance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyRepeatPartAcknowledgmentsArgs = {
  updates: Array<RepeatPartAcknowledgment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyServiceCentersArgs = {
  updates: Array<ServiceCenter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManySeverityLevelTypeArgs = {
  updates: Array<SeverityLevelType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyShortcutBindingsArgs = {
  updates: Array<ShortcutBinding_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyStepTypesArgs = {
  updates: Array<StepType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyStepsArgs = {
  updates: Array<Step_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyTaxRateAs400sArgs = {
  updates: Array<TaxRateAs400_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyTaxRatesArgs = {
  updates: Array<TaxRate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyTechnologyTypesArgs = {
  updates: Array<TechnologyType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyTypeGroupsArgs = {
  updates: Array<TypeGroup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyTypesArgs = {
  updates: Array<Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyUserFlowItemMfasArgs = {
  updates: Array<UserFlowItemMfa_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyUserFlowItemsArgs = {
  updates: Array<UserFlowItem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyUsersArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyValidationTypeOperationArgs = {
  updates: Array<ValidationTypeOperation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyVehicleStatusTypesArgs = {
  updates: Array<VehicleStatusType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateManyVpicDecodeAlternativesArgs = {
  updates: Array<VpicDecodeAlternative_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateMilesCalculationTypeArgs = {
  _inc?: InputMaybe<MilesCalculationType_Inc_Input>;
  _set?: InputMaybe<MilesCalculationType_Set_Input>;
  pk_columns: MilesCalculationType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateMilesCalculationTypesArgs = {
  _inc?: InputMaybe<MilesCalculationType_Inc_Input>;
  _set?: InputMaybe<MilesCalculationType_Set_Input>;
  where: MilesCalculationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateObligorArgs = {
  _set?: InputMaybe<Obligor_Set_Input>;
  pk_columns: Obligor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateObligorsArgs = {
  _set?: InputMaybe<Obligor_Set_Input>;
  where: Obligor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateObsoleteJobArgs = {
  _inc?: InputMaybe<ObsoleteJob_Inc_Input>;
  _set?: InputMaybe<ObsoleteJob_Set_Input>;
  pk_columns: ObsoleteJob_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateObsoleteJobsArgs = {
  _inc?: InputMaybe<ObsoleteJob_Inc_Input>;
  _set?: InputMaybe<ObsoleteJob_Set_Input>;
  where: ObsoleteJob_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateOutboxEventArgs = {
  _append?: InputMaybe<OutboxEvent_Append_Input>;
  _delete_at_path?: InputMaybe<OutboxEvent_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<OutboxEvent_Delete_Elem_Input>;
  _delete_key?: InputMaybe<OutboxEvent_Delete_Key_Input>;
  _inc?: InputMaybe<OutboxEvent_Inc_Input>;
  _prepend?: InputMaybe<OutboxEvent_Prepend_Input>;
  _set?: InputMaybe<OutboxEvent_Set_Input>;
  pk_columns: OutboxEvent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateOutboxEventsArgs = {
  _append?: InputMaybe<OutboxEvent_Append_Input>;
  _delete_at_path?: InputMaybe<OutboxEvent_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<OutboxEvent_Delete_Elem_Input>;
  _delete_key?: InputMaybe<OutboxEvent_Delete_Key_Input>;
  _inc?: InputMaybe<OutboxEvent_Inc_Input>;
  _prepend?: InputMaybe<OutboxEvent_Prepend_Input>;
  _set?: InputMaybe<OutboxEvent_Set_Input>;
  where: OutboxEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateParticipantArgs = {
  _set?: InputMaybe<Participant_Set_Input>;
  pk_columns: Participant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateParticipantsArgs = {
  _set?: InputMaybe<Participant_Set_Input>;
  where: Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePayeeArgs = {
  _set?: InputMaybe<Payee_Set_Input>;
  pk_columns: Payee_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePayeeAs400Args = {
  _set?: InputMaybe<PayeeAs400_Set_Input>;
  pk_columns: PayeeAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePayeeAs400sArgs = {
  _set?: InputMaybe<PayeeAs400_Set_Input>;
  where: PayeeAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePayeesArgs = {
  _set?: InputMaybe<Payee_Set_Input>;
  where: Payee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentArgs = {
  _append?: InputMaybe<Payment_Append_Input>;
  _delete_at_path?: InputMaybe<Payment_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Payment_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Payment_Delete_Key_Input>;
  _inc?: InputMaybe<Payment_Inc_Input>;
  _prepend?: InputMaybe<Payment_Prepend_Input>;
  _set?: InputMaybe<Payment_Set_Input>;
  pk_columns: Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePaymentAs400Args = {
  _set?: InputMaybe<PaymentAs400_Set_Input>;
  pk_columns: PaymentAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePaymentAs400sArgs = {
  _set?: InputMaybe<PaymentAs400_Set_Input>;
  where: PaymentAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentDetailArgs = {
  _inc?: InputMaybe<PaymentDetail_Inc_Input>;
  _set?: InputMaybe<PaymentDetail_Set_Input>;
  pk_columns: PaymentDetail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePaymentDetailsArgs = {
  _inc?: InputMaybe<PaymentDetail_Inc_Input>;
  _set?: InputMaybe<PaymentDetail_Set_Input>;
  where: PaymentDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodTypeArgs = {
  _inc?: InputMaybe<PaymentMethodType_Inc_Input>;
  _set?: InputMaybe<PaymentMethodType_Set_Input>;
  pk_columns: PaymentMethodType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodTypesArgs = {
  _inc?: InputMaybe<PaymentMethodType_Inc_Input>;
  _set?: InputMaybe<PaymentMethodType_Set_Input>;
  where: PaymentMethodType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusTypeArgs = {
  _inc?: InputMaybe<PaymentStatusType_Inc_Input>;
  _set?: InputMaybe<PaymentStatusType_Set_Input>;
  pk_columns: PaymentStatusType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusTypesArgs = {
  _inc?: InputMaybe<PaymentStatusType_Inc_Input>;
  _set?: InputMaybe<PaymentStatusType_Set_Input>;
  where: PaymentStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentTypeArgs = {
  _inc?: InputMaybe<PaymentType_Inc_Input>;
  _set?: InputMaybe<PaymentType_Set_Input>;
  pk_columns: PaymentType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePaymentTypesArgs = {
  _inc?: InputMaybe<PaymentType_Inc_Input>;
  _set?: InputMaybe<PaymentType_Set_Input>;
  where: PaymentType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentsArgs = {
  _append?: InputMaybe<Payment_Append_Input>;
  _delete_at_path?: InputMaybe<Payment_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Payment_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Payment_Delete_Key_Input>;
  _inc?: InputMaybe<Payment_Inc_Input>;
  _prepend?: InputMaybe<Payment_Prepend_Input>;
  _set?: InputMaybe<Payment_Set_Input>;
  where: Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePlanArgs = {
  _inc?: InputMaybe<Plan_Inc_Input>;
  _set?: InputMaybe<Plan_Set_Input>;
  pk_columns: Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePlansArgs = {
  _inc?: InputMaybe<Plan_Inc_Input>;
  _set?: InputMaybe<Plan_Set_Input>;
  where: Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePoliciesArgs = {
  _set?: InputMaybe<Policy_Set_Input>;
  where: Policy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyArgs = {
  _set?: InputMaybe<Policy_Set_Input>;
  pk_columns: Policy_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyClaimArgs = {
  _append?: InputMaybe<PolicyClaim_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyClaim_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyClaim_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyClaim_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyClaim_Inc_Input>;
  _prepend?: InputMaybe<PolicyClaim_Prepend_Input>;
  _set?: InputMaybe<PolicyClaim_Set_Input>;
  pk_columns: PolicyClaim_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyClaimAs400Args = {
  _set?: InputMaybe<PolicyClaimAs400_Set_Input>;
  pk_columns: PolicyClaimAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyClaimAs400sArgs = {
  _set?: InputMaybe<PolicyClaimAs400_Set_Input>;
  where: PolicyClaimAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyClaimConcernArgs = {
  _set?: InputMaybe<PolicyClaimConcern_Set_Input>;
  pk_columns: PolicyClaimConcern_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyClaimConcernsArgs = {
  _set?: InputMaybe<PolicyClaimConcern_Set_Input>;
  where: PolicyClaimConcern_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyClaimInsuranceArgs = {
  _append?: InputMaybe<PolicyClaimInsurance_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyClaimInsurance_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyClaimInsurance_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyClaimInsurance_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyClaimInsurance_Inc_Input>;
  _prepend?: InputMaybe<PolicyClaimInsurance_Prepend_Input>;
  _set?: InputMaybe<PolicyClaimInsurance_Set_Input>;
  pk_columns: PolicyClaimInsurance_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyClaimInsurancesArgs = {
  _append?: InputMaybe<PolicyClaimInsurance_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyClaimInsurance_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyClaimInsurance_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyClaimInsurance_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyClaimInsurance_Inc_Input>;
  _prepend?: InputMaybe<PolicyClaimInsurance_Prepend_Input>;
  _set?: InputMaybe<PolicyClaimInsurance_Set_Input>;
  where: PolicyClaimInsurance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyClaimsArgs = {
  _append?: InputMaybe<PolicyClaim_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyClaim_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyClaim_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyClaim_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyClaim_Inc_Input>;
  _prepend?: InputMaybe<PolicyClaim_Prepend_Input>;
  _set?: InputMaybe<PolicyClaim_Set_Input>;
  where: PolicyClaim_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractArgs = {
  _append?: InputMaybe<PolicyContract_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContract_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContract_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContract_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyContract_Inc_Input>;
  _prepend?: InputMaybe<PolicyContract_Prepend_Input>;
  _set?: InputMaybe<PolicyContract_Set_Input>;
  pk_columns: PolicyContract_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractAssetArgs = {
  _append?: InputMaybe<PolicyContractAsset_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContractAsset_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContractAsset_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContractAsset_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyContractAsset_Inc_Input>;
  _prepend?: InputMaybe<PolicyContractAsset_Prepend_Input>;
  _set?: InputMaybe<PolicyContractAsset_Set_Input>;
  pk_columns: PolicyContractAsset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractAssetTypeArgs = {
  _inc?: InputMaybe<PolicyContractAssetType_Inc_Input>;
  _set?: InputMaybe<PolicyContractAssetType_Set_Input>;
  pk_columns: PolicyContractAssetType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractAssetTypesArgs = {
  _inc?: InputMaybe<PolicyContractAssetType_Inc_Input>;
  _set?: InputMaybe<PolicyContractAssetType_Set_Input>;
  where: PolicyContractAssetType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractAssetsArgs = {
  _append?: InputMaybe<PolicyContractAsset_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContractAsset_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContractAsset_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContractAsset_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyContractAsset_Inc_Input>;
  _prepend?: InputMaybe<PolicyContractAsset_Prepend_Input>;
  _set?: InputMaybe<PolicyContractAsset_Set_Input>;
  where: PolicyContractAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractContractFormVersionArgs = {
  _set?: InputMaybe<PolicyContractContractFormVersion_Set_Input>;
  pk_columns: PolicyContractContractFormVersion_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractContractFormVersionsArgs = {
  _set?: InputMaybe<PolicyContractContractFormVersion_Set_Input>;
  where: PolicyContractContractFormVersion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractCostDetailArgs = {
  _append?: InputMaybe<PolicyContractCostDetail_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContractCostDetail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContractCostDetail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContractCostDetail_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyContractCostDetail_Inc_Input>;
  _prepend?: InputMaybe<PolicyContractCostDetail_Prepend_Input>;
  _set?: InputMaybe<PolicyContractCostDetail_Set_Input>;
  pk_columns: PolicyContractCostDetail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractCostDetailsArgs = {
  _append?: InputMaybe<PolicyContractCostDetail_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContractCostDetail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContractCostDetail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContractCostDetail_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyContractCostDetail_Inc_Input>;
  _prepend?: InputMaybe<PolicyContractCostDetail_Prepend_Input>;
  _set?: InputMaybe<PolicyContractCostDetail_Set_Input>;
  where: PolicyContractCostDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractLenderArgs = {
  _inc?: InputMaybe<PolicyContractLender_Inc_Input>;
  _set?: InputMaybe<PolicyContractLender_Set_Input>;
  pk_columns: PolicyContractLender_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractLendersArgs = {
  _inc?: InputMaybe<PolicyContractLender_Inc_Input>;
  _set?: InputMaybe<PolicyContractLender_Set_Input>;
  where: PolicyContractLender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractLoanContractTypeArgs = {
  _inc?: InputMaybe<PolicyContractLoanContractType_Inc_Input>;
  _set?: InputMaybe<PolicyContractLoanContractType_Set_Input>;
  pk_columns: PolicyContractLoanContractType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractLoanContractTypesArgs = {
  _inc?: InputMaybe<PolicyContractLoanContractType_Inc_Input>;
  _set?: InputMaybe<PolicyContractLoanContractType_Set_Input>;
  where: PolicyContractLoanContractType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractOwnerArgs = {
  _set?: InputMaybe<PolicyContractOwner_Set_Input>;
  pk_columns: PolicyContractOwner_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractOwnersArgs = {
  _set?: InputMaybe<PolicyContractOwner_Set_Input>;
  where: PolicyContractOwner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractProductArgs = {
  _append?: InputMaybe<PolicyContractProduct_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContractProduct_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContractProduct_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContractProduct_Delete_Key_Input>;
  _prepend?: InputMaybe<PolicyContractProduct_Prepend_Input>;
  _set?: InputMaybe<PolicyContractProduct_Set_Input>;
  pk_columns: PolicyContractProduct_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractProductCostDetailArgs = {
  _append?: InputMaybe<PolicyContractProductCostDetail_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContractProductCostDetail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContractProductCostDetail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContractProductCostDetail_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyContractProductCostDetail_Inc_Input>;
  _prepend?: InputMaybe<PolicyContractProductCostDetail_Prepend_Input>;
  _set?: InputMaybe<PolicyContractProductCostDetail_Set_Input>;
  pk_columns: PolicyContractProductCostDetail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractProductCostDetailsArgs = {
  _append?: InputMaybe<PolicyContractProductCostDetail_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContractProductCostDetail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContractProductCostDetail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContractProductCostDetail_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyContractProductCostDetail_Inc_Input>;
  _prepend?: InputMaybe<PolicyContractProductCostDetail_Prepend_Input>;
  _set?: InputMaybe<PolicyContractProductCostDetail_Set_Input>;
  where: PolicyContractProductCostDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractProductsArgs = {
  _append?: InputMaybe<PolicyContractProduct_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContractProduct_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContractProduct_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContractProduct_Delete_Key_Input>;
  _prepend?: InputMaybe<PolicyContractProduct_Prepend_Input>;
  _set?: InputMaybe<PolicyContractProduct_Set_Input>;
  where: PolicyContractProduct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractQuoteArgs = {
  _append?: InputMaybe<PolicyContractQuote_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContractQuote_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContractQuote_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContractQuote_Delete_Key_Input>;
  _prepend?: InputMaybe<PolicyContractQuote_Prepend_Input>;
  _set?: InputMaybe<PolicyContractQuote_Set_Input>;
  pk_columns: PolicyContractQuote_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractQuotesArgs = {
  _append?: InputMaybe<PolicyContractQuote_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContractQuote_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContractQuote_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContractQuote_Delete_Key_Input>;
  _prepend?: InputMaybe<PolicyContractQuote_Prepend_Input>;
  _set?: InputMaybe<PolicyContractQuote_Set_Input>;
  where: PolicyContractQuote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractStatusTypeArgs = {
  _inc?: InputMaybe<PolicyContractStatusType_Inc_Input>;
  _set?: InputMaybe<PolicyContractStatusType_Set_Input>;
  pk_columns: PolicyContractStatusType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractStatusTypesArgs = {
  _inc?: InputMaybe<PolicyContractStatusType_Inc_Input>;
  _set?: InputMaybe<PolicyContractStatusType_Set_Input>;
  where: PolicyContractStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractVoidReasonTypeArgs = {
  _inc?: InputMaybe<PolicyContractVoidReasonType_Inc_Input>;
  _set?: InputMaybe<PolicyContractVoidReasonType_Set_Input>;
  pk_columns: PolicyContractVoidReasonType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractVoidReasonTypesArgs = {
  _inc?: InputMaybe<PolicyContractVoidReasonType_Inc_Input>;
  _set?: InputMaybe<PolicyContractVoidReasonType_Set_Input>;
  where: PolicyContractVoidReasonType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyContractsArgs = {
  _append?: InputMaybe<PolicyContract_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyContract_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyContract_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyContract_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyContract_Inc_Input>;
  _prepend?: InputMaybe<PolicyContract_Prepend_Input>;
  _set?: InputMaybe<PolicyContract_Set_Input>;
  where: PolicyContract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePreAuthorizationArgs = {
  _append?: InputMaybe<PreAuthorization_Append_Input>;
  _delete_at_path?: InputMaybe<PreAuthorization_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PreAuthorization_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PreAuthorization_Delete_Key_Input>;
  _prepend?: InputMaybe<PreAuthorization_Prepend_Input>;
  _set?: InputMaybe<PreAuthorization_Set_Input>;
  pk_columns: PreAuthorization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePreAuthorizationStatusTypeArgs = {
  _set?: InputMaybe<PreAuthorizationStatusType_Set_Input>;
  pk_columns: PreAuthorizationStatusType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePreAuthorizationStatusTypesArgs = {
  _set?: InputMaybe<PreAuthorizationStatusType_Set_Input>;
  where: PreAuthorizationStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePreAuthorizationTypeArgs = {
  _set?: InputMaybe<PreAuthorizationType_Set_Input>;
  pk_columns: PreAuthorizationType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdatePreAuthorizationTypesArgs = {
  _set?: InputMaybe<PreAuthorizationType_Set_Input>;
  where: PreAuthorizationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePreAuthorizationsArgs = {
  _append?: InputMaybe<PreAuthorization_Append_Input>;
  _delete_at_path?: InputMaybe<PreAuthorization_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PreAuthorization_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PreAuthorization_Delete_Key_Input>;
  _prepend?: InputMaybe<PreAuthorization_Prepend_Input>;
  _set?: InputMaybe<PreAuthorization_Set_Input>;
  where: PreAuthorization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductArgs = {
  _append?: InputMaybe<Product_Append_Input>;
  _delete_at_path?: InputMaybe<Product_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Product_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Product_Delete_Key_Input>;
  _prepend?: InputMaybe<Product_Prepend_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  pk_columns: Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductAttributeArgs = {
  _inc?: InputMaybe<ProductAttribute_Inc_Input>;
  _set?: InputMaybe<ProductAttribute_Set_Input>;
  pk_columns: ProductAttribute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductAttributeTypeArgs = {
  _inc?: InputMaybe<ProductAttributeType_Inc_Input>;
  _set?: InputMaybe<ProductAttributeType_Set_Input>;
  pk_columns: ProductAttributeType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductAttributeTypesArgs = {
  _inc?: InputMaybe<ProductAttributeType_Inc_Input>;
  _set?: InputMaybe<ProductAttributeType_Set_Input>;
  where: ProductAttributeType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductAttributesArgs = {
  _inc?: InputMaybe<ProductAttribute_Inc_Input>;
  _set?: InputMaybe<ProductAttribute_Set_Input>;
  where: ProductAttribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductClassGuideArgs = {
  _set?: InputMaybe<ProductClassGuide_Set_Input>;
  pk_columns: ProductClassGuide_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductClassGuidesArgs = {
  _set?: InputMaybe<ProductClassGuide_Set_Input>;
  where: ProductClassGuide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductContractFormArgs = {
  _set?: InputMaybe<ProductContractForm_Set_Input>;
  pk_columns: ProductContractForm_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductContractFormsArgs = {
  _set?: InputMaybe<ProductContractForm_Set_Input>;
  where: ProductContractForm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductCostArgs = {
  _inc?: InputMaybe<ProductCost_Inc_Input>;
  _set?: InputMaybe<ProductCost_Set_Input>;
  pk_columns: ProductCost_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductCostsArgs = {
  _inc?: InputMaybe<ProductCost_Inc_Input>;
  _set?: InputMaybe<ProductCost_Set_Input>;
  where: ProductCost_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductDisbursementArgs = {
  _inc?: InputMaybe<ProductDisbursement_Inc_Input>;
  _set?: InputMaybe<ProductDisbursement_Set_Input>;
  pk_columns: ProductDisbursement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductDisbursementsArgs = {
  _inc?: InputMaybe<ProductDisbursement_Inc_Input>;
  _set?: InputMaybe<ProductDisbursement_Set_Input>;
  where: ProductDisbursement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductEligibilitiesArgs = {
  _set?: InputMaybe<ProductEligibility_Set_Input>;
  where: ProductEligibility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductEligibilityArgs = {
  _set?: InputMaybe<ProductEligibility_Set_Input>;
  pk_columns: ProductEligibility_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductObligorArgs = {
  _set?: InputMaybe<ProductObligor_Set_Input>;
  pk_columns: ProductObligor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductObligorsArgs = {
  _set?: InputMaybe<ProductObligor_Set_Input>;
  where: ProductObligor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductRateBucketArgs = {
  _inc?: InputMaybe<ProductRateBucket_Inc_Input>;
  _set?: InputMaybe<ProductRateBucket_Set_Input>;
  pk_columns: ProductRateBucket_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductRateBucketsArgs = {
  _inc?: InputMaybe<ProductRateBucket_Inc_Input>;
  _set?: InputMaybe<ProductRateBucket_Set_Input>;
  where: ProductRateBucket_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductSurchargeTypeArgs = {
  _inc?: InputMaybe<ProductSurchargeType_Inc_Input>;
  _set?: InputMaybe<ProductSurchargeType_Set_Input>;
  pk_columns: ProductSurchargeType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProductSurchargeTypesArgs = {
  _inc?: InputMaybe<ProductSurchargeType_Inc_Input>;
  _set?: InputMaybe<ProductSurchargeType_Set_Input>;
  where: ProductSurchargeType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProductsArgs = {
  _append?: InputMaybe<Product_Append_Input>;
  _delete_at_path?: InputMaybe<Product_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Product_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Product_Delete_Key_Input>;
  _prepend?: InputMaybe<Product_Prepend_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProfileArgs = {
  _set?: InputMaybe<Profile_Set_Input>;
  pk_columns: Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateProfilesArgs = {
  _set?: InputMaybe<Profile_Set_Input>;
  where: Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateQuoteArgs = {
  _append?: InputMaybe<Quote_Append_Input>;
  _delete_at_path?: InputMaybe<Quote_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quote_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quote_Delete_Key_Input>;
  _prepend?: InputMaybe<Quote_Prepend_Input>;
  _set?: InputMaybe<Quote_Set_Input>;
  pk_columns: Quote_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateQuoteMinimalViewsArgs = {
  _append?: InputMaybe<QuoteMinimalView_Append_Input>;
  _delete_at_path?: InputMaybe<QuoteMinimalView_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<QuoteMinimalView_Delete_Elem_Input>;
  _delete_key?: InputMaybe<QuoteMinimalView_Delete_Key_Input>;
  _prepend?: InputMaybe<QuoteMinimalView_Prepend_Input>;
  _set?: InputMaybe<QuoteMinimalView_Set_Input>;
  where: QuoteMinimalView_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateQuoteTypeArgs = {
  _inc?: InputMaybe<QuoteType_Inc_Input>;
  _set?: InputMaybe<QuoteType_Set_Input>;
  pk_columns: QuoteType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateQuoteTypesArgs = {
  _inc?: InputMaybe<QuoteType_Inc_Input>;
  _set?: InputMaybe<QuoteType_Set_Input>;
  where: QuoteType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateQuotesArgs = {
  _append?: InputMaybe<Quote_Append_Input>;
  _delete_at_path?: InputMaybe<Quote_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quote_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quote_Delete_Key_Input>;
  _prepend?: InputMaybe<Quote_Prepend_Input>;
  _set?: InputMaybe<Quote_Set_Input>;
  where: Quote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRateBucketTypeArgs = {
  _inc?: InputMaybe<RateBucketType_Inc_Input>;
  _set?: InputMaybe<RateBucketType_Set_Input>;
  pk_columns: RateBucketType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRateBucketTypesArgs = {
  _inc?: InputMaybe<RateBucketType_Inc_Input>;
  _set?: InputMaybe<RateBucketType_Set_Input>;
  where: RateBucketType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRateQuoteArgs = {
  _append?: InputMaybe<RateQuote_Append_Input>;
  _delete_at_path?: InputMaybe<RateQuote_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RateQuote_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RateQuote_Delete_Key_Input>;
  _prepend?: InputMaybe<RateQuote_Prepend_Input>;
  _set?: InputMaybe<RateQuote_Set_Input>;
  pk_columns: RateQuote_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRateQuotesArgs = {
  _append?: InputMaybe<RateQuote_Append_Input>;
  _delete_at_path?: InputMaybe<RateQuote_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RateQuote_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RateQuote_Delete_Key_Input>;
  _prepend?: InputMaybe<RateQuote_Prepend_Input>;
  _set?: InputMaybe<RateQuote_Set_Input>;
  where: RateQuote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRaterViewConfigArgs = {
  _append?: InputMaybe<RaterViewConfig_Append_Input>;
  _delete_at_path?: InputMaybe<RaterViewConfig_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RaterViewConfig_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RaterViewConfig_Delete_Key_Input>;
  _prepend?: InputMaybe<RaterViewConfig_Prepend_Input>;
  _set?: InputMaybe<RaterViewConfig_Set_Input>;
  pk_columns: RaterViewConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRaterViewConfigsArgs = {
  _append?: InputMaybe<RaterViewConfig_Append_Input>;
  _delete_at_path?: InputMaybe<RaterViewConfig_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RaterViewConfig_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RaterViewConfig_Delete_Key_Input>;
  _prepend?: InputMaybe<RaterViewConfig_Prepend_Input>;
  _set?: InputMaybe<RaterViewConfig_Set_Input>;
  where: RaterViewConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateReferenceLogArgs = {
  _set?: InputMaybe<ReferenceLog_Set_Input>;
  pk_columns: ReferenceLog_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateReferenceLogsArgs = {
  _set?: InputMaybe<ReferenceLog_Set_Input>;
  where: ReferenceLog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRemittanceArgs = {
  _append?: InputMaybe<Remittance_Append_Input>;
  _delete_at_path?: InputMaybe<Remittance_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Remittance_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Remittance_Delete_Key_Input>;
  _inc?: InputMaybe<Remittance_Inc_Input>;
  _prepend?: InputMaybe<Remittance_Prepend_Input>;
  _set?: InputMaybe<Remittance_Set_Input>;
  pk_columns: Remittance_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRemittanceClaimDetailArgs = {
  _inc?: InputMaybe<RemittanceClaimDetail_Inc_Input>;
  _set?: InputMaybe<RemittanceClaimDetail_Set_Input>;
  pk_columns: RemittanceClaimDetail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRemittanceClaimDetailsArgs = {
  _inc?: InputMaybe<RemittanceClaimDetail_Inc_Input>;
  _set?: InputMaybe<RemittanceClaimDetail_Set_Input>;
  where: RemittanceClaimDetail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRemittancePaymentArgs = {
  _set?: InputMaybe<RemittancePayment_Set_Input>;
  pk_columns: RemittancePayment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRemittancePaymentsArgs = {
  _set?: InputMaybe<RemittancePayment_Set_Input>;
  where: RemittancePayment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRemittancePolicyContractArgs = {
  _inc?: InputMaybe<RemittancePolicyContract_Inc_Input>;
  _set?: InputMaybe<RemittancePolicyContract_Set_Input>;
  pk_columns: RemittancePolicyContract_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRemittancePolicyContractAs400Args = {
  _set?: InputMaybe<RemittancePolicyContractAs400_Set_Input>;
  pk_columns: RemittancePolicyContractAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRemittancePolicyContractAs400sArgs = {
  _set?: InputMaybe<RemittancePolicyContractAs400_Set_Input>;
  where: RemittancePolicyContractAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRemittancePolicyContractsArgs = {
  _inc?: InputMaybe<RemittancePolicyContract_Inc_Input>;
  _set?: InputMaybe<RemittancePolicyContract_Set_Input>;
  where: RemittancePolicyContract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRemittanceStatusTypeArgs = {
  _inc?: InputMaybe<RemittanceStatusType_Inc_Input>;
  _set?: InputMaybe<RemittanceStatusType_Set_Input>;
  pk_columns: RemittanceStatusType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRemittanceStatusTypesArgs = {
  _inc?: InputMaybe<RemittanceStatusType_Inc_Input>;
  _set?: InputMaybe<RemittanceStatusType_Set_Input>;
  where: RemittanceStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRemittanceTypeArgs = {
  _inc?: InputMaybe<RemittanceType_Inc_Input>;
  _set?: InputMaybe<RemittanceType_Set_Input>;
  pk_columns: RemittanceType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRemittanceTypesArgs = {
  _inc?: InputMaybe<RemittanceType_Inc_Input>;
  _set?: InputMaybe<RemittanceType_Set_Input>;
  where: RemittanceType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRemittancesArgs = {
  _append?: InputMaybe<Remittance_Append_Input>;
  _delete_at_path?: InputMaybe<Remittance_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Remittance_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Remittance_Delete_Key_Input>;
  _inc?: InputMaybe<Remittance_Inc_Input>;
  _prepend?: InputMaybe<Remittance_Prepend_Input>;
  _set?: InputMaybe<Remittance_Set_Input>;
  where: Remittance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRepeatPartAcknowledgmentArgs = {
  _set?: InputMaybe<RepeatPartAcknowledgment_Set_Input>;
  pk_columns: RepeatPartAcknowledgment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRepeatPartAcknowledgmentsArgs = {
  _set?: InputMaybe<RepeatPartAcknowledgment_Set_Input>;
  where: RepeatPartAcknowledgment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRoleArgs = {
  _inc?: InputMaybe<Role_Inc_Input>;
  _set?: InputMaybe<Role_Set_Input>;
  pk_columns: Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRoleAttributeArgs = {
  _set?: InputMaybe<RoleAttribute_Set_Input>;
  pk_columns: RoleAttribute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRoleAttributesArgs = {
  _set?: InputMaybe<RoleAttribute_Set_Input>;
  where: RoleAttribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRolesArgs = {
  _inc?: InputMaybe<Role_Inc_Input>;
  _set?: InputMaybe<Role_Set_Input>;
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRouteArgs = {
  _set?: InputMaybe<Route_Set_Input>;
  pk_columns: Route_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRouteConfigArgs = {
  _set?: InputMaybe<RouteConfig_Set_Input>;
  pk_columns: RouteConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateRouteConfigsArgs = {
  _set?: InputMaybe<RouteConfig_Set_Input>;
  where: RouteConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRoutesArgs = {
  _set?: InputMaybe<Route_Set_Input>;
  where: Route_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSearchIndexArgs = {
  _set?: InputMaybe<SearchIndex_Set_Input>;
  pk_columns: SearchIndex_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateSearchIndexesArgs = {
  _set?: InputMaybe<SearchIndex_Set_Input>;
  where: SearchIndex_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSelectStateArgs = {
  _inc?: InputMaybe<State_Inc_Input>;
  _set?: InputMaybe<State_Set_Input>;
  pk_columns: State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateSelectStatesArgs = {
  _inc?: InputMaybe<State_Inc_Input>;
  _set?: InputMaybe<State_Set_Input>;
  where: State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateServiceCenterArgs = {
  _set?: InputMaybe<ServiceCenter_Set_Input>;
  pk_columns: ServiceCenter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateServiceCentersArgs = {
  _set?: InputMaybe<ServiceCenter_Set_Input>;
  where: ServiceCenter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSeverityLevelTypeArgs = {
  _inc?: InputMaybe<SeverityLevelType_Inc_Input>;
  _set?: InputMaybe<SeverityLevelType_Set_Input>;
  pk_columns: SeverityLevelType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateSeverityLevelTypesArgs = {
  _inc?: InputMaybe<SeverityLevelType_Inc_Input>;
  _set?: InputMaybe<SeverityLevelType_Set_Input>;
  where: SeverityLevelType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateShortcutBindingArgs = {
  _append?: InputMaybe<ShortcutBinding_Append_Input>;
  _delete_at_path?: InputMaybe<ShortcutBinding_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ShortcutBinding_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ShortcutBinding_Delete_Key_Input>;
  _prepend?: InputMaybe<ShortcutBinding_Prepend_Input>;
  _set?: InputMaybe<ShortcutBinding_Set_Input>;
  pk_columns: ShortcutBinding_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateShortcutBindingsArgs = {
  _append?: InputMaybe<ShortcutBinding_Append_Input>;
  _delete_at_path?: InputMaybe<ShortcutBinding_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ShortcutBinding_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ShortcutBinding_Delete_Key_Input>;
  _prepend?: InputMaybe<ShortcutBinding_Prepend_Input>;
  _set?: InputMaybe<ShortcutBinding_Set_Input>;
  where: ShortcutBinding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateStepArgs = {
  _set?: InputMaybe<Step_Set_Input>;
  pk_columns: Step_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateStepTypeArgs = {
  _inc?: InputMaybe<StepType_Inc_Input>;
  _set?: InputMaybe<StepType_Set_Input>;
  pk_columns: StepType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateStepTypesArgs = {
  _inc?: InputMaybe<StepType_Inc_Input>;
  _set?: InputMaybe<StepType_Set_Input>;
  where: StepType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateStepsArgs = {
  _set?: InputMaybe<Step_Set_Input>;
  where: Step_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSurchargeTypeArgs = {
  _inc?: InputMaybe<SurchargeType_Inc_Input>;
  _set?: InputMaybe<SurchargeType_Set_Input>;
  pk_columns: SurchargeType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateSurchargeTypesArgs = {
  _inc?: InputMaybe<SurchargeType_Inc_Input>;
  _set?: InputMaybe<SurchargeType_Set_Input>;
  where: SurchargeType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateTagArgs = {
  _append?: InputMaybe<Tag_Append_Input>;
  _delete_at_path?: InputMaybe<Tag_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tag_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tag_Delete_Key_Input>;
  _prepend?: InputMaybe<Tag_Prepend_Input>;
  _set?: InputMaybe<Tag_Set_Input>;
  pk_columns: Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateTagsArgs = {
  _append?: InputMaybe<Tag_Append_Input>;
  _delete_at_path?: InputMaybe<Tag_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tag_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tag_Delete_Key_Input>;
  _prepend?: InputMaybe<Tag_Prepend_Input>;
  _set?: InputMaybe<Tag_Set_Input>;
  where: Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateTaskArgs = {
  _inc?: InputMaybe<Task_Inc_Input>;
  _set?: InputMaybe<Task_Set_Input>;
  pk_columns: Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateTasksArgs = {
  _inc?: InputMaybe<Task_Inc_Input>;
  _set?: InputMaybe<Task_Set_Input>;
  where: Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateTaxRateArgs = {
  _inc?: InputMaybe<TaxRate_Inc_Input>;
  _set?: InputMaybe<TaxRate_Set_Input>;
  pk_columns: TaxRate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateTaxRateAs400Args = {
  _set?: InputMaybe<TaxRateAs400_Set_Input>;
  pk_columns: TaxRateAs400_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateTaxRateAs400sArgs = {
  _set?: InputMaybe<TaxRateAs400_Set_Input>;
  where: TaxRateAs400_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateTaxRatesArgs = {
  _inc?: InputMaybe<TaxRate_Inc_Input>;
  _set?: InputMaybe<TaxRate_Set_Input>;
  where: TaxRate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateTechnologyTypeArgs = {
  _inc?: InputMaybe<TechnologyType_Inc_Input>;
  _set?: InputMaybe<TechnologyType_Set_Input>;
  pk_columns: TechnologyType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateTechnologyTypesArgs = {
  _inc?: InputMaybe<TechnologyType_Inc_Input>;
  _set?: InputMaybe<TechnologyType_Set_Input>;
  where: TechnologyType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateTypeArgs = {
  _append?: InputMaybe<Type_Append_Input>;
  _delete_at_path?: InputMaybe<Type_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Type_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Type_Delete_Key_Input>;
  _inc?: InputMaybe<Type_Inc_Input>;
  _prepend?: InputMaybe<Type_Prepend_Input>;
  _set?: InputMaybe<Type_Set_Input>;
  pk_columns: Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateTypeGroupArgs = {
  _set?: InputMaybe<TypeGroup_Set_Input>;
  pk_columns: TypeGroup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateTypeGroupsArgs = {
  _set?: InputMaybe<TypeGroup_Set_Input>;
  where: TypeGroup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateTypesArgs = {
  _append?: InputMaybe<Type_Append_Input>;
  _delete_at_path?: InputMaybe<Type_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Type_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Type_Delete_Key_Input>;
  _inc?: InputMaybe<Type_Inc_Input>;
  _prepend?: InputMaybe<Type_Prepend_Input>;
  _set?: InputMaybe<Type_Set_Input>;
  where: Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUserFlowItemArgs = {
  _set?: InputMaybe<UserFlowItem_Set_Input>;
  pk_columns: UserFlowItem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUserFlowItemMfaArgs = {
  _set?: InputMaybe<UserFlowItemMfa_Set_Input>;
  pk_columns: UserFlowItemMfa_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUserFlowItemMfasArgs = {
  _set?: InputMaybe<UserFlowItemMfa_Set_Input>;
  where: UserFlowItemMfa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserFlowItemsArgs = {
  _set?: InputMaybe<UserFlowItem_Set_Input>;
  where: UserFlowItem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserGroupArgs = {
  _set?: InputMaybe<UserGroup_Set_Input>;
  pk_columns: UserGroup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUserGroupsArgs = {
  _set?: InputMaybe<UserGroup_Set_Input>;
  where: UserGroup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserPinArgs = {
  _set?: InputMaybe<UserPin_Set_Input>;
  pk_columns: UserPin_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUserPinsArgs = {
  _set?: InputMaybe<UserPin_Set_Input>;
  where: UserPin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserProfileArgs = {
  _inc?: InputMaybe<UserProfile_Inc_Input>;
  _set?: InputMaybe<UserProfile_Set_Input>;
  pk_columns: UserProfile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUserProfilesArgs = {
  _inc?: InputMaybe<UserProfile_Inc_Input>;
  _set?: InputMaybe<UserProfile_Set_Input>;
  where: UserProfile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserSessionArgs = {
  _set?: InputMaybe<UserSession_Set_Input>;
  pk_columns: UserSession_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUserSessionsArgs = {
  _set?: InputMaybe<UserSession_Set_Input>;
  where: UserSession_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateValidationArgs = {
  _set?: InputMaybe<Validation_Set_Input>;
  pk_columns: Validation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateValidationLifecycleHookArgs = {
  _set?: InputMaybe<ValidationLifecycleHook_Set_Input>;
  pk_columns: ValidationLifecycleHook_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateValidationLifecycleHooksArgs = {
  _set?: InputMaybe<ValidationLifecycleHook_Set_Input>;
  where: ValidationLifecycleHook_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateValidationOverrideArgs = {
  _set?: InputMaybe<ValidationOverride_Set_Input>;
  pk_columns: ValidationOverride_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateValidationOverridesArgs = {
  _set?: InputMaybe<ValidationOverride_Set_Input>;
  where: ValidationOverride_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateValidationRuleForArgs = {
  _set?: InputMaybe<ValidationRuleFor_Set_Input>;
  pk_columns: ValidationRuleFor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateValidationRuleForsArgs = {
  _set?: InputMaybe<ValidationRuleFor_Set_Input>;
  where: ValidationRuleFor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateValidationTypeOperationArgs = {
  _set?: InputMaybe<ValidationTypeOperation_Set_Input>;
  pk_columns: ValidationTypeOperation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateValidationTypeOperationsArgs = {
  _set?: InputMaybe<ValidationTypeOperation_Set_Input>;
  where: ValidationTypeOperation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateValidationWhenArgs = {
  _set?: InputMaybe<ValidationWhen_Set_Input>;
  pk_columns: ValidationWhen_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateValidationWhensArgs = {
  _set?: InputMaybe<ValidationWhen_Set_Input>;
  where: ValidationWhen_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateValidationsArgs = {
  _set?: InputMaybe<Validation_Set_Input>;
  where: Validation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateVehicleArgs = {
  _set?: InputMaybe<Vehicle_Set_Input>;
  pk_columns: Vehicle_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateVehicleStatusTypeArgs = {
  _inc?: InputMaybe<VehicleStatusType_Inc_Input>;
  _set?: InputMaybe<VehicleStatusType_Set_Input>;
  pk_columns: VehicleStatusType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateVehicleStatusTypesArgs = {
  _inc?: InputMaybe<VehicleStatusType_Inc_Input>;
  _set?: InputMaybe<VehicleStatusType_Set_Input>;
  where: VehicleStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateVehiclesArgs = {
  _set?: InputMaybe<Vehicle_Set_Input>;
  where: Vehicle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateVpicDecodeAlternativeArgs = {
  _inc?: InputMaybe<VpicDecodeAlternative_Inc_Input>;
  _set?: InputMaybe<VpicDecodeAlternative_Set_Input>;
  pk_columns: VpicDecodeAlternative_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateVpicDecodeAlternativesArgs = {
  _inc?: InputMaybe<VpicDecodeAlternative_Inc_Input>;
  _set?: InputMaybe<VpicDecodeAlternative_Set_Input>;
  where: VpicDecodeAlternative_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateWorkStatusTypeArgs = {
  _inc?: InputMaybe<WorkStatusType_Inc_Input>;
  _set?: InputMaybe<WorkStatusType_Set_Input>;
  pk_columns: WorkStatusType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateWorkStatusTypesArgs = {
  _inc?: InputMaybe<WorkStatusType_Inc_Input>;
  _set?: InputMaybe<WorkStatusType_Set_Input>;
  where: WorkStatusType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateWorkflowStateTypeArgs = {
  _inc?: InputMaybe<WorkflowStateType_Inc_Input>;
  _set?: InputMaybe<WorkflowStateType_Set_Input>;
  pk_columns: WorkflowStateType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateWorkflowStateTypesArgs = {
  _inc?: InputMaybe<WorkflowStateType_Inc_Input>;
  _set?: InputMaybe<WorkflowStateType_Set_Input>;
  where: WorkflowStateType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AbsArgs = {
  _inc?: InputMaybe<Abs_Inc_Input_Vpic>;
  _set?: InputMaybe<Abs_Set_Input_Vpic>;
  where: Abs_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Abs_By_PkArgs = {
  _inc?: InputMaybe<Abs_Inc_Input_Vpic>;
  _set?: InputMaybe<Abs_Set_Input_Vpic>;
  pk_columns: Abs_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Abs_ManyArgs = {
  updates: Array<Abs_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_AdaptiveCruiseControlArgs = {
  _inc?: InputMaybe<AdaptiveCruiseControl_Inc_Input_Vpic>;
  _set?: InputMaybe<AdaptiveCruiseControl_Set_Input_Vpic>;
  where: AdaptiveCruiseControl_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AdaptiveCruiseControl_By_PkArgs = {
  _inc?: InputMaybe<AdaptiveCruiseControl_Inc_Input_Vpic>;
  _set?: InputMaybe<AdaptiveCruiseControl_Set_Input_Vpic>;
  pk_columns: AdaptiveCruiseControl_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AdaptiveCruiseControl_ManyArgs = {
  updates: Array<AdaptiveCruiseControl_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_AdaptiveDrivingBeamArgs = {
  _inc?: InputMaybe<AdaptiveDrivingBeam_Inc_Input_Vpic>;
  _set?: InputMaybe<AdaptiveDrivingBeam_Set_Input_Vpic>;
  where: AdaptiveDrivingBeam_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AdaptiveDrivingBeam_By_PkArgs = {
  _inc?: InputMaybe<AdaptiveDrivingBeam_Inc_Input_Vpic>;
  _set?: InputMaybe<AdaptiveDrivingBeam_Set_Input_Vpic>;
  pk_columns: AdaptiveDrivingBeam_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AdaptiveDrivingBeam_ManyArgs = {
  updates: Array<AdaptiveDrivingBeam_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_AirBagLocFrontArgs = {
  _inc?: InputMaybe<AirBagLocFront_Inc_Input_Vpic>;
  _set?: InputMaybe<AirBagLocFront_Set_Input_Vpic>;
  where: AirBagLocFront_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AirBagLocFront_By_PkArgs = {
  _inc?: InputMaybe<AirBagLocFront_Inc_Input_Vpic>;
  _set?: InputMaybe<AirBagLocFront_Set_Input_Vpic>;
  pk_columns: AirBagLocFront_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AirBagLocFront_ManyArgs = {
  updates: Array<AirBagLocFront_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_AirBagLocKneeArgs = {
  _inc?: InputMaybe<AirBagLocKnee_Inc_Input_Vpic>;
  _set?: InputMaybe<AirBagLocKnee_Set_Input_Vpic>;
  where: AirBagLocKnee_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AirBagLocKnee_By_PkArgs = {
  _inc?: InputMaybe<AirBagLocKnee_Inc_Input_Vpic>;
  _set?: InputMaybe<AirBagLocKnee_Set_Input_Vpic>;
  pk_columns: AirBagLocKnee_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AirBagLocKnee_ManyArgs = {
  updates: Array<AirBagLocKnee_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_AirBagLocationsArgs = {
  _inc?: InputMaybe<AirBagLocations_Inc_Input_Vpic>;
  _set?: InputMaybe<AirBagLocations_Set_Input_Vpic>;
  where: AirBagLocations_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AirBagLocations_By_PkArgs = {
  _inc?: InputMaybe<AirBagLocations_Inc_Input_Vpic>;
  _set?: InputMaybe<AirBagLocations_Set_Input_Vpic>;
  pk_columns: AirBagLocations_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AirBagLocations_ManyArgs = {
  updates: Array<AirBagLocations_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_AutoBrakeArgs = {
  _inc?: InputMaybe<AutoBrake_Inc_Input_Vpic>;
  _set?: InputMaybe<AutoBrake_Set_Input_Vpic>;
  where: AutoBrake_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AutoBrake_By_PkArgs = {
  _inc?: InputMaybe<AutoBrake_Inc_Input_Vpic>;
  _set?: InputMaybe<AutoBrake_Set_Input_Vpic>;
  pk_columns: AutoBrake_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AutoBrake_ManyArgs = {
  updates: Array<AutoBrake_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_AutoReverseSystemArgs = {
  _inc?: InputMaybe<AutoReverseSystem_Inc_Input_Vpic>;
  _set?: InputMaybe<AutoReverseSystem_Set_Input_Vpic>;
  where: AutoReverseSystem_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AutoReverseSystem_By_PkArgs = {
  _inc?: InputMaybe<AutoReverseSystem_Inc_Input_Vpic>;
  _set?: InputMaybe<AutoReverseSystem_Set_Input_Vpic>;
  pk_columns: AutoReverseSystem_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AutoReverseSystem_ManyArgs = {
  updates: Array<AutoReverseSystem_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_AutomaticPedestrainAlertingSoundArgs = {
  _inc?: InputMaybe<AutomaticPedestrainAlertingSound_Inc_Input_Vpic>;
  _set?: InputMaybe<AutomaticPedestrainAlertingSound_Set_Input_Vpic>;
  where: AutomaticPedestrainAlertingSound_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AutomaticPedestrainAlertingSound_By_PkArgs = {
  _inc?: InputMaybe<AutomaticPedestrainAlertingSound_Inc_Input_Vpic>;
  _set?: InputMaybe<AutomaticPedestrainAlertingSound_Set_Input_Vpic>;
  pk_columns: AutomaticPedestrainAlertingSound_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AutomaticPedestrainAlertingSound_ManyArgs = {
  updates: Array<AutomaticPedestrainAlertingSound_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_AxleConfigurationArgs = {
  _inc?: InputMaybe<AxleConfiguration_Inc_Input_Vpic>;
  _set?: InputMaybe<AxleConfiguration_Set_Input_Vpic>;
  where: AxleConfiguration_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AxleConfiguration_By_PkArgs = {
  _inc?: InputMaybe<AxleConfiguration_Inc_Input_Vpic>;
  _set?: InputMaybe<AxleConfiguration_Set_Input_Vpic>;
  pk_columns: AxleConfiguration_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_AxleConfiguration_ManyArgs = {
  updates: Array<AxleConfiguration_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_BatteryTypeArgs = {
  _inc?: InputMaybe<BatteryType_Inc_Input_Vpic>;
  _set?: InputMaybe<BatteryType_Set_Input_Vpic>;
  where: BatteryType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BatteryType_By_PkArgs = {
  _inc?: InputMaybe<BatteryType_Inc_Input_Vpic>;
  _set?: InputMaybe<BatteryType_Set_Input_Vpic>;
  pk_columns: BatteryType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BatteryType_ManyArgs = {
  updates: Array<BatteryType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_BedTypeArgs = {
  _inc?: InputMaybe<BedType_Inc_Input_Vpic>;
  _set?: InputMaybe<BedType_Set_Input_Vpic>;
  where: BedType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BedType_By_PkArgs = {
  _inc?: InputMaybe<BedType_Inc_Input_Vpic>;
  _set?: InputMaybe<BedType_Set_Input_Vpic>;
  pk_columns: BedType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BedType_ManyArgs = {
  updates: Array<BedType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_BlindSpotInterventionArgs = {
  _inc?: InputMaybe<BlindSpotIntervention_Inc_Input_Vpic>;
  _set?: InputMaybe<BlindSpotIntervention_Set_Input_Vpic>;
  where: BlindSpotIntervention_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BlindSpotIntervention_By_PkArgs = {
  _inc?: InputMaybe<BlindSpotIntervention_Inc_Input_Vpic>;
  _set?: InputMaybe<BlindSpotIntervention_Set_Input_Vpic>;
  pk_columns: BlindSpotIntervention_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BlindSpotIntervention_ManyArgs = {
  updates: Array<BlindSpotIntervention_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_BlindSpotMonitoringArgs = {
  _inc?: InputMaybe<BlindSpotMonitoring_Inc_Input_Vpic>;
  _set?: InputMaybe<BlindSpotMonitoring_Set_Input_Vpic>;
  where: BlindSpotMonitoring_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BlindSpotMonitoring_By_PkArgs = {
  _inc?: InputMaybe<BlindSpotMonitoring_Inc_Input_Vpic>;
  _set?: InputMaybe<BlindSpotMonitoring_Set_Input_Vpic>;
  pk_columns: BlindSpotMonitoring_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BlindSpotMonitoring_ManyArgs = {
  updates: Array<BlindSpotMonitoring_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_BodyCabArgs = {
  _inc?: InputMaybe<BodyCab_Inc_Input_Vpic>;
  _set?: InputMaybe<BodyCab_Set_Input_Vpic>;
  where: BodyCab_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BodyCab_By_PkArgs = {
  _inc?: InputMaybe<BodyCab_Inc_Input_Vpic>;
  _set?: InputMaybe<BodyCab_Set_Input_Vpic>;
  pk_columns: BodyCab_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BodyCab_ManyArgs = {
  updates: Array<BodyCab_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_BodyStyleArgs = {
  _inc?: InputMaybe<BodyStyle_Inc_Input_Vpic>;
  _set?: InputMaybe<BodyStyle_Set_Input_Vpic>;
  where: BodyStyle_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BodyStyle_By_PkArgs = {
  _inc?: InputMaybe<BodyStyle_Inc_Input_Vpic>;
  _set?: InputMaybe<BodyStyle_Set_Input_Vpic>;
  pk_columns: BodyStyle_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BodyStyle_ManyArgs = {
  updates: Array<BodyStyle_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_BrakeSystemArgs = {
  _inc?: InputMaybe<BrakeSystem_Inc_Input_Vpic>;
  _set?: InputMaybe<BrakeSystem_Set_Input_Vpic>;
  where: BrakeSystem_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BrakeSystem_By_PkArgs = {
  _inc?: InputMaybe<BrakeSystem_Inc_Input_Vpic>;
  _set?: InputMaybe<BrakeSystem_Set_Input_Vpic>;
  pk_columns: BrakeSystem_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BrakeSystem_ManyArgs = {
  updates: Array<BrakeSystem_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_BusFloorConfigTypeArgs = {
  _inc?: InputMaybe<BusFloorConfigType_Inc_Input_Vpic>;
  _set?: InputMaybe<BusFloorConfigType_Set_Input_Vpic>;
  where: BusFloorConfigType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BusFloorConfigType_By_PkArgs = {
  _inc?: InputMaybe<BusFloorConfigType_Inc_Input_Vpic>;
  _set?: InputMaybe<BusFloorConfigType_Set_Input_Vpic>;
  pk_columns: BusFloorConfigType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BusFloorConfigType_ManyArgs = {
  updates: Array<BusFloorConfigType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_BusTypeArgs = {
  _inc?: InputMaybe<BusType_Inc_Input_Vpic>;
  _set?: InputMaybe<BusType_Set_Input_Vpic>;
  where: BusType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BusType_By_PkArgs = {
  _inc?: InputMaybe<BusType_Inc_Input_Vpic>;
  _set?: InputMaybe<BusType_Set_Input_Vpic>;
  pk_columns: BusType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_BusType_ManyArgs = {
  updates: Array<BusType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_Can_AacnArgs = {
  _inc?: InputMaybe<Can_Aacn_Inc_Input_Vpic>;
  _set?: InputMaybe<Can_Aacn_Set_Input_Vpic>;
  where: Can_Aacn_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Can_Aacn_By_PkArgs = {
  _inc?: InputMaybe<Can_Aacn_Inc_Input_Vpic>;
  _set?: InputMaybe<Can_Aacn_Set_Input_Vpic>;
  pk_columns: Can_Aacn_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Can_Aacn_ManyArgs = {
  updates: Array<Can_Aacn_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_ChargerLevelArgs = {
  _inc?: InputMaybe<ChargerLevel_Inc_Input_Vpic>;
  _set?: InputMaybe<ChargerLevel_Set_Input_Vpic>;
  where: ChargerLevel_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ChargerLevel_By_PkArgs = {
  _inc?: InputMaybe<ChargerLevel_Inc_Input_Vpic>;
  _set?: InputMaybe<ChargerLevel_Set_Input_Vpic>;
  pk_columns: ChargerLevel_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ChargerLevel_ManyArgs = {
  updates: Array<ChargerLevel_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_CombinedBrakingSystemArgs = {
  _inc?: InputMaybe<CombinedBrakingSystem_Inc_Input_Vpic>;
  _set?: InputMaybe<CombinedBrakingSystem_Set_Input_Vpic>;
  where: CombinedBrakingSystem_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_CombinedBrakingSystem_By_PkArgs = {
  _inc?: InputMaybe<CombinedBrakingSystem_Inc_Input_Vpic>;
  _set?: InputMaybe<CombinedBrakingSystem_Set_Input_Vpic>;
  pk_columns: CombinedBrakingSystem_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_CombinedBrakingSystem_ManyArgs = {
  updates: Array<CombinedBrakingSystem_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_ContractMasterSurchargeArgs = {
  _inc?: InputMaybe<ContractMasterSurcharge_Inc_Input>;
  _set?: InputMaybe<ContractMasterSurcharge_Set_Input>;
  where: ContractMasterSurcharge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConversionArgs = {
  _inc?: InputMaybe<Conversion_Inc_Input_Vpic>;
  _set?: InputMaybe<Conversion_Set_Input_Vpic>;
  where: Conversion_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Conversion_By_PkArgs = {
  _inc?: InputMaybe<Conversion_Inc_Input_Vpic>;
  _set?: InputMaybe<Conversion_Set_Input_Vpic>;
  pk_columns: Conversion_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Conversion_ManyArgs = {
  updates: Array<Conversion_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_CoolingTypeArgs = {
  _inc?: InputMaybe<CoolingType_Inc_Input_Vpic>;
  _set?: InputMaybe<CoolingType_Set_Input_Vpic>;
  where: CoolingType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_CoolingType_By_PkArgs = {
  _inc?: InputMaybe<CoolingType_Inc_Input_Vpic>;
  _set?: InputMaybe<CoolingType_Set_Input_Vpic>;
  pk_columns: CoolingType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_CoolingType_ManyArgs = {
  updates: Array<CoolingType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_CountryArgs = {
  _inc?: InputMaybe<Country_Inc_Input_Vpic>;
  _set?: InputMaybe<Country_Set_Input_Vpic>;
  where: Country_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Country_By_PkArgs = {
  _inc?: InputMaybe<Country_Inc_Input_Vpic>;
  _set?: InputMaybe<Country_Set_Input_Vpic>;
  pk_columns: Country_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Country_ManyArgs = {
  updates: Array<Country_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_CustomMotorcycleTypeArgs = {
  _inc?: InputMaybe<CustomMotorcycleType_Inc_Input_Vpic>;
  _set?: InputMaybe<CustomMotorcycleType_Set_Input_Vpic>;
  where: CustomMotorcycleType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_CustomMotorcycleType_By_PkArgs = {
  _inc?: InputMaybe<CustomMotorcycleType_Inc_Input_Vpic>;
  _set?: InputMaybe<CustomMotorcycleType_Set_Input_Vpic>;
  pk_columns: CustomMotorcycleType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_CustomMotorcycleType_ManyArgs = {
  updates: Array<CustomMotorcycleType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_DaytimeRunningLightArgs = {
  _inc?: InputMaybe<DaytimeRunningLight_Inc_Input_Vpic>;
  _set?: InputMaybe<DaytimeRunningLight_Set_Input_Vpic>;
  where: DaytimeRunningLight_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_DaytimeRunningLight_By_PkArgs = {
  _inc?: InputMaybe<DaytimeRunningLight_Inc_Input_Vpic>;
  _set?: InputMaybe<DaytimeRunningLight_Set_Input_Vpic>;
  pk_columns: DaytimeRunningLight_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_DaytimeRunningLight_ManyArgs = {
  updates: Array<DaytimeRunningLight_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_DefaultValueArgs = {
  _inc?: InputMaybe<DefaultValue_Inc_Input_Vpic>;
  _set?: InputMaybe<DefaultValue_Set_Input_Vpic>;
  where: DefaultValue_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_DefaultValue_By_PkArgs = {
  _inc?: InputMaybe<DefaultValue_Inc_Input_Vpic>;
  _set?: InputMaybe<DefaultValue_Set_Input_Vpic>;
  pk_columns: DefaultValue_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_DefaultValue_ManyArgs = {
  updates: Array<DefaultValue_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_DestinationMarketArgs = {
  _inc?: InputMaybe<DestinationMarket_Inc_Input_Vpic>;
  _set?: InputMaybe<DestinationMarket_Set_Input_Vpic>;
  where: DestinationMarket_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_DestinationMarket_By_PkArgs = {
  _inc?: InputMaybe<DestinationMarket_Inc_Input_Vpic>;
  _set?: InputMaybe<DestinationMarket_Set_Input_Vpic>;
  pk_columns: DestinationMarket_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_DestinationMarket_ManyArgs = {
  updates: Array<DestinationMarket_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_DriveTypeArgs = {
  _inc?: InputMaybe<DriveType_Inc_Input_Vpic>;
  _set?: InputMaybe<DriveType_Set_Input_Vpic>;
  where: DriveType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_DriveType_By_PkArgs = {
  _inc?: InputMaybe<DriveType_Inc_Input_Vpic>;
  _set?: InputMaybe<DriveType_Set_Input_Vpic>;
  pk_columns: DriveType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_DriveType_ManyArgs = {
  updates: Array<DriveType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_DynamicBrakeSupportArgs = {
  _inc?: InputMaybe<DynamicBrakeSupport_Inc_Input_Vpic>;
  _set?: InputMaybe<DynamicBrakeSupport_Set_Input_Vpic>;
  where: DynamicBrakeSupport_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_DynamicBrakeSupport_By_PkArgs = {
  _inc?: InputMaybe<DynamicBrakeSupport_Inc_Input_Vpic>;
  _set?: InputMaybe<DynamicBrakeSupport_Set_Input_Vpic>;
  pk_columns: DynamicBrakeSupport_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_DynamicBrakeSupport_ManyArgs = {
  updates: Array<DynamicBrakeSupport_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_EcsArgs = {
  _inc?: InputMaybe<Ecs_Inc_Input_Vpic>;
  _set?: InputMaybe<Ecs_Set_Input_Vpic>;
  where: Ecs_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Ecs_By_PkArgs = {
  _inc?: InputMaybe<Ecs_Inc_Input_Vpic>;
  _set?: InputMaybe<Ecs_Set_Input_Vpic>;
  pk_columns: Ecs_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Ecs_ManyArgs = {
  updates: Array<Ecs_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_EdrArgs = {
  _inc?: InputMaybe<Edr_Inc_Input_Vpic>;
  _set?: InputMaybe<Edr_Set_Input_Vpic>;
  where: Edr_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Edr_By_PkArgs = {
  _inc?: InputMaybe<Edr_Inc_Input_Vpic>;
  _set?: InputMaybe<Edr_Set_Input_Vpic>;
  pk_columns: Edr_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Edr_ManyArgs = {
  updates: Array<Edr_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_EvDriveUnitArgs = {
  _inc?: InputMaybe<EvDriveUnit_Inc_Input_Vpic>;
  _set?: InputMaybe<EvDriveUnit_Set_Input_Vpic>;
  where: EvDriveUnit_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_EvDriveUnit_By_PkArgs = {
  _inc?: InputMaybe<EvDriveUnit_Inc_Input_Vpic>;
  _set?: InputMaybe<EvDriveUnit_Set_Input_Vpic>;
  pk_columns: EvDriveUnit_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_EvDriveUnit_ManyArgs = {
  updates: Array<EvDriveUnit_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_ElectrificationLevelArgs = {
  _inc?: InputMaybe<ElectrificationLevel_Inc_Input_Vpic>;
  _set?: InputMaybe<ElectrificationLevel_Set_Input_Vpic>;
  where: ElectrificationLevel_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ElectrificationLevel_By_PkArgs = {
  _inc?: InputMaybe<ElectrificationLevel_Inc_Input_Vpic>;
  _set?: InputMaybe<ElectrificationLevel_Set_Input_Vpic>;
  pk_columns: ElectrificationLevel_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ElectrificationLevel_ManyArgs = {
  updates: Array<ElectrificationLevel_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_ElementArgs = {
  _inc?: InputMaybe<Element_Inc_Input_Vpic>;
  _set?: InputMaybe<Element_Set_Input_Vpic>;
  where: Element_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Element_By_PkArgs = {
  _inc?: InputMaybe<Element_Inc_Input_Vpic>;
  _set?: InputMaybe<Element_Set_Input_Vpic>;
  pk_columns: Element_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Element_ManyArgs = {
  updates: Array<Element_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_EngineConfigurationArgs = {
  _inc?: InputMaybe<EngineConfiguration_Inc_Input_Vpic>;
  _set?: InputMaybe<EngineConfiguration_Set_Input_Vpic>;
  where: EngineConfiguration_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_EngineConfiguration_By_PkArgs = {
  _inc?: InputMaybe<EngineConfiguration_Inc_Input_Vpic>;
  _set?: InputMaybe<EngineConfiguration_Set_Input_Vpic>;
  pk_columns: EngineConfiguration_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_EngineConfiguration_ManyArgs = {
  updates: Array<EngineConfiguration_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_EngineModelArgs = {
  _inc?: InputMaybe<EngineModel_Inc_Input_Vpic>;
  _set?: InputMaybe<EngineModel_Set_Input_Vpic>;
  where: EngineModel_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_EngineModelPatternArgs = {
  _inc?: InputMaybe<EngineModelPattern_Inc_Input_Vpic>;
  _set?: InputMaybe<EngineModelPattern_Set_Input_Vpic>;
  where: EngineModelPattern_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_EngineModelPattern_By_PkArgs = {
  _inc?: InputMaybe<EngineModelPattern_Inc_Input_Vpic>;
  _set?: InputMaybe<EngineModelPattern_Set_Input_Vpic>;
  pk_columns: EngineModelPattern_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_EngineModelPattern_ManyArgs = {
  updates: Array<EngineModelPattern_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_EngineModel_By_PkArgs = {
  _inc?: InputMaybe<EngineModel_Inc_Input_Vpic>;
  _set?: InputMaybe<EngineModel_Set_Input_Vpic>;
  pk_columns: EngineModel_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_EngineModel_ManyArgs = {
  updates: Array<EngineModel_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_EntertainmentSystemArgs = {
  _inc?: InputMaybe<EntertainmentSystem_Inc_Input_Vpic>;
  _set?: InputMaybe<EntertainmentSystem_Set_Input_Vpic>;
  where: EntertainmentSystem_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_EntertainmentSystem_By_PkArgs = {
  _inc?: InputMaybe<EntertainmentSystem_Inc_Input_Vpic>;
  _set?: InputMaybe<EntertainmentSystem_Set_Input_Vpic>;
  pk_columns: EntertainmentSystem_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_EntertainmentSystem_ManyArgs = {
  updates: Array<EntertainmentSystem_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_ErrorCodeArgs = {
  _inc?: InputMaybe<ErrorCode_Inc_Input_Vpic>;
  _set?: InputMaybe<ErrorCode_Set_Input_Vpic>;
  where: ErrorCode_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ErrorCode_By_PkArgs = {
  _inc?: InputMaybe<ErrorCode_Inc_Input_Vpic>;
  _set?: InputMaybe<ErrorCode_Set_Input_Vpic>;
  pk_columns: ErrorCode_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ErrorCode_ManyArgs = {
  updates: Array<ErrorCode_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_ForwardCollisionWarningArgs = {
  _inc?: InputMaybe<ForwardCollisionWarning_Inc_Input_Vpic>;
  _set?: InputMaybe<ForwardCollisionWarning_Set_Input_Vpic>;
  where: ForwardCollisionWarning_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ForwardCollisionWarning_By_PkArgs = {
  _inc?: InputMaybe<ForwardCollisionWarning_Inc_Input_Vpic>;
  _set?: InputMaybe<ForwardCollisionWarning_Set_Input_Vpic>;
  pk_columns: ForwardCollisionWarning_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ForwardCollisionWarning_ManyArgs = {
  updates: Array<ForwardCollisionWarning_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_FuelDeliveryTypeArgs = {
  _inc?: InputMaybe<FuelDeliveryType_Inc_Input_Vpic>;
  _set?: InputMaybe<FuelDeliveryType_Set_Input_Vpic>;
  where: FuelDeliveryType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_FuelDeliveryType_By_PkArgs = {
  _inc?: InputMaybe<FuelDeliveryType_Inc_Input_Vpic>;
  _set?: InputMaybe<FuelDeliveryType_Set_Input_Vpic>;
  pk_columns: FuelDeliveryType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_FuelDeliveryType_ManyArgs = {
  updates: Array<FuelDeliveryType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_FuelTankMaterialArgs = {
  _inc?: InputMaybe<FuelTankMaterial_Inc_Input_Vpic>;
  _set?: InputMaybe<FuelTankMaterial_Set_Input_Vpic>;
  where: FuelTankMaterial_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_FuelTankMaterial_By_PkArgs = {
  _inc?: InputMaybe<FuelTankMaterial_Inc_Input_Vpic>;
  _set?: InputMaybe<FuelTankMaterial_Set_Input_Vpic>;
  pk_columns: FuelTankMaterial_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_FuelTankMaterial_ManyArgs = {
  updates: Array<FuelTankMaterial_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_FuelTankTypeArgs = {
  _inc?: InputMaybe<FuelTankType_Inc_Input_Vpic>;
  _set?: InputMaybe<FuelTankType_Set_Input_Vpic>;
  where: FuelTankType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_FuelTankType_By_PkArgs = {
  _inc?: InputMaybe<FuelTankType_Inc_Input_Vpic>;
  _set?: InputMaybe<FuelTankType_Set_Input_Vpic>;
  pk_columns: FuelTankType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_FuelTankType_ManyArgs = {
  updates: Array<FuelTankType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_FuelTypeArgs = {
  _inc?: InputMaybe<FuelType_Inc_Input_Vpic>;
  _set?: InputMaybe<FuelType_Set_Input_Vpic>;
  where: FuelType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_FuelType_By_PkArgs = {
  _inc?: InputMaybe<FuelType_Inc_Input_Vpic>;
  _set?: InputMaybe<FuelType_Set_Input_Vpic>;
  pk_columns: FuelType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_FuelType_ManyArgs = {
  updates: Array<FuelType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_GrossVehicleWeightRatingArgs = {
  _inc?: InputMaybe<GrossVehicleWeightRating_Inc_Input_Vpic>;
  _set?: InputMaybe<GrossVehicleWeightRating_Set_Input_Vpic>;
  where: GrossVehicleWeightRating_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_GrossVehicleWeightRating_By_PkArgs = {
  _inc?: InputMaybe<GrossVehicleWeightRating_Inc_Input_Vpic>;
  _set?: InputMaybe<GrossVehicleWeightRating_Set_Input_Vpic>;
  pk_columns: GrossVehicleWeightRating_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_GrossVehicleWeightRating_ManyArgs = {
  updates: Array<GrossVehicleWeightRating_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_KeylessIgnitionArgs = {
  _inc?: InputMaybe<KeylessIgnition_Inc_Input_Vpic>;
  _set?: InputMaybe<KeylessIgnition_Set_Input_Vpic>;
  where: KeylessIgnition_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_KeylessIgnition_By_PkArgs = {
  _inc?: InputMaybe<KeylessIgnition_Inc_Input_Vpic>;
  _set?: InputMaybe<KeylessIgnition_Set_Input_Vpic>;
  pk_columns: KeylessIgnition_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_KeylessIgnition_ManyArgs = {
  updates: Array<KeylessIgnition_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_LaneCenteringAssistanceArgs = {
  _inc?: InputMaybe<LaneCenteringAssistance_Inc_Input_Vpic>;
  _set?: InputMaybe<LaneCenteringAssistance_Set_Input_Vpic>;
  where: LaneCenteringAssistance_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_LaneCenteringAssistance_By_PkArgs = {
  _inc?: InputMaybe<LaneCenteringAssistance_Inc_Input_Vpic>;
  _set?: InputMaybe<LaneCenteringAssistance_Set_Input_Vpic>;
  pk_columns: LaneCenteringAssistance_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_LaneCenteringAssistance_ManyArgs = {
  updates: Array<LaneCenteringAssistance_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_LaneDepartureWarningArgs = {
  _inc?: InputMaybe<LaneDepartureWarning_Inc_Input_Vpic>;
  _set?: InputMaybe<LaneDepartureWarning_Set_Input_Vpic>;
  where: LaneDepartureWarning_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_LaneDepartureWarning_By_PkArgs = {
  _inc?: InputMaybe<LaneDepartureWarning_Inc_Input_Vpic>;
  _set?: InputMaybe<LaneDepartureWarning_Set_Input_Vpic>;
  pk_columns: LaneDepartureWarning_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_LaneDepartureWarning_ManyArgs = {
  updates: Array<LaneDepartureWarning_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_LaneKeepSystemArgs = {
  _inc?: InputMaybe<LaneKeepSystem_Inc_Input_Vpic>;
  _set?: InputMaybe<LaneKeepSystem_Set_Input_Vpic>;
  where: LaneKeepSystem_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_LaneKeepSystem_By_PkArgs = {
  _inc?: InputMaybe<LaneKeepSystem_Inc_Input_Vpic>;
  _set?: InputMaybe<LaneKeepSystem_Set_Input_Vpic>;
  pk_columns: LaneKeepSystem_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_LaneKeepSystem_ManyArgs = {
  updates: Array<LaneKeepSystem_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_LowerBeamHeadlampLightSourceArgs = {
  _inc?: InputMaybe<LowerBeamHeadlampLightSource_Inc_Input_Vpic>;
  _set?: InputMaybe<LowerBeamHeadlampLightSource_Set_Input_Vpic>;
  where: LowerBeamHeadlampLightSource_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_LowerBeamHeadlampLightSource_By_PkArgs = {
  _inc?: InputMaybe<LowerBeamHeadlampLightSource_Inc_Input_Vpic>;
  _set?: InputMaybe<LowerBeamHeadlampLightSource_Set_Input_Vpic>;
  pk_columns: LowerBeamHeadlampLightSource_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_LowerBeamHeadlampLightSource_ManyArgs = {
  updates: Array<LowerBeamHeadlampLightSource_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_MakeArgs = {
  _inc?: InputMaybe<Make_Inc_Input_Vpic>;
  _set?: InputMaybe<Make_Set_Input_Vpic>;
  where: Make_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Make_ModelArgs = {
  _inc?: InputMaybe<Make_Model_Inc_Input_Vpic>;
  _set?: InputMaybe<Make_Model_Set_Input_Vpic>;
  where: Make_Model_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Make_Model_By_PkArgs = {
  _inc?: InputMaybe<Make_Model_Inc_Input_Vpic>;
  _set?: InputMaybe<Make_Model_Set_Input_Vpic>;
  pk_columns: Make_Model_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Make_Model_ManyArgs = {
  updates: Array<Make_Model_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_Make_By_PkArgs = {
  _inc?: InputMaybe<Make_Inc_Input_Vpic>;
  _set?: InputMaybe<Make_Set_Input_Vpic>;
  pk_columns: Make_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Make_ManyArgs = {
  updates: Array<Make_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_ManufacturerArgs = {
  _inc?: InputMaybe<Manufacturer_Inc_Input_Vpic>;
  _set?: InputMaybe<Manufacturer_Set_Input_Vpic>;
  where: Manufacturer_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_MakeArgs = {
  _inc?: InputMaybe<Manufacturer_Make_Inc_Input_Vpic>;
  _set?: InputMaybe<Manufacturer_Make_Set_Input_Vpic>;
  where: Manufacturer_Make_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_Make_By_PkArgs = {
  _inc?: InputMaybe<Manufacturer_Make_Inc_Input_Vpic>;
  _set?: InputMaybe<Manufacturer_Make_Set_Input_Vpic>;
  pk_columns: Manufacturer_Make_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_Make_ManyArgs = {
  updates: Array<Manufacturer_Make_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_By_PkArgs = {
  _inc?: InputMaybe<Manufacturer_Inc_Input_Vpic>;
  _set?: InputMaybe<Manufacturer_Set_Input_Vpic>;
  pk_columns: Manufacturer_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_ManyArgs = {
  updates: Array<Manufacturer_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_ModelArgs = {
  _inc?: InputMaybe<Model_Inc_Input_Vpic>;
  _set?: InputMaybe<Model_Set_Input_Vpic>;
  where: Model_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Model_By_PkArgs = {
  _inc?: InputMaybe<Model_Inc_Input_Vpic>;
  _set?: InputMaybe<Model_Set_Input_Vpic>;
  pk_columns: Model_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Model_ManyArgs = {
  updates: Array<Model_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_MotorcycleChassisTypeArgs = {
  _inc?: InputMaybe<MotorcycleChassisType_Inc_Input_Vpic>;
  _set?: InputMaybe<MotorcycleChassisType_Set_Input_Vpic>;
  where: MotorcycleChassisType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_MotorcycleChassisType_By_PkArgs = {
  _inc?: InputMaybe<MotorcycleChassisType_Inc_Input_Vpic>;
  _set?: InputMaybe<MotorcycleChassisType_Set_Input_Vpic>;
  pk_columns: MotorcycleChassisType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_MotorcycleChassisType_ManyArgs = {
  updates: Array<MotorcycleChassisType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_MotorcycleSuspensionTypeArgs = {
  _inc?: InputMaybe<MotorcycleSuspensionType_Inc_Input_Vpic>;
  _set?: InputMaybe<MotorcycleSuspensionType_Set_Input_Vpic>;
  where: MotorcycleSuspensionType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_MotorcycleSuspensionType_By_PkArgs = {
  _inc?: InputMaybe<MotorcycleSuspensionType_Inc_Input_Vpic>;
  _set?: InputMaybe<MotorcycleSuspensionType_Set_Input_Vpic>;
  pk_columns: MotorcycleSuspensionType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_MotorcycleSuspensionType_ManyArgs = {
  updates: Array<MotorcycleSuspensionType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_NonLandUseArgs = {
  _inc?: InputMaybe<NonLandUse_Inc_Input_Vpic>;
  _set?: InputMaybe<NonLandUse_Set_Input_Vpic>;
  where: NonLandUse_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_NonLandUse_By_PkArgs = {
  _inc?: InputMaybe<NonLandUse_Inc_Input_Vpic>;
  _set?: InputMaybe<NonLandUse_Set_Input_Vpic>;
  pk_columns: NonLandUse_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_NonLandUse_ManyArgs = {
  updates: Array<NonLandUse_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_ParkAssistArgs = {
  _inc?: InputMaybe<ParkAssist_Inc_Input_Vpic>;
  _set?: InputMaybe<ParkAssist_Set_Input_Vpic>;
  where: ParkAssist_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ParkAssist_By_PkArgs = {
  _inc?: InputMaybe<ParkAssist_Inc_Input_Vpic>;
  _set?: InputMaybe<ParkAssist_Set_Input_Vpic>;
  pk_columns: ParkAssist_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ParkAssist_ManyArgs = {
  updates: Array<ParkAssist_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_PatternArgs = {
  _inc?: InputMaybe<Pattern_Inc_Input_Vpic>;
  _set?: InputMaybe<Pattern_Set_Input_Vpic>;
  where: Pattern_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Pattern_By_PkArgs = {
  _inc?: InputMaybe<Pattern_Inc_Input_Vpic>;
  _set?: InputMaybe<Pattern_Set_Input_Vpic>;
  pk_columns: Pattern_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Pattern_ManyArgs = {
  updates: Array<Pattern_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_PedestrianAutomaticEmergencyBrakingArgs = {
  _inc?: InputMaybe<PedestrianAutomaticEmergencyBraking_Inc_Input_Vpic>;
  _set?: InputMaybe<PedestrianAutomaticEmergencyBraking_Set_Input_Vpic>;
  where: PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_PedestrianAutomaticEmergencyBraking_By_PkArgs = {
  _inc?: InputMaybe<PedestrianAutomaticEmergencyBraking_Inc_Input_Vpic>;
  _set?: InputMaybe<PedestrianAutomaticEmergencyBraking_Set_Input_Vpic>;
  pk_columns: PedestrianAutomaticEmergencyBraking_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_PedestrianAutomaticEmergencyBraking_ManyArgs = {
  updates: Array<PedestrianAutomaticEmergencyBraking_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_PretensionerArgs = {
  _inc?: InputMaybe<Pretensioner_Inc_Input_Vpic>;
  _set?: InputMaybe<Pretensioner_Set_Input_Vpic>;
  where: Pretensioner_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Pretensioner_By_PkArgs = {
  _inc?: InputMaybe<Pretensioner_Inc_Input_Vpic>;
  _set?: InputMaybe<Pretensioner_Set_Input_Vpic>;
  pk_columns: Pretensioner_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Pretensioner_ManyArgs = {
  updates: Array<Pretensioner_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_RearAutomaticEmergencyBrakingArgs = {
  _inc?: InputMaybe<RearAutomaticEmergencyBraking_Inc_Input_Vpic>;
  _set?: InputMaybe<RearAutomaticEmergencyBraking_Set_Input_Vpic>;
  where: RearAutomaticEmergencyBraking_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_RearAutomaticEmergencyBraking_By_PkArgs = {
  _inc?: InputMaybe<RearAutomaticEmergencyBraking_Inc_Input_Vpic>;
  _set?: InputMaybe<RearAutomaticEmergencyBraking_Set_Input_Vpic>;
  pk_columns: RearAutomaticEmergencyBraking_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_RearAutomaticEmergencyBraking_ManyArgs = {
  updates: Array<RearAutomaticEmergencyBraking_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_RearCrossTrafficAlertArgs = {
  _inc?: InputMaybe<RearCrossTrafficAlert_Inc_Input_Vpic>;
  _set?: InputMaybe<RearCrossTrafficAlert_Set_Input_Vpic>;
  where: RearCrossTrafficAlert_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_RearCrossTrafficAlert_By_PkArgs = {
  _inc?: InputMaybe<RearCrossTrafficAlert_Inc_Input_Vpic>;
  _set?: InputMaybe<RearCrossTrafficAlert_Set_Input_Vpic>;
  pk_columns: RearCrossTrafficAlert_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_RearCrossTrafficAlert_ManyArgs = {
  updates: Array<RearCrossTrafficAlert_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_RearVisibilityCameraArgs = {
  _inc?: InputMaybe<RearVisibilityCamera_Inc_Input_Vpic>;
  _set?: InputMaybe<RearVisibilityCamera_Set_Input_Vpic>;
  where: RearVisibilityCamera_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_RearVisibilityCamera_By_PkArgs = {
  _inc?: InputMaybe<RearVisibilityCamera_Inc_Input_Vpic>;
  _set?: InputMaybe<RearVisibilityCamera_Set_Input_Vpic>;
  pk_columns: RearVisibilityCamera_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_RearVisibilityCamera_ManyArgs = {
  updates: Array<RearVisibilityCamera_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_SeatBeltsAllArgs = {
  _inc?: InputMaybe<SeatBeltsAll_Inc_Input_Vpic>;
  _set?: InputMaybe<SeatBeltsAll_Set_Input_Vpic>;
  where: SeatBeltsAll_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_SeatBeltsAll_By_PkArgs = {
  _inc?: InputMaybe<SeatBeltsAll_Inc_Input_Vpic>;
  _set?: InputMaybe<SeatBeltsAll_Set_Input_Vpic>;
  pk_columns: SeatBeltsAll_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_SeatBeltsAll_ManyArgs = {
  updates: Array<SeatBeltsAll_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_SemiautomaticHeadlampBeamSwitchingArgs = {
  _inc?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Inc_Input_Vpic>;
  _set?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Set_Input_Vpic>;
  where: SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_SemiautomaticHeadlampBeamSwitching_By_PkArgs = {
  _inc?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Inc_Input_Vpic>;
  _set?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Set_Input_Vpic>;
  pk_columns: SemiautomaticHeadlampBeamSwitching_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_SemiautomaticHeadlampBeamSwitching_ManyArgs = {
  updates: Array<SemiautomaticHeadlampBeamSwitching_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_SteeringArgs = {
  _inc?: InputMaybe<Steering_Inc_Input_Vpic>;
  _set?: InputMaybe<Steering_Set_Input_Vpic>;
  where: Steering_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Steering_By_PkArgs = {
  _inc?: InputMaybe<Steering_Inc_Input_Vpic>;
  _set?: InputMaybe<Steering_Set_Input_Vpic>;
  pk_columns: Steering_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Steering_ManyArgs = {
  updates: Array<Steering_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_TpmsArgs = {
  _inc?: InputMaybe<Tpms_Inc_Input_Vpic>;
  _set?: InputMaybe<Tpms_Set_Input_Vpic>;
  where: Tpms_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Tpms_By_PkArgs = {
  _inc?: InputMaybe<Tpms_Inc_Input_Vpic>;
  _set?: InputMaybe<Tpms_Set_Input_Vpic>;
  pk_columns: Tpms_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Tpms_ManyArgs = {
  updates: Array<Tpms_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_TractionControlArgs = {
  _inc?: InputMaybe<TractionControl_Inc_Input_Vpic>;
  _set?: InputMaybe<TractionControl_Set_Input_Vpic>;
  where: TractionControl_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_TractionControl_By_PkArgs = {
  _inc?: InputMaybe<TractionControl_Inc_Input_Vpic>;
  _set?: InputMaybe<TractionControl_Set_Input_Vpic>;
  pk_columns: TractionControl_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_TractionControl_ManyArgs = {
  updates: Array<TractionControl_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_TrailerBodyTypeArgs = {
  _inc?: InputMaybe<TrailerBodyType_Inc_Input_Vpic>;
  _set?: InputMaybe<TrailerBodyType_Set_Input_Vpic>;
  where: TrailerBodyType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_TrailerBodyType_By_PkArgs = {
  _inc?: InputMaybe<TrailerBodyType_Inc_Input_Vpic>;
  _set?: InputMaybe<TrailerBodyType_Set_Input_Vpic>;
  pk_columns: TrailerBodyType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_TrailerBodyType_ManyArgs = {
  updates: Array<TrailerBodyType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_TrailerTypeArgs = {
  _inc?: InputMaybe<TrailerType_Inc_Input_Vpic>;
  _set?: InputMaybe<TrailerType_Set_Input_Vpic>;
  where: TrailerType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_TrailerType_By_PkArgs = {
  _inc?: InputMaybe<TrailerType_Inc_Input_Vpic>;
  _set?: InputMaybe<TrailerType_Set_Input_Vpic>;
  pk_columns: TrailerType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_TrailerType_ManyArgs = {
  updates: Array<TrailerType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_TransmissionArgs = {
  _inc?: InputMaybe<Transmission_Inc_Input_Vpic>;
  _set?: InputMaybe<Transmission_Set_Input_Vpic>;
  where: Transmission_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Transmission_By_PkArgs = {
  _inc?: InputMaybe<Transmission_Inc_Input_Vpic>;
  _set?: InputMaybe<Transmission_Set_Input_Vpic>;
  pk_columns: Transmission_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Transmission_ManyArgs = {
  updates: Array<Transmission_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_TurboArgs = {
  _inc?: InputMaybe<Turbo_Inc_Input_Vpic>;
  _set?: InputMaybe<Turbo_Set_Input_Vpic>;
  where: Turbo_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Turbo_By_PkArgs = {
  _inc?: InputMaybe<Turbo_Inc_Input_Vpic>;
  _set?: InputMaybe<Turbo_Set_Input_Vpic>;
  pk_columns: Turbo_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Turbo_ManyArgs = {
  updates: Array<Turbo_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_VSpecSchemaPatternArgs = {
  _inc?: InputMaybe<VSpecSchemaPattern_Inc_Input_Vpic>;
  _set?: InputMaybe<VSpecSchemaPattern_Set_Input_Vpic>;
  where: VSpecSchemaPattern_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VSpecSchemaPattern_By_PkArgs = {
  _inc?: InputMaybe<VSpecSchemaPattern_Inc_Input_Vpic>;
  _set?: InputMaybe<VSpecSchemaPattern_Set_Input_Vpic>;
  pk_columns: VSpecSchemaPattern_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VSpecSchemaPattern_ManyArgs = {
  updates: Array<VSpecSchemaPattern_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_ValvetrainDesignArgs = {
  _inc?: InputMaybe<ValvetrainDesign_Inc_Input_Vpic>;
  _set?: InputMaybe<ValvetrainDesign_Set_Input_Vpic>;
  where: ValvetrainDesign_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ValvetrainDesign_By_PkArgs = {
  _inc?: InputMaybe<ValvetrainDesign_Inc_Input_Vpic>;
  _set?: InputMaybe<ValvetrainDesign_Set_Input_Vpic>;
  pk_columns: ValvetrainDesign_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_ValvetrainDesign_ManyArgs = {
  updates: Array<ValvetrainDesign_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecPatternArgs = {
  _inc?: InputMaybe<VehicleSpecPattern_Inc_Input_Vpic>;
  _set?: InputMaybe<VehicleSpecPattern_Set_Input_Vpic>;
  where: VehicleSpecPattern_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecPattern_By_PkArgs = {
  _inc?: InputMaybe<VehicleSpecPattern_Inc_Input_Vpic>;
  _set?: InputMaybe<VehicleSpecPattern_Set_Input_Vpic>;
  pk_columns: VehicleSpecPattern_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecPattern_ManyArgs = {
  updates: Array<VehicleSpecPattern_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecSchemaArgs = {
  _inc?: InputMaybe<VehicleSpecSchema_Inc_Input_Vpic>;
  _set?: InputMaybe<VehicleSpecSchema_Set_Input_Vpic>;
  where: VehicleSpecSchema_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecSchema_ModelArgs = {
  _inc?: InputMaybe<VehicleSpecSchema_Model_Inc_Input_Vpic>;
  _set?: InputMaybe<VehicleSpecSchema_Model_Set_Input_Vpic>;
  where: VehicleSpecSchema_Model_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecSchema_Model_By_PkArgs = {
  _inc?: InputMaybe<VehicleSpecSchema_Model_Inc_Input_Vpic>;
  _set?: InputMaybe<VehicleSpecSchema_Model_Set_Input_Vpic>;
  pk_columns: VehicleSpecSchema_Model_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecSchema_Model_ManyArgs = {
  updates: Array<VehicleSpecSchema_Model_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecSchema_YearArgs = {
  _inc?: InputMaybe<VehicleSpecSchema_Year_Inc_Input_Vpic>;
  _set?: InputMaybe<VehicleSpecSchema_Year_Set_Input_Vpic>;
  where: VehicleSpecSchema_Year_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecSchema_Year_By_PkArgs = {
  _inc?: InputMaybe<VehicleSpecSchema_Year_Inc_Input_Vpic>;
  _set?: InputMaybe<VehicleSpecSchema_Year_Set_Input_Vpic>;
  pk_columns: VehicleSpecSchema_Year_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecSchema_Year_ManyArgs = {
  updates: Array<VehicleSpecSchema_Year_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecSchema_By_PkArgs = {
  _inc?: InputMaybe<VehicleSpecSchema_Inc_Input_Vpic>;
  _set?: InputMaybe<VehicleSpecSchema_Set_Input_Vpic>;
  pk_columns: VehicleSpecSchema_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleSpecSchema_ManyArgs = {
  updates: Array<VehicleSpecSchema_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleTypeArgs = {
  _inc?: InputMaybe<VehicleType_Inc_Input_Vpic>;
  _set?: InputMaybe<VehicleType_Set_Input_Vpic>;
  where: VehicleType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleType_By_PkArgs = {
  _inc?: InputMaybe<VehicleType_Inc_Input_Vpic>;
  _set?: InputMaybe<VehicleType_Set_Input_Vpic>;
  pk_columns: VehicleType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleType_ManyArgs = {
  updates: Array<VehicleType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_VinDescriptorArgs = {
  _inc?: InputMaybe<VinDescriptor_Inc_Input_Vpic>;
  _set?: InputMaybe<VinDescriptor_Set_Input_Vpic>;
  where: VinDescriptor_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VinDescriptor_By_PkArgs = {
  _inc?: InputMaybe<VinDescriptor_Inc_Input_Vpic>;
  _set?: InputMaybe<VinDescriptor_Set_Input_Vpic>;
  pk_columns: VinDescriptor_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VinDescriptor_ManyArgs = {
  updates: Array<VinDescriptor_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_VinExceptionArgs = {
  _inc?: InputMaybe<VinException_Inc_Input_Vpic>;
  _set?: InputMaybe<VinException_Set_Input_Vpic>;
  where: VinException_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VinException_By_PkArgs = {
  _inc?: InputMaybe<VinException_Inc_Input_Vpic>;
  _set?: InputMaybe<VinException_Set_Input_Vpic>;
  pk_columns: VinException_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VinException_ManyArgs = {
  updates: Array<VinException_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_VinSchemaArgs = {
  _inc?: InputMaybe<VinSchema_Inc_Input_Vpic>;
  _set?: InputMaybe<VinSchema_Set_Input_Vpic>;
  where: VinSchema_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VinSchema_By_PkArgs = {
  _inc?: InputMaybe<VinSchema_Inc_Input_Vpic>;
  _set?: InputMaybe<VinSchema_Set_Input_Vpic>;
  pk_columns: VinSchema_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_VinSchema_ManyArgs = {
  updates: Array<VinSchema_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_WmiYearValidCharsArgs = {
  _inc?: InputMaybe<WmiYearValidChars_Inc_Input_Vpic>;
  _set?: InputMaybe<WmiYearValidChars_Set_Input_Vpic>;
  where: WmiYearValidChars_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_WmiYearValidChars_CacheExceptionsArgs = {
  _inc?: InputMaybe<WmiYearValidChars_CacheExceptions_Inc_Input_Vpic>;
  _set?: InputMaybe<WmiYearValidChars_CacheExceptions_Set_Input_Vpic>;
  where: WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_WmiYearValidChars_CacheExceptions_ManyArgs = {
  updates: Array<WmiYearValidChars_CacheExceptions_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_WmiYearValidChars_By_PkArgs = {
  _inc?: InputMaybe<WmiYearValidChars_Inc_Input_Vpic>;
  _set?: InputMaybe<WmiYearValidChars_Set_Input_Vpic>;
  pk_columns: WmiYearValidChars_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_WmiYearValidChars_ManyArgs = {
  updates: Array<WmiYearValidChars_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_WheelBaseTypeArgs = {
  _inc?: InputMaybe<WheelBaseType_Inc_Input_Vpic>;
  _set?: InputMaybe<WheelBaseType_Set_Input_Vpic>;
  where: WheelBaseType_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_WheelBaseType_By_PkArgs = {
  _inc?: InputMaybe<WheelBaseType_Inc_Input_Vpic>;
  _set?: InputMaybe<WheelBaseType_Set_Input_Vpic>;
  pk_columns: WheelBaseType_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_WheelBaseType_ManyArgs = {
  updates: Array<WheelBaseType_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_WheelieMitigationArgs = {
  _inc?: InputMaybe<WheelieMitigation_Inc_Input_Vpic>;
  _set?: InputMaybe<WheelieMitigation_Set_Input_Vpic>;
  where: WheelieMitigation_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_WheelieMitigation_By_PkArgs = {
  _inc?: InputMaybe<WheelieMitigation_Inc_Input_Vpic>;
  _set?: InputMaybe<WheelieMitigation_Set_Input_Vpic>;
  pk_columns: WheelieMitigation_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_WheelieMitigation_ManyArgs = {
  updates: Array<WheelieMitigation_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_WmiArgs = {
  _inc?: InputMaybe<Wmi_Inc_Input_Vpic>;
  _set?: InputMaybe<Wmi_Set_Input_Vpic>;
  where: Wmi_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Wmi_MakeArgs = {
  _inc?: InputMaybe<Wmi_Make_Inc_Input_Vpic>;
  _set?: InputMaybe<Wmi_Make_Set_Input_Vpic>;
  where: Wmi_Make_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Wmi_Make_By_PkArgs = {
  _inc?: InputMaybe<Wmi_Make_Inc_Input_Vpic>;
  _set?: InputMaybe<Wmi_Make_Set_Input_Vpic>;
  pk_columns: Wmi_Make_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Wmi_Make_ManyArgs = {
  updates: Array<Wmi_Make_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_Wmi_VinSchemaArgs = {
  _inc?: InputMaybe<Wmi_VinSchema_Inc_Input_Vpic>;
  _set?: InputMaybe<Wmi_VinSchema_Set_Input_Vpic>;
  where: Wmi_VinSchema_Bool_Exp_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Wmi_VinSchema_By_PkArgs = {
  _inc?: InputMaybe<Wmi_VinSchema_Inc_Input_Vpic>;
  _set?: InputMaybe<Wmi_VinSchema_Set_Input_Vpic>;
  pk_columns: Wmi_VinSchema_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Wmi_VinSchema_ManyArgs = {
  updates: Array<Wmi_VinSchema_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_Wmi_By_PkArgs = {
  _inc?: InputMaybe<Wmi_Inc_Input_Vpic>;
  _set?: InputMaybe<Wmi_Set_Input_Vpic>;
  pk_columns: Wmi_Pk_Columns_Input_Vpic;
};


/** mutation root */
export type Mutation_RootUpdate_Wmi_ManyArgs = {
  updates: Array<Wmi_Updates_Vpic>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountAccountManager_ManyArgs = {
  updates: Array<AccountAccountManager_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountCategory_ManyArgs = {
  updates: Array<AccountCategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountDisbursement_ManyArgs = {
  updates: Array<AccountDisbursement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountManager_ManyArgs = {
  updates: Array<AccountManager_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountProductObligor_ManyArgs = {
  updates: Array<AccountProductObligor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountProduct_ManyArgs = {
  updates: Array<AccountProduct_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountRetail_ManyArgs = {
  updates: Array<AccountRetail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountType_ManyArgs = {
  updates: Array<AccountType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Account_ManyArgs = {
  updates: Array<Account_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressType_ManyArgs = {
  updates: Array<AddressType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApprovalAuthority_ManyArgs = {
  updates: Array<ApprovalAuthority_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApprovalGateBinding_ManyArgs = {
  updates: Array<ApprovalGateBinding_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApprovalGate_ManyArgs = {
  updates: Array<ApprovalGate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApprovalRequest_ManyArgs = {
  updates: Array<ApprovalRequest_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApprovalState_ManyArgs = {
  updates: Array<ApprovalState_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Approval_ManyArgs = {
  updates: Array<Approval_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As400DataSync_ManyArgs = {
  updates: Array<As400DataSync_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Message_Formatter_ConfigArgs = {
  _append?: InputMaybe<Audit_Message_Formatter_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Audit_Message_Formatter_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Audit_Message_Formatter_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Audit_Message_Formatter_Config_Delete_Key_Input>;
  _inc?: InputMaybe<Audit_Message_Formatter_Config_Inc_Input>;
  _prepend?: InputMaybe<Audit_Message_Formatter_Config_Prepend_Input>;
  _set?: InputMaybe<Audit_Message_Formatter_Config_Set_Input>;
  where: Audit_Message_Formatter_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Message_Formatter_Config_By_PkArgs = {
  _append?: InputMaybe<Audit_Message_Formatter_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Audit_Message_Formatter_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Audit_Message_Formatter_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Audit_Message_Formatter_Config_Delete_Key_Input>;
  _inc?: InputMaybe<Audit_Message_Formatter_Config_Inc_Input>;
  _prepend?: InputMaybe<Audit_Message_Formatter_Config_Prepend_Input>;
  _set?: InputMaybe<Audit_Message_Formatter_Config_Set_Input>;
  pk_columns: Audit_Message_Formatter_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Message_Formatter_Config_ManyArgs = {
  updates: Array<Audit_Message_Formatter_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_GroupArgs = {
  _set?: InputMaybe<Auth_Group_Set_Input>;
  where: Auth_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_ActionsArgs = {
  _append?: InputMaybe<Auth_Group_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Auth_Group_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Auth_Group_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Auth_Group_Actions_Delete_Key_Input>;
  _prepend?: InputMaybe<Auth_Group_Actions_Prepend_Input>;
  _set?: InputMaybe<Auth_Group_Actions_Set_Input>;
  where: Auth_Group_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_Actions_By_PkArgs = {
  _append?: InputMaybe<Auth_Group_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Auth_Group_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Auth_Group_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Auth_Group_Actions_Delete_Key_Input>;
  _prepend?: InputMaybe<Auth_Group_Actions_Prepend_Input>;
  _set?: InputMaybe<Auth_Group_Actions_Set_Input>;
  pk_columns: Auth_Group_Actions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_Actions_ManyArgs = {
  updates: Array<Auth_Group_Actions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_By_PkArgs = {
  _set?: InputMaybe<Auth_Group_Set_Input>;
  pk_columns: Auth_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_ManyArgs = {
  updates: Array<Auth_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CaddyServerManagerLog_ManyArgs = {
  updates: Array<CaddyServerManagerLog_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Caddy_ManyArgs = {
  updates: Array<Caddy_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cancellation_ManyArgs = {
  updates: Array<Cancellation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CapabilityConfig_ManyArgs = {
  updates: Array<CapabilityConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CapabilityRoute_ManyArgs = {
  updates: Array<CapabilityRoute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Capability_ManyArgs = {
  updates: Array<Capability_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Carrier_ManyArgs = {
  updates: Array<Carrier_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CategoryProductAttributeType_ManyArgs = {
  updates: Array<CategoryProductAttributeType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Category_ManyArgs = {
  updates: Array<Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClaimDetailCategory_ManyArgs = {
  updates: Array<ClaimDetailCategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClaimStatusType_ManyArgs = {
  updates: Array<ClaimStatusType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Claim_ManyArgs = {
  updates: Array<Claim_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Claims_Pre_Authorization_Vehicle_InformationArgs = {
  _set?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Set_Input>;
  where: Claims_Pre_Authorization_Vehicle_Information_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Claims_Pre_Authorization_Vehicle_Information_By_PkArgs = {
  _set?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Set_Input>;
  pk_columns: Claims_Pre_Authorization_Vehicle_Information_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Claims_Pre_Authorization_Vehicle_Information_ManyArgs = {
  updates: Array<Claims_Pre_Authorization_Vehicle_Information_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Claims_Temp_Claims_Auth_TableArgs = {
  _append?: InputMaybe<Claims_Temp_Claims_Auth_Table_Append_Input>;
  _delete_at_path?: InputMaybe<Claims_Temp_Claims_Auth_Table_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Claims_Temp_Claims_Auth_Table_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Claims_Temp_Claims_Auth_Table_Delete_Key_Input>;
  _prepend?: InputMaybe<Claims_Temp_Claims_Auth_Table_Prepend_Input>;
  _set?: InputMaybe<Claims_Temp_Claims_Auth_Table_Set_Input>;
  where: Claims_Temp_Claims_Auth_Table_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Claims_Temp_Claims_Auth_Table_By_PkArgs = {
  _append?: InputMaybe<Claims_Temp_Claims_Auth_Table_Append_Input>;
  _delete_at_path?: InputMaybe<Claims_Temp_Claims_Auth_Table_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Claims_Temp_Claims_Auth_Table_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Claims_Temp_Claims_Auth_Table_Delete_Key_Input>;
  _prepend?: InputMaybe<Claims_Temp_Claims_Auth_Table_Prepend_Input>;
  _set?: InputMaybe<Claims_Temp_Claims_Auth_Table_Set_Input>;
  pk_columns: Claims_Temp_Claims_Auth_Table_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Claims_Temp_Claims_Auth_Table_ManyArgs = {
  updates: Array<Claims_Temp_Claims_Auth_Table_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassCriteria_ManyArgs = {
  updates: Array<ClassCriteria_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassGuideClassCriteria_ManyArgs = {
  updates: Array<ClassGuideClassCriteria_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassGuideCriteriaDefinition_ManyArgs = {
  updates: Array<ClassGuideCriteriaDefinition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassGuideCriteriaType_ManyArgs = {
  updates: Array<ClassGuideCriteriaType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassGuide_ManyArgs = {
  updates: Array<ClassGuide_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConcernSynonymArgs = {
  _set?: InputMaybe<ConcernSynonym_Set_Input_Nhtsa>;
  where: ConcernSynonym_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_ConcernSynonym_By_PkArgs = {
  _set?: InputMaybe<ConcernSynonym_Set_Input_Nhtsa>;
  pk_columns: ConcernSynonym_Pk_Columns_Input_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_ConcernSynonym_ManyArgs = {
  updates: Array<ConcernSynonym_Updates_Nhtsa>;
};


/** mutation root */
export type Mutation_RootUpdate_ConfigurationItemType_ManyArgs = {
  updates: Array<ConfigurationItemType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConfigurationItem_ManyArgs = {
  updates: Array<ConfigurationItem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_ManyArgs = {
  updates: Array<Contact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContractFormType_ManyArgs = {
  updates: Array<ContractFormType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContractStatusType_ManyArgs = {
  updates: Array<ContractStatusType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contract_ManyArgs = {
  updates: Array<Contract_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CostAdjustmentExtendedCost_ManyArgs = {
  updates: Array<CostAdjustmentExtendedCost_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CostAdjustmentLookup_ManyArgs = {
  updates: Array<CostAdjustmentLookup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CostAdjustmentType_ManyArgs = {
  updates: Array<CostAdjustmentType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CostAdjustment_ManyArgs = {
  updates: Array<CostAdjustment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CustomFieldData_ManyArgs = {
  updates: Array<CustomFieldData_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CustomFieldType_ManyArgs = {
  updates: Array<CustomFieldType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CustomField_ManyArgs = {
  updates: Array<CustomField_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_ManyArgs = {
  updates: Array<Customer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DataType_ManyArgs = {
  updates: Array<DataType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DealerPaymentType_ManyArgs = {
  updates: Array<DealerPaymentType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DisbursementType_ManyArgs = {
  updates: Array<DisbursementType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_ManyArgs = {
  updates: Array<Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EligibilityRuleDefinition_ManyArgs = {
  updates: Array<EligibilityRuleDefinition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EligibilityRule_ManyArgs = {
  updates: Array<EligibilityRule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EligibilityType_ManyArgs = {
  updates: Array<EligibilityType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityBillingInformation_ManyArgs = {
  updates: Array<EntityBillingInformation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityConfigurationItem_ManyArgs = {
  updates: Array<EntityConfigurationItem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityCustomFieldValue_ManyArgs = {
  updates: Array<EntityCustomFieldValue_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityCustomField_ManyArgs = {
  updates: Array<EntityCustomField_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityDataDefinition_ManyArgs = {
  updates: Array<EntityDataDefinition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityEligibilityRule_ManyArgs = {
  updates: Array<EntityEligibilityRule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityFileStorage_ManyArgs = {
  updates: Array<EntityFileStorage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityNote_ManyArgs = {
  updates: Array<EntityNote_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityOffering_ManyArgs = {
  updates: Array<EntityOffering_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityRemittanceDetail_ManyArgs = {
  updates: Array<EntityRemittanceDetail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityTag_ManyArgs = {
  updates: Array<EntityTag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FileStorageType_ManyArgs = {
  updates: Array<FileStorageType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FileStorage_ManyArgs = {
  updates: Array<FileStorage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IdentitiesArgs = {
  _append?: InputMaybe<Identities_Append_Input>;
  _delete_at_path?: InputMaybe<Identities_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Identities_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Identities_Delete_Key_Input>;
  _prepend?: InputMaybe<Identities_Prepend_Input>;
  _set?: InputMaybe<Identities_Set_Input>;
  where: Identities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Identities_By_PkArgs = {
  _append?: InputMaybe<Identities_Append_Input>;
  _delete_at_path?: InputMaybe<Identities_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Identities_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Identities_Delete_Key_Input>;
  _prepend?: InputMaybe<Identities_Prepend_Input>;
  _set?: InputMaybe<Identities_Set_Input>;
  pk_columns: Identities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Identities_ManyArgs = {
  updates: Array<Identities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IdentityCapabilityViewArgs = {
  _set?: InputMaybe<IdentityCapabilityView_Set_Input>;
  where: IdentityCapabilityView_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_IdentityCapabilityView_ManyArgs = {
  updates: Array<IdentityCapabilityView_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IdentityCapability_ManyArgs = {
  updates: Array<IdentityCapability_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IdentityEntity_ManyArgs = {
  updates: Array<IdentityEntity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvestigationRecallArgs = {
  _set?: InputMaybe<InvestigationRecall_Set_Input_Nhtsa>;
  where: InvestigationRecall_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_InvestigationRecall_By_PkArgs = {
  _set?: InputMaybe<InvestigationRecall_Set_Input_Nhtsa>;
  pk_columns: InvestigationRecall_Pk_Columns_Input_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_InvestigationRecall_ManyArgs = {
  updates: Array<InvestigationRecall_Updates_Nhtsa>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoiceDocumentType_ManyArgs = {
  updates: Array<InvoiceDocumentType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoicePaymentType_ManyArgs = {
  updates: Array<InvoicePaymentType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_ManyArgs = {
  updates: Array<Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IssueArgs = {
  _inc?: InputMaybe<Issue_Inc_Input_Nhtsa>;
  _set?: InputMaybe<Issue_Set_Input_Nhtsa>;
  where: Issue_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_IssueMakeModelArgs = {
  _inc?: InputMaybe<IssueMakeModel_Inc_Input_Nhtsa>;
  _set?: InputMaybe<IssueMakeModel_Set_Input_Nhtsa>;
  where: IssueMakeModel_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_IssueMakeModel_ManyArgs = {
  updates: Array<IssueMakeModel_Updates_Nhtsa>;
};


/** mutation root */
export type Mutation_RootUpdate_IssueSearchResultArgs = {
  _inc?: InputMaybe<IssueSearchResult_Inc_Input_Nhtsa>;
  _set?: InputMaybe<IssueSearchResult_Set_Input_Nhtsa>;
  where: IssueSearchResult_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_IssueSearchResult_ManyArgs = {
  updates: Array<IssueSearchResult_Updates_Nhtsa>;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_By_PkArgs = {
  _inc?: InputMaybe<Issue_Inc_Input_Nhtsa>;
  _set?: InputMaybe<Issue_Set_Input_Nhtsa>;
  pk_columns: Issue_Pk_Columns_Input_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_ManyArgs = {
  updates: Array<Issue_Updates_Nhtsa>;
};


/** mutation root */
export type Mutation_RootUpdate_LaborGuideType_ManyArgs = {
  updates: Array<LaborGuideType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Claims_Dealer_ManyArgs = {
  updates: Array<Legacy_Claims_Dealer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Claims_Note_ManyArgs = {
  updates: Array<Legacy_Claims_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LoadArgs = {
  _inc?: InputMaybe<Load_Inc_Input_Nhtsa>;
  _set?: InputMaybe<Load_Set_Input_Nhtsa>;
  where: Load_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_Load_By_PkArgs = {
  _inc?: InputMaybe<Load_Inc_Input_Nhtsa>;
  _set?: InputMaybe<Load_Set_Input_Nhtsa>;
  pk_columns: Load_Pk_Columns_Input_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_Load_ManyArgs = {
  updates: Array<Load_Updates_Nhtsa>;
};


/** mutation root */
export type Mutation_RootUpdate_LoggedAction_ManyArgs = {
  updates: Array<LoggedAction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MakeModelArgs = {
  _set?: InputMaybe<MakeModel_Set_Input_Nhtsa>;
  where: MakeModel_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_MakeModel_By_PkArgs = {
  _set?: InputMaybe<MakeModel_Set_Input_Nhtsa>;
  pk_columns: MakeModel_Pk_Columns_Input_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_MakeModel_ManyArgs = {
  updates: Array<MakeModel_Updates_Nhtsa>;
};


/** mutation root */
export type Mutation_RootUpdate_ModelYearModelArgs = {
  _inc?: InputMaybe<ModelYearModel_Inc_Input_Nhtsa>;
  _set?: InputMaybe<ModelYearModel_Set_Input_Nhtsa>;
  where: ModelYearModel_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_ModelYearModel_By_PkArgs = {
  _inc?: InputMaybe<ModelYearModel_Inc_Input_Nhtsa>;
  _set?: InputMaybe<ModelYearModel_Set_Input_Nhtsa>;
  pk_columns: ModelYearModel_Pk_Columns_Input_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_ModelYearModel_ManyArgs = {
  updates: Array<ModelYearModel_Updates_Nhtsa>;
};


/** mutation root */
export type Mutation_RootUpdate_Obligor_ManyArgs = {
  updates: Array<Obligor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ObsoleteJob_ManyArgs = {
  updates: Array<ObsoleteJob_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Legacy_Policy_Contract_Cost_Detail_ViewArgs = {
  _append?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Append_Input>;
  _delete_at_path?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Delete_Key_Input>;
  _prepend?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Prepend_Input>;
  _set?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Set_Input>;
  where: Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_Legacy_Policy_Contract_Cost_Detail_View_ManyArgs = {
  updates: Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payee_ManyArgs = {
  updates: Array<Payee_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentDetail_ManyArgs = {
  updates: Array<PaymentDetail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentStatusType_ManyArgs = {
  updates: Array<PaymentStatusType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_ManyArgs = {
  updates: Array<Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PolicyClaimConcern_ManyArgs = {
  updates: Array<PolicyClaimConcern_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PolicyContractContractFormVersion_ManyArgs = {
  updates: Array<PolicyContractContractFormVersion_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductAttributeType_ManyArgs = {
  updates: Array<ProductAttributeType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductAttribute_ManyArgs = {
  updates: Array<ProductAttribute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductClassGuide_ManyArgs = {
  updates: Array<ProductClassGuide_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductCost_ManyArgs = {
  updates: Array<ProductCost_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductDisbursement_ManyArgs = {
  updates: Array<ProductDisbursement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductEligibility_ManyArgs = {
  updates: Array<ProductEligibility_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductObligor_ManyArgs = {
  updates: Array<ProductObligor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductRateBucket_ManyArgs = {
  updates: Array<ProductRateBucket_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductSurchargeType_ManyArgs = {
  updates: Array<ProductSurchargeType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: Array<Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuoteMinimalView_ManyArgs = {
  updates: Array<QuoteMinimalView_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RateBucketType_ManyArgs = {
  updates: Array<RateBucketType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RateQuote_ManyArgs = {
  updates: Array<RateQuote_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RecordTypeArgs = {
  _inc?: InputMaybe<RecordType_Inc_Input_Nhtsa>;
  _set?: InputMaybe<RecordType_Set_Input_Nhtsa>;
  where: RecordType_Bool_Exp_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_RecordType_By_PkArgs = {
  _inc?: InputMaybe<RecordType_Inc_Input_Nhtsa>;
  _set?: InputMaybe<RecordType_Set_Input_Nhtsa>;
  pk_columns: RecordType_Pk_Columns_Input_Nhtsa;
};


/** mutation root */
export type Mutation_RootUpdate_RecordType_ManyArgs = {
  updates: Array<RecordType_Updates_Nhtsa>;
};


/** mutation root */
export type Mutation_RootUpdate_RemittancePayment_ManyArgs = {
  updates: Array<RemittancePayment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RemittanceType_ManyArgs = {
  updates: Array<RemittanceType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoleAttribute_ManyArgs = {
  updates: Array<RoleAttribute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RouteConfig_ManyArgs = {
  updates: Array<RouteConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Route_ManyArgs = {
  updates: Array<Route_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SearchIndex_ManyArgs = {
  updates: Array<SearchIndex_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shared_Search_ResultArgs = {
  _inc?: InputMaybe<Shared_Search_Result_Inc_Input>;
  _set?: InputMaybe<Shared_Search_Result_Set_Input>;
  where: Shared_Search_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shared_Search_Result_ManyArgs = {
  updates: Array<Shared_Search_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_State_ManyArgs = {
  updates: Array<State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SurchargeType_ManyArgs = {
  updates: Array<SurchargeType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_ManyArgs = {
  updates: Array<Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_ManyArgs = {
  updates: Array<Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserGroup_ManyArgs = {
  updates: Array<UserGroup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserPin_ManyArgs = {
  updates: Array<UserPin_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserProfile_ManyArgs = {
  updates: Array<UserProfile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserSession_ManyArgs = {
  updates: Array<UserSession_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ValidationLifecycleHook_ManyArgs = {
  updates: Array<ValidationLifecycleHook_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ValidationOverride_ManyArgs = {
  updates: Array<ValidationOverride_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ValidationRuleFor_ManyArgs = {
  updates: Array<ValidationRuleFor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ValidationWhen_ManyArgs = {
  updates: Array<ValidationWhen_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Validation_ManyArgs = {
  updates: Array<Validation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleClassingBodyStyleArgs = {
  _set?: InputMaybe<VehicleClassingBodyStyle_Set_Input>;
  where: VehicleClassingBodyStyle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleClassingFuelTypeArgs = {
  _set?: InputMaybe<VehicleClassingFuelType_Set_Input>;
  where: VehicleClassingFuelType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleClassingVehicleMakeArgs = {
  _set?: InputMaybe<VehicleClassingVehicleMake_Set_Input>;
  where: VehicleClassingVehicleMake_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleClassingVehicleTypeArgs = {
  _set?: InputMaybe<VehicleClassingVehicleType_Set_Input>;
  where: VehicleClassingVehicleType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_ManyArgs = {
  updates: Array<Vehicle_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VwVehicleCylindersDistinctArgs = {
  _inc?: InputMaybe<VwVehicleCylindersDistinct_Inc_Input>;
  _set?: InputMaybe<VwVehicleCylindersDistinct_Set_Input>;
  where: VwVehicleCylindersDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VwVehicleDrivingWheelsDistinctArgs = {
  _inc?: InputMaybe<VwVehicleDrivingWheelsDistinct_Inc_Input>;
  _set?: InputMaybe<VwVehicleDrivingWheelsDistinct_Set_Input>;
  where: VwVehicleDrivingWheelsDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VwVehicleFuelTypesDistinctArgs = {
  _inc?: InputMaybe<VwVehicleFuelTypesDistinct_Inc_Input>;
  _set?: InputMaybe<VwVehicleFuelTypesDistinct_Set_Input>;
  where: VwVehicleFuelTypesDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VwVehicleMakesDistinctArgs = {
  _inc?: InputMaybe<VwVehicleMakesDistinct_Inc_Input>;
  _set?: InputMaybe<VwVehicleMakesDistinct_Set_Input>;
  where: VwVehicleMakesDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VwVehicleModelsDistinctArgs = {
  _inc?: InputMaybe<VwVehicleModelsDistinct_Inc_Input>;
  _set?: InputMaybe<VwVehicleModelsDistinct_Set_Input>;
  where: VwVehicleModelsDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VwVehicleYearsDistinctArgs = {
  _inc?: InputMaybe<VwVehicleYearsDistinct_Inc_Input>;
  _set?: InputMaybe<VwVehicleYearsDistinct_Set_Input>;
  where: VwVehicleYearsDistinct_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_WorkStatusType_ManyArgs = {
  updates: Array<WorkStatusType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WorkflowStateType_ManyArgs = {
  updates: Array<WorkflowStateType_Updates>;
};

/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type Name_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['name']>;
  _gt?: InputMaybe<Scalars['name']>;
  _gte?: InputMaybe<Scalars['name']>;
  _in?: InputMaybe<Array<Scalars['name']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['name']>;
  _lte?: InputMaybe<Scalars['name']>;
  _neq?: InputMaybe<Scalars['name']>;
  _nin?: InputMaybe<Array<Scalars['name']>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "obligor" */
export type Obligor = {
  __typename?: 'obligor';
  /** An array relationship */
  accountObligors: Array<AccountObligor>;
  /** An aggregate relationship */
  accountObligors_aggregate: AccountObligor_Aggregate;
  /** An array relationship */
  accountProductObligors: Array<AccountProductObligor>;
  /** An aggregate relationship */
  accountProductObligors_aggregate: AccountProductObligor_Aggregate;
  /** An object relationship */
  address?: Maybe<Address>;
  /** The id of the one address for this obligor. The obligor address is printed on a contract. */
  addressId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  addresses: Array<Address>;
  /** An aggregate relationship */
  addresses_aggregate: Address_Aggregate;
  /** An object relationship */
  carrier?: Maybe<Carrier>;
  carrierId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  /** An object relationship */
  contact?: Maybe<Contact>;
  /** The id of the one contact for this obligor. The obligor contact is primarily used to store the phone number displayed on a contract. */
  contactId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  contacts: Array<Contact>;
  /** An aggregate relationship */
  contacts_aggregate: Contact_Aggregate;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** Only used for carrier obligor not dealer obligor */
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  /** Only used for carrier obligor not dealer obligor */
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  isDealerObligor: Scalars['Boolean'];
  licenseNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  productObligors: Array<ProductObligor>;
  /** An aggregate relationship */
  productObligors_aggregate: ProductObligor_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "obligor" */
export type ObligorAccountObligorsArgs = {
  distinct_on?: InputMaybe<Array<AccountObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountObligor_Order_By>>;
  where?: InputMaybe<AccountObligor_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorAccountObligors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountObligor_Order_By>>;
  where?: InputMaybe<AccountObligor_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorAccountProductObligorsArgs = {
  distinct_on?: InputMaybe<Array<AccountProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProductObligor_Order_By>>;
  where?: InputMaybe<AccountProductObligor_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorAccountProductObligors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProductObligor_Order_By>>;
  where?: InputMaybe<AccountProductObligor_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorContactsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorProductObligorsArgs = {
  distinct_on?: InputMaybe<Array<ProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductObligor_Order_By>>;
  where?: InputMaybe<ProductObligor_Bool_Exp>;
};


/** columns and relationships of "obligor" */
export type ObligorProductObligors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductObligor_Order_By>>;
  where?: InputMaybe<ProductObligor_Bool_Exp>;
};

/** aggregated selection of "obligor" */
export type Obligor_Aggregate = {
  __typename?: 'obligor_aggregate';
  aggregate?: Maybe<Obligor_Aggregate_Fields>;
  nodes: Array<Obligor>;
};

export type Obligor_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Obligor_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Obligor_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Obligor_Aggregate_Bool_Exp_Count>;
};

export type Obligor_Aggregate_Bool_Exp_Bool_And = {
  arguments: Obligor_Select_Column_Obligor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Obligor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Obligor_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Obligor_Select_Column_Obligor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Obligor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Obligor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Obligor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Obligor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "obligor" */
export type Obligor_Aggregate_Fields = {
  __typename?: 'obligor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Obligor_Max_Fields>;
  min?: Maybe<Obligor_Min_Fields>;
};


/** aggregate fields of "obligor" */
export type Obligor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Obligor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "obligor" */
export type Obligor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Obligor_Max_Order_By>;
  min?: InputMaybe<Obligor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "obligor" */
export type Obligor_Arr_Rel_Insert_Input = {
  data: Array<Obligor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Obligor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "obligor". All fields are combined with a logical 'AND'. */
export type Obligor_Bool_Exp = {
  _and?: InputMaybe<Array<Obligor_Bool_Exp>>;
  _not?: InputMaybe<Obligor_Bool_Exp>;
  _or?: InputMaybe<Array<Obligor_Bool_Exp>>;
  accountObligors?: InputMaybe<AccountObligor_Bool_Exp>;
  accountObligors_aggregate?: InputMaybe<AccountObligor_Aggregate_Bool_Exp>;
  accountProductObligors?: InputMaybe<AccountProductObligor_Bool_Exp>;
  accountProductObligors_aggregate?: InputMaybe<AccountProductObligor_Aggregate_Bool_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  addressId?: InputMaybe<Uuid_Comparison_Exp>;
  addresses?: InputMaybe<Address_Bool_Exp>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Bool_Exp>;
  carrier?: InputMaybe<Carrier_Bool_Exp>;
  carrierId?: InputMaybe<Uuid_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contactId?: InputMaybe<Uuid_Comparison_Exp>;
  contacts?: InputMaybe<Contact_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDealerObligor?: InputMaybe<Boolean_Comparison_Exp>;
  licenseNumber?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  productObligors?: InputMaybe<ProductObligor_Bool_Exp>;
  productObligors_aggregate?: InputMaybe<ProductObligor_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "obligor" */
export enum Obligor_Constraint {
  /** unique or primary key constraint on columns "id" */
  ObligorPkey = 'obligor_pkey'
}

/** input type for inserting data into table "obligor" */
export type Obligor_Insert_Input = {
  accountObligors?: InputMaybe<AccountObligor_Arr_Rel_Insert_Input>;
  accountProductObligors?: InputMaybe<AccountProductObligor_Arr_Rel_Insert_Input>;
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  /** The id of the one address for this obligor. The obligor address is printed on a contract. */
  addressId?: InputMaybe<Scalars['uuid']>;
  addresses?: InputMaybe<Address_Arr_Rel_Insert_Input>;
  carrier?: InputMaybe<Carrier_Obj_Rel_Insert_Input>;
  carrierId?: InputMaybe<Scalars['uuid']>;
  code?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  /** The id of the one contact for this obligor. The obligor contact is primarily used to store the phone number displayed on a contract. */
  contactId?: InputMaybe<Scalars['uuid']>;
  contacts?: InputMaybe<Contact_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** Only used for carrier obligor not dealer obligor */
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  /** Only used for carrier obligor not dealer obligor */
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDealerObligor?: InputMaybe<Scalars['Boolean']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productObligors?: InputMaybe<ProductObligor_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Obligor_Max_Fields = {
  __typename?: 'obligor_max_fields';
  /** The id of the one address for this obligor. The obligor address is printed on a contract. */
  addressId?: Maybe<Scalars['uuid']>;
  carrierId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  /** The id of the one contact for this obligor. The obligor contact is primarily used to store the phone number displayed on a contract. */
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** Only used for carrier obligor not dealer obligor */
  effectiveDate?: Maybe<Scalars['date']>;
  /** Only used for carrier obligor not dealer obligor */
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  licenseNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "obligor" */
export type Obligor_Max_Order_By = {
  /** The id of the one address for this obligor. The obligor address is printed on a contract. */
  addressId?: InputMaybe<Order_By>;
  carrierId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  /** The id of the one contact for this obligor. The obligor contact is primarily used to store the phone number displayed on a contract. */
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** Only used for carrier obligor not dealer obligor */
  effectiveDate?: InputMaybe<Order_By>;
  /** Only used for carrier obligor not dealer obligor */
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  licenseNumber?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Obligor_Min_Fields = {
  __typename?: 'obligor_min_fields';
  /** The id of the one address for this obligor. The obligor address is printed on a contract. */
  addressId?: Maybe<Scalars['uuid']>;
  carrierId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  /** The id of the one contact for this obligor. The obligor contact is primarily used to store the phone number displayed on a contract. */
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** Only used for carrier obligor not dealer obligor */
  effectiveDate?: Maybe<Scalars['date']>;
  /** Only used for carrier obligor not dealer obligor */
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  licenseNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "obligor" */
export type Obligor_Min_Order_By = {
  /** The id of the one address for this obligor. The obligor address is printed on a contract. */
  addressId?: InputMaybe<Order_By>;
  carrierId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  /** The id of the one contact for this obligor. The obligor contact is primarily used to store the phone number displayed on a contract. */
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** Only used for carrier obligor not dealer obligor */
  effectiveDate?: InputMaybe<Order_By>;
  /** Only used for carrier obligor not dealer obligor */
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  licenseNumber?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "obligor" */
export type Obligor_Mutation_Response = {
  __typename?: 'obligor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Obligor>;
};

/** input type for inserting object relation for remote table "obligor" */
export type Obligor_Obj_Rel_Insert_Input = {
  data: Obligor_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Obligor_On_Conflict>;
};

/** on_conflict condition type for table "obligor" */
export type Obligor_On_Conflict = {
  constraint: Obligor_Constraint;
  update_columns?: Array<Obligor_Update_Column>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};

/** Ordering options when selecting data from "obligor". */
export type Obligor_Order_By = {
  accountObligors_aggregate?: InputMaybe<AccountObligor_Aggregate_Order_By>;
  accountProductObligors_aggregate?: InputMaybe<AccountProductObligor_Aggregate_Order_By>;
  address?: InputMaybe<Address_Order_By>;
  addressId?: InputMaybe<Order_By>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Order_By>;
  carrier?: InputMaybe<Carrier_Order_By>;
  carrierId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contactId?: InputMaybe<Order_By>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDealerObligor?: InputMaybe<Order_By>;
  licenseNumber?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  productObligors_aggregate?: InputMaybe<ProductObligor_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: obligor */
export type Obligor_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "obligor" */
export enum Obligor_Select_Column {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  CarrierId = 'carrierId',
  /** column name */
  Code = 'code',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsDealerObligor = 'isDealerObligor',
  /** column name */
  LicenseNumber = 'licenseNumber',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "obligor_aggregate_bool_exp_bool_and_arguments_columns" columns of table "obligor" */
export enum Obligor_Select_Column_Obligor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDealerObligor = 'isDealerObligor'
}

/** select "obligor_aggregate_bool_exp_bool_or_arguments_columns" columns of table "obligor" */
export enum Obligor_Select_Column_Obligor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDealerObligor = 'isDealerObligor'
}

/** input type for updating data in table "obligor" */
export type Obligor_Set_Input = {
  /** The id of the one address for this obligor. The obligor address is printed on a contract. */
  addressId?: InputMaybe<Scalars['uuid']>;
  carrierId?: InputMaybe<Scalars['uuid']>;
  code?: InputMaybe<Scalars['String']>;
  /** The id of the one contact for this obligor. The obligor contact is primarily used to store the phone number displayed on a contract. */
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** Only used for carrier obligor not dealer obligor */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** Only used for carrier obligor not dealer obligor */
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDealerObligor?: InputMaybe<Scalars['Boolean']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "obligor" */
export type Obligor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligor_Stream_Cursor_Value_Input = {
  /** The id of the one address for this obligor. The obligor address is printed on a contract. */
  addressId?: InputMaybe<Scalars['uuid']>;
  carrierId?: InputMaybe<Scalars['uuid']>;
  code?: InputMaybe<Scalars['String']>;
  /** The id of the one contact for this obligor. The obligor contact is primarily used to store the phone number displayed on a contract. */
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** Only used for carrier obligor not dealer obligor */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** Only used for carrier obligor not dealer obligor */
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDealerObligor?: InputMaybe<Scalars['Boolean']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "obligor" */
export enum Obligor_Update_Column {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  CarrierId = 'carrierId',
  /** column name */
  Code = 'code',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsDealerObligor = 'isDealerObligor',
  /** column name */
  LicenseNumber = 'licenseNumber',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Obligor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Obligor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Obligor_Bool_Exp;
};

/** columns and relationships of "job" */
export type ObsoleteJob = {
  __typename?: 'obsoleteJob';
  claimId: Scalars['uuid'];
  comments?: Maybe<Scalars['String']>;
  componentCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  laborGuideType: LaborGuideType;
  laborGuideTypeEnumValue: Scalars['Int'];
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "job" */
export type ObsoleteJobTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "job" */
export type ObsoleteJobTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** aggregated selection of "job" */
export type ObsoleteJob_Aggregate = {
  __typename?: 'obsoleteJob_aggregate';
  aggregate?: Maybe<ObsoleteJob_Aggregate_Fields>;
  nodes: Array<ObsoleteJob>;
};

export type ObsoleteJob_Aggregate_Bool_Exp = {
  count?: InputMaybe<ObsoleteJob_Aggregate_Bool_Exp_Count>;
};

export type ObsoleteJob_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ObsoleteJob_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ObsoleteJob_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job" */
export type ObsoleteJob_Aggregate_Fields = {
  __typename?: 'obsoleteJob_aggregate_fields';
  avg?: Maybe<ObsoleteJob_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ObsoleteJob_Max_Fields>;
  min?: Maybe<ObsoleteJob_Min_Fields>;
  stddev?: Maybe<ObsoleteJob_Stddev_Fields>;
  stddev_pop?: Maybe<ObsoleteJob_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ObsoleteJob_Stddev_Samp_Fields>;
  sum?: Maybe<ObsoleteJob_Sum_Fields>;
  var_pop?: Maybe<ObsoleteJob_Var_Pop_Fields>;
  var_samp?: Maybe<ObsoleteJob_Var_Samp_Fields>;
  variance?: Maybe<ObsoleteJob_Variance_Fields>;
};


/** aggregate fields of "job" */
export type ObsoleteJob_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ObsoleteJob_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job" */
export type ObsoleteJob_Aggregate_Order_By = {
  avg?: InputMaybe<ObsoleteJob_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ObsoleteJob_Max_Order_By>;
  min?: InputMaybe<ObsoleteJob_Min_Order_By>;
  stddev?: InputMaybe<ObsoleteJob_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ObsoleteJob_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ObsoleteJob_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ObsoleteJob_Sum_Order_By>;
  var_pop?: InputMaybe<ObsoleteJob_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ObsoleteJob_Var_Samp_Order_By>;
  variance?: InputMaybe<ObsoleteJob_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "job" */
export type ObsoleteJob_Arr_Rel_Insert_Input = {
  data: Array<ObsoleteJob_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ObsoleteJob_On_Conflict>;
};

/** aggregate avg on columns */
export type ObsoleteJob_Avg_Fields = {
  __typename?: 'obsoleteJob_avg_fields';
  laborGuideTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job" */
export type ObsoleteJob_Avg_Order_By = {
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "job". All fields are combined with a logical 'AND'. */
export type ObsoleteJob_Bool_Exp = {
  _and?: InputMaybe<Array<ObsoleteJob_Bool_Exp>>;
  _not?: InputMaybe<ObsoleteJob_Bool_Exp>;
  _or?: InputMaybe<Array<ObsoleteJob_Bool_Exp>>;
  claimId?: InputMaybe<Uuid_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  componentCode?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  laborGuideType?: InputMaybe<LaborGuideType_Bool_Exp>;
  laborGuideTypeEnumValue?: InputMaybe<Int_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "job" */
export enum ObsoleteJob_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobPkey = 'job_pkey'
}

/** input type for incrementing numeric columns in table "job" */
export type ObsoleteJob_Inc_Input = {
  laborGuideTypeEnumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "job" */
export type ObsoleteJob_Insert_Input = {
  claimId?: InputMaybe<Scalars['uuid']>;
  comments?: InputMaybe<Scalars['String']>;
  componentCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  laborGuideType?: InputMaybe<LaborGuideType_Obj_Rel_Insert_Input>;
  laborGuideTypeEnumValue?: InputMaybe<Scalars['Int']>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ObsoleteJob_Max_Fields = {
  __typename?: 'obsoleteJob_max_fields';
  claimId?: Maybe<Scalars['uuid']>;
  comments?: Maybe<Scalars['String']>;
  componentCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  laborGuideTypeEnumValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "job" */
export type ObsoleteJob_Max_Order_By = {
  claimId?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  componentCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ObsoleteJob_Min_Fields = {
  __typename?: 'obsoleteJob_min_fields';
  claimId?: Maybe<Scalars['uuid']>;
  comments?: Maybe<Scalars['String']>;
  componentCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  laborGuideTypeEnumValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "job" */
export type ObsoleteJob_Min_Order_By = {
  claimId?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  componentCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job" */
export type ObsoleteJob_Mutation_Response = {
  __typename?: 'obsoleteJob_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ObsoleteJob>;
};

/** on_conflict condition type for table "job" */
export type ObsoleteJob_On_Conflict = {
  constraint: ObsoleteJob_Constraint;
  update_columns?: Array<ObsoleteJob_Update_Column>;
  where?: InputMaybe<ObsoleteJob_Bool_Exp>;
};

/** Ordering options when selecting data from "job". */
export type ObsoleteJob_Order_By = {
  claimId?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  componentCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laborGuideType?: InputMaybe<LaborGuideType_Order_By>;
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job */
export type ObsoleteJob_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "job" */
export enum ObsoleteJob_Select_Column {
  /** column name */
  ClaimId = 'claimId',
  /** column name */
  Comments = 'comments',
  /** column name */
  ComponentCode = 'componentCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LaborGuideTypeEnumValue = 'laborGuideTypeEnumValue',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "job" */
export type ObsoleteJob_Set_Input = {
  claimId?: InputMaybe<Scalars['uuid']>;
  comments?: InputMaybe<Scalars['String']>;
  componentCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  laborGuideTypeEnumValue?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ObsoleteJob_Stddev_Fields = {
  __typename?: 'obsoleteJob_stddev_fields';
  laborGuideTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job" */
export type ObsoleteJob_Stddev_Order_By = {
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ObsoleteJob_Stddev_Pop_Fields = {
  __typename?: 'obsoleteJob_stddev_pop_fields';
  laborGuideTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "job" */
export type ObsoleteJob_Stddev_Pop_Order_By = {
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ObsoleteJob_Stddev_Samp_Fields = {
  __typename?: 'obsoleteJob_stddev_samp_fields';
  laborGuideTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "job" */
export type ObsoleteJob_Stddev_Samp_Order_By = {
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "obsoleteJob" */
export type ObsoleteJob_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ObsoleteJob_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ObsoleteJob_Stream_Cursor_Value_Input = {
  claimId?: InputMaybe<Scalars['uuid']>;
  comments?: InputMaybe<Scalars['String']>;
  componentCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  laborGuideTypeEnumValue?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ObsoleteJob_Sum_Fields = {
  __typename?: 'obsoleteJob_sum_fields';
  laborGuideTypeEnumValue?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "job" */
export type ObsoleteJob_Sum_Order_By = {
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
};

/** update columns of table "job" */
export enum ObsoleteJob_Update_Column {
  /** column name */
  ClaimId = 'claimId',
  /** column name */
  Comments = 'comments',
  /** column name */
  ComponentCode = 'componentCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LaborGuideTypeEnumValue = 'laborGuideTypeEnumValue',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ObsoleteJob_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ObsoleteJob_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ObsoleteJob_Set_Input>;
  /** filter the rows which have to be updated */
  where: ObsoleteJob_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ObsoleteJob_Var_Pop_Fields = {
  __typename?: 'obsoleteJob_var_pop_fields';
  laborGuideTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "job" */
export type ObsoleteJob_Var_Pop_Order_By = {
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ObsoleteJob_Var_Samp_Fields = {
  __typename?: 'obsoleteJob_var_samp_fields';
  laborGuideTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "job" */
export type ObsoleteJob_Var_Samp_Order_By = {
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ObsoleteJob_Variance_Fields = {
  __typename?: 'obsoleteJob_variance_fields';
  laborGuideTypeEnumValue?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job" */
export type ObsoleteJob_Variance_Order_By = {
  laborGuideTypeEnumValue?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "oid". All fields are combined with logical 'AND'. */
export type Oid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['oid']>;
  _gt?: InputMaybe<Scalars['oid']>;
  _gte?: InputMaybe<Scalars['oid']>;
  _in?: InputMaybe<Array<Scalars['oid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['oid']>;
  _lte?: InputMaybe<Scalars['oid']>;
  _neq?: InputMaybe<Scalars['oid']>;
  _nin?: InputMaybe<Array<Scalars['oid']>>;
};

/** columns and relationships of "operations.legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View = {
  __typename?: 'operations_legacy_policy_contract_cost_detail_view';
  bucketMetadata?: Maybe<Scalars['jsonb']>;
  customerCost?: Maybe<Scalars['String']>;
  dealerCost?: Maybe<Scalars['String']>;
  dealerRemitAmount?: Maybe<Scalars['String']>;
  disbursementMetadata?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['String']>;
  retailAmount?: Maybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_ViewBucketMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_ViewDisbursementMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "operations.legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Aggregate = {
  __typename?: 'operations_legacy_policy_contract_cost_detail_view_aggregate';
  aggregate?: Maybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Aggregate_Fields>;
  nodes: Array<Operations_Legacy_Policy_Contract_Cost_Detail_View>;
};

/** aggregate fields of "operations.legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Aggregate_Fields = {
  __typename?: 'operations_legacy_policy_contract_cost_detail_view_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Max_Fields>;
  min?: Maybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Min_Fields>;
};


/** aggregate fields of "operations.legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Append_Input = {
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "operations.legacy_policy_contract_cost_detail_view". All fields are combined with a logical 'AND'. */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp>>;
  _not?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp>>;
  bucketMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  customerCost?: InputMaybe<String_Comparison_Exp>;
  dealerCost?: InputMaybe<String_Comparison_Exp>;
  dealerRemitAmount?: InputMaybe<String_Comparison_Exp>;
  disbursementMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  remittanceCostMarkupAmount?: InputMaybe<String_Comparison_Exp>;
  retailAmount?: InputMaybe<String_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Delete_At_Path_Input = {
  bucketMetadata?: InputMaybe<Array<Scalars['String']>>;
  disbursementMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Delete_Elem_Input = {
  bucketMetadata?: InputMaybe<Scalars['Int']>;
  disbursementMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Delete_Key_Input = {
  bucketMetadata?: InputMaybe<Scalars['String']>;
  disbursementMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "operations.legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Insert_Input = {
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  customerCost?: InputMaybe<Scalars['String']>;
  dealerCost?: InputMaybe<Scalars['String']>;
  dealerRemitAmount?: InputMaybe<Scalars['String']>;
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: InputMaybe<Scalars['String']>;
  retailAmount?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Max_Fields = {
  __typename?: 'operations_legacy_policy_contract_cost_detail_view_max_fields';
  customerCost?: Maybe<Scalars['String']>;
  dealerCost?: Maybe<Scalars['String']>;
  dealerRemitAmount?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['String']>;
  retailAmount?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Min_Fields = {
  __typename?: 'operations_legacy_policy_contract_cost_detail_view_min_fields';
  customerCost?: Maybe<Scalars['String']>;
  dealerCost?: Maybe<Scalars['String']>;
  dealerRemitAmount?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: Maybe<Scalars['String']>;
  retailAmount?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "operations.legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Mutation_Response = {
  __typename?: 'operations_legacy_policy_contract_cost_detail_view_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations_Legacy_Policy_Contract_Cost_Detail_View>;
};

/** input type for inserting object relation for remote table "operations.legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Obj_Rel_Insert_Input = {
  data: Operations_Legacy_Policy_Contract_Cost_Detail_View_Insert_Input;
};

/** Ordering options when selecting data from "operations.legacy_policy_contract_cost_detail_view". */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Order_By = {
  bucketMetadata?: InputMaybe<Order_By>;
  customerCost?: InputMaybe<Order_By>;
  dealerCost?: InputMaybe<Order_By>;
  dealerRemitAmount?: InputMaybe<Order_By>;
  disbursementMetadata?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remittanceCostMarkupAmount?: InputMaybe<Order_By>;
  retailAmount?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Prepend_Input = {
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "operations.legacy_policy_contract_cost_detail_view" */
export enum Operations_Legacy_Policy_Contract_Cost_Detail_View_Select_Column {
  /** column name */
  BucketMetadata = 'bucketMetadata',
  /** column name */
  CustomerCost = 'customerCost',
  /** column name */
  DealerCost = 'dealerCost',
  /** column name */
  DealerRemitAmount = 'dealerRemitAmount',
  /** column name */
  DisbursementMetadata = 'disbursementMetadata',
  /** column name */
  Id = 'id',
  /** column name */
  RemittanceCostMarkupAmount = 'remittanceCostMarkupAmount',
  /** column name */
  RetailAmount = 'retailAmount'
}

/** input type for updating data in table "operations.legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Set_Input = {
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  customerCost?: InputMaybe<Scalars['String']>;
  dealerCost?: InputMaybe<Scalars['String']>;
  dealerRemitAmount?: InputMaybe<Scalars['String']>;
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: InputMaybe<Scalars['String']>;
  retailAmount?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "operations_legacy_policy_contract_cost_detail_view" */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Legacy_Policy_Contract_Cost_Detail_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Stream_Cursor_Value_Input = {
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  customerCost?: InputMaybe<Scalars['String']>;
  dealerCost?: InputMaybe<Scalars['String']>;
  dealerRemitAmount?: InputMaybe<Scalars['String']>;
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  remittanceCostMarkupAmount?: InputMaybe<Scalars['String']>;
  retailAmount?: InputMaybe<Scalars['String']>;
};

export type Operations_Legacy_Policy_Contract_Cost_Detail_View_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Set_Input>;
  /** filter the rows which have to be updated */
  where: Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp;
};

/** columns and relationships of "operations.legacy_policy_contract_list_materialized_view" */
export type Operations_Legacy_Policy_Contract_List_Materialized_View = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view';
  account_code?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  category_code?: Maybe<Scalars['String']>;
  contract_master_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  is_legacy?: Maybe<Scalars['Boolean']>;
  make_name?: Maybe<Scalars['String']>;
  model_name?: Maybe<Scalars['String']>;
  policy_contract_number?: Maybe<Scalars['String']>;
  policy_contract_owner_names?: Maybe<Scalars['String']>;
  policy_contract_status_type_name?: Maybe<Scalars['String']>;
  purchase_date?: Maybe<Scalars['date']>;
  vehicle_year?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

/** aggregated selection of "operations.legacy_policy_contract_list_materialized_view" */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Aggregate = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_aggregate';
  aggregate?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Aggregate_Fields>;
  nodes: Array<Operations_Legacy_Policy_Contract_List_Materialized_View>;
};

/** aggregate fields of "operations.legacy_policy_contract_list_materialized_view" */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Aggregate_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_aggregate_fields';
  avg?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Max_Fields>;
  min?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Min_Fields>;
  stddev?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Sum_Fields>;
  var_pop?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Var_Samp_Fields>;
  variance?: Maybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Variance_Fields>;
};


/** aggregate fields of "operations.legacy_policy_contract_list_materialized_view" */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Avg_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_avg_fields';
  contract_master_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.legacy_policy_contract_list_materialized_view". All fields are combined with a logical 'AND'. */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Bool_Exp>>;
  _not?: InputMaybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Bool_Exp>>;
  account_code?: InputMaybe<String_Comparison_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  category_code?: InputMaybe<String_Comparison_Exp>;
  contract_master_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_legacy?: InputMaybe<Boolean_Comparison_Exp>;
  make_name?: InputMaybe<String_Comparison_Exp>;
  model_name?: InputMaybe<String_Comparison_Exp>;
  policy_contract_number?: InputMaybe<String_Comparison_Exp>;
  policy_contract_owner_names?: InputMaybe<String_Comparison_Exp>;
  policy_contract_status_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_date?: InputMaybe<Date_Comparison_Exp>;
  vehicle_year?: InputMaybe<String_Comparison_Exp>;
  vin?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Max_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_max_fields';
  account_code?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  category_code?: Maybe<Scalars['String']>;
  contract_master_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  make_name?: Maybe<Scalars['String']>;
  model_name?: Maybe<Scalars['String']>;
  policy_contract_number?: Maybe<Scalars['String']>;
  policy_contract_owner_names?: Maybe<Scalars['String']>;
  policy_contract_status_type_name?: Maybe<Scalars['String']>;
  purchase_date?: Maybe<Scalars['date']>;
  vehicle_year?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Min_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_min_fields';
  account_code?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  category_code?: Maybe<Scalars['String']>;
  contract_master_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  make_name?: Maybe<Scalars['String']>;
  model_name?: Maybe<Scalars['String']>;
  policy_contract_number?: Maybe<Scalars['String']>;
  policy_contract_owner_names?: Maybe<Scalars['String']>;
  policy_contract_status_type_name?: Maybe<Scalars['String']>;
  purchase_date?: Maybe<Scalars['date']>;
  vehicle_year?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "operations.legacy_policy_contract_list_materialized_view". */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Order_By = {
  account_code?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  category_code?: InputMaybe<Order_By>;
  contract_master_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_legacy?: InputMaybe<Order_By>;
  make_name?: InputMaybe<Order_By>;
  model_name?: InputMaybe<Order_By>;
  policy_contract_number?: InputMaybe<Order_By>;
  policy_contract_owner_names?: InputMaybe<Order_By>;
  policy_contract_status_type_name?: InputMaybe<Order_By>;
  purchase_date?: InputMaybe<Order_By>;
  vehicle_year?: InputMaybe<Order_By>;
  vin?: InputMaybe<Order_By>;
};

/** select columns of table "operations.legacy_policy_contract_list_materialized_view" */
export enum Operations_Legacy_Policy_Contract_List_Materialized_View_Select_Column {
  /** column name */
  AccountCode = 'account_code',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  CategoryCode = 'category_code',
  /** column name */
  ContractMasterId = 'contract_master_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsLegacy = 'is_legacy',
  /** column name */
  MakeName = 'make_name',
  /** column name */
  ModelName = 'model_name',
  /** column name */
  PolicyContractNumber = 'policy_contract_number',
  /** column name */
  PolicyContractOwnerNames = 'policy_contract_owner_names',
  /** column name */
  PolicyContractStatusTypeName = 'policy_contract_status_type_name',
  /** column name */
  PurchaseDate = 'purchase_date',
  /** column name */
  VehicleYear = 'vehicle_year',
  /** column name */
  Vin = 'vin'
}

/** aggregate stddev on columns */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Stddev_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_stddev_fields';
  contract_master_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Stddev_Pop_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_stddev_pop_fields';
  contract_master_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Stddev_Samp_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_stddev_samp_fields';
  contract_master_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "operations_legacy_policy_contract_list_materialized_view" */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Legacy_Policy_Contract_List_Materialized_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Stream_Cursor_Value_Input = {
  account_code?: InputMaybe<Scalars['String']>;
  account_name?: InputMaybe<Scalars['String']>;
  category_code?: InputMaybe<Scalars['String']>;
  contract_master_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_legacy?: InputMaybe<Scalars['Boolean']>;
  make_name?: InputMaybe<Scalars['String']>;
  model_name?: InputMaybe<Scalars['String']>;
  policy_contract_number?: InputMaybe<Scalars['String']>;
  policy_contract_owner_names?: InputMaybe<Scalars['String']>;
  policy_contract_status_type_name?: InputMaybe<Scalars['String']>;
  purchase_date?: InputMaybe<Scalars['date']>;
  vehicle_year?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Sum_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_sum_fields';
  contract_master_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Var_Pop_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_var_pop_fields';
  contract_master_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Var_Samp_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_var_samp_fields';
  contract_master_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Operations_Legacy_Policy_Contract_List_Materialized_View_Variance_Fields = {
  __typename?: 'operations_legacy_policy_contract_list_materialized_view_variance_fields';
  contract_master_id?: Maybe<Scalars['Float']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Transactional outbox for message broker */
export type OutboxEvent = {
  __typename?: 'outboxEvent';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isPublished: Scalars['Boolean'];
  lastError?: Maybe<Scalars['String']>;
  nextRetry: Scalars['timestamptz'];
  payload: Scalars['jsonb'];
  published_at?: Maybe<Scalars['timestamptz']>;
  retryCount: Scalars['Int'];
  topic: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** Transactional outbox for message broker */
export type OutboxEventPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "system.outbox_event" */
export type OutboxEvent_Aggregate = {
  __typename?: 'outboxEvent_aggregate';
  aggregate?: Maybe<OutboxEvent_Aggregate_Fields>;
  nodes: Array<OutboxEvent>;
};

/** aggregate fields of "system.outbox_event" */
export type OutboxEvent_Aggregate_Fields = {
  __typename?: 'outboxEvent_aggregate_fields';
  avg?: Maybe<OutboxEvent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<OutboxEvent_Max_Fields>;
  min?: Maybe<OutboxEvent_Min_Fields>;
  stddev?: Maybe<OutboxEvent_Stddev_Fields>;
  stddev_pop?: Maybe<OutboxEvent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<OutboxEvent_Stddev_Samp_Fields>;
  sum?: Maybe<OutboxEvent_Sum_Fields>;
  var_pop?: Maybe<OutboxEvent_Var_Pop_Fields>;
  var_samp?: Maybe<OutboxEvent_Var_Samp_Fields>;
  variance?: Maybe<OutboxEvent_Variance_Fields>;
};


/** aggregate fields of "system.outbox_event" */
export type OutboxEvent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<OutboxEvent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type OutboxEvent_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type OutboxEvent_Avg_Fields = {
  __typename?: 'outboxEvent_avg_fields';
  retryCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "system.outbox_event". All fields are combined with a logical 'AND'. */
export type OutboxEvent_Bool_Exp = {
  _and?: InputMaybe<Array<OutboxEvent_Bool_Exp>>;
  _not?: InputMaybe<OutboxEvent_Bool_Exp>;
  _or?: InputMaybe<Array<OutboxEvent_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isPublished?: InputMaybe<Boolean_Comparison_Exp>;
  lastError?: InputMaybe<String_Comparison_Exp>;
  nextRetry?: InputMaybe<Timestamptz_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  retryCount?: InputMaybe<Int_Comparison_Exp>;
  topic?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.outbox_event" */
export enum OutboxEvent_Constraint {
  /** unique or primary key constraint on columns "id" */
  OutboxEventPkey = 'outbox_event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type OutboxEvent_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type OutboxEvent_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type OutboxEvent_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "system.outbox_event" */
export type OutboxEvent_Inc_Input = {
  retryCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "system.outbox_event" */
export type OutboxEvent_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  lastError?: InputMaybe<Scalars['String']>;
  nextRetry?: InputMaybe<Scalars['timestamptz']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  retryCount?: InputMaybe<Scalars['Int']>;
  topic?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type OutboxEvent_Max_Fields = {
  __typename?: 'outboxEvent_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastError?: Maybe<Scalars['String']>;
  nextRetry?: Maybe<Scalars['timestamptz']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  retryCount?: Maybe<Scalars['Int']>;
  topic?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type OutboxEvent_Min_Fields = {
  __typename?: 'outboxEvent_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastError?: Maybe<Scalars['String']>;
  nextRetry?: Maybe<Scalars['timestamptz']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  retryCount?: Maybe<Scalars['Int']>;
  topic?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "system.outbox_event" */
export type OutboxEvent_Mutation_Response = {
  __typename?: 'outboxEvent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OutboxEvent>;
};

/** on_conflict condition type for table "system.outbox_event" */
export type OutboxEvent_On_Conflict = {
  constraint: OutboxEvent_Constraint;
  update_columns?: Array<OutboxEvent_Update_Column>;
  where?: InputMaybe<OutboxEvent_Bool_Exp>;
};

/** Ordering options when selecting data from "system.outbox_event". */
export type OutboxEvent_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPublished?: InputMaybe<Order_By>;
  lastError?: InputMaybe<Order_By>;
  nextRetry?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  retryCount?: InputMaybe<Order_By>;
  topic?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.outbox_event */
export type OutboxEvent_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type OutboxEvent_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "system.outbox_event" */
export enum OutboxEvent_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  LastError = 'lastError',
  /** column name */
  NextRetry = 'nextRetry',
  /** column name */
  Payload = 'payload',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  RetryCount = 'retryCount',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "system.outbox_event" */
export type OutboxEvent_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  lastError?: InputMaybe<Scalars['String']>;
  nextRetry?: InputMaybe<Scalars['timestamptz']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  retryCount?: InputMaybe<Scalars['Int']>;
  topic?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type OutboxEvent_Stddev_Fields = {
  __typename?: 'outboxEvent_stddev_fields';
  retryCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type OutboxEvent_Stddev_Pop_Fields = {
  __typename?: 'outboxEvent_stddev_pop_fields';
  retryCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type OutboxEvent_Stddev_Samp_Fields = {
  __typename?: 'outboxEvent_stddev_samp_fields';
  retryCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "outboxEvent" */
export type OutboxEvent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: OutboxEvent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type OutboxEvent_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  lastError?: InputMaybe<Scalars['String']>;
  nextRetry?: InputMaybe<Scalars['timestamptz']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  retryCount?: InputMaybe<Scalars['Int']>;
  topic?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type OutboxEvent_Sum_Fields = {
  __typename?: 'outboxEvent_sum_fields';
  retryCount?: Maybe<Scalars['Int']>;
};

/** update columns of table "system.outbox_event" */
export enum OutboxEvent_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  LastError = 'lastError',
  /** column name */
  NextRetry = 'nextRetry',
  /** column name */
  Payload = 'payload',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  RetryCount = 'retryCount',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type OutboxEvent_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<OutboxEvent_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<OutboxEvent_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<OutboxEvent_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<OutboxEvent_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OutboxEvent_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<OutboxEvent_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OutboxEvent_Set_Input>;
  /** filter the rows which have to be updated */
  where: OutboxEvent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type OutboxEvent_Var_Pop_Fields = {
  __typename?: 'outboxEvent_var_pop_fields';
  retryCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type OutboxEvent_Var_Samp_Fields = {
  __typename?: 'outboxEvent_var_samp_fields';
  retryCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type OutboxEvent_Variance_Fields = {
  __typename?: 'outboxEvent_variance_fields';
  retryCount?: Maybe<Scalars['Float']>;
};

/** One row per identity that has modified a tracked entity, with the time of its last touch. Populated by an AFTER INSERT OR UPDATE OR DELETE trigger on each tracked table. */
export type Participant = {
  __typename?: 'participant';
  /** An object relationship */
  claimDetail?: Maybe<ClaimDetail>;
  /** An object relationship */
  claimServiceCenter?: Maybe<ClaimServiceCenter>;
  /** An object relationship */
  identity?: Maybe<Identity>;
  /** The Ory identity that touched the row. No FK into the Ory-managed schema. */
  identityId: Scalars['uuid'];
  /** Bumped to now() on every touch (insert, update, or delete). */
  lastTouchedAt: Scalars['timestamptz'];
  /** The tracked row's id. Globally unique across tracked tables, so it identifies the entity on its own; the parent type is resolved through per-parent relationships. No FK (polymorphic). */
  parentId: Scalars['uuid'];
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
};

/** aggregated selection of "shared.participant" */
export type Participant_Aggregate = {
  __typename?: 'participant_aggregate';
  aggregate?: Maybe<Participant_Aggregate_Fields>;
  nodes: Array<Participant>;
};

export type Participant_Aggregate_Bool_Exp = {
  count?: InputMaybe<Participant_Aggregate_Bool_Exp_Count>;
};

export type Participant_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Participant_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.participant" */
export type Participant_Aggregate_Fields = {
  __typename?: 'participant_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Participant_Max_Fields>;
  min?: Maybe<Participant_Min_Fields>;
};


/** aggregate fields of "shared.participant" */
export type Participant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.participant" */
export type Participant_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Participant_Max_Order_By>;
  min?: InputMaybe<Participant_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.participant" */
export type Participant_Arr_Rel_Insert_Input = {
  data: Array<Participant_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Participant_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.participant". All fields are combined with a logical 'AND'. */
export type Participant_Bool_Exp = {
  _and?: InputMaybe<Array<Participant_Bool_Exp>>;
  _not?: InputMaybe<Participant_Bool_Exp>;
  _or?: InputMaybe<Array<Participant_Bool_Exp>>;
  claimDetail?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  lastTouchedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
};

/** unique or primary key constraints on table "shared.participant" */
export enum Participant_Constraint {
  /** unique or primary key constraint on columns "identity_id", "parent_id" */
  ParticipantPkey = 'participant_pkey'
}

/** input type for inserting data into table "shared.participant" */
export type Participant_Insert_Input = {
  claimDetail?: InputMaybe<ClaimDetail_Obj_Rel_Insert_Input>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Obj_Rel_Insert_Input>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  /** The Ory identity that touched the row. No FK into the Ory-managed schema. */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Bumped to now() on every touch (insert, update, or delete). */
  lastTouchedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The tracked row's id. Globally unique across tracked tables, so it identifies the entity on its own; the parent type is resolved through per-parent relationships. No FK (polymorphic). */
  parentId?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Participant_Max_Fields = {
  __typename?: 'participant_max_fields';
  /** The Ory identity that touched the row. No FK into the Ory-managed schema. */
  identityId?: Maybe<Scalars['uuid']>;
  /** Bumped to now() on every touch (insert, update, or delete). */
  lastTouchedAt?: Maybe<Scalars['timestamptz']>;
  /** The tracked row's id. Globally unique across tracked tables, so it identifies the entity on its own; the parent type is resolved through per-parent relationships. No FK (polymorphic). */
  parentId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "shared.participant" */
export type Participant_Max_Order_By = {
  /** The Ory identity that touched the row. No FK into the Ory-managed schema. */
  identityId?: InputMaybe<Order_By>;
  /** Bumped to now() on every touch (insert, update, or delete). */
  lastTouchedAt?: InputMaybe<Order_By>;
  /** The tracked row's id. Globally unique across tracked tables, so it identifies the entity on its own; the parent type is resolved through per-parent relationships. No FK (polymorphic). */
  parentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Participant_Min_Fields = {
  __typename?: 'participant_min_fields';
  /** The Ory identity that touched the row. No FK into the Ory-managed schema. */
  identityId?: Maybe<Scalars['uuid']>;
  /** Bumped to now() on every touch (insert, update, or delete). */
  lastTouchedAt?: Maybe<Scalars['timestamptz']>;
  /** The tracked row's id. Globally unique across tracked tables, so it identifies the entity on its own; the parent type is resolved through per-parent relationships. No FK (polymorphic). */
  parentId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "shared.participant" */
export type Participant_Min_Order_By = {
  /** The Ory identity that touched the row. No FK into the Ory-managed schema. */
  identityId?: InputMaybe<Order_By>;
  /** Bumped to now() on every touch (insert, update, or delete). */
  lastTouchedAt?: InputMaybe<Order_By>;
  /** The tracked row's id. Globally unique across tracked tables, so it identifies the entity on its own; the parent type is resolved through per-parent relationships. No FK (polymorphic). */
  parentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.participant" */
export type Participant_Mutation_Response = {
  __typename?: 'participant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Participant>;
};

/** on_conflict condition type for table "shared.participant" */
export type Participant_On_Conflict = {
  constraint: Participant_Constraint;
  update_columns?: Array<Participant_Update_Column>;
  where?: InputMaybe<Participant_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.participant". */
export type Participant_Order_By = {
  claimDetail?: InputMaybe<ClaimDetail_Order_By>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityId?: InputMaybe<Order_By>;
  lastTouchedAt?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
};

/** primary key columns input for table: shared.participant */
export type Participant_Pk_Columns_Input = {
  /** The Ory identity that touched the row. No FK into the Ory-managed schema. */
  identityId: Scalars['uuid'];
  /** The tracked row's id. Globally unique across tracked tables, so it identifies the entity on its own; the parent type is resolved through per-parent relationships. No FK (polymorphic). */
  parentId: Scalars['uuid'];
};

/** select columns of table "shared.participant" */
export enum Participant_Select_Column {
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  LastTouchedAt = 'lastTouchedAt',
  /** column name */
  ParentId = 'parentId'
}

/** input type for updating data in table "shared.participant" */
export type Participant_Set_Input = {
  /** The Ory identity that touched the row. No FK into the Ory-managed schema. */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Bumped to now() on every touch (insert, update, or delete). */
  lastTouchedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The tracked row's id. Globally unique across tracked tables, so it identifies the entity on its own; the parent type is resolved through per-parent relationships. No FK (polymorphic). */
  parentId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "participant" */
export type Participant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Participant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Participant_Stream_Cursor_Value_Input = {
  /** The Ory identity that touched the row. No FK into the Ory-managed schema. */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Bumped to now() on every touch (insert, update, or delete). */
  lastTouchedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The tracked row's id. Globally unique across tracked tables, so it identifies the entity on its own; the parent type is resolved through per-parent relationships. No FK (polymorphic). */
  parentId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "shared.participant" */
export enum Participant_Update_Column {
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  LastTouchedAt = 'lastTouchedAt',
  /** column name */
  ParentId = 'parentId'
}

export type Participant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Participant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Participant_Bool_Exp;
};

/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type Payee = {
  __typename?: 'payee';
  /** An array relationship */
  accountDisbursements: Array<AccountDisbursement>;
  /** An aggregate relationship */
  accountDisbursements_aggregate: AccountDisbursement_Aggregate;
  /** An array relationship */
  addresses: Array<Address>;
  /** An aggregate relationship */
  addresses_aggregate: Address_Aggregate;
  /** When the Payee was created. */
  createdAt: Scalars['timestamptz'];
  /** First date the Payee is Active. Null means the Payee is Inactive. A future date makes the Payee Pending until it arrives. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** The Payee is Inactive after this date. Null means it never expires. */
  expirationDate?: Maybe<Scalars['date']>;
  /** Surrogate key. Stable for the life of the Payee, since Payees are never deleted; also the parent_id of the Payee's addresses and notes. */
  id: Scalars['uuid'];
  /** Whether payments to this Payee are reported on a 1099. */
  is1099Reportable: Scalars['Boolean'];
  /** Whether this Payee must not be paid. Stored only for now; no pay run reads it yet. */
  isDoNotPay: Scalars['Boolean'];
  /** An array relationship */
  journalEntryLines: Array<JournalEntryLine>;
  /** An aggregate relationship */
  journalEntryLines_aggregate: JournalEntryLine_Aggregate;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** The Payee's name, as shown in the payee list, on its page and in its audit history. */
  name: Scalars['String'];
  /** An array relationship */
  notes: Array<EntityNote>;
  /** An aggregate relationship */
  notes_aggregate: EntityNote_Aggregate;
  /** An object relationship */
  payeeAs400?: Maybe<PayeeAs400>;
  /** An array relationship */
  payeeLinkViews: Array<PayeeLinkView>;
  /** An aggregate relationship */
  payeeLinkViews_aggregate: PayeeLinkView_Aggregate;
  /** An object relationship */
  payeeType: Type;
  /** The shared.type (group PayeeType) that classifies this Payee. */
  payeeTypeId: Scalars['uuid'];
  /** An object relationship */
  paymentMethodType: PaymentMethodType;
  /** The shared.payment_method_type this Payee is paid by, so a pay run can compare it with a Payment's own method. Required. Existing rows were backfilled to CHECK (Dealer Payees) or ACH (everyone else). */
  paymentMethodTypeId: Scalars['uuid'];
  /** An array relationship */
  productDisbursements: Array<ProductDisbursement>;
  /** An aggregate relationship */
  productDisbursements_aggregate: ProductDisbursement_Aggregate;
  /** AesEncryptionService ciphertext of the tax identity number, whose length comes from its tax identity type's metadata. Requires tax_identity_type_id. Must only be written through the .NET Payees API (PUT api/Payees/{id}/TaxIdentity): no Hasura role may insert or update it, because a caller-supplied ciphertext would let anyone with write access use the decrypt endpoint as a padding oracle. */
  taxIdentityNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  taxIdentityType?: Maybe<Type>;
  /** The shared.type (group TaxIdentityType) saying what kind of number tax_identity_number holds: SSN, EIN or ITIN. */
  taxIdentityTypeId?: Maybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_updated_at trigger. */
  updatedAt: Scalars['timestamptz'];
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeAccountDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeAccountDisbursements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeJournalEntryLinesArgs = {
  distinct_on?: InputMaybe<Array<JournalEntryLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntryLine_Order_By>>;
  where?: InputMaybe<JournalEntryLine_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeJournalEntryLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JournalEntryLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntryLine_Order_By>>;
  where?: InputMaybe<JournalEntryLine_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeePayeeLinkViewsArgs = {
  distinct_on?: InputMaybe<Array<PayeeLinkView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PayeeLinkView_Order_By>>;
  where?: InputMaybe<PayeeLinkView_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeePayeeLinkViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PayeeLinkView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PayeeLinkView_Order_By>>;
  where?: InputMaybe<PayeeLinkView_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeProductDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductDisbursement_Order_By>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};


/** A party that money is paid to, with its own identity rather than a free-text AS400 code. A Payee's Type classifies it as a Dealer Payee, Agent or Internal Payee. Payees are never deleted. */
export type PayeeProductDisbursements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductDisbursement_Order_By>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};

/** The AS400-only facts about a Payee, so they can be dropped with the AS400 and grow here. At most one row per Payee; the row is optional in the schema and required only by the UI. */
export type PayeeAs400 = {
  __typename?: 'payeeAs400';
  createdAt: Scalars['timestamptz'];
  /** The AS400 disbursement code, trimmed and upper-cased, unique across Payees. It can be changed but never removed; a change is copied onto the Payee's disbursement rows by sync_accounting_payee_as400_disbursement_code. */
  disbursementCode: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  payee: Payee;
  /** The Payee this row describes. One row per Payee. */
  payeeId: Scalars['uuid'];
  /** Last write to the row, maintained by the set_accounting_payee_as400_updated_at trigger. */
  updatedAt: Scalars['timestamptz'];
};


/** The AS400-only facts about a Payee, so they can be dropped with the AS400 and grow here. At most one row per Payee; the row is optional in the schema and required only by the UI. */
export type PayeeAs400LoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** The AS400-only facts about a Payee, so they can be dropped with the AS400 and grow here. At most one row per Payee; the row is optional in the schema and required only by the UI. */
export type PayeeAs400LoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "accounting.payee_as400" */
export type PayeeAs400_Aggregate = {
  __typename?: 'payeeAs400_aggregate';
  aggregate?: Maybe<PayeeAs400_Aggregate_Fields>;
  nodes: Array<PayeeAs400>;
};

/** aggregate fields of "accounting.payee_as400" */
export type PayeeAs400_Aggregate_Fields = {
  __typename?: 'payeeAs400_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PayeeAs400_Max_Fields>;
  min?: Maybe<PayeeAs400_Min_Fields>;
};


/** aggregate fields of "accounting.payee_as400" */
export type PayeeAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PayeeAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "accounting.payee_as400". All fields are combined with a logical 'AND'. */
export type PayeeAs400_Bool_Exp = {
  _and?: InputMaybe<Array<PayeeAs400_Bool_Exp>>;
  _not?: InputMaybe<PayeeAs400_Bool_Exp>;
  _or?: InputMaybe<Array<PayeeAs400_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  disbursementCode?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  payee?: InputMaybe<Payee_Bool_Exp>;
  payeeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounting.payee_as400" */
export enum PayeeAs400_Constraint {
  /** unique or primary key constraint on columns "payee_id" */
  PayeeAs400PayeeIdKey = 'payee_as400_payee_id_key',
  /** unique or primary key constraint on columns "id" */
  PayeeAs400Pkey = 'payee_as400_pkey',
  /** unique or primary key constraint on columns "disbursement_code" */
  UqPayeeAs400DisbursementCode = 'uq_payee_as400_disbursement_code'
}

/** input type for inserting data into table "accounting.payee_as400" */
export type PayeeAs400_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The AS400 disbursement code, trimmed and upper-cased, unique across Payees. It can be changed but never removed; a change is copied onto the Payee's disbursement rows by sync_accounting_payee_as400_disbursement_code. */
  disbursementCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  payee?: InputMaybe<Payee_Obj_Rel_Insert_Input>;
  /** The Payee this row describes. One row per Payee. */
  payeeId?: InputMaybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_as400_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PayeeAs400_Max_Fields = {
  __typename?: 'payeeAs400_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The AS400 disbursement code, trimmed and upper-cased, unique across Payees. It can be changed but never removed; a change is copied onto the Payee's disbursement rows by sync_accounting_payee_as400_disbursement_code. */
  disbursementCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Payee this row describes. One row per Payee. */
  payeeId?: Maybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_as400_updated_at trigger. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PayeeAs400_Min_Fields = {
  __typename?: 'payeeAs400_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The AS400 disbursement code, trimmed and upper-cased, unique across Payees. It can be changed but never removed; a change is copied onto the Payee's disbursement rows by sync_accounting_payee_as400_disbursement_code. */
  disbursementCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The Payee this row describes. One row per Payee. */
  payeeId?: Maybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_as400_updated_at trigger. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "accounting.payee_as400" */
export type PayeeAs400_Mutation_Response = {
  __typename?: 'payeeAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PayeeAs400>;
};

/** input type for inserting object relation for remote table "accounting.payee_as400" */
export type PayeeAs400_Obj_Rel_Insert_Input = {
  data: PayeeAs400_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PayeeAs400_On_Conflict>;
};

/** on_conflict condition type for table "accounting.payee_as400" */
export type PayeeAs400_On_Conflict = {
  constraint: PayeeAs400_Constraint;
  update_columns?: Array<PayeeAs400_Update_Column>;
  where?: InputMaybe<PayeeAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "accounting.payee_as400". */
export type PayeeAs400_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  disbursementCode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  payee?: InputMaybe<Payee_Order_By>;
  payeeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounting.payee_as400 */
export type PayeeAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "accounting.payee_as400" */
export enum PayeeAs400_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisbursementCode = 'disbursementCode',
  /** column name */
  Id = 'id',
  /** column name */
  PayeeId = 'payeeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "accounting.payee_as400" */
export type PayeeAs400_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The AS400 disbursement code, trimmed and upper-cased, unique across Payees. It can be changed but never removed; a change is copied onto the Payee's disbursement rows by sync_accounting_payee_as400_disbursement_code. */
  disbursementCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The Payee this row describes. One row per Payee. */
  payeeId?: InputMaybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_as400_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "payeeAs400" */
export type PayeeAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PayeeAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PayeeAs400_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The AS400 disbursement code, trimmed and upper-cased, unique across Payees. It can be changed but never removed; a change is copied onto the Payee's disbursement rows by sync_accounting_payee_as400_disbursement_code. */
  disbursementCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The Payee this row describes. One row per Payee. */
  payeeId?: InputMaybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_as400_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "accounting.payee_as400" */
export enum PayeeAs400_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisbursementCode = 'disbursementCode',
  /** column name */
  Id = 'id',
  /** column name */
  PayeeId = 'payeeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PayeeAs400_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PayeeAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: PayeeAs400_Bool_Exp;
};

/** One row per Payee and Account and Category, and per Payee and Product, that has a disbursement row pointing at the Payee. is_active is true when any of the group's disbursement rows has no expiration date or one not yet passed. Read by the Links card on the Accounting Payee detail page. code is the Account code and is null for a Product; category_id and category_name are null for a Product. */
export type PayeeLinkView = {
  __typename?: 'payeeLinkView';
  categoryId?: Maybe<Scalars['uuid']>;
  categoryName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  isActive?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  payee?: Maybe<Payee>;
  payeeId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "accounting.payee_link_view" */
export type PayeeLinkView_Aggregate = {
  __typename?: 'payeeLinkView_aggregate';
  aggregate?: Maybe<PayeeLinkView_Aggregate_Fields>;
  nodes: Array<PayeeLinkView>;
};

export type PayeeLinkView_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<PayeeLinkView_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<PayeeLinkView_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<PayeeLinkView_Aggregate_Bool_Exp_Count>;
};

export type PayeeLinkView_Aggregate_Bool_Exp_Bool_And = {
  arguments: PayeeLinkView_Select_Column_PayeeLinkView_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PayeeLinkView_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PayeeLinkView_Aggregate_Bool_Exp_Bool_Or = {
  arguments: PayeeLinkView_Select_Column_PayeeLinkView_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PayeeLinkView_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PayeeLinkView_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PayeeLinkView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PayeeLinkView_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "accounting.payee_link_view" */
export type PayeeLinkView_Aggregate_Fields = {
  __typename?: 'payeeLinkView_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PayeeLinkView_Max_Fields>;
  min?: Maybe<PayeeLinkView_Min_Fields>;
};


/** aggregate fields of "accounting.payee_link_view" */
export type PayeeLinkView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PayeeLinkView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accounting.payee_link_view" */
export type PayeeLinkView_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PayeeLinkView_Max_Order_By>;
  min?: InputMaybe<PayeeLinkView_Min_Order_By>;
};

/** input type for inserting array relation for remote table "accounting.payee_link_view" */
export type PayeeLinkView_Arr_Rel_Insert_Input = {
  data: Array<PayeeLinkView_Insert_Input>;
};

/** Boolean expression to filter rows from the table "accounting.payee_link_view". All fields are combined with a logical 'AND'. */
export type PayeeLinkView_Bool_Exp = {
  _and?: InputMaybe<Array<PayeeLinkView_Bool_Exp>>;
  _not?: InputMaybe<PayeeLinkView_Bool_Exp>;
  _or?: InputMaybe<Array<PayeeLinkView_Bool_Exp>>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  categoryName?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payee?: InputMaybe<Payee_Bool_Exp>;
  payeeId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "accounting.payee_link_view" */
export type PayeeLinkView_Insert_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  categoryName?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payee?: InputMaybe<Payee_Obj_Rel_Insert_Input>;
  payeeId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PayeeLinkView_Max_Fields = {
  __typename?: 'payeeLinkView_max_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  categoryName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  payeeId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "accounting.payee_link_view" */
export type PayeeLinkView_Max_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  categoryName?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payeeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PayeeLinkView_Min_Fields = {
  __typename?: 'payeeLinkView_min_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  categoryName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  payeeId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "accounting.payee_link_view" */
export type PayeeLinkView_Min_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  categoryName?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payeeId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "accounting.payee_link_view". */
export type PayeeLinkView_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  categoryName?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payee?: InputMaybe<Payee_Order_By>;
  payeeId?: InputMaybe<Order_By>;
};

/** select columns of table "accounting.payee_link_view" */
export enum PayeeLinkView_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CategoryName = 'categoryName',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  PayeeId = 'payeeId'
}

/** select "payeeLinkView_aggregate_bool_exp_bool_and_arguments_columns" columns of table "accounting.payee_link_view" */
export enum PayeeLinkView_Select_Column_PayeeLinkView_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** select "payeeLinkView_aggregate_bool_exp_bool_or_arguments_columns" columns of table "accounting.payee_link_view" */
export enum PayeeLinkView_Select_Column_PayeeLinkView_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** Streaming cursor of the table "payeeLinkView" */
export type PayeeLinkView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PayeeLinkView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PayeeLinkView_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  categoryName?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payeeId?: InputMaybe<Scalars['uuid']>;
};

/** aggregated selection of "accounting.payee" */
export type Payee_Aggregate = {
  __typename?: 'payee_aggregate';
  aggregate?: Maybe<Payee_Aggregate_Fields>;
  nodes: Array<Payee>;
};

/** aggregate fields of "accounting.payee" */
export type Payee_Aggregate_Fields = {
  __typename?: 'payee_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Payee_Max_Fields>;
  min?: Maybe<Payee_Min_Fields>;
};


/** aggregate fields of "accounting.payee" */
export type Payee_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payee_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "accounting.payee". All fields are combined with a logical 'AND'. */
export type Payee_Bool_Exp = {
  _and?: InputMaybe<Array<Payee_Bool_Exp>>;
  _not?: InputMaybe<Payee_Bool_Exp>;
  _or?: InputMaybe<Array<Payee_Bool_Exp>>;
  accountDisbursements?: InputMaybe<AccountDisbursement_Bool_Exp>;
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Bool_Exp>;
  addresses?: InputMaybe<Address_Bool_Exp>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is1099Reportable?: InputMaybe<Boolean_Comparison_Exp>;
  isDoNotPay?: InputMaybe<Boolean_Comparison_Exp>;
  journalEntryLines?: InputMaybe<JournalEntryLine_Bool_Exp>;
  journalEntryLines_aggregate?: InputMaybe<JournalEntryLine_Aggregate_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<EntityNote_Bool_Exp>;
  notes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  payeeAs400?: InputMaybe<PayeeAs400_Bool_Exp>;
  payeeLinkViews?: InputMaybe<PayeeLinkView_Bool_Exp>;
  payeeLinkViews_aggregate?: InputMaybe<PayeeLinkView_Aggregate_Bool_Exp>;
  payeeType?: InputMaybe<Type_Bool_Exp>;
  payeeTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Bool_Exp>;
  paymentMethodTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  productDisbursements?: InputMaybe<ProductDisbursement_Bool_Exp>;
  productDisbursements_aggregate?: InputMaybe<ProductDisbursement_Aggregate_Bool_Exp>;
  taxIdentityNumber?: InputMaybe<String_Comparison_Exp>;
  taxIdentityType?: InputMaybe<Type_Bool_Exp>;
  taxIdentityTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounting.payee" */
export enum Payee_Constraint {
  /** unique or primary key constraint on columns "id" */
  PayeePkey = 'payee_pkey'
}

/** input type for inserting data into table "accounting.payee" */
export type Payee_Insert_Input = {
  accountDisbursements?: InputMaybe<AccountDisbursement_Arr_Rel_Insert_Input>;
  addresses?: InputMaybe<Address_Arr_Rel_Insert_Input>;
  /** When the Payee was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** First date the Payee is Active. Null means the Payee is Inactive. A future date makes the Payee Pending until it arrives. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** The Payee is Inactive after this date. Null means it never expires. */
  expirationDate?: InputMaybe<Scalars['date']>;
  /** Surrogate key. Stable for the life of the Payee, since Payees are never deleted; also the parent_id of the Payee's addresses and notes. */
  id?: InputMaybe<Scalars['uuid']>;
  /** Whether payments to this Payee are reported on a 1099. */
  is1099Reportable?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Payee must not be paid. Stored only for now; no pay run reads it yet. */
  isDoNotPay?: InputMaybe<Scalars['Boolean']>;
  journalEntryLines?: InputMaybe<JournalEntryLine_Arr_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  /** The Payee's name, as shown in the payee list, on its page and in its audit history. */
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  payeeAs400?: InputMaybe<PayeeAs400_Obj_Rel_Insert_Input>;
  payeeLinkViews?: InputMaybe<PayeeLinkView_Arr_Rel_Insert_Input>;
  payeeType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** The shared.type (group PayeeType) that classifies this Payee. */
  payeeTypeId?: InputMaybe<Scalars['uuid']>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Obj_Rel_Insert_Input>;
  /** The shared.payment_method_type this Payee is paid by, so a pay run can compare it with a Payment's own method. Required. Existing rows were backfilled to CHECK (Dealer Payees) or ACH (everyone else). */
  paymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  productDisbursements?: InputMaybe<ProductDisbursement_Arr_Rel_Insert_Input>;
  /** AesEncryptionService ciphertext of the tax identity number, whose length comes from its tax identity type's metadata. Requires tax_identity_type_id. Must only be written through the .NET Payees API (PUT api/Payees/{id}/TaxIdentity): no Hasura role may insert or update it, because a caller-supplied ciphertext would let anyone with write access use the decrypt endpoint as a padding oracle. */
  taxIdentityNumber?: InputMaybe<Scalars['String']>;
  taxIdentityType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** The shared.type (group TaxIdentityType) saying what kind of number tax_identity_number holds: SSN, EIN or ITIN. */
  taxIdentityTypeId?: InputMaybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Payee_Max_Fields = {
  __typename?: 'payee_max_fields';
  /** When the Payee was created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** First date the Payee is Active. Null means the Payee is Inactive. A future date makes the Payee Pending until it arrives. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** The Payee is Inactive after this date. Null means it never expires. */
  expirationDate?: Maybe<Scalars['date']>;
  /** Surrogate key. Stable for the life of the Payee, since Payees are never deleted; also the parent_id of the Payee's addresses and notes. */
  id?: Maybe<Scalars['uuid']>;
  /** The Payee's name, as shown in the payee list, on its page and in its audit history. */
  name?: Maybe<Scalars['String']>;
  /** The shared.type (group PayeeType) that classifies this Payee. */
  payeeTypeId?: Maybe<Scalars['uuid']>;
  /** The shared.payment_method_type this Payee is paid by, so a pay run can compare it with a Payment's own method. Required. Existing rows were backfilled to CHECK (Dealer Payees) or ACH (everyone else). */
  paymentMethodTypeId?: Maybe<Scalars['uuid']>;
  /** AesEncryptionService ciphertext of the tax identity number, whose length comes from its tax identity type's metadata. Requires tax_identity_type_id. Must only be written through the .NET Payees API (PUT api/Payees/{id}/TaxIdentity): no Hasura role may insert or update it, because a caller-supplied ciphertext would let anyone with write access use the decrypt endpoint as a padding oracle. */
  taxIdentityNumber?: Maybe<Scalars['String']>;
  /** The shared.type (group TaxIdentityType) saying what kind of number tax_identity_number holds: SSN, EIN or ITIN. */
  taxIdentityTypeId?: Maybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_updated_at trigger. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Payee_Min_Fields = {
  __typename?: 'payee_min_fields';
  /** When the Payee was created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** First date the Payee is Active. Null means the Payee is Inactive. A future date makes the Payee Pending until it arrives. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** The Payee is Inactive after this date. Null means it never expires. */
  expirationDate?: Maybe<Scalars['date']>;
  /** Surrogate key. Stable for the life of the Payee, since Payees are never deleted; also the parent_id of the Payee's addresses and notes. */
  id?: Maybe<Scalars['uuid']>;
  /** The Payee's name, as shown in the payee list, on its page and in its audit history. */
  name?: Maybe<Scalars['String']>;
  /** The shared.type (group PayeeType) that classifies this Payee. */
  payeeTypeId?: Maybe<Scalars['uuid']>;
  /** The shared.payment_method_type this Payee is paid by, so a pay run can compare it with a Payment's own method. Required. Existing rows were backfilled to CHECK (Dealer Payees) or ACH (everyone else). */
  paymentMethodTypeId?: Maybe<Scalars['uuid']>;
  /** AesEncryptionService ciphertext of the tax identity number, whose length comes from its tax identity type's metadata. Requires tax_identity_type_id. Must only be written through the .NET Payees API (PUT api/Payees/{id}/TaxIdentity): no Hasura role may insert or update it, because a caller-supplied ciphertext would let anyone with write access use the decrypt endpoint as a padding oracle. */
  taxIdentityNumber?: Maybe<Scalars['String']>;
  /** The shared.type (group TaxIdentityType) saying what kind of number tax_identity_number holds: SSN, EIN or ITIN. */
  taxIdentityTypeId?: Maybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_updated_at trigger. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "accounting.payee" */
export type Payee_Mutation_Response = {
  __typename?: 'payee_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payee>;
};

/** input type for inserting object relation for remote table "accounting.payee" */
export type Payee_Obj_Rel_Insert_Input = {
  data: Payee_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payee_On_Conflict>;
};

/** on_conflict condition type for table "accounting.payee" */
export type Payee_On_Conflict = {
  constraint: Payee_Constraint;
  update_columns?: Array<Payee_Update_Column>;
  where?: InputMaybe<Payee_Bool_Exp>;
};

/** Ordering options when selecting data from "accounting.payee". */
export type Payee_Order_By = {
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Order_By>;
  addresses_aggregate?: InputMaybe<Address_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is1099Reportable?: InputMaybe<Order_By>;
  isDoNotPay?: InputMaybe<Order_By>;
  journalEntryLines_aggregate?: InputMaybe<JournalEntryLine_Aggregate_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  payeeAs400?: InputMaybe<PayeeAs400_Order_By>;
  payeeLinkViews_aggregate?: InputMaybe<PayeeLinkView_Aggregate_Order_By>;
  payeeType?: InputMaybe<Type_Order_By>;
  payeeTypeId?: InputMaybe<Order_By>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Order_By>;
  paymentMethodTypeId?: InputMaybe<Order_By>;
  productDisbursements_aggregate?: InputMaybe<ProductDisbursement_Aggregate_Order_By>;
  taxIdentityNumber?: InputMaybe<Order_By>;
  taxIdentityType?: InputMaybe<Type_Order_By>;
  taxIdentityTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounting.payee */
export type Payee_Pk_Columns_Input = {
  /** Surrogate key. Stable for the life of the Payee, since Payees are never deleted; also the parent_id of the Payee's addresses and notes. */
  id: Scalars['uuid'];
};

/** select columns of table "accounting.payee" */
export enum Payee_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Is1099Reportable = 'is1099Reportable',
  /** column name */
  IsDoNotPay = 'isDoNotPay',
  /** column name */
  Name = 'name',
  /** column name */
  PayeeTypeId = 'payeeTypeId',
  /** column name */
  PaymentMethodTypeId = 'paymentMethodTypeId',
  /** column name */
  TaxIdentityNumber = 'taxIdentityNumber',
  /** column name */
  TaxIdentityTypeId = 'taxIdentityTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "accounting.payee" */
export type Payee_Set_Input = {
  /** When the Payee was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** First date the Payee is Active. Null means the Payee is Inactive. A future date makes the Payee Pending until it arrives. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** The Payee is Inactive after this date. Null means it never expires. */
  expirationDate?: InputMaybe<Scalars['date']>;
  /** Surrogate key. Stable for the life of the Payee, since Payees are never deleted; also the parent_id of the Payee's addresses and notes. */
  id?: InputMaybe<Scalars['uuid']>;
  /** Whether payments to this Payee are reported on a 1099. */
  is1099Reportable?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Payee must not be paid. Stored only for now; no pay run reads it yet. */
  isDoNotPay?: InputMaybe<Scalars['Boolean']>;
  /** The Payee's name, as shown in the payee list, on its page and in its audit history. */
  name?: InputMaybe<Scalars['String']>;
  /** The shared.type (group PayeeType) that classifies this Payee. */
  payeeTypeId?: InputMaybe<Scalars['uuid']>;
  /** The shared.payment_method_type this Payee is paid by, so a pay run can compare it with a Payment's own method. Required. Existing rows were backfilled to CHECK (Dealer Payees) or ACH (everyone else). */
  paymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  /** AesEncryptionService ciphertext of the tax identity number, whose length comes from its tax identity type's metadata. Requires tax_identity_type_id. Must only be written through the .NET Payees API (PUT api/Payees/{id}/TaxIdentity): no Hasura role may insert or update it, because a caller-supplied ciphertext would let anyone with write access use the decrypt endpoint as a padding oracle. */
  taxIdentityNumber?: InputMaybe<Scalars['String']>;
  /** The shared.type (group TaxIdentityType) saying what kind of number tax_identity_number holds: SSN, EIN or ITIN. */
  taxIdentityTypeId?: InputMaybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "payee" */
export type Payee_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payee_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payee_Stream_Cursor_Value_Input = {
  /** When the Payee was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** First date the Payee is Active. Null means the Payee is Inactive. A future date makes the Payee Pending until it arrives. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** The Payee is Inactive after this date. Null means it never expires. */
  expirationDate?: InputMaybe<Scalars['date']>;
  /** Surrogate key. Stable for the life of the Payee, since Payees are never deleted; also the parent_id of the Payee's addresses and notes. */
  id?: InputMaybe<Scalars['uuid']>;
  /** Whether payments to this Payee are reported on a 1099. */
  is1099Reportable?: InputMaybe<Scalars['Boolean']>;
  /** Whether this Payee must not be paid. Stored only for now; no pay run reads it yet. */
  isDoNotPay?: InputMaybe<Scalars['Boolean']>;
  /** The Payee's name, as shown in the payee list, on its page and in its audit history. */
  name?: InputMaybe<Scalars['String']>;
  /** The shared.type (group PayeeType) that classifies this Payee. */
  payeeTypeId?: InputMaybe<Scalars['uuid']>;
  /** The shared.payment_method_type this Payee is paid by, so a pay run can compare it with a Payment's own method. Required. Existing rows were backfilled to CHECK (Dealer Payees) or ACH (everyone else). */
  paymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  /** AesEncryptionService ciphertext of the tax identity number, whose length comes from its tax identity type's metadata. Requires tax_identity_type_id. Must only be written through the .NET Payees API (PUT api/Payees/{id}/TaxIdentity): no Hasura role may insert or update it, because a caller-supplied ciphertext would let anyone with write access use the decrypt endpoint as a padding oracle. */
  taxIdentityNumber?: InputMaybe<Scalars['String']>;
  /** The shared.type (group TaxIdentityType) saying what kind of number tax_identity_number holds: SSN, EIN or ITIN. */
  taxIdentityTypeId?: InputMaybe<Scalars['uuid']>;
  /** Last write to the row, maintained by the set_accounting_payee_updated_at trigger. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "accounting.payee" */
export enum Payee_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Is1099Reportable = 'is1099Reportable',
  /** column name */
  IsDoNotPay = 'isDoNotPay',
  /** column name */
  Name = 'name',
  /** column name */
  PayeeTypeId = 'payeeTypeId',
  /** column name */
  PaymentMethodTypeId = 'paymentMethodTypeId',
  /** column name */
  TaxIdentityNumber = 'taxIdentityNumber',
  /** column name */
  TaxIdentityTypeId = 'taxIdentityTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Payee_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payee_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payee_Bool_Exp;
};

/** columns and relationships of "shared.payment" */
export type Payment = {
  __typename?: 'payment';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  address?: Maybe<Address>;
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount: Scalars['numeric'];
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  billingMetadata: Scalars['jsonb'];
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  claimServiceCenter?: Maybe<ClaimServiceCenter>;
  /** Business date the money left our bank account: the card settled or the check was cashed. Labelled Cleared for every method. Filled from the bank; NULL until then, and on payments coming in. */
  clearedDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  contact?: Maybe<Contact>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  id: Scalars['uuid'];
  /** Business date, in Kansas City time, the payment left us: the day its card was created or its check was printed. Accounting closes the books on this date. Set with the Issued status: for a card by PaymentService.SendClaimPaymentInternal, for a check when it is printed. NULL while Pending and on payments coming in. */
  issuedDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  parentId: Scalars['uuid'];
  /** An array relationship */
  paymentDetails: Array<PaymentDetail>;
  /** An aggregate relationship */
  paymentDetails_aggregate: PaymentDetail_Aggregate;
  paymentIdentifier?: Maybe<Scalars['String']>;
  /** An object relationship */
  paymentMethodType: PaymentMethodType;
  paymentMethodTypeId: Scalars['uuid'];
  paymentNumber: Scalars['Int'];
  /** An object relationship */
  paymentStatusType: PaymentStatusType;
  paymentStatusTypeId: Scalars['uuid'];
  /** An object relationship */
  paymentType: PaymentType;
  paymentTypeId: Scalars['uuid'];
  /** An object relationship */
  policyClaim?: Maybe<PolicyClaim>;
  prefixedNumber?: Maybe<Scalars['String']>;
  /** An array relationship */
  remittancePayments: Array<RemittancePayment>;
  /** An aggregate relationship */
  remittancePayments_aggregate: RemittancePayment_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "shared.payment" */
export type PaymentBillingMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shared.payment" */
export type PaymentEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "shared.payment" */
export type PaymentEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "shared.payment" */
export type PaymentLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "shared.payment" */
export type PaymentLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "shared.payment" */
export type PaymentPaymentDetailsArgs = {
  distinct_on?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentDetail_Order_By>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};


/** columns and relationships of "shared.payment" */
export type PaymentPaymentDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentDetail_Order_By>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};


/** columns and relationships of "shared.payment" */
export type PaymentRemittancePaymentsArgs = {
  distinct_on?: InputMaybe<Array<RemittancePayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePayment_Order_By>>;
  where?: InputMaybe<RemittancePayment_Bool_Exp>;
};


/** columns and relationships of "shared.payment" */
export type PaymentRemittancePayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePayment_Order_By>>;
  where?: InputMaybe<RemittancePayment_Bool_Exp>;
};

/** Temporary table to keep track of what payments have been inserted in the AS400 */
export type PaymentAs400 = {
  __typename?: 'paymentAs400';
  checkNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  existsInAs400: Scalars['Boolean'];
  id: Scalars['uuid'];
  paymentId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "shared.payment_as400" */
export type PaymentAs400_Aggregate = {
  __typename?: 'paymentAs400_aggregate';
  aggregate?: Maybe<PaymentAs400_Aggregate_Fields>;
  nodes: Array<PaymentAs400>;
};

/** aggregate fields of "shared.payment_as400" */
export type PaymentAs400_Aggregate_Fields = {
  __typename?: 'paymentAs400_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PaymentAs400_Max_Fields>;
  min?: Maybe<PaymentAs400_Min_Fields>;
};


/** aggregate fields of "shared.payment_as400" */
export type PaymentAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "shared.payment_as400". All fields are combined with a logical 'AND'. */
export type PaymentAs400_Bool_Exp = {
  _and?: InputMaybe<Array<PaymentAs400_Bool_Exp>>;
  _not?: InputMaybe<PaymentAs400_Bool_Exp>;
  _or?: InputMaybe<Array<PaymentAs400_Bool_Exp>>;
  checkNumber?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  existsInAs400?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  paymentId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.payment_as400" */
export enum PaymentAs400_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentAs400Pkey = 'payment_as400_pkey'
}

/** input type for inserting data into table "shared.payment_as400" */
export type PaymentAs400_Insert_Input = {
  checkNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PaymentAs400_Max_Fields = {
  __typename?: 'paymentAs400_max_fields';
  checkNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  paymentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PaymentAs400_Min_Fields = {
  __typename?: 'paymentAs400_min_fields';
  checkNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  paymentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shared.payment_as400" */
export type PaymentAs400_Mutation_Response = {
  __typename?: 'paymentAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentAs400>;
};

/** on_conflict condition type for table "shared.payment_as400" */
export type PaymentAs400_On_Conflict = {
  constraint: PaymentAs400_Constraint;
  update_columns?: Array<PaymentAs400_Update_Column>;
  where?: InputMaybe<PaymentAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.payment_as400". */
export type PaymentAs400_Order_By = {
  checkNumber?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  existsInAs400?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.payment_as400 */
export type PaymentAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.payment_as400" */
export enum PaymentAs400_Select_Column {
  /** column name */
  CheckNumber = 'checkNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.payment_as400" */
export type PaymentAs400_Set_Input = {
  checkNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "paymentAs400" */
export type PaymentAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PaymentAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentAs400_Stream_Cursor_Value_Input = {
  checkNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.payment_as400" */
export enum PaymentAs400_Update_Column {
  /** column name */
  CheckNumber = 'checkNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PaymentAs400_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: PaymentAs400_Bool_Exp;
};

/** columns and relationships of "shared.payment_detail" */
export type PaymentDetail = {
  __typename?: 'paymentDetail';
  amount: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  parentId: Scalars['uuid'];
  /** An object relationship */
  payment: Payment;
  paymentId: Scalars['uuid'];
  /** An object relationship */
  remittanceClaimDetail?: Maybe<RemittanceClaimDetail>;
  /** An object relationship */
  remittancePolicyContract?: Maybe<RemittancePolicyContract>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "shared.payment_detail" */
export type PaymentDetail_Aggregate = {
  __typename?: 'paymentDetail_aggregate';
  aggregate?: Maybe<PaymentDetail_Aggregate_Fields>;
  nodes: Array<PaymentDetail>;
};

export type PaymentDetail_Aggregate_Bool_Exp = {
  count?: InputMaybe<PaymentDetail_Aggregate_Bool_Exp_Count>;
};

export type PaymentDetail_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PaymentDetail_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.payment_detail" */
export type PaymentDetail_Aggregate_Fields = {
  __typename?: 'paymentDetail_aggregate_fields';
  avg?: Maybe<PaymentDetail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PaymentDetail_Max_Fields>;
  min?: Maybe<PaymentDetail_Min_Fields>;
  stddev?: Maybe<PaymentDetail_Stddev_Fields>;
  stddev_pop?: Maybe<PaymentDetail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PaymentDetail_Stddev_Samp_Fields>;
  sum?: Maybe<PaymentDetail_Sum_Fields>;
  var_pop?: Maybe<PaymentDetail_Var_Pop_Fields>;
  var_samp?: Maybe<PaymentDetail_Var_Samp_Fields>;
  variance?: Maybe<PaymentDetail_Variance_Fields>;
};


/** aggregate fields of "shared.payment_detail" */
export type PaymentDetail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.payment_detail" */
export type PaymentDetail_Aggregate_Order_By = {
  avg?: InputMaybe<PaymentDetail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PaymentDetail_Max_Order_By>;
  min?: InputMaybe<PaymentDetail_Min_Order_By>;
  stddev?: InputMaybe<PaymentDetail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PaymentDetail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PaymentDetail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PaymentDetail_Sum_Order_By>;
  var_pop?: InputMaybe<PaymentDetail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PaymentDetail_Var_Samp_Order_By>;
  variance?: InputMaybe<PaymentDetail_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shared.payment_detail" */
export type PaymentDetail_Arr_Rel_Insert_Input = {
  data: Array<PaymentDetail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentDetail_On_Conflict>;
};

/** aggregate avg on columns */
export type PaymentDetail_Avg_Fields = {
  __typename?: 'paymentDetail_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shared.payment_detail" */
export type PaymentDetail_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shared.payment_detail". All fields are combined with a logical 'AND'. */
export type PaymentDetail_Bool_Exp = {
  _and?: InputMaybe<Array<PaymentDetail_Bool_Exp>>;
  _not?: InputMaybe<PaymentDetail_Bool_Exp>;
  _or?: InputMaybe<Array<PaymentDetail_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  payment?: InputMaybe<Payment_Bool_Exp>;
  paymentId?: InputMaybe<Uuid_Comparison_Exp>;
  remittanceClaimDetail?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
  remittancePolicyContract?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.payment_detail" */
export enum PaymentDetail_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentDetailPkey = 'payment_detail_pkey'
}

/** input type for incrementing numeric columns in table "shared.payment_detail" */
export type PaymentDetail_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "shared.payment_detail" */
export type PaymentDetail_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  payment?: InputMaybe<Payment_Obj_Rel_Insert_Input>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  remittanceClaimDetail?: InputMaybe<RemittanceClaimDetail_Obj_Rel_Insert_Input>;
  remittancePolicyContract?: InputMaybe<RemittancePolicyContract_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PaymentDetail_Max_Fields = {
  __typename?: 'paymentDetail_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  paymentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.payment_detail" */
export type PaymentDetail_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PaymentDetail_Min_Fields = {
  __typename?: 'paymentDetail_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  paymentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.payment_detail" */
export type PaymentDetail_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.payment_detail" */
export type PaymentDetail_Mutation_Response = {
  __typename?: 'paymentDetail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentDetail>;
};

/** input type for inserting object relation for remote table "shared.payment_detail" */
export type PaymentDetail_Obj_Rel_Insert_Input = {
  data: PaymentDetail_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentDetail_On_Conflict>;
};

/** on_conflict condition type for table "shared.payment_detail" */
export type PaymentDetail_On_Conflict = {
  constraint: PaymentDetail_Constraint;
  update_columns?: Array<PaymentDetail_Update_Column>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.payment_detail". */
export type PaymentDetail_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  payment?: InputMaybe<Payment_Order_By>;
  paymentId?: InputMaybe<Order_By>;
  remittanceClaimDetail?: InputMaybe<RemittanceClaimDetail_Order_By>;
  remittancePolicyContract?: InputMaybe<RemittancePolicyContract_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.payment_detail */
export type PaymentDetail_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.payment_detail" */
export enum PaymentDetail_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.payment_detail" */
export type PaymentDetail_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PaymentDetail_Stddev_Fields = {
  __typename?: 'paymentDetail_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shared.payment_detail" */
export type PaymentDetail_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PaymentDetail_Stddev_Pop_Fields = {
  __typename?: 'paymentDetail_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shared.payment_detail" */
export type PaymentDetail_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PaymentDetail_Stddev_Samp_Fields = {
  __typename?: 'paymentDetail_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shared.payment_detail" */
export type PaymentDetail_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "paymentDetail" */
export type PaymentDetail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PaymentDetail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentDetail_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PaymentDetail_Sum_Fields = {
  __typename?: 'paymentDetail_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "shared.payment_detail" */
export type PaymentDetail_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "shared.payment_detail" */
export enum PaymentDetail_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PaymentDetail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PaymentDetail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentDetail_Set_Input>;
  /** filter the rows which have to be updated */
  where: PaymentDetail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PaymentDetail_Var_Pop_Fields = {
  __typename?: 'paymentDetail_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shared.payment_detail" */
export type PaymentDetail_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PaymentDetail_Var_Samp_Fields = {
  __typename?: 'paymentDetail_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shared.payment_detail" */
export type PaymentDetail_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PaymentDetail_Variance_Fields = {
  __typename?: 'paymentDetail_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shared.payment_detail" */
export type PaymentDetail_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "shared.payment_method_type" */
export type PaymentMethodType = {
  __typename?: 'paymentMethodType';
  display: Scalars['String'];
  enumValue?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
  /** An array relationship */
  remittances: Array<Remittance>;
  /** An aggregate relationship */
  remittances_aggregate: Remittance_Aggregate;
};


/** columns and relationships of "shared.payment_method_type" */
export type PaymentMethodTypePaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "shared.payment_method_type" */
export type PaymentMethodTypePayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "shared.payment_method_type" */
export type PaymentMethodTypeRemittancesArgs = {
  distinct_on?: InputMaybe<Array<Remittance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Remittance_Order_By>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};


/** columns and relationships of "shared.payment_method_type" */
export type PaymentMethodTypeRemittances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Remittance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Remittance_Order_By>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};

/** aggregated selection of "shared.payment_method_type" */
export type PaymentMethodType_Aggregate = {
  __typename?: 'paymentMethodType_aggregate';
  aggregate?: Maybe<PaymentMethodType_Aggregate_Fields>;
  nodes: Array<PaymentMethodType>;
};

/** aggregate fields of "shared.payment_method_type" */
export type PaymentMethodType_Aggregate_Fields = {
  __typename?: 'paymentMethodType_aggregate_fields';
  avg?: Maybe<PaymentMethodType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PaymentMethodType_Max_Fields>;
  min?: Maybe<PaymentMethodType_Min_Fields>;
  stddev?: Maybe<PaymentMethodType_Stddev_Fields>;
  stddev_pop?: Maybe<PaymentMethodType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PaymentMethodType_Stddev_Samp_Fields>;
  sum?: Maybe<PaymentMethodType_Sum_Fields>;
  var_pop?: Maybe<PaymentMethodType_Var_Pop_Fields>;
  var_samp?: Maybe<PaymentMethodType_Var_Samp_Fields>;
  variance?: Maybe<PaymentMethodType_Variance_Fields>;
};


/** aggregate fields of "shared.payment_method_type" */
export type PaymentMethodType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentMethodType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PaymentMethodType_Avg_Fields = {
  __typename?: 'paymentMethodType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shared.payment_method_type". All fields are combined with a logical 'AND'. */
export type PaymentMethodType_Bool_Exp = {
  _and?: InputMaybe<Array<PaymentMethodType_Bool_Exp>>;
  _not?: InputMaybe<PaymentMethodType_Bool_Exp>;
  _or?: InputMaybe<Array<PaymentMethodType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Bool_Exp>;
  remittances?: InputMaybe<Remittance_Bool_Exp>;
  remittances_aggregate?: InputMaybe<Remittance_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "shared.payment_method_type" */
export enum PaymentMethodType_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentMethodTypePkey = 'payment_method_type_pkey'
}

/** input type for incrementing numeric columns in table "shared.payment_method_type" */
export type PaymentMethodType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "shared.payment_method_type" */
export type PaymentMethodType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
  remittances?: InputMaybe<Remittance_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type PaymentMethodType_Max_Fields = {
  __typename?: 'paymentMethodType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PaymentMethodType_Min_Fields = {
  __typename?: 'paymentMethodType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shared.payment_method_type" */
export type PaymentMethodType_Mutation_Response = {
  __typename?: 'paymentMethodType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentMethodType>;
};

/** input type for inserting object relation for remote table "shared.payment_method_type" */
export type PaymentMethodType_Obj_Rel_Insert_Input = {
  data: PaymentMethodType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentMethodType_On_Conflict>;
};

/** on_conflict condition type for table "shared.payment_method_type" */
export type PaymentMethodType_On_Conflict = {
  constraint: PaymentMethodType_Constraint;
  update_columns?: Array<PaymentMethodType_Update_Column>;
  where?: InputMaybe<PaymentMethodType_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.payment_method_type". */
export type PaymentMethodType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
  remittances_aggregate?: InputMaybe<Remittance_Aggregate_Order_By>;
};

/** primary key columns input for table: shared.payment_method_type */
export type PaymentMethodType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.payment_method_type" */
export enum PaymentMethodType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "shared.payment_method_type" */
export type PaymentMethodType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type PaymentMethodType_Stddev_Fields = {
  __typename?: 'paymentMethodType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PaymentMethodType_Stddev_Pop_Fields = {
  __typename?: 'paymentMethodType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PaymentMethodType_Stddev_Samp_Fields = {
  __typename?: 'paymentMethodType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "paymentMethodType" */
export type PaymentMethodType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PaymentMethodType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentMethodType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PaymentMethodType_Sum_Fields = {
  __typename?: 'paymentMethodType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "shared.payment_method_type" */
export enum PaymentMethodType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type PaymentMethodType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PaymentMethodType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentMethodType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PaymentMethodType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PaymentMethodType_Var_Pop_Fields = {
  __typename?: 'paymentMethodType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PaymentMethodType_Var_Samp_Fields = {
  __typename?: 'paymentMethodType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PaymentMethodType_Variance_Fields = {
  __typename?: 'paymentMethodType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "shared.payment_status_type" */
export type PaymentStatusType = {
  __typename?: 'paymentStatusType';
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  /** An array relationship */
  entityRemittanceDetails: Array<EntityRemittanceDetail>;
  /** An aggregate relationship */
  entityRemittanceDetails_aggregate: EntityRemittanceDetail_Aggregate;
  enumValue?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "shared.payment_status_type" */
export type PaymentStatusTypeEntityRemittanceDetailsArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


/** columns and relationships of "shared.payment_status_type" */
export type PaymentStatusTypeEntityRemittanceDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


/** columns and relationships of "shared.payment_status_type" */
export type PaymentStatusTypePaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "shared.payment_status_type" */
export type PaymentStatusTypePayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};

/** aggregated selection of "shared.payment_status_type" */
export type PaymentStatusType_Aggregate = {
  __typename?: 'paymentStatusType_aggregate';
  aggregate?: Maybe<PaymentStatusType_Aggregate_Fields>;
  nodes: Array<PaymentStatusType>;
};

/** aggregate fields of "shared.payment_status_type" */
export type PaymentStatusType_Aggregate_Fields = {
  __typename?: 'paymentStatusType_aggregate_fields';
  avg?: Maybe<PaymentStatusType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PaymentStatusType_Max_Fields>;
  min?: Maybe<PaymentStatusType_Min_Fields>;
  stddev?: Maybe<PaymentStatusType_Stddev_Fields>;
  stddev_pop?: Maybe<PaymentStatusType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PaymentStatusType_Stddev_Samp_Fields>;
  sum?: Maybe<PaymentStatusType_Sum_Fields>;
  var_pop?: Maybe<PaymentStatusType_Var_Pop_Fields>;
  var_samp?: Maybe<PaymentStatusType_Var_Samp_Fields>;
  variance?: Maybe<PaymentStatusType_Variance_Fields>;
};


/** aggregate fields of "shared.payment_status_type" */
export type PaymentStatusType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentStatusType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PaymentStatusType_Avg_Fields = {
  __typename?: 'paymentStatusType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shared.payment_status_type". All fields are combined with a logical 'AND'. */
export type PaymentStatusType_Bool_Exp = {
  _and?: InputMaybe<Array<PaymentStatusType_Bool_Exp>>;
  _not?: InputMaybe<PaymentStatusType_Bool_Exp>;
  _or?: InputMaybe<Array<PaymentStatusType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  entityRemittanceDetails?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
  entityRemittanceDetails_aggregate?: InputMaybe<EntityRemittanceDetail_Aggregate_Bool_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.payment_status_type" */
export enum PaymentStatusType_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentStatusTypePkey = 'payment_status_type_pkey'
}

/** input type for incrementing numeric columns in table "shared.payment_status_type" */
export type PaymentStatusType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "shared.payment_status_type" */
export type PaymentStatusType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  entityRemittanceDetails?: InputMaybe<EntityRemittanceDetail_Arr_Rel_Insert_Input>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PaymentStatusType_Max_Fields = {
  __typename?: 'paymentStatusType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PaymentStatusType_Min_Fields = {
  __typename?: 'paymentStatusType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shared.payment_status_type" */
export type PaymentStatusType_Mutation_Response = {
  __typename?: 'paymentStatusType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentStatusType>;
};

/** input type for inserting object relation for remote table "shared.payment_status_type" */
export type PaymentStatusType_Obj_Rel_Insert_Input = {
  data: PaymentStatusType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentStatusType_On_Conflict>;
};

/** on_conflict condition type for table "shared.payment_status_type" */
export type PaymentStatusType_On_Conflict = {
  constraint: PaymentStatusType_Constraint;
  update_columns?: Array<PaymentStatusType_Update_Column>;
  where?: InputMaybe<PaymentStatusType_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.payment_status_type". */
export type PaymentStatusType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  entityRemittanceDetails_aggregate?: InputMaybe<EntityRemittanceDetail_Aggregate_Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.payment_status_type */
export type PaymentStatusType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.payment_status_type" */
export enum PaymentStatusType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.payment_status_type" */
export type PaymentStatusType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PaymentStatusType_Stddev_Fields = {
  __typename?: 'paymentStatusType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PaymentStatusType_Stddev_Pop_Fields = {
  __typename?: 'paymentStatusType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PaymentStatusType_Stddev_Samp_Fields = {
  __typename?: 'paymentStatusType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "paymentStatusType" */
export type PaymentStatusType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PaymentStatusType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentStatusType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PaymentStatusType_Sum_Fields = {
  __typename?: 'paymentStatusType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "shared.payment_status_type" */
export enum PaymentStatusType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PaymentStatusType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PaymentStatusType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentStatusType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PaymentStatusType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PaymentStatusType_Var_Pop_Fields = {
  __typename?: 'paymentStatusType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PaymentStatusType_Var_Samp_Fields = {
  __typename?: 'paymentStatusType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PaymentStatusType_Variance_Fields = {
  __typename?: 'paymentStatusType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "shared.payment_type" */
export type PaymentType = {
  __typename?: 'paymentType';
  display: Scalars['String'];
  /** An array relationship */
  entityRemittanceDetails: Array<EntityRemittanceDetail>;
  /** An aggregate relationship */
  entityRemittanceDetails_aggregate: EntityRemittanceDetail_Aggregate;
  enumValue: Scalars['numeric'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
};


/** columns and relationships of "shared.payment_type" */
export type PaymentTypeEntityRemittanceDetailsArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


/** columns and relationships of "shared.payment_type" */
export type PaymentTypeEntityRemittanceDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


/** columns and relationships of "shared.payment_type" */
export type PaymentTypePaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "shared.payment_type" */
export type PaymentTypePayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};

/** aggregated selection of "shared.payment_type" */
export type PaymentType_Aggregate = {
  __typename?: 'paymentType_aggregate';
  aggregate?: Maybe<PaymentType_Aggregate_Fields>;
  nodes: Array<PaymentType>;
};

/** aggregate fields of "shared.payment_type" */
export type PaymentType_Aggregate_Fields = {
  __typename?: 'paymentType_aggregate_fields';
  avg?: Maybe<PaymentType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PaymentType_Max_Fields>;
  min?: Maybe<PaymentType_Min_Fields>;
  stddev?: Maybe<PaymentType_Stddev_Fields>;
  stddev_pop?: Maybe<PaymentType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PaymentType_Stddev_Samp_Fields>;
  sum?: Maybe<PaymentType_Sum_Fields>;
  var_pop?: Maybe<PaymentType_Var_Pop_Fields>;
  var_samp?: Maybe<PaymentType_Var_Samp_Fields>;
  variance?: Maybe<PaymentType_Variance_Fields>;
};


/** aggregate fields of "shared.payment_type" */
export type PaymentType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PaymentType_Avg_Fields = {
  __typename?: 'paymentType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shared.payment_type". All fields are combined with a logical 'AND'. */
export type PaymentType_Bool_Exp = {
  _and?: InputMaybe<Array<PaymentType_Bool_Exp>>;
  _not?: InputMaybe<PaymentType_Bool_Exp>;
  _or?: InputMaybe<Array<PaymentType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  entityRemittanceDetails?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
  entityRemittanceDetails_aggregate?: InputMaybe<EntityRemittanceDetail_Aggregate_Bool_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "shared.payment_type" */
export enum PaymentType_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentTypePkey = 'payment_type_pkey'
}

/** input type for incrementing numeric columns in table "shared.payment_type" */
export type PaymentType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "shared.payment_type" */
export type PaymentType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  entityRemittanceDetails?: InputMaybe<EntityRemittanceDetail_Arr_Rel_Insert_Input>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type PaymentType_Max_Fields = {
  __typename?: 'paymentType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PaymentType_Min_Fields = {
  __typename?: 'paymentType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shared.payment_type" */
export type PaymentType_Mutation_Response = {
  __typename?: 'paymentType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentType>;
};

/** input type for inserting object relation for remote table "shared.payment_type" */
export type PaymentType_Obj_Rel_Insert_Input = {
  data: PaymentType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentType_On_Conflict>;
};

/** on_conflict condition type for table "shared.payment_type" */
export type PaymentType_On_Conflict = {
  constraint: PaymentType_Constraint;
  update_columns?: Array<PaymentType_Update_Column>;
  where?: InputMaybe<PaymentType_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.payment_type". */
export type PaymentType_Order_By = {
  display?: InputMaybe<Order_By>;
  entityRemittanceDetails_aggregate?: InputMaybe<EntityRemittanceDetail_Aggregate_Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
};

/** primary key columns input for table: shared.payment_type */
export type PaymentType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.payment_type" */
export enum PaymentType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "shared.payment_type" */
export type PaymentType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type PaymentType_Stddev_Fields = {
  __typename?: 'paymentType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PaymentType_Stddev_Pop_Fields = {
  __typename?: 'paymentType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PaymentType_Stddev_Samp_Fields = {
  __typename?: 'paymentType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "paymentType" */
export type PaymentType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PaymentType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PaymentType_Sum_Fields = {
  __typename?: 'paymentType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "shared.payment_type" */
export enum PaymentType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type PaymentType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PaymentType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PaymentType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PaymentType_Var_Pop_Fields = {
  __typename?: 'paymentType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PaymentType_Var_Samp_Fields = {
  __typename?: 'paymentType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PaymentType_Variance_Fields = {
  __typename?: 'paymentType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "shared.payment" */
export type Payment_Aggregate = {
  __typename?: 'payment_aggregate';
  aggregate?: Maybe<Payment_Aggregate_Fields>;
  nodes: Array<Payment>;
};

export type Payment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payment_Aggregate_Bool_Exp_Count>;
};

export type Payment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.payment" */
export type Payment_Aggregate_Fields = {
  __typename?: 'payment_aggregate_fields';
  avg?: Maybe<Payment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Max_Fields>;
  min?: Maybe<Payment_Min_Fields>;
  stddev?: Maybe<Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Sum_Fields>;
  var_pop?: Maybe<Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Var_Samp_Fields>;
  variance?: Maybe<Payment_Variance_Fields>;
};


/** aggregate fields of "shared.payment" */
export type Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.payment" */
export type Payment_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Max_Order_By>;
  min?: InputMaybe<Payment_Min_Order_By>;
  stddev?: InputMaybe<Payment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Payment_Append_Input = {
  billingMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "shared.payment" */
export type Payment_Arr_Rel_Insert_Input = {
  data: Array<Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Avg_Fields = {
  __typename?: 'payment_avg_fields';
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['Float']>;
  paymentNumber?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shared.payment" */
export type Payment_Avg_Order_By = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Order_By>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shared.payment". All fields are combined with a logical 'AND'. */
export type Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Bool_Exp>>;
  _not?: InputMaybe<Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  availableAmount?: InputMaybe<Numeric_Comparison_Exp>;
  billingMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  checkNumber?: InputMaybe<Bigint_Comparison_Exp>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  clearedDate?: InputMaybe<Date_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  issuedDate?: InputMaybe<Date_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  paymentDetails?: InputMaybe<PaymentDetail_Bool_Exp>;
  paymentDetails_aggregate?: InputMaybe<PaymentDetail_Aggregate_Bool_Exp>;
  paymentIdentifier?: InputMaybe<String_Comparison_Exp>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Bool_Exp>;
  paymentMethodTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  paymentNumber?: InputMaybe<Int_Comparison_Exp>;
  paymentStatusType?: InputMaybe<PaymentStatusType_Bool_Exp>;
  paymentStatusTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  paymentType?: InputMaybe<PaymentType_Bool_Exp>;
  paymentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  prefixedNumber?: InputMaybe<String_Comparison_Exp>;
  remittancePayments?: InputMaybe<RemittancePayment_Bool_Exp>;
  remittancePayments_aggregate?: InputMaybe<RemittancePayment_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.payment" */
export enum Payment_Constraint {
  /** unique or primary key constraint on columns "payment_number" */
  PaymentPaymentNumberKey = 'payment_payment_number_key',
  /** unique or primary key constraint on columns "id" */
  PaymentPkey = 'payment_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Payment_Delete_At_Path_Input = {
  billingMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Payment_Delete_Elem_Input = {
  billingMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Payment_Delete_Key_Input = {
  billingMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "shared.payment" */
export type Payment_Inc_Input = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Scalars['bigint']>;
  paymentNumber?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shared.payment" */
export type Payment_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Scalars['numeric']>;
  billingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Scalars['bigint']>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Obj_Rel_Insert_Input>;
  /** Business date the money left our bank account: the card settled or the check was cashed. Labelled Cleared for every method. Filled from the bank; NULL until then, and on payments coming in. */
  clearedDate?: InputMaybe<Scalars['date']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Business date, in Kansas City time, the payment left us: the day its card was created or its check was printed. Accounting closes the books on this date. Set with the Issued status: for a card by PaymentService.SendClaimPaymentInternal, for a check when it is printed. NULL while Pending and on payments coming in. */
  issuedDate?: InputMaybe<Scalars['date']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['uuid']>;
  paymentDetails?: InputMaybe<PaymentDetail_Arr_Rel_Insert_Input>;
  paymentIdentifier?: InputMaybe<Scalars['String']>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Obj_Rel_Insert_Input>;
  paymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  paymentNumber?: InputMaybe<Scalars['Int']>;
  paymentStatusType?: InputMaybe<PaymentStatusType_Obj_Rel_Insert_Input>;
  paymentStatusTypeId?: InputMaybe<Scalars['uuid']>;
  paymentType?: InputMaybe<PaymentType_Obj_Rel_Insert_Input>;
  paymentTypeId?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  prefixedNumber?: InputMaybe<Scalars['String']>;
  remittancePayments?: InputMaybe<RemittancePayment_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Payment_Max_Fields = {
  __typename?: 'payment_max_fields';
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['bigint']>;
  /** Business date the money left our bank account: the card settled or the check was cashed. Labelled Cleared for every method. Filled from the bank; NULL until then, and on payments coming in. */
  clearedDate?: Maybe<Scalars['date']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Business date, in Kansas City time, the payment left us: the day its card was created or its check was printed. Accounting closes the books on this date. Set with the Issued status: for a card by PaymentService.SendClaimPaymentInternal, for a check when it is printed. NULL while Pending and on payments coming in. */
  issuedDate?: Maybe<Scalars['date']>;
  parentId?: Maybe<Scalars['uuid']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMethodTypeId?: Maybe<Scalars['uuid']>;
  paymentNumber?: Maybe<Scalars['Int']>;
  paymentStatusTypeId?: Maybe<Scalars['uuid']>;
  paymentTypeId?: Maybe<Scalars['uuid']>;
  prefixedNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.payment" */
export type Payment_Max_Order_By = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Order_By>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Order_By>;
  /** Business date the money left our bank account: the card settled or the check was cashed. Labelled Cleared for every method. Filled from the bank; NULL until then, and on payments coming in. */
  clearedDate?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Business date, in Kansas City time, the payment left us: the day its card was created or its check was printed. Accounting closes the books on this date. Set with the Issued status: for a card by PaymentService.SendClaimPaymentInternal, for a check when it is printed. NULL while Pending and on payments coming in. */
  issuedDate?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  paymentIdentifier?: InputMaybe<Order_By>;
  paymentMethodTypeId?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
  paymentStatusTypeId?: InputMaybe<Order_By>;
  paymentTypeId?: InputMaybe<Order_By>;
  prefixedNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Min_Fields = {
  __typename?: 'payment_min_fields';
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['bigint']>;
  /** Business date the money left our bank account: the card settled or the check was cashed. Labelled Cleared for every method. Filled from the bank; NULL until then, and on payments coming in. */
  clearedDate?: Maybe<Scalars['date']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Business date, in Kansas City time, the payment left us: the day its card was created or its check was printed. Accounting closes the books on this date. Set with the Issued status: for a card by PaymentService.SendClaimPaymentInternal, for a check when it is printed. NULL while Pending and on payments coming in. */
  issuedDate?: Maybe<Scalars['date']>;
  parentId?: Maybe<Scalars['uuid']>;
  paymentIdentifier?: Maybe<Scalars['String']>;
  paymentMethodTypeId?: Maybe<Scalars['uuid']>;
  paymentNumber?: Maybe<Scalars['Int']>;
  paymentStatusTypeId?: Maybe<Scalars['uuid']>;
  paymentTypeId?: Maybe<Scalars['uuid']>;
  prefixedNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.payment" */
export type Payment_Min_Order_By = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Order_By>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Order_By>;
  /** Business date the money left our bank account: the card settled or the check was cashed. Labelled Cleared for every method. Filled from the bank; NULL until then, and on payments coming in. */
  clearedDate?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Business date, in Kansas City time, the payment left us: the day its card was created or its check was printed. Accounting closes the books on this date. Set with the Issued status: for a card by PaymentService.SendClaimPaymentInternal, for a check when it is printed. NULL while Pending and on payments coming in. */
  issuedDate?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  paymentIdentifier?: InputMaybe<Order_By>;
  paymentMethodTypeId?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
  paymentStatusTypeId?: InputMaybe<Order_By>;
  paymentTypeId?: InputMaybe<Order_By>;
  prefixedNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.payment" */
export type Payment_Mutation_Response = {
  __typename?: 'payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment>;
};

/** input type for inserting object relation for remote table "shared.payment" */
export type Payment_Obj_Rel_Insert_Input = {
  data: Payment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};

/** on_conflict condition type for table "shared.payment" */
export type Payment_On_Conflict = {
  constraint: Payment_Constraint;
  update_columns?: Array<Payment_Update_Column>;
  where?: InputMaybe<Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.payment". */
export type Payment_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  address?: InputMaybe<Address_Order_By>;
  amount?: InputMaybe<Order_By>;
  availableAmount?: InputMaybe<Order_By>;
  billingMetadata?: InputMaybe<Order_By>;
  checkNumber?: InputMaybe<Order_By>;
  claimServiceCenter?: InputMaybe<ClaimServiceCenter_Order_By>;
  clearedDate?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  issuedDate?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  parentId?: InputMaybe<Order_By>;
  paymentDetails_aggregate?: InputMaybe<PaymentDetail_Aggregate_Order_By>;
  paymentIdentifier?: InputMaybe<Order_By>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Order_By>;
  paymentMethodTypeId?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
  paymentStatusType?: InputMaybe<PaymentStatusType_Order_By>;
  paymentStatusTypeId?: InputMaybe<Order_By>;
  paymentType?: InputMaybe<PaymentType_Order_By>;
  paymentTypeId?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  prefixedNumber?: InputMaybe<Order_By>;
  remittancePayments_aggregate?: InputMaybe<RemittancePayment_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.payment */
export type Payment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Payment_Prepend_Input = {
  billingMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shared.payment" */
export enum Payment_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BillingMetadata = 'billingMetadata',
  /** column name */
  CheckNumber = 'checkNumber',
  /** column name */
  ClearedDate = 'clearedDate',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IssuedDate = 'issuedDate',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PaymentIdentifier = 'paymentIdentifier',
  /** column name */
  PaymentMethodTypeId = 'paymentMethodTypeId',
  /** column name */
  PaymentNumber = 'paymentNumber',
  /** column name */
  PaymentStatusTypeId = 'paymentStatusTypeId',
  /** column name */
  PaymentTypeId = 'paymentTypeId',
  /** column name */
  PrefixedNumber = 'prefixedNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.payment" */
export type Payment_Set_Input = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Scalars['numeric']>;
  billingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Scalars['bigint']>;
  /** Business date the money left our bank account: the card settled or the check was cashed. Labelled Cleared for every method. Filled from the bank; NULL until then, and on payments coming in. */
  clearedDate?: InputMaybe<Scalars['date']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Business date, in Kansas City time, the payment left us: the day its card was created or its check was printed. Accounting closes the books on this date. Set with the Issued status: for a card by PaymentService.SendClaimPaymentInternal, for a check when it is printed. NULL while Pending and on payments coming in. */
  issuedDate?: InputMaybe<Scalars['date']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  paymentIdentifier?: InputMaybe<Scalars['String']>;
  paymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  paymentNumber?: InputMaybe<Scalars['Int']>;
  paymentStatusTypeId?: InputMaybe<Scalars['uuid']>;
  paymentTypeId?: InputMaybe<Scalars['uuid']>;
  prefixedNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Payment_Stddev_Fields = {
  __typename?: 'payment_stddev_fields';
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['Float']>;
  paymentNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shared.payment" */
export type Payment_Stddev_Order_By = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Order_By>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Stddev_Pop_Fields = {
  __typename?: 'payment_stddev_pop_fields';
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['Float']>;
  paymentNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shared.payment" */
export type Payment_Stddev_Pop_Order_By = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Order_By>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Stddev_Samp_Fields = {
  __typename?: 'payment_stddev_samp_fields';
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['Float']>;
  paymentNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shared.payment" */
export type Payment_Stddev_Samp_Order_By = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Order_By>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment" */
export type Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Stream_Cursor_Value_Input = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Scalars['numeric']>;
  billingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Scalars['bigint']>;
  /** Business date the money left our bank account: the card settled or the check was cashed. Labelled Cleared for every method. Filled from the bank; NULL until then, and on payments coming in. */
  clearedDate?: InputMaybe<Scalars['date']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Business date, in Kansas City time, the payment left us: the day its card was created or its check was printed. Accounting closes the books on this date. Set with the Issued status: for a card by PaymentService.SendClaimPaymentInternal, for a check when it is printed. NULL while Pending and on payments coming in. */
  issuedDate?: InputMaybe<Scalars['date']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  paymentIdentifier?: InputMaybe<Scalars['String']>;
  paymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  paymentNumber?: InputMaybe<Scalars['Int']>;
  paymentStatusTypeId?: InputMaybe<Scalars['uuid']>;
  paymentTypeId?: InputMaybe<Scalars['uuid']>;
  prefixedNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Payment_Sum_Fields = {
  __typename?: 'payment_sum_fields';
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['bigint']>;
  paymentNumber?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "shared.payment" */
export type Payment_Sum_Order_By = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Order_By>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
};

/** update columns of table "shared.payment" */
export enum Payment_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BillingMetadata = 'billingMetadata',
  /** column name */
  CheckNumber = 'checkNumber',
  /** column name */
  ClearedDate = 'clearedDate',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IssuedDate = 'issuedDate',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PaymentIdentifier = 'paymentIdentifier',
  /** column name */
  PaymentMethodTypeId = 'paymentMethodTypeId',
  /** column name */
  PaymentNumber = 'paymentNumber',
  /** column name */
  PaymentStatusTypeId = 'paymentStatusTypeId',
  /** column name */
  PaymentTypeId = 'paymentTypeId',
  /** column name */
  PrefixedNumber = 'prefixedNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Payment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Payment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Payment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Payment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Payment_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Payment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Var_Pop_Fields = {
  __typename?: 'payment_var_pop_fields';
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['Float']>;
  paymentNumber?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shared.payment" */
export type Payment_Var_Pop_Order_By = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Order_By>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Var_Samp_Fields = {
  __typename?: 'payment_var_samp_fields';
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['Float']>;
  paymentNumber?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shared.payment" */
export type Payment_Var_Samp_Order_By = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Order_By>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Variance_Fields = {
  __typename?: 'payment_variance_fields';
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "shared.available_amount" */
  availableAmount?: Maybe<Scalars['numeric']>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: Maybe<Scalars['Float']>;
  paymentNumber?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shared.payment" */
export type Payment_Variance_Order_By = {
  /** Face value of the payment. What actually settled is the sum of its shared.payment_detail allocations, which can differ, for example on a card charged for less than it was issued for. */
  amount?: InputMaybe<Order_By>;
  /** Number printed on the check; NULL for cards and ACH, and for a check until it is printed. Comes from our own check runs. For checks the AS400 printed it is copied from its payment register, VTSMBP.ESPAYR.PTCHKN. The AS400's card voucher numbers are not check numbers and stay in shared.payment_as400. */
  checkNumber?: InputMaybe<Order_By>;
  paymentNumber?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations.policy" */
export type Policy = {
  __typename?: 'policy';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An array relationship */
  policyContracts: Array<PolicyContract>;
  /** An aggregate relationship */
  policyContracts_aggregate: PolicyContract_Aggregate;
  policyNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "operations.policy" */
export type PolicyPolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


/** columns and relationships of "operations.policy" */
export type PolicyPolicyContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};

/** columns and relationships of "claims.policy_claim" */
export type PolicyClaim = {
  __typename?: 'policyClaim';
  /** Represents the date that all GAP claim required documents are received. Null if there are missing documents */
  allRequiredDocumentsReceivedAt?: Maybe<Scalars['timestamptz']>;
  /** Asset Metadata stores mileage as a number and ineligibleVehicleTypeId as a string in a flat json object. DATA_SYNC needs to be adjusted to avoid overwriting this data. */
  assetMetadata: Scalars['jsonb'];
  benefitAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  claimDetail?: Maybe<ClaimDetail>;
  /** An array relationship */
  claimDetails: Array<ClaimDetail>;
  /** An aggregate relationship */
  claimDetails_aggregate: ClaimDetail_Aggregate;
  /** An array relationship */
  claimParts: Array<ClaimPart>;
  /** An aggregate relationship */
  claimParts_aggregate: ClaimPart_Aggregate;
  /** An array relationship */
  claimServiceCenters: Array<ClaimServiceCenter>;
  /** An aggregate relationship */
  claimServiceCenters_aggregate: ClaimServiceCenter_Aggregate;
  claimStatusTypeId: Scalars['uuid'];
  contractId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  documentInstances: Array<DocumentInstance>;
  /** An aggregate relationship */
  documentInstances_aggregate: DocumentInstance_Aggregate;
  /** Sort key for the claims list (IT-8310): failure_date, falling back to the created date when failure_date is NULL or later than creation (future-dated legacy data). Generated column - read-only, recomputed by Postgres. */
  effectiveFailureDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityContentTypes: Array<EntityContentType>;
  /** An aggregate relationship */
  entityContentTypes_aggregate: EntityContentType_Aggregate;
  /** An array relationship */
  entityCustomFields: Array<EntityCustomField>;
  /** An aggregate relationship */
  entityCustomFields_aggregate: EntityCustomField_Aggregate;
  /** An array relationship */
  entityFileStorages: Array<EntityFileStorage>;
  /** An aggregate relationship */
  entityFileStorages_aggregate: EntityFileStorage_Aggregate;
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  failureDate?: Maybe<Scalars['date']>;
  financeBenefitLimitPercent?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  /** IT-7726: Used for cross-table change propagation */
  lastRecalcTrigger?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  legacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  metadata?: Maybe<Scalars['jsonb']>;
  number?: Maybe<Scalars['String']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount: Scalars['numeric'];
  /** An object relationship */
  partLookupProvider?: Maybe<Type>;
  /** The last part lookup provider used to search for part info on this claim. A claim is only allowed to use a single provider. */
  partLookupProviderId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  participants: Array<Participant>;
  /** An aggregate relationship */
  participants_aggregate: Participant_Aggregate;
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
  /** An object relationship */
  policyClaimConcern?: Maybe<PolicyClaimConcern>;
  /** An object relationship */
  policyClaimInsurance?: Maybe<PolicyClaimInsurance>;
  /** An object relationship */
  policyClaimStatusType?: Maybe<Type>;
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  /** An object relationship */
  policyContractListView?: Maybe<PolicyContractListView>;
  /** This is a mapping of claimReportingTypeId to number */
  reportingMetadata?: Maybe<Scalars['jsonb']>;
  salesTaxAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  statusReasonType?: Maybe<Type>;
  statusReasonTypeId?: Maybe<Scalars['uuid']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['numeric']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount: Scalars['numeric'];
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
  typeOfLossId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimAssetMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimClaimDetailsArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimClaimDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimClaimPartsArgs = {
  distinct_on?: InputMaybe<Array<ClaimPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimPart_Order_By>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimClaimParts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimPart_Order_By>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimClaimServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenter_Order_By>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimClaimServiceCenters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenter_Order_By>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimDocumentInstancesArgs = {
  distinct_on?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentInstance_Order_By>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimDocumentInstances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentInstance_Order_By>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimEntityContentTypesArgs = {
  distinct_on?: InputMaybe<Array<EntityContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityContentType_Order_By>>;
  where?: InputMaybe<EntityContentType_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimEntityContentTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityContentType_Order_By>>;
  where?: InputMaybe<EntityContentType_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimEntityCustomFieldsArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomField_Order_By>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimEntityCustomFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomField_Order_By>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimEntityFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimEntityFileStorages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimParticipants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim" */
export type PolicyClaimReportingMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Shows which claim records have been synced to the AS400 */
export type PolicyClaimAs400 = {
  __typename?: 'policyClaimAs400';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  policyClaim: PolicyClaim;
  policyClaimId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "claims.policy_claim_as400" */
export type PolicyClaimAs400_Aggregate = {
  __typename?: 'policyClaimAs400_aggregate';
  aggregate?: Maybe<PolicyClaimAs400_Aggregate_Fields>;
  nodes: Array<PolicyClaimAs400>;
};

/** aggregate fields of "claims.policy_claim_as400" */
export type PolicyClaimAs400_Aggregate_Fields = {
  __typename?: 'policyClaimAs400_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PolicyClaimAs400_Max_Fields>;
  min?: Maybe<PolicyClaimAs400_Min_Fields>;
};


/** aggregate fields of "claims.policy_claim_as400" */
export type PolicyClaimAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyClaimAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.policy_claim_as400". All fields are combined with a logical 'AND'. */
export type PolicyClaimAs400_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyClaimAs400_Bool_Exp>>;
  _not?: InputMaybe<PolicyClaimAs400_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyClaimAs400_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaimId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.policy_claim_as400" */
export enum PolicyClaimAs400_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyClaimAs400Pkey = 'policy_claim_as400_pkey',
  /** unique or primary key constraint on columns "policy_claim_id" */
  PolicyClaimAs400PolicyClaimIdKey = 'policy_claim_as400_policy_claim_id_key'
}

/** input type for inserting data into table "claims.policy_claim_as400" */
export type PolicyClaimAs400_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyClaimAs400_Max_Fields = {
  __typename?: 'policyClaimAs400_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PolicyClaimAs400_Min_Fields = {
  __typename?: 'policyClaimAs400_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.policy_claim_as400" */
export type PolicyClaimAs400_Mutation_Response = {
  __typename?: 'policyClaimAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyClaimAs400>;
};

/** on_conflict condition type for table "claims.policy_claim_as400" */
export type PolicyClaimAs400_On_Conflict = {
  constraint: PolicyClaimAs400_Constraint;
  update_columns?: Array<PolicyClaimAs400_Update_Column>;
  where?: InputMaybe<PolicyClaimAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.policy_claim_as400". */
export type PolicyClaimAs400_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.policy_claim_as400 */
export type PolicyClaimAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.policy_claim_as400" */
export enum PolicyClaimAs400_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.policy_claim_as400" */
export type PolicyClaimAs400_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "policyClaimAs400" */
export type PolicyClaimAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyClaimAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyClaimAs400_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "claims.policy_claim_as400" */
export enum PolicyClaimAs400_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyClaimAs400_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyClaimAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyClaimAs400_Bool_Exp;
};

/** columns and relationships of "claims.policy_claim_concern" */
export type PolicyClaimConcern = {
  __typename?: 'policyClaimConcern';
  cause?: Maybe<Scalars['String']>;
  concern?: Maybe<Scalars['String']>;
  correction?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  policyClaim: PolicyClaim;
  policyClaimId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "claims.policy_claim_concern" */
export type PolicyClaimConcernLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.policy_claim_concern" */
export type PolicyClaimConcernLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "claims.policy_claim_concern" */
export type PolicyClaimConcern_Aggregate = {
  __typename?: 'policyClaimConcern_aggregate';
  aggregate?: Maybe<PolicyClaimConcern_Aggregate_Fields>;
  nodes: Array<PolicyClaimConcern>;
};

/** aggregate fields of "claims.policy_claim_concern" */
export type PolicyClaimConcern_Aggregate_Fields = {
  __typename?: 'policyClaimConcern_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PolicyClaimConcern_Max_Fields>;
  min?: Maybe<PolicyClaimConcern_Min_Fields>;
};


/** aggregate fields of "claims.policy_claim_concern" */
export type PolicyClaimConcern_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyClaimConcern_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.policy_claim_concern". All fields are combined with a logical 'AND'. */
export type PolicyClaimConcern_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyClaimConcern_Bool_Exp>>;
  _not?: InputMaybe<PolicyClaimConcern_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyClaimConcern_Bool_Exp>>;
  cause?: InputMaybe<String_Comparison_Exp>;
  concern?: InputMaybe<String_Comparison_Exp>;
  correction?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaimId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.policy_claim_concern" */
export enum PolicyClaimConcern_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyClaimConcernPkey = 'policy_claim_concern_pkey',
  /** unique or primary key constraint on columns "policy_claim_id" */
  PolicyClaimConcernPolicyClaimIdKey = 'policy_claim_concern_policy_claim_id_key'
}

/** input type for inserting data into table "claims.policy_claim_concern" */
export type PolicyClaimConcern_Insert_Input = {
  cause?: InputMaybe<Scalars['String']>;
  concern?: InputMaybe<Scalars['String']>;
  correction?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyClaimConcern_Max_Fields = {
  __typename?: 'policyClaimConcern_max_fields';
  cause?: Maybe<Scalars['String']>;
  concern?: Maybe<Scalars['String']>;
  correction?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PolicyClaimConcern_Min_Fields = {
  __typename?: 'policyClaimConcern_min_fields';
  cause?: Maybe<Scalars['String']>;
  concern?: Maybe<Scalars['String']>;
  correction?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.policy_claim_concern" */
export type PolicyClaimConcern_Mutation_Response = {
  __typename?: 'policyClaimConcern_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyClaimConcern>;
};

/** input type for inserting object relation for remote table "claims.policy_claim_concern" */
export type PolicyClaimConcern_Obj_Rel_Insert_Input = {
  data: PolicyClaimConcern_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyClaimConcern_On_Conflict>;
};

/** on_conflict condition type for table "claims.policy_claim_concern" */
export type PolicyClaimConcern_On_Conflict = {
  constraint: PolicyClaimConcern_Constraint;
  update_columns?: Array<PolicyClaimConcern_Update_Column>;
  where?: InputMaybe<PolicyClaimConcern_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.policy_claim_concern". */
export type PolicyClaimConcern_Order_By = {
  cause?: InputMaybe<Order_By>;
  concern?: InputMaybe<Order_By>;
  correction?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.policy_claim_concern */
export type PolicyClaimConcern_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.policy_claim_concern" */
export enum PolicyClaimConcern_Select_Column {
  /** column name */
  Cause = 'cause',
  /** column name */
  Concern = 'concern',
  /** column name */
  Correction = 'correction',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.policy_claim_concern" */
export type PolicyClaimConcern_Set_Input = {
  cause?: InputMaybe<Scalars['String']>;
  concern?: InputMaybe<Scalars['String']>;
  correction?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "policyClaimConcern" */
export type PolicyClaimConcern_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyClaimConcern_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyClaimConcern_Stream_Cursor_Value_Input = {
  cause?: InputMaybe<Scalars['String']>;
  concern?: InputMaybe<Scalars['String']>;
  correction?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "claims.policy_claim_concern" */
export enum PolicyClaimConcern_Update_Column {
  /** column name */
  Cause = 'cause',
  /** column name */
  Concern = 'concern',
  /** column name */
  Correction = 'correction',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyClaimConcern_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyClaimConcern_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyClaimConcern_Bool_Exp;
};

/** This table holds the insurance information about a claim */
export type PolicyClaimInsurance = {
  __typename?: 'policyClaimInsurance';
  /** An object relationship */
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['uuid']>;
  claimNumber?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  /** An object relationship */
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deductibleAmount?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  policyClaim: PolicyClaim;
  policyClaimId: Scalars['uuid'];
  policyNumber?: Maybe<Scalars['String']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['numeric']>;
  /** Computed newest date in date fields in settlement_metadata, intended to be read only */
  settlementDate?: Maybe<Scalars['date']>;
  settlementMetadata: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
};


/** This table holds the insurance information about a claim */
export type PolicyClaimInsuranceLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** This table holds the insurance information about a claim */
export type PolicyClaimInsuranceLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** This table holds the insurance information about a claim */
export type PolicyClaimInsuranceSettlementMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Aggregate = {
  __typename?: 'policyClaimInsurance_aggregate';
  aggregate?: Maybe<PolicyClaimInsurance_Aggregate_Fields>;
  nodes: Array<PolicyClaimInsurance>;
};

export type PolicyClaimInsurance_Aggregate_Bool_Exp = {
  count?: InputMaybe<PolicyClaimInsurance_Aggregate_Bool_Exp_Count>;
};

export type PolicyClaimInsurance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PolicyClaimInsurance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Aggregate_Fields = {
  __typename?: 'policyClaimInsurance_aggregate_fields';
  avg?: Maybe<PolicyClaimInsurance_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyClaimInsurance_Max_Fields>;
  min?: Maybe<PolicyClaimInsurance_Min_Fields>;
  stddev?: Maybe<PolicyClaimInsurance_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyClaimInsurance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyClaimInsurance_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyClaimInsurance_Sum_Fields>;
  var_pop?: Maybe<PolicyClaimInsurance_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyClaimInsurance_Var_Samp_Fields>;
  variance?: Maybe<PolicyClaimInsurance_Variance_Fields>;
};


/** aggregate fields of "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyClaimInsurance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Aggregate_Order_By = {
  avg?: InputMaybe<PolicyClaimInsurance_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PolicyClaimInsurance_Max_Order_By>;
  min?: InputMaybe<PolicyClaimInsurance_Min_Order_By>;
  stddev?: InputMaybe<PolicyClaimInsurance_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PolicyClaimInsurance_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PolicyClaimInsurance_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PolicyClaimInsurance_Sum_Order_By>;
  var_pop?: InputMaybe<PolicyClaimInsurance_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PolicyClaimInsurance_Var_Samp_Order_By>;
  variance?: InputMaybe<PolicyClaimInsurance_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyClaimInsurance_Append_Input = {
  settlementMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Arr_Rel_Insert_Input = {
  data: Array<PolicyClaimInsurance_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyClaimInsurance_On_Conflict>;
};

/** aggregate avg on columns */
export type PolicyClaimInsurance_Avg_Fields = {
  __typename?: 'policyClaimInsurance_avg_fields';
  deductibleAmount?: Maybe<Scalars['Float']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Avg_Order_By = {
  deductibleAmount?: InputMaybe<Order_By>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "claims.policy_claim_insurance". All fields are combined with a logical 'AND'. */
export type PolicyClaimInsurance_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyClaimInsurance_Bool_Exp>>;
  _not?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyClaimInsurance_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  addressId?: InputMaybe<Uuid_Comparison_Exp>;
  claimNumber?: InputMaybe<String_Comparison_Exp>;
  companyName?: InputMaybe<String_Comparison_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contactId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deductibleAmount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  policyClaim?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaimId?: InputMaybe<Uuid_Comparison_Exp>;
  policyNumber?: InputMaybe<String_Comparison_Exp>;
  settlementAmount?: InputMaybe<Numeric_Comparison_Exp>;
  settlementDate?: InputMaybe<Date_Comparison_Exp>;
  settlementMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.policy_claim_insurance" */
export enum PolicyClaimInsurance_Constraint {
  /** unique or primary key constraint on columns "address_id" */
  PolicyClaimInsuranceAddressIdKey = 'policy_claim_insurance_address_id_key',
  /** unique or primary key constraint on columns "id" */
  PolicyClaimInsurancePkey = 'policy_claim_insurance_pkey',
  /** unique or primary key constraint on columns "policy_claim_id" */
  PolicyClaimInsurancePolicyClaimIdKey = 'policy_claim_insurance_policy_claim_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyClaimInsurance_Delete_At_Path_Input = {
  settlementMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyClaimInsurance_Delete_Elem_Input = {
  settlementMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyClaimInsurance_Delete_Key_Input = {
  settlementMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Inc_Input = {
  deductibleAmount?: InputMaybe<Scalars['numeric']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  addressId?: InputMaybe<Scalars['uuid']>;
  claimNumber?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deductibleAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  policyClaim?: InputMaybe<PolicyClaim_Obj_Rel_Insert_Input>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Scalars['numeric']>;
  /** Computed newest date in date fields in settlement_metadata, intended to be read only */
  settlementDate?: InputMaybe<Scalars['date']>;
  settlementMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyClaimInsurance_Max_Fields = {
  __typename?: 'policyClaimInsurance_max_fields';
  addressId?: Maybe<Scalars['uuid']>;
  claimNumber?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deductibleAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  policyNumber?: Maybe<Scalars['String']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['numeric']>;
  /** Computed newest date in date fields in settlement_metadata, intended to be read only */
  settlementDate?: Maybe<Scalars['date']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Max_Order_By = {
  addressId?: InputMaybe<Order_By>;
  claimNumber?: InputMaybe<Order_By>;
  companyName?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  policyNumber?: InputMaybe<Order_By>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Order_By>;
  /** Computed newest date in date fields in settlement_metadata, intended to be read only */
  settlementDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PolicyClaimInsurance_Min_Fields = {
  __typename?: 'policyClaimInsurance_min_fields';
  addressId?: Maybe<Scalars['uuid']>;
  claimNumber?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deductibleAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  policyClaimId?: Maybe<Scalars['uuid']>;
  policyNumber?: Maybe<Scalars['String']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['numeric']>;
  /** Computed newest date in date fields in settlement_metadata, intended to be read only */
  settlementDate?: Maybe<Scalars['date']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Min_Order_By = {
  addressId?: InputMaybe<Order_By>;
  claimNumber?: InputMaybe<Order_By>;
  companyName?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  policyNumber?: InputMaybe<Order_By>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Order_By>;
  /** Computed newest date in date fields in settlement_metadata, intended to be read only */
  settlementDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Mutation_Response = {
  __typename?: 'policyClaimInsurance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyClaimInsurance>;
};

/** input type for inserting object relation for remote table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Obj_Rel_Insert_Input = {
  data: PolicyClaimInsurance_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyClaimInsurance_On_Conflict>;
};

/** on_conflict condition type for table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_On_Conflict = {
  constraint: PolicyClaimInsurance_Constraint;
  update_columns?: Array<PolicyClaimInsurance_Update_Column>;
  where?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.policy_claim_insurance". */
export type PolicyClaimInsurance_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  addressId?: InputMaybe<Order_By>;
  claimNumber?: InputMaybe<Order_By>;
  companyName?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  policyClaim?: InputMaybe<PolicyClaim_Order_By>;
  policyClaimId?: InputMaybe<Order_By>;
  policyNumber?: InputMaybe<Order_By>;
  settlementAmount?: InputMaybe<Order_By>;
  settlementDate?: InputMaybe<Order_By>;
  settlementMetadata?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.policy_claim_insurance */
export type PolicyClaimInsurance_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicyClaimInsurance_Prepend_Input = {
  settlementMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "claims.policy_claim_insurance" */
export enum PolicyClaimInsurance_Select_Column {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  ClaimNumber = 'claimNumber',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeductibleAmount = 'deductibleAmount',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  PolicyNumber = 'policyNumber',
  /** column name */
  SettlementAmount = 'settlementAmount',
  /** column name */
  SettlementDate = 'settlementDate',
  /** column name */
  SettlementMetadata = 'settlementMetadata',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Set_Input = {
  addressId?: InputMaybe<Scalars['uuid']>;
  claimNumber?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deductibleAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Scalars['numeric']>;
  /** Computed newest date in date fields in settlement_metadata, intended to be read only */
  settlementDate?: InputMaybe<Scalars['date']>;
  settlementMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PolicyClaimInsurance_Stddev_Fields = {
  __typename?: 'policyClaimInsurance_stddev_fields';
  deductibleAmount?: Maybe<Scalars['Float']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Stddev_Order_By = {
  deductibleAmount?: InputMaybe<Order_By>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PolicyClaimInsurance_Stddev_Pop_Fields = {
  __typename?: 'policyClaimInsurance_stddev_pop_fields';
  deductibleAmount?: Maybe<Scalars['Float']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Stddev_Pop_Order_By = {
  deductibleAmount?: InputMaybe<Order_By>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PolicyClaimInsurance_Stddev_Samp_Fields = {
  __typename?: 'policyClaimInsurance_stddev_samp_fields';
  deductibleAmount?: Maybe<Scalars['Float']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Stddev_Samp_Order_By = {
  deductibleAmount?: InputMaybe<Order_By>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "policyClaimInsurance" */
export type PolicyClaimInsurance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyClaimInsurance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyClaimInsurance_Stream_Cursor_Value_Input = {
  addressId?: InputMaybe<Scalars['uuid']>;
  claimNumber?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deductibleAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyClaimId?: InputMaybe<Scalars['uuid']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Scalars['numeric']>;
  /** Computed newest date in date fields in settlement_metadata, intended to be read only */
  settlementDate?: InputMaybe<Scalars['date']>;
  settlementMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PolicyClaimInsurance_Sum_Fields = {
  __typename?: 'policyClaimInsurance_sum_fields';
  deductibleAmount?: Maybe<Scalars['numeric']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Sum_Order_By = {
  deductibleAmount?: InputMaybe<Order_By>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Order_By>;
};

/** update columns of table "claims.policy_claim_insurance" */
export enum PolicyClaimInsurance_Update_Column {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  ClaimNumber = 'claimNumber',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeductibleAmount = 'deductibleAmount',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyClaimId = 'policyClaimId',
  /** column name */
  PolicyNumber = 'policyNumber',
  /** column name */
  SettlementAmount = 'settlementAmount',
  /** column name */
  SettlementDate = 'settlementDate',
  /** column name */
  SettlementMetadata = 'settlementMetadata',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyClaimInsurance_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyClaimInsurance_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyClaimInsurance_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyClaimInsurance_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyClaimInsurance_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyClaimInsurance_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicyClaimInsurance_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyClaimInsurance_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyClaimInsurance_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyClaimInsurance_Var_Pop_Fields = {
  __typename?: 'policyClaimInsurance_var_pop_fields';
  deductibleAmount?: Maybe<Scalars['Float']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Var_Pop_Order_By = {
  deductibleAmount?: InputMaybe<Order_By>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PolicyClaimInsurance_Var_Samp_Fields = {
  __typename?: 'policyClaimInsurance_var_samp_fields';
  deductibleAmount?: Maybe<Scalars['Float']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Var_Samp_Order_By = {
  deductibleAmount?: InputMaybe<Order_By>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PolicyClaimInsurance_Variance_Fields = {
  __typename?: 'policyClaimInsurance_variance_fields';
  deductibleAmount?: Maybe<Scalars['Float']>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "claims.policy_claim_insurance" */
export type PolicyClaimInsurance_Variance_Order_By = {
  deductibleAmount?: InputMaybe<Order_By>;
  /** Computed total of all amount fields in settlement_metadata, intended to be read only */
  settlementAmount?: InputMaybe<Order_By>;
};

/** aggregated selection of "claims.policy_claim" */
export type PolicyClaim_Aggregate = {
  __typename?: 'policyClaim_aggregate';
  aggregate?: Maybe<PolicyClaim_Aggregate_Fields>;
  nodes: Array<PolicyClaim>;
};

export type PolicyClaim_Aggregate_Bool_Exp = {
  count?: InputMaybe<PolicyClaim_Aggregate_Bool_Exp_Count>;
};

export type PolicyClaim_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyClaim_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.policy_claim" */
export type PolicyClaim_Aggregate_Fields = {
  __typename?: 'policyClaim_aggregate_fields';
  avg?: Maybe<PolicyClaim_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyClaim_Max_Fields>;
  min?: Maybe<PolicyClaim_Min_Fields>;
  stddev?: Maybe<PolicyClaim_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyClaim_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyClaim_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyClaim_Sum_Fields>;
  var_pop?: Maybe<PolicyClaim_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyClaim_Var_Samp_Fields>;
  variance?: Maybe<PolicyClaim_Variance_Fields>;
};


/** aggregate fields of "claims.policy_claim" */
export type PolicyClaim_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.policy_claim" */
export type PolicyClaim_Aggregate_Order_By = {
  avg?: InputMaybe<PolicyClaim_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PolicyClaim_Max_Order_By>;
  min?: InputMaybe<PolicyClaim_Min_Order_By>;
  stddev?: InputMaybe<PolicyClaim_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PolicyClaim_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PolicyClaim_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PolicyClaim_Sum_Order_By>;
  var_pop?: InputMaybe<PolicyClaim_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PolicyClaim_Var_Samp_Order_By>;
  variance?: InputMaybe<PolicyClaim_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyClaim_Append_Input = {
  /** Asset Metadata stores mileage as a number and ineligibleVehicleTypeId as a string in a flat json object. DATA_SYNC needs to be adjusted to avoid overwriting this data. */
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** This is a mapping of claimReportingTypeId to number */
  reportingMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "claims.policy_claim" */
export type PolicyClaim_Arr_Rel_Insert_Input = {
  data: Array<PolicyClaim_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyClaim_On_Conflict>;
};

/** aggregate avg on columns */
export type PolicyClaim_Avg_Fields = {
  __typename?: 'policyClaim_avg_fields';
  benefitAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['Float']>;
  financeBenefitLimitPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: Maybe<Scalars['Float']>;
  salesTaxAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: Maybe<Scalars['Float']>;
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
};

/** order by avg() on columns of table "claims.policy_claim" */
export type PolicyClaim_Avg_Order_By = {
  benefitAmount?: InputMaybe<Order_By>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "claims.policy_claim". All fields are combined with a logical 'AND'. */
export type PolicyClaim_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyClaim_Bool_Exp>>;
  _not?: InputMaybe<PolicyClaim_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyClaim_Bool_Exp>>;
  allRequiredDocumentsReceivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  assetMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  benefitAmount?: InputMaybe<Numeric_Comparison_Exp>;
  benefitLimitAmount?: InputMaybe<Numeric_Comparison_Exp>;
  claimDetail?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimDetails?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimDetails_aggregate?: InputMaybe<ClaimDetail_Aggregate_Bool_Exp>;
  claimParts?: InputMaybe<ClaimPart_Bool_Exp>;
  claimParts_aggregate?: InputMaybe<ClaimPart_Aggregate_Bool_Exp>;
  claimServiceCenters?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  claimServiceCenters_aggregate?: InputMaybe<ClaimServiceCenter_Aggregate_Bool_Exp>;
  claimStatusTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  contractId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  documentInstances?: InputMaybe<DocumentInstance_Bool_Exp>;
  documentInstances_aggregate?: InputMaybe<DocumentInstance_Aggregate_Bool_Exp>;
  effectiveFailureDate?: InputMaybe<Date_Comparison_Exp>;
  entityContentTypes?: InputMaybe<EntityContentType_Bool_Exp>;
  entityContentTypes_aggregate?: InputMaybe<EntityContentType_Aggregate_Bool_Exp>;
  entityCustomFields?: InputMaybe<EntityCustomField_Bool_Exp>;
  entityCustomFields_aggregate?: InputMaybe<EntityCustomField_Aggregate_Bool_Exp>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Bool_Exp>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Bool_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  failureDate?: InputMaybe<Date_Comparison_Exp>;
  financeBenefitLimitPercent?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastRecalcTrigger?: InputMaybe<Timestamptz_Comparison_Exp>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  owedAmount?: InputMaybe<Numeric_Comparison_Exp>;
  partLookupProvider?: InputMaybe<Type_Bool_Exp>;
  partLookupProviderId?: InputMaybe<Uuid_Comparison_Exp>;
  participants?: InputMaybe<Participant_Bool_Exp>;
  participants_aggregate?: InputMaybe<Participant_Aggregate_Bool_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Bool_Exp>;
  policyClaimConcern?: InputMaybe<PolicyClaimConcern_Bool_Exp>;
  policyClaimInsurance?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
  policyClaimStatusType?: InputMaybe<Type_Bool_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractListView?: InputMaybe<PolicyContractListView_Bool_Exp>;
  reportingMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  salesTaxAmount?: InputMaybe<Numeric_Comparison_Exp>;
  salesTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  statusReasonType?: InputMaybe<Type_Bool_Exp>;
  statusReasonTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  totalCost?: InputMaybe<Numeric_Comparison_Exp>;
  totalPaidAmount?: InputMaybe<Numeric_Comparison_Exp>;
  total_claim_amount?: InputMaybe<Numeric_Comparison_Exp>;
  typeOfLossId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.policy_claim" */
export enum PolicyClaim_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyClaimPkey = 'policy_claim_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyClaim_Delete_At_Path_Input = {
  /** Asset Metadata stores mileage as a number and ineligibleVehicleTypeId as a string in a flat json object. DATA_SYNC needs to be adjusted to avoid overwriting this data. */
  assetMetadata?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<Scalars['String']>>;
  /** This is a mapping of claimReportingTypeId to number */
  reportingMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyClaim_Delete_Elem_Input = {
  /** Asset Metadata stores mileage as a number and ineligibleVehicleTypeId as a string in a flat json object. DATA_SYNC needs to be adjusted to avoid overwriting this data. */
  assetMetadata?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['Int']>;
  /** This is a mapping of claimReportingTypeId to number */
  reportingMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyClaim_Delete_Key_Input = {
  /** Asset Metadata stores mileage as a number and ineligibleVehicleTypeId as a string in a flat json object. DATA_SYNC needs to be adjusted to avoid overwriting this data. */
  assetMetadata?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
  /** This is a mapping of claimReportingTypeId to number */
  reportingMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "claims.policy_claim" */
export type PolicyClaim_Inc_Input = {
  benefitAmount?: InputMaybe<Scalars['numeric']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Scalars['numeric']>;
  financeBenefitLimitPercent?: InputMaybe<Scalars['numeric']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Scalars['numeric']>;
  salesTaxAmount?: InputMaybe<Scalars['numeric']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Scalars['numeric']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Scalars['numeric']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claims.policy_claim" */
export type PolicyClaim_Insert_Input = {
  /** Represents the date that all GAP claim required documents are received. Null if there are missing documents */
  allRequiredDocumentsReceivedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Asset Metadata stores mileage as a number and ineligibleVehicleTypeId as a string in a flat json object. DATA_SYNC needs to be adjusted to avoid overwriting this data. */
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  benefitAmount?: InputMaybe<Scalars['numeric']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Scalars['numeric']>;
  claimDetail?: InputMaybe<ClaimDetail_Obj_Rel_Insert_Input>;
  claimDetails?: InputMaybe<ClaimDetail_Arr_Rel_Insert_Input>;
  claimParts?: InputMaybe<ClaimPart_Arr_Rel_Insert_Input>;
  claimServiceCenters?: InputMaybe<ClaimServiceCenter_Arr_Rel_Insert_Input>;
  claimStatusTypeId?: InputMaybe<Scalars['uuid']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  documentInstances?: InputMaybe<DocumentInstance_Arr_Rel_Insert_Input>;
  entityContentTypes?: InputMaybe<EntityContentType_Arr_Rel_Insert_Input>;
  entityCustomFields?: InputMaybe<EntityCustomField_Arr_Rel_Insert_Input>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Arr_Rel_Insert_Input>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  failureDate?: InputMaybe<Scalars['date']>;
  financeBenefitLimitPercent?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** IT-7726: Used for cross-table change propagation */
  lastRecalcTrigger?: InputMaybe<Scalars['timestamptz']>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Obj_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  number?: InputMaybe<Scalars['String']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Scalars['numeric']>;
  partLookupProvider?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** The last part lookup provider used to search for part info on this claim. A claim is only allowed to use a single provider. */
  partLookupProviderId?: InputMaybe<Scalars['uuid']>;
  participants?: InputMaybe<Participant_Arr_Rel_Insert_Input>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
  policyClaimConcern?: InputMaybe<PolicyClaimConcern_Obj_Rel_Insert_Input>;
  policyClaimInsurance?: InputMaybe<PolicyClaimInsurance_Obj_Rel_Insert_Input>;
  policyClaimStatusType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  policyContractListView?: InputMaybe<PolicyContractListView_Obj_Rel_Insert_Input>;
  /** This is a mapping of claimReportingTypeId to number */
  reportingMetadata?: InputMaybe<Scalars['jsonb']>;
  salesTaxAmount?: InputMaybe<Scalars['numeric']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Scalars['numeric']>;
  statusReasonType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  statusReasonTypeId?: InputMaybe<Scalars['uuid']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Scalars['numeric']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Scalars['numeric']>;
  typeOfLossId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyClaim_Max_Fields = {
  __typename?: 'policyClaim_max_fields';
  /** Represents the date that all GAP claim required documents are received. Null if there are missing documents */
  allRequiredDocumentsReceivedAt?: Maybe<Scalars['timestamptz']>;
  benefitAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['numeric']>;
  claimStatusTypeId?: Maybe<Scalars['uuid']>;
  contractId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** Sort key for the claims list (IT-8310): failure_date, falling back to the created date when failure_date is NULL or later than creation (future-dated legacy data). Generated column - read-only, recomputed by Postgres. */
  effectiveFailureDate?: Maybe<Scalars['date']>;
  failureDate?: Maybe<Scalars['date']>;
  financeBenefitLimitPercent?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  /** IT-7726: Used for cross-table change propagation */
  lastRecalcTrigger?: Maybe<Scalars['timestamptz']>;
  number?: Maybe<Scalars['String']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The last part lookup provider used to search for part info on this claim. A claim is only allowed to use a single provider. */
  partLookupProviderId?: Maybe<Scalars['uuid']>;
  salesTaxAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['numeric']>;
  statusReasonTypeId?: Maybe<Scalars['uuid']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['numeric']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: Maybe<Scalars['numeric']>;
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
  typeOfLossId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "claims.policy_claim" */
export type PolicyClaim_Max_Order_By = {
  /** Represents the date that all GAP claim required documents are received. Null if there are missing documents */
  allRequiredDocumentsReceivedAt?: InputMaybe<Order_By>;
  benefitAmount?: InputMaybe<Order_By>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Order_By>;
  claimStatusTypeId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** Sort key for the claims list (IT-8310): failure_date, falling back to the created date when failure_date is NULL or later than creation (future-dated legacy data). Generated column - read-only, recomputed by Postgres. */
  effectiveFailureDate?: InputMaybe<Order_By>;
  failureDate?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** IT-7726: Used for cross-table change propagation */
  lastRecalcTrigger?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Order_By>;
  /** The last part lookup provider used to search for part info on this claim. A claim is only allowed to use a single provider. */
  partLookupProviderId?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Order_By>;
  statusReasonTypeId?: InputMaybe<Order_By>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Order_By>;
  typeOfLossId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PolicyClaim_Min_Fields = {
  __typename?: 'policyClaim_min_fields';
  /** Represents the date that all GAP claim required documents are received. Null if there are missing documents */
  allRequiredDocumentsReceivedAt?: Maybe<Scalars['timestamptz']>;
  benefitAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['numeric']>;
  claimStatusTypeId?: Maybe<Scalars['uuid']>;
  contractId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** Sort key for the claims list (IT-8310): failure_date, falling back to the created date when failure_date is NULL or later than creation (future-dated legacy data). Generated column - read-only, recomputed by Postgres. */
  effectiveFailureDate?: Maybe<Scalars['date']>;
  failureDate?: Maybe<Scalars['date']>;
  financeBenefitLimitPercent?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  /** IT-7726: Used for cross-table change propagation */
  lastRecalcTrigger?: Maybe<Scalars['timestamptz']>;
  number?: Maybe<Scalars['String']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** The last part lookup provider used to search for part info on this claim. A claim is only allowed to use a single provider. */
  partLookupProviderId?: Maybe<Scalars['uuid']>;
  salesTaxAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['numeric']>;
  statusReasonTypeId?: Maybe<Scalars['uuid']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['numeric']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: Maybe<Scalars['numeric']>;
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
  typeOfLossId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "claims.policy_claim" */
export type PolicyClaim_Min_Order_By = {
  /** Represents the date that all GAP claim required documents are received. Null if there are missing documents */
  allRequiredDocumentsReceivedAt?: InputMaybe<Order_By>;
  benefitAmount?: InputMaybe<Order_By>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Order_By>;
  claimStatusTypeId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** Sort key for the claims list (IT-8310): failure_date, falling back to the created date when failure_date is NULL or later than creation (future-dated legacy data). Generated column - read-only, recomputed by Postgres. */
  effectiveFailureDate?: InputMaybe<Order_By>;
  failureDate?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** IT-7726: Used for cross-table change propagation */
  lastRecalcTrigger?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Order_By>;
  /** The last part lookup provider used to search for part info on this claim. A claim is only allowed to use a single provider. */
  partLookupProviderId?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Order_By>;
  statusReasonTypeId?: InputMaybe<Order_By>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Order_By>;
  typeOfLossId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.policy_claim" */
export type PolicyClaim_Mutation_Response = {
  __typename?: 'policyClaim_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyClaim>;
};

/** input type for inserting object relation for remote table "claims.policy_claim" */
export type PolicyClaim_Obj_Rel_Insert_Input = {
  data: PolicyClaim_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyClaim_On_Conflict>;
};

/** on_conflict condition type for table "claims.policy_claim" */
export type PolicyClaim_On_Conflict = {
  constraint: PolicyClaim_Constraint;
  update_columns?: Array<PolicyClaim_Update_Column>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.policy_claim". */
export type PolicyClaim_Order_By = {
  allRequiredDocumentsReceivedAt?: InputMaybe<Order_By>;
  assetMetadata?: InputMaybe<Order_By>;
  benefitAmount?: InputMaybe<Order_By>;
  benefitLimitAmount?: InputMaybe<Order_By>;
  claimDetail?: InputMaybe<ClaimDetail_Order_By>;
  claimDetails_aggregate?: InputMaybe<ClaimDetail_Aggregate_Order_By>;
  claimParts_aggregate?: InputMaybe<ClaimPart_Aggregate_Order_By>;
  claimServiceCenters_aggregate?: InputMaybe<ClaimServiceCenter_Aggregate_Order_By>;
  claimStatusTypeId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  documentInstances_aggregate?: InputMaybe<DocumentInstance_Aggregate_Order_By>;
  effectiveFailureDate?: InputMaybe<Order_By>;
  entityContentTypes_aggregate?: InputMaybe<EntityContentType_Aggregate_Order_By>;
  entityCustomFields_aggregate?: InputMaybe<EntityCustomField_Aggregate_Order_By>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  failureDate?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastRecalcTrigger?: InputMaybe<Order_By>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  owedAmount?: InputMaybe<Order_By>;
  partLookupProvider?: InputMaybe<Type_Order_By>;
  partLookupProviderId?: InputMaybe<Order_By>;
  participants_aggregate?: InputMaybe<Participant_Aggregate_Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
  policyClaimConcern?: InputMaybe<PolicyClaimConcern_Order_By>;
  policyClaimInsurance?: InputMaybe<PolicyClaimInsurance_Order_By>;
  policyClaimStatusType?: InputMaybe<Type_Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractListView?: InputMaybe<PolicyContractListView_Order_By>;
  reportingMetadata?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  salesTaxPercent?: InputMaybe<Order_By>;
  statusReasonType?: InputMaybe<Type_Order_By>;
  statusReasonTypeId?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
  totalPaidAmount?: InputMaybe<Order_By>;
  total_claim_amount?: InputMaybe<Order_By>;
  typeOfLossId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.policy_claim */
export type PolicyClaim_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicyClaim_Prepend_Input = {
  /** Asset Metadata stores mileage as a number and ineligibleVehicleTypeId as a string in a flat json object. DATA_SYNC needs to be adjusted to avoid overwriting this data. */
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** This is a mapping of claimReportingTypeId to number */
  reportingMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "claims.policy_claim" */
export enum PolicyClaim_Select_Column {
  /** column name */
  AllRequiredDocumentsReceivedAt = 'allRequiredDocumentsReceivedAt',
  /** column name */
  AssetMetadata = 'assetMetadata',
  /** column name */
  BenefitAmount = 'benefitAmount',
  /** column name */
  BenefitLimitAmount = 'benefitLimitAmount',
  /** column name */
  ClaimStatusTypeId = 'claimStatusTypeId',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveFailureDate = 'effectiveFailureDate',
  /** column name */
  FailureDate = 'failureDate',
  /** column name */
  FinanceBenefitLimitPercent = 'financeBenefitLimitPercent',
  /** column name */
  Id = 'id',
  /** column name */
  LastRecalcTrigger = 'lastRecalcTrigger',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Number = 'number',
  /** column name */
  OwedAmount = 'owedAmount',
  /** column name */
  PartLookupProviderId = 'partLookupProviderId',
  /** column name */
  ReportingMetadata = 'reportingMetadata',
  /** column name */
  SalesTaxAmount = 'salesTaxAmount',
  /** column name */
  SalesTaxPercent = 'salesTaxPercent',
  /** column name */
  StatusReasonTypeId = 'statusReasonTypeId',
  /** column name */
  TotalCost = 'totalCost',
  /** column name */
  TotalPaidAmount = 'totalPaidAmount',
  /** column name */
  TypeOfLossId = 'typeOfLossId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.policy_claim" */
export type PolicyClaim_Set_Input = {
  /** Represents the date that all GAP claim required documents are received. Null if there are missing documents */
  allRequiredDocumentsReceivedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Asset Metadata stores mileage as a number and ineligibleVehicleTypeId as a string in a flat json object. DATA_SYNC needs to be adjusted to avoid overwriting this data. */
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  benefitAmount?: InputMaybe<Scalars['numeric']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Scalars['numeric']>;
  claimStatusTypeId?: InputMaybe<Scalars['uuid']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  failureDate?: InputMaybe<Scalars['date']>;
  financeBenefitLimitPercent?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** IT-7726: Used for cross-table change propagation */
  lastRecalcTrigger?: InputMaybe<Scalars['timestamptz']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  number?: InputMaybe<Scalars['String']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Scalars['numeric']>;
  /** The last part lookup provider used to search for part info on this claim. A claim is only allowed to use a single provider. */
  partLookupProviderId?: InputMaybe<Scalars['uuid']>;
  /** This is a mapping of claimReportingTypeId to number */
  reportingMetadata?: InputMaybe<Scalars['jsonb']>;
  salesTaxAmount?: InputMaybe<Scalars['numeric']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Scalars['numeric']>;
  statusReasonTypeId?: InputMaybe<Scalars['uuid']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Scalars['numeric']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Scalars['numeric']>;
  typeOfLossId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PolicyClaim_Stddev_Fields = {
  __typename?: 'policyClaim_stddev_fields';
  benefitAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['Float']>;
  financeBenefitLimitPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: Maybe<Scalars['Float']>;
  salesTaxAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: Maybe<Scalars['Float']>;
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "claims.policy_claim" */
export type PolicyClaim_Stddev_Order_By = {
  benefitAmount?: InputMaybe<Order_By>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PolicyClaim_Stddev_Pop_Fields = {
  __typename?: 'policyClaim_stddev_pop_fields';
  benefitAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['Float']>;
  financeBenefitLimitPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: Maybe<Scalars['Float']>;
  salesTaxAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: Maybe<Scalars['Float']>;
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
};

/** order by stddev_pop() on columns of table "claims.policy_claim" */
export type PolicyClaim_Stddev_Pop_Order_By = {
  benefitAmount?: InputMaybe<Order_By>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PolicyClaim_Stddev_Samp_Fields = {
  __typename?: 'policyClaim_stddev_samp_fields';
  benefitAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['Float']>;
  financeBenefitLimitPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: Maybe<Scalars['Float']>;
  salesTaxAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: Maybe<Scalars['Float']>;
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
};

/** order by stddev_samp() on columns of table "claims.policy_claim" */
export type PolicyClaim_Stddev_Samp_Order_By = {
  benefitAmount?: InputMaybe<Order_By>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "policyClaim" */
export type PolicyClaim_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyClaim_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyClaim_Stream_Cursor_Value_Input = {
  /** Represents the date that all GAP claim required documents are received. Null if there are missing documents */
  allRequiredDocumentsReceivedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Asset Metadata stores mileage as a number and ineligibleVehicleTypeId as a string in a flat json object. DATA_SYNC needs to be adjusted to avoid overwriting this data. */
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  benefitAmount?: InputMaybe<Scalars['numeric']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Scalars['numeric']>;
  claimStatusTypeId?: InputMaybe<Scalars['uuid']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** Sort key for the claims list (IT-8310): failure_date, falling back to the created date when failure_date is NULL or later than creation (future-dated legacy data). Generated column - read-only, recomputed by Postgres. */
  effectiveFailureDate?: InputMaybe<Scalars['date']>;
  failureDate?: InputMaybe<Scalars['date']>;
  financeBenefitLimitPercent?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** IT-7726: Used for cross-table change propagation */
  lastRecalcTrigger?: InputMaybe<Scalars['timestamptz']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  number?: InputMaybe<Scalars['String']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Scalars['numeric']>;
  /** The last part lookup provider used to search for part info on this claim. A claim is only allowed to use a single provider. */
  partLookupProviderId?: InputMaybe<Scalars['uuid']>;
  /** This is a mapping of claimReportingTypeId to number */
  reportingMetadata?: InputMaybe<Scalars['jsonb']>;
  salesTaxAmount?: InputMaybe<Scalars['numeric']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Scalars['numeric']>;
  statusReasonTypeId?: InputMaybe<Scalars['uuid']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Scalars['numeric']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Scalars['numeric']>;
  typeOfLossId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PolicyClaim_Sum_Fields = {
  __typename?: 'policyClaim_sum_fields';
  benefitAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['numeric']>;
  financeBenefitLimitPercent?: Maybe<Scalars['numeric']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: Maybe<Scalars['numeric']>;
  salesTaxAmount?: Maybe<Scalars['numeric']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['numeric']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['numeric']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: Maybe<Scalars['numeric']>;
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "claims.policy_claim" */
export type PolicyClaim_Sum_Order_By = {
  benefitAmount?: InputMaybe<Order_By>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Order_By>;
};

/** update columns of table "claims.policy_claim" */
export enum PolicyClaim_Update_Column {
  /** column name */
  AllRequiredDocumentsReceivedAt = 'allRequiredDocumentsReceivedAt',
  /** column name */
  AssetMetadata = 'assetMetadata',
  /** column name */
  BenefitAmount = 'benefitAmount',
  /** column name */
  BenefitLimitAmount = 'benefitLimitAmount',
  /** column name */
  ClaimStatusTypeId = 'claimStatusTypeId',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  FailureDate = 'failureDate',
  /** column name */
  FinanceBenefitLimitPercent = 'financeBenefitLimitPercent',
  /** column name */
  Id = 'id',
  /** column name */
  LastRecalcTrigger = 'lastRecalcTrigger',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Number = 'number',
  /** column name */
  OwedAmount = 'owedAmount',
  /** column name */
  PartLookupProviderId = 'partLookupProviderId',
  /** column name */
  ReportingMetadata = 'reportingMetadata',
  /** column name */
  SalesTaxAmount = 'salesTaxAmount',
  /** column name */
  SalesTaxPercent = 'salesTaxPercent',
  /** column name */
  StatusReasonTypeId = 'statusReasonTypeId',
  /** column name */
  TotalCost = 'totalCost',
  /** column name */
  TotalPaidAmount = 'totalPaidAmount',
  /** column name */
  TypeOfLossId = 'typeOfLossId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyClaim_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyClaim_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyClaim_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyClaim_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyClaim_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyClaim_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicyClaim_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyClaim_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyClaim_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyClaim_Var_Pop_Fields = {
  __typename?: 'policyClaim_var_pop_fields';
  benefitAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['Float']>;
  financeBenefitLimitPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: Maybe<Scalars['Float']>;
  salesTaxAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: Maybe<Scalars['Float']>;
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
};

/** order by var_pop() on columns of table "claims.policy_claim" */
export type PolicyClaim_Var_Pop_Order_By = {
  benefitAmount?: InputMaybe<Order_By>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PolicyClaim_Var_Samp_Fields = {
  __typename?: 'policyClaim_var_samp_fields';
  benefitAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['Float']>;
  financeBenefitLimitPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: Maybe<Scalars['Float']>;
  salesTaxAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: Maybe<Scalars['Float']>;
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
};

/** order by var_samp() on columns of table "claims.policy_claim" */
export type PolicyClaim_Var_Samp_Order_By = {
  benefitAmount?: InputMaybe<Order_By>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PolicyClaim_Variance_Fields = {
  __typename?: 'policyClaim_variance_fields';
  benefitAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: Maybe<Scalars['Float']>;
  financeBenefitLimitPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: Maybe<Scalars['Float']>;
  salesTaxAmount?: Maybe<Scalars['Float']>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: Maybe<Scalars['Float']>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: Maybe<Scalars['Float']>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: Maybe<Scalars['Float']>;
  /** IT-8301: Returns sum of all claim_detail.total_cost for the given policy_claim. Queries claim_detail directly by policy_claim_id to avoid double-counting when multiple service centers are present. */
  total_claim_amount?: Maybe<Scalars['numeric']>;
};

/** order by variance() on columns of table "claims.policy_claim" */
export type PolicyClaim_Variance_Order_By = {
  benefitAmount?: InputMaybe<Order_By>;
  /** IT-7704: Maximum benefit amount cap for Benefit TLC, Benefit LCA, and Benefit TSW claims. */
  benefitLimitAmount?: InputMaybe<Order_By>;
  financeBenefitLimitPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Owed Amount for the claim: GREATEST(0, total_cost - total_paid_amount). Clamped at zero, so an overpaid claim reads 0 rather than a negative. See ADR 0003 in docs/adr/.
   */
  owedAmount?: InputMaybe<Order_By>;
  salesTaxAmount?: InputMaybe<Order_By>;
  /** IT-7704: Sales tax percentage rate applied to benefit claims (Benefit LCA). */
  salesTaxPercent?: InputMaybe<Order_By>;
  /**
   * Materialized column -- do not write it directly from application code, and never re-aggregate it in a query or view.
   *
   * Total Claim Amount for the claim. Two systems write it, split on who owns the claim.
   *
   * The claims data-sync writes it for legacy claims (number < 3000000), which the AS400 owns: SUM(ClaimsMasterDetail.TotalCostAmount) for Mechanical and Lease, ClaimsMasterGapDetail.TotalGapAmount for GAP, both capped at the benefit limit for Benefit claims. Where the feed has no value the stored value stands (volumes/data-sync/claims/import.sql, IT-8411).
   *
   * claims.calculate_totals() writes it for everything else, and is the only writer for app-created claims (number >= 3000000), which never sync: STEP 8b sums claim_detail for Mechanical and untyped claims, ungated on claim status; STEPs 6/7/8 apply the Benefit/Lease/GAP formulas.
   *
   * See ADR 0003 in docs/adr/.
   */
  totalCost?: InputMaybe<Order_By>;
  /**
   * Materialized column, maintained by claims.calculate_totals() -- never write it directly.
   *
   * Total Paid Amount for the claim: the sum of payments against it. Payment inserts, updates and deletes propagate here via shared.propagate_payment_changes(), which resolves the parent from OLD/NEW.parent_id so deletes propagate too. See ADR 0003 in docs/adr/.
   */
  totalPaidAmount?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations.policy_contract" */
export type PolicyContract = {
  __typename?: 'policyContract';
  /** An object relationship */
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['uuid']>;
  as400AgreementNumber?: Maybe<Scalars['String']>;
  as400PostedDate?: Maybe<Scalars['date']>;
  assetMetadata: Scalars['jsonb'];
  /** This function determines if a new claim can be started on a contract */
  canStartClaim?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  cancelQuoteListView: Array<CancelQuoteListView>;
  /** An aggregate relationship */
  cancelQuoteListView_aggregate: CancelQuoteListView_Aggregate;
  /** An object relationship */
  cancellation?: Maybe<Cancellation>;
  /** This ties the policy contract to the active cancellation. */
  cancellationId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  cancellations: Array<Cancellation>;
  /** An aggregate relationship */
  cancellations_aggregate: Cancellation_Aggregate;
  /** An array relationship */
  claimParts: Array<ClaimPart>;
  /** An aggregate relationship */
  claimParts_aggregate: ClaimPart_Aggregate;
  contractMaster?: Maybe<ContractMaster>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  documentInstances: Array<DocumentInstance>;
  /** An aggregate relationship */
  documentInstances_aggregate: DocumentInstance_Aggregate;
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityFileStorages: Array<EntityFileStorage>;
  /** An aggregate relationship */
  entityFileStorages_aggregate: EntityFileStorage_Aggregate;
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  /** The As400.ContractMasterImport stored procedure will update this value when it is syncing the purchased contract to the as400. Once this is true, the contract is no longer editable. */
  existsInAs400: Scalars['Boolean'];
  expirationDate?: Maybe<Scalars['date']>;
  expirationMiles?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  isTestContract: Scalars['Boolean'];
  /** An array relationship */
  journalEntries: Array<JournalEntry>;
  /** An aggregate relationship */
  journalEntries_aggregate: JournalEntry_Aggregate;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** This column is for putting any additional data related to the contract. It can be used for a migration, conversion, or supporting specific business functionality. */
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  obligor?: Maybe<Obligor>;
  /** This obligor reference is for the carrier code, not to be confused with the obligor that is the actual obligor of the contract. */
  obligorId?: Maybe<Scalars['uuid']>;
  /** Obligor Metadata that is a snapshot of the obligor information at the time of purchase. */
  obligorMetadata?: Maybe<Scalars['jsonb']>;
  optionalCoverageMetadata: Scalars['jsonb'];
  /** An object relationship */
  policy?: Maybe<Policy>;
  /** An array relationship */
  policyClaims: Array<PolicyClaim>;
  /** An aggregate relationship */
  policyClaims_aggregate: PolicyClaim_Aggregate;
  /** An object relationship */
  policyContractAsset?: Maybe<PolicyContractAsset>;
  policyContractAssetId: Scalars['uuid'];
  /** An array relationship */
  policyContractContractFormVersions: Array<PolicyContractContractFormVersion>;
  /** An aggregate relationship */
  policyContractContractFormVersions_aggregate: PolicyContractContractFormVersion_Aggregate;
  /** An object relationship */
  policyContractCostDetail?: Maybe<PolicyContractCostDetail>;
  /** An object relationship */
  policyContractLender?: Maybe<PolicyContractLender>;
  policyContractNumber: Scalars['String'];
  /** An array relationship */
  policyContractOwners: Array<PolicyContractOwner>;
  /** An aggregate relationship */
  policyContractOwners_aggregate: PolicyContractOwner_Aggregate;
  /** An array relationship */
  policyContractProductOptionsMetadataViews: Array<PolicyContractProductOptionsMetadataView>;
  /** An aggregate relationship */
  policyContractProductOptionsMetadataViews_aggregate: PolicyContractProductOptionsMetadataView_Aggregate;
  /** An array relationship */
  policyContractProducts: Array<PolicyContractProduct>;
  /** An aggregate relationship */
  policyContractProducts_aggregate: PolicyContractProduct_Aggregate;
  /** An array relationship */
  policyContractQuote: Array<PolicyContractQuote>;
  /** An aggregate relationship */
  policyContractQuote_aggregate: PolicyContractQuote_Aggregate;
  /** An object relationship */
  policyContractStatusType?: Maybe<PolicyContractStatusType>;
  policyContractStatusTypeId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  policyContractVoidReasonType?: Maybe<PolicyContractVoidReasonType>;
  policyId: Scalars['uuid'];
  /** An object relationship */
  product: Product;
  productId: Scalars['uuid'];
  productMetadata: Scalars['jsonb'];
  productOptionId?: Maybe<Scalars['uuid']>;
  purchaseDate: Scalars['date'];
  /** An object relationship */
  quote?: Maybe<Quote>;
  /** Deprecated */
  quoteId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  quoteMinimalView?: Maybe<QuoteMinimalView>;
  /** An array relationship */
  remittancePolicyContracts: Array<RemittancePolicyContract>;
  /** An aggregate relationship */
  remittancePolicyContracts_aggregate: RemittancePolicyContract_Aggregate;
  salesRepresentativeName?: Maybe<Scalars['String']>;
  secondaryExpirationDate?: Maybe<Scalars['date']>;
  secondaryExpirationMiles?: Maybe<Scalars['Int']>;
  /** An object relationship */
  statusReasonType?: Maybe<Type>;
  statusReasonTypeId?: Maybe<Scalars['uuid']>;
  surchargeMetadata: Scalars['jsonb'];
  updateUserId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractAssetMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractCancelQuoteListViewArgs = {
  distinct_on?: InputMaybe<Array<CancelQuoteListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelQuoteListView_Order_By>>;
  where?: InputMaybe<CancelQuoteListView_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractCancelQuoteListView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelQuoteListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelQuoteListView_Order_By>>;
  where?: InputMaybe<CancelQuoteListView_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractCancellationsArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancellation_Order_By>>;
  where?: InputMaybe<Cancellation_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractCancellations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancellation_Order_By>>;
  where?: InputMaybe<Cancellation_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractClaimPartsArgs = {
  distinct_on?: InputMaybe<Array<ClaimPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimPart_Order_By>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractClaimParts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimPart_Order_By>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractDocumentInstancesArgs = {
  distinct_on?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentInstance_Order_By>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractDocumentInstances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentInstance_Order_By>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractEntityFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractEntityFileStorages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractJournalEntriesArgs = {
  distinct_on?: InputMaybe<Array<JournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntry_Order_By>>;
  where?: InputMaybe<JournalEntry_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractJournalEntries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntry_Order_By>>;
  where?: InputMaybe<JournalEntry_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractObligorMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractOptionalCoverageMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyClaimsArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaim_Order_By>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaim_Order_By>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyContractContractFormVersionsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractContractFormVersion_Order_By>>;
  where?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyContractContractFormVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractContractFormVersion_Order_By>>;
  where?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyContractOwnersArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractOwner_Order_By>>;
  where?: InputMaybe<PolicyContractOwner_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyContractOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractOwner_Order_By>>;
  where?: InputMaybe<PolicyContractOwner_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyContractProductOptionsMetadataViewsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Order_By>>;
  where?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyContractProductOptionsMetadataViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Order_By>>;
  where?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyContractProductsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProduct_Order_By>>;
  where?: InputMaybe<PolicyContractProduct_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyContractProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProduct_Order_By>>;
  where?: InputMaybe<PolicyContractProduct_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyContractQuoteArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractQuote_Order_By>>;
  where?: InputMaybe<PolicyContractQuote_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractPolicyContractQuote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractQuote_Order_By>>;
  where?: InputMaybe<PolicyContractQuote_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractProductMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractRemittancePolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContract_Order_By>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractRemittancePolicyContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContract_Order_By>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract" */
export type PolicyContractSurchargeMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "operations.policy_contract_asset" */
export type PolicyContractAsset = {
  __typename?: 'policyContractAsset';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  identifierMetadata?: Maybe<Scalars['jsonb']>;
  /** Array of strings built from values of the identifier_metadata jsonb object and uppercased. */
  keywordsMetadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  msrp?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  policyContractAssetType?: Maybe<PolicyContractAssetType>;
  policyContractAssetTypeId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  policyContracts: Array<PolicyContract>;
  /** An aggregate relationship */
  policyContracts_aggregate: PolicyContract_Aggregate;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  vehicleInformation?: Maybe<Claims_Pre_Authorization_Vehicle_Information>;
};


/** columns and relationships of "operations.policy_contract_asset" */
export type PolicyContractAssetIdentifierMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.policy_contract_asset" */
export type PolicyContractAssetKeywordsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.policy_contract_asset" */
export type PolicyContractAssetLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract_asset" */
export type PolicyContractAssetLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract_asset" */
export type PolicyContractAssetPolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract_asset" */
export type PolicyContractAssetPolicyContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};

/** columns and relationships of "operations.policy_contract_asset_type" */
export type PolicyContractAssetType = {
  __typename?: 'policyContractAssetType';
  display: Scalars['String'];
  enumValue: Scalars['numeric'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  policyContractAssets: Array<PolicyContractAsset>;
  /** An aggregate relationship */
  policyContractAssets_aggregate: PolicyContractAsset_Aggregate;
};


/** columns and relationships of "operations.policy_contract_asset_type" */
export type PolicyContractAssetTypePolicyContractAssetsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractAsset_Order_By>>;
  where?: InputMaybe<PolicyContractAsset_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract_asset_type" */
export type PolicyContractAssetTypePolicyContractAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractAsset_Order_By>>;
  where?: InputMaybe<PolicyContractAsset_Bool_Exp>;
};

/** aggregated selection of "operations.policy_contract_asset_type" */
export type PolicyContractAssetType_Aggregate = {
  __typename?: 'policyContractAssetType_aggregate';
  aggregate?: Maybe<PolicyContractAssetType_Aggregate_Fields>;
  nodes: Array<PolicyContractAssetType>;
};

/** aggregate fields of "operations.policy_contract_asset_type" */
export type PolicyContractAssetType_Aggregate_Fields = {
  __typename?: 'policyContractAssetType_aggregate_fields';
  avg?: Maybe<PolicyContractAssetType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContractAssetType_Max_Fields>;
  min?: Maybe<PolicyContractAssetType_Min_Fields>;
  stddev?: Maybe<PolicyContractAssetType_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContractAssetType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContractAssetType_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContractAssetType_Sum_Fields>;
  var_pop?: Maybe<PolicyContractAssetType_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContractAssetType_Var_Samp_Fields>;
  variance?: Maybe<PolicyContractAssetType_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract_asset_type" */
export type PolicyContractAssetType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractAssetType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PolicyContractAssetType_Avg_Fields = {
  __typename?: 'policyContractAssetType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_asset_type". All fields are combined with a logical 'AND'. */
export type PolicyContractAssetType_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractAssetType_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractAssetType_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractAssetType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  policyContractAssets?: InputMaybe<PolicyContractAsset_Bool_Exp>;
  policyContractAssets_aggregate?: InputMaybe<PolicyContractAsset_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_asset_type" */
export enum PolicyContractAssetType_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractAssetTypePkey = 'policy_contract_asset_type_pkey'
}

/** input type for incrementing numeric columns in table "operations.policy_contract_asset_type" */
export type PolicyContractAssetType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.policy_contract_asset_type" */
export type PolicyContractAssetType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  policyContractAssets?: InputMaybe<PolicyContractAsset_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type PolicyContractAssetType_Max_Fields = {
  __typename?: 'policyContractAssetType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PolicyContractAssetType_Min_Fields = {
  __typename?: 'policyContractAssetType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "operations.policy_contract_asset_type" */
export type PolicyContractAssetType_Mutation_Response = {
  __typename?: 'policyContractAssetType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractAssetType>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_asset_type" */
export type PolicyContractAssetType_Obj_Rel_Insert_Input = {
  data: PolicyContractAssetType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractAssetType_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract_asset_type" */
export type PolicyContractAssetType_On_Conflict = {
  constraint: PolicyContractAssetType_Constraint;
  update_columns?: Array<PolicyContractAssetType_Update_Column>;
  where?: InputMaybe<PolicyContractAssetType_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_asset_type". */
export type PolicyContractAssetType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  policyContractAssets_aggregate?: InputMaybe<PolicyContractAsset_Aggregate_Order_By>;
};

/** primary key columns input for table: operations.policy_contract_asset_type */
export type PolicyContractAssetType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.policy_contract_asset_type" */
export enum PolicyContractAssetType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "operations.policy_contract_asset_type" */
export type PolicyContractAssetType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type PolicyContractAssetType_Stddev_Fields = {
  __typename?: 'policyContractAssetType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PolicyContractAssetType_Stddev_Pop_Fields = {
  __typename?: 'policyContractAssetType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PolicyContractAssetType_Stddev_Samp_Fields = {
  __typename?: 'policyContractAssetType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policyContractAssetType" */
export type PolicyContractAssetType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractAssetType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractAssetType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PolicyContractAssetType_Sum_Fields = {
  __typename?: 'policyContractAssetType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "operations.policy_contract_asset_type" */
export enum PolicyContractAssetType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type PolicyContractAssetType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyContractAssetType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractAssetType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractAssetType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyContractAssetType_Var_Pop_Fields = {
  __typename?: 'policyContractAssetType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PolicyContractAssetType_Var_Samp_Fields = {
  __typename?: 'policyContractAssetType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PolicyContractAssetType_Variance_Fields = {
  __typename?: 'policyContractAssetType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "operations.policy_contract_asset" */
export type PolicyContractAsset_Aggregate = {
  __typename?: 'policyContractAsset_aggregate';
  aggregate?: Maybe<PolicyContractAsset_Aggregate_Fields>;
  nodes: Array<PolicyContractAsset>;
};

export type PolicyContractAsset_Aggregate_Bool_Exp = {
  count?: InputMaybe<PolicyContractAsset_Aggregate_Bool_Exp_Count>;
};

export type PolicyContractAsset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PolicyContractAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractAsset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.policy_contract_asset" */
export type PolicyContractAsset_Aggregate_Fields = {
  __typename?: 'policyContractAsset_aggregate_fields';
  avg?: Maybe<PolicyContractAsset_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContractAsset_Max_Fields>;
  min?: Maybe<PolicyContractAsset_Min_Fields>;
  stddev?: Maybe<PolicyContractAsset_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContractAsset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContractAsset_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContractAsset_Sum_Fields>;
  var_pop?: Maybe<PolicyContractAsset_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContractAsset_Var_Samp_Fields>;
  variance?: Maybe<PolicyContractAsset_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract_asset" */
export type PolicyContractAsset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Aggregate_Order_By = {
  avg?: InputMaybe<PolicyContractAsset_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PolicyContractAsset_Max_Order_By>;
  min?: InputMaybe<PolicyContractAsset_Min_Order_By>;
  stddev?: InputMaybe<PolicyContractAsset_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PolicyContractAsset_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PolicyContractAsset_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PolicyContractAsset_Sum_Order_By>;
  var_pop?: InputMaybe<PolicyContractAsset_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PolicyContractAsset_Var_Samp_Order_By>;
  variance?: InputMaybe<PolicyContractAsset_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyContractAsset_Append_Input = {
  identifierMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "operations.policy_contract_asset" */
export type PolicyContractAsset_Arr_Rel_Insert_Input = {
  data: Array<PolicyContractAsset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractAsset_On_Conflict>;
};

/** aggregate avg on columns */
export type PolicyContractAsset_Avg_Fields = {
  __typename?: 'policyContractAsset_avg_fields';
  msrp?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Avg_Order_By = {
  msrp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_asset". All fields are combined with a logical 'AND'. */
export type PolicyContractAsset_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractAsset_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractAsset_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractAsset_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identifierMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  keywordsMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  msrp?: InputMaybe<Numeric_Comparison_Exp>;
  policyContractAssetType?: InputMaybe<PolicyContractAssetType_Bool_Exp>;
  policyContractAssetTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContracts?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicleInformation?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Bool_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_asset" */
export enum PolicyContractAsset_Constraint {
  /** unique or primary key constraint on columns "identifier_metadata" */
  PolicyContractAssetIdentifierMetadataKey = 'policy_contract_asset_identifier_metadata_key',
  /** unique or primary key constraint on columns "id" */
  PolicyContractAssetPkey = 'policy_contract_asset_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyContractAsset_Delete_At_Path_Input = {
  identifierMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyContractAsset_Delete_Elem_Input = {
  identifierMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyContractAsset_Delete_Key_Input = {
  identifierMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "operations.policy_contract_asset" */
export type PolicyContractAsset_Inc_Input = {
  msrp?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.policy_contract_asset" */
export type PolicyContractAsset_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identifierMetadata?: InputMaybe<Scalars['jsonb']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  msrp?: InputMaybe<Scalars['numeric']>;
  policyContractAssetType?: InputMaybe<PolicyContractAssetType_Obj_Rel_Insert_Input>;
  policyContractAssetTypeId?: InputMaybe<Scalars['uuid']>;
  policyContracts?: InputMaybe<PolicyContract_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleInformation?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type PolicyContractAsset_Max_Fields = {
  __typename?: 'policyContractAsset_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  msrp?: Maybe<Scalars['numeric']>;
  policyContractAssetTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  msrp?: InputMaybe<Order_By>;
  policyContractAssetTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PolicyContractAsset_Min_Fields = {
  __typename?: 'policyContractAsset_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  msrp?: Maybe<Scalars['numeric']>;
  policyContractAssetTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  msrp?: InputMaybe<Order_By>;
  policyContractAssetTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.policy_contract_asset" */
export type PolicyContractAsset_Mutation_Response = {
  __typename?: 'policyContractAsset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractAsset>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_asset" */
export type PolicyContractAsset_Obj_Rel_Insert_Input = {
  data: PolicyContractAsset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractAsset_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract_asset" */
export type PolicyContractAsset_On_Conflict = {
  constraint: PolicyContractAsset_Constraint;
  update_columns?: Array<PolicyContractAsset_Update_Column>;
  where?: InputMaybe<PolicyContractAsset_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_asset". */
export type PolicyContractAsset_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identifierMetadata?: InputMaybe<Order_By>;
  keywordsMetadata?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  msrp?: InputMaybe<Order_By>;
  policyContractAssetType?: InputMaybe<PolicyContractAssetType_Order_By>;
  policyContractAssetTypeId?: InputMaybe<Order_By>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleInformation?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Order_By>;
};

/** primary key columns input for table: operations.policy_contract_asset */
export type PolicyContractAsset_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicyContractAsset_Prepend_Input = {
  identifierMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "operations.policy_contract_asset" */
export enum PolicyContractAsset_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentifierMetadata = 'identifierMetadata',
  /** column name */
  KeywordsMetadata = 'keywordsMetadata',
  /** column name */
  Msrp = 'msrp',
  /** column name */
  PolicyContractAssetTypeId = 'policyContractAssetTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.policy_contract_asset" */
export type PolicyContractAsset_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identifierMetadata?: InputMaybe<Scalars['jsonb']>;
  msrp?: InputMaybe<Scalars['numeric']>;
  policyContractAssetTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PolicyContractAsset_Stddev_Fields = {
  __typename?: 'policyContractAsset_stddev_fields';
  msrp?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Stddev_Order_By = {
  msrp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PolicyContractAsset_Stddev_Pop_Fields = {
  __typename?: 'policyContractAsset_stddev_pop_fields';
  msrp?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Stddev_Pop_Order_By = {
  msrp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PolicyContractAsset_Stddev_Samp_Fields = {
  __typename?: 'policyContractAsset_stddev_samp_fields';
  msrp?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Stddev_Samp_Order_By = {
  msrp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "policyContractAsset" */
export type PolicyContractAsset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractAsset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractAsset_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identifierMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Array of strings built from values of the identifier_metadata jsonb object and uppercased. */
  keywordsMetadata?: InputMaybe<Scalars['jsonb']>;
  msrp?: InputMaybe<Scalars['numeric']>;
  policyContractAssetTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PolicyContractAsset_Sum_Fields = {
  __typename?: 'policyContractAsset_sum_fields';
  msrp?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Sum_Order_By = {
  msrp?: InputMaybe<Order_By>;
};

/** update columns of table "operations.policy_contract_asset" */
export enum PolicyContractAsset_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentifierMetadata = 'identifierMetadata',
  /** column name */
  Msrp = 'msrp',
  /** column name */
  PolicyContractAssetTypeId = 'policyContractAssetTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyContractAsset_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyContractAsset_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyContractAsset_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyContractAsset_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyContractAsset_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyContractAsset_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicyContractAsset_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractAsset_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractAsset_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyContractAsset_Var_Pop_Fields = {
  __typename?: 'policyContractAsset_var_pop_fields';
  msrp?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Var_Pop_Order_By = {
  msrp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PolicyContractAsset_Var_Samp_Fields = {
  __typename?: 'policyContractAsset_var_samp_fields';
  msrp?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Var_Samp_Order_By = {
  msrp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PolicyContractAsset_Variance_Fields = {
  __typename?: 'policyContractAsset_variance_fields';
  msrp?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations.policy_contract_asset" */
export type PolicyContractAsset_Variance_Order_By = {
  msrp?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion = {
  __typename?: 'policyContractContractFormVersion';
  /** An object relationship */
  contractFormVersion?: Maybe<ContractFormVersion>;
  contractFormVersionId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isLegacyAddendum: Scalars['Boolean'];
  legacyContractFormName?: Maybe<Scalars['String']>;
  /** An object relationship */
  policyContract: PolicyContract;
  policyContractId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_Aggregate = {
  __typename?: 'policyContractContractFormVersion_aggregate';
  aggregate?: Maybe<PolicyContractContractFormVersion_Aggregate_Fields>;
  nodes: Array<PolicyContractContractFormVersion>;
};

export type PolicyContractContractFormVersion_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<PolicyContractContractFormVersion_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<PolicyContractContractFormVersion_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<PolicyContractContractFormVersion_Aggregate_Bool_Exp_Count>;
};

export type PolicyContractContractFormVersion_Aggregate_Bool_Exp_Bool_And = {
  arguments: PolicyContractContractFormVersion_Select_Column_PolicyContractContractFormVersion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PolicyContractContractFormVersion_Aggregate_Bool_Exp_Bool_Or = {
  arguments: PolicyContractContractFormVersion_Select_Column_PolicyContractContractFormVersion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PolicyContractContractFormVersion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PolicyContractContractFormVersion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_Aggregate_Fields = {
  __typename?: 'policyContractContractFormVersion_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PolicyContractContractFormVersion_Max_Fields>;
  min?: Maybe<PolicyContractContractFormVersion_Min_Fields>;
};


/** aggregate fields of "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractContractFormVersion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PolicyContractContractFormVersion_Max_Order_By>;
  min?: InputMaybe<PolicyContractContractFormVersion_Min_Order_By>;
};

/** input type for inserting array relation for remote table "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_Arr_Rel_Insert_Input = {
  data: Array<PolicyContractContractFormVersion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractContractFormVersion_On_Conflict>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_contract_form_version". All fields are combined with a logical 'AND'. */
export type PolicyContractContractFormVersion_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractContractFormVersion_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractContractFormVersion_Bool_Exp>>;
  contractFormVersion?: InputMaybe<ContractFormVersion_Bool_Exp>;
  contractFormVersionId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isLegacyAddendum?: InputMaybe<Boolean_Comparison_Exp>;
  legacyContractFormName?: InputMaybe<String_Comparison_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_contract_form_version" */
export enum PolicyContractContractFormVersion_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractContractFormVersionPkey = 'policy_contract_contract_form_version_pkey'
}

/** input type for inserting data into table "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_Insert_Input = {
  contractFormVersion?: InputMaybe<ContractFormVersion_Obj_Rel_Insert_Input>;
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isLegacyAddendum?: InputMaybe<Scalars['Boolean']>;
  legacyContractFormName?: InputMaybe<Scalars['String']>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyContractContractFormVersion_Max_Fields = {
  __typename?: 'policyContractContractFormVersion_max_fields';
  contractFormVersionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  legacyContractFormName?: Maybe<Scalars['String']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_Max_Order_By = {
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyContractFormName?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PolicyContractContractFormVersion_Min_Fields = {
  __typename?: 'policyContractContractFormVersion_min_fields';
  contractFormVersionId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  legacyContractFormName?: Maybe<Scalars['String']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_Min_Order_By = {
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyContractFormName?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_Mutation_Response = {
  __typename?: 'policyContractContractFormVersion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractContractFormVersion>;
};

/** on_conflict condition type for table "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_On_Conflict = {
  constraint: PolicyContractContractFormVersion_Constraint;
  update_columns?: Array<PolicyContractContractFormVersion_Update_Column>;
  where?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_contract_form_version". */
export type PolicyContractContractFormVersion_Order_By = {
  contractFormVersion?: InputMaybe<ContractFormVersion_Order_By>;
  contractFormVersionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isLegacyAddendum?: InputMaybe<Order_By>;
  legacyContractFormName?: InputMaybe<Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.policy_contract_contract_form_version */
export type PolicyContractContractFormVersion_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.policy_contract_contract_form_version" */
export enum PolicyContractContractFormVersion_Select_Column {
  /** column name */
  ContractFormVersionId = 'contractFormVersionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsLegacyAddendum = 'isLegacyAddendum',
  /** column name */
  LegacyContractFormName = 'legacyContractFormName',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "policyContractContractFormVersion_aggregate_bool_exp_bool_and_arguments_columns" columns of table "operations.policy_contract_contract_form_version" */
export enum PolicyContractContractFormVersion_Select_Column_PolicyContractContractFormVersion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsLegacyAddendum = 'isLegacyAddendum'
}

/** select "policyContractContractFormVersion_aggregate_bool_exp_bool_or_arguments_columns" columns of table "operations.policy_contract_contract_form_version" */
export enum PolicyContractContractFormVersion_Select_Column_PolicyContractContractFormVersion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsLegacyAddendum = 'isLegacyAddendum'
}

/** input type for updating data in table "operations.policy_contract_contract_form_version" */
export type PolicyContractContractFormVersion_Set_Input = {
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isLegacyAddendum?: InputMaybe<Scalars['Boolean']>;
  legacyContractFormName?: InputMaybe<Scalars['String']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "policyContractContractFormVersion" */
export type PolicyContractContractFormVersion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractContractFormVersion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractContractFormVersion_Stream_Cursor_Value_Input = {
  contractFormVersionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isLegacyAddendum?: InputMaybe<Scalars['Boolean']>;
  legacyContractFormName?: InputMaybe<Scalars['String']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "operations.policy_contract_contract_form_version" */
export enum PolicyContractContractFormVersion_Update_Column {
  /** column name */
  ContractFormVersionId = 'contractFormVersionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsLegacyAddendum = 'isLegacyAddendum',
  /** column name */
  LegacyContractFormName = 'legacyContractFormName',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyContractContractFormVersion_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractContractFormVersion_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractContractFormVersion_Bool_Exp;
};

/** columns and relationships of "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetail = {
  __typename?: 'policyContractCostDetail';
  bucketMetadata?: Maybe<Scalars['jsonb']>;
  costMetadata?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerPrice?: Maybe<Scalars['numeric']>;
  dealerCost?: Maybe<Scalars['numeric']>;
  dealerRemitAmount?: Maybe<Scalars['numeric']>;
  disbursementMetadata?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  policyContract: PolicyContract;
  policyContractId: Scalars['uuid'];
  retailAmount: Scalars['numeric'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetailBucketMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetailCostMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetailDisbursementMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetailLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetailLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetail_Aggregate = {
  __typename?: 'policyContractCostDetail_aggregate';
  aggregate?: Maybe<PolicyContractCostDetail_Aggregate_Fields>;
  nodes: Array<PolicyContractCostDetail>;
};

/** aggregate fields of "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetail_Aggregate_Fields = {
  __typename?: 'policyContractCostDetail_aggregate_fields';
  avg?: Maybe<PolicyContractCostDetail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContractCostDetail_Max_Fields>;
  min?: Maybe<PolicyContractCostDetail_Min_Fields>;
  stddev?: Maybe<PolicyContractCostDetail_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContractCostDetail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContractCostDetail_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContractCostDetail_Sum_Fields>;
  var_pop?: Maybe<PolicyContractCostDetail_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContractCostDetail_Var_Samp_Fields>;
  variance?: Maybe<PolicyContractCostDetail_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractCostDetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyContractCostDetail_Append_Input = {
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  costMetadata?: InputMaybe<Scalars['jsonb']>;
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type PolicyContractCostDetail_Avg_Fields = {
  __typename?: 'policyContractCostDetail_avg_fields';
  customerPrice?: Maybe<Scalars['Float']>;
  dealerCost?: Maybe<Scalars['Float']>;
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  retailAmount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_cost_detail". All fields are combined with a logical 'AND'. */
export type PolicyContractCostDetail_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractCostDetail_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractCostDetail_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractCostDetail_Bool_Exp>>;
  bucketMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  costMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customerPrice?: InputMaybe<Numeric_Comparison_Exp>;
  dealerCost?: InputMaybe<Numeric_Comparison_Exp>;
  dealerRemitAmount?: InputMaybe<Numeric_Comparison_Exp>;
  disbursementMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  retailAmount?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_cost_detail" */
export enum PolicyContractCostDetail_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractCostDetailPkey = 'policy_contract_cost_detail_pkey',
  /** unique or primary key constraint on columns "policy_contract_id" */
  PolicyContractCostDetailPolicyContractIdKey = 'policy_contract_cost_detail_policy_contract_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyContractCostDetail_Delete_At_Path_Input = {
  bucketMetadata?: InputMaybe<Array<Scalars['String']>>;
  costMetadata?: InputMaybe<Array<Scalars['String']>>;
  disbursementMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyContractCostDetail_Delete_Elem_Input = {
  bucketMetadata?: InputMaybe<Scalars['Int']>;
  costMetadata?: InputMaybe<Scalars['Int']>;
  disbursementMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyContractCostDetail_Delete_Key_Input = {
  bucketMetadata?: InputMaybe<Scalars['String']>;
  costMetadata?: InputMaybe<Scalars['String']>;
  disbursementMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetail_Inc_Input = {
  customerPrice?: InputMaybe<Scalars['numeric']>;
  dealerCost?: InputMaybe<Scalars['numeric']>;
  dealerRemitAmount?: InputMaybe<Scalars['numeric']>;
  retailAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetail_Insert_Input = {
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  costMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerPrice?: InputMaybe<Scalars['numeric']>;
  dealerCost?: InputMaybe<Scalars['numeric']>;
  dealerRemitAmount?: InputMaybe<Scalars['numeric']>;
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  retailAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyContractCostDetail_Max_Fields = {
  __typename?: 'policyContractCostDetail_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerPrice?: Maybe<Scalars['numeric']>;
  dealerCost?: Maybe<Scalars['numeric']>;
  dealerRemitAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  retailAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PolicyContractCostDetail_Min_Fields = {
  __typename?: 'policyContractCostDetail_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerPrice?: Maybe<Scalars['numeric']>;
  dealerCost?: Maybe<Scalars['numeric']>;
  dealerRemitAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  retailAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetail_Mutation_Response = {
  __typename?: 'policyContractCostDetail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractCostDetail>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetail_Obj_Rel_Insert_Input = {
  data: PolicyContractCostDetail_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractCostDetail_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetail_On_Conflict = {
  constraint: PolicyContractCostDetail_Constraint;
  update_columns?: Array<PolicyContractCostDetail_Update_Column>;
  where?: InputMaybe<PolicyContractCostDetail_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_cost_detail". */
export type PolicyContractCostDetail_Order_By = {
  bucketMetadata?: InputMaybe<Order_By>;
  costMetadata?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  dealerCost?: InputMaybe<Order_By>;
  dealerRemitAmount?: InputMaybe<Order_By>;
  disbursementMetadata?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  retailAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.policy_contract_cost_detail */
export type PolicyContractCostDetail_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicyContractCostDetail_Prepend_Input = {
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  costMetadata?: InputMaybe<Scalars['jsonb']>;
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "operations.policy_contract_cost_detail" */
export enum PolicyContractCostDetail_Select_Column {
  /** column name */
  BucketMetadata = 'bucketMetadata',
  /** column name */
  CostMetadata = 'costMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerPrice = 'customerPrice',
  /** column name */
  DealerCost = 'dealerCost',
  /** column name */
  DealerRemitAmount = 'dealerRemitAmount',
  /** column name */
  DisbursementMetadata = 'disbursementMetadata',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  RetailAmount = 'retailAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.policy_contract_cost_detail" */
export type PolicyContractCostDetail_Set_Input = {
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  costMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerPrice?: InputMaybe<Scalars['numeric']>;
  dealerCost?: InputMaybe<Scalars['numeric']>;
  dealerRemitAmount?: InputMaybe<Scalars['numeric']>;
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  retailAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PolicyContractCostDetail_Stddev_Fields = {
  __typename?: 'policyContractCostDetail_stddev_fields';
  customerPrice?: Maybe<Scalars['Float']>;
  dealerCost?: Maybe<Scalars['Float']>;
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  retailAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PolicyContractCostDetail_Stddev_Pop_Fields = {
  __typename?: 'policyContractCostDetail_stddev_pop_fields';
  customerPrice?: Maybe<Scalars['Float']>;
  dealerCost?: Maybe<Scalars['Float']>;
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  retailAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PolicyContractCostDetail_Stddev_Samp_Fields = {
  __typename?: 'policyContractCostDetail_stddev_samp_fields';
  customerPrice?: Maybe<Scalars['Float']>;
  dealerCost?: Maybe<Scalars['Float']>;
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  retailAmount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policyContractCostDetail" */
export type PolicyContractCostDetail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractCostDetail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractCostDetail_Stream_Cursor_Value_Input = {
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  costMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerPrice?: InputMaybe<Scalars['numeric']>;
  dealerCost?: InputMaybe<Scalars['numeric']>;
  dealerRemitAmount?: InputMaybe<Scalars['numeric']>;
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  retailAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PolicyContractCostDetail_Sum_Fields = {
  __typename?: 'policyContractCostDetail_sum_fields';
  customerPrice?: Maybe<Scalars['numeric']>;
  dealerCost?: Maybe<Scalars['numeric']>;
  dealerRemitAmount?: Maybe<Scalars['numeric']>;
  retailAmount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "operations.policy_contract_cost_detail" */
export enum PolicyContractCostDetail_Update_Column {
  /** column name */
  BucketMetadata = 'bucketMetadata',
  /** column name */
  CostMetadata = 'costMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerPrice = 'customerPrice',
  /** column name */
  DealerCost = 'dealerCost',
  /** column name */
  DealerRemitAmount = 'dealerRemitAmount',
  /** column name */
  DisbursementMetadata = 'disbursementMetadata',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  RetailAmount = 'retailAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyContractCostDetail_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyContractCostDetail_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyContractCostDetail_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyContractCostDetail_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyContractCostDetail_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyContractCostDetail_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicyContractCostDetail_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractCostDetail_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractCostDetail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyContractCostDetail_Var_Pop_Fields = {
  __typename?: 'policyContractCostDetail_var_pop_fields';
  customerPrice?: Maybe<Scalars['Float']>;
  dealerCost?: Maybe<Scalars['Float']>;
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  retailAmount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PolicyContractCostDetail_Var_Samp_Fields = {
  __typename?: 'policyContractCostDetail_var_samp_fields';
  customerPrice?: Maybe<Scalars['Float']>;
  dealerCost?: Maybe<Scalars['Float']>;
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  retailAmount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PolicyContractCostDetail_Variance_Fields = {
  __typename?: 'policyContractCostDetail_variance_fields';
  customerPrice?: Maybe<Scalars['Float']>;
  dealerCost?: Maybe<Scalars['Float']>;
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  retailAmount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "operations.policy_contract_lender" */
export type PolicyContractLender = {
  __typename?: 'policyContractLender';
  /** An object relationship */
  contact: Contact;
  contactId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  downPaymentAmount?: Maybe<Scalars['numeric']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  financeAmount?: Maybe<Scalars['numeric']>;
  firstPaymentDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  interestRate?: Maybe<Scalars['numeric']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Int']>;
  loanNumber?: Maybe<Scalars['String']>;
  loanPaymentFrequencyId?: Maybe<Scalars['uuid']>;
  loanTerm?: Maybe<Scalars['Int']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  monthlyPaymentAmount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  policyContract: PolicyContract;
  policyContractId: Scalars['uuid'];
  /** An object relationship */
  policyContractLoanContractType?: Maybe<PolicyContractLoanContractType>;
  policyContractLoanContractTypeId?: Maybe<Scalars['uuid']>;
  residualValue?: Maybe<Scalars['numeric']>;
  serviceFeeAmount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  type?: Maybe<Type>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "operations.policy_contract_lender" */
export type PolicyContractLenderLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract_lender" */
export type PolicyContractLenderLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "operations.policy_contract_lender" */
export type PolicyContractLender_Aggregate = {
  __typename?: 'policyContractLender_aggregate';
  aggregate?: Maybe<PolicyContractLender_Aggregate_Fields>;
  nodes: Array<PolicyContractLender>;
};

export type PolicyContractLender_Aggregate_Bool_Exp = {
  count?: InputMaybe<PolicyContractLender_Aggregate_Bool_Exp_Count>;
};

export type PolicyContractLender_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PolicyContractLender_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractLender_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.policy_contract_lender" */
export type PolicyContractLender_Aggregate_Fields = {
  __typename?: 'policyContractLender_aggregate_fields';
  avg?: Maybe<PolicyContractLender_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContractLender_Max_Fields>;
  min?: Maybe<PolicyContractLender_Min_Fields>;
  stddev?: Maybe<PolicyContractLender_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContractLender_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContractLender_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContractLender_Sum_Fields>;
  var_pop?: Maybe<PolicyContractLender_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContractLender_Var_Samp_Fields>;
  variance?: Maybe<PolicyContractLender_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract_lender" */
export type PolicyContractLender_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractLender_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.policy_contract_lender" */
export type PolicyContractLender_Aggregate_Order_By = {
  avg?: InputMaybe<PolicyContractLender_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PolicyContractLender_Max_Order_By>;
  min?: InputMaybe<PolicyContractLender_Min_Order_By>;
  stddev?: InputMaybe<PolicyContractLender_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PolicyContractLender_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PolicyContractLender_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PolicyContractLender_Sum_Order_By>;
  var_pop?: InputMaybe<PolicyContractLender_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PolicyContractLender_Var_Samp_Order_By>;
  variance?: InputMaybe<PolicyContractLender_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations.policy_contract_lender" */
export type PolicyContractLender_Arr_Rel_Insert_Input = {
  data: Array<PolicyContractLender_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractLender_On_Conflict>;
};

/** aggregate avg on columns */
export type PolicyContractLender_Avg_Fields = {
  __typename?: 'policyContractLender_avg_fields';
  downPaymentAmount?: Maybe<Scalars['Float']>;
  financeAmount?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Float']>;
  loanTerm?: Maybe<Scalars['Float']>;
  monthlyPaymentAmount?: Maybe<Scalars['Float']>;
  residualValue?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations.policy_contract_lender" */
export type PolicyContractLender_Avg_Order_By = {
  downPaymentAmount?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_lender". All fields are combined with a logical 'AND'. */
export type PolicyContractLender_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractLender_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractLender_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractLender_Bool_Exp>>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contactId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  downPaymentAmount?: InputMaybe<Numeric_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  financeAmount?: InputMaybe<Numeric_Comparison_Exp>;
  firstPaymentDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interestRate?: InputMaybe<Numeric_Comparison_Exp>;
  legacyMbpFinancePlanId?: InputMaybe<Int_Comparison_Exp>;
  loanNumber?: InputMaybe<String_Comparison_Exp>;
  loanPaymentFrequencyId?: InputMaybe<Uuid_Comparison_Exp>;
  loanTerm?: InputMaybe<Int_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  monthlyPaymentAmount?: InputMaybe<Numeric_Comparison_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContractLoanContractType?: InputMaybe<PolicyContractLoanContractType_Bool_Exp>;
  policyContractLoanContractTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  residualValue?: InputMaybe<Numeric_Comparison_Exp>;
  serviceFeeAmount?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<Type_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_lender" */
export enum PolicyContractLender_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractLenderPkey = 'policy_contract_lender_pkey',
  /** unique or primary key constraint on columns "policy_contract_id" */
  PolicyContractLenderPolicyContractIdKey = 'policy_contract_lender_policy_contract_id_key'
}

/** input type for incrementing numeric columns in table "operations.policy_contract_lender" */
export type PolicyContractLender_Inc_Input = {
  downPaymentAmount?: InputMaybe<Scalars['numeric']>;
  financeAmount?: InputMaybe<Scalars['numeric']>;
  interestRate?: InputMaybe<Scalars['numeric']>;
  legacyMbpFinancePlanId?: InputMaybe<Scalars['Int']>;
  loanTerm?: InputMaybe<Scalars['Int']>;
  monthlyPaymentAmount?: InputMaybe<Scalars['numeric']>;
  residualValue?: InputMaybe<Scalars['numeric']>;
  serviceFeeAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.policy_contract_lender" */
export type PolicyContractLender_Insert_Input = {
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  downPaymentAmount?: InputMaybe<Scalars['numeric']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  financeAmount?: InputMaybe<Scalars['numeric']>;
  firstPaymentDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  interestRate?: InputMaybe<Scalars['numeric']>;
  legacyMbpFinancePlanId?: InputMaybe<Scalars['Int']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  loanPaymentFrequencyId?: InputMaybe<Scalars['uuid']>;
  loanTerm?: InputMaybe<Scalars['Int']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  monthlyPaymentAmount?: InputMaybe<Scalars['numeric']>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  policyContractLoanContractType?: InputMaybe<PolicyContractLoanContractType_Obj_Rel_Insert_Input>;
  policyContractLoanContractTypeId?: InputMaybe<Scalars['uuid']>;
  residualValue?: InputMaybe<Scalars['numeric']>;
  serviceFeeAmount?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyContractLender_Max_Fields = {
  __typename?: 'policyContractLender_max_fields';
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  downPaymentAmount?: Maybe<Scalars['numeric']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  financeAmount?: Maybe<Scalars['numeric']>;
  firstPaymentDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  interestRate?: Maybe<Scalars['numeric']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Int']>;
  loanNumber?: Maybe<Scalars['String']>;
  loanPaymentFrequencyId?: Maybe<Scalars['uuid']>;
  loanTerm?: Maybe<Scalars['Int']>;
  monthlyPaymentAmount?: Maybe<Scalars['numeric']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  policyContractLoanContractTypeId?: Maybe<Scalars['uuid']>;
  residualValue?: Maybe<Scalars['numeric']>;
  serviceFeeAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.policy_contract_lender" */
export type PolicyContractLender_Max_Order_By = {
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  downPaymentAmount?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  firstPaymentDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanNumber?: InputMaybe<Order_By>;
  loanPaymentFrequencyId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  policyContractLoanContractTypeId?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PolicyContractLender_Min_Fields = {
  __typename?: 'policyContractLender_min_fields';
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  downPaymentAmount?: Maybe<Scalars['numeric']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  financeAmount?: Maybe<Scalars['numeric']>;
  firstPaymentDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  interestRate?: Maybe<Scalars['numeric']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Int']>;
  loanNumber?: Maybe<Scalars['String']>;
  loanPaymentFrequencyId?: Maybe<Scalars['uuid']>;
  loanTerm?: Maybe<Scalars['Int']>;
  monthlyPaymentAmount?: Maybe<Scalars['numeric']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  policyContractLoanContractTypeId?: Maybe<Scalars['uuid']>;
  residualValue?: Maybe<Scalars['numeric']>;
  serviceFeeAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.policy_contract_lender" */
export type PolicyContractLender_Min_Order_By = {
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  downPaymentAmount?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  firstPaymentDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanNumber?: InputMaybe<Order_By>;
  loanPaymentFrequencyId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  policyContractLoanContractTypeId?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.policy_contract_lender" */
export type PolicyContractLender_Mutation_Response = {
  __typename?: 'policyContractLender_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractLender>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_lender" */
export type PolicyContractLender_Obj_Rel_Insert_Input = {
  data: PolicyContractLender_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractLender_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract_lender" */
export type PolicyContractLender_On_Conflict = {
  constraint: PolicyContractLender_Constraint;
  update_columns?: Array<PolicyContractLender_Update_Column>;
  where?: InputMaybe<PolicyContractLender_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_lender". */
export type PolicyContractLender_Order_By = {
  contact?: InputMaybe<Contact_Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  downPaymentAmount?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  firstPaymentDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanNumber?: InputMaybe<Order_By>;
  loanPaymentFrequencyId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  policyContractLoanContractType?: InputMaybe<PolicyContractLoanContractType_Order_By>;
  policyContractLoanContractTypeId?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
  type?: InputMaybe<Type_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.policy_contract_lender */
export type PolicyContractLender_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.policy_contract_lender" */
export enum PolicyContractLender_Select_Column {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownPaymentAmount = 'downPaymentAmount',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  FinanceAmount = 'financeAmount',
  /** column name */
  FirstPaymentDate = 'firstPaymentDate',
  /** column name */
  Id = 'id',
  /** column name */
  InterestRate = 'interestRate',
  /** column name */
  LegacyMbpFinancePlanId = 'legacyMbpFinancePlanId',
  /** column name */
  LoanNumber = 'loanNumber',
  /** column name */
  LoanPaymentFrequencyId = 'loanPaymentFrequencyId',
  /** column name */
  LoanTerm = 'loanTerm',
  /** column name */
  MonthlyPaymentAmount = 'monthlyPaymentAmount',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  PolicyContractLoanContractTypeId = 'policyContractLoanContractTypeId',
  /** column name */
  ResidualValue = 'residualValue',
  /** column name */
  ServiceFeeAmount = 'serviceFeeAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.policy_contract_lender" */
export type PolicyContractLender_Set_Input = {
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  downPaymentAmount?: InputMaybe<Scalars['numeric']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  financeAmount?: InputMaybe<Scalars['numeric']>;
  firstPaymentDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  interestRate?: InputMaybe<Scalars['numeric']>;
  legacyMbpFinancePlanId?: InputMaybe<Scalars['Int']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  loanPaymentFrequencyId?: InputMaybe<Scalars['uuid']>;
  loanTerm?: InputMaybe<Scalars['Int']>;
  monthlyPaymentAmount?: InputMaybe<Scalars['numeric']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  policyContractLoanContractTypeId?: InputMaybe<Scalars['uuid']>;
  residualValue?: InputMaybe<Scalars['numeric']>;
  serviceFeeAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PolicyContractLender_Stddev_Fields = {
  __typename?: 'policyContractLender_stddev_fields';
  downPaymentAmount?: Maybe<Scalars['Float']>;
  financeAmount?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Float']>;
  loanTerm?: Maybe<Scalars['Float']>;
  monthlyPaymentAmount?: Maybe<Scalars['Float']>;
  residualValue?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations.policy_contract_lender" */
export type PolicyContractLender_Stddev_Order_By = {
  downPaymentAmount?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PolicyContractLender_Stddev_Pop_Fields = {
  __typename?: 'policyContractLender_stddev_pop_fields';
  downPaymentAmount?: Maybe<Scalars['Float']>;
  financeAmount?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Float']>;
  loanTerm?: Maybe<Scalars['Float']>;
  monthlyPaymentAmount?: Maybe<Scalars['Float']>;
  residualValue?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations.policy_contract_lender" */
export type PolicyContractLender_Stddev_Pop_Order_By = {
  downPaymentAmount?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PolicyContractLender_Stddev_Samp_Fields = {
  __typename?: 'policyContractLender_stddev_samp_fields';
  downPaymentAmount?: Maybe<Scalars['Float']>;
  financeAmount?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Float']>;
  loanTerm?: Maybe<Scalars['Float']>;
  monthlyPaymentAmount?: Maybe<Scalars['Float']>;
  residualValue?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations.policy_contract_lender" */
export type PolicyContractLender_Stddev_Samp_Order_By = {
  downPaymentAmount?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "policyContractLender" */
export type PolicyContractLender_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractLender_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractLender_Stream_Cursor_Value_Input = {
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  downPaymentAmount?: InputMaybe<Scalars['numeric']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  financeAmount?: InputMaybe<Scalars['numeric']>;
  firstPaymentDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  interestRate?: InputMaybe<Scalars['numeric']>;
  legacyMbpFinancePlanId?: InputMaybe<Scalars['Int']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  loanPaymentFrequencyId?: InputMaybe<Scalars['uuid']>;
  loanTerm?: InputMaybe<Scalars['Int']>;
  monthlyPaymentAmount?: InputMaybe<Scalars['numeric']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  policyContractLoanContractTypeId?: InputMaybe<Scalars['uuid']>;
  residualValue?: InputMaybe<Scalars['numeric']>;
  serviceFeeAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PolicyContractLender_Sum_Fields = {
  __typename?: 'policyContractLender_sum_fields';
  downPaymentAmount?: Maybe<Scalars['numeric']>;
  financeAmount?: Maybe<Scalars['numeric']>;
  interestRate?: Maybe<Scalars['numeric']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Int']>;
  loanTerm?: Maybe<Scalars['Int']>;
  monthlyPaymentAmount?: Maybe<Scalars['numeric']>;
  residualValue?: Maybe<Scalars['numeric']>;
  serviceFeeAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "operations.policy_contract_lender" */
export type PolicyContractLender_Sum_Order_By = {
  downPaymentAmount?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
};

/** update columns of table "operations.policy_contract_lender" */
export enum PolicyContractLender_Update_Column {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownPaymentAmount = 'downPaymentAmount',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  FinanceAmount = 'financeAmount',
  /** column name */
  FirstPaymentDate = 'firstPaymentDate',
  /** column name */
  Id = 'id',
  /** column name */
  InterestRate = 'interestRate',
  /** column name */
  LegacyMbpFinancePlanId = 'legacyMbpFinancePlanId',
  /** column name */
  LoanNumber = 'loanNumber',
  /** column name */
  LoanPaymentFrequencyId = 'loanPaymentFrequencyId',
  /** column name */
  LoanTerm = 'loanTerm',
  /** column name */
  MonthlyPaymentAmount = 'monthlyPaymentAmount',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  PolicyContractLoanContractTypeId = 'policyContractLoanContractTypeId',
  /** column name */
  ResidualValue = 'residualValue',
  /** column name */
  ServiceFeeAmount = 'serviceFeeAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyContractLender_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyContractLender_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractLender_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractLender_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyContractLender_Var_Pop_Fields = {
  __typename?: 'policyContractLender_var_pop_fields';
  downPaymentAmount?: Maybe<Scalars['Float']>;
  financeAmount?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Float']>;
  loanTerm?: Maybe<Scalars['Float']>;
  monthlyPaymentAmount?: Maybe<Scalars['Float']>;
  residualValue?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations.policy_contract_lender" */
export type PolicyContractLender_Var_Pop_Order_By = {
  downPaymentAmount?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PolicyContractLender_Var_Samp_Fields = {
  __typename?: 'policyContractLender_var_samp_fields';
  downPaymentAmount?: Maybe<Scalars['Float']>;
  financeAmount?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Float']>;
  loanTerm?: Maybe<Scalars['Float']>;
  monthlyPaymentAmount?: Maybe<Scalars['Float']>;
  residualValue?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations.policy_contract_lender" */
export type PolicyContractLender_Var_Samp_Order_By = {
  downPaymentAmount?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PolicyContractLender_Variance_Fields = {
  __typename?: 'policyContractLender_variance_fields';
  downPaymentAmount?: Maybe<Scalars['Float']>;
  financeAmount?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  legacyMbpFinancePlanId?: Maybe<Scalars['Float']>;
  loanTerm?: Maybe<Scalars['Float']>;
  monthlyPaymentAmount?: Maybe<Scalars['Float']>;
  residualValue?: Maybe<Scalars['Float']>;
  serviceFeeAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations.policy_contract_lender" */
export type PolicyContractLender_Variance_Order_By = {
  downPaymentAmount?: InputMaybe<Order_By>;
  financeAmount?: InputMaybe<Order_By>;
  interestRate?: InputMaybe<Order_By>;
  legacyMbpFinancePlanId?: InputMaybe<Order_By>;
  loanTerm?: InputMaybe<Order_By>;
  monthlyPaymentAmount?: InputMaybe<Order_By>;
  residualValue?: InputMaybe<Order_By>;
  serviceFeeAmount?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations.policy_contract_list_view" */
export type PolicyContractListView = {
  __typename?: 'policyContractListView';
  accountCode?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  contractMasterId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  isLegacy?: Maybe<Scalars['Boolean']>;
  policyContractNumber?: Maybe<Scalars['String']>;
  policyContractOwnerNames?: Maybe<Scalars['String']>;
  policyContractStatusTypeName?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['date']>;
  vin?: Maybe<Scalars['String']>;
};

/** aggregated selection of "operations.policy_contract_list_view" */
export type PolicyContractListView_Aggregate = {
  __typename?: 'policyContractListView_aggregate';
  aggregate?: Maybe<PolicyContractListView_Aggregate_Fields>;
  nodes: Array<PolicyContractListView>;
};

/** aggregate fields of "operations.policy_contract_list_view" */
export type PolicyContractListView_Aggregate_Fields = {
  __typename?: 'policyContractListView_aggregate_fields';
  avg?: Maybe<PolicyContractListView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContractListView_Max_Fields>;
  min?: Maybe<PolicyContractListView_Min_Fields>;
  stddev?: Maybe<PolicyContractListView_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContractListView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContractListView_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContractListView_Sum_Fields>;
  var_pop?: Maybe<PolicyContractListView_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContractListView_Var_Samp_Fields>;
  variance?: Maybe<PolicyContractListView_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract_list_view" */
export type PolicyContractListView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractListView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PolicyContractListView_Avg_Fields = {
  __typename?: 'policyContractListView_avg_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_list_view". All fields are combined with a logical 'AND'. */
export type PolicyContractListView_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractListView_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractListView_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractListView_Bool_Exp>>;
  accountCode?: InputMaybe<String_Comparison_Exp>;
  accountName?: InputMaybe<String_Comparison_Exp>;
  categoryName?: InputMaybe<String_Comparison_Exp>;
  contractMasterId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isLegacy?: InputMaybe<Boolean_Comparison_Exp>;
  policyContractNumber?: InputMaybe<String_Comparison_Exp>;
  policyContractOwnerNames?: InputMaybe<String_Comparison_Exp>;
  policyContractStatusTypeName?: InputMaybe<String_Comparison_Exp>;
  purchaseDate?: InputMaybe<Date_Comparison_Exp>;
  vin?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "operations.policy_contract_list_view" */
export type PolicyContractListView_Insert_Input = {
  accountCode?: InputMaybe<Scalars['String']>;
  accountName?: InputMaybe<Scalars['String']>;
  categoryName?: InputMaybe<Scalars['String']>;
  contractMasterId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isLegacy?: InputMaybe<Scalars['Boolean']>;
  policyContractNumber?: InputMaybe<Scalars['String']>;
  policyContractOwnerNames?: InputMaybe<Scalars['String']>;
  policyContractStatusTypeName?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['date']>;
  vin?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PolicyContractListView_Max_Fields = {
  __typename?: 'policyContractListView_max_fields';
  accountCode?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  contractMasterId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  policyContractNumber?: Maybe<Scalars['String']>;
  policyContractOwnerNames?: Maybe<Scalars['String']>;
  policyContractStatusTypeName?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['date']>;
  vin?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PolicyContractListView_Min_Fields = {
  __typename?: 'policyContractListView_min_fields';
  accountCode?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  contractMasterId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  policyContractNumber?: Maybe<Scalars['String']>;
  policyContractOwnerNames?: Maybe<Scalars['String']>;
  policyContractStatusTypeName?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['date']>;
  vin?: Maybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_list_view" */
export type PolicyContractListView_Obj_Rel_Insert_Input = {
  data: PolicyContractListView_Insert_Input;
};

/** Ordering options when selecting data from "operations.policy_contract_list_view". */
export type PolicyContractListView_Order_By = {
  accountCode?: InputMaybe<Order_By>;
  accountName?: InputMaybe<Order_By>;
  categoryName?: InputMaybe<Order_By>;
  contractMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isLegacy?: InputMaybe<Order_By>;
  policyContractNumber?: InputMaybe<Order_By>;
  policyContractOwnerNames?: InputMaybe<Order_By>;
  policyContractStatusTypeName?: InputMaybe<Order_By>;
  purchaseDate?: InputMaybe<Order_By>;
  vin?: InputMaybe<Order_By>;
};

/** select columns of table "operations.policy_contract_list_view" */
export enum PolicyContractListView_Select_Column {
  /** column name */
  AccountCode = 'accountCode',
  /** column name */
  AccountName = 'accountName',
  /** column name */
  CategoryName = 'categoryName',
  /** column name */
  ContractMasterId = 'contractMasterId',
  /** column name */
  Id = 'id',
  /** column name */
  IsLegacy = 'isLegacy',
  /** column name */
  PolicyContractNumber = 'policyContractNumber',
  /** column name */
  PolicyContractOwnerNames = 'policyContractOwnerNames',
  /** column name */
  PolicyContractStatusTypeName = 'policyContractStatusTypeName',
  /** column name */
  PurchaseDate = 'purchaseDate',
  /** column name */
  Vin = 'vin'
}

/** aggregate stddev on columns */
export type PolicyContractListView_Stddev_Fields = {
  __typename?: 'policyContractListView_stddev_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PolicyContractListView_Stddev_Pop_Fields = {
  __typename?: 'policyContractListView_stddev_pop_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PolicyContractListView_Stddev_Samp_Fields = {
  __typename?: 'policyContractListView_stddev_samp_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policyContractListView" */
export type PolicyContractListView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractListView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractListView_Stream_Cursor_Value_Input = {
  accountCode?: InputMaybe<Scalars['String']>;
  accountName?: InputMaybe<Scalars['String']>;
  categoryName?: InputMaybe<Scalars['String']>;
  contractMasterId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isLegacy?: InputMaybe<Scalars['Boolean']>;
  policyContractNumber?: InputMaybe<Scalars['String']>;
  policyContractOwnerNames?: InputMaybe<Scalars['String']>;
  policyContractStatusTypeName?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['date']>;
  vin?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PolicyContractListView_Sum_Fields = {
  __typename?: 'policyContractListView_sum_fields';
  contractMasterId?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type PolicyContractListView_Var_Pop_Fields = {
  __typename?: 'policyContractListView_var_pop_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PolicyContractListView_Var_Samp_Fields = {
  __typename?: 'policyContractListView_var_samp_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PolicyContractListView_Variance_Fields = {
  __typename?: 'policyContractListView_variance_fields';
  contractMasterId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractType = {
  __typename?: 'policyContractLoanContractType';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  policyContractLenders: Array<PolicyContractLender>;
  /** An aggregate relationship */
  policyContractLenders_aggregate: PolicyContractLender_Aggregate;
};


/** columns and relationships of "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractTypePolicyContractLendersArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLender_Order_By>>;
  where?: InputMaybe<PolicyContractLender_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractTypePolicyContractLenders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLender_Order_By>>;
  where?: InputMaybe<PolicyContractLender_Bool_Exp>;
};

/** aggregated selection of "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractType_Aggregate = {
  __typename?: 'policyContractLoanContractType_aggregate';
  aggregate?: Maybe<PolicyContractLoanContractType_Aggregate_Fields>;
  nodes: Array<PolicyContractLoanContractType>;
};

/** aggregate fields of "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractType_Aggregate_Fields = {
  __typename?: 'policyContractLoanContractType_aggregate_fields';
  avg?: Maybe<PolicyContractLoanContractType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContractLoanContractType_Max_Fields>;
  min?: Maybe<PolicyContractLoanContractType_Min_Fields>;
  stddev?: Maybe<PolicyContractLoanContractType_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContractLoanContractType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContractLoanContractType_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContractLoanContractType_Sum_Fields>;
  var_pop?: Maybe<PolicyContractLoanContractType_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContractLoanContractType_Var_Samp_Fields>;
  variance?: Maybe<PolicyContractLoanContractType_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractLoanContractType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PolicyContractLoanContractType_Avg_Fields = {
  __typename?: 'policyContractLoanContractType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_loan_contract_type". All fields are combined with a logical 'AND'. */
export type PolicyContractLoanContractType_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractLoanContractType_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractLoanContractType_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractLoanContractType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  policyContractLenders?: InputMaybe<PolicyContractLender_Bool_Exp>;
  policyContractLenders_aggregate?: InputMaybe<PolicyContractLender_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_loan_contract_type" */
export enum PolicyContractLoanContractType_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractLoanContractTypePkey = 'policy_contract_loan_contract_type_pkey'
}

/** input type for incrementing numeric columns in table "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  policyContractLenders?: InputMaybe<PolicyContractLender_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type PolicyContractLoanContractType_Max_Fields = {
  __typename?: 'policyContractLoanContractType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PolicyContractLoanContractType_Min_Fields = {
  __typename?: 'policyContractLoanContractType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractType_Mutation_Response = {
  __typename?: 'policyContractLoanContractType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractLoanContractType>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractType_Obj_Rel_Insert_Input = {
  data: PolicyContractLoanContractType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractLoanContractType_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractType_On_Conflict = {
  constraint: PolicyContractLoanContractType_Constraint;
  update_columns?: Array<PolicyContractLoanContractType_Update_Column>;
  where?: InputMaybe<PolicyContractLoanContractType_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_loan_contract_type". */
export type PolicyContractLoanContractType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  policyContractLenders_aggregate?: InputMaybe<PolicyContractLender_Aggregate_Order_By>;
};

/** primary key columns input for table: operations.policy_contract_loan_contract_type */
export type PolicyContractLoanContractType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.policy_contract_loan_contract_type" */
export enum PolicyContractLoanContractType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "operations.policy_contract_loan_contract_type" */
export type PolicyContractLoanContractType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type PolicyContractLoanContractType_Stddev_Fields = {
  __typename?: 'policyContractLoanContractType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PolicyContractLoanContractType_Stddev_Pop_Fields = {
  __typename?: 'policyContractLoanContractType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PolicyContractLoanContractType_Stddev_Samp_Fields = {
  __typename?: 'policyContractLoanContractType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policyContractLoanContractType" */
export type PolicyContractLoanContractType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractLoanContractType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractLoanContractType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PolicyContractLoanContractType_Sum_Fields = {
  __typename?: 'policyContractLoanContractType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "operations.policy_contract_loan_contract_type" */
export enum PolicyContractLoanContractType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type PolicyContractLoanContractType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyContractLoanContractType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractLoanContractType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractLoanContractType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyContractLoanContractType_Var_Pop_Fields = {
  __typename?: 'policyContractLoanContractType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PolicyContractLoanContractType_Var_Samp_Fields = {
  __typename?: 'policyContractLoanContractType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PolicyContractLoanContractType_Variance_Fields = {
  __typename?: 'policyContractLoanContractType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "operations.policy_contract_owner" */
export type PolicyContractOwner = {
  __typename?: 'policyContractOwner';
  /** An object relationship */
  contact?: Maybe<Contact>;
  contactId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  policyContract: PolicyContract;
  policyContractId: Scalars['uuid'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "operations.policy_contract_owner" */
export type PolicyContractOwnerLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract_owner" */
export type PolicyContractOwnerLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "operations.policy_contract_owner" */
export type PolicyContractOwner_Aggregate = {
  __typename?: 'policyContractOwner_aggregate';
  aggregate?: Maybe<PolicyContractOwner_Aggregate_Fields>;
  nodes: Array<PolicyContractOwner>;
};

export type PolicyContractOwner_Aggregate_Bool_Exp = {
  count?: InputMaybe<PolicyContractOwner_Aggregate_Bool_Exp_Count>;
};

export type PolicyContractOwner_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PolicyContractOwner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractOwner_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.policy_contract_owner" */
export type PolicyContractOwner_Aggregate_Fields = {
  __typename?: 'policyContractOwner_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PolicyContractOwner_Max_Fields>;
  min?: Maybe<PolicyContractOwner_Min_Fields>;
};


/** aggregate fields of "operations.policy_contract_owner" */
export type PolicyContractOwner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractOwner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.policy_contract_owner" */
export type PolicyContractOwner_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PolicyContractOwner_Max_Order_By>;
  min?: InputMaybe<PolicyContractOwner_Min_Order_By>;
};

/** input type for inserting array relation for remote table "operations.policy_contract_owner" */
export type PolicyContractOwner_Arr_Rel_Insert_Input = {
  data: Array<PolicyContractOwner_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractOwner_On_Conflict>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_owner". All fields are combined with a logical 'AND'. */
export type PolicyContractOwner_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractOwner_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractOwner_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractOwner_Bool_Exp>>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contactId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_owner" */
export enum PolicyContractOwner_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractOwnerPkey = 'policy_contract_owner_pkey'
}

/** input type for inserting data into table "operations.policy_contract_owner" */
export type PolicyContractOwner_Insert_Input = {
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyContractOwner_Max_Fields = {
  __typename?: 'policyContractOwner_max_fields';
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.policy_contract_owner" */
export type PolicyContractOwner_Max_Order_By = {
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PolicyContractOwner_Min_Fields = {
  __typename?: 'policyContractOwner_min_fields';
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.policy_contract_owner" */
export type PolicyContractOwner_Min_Order_By = {
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.policy_contract_owner" */
export type PolicyContractOwner_Mutation_Response = {
  __typename?: 'policyContractOwner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractOwner>;
};

/** on_conflict condition type for table "operations.policy_contract_owner" */
export type PolicyContractOwner_On_Conflict = {
  constraint: PolicyContractOwner_Constraint;
  update_columns?: Array<PolicyContractOwner_Update_Column>;
  where?: InputMaybe<PolicyContractOwner_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_owner". */
export type PolicyContractOwner_Order_By = {
  contact?: InputMaybe<Contact_Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.policy_contract_owner */
export type PolicyContractOwner_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.policy_contract_owner" */
export enum PolicyContractOwner_Select_Column {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.policy_contract_owner" */
export type PolicyContractOwner_Set_Input = {
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "policyContractOwner" */
export type PolicyContractOwner_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractOwner_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractOwner_Stream_Cursor_Value_Input = {
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "operations.policy_contract_owner" */
export enum PolicyContractOwner_Update_Column {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyContractOwner_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractOwner_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractOwner_Bool_Exp;
};

/** This table contains a snapshot of product details for a policy_contract. A policy_contract can have multiple products, and one contract. */
export type PolicyContractProduct = {
  __typename?: 'policyContractProduct';
  /** The timestamp with time zone representing when the record is created. */
  createdAt: Scalars['timestamptz'];
  /** The primary key of the policy_contract_product. */
  id: Scalars['uuid'];
  /** If a product has optional coverages attached with it, then a snapshot of those would be stored here, but not optional coverages that are composite products. */
  optionalCoverageMetadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  policyContract: PolicyContract;
  /** The uuid that establishes the relationship to the policy_contract. */
  policyContractId: Scalars['uuid'];
  /** An object relationship */
  policyContractProductCostDetail?: Maybe<PolicyContractProductCostDetail>;
  /** An object relationship */
  product?: Maybe<Product>;
  /** The uuid that establishes the relationship to a public.product. */
  productId?: Maybe<Scalars['uuid']>;
  /** Contains the snapshot of the product at time of purchase. Same as policy_contract.product_metadata. Its deductibleType key holds the legacy rating-engine integer for the deductible type (1 Flat Amount, 2 Disappearing), the same value MBP sends on to the AS400 as DeductibleTypeID. Resolve it to a row in the DeductibleType type group by matching that row metadata legacyDeductibleTypeId key; the types are identified by uuid and carry no enum_value. Read this to label the deductible on a claim (apps/claims mechanical claim page). Do not re-derive the type from the DisappearingDeductible configuration item: that item is set independently on Products and Account Categories and only means Disappearing when both levels carry it. */
  productMetadata?: Maybe<Scalars['jsonb']>;
  /** The uuid that represents a relationship to a product option in a quote. This is not a foreign key to a record in a table, but may be useful for finding quote information. */
  productOptionId?: Maybe<Scalars['uuid']>;
  /** The timestamp with timezone representing the last time the record was updated. */
  updatedAt: Scalars['timestamptz'];
};


/** This table contains a snapshot of product details for a policy_contract. A policy_contract can have multiple products, and one contract. */
export type PolicyContractProductOptionalCoverageMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table contains a snapshot of product details for a policy_contract. A policy_contract can have multiple products, and one contract. */
export type PolicyContractProductProductMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Contains snapshot of cost details for a purchased product. */
export type PolicyContractProductCostDetail = {
  __typename?: 'policyContractProductCostDetail';
  /** The information about the buckets of the product. */
  bucketMetadata?: Maybe<Scalars['jsonb']>;
  /** Information about the cost of the product. */
  costMetadata?: Maybe<Scalars['jsonb']>;
  /** The timestamp of when the record was created. */
  createdAt: Scalars['timestamptz'];
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['numeric']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['numeric']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['numeric']>;
  /** Information about the disbursements of the product. */
  disbursementMetadata?: Maybe<Scalars['jsonb']>;
  /** The primary key of the table. */
  id: Scalars['uuid'];
  /** An object relationship */
  policyContractProduct: PolicyContractProduct;
  /** The uuid that establishes the relationship to a policy_contract_product */
  policyContractProductId: Scalars['uuid'];
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['numeric']>;
  /** The timestamp of when the record was last updated. */
  updatedAt: Scalars['timestamptz'];
};


/** Contains snapshot of cost details for a purchased product. */
export type PolicyContractProductCostDetailBucketMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Contains snapshot of cost details for a purchased product. */
export type PolicyContractProductCostDetailCostMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Contains snapshot of cost details for a purchased product. */
export type PolicyContractProductCostDetailDisbursementMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "operations.policy_contract_product_cost_detail" */
export type PolicyContractProductCostDetail_Aggregate = {
  __typename?: 'policyContractProductCostDetail_aggregate';
  aggregate?: Maybe<PolicyContractProductCostDetail_Aggregate_Fields>;
  nodes: Array<PolicyContractProductCostDetail>;
};

/** aggregate fields of "operations.policy_contract_product_cost_detail" */
export type PolicyContractProductCostDetail_Aggregate_Fields = {
  __typename?: 'policyContractProductCostDetail_aggregate_fields';
  avg?: Maybe<PolicyContractProductCostDetail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContractProductCostDetail_Max_Fields>;
  min?: Maybe<PolicyContractProductCostDetail_Min_Fields>;
  stddev?: Maybe<PolicyContractProductCostDetail_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContractProductCostDetail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContractProductCostDetail_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContractProductCostDetail_Sum_Fields>;
  var_pop?: Maybe<PolicyContractProductCostDetail_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContractProductCostDetail_Var_Samp_Fields>;
  variance?: Maybe<PolicyContractProductCostDetail_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract_product_cost_detail" */
export type PolicyContractProductCostDetail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractProductCostDetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyContractProductCostDetail_Append_Input = {
  /** The information about the buckets of the product. */
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Information about the cost of the product. */
  costMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Information about the disbursements of the product. */
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type PolicyContractProductCostDetail_Avg_Fields = {
  __typename?: 'policyContractProductCostDetail_avg_fields';
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['Float']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_product_cost_detail". All fields are combined with a logical 'AND'. */
export type PolicyContractProductCostDetail_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractProductCostDetail_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractProductCostDetail_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractProductCostDetail_Bool_Exp>>;
  bucketMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  costMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customerPrice?: InputMaybe<Numeric_Comparison_Exp>;
  dealerCost?: InputMaybe<Numeric_Comparison_Exp>;
  dealerRemitAmount?: InputMaybe<Numeric_Comparison_Exp>;
  disbursementMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policyContractProduct?: InputMaybe<PolicyContractProduct_Bool_Exp>;
  policyContractProductId?: InputMaybe<Uuid_Comparison_Exp>;
  retailAmount?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_product_cost_detail" */
export enum PolicyContractProductCostDetail_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractProductCostDetailPkey = 'policy_contract_product_cost_detail_pkey',
  /** unique or primary key constraint on columns "policy_contract_product_id" */
  PolicyContractProductCostDetailPolicyContractProductId = 'policy_contract_product_cost_detail_policy_contract_product_id_'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyContractProductCostDetail_Delete_At_Path_Input = {
  /** The information about the buckets of the product. */
  bucketMetadata?: InputMaybe<Array<Scalars['String']>>;
  /** Information about the cost of the product. */
  costMetadata?: InputMaybe<Array<Scalars['String']>>;
  /** Information about the disbursements of the product. */
  disbursementMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyContractProductCostDetail_Delete_Elem_Input = {
  /** The information about the buckets of the product. */
  bucketMetadata?: InputMaybe<Scalars['Int']>;
  /** Information about the cost of the product. */
  costMetadata?: InputMaybe<Scalars['Int']>;
  /** Information about the disbursements of the product. */
  disbursementMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyContractProductCostDetail_Delete_Key_Input = {
  /** The information about the buckets of the product. */
  bucketMetadata?: InputMaybe<Scalars['String']>;
  /** Information about the cost of the product. */
  costMetadata?: InputMaybe<Scalars['String']>;
  /** Information about the disbursements of the product. */
  disbursementMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "operations.policy_contract_product_cost_detail" */
export type PolicyContractProductCostDetail_Inc_Input = {
  /** The number representing the customer price of the product. */
  customerPrice?: InputMaybe<Scalars['numeric']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: InputMaybe<Scalars['numeric']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: InputMaybe<Scalars['numeric']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.policy_contract_product_cost_detail" */
export type PolicyContractProductCostDetail_Insert_Input = {
  /** The information about the buckets of the product. */
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Information about the cost of the product. */
  costMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The timestamp of when the record was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The number representing the customer price of the product. */
  customerPrice?: InputMaybe<Scalars['numeric']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: InputMaybe<Scalars['numeric']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: InputMaybe<Scalars['numeric']>;
  /** Information about the disbursements of the product. */
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The primary key of the table. */
  id?: InputMaybe<Scalars['uuid']>;
  policyContractProduct?: InputMaybe<PolicyContractProduct_Obj_Rel_Insert_Input>;
  /** The uuid that establishes the relationship to a policy_contract_product */
  policyContractProductId?: InputMaybe<Scalars['uuid']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: InputMaybe<Scalars['numeric']>;
  /** The timestamp of when the record was last updated. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyContractProductCostDetail_Max_Fields = {
  __typename?: 'policyContractProductCostDetail_max_fields';
  /** The timestamp of when the record was created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['numeric']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['numeric']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['numeric']>;
  /** The primary key of the table. */
  id?: Maybe<Scalars['uuid']>;
  /** The uuid that establishes the relationship to a policy_contract_product */
  policyContractProductId?: Maybe<Scalars['uuid']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['numeric']>;
  /** The timestamp of when the record was last updated. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PolicyContractProductCostDetail_Min_Fields = {
  __typename?: 'policyContractProductCostDetail_min_fields';
  /** The timestamp of when the record was created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['numeric']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['numeric']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['numeric']>;
  /** The primary key of the table. */
  id?: Maybe<Scalars['uuid']>;
  /** The uuid that establishes the relationship to a policy_contract_product */
  policyContractProductId?: Maybe<Scalars['uuid']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['numeric']>;
  /** The timestamp of when the record was last updated. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "operations.policy_contract_product_cost_detail" */
export type PolicyContractProductCostDetail_Mutation_Response = {
  __typename?: 'policyContractProductCostDetail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractProductCostDetail>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_product_cost_detail" */
export type PolicyContractProductCostDetail_Obj_Rel_Insert_Input = {
  data: PolicyContractProductCostDetail_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractProductCostDetail_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract_product_cost_detail" */
export type PolicyContractProductCostDetail_On_Conflict = {
  constraint: PolicyContractProductCostDetail_Constraint;
  update_columns?: Array<PolicyContractProductCostDetail_Update_Column>;
  where?: InputMaybe<PolicyContractProductCostDetail_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_product_cost_detail". */
export type PolicyContractProductCostDetail_Order_By = {
  bucketMetadata?: InputMaybe<Order_By>;
  costMetadata?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  dealerCost?: InputMaybe<Order_By>;
  dealerRemitAmount?: InputMaybe<Order_By>;
  disbursementMetadata?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyContractProduct?: InputMaybe<PolicyContractProduct_Order_By>;
  policyContractProductId?: InputMaybe<Order_By>;
  retailAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.policy_contract_product_cost_detail */
export type PolicyContractProductCostDetail_Pk_Columns_Input = {
  /** The primary key of the table. */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicyContractProductCostDetail_Prepend_Input = {
  /** The information about the buckets of the product. */
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Information about the cost of the product. */
  costMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Information about the disbursements of the product. */
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "operations.policy_contract_product_cost_detail" */
export enum PolicyContractProductCostDetail_Select_Column {
  /** column name */
  BucketMetadata = 'bucketMetadata',
  /** column name */
  CostMetadata = 'costMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerPrice = 'customerPrice',
  /** column name */
  DealerCost = 'dealerCost',
  /** column name */
  DealerRemitAmount = 'dealerRemitAmount',
  /** column name */
  DisbursementMetadata = 'disbursementMetadata',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyContractProductId = 'policyContractProductId',
  /** column name */
  RetailAmount = 'retailAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.policy_contract_product_cost_detail" */
export type PolicyContractProductCostDetail_Set_Input = {
  /** The information about the buckets of the product. */
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Information about the cost of the product. */
  costMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The timestamp of when the record was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The number representing the customer price of the product. */
  customerPrice?: InputMaybe<Scalars['numeric']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: InputMaybe<Scalars['numeric']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: InputMaybe<Scalars['numeric']>;
  /** Information about the disbursements of the product. */
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The primary key of the table. */
  id?: InputMaybe<Scalars['uuid']>;
  /** The uuid that establishes the relationship to a policy_contract_product */
  policyContractProductId?: InputMaybe<Scalars['uuid']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: InputMaybe<Scalars['numeric']>;
  /** The timestamp of when the record was last updated. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PolicyContractProductCostDetail_Stddev_Fields = {
  __typename?: 'policyContractProductCostDetail_stddev_fields';
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['Float']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PolicyContractProductCostDetail_Stddev_Pop_Fields = {
  __typename?: 'policyContractProductCostDetail_stddev_pop_fields';
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['Float']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PolicyContractProductCostDetail_Stddev_Samp_Fields = {
  __typename?: 'policyContractProductCostDetail_stddev_samp_fields';
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['Float']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policyContractProductCostDetail" */
export type PolicyContractProductCostDetail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractProductCostDetail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractProductCostDetail_Stream_Cursor_Value_Input = {
  /** The information about the buckets of the product. */
  bucketMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Information about the cost of the product. */
  costMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The timestamp of when the record was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The number representing the customer price of the product. */
  customerPrice?: InputMaybe<Scalars['numeric']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: InputMaybe<Scalars['numeric']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: InputMaybe<Scalars['numeric']>;
  /** Information about the disbursements of the product. */
  disbursementMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The primary key of the table. */
  id?: InputMaybe<Scalars['uuid']>;
  /** The uuid that establishes the relationship to a policy_contract_product */
  policyContractProductId?: InputMaybe<Scalars['uuid']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: InputMaybe<Scalars['numeric']>;
  /** The timestamp of when the record was last updated. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PolicyContractProductCostDetail_Sum_Fields = {
  __typename?: 'policyContractProductCostDetail_sum_fields';
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['numeric']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['numeric']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['numeric']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "operations.policy_contract_product_cost_detail" */
export enum PolicyContractProductCostDetail_Update_Column {
  /** column name */
  BucketMetadata = 'bucketMetadata',
  /** column name */
  CostMetadata = 'costMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerPrice = 'customerPrice',
  /** column name */
  DealerCost = 'dealerCost',
  /** column name */
  DealerRemitAmount = 'dealerRemitAmount',
  /** column name */
  DisbursementMetadata = 'disbursementMetadata',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyContractProductId = 'policyContractProductId',
  /** column name */
  RetailAmount = 'retailAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyContractProductCostDetail_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyContractProductCostDetail_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyContractProductCostDetail_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyContractProductCostDetail_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyContractProductCostDetail_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyContractProductCostDetail_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicyContractProductCostDetail_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractProductCostDetail_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractProductCostDetail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyContractProductCostDetail_Var_Pop_Fields = {
  __typename?: 'policyContractProductCostDetail_var_pop_fields';
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['Float']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PolicyContractProductCostDetail_Var_Samp_Fields = {
  __typename?: 'policyContractProductCostDetail_var_samp_fields';
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['Float']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PolicyContractProductCostDetail_Variance_Fields = {
  __typename?: 'policyContractProductCostDetail_variance_fields';
  /** The number representing the customer price of the product. */
  customerPrice?: Maybe<Scalars['Float']>;
  /** The number representing the dealer cost of the product. */
  dealerCost?: Maybe<Scalars['Float']>;
  /** The number representing the amount that the dealer remits for the product. */
  dealerRemitAmount?: Maybe<Scalars['Float']>;
  /** The number representing the retail amount of the product. */
  retailAmount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView = {
  __typename?: 'policyContractProductOptionsMetadataView';
  coverageMiles?: Maybe<Scalars['Int']>;
  coverageMonths?: Maybe<Scalars['Int']>;
  customerPrice?: Maybe<Scalars['numeric']>;
  deductibleAmount?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['String']>;
  expirationMiles?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  includesCosmeticCoverageOption?: Maybe<Scalars['Boolean']>;
  includesDentCoverageOption?: Maybe<Scalars['Boolean']>;
  includesKeyCoverageOption?: Maybe<Scalars['Boolean']>;
  includesTireCoverageOption?: Maybe<Scalars['Boolean']>;
  includesWindshieldCoverageOption?: Maybe<Scalars['Boolean']>;
  optionalCoverages?: Maybe<Scalars['jsonb']>;
  planGroupName?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planSubGroupName?: Maybe<Scalars['String']>;
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  policyContractId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  quote?: Maybe<Quote>;
  quoteDate?: Maybe<Scalars['timestamptz']>;
  quoteId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataViewOptionalCoveragesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Aggregate = {
  __typename?: 'policyContractProductOptionsMetadataView_aggregate';
  aggregate?: Maybe<PolicyContractProductOptionsMetadataView_Aggregate_Fields>;
  nodes: Array<PolicyContractProductOptionsMetadataView>;
};

export type PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp_Count>;
};

export type PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp_Bool_And = {
  arguments: PolicyContractProductOptionsMetadataView_Select_Column_PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp_Bool_Or = {
  arguments: PolicyContractProductOptionsMetadataView_Select_Column_PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Aggregate_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_aggregate_fields';
  avg?: Maybe<PolicyContractProductOptionsMetadataView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContractProductOptionsMetadataView_Max_Fields>;
  min?: Maybe<PolicyContractProductOptionsMetadataView_Min_Fields>;
  stddev?: Maybe<PolicyContractProductOptionsMetadataView_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContractProductOptionsMetadataView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContractProductOptionsMetadataView_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContractProductOptionsMetadataView_Sum_Fields>;
  var_pop?: Maybe<PolicyContractProductOptionsMetadataView_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContractProductOptionsMetadataView_Var_Samp_Fields>;
  variance?: Maybe<PolicyContractProductOptionsMetadataView_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Aggregate_Order_By = {
  avg?: InputMaybe<PolicyContractProductOptionsMetadataView_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PolicyContractProductOptionsMetadataView_Max_Order_By>;
  min?: InputMaybe<PolicyContractProductOptionsMetadataView_Min_Order_By>;
  stddev?: InputMaybe<PolicyContractProductOptionsMetadataView_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PolicyContractProductOptionsMetadataView_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PolicyContractProductOptionsMetadataView_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PolicyContractProductOptionsMetadataView_Sum_Order_By>;
  var_pop?: InputMaybe<PolicyContractProductOptionsMetadataView_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PolicyContractProductOptionsMetadataView_Var_Samp_Order_By>;
  variance?: InputMaybe<PolicyContractProductOptionsMetadataView_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Arr_Rel_Insert_Input = {
  data: Array<PolicyContractProductOptionsMetadataView_Insert_Input>;
};

/** aggregate avg on columns */
export type PolicyContractProductOptionsMetadataView_Avg_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_avg_fields';
  coverageMiles?: Maybe<Scalars['Float']>;
  coverageMonths?: Maybe<Scalars['Float']>;
  customerPrice?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Avg_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_product_options_metadata_view". All fields are combined with a logical 'AND'. */
export type PolicyContractProductOptionsMetadataView_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Bool_Exp>>;
  coverageMiles?: InputMaybe<Int_Comparison_Exp>;
  coverageMonths?: InputMaybe<Int_Comparison_Exp>;
  customerPrice?: InputMaybe<Numeric_Comparison_Exp>;
  deductibleAmount?: InputMaybe<Numeric_Comparison_Exp>;
  expirationDate?: InputMaybe<String_Comparison_Exp>;
  expirationMiles?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  includesCosmeticCoverageOption?: InputMaybe<Boolean_Comparison_Exp>;
  includesDentCoverageOption?: InputMaybe<Boolean_Comparison_Exp>;
  includesKeyCoverageOption?: InputMaybe<Boolean_Comparison_Exp>;
  includesTireCoverageOption?: InputMaybe<Boolean_Comparison_Exp>;
  includesWindshieldCoverageOption?: InputMaybe<Boolean_Comparison_Exp>;
  optionalCoverages?: InputMaybe<Jsonb_Comparison_Exp>;
  planGroupName?: InputMaybe<String_Comparison_Exp>;
  planName?: InputMaybe<String_Comparison_Exp>;
  planSubGroupName?: InputMaybe<String_Comparison_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  quote?: InputMaybe<Quote_Bool_Exp>;
  quoteDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  quoteId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Insert_Input = {
  coverageMiles?: InputMaybe<Scalars['Int']>;
  coverageMonths?: InputMaybe<Scalars['Int']>;
  customerPrice?: InputMaybe<Scalars['numeric']>;
  deductibleAmount?: InputMaybe<Scalars['numeric']>;
  expirationDate?: InputMaybe<Scalars['String']>;
  expirationMiles?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  includesCosmeticCoverageOption?: InputMaybe<Scalars['Boolean']>;
  includesDentCoverageOption?: InputMaybe<Scalars['Boolean']>;
  includesKeyCoverageOption?: InputMaybe<Scalars['Boolean']>;
  includesTireCoverageOption?: InputMaybe<Scalars['Boolean']>;
  includesWindshieldCoverageOption?: InputMaybe<Scalars['Boolean']>;
  optionalCoverages?: InputMaybe<Scalars['jsonb']>;
  planGroupName?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  planSubGroupName?: InputMaybe<Scalars['String']>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  quote?: InputMaybe<Quote_Obj_Rel_Insert_Input>;
  quoteDate?: InputMaybe<Scalars['timestamptz']>;
  quoteId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PolicyContractProductOptionsMetadataView_Max_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_max_fields';
  coverageMiles?: Maybe<Scalars['Int']>;
  coverageMonths?: Maybe<Scalars['Int']>;
  customerPrice?: Maybe<Scalars['numeric']>;
  deductibleAmount?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['String']>;
  expirationMiles?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  planGroupName?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planSubGroupName?: Maybe<Scalars['String']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  quoteDate?: Maybe<Scalars['timestamptz']>;
  quoteId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Max_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  planGroupName?: InputMaybe<Order_By>;
  planName?: InputMaybe<Order_By>;
  planSubGroupName?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  quoteDate?: InputMaybe<Order_By>;
  quoteId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PolicyContractProductOptionsMetadataView_Min_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_min_fields';
  coverageMiles?: Maybe<Scalars['Int']>;
  coverageMonths?: Maybe<Scalars['Int']>;
  customerPrice?: Maybe<Scalars['numeric']>;
  deductibleAmount?: Maybe<Scalars['numeric']>;
  expirationDate?: Maybe<Scalars['String']>;
  expirationMiles?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  planGroupName?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planSubGroupName?: Maybe<Scalars['String']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  quoteDate?: Maybe<Scalars['timestamptz']>;
  quoteId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Min_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  planGroupName?: InputMaybe<Order_By>;
  planName?: InputMaybe<Order_By>;
  planSubGroupName?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  quoteDate?: InputMaybe<Order_By>;
  quoteId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "operations.policy_contract_product_options_metadata_view". */
export type PolicyContractProductOptionsMetadataView_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  includesCosmeticCoverageOption?: InputMaybe<Order_By>;
  includesDentCoverageOption?: InputMaybe<Order_By>;
  includesKeyCoverageOption?: InputMaybe<Order_By>;
  includesTireCoverageOption?: InputMaybe<Order_By>;
  includesWindshieldCoverageOption?: InputMaybe<Order_By>;
  optionalCoverages?: InputMaybe<Order_By>;
  planGroupName?: InputMaybe<Order_By>;
  planName?: InputMaybe<Order_By>;
  planSubGroupName?: InputMaybe<Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  quote?: InputMaybe<Quote_Order_By>;
  quoteDate?: InputMaybe<Order_By>;
  quoteId?: InputMaybe<Order_By>;
};

/** select columns of table "operations.policy_contract_product_options_metadata_view" */
export enum PolicyContractProductOptionsMetadataView_Select_Column {
  /** column name */
  CoverageMiles = 'coverageMiles',
  /** column name */
  CoverageMonths = 'coverageMonths',
  /** column name */
  CustomerPrice = 'customerPrice',
  /** column name */
  DeductibleAmount = 'deductibleAmount',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  ExpirationMiles = 'expirationMiles',
  /** column name */
  Id = 'id',
  /** column name */
  IncludesCosmeticCoverageOption = 'includesCosmeticCoverageOption',
  /** column name */
  IncludesDentCoverageOption = 'includesDentCoverageOption',
  /** column name */
  IncludesKeyCoverageOption = 'includesKeyCoverageOption',
  /** column name */
  IncludesTireCoverageOption = 'includesTireCoverageOption',
  /** column name */
  IncludesWindshieldCoverageOption = 'includesWindshieldCoverageOption',
  /** column name */
  OptionalCoverages = 'optionalCoverages',
  /** column name */
  PlanGroupName = 'planGroupName',
  /** column name */
  PlanName = 'planName',
  /** column name */
  PlanSubGroupName = 'planSubGroupName',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  QuoteDate = 'quoteDate',
  /** column name */
  QuoteId = 'quoteId'
}

/** select "policyContractProductOptionsMetadataView_aggregate_bool_exp_bool_and_arguments_columns" columns of table "operations.policy_contract_product_options_metadata_view" */
export enum PolicyContractProductOptionsMetadataView_Select_Column_PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IncludesCosmeticCoverageOption = 'includesCosmeticCoverageOption',
  /** column name */
  IncludesDentCoverageOption = 'includesDentCoverageOption',
  /** column name */
  IncludesKeyCoverageOption = 'includesKeyCoverageOption',
  /** column name */
  IncludesTireCoverageOption = 'includesTireCoverageOption',
  /** column name */
  IncludesWindshieldCoverageOption = 'includesWindshieldCoverageOption'
}

/** select "policyContractProductOptionsMetadataView_aggregate_bool_exp_bool_or_arguments_columns" columns of table "operations.policy_contract_product_options_metadata_view" */
export enum PolicyContractProductOptionsMetadataView_Select_Column_PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IncludesCosmeticCoverageOption = 'includesCosmeticCoverageOption',
  /** column name */
  IncludesDentCoverageOption = 'includesDentCoverageOption',
  /** column name */
  IncludesKeyCoverageOption = 'includesKeyCoverageOption',
  /** column name */
  IncludesTireCoverageOption = 'includesTireCoverageOption',
  /** column name */
  IncludesWindshieldCoverageOption = 'includesWindshieldCoverageOption'
}

/** aggregate stddev on columns */
export type PolicyContractProductOptionsMetadataView_Stddev_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_stddev_fields';
  coverageMiles?: Maybe<Scalars['Float']>;
  coverageMonths?: Maybe<Scalars['Float']>;
  customerPrice?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Stddev_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PolicyContractProductOptionsMetadataView_Stddev_Pop_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_stddev_pop_fields';
  coverageMiles?: Maybe<Scalars['Float']>;
  coverageMonths?: Maybe<Scalars['Float']>;
  customerPrice?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Stddev_Pop_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PolicyContractProductOptionsMetadataView_Stddev_Samp_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_stddev_samp_fields';
  coverageMiles?: Maybe<Scalars['Float']>;
  coverageMonths?: Maybe<Scalars['Float']>;
  customerPrice?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Stddev_Samp_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "policyContractProductOptionsMetadataView" */
export type PolicyContractProductOptionsMetadataView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractProductOptionsMetadataView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractProductOptionsMetadataView_Stream_Cursor_Value_Input = {
  coverageMiles?: InputMaybe<Scalars['Int']>;
  coverageMonths?: InputMaybe<Scalars['Int']>;
  customerPrice?: InputMaybe<Scalars['numeric']>;
  deductibleAmount?: InputMaybe<Scalars['numeric']>;
  expirationDate?: InputMaybe<Scalars['String']>;
  expirationMiles?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  includesCosmeticCoverageOption?: InputMaybe<Scalars['Boolean']>;
  includesDentCoverageOption?: InputMaybe<Scalars['Boolean']>;
  includesKeyCoverageOption?: InputMaybe<Scalars['Boolean']>;
  includesTireCoverageOption?: InputMaybe<Scalars['Boolean']>;
  includesWindshieldCoverageOption?: InputMaybe<Scalars['Boolean']>;
  optionalCoverages?: InputMaybe<Scalars['jsonb']>;
  planGroupName?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  planSubGroupName?: InputMaybe<Scalars['String']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  quoteDate?: InputMaybe<Scalars['timestamptz']>;
  quoteId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PolicyContractProductOptionsMetadataView_Sum_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_sum_fields';
  coverageMiles?: Maybe<Scalars['Int']>;
  coverageMonths?: Maybe<Scalars['Int']>;
  customerPrice?: Maybe<Scalars['numeric']>;
  deductibleAmount?: Maybe<Scalars['numeric']>;
  expirationMiles?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Sum_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type PolicyContractProductOptionsMetadataView_Var_Pop_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_var_pop_fields';
  coverageMiles?: Maybe<Scalars['Float']>;
  coverageMonths?: Maybe<Scalars['Float']>;
  customerPrice?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Var_Pop_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PolicyContractProductOptionsMetadataView_Var_Samp_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_var_samp_fields';
  coverageMiles?: Maybe<Scalars['Float']>;
  coverageMonths?: Maybe<Scalars['Float']>;
  customerPrice?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Var_Samp_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PolicyContractProductOptionsMetadataView_Variance_Fields = {
  __typename?: 'policyContractProductOptionsMetadataView_variance_fields';
  coverageMiles?: Maybe<Scalars['Float']>;
  coverageMonths?: Maybe<Scalars['Float']>;
  customerPrice?: Maybe<Scalars['Float']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  expirationMiles?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations.policy_contract_product_options_metadata_view" */
export type PolicyContractProductOptionsMetadataView_Variance_Order_By = {
  coverageMiles?: InputMaybe<Order_By>;
  coverageMonths?: InputMaybe<Order_By>;
  customerPrice?: InputMaybe<Order_By>;
  deductibleAmount?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
};

/** aggregated selection of "operations.policy_contract_product" */
export type PolicyContractProduct_Aggregate = {
  __typename?: 'policyContractProduct_aggregate';
  aggregate?: Maybe<PolicyContractProduct_Aggregate_Fields>;
  nodes: Array<PolicyContractProduct>;
};

export type PolicyContractProduct_Aggregate_Bool_Exp = {
  count?: InputMaybe<PolicyContractProduct_Aggregate_Bool_Exp_Count>;
};

export type PolicyContractProduct_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PolicyContractProduct_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractProduct_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.policy_contract_product" */
export type PolicyContractProduct_Aggregate_Fields = {
  __typename?: 'policyContractProduct_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PolicyContractProduct_Max_Fields>;
  min?: Maybe<PolicyContractProduct_Min_Fields>;
};


/** aggregate fields of "operations.policy_contract_product" */
export type PolicyContractProduct_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractProduct_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.policy_contract_product" */
export type PolicyContractProduct_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PolicyContractProduct_Max_Order_By>;
  min?: InputMaybe<PolicyContractProduct_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyContractProduct_Append_Input = {
  /** If a product has optional coverages attached with it, then a snapshot of those would be stored here, but not optional coverages that are composite products. */
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Contains the snapshot of the product at time of purchase. Same as policy_contract.product_metadata. Its deductibleType key holds the legacy rating-engine integer for the deductible type (1 Flat Amount, 2 Disappearing), the same value MBP sends on to the AS400 as DeductibleTypeID. Resolve it to a row in the DeductibleType type group by matching that row metadata legacyDeductibleTypeId key; the types are identified by uuid and carry no enum_value. Read this to label the deductible on a claim (apps/claims mechanical claim page). Do not re-derive the type from the DisappearingDeductible configuration item: that item is set independently on Products and Account Categories and only means Disappearing when both levels carry it. */
  productMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "operations.policy_contract_product" */
export type PolicyContractProduct_Arr_Rel_Insert_Input = {
  data: Array<PolicyContractProduct_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractProduct_On_Conflict>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_product". All fields are combined with a logical 'AND'. */
export type PolicyContractProduct_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractProduct_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractProduct_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractProduct_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  optionalCoverageMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContractProductCostDetail?: InputMaybe<PolicyContractProductCostDetail_Bool_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  productMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  productOptionId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_product" */
export enum PolicyContractProduct_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractProductPkey = 'policy_contract_product_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyContractProduct_Delete_At_Path_Input = {
  /** If a product has optional coverages attached with it, then a snapshot of those would be stored here, but not optional coverages that are composite products. */
  optionalCoverageMetadata?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the snapshot of the product at time of purchase. Same as policy_contract.product_metadata. Its deductibleType key holds the legacy rating-engine integer for the deductible type (1 Flat Amount, 2 Disappearing), the same value MBP sends on to the AS400 as DeductibleTypeID. Resolve it to a row in the DeductibleType type group by matching that row metadata legacyDeductibleTypeId key; the types are identified by uuid and carry no enum_value. Read this to label the deductible on a claim (apps/claims mechanical claim page). Do not re-derive the type from the DisappearingDeductible configuration item: that item is set independently on Products and Account Categories and only means Disappearing when both levels carry it. */
  productMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyContractProduct_Delete_Elem_Input = {
  /** If a product has optional coverages attached with it, then a snapshot of those would be stored here, but not optional coverages that are composite products. */
  optionalCoverageMetadata?: InputMaybe<Scalars['Int']>;
  /** Contains the snapshot of the product at time of purchase. Same as policy_contract.product_metadata. Its deductibleType key holds the legacy rating-engine integer for the deductible type (1 Flat Amount, 2 Disappearing), the same value MBP sends on to the AS400 as DeductibleTypeID. Resolve it to a row in the DeductibleType type group by matching that row metadata legacyDeductibleTypeId key; the types are identified by uuid and carry no enum_value. Read this to label the deductible on a claim (apps/claims mechanical claim page). Do not re-derive the type from the DisappearingDeductible configuration item: that item is set independently on Products and Account Categories and only means Disappearing when both levels carry it. */
  productMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyContractProduct_Delete_Key_Input = {
  /** If a product has optional coverages attached with it, then a snapshot of those would be stored here, but not optional coverages that are composite products. */
  optionalCoverageMetadata?: InputMaybe<Scalars['String']>;
  /** Contains the snapshot of the product at time of purchase. Same as policy_contract.product_metadata. Its deductibleType key holds the legacy rating-engine integer for the deductible type (1 Flat Amount, 2 Disappearing), the same value MBP sends on to the AS400 as DeductibleTypeID. Resolve it to a row in the DeductibleType type group by matching that row metadata legacyDeductibleTypeId key; the types are identified by uuid and carry no enum_value. Read this to label the deductible on a claim (apps/claims mechanical claim page). Do not re-derive the type from the DisappearingDeductible configuration item: that item is set independently on Products and Account Categories and only means Disappearing when both levels carry it. */
  productMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "operations.policy_contract_product" */
export type PolicyContractProduct_Insert_Input = {
  /** The timestamp with time zone representing when the record is created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The primary key of the policy_contract_product. */
  id?: InputMaybe<Scalars['uuid']>;
  /** If a product has optional coverages attached with it, then a snapshot of those would be stored here, but not optional coverages that are composite products. */
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  /** The uuid that establishes the relationship to the policy_contract. */
  policyContractId?: InputMaybe<Scalars['uuid']>;
  policyContractProductCostDetail?: InputMaybe<PolicyContractProductCostDetail_Obj_Rel_Insert_Input>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  /** The uuid that establishes the relationship to a public.product. */
  productId?: InputMaybe<Scalars['uuid']>;
  /** Contains the snapshot of the product at time of purchase. Same as policy_contract.product_metadata. Its deductibleType key holds the legacy rating-engine integer for the deductible type (1 Flat Amount, 2 Disappearing), the same value MBP sends on to the AS400 as DeductibleTypeID. Resolve it to a row in the DeductibleType type group by matching that row metadata legacyDeductibleTypeId key; the types are identified by uuid and carry no enum_value. Read this to label the deductible on a claim (apps/claims mechanical claim page). Do not re-derive the type from the DisappearingDeductible configuration item: that item is set independently on Products and Account Categories and only means Disappearing when both levels carry it. */
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The uuid that represents a relationship to a product option in a quote. This is not a foreign key to a record in a table, but may be useful for finding quote information. */
  productOptionId?: InputMaybe<Scalars['uuid']>;
  /** The timestamp with timezone representing the last time the record was updated. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyContractProduct_Max_Fields = {
  __typename?: 'policyContractProduct_max_fields';
  /** The timestamp with time zone representing when the record is created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The primary key of the policy_contract_product. */
  id?: Maybe<Scalars['uuid']>;
  /** The uuid that establishes the relationship to the policy_contract. */
  policyContractId?: Maybe<Scalars['uuid']>;
  /** The uuid that establishes the relationship to a public.product. */
  productId?: Maybe<Scalars['uuid']>;
  /** The uuid that represents a relationship to a product option in a quote. This is not a foreign key to a record in a table, but may be useful for finding quote information. */
  productOptionId?: Maybe<Scalars['uuid']>;
  /** The timestamp with timezone representing the last time the record was updated. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.policy_contract_product" */
export type PolicyContractProduct_Max_Order_By = {
  /** The timestamp with time zone representing when the record is created. */
  createdAt?: InputMaybe<Order_By>;
  /** The primary key of the policy_contract_product. */
  id?: InputMaybe<Order_By>;
  /** The uuid that establishes the relationship to the policy_contract. */
  policyContractId?: InputMaybe<Order_By>;
  /** The uuid that establishes the relationship to a public.product. */
  productId?: InputMaybe<Order_By>;
  /** The uuid that represents a relationship to a product option in a quote. This is not a foreign key to a record in a table, but may be useful for finding quote information. */
  productOptionId?: InputMaybe<Order_By>;
  /** The timestamp with timezone representing the last time the record was updated. */
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PolicyContractProduct_Min_Fields = {
  __typename?: 'policyContractProduct_min_fields';
  /** The timestamp with time zone representing when the record is created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The primary key of the policy_contract_product. */
  id?: Maybe<Scalars['uuid']>;
  /** The uuid that establishes the relationship to the policy_contract. */
  policyContractId?: Maybe<Scalars['uuid']>;
  /** The uuid that establishes the relationship to a public.product. */
  productId?: Maybe<Scalars['uuid']>;
  /** The uuid that represents a relationship to a product option in a quote. This is not a foreign key to a record in a table, but may be useful for finding quote information. */
  productOptionId?: Maybe<Scalars['uuid']>;
  /** The timestamp with timezone representing the last time the record was updated. */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.policy_contract_product" */
export type PolicyContractProduct_Min_Order_By = {
  /** The timestamp with time zone representing when the record is created. */
  createdAt?: InputMaybe<Order_By>;
  /** The primary key of the policy_contract_product. */
  id?: InputMaybe<Order_By>;
  /** The uuid that establishes the relationship to the policy_contract. */
  policyContractId?: InputMaybe<Order_By>;
  /** The uuid that establishes the relationship to a public.product. */
  productId?: InputMaybe<Order_By>;
  /** The uuid that represents a relationship to a product option in a quote. This is not a foreign key to a record in a table, but may be useful for finding quote information. */
  productOptionId?: InputMaybe<Order_By>;
  /** The timestamp with timezone representing the last time the record was updated. */
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.policy_contract_product" */
export type PolicyContractProduct_Mutation_Response = {
  __typename?: 'policyContractProduct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractProduct>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_product" */
export type PolicyContractProduct_Obj_Rel_Insert_Input = {
  data: PolicyContractProduct_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractProduct_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract_product" */
export type PolicyContractProduct_On_Conflict = {
  constraint: PolicyContractProduct_Constraint;
  update_columns?: Array<PolicyContractProduct_Update_Column>;
  where?: InputMaybe<PolicyContractProduct_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_product". */
export type PolicyContractProduct_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  optionalCoverageMetadata?: InputMaybe<Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  policyContractProductCostDetail?: InputMaybe<PolicyContractProductCostDetail_Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  productMetadata?: InputMaybe<Order_By>;
  productOptionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.policy_contract_product */
export type PolicyContractProduct_Pk_Columns_Input = {
  /** The primary key of the policy_contract_product. */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicyContractProduct_Prepend_Input = {
  /** If a product has optional coverages attached with it, then a snapshot of those would be stored here, but not optional coverages that are composite products. */
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Contains the snapshot of the product at time of purchase. Same as policy_contract.product_metadata. Its deductibleType key holds the legacy rating-engine integer for the deductible type (1 Flat Amount, 2 Disappearing), the same value MBP sends on to the AS400 as DeductibleTypeID. Resolve it to a row in the DeductibleType type group by matching that row metadata legacyDeductibleTypeId key; the types are identified by uuid and carry no enum_value. Read this to label the deductible on a claim (apps/claims mechanical claim page). Do not re-derive the type from the DisappearingDeductible configuration item: that item is set independently on Products and Account Categories and only means Disappearing when both levels carry it. */
  productMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "operations.policy_contract_product" */
export enum PolicyContractProduct_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OptionalCoverageMetadata = 'optionalCoverageMetadata',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  ProductMetadata = 'productMetadata',
  /** column name */
  ProductOptionId = 'productOptionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.policy_contract_product" */
export type PolicyContractProduct_Set_Input = {
  /** The timestamp with time zone representing when the record is created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The primary key of the policy_contract_product. */
  id?: InputMaybe<Scalars['uuid']>;
  /** If a product has optional coverages attached with it, then a snapshot of those would be stored here, but not optional coverages that are composite products. */
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The uuid that establishes the relationship to the policy_contract. */
  policyContractId?: InputMaybe<Scalars['uuid']>;
  /** The uuid that establishes the relationship to a public.product. */
  productId?: InputMaybe<Scalars['uuid']>;
  /** Contains the snapshot of the product at time of purchase. Same as policy_contract.product_metadata. Its deductibleType key holds the legacy rating-engine integer for the deductible type (1 Flat Amount, 2 Disappearing), the same value MBP sends on to the AS400 as DeductibleTypeID. Resolve it to a row in the DeductibleType type group by matching that row metadata legacyDeductibleTypeId key; the types are identified by uuid and carry no enum_value. Read this to label the deductible on a claim (apps/claims mechanical claim page). Do not re-derive the type from the DisappearingDeductible configuration item: that item is set independently on Products and Account Categories and only means Disappearing when both levels carry it. */
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The uuid that represents a relationship to a product option in a quote. This is not a foreign key to a record in a table, but may be useful for finding quote information. */
  productOptionId?: InputMaybe<Scalars['uuid']>;
  /** The timestamp with timezone representing the last time the record was updated. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "policyContractProduct" */
export type PolicyContractProduct_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractProduct_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractProduct_Stream_Cursor_Value_Input = {
  /** The timestamp with time zone representing when the record is created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The primary key of the policy_contract_product. */
  id?: InputMaybe<Scalars['uuid']>;
  /** If a product has optional coverages attached with it, then a snapshot of those would be stored here, but not optional coverages that are composite products. */
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The uuid that establishes the relationship to the policy_contract. */
  policyContractId?: InputMaybe<Scalars['uuid']>;
  /** The uuid that establishes the relationship to a public.product. */
  productId?: InputMaybe<Scalars['uuid']>;
  /** Contains the snapshot of the product at time of purchase. Same as policy_contract.product_metadata. Its deductibleType key holds the legacy rating-engine integer for the deductible type (1 Flat Amount, 2 Disappearing), the same value MBP sends on to the AS400 as DeductibleTypeID. Resolve it to a row in the DeductibleType type group by matching that row metadata legacyDeductibleTypeId key; the types are identified by uuid and carry no enum_value. Read this to label the deductible on a claim (apps/claims mechanical claim page). Do not re-derive the type from the DisappearingDeductible configuration item: that item is set independently on Products and Account Categories and only means Disappearing when both levels carry it. */
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  /** The uuid that represents a relationship to a product option in a quote. This is not a foreign key to a record in a table, but may be useful for finding quote information. */
  productOptionId?: InputMaybe<Scalars['uuid']>;
  /** The timestamp with timezone representing the last time the record was updated. */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "operations.policy_contract_product" */
export enum PolicyContractProduct_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OptionalCoverageMetadata = 'optionalCoverageMetadata',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  ProductMetadata = 'productMetadata',
  /** column name */
  ProductOptionId = 'productOptionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyContractProduct_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyContractProduct_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyContractProduct_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyContractProduct_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyContractProduct_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicyContractProduct_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractProduct_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractProduct_Bool_Exp;
};

/** This table is used to snapshot quotes, allowing us to more easily dispose of data in the quote table. */
export type PolicyContractQuote = {
  __typename?: 'policyContractQuote';
  /** Leave args blank to get availableCoverages, otherwise provide a property name to get options (ex. coverageMonths, coverageMiles, etc.) */
  availableCoverageOptions?: Maybe<Scalars['jsonb']>;
  /** This column is a copy of the cancel quotes "result_metadata" from the quote table. */
  cancelResultMetadata?: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  legacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** This is used to store the request for both rate quotes and cancel quotes. */
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  /** This field relates to policy contract or legacy policy contract. */
  policyContractId: Scalars['uuid'];
  /** An array relationship */
  policyContractProductOptionsMetadataView: Array<PolicyContractProductOptionsMetadataView>;
  /** An aggregate relationship */
  policyContractProductOptionsMetadataView_aggregate: PolicyContractProductOptionsMetadataView_Aggregate;
  /** This field stores rate quote data, specifically product options generated during rating. */
  productOptionsMetadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  quote?: Maybe<Quote>;
  quoteDate: Scalars['timestamptz'];
  quoteId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  quoteType?: Maybe<QuoteType>;
  quoteTypeId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** This table is used to snapshot quotes, allowing us to more easily dispose of data in the quote table. */
export type PolicyContractQuoteAvailableCoverageOptionsArgs = {
  args?: InputMaybe<AvailableCoverageOptions_PolicyContractQuote_Args>;
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to snapshot quotes, allowing us to more easily dispose of data in the quote table. */
export type PolicyContractQuoteCancelResultMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to snapshot quotes, allowing us to more easily dispose of data in the quote table. */
export type PolicyContractQuoteMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table is used to snapshot quotes, allowing us to more easily dispose of data in the quote table. */
export type PolicyContractQuotePolicyContractProductOptionsMetadataViewArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Order_By>>;
  where?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
};


/** This table is used to snapshot quotes, allowing us to more easily dispose of data in the quote table. */
export type PolicyContractQuotePolicyContractProductOptionsMetadataView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Order_By>>;
  where?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
};


/** This table is used to snapshot quotes, allowing us to more easily dispose of data in the quote table. */
export type PolicyContractQuoteProductOptionsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "operations.policy_contract_quote" */
export type PolicyContractQuote_Aggregate = {
  __typename?: 'policyContractQuote_aggregate';
  aggregate?: Maybe<PolicyContractQuote_Aggregate_Fields>;
  nodes: Array<PolicyContractQuote>;
};

export type PolicyContractQuote_Aggregate_Bool_Exp = {
  count?: InputMaybe<PolicyContractQuote_Aggregate_Bool_Exp_Count>;
};

export type PolicyContractQuote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PolicyContractQuote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContractQuote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.policy_contract_quote" */
export type PolicyContractQuote_Aggregate_Fields = {
  __typename?: 'policyContractQuote_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PolicyContractQuote_Max_Fields>;
  min?: Maybe<PolicyContractQuote_Min_Fields>;
};


/** aggregate fields of "operations.policy_contract_quote" */
export type PolicyContractQuote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractQuote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.policy_contract_quote" */
export type PolicyContractQuote_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PolicyContractQuote_Max_Order_By>;
  min?: InputMaybe<PolicyContractQuote_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyContractQuote_Append_Input = {
  /** This column is a copy of the cancel quotes "result_metadata" from the quote table. */
  cancelResultMetadata?: InputMaybe<Scalars['jsonb']>;
  /** This is used to store the request for both rate quotes and cancel quotes. */
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** This field stores rate quote data, specifically product options generated during rating. */
  productOptionsMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "operations.policy_contract_quote" */
export type PolicyContractQuote_Arr_Rel_Insert_Input = {
  data: Array<PolicyContractQuote_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractQuote_On_Conflict>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_quote". All fields are combined with a logical 'AND'. */
export type PolicyContractQuote_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractQuote_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractQuote_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractQuote_Bool_Exp>>;
  cancelResultMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContractProductOptionsMetadataView?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
  policyContractProductOptionsMetadataView_aggregate?: InputMaybe<PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp>;
  productOptionsMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quote?: InputMaybe<Quote_Bool_Exp>;
  quoteDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  quoteId?: InputMaybe<Uuid_Comparison_Exp>;
  quoteType?: InputMaybe<QuoteType_Bool_Exp>;
  quoteTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_quote" */
export enum PolicyContractQuote_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractQuotePkey = 'policy_contract_quote_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyContractQuote_Delete_At_Path_Input = {
  /** This column is a copy of the cancel quotes "result_metadata" from the quote table. */
  cancelResultMetadata?: InputMaybe<Array<Scalars['String']>>;
  /** This is used to store the request for both rate quotes and cancel quotes. */
  metadata?: InputMaybe<Array<Scalars['String']>>;
  /** This field stores rate quote data, specifically product options generated during rating. */
  productOptionsMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyContractQuote_Delete_Elem_Input = {
  /** This column is a copy of the cancel quotes "result_metadata" from the quote table. */
  cancelResultMetadata?: InputMaybe<Scalars['Int']>;
  /** This is used to store the request for both rate quotes and cancel quotes. */
  metadata?: InputMaybe<Scalars['Int']>;
  /** This field stores rate quote data, specifically product options generated during rating. */
  productOptionsMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyContractQuote_Delete_Key_Input = {
  /** This column is a copy of the cancel quotes "result_metadata" from the quote table. */
  cancelResultMetadata?: InputMaybe<Scalars['String']>;
  /** This is used to store the request for both rate quotes and cancel quotes. */
  metadata?: InputMaybe<Scalars['String']>;
  /** This field stores rate quote data, specifically product options generated during rating. */
  productOptionsMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "operations.policy_contract_quote" */
export type PolicyContractQuote_Insert_Input = {
  /** This column is a copy of the cancel quotes "result_metadata" from the quote table. */
  cancelResultMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Obj_Rel_Insert_Input>;
  /** This is used to store the request for both rate quotes and cancel quotes. */
  metadata?: InputMaybe<Scalars['jsonb']>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  /** This field relates to policy contract or legacy policy contract. */
  policyContractId?: InputMaybe<Scalars['uuid']>;
  policyContractProductOptionsMetadataView?: InputMaybe<PolicyContractProductOptionsMetadataView_Arr_Rel_Insert_Input>;
  /** This field stores rate quote data, specifically product options generated during rating. */
  productOptionsMetadata?: InputMaybe<Scalars['jsonb']>;
  quote?: InputMaybe<Quote_Obj_Rel_Insert_Input>;
  quoteDate?: InputMaybe<Scalars['timestamptz']>;
  quoteId?: InputMaybe<Scalars['uuid']>;
  quoteType?: InputMaybe<QuoteType_Obj_Rel_Insert_Input>;
  quoteTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyContractQuote_Max_Fields = {
  __typename?: 'policyContractQuote_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** This field relates to policy contract or legacy policy contract. */
  policyContractId?: Maybe<Scalars['uuid']>;
  quoteDate?: Maybe<Scalars['timestamptz']>;
  quoteId?: Maybe<Scalars['uuid']>;
  quoteTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.policy_contract_quote" */
export type PolicyContractQuote_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** This field relates to policy contract or legacy policy contract. */
  policyContractId?: InputMaybe<Order_By>;
  quoteDate?: InputMaybe<Order_By>;
  quoteId?: InputMaybe<Order_By>;
  quoteTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PolicyContractQuote_Min_Fields = {
  __typename?: 'policyContractQuote_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** This field relates to policy contract or legacy policy contract. */
  policyContractId?: Maybe<Scalars['uuid']>;
  quoteDate?: Maybe<Scalars['timestamptz']>;
  quoteId?: Maybe<Scalars['uuid']>;
  quoteTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.policy_contract_quote" */
export type PolicyContractQuote_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** This field relates to policy contract or legacy policy contract. */
  policyContractId?: InputMaybe<Order_By>;
  quoteDate?: InputMaybe<Order_By>;
  quoteId?: InputMaybe<Order_By>;
  quoteTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.policy_contract_quote" */
export type PolicyContractQuote_Mutation_Response = {
  __typename?: 'policyContractQuote_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractQuote>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_quote" */
export type PolicyContractQuote_Obj_Rel_Insert_Input = {
  data: PolicyContractQuote_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractQuote_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract_quote" */
export type PolicyContractQuote_On_Conflict = {
  constraint: PolicyContractQuote_Constraint;
  update_columns?: Array<PolicyContractQuote_Update_Column>;
  where?: InputMaybe<PolicyContractQuote_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_quote". */
export type PolicyContractQuote_Order_By = {
  cancelResultMetadata?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Order_By>;
  metadata?: InputMaybe<Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  policyContractProductOptionsMetadataView_aggregate?: InputMaybe<PolicyContractProductOptionsMetadataView_Aggregate_Order_By>;
  productOptionsMetadata?: InputMaybe<Order_By>;
  quote?: InputMaybe<Quote_Order_By>;
  quoteDate?: InputMaybe<Order_By>;
  quoteId?: InputMaybe<Order_By>;
  quoteType?: InputMaybe<QuoteType_Order_By>;
  quoteTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.policy_contract_quote */
export type PolicyContractQuote_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicyContractQuote_Prepend_Input = {
  /** This column is a copy of the cancel quotes "result_metadata" from the quote table. */
  cancelResultMetadata?: InputMaybe<Scalars['jsonb']>;
  /** This is used to store the request for both rate quotes and cancel quotes. */
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** This field stores rate quote data, specifically product options generated during rating. */
  productOptionsMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "operations.policy_contract_quote" */
export enum PolicyContractQuote_Select_Column {
  /** column name */
  CancelResultMetadata = 'cancelResultMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  ProductOptionsMetadata = 'productOptionsMetadata',
  /** column name */
  QuoteDate = 'quoteDate',
  /** column name */
  QuoteId = 'quoteId',
  /** column name */
  QuoteTypeId = 'quoteTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.policy_contract_quote" */
export type PolicyContractQuote_Set_Input = {
  /** This column is a copy of the cancel quotes "result_metadata" from the quote table. */
  cancelResultMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** This is used to store the request for both rate quotes and cancel quotes. */
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** This field relates to policy contract or legacy policy contract. */
  policyContractId?: InputMaybe<Scalars['uuid']>;
  /** This field stores rate quote data, specifically product options generated during rating. */
  productOptionsMetadata?: InputMaybe<Scalars['jsonb']>;
  quoteDate?: InputMaybe<Scalars['timestamptz']>;
  quoteId?: InputMaybe<Scalars['uuid']>;
  quoteTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "policyContractQuote" */
export type PolicyContractQuote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractQuote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractQuote_Stream_Cursor_Value_Input = {
  /** This column is a copy of the cancel quotes "result_metadata" from the quote table. */
  cancelResultMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** This is used to store the request for both rate quotes and cancel quotes. */
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** This field relates to policy contract or legacy policy contract. */
  policyContractId?: InputMaybe<Scalars['uuid']>;
  /** This field stores rate quote data, specifically product options generated during rating. */
  productOptionsMetadata?: InputMaybe<Scalars['jsonb']>;
  quoteDate?: InputMaybe<Scalars['timestamptz']>;
  quoteId?: InputMaybe<Scalars['uuid']>;
  quoteTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "operations.policy_contract_quote" */
export enum PolicyContractQuote_Update_Column {
  /** column name */
  CancelResultMetadata = 'cancelResultMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  ProductOptionsMetadata = 'productOptionsMetadata',
  /** column name */
  QuoteDate = 'quoteDate',
  /** column name */
  QuoteId = 'quoteId',
  /** column name */
  QuoteTypeId = 'quoteTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyContractQuote_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyContractQuote_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyContractQuote_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyContractQuote_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyContractQuote_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicyContractQuote_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractQuote_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractQuote_Bool_Exp;
};

/** columns and relationships of "operations.policy_contract_status_type" */
export type PolicyContractStatusType = {
  __typename?: 'policyContractStatusType';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  policyContracts: Array<PolicyContract>;
  /** An aggregate relationship */
  policyContracts_aggregate: PolicyContract_Aggregate;
};


/** columns and relationships of "operations.policy_contract_status_type" */
export type PolicyContractStatusTypePolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract_status_type" */
export type PolicyContractStatusTypePolicyContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};

/** aggregated selection of "operations.policy_contract_status_type" */
export type PolicyContractStatusType_Aggregate = {
  __typename?: 'policyContractStatusType_aggregate';
  aggregate?: Maybe<PolicyContractStatusType_Aggregate_Fields>;
  nodes: Array<PolicyContractStatusType>;
};

/** aggregate fields of "operations.policy_contract_status_type" */
export type PolicyContractStatusType_Aggregate_Fields = {
  __typename?: 'policyContractStatusType_aggregate_fields';
  avg?: Maybe<PolicyContractStatusType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContractStatusType_Max_Fields>;
  min?: Maybe<PolicyContractStatusType_Min_Fields>;
  stddev?: Maybe<PolicyContractStatusType_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContractStatusType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContractStatusType_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContractStatusType_Sum_Fields>;
  var_pop?: Maybe<PolicyContractStatusType_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContractStatusType_Var_Samp_Fields>;
  variance?: Maybe<PolicyContractStatusType_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract_status_type" */
export type PolicyContractStatusType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractStatusType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PolicyContractStatusType_Avg_Fields = {
  __typename?: 'policyContractStatusType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_status_type". All fields are combined with a logical 'AND'. */
export type PolicyContractStatusType_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractStatusType_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractStatusType_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractStatusType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  policyContracts?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_status_type" */
export enum PolicyContractStatusType_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractStatusTypePkey = 'policy_contract_status_type_pkey'
}

/** input type for incrementing numeric columns in table "operations.policy_contract_status_type" */
export type PolicyContractStatusType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.policy_contract_status_type" */
export type PolicyContractStatusType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  policyContracts?: InputMaybe<PolicyContract_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type PolicyContractStatusType_Max_Fields = {
  __typename?: 'policyContractStatusType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PolicyContractStatusType_Min_Fields = {
  __typename?: 'policyContractStatusType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "operations.policy_contract_status_type" */
export type PolicyContractStatusType_Mutation_Response = {
  __typename?: 'policyContractStatusType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractStatusType>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_status_type" */
export type PolicyContractStatusType_Obj_Rel_Insert_Input = {
  data: PolicyContractStatusType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractStatusType_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract_status_type" */
export type PolicyContractStatusType_On_Conflict = {
  constraint: PolicyContractStatusType_Constraint;
  update_columns?: Array<PolicyContractStatusType_Update_Column>;
  where?: InputMaybe<PolicyContractStatusType_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_status_type". */
export type PolicyContractStatusType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Order_By>;
};

/** primary key columns input for table: operations.policy_contract_status_type */
export type PolicyContractStatusType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.policy_contract_status_type" */
export enum PolicyContractStatusType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "operations.policy_contract_status_type" */
export type PolicyContractStatusType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type PolicyContractStatusType_Stddev_Fields = {
  __typename?: 'policyContractStatusType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PolicyContractStatusType_Stddev_Pop_Fields = {
  __typename?: 'policyContractStatusType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PolicyContractStatusType_Stddev_Samp_Fields = {
  __typename?: 'policyContractStatusType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policyContractStatusType" */
export type PolicyContractStatusType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractStatusType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractStatusType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PolicyContractStatusType_Sum_Fields = {
  __typename?: 'policyContractStatusType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "operations.policy_contract_status_type" */
export enum PolicyContractStatusType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type PolicyContractStatusType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyContractStatusType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractStatusType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractStatusType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyContractStatusType_Var_Pop_Fields = {
  __typename?: 'policyContractStatusType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PolicyContractStatusType_Var_Samp_Fields = {
  __typename?: 'policyContractStatusType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PolicyContractStatusType_Variance_Fields = {
  __typename?: 'policyContractStatusType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonType = {
  __typename?: 'policyContractVoidReasonType';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  policyContracts: Array<PolicyContract>;
  /** An aggregate relationship */
  policyContracts_aggregate: PolicyContract_Aggregate;
};


/** columns and relationships of "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonTypePolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


/** columns and relationships of "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonTypePolicyContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};

/** aggregated selection of "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonType_Aggregate = {
  __typename?: 'policyContractVoidReasonType_aggregate';
  aggregate?: Maybe<PolicyContractVoidReasonType_Aggregate_Fields>;
  nodes: Array<PolicyContractVoidReasonType>;
};

/** aggregate fields of "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonType_Aggregate_Fields = {
  __typename?: 'policyContractVoidReasonType_aggregate_fields';
  avg?: Maybe<PolicyContractVoidReasonType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContractVoidReasonType_Max_Fields>;
  min?: Maybe<PolicyContractVoidReasonType_Min_Fields>;
  stddev?: Maybe<PolicyContractVoidReasonType_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContractVoidReasonType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContractVoidReasonType_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContractVoidReasonType_Sum_Fields>;
  var_pop?: Maybe<PolicyContractVoidReasonType_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContractVoidReasonType_Var_Samp_Fields>;
  variance?: Maybe<PolicyContractVoidReasonType_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContractVoidReasonType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PolicyContractVoidReasonType_Avg_Fields = {
  __typename?: 'policyContractVoidReasonType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract_void_reason_type". All fields are combined with a logical 'AND'. */
export type PolicyContractVoidReasonType_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContractVoidReasonType_Bool_Exp>>;
  _not?: InputMaybe<PolicyContractVoidReasonType_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContractVoidReasonType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  policyContracts?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract_void_reason_type" */
export enum PolicyContractVoidReasonType_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractVoidReasonTypePkey = 'policy_contract_void_reason_type_pkey'
}

/** input type for incrementing numeric columns in table "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  policyContracts?: InputMaybe<PolicyContract_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type PolicyContractVoidReasonType_Max_Fields = {
  __typename?: 'policyContractVoidReasonType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PolicyContractVoidReasonType_Min_Fields = {
  __typename?: 'policyContractVoidReasonType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonType_Mutation_Response = {
  __typename?: 'policyContractVoidReasonType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContractVoidReasonType>;
};

/** input type for inserting object relation for remote table "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonType_Obj_Rel_Insert_Input = {
  data: PolicyContractVoidReasonType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContractVoidReasonType_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonType_On_Conflict = {
  constraint: PolicyContractVoidReasonType_Constraint;
  update_columns?: Array<PolicyContractVoidReasonType_Update_Column>;
  where?: InputMaybe<PolicyContractVoidReasonType_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract_void_reason_type". */
export type PolicyContractVoidReasonType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Order_By>;
};

/** primary key columns input for table: operations.policy_contract_void_reason_type */
export type PolicyContractVoidReasonType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.policy_contract_void_reason_type" */
export enum PolicyContractVoidReasonType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "operations.policy_contract_void_reason_type" */
export type PolicyContractVoidReasonType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type PolicyContractVoidReasonType_Stddev_Fields = {
  __typename?: 'policyContractVoidReasonType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PolicyContractVoidReasonType_Stddev_Pop_Fields = {
  __typename?: 'policyContractVoidReasonType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PolicyContractVoidReasonType_Stddev_Samp_Fields = {
  __typename?: 'policyContractVoidReasonType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policyContractVoidReasonType" */
export type PolicyContractVoidReasonType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContractVoidReasonType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContractVoidReasonType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PolicyContractVoidReasonType_Sum_Fields = {
  __typename?: 'policyContractVoidReasonType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "operations.policy_contract_void_reason_type" */
export enum PolicyContractVoidReasonType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type PolicyContractVoidReasonType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyContractVoidReasonType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContractVoidReasonType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContractVoidReasonType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyContractVoidReasonType_Var_Pop_Fields = {
  __typename?: 'policyContractVoidReasonType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PolicyContractVoidReasonType_Var_Samp_Fields = {
  __typename?: 'policyContractVoidReasonType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PolicyContractVoidReasonType_Variance_Fields = {
  __typename?: 'policyContractVoidReasonType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "operations.policy_contract" */
export type PolicyContract_Aggregate = {
  __typename?: 'policyContract_aggregate';
  aggregate?: Maybe<PolicyContract_Aggregate_Fields>;
  nodes: Array<PolicyContract>;
};

export type PolicyContract_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<PolicyContract_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<PolicyContract_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<PolicyContract_Aggregate_Bool_Exp_Count>;
};

export type PolicyContract_Aggregate_Bool_Exp_Bool_And = {
  arguments: PolicyContract_Select_Column_PolicyContract_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContract_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PolicyContract_Aggregate_Bool_Exp_Bool_Or = {
  arguments: PolicyContract_Select_Column_PolicyContract_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContract_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PolicyContract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PolicyContract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PolicyContract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.policy_contract" */
export type PolicyContract_Aggregate_Fields = {
  __typename?: 'policyContract_aggregate_fields';
  avg?: Maybe<PolicyContract_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyContract_Max_Fields>;
  min?: Maybe<PolicyContract_Min_Fields>;
  stddev?: Maybe<PolicyContract_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyContract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyContract_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyContract_Sum_Fields>;
  var_pop?: Maybe<PolicyContract_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyContract_Var_Samp_Fields>;
  variance?: Maybe<PolicyContract_Variance_Fields>;
};


/** aggregate fields of "operations.policy_contract" */
export type PolicyContract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyContract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.policy_contract" */
export type PolicyContract_Aggregate_Order_By = {
  avg?: InputMaybe<PolicyContract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PolicyContract_Max_Order_By>;
  min?: InputMaybe<PolicyContract_Min_Order_By>;
  stddev?: InputMaybe<PolicyContract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PolicyContract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PolicyContract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PolicyContract_Sum_Order_By>;
  var_pop?: InputMaybe<PolicyContract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PolicyContract_Var_Samp_Order_By>;
  variance?: InputMaybe<PolicyContract_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyContract_Append_Input = {
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  /** This column is for putting any additional data related to the contract. It can be used for a migration, conversion, or supporting specific business functionality. */
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** Obligor Metadata that is a snapshot of the obligor information at the time of purchase. */
  obligorMetadata?: InputMaybe<Scalars['jsonb']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  surchargeMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "operations.policy_contract" */
export type PolicyContract_Arr_Rel_Insert_Input = {
  data: Array<PolicyContract_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContract_On_Conflict>;
};

/** aggregate avg on columns */
export type PolicyContract_Avg_Fields = {
  __typename?: 'policyContract_avg_fields';
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations.policy_contract" */
export type PolicyContract_Avg_Order_By = {
  expirationMiles?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations.policy_contract". All fields are combined with a logical 'AND'. */
export type PolicyContract_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyContract_Bool_Exp>>;
  _not?: InputMaybe<PolicyContract_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyContract_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  as400AgreementNumber?: InputMaybe<String_Comparison_Exp>;
  as400PostedDate?: InputMaybe<Date_Comparison_Exp>;
  assetMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  canStartClaim?: InputMaybe<Boolean_Comparison_Exp>;
  cancelQuoteListView?: InputMaybe<CancelQuoteListView_Bool_Exp>;
  cancelQuoteListView_aggregate?: InputMaybe<CancelQuoteListView_Aggregate_Bool_Exp>;
  cancellation?: InputMaybe<Cancellation_Bool_Exp>;
  cancellationId?: InputMaybe<Uuid_Comparison_Exp>;
  cancellations?: InputMaybe<Cancellation_Bool_Exp>;
  cancellations_aggregate?: InputMaybe<Cancellation_Aggregate_Bool_Exp>;
  claimParts?: InputMaybe<ClaimPart_Bool_Exp>;
  claimParts_aggregate?: InputMaybe<ClaimPart_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  documentInstances?: InputMaybe<DocumentInstance_Bool_Exp>;
  documentInstances_aggregate?: InputMaybe<DocumentInstance_Aggregate_Bool_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Bool_Exp>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Bool_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  existsInAs400?: InputMaybe<Boolean_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  expirationMiles?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isTestContract?: InputMaybe<Boolean_Comparison_Exp>;
  journalEntries?: InputMaybe<JournalEntry_Bool_Exp>;
  journalEntries_aggregate?: InputMaybe<JournalEntry_Aggregate_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  obligor?: InputMaybe<Obligor_Bool_Exp>;
  obligorId?: InputMaybe<Uuid_Comparison_Exp>;
  obligorMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  optionalCoverageMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  policy?: InputMaybe<Policy_Bool_Exp>;
  policyClaims?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaims_aggregate?: InputMaybe<PolicyClaim_Aggregate_Bool_Exp>;
  policyContractAsset?: InputMaybe<PolicyContractAsset_Bool_Exp>;
  policyContractAssetId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContractContractFormVersions?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
  policyContractContractFormVersions_aggregate?: InputMaybe<PolicyContractContractFormVersion_Aggregate_Bool_Exp>;
  policyContractCostDetail?: InputMaybe<PolicyContractCostDetail_Bool_Exp>;
  policyContractLender?: InputMaybe<PolicyContractLender_Bool_Exp>;
  policyContractNumber?: InputMaybe<String_Comparison_Exp>;
  policyContractOwners?: InputMaybe<PolicyContractOwner_Bool_Exp>;
  policyContractOwners_aggregate?: InputMaybe<PolicyContractOwner_Aggregate_Bool_Exp>;
  policyContractProductOptionsMetadataViews?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
  policyContractProductOptionsMetadataViews_aggregate?: InputMaybe<PolicyContractProductOptionsMetadataView_Aggregate_Bool_Exp>;
  policyContractProducts?: InputMaybe<PolicyContractProduct_Bool_Exp>;
  policyContractProducts_aggregate?: InputMaybe<PolicyContractProduct_Aggregate_Bool_Exp>;
  policyContractQuote?: InputMaybe<PolicyContractQuote_Bool_Exp>;
  policyContractQuote_aggregate?: InputMaybe<PolicyContractQuote_Aggregate_Bool_Exp>;
  policyContractStatusType?: InputMaybe<PolicyContractStatusType_Bool_Exp>;
  policyContractStatusTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContractVoidReasonType?: InputMaybe<PolicyContractVoidReasonType_Bool_Exp>;
  policyId?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  productMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  productOptionId?: InputMaybe<Uuid_Comparison_Exp>;
  purchaseDate?: InputMaybe<Date_Comparison_Exp>;
  quote?: InputMaybe<Quote_Bool_Exp>;
  quoteId?: InputMaybe<Uuid_Comparison_Exp>;
  quoteMinimalView?: InputMaybe<QuoteMinimalView_Bool_Exp>;
  remittancePolicyContracts?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
  remittancePolicyContracts_aggregate?: InputMaybe<RemittancePolicyContract_Aggregate_Bool_Exp>;
  salesRepresentativeName?: InputMaybe<String_Comparison_Exp>;
  secondaryExpirationDate?: InputMaybe<Date_Comparison_Exp>;
  secondaryExpirationMiles?: InputMaybe<Int_Comparison_Exp>;
  statusReasonType?: InputMaybe<Type_Bool_Exp>;
  statusReasonTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  surchargeMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  updateUserId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.policy_contract" */
export enum PolicyContract_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyContractPkey = 'policy_contract_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyContract_Delete_At_Path_Input = {
  assetMetadata?: InputMaybe<Array<Scalars['String']>>;
  /** This column is for putting any additional data related to the contract. It can be used for a migration, conversion, or supporting specific business functionality. */
  metadata?: InputMaybe<Array<Scalars['String']>>;
  /** Obligor Metadata that is a snapshot of the obligor information at the time of purchase. */
  obligorMetadata?: InputMaybe<Array<Scalars['String']>>;
  optionalCoverageMetadata?: InputMaybe<Array<Scalars['String']>>;
  productMetadata?: InputMaybe<Array<Scalars['String']>>;
  surchargeMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyContract_Delete_Elem_Input = {
  assetMetadata?: InputMaybe<Scalars['Int']>;
  /** This column is for putting any additional data related to the contract. It can be used for a migration, conversion, or supporting specific business functionality. */
  metadata?: InputMaybe<Scalars['Int']>;
  /** Obligor Metadata that is a snapshot of the obligor information at the time of purchase. */
  obligorMetadata?: InputMaybe<Scalars['Int']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['Int']>;
  productMetadata?: InputMaybe<Scalars['Int']>;
  surchargeMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyContract_Delete_Key_Input = {
  assetMetadata?: InputMaybe<Scalars['String']>;
  /** This column is for putting any additional data related to the contract. It can be used for a migration, conversion, or supporting specific business functionality. */
  metadata?: InputMaybe<Scalars['String']>;
  /** Obligor Metadata that is a snapshot of the obligor information at the time of purchase. */
  obligorMetadata?: InputMaybe<Scalars['String']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['String']>;
  productMetadata?: InputMaybe<Scalars['String']>;
  surchargeMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "operations.policy_contract" */
export type PolicyContract_Inc_Input = {
  expirationMiles?: InputMaybe<Scalars['Int']>;
  secondaryExpirationMiles?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "operations.policy_contract" */
export type PolicyContract_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['uuid']>;
  as400AgreementNumber?: InputMaybe<Scalars['String']>;
  as400PostedDate?: InputMaybe<Scalars['date']>;
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  cancelQuoteListView?: InputMaybe<CancelQuoteListView_Arr_Rel_Insert_Input>;
  cancellation?: InputMaybe<Cancellation_Obj_Rel_Insert_Input>;
  /** This ties the policy contract to the active cancellation. */
  cancellationId?: InputMaybe<Scalars['uuid']>;
  cancellations?: InputMaybe<Cancellation_Arr_Rel_Insert_Input>;
  claimParts?: InputMaybe<ClaimPart_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentInstances?: InputMaybe<DocumentInstance_Arr_Rel_Insert_Input>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityFileStorages?: InputMaybe<EntityFileStorage_Arr_Rel_Insert_Input>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  /** The As400.ContractMasterImport stored procedure will update this value when it is syncing the purchased contract to the as400. Once this is true, the contract is no longer editable. */
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  expirationMiles?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isTestContract?: InputMaybe<Scalars['Boolean']>;
  journalEntries?: InputMaybe<JournalEntry_Arr_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  /** This column is for putting any additional data related to the contract. It can be used for a migration, conversion, or supporting specific business functionality. */
  metadata?: InputMaybe<Scalars['jsonb']>;
  obligor?: InputMaybe<Obligor_Obj_Rel_Insert_Input>;
  /** This obligor reference is for the carrier code, not to be confused with the obligor that is the actual obligor of the contract. */
  obligorId?: InputMaybe<Scalars['uuid']>;
  /** Obligor Metadata that is a snapshot of the obligor information at the time of purchase. */
  obligorMetadata?: InputMaybe<Scalars['jsonb']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  policy?: InputMaybe<Policy_Obj_Rel_Insert_Input>;
  policyClaims?: InputMaybe<PolicyClaim_Arr_Rel_Insert_Input>;
  policyContractAsset?: InputMaybe<PolicyContractAsset_Obj_Rel_Insert_Input>;
  policyContractAssetId?: InputMaybe<Scalars['uuid']>;
  policyContractContractFormVersions?: InputMaybe<PolicyContractContractFormVersion_Arr_Rel_Insert_Input>;
  policyContractCostDetail?: InputMaybe<PolicyContractCostDetail_Obj_Rel_Insert_Input>;
  policyContractLender?: InputMaybe<PolicyContractLender_Obj_Rel_Insert_Input>;
  policyContractNumber?: InputMaybe<Scalars['String']>;
  policyContractOwners?: InputMaybe<PolicyContractOwner_Arr_Rel_Insert_Input>;
  policyContractProductOptionsMetadataViews?: InputMaybe<PolicyContractProductOptionsMetadataView_Arr_Rel_Insert_Input>;
  policyContractProducts?: InputMaybe<PolicyContractProduct_Arr_Rel_Insert_Input>;
  policyContractQuote?: InputMaybe<PolicyContractQuote_Arr_Rel_Insert_Input>;
  policyContractStatusType?: InputMaybe<PolicyContractStatusType_Obj_Rel_Insert_Input>;
  policyContractStatusTypeId?: InputMaybe<Scalars['uuid']>;
  policyContractVoidReasonType?: InputMaybe<PolicyContractVoidReasonType_Obj_Rel_Insert_Input>;
  policyId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  productOptionId?: InputMaybe<Scalars['uuid']>;
  purchaseDate?: InputMaybe<Scalars['date']>;
  quote?: InputMaybe<Quote_Obj_Rel_Insert_Input>;
  /** Deprecated */
  quoteId?: InputMaybe<Scalars['uuid']>;
  quoteMinimalView?: InputMaybe<QuoteMinimalView_Obj_Rel_Insert_Input>;
  remittancePolicyContracts?: InputMaybe<RemittancePolicyContract_Arr_Rel_Insert_Input>;
  salesRepresentativeName?: InputMaybe<Scalars['String']>;
  secondaryExpirationDate?: InputMaybe<Scalars['date']>;
  secondaryExpirationMiles?: InputMaybe<Scalars['Int']>;
  statusReasonType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  statusReasonTypeId?: InputMaybe<Scalars['uuid']>;
  surchargeMetadata?: InputMaybe<Scalars['jsonb']>;
  updateUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PolicyContract_Max_Fields = {
  __typename?: 'policyContract_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  as400AgreementNumber?: Maybe<Scalars['String']>;
  as400PostedDate?: Maybe<Scalars['date']>;
  /** This ties the policy contract to the active cancellation. */
  cancellationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  expirationMiles?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** This obligor reference is for the carrier code, not to be confused with the obligor that is the actual obligor of the contract. */
  obligorId?: Maybe<Scalars['uuid']>;
  policyContractAssetId?: Maybe<Scalars['uuid']>;
  policyContractNumber?: Maybe<Scalars['String']>;
  policyContractStatusTypeId?: Maybe<Scalars['uuid']>;
  policyId?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  productOptionId?: Maybe<Scalars['uuid']>;
  purchaseDate?: Maybe<Scalars['date']>;
  /** Deprecated */
  quoteId?: Maybe<Scalars['uuid']>;
  salesRepresentativeName?: Maybe<Scalars['String']>;
  secondaryExpirationDate?: Maybe<Scalars['date']>;
  secondaryExpirationMiles?: Maybe<Scalars['Int']>;
  statusReasonTypeId?: Maybe<Scalars['uuid']>;
  updateUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.policy_contract" */
export type PolicyContract_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  as400AgreementNumber?: InputMaybe<Order_By>;
  as400PostedDate?: InputMaybe<Order_By>;
  /** This ties the policy contract to the active cancellation. */
  cancellationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** This obligor reference is for the carrier code, not to be confused with the obligor that is the actual obligor of the contract. */
  obligorId?: InputMaybe<Order_By>;
  policyContractAssetId?: InputMaybe<Order_By>;
  policyContractNumber?: InputMaybe<Order_By>;
  policyContractStatusTypeId?: InputMaybe<Order_By>;
  policyId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  productOptionId?: InputMaybe<Order_By>;
  purchaseDate?: InputMaybe<Order_By>;
  /** Deprecated */
  quoteId?: InputMaybe<Order_By>;
  salesRepresentativeName?: InputMaybe<Order_By>;
  secondaryExpirationDate?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
  statusReasonTypeId?: InputMaybe<Order_By>;
  updateUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PolicyContract_Min_Fields = {
  __typename?: 'policyContract_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  as400AgreementNumber?: Maybe<Scalars['String']>;
  as400PostedDate?: Maybe<Scalars['date']>;
  /** This ties the policy contract to the active cancellation. */
  cancellationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  expirationMiles?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  /** This obligor reference is for the carrier code, not to be confused with the obligor that is the actual obligor of the contract. */
  obligorId?: Maybe<Scalars['uuid']>;
  policyContractAssetId?: Maybe<Scalars['uuid']>;
  policyContractNumber?: Maybe<Scalars['String']>;
  policyContractStatusTypeId?: Maybe<Scalars['uuid']>;
  policyId?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  productOptionId?: Maybe<Scalars['uuid']>;
  purchaseDate?: Maybe<Scalars['date']>;
  /** Deprecated */
  quoteId?: Maybe<Scalars['uuid']>;
  salesRepresentativeName?: Maybe<Scalars['String']>;
  secondaryExpirationDate?: Maybe<Scalars['date']>;
  secondaryExpirationMiles?: Maybe<Scalars['Int']>;
  statusReasonTypeId?: Maybe<Scalars['uuid']>;
  updateUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.policy_contract" */
export type PolicyContract_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  as400AgreementNumber?: InputMaybe<Order_By>;
  as400PostedDate?: InputMaybe<Order_By>;
  /** This ties the policy contract to the active cancellation. */
  cancellationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** This obligor reference is for the carrier code, not to be confused with the obligor that is the actual obligor of the contract. */
  obligorId?: InputMaybe<Order_By>;
  policyContractAssetId?: InputMaybe<Order_By>;
  policyContractNumber?: InputMaybe<Order_By>;
  policyContractStatusTypeId?: InputMaybe<Order_By>;
  policyId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  productOptionId?: InputMaybe<Order_By>;
  purchaseDate?: InputMaybe<Order_By>;
  /** Deprecated */
  quoteId?: InputMaybe<Order_By>;
  salesRepresentativeName?: InputMaybe<Order_By>;
  secondaryExpirationDate?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
  statusReasonTypeId?: InputMaybe<Order_By>;
  updateUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.policy_contract" */
export type PolicyContract_Mutation_Response = {
  __typename?: 'policyContract_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyContract>;
};

/** input type for inserting object relation for remote table "operations.policy_contract" */
export type PolicyContract_Obj_Rel_Insert_Input = {
  data: PolicyContract_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PolicyContract_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy_contract" */
export type PolicyContract_On_Conflict = {
  constraint: PolicyContract_Constraint;
  update_columns?: Array<PolicyContract_Update_Column>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy_contract". */
export type PolicyContract_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountId?: InputMaybe<Order_By>;
  as400AgreementNumber?: InputMaybe<Order_By>;
  as400PostedDate?: InputMaybe<Order_By>;
  assetMetadata?: InputMaybe<Order_By>;
  canStartClaim?: InputMaybe<Order_By>;
  cancelQuoteListView_aggregate?: InputMaybe<CancelQuoteListView_Aggregate_Order_By>;
  cancellation?: InputMaybe<Cancellation_Order_By>;
  cancellationId?: InputMaybe<Order_By>;
  cancellations_aggregate?: InputMaybe<Cancellation_Aggregate_Order_By>;
  claimParts_aggregate?: InputMaybe<ClaimPart_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  documentInstances_aggregate?: InputMaybe<DocumentInstance_Aggregate_Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityFileStorages_aggregate?: InputMaybe<EntityFileStorage_Aggregate_Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  existsInAs400?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  expirationMiles?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isTestContract?: InputMaybe<Order_By>;
  journalEntries_aggregate?: InputMaybe<JournalEntry_Aggregate_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  obligor?: InputMaybe<Obligor_Order_By>;
  obligorId?: InputMaybe<Order_By>;
  obligorMetadata?: InputMaybe<Order_By>;
  optionalCoverageMetadata?: InputMaybe<Order_By>;
  policy?: InputMaybe<Policy_Order_By>;
  policyClaims_aggregate?: InputMaybe<PolicyClaim_Aggregate_Order_By>;
  policyContractAsset?: InputMaybe<PolicyContractAsset_Order_By>;
  policyContractAssetId?: InputMaybe<Order_By>;
  policyContractContractFormVersions_aggregate?: InputMaybe<PolicyContractContractFormVersion_Aggregate_Order_By>;
  policyContractCostDetail?: InputMaybe<PolicyContractCostDetail_Order_By>;
  policyContractLender?: InputMaybe<PolicyContractLender_Order_By>;
  policyContractNumber?: InputMaybe<Order_By>;
  policyContractOwners_aggregate?: InputMaybe<PolicyContractOwner_Aggregate_Order_By>;
  policyContractProductOptionsMetadataViews_aggregate?: InputMaybe<PolicyContractProductOptionsMetadataView_Aggregate_Order_By>;
  policyContractProducts_aggregate?: InputMaybe<PolicyContractProduct_Aggregate_Order_By>;
  policyContractQuote_aggregate?: InputMaybe<PolicyContractQuote_Aggregate_Order_By>;
  policyContractStatusType?: InputMaybe<PolicyContractStatusType_Order_By>;
  policyContractStatusTypeId?: InputMaybe<Order_By>;
  policyContractVoidReasonType?: InputMaybe<PolicyContractVoidReasonType_Order_By>;
  policyId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  productMetadata?: InputMaybe<Order_By>;
  productOptionId?: InputMaybe<Order_By>;
  purchaseDate?: InputMaybe<Order_By>;
  quote?: InputMaybe<Quote_Order_By>;
  quoteId?: InputMaybe<Order_By>;
  quoteMinimalView?: InputMaybe<QuoteMinimalView_Order_By>;
  remittancePolicyContracts_aggregate?: InputMaybe<RemittancePolicyContract_Aggregate_Order_By>;
  salesRepresentativeName?: InputMaybe<Order_By>;
  secondaryExpirationDate?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
  statusReasonType?: InputMaybe<Type_Order_By>;
  statusReasonTypeId?: InputMaybe<Order_By>;
  surchargeMetadata?: InputMaybe<Order_By>;
  updateUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.policy_contract */
export type PolicyContract_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicyContract_Prepend_Input = {
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  /** This column is for putting any additional data related to the contract. It can be used for a migration, conversion, or supporting specific business functionality. */
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** Obligor Metadata that is a snapshot of the obligor information at the time of purchase. */
  obligorMetadata?: InputMaybe<Scalars['jsonb']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  surchargeMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "operations.policy_contract" */
export enum PolicyContract_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  As400AgreementNumber = 'as400AgreementNumber',
  /** column name */
  As400PostedDate = 'as400PostedDate',
  /** column name */
  AssetMetadata = 'assetMetadata',
  /** column name */
  CancellationId = 'cancellationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  ExpirationMiles = 'expirationMiles',
  /** column name */
  Id = 'id',
  /** column name */
  IsTestContract = 'isTestContract',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ObligorId = 'obligorId',
  /** column name */
  ObligorMetadata = 'obligorMetadata',
  /** column name */
  OptionalCoverageMetadata = 'optionalCoverageMetadata',
  /** column name */
  PolicyContractAssetId = 'policyContractAssetId',
  /** column name */
  PolicyContractNumber = 'policyContractNumber',
  /** column name */
  PolicyContractStatusTypeId = 'policyContractStatusTypeId',
  /** column name */
  PolicyId = 'policyId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  ProductMetadata = 'productMetadata',
  /** column name */
  ProductOptionId = 'productOptionId',
  /** column name */
  PurchaseDate = 'purchaseDate',
  /** column name */
  QuoteId = 'quoteId',
  /** column name */
  SalesRepresentativeName = 'salesRepresentativeName',
  /** column name */
  SecondaryExpirationDate = 'secondaryExpirationDate',
  /** column name */
  SecondaryExpirationMiles = 'secondaryExpirationMiles',
  /** column name */
  StatusReasonTypeId = 'statusReasonTypeId',
  /** column name */
  SurchargeMetadata = 'surchargeMetadata',
  /** column name */
  UpdateUserId = 'updateUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "policyContract_aggregate_bool_exp_bool_and_arguments_columns" columns of table "operations.policy_contract" */
export enum PolicyContract_Select_Column_PolicyContract_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  IsTestContract = 'isTestContract'
}

/** select "policyContract_aggregate_bool_exp_bool_or_arguments_columns" columns of table "operations.policy_contract" */
export enum PolicyContract_Select_Column_PolicyContract_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  IsTestContract = 'isTestContract'
}

/** input type for updating data in table "operations.policy_contract" */
export type PolicyContract_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  as400AgreementNumber?: InputMaybe<Scalars['String']>;
  as400PostedDate?: InputMaybe<Scalars['date']>;
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  /** This ties the policy contract to the active cancellation. */
  cancellationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** The As400.ContractMasterImport stored procedure will update this value when it is syncing the purchased contract to the as400. Once this is true, the contract is no longer editable. */
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  expirationMiles?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isTestContract?: InputMaybe<Scalars['Boolean']>;
  /** This column is for putting any additional data related to the contract. It can be used for a migration, conversion, or supporting specific business functionality. */
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** This obligor reference is for the carrier code, not to be confused with the obligor that is the actual obligor of the contract. */
  obligorId?: InputMaybe<Scalars['uuid']>;
  /** Obligor Metadata that is a snapshot of the obligor information at the time of purchase. */
  obligorMetadata?: InputMaybe<Scalars['jsonb']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  policyContractAssetId?: InputMaybe<Scalars['uuid']>;
  policyContractNumber?: InputMaybe<Scalars['String']>;
  policyContractStatusTypeId?: InputMaybe<Scalars['uuid']>;
  policyId?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  productOptionId?: InputMaybe<Scalars['uuid']>;
  purchaseDate?: InputMaybe<Scalars['date']>;
  /** Deprecated */
  quoteId?: InputMaybe<Scalars['uuid']>;
  salesRepresentativeName?: InputMaybe<Scalars['String']>;
  secondaryExpirationDate?: InputMaybe<Scalars['date']>;
  secondaryExpirationMiles?: InputMaybe<Scalars['Int']>;
  statusReasonTypeId?: InputMaybe<Scalars['uuid']>;
  surchargeMetadata?: InputMaybe<Scalars['jsonb']>;
  updateUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PolicyContract_Stddev_Fields = {
  __typename?: 'policyContract_stddev_fields';
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations.policy_contract" */
export type PolicyContract_Stddev_Order_By = {
  expirationMiles?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PolicyContract_Stddev_Pop_Fields = {
  __typename?: 'policyContract_stddev_pop_fields';
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations.policy_contract" */
export type PolicyContract_Stddev_Pop_Order_By = {
  expirationMiles?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PolicyContract_Stddev_Samp_Fields = {
  __typename?: 'policyContract_stddev_samp_fields';
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations.policy_contract" */
export type PolicyContract_Stddev_Samp_Order_By = {
  expirationMiles?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "policyContract" */
export type PolicyContract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyContract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyContract_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  as400AgreementNumber?: InputMaybe<Scalars['String']>;
  as400PostedDate?: InputMaybe<Scalars['date']>;
  assetMetadata?: InputMaybe<Scalars['jsonb']>;
  /** This ties the policy contract to the active cancellation. */
  cancellationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** The As400.ContractMasterImport stored procedure will update this value when it is syncing the purchased contract to the as400. Once this is true, the contract is no longer editable. */
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  expirationMiles?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isTestContract?: InputMaybe<Scalars['Boolean']>;
  /** This column is for putting any additional data related to the contract. It can be used for a migration, conversion, or supporting specific business functionality. */
  metadata?: InputMaybe<Scalars['jsonb']>;
  /** This obligor reference is for the carrier code, not to be confused with the obligor that is the actual obligor of the contract. */
  obligorId?: InputMaybe<Scalars['uuid']>;
  /** Obligor Metadata that is a snapshot of the obligor information at the time of purchase. */
  obligorMetadata?: InputMaybe<Scalars['jsonb']>;
  optionalCoverageMetadata?: InputMaybe<Scalars['jsonb']>;
  policyContractAssetId?: InputMaybe<Scalars['uuid']>;
  policyContractNumber?: InputMaybe<Scalars['String']>;
  policyContractStatusTypeId?: InputMaybe<Scalars['uuid']>;
  policyId?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  productMetadata?: InputMaybe<Scalars['jsonb']>;
  productOptionId?: InputMaybe<Scalars['uuid']>;
  purchaseDate?: InputMaybe<Scalars['date']>;
  /** Deprecated */
  quoteId?: InputMaybe<Scalars['uuid']>;
  salesRepresentativeName?: InputMaybe<Scalars['String']>;
  secondaryExpirationDate?: InputMaybe<Scalars['date']>;
  secondaryExpirationMiles?: InputMaybe<Scalars['Int']>;
  statusReasonTypeId?: InputMaybe<Scalars['uuid']>;
  surchargeMetadata?: InputMaybe<Scalars['jsonb']>;
  updateUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PolicyContract_Sum_Fields = {
  __typename?: 'policyContract_sum_fields';
  expirationMiles?: Maybe<Scalars['Int']>;
  secondaryExpirationMiles?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "operations.policy_contract" */
export type PolicyContract_Sum_Order_By = {
  expirationMiles?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
};

/** update columns of table "operations.policy_contract" */
export enum PolicyContract_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  As400AgreementNumber = 'as400AgreementNumber',
  /** column name */
  As400PostedDate = 'as400PostedDate',
  /** column name */
  AssetMetadata = 'assetMetadata',
  /** column name */
  CancellationId = 'cancellationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  ExpirationMiles = 'expirationMiles',
  /** column name */
  Id = 'id',
  /** column name */
  IsTestContract = 'isTestContract',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ObligorId = 'obligorId',
  /** column name */
  ObligorMetadata = 'obligorMetadata',
  /** column name */
  OptionalCoverageMetadata = 'optionalCoverageMetadata',
  /** column name */
  PolicyContractAssetId = 'policyContractAssetId',
  /** column name */
  PolicyContractNumber = 'policyContractNumber',
  /** column name */
  PolicyContractStatusTypeId = 'policyContractStatusTypeId',
  /** column name */
  PolicyId = 'policyId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  ProductMetadata = 'productMetadata',
  /** column name */
  ProductOptionId = 'productOptionId',
  /** column name */
  PurchaseDate = 'purchaseDate',
  /** column name */
  QuoteId = 'quoteId',
  /** column name */
  SalesRepresentativeName = 'salesRepresentativeName',
  /** column name */
  SecondaryExpirationDate = 'secondaryExpirationDate',
  /** column name */
  SecondaryExpirationMiles = 'secondaryExpirationMiles',
  /** column name */
  StatusReasonTypeId = 'statusReasonTypeId',
  /** column name */
  SurchargeMetadata = 'surchargeMetadata',
  /** column name */
  UpdateUserId = 'updateUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyContract_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyContract_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyContract_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyContract_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyContract_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyContract_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicyContract_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyContract_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyContract_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyContract_Var_Pop_Fields = {
  __typename?: 'policyContract_var_pop_fields';
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations.policy_contract" */
export type PolicyContract_Var_Pop_Order_By = {
  expirationMiles?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PolicyContract_Var_Samp_Fields = {
  __typename?: 'policyContract_var_samp_fields';
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations.policy_contract" */
export type PolicyContract_Var_Samp_Order_By = {
  expirationMiles?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PolicyContract_Variance_Fields = {
  __typename?: 'policyContract_variance_fields';
  expirationMiles?: Maybe<Scalars['Float']>;
  secondaryExpirationMiles?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations.policy_contract" */
export type PolicyContract_Variance_Order_By = {
  expirationMiles?: InputMaybe<Order_By>;
  secondaryExpirationMiles?: InputMaybe<Order_By>;
};

/** aggregated selection of "operations.policy" */
export type Policy_Aggregate = {
  __typename?: 'policy_aggregate';
  aggregate?: Maybe<Policy_Aggregate_Fields>;
  nodes: Array<Policy>;
};

/** aggregate fields of "operations.policy" */
export type Policy_Aggregate_Fields = {
  __typename?: 'policy_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Policy_Max_Fields>;
  min?: Maybe<Policy_Min_Fields>;
};


/** aggregate fields of "operations.policy" */
export type Policy_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Policy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "operations.policy". All fields are combined with a logical 'AND'. */
export type Policy_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Bool_Exp>>;
  _not?: InputMaybe<Policy_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policyContracts?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Bool_Exp>;
  policyNumber?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.policy" */
export enum Policy_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyPkey = 'policy_pkey'
}

/** input type for inserting data into table "operations.policy" */
export type Policy_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyContracts?: InputMaybe<PolicyContract_Arr_Rel_Insert_Input>;
  policyNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Policy_Max_Fields = {
  __typename?: 'policy_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  policyNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Policy_Min_Fields = {
  __typename?: 'policy_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  policyNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "operations.policy" */
export type Policy_Mutation_Response = {
  __typename?: 'policy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy>;
};

/** input type for inserting object relation for remote table "operations.policy" */
export type Policy_Obj_Rel_Insert_Input = {
  data: Policy_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Policy_On_Conflict>;
};

/** on_conflict condition type for table "operations.policy" */
export type Policy_On_Conflict = {
  constraint: Policy_Constraint;
  update_columns?: Array<Policy_Update_Column>;
  where?: InputMaybe<Policy_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.policy". */
export type Policy_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Order_By>;
  policyNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.policy */
export type Policy_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.policy" */
export enum Policy_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyNumber = 'policyNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.policy" */
export type Policy_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "policy" */
export type Policy_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Policy_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Policy_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "operations.policy" */
export enum Policy_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PolicyNumber = 'policyNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Policy_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policy_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policy_Bool_Exp;
};

/** columns and relationships of "claims.pre_authorization" */
export type PreAuthorization = {
  __typename?: 'preAuthorization';
  as400ClaimNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  existsInAs400: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  legacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  metadata?: Maybe<Scalars['jsonb']>;
  number?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  /** An object relationship */
  preAuthorizationStatusType?: Maybe<PreAuthorizationStatusType>;
  preAuthorizationStatusTypeId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  preAuthorizationType?: Maybe<PreAuthorizationType>;
  preAuthorizationTypeId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "claims.pre_authorization" */
export type PreAuthorizationLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.pre_authorization" */
export type PreAuthorizationLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.pre_authorization" */
export type PreAuthorizationMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusType = {
  __typename?: 'preAuthorizationStatusType';
  display?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  preAuthorizations: Array<PreAuthorization>;
  /** An aggregate relationship */
  preAuthorizations_aggregate: PreAuthorization_Aggregate;
};


/** columns and relationships of "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusTypePreAuthorizationsArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorization_Order_By>>;
  where?: InputMaybe<PreAuthorization_Bool_Exp>;
};


/** columns and relationships of "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusTypePreAuthorizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorization_Order_By>>;
  where?: InputMaybe<PreAuthorization_Bool_Exp>;
};

/** aggregated selection of "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusType_Aggregate = {
  __typename?: 'preAuthorizationStatusType_aggregate';
  aggregate?: Maybe<PreAuthorizationStatusType_Aggregate_Fields>;
  nodes: Array<PreAuthorizationStatusType>;
};

/** aggregate fields of "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusType_Aggregate_Fields = {
  __typename?: 'preAuthorizationStatusType_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PreAuthorizationStatusType_Max_Fields>;
  min?: Maybe<PreAuthorizationStatusType_Min_Fields>;
};


/** aggregate fields of "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PreAuthorizationStatusType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.pre_authorization_status_type". All fields are combined with a logical 'AND'. */
export type PreAuthorizationStatusType_Bool_Exp = {
  _and?: InputMaybe<Array<PreAuthorizationStatusType_Bool_Exp>>;
  _not?: InputMaybe<PreAuthorizationStatusType_Bool_Exp>;
  _or?: InputMaybe<Array<PreAuthorizationStatusType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  preAuthorizations?: InputMaybe<PreAuthorization_Bool_Exp>;
  preAuthorizations_aggregate?: InputMaybe<PreAuthorization_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "claims.pre_authorization_status_type" */
export enum PreAuthorizationStatusType_Constraint {
  /** unique or primary key constraint on columns "id" */
  PreAuthorizationStatusTypePkey = 'pre_authorization_status_type_pkey'
}

/** input type for inserting data into table "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  preAuthorizations?: InputMaybe<PreAuthorization_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type PreAuthorizationStatusType_Max_Fields = {
  __typename?: 'preAuthorizationStatusType_max_fields';
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PreAuthorizationStatusType_Min_Fields = {
  __typename?: 'preAuthorizationStatusType_min_fields';
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusType_Mutation_Response = {
  __typename?: 'preAuthorizationStatusType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PreAuthorizationStatusType>;
};

/** input type for inserting object relation for remote table "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusType_Obj_Rel_Insert_Input = {
  data: PreAuthorizationStatusType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PreAuthorizationStatusType_On_Conflict>;
};

/** on_conflict condition type for table "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusType_On_Conflict = {
  constraint: PreAuthorizationStatusType_Constraint;
  update_columns?: Array<PreAuthorizationStatusType_Update_Column>;
  where?: InputMaybe<PreAuthorizationStatusType_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.pre_authorization_status_type". */
export type PreAuthorizationStatusType_Order_By = {
  display?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  preAuthorizations_aggregate?: InputMaybe<PreAuthorization_Aggregate_Order_By>;
};

/** primary key columns input for table: claims.pre_authorization_status_type */
export type PreAuthorizationStatusType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.pre_authorization_status_type" */
export enum PreAuthorizationStatusType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "claims.pre_authorization_status_type" */
export type PreAuthorizationStatusType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "preAuthorizationStatusType" */
export type PreAuthorizationStatusType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PreAuthorizationStatusType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PreAuthorizationStatusType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "claims.pre_authorization_status_type" */
export enum PreAuthorizationStatusType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type PreAuthorizationStatusType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PreAuthorizationStatusType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PreAuthorizationStatusType_Bool_Exp;
};

/** columns and relationships of "claims.pre_authorization_type" */
export type PreAuthorizationType = {
  __typename?: 'preAuthorizationType';
  display?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  preAuthorizations: Array<PreAuthorization>;
  /** An aggregate relationship */
  preAuthorizations_aggregate: PreAuthorization_Aggregate;
};


/** columns and relationships of "claims.pre_authorization_type" */
export type PreAuthorizationTypePreAuthorizationsArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorization_Order_By>>;
  where?: InputMaybe<PreAuthorization_Bool_Exp>;
};


/** columns and relationships of "claims.pre_authorization_type" */
export type PreAuthorizationTypePreAuthorizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorization_Order_By>>;
  where?: InputMaybe<PreAuthorization_Bool_Exp>;
};

/** aggregated selection of "claims.pre_authorization_type" */
export type PreAuthorizationType_Aggregate = {
  __typename?: 'preAuthorizationType_aggregate';
  aggregate?: Maybe<PreAuthorizationType_Aggregate_Fields>;
  nodes: Array<PreAuthorizationType>;
};

/** aggregate fields of "claims.pre_authorization_type" */
export type PreAuthorizationType_Aggregate_Fields = {
  __typename?: 'preAuthorizationType_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PreAuthorizationType_Max_Fields>;
  min?: Maybe<PreAuthorizationType_Min_Fields>;
};


/** aggregate fields of "claims.pre_authorization_type" */
export type PreAuthorizationType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PreAuthorizationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.pre_authorization_type". All fields are combined with a logical 'AND'. */
export type PreAuthorizationType_Bool_Exp = {
  _and?: InputMaybe<Array<PreAuthorizationType_Bool_Exp>>;
  _not?: InputMaybe<PreAuthorizationType_Bool_Exp>;
  _or?: InputMaybe<Array<PreAuthorizationType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  preAuthorizations?: InputMaybe<PreAuthorization_Bool_Exp>;
  preAuthorizations_aggregate?: InputMaybe<PreAuthorization_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "claims.pre_authorization_type" */
export enum PreAuthorizationType_Constraint {
  /** unique or primary key constraint on columns "id" */
  PreAuthorizationTypePkey = 'pre_authorization_type_pkey'
}

/** input type for inserting data into table "claims.pre_authorization_type" */
export type PreAuthorizationType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  preAuthorizations?: InputMaybe<PreAuthorization_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type PreAuthorizationType_Max_Fields = {
  __typename?: 'preAuthorizationType_max_fields';
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PreAuthorizationType_Min_Fields = {
  __typename?: 'preAuthorizationType_min_fields';
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "claims.pre_authorization_type" */
export type PreAuthorizationType_Mutation_Response = {
  __typename?: 'preAuthorizationType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PreAuthorizationType>;
};

/** input type for inserting object relation for remote table "claims.pre_authorization_type" */
export type PreAuthorizationType_Obj_Rel_Insert_Input = {
  data: PreAuthorizationType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PreAuthorizationType_On_Conflict>;
};

/** on_conflict condition type for table "claims.pre_authorization_type" */
export type PreAuthorizationType_On_Conflict = {
  constraint: PreAuthorizationType_Constraint;
  update_columns?: Array<PreAuthorizationType_Update_Column>;
  where?: InputMaybe<PreAuthorizationType_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.pre_authorization_type". */
export type PreAuthorizationType_Order_By = {
  display?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  preAuthorizations_aggregate?: InputMaybe<PreAuthorization_Aggregate_Order_By>;
};

/** primary key columns input for table: claims.pre_authorization_type */
export type PreAuthorizationType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.pre_authorization_type" */
export enum PreAuthorizationType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "claims.pre_authorization_type" */
export type PreAuthorizationType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "preAuthorizationType" */
export type PreAuthorizationType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PreAuthorizationType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PreAuthorizationType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "claims.pre_authorization_type" */
export enum PreAuthorizationType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type PreAuthorizationType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PreAuthorizationType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PreAuthorizationType_Bool_Exp;
};

/** aggregated selection of "claims.pre_authorization" */
export type PreAuthorization_Aggregate = {
  __typename?: 'preAuthorization_aggregate';
  aggregate?: Maybe<PreAuthorization_Aggregate_Fields>;
  nodes: Array<PreAuthorization>;
};

export type PreAuthorization_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<PreAuthorization_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<PreAuthorization_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<PreAuthorization_Aggregate_Bool_Exp_Count>;
};

export type PreAuthorization_Aggregate_Bool_Exp_Bool_And = {
  arguments: PreAuthorization_Select_Column_PreAuthorization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PreAuthorization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PreAuthorization_Aggregate_Bool_Exp_Bool_Or = {
  arguments: PreAuthorization_Select_Column_PreAuthorization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PreAuthorization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PreAuthorization_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PreAuthorization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PreAuthorization_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.pre_authorization" */
export type PreAuthorization_Aggregate_Fields = {
  __typename?: 'preAuthorization_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PreAuthorization_Max_Fields>;
  min?: Maybe<PreAuthorization_Min_Fields>;
};


/** aggregate fields of "claims.pre_authorization" */
export type PreAuthorization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PreAuthorization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.pre_authorization" */
export type PreAuthorization_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PreAuthorization_Max_Order_By>;
  min?: InputMaybe<PreAuthorization_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PreAuthorization_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "claims.pre_authorization" */
export type PreAuthorization_Arr_Rel_Insert_Input = {
  data: Array<PreAuthorization_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PreAuthorization_On_Conflict>;
};

/** Boolean expression to filter rows from the table "claims.pre_authorization". All fields are combined with a logical 'AND'. */
export type PreAuthorization_Bool_Exp = {
  _and?: InputMaybe<Array<PreAuthorization_Bool_Exp>>;
  _not?: InputMaybe<PreAuthorization_Bool_Exp>;
  _or?: InputMaybe<Array<PreAuthorization_Bool_Exp>>;
  as400ClaimNumber?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  existsInAs400?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  preAuthorizationStatusType?: InputMaybe<PreAuthorizationStatusType_Bool_Exp>;
  preAuthorizationStatusTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  preAuthorizationType?: InputMaybe<PreAuthorizationType_Bool_Exp>;
  preAuthorizationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.pre_authorization" */
export enum PreAuthorization_Constraint {
  /** unique or primary key constraint on columns "id" */
  PreAuthorizationPkey = 'pre_authorization_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PreAuthorization_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PreAuthorization_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PreAuthorization_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "claims.pre_authorization" */
export type PreAuthorization_Insert_Input = {
  as400ClaimNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Obj_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  preAuthorizationStatusType?: InputMaybe<PreAuthorizationStatusType_Obj_Rel_Insert_Input>;
  preAuthorizationStatusTypeId?: InputMaybe<Scalars['uuid']>;
  preAuthorizationType?: InputMaybe<PreAuthorizationType_Obj_Rel_Insert_Input>;
  preAuthorizationTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PreAuthorization_Max_Fields = {
  __typename?: 'preAuthorization_max_fields';
  as400ClaimNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  preAuthorizationStatusTypeId?: Maybe<Scalars['uuid']>;
  preAuthorizationTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "claims.pre_authorization" */
export type PreAuthorization_Max_Order_By = {
  as400ClaimNumber?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  preAuthorizationStatusTypeId?: InputMaybe<Order_By>;
  preAuthorizationTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PreAuthorization_Min_Fields = {
  __typename?: 'preAuthorization_min_fields';
  as400ClaimNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  preAuthorizationStatusTypeId?: Maybe<Scalars['uuid']>;
  preAuthorizationTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "claims.pre_authorization" */
export type PreAuthorization_Min_Order_By = {
  as400ClaimNumber?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  preAuthorizationStatusTypeId?: InputMaybe<Order_By>;
  preAuthorizationTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.pre_authorization" */
export type PreAuthorization_Mutation_Response = {
  __typename?: 'preAuthorization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PreAuthorization>;
};

/** on_conflict condition type for table "claims.pre_authorization" */
export type PreAuthorization_On_Conflict = {
  constraint: PreAuthorization_Constraint;
  update_columns?: Array<PreAuthorization_Update_Column>;
  where?: InputMaybe<PreAuthorization_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.pre_authorization". */
export type PreAuthorization_Order_By = {
  as400ClaimNumber?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  existsInAs400?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  preAuthorizationStatusType?: InputMaybe<PreAuthorizationStatusType_Order_By>;
  preAuthorizationStatusTypeId?: InputMaybe<Order_By>;
  preAuthorizationType?: InputMaybe<PreAuthorizationType_Order_By>;
  preAuthorizationTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.pre_authorization */
export type PreAuthorization_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PreAuthorization_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "claims.pre_authorization" */
export enum PreAuthorization_Select_Column {
  /** column name */
  As400ClaimNumber = 'as400ClaimNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Number = 'number',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PreAuthorizationStatusTypeId = 'preAuthorizationStatusTypeId',
  /** column name */
  PreAuthorizationTypeId = 'preAuthorizationTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "preAuthorization_aggregate_bool_exp_bool_and_arguments_columns" columns of table "claims.pre_authorization" */
export enum PreAuthorization_Select_Column_PreAuthorization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ExistsInAs400 = 'existsInAs400'
}

/** select "preAuthorization_aggregate_bool_exp_bool_or_arguments_columns" columns of table "claims.pre_authorization" */
export enum PreAuthorization_Select_Column_PreAuthorization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ExistsInAs400 = 'existsInAs400'
}

/** input type for updating data in table "claims.pre_authorization" */
export type PreAuthorization_Set_Input = {
  as400ClaimNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  preAuthorizationStatusTypeId?: InputMaybe<Scalars['uuid']>;
  preAuthorizationTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "preAuthorization" */
export type PreAuthorization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PreAuthorization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PreAuthorization_Stream_Cursor_Value_Input = {
  as400ClaimNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  number?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  preAuthorizationStatusTypeId?: InputMaybe<Scalars['uuid']>;
  preAuthorizationTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "claims.pre_authorization" */
export enum PreAuthorization_Update_Column {
  /** column name */
  As400ClaimNumber = 'as400ClaimNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PreAuthorizationStatusTypeId = 'preAuthorizationStatusTypeId',
  /** column name */
  PreAuthorizationTypeId = 'preAuthorizationTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PreAuthorization_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PreAuthorization_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PreAuthorization_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PreAuthorization_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PreAuthorization_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PreAuthorization_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PreAuthorization_Set_Input>;
  /** filter the rows which have to be updated */
  where: PreAuthorization_Bool_Exp;
};

/** columns and relationships of "product" */
export type Product = {
  __typename?: 'product';
  /** An array relationship */
  accountDisbursements: Array<AccountDisbursement>;
  /** An aggregate relationship */
  accountDisbursements_aggregate: AccountDisbursement_Aggregate;
  /** An array relationship */
  accountProducts: Array<AccountProduct>;
  /** An aggregate relationship */
  accountProducts_aggregate: AccountProduct_Aggregate;
  /** An array relationship */
  accountRetails: Array<AccountRetail>;
  /** An aggregate relationship */
  accountRetails_aggregate: AccountRetail_Aggregate;
  /** An object relationship */
  category: Category;
  categoryId: Scalars['uuid'];
  /** An array relationship */
  childCompositeProducts: Array<CompositeProduct>;
  /** An aggregate relationship */
  childCompositeProducts_aggregate: CompositeProduct_Aggregate;
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  entityConfigurationItems: Array<EntityConfigurationItem>;
  /** An aggregate relationship */
  entityConfigurationItems_aggregate: EntityConfigurationItem_Aggregate;
  /** An array relationship */
  entityEligibilityRules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entityEligibilityRules_aggregate: EntityEligibilityRule_Aggregate;
  /** An array relationship */
  entityOfferings: Array<EntityOffering>;
  /** An aggregate relationship */
  entityOfferings_aggregate: EntityOffering_Aggregate;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  expirationCalculationMetadata?: Maybe<Scalars['jsonb']>;
  formCode?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isArchived: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  parentCompositeProducts: Array<CompositeProduct>;
  /** An aggregate relationship */
  parentCompositeProducts_aggregate: CompositeProduct_Aggregate;
  /** An array relationship */
  policyContracts: Array<PolicyContract>;
  /** An aggregate relationship */
  policyContracts_aggregate: PolicyContract_Aggregate;
  /** An array relationship */
  productAttributes: Array<ProductAttribute>;
  /** An aggregate relationship */
  productAttributes_aggregate: ProductAttribute_Aggregate;
  /** An array relationship */
  productClassGuides: Array<ProductClassGuide>;
  /** An aggregate relationship */
  productClassGuides_aggregate: ProductClassGuide_Aggregate;
  /** An array relationship */
  productContractForms: Array<ProductContractForm>;
  /** An aggregate relationship */
  productContractForms_aggregate: ProductContractForm_Aggregate;
  /** An array relationship */
  productCosts: Array<ProductCost>;
  /** An aggregate relationship */
  productCosts_aggregate: ProductCost_Aggregate;
  /** An array relationship */
  productDisbursements: Array<ProductDisbursement>;
  /** An aggregate relationship */
  productDisbursements_aggregate: ProductDisbursement_Aggregate;
  /** An array relationship */
  productEligibilities: Array<ProductEligibility>;
  /** An aggregate relationship */
  productEligibilities_aggregate: ProductEligibility_Aggregate;
  /** An array relationship */
  productObligors: Array<ProductObligor>;
  /** An aggregate relationship */
  productObligors_aggregate: ProductObligor_Aggregate;
  /** An array relationship */
  productRateBuckets: Array<ProductRateBucket>;
  /** An aggregate relationship */
  productRateBuckets_aggregate: ProductRateBucket_Aggregate;
  /** An array relationship */
  productSurchargeTypes: Array<ProductSurchargeType>;
  /** An aggregate relationship */
  productSurchargeTypes_aggregate: ProductSurchargeType_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "product" */
export type ProductAccountDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductAccountDisbursements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductAccountProductsArgs = {
  distinct_on?: InputMaybe<Array<AccountProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProduct_Order_By>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductAccountProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProduct_Order_By>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductAccountRetailsArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductAccountRetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductChildCompositeProductsArgs = {
  distinct_on?: InputMaybe<Array<CompositeProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompositeProduct_Order_By>>;
  where?: InputMaybe<CompositeProduct_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductChildCompositeProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CompositeProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompositeProduct_Order_By>>;
  where?: InputMaybe<CompositeProduct_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductEntityConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductEntityConfigurationItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductEntityEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductEntityOfferingsArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductEntityOfferings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductExpirationCalculationMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "product" */
export type ProductParentCompositeProductsArgs = {
  distinct_on?: InputMaybe<Array<CompositeProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompositeProduct_Order_By>>;
  where?: InputMaybe<CompositeProduct_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductParentCompositeProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CompositeProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompositeProduct_Order_By>>;
  where?: InputMaybe<CompositeProduct_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductPolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductPolicyContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductAttributesArgs = {
  distinct_on?: InputMaybe<Array<ProductAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttribute_Order_By>>;
  where?: InputMaybe<ProductAttribute_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttribute_Order_By>>;
  where?: InputMaybe<ProductAttribute_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductClassGuidesArgs = {
  distinct_on?: InputMaybe<Array<ProductClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductClassGuide_Order_By>>;
  where?: InputMaybe<ProductClassGuide_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductClassGuides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductClassGuide_Order_By>>;
  where?: InputMaybe<ProductClassGuide_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductContractFormsArgs = {
  distinct_on?: InputMaybe<Array<ProductContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductContractForm_Order_By>>;
  where?: InputMaybe<ProductContractForm_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductContractForms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductContractForm_Order_By>>;
  where?: InputMaybe<ProductContractForm_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductCostsArgs = {
  distinct_on?: InputMaybe<Array<ProductCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductCost_Order_By>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductCosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductCost_Order_By>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductDisbursement_Order_By>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductDisbursements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductDisbursement_Order_By>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductEligibilitiesArgs = {
  distinct_on?: InputMaybe<Array<ProductEligibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductEligibility_Order_By>>;
  where?: InputMaybe<ProductEligibility_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductEligibilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductEligibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductEligibility_Order_By>>;
  where?: InputMaybe<ProductEligibility_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductObligorsArgs = {
  distinct_on?: InputMaybe<Array<ProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductObligor_Order_By>>;
  where?: InputMaybe<ProductObligor_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductObligors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductObligor_Order_By>>;
  where?: InputMaybe<ProductObligor_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductRateBucketsArgs = {
  distinct_on?: InputMaybe<Array<ProductRateBucket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductRateBucket_Order_By>>;
  where?: InputMaybe<ProductRateBucket_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductRateBuckets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductRateBucket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductRateBucket_Order_By>>;
  where?: InputMaybe<ProductRateBucket_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductSurchargeTypesArgs = {
  distinct_on?: InputMaybe<Array<ProductSurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductSurchargeType_Order_By>>;
  where?: InputMaybe<ProductSurchargeType_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProductSurchargeTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductSurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductSurchargeType_Order_By>>;
  where?: InputMaybe<ProductSurchargeType_Bool_Exp>;
};

/** columns and relationships of "product_attribute" */
export type ProductAttribute = {
  __typename?: 'productAttribute';
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  /** An array relationship */
  entity_offerings: Array<EntityOffering>;
  /** An aggregate relationship */
  entity_offerings_aggregate: EntityOffering_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  product: Product;
  /** An object relationship */
  productAttributeType?: Maybe<ProductAttributeType>;
  productAttributeTypeId?: Maybe<Scalars['Int']>;
  productId: Scalars['uuid'];
  value: Scalars['String'];
};


/** columns and relationships of "product_attribute" */
export type ProductAttributeEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "product_attribute" */
export type ProductAttributeEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "product_attribute" */
export type ProductAttributeEntity_OfferingsArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


/** columns and relationships of "product_attribute" */
export type ProductAttributeEntity_Offerings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};

/** columns and relationships of "product_attribute_type" */
export type ProductAttributeType = {
  __typename?: 'productAttributeType';
  /** An array relationship */
  categoryProductAttributeTypes: Array<CategoryProductAttributeType>;
  /** An aggregate relationship */
  categoryProductAttributeTypes_aggregate: CategoryProductAttributeType_Aggregate;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  productAttributes: Array<ProductAttribute>;
  /** An aggregate relationship */
  productAttributes_aggregate: ProductAttribute_Aggregate;
};


/** columns and relationships of "product_attribute_type" */
export type ProductAttributeTypeCategoryProductAttributeTypesArgs = {
  distinct_on?: InputMaybe<Array<CategoryProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CategoryProductAttributeType_Order_By>>;
  where?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
};


/** columns and relationships of "product_attribute_type" */
export type ProductAttributeTypeCategoryProductAttributeTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CategoryProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CategoryProductAttributeType_Order_By>>;
  where?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
};


/** columns and relationships of "product_attribute_type" */
export type ProductAttributeTypeProductAttributesArgs = {
  distinct_on?: InputMaybe<Array<ProductAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttribute_Order_By>>;
  where?: InputMaybe<ProductAttribute_Bool_Exp>;
};


/** columns and relationships of "product_attribute_type" */
export type ProductAttributeTypeProductAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttribute_Order_By>>;
  where?: InputMaybe<ProductAttribute_Bool_Exp>;
};

/** aggregated selection of "product_attribute_type" */
export type ProductAttributeType_Aggregate = {
  __typename?: 'productAttributeType_aggregate';
  aggregate?: Maybe<ProductAttributeType_Aggregate_Fields>;
  nodes: Array<ProductAttributeType>;
};

/** aggregate fields of "product_attribute_type" */
export type ProductAttributeType_Aggregate_Fields = {
  __typename?: 'productAttributeType_aggregate_fields';
  avg?: Maybe<ProductAttributeType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProductAttributeType_Max_Fields>;
  min?: Maybe<ProductAttributeType_Min_Fields>;
  stddev?: Maybe<ProductAttributeType_Stddev_Fields>;
  stddev_pop?: Maybe<ProductAttributeType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProductAttributeType_Stddev_Samp_Fields>;
  sum?: Maybe<ProductAttributeType_Sum_Fields>;
  var_pop?: Maybe<ProductAttributeType_Var_Pop_Fields>;
  var_samp?: Maybe<ProductAttributeType_Var_Samp_Fields>;
  variance?: Maybe<ProductAttributeType_Variance_Fields>;
};


/** aggregate fields of "product_attribute_type" */
export type ProductAttributeType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductAttributeType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ProductAttributeType_Avg_Fields = {
  __typename?: 'productAttributeType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "product_attribute_type". All fields are combined with a logical 'AND'. */
export type ProductAttributeType_Bool_Exp = {
  _and?: InputMaybe<Array<ProductAttributeType_Bool_Exp>>;
  _not?: InputMaybe<ProductAttributeType_Bool_Exp>;
  _or?: InputMaybe<Array<ProductAttributeType_Bool_Exp>>;
  categoryProductAttributeTypes?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
  categoryProductAttributeTypes_aggregate?: InputMaybe<CategoryProductAttributeType_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  productAttributes?: InputMaybe<ProductAttribute_Bool_Exp>;
  productAttributes_aggregate?: InputMaybe<ProductAttribute_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "product_attribute_type" */
export enum ProductAttributeType_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductAttributeTypePkey = 'product_attribute_type_pkey'
}

/** input type for incrementing numeric columns in table "product_attribute_type" */
export type ProductAttributeType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_attribute_type" */
export type ProductAttributeType_Insert_Input = {
  categoryProductAttributeTypes?: InputMaybe<CategoryProductAttributeType_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productAttributes?: InputMaybe<ProductAttribute_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ProductAttributeType_Max_Fields = {
  __typename?: 'productAttributeType_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProductAttributeType_Min_Fields = {
  __typename?: 'productAttributeType_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "product_attribute_type" */
export type ProductAttributeType_Mutation_Response = {
  __typename?: 'productAttributeType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductAttributeType>;
};

/** input type for inserting object relation for remote table "product_attribute_type" */
export type ProductAttributeType_Obj_Rel_Insert_Input = {
  data: ProductAttributeType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductAttributeType_On_Conflict>;
};

/** on_conflict condition type for table "product_attribute_type" */
export type ProductAttributeType_On_Conflict = {
  constraint: ProductAttributeType_Constraint;
  update_columns?: Array<ProductAttributeType_Update_Column>;
  where?: InputMaybe<ProductAttributeType_Bool_Exp>;
};

/** Ordering options when selecting data from "product_attribute_type". */
export type ProductAttributeType_Order_By = {
  categoryProductAttributeTypes_aggregate?: InputMaybe<CategoryProductAttributeType_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  productAttributes_aggregate?: InputMaybe<ProductAttribute_Aggregate_Order_By>;
};

/** primary key columns input for table: product_attribute_type */
export type ProductAttributeType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "product_attribute_type" */
export enum ProductAttributeType_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "product_attribute_type" */
export type ProductAttributeType_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProductAttributeType_Stddev_Fields = {
  __typename?: 'productAttributeType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ProductAttributeType_Stddev_Pop_Fields = {
  __typename?: 'productAttributeType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ProductAttributeType_Stddev_Samp_Fields = {
  __typename?: 'productAttributeType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "productAttributeType" */
export type ProductAttributeType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductAttributeType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductAttributeType_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProductAttributeType_Sum_Fields = {
  __typename?: 'productAttributeType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "product_attribute_type" */
export enum ProductAttributeType_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type ProductAttributeType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProductAttributeType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductAttributeType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProductAttributeType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProductAttributeType_Var_Pop_Fields = {
  __typename?: 'productAttributeType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ProductAttributeType_Var_Samp_Fields = {
  __typename?: 'productAttributeType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ProductAttributeType_Variance_Fields = {
  __typename?: 'productAttributeType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "product_attribute" */
export type ProductAttribute_Aggregate = {
  __typename?: 'productAttribute_aggregate';
  aggregate?: Maybe<ProductAttribute_Aggregate_Fields>;
  nodes: Array<ProductAttribute>;
};

export type ProductAttribute_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProductAttribute_Aggregate_Bool_Exp_Count>;
};

export type ProductAttribute_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProductAttribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductAttribute_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_attribute" */
export type ProductAttribute_Aggregate_Fields = {
  __typename?: 'productAttribute_aggregate_fields';
  avg?: Maybe<ProductAttribute_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProductAttribute_Max_Fields>;
  min?: Maybe<ProductAttribute_Min_Fields>;
  stddev?: Maybe<ProductAttribute_Stddev_Fields>;
  stddev_pop?: Maybe<ProductAttribute_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProductAttribute_Stddev_Samp_Fields>;
  sum?: Maybe<ProductAttribute_Sum_Fields>;
  var_pop?: Maybe<ProductAttribute_Var_Pop_Fields>;
  var_samp?: Maybe<ProductAttribute_Var_Samp_Fields>;
  variance?: Maybe<ProductAttribute_Variance_Fields>;
};


/** aggregate fields of "product_attribute" */
export type ProductAttribute_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductAttribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_attribute" */
export type ProductAttribute_Aggregate_Order_By = {
  avg?: InputMaybe<ProductAttribute_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProductAttribute_Max_Order_By>;
  min?: InputMaybe<ProductAttribute_Min_Order_By>;
  stddev?: InputMaybe<ProductAttribute_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProductAttribute_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProductAttribute_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProductAttribute_Sum_Order_By>;
  var_pop?: InputMaybe<ProductAttribute_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProductAttribute_Var_Samp_Order_By>;
  variance?: InputMaybe<ProductAttribute_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_attribute" */
export type ProductAttribute_Arr_Rel_Insert_Input = {
  data: Array<ProductAttribute_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductAttribute_On_Conflict>;
};

/** aggregate avg on columns */
export type ProductAttribute_Avg_Fields = {
  __typename?: 'productAttribute_avg_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_attribute" */
export type ProductAttribute_Avg_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_attribute". All fields are combined with a logical 'AND'. */
export type ProductAttribute_Bool_Exp = {
  _and?: InputMaybe<Array<ProductAttribute_Bool_Exp>>;
  _not?: InputMaybe<ProductAttribute_Bool_Exp>;
  _or?: InputMaybe<Array<ProductAttribute_Bool_Exp>>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  entity_offerings?: InputMaybe<EntityOffering_Bool_Exp>;
  entity_offerings_aggregate?: InputMaybe<EntityOffering_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productAttributeType?: InputMaybe<ProductAttributeType_Bool_Exp>;
  productAttributeTypeId?: InputMaybe<Int_Comparison_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_attribute" */
export enum ProductAttribute_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductAttributePkey = 'product_attribute_pkey'
}

/** input type for incrementing numeric columns in table "product_attribute" */
export type ProductAttribute_Inc_Input = {
  productAttributeTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_attribute" */
export type ProductAttribute_Insert_Input = {
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  entity_offerings?: InputMaybe<EntityOffering_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productAttributeType?: InputMaybe<ProductAttributeType_Obj_Rel_Insert_Input>;
  productAttributeTypeId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProductAttribute_Max_Fields = {
  __typename?: 'productAttribute_max_fields';
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productAttributeTypeId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product_attribute" */
export type ProductAttribute_Max_Order_By = {
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productAttributeTypeId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProductAttribute_Min_Fields = {
  __typename?: 'productAttribute_min_fields';
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productAttributeTypeId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product_attribute" */
export type ProductAttribute_Min_Order_By = {
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productAttributeTypeId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_attribute" */
export type ProductAttribute_Mutation_Response = {
  __typename?: 'productAttribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductAttribute>;
};

/** input type for inserting object relation for remote table "product_attribute" */
export type ProductAttribute_Obj_Rel_Insert_Input = {
  data: ProductAttribute_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductAttribute_On_Conflict>;
};

/** on_conflict condition type for table "product_attribute" */
export type ProductAttribute_On_Conflict = {
  constraint: ProductAttribute_Constraint;
  update_columns?: Array<ProductAttribute_Update_Column>;
  where?: InputMaybe<ProductAttribute_Bool_Exp>;
};

/** Ordering options when selecting data from "product_attribute". */
export type ProductAttribute_Order_By = {
  effectiveDate?: InputMaybe<Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  entity_offerings_aggregate?: InputMaybe<EntityOffering_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productAttributeType?: InputMaybe<ProductAttributeType_Order_By>;
  productAttributeTypeId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_attribute */
export type ProductAttribute_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_attribute" */
export enum ProductAttribute_Select_Column {
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProductAttributeTypeId = 'productAttributeTypeId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "product_attribute" */
export type ProductAttribute_Set_Input = {
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  productAttributeTypeId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ProductAttribute_Stddev_Fields = {
  __typename?: 'productAttribute_stddev_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_attribute" */
export type ProductAttribute_Stddev_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProductAttribute_Stddev_Pop_Fields = {
  __typename?: 'productAttribute_stddev_pop_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_attribute" */
export type ProductAttribute_Stddev_Pop_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProductAttribute_Stddev_Samp_Fields = {
  __typename?: 'productAttribute_stddev_samp_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_attribute" */
export type ProductAttribute_Stddev_Samp_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "productAttribute" */
export type ProductAttribute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductAttribute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductAttribute_Stream_Cursor_Value_Input = {
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  productAttributeTypeId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProductAttribute_Sum_Fields = {
  __typename?: 'productAttribute_sum_fields';
  productAttributeTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product_attribute" */
export type ProductAttribute_Sum_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "product_attribute" */
export enum ProductAttribute_Update_Column {
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProductAttributeTypeId = 'productAttributeTypeId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  Value = 'value'
}

export type ProductAttribute_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProductAttribute_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductAttribute_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProductAttribute_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProductAttribute_Var_Pop_Fields = {
  __typename?: 'productAttribute_var_pop_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_attribute" */
export type ProductAttribute_Var_Pop_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProductAttribute_Var_Samp_Fields = {
  __typename?: 'productAttribute_var_samp_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_attribute" */
export type ProductAttribute_Var_Samp_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProductAttribute_Variance_Fields = {
  __typename?: 'productAttribute_variance_fields';
  productAttributeTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_attribute" */
export type ProductAttribute_Variance_Order_By = {
  productAttributeTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_class_guide" */
export type ProductClassGuide = {
  __typename?: 'productClassGuide';
  classGuideName?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  product: Product;
  productId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "product_class_guide" */
export type ProductClassGuide_Aggregate = {
  __typename?: 'productClassGuide_aggregate';
  aggregate?: Maybe<ProductClassGuide_Aggregate_Fields>;
  nodes: Array<ProductClassGuide>;
};

export type ProductClassGuide_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProductClassGuide_Aggregate_Bool_Exp_Count>;
};

export type ProductClassGuide_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProductClassGuide_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductClassGuide_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_class_guide" */
export type ProductClassGuide_Aggregate_Fields = {
  __typename?: 'productClassGuide_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProductClassGuide_Max_Fields>;
  min?: Maybe<ProductClassGuide_Min_Fields>;
};


/** aggregate fields of "product_class_guide" */
export type ProductClassGuide_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductClassGuide_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_class_guide" */
export type ProductClassGuide_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProductClassGuide_Max_Order_By>;
  min?: InputMaybe<ProductClassGuide_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_class_guide" */
export type ProductClassGuide_Arr_Rel_Insert_Input = {
  data: Array<ProductClassGuide_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductClassGuide_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_class_guide". All fields are combined with a logical 'AND'. */
export type ProductClassGuide_Bool_Exp = {
  _and?: InputMaybe<Array<ProductClassGuide_Bool_Exp>>;
  _not?: InputMaybe<ProductClassGuide_Bool_Exp>;
  _or?: InputMaybe<Array<ProductClassGuide_Bool_Exp>>;
  classGuideName?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_class_guide" */
export enum ProductClassGuide_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductClassGuidePkey = 'product_class_guide_pkey'
}

/** input type for inserting data into table "product_class_guide" */
export type ProductClassGuide_Insert_Input = {
  classGuideName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ProductClassGuide_Max_Fields = {
  __typename?: 'productClassGuide_max_fields';
  classGuideName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "product_class_guide" */
export type ProductClassGuide_Max_Order_By = {
  classGuideName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProductClassGuide_Min_Fields = {
  __typename?: 'productClassGuide_min_fields';
  classGuideName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "product_class_guide" */
export type ProductClassGuide_Min_Order_By = {
  classGuideName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_class_guide" */
export type ProductClassGuide_Mutation_Response = {
  __typename?: 'productClassGuide_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductClassGuide>;
};

/** on_conflict condition type for table "product_class_guide" */
export type ProductClassGuide_On_Conflict = {
  constraint: ProductClassGuide_Constraint;
  update_columns?: Array<ProductClassGuide_Update_Column>;
  where?: InputMaybe<ProductClassGuide_Bool_Exp>;
};

/** Ordering options when selecting data from "product_class_guide". */
export type ProductClassGuide_Order_By = {
  classGuideName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_class_guide */
export type ProductClassGuide_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_class_guide" */
export enum ProductClassGuide_Select_Column {
  /** column name */
  ClassGuideName = 'classGuideName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "product_class_guide" */
export type ProductClassGuide_Set_Input = {
  classGuideName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "productClassGuide" */
export type ProductClassGuide_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductClassGuide_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductClassGuide_Stream_Cursor_Value_Input = {
  classGuideName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "product_class_guide" */
export enum ProductClassGuide_Update_Column {
  /** column name */
  ClassGuideName = 'classGuideName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ProductClassGuide_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductClassGuide_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProductClassGuide_Bool_Exp;
};

/** columns and relationships of "compliance.product_contract_form" */
export type ProductContractForm = {
  __typename?: 'productContractForm';
  /** An object relationship */
  contractForm?: Maybe<ContractForm>;
  contractFormId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityEligibilityRules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entityEligibilityRules_aggregate: EntityEligibilityRule_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "compliance.product_contract_form" */
export type ProductContractFormEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "compliance.product_contract_form" */
export type ProductContractFormEntityEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};

/** aggregated selection of "compliance.product_contract_form" */
export type ProductContractForm_Aggregate = {
  __typename?: 'productContractForm_aggregate';
  aggregate?: Maybe<ProductContractForm_Aggregate_Fields>;
  nodes: Array<ProductContractForm>;
};

export type ProductContractForm_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProductContractForm_Aggregate_Bool_Exp_Count>;
};

export type ProductContractForm_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProductContractForm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductContractForm_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance.product_contract_form" */
export type ProductContractForm_Aggregate_Fields = {
  __typename?: 'productContractForm_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProductContractForm_Max_Fields>;
  min?: Maybe<ProductContractForm_Min_Fields>;
};


/** aggregate fields of "compliance.product_contract_form" */
export type ProductContractForm_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductContractForm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance.product_contract_form" */
export type ProductContractForm_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProductContractForm_Max_Order_By>;
  min?: InputMaybe<ProductContractForm_Min_Order_By>;
};

/** input type for inserting array relation for remote table "compliance.product_contract_form" */
export type ProductContractForm_Arr_Rel_Insert_Input = {
  data: Array<ProductContractForm_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductContractForm_On_Conflict>;
};

/** Boolean expression to filter rows from the table "compliance.product_contract_form". All fields are combined with a logical 'AND'. */
export type ProductContractForm_Bool_Exp = {
  _and?: InputMaybe<Array<ProductContractForm_Bool_Exp>>;
  _not?: InputMaybe<ProductContractForm_Bool_Exp>;
  _or?: InputMaybe<Array<ProductContractForm_Bool_Exp>>;
  contractForm?: InputMaybe<ContractForm_Bool_Exp>;
  contractFormId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance.product_contract_form" */
export enum ProductContractForm_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductContractFormPkey = 'product_contract_form_pkey'
}

/** input type for inserting data into table "compliance.product_contract_form" */
export type ProductContractForm_Insert_Input = {
  contractForm?: InputMaybe<ContractForm_Obj_Rel_Insert_Input>;
  contractFormId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ProductContractForm_Max_Fields = {
  __typename?: 'productContractForm_max_fields';
  contractFormId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance.product_contract_form" */
export type ProductContractForm_Max_Order_By = {
  contractFormId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProductContractForm_Min_Fields = {
  __typename?: 'productContractForm_min_fields';
  contractFormId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance.product_contract_form" */
export type ProductContractForm_Min_Order_By = {
  contractFormId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance.product_contract_form" */
export type ProductContractForm_Mutation_Response = {
  __typename?: 'productContractForm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductContractForm>;
};

/** input type for inserting object relation for remote table "compliance.product_contract_form" */
export type ProductContractForm_Obj_Rel_Insert_Input = {
  data: ProductContractForm_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductContractForm_On_Conflict>;
};

/** on_conflict condition type for table "compliance.product_contract_form" */
export type ProductContractForm_On_Conflict = {
  constraint: ProductContractForm_Constraint;
  update_columns?: Array<ProductContractForm_Update_Column>;
  where?: InputMaybe<ProductContractForm_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance.product_contract_form". */
export type ProductContractForm_Order_By = {
  contractForm?: InputMaybe<ContractForm_Order_By>;
  contractFormId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance.product_contract_form */
export type ProductContractForm_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "compliance.product_contract_form" */
export enum ProductContractForm_Select_Column {
  /** column name */
  ContractFormId = 'contractFormId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "compliance.product_contract_form" */
export type ProductContractForm_Set_Input = {
  contractFormId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "productContractForm" */
export type ProductContractForm_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductContractForm_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductContractForm_Stream_Cursor_Value_Input = {
  contractFormId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "compliance.product_contract_form" */
export enum ProductContractForm_Update_Column {
  /** column name */
  ContractFormId = 'contractFormId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ProductContractForm_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductContractForm_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProductContractForm_Bool_Exp;
};

/** columns and relationships of "product_cost" */
export type ProductCost = {
  __typename?: 'productCost';
  /** An object relationship */
  costAdjustment: CostAdjustment;
  costAdjustmentId: Scalars['uuid'];
  effectiveDate?: Maybe<Scalars['date']>;
  /** An array relationship */
  entityEligibilityRules: Array<EntityEligibilityRule>;
  /** An aggregate relationship */
  entityEligibilityRules_aggregate: EntityEligibilityRule_Aggregate;
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  orderNumber: Scalars['Int'];
  /** An object relationship */
  product: Product;
  productId: Scalars['uuid'];
  /** An object relationship */
  rateBucketType?: Maybe<RateBucketType>;
  rateBucketTypeId?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "product_cost" */
export type ProductCostEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "product_cost" */
export type ProductCostEntityEligibilityRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


/** columns and relationships of "product_cost" */
export type ProductCostEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** columns and relationships of "product_cost" */
export type ProductCostEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};

/** aggregated selection of "product_cost" */
export type ProductCost_Aggregate = {
  __typename?: 'productCost_aggregate';
  aggregate?: Maybe<ProductCost_Aggregate_Fields>;
  nodes: Array<ProductCost>;
};

export type ProductCost_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProductCost_Aggregate_Bool_Exp_Count>;
};

export type ProductCost_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProductCost_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductCost_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_cost" */
export type ProductCost_Aggregate_Fields = {
  __typename?: 'productCost_aggregate_fields';
  avg?: Maybe<ProductCost_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProductCost_Max_Fields>;
  min?: Maybe<ProductCost_Min_Fields>;
  stddev?: Maybe<ProductCost_Stddev_Fields>;
  stddev_pop?: Maybe<ProductCost_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProductCost_Stddev_Samp_Fields>;
  sum?: Maybe<ProductCost_Sum_Fields>;
  var_pop?: Maybe<ProductCost_Var_Pop_Fields>;
  var_samp?: Maybe<ProductCost_Var_Samp_Fields>;
  variance?: Maybe<ProductCost_Variance_Fields>;
};


/** aggregate fields of "product_cost" */
export type ProductCost_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductCost_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_cost" */
export type ProductCost_Aggregate_Order_By = {
  avg?: InputMaybe<ProductCost_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProductCost_Max_Order_By>;
  min?: InputMaybe<ProductCost_Min_Order_By>;
  stddev?: InputMaybe<ProductCost_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProductCost_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProductCost_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProductCost_Sum_Order_By>;
  var_pop?: InputMaybe<ProductCost_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProductCost_Var_Samp_Order_By>;
  variance?: InputMaybe<ProductCost_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_cost" */
export type ProductCost_Arr_Rel_Insert_Input = {
  data: Array<ProductCost_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductCost_On_Conflict>;
};

/** aggregate avg on columns */
export type ProductCost_Avg_Fields = {
  __typename?: 'productCost_avg_fields';
  orderNumber?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_cost" */
export type ProductCost_Avg_Order_By = {
  orderNumber?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_cost". All fields are combined with a logical 'AND'. */
export type ProductCost_Bool_Exp = {
  _and?: InputMaybe<Array<ProductCost_Bool_Exp>>;
  _not?: InputMaybe<ProductCost_Bool_Exp>;
  _or?: InputMaybe<Array<ProductCost_Bool_Exp>>;
  costAdjustment?: InputMaybe<CostAdjustment_Bool_Exp>;
  costAdjustmentId?: InputMaybe<Uuid_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orderNumber?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  rateBucketType?: InputMaybe<RateBucketType_Bool_Exp>;
  rateBucketTypeId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_cost" */
export enum ProductCost_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductCostPkey = 'product_cost_pkey'
}

/** input type for incrementing numeric columns in table "product_cost" */
export type ProductCost_Inc_Input = {
  orderNumber?: InputMaybe<Scalars['Int']>;
  rateBucketTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_cost" */
export type ProductCost_Insert_Input = {
  costAdjustment?: InputMaybe<CostAdjustment_Obj_Rel_Insert_Input>;
  costAdjustmentId?: InputMaybe<Scalars['uuid']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  orderNumber?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  rateBucketType?: InputMaybe<RateBucketType_Obj_Rel_Insert_Input>;
  rateBucketTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ProductCost_Max_Fields = {
  __typename?: 'productCost_max_fields';
  costAdjustmentId?: Maybe<Scalars['uuid']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  orderNumber?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['uuid']>;
  rateBucketTypeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "product_cost" */
export type ProductCost_Max_Order_By = {
  costAdjustmentId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderNumber?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProductCost_Min_Fields = {
  __typename?: 'productCost_min_fields';
  costAdjustmentId?: Maybe<Scalars['uuid']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  orderNumber?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['uuid']>;
  rateBucketTypeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "product_cost" */
export type ProductCost_Min_Order_By = {
  costAdjustmentId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderNumber?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_cost" */
export type ProductCost_Mutation_Response = {
  __typename?: 'productCost_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductCost>;
};

/** input type for inserting object relation for remote table "product_cost" */
export type ProductCost_Obj_Rel_Insert_Input = {
  data: ProductCost_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductCost_On_Conflict>;
};

/** on_conflict condition type for table "product_cost" */
export type ProductCost_On_Conflict = {
  constraint: ProductCost_Constraint;
  update_columns?: Array<ProductCost_Update_Column>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};

/** Ordering options when selecting data from "product_cost". */
export type ProductCost_Order_By = {
  costAdjustment?: InputMaybe<CostAdjustment_Order_By>;
  costAdjustmentId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderNumber?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  rateBucketType?: InputMaybe<RateBucketType_Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_cost */
export type ProductCost_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_cost" */
export enum ProductCost_Select_Column {
  /** column name */
  CostAdjustmentId = 'costAdjustmentId',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  OrderNumber = 'orderNumber',
  /** column name */
  ProductId = 'productId',
  /** column name */
  RateBucketTypeId = 'rateBucketTypeId'
}

/** input type for updating data in table "product_cost" */
export type ProductCost_Set_Input = {
  costAdjustmentId?: InputMaybe<Scalars['uuid']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  orderNumber?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['uuid']>;
  rateBucketTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ProductCost_Stddev_Fields = {
  __typename?: 'productCost_stddev_fields';
  orderNumber?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_cost" */
export type ProductCost_Stddev_Order_By = {
  orderNumber?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProductCost_Stddev_Pop_Fields = {
  __typename?: 'productCost_stddev_pop_fields';
  orderNumber?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_cost" */
export type ProductCost_Stddev_Pop_Order_By = {
  orderNumber?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProductCost_Stddev_Samp_Fields = {
  __typename?: 'productCost_stddev_samp_fields';
  orderNumber?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_cost" */
export type ProductCost_Stddev_Samp_Order_By = {
  orderNumber?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "productCost" */
export type ProductCost_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductCost_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductCost_Stream_Cursor_Value_Input = {
  costAdjustmentId?: InputMaybe<Scalars['uuid']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  orderNumber?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['uuid']>;
  rateBucketTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ProductCost_Sum_Fields = {
  __typename?: 'productCost_sum_fields';
  orderNumber?: Maybe<Scalars['Int']>;
  rateBucketTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product_cost" */
export type ProductCost_Sum_Order_By = {
  orderNumber?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "product_cost" */
export enum ProductCost_Update_Column {
  /** column name */
  CostAdjustmentId = 'costAdjustmentId',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  OrderNumber = 'orderNumber',
  /** column name */
  ProductId = 'productId',
  /** column name */
  RateBucketTypeId = 'rateBucketTypeId'
}

export type ProductCost_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProductCost_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductCost_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProductCost_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProductCost_Var_Pop_Fields = {
  __typename?: 'productCost_var_pop_fields';
  orderNumber?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_cost" */
export type ProductCost_Var_Pop_Order_By = {
  orderNumber?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProductCost_Var_Samp_Fields = {
  __typename?: 'productCost_var_samp_fields';
  orderNumber?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_cost" */
export type ProductCost_Var_Samp_Order_By = {
  orderNumber?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProductCost_Variance_Fields = {
  __typename?: 'productCost_variance_fields';
  orderNumber?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_cost" */
export type ProductCost_Variance_Order_By = {
  orderNumber?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_disbursement" */
export type ProductDisbursement = {
  __typename?: 'productDisbursement';
  amount?: Maybe<Scalars['numeric']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  createdAt: Scalars['timestamptz'];
  disbursementCode?: Maybe<Scalars['String']>;
  /** An object relationship */
  disbursementType?: Maybe<DisbursementType>;
  disbursementTypeId?: Maybe<Scalars['Int']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  payee?: Maybe<Payee>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "product_disbursement" */
export type ProductDisbursement_Aggregate = {
  __typename?: 'productDisbursement_aggregate';
  aggregate?: Maybe<ProductDisbursement_Aggregate_Fields>;
  nodes: Array<ProductDisbursement>;
};

export type ProductDisbursement_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProductDisbursement_Aggregate_Bool_Exp_Count>;
};

export type ProductDisbursement_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductDisbursement_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_disbursement" */
export type ProductDisbursement_Aggregate_Fields = {
  __typename?: 'productDisbursement_aggregate_fields';
  avg?: Maybe<ProductDisbursement_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProductDisbursement_Max_Fields>;
  min?: Maybe<ProductDisbursement_Min_Fields>;
  stddev?: Maybe<ProductDisbursement_Stddev_Fields>;
  stddev_pop?: Maybe<ProductDisbursement_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProductDisbursement_Stddev_Samp_Fields>;
  sum?: Maybe<ProductDisbursement_Sum_Fields>;
  var_pop?: Maybe<ProductDisbursement_Var_Pop_Fields>;
  var_samp?: Maybe<ProductDisbursement_Var_Samp_Fields>;
  variance?: Maybe<ProductDisbursement_Variance_Fields>;
};


/** aggregate fields of "product_disbursement" */
export type ProductDisbursement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_disbursement" */
export type ProductDisbursement_Aggregate_Order_By = {
  avg?: InputMaybe<ProductDisbursement_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProductDisbursement_Max_Order_By>;
  min?: InputMaybe<ProductDisbursement_Min_Order_By>;
  stddev?: InputMaybe<ProductDisbursement_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProductDisbursement_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProductDisbursement_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProductDisbursement_Sum_Order_By>;
  var_pop?: InputMaybe<ProductDisbursement_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProductDisbursement_Var_Samp_Order_By>;
  variance?: InputMaybe<ProductDisbursement_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_disbursement" */
export type ProductDisbursement_Arr_Rel_Insert_Input = {
  data: Array<ProductDisbursement_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductDisbursement_On_Conflict>;
};

/** aggregate avg on columns */
export type ProductDisbursement_Avg_Fields = {
  __typename?: 'productDisbursement_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_disbursement" */
export type ProductDisbursement_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_disbursement". All fields are combined with a logical 'AND'. */
export type ProductDisbursement_Bool_Exp = {
  _and?: InputMaybe<Array<ProductDisbursement_Bool_Exp>>;
  _not?: InputMaybe<ProductDisbursement_Bool_Exp>;
  _or?: InputMaybe<Array<ProductDisbursement_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  coverageMonthsEnd?: InputMaybe<Int_Comparison_Exp>;
  coverageMonthsStart?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  disbursementCode?: InputMaybe<String_Comparison_Exp>;
  disbursementType?: InputMaybe<DisbursementType_Bool_Exp>;
  disbursementTypeId?: InputMaybe<Int_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payee?: InputMaybe<Payee_Bool_Exp>;
  payeeId?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_disbursement" */
export enum ProductDisbursement_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductDisbursementPkey = 'product_disbursement_pkey'
}

/** input type for incrementing numeric columns in table "product_disbursement" */
export type ProductDisbursement_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  disbursementTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_disbursement" */
export type ProductDisbursement_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  disbursementCode?: InputMaybe<Scalars['String']>;
  disbursementType?: InputMaybe<DisbursementType_Obj_Rel_Insert_Input>;
  disbursementTypeId?: InputMaybe<Scalars['Int']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  payee?: InputMaybe<Payee_Obj_Rel_Insert_Input>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ProductDisbursement_Max_Fields = {
  __typename?: 'productDisbursement_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  disbursementCode?: Maybe<Scalars['String']>;
  disbursementTypeId?: Maybe<Scalars['Int']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "product_disbursement" */
export type ProductDisbursement_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  disbursementCode?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProductDisbursement_Min_Fields = {
  __typename?: 'productDisbursement_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  disbursementCode?: Maybe<Scalars['String']>;
  disbursementTypeId?: Maybe<Scalars['Int']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "product_disbursement" */
export type ProductDisbursement_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  disbursementCode?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_disbursement" */
export type ProductDisbursement_Mutation_Response = {
  __typename?: 'productDisbursement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductDisbursement>;
};

/** on_conflict condition type for table "product_disbursement" */
export type ProductDisbursement_On_Conflict = {
  constraint: ProductDisbursement_Constraint;
  update_columns?: Array<ProductDisbursement_Update_Column>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};

/** Ordering options when selecting data from "product_disbursement". */
export type ProductDisbursement_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  disbursementCode?: InputMaybe<Order_By>;
  disbursementType?: InputMaybe<DisbursementType_Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payee?: InputMaybe<Payee_Order_By>;
  payeeId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_disbursement */
export type ProductDisbursement_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_disbursement" */
export enum ProductDisbursement_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CoverageMonthsEnd = 'coverageMonthsEnd',
  /** column name */
  CoverageMonthsStart = 'coverageMonthsStart',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisbursementCode = 'disbursementCode',
  /** column name */
  DisbursementTypeId = 'disbursementTypeId',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  PayeeId = 'payeeId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "product_disbursement" */
export type ProductDisbursement_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  disbursementCode?: InputMaybe<Scalars['String']>;
  disbursementTypeId?: InputMaybe<Scalars['Int']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ProductDisbursement_Stddev_Fields = {
  __typename?: 'productDisbursement_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_disbursement" */
export type ProductDisbursement_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProductDisbursement_Stddev_Pop_Fields = {
  __typename?: 'productDisbursement_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_disbursement" */
export type ProductDisbursement_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProductDisbursement_Stddev_Samp_Fields = {
  __typename?: 'productDisbursement_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_disbursement" */
export type ProductDisbursement_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "productDisbursement" */
export type ProductDisbursement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductDisbursement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductDisbursement_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  coverageMonthsEnd?: InputMaybe<Scalars['Int']>;
  coverageMonthsStart?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  disbursementCode?: InputMaybe<Scalars['String']>;
  disbursementTypeId?: InputMaybe<Scalars['Int']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The accounting.payee this disbursement pays. Nullable until existing rows are backfilled; disbursement_code is kept alongside it. */
  payeeId?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ProductDisbursement_Sum_Fields = {
  __typename?: 'productDisbursement_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  coverageMonthsEnd?: Maybe<Scalars['Int']>;
  coverageMonthsStart?: Maybe<Scalars['Int']>;
  disbursementTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product_disbursement" */
export type ProductDisbursement_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "product_disbursement" */
export enum ProductDisbursement_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CoverageMonthsEnd = 'coverageMonthsEnd',
  /** column name */
  CoverageMonthsStart = 'coverageMonthsStart',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisbursementCode = 'disbursementCode',
  /** column name */
  DisbursementTypeId = 'disbursementTypeId',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  PayeeId = 'payeeId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ProductDisbursement_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProductDisbursement_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductDisbursement_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProductDisbursement_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProductDisbursement_Var_Pop_Fields = {
  __typename?: 'productDisbursement_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_disbursement" */
export type ProductDisbursement_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProductDisbursement_Var_Samp_Fields = {
  __typename?: 'productDisbursement_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_disbursement" */
export type ProductDisbursement_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProductDisbursement_Variance_Fields = {
  __typename?: 'productDisbursement_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  coverageMonthsEnd?: Maybe<Scalars['Float']>;
  coverageMonthsStart?: Maybe<Scalars['Float']>;
  disbursementTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_disbursement" */
export type ProductDisbursement_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  coverageMonthsEnd?: InputMaybe<Order_By>;
  coverageMonthsStart?: InputMaybe<Order_By>;
  disbursementTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_eligibility_rule" */
export type ProductEligibility = {
  __typename?: 'productEligibility';
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  eligibilityRule: EligibilityRule;
  eligibilityRuleId: Scalars['uuid'];
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  isInclusion: Scalars['Boolean'];
  /** An object relationship */
  product: Product;
  productId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "product_eligibility_rule" */
export type ProductEligibility_Aggregate = {
  __typename?: 'productEligibility_aggregate';
  aggregate?: Maybe<ProductEligibility_Aggregate_Fields>;
  nodes: Array<ProductEligibility>;
};

export type ProductEligibility_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ProductEligibility_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ProductEligibility_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ProductEligibility_Aggregate_Bool_Exp_Count>;
};

export type ProductEligibility_Aggregate_Bool_Exp_Bool_And = {
  arguments: ProductEligibility_Select_Column_ProductEligibility_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductEligibility_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ProductEligibility_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ProductEligibility_Select_Column_ProductEligibility_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductEligibility_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ProductEligibility_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProductEligibility_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductEligibility_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_eligibility_rule" */
export type ProductEligibility_Aggregate_Fields = {
  __typename?: 'productEligibility_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProductEligibility_Max_Fields>;
  min?: Maybe<ProductEligibility_Min_Fields>;
};


/** aggregate fields of "product_eligibility_rule" */
export type ProductEligibility_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductEligibility_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_eligibility_rule" */
export type ProductEligibility_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProductEligibility_Max_Order_By>;
  min?: InputMaybe<ProductEligibility_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_eligibility_rule" */
export type ProductEligibility_Arr_Rel_Insert_Input = {
  data: Array<ProductEligibility_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductEligibility_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_eligibility_rule". All fields are combined with a logical 'AND'. */
export type ProductEligibility_Bool_Exp = {
  _and?: InputMaybe<Array<ProductEligibility_Bool_Exp>>;
  _not?: InputMaybe<ProductEligibility_Bool_Exp>;
  _or?: InputMaybe<Array<ProductEligibility_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  eligibilityRule?: InputMaybe<EligibilityRule_Bool_Exp>;
  eligibilityRuleId?: InputMaybe<Uuid_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isInclusion?: InputMaybe<Boolean_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_eligibility_rule" */
export enum ProductEligibility_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductEligibilityPkey = 'product_eligibility_pkey'
}

/** input type for inserting data into table "product_eligibility_rule" */
export type ProductEligibility_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  eligibilityRule?: InputMaybe<EligibilityRule_Obj_Rel_Insert_Input>;
  eligibilityRuleId?: InputMaybe<Scalars['uuid']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInclusion?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ProductEligibility_Max_Fields = {
  __typename?: 'productEligibility_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  eligibilityRuleId?: Maybe<Scalars['uuid']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "product_eligibility_rule" */
export type ProductEligibility_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  eligibilityRuleId?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProductEligibility_Min_Fields = {
  __typename?: 'productEligibility_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  eligibilityRuleId?: Maybe<Scalars['uuid']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "product_eligibility_rule" */
export type ProductEligibility_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  eligibilityRuleId?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_eligibility_rule" */
export type ProductEligibility_Mutation_Response = {
  __typename?: 'productEligibility_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductEligibility>;
};

/** on_conflict condition type for table "product_eligibility_rule" */
export type ProductEligibility_On_Conflict = {
  constraint: ProductEligibility_Constraint;
  update_columns?: Array<ProductEligibility_Update_Column>;
  where?: InputMaybe<ProductEligibility_Bool_Exp>;
};

/** Ordering options when selecting data from "product_eligibility_rule". */
export type ProductEligibility_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  eligibilityRule?: InputMaybe<EligibilityRule_Order_By>;
  eligibilityRuleId?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isInclusion?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_eligibility_rule */
export type ProductEligibility_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_eligibility_rule" */
export enum ProductEligibility_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EligibilityRuleId = 'eligibilityRuleId',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsInclusion = 'isInclusion',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "productEligibility_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_eligibility_rule" */
export enum ProductEligibility_Select_Column_ProductEligibility_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsInclusion = 'isInclusion'
}

/** select "productEligibility_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_eligibility_rule" */
export enum ProductEligibility_Select_Column_ProductEligibility_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsInclusion = 'isInclusion'
}

/** input type for updating data in table "product_eligibility_rule" */
export type ProductEligibility_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  eligibilityRuleId?: InputMaybe<Scalars['uuid']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInclusion?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "productEligibility" */
export type ProductEligibility_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductEligibility_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductEligibility_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  eligibilityRuleId?: InputMaybe<Scalars['uuid']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInclusion?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "product_eligibility_rule" */
export enum ProductEligibility_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  EligibilityRuleId = 'eligibilityRuleId',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsInclusion = 'isInclusion',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ProductEligibility_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductEligibility_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProductEligibility_Bool_Exp;
};

/** columns and relationships of "product_obligor" */
export type ProductObligor = {
  __typename?: 'productObligor';
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  obligor?: Maybe<Obligor>;
  obligorId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "product_obligor" */
export type ProductObligor_Aggregate = {
  __typename?: 'productObligor_aggregate';
  aggregate?: Maybe<ProductObligor_Aggregate_Fields>;
  nodes: Array<ProductObligor>;
};

export type ProductObligor_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProductObligor_Aggregate_Bool_Exp_Count>;
};

export type ProductObligor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProductObligor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductObligor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_obligor" */
export type ProductObligor_Aggregate_Fields = {
  __typename?: 'productObligor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProductObligor_Max_Fields>;
  min?: Maybe<ProductObligor_Min_Fields>;
};


/** aggregate fields of "product_obligor" */
export type ProductObligor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductObligor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_obligor" */
export type ProductObligor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProductObligor_Max_Order_By>;
  min?: InputMaybe<ProductObligor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_obligor" */
export type ProductObligor_Arr_Rel_Insert_Input = {
  data: Array<ProductObligor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductObligor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_obligor". All fields are combined with a logical 'AND'. */
export type ProductObligor_Bool_Exp = {
  _and?: InputMaybe<Array<ProductObligor_Bool_Exp>>;
  _not?: InputMaybe<ProductObligor_Bool_Exp>;
  _or?: InputMaybe<Array<ProductObligor_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  obligor?: InputMaybe<Obligor_Bool_Exp>;
  obligorId?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_obligor" */
export enum ProductObligor_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductObligorPkey = 'product_obligor_pkey'
}

/** input type for inserting data into table "product_obligor" */
export type ProductObligor_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  obligor?: InputMaybe<Obligor_Obj_Rel_Insert_Input>;
  obligorId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ProductObligor_Max_Fields = {
  __typename?: 'productObligor_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  obligorId?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "product_obligor" */
export type ProductObligor_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  obligorId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProductObligor_Min_Fields = {
  __typename?: 'productObligor_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  obligorId?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "product_obligor" */
export type ProductObligor_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  obligorId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_obligor" */
export type ProductObligor_Mutation_Response = {
  __typename?: 'productObligor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductObligor>;
};

/** on_conflict condition type for table "product_obligor" */
export type ProductObligor_On_Conflict = {
  constraint: ProductObligor_Constraint;
  update_columns?: Array<ProductObligor_Update_Column>;
  where?: InputMaybe<ProductObligor_Bool_Exp>;
};

/** Ordering options when selecting data from "product_obligor". */
export type ProductObligor_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  obligor?: InputMaybe<Obligor_Order_By>;
  obligorId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_obligor */
export type ProductObligor_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_obligor" */
export enum ProductObligor_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ObligorId = 'obligorId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "product_obligor" */
export type ProductObligor_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  obligorId?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "productObligor" */
export type ProductObligor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductObligor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductObligor_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  obligorId?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "product_obligor" */
export enum ProductObligor_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ObligorId = 'obligorId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ProductObligor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductObligor_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProductObligor_Bool_Exp;
};

/** columns and relationships of "product_rate_bucket" */
export type ProductRateBucket = {
  __typename?: 'productRateBucket';
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  minimumCost?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  product: Product;
  productId: Scalars['uuid'];
  /** An object relationship */
  rateBucketType: RateBucketType;
  rateBucketTypeId: Scalars['Int'];
};

/** aggregated selection of "product_rate_bucket" */
export type ProductRateBucket_Aggregate = {
  __typename?: 'productRateBucket_aggregate';
  aggregate?: Maybe<ProductRateBucket_Aggregate_Fields>;
  nodes: Array<ProductRateBucket>;
};

export type ProductRateBucket_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProductRateBucket_Aggregate_Bool_Exp_Count>;
};

export type ProductRateBucket_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProductRateBucket_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductRateBucket_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_rate_bucket" */
export type ProductRateBucket_Aggregate_Fields = {
  __typename?: 'productRateBucket_aggregate_fields';
  avg?: Maybe<ProductRateBucket_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProductRateBucket_Max_Fields>;
  min?: Maybe<ProductRateBucket_Min_Fields>;
  stddev?: Maybe<ProductRateBucket_Stddev_Fields>;
  stddev_pop?: Maybe<ProductRateBucket_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProductRateBucket_Stddev_Samp_Fields>;
  sum?: Maybe<ProductRateBucket_Sum_Fields>;
  var_pop?: Maybe<ProductRateBucket_Var_Pop_Fields>;
  var_samp?: Maybe<ProductRateBucket_Var_Samp_Fields>;
  variance?: Maybe<ProductRateBucket_Variance_Fields>;
};


/** aggregate fields of "product_rate_bucket" */
export type ProductRateBucket_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductRateBucket_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_rate_bucket" */
export type ProductRateBucket_Aggregate_Order_By = {
  avg?: InputMaybe<ProductRateBucket_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProductRateBucket_Max_Order_By>;
  min?: InputMaybe<ProductRateBucket_Min_Order_By>;
  stddev?: InputMaybe<ProductRateBucket_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProductRateBucket_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProductRateBucket_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProductRateBucket_Sum_Order_By>;
  var_pop?: InputMaybe<ProductRateBucket_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProductRateBucket_Var_Samp_Order_By>;
  variance?: InputMaybe<ProductRateBucket_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_rate_bucket" */
export type ProductRateBucket_Arr_Rel_Insert_Input = {
  data: Array<ProductRateBucket_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductRateBucket_On_Conflict>;
};

/** aggregate avg on columns */
export type ProductRateBucket_Avg_Fields = {
  __typename?: 'productRateBucket_avg_fields';
  minimumCost?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_rate_bucket" */
export type ProductRateBucket_Avg_Order_By = {
  minimumCost?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_rate_bucket". All fields are combined with a logical 'AND'. */
export type ProductRateBucket_Bool_Exp = {
  _and?: InputMaybe<Array<ProductRateBucket_Bool_Exp>>;
  _not?: InputMaybe<ProductRateBucket_Bool_Exp>;
  _or?: InputMaybe<Array<ProductRateBucket_Bool_Exp>>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  minimumCost?: InputMaybe<Numeric_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  rateBucketType?: InputMaybe<RateBucketType_Bool_Exp>;
  rateBucketTypeId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_rate_bucket" */
export enum ProductRateBucket_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductRateBucketPkey = 'product_rate_bucket_pkey'
}

/** input type for incrementing numeric columns in table "product_rate_bucket" */
export type ProductRateBucket_Inc_Input = {
  minimumCost?: InputMaybe<Scalars['numeric']>;
  rateBucketTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_rate_bucket" */
export type ProductRateBucket_Insert_Input = {
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  minimumCost?: InputMaybe<Scalars['numeric']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  rateBucketType?: InputMaybe<RateBucketType_Obj_Rel_Insert_Input>;
  rateBucketTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ProductRateBucket_Max_Fields = {
  __typename?: 'productRateBucket_max_fields';
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  minimumCost?: Maybe<Scalars['numeric']>;
  productId?: Maybe<Scalars['uuid']>;
  rateBucketTypeId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "product_rate_bucket" */
export type ProductRateBucket_Max_Order_By = {
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minimumCost?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProductRateBucket_Min_Fields = {
  __typename?: 'productRateBucket_min_fields';
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  minimumCost?: Maybe<Scalars['numeric']>;
  productId?: Maybe<Scalars['uuid']>;
  rateBucketTypeId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "product_rate_bucket" */
export type ProductRateBucket_Min_Order_By = {
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minimumCost?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_rate_bucket" */
export type ProductRateBucket_Mutation_Response = {
  __typename?: 'productRateBucket_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductRateBucket>;
};

/** on_conflict condition type for table "product_rate_bucket" */
export type ProductRateBucket_On_Conflict = {
  constraint: ProductRateBucket_Constraint;
  update_columns?: Array<ProductRateBucket_Update_Column>;
  where?: InputMaybe<ProductRateBucket_Bool_Exp>;
};

/** Ordering options when selecting data from "product_rate_bucket". */
export type ProductRateBucket_Order_By = {
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minimumCost?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  rateBucketType?: InputMaybe<RateBucketType_Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_rate_bucket */
export type ProductRateBucket_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_rate_bucket" */
export enum ProductRateBucket_Select_Column {
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  MinimumCost = 'minimumCost',
  /** column name */
  ProductId = 'productId',
  /** column name */
  RateBucketTypeId = 'rateBucketTypeId'
}

/** input type for updating data in table "product_rate_bucket" */
export type ProductRateBucket_Set_Input = {
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  minimumCost?: InputMaybe<Scalars['numeric']>;
  productId?: InputMaybe<Scalars['uuid']>;
  rateBucketTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ProductRateBucket_Stddev_Fields = {
  __typename?: 'productRateBucket_stddev_fields';
  minimumCost?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_rate_bucket" */
export type ProductRateBucket_Stddev_Order_By = {
  minimumCost?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProductRateBucket_Stddev_Pop_Fields = {
  __typename?: 'productRateBucket_stddev_pop_fields';
  minimumCost?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_rate_bucket" */
export type ProductRateBucket_Stddev_Pop_Order_By = {
  minimumCost?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProductRateBucket_Stddev_Samp_Fields = {
  __typename?: 'productRateBucket_stddev_samp_fields';
  minimumCost?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_rate_bucket" */
export type ProductRateBucket_Stddev_Samp_Order_By = {
  minimumCost?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "productRateBucket" */
export type ProductRateBucket_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductRateBucket_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductRateBucket_Stream_Cursor_Value_Input = {
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  minimumCost?: InputMaybe<Scalars['numeric']>;
  productId?: InputMaybe<Scalars['uuid']>;
  rateBucketTypeId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ProductRateBucket_Sum_Fields = {
  __typename?: 'productRateBucket_sum_fields';
  minimumCost?: Maybe<Scalars['numeric']>;
  rateBucketTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product_rate_bucket" */
export type ProductRateBucket_Sum_Order_By = {
  minimumCost?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "product_rate_bucket" */
export enum ProductRateBucket_Update_Column {
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  MinimumCost = 'minimumCost',
  /** column name */
  ProductId = 'productId',
  /** column name */
  RateBucketTypeId = 'rateBucketTypeId'
}

export type ProductRateBucket_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProductRateBucket_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductRateBucket_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProductRateBucket_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProductRateBucket_Var_Pop_Fields = {
  __typename?: 'productRateBucket_var_pop_fields';
  minimumCost?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_rate_bucket" */
export type ProductRateBucket_Var_Pop_Order_By = {
  minimumCost?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProductRateBucket_Var_Samp_Fields = {
  __typename?: 'productRateBucket_var_samp_fields';
  minimumCost?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_rate_bucket" */
export type ProductRateBucket_Var_Samp_Order_By = {
  minimumCost?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProductRateBucket_Variance_Fields = {
  __typename?: 'productRateBucket_variance_fields';
  minimumCost?: Maybe<Scalars['Float']>;
  rateBucketTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_rate_bucket" */
export type ProductRateBucket_Variance_Order_By = {
  minimumCost?: InputMaybe<Order_By>;
  rateBucketTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_surcharge_type" */
export type ProductSurchargeType = {
  __typename?: 'productSurchargeType';
  cost?: Maybe<Scalars['numeric']>;
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  product: Product;
  productId: Scalars['uuid'];
  /** An object relationship */
  surchargeType: SurchargeType;
  surchargeTypeId: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "product_surcharge_type" */
export type ProductSurchargeType_Aggregate = {
  __typename?: 'productSurchargeType_aggregate';
  aggregate?: Maybe<ProductSurchargeType_Aggregate_Fields>;
  nodes: Array<ProductSurchargeType>;
};

export type ProductSurchargeType_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProductSurchargeType_Aggregate_Bool_Exp_Count>;
};

export type ProductSurchargeType_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProductSurchargeType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductSurchargeType_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_surcharge_type" */
export type ProductSurchargeType_Aggregate_Fields = {
  __typename?: 'productSurchargeType_aggregate_fields';
  avg?: Maybe<ProductSurchargeType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProductSurchargeType_Max_Fields>;
  min?: Maybe<ProductSurchargeType_Min_Fields>;
  stddev?: Maybe<ProductSurchargeType_Stddev_Fields>;
  stddev_pop?: Maybe<ProductSurchargeType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProductSurchargeType_Stddev_Samp_Fields>;
  sum?: Maybe<ProductSurchargeType_Sum_Fields>;
  var_pop?: Maybe<ProductSurchargeType_Var_Pop_Fields>;
  var_samp?: Maybe<ProductSurchargeType_Var_Samp_Fields>;
  variance?: Maybe<ProductSurchargeType_Variance_Fields>;
};


/** aggregate fields of "product_surcharge_type" */
export type ProductSurchargeType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductSurchargeType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_surcharge_type" */
export type ProductSurchargeType_Aggregate_Order_By = {
  avg?: InputMaybe<ProductSurchargeType_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProductSurchargeType_Max_Order_By>;
  min?: InputMaybe<ProductSurchargeType_Min_Order_By>;
  stddev?: InputMaybe<ProductSurchargeType_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProductSurchargeType_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProductSurchargeType_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProductSurchargeType_Sum_Order_By>;
  var_pop?: InputMaybe<ProductSurchargeType_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProductSurchargeType_Var_Samp_Order_By>;
  variance?: InputMaybe<ProductSurchargeType_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_surcharge_type" */
export type ProductSurchargeType_Arr_Rel_Insert_Input = {
  data: Array<ProductSurchargeType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductSurchargeType_On_Conflict>;
};

/** aggregate avg on columns */
export type ProductSurchargeType_Avg_Fields = {
  __typename?: 'productSurchargeType_avg_fields';
  cost?: Maybe<Scalars['Float']>;
  surchargeTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_surcharge_type" */
export type ProductSurchargeType_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_surcharge_type". All fields are combined with a logical 'AND'. */
export type ProductSurchargeType_Bool_Exp = {
  _and?: InputMaybe<Array<ProductSurchargeType_Bool_Exp>>;
  _not?: InputMaybe<ProductSurchargeType_Bool_Exp>;
  _or?: InputMaybe<Array<ProductSurchargeType_Bool_Exp>>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  surchargeType?: InputMaybe<SurchargeType_Bool_Exp>;
  surchargeTypeId?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_surcharge_type" */
export enum ProductSurchargeType_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductSurchargeTypePkey = 'product_surcharge_type_pkey'
}

/** input type for incrementing numeric columns in table "product_surcharge_type" */
export type ProductSurchargeType_Inc_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  surchargeTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_surcharge_type" */
export type ProductSurchargeType_Insert_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  surchargeType?: InputMaybe<SurchargeType_Obj_Rel_Insert_Input>;
  surchargeTypeId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ProductSurchargeType_Max_Fields = {
  __typename?: 'productSurchargeType_max_fields';
  cost?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  surchargeTypeId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "product_surcharge_type" */
export type ProductSurchargeType_Max_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProductSurchargeType_Min_Fields = {
  __typename?: 'productSurchargeType_min_fields';
  cost?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  surchargeTypeId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "product_surcharge_type" */
export type ProductSurchargeType_Min_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_surcharge_type" */
export type ProductSurchargeType_Mutation_Response = {
  __typename?: 'productSurchargeType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductSurchargeType>;
};

/** on_conflict condition type for table "product_surcharge_type" */
export type ProductSurchargeType_On_Conflict = {
  constraint: ProductSurchargeType_Constraint;
  update_columns?: Array<ProductSurchargeType_Update_Column>;
  where?: InputMaybe<ProductSurchargeType_Bool_Exp>;
};

/** Ordering options when selecting data from "product_surcharge_type". */
export type ProductSurchargeType_Order_By = {
  cost?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  surchargeType?: InputMaybe<SurchargeType_Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_surcharge_type */
export type ProductSurchargeType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_surcharge_type" */
export enum ProductSurchargeType_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'productId',
  /** column name */
  SurchargeTypeId = 'surchargeTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "product_surcharge_type" */
export type ProductSurchargeType_Set_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  surchargeTypeId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ProductSurchargeType_Stddev_Fields = {
  __typename?: 'productSurchargeType_stddev_fields';
  cost?: Maybe<Scalars['Float']>;
  surchargeTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_surcharge_type" */
export type ProductSurchargeType_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProductSurchargeType_Stddev_Pop_Fields = {
  __typename?: 'productSurchargeType_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  surchargeTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_surcharge_type" */
export type ProductSurchargeType_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProductSurchargeType_Stddev_Samp_Fields = {
  __typename?: 'productSurchargeType_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  surchargeTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_surcharge_type" */
export type ProductSurchargeType_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "productSurchargeType" */
export type ProductSurchargeType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductSurchargeType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductSurchargeType_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  surchargeTypeId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ProductSurchargeType_Sum_Fields = {
  __typename?: 'productSurchargeType_sum_fields';
  cost?: Maybe<Scalars['numeric']>;
  surchargeTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product_surcharge_type" */
export type ProductSurchargeType_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "product_surcharge_type" */
export enum ProductSurchargeType_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'productId',
  /** column name */
  SurchargeTypeId = 'surchargeTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ProductSurchargeType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProductSurchargeType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductSurchargeType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProductSurchargeType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProductSurchargeType_Var_Pop_Fields = {
  __typename?: 'productSurchargeType_var_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  surchargeTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_surcharge_type" */
export type ProductSurchargeType_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProductSurchargeType_Var_Samp_Fields = {
  __typename?: 'productSurchargeType_var_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  surchargeTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_surcharge_type" */
export type ProductSurchargeType_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProductSurchargeType_Variance_Fields = {
  __typename?: 'productSurchargeType_variance_fields';
  cost?: Maybe<Scalars['Float']>;
  surchargeTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_surcharge_type" */
export type ProductSurchargeType_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
  surchargeTypeId?: InputMaybe<Order_By>;
};

/** aggregated selection of "product" */
export type Product_Aggregate = {
  __typename?: 'product_aggregate';
  aggregate?: Maybe<Product_Aggregate_Fields>;
  nodes: Array<Product>;
};

export type Product_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Aggregate_Bool_Exp_Count>;
};

export type Product_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product" */
export type Product_Aggregate_Fields = {
  __typename?: 'product_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Product_Max_Fields>;
  min?: Maybe<Product_Min_Fields>;
};


/** aggregate fields of "product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product" */
export type Product_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Max_Order_By>;
  min?: InputMaybe<Product_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Product_Append_Input = {
  expirationCalculationMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "product" */
export type Product_Arr_Rel_Insert_Input = {
  data: Array<Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bool_Exp>>;
  _not?: InputMaybe<Product_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bool_Exp>>;
  accountDisbursements?: InputMaybe<AccountDisbursement_Bool_Exp>;
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Bool_Exp>;
  accountProducts?: InputMaybe<AccountProduct_Bool_Exp>;
  accountProducts_aggregate?: InputMaybe<AccountProduct_Aggregate_Bool_Exp>;
  accountRetails?: InputMaybe<AccountRetail_Bool_Exp>;
  accountRetails_aggregate?: InputMaybe<AccountRetail_Aggregate_Bool_Exp>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  childCompositeProducts?: InputMaybe<CompositeProduct_Bool_Exp>;
  childCompositeProducts_aggregate?: InputMaybe<CompositeProduct_Aggregate_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Bool_Exp>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Bool_Exp>;
  entityOfferings?: InputMaybe<EntityOffering_Bool_Exp>;
  entityOfferings_aggregate?: InputMaybe<EntityOffering_Aggregate_Bool_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  expirationCalculationMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  formCode?: InputMaybe<String_Comparison_Exp>;
  friendlyName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isArchived?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parentCompositeProducts?: InputMaybe<CompositeProduct_Bool_Exp>;
  parentCompositeProducts_aggregate?: InputMaybe<CompositeProduct_Aggregate_Bool_Exp>;
  policyContracts?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Bool_Exp>;
  productAttributes?: InputMaybe<ProductAttribute_Bool_Exp>;
  productAttributes_aggregate?: InputMaybe<ProductAttribute_Aggregate_Bool_Exp>;
  productClassGuides?: InputMaybe<ProductClassGuide_Bool_Exp>;
  productClassGuides_aggregate?: InputMaybe<ProductClassGuide_Aggregate_Bool_Exp>;
  productContractForms?: InputMaybe<ProductContractForm_Bool_Exp>;
  productContractForms_aggregate?: InputMaybe<ProductContractForm_Aggregate_Bool_Exp>;
  productCosts?: InputMaybe<ProductCost_Bool_Exp>;
  productCosts_aggregate?: InputMaybe<ProductCost_Aggregate_Bool_Exp>;
  productDisbursements?: InputMaybe<ProductDisbursement_Bool_Exp>;
  productDisbursements_aggregate?: InputMaybe<ProductDisbursement_Aggregate_Bool_Exp>;
  productEligibilities?: InputMaybe<ProductEligibility_Bool_Exp>;
  productEligibilities_aggregate?: InputMaybe<ProductEligibility_Aggregate_Bool_Exp>;
  productObligors?: InputMaybe<ProductObligor_Bool_Exp>;
  productObligors_aggregate?: InputMaybe<ProductObligor_Aggregate_Bool_Exp>;
  productRateBuckets?: InputMaybe<ProductRateBucket_Bool_Exp>;
  productRateBuckets_aggregate?: InputMaybe<ProductRateBucket_Aggregate_Bool_Exp>;
  productSurchargeTypes?: InputMaybe<ProductSurchargeType_Bool_Exp>;
  productSurchargeTypes_aggregate?: InputMaybe<ProductSurchargeType_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product" */
export enum Product_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPkey = 'product_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Product_Delete_At_Path_Input = {
  expirationCalculationMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Product_Delete_Elem_Input = {
  expirationCalculationMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Product_Delete_Key_Input = {
  expirationCalculationMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "product" */
export type Product_Insert_Input = {
  accountDisbursements?: InputMaybe<AccountDisbursement_Arr_Rel_Insert_Input>;
  accountProducts?: InputMaybe<AccountProduct_Arr_Rel_Insert_Input>;
  accountRetails?: InputMaybe<AccountRetail_Arr_Rel_Insert_Input>;
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  childCompositeProducts?: InputMaybe<CompositeProduct_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Arr_Rel_Insert_Input>;
  entityEligibilityRules?: InputMaybe<EntityEligibilityRule_Arr_Rel_Insert_Input>;
  entityOfferings?: InputMaybe<EntityOffering_Arr_Rel_Insert_Input>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  expirationCalculationMetadata?: InputMaybe<Scalars['jsonb']>;
  formCode?: InputMaybe<Scalars['String']>;
  friendlyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentCompositeProducts?: InputMaybe<CompositeProduct_Arr_Rel_Insert_Input>;
  policyContracts?: InputMaybe<PolicyContract_Arr_Rel_Insert_Input>;
  productAttributes?: InputMaybe<ProductAttribute_Arr_Rel_Insert_Input>;
  productClassGuides?: InputMaybe<ProductClassGuide_Arr_Rel_Insert_Input>;
  productContractForms?: InputMaybe<ProductContractForm_Arr_Rel_Insert_Input>;
  productCosts?: InputMaybe<ProductCost_Arr_Rel_Insert_Input>;
  productDisbursements?: InputMaybe<ProductDisbursement_Arr_Rel_Insert_Input>;
  productEligibilities?: InputMaybe<ProductEligibility_Arr_Rel_Insert_Input>;
  productObligors?: InputMaybe<ProductObligor_Arr_Rel_Insert_Input>;
  productRateBuckets?: InputMaybe<ProductRateBucket_Arr_Rel_Insert_Input>;
  productSurchargeTypes?: InputMaybe<ProductSurchargeType_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Product_Max_Fields = {
  __typename?: 'product_max_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  formCode?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "product" */
export type Product_Max_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  formCode?: InputMaybe<Order_By>;
  friendlyName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Min_Fields = {
  __typename?: 'product_min_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  formCode?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "product" */
export type Product_Min_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  formCode?: InputMaybe<Order_By>;
  friendlyName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product" */
export type Product_Mutation_Response = {
  __typename?: 'product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product>;
};

/** input type for inserting object relation for remote table "product" */
export type Product_Obj_Rel_Insert_Input = {
  data: Product_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** on_conflict condition type for table "product" */
export type Product_On_Conflict = {
  constraint: Product_Constraint;
  update_columns?: Array<Product_Update_Column>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Order_By>;
  accountProducts_aggregate?: InputMaybe<AccountProduct_Aggregate_Order_By>;
  accountRetails_aggregate?: InputMaybe<AccountRetail_Aggregate_Order_By>;
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  childCompositeProducts_aggregate?: InputMaybe<CompositeProduct_Aggregate_Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Order_By>;
  entityEligibilityRules_aggregate?: InputMaybe<EntityEligibilityRule_Aggregate_Order_By>;
  entityOfferings_aggregate?: InputMaybe<EntityOffering_Aggregate_Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  expirationCalculationMetadata?: InputMaybe<Order_By>;
  formCode?: InputMaybe<Order_By>;
  friendlyName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isArchived?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentCompositeProducts_aggregate?: InputMaybe<CompositeProduct_Aggregate_Order_By>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Order_By>;
  productAttributes_aggregate?: InputMaybe<ProductAttribute_Aggregate_Order_By>;
  productClassGuides_aggregate?: InputMaybe<ProductClassGuide_Aggregate_Order_By>;
  productContractForms_aggregate?: InputMaybe<ProductContractForm_Aggregate_Order_By>;
  productCosts_aggregate?: InputMaybe<ProductCost_Aggregate_Order_By>;
  productDisbursements_aggregate?: InputMaybe<ProductDisbursement_Aggregate_Order_By>;
  productEligibilities_aggregate?: InputMaybe<ProductEligibility_Aggregate_Order_By>;
  productObligors_aggregate?: InputMaybe<ProductObligor_Aggregate_Order_By>;
  productRateBuckets_aggregate?: InputMaybe<ProductRateBucket_Aggregate_Order_By>;
  productSurchargeTypes_aggregate?: InputMaybe<ProductSurchargeType_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product */
export type Product_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Product_Prepend_Input = {
  expirationCalculationMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "product" */
export enum Product_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  ExpirationCalculationMetadata = 'expirationCalculationMetadata',
  /** column name */
  FormCode = 'formCode',
  /** column name */
  FriendlyName = 'friendlyName',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'isArchived',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "product_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsArchived = 'isArchived'
}

/** select "product_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsArchived = 'isArchived'
}

/** input type for updating data in table "product" */
export type Product_Set_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expirationCalculationMetadata?: InputMaybe<Scalars['jsonb']>;
  formCode?: InputMaybe<Scalars['String']>;
  friendlyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expirationCalculationMetadata?: InputMaybe<Scalars['jsonb']>;
  formCode?: InputMaybe<Scalars['String']>;
  friendlyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "product" */
export enum Product_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  ExpirationCalculationMetadata = 'expirationCalculationMetadata',
  /** column name */
  FormCode = 'formCode',
  /** column name */
  FriendlyName = 'friendlyName',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'isArchived',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Product_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Product_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Product_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Product_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Product_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Product_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Bool_Exp;
};

/**
 * Per-user profile data keyed by the Kratos identity id. One row per identity.
 * Written by the MBP.Api OIDC sign-in webhook (profile photo capture) and, in the
 * future, by user photo upload. This is user-domain data — NOT the legacy
 * MSSQL-mastered auth.user_profile mirror. See
 * docs/adr/0009-auth-vs-users-schema-boundary.md.
 */
export type Profile = {
  __typename?: 'profile';
  /** Timestamp the row was created. */
  createdAt: Scalars['timestamptz'];
  /** Primary key. */
  id: Scalars['uuid'];
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Unique: one profile row per identity. Apps look up avatars by this column.
   */
  identityId: Scalars['uuid'];
  /**
   * Path of the profile photo relative to the CDN web root (/avatars/<unguessable-name>.<ext>).
   * Deliberately NOT an absolute URL: the database is copied between environments, and a stored
   * https://cdn.<domain>/... would point a refreshed QAT at the PRD CDN. Callers build the URL as
   * https://cdn.<DOMAIN_NAME><path>. The file itself is served to anyone holding the link; the
   * unguessable name is the only thing protecting it, so never expose this column to a role that
   * should not see whose photo it is. The /avatars/ directory listing is blocked in the Caddy config of the cdn service
   * so the names cannot be enumerated. Where the photo came from is deliberately not recorded: the
   * last writer wins, and the product only needs an image to display.
   */
  profilePhotoPath?: Maybe<Scalars['String']>;
  /** Timestamp the row was last updated (maintained by trigger). */
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "users.profile" */
export type Profile_Aggregate = {
  __typename?: 'profile_aggregate';
  aggregate?: Maybe<Profile_Aggregate_Fields>;
  nodes: Array<Profile>;
};

/** aggregate fields of "users.profile" */
export type Profile_Aggregate_Fields = {
  __typename?: 'profile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Profile_Max_Fields>;
  min?: Maybe<Profile_Min_Fields>;
};


/** aggregate fields of "users.profile" */
export type Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "users.profile". All fields are combined with a logical 'AND'. */
export type Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Profile_Bool_Exp>>;
  _not?: InputMaybe<Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Profile_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  profilePhotoPath?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "users.profile" */
export enum Profile_Constraint {
  /** unique or primary key constraint on columns "identity_id" */
  ProfileIdentityIdKey = 'profile_identity_id_key',
  /** unique or primary key constraint on columns "id" */
  ProfilePkey = 'profile_pkey'
}

/** input type for inserting data into table "users.profile" */
export type Profile_Insert_Input = {
  /** Timestamp the row was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Unique: one profile row per identity. Apps look up avatars by this column.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /**
   * Path of the profile photo relative to the CDN web root (/avatars/<unguessable-name>.<ext>).
   * Deliberately NOT an absolute URL: the database is copied between environments, and a stored
   * https://cdn.<domain>/... would point a refreshed QAT at the PRD CDN. Callers build the URL as
   * https://cdn.<DOMAIN_NAME><path>. The file itself is served to anyone holding the link; the
   * unguessable name is the only thing protecting it, so never expose this column to a role that
   * should not see whose photo it is. The /avatars/ directory listing is blocked in the Caddy config of the cdn service
   * so the names cannot be enumerated. Where the photo came from is deliberately not recorded: the
   * last writer wins, and the product only needs an image to display.
   */
  profilePhotoPath?: InputMaybe<Scalars['String']>;
  /** Timestamp the row was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Profile_Max_Fields = {
  __typename?: 'profile_max_fields';
  /** Timestamp the row was created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Unique: one profile row per identity. Apps look up avatars by this column.
   */
  identityId?: Maybe<Scalars['uuid']>;
  /**
   * Path of the profile photo relative to the CDN web root (/avatars/<unguessable-name>.<ext>).
   * Deliberately NOT an absolute URL: the database is copied between environments, and a stored
   * https://cdn.<domain>/... would point a refreshed QAT at the PRD CDN. Callers build the URL as
   * https://cdn.<DOMAIN_NAME><path>. The file itself is served to anyone holding the link; the
   * unguessable name is the only thing protecting it, so never expose this column to a role that
   * should not see whose photo it is. The /avatars/ directory listing is blocked in the Caddy config of the cdn service
   * so the names cannot be enumerated. Where the photo came from is deliberately not recorded: the
   * last writer wins, and the product only needs an image to display.
   */
  profilePhotoPath?: Maybe<Scalars['String']>;
  /** Timestamp the row was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Profile_Min_Fields = {
  __typename?: 'profile_min_fields';
  /** Timestamp the row was created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Unique: one profile row per identity. Apps look up avatars by this column.
   */
  identityId?: Maybe<Scalars['uuid']>;
  /**
   * Path of the profile photo relative to the CDN web root (/avatars/<unguessable-name>.<ext>).
   * Deliberately NOT an absolute URL: the database is copied between environments, and a stored
   * https://cdn.<domain>/... would point a refreshed QAT at the PRD CDN. Callers build the URL as
   * https://cdn.<DOMAIN_NAME><path>. The file itself is served to anyone holding the link; the
   * unguessable name is the only thing protecting it, so never expose this column to a role that
   * should not see whose photo it is. The /avatars/ directory listing is blocked in the Caddy config of the cdn service
   * so the names cannot be enumerated. Where the photo came from is deliberately not recorded: the
   * last writer wins, and the product only needs an image to display.
   */
  profilePhotoPath?: Maybe<Scalars['String']>;
  /** Timestamp the row was last updated (maintained by trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "users.profile" */
export type Profile_Mutation_Response = {
  __typename?: 'profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Profile>;
};

/** input type for inserting object relation for remote table "users.profile" */
export type Profile_Obj_Rel_Insert_Input = {
  data: Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Profile_On_Conflict>;
};

/** on_conflict condition type for table "users.profile" */
export type Profile_On_Conflict = {
  constraint: Profile_Constraint;
  update_columns?: Array<Profile_Update_Column>;
  where?: InputMaybe<Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "users.profile". */
export type Profile_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  profilePhotoPath?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users.profile */
export type Profile_Pk_Columns_Input = {
  /** Primary key. */
  id: Scalars['uuid'];
};

/** select columns of table "users.profile" */
export enum Profile_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  ProfilePhotoPath = 'profilePhotoPath',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "users.profile" */
export type Profile_Set_Input = {
  /** Timestamp the row was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Unique: one profile row per identity. Apps look up avatars by this column.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /**
   * Path of the profile photo relative to the CDN web root (/avatars/<unguessable-name>.<ext>).
   * Deliberately NOT an absolute URL: the database is copied between environments, and a stored
   * https://cdn.<domain>/... would point a refreshed QAT at the PRD CDN. Callers build the URL as
   * https://cdn.<DOMAIN_NAME><path>. The file itself is served to anyone holding the link; the
   * unguessable name is the only thing protecting it, so never expose this column to a role that
   * should not see whose photo it is. The /avatars/ directory listing is blocked in the Caddy config of the cdn service
   * so the names cannot be enumerated. Where the photo came from is deliberately not recorded: the
   * last writer wins, and the product only needs an image to display.
   */
  profilePhotoPath?: InputMaybe<Scalars['String']>;
  /** Timestamp the row was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "profile" */
export type Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Profile_Stream_Cursor_Value_Input = {
  /** Timestamp the row was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Logical reference to the Kratos identity (ory identities table in the kratos database).
   * No FK is enforced because the identity is mastered by Kratos in a separate database.
   * Unique: one profile row per identity. Apps look up avatars by this column.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /**
   * Path of the profile photo relative to the CDN web root (/avatars/<unguessable-name>.<ext>).
   * Deliberately NOT an absolute URL: the database is copied between environments, and a stored
   * https://cdn.<domain>/... would point a refreshed QAT at the PRD CDN. Callers build the URL as
   * https://cdn.<DOMAIN_NAME><path>. The file itself is served to anyone holding the link; the
   * unguessable name is the only thing protecting it, so never expose this column to a role that
   * should not see whose photo it is. The /avatars/ directory listing is blocked in the Caddy config of the cdn service
   * so the names cannot be enumerated. Where the photo came from is deliberately not recorded: the
   * last writer wins, and the product only needs an image to display.
   */
  profilePhotoPath?: InputMaybe<Scalars['String']>;
  /** Timestamp the row was last updated (maintained by trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "users.profile" */
export enum Profile_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  ProfilePhotoPath = 'profilePhotoPath',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Profile_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Profile_Bool_Exp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "vpic.abs" */
  ABS: Array<Abs_Vpic>;
  /** fetch aggregated fields from the table: "vpic.abs" */
  ABS_aggregate: Abs_Aggregate_Vpic;
  /** fetch data from the table: "vpic.abs" using primary key columns */
  ABS_by_pk?: Maybe<Abs_Vpic>;
  /** fetch data from the table: "vpic.adaptivecruisecontrol" */
  AdaptiveCruiseControl: Array<AdaptiveCruiseControl_Vpic>;
  /** fetch aggregated fields from the table: "vpic.adaptivecruisecontrol" */
  AdaptiveCruiseControl_aggregate: AdaptiveCruiseControl_Aggregate_Vpic;
  /** fetch data from the table: "vpic.adaptivecruisecontrol" using primary key columns */
  AdaptiveCruiseControl_by_pk?: Maybe<AdaptiveCruiseControl_Vpic>;
  /** fetch data from the table: "vpic.adaptivedrivingbeam" */
  AdaptiveDrivingBeam: Array<AdaptiveDrivingBeam_Vpic>;
  /** fetch aggregated fields from the table: "vpic.adaptivedrivingbeam" */
  AdaptiveDrivingBeam_aggregate: AdaptiveDrivingBeam_Aggregate_Vpic;
  /** fetch data from the table: "vpic.adaptivedrivingbeam" using primary key columns */
  AdaptiveDrivingBeam_by_pk?: Maybe<AdaptiveDrivingBeam_Vpic>;
  /** fetch data from the table: "vpic.airbaglocfront" */
  AirBagLocFront: Array<AirBagLocFront_Vpic>;
  /** fetch aggregated fields from the table: "vpic.airbaglocfront" */
  AirBagLocFront_aggregate: AirBagLocFront_Aggregate_Vpic;
  /** fetch data from the table: "vpic.airbaglocfront" using primary key columns */
  AirBagLocFront_by_pk?: Maybe<AirBagLocFront_Vpic>;
  /** fetch data from the table: "vpic.airbaglocknee" */
  AirBagLocKnee: Array<AirBagLocKnee_Vpic>;
  /** fetch aggregated fields from the table: "vpic.airbaglocknee" */
  AirBagLocKnee_aggregate: AirBagLocKnee_Aggregate_Vpic;
  /** fetch data from the table: "vpic.airbaglocknee" using primary key columns */
  AirBagLocKnee_by_pk?: Maybe<AirBagLocKnee_Vpic>;
  /** fetch data from the table: "vpic.airbaglocations" */
  AirBagLocations: Array<AirBagLocations_Vpic>;
  /** fetch aggregated fields from the table: "vpic.airbaglocations" */
  AirBagLocations_aggregate: AirBagLocations_Aggregate_Vpic;
  /** fetch data from the table: "vpic.airbaglocations" using primary key columns */
  AirBagLocations_by_pk?: Maybe<AirBagLocations_Vpic>;
  /** fetch data from the table: "vpic.autobrake" */
  AutoBrake: Array<AutoBrake_Vpic>;
  /** fetch aggregated fields from the table: "vpic.autobrake" */
  AutoBrake_aggregate: AutoBrake_Aggregate_Vpic;
  /** fetch data from the table: "vpic.autobrake" using primary key columns */
  AutoBrake_by_pk?: Maybe<AutoBrake_Vpic>;
  /** fetch data from the table: "vpic.autoreversesystem" */
  AutoReverseSystem: Array<AutoReverseSystem_Vpic>;
  /** fetch aggregated fields from the table: "vpic.autoreversesystem" */
  AutoReverseSystem_aggregate: AutoReverseSystem_Aggregate_Vpic;
  /** fetch data from the table: "vpic.autoreversesystem" using primary key columns */
  AutoReverseSystem_by_pk?: Maybe<AutoReverseSystem_Vpic>;
  /** fetch data from the table: "vpic.automaticpedestrainalertingsound" */
  AutomaticPedestrainAlertingSound: Array<AutomaticPedestrainAlertingSound_Vpic>;
  /** fetch aggregated fields from the table: "vpic.automaticpedestrainalertingsound" */
  AutomaticPedestrainAlertingSound_aggregate: AutomaticPedestrainAlertingSound_Aggregate_Vpic;
  /** fetch data from the table: "vpic.automaticpedestrainalertingsound" using primary key columns */
  AutomaticPedestrainAlertingSound_by_pk?: Maybe<AutomaticPedestrainAlertingSound_Vpic>;
  /** fetch data from the table: "vpic.axleconfiguration" */
  AxleConfiguration: Array<AxleConfiguration_Vpic>;
  /** fetch aggregated fields from the table: "vpic.axleconfiguration" */
  AxleConfiguration_aggregate: AxleConfiguration_Aggregate_Vpic;
  /** fetch data from the table: "vpic.axleconfiguration" using primary key columns */
  AxleConfiguration_by_pk?: Maybe<AxleConfiguration_Vpic>;
  /** fetch data from the table: "vpic.batterytype" */
  BatteryType: Array<BatteryType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.batterytype" */
  BatteryType_aggregate: BatteryType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.batterytype" using primary key columns */
  BatteryType_by_pk?: Maybe<BatteryType_Vpic>;
  /** fetch data from the table: "vpic.bedtype" */
  BedType: Array<BedType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.bedtype" */
  BedType_aggregate: BedType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.bedtype" using primary key columns */
  BedType_by_pk?: Maybe<BedType_Vpic>;
  /** fetch data from the table: "vpic.blindspotintervention" */
  BlindSpotIntervention: Array<BlindSpotIntervention_Vpic>;
  /** fetch aggregated fields from the table: "vpic.blindspotintervention" */
  BlindSpotIntervention_aggregate: BlindSpotIntervention_Aggregate_Vpic;
  /** fetch data from the table: "vpic.blindspotintervention" using primary key columns */
  BlindSpotIntervention_by_pk?: Maybe<BlindSpotIntervention_Vpic>;
  /** fetch data from the table: "vpic.blindspotmonitoring" */
  BlindSpotMonitoring: Array<BlindSpotMonitoring_Vpic>;
  /** fetch aggregated fields from the table: "vpic.blindspotmonitoring" */
  BlindSpotMonitoring_aggregate: BlindSpotMonitoring_Aggregate_Vpic;
  /** fetch data from the table: "vpic.blindspotmonitoring" using primary key columns */
  BlindSpotMonitoring_by_pk?: Maybe<BlindSpotMonitoring_Vpic>;
  /** fetch data from the table: "vpic.bodycab" */
  BodyCab: Array<BodyCab_Vpic>;
  /** fetch aggregated fields from the table: "vpic.bodycab" */
  BodyCab_aggregate: BodyCab_Aggregate_Vpic;
  /** fetch data from the table: "vpic.bodycab" using primary key columns */
  BodyCab_by_pk?: Maybe<BodyCab_Vpic>;
  /** fetch data from the table: "vpic.bodystyle" */
  BodyStyle: Array<BodyStyle_Vpic>;
  /** fetch aggregated fields from the table: "vpic.bodystyle" */
  BodyStyle_aggregate: BodyStyle_Aggregate_Vpic;
  /** fetch data from the table: "vpic.bodystyle" using primary key columns */
  BodyStyle_by_pk?: Maybe<BodyStyle_Vpic>;
  /** fetch data from the table: "vpic.brakesystem" */
  BrakeSystem: Array<BrakeSystem_Vpic>;
  /** fetch aggregated fields from the table: "vpic.brakesystem" */
  BrakeSystem_aggregate: BrakeSystem_Aggregate_Vpic;
  /** fetch data from the table: "vpic.brakesystem" using primary key columns */
  BrakeSystem_by_pk?: Maybe<BrakeSystem_Vpic>;
  /** fetch data from the table: "vpic.busfloorconfigtype" */
  BusFloorConfigType: Array<BusFloorConfigType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.busfloorconfigtype" */
  BusFloorConfigType_aggregate: BusFloorConfigType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.busfloorconfigtype" using primary key columns */
  BusFloorConfigType_by_pk?: Maybe<BusFloorConfigType_Vpic>;
  /** fetch data from the table: "vpic.bustype" */
  BusType: Array<BusType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.bustype" */
  BusType_aggregate: BusType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.bustype" using primary key columns */
  BusType_by_pk?: Maybe<BusType_Vpic>;
  /** fetch data from the table: "vpic.can_aacn" */
  CAN_AACN: Array<Can_Aacn_Vpic>;
  /** fetch aggregated fields from the table: "vpic.can_aacn" */
  CAN_AACN_aggregate: Can_Aacn_Aggregate_Vpic;
  /** fetch data from the table: "vpic.can_aacn" using primary key columns */
  CAN_AACN_by_pk?: Maybe<Can_Aacn_Vpic>;
  /** fetch data from the table: "vpic.chargerlevel" */
  ChargerLevel: Array<ChargerLevel_Vpic>;
  /** fetch aggregated fields from the table: "vpic.chargerlevel" */
  ChargerLevel_aggregate: ChargerLevel_Aggregate_Vpic;
  /** fetch data from the table: "vpic.chargerlevel" using primary key columns */
  ChargerLevel_by_pk?: Maybe<ChargerLevel_Vpic>;
  /** fetch data from the table: "vpic.combinedbrakingsystem" */
  CombinedBrakingSystem: Array<CombinedBrakingSystem_Vpic>;
  /** fetch aggregated fields from the table: "vpic.combinedbrakingsystem" */
  CombinedBrakingSystem_aggregate: CombinedBrakingSystem_Aggregate_Vpic;
  /** fetch data from the table: "vpic.combinedbrakingsystem" using primary key columns */
  CombinedBrakingSystem_by_pk?: Maybe<CombinedBrakingSystem_Vpic>;
  /** fetch data from the table: "ContractMasterSurcharge" */
  ContractMasterSurcharge: Array<ContractMasterSurcharge>;
  /** fetch aggregated fields from the table: "ContractMasterSurcharge" */
  ContractMasterSurcharge_aggregate: ContractMasterSurcharge_Aggregate;
  /** fetch data from the table: "vpic.conversion" */
  Conversion: Array<Conversion_Vpic>;
  /** fetch aggregated fields from the table: "vpic.conversion" */
  Conversion_aggregate: Conversion_Aggregate_Vpic;
  /** fetch data from the table: "vpic.conversion" using primary key columns */
  Conversion_by_pk?: Maybe<Conversion_Vpic>;
  /** fetch data from the table: "vpic.coolingtype" */
  CoolingType: Array<CoolingType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.coolingtype" */
  CoolingType_aggregate: CoolingType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.coolingtype" using primary key columns */
  CoolingType_by_pk?: Maybe<CoolingType_Vpic>;
  /** fetch data from the table: "vpic.country" */
  Country: Array<Country_Vpic>;
  /** fetch aggregated fields from the table: "vpic.country" */
  Country_aggregate: Country_Aggregate_Vpic;
  /** fetch data from the table: "vpic.country" using primary key columns */
  Country_by_pk?: Maybe<Country_Vpic>;
  /** fetch data from the table: "vpic.custommotorcycletype" */
  CustomMotorcycleType: Array<CustomMotorcycleType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.custommotorcycletype" */
  CustomMotorcycleType_aggregate: CustomMotorcycleType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.custommotorcycletype" using primary key columns */
  CustomMotorcycleType_by_pk?: Maybe<CustomMotorcycleType_Vpic>;
  /** fetch data from the table: "vpic.daytimerunninglight" */
  DaytimeRunningLight: Array<DaytimeRunningLight_Vpic>;
  /** fetch aggregated fields from the table: "vpic.daytimerunninglight" */
  DaytimeRunningLight_aggregate: DaytimeRunningLight_Aggregate_Vpic;
  /** fetch data from the table: "vpic.daytimerunninglight" using primary key columns */
  DaytimeRunningLight_by_pk?: Maybe<DaytimeRunningLight_Vpic>;
  /** fetch data from the table: "vpic.defaultvalue" */
  DefaultValue: Array<DefaultValue_Vpic>;
  /** fetch aggregated fields from the table: "vpic.defaultvalue" */
  DefaultValue_aggregate: DefaultValue_Aggregate_Vpic;
  /** fetch data from the table: "vpic.defaultvalue" using primary key columns */
  DefaultValue_by_pk?: Maybe<DefaultValue_Vpic>;
  /** fetch data from the table: "vpic.destinationmarket" */
  DestinationMarket: Array<DestinationMarket_Vpic>;
  /** fetch aggregated fields from the table: "vpic.destinationmarket" */
  DestinationMarket_aggregate: DestinationMarket_Aggregate_Vpic;
  /** fetch data from the table: "vpic.destinationmarket" using primary key columns */
  DestinationMarket_by_pk?: Maybe<DestinationMarket_Vpic>;
  /** fetch data from the table: "vpic.drivetype" */
  DriveType: Array<DriveType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.drivetype" */
  DriveType_aggregate: DriveType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.drivetype" using primary key columns */
  DriveType_by_pk?: Maybe<DriveType_Vpic>;
  /** fetch data from the table: "vpic.dynamicbrakesupport" */
  DynamicBrakeSupport: Array<DynamicBrakeSupport_Vpic>;
  /** fetch aggregated fields from the table: "vpic.dynamicbrakesupport" */
  DynamicBrakeSupport_aggregate: DynamicBrakeSupport_Aggregate_Vpic;
  /** fetch data from the table: "vpic.dynamicbrakesupport" using primary key columns */
  DynamicBrakeSupport_by_pk?: Maybe<DynamicBrakeSupport_Vpic>;
  /** fetch data from the table: "vpic.ecs" */
  ECS: Array<Ecs_Vpic>;
  /** fetch aggregated fields from the table: "vpic.ecs" */
  ECS_aggregate: Ecs_Aggregate_Vpic;
  /** fetch data from the table: "vpic.ecs" using primary key columns */
  ECS_by_pk?: Maybe<Ecs_Vpic>;
  /** fetch data from the table: "vpic.edr" */
  EDR: Array<Edr_Vpic>;
  /** fetch aggregated fields from the table: "vpic.edr" */
  EDR_aggregate: Edr_Aggregate_Vpic;
  /** fetch data from the table: "vpic.edr" using primary key columns */
  EDR_by_pk?: Maybe<Edr_Vpic>;
  /** fetch data from the table: "vpic.evdriveunit" */
  EVDriveUnit: Array<EvDriveUnit_Vpic>;
  /** fetch aggregated fields from the table: "vpic.evdriveunit" */
  EVDriveUnit_aggregate: EvDriveUnit_Aggregate_Vpic;
  /** fetch data from the table: "vpic.evdriveunit" using primary key columns */
  EVDriveUnit_by_pk?: Maybe<EvDriveUnit_Vpic>;
  /** fetch data from the table: "vpic.electrificationlevel" */
  ElectrificationLevel: Array<ElectrificationLevel_Vpic>;
  /** fetch aggregated fields from the table: "vpic.electrificationlevel" */
  ElectrificationLevel_aggregate: ElectrificationLevel_Aggregate_Vpic;
  /** fetch data from the table: "vpic.electrificationlevel" using primary key columns */
  ElectrificationLevel_by_pk?: Maybe<ElectrificationLevel_Vpic>;
  /** fetch data from the table: "vpic.element" */
  Element: Array<Element_Vpic>;
  /** fetch aggregated fields from the table: "vpic.element" */
  Element_aggregate: Element_Aggregate_Vpic;
  /** fetch data from the table: "vpic.element" using primary key columns */
  Element_by_pk?: Maybe<Element_Vpic>;
  /** fetch data from the table: "vpic.engineconfiguration" */
  EngineConfiguration: Array<EngineConfiguration_Vpic>;
  /** fetch aggregated fields from the table: "vpic.engineconfiguration" */
  EngineConfiguration_aggregate: EngineConfiguration_Aggregate_Vpic;
  /** fetch data from the table: "vpic.engineconfiguration" using primary key columns */
  EngineConfiguration_by_pk?: Maybe<EngineConfiguration_Vpic>;
  /** fetch data from the table: "vpic.enginemodel" */
  EngineModel: Array<EngineModel_Vpic>;
  /** fetch data from the table: "vpic.enginemodelpattern" */
  EngineModelPattern: Array<EngineModelPattern_Vpic>;
  /** fetch aggregated fields from the table: "vpic.enginemodelpattern" */
  EngineModelPattern_aggregate: EngineModelPattern_Aggregate_Vpic;
  /** fetch data from the table: "vpic.enginemodelpattern" using primary key columns */
  EngineModelPattern_by_pk?: Maybe<EngineModelPattern_Vpic>;
  /** fetch aggregated fields from the table: "vpic.enginemodel" */
  EngineModel_aggregate: EngineModel_Aggregate_Vpic;
  /** fetch data from the table: "vpic.enginemodel" using primary key columns */
  EngineModel_by_pk?: Maybe<EngineModel_Vpic>;
  /** fetch data from the table: "vpic.entertainmentsystem" */
  EntertainmentSystem: Array<EntertainmentSystem_Vpic>;
  /** fetch aggregated fields from the table: "vpic.entertainmentsystem" */
  EntertainmentSystem_aggregate: EntertainmentSystem_Aggregate_Vpic;
  /** fetch data from the table: "vpic.entertainmentsystem" using primary key columns */
  EntertainmentSystem_by_pk?: Maybe<EntertainmentSystem_Vpic>;
  /** fetch data from the table: "vpic.errorcode" */
  ErrorCode: Array<ErrorCode_Vpic>;
  /** fetch aggregated fields from the table: "vpic.errorcode" */
  ErrorCode_aggregate: ErrorCode_Aggregate_Vpic;
  /** fetch data from the table: "vpic.errorcode" using primary key columns */
  ErrorCode_by_pk?: Maybe<ErrorCode_Vpic>;
  /** fetch data from the table: "vpic.forwardcollisionwarning" */
  ForwardCollisionWarning: Array<ForwardCollisionWarning_Vpic>;
  /** fetch aggregated fields from the table: "vpic.forwardcollisionwarning" */
  ForwardCollisionWarning_aggregate: ForwardCollisionWarning_Aggregate_Vpic;
  /** fetch data from the table: "vpic.forwardcollisionwarning" using primary key columns */
  ForwardCollisionWarning_by_pk?: Maybe<ForwardCollisionWarning_Vpic>;
  /** fetch data from the table: "vpic.fueldeliverytype" */
  FuelDeliveryType: Array<FuelDeliveryType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.fueldeliverytype" */
  FuelDeliveryType_aggregate: FuelDeliveryType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.fueldeliverytype" using primary key columns */
  FuelDeliveryType_by_pk?: Maybe<FuelDeliveryType_Vpic>;
  /** fetch data from the table: "vpic.fueltankmaterial" */
  FuelTankMaterial: Array<FuelTankMaterial_Vpic>;
  /** fetch aggregated fields from the table: "vpic.fueltankmaterial" */
  FuelTankMaterial_aggregate: FuelTankMaterial_Aggregate_Vpic;
  /** fetch data from the table: "vpic.fueltankmaterial" using primary key columns */
  FuelTankMaterial_by_pk?: Maybe<FuelTankMaterial_Vpic>;
  /** fetch data from the table: "vpic.fueltanktype" */
  FuelTankType: Array<FuelTankType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.fueltanktype" */
  FuelTankType_aggregate: FuelTankType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.fueltanktype" using primary key columns */
  FuelTankType_by_pk?: Maybe<FuelTankType_Vpic>;
  /** fetch data from the table: "vpic.fueltype" */
  FuelType: Array<FuelType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.fueltype" */
  FuelType_aggregate: FuelType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.fueltype" using primary key columns */
  FuelType_by_pk?: Maybe<FuelType_Vpic>;
  /** fetch data from the table: "vpic.grossvehicleweightrating" */
  GrossVehicleWeightRating: Array<GrossVehicleWeightRating_Vpic>;
  /** fetch aggregated fields from the table: "vpic.grossvehicleweightrating" */
  GrossVehicleWeightRating_aggregate: GrossVehicleWeightRating_Aggregate_Vpic;
  /** fetch data from the table: "vpic.grossvehicleweightrating" using primary key columns */
  GrossVehicleWeightRating_by_pk?: Maybe<GrossVehicleWeightRating_Vpic>;
  /** fetch data from the table: "vpic.keylessignition" */
  KeylessIgnition: Array<KeylessIgnition_Vpic>;
  /** fetch aggregated fields from the table: "vpic.keylessignition" */
  KeylessIgnition_aggregate: KeylessIgnition_Aggregate_Vpic;
  /** fetch data from the table: "vpic.keylessignition" using primary key columns */
  KeylessIgnition_by_pk?: Maybe<KeylessIgnition_Vpic>;
  /** fetch data from the table: "vpic.lanecenteringassistance" */
  LaneCenteringAssistance: Array<LaneCenteringAssistance_Vpic>;
  /** fetch aggregated fields from the table: "vpic.lanecenteringassistance" */
  LaneCenteringAssistance_aggregate: LaneCenteringAssistance_Aggregate_Vpic;
  /** fetch data from the table: "vpic.lanecenteringassistance" using primary key columns */
  LaneCenteringAssistance_by_pk?: Maybe<LaneCenteringAssistance_Vpic>;
  /** fetch data from the table: "vpic.lanedeparturewarning" */
  LaneDepartureWarning: Array<LaneDepartureWarning_Vpic>;
  /** fetch aggregated fields from the table: "vpic.lanedeparturewarning" */
  LaneDepartureWarning_aggregate: LaneDepartureWarning_Aggregate_Vpic;
  /** fetch data from the table: "vpic.lanedeparturewarning" using primary key columns */
  LaneDepartureWarning_by_pk?: Maybe<LaneDepartureWarning_Vpic>;
  /** fetch data from the table: "vpic.lanekeepsystem" */
  LaneKeepSystem: Array<LaneKeepSystem_Vpic>;
  /** fetch aggregated fields from the table: "vpic.lanekeepsystem" */
  LaneKeepSystem_aggregate: LaneKeepSystem_Aggregate_Vpic;
  /** fetch data from the table: "vpic.lanekeepsystem" using primary key columns */
  LaneKeepSystem_by_pk?: Maybe<LaneKeepSystem_Vpic>;
  /** fetch data from the table: "vpic.lowerbeamheadlamplightsource" */
  LowerBeamHeadlampLightSource: Array<LowerBeamHeadlampLightSource_Vpic>;
  /** fetch aggregated fields from the table: "vpic.lowerbeamheadlamplightsource" */
  LowerBeamHeadlampLightSource_aggregate: LowerBeamHeadlampLightSource_Aggregate_Vpic;
  /** fetch data from the table: "vpic.lowerbeamheadlamplightsource" using primary key columns */
  LowerBeamHeadlampLightSource_by_pk?: Maybe<LowerBeamHeadlampLightSource_Vpic>;
  /** fetch data from the table: "vpic.make" */
  Make: Array<Make_Vpic>;
  /** fetch data from the table: "vpic.make_model" */
  Make_Model: Array<Make_Model_Vpic>;
  /** fetch aggregated fields from the table: "vpic.make_model" */
  Make_Model_aggregate: Make_Model_Aggregate_Vpic;
  /** fetch data from the table: "vpic.make_model" using primary key columns */
  Make_Model_by_pk?: Maybe<Make_Model_Vpic>;
  /** fetch aggregated fields from the table: "vpic.make" */
  Make_aggregate: Make_Aggregate_Vpic;
  /** fetch data from the table: "vpic.make" using primary key columns */
  Make_by_pk?: Maybe<Make_Vpic>;
  /** fetch data from the table: "vpic.manufacturer" */
  Manufacturer: Array<Manufacturer_Vpic>;
  /** fetch data from the table: "vpic.manufacturer_make" */
  Manufacturer_Make: Array<Manufacturer_Make_Vpic>;
  /** fetch aggregated fields from the table: "vpic.manufacturer_make" */
  Manufacturer_Make_aggregate: Manufacturer_Make_Aggregate_Vpic;
  /** fetch data from the table: "vpic.manufacturer_make" using primary key columns */
  Manufacturer_Make_by_pk?: Maybe<Manufacturer_Make_Vpic>;
  /** fetch aggregated fields from the table: "vpic.manufacturer" */
  Manufacturer_aggregate: Manufacturer_Aggregate_Vpic;
  /** fetch data from the table: "vpic.manufacturer" using primary key columns */
  Manufacturer_by_pk?: Maybe<Manufacturer_Vpic>;
  /** fetch data from the table: "vpic.model" */
  Model: Array<Model_Vpic>;
  /** fetch aggregated fields from the table: "vpic.model" */
  Model_aggregate: Model_Aggregate_Vpic;
  /** fetch data from the table: "vpic.model" using primary key columns */
  Model_by_pk?: Maybe<Model_Vpic>;
  /** fetch data from the table: "vpic.motorcyclechassistype" */
  MotorcycleChassisType: Array<MotorcycleChassisType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.motorcyclechassistype" */
  MotorcycleChassisType_aggregate: MotorcycleChassisType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.motorcyclechassistype" using primary key columns */
  MotorcycleChassisType_by_pk?: Maybe<MotorcycleChassisType_Vpic>;
  /** fetch data from the table: "vpic.motorcyclesuspensiontype" */
  MotorcycleSuspensionType: Array<MotorcycleSuspensionType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.motorcyclesuspensiontype" */
  MotorcycleSuspensionType_aggregate: MotorcycleSuspensionType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.motorcyclesuspensiontype" using primary key columns */
  MotorcycleSuspensionType_by_pk?: Maybe<MotorcycleSuspensionType_Vpic>;
  /** fetch data from the table: "vpic.nonlanduse" */
  NonLandUse: Array<NonLandUse_Vpic>;
  /** fetch aggregated fields from the table: "vpic.nonlanduse" */
  NonLandUse_aggregate: NonLandUse_Aggregate_Vpic;
  /** fetch data from the table: "vpic.nonlanduse" using primary key columns */
  NonLandUse_by_pk?: Maybe<NonLandUse_Vpic>;
  /** fetch data from the table: "vpic.parkassist" */
  ParkAssist: Array<ParkAssist_Vpic>;
  /** fetch aggregated fields from the table: "vpic.parkassist" */
  ParkAssist_aggregate: ParkAssist_Aggregate_Vpic;
  /** fetch data from the table: "vpic.parkassist" using primary key columns */
  ParkAssist_by_pk?: Maybe<ParkAssist_Vpic>;
  /** fetch data from the table: "vpic.pattern" */
  Pattern: Array<Pattern_Vpic>;
  /** fetch aggregated fields from the table: "vpic.pattern" */
  Pattern_aggregate: Pattern_Aggregate_Vpic;
  /** fetch data from the table: "vpic.pattern" using primary key columns */
  Pattern_by_pk?: Maybe<Pattern_Vpic>;
  /** fetch data from the table: "vpic.pedestrianautomaticemergencybraking" */
  PedestrianAutomaticEmergencyBraking: Array<PedestrianAutomaticEmergencyBraking_Vpic>;
  /** fetch aggregated fields from the table: "vpic.pedestrianautomaticemergencybraking" */
  PedestrianAutomaticEmergencyBraking_aggregate: PedestrianAutomaticEmergencyBraking_Aggregate_Vpic;
  /** fetch data from the table: "vpic.pedestrianautomaticemergencybraking" using primary key columns */
  PedestrianAutomaticEmergencyBraking_by_pk?: Maybe<PedestrianAutomaticEmergencyBraking_Vpic>;
  /** fetch data from the table: "vpic.pretensioner" */
  Pretensioner: Array<Pretensioner_Vpic>;
  /** fetch aggregated fields from the table: "vpic.pretensioner" */
  Pretensioner_aggregate: Pretensioner_Aggregate_Vpic;
  /** fetch data from the table: "vpic.pretensioner" using primary key columns */
  Pretensioner_by_pk?: Maybe<Pretensioner_Vpic>;
  /** fetch data from the table: "vpic.rearautomaticemergencybraking" */
  RearAutomaticEmergencyBraking: Array<RearAutomaticEmergencyBraking_Vpic>;
  /** fetch aggregated fields from the table: "vpic.rearautomaticemergencybraking" */
  RearAutomaticEmergencyBraking_aggregate: RearAutomaticEmergencyBraking_Aggregate_Vpic;
  /** fetch data from the table: "vpic.rearautomaticemergencybraking" using primary key columns */
  RearAutomaticEmergencyBraking_by_pk?: Maybe<RearAutomaticEmergencyBraking_Vpic>;
  /** fetch data from the table: "vpic.rearcrosstrafficalert" */
  RearCrossTrafficAlert: Array<RearCrossTrafficAlert_Vpic>;
  /** fetch aggregated fields from the table: "vpic.rearcrosstrafficalert" */
  RearCrossTrafficAlert_aggregate: RearCrossTrafficAlert_Aggregate_Vpic;
  /** fetch data from the table: "vpic.rearcrosstrafficalert" using primary key columns */
  RearCrossTrafficAlert_by_pk?: Maybe<RearCrossTrafficAlert_Vpic>;
  /** fetch data from the table: "vpic.rearvisibilitycamera" */
  RearVisibilityCamera: Array<RearVisibilityCamera_Vpic>;
  /** fetch aggregated fields from the table: "vpic.rearvisibilitycamera" */
  RearVisibilityCamera_aggregate: RearVisibilityCamera_Aggregate_Vpic;
  /** fetch data from the table: "vpic.rearvisibilitycamera" using primary key columns */
  RearVisibilityCamera_by_pk?: Maybe<RearVisibilityCamera_Vpic>;
  /** fetch data from the table: "vpic.seatbeltsall" */
  SeatBeltsAll: Array<SeatBeltsAll_Vpic>;
  /** fetch aggregated fields from the table: "vpic.seatbeltsall" */
  SeatBeltsAll_aggregate: SeatBeltsAll_Aggregate_Vpic;
  /** fetch data from the table: "vpic.seatbeltsall" using primary key columns */
  SeatBeltsAll_by_pk?: Maybe<SeatBeltsAll_Vpic>;
  /** fetch data from the table: "vpic.semiautomaticheadlampbeamswitching" */
  SemiautomaticHeadlampBeamSwitching: Array<SemiautomaticHeadlampBeamSwitching_Vpic>;
  /** fetch aggregated fields from the table: "vpic.semiautomaticheadlampbeamswitching" */
  SemiautomaticHeadlampBeamSwitching_aggregate: SemiautomaticHeadlampBeamSwitching_Aggregate_Vpic;
  /** fetch data from the table: "vpic.semiautomaticheadlampbeamswitching" using primary key columns */
  SemiautomaticHeadlampBeamSwitching_by_pk?: Maybe<SemiautomaticHeadlampBeamSwitching_Vpic>;
  /** fetch data from the table: "vpic.steering" */
  Steering: Array<Steering_Vpic>;
  /** fetch aggregated fields from the table: "vpic.steering" */
  Steering_aggregate: Steering_Aggregate_Vpic;
  /** fetch data from the table: "vpic.steering" using primary key columns */
  Steering_by_pk?: Maybe<Steering_Vpic>;
  /** fetch data from the table: "vpic.tpms" */
  TPMS: Array<Tpms_Vpic>;
  /** fetch aggregated fields from the table: "vpic.tpms" */
  TPMS_aggregate: Tpms_Aggregate_Vpic;
  /** fetch data from the table: "vpic.tpms" using primary key columns */
  TPMS_by_pk?: Maybe<Tpms_Vpic>;
  /** fetch data from the table: "vpic.tractioncontrol" */
  TractionControl: Array<TractionControl_Vpic>;
  /** fetch aggregated fields from the table: "vpic.tractioncontrol" */
  TractionControl_aggregate: TractionControl_Aggregate_Vpic;
  /** fetch data from the table: "vpic.tractioncontrol" using primary key columns */
  TractionControl_by_pk?: Maybe<TractionControl_Vpic>;
  /** fetch data from the table: "vpic.trailerbodytype" */
  TrailerBodyType: Array<TrailerBodyType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.trailerbodytype" */
  TrailerBodyType_aggregate: TrailerBodyType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.trailerbodytype" using primary key columns */
  TrailerBodyType_by_pk?: Maybe<TrailerBodyType_Vpic>;
  /** fetch data from the table: "vpic.trailertype" */
  TrailerType: Array<TrailerType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.trailertype" */
  TrailerType_aggregate: TrailerType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.trailertype" using primary key columns */
  TrailerType_by_pk?: Maybe<TrailerType_Vpic>;
  /** fetch data from the table: "vpic.transmission" */
  Transmission: Array<Transmission_Vpic>;
  /** fetch aggregated fields from the table: "vpic.transmission" */
  Transmission_aggregate: Transmission_Aggregate_Vpic;
  /** fetch data from the table: "vpic.transmission" using primary key columns */
  Transmission_by_pk?: Maybe<Transmission_Vpic>;
  /** fetch data from the table: "vpic.turbo" */
  Turbo: Array<Turbo_Vpic>;
  /** fetch aggregated fields from the table: "vpic.turbo" */
  Turbo_aggregate: Turbo_Aggregate_Vpic;
  /** fetch data from the table: "vpic.turbo" using primary key columns */
  Turbo_by_pk?: Maybe<Turbo_Vpic>;
  /** fetch data from the table: "vpic.vspecschemapattern" */
  VSpecSchemaPattern: Array<VSpecSchemaPattern_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vspecschemapattern" */
  VSpecSchemaPattern_aggregate: VSpecSchemaPattern_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vspecschemapattern" using primary key columns */
  VSpecSchemaPattern_by_pk?: Maybe<VSpecSchemaPattern_Vpic>;
  /** fetch data from the table: "vpic.valvetraindesign" */
  ValvetrainDesign: Array<ValvetrainDesign_Vpic>;
  /** fetch aggregated fields from the table: "vpic.valvetraindesign" */
  ValvetrainDesign_aggregate: ValvetrainDesign_Aggregate_Vpic;
  /** fetch data from the table: "vpic.valvetraindesign" using primary key columns */
  ValvetrainDesign_by_pk?: Maybe<ValvetrainDesign_Vpic>;
  /** fetch data from the table: "vpic.vehiclespecpattern" */
  VehicleSpecPattern: Array<VehicleSpecPattern_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vehiclespecpattern" */
  VehicleSpecPattern_aggregate: VehicleSpecPattern_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vehiclespecpattern" using primary key columns */
  VehicleSpecPattern_by_pk?: Maybe<VehicleSpecPattern_Vpic>;
  /** fetch data from the table: "vpic.vehiclespecschema" */
  VehicleSpecSchema: Array<VehicleSpecSchema_Vpic>;
  /** fetch data from the table: "vpic.vehiclespecschema_model" */
  VehicleSpecSchema_Model: Array<VehicleSpecSchema_Model_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vehiclespecschema_model" */
  VehicleSpecSchema_Model_aggregate: VehicleSpecSchema_Model_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vehiclespecschema_model" using primary key columns */
  VehicleSpecSchema_Model_by_pk?: Maybe<VehicleSpecSchema_Model_Vpic>;
  /** fetch data from the table: "vpic.vehiclespecschema_year" */
  VehicleSpecSchema_Year: Array<VehicleSpecSchema_Year_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vehiclespecschema_year" */
  VehicleSpecSchema_Year_aggregate: VehicleSpecSchema_Year_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vehiclespecschema_year" using primary key columns */
  VehicleSpecSchema_Year_by_pk?: Maybe<VehicleSpecSchema_Year_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vehiclespecschema" */
  VehicleSpecSchema_aggregate: VehicleSpecSchema_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vehiclespecschema" using primary key columns */
  VehicleSpecSchema_by_pk?: Maybe<VehicleSpecSchema_Vpic>;
  /** fetch data from the table: "vpic.vehicletype" */
  VehicleType: Array<VehicleType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vehicletype" */
  VehicleType_aggregate: VehicleType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vehicletype" using primary key columns */
  VehicleType_by_pk?: Maybe<VehicleType_Vpic>;
  /** fetch data from the table: "vpic.vindescriptor" */
  VinDescriptor: Array<VinDescriptor_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vindescriptor" */
  VinDescriptor_aggregate: VinDescriptor_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vindescriptor" using primary key columns */
  VinDescriptor_by_pk?: Maybe<VinDescriptor_Vpic>;
  /** fetch data from the table: "vpic.vinexception" */
  VinException: Array<VinException_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vinexception" */
  VinException_aggregate: VinException_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vinexception" using primary key columns */
  VinException_by_pk?: Maybe<VinException_Vpic>;
  /** fetch data from the table: "vpic.vinschema" */
  VinSchema: Array<VinSchema_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vinschema" */
  VinSchema_aggregate: VinSchema_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vinschema" using primary key columns */
  VinSchema_by_pk?: Maybe<VinSchema_Vpic>;
  /** fetch data from the table: "vpic.wmiyearvalidchars" */
  WMIYearValidChars: Array<WmiYearValidChars_Vpic>;
  /** fetch data from the table: "vpic.wmiyearvalidchars_cacheexceptions" */
  WMIYearValidChars_CacheExceptions: Array<WmiYearValidChars_CacheExceptions_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wmiyearvalidchars_cacheexceptions" */
  WMIYearValidChars_CacheExceptions_aggregate: WmiYearValidChars_CacheExceptions_Aggregate_Vpic;
  /** fetch aggregated fields from the table: "vpic.wmiyearvalidchars" */
  WMIYearValidChars_aggregate: WmiYearValidChars_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wmiyearvalidchars" using primary key columns */
  WMIYearValidChars_by_pk?: Maybe<WmiYearValidChars_Vpic>;
  /** fetch data from the table: "vpic.wheelbasetype" */
  WheelBaseType: Array<WheelBaseType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wheelbasetype" */
  WheelBaseType_aggregate: WheelBaseType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wheelbasetype" using primary key columns */
  WheelBaseType_by_pk?: Maybe<WheelBaseType_Vpic>;
  /** fetch data from the table: "vpic.wheeliemitigation" */
  WheelieMitigation: Array<WheelieMitigation_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wheeliemitigation" */
  WheelieMitigation_aggregate: WheelieMitigation_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wheeliemitigation" using primary key columns */
  WheelieMitigation_by_pk?: Maybe<WheelieMitigation_Vpic>;
  /** fetch data from the table: "vpic.wmi" */
  Wmi: Array<Wmi_Vpic>;
  /** fetch data from the table: "vpic.wmi_make" */
  Wmi_Make: Array<Wmi_Make_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wmi_make" */
  Wmi_Make_aggregate: Wmi_Make_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wmi_make" using primary key columns */
  Wmi_Make_by_pk?: Maybe<Wmi_Make_Vpic>;
  /** fetch data from the table: "vpic.wmi_vinschema" */
  Wmi_VinSchema: Array<Wmi_VinSchema_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wmi_vinschema" */
  Wmi_VinSchema_aggregate: Wmi_VinSchema_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wmi_vinschema" using primary key columns */
  Wmi_VinSchema_by_pk?: Maybe<Wmi_VinSchema_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wmi" */
  Wmi_aggregate: Wmi_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wmi" using primary key columns */
  Wmi_by_pk?: Maybe<Wmi_Vpic>;
  /** execute function "account_search" which returns "account" */
  account_search: Array<Account>;
  /** execute function "account_search" and query aggregates on result of table type "account" */
  account_search_aggregate: Account_Aggregate;
  /** This action is not intended to be called. It's purpose is to provide custom types that can be generated. */
  actionToCreateCustomTypesForGeneration?: Maybe<CustomTypesForGeneration>;
  /** execute function "approvals.headroom_for_viewer" which returns "approvals.state" */
  approvalHeadroom: Array<ApprovalState>;
  /** execute function "approvals.headroom_for_viewer" and query aggregates on result of table type "approvals.state" */
  approvalHeadroom_aggregate: ApprovalState_Aggregate;
  /** fetch data from the table: "audit.message_formatter_config" */
  audit_message_formatter_config: Array<Audit_Message_Formatter_Config>;
  /** fetch aggregated fields from the table: "audit.message_formatter_config" */
  audit_message_formatter_config_aggregate: Audit_Message_Formatter_Config_Aggregate;
  /** fetch data from the table: "audit.message_formatter_config" using primary key columns */
  audit_message_formatter_config_by_pk?: Maybe<Audit_Message_Formatter_Config>;
  /** fetch data from the table: "audit.tableslist" */
  audit_tableslist: Array<Audit_Tableslist>;
  /** fetch aggregated fields from the table: "audit.tableslist" */
  audit_tableslist_aggregate: Audit_Tableslist_Aggregate;
  /** fetch data from the table: "auth.group" */
  auth_group: Array<Auth_Group>;
  /** fetch data from the table: "auth.group_actions" */
  auth_group_actions: Array<Auth_Group_Actions>;
  /** fetch aggregated fields from the table: "auth.group_actions" */
  auth_group_actions_aggregate: Auth_Group_Actions_Aggregate;
  /** fetch data from the table: "auth.group_actions" using primary key columns */
  auth_group_actions_by_pk?: Maybe<Auth_Group_Actions>;
  /** fetch aggregated fields from the table: "auth.group" */
  auth_group_aggregate: Auth_Group_Aggregate;
  /** fetch data from the table: "auth.group" using primary key columns */
  auth_group_by_pk?: Maybe<Auth_Group>;
  /** fetch data from the table: "claims.pre_authorization_vehicle_information" */
  claims_pre_authorization_vehicle_information: Array<Claims_Pre_Authorization_Vehicle_Information>;
  /** fetch aggregated fields from the table: "claims.pre_authorization_vehicle_information" */
  claims_pre_authorization_vehicle_information_aggregate: Claims_Pre_Authorization_Vehicle_Information_Aggregate;
  /** fetch data from the table: "claims.pre_authorization_vehicle_information" using primary key columns */
  claims_pre_authorization_vehicle_information_by_pk?: Maybe<Claims_Pre_Authorization_Vehicle_Information>;
  /** fetch data from the table: "claims.temp_claims_auth_table" */
  claims_temp_claims_auth_table: Array<Claims_Temp_Claims_Auth_Table>;
  /** fetch aggregated fields from the table: "claims.temp_claims_auth_table" */
  claims_temp_claims_auth_table_aggregate: Claims_Temp_Claims_Auth_Table_Aggregate;
  /** fetch data from the table: "claims.temp_claims_auth_table" using primary key columns */
  claims_temp_claims_auth_table_by_pk?: Maybe<Claims_Temp_Claims_Auth_Table>;
  /** fetch data from the table: "nhtsa.concern_synonym" using primary key columns */
  concernSynonym_by_pk?: Maybe<ConcernSynonym_Nhtsa>;
  getDistinctMakes: Array<Vpic_Criteria_Make>;
  /** fetch data from the table: "identities" */
  identities: Array<Identities>;
  /** fetch aggregated fields from the table: "identities" */
  identities_aggregate: Identities_Aggregate;
  /** fetch data from the table: "identities" using primary key columns */
  identities_by_pk?: Maybe<Identities>;
  /** fetch data from the table: "dealer" using primary key columns */
  legacy_claims_selectDealer?: Maybe<Legacy_Claims_Dealer>;
  /** fetch aggregated fields from the table: "dealer" */
  legacy_claims_selectDealerAggregate: Legacy_Claims_Dealer_Aggregate;
  /** fetch data from the table: "dealer" */
  legacy_claims_selectDealers: Array<Legacy_Claims_Dealer>;
  /** fetch data from the table: "note" using primary key columns */
  legacy_claims_selectNote?: Maybe<Legacy_Claims_Note>;
  /** fetch aggregated fields from the table: "note" */
  legacy_claims_selectNoteAggregate: Legacy_Claims_Note_Aggregate;
  /** fetch data from the table: "note" */
  legacy_claims_selectNotes: Array<Legacy_Claims_Note>;
  /** fetch data from the table: "nhtsa.model_year_model" using primary key columns */
  modelYearModel_by_pk?: Maybe<ModelYearModel_Nhtsa>;
  /** fetch data from the table: "operations.legacy_policy_contract_cost_detail_view" */
  operations_legacy_policy_contract_cost_detail_view: Array<Operations_Legacy_Policy_Contract_Cost_Detail_View>;
  /** fetch aggregated fields from the table: "operations.legacy_policy_contract_cost_detail_view" */
  operations_legacy_policy_contract_cost_detail_view_aggregate: Operations_Legacy_Policy_Contract_Cost_Detail_View_Aggregate;
  /** fetch data from the table: "operations.legacy_policy_contract_list_materialized_view" */
  operations_legacy_policy_contract_list_materialized_view: Array<Operations_Legacy_Policy_Contract_List_Materialized_View>;
  /** fetch aggregated fields from the table: "operations.legacy_policy_contract_list_materialized_view" */
  operations_legacy_policy_contract_list_materialized_view_aggregate: Operations_Legacy_Policy_Contract_List_Materialized_View_Aggregate;
  saveRateQuoteAction?: Maybe<SaveRateQuoteAction>;
  /** execute function "shared.search" which returns "shared.search_result" */
  search: Array<Shared_Search_Result>;
  /** execute function "nhtsa.search_issues" and query aggregates on result of table type "nhtsa.issue_search_result" */
  searchNhtsaIssueAggregate: IssueSearchResult_Aggregate_Nhtsa;
  /** execute function "nhtsa.search_issues" which returns "nhtsa.issue_search_result" */
  searchNhtsaIssues: Array<IssueSearchResult_Nhtsa>;
  /** execute function "shared.search" and query aggregates on result of table type "shared.search_result" */
  search_aggregate: Shared_Search_Result_Aggregate;
  /** fetch data from the table: "account" using primary key columns */
  selectAccount?: Maybe<Account>;
  /** fetch data from the table: "account_account_manager" using primary key columns */
  selectAccountAccountManager?: Maybe<AccountAccountManager>;
  /** fetch data from the table: "account_account_manager" */
  selectAccountAccountManagers: Array<AccountAccountManager>;
  /** fetch aggregated fields from the table: "account_account_manager" */
  selectAccountAccountManagersAggregate: AccountAccountManager_Aggregate;
  /** fetch aggregated fields from the table: "account" */
  selectAccountAggregate: Account_Aggregate;
  /** fetch data from the table: "account_category" */
  selectAccountCategories: Array<AccountCategory>;
  /** fetch data from the table: "account_category" using primary key columns */
  selectAccountCategory?: Maybe<AccountCategory>;
  /** fetch aggregated fields from the table: "account_category" */
  selectAccountCategoryAggregate: AccountCategory_Aggregate;
  /** fetch data from the table: "account_disbursement" using primary key columns */
  selectAccountDisbursement?: Maybe<AccountDisbursement>;
  /** fetch data from the table: "account_disbursement" */
  selectAccountDisbursements: Array<AccountDisbursement>;
  /** fetch aggregated fields from the table: "account_disbursement" */
  selectAccountDisbursementsAggregate: AccountDisbursement_Aggregate;
  /** fetch data from the table: "account_manager" using primary key columns */
  selectAccountManager?: Maybe<AccountManager>;
  /** fetch data from the table: "account_manager" */
  selectAccountManagers: Array<AccountManager>;
  /** fetch aggregated fields from the table: "account_manager" */
  selectAccountManagersAggregate: AccountManager_Aggregate;
  /** fetch data from the table: "account_obligor" using primary key columns */
  selectAccountObligor?: Maybe<AccountObligor>;
  /** fetch data from the table: "account_obligor" */
  selectAccountObligors: Array<AccountObligor>;
  /** fetch data from the table: "account_product" using primary key columns */
  selectAccountProduct?: Maybe<AccountProduct>;
  /** fetch data from the table: "account_product_obligor" using primary key columns */
  selectAccountProductObligor?: Maybe<AccountProductObligor>;
  /** fetch data from the table: "account_product_obligor" */
  selectAccountProductObligors: Array<AccountProductObligor>;
  /** fetch aggregated fields from the table: "account_product_obligor" */
  selectAccountProductObligorsAggregate: AccountProductObligor_Aggregate;
  /** fetch data from the table: "account_product" */
  selectAccountProducts: Array<AccountProduct>;
  /** fetch aggregated fields from the table: "account_product" */
  selectAccountProductsAggregate: AccountProduct_Aggregate;
  /** fetch data from the table: "account_retail" using primary key columns */
  selectAccountRetail?: Maybe<AccountRetail>;
  /** fetch data from the table: "account_retail" */
  selectAccountRetails: Array<AccountRetail>;
  /** fetch aggregated fields from the table: "account_retail" */
  selectAccountRetailsAggregate: AccountRetail_Aggregate;
  /** fetch data from the table: "account_type" using primary key columns */
  selectAccountType?: Maybe<AccountType>;
  /** fetch data from the table: "account_type" */
  selectAccountTypes: Array<AccountType>;
  /** fetch aggregated fields from the table: "account_type" */
  selectAccountTypesAggregage: AccountType_Aggregate;
  /** fetch data from the table: "account" */
  selectAccounts: Array<Account>;
  /** fetch data from the table: "address" using primary key columns */
  selectAddress?: Maybe<Address>;
  /** fetch data from the table: "address_type" using primary key columns */
  selectAddressType?: Maybe<AddressType>;
  /** fetch data from the table: "address_type" */
  selectAddressTypes: Array<AddressType>;
  /** fetch aggregated fields from the table: "address_type" */
  selectAddressTypesAggregate: AddressType_Aggregate;
  /** fetch data from the table: "address" */
  selectAddresses: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  selectAddressesAggregate: Address_Aggregate;
  /** fetch aggregated fields from the table: "shared.payment_type" */
  selectAggreatePaymentType: PaymentType_Aggregate;
  /** fetch aggregated fields from the table: "account_obligor" */
  selectAggregateAccountObligors: AccountObligor_Aggregate;
  /** fetch aggregated fields from the table: "claims.claim_detail_as400" */
  selectAggregateClaimDetailAs400: ClaimDetailAs400_Aggregate;
  /** fetch aggregated fields from the table: "claims.claim_detail_deduction_as400" */
  selectAggregateClaimDetailDeductionAs400: ClaimDetailDeductionAs400_Aggregate;
  /** fetch aggregated fields from the table: "claims.claim_service_center_as400" */
  selectAggregateClaimServiceCenterAs400: ClaimServiceCenterAs400_Aggregate;
  /** fetch aggregated fields from the table: "composite_product" */
  selectAggregateCompositeProducts: CompositeProduct_Aggregate;
  /** fetch aggregated fields from the table: "ory.identity_as400" */
  selectAggregateIdentityAs400: IdentityAs400_Aggregate;
  /** fetch aggregated fields from the table: "system.job_list_view" */
  selectAggregateJobListView: JobListView_Aggregate;
  /** fetch aggregated fields from the table: "claims.labor_rate" */
  selectAggregateLaborRate: LaborRate_Aggregate;
  /** fetch aggregated fields from the table: "claims.labor_rate_as400" */
  selectAggregateLaborRateAs400: LaborRateAs400_Aggregate;
  /** fetch aggregated fields from the table: "shared.payment_as400" */
  selectAggregatePaymentAs400: PaymentAs400_Aggregate;
  /** fetch aggregated fields from the table: "claims.policy_claim_as400" */
  selectAggregatePolicyClaimAs400: PolicyClaimAs400_Aggregate;
  /** fetch aggregated fields from the table: "claims.policy_claim_insurance" */
  selectAggregatePolicyClaimInsurances: PolicyClaimInsurance_Aggregate;
  /** fetch aggregated fields from the table: "ui.rater_view_config" */
  selectAggregateRaterViewConfigs: RaterViewConfig_Aggregate;
  /** fetch aggregated fields from the table: "claims.remittance_claim_detail" */
  selectAggregateRemittanceClaimDetail: RemittanceClaimDetail_Aggregate;
  /** fetch aggregated fields from the table: "system.step_list_view" */
  selectAggregateStepListView: StepListView_Aggregate;
  /** fetch aggregated fields from the table: "claims.tax_rate" */
  selectAggregateTaxRate: TaxRate_Aggregate;
  /** fetch aggregated fields from the table: "claims.tax_rate_as400" */
  selectAggregateTaxRateAs400: TaxRateAs400_Aggregate;
  /** fetch data from the table: "shared.alert" using primary key columns */
  selectAlert?: Maybe<Alert>;
  /** fetch data from the table: "shared.alert_acknowledgment" using primary key columns */
  selectAlertAcknowledgment?: Maybe<AlertAcknowledgment>;
  /** fetch aggregated fields from the table: "shared.alert_acknowledgment" */
  selectAlertAcknowledgmentAggregate: AlertAcknowledgment_Aggregate;
  /** fetch data from the table: "shared.alert_acknowledgment" */
  selectAlertAcknowledgments: Array<AlertAcknowledgment>;
  /** fetch aggregated fields from the table: "shared.alert" */
  selectAlertAggregate: Alert_Aggregate;
  /** fetch data from the table: "shared.alert" */
  selectAlerts: Array<Alert>;
  /** fetch data from the table: "auth.application" using primary key columns */
  selectApplication?: Maybe<Application>;
  /** fetch aggregated fields from the table: "auth.application" */
  selectApplicationAggregate: Application_Aggregate;
  /** fetch data from the table: "users.application_preference" using primary key columns */
  selectApplicationPreference?: Maybe<ApplicationPreference>;
  /** fetch aggregated fields from the table: "users.application_preference" */
  selectApplicationPreferenceAggregate: ApplicationPreference_Aggregate;
  /** fetch data from the table: "users.application_preference" */
  selectApplicationPreferences: Array<ApplicationPreference>;
  /** fetch data from the table: "auth.application" */
  selectApplications: Array<Application>;
  /** fetch data from the table: "approvals.approval" using primary key columns */
  selectApproval?: Maybe<Approval>;
  /** fetch aggregated fields from the table: "approvals.approval" */
  selectApprovalAggregate: Approval_Aggregate;
  /** fetch data from the table: "approvals.authority" */
  selectApprovalAuthorities: Array<ApprovalAuthority>;
  /** fetch data from the table: "approvals.authority" using primary key columns */
  selectApprovalAuthority?: Maybe<ApprovalAuthority>;
  /** fetch aggregated fields from the table: "approvals.authority" */
  selectApprovalAuthorityAggregate: ApprovalAuthority_Aggregate;
  /** fetch data from the table: "approvals.gate" using primary key columns */
  selectApprovalGate?: Maybe<ApprovalGate>;
  /** fetch aggregated fields from the table: "approvals.gate" */
  selectApprovalGateAggregate: ApprovalGate_Aggregate;
  /** fetch data from the table: "approvals.gate_binding" using primary key columns */
  selectApprovalGateBinding?: Maybe<ApprovalGateBinding>;
  /** fetch aggregated fields from the table: "approvals.gate_binding" */
  selectApprovalGateBindingAggregate: ApprovalGateBinding_Aggregate;
  /** fetch data from the table: "approvals.gate_binding" */
  selectApprovalGateBindings: Array<ApprovalGateBinding>;
  /** fetch data from the table: "approvals.gate" */
  selectApprovalGates: Array<ApprovalGate>;
  /** fetch data from the table: "approvals.approval" */
  selectApprovalRecords: Array<Approval>;
  /** fetch data from the table: "approvals.request" using primary key columns */
  selectApprovalRequest?: Maybe<ApprovalRequest>;
  /** fetch aggregated fields from the table: "approvals.request" */
  selectApprovalRequestAggregate: ApprovalRequest_Aggregate;
  /** fetch data from the table: "approvals.request" */
  selectApprovalRequests: Array<ApprovalRequest>;
  /** fetch aggregated fields from the table: "approvals.state" */
  selectApprovalStateAggregate: ApprovalState_Aggregate;
  /** fetch data from the table: "approvals.state" */
  selectApprovalStates: Array<ApprovalState>;
  /** fetch data from the table: "as400_data_sync" using primary key columns */
  selectAs400DataSync?: Maybe<As400DataSync>;
  /** fetch data from the table: "as400_data_sync" */
  selectAs400DataSyncs: Array<As400DataSync>;
  /** fetch aggregated fields from the table: "as400_data_sync" */
  selectAs400DataSyncsAggregate: As400DataSync_Aggregate;
  /** fetch data from the table: "shared.bank_account_type" using primary key columns */
  selectBankAccountType?: Maybe<BankAccountType>;
  /** fetch aggregated fields from the table: "shared.bank_account_type" */
  selectBankAccountTypeAggregate: BankAccountType_Aggregate;
  /** fetch data from the table: "shared.bank_account_type" */
  selectBankAccountTypes: Array<BankAccountType>;
  /** fetch data from the table: "caddy.caddy" using primary key columns */
  selectCaddy?: Maybe<Caddy>;
  /** fetch aggregated fields from the table: "caddy.caddy" */
  selectCaddyAggregate: Caddy_Aggregate;
  /** fetch data from the table: "caddy.caddy_server_manager_log" using primary key columns */
  selectCaddyServerManagerLog?: Maybe<CaddyServerManagerLog>;
  /** fetch aggregated fields from the table: "caddy.caddy_server_manager_log" */
  selectCaddyServerManagerLogAggregate: CaddyServerManagerLog_Aggregate;
  /** fetch data from the table: "caddy.caddy_server_manager_log" */
  selectCaddyServerManagerLogs: Array<CaddyServerManagerLog>;
  /** fetch data from the table: "caddy.caddy" */
  selectCaddys: Array<Caddy>;
  /** fetch aggregated fields from the table: "quotes.cancel_quote_list_view" */
  selectCancelQuoteListViewAggregate: CancelQuoteListView_Aggregate;
  /** fetch data from the table: "quotes.cancel_quote_list_view" */
  selectCancelQuoteListViews: Array<CancelQuoteListView>;
  /** fetch data from the table: "compliance.cancel_rule" using primary key columns */
  selectCancelRule?: Maybe<CancelRule>;
  /** fetch aggregated fields from the table: "compliance.cancel_rule" */
  selectCancelRuleAggregate: CancelRule_Aggregate;
  /** fetch data from the table: "compliance.cancel_rule_fee" using primary key columns */
  selectCancelRuleFee?: Maybe<CancelRuleFee>;
  /** fetch aggregated fields from the table: "compliance.cancel_rule_fee" */
  selectCancelRuleFeeAggregate: CancelRuleFee_Aggregate;
  /** fetch data from the table: "compliance.cancel_rule_fee" */
  selectCancelRuleFees: Array<CancelRuleFee>;
  /** fetch data from the table: "compliance.cancel_rule_refund" using primary key columns */
  selectCancelRuleRefund?: Maybe<CancelRuleRefund>;
  /** fetch aggregated fields from the table: "compliance.cancel_rule_refund" */
  selectCancelRuleRefundAggregate: CancelRuleRefund_Aggregate;
  /** fetch data from the table: "compliance.cancel_rule_refund" */
  selectCancelRuleRefunds: Array<CancelRuleRefund>;
  /** fetch data from the table: "compliance.cancel_rule" */
  selectCancelRules: Array<CancelRule>;
  /** fetch data from the table: "operations.cancellation" using primary key columns */
  selectCancellation?: Maybe<Cancellation>;
  /** fetch aggregated fields from the table: "operations.cancellation" */
  selectCancellationAggregate: Cancellation_Aggregate;
  /** fetch data from the table: "operations.cancellation_as400" using primary key columns */
  selectCancellationAs400?: Maybe<CancellationAs400>;
  /** fetch aggregated fields from the table: "operations.cancellation_as400" */
  selectCancellationAs400Aggregate: CancellationAs400_Aggregate;
  /** fetch data from the table: "operations.cancellation_as400" */
  selectCancellationAs400s: Array<CancellationAs400>;
  /** fetch data from the table: "operations.cancellation" */
  selectCancellations: Array<Cancellation>;
  /** fetch data from the table: "auth.capability" */
  selectCapabilities: Array<Capability>;
  /** fetch data from the table: "auth.capability" using primary key columns */
  selectCapability?: Maybe<Capability>;
  /** fetch aggregated fields from the table: "auth.capability" */
  selectCapabilityAggregate: Capability_Aggregate;
  /** fetch data from the table: "auth.capability_config" using primary key columns */
  selectCapabilityConfig?: Maybe<CapabilityConfig>;
  /** fetch aggregated fields from the table: "auth.capability_config" */
  selectCapabilityConfigAggregate: CapabilityConfig_Aggregate;
  /** fetch data from the table: "auth.capability_config" */
  selectCapabilityConfigs: Array<CapabilityConfig>;
  /** fetch data from the table: "auth.capability_route" using primary key columns */
  selectCapabilityRoute?: Maybe<CapabilityRoute>;
  /** fetch aggregated fields from the table: "auth.capability_route" */
  selectCapabilityRouteAggregate: CapabilityRoute_Aggregate;
  /** fetch data from the table: "auth.capability_route" */
  selectCapabilityRoutes: Array<CapabilityRoute>;
  /** fetch data from the table: "users.card_layout" using primary key columns */
  selectCardLayout?: Maybe<CardLayout>;
  /** fetch aggregated fields from the table: "users.card_layout" */
  selectCardLayoutAggregate: CardLayout_Aggregate;
  /** fetch data from the table: "users.card_layout" */
  selectCardLayouts: Array<CardLayout>;
  /** fetch data from the table: "carrier" using primary key columns */
  selectCarrier?: Maybe<Carrier>;
  /** fetch aggregated fields from the table: "carrier" */
  selectCarrierAggregate: Carrier_Aggregate;
  /** fetch data from the table: "carrier" */
  selectCarriers: Array<Carrier>;
  /** fetch data from the table: "category" */
  selectCategories: Array<Category>;
  /** fetch aggregated fields from the table: "category" */
  selectCategoriesAggregate: Category_Aggregate;
  /** fetch data from the table: "category" using primary key columns */
  selectCategory?: Maybe<Category>;
  selectCategoryClassGuides: Array<CategoryClassGuide>;
  /** fetch data from the table: "category_product_attribute_type" using primary key columns */
  selectCategoryProductAttributeType?: Maybe<CategoryProductAttributeType>;
  /** fetch data from the table: "category_product_attribute_type" */
  selectCategoryProductAttributeTypes: Array<CategoryProductAttributeType>;
  /** fetch aggregated fields from the table: "category_product_attribute_type" */
  selectCategoryProductAttributeTypesAggregate: CategoryProductAttributeType_Aggregate;
  /** fetch data from the table: "claim" using primary key columns */
  selectClaim?: Maybe<Claim>;
  /** fetch aggregated fields from the table: "claim" */
  selectClaimAggregate: Claim_Aggregate;
  /** fetch data from the table: "claims.claim_detail" using primary key columns */
  selectClaimDetail?: Maybe<ClaimDetail>;
  /** fetch aggregated fields from the table: "claims.claim_detail" */
  selectClaimDetailAggregate: ClaimDetail_Aggregate;
  /** fetch data from the table: "claims.claim_detail_as400" using primary key columns */
  selectClaimDetailAs400?: Maybe<ClaimDetailAs400>;
  /** fetch data from the table: "claims.claim_detail_as400" */
  selectClaimDetailAs400s: Array<ClaimDetailAs400>;
  /** fetch data from the table: "claims.claim_detail_category" */
  selectClaimDetailCategories: Array<ClaimDetailCategory>;
  /** fetch data from the table: "claims.claim_detail_category" using primary key columns */
  selectClaimDetailCategory?: Maybe<ClaimDetailCategory>;
  /** fetch aggregated fields from the table: "claims.claim_detail_category" */
  selectClaimDetailCategoryAggregate: ClaimDetailCategory_Aggregate;
  /** fetch data from the table: "claims.claim_detail_deduction_as400" using primary key columns */
  selectClaimDetailDeductionAs400?: Maybe<ClaimDetailDeductionAs400>;
  /** fetch data from the table: "claims.claim_detail_deduction_as400" */
  selectClaimDetailDeductionAs400s: Array<ClaimDetailDeductionAs400>;
  /** fetch data from the table: "claims.claim_detail_part_lookup" using primary key columns */
  selectClaimDetailPartLookup?: Maybe<ClaimDetailPartLookup>;
  /** fetch aggregated fields from the table: "claims.claim_detail_part_lookup" */
  selectClaimDetailPartLookupAggregate: ClaimDetailPartLookup_Aggregate;
  /** fetch data from the table: "claims.claim_detail_part_lookup" */
  selectClaimDetailPartLookups: Array<ClaimDetailPartLookup>;
  /** fetch data from the table: "claims.claim_detail" */
  selectClaimDetails: Array<ClaimDetail>;
  /** fetch aggregated fields from the table: "claims.claim_part" */
  selectClaimPartAggregate: ClaimPart_Aggregate;
  /** fetch data from the table: "claims.claim_part" */
  selectClaimParts: Array<ClaimPart>;
  /** fetch data from the table: "claims.claim_service_center" using primary key columns */
  selectClaimServiceCenter?: Maybe<ClaimServiceCenter>;
  /** fetch aggregated fields from the table: "claims.claim_service_center" */
  selectClaimServiceCenterAggregate: ClaimServiceCenter_Aggregate;
  /** fetch data from the table: "claims.claim_service_center_as400" using primary key columns */
  selectClaimServiceCenterAs400?: Maybe<ClaimServiceCenterAs400>;
  /** fetch data from the table: "claims.claim_service_center_as400" */
  selectClaimServiceCenterAs400s: Array<ClaimServiceCenterAs400>;
  /** fetch data from the table: "claims.claim_service_center_authorization" using primary key columns */
  selectClaimServiceCenterAuthorization?: Maybe<ClaimServiceCenterAuthorization>;
  /** fetch aggregated fields from the table: "claims.claim_service_center_authorization" */
  selectClaimServiceCenterAuthorizationAggregate: ClaimServiceCenterAuthorization_Aggregate;
  /** fetch data from the table: "claims.claim_service_center_authorization" */
  selectClaimServiceCenterAuthorizations: Array<ClaimServiceCenterAuthorization>;
  /** fetch data from the table: "claims.claim_service_center" */
  selectClaimServiceCenters: Array<ClaimServiceCenter>;
  /** fetch data from the table: "ClaimStatus" using primary key columns */
  selectClaimStatus?: Maybe<ClaimStatus>;
  /** fetch aggregated fields from the table: "ClaimStatus" */
  selectClaimStatusAggregate: ClaimStatus_Aggregate;
  /** fetch data from the table: "claim_status_type" using primary key columns */
  selectClaimStatusType?: Maybe<ClaimStatusType>;
  /** fetch aggregated fields from the table: "claim_status_type" */
  selectClaimStatusTypeAggregate: ClaimStatusType_Aggregate;
  /** fetch data from the table: "claim_status_type" */
  selectClaimStatusTypes: Array<ClaimStatusType>;
  /** fetch data from the table: "ClaimStatus" */
  selectClaimStatuses: Array<ClaimStatus>;
  /** fetch data from the table: "claim" */
  selectClaims: Array<Claim>;
  /** fetch aggregated fields from the table: "ClaimsMaster" */
  selectClaimsMasterAggregate: ClaimsMaster_Aggregate;
  /** fetch data from the table: "ClaimsMaster" */
  selectClaimsMasters: Array<ClaimsMaster>;
  /** fetch data from the table: "classes.class_criteria" using primary key columns */
  selectClassCriteria?: Maybe<ClassCriteria>;
  /** fetch aggregated fields from the table: "classes.class_criteria" */
  selectClassCriteriaAggregate: ClassCriteria_Aggregate;
  /** fetch aggregated fields from the table: "classes.class_criteria_view" */
  selectClassCriteriaViewAggregate: ClassCriteriaView_Aggregate;
  /** fetch aggregated fields from the table: "classes.class_criteria_view_default_vehicle_criteria" */
  selectClassCriteriaViewDefaultVehicleCriteriaAggregate: ClassCriteriaViewDefaultVehicleCriteria_Aggregate;
  /** fetch data from the table: "classes.class_criteria_view_default_vehicle_criteria" */
  selectClassCriteriaViewDefaultVehicleCriterias: Array<ClassCriteriaViewDefaultVehicleCriteria>;
  /** fetch aggregated fields from the table: "classes.class_criteria_view_unclassed_default_vehicle_criteria" */
  selectClassCriteriaViewUnclassedDefaultVehicleCriteriaAggregate: ClassCriteriaViewUnclassedDefaultVehicleCriteria_Aggregate;
  /** fetch data from the table: "classes.class_criteria_view_unclassed_default_vehicle_criteria" */
  selectClassCriteriaViewUnclassedDefaultVehicleCriterias: Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria>;
  /** fetch data from the table: "classes.class_criteria" */
  selectClassCriterias: Array<ClassCriteria>;
  /** fetch data from the table: "classes.class_criteria_view" */
  selectClassCriteriasView: Array<ClassCriteriaView>;
  /** fetch data from the table: "classes.class_guide" using primary key columns */
  selectClassGuide?: Maybe<ClassGuide>;
  /** fetch aggregated fields from the table: "classes.class_guide" */
  selectClassGuideAggregate: ClassGuide_Aggregate;
  /** fetch data from the table: "classes.class_guide_class_criteria" using primary key columns */
  selectClassGuideClassCriteria?: Maybe<ClassGuideClassCriteria>;
  /** fetch aggregated fields from the table: "classes.class_guide_class_criteria" */
  selectClassGuideClassCriteriaAggregate: ClassGuideClassCriteria_Aggregate;
  /** fetch aggregated fields from the table: "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
  selectClassGuideClassCriteriaViewDefaultVehicleCriteriaAggregate: ClassGuideClassCriteriaViewDefaultVehicleCriteria_Aggregate;
  /** fetch data from the table: "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
  selectClassGuideClassCriteriaViewDefaultVehicleCriterias: Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria>;
  /** fetch aggregated fields from the table: "classes.class_guide_class_criteria_view_vin" */
  selectClassGuideClassCriteriaViewVinAggregate: ClassGuideClassCriteriaViewVin_Aggregate;
  /** fetch data from the table: "classes.class_guide_class_criteria_view_vin" */
  selectClassGuideClassCriteriaViewVins: Array<ClassGuideClassCriteriaViewVin>;
  /** fetch data from the table: "classes.class_guide_class_criteria" */
  selectClassGuideClassCriterias: Array<ClassGuideClassCriteria>;
  /** fetch data from the table: "classes.class_guide_criteria_definition" using primary key columns */
  selectClassGuideCriteriaDefinition?: Maybe<ClassGuideCriteriaDefinition>;
  /** fetch aggregated fields from the table: "classes.class_guide_criteria_definition" */
  selectClassGuideCriteriaDefinitionAggregate: ClassGuideCriteriaDefinition_Aggregate;
  /** fetch data from the table: "classes.class_guide_criteria_definition" */
  selectClassGuideCriteriaDefinitions: Array<ClassGuideCriteriaDefinition>;
  /** fetch data from the table: "classes.class_guide_criteria_type" using primary key columns */
  selectClassGuideCriteriaType?: Maybe<ClassGuideCriteriaType>;
  /** fetch aggregated fields from the table: "classes.class_guide_criteria_type" */
  selectClassGuideCriteriaTypeAggregate: ClassGuideCriteriaType_Aggregate;
  /** fetch data from the table: "classes.class_guide_criteria_type" */
  selectClassGuideCriteriaTypes: Array<ClassGuideCriteriaType>;
  /** fetch data from the table: "classes.class_guide" */
  selectClassGuides: Array<ClassGuide>;
  /** fetch data from the table: "composite_product" using primary key columns */
  selectCompositeProduct?: Maybe<CompositeProduct>;
  /** fetch data from the table: "composite_product" */
  selectCompositeProducts: Array<CompositeProduct>;
  /** fetch data from the table: "configuration_item" using primary key columns */
  selectConfigurationItem?: Maybe<ConfigurationItem>;
  /** fetch aggregated fields from the table: "configuration_item" */
  selectConfigurationItemAggregate: ConfigurationItem_Aggregate;
  /** fetch data from the table: "configuration_item_type" using primary key columns */
  selectConfigurationItemType?: Maybe<ConfigurationItemType>;
  /** fetch aggregated fields from the table: "configuration_item_type" */
  selectConfigurationItemTypeAggregate: ConfigurationItemType_Aggregate;
  /** fetch data from the table: "configuration_item_type" */
  selectConfigurationItemTypes: Array<ConfigurationItemType>;
  /** fetch data from the table: "configuration_item" */
  selectConfigurationItems: Array<ConfigurationItem>;
  /** fetch data from the table: "contact" using primary key columns */
  selectContact?: Maybe<Contact>;
  /** fetch aggregated fields from the table: "contact" */
  selectContactAggregate: Contact_Aggregate;
  /** fetch data from the table: "contact" */
  selectContacts: Array<Contact>;
  /** fetch data from the table: "shared.content_type" using primary key columns */
  selectContentType?: Maybe<ContentType>;
  /** fetch aggregated fields from the table: "shared.content_type" */
  selectContentTypeAggregate: ContentType_Aggregate;
  /** fetch data from the table: "shared.content_type" */
  selectContentTypes: Array<ContentType>;
  /** fetch data from the table: "contract" using primary key columns */
  selectContract?: Maybe<Contract>;
  /** fetch aggregated fields from the table: "contract" */
  selectContractAggregate: Contract_Aggregate;
  /** fetch data from the table: "compliance.contract_form" using primary key columns */
  selectContractForm?: Maybe<ContractForm>;
  /** fetch aggregated fields from the table: "compliance.contract_form" */
  selectContractFormAggregate: ContractForm_Aggregate;
  /** fetch data from the table: "compliance.contract_form_filing_status" using primary key columns */
  selectContractFormFilingStatus?: Maybe<ContractFormFilingStatus>;
  /** fetch aggregated fields from the table: "compliance.contract_form_filing_status" */
  selectContractFormFilingStatusAggregate: ContractFormFilingStatus_Aggregate;
  /** fetch data from the table: "compliance.contract_form_filing_status" */
  selectContractFormFilingStatuses: Array<ContractFormFilingStatus>;
  /** fetch data from the table: "compliance.contract_form_type" using primary key columns */
  selectContractFormType?: Maybe<ContractFormType>;
  /** fetch aggregated fields from the table: "compliance.contract_form_type" */
  selectContractFormTypeAggregate: ContractFormType_Aggregate;
  /** fetch data from the table: "compliance.contract_form_type" */
  selectContractFormTypes: Array<ContractFormType>;
  /** fetch data from the table: "compliance.contract_form_version" using primary key columns */
  selectContractFormVersion?: Maybe<ContractFormVersion>;
  /** fetch aggregated fields from the table: "compliance.contract_form_version" */
  selectContractFormVersionAggregate: ContractFormVersion_Aggregate;
  /** fetch data from the table: "compliance.contract_form_version_legacy_file" using primary key columns */
  selectContractFormVersionLegacyFile?: Maybe<ContractFormVersionLegacyFile>;
  /** fetch aggregated fields from the table: "compliance.contract_form_version_legacy_file" */
  selectContractFormVersionLegacyFileAggregate: ContractFormVersionLegacyFile_Aggregate;
  /** fetch data from the table: "compliance.contract_form_version_legacy_file" */
  selectContractFormVersionLegacyFiles: Array<ContractFormVersionLegacyFile>;
  /** fetch data from the table: "compliance.contract_form_version" */
  selectContractFormVersions: Array<ContractFormVersion>;
  /** fetch data from the table: "compliance.contract_form" */
  selectContractForms: Array<ContractForm>;
  /** fetch data from the table: "ContractMaster" using primary key columns */
  selectContractMaster?: Maybe<ContractMaster>;
  /** fetch data from the table: "ContractMasterAdditionalEntity" */
  selectContractMasterAdditionalEntiies: Array<ContractMasterAdditionalEntity>;
  /** fetch aggregated fields from the table: "ContractMasterAdditionalEntity" */
  selectContractMasterAdditionalEntityAggregate: ContractMasterAdditionalEntity_Aggregate;
  /** fetch aggregated fields from the table: "ContractMaster" */
  selectContractMasterAggregate: ContractMaster_Aggregate;
  /** fetch data from the table: "ContractMaster" */
  selectContractMasters: Array<ContractMaster>;
  /** fetch data from the table: "contract_status_type" using primary key columns */
  selectContractStatusType?: Maybe<ContractStatusType>;
  /** fetch aggregated fields from the table: "contract_status_type" */
  selectContractStatusTypeAggregate: ContractStatusType_Aggregate;
  /** fetch data from the table: "contract_status_type" */
  selectContractStatusTypes: Array<ContractStatusType>;
  /** fetch data from the table: "contract" */
  selectContracts: Array<Contract>;
  /** fetch data from the table: "cost_adjustment" using primary key columns */
  selectCostAdjustment?: Maybe<CostAdjustment>;
  /** fetch aggregated fields from the table: "cost_adjustment" */
  selectCostAdjustmentAggregate: CostAdjustment_Aggregate;
  /** fetch data from the table: "cost_adjustment_extended_cost" using primary key columns */
  selectCostAdjustmentExtendedCost?: Maybe<CostAdjustmentExtendedCost>;
  /** fetch aggregated fields from the table: "cost_adjustment_extended_cost" */
  selectCostAdjustmentExtendedCostAggregate: CostAdjustmentExtendedCost_Aggregate;
  /** fetch data from the table: "cost_adjustment_extended_cost" */
  selectCostAdjustmentExtendedCosts: Array<CostAdjustmentExtendedCost>;
  /** fetch data from the table: "cost_adjustment_lookup" using primary key columns */
  selectCostAdjustmentLookup?: Maybe<CostAdjustmentLookup>;
  /** fetch aggregated fields from the table: "cost_adjustment_lookup" */
  selectCostAdjustmentLookupAggregate: CostAdjustmentLookup_Aggregate;
  /** fetch data from the table: "cost_adjustment_lookup" */
  selectCostAdjustmentLookups: Array<CostAdjustmentLookup>;
  /** fetch data from the table: "cost_adjustment_type" using primary key columns */
  selectCostAdjustmentType?: Maybe<CostAdjustmentType>;
  /** fetch aggregated fields from the table: "cost_adjustment_type" */
  selectCostAdjustmentTypeAggregate: CostAdjustmentType_Aggregate;
  /** fetch data from the table: "cost_adjustment_type" */
  selectCostAdjustmentTypes: Array<CostAdjustmentType>;
  /** fetch data from the table: "cost_adjustment" */
  selectCostAdjustments: Array<CostAdjustment>;
  /** fetch data from the table: "custom_field" using primary key columns */
  selectCustomField?: Maybe<CustomField>;
  /** fetch data from the table: "custom_field_data" using primary key columns */
  selectCustomFieldData?: Maybe<CustomFieldData>;
  /** fetch aggregated fields from the table: "custom_field_data" */
  selectCustomFieldDataAggregate: CustomFieldData_Aggregate;
  /** fetch data from the table: "custom_field_data" */
  selectCustomFieldDatas: Array<CustomFieldData>;
  /** fetch data from the table: "custom_field_type" using primary key columns */
  selectCustomFieldType?: Maybe<CustomFieldType>;
  /** fetch aggregated fields from the table: "custom_field_type" */
  selectCustomFieldTypeAggregate: CustomFieldType_Aggregate;
  /** fetch data from the table: "custom_field_type" */
  selectCustomFieldTypes: Array<CustomFieldType>;
  /** fetch data from the table: "custom_field" */
  selectCustomFields: Array<CustomField>;
  /** fetch aggregated fields from the table: "custom_field" */
  selectCustomFieldsAggregate: CustomField_Aggregate;
  /** fetch data from the table: "customer" using primary key columns */
  selectCustomer?: Maybe<Customer>;
  /** fetch aggregated fields from the table: "customer" */
  selectCustomerAggregate: Customer_Aggregate;
  /** fetch data from the table: "customer" */
  selectCustomers: Array<Customer>;
  /** fetch data from the table: "accounting.cycle" using primary key columns */
  selectCycle?: Maybe<Cycle>;
  /** fetch aggregated fields from the table: "accounting.cycle" */
  selectCycleAggregate: Cycle_Aggregate;
  /** fetch data from the table: "accounting.cycle_journal_entry" */
  selectCycleJournalEntries: Array<CycleJournalEntry>;
  /** fetch data from the table: "accounting.cycle_journal_entry" using primary key columns */
  selectCycleJournalEntry?: Maybe<CycleJournalEntry>;
  /** fetch aggregated fields from the table: "accounting.cycle_journal_entry" */
  selectCycleJournalEntryAggregate: CycleJournalEntry_Aggregate;
  /** fetch data from the table: "accounting.cycle_total" using primary key columns */
  selectCycleTotal?: Maybe<CycleTotal>;
  /** fetch aggregated fields from the table: "accounting.cycle_total" */
  selectCycleTotalAggregate: CycleTotal_Aggregate;
  /** fetch data from the table: "accounting.cycle_total" */
  selectCycleTotals: Array<CycleTotal>;
  /** fetch data from the table: "accounting.cycle" */
  selectCycles: Array<Cycle>;
  /** fetch data from the table: "data_type" using primary key columns */
  selectDataType?: Maybe<DataType>;
  /** fetch aggregated fields from the table: "data_type" */
  selectDataTypeAggregate: DataType_Aggregate;
  /** fetch data from the table: "data_type" */
  selectDataTypes: Array<DataType>;
  /** fetch data from the table: "date_calculation_type" using primary key columns */
  selectDateCalculationType?: Maybe<DateCalculationType>;
  /** fetch aggregated fields from the table: "date_calculation_type" */
  selectDateCalculationTypeAggregate: DateCalculationType_Aggregate;
  /** fetch data from the table: "date_calculation_type" */
  selectDateCalculationTypes: Array<DateCalculationType>;
  /** fetch data from the table: "Dealer" using primary key columns */
  selectDealer?: Maybe<Dealer>;
  /** fetch aggregated fields from the table: "Dealer" */
  selectDealerAggregate: Dealer_Aggregate;
  /** fetch aggregated fields from the table: "shared.dealer_alert_list_view" */
  selectDealerAlertAggregate: Shared_Dealer_Alert_List_View_Aggregate;
  /** fetch data from the table: "shared.dealer_alert_list_view" */
  selectDealerAlerts: Array<Shared_Dealer_Alert_List_View>;
  /** fetch data from the table: "dealer_payment_type" using primary key columns */
  selectDealerPaymentType?: Maybe<DealerPaymentType>;
  /** fetch aggregated fields from the table: "dealer_payment_type" */
  selectDealerPaymentTypeAggregate: DealerPaymentType_Aggregate;
  /** fetch data from the table: "dealer_payment_type" */
  selectDealerPaymentTypes: Array<DealerPaymentType>;
  /** fetch data from the table: "Dealer" */
  selectDealers: Array<Dealer>;
  /** fetch data from the table: "disbursement_type" using primary key columns */
  selectDisbursementType?: Maybe<DisbursementType>;
  /** fetch data from the table: "disbursement_type" */
  selectDisbursementTypes: Array<DisbursementType>;
  /** fetch aggregated fields from the table: "disbursement_type" */
  selectDisbursementTypesAggregate: DisbursementType_Aggregate;
  /** fetch data from the table: "claims.document" using primary key columns */
  selectDocument?: Maybe<Document>;
  /** fetch aggregated fields from the table: "claims.document" */
  selectDocumentAggregate: Document_Aggregate;
  /** fetch data from the table: "shared.document_instance" using primary key columns */
  selectDocumentInstance?: Maybe<DocumentInstance>;
  /** fetch aggregated fields from the table: "shared.document_instance" */
  selectDocumentInstanceAggregate: DocumentInstance_Aggregate;
  /** fetch data from the table: "shared.document_instance" */
  selectDocumentInstances: Array<DocumentInstance>;
  /** fetch data from the table: "shared.document_template" using primary key columns */
  selectDocumentTemplate?: Maybe<DocumentTemplate>;
  /** fetch aggregated fields from the table: "shared.document_template" */
  selectDocumentTemplateAggregate: DocumentTemplate_Aggregate;
  /** fetch data from the table: "shared.document_template_application" using primary key columns */
  selectDocumentTemplateApplication?: Maybe<DocumentTemplateApplication>;
  /** fetch aggregated fields from the table: "shared.document_template_application" */
  selectDocumentTemplateApplicationAggregate: DocumentTemplateApplication_Aggregate;
  /** fetch data from the table: "shared.document_template_application" */
  selectDocumentTemplateApplications: Array<DocumentTemplateApplication>;
  /** fetch data from the table: "shared.document_template" */
  selectDocumentTemplates: Array<DocumentTemplate>;
  /** fetch data from the table: "claims.document" */
  selectDocuments: Array<Document>;
  /** fetch data from the table: "eligibility_rule" using primary key columns */
  selectEligibilityRule?: Maybe<EligibilityRule>;
  /** fetch aggregated fields from the table: "eligibility_rule" */
  selectEligibilityRuleAggregate: EligibilityRule_Aggregate;
  /** fetch data from the table: "eligibility_rule_definition" using primary key columns */
  selectEligibilityRuleDefinition?: Maybe<EligibilityRuleDefinition>;
  /** fetch aggregated fields from the table: "eligibility_rule_definition" */
  selectEligibilityRuleDefinitionAggregate: EligibilityRuleDefinition_Aggregate;
  /** fetch data from the table: "eligibility_rule_definition" */
  selectEligibilityRuleDefinitions: Array<EligibilityRuleDefinition>;
  /** fetch data from the table: "eligibility_rule" */
  selectEligibilityRules: Array<EligibilityRule>;
  /** fetch data from the table: "eligibility_type" using primary key columns */
  selectEligibilityType?: Maybe<EligibilityType>;
  /** fetch data from the table: "eligibility_type" */
  selectEligibilityTypes: Array<EligibilityType>;
  /** fetch aggregated fields from the table: "eligibility_type" */
  selectEligibilityTypesAggregate: EligibilityType_Aggregate;
  /** fetch data from the table: "shared.entity_billing_information" using primary key columns */
  selectEntityBillingInformation?: Maybe<EntityBillingInformation>;
  /** fetch aggregated fields from the table: "shared.entity_billing_information" */
  selectEntityBillingInformationAggregate: EntityBillingInformation_Aggregate;
  /** fetch data from the table: "shared.entity_billing_information" */
  selectEntityBillingInformations: Array<EntityBillingInformation>;
  /** fetch data from the table: "entity_configuration_item" using primary key columns */
  selectEntityConfigurationItem?: Maybe<EntityConfigurationItem>;
  /** fetch aggregated fields from the table: "entity_configuration_item" */
  selectEntityConfigurationItemAggregate: EntityConfigurationItem_Aggregate;
  /** fetch data from the table: "entity_configuration_item" */
  selectEntityConfigurationItems: Array<EntityConfigurationItem>;
  /** fetch data from the table: "shared.entity_content_type" using primary key columns */
  selectEntityContentType?: Maybe<EntityContentType>;
  /** fetch aggregated fields from the table: "shared.entity_content_type" */
  selectEntityContentTypeAggregate: EntityContentType_Aggregate;
  /** fetch data from the table: "shared.entity_content_type" */
  selectEntityContentTypes: Array<EntityContentType>;
  /** fetch data from the table: "entity_custom_field" using primary key columns */
  selectEntityCustomField?: Maybe<EntityCustomField>;
  /** fetch data from the table: "entity_custom_field_value" using primary key columns */
  selectEntityCustomFieldValue?: Maybe<EntityCustomFieldValue>;
  /** fetch aggregated fields from the table: "entity_custom_field_value" */
  selectEntityCustomFieldValueAggregate: EntityCustomFieldValue_Aggregate;
  /** fetch data from the table: "entity_custom_field_value" */
  selectEntityCustomFieldValues: Array<EntityCustomFieldValue>;
  /** fetch data from the table: "entity_custom_field" */
  selectEntityCustomFields: Array<EntityCustomField>;
  /** fetch aggregated fields from the table: "entity_custom_field" */
  selectEntityCustomFieldsAggregate: EntityCustomField_Aggregate;
  /** fetch data from the table: "entity_data_definition" using primary key columns */
  selectEntityDataDefinition?: Maybe<EntityDataDefinition>;
  /** fetch aggregated fields from the table: "entity_data_definition" */
  selectEntityDataDefinitionAggregate: EntityDataDefinition_Aggregate;
  /** fetch data from the table: "entity_data_definition" */
  selectEntityDataDefinitions: Array<EntityDataDefinition>;
  /** fetch data from the table: "entity_eligibility_rule" using primary key columns */
  selectEntityEligibilityRule?: Maybe<EntityEligibilityRule>;
  /** fetch aggregated fields from the table: "entity_eligibility_rule" */
  selectEntityEligibilityRuleAggregate: EntityEligibilityRule_Aggregate;
  /** fetch data from the table: "entity_eligibility_rule" */
  selectEntityEligibilityRules: Array<EntityEligibilityRule>;
  /** fetch data from the table: "shared.entity_feature" using primary key columns */
  selectEntityFeature?: Maybe<EntityFeature>;
  /** fetch aggregated fields from the table: "shared.entity_feature" */
  selectEntityFeatureAggregate: EntityFeature_Aggregate;
  /** fetch data from the table: "shared.entity_feature" */
  selectEntityFeatures: Array<EntityFeature>;
  /** fetch data from the table: "shared.entity_file_content_type" using primary key columns */
  selectEntityFileContentType?: Maybe<EntityFileContentType>;
  /** fetch aggregated fields from the table: "shared.entity_file_content_type" */
  selectEntityFileContentTypeAggregate: EntityFileContentType_Aggregate;
  /** fetch data from the table: "shared.entity_file_content_type" */
  selectEntityFileContentTypes: Array<EntityFileContentType>;
  /** fetch data from the table: "shared.entity_file_storage" using primary key columns */
  selectEntityFileStorage?: Maybe<EntityFileStorage>;
  /** fetch aggregated fields from the table: "shared.entity_file_storage" */
  selectEntityFileStorageAggregate: EntityFileStorage_Aggregate;
  /** fetch data from the table: "shared.entity_file_storage" */
  selectEntityFileStorages: Array<EntityFileStorage>;
  /** fetch data from the table: "shared.entity_note" using primary key columns */
  selectEntityNote?: Maybe<EntityNote>;
  /** fetch aggregated fields from the table: "shared.entity_note" */
  selectEntityNoteAggregate: EntityNote_Aggregate;
  /** fetch aggregated fields from the table: "auth.entity_note_capability_view" */
  selectEntityNoteCapabilityViewAggregate: EntityNoteCapabilityView_Aggregate;
  /** fetch data from the table: "auth.entity_note_capability_view" */
  selectEntityNoteCapabilityViews: Array<EntityNoteCapabilityView>;
  /** fetch data from the table: "shared.entity_note" */
  selectEntityNotes: Array<EntityNote>;
  /** fetch data from the table: "entity_offering" using primary key columns */
  selectEntityOffering?: Maybe<EntityOffering>;
  /** fetch aggregated fields from the table: "entity_offering" */
  selectEntityOfferingAggregate: EntityOffering_Aggregate;
  /** fetch data from the table: "entity_offering" */
  selectEntityOfferings: Array<EntityOffering>;
  /** fetch data from the table: "shared.entity_remittance_detail" using primary key columns */
  selectEntityRemittanceDetail?: Maybe<EntityRemittanceDetail>;
  /** fetch aggregated fields from the table: "shared.entity_remittance_detail" */
  selectEntityRemittanceDetailAggregate: EntityRemittanceDetail_Aggregate;
  /** fetch data from the table: "shared.entity_remittance_detail" */
  selectEntityRemittanceDetails: Array<EntityRemittanceDetail>;
  /** fetch data from the table: "shared.entity_tag" using primary key columns */
  selectEntityTag?: Maybe<EntityTag>;
  /** fetch aggregated fields from the table: "shared.entity_tag" */
  selectEntityTagAggregate: EntityTag_Aggregate;
  /** fetch data from the table: "shared.entity_tag" */
  selectEntityTags: Array<EntityTag>;
  /** fetch data from the table: "shared.feature" using primary key columns */
  selectFeature?: Maybe<Feature>;
  /** fetch aggregated fields from the table: "shared.feature" */
  selectFeatureAggregate: Feature_Aggregate;
  /** fetch data from the table: "shared.feature" */
  selectFeatures: Array<Feature>;
  /** fetch data from the table: "shared.file_storage" using primary key columns */
  selectFileStorage?: Maybe<FileStorage>;
  /** fetch aggregated fields from the table: "shared.file_storage" */
  selectFileStorageAggregate: FileStorage_Aggregate;
  /** fetch data from the table: "shared.file_storage_type" using primary key columns */
  selectFileStorageType?: Maybe<FileStorageType>;
  /** fetch aggregated fields from the table: "shared.file_storage_type" */
  selectFileStorageTypeAggregate: FileStorageType_Aggregate;
  /** fetch data from the table: "shared.file_storage_type" */
  selectFileStorageTypes: Array<FileStorageType>;
  /** fetch data from the table: "shared.file_storage" */
  selectFileStorages: Array<FileStorage>;
  /** fetch data from the table: "compliance.filing_lender" using primary key columns */
  selectFilingLender?: Maybe<FilingLender>;
  /** fetch data from the table: "compliance.filing_lender_match" using primary key columns */
  selectFilingLenderMatch?: Maybe<FilingLenderMatch>;
  /** fetch aggregated fields from the table: "compliance.filing_lender_match" */
  selectFilingLenderMatchAggregate: FilingLenderMatch_Aggregate;
  /** fetch data from the table: "compliance.filing_lender_match" */
  selectFilingLenderMatches: Array<FilingLenderMatch>;
  /** fetch data from the table: "compliance.filing_lender" */
  selectFilingLenders: Array<FilingLender>;
  /** fetch data from the table: "compliance.filing_state" using primary key columns */
  selectFilingState?: Maybe<FilingState>;
  /** fetch aggregated fields from the table: "compliance.filing_state" */
  selectFilingStateAggregate: FilingState_Aggregate;
  /** fetch data from the table: "compliance.filing_state" */
  selectFilingStates: Array<FilingState>;
  /** fetch data from the table: "compliance.filing_status_type" using primary key columns */
  selectFilingStatusType?: Maybe<FilingStatusType>;
  /** fetch aggregated fields from the table: "compliance.filing_status_type" */
  selectFilingStatusTypeAggregate: FilingStatusType_Aggregate;
  /** fetch data from the table: "compliance.filing_status_type" */
  selectFilingStatusTypes: Array<FilingStatusType>;
  /** fetch data from the table: "auth.flow_item" using primary key columns */
  selectFlowItem?: Maybe<FlowItem>;
  /** fetch aggregated fields from the table: "auth.flow_item" */
  selectFlowItemAggregate: FlowItem_Aggregate;
  /** fetch data from the table: "auth.flow_item_type" using primary key columns */
  selectFlowItemType?: Maybe<FlowItemType>;
  /** fetch aggregated fields from the table: "auth.flow_item_type" */
  selectFlowItemTypeAggregate: FlowItemType_Aggregate;
  /** fetch data from the table: "auth.flow_item_type" */
  selectFlowItemTypes: Array<FlowItemType>;
  /** fetch data from the table: "auth.flow_item" */
  selectFlowItems: Array<FlowItem>;
  /** fetch data from the table: "auth.flow_type" using primary key columns */
  selectFlowType?: Maybe<FlowType>;
  /** fetch aggregated fields from the table: "auth.flow_type" */
  selectFlowTypeAggregate: FlowType_Aggregate;
  /** fetch data from the table: "auth.flow_type" */
  selectFlowTypes: Array<FlowType>;
  /** fetch data from the table: "ory.identity" */
  selectIdentities: Array<Identity>;
  /** fetch aggregated fields from the table: "ory.identity" */
  selectIdentitiesAggregate: Identity_Aggregate;
  /** fetch data from the table: "ory.identity" using primary key columns */
  selectIdentity?: Maybe<Identity>;
  /** fetch data from the table: "ory.identity_as400" using primary key columns */
  selectIdentityAs400?: Maybe<IdentityAs400>;
  /** fetch data from the table: "ory.identity_as400" */
  selectIdentityAs400s: Array<IdentityAs400>;
  /** fetch data from the table: "auth.identity_capability" */
  selectIdentityCapabilities: Array<IdentityCapability>;
  /** fetch data from the table: "auth.identity_capability" using primary key columns */
  selectIdentityCapability?: Maybe<IdentityCapability>;
  /** fetch aggregated fields from the table: "auth.identity_capability" */
  selectIdentityCapabilityAggregate: IdentityCapability_Aggregate;
  /** fetch aggregated fields from the table: "auth.identity_capability_view" */
  selectIdentityCapabilityViewAggregate: IdentityCapabilityView_Aggregate;
  /** fetch data from the table: "auth.identity_capability_view" */
  selectIdentityCapabilityViews: Array<IdentityCapabilityView>;
  /** fetch data from the table: "auth.identity_entity" */
  selectIdentityEntities: Array<IdentityEntity>;
  /** fetch data from the table: "auth.identity_entity" using primary key columns */
  selectIdentityEntity?: Maybe<IdentityEntity>;
  /** fetch aggregated fields from the table: "auth.identity_entity" */
  selectIdentityEntityAggregate: IdentityEntity_Aggregate;
  /** fetch aggregated fields from the table: "auth.identity_entity_view" */
  selectIdentityEntityViewAggregate: IdentityEntityView_Aggregate;
  /** fetch data from the table: "auth.identity_entity_view" */
  selectIdentityEntityViews: Array<IdentityEntityView>;
  /** fetch data from the table: "auth.identity_filter" using primary key columns */
  selectIdentityFilter?: Maybe<IdentityFilter>;
  /** fetch aggregated fields from the table: "auth.identity_filter" */
  selectIdentityFilterAggregate: IdentityFilter_Aggregate;
  /** fetch data from the table: "auth.identity_filter" */
  selectIdentityFilters: Array<IdentityFilter>;
  /** fetch data from the table: "claims.invoice" using primary key columns */
  selectInvoice?: Maybe<Invoice>;
  /** fetch aggregated fields from the table: "claims.invoice" */
  selectInvoiceAggregate: Invoice_Aggregate;
  /** fetch data from the table: "claims.invoice_document_type" using primary key columns */
  selectInvoiceDocumentType?: Maybe<InvoiceDocumentType>;
  /** fetch aggregated fields from the table: "claims.invoice_document_type" */
  selectInvoiceDocumentTypeAggregate: InvoiceDocumentType_Aggregate;
  /** fetch data from the table: "claims.invoice_document_type" */
  selectInvoiceDocumentTypes: Array<InvoiceDocumentType>;
  /** fetch data from the table: "claims.invoice_payment_type" using primary key columns */
  selectInvoicePaymentType?: Maybe<InvoicePaymentType>;
  /** fetch aggregated fields from the table: "claims.invoice_payment_type" */
  selectInvoicePaymentTypeAggregate: InvoicePaymentType_Aggregate;
  /** fetch data from the table: "claims.invoice_payment_type" */
  selectInvoicePaymentTypes: Array<InvoicePaymentType>;
  /** fetch data from the table: "claims.invoice" */
  selectInvoices: Array<Invoice>;
  /** fetch data from the table: "system.job" using primary key columns */
  selectJob?: Maybe<Job>;
  /** fetch aggregated fields from the table: "system.job" */
  selectJobAggregate: Job_Aggregate;
  /** fetch data from the table: "system.job_history" */
  selectJobHistories: Array<JobHistory>;
  /** fetch data from the table: "system.job_history" using primary key columns */
  selectJobHistory?: Maybe<JobHistory>;
  /** fetch aggregated fields from the table: "system.job_history" */
  selectJobHistoryAggregate: JobHistory_Aggregate;
  /** fetch data from the table: "system.job_history_log" using primary key columns */
  selectJobHistoryLog?: Maybe<JobHistoryLog>;
  /** fetch aggregated fields from the table: "system.job_history_log" */
  selectJobHistoryLogAggregate: JobHistoryLog_Aggregate;
  /** fetch data from the table: "system.job_history_log" */
  selectJobHistoryLogs: Array<JobHistoryLog>;
  /** fetch data from the table: "system.job_list_view" */
  selectJobListViews: Array<JobListView>;
  /** fetch data from the table: "system.job_schedule" using primary key columns */
  selectJobSchedule?: Maybe<JobSchedule>;
  /** fetch aggregated fields from the table: "system.job_schedule" */
  selectJobScheduleAggregate: JobSchedule_Aggregate;
  /** fetch data from the table: "system.job_schedule" */
  selectJobSchedules: Array<JobSchedule>;
  /** fetch data from the table: "system.job_step" using primary key columns */
  selectJobStep?: Maybe<JobStep>;
  /** fetch aggregated fields from the table: "system.job_step" */
  selectJobStepAggregate: JobStep_Aggregate;
  /** fetch data from the table: "system.job_step" */
  selectJobSteps: Array<JobStep>;
  /** fetch data from the table: "system.job" */
  selectJobs: Array<Job>;
  /** fetch data from the table: "accounting.journal_entry" */
  selectJournalEntries: Array<JournalEntry>;
  /** fetch data from the table: "accounting.journal_entry" using primary key columns */
  selectJournalEntry?: Maybe<JournalEntry>;
  /** fetch aggregated fields from the table: "accounting.journal_entry" */
  selectJournalEntryAggregate: JournalEntry_Aggregate;
  /** fetch data from the table: "accounting.journal_entry_line" using primary key columns */
  selectJournalEntryLine?: Maybe<JournalEntryLine>;
  /** fetch aggregated fields from the table: "accounting.journal_entry_line" */
  selectJournalEntryLineAggregate: JournalEntryLine_Aggregate;
  /** fetch data from the table: "accounting.journal_entry_line" */
  selectJournalEntryLines: Array<JournalEntryLine>;
  /** fetch data from the table: "labor_guide_type" using primary key columns */
  selectLaborGuideType?: Maybe<LaborGuideType>;
  /** fetch aggregated fields from the table: "labor_guide_type" */
  selectLaborGuideTypeAggregate: LaborGuideType_Aggregate;
  /** fetch data from the table: "labor_guide_type" */
  selectLaborGuideTypes: Array<LaborGuideType>;
  /** fetch data from the table: "claims.labor_rate" using primary key columns */
  selectLaborRate?: Maybe<LaborRate>;
  /** fetch data from the table: "claims.labor_rate_as400" using primary key columns */
  selectLaborRateAs400?: Maybe<LaborRateAs400>;
  /** fetch data from the table: "claims.labor_rate_as400" */
  selectLaborRateAs400s: Array<LaborRateAs400>;
  /** fetch data from the table: "claims.labor_rate" */
  selectLaborRates: Array<LaborRate>;
  /** fetch data from the table: "operations.legacy_policy_contract" using primary key columns */
  selectLegacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** fetch aggregated fields from the table: "operations.legacy_policy_contract" */
  selectLegacyPolicyContractAggregate: LegacyPolicyContract_Aggregate;
  /** fetch data from the table: "operations.legacy_policy_contract" */
  selectLegacyPolicyContracts: Array<LegacyPolicyContract>;
  /** fetch aggregated fields from the table: "audit.logged_actions" */
  selectLoggedActionAggregate: LoggedAction_Aggregate;
  /** fetch data from the table: "audit.logged_actions" */
  selectLoggedActions: Array<LoggedAction>;
  /** fetch data from the table: "reporting.loss_ratio" using primary key columns */
  selectLossRatio?: Maybe<LossRatio>;
  /** fetch aggregated fields from the table: "reporting.loss_ratio_current_view" */
  selectLossRatioCurrentViewAggregate: LossRatioCurrentView_Aggregate;
  /** fetch data from the table: "reporting.loss_ratio_current_view" */
  selectLossRatioCurrentViews: Array<LossRatioCurrentView>;
  /** fetch data from the table: "reporting.loss_ratio" */
  selectLossRatios: Array<LossRatio>;
  /** fetch aggregated fields from the table: "reporting.loss_ratio" */
  selectLossRatiosAggregate: LossRatio_Aggregate;
  /** fetch aggregated fields from the table: "classes.materalized_class_criteria_view_default_vehicle_criteria" */
  selectMateralizedClassCriteriaViewDefaultVehicleCriteriaAggregate: MateralizedClassCriteriaViewDefaultVehicleCriteria_Aggregate;
  /** fetch data from the table: "classes.materalized_class_criteria_view_default_vehicle_criteria" */
  selectMateralizedClassCriteriaViewDefaultVehicleCriterias: Array<MateralizedClassCriteriaViewDefaultVehicleCriteria>;
  /** fetch data from the table: "miles_calculation_type" using primary key columns */
  selectMilesCalculationType?: Maybe<MilesCalculationType>;
  /** fetch aggregated fields from the table: "miles_calculation_type" */
  selectMilesCalculationTypeAggregate: MilesCalculationType_Aggregate;
  /** fetch data from the table: "miles_calculation_type" */
  selectMilesCalculationTypes: Array<MilesCalculationType>;
  /** fetch aggregated fields from the table: "nhtsa.concern_synonym" */
  selectNhtsaConcernSynonymAggregate: ConcernSynonym_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.concern_synonym" */
  selectNhtsaConcernSynonyms: Array<ConcernSynonym_Nhtsa>;
  /** fetch data from the table: "nhtsa.investigation_recall" using primary key columns */
  selectNhtsaInvestigationRecall?: Maybe<InvestigationRecall_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.investigation_recall" */
  selectNhtsaInvestigationRecallAggregate: InvestigationRecall_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.investigation_recall" */
  selectNhtsaInvestigationRecalls: Array<InvestigationRecall_Nhtsa>;
  /** fetch data from the table: "nhtsa.issue" using primary key columns */
  selectNhtsaIssue?: Maybe<Issue_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.issue" */
  selectNhtsaIssueAggregate: Issue_Aggregate_Nhtsa;
  /** fetch aggregated fields from the table: "nhtsa.issue_make_model" */
  selectNhtsaIssueMakeModelAggregate: IssueMakeModel_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.issue_make_model" */
  selectNhtsaIssueMakeModels: Array<IssueMakeModel_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.issue_search_result" */
  selectNhtsaIssueSearchResultAggregate: IssueSearchResult_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.issue_search_result" */
  selectNhtsaIssueSearchResults: Array<IssueSearchResult_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.issue_vehicle" */
  selectNhtsaIssueVehicleAggregate: IssueVehicle_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.issue_vehicle" */
  selectNhtsaIssueVehicles: Array<IssueVehicle_Nhtsa>;
  /** fetch data from the table: "nhtsa.issue" */
  selectNhtsaIssues: Array<Issue_Nhtsa>;
  /** fetch data from the table: "nhtsa.load" using primary key columns */
  selectNhtsaLoad?: Maybe<Load_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.load" */
  selectNhtsaLoadAggregate: Load_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.load" */
  selectNhtsaLoads: Array<Load_Nhtsa>;
  /** fetch data from the table: "nhtsa.make_model" using primary key columns */
  selectNhtsaMakeModel?: Maybe<MakeModel_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.make_model" */
  selectNhtsaMakeModelAggregate: MakeModel_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.make_model" */
  selectNhtsaMakeModels: Array<MakeModel_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.model_year_model" */
  selectNhtsaModelYearModelAggregate: ModelYearModel_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.model_year_model" */
  selectNhtsaModelYearModels: Array<ModelYearModel_Nhtsa>;
  /** fetch data from the table: "nhtsa.record_type" using primary key columns */
  selectNhtsaRecordType?: Maybe<RecordType_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.record_type" */
  selectNhtsaRecordTypeAggregate: RecordType_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.record_type" */
  selectNhtsaRecordTypes: Array<RecordType_Nhtsa>;
  /** fetch data from the table: "obligor" using primary key columns */
  selectObligor?: Maybe<Obligor>;
  /** fetch data from the table: "obligor" */
  selectObligors: Array<Obligor>;
  /** fetch aggregated fields from the table: "obligor" */
  selectObligorsAggregate: Obligor_Aggregate;
  /** fetch data from the table: "job" using primary key columns */
  selectObsoleteJob?: Maybe<ObsoleteJob>;
  /** fetch aggregated fields from the table: "job" */
  selectObsoleteJobAggregate: ObsoleteJob_Aggregate;
  /** fetch data from the table: "job" */
  selectObsoleteJobs: Array<ObsoleteJob>;
  /** fetch data from the table: "system.outbox_event" using primary key columns */
  selectOutboxEvent?: Maybe<OutboxEvent>;
  /** fetch aggregated fields from the table: "system.outbox_event" */
  selectOutboxEventAggregate: OutboxEvent_Aggregate;
  /** fetch data from the table: "system.outbox_event" */
  selectOutboxEvents: Array<OutboxEvent>;
  /** fetch data from the table: "shared.participant" using primary key columns */
  selectParticipant?: Maybe<Participant>;
  /** fetch aggregated fields from the table: "shared.participant" */
  selectParticipantAggregate: Participant_Aggregate;
  /** fetch data from the table: "shared.participant" */
  selectParticipants: Array<Participant>;
  /** fetch data from the table: "accounting.payee" using primary key columns */
  selectPayee?: Maybe<Payee>;
  /** fetch data from the table: "accounting.payee_as400" using primary key columns */
  selectPayeeAs400?: Maybe<PayeeAs400>;
  /** fetch aggregated fields from the table: "accounting.payee_as400" */
  selectPayeeAs400Aggregate: PayeeAs400_Aggregate;
  /** fetch data from the table: "accounting.payee_as400" */
  selectPayeeAs400s: Array<PayeeAs400>;
  /** fetch aggregated fields from the table: "accounting.payee_link_view" */
  selectPayeeLinkViewAggregate: PayeeLinkView_Aggregate;
  /** fetch data from the table: "accounting.payee_link_view" */
  selectPayeeLinkViews: Array<PayeeLinkView>;
  /** fetch data from the table: "accounting.payee" */
  selectPayees: Array<Payee>;
  /** fetch aggregated fields from the table: "accounting.payee" */
  selectPayeesAggregate: Payee_Aggregate;
  /** fetch data from the table: "shared.payment" using primary key columns */
  selectPayment?: Maybe<Payment>;
  /** fetch aggregated fields from the table: "shared.payment" */
  selectPaymentAggregate: Payment_Aggregate;
  /** fetch data from the table: "shared.payment_as400" using primary key columns */
  selectPaymentAs400?: Maybe<PaymentAs400>;
  /** fetch data from the table: "shared.payment_as400" */
  selectPaymentAs400s: Array<PaymentAs400>;
  /** fetch data from the table: "shared.payment_detail" using primary key columns */
  selectPaymentDetail?: Maybe<PaymentDetail>;
  /** fetch aggregated fields from the table: "shared.payment_detail" */
  selectPaymentDetailAggregate: PaymentDetail_Aggregate;
  /** fetch data from the table: "shared.payment_detail" */
  selectPaymentDetails: Array<PaymentDetail>;
  /** fetch data from the table: "shared.payment_method_type" using primary key columns */
  selectPaymentMethodType?: Maybe<PaymentMethodType>;
  /** fetch aggregated fields from the table: "shared.payment_method_type" */
  selectPaymentMethodTypeAggregate: PaymentMethodType_Aggregate;
  /** fetch data from the table: "shared.payment_method_type" */
  selectPaymentMethodTypes: Array<PaymentMethodType>;
  /** fetch data from the table: "shared.payment_status_type" using primary key columns */
  selectPaymentStatusType?: Maybe<PaymentStatusType>;
  /** fetch aggregated fields from the table: "shared.payment_status_type" */
  selectPaymentStatusTypeAggregate: PaymentStatusType_Aggregate;
  /** fetch data from the table: "shared.payment_status_type" */
  selectPaymentStatusTypes: Array<PaymentStatusType>;
  /** fetch data from the table: "shared.payment_type" using primary key columns */
  selectPaymentType?: Maybe<PaymentType>;
  /** fetch data from the table: "shared.payment_type" */
  selectPaymentTypes: Array<PaymentType>;
  /** fetch data from the table: "shared.payment" */
  selectPayments: Array<Payment>;
  /** fetch data from the table: "Plan" using primary key columns */
  selectPlan?: Maybe<Plan>;
  /** fetch aggregated fields from the table: "Plan" */
  selectPlanAggregate: Plan_Aggregate;
  /** fetch data from the table: "Plan" */
  selectPlans: Array<Plan>;
  /** fetch data from the table: "operations.policy" */
  selectPolicies: Array<Policy>;
  /** fetch aggregated fields from the table: "operations.policy" */
  selectPoliciesAggregate: Policy_Aggregate;
  /** fetch data from the table: "operations.policy" using primary key columns */
  selectPolicy?: Maybe<Policy>;
  /** fetch data from the table: "claims.policy_claim" using primary key columns */
  selectPolicyClaim?: Maybe<PolicyClaim>;
  /** fetch aggregated fields from the table: "claims.policy_claim" */
  selectPolicyClaimAggregate: PolicyClaim_Aggregate;
  /** fetch data from the table: "claims.policy_claim_as400" using primary key columns */
  selectPolicyClaimAs400?: Maybe<PolicyClaimAs400>;
  /** fetch data from the table: "claims.policy_claim_as400" */
  selectPolicyClaimAs400s: Array<PolicyClaimAs400>;
  /** fetch data from the table: "claims.policy_claim_concern" using primary key columns */
  selectPolicyClaimConcern?: Maybe<PolicyClaimConcern>;
  /** fetch aggregated fields from the table: "claims.policy_claim_concern" */
  selectPolicyClaimConcernAggregate: PolicyClaimConcern_Aggregate;
  /** fetch data from the table: "claims.policy_claim_concern" */
  selectPolicyClaimConcerns: Array<PolicyClaimConcern>;
  /** fetch data from the table: "claims.policy_claim_insurance" using primary key columns */
  selectPolicyClaimInsurance?: Maybe<PolicyClaimInsurance>;
  /** fetch data from the table: "claims.policy_claim_insurance" */
  selectPolicyClaimInsurances: Array<PolicyClaimInsurance>;
  /** fetch data from the table: "claims.policy_claim" */
  selectPolicyClaims: Array<PolicyClaim>;
  /** comment about pk */
  selectPolicyContract?: Maybe<PolicyContract>;
  /** fetch data from the table: "operations.policy_contract_asset" using primary key columns */
  selectPolicyContractAsset?: Maybe<PolicyContractAsset>;
  /** fetch data from the table: "operations.policy_contract_asset_type" using primary key columns */
  selectPolicyContractAssetType?: Maybe<PolicyContractAssetType>;
  /** fetch aggregated fields from the table: "operations.policy_contract_asset_type" */
  selectPolicyContractAssetTypeAggregate: PolicyContractAssetType_Aggregate;
  /** fetch data from the table: "operations.policy_contract_asset_type" */
  selectPolicyContractAssetTypes: Array<PolicyContractAssetType>;
  /** fetch data from the table: "operations.policy_contract_asset" */
  selectPolicyContractAssets: Array<PolicyContractAsset>;
  /** fetch aggregated fields from the table: "operations.policy_contract_asset" */
  selectPolicyContractAssetsAggregate: PolicyContractAsset_Aggregate;
  /** fetch data from the table: "operations.policy_contract_contract_form_version" using primary key columns */
  selectPolicyContractContractFormVersion?: Maybe<PolicyContractContractFormVersion>;
  /** fetch aggregated fields from the table: "operations.policy_contract_contract_form_version" */
  selectPolicyContractContractFormVersionAggregate: PolicyContractContractFormVersion_Aggregate;
  /** fetch data from the table: "operations.policy_contract_contract_form_version" */
  selectPolicyContractContractFormVersions: Array<PolicyContractContractFormVersion>;
  /** fetch data from the table: "operations.policy_contract_cost_detail" using primary key columns */
  selectPolicyContractCostDetail?: Maybe<PolicyContractCostDetail>;
  /** fetch data from the table: "operations.policy_contract_cost_detail" */
  selectPolicyContractCostDetails: Array<PolicyContractCostDetail>;
  /** fetch aggregated fields from the table: "operations.policy_contract_cost_detail" */
  selectPolicyContractCostDetailsAggregate: PolicyContractCostDetail_Aggregate;
  /** fetch data from the table: "operations.policy_contract_lender" using primary key columns */
  selectPolicyContractLender?: Maybe<PolicyContractLender>;
  /** fetch data from the table: "operations.policy_contract_lender" */
  selectPolicyContractLenders: Array<PolicyContractLender>;
  /** fetch aggregated fields from the table: "operations.policy_contract_lender" */
  selectPolicyContractLendersAggregate: PolicyContractLender_Aggregate;
  /** fetch aggregated fields from the table: "operations.policy_contract_list_view" */
  selectPolicyContractListViewAggregate: PolicyContractListView_Aggregate;
  /** fetch data from the table: "operations.policy_contract_list_view" */
  selectPolicyContractListViews: Array<PolicyContractListView>;
  /** fetch data from the table: "operations.policy_contract_loan_contract_type" using primary key columns */
  selectPolicyContractLoanContractType?: Maybe<PolicyContractLoanContractType>;
  /** fetch aggregated fields from the table: "operations.policy_contract_loan_contract_type" */
  selectPolicyContractLoanContractTypeAggregate: PolicyContractLoanContractType_Aggregate;
  /** fetch data from the table: "operations.policy_contract_loan_contract_type" */
  selectPolicyContractLoanContractTypes: Array<PolicyContractLoanContractType>;
  /** fetch data from the table: "operations.policy_contract_owner" using primary key columns */
  selectPolicyContractOwner?: Maybe<PolicyContractOwner>;
  /** fetch data from the table: "operations.policy_contract_owner" */
  selectPolicyContractOwners: Array<PolicyContractOwner>;
  /** fetch aggregated fields from the table: "operations.policy_contract_owner" */
  selectPolicyContractOwnersAggregate: PolicyContractOwner_Aggregate;
  /** fetch data from the table: "operations.policy_contract_product" using primary key columns */
  selectPolicyContractProduct?: Maybe<PolicyContractProduct>;
  /** fetch aggregated fields from the table: "operations.policy_contract_product" */
  selectPolicyContractProductAggregate: PolicyContractProduct_Aggregate;
  /** fetch data from the table: "operations.policy_contract_product_cost_detail" using primary key columns */
  selectPolicyContractProductCostDetail?: Maybe<PolicyContractProductCostDetail>;
  /** fetch aggregated fields from the table: "operations.policy_contract_product_cost_detail" */
  selectPolicyContractProductCostDetailAggregate: PolicyContractProductCostDetail_Aggregate;
  /** fetch data from the table: "operations.policy_contract_product_cost_detail" */
  selectPolicyContractProductCostDetails: Array<PolicyContractProductCostDetail>;
  /** fetch aggregated fields from the table: "operations.policy_contract_product_options_metadata_view" */
  selectPolicyContractProductOptionsMetadataViewAggregate: PolicyContractProductOptionsMetadataView_Aggregate;
  /** fetch data from the table: "operations.policy_contract_product_options_metadata_view" */
  selectPolicyContractProductOptionsMetadataViews: Array<PolicyContractProductOptionsMetadataView>;
  /** fetch data from the table: "operations.policy_contract_product" */
  selectPolicyContractProducts: Array<PolicyContractProduct>;
  /** fetch data from the table: "operations.policy_contract_quote" using primary key columns */
  selectPolicyContractQuote?: Maybe<PolicyContractQuote>;
  /** fetch aggregated fields from the table: "operations.policy_contract_quote" */
  selectPolicyContractQuoteAggregate: PolicyContractQuote_Aggregate;
  /** fetch data from the table: "operations.policy_contract_quote" */
  selectPolicyContractQuotes: Array<PolicyContractQuote>;
  /** fetch data from the table: "operations.policy_contract_status_type" using primary key columns */
  selectPolicyContractStatusType?: Maybe<PolicyContractStatusType>;
  /** fetch aggregated fields from the table: "operations.policy_contract_status_type" */
  selectPolicyContractStatusTypeAggregate: PolicyContractStatusType_Aggregate;
  /** fetch data from the table: "operations.policy_contract_status_type" */
  selectPolicyContractStatusTypes: Array<PolicyContractStatusType>;
  /** fetch data from the table: "operations.policy_contract_void_reason_type" using primary key columns */
  selectPolicyContractVoidReasonType?: Maybe<PolicyContractVoidReasonType>;
  /** fetch aggregated fields from the table: "operations.policy_contract_void_reason_type" */
  selectPolicyContractVoidReasonTypeAggregate: PolicyContractVoidReasonType_Aggregate;
  /** fetch data from the table: "operations.policy_contract_void_reason_type" */
  selectPolicyContractVoidReasonTypes: Array<PolicyContractVoidReasonType>;
  /** comment about this */
  selectPolicyContracts: Array<PolicyContract>;
  /** fetch aggregated fields from the table: "operations.policy_contract" */
  selectPolicyContractsAggregate: PolicyContract_Aggregate;
  /** fetch data from the table: "claims.pre_authorization" using primary key columns */
  selectPreAuthorization?: Maybe<PreAuthorization>;
  /** fetch data from the table: "claims.pre_authorization_status_type" using primary key columns */
  selectPreAuthorizationStatusType?: Maybe<PreAuthorizationStatusType>;
  /** fetch aggregated fields from the table: "claims.pre_authorization_status_type" */
  selectPreAuthorizationStatusTypeAggregate: PreAuthorizationStatusType_Aggregate;
  /** fetch data from the table: "claims.pre_authorization_status_type" */
  selectPreAuthorizationStatusTypes: Array<PreAuthorizationStatusType>;
  /** fetch data from the table: "claims.pre_authorization_type" using primary key columns */
  selectPreAuthorizationType?: Maybe<PreAuthorizationType>;
  /** fetch data from the table: "claims.pre_authorization_type" */
  selectPreAuthorizationTypes: Array<PreAuthorizationType>;
  /** fetch aggregated fields from the table: "claims.pre_authorization_type" */
  selectPreAuthorizationTypesAggregate: PreAuthorizationType_Aggregate;
  /** fetch data from the table: "claims.pre_authorization" */
  selectPreAuthorizations: Array<PreAuthorization>;
  /** fetch aggregated fields from the table: "claims.pre_authorization" */
  selectPreAuthorizationsAggregate: PreAuthorization_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  selectProduct?: Maybe<Product>;
  /** fetch data from the table: "product_attribute" using primary key columns */
  selectProductAttribute?: Maybe<ProductAttribute>;
  /** fetch aggregated fields from the table: "product_attribute" */
  selectProductAttributeAggregate: ProductAttribute_Aggregate;
  /** fetch data from the table: "product_attribute_type" using primary key columns */
  selectProductAttributeType?: Maybe<ProductAttributeType>;
  /** fetch aggregated fields from the table: "product_attribute_type" */
  selectProductAttributeTypeAggregate: ProductAttributeType_Aggregate;
  /** fetch data from the table: "product_attribute_type" */
  selectProductAttributeTypes: Array<ProductAttributeType>;
  /** fetch data from the table: "product_attribute" */
  selectProductAttributes: Array<ProductAttribute>;
  /** fetch data from the table: "product_class_guide" using primary key columns */
  selectProductClassGuide?: Maybe<ProductClassGuide>;
  /** fetch aggregated fields from the table: "product_class_guide" */
  selectProductClassGuideAggregate: ProductClassGuide_Aggregate;
  /** fetch data from the table: "product_class_guide" */
  selectProductClassGuides: Array<ProductClassGuide>;
  /** fetch data from the table: "compliance.product_contract_form" using primary key columns */
  selectProductContractForm?: Maybe<ProductContractForm>;
  /** fetch aggregated fields from the table: "compliance.product_contract_form" */
  selectProductContractFormAggregate: ProductContractForm_Aggregate;
  /** fetch data from the table: "compliance.product_contract_form" */
  selectProductContractForms: Array<ProductContractForm>;
  /** fetch data from the table: "product_cost" using primary key columns */
  selectProductCost?: Maybe<ProductCost>;
  /** fetch aggregated fields from the table: "product_cost" */
  selectProductCostAggregate: ProductCost_Aggregate;
  /** fetch data from the table: "product_cost" */
  selectProductCosts: Array<ProductCost>;
  /** fetch data from the table: "product_disbursement" using primary key columns */
  selectProductDisbursement?: Maybe<ProductDisbursement>;
  /** fetch aggregated fields from the table: "product_disbursement" */
  selectProductDisbursementAggregate: ProductDisbursement_Aggregate;
  /** fetch data from the table: "product_disbursement" */
  selectProductDisbursements: Array<ProductDisbursement>;
  /** fetch data from the table: "product_eligibility_rule" */
  selectProductEligibilities: Array<ProductEligibility>;
  /** fetch data from the table: "product_eligibility_rule" using primary key columns */
  selectProductEligibility?: Maybe<ProductEligibility>;
  /** fetch aggregated fields from the table: "product_eligibility_rule" */
  selectProductEligibilityAggregate: ProductEligibility_Aggregate;
  /** fetch data from the table: "product_obligor" using primary key columns */
  selectProductObligor?: Maybe<ProductObligor>;
  /** fetch data from the table: "product_obligor" */
  selectProductObligors: Array<ProductObligor>;
  /** fetch aggregated fields from the table: "product_obligor" */
  selectProductObligorsAggregate: ProductObligor_Aggregate;
  /** fetch data from the table: "product_rate_bucket" using primary key columns */
  selectProductRateBucket?: Maybe<ProductRateBucket>;
  /** fetch aggregated fields from the table: "product_rate_bucket" */
  selectProductRateBucketAggregate: ProductRateBucket_Aggregate;
  /** fetch data from the table: "product_rate_bucket" */
  selectProductRateBuckets: Array<ProductRateBucket>;
  /** fetch data from the table: "product_surcharge_type" using primary key columns */
  selectProductSurchargeType?: Maybe<ProductSurchargeType>;
  /** fetch aggregated fields from the table: "product_surcharge_type" */
  selectProductSurchargeTypeAggregate: ProductSurchargeType_Aggregate;
  /** fetch data from the table: "product_surcharge_type" */
  selectProductSurchargeTypes: Array<ProductSurchargeType>;
  /** fetch data from the table: "product" */
  selectProducts: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  selectProductsAggregate: Product_Aggregate;
  /** fetch data from the table: "users.profile" using primary key columns */
  selectProfile?: Maybe<Profile>;
  /** fetch aggregated fields from the table: "users.profile" */
  selectProfileAggregate: Profile_Aggregate;
  /** fetch data from the table: "users.profile" */
  selectProfiles: Array<Profile>;
  /** fetch data from the table: "quotes.quote" using primary key columns */
  selectQuote?: Maybe<Quote>;
  /** fetch aggregated fields from the table: "quotes.quote" */
  selectQuoteAggregate: Quote_Aggregate;
  /** fetch aggregated fields from the table: "quotes.quote_minimal_view" */
  selectQuoteMinimalViewAggregate: QuoteMinimalView_Aggregate;
  /** fetch data from the table: "quotes.quote_minimal_view" */
  selectQuoteMinimalViews: Array<QuoteMinimalView>;
  /** fetch data from the table: "quotes.quote_type" using primary key columns */
  selectQuoteType?: Maybe<QuoteType>;
  /** fetch aggregated fields from the table: "quotes.quote_type" */
  selectQuoteTypeAggregate: QuoteType_Aggregate;
  /** fetch data from the table: "quotes.quote_type" */
  selectQuoteTypes: Array<QuoteType>;
  /** fetch data from the table: "quotes.quote" */
  selectQuotes: Array<Quote>;
  /** fetch data from the table: "rate_bucket_type" using primary key columns */
  selectRateBucketType?: Maybe<RateBucketType>;
  /** fetch aggregated fields from the table: "rate_bucket_type" */
  selectRateBucketTypeAggregate: RateBucketType_Aggregate;
  /** fetch data from the table: "rate_bucket_type" */
  selectRateBucketTypes: Array<RateBucketType>;
  /** fetch data from the table: "rate_quote" using primary key columns */
  selectRateQuote?: Maybe<RateQuote>;
  /** fetch data from the table: "rate_quote" */
  selectRateQuotes: Array<RateQuote>;
  /** fetch aggregated fields from the table: "rate_quote" */
  selectRateQuotesAggregate: RateQuote_Aggregate;
  /** fetch data from the table: "ui.rater_view_config" using primary key columns */
  selectRaterViewConfig?: Maybe<RaterViewConfig>;
  /** fetch data from the table: "ui.rater_view_config" */
  selectRaterViewConfigs: Array<RaterViewConfig>;
  /** fetch data from the table: "system.reference_log" using primary key columns */
  selectReferenceLog?: Maybe<ReferenceLog>;
  /** fetch aggregated fields from the table: "system.reference_log" */
  selectReferenceLogAggregate: ReferenceLog_Aggregate;
  /** fetch data from the table: "system.reference_log" */
  selectReferenceLogs: Array<ReferenceLog>;
  /** fetch data from the table: "operations.remittance" using primary key columns */
  selectRemittance?: Maybe<Remittance>;
  /** fetch aggregated fields from the table: "operations.remittance" */
  selectRemittanceAggregate: Remittance_Aggregate;
  /** fetch data from the table: "claims.remittance_claim_detail" using primary key columns */
  selectRemittanceClaimDetail?: Maybe<RemittanceClaimDetail>;
  /** fetch data from the table: "claims.remittance_claim_detail" */
  selectRemittanceClaimDetails: Array<RemittanceClaimDetail>;
  /** fetch data from the table: "operations.remittance_payment" using primary key columns */
  selectRemittancePayment?: Maybe<RemittancePayment>;
  /** fetch aggregated fields from the table: "operations.remittance_payment" */
  selectRemittancePaymentAggregate: RemittancePayment_Aggregate;
  /** fetch data from the table: "operations.remittance_payment" */
  selectRemittancePayments: Array<RemittancePayment>;
  /** fetch data from the table: "operations.remittance_policy_contract" using primary key columns */
  selectRemittancePolicyContract?: Maybe<RemittancePolicyContract>;
  /** fetch aggregated fields from the table: "operations.remittance_policy_contract" */
  selectRemittancePolicyContractAggregate: RemittancePolicyContract_Aggregate;
  /** fetch data from the table: "operations.remittance_policy_contract_as400" using primary key columns */
  selectRemittancePolicyContractAs400?: Maybe<RemittancePolicyContractAs400>;
  /** fetch aggregated fields from the table: "operations.remittance_policy_contract_as400" */
  selectRemittancePolicyContractAs400Aggregate: RemittancePolicyContractAs400_Aggregate;
  /** fetch data from the table: "operations.remittance_policy_contract_as400" */
  selectRemittancePolicyContractAs400s: Array<RemittancePolicyContractAs400>;
  /** fetch data from the table: "operations.remittance_policy_contract" */
  selectRemittancePolicyContracts: Array<RemittancePolicyContract>;
  /** fetch data from the table: "operations.remittance_status_type" using primary key columns */
  selectRemittanceStatusType?: Maybe<RemittanceStatusType>;
  /** fetch aggregated fields from the table: "operations.remittance_status_type" */
  selectRemittanceStatusTypeAggregate: RemittanceStatusType_Aggregate;
  /** fetch data from the table: "operations.remittance_status_type" */
  selectRemittanceStatusTypes: Array<RemittanceStatusType>;
  /** fetch data from the table: "operations.remittance_type" using primary key columns */
  selectRemittanceType?: Maybe<RemittanceType>;
  /** fetch aggregated fields from the table: "operations.remittance_type" */
  selectRemittanceTypeAggregate: RemittanceType_Aggregate;
  /** fetch data from the table: "operations.remittance_type" */
  selectRemittanceTypes: Array<RemittanceType>;
  /** fetch data from the table: "operations.remittance" */
  selectRemittances: Array<Remittance>;
  /** fetch data from the table: "claims.repeat_part_acknowledgment" using primary key columns */
  selectRepeatPartAcknowledgment?: Maybe<RepeatPartAcknowledgment>;
  /** fetch aggregated fields from the table: "claims.repeat_part_acknowledgment" */
  selectRepeatPartAcknowledgmentAggregate: RepeatPartAcknowledgment_Aggregate;
  /** fetch data from the table: "claims.repeat_part_acknowledgment" */
  selectRepeatPartAcknowledgments: Array<RepeatPartAcknowledgment>;
  /** fetch data from the table: "auth.role" using primary key columns */
  selectRole?: Maybe<Role>;
  /** fetch aggregated fields from the table: "auth.role" */
  selectRoleAggregate: Role_Aggregate;
  /** fetch data from the table: "auth.role_attribute" using primary key columns */
  selectRoleAttribute?: Maybe<RoleAttribute>;
  /** fetch aggregated fields from the table: "auth.role_attribute" */
  selectRoleAttributeAggregate: RoleAttribute_Aggregate;
  /** fetch data from the table: "auth.role_attribute" */
  selectRoleAttributes: Array<RoleAttribute>;
  /** fetch aggregated fields from the table: "auth.role_hierarchy_view" */
  selectRoleHierarchyViewAggregate: RoleHierarchyView_Aggregate;
  /** fetch data from the table: "auth.role_hierarchy_view" */
  selectRoleHierarchyViews: Array<RoleHierarchyView>;
  /** fetch data from the table: "auth.role" */
  selectRoles: Array<Role>;
  /** fetch data from the table: "auth.route" using primary key columns */
  selectRoute?: Maybe<Route>;
  /** fetch aggregated fields from the table: "auth.route" */
  selectRouteAggregate: Route_Aggregate;
  /** fetch data from the table: "auth.route_config" using primary key columns */
  selectRouteConfig?: Maybe<RouteConfig>;
  /** fetch aggregated fields from the table: "auth.route_config" */
  selectRouteConfigAggregate: RouteConfig_Aggregate;
  /** fetch data from the table: "auth.route_config" */
  selectRouteConfigs: Array<RouteConfig>;
  /** fetch data from the table: "auth.route" */
  selectRoutes: Array<Route>;
  /** fetch data from the table: "shared.search_index" using primary key columns */
  selectSearchIndex?: Maybe<SearchIndex>;
  /** fetch aggregated fields from the table: "shared.search_index" */
  selectSearchIndexAggregate: SearchIndex_Aggregate;
  /** fetch data from the table: "shared.search_index" */
  selectSearchIndexes: Array<SearchIndex>;
  /** fetch data from the table: "claims.service_center" using primary key columns */
  selectServiceCenter?: Maybe<ServiceCenter>;
  /** fetch aggregated fields from the table: "claims.service_center" */
  selectServiceCenterAggregate: ServiceCenter_Aggregate;
  /** fetch data from the table: "claims.service_center" */
  selectServiceCenters: Array<ServiceCenter>;
  /** fetch data from the table: "system.severity_level_type" using primary key columns */
  selectSeverityLevelType?: Maybe<SeverityLevelType>;
  /** fetch aggregated fields from the table: "system.severity_level_type" */
  selectSeverityLevelTypeAggregate: SeverityLevelType_Aggregate;
  /** fetch data from the table: "system.severity_level_type" */
  selectSeverityLevelTypes: Array<SeverityLevelType>;
  /** fetch data from the table: "users.shortcut_binding" using primary key columns */
  selectShortcutBinding?: Maybe<ShortcutBinding>;
  /** fetch aggregated fields from the table: "users.shortcut_binding" */
  selectShortcutBindingAggregate: ShortcutBinding_Aggregate;
  /** fetch data from the table: "users.shortcut_binding" */
  selectShortcutBindings: Array<ShortcutBinding>;
  /** fetch data from the table: "state" using primary key columns */
  selectState?: Maybe<State>;
  /** fetch data from the table: "state" */
  selectStates: Array<State>;
  /** fetch aggregated fields from the table: "state" */
  selectStatesAggregate: State_Aggregate;
  /** fetch data from the table: "system.step" using primary key columns */
  selectStep?: Maybe<Step>;
  /** fetch aggregated fields from the table: "system.step" */
  selectStepAggregate: Step_Aggregate;
  /** fetch data from the table: "system.step_list_view" */
  selectStepListViews: Array<StepListView>;
  /** fetch data from the table: "system.step_type" using primary key columns */
  selectStepType?: Maybe<StepType>;
  /** fetch aggregated fields from the table: "system.step_type" */
  selectStepTypeAggregate: StepType_Aggregate;
  /** fetch data from the table: "system.step_type" */
  selectStepTypes: Array<StepType>;
  /** fetch data from the table: "system.step" */
  selectSteps: Array<Step>;
  /** fetch data from the table: "surcharge_type" using primary key columns */
  selectSurchargeType?: Maybe<SurchargeType>;
  /** fetch aggregated fields from the table: "surcharge_type" */
  selectSurchargeTypeAggregate: SurchargeType_Aggregate;
  /** fetch data from the table: "surcharge_type" */
  selectSurchargeTypes: Array<SurchargeType>;
  /** fetch data from the table: "shared.tag" using primary key columns */
  selectTag?: Maybe<Tag>;
  /** fetch aggregated fields from the table: "shared.tag" */
  selectTagAggregate: Tag_Aggregate;
  /** fetch data from the table: "shared.tag" */
  selectTags: Array<Tag>;
  /** fetch data from the table: "task" using primary key columns */
  selectTask?: Maybe<Task>;
  /** fetch aggregated fields from the table: "task" */
  selectTaskAggregate: Task_Aggregate;
  /** fetch data from the table: "task" */
  selectTasks: Array<Task>;
  /** fetch data from the table: "claims.tax_rate" using primary key columns */
  selectTaxRate?: Maybe<TaxRate>;
  /** fetch data from the table: "claims.tax_rate_as400" using primary key columns */
  selectTaxRateAs400?: Maybe<TaxRateAs400>;
  /** fetch data from the table: "claims.tax_rate_as400" */
  selectTaxRateAs400s: Array<TaxRateAs400>;
  /** fetch data from the table: "claims.tax_rate" */
  selectTaxRates: Array<TaxRate>;
  /** fetch data from the table: "system.technology_type" using primary key columns */
  selectTechnologyType?: Maybe<TechnologyType>;
  /** fetch aggregated fields from the table: "system.technology_type" */
  selectTechnologyTypeAggregate: TechnologyType_Aggregate;
  /** fetch data from the table: "system.technology_type" */
  selectTechnologyTypes: Array<TechnologyType>;
  /** fetch data from the table: "shared.type" using primary key columns */
  selectType?: Maybe<Type>;
  /** fetch aggregated fields from the table: "shared.type" */
  selectTypeAggregate: Type_Aggregate;
  /** fetch data from the table: "shared.type_group" using primary key columns */
  selectTypeGroup?: Maybe<TypeGroup>;
  /** fetch aggregated fields from the table: "shared.type_group" */
  selectTypeGroupAggregate: TypeGroup_Aggregate;
  /** fetch data from the table: "shared.type_group" */
  selectTypeGroups: Array<TypeGroup>;
  /** fetch data from the table: "shared.type" */
  selectTypes: Array<Type>;
  /** fetch data from the table: "auth.user" using primary key columns */
  selectUser?: Maybe<User>;
  /** fetch aggregated fields from the table: "auth.user" */
  selectUserAggregate: User_Aggregate;
  /** fetch data from the table: "auth.user_flow_item" using primary key columns */
  selectUserFlowItem?: Maybe<UserFlowItem>;
  /** fetch aggregated fields from the table: "auth.user_flow_item" */
  selectUserFlowItemAggregate: UserFlowItem_Aggregate;
  /** fetch data from the table: "auth.user_flow_item_mfa" using primary key columns */
  selectUserFlowItemMfa?: Maybe<UserFlowItemMfa>;
  /** fetch aggregated fields from the table: "auth.user_flow_item_mfa" */
  selectUserFlowItemMfaAggregate: UserFlowItemMfa_Aggregate;
  /** fetch data from the table: "auth.user_flow_item_mfa" */
  selectUserFlowItemMfas: Array<UserFlowItemMfa>;
  /** fetch data from the table: "auth.user_flow_item" */
  selectUserFlowItems: Array<UserFlowItem>;
  /** fetch data from the table: "auth.user_group" using primary key columns */
  selectUserGroup?: Maybe<UserGroup>;
  /** fetch aggregated fields from the table: "auth.user_group" */
  selectUserGroupAggregate: UserGroup_Aggregate;
  /** fetch data from the table: "auth.user_group" */
  selectUserGroups: Array<UserGroup>;
  /** fetch data from the table: "user_pin" using primary key columns */
  selectUserPin?: Maybe<UserPin>;
  /** fetch data from the table: "user_pin" */
  selectUserPins: Array<UserPin>;
  /** fetch aggregated fields from the table: "user_pin" */
  selectUserPinsAggregate: UserPin_Aggregate;
  /** fetch data from the table: "auth.user_profile" using primary key columns */
  selectUserProfile?: Maybe<UserProfile>;
  /** fetch aggregated fields from the table: "auth.user_profile" */
  selectUserProfileAggregate: UserProfile_Aggregate;
  /** fetch data from the table: "auth.user_profile" */
  selectUserProfiles: Array<UserProfile>;
  /** fetch data from the table: "auth.user_session" using primary key columns */
  selectUserSession?: Maybe<UserSession>;
  /** fetch aggregated fields from the table: "auth.user_session" */
  selectUserSessionAggregate: UserSession_Aggregate;
  /** fetch data from the table: "auth.user_session" */
  selectUserSessions: Array<UserSession>;
  /** fetch data from the table: "auth.user" */
  selectUsers: Array<User>;
  /** fetch data from the table: "shared.validation" using primary key columns */
  selectValidation?: Maybe<Validation>;
  /** fetch aggregated fields from the table: "shared.validation" */
  selectValidationAggregate: Validation_Aggregate;
  /** fetch data from the table: "shared.validation_lifecycle_hook" using primary key columns */
  selectValidationLifecycleHook?: Maybe<ValidationLifecycleHook>;
  /** fetch aggregated fields from the table: "shared.validation_lifecycle_hook" */
  selectValidationLifecycleHookAggregate: ValidationLifecycleHook_Aggregate;
  /** fetch data from the table: "shared.validation_lifecycle_hook" */
  selectValidationLifecycleHooks: Array<ValidationLifecycleHook>;
  /** fetch data from the table: "shared.validation_override" using primary key columns */
  selectValidationOverride?: Maybe<ValidationOverride>;
  /** fetch aggregated fields from the table: "shared.validation_override" */
  selectValidationOverrideAggregate: ValidationOverride_Aggregate;
  /** fetch data from the table: "shared.validation_override" */
  selectValidationOverrides: Array<ValidationOverride>;
  /** fetch data from the table: "shared.validation_rule_for" using primary key columns */
  selectValidationRuleFor?: Maybe<ValidationRuleFor>;
  /** fetch aggregated fields from the table: "shared.validation_rule_for" */
  selectValidationRuleForAggregate: ValidationRuleFor_Aggregate;
  /** fetch data from the table: "shared.validation_rule_for" */
  selectValidationRuleFors: Array<ValidationRuleFor>;
  /** fetch data from the table: "shared.validation_type_operation" using primary key columns */
  selectValidationTypeOperation?: Maybe<ValidationTypeOperation>;
  /** fetch aggregated fields from the table: "shared.validation_type_operation" */
  selectValidationTypeOperationAggregate: ValidationTypeOperation_Aggregate;
  /** fetch data from the table: "shared.validation_type_operation" */
  selectValidationTypeOperations: Array<ValidationTypeOperation>;
  /** fetch data from the table: "shared.validation_when" using primary key columns */
  selectValidationWhen?: Maybe<ValidationWhen>;
  /** fetch aggregated fields from the table: "shared.validation_when" */
  selectValidationWhenAggregate: ValidationWhen_Aggregate;
  /** fetch data from the table: "shared.validation_when" */
  selectValidationWhens: Array<ValidationWhen>;
  /** fetch data from the table: "shared.validation" */
  selectValidations: Array<Validation>;
  /** fetch data from the table: "vehicle" using primary key columns */
  selectVehicle?: Maybe<Vehicle>;
  /** fetch aggregated fields from the table: "vehicle" */
  selectVehicleAggregate: Vehicle_Aggregate;
  /** fetch data from the table: "vehicle.vehicle_attributes_defined_view" */
  selectVehicleAttributesDefinedView: Array<VehicleAttributesDefinedView>;
  /** fetch aggregated fields from the table: "vehicle.vehicle_attributes_defined_view" */
  selectVehicleAttributesDefinedViewAggregate: VehicleAttributesDefinedView_Aggregate;
  /** fetch aggregated fields from the table: "vwVehicleClassingBodyStyle" */
  selectVehicleClassingBodyStyleAggregate: VehicleClassingBodyStyle_Aggregate;
  /** fetch data from the table: "vwVehicleClassingBodyStyle" */
  selectVehicleClassingBodyStyles: Array<VehicleClassingBodyStyle>;
  /** fetch aggregated fields from the table: "vwVehicleClassingFuelType" */
  selectVehicleClassingFuelTypeAggregate: VehicleClassingFuelType_Aggregate;
  /** fetch data from the table: "vwVehicleClassingFuelType" */
  selectVehicleClassingFuelTypes: Array<VehicleClassingFuelType>;
  /** fetch aggregated fields from the table: "vwVehicleClassingVehicleMake" */
  selectVehicleClassingVehicleMakeAggregate: VehicleClassingVehicleMake_Aggregate;
  /** fetch data from the table: "vwVehicleClassingVehicleMake" */
  selectVehicleClassingVehicleMakes: Array<VehicleClassingVehicleMake>;
  /** fetch aggregated fields from the table: "vwVehicleClassingVehicleType" */
  selectVehicleClassingVehicleTypeAggregate: VehicleClassingVehicleType_Aggregate;
  /** fetch data from the table: "vwVehicleClassingVehicleType" */
  selectVehicleClassingVehicleTypes: Array<VehicleClassingVehicleType>;
  /** fetch data from the table: "vehicle.vehicle_status_type" using primary key columns */
  selectVehicleStatusType?: Maybe<VehicleStatusType>;
  /** fetch aggregated fields from the table: "vehicle.vehicle_status_type" */
  selectVehicleStatusTypeAggregate: VehicleStatusType_Aggregate;
  /** fetch data from the table: "vehicle.vehicle_status_type" */
  selectVehicleStatusTypes: Array<VehicleStatusType>;
  /** fetch data from the table: "vehicle" */
  selectVehicles: Array<Vehicle>;
  /** fetch data from the table: "vehicle.vpic_decode_alternative" using primary key columns */
  selectVpicDecodeAlternative?: Maybe<VpicDecodeAlternative>;
  /** fetch aggregated fields from the table: "vehicle.vpic_decode_alternative" */
  selectVpicDecodeAlternativeAggregate: VpicDecodeAlternative_Aggregate;
  /** fetch data from the table: "vehicle.vpic_decode_alternative" */
  selectVpicDecodeAlternatives: Array<VpicDecodeAlternative>;
  /** fetch data from the table: "work_status_type" using primary key columns */
  selectWorkStatusType?: Maybe<WorkStatusType>;
  /** fetch aggregated fields from the table: "work_status_type" */
  selectWorkStatusTypeAggregate: WorkStatusType_Aggregate;
  /** fetch data from the table: "work_status_type" */
  selectWorkStatusTypes: Array<WorkStatusType>;
  /** fetch data from the table: "claims.workflow_state_type" using primary key columns */
  selectWorkflowStateType?: Maybe<WorkflowStateType>;
  /** fetch aggregated fields from the table: "claims.workflow_state_type" */
  selectWorkflowStateTypeAggregate: WorkflowStateType_Aggregate;
  /** fetch data from the table: "claims.workflow_state_type" */
  selectWorkflowStateTypes: Array<WorkflowStateType>;
  /** fetch aggregated fields from the table: "compliance.filing_lender" */
  selectselectFilingLenderAggregate: FilingLender_Aggregate;
  /** fetch data from the table: "shared.search_result" */
  shared_search_result: Array<Shared_Search_Result>;
  /** fetch aggregated fields from the table: "shared.search_result" */
  shared_search_result_aggregate: Shared_Search_Result_Aggregate;
  /** fetch data from the table: "vpic.vncsabodytype" */
  vNCSABodyType: Array<VNcsaBodyType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vncsabodytype" */
  vNCSABodyType_aggregate: VNcsaBodyType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vncsamake" */
  vNCSAMake: Array<VNcsaMake_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vncsamake" */
  vNCSAMake_aggregate: VNcsaMake_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vncsamodel" */
  vNCSAModel: Array<VNcsaModel_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vncsamodel" */
  vNCSAModel_aggregate: VNcsaModel_Aggregate_Vpic;
  /** execute function "users.shortcut_bindings_for_viewer" which returns "users.shortcut_binding" */
  viewerShortcutBindings: Array<ShortcutBinding>;
  /** execute function "users.shortcut_bindings_for_viewer" and query aggregates on result of table type "users.shortcut_binding" */
  viewerShortcutBindings_aggregate: ShortcutBinding_Aggregate;
  vinDecoderAction: VinDecoderActionOutput;
  /** fetch data from the table: "vwVehicleCylindersDistinct" */
  vwVehicleCylindersDistinct: Array<VwVehicleCylindersDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleCylindersDistinct" */
  vwVehicleCylindersDistinct_aggregate: VwVehicleCylindersDistinct_Aggregate;
  /** fetch data from the table: "vwVehicleDrivingWheelsDistinct" */
  vwVehicleDrivingWheelsDistinct: Array<VwVehicleDrivingWheelsDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleDrivingWheelsDistinct" */
  vwVehicleDrivingWheelsDistinct_aggregate: VwVehicleDrivingWheelsDistinct_Aggregate;
  /** fetch data from the table: "vwVehicleFuelTypesDistinct" */
  vwVehicleFuelTypesDistinct: Array<VwVehicleFuelTypesDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleFuelTypesDistinct" */
  vwVehicleFuelTypesDistinct_aggregate: VwVehicleFuelTypesDistinct_Aggregate;
  /** fetch data from the table: "vwVehicleMakesDistinct" */
  vwVehicleMakesDistinct: Array<VwVehicleMakesDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleMakesDistinct" */
  vwVehicleMakesDistinct_aggregate: VwVehicleMakesDistinct_Aggregate;
  /** fetch data from the table: "vwVehicleModelsDistinct" */
  vwVehicleModelsDistinct: Array<VwVehicleModelsDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleModelsDistinct" */
  vwVehicleModelsDistinct_aggregate: VwVehicleModelsDistinct_Aggregate;
  /** fetch data from the table: "vwVehicleYearsDistinct" */
  vwVehicleYearsDistinct: Array<VwVehicleYearsDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleYearsDistinct" */
  vwVehicleYearsDistinct_aggregate: VwVehicleYearsDistinct_Aggregate;
};


export type Query_RootAbsArgs = {
  distinct_on?: InputMaybe<Array<Abs_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Abs_Order_By_Vpic>>;
  where?: InputMaybe<Abs_Bool_Exp_Vpic>;
};


export type Query_RootAbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Abs_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Abs_Order_By_Vpic>>;
  where?: InputMaybe<Abs_Bool_Exp_Vpic>;
};


export type Query_RootAbs_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootAdaptiveCruiseControlArgs = {
  distinct_on?: InputMaybe<Array<AdaptiveCruiseControl_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdaptiveCruiseControl_Order_By_Vpic>>;
  where?: InputMaybe<AdaptiveCruiseControl_Bool_Exp_Vpic>;
};


export type Query_RootAdaptiveCruiseControl_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AdaptiveCruiseControl_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdaptiveCruiseControl_Order_By_Vpic>>;
  where?: InputMaybe<AdaptiveCruiseControl_Bool_Exp_Vpic>;
};


export type Query_RootAdaptiveCruiseControl_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootAdaptiveDrivingBeamArgs = {
  distinct_on?: InputMaybe<Array<AdaptiveDrivingBeam_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdaptiveDrivingBeam_Order_By_Vpic>>;
  where?: InputMaybe<AdaptiveDrivingBeam_Bool_Exp_Vpic>;
};


export type Query_RootAdaptiveDrivingBeam_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AdaptiveDrivingBeam_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdaptiveDrivingBeam_Order_By_Vpic>>;
  where?: InputMaybe<AdaptiveDrivingBeam_Bool_Exp_Vpic>;
};


export type Query_RootAdaptiveDrivingBeam_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootAirBagLocFrontArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocFront_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocFront_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocFront_Bool_Exp_Vpic>;
};


export type Query_RootAirBagLocFront_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocFront_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocFront_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocFront_Bool_Exp_Vpic>;
};


export type Query_RootAirBagLocFront_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootAirBagLocKneeArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocKnee_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocKnee_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocKnee_Bool_Exp_Vpic>;
};


export type Query_RootAirBagLocKnee_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocKnee_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocKnee_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocKnee_Bool_Exp_Vpic>;
};


export type Query_RootAirBagLocKnee_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootAirBagLocationsArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocations_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocations_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocations_Bool_Exp_Vpic>;
};


export type Query_RootAirBagLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocations_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocations_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocations_Bool_Exp_Vpic>;
};


export type Query_RootAirBagLocations_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootAutoBrakeArgs = {
  distinct_on?: InputMaybe<Array<AutoBrake_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoBrake_Order_By_Vpic>>;
  where?: InputMaybe<AutoBrake_Bool_Exp_Vpic>;
};


export type Query_RootAutoBrake_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AutoBrake_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoBrake_Order_By_Vpic>>;
  where?: InputMaybe<AutoBrake_Bool_Exp_Vpic>;
};


export type Query_RootAutoBrake_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootAutoReverseSystemArgs = {
  distinct_on?: InputMaybe<Array<AutoReverseSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoReverseSystem_Order_By_Vpic>>;
  where?: InputMaybe<AutoReverseSystem_Bool_Exp_Vpic>;
};


export type Query_RootAutoReverseSystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AutoReverseSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoReverseSystem_Order_By_Vpic>>;
  where?: InputMaybe<AutoReverseSystem_Bool_Exp_Vpic>;
};


export type Query_RootAutoReverseSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootAutomaticPedestrainAlertingSoundArgs = {
  distinct_on?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Order_By_Vpic>>;
  where?: InputMaybe<AutomaticPedestrainAlertingSound_Bool_Exp_Vpic>;
};


export type Query_RootAutomaticPedestrainAlertingSound_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Order_By_Vpic>>;
  where?: InputMaybe<AutomaticPedestrainAlertingSound_Bool_Exp_Vpic>;
};


export type Query_RootAutomaticPedestrainAlertingSound_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootAxleConfigurationArgs = {
  distinct_on?: InputMaybe<Array<AxleConfiguration_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AxleConfiguration_Order_By_Vpic>>;
  where?: InputMaybe<AxleConfiguration_Bool_Exp_Vpic>;
};


export type Query_RootAxleConfiguration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AxleConfiguration_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AxleConfiguration_Order_By_Vpic>>;
  where?: InputMaybe<AxleConfiguration_Bool_Exp_Vpic>;
};


export type Query_RootAxleConfiguration_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootBatteryTypeArgs = {
  distinct_on?: InputMaybe<Array<BatteryType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BatteryType_Order_By_Vpic>>;
  where?: InputMaybe<BatteryType_Bool_Exp_Vpic>;
};


export type Query_RootBatteryType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BatteryType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BatteryType_Order_By_Vpic>>;
  where?: InputMaybe<BatteryType_Bool_Exp_Vpic>;
};


export type Query_RootBatteryType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootBedTypeArgs = {
  distinct_on?: InputMaybe<Array<BedType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BedType_Order_By_Vpic>>;
  where?: InputMaybe<BedType_Bool_Exp_Vpic>;
};


export type Query_RootBedType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BedType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BedType_Order_By_Vpic>>;
  where?: InputMaybe<BedType_Bool_Exp_Vpic>;
};


export type Query_RootBedType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootBlindSpotInterventionArgs = {
  distinct_on?: InputMaybe<Array<BlindSpotIntervention_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlindSpotIntervention_Order_By_Vpic>>;
  where?: InputMaybe<BlindSpotIntervention_Bool_Exp_Vpic>;
};


export type Query_RootBlindSpotIntervention_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BlindSpotIntervention_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlindSpotIntervention_Order_By_Vpic>>;
  where?: InputMaybe<BlindSpotIntervention_Bool_Exp_Vpic>;
};


export type Query_RootBlindSpotIntervention_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootBlindSpotMonitoringArgs = {
  distinct_on?: InputMaybe<Array<BlindSpotMonitoring_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlindSpotMonitoring_Order_By_Vpic>>;
  where?: InputMaybe<BlindSpotMonitoring_Bool_Exp_Vpic>;
};


export type Query_RootBlindSpotMonitoring_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BlindSpotMonitoring_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlindSpotMonitoring_Order_By_Vpic>>;
  where?: InputMaybe<BlindSpotMonitoring_Bool_Exp_Vpic>;
};


export type Query_RootBlindSpotMonitoring_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootBodyCabArgs = {
  distinct_on?: InputMaybe<Array<BodyCab_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BodyCab_Order_By_Vpic>>;
  where?: InputMaybe<BodyCab_Bool_Exp_Vpic>;
};


export type Query_RootBodyCab_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BodyCab_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BodyCab_Order_By_Vpic>>;
  where?: InputMaybe<BodyCab_Bool_Exp_Vpic>;
};


export type Query_RootBodyCab_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootBodyStyleArgs = {
  distinct_on?: InputMaybe<Array<BodyStyle_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BodyStyle_Order_By_Vpic>>;
  where?: InputMaybe<BodyStyle_Bool_Exp_Vpic>;
};


export type Query_RootBodyStyle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BodyStyle_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BodyStyle_Order_By_Vpic>>;
  where?: InputMaybe<BodyStyle_Bool_Exp_Vpic>;
};


export type Query_RootBodyStyle_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootBrakeSystemArgs = {
  distinct_on?: InputMaybe<Array<BrakeSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrakeSystem_Order_By_Vpic>>;
  where?: InputMaybe<BrakeSystem_Bool_Exp_Vpic>;
};


export type Query_RootBrakeSystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BrakeSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrakeSystem_Order_By_Vpic>>;
  where?: InputMaybe<BrakeSystem_Bool_Exp_Vpic>;
};


export type Query_RootBrakeSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootBusFloorConfigTypeArgs = {
  distinct_on?: InputMaybe<Array<BusFloorConfigType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BusFloorConfigType_Order_By_Vpic>>;
  where?: InputMaybe<BusFloorConfigType_Bool_Exp_Vpic>;
};


export type Query_RootBusFloorConfigType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BusFloorConfigType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BusFloorConfigType_Order_By_Vpic>>;
  where?: InputMaybe<BusFloorConfigType_Bool_Exp_Vpic>;
};


export type Query_RootBusFloorConfigType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootBusTypeArgs = {
  distinct_on?: InputMaybe<Array<BusType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BusType_Order_By_Vpic>>;
  where?: InputMaybe<BusType_Bool_Exp_Vpic>;
};


export type Query_RootBusType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BusType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BusType_Order_By_Vpic>>;
  where?: InputMaybe<BusType_Bool_Exp_Vpic>;
};


export type Query_RootBusType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootCan_AacnArgs = {
  distinct_on?: InputMaybe<Array<Can_Aacn_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Can_Aacn_Order_By_Vpic>>;
  where?: InputMaybe<Can_Aacn_Bool_Exp_Vpic>;
};


export type Query_RootCan_Aacn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Can_Aacn_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Can_Aacn_Order_By_Vpic>>;
  where?: InputMaybe<Can_Aacn_Bool_Exp_Vpic>;
};


export type Query_RootCan_Aacn_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootChargerLevelArgs = {
  distinct_on?: InputMaybe<Array<ChargerLevel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChargerLevel_Order_By_Vpic>>;
  where?: InputMaybe<ChargerLevel_Bool_Exp_Vpic>;
};


export type Query_RootChargerLevel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ChargerLevel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChargerLevel_Order_By_Vpic>>;
  where?: InputMaybe<ChargerLevel_Bool_Exp_Vpic>;
};


export type Query_RootChargerLevel_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootCombinedBrakingSystemArgs = {
  distinct_on?: InputMaybe<Array<CombinedBrakingSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CombinedBrakingSystem_Order_By_Vpic>>;
  where?: InputMaybe<CombinedBrakingSystem_Bool_Exp_Vpic>;
};


export type Query_RootCombinedBrakingSystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CombinedBrakingSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CombinedBrakingSystem_Order_By_Vpic>>;
  where?: InputMaybe<CombinedBrakingSystem_Bool_Exp_Vpic>;
};


export type Query_RootCombinedBrakingSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootContractMasterSurchargeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterSurcharge_Order_By>>;
  where?: InputMaybe<ContractMasterSurcharge_Bool_Exp>;
};


export type Query_RootContractMasterSurcharge_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterSurcharge_Order_By>>;
  where?: InputMaybe<ContractMasterSurcharge_Bool_Exp>;
};


export type Query_RootConversionArgs = {
  distinct_on?: InputMaybe<Array<Conversion_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Conversion_Order_By_Vpic>>;
  where?: InputMaybe<Conversion_Bool_Exp_Vpic>;
};


export type Query_RootConversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Conversion_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Conversion_Order_By_Vpic>>;
  where?: InputMaybe<Conversion_Bool_Exp_Vpic>;
};


export type Query_RootConversion_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootCoolingTypeArgs = {
  distinct_on?: InputMaybe<Array<CoolingType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CoolingType_Order_By_Vpic>>;
  where?: InputMaybe<CoolingType_Bool_Exp_Vpic>;
};


export type Query_RootCoolingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CoolingType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CoolingType_Order_By_Vpic>>;
  where?: InputMaybe<CoolingType_Bool_Exp_Vpic>;
};


export type Query_RootCoolingType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Order_By_Vpic>>;
  where?: InputMaybe<Country_Bool_Exp_Vpic>;
};


export type Query_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Order_By_Vpic>>;
  where?: InputMaybe<Country_Bool_Exp_Vpic>;
};


export type Query_RootCountry_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootCustomMotorcycleTypeArgs = {
  distinct_on?: InputMaybe<Array<CustomMotorcycleType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomMotorcycleType_Order_By_Vpic>>;
  where?: InputMaybe<CustomMotorcycleType_Bool_Exp_Vpic>;
};


export type Query_RootCustomMotorcycleType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomMotorcycleType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomMotorcycleType_Order_By_Vpic>>;
  where?: InputMaybe<CustomMotorcycleType_Bool_Exp_Vpic>;
};


export type Query_RootCustomMotorcycleType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootDaytimeRunningLightArgs = {
  distinct_on?: InputMaybe<Array<DaytimeRunningLight_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DaytimeRunningLight_Order_By_Vpic>>;
  where?: InputMaybe<DaytimeRunningLight_Bool_Exp_Vpic>;
};


export type Query_RootDaytimeRunningLight_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DaytimeRunningLight_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DaytimeRunningLight_Order_By_Vpic>>;
  where?: InputMaybe<DaytimeRunningLight_Bool_Exp_Vpic>;
};


export type Query_RootDaytimeRunningLight_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootDefaultValueArgs = {
  distinct_on?: InputMaybe<Array<DefaultValue_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DefaultValue_Order_By_Vpic>>;
  where?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
};


export type Query_RootDefaultValue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DefaultValue_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DefaultValue_Order_By_Vpic>>;
  where?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
};


export type Query_RootDefaultValue_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootDestinationMarketArgs = {
  distinct_on?: InputMaybe<Array<DestinationMarket_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationMarket_Order_By_Vpic>>;
  where?: InputMaybe<DestinationMarket_Bool_Exp_Vpic>;
};


export type Query_RootDestinationMarket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationMarket_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationMarket_Order_By_Vpic>>;
  where?: InputMaybe<DestinationMarket_Bool_Exp_Vpic>;
};


export type Query_RootDestinationMarket_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootDriveTypeArgs = {
  distinct_on?: InputMaybe<Array<DriveType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DriveType_Order_By_Vpic>>;
  where?: InputMaybe<DriveType_Bool_Exp_Vpic>;
};


export type Query_RootDriveType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DriveType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DriveType_Order_By_Vpic>>;
  where?: InputMaybe<DriveType_Bool_Exp_Vpic>;
};


export type Query_RootDriveType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootDynamicBrakeSupportArgs = {
  distinct_on?: InputMaybe<Array<DynamicBrakeSupport_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DynamicBrakeSupport_Order_By_Vpic>>;
  where?: InputMaybe<DynamicBrakeSupport_Bool_Exp_Vpic>;
};


export type Query_RootDynamicBrakeSupport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DynamicBrakeSupport_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DynamicBrakeSupport_Order_By_Vpic>>;
  where?: InputMaybe<DynamicBrakeSupport_Bool_Exp_Vpic>;
};


export type Query_RootDynamicBrakeSupport_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootEcsArgs = {
  distinct_on?: InputMaybe<Array<Ecs_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecs_Order_By_Vpic>>;
  where?: InputMaybe<Ecs_Bool_Exp_Vpic>;
};


export type Query_RootEcs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ecs_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecs_Order_By_Vpic>>;
  where?: InputMaybe<Ecs_Bool_Exp_Vpic>;
};


export type Query_RootEcs_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootEdrArgs = {
  distinct_on?: InputMaybe<Array<Edr_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edr_Order_By_Vpic>>;
  where?: InputMaybe<Edr_Bool_Exp_Vpic>;
};


export type Query_RootEdr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Edr_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edr_Order_By_Vpic>>;
  where?: InputMaybe<Edr_Bool_Exp_Vpic>;
};


export type Query_RootEdr_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootEvDriveUnitArgs = {
  distinct_on?: InputMaybe<Array<EvDriveUnit_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EvDriveUnit_Order_By_Vpic>>;
  where?: InputMaybe<EvDriveUnit_Bool_Exp_Vpic>;
};


export type Query_RootEvDriveUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EvDriveUnit_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EvDriveUnit_Order_By_Vpic>>;
  where?: InputMaybe<EvDriveUnit_Bool_Exp_Vpic>;
};


export type Query_RootEvDriveUnit_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootElectrificationLevelArgs = {
  distinct_on?: InputMaybe<Array<ElectrificationLevel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ElectrificationLevel_Order_By_Vpic>>;
  where?: InputMaybe<ElectrificationLevel_Bool_Exp_Vpic>;
};


export type Query_RootElectrificationLevel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ElectrificationLevel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ElectrificationLevel_Order_By_Vpic>>;
  where?: InputMaybe<ElectrificationLevel_Bool_Exp_Vpic>;
};


export type Query_RootElectrificationLevel_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootElementArgs = {
  distinct_on?: InputMaybe<Array<Element_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Element_Order_By_Vpic>>;
  where?: InputMaybe<Element_Bool_Exp_Vpic>;
};


export type Query_RootElement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Element_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Element_Order_By_Vpic>>;
  where?: InputMaybe<Element_Bool_Exp_Vpic>;
};


export type Query_RootElement_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootEngineConfigurationArgs = {
  distinct_on?: InputMaybe<Array<EngineConfiguration_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineConfiguration_Order_By_Vpic>>;
  where?: InputMaybe<EngineConfiguration_Bool_Exp_Vpic>;
};


export type Query_RootEngineConfiguration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EngineConfiguration_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineConfiguration_Order_By_Vpic>>;
  where?: InputMaybe<EngineConfiguration_Bool_Exp_Vpic>;
};


export type Query_RootEngineConfiguration_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootEngineModelArgs = {
  distinct_on?: InputMaybe<Array<EngineModel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineModel_Order_By_Vpic>>;
  where?: InputMaybe<EngineModel_Bool_Exp_Vpic>;
};


export type Query_RootEngineModelPatternArgs = {
  distinct_on?: InputMaybe<Array<EngineModelPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineModelPattern_Order_By_Vpic>>;
  where?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
};


export type Query_RootEngineModelPattern_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EngineModelPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineModelPattern_Order_By_Vpic>>;
  where?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
};


export type Query_RootEngineModelPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootEngineModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EngineModel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineModel_Order_By_Vpic>>;
  where?: InputMaybe<EngineModel_Bool_Exp_Vpic>;
};


export type Query_RootEngineModel_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootEntertainmentSystemArgs = {
  distinct_on?: InputMaybe<Array<EntertainmentSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntertainmentSystem_Order_By_Vpic>>;
  where?: InputMaybe<EntertainmentSystem_Bool_Exp_Vpic>;
};


export type Query_RootEntertainmentSystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntertainmentSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntertainmentSystem_Order_By_Vpic>>;
  where?: InputMaybe<EntertainmentSystem_Bool_Exp_Vpic>;
};


export type Query_RootEntertainmentSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootErrorCodeArgs = {
  distinct_on?: InputMaybe<Array<ErrorCode_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ErrorCode_Order_By_Vpic>>;
  where?: InputMaybe<ErrorCode_Bool_Exp_Vpic>;
};


export type Query_RootErrorCode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ErrorCode_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ErrorCode_Order_By_Vpic>>;
  where?: InputMaybe<ErrorCode_Bool_Exp_Vpic>;
};


export type Query_RootErrorCode_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootForwardCollisionWarningArgs = {
  distinct_on?: InputMaybe<Array<ForwardCollisionWarning_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ForwardCollisionWarning_Order_By_Vpic>>;
  where?: InputMaybe<ForwardCollisionWarning_Bool_Exp_Vpic>;
};


export type Query_RootForwardCollisionWarning_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ForwardCollisionWarning_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ForwardCollisionWarning_Order_By_Vpic>>;
  where?: InputMaybe<ForwardCollisionWarning_Bool_Exp_Vpic>;
};


export type Query_RootForwardCollisionWarning_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootFuelDeliveryTypeArgs = {
  distinct_on?: InputMaybe<Array<FuelDeliveryType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelDeliveryType_Order_By_Vpic>>;
  where?: InputMaybe<FuelDeliveryType_Bool_Exp_Vpic>;
};


export type Query_RootFuelDeliveryType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FuelDeliveryType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelDeliveryType_Order_By_Vpic>>;
  where?: InputMaybe<FuelDeliveryType_Bool_Exp_Vpic>;
};


export type Query_RootFuelDeliveryType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootFuelTankMaterialArgs = {
  distinct_on?: InputMaybe<Array<FuelTankMaterial_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelTankMaterial_Order_By_Vpic>>;
  where?: InputMaybe<FuelTankMaterial_Bool_Exp_Vpic>;
};


export type Query_RootFuelTankMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FuelTankMaterial_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelTankMaterial_Order_By_Vpic>>;
  where?: InputMaybe<FuelTankMaterial_Bool_Exp_Vpic>;
};


export type Query_RootFuelTankMaterial_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootFuelTankTypeArgs = {
  distinct_on?: InputMaybe<Array<FuelTankType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelTankType_Order_By_Vpic>>;
  where?: InputMaybe<FuelTankType_Bool_Exp_Vpic>;
};


export type Query_RootFuelTankType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FuelTankType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelTankType_Order_By_Vpic>>;
  where?: InputMaybe<FuelTankType_Bool_Exp_Vpic>;
};


export type Query_RootFuelTankType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootFuelTypeArgs = {
  distinct_on?: InputMaybe<Array<FuelType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelType_Order_By_Vpic>>;
  where?: InputMaybe<FuelType_Bool_Exp_Vpic>;
};


export type Query_RootFuelType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FuelType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelType_Order_By_Vpic>>;
  where?: InputMaybe<FuelType_Bool_Exp_Vpic>;
};


export type Query_RootFuelType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootGrossVehicleWeightRatingArgs = {
  distinct_on?: InputMaybe<Array<GrossVehicleWeightRating_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GrossVehicleWeightRating_Order_By_Vpic>>;
  where?: InputMaybe<GrossVehicleWeightRating_Bool_Exp_Vpic>;
};


export type Query_RootGrossVehicleWeightRating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GrossVehicleWeightRating_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GrossVehicleWeightRating_Order_By_Vpic>>;
  where?: InputMaybe<GrossVehicleWeightRating_Bool_Exp_Vpic>;
};


export type Query_RootGrossVehicleWeightRating_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootKeylessIgnitionArgs = {
  distinct_on?: InputMaybe<Array<KeylessIgnition_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<KeylessIgnition_Order_By_Vpic>>;
  where?: InputMaybe<KeylessIgnition_Bool_Exp_Vpic>;
};


export type Query_RootKeylessIgnition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<KeylessIgnition_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<KeylessIgnition_Order_By_Vpic>>;
  where?: InputMaybe<KeylessIgnition_Bool_Exp_Vpic>;
};


export type Query_RootKeylessIgnition_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootLaneCenteringAssistanceArgs = {
  distinct_on?: InputMaybe<Array<LaneCenteringAssistance_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneCenteringAssistance_Order_By_Vpic>>;
  where?: InputMaybe<LaneCenteringAssistance_Bool_Exp_Vpic>;
};


export type Query_RootLaneCenteringAssistance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LaneCenteringAssistance_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneCenteringAssistance_Order_By_Vpic>>;
  where?: InputMaybe<LaneCenteringAssistance_Bool_Exp_Vpic>;
};


export type Query_RootLaneCenteringAssistance_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootLaneDepartureWarningArgs = {
  distinct_on?: InputMaybe<Array<LaneDepartureWarning_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneDepartureWarning_Order_By_Vpic>>;
  where?: InputMaybe<LaneDepartureWarning_Bool_Exp_Vpic>;
};


export type Query_RootLaneDepartureWarning_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LaneDepartureWarning_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneDepartureWarning_Order_By_Vpic>>;
  where?: InputMaybe<LaneDepartureWarning_Bool_Exp_Vpic>;
};


export type Query_RootLaneDepartureWarning_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootLaneKeepSystemArgs = {
  distinct_on?: InputMaybe<Array<LaneKeepSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneKeepSystem_Order_By_Vpic>>;
  where?: InputMaybe<LaneKeepSystem_Bool_Exp_Vpic>;
};


export type Query_RootLaneKeepSystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LaneKeepSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneKeepSystem_Order_By_Vpic>>;
  where?: InputMaybe<LaneKeepSystem_Bool_Exp_Vpic>;
};


export type Query_RootLaneKeepSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootLowerBeamHeadlampLightSourceArgs = {
  distinct_on?: InputMaybe<Array<LowerBeamHeadlampLightSource_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LowerBeamHeadlampLightSource_Order_By_Vpic>>;
  where?: InputMaybe<LowerBeamHeadlampLightSource_Bool_Exp_Vpic>;
};


export type Query_RootLowerBeamHeadlampLightSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LowerBeamHeadlampLightSource_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LowerBeamHeadlampLightSource_Order_By_Vpic>>;
  where?: InputMaybe<LowerBeamHeadlampLightSource_Bool_Exp_Vpic>;
};


export type Query_RootLowerBeamHeadlampLightSource_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootMakeArgs = {
  distinct_on?: InputMaybe<Array<Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Order_By_Vpic>>;
  where?: InputMaybe<Make_Bool_Exp_Vpic>;
};


export type Query_RootMake_ModelArgs = {
  distinct_on?: InputMaybe<Array<Make_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Model_Order_By_Vpic>>;
  where?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
};


export type Query_RootMake_Model_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Make_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Model_Order_By_Vpic>>;
  where?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
};


export type Query_RootMake_Model_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootMake_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Order_By_Vpic>>;
  where?: InputMaybe<Make_Bool_Exp_Vpic>;
};


export type Query_RootMake_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootManufacturerArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By_Vpic>>;
  where?: InputMaybe<Manufacturer_Bool_Exp_Vpic>;
};


export type Query_RootManufacturer_MakeArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Make_Order_By_Vpic>>;
  where?: InputMaybe<Manufacturer_Make_Bool_Exp_Vpic>;
};


export type Query_RootManufacturer_Make_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Make_Order_By_Vpic>>;
  where?: InputMaybe<Manufacturer_Make_Bool_Exp_Vpic>;
};


export type Query_RootManufacturer_Make_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootManufacturer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By_Vpic>>;
  where?: InputMaybe<Manufacturer_Bool_Exp_Vpic>;
};


export type Query_RootManufacturer_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootModelArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Order_By_Vpic>>;
  where?: InputMaybe<Model_Bool_Exp_Vpic>;
};


export type Query_RootModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Order_By_Vpic>>;
  where?: InputMaybe<Model_Bool_Exp_Vpic>;
};


export type Query_RootModel_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootMotorcycleChassisTypeArgs = {
  distinct_on?: InputMaybe<Array<MotorcycleChassisType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MotorcycleChassisType_Order_By_Vpic>>;
  where?: InputMaybe<MotorcycleChassisType_Bool_Exp_Vpic>;
};


export type Query_RootMotorcycleChassisType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MotorcycleChassisType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MotorcycleChassisType_Order_By_Vpic>>;
  where?: InputMaybe<MotorcycleChassisType_Bool_Exp_Vpic>;
};


export type Query_RootMotorcycleChassisType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootMotorcycleSuspensionTypeArgs = {
  distinct_on?: InputMaybe<Array<MotorcycleSuspensionType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MotorcycleSuspensionType_Order_By_Vpic>>;
  where?: InputMaybe<MotorcycleSuspensionType_Bool_Exp_Vpic>;
};


export type Query_RootMotorcycleSuspensionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MotorcycleSuspensionType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MotorcycleSuspensionType_Order_By_Vpic>>;
  where?: InputMaybe<MotorcycleSuspensionType_Bool_Exp_Vpic>;
};


export type Query_RootMotorcycleSuspensionType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootNonLandUseArgs = {
  distinct_on?: InputMaybe<Array<NonLandUse_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NonLandUse_Order_By_Vpic>>;
  where?: InputMaybe<NonLandUse_Bool_Exp_Vpic>;
};


export type Query_RootNonLandUse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NonLandUse_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NonLandUse_Order_By_Vpic>>;
  where?: InputMaybe<NonLandUse_Bool_Exp_Vpic>;
};


export type Query_RootNonLandUse_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootParkAssistArgs = {
  distinct_on?: InputMaybe<Array<ParkAssist_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkAssist_Order_By_Vpic>>;
  where?: InputMaybe<ParkAssist_Bool_Exp_Vpic>;
};


export type Query_RootParkAssist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkAssist_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkAssist_Order_By_Vpic>>;
  where?: InputMaybe<ParkAssist_Bool_Exp_Vpic>;
};


export type Query_RootParkAssist_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootPatternArgs = {
  distinct_on?: InputMaybe<Array<Pattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pattern_Order_By_Vpic>>;
  where?: InputMaybe<Pattern_Bool_Exp_Vpic>;
};


export type Query_RootPattern_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pattern_Order_By_Vpic>>;
  where?: InputMaybe<Pattern_Bool_Exp_Vpic>;
};


export type Query_RootPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootPedestrianAutomaticEmergencyBrakingArgs = {
  distinct_on?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Order_By_Vpic>>;
  where?: InputMaybe<PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};


export type Query_RootPedestrianAutomaticEmergencyBraking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Order_By_Vpic>>;
  where?: InputMaybe<PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};


export type Query_RootPedestrianAutomaticEmergencyBraking_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootPretensionerArgs = {
  distinct_on?: InputMaybe<Array<Pretensioner_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pretensioner_Order_By_Vpic>>;
  where?: InputMaybe<Pretensioner_Bool_Exp_Vpic>;
};


export type Query_RootPretensioner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pretensioner_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pretensioner_Order_By_Vpic>>;
  where?: InputMaybe<Pretensioner_Bool_Exp_Vpic>;
};


export type Query_RootPretensioner_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootRearAutomaticEmergencyBrakingArgs = {
  distinct_on?: InputMaybe<Array<RearAutomaticEmergencyBraking_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearAutomaticEmergencyBraking_Order_By_Vpic>>;
  where?: InputMaybe<RearAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};


export type Query_RootRearAutomaticEmergencyBraking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RearAutomaticEmergencyBraking_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearAutomaticEmergencyBraking_Order_By_Vpic>>;
  where?: InputMaybe<RearAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};


export type Query_RootRearAutomaticEmergencyBraking_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootRearCrossTrafficAlertArgs = {
  distinct_on?: InputMaybe<Array<RearCrossTrafficAlert_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearCrossTrafficAlert_Order_By_Vpic>>;
  where?: InputMaybe<RearCrossTrafficAlert_Bool_Exp_Vpic>;
};


export type Query_RootRearCrossTrafficAlert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RearCrossTrafficAlert_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearCrossTrafficAlert_Order_By_Vpic>>;
  where?: InputMaybe<RearCrossTrafficAlert_Bool_Exp_Vpic>;
};


export type Query_RootRearCrossTrafficAlert_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootRearVisibilityCameraArgs = {
  distinct_on?: InputMaybe<Array<RearVisibilityCamera_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearVisibilityCamera_Order_By_Vpic>>;
  where?: InputMaybe<RearVisibilityCamera_Bool_Exp_Vpic>;
};


export type Query_RootRearVisibilityCamera_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RearVisibilityCamera_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearVisibilityCamera_Order_By_Vpic>>;
  where?: InputMaybe<RearVisibilityCamera_Bool_Exp_Vpic>;
};


export type Query_RootRearVisibilityCamera_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootSeatBeltsAllArgs = {
  distinct_on?: InputMaybe<Array<SeatBeltsAll_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SeatBeltsAll_Order_By_Vpic>>;
  where?: InputMaybe<SeatBeltsAll_Bool_Exp_Vpic>;
};


export type Query_RootSeatBeltsAll_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SeatBeltsAll_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SeatBeltsAll_Order_By_Vpic>>;
  where?: InputMaybe<SeatBeltsAll_Bool_Exp_Vpic>;
};


export type Query_RootSeatBeltsAll_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootSemiautomaticHeadlampBeamSwitchingArgs = {
  distinct_on?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Order_By_Vpic>>;
  where?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic>;
};


export type Query_RootSemiautomaticHeadlampBeamSwitching_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Order_By_Vpic>>;
  where?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic>;
};


export type Query_RootSemiautomaticHeadlampBeamSwitching_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootSteeringArgs = {
  distinct_on?: InputMaybe<Array<Steering_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Steering_Order_By_Vpic>>;
  where?: InputMaybe<Steering_Bool_Exp_Vpic>;
};


export type Query_RootSteering_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Steering_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Steering_Order_By_Vpic>>;
  where?: InputMaybe<Steering_Bool_Exp_Vpic>;
};


export type Query_RootSteering_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootTpmsArgs = {
  distinct_on?: InputMaybe<Array<Tpms_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tpms_Order_By_Vpic>>;
  where?: InputMaybe<Tpms_Bool_Exp_Vpic>;
};


export type Query_RootTpms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tpms_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tpms_Order_By_Vpic>>;
  where?: InputMaybe<Tpms_Bool_Exp_Vpic>;
};


export type Query_RootTpms_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootTractionControlArgs = {
  distinct_on?: InputMaybe<Array<TractionControl_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TractionControl_Order_By_Vpic>>;
  where?: InputMaybe<TractionControl_Bool_Exp_Vpic>;
};


export type Query_RootTractionControl_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TractionControl_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TractionControl_Order_By_Vpic>>;
  where?: InputMaybe<TractionControl_Bool_Exp_Vpic>;
};


export type Query_RootTractionControl_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootTrailerBodyTypeArgs = {
  distinct_on?: InputMaybe<Array<TrailerBodyType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrailerBodyType_Order_By_Vpic>>;
  where?: InputMaybe<TrailerBodyType_Bool_Exp_Vpic>;
};


export type Query_RootTrailerBodyType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TrailerBodyType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrailerBodyType_Order_By_Vpic>>;
  where?: InputMaybe<TrailerBodyType_Bool_Exp_Vpic>;
};


export type Query_RootTrailerBodyType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootTrailerTypeArgs = {
  distinct_on?: InputMaybe<Array<TrailerType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrailerType_Order_By_Vpic>>;
  where?: InputMaybe<TrailerType_Bool_Exp_Vpic>;
};


export type Query_RootTrailerType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TrailerType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrailerType_Order_By_Vpic>>;
  where?: InputMaybe<TrailerType_Bool_Exp_Vpic>;
};


export type Query_RootTrailerType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootTransmissionArgs = {
  distinct_on?: InputMaybe<Array<Transmission_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transmission_Order_By_Vpic>>;
  where?: InputMaybe<Transmission_Bool_Exp_Vpic>;
};


export type Query_RootTransmission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transmission_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transmission_Order_By_Vpic>>;
  where?: InputMaybe<Transmission_Bool_Exp_Vpic>;
};


export type Query_RootTransmission_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootTurboArgs = {
  distinct_on?: InputMaybe<Array<Turbo_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Turbo_Order_By_Vpic>>;
  where?: InputMaybe<Turbo_Bool_Exp_Vpic>;
};


export type Query_RootTurbo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Turbo_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Turbo_Order_By_Vpic>>;
  where?: InputMaybe<Turbo_Bool_Exp_Vpic>;
};


export type Query_RootTurbo_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootVSpecSchemaPatternArgs = {
  distinct_on?: InputMaybe<Array<VSpecSchemaPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VSpecSchemaPattern_Order_By_Vpic>>;
  where?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
};


export type Query_RootVSpecSchemaPattern_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VSpecSchemaPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VSpecSchemaPattern_Order_By_Vpic>>;
  where?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
};


export type Query_RootVSpecSchemaPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootValvetrainDesignArgs = {
  distinct_on?: InputMaybe<Array<ValvetrainDesign_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValvetrainDesign_Order_By_Vpic>>;
  where?: InputMaybe<ValvetrainDesign_Bool_Exp_Vpic>;
};


export type Query_RootValvetrainDesign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValvetrainDesign_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValvetrainDesign_Order_By_Vpic>>;
  where?: InputMaybe<ValvetrainDesign_Bool_Exp_Vpic>;
};


export type Query_RootValvetrainDesign_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootVehicleSpecPatternArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecPattern_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
};


export type Query_RootVehicleSpecPattern_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecPattern_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
};


export type Query_RootVehicleSpecPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootVehicleSpecSchemaArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Bool_Exp_Vpic>;
};


export type Query_RootVehicleSpecSchema_ModelArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Model_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Model_Bool_Exp_Vpic>;
};


export type Query_RootVehicleSpecSchema_Model_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Model_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Model_Bool_Exp_Vpic>;
};


export type Query_RootVehicleSpecSchema_Model_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootVehicleSpecSchema_YearArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Year_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Year_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Year_Bool_Exp_Vpic>;
};


export type Query_RootVehicleSpecSchema_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Year_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Year_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Year_Bool_Exp_Vpic>;
};


export type Query_RootVehicleSpecSchema_Year_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootVehicleSpecSchema_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Bool_Exp_Vpic>;
};


export type Query_RootVehicleSpecSchema_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootVehicleTypeArgs = {
  distinct_on?: InputMaybe<Array<VehicleType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleType_Order_By_Vpic>>;
  where?: InputMaybe<VehicleType_Bool_Exp_Vpic>;
};


export type Query_RootVehicleType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleType_Order_By_Vpic>>;
  where?: InputMaybe<VehicleType_Bool_Exp_Vpic>;
};


export type Query_RootVehicleType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootVinDescriptorArgs = {
  distinct_on?: InputMaybe<Array<VinDescriptor_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinDescriptor_Order_By_Vpic>>;
  where?: InputMaybe<VinDescriptor_Bool_Exp_Vpic>;
};


export type Query_RootVinDescriptor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VinDescriptor_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinDescriptor_Order_By_Vpic>>;
  where?: InputMaybe<VinDescriptor_Bool_Exp_Vpic>;
};


export type Query_RootVinDescriptor_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootVinExceptionArgs = {
  distinct_on?: InputMaybe<Array<VinException_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinException_Order_By_Vpic>>;
  where?: InputMaybe<VinException_Bool_Exp_Vpic>;
};


export type Query_RootVinException_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VinException_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinException_Order_By_Vpic>>;
  where?: InputMaybe<VinException_Bool_Exp_Vpic>;
};


export type Query_RootVinException_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootVinSchemaArgs = {
  distinct_on?: InputMaybe<Array<VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<VinSchema_Bool_Exp_Vpic>;
};


export type Query_RootVinSchema_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<VinSchema_Bool_Exp_Vpic>;
};


export type Query_RootVinSchema_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootWmiYearValidCharsArgs = {
  distinct_on?: InputMaybe<Array<WmiYearValidChars_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WmiYearValidChars_Order_By_Vpic>>;
  where?: InputMaybe<WmiYearValidChars_Bool_Exp_Vpic>;
};


export type Query_RootWmiYearValidChars_CacheExceptionsArgs = {
  distinct_on?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Order_By_Vpic>>;
  where?: InputMaybe<WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic>;
};


export type Query_RootWmiYearValidChars_CacheExceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Order_By_Vpic>>;
  where?: InputMaybe<WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic>;
};


export type Query_RootWmiYearValidChars_AggregateArgs = {
  distinct_on?: InputMaybe<Array<WmiYearValidChars_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WmiYearValidChars_Order_By_Vpic>>;
  where?: InputMaybe<WmiYearValidChars_Bool_Exp_Vpic>;
};


export type Query_RootWmiYearValidChars_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWheelBaseTypeArgs = {
  distinct_on?: InputMaybe<Array<WheelBaseType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WheelBaseType_Order_By_Vpic>>;
  where?: InputMaybe<WheelBaseType_Bool_Exp_Vpic>;
};


export type Query_RootWheelBaseType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<WheelBaseType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WheelBaseType_Order_By_Vpic>>;
  where?: InputMaybe<WheelBaseType_Bool_Exp_Vpic>;
};


export type Query_RootWheelBaseType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootWheelieMitigationArgs = {
  distinct_on?: InputMaybe<Array<WheelieMitigation_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WheelieMitigation_Order_By_Vpic>>;
  where?: InputMaybe<WheelieMitigation_Bool_Exp_Vpic>;
};


export type Query_RootWheelieMitigation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<WheelieMitigation_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WheelieMitigation_Order_By_Vpic>>;
  where?: InputMaybe<WheelieMitigation_Bool_Exp_Vpic>;
};


export type Query_RootWheelieMitigation_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootWmiArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Bool_Exp_Vpic>;
};


export type Query_RootWmi_MakeArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Make_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
};


export type Query_RootWmi_Make_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Make_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
};


export type Query_RootWmi_Make_By_PkArgs = {
  MakeId: Scalars['Int'];
  WmiId: Scalars['Int'];
};


export type Query_RootWmi_VinSchemaArgs = {
  distinct_on?: InputMaybe<Array<Wmi_VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
};


export type Query_RootWmi_VinSchema_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
};


export type Query_RootWmi_VinSchema_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootWmi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Bool_Exp_Vpic>;
};


export type Query_RootWmi_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Query_RootAccount_SearchArgs = {
  args: Account_Search_Args;
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootAccount_Search_AggregateArgs = {
  args: Account_Search_Args;
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootApprovalHeadroomArgs = {
  args: ApprovalHeadroom_Args;
  distinct_on?: InputMaybe<Array<ApprovalState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalState_Order_By>>;
  where?: InputMaybe<ApprovalState_Bool_Exp>;
};


export type Query_RootApprovalHeadroom_AggregateArgs = {
  args: ApprovalHeadroom_Args;
  distinct_on?: InputMaybe<Array<ApprovalState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalState_Order_By>>;
  where?: InputMaybe<ApprovalState_Bool_Exp>;
};


export type Query_RootAudit_Message_Formatter_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Audit_Message_Formatter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Message_Formatter_Config_Order_By>>;
  where?: InputMaybe<Audit_Message_Formatter_Config_Bool_Exp>;
};


export type Query_RootAudit_Message_Formatter_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Message_Formatter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Message_Formatter_Config_Order_By>>;
  where?: InputMaybe<Audit_Message_Formatter_Config_Bool_Exp>;
};


export type Query_RootAudit_Message_Formatter_Config_By_PkArgs = {
  field_name: Scalars['String'];
  formatter_strategy: Scalars['String'];
  schema_name: Scalars['String'];
  table_name: Scalars['String'];
};


export type Query_RootAudit_TableslistArgs = {
  distinct_on?: InputMaybe<Array<Audit_Tableslist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Tableslist_Order_By>>;
  where?: InputMaybe<Audit_Tableslist_Bool_Exp>;
};


export type Query_RootAudit_Tableslist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Tableslist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Tableslist_Order_By>>;
  where?: InputMaybe<Audit_Tableslist_Bool_Exp>;
};


export type Query_RootAuth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Query_RootAuth_Group_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Actions_Order_By>>;
  where?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
};


export type Query_RootAuth_Group_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Actions_Order_By>>;
  where?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
};


export type Query_RootAuth_Group_Actions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuth_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Query_RootAuth_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClaims_Pre_Authorization_Vehicle_InformationArgs = {
  distinct_on?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Order_By>>;
  where?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Bool_Exp>;
};


export type Query_RootClaims_Pre_Authorization_Vehicle_Information_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Order_By>>;
  where?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Bool_Exp>;
};


export type Query_RootClaims_Pre_Authorization_Vehicle_Information_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClaims_Temp_Claims_Auth_TableArgs = {
  distinct_on?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Order_By>>;
  where?: InputMaybe<Claims_Temp_Claims_Auth_Table_Bool_Exp>;
};


export type Query_RootClaims_Temp_Claims_Auth_Table_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Order_By>>;
  where?: InputMaybe<Claims_Temp_Claims_Auth_Table_Bool_Exp>;
};


export type Query_RootClaims_Temp_Claims_Auth_Table_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootConcernSynonym_By_PkArgs = {
  groupName: Scalars['String'];
  term: Scalars['String'];
};


export type Query_RootGetDistinctMakesArgs = {
  distinct_on?: InputMaybe<Array<Vpic_Criteria_Make_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vpic_Criteria_Make_Order_By>>;
  where?: InputMaybe<Vpic_Criteria_Make_Bool_Exp_Bool_Exp>;
};


export type Query_RootIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


export type Query_RootIdentities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


export type Query_RootIdentities_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLegacy_Claims_SelectDealerArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLegacy_Claims_SelectDealerAggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Claims_Dealer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Claims_Dealer_Order_By>>;
  where?: InputMaybe<Legacy_Claims_Dealer_Bool_Exp>;
};


export type Query_RootLegacy_Claims_SelectDealersArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Claims_Dealer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Claims_Dealer_Order_By>>;
  where?: InputMaybe<Legacy_Claims_Dealer_Bool_Exp>;
};


export type Query_RootLegacy_Claims_SelectNoteArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLegacy_Claims_SelectNoteAggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Claims_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Claims_Note_Order_By>>;
  where?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
};


export type Query_RootLegacy_Claims_SelectNotesArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Claims_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Claims_Note_Order_By>>;
  where?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
};


export type Query_RootModelYearModel_By_PkArgs = {
  makeKey: Scalars['String'];
  model: Scalars['String'];
  modelYear: Scalars['Int'];
};


export type Query_RootOperations_Legacy_Policy_Contract_Cost_Detail_ViewArgs = {
  distinct_on?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Order_By>>;
  where?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp>;
};


export type Query_RootOperations_Legacy_Policy_Contract_Cost_Detail_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Order_By>>;
  where?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp>;
};


export type Query_RootOperations_Legacy_Policy_Contract_List_Materialized_ViewArgs = {
  distinct_on?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Order_By>>;
  where?: InputMaybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Bool_Exp>;
};


export type Query_RootOperations_Legacy_Policy_Contract_List_Materialized_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Order_By>>;
  where?: InputMaybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Bool_Exp>;
};


export type Query_RootSaveRateQuoteActionArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSearchArgs = {
  args: Search_Args;
  distinct_on?: InputMaybe<Array<Shared_Search_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Search_Result_Order_By>>;
  where?: InputMaybe<Shared_Search_Result_Bool_Exp>;
};


export type Query_RootSearchNhtsaIssueAggregateArgs = {
  args?: InputMaybe<SearchNhtsaIssues_Args_Nhtsa>;
  distinct_on?: InputMaybe<Array<IssueSearchResult_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueSearchResult_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueSearchResult_Bool_Exp_Nhtsa>;
};


export type Query_RootSearchNhtsaIssuesArgs = {
  args?: InputMaybe<SearchNhtsaIssues_Args_Nhtsa>;
  distinct_on?: InputMaybe<Array<IssueSearchResult_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueSearchResult_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueSearchResult_Bool_Exp_Nhtsa>;
};


export type Query_RootSearch_AggregateArgs = {
  args: Search_Args;
  distinct_on?: InputMaybe<Array<Shared_Search_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Search_Result_Order_By>>;
  where?: InputMaybe<Shared_Search_Result_Bool_Exp>;
};


export type Query_RootSelectAccountArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAccountAccountManagerArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAccountAccountManagersArgs = {
  distinct_on?: InputMaybe<Array<AccountAccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountAccountManager_Order_By>>;
  where?: InputMaybe<AccountAccountManager_Bool_Exp>;
};


export type Query_RootSelectAccountAccountManagersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountAccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountAccountManager_Order_By>>;
  where?: InputMaybe<AccountAccountManager_Bool_Exp>;
};


export type Query_RootSelectAccountAggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootSelectAccountCategoriesArgs = {
  distinct_on?: InputMaybe<Array<AccountCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountCategory_Order_By>>;
  where?: InputMaybe<AccountCategory_Bool_Exp>;
};


export type Query_RootSelectAccountCategoryArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAccountCategoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountCategory_Order_By>>;
  where?: InputMaybe<AccountCategory_Bool_Exp>;
};


export type Query_RootSelectAccountDisbursementArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAccountDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


export type Query_RootSelectAccountDisbursementsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


export type Query_RootSelectAccountManagerArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAccountManagersArgs = {
  distinct_on?: InputMaybe<Array<AccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountManager_Order_By>>;
  where?: InputMaybe<AccountManager_Bool_Exp>;
};


export type Query_RootSelectAccountManagersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountManager_Order_By>>;
  where?: InputMaybe<AccountManager_Bool_Exp>;
};


export type Query_RootSelectAccountObligorArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAccountObligorsArgs = {
  distinct_on?: InputMaybe<Array<AccountObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountObligor_Order_By>>;
  where?: InputMaybe<AccountObligor_Bool_Exp>;
};


export type Query_RootSelectAccountProductArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAccountProductObligorArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAccountProductObligorsArgs = {
  distinct_on?: InputMaybe<Array<AccountProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProductObligor_Order_By>>;
  where?: InputMaybe<AccountProductObligor_Bool_Exp>;
};


export type Query_RootSelectAccountProductObligorsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProductObligor_Order_By>>;
  where?: InputMaybe<AccountProductObligor_Bool_Exp>;
};


export type Query_RootSelectAccountProductsArgs = {
  distinct_on?: InputMaybe<Array<AccountProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProduct_Order_By>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


export type Query_RootSelectAccountProductsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProduct_Order_By>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


export type Query_RootSelectAccountRetailArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAccountRetailsArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


export type Query_RootSelectAccountRetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


export type Query_RootSelectAccountTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectAccountTypesArgs = {
  distinct_on?: InputMaybe<Array<AccountType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountType_Order_By>>;
  where?: InputMaybe<AccountType_Bool_Exp>;
};


export type Query_RootSelectAccountTypesAggregageArgs = {
  distinct_on?: InputMaybe<Array<AccountType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountType_Order_By>>;
  where?: InputMaybe<AccountType_Bool_Exp>;
};


export type Query_RootSelectAccountsArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootSelectAddressArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAddressTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectAddressTypesArgs = {
  distinct_on?: InputMaybe<Array<AddressType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AddressType_Order_By>>;
  where?: InputMaybe<AddressType_Bool_Exp>;
};


export type Query_RootSelectAddressTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AddressType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AddressType_Order_By>>;
  where?: InputMaybe<AddressType_Bool_Exp>;
};


export type Query_RootSelectAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootSelectAddressesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootSelectAggreatePaymentTypeArgs = {
  distinct_on?: InputMaybe<Array<PaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentType_Order_By>>;
  where?: InputMaybe<PaymentType_Bool_Exp>;
};


export type Query_RootSelectAggregateAccountObligorsArgs = {
  distinct_on?: InputMaybe<Array<AccountObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountObligor_Order_By>>;
  where?: InputMaybe<AccountObligor_Bool_Exp>;
};


export type Query_RootSelectAggregateClaimDetailAs400Args = {
  distinct_on?: InputMaybe<Array<ClaimDetailAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailAs400_Order_By>>;
  where?: InputMaybe<ClaimDetailAs400_Bool_Exp>;
};


export type Query_RootSelectAggregateClaimDetailDeductionAs400Args = {
  distinct_on?: InputMaybe<Array<ClaimDetailDeductionAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailDeductionAs400_Order_By>>;
  where?: InputMaybe<ClaimDetailDeductionAs400_Bool_Exp>;
};


export type Query_RootSelectAggregateClaimServiceCenterAs400Args = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenterAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenterAs400_Order_By>>;
  where?: InputMaybe<ClaimServiceCenterAs400_Bool_Exp>;
};


export type Query_RootSelectAggregateCompositeProductsArgs = {
  distinct_on?: InputMaybe<Array<CompositeProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompositeProduct_Order_By>>;
  where?: InputMaybe<CompositeProduct_Bool_Exp>;
};


export type Query_RootSelectAggregateIdentityAs400Args = {
  distinct_on?: InputMaybe<Array<IdentityAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityAs400_Order_By>>;
  where?: InputMaybe<IdentityAs400_Bool_Exp>;
};


export type Query_RootSelectAggregateJobListViewArgs = {
  distinct_on?: InputMaybe<Array<JobListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobListView_Order_By>>;
  where?: InputMaybe<JobListView_Bool_Exp>;
};


export type Query_RootSelectAggregateLaborRateArgs = {
  distinct_on?: InputMaybe<Array<LaborRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborRate_Order_By>>;
  where?: InputMaybe<LaborRate_Bool_Exp>;
};


export type Query_RootSelectAggregateLaborRateAs400Args = {
  distinct_on?: InputMaybe<Array<LaborRateAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborRateAs400_Order_By>>;
  where?: InputMaybe<LaborRateAs400_Bool_Exp>;
};


export type Query_RootSelectAggregatePaymentAs400Args = {
  distinct_on?: InputMaybe<Array<PaymentAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentAs400_Order_By>>;
  where?: InputMaybe<PaymentAs400_Bool_Exp>;
};


export type Query_RootSelectAggregatePolicyClaimAs400Args = {
  distinct_on?: InputMaybe<Array<PolicyClaimAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimAs400_Order_By>>;
  where?: InputMaybe<PolicyClaimAs400_Bool_Exp>;
};


export type Query_RootSelectAggregatePolicyClaimInsurancesArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimInsurance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimInsurance_Order_By>>;
  where?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
};


export type Query_RootSelectAggregateRaterViewConfigsArgs = {
  distinct_on?: InputMaybe<Array<RaterViewConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RaterViewConfig_Order_By>>;
  where?: InputMaybe<RaterViewConfig_Bool_Exp>;
};


export type Query_RootSelectAggregateRemittanceClaimDetailArgs = {
  distinct_on?: InputMaybe<Array<RemittanceClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceClaimDetail_Order_By>>;
  where?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
};


export type Query_RootSelectAggregateStepListViewArgs = {
  distinct_on?: InputMaybe<Array<StepListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StepListView_Order_By>>;
  where?: InputMaybe<StepListView_Bool_Exp>;
};


export type Query_RootSelectAggregateTaxRateArgs = {
  distinct_on?: InputMaybe<Array<TaxRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxRate_Order_By>>;
  where?: InputMaybe<TaxRate_Bool_Exp>;
};


export type Query_RootSelectAggregateTaxRateAs400Args = {
  distinct_on?: InputMaybe<Array<TaxRateAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxRateAs400_Order_By>>;
  where?: InputMaybe<TaxRateAs400_Bool_Exp>;
};


export type Query_RootSelectAlertArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAlertAcknowledgmentArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAlertAcknowledgmentAggregateArgs = {
  distinct_on?: InputMaybe<Array<AlertAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertAcknowledgment_Order_By>>;
  where?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
};


export type Query_RootSelectAlertAcknowledgmentsArgs = {
  distinct_on?: InputMaybe<Array<AlertAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertAcknowledgment_Order_By>>;
  where?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
};


export type Query_RootSelectAlertAggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Order_By>>;
  where?: InputMaybe<Alert_Bool_Exp>;
};


export type Query_RootSelectAlertsArgs = {
  distinct_on?: InputMaybe<Array<Alert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Order_By>>;
  where?: InputMaybe<Alert_Bool_Exp>;
};


export type Query_RootSelectApplicationArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectApplicationAggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Query_RootSelectApplicationPreferenceArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectApplicationPreferenceAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationPreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationPreference_Order_By>>;
  where?: InputMaybe<ApplicationPreference_Bool_Exp>;
};


export type Query_RootSelectApplicationPreferencesArgs = {
  distinct_on?: InputMaybe<Array<ApplicationPreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationPreference_Order_By>>;
  where?: InputMaybe<ApplicationPreference_Bool_Exp>;
};


export type Query_RootSelectApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Query_RootSelectApprovalArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectApprovalAggregateArgs = {
  distinct_on?: InputMaybe<Array<Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approval_Order_By>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


export type Query_RootSelectApprovalAuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<ApprovalAuthority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalAuthority_Order_By>>;
  where?: InputMaybe<ApprovalAuthority_Bool_Exp>;
};


export type Query_RootSelectApprovalAuthorityArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectApprovalAuthorityAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalAuthority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalAuthority_Order_By>>;
  where?: InputMaybe<ApprovalAuthority_Bool_Exp>;
};


export type Query_RootSelectApprovalGateArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectApprovalGateAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGate_Order_By>>;
  where?: InputMaybe<ApprovalGate_Bool_Exp>;
};


export type Query_RootSelectApprovalGateBindingArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectApprovalGateBindingAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGateBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGateBinding_Order_By>>;
  where?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
};


export type Query_RootSelectApprovalGateBindingsArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGateBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGateBinding_Order_By>>;
  where?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
};


export type Query_RootSelectApprovalGatesArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGate_Order_By>>;
  where?: InputMaybe<ApprovalGate_Bool_Exp>;
};


export type Query_RootSelectApprovalRecordsArgs = {
  distinct_on?: InputMaybe<Array<Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approval_Order_By>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


export type Query_RootSelectApprovalRequestArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectApprovalRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalRequest_Order_By>>;
  where?: InputMaybe<ApprovalRequest_Bool_Exp>;
};


export type Query_RootSelectApprovalRequestsArgs = {
  distinct_on?: InputMaybe<Array<ApprovalRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalRequest_Order_By>>;
  where?: InputMaybe<ApprovalRequest_Bool_Exp>;
};


export type Query_RootSelectApprovalStateAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalState_Order_By>>;
  where?: InputMaybe<ApprovalState_Bool_Exp>;
};


export type Query_RootSelectApprovalStatesArgs = {
  distinct_on?: InputMaybe<Array<ApprovalState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalState_Order_By>>;
  where?: InputMaybe<ApprovalState_Bool_Exp>;
};


export type Query_RootSelectAs400DataSyncArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectAs400DataSyncsArgs = {
  distinct_on?: InputMaybe<Array<As400DataSync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As400DataSync_Order_By>>;
  where?: InputMaybe<As400DataSync_Bool_Exp>;
};


export type Query_RootSelectAs400DataSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<As400DataSync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As400DataSync_Order_By>>;
  where?: InputMaybe<As400DataSync_Bool_Exp>;
};


export type Query_RootSelectBankAccountTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectBankAccountTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<BankAccountType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BankAccountType_Order_By>>;
  where?: InputMaybe<BankAccountType_Bool_Exp>;
};


export type Query_RootSelectBankAccountTypesArgs = {
  distinct_on?: InputMaybe<Array<BankAccountType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BankAccountType_Order_By>>;
  where?: InputMaybe<BankAccountType_Bool_Exp>;
};


export type Query_RootSelectCaddyArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCaddyAggregateArgs = {
  distinct_on?: InputMaybe<Array<Caddy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caddy_Order_By>>;
  where?: InputMaybe<Caddy_Bool_Exp>;
};


export type Query_RootSelectCaddyServerManagerLogArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCaddyServerManagerLogAggregateArgs = {
  distinct_on?: InputMaybe<Array<CaddyServerManagerLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CaddyServerManagerLog_Order_By>>;
  where?: InputMaybe<CaddyServerManagerLog_Bool_Exp>;
};


export type Query_RootSelectCaddyServerManagerLogsArgs = {
  distinct_on?: InputMaybe<Array<CaddyServerManagerLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CaddyServerManagerLog_Order_By>>;
  where?: InputMaybe<CaddyServerManagerLog_Bool_Exp>;
};


export type Query_RootSelectCaddysArgs = {
  distinct_on?: InputMaybe<Array<Caddy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caddy_Order_By>>;
  where?: InputMaybe<Caddy_Bool_Exp>;
};


export type Query_RootSelectCancelQuoteListViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelQuoteListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelQuoteListView_Order_By>>;
  where?: InputMaybe<CancelQuoteListView_Bool_Exp>;
};


export type Query_RootSelectCancelQuoteListViewsArgs = {
  distinct_on?: InputMaybe<Array<CancelQuoteListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelQuoteListView_Order_By>>;
  where?: InputMaybe<CancelQuoteListView_Bool_Exp>;
};


export type Query_RootSelectCancelRuleArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCancelRuleAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRule_Order_By>>;
  where?: InputMaybe<CancelRule_Bool_Exp>;
};


export type Query_RootSelectCancelRuleFeeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCancelRuleFeeAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleFee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleFee_Order_By>>;
  where?: InputMaybe<CancelRuleFee_Bool_Exp>;
};


export type Query_RootSelectCancelRuleFeesArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleFee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleFee_Order_By>>;
  where?: InputMaybe<CancelRuleFee_Bool_Exp>;
};


export type Query_RootSelectCancelRuleRefundArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCancelRuleRefundAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleRefund_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleRefund_Order_By>>;
  where?: InputMaybe<CancelRuleRefund_Bool_Exp>;
};


export type Query_RootSelectCancelRuleRefundsArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleRefund_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleRefund_Order_By>>;
  where?: InputMaybe<CancelRuleRefund_Bool_Exp>;
};


export type Query_RootSelectCancelRulesArgs = {
  distinct_on?: InputMaybe<Array<CancelRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRule_Order_By>>;
  where?: InputMaybe<CancelRule_Bool_Exp>;
};


export type Query_RootSelectCancellationArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCancellationAggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancellation_Order_By>>;
  where?: InputMaybe<Cancellation_Bool_Exp>;
};


export type Query_RootSelectCancellationAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCancellationAs400AggregateArgs = {
  distinct_on?: InputMaybe<Array<CancellationAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationAs400_Order_By>>;
  where?: InputMaybe<CancellationAs400_Bool_Exp>;
};


export type Query_RootSelectCancellationAs400sArgs = {
  distinct_on?: InputMaybe<Array<CancellationAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationAs400_Order_By>>;
  where?: InputMaybe<CancellationAs400_Bool_Exp>;
};


export type Query_RootSelectCancellationsArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancellation_Order_By>>;
  where?: InputMaybe<Cancellation_Bool_Exp>;
};


export type Query_RootSelectCapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Capability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Capability_Order_By>>;
  where?: InputMaybe<Capability_Bool_Exp>;
};


export type Query_RootSelectCapabilityArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCapabilityAggregateArgs = {
  distinct_on?: InputMaybe<Array<Capability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Capability_Order_By>>;
  where?: InputMaybe<Capability_Bool_Exp>;
};


export type Query_RootSelectCapabilityConfigArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCapabilityConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<CapabilityConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityConfig_Order_By>>;
  where?: InputMaybe<CapabilityConfig_Bool_Exp>;
};


export type Query_RootSelectCapabilityConfigsArgs = {
  distinct_on?: InputMaybe<Array<CapabilityConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityConfig_Order_By>>;
  where?: InputMaybe<CapabilityConfig_Bool_Exp>;
};


export type Query_RootSelectCapabilityRouteArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCapabilityRouteAggregateArgs = {
  distinct_on?: InputMaybe<Array<CapabilityRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityRoute_Order_By>>;
  where?: InputMaybe<CapabilityRoute_Bool_Exp>;
};


export type Query_RootSelectCapabilityRoutesArgs = {
  distinct_on?: InputMaybe<Array<CapabilityRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityRoute_Order_By>>;
  where?: InputMaybe<CapabilityRoute_Bool_Exp>;
};


export type Query_RootSelectCardLayoutArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCardLayoutAggregateArgs = {
  distinct_on?: InputMaybe<Array<CardLayout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CardLayout_Order_By>>;
  where?: InputMaybe<CardLayout_Bool_Exp>;
};


export type Query_RootSelectCardLayoutsArgs = {
  distinct_on?: InputMaybe<Array<CardLayout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CardLayout_Order_By>>;
  where?: InputMaybe<CardLayout_Bool_Exp>;
};


export type Query_RootSelectCarrierArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCarrierAggregateArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Query_RootSelectCarriersArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Query_RootSelectCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Query_RootSelectCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Query_RootSelectCategoryArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCategoryClassGuidesArgs = {
  distinct_on?: InputMaybe<Array<CategoryClassGuide_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CategoryClassGuide_Order_By>>;
  where?: InputMaybe<CategoryClassGuide_Bool_Exp_Bool_Exp>;
};


export type Query_RootSelectCategoryProductAttributeTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCategoryProductAttributeTypesArgs = {
  distinct_on?: InputMaybe<Array<CategoryProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CategoryProductAttributeType_Order_By>>;
  where?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
};


export type Query_RootSelectCategoryProductAttributeTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CategoryProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CategoryProductAttributeType_Order_By>>;
  where?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
};


export type Query_RootSelectClaimArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClaimAggregateArgs = {
  distinct_on?: InputMaybe<Array<Claim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claim_Order_By>>;
  where?: InputMaybe<Claim_Bool_Exp>;
};


export type Query_RootSelectClaimDetailArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClaimDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


export type Query_RootSelectClaimDetailAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClaimDetailAs400sArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailAs400_Order_By>>;
  where?: InputMaybe<ClaimDetailAs400_Bool_Exp>;
};


export type Query_RootSelectClaimDetailCategoriesArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailCategory_Order_By>>;
  where?: InputMaybe<ClaimDetailCategory_Bool_Exp>;
};


export type Query_RootSelectClaimDetailCategoryArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClaimDetailCategoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailCategory_Order_By>>;
  where?: InputMaybe<ClaimDetailCategory_Bool_Exp>;
};


export type Query_RootSelectClaimDetailDeductionAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClaimDetailDeductionAs400sArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailDeductionAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailDeductionAs400_Order_By>>;
  where?: InputMaybe<ClaimDetailDeductionAs400_Bool_Exp>;
};


export type Query_RootSelectClaimDetailPartLookupArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClaimDetailPartLookupAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailPartLookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailPartLookup_Order_By>>;
  where?: InputMaybe<ClaimDetailPartLookup_Bool_Exp>;
};


export type Query_RootSelectClaimDetailPartLookupsArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailPartLookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailPartLookup_Order_By>>;
  where?: InputMaybe<ClaimDetailPartLookup_Bool_Exp>;
};


export type Query_RootSelectClaimDetailsArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


export type Query_RootSelectClaimPartAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimPart_Order_By>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};


export type Query_RootSelectClaimPartsArgs = {
  distinct_on?: InputMaybe<Array<ClaimPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimPart_Order_By>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};


export type Query_RootSelectClaimServiceCenterArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClaimServiceCenterAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenter_Order_By>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


export type Query_RootSelectClaimServiceCenterAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClaimServiceCenterAs400sArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenterAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenterAs400_Order_By>>;
  where?: InputMaybe<ClaimServiceCenterAs400_Bool_Exp>;
};


export type Query_RootSelectClaimServiceCenterAuthorizationArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClaimServiceCenterAuthorizationAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenterAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenterAuthorization_Order_By>>;
  where?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
};


export type Query_RootSelectClaimServiceCenterAuthorizationsArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenterAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenterAuthorization_Order_By>>;
  where?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
};


export type Query_RootSelectClaimServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenter_Order_By>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


export type Query_RootSelectClaimStatusArgs = {
  ClaimStatusCode: Scalars['String'];
};


export type Query_RootSelectClaimStatusAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimStatus_Order_By>>;
  where?: InputMaybe<ClaimStatus_Bool_Exp>;
};


export type Query_RootSelectClaimStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClaimStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimStatusType_Order_By>>;
  where?: InputMaybe<ClaimStatusType_Bool_Exp>;
};


export type Query_RootSelectClaimStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<ClaimStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimStatusType_Order_By>>;
  where?: InputMaybe<ClaimStatusType_Bool_Exp>;
};


export type Query_RootSelectClaimStatusesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimStatus_Order_By>>;
  where?: InputMaybe<ClaimStatus_Bool_Exp>;
};


export type Query_RootSelectClaimsArgs = {
  distinct_on?: InputMaybe<Array<Claim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claim_Order_By>>;
  where?: InputMaybe<Claim_Bool_Exp>;
};


export type Query_RootSelectClaimsMasterAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimsMaster_Order_By>>;
  where?: InputMaybe<ClaimsMaster_Bool_Exp>;
};


export type Query_RootSelectClaimsMastersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimsMaster_Order_By>>;
  where?: InputMaybe<ClaimsMaster_Bool_Exp>;
};


export type Query_RootSelectClassCriteriaArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClassCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteria_Bool_Exp>;
};


export type Query_RootSelectClassCriteriaViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaView_Order_By>>;
  where?: InputMaybe<ClassCriteriaView_Bool_Exp>;
};


export type Query_RootSelectClassCriteriaViewDefaultVehicleCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Query_RootSelectClassCriteriaViewDefaultVehicleCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Query_RootSelectClassCriteriaViewUnclassedDefaultVehicleCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Bool_Exp>;
};


export type Query_RootSelectClassCriteriaViewUnclassedDefaultVehicleCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Bool_Exp>;
};


export type Query_RootSelectClassCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteria_Bool_Exp>;
};


export type Query_RootSelectClassCriteriasViewArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaView_Order_By>>;
  where?: InputMaybe<ClassCriteriaView_Bool_Exp>;
};


export type Query_RootSelectClassGuideArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClassGuideAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuide_Order_By>>;
  where?: InputMaybe<ClassGuide_Bool_Exp>;
};


export type Query_RootSelectClassGuideClassCriteriaArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClassGuideClassCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


export type Query_RootSelectClassGuideClassCriteriaViewDefaultVehicleCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Query_RootSelectClassGuideClassCriteriaViewDefaultVehicleCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Query_RootSelectClassGuideClassCriteriaViewVinAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteriaViewVin_Bool_Exp>;
};


export type Query_RootSelectClassGuideClassCriteriaViewVinsArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteriaViewVin_Bool_Exp>;
};


export type Query_RootSelectClassGuideClassCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


export type Query_RootSelectClassGuideCriteriaDefinitionArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClassGuideCriteriaDefinitionAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaDefinition_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};


export type Query_RootSelectClassGuideCriteriaDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaDefinition_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};


export type Query_RootSelectClassGuideCriteriaTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectClassGuideCriteriaTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaType_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaType_Bool_Exp>;
};


export type Query_RootSelectClassGuideCriteriaTypesArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaType_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaType_Bool_Exp>;
};


export type Query_RootSelectClassGuidesArgs = {
  distinct_on?: InputMaybe<Array<ClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuide_Order_By>>;
  where?: InputMaybe<ClassGuide_Bool_Exp>;
};


export type Query_RootSelectCompositeProductArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCompositeProductsArgs = {
  distinct_on?: InputMaybe<Array<CompositeProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompositeProduct_Order_By>>;
  where?: InputMaybe<CompositeProduct_Bool_Exp>;
};


export type Query_RootSelectConfigurationItemArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectConfigurationItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigurationItem_Order_By>>;
  where?: InputMaybe<ConfigurationItem_Bool_Exp>;
};


export type Query_RootSelectConfigurationItemTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectConfigurationItemTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigurationItemType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigurationItemType_Order_By>>;
  where?: InputMaybe<ConfigurationItemType_Bool_Exp>;
};


export type Query_RootSelectConfigurationItemTypesArgs = {
  distinct_on?: InputMaybe<Array<ConfigurationItemType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigurationItemType_Order_By>>;
  where?: InputMaybe<ConfigurationItemType_Bool_Exp>;
};


export type Query_RootSelectConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<ConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigurationItem_Order_By>>;
  where?: InputMaybe<ConfigurationItem_Bool_Exp>;
};


export type Query_RootSelectContactArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectContactAggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Query_RootSelectContactsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Query_RootSelectContentTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectContentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentType_Order_By>>;
  where?: InputMaybe<ContentType_Bool_Exp>;
};


export type Query_RootSelectContentTypesArgs = {
  distinct_on?: InputMaybe<Array<ContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentType_Order_By>>;
  where?: InputMaybe<ContentType_Bool_Exp>;
};


export type Query_RootSelectContractArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectContractAggregateArgs = {
  distinct_on?: InputMaybe<Array<Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contract_Order_By>>;
  where?: InputMaybe<Contract_Bool_Exp>;
};


export type Query_RootSelectContractFormArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectContractFormAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractForm_Order_By>>;
  where?: InputMaybe<ContractForm_Bool_Exp>;
};


export type Query_RootSelectContractFormFilingStatusArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectContractFormFilingStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


export type Query_RootSelectContractFormFilingStatusesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


export type Query_RootSelectContractFormTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectContractFormTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormType_Order_By>>;
  where?: InputMaybe<ContractFormType_Bool_Exp>;
};


export type Query_RootSelectContractFormTypesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormType_Order_By>>;
  where?: InputMaybe<ContractFormType_Bool_Exp>;
};


export type Query_RootSelectContractFormVersionArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectContractFormVersionAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersion_Order_By>>;
  where?: InputMaybe<ContractFormVersion_Bool_Exp>;
};


export type Query_RootSelectContractFormVersionLegacyFileArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectContractFormVersionLegacyFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersionLegacyFile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersionLegacyFile_Order_By>>;
  where?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
};


export type Query_RootSelectContractFormVersionLegacyFilesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersionLegacyFile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersionLegacyFile_Order_By>>;
  where?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
};


export type Query_RootSelectContractFormVersionsArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersion_Order_By>>;
  where?: InputMaybe<ContractFormVersion_Bool_Exp>;
};


export type Query_RootSelectContractFormsArgs = {
  distinct_on?: InputMaybe<Array<ContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractForm_Order_By>>;
  where?: InputMaybe<ContractForm_Bool_Exp>;
};


export type Query_RootSelectContractMasterArgs = {
  ContractMasterID: Scalars['Int'];
};


export type Query_RootSelectContractMasterAdditionalEntiiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterAdditionalEntity_Order_By>>;
  where?: InputMaybe<ContractMasterAdditionalEntity_Bool_Exp>;
};


export type Query_RootSelectContractMasterAdditionalEntityAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterAdditionalEntity_Order_By>>;
  where?: InputMaybe<ContractMasterAdditionalEntity_Bool_Exp>;
};


export type Query_RootSelectContractMasterAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMaster_Order_By>>;
  where?: InputMaybe<ContractMaster_Bool_Exp>;
};


export type Query_RootSelectContractMastersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMaster_Order_By>>;
  where?: InputMaybe<ContractMaster_Bool_Exp>;
};


export type Query_RootSelectContractStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectContractStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractStatusType_Order_By>>;
  where?: InputMaybe<ContractStatusType_Bool_Exp>;
};


export type Query_RootSelectContractStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<ContractStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractStatusType_Order_By>>;
  where?: InputMaybe<ContractStatusType_Bool_Exp>;
};


export type Query_RootSelectContractsArgs = {
  distinct_on?: InputMaybe<Array<Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contract_Order_By>>;
  where?: InputMaybe<Contract_Bool_Exp>;
};


export type Query_RootSelectCostAdjustmentArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCostAdjustmentAggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustment_Order_By>>;
  where?: InputMaybe<CostAdjustment_Bool_Exp>;
};


export type Query_RootSelectCostAdjustmentExtendedCostArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCostAdjustmentExtendedCostAggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentExtendedCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentExtendedCost_Order_By>>;
  where?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
};


export type Query_RootSelectCostAdjustmentExtendedCostsArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentExtendedCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentExtendedCost_Order_By>>;
  where?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
};


export type Query_RootSelectCostAdjustmentLookupArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCostAdjustmentLookupAggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentLookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentLookup_Order_By>>;
  where?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
};


export type Query_RootSelectCostAdjustmentLookupsArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentLookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentLookup_Order_By>>;
  where?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
};


export type Query_RootSelectCostAdjustmentTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectCostAdjustmentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentType_Order_By>>;
  where?: InputMaybe<CostAdjustmentType_Bool_Exp>;
};


export type Query_RootSelectCostAdjustmentTypesArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentType_Order_By>>;
  where?: InputMaybe<CostAdjustmentType_Bool_Exp>;
};


export type Query_RootSelectCostAdjustmentsArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustment_Order_By>>;
  where?: InputMaybe<CostAdjustment_Bool_Exp>;
};


export type Query_RootSelectCustomFieldArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCustomFieldDataArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCustomFieldDataAggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomFieldData_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomFieldData_Order_By>>;
  where?: InputMaybe<CustomFieldData_Bool_Exp>;
};


export type Query_RootSelectCustomFieldDatasArgs = {
  distinct_on?: InputMaybe<Array<CustomFieldData_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomFieldData_Order_By>>;
  where?: InputMaybe<CustomFieldData_Bool_Exp>;
};


export type Query_RootSelectCustomFieldTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCustomFieldTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomFieldType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomFieldType_Order_By>>;
  where?: InputMaybe<CustomFieldType_Bool_Exp>;
};


export type Query_RootSelectCustomFieldTypesArgs = {
  distinct_on?: InputMaybe<Array<CustomFieldType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomFieldType_Order_By>>;
  where?: InputMaybe<CustomFieldType_Bool_Exp>;
};


export type Query_RootSelectCustomFieldsArgs = {
  distinct_on?: InputMaybe<Array<CustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomField_Order_By>>;
  where?: InputMaybe<CustomField_Bool_Exp>;
};


export type Query_RootSelectCustomFieldsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomField_Order_By>>;
  where?: InputMaybe<CustomField_Bool_Exp>;
};


export type Query_RootSelectCustomerArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCustomerAggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Query_RootSelectCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Query_RootSelectCycleArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCycleAggregateArgs = {
  distinct_on?: InputMaybe<Array<Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cycle_Order_By>>;
  where?: InputMaybe<Cycle_Bool_Exp>;
};


export type Query_RootSelectCycleJournalEntriesArgs = {
  distinct_on?: InputMaybe<Array<CycleJournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleJournalEntry_Order_By>>;
  where?: InputMaybe<CycleJournalEntry_Bool_Exp>;
};


export type Query_RootSelectCycleJournalEntryArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCycleJournalEntryAggregateArgs = {
  distinct_on?: InputMaybe<Array<CycleJournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleJournalEntry_Order_By>>;
  where?: InputMaybe<CycleJournalEntry_Bool_Exp>;
};


export type Query_RootSelectCycleTotalArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectCycleTotalAggregateArgs = {
  distinct_on?: InputMaybe<Array<CycleTotal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleTotal_Order_By>>;
  where?: InputMaybe<CycleTotal_Bool_Exp>;
};


export type Query_RootSelectCycleTotalsArgs = {
  distinct_on?: InputMaybe<Array<CycleTotal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleTotal_Order_By>>;
  where?: InputMaybe<CycleTotal_Bool_Exp>;
};


export type Query_RootSelectCyclesArgs = {
  distinct_on?: InputMaybe<Array<Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cycle_Order_By>>;
  where?: InputMaybe<Cycle_Bool_Exp>;
};


export type Query_RootSelectDataTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectDataTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<DataType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DataType_Order_By>>;
  where?: InputMaybe<DataType_Bool_Exp>;
};


export type Query_RootSelectDataTypesArgs = {
  distinct_on?: InputMaybe<Array<DataType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DataType_Order_By>>;
  where?: InputMaybe<DataType_Bool_Exp>;
};


export type Query_RootSelectDateCalculationTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectDateCalculationTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<DateCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DateCalculationType_Order_By>>;
  where?: InputMaybe<DateCalculationType_Bool_Exp>;
};


export type Query_RootSelectDateCalculationTypesArgs = {
  distinct_on?: InputMaybe<Array<DateCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DateCalculationType_Order_By>>;
  where?: InputMaybe<DateCalculationType_Bool_Exp>;
};


export type Query_RootSelectDealerArgs = {
  DealerID: Scalars['Int'];
};


export type Query_RootSelectDealerAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dealer_Order_By>>;
  where?: InputMaybe<Dealer_Bool_Exp>;
};


export type Query_RootSelectDealerAlertAggregateArgs = {
  distinct_on?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Order_By>>;
  where?: InputMaybe<Shared_Dealer_Alert_List_View_Bool_Exp>;
};


export type Query_RootSelectDealerAlertsArgs = {
  distinct_on?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Order_By>>;
  where?: InputMaybe<Shared_Dealer_Alert_List_View_Bool_Exp>;
};


export type Query_RootSelectDealerPaymentTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectDealerPaymentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<DealerPaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DealerPaymentType_Order_By>>;
  where?: InputMaybe<DealerPaymentType_Bool_Exp>;
};


export type Query_RootSelectDealerPaymentTypesArgs = {
  distinct_on?: InputMaybe<Array<DealerPaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DealerPaymentType_Order_By>>;
  where?: InputMaybe<DealerPaymentType_Bool_Exp>;
};


export type Query_RootSelectDealersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dealer_Order_By>>;
  where?: InputMaybe<Dealer_Bool_Exp>;
};


export type Query_RootSelectDisbursementTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectDisbursementTypesArgs = {
  distinct_on?: InputMaybe<Array<DisbursementType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DisbursementType_Order_By>>;
  where?: InputMaybe<DisbursementType_Bool_Exp>;
};


export type Query_RootSelectDisbursementTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DisbursementType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DisbursementType_Order_By>>;
  where?: InputMaybe<DisbursementType_Bool_Exp>;
};


export type Query_RootSelectDocumentArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectDocumentAggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootSelectDocumentInstanceArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectDocumentInstanceAggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentInstance_Order_By>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


export type Query_RootSelectDocumentInstancesArgs = {
  distinct_on?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentInstance_Order_By>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


export type Query_RootSelectDocumentTemplateArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectDocumentTemplateAggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplate_Order_By>>;
  where?: InputMaybe<DocumentTemplate_Bool_Exp>;
};


export type Query_RootSelectDocumentTemplateApplicationArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectDocumentTemplateApplicationAggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplateApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplateApplication_Order_By>>;
  where?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
};


export type Query_RootSelectDocumentTemplateApplicationsArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplateApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplateApplication_Order_By>>;
  where?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
};


export type Query_RootSelectDocumentTemplatesArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplate_Order_By>>;
  where?: InputMaybe<DocumentTemplate_Bool_Exp>;
};


export type Query_RootSelectDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootSelectEligibilityRuleArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEligibilityRuleAggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRule_Order_By>>;
  where?: InputMaybe<EligibilityRule_Bool_Exp>;
};


export type Query_RootSelectEligibilityRuleDefinitionArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEligibilityRuleDefinitionAggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRuleDefinition_Order_By>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};


export type Query_RootSelectEligibilityRuleDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRuleDefinition_Order_By>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};


export type Query_RootSelectEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRule_Order_By>>;
  where?: InputMaybe<EligibilityRule_Bool_Exp>;
};


export type Query_RootSelectEligibilityTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectEligibilityTypesArgs = {
  distinct_on?: InputMaybe<Array<EligibilityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityType_Order_By>>;
  where?: InputMaybe<EligibilityType_Bool_Exp>;
};


export type Query_RootSelectEligibilityTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityType_Order_By>>;
  where?: InputMaybe<EligibilityType_Bool_Exp>;
};


export type Query_RootSelectEntityBillingInformationArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityBillingInformationAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityBillingInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityBillingInformation_Order_By>>;
  where?: InputMaybe<EntityBillingInformation_Bool_Exp>;
};


export type Query_RootSelectEntityBillingInformationsArgs = {
  distinct_on?: InputMaybe<Array<EntityBillingInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityBillingInformation_Order_By>>;
  where?: InputMaybe<EntityBillingInformation_Bool_Exp>;
};


export type Query_RootSelectEntityConfigurationItemArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityConfigurationItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


export type Query_RootSelectEntityConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


export type Query_RootSelectEntityContentTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityContentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityContentType_Order_By>>;
  where?: InputMaybe<EntityContentType_Bool_Exp>;
};


export type Query_RootSelectEntityContentTypesArgs = {
  distinct_on?: InputMaybe<Array<EntityContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityContentType_Order_By>>;
  where?: InputMaybe<EntityContentType_Bool_Exp>;
};


export type Query_RootSelectEntityCustomFieldArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityCustomFieldValueArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityCustomFieldValueAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomFieldValue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomFieldValue_Order_By>>;
  where?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
};


export type Query_RootSelectEntityCustomFieldValuesArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomFieldValue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomFieldValue_Order_By>>;
  where?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
};


export type Query_RootSelectEntityCustomFieldsArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomField_Order_By>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


export type Query_RootSelectEntityCustomFieldsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomField_Order_By>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


export type Query_RootSelectEntityDataDefinitionArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityDataDefinitionAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityDataDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityDataDefinition_Order_By>>;
  where?: InputMaybe<EntityDataDefinition_Bool_Exp>;
};


export type Query_RootSelectEntityDataDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<EntityDataDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityDataDefinition_Order_By>>;
  where?: InputMaybe<EntityDataDefinition_Bool_Exp>;
};


export type Query_RootSelectEntityEligibilityRuleArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityEligibilityRuleAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


export type Query_RootSelectEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


export type Query_RootSelectEntityFeatureArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityFeatureAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


export type Query_RootSelectEntityFeaturesArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


export type Query_RootSelectEntityFileContentTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityFileContentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileContentType_Order_By>>;
  where?: InputMaybe<EntityFileContentType_Bool_Exp>;
};


export type Query_RootSelectEntityFileContentTypesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileContentType_Order_By>>;
  where?: InputMaybe<EntityFileContentType_Bool_Exp>;
};


export type Query_RootSelectEntityFileStorageArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityFileStorageAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


export type Query_RootSelectEntityFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


export type Query_RootSelectEntityNoteArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityNoteAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


export type Query_RootSelectEntityNoteCapabilityViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNoteCapabilityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNoteCapabilityView_Order_By>>;
  where?: InputMaybe<EntityNoteCapabilityView_Bool_Exp>;
};


export type Query_RootSelectEntityNoteCapabilityViewsArgs = {
  distinct_on?: InputMaybe<Array<EntityNoteCapabilityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNoteCapabilityView_Order_By>>;
  where?: InputMaybe<EntityNoteCapabilityView_Bool_Exp>;
};


export type Query_RootSelectEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


export type Query_RootSelectEntityOfferingArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityOfferingAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


export type Query_RootSelectEntityOfferingsArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


export type Query_RootSelectEntityRemittanceDetailArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityRemittanceDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


export type Query_RootSelectEntityRemittanceDetailsArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


export type Query_RootSelectEntityTagArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectEntityTagAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


export type Query_RootSelectEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


export type Query_RootSelectFeatureArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectFeatureAggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Order_By>>;
  where?: InputMaybe<Feature_Bool_Exp>;
};


export type Query_RootSelectFeaturesArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Order_By>>;
  where?: InputMaybe<Feature_Bool_Exp>;
};


export type Query_RootSelectFileStorageArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectFileStorageAggregateArgs = {
  distinct_on?: InputMaybe<Array<FileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileStorage_Order_By>>;
  where?: InputMaybe<FileStorage_Bool_Exp>;
};


export type Query_RootSelectFileStorageTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectFileStorageTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<FileStorageType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileStorageType_Order_By>>;
  where?: InputMaybe<FileStorageType_Bool_Exp>;
};


export type Query_RootSelectFileStorageTypesArgs = {
  distinct_on?: InputMaybe<Array<FileStorageType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileStorageType_Order_By>>;
  where?: InputMaybe<FileStorageType_Bool_Exp>;
};


export type Query_RootSelectFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<FileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileStorage_Order_By>>;
  where?: InputMaybe<FileStorage_Bool_Exp>;
};


export type Query_RootSelectFilingLenderArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectFilingLenderMatchArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectFilingLenderMatchAggregateArgs = {
  distinct_on?: InputMaybe<Array<FilingLenderMatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingLenderMatch_Order_By>>;
  where?: InputMaybe<FilingLenderMatch_Bool_Exp>;
};


export type Query_RootSelectFilingLenderMatchesArgs = {
  distinct_on?: InputMaybe<Array<FilingLenderMatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingLenderMatch_Order_By>>;
  where?: InputMaybe<FilingLenderMatch_Bool_Exp>;
};


export type Query_RootSelectFilingLendersArgs = {
  distinct_on?: InputMaybe<Array<FilingLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingLender_Order_By>>;
  where?: InputMaybe<FilingLender_Bool_Exp>;
};


export type Query_RootSelectFilingStateArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectFilingStateAggregateArgs = {
  distinct_on?: InputMaybe<Array<FilingState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingState_Order_By>>;
  where?: InputMaybe<FilingState_Bool_Exp>;
};


export type Query_RootSelectFilingStatesArgs = {
  distinct_on?: InputMaybe<Array<FilingState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingState_Order_By>>;
  where?: InputMaybe<FilingState_Bool_Exp>;
};


export type Query_RootSelectFilingStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectFilingStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<FilingStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingStatusType_Order_By>>;
  where?: InputMaybe<FilingStatusType_Bool_Exp>;
};


export type Query_RootSelectFilingStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<FilingStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingStatusType_Order_By>>;
  where?: InputMaybe<FilingStatusType_Bool_Exp>;
};


export type Query_RootSelectFlowItemArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectFlowItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItem_Order_By>>;
  where?: InputMaybe<FlowItem_Bool_Exp>;
};


export type Query_RootSelectFlowItemTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectFlowItemTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowItemType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItemType_Order_By>>;
  where?: InputMaybe<FlowItemType_Bool_Exp>;
};


export type Query_RootSelectFlowItemTypesArgs = {
  distinct_on?: InputMaybe<Array<FlowItemType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItemType_Order_By>>;
  where?: InputMaybe<FlowItemType_Bool_Exp>;
};


export type Query_RootSelectFlowItemsArgs = {
  distinct_on?: InputMaybe<Array<FlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItem_Order_By>>;
  where?: InputMaybe<FlowItem_Bool_Exp>;
};


export type Query_RootSelectFlowTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectFlowTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowType_Order_By>>;
  where?: InputMaybe<FlowType_Bool_Exp>;
};


export type Query_RootSelectFlowTypesArgs = {
  distinct_on?: InputMaybe<Array<FlowType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowType_Order_By>>;
  where?: InputMaybe<FlowType_Bool_Exp>;
};


export type Query_RootSelectIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


export type Query_RootSelectIdentitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


export type Query_RootSelectIdentityArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectIdentityAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectIdentityAs400sArgs = {
  distinct_on?: InputMaybe<Array<IdentityAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityAs400_Order_By>>;
  where?: InputMaybe<IdentityAs400_Bool_Exp>;
};


export type Query_RootSelectIdentityCapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapability_Order_By>>;
  where?: InputMaybe<IdentityCapability_Bool_Exp>;
};


export type Query_RootSelectIdentityCapabilityArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectIdentityCapabilityAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapability_Order_By>>;
  where?: InputMaybe<IdentityCapability_Bool_Exp>;
};


export type Query_RootSelectIdentityCapabilityViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapabilityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapabilityView_Order_By>>;
  where?: InputMaybe<IdentityCapabilityView_Bool_Exp>;
};


export type Query_RootSelectIdentityCapabilityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapabilityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapabilityView_Order_By>>;
  where?: InputMaybe<IdentityCapabilityView_Bool_Exp>;
};


export type Query_RootSelectIdentityEntitiesArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntity_Order_By>>;
  where?: InputMaybe<IdentityEntity_Bool_Exp>;
};


export type Query_RootSelectIdentityEntityArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectIdentityEntityAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntity_Order_By>>;
  where?: InputMaybe<IdentityEntity_Bool_Exp>;
};


export type Query_RootSelectIdentityEntityViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


export type Query_RootSelectIdentityEntityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


export type Query_RootSelectIdentityFilterArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectIdentityFilterAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityFilter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityFilter_Order_By>>;
  where?: InputMaybe<IdentityFilter_Bool_Exp>;
};


export type Query_RootSelectIdentityFiltersArgs = {
  distinct_on?: InputMaybe<Array<IdentityFilter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityFilter_Order_By>>;
  where?: InputMaybe<IdentityFilter_Bool_Exp>;
};


export type Query_RootSelectInvoiceArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectInvoiceAggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootSelectInvoiceDocumentTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectInvoiceDocumentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvoiceDocumentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceDocumentType_Order_By>>;
  where?: InputMaybe<InvoiceDocumentType_Bool_Exp>;
};


export type Query_RootSelectInvoiceDocumentTypesArgs = {
  distinct_on?: InputMaybe<Array<InvoiceDocumentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceDocumentType_Order_By>>;
  where?: InputMaybe<InvoiceDocumentType_Bool_Exp>;
};


export type Query_RootSelectInvoicePaymentTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectInvoicePaymentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvoicePaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoicePaymentType_Order_By>>;
  where?: InputMaybe<InvoicePaymentType_Bool_Exp>;
};


export type Query_RootSelectInvoicePaymentTypesArgs = {
  distinct_on?: InputMaybe<Array<InvoicePaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoicePaymentType_Order_By>>;
  where?: InputMaybe<InvoicePaymentType_Bool_Exp>;
};


export type Query_RootSelectInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootSelectJobArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectJobAggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Order_By>>;
  where?: InputMaybe<Job_Bool_Exp>;
};


export type Query_RootSelectJobHistoriesArgs = {
  distinct_on?: InputMaybe<Array<JobHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistory_Order_By>>;
  where?: InputMaybe<JobHistory_Bool_Exp>;
};


export type Query_RootSelectJobHistoryArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectJobHistoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistory_Order_By>>;
  where?: InputMaybe<JobHistory_Bool_Exp>;
};


export type Query_RootSelectJobHistoryLogArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectJobHistoryLogAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobHistoryLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistoryLog_Order_By>>;
  where?: InputMaybe<JobHistoryLog_Bool_Exp>;
};


export type Query_RootSelectJobHistoryLogsArgs = {
  distinct_on?: InputMaybe<Array<JobHistoryLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistoryLog_Order_By>>;
  where?: InputMaybe<JobHistoryLog_Bool_Exp>;
};


export type Query_RootSelectJobListViewsArgs = {
  distinct_on?: InputMaybe<Array<JobListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobListView_Order_By>>;
  where?: InputMaybe<JobListView_Bool_Exp>;
};


export type Query_RootSelectJobScheduleArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectJobScheduleAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobSchedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSchedule_Order_By>>;
  where?: InputMaybe<JobSchedule_Bool_Exp>;
};


export type Query_RootSelectJobSchedulesArgs = {
  distinct_on?: InputMaybe<Array<JobSchedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSchedule_Order_By>>;
  where?: InputMaybe<JobSchedule_Bool_Exp>;
};


export type Query_RootSelectJobStepArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectJobStepAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobStep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobStep_Order_By>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};


export type Query_RootSelectJobStepsArgs = {
  distinct_on?: InputMaybe<Array<JobStep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobStep_Order_By>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};


export type Query_RootSelectJobsArgs = {
  distinct_on?: InputMaybe<Array<Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Order_By>>;
  where?: InputMaybe<Job_Bool_Exp>;
};


export type Query_RootSelectJournalEntriesArgs = {
  distinct_on?: InputMaybe<Array<JournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntry_Order_By>>;
  where?: InputMaybe<JournalEntry_Bool_Exp>;
};


export type Query_RootSelectJournalEntryArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectJournalEntryAggregateArgs = {
  distinct_on?: InputMaybe<Array<JournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntry_Order_By>>;
  where?: InputMaybe<JournalEntry_Bool_Exp>;
};


export type Query_RootSelectJournalEntryLineArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectJournalEntryLineAggregateArgs = {
  distinct_on?: InputMaybe<Array<JournalEntryLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntryLine_Order_By>>;
  where?: InputMaybe<JournalEntryLine_Bool_Exp>;
};


export type Query_RootSelectJournalEntryLinesArgs = {
  distinct_on?: InputMaybe<Array<JournalEntryLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntryLine_Order_By>>;
  where?: InputMaybe<JournalEntryLine_Bool_Exp>;
};


export type Query_RootSelectLaborGuideTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectLaborGuideTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<LaborGuideType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborGuideType_Order_By>>;
  where?: InputMaybe<LaborGuideType_Bool_Exp>;
};


export type Query_RootSelectLaborGuideTypesArgs = {
  distinct_on?: InputMaybe<Array<LaborGuideType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborGuideType_Order_By>>;
  where?: InputMaybe<LaborGuideType_Bool_Exp>;
};


export type Query_RootSelectLaborRateArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectLaborRateAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectLaborRateAs400sArgs = {
  distinct_on?: InputMaybe<Array<LaborRateAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborRateAs400_Order_By>>;
  where?: InputMaybe<LaborRateAs400_Bool_Exp>;
};


export type Query_RootSelectLaborRatesArgs = {
  distinct_on?: InputMaybe<Array<LaborRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborRate_Order_By>>;
  where?: InputMaybe<LaborRate_Bool_Exp>;
};


export type Query_RootSelectLegacyPolicyContractArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectLegacyPolicyContractAggregateArgs = {
  distinct_on?: InputMaybe<Array<LegacyPolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LegacyPolicyContract_Order_By>>;
  where?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
};


export type Query_RootSelectLegacyPolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<LegacyPolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LegacyPolicyContract_Order_By>>;
  where?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
};


export type Query_RootSelectLoggedActionAggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


export type Query_RootSelectLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


export type Query_RootSelectLossRatioArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectLossRatioCurrentViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<LossRatioCurrentView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatioCurrentView_Order_By>>;
  where?: InputMaybe<LossRatioCurrentView_Bool_Exp>;
};


export type Query_RootSelectLossRatioCurrentViewsArgs = {
  distinct_on?: InputMaybe<Array<LossRatioCurrentView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatioCurrentView_Order_By>>;
  where?: InputMaybe<LossRatioCurrentView_Bool_Exp>;
};


export type Query_RootSelectLossRatiosArgs = {
  distinct_on?: InputMaybe<Array<LossRatio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatio_Order_By>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};


export type Query_RootSelectLossRatiosAggregateArgs = {
  distinct_on?: InputMaybe<Array<LossRatio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatio_Order_By>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};


export type Query_RootSelectMateralizedClassCriteriaViewDefaultVehicleCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Query_RootSelectMateralizedClassCriteriaViewDefaultVehicleCriteriasArgs = {
  distinct_on?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Query_RootSelectMilesCalculationTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectMilesCalculationTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<MilesCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MilesCalculationType_Order_By>>;
  where?: InputMaybe<MilesCalculationType_Bool_Exp>;
};


export type Query_RootSelectMilesCalculationTypesArgs = {
  distinct_on?: InputMaybe<Array<MilesCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MilesCalculationType_Order_By>>;
  where?: InputMaybe<MilesCalculationType_Bool_Exp>;
};


export type Query_RootSelectNhtsaConcernSynonymAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConcernSynonym_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConcernSynonym_Order_By_Nhtsa>>;
  where?: InputMaybe<ConcernSynonym_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaConcernSynonymsArgs = {
  distinct_on?: InputMaybe<Array<ConcernSynonym_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConcernSynonym_Order_By_Nhtsa>>;
  where?: InputMaybe<ConcernSynonym_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaInvestigationRecallArgs = {
  investigationIssueId: Scalars['String'];
  recallNumber: Scalars['String'];
};


export type Query_RootSelectNhtsaInvestigationRecallAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvestigationRecall_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvestigationRecall_Order_By_Nhtsa>>;
  where?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaInvestigationRecallsArgs = {
  distinct_on?: InputMaybe<Array<InvestigationRecall_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvestigationRecall_Order_By_Nhtsa>>;
  where?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaIssueArgs = {
  id: Scalars['String'];
};


export type Query_RootSelectNhtsaIssueAggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Order_By_Nhtsa>>;
  where?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaIssueMakeModelAggregateArgs = {
  distinct_on?: InputMaybe<Array<IssueMakeModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueMakeModel_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaIssueMakeModelsArgs = {
  distinct_on?: InputMaybe<Array<IssueMakeModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueMakeModel_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaIssueSearchResultAggregateArgs = {
  distinct_on?: InputMaybe<Array<IssueSearchResult_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueSearchResult_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueSearchResult_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaIssueSearchResultsArgs = {
  distinct_on?: InputMaybe<Array<IssueSearchResult_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueSearchResult_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueSearchResult_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaIssueVehicleAggregateArgs = {
  distinct_on?: InputMaybe<Array<IssueVehicle_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueVehicle_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueVehicle_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaIssueVehiclesArgs = {
  distinct_on?: InputMaybe<Array<IssueVehicle_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueVehicle_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueVehicle_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaIssuesArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Order_By_Nhtsa>>;
  where?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaLoadArgs = {
  dataset: Scalars['String'];
};


export type Query_RootSelectNhtsaLoadAggregateArgs = {
  distinct_on?: InputMaybe<Array<Load_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Load_Order_By_Nhtsa>>;
  where?: InputMaybe<Load_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaLoadsArgs = {
  distinct_on?: InputMaybe<Array<Load_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Load_Order_By_Nhtsa>>;
  where?: InputMaybe<Load_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaMakeModelArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectNhtsaMakeModelAggregateArgs = {
  distinct_on?: InputMaybe<Array<MakeModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MakeModel_Order_By_Nhtsa>>;
  where?: InputMaybe<MakeModel_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaMakeModelsArgs = {
  distinct_on?: InputMaybe<Array<MakeModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MakeModel_Order_By_Nhtsa>>;
  where?: InputMaybe<MakeModel_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaModelYearModelAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelYearModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelYearModel_Order_By_Nhtsa>>;
  where?: InputMaybe<ModelYearModel_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaModelYearModelsArgs = {
  distinct_on?: InputMaybe<Array<ModelYearModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelYearModel_Order_By_Nhtsa>>;
  where?: InputMaybe<ModelYearModel_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaRecordTypeArgs = {
  name: Scalars['String'];
};


export type Query_RootSelectNhtsaRecordTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<RecordType_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RecordType_Order_By_Nhtsa>>;
  where?: InputMaybe<RecordType_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectNhtsaRecordTypesArgs = {
  distinct_on?: InputMaybe<Array<RecordType_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RecordType_Order_By_Nhtsa>>;
  where?: InputMaybe<RecordType_Bool_Exp_Nhtsa>;
};


export type Query_RootSelectObligorArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectObligorsArgs = {
  distinct_on?: InputMaybe<Array<Obligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Obligor_Order_By>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};


export type Query_RootSelectObligorsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Obligor_Order_By>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};


export type Query_RootSelectObsoleteJobArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectObsoleteJobAggregateArgs = {
  distinct_on?: InputMaybe<Array<ObsoleteJob_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObsoleteJob_Order_By>>;
  where?: InputMaybe<ObsoleteJob_Bool_Exp>;
};


export type Query_RootSelectObsoleteJobsArgs = {
  distinct_on?: InputMaybe<Array<ObsoleteJob_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObsoleteJob_Order_By>>;
  where?: InputMaybe<ObsoleteJob_Bool_Exp>;
};


export type Query_RootSelectOutboxEventArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectOutboxEventAggregateArgs = {
  distinct_on?: InputMaybe<Array<OutboxEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OutboxEvent_Order_By>>;
  where?: InputMaybe<OutboxEvent_Bool_Exp>;
};


export type Query_RootSelectOutboxEventsArgs = {
  distinct_on?: InputMaybe<Array<OutboxEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OutboxEvent_Order_By>>;
  where?: InputMaybe<OutboxEvent_Bool_Exp>;
};


export type Query_RootSelectParticipantArgs = {
  identityId: Scalars['uuid'];
  parentId: Scalars['uuid'];
};


export type Query_RootSelectParticipantAggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Query_RootSelectParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Query_RootSelectPayeeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPayeeAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPayeeAs400AggregateArgs = {
  distinct_on?: InputMaybe<Array<PayeeAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PayeeAs400_Order_By>>;
  where?: InputMaybe<PayeeAs400_Bool_Exp>;
};


export type Query_RootSelectPayeeAs400sArgs = {
  distinct_on?: InputMaybe<Array<PayeeAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PayeeAs400_Order_By>>;
  where?: InputMaybe<PayeeAs400_Bool_Exp>;
};


export type Query_RootSelectPayeeLinkViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<PayeeLinkView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PayeeLinkView_Order_By>>;
  where?: InputMaybe<PayeeLinkView_Bool_Exp>;
};


export type Query_RootSelectPayeeLinkViewsArgs = {
  distinct_on?: InputMaybe<Array<PayeeLinkView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PayeeLinkView_Order_By>>;
  where?: InputMaybe<PayeeLinkView_Bool_Exp>;
};


export type Query_RootSelectPayeesArgs = {
  distinct_on?: InputMaybe<Array<Payee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payee_Order_By>>;
  where?: InputMaybe<Payee_Bool_Exp>;
};


export type Query_RootSelectPayeesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Payee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payee_Order_By>>;
  where?: InputMaybe<Payee_Bool_Exp>;
};


export type Query_RootSelectPaymentArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPaymentAggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Query_RootSelectPaymentAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPaymentAs400sArgs = {
  distinct_on?: InputMaybe<Array<PaymentAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentAs400_Order_By>>;
  where?: InputMaybe<PaymentAs400_Bool_Exp>;
};


export type Query_RootSelectPaymentDetailArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPaymentDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentDetail_Order_By>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};


export type Query_RootSelectPaymentDetailsArgs = {
  distinct_on?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentDetail_Order_By>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};


export type Query_RootSelectPaymentMethodTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPaymentMethodTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentMethodType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentMethodType_Order_By>>;
  where?: InputMaybe<PaymentMethodType_Bool_Exp>;
};


export type Query_RootSelectPaymentMethodTypesArgs = {
  distinct_on?: InputMaybe<Array<PaymentMethodType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentMethodType_Order_By>>;
  where?: InputMaybe<PaymentMethodType_Bool_Exp>;
};


export type Query_RootSelectPaymentStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPaymentStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentStatusType_Order_By>>;
  where?: InputMaybe<PaymentStatusType_Bool_Exp>;
};


export type Query_RootSelectPaymentStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<PaymentStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentStatusType_Order_By>>;
  where?: InputMaybe<PaymentStatusType_Bool_Exp>;
};


export type Query_RootSelectPaymentTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPaymentTypesArgs = {
  distinct_on?: InputMaybe<Array<PaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentType_Order_By>>;
  where?: InputMaybe<PaymentType_Bool_Exp>;
};


export type Query_RootSelectPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Query_RootSelectPlanArgs = {
  PlanID: Scalars['Int'];
};


export type Query_RootSelectPlanAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Query_RootSelectPlansArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Query_RootSelectPoliciesArgs = {
  distinct_on?: InputMaybe<Array<Policy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policy_Order_By>>;
  where?: InputMaybe<Policy_Bool_Exp>;
};


export type Query_RootSelectPoliciesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Policy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policy_Order_By>>;
  where?: InputMaybe<Policy_Bool_Exp>;
};


export type Query_RootSelectPolicyArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyClaimArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyClaimAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaim_Order_By>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


export type Query_RootSelectPolicyClaimAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyClaimAs400sArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimAs400_Order_By>>;
  where?: InputMaybe<PolicyClaimAs400_Bool_Exp>;
};


export type Query_RootSelectPolicyClaimConcernArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyClaimConcernAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimConcern_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimConcern_Order_By>>;
  where?: InputMaybe<PolicyClaimConcern_Bool_Exp>;
};


export type Query_RootSelectPolicyClaimConcernsArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimConcern_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimConcern_Order_By>>;
  where?: InputMaybe<PolicyClaimConcern_Bool_Exp>;
};


export type Query_RootSelectPolicyClaimInsuranceArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyClaimInsurancesArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimInsurance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimInsurance_Order_By>>;
  where?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
};


export type Query_RootSelectPolicyClaimsArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaim_Order_By>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


export type Query_RootSelectPolicyContractArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractAssetArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractAssetTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractAssetTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractAssetType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractAssetType_Order_By>>;
  where?: InputMaybe<PolicyContractAssetType_Bool_Exp>;
};


export type Query_RootSelectPolicyContractAssetTypesArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractAssetType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractAssetType_Order_By>>;
  where?: InputMaybe<PolicyContractAssetType_Bool_Exp>;
};


export type Query_RootSelectPolicyContractAssetsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractAsset_Order_By>>;
  where?: InputMaybe<PolicyContractAsset_Bool_Exp>;
};


export type Query_RootSelectPolicyContractAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractAsset_Order_By>>;
  where?: InputMaybe<PolicyContractAsset_Bool_Exp>;
};


export type Query_RootSelectPolicyContractContractFormVersionArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractContractFormVersionAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractContractFormVersion_Order_By>>;
  where?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
};


export type Query_RootSelectPolicyContractContractFormVersionsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractContractFormVersion_Order_By>>;
  where?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
};


export type Query_RootSelectPolicyContractCostDetailArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractCostDetailsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractCostDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractCostDetail_Order_By>>;
  where?: InputMaybe<PolicyContractCostDetail_Bool_Exp>;
};


export type Query_RootSelectPolicyContractCostDetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractCostDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractCostDetail_Order_By>>;
  where?: InputMaybe<PolicyContractCostDetail_Bool_Exp>;
};


export type Query_RootSelectPolicyContractLenderArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractLendersArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLender_Order_By>>;
  where?: InputMaybe<PolicyContractLender_Bool_Exp>;
};


export type Query_RootSelectPolicyContractLendersAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLender_Order_By>>;
  where?: InputMaybe<PolicyContractLender_Bool_Exp>;
};


export type Query_RootSelectPolicyContractListViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractListView_Order_By>>;
  where?: InputMaybe<PolicyContractListView_Bool_Exp>;
};


export type Query_RootSelectPolicyContractListViewsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractListView_Order_By>>;
  where?: InputMaybe<PolicyContractListView_Bool_Exp>;
};


export type Query_RootSelectPolicyContractLoanContractTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractLoanContractTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLoanContractType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLoanContractType_Order_By>>;
  where?: InputMaybe<PolicyContractLoanContractType_Bool_Exp>;
};


export type Query_RootSelectPolicyContractLoanContractTypesArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLoanContractType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLoanContractType_Order_By>>;
  where?: InputMaybe<PolicyContractLoanContractType_Bool_Exp>;
};


export type Query_RootSelectPolicyContractOwnerArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractOwnersArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractOwner_Order_By>>;
  where?: InputMaybe<PolicyContractOwner_Bool_Exp>;
};


export type Query_RootSelectPolicyContractOwnersAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractOwner_Order_By>>;
  where?: InputMaybe<PolicyContractOwner_Bool_Exp>;
};


export type Query_RootSelectPolicyContractProductArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProduct_Order_By>>;
  where?: InputMaybe<PolicyContractProduct_Bool_Exp>;
};


export type Query_RootSelectPolicyContractProductCostDetailArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractProductCostDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductCostDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductCostDetail_Order_By>>;
  where?: InputMaybe<PolicyContractProductCostDetail_Bool_Exp>;
};


export type Query_RootSelectPolicyContractProductCostDetailsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductCostDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductCostDetail_Order_By>>;
  where?: InputMaybe<PolicyContractProductCostDetail_Bool_Exp>;
};


export type Query_RootSelectPolicyContractProductOptionsMetadataViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Order_By>>;
  where?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
};


export type Query_RootSelectPolicyContractProductOptionsMetadataViewsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Order_By>>;
  where?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
};


export type Query_RootSelectPolicyContractProductsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProduct_Order_By>>;
  where?: InputMaybe<PolicyContractProduct_Bool_Exp>;
};


export type Query_RootSelectPolicyContractQuoteArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractQuoteAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractQuote_Order_By>>;
  where?: InputMaybe<PolicyContractQuote_Bool_Exp>;
};


export type Query_RootSelectPolicyContractQuotesArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractQuote_Order_By>>;
  where?: InputMaybe<PolicyContractQuote_Bool_Exp>;
};


export type Query_RootSelectPolicyContractStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractStatusType_Order_By>>;
  where?: InputMaybe<PolicyContractStatusType_Bool_Exp>;
};


export type Query_RootSelectPolicyContractStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractStatusType_Order_By>>;
  where?: InputMaybe<PolicyContractStatusType_Bool_Exp>;
};


export type Query_RootSelectPolicyContractVoidReasonTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPolicyContractVoidReasonTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractVoidReasonType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractVoidReasonType_Order_By>>;
  where?: InputMaybe<PolicyContractVoidReasonType_Bool_Exp>;
};


export type Query_RootSelectPolicyContractVoidReasonTypesArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractVoidReasonType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractVoidReasonType_Order_By>>;
  where?: InputMaybe<PolicyContractVoidReasonType_Bool_Exp>;
};


export type Query_RootSelectPolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


export type Query_RootSelectPolicyContractsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


export type Query_RootSelectPreAuthorizationArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPreAuthorizationStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPreAuthorizationStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorizationStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorizationStatusType_Order_By>>;
  where?: InputMaybe<PreAuthorizationStatusType_Bool_Exp>;
};


export type Query_RootSelectPreAuthorizationStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorizationStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorizationStatusType_Order_By>>;
  where?: InputMaybe<PreAuthorizationStatusType_Bool_Exp>;
};


export type Query_RootSelectPreAuthorizationTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectPreAuthorizationTypesArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorizationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorizationType_Order_By>>;
  where?: InputMaybe<PreAuthorizationType_Bool_Exp>;
};


export type Query_RootSelectPreAuthorizationTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorizationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorizationType_Order_By>>;
  where?: InputMaybe<PreAuthorizationType_Bool_Exp>;
};


export type Query_RootSelectPreAuthorizationsArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorization_Order_By>>;
  where?: InputMaybe<PreAuthorization_Bool_Exp>;
};


export type Query_RootSelectPreAuthorizationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorization_Order_By>>;
  where?: InputMaybe<PreAuthorization_Bool_Exp>;
};


export type Query_RootSelectProductArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProductAttributeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProductAttributeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttribute_Order_By>>;
  where?: InputMaybe<ProductAttribute_Bool_Exp>;
};


export type Query_RootSelectProductAttributeTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectProductAttributeTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttributeType_Order_By>>;
  where?: InputMaybe<ProductAttributeType_Bool_Exp>;
};


export type Query_RootSelectProductAttributeTypesArgs = {
  distinct_on?: InputMaybe<Array<ProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttributeType_Order_By>>;
  where?: InputMaybe<ProductAttributeType_Bool_Exp>;
};


export type Query_RootSelectProductAttributesArgs = {
  distinct_on?: InputMaybe<Array<ProductAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttribute_Order_By>>;
  where?: InputMaybe<ProductAttribute_Bool_Exp>;
};


export type Query_RootSelectProductClassGuideArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProductClassGuideAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductClassGuide_Order_By>>;
  where?: InputMaybe<ProductClassGuide_Bool_Exp>;
};


export type Query_RootSelectProductClassGuidesArgs = {
  distinct_on?: InputMaybe<Array<ProductClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductClassGuide_Order_By>>;
  where?: InputMaybe<ProductClassGuide_Bool_Exp>;
};


export type Query_RootSelectProductContractFormArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProductContractFormAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductContractForm_Order_By>>;
  where?: InputMaybe<ProductContractForm_Bool_Exp>;
};


export type Query_RootSelectProductContractFormsArgs = {
  distinct_on?: InputMaybe<Array<ProductContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductContractForm_Order_By>>;
  where?: InputMaybe<ProductContractForm_Bool_Exp>;
};


export type Query_RootSelectProductCostArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProductCostAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductCost_Order_By>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};


export type Query_RootSelectProductCostsArgs = {
  distinct_on?: InputMaybe<Array<ProductCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductCost_Order_By>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};


export type Query_RootSelectProductDisbursementArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProductDisbursementAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductDisbursement_Order_By>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};


export type Query_RootSelectProductDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductDisbursement_Order_By>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};


export type Query_RootSelectProductEligibilitiesArgs = {
  distinct_on?: InputMaybe<Array<ProductEligibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductEligibility_Order_By>>;
  where?: InputMaybe<ProductEligibility_Bool_Exp>;
};


export type Query_RootSelectProductEligibilityArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProductEligibilityAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductEligibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductEligibility_Order_By>>;
  where?: InputMaybe<ProductEligibility_Bool_Exp>;
};


export type Query_RootSelectProductObligorArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProductObligorsArgs = {
  distinct_on?: InputMaybe<Array<ProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductObligor_Order_By>>;
  where?: InputMaybe<ProductObligor_Bool_Exp>;
};


export type Query_RootSelectProductObligorsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductObligor_Order_By>>;
  where?: InputMaybe<ProductObligor_Bool_Exp>;
};


export type Query_RootSelectProductRateBucketArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProductRateBucketAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductRateBucket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductRateBucket_Order_By>>;
  where?: InputMaybe<ProductRateBucket_Bool_Exp>;
};


export type Query_RootSelectProductRateBucketsArgs = {
  distinct_on?: InputMaybe<Array<ProductRateBucket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductRateBucket_Order_By>>;
  where?: InputMaybe<ProductRateBucket_Bool_Exp>;
};


export type Query_RootSelectProductSurchargeTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProductSurchargeTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductSurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductSurchargeType_Order_By>>;
  where?: InputMaybe<ProductSurchargeType_Bool_Exp>;
};


export type Query_RootSelectProductSurchargeTypesArgs = {
  distinct_on?: InputMaybe<Array<ProductSurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductSurchargeType_Order_By>>;
  where?: InputMaybe<ProductSurchargeType_Bool_Exp>;
};


export type Query_RootSelectProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootSelectProductsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootSelectProfileArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectProfileAggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Query_RootSelectProfilesArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Query_RootSelectQuoteArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectQuoteAggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Query_RootSelectQuoteMinimalViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<QuoteMinimalView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuoteMinimalView_Order_By>>;
  where?: InputMaybe<QuoteMinimalView_Bool_Exp>;
};


export type Query_RootSelectQuoteMinimalViewsArgs = {
  distinct_on?: InputMaybe<Array<QuoteMinimalView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuoteMinimalView_Order_By>>;
  where?: InputMaybe<QuoteMinimalView_Bool_Exp>;
};


export type Query_RootSelectQuoteTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectQuoteTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<QuoteType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuoteType_Order_By>>;
  where?: InputMaybe<QuoteType_Bool_Exp>;
};


export type Query_RootSelectQuoteTypesArgs = {
  distinct_on?: InputMaybe<Array<QuoteType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuoteType_Order_By>>;
  where?: InputMaybe<QuoteType_Bool_Exp>;
};


export type Query_RootSelectQuotesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Query_RootSelectRateBucketTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectRateBucketTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<RateBucketType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RateBucketType_Order_By>>;
  where?: InputMaybe<RateBucketType_Bool_Exp>;
};


export type Query_RootSelectRateBucketTypesArgs = {
  distinct_on?: InputMaybe<Array<RateBucketType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RateBucketType_Order_By>>;
  where?: InputMaybe<RateBucketType_Bool_Exp>;
};


export type Query_RootSelectRateQuoteArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRateQuotesArgs = {
  distinct_on?: InputMaybe<Array<RateQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RateQuote_Order_By>>;
  where?: InputMaybe<RateQuote_Bool_Exp>;
};


export type Query_RootSelectRateQuotesAggregateArgs = {
  distinct_on?: InputMaybe<Array<RateQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RateQuote_Order_By>>;
  where?: InputMaybe<RateQuote_Bool_Exp>;
};


export type Query_RootSelectRaterViewConfigArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRaterViewConfigsArgs = {
  distinct_on?: InputMaybe<Array<RaterViewConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RaterViewConfig_Order_By>>;
  where?: InputMaybe<RaterViewConfig_Bool_Exp>;
};


export type Query_RootSelectReferenceLogArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectReferenceLogAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReferenceLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReferenceLog_Order_By>>;
  where?: InputMaybe<ReferenceLog_Bool_Exp>;
};


export type Query_RootSelectReferenceLogsArgs = {
  distinct_on?: InputMaybe<Array<ReferenceLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReferenceLog_Order_By>>;
  where?: InputMaybe<ReferenceLog_Bool_Exp>;
};


export type Query_RootSelectRemittanceArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRemittanceAggregateArgs = {
  distinct_on?: InputMaybe<Array<Remittance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Remittance_Order_By>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};


export type Query_RootSelectRemittanceClaimDetailArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRemittanceClaimDetailsArgs = {
  distinct_on?: InputMaybe<Array<RemittanceClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceClaimDetail_Order_By>>;
  where?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
};


export type Query_RootSelectRemittancePaymentArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRemittancePaymentAggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePayment_Order_By>>;
  where?: InputMaybe<RemittancePayment_Bool_Exp>;
};


export type Query_RootSelectRemittancePaymentsArgs = {
  distinct_on?: InputMaybe<Array<RemittancePayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePayment_Order_By>>;
  where?: InputMaybe<RemittancePayment_Bool_Exp>;
};


export type Query_RootSelectRemittancePolicyContractArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRemittancePolicyContractAggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContract_Order_By>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};


export type Query_RootSelectRemittancePolicyContractAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRemittancePolicyContractAs400AggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContractAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContractAs400_Order_By>>;
  where?: InputMaybe<RemittancePolicyContractAs400_Bool_Exp>;
};


export type Query_RootSelectRemittancePolicyContractAs400sArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContractAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContractAs400_Order_By>>;
  where?: InputMaybe<RemittancePolicyContractAs400_Bool_Exp>;
};


export type Query_RootSelectRemittancePolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContract_Order_By>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};


export type Query_RootSelectRemittanceStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRemittanceStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittanceStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceStatusType_Order_By>>;
  where?: InputMaybe<RemittanceStatusType_Bool_Exp>;
};


export type Query_RootSelectRemittanceStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<RemittanceStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceStatusType_Order_By>>;
  where?: InputMaybe<RemittanceStatusType_Bool_Exp>;
};


export type Query_RootSelectRemittanceTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRemittanceTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittanceType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceType_Order_By>>;
  where?: InputMaybe<RemittanceType_Bool_Exp>;
};


export type Query_RootSelectRemittanceTypesArgs = {
  distinct_on?: InputMaybe<Array<RemittanceType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceType_Order_By>>;
  where?: InputMaybe<RemittanceType_Bool_Exp>;
};


export type Query_RootSelectRemittancesArgs = {
  distinct_on?: InputMaybe<Array<Remittance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Remittance_Order_By>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};


export type Query_RootSelectRepeatPartAcknowledgmentArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRepeatPartAcknowledgmentAggregateArgs = {
  distinct_on?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatPartAcknowledgment_Order_By>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};


export type Query_RootSelectRepeatPartAcknowledgmentsArgs = {
  distinct_on?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatPartAcknowledgment_Order_By>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};


export type Query_RootSelectRoleArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRoleAggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootSelectRoleAttributeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRoleAttributeAggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleAttribute_Order_By>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};


export type Query_RootSelectRoleAttributesArgs = {
  distinct_on?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleAttribute_Order_By>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};


export type Query_RootSelectRoleHierarchyViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleHierarchyView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleHierarchyView_Order_By>>;
  where?: InputMaybe<RoleHierarchyView_Bool_Exp>;
};


export type Query_RootSelectRoleHierarchyViewsArgs = {
  distinct_on?: InputMaybe<Array<RoleHierarchyView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleHierarchyView_Order_By>>;
  where?: InputMaybe<RoleHierarchyView_Bool_Exp>;
};


export type Query_RootSelectRolesArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootSelectRouteArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRouteAggregateArgs = {
  distinct_on?: InputMaybe<Array<Route_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Route_Order_By>>;
  where?: InputMaybe<Route_Bool_Exp>;
};


export type Query_RootSelectRouteConfigArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectRouteConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<RouteConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RouteConfig_Order_By>>;
  where?: InputMaybe<RouteConfig_Bool_Exp>;
};


export type Query_RootSelectRouteConfigsArgs = {
  distinct_on?: InputMaybe<Array<RouteConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RouteConfig_Order_By>>;
  where?: InputMaybe<RouteConfig_Bool_Exp>;
};


export type Query_RootSelectRoutesArgs = {
  distinct_on?: InputMaybe<Array<Route_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Route_Order_By>>;
  where?: InputMaybe<Route_Bool_Exp>;
};


export type Query_RootSelectSearchIndexArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectSearchIndexAggregateArgs = {
  distinct_on?: InputMaybe<Array<SearchIndex_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SearchIndex_Order_By>>;
  where?: InputMaybe<SearchIndex_Bool_Exp>;
};


export type Query_RootSelectSearchIndexesArgs = {
  distinct_on?: InputMaybe<Array<SearchIndex_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SearchIndex_Order_By>>;
  where?: InputMaybe<SearchIndex_Bool_Exp>;
};


export type Query_RootSelectServiceCenterArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectServiceCenterAggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


export type Query_RootSelectServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


export type Query_RootSelectSeverityLevelTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectSeverityLevelTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<SeverityLevelType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SeverityLevelType_Order_By>>;
  where?: InputMaybe<SeverityLevelType_Bool_Exp>;
};


export type Query_RootSelectSeverityLevelTypesArgs = {
  distinct_on?: InputMaybe<Array<SeverityLevelType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SeverityLevelType_Order_By>>;
  where?: InputMaybe<SeverityLevelType_Bool_Exp>;
};


export type Query_RootSelectShortcutBindingArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectShortcutBindingAggregateArgs = {
  distinct_on?: InputMaybe<Array<ShortcutBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShortcutBinding_Order_By>>;
  where?: InputMaybe<ShortcutBinding_Bool_Exp>;
};


export type Query_RootSelectShortcutBindingsArgs = {
  distinct_on?: InputMaybe<Array<ShortcutBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShortcutBinding_Order_By>>;
  where?: InputMaybe<ShortcutBinding_Bool_Exp>;
};


export type Query_RootSelectStateArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectStatesArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Query_RootSelectStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Query_RootSelectStepArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectStepAggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Step_Order_By>>;
  where?: InputMaybe<Step_Bool_Exp>;
};


export type Query_RootSelectStepListViewsArgs = {
  distinct_on?: InputMaybe<Array<StepListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StepListView_Order_By>>;
  where?: InputMaybe<StepListView_Bool_Exp>;
};


export type Query_RootSelectStepTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectStepTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<StepType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StepType_Order_By>>;
  where?: InputMaybe<StepType_Bool_Exp>;
};


export type Query_RootSelectStepTypesArgs = {
  distinct_on?: InputMaybe<Array<StepType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StepType_Order_By>>;
  where?: InputMaybe<StepType_Bool_Exp>;
};


export type Query_RootSelectStepsArgs = {
  distinct_on?: InputMaybe<Array<Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Step_Order_By>>;
  where?: InputMaybe<Step_Bool_Exp>;
};


export type Query_RootSelectSurchargeTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectSurchargeTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<SurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SurchargeType_Order_By>>;
  where?: InputMaybe<SurchargeType_Bool_Exp>;
};


export type Query_RootSelectSurchargeTypesArgs = {
  distinct_on?: InputMaybe<Array<SurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SurchargeType_Order_By>>;
  where?: InputMaybe<SurchargeType_Bool_Exp>;
};


export type Query_RootSelectTagArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectTagAggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Query_RootSelectTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Query_RootSelectTaskArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectTaskAggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Query_RootSelectTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Query_RootSelectTaxRateArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectTaxRateAs400Args = {
  id: Scalars['uuid'];
};


export type Query_RootSelectTaxRateAs400sArgs = {
  distinct_on?: InputMaybe<Array<TaxRateAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxRateAs400_Order_By>>;
  where?: InputMaybe<TaxRateAs400_Bool_Exp>;
};


export type Query_RootSelectTaxRatesArgs = {
  distinct_on?: InputMaybe<Array<TaxRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxRate_Order_By>>;
  where?: InputMaybe<TaxRate_Bool_Exp>;
};


export type Query_RootSelectTechnologyTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectTechnologyTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TechnologyType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TechnologyType_Order_By>>;
  where?: InputMaybe<TechnologyType_Bool_Exp>;
};


export type Query_RootSelectTechnologyTypesArgs = {
  distinct_on?: InputMaybe<Array<TechnologyType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TechnologyType_Order_By>>;
  where?: InputMaybe<TechnologyType_Bool_Exp>;
};


export type Query_RootSelectTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Type_Order_By>>;
  where?: InputMaybe<Type_Bool_Exp>;
};


export type Query_RootSelectTypeGroupArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectTypeGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TypeGroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TypeGroup_Order_By>>;
  where?: InputMaybe<TypeGroup_Bool_Exp>;
};


export type Query_RootSelectTypeGroupsArgs = {
  distinct_on?: InputMaybe<Array<TypeGroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TypeGroup_Order_By>>;
  where?: InputMaybe<TypeGroup_Bool_Exp>;
};


export type Query_RootSelectTypesArgs = {
  distinct_on?: InputMaybe<Array<Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Type_Order_By>>;
  where?: InputMaybe<Type_Bool_Exp>;
};


export type Query_RootSelectUserArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootSelectUserFlowItemArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectUserFlowItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItem_Order_By>>;
  where?: InputMaybe<UserFlowItem_Bool_Exp>;
};


export type Query_RootSelectUserFlowItemMfaArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectUserFlowItemMfaAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItemMfa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItemMfa_Order_By>>;
  where?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
};


export type Query_RootSelectUserFlowItemMfasArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItemMfa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItemMfa_Order_By>>;
  where?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
};


export type Query_RootSelectUserFlowItemsArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItem_Order_By>>;
  where?: InputMaybe<UserFlowItem_Bool_Exp>;
};


export type Query_RootSelectUserGroupArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectUserGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroup_Order_By>>;
  where?: InputMaybe<UserGroup_Bool_Exp>;
};


export type Query_RootSelectUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<UserGroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroup_Order_By>>;
  where?: InputMaybe<UserGroup_Bool_Exp>;
};


export type Query_RootSelectUserPinArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectUserPinsArgs = {
  distinct_on?: InputMaybe<Array<UserPin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPin_Order_By>>;
  where?: InputMaybe<UserPin_Bool_Exp>;
};


export type Query_RootSelectUserPinsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPin_Order_By>>;
  where?: InputMaybe<UserPin_Bool_Exp>;
};


export type Query_RootSelectUserProfileArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectUserProfileAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserProfile_Order_By>>;
  where?: InputMaybe<UserProfile_Bool_Exp>;
};


export type Query_RootSelectUserProfilesArgs = {
  distinct_on?: InputMaybe<Array<UserProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserProfile_Order_By>>;
  where?: InputMaybe<UserProfile_Bool_Exp>;
};


export type Query_RootSelectUserSessionArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectUserSessionAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserSession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserSession_Order_By>>;
  where?: InputMaybe<UserSession_Bool_Exp>;
};


export type Query_RootSelectUserSessionsArgs = {
  distinct_on?: InputMaybe<Array<UserSession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserSession_Order_By>>;
  where?: InputMaybe<UserSession_Bool_Exp>;
};


export type Query_RootSelectUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootSelectValidationArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectValidationAggregateArgs = {
  distinct_on?: InputMaybe<Array<Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Validation_Order_By>>;
  where?: InputMaybe<Validation_Bool_Exp>;
};


export type Query_RootSelectValidationLifecycleHookArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectValidationLifecycleHookAggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationLifecycleHook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationLifecycleHook_Order_By>>;
  where?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
};


export type Query_RootSelectValidationLifecycleHooksArgs = {
  distinct_on?: InputMaybe<Array<ValidationLifecycleHook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationLifecycleHook_Order_By>>;
  where?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
};


export type Query_RootSelectValidationOverrideArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectValidationOverrideAggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationOverride_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationOverride_Order_By>>;
  where?: InputMaybe<ValidationOverride_Bool_Exp>;
};


export type Query_RootSelectValidationOverridesArgs = {
  distinct_on?: InputMaybe<Array<ValidationOverride_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationOverride_Order_By>>;
  where?: InputMaybe<ValidationOverride_Bool_Exp>;
};


export type Query_RootSelectValidationRuleForArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectValidationRuleForAggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationRuleFor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationRuleFor_Order_By>>;
  where?: InputMaybe<ValidationRuleFor_Bool_Exp>;
};


export type Query_RootSelectValidationRuleForsArgs = {
  distinct_on?: InputMaybe<Array<ValidationRuleFor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationRuleFor_Order_By>>;
  where?: InputMaybe<ValidationRuleFor_Bool_Exp>;
};


export type Query_RootSelectValidationTypeOperationArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectValidationTypeOperationAggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationTypeOperation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationTypeOperation_Order_By>>;
  where?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
};


export type Query_RootSelectValidationTypeOperationsArgs = {
  distinct_on?: InputMaybe<Array<ValidationTypeOperation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationTypeOperation_Order_By>>;
  where?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
};


export type Query_RootSelectValidationWhenArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectValidationWhenAggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationWhen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationWhen_Order_By>>;
  where?: InputMaybe<ValidationWhen_Bool_Exp>;
};


export type Query_RootSelectValidationWhensArgs = {
  distinct_on?: InputMaybe<Array<ValidationWhen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationWhen_Order_By>>;
  where?: InputMaybe<ValidationWhen_Bool_Exp>;
};


export type Query_RootSelectValidationsArgs = {
  distinct_on?: InputMaybe<Array<Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Validation_Order_By>>;
  where?: InputMaybe<Validation_Bool_Exp>;
};


export type Query_RootSelectVehicleArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectVehicleAggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


export type Query_RootSelectVehicleAttributesDefinedViewArgs = {
  distinct_on?: InputMaybe<Array<VehicleAttributesDefinedView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleAttributesDefinedView_Order_By>>;
  where?: InputMaybe<VehicleAttributesDefinedView_Bool_Exp>;
};


export type Query_RootSelectVehicleAttributesDefinedViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleAttributesDefinedView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleAttributesDefinedView_Order_By>>;
  where?: InputMaybe<VehicleAttributesDefinedView_Bool_Exp>;
};


export type Query_RootSelectVehicleClassingBodyStyleAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingBodyStyle_Order_By>>;
  where?: InputMaybe<VehicleClassingBodyStyle_Bool_Exp>;
};


export type Query_RootSelectVehicleClassingBodyStylesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingBodyStyle_Order_By>>;
  where?: InputMaybe<VehicleClassingBodyStyle_Bool_Exp>;
};


export type Query_RootSelectVehicleClassingFuelTypeAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingFuelType_Order_By>>;
  where?: InputMaybe<VehicleClassingFuelType_Bool_Exp>;
};


export type Query_RootSelectVehicleClassingFuelTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingFuelType_Order_By>>;
  where?: InputMaybe<VehicleClassingFuelType_Bool_Exp>;
};


export type Query_RootSelectVehicleClassingVehicleMakeAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingVehicleMake_Order_By>>;
  where?: InputMaybe<VehicleClassingVehicleMake_Bool_Exp>;
};


export type Query_RootSelectVehicleClassingVehicleMakesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingVehicleMake_Order_By>>;
  where?: InputMaybe<VehicleClassingVehicleMake_Bool_Exp>;
};


export type Query_RootSelectVehicleClassingVehicleTypeAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingVehicleType_Order_By>>;
  where?: InputMaybe<VehicleClassingVehicleType_Bool_Exp>;
};


export type Query_RootSelectVehicleClassingVehicleTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingVehicleType_Order_By>>;
  where?: InputMaybe<VehicleClassingVehicleType_Bool_Exp>;
};


export type Query_RootSelectVehicleStatusTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectVehicleStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleStatusType_Order_By>>;
  where?: InputMaybe<VehicleStatusType_Bool_Exp>;
};


export type Query_RootSelectVehicleStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<VehicleStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleStatusType_Order_By>>;
  where?: InputMaybe<VehicleStatusType_Bool_Exp>;
};


export type Query_RootSelectVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


export type Query_RootSelectVpicDecodeAlternativeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectVpicDecodeAlternativeAggregateArgs = {
  distinct_on?: InputMaybe<Array<VpicDecodeAlternative_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VpicDecodeAlternative_Order_By>>;
  where?: InputMaybe<VpicDecodeAlternative_Bool_Exp>;
};


export type Query_RootSelectVpicDecodeAlternativesArgs = {
  distinct_on?: InputMaybe<Array<VpicDecodeAlternative_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VpicDecodeAlternative_Order_By>>;
  where?: InputMaybe<VpicDecodeAlternative_Bool_Exp>;
};


export type Query_RootSelectWorkStatusTypeArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelectWorkStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<WorkStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkStatusType_Order_By>>;
  where?: InputMaybe<WorkStatusType_Bool_Exp>;
};


export type Query_RootSelectWorkStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<WorkStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkStatusType_Order_By>>;
  where?: InputMaybe<WorkStatusType_Bool_Exp>;
};


export type Query_RootSelectWorkflowStateTypeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSelectWorkflowStateTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<WorkflowStateType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkflowStateType_Order_By>>;
  where?: InputMaybe<WorkflowStateType_Bool_Exp>;
};


export type Query_RootSelectWorkflowStateTypesArgs = {
  distinct_on?: InputMaybe<Array<WorkflowStateType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkflowStateType_Order_By>>;
  where?: InputMaybe<WorkflowStateType_Bool_Exp>;
};


export type Query_RootSelectselectFilingLenderAggregateArgs = {
  distinct_on?: InputMaybe<Array<FilingLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingLender_Order_By>>;
  where?: InputMaybe<FilingLender_Bool_Exp>;
};


export type Query_RootShared_Search_ResultArgs = {
  distinct_on?: InputMaybe<Array<Shared_Search_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Search_Result_Order_By>>;
  where?: InputMaybe<Shared_Search_Result_Bool_Exp>;
};


export type Query_RootShared_Search_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shared_Search_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Search_Result_Order_By>>;
  where?: InputMaybe<Shared_Search_Result_Bool_Exp>;
};


export type Query_RootVNcsaBodyTypeArgs = {
  distinct_on?: InputMaybe<Array<VNcsaBodyType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaBodyType_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaBodyType_Bool_Exp_Vpic>;
};


export type Query_RootVNcsaBodyType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VNcsaBodyType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaBodyType_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaBodyType_Bool_Exp_Vpic>;
};


export type Query_RootVNcsaMakeArgs = {
  distinct_on?: InputMaybe<Array<VNcsaMake_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaMake_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaMake_Bool_Exp_Vpic>;
};


export type Query_RootVNcsaMake_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VNcsaMake_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaMake_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaMake_Bool_Exp_Vpic>;
};


export type Query_RootVNcsaModelArgs = {
  distinct_on?: InputMaybe<Array<VNcsaModel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaModel_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaModel_Bool_Exp_Vpic>;
};


export type Query_RootVNcsaModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VNcsaModel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaModel_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaModel_Bool_Exp_Vpic>;
};


export type Query_RootViewerShortcutBindingsArgs = {
  distinct_on?: InputMaybe<Array<ShortcutBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShortcutBinding_Order_By>>;
  where?: InputMaybe<ShortcutBinding_Bool_Exp>;
};


export type Query_RootViewerShortcutBindings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShortcutBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShortcutBinding_Order_By>>;
  where?: InputMaybe<ShortcutBinding_Bool_Exp>;
};


export type Query_RootVinDecoderActionArgs = {
  object: VinDecoderActionInput;
};


export type Query_RootVwVehicleCylindersDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleCylindersDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleCylindersDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleCylindersDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleCylindersDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleCylindersDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleDrivingWheelsDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleDrivingWheelsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleDrivingWheelsDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleDrivingWheelsDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleDrivingWheelsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleDrivingWheelsDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleFuelTypesDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleFuelTypesDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleFuelTypesDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleFuelTypesDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleFuelTypesDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleFuelTypesDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleMakesDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleMakesDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleMakesDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleMakesDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleMakesDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleMakesDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleModelsDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleModelsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleModelsDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleModelsDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleModelsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleModelsDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleYearsDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleYearsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleYearsDistinct_Bool_Exp>;
};


export type Query_RootVwVehicleYearsDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleYearsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleYearsDistinct_Bool_Exp>;
};

/** columns and relationships of "quotes.quote" */
export type Quote = {
  __typename?: 'quote';
  createdAt: Scalars['timestamptz'];
  editMetadata?: Maybe<Scalars['jsonb']>;
  expirationDate: Scalars['date'];
  id: Scalars['uuid'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  quoteType?: Maybe<QuoteType>;
  quoteTypeId: Scalars['uuid'];
  resultMetadata?: Maybe<Scalars['jsonb']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "quotes.quote" */
export type QuoteEditMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "quotes.quote" */
export type QuoteMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "quotes.quote" */
export type QuoteResultMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "quotes.quote_minimal_view" */
export type QuoteMinimalView = {
  __typename?: 'quoteMinimalView';
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylindersNumber?: Maybe<Scalars['String']>;
  dealerCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fuelTypeDescription?: Maybe<Scalars['String']>;
  hasBeenPurchased?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['String']>;
  selectedPlans?: Maybe<Scalars['jsonb']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleYear?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};


/** columns and relationships of "quotes.quote_minimal_view" */
export type QuoteMinimalViewSelectedPlansArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "quotes.quote_minimal_view" */
export type QuoteMinimalView_Aggregate = {
  __typename?: 'quoteMinimalView_aggregate';
  aggregate?: Maybe<QuoteMinimalView_Aggregate_Fields>;
  nodes: Array<QuoteMinimalView>;
};

/** aggregate fields of "quotes.quote_minimal_view" */
export type QuoteMinimalView_Aggregate_Fields = {
  __typename?: 'quoteMinimalView_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<QuoteMinimalView_Max_Fields>;
  min?: Maybe<QuoteMinimalView_Min_Fields>;
};


/** aggregate fields of "quotes.quote_minimal_view" */
export type QuoteMinimalView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<QuoteMinimalView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type QuoteMinimalView_Append_Input = {
  selectedPlans?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "quotes.quote_minimal_view". All fields are combined with a logical 'AND'. */
export type QuoteMinimalView_Bool_Exp = {
  _and?: InputMaybe<Array<QuoteMinimalView_Bool_Exp>>;
  _not?: InputMaybe<QuoteMinimalView_Bool_Exp>;
  _or?: InputMaybe<Array<QuoteMinimalView_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cylindersNumber?: InputMaybe<String_Comparison_Exp>;
  dealerCode?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  fuelTypeDescription?: InputMaybe<String_Comparison_Exp>;
  hasBeenPurchased?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  makeName?: InputMaybe<String_Comparison_Exp>;
  modelName?: InputMaybe<String_Comparison_Exp>;
  numberWheelsDriving?: InputMaybe<String_Comparison_Exp>;
  purchaseDate?: InputMaybe<String_Comparison_Exp>;
  selectedPlans?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicleYear?: InputMaybe<String_Comparison_Exp>;
  vin?: InputMaybe<String_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type QuoteMinimalView_Delete_At_Path_Input = {
  selectedPlans?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type QuoteMinimalView_Delete_Elem_Input = {
  selectedPlans?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type QuoteMinimalView_Delete_Key_Input = {
  selectedPlans?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "quotes.quote_minimal_view" */
export type QuoteMinimalView_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cylindersNumber?: InputMaybe<Scalars['String']>;
  dealerCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fuelTypeDescription?: InputMaybe<Scalars['String']>;
  hasBeenPurchased?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  makeName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['String']>;
  selectedPlans?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleYear?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type QuoteMinimalView_Max_Fields = {
  __typename?: 'quoteMinimalView_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylindersNumber?: Maybe<Scalars['String']>;
  dealerCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fuelTypeDescription?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleYear?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type QuoteMinimalView_Min_Fields = {
  __typename?: 'quoteMinimalView_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylindersNumber?: Maybe<Scalars['String']>;
  dealerCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fuelTypeDescription?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  numberWheelsDriving?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vehicleYear?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "quotes.quote_minimal_view" */
export type QuoteMinimalView_Mutation_Response = {
  __typename?: 'quoteMinimalView_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<QuoteMinimalView>;
};

/** input type for inserting object relation for remote table "quotes.quote_minimal_view" */
export type QuoteMinimalView_Obj_Rel_Insert_Input = {
  data: QuoteMinimalView_Insert_Input;
};

/** Ordering options when selecting data from "quotes.quote_minimal_view". */
export type QuoteMinimalView_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  cylindersNumber?: InputMaybe<Order_By>;
  dealerCode?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  fuelTypeDescription?: InputMaybe<Order_By>;
  hasBeenPurchased?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  makeName?: InputMaybe<Order_By>;
  modelName?: InputMaybe<Order_By>;
  numberWheelsDriving?: InputMaybe<Order_By>;
  purchaseDate?: InputMaybe<Order_By>;
  selectedPlans?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vehicleYear?: InputMaybe<Order_By>;
  vin?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type QuoteMinimalView_Prepend_Input = {
  selectedPlans?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "quotes.quote_minimal_view" */
export enum QuoteMinimalView_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CylindersNumber = 'cylindersNumber',
  /** column name */
  DealerCode = 'dealerCode',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FuelTypeDescription = 'fuelTypeDescription',
  /** column name */
  HasBeenPurchased = 'hasBeenPurchased',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  MakeName = 'makeName',
  /** column name */
  ModelName = 'modelName',
  /** column name */
  NumberWheelsDriving = 'numberWheelsDriving',
  /** column name */
  PurchaseDate = 'purchaseDate',
  /** column name */
  SelectedPlans = 'selectedPlans',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VehicleYear = 'vehicleYear',
  /** column name */
  Vin = 'vin'
}

/** input type for updating data in table "quotes.quote_minimal_view" */
export type QuoteMinimalView_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cylindersNumber?: InputMaybe<Scalars['String']>;
  dealerCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fuelTypeDescription?: InputMaybe<Scalars['String']>;
  hasBeenPurchased?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  makeName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['String']>;
  selectedPlans?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleYear?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "quoteMinimalView" */
export type QuoteMinimalView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: QuoteMinimalView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type QuoteMinimalView_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cylindersNumber?: InputMaybe<Scalars['String']>;
  dealerCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fuelTypeDescription?: InputMaybe<Scalars['String']>;
  hasBeenPurchased?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  makeName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  numberWheelsDriving?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['String']>;
  selectedPlans?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vehicleYear?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type QuoteMinimalView_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<QuoteMinimalView_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<QuoteMinimalView_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<QuoteMinimalView_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<QuoteMinimalView_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<QuoteMinimalView_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuoteMinimalView_Set_Input>;
  /** filter the rows which have to be updated */
  where: QuoteMinimalView_Bool_Exp;
};

/** columns and relationships of "quotes.quote_type" */
export type QuoteType = {
  __typename?: 'quoteType';
  display?: Maybe<Scalars['String']>;
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  quotes: Array<Quote>;
  /** An aggregate relationship */
  quotes_aggregate: Quote_Aggregate;
};


/** columns and relationships of "quotes.quote_type" */
export type QuoteTypeQuotesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


/** columns and relationships of "quotes.quote_type" */
export type QuoteTypeQuotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};

/** aggregated selection of "quotes.quote_type" */
export type QuoteType_Aggregate = {
  __typename?: 'quoteType_aggregate';
  aggregate?: Maybe<QuoteType_Aggregate_Fields>;
  nodes: Array<QuoteType>;
};

/** aggregate fields of "quotes.quote_type" */
export type QuoteType_Aggregate_Fields = {
  __typename?: 'quoteType_aggregate_fields';
  avg?: Maybe<QuoteType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<QuoteType_Max_Fields>;
  min?: Maybe<QuoteType_Min_Fields>;
  stddev?: Maybe<QuoteType_Stddev_Fields>;
  stddev_pop?: Maybe<QuoteType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<QuoteType_Stddev_Samp_Fields>;
  sum?: Maybe<QuoteType_Sum_Fields>;
  var_pop?: Maybe<QuoteType_Var_Pop_Fields>;
  var_samp?: Maybe<QuoteType_Var_Samp_Fields>;
  variance?: Maybe<QuoteType_Variance_Fields>;
};


/** aggregate fields of "quotes.quote_type" */
export type QuoteType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<QuoteType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type QuoteType_Avg_Fields = {
  __typename?: 'quoteType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "quotes.quote_type". All fields are combined with a logical 'AND'. */
export type QuoteType_Bool_Exp = {
  _and?: InputMaybe<Array<QuoteType_Bool_Exp>>;
  _not?: InputMaybe<QuoteType_Bool_Exp>;
  _or?: InputMaybe<Array<QuoteType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  quotes?: InputMaybe<Quote_Bool_Exp>;
  quotes_aggregate?: InputMaybe<Quote_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "quotes.quote_type" */
export enum QuoteType_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuoteTypePkey = 'quote_type_pkey'
}

/** input type for incrementing numeric columns in table "quotes.quote_type" */
export type QuoteType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "quotes.quote_type" */
export type QuoteType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  quotes?: InputMaybe<Quote_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type QuoteType_Max_Fields = {
  __typename?: 'quoteType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type QuoteType_Min_Fields = {
  __typename?: 'quoteType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "quotes.quote_type" */
export type QuoteType_Mutation_Response = {
  __typename?: 'quoteType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<QuoteType>;
};

/** input type for inserting object relation for remote table "quotes.quote_type" */
export type QuoteType_Obj_Rel_Insert_Input = {
  data: QuoteType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<QuoteType_On_Conflict>;
};

/** on_conflict condition type for table "quotes.quote_type" */
export type QuoteType_On_Conflict = {
  constraint: QuoteType_Constraint;
  update_columns?: Array<QuoteType_Update_Column>;
  where?: InputMaybe<QuoteType_Bool_Exp>;
};

/** Ordering options when selecting data from "quotes.quote_type". */
export type QuoteType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  quotes_aggregate?: InputMaybe<Quote_Aggregate_Order_By>;
};

/** primary key columns input for table: quotes.quote_type */
export type QuoteType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "quotes.quote_type" */
export enum QuoteType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "quotes.quote_type" */
export type QuoteType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type QuoteType_Stddev_Fields = {
  __typename?: 'quoteType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type QuoteType_Stddev_Pop_Fields = {
  __typename?: 'quoteType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type QuoteType_Stddev_Samp_Fields = {
  __typename?: 'quoteType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "quoteType" */
export type QuoteType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: QuoteType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type QuoteType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type QuoteType_Sum_Fields = {
  __typename?: 'quoteType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "quotes.quote_type" */
export enum QuoteType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type QuoteType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<QuoteType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuoteType_Set_Input>;
  /** filter the rows which have to be updated */
  where: QuoteType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type QuoteType_Var_Pop_Fields = {
  __typename?: 'quoteType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type QuoteType_Var_Samp_Fields = {
  __typename?: 'quoteType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type QuoteType_Variance_Fields = {
  __typename?: 'quoteType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "quotes.quote" */
export type Quote_Aggregate = {
  __typename?: 'quote_aggregate';
  aggregate?: Maybe<Quote_Aggregate_Fields>;
  nodes: Array<Quote>;
};

export type Quote_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quote_Aggregate_Bool_Exp_Count>;
};

export type Quote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quotes.quote" */
export type Quote_Aggregate_Fields = {
  __typename?: 'quote_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Quote_Max_Fields>;
  min?: Maybe<Quote_Min_Fields>;
};


/** aggregate fields of "quotes.quote" */
export type Quote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quotes.quote" */
export type Quote_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quote_Max_Order_By>;
  min?: InputMaybe<Quote_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Quote_Append_Input = {
  editMetadata?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  resultMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "quotes.quote" */
export type Quote_Arr_Rel_Insert_Input = {
  data: Array<Quote_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_On_Conflict>;
};

/** Boolean expression to filter rows from the table "quotes.quote". All fields are combined with a logical 'AND'. */
export type Quote_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Bool_Exp>>;
  _not?: InputMaybe<Quote_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  editMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quoteType?: InputMaybe<QuoteType_Bool_Exp>;
  quoteTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  resultMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quotes.quote" */
export enum Quote_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuotePkey = 'quote_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Quote_Delete_At_Path_Input = {
  editMetadata?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<Scalars['String']>>;
  resultMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Quote_Delete_Elem_Input = {
  editMetadata?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['Int']>;
  resultMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Quote_Delete_Key_Input = {
  editMetadata?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
  resultMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "quotes.quote" */
export type Quote_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  editMetadata?: InputMaybe<Scalars['jsonb']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  quoteType?: InputMaybe<QuoteType_Obj_Rel_Insert_Input>;
  quoteTypeId?: InputMaybe<Scalars['uuid']>;
  resultMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Quote_Max_Fields = {
  __typename?: 'quote_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  quoteTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "quotes.quote" */
export type Quote_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quoteTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quote_Min_Fields = {
  __typename?: 'quote_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  quoteTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "quotes.quote" */
export type Quote_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quoteTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quotes.quote" */
export type Quote_Mutation_Response = {
  __typename?: 'quote_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote>;
};

/** input type for inserting object relation for remote table "quotes.quote" */
export type Quote_Obj_Rel_Insert_Input = {
  data: Quote_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_On_Conflict>;
};

/** on_conflict condition type for table "quotes.quote" */
export type Quote_On_Conflict = {
  constraint: Quote_Constraint;
  update_columns?: Array<Quote_Update_Column>;
  where?: InputMaybe<Quote_Bool_Exp>;
};

/** Ordering options when selecting data from "quotes.quote". */
export type Quote_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  editMetadata?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  quoteType?: InputMaybe<QuoteType_Order_By>;
  quoteTypeId?: InputMaybe<Order_By>;
  resultMetadata?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quotes.quote */
export type Quote_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Quote_Prepend_Input = {
  editMetadata?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  resultMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "quotes.quote" */
export enum Quote_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EditMetadata = 'editMetadata',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  QuoteTypeId = 'quoteTypeId',
  /** column name */
  ResultMetadata = 'resultMetadata',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "quotes.quote" */
export type Quote_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  editMetadata?: InputMaybe<Scalars['jsonb']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  quoteTypeId?: InputMaybe<Scalars['uuid']>;
  resultMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "quote" */
export type Quote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  editMetadata?: InputMaybe<Scalars['jsonb']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  quoteTypeId?: InputMaybe<Scalars['uuid']>;
  resultMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "quotes.quote" */
export enum Quote_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EditMetadata = 'editMetadata',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  QuoteTypeId = 'quoteTypeId',
  /** column name */
  ResultMetadata = 'resultMetadata',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Quote_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Quote_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Quote_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Quote_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Quote_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Quote_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Bool_Exp;
};

/** columns and relationships of "rate_bucket_type" */
export type RateBucketType = {
  __typename?: 'rateBucketType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  productCosts: Array<ProductCost>;
  /** An aggregate relationship */
  productCosts_aggregate: ProductCost_Aggregate;
  /** An array relationship */
  productRateBuckets: Array<ProductRateBucket>;
  /** An aggregate relationship */
  productRateBuckets_aggregate: ProductRateBucket_Aggregate;
};


/** columns and relationships of "rate_bucket_type" */
export type RateBucketTypeProductCostsArgs = {
  distinct_on?: InputMaybe<Array<ProductCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductCost_Order_By>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};


/** columns and relationships of "rate_bucket_type" */
export type RateBucketTypeProductCosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductCost_Order_By>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};


/** columns and relationships of "rate_bucket_type" */
export type RateBucketTypeProductRateBucketsArgs = {
  distinct_on?: InputMaybe<Array<ProductRateBucket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductRateBucket_Order_By>>;
  where?: InputMaybe<ProductRateBucket_Bool_Exp>;
};


/** columns and relationships of "rate_bucket_type" */
export type RateBucketTypeProductRateBuckets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductRateBucket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductRateBucket_Order_By>>;
  where?: InputMaybe<ProductRateBucket_Bool_Exp>;
};

/** aggregated selection of "rate_bucket_type" */
export type RateBucketType_Aggregate = {
  __typename?: 'rateBucketType_aggregate';
  aggregate?: Maybe<RateBucketType_Aggregate_Fields>;
  nodes: Array<RateBucketType>;
};

/** aggregate fields of "rate_bucket_type" */
export type RateBucketType_Aggregate_Fields = {
  __typename?: 'rateBucketType_aggregate_fields';
  avg?: Maybe<RateBucketType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RateBucketType_Max_Fields>;
  min?: Maybe<RateBucketType_Min_Fields>;
  stddev?: Maybe<RateBucketType_Stddev_Fields>;
  stddev_pop?: Maybe<RateBucketType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RateBucketType_Stddev_Samp_Fields>;
  sum?: Maybe<RateBucketType_Sum_Fields>;
  var_pop?: Maybe<RateBucketType_Var_Pop_Fields>;
  var_samp?: Maybe<RateBucketType_Var_Samp_Fields>;
  variance?: Maybe<RateBucketType_Variance_Fields>;
};


/** aggregate fields of "rate_bucket_type" */
export type RateBucketType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RateBucketType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RateBucketType_Avg_Fields = {
  __typename?: 'rateBucketType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "rate_bucket_type". All fields are combined with a logical 'AND'. */
export type RateBucketType_Bool_Exp = {
  _and?: InputMaybe<Array<RateBucketType_Bool_Exp>>;
  _not?: InputMaybe<RateBucketType_Bool_Exp>;
  _or?: InputMaybe<Array<RateBucketType_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  productCosts?: InputMaybe<ProductCost_Bool_Exp>;
  productCosts_aggregate?: InputMaybe<ProductCost_Aggregate_Bool_Exp>;
  productRateBuckets?: InputMaybe<ProductRateBucket_Bool_Exp>;
  productRateBuckets_aggregate?: InputMaybe<ProductRateBucket_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "rate_bucket_type" */
export enum RateBucketType_Constraint {
  /** unique or primary key constraint on columns "id" */
  RateBucketTypeIdKey = 'rate_bucket_type_id_key',
  /** unique or primary key constraint on columns "id" */
  RateBucketTypePkey = 'rate_bucket_type_pkey'
}

/** input type for incrementing numeric columns in table "rate_bucket_type" */
export type RateBucketType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "rate_bucket_type" */
export type RateBucketType_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productCosts?: InputMaybe<ProductCost_Arr_Rel_Insert_Input>;
  productRateBuckets?: InputMaybe<ProductRateBucket_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type RateBucketType_Max_Fields = {
  __typename?: 'rateBucketType_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RateBucketType_Min_Fields = {
  __typename?: 'rateBucketType_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "rate_bucket_type" */
export type RateBucketType_Mutation_Response = {
  __typename?: 'rateBucketType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RateBucketType>;
};

/** input type for inserting object relation for remote table "rate_bucket_type" */
export type RateBucketType_Obj_Rel_Insert_Input = {
  data: RateBucketType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RateBucketType_On_Conflict>;
};

/** on_conflict condition type for table "rate_bucket_type" */
export type RateBucketType_On_Conflict = {
  constraint: RateBucketType_Constraint;
  update_columns?: Array<RateBucketType_Update_Column>;
  where?: InputMaybe<RateBucketType_Bool_Exp>;
};

/** Ordering options when selecting data from "rate_bucket_type". */
export type RateBucketType_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  productCosts_aggregate?: InputMaybe<ProductCost_Aggregate_Order_By>;
  productRateBuckets_aggregate?: InputMaybe<ProductRateBucket_Aggregate_Order_By>;
};

/** primary key columns input for table: rate_bucket_type */
export type RateBucketType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "rate_bucket_type" */
export enum RateBucketType_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "rate_bucket_type" */
export type RateBucketType_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RateBucketType_Stddev_Fields = {
  __typename?: 'rateBucketType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RateBucketType_Stddev_Pop_Fields = {
  __typename?: 'rateBucketType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RateBucketType_Stddev_Samp_Fields = {
  __typename?: 'rateBucketType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "rateBucketType" */
export type RateBucketType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RateBucketType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RateBucketType_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type RateBucketType_Sum_Fields = {
  __typename?: 'rateBucketType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "rate_bucket_type" */
export enum RateBucketType_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type RateBucketType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RateBucketType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RateBucketType_Set_Input>;
  /** filter the rows which have to be updated */
  where: RateBucketType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RateBucketType_Var_Pop_Fields = {
  __typename?: 'rateBucketType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RateBucketType_Var_Samp_Fields = {
  __typename?: 'rateBucketType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RateBucketType_Variance_Fields = {
  __typename?: 'rateBucketType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "rate_quote" */
export type RateQuote = {
  __typename?: 'rateQuote';
  accountId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  performance?: Maybe<Scalars['jsonb']>;
  query?: Maybe<Scalars['jsonb']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "rate_quote" */
export type RateQuotePerformanceArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "rate_quote" */
export type RateQuoteQueryArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "rate_quote" */
export type RateQuote_Aggregate = {
  __typename?: 'rateQuote_aggregate';
  aggregate?: Maybe<RateQuote_Aggregate_Fields>;
  nodes: Array<RateQuote>;
};

/** aggregate fields of "rate_quote" */
export type RateQuote_Aggregate_Fields = {
  __typename?: 'rateQuote_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<RateQuote_Max_Fields>;
  min?: Maybe<RateQuote_Min_Fields>;
};


/** aggregate fields of "rate_quote" */
export type RateQuote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RateQuote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RateQuote_Append_Input = {
  performance?: InputMaybe<Scalars['jsonb']>;
  query?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "rate_quote". All fields are combined with a logical 'AND'. */
export type RateQuote_Bool_Exp = {
  _and?: InputMaybe<Array<RateQuote_Bool_Exp>>;
  _not?: InputMaybe<RateQuote_Bool_Exp>;
  _or?: InputMaybe<Array<RateQuote_Bool_Exp>>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  performance?: InputMaybe<Jsonb_Comparison_Exp>;
  query?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rate_quote" */
export enum RateQuote_Constraint {
  /** unique or primary key constraint on columns "id" */
  RateQuotePkey = 'rate_quote_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RateQuote_Delete_At_Path_Input = {
  performance?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RateQuote_Delete_Elem_Input = {
  performance?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RateQuote_Delete_Key_Input = {
  performance?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "rate_quote" */
export type RateQuote_Insert_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  performance?: InputMaybe<Scalars['jsonb']>;
  query?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RateQuote_Max_Fields = {
  __typename?: 'rateQuote_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type RateQuote_Min_Fields = {
  __typename?: 'rateQuote_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "rate_quote" */
export type RateQuote_Mutation_Response = {
  __typename?: 'rateQuote_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RateQuote>;
};

/** on_conflict condition type for table "rate_quote" */
export type RateQuote_On_Conflict = {
  constraint: RateQuote_Constraint;
  update_columns?: Array<RateQuote_Update_Column>;
  where?: InputMaybe<RateQuote_Bool_Exp>;
};

/** Ordering options when selecting data from "rate_quote". */
export type RateQuote_Order_By = {
  accountId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  performance?: InputMaybe<Order_By>;
  query?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rate_quote */
export type RateQuote_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RateQuote_Prepend_Input = {
  performance?: InputMaybe<Scalars['jsonb']>;
  query?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "rate_quote" */
export enum RateQuote_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Performance = 'performance',
  /** column name */
  Query = 'query',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "rate_quote" */
export type RateQuote_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  performance?: InputMaybe<Scalars['jsonb']>;
  query?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "rateQuote" */
export type RateQuote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RateQuote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RateQuote_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  performance?: InputMaybe<Scalars['jsonb']>;
  query?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "rate_quote" */
export enum RateQuote_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Performance = 'performance',
  /** column name */
  Query = 'query',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RateQuote_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RateQuote_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RateQuote_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RateQuote_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RateQuote_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RateQuote_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RateQuote_Set_Input>;
  /** filter the rows which have to be updated */
  where: RateQuote_Bool_Exp;
};

/**
 * Rater program display configuration: which component renders a program, how its coverages are presented, and which columns a table shows. Business-editable data, loaded by the Portal over GraphQL (RaterState raterViewConfigs) -- it replaced a static TypeScript config, so display rules no longer need a deploy.
 *
 * Self-referential: a root row is a program, child rows (parent_rater_view_config_id) are its nested Group / Coverage / Table nodes. A program with no rows here does not render.
 */
export type RaterViewConfig = {
  __typename?: 'raterViewConfig';
  /** An object relationship */
  childRaterViewConfig?: Maybe<RaterViewConfig>;
  /** An array relationship */
  childRaterViewConfigs: Array<RaterViewConfig>;
  /** An aggregate relationship */
  childRaterViewConfigs_aggregate: RaterViewConfig_Aggregate;
  /**
   * Untyped display properties for this node. No schema or constraint -- the keys below are what Portal/src/app/modules/rater/state/rater.state.ts actually reads, and adding a key here means changing that selector.
   *
   * categoryCode: on a root row, the program/category code this config is for -- this is how a program is identified (there is no category_id column).
   * coverageType (or type): 'select' or 'input'.
   * coverageConfig, tableConfig: per-node display settings.
   * coverageDisplay: on a Coverage node, 'months' or 'years' -- the unit its terms are labeled in. Unset, the unit is the API's per-program-type default.
   * displayedColumns: the columns a Table node shows.
   */
  configMetadata: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** Self-FK modelling the nested Group-of-Groups structure; NULL on a root row (a program). ON DELETE cascade, so deleting a program removes its whole subtree. */
  parentRaterViewConfigId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  raterViewConfigType?: Maybe<Type>;
  /** FK into shared.type, RaterViews group: Table, Group or Coverage. Determines which component renders the node. Nullable -- when unset the Portal falls back to Group if the row has children and Coverage otherwise. */
  raterViewConfigTypeId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/**
 * Rater program display configuration: which component renders a program, how its coverages are presented, and which columns a table shows. Business-editable data, loaded by the Portal over GraphQL (RaterState raterViewConfigs) -- it replaced a static TypeScript config, so display rules no longer need a deploy.
 *
 * Self-referential: a root row is a program, child rows (parent_rater_view_config_id) are its nested Group / Coverage / Table nodes. A program with no rows here does not render.
 */
export type RaterViewConfigChildRaterViewConfigsArgs = {
  distinct_on?: InputMaybe<Array<RaterViewConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RaterViewConfig_Order_By>>;
  where?: InputMaybe<RaterViewConfig_Bool_Exp>;
};


/**
 * Rater program display configuration: which component renders a program, how its coverages are presented, and which columns a table shows. Business-editable data, loaded by the Portal over GraphQL (RaterState raterViewConfigs) -- it replaced a static TypeScript config, so display rules no longer need a deploy.
 *
 * Self-referential: a root row is a program, child rows (parent_rater_view_config_id) are its nested Group / Coverage / Table nodes. A program with no rows here does not render.
 */
export type RaterViewConfigChildRaterViewConfigs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RaterViewConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RaterViewConfig_Order_By>>;
  where?: InputMaybe<RaterViewConfig_Bool_Exp>;
};


/**
 * Rater program display configuration: which component renders a program, how its coverages are presented, and which columns a table shows. Business-editable data, loaded by the Portal over GraphQL (RaterState raterViewConfigs) -- it replaced a static TypeScript config, so display rules no longer need a deploy.
 *
 * Self-referential: a root row is a program, child rows (parent_rater_view_config_id) are its nested Group / Coverage / Table nodes. A program with no rows here does not render.
 */
export type RaterViewConfigConfigMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ui.rater_view_config" */
export type RaterViewConfig_Aggregate = {
  __typename?: 'raterViewConfig_aggregate';
  aggregate?: Maybe<RaterViewConfig_Aggregate_Fields>;
  nodes: Array<RaterViewConfig>;
};

export type RaterViewConfig_Aggregate_Bool_Exp = {
  count?: InputMaybe<RaterViewConfig_Aggregate_Bool_Exp_Count>;
};

export type RaterViewConfig_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RaterViewConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RaterViewConfig_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ui.rater_view_config" */
export type RaterViewConfig_Aggregate_Fields = {
  __typename?: 'raterViewConfig_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<RaterViewConfig_Max_Fields>;
  min?: Maybe<RaterViewConfig_Min_Fields>;
};


/** aggregate fields of "ui.rater_view_config" */
export type RaterViewConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RaterViewConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ui.rater_view_config" */
export type RaterViewConfig_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RaterViewConfig_Max_Order_By>;
  min?: InputMaybe<RaterViewConfig_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RaterViewConfig_Append_Input = {
  /**
   * Untyped display properties for this node. No schema or constraint -- the keys below are what Portal/src/app/modules/rater/state/rater.state.ts actually reads, and adding a key here means changing that selector.
   *
   * categoryCode: on a root row, the program/category code this config is for -- this is how a program is identified (there is no category_id column).
   * coverageType (or type): 'select' or 'input'.
   * coverageConfig, tableConfig: per-node display settings.
   * coverageDisplay: on a Coverage node, 'months' or 'years' -- the unit its terms are labeled in. Unset, the unit is the API's per-program-type default.
   * displayedColumns: the columns a Table node shows.
   */
  configMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "ui.rater_view_config" */
export type RaterViewConfig_Arr_Rel_Insert_Input = {
  data: Array<RaterViewConfig_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RaterViewConfig_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ui.rater_view_config". All fields are combined with a logical 'AND'. */
export type RaterViewConfig_Bool_Exp = {
  _and?: InputMaybe<Array<RaterViewConfig_Bool_Exp>>;
  _not?: InputMaybe<RaterViewConfig_Bool_Exp>;
  _or?: InputMaybe<Array<RaterViewConfig_Bool_Exp>>;
  childRaterViewConfig?: InputMaybe<RaterViewConfig_Bool_Exp>;
  childRaterViewConfigs?: InputMaybe<RaterViewConfig_Bool_Exp>;
  childRaterViewConfigs_aggregate?: InputMaybe<RaterViewConfig_Aggregate_Bool_Exp>;
  configMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parentRaterViewConfigId?: InputMaybe<Uuid_Comparison_Exp>;
  raterViewConfigType?: InputMaybe<Type_Bool_Exp>;
  raterViewConfigTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ui.rater_view_config" */
export enum RaterViewConfig_Constraint {
  /** unique or primary key constraint on columns "id" */
  RaterViewConfigPkey = 'rater_view_config_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RaterViewConfig_Delete_At_Path_Input = {
  /**
   * Untyped display properties for this node. No schema or constraint -- the keys below are what Portal/src/app/modules/rater/state/rater.state.ts actually reads, and adding a key here means changing that selector.
   *
   * categoryCode: on a root row, the program/category code this config is for -- this is how a program is identified (there is no category_id column).
   * coverageType (or type): 'select' or 'input'.
   * coverageConfig, tableConfig: per-node display settings.
   * coverageDisplay: on a Coverage node, 'months' or 'years' -- the unit its terms are labeled in. Unset, the unit is the API's per-program-type default.
   * displayedColumns: the columns a Table node shows.
   */
  configMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RaterViewConfig_Delete_Elem_Input = {
  /**
   * Untyped display properties for this node. No schema or constraint -- the keys below are what Portal/src/app/modules/rater/state/rater.state.ts actually reads, and adding a key here means changing that selector.
   *
   * categoryCode: on a root row, the program/category code this config is for -- this is how a program is identified (there is no category_id column).
   * coverageType (or type): 'select' or 'input'.
   * coverageConfig, tableConfig: per-node display settings.
   * coverageDisplay: on a Coverage node, 'months' or 'years' -- the unit its terms are labeled in. Unset, the unit is the API's per-program-type default.
   * displayedColumns: the columns a Table node shows.
   */
  configMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RaterViewConfig_Delete_Key_Input = {
  /**
   * Untyped display properties for this node. No schema or constraint -- the keys below are what Portal/src/app/modules/rater/state/rater.state.ts actually reads, and adding a key here means changing that selector.
   *
   * categoryCode: on a root row, the program/category code this config is for -- this is how a program is identified (there is no category_id column).
   * coverageType (or type): 'select' or 'input'.
   * coverageConfig, tableConfig: per-node display settings.
   * coverageDisplay: on a Coverage node, 'months' or 'years' -- the unit its terms are labeled in. Unset, the unit is the API's per-program-type default.
   * displayedColumns: the columns a Table node shows.
   */
  configMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "ui.rater_view_config" */
export type RaterViewConfig_Insert_Input = {
  childRaterViewConfig?: InputMaybe<RaterViewConfig_Obj_Rel_Insert_Input>;
  childRaterViewConfigs?: InputMaybe<RaterViewConfig_Arr_Rel_Insert_Input>;
  /**
   * Untyped display properties for this node. No schema or constraint -- the keys below are what Portal/src/app/modules/rater/state/rater.state.ts actually reads, and adding a key here means changing that selector.
   *
   * categoryCode: on a root row, the program/category code this config is for -- this is how a program is identified (there is no category_id column).
   * coverageType (or type): 'select' or 'input'.
   * coverageConfig, tableConfig: per-node display settings.
   * coverageDisplay: on a Coverage node, 'months' or 'years' -- the unit its terms are labeled in. Unset, the unit is the API's per-program-type default.
   * displayedColumns: the columns a Table node shows.
   */
  configMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** Self-FK modelling the nested Group-of-Groups structure; NULL on a root row (a program). ON DELETE cascade, so deleting a program removes its whole subtree. */
  parentRaterViewConfigId?: InputMaybe<Scalars['uuid']>;
  raterViewConfigType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** FK into shared.type, RaterViews group: Table, Group or Coverage. Determines which component renders the node. Nullable -- when unset the Portal falls back to Group if the row has children and Coverage otherwise. */
  raterViewConfigTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RaterViewConfig_Max_Fields = {
  __typename?: 'raterViewConfig_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** Self-FK modelling the nested Group-of-Groups structure; NULL on a root row (a program). ON DELETE cascade, so deleting a program removes its whole subtree. */
  parentRaterViewConfigId?: Maybe<Scalars['uuid']>;
  /** FK into shared.type, RaterViews group: Table, Group or Coverage. Determines which component renders the node. Nullable -- when unset the Portal falls back to Group if the row has children and Coverage otherwise. */
  raterViewConfigTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ui.rater_view_config" */
export type RaterViewConfig_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Self-FK modelling the nested Group-of-Groups structure; NULL on a root row (a program). ON DELETE cascade, so deleting a program removes its whole subtree. */
  parentRaterViewConfigId?: InputMaybe<Order_By>;
  /** FK into shared.type, RaterViews group: Table, Group or Coverage. Determines which component renders the node. Nullable -- when unset the Portal falls back to Group if the row has children and Coverage otherwise. */
  raterViewConfigTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RaterViewConfig_Min_Fields = {
  __typename?: 'raterViewConfig_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** Self-FK modelling the nested Group-of-Groups structure; NULL on a root row (a program). ON DELETE cascade, so deleting a program removes its whole subtree. */
  parentRaterViewConfigId?: Maybe<Scalars['uuid']>;
  /** FK into shared.type, RaterViews group: Table, Group or Coverage. Determines which component renders the node. Nullable -- when unset the Portal falls back to Group if the row has children and Coverage otherwise. */
  raterViewConfigTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ui.rater_view_config" */
export type RaterViewConfig_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Self-FK modelling the nested Group-of-Groups structure; NULL on a root row (a program). ON DELETE cascade, so deleting a program removes its whole subtree. */
  parentRaterViewConfigId?: InputMaybe<Order_By>;
  /** FK into shared.type, RaterViews group: Table, Group or Coverage. Determines which component renders the node. Nullable -- when unset the Portal falls back to Group if the row has children and Coverage otherwise. */
  raterViewConfigTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ui.rater_view_config" */
export type RaterViewConfig_Mutation_Response = {
  __typename?: 'raterViewConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RaterViewConfig>;
};

/** input type for inserting object relation for remote table "ui.rater_view_config" */
export type RaterViewConfig_Obj_Rel_Insert_Input = {
  data: RaterViewConfig_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RaterViewConfig_On_Conflict>;
};

/** on_conflict condition type for table "ui.rater_view_config" */
export type RaterViewConfig_On_Conflict = {
  constraint: RaterViewConfig_Constraint;
  update_columns?: Array<RaterViewConfig_Update_Column>;
  where?: InputMaybe<RaterViewConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "ui.rater_view_config". */
export type RaterViewConfig_Order_By = {
  childRaterViewConfig?: InputMaybe<RaterViewConfig_Order_By>;
  childRaterViewConfigs_aggregate?: InputMaybe<RaterViewConfig_Aggregate_Order_By>;
  configMetadata?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentRaterViewConfigId?: InputMaybe<Order_By>;
  raterViewConfigType?: InputMaybe<Type_Order_By>;
  raterViewConfigTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ui.rater_view_config */
export type RaterViewConfig_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RaterViewConfig_Prepend_Input = {
  /**
   * Untyped display properties for this node. No schema or constraint -- the keys below are what Portal/src/app/modules/rater/state/rater.state.ts actually reads, and adding a key here means changing that selector.
   *
   * categoryCode: on a root row, the program/category code this config is for -- this is how a program is identified (there is no category_id column).
   * coverageType (or type): 'select' or 'input'.
   * coverageConfig, tableConfig: per-node display settings.
   * coverageDisplay: on a Coverage node, 'months' or 'years' -- the unit its terms are labeled in. Unset, the unit is the API's per-program-type default.
   * displayedColumns: the columns a Table node shows.
   */
  configMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ui.rater_view_config" */
export enum RaterViewConfig_Select_Column {
  /** column name */
  ConfigMetadata = 'configMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentRaterViewConfigId = 'parentRaterViewConfigId',
  /** column name */
  RaterViewConfigTypeId = 'raterViewConfigTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "ui.rater_view_config" */
export type RaterViewConfig_Set_Input = {
  /**
   * Untyped display properties for this node. No schema or constraint -- the keys below are what Portal/src/app/modules/rater/state/rater.state.ts actually reads, and adding a key here means changing that selector.
   *
   * categoryCode: on a root row, the program/category code this config is for -- this is how a program is identified (there is no category_id column).
   * coverageType (or type): 'select' or 'input'.
   * coverageConfig, tableConfig: per-node display settings.
   * coverageDisplay: on a Coverage node, 'months' or 'years' -- the unit its terms are labeled in. Unset, the unit is the API's per-program-type default.
   * displayedColumns: the columns a Table node shows.
   */
  configMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** Self-FK modelling the nested Group-of-Groups structure; NULL on a root row (a program). ON DELETE cascade, so deleting a program removes its whole subtree. */
  parentRaterViewConfigId?: InputMaybe<Scalars['uuid']>;
  /** FK into shared.type, RaterViews group: Table, Group or Coverage. Determines which component renders the node. Nullable -- when unset the Portal falls back to Group if the row has children and Coverage otherwise. */
  raterViewConfigTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "raterViewConfig" */
export type RaterViewConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RaterViewConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RaterViewConfig_Stream_Cursor_Value_Input = {
  /**
   * Untyped display properties for this node. No schema or constraint -- the keys below are what Portal/src/app/modules/rater/state/rater.state.ts actually reads, and adding a key here means changing that selector.
   *
   * categoryCode: on a root row, the program/category code this config is for -- this is how a program is identified (there is no category_id column).
   * coverageType (or type): 'select' or 'input'.
   * coverageConfig, tableConfig: per-node display settings.
   * coverageDisplay: on a Coverage node, 'months' or 'years' -- the unit its terms are labeled in. Unset, the unit is the API's per-program-type default.
   * displayedColumns: the columns a Table node shows.
   */
  configMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** Self-FK modelling the nested Group-of-Groups structure; NULL on a root row (a program). ON DELETE cascade, so deleting a program removes its whole subtree. */
  parentRaterViewConfigId?: InputMaybe<Scalars['uuid']>;
  /** FK into shared.type, RaterViews group: Table, Group or Coverage. Determines which component renders the node. Nullable -- when unset the Portal falls back to Group if the row has children and Coverage otherwise. */
  raterViewConfigTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ui.rater_view_config" */
export enum RaterViewConfig_Update_Column {
  /** column name */
  ConfigMetadata = 'configMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentRaterViewConfigId = 'parentRaterViewConfigId',
  /** column name */
  RaterViewConfigTypeId = 'raterViewConfigTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RaterViewConfig_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RaterViewConfig_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RaterViewConfig_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RaterViewConfig_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RaterViewConfig_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RaterViewConfig_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RaterViewConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: RaterViewConfig_Bool_Exp;
};

/** aggregate fields of "nhtsa.record_type" */
export type RecordType_Aggregate_Fields_Nhtsa = {
  __typename?: 'recordType_aggregate_fields_nhtsa';
  avg?: Maybe<RecordType_Avg_Fields_Nhtsa>;
  count: Scalars['Int'];
  max?: Maybe<RecordType_Max_Fields_Nhtsa>;
  min?: Maybe<RecordType_Min_Fields_Nhtsa>;
  stddev?: Maybe<RecordType_Stddev_Fields_Nhtsa>;
  stddev_pop?: Maybe<RecordType_Stddev_Pop_Fields_Nhtsa>;
  stddev_samp?: Maybe<RecordType_Stddev_Samp_Fields_Nhtsa>;
  sum?: Maybe<RecordType_Sum_Fields_Nhtsa>;
  var_pop?: Maybe<RecordType_Var_Pop_Fields_Nhtsa>;
  var_samp?: Maybe<RecordType_Var_Samp_Fields_Nhtsa>;
  variance?: Maybe<RecordType_Variance_Fields_Nhtsa>;
};


/** aggregate fields of "nhtsa.record_type" */
export type RecordType_Aggregate_Fields_NhtsaCountArgs = {
  columns?: InputMaybe<Array<RecordType_Select_Column_Nhtsa>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "nhtsa.record_type" */
export type RecordType_Aggregate_Nhtsa = {
  __typename?: 'recordType_aggregate_nhtsa';
  aggregate?: Maybe<RecordType_Aggregate_Fields_Nhtsa>;
  nodes: Array<RecordType_Nhtsa>;
};

/** aggregate avg on columns */
export type RecordType_Avg_Fields_Nhtsa = {
  __typename?: 'recordType_avg_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nhtsa.record_type". All fields are combined with a logical 'AND'. */
export type RecordType_Bool_Exp_Nhtsa = {
  _and?: InputMaybe<Array<RecordType_Bool_Exp_Nhtsa>>;
  _not?: InputMaybe<RecordType_Bool_Exp_Nhtsa>;
  _or?: InputMaybe<Array<RecordType_Bool_Exp_Nhtsa>>;
  issueCount?: InputMaybe<Int_Comparison_Exp>;
  issueType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "nhtsa.record_type" */
export enum RecordType_Constraint_Nhtsa {
  /** unique or primary key constraint on columns "name" */
  RecordTypePkey = 'record_type_pkey'
}

/** input type for incrementing numeric columns in table "nhtsa.record_type" */
export type RecordType_Inc_Input_Nhtsa = {
  issueCount?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nhtsa.record_type" */
export type RecordType_Insert_Input_Nhtsa = {
  issueCount?: InputMaybe<Scalars['Int']>;
  issueType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type RecordType_Max_Fields_Nhtsa = {
  __typename?: 'recordType_max_fields_nhtsa';
  issueCount?: Maybe<Scalars['Int']>;
  issueType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type RecordType_Min_Fields_Nhtsa = {
  __typename?: 'recordType_min_fields_nhtsa';
  issueCount?: Maybe<Scalars['Int']>;
  issueType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "nhtsa.record_type" */
export type RecordType_Mutation_Response_Nhtsa = {
  __typename?: 'recordType_mutation_response_nhtsa';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordType_Nhtsa>;
};

/** The record types present in this load, in display order, for the claims search filter. */
export type RecordType_Nhtsa = {
  __typename?: 'recordType_nhtsa';
  issueCount: Scalars['Int'];
  issueType: Scalars['String'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

/** on_conflict condition type for table "nhtsa.record_type" */
export type RecordType_On_Conflict_Nhtsa = {
  constraint: RecordType_Constraint_Nhtsa;
  update_columns?: Array<RecordType_Update_Column_Nhtsa>;
  where?: InputMaybe<RecordType_Bool_Exp_Nhtsa>;
};

/** Ordering options when selecting data from "nhtsa.record_type". */
export type RecordType_Order_By_Nhtsa = {
  issueCount?: InputMaybe<Order_By>;
  issueType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nhtsa.record_type */
export type RecordType_Pk_Columns_Input_Nhtsa = {
  name: Scalars['String'];
};

/** select columns of table "nhtsa.record_type" */
export enum RecordType_Select_Column_Nhtsa {
  /** column name */
  IssueCount = 'issueCount',
  /** column name */
  IssueType = 'issueType',
  /** column name */
  Name = 'name',
  /** column name */
  SortOrder = 'sortOrder'
}

/** input type for updating data in table "nhtsa.record_type" */
export type RecordType_Set_Input_Nhtsa = {
  issueCount?: InputMaybe<Scalars['Int']>;
  issueType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type RecordType_Stddev_Fields_Nhtsa = {
  __typename?: 'recordType_stddev_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RecordType_Stddev_Pop_Fields_Nhtsa = {
  __typename?: 'recordType_stddev_pop_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RecordType_Stddev_Samp_Fields_Nhtsa = {
  __typename?: 'recordType_stddev_samp_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "recordType" */
export type RecordType_Stream_Cursor_Input_Nhtsa = {
  /** Stream column input with initial value */
  initial_value: RecordType_Stream_Cursor_Value_Input_Nhtsa;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Nhtsa>;
};

/** Initial value of the column from where the streaming should start */
export type RecordType_Stream_Cursor_Value_Input_Nhtsa = {
  issueCount?: InputMaybe<Scalars['Int']>;
  issueType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type RecordType_Sum_Fields_Nhtsa = {
  __typename?: 'recordType_sum_fields_nhtsa';
  issueCount?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

/** update columns of table "nhtsa.record_type" */
export enum RecordType_Update_Column_Nhtsa {
  /** column name */
  IssueCount = 'issueCount',
  /** column name */
  IssueType = 'issueType',
  /** column name */
  Name = 'name',
  /** column name */
  SortOrder = 'sortOrder'
}

export type RecordType_Updates_Nhtsa = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RecordType_Inc_Input_Nhtsa>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordType_Set_Input_Nhtsa>;
  /** filter the rows which have to be updated */
  where: RecordType_Bool_Exp_Nhtsa;
};

/** aggregate var_pop on columns */
export type RecordType_Var_Pop_Fields_Nhtsa = {
  __typename?: 'recordType_var_pop_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RecordType_Var_Samp_Fields_Nhtsa = {
  __typename?: 'recordType_var_samp_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RecordType_Variance_Fields_Nhtsa = {
  __typename?: 'recordType_variance_fields_nhtsa';
  issueCount?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "system.reference_log" */
export type ReferenceLog = {
  __typename?: 'referenceLog';
  id: Scalars['uuid'];
  /** An object relationship */
  jobHistoryLog?: Maybe<JobHistoryLog>;
  jobHistoryLogId: Scalars['uuid'];
  message?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  severityLevelType?: Maybe<SeverityLevelType>;
  severityLevelTypeId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "system.reference_log" */
export type ReferenceLog_Aggregate = {
  __typename?: 'referenceLog_aggregate';
  aggregate?: Maybe<ReferenceLog_Aggregate_Fields>;
  nodes: Array<ReferenceLog>;
};

export type ReferenceLog_Aggregate_Bool_Exp = {
  count?: InputMaybe<ReferenceLog_Aggregate_Bool_Exp_Count>;
};

export type ReferenceLog_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ReferenceLog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReferenceLog_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "system.reference_log" */
export type ReferenceLog_Aggregate_Fields = {
  __typename?: 'referenceLog_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ReferenceLog_Max_Fields>;
  min?: Maybe<ReferenceLog_Min_Fields>;
};


/** aggregate fields of "system.reference_log" */
export type ReferenceLog_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReferenceLog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "system.reference_log" */
export type ReferenceLog_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ReferenceLog_Max_Order_By>;
  min?: InputMaybe<ReferenceLog_Min_Order_By>;
};

/** input type for inserting array relation for remote table "system.reference_log" */
export type ReferenceLog_Arr_Rel_Insert_Input = {
  data: Array<ReferenceLog_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ReferenceLog_On_Conflict>;
};

/** Boolean expression to filter rows from the table "system.reference_log". All fields are combined with a logical 'AND'. */
export type ReferenceLog_Bool_Exp = {
  _and?: InputMaybe<Array<ReferenceLog_Bool_Exp>>;
  _not?: InputMaybe<ReferenceLog_Bool_Exp>;
  _or?: InputMaybe<Array<ReferenceLog_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobHistoryLog?: InputMaybe<JobHistoryLog_Bool_Exp>;
  jobHistoryLogId?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  severityLevelType?: InputMaybe<SeverityLevelType_Bool_Exp>;
  severityLevelTypeId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.reference_log" */
export enum ReferenceLog_Constraint {
  /** unique or primary key constraint on columns "id" */
  ValidationLogPkey = 'validation_log_pkey'
}

/** input type for inserting data into table "system.reference_log" */
export type ReferenceLog_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  jobHistoryLog?: InputMaybe<JobHistoryLog_Obj_Rel_Insert_Input>;
  jobHistoryLogId?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  severityLevelType?: InputMaybe<SeverityLevelType_Obj_Rel_Insert_Input>;
  severityLevelTypeId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ReferenceLog_Max_Fields = {
  __typename?: 'referenceLog_max_fields';
  id?: Maybe<Scalars['uuid']>;
  jobHistoryLogId?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  severityLevelTypeId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "system.reference_log" */
export type ReferenceLog_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  jobHistoryLogId?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  severityLevelTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ReferenceLog_Min_Fields = {
  __typename?: 'referenceLog_min_fields';
  id?: Maybe<Scalars['uuid']>;
  jobHistoryLogId?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  severityLevelTypeId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "system.reference_log" */
export type ReferenceLog_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  jobHistoryLogId?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  severityLevelTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "system.reference_log" */
export type ReferenceLog_Mutation_Response = {
  __typename?: 'referenceLog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ReferenceLog>;
};

/** on_conflict condition type for table "system.reference_log" */
export type ReferenceLog_On_Conflict = {
  constraint: ReferenceLog_Constraint;
  update_columns?: Array<ReferenceLog_Update_Column>;
  where?: InputMaybe<ReferenceLog_Bool_Exp>;
};

/** Ordering options when selecting data from "system.reference_log". */
export type ReferenceLog_Order_By = {
  id?: InputMaybe<Order_By>;
  jobHistoryLog?: InputMaybe<JobHistoryLog_Order_By>;
  jobHistoryLogId?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  severityLevelType?: InputMaybe<SeverityLevelType_Order_By>;
  severityLevelTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.reference_log */
export type ReferenceLog_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "system.reference_log" */
export enum ReferenceLog_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JobHistoryLogId = 'jobHistoryLogId',
  /** column name */
  Message = 'message',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  SeverityLevelTypeId = 'severityLevelTypeId'
}

/** input type for updating data in table "system.reference_log" */
export type ReferenceLog_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  jobHistoryLogId?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  severityLevelTypeId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "referenceLog" */
export type ReferenceLog_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReferenceLog_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReferenceLog_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  jobHistoryLogId?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  severityLevelTypeId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "system.reference_log" */
export enum ReferenceLog_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JobHistoryLogId = 'jobHistoryLogId',
  /** column name */
  Message = 'message',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  SeverityLevelTypeId = 'severityLevelTypeId'
}

export type ReferenceLog_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReferenceLog_Set_Input>;
  /** filter the rows which have to be updated */
  where: ReferenceLog_Bool_Exp;
};

/** columns and relationships of "operations.remittance" */
export type Remittance = {
  __typename?: 'remittance';
  /** Distinct {name, code} of the accounts on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.account.name/code is renamed or policy_contract.account_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  accountMetadata?: Maybe<Scalars['jsonb']>;
  billingMetadata?: Maybe<Scalars['jsonb']>;
  /** Distinct {code, name} of the categories on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.category.code/name is renamed, product.category_id is moved, or policy_contract.product_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  categoryMetadata?: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  /** An array relationship */
  entityRemittanceDetails: Array<EntityRemittanceDetail>;
  /** An aggregate relationship */
  entityRemittanceDetails_aggregate: EntityRemittanceDetail_Aggregate;
  id: Scalars['uuid'];
  /** Bumped by operations.force_recalculate_remittance so a child-row change re-fires the BEFORE trigger that recomputes this row's aggregates. Carries no business meaning. */
  lastRecalcTrigger?: Maybe<Scalars['timestamptz']>;
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount: Scalars['Int'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount: Scalars['numeric'];
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount: Scalars['numeric'];
  /** An object relationship */
  paymentMethodType?: Maybe<PaymentMethodType>;
  paymentMethodTypeId?: Maybe<Scalars['uuid']>;
  /** Payment method type name(s) applied to this remittance, ' / '-joined. NULL when unpaid. DISPLAY SNAPSHOT, not a live value: recomputed when remittance_payment rows change, but NOT when shared.payment_method_type.name is renamed or payment.payment_method_type_id is changed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  paymentType?: Maybe<Scalars['String']>;
  prefixedNumber?: Maybe<Scalars['String']>;
  /** An array relationship */
  remittanceClaimDetails: Array<RemittanceClaimDetail>;
  /** An aggregate relationship */
  remittanceClaimDetails_aggregate: RemittanceClaimDetail_Aggregate;
  remittanceNumber: Scalars['Int'];
  /** An array relationship */
  remittancePayments: Array<RemittancePayment>;
  /** An aggregate relationship */
  remittancePayments_aggregate: RemittancePayment_Aggregate;
  /** An array relationship */
  remittancePolicyContracts: Array<RemittancePolicyContract>;
  /** An aggregate relationship */
  remittancePolicyContracts_aggregate: RemittancePolicyContract_Aggregate;
  /** An object relationship */
  remittanceStatusType: RemittanceStatusType;
  remittanceStatusTypeId: Scalars['uuid'];
  /** An object relationship */
  remittanceType: RemittanceType;
  remittanceTypeId: Scalars['uuid'];
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "operations.remittance" */
export type RemittanceAccountMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceBillingMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceCategoryMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceEntityRemittanceDetailsArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceEntityRemittanceDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceRemittanceClaimDetailsArgs = {
  distinct_on?: InputMaybe<Array<RemittanceClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceClaimDetail_Order_By>>;
  where?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceRemittanceClaimDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittanceClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceClaimDetail_Order_By>>;
  where?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceRemittancePaymentsArgs = {
  distinct_on?: InputMaybe<Array<RemittancePayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePayment_Order_By>>;
  where?: InputMaybe<RemittancePayment_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceRemittancePayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePayment_Order_By>>;
  where?: InputMaybe<RemittancePayment_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceRemittancePolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContract_Order_By>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};


/** columns and relationships of "operations.remittance" */
export type RemittanceRemittancePolicyContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContract_Order_By>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};

/** columns and relationships of "claims.remittance_claim_detail" */
export type RemittanceClaimDetail = {
  __typename?: 'remittanceClaimDetail';
  /** An object relationship */
  claimDetail?: Maybe<ClaimDetail>;
  claimDetailId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isActive?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An array relationship */
  paymentDetails: Array<PaymentDetail>;
  /** An aggregate relationship */
  paymentDetails_aggregate: PaymentDetail_Aggregate;
  remitAmount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  remittance?: Maybe<Remittance>;
  remittanceId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "claims.remittance_claim_detail" */
export type RemittanceClaimDetailLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.remittance_claim_detail" */
export type RemittanceClaimDetailLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.remittance_claim_detail" */
export type RemittanceClaimDetailPaymentDetailsArgs = {
  distinct_on?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentDetail_Order_By>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};


/** columns and relationships of "claims.remittance_claim_detail" */
export type RemittanceClaimDetailPaymentDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentDetail_Order_By>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};

/** aggregated selection of "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Aggregate = {
  __typename?: 'remittanceClaimDetail_aggregate';
  aggregate?: Maybe<RemittanceClaimDetail_Aggregate_Fields>;
  nodes: Array<RemittanceClaimDetail>;
};

export type RemittanceClaimDetail_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<RemittanceClaimDetail_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<RemittanceClaimDetail_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<RemittanceClaimDetail_Aggregate_Bool_Exp_Count>;
};

export type RemittanceClaimDetail_Aggregate_Bool_Exp_Bool_And = {
  arguments: RemittanceClaimDetail_Select_Column_RemittanceClaimDetail_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type RemittanceClaimDetail_Aggregate_Bool_Exp_Bool_Or = {
  arguments: RemittanceClaimDetail_Select_Column_RemittanceClaimDetail_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type RemittanceClaimDetail_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RemittanceClaimDetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Aggregate_Fields = {
  __typename?: 'remittanceClaimDetail_aggregate_fields';
  avg?: Maybe<RemittanceClaimDetail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RemittanceClaimDetail_Max_Fields>;
  min?: Maybe<RemittanceClaimDetail_Min_Fields>;
  stddev?: Maybe<RemittanceClaimDetail_Stddev_Fields>;
  stddev_pop?: Maybe<RemittanceClaimDetail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RemittanceClaimDetail_Stddev_Samp_Fields>;
  sum?: Maybe<RemittanceClaimDetail_Sum_Fields>;
  var_pop?: Maybe<RemittanceClaimDetail_Var_Pop_Fields>;
  var_samp?: Maybe<RemittanceClaimDetail_Var_Samp_Fields>;
  variance?: Maybe<RemittanceClaimDetail_Variance_Fields>;
};


/** aggregate fields of "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RemittanceClaimDetail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Aggregate_Order_By = {
  avg?: InputMaybe<RemittanceClaimDetail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RemittanceClaimDetail_Max_Order_By>;
  min?: InputMaybe<RemittanceClaimDetail_Min_Order_By>;
  stddev?: InputMaybe<RemittanceClaimDetail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RemittanceClaimDetail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RemittanceClaimDetail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RemittanceClaimDetail_Sum_Order_By>;
  var_pop?: InputMaybe<RemittanceClaimDetail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RemittanceClaimDetail_Var_Samp_Order_By>;
  variance?: InputMaybe<RemittanceClaimDetail_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Arr_Rel_Insert_Input = {
  data: Array<RemittanceClaimDetail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RemittanceClaimDetail_On_Conflict>;
};

/** aggregate avg on columns */
export type RemittanceClaimDetail_Avg_Fields = {
  __typename?: 'remittanceClaimDetail_avg_fields';
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Avg_Order_By = {
  remitAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "claims.remittance_claim_detail". All fields are combined with a logical 'AND'. */
export type RemittanceClaimDetail_Bool_Exp = {
  _and?: InputMaybe<Array<RemittanceClaimDetail_Bool_Exp>>;
  _not?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
  _or?: InputMaybe<Array<RemittanceClaimDetail_Bool_Exp>>;
  claimDetail?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimDetailId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  paymentDetails?: InputMaybe<PaymentDetail_Bool_Exp>;
  paymentDetails_aggregate?: InputMaybe<PaymentDetail_Aggregate_Bool_Exp>;
  remitAmount?: InputMaybe<Numeric_Comparison_Exp>;
  remittance?: InputMaybe<Remittance_Bool_Exp>;
  remittanceId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.remittance_claim_detail" */
export enum RemittanceClaimDetail_Constraint {
  /** unique or primary key constraint on columns "id" */
  RemittanceClaimDetailPkey = 'remittance_claim_detail_pkey'
}

/** input type for incrementing numeric columns in table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Inc_Input = {
  remitAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Insert_Input = {
  claimDetail?: InputMaybe<ClaimDetail_Obj_Rel_Insert_Input>;
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  paymentDetails?: InputMaybe<PaymentDetail_Arr_Rel_Insert_Input>;
  remitAmount?: InputMaybe<Scalars['numeric']>;
  remittance?: InputMaybe<Remittance_Obj_Rel_Insert_Input>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RemittanceClaimDetail_Max_Fields = {
  __typename?: 'remittanceClaimDetail_max_fields';
  claimDetailId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  remitAmount?: Maybe<Scalars['numeric']>;
  remittanceId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Max_Order_By = {
  claimDetailId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remitAmount?: InputMaybe<Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RemittanceClaimDetail_Min_Fields = {
  __typename?: 'remittanceClaimDetail_min_fields';
  claimDetailId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  remitAmount?: Maybe<Scalars['numeric']>;
  remittanceId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Min_Order_By = {
  claimDetailId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remitAmount?: InputMaybe<Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Mutation_Response = {
  __typename?: 'remittanceClaimDetail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RemittanceClaimDetail>;
};

/** input type for inserting object relation for remote table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Obj_Rel_Insert_Input = {
  data: RemittanceClaimDetail_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RemittanceClaimDetail_On_Conflict>;
};

/** on_conflict condition type for table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_On_Conflict = {
  constraint: RemittanceClaimDetail_Constraint;
  update_columns?: Array<RemittanceClaimDetail_Update_Column>;
  where?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.remittance_claim_detail". */
export type RemittanceClaimDetail_Order_By = {
  claimDetail?: InputMaybe<ClaimDetail_Order_By>;
  claimDetailId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  paymentDetails_aggregate?: InputMaybe<PaymentDetail_Aggregate_Order_By>;
  remitAmount?: InputMaybe<Order_By>;
  remittance?: InputMaybe<Remittance_Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.remittance_claim_detail */
export type RemittanceClaimDetail_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.remittance_claim_detail" */
export enum RemittanceClaimDetail_Select_Column {
  /** column name */
  ClaimDetailId = 'claimDetailId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  RemitAmount = 'remitAmount',
  /** column name */
  RemittanceId = 'remittanceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "remittanceClaimDetail_aggregate_bool_exp_bool_and_arguments_columns" columns of table "claims.remittance_claim_detail" */
export enum RemittanceClaimDetail_Select_Column_RemittanceClaimDetail_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** select "remittanceClaimDetail_aggregate_bool_exp_bool_or_arguments_columns" columns of table "claims.remittance_claim_detail" */
export enum RemittanceClaimDetail_Select_Column_RemittanceClaimDetail_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Set_Input = {
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  remitAmount?: InputMaybe<Scalars['numeric']>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type RemittanceClaimDetail_Stddev_Fields = {
  __typename?: 'remittanceClaimDetail_stddev_fields';
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Stddev_Order_By = {
  remitAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type RemittanceClaimDetail_Stddev_Pop_Fields = {
  __typename?: 'remittanceClaimDetail_stddev_pop_fields';
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Stddev_Pop_Order_By = {
  remitAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type RemittanceClaimDetail_Stddev_Samp_Fields = {
  __typename?: 'remittanceClaimDetail_stddev_samp_fields';
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Stddev_Samp_Order_By = {
  remitAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "remittanceClaimDetail" */
export type RemittanceClaimDetail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RemittanceClaimDetail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RemittanceClaimDetail_Stream_Cursor_Value_Input = {
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  remitAmount?: InputMaybe<Scalars['numeric']>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type RemittanceClaimDetail_Sum_Fields = {
  __typename?: 'remittanceClaimDetail_sum_fields';
  remitAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Sum_Order_By = {
  remitAmount?: InputMaybe<Order_By>;
};

/** update columns of table "claims.remittance_claim_detail" */
export enum RemittanceClaimDetail_Update_Column {
  /** column name */
  ClaimDetailId = 'claimDetailId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  RemitAmount = 'remitAmount',
  /** column name */
  RemittanceId = 'remittanceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RemittanceClaimDetail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RemittanceClaimDetail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RemittanceClaimDetail_Set_Input>;
  /** filter the rows which have to be updated */
  where: RemittanceClaimDetail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RemittanceClaimDetail_Var_Pop_Fields = {
  __typename?: 'remittanceClaimDetail_var_pop_fields';
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Var_Pop_Order_By = {
  remitAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type RemittanceClaimDetail_Var_Samp_Fields = {
  __typename?: 'remittanceClaimDetail_var_samp_fields';
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Var_Samp_Order_By = {
  remitAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type RemittanceClaimDetail_Variance_Fields = {
  __typename?: 'remittanceClaimDetail_variance_fields';
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "claims.remittance_claim_detail" */
export type RemittanceClaimDetail_Variance_Order_By = {
  remitAmount?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations.remittance_payment" */
export type RemittancePayment = {
  __typename?: 'remittancePayment';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  payment: Payment;
  paymentId: Scalars['uuid'];
  /** An object relationship */
  remittance: Remittance;
  remittanceId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "operations.remittance_payment" */
export type RemittancePaymentLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.remittance_payment" */
export type RemittancePaymentLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "operations.remittance_payment" */
export type RemittancePayment_Aggregate = {
  __typename?: 'remittancePayment_aggregate';
  aggregate?: Maybe<RemittancePayment_Aggregate_Fields>;
  nodes: Array<RemittancePayment>;
};

export type RemittancePayment_Aggregate_Bool_Exp = {
  count?: InputMaybe<RemittancePayment_Aggregate_Bool_Exp_Count>;
};

export type RemittancePayment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RemittancePayment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RemittancePayment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.remittance_payment" */
export type RemittancePayment_Aggregate_Fields = {
  __typename?: 'remittancePayment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<RemittancePayment_Max_Fields>;
  min?: Maybe<RemittancePayment_Min_Fields>;
};


/** aggregate fields of "operations.remittance_payment" */
export type RemittancePayment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RemittancePayment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.remittance_payment" */
export type RemittancePayment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RemittancePayment_Max_Order_By>;
  min?: InputMaybe<RemittancePayment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "operations.remittance_payment" */
export type RemittancePayment_Arr_Rel_Insert_Input = {
  data: Array<RemittancePayment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RemittancePayment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "operations.remittance_payment". All fields are combined with a logical 'AND'. */
export type RemittancePayment_Bool_Exp = {
  _and?: InputMaybe<Array<RemittancePayment_Bool_Exp>>;
  _not?: InputMaybe<RemittancePayment_Bool_Exp>;
  _or?: InputMaybe<Array<RemittancePayment_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  payment?: InputMaybe<Payment_Bool_Exp>;
  paymentId?: InputMaybe<Uuid_Comparison_Exp>;
  remittance?: InputMaybe<Remittance_Bool_Exp>;
  remittanceId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.remittance_payment" */
export enum RemittancePayment_Constraint {
  /** unique or primary key constraint on columns "id" */
  RemittancePaymentPkey = 'remittance_payment_pkey',
  /** unique or primary key constraint on columns "payment_id", "remittance_id" */
  RemittancePaymentRemittanceIdPaymentIdKey = 'remittance_payment_remittance_id_payment_id_key'
}

/** input type for inserting data into table "operations.remittance_payment" */
export type RemittancePayment_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  payment?: InputMaybe<Payment_Obj_Rel_Insert_Input>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  remittance?: InputMaybe<Remittance_Obj_Rel_Insert_Input>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RemittancePayment_Max_Fields = {
  __typename?: 'remittancePayment_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  paymentId?: Maybe<Scalars['uuid']>;
  remittanceId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.remittance_payment" */
export type RemittancePayment_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RemittancePayment_Min_Fields = {
  __typename?: 'remittancePayment_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  paymentId?: Maybe<Scalars['uuid']>;
  remittanceId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.remittance_payment" */
export type RemittancePayment_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.remittance_payment" */
export type RemittancePayment_Mutation_Response = {
  __typename?: 'remittancePayment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RemittancePayment>;
};

/** on_conflict condition type for table "operations.remittance_payment" */
export type RemittancePayment_On_Conflict = {
  constraint: RemittancePayment_Constraint;
  update_columns?: Array<RemittancePayment_Update_Column>;
  where?: InputMaybe<RemittancePayment_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.remittance_payment". */
export type RemittancePayment_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  payment?: InputMaybe<Payment_Order_By>;
  paymentId?: InputMaybe<Order_By>;
  remittance?: InputMaybe<Remittance_Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.remittance_payment */
export type RemittancePayment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.remittance_payment" */
export enum RemittancePayment_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  RemittanceId = 'remittanceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.remittance_payment" */
export type RemittancePayment_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "remittancePayment" */
export type RemittancePayment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RemittancePayment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RemittancePayment_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "operations.remittance_payment" */
export enum RemittancePayment_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  RemittanceId = 'remittanceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RemittancePayment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RemittancePayment_Set_Input>;
  /** filter the rows which have to be updated */
  where: RemittancePayment_Bool_Exp;
};

/** columns and relationships of "operations.remittance_policy_contract" */
export type RemittancePolicyContract = {
  __typename?: 'remittancePolicyContract';
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  entityRemittanceDetails: Array<EntityRemittanceDetail>;
  /** An aggregate relationship */
  entityRemittanceDetails_aggregate: EntityRemittanceDetail_Aggregate;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  /** An object relationship */
  legacyPolicyContract?: Maybe<LegacyPolicyContract>;
  legacyPolicyContractId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An array relationship */
  paymentDetails: Array<PaymentDetail>;
  /** An aggregate relationship */
  paymentDetails_aggregate: PaymentDetail_Aggregate;
  /** An object relationship */
  policyContract?: Maybe<PolicyContract>;
  policyContractId?: Maybe<Scalars['uuid']>;
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount: Scalars['numeric'];
  /** An object relationship */
  remittance: Remittance;
  remittanceId: Scalars['uuid'];
  /** An object relationship */
  remittancePolicyContractAs400?: Maybe<RemittancePolicyContractAs400>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "operations.remittance_policy_contract" */
export type RemittancePolicyContractEntityRemittanceDetailsArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


/** columns and relationships of "operations.remittance_policy_contract" */
export type RemittancePolicyContractEntityRemittanceDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


/** columns and relationships of "operations.remittance_policy_contract" */
export type RemittancePolicyContractLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.remittance_policy_contract" */
export type RemittancePolicyContractLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "operations.remittance_policy_contract" */
export type RemittancePolicyContractPaymentDetailsArgs = {
  distinct_on?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentDetail_Order_By>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};


/** columns and relationships of "operations.remittance_policy_contract" */
export type RemittancePolicyContractPaymentDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentDetail_Order_By>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};

/** columns and relationships of "operations.remittance_policy_contract_as400" */
export type RemittancePolicyContractAs400 = {
  __typename?: 'remittancePolicyContractAs400';
  batchNumber: Scalars['String'];
  checkNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  existsInAs400: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  paymentDetail?: Maybe<PaymentDetail>;
  payment_detail_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  remittancePolicyContract: RemittancePolicyContract;
  remittancePolicyContractId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "operations.remittance_policy_contract_as400" */
export type RemittancePolicyContractAs400_Aggregate = {
  __typename?: 'remittancePolicyContractAs400_aggregate';
  aggregate?: Maybe<RemittancePolicyContractAs400_Aggregate_Fields>;
  nodes: Array<RemittancePolicyContractAs400>;
};

/** aggregate fields of "operations.remittance_policy_contract_as400" */
export type RemittancePolicyContractAs400_Aggregate_Fields = {
  __typename?: 'remittancePolicyContractAs400_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<RemittancePolicyContractAs400_Max_Fields>;
  min?: Maybe<RemittancePolicyContractAs400_Min_Fields>;
};


/** aggregate fields of "operations.remittance_policy_contract_as400" */
export type RemittancePolicyContractAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RemittancePolicyContractAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "operations.remittance_policy_contract_as400". All fields are combined with a logical 'AND'. */
export type RemittancePolicyContractAs400_Bool_Exp = {
  _and?: InputMaybe<Array<RemittancePolicyContractAs400_Bool_Exp>>;
  _not?: InputMaybe<RemittancePolicyContractAs400_Bool_Exp>;
  _or?: InputMaybe<Array<RemittancePolicyContractAs400_Bool_Exp>>;
  batchNumber?: InputMaybe<String_Comparison_Exp>;
  checkNumber?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  existsInAs400?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  paymentDetail?: InputMaybe<PaymentDetail_Bool_Exp>;
  payment_detail_id?: InputMaybe<Uuid_Comparison_Exp>;
  remittancePolicyContract?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
  remittancePolicyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.remittance_policy_contract_as400" */
export enum RemittancePolicyContractAs400_Constraint {
  /** unique or primary key constraint on columns "id" */
  RemittancePolicyContractAs400Pkey = 'remittance_policy_contract_as400_pkey',
  /** unique or primary key constraint on columns "remittance_policy_contract_id", "payment_detail_id" */
  RemittancePolicyContractAs400UniqueKey = 'remittance_policy_contract_as400_unique_key'
}

/** input type for inserting data into table "operations.remittance_policy_contract_as400" */
export type RemittancePolicyContractAs400_Insert_Input = {
  batchNumber?: InputMaybe<Scalars['String']>;
  checkNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  paymentDetail?: InputMaybe<PaymentDetail_Obj_Rel_Insert_Input>;
  payment_detail_id?: InputMaybe<Scalars['uuid']>;
  remittancePolicyContract?: InputMaybe<RemittancePolicyContract_Obj_Rel_Insert_Input>;
  remittancePolicyContractId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RemittancePolicyContractAs400_Max_Fields = {
  __typename?: 'remittancePolicyContractAs400_max_fields';
  batchNumber?: Maybe<Scalars['String']>;
  checkNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  payment_detail_id?: Maybe<Scalars['uuid']>;
  remittancePolicyContractId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type RemittancePolicyContractAs400_Min_Fields = {
  __typename?: 'remittancePolicyContractAs400_min_fields';
  batchNumber?: Maybe<Scalars['String']>;
  checkNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  payment_detail_id?: Maybe<Scalars['uuid']>;
  remittancePolicyContractId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "operations.remittance_policy_contract_as400" */
export type RemittancePolicyContractAs400_Mutation_Response = {
  __typename?: 'remittancePolicyContractAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RemittancePolicyContractAs400>;
};

/** input type for inserting object relation for remote table "operations.remittance_policy_contract_as400" */
export type RemittancePolicyContractAs400_Obj_Rel_Insert_Input = {
  data: RemittancePolicyContractAs400_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RemittancePolicyContractAs400_On_Conflict>;
};

/** on_conflict condition type for table "operations.remittance_policy_contract_as400" */
export type RemittancePolicyContractAs400_On_Conflict = {
  constraint: RemittancePolicyContractAs400_Constraint;
  update_columns?: Array<RemittancePolicyContractAs400_Update_Column>;
  where?: InputMaybe<RemittancePolicyContractAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.remittance_policy_contract_as400". */
export type RemittancePolicyContractAs400_Order_By = {
  batchNumber?: InputMaybe<Order_By>;
  checkNumber?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  existsInAs400?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paymentDetail?: InputMaybe<PaymentDetail_Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  remittancePolicyContract?: InputMaybe<RemittancePolicyContract_Order_By>;
  remittancePolicyContractId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.remittance_policy_contract_as400 */
export type RemittancePolicyContractAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.remittance_policy_contract_as400" */
export enum RemittancePolicyContractAs400_Select_Column {
  /** column name */
  BatchNumber = 'batchNumber',
  /** column name */
  CheckNumber = 'checkNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDetailId = 'payment_detail_id',
  /** column name */
  RemittancePolicyContractId = 'remittancePolicyContractId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.remittance_policy_contract_as400" */
export type RemittancePolicyContractAs400_Set_Input = {
  batchNumber?: InputMaybe<Scalars['String']>;
  checkNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  payment_detail_id?: InputMaybe<Scalars['uuid']>;
  remittancePolicyContractId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "remittancePolicyContractAs400" */
export type RemittancePolicyContractAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RemittancePolicyContractAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RemittancePolicyContractAs400_Stream_Cursor_Value_Input = {
  batchNumber?: InputMaybe<Scalars['String']>;
  checkNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  existsInAs400?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  payment_detail_id?: InputMaybe<Scalars['uuid']>;
  remittancePolicyContractId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "operations.remittance_policy_contract_as400" */
export enum RemittancePolicyContractAs400_Update_Column {
  /** column name */
  BatchNumber = 'batchNumber',
  /** column name */
  CheckNumber = 'checkNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExistsInAs400 = 'existsInAs400',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDetailId = 'payment_detail_id',
  /** column name */
  RemittancePolicyContractId = 'remittancePolicyContractId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RemittancePolicyContractAs400_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RemittancePolicyContractAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: RemittancePolicyContractAs400_Bool_Exp;
};

/** aggregated selection of "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Aggregate = {
  __typename?: 'remittancePolicyContract_aggregate';
  aggregate?: Maybe<RemittancePolicyContract_Aggregate_Fields>;
  nodes: Array<RemittancePolicyContract>;
};

export type RemittancePolicyContract_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<RemittancePolicyContract_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<RemittancePolicyContract_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<RemittancePolicyContract_Aggregate_Bool_Exp_Count>;
};

export type RemittancePolicyContract_Aggregate_Bool_Exp_Bool_And = {
  arguments: RemittancePolicyContract_Select_Column_RemittancePolicyContract_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type RemittancePolicyContract_Aggregate_Bool_Exp_Bool_Or = {
  arguments: RemittancePolicyContract_Select_Column_RemittancePolicyContract_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type RemittancePolicyContract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Aggregate_Fields = {
  __typename?: 'remittancePolicyContract_aggregate_fields';
  avg?: Maybe<RemittancePolicyContract_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RemittancePolicyContract_Max_Fields>;
  min?: Maybe<RemittancePolicyContract_Min_Fields>;
  stddev?: Maybe<RemittancePolicyContract_Stddev_Fields>;
  stddev_pop?: Maybe<RemittancePolicyContract_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RemittancePolicyContract_Stddev_Samp_Fields>;
  sum?: Maybe<RemittancePolicyContract_Sum_Fields>;
  var_pop?: Maybe<RemittancePolicyContract_Var_Pop_Fields>;
  var_samp?: Maybe<RemittancePolicyContract_Var_Samp_Fields>;
  variance?: Maybe<RemittancePolicyContract_Variance_Fields>;
};


/** aggregate fields of "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Aggregate_Order_By = {
  avg?: InputMaybe<RemittancePolicyContract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RemittancePolicyContract_Max_Order_By>;
  min?: InputMaybe<RemittancePolicyContract_Min_Order_By>;
  stddev?: InputMaybe<RemittancePolicyContract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RemittancePolicyContract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RemittancePolicyContract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RemittancePolicyContract_Sum_Order_By>;
  var_pop?: InputMaybe<RemittancePolicyContract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RemittancePolicyContract_Var_Samp_Order_By>;
  variance?: InputMaybe<RemittancePolicyContract_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Arr_Rel_Insert_Input = {
  data: Array<RemittancePolicyContract_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RemittancePolicyContract_On_Conflict>;
};

/** aggregate avg on columns */
export type RemittancePolicyContract_Avg_Fields = {
  __typename?: 'remittancePolicyContract_avg_fields';
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Avg_Order_By = {
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations.remittance_policy_contract". All fields are combined with a logical 'AND'. */
export type RemittancePolicyContract_Bool_Exp = {
  _and?: InputMaybe<Array<RemittancePolicyContract_Bool_Exp>>;
  _not?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
  _or?: InputMaybe<Array<RemittancePolicyContract_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityRemittanceDetails?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
  entityRemittanceDetails_aggregate?: InputMaybe<EntityRemittanceDetail_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
  legacyPolicyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  paymentDetails?: InputMaybe<PaymentDetail_Bool_Exp>;
  paymentDetails_aggregate?: InputMaybe<PaymentDetail_Aggregate_Bool_Exp>;
  policyContract?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContractId?: InputMaybe<Uuid_Comparison_Exp>;
  remitAmount?: InputMaybe<Numeric_Comparison_Exp>;
  remittance?: InputMaybe<Remittance_Bool_Exp>;
  remittanceId?: InputMaybe<Uuid_Comparison_Exp>;
  remittancePolicyContractAs400?: InputMaybe<RemittancePolicyContractAs400_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.remittance_policy_contract" */
export enum RemittancePolicyContract_Constraint {
  /** unique or primary key constraint on columns "id" */
  RemittancePolicyContractPkey = 'remittance_policy_contract_pkey'
}

/** input type for incrementing numeric columns in table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Inc_Input = {
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityRemittanceDetails?: InputMaybe<EntityRemittanceDetail_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Obj_Rel_Insert_Input>;
  legacyPolicyContractId?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  paymentDetails?: InputMaybe<PaymentDetail_Arr_Rel_Insert_Input>;
  policyContract?: InputMaybe<PolicyContract_Obj_Rel_Insert_Input>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Scalars['numeric']>;
  remittance?: InputMaybe<Remittance_Obj_Rel_Insert_Input>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  remittancePolicyContractAs400?: InputMaybe<RemittancePolicyContractAs400_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RemittancePolicyContract_Max_Fields = {
  __typename?: 'remittancePolicyContract_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  legacyPolicyContractId?: Maybe<Scalars['uuid']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: Maybe<Scalars['numeric']>;
  remittanceId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyPolicyContractId?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RemittancePolicyContract_Min_Fields = {
  __typename?: 'remittancePolicyContract_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  legacyPolicyContractId?: Maybe<Scalars['uuid']>;
  policyContractId?: Maybe<Scalars['uuid']>;
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: Maybe<Scalars['numeric']>;
  remittanceId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyPolicyContractId?: InputMaybe<Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Mutation_Response = {
  __typename?: 'remittancePolicyContract_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RemittancePolicyContract>;
};

/** input type for inserting object relation for remote table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Obj_Rel_Insert_Input = {
  data: RemittancePolicyContract_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RemittancePolicyContract_On_Conflict>;
};

/** on_conflict condition type for table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_On_Conflict = {
  constraint: RemittancePolicyContract_Constraint;
  update_columns?: Array<RemittancePolicyContract_Update_Column>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.remittance_policy_contract". */
export type RemittancePolicyContract_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  entityRemittanceDetails_aggregate?: InputMaybe<EntityRemittanceDetail_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  legacyPolicyContract?: InputMaybe<LegacyPolicyContract_Order_By>;
  legacyPolicyContractId?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  paymentDetails_aggregate?: InputMaybe<PaymentDetail_Aggregate_Order_By>;
  policyContract?: InputMaybe<PolicyContract_Order_By>;
  policyContractId?: InputMaybe<Order_By>;
  remitAmount?: InputMaybe<Order_By>;
  remittance?: InputMaybe<Remittance_Order_By>;
  remittanceId?: InputMaybe<Order_By>;
  remittancePolicyContractAs400?: InputMaybe<RemittancePolicyContractAs400_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.remittance_policy_contract */
export type RemittancePolicyContract_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.remittance_policy_contract" */
export enum RemittancePolicyContract_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  LegacyPolicyContractId = 'legacyPolicyContractId',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  RemitAmount = 'remitAmount',
  /** column name */
  RemittanceId = 'remittanceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "remittancePolicyContract_aggregate_bool_exp_bool_and_arguments_columns" columns of table "operations.remittance_policy_contract" */
export enum RemittancePolicyContract_Select_Column_RemittancePolicyContract_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** select "remittancePolicyContract_aggregate_bool_exp_bool_or_arguments_columns" columns of table "operations.remittance_policy_contract" */
export enum RemittancePolicyContract_Select_Column_RemittancePolicyContract_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  legacyPolicyContractId?: InputMaybe<Scalars['uuid']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Scalars['numeric']>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type RemittancePolicyContract_Stddev_Fields = {
  __typename?: 'remittancePolicyContract_stddev_fields';
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Stddev_Order_By = {
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type RemittancePolicyContract_Stddev_Pop_Fields = {
  __typename?: 'remittancePolicyContract_stddev_pop_fields';
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Stddev_Pop_Order_By = {
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type RemittancePolicyContract_Stddev_Samp_Fields = {
  __typename?: 'remittancePolicyContract_stddev_samp_fields';
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Stddev_Samp_Order_By = {
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "remittancePolicyContract" */
export type RemittancePolicyContract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RemittancePolicyContract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RemittancePolicyContract_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  legacyPolicyContractId?: InputMaybe<Scalars['uuid']>;
  policyContractId?: InputMaybe<Scalars['uuid']>;
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Scalars['numeric']>;
  remittanceId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type RemittancePolicyContract_Sum_Fields = {
  __typename?: 'remittancePolicyContract_sum_fields';
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Sum_Order_By = {
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Order_By>;
};

/** update columns of table "operations.remittance_policy_contract" */
export enum RemittancePolicyContract_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  LegacyPolicyContractId = 'legacyPolicyContractId',
  /** column name */
  PolicyContractId = 'policyContractId',
  /** column name */
  RemitAmount = 'remitAmount',
  /** column name */
  RemittanceId = 'remittanceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RemittancePolicyContract_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RemittancePolicyContract_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RemittancePolicyContract_Set_Input>;
  /** filter the rows which have to be updated */
  where: RemittancePolicyContract_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RemittancePolicyContract_Var_Pop_Fields = {
  __typename?: 'remittancePolicyContract_var_pop_fields';
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Var_Pop_Order_By = {
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type RemittancePolicyContract_Var_Samp_Fields = {
  __typename?: 'remittancePolicyContract_var_samp_fields';
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Var_Samp_Order_By = {
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type RemittancePolicyContract_Variance_Fields = {
  __typename?: 'remittancePolicyContract_variance_fields';
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations.remittance_policy_contract" */
export type RemittancePolicyContract_Variance_Order_By = {
  /**
   * What was billed on this remittance line at the time it was raised -- NOT what the contract owes, and never the figure a contract is settled against.
   *
   * Account remittance: the dealer cost plus any add-on the dealer or agent asked us to collect on their behalf. That add-on is not part of the contract (usually the agent collects it directly; if it does reach us we pay it back out), so it never settles the contract.
   * Customer (MBPI-financed) remittance: the lender down payment, which has no relationship to dealer cost. Here the remitted amount IS what settles the contract.
   *
   * A historical snapshot, stamped at remittance time by RemittanceServiceQueries.RemitPolicyContracts and never recomputed -- a surcharge added afterwards raises the dealer cost but not this value. It remains the record of what was remitted.
   *
   * The amount a contract is settled against is the settlement basis: for an Account remittance, COALESCE(cost_metadata->>'remittanceOverrideAmount', dealer_cost) on operations.policy_contract_cost_detail, excluding cost_metadata->>'remittanceCostMarkupAmount'; for a Customer remittance, this column. Falls back to this column when cost detail is missing, so nothing settles for free. See ADR 0009 in docs/adr/.
   */
  remitAmount?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations.remittance_status_type" */
export type RemittanceStatusType = {
  __typename?: 'remittanceStatusType';
  display: Scalars['String'];
  enumValue?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  remittances: Array<Remittance>;
  /** An aggregate relationship */
  remittances_aggregate: Remittance_Aggregate;
};


/** columns and relationships of "operations.remittance_status_type" */
export type RemittanceStatusTypeRemittancesArgs = {
  distinct_on?: InputMaybe<Array<Remittance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Remittance_Order_By>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};


/** columns and relationships of "operations.remittance_status_type" */
export type RemittanceStatusTypeRemittances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Remittance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Remittance_Order_By>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};

/** aggregated selection of "operations.remittance_status_type" */
export type RemittanceStatusType_Aggregate = {
  __typename?: 'remittanceStatusType_aggregate';
  aggregate?: Maybe<RemittanceStatusType_Aggregate_Fields>;
  nodes: Array<RemittanceStatusType>;
};

/** aggregate fields of "operations.remittance_status_type" */
export type RemittanceStatusType_Aggregate_Fields = {
  __typename?: 'remittanceStatusType_aggregate_fields';
  avg?: Maybe<RemittanceStatusType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RemittanceStatusType_Max_Fields>;
  min?: Maybe<RemittanceStatusType_Min_Fields>;
  stddev?: Maybe<RemittanceStatusType_Stddev_Fields>;
  stddev_pop?: Maybe<RemittanceStatusType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RemittanceStatusType_Stddev_Samp_Fields>;
  sum?: Maybe<RemittanceStatusType_Sum_Fields>;
  var_pop?: Maybe<RemittanceStatusType_Var_Pop_Fields>;
  var_samp?: Maybe<RemittanceStatusType_Var_Samp_Fields>;
  variance?: Maybe<RemittanceStatusType_Variance_Fields>;
};


/** aggregate fields of "operations.remittance_status_type" */
export type RemittanceStatusType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RemittanceStatusType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RemittanceStatusType_Avg_Fields = {
  __typename?: 'remittanceStatusType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.remittance_status_type". All fields are combined with a logical 'AND'. */
export type RemittanceStatusType_Bool_Exp = {
  _and?: InputMaybe<Array<RemittanceStatusType_Bool_Exp>>;
  _not?: InputMaybe<RemittanceStatusType_Bool_Exp>;
  _or?: InputMaybe<Array<RemittanceStatusType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  remittances?: InputMaybe<Remittance_Bool_Exp>;
  remittances_aggregate?: InputMaybe<Remittance_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "operations.remittance_status_type" */
export enum RemittanceStatusType_Constraint {
  /** unique or primary key constraint on columns "id" */
  RemittanceStatusTypePkey = 'remittance_status_type_pkey'
}

/** input type for incrementing numeric columns in table "operations.remittance_status_type" */
export type RemittanceStatusType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.remittance_status_type" */
export type RemittanceStatusType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  remittances?: InputMaybe<Remittance_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type RemittanceStatusType_Max_Fields = {
  __typename?: 'remittanceStatusType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RemittanceStatusType_Min_Fields = {
  __typename?: 'remittanceStatusType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "operations.remittance_status_type" */
export type RemittanceStatusType_Mutation_Response = {
  __typename?: 'remittanceStatusType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RemittanceStatusType>;
};

/** input type for inserting object relation for remote table "operations.remittance_status_type" */
export type RemittanceStatusType_Obj_Rel_Insert_Input = {
  data: RemittanceStatusType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RemittanceStatusType_On_Conflict>;
};

/** on_conflict condition type for table "operations.remittance_status_type" */
export type RemittanceStatusType_On_Conflict = {
  constraint: RemittanceStatusType_Constraint;
  update_columns?: Array<RemittanceStatusType_Update_Column>;
  where?: InputMaybe<RemittanceStatusType_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.remittance_status_type". */
export type RemittanceStatusType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remittances_aggregate?: InputMaybe<Remittance_Aggregate_Order_By>;
};

/** primary key columns input for table: operations.remittance_status_type */
export type RemittanceStatusType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.remittance_status_type" */
export enum RemittanceStatusType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "operations.remittance_status_type" */
export type RemittanceStatusType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RemittanceStatusType_Stddev_Fields = {
  __typename?: 'remittanceStatusType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RemittanceStatusType_Stddev_Pop_Fields = {
  __typename?: 'remittanceStatusType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RemittanceStatusType_Stddev_Samp_Fields = {
  __typename?: 'remittanceStatusType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "remittanceStatusType" */
export type RemittanceStatusType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RemittanceStatusType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RemittanceStatusType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type RemittanceStatusType_Sum_Fields = {
  __typename?: 'remittanceStatusType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "operations.remittance_status_type" */
export enum RemittanceStatusType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type RemittanceStatusType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RemittanceStatusType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RemittanceStatusType_Set_Input>;
  /** filter the rows which have to be updated */
  where: RemittanceStatusType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RemittanceStatusType_Var_Pop_Fields = {
  __typename?: 'remittanceStatusType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RemittanceStatusType_Var_Samp_Fields = {
  __typename?: 'remittanceStatusType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RemittanceStatusType_Variance_Fields = {
  __typename?: 'remittanceStatusType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "operations.remittance_type" */
export type RemittanceType = {
  __typename?: 'remittanceType';
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  enumValue: Scalars['numeric'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  remittances: Array<Remittance>;
  /** An aggregate relationship */
  remittances_aggregate: Remittance_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "operations.remittance_type" */
export type RemittanceTypeRemittancesArgs = {
  distinct_on?: InputMaybe<Array<Remittance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Remittance_Order_By>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};


/** columns and relationships of "operations.remittance_type" */
export type RemittanceTypeRemittances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Remittance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Remittance_Order_By>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};

/** aggregated selection of "operations.remittance_type" */
export type RemittanceType_Aggregate = {
  __typename?: 'remittanceType_aggregate';
  aggregate?: Maybe<RemittanceType_Aggregate_Fields>;
  nodes: Array<RemittanceType>;
};

/** aggregate fields of "operations.remittance_type" */
export type RemittanceType_Aggregate_Fields = {
  __typename?: 'remittanceType_aggregate_fields';
  avg?: Maybe<RemittanceType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RemittanceType_Max_Fields>;
  min?: Maybe<RemittanceType_Min_Fields>;
  stddev?: Maybe<RemittanceType_Stddev_Fields>;
  stddev_pop?: Maybe<RemittanceType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RemittanceType_Stddev_Samp_Fields>;
  sum?: Maybe<RemittanceType_Sum_Fields>;
  var_pop?: Maybe<RemittanceType_Var_Pop_Fields>;
  var_samp?: Maybe<RemittanceType_Var_Samp_Fields>;
  variance?: Maybe<RemittanceType_Variance_Fields>;
};


/** aggregate fields of "operations.remittance_type" */
export type RemittanceType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RemittanceType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RemittanceType_Avg_Fields = {
  __typename?: 'remittanceType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations.remittance_type". All fields are combined with a logical 'AND'. */
export type RemittanceType_Bool_Exp = {
  _and?: InputMaybe<Array<RemittanceType_Bool_Exp>>;
  _not?: InputMaybe<RemittanceType_Bool_Exp>;
  _or?: InputMaybe<Array<RemittanceType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  remittances?: InputMaybe<Remittance_Bool_Exp>;
  remittances_aggregate?: InputMaybe<Remittance_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.remittance_type" */
export enum RemittanceType_Constraint {
  /** unique or primary key constraint on columns "id" */
  RemittanceTypePkey = 'remittance_type_pkey'
}

/** input type for incrementing numeric columns in table "operations.remittance_type" */
export type RemittanceType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.remittance_type" */
export type RemittanceType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  remittances?: InputMaybe<Remittance_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RemittanceType_Max_Fields = {
  __typename?: 'remittanceType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type RemittanceType_Min_Fields = {
  __typename?: 'remittanceType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "operations.remittance_type" */
export type RemittanceType_Mutation_Response = {
  __typename?: 'remittanceType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RemittanceType>;
};

/** input type for inserting object relation for remote table "operations.remittance_type" */
export type RemittanceType_Obj_Rel_Insert_Input = {
  data: RemittanceType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RemittanceType_On_Conflict>;
};

/** on_conflict condition type for table "operations.remittance_type" */
export type RemittanceType_On_Conflict = {
  constraint: RemittanceType_Constraint;
  update_columns?: Array<RemittanceType_Update_Column>;
  where?: InputMaybe<RemittanceType_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.remittance_type". */
export type RemittanceType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remittances_aggregate?: InputMaybe<Remittance_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.remittance_type */
export type RemittanceType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operations.remittance_type" */
export enum RemittanceType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.remittance_type" */
export type RemittanceType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type RemittanceType_Stddev_Fields = {
  __typename?: 'remittanceType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RemittanceType_Stddev_Pop_Fields = {
  __typename?: 'remittanceType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RemittanceType_Stddev_Samp_Fields = {
  __typename?: 'remittanceType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "remittanceType" */
export type RemittanceType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RemittanceType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RemittanceType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type RemittanceType_Sum_Fields = {
  __typename?: 'remittanceType_sum_fields';
  enumValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "operations.remittance_type" */
export enum RemittanceType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RemittanceType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RemittanceType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RemittanceType_Set_Input>;
  /** filter the rows which have to be updated */
  where: RemittanceType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RemittanceType_Var_Pop_Fields = {
  __typename?: 'remittanceType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RemittanceType_Var_Samp_Fields = {
  __typename?: 'remittanceType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RemittanceType_Variance_Fields = {
  __typename?: 'remittanceType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "operations.remittance" */
export type Remittance_Aggregate = {
  __typename?: 'remittance_aggregate';
  aggregate?: Maybe<Remittance_Aggregate_Fields>;
  nodes: Array<Remittance>;
};

export type Remittance_Aggregate_Bool_Exp = {
  count?: InputMaybe<Remittance_Aggregate_Bool_Exp_Count>;
};

export type Remittance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Remittance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Remittance_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operations.remittance" */
export type Remittance_Aggregate_Fields = {
  __typename?: 'remittance_aggregate_fields';
  avg?: Maybe<Remittance_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Remittance_Max_Fields>;
  min?: Maybe<Remittance_Min_Fields>;
  stddev?: Maybe<Remittance_Stddev_Fields>;
  stddev_pop?: Maybe<Remittance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Remittance_Stddev_Samp_Fields>;
  sum?: Maybe<Remittance_Sum_Fields>;
  var_pop?: Maybe<Remittance_Var_Pop_Fields>;
  var_samp?: Maybe<Remittance_Var_Samp_Fields>;
  variance?: Maybe<Remittance_Variance_Fields>;
};


/** aggregate fields of "operations.remittance" */
export type Remittance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Remittance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operations.remittance" */
export type Remittance_Aggregate_Order_By = {
  avg?: InputMaybe<Remittance_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Remittance_Max_Order_By>;
  min?: InputMaybe<Remittance_Min_Order_By>;
  stddev?: InputMaybe<Remittance_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Remittance_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Remittance_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Remittance_Sum_Order_By>;
  var_pop?: InputMaybe<Remittance_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Remittance_Var_Samp_Order_By>;
  variance?: InputMaybe<Remittance_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Remittance_Append_Input = {
  /** Distinct {name, code} of the accounts on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.account.name/code is renamed or policy_contract.account_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  accountMetadata?: InputMaybe<Scalars['jsonb']>;
  billingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Distinct {code, name} of the categories on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.category.code/name is renamed, product.category_id is moved, or policy_contract.product_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  categoryMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "operations.remittance" */
export type Remittance_Arr_Rel_Insert_Input = {
  data: Array<Remittance_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Remittance_On_Conflict>;
};

/** aggregate avg on columns */
export type Remittance_Avg_Fields = {
  __typename?: 'remittance_avg_fields';
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: Maybe<Scalars['Float']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: Maybe<Scalars['Float']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: Maybe<Scalars['Float']>;
  remittanceNumber?: Maybe<Scalars['Float']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operations.remittance" */
export type Remittance_Avg_Order_By = {
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Order_By>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Order_By>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operations.remittance". All fields are combined with a logical 'AND'. */
export type Remittance_Bool_Exp = {
  _and?: InputMaybe<Array<Remittance_Bool_Exp>>;
  _not?: InputMaybe<Remittance_Bool_Exp>;
  _or?: InputMaybe<Array<Remittance_Bool_Exp>>;
  accountMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  billingMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  categoryMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  entityRemittanceDetails?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
  entityRemittanceDetails_aggregate?: InputMaybe<EntityRemittanceDetail_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastRecalcTrigger?: InputMaybe<Timestamptz_Comparison_Exp>;
  lineItemCount?: InputMaybe<Int_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  owedAmount?: InputMaybe<Numeric_Comparison_Exp>;
  paidAmount?: InputMaybe<Numeric_Comparison_Exp>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Bool_Exp>;
  paymentMethodTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  paymentType?: InputMaybe<String_Comparison_Exp>;
  prefixedNumber?: InputMaybe<String_Comparison_Exp>;
  remittanceClaimDetails?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
  remittanceClaimDetails_aggregate?: InputMaybe<RemittanceClaimDetail_Aggregate_Bool_Exp>;
  remittanceNumber?: InputMaybe<Int_Comparison_Exp>;
  remittancePayments?: InputMaybe<RemittancePayment_Bool_Exp>;
  remittancePayments_aggregate?: InputMaybe<RemittancePayment_Aggregate_Bool_Exp>;
  remittancePolicyContracts?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
  remittancePolicyContracts_aggregate?: InputMaybe<RemittancePolicyContract_Aggregate_Bool_Exp>;
  remittanceStatusType?: InputMaybe<RemittanceStatusType_Bool_Exp>;
  remittanceStatusTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  remittanceType?: InputMaybe<RemittanceType_Bool_Exp>;
  remittanceTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  totalAmount?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations.remittance" */
export enum Remittance_Constraint {
  /** unique or primary key constraint on columns "id" */
  RemittancePkey = 'remittance_pkey',
  /** unique or primary key constraint on columns "remittance_number" */
  RemittanceRemittanceNumberKey = 'remittance_remittance_number_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Remittance_Delete_At_Path_Input = {
  /** Distinct {name, code} of the accounts on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.account.name/code is renamed or policy_contract.account_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  accountMetadata?: InputMaybe<Array<Scalars['String']>>;
  billingMetadata?: InputMaybe<Array<Scalars['String']>>;
  /** Distinct {code, name} of the categories on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.category.code/name is renamed, product.category_id is moved, or policy_contract.product_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  categoryMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Remittance_Delete_Elem_Input = {
  /** Distinct {name, code} of the accounts on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.account.name/code is renamed or policy_contract.account_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  accountMetadata?: InputMaybe<Scalars['Int']>;
  billingMetadata?: InputMaybe<Scalars['Int']>;
  /** Distinct {code, name} of the categories on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.category.code/name is renamed, product.category_id is moved, or policy_contract.product_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  categoryMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Remittance_Delete_Key_Input = {
  /** Distinct {name, code} of the accounts on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.account.name/code is renamed or policy_contract.account_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  accountMetadata?: InputMaybe<Scalars['String']>;
  billingMetadata?: InputMaybe<Scalars['String']>;
  /** Distinct {code, name} of the categories on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.category.code/name is renamed, product.category_id is moved, or policy_contract.product_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  categoryMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "operations.remittance" */
export type Remittance_Inc_Input = {
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Scalars['Int']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Scalars['numeric']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Scalars['numeric']>;
  remittanceNumber?: InputMaybe<Scalars['Int']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "operations.remittance" */
export type Remittance_Insert_Input = {
  /** Distinct {name, code} of the accounts on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.account.name/code is renamed or policy_contract.account_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  accountMetadata?: InputMaybe<Scalars['jsonb']>;
  billingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Distinct {code, name} of the categories on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.category.code/name is renamed, product.category_id is moved, or policy_contract.product_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  categoryMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  entityRemittanceDetails?: InputMaybe<EntityRemittanceDetail_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Bumped by operations.force_recalculate_remittance so a child-row change re-fires the BEFORE trigger that recomputes this row's aggregates. Carries no business meaning. */
  lastRecalcTrigger?: InputMaybe<Scalars['timestamptz']>;
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Scalars['Int']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Scalars['numeric']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Scalars['numeric']>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Obj_Rel_Insert_Input>;
  paymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  /** Payment method type name(s) applied to this remittance, ' / '-joined. NULL when unpaid. DISPLAY SNAPSHOT, not a live value: recomputed when remittance_payment rows change, but NOT when shared.payment_method_type.name is renamed or payment.payment_method_type_id is changed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  paymentType?: InputMaybe<Scalars['String']>;
  prefixedNumber?: InputMaybe<Scalars['String']>;
  remittanceClaimDetails?: InputMaybe<RemittanceClaimDetail_Arr_Rel_Insert_Input>;
  remittanceNumber?: InputMaybe<Scalars['Int']>;
  remittancePayments?: InputMaybe<RemittancePayment_Arr_Rel_Insert_Input>;
  remittancePolicyContracts?: InputMaybe<RemittancePolicyContract_Arr_Rel_Insert_Input>;
  remittanceStatusType?: InputMaybe<RemittanceStatusType_Obj_Rel_Insert_Input>;
  remittanceStatusTypeId?: InputMaybe<Scalars['uuid']>;
  remittanceType?: InputMaybe<RemittanceType_Obj_Rel_Insert_Input>;
  remittanceTypeId?: InputMaybe<Scalars['uuid']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Remittance_Max_Fields = {
  __typename?: 'remittance_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Bumped by operations.force_recalculate_remittance so a child-row change re-fires the BEFORE trigger that recomputes this row's aggregates. Carries no business meaning. */
  lastRecalcTrigger?: Maybe<Scalars['timestamptz']>;
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: Maybe<Scalars['Int']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: Maybe<Scalars['numeric']>;
  paymentMethodTypeId?: Maybe<Scalars['uuid']>;
  /** Payment method type name(s) applied to this remittance, ' / '-joined. NULL when unpaid. DISPLAY SNAPSHOT, not a live value: recomputed when remittance_payment rows change, but NOT when shared.payment_method_type.name is renamed or payment.payment_method_type_id is changed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  paymentType?: Maybe<Scalars['String']>;
  prefixedNumber?: Maybe<Scalars['String']>;
  remittanceNumber?: Maybe<Scalars['Int']>;
  remittanceStatusTypeId?: Maybe<Scalars['uuid']>;
  remittanceTypeId?: Maybe<Scalars['uuid']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "operations.remittance" */
export type Remittance_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Bumped by operations.force_recalculate_remittance so a child-row change re-fires the BEFORE trigger that recomputes this row's aggregates. Carries no business meaning. */
  lastRecalcTrigger?: InputMaybe<Order_By>;
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Order_By>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Order_By>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Order_By>;
  paymentMethodTypeId?: InputMaybe<Order_By>;
  /** Payment method type name(s) applied to this remittance, ' / '-joined. NULL when unpaid. DISPLAY SNAPSHOT, not a live value: recomputed when remittance_payment rows change, but NOT when shared.payment_method_type.name is renamed or payment.payment_method_type_id is changed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  paymentType?: InputMaybe<Order_By>;
  prefixedNumber?: InputMaybe<Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  remittanceStatusTypeId?: InputMaybe<Order_By>;
  remittanceTypeId?: InputMaybe<Order_By>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Remittance_Min_Fields = {
  __typename?: 'remittance_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Bumped by operations.force_recalculate_remittance so a child-row change re-fires the BEFORE trigger that recomputes this row's aggregates. Carries no business meaning. */
  lastRecalcTrigger?: Maybe<Scalars['timestamptz']>;
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: Maybe<Scalars['Int']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: Maybe<Scalars['numeric']>;
  paymentMethodTypeId?: Maybe<Scalars['uuid']>;
  /** Payment method type name(s) applied to this remittance, ' / '-joined. NULL when unpaid. DISPLAY SNAPSHOT, not a live value: recomputed when remittance_payment rows change, but NOT when shared.payment_method_type.name is renamed or payment.payment_method_type_id is changed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  paymentType?: Maybe<Scalars['String']>;
  prefixedNumber?: Maybe<Scalars['String']>;
  remittanceNumber?: Maybe<Scalars['Int']>;
  remittanceStatusTypeId?: Maybe<Scalars['uuid']>;
  remittanceTypeId?: Maybe<Scalars['uuid']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "operations.remittance" */
export type Remittance_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Bumped by operations.force_recalculate_remittance so a child-row change re-fires the BEFORE trigger that recomputes this row's aggregates. Carries no business meaning. */
  lastRecalcTrigger?: InputMaybe<Order_By>;
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Order_By>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Order_By>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Order_By>;
  paymentMethodTypeId?: InputMaybe<Order_By>;
  /** Payment method type name(s) applied to this remittance, ' / '-joined. NULL when unpaid. DISPLAY SNAPSHOT, not a live value: recomputed when remittance_payment rows change, but NOT when shared.payment_method_type.name is renamed or payment.payment_method_type_id is changed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  paymentType?: InputMaybe<Order_By>;
  prefixedNumber?: InputMaybe<Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  remittanceStatusTypeId?: InputMaybe<Order_By>;
  remittanceTypeId?: InputMaybe<Order_By>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operations.remittance" */
export type Remittance_Mutation_Response = {
  __typename?: 'remittance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Remittance>;
};

/** input type for inserting object relation for remote table "operations.remittance" */
export type Remittance_Obj_Rel_Insert_Input = {
  data: Remittance_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Remittance_On_Conflict>;
};

/** on_conflict condition type for table "operations.remittance" */
export type Remittance_On_Conflict = {
  constraint: Remittance_Constraint;
  update_columns?: Array<Remittance_Update_Column>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};

/** Ordering options when selecting data from "operations.remittance". */
export type Remittance_Order_By = {
  accountMetadata?: InputMaybe<Order_By>;
  billingMetadata?: InputMaybe<Order_By>;
  categoryMetadata?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  entityRemittanceDetails_aggregate?: InputMaybe<EntityRemittanceDetail_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lastRecalcTrigger?: InputMaybe<Order_By>;
  lineItemCount?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  owedAmount?: InputMaybe<Order_By>;
  paidAmount?: InputMaybe<Order_By>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Order_By>;
  paymentMethodTypeId?: InputMaybe<Order_By>;
  paymentType?: InputMaybe<Order_By>;
  prefixedNumber?: InputMaybe<Order_By>;
  remittanceClaimDetails_aggregate?: InputMaybe<RemittanceClaimDetail_Aggregate_Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  remittancePayments_aggregate?: InputMaybe<RemittancePayment_Aggregate_Order_By>;
  remittancePolicyContracts_aggregate?: InputMaybe<RemittancePolicyContract_Aggregate_Order_By>;
  remittanceStatusType?: InputMaybe<RemittanceStatusType_Order_By>;
  remittanceStatusTypeId?: InputMaybe<Order_By>;
  remittanceType?: InputMaybe<RemittanceType_Order_By>;
  remittanceTypeId?: InputMaybe<Order_By>;
  totalAmount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations.remittance */
export type Remittance_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Remittance_Prepend_Input = {
  /** Distinct {name, code} of the accounts on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.account.name/code is renamed or policy_contract.account_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  accountMetadata?: InputMaybe<Scalars['jsonb']>;
  billingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Distinct {code, name} of the categories on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.category.code/name is renamed, product.category_id is moved, or policy_contract.product_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  categoryMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "operations.remittance" */
export enum Remittance_Select_Column {
  /** column name */
  AccountMetadata = 'accountMetadata',
  /** column name */
  BillingMetadata = 'billingMetadata',
  /** column name */
  CategoryMetadata = 'categoryMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastRecalcTrigger = 'lastRecalcTrigger',
  /** column name */
  LineItemCount = 'lineItemCount',
  /** column name */
  OwedAmount = 'owedAmount',
  /** column name */
  PaidAmount = 'paidAmount',
  /** column name */
  PaymentMethodTypeId = 'paymentMethodTypeId',
  /** column name */
  PaymentType = 'paymentType',
  /** column name */
  PrefixedNumber = 'prefixedNumber',
  /** column name */
  RemittanceNumber = 'remittanceNumber',
  /** column name */
  RemittanceStatusTypeId = 'remittanceStatusTypeId',
  /** column name */
  RemittanceTypeId = 'remittanceTypeId',
  /** column name */
  TotalAmount = 'totalAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "operations.remittance" */
export type Remittance_Set_Input = {
  /** Distinct {name, code} of the accounts on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.account.name/code is renamed or policy_contract.account_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  accountMetadata?: InputMaybe<Scalars['jsonb']>;
  billingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Distinct {code, name} of the categories on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.category.code/name is renamed, product.category_id is moved, or policy_contract.product_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  categoryMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Bumped by operations.force_recalculate_remittance so a child-row change re-fires the BEFORE trigger that recomputes this row's aggregates. Carries no business meaning. */
  lastRecalcTrigger?: InputMaybe<Scalars['timestamptz']>;
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Scalars['Int']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Scalars['numeric']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Scalars['numeric']>;
  paymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  /** Payment method type name(s) applied to this remittance, ' / '-joined. NULL when unpaid. DISPLAY SNAPSHOT, not a live value: recomputed when remittance_payment rows change, but NOT when shared.payment_method_type.name is renamed or payment.payment_method_type_id is changed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  paymentType?: InputMaybe<Scalars['String']>;
  prefixedNumber?: InputMaybe<Scalars['String']>;
  remittanceNumber?: InputMaybe<Scalars['Int']>;
  remittanceStatusTypeId?: InputMaybe<Scalars['uuid']>;
  remittanceTypeId?: InputMaybe<Scalars['uuid']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Remittance_Stddev_Fields = {
  __typename?: 'remittance_stddev_fields';
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: Maybe<Scalars['Float']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: Maybe<Scalars['Float']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: Maybe<Scalars['Float']>;
  remittanceNumber?: Maybe<Scalars['Float']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operations.remittance" */
export type Remittance_Stddev_Order_By = {
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Order_By>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Order_By>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Remittance_Stddev_Pop_Fields = {
  __typename?: 'remittance_stddev_pop_fields';
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: Maybe<Scalars['Float']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: Maybe<Scalars['Float']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: Maybe<Scalars['Float']>;
  remittanceNumber?: Maybe<Scalars['Float']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operations.remittance" */
export type Remittance_Stddev_Pop_Order_By = {
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Order_By>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Order_By>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Remittance_Stddev_Samp_Fields = {
  __typename?: 'remittance_stddev_samp_fields';
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: Maybe<Scalars['Float']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: Maybe<Scalars['Float']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: Maybe<Scalars['Float']>;
  remittanceNumber?: Maybe<Scalars['Float']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operations.remittance" */
export type Remittance_Stddev_Samp_Order_By = {
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Order_By>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Order_By>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "remittance" */
export type Remittance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Remittance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Remittance_Stream_Cursor_Value_Input = {
  /** Distinct {name, code} of the accounts on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.account.name/code is renamed or policy_contract.account_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  accountMetadata?: InputMaybe<Scalars['jsonb']>;
  billingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Distinct {code, name} of the categories on this remittance's ACTIVE line items, for the list page. NULL when there are none. DISPLAY SNAPSHOT, not a live value: recomputed when the line items change, but NOT when public.category.code/name is renamed, product.category_id is moved, or policy_contract.product_id is repointed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  categoryMetadata?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Bumped by operations.force_recalculate_remittance so a child-row change re-fires the BEFORE trigger that recomputes this row's aggregates. Carries no business meaning. */
  lastRecalcTrigger?: InputMaybe<Scalars['timestamptz']>;
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Scalars['Int']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Scalars['numeric']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Scalars['numeric']>;
  paymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  /** Payment method type name(s) applied to this remittance, ' / '-joined. NULL when unpaid. DISPLAY SNAPSHOT, not a live value: recomputed when remittance_payment rows change, but NOT when shared.payment_method_type.name is renamed or payment.payment_method_type_id is changed. Run operations.reconcile_remittance_aggregates() after such a change. Do not write directly. */
  paymentType?: InputMaybe<Scalars['String']>;
  prefixedNumber?: InputMaybe<Scalars['String']>;
  remittanceNumber?: InputMaybe<Scalars['Int']>;
  remittanceStatusTypeId?: InputMaybe<Scalars['uuid']>;
  remittanceTypeId?: InputMaybe<Scalars['uuid']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Remittance_Sum_Fields = {
  __typename?: 'remittance_sum_fields';
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: Maybe<Scalars['Int']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: Maybe<Scalars['numeric']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: Maybe<Scalars['numeric']>;
  remittanceNumber?: Maybe<Scalars['Int']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "operations.remittance" */
export type Remittance_Sum_Order_By = {
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Order_By>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Order_By>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Order_By>;
};

/** update columns of table "operations.remittance" */
export enum Remittance_Update_Column {
  /** column name */
  AccountMetadata = 'accountMetadata',
  /** column name */
  BillingMetadata = 'billingMetadata',
  /** column name */
  CategoryMetadata = 'categoryMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastRecalcTrigger = 'lastRecalcTrigger',
  /** column name */
  LineItemCount = 'lineItemCount',
  /** column name */
  OwedAmount = 'owedAmount',
  /** column name */
  PaidAmount = 'paidAmount',
  /** column name */
  PaymentMethodTypeId = 'paymentMethodTypeId',
  /** column name */
  PaymentType = 'paymentType',
  /** column name */
  PrefixedNumber = 'prefixedNumber',
  /** column name */
  RemittanceNumber = 'remittanceNumber',
  /** column name */
  RemittanceStatusTypeId = 'remittanceStatusTypeId',
  /** column name */
  RemittanceTypeId = 'remittanceTypeId',
  /** column name */
  TotalAmount = 'totalAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Remittance_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Remittance_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Remittance_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Remittance_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Remittance_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Remittance_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Remittance_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Remittance_Set_Input>;
  /** filter the rows which have to be updated */
  where: Remittance_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Remittance_Var_Pop_Fields = {
  __typename?: 'remittance_var_pop_fields';
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: Maybe<Scalars['Float']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: Maybe<Scalars['Float']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: Maybe<Scalars['Float']>;
  remittanceNumber?: Maybe<Scalars['Float']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operations.remittance" */
export type Remittance_Var_Pop_Order_By = {
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Order_By>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Order_By>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Remittance_Var_Samp_Fields = {
  __typename?: 'remittance_var_samp_fields';
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: Maybe<Scalars['Float']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: Maybe<Scalars['Float']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: Maybe<Scalars['Float']>;
  remittanceNumber?: Maybe<Scalars['Float']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operations.remittance" */
export type Remittance_Var_Samp_Order_By = {
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Order_By>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Order_By>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Remittance_Variance_Fields = {
  __typename?: 'remittance_variance_fields';
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: Maybe<Scalars['Float']>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: Maybe<Scalars['Float']>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: Maybe<Scalars['Float']>;
  remittanceNumber?: Maybe<Scalars['Float']>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operations.remittance" */
export type Remittance_Variance_Order_By = {
  /** Count of ACTIVE line items on this remittance -- operations.remittance_policy_contract rows today. Named for the line item rather than the contract because a remittance line item is not guaranteed to always be a contract. Exposed to GraphQL as lineItemCount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  lineItemCount?: InputMaybe<Order_By>;
  /** total_amount - paid_amount. Can be negative where a dealer also sent an add-on amount. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  owedAmount?: InputMaybe<Order_By>;
  /** Sum of shared.payment_detail.amount against ACTIVE line items. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  paidAmount?: InputMaybe<Order_By>;
  remittanceNumber?: InputMaybe<Order_By>;
  /** Sum of the settlement basis over ACTIVE line items -- the amount this remittance has to collect, not the amount that was remitted. Account remittances use COALESCE(costMetadata->>'remittanceOverrideAmount', dealer_cost, remit_amount); Customer (MBPI-financed) remittances use remit_amount, which is the lender down payment. See ADR 0009. Maintained by operations.recalculate_remittance_totals; do not write directly. */
  totalAmount?: InputMaybe<Order_By>;
};

/** A user's review of a Repeat Part on a line item: "I reviewed that this line item carries this part number, which repeats on the Contract." Insert-only; the key holds the normalized part number, so an edit orphans the row rather than requiring a voiding rule, and deleting the line item cascades. */
export type RepeatPartAcknowledgment = {
  __typename?: 'repeatPartAcknowledgment';
  /** An object relationship */
  claimDetail: ClaimDetail;
  claimDetailId: Scalars['uuid'];
  /** An object relationship */
  claimPart?: Maybe<ClaimPart>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  identity: Identity;
  identityId: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  partNumberNormalized: Scalars['String'];
};


/** A user's review of a Repeat Part on a line item: "I reviewed that this line item carries this part number, which repeats on the Contract." Insert-only; the key holds the normalized part number, so an edit orphans the row rather than requiring a voiding rule, and deleting the line item cascades. */
export type RepeatPartAcknowledgmentLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** A user's review of a Repeat Part on a line item: "I reviewed that this line item carries this part number, which repeats on the Contract." Insert-only; the key holds the normalized part number, so an edit orphans the row rather than requiring a voiding rule, and deleting the line item cascades. */
export type RepeatPartAcknowledgmentLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** aggregated selection of "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_Aggregate = {
  __typename?: 'repeatPartAcknowledgment_aggregate';
  aggregate?: Maybe<RepeatPartAcknowledgment_Aggregate_Fields>;
  nodes: Array<RepeatPartAcknowledgment>;
};

export type RepeatPartAcknowledgment_Aggregate_Bool_Exp = {
  count?: InputMaybe<RepeatPartAcknowledgment_Aggregate_Bool_Exp_Count>;
};

export type RepeatPartAcknowledgment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_Aggregate_Fields = {
  __typename?: 'repeatPartAcknowledgment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<RepeatPartAcknowledgment_Max_Fields>;
  min?: Maybe<RepeatPartAcknowledgment_Min_Fields>;
};


/** aggregate fields of "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RepeatPartAcknowledgment_Max_Order_By>;
  min?: InputMaybe<RepeatPartAcknowledgment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_Arr_Rel_Insert_Input = {
  data: Array<RepeatPartAcknowledgment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RepeatPartAcknowledgment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "claims.repeat_part_acknowledgment". All fields are combined with a logical 'AND'. */
export type RepeatPartAcknowledgment_Bool_Exp = {
  _and?: InputMaybe<Array<RepeatPartAcknowledgment_Bool_Exp>>;
  _not?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
  _or?: InputMaybe<Array<RepeatPartAcknowledgment_Bool_Exp>>;
  claimDetail?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimDetailId?: InputMaybe<Uuid_Comparison_Exp>;
  claimPart?: InputMaybe<ClaimPart_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  partNumberNormalized?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.repeat_part_acknowledgment" */
export enum RepeatPartAcknowledgment_Constraint {
  /** unique or primary key constraint on columns "claim_detail_id", "identity_id", "part_number_normalized" */
  RepeatPartAcknowledgmentEvidenceKey = 'repeat_part_acknowledgment_evidence_key',
  /** unique or primary key constraint on columns "id" */
  RepeatPartAcknowledgmentPkey = 'repeat_part_acknowledgment_pkey'
}

/** input type for inserting data into table "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_Insert_Input = {
  claimDetail?: InputMaybe<ClaimDetail_Obj_Rel_Insert_Input>;
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  claimPart?: InputMaybe<ClaimPart_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  identityId?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  partNumberNormalized?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RepeatPartAcknowledgment_Max_Fields = {
  __typename?: 'repeatPartAcknowledgment_max_fields';
  claimDetailId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
  partNumberNormalized?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_Max_Order_By = {
  claimDetailId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  partNumberNormalized?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RepeatPartAcknowledgment_Min_Fields = {
  __typename?: 'repeatPartAcknowledgment_min_fields';
  claimDetailId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  identityId?: Maybe<Scalars['uuid']>;
  partNumberNormalized?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_Min_Order_By = {
  claimDetailId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  partNumberNormalized?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_Mutation_Response = {
  __typename?: 'repeatPartAcknowledgment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RepeatPartAcknowledgment>;
};

/** on_conflict condition type for table "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_On_Conflict = {
  constraint: RepeatPartAcknowledgment_Constraint;
  update_columns?: Array<RepeatPartAcknowledgment_Update_Column>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.repeat_part_acknowledgment". */
export type RepeatPartAcknowledgment_Order_By = {
  claimDetail?: InputMaybe<ClaimDetail_Order_By>;
  claimDetailId?: InputMaybe<Order_By>;
  claimPart?: InputMaybe<ClaimPart_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  identityId?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  partNumberNormalized?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.repeat_part_acknowledgment */
export type RepeatPartAcknowledgment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.repeat_part_acknowledgment" */
export enum RepeatPartAcknowledgment_Select_Column {
  /** column name */
  ClaimDetailId = 'claimDetailId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  PartNumberNormalized = 'partNumberNormalized'
}

/** input type for updating data in table "claims.repeat_part_acknowledgment" */
export type RepeatPartAcknowledgment_Set_Input = {
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  partNumberNormalized?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "repeatPartAcknowledgment" */
export type RepeatPartAcknowledgment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RepeatPartAcknowledgment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RepeatPartAcknowledgment_Stream_Cursor_Value_Input = {
  claimDetailId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityId?: InputMaybe<Scalars['uuid']>;
  partNumberNormalized?: InputMaybe<Scalars['String']>;
};

/** update columns of table "claims.repeat_part_acknowledgment" */
export enum RepeatPartAcknowledgment_Update_Column {
  /** column name */
  ClaimDetailId = 'claimDetailId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  PartNumberNormalized = 'partNumberNormalized'
}

export type RepeatPartAcknowledgment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RepeatPartAcknowledgment_Set_Input>;
  /** filter the rows which have to be updated */
  where: RepeatPartAcknowledgment_Bool_Exp;
};

/** columns and relationships of "auth.role" */
export type Role = {
  __typename?: 'role';
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  hierarchyValue?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  /** An array relationship */
  identities: Array<Identity>;
  /** An aggregate relationship */
  identities_aggregate: Identity_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  roleAttributes: Array<RoleAttribute>;
  /** An aggregate relationship */
  roleAttributes_aggregate: RoleAttribute_Aggregate;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userRoleHierarchy: Array<RoleHierarchyView>;
  /** An aggregate relationship */
  userRoleHierarchy_aggregate: RoleHierarchyView_Aggregate;
};


/** columns and relationships of "auth.role" */
export type RoleIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


/** columns and relationships of "auth.role" */
export type RoleIdentities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


/** columns and relationships of "auth.role" */
export type RoleRoleAttributesArgs = {
  distinct_on?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleAttribute_Order_By>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};


/** columns and relationships of "auth.role" */
export type RoleRoleAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleAttribute_Order_By>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};


/** columns and relationships of "auth.role" */
export type RoleUserRoleHierarchyArgs = {
  distinct_on?: InputMaybe<Array<RoleHierarchyView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleHierarchyView_Order_By>>;
  where?: InputMaybe<RoleHierarchyView_Bool_Exp>;
};


/** columns and relationships of "auth.role" */
export type RoleUserRoleHierarchy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleHierarchyView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleHierarchyView_Order_By>>;
  where?: InputMaybe<RoleHierarchyView_Bool_Exp>;
};

/** columns and relationships of "auth.role_attribute" */
export type RoleAttribute = {
  __typename?: 'roleAttribute';
  /** An object relationship */
  attribute: Type;
  attributeId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  role: Role;
  /** An array relationship */
  roleAttributeRoleAttribute: Array<RoleAttribute>;
  /** An aggregate relationship */
  roleAttributeRoleAttribute_aggregate: RoleAttribute_Aggregate;
  roleId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "auth.role_attribute" */
export type RoleAttributeRoleAttributeRoleAttributeArgs = {
  distinct_on?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleAttribute_Order_By>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};


/** columns and relationships of "auth.role_attribute" */
export type RoleAttributeRoleAttributeRoleAttribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleAttribute_Order_By>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};

/** aggregated selection of "auth.role_attribute" */
export type RoleAttribute_Aggregate = {
  __typename?: 'roleAttribute_aggregate';
  aggregate?: Maybe<RoleAttribute_Aggregate_Fields>;
  nodes: Array<RoleAttribute>;
};

export type RoleAttribute_Aggregate_Bool_Exp = {
  count?: InputMaybe<RoleAttribute_Aggregate_Bool_Exp_Count>;
};

export type RoleAttribute_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RoleAttribute_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.role_attribute" */
export type RoleAttribute_Aggregate_Fields = {
  __typename?: 'roleAttribute_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<RoleAttribute_Max_Fields>;
  min?: Maybe<RoleAttribute_Min_Fields>;
};


/** aggregate fields of "auth.role_attribute" */
export type RoleAttribute_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.role_attribute" */
export type RoleAttribute_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoleAttribute_Max_Order_By>;
  min?: InputMaybe<RoleAttribute_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.role_attribute" */
export type RoleAttribute_Arr_Rel_Insert_Input = {
  data: Array<RoleAttribute_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoleAttribute_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.role_attribute". All fields are combined with a logical 'AND'. */
export type RoleAttribute_Bool_Exp = {
  _and?: InputMaybe<Array<RoleAttribute_Bool_Exp>>;
  _not?: InputMaybe<RoleAttribute_Bool_Exp>;
  _or?: InputMaybe<Array<RoleAttribute_Bool_Exp>>;
  attribute?: InputMaybe<Type_Bool_Exp>;
  attributeId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Role_Bool_Exp>;
  roleAttributeRoleAttribute?: InputMaybe<RoleAttribute_Bool_Exp>;
  roleAttributeRoleAttribute_aggregate?: InputMaybe<RoleAttribute_Aggregate_Bool_Exp>;
  roleId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.role_attribute" */
export enum RoleAttribute_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoleAttributePkey = 'role_attribute_pkey'
}

/** input type for inserting data into table "auth.role_attribute" */
export type RoleAttribute_Insert_Input = {
  attribute?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  attributeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  roleAttributeRoleAttribute?: InputMaybe<RoleAttribute_Arr_Rel_Insert_Input>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RoleAttribute_Max_Fields = {
  __typename?: 'roleAttribute_max_fields';
  attributeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  roleId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.role_attribute" */
export type RoleAttribute_Max_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RoleAttribute_Min_Fields = {
  __typename?: 'roleAttribute_min_fields';
  attributeId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  roleId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.role_attribute" */
export type RoleAttribute_Min_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.role_attribute" */
export type RoleAttribute_Mutation_Response = {
  __typename?: 'roleAttribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RoleAttribute>;
};

/** on_conflict condition type for table "auth.role_attribute" */
export type RoleAttribute_On_Conflict = {
  constraint: RoleAttribute_Constraint;
  update_columns?: Array<RoleAttribute_Update_Column>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.role_attribute". */
export type RoleAttribute_Order_By = {
  attribute?: InputMaybe<Type_Order_By>;
  attributeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Role_Order_By>;
  roleAttributeRoleAttribute_aggregate?: InputMaybe<RoleAttribute_Aggregate_Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.role_attribute */
export type RoleAttribute_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.role_attribute" */
export enum RoleAttribute_Select_Column {
  /** column name */
  AttributeId = 'attributeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.role_attribute" */
export type RoleAttribute_Set_Input = {
  attributeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "roleAttribute" */
export type RoleAttribute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoleAttribute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoleAttribute_Stream_Cursor_Value_Input = {
  attributeId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.role_attribute" */
export enum RoleAttribute_Update_Column {
  /** column name */
  AttributeId = 'attributeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RoleAttribute_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoleAttribute_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoleAttribute_Bool_Exp;
};

/** columns and relationships of "auth.role_hierarchy_view" */
export type RoleHierarchyView = {
  __typename?: 'roleHierarchyView';
  relatedRoleHierarchyValue?: Maybe<Scalars['Int']>;
  relatedRoleId?: Maybe<Scalars['uuid']>;
  relatedRoleName?: Maybe<Scalars['String']>;
  roleAttributeId?: Maybe<Scalars['uuid']>;
  userRoleHierarchyValue?: Maybe<Scalars['Int']>;
  userRoleId?: Maybe<Scalars['uuid']>;
  userRoleName?: Maybe<Scalars['String']>;
};

/** aggregated selection of "auth.role_hierarchy_view" */
export type RoleHierarchyView_Aggregate = {
  __typename?: 'roleHierarchyView_aggregate';
  aggregate?: Maybe<RoleHierarchyView_Aggregate_Fields>;
  nodes: Array<RoleHierarchyView>;
};

export type RoleHierarchyView_Aggregate_Bool_Exp = {
  count?: InputMaybe<RoleHierarchyView_Aggregate_Bool_Exp_Count>;
};

export type RoleHierarchyView_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RoleHierarchyView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RoleHierarchyView_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.role_hierarchy_view" */
export type RoleHierarchyView_Aggregate_Fields = {
  __typename?: 'roleHierarchyView_aggregate_fields';
  avg?: Maybe<RoleHierarchyView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RoleHierarchyView_Max_Fields>;
  min?: Maybe<RoleHierarchyView_Min_Fields>;
  stddev?: Maybe<RoleHierarchyView_Stddev_Fields>;
  stddev_pop?: Maybe<RoleHierarchyView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RoleHierarchyView_Stddev_Samp_Fields>;
  sum?: Maybe<RoleHierarchyView_Sum_Fields>;
  var_pop?: Maybe<RoleHierarchyView_Var_Pop_Fields>;
  var_samp?: Maybe<RoleHierarchyView_Var_Samp_Fields>;
  variance?: Maybe<RoleHierarchyView_Variance_Fields>;
};


/** aggregate fields of "auth.role_hierarchy_view" */
export type RoleHierarchyView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RoleHierarchyView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Aggregate_Order_By = {
  avg?: InputMaybe<RoleHierarchyView_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoleHierarchyView_Max_Order_By>;
  min?: InputMaybe<RoleHierarchyView_Min_Order_By>;
  stddev?: InputMaybe<RoleHierarchyView_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoleHierarchyView_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoleHierarchyView_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoleHierarchyView_Sum_Order_By>;
  var_pop?: InputMaybe<RoleHierarchyView_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoleHierarchyView_Var_Samp_Order_By>;
  variance?: InputMaybe<RoleHierarchyView_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Arr_Rel_Insert_Input = {
  data: Array<RoleHierarchyView_Insert_Input>;
};

/** aggregate avg on columns */
export type RoleHierarchyView_Avg_Fields = {
  __typename?: 'roleHierarchyView_avg_fields';
  relatedRoleHierarchyValue?: Maybe<Scalars['Float']>;
  userRoleHierarchyValue?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Avg_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth.role_hierarchy_view". All fields are combined with a logical 'AND'. */
export type RoleHierarchyView_Bool_Exp = {
  _and?: InputMaybe<Array<RoleHierarchyView_Bool_Exp>>;
  _not?: InputMaybe<RoleHierarchyView_Bool_Exp>;
  _or?: InputMaybe<Array<RoleHierarchyView_Bool_Exp>>;
  relatedRoleHierarchyValue?: InputMaybe<Int_Comparison_Exp>;
  relatedRoleId?: InputMaybe<Uuid_Comparison_Exp>;
  relatedRoleName?: InputMaybe<String_Comparison_Exp>;
  roleAttributeId?: InputMaybe<Uuid_Comparison_Exp>;
  userRoleHierarchyValue?: InputMaybe<Int_Comparison_Exp>;
  userRoleId?: InputMaybe<Uuid_Comparison_Exp>;
  userRoleName?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Insert_Input = {
  relatedRoleHierarchyValue?: InputMaybe<Scalars['Int']>;
  relatedRoleId?: InputMaybe<Scalars['uuid']>;
  relatedRoleName?: InputMaybe<Scalars['String']>;
  roleAttributeId?: InputMaybe<Scalars['uuid']>;
  userRoleHierarchyValue?: InputMaybe<Scalars['Int']>;
  userRoleId?: InputMaybe<Scalars['uuid']>;
  userRoleName?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RoleHierarchyView_Max_Fields = {
  __typename?: 'roleHierarchyView_max_fields';
  relatedRoleHierarchyValue?: Maybe<Scalars['Int']>;
  relatedRoleId?: Maybe<Scalars['uuid']>;
  relatedRoleName?: Maybe<Scalars['String']>;
  roleAttributeId?: Maybe<Scalars['uuid']>;
  userRoleHierarchyValue?: Maybe<Scalars['Int']>;
  userRoleId?: Maybe<Scalars['uuid']>;
  userRoleName?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Max_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  relatedRoleId?: InputMaybe<Order_By>;
  relatedRoleName?: InputMaybe<Order_By>;
  roleAttributeId?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleId?: InputMaybe<Order_By>;
  userRoleName?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RoleHierarchyView_Min_Fields = {
  __typename?: 'roleHierarchyView_min_fields';
  relatedRoleHierarchyValue?: Maybe<Scalars['Int']>;
  relatedRoleId?: Maybe<Scalars['uuid']>;
  relatedRoleName?: Maybe<Scalars['String']>;
  roleAttributeId?: Maybe<Scalars['uuid']>;
  userRoleHierarchyValue?: Maybe<Scalars['Int']>;
  userRoleId?: Maybe<Scalars['uuid']>;
  userRoleName?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Min_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  relatedRoleId?: InputMaybe<Order_By>;
  relatedRoleName?: InputMaybe<Order_By>;
  roleAttributeId?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleId?: InputMaybe<Order_By>;
  userRoleName?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "auth.role_hierarchy_view". */
export type RoleHierarchyView_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  relatedRoleId?: InputMaybe<Order_By>;
  relatedRoleName?: InputMaybe<Order_By>;
  roleAttributeId?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleId?: InputMaybe<Order_By>;
  userRoleName?: InputMaybe<Order_By>;
};

/** select columns of table "auth.role_hierarchy_view" */
export enum RoleHierarchyView_Select_Column {
  /** column name */
  RelatedRoleHierarchyValue = 'relatedRoleHierarchyValue',
  /** column name */
  RelatedRoleId = 'relatedRoleId',
  /** column name */
  RelatedRoleName = 'relatedRoleName',
  /** column name */
  RoleAttributeId = 'roleAttributeId',
  /** column name */
  UserRoleHierarchyValue = 'userRoleHierarchyValue',
  /** column name */
  UserRoleId = 'userRoleId',
  /** column name */
  UserRoleName = 'userRoleName'
}

/** aggregate stddev on columns */
export type RoleHierarchyView_Stddev_Fields = {
  __typename?: 'roleHierarchyView_stddev_fields';
  relatedRoleHierarchyValue?: Maybe<Scalars['Float']>;
  userRoleHierarchyValue?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Stddev_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type RoleHierarchyView_Stddev_Pop_Fields = {
  __typename?: 'roleHierarchyView_stddev_pop_fields';
  relatedRoleHierarchyValue?: Maybe<Scalars['Float']>;
  userRoleHierarchyValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Stddev_Pop_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type RoleHierarchyView_Stddev_Samp_Fields = {
  __typename?: 'roleHierarchyView_stddev_samp_fields';
  relatedRoleHierarchyValue?: Maybe<Scalars['Float']>;
  userRoleHierarchyValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Stddev_Samp_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roleHierarchyView" */
export type RoleHierarchyView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoleHierarchyView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoleHierarchyView_Stream_Cursor_Value_Input = {
  relatedRoleHierarchyValue?: InputMaybe<Scalars['Int']>;
  relatedRoleId?: InputMaybe<Scalars['uuid']>;
  relatedRoleName?: InputMaybe<Scalars['String']>;
  roleAttributeId?: InputMaybe<Scalars['uuid']>;
  userRoleHierarchyValue?: InputMaybe<Scalars['Int']>;
  userRoleId?: InputMaybe<Scalars['uuid']>;
  userRoleName?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type RoleHierarchyView_Sum_Fields = {
  __typename?: 'roleHierarchyView_sum_fields';
  relatedRoleHierarchyValue?: Maybe<Scalars['Int']>;
  userRoleHierarchyValue?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Sum_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type RoleHierarchyView_Var_Pop_Fields = {
  __typename?: 'roleHierarchyView_var_pop_fields';
  relatedRoleHierarchyValue?: Maybe<Scalars['Float']>;
  userRoleHierarchyValue?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Var_Pop_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type RoleHierarchyView_Var_Samp_Fields = {
  __typename?: 'roleHierarchyView_var_samp_fields';
  relatedRoleHierarchyValue?: Maybe<Scalars['Float']>;
  userRoleHierarchyValue?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Var_Samp_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type RoleHierarchyView_Variance_Fields = {
  __typename?: 'roleHierarchyView_variance_fields';
  relatedRoleHierarchyValue?: Maybe<Scalars['Float']>;
  userRoleHierarchyValue?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "auth.role_hierarchy_view" */
export type RoleHierarchyView_Variance_Order_By = {
  relatedRoleHierarchyValue?: InputMaybe<Order_By>;
  userRoleHierarchyValue?: InputMaybe<Order_By>;
};

/** aggregated selection of "auth.role" */
export type Role_Aggregate = {
  __typename?: 'role_aggregate';
  aggregate?: Maybe<Role_Aggregate_Fields>;
  nodes: Array<Role>;
};

/** aggregate fields of "auth.role" */
export type Role_Aggregate_Fields = {
  __typename?: 'role_aggregate_fields';
  avg?: Maybe<Role_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Role_Max_Fields>;
  min?: Maybe<Role_Min_Fields>;
  stddev?: Maybe<Role_Stddev_Fields>;
  stddev_pop?: Maybe<Role_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Role_Stddev_Samp_Fields>;
  sum?: Maybe<Role_Sum_Fields>;
  var_pop?: Maybe<Role_Var_Pop_Fields>;
  var_samp?: Maybe<Role_Var_Samp_Fields>;
  variance?: Maybe<Role_Variance_Fields>;
};


/** aggregate fields of "auth.role" */
export type Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Role_Avg_Fields = {
  __typename?: 'role_avg_fields';
  hierarchyValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "auth.role". All fields are combined with a logical 'AND'. */
export type Role_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Bool_Exp>>;
  _not?: InputMaybe<Role_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  hierarchyValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identities?: InputMaybe<Identity_Bool_Exp>;
  identities_aggregate?: InputMaybe<Identity_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  roleAttributes?: InputMaybe<RoleAttribute_Bool_Exp>;
  roleAttributes_aggregate?: InputMaybe<RoleAttribute_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userRoleHierarchy?: InputMaybe<RoleHierarchyView_Bool_Exp>;
  userRoleHierarchy_aggregate?: InputMaybe<RoleHierarchyView_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.role" */
export enum Role_Constraint {
  /** unique or primary key constraint on columns "name" */
  RoleNameKey = 'role_name_key',
  /** unique or primary key constraint on columns "id" */
  RolePkey = 'role_pkey'
}

/** input type for incrementing numeric columns in table "auth.role" */
export type Role_Inc_Input = {
  hierarchyValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth.role" */
export type Role_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  hierarchyValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  identities?: InputMaybe<Identity_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  roleAttributes?: InputMaybe<RoleAttribute_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userRoleHierarchy?: InputMaybe<RoleHierarchyView_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Role_Max_Fields = {
  __typename?: 'role_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  hierarchyValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Role_Min_Fields = {
  __typename?: 'role_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  hierarchyValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "auth.role" */
export type Role_Mutation_Response = {
  __typename?: 'role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Role>;
};

/** input type for inserting object relation for remote table "auth.role" */
export type Role_Obj_Rel_Insert_Input = {
  data: Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_On_Conflict>;
};

/** on_conflict condition type for table "auth.role" */
export type Role_On_Conflict = {
  constraint: Role_Constraint;
  update_columns?: Array<Role_Update_Column>;
  where?: InputMaybe<Role_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.role". */
export type Role_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hierarchyValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identities_aggregate?: InputMaybe<Identity_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  roleAttributes_aggregate?: InputMaybe<RoleAttribute_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userRoleHierarchy_aggregate?: InputMaybe<RoleHierarchyView_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.role */
export type Role_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.role" */
export enum Role_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  HierarchyValue = 'hierarchyValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.role" */
export type Role_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  hierarchyValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Role_Stddev_Fields = {
  __typename?: 'role_stddev_fields';
  hierarchyValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Role_Stddev_Pop_Fields = {
  __typename?: 'role_stddev_pop_fields';
  hierarchyValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Role_Stddev_Samp_Fields = {
  __typename?: 'role_stddev_samp_fields';
  hierarchyValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "role" */
export type Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  hierarchyValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Role_Sum_Fields = {
  __typename?: 'role_sum_fields';
  hierarchyValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "auth.role" */
export enum Role_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  HierarchyValue = 'hierarchyValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Role_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Role_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Role_Var_Pop_Fields = {
  __typename?: 'role_var_pop_fields';
  hierarchyValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Role_Var_Samp_Fields = {
  __typename?: 'role_var_samp_fields';
  hierarchyValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Role_Variance_Fields = {
  __typename?: 'role_variance_fields';
  hierarchyValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "auth.route" */
export type Route = {
  __typename?: 'route';
  /** An object relationship */
  application: Application;
  applicationId: Scalars['uuid'];
  /** An array relationship */
  configs: Array<RouteConfig>;
  /** An aggregate relationship */
  configs_aggregate: RouteConfig_Aggregate;
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An array relationship */
  identityEntityViews: Array<IdentityEntityView>;
  /** An aggregate relationship */
  identityEntityViews_aggregate: IdentityEntityView_Aggregate;
  /** An array relationship */
  identityFilters: Array<IdentityFilter>;
  /** An aggregate relationship */
  identityFilters_aggregate: IdentityFilter_Aggregate;
  method: Scalars['String'];
  path: Scalars['String'];
  /** An object relationship */
  routeType?: Maybe<Type>;
  routeTypeId: Scalars['uuid'];
  /** Returns a security path for our convention: "METHOD:subdomain/route/path" */
  securePath?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "auth.route" */
export type RouteConfigsArgs = {
  distinct_on?: InputMaybe<Array<RouteConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RouteConfig_Order_By>>;
  where?: InputMaybe<RouteConfig_Bool_Exp>;
};


/** columns and relationships of "auth.route" */
export type RouteConfigs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RouteConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RouteConfig_Order_By>>;
  where?: InputMaybe<RouteConfig_Bool_Exp>;
};


/** columns and relationships of "auth.route" */
export type RouteIdentityEntityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** columns and relationships of "auth.route" */
export type RouteIdentityEntityViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** columns and relationships of "auth.route" */
export type RouteIdentityFiltersArgs = {
  distinct_on?: InputMaybe<Array<IdentityFilter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityFilter_Order_By>>;
  where?: InputMaybe<IdentityFilter_Bool_Exp>;
};


/** columns and relationships of "auth.route" */
export type RouteIdentityFilters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityFilter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityFilter_Order_By>>;
  where?: InputMaybe<IdentityFilter_Bool_Exp>;
};

/** Configuration table for defining table-level permissions (insert, update, delete, select) for routes. Used in Hasura permission checks. */
export type RouteConfig = {
  __typename?: 'routeConfig';
  /** Whether this route allows delete operations on the table */
  canDelete: Scalars['Boolean'];
  /** Whether this route allows insert operations on the table */
  canInsert: Scalars['Boolean'];
  /** Whether this route allows update operations on the table */
  canUpdate: Scalars['Boolean'];
  /** Whether this route allows select operations on the table */
  can_select: Scalars['Boolean'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  route: Route;
  /** Foreign key to auth.route table */
  routeId: Scalars['uuid'];
  /** Full table name including schema (e.g., public.account) */
  tableName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "auth.route_config" */
export type RouteConfig_Aggregate = {
  __typename?: 'routeConfig_aggregate';
  aggregate?: Maybe<RouteConfig_Aggregate_Fields>;
  nodes: Array<RouteConfig>;
};

export type RouteConfig_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<RouteConfig_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<RouteConfig_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<RouteConfig_Aggregate_Bool_Exp_Count>;
};

export type RouteConfig_Aggregate_Bool_Exp_Bool_And = {
  arguments: RouteConfig_Select_Column_RouteConfig_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RouteConfig_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type RouteConfig_Aggregate_Bool_Exp_Bool_Or = {
  arguments: RouteConfig_Select_Column_RouteConfig_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RouteConfig_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type RouteConfig_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RouteConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RouteConfig_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.route_config" */
export type RouteConfig_Aggregate_Fields = {
  __typename?: 'routeConfig_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<RouteConfig_Max_Fields>;
  min?: Maybe<RouteConfig_Min_Fields>;
};


/** aggregate fields of "auth.route_config" */
export type RouteConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RouteConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.route_config" */
export type RouteConfig_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RouteConfig_Max_Order_By>;
  min?: InputMaybe<RouteConfig_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.route_config" */
export type RouteConfig_Arr_Rel_Insert_Input = {
  data: Array<RouteConfig_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RouteConfig_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.route_config". All fields are combined with a logical 'AND'. */
export type RouteConfig_Bool_Exp = {
  _and?: InputMaybe<Array<RouteConfig_Bool_Exp>>;
  _not?: InputMaybe<RouteConfig_Bool_Exp>;
  _or?: InputMaybe<Array<RouteConfig_Bool_Exp>>;
  canDelete?: InputMaybe<Boolean_Comparison_Exp>;
  canInsert?: InputMaybe<Boolean_Comparison_Exp>;
  canUpdate?: InputMaybe<Boolean_Comparison_Exp>;
  can_select?: InputMaybe<Boolean_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  route?: InputMaybe<Route_Bool_Exp>;
  routeId?: InputMaybe<Uuid_Comparison_Exp>;
  tableName?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.route_config" */
export enum RouteConfig_Constraint {
  /** unique or primary key constraint on columns "id" */
  RouteConfigPkey = 'route_config_pkey',
  /** unique or primary key constraint on columns "route_id", "table_name" */
  RouteConfigRouteIdTableNameKey = 'route_config_route_id_table_name_key'
}

/** input type for inserting data into table "auth.route_config" */
export type RouteConfig_Insert_Input = {
  /** Whether this route allows delete operations on the table */
  canDelete?: InputMaybe<Scalars['Boolean']>;
  /** Whether this route allows insert operations on the table */
  canInsert?: InputMaybe<Scalars['Boolean']>;
  /** Whether this route allows update operations on the table */
  canUpdate?: InputMaybe<Scalars['Boolean']>;
  /** Whether this route allows select operations on the table */
  can_select?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  route?: InputMaybe<Route_Obj_Rel_Insert_Input>;
  /** Foreign key to auth.route table */
  routeId?: InputMaybe<Scalars['uuid']>;
  /** Full table name including schema (e.g., public.account) */
  tableName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RouteConfig_Max_Fields = {
  __typename?: 'routeConfig_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Foreign key to auth.route table */
  routeId?: Maybe<Scalars['uuid']>;
  /** Full table name including schema (e.g., public.account) */
  tableName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.route_config" */
export type RouteConfig_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Foreign key to auth.route table */
  routeId?: InputMaybe<Order_By>;
  /** Full table name including schema (e.g., public.account) */
  tableName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RouteConfig_Min_Fields = {
  __typename?: 'routeConfig_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Foreign key to auth.route table */
  routeId?: Maybe<Scalars['uuid']>;
  /** Full table name including schema (e.g., public.account) */
  tableName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.route_config" */
export type RouteConfig_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Foreign key to auth.route table */
  routeId?: InputMaybe<Order_By>;
  /** Full table name including schema (e.g., public.account) */
  tableName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.route_config" */
export type RouteConfig_Mutation_Response = {
  __typename?: 'routeConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RouteConfig>;
};

/** on_conflict condition type for table "auth.route_config" */
export type RouteConfig_On_Conflict = {
  constraint: RouteConfig_Constraint;
  update_columns?: Array<RouteConfig_Update_Column>;
  where?: InputMaybe<RouteConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.route_config". */
export type RouteConfig_Order_By = {
  canDelete?: InputMaybe<Order_By>;
  canInsert?: InputMaybe<Order_By>;
  canUpdate?: InputMaybe<Order_By>;
  can_select?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  route?: InputMaybe<Route_Order_By>;
  routeId?: InputMaybe<Order_By>;
  tableName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.route_config */
export type RouteConfig_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.route_config" */
export enum RouteConfig_Select_Column {
  /** column name */
  CanDelete = 'canDelete',
  /** column name */
  CanInsert = 'canInsert',
  /** column name */
  CanUpdate = 'canUpdate',
  /** column name */
  CanSelect = 'can_select',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RouteId = 'routeId',
  /** column name */
  TableName = 'tableName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "routeConfig_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.route_config" */
export enum RouteConfig_Select_Column_RouteConfig_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CanDelete = 'canDelete',
  /** column name */
  CanInsert = 'canInsert',
  /** column name */
  CanUpdate = 'canUpdate',
  /** column name */
  CanSelect = 'can_select'
}

/** select "routeConfig_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.route_config" */
export enum RouteConfig_Select_Column_RouteConfig_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CanDelete = 'canDelete',
  /** column name */
  CanInsert = 'canInsert',
  /** column name */
  CanUpdate = 'canUpdate',
  /** column name */
  CanSelect = 'can_select'
}

/** input type for updating data in table "auth.route_config" */
export type RouteConfig_Set_Input = {
  /** Whether this route allows delete operations on the table */
  canDelete?: InputMaybe<Scalars['Boolean']>;
  /** Whether this route allows insert operations on the table */
  canInsert?: InputMaybe<Scalars['Boolean']>;
  /** Whether this route allows update operations on the table */
  canUpdate?: InputMaybe<Scalars['Boolean']>;
  /** Whether this route allows select operations on the table */
  can_select?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Foreign key to auth.route table */
  routeId?: InputMaybe<Scalars['uuid']>;
  /** Full table name including schema (e.g., public.account) */
  tableName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "routeConfig" */
export type RouteConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RouteConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RouteConfig_Stream_Cursor_Value_Input = {
  /** Whether this route allows delete operations on the table */
  canDelete?: InputMaybe<Scalars['Boolean']>;
  /** Whether this route allows insert operations on the table */
  canInsert?: InputMaybe<Scalars['Boolean']>;
  /** Whether this route allows update operations on the table */
  canUpdate?: InputMaybe<Scalars['Boolean']>;
  /** Whether this route allows select operations on the table */
  can_select?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Foreign key to auth.route table */
  routeId?: InputMaybe<Scalars['uuid']>;
  /** Full table name including schema (e.g., public.account) */
  tableName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.route_config" */
export enum RouteConfig_Update_Column {
  /** column name */
  CanDelete = 'canDelete',
  /** column name */
  CanInsert = 'canInsert',
  /** column name */
  CanUpdate = 'canUpdate',
  /** column name */
  CanSelect = 'can_select',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RouteId = 'routeId',
  /** column name */
  TableName = 'tableName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RouteConfig_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RouteConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: RouteConfig_Bool_Exp;
};

/** aggregated selection of "auth.route" */
export type Route_Aggregate = {
  __typename?: 'route_aggregate';
  aggregate?: Maybe<Route_Aggregate_Fields>;
  nodes: Array<Route>;
};

export type Route_Aggregate_Bool_Exp = {
  count?: InputMaybe<Route_Aggregate_Bool_Exp_Count>;
};

export type Route_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Route_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Route_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.route" */
export type Route_Aggregate_Fields = {
  __typename?: 'route_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Route_Max_Fields>;
  min?: Maybe<Route_Min_Fields>;
};


/** aggregate fields of "auth.route" */
export type Route_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Route_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.route" */
export type Route_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Route_Max_Order_By>;
  min?: InputMaybe<Route_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.route" */
export type Route_Arr_Rel_Insert_Input = {
  data: Array<Route_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Route_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.route". All fields are combined with a logical 'AND'. */
export type Route_Bool_Exp = {
  _and?: InputMaybe<Array<Route_Bool_Exp>>;
  _not?: InputMaybe<Route_Bool_Exp>;
  _or?: InputMaybe<Array<Route_Bool_Exp>>;
  application?: InputMaybe<Application_Bool_Exp>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  configs?: InputMaybe<RouteConfig_Bool_Exp>;
  configs_aggregate?: InputMaybe<RouteConfig_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Bool_Exp>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Bool_Exp>;
  identityFilters?: InputMaybe<IdentityFilter_Bool_Exp>;
  identityFilters_aggregate?: InputMaybe<IdentityFilter_Aggregate_Bool_Exp>;
  method?: InputMaybe<String_Comparison_Exp>;
  path?: InputMaybe<String_Comparison_Exp>;
  routeType?: InputMaybe<Type_Bool_Exp>;
  routeTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  securePath?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.route" */
export enum Route_Constraint {
  /** unique or primary key constraint on columns "application_id", "method", "path" */
  RouteApplicationIdPathMethodKey = 'route_application_id_path_method_key',
  /** unique or primary key constraint on columns "id" */
  RoutePkey = 'route_pkey'
}

/** input type for inserting data into table "auth.route" */
export type Route_Insert_Input = {
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  applicationId?: InputMaybe<Scalars['uuid']>;
  configs?: InputMaybe<RouteConfig_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Arr_Rel_Insert_Input>;
  identityFilters?: InputMaybe<IdentityFilter_Arr_Rel_Insert_Input>;
  method?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  routeType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  routeTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Route_Max_Fields = {
  __typename?: 'route_max_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  method?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  routeTypeId?: Maybe<Scalars['uuid']>;
  /** Returns a security path for our convention: "METHOD:subdomain/route/path" */
  securePath?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.route" */
export type Route_Max_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  routeTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Route_Min_Fields = {
  __typename?: 'route_min_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  method?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  routeTypeId?: Maybe<Scalars['uuid']>;
  /** Returns a security path for our convention: "METHOD:subdomain/route/path" */
  securePath?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.route" */
export type Route_Min_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  routeTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.route" */
export type Route_Mutation_Response = {
  __typename?: 'route_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Route>;
};

/** input type for inserting object relation for remote table "auth.route" */
export type Route_Obj_Rel_Insert_Input = {
  data: Route_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Route_On_Conflict>;
};

/** on_conflict condition type for table "auth.route" */
export type Route_On_Conflict = {
  constraint: Route_Constraint;
  update_columns?: Array<Route_Update_Column>;
  where?: InputMaybe<Route_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.route". */
export type Route_Order_By = {
  application?: InputMaybe<Application_Order_By>;
  applicationId?: InputMaybe<Order_By>;
  configs_aggregate?: InputMaybe<RouteConfig_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Order_By>;
  identityFilters_aggregate?: InputMaybe<IdentityFilter_Aggregate_Order_By>;
  method?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  routeType?: InputMaybe<Type_Order_By>;
  routeTypeId?: InputMaybe<Order_By>;
  securePath?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.route */
export type Route_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.route" */
export enum Route_Select_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  Path = 'path',
  /** column name */
  RouteTypeId = 'routeTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.route" */
export type Route_Set_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  method?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  routeTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "route" */
export type Route_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Route_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Route_Stream_Cursor_Value_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  method?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  routeTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.route" */
export enum Route_Update_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  Path = 'path',
  /** column name */
  RouteTypeId = 'routeTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Route_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Route_Set_Input>;
  /** filter the rows which have to be updated */
  where: Route_Bool_Exp;
};

/** fields of action: "saveRateQuoteAction" */
export type SaveRateQuoteAction = {
  __typename?: 'saveRateQuoteAction';
  /** the time at which this action was created */
  created_at: Scalars['timestamptz'];
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']>;
  /** the unique id of an action */
  id: Scalars['uuid'];
  /** the output fields of this action */
  output: SaveRateQuoteActionOutput;
};

/** columns and relationships of "shared.search_index" */
export type SearchIndex = {
  __typename?: 'searchIndex';
  /** An object relationship */
  application: Application;
  application_id: Scalars['uuid'];
  content?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  identityEntityViews: Array<IdentityEntityView>;
  /** An aggregate relationship */
  identityEntityViews_aggregate: IdentityEntityView_Aggregate;
  keywords?: Maybe<Scalars['String']>;
  parent_id: Scalars['uuid'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  vector?: Maybe<Scalars['tsvector']>;
};


/** columns and relationships of "shared.search_index" */
export type SearchIndexIdentityEntityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** columns and relationships of "shared.search_index" */
export type SearchIndexIdentityEntityViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};

/** aggregated selection of "shared.search_index" */
export type SearchIndex_Aggregate = {
  __typename?: 'searchIndex_aggregate';
  aggregate?: Maybe<SearchIndex_Aggregate_Fields>;
  nodes: Array<SearchIndex>;
};

/** aggregate fields of "shared.search_index" */
export type SearchIndex_Aggregate_Fields = {
  __typename?: 'searchIndex_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<SearchIndex_Max_Fields>;
  min?: Maybe<SearchIndex_Min_Fields>;
};


/** aggregate fields of "shared.search_index" */
export type SearchIndex_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SearchIndex_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "shared.search_index". All fields are combined with a logical 'AND'. */
export type SearchIndex_Bool_Exp = {
  _and?: InputMaybe<Array<SearchIndex_Bool_Exp>>;
  _not?: InputMaybe<SearchIndex_Bool_Exp>;
  _or?: InputMaybe<Array<SearchIndex_Bool_Exp>>;
  application?: InputMaybe<Application_Bool_Exp>;
  application_id?: InputMaybe<Uuid_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Bool_Exp>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Bool_Exp>;
  keywords?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  vector?: InputMaybe<Tsvector_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.search_index" */
export enum SearchIndex_Constraint {
  /** unique or primary key constraint on columns "id" */
  SearchIndexPkey = 'search_index_pkey'
}

/** input type for inserting data into table "shared.search_index" */
export type SearchIndex_Insert_Input = {
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  application_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Arr_Rel_Insert_Input>;
  keywords?: InputMaybe<Scalars['String']>;
  parent_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  vector?: InputMaybe<Scalars['tsvector']>;
};

/** aggregate max on columns */
export type SearchIndex_Max_Fields = {
  __typename?: 'searchIndex_max_fields';
  application_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  keywords?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SearchIndex_Min_Fields = {
  __typename?: 'searchIndex_min_fields';
  application_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  keywords?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shared.search_index" */
export type SearchIndex_Mutation_Response = {
  __typename?: 'searchIndex_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SearchIndex>;
};

/** on_conflict condition type for table "shared.search_index" */
export type SearchIndex_On_Conflict = {
  constraint: SearchIndex_Constraint;
  update_columns?: Array<SearchIndex_Update_Column>;
  where?: InputMaybe<SearchIndex_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.search_index". */
export type SearchIndex_Order_By = {
  application?: InputMaybe<Application_Order_By>;
  application_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Order_By>;
  keywords?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  vector?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.search_index */
export type SearchIndex_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.search_index" */
export enum SearchIndex_Select_Column {
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Keywords = 'keywords',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Vector = 'vector'
}

/** input type for updating data in table "shared.search_index" */
export type SearchIndex_Set_Input = {
  application_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  keywords?: InputMaybe<Scalars['String']>;
  parent_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  vector?: InputMaybe<Scalars['tsvector']>;
};

/** Streaming cursor of the table "searchIndex" */
export type SearchIndex_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SearchIndex_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SearchIndex_Stream_Cursor_Value_Input = {
  application_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  keywords?: InputMaybe<Scalars['String']>;
  parent_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  vector?: InputMaybe<Scalars['tsvector']>;
};

/** update columns of table "shared.search_index" */
export enum SearchIndex_Update_Column {
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Keywords = 'keywords',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Vector = 'vector'
}

export type SearchIndex_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SearchIndex_Set_Input>;
  /** filter the rows which have to be updated */
  where: SearchIndex_Bool_Exp;
};

export type SearchNhtsaIssues_Args_Nhtsa = {
  concern?: InputMaybe<Scalars['String']>;
  descriptors?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  narrow?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Scalars['_text']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type Search_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "claims.service_center" */
export type ServiceCenter = {
  __typename?: 'serviceCenter';
  /** An object relationship */
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  claimServiceCenters: Array<ClaimServiceCenter>;
  /** An aggregate relationship */
  claimServiceCenters_aggregate: ClaimServiceCenter_Aggregate;
  /** An object relationship */
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  defaultPaymentMethodTypeId?: Maybe<Scalars['uuid']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An array relationship */
  laborRates: Array<LaborRate>;
  /** An aggregate relationship */
  laborRates_aggregate: LaborRate_Aggregate;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  paymentMethodType?: Maybe<PaymentMethodType>;
  serviceCenterTypeId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  serviceProviderType?: Maybe<Type>;
  /** An array relationship */
  taxRates: Array<TaxRate>;
  /** An aggregate relationship */
  taxRates_aggregate: TaxRate_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "claims.service_center" */
export type ServiceCenterClaimServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenter_Order_By>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


/** columns and relationships of "claims.service_center" */
export type ServiceCenterClaimServiceCenters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenter_Order_By>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


/** columns and relationships of "claims.service_center" */
export type ServiceCenterLaborRatesArgs = {
  distinct_on?: InputMaybe<Array<LaborRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborRate_Order_By>>;
  where?: InputMaybe<LaborRate_Bool_Exp>;
};


/** columns and relationships of "claims.service_center" */
export type ServiceCenterLaborRates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LaborRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborRate_Order_By>>;
  where?: InputMaybe<LaborRate_Bool_Exp>;
};


/** columns and relationships of "claims.service_center" */
export type ServiceCenterLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.service_center" */
export type ServiceCenterLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.service_center" */
export type ServiceCenterTaxRatesArgs = {
  distinct_on?: InputMaybe<Array<TaxRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxRate_Order_By>>;
  where?: InputMaybe<TaxRate_Bool_Exp>;
};


/** columns and relationships of "claims.service_center" */
export type ServiceCenterTaxRates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaxRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxRate_Order_By>>;
  where?: InputMaybe<TaxRate_Bool_Exp>;
};

/** aggregated selection of "claims.service_center" */
export type ServiceCenter_Aggregate = {
  __typename?: 'serviceCenter_aggregate';
  aggregate?: Maybe<ServiceCenter_Aggregate_Fields>;
  nodes: Array<ServiceCenter>;
};

export type ServiceCenter_Aggregate_Bool_Exp = {
  count?: InputMaybe<ServiceCenter_Aggregate_Bool_Exp_Count>;
};

export type ServiceCenter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ServiceCenter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.service_center" */
export type ServiceCenter_Aggregate_Fields = {
  __typename?: 'serviceCenter_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ServiceCenter_Max_Fields>;
  min?: Maybe<ServiceCenter_Min_Fields>;
};


/** aggregate fields of "claims.service_center" */
export type ServiceCenter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.service_center" */
export type ServiceCenter_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceCenter_Max_Order_By>;
  min?: InputMaybe<ServiceCenter_Min_Order_By>;
};

/** input type for inserting array relation for remote table "claims.service_center" */
export type ServiceCenter_Arr_Rel_Insert_Input = {
  data: Array<ServiceCenter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceCenter_On_Conflict>;
};

/** Boolean expression to filter rows from the table "claims.service_center". All fields are combined with a logical 'AND'. */
export type ServiceCenter_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceCenter_Bool_Exp>>;
  _not?: InputMaybe<ServiceCenter_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceCenter_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  addressId?: InputMaybe<Uuid_Comparison_Exp>;
  claimServiceCenters?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  claimServiceCenters_aggregate?: InputMaybe<ClaimServiceCenter_Aggregate_Bool_Exp>;
  contact?: InputMaybe<Contact_Bool_Exp>;
  contactId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  defaultPaymentMethodTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  laborRates?: InputMaybe<LaborRate_Bool_Exp>;
  laborRates_aggregate?: InputMaybe<LaborRate_Aggregate_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Bool_Exp>;
  serviceCenterTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  serviceProviderType?: InputMaybe<Type_Bool_Exp>;
  taxRates?: InputMaybe<TaxRate_Bool_Exp>;
  taxRates_aggregate?: InputMaybe<TaxRate_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.service_center" */
export enum ServiceCenter_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceCenterPkey = 'service_center_pkey'
}

/** input type for inserting data into table "claims.service_center" */
export type ServiceCenter_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountId?: InputMaybe<Scalars['uuid']>;
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  addressId?: InputMaybe<Scalars['uuid']>;
  claimServiceCenters?: InputMaybe<ClaimServiceCenter_Arr_Rel_Insert_Input>;
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultPaymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  laborRates?: InputMaybe<LaborRate_Arr_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Obj_Rel_Insert_Input>;
  serviceCenterTypeId?: InputMaybe<Scalars['uuid']>;
  serviceProviderType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  taxRates?: InputMaybe<TaxRate_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ServiceCenter_Max_Fields = {
  __typename?: 'serviceCenter_max_fields';
  accountId?: Maybe<Scalars['uuid']>;
  addressId?: Maybe<Scalars['uuid']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultPaymentMethodTypeId?: Maybe<Scalars['uuid']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  serviceCenterTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "claims.service_center" */
export type ServiceCenter_Max_Order_By = {
  accountId?: InputMaybe<Order_By>;
  addressId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defaultPaymentMethodTypeId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  serviceCenterTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceCenter_Min_Fields = {
  __typename?: 'serviceCenter_min_fields';
  accountId?: Maybe<Scalars['uuid']>;
  addressId?: Maybe<Scalars['uuid']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultPaymentMethodTypeId?: Maybe<Scalars['uuid']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  serviceCenterTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "claims.service_center" */
export type ServiceCenter_Min_Order_By = {
  accountId?: InputMaybe<Order_By>;
  addressId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defaultPaymentMethodTypeId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  serviceCenterTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.service_center" */
export type ServiceCenter_Mutation_Response = {
  __typename?: 'serviceCenter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceCenter>;
};

/** input type for inserting object relation for remote table "claims.service_center" */
export type ServiceCenter_Obj_Rel_Insert_Input = {
  data: ServiceCenter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceCenter_On_Conflict>;
};

/** on_conflict condition type for table "claims.service_center" */
export type ServiceCenter_On_Conflict = {
  constraint: ServiceCenter_Constraint;
  update_columns?: Array<ServiceCenter_Update_Column>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.service_center". */
export type ServiceCenter_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountId?: InputMaybe<Order_By>;
  address?: InputMaybe<Address_Order_By>;
  addressId?: InputMaybe<Order_By>;
  claimServiceCenters_aggregate?: InputMaybe<ClaimServiceCenter_Aggregate_Order_By>;
  contact?: InputMaybe<Contact_Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defaultPaymentMethodTypeId?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laborRates_aggregate?: InputMaybe<LaborRate_Aggregate_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  paymentMethodType?: InputMaybe<PaymentMethodType_Order_By>;
  serviceCenterTypeId?: InputMaybe<Order_By>;
  serviceProviderType?: InputMaybe<Type_Order_By>;
  taxRates_aggregate?: InputMaybe<TaxRate_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.service_center */
export type ServiceCenter_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.service_center" */
export enum ServiceCenter_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AddressId = 'addressId',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultPaymentMethodTypeId = 'defaultPaymentMethodTypeId',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceCenterTypeId = 'serviceCenterTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.service_center" */
export type ServiceCenter_Set_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  addressId?: InputMaybe<Scalars['uuid']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultPaymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  serviceCenterTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "serviceCenter" */
export type ServiceCenter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceCenter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceCenter_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars['uuid']>;
  addressId?: InputMaybe<Scalars['uuid']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultPaymentMethodTypeId?: InputMaybe<Scalars['uuid']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  serviceCenterTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "claims.service_center" */
export enum ServiceCenter_Update_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AddressId = 'addressId',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultPaymentMethodTypeId = 'defaultPaymentMethodTypeId',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceCenterTypeId = 'serviceCenterTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ServiceCenter_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceCenter_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceCenter_Bool_Exp;
};

/** columns and relationships of "system.severity_level_type" */
export type SeverityLevelType = {
  __typename?: 'severityLevelType';
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  referenceLogs: Array<ReferenceLog>;
  /** An aggregate relationship */
  referenceLogs_aggregate: ReferenceLog_Aggregate;
};


/** columns and relationships of "system.severity_level_type" */
export type SeverityLevelTypeReferenceLogsArgs = {
  distinct_on?: InputMaybe<Array<ReferenceLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReferenceLog_Order_By>>;
  where?: InputMaybe<ReferenceLog_Bool_Exp>;
};


/** columns and relationships of "system.severity_level_type" */
export type SeverityLevelTypeReferenceLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReferenceLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReferenceLog_Order_By>>;
  where?: InputMaybe<ReferenceLog_Bool_Exp>;
};

/** aggregated selection of "system.severity_level_type" */
export type SeverityLevelType_Aggregate = {
  __typename?: 'severityLevelType_aggregate';
  aggregate?: Maybe<SeverityLevelType_Aggregate_Fields>;
  nodes: Array<SeverityLevelType>;
};

/** aggregate fields of "system.severity_level_type" */
export type SeverityLevelType_Aggregate_Fields = {
  __typename?: 'severityLevelType_aggregate_fields';
  avg?: Maybe<SeverityLevelType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SeverityLevelType_Max_Fields>;
  min?: Maybe<SeverityLevelType_Min_Fields>;
  stddev?: Maybe<SeverityLevelType_Stddev_Fields>;
  stddev_pop?: Maybe<SeverityLevelType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SeverityLevelType_Stddev_Samp_Fields>;
  sum?: Maybe<SeverityLevelType_Sum_Fields>;
  var_pop?: Maybe<SeverityLevelType_Var_Pop_Fields>;
  var_samp?: Maybe<SeverityLevelType_Var_Samp_Fields>;
  variance?: Maybe<SeverityLevelType_Variance_Fields>;
};


/** aggregate fields of "system.severity_level_type" */
export type SeverityLevelType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SeverityLevelType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SeverityLevelType_Avg_Fields = {
  __typename?: 'severityLevelType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "system.severity_level_type". All fields are combined with a logical 'AND'. */
export type SeverityLevelType_Bool_Exp = {
  _and?: InputMaybe<Array<SeverityLevelType_Bool_Exp>>;
  _not?: InputMaybe<SeverityLevelType_Bool_Exp>;
  _or?: InputMaybe<Array<SeverityLevelType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  referenceLogs?: InputMaybe<ReferenceLog_Bool_Exp>;
  referenceLogs_aggregate?: InputMaybe<ReferenceLog_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "system.severity_level_type" */
export enum SeverityLevelType_Constraint {
  /** unique or primary key constraint on columns "id" */
  SeverityLevelTypePkey = 'severity_level_type_pkey'
}

/** input type for incrementing numeric columns in table "system.severity_level_type" */
export type SeverityLevelType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "system.severity_level_type" */
export type SeverityLevelType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  referenceLogs?: InputMaybe<ReferenceLog_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type SeverityLevelType_Max_Fields = {
  __typename?: 'severityLevelType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SeverityLevelType_Min_Fields = {
  __typename?: 'severityLevelType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "system.severity_level_type" */
export type SeverityLevelType_Mutation_Response = {
  __typename?: 'severityLevelType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SeverityLevelType>;
};

/** input type for inserting object relation for remote table "system.severity_level_type" */
export type SeverityLevelType_Obj_Rel_Insert_Input = {
  data: SeverityLevelType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SeverityLevelType_On_Conflict>;
};

/** on_conflict condition type for table "system.severity_level_type" */
export type SeverityLevelType_On_Conflict = {
  constraint: SeverityLevelType_Constraint;
  update_columns?: Array<SeverityLevelType_Update_Column>;
  where?: InputMaybe<SeverityLevelType_Bool_Exp>;
};

/** Ordering options when selecting data from "system.severity_level_type". */
export type SeverityLevelType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  referenceLogs_aggregate?: InputMaybe<ReferenceLog_Aggregate_Order_By>;
};

/** primary key columns input for table: system.severity_level_type */
export type SeverityLevelType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "system.severity_level_type" */
export enum SeverityLevelType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "system.severity_level_type" */
export type SeverityLevelType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SeverityLevelType_Stddev_Fields = {
  __typename?: 'severityLevelType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SeverityLevelType_Stddev_Pop_Fields = {
  __typename?: 'severityLevelType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SeverityLevelType_Stddev_Samp_Fields = {
  __typename?: 'severityLevelType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "severityLevelType" */
export type SeverityLevelType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SeverityLevelType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SeverityLevelType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SeverityLevelType_Sum_Fields = {
  __typename?: 'severityLevelType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "system.severity_level_type" */
export enum SeverityLevelType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type SeverityLevelType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SeverityLevelType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SeverityLevelType_Set_Input>;
  /** filter the rows which have to be updated */
  where: SeverityLevelType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SeverityLevelType_Var_Pop_Fields = {
  __typename?: 'severityLevelType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SeverityLevelType_Var_Samp_Fields = {
  __typename?: 'severityLevelType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SeverityLevelType_Variance_Fields = {
  __typename?: 'severityLevelType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** One row per Alert per Dealer Code per Category the Alert names, flattened from the eligibility graph so consumers can filter and sort on columns. An Alert is targeted exclusively through Eligibility Rules, so a row exists only where a rule carries a DealerCode definition; account_id resolves that code to an Account where one exists. effective_date and expiration_date are the intersection of the alert, attachment, dealer definition and category definition windows, so a row is effective only while all four are. Rows with no resolvable Category are retained with a null category, and blank dealer codes are excluded. */
export type Shared_Dealer_Alert_List_View = {
  __typename?: 'shared_dealer_alert_list_view';
  /** The Account whose code the Alert's DealerCode definition names, resolved the way the eligibility engine compares it: trimmed, case-insensitive, and numerically when both sides parse. No foreign key enforces this — the definition stores a code as typed, not an account reference — so a code naming no Account leaves this null and the row never reaches an account screen. */
  accountId?: Maybe<Scalars['uuid']>;
  alertId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  categoryName?: Maybe<Scalars['String']>;
  dealerCode?: Maybe<Scalars['String']>;
  /** Start of the window in which this row is effective: the latest of the alert, attachment, dealer definition and category definition start dates. Null when any of those is null, which is what stops the alert matching. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** End of the window in which this row is effective: the earliest of the alert, attachment, dealer definition and category definition end dates. Null means no end date. */
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  isInclusion?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
};

/** aggregated selection of "shared.dealer_alert_list_view" */
export type Shared_Dealer_Alert_List_View_Aggregate = {
  __typename?: 'shared_dealer_alert_list_view_aggregate';
  aggregate?: Maybe<Shared_Dealer_Alert_List_View_Aggregate_Fields>;
  nodes: Array<Shared_Dealer_Alert_List_View>;
};

/** aggregate fields of "shared.dealer_alert_list_view" */
export type Shared_Dealer_Alert_List_View_Aggregate_Fields = {
  __typename?: 'shared_dealer_alert_list_view_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Shared_Dealer_Alert_List_View_Max_Fields>;
  min?: Maybe<Shared_Dealer_Alert_List_View_Min_Fields>;
};


/** aggregate fields of "shared.dealer_alert_list_view" */
export type Shared_Dealer_Alert_List_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "shared.dealer_alert_list_view". All fields are combined with a logical 'AND'. */
export type Shared_Dealer_Alert_List_View_Bool_Exp = {
  _and?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Bool_Exp>>;
  _not?: InputMaybe<Shared_Dealer_Alert_List_View_Bool_Exp>;
  _or?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Bool_Exp>>;
  accountId?: InputMaybe<Uuid_Comparison_Exp>;
  alertId?: InputMaybe<Uuid_Comparison_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  categoryName?: InputMaybe<String_Comparison_Exp>;
  dealerCode?: InputMaybe<String_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isInclusion?: InputMaybe<Boolean_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Shared_Dealer_Alert_List_View_Max_Fields = {
  __typename?: 'shared_dealer_alert_list_view_max_fields';
  /** The Account whose code the Alert's DealerCode definition names, resolved the way the eligibility engine compares it: trimmed, case-insensitive, and numerically when both sides parse. No foreign key enforces this — the definition stores a code as typed, not an account reference — so a code naming no Account leaves this null and the row never reaches an account screen. */
  accountId?: Maybe<Scalars['uuid']>;
  alertId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  categoryName?: Maybe<Scalars['String']>;
  dealerCode?: Maybe<Scalars['String']>;
  /** Start of the window in which this row is effective: the latest of the alert, attachment, dealer definition and category definition start dates. Null when any of those is null, which is what stops the alert matching. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** End of the window in which this row is effective: the earliest of the alert, attachment, dealer definition and category definition end dates. Null means no end date. */
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Shared_Dealer_Alert_List_View_Min_Fields = {
  __typename?: 'shared_dealer_alert_list_view_min_fields';
  /** The Account whose code the Alert's DealerCode definition names, resolved the way the eligibility engine compares it: trimmed, case-insensitive, and numerically when both sides parse. No foreign key enforces this — the definition stores a code as typed, not an account reference — so a code naming no Account leaves this null and the row never reaches an account screen. */
  accountId?: Maybe<Scalars['uuid']>;
  alertId?: Maybe<Scalars['uuid']>;
  categoryId?: Maybe<Scalars['uuid']>;
  categoryName?: Maybe<Scalars['String']>;
  dealerCode?: Maybe<Scalars['String']>;
  /** Start of the window in which this row is effective: the latest of the alert, attachment, dealer definition and category definition start dates. Null when any of those is null, which is what stops the alert matching. */
  effectiveDate?: Maybe<Scalars['date']>;
  /** End of the window in which this row is effective: the earliest of the alert, attachment, dealer definition and category definition end dates. Null means no end date. */
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "shared.dealer_alert_list_view". */
export type Shared_Dealer_Alert_List_View_Order_By = {
  accountId?: InputMaybe<Order_By>;
  alertId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  categoryName?: InputMaybe<Order_By>;
  dealerCode?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isInclusion?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
};

/** select columns of table "shared.dealer_alert_list_view" */
export enum Shared_Dealer_Alert_List_View_Select_Column {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  AlertId = 'alertId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CategoryName = 'categoryName',
  /** column name */
  DealerCode = 'dealerCode',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsInclusion = 'isInclusion',
  /** column name */
  Message = 'message',
  /** column name */
  Severity = 'severity'
}

/** Streaming cursor of the table "shared_dealer_alert_list_view" */
export type Shared_Dealer_Alert_List_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shared_Dealer_Alert_List_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shared_Dealer_Alert_List_View_Stream_Cursor_Value_Input = {
  /** The Account whose code the Alert's DealerCode definition names, resolved the way the eligibility engine compares it: trimmed, case-insensitive, and numerically when both sides parse. No foreign key enforces this — the definition stores a code as typed, not an account reference — so a code naming no Account leaves this null and the row never reaches an account screen. */
  accountId?: InputMaybe<Scalars['uuid']>;
  alertId?: InputMaybe<Scalars['uuid']>;
  categoryId?: InputMaybe<Scalars['uuid']>;
  categoryName?: InputMaybe<Scalars['String']>;
  dealerCode?: InputMaybe<Scalars['String']>;
  /** Start of the window in which this row is effective: the latest of the alert, attachment, dealer definition and category definition start dates. Null when any of those is null, which is what stops the alert matching. */
  effectiveDate?: InputMaybe<Scalars['date']>;
  /** End of the window in which this row is effective: the earliest of the alert, attachment, dealer definition and category definition end dates. Null means no end date. */
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInclusion?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
};

/** This table is only for the type/shape and should not contain data. */
export type Shared_Search_Result = {
  __typename?: 'shared_search_result';
  application_id?: Maybe<Scalars['uuid']>;
  application_subdomain?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  /** An array relationship */
  identityEntityViews: Array<IdentityEntityView>;
  /** An aggregate relationship */
  identityEntityViews_aggregate: IdentityEntityView_Aggregate;
  parent_id: Scalars['uuid'];
  rank: Scalars['Float'];
  title: Scalars['String'];
  type: Scalars['String'];
};


/** This table is only for the type/shape and should not contain data. */
export type Shared_Search_ResultIdentityEntityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


/** This table is only for the type/shape and should not contain data. */
export type Shared_Search_ResultIdentityEntityViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};

export type Shared_Search_Result_Aggregate = {
  __typename?: 'shared_search_result_aggregate';
  aggregate?: Maybe<Shared_Search_Result_Aggregate_Fields>;
  nodes: Array<Shared_Search_Result>;
};

/** aggregate fields of "shared.search_result" */
export type Shared_Search_Result_Aggregate_Fields = {
  __typename?: 'shared_search_result_aggregate_fields';
  avg?: Maybe<Shared_Search_Result_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shared_Search_Result_Max_Fields>;
  min?: Maybe<Shared_Search_Result_Min_Fields>;
  stddev?: Maybe<Shared_Search_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Shared_Search_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shared_Search_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Shared_Search_Result_Sum_Fields>;
  var_pop?: Maybe<Shared_Search_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Shared_Search_Result_Var_Samp_Fields>;
  variance?: Maybe<Shared_Search_Result_Variance_Fields>;
};


/** aggregate fields of "shared.search_result" */
export type Shared_Search_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shared_Search_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Shared_Search_Result_Avg_Fields = {
  __typename?: 'shared_search_result_avg_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shared.search_result". All fields are combined with a logical 'AND'. */
export type Shared_Search_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Shared_Search_Result_Bool_Exp>>;
  _not?: InputMaybe<Shared_Search_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Shared_Search_Result_Bool_Exp>>;
  application_id?: InputMaybe<Uuid_Comparison_Exp>;
  application_subdomain?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Bool_Exp>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Bool_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  rank?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "shared.search_result" */
export type Shared_Search_Result_Inc_Input = {
  rank?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "shared.search_result" */
export type Shared_Search_Result_Insert_Input = {
  application_id?: InputMaybe<Scalars['uuid']>;
  application_subdomain?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  identityEntityViews?: InputMaybe<IdentityEntityView_Arr_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shared_Search_Result_Max_Fields = {
  __typename?: 'shared_search_result_max_fields';
  application_id?: Maybe<Scalars['uuid']>;
  application_subdomain?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  rank?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Shared_Search_Result_Min_Fields = {
  __typename?: 'shared_search_result_min_fields';
  application_id?: Maybe<Scalars['uuid']>;
  application_subdomain?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  rank?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "shared.search_result" */
export type Shared_Search_Result_Mutation_Response = {
  __typename?: 'shared_search_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shared_Search_Result>;
};

/** Ordering options when selecting data from "shared.search_result". */
export type Shared_Search_Result_Order_By = {
  application_id?: InputMaybe<Order_By>;
  application_subdomain?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  identityEntityViews_aggregate?: InputMaybe<IdentityEntityView_Aggregate_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "shared.search_result" */
export enum Shared_Search_Result_Select_Column {
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  ApplicationSubdomain = 'application_subdomain',
  /** column name */
  Content = 'content',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "shared.search_result" */
export type Shared_Search_Result_Set_Input = {
  application_id?: InputMaybe<Scalars['uuid']>;
  application_subdomain?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  parent_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Shared_Search_Result_Stddev_Fields = {
  __typename?: 'shared_search_result_stddev_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Shared_Search_Result_Stddev_Pop_Fields = {
  __typename?: 'shared_search_result_stddev_pop_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Shared_Search_Result_Stddev_Samp_Fields = {
  __typename?: 'shared_search_result_stddev_samp_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "shared_search_result" */
export type Shared_Search_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shared_Search_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shared_Search_Result_Stream_Cursor_Value_Input = {
  application_id?: InputMaybe<Scalars['uuid']>;
  application_subdomain?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  parent_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Shared_Search_Result_Sum_Fields = {
  __typename?: 'shared_search_result_sum_fields';
  rank?: Maybe<Scalars['Float']>;
};

export type Shared_Search_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shared_Search_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shared_Search_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shared_Search_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shared_Search_Result_Var_Pop_Fields = {
  __typename?: 'shared_search_result_var_pop_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Shared_Search_Result_Var_Samp_Fields = {
  __typename?: 'shared_search_result_var_samp_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Shared_Search_Result_Variance_Fields = {
  __typename?: 'shared_search_result_variance_fields';
  rank?: Maybe<Scalars['Float']>;
};

/**
 * A user's overrides for keyboard shortcut key bindings. One row per identity per
 * action, and only for actions the user has actually changed: no row means the default in the
 * packages/svelte-shared shortcut registry applies. Defaults therefore live in code, so a fresh
 * environment needs no seed and changing a default needs no data migration.
 * Written by the user from the command palette. Readable and writable only by the employee role,
 * filtered to the caller's own identity_id.
 */
export type ShortcutBinding = {
  __typename?: 'shortcutBinding';
  /**
   * Which action is being rebound, as the shortcut registry's stable identifier namespaced by area
   * - for example "claims.addLineItem" or "search.open". Matches an id declared in
   * packages/svelte-shared; call sites name an action, never a keystroke, which is what allows a
   * binding to change without touching the code that uses it. An id with no matching action in the
   * registry is ignored at runtime rather than failing, so removing an action does not break a user
   * whose row still references it.
   */
  actionId: Scalars['String'];
  /**
   * The keystroke the user chose, in the registry's binding shape:
   * {"key": "Enter", "mod": true, "shift": false, "alt": false}. Only "key" is required; the
   * modifiers default to false when absent. "mod" is the platform-appropriate modifier - Command on
   * macOS, Control elsewhere - so one stored row is correct on both, and bindings follow a user
   * between machines. The shape is enforced by the shortcut_binding_binding_metadata_shape check
   * constraint, which also rejects unknown keys so a typo cannot silently become an inert binding.
   */
  bindingMetadata: Scalars['jsonb'];
  /** Timestamp the row was created. */
  createdAt: Scalars['timestamptz'];
  /** Primary key. */
  id: Scalars['uuid'];
  /**
   * The person this binding belongs to. Logical reference to the Kratos identity (identities table
   * in the kratos database); no foreign key is enforced because the identity is mastered by Kratos
   * in a separate database, which Postgres cannot reference. This is the value X-Hasura-User-Id
   * carries, and every Hasura permission on this table filters on it, so it is what stops one user
   * reading or writing another user's bindings. Set from the session - by the column default here,
   * and by the insert permission's preset for the roles that have one - never by the client.
   */
  identityId: Scalars['uuid'];
  /** Timestamp the row was last updated (maintained by the set_users_shortcut_binding_updated_at trigger). */
  updatedAt: Scalars['timestamptz'];
};


/**
 * A user's overrides for keyboard shortcut key bindings. One row per identity per
 * action, and only for actions the user has actually changed: no row means the default in the
 * packages/svelte-shared shortcut registry applies. Defaults therefore live in code, so a fresh
 * environment needs no seed and changing a default needs no data migration.
 * Written by the user from the command palette. Readable and writable only by the employee role,
 * filtered to the caller's own identity_id.
 */
export type ShortcutBindingBindingMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "users.shortcut_binding" */
export type ShortcutBinding_Aggregate = {
  __typename?: 'shortcutBinding_aggregate';
  aggregate?: Maybe<ShortcutBinding_Aggregate_Fields>;
  nodes: Array<ShortcutBinding>;
};

/** aggregate fields of "users.shortcut_binding" */
export type ShortcutBinding_Aggregate_Fields = {
  __typename?: 'shortcutBinding_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ShortcutBinding_Max_Fields>;
  min?: Maybe<ShortcutBinding_Min_Fields>;
};


/** aggregate fields of "users.shortcut_binding" */
export type ShortcutBinding_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ShortcutBinding_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ShortcutBinding_Append_Input = {
  /**
   * The keystroke the user chose, in the registry's binding shape:
   * {"key": "Enter", "mod": true, "shift": false, "alt": false}. Only "key" is required; the
   * modifiers default to false when absent. "mod" is the platform-appropriate modifier - Command on
   * macOS, Control elsewhere - so one stored row is correct on both, and bindings follow a user
   * between machines. The shape is enforced by the shortcut_binding_binding_metadata_shape check
   * constraint, which also rejects unknown keys so a typo cannot silently become an inert binding.
   */
  bindingMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "users.shortcut_binding". All fields are combined with a logical 'AND'. */
export type ShortcutBinding_Bool_Exp = {
  _and?: InputMaybe<Array<ShortcutBinding_Bool_Exp>>;
  _not?: InputMaybe<ShortcutBinding_Bool_Exp>;
  _or?: InputMaybe<Array<ShortcutBinding_Bool_Exp>>;
  actionId?: InputMaybe<String_Comparison_Exp>;
  bindingMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identityId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "users.shortcut_binding" */
export enum ShortcutBinding_Constraint {
  /** unique or primary key constraint on columns "identity_id", "action_id" */
  ShortcutBindingIdentityIdActionIdKey = 'shortcut_binding_identity_id_action_id_key',
  /** unique or primary key constraint on columns "id" */
  ShortcutBindingPkey = 'shortcut_binding_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ShortcutBinding_Delete_At_Path_Input = {
  /**
   * The keystroke the user chose, in the registry's binding shape:
   * {"key": "Enter", "mod": true, "shift": false, "alt": false}. Only "key" is required; the
   * modifiers default to false when absent. "mod" is the platform-appropriate modifier - Command on
   * macOS, Control elsewhere - so one stored row is correct on both, and bindings follow a user
   * between machines. The shape is enforced by the shortcut_binding_binding_metadata_shape check
   * constraint, which also rejects unknown keys so a typo cannot silently become an inert binding.
   */
  bindingMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ShortcutBinding_Delete_Elem_Input = {
  /**
   * The keystroke the user chose, in the registry's binding shape:
   * {"key": "Enter", "mod": true, "shift": false, "alt": false}. Only "key" is required; the
   * modifiers default to false when absent. "mod" is the platform-appropriate modifier - Command on
   * macOS, Control elsewhere - so one stored row is correct on both, and bindings follow a user
   * between machines. The shape is enforced by the shortcut_binding_binding_metadata_shape check
   * constraint, which also rejects unknown keys so a typo cannot silently become an inert binding.
   */
  bindingMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ShortcutBinding_Delete_Key_Input = {
  /**
   * The keystroke the user chose, in the registry's binding shape:
   * {"key": "Enter", "mod": true, "shift": false, "alt": false}. Only "key" is required; the
   * modifiers default to false when absent. "mod" is the platform-appropriate modifier - Command on
   * macOS, Control elsewhere - so one stored row is correct on both, and bindings follow a user
   * between machines. The shape is enforced by the shortcut_binding_binding_metadata_shape check
   * constraint, which also rejects unknown keys so a typo cannot silently become an inert binding.
   */
  bindingMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "users.shortcut_binding" */
export type ShortcutBinding_Insert_Input = {
  /**
   * Which action is being rebound, as the shortcut registry's stable identifier namespaced by area
   * - for example "claims.addLineItem" or "search.open". Matches an id declared in
   * packages/svelte-shared; call sites name an action, never a keystroke, which is what allows a
   * binding to change without touching the code that uses it. An id with no matching action in the
   * registry is ignored at runtime rather than failing, so removing an action does not break a user
   * whose row still references it.
   */
  actionId?: InputMaybe<Scalars['String']>;
  /**
   * The keystroke the user chose, in the registry's binding shape:
   * {"key": "Enter", "mod": true, "shift": false, "alt": false}. Only "key" is required; the
   * modifiers default to false when absent. "mod" is the platform-appropriate modifier - Command on
   * macOS, Control elsewhere - so one stored row is correct on both, and bindings follow a user
   * between machines. The shape is enforced by the shortcut_binding_binding_metadata_shape check
   * constraint, which also rejects unknown keys so a typo cannot silently become an inert binding.
   */
  bindingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Timestamp the row was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * The person this binding belongs to. Logical reference to the Kratos identity (identities table
   * in the kratos database); no foreign key is enforced because the identity is mastered by Kratos
   * in a separate database, which Postgres cannot reference. This is the value X-Hasura-User-Id
   * carries, and every Hasura permission on this table filters on it, so it is what stops one user
   * reading or writing another user's bindings. Set from the session - by the column default here,
   * and by the insert permission's preset for the roles that have one - never by the client.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Timestamp the row was last updated (maintained by the set_users_shortcut_binding_updated_at trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ShortcutBinding_Max_Fields = {
  __typename?: 'shortcutBinding_max_fields';
  /**
   * Which action is being rebound, as the shortcut registry's stable identifier namespaced by area
   * - for example "claims.addLineItem" or "search.open". Matches an id declared in
   * packages/svelte-shared; call sites name an action, never a keystroke, which is what allows a
   * binding to change without touching the code that uses it. An id with no matching action in the
   * registry is ignored at runtime rather than failing, so removing an action does not break a user
   * whose row still references it.
   */
  actionId?: Maybe<Scalars['String']>;
  /** Timestamp the row was created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /**
   * The person this binding belongs to. Logical reference to the Kratos identity (identities table
   * in the kratos database); no foreign key is enforced because the identity is mastered by Kratos
   * in a separate database, which Postgres cannot reference. This is the value X-Hasura-User-Id
   * carries, and every Hasura permission on this table filters on it, so it is what stops one user
   * reading or writing another user's bindings. Set from the session - by the column default here,
   * and by the insert permission's preset for the roles that have one - never by the client.
   */
  identityId?: Maybe<Scalars['uuid']>;
  /** Timestamp the row was last updated (maintained by the set_users_shortcut_binding_updated_at trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ShortcutBinding_Min_Fields = {
  __typename?: 'shortcutBinding_min_fields';
  /**
   * Which action is being rebound, as the shortcut registry's stable identifier namespaced by area
   * - for example "claims.addLineItem" or "search.open". Matches an id declared in
   * packages/svelte-shared; call sites name an action, never a keystroke, which is what allows a
   * binding to change without touching the code that uses it. An id with no matching action in the
   * registry is ignored at runtime rather than failing, so removing an action does not break a user
   * whose row still references it.
   */
  actionId?: Maybe<Scalars['String']>;
  /** Timestamp the row was created. */
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: Maybe<Scalars['uuid']>;
  /**
   * The person this binding belongs to. Logical reference to the Kratos identity (identities table
   * in the kratos database); no foreign key is enforced because the identity is mastered by Kratos
   * in a separate database, which Postgres cannot reference. This is the value X-Hasura-User-Id
   * carries, and every Hasura permission on this table filters on it, so it is what stops one user
   * reading or writing another user's bindings. Set from the session - by the column default here,
   * and by the insert permission's preset for the roles that have one - never by the client.
   */
  identityId?: Maybe<Scalars['uuid']>;
  /** Timestamp the row was last updated (maintained by the set_users_shortcut_binding_updated_at trigger). */
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "users.shortcut_binding" */
export type ShortcutBinding_Mutation_Response = {
  __typename?: 'shortcutBinding_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ShortcutBinding>;
};

/** on_conflict condition type for table "users.shortcut_binding" */
export type ShortcutBinding_On_Conflict = {
  constraint: ShortcutBinding_Constraint;
  update_columns?: Array<ShortcutBinding_Update_Column>;
  where?: InputMaybe<ShortcutBinding_Bool_Exp>;
};

/** Ordering options when selecting data from "users.shortcut_binding". */
export type ShortcutBinding_Order_By = {
  actionId?: InputMaybe<Order_By>;
  bindingMetadata?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identityId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users.shortcut_binding */
export type ShortcutBinding_Pk_Columns_Input = {
  /** Primary key. */
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ShortcutBinding_Prepend_Input = {
  /**
   * The keystroke the user chose, in the registry's binding shape:
   * {"key": "Enter", "mod": true, "shift": false, "alt": false}. Only "key" is required; the
   * modifiers default to false when absent. "mod" is the platform-appropriate modifier - Command on
   * macOS, Control elsewhere - so one stored row is correct on both, and bindings follow a user
   * between machines. The shape is enforced by the shortcut_binding_binding_metadata_shape check
   * constraint, which also rejects unknown keys so a typo cannot silently become an inert binding.
   */
  bindingMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users.shortcut_binding" */
export enum ShortcutBinding_Select_Column {
  /** column name */
  ActionId = 'actionId',
  /** column name */
  BindingMetadata = 'bindingMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "users.shortcut_binding" */
export type ShortcutBinding_Set_Input = {
  /**
   * Which action is being rebound, as the shortcut registry's stable identifier namespaced by area
   * - for example "claims.addLineItem" or "search.open". Matches an id declared in
   * packages/svelte-shared; call sites name an action, never a keystroke, which is what allows a
   * binding to change without touching the code that uses it. An id with no matching action in the
   * registry is ignored at runtime rather than failing, so removing an action does not break a user
   * whose row still references it.
   */
  actionId?: InputMaybe<Scalars['String']>;
  /**
   * The keystroke the user chose, in the registry's binding shape:
   * {"key": "Enter", "mod": true, "shift": false, "alt": false}. Only "key" is required; the
   * modifiers default to false when absent. "mod" is the platform-appropriate modifier - Command on
   * macOS, Control elsewhere - so one stored row is correct on both, and bindings follow a user
   * between machines. The shape is enforced by the shortcut_binding_binding_metadata_shape check
   * constraint, which also rejects unknown keys so a typo cannot silently become an inert binding.
   */
  bindingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Timestamp the row was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * The person this binding belongs to. Logical reference to the Kratos identity (identities table
   * in the kratos database); no foreign key is enforced because the identity is mastered by Kratos
   * in a separate database, which Postgres cannot reference. This is the value X-Hasura-User-Id
   * carries, and every Hasura permission on this table filters on it, so it is what stops one user
   * reading or writing another user's bindings. Set from the session - by the column default here,
   * and by the insert permission's preset for the roles that have one - never by the client.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Timestamp the row was last updated (maintained by the set_users_shortcut_binding_updated_at trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "shortcutBinding" */
export type ShortcutBinding_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ShortcutBinding_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ShortcutBinding_Stream_Cursor_Value_Input = {
  /**
   * Which action is being rebound, as the shortcut registry's stable identifier namespaced by area
   * - for example "claims.addLineItem" or "search.open". Matches an id declared in
   * packages/svelte-shared; call sites name an action, never a keystroke, which is what allows a
   * binding to change without touching the code that uses it. An id with no matching action in the
   * registry is ignored at runtime rather than failing, so removing an action does not break a user
   * whose row still references it.
   */
  actionId?: InputMaybe<Scalars['String']>;
  /**
   * The keystroke the user chose, in the registry's binding shape:
   * {"key": "Enter", "mod": true, "shift": false, "alt": false}. Only "key" is required; the
   * modifiers default to false when absent. "mod" is the platform-appropriate modifier - Command on
   * macOS, Control elsewhere - so one stored row is correct on both, and bindings follow a user
   * between machines. The shape is enforced by the shortcut_binding_binding_metadata_shape check
   * constraint, which also rejects unknown keys so a typo cannot silently become an inert binding.
   */
  bindingMetadata?: InputMaybe<Scalars['jsonb']>;
  /** Timestamp the row was created. */
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Primary key. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * The person this binding belongs to. Logical reference to the Kratos identity (identities table
   * in the kratos database); no foreign key is enforced because the identity is mastered by Kratos
   * in a separate database, which Postgres cannot reference. This is the value X-Hasura-User-Id
   * carries, and every Hasura permission on this table filters on it, so it is what stops one user
   * reading or writing another user's bindings. Set from the session - by the column default here,
   * and by the insert permission's preset for the roles that have one - never by the client.
   */
  identityId?: InputMaybe<Scalars['uuid']>;
  /** Timestamp the row was last updated (maintained by the set_users_shortcut_binding_updated_at trigger). */
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "users.shortcut_binding" */
export enum ShortcutBinding_Update_Column {
  /** column name */
  ActionId = 'actionId',
  /** column name */
  BindingMetadata = 'bindingMetadata',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityId = 'identityId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ShortcutBinding_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ShortcutBinding_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ShortcutBinding_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ShortcutBinding_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ShortcutBinding_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ShortcutBinding_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ShortcutBinding_Set_Input>;
  /** filter the rows which have to be updated */
  where: ShortcutBinding_Bool_Exp;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "state" */
export type State = {
  __typename?: 'state';
  abbreviation?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "state" */
export type State_Aggregate = {
  __typename?: 'state_aggregate';
  aggregate?: Maybe<State_Aggregate_Fields>;
  nodes: Array<State>;
};

/** aggregate fields of "state" */
export type State_Aggregate_Fields = {
  __typename?: 'state_aggregate_fields';
  avg?: Maybe<State_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<State_Max_Fields>;
  min?: Maybe<State_Min_Fields>;
  stddev?: Maybe<State_Stddev_Fields>;
  stddev_pop?: Maybe<State_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<State_Stddev_Samp_Fields>;
  sum?: Maybe<State_Sum_Fields>;
  var_pop?: Maybe<State_Var_Pop_Fields>;
  var_samp?: Maybe<State_Var_Samp_Fields>;
  variance?: Maybe<State_Variance_Fields>;
};


/** aggregate fields of "state" */
export type State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type State_Avg_Fields = {
  __typename?: 'state_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "state". All fields are combined with a logical 'AND'. */
export type State_Bool_Exp = {
  _and?: InputMaybe<Array<State_Bool_Exp>>;
  _not?: InputMaybe<State_Bool_Exp>;
  _or?: InputMaybe<Array<State_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "state" */
export enum State_Constraint {
  /** unique or primary key constraint on columns "id" */
  StatePkey = 'state_pkey'
}

/** input type for incrementing numeric columns in table "state" */
export type State_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "state" */
export type State_Insert_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type State_Max_Fields = {
  __typename?: 'state_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type State_Min_Fields = {
  __typename?: 'state_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "state" */
export type State_Mutation_Response = {
  __typename?: 'state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<State>;
};

/** input type for inserting object relation for remote table "state" */
export type State_Obj_Rel_Insert_Input = {
  data: State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<State_On_Conflict>;
};

/** on_conflict condition type for table "state" */
export type State_On_Conflict = {
  constraint: State_Constraint;
  update_columns?: Array<State_Update_Column>;
  where?: InputMaybe<State_Bool_Exp>;
};

/** Ordering options when selecting data from "state". */
export type State_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: state */
export type State_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "state" */
export enum State_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "state" */
export type State_Set_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type State_Stddev_Fields = {
  __typename?: 'state_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type State_Stddev_Pop_Fields = {
  __typename?: 'state_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type State_Stddev_Samp_Fields = {
  __typename?: 'state_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "state" */
export type State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type State_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type State_Sum_Fields = {
  __typename?: 'state_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "state" */
export enum State_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type State_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<State_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<State_Set_Input>;
  /** filter the rows which have to be updated */
  where: State_Bool_Exp;
};

/** aggregate var_pop on columns */
export type State_Var_Pop_Fields = {
  __typename?: 'state_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type State_Var_Samp_Fields = {
  __typename?: 'state_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type State_Variance_Fields = {
  __typename?: 'state_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "system.step" */
export type Step = {
  __typename?: 'step';
  args?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  entityNotes: Array<EntityNote>;
  /** An aggregate relationship */
  entityNotes_aggregate: EntityNote_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  jobSteps: Array<JobStep>;
  /** An aggregate relationship */
  jobSteps_aggregate: JobStep_Aggregate;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  stepType?: Maybe<StepType>;
  stepTypeId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  technologyType: TechnologyType;
  technologyTypeId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "system.step" */
export type StepEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "system.step" */
export type StepEntityNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


/** columns and relationships of "system.step" */
export type StepJobStepsArgs = {
  distinct_on?: InputMaybe<Array<JobStep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobStep_Order_By>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};


/** columns and relationships of "system.step" */
export type StepJobSteps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JobStep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobStep_Order_By>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};


/** columns and relationships of "system.step" */
export type StepLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "system.step" */
export type StepLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** columns and relationships of "system.step_list_view" */
export type StepListView = {
  __typename?: 'stepListView';
  args?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  numberOfJobs?: Maybe<Scalars['Int']>;
  stepType?: Maybe<Scalars['String']>;
  technologyName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "system.step_list_view" */
export type StepListView_Aggregate = {
  __typename?: 'stepListView_aggregate';
  aggregate?: Maybe<StepListView_Aggregate_Fields>;
  nodes: Array<StepListView>;
};

/** aggregate fields of "system.step_list_view" */
export type StepListView_Aggregate_Fields = {
  __typename?: 'stepListView_aggregate_fields';
  avg?: Maybe<StepListView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<StepListView_Max_Fields>;
  min?: Maybe<StepListView_Min_Fields>;
  stddev?: Maybe<StepListView_Stddev_Fields>;
  stddev_pop?: Maybe<StepListView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StepListView_Stddev_Samp_Fields>;
  sum?: Maybe<StepListView_Sum_Fields>;
  var_pop?: Maybe<StepListView_Var_Pop_Fields>;
  var_samp?: Maybe<StepListView_Var_Samp_Fields>;
  variance?: Maybe<StepListView_Variance_Fields>;
};


/** aggregate fields of "system.step_list_view" */
export type StepListView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StepListView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type StepListView_Avg_Fields = {
  __typename?: 'stepListView_avg_fields';
  numberOfJobs?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "system.step_list_view". All fields are combined with a logical 'AND'. */
export type StepListView_Bool_Exp = {
  _and?: InputMaybe<Array<StepListView_Bool_Exp>>;
  _not?: InputMaybe<StepListView_Bool_Exp>;
  _or?: InputMaybe<Array<StepListView_Bool_Exp>>;
  args?: InputMaybe<String_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numberOfJobs?: InputMaybe<Int_Comparison_Exp>;
  stepType?: InputMaybe<String_Comparison_Exp>;
  technologyName?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type StepListView_Max_Fields = {
  __typename?: 'stepListView_max_fields';
  args?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  numberOfJobs?: Maybe<Scalars['Int']>;
  stepType?: Maybe<Scalars['String']>;
  technologyName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type StepListView_Min_Fields = {
  __typename?: 'stepListView_min_fields';
  args?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  numberOfJobs?: Maybe<Scalars['Int']>;
  stepType?: Maybe<Scalars['String']>;
  technologyName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "system.step_list_view". */
export type StepListView_Order_By = {
  args?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfJobs?: InputMaybe<Order_By>;
  stepType?: InputMaybe<Order_By>;
  technologyName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "system.step_list_view" */
export enum StepListView_Select_Column {
  /** column name */
  Args = 'args',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfJobs = 'numberOfJobs',
  /** column name */
  StepType = 'stepType',
  /** column name */
  TechnologyName = 'technologyName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type StepListView_Stddev_Fields = {
  __typename?: 'stepListView_stddev_fields';
  numberOfJobs?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type StepListView_Stddev_Pop_Fields = {
  __typename?: 'stepListView_stddev_pop_fields';
  numberOfJobs?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type StepListView_Stddev_Samp_Fields = {
  __typename?: 'stepListView_stddev_samp_fields';
  numberOfJobs?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stepListView" */
export type StepListView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StepListView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StepListView_Stream_Cursor_Value_Input = {
  args?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  numberOfJobs?: InputMaybe<Scalars['Int']>;
  stepType?: InputMaybe<Scalars['String']>;
  technologyName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type StepListView_Sum_Fields = {
  __typename?: 'stepListView_sum_fields';
  numberOfJobs?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type StepListView_Var_Pop_Fields = {
  __typename?: 'stepListView_var_pop_fields';
  numberOfJobs?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type StepListView_Var_Samp_Fields = {
  __typename?: 'stepListView_var_samp_fields';
  numberOfJobs?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type StepListView_Variance_Fields = {
  __typename?: 'stepListView_variance_fields';
  numberOfJobs?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "system.step_type" */
export type StepType = {
  __typename?: 'stepType';
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  steps: Array<Step>;
  /** An aggregate relationship */
  steps_aggregate: Step_Aggregate;
};


/** columns and relationships of "system.step_type" */
export type StepTypeStepsArgs = {
  distinct_on?: InputMaybe<Array<Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Step_Order_By>>;
  where?: InputMaybe<Step_Bool_Exp>;
};


/** columns and relationships of "system.step_type" */
export type StepTypeSteps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Step_Order_By>>;
  where?: InputMaybe<Step_Bool_Exp>;
};

/** aggregated selection of "system.step_type" */
export type StepType_Aggregate = {
  __typename?: 'stepType_aggregate';
  aggregate?: Maybe<StepType_Aggregate_Fields>;
  nodes: Array<StepType>;
};

/** aggregate fields of "system.step_type" */
export type StepType_Aggregate_Fields = {
  __typename?: 'stepType_aggregate_fields';
  avg?: Maybe<StepType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<StepType_Max_Fields>;
  min?: Maybe<StepType_Min_Fields>;
  stddev?: Maybe<StepType_Stddev_Fields>;
  stddev_pop?: Maybe<StepType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StepType_Stddev_Samp_Fields>;
  sum?: Maybe<StepType_Sum_Fields>;
  var_pop?: Maybe<StepType_Var_Pop_Fields>;
  var_samp?: Maybe<StepType_Var_Samp_Fields>;
  variance?: Maybe<StepType_Variance_Fields>;
};


/** aggregate fields of "system.step_type" */
export type StepType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StepType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type StepType_Avg_Fields = {
  __typename?: 'stepType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "system.step_type". All fields are combined with a logical 'AND'. */
export type StepType_Bool_Exp = {
  _and?: InputMaybe<Array<StepType_Bool_Exp>>;
  _not?: InputMaybe<StepType_Bool_Exp>;
  _or?: InputMaybe<Array<StepType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  steps?: InputMaybe<Step_Bool_Exp>;
  steps_aggregate?: InputMaybe<Step_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "system.step_type" */
export enum StepType_Constraint {
  /** unique or primary key constraint on columns "id" */
  StepTypePkey = 'step_type_pkey'
}

/** input type for incrementing numeric columns in table "system.step_type" */
export type StepType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "system.step_type" */
export type StepType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  steps?: InputMaybe<Step_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type StepType_Max_Fields = {
  __typename?: 'stepType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type StepType_Min_Fields = {
  __typename?: 'stepType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "system.step_type" */
export type StepType_Mutation_Response = {
  __typename?: 'stepType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<StepType>;
};

/** input type for inserting object relation for remote table "system.step_type" */
export type StepType_Obj_Rel_Insert_Input = {
  data: StepType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<StepType_On_Conflict>;
};

/** on_conflict condition type for table "system.step_type" */
export type StepType_On_Conflict = {
  constraint: StepType_Constraint;
  update_columns?: Array<StepType_Update_Column>;
  where?: InputMaybe<StepType_Bool_Exp>;
};

/** Ordering options when selecting data from "system.step_type". */
export type StepType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  steps_aggregate?: InputMaybe<Step_Aggregate_Order_By>;
};

/** primary key columns input for table: system.step_type */
export type StepType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "system.step_type" */
export enum StepType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "system.step_type" */
export type StepType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type StepType_Stddev_Fields = {
  __typename?: 'stepType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type StepType_Stddev_Pop_Fields = {
  __typename?: 'stepType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type StepType_Stddev_Samp_Fields = {
  __typename?: 'stepType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stepType" */
export type StepType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StepType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StepType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type StepType_Sum_Fields = {
  __typename?: 'stepType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "system.step_type" */
export enum StepType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type StepType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StepType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StepType_Set_Input>;
  /** filter the rows which have to be updated */
  where: StepType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StepType_Var_Pop_Fields = {
  __typename?: 'stepType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type StepType_Var_Samp_Fields = {
  __typename?: 'stepType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type StepType_Variance_Fields = {
  __typename?: 'stepType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "system.step" */
export type Step_Aggregate = {
  __typename?: 'step_aggregate';
  aggregate?: Maybe<Step_Aggregate_Fields>;
  nodes: Array<Step>;
};

export type Step_Aggregate_Bool_Exp = {
  count?: InputMaybe<Step_Aggregate_Bool_Exp_Count>;
};

export type Step_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Step_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Step_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "system.step" */
export type Step_Aggregate_Fields = {
  __typename?: 'step_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Step_Max_Fields>;
  min?: Maybe<Step_Min_Fields>;
};


/** aggregate fields of "system.step" */
export type Step_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Step_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "system.step" */
export type Step_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Step_Max_Order_By>;
  min?: InputMaybe<Step_Min_Order_By>;
};

/** input type for inserting array relation for remote table "system.step" */
export type Step_Arr_Rel_Insert_Input = {
  data: Array<Step_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Step_On_Conflict>;
};

/** Boolean expression to filter rows from the table "system.step". All fields are combined with a logical 'AND'. */
export type Step_Bool_Exp = {
  _and?: InputMaybe<Array<Step_Bool_Exp>>;
  _not?: InputMaybe<Step_Bool_Exp>;
  _or?: InputMaybe<Array<Step_Bool_Exp>>;
  args?: InputMaybe<String_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityNotes?: InputMaybe<EntityNote_Bool_Exp>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobSteps?: InputMaybe<JobStep_Bool_Exp>;
  jobSteps_aggregate?: InputMaybe<JobStep_Aggregate_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  stepType?: InputMaybe<StepType_Bool_Exp>;
  stepTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  technologyType?: InputMaybe<TechnologyType_Bool_Exp>;
  technologyTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "system.step" */
export enum Step_Constraint {
  /** unique or primary key constraint on columns "id" */
  StepPkey = 'step_pkey'
}

/** input type for inserting data into table "system.step" */
export type Step_Insert_Input = {
  args?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityNotes?: InputMaybe<EntityNote_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  jobSteps?: InputMaybe<JobStep_Arr_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  stepType?: InputMaybe<StepType_Obj_Rel_Insert_Input>;
  stepTypeId?: InputMaybe<Scalars['uuid']>;
  technologyType?: InputMaybe<TechnologyType_Obj_Rel_Insert_Input>;
  technologyTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Step_Max_Fields = {
  __typename?: 'step_max_fields';
  args?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  stepTypeId?: Maybe<Scalars['uuid']>;
  technologyTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "system.step" */
export type Step_Max_Order_By = {
  args?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stepTypeId?: InputMaybe<Order_By>;
  technologyTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Step_Min_Fields = {
  __typename?: 'step_min_fields';
  args?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  stepTypeId?: Maybe<Scalars['uuid']>;
  technologyTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "system.step" */
export type Step_Min_Order_By = {
  args?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stepTypeId?: InputMaybe<Order_By>;
  technologyTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "system.step" */
export type Step_Mutation_Response = {
  __typename?: 'step_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Step>;
};

/** input type for inserting object relation for remote table "system.step" */
export type Step_Obj_Rel_Insert_Input = {
  data: Step_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Step_On_Conflict>;
};

/** on_conflict condition type for table "system.step" */
export type Step_On_Conflict = {
  constraint: Step_Constraint;
  update_columns?: Array<Step_Update_Column>;
  where?: InputMaybe<Step_Bool_Exp>;
};

/** Ordering options when selecting data from "system.step". */
export type Step_Order_By = {
  args?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityNotes_aggregate?: InputMaybe<EntityNote_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  jobSteps_aggregate?: InputMaybe<JobStep_Aggregate_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  stepType?: InputMaybe<StepType_Order_By>;
  stepTypeId?: InputMaybe<Order_By>;
  technologyType?: InputMaybe<TechnologyType_Order_By>;
  technologyTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system.step */
export type Step_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "system.step" */
export enum Step_Select_Column {
  /** column name */
  Args = 'args',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StepTypeId = 'stepTypeId',
  /** column name */
  TechnologyTypeId = 'technologyTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "system.step" */
export type Step_Set_Input = {
  args?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  stepTypeId?: InputMaybe<Scalars['uuid']>;
  technologyTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "step" */
export type Step_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Step_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Step_Stream_Cursor_Value_Input = {
  args?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  stepTypeId?: InputMaybe<Scalars['uuid']>;
  technologyTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "system.step" */
export enum Step_Update_Column {
  /** column name */
  Args = 'args',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StepTypeId = 'stepTypeId',
  /** column name */
  TechnologyTypeId = 'technologyTypeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Step_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Step_Set_Input>;
  /** filter the rows which have to be updated */
  where: Step_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "vpic.abs" */
  ABS: Array<Abs_Vpic>;
  /** fetch aggregated fields from the table: "vpic.abs" */
  ABS_aggregate: Abs_Aggregate_Vpic;
  /** fetch data from the table: "vpic.abs" using primary key columns */
  ABS_by_pk?: Maybe<Abs_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.abs" */
  ABS_stream: Array<Abs_Vpic>;
  /** fetch data from the table: "vpic.adaptivecruisecontrol" */
  AdaptiveCruiseControl: Array<AdaptiveCruiseControl_Vpic>;
  /** fetch aggregated fields from the table: "vpic.adaptivecruisecontrol" */
  AdaptiveCruiseControl_aggregate: AdaptiveCruiseControl_Aggregate_Vpic;
  /** fetch data from the table: "vpic.adaptivecruisecontrol" using primary key columns */
  AdaptiveCruiseControl_by_pk?: Maybe<AdaptiveCruiseControl_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.adaptivecruisecontrol" */
  AdaptiveCruiseControl_stream: Array<AdaptiveCruiseControl_Vpic>;
  /** fetch data from the table: "vpic.adaptivedrivingbeam" */
  AdaptiveDrivingBeam: Array<AdaptiveDrivingBeam_Vpic>;
  /** fetch aggregated fields from the table: "vpic.adaptivedrivingbeam" */
  AdaptiveDrivingBeam_aggregate: AdaptiveDrivingBeam_Aggregate_Vpic;
  /** fetch data from the table: "vpic.adaptivedrivingbeam" using primary key columns */
  AdaptiveDrivingBeam_by_pk?: Maybe<AdaptiveDrivingBeam_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.adaptivedrivingbeam" */
  AdaptiveDrivingBeam_stream: Array<AdaptiveDrivingBeam_Vpic>;
  /** fetch data from the table: "vpic.airbaglocfront" */
  AirBagLocFront: Array<AirBagLocFront_Vpic>;
  /** fetch aggregated fields from the table: "vpic.airbaglocfront" */
  AirBagLocFront_aggregate: AirBagLocFront_Aggregate_Vpic;
  /** fetch data from the table: "vpic.airbaglocfront" using primary key columns */
  AirBagLocFront_by_pk?: Maybe<AirBagLocFront_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.airbaglocfront" */
  AirBagLocFront_stream: Array<AirBagLocFront_Vpic>;
  /** fetch data from the table: "vpic.airbaglocknee" */
  AirBagLocKnee: Array<AirBagLocKnee_Vpic>;
  /** fetch aggregated fields from the table: "vpic.airbaglocknee" */
  AirBagLocKnee_aggregate: AirBagLocKnee_Aggregate_Vpic;
  /** fetch data from the table: "vpic.airbaglocknee" using primary key columns */
  AirBagLocKnee_by_pk?: Maybe<AirBagLocKnee_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.airbaglocknee" */
  AirBagLocKnee_stream: Array<AirBagLocKnee_Vpic>;
  /** fetch data from the table: "vpic.airbaglocations" */
  AirBagLocations: Array<AirBagLocations_Vpic>;
  /** fetch aggregated fields from the table: "vpic.airbaglocations" */
  AirBagLocations_aggregate: AirBagLocations_Aggregate_Vpic;
  /** fetch data from the table: "vpic.airbaglocations" using primary key columns */
  AirBagLocations_by_pk?: Maybe<AirBagLocations_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.airbaglocations" */
  AirBagLocations_stream: Array<AirBagLocations_Vpic>;
  /** fetch data from the table: "vpic.autobrake" */
  AutoBrake: Array<AutoBrake_Vpic>;
  /** fetch aggregated fields from the table: "vpic.autobrake" */
  AutoBrake_aggregate: AutoBrake_Aggregate_Vpic;
  /** fetch data from the table: "vpic.autobrake" using primary key columns */
  AutoBrake_by_pk?: Maybe<AutoBrake_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.autobrake" */
  AutoBrake_stream: Array<AutoBrake_Vpic>;
  /** fetch data from the table: "vpic.autoreversesystem" */
  AutoReverseSystem: Array<AutoReverseSystem_Vpic>;
  /** fetch aggregated fields from the table: "vpic.autoreversesystem" */
  AutoReverseSystem_aggregate: AutoReverseSystem_Aggregate_Vpic;
  /** fetch data from the table: "vpic.autoreversesystem" using primary key columns */
  AutoReverseSystem_by_pk?: Maybe<AutoReverseSystem_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.autoreversesystem" */
  AutoReverseSystem_stream: Array<AutoReverseSystem_Vpic>;
  /** fetch data from the table: "vpic.automaticpedestrainalertingsound" */
  AutomaticPedestrainAlertingSound: Array<AutomaticPedestrainAlertingSound_Vpic>;
  /** fetch aggregated fields from the table: "vpic.automaticpedestrainalertingsound" */
  AutomaticPedestrainAlertingSound_aggregate: AutomaticPedestrainAlertingSound_Aggregate_Vpic;
  /** fetch data from the table: "vpic.automaticpedestrainalertingsound" using primary key columns */
  AutomaticPedestrainAlertingSound_by_pk?: Maybe<AutomaticPedestrainAlertingSound_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.automaticpedestrainalertingsound" */
  AutomaticPedestrainAlertingSound_stream: Array<AutomaticPedestrainAlertingSound_Vpic>;
  /** fetch data from the table: "vpic.axleconfiguration" */
  AxleConfiguration: Array<AxleConfiguration_Vpic>;
  /** fetch aggregated fields from the table: "vpic.axleconfiguration" */
  AxleConfiguration_aggregate: AxleConfiguration_Aggregate_Vpic;
  /** fetch data from the table: "vpic.axleconfiguration" using primary key columns */
  AxleConfiguration_by_pk?: Maybe<AxleConfiguration_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.axleconfiguration" */
  AxleConfiguration_stream: Array<AxleConfiguration_Vpic>;
  /** fetch data from the table: "vpic.batterytype" */
  BatteryType: Array<BatteryType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.batterytype" */
  BatteryType_aggregate: BatteryType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.batterytype" using primary key columns */
  BatteryType_by_pk?: Maybe<BatteryType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.batterytype" */
  BatteryType_stream: Array<BatteryType_Vpic>;
  /** fetch data from the table: "vpic.bedtype" */
  BedType: Array<BedType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.bedtype" */
  BedType_aggregate: BedType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.bedtype" using primary key columns */
  BedType_by_pk?: Maybe<BedType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.bedtype" */
  BedType_stream: Array<BedType_Vpic>;
  /** fetch data from the table: "vpic.blindspotintervention" */
  BlindSpotIntervention: Array<BlindSpotIntervention_Vpic>;
  /** fetch aggregated fields from the table: "vpic.blindspotintervention" */
  BlindSpotIntervention_aggregate: BlindSpotIntervention_Aggregate_Vpic;
  /** fetch data from the table: "vpic.blindspotintervention" using primary key columns */
  BlindSpotIntervention_by_pk?: Maybe<BlindSpotIntervention_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.blindspotintervention" */
  BlindSpotIntervention_stream: Array<BlindSpotIntervention_Vpic>;
  /** fetch data from the table: "vpic.blindspotmonitoring" */
  BlindSpotMonitoring: Array<BlindSpotMonitoring_Vpic>;
  /** fetch aggregated fields from the table: "vpic.blindspotmonitoring" */
  BlindSpotMonitoring_aggregate: BlindSpotMonitoring_Aggregate_Vpic;
  /** fetch data from the table: "vpic.blindspotmonitoring" using primary key columns */
  BlindSpotMonitoring_by_pk?: Maybe<BlindSpotMonitoring_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.blindspotmonitoring" */
  BlindSpotMonitoring_stream: Array<BlindSpotMonitoring_Vpic>;
  /** fetch data from the table: "vpic.bodycab" */
  BodyCab: Array<BodyCab_Vpic>;
  /** fetch aggregated fields from the table: "vpic.bodycab" */
  BodyCab_aggregate: BodyCab_Aggregate_Vpic;
  /** fetch data from the table: "vpic.bodycab" using primary key columns */
  BodyCab_by_pk?: Maybe<BodyCab_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.bodycab" */
  BodyCab_stream: Array<BodyCab_Vpic>;
  /** fetch data from the table: "vpic.bodystyle" */
  BodyStyle: Array<BodyStyle_Vpic>;
  /** fetch aggregated fields from the table: "vpic.bodystyle" */
  BodyStyle_aggregate: BodyStyle_Aggregate_Vpic;
  /** fetch data from the table: "vpic.bodystyle" using primary key columns */
  BodyStyle_by_pk?: Maybe<BodyStyle_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.bodystyle" */
  BodyStyle_stream: Array<BodyStyle_Vpic>;
  /** fetch data from the table: "vpic.brakesystem" */
  BrakeSystem: Array<BrakeSystem_Vpic>;
  /** fetch aggregated fields from the table: "vpic.brakesystem" */
  BrakeSystem_aggregate: BrakeSystem_Aggregate_Vpic;
  /** fetch data from the table: "vpic.brakesystem" using primary key columns */
  BrakeSystem_by_pk?: Maybe<BrakeSystem_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.brakesystem" */
  BrakeSystem_stream: Array<BrakeSystem_Vpic>;
  /** fetch data from the table: "vpic.busfloorconfigtype" */
  BusFloorConfigType: Array<BusFloorConfigType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.busfloorconfigtype" */
  BusFloorConfigType_aggregate: BusFloorConfigType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.busfloorconfigtype" using primary key columns */
  BusFloorConfigType_by_pk?: Maybe<BusFloorConfigType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.busfloorconfigtype" */
  BusFloorConfigType_stream: Array<BusFloorConfigType_Vpic>;
  /** fetch data from the table: "vpic.bustype" */
  BusType: Array<BusType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.bustype" */
  BusType_aggregate: BusType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.bustype" using primary key columns */
  BusType_by_pk?: Maybe<BusType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.bustype" */
  BusType_stream: Array<BusType_Vpic>;
  /** fetch data from the table: "vpic.can_aacn" */
  CAN_AACN: Array<Can_Aacn_Vpic>;
  /** fetch aggregated fields from the table: "vpic.can_aacn" */
  CAN_AACN_aggregate: Can_Aacn_Aggregate_Vpic;
  /** fetch data from the table: "vpic.can_aacn" using primary key columns */
  CAN_AACN_by_pk?: Maybe<Can_Aacn_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.can_aacn" */
  CAN_AACN_stream: Array<Can_Aacn_Vpic>;
  /** fetch data from the table: "vpic.chargerlevel" */
  ChargerLevel: Array<ChargerLevel_Vpic>;
  /** fetch aggregated fields from the table: "vpic.chargerlevel" */
  ChargerLevel_aggregate: ChargerLevel_Aggregate_Vpic;
  /** fetch data from the table: "vpic.chargerlevel" using primary key columns */
  ChargerLevel_by_pk?: Maybe<ChargerLevel_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.chargerlevel" */
  ChargerLevel_stream: Array<ChargerLevel_Vpic>;
  /** fetch data from the table: "vpic.combinedbrakingsystem" */
  CombinedBrakingSystem: Array<CombinedBrakingSystem_Vpic>;
  /** fetch aggregated fields from the table: "vpic.combinedbrakingsystem" */
  CombinedBrakingSystem_aggregate: CombinedBrakingSystem_Aggregate_Vpic;
  /** fetch data from the table: "vpic.combinedbrakingsystem" using primary key columns */
  CombinedBrakingSystem_by_pk?: Maybe<CombinedBrakingSystem_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.combinedbrakingsystem" */
  CombinedBrakingSystem_stream: Array<CombinedBrakingSystem_Vpic>;
  /** fetch data from the table: "ContractMasterSurcharge" */
  ContractMasterSurcharge: Array<ContractMasterSurcharge>;
  /** fetch aggregated fields from the table: "ContractMasterSurcharge" */
  ContractMasterSurcharge_aggregate: ContractMasterSurcharge_Aggregate;
  /** fetch data from the table: "vpic.conversion" */
  Conversion: Array<Conversion_Vpic>;
  /** fetch aggregated fields from the table: "vpic.conversion" */
  Conversion_aggregate: Conversion_Aggregate_Vpic;
  /** fetch data from the table: "vpic.conversion" using primary key columns */
  Conversion_by_pk?: Maybe<Conversion_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.conversion" */
  Conversion_stream: Array<Conversion_Vpic>;
  /** fetch data from the table: "vpic.coolingtype" */
  CoolingType: Array<CoolingType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.coolingtype" */
  CoolingType_aggregate: CoolingType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.coolingtype" using primary key columns */
  CoolingType_by_pk?: Maybe<CoolingType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.coolingtype" */
  CoolingType_stream: Array<CoolingType_Vpic>;
  /** fetch data from the table: "vpic.country" */
  Country: Array<Country_Vpic>;
  /** fetch aggregated fields from the table: "vpic.country" */
  Country_aggregate: Country_Aggregate_Vpic;
  /** fetch data from the table: "vpic.country" using primary key columns */
  Country_by_pk?: Maybe<Country_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.country" */
  Country_stream: Array<Country_Vpic>;
  /** fetch data from the table: "vpic.custommotorcycletype" */
  CustomMotorcycleType: Array<CustomMotorcycleType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.custommotorcycletype" */
  CustomMotorcycleType_aggregate: CustomMotorcycleType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.custommotorcycletype" using primary key columns */
  CustomMotorcycleType_by_pk?: Maybe<CustomMotorcycleType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.custommotorcycletype" */
  CustomMotorcycleType_stream: Array<CustomMotorcycleType_Vpic>;
  /** fetch data from the table: "vpic.daytimerunninglight" */
  DaytimeRunningLight: Array<DaytimeRunningLight_Vpic>;
  /** fetch aggregated fields from the table: "vpic.daytimerunninglight" */
  DaytimeRunningLight_aggregate: DaytimeRunningLight_Aggregate_Vpic;
  /** fetch data from the table: "vpic.daytimerunninglight" using primary key columns */
  DaytimeRunningLight_by_pk?: Maybe<DaytimeRunningLight_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.daytimerunninglight" */
  DaytimeRunningLight_stream: Array<DaytimeRunningLight_Vpic>;
  /** fetch data from the table: "vpic.defaultvalue" */
  DefaultValue: Array<DefaultValue_Vpic>;
  /** fetch aggregated fields from the table: "vpic.defaultvalue" */
  DefaultValue_aggregate: DefaultValue_Aggregate_Vpic;
  /** fetch data from the table: "vpic.defaultvalue" using primary key columns */
  DefaultValue_by_pk?: Maybe<DefaultValue_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.defaultvalue" */
  DefaultValue_stream: Array<DefaultValue_Vpic>;
  /** fetch data from the table: "vpic.destinationmarket" */
  DestinationMarket: Array<DestinationMarket_Vpic>;
  /** fetch aggregated fields from the table: "vpic.destinationmarket" */
  DestinationMarket_aggregate: DestinationMarket_Aggregate_Vpic;
  /** fetch data from the table: "vpic.destinationmarket" using primary key columns */
  DestinationMarket_by_pk?: Maybe<DestinationMarket_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.destinationmarket" */
  DestinationMarket_stream: Array<DestinationMarket_Vpic>;
  /** fetch data from the table: "vpic.drivetype" */
  DriveType: Array<DriveType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.drivetype" */
  DriveType_aggregate: DriveType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.drivetype" using primary key columns */
  DriveType_by_pk?: Maybe<DriveType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.drivetype" */
  DriveType_stream: Array<DriveType_Vpic>;
  /** fetch data from the table: "vpic.dynamicbrakesupport" */
  DynamicBrakeSupport: Array<DynamicBrakeSupport_Vpic>;
  /** fetch aggregated fields from the table: "vpic.dynamicbrakesupport" */
  DynamicBrakeSupport_aggregate: DynamicBrakeSupport_Aggregate_Vpic;
  /** fetch data from the table: "vpic.dynamicbrakesupport" using primary key columns */
  DynamicBrakeSupport_by_pk?: Maybe<DynamicBrakeSupport_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.dynamicbrakesupport" */
  DynamicBrakeSupport_stream: Array<DynamicBrakeSupport_Vpic>;
  /** fetch data from the table: "vpic.ecs" */
  ECS: Array<Ecs_Vpic>;
  /** fetch aggregated fields from the table: "vpic.ecs" */
  ECS_aggregate: Ecs_Aggregate_Vpic;
  /** fetch data from the table: "vpic.ecs" using primary key columns */
  ECS_by_pk?: Maybe<Ecs_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.ecs" */
  ECS_stream: Array<Ecs_Vpic>;
  /** fetch data from the table: "vpic.edr" */
  EDR: Array<Edr_Vpic>;
  /** fetch aggregated fields from the table: "vpic.edr" */
  EDR_aggregate: Edr_Aggregate_Vpic;
  /** fetch data from the table: "vpic.edr" using primary key columns */
  EDR_by_pk?: Maybe<Edr_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.edr" */
  EDR_stream: Array<Edr_Vpic>;
  /** fetch data from the table: "vpic.evdriveunit" */
  EVDriveUnit: Array<EvDriveUnit_Vpic>;
  /** fetch aggregated fields from the table: "vpic.evdriveunit" */
  EVDriveUnit_aggregate: EvDriveUnit_Aggregate_Vpic;
  /** fetch data from the table: "vpic.evdriveunit" using primary key columns */
  EVDriveUnit_by_pk?: Maybe<EvDriveUnit_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.evdriveunit" */
  EVDriveUnit_stream: Array<EvDriveUnit_Vpic>;
  /** fetch data from the table: "vpic.electrificationlevel" */
  ElectrificationLevel: Array<ElectrificationLevel_Vpic>;
  /** fetch aggregated fields from the table: "vpic.electrificationlevel" */
  ElectrificationLevel_aggregate: ElectrificationLevel_Aggregate_Vpic;
  /** fetch data from the table: "vpic.electrificationlevel" using primary key columns */
  ElectrificationLevel_by_pk?: Maybe<ElectrificationLevel_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.electrificationlevel" */
  ElectrificationLevel_stream: Array<ElectrificationLevel_Vpic>;
  /** fetch data from the table: "vpic.element" */
  Element: Array<Element_Vpic>;
  /** fetch aggregated fields from the table: "vpic.element" */
  Element_aggregate: Element_Aggregate_Vpic;
  /** fetch data from the table: "vpic.element" using primary key columns */
  Element_by_pk?: Maybe<Element_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.element" */
  Element_stream: Array<Element_Vpic>;
  /** fetch data from the table: "vpic.engineconfiguration" */
  EngineConfiguration: Array<EngineConfiguration_Vpic>;
  /** fetch aggregated fields from the table: "vpic.engineconfiguration" */
  EngineConfiguration_aggregate: EngineConfiguration_Aggregate_Vpic;
  /** fetch data from the table: "vpic.engineconfiguration" using primary key columns */
  EngineConfiguration_by_pk?: Maybe<EngineConfiguration_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.engineconfiguration" */
  EngineConfiguration_stream: Array<EngineConfiguration_Vpic>;
  /** fetch data from the table: "vpic.enginemodel" */
  EngineModel: Array<EngineModel_Vpic>;
  /** fetch data from the table: "vpic.enginemodelpattern" */
  EngineModelPattern: Array<EngineModelPattern_Vpic>;
  /** fetch aggregated fields from the table: "vpic.enginemodelpattern" */
  EngineModelPattern_aggregate: EngineModelPattern_Aggregate_Vpic;
  /** fetch data from the table: "vpic.enginemodelpattern" using primary key columns */
  EngineModelPattern_by_pk?: Maybe<EngineModelPattern_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.enginemodelpattern" */
  EngineModelPattern_stream: Array<EngineModelPattern_Vpic>;
  /** fetch aggregated fields from the table: "vpic.enginemodel" */
  EngineModel_aggregate: EngineModel_Aggregate_Vpic;
  /** fetch data from the table: "vpic.enginemodel" using primary key columns */
  EngineModel_by_pk?: Maybe<EngineModel_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.enginemodel" */
  EngineModel_stream: Array<EngineModel_Vpic>;
  /** fetch data from the table: "vpic.entertainmentsystem" */
  EntertainmentSystem: Array<EntertainmentSystem_Vpic>;
  /** fetch aggregated fields from the table: "vpic.entertainmentsystem" */
  EntertainmentSystem_aggregate: EntertainmentSystem_Aggregate_Vpic;
  /** fetch data from the table: "vpic.entertainmentsystem" using primary key columns */
  EntertainmentSystem_by_pk?: Maybe<EntertainmentSystem_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.entertainmentsystem" */
  EntertainmentSystem_stream: Array<EntertainmentSystem_Vpic>;
  /** fetch data from the table: "vpic.errorcode" */
  ErrorCode: Array<ErrorCode_Vpic>;
  /** fetch aggregated fields from the table: "vpic.errorcode" */
  ErrorCode_aggregate: ErrorCode_Aggregate_Vpic;
  /** fetch data from the table: "vpic.errorcode" using primary key columns */
  ErrorCode_by_pk?: Maybe<ErrorCode_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.errorcode" */
  ErrorCode_stream: Array<ErrorCode_Vpic>;
  /** fetch data from the table: "vpic.forwardcollisionwarning" */
  ForwardCollisionWarning: Array<ForwardCollisionWarning_Vpic>;
  /** fetch aggregated fields from the table: "vpic.forwardcollisionwarning" */
  ForwardCollisionWarning_aggregate: ForwardCollisionWarning_Aggregate_Vpic;
  /** fetch data from the table: "vpic.forwardcollisionwarning" using primary key columns */
  ForwardCollisionWarning_by_pk?: Maybe<ForwardCollisionWarning_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.forwardcollisionwarning" */
  ForwardCollisionWarning_stream: Array<ForwardCollisionWarning_Vpic>;
  /** fetch data from the table: "vpic.fueldeliverytype" */
  FuelDeliveryType: Array<FuelDeliveryType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.fueldeliverytype" */
  FuelDeliveryType_aggregate: FuelDeliveryType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.fueldeliverytype" using primary key columns */
  FuelDeliveryType_by_pk?: Maybe<FuelDeliveryType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.fueldeliverytype" */
  FuelDeliveryType_stream: Array<FuelDeliveryType_Vpic>;
  /** fetch data from the table: "vpic.fueltankmaterial" */
  FuelTankMaterial: Array<FuelTankMaterial_Vpic>;
  /** fetch aggregated fields from the table: "vpic.fueltankmaterial" */
  FuelTankMaterial_aggregate: FuelTankMaterial_Aggregate_Vpic;
  /** fetch data from the table: "vpic.fueltankmaterial" using primary key columns */
  FuelTankMaterial_by_pk?: Maybe<FuelTankMaterial_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.fueltankmaterial" */
  FuelTankMaterial_stream: Array<FuelTankMaterial_Vpic>;
  /** fetch data from the table: "vpic.fueltanktype" */
  FuelTankType: Array<FuelTankType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.fueltanktype" */
  FuelTankType_aggregate: FuelTankType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.fueltanktype" using primary key columns */
  FuelTankType_by_pk?: Maybe<FuelTankType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.fueltanktype" */
  FuelTankType_stream: Array<FuelTankType_Vpic>;
  /** fetch data from the table: "vpic.fueltype" */
  FuelType: Array<FuelType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.fueltype" */
  FuelType_aggregate: FuelType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.fueltype" using primary key columns */
  FuelType_by_pk?: Maybe<FuelType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.fueltype" */
  FuelType_stream: Array<FuelType_Vpic>;
  /** fetch data from the table: "vpic.grossvehicleweightrating" */
  GrossVehicleWeightRating: Array<GrossVehicleWeightRating_Vpic>;
  /** fetch aggregated fields from the table: "vpic.grossvehicleweightrating" */
  GrossVehicleWeightRating_aggregate: GrossVehicleWeightRating_Aggregate_Vpic;
  /** fetch data from the table: "vpic.grossvehicleweightrating" using primary key columns */
  GrossVehicleWeightRating_by_pk?: Maybe<GrossVehicleWeightRating_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.grossvehicleweightrating" */
  GrossVehicleWeightRating_stream: Array<GrossVehicleWeightRating_Vpic>;
  /** fetch data from the table: "vpic.keylessignition" */
  KeylessIgnition: Array<KeylessIgnition_Vpic>;
  /** fetch aggregated fields from the table: "vpic.keylessignition" */
  KeylessIgnition_aggregate: KeylessIgnition_Aggregate_Vpic;
  /** fetch data from the table: "vpic.keylessignition" using primary key columns */
  KeylessIgnition_by_pk?: Maybe<KeylessIgnition_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.keylessignition" */
  KeylessIgnition_stream: Array<KeylessIgnition_Vpic>;
  /** fetch data from the table: "vpic.lanecenteringassistance" */
  LaneCenteringAssistance: Array<LaneCenteringAssistance_Vpic>;
  /** fetch aggregated fields from the table: "vpic.lanecenteringassistance" */
  LaneCenteringAssistance_aggregate: LaneCenteringAssistance_Aggregate_Vpic;
  /** fetch data from the table: "vpic.lanecenteringassistance" using primary key columns */
  LaneCenteringAssistance_by_pk?: Maybe<LaneCenteringAssistance_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.lanecenteringassistance" */
  LaneCenteringAssistance_stream: Array<LaneCenteringAssistance_Vpic>;
  /** fetch data from the table: "vpic.lanedeparturewarning" */
  LaneDepartureWarning: Array<LaneDepartureWarning_Vpic>;
  /** fetch aggregated fields from the table: "vpic.lanedeparturewarning" */
  LaneDepartureWarning_aggregate: LaneDepartureWarning_Aggregate_Vpic;
  /** fetch data from the table: "vpic.lanedeparturewarning" using primary key columns */
  LaneDepartureWarning_by_pk?: Maybe<LaneDepartureWarning_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.lanedeparturewarning" */
  LaneDepartureWarning_stream: Array<LaneDepartureWarning_Vpic>;
  /** fetch data from the table: "vpic.lanekeepsystem" */
  LaneKeepSystem: Array<LaneKeepSystem_Vpic>;
  /** fetch aggregated fields from the table: "vpic.lanekeepsystem" */
  LaneKeepSystem_aggregate: LaneKeepSystem_Aggregate_Vpic;
  /** fetch data from the table: "vpic.lanekeepsystem" using primary key columns */
  LaneKeepSystem_by_pk?: Maybe<LaneKeepSystem_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.lanekeepsystem" */
  LaneKeepSystem_stream: Array<LaneKeepSystem_Vpic>;
  /** fetch data from the table: "vpic.lowerbeamheadlamplightsource" */
  LowerBeamHeadlampLightSource: Array<LowerBeamHeadlampLightSource_Vpic>;
  /** fetch aggregated fields from the table: "vpic.lowerbeamheadlamplightsource" */
  LowerBeamHeadlampLightSource_aggregate: LowerBeamHeadlampLightSource_Aggregate_Vpic;
  /** fetch data from the table: "vpic.lowerbeamheadlamplightsource" using primary key columns */
  LowerBeamHeadlampLightSource_by_pk?: Maybe<LowerBeamHeadlampLightSource_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.lowerbeamheadlamplightsource" */
  LowerBeamHeadlampLightSource_stream: Array<LowerBeamHeadlampLightSource_Vpic>;
  /** fetch data from the table: "vpic.make" */
  Make: Array<Make_Vpic>;
  /** fetch data from the table: "vpic.make_model" */
  Make_Model: Array<Make_Model_Vpic>;
  /** fetch aggregated fields from the table: "vpic.make_model" */
  Make_Model_aggregate: Make_Model_Aggregate_Vpic;
  /** fetch data from the table: "vpic.make_model" using primary key columns */
  Make_Model_by_pk?: Maybe<Make_Model_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.make_model" */
  Make_Model_stream: Array<Make_Model_Vpic>;
  /** fetch aggregated fields from the table: "vpic.make" */
  Make_aggregate: Make_Aggregate_Vpic;
  /** fetch data from the table: "vpic.make" using primary key columns */
  Make_by_pk?: Maybe<Make_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.make" */
  Make_stream: Array<Make_Vpic>;
  /** fetch data from the table: "vpic.manufacturer" */
  Manufacturer: Array<Manufacturer_Vpic>;
  /** fetch data from the table: "vpic.manufacturer_make" */
  Manufacturer_Make: Array<Manufacturer_Make_Vpic>;
  /** fetch aggregated fields from the table: "vpic.manufacturer_make" */
  Manufacturer_Make_aggregate: Manufacturer_Make_Aggregate_Vpic;
  /** fetch data from the table: "vpic.manufacturer_make" using primary key columns */
  Manufacturer_Make_by_pk?: Maybe<Manufacturer_Make_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.manufacturer_make" */
  Manufacturer_Make_stream: Array<Manufacturer_Make_Vpic>;
  /** fetch aggregated fields from the table: "vpic.manufacturer" */
  Manufacturer_aggregate: Manufacturer_Aggregate_Vpic;
  /** fetch data from the table: "vpic.manufacturer" using primary key columns */
  Manufacturer_by_pk?: Maybe<Manufacturer_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.manufacturer" */
  Manufacturer_stream: Array<Manufacturer_Vpic>;
  /** fetch data from the table: "vpic.model" */
  Model: Array<Model_Vpic>;
  /** fetch aggregated fields from the table: "vpic.model" */
  Model_aggregate: Model_Aggregate_Vpic;
  /** fetch data from the table: "vpic.model" using primary key columns */
  Model_by_pk?: Maybe<Model_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.model" */
  Model_stream: Array<Model_Vpic>;
  /** fetch data from the table: "vpic.motorcyclechassistype" */
  MotorcycleChassisType: Array<MotorcycleChassisType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.motorcyclechassistype" */
  MotorcycleChassisType_aggregate: MotorcycleChassisType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.motorcyclechassistype" using primary key columns */
  MotorcycleChassisType_by_pk?: Maybe<MotorcycleChassisType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.motorcyclechassistype" */
  MotorcycleChassisType_stream: Array<MotorcycleChassisType_Vpic>;
  /** fetch data from the table: "vpic.motorcyclesuspensiontype" */
  MotorcycleSuspensionType: Array<MotorcycleSuspensionType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.motorcyclesuspensiontype" */
  MotorcycleSuspensionType_aggregate: MotorcycleSuspensionType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.motorcyclesuspensiontype" using primary key columns */
  MotorcycleSuspensionType_by_pk?: Maybe<MotorcycleSuspensionType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.motorcyclesuspensiontype" */
  MotorcycleSuspensionType_stream: Array<MotorcycleSuspensionType_Vpic>;
  /** fetch data from the table: "vpic.nonlanduse" */
  NonLandUse: Array<NonLandUse_Vpic>;
  /** fetch aggregated fields from the table: "vpic.nonlanduse" */
  NonLandUse_aggregate: NonLandUse_Aggregate_Vpic;
  /** fetch data from the table: "vpic.nonlanduse" using primary key columns */
  NonLandUse_by_pk?: Maybe<NonLandUse_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.nonlanduse" */
  NonLandUse_stream: Array<NonLandUse_Vpic>;
  /** fetch data from the table: "vpic.parkassist" */
  ParkAssist: Array<ParkAssist_Vpic>;
  /** fetch aggregated fields from the table: "vpic.parkassist" */
  ParkAssist_aggregate: ParkAssist_Aggregate_Vpic;
  /** fetch data from the table: "vpic.parkassist" using primary key columns */
  ParkAssist_by_pk?: Maybe<ParkAssist_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.parkassist" */
  ParkAssist_stream: Array<ParkAssist_Vpic>;
  /** fetch data from the table: "vpic.pattern" */
  Pattern: Array<Pattern_Vpic>;
  /** fetch aggregated fields from the table: "vpic.pattern" */
  Pattern_aggregate: Pattern_Aggregate_Vpic;
  /** fetch data from the table: "vpic.pattern" using primary key columns */
  Pattern_by_pk?: Maybe<Pattern_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.pattern" */
  Pattern_stream: Array<Pattern_Vpic>;
  /** fetch data from the table: "vpic.pedestrianautomaticemergencybraking" */
  PedestrianAutomaticEmergencyBraking: Array<PedestrianAutomaticEmergencyBraking_Vpic>;
  /** fetch aggregated fields from the table: "vpic.pedestrianautomaticemergencybraking" */
  PedestrianAutomaticEmergencyBraking_aggregate: PedestrianAutomaticEmergencyBraking_Aggregate_Vpic;
  /** fetch data from the table: "vpic.pedestrianautomaticemergencybraking" using primary key columns */
  PedestrianAutomaticEmergencyBraking_by_pk?: Maybe<PedestrianAutomaticEmergencyBraking_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.pedestrianautomaticemergencybraking" */
  PedestrianAutomaticEmergencyBraking_stream: Array<PedestrianAutomaticEmergencyBraking_Vpic>;
  /** fetch data from the table: "vpic.pretensioner" */
  Pretensioner: Array<Pretensioner_Vpic>;
  /** fetch aggregated fields from the table: "vpic.pretensioner" */
  Pretensioner_aggregate: Pretensioner_Aggregate_Vpic;
  /** fetch data from the table: "vpic.pretensioner" using primary key columns */
  Pretensioner_by_pk?: Maybe<Pretensioner_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.pretensioner" */
  Pretensioner_stream: Array<Pretensioner_Vpic>;
  /** fetch data from the table: "vpic.rearautomaticemergencybraking" */
  RearAutomaticEmergencyBraking: Array<RearAutomaticEmergencyBraking_Vpic>;
  /** fetch aggregated fields from the table: "vpic.rearautomaticemergencybraking" */
  RearAutomaticEmergencyBraking_aggregate: RearAutomaticEmergencyBraking_Aggregate_Vpic;
  /** fetch data from the table: "vpic.rearautomaticemergencybraking" using primary key columns */
  RearAutomaticEmergencyBraking_by_pk?: Maybe<RearAutomaticEmergencyBraking_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.rearautomaticemergencybraking" */
  RearAutomaticEmergencyBraking_stream: Array<RearAutomaticEmergencyBraking_Vpic>;
  /** fetch data from the table: "vpic.rearcrosstrafficalert" */
  RearCrossTrafficAlert: Array<RearCrossTrafficAlert_Vpic>;
  /** fetch aggregated fields from the table: "vpic.rearcrosstrafficalert" */
  RearCrossTrafficAlert_aggregate: RearCrossTrafficAlert_Aggregate_Vpic;
  /** fetch data from the table: "vpic.rearcrosstrafficalert" using primary key columns */
  RearCrossTrafficAlert_by_pk?: Maybe<RearCrossTrafficAlert_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.rearcrosstrafficalert" */
  RearCrossTrafficAlert_stream: Array<RearCrossTrafficAlert_Vpic>;
  /** fetch data from the table: "vpic.rearvisibilitycamera" */
  RearVisibilityCamera: Array<RearVisibilityCamera_Vpic>;
  /** fetch aggregated fields from the table: "vpic.rearvisibilitycamera" */
  RearVisibilityCamera_aggregate: RearVisibilityCamera_Aggregate_Vpic;
  /** fetch data from the table: "vpic.rearvisibilitycamera" using primary key columns */
  RearVisibilityCamera_by_pk?: Maybe<RearVisibilityCamera_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.rearvisibilitycamera" */
  RearVisibilityCamera_stream: Array<RearVisibilityCamera_Vpic>;
  /** fetch data from the table: "vpic.seatbeltsall" */
  SeatBeltsAll: Array<SeatBeltsAll_Vpic>;
  /** fetch aggregated fields from the table: "vpic.seatbeltsall" */
  SeatBeltsAll_aggregate: SeatBeltsAll_Aggregate_Vpic;
  /** fetch data from the table: "vpic.seatbeltsall" using primary key columns */
  SeatBeltsAll_by_pk?: Maybe<SeatBeltsAll_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.seatbeltsall" */
  SeatBeltsAll_stream: Array<SeatBeltsAll_Vpic>;
  /** fetch data from the table: "vpic.semiautomaticheadlampbeamswitching" */
  SemiautomaticHeadlampBeamSwitching: Array<SemiautomaticHeadlampBeamSwitching_Vpic>;
  /** fetch aggregated fields from the table: "vpic.semiautomaticheadlampbeamswitching" */
  SemiautomaticHeadlampBeamSwitching_aggregate: SemiautomaticHeadlampBeamSwitching_Aggregate_Vpic;
  /** fetch data from the table: "vpic.semiautomaticheadlampbeamswitching" using primary key columns */
  SemiautomaticHeadlampBeamSwitching_by_pk?: Maybe<SemiautomaticHeadlampBeamSwitching_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.semiautomaticheadlampbeamswitching" */
  SemiautomaticHeadlampBeamSwitching_stream: Array<SemiautomaticHeadlampBeamSwitching_Vpic>;
  /** fetch data from the table: "vpic.steering" */
  Steering: Array<Steering_Vpic>;
  /** fetch aggregated fields from the table: "vpic.steering" */
  Steering_aggregate: Steering_Aggregate_Vpic;
  /** fetch data from the table: "vpic.steering" using primary key columns */
  Steering_by_pk?: Maybe<Steering_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.steering" */
  Steering_stream: Array<Steering_Vpic>;
  /** fetch data from the table: "vpic.tpms" */
  TPMS: Array<Tpms_Vpic>;
  /** fetch aggregated fields from the table: "vpic.tpms" */
  TPMS_aggregate: Tpms_Aggregate_Vpic;
  /** fetch data from the table: "vpic.tpms" using primary key columns */
  TPMS_by_pk?: Maybe<Tpms_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.tpms" */
  TPMS_stream: Array<Tpms_Vpic>;
  /** fetch data from the table: "vpic.tractioncontrol" */
  TractionControl: Array<TractionControl_Vpic>;
  /** fetch aggregated fields from the table: "vpic.tractioncontrol" */
  TractionControl_aggregate: TractionControl_Aggregate_Vpic;
  /** fetch data from the table: "vpic.tractioncontrol" using primary key columns */
  TractionControl_by_pk?: Maybe<TractionControl_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.tractioncontrol" */
  TractionControl_stream: Array<TractionControl_Vpic>;
  /** fetch data from the table: "vpic.trailerbodytype" */
  TrailerBodyType: Array<TrailerBodyType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.trailerbodytype" */
  TrailerBodyType_aggregate: TrailerBodyType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.trailerbodytype" using primary key columns */
  TrailerBodyType_by_pk?: Maybe<TrailerBodyType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.trailerbodytype" */
  TrailerBodyType_stream: Array<TrailerBodyType_Vpic>;
  /** fetch data from the table: "vpic.trailertype" */
  TrailerType: Array<TrailerType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.trailertype" */
  TrailerType_aggregate: TrailerType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.trailertype" using primary key columns */
  TrailerType_by_pk?: Maybe<TrailerType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.trailertype" */
  TrailerType_stream: Array<TrailerType_Vpic>;
  /** fetch data from the table: "vpic.transmission" */
  Transmission: Array<Transmission_Vpic>;
  /** fetch aggregated fields from the table: "vpic.transmission" */
  Transmission_aggregate: Transmission_Aggregate_Vpic;
  /** fetch data from the table: "vpic.transmission" using primary key columns */
  Transmission_by_pk?: Maybe<Transmission_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.transmission" */
  Transmission_stream: Array<Transmission_Vpic>;
  /** fetch data from the table: "vpic.turbo" */
  Turbo: Array<Turbo_Vpic>;
  /** fetch aggregated fields from the table: "vpic.turbo" */
  Turbo_aggregate: Turbo_Aggregate_Vpic;
  /** fetch data from the table: "vpic.turbo" using primary key columns */
  Turbo_by_pk?: Maybe<Turbo_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.turbo" */
  Turbo_stream: Array<Turbo_Vpic>;
  /** fetch data from the table: "vpic.vspecschemapattern" */
  VSpecSchemaPattern: Array<VSpecSchemaPattern_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vspecschemapattern" */
  VSpecSchemaPattern_aggregate: VSpecSchemaPattern_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vspecschemapattern" using primary key columns */
  VSpecSchemaPattern_by_pk?: Maybe<VSpecSchemaPattern_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.vspecschemapattern" */
  VSpecSchemaPattern_stream: Array<VSpecSchemaPattern_Vpic>;
  /** fetch data from the table: "vpic.valvetraindesign" */
  ValvetrainDesign: Array<ValvetrainDesign_Vpic>;
  /** fetch aggregated fields from the table: "vpic.valvetraindesign" */
  ValvetrainDesign_aggregate: ValvetrainDesign_Aggregate_Vpic;
  /** fetch data from the table: "vpic.valvetraindesign" using primary key columns */
  ValvetrainDesign_by_pk?: Maybe<ValvetrainDesign_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.valvetraindesign" */
  ValvetrainDesign_stream: Array<ValvetrainDesign_Vpic>;
  /** fetch data from the table: "vpic.vehiclespecpattern" */
  VehicleSpecPattern: Array<VehicleSpecPattern_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vehiclespecpattern" */
  VehicleSpecPattern_aggregate: VehicleSpecPattern_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vehiclespecpattern" using primary key columns */
  VehicleSpecPattern_by_pk?: Maybe<VehicleSpecPattern_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.vehiclespecpattern" */
  VehicleSpecPattern_stream: Array<VehicleSpecPattern_Vpic>;
  /** fetch data from the table: "vpic.vehiclespecschema" */
  VehicleSpecSchema: Array<VehicleSpecSchema_Vpic>;
  /** fetch data from the table: "vpic.vehiclespecschema_model" */
  VehicleSpecSchema_Model: Array<VehicleSpecSchema_Model_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vehiclespecschema_model" */
  VehicleSpecSchema_Model_aggregate: VehicleSpecSchema_Model_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vehiclespecschema_model" using primary key columns */
  VehicleSpecSchema_Model_by_pk?: Maybe<VehicleSpecSchema_Model_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.vehiclespecschema_model" */
  VehicleSpecSchema_Model_stream: Array<VehicleSpecSchema_Model_Vpic>;
  /** fetch data from the table: "vpic.vehiclespecschema_year" */
  VehicleSpecSchema_Year: Array<VehicleSpecSchema_Year_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vehiclespecschema_year" */
  VehicleSpecSchema_Year_aggregate: VehicleSpecSchema_Year_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vehiclespecschema_year" using primary key columns */
  VehicleSpecSchema_Year_by_pk?: Maybe<VehicleSpecSchema_Year_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.vehiclespecschema_year" */
  VehicleSpecSchema_Year_stream: Array<VehicleSpecSchema_Year_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vehiclespecschema" */
  VehicleSpecSchema_aggregate: VehicleSpecSchema_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vehiclespecschema" using primary key columns */
  VehicleSpecSchema_by_pk?: Maybe<VehicleSpecSchema_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.vehiclespecschema" */
  VehicleSpecSchema_stream: Array<VehicleSpecSchema_Vpic>;
  /** fetch data from the table: "vpic.vehicletype" */
  VehicleType: Array<VehicleType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vehicletype" */
  VehicleType_aggregate: VehicleType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vehicletype" using primary key columns */
  VehicleType_by_pk?: Maybe<VehicleType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.vehicletype" */
  VehicleType_stream: Array<VehicleType_Vpic>;
  /** fetch data from the table: "vpic.vindescriptor" */
  VinDescriptor: Array<VinDescriptor_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vindescriptor" */
  VinDescriptor_aggregate: VinDescriptor_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vindescriptor" using primary key columns */
  VinDescriptor_by_pk?: Maybe<VinDescriptor_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.vindescriptor" */
  VinDescriptor_stream: Array<VinDescriptor_Vpic>;
  /** fetch data from the table: "vpic.vinexception" */
  VinException: Array<VinException_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vinexception" */
  VinException_aggregate: VinException_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vinexception" using primary key columns */
  VinException_by_pk?: Maybe<VinException_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.vinexception" */
  VinException_stream: Array<VinException_Vpic>;
  /** fetch data from the table: "vpic.vinschema" */
  VinSchema: Array<VinSchema_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vinschema" */
  VinSchema_aggregate: VinSchema_Aggregate_Vpic;
  /** fetch data from the table: "vpic.vinschema" using primary key columns */
  VinSchema_by_pk?: Maybe<VinSchema_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.vinschema" */
  VinSchema_stream: Array<VinSchema_Vpic>;
  /** fetch data from the table: "vpic.wmiyearvalidchars" */
  WMIYearValidChars: Array<WmiYearValidChars_Vpic>;
  /** fetch data from the table: "vpic.wmiyearvalidchars_cacheexceptions" */
  WMIYearValidChars_CacheExceptions: Array<WmiYearValidChars_CacheExceptions_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wmiyearvalidchars_cacheexceptions" */
  WMIYearValidChars_CacheExceptions_aggregate: WmiYearValidChars_CacheExceptions_Aggregate_Vpic;
  /** fetch data from the table in a streaming manner: "vpic.wmiyearvalidchars_cacheexceptions" */
  WMIYearValidChars_CacheExceptions_stream: Array<WmiYearValidChars_CacheExceptions_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wmiyearvalidchars" */
  WMIYearValidChars_aggregate: WmiYearValidChars_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wmiyearvalidchars" using primary key columns */
  WMIYearValidChars_by_pk?: Maybe<WmiYearValidChars_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.wmiyearvalidchars" */
  WMIYearValidChars_stream: Array<WmiYearValidChars_Vpic>;
  /** fetch data from the table: "vpic.wheelbasetype" */
  WheelBaseType: Array<WheelBaseType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wheelbasetype" */
  WheelBaseType_aggregate: WheelBaseType_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wheelbasetype" using primary key columns */
  WheelBaseType_by_pk?: Maybe<WheelBaseType_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.wheelbasetype" */
  WheelBaseType_stream: Array<WheelBaseType_Vpic>;
  /** fetch data from the table: "vpic.wheeliemitigation" */
  WheelieMitigation: Array<WheelieMitigation_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wheeliemitigation" */
  WheelieMitigation_aggregate: WheelieMitigation_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wheeliemitigation" using primary key columns */
  WheelieMitigation_by_pk?: Maybe<WheelieMitigation_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.wheeliemitigation" */
  WheelieMitigation_stream: Array<WheelieMitigation_Vpic>;
  /** fetch data from the table: "vpic.wmi" */
  Wmi: Array<Wmi_Vpic>;
  /** fetch data from the table: "vpic.wmi_make" */
  Wmi_Make: Array<Wmi_Make_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wmi_make" */
  Wmi_Make_aggregate: Wmi_Make_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wmi_make" using primary key columns */
  Wmi_Make_by_pk?: Maybe<Wmi_Make_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.wmi_make" */
  Wmi_Make_stream: Array<Wmi_Make_Vpic>;
  /** fetch data from the table: "vpic.wmi_vinschema" */
  Wmi_VinSchema: Array<Wmi_VinSchema_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wmi_vinschema" */
  Wmi_VinSchema_aggregate: Wmi_VinSchema_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wmi_vinschema" using primary key columns */
  Wmi_VinSchema_by_pk?: Maybe<Wmi_VinSchema_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.wmi_vinschema" */
  Wmi_VinSchema_stream: Array<Wmi_VinSchema_Vpic>;
  /** fetch aggregated fields from the table: "vpic.wmi" */
  Wmi_aggregate: Wmi_Aggregate_Vpic;
  /** fetch data from the table: "vpic.wmi" using primary key columns */
  Wmi_by_pk?: Maybe<Wmi_Vpic>;
  /** fetch data from the table in a streaming manner: "vpic.wmi" */
  Wmi_stream: Array<Wmi_Vpic>;
  /** fetch data from the table in a streaming manner: "account_account_manager" */
  accountAccountManager_stream: Array<AccountAccountManager>;
  /** fetch data from the table in a streaming manner: "account_category" */
  accountCategory_stream: Array<AccountCategory>;
  /** fetch data from the table in a streaming manner: "account_disbursement" */
  accountDisbursement_stream: Array<AccountDisbursement>;
  /** fetch data from the table in a streaming manner: "account_manager" */
  accountManager_stream: Array<AccountManager>;
  /** fetch data from the table in a streaming manner: "account_product_obligor" */
  accountProductObligor_stream: Array<AccountProductObligor>;
  /** fetch data from the table in a streaming manner: "account_product" */
  accountProduct_stream: Array<AccountProduct>;
  /** fetch data from the table in a streaming manner: "account_retail" */
  accountRetail_stream: Array<AccountRetail>;
  /** fetch data from the table in a streaming manner: "account_type" */
  accountType_stream: Array<AccountType>;
  /** execute function "account_search" which returns "account" */
  account_search: Array<Account>;
  /** execute function "account_search" and query aggregates on result of table type "account" */
  account_search_aggregate: Account_Aggregate;
  /** fetch data from the table in a streaming manner: "account" */
  account_stream: Array<Account>;
  /** fetch data from the table in a streaming manner: "address_type" */
  addressType_stream: Array<AddressType>;
  /** fetch data from the table in a streaming manner: "address" */
  address_stream: Array<Address>;
  /** fetch data from the table in a streaming manner: "approvals.authority" */
  approvalAuthority_stream: Array<ApprovalAuthority>;
  /** fetch data from the table in a streaming manner: "approvals.gate_binding" */
  approvalGateBinding_stream: Array<ApprovalGateBinding>;
  /** fetch data from the table in a streaming manner: "approvals.gate" */
  approvalGate_stream: Array<ApprovalGate>;
  /** execute function "approvals.headroom_for_viewer" which returns "approvals.state" */
  approvalHeadroom: Array<ApprovalState>;
  /** execute function "approvals.headroom_for_viewer" and query aggregates on result of table type "approvals.state" */
  approvalHeadroom_aggregate: ApprovalState_Aggregate;
  /** fetch data from the table in a streaming manner: "approvals.request" */
  approvalRequest_stream: Array<ApprovalRequest>;
  /** fetch data from the table in a streaming manner: "approvals.state" */
  approvalState_stream: Array<ApprovalState>;
  /** fetch data from the table in a streaming manner: "approvals.approval" */
  approval_stream: Array<Approval>;
  /** fetch data from the table in a streaming manner: "as400_data_sync" */
  as400DataSync_stream: Array<As400DataSync>;
  /** fetch data from the table: "audit.message_formatter_config" */
  audit_message_formatter_config: Array<Audit_Message_Formatter_Config>;
  /** fetch aggregated fields from the table: "audit.message_formatter_config" */
  audit_message_formatter_config_aggregate: Audit_Message_Formatter_Config_Aggregate;
  /** fetch data from the table: "audit.message_formatter_config" using primary key columns */
  audit_message_formatter_config_by_pk?: Maybe<Audit_Message_Formatter_Config>;
  /** fetch data from the table in a streaming manner: "audit.message_formatter_config" */
  audit_message_formatter_config_stream: Array<Audit_Message_Formatter_Config>;
  /** fetch data from the table: "audit.tableslist" */
  audit_tableslist: Array<Audit_Tableslist>;
  /** fetch aggregated fields from the table: "audit.tableslist" */
  audit_tableslist_aggregate: Audit_Tableslist_Aggregate;
  /** fetch data from the table in a streaming manner: "audit.tableslist" */
  audit_tableslist_stream: Array<Audit_Tableslist>;
  /** fetch data from the table: "auth.group" */
  auth_group: Array<Auth_Group>;
  /** fetch data from the table: "auth.group_actions" */
  auth_group_actions: Array<Auth_Group_Actions>;
  /** fetch aggregated fields from the table: "auth.group_actions" */
  auth_group_actions_aggregate: Auth_Group_Actions_Aggregate;
  /** fetch data from the table: "auth.group_actions" using primary key columns */
  auth_group_actions_by_pk?: Maybe<Auth_Group_Actions>;
  /** fetch data from the table in a streaming manner: "auth.group_actions" */
  auth_group_actions_stream: Array<Auth_Group_Actions>;
  /** fetch aggregated fields from the table: "auth.group" */
  auth_group_aggregate: Auth_Group_Aggregate;
  /** fetch data from the table: "auth.group" using primary key columns */
  auth_group_by_pk?: Maybe<Auth_Group>;
  /** fetch data from the table in a streaming manner: "auth.group" */
  auth_group_stream: Array<Auth_Group>;
  /** fetch data from the table in a streaming manner: "caddy.caddy_server_manager_log" */
  caddyServerManagerLog_stream: Array<CaddyServerManagerLog>;
  /** fetch data from the table in a streaming manner: "caddy.caddy" */
  caddy_stream: Array<Caddy>;
  /** fetch data from the table in a streaming manner: "operations.cancellation" */
  cancellation_stream: Array<Cancellation>;
  /** fetch data from the table in a streaming manner: "auth.capability_config" */
  capabilityConfig_stream: Array<CapabilityConfig>;
  /** fetch data from the table in a streaming manner: "auth.capability_route" */
  capabilityRoute_stream: Array<CapabilityRoute>;
  /** fetch data from the table in a streaming manner: "auth.capability" */
  capability_stream: Array<Capability>;
  /** fetch data from the table in a streaming manner: "carrier" */
  carrier_stream: Array<Carrier>;
  /** fetch data from the table in a streaming manner: "category_product_attribute_type" */
  categoryProductAttributeType_stream: Array<CategoryProductAttributeType>;
  /** fetch data from the table in a streaming manner: "category" */
  category_stream: Array<Category>;
  /** fetch data from the table in a streaming manner: "claims.claim_detail_category" */
  claimDetailCategory_stream: Array<ClaimDetailCategory>;
  /** fetch data from the table in a streaming manner: "claims.claim_detail_part_lookup" */
  claimDetailPartLookup_stream: Array<ClaimDetailPartLookup>;
  /** fetch data from the table in a streaming manner: "claims.claim_detail" */
  claimDetail_stream: Array<ClaimDetail>;
  /** fetch data from the table in a streaming manner: "claims.claim_part" */
  claimPart_stream: Array<ClaimPart>;
  /** fetch data from the table in a streaming manner: "claims.claim_service_center_authorization" */
  claimServiceCenterAuthorization_stream: Array<ClaimServiceCenterAuthorization>;
  /** fetch data from the table in a streaming manner: "claims.claim_service_center" */
  claimServiceCenter_stream: Array<ClaimServiceCenter>;
  /** fetch data from the table in a streaming manner: "claim_status_type" */
  claimStatusType_stream: Array<ClaimStatusType>;
  /** fetch data from the table in a streaming manner: "claim" */
  claim_stream: Array<Claim>;
  /** fetch data from the table: "claims.pre_authorization_vehicle_information" */
  claims_pre_authorization_vehicle_information: Array<Claims_Pre_Authorization_Vehicle_Information>;
  /** fetch aggregated fields from the table: "claims.pre_authorization_vehicle_information" */
  claims_pre_authorization_vehicle_information_aggregate: Claims_Pre_Authorization_Vehicle_Information_Aggregate;
  /** fetch data from the table: "claims.pre_authorization_vehicle_information" using primary key columns */
  claims_pre_authorization_vehicle_information_by_pk?: Maybe<Claims_Pre_Authorization_Vehicle_Information>;
  /** fetch data from the table in a streaming manner: "claims.pre_authorization_vehicle_information" */
  claims_pre_authorization_vehicle_information_stream: Array<Claims_Pre_Authorization_Vehicle_Information>;
  /** fetch data from the table: "claims.temp_claims_auth_table" */
  claims_temp_claims_auth_table: Array<Claims_Temp_Claims_Auth_Table>;
  /** fetch aggregated fields from the table: "claims.temp_claims_auth_table" */
  claims_temp_claims_auth_table_aggregate: Claims_Temp_Claims_Auth_Table_Aggregate;
  /** fetch data from the table: "claims.temp_claims_auth_table" using primary key columns */
  claims_temp_claims_auth_table_by_pk?: Maybe<Claims_Temp_Claims_Auth_Table>;
  /** fetch data from the table in a streaming manner: "claims.temp_claims_auth_table" */
  claims_temp_claims_auth_table_stream: Array<Claims_Temp_Claims_Auth_Table>;
  /** fetch data from the table in a streaming manner: "classes.class_criteria_view_default_vehicle_criteria" */
  classCriteriaViewDefaultVehicleCriteria_stream: Array<ClassCriteriaViewDefaultVehicleCriteria>;
  /** fetch data from the table in a streaming manner: "classes.class_criteria_view_unclassed_default_vehicle_criteria" */
  classCriteriaViewUnclassedDefaultVehicleCriteria_stream: Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria>;
  /** fetch data from the table in a streaming manner: "classes.class_criteria" */
  classCriteria_stream: Array<ClassCriteria>;
  /** fetch data from the table in a streaming manner: "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
  classGuideClassCriteriaViewDefaultVehicleCriteria_stream: Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria>;
  /** fetch data from the table in a streaming manner: "classes.class_guide_class_criteria_view_vin" */
  classGuideClassCriteriaViewVin_stream: Array<ClassGuideClassCriteriaViewVin>;
  /** fetch data from the table in a streaming manner: "classes.class_guide_class_criteria" */
  classGuideClassCriteria_stream: Array<ClassGuideClassCriteria>;
  /** fetch data from the table in a streaming manner: "classes.class_guide_criteria_definition" */
  classGuideCriteriaDefinition_stream: Array<ClassGuideCriteriaDefinition>;
  /** fetch data from the table in a streaming manner: "classes.class_guide_criteria_type" */
  classGuideCriteriaType_stream: Array<ClassGuideCriteriaType>;
  /** fetch data from the table in a streaming manner: "classes.class_guide" */
  classGuide_stream: Array<ClassGuide>;
  /** fetch data from the table: "nhtsa.concern_synonym" using primary key columns */
  concernSynonym_by_pk?: Maybe<ConcernSynonym_Nhtsa>;
  /** fetch data from the table in a streaming manner: "nhtsa.concern_synonym" */
  concernSynonym_stream: Array<ConcernSynonym_Nhtsa>;
  /** fetch data from the table in a streaming manner: "configuration_item_type" */
  configurationItemType_stream: Array<ConfigurationItemType>;
  /** fetch data from the table in a streaming manner: "configuration_item" */
  configurationItem_stream: Array<ConfigurationItem>;
  /** fetch data from the table in a streaming manner: "contact" */
  contact_stream: Array<Contact>;
  /** fetch data from the table in a streaming manner: "compliance.contract_form_filing_status" */
  contractFormFilingStatusStream: Array<ContractFormFilingStatus>;
  /** fetch data from the table in a streaming manner: "compliance.contract_form" */
  contractFormStream: Array<ContractForm>;
  /** fetch data from the table in a streaming manner: "compliance.contract_form_version" */
  contractFormStreamVersion: Array<ContractFormVersion>;
  /** fetch data from the table in a streaming manner: "compliance.contract_form_type" */
  contractFormType_stream: Array<ContractFormType>;
  /** fetch data from the table in a streaming manner: "contract_status_type" */
  contractStatusType_stream: Array<ContractStatusType>;
  /** fetch data from the table in a streaming manner: "contract" */
  contract_stream: Array<Contract>;
  /** fetch data from the table in a streaming manner: "cost_adjustment_extended_cost" */
  costAdjustmentExtendedCost_stream: Array<CostAdjustmentExtendedCost>;
  /** fetch data from the table in a streaming manner: "cost_adjustment_lookup" */
  costAdjustmentLookup_stream: Array<CostAdjustmentLookup>;
  /** fetch data from the table in a streaming manner: "cost_adjustment_type" */
  costAdjustmentType_stream: Array<CostAdjustmentType>;
  /** fetch data from the table in a streaming manner: "cost_adjustment" */
  costAdjustment_stream: Array<CostAdjustment>;
  /** fetch data from the table in a streaming manner: "custom_field_data" */
  customFieldData_stream: Array<CustomFieldData>;
  /** fetch data from the table in a streaming manner: "custom_field_type" */
  customFieldType_stream: Array<CustomFieldType>;
  /** fetch data from the table in a streaming manner: "custom_field" */
  customField_stream: Array<CustomField>;
  /** fetch data from the table in a streaming manner: "customer" */
  customer_stream: Array<Customer>;
  /** fetch data from the table in a streaming manner: "data_type" */
  dataType_stream: Array<DataType>;
  /** fetch data from the table in a streaming manner: "dealer_payment_type" */
  dealerPaymentType_stream: Array<DealerPaymentType>;
  /** fetch data from the table in a streaming manner: "disbursement_type" */
  disbursementType_stream: Array<DisbursementType>;
  /** fetch data from the table in a streaming manner: "claims.document" */
  document_stream: Array<Document>;
  /** fetch data from the table in a streaming manner: "eligibility_rule_definition" */
  eligibilityRuleDefinition_stream: Array<EligibilityRuleDefinition>;
  /** fetch data from the table in a streaming manner: "eligibility_rule" */
  eligibilityRule_stream: Array<EligibilityRule>;
  /** fetch data from the table in a streaming manner: "eligibility_type" */
  eligibilityType_stream: Array<EligibilityType>;
  /** fetch data from the table in a streaming manner: "shared.entity_billing_information" */
  entityBillingInformation_stream: Array<EntityBillingInformation>;
  /** fetch data from the table in a streaming manner: "entity_configuration_item" */
  entityConfigurationItem_stream: Array<EntityConfigurationItem>;
  /** fetch data from the table in a streaming manner: "entity_custom_field_value" */
  entityCustomFieldValue_stream: Array<EntityCustomFieldValue>;
  /** fetch data from the table in a streaming manner: "entity_custom_field" */
  entityCustomField_stream: Array<EntityCustomField>;
  /** fetch data from the table in a streaming manner: "entity_data_definition" */
  entityDataDefinition_stream: Array<EntityDataDefinition>;
  /** fetch data from the table in a streaming manner: "entity_eligibility_rule" */
  entityEligibilityRule_stream: Array<EntityEligibilityRule>;
  /** fetch data from the table in a streaming manner: "shared.entity_file_storage" */
  entityFileStorage_stream: Array<EntityFileStorage>;
  /** fetch data from the table in a streaming manner: "auth.entity_note_capability_view" */
  entityNoteCapabilityView_stream: Array<EntityNoteCapabilityView>;
  /** fetch data from the table in a streaming manner: "shared.entity_note" */
  entityNote_stream: Array<EntityNote>;
  /** fetch data from the table in a streaming manner: "entity_offering" */
  entityOffering_stream: Array<EntityOffering>;
  /** fetch data from the table in a streaming manner: "shared.entity_remittance_detail" */
  entityRemittanceDetail_stream: Array<EntityRemittanceDetail>;
  /** fetch data from the table in a streaming manner: "shared.entity_tag" */
  entityTag_stream: Array<EntityTag>;
  /** fetch data from the table in a streaming manner: "shared.file_storage_type" */
  fileStorageType_stream: Array<FileStorageType>;
  /** fetch data from the table in a streaming manner: "shared.file_storage" */
  fileStorage_stream: Array<FileStorage>;
  /** fetch data from the table in a streaming manner: "compliance.filing_lender" */
  filingLenderStream: Array<FilingLender>;
  /** fetch data from the table in a streaming manner: "compliance.filing_state" */
  filingStatesStream: Array<FilingState>;
  /** fetch data from the table in a streaming manner: "compliance.filing_status_type" */
  filingStatusTypeStream: Array<FilingStatusType>;
  getDistinctMakes: Array<Vpic_Criteria_Make>;
  /** fetch data from the table: "identities" */
  identities: Array<Identities>;
  /** fetch aggregated fields from the table: "identities" */
  identities_aggregate: Identities_Aggregate;
  /** fetch data from the table: "identities" using primary key columns */
  identities_by_pk?: Maybe<Identities>;
  /** fetch data from the table in a streaming manner: "identities" */
  identities_stream: Array<Identities>;
  /** fetch data from the table in a streaming manner: "auth.identity_capability_view" */
  identityCapabilityView_stream: Array<IdentityCapabilityView>;
  /** fetch data from the table in a streaming manner: "auth.identity_capability" */
  identityCapability_stream: Array<IdentityCapability>;
  /** fetch data from the table in a streaming manner: "auth.identity_entity_view" */
  identityEntityView_stream: Array<IdentityEntityView>;
  /** fetch data from the table in a streaming manner: "auth.identity_entity" */
  identityEntity_stream: Array<IdentityEntity>;
  /** fetch data from the table in a streaming manner: "nhtsa.investigation_recall" */
  investigationRecall_stream: Array<InvestigationRecall_Nhtsa>;
  /** fetch data from the table in a streaming manner: "claims.invoice_document_type" */
  invoiceDocumentType_stream: Array<InvoiceDocumentType>;
  /** fetch data from the table in a streaming manner: "claims.invoice_payment_type" */
  invoicePaymentType_stream: Array<InvoicePaymentType>;
  /** fetch data from the table in a streaming manner: "claims.invoice" */
  invoice_stream: Array<Invoice>;
  /** fetch data from the table in a streaming manner: "nhtsa.issue_make_model" */
  issueMakeModel_stream: Array<IssueMakeModel_Nhtsa>;
  /** fetch data from the table in a streaming manner: "nhtsa.issue_search_result" */
  issueSearchResult_stream: Array<IssueSearchResult_Nhtsa>;
  /** fetch data from the table in a streaming manner: "nhtsa.issue_vehicle" */
  issueVehicle_stream: Array<IssueVehicle_Nhtsa>;
  /** fetch data from the table in a streaming manner: "nhtsa.issue" */
  issue_stream: Array<Issue_Nhtsa>;
  /** fetch data from the table in a streaming manner: "system.job_schedule" */
  jobSchedule_stream: Array<JobSchedule>;
  /** fetch data from the table in a streaming manner: "labor_guide_type" */
  laborGuideType_stream: Array<LaborGuideType>;
  /** fetch data from the table in a streaming manner: "operations.legacy_policy_contract" */
  legacyPolicyContract_stream: Array<LegacyPolicyContract>;
  /** fetch data from the table in a streaming manner: "dealer" */
  legacy_claims_dealer_stream: Array<Legacy_Claims_Dealer>;
  /** fetch data from the table in a streaming manner: "note" */
  legacy_claims_note_stream: Array<Legacy_Claims_Note>;
  /** fetch data from the table: "dealer" using primary key columns */
  legacy_claims_selectDealer?: Maybe<Legacy_Claims_Dealer>;
  /** fetch aggregated fields from the table: "dealer" */
  legacy_claims_selectDealerAggregate: Legacy_Claims_Dealer_Aggregate;
  /** fetch data from the table: "dealer" */
  legacy_claims_selectDealers: Array<Legacy_Claims_Dealer>;
  /** fetch data from the table: "note" using primary key columns */
  legacy_claims_selectNote?: Maybe<Legacy_Claims_Note>;
  /** fetch aggregated fields from the table: "note" */
  legacy_claims_selectNoteAggregate: Legacy_Claims_Note_Aggregate;
  /** fetch data from the table: "note" */
  legacy_claims_selectNotes: Array<Legacy_Claims_Note>;
  /** fetch data from the table in a streaming manner: "nhtsa.load" */
  load_stream: Array<Load_Nhtsa>;
  /** fetch data from the table in a streaming manner: "audit.logged_actions" */
  loggedAction_stream: Array<LoggedAction>;
  /** fetch data from the table in a streaming manner: "nhtsa.make_model" */
  makeModel_stream: Array<MakeModel_Nhtsa>;
  /** fetch data from the table in a streaming manner: "classes.materalized_class_criteria_view_default_vehicle_criteria" */
  materalizedClassCriteriaViewDefaultVehicleCriteria_stream: Array<MateralizedClassCriteriaViewDefaultVehicleCriteria>;
  /** fetch data from the table: "nhtsa.model_year_model" using primary key columns */
  modelYearModel_by_pk?: Maybe<ModelYearModel_Nhtsa>;
  /** fetch data from the table in a streaming manner: "nhtsa.model_year_model" */
  modelYearModel_stream: Array<ModelYearModel_Nhtsa>;
  /** fetch data from the table in a streaming manner: "obligor" */
  obligor_stream: Array<Obligor>;
  /** fetch data from the table in a streaming manner: "job" */
  obsoleteJob_stream: Array<ObsoleteJob>;
  /** fetch data from the table: "operations.legacy_policy_contract_cost_detail_view" */
  operations_legacy_policy_contract_cost_detail_view: Array<Operations_Legacy_Policy_Contract_Cost_Detail_View>;
  /** fetch aggregated fields from the table: "operations.legacy_policy_contract_cost_detail_view" */
  operations_legacy_policy_contract_cost_detail_view_aggregate: Operations_Legacy_Policy_Contract_Cost_Detail_View_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.legacy_policy_contract_cost_detail_view" */
  operations_legacy_policy_contract_cost_detail_view_stream: Array<Operations_Legacy_Policy_Contract_Cost_Detail_View>;
  /** fetch data from the table: "operations.legacy_policy_contract_list_materialized_view" */
  operations_legacy_policy_contract_list_materialized_view: Array<Operations_Legacy_Policy_Contract_List_Materialized_View>;
  /** fetch aggregated fields from the table: "operations.legacy_policy_contract_list_materialized_view" */
  operations_legacy_policy_contract_list_materialized_view_aggregate: Operations_Legacy_Policy_Contract_List_Materialized_View_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.legacy_policy_contract_list_materialized_view" */
  operations_legacy_policy_contract_list_materialized_view_stream: Array<Operations_Legacy_Policy_Contract_List_Materialized_View>;
  /** fetch data from the table in a streaming manner: "accounting.payee_as400" */
  payeeAs400_stream: Array<PayeeAs400>;
  /** fetch data from the table in a streaming manner: "accounting.payee_link_view" */
  payeeLinkView_stream: Array<PayeeLinkView>;
  /** fetch data from the table in a streaming manner: "accounting.payee" */
  payee_stream: Array<Payee>;
  /** fetch data from the table in a streaming manner: "shared.payment_detail" */
  paymentDetail_stream: Array<PaymentDetail>;
  /** fetch data from the table in a streaming manner: "shared.payment_status_type" */
  paymentStatusType_stream: Array<PaymentStatusType>;
  /** fetch data from the table in a streaming manner: "shared.payment_type" */
  paymentType_stream: Array<PaymentType>;
  /** fetch data from the table in a streaming manner: "shared.payment" */
  payment_stream: Array<Payment>;
  /** fetch data from the table in a streaming manner: "claims.policy_claim_concern" */
  policyClaimConcern_stream: Array<PolicyClaimConcern>;
  /** fetch data from the table in a streaming manner: "claims.policy_claim" */
  policyClaim_stream: Array<PolicyClaim>;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_contract_form_version" */
  policyContractContractFormVersion_stream: Array<PolicyContractContractFormVersion>;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_list_view" */
  policyContractListView_stream: Array<PolicyContractListView>;
  /** fetch data from the table in a streaming manner: "product_attribute_type" */
  productAttributeType_stream: Array<ProductAttributeType>;
  /** fetch data from the table in a streaming manner: "product_attribute" */
  productAttribute_stream: Array<ProductAttribute>;
  /** fetch data from the table in a streaming manner: "product_class_guide" */
  productClassGuide_stream: Array<ProductClassGuide>;
  /** fetch data from the table in a streaming manner: "compliance.product_contract_form" */
  productContractFormsStream: Array<ProductContractForm>;
  /** fetch data from the table in a streaming manner: "product_cost" */
  productCost_stream: Array<ProductCost>;
  /** fetch data from the table in a streaming manner: "product_disbursement" */
  productDisbursement_stream: Array<ProductDisbursement>;
  /** fetch data from the table in a streaming manner: "product_eligibility_rule" */
  productEligibility_stream: Array<ProductEligibility>;
  /** fetch data from the table in a streaming manner: "product_obligor" */
  productObligor_stream: Array<ProductObligor>;
  /** fetch data from the table in a streaming manner: "product_rate_bucket" */
  productRateBucket_stream: Array<ProductRateBucket>;
  /** fetch data from the table in a streaming manner: "product_surcharge_type" */
  productSurchargeType_stream: Array<ProductSurchargeType>;
  /** fetch data from the table in a streaming manner: "product" */
  product_stream: Array<Product>;
  /** fetch data from the table in a streaming manner: "quotes.quote_minimal_view" */
  quoteMinimalView_stream: Array<QuoteMinimalView>;
  /** fetch data from the table in a streaming manner: "quotes.quote" */
  quoteStream: Array<Quote>;
  /** fetch data from the table in a streaming manner: "quotes.quote_type" */
  quoteTypeStream: Array<QuoteType>;
  /** fetch data from the table in a streaming manner: "rate_bucket_type" */
  rateBucketType_stream: Array<RateBucketType>;
  /** fetch data from the table in a streaming manner: "rate_quote" */
  rateQuote_stream: Array<RateQuote>;
  /** fetch data from the table in a streaming manner: "nhtsa.record_type" */
  recordType_stream: Array<RecordType_Nhtsa>;
  /** fetch data from the table in a streaming manner: "claims.remittance_claim_detail" */
  remittanceClaimDetail_stream: Array<RemittanceClaimDetail>;
  /** fetch data from the table in a streaming manner: "operations.remittance_payment" */
  remittancePayment_stream: Array<RemittancePayment>;
  /** fetch data from the table in a streaming manner: "operations.remittance_policy_contract_as400" */
  remittancePolicyContractAs400_stream: Array<RemittancePolicyContractAs400>;
  /** fetch data from the table in a streaming manner: "operations.remittance_type" */
  remittanceType_stream: Array<RemittanceType>;
  /** fetch data from the table in a streaming manner: "claims.repeat_part_acknowledgment" */
  repeatPartAcknowledgment_stream: Array<RepeatPartAcknowledgment>;
  /** fetch data from the table in a streaming manner: "auth.role_attribute" */
  roleAttribute_stream: Array<RoleAttribute>;
  /** fetch data from the table in a streaming manner: "auth.role" */
  role_stream: Array<Role>;
  /** fetch data from the table in a streaming manner: "auth.route_config" */
  routeConfig_stream: Array<RouteConfig>;
  /** fetch data from the table in a streaming manner: "auth.route" */
  route_stream: Array<Route>;
  saveRateQuoteAction?: Maybe<SaveRateQuoteAction>;
  /** execute function "shared.search" which returns "shared.search_result" */
  search: Array<Shared_Search_Result>;
  /** fetch data from the table in a streaming manner: "shared.search_index" */
  searchIndex_stream: Array<SearchIndex>;
  /** execute function "nhtsa.search_issues" and query aggregates on result of table type "nhtsa.issue_search_result" */
  searchNhtsaIssueAggregate: IssueSearchResult_Aggregate_Nhtsa;
  /** execute function "nhtsa.search_issues" which returns "nhtsa.issue_search_result" */
  searchNhtsaIssues: Array<IssueSearchResult_Nhtsa>;
  /** execute function "shared.search" and query aggregates on result of table type "shared.search_result" */
  search_aggregate: Shared_Search_Result_Aggregate;
  /** fetch data from the table: "account" using primary key columns */
  selectAccount?: Maybe<Account>;
  /** fetch data from the table: "account_account_manager" using primary key columns */
  selectAccountAccountManager?: Maybe<AccountAccountManager>;
  /** fetch data from the table: "account_account_manager" */
  selectAccountAccountManagers: Array<AccountAccountManager>;
  /** fetch aggregated fields from the table: "account_account_manager" */
  selectAccountAccountManagersAggregate: AccountAccountManager_Aggregate;
  /** fetch aggregated fields from the table: "account" */
  selectAccountAggregate: Account_Aggregate;
  /** fetch data from the table: "account_category" */
  selectAccountCategories: Array<AccountCategory>;
  /** fetch data from the table: "account_category" using primary key columns */
  selectAccountCategory?: Maybe<AccountCategory>;
  /** fetch aggregated fields from the table: "account_category" */
  selectAccountCategoryAggregate: AccountCategory_Aggregate;
  /** fetch data from the table: "account_disbursement" using primary key columns */
  selectAccountDisbursement?: Maybe<AccountDisbursement>;
  /** fetch data from the table: "account_disbursement" */
  selectAccountDisbursements: Array<AccountDisbursement>;
  /** fetch aggregated fields from the table: "account_disbursement" */
  selectAccountDisbursementsAggregate: AccountDisbursement_Aggregate;
  /** fetch data from the table: "account_manager" using primary key columns */
  selectAccountManager?: Maybe<AccountManager>;
  /** fetch data from the table: "account_manager" */
  selectAccountManagers: Array<AccountManager>;
  /** fetch aggregated fields from the table: "account_manager" */
  selectAccountManagersAggregate: AccountManager_Aggregate;
  /** fetch data from the table: "account_obligor" using primary key columns */
  selectAccountObligor?: Maybe<AccountObligor>;
  /** fetch data from the table: "account_obligor" */
  selectAccountObligors: Array<AccountObligor>;
  /** fetch data from the table: "account_product" using primary key columns */
  selectAccountProduct?: Maybe<AccountProduct>;
  /** fetch data from the table: "account_product_obligor" using primary key columns */
  selectAccountProductObligor?: Maybe<AccountProductObligor>;
  /** fetch data from the table: "account_product_obligor" */
  selectAccountProductObligors: Array<AccountProductObligor>;
  /** fetch aggregated fields from the table: "account_product_obligor" */
  selectAccountProductObligorsAggregate: AccountProductObligor_Aggregate;
  /** fetch data from the table: "account_product" */
  selectAccountProducts: Array<AccountProduct>;
  /** fetch aggregated fields from the table: "account_product" */
  selectAccountProductsAggregate: AccountProduct_Aggregate;
  /** fetch data from the table: "account_retail" using primary key columns */
  selectAccountRetail?: Maybe<AccountRetail>;
  /** fetch data from the table: "account_retail" */
  selectAccountRetails: Array<AccountRetail>;
  /** fetch aggregated fields from the table: "account_retail" */
  selectAccountRetailsAggregate: AccountRetail_Aggregate;
  /** fetch data from the table: "account_type" using primary key columns */
  selectAccountType?: Maybe<AccountType>;
  /** fetch data from the table: "account_type" */
  selectAccountTypes: Array<AccountType>;
  /** fetch aggregated fields from the table: "account_type" */
  selectAccountTypesAggregage: AccountType_Aggregate;
  /** fetch data from the table: "account" */
  selectAccounts: Array<Account>;
  /** fetch data from the table: "address" using primary key columns */
  selectAddress?: Maybe<Address>;
  /** fetch data from the table: "address_type" using primary key columns */
  selectAddressType?: Maybe<AddressType>;
  /** fetch data from the table: "address_type" */
  selectAddressTypes: Array<AddressType>;
  /** fetch aggregated fields from the table: "address_type" */
  selectAddressTypesAggregate: AddressType_Aggregate;
  /** fetch data from the table: "address" */
  selectAddresses: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  selectAddressesAggregate: Address_Aggregate;
  /** fetch aggregated fields from the table: "shared.payment_type" */
  selectAggreatePaymentType: PaymentType_Aggregate;
  /** fetch aggregated fields from the table: "account_obligor" */
  selectAggregateAccountObligors: AccountObligor_Aggregate;
  /** fetch aggregated fields from the table: "claims.claim_detail_as400" */
  selectAggregateClaimDetailAs400: ClaimDetailAs400_Aggregate;
  /** fetch aggregated fields from the table: "claims.claim_detail_deduction_as400" */
  selectAggregateClaimDetailDeductionAs400: ClaimDetailDeductionAs400_Aggregate;
  /** fetch aggregated fields from the table: "claims.claim_service_center_as400" */
  selectAggregateClaimServiceCenterAs400: ClaimServiceCenterAs400_Aggregate;
  /** fetch aggregated fields from the table: "composite_product" */
  selectAggregateCompositeProducts: CompositeProduct_Aggregate;
  /** fetch aggregated fields from the table: "ory.identity_as400" */
  selectAggregateIdentityAs400: IdentityAs400_Aggregate;
  /** fetch aggregated fields from the table: "system.job_list_view" */
  selectAggregateJobListView: JobListView_Aggregate;
  /** fetch aggregated fields from the table: "claims.labor_rate" */
  selectAggregateLaborRate: LaborRate_Aggregate;
  /** fetch aggregated fields from the table: "claims.labor_rate_as400" */
  selectAggregateLaborRateAs400: LaborRateAs400_Aggregate;
  /** fetch aggregated fields from the table: "shared.payment_as400" */
  selectAggregatePaymentAs400: PaymentAs400_Aggregate;
  /** fetch aggregated fields from the table: "claims.policy_claim_as400" */
  selectAggregatePolicyClaimAs400: PolicyClaimAs400_Aggregate;
  /** fetch aggregated fields from the table: "claims.policy_claim_insurance" */
  selectAggregatePolicyClaimInsurances: PolicyClaimInsurance_Aggregate;
  /** fetch aggregated fields from the table: "ui.rater_view_config" */
  selectAggregateRaterViewConfigs: RaterViewConfig_Aggregate;
  /** fetch aggregated fields from the table: "claims.remittance_claim_detail" */
  selectAggregateRemittanceClaimDetail: RemittanceClaimDetail_Aggregate;
  /** fetch aggregated fields from the table: "system.step_list_view" */
  selectAggregateStepListView: StepListView_Aggregate;
  /** fetch aggregated fields from the table: "claims.tax_rate" */
  selectAggregateTaxRate: TaxRate_Aggregate;
  /** fetch aggregated fields from the table: "claims.tax_rate_as400" */
  selectAggregateTaxRateAs400: TaxRateAs400_Aggregate;
  /** fetch data from the table: "shared.alert" using primary key columns */
  selectAlert?: Maybe<Alert>;
  /** fetch data from the table: "shared.alert_acknowledgment" using primary key columns */
  selectAlertAcknowledgment?: Maybe<AlertAcknowledgment>;
  /** fetch aggregated fields from the table: "shared.alert_acknowledgment" */
  selectAlertAcknowledgmentAggregate: AlertAcknowledgment_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.alert_acknowledgment" */
  selectAlertAcknowledgmentStream: Array<AlertAcknowledgment>;
  /** fetch data from the table: "shared.alert_acknowledgment" */
  selectAlertAcknowledgments: Array<AlertAcknowledgment>;
  /** fetch aggregated fields from the table: "shared.alert" */
  selectAlertAggregate: Alert_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.alert" */
  selectAlertStream: Array<Alert>;
  /** fetch data from the table: "shared.alert" */
  selectAlerts: Array<Alert>;
  /** fetch data from the table: "auth.application" using primary key columns */
  selectApplication?: Maybe<Application>;
  /** fetch aggregated fields from the table: "auth.application" */
  selectApplicationAggregate: Application_Aggregate;
  /** fetch data from the table: "users.application_preference" using primary key columns */
  selectApplicationPreference?: Maybe<ApplicationPreference>;
  /** fetch aggregated fields from the table: "users.application_preference" */
  selectApplicationPreferenceAggregate: ApplicationPreference_Aggregate;
  /** fetch data from the table in a streaming manner: "users.application_preference" */
  selectApplicationPreferenceStream: Array<ApplicationPreference>;
  /** fetch data from the table: "users.application_preference" */
  selectApplicationPreferences: Array<ApplicationPreference>;
  /** fetch data from the table in a streaming manner: "auth.application" */
  selectApplicationStream: Array<Application>;
  /** fetch data from the table: "auth.application" */
  selectApplications: Array<Application>;
  /** fetch data from the table: "approvals.approval" using primary key columns */
  selectApproval?: Maybe<Approval>;
  /** fetch aggregated fields from the table: "approvals.approval" */
  selectApprovalAggregate: Approval_Aggregate;
  /** fetch data from the table: "approvals.authority" */
  selectApprovalAuthorities: Array<ApprovalAuthority>;
  /** fetch data from the table: "approvals.authority" using primary key columns */
  selectApprovalAuthority?: Maybe<ApprovalAuthority>;
  /** fetch aggregated fields from the table: "approvals.authority" */
  selectApprovalAuthorityAggregate: ApprovalAuthority_Aggregate;
  /** fetch data from the table: "approvals.gate" using primary key columns */
  selectApprovalGate?: Maybe<ApprovalGate>;
  /** fetch aggregated fields from the table: "approvals.gate" */
  selectApprovalGateAggregate: ApprovalGate_Aggregate;
  /** fetch data from the table: "approvals.gate_binding" using primary key columns */
  selectApprovalGateBinding?: Maybe<ApprovalGateBinding>;
  /** fetch aggregated fields from the table: "approvals.gate_binding" */
  selectApprovalGateBindingAggregate: ApprovalGateBinding_Aggregate;
  /** fetch data from the table: "approvals.gate_binding" */
  selectApprovalGateBindings: Array<ApprovalGateBinding>;
  /** fetch data from the table: "approvals.gate" */
  selectApprovalGates: Array<ApprovalGate>;
  /** fetch data from the table: "approvals.approval" */
  selectApprovalRecords: Array<Approval>;
  /** fetch data from the table: "approvals.request" using primary key columns */
  selectApprovalRequest?: Maybe<ApprovalRequest>;
  /** fetch aggregated fields from the table: "approvals.request" */
  selectApprovalRequestAggregate: ApprovalRequest_Aggregate;
  /** fetch data from the table: "approvals.request" */
  selectApprovalRequests: Array<ApprovalRequest>;
  /** fetch aggregated fields from the table: "approvals.state" */
  selectApprovalStateAggregate: ApprovalState_Aggregate;
  /** fetch data from the table: "approvals.state" */
  selectApprovalStates: Array<ApprovalState>;
  /** fetch data from the table: "as400_data_sync" using primary key columns */
  selectAs400DataSync?: Maybe<As400DataSync>;
  /** fetch data from the table: "as400_data_sync" */
  selectAs400DataSyncs: Array<As400DataSync>;
  /** fetch aggregated fields from the table: "as400_data_sync" */
  selectAs400DataSyncsAggregate: As400DataSync_Aggregate;
  /** fetch data from the table: "shared.bank_account_type" using primary key columns */
  selectBankAccountType?: Maybe<BankAccountType>;
  /** fetch aggregated fields from the table: "shared.bank_account_type" */
  selectBankAccountTypeAggregate: BankAccountType_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.bank_account_type" */
  selectBankAccountTypeStream: Array<BankAccountType>;
  /** fetch data from the table: "shared.bank_account_type" */
  selectBankAccountTypes: Array<BankAccountType>;
  /** fetch data from the table: "caddy.caddy" using primary key columns */
  selectCaddy?: Maybe<Caddy>;
  /** fetch aggregated fields from the table: "caddy.caddy" */
  selectCaddyAggregate: Caddy_Aggregate;
  /** fetch data from the table: "caddy.caddy_server_manager_log" using primary key columns */
  selectCaddyServerManagerLog?: Maybe<CaddyServerManagerLog>;
  /** fetch aggregated fields from the table: "caddy.caddy_server_manager_log" */
  selectCaddyServerManagerLogAggregate: CaddyServerManagerLog_Aggregate;
  /** fetch data from the table: "caddy.caddy_server_manager_log" */
  selectCaddyServerManagerLogs: Array<CaddyServerManagerLog>;
  /** fetch data from the table: "caddy.caddy" */
  selectCaddys: Array<Caddy>;
  /** fetch aggregated fields from the table: "quotes.cancel_quote_list_view" */
  selectCancelQuoteListViewAggregate: CancelQuoteListView_Aggregate;
  /** fetch data from the table in a streaming manner: "quotes.cancel_quote_list_view" */
  selectCancelQuoteListViewStream: Array<CancelQuoteListView>;
  /** fetch data from the table: "quotes.cancel_quote_list_view" */
  selectCancelQuoteListViews: Array<CancelQuoteListView>;
  /** fetch data from the table: "compliance.cancel_rule" using primary key columns */
  selectCancelRule?: Maybe<CancelRule>;
  /** fetch aggregated fields from the table: "compliance.cancel_rule" */
  selectCancelRuleAggregate: CancelRule_Aggregate;
  /** fetch data from the table: "compliance.cancel_rule_fee" using primary key columns */
  selectCancelRuleFee?: Maybe<CancelRuleFee>;
  /** fetch aggregated fields from the table: "compliance.cancel_rule_fee" */
  selectCancelRuleFeeAggregate: CancelRuleFee_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance.cancel_rule_fee" */
  selectCancelRuleFeeStream: Array<CancelRuleFee>;
  /** fetch data from the table: "compliance.cancel_rule_fee" */
  selectCancelRuleFees: Array<CancelRuleFee>;
  /** fetch data from the table: "compliance.cancel_rule_refund" using primary key columns */
  selectCancelRuleRefund?: Maybe<CancelRuleRefund>;
  /** fetch aggregated fields from the table: "compliance.cancel_rule_refund" */
  selectCancelRuleRefundAggregate: CancelRuleRefund_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance.cancel_rule_refund" */
  selectCancelRuleRefundStream: Array<CancelRuleRefund>;
  /** fetch data from the table: "compliance.cancel_rule_refund" */
  selectCancelRuleRefunds: Array<CancelRuleRefund>;
  /** fetch data from the table in a streaming manner: "compliance.cancel_rule" */
  selectCancelRuleStream: Array<CancelRule>;
  /** fetch data from the table: "compliance.cancel_rule" */
  selectCancelRules: Array<CancelRule>;
  /** fetch data from the table: "operations.cancellation" using primary key columns */
  selectCancellation?: Maybe<Cancellation>;
  /** fetch aggregated fields from the table: "operations.cancellation" */
  selectCancellationAggregate: Cancellation_Aggregate;
  /** fetch data from the table: "operations.cancellation_as400" using primary key columns */
  selectCancellationAs400?: Maybe<CancellationAs400>;
  /** fetch aggregated fields from the table: "operations.cancellation_as400" */
  selectCancellationAs400Aggregate: CancellationAs400_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.cancellation_as400" */
  selectCancellationAs400Stream: Array<CancellationAs400>;
  /** fetch data from the table: "operations.cancellation_as400" */
  selectCancellationAs400s: Array<CancellationAs400>;
  /** fetch data from the table: "operations.cancellation" */
  selectCancellations: Array<Cancellation>;
  /** fetch data from the table: "auth.capability" */
  selectCapabilities: Array<Capability>;
  /** fetch data from the table: "auth.capability" using primary key columns */
  selectCapability?: Maybe<Capability>;
  /** fetch aggregated fields from the table: "auth.capability" */
  selectCapabilityAggregate: Capability_Aggregate;
  /** fetch data from the table: "auth.capability_config" using primary key columns */
  selectCapabilityConfig?: Maybe<CapabilityConfig>;
  /** fetch aggregated fields from the table: "auth.capability_config" */
  selectCapabilityConfigAggregate: CapabilityConfig_Aggregate;
  /** fetch data from the table: "auth.capability_config" */
  selectCapabilityConfigs: Array<CapabilityConfig>;
  /** fetch data from the table: "auth.capability_route" using primary key columns */
  selectCapabilityRoute?: Maybe<CapabilityRoute>;
  /** fetch aggregated fields from the table: "auth.capability_route" */
  selectCapabilityRouteAggregate: CapabilityRoute_Aggregate;
  /** fetch data from the table: "auth.capability_route" */
  selectCapabilityRoutes: Array<CapabilityRoute>;
  /** fetch data from the table: "users.card_layout" using primary key columns */
  selectCardLayout?: Maybe<CardLayout>;
  /** fetch aggregated fields from the table: "users.card_layout" */
  selectCardLayoutAggregate: CardLayout_Aggregate;
  /** fetch data from the table in a streaming manner: "users.card_layout" */
  selectCardLayoutStream: Array<CardLayout>;
  /** fetch data from the table: "users.card_layout" */
  selectCardLayouts: Array<CardLayout>;
  /** fetch data from the table: "carrier" using primary key columns */
  selectCarrier?: Maybe<Carrier>;
  /** fetch aggregated fields from the table: "carrier" */
  selectCarrierAggregate: Carrier_Aggregate;
  /** fetch data from the table: "carrier" */
  selectCarriers: Array<Carrier>;
  /** fetch data from the table: "category" */
  selectCategories: Array<Category>;
  /** fetch aggregated fields from the table: "category" */
  selectCategoriesAggregate: Category_Aggregate;
  /** fetch data from the table: "category" using primary key columns */
  selectCategory?: Maybe<Category>;
  selectCategoryClassGuides: Array<CategoryClassGuide>;
  /** fetch data from the table: "category_product_attribute_type" using primary key columns */
  selectCategoryProductAttributeType?: Maybe<CategoryProductAttributeType>;
  /** fetch data from the table: "category_product_attribute_type" */
  selectCategoryProductAttributeTypes: Array<CategoryProductAttributeType>;
  /** fetch aggregated fields from the table: "category_product_attribute_type" */
  selectCategoryProductAttributeTypesAggregate: CategoryProductAttributeType_Aggregate;
  /** fetch data from the table: "claim" using primary key columns */
  selectClaim?: Maybe<Claim>;
  /** fetch aggregated fields from the table: "claim" */
  selectClaimAggregate: Claim_Aggregate;
  /** fetch data from the table: "claims.claim_detail" using primary key columns */
  selectClaimDetail?: Maybe<ClaimDetail>;
  /** fetch aggregated fields from the table: "claims.claim_detail" */
  selectClaimDetailAggregate: ClaimDetail_Aggregate;
  /** fetch data from the table: "claims.claim_detail_as400" using primary key columns */
  selectClaimDetailAs400?: Maybe<ClaimDetailAs400>;
  /** fetch data from the table: "claims.claim_detail_as400" */
  selectClaimDetailAs400s: Array<ClaimDetailAs400>;
  /** fetch data from the table: "claims.claim_detail_category" */
  selectClaimDetailCategories: Array<ClaimDetailCategory>;
  /** fetch data from the table: "claims.claim_detail_category" using primary key columns */
  selectClaimDetailCategory?: Maybe<ClaimDetailCategory>;
  /** fetch aggregated fields from the table: "claims.claim_detail_category" */
  selectClaimDetailCategoryAggregate: ClaimDetailCategory_Aggregate;
  /** fetch data from the table: "claims.claim_detail_deduction_as400" using primary key columns */
  selectClaimDetailDeductionAs400?: Maybe<ClaimDetailDeductionAs400>;
  /** fetch data from the table: "claims.claim_detail_deduction_as400" */
  selectClaimDetailDeductionAs400s: Array<ClaimDetailDeductionAs400>;
  /** fetch data from the table: "claims.claim_detail_part_lookup" using primary key columns */
  selectClaimDetailPartLookup?: Maybe<ClaimDetailPartLookup>;
  /** fetch aggregated fields from the table: "claims.claim_detail_part_lookup" */
  selectClaimDetailPartLookupAggregate: ClaimDetailPartLookup_Aggregate;
  /** fetch data from the table: "claims.claim_detail_part_lookup" */
  selectClaimDetailPartLookups: Array<ClaimDetailPartLookup>;
  /** fetch data from the table: "claims.claim_detail" */
  selectClaimDetails: Array<ClaimDetail>;
  /** fetch aggregated fields from the table: "claims.claim_part" */
  selectClaimPartAggregate: ClaimPart_Aggregate;
  /** fetch data from the table: "claims.claim_part" */
  selectClaimParts: Array<ClaimPart>;
  /** fetch data from the table: "claims.claim_service_center" using primary key columns */
  selectClaimServiceCenter?: Maybe<ClaimServiceCenter>;
  /** fetch aggregated fields from the table: "claims.claim_service_center" */
  selectClaimServiceCenterAggregate: ClaimServiceCenter_Aggregate;
  /** fetch data from the table: "claims.claim_service_center_as400" using primary key columns */
  selectClaimServiceCenterAs400?: Maybe<ClaimServiceCenterAs400>;
  /** fetch data from the table: "claims.claim_service_center_as400" */
  selectClaimServiceCenterAs400s: Array<ClaimServiceCenterAs400>;
  /** fetch data from the table: "claims.claim_service_center_authorization" using primary key columns */
  selectClaimServiceCenterAuthorization?: Maybe<ClaimServiceCenterAuthorization>;
  /** fetch aggregated fields from the table: "claims.claim_service_center_authorization" */
  selectClaimServiceCenterAuthorizationAggregate: ClaimServiceCenterAuthorization_Aggregate;
  /** fetch data from the table: "claims.claim_service_center_authorization" */
  selectClaimServiceCenterAuthorizations: Array<ClaimServiceCenterAuthorization>;
  /** fetch data from the table: "claims.claim_service_center" */
  selectClaimServiceCenters: Array<ClaimServiceCenter>;
  /** fetch data from the table: "ClaimStatus" using primary key columns */
  selectClaimStatus?: Maybe<ClaimStatus>;
  /** fetch aggregated fields from the table: "ClaimStatus" */
  selectClaimStatusAggregate: ClaimStatus_Aggregate;
  /** fetch data from the table: "claim_status_type" using primary key columns */
  selectClaimStatusType?: Maybe<ClaimStatusType>;
  /** fetch aggregated fields from the table: "claim_status_type" */
  selectClaimStatusTypeAggregate: ClaimStatusType_Aggregate;
  /** fetch data from the table: "claim_status_type" */
  selectClaimStatusTypes: Array<ClaimStatusType>;
  /** fetch data from the table: "ClaimStatus" */
  selectClaimStatuses: Array<ClaimStatus>;
  /** fetch data from the table: "claim" */
  selectClaims: Array<Claim>;
  /** fetch aggregated fields from the table: "ClaimsMaster" */
  selectClaimsMasterAggregate: ClaimsMaster_Aggregate;
  /** fetch data from the table: "ClaimsMaster" */
  selectClaimsMasters: Array<ClaimsMaster>;
  /** fetch data from the table: "classes.class_criteria" using primary key columns */
  selectClassCriteria?: Maybe<ClassCriteria>;
  /** fetch aggregated fields from the table: "classes.class_criteria" */
  selectClassCriteriaAggregate: ClassCriteria_Aggregate;
  /** fetch aggregated fields from the table: "classes.class_criteria_view" */
  selectClassCriteriaViewAggregate: ClassCriteriaView_Aggregate;
  /** fetch aggregated fields from the table: "classes.class_criteria_view_default_vehicle_criteria" */
  selectClassCriteriaViewDefaultVehicleCriteriaAggregate: ClassCriteriaViewDefaultVehicleCriteria_Aggregate;
  /** fetch data from the table: "classes.class_criteria_view_default_vehicle_criteria" */
  selectClassCriteriaViewDefaultVehicleCriterias: Array<ClassCriteriaViewDefaultVehicleCriteria>;
  /** fetch data from the table in a streaming manner: "classes.class_criteria_view" */
  selectClassCriteriaViewStream: Array<ClassCriteriaView>;
  /** fetch aggregated fields from the table: "classes.class_criteria_view_unclassed_default_vehicle_criteria" */
  selectClassCriteriaViewUnclassedDefaultVehicleCriteriaAggregate: ClassCriteriaViewUnclassedDefaultVehicleCriteria_Aggregate;
  /** fetch data from the table: "classes.class_criteria_view_unclassed_default_vehicle_criteria" */
  selectClassCriteriaViewUnclassedDefaultVehicleCriterias: Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria>;
  /** fetch data from the table: "classes.class_criteria" */
  selectClassCriterias: Array<ClassCriteria>;
  /** fetch data from the table: "classes.class_criteria_view" */
  selectClassCriteriasView: Array<ClassCriteriaView>;
  /** fetch data from the table: "classes.class_guide" using primary key columns */
  selectClassGuide?: Maybe<ClassGuide>;
  /** fetch aggregated fields from the table: "classes.class_guide" */
  selectClassGuideAggregate: ClassGuide_Aggregate;
  /** fetch data from the table: "classes.class_guide_class_criteria" using primary key columns */
  selectClassGuideClassCriteria?: Maybe<ClassGuideClassCriteria>;
  /** fetch aggregated fields from the table: "classes.class_guide_class_criteria" */
  selectClassGuideClassCriteriaAggregate: ClassGuideClassCriteria_Aggregate;
  /** fetch aggregated fields from the table: "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
  selectClassGuideClassCriteriaViewDefaultVehicleCriteriaAggregate: ClassGuideClassCriteriaViewDefaultVehicleCriteria_Aggregate;
  /** fetch data from the table: "classes.class_guide_class_criteria_view_default_vehicle_criteria" */
  selectClassGuideClassCriteriaViewDefaultVehicleCriterias: Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria>;
  /** fetch aggregated fields from the table: "classes.class_guide_class_criteria_view_vin" */
  selectClassGuideClassCriteriaViewVinAggregate: ClassGuideClassCriteriaViewVin_Aggregate;
  /** fetch data from the table: "classes.class_guide_class_criteria_view_vin" */
  selectClassGuideClassCriteriaViewVins: Array<ClassGuideClassCriteriaViewVin>;
  /** fetch data from the table: "classes.class_guide_class_criteria" */
  selectClassGuideClassCriterias: Array<ClassGuideClassCriteria>;
  /** fetch data from the table: "classes.class_guide_criteria_definition" using primary key columns */
  selectClassGuideCriteriaDefinition?: Maybe<ClassGuideCriteriaDefinition>;
  /** fetch aggregated fields from the table: "classes.class_guide_criteria_definition" */
  selectClassGuideCriteriaDefinitionAggregate: ClassGuideCriteriaDefinition_Aggregate;
  /** fetch data from the table: "classes.class_guide_criteria_definition" */
  selectClassGuideCriteriaDefinitions: Array<ClassGuideCriteriaDefinition>;
  /** fetch data from the table: "classes.class_guide_criteria_type" using primary key columns */
  selectClassGuideCriteriaType?: Maybe<ClassGuideCriteriaType>;
  /** fetch aggregated fields from the table: "classes.class_guide_criteria_type" */
  selectClassGuideCriteriaTypeAggregate: ClassGuideCriteriaType_Aggregate;
  /** fetch data from the table: "classes.class_guide_criteria_type" */
  selectClassGuideCriteriaTypes: Array<ClassGuideCriteriaType>;
  /** fetch data from the table: "classes.class_guide" */
  selectClassGuides: Array<ClassGuide>;
  /** fetch data from the table: "composite_product" using primary key columns */
  selectCompositeProduct?: Maybe<CompositeProduct>;
  /** fetch data from the table: "composite_product" */
  selectCompositeProducts: Array<CompositeProduct>;
  /** fetch data from the table: "configuration_item" using primary key columns */
  selectConfigurationItem?: Maybe<ConfigurationItem>;
  /** fetch aggregated fields from the table: "configuration_item" */
  selectConfigurationItemAggregate: ConfigurationItem_Aggregate;
  /** fetch data from the table: "configuration_item_type" using primary key columns */
  selectConfigurationItemType?: Maybe<ConfigurationItemType>;
  /** fetch aggregated fields from the table: "configuration_item_type" */
  selectConfigurationItemTypeAggregate: ConfigurationItemType_Aggregate;
  /** fetch data from the table: "configuration_item_type" */
  selectConfigurationItemTypes: Array<ConfigurationItemType>;
  /** fetch data from the table: "configuration_item" */
  selectConfigurationItems: Array<ConfigurationItem>;
  /** fetch data from the table: "contact" using primary key columns */
  selectContact?: Maybe<Contact>;
  /** fetch aggregated fields from the table: "contact" */
  selectContactAggregate: Contact_Aggregate;
  /** fetch data from the table: "contact" */
  selectContacts: Array<Contact>;
  /** fetch data from the table: "shared.content_type" using primary key columns */
  selectContentType?: Maybe<ContentType>;
  /** fetch aggregated fields from the table: "shared.content_type" */
  selectContentTypeAggregate: ContentType_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.content_type" */
  selectContentTypeStream: Array<ContentType>;
  /** fetch data from the table: "shared.content_type" */
  selectContentTypes: Array<ContentType>;
  /** fetch data from the table: "contract" using primary key columns */
  selectContract?: Maybe<Contract>;
  /** fetch aggregated fields from the table: "contract" */
  selectContractAggregate: Contract_Aggregate;
  /** fetch data from the table: "compliance.contract_form" using primary key columns */
  selectContractForm?: Maybe<ContractForm>;
  /** fetch aggregated fields from the table: "compliance.contract_form" */
  selectContractFormAggregate: ContractForm_Aggregate;
  /** fetch data from the table: "compliance.contract_form_filing_status" using primary key columns */
  selectContractFormFilingStatus?: Maybe<ContractFormFilingStatus>;
  /** fetch aggregated fields from the table: "compliance.contract_form_filing_status" */
  selectContractFormFilingStatusAggregate: ContractFormFilingStatus_Aggregate;
  /** fetch data from the table: "compliance.contract_form_filing_status" */
  selectContractFormFilingStatuses: Array<ContractFormFilingStatus>;
  /** fetch data from the table: "compliance.contract_form_type" using primary key columns */
  selectContractFormType?: Maybe<ContractFormType>;
  /** fetch aggregated fields from the table: "compliance.contract_form_type" */
  selectContractFormTypeAggregate: ContractFormType_Aggregate;
  /** fetch data from the table: "compliance.contract_form_type" */
  selectContractFormTypes: Array<ContractFormType>;
  /** fetch data from the table: "compliance.contract_form_version" using primary key columns */
  selectContractFormVersion?: Maybe<ContractFormVersion>;
  /** fetch aggregated fields from the table: "compliance.contract_form_version" */
  selectContractFormVersionAggregate: ContractFormVersion_Aggregate;
  /** fetch data from the table: "compliance.contract_form_version_legacy_file" using primary key columns */
  selectContractFormVersionLegacyFile?: Maybe<ContractFormVersionLegacyFile>;
  /** fetch aggregated fields from the table: "compliance.contract_form_version_legacy_file" */
  selectContractFormVersionLegacyFileAggregate: ContractFormVersionLegacyFile_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance.contract_form_version_legacy_file" */
  selectContractFormVersionLegacyFileStream: Array<ContractFormVersionLegacyFile>;
  /** fetch data from the table: "compliance.contract_form_version_legacy_file" */
  selectContractFormVersionLegacyFiles: Array<ContractFormVersionLegacyFile>;
  /** fetch data from the table: "compliance.contract_form_version" */
  selectContractFormVersions: Array<ContractFormVersion>;
  /** fetch data from the table: "compliance.contract_form" */
  selectContractForms: Array<ContractForm>;
  /** fetch data from the table: "ContractMaster" using primary key columns */
  selectContractMaster?: Maybe<ContractMaster>;
  /** fetch data from the table: "ContractMasterAdditionalEntity" */
  selectContractMasterAdditionalEntiies: Array<ContractMasterAdditionalEntity>;
  /** fetch aggregated fields from the table: "ContractMasterAdditionalEntity" */
  selectContractMasterAdditionalEntityAggregate: ContractMasterAdditionalEntity_Aggregate;
  /** fetch aggregated fields from the table: "ContractMaster" */
  selectContractMasterAggregate: ContractMaster_Aggregate;
  /** fetch data from the table: "ContractMaster" */
  selectContractMasters: Array<ContractMaster>;
  /** fetch data from the table: "contract_status_type" using primary key columns */
  selectContractStatusType?: Maybe<ContractStatusType>;
  /** fetch aggregated fields from the table: "contract_status_type" */
  selectContractStatusTypeAggregate: ContractStatusType_Aggregate;
  /** fetch data from the table: "contract_status_type" */
  selectContractStatusTypes: Array<ContractStatusType>;
  /** fetch data from the table: "contract" */
  selectContracts: Array<Contract>;
  /** fetch data from the table: "cost_adjustment" using primary key columns */
  selectCostAdjustment?: Maybe<CostAdjustment>;
  /** fetch aggregated fields from the table: "cost_adjustment" */
  selectCostAdjustmentAggregate: CostAdjustment_Aggregate;
  /** fetch data from the table: "cost_adjustment_extended_cost" using primary key columns */
  selectCostAdjustmentExtendedCost?: Maybe<CostAdjustmentExtendedCost>;
  /** fetch aggregated fields from the table: "cost_adjustment_extended_cost" */
  selectCostAdjustmentExtendedCostAggregate: CostAdjustmentExtendedCost_Aggregate;
  /** fetch data from the table: "cost_adjustment_extended_cost" */
  selectCostAdjustmentExtendedCosts: Array<CostAdjustmentExtendedCost>;
  /** fetch data from the table: "cost_adjustment_lookup" using primary key columns */
  selectCostAdjustmentLookup?: Maybe<CostAdjustmentLookup>;
  /** fetch aggregated fields from the table: "cost_adjustment_lookup" */
  selectCostAdjustmentLookupAggregate: CostAdjustmentLookup_Aggregate;
  /** fetch data from the table: "cost_adjustment_lookup" */
  selectCostAdjustmentLookups: Array<CostAdjustmentLookup>;
  /** fetch data from the table: "cost_adjustment_type" using primary key columns */
  selectCostAdjustmentType?: Maybe<CostAdjustmentType>;
  /** fetch aggregated fields from the table: "cost_adjustment_type" */
  selectCostAdjustmentTypeAggregate: CostAdjustmentType_Aggregate;
  /** fetch data from the table: "cost_adjustment_type" */
  selectCostAdjustmentTypes: Array<CostAdjustmentType>;
  /** fetch data from the table: "cost_adjustment" */
  selectCostAdjustments: Array<CostAdjustment>;
  /** fetch data from the table: "custom_field" using primary key columns */
  selectCustomField?: Maybe<CustomField>;
  /** fetch data from the table: "custom_field_data" using primary key columns */
  selectCustomFieldData?: Maybe<CustomFieldData>;
  /** fetch aggregated fields from the table: "custom_field_data" */
  selectCustomFieldDataAggregate: CustomFieldData_Aggregate;
  /** fetch data from the table: "custom_field_data" */
  selectCustomFieldDatas: Array<CustomFieldData>;
  /** fetch data from the table: "custom_field_type" using primary key columns */
  selectCustomFieldType?: Maybe<CustomFieldType>;
  /** fetch aggregated fields from the table: "custom_field_type" */
  selectCustomFieldTypeAggregate: CustomFieldType_Aggregate;
  /** fetch data from the table: "custom_field_type" */
  selectCustomFieldTypes: Array<CustomFieldType>;
  /** fetch data from the table: "custom_field" */
  selectCustomFields: Array<CustomField>;
  /** fetch aggregated fields from the table: "custom_field" */
  selectCustomFieldsAggregate: CustomField_Aggregate;
  /** fetch data from the table: "customer" using primary key columns */
  selectCustomer?: Maybe<Customer>;
  /** fetch aggregated fields from the table: "customer" */
  selectCustomerAggregate: Customer_Aggregate;
  /** fetch data from the table: "customer" */
  selectCustomers: Array<Customer>;
  /** fetch data from the table: "accounting.cycle" using primary key columns */
  selectCycle?: Maybe<Cycle>;
  /** fetch aggregated fields from the table: "accounting.cycle" */
  selectCycleAggregate: Cycle_Aggregate;
  /** fetch data from the table: "accounting.cycle_journal_entry" */
  selectCycleJournalEntries: Array<CycleJournalEntry>;
  /** fetch data from the table: "accounting.cycle_journal_entry" using primary key columns */
  selectCycleJournalEntry?: Maybe<CycleJournalEntry>;
  /** fetch aggregated fields from the table: "accounting.cycle_journal_entry" */
  selectCycleJournalEntryAggregate: CycleJournalEntry_Aggregate;
  /** fetch data from the table in a streaming manner: "accounting.cycle_journal_entry" */
  selectCycleJournalEntryStream: Array<CycleJournalEntry>;
  /** fetch data from the table in a streaming manner: "accounting.cycle" */
  selectCycleStream: Array<Cycle>;
  /** fetch data from the table: "accounting.cycle_total" using primary key columns */
  selectCycleTotal?: Maybe<CycleTotal>;
  /** fetch aggregated fields from the table: "accounting.cycle_total" */
  selectCycleTotalAggregate: CycleTotal_Aggregate;
  /** fetch data from the table in a streaming manner: "accounting.cycle_total" */
  selectCycleTotalStream: Array<CycleTotal>;
  /** fetch data from the table: "accounting.cycle_total" */
  selectCycleTotals: Array<CycleTotal>;
  /** fetch data from the table: "accounting.cycle" */
  selectCycles: Array<Cycle>;
  /** fetch data from the table: "data_type" using primary key columns */
  selectDataType?: Maybe<DataType>;
  /** fetch aggregated fields from the table: "data_type" */
  selectDataTypeAggregate: DataType_Aggregate;
  /** fetch data from the table: "data_type" */
  selectDataTypes: Array<DataType>;
  /** fetch data from the table: "date_calculation_type" using primary key columns */
  selectDateCalculationType?: Maybe<DateCalculationType>;
  /** fetch aggregated fields from the table: "date_calculation_type" */
  selectDateCalculationTypeAggregate: DateCalculationType_Aggregate;
  /** fetch data from the table in a streaming manner: "date_calculation_type" */
  selectDateCalculationTypeStream: Array<DateCalculationType>;
  /** fetch data from the table: "date_calculation_type" */
  selectDateCalculationTypes: Array<DateCalculationType>;
  /** fetch data from the table: "Dealer" using primary key columns */
  selectDealer?: Maybe<Dealer>;
  /** fetch aggregated fields from the table: "Dealer" */
  selectDealerAggregate: Dealer_Aggregate;
  /** fetch aggregated fields from the table: "shared.dealer_alert_list_view" */
  selectDealerAlertAggregate: Shared_Dealer_Alert_List_View_Aggregate;
  /** fetch data from the table: "shared.dealer_alert_list_view" */
  selectDealerAlerts: Array<Shared_Dealer_Alert_List_View>;
  /** fetch data from the table: "dealer_payment_type" using primary key columns */
  selectDealerPaymentType?: Maybe<DealerPaymentType>;
  /** fetch aggregated fields from the table: "dealer_payment_type" */
  selectDealerPaymentTypeAggregate: DealerPaymentType_Aggregate;
  /** fetch data from the table: "dealer_payment_type" */
  selectDealerPaymentTypes: Array<DealerPaymentType>;
  /** fetch data from the table: "Dealer" */
  selectDealers: Array<Dealer>;
  /** fetch data from the table: "disbursement_type" using primary key columns */
  selectDisbursementType?: Maybe<DisbursementType>;
  /** fetch data from the table: "disbursement_type" */
  selectDisbursementTypes: Array<DisbursementType>;
  /** fetch aggregated fields from the table: "disbursement_type" */
  selectDisbursementTypesAggregate: DisbursementType_Aggregate;
  /** fetch data from the table: "claims.document" using primary key columns */
  selectDocument?: Maybe<Document>;
  /** fetch aggregated fields from the table: "claims.document" */
  selectDocumentAggregate: Document_Aggregate;
  /** fetch data from the table: "shared.document_instance" using primary key columns */
  selectDocumentInstance?: Maybe<DocumentInstance>;
  /** fetch aggregated fields from the table: "shared.document_instance" */
  selectDocumentInstanceAggregate: DocumentInstance_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.document_instance" */
  selectDocumentInstanceStream: Array<DocumentInstance>;
  /** fetch data from the table: "shared.document_instance" */
  selectDocumentInstances: Array<DocumentInstance>;
  /** fetch data from the table: "shared.document_template" using primary key columns */
  selectDocumentTemplate?: Maybe<DocumentTemplate>;
  /** fetch aggregated fields from the table: "shared.document_template" */
  selectDocumentTemplateAggregate: DocumentTemplate_Aggregate;
  /** fetch data from the table: "shared.document_template_application" using primary key columns */
  selectDocumentTemplateApplication?: Maybe<DocumentTemplateApplication>;
  /** fetch aggregated fields from the table: "shared.document_template_application" */
  selectDocumentTemplateApplicationAggregate: DocumentTemplateApplication_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.document_template_application" */
  selectDocumentTemplateApplicationStream: Array<DocumentTemplateApplication>;
  /** fetch data from the table: "shared.document_template_application" */
  selectDocumentTemplateApplications: Array<DocumentTemplateApplication>;
  /** fetch data from the table in a streaming manner: "shared.document_template" */
  selectDocumentTemplateStream: Array<DocumentTemplate>;
  /** fetch data from the table: "shared.document_template" */
  selectDocumentTemplates: Array<DocumentTemplate>;
  /** fetch data from the table: "claims.document" */
  selectDocuments: Array<Document>;
  /** fetch data from the table: "eligibility_rule" using primary key columns */
  selectEligibilityRule?: Maybe<EligibilityRule>;
  /** fetch aggregated fields from the table: "eligibility_rule" */
  selectEligibilityRuleAggregate: EligibilityRule_Aggregate;
  /** fetch data from the table: "eligibility_rule_definition" using primary key columns */
  selectEligibilityRuleDefinition?: Maybe<EligibilityRuleDefinition>;
  /** fetch aggregated fields from the table: "eligibility_rule_definition" */
  selectEligibilityRuleDefinitionAggregate: EligibilityRuleDefinition_Aggregate;
  /** fetch data from the table: "eligibility_rule_definition" */
  selectEligibilityRuleDefinitions: Array<EligibilityRuleDefinition>;
  /** fetch data from the table: "eligibility_rule" */
  selectEligibilityRules: Array<EligibilityRule>;
  /** fetch data from the table: "eligibility_type" using primary key columns */
  selectEligibilityType?: Maybe<EligibilityType>;
  /** fetch data from the table: "eligibility_type" */
  selectEligibilityTypes: Array<EligibilityType>;
  /** fetch aggregated fields from the table: "eligibility_type" */
  selectEligibilityTypesAggregate: EligibilityType_Aggregate;
  /** fetch data from the table: "shared.entity_billing_information" using primary key columns */
  selectEntityBillingInformation?: Maybe<EntityBillingInformation>;
  /** fetch aggregated fields from the table: "shared.entity_billing_information" */
  selectEntityBillingInformationAggregate: EntityBillingInformation_Aggregate;
  /** fetch data from the table: "shared.entity_billing_information" */
  selectEntityBillingInformations: Array<EntityBillingInformation>;
  /** fetch data from the table: "entity_configuration_item" using primary key columns */
  selectEntityConfigurationItem?: Maybe<EntityConfigurationItem>;
  /** fetch aggregated fields from the table: "entity_configuration_item" */
  selectEntityConfigurationItemAggregate: EntityConfigurationItem_Aggregate;
  /** fetch data from the table: "entity_configuration_item" */
  selectEntityConfigurationItems: Array<EntityConfigurationItem>;
  /** fetch data from the table: "shared.entity_content_type" using primary key columns */
  selectEntityContentType?: Maybe<EntityContentType>;
  /** fetch aggregated fields from the table: "shared.entity_content_type" */
  selectEntityContentTypeAggregate: EntityContentType_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.entity_content_type" */
  selectEntityContentTypeStream: Array<EntityContentType>;
  /** fetch data from the table: "shared.entity_content_type" */
  selectEntityContentTypes: Array<EntityContentType>;
  /** fetch data from the table: "entity_custom_field" using primary key columns */
  selectEntityCustomField?: Maybe<EntityCustomField>;
  /** fetch data from the table: "entity_custom_field_value" using primary key columns */
  selectEntityCustomFieldValue?: Maybe<EntityCustomFieldValue>;
  /** fetch aggregated fields from the table: "entity_custom_field_value" */
  selectEntityCustomFieldValueAggregate: EntityCustomFieldValue_Aggregate;
  /** fetch data from the table: "entity_custom_field_value" */
  selectEntityCustomFieldValues: Array<EntityCustomFieldValue>;
  /** fetch data from the table: "entity_custom_field" */
  selectEntityCustomFields: Array<EntityCustomField>;
  /** fetch aggregated fields from the table: "entity_custom_field" */
  selectEntityCustomFieldsAggregate: EntityCustomField_Aggregate;
  /** fetch data from the table: "entity_data_definition" using primary key columns */
  selectEntityDataDefinition?: Maybe<EntityDataDefinition>;
  /** fetch aggregated fields from the table: "entity_data_definition" */
  selectEntityDataDefinitionAggregate: EntityDataDefinition_Aggregate;
  /** fetch data from the table: "entity_data_definition" */
  selectEntityDataDefinitions: Array<EntityDataDefinition>;
  /** fetch data from the table: "entity_eligibility_rule" using primary key columns */
  selectEntityEligibilityRule?: Maybe<EntityEligibilityRule>;
  /** fetch aggregated fields from the table: "entity_eligibility_rule" */
  selectEntityEligibilityRuleAggregate: EntityEligibilityRule_Aggregate;
  /** fetch data from the table: "entity_eligibility_rule" */
  selectEntityEligibilityRules: Array<EntityEligibilityRule>;
  /** fetch data from the table: "shared.entity_feature" using primary key columns */
  selectEntityFeature?: Maybe<EntityFeature>;
  /** fetch aggregated fields from the table: "shared.entity_feature" */
  selectEntityFeatureAggregate: EntityFeature_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.entity_feature" */
  selectEntityFeatureStream: Array<EntityFeature>;
  /** fetch data from the table: "shared.entity_feature" */
  selectEntityFeatures: Array<EntityFeature>;
  /** fetch data from the table: "shared.entity_file_content_type" using primary key columns */
  selectEntityFileContentType?: Maybe<EntityFileContentType>;
  /** fetch aggregated fields from the table: "shared.entity_file_content_type" */
  selectEntityFileContentTypeAggregate: EntityFileContentType_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.entity_file_content_type" */
  selectEntityFileContentTypeStream: Array<EntityFileContentType>;
  /** fetch data from the table: "shared.entity_file_content_type" */
  selectEntityFileContentTypes: Array<EntityFileContentType>;
  /** fetch data from the table: "shared.entity_file_storage" using primary key columns */
  selectEntityFileStorage?: Maybe<EntityFileStorage>;
  /** fetch aggregated fields from the table: "shared.entity_file_storage" */
  selectEntityFileStorageAggregate: EntityFileStorage_Aggregate;
  /** fetch data from the table: "shared.entity_file_storage" */
  selectEntityFileStorages: Array<EntityFileStorage>;
  /** fetch data from the table: "shared.entity_note" using primary key columns */
  selectEntityNote?: Maybe<EntityNote>;
  /** fetch aggregated fields from the table: "shared.entity_note" */
  selectEntityNoteAggregate: EntityNote_Aggregate;
  /** fetch aggregated fields from the table: "auth.entity_note_capability_view" */
  selectEntityNoteCapabilityViewAggregate: EntityNoteCapabilityView_Aggregate;
  /** fetch data from the table: "auth.entity_note_capability_view" */
  selectEntityNoteCapabilityViews: Array<EntityNoteCapabilityView>;
  /** fetch data from the table: "shared.entity_note" */
  selectEntityNotes: Array<EntityNote>;
  /** fetch data from the table: "entity_offering" using primary key columns */
  selectEntityOffering?: Maybe<EntityOffering>;
  /** fetch aggregated fields from the table: "entity_offering" */
  selectEntityOfferingAggregate: EntityOffering_Aggregate;
  /** fetch data from the table: "entity_offering" */
  selectEntityOfferings: Array<EntityOffering>;
  /** fetch data from the table: "shared.entity_remittance_detail" using primary key columns */
  selectEntityRemittanceDetail?: Maybe<EntityRemittanceDetail>;
  /** fetch aggregated fields from the table: "shared.entity_remittance_detail" */
  selectEntityRemittanceDetailAggregate: EntityRemittanceDetail_Aggregate;
  /** fetch data from the table: "shared.entity_remittance_detail" */
  selectEntityRemittanceDetails: Array<EntityRemittanceDetail>;
  /** fetch data from the table: "shared.entity_tag" using primary key columns */
  selectEntityTag?: Maybe<EntityTag>;
  /** fetch aggregated fields from the table: "shared.entity_tag" */
  selectEntityTagAggregate: EntityTag_Aggregate;
  /** fetch data from the table: "shared.entity_tag" */
  selectEntityTags: Array<EntityTag>;
  /** fetch data from the table: "shared.feature" using primary key columns */
  selectFeature?: Maybe<Feature>;
  /** fetch aggregated fields from the table: "shared.feature" */
  selectFeatureAggregate: Feature_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.feature" */
  selectFeatureStream: Array<Feature>;
  /** fetch data from the table: "shared.feature" */
  selectFeatures: Array<Feature>;
  /** fetch data from the table: "shared.file_storage" using primary key columns */
  selectFileStorage?: Maybe<FileStorage>;
  /** fetch aggregated fields from the table: "shared.file_storage" */
  selectFileStorageAggregate: FileStorage_Aggregate;
  /** fetch data from the table: "shared.file_storage_type" using primary key columns */
  selectFileStorageType?: Maybe<FileStorageType>;
  /** fetch aggregated fields from the table: "shared.file_storage_type" */
  selectFileStorageTypeAggregate: FileStorageType_Aggregate;
  /** fetch data from the table: "shared.file_storage_type" */
  selectFileStorageTypes: Array<FileStorageType>;
  /** fetch data from the table: "shared.file_storage" */
  selectFileStorages: Array<FileStorage>;
  /** fetch data from the table: "compliance.filing_lender" using primary key columns */
  selectFilingLender?: Maybe<FilingLender>;
  /** fetch data from the table: "compliance.filing_lender_match" using primary key columns */
  selectFilingLenderMatch?: Maybe<FilingLenderMatch>;
  /** fetch aggregated fields from the table: "compliance.filing_lender_match" */
  selectFilingLenderMatchAggregate: FilingLenderMatch_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance.filing_lender_match" */
  selectFilingLenderMatchStream: Array<FilingLenderMatch>;
  /** fetch data from the table: "compliance.filing_lender_match" */
  selectFilingLenderMatches: Array<FilingLenderMatch>;
  /** fetch data from the table: "compliance.filing_lender" */
  selectFilingLenders: Array<FilingLender>;
  /** fetch data from the table: "compliance.filing_state" using primary key columns */
  selectFilingState?: Maybe<FilingState>;
  /** fetch aggregated fields from the table: "compliance.filing_state" */
  selectFilingStateAggregate: FilingState_Aggregate;
  /** fetch data from the table: "compliance.filing_state" */
  selectFilingStates: Array<FilingState>;
  /** fetch data from the table: "compliance.filing_status_type" using primary key columns */
  selectFilingStatusType?: Maybe<FilingStatusType>;
  /** fetch aggregated fields from the table: "compliance.filing_status_type" */
  selectFilingStatusTypeAggregate: FilingStatusType_Aggregate;
  /** fetch data from the table: "compliance.filing_status_type" */
  selectFilingStatusTypes: Array<FilingStatusType>;
  /** fetch data from the table: "auth.flow_item" using primary key columns */
  selectFlowItem?: Maybe<FlowItem>;
  /** fetch aggregated fields from the table: "auth.flow_item" */
  selectFlowItemAggregate: FlowItem_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.flow_item" */
  selectFlowItemStream: Array<FlowItem>;
  /** fetch data from the table: "auth.flow_item_type" using primary key columns */
  selectFlowItemType?: Maybe<FlowItemType>;
  /** fetch aggregated fields from the table: "auth.flow_item_type" */
  selectFlowItemTypeAggregate: FlowItemType_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.flow_item_type" */
  selectFlowItemTypeStream: Array<FlowItemType>;
  /** fetch data from the table: "auth.flow_item_type" */
  selectFlowItemTypes: Array<FlowItemType>;
  /** fetch data from the table: "auth.flow_item" */
  selectFlowItems: Array<FlowItem>;
  /** fetch data from the table: "auth.flow_type" using primary key columns */
  selectFlowType?: Maybe<FlowType>;
  /** fetch aggregated fields from the table: "auth.flow_type" */
  selectFlowTypeAggregate: FlowType_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.flow_type" */
  selectFlowTypeStream: Array<FlowType>;
  /** fetch data from the table: "auth.flow_type" */
  selectFlowTypes: Array<FlowType>;
  /** fetch data from the table: "ory.identity" */
  selectIdentities: Array<Identity>;
  /** fetch aggregated fields from the table: "ory.identity" */
  selectIdentitiesAggregate: Identity_Aggregate;
  /** fetch data from the table in a streaming manner: "ory.identity" */
  selectIdentitiesStream: Array<Identity>;
  /** fetch data from the table: "ory.identity" using primary key columns */
  selectIdentity?: Maybe<Identity>;
  /** fetch data from the table: "ory.identity_as400" using primary key columns */
  selectIdentityAs400?: Maybe<IdentityAs400>;
  /** fetch data from the table: "ory.identity_as400" */
  selectIdentityAs400s: Array<IdentityAs400>;
  /** fetch data from the table: "auth.identity_capability" */
  selectIdentityCapabilities: Array<IdentityCapability>;
  /** fetch data from the table: "auth.identity_capability" using primary key columns */
  selectIdentityCapability?: Maybe<IdentityCapability>;
  /** fetch aggregated fields from the table: "auth.identity_capability" */
  selectIdentityCapabilityAggregate: IdentityCapability_Aggregate;
  /** fetch aggregated fields from the table: "auth.identity_capability_view" */
  selectIdentityCapabilityViewAggregate: IdentityCapabilityView_Aggregate;
  /** fetch data from the table: "auth.identity_capability_view" */
  selectIdentityCapabilityViews: Array<IdentityCapabilityView>;
  /** fetch data from the table: "auth.identity_entity" */
  selectIdentityEntities: Array<IdentityEntity>;
  /** fetch data from the table: "auth.identity_entity" using primary key columns */
  selectIdentityEntity?: Maybe<IdentityEntity>;
  /** fetch aggregated fields from the table: "auth.identity_entity" */
  selectIdentityEntityAggregate: IdentityEntity_Aggregate;
  /** fetch aggregated fields from the table: "auth.identity_entity_view" */
  selectIdentityEntityViewAggregate: IdentityEntityView_Aggregate;
  /** fetch data from the table: "auth.identity_entity_view" */
  selectIdentityEntityViews: Array<IdentityEntityView>;
  /** fetch data from the table: "auth.identity_filter" using primary key columns */
  selectIdentityFilter?: Maybe<IdentityFilter>;
  /** fetch aggregated fields from the table: "auth.identity_filter" */
  selectIdentityFilterAggregate: IdentityFilter_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.identity_filter" */
  selectIdentityFilterStream: Array<IdentityFilter>;
  /** fetch data from the table: "auth.identity_filter" */
  selectIdentityFilters: Array<IdentityFilter>;
  /** fetch data from the table: "claims.invoice" using primary key columns */
  selectInvoice?: Maybe<Invoice>;
  /** fetch aggregated fields from the table: "claims.invoice" */
  selectInvoiceAggregate: Invoice_Aggregate;
  /** fetch data from the table: "claims.invoice_document_type" using primary key columns */
  selectInvoiceDocumentType?: Maybe<InvoiceDocumentType>;
  /** fetch aggregated fields from the table: "claims.invoice_document_type" */
  selectInvoiceDocumentTypeAggregate: InvoiceDocumentType_Aggregate;
  /** fetch data from the table: "claims.invoice_document_type" */
  selectInvoiceDocumentTypes: Array<InvoiceDocumentType>;
  /** fetch data from the table: "claims.invoice_payment_type" using primary key columns */
  selectInvoicePaymentType?: Maybe<InvoicePaymentType>;
  /** fetch aggregated fields from the table: "claims.invoice_payment_type" */
  selectInvoicePaymentTypeAggregate: InvoicePaymentType_Aggregate;
  /** fetch data from the table: "claims.invoice_payment_type" */
  selectInvoicePaymentTypes: Array<InvoicePaymentType>;
  /** fetch data from the table: "claims.invoice" */
  selectInvoices: Array<Invoice>;
  /** fetch data from the table: "system.job" using primary key columns */
  selectJob?: Maybe<Job>;
  /** fetch aggregated fields from the table: "system.job" */
  selectJobAggregate: Job_Aggregate;
  /** fetch data from the table: "system.job_history" */
  selectJobHistories: Array<JobHistory>;
  /** fetch data from the table: "system.job_history" using primary key columns */
  selectJobHistory?: Maybe<JobHistory>;
  /** fetch aggregated fields from the table: "system.job_history" */
  selectJobHistoryAggregate: JobHistory_Aggregate;
  /** fetch data from the table: "system.job_history_log" using primary key columns */
  selectJobHistoryLog?: Maybe<JobHistoryLog>;
  /** fetch aggregated fields from the table: "system.job_history_log" */
  selectJobHistoryLogAggregate: JobHistoryLog_Aggregate;
  /** fetch data from the table in a streaming manner: "system.job_history_log" */
  selectJobHistoryLogStream: Array<JobHistoryLog>;
  /** fetch data from the table: "system.job_history_log" */
  selectJobHistoryLogs: Array<JobHistoryLog>;
  /** fetch data from the table in a streaming manner: "system.job_history" */
  selectJobHistoryStream: Array<JobHistory>;
  /** fetch data from the table: "system.job_list_view" */
  selectJobListViews: Array<JobListView>;
  /** fetch data from the table: "system.job_schedule" using primary key columns */
  selectJobSchedule?: Maybe<JobSchedule>;
  /** fetch aggregated fields from the table: "system.job_schedule" */
  selectJobScheduleAggregate: JobSchedule_Aggregate;
  /** fetch data from the table: "system.job_schedule" */
  selectJobSchedules: Array<JobSchedule>;
  /** fetch data from the table: "system.job_step" using primary key columns */
  selectJobStep?: Maybe<JobStep>;
  /** fetch aggregated fields from the table: "system.job_step" */
  selectJobStepAggregate: JobStep_Aggregate;
  /** fetch data from the table in a streaming manner: "system.job_step" */
  selectJobStepStream: Array<JobStep>;
  /** fetch data from the table: "system.job_step" */
  selectJobSteps: Array<JobStep>;
  /** fetch data from the table in a streaming manner: "system.job" */
  selectJobStream: Array<Job>;
  /** fetch data from the table: "system.job" */
  selectJobs: Array<Job>;
  /** fetch data from the table: "accounting.journal_entry" */
  selectJournalEntries: Array<JournalEntry>;
  /** fetch data from the table: "accounting.journal_entry" using primary key columns */
  selectJournalEntry?: Maybe<JournalEntry>;
  /** fetch aggregated fields from the table: "accounting.journal_entry" */
  selectJournalEntryAggregate: JournalEntry_Aggregate;
  /** fetch data from the table: "accounting.journal_entry_line" using primary key columns */
  selectJournalEntryLine?: Maybe<JournalEntryLine>;
  /** fetch aggregated fields from the table: "accounting.journal_entry_line" */
  selectJournalEntryLineAggregate: JournalEntryLine_Aggregate;
  /** fetch data from the table in a streaming manner: "accounting.journal_entry_line" */
  selectJournalEntryLineStream: Array<JournalEntryLine>;
  /** fetch data from the table: "accounting.journal_entry_line" */
  selectJournalEntryLines: Array<JournalEntryLine>;
  /** fetch data from the table in a streaming manner: "accounting.journal_entry" */
  selectJournalEntryStream: Array<JournalEntry>;
  /** fetch data from the table: "labor_guide_type" using primary key columns */
  selectLaborGuideType?: Maybe<LaborGuideType>;
  /** fetch aggregated fields from the table: "labor_guide_type" */
  selectLaborGuideTypeAggregate: LaborGuideType_Aggregate;
  /** fetch data from the table: "labor_guide_type" */
  selectLaborGuideTypes: Array<LaborGuideType>;
  /** fetch data from the table: "claims.labor_rate" using primary key columns */
  selectLaborRate?: Maybe<LaborRate>;
  /** fetch data from the table: "claims.labor_rate_as400" using primary key columns */
  selectLaborRateAs400?: Maybe<LaborRateAs400>;
  /** fetch data from the table: "claims.labor_rate_as400" */
  selectLaborRateAs400s: Array<LaborRateAs400>;
  /** fetch data from the table: "claims.labor_rate" */
  selectLaborRates: Array<LaborRate>;
  /** fetch data from the table: "operations.legacy_policy_contract" using primary key columns */
  selectLegacyPolicyContract?: Maybe<LegacyPolicyContract>;
  /** fetch aggregated fields from the table: "operations.legacy_policy_contract" */
  selectLegacyPolicyContractAggregate: LegacyPolicyContract_Aggregate;
  /** fetch data from the table: "operations.legacy_policy_contract" */
  selectLegacyPolicyContracts: Array<LegacyPolicyContract>;
  /** fetch aggregated fields from the table: "audit.logged_actions" */
  selectLoggedActionAggregate: LoggedAction_Aggregate;
  /** fetch data from the table: "audit.logged_actions" */
  selectLoggedActions: Array<LoggedAction>;
  /** fetch data from the table: "reporting.loss_ratio" using primary key columns */
  selectLossRatio?: Maybe<LossRatio>;
  /** fetch aggregated fields from the table: "reporting.loss_ratio_current_view" */
  selectLossRatioCurrentViewAggregate: LossRatioCurrentView_Aggregate;
  /** fetch data from the table in a streaming manner: "reporting.loss_ratio_current_view" */
  selectLossRatioCurrentViewStream: Array<LossRatioCurrentView>;
  /** fetch data from the table: "reporting.loss_ratio_current_view" */
  selectLossRatioCurrentViews: Array<LossRatioCurrentView>;
  /** fetch data from the table in a streaming manner: "reporting.loss_ratio" */
  selectLossRatioStream: Array<LossRatio>;
  /** fetch data from the table: "reporting.loss_ratio" */
  selectLossRatios: Array<LossRatio>;
  /** fetch aggregated fields from the table: "reporting.loss_ratio" */
  selectLossRatiosAggregate: LossRatio_Aggregate;
  /** fetch aggregated fields from the table: "classes.materalized_class_criteria_view_default_vehicle_criteria" */
  selectMateralizedClassCriteriaViewDefaultVehicleCriteriaAggregate: MateralizedClassCriteriaViewDefaultVehicleCriteria_Aggregate;
  /** fetch data from the table: "classes.materalized_class_criteria_view_default_vehicle_criteria" */
  selectMateralizedClassCriteriaViewDefaultVehicleCriterias: Array<MateralizedClassCriteriaViewDefaultVehicleCriteria>;
  /** fetch data from the table: "miles_calculation_type" using primary key columns */
  selectMilesCalculationType?: Maybe<MilesCalculationType>;
  /** fetch aggregated fields from the table: "miles_calculation_type" */
  selectMilesCalculationTypeAggregate: MilesCalculationType_Aggregate;
  /** fetch data from the table in a streaming manner: "miles_calculation_type" */
  selectMilesCalculationTypeStream: Array<MilesCalculationType>;
  /** fetch data from the table: "miles_calculation_type" */
  selectMilesCalculationTypes: Array<MilesCalculationType>;
  /** fetch aggregated fields from the table: "nhtsa.concern_synonym" */
  selectNhtsaConcernSynonymAggregate: ConcernSynonym_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.concern_synonym" */
  selectNhtsaConcernSynonyms: Array<ConcernSynonym_Nhtsa>;
  /** fetch data from the table: "nhtsa.investigation_recall" using primary key columns */
  selectNhtsaInvestigationRecall?: Maybe<InvestigationRecall_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.investigation_recall" */
  selectNhtsaInvestigationRecallAggregate: InvestigationRecall_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.investigation_recall" */
  selectNhtsaInvestigationRecalls: Array<InvestigationRecall_Nhtsa>;
  /** fetch data from the table: "nhtsa.issue" using primary key columns */
  selectNhtsaIssue?: Maybe<Issue_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.issue" */
  selectNhtsaIssueAggregate: Issue_Aggregate_Nhtsa;
  /** fetch aggregated fields from the table: "nhtsa.issue_make_model" */
  selectNhtsaIssueMakeModelAggregate: IssueMakeModel_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.issue_make_model" */
  selectNhtsaIssueMakeModels: Array<IssueMakeModel_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.issue_search_result" */
  selectNhtsaIssueSearchResultAggregate: IssueSearchResult_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.issue_search_result" */
  selectNhtsaIssueSearchResults: Array<IssueSearchResult_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.issue_vehicle" */
  selectNhtsaIssueVehicleAggregate: IssueVehicle_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.issue_vehicle" */
  selectNhtsaIssueVehicles: Array<IssueVehicle_Nhtsa>;
  /** fetch data from the table: "nhtsa.issue" */
  selectNhtsaIssues: Array<Issue_Nhtsa>;
  /** fetch data from the table: "nhtsa.load" using primary key columns */
  selectNhtsaLoad?: Maybe<Load_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.load" */
  selectNhtsaLoadAggregate: Load_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.load" */
  selectNhtsaLoads: Array<Load_Nhtsa>;
  /** fetch data from the table: "nhtsa.make_model" using primary key columns */
  selectNhtsaMakeModel?: Maybe<MakeModel_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.make_model" */
  selectNhtsaMakeModelAggregate: MakeModel_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.make_model" */
  selectNhtsaMakeModels: Array<MakeModel_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.model_year_model" */
  selectNhtsaModelYearModelAggregate: ModelYearModel_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.model_year_model" */
  selectNhtsaModelYearModels: Array<ModelYearModel_Nhtsa>;
  /** fetch data from the table: "nhtsa.record_type" using primary key columns */
  selectNhtsaRecordType?: Maybe<RecordType_Nhtsa>;
  /** fetch aggregated fields from the table: "nhtsa.record_type" */
  selectNhtsaRecordTypeAggregate: RecordType_Aggregate_Nhtsa;
  /** fetch data from the table: "nhtsa.record_type" */
  selectNhtsaRecordTypes: Array<RecordType_Nhtsa>;
  /** fetch data from the table: "obligor" using primary key columns */
  selectObligor?: Maybe<Obligor>;
  /** fetch data from the table: "obligor" */
  selectObligors: Array<Obligor>;
  /** fetch aggregated fields from the table: "obligor" */
  selectObligorsAggregate: Obligor_Aggregate;
  /** fetch data from the table: "job" using primary key columns */
  selectObsoleteJob?: Maybe<ObsoleteJob>;
  /** fetch aggregated fields from the table: "job" */
  selectObsoleteJobAggregate: ObsoleteJob_Aggregate;
  /** fetch data from the table: "job" */
  selectObsoleteJobs: Array<ObsoleteJob>;
  /** fetch data from the table: "system.outbox_event" using primary key columns */
  selectOutboxEvent?: Maybe<OutboxEvent>;
  /** fetch aggregated fields from the table: "system.outbox_event" */
  selectOutboxEventAggregate: OutboxEvent_Aggregate;
  /** fetch data from the table in a streaming manner: "system.outbox_event" */
  selectOutboxEventStream: Array<OutboxEvent>;
  /** fetch data from the table: "system.outbox_event" */
  selectOutboxEvents: Array<OutboxEvent>;
  /** fetch data from the table: "shared.participant" using primary key columns */
  selectParticipant?: Maybe<Participant>;
  /** fetch aggregated fields from the table: "shared.participant" */
  selectParticipantAggregate: Participant_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.participant" */
  selectParticipantStream: Array<Participant>;
  /** fetch data from the table: "shared.participant" */
  selectParticipants: Array<Participant>;
  /** fetch data from the table: "accounting.payee" using primary key columns */
  selectPayee?: Maybe<Payee>;
  /** fetch data from the table: "accounting.payee_as400" using primary key columns */
  selectPayeeAs400?: Maybe<PayeeAs400>;
  /** fetch aggregated fields from the table: "accounting.payee_as400" */
  selectPayeeAs400Aggregate: PayeeAs400_Aggregate;
  /** fetch data from the table: "accounting.payee_as400" */
  selectPayeeAs400s: Array<PayeeAs400>;
  /** fetch aggregated fields from the table: "accounting.payee_link_view" */
  selectPayeeLinkViewAggregate: PayeeLinkView_Aggregate;
  /** fetch data from the table: "accounting.payee_link_view" */
  selectPayeeLinkViews: Array<PayeeLinkView>;
  /** fetch data from the table: "accounting.payee" */
  selectPayees: Array<Payee>;
  /** fetch aggregated fields from the table: "accounting.payee" */
  selectPayeesAggregate: Payee_Aggregate;
  /** fetch data from the table: "shared.payment" using primary key columns */
  selectPayment?: Maybe<Payment>;
  /** fetch aggregated fields from the table: "shared.payment" */
  selectPaymentAggregate: Payment_Aggregate;
  /** fetch data from the table: "shared.payment_as400" using primary key columns */
  selectPaymentAs400?: Maybe<PaymentAs400>;
  /** fetch data from the table: "shared.payment_as400" */
  selectPaymentAs400s: Array<PaymentAs400>;
  /** fetch data from the table: "shared.payment_detail" using primary key columns */
  selectPaymentDetail?: Maybe<PaymentDetail>;
  /** fetch aggregated fields from the table: "shared.payment_detail" */
  selectPaymentDetailAggregate: PaymentDetail_Aggregate;
  /** fetch data from the table: "shared.payment_detail" */
  selectPaymentDetails: Array<PaymentDetail>;
  /** fetch data from the table: "shared.payment_method_type" using primary key columns */
  selectPaymentMethodType?: Maybe<PaymentMethodType>;
  /** fetch aggregated fields from the table: "shared.payment_method_type" */
  selectPaymentMethodTypeAggregate: PaymentMethodType_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.payment_method_type" */
  selectPaymentMethodTypeStream: Array<PaymentMethodType>;
  /** fetch data from the table: "shared.payment_method_type" */
  selectPaymentMethodTypes: Array<PaymentMethodType>;
  /** fetch data from the table: "shared.payment_status_type" using primary key columns */
  selectPaymentStatusType?: Maybe<PaymentStatusType>;
  /** fetch aggregated fields from the table: "shared.payment_status_type" */
  selectPaymentStatusTypeAggregate: PaymentStatusType_Aggregate;
  /** fetch data from the table: "shared.payment_status_type" */
  selectPaymentStatusTypes: Array<PaymentStatusType>;
  /** fetch data from the table: "shared.payment_type" using primary key columns */
  selectPaymentType?: Maybe<PaymentType>;
  /** fetch data from the table: "shared.payment_type" */
  selectPaymentTypes: Array<PaymentType>;
  /** fetch data from the table: "shared.payment" */
  selectPayments: Array<Payment>;
  /** fetch data from the table: "Plan" using primary key columns */
  selectPlan?: Maybe<Plan>;
  /** fetch aggregated fields from the table: "Plan" */
  selectPlanAggregate: Plan_Aggregate;
  /** fetch data from the table: "Plan" */
  selectPlans: Array<Plan>;
  /** fetch data from the table: "operations.policy" */
  selectPolicies: Array<Policy>;
  /** fetch aggregated fields from the table: "operations.policy" */
  selectPoliciesAggregate: Policy_Aggregate;
  /** fetch data from the table: "operations.policy" using primary key columns */
  selectPolicy?: Maybe<Policy>;
  /** fetch data from the table: "claims.policy_claim" using primary key columns */
  selectPolicyClaim?: Maybe<PolicyClaim>;
  /** fetch aggregated fields from the table: "claims.policy_claim" */
  selectPolicyClaimAggregate: PolicyClaim_Aggregate;
  /** fetch data from the table: "claims.policy_claim_as400" using primary key columns */
  selectPolicyClaimAs400?: Maybe<PolicyClaimAs400>;
  /** fetch data from the table: "claims.policy_claim_as400" */
  selectPolicyClaimAs400s: Array<PolicyClaimAs400>;
  /** fetch data from the table: "claims.policy_claim_concern" using primary key columns */
  selectPolicyClaimConcern?: Maybe<PolicyClaimConcern>;
  /** fetch aggregated fields from the table: "claims.policy_claim_concern" */
  selectPolicyClaimConcernAggregate: PolicyClaimConcern_Aggregate;
  /** fetch data from the table: "claims.policy_claim_concern" */
  selectPolicyClaimConcerns: Array<PolicyClaimConcern>;
  /** fetch data from the table: "claims.policy_claim_insurance" using primary key columns */
  selectPolicyClaimInsurance?: Maybe<PolicyClaimInsurance>;
  /** fetch data from the table: "claims.policy_claim_insurance" */
  selectPolicyClaimInsurances: Array<PolicyClaimInsurance>;
  /** fetch data from the table: "claims.policy_claim" */
  selectPolicyClaims: Array<PolicyClaim>;
  /** comment about pk */
  selectPolicyContract?: Maybe<PolicyContract>;
  /** fetch data from the table: "operations.policy_contract_asset" using primary key columns */
  selectPolicyContractAsset?: Maybe<PolicyContractAsset>;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_asset" */
  selectPolicyContractAssetStream: Array<PolicyContractAsset>;
  /** fetch data from the table: "operations.policy_contract_asset_type" using primary key columns */
  selectPolicyContractAssetType?: Maybe<PolicyContractAssetType>;
  /** fetch aggregated fields from the table: "operations.policy_contract_asset_type" */
  selectPolicyContractAssetTypeAggregate: PolicyContractAssetType_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_asset_type" */
  selectPolicyContractAssetTypeStream: Array<PolicyContractAssetType>;
  /** fetch data from the table: "operations.policy_contract_asset_type" */
  selectPolicyContractAssetTypes: Array<PolicyContractAssetType>;
  /** fetch data from the table: "operations.policy_contract_asset" */
  selectPolicyContractAssets: Array<PolicyContractAsset>;
  /** fetch aggregated fields from the table: "operations.policy_contract_asset" */
  selectPolicyContractAssetsAggregate: PolicyContractAsset_Aggregate;
  /** fetch data from the table: "operations.policy_contract_contract_form_version" using primary key columns */
  selectPolicyContractContractFormVersion?: Maybe<PolicyContractContractFormVersion>;
  /** fetch aggregated fields from the table: "operations.policy_contract_contract_form_version" */
  selectPolicyContractContractFormVersionAggregate: PolicyContractContractFormVersion_Aggregate;
  /** fetch data from the table: "operations.policy_contract_contract_form_version" */
  selectPolicyContractContractFormVersions: Array<PolicyContractContractFormVersion>;
  /** fetch data from the table: "operations.policy_contract_cost_detail" using primary key columns */
  selectPolicyContractCostDetail?: Maybe<PolicyContractCostDetail>;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_cost_detail" */
  selectPolicyContractCostDetailStream: Array<PolicyContractCostDetail>;
  /** fetch data from the table: "operations.policy_contract_cost_detail" */
  selectPolicyContractCostDetails: Array<PolicyContractCostDetail>;
  /** fetch aggregated fields from the table: "operations.policy_contract_cost_detail" */
  selectPolicyContractCostDetailsAggregate: PolicyContractCostDetail_Aggregate;
  /** fetch data from the table: "operations.policy_contract_lender" using primary key columns */
  selectPolicyContractLender?: Maybe<PolicyContractLender>;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_lender" */
  selectPolicyContractLenderStream: Array<PolicyContractLender>;
  /** fetch data from the table: "operations.policy_contract_lender" */
  selectPolicyContractLenders: Array<PolicyContractLender>;
  /** fetch aggregated fields from the table: "operations.policy_contract_lender" */
  selectPolicyContractLendersAggregate: PolicyContractLender_Aggregate;
  /** fetch aggregated fields from the table: "operations.policy_contract_list_view" */
  selectPolicyContractListViewAggregate: PolicyContractListView_Aggregate;
  /** fetch data from the table: "operations.policy_contract_list_view" */
  selectPolicyContractListViews: Array<PolicyContractListView>;
  /** fetch data from the table: "operations.policy_contract_loan_contract_type" using primary key columns */
  selectPolicyContractLoanContractType?: Maybe<PolicyContractLoanContractType>;
  /** fetch aggregated fields from the table: "operations.policy_contract_loan_contract_type" */
  selectPolicyContractLoanContractTypeAggregate: PolicyContractLoanContractType_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_loan_contract_type" */
  selectPolicyContractLoanContractTypeStream: Array<PolicyContractLoanContractType>;
  /** fetch data from the table: "operations.policy_contract_loan_contract_type" */
  selectPolicyContractLoanContractTypes: Array<PolicyContractLoanContractType>;
  /** fetch data from the table: "operations.policy_contract_owner" using primary key columns */
  selectPolicyContractOwner?: Maybe<PolicyContractOwner>;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_owner" */
  selectPolicyContractOwnerStream: Array<PolicyContractOwner>;
  /** fetch data from the table: "operations.policy_contract_owner" */
  selectPolicyContractOwners: Array<PolicyContractOwner>;
  /** fetch aggregated fields from the table: "operations.policy_contract_owner" */
  selectPolicyContractOwnersAggregate: PolicyContractOwner_Aggregate;
  /** fetch data from the table: "operations.policy_contract_product" using primary key columns */
  selectPolicyContractProduct?: Maybe<PolicyContractProduct>;
  /** fetch aggregated fields from the table: "operations.policy_contract_product" */
  selectPolicyContractProductAggregate: PolicyContractProduct_Aggregate;
  /** fetch data from the table: "operations.policy_contract_product_cost_detail" using primary key columns */
  selectPolicyContractProductCostDetail?: Maybe<PolicyContractProductCostDetail>;
  /** fetch aggregated fields from the table: "operations.policy_contract_product_cost_detail" */
  selectPolicyContractProductCostDetailAggregate: PolicyContractProductCostDetail_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_product_cost_detail" */
  selectPolicyContractProductCostDetailStream: Array<PolicyContractProductCostDetail>;
  /** fetch data from the table: "operations.policy_contract_product_cost_detail" */
  selectPolicyContractProductCostDetails: Array<PolicyContractProductCostDetail>;
  /** fetch aggregated fields from the table: "operations.policy_contract_product_options_metadata_view" */
  selectPolicyContractProductOptionsMetadataViewAggregate: PolicyContractProductOptionsMetadataView_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_product_options_metadata_view" */
  selectPolicyContractProductOptionsMetadataViewStream: Array<PolicyContractProductOptionsMetadataView>;
  /** fetch data from the table: "operations.policy_contract_product_options_metadata_view" */
  selectPolicyContractProductOptionsMetadataViews: Array<PolicyContractProductOptionsMetadataView>;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_product" */
  selectPolicyContractProductStream: Array<PolicyContractProduct>;
  /** fetch data from the table: "operations.policy_contract_product" */
  selectPolicyContractProducts: Array<PolicyContractProduct>;
  /** fetch data from the table: "operations.policy_contract_quote" using primary key columns */
  selectPolicyContractQuote?: Maybe<PolicyContractQuote>;
  /** fetch aggregated fields from the table: "operations.policy_contract_quote" */
  selectPolicyContractQuoteAggregate: PolicyContractQuote_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_quote" */
  selectPolicyContractQuoteStream: Array<PolicyContractQuote>;
  /** fetch data from the table: "operations.policy_contract_quote" */
  selectPolicyContractQuotes: Array<PolicyContractQuote>;
  /** fetch data from the table: "operations.policy_contract_status_type" using primary key columns */
  selectPolicyContractStatusType?: Maybe<PolicyContractStatusType>;
  /** fetch aggregated fields from the table: "operations.policy_contract_status_type" */
  selectPolicyContractStatusTypeAggregate: PolicyContractStatusType_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_status_type" */
  selectPolicyContractStatusTypeStream: Array<PolicyContractStatusType>;
  /** fetch data from the table: "operations.policy_contract_status_type" */
  selectPolicyContractStatusTypes: Array<PolicyContractStatusType>;
  /** fetch data from the table in a streaming manner: "operations.policy_contract" */
  selectPolicyContractStream: Array<PolicyContract>;
  /** fetch data from the table: "operations.policy_contract_void_reason_type" using primary key columns */
  selectPolicyContractVoidReasonType?: Maybe<PolicyContractVoidReasonType>;
  /** fetch aggregated fields from the table: "operations.policy_contract_void_reason_type" */
  selectPolicyContractVoidReasonTypeAggregate: PolicyContractVoidReasonType_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.policy_contract_void_reason_type" */
  selectPolicyContractVoidReasonTypeStream: Array<PolicyContractVoidReasonType>;
  /** fetch data from the table: "operations.policy_contract_void_reason_type" */
  selectPolicyContractVoidReasonTypes: Array<PolicyContractVoidReasonType>;
  /** comment about this */
  selectPolicyContracts: Array<PolicyContract>;
  /** fetch aggregated fields from the table: "operations.policy_contract" */
  selectPolicyContractsAggregate: PolicyContract_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.policy" */
  selectPolicyStream: Array<Policy>;
  /** fetch data from the table: "claims.pre_authorization" using primary key columns */
  selectPreAuthorization?: Maybe<PreAuthorization>;
  /** fetch data from the table: "claims.pre_authorization_status_type" using primary key columns */
  selectPreAuthorizationStatusType?: Maybe<PreAuthorizationStatusType>;
  /** fetch aggregated fields from the table: "claims.pre_authorization_status_type" */
  selectPreAuthorizationStatusTypeAggregate: PreAuthorizationStatusType_Aggregate;
  /** fetch data from the table in a streaming manner: "claims.pre_authorization_status_type" */
  selectPreAuthorizationStatusTypeStream: Array<PreAuthorizationStatusType>;
  /** fetch data from the table: "claims.pre_authorization_status_type" */
  selectPreAuthorizationStatusTypes: Array<PreAuthorizationStatusType>;
  /** fetch data from the table in a streaming manner: "claims.pre_authorization" */
  selectPreAuthorizationStream: Array<PreAuthorization>;
  /** fetch data from the table: "claims.pre_authorization_type" using primary key columns */
  selectPreAuthorizationType?: Maybe<PreAuthorizationType>;
  /** fetch data from the table in a streaming manner: "claims.pre_authorization_type" */
  selectPreAuthorizationTypeStream: Array<PreAuthorizationType>;
  /** fetch data from the table: "claims.pre_authorization_type" */
  selectPreAuthorizationTypes: Array<PreAuthorizationType>;
  /** fetch aggregated fields from the table: "claims.pre_authorization_type" */
  selectPreAuthorizationTypesAggregate: PreAuthorizationType_Aggregate;
  /** fetch data from the table: "claims.pre_authorization" */
  selectPreAuthorizations: Array<PreAuthorization>;
  /** fetch aggregated fields from the table: "claims.pre_authorization" */
  selectPreAuthorizationsAggregate: PreAuthorization_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  selectProduct?: Maybe<Product>;
  /** fetch data from the table: "product_attribute" using primary key columns */
  selectProductAttribute?: Maybe<ProductAttribute>;
  /** fetch aggregated fields from the table: "product_attribute" */
  selectProductAttributeAggregate: ProductAttribute_Aggregate;
  /** fetch data from the table: "product_attribute_type" using primary key columns */
  selectProductAttributeType?: Maybe<ProductAttributeType>;
  /** fetch aggregated fields from the table: "product_attribute_type" */
  selectProductAttributeTypeAggregate: ProductAttributeType_Aggregate;
  /** fetch data from the table: "product_attribute_type" */
  selectProductAttributeTypes: Array<ProductAttributeType>;
  /** fetch data from the table: "product_attribute" */
  selectProductAttributes: Array<ProductAttribute>;
  /** fetch data from the table: "product_class_guide" using primary key columns */
  selectProductClassGuide?: Maybe<ProductClassGuide>;
  /** fetch aggregated fields from the table: "product_class_guide" */
  selectProductClassGuideAggregate: ProductClassGuide_Aggregate;
  /** fetch data from the table: "product_class_guide" */
  selectProductClassGuides: Array<ProductClassGuide>;
  /** fetch data from the table: "compliance.product_contract_form" using primary key columns */
  selectProductContractForm?: Maybe<ProductContractForm>;
  /** fetch aggregated fields from the table: "compliance.product_contract_form" */
  selectProductContractFormAggregate: ProductContractForm_Aggregate;
  /** fetch data from the table: "compliance.product_contract_form" */
  selectProductContractForms: Array<ProductContractForm>;
  /** fetch data from the table: "product_cost" using primary key columns */
  selectProductCost?: Maybe<ProductCost>;
  /** fetch aggregated fields from the table: "product_cost" */
  selectProductCostAggregate: ProductCost_Aggregate;
  /** fetch data from the table: "product_cost" */
  selectProductCosts: Array<ProductCost>;
  /** fetch data from the table: "product_disbursement" using primary key columns */
  selectProductDisbursement?: Maybe<ProductDisbursement>;
  /** fetch aggregated fields from the table: "product_disbursement" */
  selectProductDisbursementAggregate: ProductDisbursement_Aggregate;
  /** fetch data from the table: "product_disbursement" */
  selectProductDisbursements: Array<ProductDisbursement>;
  /** fetch data from the table: "product_eligibility_rule" */
  selectProductEligibilities: Array<ProductEligibility>;
  /** fetch data from the table: "product_eligibility_rule" using primary key columns */
  selectProductEligibility?: Maybe<ProductEligibility>;
  /** fetch aggregated fields from the table: "product_eligibility_rule" */
  selectProductEligibilityAggregate: ProductEligibility_Aggregate;
  /** fetch data from the table: "product_obligor" using primary key columns */
  selectProductObligor?: Maybe<ProductObligor>;
  /** fetch data from the table: "product_obligor" */
  selectProductObligors: Array<ProductObligor>;
  /** fetch aggregated fields from the table: "product_obligor" */
  selectProductObligorsAggregate: ProductObligor_Aggregate;
  /** fetch data from the table: "product_rate_bucket" using primary key columns */
  selectProductRateBucket?: Maybe<ProductRateBucket>;
  /** fetch aggregated fields from the table: "product_rate_bucket" */
  selectProductRateBucketAggregate: ProductRateBucket_Aggregate;
  /** fetch data from the table: "product_rate_bucket" */
  selectProductRateBuckets: Array<ProductRateBucket>;
  /** fetch data from the table: "product_surcharge_type" using primary key columns */
  selectProductSurchargeType?: Maybe<ProductSurchargeType>;
  /** fetch aggregated fields from the table: "product_surcharge_type" */
  selectProductSurchargeTypeAggregate: ProductSurchargeType_Aggregate;
  /** fetch data from the table: "product_surcharge_type" */
  selectProductSurchargeTypes: Array<ProductSurchargeType>;
  /** fetch data from the table: "product" */
  selectProducts: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  selectProductsAggregate: Product_Aggregate;
  /** fetch data from the table: "users.profile" using primary key columns */
  selectProfile?: Maybe<Profile>;
  /** fetch aggregated fields from the table: "users.profile" */
  selectProfileAggregate: Profile_Aggregate;
  /** fetch data from the table in a streaming manner: "users.profile" */
  selectProfileStream: Array<Profile>;
  /** fetch data from the table: "users.profile" */
  selectProfiles: Array<Profile>;
  /** fetch data from the table: "quotes.quote" using primary key columns */
  selectQuote?: Maybe<Quote>;
  /** fetch aggregated fields from the table: "quotes.quote" */
  selectQuoteAggregate: Quote_Aggregate;
  /** fetch aggregated fields from the table: "quotes.quote_minimal_view" */
  selectQuoteMinimalViewAggregate: QuoteMinimalView_Aggregate;
  /** fetch data from the table: "quotes.quote_minimal_view" */
  selectQuoteMinimalViews: Array<QuoteMinimalView>;
  /** fetch data from the table: "quotes.quote_type" using primary key columns */
  selectQuoteType?: Maybe<QuoteType>;
  /** fetch aggregated fields from the table: "quotes.quote_type" */
  selectQuoteTypeAggregate: QuoteType_Aggregate;
  /** fetch data from the table: "quotes.quote_type" */
  selectQuoteTypes: Array<QuoteType>;
  /** fetch data from the table: "quotes.quote" */
  selectQuotes: Array<Quote>;
  /** fetch data from the table: "rate_bucket_type" using primary key columns */
  selectRateBucketType?: Maybe<RateBucketType>;
  /** fetch aggregated fields from the table: "rate_bucket_type" */
  selectRateBucketTypeAggregate: RateBucketType_Aggregate;
  /** fetch data from the table: "rate_bucket_type" */
  selectRateBucketTypes: Array<RateBucketType>;
  /** fetch data from the table: "rate_quote" using primary key columns */
  selectRateQuote?: Maybe<RateQuote>;
  /** fetch data from the table: "rate_quote" */
  selectRateQuotes: Array<RateQuote>;
  /** fetch aggregated fields from the table: "rate_quote" */
  selectRateQuotesAggregate: RateQuote_Aggregate;
  /** fetch data from the table: "ui.rater_view_config" using primary key columns */
  selectRaterViewConfig?: Maybe<RaterViewConfig>;
  /** fetch data from the table: "ui.rater_view_config" */
  selectRaterViewConfigs: Array<RaterViewConfig>;
  /** fetch data from the table: "system.reference_log" using primary key columns */
  selectReferenceLog?: Maybe<ReferenceLog>;
  /** fetch aggregated fields from the table: "system.reference_log" */
  selectReferenceLogAggregate: ReferenceLog_Aggregate;
  /** fetch data from the table in a streaming manner: "system.reference_log" */
  selectReferenceLogStream: Array<ReferenceLog>;
  /** fetch data from the table: "system.reference_log" */
  selectReferenceLogs: Array<ReferenceLog>;
  /** fetch data from the table: "operations.remittance" using primary key columns */
  selectRemittance?: Maybe<Remittance>;
  /** fetch aggregated fields from the table: "operations.remittance" */
  selectRemittanceAggregate: Remittance_Aggregate;
  /** fetch data from the table: "claims.remittance_claim_detail" using primary key columns */
  selectRemittanceClaimDetail?: Maybe<RemittanceClaimDetail>;
  /** fetch data from the table: "claims.remittance_claim_detail" */
  selectRemittanceClaimDetails: Array<RemittanceClaimDetail>;
  /** fetch data from the table: "operations.remittance_payment" using primary key columns */
  selectRemittancePayment?: Maybe<RemittancePayment>;
  /** fetch aggregated fields from the table: "operations.remittance_payment" */
  selectRemittancePaymentAggregate: RemittancePayment_Aggregate;
  /** fetch data from the table: "operations.remittance_payment" */
  selectRemittancePayments: Array<RemittancePayment>;
  /** fetch data from the table: "operations.remittance_policy_contract" using primary key columns */
  selectRemittancePolicyContract?: Maybe<RemittancePolicyContract>;
  /** fetch aggregated fields from the table: "operations.remittance_policy_contract" */
  selectRemittancePolicyContractAggregate: RemittancePolicyContract_Aggregate;
  /** fetch data from the table: "operations.remittance_policy_contract_as400" using primary key columns */
  selectRemittancePolicyContractAs400?: Maybe<RemittancePolicyContractAs400>;
  /** fetch aggregated fields from the table: "operations.remittance_policy_contract_as400" */
  selectRemittancePolicyContractAs400Aggregate: RemittancePolicyContractAs400_Aggregate;
  /** fetch data from the table: "operations.remittance_policy_contract_as400" */
  selectRemittancePolicyContractAs400s: Array<RemittancePolicyContractAs400>;
  /** fetch data from the table in a streaming manner: "operations.remittance_policy_contract" */
  selectRemittancePolicyContractStream: Array<RemittancePolicyContract>;
  /** fetch data from the table: "operations.remittance_policy_contract" */
  selectRemittancePolicyContracts: Array<RemittancePolicyContract>;
  /** fetch data from the table: "operations.remittance_status_type" using primary key columns */
  selectRemittanceStatusType?: Maybe<RemittanceStatusType>;
  /** fetch aggregated fields from the table: "operations.remittance_status_type" */
  selectRemittanceStatusTypeAggregate: RemittanceStatusType_Aggregate;
  /** fetch data from the table in a streaming manner: "operations.remittance_status_type" */
  selectRemittanceStatusTypeStream: Array<RemittanceStatusType>;
  /** fetch data from the table: "operations.remittance_status_type" */
  selectRemittanceStatusTypes: Array<RemittanceStatusType>;
  /** fetch data from the table in a streaming manner: "operations.remittance" */
  selectRemittanceStream: Array<Remittance>;
  /** fetch data from the table: "operations.remittance_type" using primary key columns */
  selectRemittanceType?: Maybe<RemittanceType>;
  /** fetch aggregated fields from the table: "operations.remittance_type" */
  selectRemittanceTypeAggregate: RemittanceType_Aggregate;
  /** fetch data from the table: "operations.remittance_type" */
  selectRemittanceTypes: Array<RemittanceType>;
  /** fetch data from the table: "operations.remittance" */
  selectRemittances: Array<Remittance>;
  /** fetch data from the table: "claims.repeat_part_acknowledgment" using primary key columns */
  selectRepeatPartAcknowledgment?: Maybe<RepeatPartAcknowledgment>;
  /** fetch aggregated fields from the table: "claims.repeat_part_acknowledgment" */
  selectRepeatPartAcknowledgmentAggregate: RepeatPartAcknowledgment_Aggregate;
  /** fetch data from the table: "claims.repeat_part_acknowledgment" */
  selectRepeatPartAcknowledgments: Array<RepeatPartAcknowledgment>;
  /** fetch data from the table: "auth.role" using primary key columns */
  selectRole?: Maybe<Role>;
  /** fetch aggregated fields from the table: "auth.role" */
  selectRoleAggregate: Role_Aggregate;
  /** fetch data from the table: "auth.role_attribute" using primary key columns */
  selectRoleAttribute?: Maybe<RoleAttribute>;
  /** fetch aggregated fields from the table: "auth.role_attribute" */
  selectRoleAttributeAggregate: RoleAttribute_Aggregate;
  /** fetch data from the table: "auth.role_attribute" */
  selectRoleAttributes: Array<RoleAttribute>;
  /** fetch aggregated fields from the table: "auth.role_hierarchy_view" */
  selectRoleHierarchyViewAggregate: RoleHierarchyView_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.role_hierarchy_view" */
  selectRoleHierarchyViewStream: Array<RoleHierarchyView>;
  /** fetch data from the table: "auth.role_hierarchy_view" */
  selectRoleHierarchyViews: Array<RoleHierarchyView>;
  /** fetch data from the table: "auth.role" */
  selectRoles: Array<Role>;
  /** fetch data from the table: "auth.route" using primary key columns */
  selectRoute?: Maybe<Route>;
  /** fetch aggregated fields from the table: "auth.route" */
  selectRouteAggregate: Route_Aggregate;
  /** fetch data from the table: "auth.route_config" using primary key columns */
  selectRouteConfig?: Maybe<RouteConfig>;
  /** fetch aggregated fields from the table: "auth.route_config" */
  selectRouteConfigAggregate: RouteConfig_Aggregate;
  /** fetch data from the table: "auth.route_config" */
  selectRouteConfigs: Array<RouteConfig>;
  /** fetch data from the table: "auth.route" */
  selectRoutes: Array<Route>;
  /** fetch data from the table: "shared.search_index" using primary key columns */
  selectSearchIndex?: Maybe<SearchIndex>;
  /** fetch aggregated fields from the table: "shared.search_index" */
  selectSearchIndexAggregate: SearchIndex_Aggregate;
  /** fetch data from the table: "shared.search_index" */
  selectSearchIndexes: Array<SearchIndex>;
  /** fetch data from the table: "claims.service_center" using primary key columns */
  selectServiceCenter?: Maybe<ServiceCenter>;
  /** fetch aggregated fields from the table: "claims.service_center" */
  selectServiceCenterAggregate: ServiceCenter_Aggregate;
  /** fetch data from the table: "claims.service_center" */
  selectServiceCenters: Array<ServiceCenter>;
  /** fetch data from the table: "system.severity_level_type" using primary key columns */
  selectSeverityLevelType?: Maybe<SeverityLevelType>;
  /** fetch aggregated fields from the table: "system.severity_level_type" */
  selectSeverityLevelTypeAggregate: SeverityLevelType_Aggregate;
  /** fetch data from the table in a streaming manner: "system.severity_level_type" */
  selectSeverityLevelTypeStream: Array<SeverityLevelType>;
  /** fetch data from the table: "system.severity_level_type" */
  selectSeverityLevelTypes: Array<SeverityLevelType>;
  /** fetch data from the table: "users.shortcut_binding" using primary key columns */
  selectShortcutBinding?: Maybe<ShortcutBinding>;
  /** fetch aggregated fields from the table: "users.shortcut_binding" */
  selectShortcutBindingAggregate: ShortcutBinding_Aggregate;
  /** fetch data from the table in a streaming manner: "users.shortcut_binding" */
  selectShortcutBindingStream: Array<ShortcutBinding>;
  /** fetch data from the table: "users.shortcut_binding" */
  selectShortcutBindings: Array<ShortcutBinding>;
  /** fetch data from the table: "state" using primary key columns */
  selectState?: Maybe<State>;
  /** fetch data from the table: "state" */
  selectStates: Array<State>;
  /** fetch aggregated fields from the table: "state" */
  selectStatesAggregate: State_Aggregate;
  /** fetch data from the table: "system.step" using primary key columns */
  selectStep?: Maybe<Step>;
  /** fetch aggregated fields from the table: "system.step" */
  selectStepAggregate: Step_Aggregate;
  /** fetch data from the table: "system.step_list_view" */
  selectStepListViews: Array<StepListView>;
  /** fetch data from the table in a streaming manner: "system.step" */
  selectStepStream: Array<Step>;
  /** fetch data from the table: "system.step_type" using primary key columns */
  selectStepType?: Maybe<StepType>;
  /** fetch aggregated fields from the table: "system.step_type" */
  selectStepTypeAggregate: StepType_Aggregate;
  /** fetch data from the table in a streaming manner: "system.step_type" */
  selectStepTypeStream: Array<StepType>;
  /** fetch data from the table: "system.step_type" */
  selectStepTypes: Array<StepType>;
  /** fetch data from the table: "system.step" */
  selectSteps: Array<Step>;
  /** fetch data from the table in a streaming manner: "account_obligor" */
  selectStreamAccountObligors: Array<AccountObligor>;
  /** fetch data from the table in a streaming manner: "claims.claim_detail_as400" */
  selectStreamClaimDetailAs400: Array<ClaimDetailAs400>;
  /** fetch data from the table in a streaming manner: "claims.claim_detail_deduction_as400" */
  selectStreamClaimDetailDeductionAs400: Array<ClaimDetailDeductionAs400>;
  /** fetch data from the table in a streaming manner: "claims.claim_service_center_as400" */
  selectStreamClaimServiceCenterAs400: Array<ClaimServiceCenterAs400>;
  /** fetch data from the table in a streaming manner: "composite_product" */
  selectStreamCompositeProducts: Array<CompositeProduct>;
  /** fetch data from the table in a streaming manner: "ory.identity_as400" */
  selectStreamIdentityAs400: Array<IdentityAs400>;
  /** fetch data from the table in a streaming manner: "system.job_list_view" */
  selectStreamJobListView: Array<JobListView>;
  /** fetch data from the table in a streaming manner: "claims.labor_rate" */
  selectStreamLaborRate: Array<LaborRate>;
  /** fetch data from the table in a streaming manner: "claims.labor_rate_as400" */
  selectStreamLaborRateAs400: Array<LaborRateAs400>;
  /** fetch data from the table in a streaming manner: "shared.payment_as400" */
  selectStreamPaymentAs400: Array<PaymentAs400>;
  /** fetch data from the table in a streaming manner: "claims.policy_claim_as400" */
  selectStreamPolicyClaimAs400: Array<PolicyClaimAs400>;
  /** fetch data from the table in a streaming manner: "claims.policy_claim_insurance" */
  selectStreamPolicyClaimInsurance: Array<PolicyClaimInsurance>;
  /** fetch data from the table in a streaming manner: "ui.rater_view_config" */
  selectStreamRaterViewConfigs: Array<RaterViewConfig>;
  /** fetch data from the table in a streaming manner: "system.step_list_view" */
  selectStreamStepListView: Array<StepListView>;
  /** fetch data from the table in a streaming manner: "claims.tax_rate" */
  selectStreamTaxRate: Array<TaxRate>;
  /** fetch data from the table in a streaming manner: "claims.tax_rate_as400" */
  selectStreamTaxRateAs400: Array<TaxRateAs400>;
  /** fetch data from the table: "surcharge_type" using primary key columns */
  selectSurchargeType?: Maybe<SurchargeType>;
  /** fetch aggregated fields from the table: "surcharge_type" */
  selectSurchargeTypeAggregate: SurchargeType_Aggregate;
  /** fetch data from the table: "surcharge_type" */
  selectSurchargeTypes: Array<SurchargeType>;
  /** fetch data from the table: "shared.tag" using primary key columns */
  selectTag?: Maybe<Tag>;
  /** fetch aggregated fields from the table: "shared.tag" */
  selectTagAggregate: Tag_Aggregate;
  /** fetch data from the table: "shared.tag" */
  selectTags: Array<Tag>;
  /** fetch data from the table: "task" using primary key columns */
  selectTask?: Maybe<Task>;
  /** fetch aggregated fields from the table: "task" */
  selectTaskAggregate: Task_Aggregate;
  /** fetch data from the table: "task" */
  selectTasks: Array<Task>;
  /** fetch data from the table: "claims.tax_rate" using primary key columns */
  selectTaxRate?: Maybe<TaxRate>;
  /** fetch data from the table: "claims.tax_rate_as400" using primary key columns */
  selectTaxRateAs400?: Maybe<TaxRateAs400>;
  /** fetch data from the table: "claims.tax_rate_as400" */
  selectTaxRateAs400s: Array<TaxRateAs400>;
  /** fetch data from the table: "claims.tax_rate" */
  selectTaxRates: Array<TaxRate>;
  /** fetch data from the table: "system.technology_type" using primary key columns */
  selectTechnologyType?: Maybe<TechnologyType>;
  /** fetch aggregated fields from the table: "system.technology_type" */
  selectTechnologyTypeAggregate: TechnologyType_Aggregate;
  /** fetch data from the table in a streaming manner: "system.technology_type" */
  selectTechnologyTypeStream: Array<TechnologyType>;
  /** fetch data from the table: "system.technology_type" */
  selectTechnologyTypes: Array<TechnologyType>;
  /** fetch data from the table: "shared.type" using primary key columns */
  selectType?: Maybe<Type>;
  /** fetch aggregated fields from the table: "shared.type" */
  selectTypeAggregate: Type_Aggregate;
  /** fetch data from the table: "shared.type_group" using primary key columns */
  selectTypeGroup?: Maybe<TypeGroup>;
  /** fetch aggregated fields from the table: "shared.type_group" */
  selectTypeGroupAggregate: TypeGroup_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.type_group" */
  selectTypeGroupStream: Array<TypeGroup>;
  /** fetch data from the table: "shared.type_group" */
  selectTypeGroups: Array<TypeGroup>;
  /** fetch data from the table in a streaming manner: "shared.type" */
  selectTypeStream: Array<Type>;
  /** fetch data from the table: "shared.type" */
  selectTypes: Array<Type>;
  /** fetch data from the table: "auth.user" using primary key columns */
  selectUser?: Maybe<User>;
  /** fetch aggregated fields from the table: "auth.user" */
  selectUserAggregate: User_Aggregate;
  /** fetch data from the table: "auth.user_flow_item" using primary key columns */
  selectUserFlowItem?: Maybe<UserFlowItem>;
  /** fetch aggregated fields from the table: "auth.user_flow_item" */
  selectUserFlowItemAggregate: UserFlowItem_Aggregate;
  /** fetch data from the table: "auth.user_flow_item_mfa" using primary key columns */
  selectUserFlowItemMfa?: Maybe<UserFlowItemMfa>;
  /** fetch aggregated fields from the table: "auth.user_flow_item_mfa" */
  selectUserFlowItemMfaAggregate: UserFlowItemMfa_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_flow_item_mfa" */
  selectUserFlowItemMfaStream: Array<UserFlowItemMfa>;
  /** fetch data from the table: "auth.user_flow_item_mfa" */
  selectUserFlowItemMfas: Array<UserFlowItemMfa>;
  /** fetch data from the table in a streaming manner: "auth.user_flow_item" */
  selectUserFlowItemStream: Array<UserFlowItem>;
  /** fetch data from the table: "auth.user_flow_item" */
  selectUserFlowItems: Array<UserFlowItem>;
  /** fetch data from the table: "auth.user_group" using primary key columns */
  selectUserGroup?: Maybe<UserGroup>;
  /** fetch aggregated fields from the table: "auth.user_group" */
  selectUserGroupAggregate: UserGroup_Aggregate;
  /** fetch data from the table: "auth.user_group" */
  selectUserGroups: Array<UserGroup>;
  /** fetch data from the table: "user_pin" using primary key columns */
  selectUserPin?: Maybe<UserPin>;
  /** fetch data from the table: "user_pin" */
  selectUserPins: Array<UserPin>;
  /** fetch aggregated fields from the table: "user_pin" */
  selectUserPinsAggregate: UserPin_Aggregate;
  /** fetch data from the table: "auth.user_profile" using primary key columns */
  selectUserProfile?: Maybe<UserProfile>;
  /** fetch aggregated fields from the table: "auth.user_profile" */
  selectUserProfileAggregate: UserProfile_Aggregate;
  /** fetch data from the table: "auth.user_profile" */
  selectUserProfiles: Array<UserProfile>;
  /** fetch data from the table: "auth.user_session" using primary key columns */
  selectUserSession?: Maybe<UserSession>;
  /** fetch aggregated fields from the table: "auth.user_session" */
  selectUserSessionAggregate: UserSession_Aggregate;
  /** fetch data from the table: "auth.user_session" */
  selectUserSessions: Array<UserSession>;
  /** fetch data from the table in a streaming manner: "auth.user" */
  selectUserStream: Array<User>;
  /** fetch data from the table: "auth.user" */
  selectUsers: Array<User>;
  /** fetch data from the table: "shared.validation" using primary key columns */
  selectValidation?: Maybe<Validation>;
  /** fetch aggregated fields from the table: "shared.validation" */
  selectValidationAggregate: Validation_Aggregate;
  /** fetch data from the table: "shared.validation_lifecycle_hook" using primary key columns */
  selectValidationLifecycleHook?: Maybe<ValidationLifecycleHook>;
  /** fetch aggregated fields from the table: "shared.validation_lifecycle_hook" */
  selectValidationLifecycleHookAggregate: ValidationLifecycleHook_Aggregate;
  /** fetch data from the table: "shared.validation_lifecycle_hook" */
  selectValidationLifecycleHooks: Array<ValidationLifecycleHook>;
  /** fetch data from the table: "shared.validation_override" using primary key columns */
  selectValidationOverride?: Maybe<ValidationOverride>;
  /** fetch aggregated fields from the table: "shared.validation_override" */
  selectValidationOverrideAggregate: ValidationOverride_Aggregate;
  /** fetch data from the table: "shared.validation_override" */
  selectValidationOverrides: Array<ValidationOverride>;
  /** fetch data from the table: "shared.validation_rule_for" using primary key columns */
  selectValidationRuleFor?: Maybe<ValidationRuleFor>;
  /** fetch aggregated fields from the table: "shared.validation_rule_for" */
  selectValidationRuleForAggregate: ValidationRuleFor_Aggregate;
  /** fetch data from the table: "shared.validation_rule_for" */
  selectValidationRuleFors: Array<ValidationRuleFor>;
  /** fetch data from the table: "shared.validation_type_operation" using primary key columns */
  selectValidationTypeOperation?: Maybe<ValidationTypeOperation>;
  /** fetch aggregated fields from the table: "shared.validation_type_operation" */
  selectValidationTypeOperationAggregate: ValidationTypeOperation_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.validation_type_operation" */
  selectValidationTypeOperationStream: Array<ValidationTypeOperation>;
  /** fetch data from the table: "shared.validation_type_operation" */
  selectValidationTypeOperations: Array<ValidationTypeOperation>;
  /** fetch data from the table: "shared.validation_when" using primary key columns */
  selectValidationWhen?: Maybe<ValidationWhen>;
  /** fetch aggregated fields from the table: "shared.validation_when" */
  selectValidationWhenAggregate: ValidationWhen_Aggregate;
  /** fetch data from the table: "shared.validation_when" */
  selectValidationWhens: Array<ValidationWhen>;
  /** fetch data from the table: "shared.validation" */
  selectValidations: Array<Validation>;
  /** fetch data from the table: "vehicle" using primary key columns */
  selectVehicle?: Maybe<Vehicle>;
  /** fetch aggregated fields from the table: "vehicle" */
  selectVehicleAggregate: Vehicle_Aggregate;
  /** fetch data from the table: "vehicle.vehicle_attributes_defined_view" */
  selectVehicleAttributesDefinedView: Array<VehicleAttributesDefinedView>;
  /** fetch aggregated fields from the table: "vehicle.vehicle_attributes_defined_view" */
  selectVehicleAttributesDefinedViewAggregate: VehicleAttributesDefinedView_Aggregate;
  /** fetch aggregated fields from the table: "vwVehicleClassingBodyStyle" */
  selectVehicleClassingBodyStyleAggregate: VehicleClassingBodyStyle_Aggregate;
  /** fetch data from the table: "vwVehicleClassingBodyStyle" */
  selectVehicleClassingBodyStyles: Array<VehicleClassingBodyStyle>;
  /** fetch aggregated fields from the table: "vwVehicleClassingFuelType" */
  selectVehicleClassingFuelTypeAggregate: VehicleClassingFuelType_Aggregate;
  /** fetch data from the table: "vwVehicleClassingFuelType" */
  selectVehicleClassingFuelTypes: Array<VehicleClassingFuelType>;
  /** fetch aggregated fields from the table: "vwVehicleClassingVehicleMake" */
  selectVehicleClassingVehicleMakeAggregate: VehicleClassingVehicleMake_Aggregate;
  /** fetch data from the table: "vwVehicleClassingVehicleMake" */
  selectVehicleClassingVehicleMakes: Array<VehicleClassingVehicleMake>;
  /** fetch aggregated fields from the table: "vwVehicleClassingVehicleType" */
  selectVehicleClassingVehicleTypeAggregate: VehicleClassingVehicleType_Aggregate;
  /** fetch data from the table: "vwVehicleClassingVehicleType" */
  selectVehicleClassingVehicleTypes: Array<VehicleClassingVehicleType>;
  /** fetch data from the table: "vehicle.vehicle_status_type" using primary key columns */
  selectVehicleStatusType?: Maybe<VehicleStatusType>;
  /** fetch aggregated fields from the table: "vehicle.vehicle_status_type" */
  selectVehicleStatusTypeAggregate: VehicleStatusType_Aggregate;
  /** fetch data from the table in a streaming manner: "vehicle.vehicle_status_type" */
  selectVehicleStatusTypeStream: Array<VehicleStatusType>;
  /** fetch data from the table: "vehicle.vehicle_status_type" */
  selectVehicleStatusTypes: Array<VehicleStatusType>;
  /** fetch data from the table: "vehicle" */
  selectVehicles: Array<Vehicle>;
  /** fetch data from the table: "vehicle.vpic_decode_alternative" using primary key columns */
  selectVpicDecodeAlternative?: Maybe<VpicDecodeAlternative>;
  /** fetch aggregated fields from the table: "vehicle.vpic_decode_alternative" */
  selectVpicDecodeAlternativeAggregate: VpicDecodeAlternative_Aggregate;
  /** fetch data from the table in a streaming manner: "vehicle.vpic_decode_alternative" */
  selectVpicDecodeAlternativeStream: Array<VpicDecodeAlternative>;
  /** fetch data from the table: "vehicle.vpic_decode_alternative" */
  selectVpicDecodeAlternatives: Array<VpicDecodeAlternative>;
  /** fetch data from the table: "work_status_type" using primary key columns */
  selectWorkStatusType?: Maybe<WorkStatusType>;
  /** fetch aggregated fields from the table: "work_status_type" */
  selectWorkStatusTypeAggregate: WorkStatusType_Aggregate;
  /** fetch data from the table: "work_status_type" */
  selectWorkStatusTypes: Array<WorkStatusType>;
  /** fetch data from the table: "claims.workflow_state_type" using primary key columns */
  selectWorkflowStateType?: Maybe<WorkflowStateType>;
  /** fetch aggregated fields from the table: "claims.workflow_state_type" */
  selectWorkflowStateTypeAggregate: WorkflowStateType_Aggregate;
  /** fetch data from the table: "claims.workflow_state_type" */
  selectWorkflowStateTypes: Array<WorkflowStateType>;
  /** fetch aggregated fields from the table: "compliance.filing_lender" */
  selectselectFilingLenderAggregate: FilingLender_Aggregate;
  /** fetch data from the table in a streaming manner: "claims.service_center" */
  serviceCenter_stream: Array<ServiceCenter>;
  /** fetch data from the table in a streaming manner: "shared.dealer_alert_list_view" */
  shared_dealer_alert_list_view_stream: Array<Shared_Dealer_Alert_List_View>;
  /** fetch data from the table: "shared.search_result" */
  shared_search_result: Array<Shared_Search_Result>;
  /** fetch aggregated fields from the table: "shared.search_result" */
  shared_search_result_aggregate: Shared_Search_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "shared.search_result" */
  shared_search_result_stream: Array<Shared_Search_Result>;
  /** fetch data from the table in a streaming manner: "state" */
  state_stream: Array<State>;
  /** fetch data from the table in a streaming manner: "surcharge_type" */
  surchargeType_stream: Array<SurchargeType>;
  /** fetch data from the table in a streaming manner: "shared.tag" */
  tag_stream: Array<Tag>;
  /** fetch data from the table in a streaming manner: "task" */
  task_stream: Array<Task>;
  /** fetch data from the table in a streaming manner: "auth.user_group" */
  userGroup_stream: Array<UserGroup>;
  /** fetch data from the table in a streaming manner: "user_pin" */
  userPin_stream: Array<UserPin>;
  /** fetch data from the table in a streaming manner: "auth.user_profile" */
  userProfile_stream: Array<UserProfile>;
  /** fetch data from the table in a streaming manner: "auth.user_session" */
  userSession_stream: Array<UserSession>;
  /** fetch data from the table: "vpic.vncsabodytype" */
  vNCSABodyType: Array<VNcsaBodyType_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vncsabodytype" */
  vNCSABodyType_aggregate: VNcsaBodyType_Aggregate_Vpic;
  /** fetch data from the table in a streaming manner: "vpic.vncsabodytype" */
  vNCSABodyType_stream: Array<VNcsaBodyType_Vpic>;
  /** fetch data from the table: "vpic.vncsamake" */
  vNCSAMake: Array<VNcsaMake_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vncsamake" */
  vNCSAMake_aggregate: VNcsaMake_Aggregate_Vpic;
  /** fetch data from the table in a streaming manner: "vpic.vncsamake" */
  vNCSAMake_stream: Array<VNcsaMake_Vpic>;
  /** fetch data from the table: "vpic.vncsamodel" */
  vNCSAModel: Array<VNcsaModel_Vpic>;
  /** fetch aggregated fields from the table: "vpic.vncsamodel" */
  vNCSAModel_aggregate: VNcsaModel_Aggregate_Vpic;
  /** fetch data from the table in a streaming manner: "vpic.vncsamodel" */
  vNCSAModel_stream: Array<VNcsaModel_Vpic>;
  /** fetch data from the table in a streaming manner: "shared.validation_lifecycle_hook" */
  validationLifecycleHook_stream: Array<ValidationLifecycleHook>;
  /** fetch data from the table in a streaming manner: "shared.validation_override" */
  validationOverride_stream: Array<ValidationOverride>;
  /** fetch data from the table in a streaming manner: "shared.validation_rule_for" */
  validationRuleFor_stream: Array<ValidationRuleFor>;
  /** fetch data from the table in a streaming manner: "shared.validation_when" */
  validationWhen_stream: Array<ValidationWhen>;
  /** fetch data from the table in a streaming manner: "shared.validation" */
  validation_stream: Array<Validation>;
  /** fetch data from the table in a streaming manner: "vehicle.vehicle_attributes_defined_view" */
  vehicleAttributesDefinedView_stream: Array<VehicleAttributesDefinedView>;
  /** fetch data from the table in a streaming manner: "vehicle" */
  vehicle_stream: Array<Vehicle>;
  /** execute function "users.shortcut_bindings_for_viewer" which returns "users.shortcut_binding" */
  viewerShortcutBindings: Array<ShortcutBinding>;
  /** execute function "users.shortcut_bindings_for_viewer" and query aggregates on result of table type "users.shortcut_binding" */
  viewerShortcutBindings_aggregate: ShortcutBinding_Aggregate;
  /** fetch data from the table: "vwVehicleCylindersDistinct" */
  vwVehicleCylindersDistinct: Array<VwVehicleCylindersDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleCylindersDistinct" */
  vwVehicleCylindersDistinct_aggregate: VwVehicleCylindersDistinct_Aggregate;
  /** fetch data from the table: "vwVehicleDrivingWheelsDistinct" */
  vwVehicleDrivingWheelsDistinct: Array<VwVehicleDrivingWheelsDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleDrivingWheelsDistinct" */
  vwVehicleDrivingWheelsDistinct_aggregate: VwVehicleDrivingWheelsDistinct_Aggregate;
  /** fetch data from the table: "vwVehicleFuelTypesDistinct" */
  vwVehicleFuelTypesDistinct: Array<VwVehicleFuelTypesDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleFuelTypesDistinct" */
  vwVehicleFuelTypesDistinct_aggregate: VwVehicleFuelTypesDistinct_Aggregate;
  /** fetch data from the table: "vwVehicleMakesDistinct" */
  vwVehicleMakesDistinct: Array<VwVehicleMakesDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleMakesDistinct" */
  vwVehicleMakesDistinct_aggregate: VwVehicleMakesDistinct_Aggregate;
  /** fetch data from the table: "vwVehicleModelsDistinct" */
  vwVehicleModelsDistinct: Array<VwVehicleModelsDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleModelsDistinct" */
  vwVehicleModelsDistinct_aggregate: VwVehicleModelsDistinct_Aggregate;
  /** fetch data from the table: "vwVehicleYearsDistinct" */
  vwVehicleYearsDistinct: Array<VwVehicleYearsDistinct>;
  /** fetch aggregated fields from the table: "vwVehicleYearsDistinct" */
  vwVehicleYearsDistinct_aggregate: VwVehicleYearsDistinct_Aggregate;
  /** fetch data from the table in a streaming manner: "work_status_type" */
  workStatusType_stream: Array<WorkStatusType>;
  /** fetch data from the table in a streaming manner: "claims.workflow_state_type" */
  workflowStateType_stream: Array<WorkflowStateType>;
};


export type Subscription_RootAbsArgs = {
  distinct_on?: InputMaybe<Array<Abs_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Abs_Order_By_Vpic>>;
  where?: InputMaybe<Abs_Bool_Exp_Vpic>;
};


export type Subscription_RootAbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Abs_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Abs_Order_By_Vpic>>;
  where?: InputMaybe<Abs_Bool_Exp_Vpic>;
};


export type Subscription_RootAbs_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootAbs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Abs_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Abs_Bool_Exp_Vpic>;
};


export type Subscription_RootAdaptiveCruiseControlArgs = {
  distinct_on?: InputMaybe<Array<AdaptiveCruiseControl_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdaptiveCruiseControl_Order_By_Vpic>>;
  where?: InputMaybe<AdaptiveCruiseControl_Bool_Exp_Vpic>;
};


export type Subscription_RootAdaptiveCruiseControl_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AdaptiveCruiseControl_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdaptiveCruiseControl_Order_By_Vpic>>;
  where?: InputMaybe<AdaptiveCruiseControl_Bool_Exp_Vpic>;
};


export type Subscription_RootAdaptiveCruiseControl_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootAdaptiveCruiseControl_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdaptiveCruiseControl_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<AdaptiveCruiseControl_Bool_Exp_Vpic>;
};


export type Subscription_RootAdaptiveDrivingBeamArgs = {
  distinct_on?: InputMaybe<Array<AdaptiveDrivingBeam_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdaptiveDrivingBeam_Order_By_Vpic>>;
  where?: InputMaybe<AdaptiveDrivingBeam_Bool_Exp_Vpic>;
};


export type Subscription_RootAdaptiveDrivingBeam_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AdaptiveDrivingBeam_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdaptiveDrivingBeam_Order_By_Vpic>>;
  where?: InputMaybe<AdaptiveDrivingBeam_Bool_Exp_Vpic>;
};


export type Subscription_RootAdaptiveDrivingBeam_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootAdaptiveDrivingBeam_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdaptiveDrivingBeam_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<AdaptiveDrivingBeam_Bool_Exp_Vpic>;
};


export type Subscription_RootAirBagLocFrontArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocFront_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocFront_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocFront_Bool_Exp_Vpic>;
};


export type Subscription_RootAirBagLocFront_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocFront_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocFront_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocFront_Bool_Exp_Vpic>;
};


export type Subscription_RootAirBagLocFront_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootAirBagLocFront_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AirBagLocFront_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<AirBagLocFront_Bool_Exp_Vpic>;
};


export type Subscription_RootAirBagLocKneeArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocKnee_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocKnee_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocKnee_Bool_Exp_Vpic>;
};


export type Subscription_RootAirBagLocKnee_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocKnee_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocKnee_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocKnee_Bool_Exp_Vpic>;
};


export type Subscription_RootAirBagLocKnee_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootAirBagLocKnee_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AirBagLocKnee_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<AirBagLocKnee_Bool_Exp_Vpic>;
};


export type Subscription_RootAirBagLocationsArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocations_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocations_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocations_Bool_Exp_Vpic>;
};


export type Subscription_RootAirBagLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AirBagLocations_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirBagLocations_Order_By_Vpic>>;
  where?: InputMaybe<AirBagLocations_Bool_Exp_Vpic>;
};


export type Subscription_RootAirBagLocations_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootAirBagLocations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AirBagLocations_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<AirBagLocations_Bool_Exp_Vpic>;
};


export type Subscription_RootAutoBrakeArgs = {
  distinct_on?: InputMaybe<Array<AutoBrake_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoBrake_Order_By_Vpic>>;
  where?: InputMaybe<AutoBrake_Bool_Exp_Vpic>;
};


export type Subscription_RootAutoBrake_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AutoBrake_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoBrake_Order_By_Vpic>>;
  where?: InputMaybe<AutoBrake_Bool_Exp_Vpic>;
};


export type Subscription_RootAutoBrake_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootAutoBrake_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AutoBrake_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<AutoBrake_Bool_Exp_Vpic>;
};


export type Subscription_RootAutoReverseSystemArgs = {
  distinct_on?: InputMaybe<Array<AutoReverseSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoReverseSystem_Order_By_Vpic>>;
  where?: InputMaybe<AutoReverseSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootAutoReverseSystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AutoReverseSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoReverseSystem_Order_By_Vpic>>;
  where?: InputMaybe<AutoReverseSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootAutoReverseSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootAutoReverseSystem_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AutoReverseSystem_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<AutoReverseSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootAutomaticPedestrainAlertingSoundArgs = {
  distinct_on?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Order_By_Vpic>>;
  where?: InputMaybe<AutomaticPedestrainAlertingSound_Bool_Exp_Vpic>;
};


export type Subscription_RootAutomaticPedestrainAlertingSound_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomaticPedestrainAlertingSound_Order_By_Vpic>>;
  where?: InputMaybe<AutomaticPedestrainAlertingSound_Bool_Exp_Vpic>;
};


export type Subscription_RootAutomaticPedestrainAlertingSound_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootAutomaticPedestrainAlertingSound_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AutomaticPedestrainAlertingSound_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<AutomaticPedestrainAlertingSound_Bool_Exp_Vpic>;
};


export type Subscription_RootAxleConfigurationArgs = {
  distinct_on?: InputMaybe<Array<AxleConfiguration_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AxleConfiguration_Order_By_Vpic>>;
  where?: InputMaybe<AxleConfiguration_Bool_Exp_Vpic>;
};


export type Subscription_RootAxleConfiguration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AxleConfiguration_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AxleConfiguration_Order_By_Vpic>>;
  where?: InputMaybe<AxleConfiguration_Bool_Exp_Vpic>;
};


export type Subscription_RootAxleConfiguration_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootAxleConfiguration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AxleConfiguration_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<AxleConfiguration_Bool_Exp_Vpic>;
};


export type Subscription_RootBatteryTypeArgs = {
  distinct_on?: InputMaybe<Array<BatteryType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BatteryType_Order_By_Vpic>>;
  where?: InputMaybe<BatteryType_Bool_Exp_Vpic>;
};


export type Subscription_RootBatteryType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BatteryType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BatteryType_Order_By_Vpic>>;
  where?: InputMaybe<BatteryType_Bool_Exp_Vpic>;
};


export type Subscription_RootBatteryType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootBatteryType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BatteryType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<BatteryType_Bool_Exp_Vpic>;
};


export type Subscription_RootBedTypeArgs = {
  distinct_on?: InputMaybe<Array<BedType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BedType_Order_By_Vpic>>;
  where?: InputMaybe<BedType_Bool_Exp_Vpic>;
};


export type Subscription_RootBedType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BedType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BedType_Order_By_Vpic>>;
  where?: InputMaybe<BedType_Bool_Exp_Vpic>;
};


export type Subscription_RootBedType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootBedType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BedType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<BedType_Bool_Exp_Vpic>;
};


export type Subscription_RootBlindSpotInterventionArgs = {
  distinct_on?: InputMaybe<Array<BlindSpotIntervention_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlindSpotIntervention_Order_By_Vpic>>;
  where?: InputMaybe<BlindSpotIntervention_Bool_Exp_Vpic>;
};


export type Subscription_RootBlindSpotIntervention_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BlindSpotIntervention_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlindSpotIntervention_Order_By_Vpic>>;
  where?: InputMaybe<BlindSpotIntervention_Bool_Exp_Vpic>;
};


export type Subscription_RootBlindSpotIntervention_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootBlindSpotIntervention_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BlindSpotIntervention_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<BlindSpotIntervention_Bool_Exp_Vpic>;
};


export type Subscription_RootBlindSpotMonitoringArgs = {
  distinct_on?: InputMaybe<Array<BlindSpotMonitoring_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlindSpotMonitoring_Order_By_Vpic>>;
  where?: InputMaybe<BlindSpotMonitoring_Bool_Exp_Vpic>;
};


export type Subscription_RootBlindSpotMonitoring_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BlindSpotMonitoring_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BlindSpotMonitoring_Order_By_Vpic>>;
  where?: InputMaybe<BlindSpotMonitoring_Bool_Exp_Vpic>;
};


export type Subscription_RootBlindSpotMonitoring_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootBlindSpotMonitoring_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BlindSpotMonitoring_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<BlindSpotMonitoring_Bool_Exp_Vpic>;
};


export type Subscription_RootBodyCabArgs = {
  distinct_on?: InputMaybe<Array<BodyCab_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BodyCab_Order_By_Vpic>>;
  where?: InputMaybe<BodyCab_Bool_Exp_Vpic>;
};


export type Subscription_RootBodyCab_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BodyCab_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BodyCab_Order_By_Vpic>>;
  where?: InputMaybe<BodyCab_Bool_Exp_Vpic>;
};


export type Subscription_RootBodyCab_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootBodyCab_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BodyCab_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<BodyCab_Bool_Exp_Vpic>;
};


export type Subscription_RootBodyStyleArgs = {
  distinct_on?: InputMaybe<Array<BodyStyle_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BodyStyle_Order_By_Vpic>>;
  where?: InputMaybe<BodyStyle_Bool_Exp_Vpic>;
};


export type Subscription_RootBodyStyle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BodyStyle_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BodyStyle_Order_By_Vpic>>;
  where?: InputMaybe<BodyStyle_Bool_Exp_Vpic>;
};


export type Subscription_RootBodyStyle_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootBodyStyle_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BodyStyle_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<BodyStyle_Bool_Exp_Vpic>;
};


export type Subscription_RootBrakeSystemArgs = {
  distinct_on?: InputMaybe<Array<BrakeSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrakeSystem_Order_By_Vpic>>;
  where?: InputMaybe<BrakeSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootBrakeSystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BrakeSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrakeSystem_Order_By_Vpic>>;
  where?: InputMaybe<BrakeSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootBrakeSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootBrakeSystem_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BrakeSystem_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<BrakeSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootBusFloorConfigTypeArgs = {
  distinct_on?: InputMaybe<Array<BusFloorConfigType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BusFloorConfigType_Order_By_Vpic>>;
  where?: InputMaybe<BusFloorConfigType_Bool_Exp_Vpic>;
};


export type Subscription_RootBusFloorConfigType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BusFloorConfigType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BusFloorConfigType_Order_By_Vpic>>;
  where?: InputMaybe<BusFloorConfigType_Bool_Exp_Vpic>;
};


export type Subscription_RootBusFloorConfigType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootBusFloorConfigType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BusFloorConfigType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<BusFloorConfigType_Bool_Exp_Vpic>;
};


export type Subscription_RootBusTypeArgs = {
  distinct_on?: InputMaybe<Array<BusType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BusType_Order_By_Vpic>>;
  where?: InputMaybe<BusType_Bool_Exp_Vpic>;
};


export type Subscription_RootBusType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BusType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BusType_Order_By_Vpic>>;
  where?: InputMaybe<BusType_Bool_Exp_Vpic>;
};


export type Subscription_RootBusType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootBusType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BusType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<BusType_Bool_Exp_Vpic>;
};


export type Subscription_RootCan_AacnArgs = {
  distinct_on?: InputMaybe<Array<Can_Aacn_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Can_Aacn_Order_By_Vpic>>;
  where?: InputMaybe<Can_Aacn_Bool_Exp_Vpic>;
};


export type Subscription_RootCan_Aacn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Can_Aacn_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Can_Aacn_Order_By_Vpic>>;
  where?: InputMaybe<Can_Aacn_Bool_Exp_Vpic>;
};


export type Subscription_RootCan_Aacn_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootCan_Aacn_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Can_Aacn_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Can_Aacn_Bool_Exp_Vpic>;
};


export type Subscription_RootChargerLevelArgs = {
  distinct_on?: InputMaybe<Array<ChargerLevel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChargerLevel_Order_By_Vpic>>;
  where?: InputMaybe<ChargerLevel_Bool_Exp_Vpic>;
};


export type Subscription_RootChargerLevel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ChargerLevel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChargerLevel_Order_By_Vpic>>;
  where?: InputMaybe<ChargerLevel_Bool_Exp_Vpic>;
};


export type Subscription_RootChargerLevel_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootChargerLevel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ChargerLevel_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<ChargerLevel_Bool_Exp_Vpic>;
};


export type Subscription_RootCombinedBrakingSystemArgs = {
  distinct_on?: InputMaybe<Array<CombinedBrakingSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CombinedBrakingSystem_Order_By_Vpic>>;
  where?: InputMaybe<CombinedBrakingSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootCombinedBrakingSystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CombinedBrakingSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CombinedBrakingSystem_Order_By_Vpic>>;
  where?: InputMaybe<CombinedBrakingSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootCombinedBrakingSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootCombinedBrakingSystem_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CombinedBrakingSystem_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<CombinedBrakingSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootContractMasterSurchargeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterSurcharge_Order_By>>;
  where?: InputMaybe<ContractMasterSurcharge_Bool_Exp>;
};


export type Subscription_RootContractMasterSurcharge_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterSurcharge_Order_By>>;
  where?: InputMaybe<ContractMasterSurcharge_Bool_Exp>;
};


export type Subscription_RootConversionArgs = {
  distinct_on?: InputMaybe<Array<Conversion_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Conversion_Order_By_Vpic>>;
  where?: InputMaybe<Conversion_Bool_Exp_Vpic>;
};


export type Subscription_RootConversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Conversion_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Conversion_Order_By_Vpic>>;
  where?: InputMaybe<Conversion_Bool_Exp_Vpic>;
};


export type Subscription_RootConversion_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootConversion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Conversion_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Conversion_Bool_Exp_Vpic>;
};


export type Subscription_RootCoolingTypeArgs = {
  distinct_on?: InputMaybe<Array<CoolingType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CoolingType_Order_By_Vpic>>;
  where?: InputMaybe<CoolingType_Bool_Exp_Vpic>;
};


export type Subscription_RootCoolingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CoolingType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CoolingType_Order_By_Vpic>>;
  where?: InputMaybe<CoolingType_Bool_Exp_Vpic>;
};


export type Subscription_RootCoolingType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootCoolingType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CoolingType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<CoolingType_Bool_Exp_Vpic>;
};


export type Subscription_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Order_By_Vpic>>;
  where?: InputMaybe<Country_Bool_Exp_Vpic>;
};


export type Subscription_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Order_By_Vpic>>;
  where?: InputMaybe<Country_Bool_Exp_Vpic>;
};


export type Subscription_RootCountry_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootCountry_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Country_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Country_Bool_Exp_Vpic>;
};


export type Subscription_RootCustomMotorcycleTypeArgs = {
  distinct_on?: InputMaybe<Array<CustomMotorcycleType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomMotorcycleType_Order_By_Vpic>>;
  where?: InputMaybe<CustomMotorcycleType_Bool_Exp_Vpic>;
};


export type Subscription_RootCustomMotorcycleType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomMotorcycleType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomMotorcycleType_Order_By_Vpic>>;
  where?: InputMaybe<CustomMotorcycleType_Bool_Exp_Vpic>;
};


export type Subscription_RootCustomMotorcycleType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootCustomMotorcycleType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CustomMotorcycleType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<CustomMotorcycleType_Bool_Exp_Vpic>;
};


export type Subscription_RootDaytimeRunningLightArgs = {
  distinct_on?: InputMaybe<Array<DaytimeRunningLight_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DaytimeRunningLight_Order_By_Vpic>>;
  where?: InputMaybe<DaytimeRunningLight_Bool_Exp_Vpic>;
};


export type Subscription_RootDaytimeRunningLight_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DaytimeRunningLight_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DaytimeRunningLight_Order_By_Vpic>>;
  where?: InputMaybe<DaytimeRunningLight_Bool_Exp_Vpic>;
};


export type Subscription_RootDaytimeRunningLight_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootDaytimeRunningLight_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DaytimeRunningLight_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<DaytimeRunningLight_Bool_Exp_Vpic>;
};


export type Subscription_RootDefaultValueArgs = {
  distinct_on?: InputMaybe<Array<DefaultValue_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DefaultValue_Order_By_Vpic>>;
  where?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
};


export type Subscription_RootDefaultValue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DefaultValue_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DefaultValue_Order_By_Vpic>>;
  where?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
};


export type Subscription_RootDefaultValue_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootDefaultValue_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DefaultValue_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<DefaultValue_Bool_Exp_Vpic>;
};


export type Subscription_RootDestinationMarketArgs = {
  distinct_on?: InputMaybe<Array<DestinationMarket_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationMarket_Order_By_Vpic>>;
  where?: InputMaybe<DestinationMarket_Bool_Exp_Vpic>;
};


export type Subscription_RootDestinationMarket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationMarket_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationMarket_Order_By_Vpic>>;
  where?: InputMaybe<DestinationMarket_Bool_Exp_Vpic>;
};


export type Subscription_RootDestinationMarket_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootDestinationMarket_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DestinationMarket_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<DestinationMarket_Bool_Exp_Vpic>;
};


export type Subscription_RootDriveTypeArgs = {
  distinct_on?: InputMaybe<Array<DriveType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DriveType_Order_By_Vpic>>;
  where?: InputMaybe<DriveType_Bool_Exp_Vpic>;
};


export type Subscription_RootDriveType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DriveType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DriveType_Order_By_Vpic>>;
  where?: InputMaybe<DriveType_Bool_Exp_Vpic>;
};


export type Subscription_RootDriveType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootDriveType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DriveType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<DriveType_Bool_Exp_Vpic>;
};


export type Subscription_RootDynamicBrakeSupportArgs = {
  distinct_on?: InputMaybe<Array<DynamicBrakeSupport_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DynamicBrakeSupport_Order_By_Vpic>>;
  where?: InputMaybe<DynamicBrakeSupport_Bool_Exp_Vpic>;
};


export type Subscription_RootDynamicBrakeSupport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DynamicBrakeSupport_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DynamicBrakeSupport_Order_By_Vpic>>;
  where?: InputMaybe<DynamicBrakeSupport_Bool_Exp_Vpic>;
};


export type Subscription_RootDynamicBrakeSupport_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootDynamicBrakeSupport_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DynamicBrakeSupport_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<DynamicBrakeSupport_Bool_Exp_Vpic>;
};


export type Subscription_RootEcsArgs = {
  distinct_on?: InputMaybe<Array<Ecs_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecs_Order_By_Vpic>>;
  where?: InputMaybe<Ecs_Bool_Exp_Vpic>;
};


export type Subscription_RootEcs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ecs_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecs_Order_By_Vpic>>;
  where?: InputMaybe<Ecs_Bool_Exp_Vpic>;
};


export type Subscription_RootEcs_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootEcs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ecs_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Ecs_Bool_Exp_Vpic>;
};


export type Subscription_RootEdrArgs = {
  distinct_on?: InputMaybe<Array<Edr_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edr_Order_By_Vpic>>;
  where?: InputMaybe<Edr_Bool_Exp_Vpic>;
};


export type Subscription_RootEdr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Edr_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edr_Order_By_Vpic>>;
  where?: InputMaybe<Edr_Bool_Exp_Vpic>;
};


export type Subscription_RootEdr_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootEdr_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edr_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Edr_Bool_Exp_Vpic>;
};


export type Subscription_RootEvDriveUnitArgs = {
  distinct_on?: InputMaybe<Array<EvDriveUnit_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EvDriveUnit_Order_By_Vpic>>;
  where?: InputMaybe<EvDriveUnit_Bool_Exp_Vpic>;
};


export type Subscription_RootEvDriveUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EvDriveUnit_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EvDriveUnit_Order_By_Vpic>>;
  where?: InputMaybe<EvDriveUnit_Bool_Exp_Vpic>;
};


export type Subscription_RootEvDriveUnit_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootEvDriveUnit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EvDriveUnit_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<EvDriveUnit_Bool_Exp_Vpic>;
};


export type Subscription_RootElectrificationLevelArgs = {
  distinct_on?: InputMaybe<Array<ElectrificationLevel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ElectrificationLevel_Order_By_Vpic>>;
  where?: InputMaybe<ElectrificationLevel_Bool_Exp_Vpic>;
};


export type Subscription_RootElectrificationLevel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ElectrificationLevel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ElectrificationLevel_Order_By_Vpic>>;
  where?: InputMaybe<ElectrificationLevel_Bool_Exp_Vpic>;
};


export type Subscription_RootElectrificationLevel_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootElectrificationLevel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ElectrificationLevel_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<ElectrificationLevel_Bool_Exp_Vpic>;
};


export type Subscription_RootElementArgs = {
  distinct_on?: InputMaybe<Array<Element_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Element_Order_By_Vpic>>;
  where?: InputMaybe<Element_Bool_Exp_Vpic>;
};


export type Subscription_RootElement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Element_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Element_Order_By_Vpic>>;
  where?: InputMaybe<Element_Bool_Exp_Vpic>;
};


export type Subscription_RootElement_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootElement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Element_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Element_Bool_Exp_Vpic>;
};


export type Subscription_RootEngineConfigurationArgs = {
  distinct_on?: InputMaybe<Array<EngineConfiguration_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineConfiguration_Order_By_Vpic>>;
  where?: InputMaybe<EngineConfiguration_Bool_Exp_Vpic>;
};


export type Subscription_RootEngineConfiguration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EngineConfiguration_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineConfiguration_Order_By_Vpic>>;
  where?: InputMaybe<EngineConfiguration_Bool_Exp_Vpic>;
};


export type Subscription_RootEngineConfiguration_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootEngineConfiguration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EngineConfiguration_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<EngineConfiguration_Bool_Exp_Vpic>;
};


export type Subscription_RootEngineModelArgs = {
  distinct_on?: InputMaybe<Array<EngineModel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineModel_Order_By_Vpic>>;
  where?: InputMaybe<EngineModel_Bool_Exp_Vpic>;
};


export type Subscription_RootEngineModelPatternArgs = {
  distinct_on?: InputMaybe<Array<EngineModelPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineModelPattern_Order_By_Vpic>>;
  where?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
};


export type Subscription_RootEngineModelPattern_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EngineModelPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineModelPattern_Order_By_Vpic>>;
  where?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
};


export type Subscription_RootEngineModelPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootEngineModelPattern_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EngineModelPattern_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<EngineModelPattern_Bool_Exp_Vpic>;
};


export type Subscription_RootEngineModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EngineModel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EngineModel_Order_By_Vpic>>;
  where?: InputMaybe<EngineModel_Bool_Exp_Vpic>;
};


export type Subscription_RootEngineModel_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootEngineModel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EngineModel_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<EngineModel_Bool_Exp_Vpic>;
};


export type Subscription_RootEntertainmentSystemArgs = {
  distinct_on?: InputMaybe<Array<EntertainmentSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntertainmentSystem_Order_By_Vpic>>;
  where?: InputMaybe<EntertainmentSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootEntertainmentSystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntertainmentSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntertainmentSystem_Order_By_Vpic>>;
  where?: InputMaybe<EntertainmentSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootEntertainmentSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootEntertainmentSystem_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntertainmentSystem_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<EntertainmentSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootErrorCodeArgs = {
  distinct_on?: InputMaybe<Array<ErrorCode_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ErrorCode_Order_By_Vpic>>;
  where?: InputMaybe<ErrorCode_Bool_Exp_Vpic>;
};


export type Subscription_RootErrorCode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ErrorCode_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ErrorCode_Order_By_Vpic>>;
  where?: InputMaybe<ErrorCode_Bool_Exp_Vpic>;
};


export type Subscription_RootErrorCode_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootErrorCode_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ErrorCode_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<ErrorCode_Bool_Exp_Vpic>;
};


export type Subscription_RootForwardCollisionWarningArgs = {
  distinct_on?: InputMaybe<Array<ForwardCollisionWarning_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ForwardCollisionWarning_Order_By_Vpic>>;
  where?: InputMaybe<ForwardCollisionWarning_Bool_Exp_Vpic>;
};


export type Subscription_RootForwardCollisionWarning_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ForwardCollisionWarning_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ForwardCollisionWarning_Order_By_Vpic>>;
  where?: InputMaybe<ForwardCollisionWarning_Bool_Exp_Vpic>;
};


export type Subscription_RootForwardCollisionWarning_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootForwardCollisionWarning_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ForwardCollisionWarning_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<ForwardCollisionWarning_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelDeliveryTypeArgs = {
  distinct_on?: InputMaybe<Array<FuelDeliveryType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelDeliveryType_Order_By_Vpic>>;
  where?: InputMaybe<FuelDeliveryType_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelDeliveryType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FuelDeliveryType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelDeliveryType_Order_By_Vpic>>;
  where?: InputMaybe<FuelDeliveryType_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelDeliveryType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootFuelDeliveryType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FuelDeliveryType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<FuelDeliveryType_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelTankMaterialArgs = {
  distinct_on?: InputMaybe<Array<FuelTankMaterial_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelTankMaterial_Order_By_Vpic>>;
  where?: InputMaybe<FuelTankMaterial_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelTankMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FuelTankMaterial_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelTankMaterial_Order_By_Vpic>>;
  where?: InputMaybe<FuelTankMaterial_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelTankMaterial_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootFuelTankMaterial_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FuelTankMaterial_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<FuelTankMaterial_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelTankTypeArgs = {
  distinct_on?: InputMaybe<Array<FuelTankType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelTankType_Order_By_Vpic>>;
  where?: InputMaybe<FuelTankType_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelTankType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FuelTankType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelTankType_Order_By_Vpic>>;
  where?: InputMaybe<FuelTankType_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelTankType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootFuelTankType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FuelTankType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<FuelTankType_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelTypeArgs = {
  distinct_on?: InputMaybe<Array<FuelType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelType_Order_By_Vpic>>;
  where?: InputMaybe<FuelType_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FuelType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FuelType_Order_By_Vpic>>;
  where?: InputMaybe<FuelType_Bool_Exp_Vpic>;
};


export type Subscription_RootFuelType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootFuelType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FuelType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<FuelType_Bool_Exp_Vpic>;
};


export type Subscription_RootGrossVehicleWeightRatingArgs = {
  distinct_on?: InputMaybe<Array<GrossVehicleWeightRating_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GrossVehicleWeightRating_Order_By_Vpic>>;
  where?: InputMaybe<GrossVehicleWeightRating_Bool_Exp_Vpic>;
};


export type Subscription_RootGrossVehicleWeightRating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GrossVehicleWeightRating_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GrossVehicleWeightRating_Order_By_Vpic>>;
  where?: InputMaybe<GrossVehicleWeightRating_Bool_Exp_Vpic>;
};


export type Subscription_RootGrossVehicleWeightRating_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootGrossVehicleWeightRating_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GrossVehicleWeightRating_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<GrossVehicleWeightRating_Bool_Exp_Vpic>;
};


export type Subscription_RootKeylessIgnitionArgs = {
  distinct_on?: InputMaybe<Array<KeylessIgnition_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<KeylessIgnition_Order_By_Vpic>>;
  where?: InputMaybe<KeylessIgnition_Bool_Exp_Vpic>;
};


export type Subscription_RootKeylessIgnition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<KeylessIgnition_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<KeylessIgnition_Order_By_Vpic>>;
  where?: InputMaybe<KeylessIgnition_Bool_Exp_Vpic>;
};


export type Subscription_RootKeylessIgnition_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootKeylessIgnition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<KeylessIgnition_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<KeylessIgnition_Bool_Exp_Vpic>;
};


export type Subscription_RootLaneCenteringAssistanceArgs = {
  distinct_on?: InputMaybe<Array<LaneCenteringAssistance_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneCenteringAssistance_Order_By_Vpic>>;
  where?: InputMaybe<LaneCenteringAssistance_Bool_Exp_Vpic>;
};


export type Subscription_RootLaneCenteringAssistance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LaneCenteringAssistance_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneCenteringAssistance_Order_By_Vpic>>;
  where?: InputMaybe<LaneCenteringAssistance_Bool_Exp_Vpic>;
};


export type Subscription_RootLaneCenteringAssistance_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootLaneCenteringAssistance_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LaneCenteringAssistance_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<LaneCenteringAssistance_Bool_Exp_Vpic>;
};


export type Subscription_RootLaneDepartureWarningArgs = {
  distinct_on?: InputMaybe<Array<LaneDepartureWarning_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneDepartureWarning_Order_By_Vpic>>;
  where?: InputMaybe<LaneDepartureWarning_Bool_Exp_Vpic>;
};


export type Subscription_RootLaneDepartureWarning_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LaneDepartureWarning_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneDepartureWarning_Order_By_Vpic>>;
  where?: InputMaybe<LaneDepartureWarning_Bool_Exp_Vpic>;
};


export type Subscription_RootLaneDepartureWarning_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootLaneDepartureWarning_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LaneDepartureWarning_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<LaneDepartureWarning_Bool_Exp_Vpic>;
};


export type Subscription_RootLaneKeepSystemArgs = {
  distinct_on?: InputMaybe<Array<LaneKeepSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneKeepSystem_Order_By_Vpic>>;
  where?: InputMaybe<LaneKeepSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootLaneKeepSystem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LaneKeepSystem_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaneKeepSystem_Order_By_Vpic>>;
  where?: InputMaybe<LaneKeepSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootLaneKeepSystem_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootLaneKeepSystem_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LaneKeepSystem_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<LaneKeepSystem_Bool_Exp_Vpic>;
};


export type Subscription_RootLowerBeamHeadlampLightSourceArgs = {
  distinct_on?: InputMaybe<Array<LowerBeamHeadlampLightSource_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LowerBeamHeadlampLightSource_Order_By_Vpic>>;
  where?: InputMaybe<LowerBeamHeadlampLightSource_Bool_Exp_Vpic>;
};


export type Subscription_RootLowerBeamHeadlampLightSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LowerBeamHeadlampLightSource_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LowerBeamHeadlampLightSource_Order_By_Vpic>>;
  where?: InputMaybe<LowerBeamHeadlampLightSource_Bool_Exp_Vpic>;
};


export type Subscription_RootLowerBeamHeadlampLightSource_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootLowerBeamHeadlampLightSource_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LowerBeamHeadlampLightSource_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<LowerBeamHeadlampLightSource_Bool_Exp_Vpic>;
};


export type Subscription_RootMakeArgs = {
  distinct_on?: InputMaybe<Array<Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Order_By_Vpic>>;
  where?: InputMaybe<Make_Bool_Exp_Vpic>;
};


export type Subscription_RootMake_ModelArgs = {
  distinct_on?: InputMaybe<Array<Make_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Model_Order_By_Vpic>>;
  where?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
};


export type Subscription_RootMake_Model_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Make_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Model_Order_By_Vpic>>;
  where?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
};


export type Subscription_RootMake_Model_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootMake_Model_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Make_Model_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Make_Model_Bool_Exp_Vpic>;
};


export type Subscription_RootMake_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Make_Order_By_Vpic>>;
  where?: InputMaybe<Make_Bool_Exp_Vpic>;
};


export type Subscription_RootMake_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootMake_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Make_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Make_Bool_Exp_Vpic>;
};


export type Subscription_RootManufacturerArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By_Vpic>>;
  where?: InputMaybe<Manufacturer_Bool_Exp_Vpic>;
};


export type Subscription_RootManufacturer_MakeArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Make_Order_By_Vpic>>;
  where?: InputMaybe<Manufacturer_Make_Bool_Exp_Vpic>;
};


export type Subscription_RootManufacturer_Make_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Make_Order_By_Vpic>>;
  where?: InputMaybe<Manufacturer_Make_Bool_Exp_Vpic>;
};


export type Subscription_RootManufacturer_Make_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootManufacturer_Make_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Manufacturer_Make_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Manufacturer_Make_Bool_Exp_Vpic>;
};


export type Subscription_RootManufacturer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By_Vpic>>;
  where?: InputMaybe<Manufacturer_Bool_Exp_Vpic>;
};


export type Subscription_RootManufacturer_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootManufacturer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Manufacturer_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Manufacturer_Bool_Exp_Vpic>;
};


export type Subscription_RootModelArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Order_By_Vpic>>;
  where?: InputMaybe<Model_Bool_Exp_Vpic>;
};


export type Subscription_RootModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Order_By_Vpic>>;
  where?: InputMaybe<Model_Bool_Exp_Vpic>;
};


export type Subscription_RootModel_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootModel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Model_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Model_Bool_Exp_Vpic>;
};


export type Subscription_RootMotorcycleChassisTypeArgs = {
  distinct_on?: InputMaybe<Array<MotorcycleChassisType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MotorcycleChassisType_Order_By_Vpic>>;
  where?: InputMaybe<MotorcycleChassisType_Bool_Exp_Vpic>;
};


export type Subscription_RootMotorcycleChassisType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MotorcycleChassisType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MotorcycleChassisType_Order_By_Vpic>>;
  where?: InputMaybe<MotorcycleChassisType_Bool_Exp_Vpic>;
};


export type Subscription_RootMotorcycleChassisType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootMotorcycleChassisType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MotorcycleChassisType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<MotorcycleChassisType_Bool_Exp_Vpic>;
};


export type Subscription_RootMotorcycleSuspensionTypeArgs = {
  distinct_on?: InputMaybe<Array<MotorcycleSuspensionType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MotorcycleSuspensionType_Order_By_Vpic>>;
  where?: InputMaybe<MotorcycleSuspensionType_Bool_Exp_Vpic>;
};


export type Subscription_RootMotorcycleSuspensionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MotorcycleSuspensionType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MotorcycleSuspensionType_Order_By_Vpic>>;
  where?: InputMaybe<MotorcycleSuspensionType_Bool_Exp_Vpic>;
};


export type Subscription_RootMotorcycleSuspensionType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootMotorcycleSuspensionType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MotorcycleSuspensionType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<MotorcycleSuspensionType_Bool_Exp_Vpic>;
};


export type Subscription_RootNonLandUseArgs = {
  distinct_on?: InputMaybe<Array<NonLandUse_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NonLandUse_Order_By_Vpic>>;
  where?: InputMaybe<NonLandUse_Bool_Exp_Vpic>;
};


export type Subscription_RootNonLandUse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NonLandUse_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NonLandUse_Order_By_Vpic>>;
  where?: InputMaybe<NonLandUse_Bool_Exp_Vpic>;
};


export type Subscription_RootNonLandUse_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootNonLandUse_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NonLandUse_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<NonLandUse_Bool_Exp_Vpic>;
};


export type Subscription_RootParkAssistArgs = {
  distinct_on?: InputMaybe<Array<ParkAssist_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkAssist_Order_By_Vpic>>;
  where?: InputMaybe<ParkAssist_Bool_Exp_Vpic>;
};


export type Subscription_RootParkAssist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ParkAssist_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ParkAssist_Order_By_Vpic>>;
  where?: InputMaybe<ParkAssist_Bool_Exp_Vpic>;
};


export type Subscription_RootParkAssist_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootParkAssist_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ParkAssist_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<ParkAssist_Bool_Exp_Vpic>;
};


export type Subscription_RootPatternArgs = {
  distinct_on?: InputMaybe<Array<Pattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pattern_Order_By_Vpic>>;
  where?: InputMaybe<Pattern_Bool_Exp_Vpic>;
};


export type Subscription_RootPattern_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pattern_Order_By_Vpic>>;
  where?: InputMaybe<Pattern_Bool_Exp_Vpic>;
};


export type Subscription_RootPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootPattern_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pattern_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Pattern_Bool_Exp_Vpic>;
};


export type Subscription_RootPedestrianAutomaticEmergencyBrakingArgs = {
  distinct_on?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Order_By_Vpic>>;
  where?: InputMaybe<PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};


export type Subscription_RootPedestrianAutomaticEmergencyBraking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PedestrianAutomaticEmergencyBraking_Order_By_Vpic>>;
  where?: InputMaybe<PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};


export type Subscription_RootPedestrianAutomaticEmergencyBraking_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootPedestrianAutomaticEmergencyBraking_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PedestrianAutomaticEmergencyBraking_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<PedestrianAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};


export type Subscription_RootPretensionerArgs = {
  distinct_on?: InputMaybe<Array<Pretensioner_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pretensioner_Order_By_Vpic>>;
  where?: InputMaybe<Pretensioner_Bool_Exp_Vpic>;
};


export type Subscription_RootPretensioner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pretensioner_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pretensioner_Order_By_Vpic>>;
  where?: InputMaybe<Pretensioner_Bool_Exp_Vpic>;
};


export type Subscription_RootPretensioner_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootPretensioner_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pretensioner_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Pretensioner_Bool_Exp_Vpic>;
};


export type Subscription_RootRearAutomaticEmergencyBrakingArgs = {
  distinct_on?: InputMaybe<Array<RearAutomaticEmergencyBraking_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearAutomaticEmergencyBraking_Order_By_Vpic>>;
  where?: InputMaybe<RearAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};


export type Subscription_RootRearAutomaticEmergencyBraking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RearAutomaticEmergencyBraking_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearAutomaticEmergencyBraking_Order_By_Vpic>>;
  where?: InputMaybe<RearAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};


export type Subscription_RootRearAutomaticEmergencyBraking_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootRearAutomaticEmergencyBraking_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RearAutomaticEmergencyBraking_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<RearAutomaticEmergencyBraking_Bool_Exp_Vpic>;
};


export type Subscription_RootRearCrossTrafficAlertArgs = {
  distinct_on?: InputMaybe<Array<RearCrossTrafficAlert_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearCrossTrafficAlert_Order_By_Vpic>>;
  where?: InputMaybe<RearCrossTrafficAlert_Bool_Exp_Vpic>;
};


export type Subscription_RootRearCrossTrafficAlert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RearCrossTrafficAlert_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearCrossTrafficAlert_Order_By_Vpic>>;
  where?: InputMaybe<RearCrossTrafficAlert_Bool_Exp_Vpic>;
};


export type Subscription_RootRearCrossTrafficAlert_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootRearCrossTrafficAlert_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RearCrossTrafficAlert_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<RearCrossTrafficAlert_Bool_Exp_Vpic>;
};


export type Subscription_RootRearVisibilityCameraArgs = {
  distinct_on?: InputMaybe<Array<RearVisibilityCamera_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearVisibilityCamera_Order_By_Vpic>>;
  where?: InputMaybe<RearVisibilityCamera_Bool_Exp_Vpic>;
};


export type Subscription_RootRearVisibilityCamera_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RearVisibilityCamera_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RearVisibilityCamera_Order_By_Vpic>>;
  where?: InputMaybe<RearVisibilityCamera_Bool_Exp_Vpic>;
};


export type Subscription_RootRearVisibilityCamera_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootRearVisibilityCamera_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RearVisibilityCamera_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<RearVisibilityCamera_Bool_Exp_Vpic>;
};


export type Subscription_RootSeatBeltsAllArgs = {
  distinct_on?: InputMaybe<Array<SeatBeltsAll_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SeatBeltsAll_Order_By_Vpic>>;
  where?: InputMaybe<SeatBeltsAll_Bool_Exp_Vpic>;
};


export type Subscription_RootSeatBeltsAll_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SeatBeltsAll_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SeatBeltsAll_Order_By_Vpic>>;
  where?: InputMaybe<SeatBeltsAll_Bool_Exp_Vpic>;
};


export type Subscription_RootSeatBeltsAll_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootSeatBeltsAll_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SeatBeltsAll_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<SeatBeltsAll_Bool_Exp_Vpic>;
};


export type Subscription_RootSemiautomaticHeadlampBeamSwitchingArgs = {
  distinct_on?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Order_By_Vpic>>;
  where?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic>;
};


export type Subscription_RootSemiautomaticHeadlampBeamSwitching_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SemiautomaticHeadlampBeamSwitching_Order_By_Vpic>>;
  where?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic>;
};


export type Subscription_RootSemiautomaticHeadlampBeamSwitching_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootSemiautomaticHeadlampBeamSwitching_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SemiautomaticHeadlampBeamSwitching_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<SemiautomaticHeadlampBeamSwitching_Bool_Exp_Vpic>;
};


export type Subscription_RootSteeringArgs = {
  distinct_on?: InputMaybe<Array<Steering_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Steering_Order_By_Vpic>>;
  where?: InputMaybe<Steering_Bool_Exp_Vpic>;
};


export type Subscription_RootSteering_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Steering_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Steering_Order_By_Vpic>>;
  where?: InputMaybe<Steering_Bool_Exp_Vpic>;
};


export type Subscription_RootSteering_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootSteering_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Steering_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Steering_Bool_Exp_Vpic>;
};


export type Subscription_RootTpmsArgs = {
  distinct_on?: InputMaybe<Array<Tpms_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tpms_Order_By_Vpic>>;
  where?: InputMaybe<Tpms_Bool_Exp_Vpic>;
};


export type Subscription_RootTpms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tpms_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tpms_Order_By_Vpic>>;
  where?: InputMaybe<Tpms_Bool_Exp_Vpic>;
};


export type Subscription_RootTpms_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootTpms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tpms_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Tpms_Bool_Exp_Vpic>;
};


export type Subscription_RootTractionControlArgs = {
  distinct_on?: InputMaybe<Array<TractionControl_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TractionControl_Order_By_Vpic>>;
  where?: InputMaybe<TractionControl_Bool_Exp_Vpic>;
};


export type Subscription_RootTractionControl_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TractionControl_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TractionControl_Order_By_Vpic>>;
  where?: InputMaybe<TractionControl_Bool_Exp_Vpic>;
};


export type Subscription_RootTractionControl_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootTractionControl_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TractionControl_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<TractionControl_Bool_Exp_Vpic>;
};


export type Subscription_RootTrailerBodyTypeArgs = {
  distinct_on?: InputMaybe<Array<TrailerBodyType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrailerBodyType_Order_By_Vpic>>;
  where?: InputMaybe<TrailerBodyType_Bool_Exp_Vpic>;
};


export type Subscription_RootTrailerBodyType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TrailerBodyType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrailerBodyType_Order_By_Vpic>>;
  where?: InputMaybe<TrailerBodyType_Bool_Exp_Vpic>;
};


export type Subscription_RootTrailerBodyType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootTrailerBodyType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TrailerBodyType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<TrailerBodyType_Bool_Exp_Vpic>;
};


export type Subscription_RootTrailerTypeArgs = {
  distinct_on?: InputMaybe<Array<TrailerType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrailerType_Order_By_Vpic>>;
  where?: InputMaybe<TrailerType_Bool_Exp_Vpic>;
};


export type Subscription_RootTrailerType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TrailerType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrailerType_Order_By_Vpic>>;
  where?: InputMaybe<TrailerType_Bool_Exp_Vpic>;
};


export type Subscription_RootTrailerType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootTrailerType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TrailerType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<TrailerType_Bool_Exp_Vpic>;
};


export type Subscription_RootTransmissionArgs = {
  distinct_on?: InputMaybe<Array<Transmission_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transmission_Order_By_Vpic>>;
  where?: InputMaybe<Transmission_Bool_Exp_Vpic>;
};


export type Subscription_RootTransmission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transmission_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transmission_Order_By_Vpic>>;
  where?: InputMaybe<Transmission_Bool_Exp_Vpic>;
};


export type Subscription_RootTransmission_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootTransmission_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transmission_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Transmission_Bool_Exp_Vpic>;
};


export type Subscription_RootTurboArgs = {
  distinct_on?: InputMaybe<Array<Turbo_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Turbo_Order_By_Vpic>>;
  where?: InputMaybe<Turbo_Bool_Exp_Vpic>;
};


export type Subscription_RootTurbo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Turbo_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Turbo_Order_By_Vpic>>;
  where?: InputMaybe<Turbo_Bool_Exp_Vpic>;
};


export type Subscription_RootTurbo_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootTurbo_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Turbo_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Turbo_Bool_Exp_Vpic>;
};


export type Subscription_RootVSpecSchemaPatternArgs = {
  distinct_on?: InputMaybe<Array<VSpecSchemaPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VSpecSchemaPattern_Order_By_Vpic>>;
  where?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
};


export type Subscription_RootVSpecSchemaPattern_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VSpecSchemaPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VSpecSchemaPattern_Order_By_Vpic>>;
  where?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
};


export type Subscription_RootVSpecSchemaPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootVSpecSchemaPattern_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VSpecSchemaPattern_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VSpecSchemaPattern_Bool_Exp_Vpic>;
};


export type Subscription_RootValvetrainDesignArgs = {
  distinct_on?: InputMaybe<Array<ValvetrainDesign_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValvetrainDesign_Order_By_Vpic>>;
  where?: InputMaybe<ValvetrainDesign_Bool_Exp_Vpic>;
};


export type Subscription_RootValvetrainDesign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValvetrainDesign_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValvetrainDesign_Order_By_Vpic>>;
  where?: InputMaybe<ValvetrainDesign_Bool_Exp_Vpic>;
};


export type Subscription_RootValvetrainDesign_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootValvetrainDesign_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ValvetrainDesign_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<ValvetrainDesign_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecPatternArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecPattern_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecPattern_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecPattern_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecPattern_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecPattern_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootVehicleSpecPattern_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VehicleSpecPattern_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VehicleSpecPattern_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecSchemaArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecSchema_ModelArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Model_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Model_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecSchema_Model_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Model_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Model_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Model_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecSchema_Model_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootVehicleSpecSchema_Model_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VehicleSpecSchema_Model_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Model_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecSchema_YearArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Year_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Year_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Year_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecSchema_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Year_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Year_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Year_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecSchema_Year_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootVehicleSpecSchema_Year_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VehicleSpecSchema_Year_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Year_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecSchema_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleSpecSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleSpecSchema_Order_By_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleSpecSchema_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootVehicleSpecSchema_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VehicleSpecSchema_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VehicleSpecSchema_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleTypeArgs = {
  distinct_on?: InputMaybe<Array<VehicleType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleType_Order_By_Vpic>>;
  where?: InputMaybe<VehicleType_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleType_Order_By_Vpic>>;
  where?: InputMaybe<VehicleType_Bool_Exp_Vpic>;
};


export type Subscription_RootVehicleType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootVehicleType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VehicleType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VehicleType_Bool_Exp_Vpic>;
};


export type Subscription_RootVinDescriptorArgs = {
  distinct_on?: InputMaybe<Array<VinDescriptor_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinDescriptor_Order_By_Vpic>>;
  where?: InputMaybe<VinDescriptor_Bool_Exp_Vpic>;
};


export type Subscription_RootVinDescriptor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VinDescriptor_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinDescriptor_Order_By_Vpic>>;
  where?: InputMaybe<VinDescriptor_Bool_Exp_Vpic>;
};


export type Subscription_RootVinDescriptor_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootVinDescriptor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VinDescriptor_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VinDescriptor_Bool_Exp_Vpic>;
};


export type Subscription_RootVinExceptionArgs = {
  distinct_on?: InputMaybe<Array<VinException_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinException_Order_By_Vpic>>;
  where?: InputMaybe<VinException_Bool_Exp_Vpic>;
};


export type Subscription_RootVinException_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VinException_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinException_Order_By_Vpic>>;
  where?: InputMaybe<VinException_Bool_Exp_Vpic>;
};


export type Subscription_RootVinException_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootVinException_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VinException_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VinException_Bool_Exp_Vpic>;
};


export type Subscription_RootVinSchemaArgs = {
  distinct_on?: InputMaybe<Array<VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<VinSchema_Bool_Exp_Vpic>;
};


export type Subscription_RootVinSchema_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<VinSchema_Bool_Exp_Vpic>;
};


export type Subscription_RootVinSchema_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootVinSchema_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VinSchema_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VinSchema_Bool_Exp_Vpic>;
};


export type Subscription_RootWmiYearValidCharsArgs = {
  distinct_on?: InputMaybe<Array<WmiYearValidChars_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WmiYearValidChars_Order_By_Vpic>>;
  where?: InputMaybe<WmiYearValidChars_Bool_Exp_Vpic>;
};


export type Subscription_RootWmiYearValidChars_CacheExceptionsArgs = {
  distinct_on?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Order_By_Vpic>>;
  where?: InputMaybe<WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic>;
};


export type Subscription_RootWmiYearValidChars_CacheExceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WmiYearValidChars_CacheExceptions_Order_By_Vpic>>;
  where?: InputMaybe<WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic>;
};


export type Subscription_RootWmiYearValidChars_CacheExceptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WmiYearValidChars_CacheExceptions_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<WmiYearValidChars_CacheExceptions_Bool_Exp_Vpic>;
};


export type Subscription_RootWmiYearValidChars_AggregateArgs = {
  distinct_on?: InputMaybe<Array<WmiYearValidChars_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WmiYearValidChars_Order_By_Vpic>>;
  where?: InputMaybe<WmiYearValidChars_Bool_Exp_Vpic>;
};


export type Subscription_RootWmiYearValidChars_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWmiYearValidChars_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WmiYearValidChars_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<WmiYearValidChars_Bool_Exp_Vpic>;
};


export type Subscription_RootWheelBaseTypeArgs = {
  distinct_on?: InputMaybe<Array<WheelBaseType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WheelBaseType_Order_By_Vpic>>;
  where?: InputMaybe<WheelBaseType_Bool_Exp_Vpic>;
};


export type Subscription_RootWheelBaseType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<WheelBaseType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WheelBaseType_Order_By_Vpic>>;
  where?: InputMaybe<WheelBaseType_Bool_Exp_Vpic>;
};


export type Subscription_RootWheelBaseType_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootWheelBaseType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WheelBaseType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<WheelBaseType_Bool_Exp_Vpic>;
};


export type Subscription_RootWheelieMitigationArgs = {
  distinct_on?: InputMaybe<Array<WheelieMitigation_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WheelieMitigation_Order_By_Vpic>>;
  where?: InputMaybe<WheelieMitigation_Bool_Exp_Vpic>;
};


export type Subscription_RootWheelieMitigation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<WheelieMitigation_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WheelieMitigation_Order_By_Vpic>>;
  where?: InputMaybe<WheelieMitigation_Bool_Exp_Vpic>;
};


export type Subscription_RootWheelieMitigation_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootWheelieMitigation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WheelieMitigation_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<WheelieMitigation_Bool_Exp_Vpic>;
};


export type Subscription_RootWmiArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Bool_Exp_Vpic>;
};


export type Subscription_RootWmi_MakeArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Make_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
};


export type Subscription_RootWmi_Make_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Make_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Make_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
};


export type Subscription_RootWmi_Make_By_PkArgs = {
  MakeId: Scalars['Int'];
  WmiId: Scalars['Int'];
};


export type Subscription_RootWmi_Make_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Wmi_Make_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Wmi_Make_Bool_Exp_Vpic>;
};


export type Subscription_RootWmi_VinSchemaArgs = {
  distinct_on?: InputMaybe<Array<Wmi_VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
};


export type Subscription_RootWmi_VinSchema_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_VinSchema_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_VinSchema_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
};


export type Subscription_RootWmi_VinSchema_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootWmi_VinSchema_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Wmi_VinSchema_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Wmi_VinSchema_Bool_Exp_Vpic>;
};


export type Subscription_RootWmi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wmi_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wmi_Order_By_Vpic>>;
  where?: InputMaybe<Wmi_Bool_Exp_Vpic>;
};


export type Subscription_RootWmi_By_PkArgs = {
  Id: Scalars['Int'];
};


export type Subscription_RootWmi_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Wmi_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<Wmi_Bool_Exp_Vpic>;
};


export type Subscription_RootAccountAccountManager_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountAccountManager_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountAccountManager_Bool_Exp>;
};


export type Subscription_RootAccountCategory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountCategory_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountCategory_Bool_Exp>;
};


export type Subscription_RootAccountDisbursement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountDisbursement_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


export type Subscription_RootAccountManager_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountManager_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountManager_Bool_Exp>;
};


export type Subscription_RootAccountProductObligor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountProductObligor_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountProductObligor_Bool_Exp>;
};


export type Subscription_RootAccountProduct_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountProduct_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


export type Subscription_RootAccountRetail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountRetail_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


export type Subscription_RootAccountType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountType_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountType_Bool_Exp>;
};


export type Subscription_RootAccount_SearchArgs = {
  args: Account_Search_Args;
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAccount_Search_AggregateArgs = {
  args: Account_Search_Args;
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAccount_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Account_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAddressType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AddressType_Stream_Cursor_Input>>;
  where?: InputMaybe<AddressType_Bool_Exp>;
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootApprovalAuthority_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApprovalAuthority_Stream_Cursor_Input>>;
  where?: InputMaybe<ApprovalAuthority_Bool_Exp>;
};


export type Subscription_RootApprovalGateBinding_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApprovalGateBinding_Stream_Cursor_Input>>;
  where?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
};


export type Subscription_RootApprovalGate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApprovalGate_Stream_Cursor_Input>>;
  where?: InputMaybe<ApprovalGate_Bool_Exp>;
};


export type Subscription_RootApprovalHeadroomArgs = {
  args: ApprovalHeadroom_Args;
  distinct_on?: InputMaybe<Array<ApprovalState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalState_Order_By>>;
  where?: InputMaybe<ApprovalState_Bool_Exp>;
};


export type Subscription_RootApprovalHeadroom_AggregateArgs = {
  args: ApprovalHeadroom_Args;
  distinct_on?: InputMaybe<Array<ApprovalState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalState_Order_By>>;
  where?: InputMaybe<ApprovalState_Bool_Exp>;
};


export type Subscription_RootApprovalRequest_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApprovalRequest_Stream_Cursor_Input>>;
  where?: InputMaybe<ApprovalRequest_Bool_Exp>;
};


export type Subscription_RootApprovalState_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApprovalState_Stream_Cursor_Input>>;
  where?: InputMaybe<ApprovalState_Bool_Exp>;
};


export type Subscription_RootApproval_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Approval_Stream_Cursor_Input>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


export type Subscription_RootAs400DataSync_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As400DataSync_Stream_Cursor_Input>>;
  where?: InputMaybe<As400DataSync_Bool_Exp>;
};


export type Subscription_RootAudit_Message_Formatter_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Audit_Message_Formatter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Message_Formatter_Config_Order_By>>;
  where?: InputMaybe<Audit_Message_Formatter_Config_Bool_Exp>;
};


export type Subscription_RootAudit_Message_Formatter_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Message_Formatter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Message_Formatter_Config_Order_By>>;
  where?: InputMaybe<Audit_Message_Formatter_Config_Bool_Exp>;
};


export type Subscription_RootAudit_Message_Formatter_Config_By_PkArgs = {
  field_name: Scalars['String'];
  formatter_strategy: Scalars['String'];
  schema_name: Scalars['String'];
  table_name: Scalars['String'];
};


export type Subscription_RootAudit_Message_Formatter_Config_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Audit_Message_Formatter_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Message_Formatter_Config_Bool_Exp>;
};


export type Subscription_RootAudit_TableslistArgs = {
  distinct_on?: InputMaybe<Array<Audit_Tableslist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Tableslist_Order_By>>;
  where?: InputMaybe<Audit_Tableslist_Bool_Exp>;
};


export type Subscription_RootAudit_Tableslist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Tableslist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Tableslist_Order_By>>;
  where?: InputMaybe<Audit_Tableslist_Bool_Exp>;
};


export type Subscription_RootAudit_Tableslist_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Audit_Tableslist_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Tableslist_Bool_Exp>;
};


export type Subscription_RootAuth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootAuth_Group_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Actions_Order_By>>;
  where?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
};


export type Subscription_RootAuth_Group_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Actions_Order_By>>;
  where?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
};


export type Subscription_RootAuth_Group_Actions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuth_Group_Actions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_Group_Actions_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Group_Actions_Bool_Exp>;
};


export type Subscription_RootAuth_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootAuth_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuth_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootCaddyServerManagerLog_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CaddyServerManagerLog_Stream_Cursor_Input>>;
  where?: InputMaybe<CaddyServerManagerLog_Bool_Exp>;
};


export type Subscription_RootCaddy_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Caddy_Stream_Cursor_Input>>;
  where?: InputMaybe<Caddy_Bool_Exp>;
};


export type Subscription_RootCancellation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cancellation_Stream_Cursor_Input>>;
  where?: InputMaybe<Cancellation_Bool_Exp>;
};


export type Subscription_RootCapabilityConfig_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CapabilityConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<CapabilityConfig_Bool_Exp>;
};


export type Subscription_RootCapabilityRoute_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CapabilityRoute_Stream_Cursor_Input>>;
  where?: InputMaybe<CapabilityRoute_Bool_Exp>;
};


export type Subscription_RootCapability_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Capability_Stream_Cursor_Input>>;
  where?: InputMaybe<Capability_Bool_Exp>;
};


export type Subscription_RootCarrier_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Carrier_Stream_Cursor_Input>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Subscription_RootCategoryProductAttributeType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CategoryProductAttributeType_Stream_Cursor_Input>>;
  where?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
};


export type Subscription_RootCategory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootClaimDetailCategory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClaimDetailCategory_Stream_Cursor_Input>>;
  where?: InputMaybe<ClaimDetailCategory_Bool_Exp>;
};


export type Subscription_RootClaimDetailPartLookup_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClaimDetailPartLookup_Stream_Cursor_Input>>;
  where?: InputMaybe<ClaimDetailPartLookup_Bool_Exp>;
};


export type Subscription_RootClaimDetail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClaimDetail_Stream_Cursor_Input>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


export type Subscription_RootClaimPart_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClaimPart_Stream_Cursor_Input>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};


export type Subscription_RootClaimServiceCenterAuthorization_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClaimServiceCenterAuthorization_Stream_Cursor_Input>>;
  where?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
};


export type Subscription_RootClaimServiceCenter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClaimServiceCenter_Stream_Cursor_Input>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


export type Subscription_RootClaimStatusType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClaimStatusType_Stream_Cursor_Input>>;
  where?: InputMaybe<ClaimStatusType_Bool_Exp>;
};


export type Subscription_RootClaim_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Claim_Stream_Cursor_Input>>;
  where?: InputMaybe<Claim_Bool_Exp>;
};


export type Subscription_RootClaims_Pre_Authorization_Vehicle_InformationArgs = {
  distinct_on?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Order_By>>;
  where?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Bool_Exp>;
};


export type Subscription_RootClaims_Pre_Authorization_Vehicle_Information_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claims_Pre_Authorization_Vehicle_Information_Order_By>>;
  where?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Bool_Exp>;
};


export type Subscription_RootClaims_Pre_Authorization_Vehicle_Information_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClaims_Pre_Authorization_Vehicle_Information_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Stream_Cursor_Input>>;
  where?: InputMaybe<Claims_Pre_Authorization_Vehicle_Information_Bool_Exp>;
};


export type Subscription_RootClaims_Temp_Claims_Auth_TableArgs = {
  distinct_on?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Order_By>>;
  where?: InputMaybe<Claims_Temp_Claims_Auth_Table_Bool_Exp>;
};


export type Subscription_RootClaims_Temp_Claims_Auth_Table_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claims_Temp_Claims_Auth_Table_Order_By>>;
  where?: InputMaybe<Claims_Temp_Claims_Auth_Table_Bool_Exp>;
};


export type Subscription_RootClaims_Temp_Claims_Auth_Table_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClaims_Temp_Claims_Auth_Table_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Claims_Temp_Claims_Auth_Table_Stream_Cursor_Input>>;
  where?: InputMaybe<Claims_Temp_Claims_Auth_Table_Bool_Exp>;
};


export type Subscription_RootClassCriteriaViewDefaultVehicleCriteria_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootClassCriteriaViewUnclassedDefaultVehicleCriteria_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootClassCriteria_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClassCriteria_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassCriteria_Bool_Exp>;
};


export type Subscription_RootClassGuideClassCriteriaViewDefaultVehicleCriteria_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootClassGuideClassCriteriaViewVin_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClassGuideClassCriteriaViewVin_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassGuideClassCriteriaViewVin_Bool_Exp>;
};


export type Subscription_RootClassGuideClassCriteria_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClassGuideClassCriteria_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


export type Subscription_RootClassGuideCriteriaDefinition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClassGuideCriteriaDefinition_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};


export type Subscription_RootClassGuideCriteriaType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClassGuideCriteriaType_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassGuideCriteriaType_Bool_Exp>;
};


export type Subscription_RootClassGuide_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClassGuide_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassGuide_Bool_Exp>;
};


export type Subscription_RootConcernSynonym_By_PkArgs = {
  groupName: Scalars['String'];
  term: Scalars['String'];
};


export type Subscription_RootConcernSynonym_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ConcernSynonym_Stream_Cursor_Input_Nhtsa>>;
  where?: InputMaybe<ConcernSynonym_Bool_Exp_Nhtsa>;
};


export type Subscription_RootConfigurationItemType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ConfigurationItemType_Stream_Cursor_Input>>;
  where?: InputMaybe<ConfigurationItemType_Bool_Exp>;
};


export type Subscription_RootConfigurationItem_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ConfigurationItem_Stream_Cursor_Input>>;
  where?: InputMaybe<ConfigurationItem_Bool_Exp>;
};


export type Subscription_RootContact_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Contact_Stream_Cursor_Input>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootContractFormFilingStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContractFormFilingStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


export type Subscription_RootContractFormStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContractForm_Stream_Cursor_Input>>;
  where?: InputMaybe<ContractForm_Bool_Exp>;
};


export type Subscription_RootContractFormStreamVersionArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContractFormVersion_Stream_Cursor_Input>>;
  where?: InputMaybe<ContractFormVersion_Bool_Exp>;
};


export type Subscription_RootContractFormType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContractFormType_Stream_Cursor_Input>>;
  where?: InputMaybe<ContractFormType_Bool_Exp>;
};


export type Subscription_RootContractStatusType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContractStatusType_Stream_Cursor_Input>>;
  where?: InputMaybe<ContractStatusType_Bool_Exp>;
};


export type Subscription_RootContract_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Contract_Bool_Exp>;
};


export type Subscription_RootCostAdjustmentExtendedCost_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CostAdjustmentExtendedCost_Stream_Cursor_Input>>;
  where?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
};


export type Subscription_RootCostAdjustmentLookup_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CostAdjustmentLookup_Stream_Cursor_Input>>;
  where?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
};


export type Subscription_RootCostAdjustmentType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CostAdjustmentType_Stream_Cursor_Input>>;
  where?: InputMaybe<CostAdjustmentType_Bool_Exp>;
};


export type Subscription_RootCostAdjustment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CostAdjustment_Stream_Cursor_Input>>;
  where?: InputMaybe<CostAdjustment_Bool_Exp>;
};


export type Subscription_RootCustomFieldData_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CustomFieldData_Stream_Cursor_Input>>;
  where?: InputMaybe<CustomFieldData_Bool_Exp>;
};


export type Subscription_RootCustomFieldType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CustomFieldType_Stream_Cursor_Input>>;
  where?: InputMaybe<CustomFieldType_Bool_Exp>;
};


export type Subscription_RootCustomField_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CustomField_Stream_Cursor_Input>>;
  where?: InputMaybe<CustomField_Bool_Exp>;
};


export type Subscription_RootCustomer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootDataType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DataType_Stream_Cursor_Input>>;
  where?: InputMaybe<DataType_Bool_Exp>;
};


export type Subscription_RootDealerPaymentType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DealerPaymentType_Stream_Cursor_Input>>;
  where?: InputMaybe<DealerPaymentType_Bool_Exp>;
};


export type Subscription_RootDisbursementType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DisbursementType_Stream_Cursor_Input>>;
  where?: InputMaybe<DisbursementType_Bool_Exp>;
};


export type Subscription_RootDocument_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootEligibilityRuleDefinition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EligibilityRuleDefinition_Stream_Cursor_Input>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};


export type Subscription_RootEligibilityRule_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EligibilityRule_Stream_Cursor_Input>>;
  where?: InputMaybe<EligibilityRule_Bool_Exp>;
};


export type Subscription_RootEligibilityType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EligibilityType_Stream_Cursor_Input>>;
  where?: InputMaybe<EligibilityType_Bool_Exp>;
};


export type Subscription_RootEntityBillingInformation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityBillingInformation_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityBillingInformation_Bool_Exp>;
};


export type Subscription_RootEntityConfigurationItem_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityConfigurationItem_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


export type Subscription_RootEntityCustomFieldValue_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityCustomFieldValue_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
};


export type Subscription_RootEntityCustomField_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityCustomField_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


export type Subscription_RootEntityDataDefinition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityDataDefinition_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityDataDefinition_Bool_Exp>;
};


export type Subscription_RootEntityEligibilityRule_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityEligibilityRule_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


export type Subscription_RootEntityFileStorage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityFileStorage_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


export type Subscription_RootEntityNoteCapabilityView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityNoteCapabilityView_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityNoteCapabilityView_Bool_Exp>;
};


export type Subscription_RootEntityNote_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityNote_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


export type Subscription_RootEntityOffering_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityOffering_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


export type Subscription_RootEntityRemittanceDetail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityRemittanceDetail_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


export type Subscription_RootEntityTag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityTag_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


export type Subscription_RootFileStorageType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FileStorageType_Stream_Cursor_Input>>;
  where?: InputMaybe<FileStorageType_Bool_Exp>;
};


export type Subscription_RootFileStorage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FileStorage_Stream_Cursor_Input>>;
  where?: InputMaybe<FileStorage_Bool_Exp>;
};


export type Subscription_RootFilingLenderStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FilingLender_Stream_Cursor_Input>>;
  where?: InputMaybe<FilingLender_Bool_Exp>;
};


export type Subscription_RootFilingStatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FilingState_Stream_Cursor_Input>>;
  where?: InputMaybe<FilingState_Bool_Exp>;
};


export type Subscription_RootFilingStatusTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FilingStatusType_Stream_Cursor_Input>>;
  where?: InputMaybe<FilingStatusType_Bool_Exp>;
};


export type Subscription_RootGetDistinctMakesArgs = {
  distinct_on?: InputMaybe<Array<Vpic_Criteria_Make_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vpic_Criteria_Make_Order_By>>;
  where?: InputMaybe<Vpic_Criteria_Make_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


export type Subscription_RootIdentities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


export type Subscription_RootIdentities_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootIdentities_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Identities_Stream_Cursor_Input>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


export type Subscription_RootIdentityCapabilityView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdentityCapabilityView_Stream_Cursor_Input>>;
  where?: InputMaybe<IdentityCapabilityView_Bool_Exp>;
};


export type Subscription_RootIdentityCapability_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdentityCapability_Stream_Cursor_Input>>;
  where?: InputMaybe<IdentityCapability_Bool_Exp>;
};


export type Subscription_RootIdentityEntityView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdentityEntityView_Stream_Cursor_Input>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


export type Subscription_RootIdentityEntity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdentityEntity_Stream_Cursor_Input>>;
  where?: InputMaybe<IdentityEntity_Bool_Exp>;
};


export type Subscription_RootInvestigationRecall_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InvestigationRecall_Stream_Cursor_Input_Nhtsa>>;
  where?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
};


export type Subscription_RootInvoiceDocumentType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceDocumentType_Stream_Cursor_Input>>;
  where?: InputMaybe<InvoiceDocumentType_Bool_Exp>;
};


export type Subscription_RootInvoicePaymentType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicePaymentType_Stream_Cursor_Input>>;
  where?: InputMaybe<InvoicePaymentType_Bool_Exp>;
};


export type Subscription_RootInvoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootIssueMakeModel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IssueMakeModel_Stream_Cursor_Input_Nhtsa>>;
  where?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
};


export type Subscription_RootIssueSearchResult_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IssueSearchResult_Stream_Cursor_Input_Nhtsa>>;
  where?: InputMaybe<IssueSearchResult_Bool_Exp_Nhtsa>;
};


export type Subscription_RootIssueVehicle_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IssueVehicle_Stream_Cursor_Input_Nhtsa>>;
  where?: InputMaybe<IssueVehicle_Bool_Exp_Nhtsa>;
};


export type Subscription_RootIssue_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Issue_Stream_Cursor_Input_Nhtsa>>;
  where?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
};


export type Subscription_RootJobSchedule_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JobSchedule_Stream_Cursor_Input>>;
  where?: InputMaybe<JobSchedule_Bool_Exp>;
};


export type Subscription_RootLaborGuideType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LaborGuideType_Stream_Cursor_Input>>;
  where?: InputMaybe<LaborGuideType_Bool_Exp>;
};


export type Subscription_RootLegacyPolicyContract_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LegacyPolicyContract_Stream_Cursor_Input>>;
  where?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
};


export type Subscription_RootLegacy_Claims_Dealer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Legacy_Claims_Dealer_Stream_Cursor_Input>>;
  where?: InputMaybe<Legacy_Claims_Dealer_Bool_Exp>;
};


export type Subscription_RootLegacy_Claims_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Legacy_Claims_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
};


export type Subscription_RootLegacy_Claims_SelectDealerArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLegacy_Claims_SelectDealerAggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Claims_Dealer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Claims_Dealer_Order_By>>;
  where?: InputMaybe<Legacy_Claims_Dealer_Bool_Exp>;
};


export type Subscription_RootLegacy_Claims_SelectDealersArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Claims_Dealer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Claims_Dealer_Order_By>>;
  where?: InputMaybe<Legacy_Claims_Dealer_Bool_Exp>;
};


export type Subscription_RootLegacy_Claims_SelectNoteArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLegacy_Claims_SelectNoteAggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Claims_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Claims_Note_Order_By>>;
  where?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
};


export type Subscription_RootLegacy_Claims_SelectNotesArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Claims_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Claims_Note_Order_By>>;
  where?: InputMaybe<Legacy_Claims_Note_Bool_Exp>;
};


export type Subscription_RootLoad_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Load_Stream_Cursor_Input_Nhtsa>>;
  where?: InputMaybe<Load_Bool_Exp_Nhtsa>;
};


export type Subscription_RootLoggedAction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LoggedAction_Stream_Cursor_Input>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


export type Subscription_RootMakeModel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MakeModel_Stream_Cursor_Input_Nhtsa>>;
  where?: InputMaybe<MakeModel_Bool_Exp_Nhtsa>;
};


export type Subscription_RootMateralizedClassCriteriaViewDefaultVehicleCriteria_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Stream_Cursor_Input>>;
  where?: InputMaybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootModelYearModel_By_PkArgs = {
  makeKey: Scalars['String'];
  model: Scalars['String'];
  modelYear: Scalars['Int'];
};


export type Subscription_RootModelYearModel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ModelYearModel_Stream_Cursor_Input_Nhtsa>>;
  where?: InputMaybe<ModelYearModel_Bool_Exp_Nhtsa>;
};


export type Subscription_RootObligor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Obligor_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};


export type Subscription_RootObsoleteJob_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ObsoleteJob_Stream_Cursor_Input>>;
  where?: InputMaybe<ObsoleteJob_Bool_Exp>;
};


export type Subscription_RootOperations_Legacy_Policy_Contract_Cost_Detail_ViewArgs = {
  distinct_on?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Order_By>>;
  where?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp>;
};


export type Subscription_RootOperations_Legacy_Policy_Contract_Cost_Detail_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Legacy_Policy_Contract_Cost_Detail_View_Order_By>>;
  where?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp>;
};


export type Subscription_RootOperations_Legacy_Policy_Contract_Cost_Detail_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Legacy_Policy_Contract_Cost_Detail_View_Bool_Exp>;
};


export type Subscription_RootOperations_Legacy_Policy_Contract_List_Materialized_ViewArgs = {
  distinct_on?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Order_By>>;
  where?: InputMaybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Bool_Exp>;
};


export type Subscription_RootOperations_Legacy_Policy_Contract_List_Materialized_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Legacy_Policy_Contract_List_Materialized_View_Order_By>>;
  where?: InputMaybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Bool_Exp>;
};


export type Subscription_RootOperations_Legacy_Policy_Contract_List_Materialized_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Legacy_Policy_Contract_List_Materialized_View_Bool_Exp>;
};


export type Subscription_RootPayeeAs400_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PayeeAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<PayeeAs400_Bool_Exp>;
};


export type Subscription_RootPayeeLinkView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PayeeLinkView_Stream_Cursor_Input>>;
  where?: InputMaybe<PayeeLinkView_Bool_Exp>;
};


export type Subscription_RootPayee_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payee_Stream_Cursor_Input>>;
  where?: InputMaybe<Payee_Bool_Exp>;
};


export type Subscription_RootPaymentDetail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentDetail_Stream_Cursor_Input>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};


export type Subscription_RootPaymentStatusType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentStatusType_Stream_Cursor_Input>>;
  where?: InputMaybe<PaymentStatusType_Bool_Exp>;
};


export type Subscription_RootPaymentType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentType_Stream_Cursor_Input>>;
  where?: InputMaybe<PaymentType_Bool_Exp>;
};


export type Subscription_RootPayment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootPolicyClaimConcern_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyClaimConcern_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyClaimConcern_Bool_Exp>;
};


export type Subscription_RootPolicyClaim_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyClaim_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


export type Subscription_RootPolicyContractContractFormVersion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractContractFormVersion_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
};


export type Subscription_RootPolicyContractListView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractListView_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractListView_Bool_Exp>;
};


export type Subscription_RootProductAttributeType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductAttributeType_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductAttributeType_Bool_Exp>;
};


export type Subscription_RootProductAttribute_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductAttribute_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductAttribute_Bool_Exp>;
};


export type Subscription_RootProductClassGuide_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductClassGuide_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductClassGuide_Bool_Exp>;
};


export type Subscription_RootProductContractFormsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductContractForm_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductContractForm_Bool_Exp>;
};


export type Subscription_RootProductCost_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductCost_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};


export type Subscription_RootProductDisbursement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductDisbursement_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};


export type Subscription_RootProductEligibility_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductEligibility_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductEligibility_Bool_Exp>;
};


export type Subscription_RootProductObligor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductObligor_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductObligor_Bool_Exp>;
};


export type Subscription_RootProductRateBucket_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductRateBucket_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductRateBucket_Bool_Exp>;
};


export type Subscription_RootProductSurchargeType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductSurchargeType_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductSurchargeType_Bool_Exp>;
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootQuoteMinimalView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<QuoteMinimalView_Stream_Cursor_Input>>;
  where?: InputMaybe<QuoteMinimalView_Bool_Exp>;
};


export type Subscription_RootQuoteStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quote_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Subscription_RootQuoteTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<QuoteType_Stream_Cursor_Input>>;
  where?: InputMaybe<QuoteType_Bool_Exp>;
};


export type Subscription_RootRateBucketType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RateBucketType_Stream_Cursor_Input>>;
  where?: InputMaybe<RateBucketType_Bool_Exp>;
};


export type Subscription_RootRateQuote_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RateQuote_Stream_Cursor_Input>>;
  where?: InputMaybe<RateQuote_Bool_Exp>;
};


export type Subscription_RootRecordType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RecordType_Stream_Cursor_Input_Nhtsa>>;
  where?: InputMaybe<RecordType_Bool_Exp_Nhtsa>;
};


export type Subscription_RootRemittanceClaimDetail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RemittanceClaimDetail_Stream_Cursor_Input>>;
  where?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
};


export type Subscription_RootRemittancePayment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RemittancePayment_Stream_Cursor_Input>>;
  where?: InputMaybe<RemittancePayment_Bool_Exp>;
};


export type Subscription_RootRemittancePolicyContractAs400_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RemittancePolicyContractAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<RemittancePolicyContractAs400_Bool_Exp>;
};


export type Subscription_RootRemittanceType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RemittanceType_Stream_Cursor_Input>>;
  where?: InputMaybe<RemittanceType_Bool_Exp>;
};


export type Subscription_RootRepeatPartAcknowledgment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RepeatPartAcknowledgment_Stream_Cursor_Input>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};


export type Subscription_RootRoleAttribute_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RoleAttribute_Stream_Cursor_Input>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};


export type Subscription_RootRole_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRouteConfig_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RouteConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<RouteConfig_Bool_Exp>;
};


export type Subscription_RootRoute_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Route_Stream_Cursor_Input>>;
  where?: InputMaybe<Route_Bool_Exp>;
};


export type Subscription_RootSaveRateQuoteActionArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSearchArgs = {
  args: Search_Args;
  distinct_on?: InputMaybe<Array<Shared_Search_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Search_Result_Order_By>>;
  where?: InputMaybe<Shared_Search_Result_Bool_Exp>;
};


export type Subscription_RootSearchIndex_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SearchIndex_Stream_Cursor_Input>>;
  where?: InputMaybe<SearchIndex_Bool_Exp>;
};


export type Subscription_RootSearchNhtsaIssueAggregateArgs = {
  args?: InputMaybe<SearchNhtsaIssues_Args_Nhtsa>;
  distinct_on?: InputMaybe<Array<IssueSearchResult_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueSearchResult_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueSearchResult_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSearchNhtsaIssuesArgs = {
  args?: InputMaybe<SearchNhtsaIssues_Args_Nhtsa>;
  distinct_on?: InputMaybe<Array<IssueSearchResult_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueSearchResult_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueSearchResult_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSearch_AggregateArgs = {
  args: Search_Args;
  distinct_on?: InputMaybe<Array<Shared_Search_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Search_Result_Order_By>>;
  where?: InputMaybe<Shared_Search_Result_Bool_Exp>;
};


export type Subscription_RootSelectAccountArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAccountAccountManagerArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAccountAccountManagersArgs = {
  distinct_on?: InputMaybe<Array<AccountAccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountAccountManager_Order_By>>;
  where?: InputMaybe<AccountAccountManager_Bool_Exp>;
};


export type Subscription_RootSelectAccountAccountManagersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountAccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountAccountManager_Order_By>>;
  where?: InputMaybe<AccountAccountManager_Bool_Exp>;
};


export type Subscription_RootSelectAccountAggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootSelectAccountCategoriesArgs = {
  distinct_on?: InputMaybe<Array<AccountCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountCategory_Order_By>>;
  where?: InputMaybe<AccountCategory_Bool_Exp>;
};


export type Subscription_RootSelectAccountCategoryArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAccountCategoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountCategory_Order_By>>;
  where?: InputMaybe<AccountCategory_Bool_Exp>;
};


export type Subscription_RootSelectAccountDisbursementArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAccountDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


export type Subscription_RootSelectAccountDisbursementsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


export type Subscription_RootSelectAccountManagerArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAccountManagersArgs = {
  distinct_on?: InputMaybe<Array<AccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountManager_Order_By>>;
  where?: InputMaybe<AccountManager_Bool_Exp>;
};


export type Subscription_RootSelectAccountManagersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountManager_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountManager_Order_By>>;
  where?: InputMaybe<AccountManager_Bool_Exp>;
};


export type Subscription_RootSelectAccountObligorArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAccountObligorsArgs = {
  distinct_on?: InputMaybe<Array<AccountObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountObligor_Order_By>>;
  where?: InputMaybe<AccountObligor_Bool_Exp>;
};


export type Subscription_RootSelectAccountProductArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAccountProductObligorArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAccountProductObligorsArgs = {
  distinct_on?: InputMaybe<Array<AccountProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProductObligor_Order_By>>;
  where?: InputMaybe<AccountProductObligor_Bool_Exp>;
};


export type Subscription_RootSelectAccountProductObligorsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProductObligor_Order_By>>;
  where?: InputMaybe<AccountProductObligor_Bool_Exp>;
};


export type Subscription_RootSelectAccountProductsArgs = {
  distinct_on?: InputMaybe<Array<AccountProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProduct_Order_By>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


export type Subscription_RootSelectAccountProductsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProduct_Order_By>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


export type Subscription_RootSelectAccountRetailArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAccountRetailsArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


export type Subscription_RootSelectAccountRetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


export type Subscription_RootSelectAccountTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectAccountTypesArgs = {
  distinct_on?: InputMaybe<Array<AccountType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountType_Order_By>>;
  where?: InputMaybe<AccountType_Bool_Exp>;
};


export type Subscription_RootSelectAccountTypesAggregageArgs = {
  distinct_on?: InputMaybe<Array<AccountType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountType_Order_By>>;
  where?: InputMaybe<AccountType_Bool_Exp>;
};


export type Subscription_RootSelectAccountsArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootSelectAddressArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAddressTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectAddressTypesArgs = {
  distinct_on?: InputMaybe<Array<AddressType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AddressType_Order_By>>;
  where?: InputMaybe<AddressType_Bool_Exp>;
};


export type Subscription_RootSelectAddressTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AddressType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AddressType_Order_By>>;
  where?: InputMaybe<AddressType_Bool_Exp>;
};


export type Subscription_RootSelectAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootSelectAddressesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootSelectAggreatePaymentTypeArgs = {
  distinct_on?: InputMaybe<Array<PaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentType_Order_By>>;
  where?: InputMaybe<PaymentType_Bool_Exp>;
};


export type Subscription_RootSelectAggregateAccountObligorsArgs = {
  distinct_on?: InputMaybe<Array<AccountObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountObligor_Order_By>>;
  where?: InputMaybe<AccountObligor_Bool_Exp>;
};


export type Subscription_RootSelectAggregateClaimDetailAs400Args = {
  distinct_on?: InputMaybe<Array<ClaimDetailAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailAs400_Order_By>>;
  where?: InputMaybe<ClaimDetailAs400_Bool_Exp>;
};


export type Subscription_RootSelectAggregateClaimDetailDeductionAs400Args = {
  distinct_on?: InputMaybe<Array<ClaimDetailDeductionAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailDeductionAs400_Order_By>>;
  where?: InputMaybe<ClaimDetailDeductionAs400_Bool_Exp>;
};


export type Subscription_RootSelectAggregateClaimServiceCenterAs400Args = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenterAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenterAs400_Order_By>>;
  where?: InputMaybe<ClaimServiceCenterAs400_Bool_Exp>;
};


export type Subscription_RootSelectAggregateCompositeProductsArgs = {
  distinct_on?: InputMaybe<Array<CompositeProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompositeProduct_Order_By>>;
  where?: InputMaybe<CompositeProduct_Bool_Exp>;
};


export type Subscription_RootSelectAggregateIdentityAs400Args = {
  distinct_on?: InputMaybe<Array<IdentityAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityAs400_Order_By>>;
  where?: InputMaybe<IdentityAs400_Bool_Exp>;
};


export type Subscription_RootSelectAggregateJobListViewArgs = {
  distinct_on?: InputMaybe<Array<JobListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobListView_Order_By>>;
  where?: InputMaybe<JobListView_Bool_Exp>;
};


export type Subscription_RootSelectAggregateLaborRateArgs = {
  distinct_on?: InputMaybe<Array<LaborRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborRate_Order_By>>;
  where?: InputMaybe<LaborRate_Bool_Exp>;
};


export type Subscription_RootSelectAggregateLaborRateAs400Args = {
  distinct_on?: InputMaybe<Array<LaborRateAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborRateAs400_Order_By>>;
  where?: InputMaybe<LaborRateAs400_Bool_Exp>;
};


export type Subscription_RootSelectAggregatePaymentAs400Args = {
  distinct_on?: InputMaybe<Array<PaymentAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentAs400_Order_By>>;
  where?: InputMaybe<PaymentAs400_Bool_Exp>;
};


export type Subscription_RootSelectAggregatePolicyClaimAs400Args = {
  distinct_on?: InputMaybe<Array<PolicyClaimAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimAs400_Order_By>>;
  where?: InputMaybe<PolicyClaimAs400_Bool_Exp>;
};


export type Subscription_RootSelectAggregatePolicyClaimInsurancesArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimInsurance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimInsurance_Order_By>>;
  where?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
};


export type Subscription_RootSelectAggregateRaterViewConfigsArgs = {
  distinct_on?: InputMaybe<Array<RaterViewConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RaterViewConfig_Order_By>>;
  where?: InputMaybe<RaterViewConfig_Bool_Exp>;
};


export type Subscription_RootSelectAggregateRemittanceClaimDetailArgs = {
  distinct_on?: InputMaybe<Array<RemittanceClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceClaimDetail_Order_By>>;
  where?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
};


export type Subscription_RootSelectAggregateStepListViewArgs = {
  distinct_on?: InputMaybe<Array<StepListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StepListView_Order_By>>;
  where?: InputMaybe<StepListView_Bool_Exp>;
};


export type Subscription_RootSelectAggregateTaxRateArgs = {
  distinct_on?: InputMaybe<Array<TaxRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxRate_Order_By>>;
  where?: InputMaybe<TaxRate_Bool_Exp>;
};


export type Subscription_RootSelectAggregateTaxRateAs400Args = {
  distinct_on?: InputMaybe<Array<TaxRateAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxRateAs400_Order_By>>;
  where?: InputMaybe<TaxRateAs400_Bool_Exp>;
};


export type Subscription_RootSelectAlertArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAlertAcknowledgmentArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAlertAcknowledgmentAggregateArgs = {
  distinct_on?: InputMaybe<Array<AlertAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertAcknowledgment_Order_By>>;
  where?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
};


export type Subscription_RootSelectAlertAcknowledgmentStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AlertAcknowledgment_Stream_Cursor_Input>>;
  where?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
};


export type Subscription_RootSelectAlertAcknowledgmentsArgs = {
  distinct_on?: InputMaybe<Array<AlertAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertAcknowledgment_Order_By>>;
  where?: InputMaybe<AlertAcknowledgment_Bool_Exp>;
};


export type Subscription_RootSelectAlertAggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Order_By>>;
  where?: InputMaybe<Alert_Bool_Exp>;
};


export type Subscription_RootSelectAlertStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Alert_Stream_Cursor_Input>>;
  where?: InputMaybe<Alert_Bool_Exp>;
};


export type Subscription_RootSelectAlertsArgs = {
  distinct_on?: InputMaybe<Array<Alert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Order_By>>;
  where?: InputMaybe<Alert_Bool_Exp>;
};


export type Subscription_RootSelectApplicationArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectApplicationAggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootSelectApplicationPreferenceArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectApplicationPreferenceAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationPreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationPreference_Order_By>>;
  where?: InputMaybe<ApplicationPreference_Bool_Exp>;
};


export type Subscription_RootSelectApplicationPreferenceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApplicationPreference_Stream_Cursor_Input>>;
  where?: InputMaybe<ApplicationPreference_Bool_Exp>;
};


export type Subscription_RootSelectApplicationPreferencesArgs = {
  distinct_on?: InputMaybe<Array<ApplicationPreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationPreference_Order_By>>;
  where?: InputMaybe<ApplicationPreference_Bool_Exp>;
};


export type Subscription_RootSelectApplicationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Application_Stream_Cursor_Input>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootSelectApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootSelectApprovalArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectApprovalAggregateArgs = {
  distinct_on?: InputMaybe<Array<Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approval_Order_By>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


export type Subscription_RootSelectApprovalAuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<ApprovalAuthority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalAuthority_Order_By>>;
  where?: InputMaybe<ApprovalAuthority_Bool_Exp>;
};


export type Subscription_RootSelectApprovalAuthorityArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectApprovalAuthorityAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalAuthority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalAuthority_Order_By>>;
  where?: InputMaybe<ApprovalAuthority_Bool_Exp>;
};


export type Subscription_RootSelectApprovalGateArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectApprovalGateAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGate_Order_By>>;
  where?: InputMaybe<ApprovalGate_Bool_Exp>;
};


export type Subscription_RootSelectApprovalGateBindingArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectApprovalGateBindingAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGateBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGateBinding_Order_By>>;
  where?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
};


export type Subscription_RootSelectApprovalGateBindingsArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGateBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGateBinding_Order_By>>;
  where?: InputMaybe<ApprovalGateBinding_Bool_Exp>;
};


export type Subscription_RootSelectApprovalGatesArgs = {
  distinct_on?: InputMaybe<Array<ApprovalGate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalGate_Order_By>>;
  where?: InputMaybe<ApprovalGate_Bool_Exp>;
};


export type Subscription_RootSelectApprovalRecordsArgs = {
  distinct_on?: InputMaybe<Array<Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approval_Order_By>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


export type Subscription_RootSelectApprovalRequestArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectApprovalRequestAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalRequest_Order_By>>;
  where?: InputMaybe<ApprovalRequest_Bool_Exp>;
};


export type Subscription_RootSelectApprovalRequestsArgs = {
  distinct_on?: InputMaybe<Array<ApprovalRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalRequest_Order_By>>;
  where?: InputMaybe<ApprovalRequest_Bool_Exp>;
};


export type Subscription_RootSelectApprovalStateAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovalState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalState_Order_By>>;
  where?: InputMaybe<ApprovalState_Bool_Exp>;
};


export type Subscription_RootSelectApprovalStatesArgs = {
  distinct_on?: InputMaybe<Array<ApprovalState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovalState_Order_By>>;
  where?: InputMaybe<ApprovalState_Bool_Exp>;
};


export type Subscription_RootSelectAs400DataSyncArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectAs400DataSyncsArgs = {
  distinct_on?: InputMaybe<Array<As400DataSync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As400DataSync_Order_By>>;
  where?: InputMaybe<As400DataSync_Bool_Exp>;
};


export type Subscription_RootSelectAs400DataSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<As400DataSync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As400DataSync_Order_By>>;
  where?: InputMaybe<As400DataSync_Bool_Exp>;
};


export type Subscription_RootSelectBankAccountTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectBankAccountTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<BankAccountType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BankAccountType_Order_By>>;
  where?: InputMaybe<BankAccountType_Bool_Exp>;
};


export type Subscription_RootSelectBankAccountTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BankAccountType_Stream_Cursor_Input>>;
  where?: InputMaybe<BankAccountType_Bool_Exp>;
};


export type Subscription_RootSelectBankAccountTypesArgs = {
  distinct_on?: InputMaybe<Array<BankAccountType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BankAccountType_Order_By>>;
  where?: InputMaybe<BankAccountType_Bool_Exp>;
};


export type Subscription_RootSelectCaddyArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCaddyAggregateArgs = {
  distinct_on?: InputMaybe<Array<Caddy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caddy_Order_By>>;
  where?: InputMaybe<Caddy_Bool_Exp>;
};


export type Subscription_RootSelectCaddyServerManagerLogArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCaddyServerManagerLogAggregateArgs = {
  distinct_on?: InputMaybe<Array<CaddyServerManagerLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CaddyServerManagerLog_Order_By>>;
  where?: InputMaybe<CaddyServerManagerLog_Bool_Exp>;
};


export type Subscription_RootSelectCaddyServerManagerLogsArgs = {
  distinct_on?: InputMaybe<Array<CaddyServerManagerLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CaddyServerManagerLog_Order_By>>;
  where?: InputMaybe<CaddyServerManagerLog_Bool_Exp>;
};


export type Subscription_RootSelectCaddysArgs = {
  distinct_on?: InputMaybe<Array<Caddy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caddy_Order_By>>;
  where?: InputMaybe<Caddy_Bool_Exp>;
};


export type Subscription_RootSelectCancelQuoteListViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelQuoteListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelQuoteListView_Order_By>>;
  where?: InputMaybe<CancelQuoteListView_Bool_Exp>;
};


export type Subscription_RootSelectCancelQuoteListViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CancelQuoteListView_Stream_Cursor_Input>>;
  where?: InputMaybe<CancelQuoteListView_Bool_Exp>;
};


export type Subscription_RootSelectCancelQuoteListViewsArgs = {
  distinct_on?: InputMaybe<Array<CancelQuoteListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelQuoteListView_Order_By>>;
  where?: InputMaybe<CancelQuoteListView_Bool_Exp>;
};


export type Subscription_RootSelectCancelRuleArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCancelRuleAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRule_Order_By>>;
  where?: InputMaybe<CancelRule_Bool_Exp>;
};


export type Subscription_RootSelectCancelRuleFeeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCancelRuleFeeAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleFee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleFee_Order_By>>;
  where?: InputMaybe<CancelRuleFee_Bool_Exp>;
};


export type Subscription_RootSelectCancelRuleFeeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CancelRuleFee_Stream_Cursor_Input>>;
  where?: InputMaybe<CancelRuleFee_Bool_Exp>;
};


export type Subscription_RootSelectCancelRuleFeesArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleFee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleFee_Order_By>>;
  where?: InputMaybe<CancelRuleFee_Bool_Exp>;
};


export type Subscription_RootSelectCancelRuleRefundArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCancelRuleRefundAggregateArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleRefund_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleRefund_Order_By>>;
  where?: InputMaybe<CancelRuleRefund_Bool_Exp>;
};


export type Subscription_RootSelectCancelRuleRefundStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CancelRuleRefund_Stream_Cursor_Input>>;
  where?: InputMaybe<CancelRuleRefund_Bool_Exp>;
};


export type Subscription_RootSelectCancelRuleRefundsArgs = {
  distinct_on?: InputMaybe<Array<CancelRuleRefund_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRuleRefund_Order_By>>;
  where?: InputMaybe<CancelRuleRefund_Bool_Exp>;
};


export type Subscription_RootSelectCancelRuleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CancelRule_Stream_Cursor_Input>>;
  where?: InputMaybe<CancelRule_Bool_Exp>;
};


export type Subscription_RootSelectCancelRulesArgs = {
  distinct_on?: InputMaybe<Array<CancelRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancelRule_Order_By>>;
  where?: InputMaybe<CancelRule_Bool_Exp>;
};


export type Subscription_RootSelectCancellationArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCancellationAggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancellation_Order_By>>;
  where?: InputMaybe<Cancellation_Bool_Exp>;
};


export type Subscription_RootSelectCancellationAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCancellationAs400AggregateArgs = {
  distinct_on?: InputMaybe<Array<CancellationAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationAs400_Order_By>>;
  where?: InputMaybe<CancellationAs400_Bool_Exp>;
};


export type Subscription_RootSelectCancellationAs400StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CancellationAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<CancellationAs400_Bool_Exp>;
};


export type Subscription_RootSelectCancellationAs400sArgs = {
  distinct_on?: InputMaybe<Array<CancellationAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CancellationAs400_Order_By>>;
  where?: InputMaybe<CancellationAs400_Bool_Exp>;
};


export type Subscription_RootSelectCancellationsArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancellation_Order_By>>;
  where?: InputMaybe<Cancellation_Bool_Exp>;
};


export type Subscription_RootSelectCapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Capability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Capability_Order_By>>;
  where?: InputMaybe<Capability_Bool_Exp>;
};


export type Subscription_RootSelectCapabilityArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCapabilityAggregateArgs = {
  distinct_on?: InputMaybe<Array<Capability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Capability_Order_By>>;
  where?: InputMaybe<Capability_Bool_Exp>;
};


export type Subscription_RootSelectCapabilityConfigArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCapabilityConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<CapabilityConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityConfig_Order_By>>;
  where?: InputMaybe<CapabilityConfig_Bool_Exp>;
};


export type Subscription_RootSelectCapabilityConfigsArgs = {
  distinct_on?: InputMaybe<Array<CapabilityConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityConfig_Order_By>>;
  where?: InputMaybe<CapabilityConfig_Bool_Exp>;
};


export type Subscription_RootSelectCapabilityRouteArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCapabilityRouteAggregateArgs = {
  distinct_on?: InputMaybe<Array<CapabilityRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityRoute_Order_By>>;
  where?: InputMaybe<CapabilityRoute_Bool_Exp>;
};


export type Subscription_RootSelectCapabilityRoutesArgs = {
  distinct_on?: InputMaybe<Array<CapabilityRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CapabilityRoute_Order_By>>;
  where?: InputMaybe<CapabilityRoute_Bool_Exp>;
};


export type Subscription_RootSelectCardLayoutArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCardLayoutAggregateArgs = {
  distinct_on?: InputMaybe<Array<CardLayout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CardLayout_Order_By>>;
  where?: InputMaybe<CardLayout_Bool_Exp>;
};


export type Subscription_RootSelectCardLayoutStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CardLayout_Stream_Cursor_Input>>;
  where?: InputMaybe<CardLayout_Bool_Exp>;
};


export type Subscription_RootSelectCardLayoutsArgs = {
  distinct_on?: InputMaybe<Array<CardLayout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CardLayout_Order_By>>;
  where?: InputMaybe<CardLayout_Bool_Exp>;
};


export type Subscription_RootSelectCarrierArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCarrierAggregateArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Subscription_RootSelectCarriersArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Subscription_RootSelectCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootSelectCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootSelectCategoryArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCategoryClassGuidesArgs = {
  distinct_on?: InputMaybe<Array<CategoryClassGuide_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CategoryClassGuide_Order_By>>;
  where?: InputMaybe<CategoryClassGuide_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootSelectCategoryProductAttributeTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCategoryProductAttributeTypesArgs = {
  distinct_on?: InputMaybe<Array<CategoryProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CategoryProductAttributeType_Order_By>>;
  where?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
};


export type Subscription_RootSelectCategoryProductAttributeTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CategoryProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CategoryProductAttributeType_Order_By>>;
  where?: InputMaybe<CategoryProductAttributeType_Bool_Exp>;
};


export type Subscription_RootSelectClaimArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClaimAggregateArgs = {
  distinct_on?: InputMaybe<Array<Claim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claim_Order_By>>;
  where?: InputMaybe<Claim_Bool_Exp>;
};


export type Subscription_RootSelectClaimDetailArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClaimDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


export type Subscription_RootSelectClaimDetailAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClaimDetailAs400sArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailAs400_Order_By>>;
  where?: InputMaybe<ClaimDetailAs400_Bool_Exp>;
};


export type Subscription_RootSelectClaimDetailCategoriesArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailCategory_Order_By>>;
  where?: InputMaybe<ClaimDetailCategory_Bool_Exp>;
};


export type Subscription_RootSelectClaimDetailCategoryArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClaimDetailCategoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailCategory_Order_By>>;
  where?: InputMaybe<ClaimDetailCategory_Bool_Exp>;
};


export type Subscription_RootSelectClaimDetailDeductionAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClaimDetailDeductionAs400sArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailDeductionAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailDeductionAs400_Order_By>>;
  where?: InputMaybe<ClaimDetailDeductionAs400_Bool_Exp>;
};


export type Subscription_RootSelectClaimDetailPartLookupArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClaimDetailPartLookupAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailPartLookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailPartLookup_Order_By>>;
  where?: InputMaybe<ClaimDetailPartLookup_Bool_Exp>;
};


export type Subscription_RootSelectClaimDetailPartLookupsArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetailPartLookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetailPartLookup_Order_By>>;
  where?: InputMaybe<ClaimDetailPartLookup_Bool_Exp>;
};


export type Subscription_RootSelectClaimDetailsArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


export type Subscription_RootSelectClaimPartAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimPart_Order_By>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};


export type Subscription_RootSelectClaimPartsArgs = {
  distinct_on?: InputMaybe<Array<ClaimPart_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimPart_Order_By>>;
  where?: InputMaybe<ClaimPart_Bool_Exp>;
};


export type Subscription_RootSelectClaimServiceCenterArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClaimServiceCenterAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenter_Order_By>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


export type Subscription_RootSelectClaimServiceCenterAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClaimServiceCenterAs400sArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenterAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenterAs400_Order_By>>;
  where?: InputMaybe<ClaimServiceCenterAs400_Bool_Exp>;
};


export type Subscription_RootSelectClaimServiceCenterAuthorizationArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClaimServiceCenterAuthorizationAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenterAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenterAuthorization_Order_By>>;
  where?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
};


export type Subscription_RootSelectClaimServiceCenterAuthorizationsArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenterAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenterAuthorization_Order_By>>;
  where?: InputMaybe<ClaimServiceCenterAuthorization_Bool_Exp>;
};


export type Subscription_RootSelectClaimServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenter_Order_By>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


export type Subscription_RootSelectClaimStatusArgs = {
  ClaimStatusCode: Scalars['String'];
};


export type Subscription_RootSelectClaimStatusAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimStatus_Order_By>>;
  where?: InputMaybe<ClaimStatus_Bool_Exp>;
};


export type Subscription_RootSelectClaimStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClaimStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimStatusType_Order_By>>;
  where?: InputMaybe<ClaimStatusType_Bool_Exp>;
};


export type Subscription_RootSelectClaimStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<ClaimStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimStatusType_Order_By>>;
  where?: InputMaybe<ClaimStatusType_Bool_Exp>;
};


export type Subscription_RootSelectClaimStatusesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimStatus_Order_By>>;
  where?: InputMaybe<ClaimStatus_Bool_Exp>;
};


export type Subscription_RootSelectClaimsArgs = {
  distinct_on?: InputMaybe<Array<Claim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Claim_Order_By>>;
  where?: InputMaybe<Claim_Bool_Exp>;
};


export type Subscription_RootSelectClaimsMasterAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimsMaster_Order_By>>;
  where?: InputMaybe<ClaimsMaster_Bool_Exp>;
};


export type Subscription_RootSelectClaimsMastersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimsMaster_Order_By>>;
  where?: InputMaybe<ClaimsMaster_Bool_Exp>;
};


export type Subscription_RootSelectClassCriteriaArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClassCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteria_Bool_Exp>;
};


export type Subscription_RootSelectClassCriteriaViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaView_Order_By>>;
  where?: InputMaybe<ClassCriteriaView_Bool_Exp>;
};


export type Subscription_RootSelectClassCriteriaViewDefaultVehicleCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootSelectClassCriteriaViewDefaultVehicleCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootSelectClassCriteriaViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClassCriteriaView_Stream_Cursor_Input>>;
  where?: InputMaybe<ClassCriteriaView_Bool_Exp>;
};


export type Subscription_RootSelectClassCriteriaViewUnclassedDefaultVehicleCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootSelectClassCriteriaViewUnclassedDefaultVehicleCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteriaViewUnclassedDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootSelectClassCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteria_Order_By>>;
  where?: InputMaybe<ClassCriteria_Bool_Exp>;
};


export type Subscription_RootSelectClassCriteriasViewArgs = {
  distinct_on?: InputMaybe<Array<ClassCriteriaView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassCriteriaView_Order_By>>;
  where?: InputMaybe<ClassCriteriaView_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClassGuideAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuide_Order_By>>;
  where?: InputMaybe<ClassGuide_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideClassCriteriaArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClassGuideClassCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideClassCriteriaViewDefaultVehicleCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideClassCriteriaViewDefaultVehicleCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideClassCriteriaViewVinAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteriaViewVin_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideClassCriteriaViewVinsArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteriaViewVin_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteriaViewVin_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideClassCriteriasArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideClassCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideClassCriteria_Order_By>>;
  where?: InputMaybe<ClassGuideClassCriteria_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideCriteriaDefinitionArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClassGuideCriteriaDefinitionAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaDefinition_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideCriteriaDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaDefinition_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaDefinition_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideCriteriaTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectClassGuideCriteriaTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaType_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaType_Bool_Exp>;
};


export type Subscription_RootSelectClassGuideCriteriaTypesArgs = {
  distinct_on?: InputMaybe<Array<ClassGuideCriteriaType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuideCriteriaType_Order_By>>;
  where?: InputMaybe<ClassGuideCriteriaType_Bool_Exp>;
};


export type Subscription_RootSelectClassGuidesArgs = {
  distinct_on?: InputMaybe<Array<ClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClassGuide_Order_By>>;
  where?: InputMaybe<ClassGuide_Bool_Exp>;
};


export type Subscription_RootSelectCompositeProductArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCompositeProductsArgs = {
  distinct_on?: InputMaybe<Array<CompositeProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompositeProduct_Order_By>>;
  where?: InputMaybe<CompositeProduct_Bool_Exp>;
};


export type Subscription_RootSelectConfigurationItemArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectConfigurationItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigurationItem_Order_By>>;
  where?: InputMaybe<ConfigurationItem_Bool_Exp>;
};


export type Subscription_RootSelectConfigurationItemTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectConfigurationItemTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigurationItemType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigurationItemType_Order_By>>;
  where?: InputMaybe<ConfigurationItemType_Bool_Exp>;
};


export type Subscription_RootSelectConfigurationItemTypesArgs = {
  distinct_on?: InputMaybe<Array<ConfigurationItemType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigurationItemType_Order_By>>;
  where?: InputMaybe<ConfigurationItemType_Bool_Exp>;
};


export type Subscription_RootSelectConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<ConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigurationItem_Order_By>>;
  where?: InputMaybe<ConfigurationItem_Bool_Exp>;
};


export type Subscription_RootSelectContactArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectContactAggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootSelectContactsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootSelectContentTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectContentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentType_Order_By>>;
  where?: InputMaybe<ContentType_Bool_Exp>;
};


export type Subscription_RootSelectContentTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentType_Stream_Cursor_Input>>;
  where?: InputMaybe<ContentType_Bool_Exp>;
};


export type Subscription_RootSelectContentTypesArgs = {
  distinct_on?: InputMaybe<Array<ContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentType_Order_By>>;
  where?: InputMaybe<ContentType_Bool_Exp>;
};


export type Subscription_RootSelectContractArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectContractAggregateArgs = {
  distinct_on?: InputMaybe<Array<Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contract_Order_By>>;
  where?: InputMaybe<Contract_Bool_Exp>;
};


export type Subscription_RootSelectContractFormArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectContractFormAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractForm_Order_By>>;
  where?: InputMaybe<ContractForm_Bool_Exp>;
};


export type Subscription_RootSelectContractFormFilingStatusArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectContractFormFilingStatusAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


export type Subscription_RootSelectContractFormFilingStatusesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormFilingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormFilingStatus_Order_By>>;
  where?: InputMaybe<ContractFormFilingStatus_Bool_Exp>;
};


export type Subscription_RootSelectContractFormTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectContractFormTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormType_Order_By>>;
  where?: InputMaybe<ContractFormType_Bool_Exp>;
};


export type Subscription_RootSelectContractFormTypesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormType_Order_By>>;
  where?: InputMaybe<ContractFormType_Bool_Exp>;
};


export type Subscription_RootSelectContractFormVersionArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectContractFormVersionAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersion_Order_By>>;
  where?: InputMaybe<ContractFormVersion_Bool_Exp>;
};


export type Subscription_RootSelectContractFormVersionLegacyFileArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectContractFormVersionLegacyFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersionLegacyFile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersionLegacyFile_Order_By>>;
  where?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
};


export type Subscription_RootSelectContractFormVersionLegacyFileStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContractFormVersionLegacyFile_Stream_Cursor_Input>>;
  where?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
};


export type Subscription_RootSelectContractFormVersionLegacyFilesArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersionLegacyFile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersionLegacyFile_Order_By>>;
  where?: InputMaybe<ContractFormVersionLegacyFile_Bool_Exp>;
};


export type Subscription_RootSelectContractFormVersionsArgs = {
  distinct_on?: InputMaybe<Array<ContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractFormVersion_Order_By>>;
  where?: InputMaybe<ContractFormVersion_Bool_Exp>;
};


export type Subscription_RootSelectContractFormsArgs = {
  distinct_on?: InputMaybe<Array<ContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractForm_Order_By>>;
  where?: InputMaybe<ContractForm_Bool_Exp>;
};


export type Subscription_RootSelectContractMasterArgs = {
  ContractMasterID: Scalars['Int'];
};


export type Subscription_RootSelectContractMasterAdditionalEntiiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterAdditionalEntity_Order_By>>;
  where?: InputMaybe<ContractMasterAdditionalEntity_Bool_Exp>;
};


export type Subscription_RootSelectContractMasterAdditionalEntityAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMasterAdditionalEntity_Order_By>>;
  where?: InputMaybe<ContractMasterAdditionalEntity_Bool_Exp>;
};


export type Subscription_RootSelectContractMasterAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMaster_Order_By>>;
  where?: InputMaybe<ContractMaster_Bool_Exp>;
};


export type Subscription_RootSelectContractMastersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractMaster_Order_By>>;
  where?: InputMaybe<ContractMaster_Bool_Exp>;
};


export type Subscription_RootSelectContractStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectContractStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContractStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractStatusType_Order_By>>;
  where?: InputMaybe<ContractStatusType_Bool_Exp>;
};


export type Subscription_RootSelectContractStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<ContractStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContractStatusType_Order_By>>;
  where?: InputMaybe<ContractStatusType_Bool_Exp>;
};


export type Subscription_RootSelectContractsArgs = {
  distinct_on?: InputMaybe<Array<Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contract_Order_By>>;
  where?: InputMaybe<Contract_Bool_Exp>;
};


export type Subscription_RootSelectCostAdjustmentArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCostAdjustmentAggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustment_Order_By>>;
  where?: InputMaybe<CostAdjustment_Bool_Exp>;
};


export type Subscription_RootSelectCostAdjustmentExtendedCostArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCostAdjustmentExtendedCostAggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentExtendedCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentExtendedCost_Order_By>>;
  where?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
};


export type Subscription_RootSelectCostAdjustmentExtendedCostsArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentExtendedCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentExtendedCost_Order_By>>;
  where?: InputMaybe<CostAdjustmentExtendedCost_Bool_Exp>;
};


export type Subscription_RootSelectCostAdjustmentLookupArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCostAdjustmentLookupAggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentLookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentLookup_Order_By>>;
  where?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
};


export type Subscription_RootSelectCostAdjustmentLookupsArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentLookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentLookup_Order_By>>;
  where?: InputMaybe<CostAdjustmentLookup_Bool_Exp>;
};


export type Subscription_RootSelectCostAdjustmentTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectCostAdjustmentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentType_Order_By>>;
  where?: InputMaybe<CostAdjustmentType_Bool_Exp>;
};


export type Subscription_RootSelectCostAdjustmentTypesArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustmentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustmentType_Order_By>>;
  where?: InputMaybe<CostAdjustmentType_Bool_Exp>;
};


export type Subscription_RootSelectCostAdjustmentsArgs = {
  distinct_on?: InputMaybe<Array<CostAdjustment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CostAdjustment_Order_By>>;
  where?: InputMaybe<CostAdjustment_Bool_Exp>;
};


export type Subscription_RootSelectCustomFieldArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCustomFieldDataArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCustomFieldDataAggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomFieldData_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomFieldData_Order_By>>;
  where?: InputMaybe<CustomFieldData_Bool_Exp>;
};


export type Subscription_RootSelectCustomFieldDatasArgs = {
  distinct_on?: InputMaybe<Array<CustomFieldData_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomFieldData_Order_By>>;
  where?: InputMaybe<CustomFieldData_Bool_Exp>;
};


export type Subscription_RootSelectCustomFieldTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCustomFieldTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomFieldType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomFieldType_Order_By>>;
  where?: InputMaybe<CustomFieldType_Bool_Exp>;
};


export type Subscription_RootSelectCustomFieldTypesArgs = {
  distinct_on?: InputMaybe<Array<CustomFieldType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomFieldType_Order_By>>;
  where?: InputMaybe<CustomFieldType_Bool_Exp>;
};


export type Subscription_RootSelectCustomFieldsArgs = {
  distinct_on?: InputMaybe<Array<CustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomField_Order_By>>;
  where?: InputMaybe<CustomField_Bool_Exp>;
};


export type Subscription_RootSelectCustomFieldsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomField_Order_By>>;
  where?: InputMaybe<CustomField_Bool_Exp>;
};


export type Subscription_RootSelectCustomerArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCustomerAggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootSelectCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootSelectCycleArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCycleAggregateArgs = {
  distinct_on?: InputMaybe<Array<Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cycle_Order_By>>;
  where?: InputMaybe<Cycle_Bool_Exp>;
};


export type Subscription_RootSelectCycleJournalEntriesArgs = {
  distinct_on?: InputMaybe<Array<CycleJournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleJournalEntry_Order_By>>;
  where?: InputMaybe<CycleJournalEntry_Bool_Exp>;
};


export type Subscription_RootSelectCycleJournalEntryArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCycleJournalEntryAggregateArgs = {
  distinct_on?: InputMaybe<Array<CycleJournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleJournalEntry_Order_By>>;
  where?: InputMaybe<CycleJournalEntry_Bool_Exp>;
};


export type Subscription_RootSelectCycleJournalEntryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CycleJournalEntry_Stream_Cursor_Input>>;
  where?: InputMaybe<CycleJournalEntry_Bool_Exp>;
};


export type Subscription_RootSelectCycleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cycle_Stream_Cursor_Input>>;
  where?: InputMaybe<Cycle_Bool_Exp>;
};


export type Subscription_RootSelectCycleTotalArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectCycleTotalAggregateArgs = {
  distinct_on?: InputMaybe<Array<CycleTotal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleTotal_Order_By>>;
  where?: InputMaybe<CycleTotal_Bool_Exp>;
};


export type Subscription_RootSelectCycleTotalStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CycleTotal_Stream_Cursor_Input>>;
  where?: InputMaybe<CycleTotal_Bool_Exp>;
};


export type Subscription_RootSelectCycleTotalsArgs = {
  distinct_on?: InputMaybe<Array<CycleTotal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CycleTotal_Order_By>>;
  where?: InputMaybe<CycleTotal_Bool_Exp>;
};


export type Subscription_RootSelectCyclesArgs = {
  distinct_on?: InputMaybe<Array<Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cycle_Order_By>>;
  where?: InputMaybe<Cycle_Bool_Exp>;
};


export type Subscription_RootSelectDataTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectDataTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<DataType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DataType_Order_By>>;
  where?: InputMaybe<DataType_Bool_Exp>;
};


export type Subscription_RootSelectDataTypesArgs = {
  distinct_on?: InputMaybe<Array<DataType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DataType_Order_By>>;
  where?: InputMaybe<DataType_Bool_Exp>;
};


export type Subscription_RootSelectDateCalculationTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectDateCalculationTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<DateCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DateCalculationType_Order_By>>;
  where?: InputMaybe<DateCalculationType_Bool_Exp>;
};


export type Subscription_RootSelectDateCalculationTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DateCalculationType_Stream_Cursor_Input>>;
  where?: InputMaybe<DateCalculationType_Bool_Exp>;
};


export type Subscription_RootSelectDateCalculationTypesArgs = {
  distinct_on?: InputMaybe<Array<DateCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DateCalculationType_Order_By>>;
  where?: InputMaybe<DateCalculationType_Bool_Exp>;
};


export type Subscription_RootSelectDealerArgs = {
  DealerID: Scalars['Int'];
};


export type Subscription_RootSelectDealerAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dealer_Order_By>>;
  where?: InputMaybe<Dealer_Bool_Exp>;
};


export type Subscription_RootSelectDealerAlertAggregateArgs = {
  distinct_on?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Order_By>>;
  where?: InputMaybe<Shared_Dealer_Alert_List_View_Bool_Exp>;
};


export type Subscription_RootSelectDealerAlertsArgs = {
  distinct_on?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Dealer_Alert_List_View_Order_By>>;
  where?: InputMaybe<Shared_Dealer_Alert_List_View_Bool_Exp>;
};


export type Subscription_RootSelectDealerPaymentTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectDealerPaymentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<DealerPaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DealerPaymentType_Order_By>>;
  where?: InputMaybe<DealerPaymentType_Bool_Exp>;
};


export type Subscription_RootSelectDealerPaymentTypesArgs = {
  distinct_on?: InputMaybe<Array<DealerPaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DealerPaymentType_Order_By>>;
  where?: InputMaybe<DealerPaymentType_Bool_Exp>;
};


export type Subscription_RootSelectDealersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dealer_Order_By>>;
  where?: InputMaybe<Dealer_Bool_Exp>;
};


export type Subscription_RootSelectDisbursementTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectDisbursementTypesArgs = {
  distinct_on?: InputMaybe<Array<DisbursementType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DisbursementType_Order_By>>;
  where?: InputMaybe<DisbursementType_Bool_Exp>;
};


export type Subscription_RootSelectDisbursementTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DisbursementType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DisbursementType_Order_By>>;
  where?: InputMaybe<DisbursementType_Bool_Exp>;
};


export type Subscription_RootSelectDocumentArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectDocumentAggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootSelectDocumentInstanceArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectDocumentInstanceAggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentInstance_Order_By>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


export type Subscription_RootSelectDocumentInstanceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DocumentInstance_Stream_Cursor_Input>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


export type Subscription_RootSelectDocumentInstancesArgs = {
  distinct_on?: InputMaybe<Array<DocumentInstance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentInstance_Order_By>>;
  where?: InputMaybe<DocumentInstance_Bool_Exp>;
};


export type Subscription_RootSelectDocumentTemplateArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectDocumentTemplateAggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplate_Order_By>>;
  where?: InputMaybe<DocumentTemplate_Bool_Exp>;
};


export type Subscription_RootSelectDocumentTemplateApplicationArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectDocumentTemplateApplicationAggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplateApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplateApplication_Order_By>>;
  where?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
};


export type Subscription_RootSelectDocumentTemplateApplicationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DocumentTemplateApplication_Stream_Cursor_Input>>;
  where?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
};


export type Subscription_RootSelectDocumentTemplateApplicationsArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplateApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplateApplication_Order_By>>;
  where?: InputMaybe<DocumentTemplateApplication_Bool_Exp>;
};


export type Subscription_RootSelectDocumentTemplateStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DocumentTemplate_Stream_Cursor_Input>>;
  where?: InputMaybe<DocumentTemplate_Bool_Exp>;
};


export type Subscription_RootSelectDocumentTemplatesArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplate_Order_By>>;
  where?: InputMaybe<DocumentTemplate_Bool_Exp>;
};


export type Subscription_RootSelectDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootSelectEligibilityRuleArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEligibilityRuleAggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRule_Order_By>>;
  where?: InputMaybe<EligibilityRule_Bool_Exp>;
};


export type Subscription_RootSelectEligibilityRuleDefinitionArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEligibilityRuleDefinitionAggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRuleDefinition_Order_By>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};


export type Subscription_RootSelectEligibilityRuleDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRuleDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRuleDefinition_Order_By>>;
  where?: InputMaybe<EligibilityRuleDefinition_Bool_Exp>;
};


export type Subscription_RootSelectEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityRule_Order_By>>;
  where?: InputMaybe<EligibilityRule_Bool_Exp>;
};


export type Subscription_RootSelectEligibilityTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectEligibilityTypesArgs = {
  distinct_on?: InputMaybe<Array<EligibilityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityType_Order_By>>;
  where?: InputMaybe<EligibilityType_Bool_Exp>;
};


export type Subscription_RootSelectEligibilityTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EligibilityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EligibilityType_Order_By>>;
  where?: InputMaybe<EligibilityType_Bool_Exp>;
};


export type Subscription_RootSelectEntityBillingInformationArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityBillingInformationAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityBillingInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityBillingInformation_Order_By>>;
  where?: InputMaybe<EntityBillingInformation_Bool_Exp>;
};


export type Subscription_RootSelectEntityBillingInformationsArgs = {
  distinct_on?: InputMaybe<Array<EntityBillingInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityBillingInformation_Order_By>>;
  where?: InputMaybe<EntityBillingInformation_Bool_Exp>;
};


export type Subscription_RootSelectEntityConfigurationItemArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityConfigurationItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


export type Subscription_RootSelectEntityConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


export type Subscription_RootSelectEntityContentTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityContentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityContentType_Order_By>>;
  where?: InputMaybe<EntityContentType_Bool_Exp>;
};


export type Subscription_RootSelectEntityContentTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityContentType_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityContentType_Bool_Exp>;
};


export type Subscription_RootSelectEntityContentTypesArgs = {
  distinct_on?: InputMaybe<Array<EntityContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityContentType_Order_By>>;
  where?: InputMaybe<EntityContentType_Bool_Exp>;
};


export type Subscription_RootSelectEntityCustomFieldArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityCustomFieldValueArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityCustomFieldValueAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomFieldValue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomFieldValue_Order_By>>;
  where?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
};


export type Subscription_RootSelectEntityCustomFieldValuesArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomFieldValue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomFieldValue_Order_By>>;
  where?: InputMaybe<EntityCustomFieldValue_Bool_Exp>;
};


export type Subscription_RootSelectEntityCustomFieldsArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomField_Order_By>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


export type Subscription_RootSelectEntityCustomFieldsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityCustomField_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityCustomField_Order_By>>;
  where?: InputMaybe<EntityCustomField_Bool_Exp>;
};


export type Subscription_RootSelectEntityDataDefinitionArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityDataDefinitionAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityDataDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityDataDefinition_Order_By>>;
  where?: InputMaybe<EntityDataDefinition_Bool_Exp>;
};


export type Subscription_RootSelectEntityDataDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<EntityDataDefinition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityDataDefinition_Order_By>>;
  where?: InputMaybe<EntityDataDefinition_Bool_Exp>;
};


export type Subscription_RootSelectEntityEligibilityRuleArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityEligibilityRuleAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


export type Subscription_RootSelectEntityEligibilityRulesArgs = {
  distinct_on?: InputMaybe<Array<EntityEligibilityRule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityEligibilityRule_Order_By>>;
  where?: InputMaybe<EntityEligibilityRule_Bool_Exp>;
};


export type Subscription_RootSelectEntityFeatureArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityFeatureAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


export type Subscription_RootSelectEntityFeatureStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityFeature_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


export type Subscription_RootSelectEntityFeaturesArgs = {
  distinct_on?: InputMaybe<Array<EntityFeature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFeature_Order_By>>;
  where?: InputMaybe<EntityFeature_Bool_Exp>;
};


export type Subscription_RootSelectEntityFileContentTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityFileContentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileContentType_Order_By>>;
  where?: InputMaybe<EntityFileContentType_Bool_Exp>;
};


export type Subscription_RootSelectEntityFileContentTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EntityFileContentType_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityFileContentType_Bool_Exp>;
};


export type Subscription_RootSelectEntityFileContentTypesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileContentType_Order_By>>;
  where?: InputMaybe<EntityFileContentType_Bool_Exp>;
};


export type Subscription_RootSelectEntityFileStorageArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityFileStorageAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


export type Subscription_RootSelectEntityFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<EntityFileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityFileStorage_Order_By>>;
  where?: InputMaybe<EntityFileStorage_Bool_Exp>;
};


export type Subscription_RootSelectEntityNoteArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityNoteAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


export type Subscription_RootSelectEntityNoteCapabilityViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityNoteCapabilityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNoteCapabilityView_Order_By>>;
  where?: InputMaybe<EntityNoteCapabilityView_Bool_Exp>;
};


export type Subscription_RootSelectEntityNoteCapabilityViewsArgs = {
  distinct_on?: InputMaybe<Array<EntityNoteCapabilityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNoteCapabilityView_Order_By>>;
  where?: InputMaybe<EntityNoteCapabilityView_Bool_Exp>;
};


export type Subscription_RootSelectEntityNotesArgs = {
  distinct_on?: InputMaybe<Array<EntityNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityNote_Order_By>>;
  where?: InputMaybe<EntityNote_Bool_Exp>;
};


export type Subscription_RootSelectEntityOfferingArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityOfferingAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


export type Subscription_RootSelectEntityOfferingsArgs = {
  distinct_on?: InputMaybe<Array<EntityOffering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityOffering_Order_By>>;
  where?: InputMaybe<EntityOffering_Bool_Exp>;
};


export type Subscription_RootSelectEntityRemittanceDetailArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityRemittanceDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


export type Subscription_RootSelectEntityRemittanceDetailsArgs = {
  distinct_on?: InputMaybe<Array<EntityRemittanceDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityRemittanceDetail_Order_By>>;
  where?: InputMaybe<EntityRemittanceDetail_Bool_Exp>;
};


export type Subscription_RootSelectEntityTagArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectEntityTagAggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


export type Subscription_RootSelectEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


export type Subscription_RootSelectFeatureArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectFeatureAggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Order_By>>;
  where?: InputMaybe<Feature_Bool_Exp>;
};


export type Subscription_RootSelectFeatureStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feature_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Bool_Exp>;
};


export type Subscription_RootSelectFeaturesArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Order_By>>;
  where?: InputMaybe<Feature_Bool_Exp>;
};


export type Subscription_RootSelectFileStorageArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectFileStorageAggregateArgs = {
  distinct_on?: InputMaybe<Array<FileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileStorage_Order_By>>;
  where?: InputMaybe<FileStorage_Bool_Exp>;
};


export type Subscription_RootSelectFileStorageTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectFileStorageTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<FileStorageType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileStorageType_Order_By>>;
  where?: InputMaybe<FileStorageType_Bool_Exp>;
};


export type Subscription_RootSelectFileStorageTypesArgs = {
  distinct_on?: InputMaybe<Array<FileStorageType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileStorageType_Order_By>>;
  where?: InputMaybe<FileStorageType_Bool_Exp>;
};


export type Subscription_RootSelectFileStoragesArgs = {
  distinct_on?: InputMaybe<Array<FileStorage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FileStorage_Order_By>>;
  where?: InputMaybe<FileStorage_Bool_Exp>;
};


export type Subscription_RootSelectFilingLenderArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectFilingLenderMatchArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectFilingLenderMatchAggregateArgs = {
  distinct_on?: InputMaybe<Array<FilingLenderMatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingLenderMatch_Order_By>>;
  where?: InputMaybe<FilingLenderMatch_Bool_Exp>;
};


export type Subscription_RootSelectFilingLenderMatchStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FilingLenderMatch_Stream_Cursor_Input>>;
  where?: InputMaybe<FilingLenderMatch_Bool_Exp>;
};


export type Subscription_RootSelectFilingLenderMatchesArgs = {
  distinct_on?: InputMaybe<Array<FilingLenderMatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingLenderMatch_Order_By>>;
  where?: InputMaybe<FilingLenderMatch_Bool_Exp>;
};


export type Subscription_RootSelectFilingLendersArgs = {
  distinct_on?: InputMaybe<Array<FilingLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingLender_Order_By>>;
  where?: InputMaybe<FilingLender_Bool_Exp>;
};


export type Subscription_RootSelectFilingStateArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectFilingStateAggregateArgs = {
  distinct_on?: InputMaybe<Array<FilingState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingState_Order_By>>;
  where?: InputMaybe<FilingState_Bool_Exp>;
};


export type Subscription_RootSelectFilingStatesArgs = {
  distinct_on?: InputMaybe<Array<FilingState_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingState_Order_By>>;
  where?: InputMaybe<FilingState_Bool_Exp>;
};


export type Subscription_RootSelectFilingStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectFilingStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<FilingStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingStatusType_Order_By>>;
  where?: InputMaybe<FilingStatusType_Bool_Exp>;
};


export type Subscription_RootSelectFilingStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<FilingStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingStatusType_Order_By>>;
  where?: InputMaybe<FilingStatusType_Bool_Exp>;
};


export type Subscription_RootSelectFlowItemArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectFlowItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItem_Order_By>>;
  where?: InputMaybe<FlowItem_Bool_Exp>;
};


export type Subscription_RootSelectFlowItemStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FlowItem_Stream_Cursor_Input>>;
  where?: InputMaybe<FlowItem_Bool_Exp>;
};


export type Subscription_RootSelectFlowItemTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectFlowItemTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowItemType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItemType_Order_By>>;
  where?: InputMaybe<FlowItemType_Bool_Exp>;
};


export type Subscription_RootSelectFlowItemTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FlowItemType_Stream_Cursor_Input>>;
  where?: InputMaybe<FlowItemType_Bool_Exp>;
};


export type Subscription_RootSelectFlowItemTypesArgs = {
  distinct_on?: InputMaybe<Array<FlowItemType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItemType_Order_By>>;
  where?: InputMaybe<FlowItemType_Bool_Exp>;
};


export type Subscription_RootSelectFlowItemsArgs = {
  distinct_on?: InputMaybe<Array<FlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowItem_Order_By>>;
  where?: InputMaybe<FlowItem_Bool_Exp>;
};


export type Subscription_RootSelectFlowTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectFlowTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<FlowType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowType_Order_By>>;
  where?: InputMaybe<FlowType_Bool_Exp>;
};


export type Subscription_RootSelectFlowTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FlowType_Stream_Cursor_Input>>;
  where?: InputMaybe<FlowType_Bool_Exp>;
};


export type Subscription_RootSelectFlowTypesArgs = {
  distinct_on?: InputMaybe<Array<FlowType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FlowType_Order_By>>;
  where?: InputMaybe<FlowType_Bool_Exp>;
};


export type Subscription_RootSelectIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


export type Subscription_RootSelectIdentitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


export type Subscription_RootSelectIdentitiesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Identity_Stream_Cursor_Input>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


export type Subscription_RootSelectIdentityArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectIdentityAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectIdentityAs400sArgs = {
  distinct_on?: InputMaybe<Array<IdentityAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityAs400_Order_By>>;
  where?: InputMaybe<IdentityAs400_Bool_Exp>;
};


export type Subscription_RootSelectIdentityCapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapability_Order_By>>;
  where?: InputMaybe<IdentityCapability_Bool_Exp>;
};


export type Subscription_RootSelectIdentityCapabilityArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectIdentityCapabilityAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapability_Order_By>>;
  where?: InputMaybe<IdentityCapability_Bool_Exp>;
};


export type Subscription_RootSelectIdentityCapabilityViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapabilityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapabilityView_Order_By>>;
  where?: InputMaybe<IdentityCapabilityView_Bool_Exp>;
};


export type Subscription_RootSelectIdentityCapabilityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityCapabilityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityCapabilityView_Order_By>>;
  where?: InputMaybe<IdentityCapabilityView_Bool_Exp>;
};


export type Subscription_RootSelectIdentityEntitiesArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntity_Order_By>>;
  where?: InputMaybe<IdentityEntity_Bool_Exp>;
};


export type Subscription_RootSelectIdentityEntityArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectIdentityEntityAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntity_Order_By>>;
  where?: InputMaybe<IdentityEntity_Bool_Exp>;
};


export type Subscription_RootSelectIdentityEntityViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


export type Subscription_RootSelectIdentityEntityViewsArgs = {
  distinct_on?: InputMaybe<Array<IdentityEntityView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityEntityView_Order_By>>;
  where?: InputMaybe<IdentityEntityView_Bool_Exp>;
};


export type Subscription_RootSelectIdentityFilterArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectIdentityFilterAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdentityFilter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityFilter_Order_By>>;
  where?: InputMaybe<IdentityFilter_Bool_Exp>;
};


export type Subscription_RootSelectIdentityFilterStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdentityFilter_Stream_Cursor_Input>>;
  where?: InputMaybe<IdentityFilter_Bool_Exp>;
};


export type Subscription_RootSelectIdentityFiltersArgs = {
  distinct_on?: InputMaybe<Array<IdentityFilter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdentityFilter_Order_By>>;
  where?: InputMaybe<IdentityFilter_Bool_Exp>;
};


export type Subscription_RootSelectInvoiceArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectInvoiceAggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootSelectInvoiceDocumentTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectInvoiceDocumentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvoiceDocumentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceDocumentType_Order_By>>;
  where?: InputMaybe<InvoiceDocumentType_Bool_Exp>;
};


export type Subscription_RootSelectInvoiceDocumentTypesArgs = {
  distinct_on?: InputMaybe<Array<InvoiceDocumentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoiceDocumentType_Order_By>>;
  where?: InputMaybe<InvoiceDocumentType_Bool_Exp>;
};


export type Subscription_RootSelectInvoicePaymentTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectInvoicePaymentTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvoicePaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoicePaymentType_Order_By>>;
  where?: InputMaybe<InvoicePaymentType_Bool_Exp>;
};


export type Subscription_RootSelectInvoicePaymentTypesArgs = {
  distinct_on?: InputMaybe<Array<InvoicePaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvoicePaymentType_Order_By>>;
  where?: InputMaybe<InvoicePaymentType_Bool_Exp>;
};


export type Subscription_RootSelectInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootSelectJobArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectJobAggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Order_By>>;
  where?: InputMaybe<Job_Bool_Exp>;
};


export type Subscription_RootSelectJobHistoriesArgs = {
  distinct_on?: InputMaybe<Array<JobHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistory_Order_By>>;
  where?: InputMaybe<JobHistory_Bool_Exp>;
};


export type Subscription_RootSelectJobHistoryArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectJobHistoryAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistory_Order_By>>;
  where?: InputMaybe<JobHistory_Bool_Exp>;
};


export type Subscription_RootSelectJobHistoryLogArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectJobHistoryLogAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobHistoryLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistoryLog_Order_By>>;
  where?: InputMaybe<JobHistoryLog_Bool_Exp>;
};


export type Subscription_RootSelectJobHistoryLogStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JobHistoryLog_Stream_Cursor_Input>>;
  where?: InputMaybe<JobHistoryLog_Bool_Exp>;
};


export type Subscription_RootSelectJobHistoryLogsArgs = {
  distinct_on?: InputMaybe<Array<JobHistoryLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobHistoryLog_Order_By>>;
  where?: InputMaybe<JobHistoryLog_Bool_Exp>;
};


export type Subscription_RootSelectJobHistoryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JobHistory_Stream_Cursor_Input>>;
  where?: InputMaybe<JobHistory_Bool_Exp>;
};


export type Subscription_RootSelectJobListViewsArgs = {
  distinct_on?: InputMaybe<Array<JobListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobListView_Order_By>>;
  where?: InputMaybe<JobListView_Bool_Exp>;
};


export type Subscription_RootSelectJobScheduleArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectJobScheduleAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobSchedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSchedule_Order_By>>;
  where?: InputMaybe<JobSchedule_Bool_Exp>;
};


export type Subscription_RootSelectJobSchedulesArgs = {
  distinct_on?: InputMaybe<Array<JobSchedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSchedule_Order_By>>;
  where?: InputMaybe<JobSchedule_Bool_Exp>;
};


export type Subscription_RootSelectJobStepArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectJobStepAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobStep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobStep_Order_By>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};


export type Subscription_RootSelectJobStepStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JobStep_Stream_Cursor_Input>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};


export type Subscription_RootSelectJobStepsArgs = {
  distinct_on?: InputMaybe<Array<JobStep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobStep_Order_By>>;
  where?: InputMaybe<JobStep_Bool_Exp>;
};


export type Subscription_RootSelectJobStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Bool_Exp>;
};


export type Subscription_RootSelectJobsArgs = {
  distinct_on?: InputMaybe<Array<Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Order_By>>;
  where?: InputMaybe<Job_Bool_Exp>;
};


export type Subscription_RootSelectJournalEntriesArgs = {
  distinct_on?: InputMaybe<Array<JournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntry_Order_By>>;
  where?: InputMaybe<JournalEntry_Bool_Exp>;
};


export type Subscription_RootSelectJournalEntryArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectJournalEntryAggregateArgs = {
  distinct_on?: InputMaybe<Array<JournalEntry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntry_Order_By>>;
  where?: InputMaybe<JournalEntry_Bool_Exp>;
};


export type Subscription_RootSelectJournalEntryLineArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectJournalEntryLineAggregateArgs = {
  distinct_on?: InputMaybe<Array<JournalEntryLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntryLine_Order_By>>;
  where?: InputMaybe<JournalEntryLine_Bool_Exp>;
};


export type Subscription_RootSelectJournalEntryLineStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JournalEntryLine_Stream_Cursor_Input>>;
  where?: InputMaybe<JournalEntryLine_Bool_Exp>;
};


export type Subscription_RootSelectJournalEntryLinesArgs = {
  distinct_on?: InputMaybe<Array<JournalEntryLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JournalEntryLine_Order_By>>;
  where?: InputMaybe<JournalEntryLine_Bool_Exp>;
};


export type Subscription_RootSelectJournalEntryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JournalEntry_Stream_Cursor_Input>>;
  where?: InputMaybe<JournalEntry_Bool_Exp>;
};


export type Subscription_RootSelectLaborGuideTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectLaborGuideTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<LaborGuideType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborGuideType_Order_By>>;
  where?: InputMaybe<LaborGuideType_Bool_Exp>;
};


export type Subscription_RootSelectLaborGuideTypesArgs = {
  distinct_on?: InputMaybe<Array<LaborGuideType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborGuideType_Order_By>>;
  where?: InputMaybe<LaborGuideType_Bool_Exp>;
};


export type Subscription_RootSelectLaborRateArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectLaborRateAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectLaborRateAs400sArgs = {
  distinct_on?: InputMaybe<Array<LaborRateAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborRateAs400_Order_By>>;
  where?: InputMaybe<LaborRateAs400_Bool_Exp>;
};


export type Subscription_RootSelectLaborRatesArgs = {
  distinct_on?: InputMaybe<Array<LaborRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LaborRate_Order_By>>;
  where?: InputMaybe<LaborRate_Bool_Exp>;
};


export type Subscription_RootSelectLegacyPolicyContractArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectLegacyPolicyContractAggregateArgs = {
  distinct_on?: InputMaybe<Array<LegacyPolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LegacyPolicyContract_Order_By>>;
  where?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
};


export type Subscription_RootSelectLegacyPolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<LegacyPolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LegacyPolicyContract_Order_By>>;
  where?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
};


export type Subscription_RootSelectLoggedActionAggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


export type Subscription_RootSelectLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


export type Subscription_RootSelectLossRatioArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectLossRatioCurrentViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<LossRatioCurrentView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatioCurrentView_Order_By>>;
  where?: InputMaybe<LossRatioCurrentView_Bool_Exp>;
};


export type Subscription_RootSelectLossRatioCurrentViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LossRatioCurrentView_Stream_Cursor_Input>>;
  where?: InputMaybe<LossRatioCurrentView_Bool_Exp>;
};


export type Subscription_RootSelectLossRatioCurrentViewsArgs = {
  distinct_on?: InputMaybe<Array<LossRatioCurrentView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatioCurrentView_Order_By>>;
  where?: InputMaybe<LossRatioCurrentView_Bool_Exp>;
};


export type Subscription_RootSelectLossRatioStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LossRatio_Stream_Cursor_Input>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};


export type Subscription_RootSelectLossRatiosArgs = {
  distinct_on?: InputMaybe<Array<LossRatio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatio_Order_By>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};


export type Subscription_RootSelectLossRatiosAggregateArgs = {
  distinct_on?: InputMaybe<Array<LossRatio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LossRatio_Order_By>>;
  where?: InputMaybe<LossRatio_Bool_Exp>;
};


export type Subscription_RootSelectMateralizedClassCriteriaViewDefaultVehicleCriteriaAggregateArgs = {
  distinct_on?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootSelectMateralizedClassCriteriaViewDefaultVehicleCriteriasArgs = {
  distinct_on?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MateralizedClassCriteriaViewDefaultVehicleCriteria_Order_By>>;
  where?: InputMaybe<MateralizedClassCriteriaViewDefaultVehicleCriteria_Bool_Exp>;
};


export type Subscription_RootSelectMilesCalculationTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectMilesCalculationTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<MilesCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MilesCalculationType_Order_By>>;
  where?: InputMaybe<MilesCalculationType_Bool_Exp>;
};


export type Subscription_RootSelectMilesCalculationTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MilesCalculationType_Stream_Cursor_Input>>;
  where?: InputMaybe<MilesCalculationType_Bool_Exp>;
};


export type Subscription_RootSelectMilesCalculationTypesArgs = {
  distinct_on?: InputMaybe<Array<MilesCalculationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MilesCalculationType_Order_By>>;
  where?: InputMaybe<MilesCalculationType_Bool_Exp>;
};


export type Subscription_RootSelectNhtsaConcernSynonymAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConcernSynonym_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConcernSynonym_Order_By_Nhtsa>>;
  where?: InputMaybe<ConcernSynonym_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaConcernSynonymsArgs = {
  distinct_on?: InputMaybe<Array<ConcernSynonym_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConcernSynonym_Order_By_Nhtsa>>;
  where?: InputMaybe<ConcernSynonym_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaInvestigationRecallArgs = {
  investigationIssueId: Scalars['String'];
  recallNumber: Scalars['String'];
};


export type Subscription_RootSelectNhtsaInvestigationRecallAggregateArgs = {
  distinct_on?: InputMaybe<Array<InvestigationRecall_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvestigationRecall_Order_By_Nhtsa>>;
  where?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaInvestigationRecallsArgs = {
  distinct_on?: InputMaybe<Array<InvestigationRecall_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InvestigationRecall_Order_By_Nhtsa>>;
  where?: InputMaybe<InvestigationRecall_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaIssueArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSelectNhtsaIssueAggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Order_By_Nhtsa>>;
  where?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaIssueMakeModelAggregateArgs = {
  distinct_on?: InputMaybe<Array<IssueMakeModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueMakeModel_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaIssueMakeModelsArgs = {
  distinct_on?: InputMaybe<Array<IssueMakeModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueMakeModel_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueMakeModel_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaIssueSearchResultAggregateArgs = {
  distinct_on?: InputMaybe<Array<IssueSearchResult_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueSearchResult_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueSearchResult_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaIssueSearchResultsArgs = {
  distinct_on?: InputMaybe<Array<IssueSearchResult_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueSearchResult_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueSearchResult_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaIssueVehicleAggregateArgs = {
  distinct_on?: InputMaybe<Array<IssueVehicle_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueVehicle_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueVehicle_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaIssueVehiclesArgs = {
  distinct_on?: InputMaybe<Array<IssueVehicle_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IssueVehicle_Order_By_Nhtsa>>;
  where?: InputMaybe<IssueVehicle_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaIssuesArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Order_By_Nhtsa>>;
  where?: InputMaybe<Issue_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaLoadArgs = {
  dataset: Scalars['String'];
};


export type Subscription_RootSelectNhtsaLoadAggregateArgs = {
  distinct_on?: InputMaybe<Array<Load_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Load_Order_By_Nhtsa>>;
  where?: InputMaybe<Load_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaLoadsArgs = {
  distinct_on?: InputMaybe<Array<Load_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Load_Order_By_Nhtsa>>;
  where?: InputMaybe<Load_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaMakeModelArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectNhtsaMakeModelAggregateArgs = {
  distinct_on?: InputMaybe<Array<MakeModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MakeModel_Order_By_Nhtsa>>;
  where?: InputMaybe<MakeModel_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaMakeModelsArgs = {
  distinct_on?: InputMaybe<Array<MakeModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MakeModel_Order_By_Nhtsa>>;
  where?: InputMaybe<MakeModel_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaModelYearModelAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelYearModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelYearModel_Order_By_Nhtsa>>;
  where?: InputMaybe<ModelYearModel_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaModelYearModelsArgs = {
  distinct_on?: InputMaybe<Array<ModelYearModel_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelYearModel_Order_By_Nhtsa>>;
  where?: InputMaybe<ModelYearModel_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaRecordTypeArgs = {
  name: Scalars['String'];
};


export type Subscription_RootSelectNhtsaRecordTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<RecordType_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RecordType_Order_By_Nhtsa>>;
  where?: InputMaybe<RecordType_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectNhtsaRecordTypesArgs = {
  distinct_on?: InputMaybe<Array<RecordType_Select_Column_Nhtsa>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RecordType_Order_By_Nhtsa>>;
  where?: InputMaybe<RecordType_Bool_Exp_Nhtsa>;
};


export type Subscription_RootSelectObligorArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectObligorsArgs = {
  distinct_on?: InputMaybe<Array<Obligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Obligor_Order_By>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};


export type Subscription_RootSelectObligorsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Obligor_Order_By>>;
  where?: InputMaybe<Obligor_Bool_Exp>;
};


export type Subscription_RootSelectObsoleteJobArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectObsoleteJobAggregateArgs = {
  distinct_on?: InputMaybe<Array<ObsoleteJob_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObsoleteJob_Order_By>>;
  where?: InputMaybe<ObsoleteJob_Bool_Exp>;
};


export type Subscription_RootSelectObsoleteJobsArgs = {
  distinct_on?: InputMaybe<Array<ObsoleteJob_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObsoleteJob_Order_By>>;
  where?: InputMaybe<ObsoleteJob_Bool_Exp>;
};


export type Subscription_RootSelectOutboxEventArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectOutboxEventAggregateArgs = {
  distinct_on?: InputMaybe<Array<OutboxEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OutboxEvent_Order_By>>;
  where?: InputMaybe<OutboxEvent_Bool_Exp>;
};


export type Subscription_RootSelectOutboxEventStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OutboxEvent_Stream_Cursor_Input>>;
  where?: InputMaybe<OutboxEvent_Bool_Exp>;
};


export type Subscription_RootSelectOutboxEventsArgs = {
  distinct_on?: InputMaybe<Array<OutboxEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OutboxEvent_Order_By>>;
  where?: InputMaybe<OutboxEvent_Bool_Exp>;
};


export type Subscription_RootSelectParticipantArgs = {
  identityId: Scalars['uuid'];
  parentId: Scalars['uuid'];
};


export type Subscription_RootSelectParticipantAggregateArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Subscription_RootSelectParticipantStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Participant_Stream_Cursor_Input>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Subscription_RootSelectParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Participant_Order_By>>;
  where?: InputMaybe<Participant_Bool_Exp>;
};


export type Subscription_RootSelectPayeeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPayeeAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPayeeAs400AggregateArgs = {
  distinct_on?: InputMaybe<Array<PayeeAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PayeeAs400_Order_By>>;
  where?: InputMaybe<PayeeAs400_Bool_Exp>;
};


export type Subscription_RootSelectPayeeAs400sArgs = {
  distinct_on?: InputMaybe<Array<PayeeAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PayeeAs400_Order_By>>;
  where?: InputMaybe<PayeeAs400_Bool_Exp>;
};


export type Subscription_RootSelectPayeeLinkViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<PayeeLinkView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PayeeLinkView_Order_By>>;
  where?: InputMaybe<PayeeLinkView_Bool_Exp>;
};


export type Subscription_RootSelectPayeeLinkViewsArgs = {
  distinct_on?: InputMaybe<Array<PayeeLinkView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PayeeLinkView_Order_By>>;
  where?: InputMaybe<PayeeLinkView_Bool_Exp>;
};


export type Subscription_RootSelectPayeesArgs = {
  distinct_on?: InputMaybe<Array<Payee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payee_Order_By>>;
  where?: InputMaybe<Payee_Bool_Exp>;
};


export type Subscription_RootSelectPayeesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Payee_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payee_Order_By>>;
  where?: InputMaybe<Payee_Bool_Exp>;
};


export type Subscription_RootSelectPaymentArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPaymentAggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootSelectPaymentAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPaymentAs400sArgs = {
  distinct_on?: InputMaybe<Array<PaymentAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentAs400_Order_By>>;
  where?: InputMaybe<PaymentAs400_Bool_Exp>;
};


export type Subscription_RootSelectPaymentDetailArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPaymentDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentDetail_Order_By>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};


export type Subscription_RootSelectPaymentDetailsArgs = {
  distinct_on?: InputMaybe<Array<PaymentDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentDetail_Order_By>>;
  where?: InputMaybe<PaymentDetail_Bool_Exp>;
};


export type Subscription_RootSelectPaymentMethodTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPaymentMethodTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentMethodType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentMethodType_Order_By>>;
  where?: InputMaybe<PaymentMethodType_Bool_Exp>;
};


export type Subscription_RootSelectPaymentMethodTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentMethodType_Stream_Cursor_Input>>;
  where?: InputMaybe<PaymentMethodType_Bool_Exp>;
};


export type Subscription_RootSelectPaymentMethodTypesArgs = {
  distinct_on?: InputMaybe<Array<PaymentMethodType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentMethodType_Order_By>>;
  where?: InputMaybe<PaymentMethodType_Bool_Exp>;
};


export type Subscription_RootSelectPaymentStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPaymentStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentStatusType_Order_By>>;
  where?: InputMaybe<PaymentStatusType_Bool_Exp>;
};


export type Subscription_RootSelectPaymentStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<PaymentStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentStatusType_Order_By>>;
  where?: InputMaybe<PaymentStatusType_Bool_Exp>;
};


export type Subscription_RootSelectPaymentTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPaymentTypesArgs = {
  distinct_on?: InputMaybe<Array<PaymentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentType_Order_By>>;
  where?: InputMaybe<PaymentType_Bool_Exp>;
};


export type Subscription_RootSelectPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootSelectPlanArgs = {
  PlanID: Scalars['Int'];
};


export type Subscription_RootSelectPlanAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootSelectPlansArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootSelectPoliciesArgs = {
  distinct_on?: InputMaybe<Array<Policy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policy_Order_By>>;
  where?: InputMaybe<Policy_Bool_Exp>;
};


export type Subscription_RootSelectPoliciesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Policy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policy_Order_By>>;
  where?: InputMaybe<Policy_Bool_Exp>;
};


export type Subscription_RootSelectPolicyArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyClaimArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyClaimAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaim_Order_By>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


export type Subscription_RootSelectPolicyClaimAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyClaimAs400sArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimAs400_Order_By>>;
  where?: InputMaybe<PolicyClaimAs400_Bool_Exp>;
};


export type Subscription_RootSelectPolicyClaimConcernArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyClaimConcernAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimConcern_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimConcern_Order_By>>;
  where?: InputMaybe<PolicyClaimConcern_Bool_Exp>;
};


export type Subscription_RootSelectPolicyClaimConcernsArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimConcern_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimConcern_Order_By>>;
  where?: InputMaybe<PolicyClaimConcern_Bool_Exp>;
};


export type Subscription_RootSelectPolicyClaimInsuranceArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyClaimInsurancesArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaimInsurance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaimInsurance_Order_By>>;
  where?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
};


export type Subscription_RootSelectPolicyClaimsArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaim_Order_By>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractAssetArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractAssetStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractAsset_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractAsset_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractAssetTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractAssetTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractAssetType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractAssetType_Order_By>>;
  where?: InputMaybe<PolicyContractAssetType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractAssetTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractAssetType_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractAssetType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractAssetTypesArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractAssetType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractAssetType_Order_By>>;
  where?: InputMaybe<PolicyContractAssetType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractAssetsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractAsset_Order_By>>;
  where?: InputMaybe<PolicyContractAsset_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractAsset_Order_By>>;
  where?: InputMaybe<PolicyContractAsset_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractContractFormVersionArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractContractFormVersionAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractContractFormVersion_Order_By>>;
  where?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractContractFormVersionsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractContractFormVersion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractContractFormVersion_Order_By>>;
  where?: InputMaybe<PolicyContractContractFormVersion_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractCostDetailArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractCostDetailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractCostDetail_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractCostDetail_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractCostDetailsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractCostDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractCostDetail_Order_By>>;
  where?: InputMaybe<PolicyContractCostDetail_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractCostDetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractCostDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractCostDetail_Order_By>>;
  where?: InputMaybe<PolicyContractCostDetail_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractLenderArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractLenderStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractLender_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractLender_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractLendersArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLender_Order_By>>;
  where?: InputMaybe<PolicyContractLender_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractLendersAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLender_Order_By>>;
  where?: InputMaybe<PolicyContractLender_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractListViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractListView_Order_By>>;
  where?: InputMaybe<PolicyContractListView_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractListViewsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractListView_Order_By>>;
  where?: InputMaybe<PolicyContractListView_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractLoanContractTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractLoanContractTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLoanContractType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLoanContractType_Order_By>>;
  where?: InputMaybe<PolicyContractLoanContractType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractLoanContractTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractLoanContractType_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractLoanContractType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractLoanContractTypesArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractLoanContractType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractLoanContractType_Order_By>>;
  where?: InputMaybe<PolicyContractLoanContractType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractOwnerArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractOwnerStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractOwner_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractOwner_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractOwnersArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractOwner_Order_By>>;
  where?: InputMaybe<PolicyContractOwner_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractOwnersAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractOwner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractOwner_Order_By>>;
  where?: InputMaybe<PolicyContractOwner_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractProductArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProduct_Order_By>>;
  where?: InputMaybe<PolicyContractProduct_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractProductCostDetailArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractProductCostDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductCostDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductCostDetail_Order_By>>;
  where?: InputMaybe<PolicyContractProductCostDetail_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractProductCostDetailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractProductCostDetail_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractProductCostDetail_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractProductCostDetailsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductCostDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductCostDetail_Order_By>>;
  where?: InputMaybe<PolicyContractProductCostDetail_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractProductOptionsMetadataViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Order_By>>;
  where?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractProductOptionsMetadataViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractProductOptionsMetadataView_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractProductOptionsMetadataViewsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProductOptionsMetadataView_Order_By>>;
  where?: InputMaybe<PolicyContractProductOptionsMetadataView_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractProductStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractProduct_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractProduct_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractProductsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractProduct_Order_By>>;
  where?: InputMaybe<PolicyContractProduct_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractQuoteArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractQuoteAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractQuote_Order_By>>;
  where?: InputMaybe<PolicyContractQuote_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractQuoteStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractQuote_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractQuote_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractQuotesArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractQuote_Order_By>>;
  where?: InputMaybe<PolicyContractQuote_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractStatusType_Order_By>>;
  where?: InputMaybe<PolicyContractStatusType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractStatusTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractStatusType_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractStatusType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractStatusType_Order_By>>;
  where?: InputMaybe<PolicyContractStatusType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContract_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractVoidReasonTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPolicyContractVoidReasonTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractVoidReasonType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractVoidReasonType_Order_By>>;
  where?: InputMaybe<PolicyContractVoidReasonType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractVoidReasonTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyContractVoidReasonType_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyContractVoidReasonType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractVoidReasonTypesArgs = {
  distinct_on?: InputMaybe<Array<PolicyContractVoidReasonType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContractVoidReasonType_Order_By>>;
  where?: InputMaybe<PolicyContractVoidReasonType_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


export type Subscription_RootSelectPolicyContractsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


export type Subscription_RootSelectPolicyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Policy_Stream_Cursor_Input>>;
  where?: InputMaybe<Policy_Bool_Exp>;
};


export type Subscription_RootSelectPreAuthorizationArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPreAuthorizationStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPreAuthorizationStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorizationStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorizationStatusType_Order_By>>;
  where?: InputMaybe<PreAuthorizationStatusType_Bool_Exp>;
};


export type Subscription_RootSelectPreAuthorizationStatusTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PreAuthorizationStatusType_Stream_Cursor_Input>>;
  where?: InputMaybe<PreAuthorizationStatusType_Bool_Exp>;
};


export type Subscription_RootSelectPreAuthorizationStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorizationStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorizationStatusType_Order_By>>;
  where?: InputMaybe<PreAuthorizationStatusType_Bool_Exp>;
};


export type Subscription_RootSelectPreAuthorizationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PreAuthorization_Stream_Cursor_Input>>;
  where?: InputMaybe<PreAuthorization_Bool_Exp>;
};


export type Subscription_RootSelectPreAuthorizationTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectPreAuthorizationTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PreAuthorizationType_Stream_Cursor_Input>>;
  where?: InputMaybe<PreAuthorizationType_Bool_Exp>;
};


export type Subscription_RootSelectPreAuthorizationTypesArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorizationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorizationType_Order_By>>;
  where?: InputMaybe<PreAuthorizationType_Bool_Exp>;
};


export type Subscription_RootSelectPreAuthorizationTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorizationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorizationType_Order_By>>;
  where?: InputMaybe<PreAuthorizationType_Bool_Exp>;
};


export type Subscription_RootSelectPreAuthorizationsArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorization_Order_By>>;
  where?: InputMaybe<PreAuthorization_Bool_Exp>;
};


export type Subscription_RootSelectPreAuthorizationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PreAuthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PreAuthorization_Order_By>>;
  where?: InputMaybe<PreAuthorization_Bool_Exp>;
};


export type Subscription_RootSelectProductArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProductAttributeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProductAttributeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttribute_Order_By>>;
  where?: InputMaybe<ProductAttribute_Bool_Exp>;
};


export type Subscription_RootSelectProductAttributeTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectProductAttributeTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttributeType_Order_By>>;
  where?: InputMaybe<ProductAttributeType_Bool_Exp>;
};


export type Subscription_RootSelectProductAttributeTypesArgs = {
  distinct_on?: InputMaybe<Array<ProductAttributeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttributeType_Order_By>>;
  where?: InputMaybe<ProductAttributeType_Bool_Exp>;
};


export type Subscription_RootSelectProductAttributesArgs = {
  distinct_on?: InputMaybe<Array<ProductAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductAttribute_Order_By>>;
  where?: InputMaybe<ProductAttribute_Bool_Exp>;
};


export type Subscription_RootSelectProductClassGuideArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProductClassGuideAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductClassGuide_Order_By>>;
  where?: InputMaybe<ProductClassGuide_Bool_Exp>;
};


export type Subscription_RootSelectProductClassGuidesArgs = {
  distinct_on?: InputMaybe<Array<ProductClassGuide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductClassGuide_Order_By>>;
  where?: InputMaybe<ProductClassGuide_Bool_Exp>;
};


export type Subscription_RootSelectProductContractFormArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProductContractFormAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductContractForm_Order_By>>;
  where?: InputMaybe<ProductContractForm_Bool_Exp>;
};


export type Subscription_RootSelectProductContractFormsArgs = {
  distinct_on?: InputMaybe<Array<ProductContractForm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductContractForm_Order_By>>;
  where?: InputMaybe<ProductContractForm_Bool_Exp>;
};


export type Subscription_RootSelectProductCostArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProductCostAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductCost_Order_By>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};


export type Subscription_RootSelectProductCostsArgs = {
  distinct_on?: InputMaybe<Array<ProductCost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductCost_Order_By>>;
  where?: InputMaybe<ProductCost_Bool_Exp>;
};


export type Subscription_RootSelectProductDisbursementArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProductDisbursementAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductDisbursement_Order_By>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};


export type Subscription_RootSelectProductDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<ProductDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductDisbursement_Order_By>>;
  where?: InputMaybe<ProductDisbursement_Bool_Exp>;
};


export type Subscription_RootSelectProductEligibilitiesArgs = {
  distinct_on?: InputMaybe<Array<ProductEligibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductEligibility_Order_By>>;
  where?: InputMaybe<ProductEligibility_Bool_Exp>;
};


export type Subscription_RootSelectProductEligibilityArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProductEligibilityAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductEligibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductEligibility_Order_By>>;
  where?: InputMaybe<ProductEligibility_Bool_Exp>;
};


export type Subscription_RootSelectProductObligorArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProductObligorsArgs = {
  distinct_on?: InputMaybe<Array<ProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductObligor_Order_By>>;
  where?: InputMaybe<ProductObligor_Bool_Exp>;
};


export type Subscription_RootSelectProductObligorsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductObligor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductObligor_Order_By>>;
  where?: InputMaybe<ProductObligor_Bool_Exp>;
};


export type Subscription_RootSelectProductRateBucketArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProductRateBucketAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductRateBucket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductRateBucket_Order_By>>;
  where?: InputMaybe<ProductRateBucket_Bool_Exp>;
};


export type Subscription_RootSelectProductRateBucketsArgs = {
  distinct_on?: InputMaybe<Array<ProductRateBucket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductRateBucket_Order_By>>;
  where?: InputMaybe<ProductRateBucket_Bool_Exp>;
};


export type Subscription_RootSelectProductSurchargeTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProductSurchargeTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductSurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductSurchargeType_Order_By>>;
  where?: InputMaybe<ProductSurchargeType_Bool_Exp>;
};


export type Subscription_RootSelectProductSurchargeTypesArgs = {
  distinct_on?: InputMaybe<Array<ProductSurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductSurchargeType_Order_By>>;
  where?: InputMaybe<ProductSurchargeType_Bool_Exp>;
};


export type Subscription_RootSelectProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootSelectProductsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootSelectProfileArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectProfileAggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Subscription_RootSelectProfileStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Subscription_RootSelectProfilesArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Subscription_RootSelectQuoteArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectQuoteAggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Subscription_RootSelectQuoteMinimalViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<QuoteMinimalView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuoteMinimalView_Order_By>>;
  where?: InputMaybe<QuoteMinimalView_Bool_Exp>;
};


export type Subscription_RootSelectQuoteMinimalViewsArgs = {
  distinct_on?: InputMaybe<Array<QuoteMinimalView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuoteMinimalView_Order_By>>;
  where?: InputMaybe<QuoteMinimalView_Bool_Exp>;
};


export type Subscription_RootSelectQuoteTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectQuoteTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<QuoteType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuoteType_Order_By>>;
  where?: InputMaybe<QuoteType_Bool_Exp>;
};


export type Subscription_RootSelectQuoteTypesArgs = {
  distinct_on?: InputMaybe<Array<QuoteType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QuoteType_Order_By>>;
  where?: InputMaybe<QuoteType_Bool_Exp>;
};


export type Subscription_RootSelectQuotesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Subscription_RootSelectRateBucketTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectRateBucketTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<RateBucketType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RateBucketType_Order_By>>;
  where?: InputMaybe<RateBucketType_Bool_Exp>;
};


export type Subscription_RootSelectRateBucketTypesArgs = {
  distinct_on?: InputMaybe<Array<RateBucketType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RateBucketType_Order_By>>;
  where?: InputMaybe<RateBucketType_Bool_Exp>;
};


export type Subscription_RootSelectRateQuoteArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRateQuotesArgs = {
  distinct_on?: InputMaybe<Array<RateQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RateQuote_Order_By>>;
  where?: InputMaybe<RateQuote_Bool_Exp>;
};


export type Subscription_RootSelectRateQuotesAggregateArgs = {
  distinct_on?: InputMaybe<Array<RateQuote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RateQuote_Order_By>>;
  where?: InputMaybe<RateQuote_Bool_Exp>;
};


export type Subscription_RootSelectRaterViewConfigArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRaterViewConfigsArgs = {
  distinct_on?: InputMaybe<Array<RaterViewConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RaterViewConfig_Order_By>>;
  where?: InputMaybe<RaterViewConfig_Bool_Exp>;
};


export type Subscription_RootSelectReferenceLogArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectReferenceLogAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReferenceLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReferenceLog_Order_By>>;
  where?: InputMaybe<ReferenceLog_Bool_Exp>;
};


export type Subscription_RootSelectReferenceLogStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ReferenceLog_Stream_Cursor_Input>>;
  where?: InputMaybe<ReferenceLog_Bool_Exp>;
};


export type Subscription_RootSelectReferenceLogsArgs = {
  distinct_on?: InputMaybe<Array<ReferenceLog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReferenceLog_Order_By>>;
  where?: InputMaybe<ReferenceLog_Bool_Exp>;
};


export type Subscription_RootSelectRemittanceArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRemittanceAggregateArgs = {
  distinct_on?: InputMaybe<Array<Remittance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Remittance_Order_By>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};


export type Subscription_RootSelectRemittanceClaimDetailArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRemittanceClaimDetailsArgs = {
  distinct_on?: InputMaybe<Array<RemittanceClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceClaimDetail_Order_By>>;
  where?: InputMaybe<RemittanceClaimDetail_Bool_Exp>;
};


export type Subscription_RootSelectRemittancePaymentArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRemittancePaymentAggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePayment_Order_By>>;
  where?: InputMaybe<RemittancePayment_Bool_Exp>;
};


export type Subscription_RootSelectRemittancePaymentsArgs = {
  distinct_on?: InputMaybe<Array<RemittancePayment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePayment_Order_By>>;
  where?: InputMaybe<RemittancePayment_Bool_Exp>;
};


export type Subscription_RootSelectRemittancePolicyContractArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRemittancePolicyContractAggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContract_Order_By>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};


export type Subscription_RootSelectRemittancePolicyContractAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRemittancePolicyContractAs400AggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContractAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContractAs400_Order_By>>;
  where?: InputMaybe<RemittancePolicyContractAs400_Bool_Exp>;
};


export type Subscription_RootSelectRemittancePolicyContractAs400sArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContractAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContractAs400_Order_By>>;
  where?: InputMaybe<RemittancePolicyContractAs400_Bool_Exp>;
};


export type Subscription_RootSelectRemittancePolicyContractStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RemittancePolicyContract_Stream_Cursor_Input>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};


export type Subscription_RootSelectRemittancePolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<RemittancePolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittancePolicyContract_Order_By>>;
  where?: InputMaybe<RemittancePolicyContract_Bool_Exp>;
};


export type Subscription_RootSelectRemittanceStatusTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRemittanceStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittanceStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceStatusType_Order_By>>;
  where?: InputMaybe<RemittanceStatusType_Bool_Exp>;
};


export type Subscription_RootSelectRemittanceStatusTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RemittanceStatusType_Stream_Cursor_Input>>;
  where?: InputMaybe<RemittanceStatusType_Bool_Exp>;
};


export type Subscription_RootSelectRemittanceStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<RemittanceStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceStatusType_Order_By>>;
  where?: InputMaybe<RemittanceStatusType_Bool_Exp>;
};


export type Subscription_RootSelectRemittanceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Remittance_Stream_Cursor_Input>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};


export type Subscription_RootSelectRemittanceTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRemittanceTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<RemittanceType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceType_Order_By>>;
  where?: InputMaybe<RemittanceType_Bool_Exp>;
};


export type Subscription_RootSelectRemittanceTypesArgs = {
  distinct_on?: InputMaybe<Array<RemittanceType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RemittanceType_Order_By>>;
  where?: InputMaybe<RemittanceType_Bool_Exp>;
};


export type Subscription_RootSelectRemittancesArgs = {
  distinct_on?: InputMaybe<Array<Remittance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Remittance_Order_By>>;
  where?: InputMaybe<Remittance_Bool_Exp>;
};


export type Subscription_RootSelectRepeatPartAcknowledgmentArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRepeatPartAcknowledgmentAggregateArgs = {
  distinct_on?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatPartAcknowledgment_Order_By>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};


export type Subscription_RootSelectRepeatPartAcknowledgmentsArgs = {
  distinct_on?: InputMaybe<Array<RepeatPartAcknowledgment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RepeatPartAcknowledgment_Order_By>>;
  where?: InputMaybe<RepeatPartAcknowledgment_Bool_Exp>;
};


export type Subscription_RootSelectRoleArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRoleAggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootSelectRoleAttributeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRoleAttributeAggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleAttribute_Order_By>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};


export type Subscription_RootSelectRoleAttributesArgs = {
  distinct_on?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleAttribute_Order_By>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};


export type Subscription_RootSelectRoleHierarchyViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleHierarchyView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleHierarchyView_Order_By>>;
  where?: InputMaybe<RoleHierarchyView_Bool_Exp>;
};


export type Subscription_RootSelectRoleHierarchyViewStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RoleHierarchyView_Stream_Cursor_Input>>;
  where?: InputMaybe<RoleHierarchyView_Bool_Exp>;
};


export type Subscription_RootSelectRoleHierarchyViewsArgs = {
  distinct_on?: InputMaybe<Array<RoleHierarchyView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleHierarchyView_Order_By>>;
  where?: InputMaybe<RoleHierarchyView_Bool_Exp>;
};


export type Subscription_RootSelectRolesArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootSelectRouteArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRouteAggregateArgs = {
  distinct_on?: InputMaybe<Array<Route_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Route_Order_By>>;
  where?: InputMaybe<Route_Bool_Exp>;
};


export type Subscription_RootSelectRouteConfigArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectRouteConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<RouteConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RouteConfig_Order_By>>;
  where?: InputMaybe<RouteConfig_Bool_Exp>;
};


export type Subscription_RootSelectRouteConfigsArgs = {
  distinct_on?: InputMaybe<Array<RouteConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RouteConfig_Order_By>>;
  where?: InputMaybe<RouteConfig_Bool_Exp>;
};


export type Subscription_RootSelectRoutesArgs = {
  distinct_on?: InputMaybe<Array<Route_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Route_Order_By>>;
  where?: InputMaybe<Route_Bool_Exp>;
};


export type Subscription_RootSelectSearchIndexArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectSearchIndexAggregateArgs = {
  distinct_on?: InputMaybe<Array<SearchIndex_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SearchIndex_Order_By>>;
  where?: InputMaybe<SearchIndex_Bool_Exp>;
};


export type Subscription_RootSelectSearchIndexesArgs = {
  distinct_on?: InputMaybe<Array<SearchIndex_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SearchIndex_Order_By>>;
  where?: InputMaybe<SearchIndex_Bool_Exp>;
};


export type Subscription_RootSelectServiceCenterArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectServiceCenterAggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


export type Subscription_RootSelectServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


export type Subscription_RootSelectSeverityLevelTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectSeverityLevelTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<SeverityLevelType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SeverityLevelType_Order_By>>;
  where?: InputMaybe<SeverityLevelType_Bool_Exp>;
};


export type Subscription_RootSelectSeverityLevelTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SeverityLevelType_Stream_Cursor_Input>>;
  where?: InputMaybe<SeverityLevelType_Bool_Exp>;
};


export type Subscription_RootSelectSeverityLevelTypesArgs = {
  distinct_on?: InputMaybe<Array<SeverityLevelType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SeverityLevelType_Order_By>>;
  where?: InputMaybe<SeverityLevelType_Bool_Exp>;
};


export type Subscription_RootSelectShortcutBindingArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectShortcutBindingAggregateArgs = {
  distinct_on?: InputMaybe<Array<ShortcutBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShortcutBinding_Order_By>>;
  where?: InputMaybe<ShortcutBinding_Bool_Exp>;
};


export type Subscription_RootSelectShortcutBindingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ShortcutBinding_Stream_Cursor_Input>>;
  where?: InputMaybe<ShortcutBinding_Bool_Exp>;
};


export type Subscription_RootSelectShortcutBindingsArgs = {
  distinct_on?: InputMaybe<Array<ShortcutBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShortcutBinding_Order_By>>;
  where?: InputMaybe<ShortcutBinding_Bool_Exp>;
};


export type Subscription_RootSelectStateArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectStatesArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Subscription_RootSelectStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Subscription_RootSelectStepArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectStepAggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Step_Order_By>>;
  where?: InputMaybe<Step_Bool_Exp>;
};


export type Subscription_RootSelectStepListViewsArgs = {
  distinct_on?: InputMaybe<Array<StepListView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StepListView_Order_By>>;
  where?: InputMaybe<StepListView_Bool_Exp>;
};


export type Subscription_RootSelectStepStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Step_Stream_Cursor_Input>>;
  where?: InputMaybe<Step_Bool_Exp>;
};


export type Subscription_RootSelectStepTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectStepTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<StepType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StepType_Order_By>>;
  where?: InputMaybe<StepType_Bool_Exp>;
};


export type Subscription_RootSelectStepTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<StepType_Stream_Cursor_Input>>;
  where?: InputMaybe<StepType_Bool_Exp>;
};


export type Subscription_RootSelectStepTypesArgs = {
  distinct_on?: InputMaybe<Array<StepType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StepType_Order_By>>;
  where?: InputMaybe<StepType_Bool_Exp>;
};


export type Subscription_RootSelectStepsArgs = {
  distinct_on?: InputMaybe<Array<Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Step_Order_By>>;
  where?: InputMaybe<Step_Bool_Exp>;
};


export type Subscription_RootSelectStreamAccountObligorsArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountObligor_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountObligor_Bool_Exp>;
};


export type Subscription_RootSelectStreamClaimDetailAs400Args = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClaimDetailAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<ClaimDetailAs400_Bool_Exp>;
};


export type Subscription_RootSelectStreamClaimDetailDeductionAs400Args = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClaimDetailDeductionAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<ClaimDetailDeductionAs400_Bool_Exp>;
};


export type Subscription_RootSelectStreamClaimServiceCenterAs400Args = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClaimServiceCenterAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<ClaimServiceCenterAs400_Bool_Exp>;
};


export type Subscription_RootSelectStreamCompositeProductsArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompositeProduct_Stream_Cursor_Input>>;
  where?: InputMaybe<CompositeProduct_Bool_Exp>;
};


export type Subscription_RootSelectStreamIdentityAs400Args = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdentityAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<IdentityAs400_Bool_Exp>;
};


export type Subscription_RootSelectStreamJobListViewArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JobListView_Stream_Cursor_Input>>;
  where?: InputMaybe<JobListView_Bool_Exp>;
};


export type Subscription_RootSelectStreamLaborRateArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LaborRate_Stream_Cursor_Input>>;
  where?: InputMaybe<LaborRate_Bool_Exp>;
};


export type Subscription_RootSelectStreamLaborRateAs400Args = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LaborRateAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<LaborRateAs400_Bool_Exp>;
};


export type Subscription_RootSelectStreamPaymentAs400Args = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<PaymentAs400_Bool_Exp>;
};


export type Subscription_RootSelectStreamPolicyClaimAs400Args = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyClaimAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyClaimAs400_Bool_Exp>;
};


export type Subscription_RootSelectStreamPolicyClaimInsuranceArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyClaimInsurance_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyClaimInsurance_Bool_Exp>;
};


export type Subscription_RootSelectStreamRaterViewConfigsArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RaterViewConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<RaterViewConfig_Bool_Exp>;
};


export type Subscription_RootSelectStreamStepListViewArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<StepListView_Stream_Cursor_Input>>;
  where?: InputMaybe<StepListView_Bool_Exp>;
};


export type Subscription_RootSelectStreamTaxRateArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TaxRate_Stream_Cursor_Input>>;
  where?: InputMaybe<TaxRate_Bool_Exp>;
};


export type Subscription_RootSelectStreamTaxRateAs400Args = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TaxRateAs400_Stream_Cursor_Input>>;
  where?: InputMaybe<TaxRateAs400_Bool_Exp>;
};


export type Subscription_RootSelectSurchargeTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectSurchargeTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<SurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SurchargeType_Order_By>>;
  where?: InputMaybe<SurchargeType_Bool_Exp>;
};


export type Subscription_RootSelectSurchargeTypesArgs = {
  distinct_on?: InputMaybe<Array<SurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SurchargeType_Order_By>>;
  where?: InputMaybe<SurchargeType_Bool_Exp>;
};


export type Subscription_RootSelectTagArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectTagAggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootSelectTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootSelectTaskArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectTaskAggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootSelectTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootSelectTaxRateArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectTaxRateAs400Args = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectTaxRateAs400sArgs = {
  distinct_on?: InputMaybe<Array<TaxRateAs400_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxRateAs400_Order_By>>;
  where?: InputMaybe<TaxRateAs400_Bool_Exp>;
};


export type Subscription_RootSelectTaxRatesArgs = {
  distinct_on?: InputMaybe<Array<TaxRate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TaxRate_Order_By>>;
  where?: InputMaybe<TaxRate_Bool_Exp>;
};


export type Subscription_RootSelectTechnologyTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectTechnologyTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TechnologyType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TechnologyType_Order_By>>;
  where?: InputMaybe<TechnologyType_Bool_Exp>;
};


export type Subscription_RootSelectTechnologyTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TechnologyType_Stream_Cursor_Input>>;
  where?: InputMaybe<TechnologyType_Bool_Exp>;
};


export type Subscription_RootSelectTechnologyTypesArgs = {
  distinct_on?: InputMaybe<Array<TechnologyType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TechnologyType_Order_By>>;
  where?: InputMaybe<TechnologyType_Bool_Exp>;
};


export type Subscription_RootSelectTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Type_Order_By>>;
  where?: InputMaybe<Type_Bool_Exp>;
};


export type Subscription_RootSelectTypeGroupArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectTypeGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TypeGroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TypeGroup_Order_By>>;
  where?: InputMaybe<TypeGroup_Bool_Exp>;
};


export type Subscription_RootSelectTypeGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TypeGroup_Stream_Cursor_Input>>;
  where?: InputMaybe<TypeGroup_Bool_Exp>;
};


export type Subscription_RootSelectTypeGroupsArgs = {
  distinct_on?: InputMaybe<Array<TypeGroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TypeGroup_Order_By>>;
  where?: InputMaybe<TypeGroup_Bool_Exp>;
};


export type Subscription_RootSelectTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Type_Bool_Exp>;
};


export type Subscription_RootSelectTypesArgs = {
  distinct_on?: InputMaybe<Array<Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Type_Order_By>>;
  where?: InputMaybe<Type_Bool_Exp>;
};


export type Subscription_RootSelectUserArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootSelectUserFlowItemArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectUserFlowItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItem_Order_By>>;
  where?: InputMaybe<UserFlowItem_Bool_Exp>;
};


export type Subscription_RootSelectUserFlowItemMfaArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectUserFlowItemMfaAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItemMfa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItemMfa_Order_By>>;
  where?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
};


export type Subscription_RootSelectUserFlowItemMfaStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserFlowItemMfa_Stream_Cursor_Input>>;
  where?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
};


export type Subscription_RootSelectUserFlowItemMfasArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItemMfa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItemMfa_Order_By>>;
  where?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
};


export type Subscription_RootSelectUserFlowItemStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserFlowItem_Stream_Cursor_Input>>;
  where?: InputMaybe<UserFlowItem_Bool_Exp>;
};


export type Subscription_RootSelectUserFlowItemsArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItem_Order_By>>;
  where?: InputMaybe<UserFlowItem_Bool_Exp>;
};


export type Subscription_RootSelectUserGroupArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectUserGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroup_Order_By>>;
  where?: InputMaybe<UserGroup_Bool_Exp>;
};


export type Subscription_RootSelectUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<UserGroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroup_Order_By>>;
  where?: InputMaybe<UserGroup_Bool_Exp>;
};


export type Subscription_RootSelectUserPinArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectUserPinsArgs = {
  distinct_on?: InputMaybe<Array<UserPin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPin_Order_By>>;
  where?: InputMaybe<UserPin_Bool_Exp>;
};


export type Subscription_RootSelectUserPinsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPin_Order_By>>;
  where?: InputMaybe<UserPin_Bool_Exp>;
};


export type Subscription_RootSelectUserProfileArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectUserProfileAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserProfile_Order_By>>;
  where?: InputMaybe<UserProfile_Bool_Exp>;
};


export type Subscription_RootSelectUserProfilesArgs = {
  distinct_on?: InputMaybe<Array<UserProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserProfile_Order_By>>;
  where?: InputMaybe<UserProfile_Bool_Exp>;
};


export type Subscription_RootSelectUserSessionArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectUserSessionAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserSession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserSession_Order_By>>;
  where?: InputMaybe<UserSession_Bool_Exp>;
};


export type Subscription_RootSelectUserSessionsArgs = {
  distinct_on?: InputMaybe<Array<UserSession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserSession_Order_By>>;
  where?: InputMaybe<UserSession_Bool_Exp>;
};


export type Subscription_RootSelectUserStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootSelectUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootSelectValidationArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectValidationAggregateArgs = {
  distinct_on?: InputMaybe<Array<Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Validation_Order_By>>;
  where?: InputMaybe<Validation_Bool_Exp>;
};


export type Subscription_RootSelectValidationLifecycleHookArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectValidationLifecycleHookAggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationLifecycleHook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationLifecycleHook_Order_By>>;
  where?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
};


export type Subscription_RootSelectValidationLifecycleHooksArgs = {
  distinct_on?: InputMaybe<Array<ValidationLifecycleHook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationLifecycleHook_Order_By>>;
  where?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
};


export type Subscription_RootSelectValidationOverrideArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectValidationOverrideAggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationOverride_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationOverride_Order_By>>;
  where?: InputMaybe<ValidationOverride_Bool_Exp>;
};


export type Subscription_RootSelectValidationOverridesArgs = {
  distinct_on?: InputMaybe<Array<ValidationOverride_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationOverride_Order_By>>;
  where?: InputMaybe<ValidationOverride_Bool_Exp>;
};


export type Subscription_RootSelectValidationRuleForArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectValidationRuleForAggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationRuleFor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationRuleFor_Order_By>>;
  where?: InputMaybe<ValidationRuleFor_Bool_Exp>;
};


export type Subscription_RootSelectValidationRuleForsArgs = {
  distinct_on?: InputMaybe<Array<ValidationRuleFor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationRuleFor_Order_By>>;
  where?: InputMaybe<ValidationRuleFor_Bool_Exp>;
};


export type Subscription_RootSelectValidationTypeOperationArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectValidationTypeOperationAggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationTypeOperation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationTypeOperation_Order_By>>;
  where?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
};


export type Subscription_RootSelectValidationTypeOperationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ValidationTypeOperation_Stream_Cursor_Input>>;
  where?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
};


export type Subscription_RootSelectValidationTypeOperationsArgs = {
  distinct_on?: InputMaybe<Array<ValidationTypeOperation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationTypeOperation_Order_By>>;
  where?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
};


export type Subscription_RootSelectValidationWhenArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectValidationWhenAggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationWhen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationWhen_Order_By>>;
  where?: InputMaybe<ValidationWhen_Bool_Exp>;
};


export type Subscription_RootSelectValidationWhensArgs = {
  distinct_on?: InputMaybe<Array<ValidationWhen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationWhen_Order_By>>;
  where?: InputMaybe<ValidationWhen_Bool_Exp>;
};


export type Subscription_RootSelectValidationsArgs = {
  distinct_on?: InputMaybe<Array<Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Validation_Order_By>>;
  where?: InputMaybe<Validation_Bool_Exp>;
};


export type Subscription_RootSelectVehicleArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectVehicleAggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


export type Subscription_RootSelectVehicleAttributesDefinedViewArgs = {
  distinct_on?: InputMaybe<Array<VehicleAttributesDefinedView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleAttributesDefinedView_Order_By>>;
  where?: InputMaybe<VehicleAttributesDefinedView_Bool_Exp>;
};


export type Subscription_RootSelectVehicleAttributesDefinedViewAggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleAttributesDefinedView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleAttributesDefinedView_Order_By>>;
  where?: InputMaybe<VehicleAttributesDefinedView_Bool_Exp>;
};


export type Subscription_RootSelectVehicleClassingBodyStyleAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingBodyStyle_Order_By>>;
  where?: InputMaybe<VehicleClassingBodyStyle_Bool_Exp>;
};


export type Subscription_RootSelectVehicleClassingBodyStylesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingBodyStyle_Order_By>>;
  where?: InputMaybe<VehicleClassingBodyStyle_Bool_Exp>;
};


export type Subscription_RootSelectVehicleClassingFuelTypeAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingFuelType_Order_By>>;
  where?: InputMaybe<VehicleClassingFuelType_Bool_Exp>;
};


export type Subscription_RootSelectVehicleClassingFuelTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingFuelType_Order_By>>;
  where?: InputMaybe<VehicleClassingFuelType_Bool_Exp>;
};


export type Subscription_RootSelectVehicleClassingVehicleMakeAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingVehicleMake_Order_By>>;
  where?: InputMaybe<VehicleClassingVehicleMake_Bool_Exp>;
};


export type Subscription_RootSelectVehicleClassingVehicleMakesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingVehicleMake_Order_By>>;
  where?: InputMaybe<VehicleClassingVehicleMake_Bool_Exp>;
};


export type Subscription_RootSelectVehicleClassingVehicleTypeAggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingVehicleType_Order_By>>;
  where?: InputMaybe<VehicleClassingVehicleType_Bool_Exp>;
};


export type Subscription_RootSelectVehicleClassingVehicleTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleClassingVehicleType_Order_By>>;
  where?: InputMaybe<VehicleClassingVehicleType_Bool_Exp>;
};


export type Subscription_RootSelectVehicleStatusTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectVehicleStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<VehicleStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleStatusType_Order_By>>;
  where?: InputMaybe<VehicleStatusType_Bool_Exp>;
};


export type Subscription_RootSelectVehicleStatusTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VehicleStatusType_Stream_Cursor_Input>>;
  where?: InputMaybe<VehicleStatusType_Bool_Exp>;
};


export type Subscription_RootSelectVehicleStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<VehicleStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VehicleStatusType_Order_By>>;
  where?: InputMaybe<VehicleStatusType_Bool_Exp>;
};


export type Subscription_RootSelectVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


export type Subscription_RootSelectVpicDecodeAlternativeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectVpicDecodeAlternativeAggregateArgs = {
  distinct_on?: InputMaybe<Array<VpicDecodeAlternative_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VpicDecodeAlternative_Order_By>>;
  where?: InputMaybe<VpicDecodeAlternative_Bool_Exp>;
};


export type Subscription_RootSelectVpicDecodeAlternativeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VpicDecodeAlternative_Stream_Cursor_Input>>;
  where?: InputMaybe<VpicDecodeAlternative_Bool_Exp>;
};


export type Subscription_RootSelectVpicDecodeAlternativesArgs = {
  distinct_on?: InputMaybe<Array<VpicDecodeAlternative_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VpicDecodeAlternative_Order_By>>;
  where?: InputMaybe<VpicDecodeAlternative_Bool_Exp>;
};


export type Subscription_RootSelectWorkStatusTypeArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelectWorkStatusTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<WorkStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkStatusType_Order_By>>;
  where?: InputMaybe<WorkStatusType_Bool_Exp>;
};


export type Subscription_RootSelectWorkStatusTypesArgs = {
  distinct_on?: InputMaybe<Array<WorkStatusType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkStatusType_Order_By>>;
  where?: InputMaybe<WorkStatusType_Bool_Exp>;
};


export type Subscription_RootSelectWorkflowStateTypeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSelectWorkflowStateTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<WorkflowStateType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkflowStateType_Order_By>>;
  where?: InputMaybe<WorkflowStateType_Bool_Exp>;
};


export type Subscription_RootSelectWorkflowStateTypesArgs = {
  distinct_on?: InputMaybe<Array<WorkflowStateType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkflowStateType_Order_By>>;
  where?: InputMaybe<WorkflowStateType_Bool_Exp>;
};


export type Subscription_RootSelectselectFilingLenderAggregateArgs = {
  distinct_on?: InputMaybe<Array<FilingLender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FilingLender_Order_By>>;
  where?: InputMaybe<FilingLender_Bool_Exp>;
};


export type Subscription_RootServiceCenter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ServiceCenter_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


export type Subscription_RootShared_Dealer_Alert_List_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shared_Dealer_Alert_List_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Shared_Dealer_Alert_List_View_Bool_Exp>;
};


export type Subscription_RootShared_Search_ResultArgs = {
  distinct_on?: InputMaybe<Array<Shared_Search_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Search_Result_Order_By>>;
  where?: InputMaybe<Shared_Search_Result_Bool_Exp>;
};


export type Subscription_RootShared_Search_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shared_Search_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shared_Search_Result_Order_By>>;
  where?: InputMaybe<Shared_Search_Result_Bool_Exp>;
};


export type Subscription_RootShared_Search_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shared_Search_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Shared_Search_Result_Bool_Exp>;
};


export type Subscription_RootState_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<State_Stream_Cursor_Input>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Subscription_RootSurchargeType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SurchargeType_Stream_Cursor_Input>>;
  where?: InputMaybe<SurchargeType_Bool_Exp>;
};


export type Subscription_RootTag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootTask_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Task_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootUserGroup_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroup_Stream_Cursor_Input>>;
  where?: InputMaybe<UserGroup_Bool_Exp>;
};


export type Subscription_RootUserPin_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserPin_Stream_Cursor_Input>>;
  where?: InputMaybe<UserPin_Bool_Exp>;
};


export type Subscription_RootUserProfile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserProfile_Stream_Cursor_Input>>;
  where?: InputMaybe<UserProfile_Bool_Exp>;
};


export type Subscription_RootUserSession_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserSession_Stream_Cursor_Input>>;
  where?: InputMaybe<UserSession_Bool_Exp>;
};


export type Subscription_RootVNcsaBodyTypeArgs = {
  distinct_on?: InputMaybe<Array<VNcsaBodyType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaBodyType_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaBodyType_Bool_Exp_Vpic>;
};


export type Subscription_RootVNcsaBodyType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VNcsaBodyType_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaBodyType_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaBodyType_Bool_Exp_Vpic>;
};


export type Subscription_RootVNcsaBodyType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VNcsaBodyType_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VNcsaBodyType_Bool_Exp_Vpic>;
};


export type Subscription_RootVNcsaMakeArgs = {
  distinct_on?: InputMaybe<Array<VNcsaMake_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaMake_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaMake_Bool_Exp_Vpic>;
};


export type Subscription_RootVNcsaMake_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VNcsaMake_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaMake_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaMake_Bool_Exp_Vpic>;
};


export type Subscription_RootVNcsaMake_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VNcsaMake_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VNcsaMake_Bool_Exp_Vpic>;
};


export type Subscription_RootVNcsaModelArgs = {
  distinct_on?: InputMaybe<Array<VNcsaModel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaModel_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaModel_Bool_Exp_Vpic>;
};


export type Subscription_RootVNcsaModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<VNcsaModel_Select_Column_Vpic>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VNcsaModel_Order_By_Vpic>>;
  where?: InputMaybe<VNcsaModel_Bool_Exp_Vpic>;
};


export type Subscription_RootVNcsaModel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VNcsaModel_Stream_Cursor_Input_Vpic>>;
  where?: InputMaybe<VNcsaModel_Bool_Exp_Vpic>;
};


export type Subscription_RootValidationLifecycleHook_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ValidationLifecycleHook_Stream_Cursor_Input>>;
  where?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
};


export type Subscription_RootValidationOverride_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ValidationOverride_Stream_Cursor_Input>>;
  where?: InputMaybe<ValidationOverride_Bool_Exp>;
};


export type Subscription_RootValidationRuleFor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ValidationRuleFor_Stream_Cursor_Input>>;
  where?: InputMaybe<ValidationRuleFor_Bool_Exp>;
};


export type Subscription_RootValidationWhen_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ValidationWhen_Stream_Cursor_Input>>;
  where?: InputMaybe<ValidationWhen_Bool_Exp>;
};


export type Subscription_RootValidation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Validation_Stream_Cursor_Input>>;
  where?: InputMaybe<Validation_Bool_Exp>;
};


export type Subscription_RootVehicleAttributesDefinedView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VehicleAttributesDefinedView_Stream_Cursor_Input>>;
  where?: InputMaybe<VehicleAttributesDefinedView_Bool_Exp>;
};


export type Subscription_RootVehicle_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vehicle_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


export type Subscription_RootViewerShortcutBindingsArgs = {
  distinct_on?: InputMaybe<Array<ShortcutBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShortcutBinding_Order_By>>;
  where?: InputMaybe<ShortcutBinding_Bool_Exp>;
};


export type Subscription_RootViewerShortcutBindings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShortcutBinding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShortcutBinding_Order_By>>;
  where?: InputMaybe<ShortcutBinding_Bool_Exp>;
};


export type Subscription_RootVwVehicleCylindersDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleCylindersDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleCylindersDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleCylindersDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleCylindersDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleCylindersDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleDrivingWheelsDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleDrivingWheelsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleDrivingWheelsDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleDrivingWheelsDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleDrivingWheelsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleDrivingWheelsDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleFuelTypesDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleFuelTypesDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleFuelTypesDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleFuelTypesDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleFuelTypesDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleFuelTypesDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleMakesDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleMakesDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleMakesDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleMakesDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleMakesDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleMakesDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleModelsDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleModelsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleModelsDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleModelsDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleModelsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleModelsDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleYearsDistinctArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleYearsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleYearsDistinct_Bool_Exp>;
};


export type Subscription_RootVwVehicleYearsDistinct_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VwVehicleYearsDistinct_Order_By>>;
  where?: InputMaybe<VwVehicleYearsDistinct_Bool_Exp>;
};


export type Subscription_RootWorkStatusType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WorkStatusType_Stream_Cursor_Input>>;
  where?: InputMaybe<WorkStatusType_Bool_Exp>;
};


export type Subscription_RootWorkflowStateType_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WorkflowStateType_Stream_Cursor_Input>>;
  where?: InputMaybe<WorkflowStateType_Bool_Exp>;
};

/** columns and relationships of "surcharge_type" */
export type SurchargeType = {
  __typename?: 'surchargeType';
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  productSurchargeTypes: Array<ProductSurchargeType>;
  /** An aggregate relationship */
  productSurchargeTypes_aggregate: ProductSurchargeType_Aggregate;
};


/** columns and relationships of "surcharge_type" */
export type SurchargeTypeProductSurchargeTypesArgs = {
  distinct_on?: InputMaybe<Array<ProductSurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductSurchargeType_Order_By>>;
  where?: InputMaybe<ProductSurchargeType_Bool_Exp>;
};


/** columns and relationships of "surcharge_type" */
export type SurchargeTypeProductSurchargeTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductSurchargeType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductSurchargeType_Order_By>>;
  where?: InputMaybe<ProductSurchargeType_Bool_Exp>;
};

/** aggregated selection of "surcharge_type" */
export type SurchargeType_Aggregate = {
  __typename?: 'surchargeType_aggregate';
  aggregate?: Maybe<SurchargeType_Aggregate_Fields>;
  nodes: Array<SurchargeType>;
};

/** aggregate fields of "surcharge_type" */
export type SurchargeType_Aggregate_Fields = {
  __typename?: 'surchargeType_aggregate_fields';
  avg?: Maybe<SurchargeType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SurchargeType_Max_Fields>;
  min?: Maybe<SurchargeType_Min_Fields>;
  stddev?: Maybe<SurchargeType_Stddev_Fields>;
  stddev_pop?: Maybe<SurchargeType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SurchargeType_Stddev_Samp_Fields>;
  sum?: Maybe<SurchargeType_Sum_Fields>;
  var_pop?: Maybe<SurchargeType_Var_Pop_Fields>;
  var_samp?: Maybe<SurchargeType_Var_Samp_Fields>;
  variance?: Maybe<SurchargeType_Variance_Fields>;
};


/** aggregate fields of "surcharge_type" */
export type SurchargeType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SurchargeType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SurchargeType_Avg_Fields = {
  __typename?: 'surchargeType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "surcharge_type". All fields are combined with a logical 'AND'. */
export type SurchargeType_Bool_Exp = {
  _and?: InputMaybe<Array<SurchargeType_Bool_Exp>>;
  _not?: InputMaybe<SurchargeType_Bool_Exp>;
  _or?: InputMaybe<Array<SurchargeType_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  productSurchargeTypes?: InputMaybe<ProductSurchargeType_Bool_Exp>;
  productSurchargeTypes_aggregate?: InputMaybe<ProductSurchargeType_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "surcharge_type" */
export enum SurchargeType_Constraint {
  /** unique or primary key constraint on columns "id" */
  SurchargeTypePkey = 'surcharge_type_pkey'
}

/** input type for incrementing numeric columns in table "surcharge_type" */
export type SurchargeType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "surcharge_type" */
export type SurchargeType_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productSurchargeTypes?: InputMaybe<ProductSurchargeType_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type SurchargeType_Max_Fields = {
  __typename?: 'surchargeType_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SurchargeType_Min_Fields = {
  __typename?: 'surchargeType_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "surcharge_type" */
export type SurchargeType_Mutation_Response = {
  __typename?: 'surchargeType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SurchargeType>;
};

/** input type for inserting object relation for remote table "surcharge_type" */
export type SurchargeType_Obj_Rel_Insert_Input = {
  data: SurchargeType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SurchargeType_On_Conflict>;
};

/** on_conflict condition type for table "surcharge_type" */
export type SurchargeType_On_Conflict = {
  constraint: SurchargeType_Constraint;
  update_columns?: Array<SurchargeType_Update_Column>;
  where?: InputMaybe<SurchargeType_Bool_Exp>;
};

/** Ordering options when selecting data from "surcharge_type". */
export type SurchargeType_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  productSurchargeTypes_aggregate?: InputMaybe<ProductSurchargeType_Aggregate_Order_By>;
};

/** primary key columns input for table: surcharge_type */
export type SurchargeType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "surcharge_type" */
export enum SurchargeType_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "surcharge_type" */
export type SurchargeType_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SurchargeType_Stddev_Fields = {
  __typename?: 'surchargeType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SurchargeType_Stddev_Pop_Fields = {
  __typename?: 'surchargeType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SurchargeType_Stddev_Samp_Fields = {
  __typename?: 'surchargeType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "surchargeType" */
export type SurchargeType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SurchargeType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SurchargeType_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SurchargeType_Sum_Fields = {
  __typename?: 'surchargeType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "surcharge_type" */
export enum SurchargeType_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type SurchargeType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SurchargeType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SurchargeType_Set_Input>;
  /** filter the rows which have to be updated */
  where: SurchargeType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SurchargeType_Var_Pop_Fields = {
  __typename?: 'surchargeType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SurchargeType_Var_Samp_Fields = {
  __typename?: 'surchargeType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SurchargeType_Variance_Fields = {
  __typename?: 'surchargeType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Tags are used to mark an entity with a user defined named tag. */
export type Tag = {
  __typename?: 'tag';
  /** An object relationship */
  application?: Maybe<Application>;
  applicationId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  entityTags: Array<EntityTag>;
  /** An aggregate relationship */
  entityTags_aggregate: EntityTag_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  meta?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** Tags are used to mark an entity with a user defined named tag. */
export type TagEntityTagsArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** Tags are used to mark an entity with a user defined named tag. */
export type TagEntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityTag_Order_By>>;
  where?: InputMaybe<EntityTag_Bool_Exp>;
};


/** Tags are used to mark an entity with a user defined named tag. */
export type TagLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** Tags are used to mark an entity with a user defined named tag. */
export type TagLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** Tags are used to mark an entity with a user defined named tag. */
export type TagMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "shared.tag" */
export type Tag_Aggregate = {
  __typename?: 'tag_aggregate';
  aggregate?: Maybe<Tag_Aggregate_Fields>;
  nodes: Array<Tag>;
};

/** aggregate fields of "shared.tag" */
export type Tag_Aggregate_Fields = {
  __typename?: 'tag_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tag_Max_Fields>;
  min?: Maybe<Tag_Min_Fields>;
};


/** aggregate fields of "shared.tag" */
export type Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tag_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "shared.tag". All fields are combined with a logical 'AND'. */
export type Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Bool_Exp>>;
  _not?: InputMaybe<Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Bool_Exp>>;
  application?: InputMaybe<Application_Bool_Exp>;
  applicationId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityTags?: InputMaybe<EntityTag_Bool_Exp>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.tag" */
export enum Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  TagPkey = 'tag_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tag_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tag_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tag_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "shared.tag" */
export type Tag_Insert_Input = {
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  entityTags?: InputMaybe<EntityTag_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Tag_Max_Fields = {
  __typename?: 'tag_max_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Tag_Min_Fields = {
  __typename?: 'tag_min_fields';
  applicationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shared.tag" */
export type Tag_Mutation_Response = {
  __typename?: 'tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag>;
};

/** input type for inserting object relation for remote table "shared.tag" */
export type Tag_Obj_Rel_Insert_Input = {
  data: Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};

/** on_conflict condition type for table "shared.tag" */
export type Tag_On_Conflict = {
  constraint: Tag_Constraint;
  update_columns?: Array<Tag_Update_Column>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.tag". */
export type Tag_Order_By = {
  application?: InputMaybe<Application_Order_By>;
  applicationId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  entityTags_aggregate?: InputMaybe<EntityTag_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.tag */
export type Tag_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tag_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shared.tag" */
export enum Tag_Select_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.tag" */
export type Tag_Set_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "tag" */
export type Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Stream_Cursor_Value_Input = {
  applicationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.tag" */
export enum Tag_Update_Column {
  /** column name */
  ApplicationId = 'applicationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Tag_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tag_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tag_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tag_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tag_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tag_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Bool_Exp;
};

/** columns and relationships of "task" */
export type Task = {
  __typename?: 'task';
  createdAt: Scalars['timestamptz'];
  diagnosisHoursAmount: Scalars['numeric'];
  id: Scalars['uuid'];
  jobId: Scalars['uuid'];
  laborHoursAmount: Scalars['numeric'];
  partCostAmount: Scalars['numeric'];
  partName: Scalars['String'];
  partNumber: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "task" */
export type Task_Aggregate = {
  __typename?: 'task_aggregate';
  aggregate?: Maybe<Task_Aggregate_Fields>;
  nodes: Array<Task>;
};

export type Task_Aggregate_Bool_Exp = {
  count?: InputMaybe<Task_Aggregate_Bool_Exp_Count>;
};

export type Task_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Task_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "task" */
export type Task_Aggregate_Fields = {
  __typename?: 'task_aggregate_fields';
  avg?: Maybe<Task_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Task_Max_Fields>;
  min?: Maybe<Task_Min_Fields>;
  stddev?: Maybe<Task_Stddev_Fields>;
  stddev_pop?: Maybe<Task_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Task_Stddev_Samp_Fields>;
  sum?: Maybe<Task_Sum_Fields>;
  var_pop?: Maybe<Task_Var_Pop_Fields>;
  var_samp?: Maybe<Task_Var_Samp_Fields>;
  variance?: Maybe<Task_Variance_Fields>;
};


/** aggregate fields of "task" */
export type Task_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "task" */
export type Task_Aggregate_Order_By = {
  avg?: InputMaybe<Task_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Max_Order_By>;
  min?: InputMaybe<Task_Min_Order_By>;
  stddev?: InputMaybe<Task_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Task_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Task_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Task_Sum_Order_By>;
  var_pop?: InputMaybe<Task_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Task_Var_Samp_Order_By>;
  variance?: InputMaybe<Task_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "task" */
export type Task_Arr_Rel_Insert_Input = {
  data: Array<Task_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_On_Conflict>;
};

/** aggregate avg on columns */
export type Task_Avg_Fields = {
  __typename?: 'task_avg_fields';
  diagnosisHoursAmount?: Maybe<Scalars['Float']>;
  laborHoursAmount?: Maybe<Scalars['Float']>;
  partCostAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "task" */
export type Task_Avg_Order_By = {
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "task". All fields are combined with a logical 'AND'. */
export type Task_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Bool_Exp>>;
  _not?: InputMaybe<Task_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  diagnosisHoursAmount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobId?: InputMaybe<Uuid_Comparison_Exp>;
  laborHoursAmount?: InputMaybe<Numeric_Comparison_Exp>;
  partCostAmount?: InputMaybe<Numeric_Comparison_Exp>;
  partName?: InputMaybe<String_Comparison_Exp>;
  partNumber?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "task" */
export enum Task_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskPkey = 'task_pkey'
}

/** input type for incrementing numeric columns in table "task" */
export type Task_Inc_Input = {
  diagnosisHoursAmount?: InputMaybe<Scalars['numeric']>;
  laborHoursAmount?: InputMaybe<Scalars['numeric']>;
  partCostAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "task" */
export type Task_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  diagnosisHoursAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  laborHoursAmount?: InputMaybe<Scalars['numeric']>;
  partCostAmount?: InputMaybe<Scalars['numeric']>;
  partName?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Task_Max_Fields = {
  __typename?: 'task_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  diagnosisHoursAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['uuid']>;
  laborHoursAmount?: Maybe<Scalars['numeric']>;
  partCostAmount?: Maybe<Scalars['numeric']>;
  partName?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "task" */
export type Task_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
  partName?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Task_Min_Fields = {
  __typename?: 'task_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  diagnosisHoursAmount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['uuid']>;
  laborHoursAmount?: Maybe<Scalars['numeric']>;
  partCostAmount?: Maybe<Scalars['numeric']>;
  partName?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "task" */
export type Task_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
  partName?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task" */
export type Task_Mutation_Response = {
  __typename?: 'task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Task>;
};

/** on_conflict condition type for table "task" */
export type Task_On_Conflict = {
  constraint: Task_Constraint;
  update_columns?: Array<Task_Update_Column>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** Ordering options when selecting data from "task". */
export type Task_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
  partName?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task */
export type Task_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "task" */
export enum Task_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiagnosisHoursAmount = 'diagnosisHoursAmount',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'jobId',
  /** column name */
  LaborHoursAmount = 'laborHoursAmount',
  /** column name */
  PartCostAmount = 'partCostAmount',
  /** column name */
  PartName = 'partName',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "task" */
export type Task_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  diagnosisHoursAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  laborHoursAmount?: InputMaybe<Scalars['numeric']>;
  partCostAmount?: InputMaybe<Scalars['numeric']>;
  partName?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Task_Stddev_Fields = {
  __typename?: 'task_stddev_fields';
  diagnosisHoursAmount?: Maybe<Scalars['Float']>;
  laborHoursAmount?: Maybe<Scalars['Float']>;
  partCostAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "task" */
export type Task_Stddev_Order_By = {
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Task_Stddev_Pop_Fields = {
  __typename?: 'task_stddev_pop_fields';
  diagnosisHoursAmount?: Maybe<Scalars['Float']>;
  laborHoursAmount?: Maybe<Scalars['Float']>;
  partCostAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "task" */
export type Task_Stddev_Pop_Order_By = {
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Task_Stddev_Samp_Fields = {
  __typename?: 'task_stddev_samp_fields';
  diagnosisHoursAmount?: Maybe<Scalars['Float']>;
  laborHoursAmount?: Maybe<Scalars['Float']>;
  partCostAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "task" */
export type Task_Stddev_Samp_Order_By = {
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "task" */
export type Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  diagnosisHoursAmount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  laborHoursAmount?: InputMaybe<Scalars['numeric']>;
  partCostAmount?: InputMaybe<Scalars['numeric']>;
  partName?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Task_Sum_Fields = {
  __typename?: 'task_sum_fields';
  diagnosisHoursAmount?: Maybe<Scalars['numeric']>;
  laborHoursAmount?: Maybe<Scalars['numeric']>;
  partCostAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "task" */
export type Task_Sum_Order_By = {
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
};

/** update columns of table "task" */
export enum Task_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiagnosisHoursAmount = 'diagnosisHoursAmount',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'jobId',
  /** column name */
  LaborHoursAmount = 'laborHoursAmount',
  /** column name */
  PartCostAmount = 'partCostAmount',
  /** column name */
  PartName = 'partName',
  /** column name */
  PartNumber = 'partNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Task_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Task_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Task_Var_Pop_Fields = {
  __typename?: 'task_var_pop_fields';
  diagnosisHoursAmount?: Maybe<Scalars['Float']>;
  laborHoursAmount?: Maybe<Scalars['Float']>;
  partCostAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "task" */
export type Task_Var_Pop_Order_By = {
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Task_Var_Samp_Fields = {
  __typename?: 'task_var_samp_fields';
  diagnosisHoursAmount?: Maybe<Scalars['Float']>;
  laborHoursAmount?: Maybe<Scalars['Float']>;
  partCostAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "task" */
export type Task_Var_Samp_Order_By = {
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Task_Variance_Fields = {
  __typename?: 'task_variance_fields';
  diagnosisHoursAmount?: Maybe<Scalars['Float']>;
  laborHoursAmount?: Maybe<Scalars['Float']>;
  partCostAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "task" */
export type Task_Variance_Order_By = {
  diagnosisHoursAmount?: InputMaybe<Order_By>;
  laborHoursAmount?: InputMaybe<Order_By>;
  partCostAmount?: InputMaybe<Order_By>;
};

/** columns and relationships of "claims.tax_rate" */
export type TaxRate = {
  __typename?: 'taxRate';
  createdAt: Scalars['timestamptz'];
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent: Scalars['numeric'];
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate: Scalars['numeric'];
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent: Scalars['numeric'];
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate: Scalars['numeric'];
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  /** An object relationship */
  serviceCenter: ServiceCenter;
  serviceCenterId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "claims.tax_rate" */
export type TaxRateLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** columns and relationships of "claims.tax_rate" */
export type TaxRateLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};

/** Shows which tax rates were written by the dealer_labor sync */
export type TaxRateAs400 = {
  __typename?: 'taxRateAs400';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  taxRate: TaxRate;
  /** The tax rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a tax rate that has a row here. */
  taxRateId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "claims.tax_rate_as400" */
export type TaxRateAs400_Aggregate = {
  __typename?: 'taxRateAs400_aggregate';
  aggregate?: Maybe<TaxRateAs400_Aggregate_Fields>;
  nodes: Array<TaxRateAs400>;
};

/** aggregate fields of "claims.tax_rate_as400" */
export type TaxRateAs400_Aggregate_Fields = {
  __typename?: 'taxRateAs400_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TaxRateAs400_Max_Fields>;
  min?: Maybe<TaxRateAs400_Min_Fields>;
};


/** aggregate fields of "claims.tax_rate_as400" */
export type TaxRateAs400_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TaxRateAs400_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "claims.tax_rate_as400". All fields are combined with a logical 'AND'. */
export type TaxRateAs400_Bool_Exp = {
  _and?: InputMaybe<Array<TaxRateAs400_Bool_Exp>>;
  _not?: InputMaybe<TaxRateAs400_Bool_Exp>;
  _or?: InputMaybe<Array<TaxRateAs400_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  taxRate?: InputMaybe<TaxRate_Bool_Exp>;
  taxRateId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.tax_rate_as400" */
export enum TaxRateAs400_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaxRateAs400Pkey = 'tax_rate_as400_pkey',
  /** unique or primary key constraint on columns "tax_rate_id" */
  TaxRateAs400TaxRateIdKey = 'tax_rate_as400_tax_rate_id_key'
}

/** input type for inserting data into table "claims.tax_rate_as400" */
export type TaxRateAs400_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  taxRate?: InputMaybe<TaxRate_Obj_Rel_Insert_Input>;
  /** The tax rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a tax rate that has a row here. */
  taxRateId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type TaxRateAs400_Max_Fields = {
  __typename?: 'taxRateAs400_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The tax rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a tax rate that has a row here. */
  taxRateId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type TaxRateAs400_Min_Fields = {
  __typename?: 'taxRateAs400_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The tax rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a tax rate that has a row here. */
  taxRateId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.tax_rate_as400" */
export type TaxRateAs400_Mutation_Response = {
  __typename?: 'taxRateAs400_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TaxRateAs400>;
};

/** on_conflict condition type for table "claims.tax_rate_as400" */
export type TaxRateAs400_On_Conflict = {
  constraint: TaxRateAs400_Constraint;
  update_columns?: Array<TaxRateAs400_Update_Column>;
  where?: InputMaybe<TaxRateAs400_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.tax_rate_as400". */
export type TaxRateAs400_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  taxRate?: InputMaybe<TaxRate_Order_By>;
  taxRateId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.tax_rate_as400 */
export type TaxRateAs400_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.tax_rate_as400" */
export enum TaxRateAs400_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  TaxRateId = 'taxRateId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.tax_rate_as400" */
export type TaxRateAs400_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The tax rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a tax rate that has a row here. */
  taxRateId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "taxRateAs400" */
export type TaxRateAs400_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TaxRateAs400_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TaxRateAs400_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The tax rate this row marks as sync-written. Read by the dealer_labor import, which only deletes or overwrites a tax rate that has a row here. */
  taxRateId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "claims.tax_rate_as400" */
export enum TaxRateAs400_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  TaxRateId = 'taxRateId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type TaxRateAs400_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaxRateAs400_Set_Input>;
  /** filter the rows which have to be updated */
  where: TaxRateAs400_Bool_Exp;
};

/** aggregated selection of "claims.tax_rate" */
export type TaxRate_Aggregate = {
  __typename?: 'taxRate_aggregate';
  aggregate?: Maybe<TaxRate_Aggregate_Fields>;
  nodes: Array<TaxRate>;
};

export type TaxRate_Aggregate_Bool_Exp = {
  count?: InputMaybe<TaxRate_Aggregate_Bool_Exp_Count>;
};

export type TaxRate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<TaxRate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TaxRate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "claims.tax_rate" */
export type TaxRate_Aggregate_Fields = {
  __typename?: 'taxRate_aggregate_fields';
  avg?: Maybe<TaxRate_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<TaxRate_Max_Fields>;
  min?: Maybe<TaxRate_Min_Fields>;
  stddev?: Maybe<TaxRate_Stddev_Fields>;
  stddev_pop?: Maybe<TaxRate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TaxRate_Stddev_Samp_Fields>;
  sum?: Maybe<TaxRate_Sum_Fields>;
  var_pop?: Maybe<TaxRate_Var_Pop_Fields>;
  var_samp?: Maybe<TaxRate_Var_Samp_Fields>;
  variance?: Maybe<TaxRate_Variance_Fields>;
};


/** aggregate fields of "claims.tax_rate" */
export type TaxRate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TaxRate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "claims.tax_rate" */
export type TaxRate_Aggregate_Order_By = {
  avg?: InputMaybe<TaxRate_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TaxRate_Max_Order_By>;
  min?: InputMaybe<TaxRate_Min_Order_By>;
  stddev?: InputMaybe<TaxRate_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TaxRate_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TaxRate_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TaxRate_Sum_Order_By>;
  var_pop?: InputMaybe<TaxRate_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TaxRate_Var_Samp_Order_By>;
  variance?: InputMaybe<TaxRate_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "claims.tax_rate" */
export type TaxRate_Arr_Rel_Insert_Input = {
  data: Array<TaxRate_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<TaxRate_On_Conflict>;
};

/** aggregate avg on columns */
export type TaxRate_Avg_Fields = {
  __typename?: 'taxRate_avg_fields';
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: Maybe<Scalars['Float']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: Maybe<Scalars['Float']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: Maybe<Scalars['Float']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "claims.tax_rate" */
export type TaxRate_Avg_Order_By = {
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Order_By>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Order_By>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Order_By>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "claims.tax_rate". All fields are combined with a logical 'AND'. */
export type TaxRate_Bool_Exp = {
  _and?: InputMaybe<Array<TaxRate_Bool_Exp>>;
  _not?: InputMaybe<TaxRate_Bool_Exp>;
  _or?: InputMaybe<Array<TaxRate_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  itemTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  itemTaxRate?: InputMaybe<Numeric_Comparison_Exp>;
  laborTaxPercent?: InputMaybe<Numeric_Comparison_Exp>;
  laborTaxRate?: InputMaybe<Numeric_Comparison_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  serviceCenter?: InputMaybe<ServiceCenter_Bool_Exp>;
  serviceCenterId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.tax_rate" */
export enum TaxRate_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaxRatePkey = 'tax_rate_pkey',
  /** unique or primary key constraint on columns "service_center_id", "effective_date" */
  TaxRateServiceCenterIdEffectiveDateKey = 'tax_rate_service_center_id_effective_date_key'
}

/** input type for incrementing numeric columns in table "claims.tax_rate" */
export type TaxRate_Inc_Input = {
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Scalars['numeric']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Scalars['numeric']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "claims.tax_rate" */
export type TaxRate_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Scalars['numeric']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Scalars['numeric']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  serviceCenter?: InputMaybe<ServiceCenter_Obj_Rel_Insert_Input>;
  serviceCenterId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type TaxRate_Max_Fields = {
  __typename?: 'taxRate_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: Maybe<Scalars['numeric']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: Maybe<Scalars['numeric']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: Maybe<Scalars['numeric']>;
  serviceCenterId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "claims.tax_rate" */
export type TaxRate_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Order_By>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Order_By>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Order_By>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Order_By>;
  serviceCenterId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TaxRate_Min_Fields = {
  __typename?: 'taxRate_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: Maybe<Scalars['numeric']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: Maybe<Scalars['numeric']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: Maybe<Scalars['numeric']>;
  serviceCenterId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "claims.tax_rate" */
export type TaxRate_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Order_By>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Order_By>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Order_By>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Order_By>;
  serviceCenterId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "claims.tax_rate" */
export type TaxRate_Mutation_Response = {
  __typename?: 'taxRate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TaxRate>;
};

/** input type for inserting object relation for remote table "claims.tax_rate" */
export type TaxRate_Obj_Rel_Insert_Input = {
  data: TaxRate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<TaxRate_On_Conflict>;
};

/** on_conflict condition type for table "claims.tax_rate" */
export type TaxRate_On_Conflict = {
  constraint: TaxRate_Constraint;
  update_columns?: Array<TaxRate_Update_Column>;
  where?: InputMaybe<TaxRate_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.tax_rate". */
export type TaxRate_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemTaxPercent?: InputMaybe<Order_By>;
  itemTaxRate?: InputMaybe<Order_By>;
  laborTaxPercent?: InputMaybe<Order_By>;
  laborTaxRate?: InputMaybe<Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  serviceCenter?: InputMaybe<ServiceCenter_Order_By>;
  serviceCenterId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.tax_rate */
export type TaxRate_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.tax_rate" */
export enum TaxRate_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ItemTaxPercent = 'itemTaxPercent',
  /** column name */
  ItemTaxRate = 'itemTaxRate',
  /** column name */
  LaborTaxPercent = 'laborTaxPercent',
  /** column name */
  LaborTaxRate = 'laborTaxRate',
  /** column name */
  ServiceCenterId = 'serviceCenterId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.tax_rate" */
export type TaxRate_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Scalars['numeric']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Scalars['numeric']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
  serviceCenterId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type TaxRate_Stddev_Fields = {
  __typename?: 'taxRate_stddev_fields';
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: Maybe<Scalars['Float']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: Maybe<Scalars['Float']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: Maybe<Scalars['Float']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "claims.tax_rate" */
export type TaxRate_Stddev_Order_By = {
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Order_By>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Order_By>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Order_By>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type TaxRate_Stddev_Pop_Fields = {
  __typename?: 'taxRate_stddev_pop_fields';
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: Maybe<Scalars['Float']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: Maybe<Scalars['Float']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: Maybe<Scalars['Float']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "claims.tax_rate" */
export type TaxRate_Stddev_Pop_Order_By = {
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Order_By>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Order_By>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Order_By>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type TaxRate_Stddev_Samp_Fields = {
  __typename?: 'taxRate_stddev_samp_fields';
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: Maybe<Scalars['Float']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: Maybe<Scalars['Float']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: Maybe<Scalars['Float']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "claims.tax_rate" */
export type TaxRate_Stddev_Samp_Order_By = {
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Order_By>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Order_By>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Order_By>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "taxRate" */
export type TaxRate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TaxRate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TaxRate_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Scalars['numeric']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Scalars['numeric']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Scalars['numeric']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Scalars['numeric']>;
  serviceCenterId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type TaxRate_Sum_Fields = {
  __typename?: 'taxRate_sum_fields';
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: Maybe<Scalars['numeric']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: Maybe<Scalars['numeric']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: Maybe<Scalars['numeric']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "claims.tax_rate" */
export type TaxRate_Sum_Order_By = {
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Order_By>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Order_By>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Order_By>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Order_By>;
};

/** update columns of table "claims.tax_rate" */
export enum TaxRate_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  ItemTaxPercent = 'itemTaxPercent',
  /** column name */
  ItemTaxRate = 'itemTaxRate',
  /** column name */
  LaborTaxPercent = 'laborTaxPercent',
  /** column name */
  LaborTaxRate = 'laborTaxRate',
  /** column name */
  ServiceCenterId = 'serviceCenterId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type TaxRate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TaxRate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaxRate_Set_Input>;
  /** filter the rows which have to be updated */
  where: TaxRate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TaxRate_Var_Pop_Fields = {
  __typename?: 'taxRate_var_pop_fields';
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: Maybe<Scalars['Float']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: Maybe<Scalars['Float']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: Maybe<Scalars['Float']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "claims.tax_rate" */
export type TaxRate_Var_Pop_Order_By = {
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Order_By>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Order_By>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Order_By>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type TaxRate_Var_Samp_Fields = {
  __typename?: 'taxRate_var_samp_fields';
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: Maybe<Scalars['Float']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: Maybe<Scalars['Float']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: Maybe<Scalars['Float']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "claims.tax_rate" */
export type TaxRate_Var_Samp_Order_By = {
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Order_By>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Order_By>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Order_By>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type TaxRate_Variance_Fields = {
  __typename?: 'taxRate_variance_fields';
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: Maybe<Scalars['Float']>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: Maybe<Scalars['Float']>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: Maybe<Scalars['Float']>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "claims.tax_rate" */
export type TaxRate_Variance_Order_By = {
  /** Item tax as a percentage (e.g. 8.75). Synced with item_tax_rate via trigger — only one needs to be provided. */
  itemTaxPercent?: InputMaybe<Order_By>;
  /** Item tax as a decimal rate (e.g. 0.0875). Synced with item_tax_percent via trigger — only one needs to be provided. */
  itemTaxRate?: InputMaybe<Order_By>;
  /** Labor tax as a percentage (e.g. 8.75). Synced with labor_tax_rate via trigger — only one needs to be provided. */
  laborTaxPercent?: InputMaybe<Order_By>;
  /** Labor tax as a decimal rate (e.g. 0.0875). Synced with labor_tax_percent via trigger — only one needs to be provided. */
  laborTaxRate?: InputMaybe<Order_By>;
};

/** columns and relationships of "system.technology_type" */
export type TechnologyType = {
  __typename?: 'technologyType';
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  steps: Array<Step>;
  /** An aggregate relationship */
  steps_aggregate: Step_Aggregate;
};


/** columns and relationships of "system.technology_type" */
export type TechnologyTypeStepsArgs = {
  distinct_on?: InputMaybe<Array<Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Step_Order_By>>;
  where?: InputMaybe<Step_Bool_Exp>;
};


/** columns and relationships of "system.technology_type" */
export type TechnologyTypeSteps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Step_Order_By>>;
  where?: InputMaybe<Step_Bool_Exp>;
};

/** aggregated selection of "system.technology_type" */
export type TechnologyType_Aggregate = {
  __typename?: 'technologyType_aggregate';
  aggregate?: Maybe<TechnologyType_Aggregate_Fields>;
  nodes: Array<TechnologyType>;
};

/** aggregate fields of "system.technology_type" */
export type TechnologyType_Aggregate_Fields = {
  __typename?: 'technologyType_aggregate_fields';
  avg?: Maybe<TechnologyType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<TechnologyType_Max_Fields>;
  min?: Maybe<TechnologyType_Min_Fields>;
  stddev?: Maybe<TechnologyType_Stddev_Fields>;
  stddev_pop?: Maybe<TechnologyType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TechnologyType_Stddev_Samp_Fields>;
  sum?: Maybe<TechnologyType_Sum_Fields>;
  var_pop?: Maybe<TechnologyType_Var_Pop_Fields>;
  var_samp?: Maybe<TechnologyType_Var_Samp_Fields>;
  variance?: Maybe<TechnologyType_Variance_Fields>;
};


/** aggregate fields of "system.technology_type" */
export type TechnologyType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TechnologyType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TechnologyType_Avg_Fields = {
  __typename?: 'technologyType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "system.technology_type". All fields are combined with a logical 'AND'. */
export type TechnologyType_Bool_Exp = {
  _and?: InputMaybe<Array<TechnologyType_Bool_Exp>>;
  _not?: InputMaybe<TechnologyType_Bool_Exp>;
  _or?: InputMaybe<Array<TechnologyType_Bool_Exp>>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  steps?: InputMaybe<Step_Bool_Exp>;
  steps_aggregate?: InputMaybe<Step_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "system.technology_type" */
export enum TechnologyType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  TechnologyTypeEnumValueKey = 'technology_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  TechnologyTypePkey = 'technology_type_pkey'
}

/** input type for incrementing numeric columns in table "system.technology_type" */
export type TechnologyType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "system.technology_type" */
export type TechnologyType_Insert_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  steps?: InputMaybe<Step_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type TechnologyType_Max_Fields = {
  __typename?: 'technologyType_max_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TechnologyType_Min_Fields = {
  __typename?: 'technologyType_min_fields';
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "system.technology_type" */
export type TechnologyType_Mutation_Response = {
  __typename?: 'technologyType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TechnologyType>;
};

/** input type for inserting object relation for remote table "system.technology_type" */
export type TechnologyType_Obj_Rel_Insert_Input = {
  data: TechnologyType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<TechnologyType_On_Conflict>;
};

/** on_conflict condition type for table "system.technology_type" */
export type TechnologyType_On_Conflict = {
  constraint: TechnologyType_Constraint;
  update_columns?: Array<TechnologyType_Update_Column>;
  where?: InputMaybe<TechnologyType_Bool_Exp>;
};

/** Ordering options when selecting data from "system.technology_type". */
export type TechnologyType_Order_By = {
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  steps_aggregate?: InputMaybe<Step_Aggregate_Order_By>;
};

/** primary key columns input for table: system.technology_type */
export type TechnologyType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "system.technology_type" */
export enum TechnologyType_Select_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "system.technology_type" */
export type TechnologyType_Set_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TechnologyType_Stddev_Fields = {
  __typename?: 'technologyType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TechnologyType_Stddev_Pop_Fields = {
  __typename?: 'technologyType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TechnologyType_Stddev_Samp_Fields = {
  __typename?: 'technologyType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "technologyType" */
export type TechnologyType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TechnologyType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TechnologyType_Stream_Cursor_Value_Input = {
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TechnologyType_Sum_Fields = {
  __typename?: 'technologyType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "system.technology_type" */
export enum TechnologyType_Update_Column {
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type TechnologyType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TechnologyType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TechnologyType_Set_Input>;
  /** filter the rows which have to be updated */
  where: TechnologyType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TechnologyType_Var_Pop_Fields = {
  __typename?: 'technologyType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TechnologyType_Var_Samp_Fields = {
  __typename?: 'technologyType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TechnologyType_Variance_Fields = {
  __typename?: 'technologyType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['timestamp']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['timestamp']>>;
  _eq?: InputMaybe<Array<Scalars['timestamp']>>;
  _gt?: InputMaybe<Array<Scalars['timestamp']>>;
  _gte?: InputMaybe<Array<Scalars['timestamp']>>;
  _in?: InputMaybe<Array<Array<Scalars['timestamp']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['timestamp']>>;
  _lte?: InputMaybe<Array<Scalars['timestamp']>>;
  _neq?: InputMaybe<Array<Scalars['timestamp']>>;
  _nin?: InputMaybe<Array<Array<Scalars['timestamp']>>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "tsvector". All fields are combined with logical 'AND'. */
export type Tsvector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tsvector']>;
  _gt?: InputMaybe<Scalars['tsvector']>;
  _gte?: InputMaybe<Scalars['tsvector']>;
  _in?: InputMaybe<Array<Scalars['tsvector']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tsvector']>;
  _lte?: InputMaybe<Scalars['tsvector']>;
  _neq?: InputMaybe<Scalars['tsvector']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']>>;
};

/** This table contains types used for enums and dropdowns, etc. */
export type Type = {
  __typename?: 'type';
  /** An array relationship */
  claimDetails: Array<ClaimDetail>;
  /** An aggregate relationship */
  claimDetails_aggregate: ClaimDetail_Aggregate;
  code?: Maybe<Scalars['String']>;
  /** An array relationship */
  contentTypes: Array<ContentType>;
  /** An aggregate relationship */
  contentTypes_aggregate: ContentType_Aggregate;
  createdAt: Scalars['timestamptz'];
  display?: Maybe<Scalars['String']>;
  /** An array relationship */
  documentTemplates: Array<DocumentTemplate>;
  /** An aggregate relationship */
  documentTemplates_aggregate: DocumentTemplate_Aggregate;
  /** An array relationship */
  entityConfigurationItems: Array<EntityConfigurationItem>;
  /** An aggregate relationship */
  entityConfigurationItems_aggregate: EntityConfigurationItem_Aggregate;
  enumValue?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  /** Indicates whether the type is code-generated & System owned. Defaults to false so that user entered types are not codegenned. Developer entered types need to be explicity set to true if they need to be codegenned. */
  isCodegenned: Scalars['Boolean'];
  /** An array relationship */
  laborGuideClaimServiceCenters: Array<ClaimServiceCenter>;
  /** An aggregate relationship */
  laborGuideClaimServiceCenters_aggregate: ClaimServiceCenter_Aggregate;
  /** An array relationship */
  loggedActions: Array<LoggedAction>;
  /** An aggregate relationship */
  loggedActions_aggregate: LoggedAction_Aggregate;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  operationValidationTypes: Array<ValidationTypeOperation>;
  /** An aggregate relationship */
  operationValidationTypes_aggregate: ValidationTypeOperation_Aggregate;
  /** An array relationship */
  policyClaims: Array<PolicyClaim>;
  /** An aggregate relationship */
  policyClaims_aggregate: PolicyClaim_Aggregate;
  /** An array relationship */
  roleAttributes: Array<RoleAttribute>;
  /** An aggregate relationship */
  roleAttributes_aggregate: RoleAttribute_Aggregate;
  /** An array relationship */
  serviceCenters: Array<ServiceCenter>;
  /** An aggregate relationship */
  serviceCenters_aggregate: ServiceCenter_Aggregate;
  /** An object relationship */
  typeGroup?: Maybe<TypeGroup>;
  typeGroupId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  validationOperationTypes: Array<ValidationTypeOperation>;
  /** An aggregate relationship */
  validationOperationTypes_aggregate: ValidationTypeOperation_Aggregate;
  /** An array relationship */
  validationOverrides: Array<ValidationOverride>;
  /** An aggregate relationship */
  validationOverrides_aggregate: ValidationOverride_Aggregate;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeClaimDetailsArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeClaimDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimDetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimDetail_Order_By>>;
  where?: InputMaybe<ClaimDetail_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeContentTypesArgs = {
  distinct_on?: InputMaybe<Array<ContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentType_Order_By>>;
  where?: InputMaybe<ContentType_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeContentTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentType_Order_By>>;
  where?: InputMaybe<ContentType_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeDocumentTemplatesArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplate_Order_By>>;
  where?: InputMaybe<DocumentTemplate_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeDocumentTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DocumentTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DocumentTemplate_Order_By>>;
  where?: InputMaybe<DocumentTemplate_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeEntityConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeEntityConfigurationItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityConfigurationItem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EntityConfigurationItem_Order_By>>;
  where?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeLaborGuideClaimServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenter_Order_By>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeLaborGuideClaimServiceCenters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClaimServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClaimServiceCenter_Order_By>>;
  where?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeLoggedActionsArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeLoggedActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoggedAction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoggedAction_Order_By>>;
  where?: InputMaybe<LoggedAction_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeOperationValidationTypesArgs = {
  distinct_on?: InputMaybe<Array<ValidationTypeOperation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationTypeOperation_Order_By>>;
  where?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeOperationValidationTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationTypeOperation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationTypeOperation_Order_By>>;
  where?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypePolicyClaimsArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaim_Order_By>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypePolicyClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyClaim_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyClaim_Order_By>>;
  where?: InputMaybe<PolicyClaim_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeRoleAttributesArgs = {
  distinct_on?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleAttribute_Order_By>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeRoleAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleAttribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RoleAttribute_Order_By>>;
  where?: InputMaybe<RoleAttribute_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeServiceCentersArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeServiceCenters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceCenter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServiceCenter_Order_By>>;
  where?: InputMaybe<ServiceCenter_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeValidationOperationTypesArgs = {
  distinct_on?: InputMaybe<Array<ValidationTypeOperation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationTypeOperation_Order_By>>;
  where?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeValidationOperationTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationTypeOperation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationTypeOperation_Order_By>>;
  where?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeValidationOverridesArgs = {
  distinct_on?: InputMaybe<Array<ValidationOverride_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationOverride_Order_By>>;
  where?: InputMaybe<ValidationOverride_Bool_Exp>;
};


/** This table contains types used for enums and dropdowns, etc. */
export type TypeValidationOverrides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationOverride_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationOverride_Order_By>>;
  where?: InputMaybe<ValidationOverride_Bool_Exp>;
};

/** This table groups shared.type(s) together. */
export type TypeGroup = {
  __typename?: 'typeGroup';
  createdAt: Scalars['timestamptz'];
  display?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  types: Array<Type>;
  /** An aggregate relationship */
  types_aggregate: Type_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** This table groups shared.type(s) together. */
export type TypeGroupTypesArgs = {
  distinct_on?: InputMaybe<Array<Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Type_Order_By>>;
  where?: InputMaybe<Type_Bool_Exp>;
};


/** This table groups shared.type(s) together. */
export type TypeGroupTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Type_Order_By>>;
  where?: InputMaybe<Type_Bool_Exp>;
};

/** aggregated selection of "shared.type_group" */
export type TypeGroup_Aggregate = {
  __typename?: 'typeGroup_aggregate';
  aggregate?: Maybe<TypeGroup_Aggregate_Fields>;
  nodes: Array<TypeGroup>;
};

/** aggregate fields of "shared.type_group" */
export type TypeGroup_Aggregate_Fields = {
  __typename?: 'typeGroup_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TypeGroup_Max_Fields>;
  min?: Maybe<TypeGroup_Min_Fields>;
};


/** aggregate fields of "shared.type_group" */
export type TypeGroup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TypeGroup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "shared.type_group". All fields are combined with a logical 'AND'. */
export type TypeGroup_Bool_Exp = {
  _and?: InputMaybe<Array<TypeGroup_Bool_Exp>>;
  _not?: InputMaybe<TypeGroup_Bool_Exp>;
  _or?: InputMaybe<Array<TypeGroup_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  types?: InputMaybe<Type_Bool_Exp>;
  types_aggregate?: InputMaybe<Type_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.type_group" */
export enum TypeGroup_Constraint {
  /** unique or primary key constraint on columns "name" */
  TypeGroupNameKey = 'type_group_name_key',
  /** unique or primary key constraint on columns "id" */
  TypeGroupPkey = 'type_group_pkey'
}

/** input type for inserting data into table "shared.type_group" */
export type TypeGroup_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Type_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type TypeGroup_Max_Fields = {
  __typename?: 'typeGroup_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type TypeGroup_Min_Fields = {
  __typename?: 'typeGroup_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shared.type_group" */
export type TypeGroup_Mutation_Response = {
  __typename?: 'typeGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TypeGroup>;
};

/** input type for inserting object relation for remote table "shared.type_group" */
export type TypeGroup_Obj_Rel_Insert_Input = {
  data: TypeGroup_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<TypeGroup_On_Conflict>;
};

/** on_conflict condition type for table "shared.type_group" */
export type TypeGroup_On_Conflict = {
  constraint: TypeGroup_Constraint;
  update_columns?: Array<TypeGroup_Update_Column>;
  where?: InputMaybe<TypeGroup_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.type_group". */
export type TypeGroup_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  types_aggregate?: InputMaybe<Type_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.type_group */
export type TypeGroup_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.type_group" */
export enum TypeGroup_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.type_group" */
export type TypeGroup_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "typeGroup" */
export type TypeGroup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TypeGroup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TypeGroup_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.type_group" */
export enum TypeGroup_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type TypeGroup_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TypeGroup_Set_Input>;
  /** filter the rows which have to be updated */
  where: TypeGroup_Bool_Exp;
};

/** aggregated selection of "shared.type" */
export type Type_Aggregate = {
  __typename?: 'type_aggregate';
  aggregate?: Maybe<Type_Aggregate_Fields>;
  nodes: Array<Type>;
};

export type Type_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Type_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Type_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Type_Aggregate_Bool_Exp_Count>;
};

export type Type_Aggregate_Bool_Exp_Bool_And = {
  arguments: Type_Select_Column_Type_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Type_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Type_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Type_Select_Column_Type_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Type_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.type" */
export type Type_Aggregate_Fields = {
  __typename?: 'type_aggregate_fields';
  avg?: Maybe<Type_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Type_Max_Fields>;
  min?: Maybe<Type_Min_Fields>;
  stddev?: Maybe<Type_Stddev_Fields>;
  stddev_pop?: Maybe<Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Type_Stddev_Samp_Fields>;
  sum?: Maybe<Type_Sum_Fields>;
  var_pop?: Maybe<Type_Var_Pop_Fields>;
  var_samp?: Maybe<Type_Var_Samp_Fields>;
  variance?: Maybe<Type_Variance_Fields>;
};


/** aggregate fields of "shared.type" */
export type Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.type" */
export type Type_Aggregate_Order_By = {
  avg?: InputMaybe<Type_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Type_Max_Order_By>;
  min?: InputMaybe<Type_Min_Order_By>;
  stddev?: InputMaybe<Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Type_Sum_Order_By>;
  var_pop?: InputMaybe<Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Type_Var_Samp_Order_By>;
  variance?: InputMaybe<Type_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Type_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "shared.type" */
export type Type_Arr_Rel_Insert_Input = {
  data: Array<Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Type_On_Conflict>;
};

/** aggregate avg on columns */
export type Type_Avg_Fields = {
  __typename?: 'type_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shared.type" */
export type Type_Avg_Order_By = {
  enumValue?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shared.type". All fields are combined with a logical 'AND'. */
export type Type_Bool_Exp = {
  _and?: InputMaybe<Array<Type_Bool_Exp>>;
  _not?: InputMaybe<Type_Bool_Exp>;
  _or?: InputMaybe<Array<Type_Bool_Exp>>;
  claimDetails?: InputMaybe<ClaimDetail_Bool_Exp>;
  claimDetails_aggregate?: InputMaybe<ClaimDetail_Aggregate_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  contentTypes?: InputMaybe<ContentType_Bool_Exp>;
  contentTypes_aggregate?: InputMaybe<ContentType_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  documentTemplates?: InputMaybe<DocumentTemplate_Bool_Exp>;
  documentTemplates_aggregate?: InputMaybe<DocumentTemplate_Aggregate_Bool_Exp>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Bool_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isCodegenned?: InputMaybe<Boolean_Comparison_Exp>;
  laborGuideClaimServiceCenters?: InputMaybe<ClaimServiceCenter_Bool_Exp>;
  laborGuideClaimServiceCenters_aggregate?: InputMaybe<ClaimServiceCenter_Aggregate_Bool_Exp>;
  loggedActions?: InputMaybe<LoggedAction_Bool_Exp>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  operationValidationTypes?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
  operationValidationTypes_aggregate?: InputMaybe<ValidationTypeOperation_Aggregate_Bool_Exp>;
  policyClaims?: InputMaybe<PolicyClaim_Bool_Exp>;
  policyClaims_aggregate?: InputMaybe<PolicyClaim_Aggregate_Bool_Exp>;
  roleAttributes?: InputMaybe<RoleAttribute_Bool_Exp>;
  roleAttributes_aggregate?: InputMaybe<RoleAttribute_Aggregate_Bool_Exp>;
  serviceCenters?: InputMaybe<ServiceCenter_Bool_Exp>;
  serviceCenters_aggregate?: InputMaybe<ServiceCenter_Aggregate_Bool_Exp>;
  typeGroup?: InputMaybe<TypeGroup_Bool_Exp>;
  typeGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  validationOperationTypes?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
  validationOperationTypes_aggregate?: InputMaybe<ValidationTypeOperation_Aggregate_Bool_Exp>;
  validationOverrides?: InputMaybe<ValidationOverride_Bool_Exp>;
  validationOverrides_aggregate?: InputMaybe<ValidationOverride_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "shared.type" */
export enum Type_Constraint {
  /** unique or primary key constraint on columns "type_group_id", "name" */
  TypeNameTypeGroupIdUnique = 'type_name_type_group_id_unique',
  /** unique or primary key constraint on columns "id" */
  TypePkey = 'type_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Type_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Type_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Type_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "shared.type" */
export type Type_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shared.type" */
export type Type_Insert_Input = {
  claimDetails?: InputMaybe<ClaimDetail_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']>;
  contentTypes?: InputMaybe<ContentType_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  documentTemplates?: InputMaybe<DocumentTemplate_Arr_Rel_Insert_Input>;
  entityConfigurationItems?: InputMaybe<EntityConfigurationItem_Arr_Rel_Insert_Input>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Indicates whether the type is code-generated & System owned. Defaults to false so that user entered types are not codegenned. Developer entered types need to be explicity set to true if they need to be codegenned. */
  isCodegenned?: InputMaybe<Scalars['Boolean']>;
  laborGuideClaimServiceCenters?: InputMaybe<ClaimServiceCenter_Arr_Rel_Insert_Input>;
  loggedActions?: InputMaybe<LoggedAction_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  operationValidationTypes?: InputMaybe<ValidationTypeOperation_Arr_Rel_Insert_Input>;
  policyClaims?: InputMaybe<PolicyClaim_Arr_Rel_Insert_Input>;
  roleAttributes?: InputMaybe<RoleAttribute_Arr_Rel_Insert_Input>;
  serviceCenters?: InputMaybe<ServiceCenter_Arr_Rel_Insert_Input>;
  typeGroup?: InputMaybe<TypeGroup_Obj_Rel_Insert_Input>;
  typeGroupId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationOperationTypes?: InputMaybe<ValidationTypeOperation_Arr_Rel_Insert_Input>;
  validationOverrides?: InputMaybe<ValidationOverride_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Type_Max_Fields = {
  __typename?: 'type_max_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  typeGroupId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shared.type" */
export type Type_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  typeGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Type_Min_Fields = {
  __typename?: 'type_min_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  typeGroupId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shared.type" */
export type Type_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  typeGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.type" */
export type Type_Mutation_Response = {
  __typename?: 'type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Type>;
};

/** input type for inserting object relation for remote table "shared.type" */
export type Type_Obj_Rel_Insert_Input = {
  data: Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Type_On_Conflict>;
};

/** on_conflict condition type for table "shared.type" */
export type Type_On_Conflict = {
  constraint: Type_Constraint;
  update_columns?: Array<Type_Update_Column>;
  where?: InputMaybe<Type_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.type". */
export type Type_Order_By = {
  claimDetails_aggregate?: InputMaybe<ClaimDetail_Aggregate_Order_By>;
  code?: InputMaybe<Order_By>;
  contentTypes_aggregate?: InputMaybe<ContentType_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  documentTemplates_aggregate?: InputMaybe<DocumentTemplate_Aggregate_Order_By>;
  entityConfigurationItems_aggregate?: InputMaybe<EntityConfigurationItem_Aggregate_Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isCodegenned?: InputMaybe<Order_By>;
  laborGuideClaimServiceCenters_aggregate?: InputMaybe<ClaimServiceCenter_Aggregate_Order_By>;
  loggedActions_aggregate?: InputMaybe<LoggedAction_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operationValidationTypes_aggregate?: InputMaybe<ValidationTypeOperation_Aggregate_Order_By>;
  policyClaims_aggregate?: InputMaybe<PolicyClaim_Aggregate_Order_By>;
  roleAttributes_aggregate?: InputMaybe<RoleAttribute_Aggregate_Order_By>;
  serviceCenters_aggregate?: InputMaybe<ServiceCenter_Aggregate_Order_By>;
  typeGroup?: InputMaybe<TypeGroup_Order_By>;
  typeGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationOperationTypes_aggregate?: InputMaybe<ValidationTypeOperation_Aggregate_Order_By>;
  validationOverrides_aggregate?: InputMaybe<ValidationOverride_Aggregate_Order_By>;
};

/** primary key columns input for table: shared.type */
export type Type_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Type_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shared.type" */
export enum Type_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  IsCodegenned = 'isCodegenned',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  TypeGroupId = 'typeGroupId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "type_aggregate_bool_exp_bool_and_arguments_columns" columns of table "shared.type" */
export enum Type_Select_Column_Type_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCodegenned = 'isCodegenned'
}

/** select "type_aggregate_bool_exp_bool_or_arguments_columns" columns of table "shared.type" */
export enum Type_Select_Column_Type_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCodegenned = 'isCodegenned'
}

/** input type for updating data in table "shared.type" */
export type Type_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Indicates whether the type is code-generated & System owned. Defaults to false so that user entered types are not codegenned. Developer entered types need to be explicity set to true if they need to be codegenned. */
  isCodegenned?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  typeGroupId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Type_Stddev_Fields = {
  __typename?: 'type_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shared.type" */
export type Type_Stddev_Order_By = {
  enumValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Type_Stddev_Pop_Fields = {
  __typename?: 'type_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shared.type" */
export type Type_Stddev_Pop_Order_By = {
  enumValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Type_Stddev_Samp_Fields = {
  __typename?: 'type_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shared.type" */
export type Type_Stddev_Samp_Order_By = {
  enumValue?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "type" */
export type Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Type_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Indicates whether the type is code-generated & System owned. Defaults to false so that user entered types are not codegenned. Developer entered types need to be explicity set to true if they need to be codegenned. */
  isCodegenned?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  typeGroupId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Type_Sum_Fields = {
  __typename?: 'type_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "shared.type" */
export type Type_Sum_Order_By = {
  enumValue?: InputMaybe<Order_By>;
};

/** update columns of table "shared.type" */
export enum Type_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  IsCodegenned = 'isCodegenned',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  TypeGroupId = 'typeGroupId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Type_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Type_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Type_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Type_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Type_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Type_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Type_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Type_Var_Pop_Fields = {
  __typename?: 'type_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shared.type" */
export type Type_Var_Pop_Order_By = {
  enumValue?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Type_Var_Samp_Fields = {
  __typename?: 'type_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shared.type" */
export type Type_Var_Samp_Order_By = {
  enumValue?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Type_Variance_Fields = {
  __typename?: 'type_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shared.type" */
export type Type_Variance_Order_By = {
  enumValue?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "uniqueidentifier". All fields are combined with logical 'AND'. */
export type Uniqueidentifier_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uniqueidentifier']>;
  _gt?: InputMaybe<Scalars['uniqueidentifier']>;
  _gte?: InputMaybe<Scalars['uniqueidentifier']>;
  _in?: InputMaybe<Array<Scalars['uniqueidentifier']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uniqueidentifier']>;
  _lte?: InputMaybe<Scalars['uniqueidentifier']>;
  _neq?: InputMaybe<Scalars['uniqueidentifier']>;
  _nin?: InputMaybe<Array<Scalars['uniqueidentifier']>>;
};

/** columns and relationships of "auth.user" */
export type User = {
  __typename?: 'user';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An array relationship */
  policyContracts: Array<PolicyContract>;
  /** An aggregate relationship */
  policyContracts_aggregate: PolicyContract_Aggregate;
  traitMetadata?: Maybe<Scalars['jsonb']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userProfile: UserProfile;
  userProfileId: Scalars['uuid'];
};


/** columns and relationships of "auth.user" */
export type UserPolicyContractsArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


/** columns and relationships of "auth.user" */
export type UserPolicyContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyContract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyContract_Order_By>>;
  where?: InputMaybe<PolicyContract_Bool_Exp>;
};


/** columns and relationships of "auth.user" */
export type UserTraitMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "auth.user_flow_item" */
export type UserFlowItem = {
  __typename?: 'userFlowItem';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  flowItem: FlowItem;
  flowItemId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  identity: Identity;
  isCompleted: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userFlowItemMfas: Array<UserFlowItemMfa>;
  /** An aggregate relationship */
  userFlowItemMfas_aggregate: UserFlowItemMfa_Aggregate;
  userId: Scalars['uuid'];
};


/** columns and relationships of "auth.user_flow_item" */
export type UserFlowItemUserFlowItemMfasArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItemMfa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItemMfa_Order_By>>;
  where?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
};


/** columns and relationships of "auth.user_flow_item" */
export type UserFlowItemUserFlowItemMfas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserFlowItemMfa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserFlowItemMfa_Order_By>>;
  where?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
};

/** columns and relationships of "auth.user_flow_item_mfa" */
export type UserFlowItemMfa = {
  __typename?: 'userFlowItemMfa';
  code: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  userFlowItem: UserFlowItem;
  userFlowItemId: Scalars['uuid'];
};

/** aggregated selection of "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_Aggregate = {
  __typename?: 'userFlowItemMfa_aggregate';
  aggregate?: Maybe<UserFlowItemMfa_Aggregate_Fields>;
  nodes: Array<UserFlowItemMfa>;
};

export type UserFlowItemMfa_Aggregate_Bool_Exp = {
  count?: InputMaybe<UserFlowItemMfa_Aggregate_Bool_Exp_Count>;
};

export type UserFlowItemMfa_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserFlowItemMfa_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_Aggregate_Fields = {
  __typename?: 'userFlowItemMfa_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<UserFlowItemMfa_Max_Fields>;
  min?: Maybe<UserFlowItemMfa_Min_Fields>;
};


/** aggregate fields of "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserFlowItemMfa_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserFlowItemMfa_Max_Order_By>;
  min?: InputMaybe<UserFlowItemMfa_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_Arr_Rel_Insert_Input = {
  data: Array<UserFlowItemMfa_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserFlowItemMfa_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_flow_item_mfa". All fields are combined with a logical 'AND'. */
export type UserFlowItemMfa_Bool_Exp = {
  _and?: InputMaybe<Array<UserFlowItemMfa_Bool_Exp>>;
  _not?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
  _or?: InputMaybe<Array<UserFlowItemMfa_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  userFlowItem?: InputMaybe<UserFlowItem_Bool_Exp>;
  userFlowItemId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_flow_item_mfa" */
export enum UserFlowItemMfa_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserFlowItemMfaPkey = 'user_flow_item_mfa_pkey'
}

/** input type for inserting data into table "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  userFlowItem?: InputMaybe<UserFlowItem_Obj_Rel_Insert_Input>;
  userFlowItemId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserFlowItemMfa_Max_Fields = {
  __typename?: 'userFlowItemMfa_max_fields';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  userFlowItemId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userFlowItemId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserFlowItemMfa_Min_Fields = {
  __typename?: 'userFlowItemMfa_min_fields';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  userFlowItemId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userFlowItemId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_Mutation_Response = {
  __typename?: 'userFlowItemMfa_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserFlowItemMfa>;
};

/** on_conflict condition type for table "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_On_Conflict = {
  constraint: UserFlowItemMfa_Constraint;
  update_columns?: Array<UserFlowItemMfa_Update_Column>;
  where?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_flow_item_mfa". */
export type UserFlowItemMfa_Order_By = {
  code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userFlowItem?: InputMaybe<UserFlowItem_Order_By>;
  userFlowItemId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_flow_item_mfa */
export type UserFlowItemMfa_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_flow_item_mfa" */
export enum UserFlowItemMfa_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  UserFlowItemId = 'userFlowItemId'
}

/** input type for updating data in table "auth.user_flow_item_mfa" */
export type UserFlowItemMfa_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  userFlowItemId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "userFlowItemMfa" */
export type UserFlowItemMfa_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserFlowItemMfa_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserFlowItemMfa_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  userFlowItemId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "auth.user_flow_item_mfa" */
export enum UserFlowItemMfa_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  UserFlowItemId = 'userFlowItemId'
}

export type UserFlowItemMfa_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserFlowItemMfa_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserFlowItemMfa_Bool_Exp;
};

/** aggregated selection of "auth.user_flow_item" */
export type UserFlowItem_Aggregate = {
  __typename?: 'userFlowItem_aggregate';
  aggregate?: Maybe<UserFlowItem_Aggregate_Fields>;
  nodes: Array<UserFlowItem>;
};

export type UserFlowItem_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<UserFlowItem_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<UserFlowItem_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<UserFlowItem_Aggregate_Bool_Exp_Count>;
};

export type UserFlowItem_Aggregate_Bool_Exp_Bool_And = {
  arguments: UserFlowItem_Select_Column_UserFlowItem_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserFlowItem_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type UserFlowItem_Aggregate_Bool_Exp_Bool_Or = {
  arguments: UserFlowItem_Select_Column_UserFlowItem_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserFlowItem_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type UserFlowItem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserFlowItem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserFlowItem_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_flow_item" */
export type UserFlowItem_Aggregate_Fields = {
  __typename?: 'userFlowItem_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<UserFlowItem_Max_Fields>;
  min?: Maybe<UserFlowItem_Min_Fields>;
};


/** aggregate fields of "auth.user_flow_item" */
export type UserFlowItem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserFlowItem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_flow_item" */
export type UserFlowItem_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserFlowItem_Max_Order_By>;
  min?: InputMaybe<UserFlowItem_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_flow_item" */
export type UserFlowItem_Arr_Rel_Insert_Input = {
  data: Array<UserFlowItem_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserFlowItem_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_flow_item". All fields are combined with a logical 'AND'. */
export type UserFlowItem_Bool_Exp = {
  _and?: InputMaybe<Array<UserFlowItem_Bool_Exp>>;
  _not?: InputMaybe<UserFlowItem_Bool_Exp>;
  _or?: InputMaybe<Array<UserFlowItem_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  flowItem?: InputMaybe<FlowItem_Bool_Exp>;
  flowItemId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  isCompleted?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userFlowItemMfas?: InputMaybe<UserFlowItemMfa_Bool_Exp>;
  userFlowItemMfas_aggregate?: InputMaybe<UserFlowItemMfa_Aggregate_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_flow_item" */
export enum UserFlowItem_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserFlowItemPkey = 'user_flow_item_pkey'
}

/** input type for inserting data into table "auth.user_flow_item" */
export type UserFlowItem_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  flowItem?: InputMaybe<FlowItem_Obj_Rel_Insert_Input>;
  flowItemId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userFlowItemMfas?: InputMaybe<UserFlowItemMfa_Arr_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserFlowItem_Max_Fields = {
  __typename?: 'userFlowItem_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  flowItemId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.user_flow_item" */
export type UserFlowItem_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  flowItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserFlowItem_Min_Fields = {
  __typename?: 'userFlowItem_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  flowItemId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.user_flow_item" */
export type UserFlowItem_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  flowItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_flow_item" */
export type UserFlowItem_Mutation_Response = {
  __typename?: 'userFlowItem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserFlowItem>;
};

/** input type for inserting object relation for remote table "auth.user_flow_item" */
export type UserFlowItem_Obj_Rel_Insert_Input = {
  data: UserFlowItem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<UserFlowItem_On_Conflict>;
};

/** on_conflict condition type for table "auth.user_flow_item" */
export type UserFlowItem_On_Conflict = {
  constraint: UserFlowItem_Constraint;
  update_columns?: Array<UserFlowItem_Update_Column>;
  where?: InputMaybe<UserFlowItem_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_flow_item". */
export type UserFlowItem_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  flowItem?: InputMaybe<FlowItem_Order_By>;
  flowItemId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  isCompleted?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userFlowItemMfas_aggregate?: InputMaybe<UserFlowItemMfa_Aggregate_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_flow_item */
export type UserFlowItem_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_flow_item" */
export enum UserFlowItem_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FlowItemId = 'flowItemId',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'isCompleted',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** select "userFlowItem_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.user_flow_item" */
export enum UserFlowItem_Select_Column_UserFlowItem_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCompleted = 'isCompleted'
}

/** select "userFlowItem_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.user_flow_item" */
export enum UserFlowItem_Select_Column_UserFlowItem_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCompleted = 'isCompleted'
}

/** input type for updating data in table "auth.user_flow_item" */
export type UserFlowItem_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  flowItemId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "userFlowItem" */
export type UserFlowItem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserFlowItem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserFlowItem_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  flowItemId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "auth.user_flow_item" */
export enum UserFlowItem_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FlowItemId = 'flowItemId',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'isCompleted',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserFlowItem_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserFlowItem_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserFlowItem_Bool_Exp;
};

/** columns and relationships of "auth.user_group" */
export type UserGroup = {
  __typename?: 'userGroup';
  createdAt: Scalars['timestamptz'];
  emailAddress?: Maybe<Scalars['String']>;
  /** An object relationship */
  group: Auth_Group;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "auth.user_group" */
export type UserGroup_Aggregate = {
  __typename?: 'userGroup_aggregate';
  aggregate?: Maybe<UserGroup_Aggregate_Fields>;
  nodes: Array<UserGroup>;
};

export type UserGroup_Aggregate_Bool_Exp = {
  count?: InputMaybe<UserGroup_Aggregate_Bool_Exp_Count>;
};

export type UserGroup_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserGroup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserGroup_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_group" */
export type UserGroup_Aggregate_Fields = {
  __typename?: 'userGroup_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<UserGroup_Max_Fields>;
  min?: Maybe<UserGroup_Min_Fields>;
};


/** aggregate fields of "auth.user_group" */
export type UserGroup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserGroup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_group" */
export type UserGroup_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserGroup_Max_Order_By>;
  min?: InputMaybe<UserGroup_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_group" */
export type UserGroup_Arr_Rel_Insert_Input = {
  data: Array<UserGroup_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserGroup_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_group". All fields are combined with a logical 'AND'. */
export type UserGroup_Bool_Exp = {
  _and?: InputMaybe<Array<UserGroup_Bool_Exp>>;
  _not?: InputMaybe<UserGroup_Bool_Exp>;
  _or?: InputMaybe<Array<UserGroup_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  emailAddress?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<Auth_Group_Bool_Exp>;
  groupId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_group" */
export enum UserGroup_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserGroupPkey = 'user_group_pkey'
}

/** input type for inserting data into table "auth.user_group" */
export type UserGroup_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Auth_Group_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type UserGroup_Max_Fields = {
  __typename?: 'userGroup_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  emailAddress?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.user_group" */
export type UserGroup_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  emailAddress?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserGroup_Min_Fields = {
  __typename?: 'userGroup_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  emailAddress?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.user_group" */
export type UserGroup_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  emailAddress?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_group" */
export type UserGroup_Mutation_Response = {
  __typename?: 'userGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserGroup>;
};

/** on_conflict condition type for table "auth.user_group" */
export type UserGroup_On_Conflict = {
  constraint: UserGroup_Constraint;
  update_columns?: Array<UserGroup_Update_Column>;
  where?: InputMaybe<UserGroup_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_group". */
export type UserGroup_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  emailAddress?: InputMaybe<Order_By>;
  group?: InputMaybe<Auth_Group_Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_group */
export type UserGroup_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_group" */
export enum UserGroup_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.user_group" */
export type UserGroup_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "userGroup" */
export type UserGroup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserGroup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroup_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.user_group" */
export enum UserGroup_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type UserGroup_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserGroup_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserGroup_Bool_Exp;
};

/** columns and relationships of "user_pin" */
export type UserPin = {
  __typename?: 'userPin';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  accountManager?: Maybe<AccountManager>;
  bgColor?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  parentId: Scalars['uuid'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_pin" */
export type UserPin_Aggregate = {
  __typename?: 'userPin_aggregate';
  aggregate?: Maybe<UserPin_Aggregate_Fields>;
  nodes: Array<UserPin>;
};

/** aggregate fields of "user_pin" */
export type UserPin_Aggregate_Fields = {
  __typename?: 'userPin_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<UserPin_Max_Fields>;
  min?: Maybe<UserPin_Min_Fields>;
};


/** aggregate fields of "user_pin" */
export type UserPin_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserPin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_pin". All fields are combined with a logical 'AND'. */
export type UserPin_Bool_Exp = {
  _and?: InputMaybe<Array<UserPin_Bool_Exp>>;
  _not?: InputMaybe<UserPin_Bool_Exp>;
  _or?: InputMaybe<Array<UserPin_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountManager?: InputMaybe<AccountManager_Bool_Exp>;
  bgColor?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_pin" */
export enum UserPin_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPinPkey = 'user_pin_pkey'
}

/** input type for inserting data into table "user_pin" */
export type UserPin_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountManager?: InputMaybe<AccountManager_Obj_Rel_Insert_Input>;
  bgColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserPin_Max_Fields = {
  __typename?: 'userPin_max_fields';
  bgColor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserPin_Min_Fields = {
  __typename?: 'userPin_min_fields';
  bgColor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  parentId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_pin" */
export type UserPin_Mutation_Response = {
  __typename?: 'userPin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPin>;
};

/** on_conflict condition type for table "user_pin" */
export type UserPin_On_Conflict = {
  constraint: UserPin_Constraint;
  update_columns?: Array<UserPin_Update_Column>;
  where?: InputMaybe<UserPin_Bool_Exp>;
};

/** Ordering options when selecting data from "user_pin". */
export type UserPin_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountManager?: InputMaybe<AccountManager_Order_By>;
  bgColor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_pin */
export type UserPin_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_pin" */
export enum UserPin_Select_Column {
  /** column name */
  BgColor = 'bgColor',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_pin" */
export type UserPin_Set_Input = {
  bgColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "userPin" */
export type UserPin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserPin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPin_Stream_Cursor_Value_Input = {
  bgColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  parentId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_pin" */
export enum UserPin_Update_Column {
  /** column name */
  BgColor = 'bgColor',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UserId = 'userId'
}

export type UserPin_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPin_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserPin_Bool_Exp;
};

/** columns and relationships of "auth.user_profile" */
export type UserProfile = {
  __typename?: 'userProfile';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  accountManager?: Maybe<AccountManager>;
  agentCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  dealerCode?: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  isActiveDirectoryUser: Scalars['Boolean'];
  kratosIdentitySchemaId?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  mbpiDepartmentName?: Maybe<Scalars['String']>;
  /** An object relationship */
  parentUserProfile?: Maybe<UserProfile>;
  parentUserProfileId?: Maybe<Scalars['Int']>;
  password: Scalars['String'];
  pipMemberNumber?: Maybe<Scalars['String']>;
  profilePhotoUrl?: Maybe<Scalars['String']>;
  requirePasswordChange: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
  userProfileId: Scalars['Int'];
  userProfileTypeId: Scalars['Int'];
  /** An array relationship */
  userSessions: Array<UserSession>;
  /** An aggregate relationship */
  userSessions_aggregate: UserSession_Aggregate;
  username: Scalars['String'];
  /** An array relationship */
  users: Array<User>;
  /** An aggregate relationship */
  users_aggregate: User_Aggregate;
};


/** columns and relationships of "auth.user_profile" */
export type UserProfileUserSessionsArgs = {
  distinct_on?: InputMaybe<Array<UserSession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserSession_Order_By>>;
  where?: InputMaybe<UserSession_Bool_Exp>;
};


/** columns and relationships of "auth.user_profile" */
export type UserProfileUserSessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserSession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserSession_Order_By>>;
  where?: InputMaybe<UserSession_Bool_Exp>;
};


/** columns and relationships of "auth.user_profile" */
export type UserProfileUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "auth.user_profile" */
export type UserProfileUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** aggregated selection of "auth.user_profile" */
export type UserProfile_Aggregate = {
  __typename?: 'userProfile_aggregate';
  aggregate?: Maybe<UserProfile_Aggregate_Fields>;
  nodes: Array<UserProfile>;
};

export type UserProfile_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<UserProfile_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<UserProfile_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<UserProfile_Aggregate_Bool_Exp_Count>;
};

export type UserProfile_Aggregate_Bool_Exp_Bool_And = {
  arguments: UserProfile_Select_Column_UserProfile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserProfile_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type UserProfile_Aggregate_Bool_Exp_Bool_Or = {
  arguments: UserProfile_Select_Column_UserProfile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserProfile_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type UserProfile_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserProfile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserProfile_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_profile" */
export type UserProfile_Aggregate_Fields = {
  __typename?: 'userProfile_aggregate_fields';
  avg?: Maybe<UserProfile_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UserProfile_Max_Fields>;
  min?: Maybe<UserProfile_Min_Fields>;
  stddev?: Maybe<UserProfile_Stddev_Fields>;
  stddev_pop?: Maybe<UserProfile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserProfile_Stddev_Samp_Fields>;
  sum?: Maybe<UserProfile_Sum_Fields>;
  var_pop?: Maybe<UserProfile_Var_Pop_Fields>;
  var_samp?: Maybe<UserProfile_Var_Samp_Fields>;
  variance?: Maybe<UserProfile_Variance_Fields>;
};


/** aggregate fields of "auth.user_profile" */
export type UserProfile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserProfile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_profile" */
export type UserProfile_Aggregate_Order_By = {
  avg?: InputMaybe<UserProfile_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserProfile_Max_Order_By>;
  min?: InputMaybe<UserProfile_Min_Order_By>;
  stddev?: InputMaybe<UserProfile_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UserProfile_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UserProfile_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UserProfile_Sum_Order_By>;
  var_pop?: InputMaybe<UserProfile_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UserProfile_Var_Samp_Order_By>;
  variance?: InputMaybe<UserProfile_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_profile" */
export type UserProfile_Arr_Rel_Insert_Input = {
  data: Array<UserProfile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserProfile_On_Conflict>;
};

/** aggregate avg on columns */
export type UserProfile_Avg_Fields = {
  __typename?: 'userProfile_avg_fields';
  parentUserProfileId?: Maybe<Scalars['Float']>;
  userProfileId?: Maybe<Scalars['Float']>;
  userProfileTypeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "auth.user_profile" */
export type UserProfile_Avg_Order_By = {
  parentUserProfileId?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth.user_profile". All fields are combined with a logical 'AND'. */
export type UserProfile_Bool_Exp = {
  _and?: InputMaybe<Array<UserProfile_Bool_Exp>>;
  _not?: InputMaybe<UserProfile_Bool_Exp>;
  _or?: InputMaybe<Array<UserProfile_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountManager?: InputMaybe<AccountManager_Bool_Exp>;
  agentCode?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dealerCode?: InputMaybe<String_Comparison_Exp>;
  emailAddress?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  isActiveDirectoryUser?: InputMaybe<Boolean_Comparison_Exp>;
  kratosIdentitySchemaId?: InputMaybe<String_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  mbpiDepartmentName?: InputMaybe<String_Comparison_Exp>;
  parentUserProfile?: InputMaybe<UserProfile_Bool_Exp>;
  parentUserProfileId?: InputMaybe<Int_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  pipMemberNumber?: InputMaybe<String_Comparison_Exp>;
  profilePhotoUrl?: InputMaybe<String_Comparison_Exp>;
  requirePasswordChange?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userProfileId?: InputMaybe<Int_Comparison_Exp>;
  userProfileTypeId?: InputMaybe<Int_Comparison_Exp>;
  userSessions?: InputMaybe<UserSession_Bool_Exp>;
  userSessions_aggregate?: InputMaybe<UserSession_Aggregate_Bool_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<User_Bool_Exp>;
  users_aggregate?: InputMaybe<User_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.user_profile" */
export enum UserProfile_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProfilePkey = 'user_profile_pkey'
}

/** input type for incrementing numeric columns in table "auth.user_profile" */
export type UserProfile_Inc_Input = {
  parentUserProfileId?: InputMaybe<Scalars['Int']>;
  userProfileId?: InputMaybe<Scalars['Int']>;
  userProfileTypeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth.user_profile" */
export type UserProfile_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountManager?: InputMaybe<AccountManager_Obj_Rel_Insert_Input>;
  agentCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerCode?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveDirectoryUser?: InputMaybe<Scalars['Boolean']>;
  kratosIdentitySchemaId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mbpiDepartmentName?: InputMaybe<Scalars['String']>;
  parentUserProfile?: InputMaybe<UserProfile_Obj_Rel_Insert_Input>;
  parentUserProfileId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  pipMemberNumber?: InputMaybe<Scalars['String']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']>;
  requirePasswordChange?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userProfileId?: InputMaybe<Scalars['Int']>;
  userProfileTypeId?: InputMaybe<Scalars['Int']>;
  userSessions?: InputMaybe<UserSession_Arr_Rel_Insert_Input>;
  username?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<User_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type UserProfile_Max_Fields = {
  __typename?: 'userProfile_max_fields';
  agentCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dealerCode?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  kratosIdentitySchemaId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mbpiDepartmentName?: Maybe<Scalars['String']>;
  parentUserProfileId?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  pipMemberNumber?: Maybe<Scalars['String']>;
  profilePhotoUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userProfileId?: Maybe<Scalars['Int']>;
  userProfileTypeId?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "auth.user_profile" */
export type UserProfile_Max_Order_By = {
  agentCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dealerCode?: InputMaybe<Order_By>;
  emailAddress?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kratosIdentitySchemaId?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  mbpiDepartmentName?: InputMaybe<Order_By>;
  parentUserProfileId?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  pipMemberNumber?: InputMaybe<Order_By>;
  profilePhotoUrl?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserProfile_Min_Fields = {
  __typename?: 'userProfile_min_fields';
  agentCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dealerCode?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  kratosIdentitySchemaId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mbpiDepartmentName?: Maybe<Scalars['String']>;
  parentUserProfileId?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  pipMemberNumber?: Maybe<Scalars['String']>;
  profilePhotoUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userProfileId?: Maybe<Scalars['Int']>;
  userProfileTypeId?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "auth.user_profile" */
export type UserProfile_Min_Order_By = {
  agentCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dealerCode?: InputMaybe<Order_By>;
  emailAddress?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kratosIdentitySchemaId?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  mbpiDepartmentName?: InputMaybe<Order_By>;
  parentUserProfileId?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  pipMemberNumber?: InputMaybe<Order_By>;
  profilePhotoUrl?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_profile" */
export type UserProfile_Mutation_Response = {
  __typename?: 'userProfile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserProfile>;
};

/** input type for inserting object relation for remote table "auth.user_profile" */
export type UserProfile_Obj_Rel_Insert_Input = {
  data: UserProfile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<UserProfile_On_Conflict>;
};

/** on_conflict condition type for table "auth.user_profile" */
export type UserProfile_On_Conflict = {
  constraint: UserProfile_Constraint;
  update_columns?: Array<UserProfile_Update_Column>;
  where?: InputMaybe<UserProfile_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_profile". */
export type UserProfile_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountManager?: InputMaybe<AccountManager_Order_By>;
  agentCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dealerCode?: InputMaybe<Order_By>;
  emailAddress?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  isActiveDirectoryUser?: InputMaybe<Order_By>;
  kratosIdentitySchemaId?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  mbpiDepartmentName?: InputMaybe<Order_By>;
  parentUserProfile?: InputMaybe<UserProfile_Order_By>;
  parentUserProfileId?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  pipMemberNumber?: InputMaybe<Order_By>;
  profilePhotoUrl?: InputMaybe<Order_By>;
  requirePasswordChange?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
  userSessions_aggregate?: InputMaybe<UserSession_Aggregate_Order_By>;
  username?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.user_profile */
export type UserProfile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_profile" */
export enum UserProfile_Select_Column {
  /** column name */
  AgentCode = 'agentCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DealerCode = 'dealerCode',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsActiveDirectoryUser = 'isActiveDirectoryUser',
  /** column name */
  KratosIdentitySchemaId = 'kratosIdentitySchemaId',
  /** column name */
  LastName = 'lastName',
  /** column name */
  MbpiDepartmentName = 'mbpiDepartmentName',
  /** column name */
  ParentUserProfileId = 'parentUserProfileId',
  /** column name */
  Password = 'password',
  /** column name */
  PipMemberNumber = 'pipMemberNumber',
  /** column name */
  ProfilePhotoUrl = 'profilePhotoUrl',
  /** column name */
  RequirePasswordChange = 'requirePasswordChange',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserProfileId = 'userProfileId',
  /** column name */
  UserProfileTypeId = 'userProfileTypeId',
  /** column name */
  Username = 'username'
}

/** select "userProfile_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.user_profile" */
export enum UserProfile_Select_Column_UserProfile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsActiveDirectoryUser = 'isActiveDirectoryUser',
  /** column name */
  RequirePasswordChange = 'requirePasswordChange'
}

/** select "userProfile_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.user_profile" */
export enum UserProfile_Select_Column_UserProfile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsActiveDirectoryUser = 'isActiveDirectoryUser',
  /** column name */
  RequirePasswordChange = 'requirePasswordChange'
}

/** input type for updating data in table "auth.user_profile" */
export type UserProfile_Set_Input = {
  agentCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerCode?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveDirectoryUser?: InputMaybe<Scalars['Boolean']>;
  kratosIdentitySchemaId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mbpiDepartmentName?: InputMaybe<Scalars['String']>;
  parentUserProfileId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  pipMemberNumber?: InputMaybe<Scalars['String']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']>;
  requirePasswordChange?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userProfileId?: InputMaybe<Scalars['Int']>;
  userProfileTypeId?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UserProfile_Stddev_Fields = {
  __typename?: 'userProfile_stddev_fields';
  parentUserProfileId?: Maybe<Scalars['Float']>;
  userProfileId?: Maybe<Scalars['Float']>;
  userProfileTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "auth.user_profile" */
export type UserProfile_Stddev_Order_By = {
  parentUserProfileId?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UserProfile_Stddev_Pop_Fields = {
  __typename?: 'userProfile_stddev_pop_fields';
  parentUserProfileId?: Maybe<Scalars['Float']>;
  userProfileId?: Maybe<Scalars['Float']>;
  userProfileTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "auth.user_profile" */
export type UserProfile_Stddev_Pop_Order_By = {
  parentUserProfileId?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UserProfile_Stddev_Samp_Fields = {
  __typename?: 'userProfile_stddev_samp_fields';
  parentUserProfileId?: Maybe<Scalars['Float']>;
  userProfileId?: Maybe<Scalars['Float']>;
  userProfileTypeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "auth.user_profile" */
export type UserProfile_Stddev_Samp_Order_By = {
  parentUserProfileId?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "userProfile" */
export type UserProfile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserProfile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserProfile_Stream_Cursor_Value_Input = {
  agentCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dealerCode?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveDirectoryUser?: InputMaybe<Scalars['Boolean']>;
  kratosIdentitySchemaId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mbpiDepartmentName?: InputMaybe<Scalars['String']>;
  parentUserProfileId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  pipMemberNumber?: InputMaybe<Scalars['String']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']>;
  requirePasswordChange?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userProfileId?: InputMaybe<Scalars['Int']>;
  userProfileTypeId?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UserProfile_Sum_Fields = {
  __typename?: 'userProfile_sum_fields';
  parentUserProfileId?: Maybe<Scalars['Int']>;
  userProfileId?: Maybe<Scalars['Int']>;
  userProfileTypeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "auth.user_profile" */
export type UserProfile_Sum_Order_By = {
  parentUserProfileId?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
};

/** update columns of table "auth.user_profile" */
export enum UserProfile_Update_Column {
  /** column name */
  AgentCode = 'agentCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DealerCode = 'dealerCode',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsActiveDirectoryUser = 'isActiveDirectoryUser',
  /** column name */
  KratosIdentitySchemaId = 'kratosIdentitySchemaId',
  /** column name */
  LastName = 'lastName',
  /** column name */
  MbpiDepartmentName = 'mbpiDepartmentName',
  /** column name */
  ParentUserProfileId = 'parentUserProfileId',
  /** column name */
  Password = 'password',
  /** column name */
  PipMemberNumber = 'pipMemberNumber',
  /** column name */
  ProfilePhotoUrl = 'profilePhotoUrl',
  /** column name */
  RequirePasswordChange = 'requirePasswordChange',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserProfileId = 'userProfileId',
  /** column name */
  UserProfileTypeId = 'userProfileTypeId',
  /** column name */
  Username = 'username'
}

export type UserProfile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserProfile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserProfile_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserProfile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UserProfile_Var_Pop_Fields = {
  __typename?: 'userProfile_var_pop_fields';
  parentUserProfileId?: Maybe<Scalars['Float']>;
  userProfileId?: Maybe<Scalars['Float']>;
  userProfileTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "auth.user_profile" */
export type UserProfile_Var_Pop_Order_By = {
  parentUserProfileId?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UserProfile_Var_Samp_Fields = {
  __typename?: 'userProfile_var_samp_fields';
  parentUserProfileId?: Maybe<Scalars['Float']>;
  userProfileId?: Maybe<Scalars['Float']>;
  userProfileTypeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "auth.user_profile" */
export type UserProfile_Var_Samp_Order_By = {
  parentUserProfileId?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UserProfile_Variance_Fields = {
  __typename?: 'userProfile_variance_fields';
  parentUserProfileId?: Maybe<Scalars['Float']>;
  userProfileId?: Maybe<Scalars['Float']>;
  userProfileTypeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "auth.user_profile" */
export type UserProfile_Variance_Order_By = {
  parentUserProfileId?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
  userProfileTypeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "auth.user_session" */
export type UserSession = {
  __typename?: 'userSession';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  refreshToken: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  userAgent: Scalars['String'];
  /** An object relationship */
  userProfile: UserProfile;
  userProfileId: Scalars['uuid'];
};

/** aggregated selection of "auth.user_session" */
export type UserSession_Aggregate = {
  __typename?: 'userSession_aggregate';
  aggregate?: Maybe<UserSession_Aggregate_Fields>;
  nodes: Array<UserSession>;
};

export type UserSession_Aggregate_Bool_Exp = {
  count?: InputMaybe<UserSession_Aggregate_Bool_Exp_Count>;
};

export type UserSession_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserSession_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserSession_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_session" */
export type UserSession_Aggregate_Fields = {
  __typename?: 'userSession_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<UserSession_Max_Fields>;
  min?: Maybe<UserSession_Min_Fields>;
};


/** aggregate fields of "auth.user_session" */
export type UserSession_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserSession_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_session" */
export type UserSession_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserSession_Max_Order_By>;
  min?: InputMaybe<UserSession_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_session" */
export type UserSession_Arr_Rel_Insert_Input = {
  data: Array<UserSession_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserSession_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_session". All fields are combined with a logical 'AND'. */
export type UserSession_Bool_Exp = {
  _and?: InputMaybe<Array<UserSession_Bool_Exp>>;
  _not?: InputMaybe<UserSession_Bool_Exp>;
  _or?: InputMaybe<Array<UserSession_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  refreshToken?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userAgent?: InputMaybe<String_Comparison_Exp>;
  userProfile?: InputMaybe<UserProfile_Bool_Exp>;
  userProfileId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_session" */
export enum UserSession_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSessionPkey = 'user_session_pkey'
}

/** input type for inserting data into table "auth.user_session" */
export type UserSession_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userProfile?: InputMaybe<UserProfile_Obj_Rel_Insert_Input>;
  userProfileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserSession_Max_Fields = {
  __typename?: 'userSession_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userAgent?: Maybe<Scalars['String']>;
  userProfileId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.user_session" */
export type UserSession_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAgent?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserSession_Min_Fields = {
  __typename?: 'userSession_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userAgent?: Maybe<Scalars['String']>;
  userProfileId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.user_session" */
export type UserSession_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAgent?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_session" */
export type UserSession_Mutation_Response = {
  __typename?: 'userSession_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserSession>;
};

/** on_conflict condition type for table "auth.user_session" */
export type UserSession_On_Conflict = {
  constraint: UserSession_Constraint;
  update_columns?: Array<UserSession_Update_Column>;
  where?: InputMaybe<UserSession_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_session". */
export type UserSession_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAgent?: InputMaybe<Order_By>;
  userProfile?: InputMaybe<UserProfile_Order_By>;
  userProfileId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_session */
export type UserSession_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_session" */
export enum UserSession_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAgent = 'userAgent',
  /** column name */
  UserProfileId = 'userProfileId'
}

/** input type for updating data in table "auth.user_session" */
export type UserSession_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userProfileId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "userSession" */
export type UserSession_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserSession_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserSession_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userProfileId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "auth.user_session" */
export enum UserSession_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAgent = 'userAgent',
  /** column name */
  UserProfileId = 'userProfileId'
}

export type UserSession_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserSession_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserSession_Bool_Exp;
};

/** aggregated selection of "auth.user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

export type User_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Aggregate_Bool_Exp_Count>;
};

export type User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "auth.user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user" */
export type User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Max_Order_By>;
  min?: InputMaybe<User_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Append_Input = {
  traitMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "auth.user" */
export type User_Arr_Rel_Insert_Input = {
  data: Array<User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  policyContracts?: InputMaybe<PolicyContract_Bool_Exp>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Bool_Exp>;
  traitMetadata?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userProfile?: InputMaybe<UserProfile_Bool_Exp>;
  userProfileId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Delete_At_Path_Input = {
  traitMetadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Delete_Elem_Input = {
  traitMetadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Delete_Key_Input = {
  traitMetadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "auth.user" */
export type User_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  policyContracts?: InputMaybe<PolicyContract_Arr_Rel_Insert_Input>;
  traitMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userProfile?: InputMaybe<UserProfile_Obj_Rel_Insert_Input>;
  userProfileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userProfileId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.user" */
export type User_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userProfileId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.user" */
export type User_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProfileId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** on_conflict condition type for table "auth.user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user". */
export type User_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  policyContracts_aggregate?: InputMaybe<PolicyContract_Aggregate_Order_By>;
  traitMetadata?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProfile?: InputMaybe<UserProfile_Order_By>;
  userProfileId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user */
export type User_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Prepend_Input = {
  traitMetadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "auth.user" */
export enum User_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  TraitMetadata = 'traitMetadata',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserProfileId = 'userProfileId'
}

/** input type for updating data in table "auth.user" */
export type User_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  traitMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userProfileId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  traitMetadata?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userProfileId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "auth.user" */
export enum User_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  TraitMetadata = 'traitMetadata',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserProfileId = 'userProfileId'
}

export type User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** aggregate fields of "vpic.vncsabodytype" */
export type VNcsaBodyType_Aggregate_Fields_Vpic = {
  __typename?: 'vNCSABodyType_aggregate_fields_vpic';
  avg?: Maybe<VNcsaBodyType_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VNcsaBodyType_Max_Fields_Vpic>;
  min?: Maybe<VNcsaBodyType_Min_Fields_Vpic>;
  stddev?: Maybe<VNcsaBodyType_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VNcsaBodyType_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VNcsaBodyType_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VNcsaBodyType_Sum_Fields_Vpic>;
  var_pop?: Maybe<VNcsaBodyType_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VNcsaBodyType_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VNcsaBodyType_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vncsabodytype" */
export type VNcsaBodyType_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VNcsaBodyType_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.vncsabodytype" */
export type VNcsaBodyType_Aggregate_Vpic = {
  __typename?: 'vNCSABodyType_aggregate_vpic';
  aggregate?: Maybe<VNcsaBodyType_Aggregate_Fields_Vpic>;
  nodes: Array<VNcsaBodyType_Vpic>;
};

/** aggregate avg on columns */
export type VNcsaBodyType_Avg_Fields_Vpic = {
  __typename?: 'vNCSABodyType_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.vncsabodytype". All fields are combined with a logical 'AND'. */
export type VNcsaBodyType_Bool_Exp_Vpic = {
  Id?: InputMaybe<Smallint_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<VNcsaBodyType_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VNcsaBodyType_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VNcsaBodyType_Bool_Exp_Vpic>>;
};

/** aggregate max on columns */
export type VNcsaBodyType_Max_Fields_Vpic = {
  __typename?: 'vNCSABodyType_max_fields_vpic';
  Id?: Maybe<Scalars['smallint']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VNcsaBodyType_Min_Fields_Vpic = {
  __typename?: 'vNCSABodyType_min_fields_vpic';
  Id?: Maybe<Scalars['smallint']>;
  Name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "vpic.vncsabodytype". */
export type VNcsaBodyType_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** select columns of table "vpic.vncsabodytype" */
export enum VNcsaBodyType_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** aggregate stddev on columns */
export type VNcsaBodyType_Stddev_Fields_Vpic = {
  __typename?: 'vNCSABodyType_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VNcsaBodyType_Stddev_Pop_Fields_Vpic = {
  __typename?: 'vNCSABodyType_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VNcsaBodyType_Stddev_Samp_Fields_Vpic = {
  __typename?: 'vNCSABodyType_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vNCSABodyType" */
export type VNcsaBodyType_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VNcsaBodyType_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VNcsaBodyType_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['smallint']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type VNcsaBodyType_Sum_Fields_Vpic = {
  __typename?: 'vNCSABodyType_sum_fields_vpic';
  Id?: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type VNcsaBodyType_Var_Pop_Fields_Vpic = {
  __typename?: 'vNCSABodyType_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VNcsaBodyType_Var_Samp_Fields_Vpic = {
  __typename?: 'vNCSABodyType_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VNcsaBodyType_Variance_Fields_Vpic = {
  __typename?: 'vNCSABodyType_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.vncsabodytype" */
export type VNcsaBodyType_Vpic = {
  __typename?: 'vNCSABodyType_vpic';
  Id?: Maybe<Scalars['smallint']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate fields of "vpic.vncsamake" */
export type VNcsaMake_Aggregate_Fields_Vpic = {
  __typename?: 'vNCSAMake_aggregate_fields_vpic';
  avg?: Maybe<VNcsaMake_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VNcsaMake_Max_Fields_Vpic>;
  min?: Maybe<VNcsaMake_Min_Fields_Vpic>;
  stddev?: Maybe<VNcsaMake_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VNcsaMake_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VNcsaMake_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VNcsaMake_Sum_Fields_Vpic>;
  var_pop?: Maybe<VNcsaMake_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VNcsaMake_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VNcsaMake_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vncsamake" */
export type VNcsaMake_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VNcsaMake_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.vncsamake" */
export type VNcsaMake_Aggregate_Vpic = {
  __typename?: 'vNCSAMake_aggregate_vpic';
  aggregate?: Maybe<VNcsaMake_Aggregate_Fields_Vpic>;
  nodes: Array<VNcsaMake_Vpic>;
};

/** aggregate avg on columns */
export type VNcsaMake_Avg_Fields_Vpic = {
  __typename?: 'vNCSAMake_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.vncsamake". All fields are combined with a logical 'AND'. */
export type VNcsaMake_Bool_Exp_Vpic = {
  Id?: InputMaybe<Smallint_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<VNcsaMake_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VNcsaMake_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VNcsaMake_Bool_Exp_Vpic>>;
};

/** aggregate max on columns */
export type VNcsaMake_Max_Fields_Vpic = {
  __typename?: 'vNCSAMake_max_fields_vpic';
  Id?: Maybe<Scalars['smallint']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VNcsaMake_Min_Fields_Vpic = {
  __typename?: 'vNCSAMake_min_fields_vpic';
  Id?: Maybe<Scalars['smallint']>;
  Name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "vpic.vncsamake". */
export type VNcsaMake_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** select columns of table "vpic.vncsamake" */
export enum VNcsaMake_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name'
}

/** aggregate stddev on columns */
export type VNcsaMake_Stddev_Fields_Vpic = {
  __typename?: 'vNCSAMake_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VNcsaMake_Stddev_Pop_Fields_Vpic = {
  __typename?: 'vNCSAMake_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VNcsaMake_Stddev_Samp_Fields_Vpic = {
  __typename?: 'vNCSAMake_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vNCSAMake" */
export type VNcsaMake_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VNcsaMake_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VNcsaMake_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['smallint']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type VNcsaMake_Sum_Fields_Vpic = {
  __typename?: 'vNCSAMake_sum_fields_vpic';
  Id?: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type VNcsaMake_Var_Pop_Fields_Vpic = {
  __typename?: 'vNCSAMake_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VNcsaMake_Var_Samp_Fields_Vpic = {
  __typename?: 'vNCSAMake_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VNcsaMake_Variance_Fields_Vpic = {
  __typename?: 'vNCSAMake_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.vncsamake" */
export type VNcsaMake_Vpic = {
  __typename?: 'vNCSAMake_vpic';
  Id?: Maybe<Scalars['smallint']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate fields of "vpic.vncsamodel" */
export type VNcsaModel_Aggregate_Fields_Vpic = {
  __typename?: 'vNCSAModel_aggregate_fields_vpic';
  avg?: Maybe<VNcsaModel_Avg_Fields_Vpic>;
  count: Scalars['Int'];
  max?: Maybe<VNcsaModel_Max_Fields_Vpic>;
  min?: Maybe<VNcsaModel_Min_Fields_Vpic>;
  stddev?: Maybe<VNcsaModel_Stddev_Fields_Vpic>;
  stddev_pop?: Maybe<VNcsaModel_Stddev_Pop_Fields_Vpic>;
  stddev_samp?: Maybe<VNcsaModel_Stddev_Samp_Fields_Vpic>;
  sum?: Maybe<VNcsaModel_Sum_Fields_Vpic>;
  var_pop?: Maybe<VNcsaModel_Var_Pop_Fields_Vpic>;
  var_samp?: Maybe<VNcsaModel_Var_Samp_Fields_Vpic>;
  variance?: Maybe<VNcsaModel_Variance_Fields_Vpic>;
};


/** aggregate fields of "vpic.vncsamodel" */
export type VNcsaModel_Aggregate_Fields_VpicCountArgs = {
  columns?: InputMaybe<Array<VNcsaModel_Select_Column_Vpic>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregated selection of "vpic.vncsamodel" */
export type VNcsaModel_Aggregate_Vpic = {
  __typename?: 'vNCSAModel_aggregate_vpic';
  aggregate?: Maybe<VNcsaModel_Aggregate_Fields_Vpic>;
  nodes: Array<VNcsaModel_Vpic>;
};

/** aggregate avg on columns */
export type VNcsaModel_Avg_Fields_Vpic = {
  __typename?: 'vNCSAModel_avg_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  OriginalId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vpic.vncsamodel". All fields are combined with a logical 'AND'. */
export type VNcsaModel_Bool_Exp_Vpic = {
  Id?: InputMaybe<Int_Comparison_Exp>;
  MakeId?: InputMaybe<Smallint_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OriginalId?: InputMaybe<Smallint_Comparison_Exp>;
  _and?: InputMaybe<Array<VNcsaModel_Bool_Exp_Vpic>>;
  _not?: InputMaybe<VNcsaModel_Bool_Exp_Vpic>;
  _or?: InputMaybe<Array<VNcsaModel_Bool_Exp_Vpic>>;
};

/** aggregate max on columns */
export type VNcsaModel_Max_Fields_Vpic = {
  __typename?: 'vNCSAModel_max_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['smallint']>;
  Name?: Maybe<Scalars['String']>;
  OriginalId?: Maybe<Scalars['smallint']>;
};

/** aggregate min on columns */
export type VNcsaModel_Min_Fields_Vpic = {
  __typename?: 'vNCSAModel_min_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['smallint']>;
  Name?: Maybe<Scalars['String']>;
  OriginalId?: Maybe<Scalars['smallint']>;
};

/** Ordering options when selecting data from "vpic.vncsamodel". */
export type VNcsaModel_Order_By_Vpic = {
  Id?: InputMaybe<Order_By>;
  MakeId?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OriginalId?: InputMaybe<Order_By>;
};

/** select columns of table "vpic.vncsamodel" */
export enum VNcsaModel_Select_Column_Vpic {
  /** column name */
  Id = 'Id',
  /** column name */
  MakeId = 'MakeId',
  /** column name */
  Name = 'Name',
  /** column name */
  OriginalId = 'OriginalId'
}

/** aggregate stddev on columns */
export type VNcsaModel_Stddev_Fields_Vpic = {
  __typename?: 'vNCSAModel_stddev_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  OriginalId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VNcsaModel_Stddev_Pop_Fields_Vpic = {
  __typename?: 'vNCSAModel_stddev_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  OriginalId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VNcsaModel_Stddev_Samp_Fields_Vpic = {
  __typename?: 'vNCSAModel_stddev_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  OriginalId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vNCSAModel" */
export type VNcsaModel_Stream_Cursor_Input_Vpic = {
  /** Stream column input with initial value */
  initial_value: VNcsaModel_Stream_Cursor_Value_Input_Vpic;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_Vpic>;
};

/** Initial value of the column from where the streaming should start */
export type VNcsaModel_Stream_Cursor_Value_Input_Vpic = {
  Id?: InputMaybe<Scalars['Int']>;
  MakeId?: InputMaybe<Scalars['smallint']>;
  Name?: InputMaybe<Scalars['String']>;
  OriginalId?: InputMaybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type VNcsaModel_Sum_Fields_Vpic = {
  __typename?: 'vNCSAModel_sum_fields_vpic';
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['smallint']>;
  OriginalId?: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type VNcsaModel_Var_Pop_Fields_Vpic = {
  __typename?: 'vNCSAModel_var_pop_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  OriginalId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VNcsaModel_Var_Samp_Fields_Vpic = {
  __typename?: 'vNCSAModel_var_samp_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  OriginalId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VNcsaModel_Variance_Fields_Vpic = {
  __typename?: 'vNCSAModel_variance_fields_vpic';
  Id?: Maybe<Scalars['Float']>;
  MakeId?: Maybe<Scalars['Float']>;
  OriginalId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vpic.vncsamodel" */
export type VNcsaModel_Vpic = {
  __typename?: 'vNCSAModel_vpic';
  Id?: Maybe<Scalars['Int']>;
  MakeId?: Maybe<Scalars['smallint']>;
  Name?: Maybe<Scalars['String']>;
  OriginalId?: Maybe<Scalars['smallint']>;
};

/** Top level node for the validation rules. These models are directly based on FluentValidation. This table contains high level user friendly information to help them identify the validation. */
export type Validation = {
  __typename?: 'validation';
  createdAt: Scalars['timestamptz'];
  /** Description of what the validation is intended to do */
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** Name of the validation */
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  validationLifecycleHooks: Array<ValidationLifecycleHook>;
  /** An aggregate relationship */
  validationLifecycleHooks_aggregate: ValidationLifecycleHook_Aggregate;
  /** An array relationship */
  validationOverrides: Array<ValidationOverride>;
  /** An aggregate relationship */
  validationOverrides_aggregate: ValidationOverride_Aggregate;
  /** An array relationship */
  validationRuleFors: Array<ValidationRuleFor>;
  /** An aggregate relationship */
  validationRuleFors_aggregate: ValidationRuleFor_Aggregate;
  /** An array relationship */
  validationWhens: Array<ValidationWhen>;
  /** An aggregate relationship */
  validationWhens_aggregate: ValidationWhen_Aggregate;
};


/** Top level node for the validation rules. These models are directly based on FluentValidation. This table contains high level user friendly information to help them identify the validation. */
export type ValidationValidationLifecycleHooksArgs = {
  distinct_on?: InputMaybe<Array<ValidationLifecycleHook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationLifecycleHook_Order_By>>;
  where?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
};


/** Top level node for the validation rules. These models are directly based on FluentValidation. This table contains high level user friendly information to help them identify the validation. */
export type ValidationValidationLifecycleHooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationLifecycleHook_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationLifecycleHook_Order_By>>;
  where?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
};


/** Top level node for the validation rules. These models are directly based on FluentValidation. This table contains high level user friendly information to help them identify the validation. */
export type ValidationValidationOverridesArgs = {
  distinct_on?: InputMaybe<Array<ValidationOverride_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationOverride_Order_By>>;
  where?: InputMaybe<ValidationOverride_Bool_Exp>;
};


/** Top level node for the validation rules. These models are directly based on FluentValidation. This table contains high level user friendly information to help them identify the validation. */
export type ValidationValidationOverrides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationOverride_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationOverride_Order_By>>;
  where?: InputMaybe<ValidationOverride_Bool_Exp>;
};


/** Top level node for the validation rules. These models are directly based on FluentValidation. This table contains high level user friendly information to help them identify the validation. */
export type ValidationValidationRuleForsArgs = {
  distinct_on?: InputMaybe<Array<ValidationRuleFor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationRuleFor_Order_By>>;
  where?: InputMaybe<ValidationRuleFor_Bool_Exp>;
};


/** Top level node for the validation rules. These models are directly based on FluentValidation. This table contains high level user friendly information to help them identify the validation. */
export type ValidationValidationRuleFors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationRuleFor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationRuleFor_Order_By>>;
  where?: InputMaybe<ValidationRuleFor_Bool_Exp>;
};


/** Top level node for the validation rules. These models are directly based on FluentValidation. This table contains high level user friendly information to help them identify the validation. */
export type ValidationValidationWhensArgs = {
  distinct_on?: InputMaybe<Array<ValidationWhen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationWhen_Order_By>>;
  where?: InputMaybe<ValidationWhen_Bool_Exp>;
};


/** Top level node for the validation rules. These models are directly based on FluentValidation. This table contains high level user friendly information to help them identify the validation. */
export type ValidationValidationWhens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationWhen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationWhen_Order_By>>;
  where?: InputMaybe<ValidationWhen_Bool_Exp>;
};

/** Join table between the Validation & Lifecycle Hooks. A validation can have multiple lifecycle hooks and vice versa. */
export type ValidationLifecycleHook = {
  __typename?: 'validationLifecycleHook';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  lifecycleHookType: Type;
  lifecycleHookTypeId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  validation: Validation;
  validationId: Scalars['uuid'];
};

/** aggregated selection of "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_Aggregate = {
  __typename?: 'validationLifecycleHook_aggregate';
  aggregate?: Maybe<ValidationLifecycleHook_Aggregate_Fields>;
  nodes: Array<ValidationLifecycleHook>;
};

export type ValidationLifecycleHook_Aggregate_Bool_Exp = {
  count?: InputMaybe<ValidationLifecycleHook_Aggregate_Bool_Exp_Count>;
};

export type ValidationLifecycleHook_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ValidationLifecycleHook_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_Aggregate_Fields = {
  __typename?: 'validationLifecycleHook_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ValidationLifecycleHook_Max_Fields>;
  min?: Maybe<ValidationLifecycleHook_Min_Fields>;
};


/** aggregate fields of "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ValidationLifecycleHook_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ValidationLifecycleHook_Max_Order_By>;
  min?: InputMaybe<ValidationLifecycleHook_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_Arr_Rel_Insert_Input = {
  data: Array<ValidationLifecycleHook_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ValidationLifecycleHook_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.validation_lifecycle_hook". All fields are combined with a logical 'AND'. */
export type ValidationLifecycleHook_Bool_Exp = {
  _and?: InputMaybe<Array<ValidationLifecycleHook_Bool_Exp>>;
  _not?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
  _or?: InputMaybe<Array<ValidationLifecycleHook_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lifecycleHookType?: InputMaybe<Type_Bool_Exp>;
  lifecycleHookTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  validation?: InputMaybe<Validation_Bool_Exp>;
  validationId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.validation_lifecycle_hook" */
export enum ValidationLifecycleHook_Constraint {
  /** unique or primary key constraint on columns "id" */
  ValidationLifecycleHookPkey = 'validation_lifecycle_hook_pkey'
}

/** input type for inserting data into table "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lifecycleHookType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  lifecycleHookTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validation?: InputMaybe<Validation_Obj_Rel_Insert_Input>;
  validationId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ValidationLifecycleHook_Max_Fields = {
  __typename?: 'validationLifecycleHook_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lifecycleHookTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validationId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lifecycleHookTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ValidationLifecycleHook_Min_Fields = {
  __typename?: 'validationLifecycleHook_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lifecycleHookTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validationId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lifecycleHookTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_Mutation_Response = {
  __typename?: 'validationLifecycleHook_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ValidationLifecycleHook>;
};

/** on_conflict condition type for table "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_On_Conflict = {
  constraint: ValidationLifecycleHook_Constraint;
  update_columns?: Array<ValidationLifecycleHook_Update_Column>;
  where?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.validation_lifecycle_hook". */
export type ValidationLifecycleHook_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lifecycleHookType?: InputMaybe<Type_Order_By>;
  lifecycleHookTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validation?: InputMaybe<Validation_Order_By>;
  validationId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.validation_lifecycle_hook */
export type ValidationLifecycleHook_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.validation_lifecycle_hook" */
export enum ValidationLifecycleHook_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LifecycleHookTypeId = 'lifecycleHookTypeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidationId = 'validationId'
}

/** input type for updating data in table "shared.validation_lifecycle_hook" */
export type ValidationLifecycleHook_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lifecycleHookTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "validationLifecycleHook" */
export type ValidationLifecycleHook_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ValidationLifecycleHook_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ValidationLifecycleHook_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lifecycleHookTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "shared.validation_lifecycle_hook" */
export enum ValidationLifecycleHook_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LifecycleHookTypeId = 'lifecycleHookTypeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidationId = 'validationId'
}

export type ValidationLifecycleHook_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ValidationLifecycleHook_Set_Input>;
  /** filter the rows which have to be updated */
  where: ValidationLifecycleHook_Bool_Exp;
};

/** Determines which validations or lifecycle hooks are overridden. An override means we will produce warning messages, and the operation will succeed rather than producing an error and failing. */
export type ValidationOverride = {
  __typename?: 'validationOverride';
  /** An object relationship */
  account?: Maybe<Account>;
  /** An object relationship */
  accountCategory?: Maybe<AccountCategory>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  identity?: Maybe<Identity>;
  /** An object relationship */
  lifecycleHookType?: Maybe<Type>;
  /** Determines what is being overridden. For example, A specific user overrides all rules for the Purchase lifecycle. */
  lifecycleHookTypeId?: Maybe<Scalars['uuid']>;
  /** Determines who can do the override ( Identity / Account / Account Category / etc. ) */
  parentId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  validation?: Maybe<Validation>;
  /** Determines what is being overridden. For example: A specific user overrides a validation. */
  validationId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "shared.validation_override" */
export type ValidationOverride_Aggregate = {
  __typename?: 'validationOverride_aggregate';
  aggregate?: Maybe<ValidationOverride_Aggregate_Fields>;
  nodes: Array<ValidationOverride>;
};

export type ValidationOverride_Aggregate_Bool_Exp = {
  count?: InputMaybe<ValidationOverride_Aggregate_Bool_Exp_Count>;
};

export type ValidationOverride_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ValidationOverride_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ValidationOverride_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.validation_override" */
export type ValidationOverride_Aggregate_Fields = {
  __typename?: 'validationOverride_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ValidationOverride_Max_Fields>;
  min?: Maybe<ValidationOverride_Min_Fields>;
};


/** aggregate fields of "shared.validation_override" */
export type ValidationOverride_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ValidationOverride_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.validation_override" */
export type ValidationOverride_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ValidationOverride_Max_Order_By>;
  min?: InputMaybe<ValidationOverride_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.validation_override" */
export type ValidationOverride_Arr_Rel_Insert_Input = {
  data: Array<ValidationOverride_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ValidationOverride_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.validation_override". All fields are combined with a logical 'AND'. */
export type ValidationOverride_Bool_Exp = {
  _and?: InputMaybe<Array<ValidationOverride_Bool_Exp>>;
  _not?: InputMaybe<ValidationOverride_Bool_Exp>;
  _or?: InputMaybe<Array<ValidationOverride_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  accountCategory?: InputMaybe<AccountCategory_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identity_Bool_Exp>;
  lifecycleHookType?: InputMaybe<Type_Bool_Exp>;
  lifecycleHookTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  validation?: InputMaybe<Validation_Bool_Exp>;
  validationId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.validation_override" */
export enum ValidationOverride_Constraint {
  /** unique or primary key constraint on columns "id" */
  ValidationOverridePkey = 'validation_override_pkey'
}

/** input type for inserting data into table "shared.validation_override" */
export type ValidationOverride_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  accountCategory?: InputMaybe<AccountCategory_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
  lifecycleHookType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** Determines what is being overridden. For example, A specific user overrides all rules for the Purchase lifecycle. */
  lifecycleHookTypeId?: InputMaybe<Scalars['uuid']>;
  /** Determines who can do the override ( Identity / Account / Account Category / etc. ) */
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validation?: InputMaybe<Validation_Obj_Rel_Insert_Input>;
  /** Determines what is being overridden. For example: A specific user overrides a validation. */
  validationId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ValidationOverride_Max_Fields = {
  __typename?: 'validationOverride_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Determines what is being overridden. For example, A specific user overrides all rules for the Purchase lifecycle. */
  lifecycleHookTypeId?: Maybe<Scalars['uuid']>;
  /** Determines who can do the override ( Identity / Account / Account Category / etc. ) */
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** Determines what is being overridden. For example: A specific user overrides a validation. */
  validationId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "shared.validation_override" */
export type ValidationOverride_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Determines what is being overridden. For example, A specific user overrides all rules for the Purchase lifecycle. */
  lifecycleHookTypeId?: InputMaybe<Order_By>;
  /** Determines who can do the override ( Identity / Account / Account Category / etc. ) */
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  /** Determines what is being overridden. For example: A specific user overrides a validation. */
  validationId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ValidationOverride_Min_Fields = {
  __typename?: 'validationOverride_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Determines what is being overridden. For example, A specific user overrides all rules for the Purchase lifecycle. */
  lifecycleHookTypeId?: Maybe<Scalars['uuid']>;
  /** Determines who can do the override ( Identity / Account / Account Category / etc. ) */
  parentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** Determines what is being overridden. For example: A specific user overrides a validation. */
  validationId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "shared.validation_override" */
export type ValidationOverride_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Determines what is being overridden. For example, A specific user overrides all rules for the Purchase lifecycle. */
  lifecycleHookTypeId?: InputMaybe<Order_By>;
  /** Determines who can do the override ( Identity / Account / Account Category / etc. ) */
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  /** Determines what is being overridden. For example: A specific user overrides a validation. */
  validationId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.validation_override" */
export type ValidationOverride_Mutation_Response = {
  __typename?: 'validationOverride_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ValidationOverride>;
};

/** on_conflict condition type for table "shared.validation_override" */
export type ValidationOverride_On_Conflict = {
  constraint: ValidationOverride_Constraint;
  update_columns?: Array<ValidationOverride_Update_Column>;
  where?: InputMaybe<ValidationOverride_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.validation_override". */
export type ValidationOverride_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  accountCategory?: InputMaybe<AccountCategory_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identity_Order_By>;
  lifecycleHookType?: InputMaybe<Type_Order_By>;
  lifecycleHookTypeId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validation?: InputMaybe<Validation_Order_By>;
  validationId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.validation_override */
export type ValidationOverride_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.validation_override" */
export enum ValidationOverride_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LifecycleHookTypeId = 'lifecycleHookTypeId',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidationId = 'validationId'
}

/** input type for updating data in table "shared.validation_override" */
export type ValidationOverride_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Determines what is being overridden. For example, A specific user overrides all rules for the Purchase lifecycle. */
  lifecycleHookTypeId?: InputMaybe<Scalars['uuid']>;
  /** Determines who can do the override ( Identity / Account / Account Category / etc. ) */
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Determines what is being overridden. For example: A specific user overrides a validation. */
  validationId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "validationOverride" */
export type ValidationOverride_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ValidationOverride_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ValidationOverride_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Determines what is being overridden. For example, A specific user overrides all rules for the Purchase lifecycle. */
  lifecycleHookTypeId?: InputMaybe<Scalars['uuid']>;
  /** Determines who can do the override ( Identity / Account / Account Category / etc. ) */
  parentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Determines what is being overridden. For example: A specific user overrides a validation. */
  validationId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "shared.validation_override" */
export enum ValidationOverride_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LifecycleHookTypeId = 'lifecycleHookTypeId',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidationId = 'validationId'
}

export type ValidationOverride_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ValidationOverride_Set_Input>;
  /** filter the rows which have to be updated */
  where: ValidationOverride_Bool_Exp;
};

/** Rules to determine Pass/Fail. Stores information for the code to build FluentValidation RuleFor statements. */
export type ValidationRuleFor = {
  __typename?: 'validationRuleFor';
  /** An object relationship */
  category?: Maybe<Category>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** The message returned to the user when the validation fails */
  message: Scalars['String'];
  /** An object relationship */
  operationType: Type;
  operationTypeId: Scalars['uuid'];
  /** An object relationship */
  product?: Maybe<Product>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  validation: Validation;
  validationId: Scalars['uuid'];
  /** An object relationship */
  validationType: Type;
  /** The type helps the code determine how to build and run the rule for statement & how to access the data to check against. */
  validationTypeId: Scalars['uuid'];
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value: Scalars['String'];
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "shared.validation_rule_for" */
export type ValidationRuleFor_Aggregate = {
  __typename?: 'validationRuleFor_aggregate';
  aggregate?: Maybe<ValidationRuleFor_Aggregate_Fields>;
  nodes: Array<ValidationRuleFor>;
};

export type ValidationRuleFor_Aggregate_Bool_Exp = {
  count?: InputMaybe<ValidationRuleFor_Aggregate_Bool_Exp_Count>;
};

export type ValidationRuleFor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ValidationRuleFor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ValidationRuleFor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.validation_rule_for" */
export type ValidationRuleFor_Aggregate_Fields = {
  __typename?: 'validationRuleFor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ValidationRuleFor_Max_Fields>;
  min?: Maybe<ValidationRuleFor_Min_Fields>;
};


/** aggregate fields of "shared.validation_rule_for" */
export type ValidationRuleFor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ValidationRuleFor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.validation_rule_for" */
export type ValidationRuleFor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ValidationRuleFor_Max_Order_By>;
  min?: InputMaybe<ValidationRuleFor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.validation_rule_for" */
export type ValidationRuleFor_Arr_Rel_Insert_Input = {
  data: Array<ValidationRuleFor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ValidationRuleFor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.validation_rule_for". All fields are combined with a logical 'AND'. */
export type ValidationRuleFor_Bool_Exp = {
  _and?: InputMaybe<Array<ValidationRuleFor_Bool_Exp>>;
  _not?: InputMaybe<ValidationRuleFor_Bool_Exp>;
  _or?: InputMaybe<Array<ValidationRuleFor_Bool_Exp>>;
  category?: InputMaybe<Category_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  operationType?: InputMaybe<Type_Bool_Exp>;
  operationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  validation?: InputMaybe<Validation_Bool_Exp>;
  validationId?: InputMaybe<Uuid_Comparison_Exp>;
  validationType?: InputMaybe<Type_Bool_Exp>;
  validationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  valueId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.validation_rule_for" */
export enum ValidationRuleFor_Constraint {
  /** unique or primary key constraint on columns "id" */
  ValidationRuleForPkey = 'validation_rule_for_pkey'
}

/** input type for inserting data into table "shared.validation_rule_for" */
export type ValidationRuleFor_Insert_Input = {
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The message returned to the user when the validation fails */
  message?: InputMaybe<Scalars['String']>;
  operationType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  operationTypeId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validation?: InputMaybe<Validation_Obj_Rel_Insert_Input>;
  validationId?: InputMaybe<Scalars['uuid']>;
  validationType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  /** The type helps the code determine how to build and run the rule for statement & how to access the data to check against. */
  validationTypeId?: InputMaybe<Scalars['uuid']>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: InputMaybe<Scalars['String']>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ValidationRuleFor_Max_Fields = {
  __typename?: 'validationRuleFor_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The message returned to the user when the validation fails */
  message?: Maybe<Scalars['String']>;
  operationTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validationId?: Maybe<Scalars['uuid']>;
  /** The type helps the code determine how to build and run the rule for statement & how to access the data to check against. */
  validationTypeId?: Maybe<Scalars['uuid']>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: Maybe<Scalars['String']>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "shared.validation_rule_for" */
export type ValidationRuleFor_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The message returned to the user when the validation fails */
  message?: InputMaybe<Order_By>;
  operationTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationId?: InputMaybe<Order_By>;
  /** The type helps the code determine how to build and run the rule for statement & how to access the data to check against. */
  validationTypeId?: InputMaybe<Order_By>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: InputMaybe<Order_By>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ValidationRuleFor_Min_Fields = {
  __typename?: 'validationRuleFor_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The message returned to the user when the validation fails */
  message?: Maybe<Scalars['String']>;
  operationTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validationId?: Maybe<Scalars['uuid']>;
  /** The type helps the code determine how to build and run the rule for statement & how to access the data to check against. */
  validationTypeId?: Maybe<Scalars['uuid']>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: Maybe<Scalars['String']>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "shared.validation_rule_for" */
export type ValidationRuleFor_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The message returned to the user when the validation fails */
  message?: InputMaybe<Order_By>;
  operationTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationId?: InputMaybe<Order_By>;
  /** The type helps the code determine how to build and run the rule for statement & how to access the data to check against. */
  validationTypeId?: InputMaybe<Order_By>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: InputMaybe<Order_By>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.validation_rule_for" */
export type ValidationRuleFor_Mutation_Response = {
  __typename?: 'validationRuleFor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ValidationRuleFor>;
};

/** on_conflict condition type for table "shared.validation_rule_for" */
export type ValidationRuleFor_On_Conflict = {
  constraint: ValidationRuleFor_Constraint;
  update_columns?: Array<ValidationRuleFor_Update_Column>;
  where?: InputMaybe<ValidationRuleFor_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.validation_rule_for". */
export type ValidationRuleFor_Order_By = {
  category?: InputMaybe<Category_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  operationType?: InputMaybe<Type_Order_By>;
  operationTypeId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validation?: InputMaybe<Validation_Order_By>;
  validationId?: InputMaybe<Order_By>;
  validationType?: InputMaybe<Type_Order_By>;
  validationTypeId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  valueId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.validation_rule_for */
export type ValidationRuleFor_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.validation_rule_for" */
export enum ValidationRuleFor_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  OperationTypeId = 'operationTypeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidationId = 'validationId',
  /** column name */
  ValidationTypeId = 'validationTypeId',
  /** column name */
  Value = 'value',
  /** column name */
  ValueId = 'valueId'
}

/** input type for updating data in table "shared.validation_rule_for" */
export type ValidationRuleFor_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The message returned to the user when the validation fails */
  message?: InputMaybe<Scalars['String']>;
  operationTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationId?: InputMaybe<Scalars['uuid']>;
  /** The type helps the code determine how to build and run the rule for statement & how to access the data to check against. */
  validationTypeId?: InputMaybe<Scalars['uuid']>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: InputMaybe<Scalars['String']>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "validationRuleFor" */
export type ValidationRuleFor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ValidationRuleFor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ValidationRuleFor_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The message returned to the user when the validation fails */
  message?: InputMaybe<Scalars['String']>;
  operationTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationId?: InputMaybe<Scalars['uuid']>;
  /** The type helps the code determine how to build and run the rule for statement & how to access the data to check against. */
  validationTypeId?: InputMaybe<Scalars['uuid']>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: InputMaybe<Scalars['String']>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "shared.validation_rule_for" */
export enum ValidationRuleFor_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  OperationTypeId = 'operationTypeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidationId = 'validationId',
  /** column name */
  ValidationTypeId = 'validationTypeId',
  /** column name */
  Value = 'value',
  /** column name */
  ValueId = 'valueId'
}

export type ValidationRuleFor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ValidationRuleFor_Set_Input>;
  /** filter the rows which have to be updated */
  where: ValidationRuleFor_Bool_Exp;
};

/** Many to Many table that allows us to define what operations have been set up for specific validation types. */
export type ValidationTypeOperation = {
  __typename?: 'validationTypeOperation';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  operationType: Type;
  operationTypeId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  validationType: Type;
  validationTypeId: Scalars['uuid'];
};

/** aggregated selection of "shared.validation_type_operation" */
export type ValidationTypeOperation_Aggregate = {
  __typename?: 'validationTypeOperation_aggregate';
  aggregate?: Maybe<ValidationTypeOperation_Aggregate_Fields>;
  nodes: Array<ValidationTypeOperation>;
};

export type ValidationTypeOperation_Aggregate_Bool_Exp = {
  count?: InputMaybe<ValidationTypeOperation_Aggregate_Bool_Exp_Count>;
};

export type ValidationTypeOperation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ValidationTypeOperation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.validation_type_operation" */
export type ValidationTypeOperation_Aggregate_Fields = {
  __typename?: 'validationTypeOperation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ValidationTypeOperation_Max_Fields>;
  min?: Maybe<ValidationTypeOperation_Min_Fields>;
};


/** aggregate fields of "shared.validation_type_operation" */
export type ValidationTypeOperation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ValidationTypeOperation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.validation_type_operation" */
export type ValidationTypeOperation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ValidationTypeOperation_Max_Order_By>;
  min?: InputMaybe<ValidationTypeOperation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.validation_type_operation" */
export type ValidationTypeOperation_Arr_Rel_Insert_Input = {
  data: Array<ValidationTypeOperation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ValidationTypeOperation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.validation_type_operation". All fields are combined with a logical 'AND'. */
export type ValidationTypeOperation_Bool_Exp = {
  _and?: InputMaybe<Array<ValidationTypeOperation_Bool_Exp>>;
  _not?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
  _or?: InputMaybe<Array<ValidationTypeOperation_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  operationType?: InputMaybe<Type_Bool_Exp>;
  operationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  validationType?: InputMaybe<Type_Bool_Exp>;
  validationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.validation_type_operation" */
export enum ValidationTypeOperation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ValidationTypeOperationPkey = 'validation_type_operation_pkey',
  /** unique or primary key constraint on columns "operation_type_id", "validation_type_id" */
  ValidationTypeOperationValidationTypeIdOperationTypeId = 'validation_type_operation_validation_type_id_operation_type_id_'
}

/** input type for inserting data into table "shared.validation_type_operation" */
export type ValidationTypeOperation_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  operationType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  operationTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  validationTypeId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ValidationTypeOperation_Max_Fields = {
  __typename?: 'validationTypeOperation_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  operationTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validationTypeId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "shared.validation_type_operation" */
export type ValidationTypeOperation_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationTypeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ValidationTypeOperation_Min_Fields = {
  __typename?: 'validationTypeOperation_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  operationTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validationTypeId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "shared.validation_type_operation" */
export type ValidationTypeOperation_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.validation_type_operation" */
export type ValidationTypeOperation_Mutation_Response = {
  __typename?: 'validationTypeOperation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ValidationTypeOperation>;
};

/** on_conflict condition type for table "shared.validation_type_operation" */
export type ValidationTypeOperation_On_Conflict = {
  constraint: ValidationTypeOperation_Constraint;
  update_columns?: Array<ValidationTypeOperation_Update_Column>;
  where?: InputMaybe<ValidationTypeOperation_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.validation_type_operation". */
export type ValidationTypeOperation_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationType?: InputMaybe<Type_Order_By>;
  operationTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationType?: InputMaybe<Type_Order_By>;
  validationTypeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.validation_type_operation */
export type ValidationTypeOperation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.validation_type_operation" */
export enum ValidationTypeOperation_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OperationTypeId = 'operationTypeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidationTypeId = 'validationTypeId'
}

/** input type for updating data in table "shared.validation_type_operation" */
export type ValidationTypeOperation_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  operationTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationTypeId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "validationTypeOperation" */
export type ValidationTypeOperation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ValidationTypeOperation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ValidationTypeOperation_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  operationTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationTypeId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "shared.validation_type_operation" */
export enum ValidationTypeOperation_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OperationTypeId = 'operationTypeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidationTypeId = 'validationTypeId'
}

export type ValidationTypeOperation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ValidationTypeOperation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ValidationTypeOperation_Bool_Exp;
};

/** Used to determine when the Rule For statements are supposed to run in the given context. Stores information for the code to build FluentValidation When statements. For example, when the category is OEM, then the RuleFor statements for this validation apply. Multiple When statements with the same type combine with OR statements, different types use AND statements. If there are no When records, the RuleFor statement will always be ran. */
export type ValidationWhen = {
  __typename?: 'validationWhen';
  /** An object relationship */
  category?: Maybe<Category>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  operationType: Type;
  operationTypeId: Scalars['uuid'];
  /** An object relationship */
  product?: Maybe<Product>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  validation: Validation;
  validationId: Scalars['uuid'];
  /** An object relationship */
  validationType: Type;
  validationTypeId: Scalars['uuid'];
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value: Scalars['String'];
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "shared.validation_when" */
export type ValidationWhen_Aggregate = {
  __typename?: 'validationWhen_aggregate';
  aggregate?: Maybe<ValidationWhen_Aggregate_Fields>;
  nodes: Array<ValidationWhen>;
};

export type ValidationWhen_Aggregate_Bool_Exp = {
  count?: InputMaybe<ValidationWhen_Aggregate_Bool_Exp_Count>;
};

export type ValidationWhen_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ValidationWhen_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ValidationWhen_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shared.validation_when" */
export type ValidationWhen_Aggregate_Fields = {
  __typename?: 'validationWhen_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ValidationWhen_Max_Fields>;
  min?: Maybe<ValidationWhen_Min_Fields>;
};


/** aggregate fields of "shared.validation_when" */
export type ValidationWhen_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ValidationWhen_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shared.validation_when" */
export type ValidationWhen_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ValidationWhen_Max_Order_By>;
  min?: InputMaybe<ValidationWhen_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shared.validation_when" */
export type ValidationWhen_Arr_Rel_Insert_Input = {
  data: Array<ValidationWhen_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ValidationWhen_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shared.validation_when". All fields are combined with a logical 'AND'. */
export type ValidationWhen_Bool_Exp = {
  _and?: InputMaybe<Array<ValidationWhen_Bool_Exp>>;
  _not?: InputMaybe<ValidationWhen_Bool_Exp>;
  _or?: InputMaybe<Array<ValidationWhen_Bool_Exp>>;
  category?: InputMaybe<Category_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  operationType?: InputMaybe<Type_Bool_Exp>;
  operationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  validation?: InputMaybe<Validation_Bool_Exp>;
  validationId?: InputMaybe<Uuid_Comparison_Exp>;
  validationType?: InputMaybe<Type_Bool_Exp>;
  validationTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  valueId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared.validation_when" */
export enum ValidationWhen_Constraint {
  /** unique or primary key constraint on columns "id" */
  ValidationWhenPkey = 'validation_when_pkey'
}

/** input type for inserting data into table "shared.validation_when" */
export type ValidationWhen_Insert_Input = {
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  operationType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  operationTypeId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validation?: InputMaybe<Validation_Obj_Rel_Insert_Input>;
  validationId?: InputMaybe<Scalars['uuid']>;
  validationType?: InputMaybe<Type_Obj_Rel_Insert_Input>;
  validationTypeId?: InputMaybe<Scalars['uuid']>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: InputMaybe<Scalars['String']>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ValidationWhen_Max_Fields = {
  __typename?: 'validationWhen_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  operationTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validationId?: Maybe<Scalars['uuid']>;
  validationTypeId?: Maybe<Scalars['uuid']>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: Maybe<Scalars['String']>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "shared.validation_when" */
export type ValidationWhen_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationId?: InputMaybe<Order_By>;
  validationTypeId?: InputMaybe<Order_By>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: InputMaybe<Order_By>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ValidationWhen_Min_Fields = {
  __typename?: 'validationWhen_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  operationTypeId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validationId?: Maybe<Scalars['uuid']>;
  validationTypeId?: Maybe<Scalars['uuid']>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: Maybe<Scalars['String']>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "shared.validation_when" */
export type ValidationWhen_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationTypeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationId?: InputMaybe<Order_By>;
  validationTypeId?: InputMaybe<Order_By>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: InputMaybe<Order_By>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shared.validation_when" */
export type ValidationWhen_Mutation_Response = {
  __typename?: 'validationWhen_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ValidationWhen>;
};

/** on_conflict condition type for table "shared.validation_when" */
export type ValidationWhen_On_Conflict = {
  constraint: ValidationWhen_Constraint;
  update_columns?: Array<ValidationWhen_Update_Column>;
  where?: InputMaybe<ValidationWhen_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.validation_when". */
export type ValidationWhen_Order_By = {
  category?: InputMaybe<Category_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationType?: InputMaybe<Type_Order_By>;
  operationTypeId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validation?: InputMaybe<Validation_Order_By>;
  validationId?: InputMaybe<Order_By>;
  validationType?: InputMaybe<Type_Order_By>;
  validationTypeId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  valueId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared.validation_when */
export type ValidationWhen_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.validation_when" */
export enum ValidationWhen_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OperationTypeId = 'operationTypeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidationId = 'validationId',
  /** column name */
  ValidationTypeId = 'validationTypeId',
  /** column name */
  Value = 'value',
  /** column name */
  ValueId = 'valueId'
}

/** input type for updating data in table "shared.validation_when" */
export type ValidationWhen_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  operationTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationId?: InputMaybe<Scalars['uuid']>;
  validationTypeId?: InputMaybe<Scalars['uuid']>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: InputMaybe<Scalars['String']>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "validationWhen" */
export type ValidationWhen_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ValidationWhen_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ValidationWhen_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  operationTypeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationId?: InputMaybe<Scalars['uuid']>;
  validationTypeId?: InputMaybe<Scalars['uuid']>;
  /** A string containing whatever value we need to check for for the given validation type. Could be uuid, bool, string, etc. */
  value?: InputMaybe<Scalars['String']>;
  /** Maintained through a trigger that will set this to whatever is in value if the type of the value is a uuid. Otherwise this will be null. Used to build relationships to the entity the matcher is created for. */
  valueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "shared.validation_when" */
export enum ValidationWhen_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OperationTypeId = 'operationTypeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidationId = 'validationId',
  /** column name */
  ValidationTypeId = 'validationTypeId',
  /** column name */
  Value = 'value',
  /** column name */
  ValueId = 'valueId'
}

export type ValidationWhen_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ValidationWhen_Set_Input>;
  /** filter the rows which have to be updated */
  where: ValidationWhen_Bool_Exp;
};

/** aggregated selection of "shared.validation" */
export type Validation_Aggregate = {
  __typename?: 'validation_aggregate';
  aggregate?: Maybe<Validation_Aggregate_Fields>;
  nodes: Array<Validation>;
};

/** aggregate fields of "shared.validation" */
export type Validation_Aggregate_Fields = {
  __typename?: 'validation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Validation_Max_Fields>;
  min?: Maybe<Validation_Min_Fields>;
};


/** aggregate fields of "shared.validation" */
export type Validation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Validation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "shared.validation". All fields are combined with a logical 'AND'. */
export type Validation_Bool_Exp = {
  _and?: InputMaybe<Array<Validation_Bool_Exp>>;
  _not?: InputMaybe<Validation_Bool_Exp>;
  _or?: InputMaybe<Array<Validation_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  effectiveDate?: InputMaybe<Date_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  validationLifecycleHooks?: InputMaybe<ValidationLifecycleHook_Bool_Exp>;
  validationLifecycleHooks_aggregate?: InputMaybe<ValidationLifecycleHook_Aggregate_Bool_Exp>;
  validationOverrides?: InputMaybe<ValidationOverride_Bool_Exp>;
  validationOverrides_aggregate?: InputMaybe<ValidationOverride_Aggregate_Bool_Exp>;
  validationRuleFors?: InputMaybe<ValidationRuleFor_Bool_Exp>;
  validationRuleFors_aggregate?: InputMaybe<ValidationRuleFor_Aggregate_Bool_Exp>;
  validationWhens?: InputMaybe<ValidationWhen_Bool_Exp>;
  validationWhens_aggregate?: InputMaybe<ValidationWhen_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "shared.validation" */
export enum Validation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ValidationPkey = 'validation_pkey'
}

/** input type for inserting data into table "shared.validation" */
export type Validation_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Description of what the validation is intended to do */
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Name of the validation */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationLifecycleHooks?: InputMaybe<ValidationLifecycleHook_Arr_Rel_Insert_Input>;
  validationOverrides?: InputMaybe<ValidationOverride_Arr_Rel_Insert_Input>;
  validationRuleFors?: InputMaybe<ValidationRuleFor_Arr_Rel_Insert_Input>;
  validationWhens?: InputMaybe<ValidationWhen_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Validation_Max_Fields = {
  __typename?: 'validation_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Description of what the validation is intended to do */
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** Name of the validation */
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Validation_Min_Fields = {
  __typename?: 'validation_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Description of what the validation is intended to do */
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['date']>;
  expirationDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** Name of the validation */
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shared.validation" */
export type Validation_Mutation_Response = {
  __typename?: 'validation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Validation>;
};

/** input type for inserting object relation for remote table "shared.validation" */
export type Validation_Obj_Rel_Insert_Input = {
  data: Validation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Validation_On_Conflict>;
};

/** on_conflict condition type for table "shared.validation" */
export type Validation_On_Conflict = {
  constraint: Validation_Constraint;
  update_columns?: Array<Validation_Update_Column>;
  where?: InputMaybe<Validation_Bool_Exp>;
};

/** Ordering options when selecting data from "shared.validation". */
export type Validation_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  effectiveDate?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationLifecycleHooks_aggregate?: InputMaybe<ValidationLifecycleHook_Aggregate_Order_By>;
  validationOverrides_aggregate?: InputMaybe<ValidationOverride_Aggregate_Order_By>;
  validationRuleFors_aggregate?: InputMaybe<ValidationRuleFor_Aggregate_Order_By>;
  validationWhens_aggregate?: InputMaybe<ValidationWhen_Aggregate_Order_By>;
};

/** primary key columns input for table: shared.validation */
export type Validation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shared.validation" */
export enum Validation_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shared.validation" */
export type Validation_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Description of what the validation is intended to do */
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Name of the validation */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "validation" */
export type Validation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Validation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Validation_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Description of what the validation is intended to do */
  description?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['date']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Name of the validation */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "shared.validation" */
export enum Validation_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveDate = 'effectiveDate',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Validation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Validation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Validation_Bool_Exp;
};

/** columns and relationships of "vehicle" */
export type Vehicle = {
  __typename?: 'vehicle';
  createdAt: Scalars['timestamptz'];
  cylinders: Scalars['String'];
  drive: Scalars['String'];
  engineSize: Scalars['String'];
  id: Scalars['uuid'];
  make: Scalars['String'];
  model: Scalars['String'];
  transmission: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  vin: Scalars['String'];
  year: Scalars['String'];
};

/** This view is used during the flow of determining if a decoded vin is missing any information. */
export type VehicleAttributesDefinedView = {
  __typename?: 'vehicleAttributesDefinedView';
  /** An object relationship */
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
};

/** aggregated selection of "vehicle.vehicle_attributes_defined_view" */
export type VehicleAttributesDefinedView_Aggregate = {
  __typename?: 'vehicleAttributesDefinedView_aggregate';
  aggregate?: Maybe<VehicleAttributesDefinedView_Aggregate_Fields>;
  nodes: Array<VehicleAttributesDefinedView>;
};

/** aggregate fields of "vehicle.vehicle_attributes_defined_view" */
export type VehicleAttributesDefinedView_Aggregate_Fields = {
  __typename?: 'vehicleAttributesDefinedView_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<VehicleAttributesDefinedView_Max_Fields>;
  min?: Maybe<VehicleAttributesDefinedView_Min_Fields>;
};


/** aggregate fields of "vehicle.vehicle_attributes_defined_view" */
export type VehicleAttributesDefinedView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<VehicleAttributesDefinedView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "vehicle.vehicle_attributes_defined_view". All fields are combined with a logical 'AND'. */
export type VehicleAttributesDefinedView_Bool_Exp = {
  _and?: InputMaybe<Array<VehicleAttributesDefinedView_Bool_Exp>>;
  _not?: InputMaybe<VehicleAttributesDefinedView_Bool_Exp>;
  _or?: InputMaybe<Array<VehicleAttributesDefinedView_Bool_Exp>>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type VehicleAttributesDefinedView_Max_Fields = {
  __typename?: 'vehicleAttributesDefinedView_max_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VehicleAttributesDefinedView_Min_Fields = {
  __typename?: 'vehicleAttributesDefinedView_min_fields';
  categoryId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "vehicle.vehicle_attributes_defined_view". */
export type VehicleAttributesDefinedView_Order_By = {
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
};

/** select columns of table "vehicle.vehicle_attributes_defined_view" */
export enum VehicleAttributesDefinedView_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Code = 'code'
}

/** Streaming cursor of the table "vehicleAttributesDefinedView" */
export type VehicleAttributesDefinedView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: VehicleAttributesDefinedView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type VehicleAttributesDefinedView_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['uuid']>;
  code?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "vwVehicleClassingBodyStyle" */
export type VehicleClassingBodyStyle = {
  __typename?: 'vehicleClassingBodyStyle';
  Code: Scalars['String'];
  Name: Scalars['String'];
};

/** aggregated selection of "vwVehicleClassingBodyStyle" */
export type VehicleClassingBodyStyle_Aggregate = {
  __typename?: 'vehicleClassingBodyStyle_aggregate';
  aggregate?: Maybe<VehicleClassingBodyStyle_Aggregate_Fields>;
  nodes: Array<VehicleClassingBodyStyle>;
};

/** aggregate fields of "vwVehicleClassingBodyStyle" */
export type VehicleClassingBodyStyle_Aggregate_Fields = {
  __typename?: 'vehicleClassingBodyStyle_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<VehicleClassingBodyStyle_Max_Fields>;
  min?: Maybe<VehicleClassingBodyStyle_Min_Fields>;
};


/** aggregate fields of "vwVehicleClassingBodyStyle" */
export type VehicleClassingBodyStyle_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<VehicleClassingBodyStyle_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "vwVehicleClassingBodyStyle". All fields are combined with a logical 'AND'. */
export type VehicleClassingBodyStyle_Bool_Exp = {
  Code?: InputMaybe<String_Mssql_Comparison_Exp>;
  Name?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<VehicleClassingBodyStyle_Bool_Exp>>;
  _not?: InputMaybe<VehicleClassingBodyStyle_Bool_Exp>;
  _or?: InputMaybe<Array<VehicleClassingBodyStyle_Bool_Exp>>;
};

/** upsert condition type for table "vwVehicleClassingBodyStyle" */
export type VehicleClassingBodyStyle_If_Matched = {
  match_columns?: Array<VehicleClassingBodyStyle_Insert_Match_Column>;
  update_columns?: Array<VehicleClassingBodyStyle_Update_Column>;
  where?: InputMaybe<VehicleClassingBodyStyle_Bool_Exp>;
};

/** input type for inserting data into table "vwVehicleClassingBodyStyle" */
export type VehicleClassingBodyStyle_Insert_Input = {
  Code?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** select match_columns of table "vwVehicleClassingBodyStyle" */
export enum VehicleClassingBodyStyle_Insert_Match_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** aggregate max on columns */
export type VehicleClassingBodyStyle_Max_Fields = {
  __typename?: 'vehicleClassingBodyStyle_max_fields';
  Code?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VehicleClassingBodyStyle_Min_Fields = {
  __typename?: 'vehicleClassingBodyStyle_min_fields';
  Code?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vwVehicleClassingBodyStyle" */
export type VehicleClassingBodyStyle_Mutation_Response = {
  __typename?: 'vehicleClassingBodyStyle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleClassingBodyStyle>;
};

/** Ordering options when selecting data from "vwVehicleClassingBodyStyle". */
export type VehicleClassingBodyStyle_Order_By = {
  Code?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** select columns of table "vwVehicleClassingBodyStyle" */
export enum VehicleClassingBodyStyle_Select_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vwVehicleClassingBodyStyle" */
export type VehicleClassingBodyStyle_Set_Input = {
  Code?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "vwVehicleClassingBodyStyle" */
export enum VehicleClassingBodyStyle_Update_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** columns and relationships of "vwVehicleClassingFuelType" */
export type VehicleClassingFuelType = {
  __typename?: 'vehicleClassingFuelType';
  Code: Scalars['String'];
  Name: Scalars['String'];
};

/** aggregated selection of "vwVehicleClassingFuelType" */
export type VehicleClassingFuelType_Aggregate = {
  __typename?: 'vehicleClassingFuelType_aggregate';
  aggregate?: Maybe<VehicleClassingFuelType_Aggregate_Fields>;
  nodes: Array<VehicleClassingFuelType>;
};

/** aggregate fields of "vwVehicleClassingFuelType" */
export type VehicleClassingFuelType_Aggregate_Fields = {
  __typename?: 'vehicleClassingFuelType_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<VehicleClassingFuelType_Max_Fields>;
  min?: Maybe<VehicleClassingFuelType_Min_Fields>;
};


/** aggregate fields of "vwVehicleClassingFuelType" */
export type VehicleClassingFuelType_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<VehicleClassingFuelType_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "vwVehicleClassingFuelType". All fields are combined with a logical 'AND'. */
export type VehicleClassingFuelType_Bool_Exp = {
  Code?: InputMaybe<String_Mssql_Comparison_Exp>;
  Name?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<VehicleClassingFuelType_Bool_Exp>>;
  _not?: InputMaybe<VehicleClassingFuelType_Bool_Exp>;
  _or?: InputMaybe<Array<VehicleClassingFuelType_Bool_Exp>>;
};

/** upsert condition type for table "vwVehicleClassingFuelType" */
export type VehicleClassingFuelType_If_Matched = {
  match_columns?: Array<VehicleClassingFuelType_Insert_Match_Column>;
  update_columns?: Array<VehicleClassingFuelType_Update_Column>;
  where?: InputMaybe<VehicleClassingFuelType_Bool_Exp>;
};

/** input type for inserting data into table "vwVehicleClassingFuelType" */
export type VehicleClassingFuelType_Insert_Input = {
  Code?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** select match_columns of table "vwVehicleClassingFuelType" */
export enum VehicleClassingFuelType_Insert_Match_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** aggregate max on columns */
export type VehicleClassingFuelType_Max_Fields = {
  __typename?: 'vehicleClassingFuelType_max_fields';
  Code?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VehicleClassingFuelType_Min_Fields = {
  __typename?: 'vehicleClassingFuelType_min_fields';
  Code?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vwVehicleClassingFuelType" */
export type VehicleClassingFuelType_Mutation_Response = {
  __typename?: 'vehicleClassingFuelType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleClassingFuelType>;
};

/** Ordering options when selecting data from "vwVehicleClassingFuelType". */
export type VehicleClassingFuelType_Order_By = {
  Code?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** select columns of table "vwVehicleClassingFuelType" */
export enum VehicleClassingFuelType_Select_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vwVehicleClassingFuelType" */
export type VehicleClassingFuelType_Set_Input = {
  Code?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "vwVehicleClassingFuelType" */
export enum VehicleClassingFuelType_Update_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** columns and relationships of "vwVehicleClassingVehicleMake" */
export type VehicleClassingVehicleMake = {
  __typename?: 'vehicleClassingVehicleMake';
  Code: Scalars['String'];
  Name: Scalars['String'];
};

/** aggregated selection of "vwVehicleClassingVehicleMake" */
export type VehicleClassingVehicleMake_Aggregate = {
  __typename?: 'vehicleClassingVehicleMake_aggregate';
  aggregate?: Maybe<VehicleClassingVehicleMake_Aggregate_Fields>;
  nodes: Array<VehicleClassingVehicleMake>;
};

/** aggregate fields of "vwVehicleClassingVehicleMake" */
export type VehicleClassingVehicleMake_Aggregate_Fields = {
  __typename?: 'vehicleClassingVehicleMake_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<VehicleClassingVehicleMake_Max_Fields>;
  min?: Maybe<VehicleClassingVehicleMake_Min_Fields>;
};


/** aggregate fields of "vwVehicleClassingVehicleMake" */
export type VehicleClassingVehicleMake_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<VehicleClassingVehicleMake_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "vwVehicleClassingVehicleMake". All fields are combined with a logical 'AND'. */
export type VehicleClassingVehicleMake_Bool_Exp = {
  Code?: InputMaybe<String_Mssql_Comparison_Exp>;
  Name?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<VehicleClassingVehicleMake_Bool_Exp>>;
  _not?: InputMaybe<VehicleClassingVehicleMake_Bool_Exp>;
  _or?: InputMaybe<Array<VehicleClassingVehicleMake_Bool_Exp>>;
};

/** upsert condition type for table "vwVehicleClassingVehicleMake" */
export type VehicleClassingVehicleMake_If_Matched = {
  match_columns?: Array<VehicleClassingVehicleMake_Insert_Match_Column>;
  update_columns?: Array<VehicleClassingVehicleMake_Update_Column>;
  where?: InputMaybe<VehicleClassingVehicleMake_Bool_Exp>;
};

/** input type for inserting data into table "vwVehicleClassingVehicleMake" */
export type VehicleClassingVehicleMake_Insert_Input = {
  Code?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** select match_columns of table "vwVehicleClassingVehicleMake" */
export enum VehicleClassingVehicleMake_Insert_Match_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** aggregate max on columns */
export type VehicleClassingVehicleMake_Max_Fields = {
  __typename?: 'vehicleClassingVehicleMake_max_fields';
  Code?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VehicleClassingVehicleMake_Min_Fields = {
  __typename?: 'vehicleClassingVehicleMake_min_fields';
  Code?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vwVehicleClassingVehicleMake" */
export type VehicleClassingVehicleMake_Mutation_Response = {
  __typename?: 'vehicleClassingVehicleMake_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleClassingVehicleMake>;
};

/** Ordering options when selecting data from "vwVehicleClassingVehicleMake". */
export type VehicleClassingVehicleMake_Order_By = {
  Code?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** select columns of table "vwVehicleClassingVehicleMake" */
export enum VehicleClassingVehicleMake_Select_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vwVehicleClassingVehicleMake" */
export type VehicleClassingVehicleMake_Set_Input = {
  Code?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "vwVehicleClassingVehicleMake" */
export enum VehicleClassingVehicleMake_Update_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** columns and relationships of "vwVehicleClassingVehicleType" */
export type VehicleClassingVehicleType = {
  __typename?: 'vehicleClassingVehicleType';
  Code: Scalars['String'];
  Name: Scalars['String'];
};

/** aggregated selection of "vwVehicleClassingVehicleType" */
export type VehicleClassingVehicleType_Aggregate = {
  __typename?: 'vehicleClassingVehicleType_aggregate';
  aggregate?: Maybe<VehicleClassingVehicleType_Aggregate_Fields>;
  nodes: Array<VehicleClassingVehicleType>;
};

/** aggregate fields of "vwVehicleClassingVehicleType" */
export type VehicleClassingVehicleType_Aggregate_Fields = {
  __typename?: 'vehicleClassingVehicleType_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<VehicleClassingVehicleType_Max_Fields>;
  min?: Maybe<VehicleClassingVehicleType_Min_Fields>;
};


/** aggregate fields of "vwVehicleClassingVehicleType" */
export type VehicleClassingVehicleType_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<VehicleClassingVehicleType_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "vwVehicleClassingVehicleType". All fields are combined with a logical 'AND'. */
export type VehicleClassingVehicleType_Bool_Exp = {
  Code?: InputMaybe<String_Mssql_Comparison_Exp>;
  Name?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<VehicleClassingVehicleType_Bool_Exp>>;
  _not?: InputMaybe<VehicleClassingVehicleType_Bool_Exp>;
  _or?: InputMaybe<Array<VehicleClassingVehicleType_Bool_Exp>>;
};

/** upsert condition type for table "vwVehicleClassingVehicleType" */
export type VehicleClassingVehicleType_If_Matched = {
  match_columns?: Array<VehicleClassingVehicleType_Insert_Match_Column>;
  update_columns?: Array<VehicleClassingVehicleType_Update_Column>;
  where?: InputMaybe<VehicleClassingVehicleType_Bool_Exp>;
};

/** input type for inserting data into table "vwVehicleClassingVehicleType" */
export type VehicleClassingVehicleType_Insert_Input = {
  Code?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** select match_columns of table "vwVehicleClassingVehicleType" */
export enum VehicleClassingVehicleType_Insert_Match_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** aggregate max on columns */
export type VehicleClassingVehicleType_Max_Fields = {
  __typename?: 'vehicleClassingVehicleType_max_fields';
  Code?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VehicleClassingVehicleType_Min_Fields = {
  __typename?: 'vehicleClassingVehicleType_min_fields';
  Code?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vwVehicleClassingVehicleType" */
export type VehicleClassingVehicleType_Mutation_Response = {
  __typename?: 'vehicleClassingVehicleType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleClassingVehicleType>;
};

/** Ordering options when selecting data from "vwVehicleClassingVehicleType". */
export type VehicleClassingVehicleType_Order_By = {
  Code?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** select columns of table "vwVehicleClassingVehicleType" */
export enum VehicleClassingVehicleType_Select_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** input type for updating data in table "vwVehicleClassingVehicleType" */
export type VehicleClassingVehicleType_Set_Input = {
  Code?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "vwVehicleClassingVehicleType" */
export enum VehicleClassingVehicleType_Update_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  Name = 'Name'
}

/** These status types are used in codegen. */
export type VehicleStatusType = {
  __typename?: 'vehicleStatusType';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "vehicle.vehicle_status_type" */
export type VehicleStatusType_Aggregate = {
  __typename?: 'vehicleStatusType_aggregate';
  aggregate?: Maybe<VehicleStatusType_Aggregate_Fields>;
  nodes: Array<VehicleStatusType>;
};

/** aggregate fields of "vehicle.vehicle_status_type" */
export type VehicleStatusType_Aggregate_Fields = {
  __typename?: 'vehicleStatusType_aggregate_fields';
  avg?: Maybe<VehicleStatusType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<VehicleStatusType_Max_Fields>;
  min?: Maybe<VehicleStatusType_Min_Fields>;
  stddev?: Maybe<VehicleStatusType_Stddev_Fields>;
  stddev_pop?: Maybe<VehicleStatusType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VehicleStatusType_Stddev_Samp_Fields>;
  sum?: Maybe<VehicleStatusType_Sum_Fields>;
  var_pop?: Maybe<VehicleStatusType_Var_Pop_Fields>;
  var_samp?: Maybe<VehicleStatusType_Var_Samp_Fields>;
  variance?: Maybe<VehicleStatusType_Variance_Fields>;
};


/** aggregate fields of "vehicle.vehicle_status_type" */
export type VehicleStatusType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<VehicleStatusType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VehicleStatusType_Avg_Fields = {
  __typename?: 'vehicleStatusType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vehicle.vehicle_status_type". All fields are combined with a logical 'AND'. */
export type VehicleStatusType_Bool_Exp = {
  _and?: InputMaybe<Array<VehicleStatusType_Bool_Exp>>;
  _not?: InputMaybe<VehicleStatusType_Bool_Exp>;
  _or?: InputMaybe<Array<VehicleStatusType_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle.vehicle_status_type" */
export enum VehicleStatusType_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehicleStatusTypePkey = 'vehicle_status_type_pkey'
}

/** input type for incrementing numeric columns in table "vehicle.vehicle_status_type" */
export type VehicleStatusType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle.vehicle_status_type" */
export type VehicleStatusType_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type VehicleStatusType_Max_Fields = {
  __typename?: 'vehicleStatusType_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type VehicleStatusType_Min_Fields = {
  __typename?: 'vehicleStatusType_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "vehicle.vehicle_status_type" */
export type VehicleStatusType_Mutation_Response = {
  __typename?: 'vehicleStatusType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VehicleStatusType>;
};

/** on_conflict condition type for table "vehicle.vehicle_status_type" */
export type VehicleStatusType_On_Conflict = {
  constraint: VehicleStatusType_Constraint;
  update_columns?: Array<VehicleStatusType_Update_Column>;
  where?: InputMaybe<VehicleStatusType_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle.vehicle_status_type". */
export type VehicleStatusType_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle.vehicle_status_type */
export type VehicleStatusType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "vehicle.vehicle_status_type" */
export enum VehicleStatusType_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "vehicle.vehicle_status_type" */
export type VehicleStatusType_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type VehicleStatusType_Stddev_Fields = {
  __typename?: 'vehicleStatusType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VehicleStatusType_Stddev_Pop_Fields = {
  __typename?: 'vehicleStatusType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VehicleStatusType_Stddev_Samp_Fields = {
  __typename?: 'vehicleStatusType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vehicleStatusType" */
export type VehicleStatusType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: VehicleStatusType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type VehicleStatusType_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type VehicleStatusType_Sum_Fields = {
  __typename?: 'vehicleStatusType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "vehicle.vehicle_status_type" */
export enum VehicleStatusType_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type VehicleStatusType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VehicleStatusType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VehicleStatusType_Set_Input>;
  /** filter the rows which have to be updated */
  where: VehicleStatusType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type VehicleStatusType_Var_Pop_Fields = {
  __typename?: 'vehicleStatusType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VehicleStatusType_Var_Samp_Fields = {
  __typename?: 'vehicleStatusType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VehicleStatusType_Variance_Fields = {
  __typename?: 'vehicleStatusType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "vehicle" */
export type Vehicle_Aggregate = {
  __typename?: 'vehicle_aggregate';
  aggregate?: Maybe<Vehicle_Aggregate_Fields>;
  nodes: Array<Vehicle>;
};

/** aggregate fields of "vehicle" */
export type Vehicle_Aggregate_Fields = {
  __typename?: 'vehicle_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Vehicle_Max_Fields>;
  min?: Maybe<Vehicle_Min_Fields>;
};


/** aggregate fields of "vehicle" */
export type Vehicle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "vehicle". All fields are combined with a logical 'AND'. */
export type Vehicle_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cylinders?: InputMaybe<String_Comparison_Exp>;
  drive?: InputMaybe<String_Comparison_Exp>;
  engineSize?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  make?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  transmission?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vin?: InputMaybe<String_Comparison_Exp>;
  year?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle" */
export enum Vehicle_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehiclePkey = 'vehicle_pkey'
}

/** input type for inserting data into table "vehicle" */
export type Vehicle_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cylinders?: InputMaybe<Scalars['String']>;
  drive?: InputMaybe<Scalars['String']>;
  engineSize?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  transmission?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Vehicle_Max_Fields = {
  __typename?: 'vehicle_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['String']>;
  drive?: Maybe<Scalars['String']>;
  engineSize?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  transmission?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Vehicle_Min_Fields = {
  __typename?: 'vehicle_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  cylinders?: Maybe<Scalars['String']>;
  drive?: Maybe<Scalars['String']>;
  engineSize?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  transmission?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vehicle" */
export type Vehicle_Mutation_Response = {
  __typename?: 'vehicle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle>;
};

/** input type for inserting object relation for remote table "vehicle" */
export type Vehicle_Obj_Rel_Insert_Input = {
  data: Vehicle_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_On_Conflict>;
};

/** on_conflict condition type for table "vehicle" */
export type Vehicle_On_Conflict = {
  constraint: Vehicle_Constraint;
  update_columns?: Array<Vehicle_Update_Column>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle". */
export type Vehicle_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  cylinders?: InputMaybe<Order_By>;
  drive?: InputMaybe<Order_By>;
  engineSize?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  transmission?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vin?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle */
export type Vehicle_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "vehicle" */
export enum Vehicle_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Cylinders = 'cylinders',
  /** column name */
  Drive = 'drive',
  /** column name */
  EngineSize = 'engineSize',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  Transmission = 'transmission',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Vin = 'vin',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "vehicle" */
export type Vehicle_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cylinders?: InputMaybe<Scalars['String']>;
  drive?: InputMaybe<Scalars['String']>;
  engineSize?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  transmission?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "vehicle" */
export type Vehicle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cylinders?: InputMaybe<Scalars['String']>;
  drive?: InputMaybe<Scalars['String']>;
  engineSize?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  transmission?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** update columns of table "vehicle" */
export enum Vehicle_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Cylinders = 'cylinders',
  /** column name */
  Drive = 'drive',
  /** column name */
  EngineSize = 'engineSize',
  /** column name */
  Id = 'id',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  Transmission = 'transmission',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Vin = 'vin',
  /** column name */
  Year = 'year'
}

export type Vehicle_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Bool_Exp;
};

/** This table is used to fill in missing decoded vin information. It is used in the https://cc.mbpnetwork.com/vehicles/missing-vin-information page. */
export type VpicDecodeAlternative = {
  __typename?: 'vpicDecodeAlternative';
  VpicElement?: Maybe<Element_Vpic>;
  attributeId?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  elementId: Scalars['Int'];
  id: Scalars['uuid'];
  isIgnored?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['timestamptz'];
  value?: Maybe<Scalars['String']>;
  /** The VIN Descriptor does not contain the sequence number or the check digit. Eg 4T1K61AK*PU */
  vinDescriptor: Scalars['String'];
};

/** aggregated selection of "vehicle.vpic_decode_alternative" */
export type VpicDecodeAlternative_Aggregate = {
  __typename?: 'vpicDecodeAlternative_aggregate';
  aggregate?: Maybe<VpicDecodeAlternative_Aggregate_Fields>;
  nodes: Array<VpicDecodeAlternative>;
};

/** aggregate fields of "vehicle.vpic_decode_alternative" */
export type VpicDecodeAlternative_Aggregate_Fields = {
  __typename?: 'vpicDecodeAlternative_aggregate_fields';
  avg?: Maybe<VpicDecodeAlternative_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<VpicDecodeAlternative_Max_Fields>;
  min?: Maybe<VpicDecodeAlternative_Min_Fields>;
  stddev?: Maybe<VpicDecodeAlternative_Stddev_Fields>;
  stddev_pop?: Maybe<VpicDecodeAlternative_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VpicDecodeAlternative_Stddev_Samp_Fields>;
  sum?: Maybe<VpicDecodeAlternative_Sum_Fields>;
  var_pop?: Maybe<VpicDecodeAlternative_Var_Pop_Fields>;
  var_samp?: Maybe<VpicDecodeAlternative_Var_Samp_Fields>;
  variance?: Maybe<VpicDecodeAlternative_Variance_Fields>;
};


/** aggregate fields of "vehicle.vpic_decode_alternative" */
export type VpicDecodeAlternative_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<VpicDecodeAlternative_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VpicDecodeAlternative_Avg_Fields = {
  __typename?: 'vpicDecodeAlternative_avg_fields';
  elementId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vehicle.vpic_decode_alternative". All fields are combined with a logical 'AND'. */
export type VpicDecodeAlternative_Bool_Exp = {
  _and?: InputMaybe<Array<VpicDecodeAlternative_Bool_Exp>>;
  _not?: InputMaybe<VpicDecodeAlternative_Bool_Exp>;
  _or?: InputMaybe<Array<VpicDecodeAlternative_Bool_Exp>>;
  attributeId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  elementId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isIgnored?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  vinDescriptor?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle.vpic_decode_alternative" */
export enum VpicDecodeAlternative_Constraint {
  /** unique or primary key constraint on columns "id" */
  VpicDecodeAlternativePkey = 'vpic_decode_alternative_pkey',
  /** unique or primary key constraint on columns "vin_descriptor", "element_id" */
  VpicDecodeAlternativeVinDescriptorElementIdKey = 'vpic_decode_alternative_vin_descriptor_element_id_key'
}

/** input type for incrementing numeric columns in table "vehicle.vpic_decode_alternative" */
export type VpicDecodeAlternative_Inc_Input = {
  elementId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle.vpic_decode_alternative" */
export type VpicDecodeAlternative_Insert_Input = {
  attributeId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  elementId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isIgnored?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
  /** The VIN Descriptor does not contain the sequence number or the check digit. Eg 4T1K61AK*PU */
  vinDescriptor?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type VpicDecodeAlternative_Max_Fields = {
  __typename?: 'vpicDecodeAlternative_max_fields';
  attributeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  elementId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
  /** The VIN Descriptor does not contain the sequence number or the check digit. Eg 4T1K61AK*PU */
  vinDescriptor?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type VpicDecodeAlternative_Min_Fields = {
  __typename?: 'vpicDecodeAlternative_min_fields';
  attributeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  elementId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
  /** The VIN Descriptor does not contain the sequence number or the check digit. Eg 4T1K61AK*PU */
  vinDescriptor?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vehicle.vpic_decode_alternative" */
export type VpicDecodeAlternative_Mutation_Response = {
  __typename?: 'vpicDecodeAlternative_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VpicDecodeAlternative>;
};

/** on_conflict condition type for table "vehicle.vpic_decode_alternative" */
export type VpicDecodeAlternative_On_Conflict = {
  constraint: VpicDecodeAlternative_Constraint;
  update_columns?: Array<VpicDecodeAlternative_Update_Column>;
  where?: InputMaybe<VpicDecodeAlternative_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle.vpic_decode_alternative". */
export type VpicDecodeAlternative_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  elementId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isIgnored?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vinDescriptor?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle.vpic_decode_alternative */
export type VpicDecodeAlternative_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "vehicle.vpic_decode_alternative" */
export enum VpicDecodeAlternative_Select_Column {
  /** column name */
  AttributeId = 'attributeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ElementId = 'elementId',
  /** column name */
  Id = 'id',
  /** column name */
  IsIgnored = 'isIgnored',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value',
  /** column name */
  VinDescriptor = 'vinDescriptor'
}

/** input type for updating data in table "vehicle.vpic_decode_alternative" */
export type VpicDecodeAlternative_Set_Input = {
  attributeId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  elementId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isIgnored?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
  /** The VIN Descriptor does not contain the sequence number or the check digit. Eg 4T1K61AK*PU */
  vinDescriptor?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type VpicDecodeAlternative_Stddev_Fields = {
  __typename?: 'vpicDecodeAlternative_stddev_fields';
  elementId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VpicDecodeAlternative_Stddev_Pop_Fields = {
  __typename?: 'vpicDecodeAlternative_stddev_pop_fields';
  elementId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VpicDecodeAlternative_Stddev_Samp_Fields = {
  __typename?: 'vpicDecodeAlternative_stddev_samp_fields';
  elementId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vpicDecodeAlternative" */
export type VpicDecodeAlternative_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: VpicDecodeAlternative_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type VpicDecodeAlternative_Stream_Cursor_Value_Input = {
  attributeId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  elementId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isIgnored?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
  /** The VIN Descriptor does not contain the sequence number or the check digit. Eg 4T1K61AK*PU */
  vinDescriptor?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type VpicDecodeAlternative_Sum_Fields = {
  __typename?: 'vpicDecodeAlternative_sum_fields';
  elementId?: Maybe<Scalars['Int']>;
};

/** update columns of table "vehicle.vpic_decode_alternative" */
export enum VpicDecodeAlternative_Update_Column {
  /** column name */
  AttributeId = 'attributeId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ElementId = 'elementId',
  /** column name */
  Id = 'id',
  /** column name */
  IsIgnored = 'isIgnored',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value',
  /** column name */
  VinDescriptor = 'vinDescriptor'
}

export type VpicDecodeAlternative_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VpicDecodeAlternative_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VpicDecodeAlternative_Set_Input>;
  /** filter the rows which have to be updated */
  where: VpicDecodeAlternative_Bool_Exp;
};

/** aggregate var_pop on columns */
export type VpicDecodeAlternative_Var_Pop_Fields = {
  __typename?: 'vpicDecodeAlternative_var_pop_fields';
  elementId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VpicDecodeAlternative_Var_Samp_Fields = {
  __typename?: 'vpicDecodeAlternative_var_samp_fields';
  elementId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VpicDecodeAlternative_Variance_Fields = {
  __typename?: 'vpicDecodeAlternative_variance_fields';
  elementId?: Maybe<Scalars['Float']>;
};

export type Vpic_Criteria_Make = {
  __typename?: 'vpic_criteria_make';
  makeId: Scalars['String'];
  makeName: Scalars['String'];
};

/** Boolean expression to filter rows from the logical model for "vpic_criteria_make". All fields are combined with a logical 'AND'. */
export type Vpic_Criteria_Make_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Vpic_Criteria_Make_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Vpic_Criteria_Make_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Vpic_Criteria_Make_Bool_Exp_Bool_Exp>>;
  makeId?: InputMaybe<String_Comparison_Exp>;
  makeName?: InputMaybe<String_Comparison_Exp>;
};

export enum Vpic_Criteria_Make_Enum_Name {
  /** column name */
  MakeId = 'makeId',
  /** column name */
  MakeName = 'makeName'
}

/** Ordering options when selecting data from "vpic_criteria_make". */
export type Vpic_Criteria_Make_Order_By = {
  makeId?: InputMaybe<Order_By>;
  makeName?: InputMaybe<Order_By>;
};

/** columns and relationships of "vwVehicleCylindersDistinct" */
export type VwVehicleCylindersDistinct = {
  __typename?: 'vwVehicleCylindersDistinct';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  MakeCode: Scalars['String'];
  ModelName: Scalars['String'];
  VehicleYear: Scalars['Int'];
};

/** aggregated selection of "vwVehicleCylindersDistinct" */
export type VwVehicleCylindersDistinct_Aggregate = {
  __typename?: 'vwVehicleCylindersDistinct_aggregate';
  aggregate?: Maybe<VwVehicleCylindersDistinct_Aggregate_Fields>;
  nodes: Array<VwVehicleCylindersDistinct>;
};

/** aggregate fields of "vwVehicleCylindersDistinct" */
export type VwVehicleCylindersDistinct_Aggregate_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_aggregate_fields';
  avg?: Maybe<VwVehicleCylindersDistinct_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<VwVehicleCylindersDistinct_Max_Fields>;
  min?: Maybe<VwVehicleCylindersDistinct_Min_Fields>;
  stddev?: Maybe<VwVehicleCylindersDistinct_Stddev_Fields>;
  stddev_pop?: Maybe<VwVehicleCylindersDistinct_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VwVehicleCylindersDistinct_Stddev_Samp_Fields>;
  sum?: Maybe<VwVehicleCylindersDistinct_Sum_Fields>;
  var_pop?: Maybe<VwVehicleCylindersDistinct_Var_Pop_Fields>;
  var_samp?: Maybe<VwVehicleCylindersDistinct_Var_Samp_Fields>;
  variance?: Maybe<VwVehicleCylindersDistinct_Variance_Fields>;
};


/** aggregate fields of "vwVehicleCylindersDistinct" */
export type VwVehicleCylindersDistinct_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<VwVehicleCylindersDistinct_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VwVehicleCylindersDistinct_Avg_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_avg_fields';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vwVehicleCylindersDistinct". All fields are combined with a logical 'AND'. */
export type VwVehicleCylindersDistinct_Bool_Exp = {
  CylinderNumber?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Cylinders?: InputMaybe<Float_Mssql_Comparison_Exp>;
  MakeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ModelName?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<VwVehicleCylindersDistinct_Bool_Exp>>;
  _not?: InputMaybe<VwVehicleCylindersDistinct_Bool_Exp>;
  _or?: InputMaybe<Array<VwVehicleCylindersDistinct_Bool_Exp>>;
};

/** upsert condition type for table "vwVehicleCylindersDistinct" */
export type VwVehicleCylindersDistinct_If_Matched = {
  match_columns?: Array<VwVehicleCylindersDistinct_Insert_Match_Column>;
  update_columns?: Array<VwVehicleCylindersDistinct_Update_Column>;
  where?: InputMaybe<VwVehicleCylindersDistinct_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "vwVehicleCylindersDistinct" */
export type VwVehicleCylindersDistinct_Inc_Input = {
  CylinderNumber?: InputMaybe<Scalars['Float']>;
  Cylinders?: InputMaybe<Scalars['Float']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vwVehicleCylindersDistinct" */
export type VwVehicleCylindersDistinct_Insert_Input = {
  CylinderNumber?: InputMaybe<Scalars['Float']>;
  Cylinders?: InputMaybe<Scalars['Float']>;
  MakeCode?: InputMaybe<Scalars['String']>;
  ModelName?: InputMaybe<Scalars['String']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** select match_columns of table "vwVehicleCylindersDistinct" */
export enum VwVehicleCylindersDistinct_Insert_Match_Column {
  /** column name */
  CylinderNumber = 'CylinderNumber',
  /** column name */
  Cylinders = 'Cylinders',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate max on columns */
export type VwVehicleCylindersDistinct_Max_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_max_fields';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  MakeCode?: Maybe<Scalars['String']>;
  ModelName?: Maybe<Scalars['String']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type VwVehicleCylindersDistinct_Min_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_min_fields';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  MakeCode?: Maybe<Scalars['String']>;
  ModelName?: Maybe<Scalars['String']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vwVehicleCylindersDistinct" */
export type VwVehicleCylindersDistinct_Mutation_Response = {
  __typename?: 'vwVehicleCylindersDistinct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VwVehicleCylindersDistinct>;
};

/** Ordering options when selecting data from "vwVehicleCylindersDistinct". */
export type VwVehicleCylindersDistinct_Order_By = {
  CylinderNumber?: InputMaybe<Order_By>;
  Cylinders?: InputMaybe<Order_By>;
  MakeCode?: InputMaybe<Order_By>;
  ModelName?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** select columns of table "vwVehicleCylindersDistinct" */
export enum VwVehicleCylindersDistinct_Select_Column {
  /** column name */
  CylinderNumber = 'CylinderNumber',
  /** column name */
  Cylinders = 'Cylinders',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** input type for updating data in table "vwVehicleCylindersDistinct" */
export type VwVehicleCylindersDistinct_Set_Input = {
  CylinderNumber?: InputMaybe<Scalars['Float']>;
  Cylinders?: InputMaybe<Scalars['Float']>;
  MakeCode?: InputMaybe<Scalars['String']>;
  ModelName?: InputMaybe<Scalars['String']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VwVehicleCylindersDistinct_Stddev_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_stddev_fields';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VwVehicleCylindersDistinct_Stddev_Pop_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_stddev_pop_fields';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VwVehicleCylindersDistinct_Stddev_Samp_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_stddev_samp_fields';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VwVehicleCylindersDistinct_Sum_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_sum_fields';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** update columns of table "vwVehicleCylindersDistinct" */
export enum VwVehicleCylindersDistinct_Update_Column {
  /** column name */
  CylinderNumber = 'CylinderNumber',
  /** column name */
  Cylinders = 'Cylinders',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate var_pop on columns */
export type VwVehicleCylindersDistinct_Var_Pop_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_var_pop_fields';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VwVehicleCylindersDistinct_Var_Samp_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_var_samp_fields';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VwVehicleCylindersDistinct_Variance_Fields = {
  __typename?: 'vwVehicleCylindersDistinct_variance_fields';
  CylinderNumber?: Maybe<Scalars['Float']>;
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vwVehicleDrivingWheelsDistinct" */
export type VwVehicleDrivingWheelsDistinct = {
  __typename?: 'vwVehicleDrivingWheelsDistinct';
  Cylinders: Scalars['Int'];
  DrivingWheelsCode: Scalars['String'];
  DrivingWheelsDescription: Scalars['String'];
  MakeCode: Scalars['String'];
  ModelName: Scalars['String'];
  NumberWheelsDriving: Scalars['Int'];
  VehicleYear: Scalars['Int'];
};

/** aggregated selection of "vwVehicleDrivingWheelsDistinct" */
export type VwVehicleDrivingWheelsDistinct_Aggregate = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_aggregate';
  aggregate?: Maybe<VwVehicleDrivingWheelsDistinct_Aggregate_Fields>;
  nodes: Array<VwVehicleDrivingWheelsDistinct>;
};

/** aggregate fields of "vwVehicleDrivingWheelsDistinct" */
export type VwVehicleDrivingWheelsDistinct_Aggregate_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_aggregate_fields';
  avg?: Maybe<VwVehicleDrivingWheelsDistinct_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<VwVehicleDrivingWheelsDistinct_Max_Fields>;
  min?: Maybe<VwVehicleDrivingWheelsDistinct_Min_Fields>;
  stddev?: Maybe<VwVehicleDrivingWheelsDistinct_Stddev_Fields>;
  stddev_pop?: Maybe<VwVehicleDrivingWheelsDistinct_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VwVehicleDrivingWheelsDistinct_Stddev_Samp_Fields>;
  sum?: Maybe<VwVehicleDrivingWheelsDistinct_Sum_Fields>;
  var_pop?: Maybe<VwVehicleDrivingWheelsDistinct_Var_Pop_Fields>;
  var_samp?: Maybe<VwVehicleDrivingWheelsDistinct_Var_Samp_Fields>;
  variance?: Maybe<VwVehicleDrivingWheelsDistinct_Variance_Fields>;
};


/** aggregate fields of "vwVehicleDrivingWheelsDistinct" */
export type VwVehicleDrivingWheelsDistinct_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<VwVehicleDrivingWheelsDistinct_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VwVehicleDrivingWheelsDistinct_Avg_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_avg_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  NumberWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vwVehicleDrivingWheelsDistinct". All fields are combined with a logical 'AND'. */
export type VwVehicleDrivingWheelsDistinct_Bool_Exp = {
  Cylinders?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DrivingWheelsCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  DrivingWheelsDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MakeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ModelName?: InputMaybe<String_Mssql_Comparison_Exp>;
  NumberWheelsDriving?: InputMaybe<Int_Mssql_Comparison_Exp>;
  VehicleYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<VwVehicleDrivingWheelsDistinct_Bool_Exp>>;
  _not?: InputMaybe<VwVehicleDrivingWheelsDistinct_Bool_Exp>;
  _or?: InputMaybe<Array<VwVehicleDrivingWheelsDistinct_Bool_Exp>>;
};

/** upsert condition type for table "vwVehicleDrivingWheelsDistinct" */
export type VwVehicleDrivingWheelsDistinct_If_Matched = {
  match_columns?: Array<VwVehicleDrivingWheelsDistinct_Insert_Match_Column>;
  update_columns?: Array<VwVehicleDrivingWheelsDistinct_Update_Column>;
  where?: InputMaybe<VwVehicleDrivingWheelsDistinct_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "vwVehicleDrivingWheelsDistinct" */
export type VwVehicleDrivingWheelsDistinct_Inc_Input = {
  Cylinders?: InputMaybe<Scalars['Int']>;
  NumberWheelsDriving?: InputMaybe<Scalars['Int']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vwVehicleDrivingWheelsDistinct" */
export type VwVehicleDrivingWheelsDistinct_Insert_Input = {
  Cylinders?: InputMaybe<Scalars['Int']>;
  DrivingWheelsCode?: InputMaybe<Scalars['String']>;
  DrivingWheelsDescription?: InputMaybe<Scalars['String']>;
  MakeCode?: InputMaybe<Scalars['String']>;
  ModelName?: InputMaybe<Scalars['String']>;
  NumberWheelsDriving?: InputMaybe<Scalars['Int']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** select match_columns of table "vwVehicleDrivingWheelsDistinct" */
export enum VwVehicleDrivingWheelsDistinct_Insert_Match_Column {
  /** column name */
  Cylinders = 'Cylinders',
  /** column name */
  DrivingWheelsCode = 'DrivingWheelsCode',
  /** column name */
  DrivingWheelsDescription = 'DrivingWheelsDescription',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  NumberWheelsDriving = 'NumberWheelsDriving',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate max on columns */
export type VwVehicleDrivingWheelsDistinct_Max_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_max_fields';
  Cylinders?: Maybe<Scalars['Int']>;
  DrivingWheelsCode?: Maybe<Scalars['String']>;
  DrivingWheelsDescription?: Maybe<Scalars['String']>;
  MakeCode?: Maybe<Scalars['String']>;
  ModelName?: Maybe<Scalars['String']>;
  NumberWheelsDriving?: Maybe<Scalars['Int']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type VwVehicleDrivingWheelsDistinct_Min_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_min_fields';
  Cylinders?: Maybe<Scalars['Int']>;
  DrivingWheelsCode?: Maybe<Scalars['String']>;
  DrivingWheelsDescription?: Maybe<Scalars['String']>;
  MakeCode?: Maybe<Scalars['String']>;
  ModelName?: Maybe<Scalars['String']>;
  NumberWheelsDriving?: Maybe<Scalars['Int']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vwVehicleDrivingWheelsDistinct" */
export type VwVehicleDrivingWheelsDistinct_Mutation_Response = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VwVehicleDrivingWheelsDistinct>;
};

/** Ordering options when selecting data from "vwVehicleDrivingWheelsDistinct". */
export type VwVehicleDrivingWheelsDistinct_Order_By = {
  Cylinders?: InputMaybe<Order_By>;
  DrivingWheelsCode?: InputMaybe<Order_By>;
  DrivingWheelsDescription?: InputMaybe<Order_By>;
  MakeCode?: InputMaybe<Order_By>;
  ModelName?: InputMaybe<Order_By>;
  NumberWheelsDriving?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** select columns of table "vwVehicleDrivingWheelsDistinct" */
export enum VwVehicleDrivingWheelsDistinct_Select_Column {
  /** column name */
  Cylinders = 'Cylinders',
  /** column name */
  DrivingWheelsCode = 'DrivingWheelsCode',
  /** column name */
  DrivingWheelsDescription = 'DrivingWheelsDescription',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  NumberWheelsDriving = 'NumberWheelsDriving',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** input type for updating data in table "vwVehicleDrivingWheelsDistinct" */
export type VwVehicleDrivingWheelsDistinct_Set_Input = {
  Cylinders?: InputMaybe<Scalars['Int']>;
  DrivingWheelsCode?: InputMaybe<Scalars['String']>;
  DrivingWheelsDescription?: InputMaybe<Scalars['String']>;
  MakeCode?: InputMaybe<Scalars['String']>;
  ModelName?: InputMaybe<Scalars['String']>;
  NumberWheelsDriving?: InputMaybe<Scalars['Int']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VwVehicleDrivingWheelsDistinct_Stddev_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_stddev_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  NumberWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VwVehicleDrivingWheelsDistinct_Stddev_Pop_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_stddev_pop_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  NumberWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VwVehicleDrivingWheelsDistinct_Stddev_Samp_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_stddev_samp_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  NumberWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VwVehicleDrivingWheelsDistinct_Sum_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_sum_fields';
  Cylinders?: Maybe<Scalars['Int']>;
  NumberWheelsDriving?: Maybe<Scalars['Int']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** update columns of table "vwVehicleDrivingWheelsDistinct" */
export enum VwVehicleDrivingWheelsDistinct_Update_Column {
  /** column name */
  Cylinders = 'Cylinders',
  /** column name */
  DrivingWheelsCode = 'DrivingWheelsCode',
  /** column name */
  DrivingWheelsDescription = 'DrivingWheelsDescription',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  NumberWheelsDriving = 'NumberWheelsDriving',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate var_pop on columns */
export type VwVehicleDrivingWheelsDistinct_Var_Pop_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_var_pop_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  NumberWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VwVehicleDrivingWheelsDistinct_Var_Samp_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_var_samp_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  NumberWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VwVehicleDrivingWheelsDistinct_Variance_Fields = {
  __typename?: 'vwVehicleDrivingWheelsDistinct_variance_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  NumberWheelsDriving?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vwVehicleFuelTypesDistinct" */
export type VwVehicleFuelTypesDistinct = {
  __typename?: 'vwVehicleFuelTypesDistinct';
  Cylinders: Scalars['Int'];
  DrivingWheelsCode: Scalars['String'];
  FuelTypeCode: Scalars['String'];
  FuelTypeDescription: Scalars['String'];
  HasTurbo: Scalars['Boolean'];
  MakeCode: Scalars['String'];
  ModelName: Scalars['String'];
  VehicleYear: Scalars['Int'];
};

/** aggregated selection of "vwVehicleFuelTypesDistinct" */
export type VwVehicleFuelTypesDistinct_Aggregate = {
  __typename?: 'vwVehicleFuelTypesDistinct_aggregate';
  aggregate?: Maybe<VwVehicleFuelTypesDistinct_Aggregate_Fields>;
  nodes: Array<VwVehicleFuelTypesDistinct>;
};

/** aggregate fields of "vwVehicleFuelTypesDistinct" */
export type VwVehicleFuelTypesDistinct_Aggregate_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_aggregate_fields';
  avg?: Maybe<VwVehicleFuelTypesDistinct_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<VwVehicleFuelTypesDistinct_Max_Fields>;
  min?: Maybe<VwVehicleFuelTypesDistinct_Min_Fields>;
  stddev?: Maybe<VwVehicleFuelTypesDistinct_Stddev_Fields>;
  stddev_pop?: Maybe<VwVehicleFuelTypesDistinct_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VwVehicleFuelTypesDistinct_Stddev_Samp_Fields>;
  sum?: Maybe<VwVehicleFuelTypesDistinct_Sum_Fields>;
  var_pop?: Maybe<VwVehicleFuelTypesDistinct_Var_Pop_Fields>;
  var_samp?: Maybe<VwVehicleFuelTypesDistinct_Var_Samp_Fields>;
  variance?: Maybe<VwVehicleFuelTypesDistinct_Variance_Fields>;
};


/** aggregate fields of "vwVehicleFuelTypesDistinct" */
export type VwVehicleFuelTypesDistinct_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<VwVehicleFuelTypesDistinct_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VwVehicleFuelTypesDistinct_Avg_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_avg_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vwVehicleFuelTypesDistinct". All fields are combined with a logical 'AND'. */
export type VwVehicleFuelTypesDistinct_Bool_Exp = {
  Cylinders?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DrivingWheelsCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  FuelTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  FuelTypeDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  HasTurbo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  MakeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ModelName?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<VwVehicleFuelTypesDistinct_Bool_Exp>>;
  _not?: InputMaybe<VwVehicleFuelTypesDistinct_Bool_Exp>;
  _or?: InputMaybe<Array<VwVehicleFuelTypesDistinct_Bool_Exp>>;
};

/** upsert condition type for table "vwVehicleFuelTypesDistinct" */
export type VwVehicleFuelTypesDistinct_If_Matched = {
  match_columns?: Array<VwVehicleFuelTypesDistinct_Insert_Match_Column>;
  update_columns?: Array<VwVehicleFuelTypesDistinct_Update_Column>;
  where?: InputMaybe<VwVehicleFuelTypesDistinct_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "vwVehicleFuelTypesDistinct" */
export type VwVehicleFuelTypesDistinct_Inc_Input = {
  Cylinders?: InputMaybe<Scalars['Int']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vwVehicleFuelTypesDistinct" */
export type VwVehicleFuelTypesDistinct_Insert_Input = {
  Cylinders?: InputMaybe<Scalars['Int']>;
  DrivingWheelsCode?: InputMaybe<Scalars['String']>;
  FuelTypeCode?: InputMaybe<Scalars['String']>;
  FuelTypeDescription?: InputMaybe<Scalars['String']>;
  HasTurbo?: InputMaybe<Scalars['Boolean']>;
  MakeCode?: InputMaybe<Scalars['String']>;
  ModelName?: InputMaybe<Scalars['String']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** select match_columns of table "vwVehicleFuelTypesDistinct" */
export enum VwVehicleFuelTypesDistinct_Insert_Match_Column {
  /** column name */
  Cylinders = 'Cylinders',
  /** column name */
  DrivingWheelsCode = 'DrivingWheelsCode',
  /** column name */
  FuelTypeCode = 'FuelTypeCode',
  /** column name */
  FuelTypeDescription = 'FuelTypeDescription',
  /** column name */
  HasTurbo = 'HasTurbo',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate max on columns */
export type VwVehicleFuelTypesDistinct_Max_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_max_fields';
  Cylinders?: Maybe<Scalars['Int']>;
  DrivingWheelsCode?: Maybe<Scalars['String']>;
  FuelTypeCode?: Maybe<Scalars['String']>;
  FuelTypeDescription?: Maybe<Scalars['String']>;
  MakeCode?: Maybe<Scalars['String']>;
  ModelName?: Maybe<Scalars['String']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type VwVehicleFuelTypesDistinct_Min_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_min_fields';
  Cylinders?: Maybe<Scalars['Int']>;
  DrivingWheelsCode?: Maybe<Scalars['String']>;
  FuelTypeCode?: Maybe<Scalars['String']>;
  FuelTypeDescription?: Maybe<Scalars['String']>;
  MakeCode?: Maybe<Scalars['String']>;
  ModelName?: Maybe<Scalars['String']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vwVehicleFuelTypesDistinct" */
export type VwVehicleFuelTypesDistinct_Mutation_Response = {
  __typename?: 'vwVehicleFuelTypesDistinct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VwVehicleFuelTypesDistinct>;
};

/** Ordering options when selecting data from "vwVehicleFuelTypesDistinct". */
export type VwVehicleFuelTypesDistinct_Order_By = {
  Cylinders?: InputMaybe<Order_By>;
  DrivingWheelsCode?: InputMaybe<Order_By>;
  FuelTypeCode?: InputMaybe<Order_By>;
  FuelTypeDescription?: InputMaybe<Order_By>;
  HasTurbo?: InputMaybe<Order_By>;
  MakeCode?: InputMaybe<Order_By>;
  ModelName?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** select columns of table "vwVehicleFuelTypesDistinct" */
export enum VwVehicleFuelTypesDistinct_Select_Column {
  /** column name */
  Cylinders = 'Cylinders',
  /** column name */
  DrivingWheelsCode = 'DrivingWheelsCode',
  /** column name */
  FuelTypeCode = 'FuelTypeCode',
  /** column name */
  FuelTypeDescription = 'FuelTypeDescription',
  /** column name */
  HasTurbo = 'HasTurbo',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** input type for updating data in table "vwVehicleFuelTypesDistinct" */
export type VwVehicleFuelTypesDistinct_Set_Input = {
  Cylinders?: InputMaybe<Scalars['Int']>;
  DrivingWheelsCode?: InputMaybe<Scalars['String']>;
  FuelTypeCode?: InputMaybe<Scalars['String']>;
  FuelTypeDescription?: InputMaybe<Scalars['String']>;
  HasTurbo?: InputMaybe<Scalars['Boolean']>;
  MakeCode?: InputMaybe<Scalars['String']>;
  ModelName?: InputMaybe<Scalars['String']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VwVehicleFuelTypesDistinct_Stddev_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_stddev_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VwVehicleFuelTypesDistinct_Stddev_Pop_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_stddev_pop_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VwVehicleFuelTypesDistinct_Stddev_Samp_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_stddev_samp_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VwVehicleFuelTypesDistinct_Sum_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_sum_fields';
  Cylinders?: Maybe<Scalars['Int']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** update columns of table "vwVehicleFuelTypesDistinct" */
export enum VwVehicleFuelTypesDistinct_Update_Column {
  /** column name */
  Cylinders = 'Cylinders',
  /** column name */
  DrivingWheelsCode = 'DrivingWheelsCode',
  /** column name */
  FuelTypeCode = 'FuelTypeCode',
  /** column name */
  FuelTypeDescription = 'FuelTypeDescription',
  /** column name */
  HasTurbo = 'HasTurbo',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate var_pop on columns */
export type VwVehicleFuelTypesDistinct_Var_Pop_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_var_pop_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VwVehicleFuelTypesDistinct_Var_Samp_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_var_samp_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VwVehicleFuelTypesDistinct_Variance_Fields = {
  __typename?: 'vwVehicleFuelTypesDistinct_variance_fields';
  Cylinders?: Maybe<Scalars['Float']>;
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vwVehicleMakesDistinct" */
export type VwVehicleMakesDistinct = {
  __typename?: 'vwVehicleMakesDistinct';
  IsPowersport?: Maybe<Scalars['Boolean']>;
  IsRV?: Maybe<Scalars['Boolean']>;
  MakeCode: Scalars['String'];
  MakeName: Scalars['String'];
  VehicleYear: Scalars['Int'];
};

/** aggregated selection of "vwVehicleMakesDistinct" */
export type VwVehicleMakesDistinct_Aggregate = {
  __typename?: 'vwVehicleMakesDistinct_aggregate';
  aggregate?: Maybe<VwVehicleMakesDistinct_Aggregate_Fields>;
  nodes: Array<VwVehicleMakesDistinct>;
};

/** aggregate fields of "vwVehicleMakesDistinct" */
export type VwVehicleMakesDistinct_Aggregate_Fields = {
  __typename?: 'vwVehicleMakesDistinct_aggregate_fields';
  avg?: Maybe<VwVehicleMakesDistinct_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<VwVehicleMakesDistinct_Max_Fields>;
  min?: Maybe<VwVehicleMakesDistinct_Min_Fields>;
  stddev?: Maybe<VwVehicleMakesDistinct_Stddev_Fields>;
  stddev_pop?: Maybe<VwVehicleMakesDistinct_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VwVehicleMakesDistinct_Stddev_Samp_Fields>;
  sum?: Maybe<VwVehicleMakesDistinct_Sum_Fields>;
  var_pop?: Maybe<VwVehicleMakesDistinct_Var_Pop_Fields>;
  var_samp?: Maybe<VwVehicleMakesDistinct_Var_Samp_Fields>;
  variance?: Maybe<VwVehicleMakesDistinct_Variance_Fields>;
};


/** aggregate fields of "vwVehicleMakesDistinct" */
export type VwVehicleMakesDistinct_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<VwVehicleMakesDistinct_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VwVehicleMakesDistinct_Avg_Fields = {
  __typename?: 'vwVehicleMakesDistinct_avg_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vwVehicleMakesDistinct". All fields are combined with a logical 'AND'. */
export type VwVehicleMakesDistinct_Bool_Exp = {
  IsPowersport?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  IsRV?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  MakeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MakeName?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<VwVehicleMakesDistinct_Bool_Exp>>;
  _not?: InputMaybe<VwVehicleMakesDistinct_Bool_Exp>;
  _or?: InputMaybe<Array<VwVehicleMakesDistinct_Bool_Exp>>;
};

/** upsert condition type for table "vwVehicleMakesDistinct" */
export type VwVehicleMakesDistinct_If_Matched = {
  match_columns?: Array<VwVehicleMakesDistinct_Insert_Match_Column>;
  update_columns?: Array<VwVehicleMakesDistinct_Update_Column>;
  where?: InputMaybe<VwVehicleMakesDistinct_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "vwVehicleMakesDistinct" */
export type VwVehicleMakesDistinct_Inc_Input = {
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vwVehicleMakesDistinct" */
export type VwVehicleMakesDistinct_Insert_Input = {
  IsPowersport?: InputMaybe<Scalars['Boolean']>;
  IsRV?: InputMaybe<Scalars['Boolean']>;
  MakeCode?: InputMaybe<Scalars['String']>;
  MakeName?: InputMaybe<Scalars['String']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** select match_columns of table "vwVehicleMakesDistinct" */
export enum VwVehicleMakesDistinct_Insert_Match_Column {
  /** column name */
  IsPowersport = 'IsPowersport',
  /** column name */
  IsRv = 'IsRV',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  MakeName = 'MakeName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate max on columns */
export type VwVehicleMakesDistinct_Max_Fields = {
  __typename?: 'vwVehicleMakesDistinct_max_fields';
  MakeCode?: Maybe<Scalars['String']>;
  MakeName?: Maybe<Scalars['String']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type VwVehicleMakesDistinct_Min_Fields = {
  __typename?: 'vwVehicleMakesDistinct_min_fields';
  MakeCode?: Maybe<Scalars['String']>;
  MakeName?: Maybe<Scalars['String']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vwVehicleMakesDistinct" */
export type VwVehicleMakesDistinct_Mutation_Response = {
  __typename?: 'vwVehicleMakesDistinct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VwVehicleMakesDistinct>;
};

/** Ordering options when selecting data from "vwVehicleMakesDistinct". */
export type VwVehicleMakesDistinct_Order_By = {
  IsPowersport?: InputMaybe<Order_By>;
  IsRV?: InputMaybe<Order_By>;
  MakeCode?: InputMaybe<Order_By>;
  MakeName?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** select columns of table "vwVehicleMakesDistinct" */
export enum VwVehicleMakesDistinct_Select_Column {
  /** column name */
  IsPowersport = 'IsPowersport',
  /** column name */
  IsRv = 'IsRV',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  MakeName = 'MakeName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** input type for updating data in table "vwVehicleMakesDistinct" */
export type VwVehicleMakesDistinct_Set_Input = {
  IsPowersport?: InputMaybe<Scalars['Boolean']>;
  IsRV?: InputMaybe<Scalars['Boolean']>;
  MakeCode?: InputMaybe<Scalars['String']>;
  MakeName?: InputMaybe<Scalars['String']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VwVehicleMakesDistinct_Stddev_Fields = {
  __typename?: 'vwVehicleMakesDistinct_stddev_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VwVehicleMakesDistinct_Stddev_Pop_Fields = {
  __typename?: 'vwVehicleMakesDistinct_stddev_pop_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VwVehicleMakesDistinct_Stddev_Samp_Fields = {
  __typename?: 'vwVehicleMakesDistinct_stddev_samp_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VwVehicleMakesDistinct_Sum_Fields = {
  __typename?: 'vwVehicleMakesDistinct_sum_fields';
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** update columns of table "vwVehicleMakesDistinct" */
export enum VwVehicleMakesDistinct_Update_Column {
  /** column name */
  IsPowersport = 'IsPowersport',
  /** column name */
  IsRv = 'IsRV',
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  MakeName = 'MakeName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate var_pop on columns */
export type VwVehicleMakesDistinct_Var_Pop_Fields = {
  __typename?: 'vwVehicleMakesDistinct_var_pop_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VwVehicleMakesDistinct_Var_Samp_Fields = {
  __typename?: 'vwVehicleMakesDistinct_var_samp_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VwVehicleMakesDistinct_Variance_Fields = {
  __typename?: 'vwVehicleMakesDistinct_variance_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vwVehicleModelsDistinct" */
export type VwVehicleModelsDistinct = {
  __typename?: 'vwVehicleModelsDistinct';
  MakeCode: Scalars['String'];
  ModelCode: Scalars['String'];
  ModelName: Scalars['String'];
  VehicleYear: Scalars['Int'];
};

/** aggregated selection of "vwVehicleModelsDistinct" */
export type VwVehicleModelsDistinct_Aggregate = {
  __typename?: 'vwVehicleModelsDistinct_aggregate';
  aggregate?: Maybe<VwVehicleModelsDistinct_Aggregate_Fields>;
  nodes: Array<VwVehicleModelsDistinct>;
};

/** aggregate fields of "vwVehicleModelsDistinct" */
export type VwVehicleModelsDistinct_Aggregate_Fields = {
  __typename?: 'vwVehicleModelsDistinct_aggregate_fields';
  avg?: Maybe<VwVehicleModelsDistinct_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<VwVehicleModelsDistinct_Max_Fields>;
  min?: Maybe<VwVehicleModelsDistinct_Min_Fields>;
  stddev?: Maybe<VwVehicleModelsDistinct_Stddev_Fields>;
  stddev_pop?: Maybe<VwVehicleModelsDistinct_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VwVehicleModelsDistinct_Stddev_Samp_Fields>;
  sum?: Maybe<VwVehicleModelsDistinct_Sum_Fields>;
  var_pop?: Maybe<VwVehicleModelsDistinct_Var_Pop_Fields>;
  var_samp?: Maybe<VwVehicleModelsDistinct_Var_Samp_Fields>;
  variance?: Maybe<VwVehicleModelsDistinct_Variance_Fields>;
};


/** aggregate fields of "vwVehicleModelsDistinct" */
export type VwVehicleModelsDistinct_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<VwVehicleModelsDistinct_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VwVehicleModelsDistinct_Avg_Fields = {
  __typename?: 'vwVehicleModelsDistinct_avg_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vwVehicleModelsDistinct". All fields are combined with a logical 'AND'. */
export type VwVehicleModelsDistinct_Bool_Exp = {
  MakeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ModelCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ModelName?: InputMaybe<String_Mssql_Comparison_Exp>;
  VehicleYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<VwVehicleModelsDistinct_Bool_Exp>>;
  _not?: InputMaybe<VwVehicleModelsDistinct_Bool_Exp>;
  _or?: InputMaybe<Array<VwVehicleModelsDistinct_Bool_Exp>>;
};

/** upsert condition type for table "vwVehicleModelsDistinct" */
export type VwVehicleModelsDistinct_If_Matched = {
  match_columns?: Array<VwVehicleModelsDistinct_Insert_Match_Column>;
  update_columns?: Array<VwVehicleModelsDistinct_Update_Column>;
  where?: InputMaybe<VwVehicleModelsDistinct_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "vwVehicleModelsDistinct" */
export type VwVehicleModelsDistinct_Inc_Input = {
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vwVehicleModelsDistinct" */
export type VwVehicleModelsDistinct_Insert_Input = {
  MakeCode?: InputMaybe<Scalars['String']>;
  ModelCode?: InputMaybe<Scalars['String']>;
  ModelName?: InputMaybe<Scalars['String']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** select match_columns of table "vwVehicleModelsDistinct" */
export enum VwVehicleModelsDistinct_Insert_Match_Column {
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelCode = 'ModelCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate max on columns */
export type VwVehicleModelsDistinct_Max_Fields = {
  __typename?: 'vwVehicleModelsDistinct_max_fields';
  MakeCode?: Maybe<Scalars['String']>;
  ModelCode?: Maybe<Scalars['String']>;
  ModelName?: Maybe<Scalars['String']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type VwVehicleModelsDistinct_Min_Fields = {
  __typename?: 'vwVehicleModelsDistinct_min_fields';
  MakeCode?: Maybe<Scalars['String']>;
  ModelCode?: Maybe<Scalars['String']>;
  ModelName?: Maybe<Scalars['String']>;
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vwVehicleModelsDistinct" */
export type VwVehicleModelsDistinct_Mutation_Response = {
  __typename?: 'vwVehicleModelsDistinct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VwVehicleModelsDistinct>;
};

/** Ordering options when selecting data from "vwVehicleModelsDistinct". */
export type VwVehicleModelsDistinct_Order_By = {
  MakeCode?: InputMaybe<Order_By>;
  ModelCode?: InputMaybe<Order_By>;
  ModelName?: InputMaybe<Order_By>;
  VehicleYear?: InputMaybe<Order_By>;
};

/** select columns of table "vwVehicleModelsDistinct" */
export enum VwVehicleModelsDistinct_Select_Column {
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelCode = 'ModelCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** input type for updating data in table "vwVehicleModelsDistinct" */
export type VwVehicleModelsDistinct_Set_Input = {
  MakeCode?: InputMaybe<Scalars['String']>;
  ModelCode?: InputMaybe<Scalars['String']>;
  ModelName?: InputMaybe<Scalars['String']>;
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VwVehicleModelsDistinct_Stddev_Fields = {
  __typename?: 'vwVehicleModelsDistinct_stddev_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VwVehicleModelsDistinct_Stddev_Pop_Fields = {
  __typename?: 'vwVehicleModelsDistinct_stddev_pop_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VwVehicleModelsDistinct_Stddev_Samp_Fields = {
  __typename?: 'vwVehicleModelsDistinct_stddev_samp_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VwVehicleModelsDistinct_Sum_Fields = {
  __typename?: 'vwVehicleModelsDistinct_sum_fields';
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** update columns of table "vwVehicleModelsDistinct" */
export enum VwVehicleModelsDistinct_Update_Column {
  /** column name */
  MakeCode = 'MakeCode',
  /** column name */
  ModelCode = 'ModelCode',
  /** column name */
  ModelName = 'ModelName',
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate var_pop on columns */
export type VwVehicleModelsDistinct_Var_Pop_Fields = {
  __typename?: 'vwVehicleModelsDistinct_var_pop_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VwVehicleModelsDistinct_Var_Samp_Fields = {
  __typename?: 'vwVehicleModelsDistinct_var_samp_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VwVehicleModelsDistinct_Variance_Fields = {
  __typename?: 'vwVehicleModelsDistinct_variance_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vwVehicleYearsDistinct" */
export type VwVehicleYearsDistinct = {
  __typename?: 'vwVehicleYearsDistinct';
  VehicleYear: Scalars['Int'];
};

/** aggregated selection of "vwVehicleYearsDistinct" */
export type VwVehicleYearsDistinct_Aggregate = {
  __typename?: 'vwVehicleYearsDistinct_aggregate';
  aggregate?: Maybe<VwVehicleYearsDistinct_Aggregate_Fields>;
  nodes: Array<VwVehicleYearsDistinct>;
};

/** aggregate fields of "vwVehicleYearsDistinct" */
export type VwVehicleYearsDistinct_Aggregate_Fields = {
  __typename?: 'vwVehicleYearsDistinct_aggregate_fields';
  avg?: Maybe<VwVehicleYearsDistinct_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<VwVehicleYearsDistinct_Max_Fields>;
  min?: Maybe<VwVehicleYearsDistinct_Min_Fields>;
  stddev?: Maybe<VwVehicleYearsDistinct_Stddev_Fields>;
  stddev_pop?: Maybe<VwVehicleYearsDistinct_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<VwVehicleYearsDistinct_Stddev_Samp_Fields>;
  sum?: Maybe<VwVehicleYearsDistinct_Sum_Fields>;
  var_pop?: Maybe<VwVehicleYearsDistinct_Var_Pop_Fields>;
  var_samp?: Maybe<VwVehicleYearsDistinct_Var_Samp_Fields>;
  variance?: Maybe<VwVehicleYearsDistinct_Variance_Fields>;
};


/** aggregate fields of "vwVehicleYearsDistinct" */
export type VwVehicleYearsDistinct_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<VwVehicleYearsDistinct_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type VwVehicleYearsDistinct_Avg_Fields = {
  __typename?: 'vwVehicleYearsDistinct_avg_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vwVehicleYearsDistinct". All fields are combined with a logical 'AND'. */
export type VwVehicleYearsDistinct_Bool_Exp = {
  VehicleYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<VwVehicleYearsDistinct_Bool_Exp>>;
  _not?: InputMaybe<VwVehicleYearsDistinct_Bool_Exp>;
  _or?: InputMaybe<Array<VwVehicleYearsDistinct_Bool_Exp>>;
};

/** upsert condition type for table "vwVehicleYearsDistinct" */
export type VwVehicleYearsDistinct_If_Matched = {
  match_columns?: Array<VwVehicleYearsDistinct_Insert_Match_Column>;
  update_columns?: Array<VwVehicleYearsDistinct_Update_Column>;
  where?: InputMaybe<VwVehicleYearsDistinct_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "vwVehicleYearsDistinct" */
export type VwVehicleYearsDistinct_Inc_Input = {
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vwVehicleYearsDistinct" */
export type VwVehicleYearsDistinct_Insert_Input = {
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** select match_columns of table "vwVehicleYearsDistinct" */
export enum VwVehicleYearsDistinct_Insert_Match_Column {
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate max on columns */
export type VwVehicleYearsDistinct_Max_Fields = {
  __typename?: 'vwVehicleYearsDistinct_max_fields';
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type VwVehicleYearsDistinct_Min_Fields = {
  __typename?: 'vwVehicleYearsDistinct_min_fields';
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vwVehicleYearsDistinct" */
export type VwVehicleYearsDistinct_Mutation_Response = {
  __typename?: 'vwVehicleYearsDistinct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VwVehicleYearsDistinct>;
};

/** Ordering options when selecting data from "vwVehicleYearsDistinct". */
export type VwVehicleYearsDistinct_Order_By = {
  VehicleYear?: InputMaybe<Order_By>;
};

/** select columns of table "vwVehicleYearsDistinct" */
export enum VwVehicleYearsDistinct_Select_Column {
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** input type for updating data in table "vwVehicleYearsDistinct" */
export type VwVehicleYearsDistinct_Set_Input = {
  VehicleYear?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type VwVehicleYearsDistinct_Stddev_Fields = {
  __typename?: 'vwVehicleYearsDistinct_stddev_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type VwVehicleYearsDistinct_Stddev_Pop_Fields = {
  __typename?: 'vwVehicleYearsDistinct_stddev_pop_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type VwVehicleYearsDistinct_Stddev_Samp_Fields = {
  __typename?: 'vwVehicleYearsDistinct_stddev_samp_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type VwVehicleYearsDistinct_Sum_Fields = {
  __typename?: 'vwVehicleYearsDistinct_sum_fields';
  VehicleYear?: Maybe<Scalars['Int']>;
};

/** update columns of table "vwVehicleYearsDistinct" */
export enum VwVehicleYearsDistinct_Update_Column {
  /** column name */
  VehicleYear = 'VehicleYear'
}

/** aggregate var_pop on columns */
export type VwVehicleYearsDistinct_Var_Pop_Fields = {
  __typename?: 'vwVehicleYearsDistinct_var_pop_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type VwVehicleYearsDistinct_Var_Samp_Fields = {
  __typename?: 'vwVehicleYearsDistinct_var_samp_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type VwVehicleYearsDistinct_Variance_Fields = {
  __typename?: 'vwVehicleYearsDistinct_variance_fields';
  VehicleYear?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "work_status_type" */
export type WorkStatusType = {
  __typename?: 'workStatusType';
  /** An array relationship */
  accountDisbursements: Array<AccountDisbursement>;
  /** An aggregate relationship */
  accountDisbursements_aggregate: AccountDisbursement_Aggregate;
  /** An array relationship */
  accountProducts: Array<AccountProduct>;
  /** An aggregate relationship */
  accountProducts_aggregate: AccountProduct_Aggregate;
  /** An array relationship */
  accountRetails: Array<AccountRetail>;
  /** An aggregate relationship */
  accountRetails_aggregate: AccountRetail_Aggregate;
  /** An array relationship */
  accounts: Array<Account>;
  /** An aggregate relationship */
  accounts_aggregate: Account_Aggregate;
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** columns and relationships of "work_status_type" */
export type WorkStatusTypeAccountDisbursementsArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** columns and relationships of "work_status_type" */
export type WorkStatusTypeAccountDisbursements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountDisbursement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountDisbursement_Order_By>>;
  where?: InputMaybe<AccountDisbursement_Bool_Exp>;
};


/** columns and relationships of "work_status_type" */
export type WorkStatusTypeAccountProductsArgs = {
  distinct_on?: InputMaybe<Array<AccountProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProduct_Order_By>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


/** columns and relationships of "work_status_type" */
export type WorkStatusTypeAccountProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountProduct_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountProduct_Order_By>>;
  where?: InputMaybe<AccountProduct_Bool_Exp>;
};


/** columns and relationships of "work_status_type" */
export type WorkStatusTypeAccountRetailsArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


/** columns and relationships of "work_status_type" */
export type WorkStatusTypeAccountRetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountRetail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountRetail_Order_By>>;
  where?: InputMaybe<AccountRetail_Bool_Exp>;
};


/** columns and relationships of "work_status_type" */
export type WorkStatusTypeAccountsArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


/** columns and relationships of "work_status_type" */
export type WorkStatusTypeAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};

/** aggregated selection of "work_status_type" */
export type WorkStatusType_Aggregate = {
  __typename?: 'workStatusType_aggregate';
  aggregate?: Maybe<WorkStatusType_Aggregate_Fields>;
  nodes: Array<WorkStatusType>;
};

/** aggregate fields of "work_status_type" */
export type WorkStatusType_Aggregate_Fields = {
  __typename?: 'workStatusType_aggregate_fields';
  avg?: Maybe<WorkStatusType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<WorkStatusType_Max_Fields>;
  min?: Maybe<WorkStatusType_Min_Fields>;
  stddev?: Maybe<WorkStatusType_Stddev_Fields>;
  stddev_pop?: Maybe<WorkStatusType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<WorkStatusType_Stddev_Samp_Fields>;
  sum?: Maybe<WorkStatusType_Sum_Fields>;
  var_pop?: Maybe<WorkStatusType_Var_Pop_Fields>;
  var_samp?: Maybe<WorkStatusType_Var_Samp_Fields>;
  variance?: Maybe<WorkStatusType_Variance_Fields>;
};


/** aggregate fields of "work_status_type" */
export type WorkStatusType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<WorkStatusType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type WorkStatusType_Avg_Fields = {
  __typename?: 'workStatusType_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "work_status_type". All fields are combined with a logical 'AND'. */
export type WorkStatusType_Bool_Exp = {
  _and?: InputMaybe<Array<WorkStatusType_Bool_Exp>>;
  _not?: InputMaybe<WorkStatusType_Bool_Exp>;
  _or?: InputMaybe<Array<WorkStatusType_Bool_Exp>>;
  accountDisbursements?: InputMaybe<AccountDisbursement_Bool_Exp>;
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Bool_Exp>;
  accountProducts?: InputMaybe<AccountProduct_Bool_Exp>;
  accountProducts_aggregate?: InputMaybe<AccountProduct_Aggregate_Bool_Exp>;
  accountRetails?: InputMaybe<AccountRetail_Bool_Exp>;
  accountRetails_aggregate?: InputMaybe<AccountRetail_Aggregate_Bool_Exp>;
  accounts?: InputMaybe<Account_Bool_Exp>;
  accounts_aggregate?: InputMaybe<Account_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "work_status_type" */
export enum WorkStatusType_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkStatusTypePkey = 'work_status_type_pkey'
}

/** input type for incrementing numeric columns in table "work_status_type" */
export type WorkStatusType_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "work_status_type" */
export type WorkStatusType_Insert_Input = {
  accountDisbursements?: InputMaybe<AccountDisbursement_Arr_Rel_Insert_Input>;
  accountProducts?: InputMaybe<AccountProduct_Arr_Rel_Insert_Input>;
  accountRetails?: InputMaybe<AccountRetail_Arr_Rel_Insert_Input>;
  accounts?: InputMaybe<Account_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type WorkStatusType_Max_Fields = {
  __typename?: 'workStatusType_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type WorkStatusType_Min_Fields = {
  __typename?: 'workStatusType_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "work_status_type" */
export type WorkStatusType_Mutation_Response = {
  __typename?: 'workStatusType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WorkStatusType>;
};

/** input type for inserting object relation for remote table "work_status_type" */
export type WorkStatusType_Obj_Rel_Insert_Input = {
  data: WorkStatusType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<WorkStatusType_On_Conflict>;
};

/** on_conflict condition type for table "work_status_type" */
export type WorkStatusType_On_Conflict = {
  constraint: WorkStatusType_Constraint;
  update_columns?: Array<WorkStatusType_Update_Column>;
  where?: InputMaybe<WorkStatusType_Bool_Exp>;
};

/** Ordering options when selecting data from "work_status_type". */
export type WorkStatusType_Order_By = {
  accountDisbursements_aggregate?: InputMaybe<AccountDisbursement_Aggregate_Order_By>;
  accountProducts_aggregate?: InputMaybe<AccountProduct_Aggregate_Order_By>;
  accountRetails_aggregate?: InputMaybe<AccountRetail_Aggregate_Order_By>;
  accounts_aggregate?: InputMaybe<Account_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: work_status_type */
export type WorkStatusType_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "work_status_type" */
export enum WorkStatusType_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "work_status_type" */
export type WorkStatusType_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type WorkStatusType_Stddev_Fields = {
  __typename?: 'workStatusType_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WorkStatusType_Stddev_Pop_Fields = {
  __typename?: 'workStatusType_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WorkStatusType_Stddev_Samp_Fields = {
  __typename?: 'workStatusType_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "workStatusType" */
export type WorkStatusType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: WorkStatusType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type WorkStatusType_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type WorkStatusType_Sum_Fields = {
  __typename?: 'workStatusType_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "work_status_type" */
export enum WorkStatusType_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type WorkStatusType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WorkStatusType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WorkStatusType_Set_Input>;
  /** filter the rows which have to be updated */
  where: WorkStatusType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type WorkStatusType_Var_Pop_Fields = {
  __typename?: 'workStatusType_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WorkStatusType_Var_Samp_Fields = {
  __typename?: 'workStatusType_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WorkStatusType_Variance_Fields = {
  __typename?: 'workStatusType_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "claims.workflow_state_type" */
export type WorkflowStateType = {
  __typename?: 'workflowStateType';
  createdAt: Scalars['timestamptz'];
  display: Scalars['String'];
  enumValue: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "claims.workflow_state_type" */
export type WorkflowStateType_Aggregate = {
  __typename?: 'workflowStateType_aggregate';
  aggregate?: Maybe<WorkflowStateType_Aggregate_Fields>;
  nodes: Array<WorkflowStateType>;
};

/** aggregate fields of "claims.workflow_state_type" */
export type WorkflowStateType_Aggregate_Fields = {
  __typename?: 'workflowStateType_aggregate_fields';
  avg?: Maybe<WorkflowStateType_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<WorkflowStateType_Max_Fields>;
  min?: Maybe<WorkflowStateType_Min_Fields>;
  stddev?: Maybe<WorkflowStateType_Stddev_Fields>;
  stddev_pop?: Maybe<WorkflowStateType_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<WorkflowStateType_Stddev_Samp_Fields>;
  sum?: Maybe<WorkflowStateType_Sum_Fields>;
  var_pop?: Maybe<WorkflowStateType_Var_Pop_Fields>;
  var_samp?: Maybe<WorkflowStateType_Var_Samp_Fields>;
  variance?: Maybe<WorkflowStateType_Variance_Fields>;
};


/** aggregate fields of "claims.workflow_state_type" */
export type WorkflowStateType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<WorkflowStateType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type WorkflowStateType_Avg_Fields = {
  __typename?: 'workflowStateType_avg_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "claims.workflow_state_type". All fields are combined with a logical 'AND'. */
export type WorkflowStateType_Bool_Exp = {
  _and?: InputMaybe<Array<WorkflowStateType_Bool_Exp>>;
  _not?: InputMaybe<WorkflowStateType_Bool_Exp>;
  _or?: InputMaybe<Array<WorkflowStateType_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  display?: InputMaybe<String_Comparison_Exp>;
  enumValue?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "claims.workflow_state_type" */
export enum WorkflowStateType_Constraint {
  /** unique or primary key constraint on columns "enum_value" */
  WorkflowStateTypeEnumValueKey = 'workflow_state_type_enum_value_key',
  /** unique or primary key constraint on columns "id" */
  WorkflowStateTypePkey = 'workflow_state_type_pkey'
}

/** input type for incrementing numeric columns in table "claims.workflow_state_type" */
export type WorkflowStateType_Inc_Input = {
  enumValue?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "claims.workflow_state_type" */
export type WorkflowStateType_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type WorkflowStateType_Max_Fields = {
  __typename?: 'workflowStateType_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type WorkflowStateType_Min_Fields = {
  __typename?: 'workflowStateType_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  display?: Maybe<Scalars['String']>;
  enumValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "claims.workflow_state_type" */
export type WorkflowStateType_Mutation_Response = {
  __typename?: 'workflowStateType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WorkflowStateType>;
};

/** input type for inserting object relation for remote table "claims.workflow_state_type" */
export type WorkflowStateType_Obj_Rel_Insert_Input = {
  data: WorkflowStateType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<WorkflowStateType_On_Conflict>;
};

/** on_conflict condition type for table "claims.workflow_state_type" */
export type WorkflowStateType_On_Conflict = {
  constraint: WorkflowStateType_Constraint;
  update_columns?: Array<WorkflowStateType_Update_Column>;
  where?: InputMaybe<WorkflowStateType_Bool_Exp>;
};

/** Ordering options when selecting data from "claims.workflow_state_type". */
export type WorkflowStateType_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  enumValue?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: claims.workflow_state_type */
export type WorkflowStateType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "claims.workflow_state_type" */
export enum WorkflowStateType_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "claims.workflow_state_type" */
export type WorkflowStateType_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type WorkflowStateType_Stddev_Fields = {
  __typename?: 'workflowStateType_stddev_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type WorkflowStateType_Stddev_Pop_Fields = {
  __typename?: 'workflowStateType_stddev_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type WorkflowStateType_Stddev_Samp_Fields = {
  __typename?: 'workflowStateType_stddev_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "workflowStateType" */
export type WorkflowStateType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: WorkflowStateType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type WorkflowStateType_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  display?: InputMaybe<Scalars['String']>;
  enumValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type WorkflowStateType_Sum_Fields = {
  __typename?: 'workflowStateType_sum_fields';
  enumValue?: Maybe<Scalars['Int']>;
};

/** update columns of table "claims.workflow_state_type" */
export enum WorkflowStateType_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Display = 'display',
  /** column name */
  EnumValue = 'enumValue',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type WorkflowStateType_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WorkflowStateType_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WorkflowStateType_Set_Input>;
  /** filter the rows which have to be updated */
  where: WorkflowStateType_Bool_Exp;
};

/** aggregate var_pop on columns */
export type WorkflowStateType_Var_Pop_Fields = {
  __typename?: 'workflowStateType_var_pop_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type WorkflowStateType_Var_Samp_Fields = {
  __typename?: 'workflowStateType_var_samp_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type WorkflowStateType_Variance_Fields = {
  __typename?: 'workflowStateType_variance_fields';
  enumValue?: Maybe<Scalars['Float']>;
};

export type GetConfigurationItemQueryVariables = Exact<{
  accountCode: Scalars['String'];
  whereEntityConfigurationItems?: InputMaybe<EntityConfigurationItem_Bool_Exp>;
}>;


export type GetConfigurationItemQuery = { __typename?: 'query_root', selectAccounts: Array<{ __typename?: 'account', entityConfigurationItems: Array<{ __typename?: 'entityConfigurationItem', value?: string | null }> }> };

export type InsertPreAuthorizationMutationVariables = Exact<{
  object: PreAuthorization_Insert_Input;
}>;


export type InsertPreAuthorizationMutation = { __typename?: 'mutation_root', insertPreAuthorization?: { __typename?: 'preAuthorization', id: string, number?: string | null } | null };

export type SelectPreAuthorizationQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SelectPreAuthorizationQuery = { __typename?: 'query_root', selectPreAuthorization?: { __typename?: 'preAuthorization', id: string, createdAt: any, updatedAt: any, parentId?: string | null, metadata?: any | null, preAuthorizationTypeId?: string | null, preAuthorizationStatusTypeId?: string | null, existsInAs400: boolean, as400ClaimNumber?: string | null, number?: string | null, preAuthorizationType?: { __typename?: 'preAuthorizationType', name?: string | null } | null } | null, selectPolicyClaim?: { __typename?: 'policyClaim', id: string, number?: string | null, contractId?: string | null, salesTaxPercent?: number | null, totalCost?: number | null, claimServiceCenters: Array<{ __typename?: 'claimServiceCenter', roNumber?: string | null, contact?: { __typename?: 'contact', phone?: string | null } | null }> } | null };

export type GetPolicyContractsQueryVariables = Exact<{
  where?: InputMaybe<PolicyContract_Bool_Exp>;
  whereLegacy?: InputMaybe<LegacyPolicyContract_Bool_Exp>;
}>;


export type GetPolicyContractsQuery = { __typename?: 'query_root', selectLegacyPolicyContracts: Array<{ __typename?: 'legacyPolicyContract', id: string, categoryCode?: string | null, includesTireCoverage?: any | null, includesDentCoverage?: any | null, includesWindshieldCoverage?: any | null }>, selectPolicyContracts: Array<{ __typename?: 'policyContract', id: string, includesTireCoverage: any, includesDentCoverage: any, includesWindshieldCoverage: any, product: { __typename?: 'product', category: { __typename?: 'category', code?: string | null } } }> };

export type GetPolicyContractQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetPolicyContractQuery = { __typename?: 'query_root', selectPolicyContract?: { __typename?: 'policyContract', id: string, policyContractNumber: string, includesTireCoverage: any, includesDentCoverage: any, includesWindshieldCoverage: any, product: { __typename?: 'product', category: { __typename?: 'category', code?: string | null } }, policyContractAsset?: { __typename?: 'policyContractAsset', vin?: any | null } | null, policyContractOwners: Array<{ __typename?: 'policyContractOwner', contact?: { __typename?: 'contact', name?: string | null } | null }> } | null };

export type GetLegacyPolicyContractQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetLegacyPolicyContractQuery = { __typename?: 'query_root', selectLegacyPolicyContract?: { __typename?: 'legacyPolicyContract', id: string, contractNumber?: string | null, contractSuffix?: string | null, categoryCode?: string | null, vin?: any | null, name?: any | null, includesTireCoverage?: any | null, includesDentCoverage?: any | null, includesWindshieldCoverage?: any | null } | null };

export type GetPolicyContractForLinkQueryVariables = Exact<{
  contractNumber: Scalars['String'];
  programCode?: InputMaybe<Scalars['String']>;
  contractSuffix?: InputMaybe<Scalars['String']>;
}>;


export type GetPolicyContractForLinkQuery = { __typename?: 'query_root', selectLegacyPolicyContracts: Array<{ __typename?: 'legacyPolicyContract', id: string, categoryCode?: string | null, includesTireCoverage?: any | null, includesDentCoverage?: any | null, includesWindshieldCoverage?: any | null }>, selectPolicyContracts: Array<{ __typename?: 'policyContract', id: string, includesTireCoverage: any, includesDentCoverage: any, includesWindshieldCoverage: any, product: { __typename?: 'product', category: { __typename?: 'category', code?: string | null } } }> };

export type GetFeatureFlagsQueryVariables = Exact<{
  date: Scalars['date'];
  name: Scalars['String'];
}>;


export type GetFeatureFlagsQuery = { __typename?: 'query_root', selectFeatures: Array<{ __typename?: 'feature', id: string }> };

export type GetRaterViewConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRaterViewConfigsQuery = { __typename?: 'query_root', selectRaterViewConfigs: Array<{ __typename?: 'raterViewConfig', id: string, name?: string | null, configMetadata: any, raterViewConfigType?: { __typename?: 'type', name?: string | null } | null, childRaterViewConfigs: Array<{ __typename?: 'raterViewConfig', id: string, name?: string | null, configMetadata: any, raterViewConfigType?: { __typename?: 'type', name?: string | null } | null }> }> };


export const GetConfigurationItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConfigurationItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereEntityConfigurationItems"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"entityConfigurationItem_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountCode"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityConfigurationItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereEntityConfigurationItems"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetConfigurationItemQuery, GetConfigurationItemQueryVariables>;
export const InsertPreAuthorizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertPreAuthorization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"preAuthorization_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertPreAuthorization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]} as unknown as DocumentNode<InsertPreAuthorizationMutation, InsertPreAuthorizationMutationVariables>;
export const SelectPreAuthorizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"selectPreAuthorization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectPreAuthorization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"preAuthorizationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"preAuthorizationStatusTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"existsInAs400"}},{"kind":"Field","name":{"kind":"Name","value":"as400ClaimNumber"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"preAuthorizationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectPolicyClaim"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"salesTaxPercent"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"claimServiceCenters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SelectPreAuthorizationQuery, SelectPreAuthorizationQueryVariables>;
export const GetPolicyContractsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPolicyContracts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"policyContract_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereLegacy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"legacyPolicyContract_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectLegacyPolicyContracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereLegacy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryCode"}},{"kind":"Field","alias":{"kind":"Name","value":"includesTireCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesTireCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesDentCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesDentCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesWindshieldCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesWindshieldCoverageOption","block":false}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"selectPolicyContracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"includesTireCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesTireCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesDentCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesDentCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesWindshieldCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesWindshieldCoverageOption","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPolicyContractsQuery, GetPolicyContractsQueryVariables>;
export const GetPolicyContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPolicyContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectPolicyContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"policyContractNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"includesTireCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesTireCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesDentCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesDentCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesWindshieldCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesWindshieldCoverageOption","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"policyContractAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"vin"},"name":{"kind":"Name","value":"identifierMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"vin","block":false}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"policyContractOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contact"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"addresses_aggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPolicyContractQuery, GetPolicyContractQueryVariables>;
export const GetLegacyPolicyContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLegacyPolicyContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectLegacyPolicyContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contractSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"categoryCode"}},{"kind":"Field","alias":{"kind":"Name","value":"vin"},"name":{"kind":"Name","value":"assetMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"vin","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"ownerMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"$[0].name","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesTireCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesTireCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesDentCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesDentCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesWindshieldCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesWindshieldCoverageOption","block":false}}]}]}}]}}]} as unknown as DocumentNode<GetLegacyPolicyContractQuery, GetLegacyPolicyContractQueryVariables>;
export const GetPolicyContractForLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPolicyContractForLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSuffix"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectLegacyPolicyContracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"categoryCode"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programCode"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractNumber"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSuffix"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSuffix"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSuffix"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryCode"}},{"kind":"Field","alias":{"kind":"Name","value":"includesTireCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesTireCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesDentCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesDentCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesWindshieldCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesWindshieldCoverageOption","block":false}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"selectPolicyContracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"policyContractNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractNumber"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"includesTireCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesTireCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesDentCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesDentCoverageOption","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"includesWindshieldCoverage"},"name":{"kind":"Name","value":"productMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"includesWindshieldCoverageOption","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPolicyContractForLinkQuery, GetPolicyContractForLinkQueryVariables>;
export const GetFeatureFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFeatureFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectFeatures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isFullyActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"effectiveDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expirationDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expirationDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>;
export const GetRaterViewConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRaterViewConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectRaterViewConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentRaterViewConfigId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"configMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"raterViewConfigType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childRaterViewConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"configMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"raterViewConfigType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRaterViewConfigsQuery, GetRaterViewConfigsQueryVariables>;